(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode('*:where(.twp,.twp *),:where(.twp,.twp *):before,:where(.twp,.twp *):after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:where(.twp,.twp *):before,:where(.twp,.twp *):after{--tw-content: ""}.twp{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}.twp{margin:0;line-height:inherit}hr:where(.twp,.twp *){height:0;color:inherit;border-top-width:1px}abbr:where([title]):where(.twp,.twp *){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1:where(.twp,.twp *),h2:where(.twp,.twp *),h3:where(.twp,.twp *),h4:where(.twp,.twp *),h5:where(.twp,.twp *),h6:where(.twp,.twp *){font-size:inherit;font-weight:inherit}a:where(.twp,.twp *){color:inherit;text-decoration:inherit}b:where(.twp,.twp *),strong:where(.twp,.twp *){font-weight:bolder}code:where(.twp,.twp *),kbd:where(.twp,.twp *),samp:where(.twp,.twp *),pre:where(.twp,.twp *){font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small:where(.twp,.twp *){font-size:80%}sub:where(.twp,.twp *),sup:where(.twp,.twp *){font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub:where(.twp,.twp *){bottom:-.25em}sup:where(.twp,.twp *){top:-.5em}table:where(.twp,.twp *){text-indent:0;border-color:inherit;border-collapse:collapse}button:where(.twp,.twp *),input:where(.twp,.twp *),optgroup:where(.twp,.twp *),select:where(.twp,.twp *),textarea:where(.twp,.twp *){font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button:where(.twp,.twp *),select:where(.twp,.twp *){text-transform:none}button:where(.twp,.twp *),input:where([type=button]):where(.twp,.twp *),input:where([type=reset]):where(.twp,.twp *),input:where([type=submit]):where(.twp,.twp *){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring:where(.twp,.twp *){outline:auto}:-moz-ui-invalid:where(.twp,.twp *){box-shadow:none}progress:where(.twp,.twp *){vertical-align:baseline}:where(.twp,.twp *) ::-webkit-inner-spin-button,:where(.twp,.twp *) ::-webkit-outer-spin-button{height:auto}[type=search]:where(.twp,.twp *){-webkit-appearance:textfield;outline-offset:-2px}:where(.twp,.twp *) ::-webkit-search-decoration{-webkit-appearance:none}:where(.twp,.twp *) ::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary:where(.twp,.twp *){display:list-item}blockquote:where(.twp,.twp *),dl:where(.twp,.twp *),dd:where(.twp,.twp *),h1:where(.twp,.twp *),h2:where(.twp,.twp *),h3:where(.twp,.twp *),h4:where(.twp,.twp *),h5:where(.twp,.twp *),h6:where(.twp,.twp *),hr:where(.twp,.twp *),figure:where(.twp,.twp *),p:where(.twp,.twp *),pre:where(.twp,.twp *){margin:0}fieldset:where(.twp,.twp *){margin:0;padding:0}legend:where(.twp,.twp *){padding:0}ol:where(.twp,.twp *),ul:where(.twp,.twp *),menu:where(.twp,.twp *){list-style:none;margin:0;padding:0}dialog:where(.twp,.twp *){padding:0}textarea:where(.twp,.twp *){resize:vertical}:where(.twp,.twp *) input::-moz-placeholder,:where(.twp,.twp *) textarea::-moz-placeholder{opacity:1;color:#9ca3af}:where(.twp,.twp *) input::placeholder,:where(.twp,.twp *) textarea::placeholder{opacity:1;color:#9ca3af}button:where(.twp,.twp *),[role=button]:where(.twp,.twp *){cursor:pointer}:disabled:where(.twp,.twp *){cursor:default}img:where(.twp,.twp *),svg:where(.twp,.twp *),video:where(.twp,.twp *),canvas:where(.twp,.twp *),audio:where(.twp,.twp *),iframe:where(.twp,.twp *),embed:where(.twp,.twp *),object:where(.twp,.twp *){display:block;vertical-align:middle}img:where(.twp,.twp *),video:where(.twp,.twp *){max-width:100%;height:auto}[hidden]:where(.twp,.twp *){display:none}input[type=number].appearance-none::-webkit-inner-spin-button,input[type=number].appearance-none::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number].appearance-none{-moz-appearance:textfield}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1920px){.container{max-width:1920px}}.mco-membership-input{width:100%;border-radius:4px;border-width:1px;--tw-border-opacity: 1;border-color:rgb(231 231 231 / var(--tw-border-opacity));--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity));padding:12px;--tw-text-opacity: 1;color:rgb(20 20 20 / var(--tw-text-opacity))}.mco-membership-input::-moz-placeholder{--tw-placeholder-opacity: 1;color:rgb(162 162 162 / var(--tw-placeholder-opacity))}.mco-membership-input::placeholder{--tw-placeholder-opacity: 1;color:rgb(162 162 162 / var(--tw-placeholder-opacity))}.mco-membership-input-dark{width:100%;border-radius:8px;--tw-bg-opacity: 1;background-color:rgb(40 40 47 / var(--tw-bg-opacity));padding:12px;--tw-text-opacity: 1;color:rgb(251 251 251 / var(--tw-text-opacity))}.mco-membership-input-dark::-moz-placeholder{--tw-placeholder-opacity: 1;color:rgb(119 119 124 / var(--tw-placeholder-opacity))}.mco-membership-input-dark::placeholder{--tw-placeholder-opacity: 1;color:rgb(119 119 124 / var(--tw-placeholder-opacity))}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{top:0;right:0;bottom:0;left:0}.inset-y-0{top:0;bottom:0}.-bottom-\\[\\.42857rem\\]{bottom:-.42857rem}.-right-\\[0\\.12rem\\]{right:-.12rem}.-right-\\[0\\.13rem\\]{right:-.13rem}.-right-\\[0\\.25rem\\]{right:-.25rem}.-right-\\[0\\.571rem\\]{right:-.571rem}.-top-\\[\\.42857rem\\]{top:-.42857rem}.-top-\\[0\\.12rem\\]{top:-.12rem}.-top-\\[0\\.13rem\\]{top:-.13rem}.-top-\\[0\\.25rem\\]{top:-.25rem}.-top-\\[0\\.571rem\\]{top:-.571rem}.-top-\\[2\\.057rem\\]{top:-2.057rem}.bottom-0{bottom:0}.bottom-\\[2\\.29rem\\]{bottom:2.29rem}.left-0{left:0}.left-1\\/2{left:50%}.left-\\[0\\.29rem\\]{left:.29rem}.left-\\[0\\.57143rem\\]{left:.57143rem}.left-\\[1\\.14286rem\\]{left:1.14286rem}.left-\\[1\\.143rem\\]{left:1.143rem}.left-\\[1\\.14rem\\]{left:1.14rem}.left-\\[1\\.429rem\\]{left:1.429rem}.left-\\[1\\.43rem\\]{left:1.43rem}.left-\\[1\\.5rem\\]{left:1.5rem}.left-\\[1\\.71rem\\]{left:1.71rem}.right-0{right:0}.right-\\[\\.57143rem\\]{right:.57143rem}.right-\\[0\\.13rem\\]{right:.13rem}.right-\\[0\\.57143rem\\]{right:.57143rem}.right-\\[0\\.571rem\\]{right:.571rem}.right-\\[1\\.14285rem\\]{right:1.14285rem}.right-\\[1\\.14286rem\\]{right:1.14286rem}.right-\\[1\\.14rem\\]{right:1.14rem}.right-\\[1\\.71429rem\\]{right:1.71429rem}.top-0{top:0}.top-1\\/2{top:50%}.top-\\[\\.57143rem\\]{top:.57143rem}.top-\\[0\\.13rem\\]{top:.13rem}.top-\\[0\\.57143rem\\]{top:.57143rem}.top-\\[0\\.571rem\\]{top:.571rem}.top-\\[0\\.86rem\\]{top:.86rem}.top-\\[1\\.14286rem\\]{top:1.14286rem}.top-\\[1\\.143rem\\]{top:1.143rem}.top-\\[1\\.14rem\\]{top:1.14rem}.top-\\[1\\.429rem\\]{top:1.429rem}.top-\\[1\\.43rem\\]{top:1.43rem}.top-\\[1\\.71429rem\\]{top:1.71429rem}.top-\\[2\\.85714rem\\]{top:2.85714rem}.top-\\[2rem\\]{top:2rem}.top-\\[3\\.4285rem\\]{top:3.4285rem}.isolate{isolation:isolate}.-z-\\[2\\.85714rem\\]{z-index:-2.85714rem}.z-0{z-index:0}.z-10{z-index:10}.z-20{z-index:20}.z-\\[200\\]{z-index:200}.m-0{margin:0}.m-\\[1\\.14285rem\\]{margin:1.14285rem}.mx-\\[0\\.57142rem\\]{margin-left:.57142rem;margin-right:.57142rem}.mx-\\[0\\.571rem\\]{margin-left:.571rem;margin-right:.571rem}.mx-\\[1\\.14285rem\\]{margin-left:1.14285rem;margin-right:1.14285rem}.mx-\\[1\\.14286rem\\]{margin-left:1.14286rem;margin-right:1.14286rem}.mx-\\[1\\.14rem\\]{margin-left:1.14rem;margin-right:1.14rem}.mx-\\[2\\.28571rem\\]{margin-left:2.28571rem;margin-right:2.28571rem}.mx-auto{margin-left:auto;margin-right:auto}.my-\\[\\.85714rem\\]{margin-top:.85714rem;margin-bottom:.85714rem}.my-\\[0\\.857rem\\]{margin-top:.857rem;margin-bottom:.857rem}.-ml-\\[\\.71429rem\\]{margin-left:-.71429rem}.-ml-\\[\\.85714rem\\]{margin-left:-.85714rem}.-ml-\\[1\\.14285rem\\]{margin-left:-1.14285rem}.-mt-\\[0\\.28571rem\\]{margin-top:-.28571rem}.-mt-\\[0\\.57143rem\\]{margin-top:-.57143rem}.mb-0{margin-bottom:0}.mb-\\[\\.57143rem\\]{margin-bottom:.57143rem}.mb-\\[0\\.28571rem\\]{margin-bottom:.28571rem}.mb-\\[0\\.57143rem\\]{margin-bottom:.57143rem}.mb-\\[0\\.85714rem\\]{margin-bottom:.85714rem}.mb-\\[1\\.14rem\\]{margin-bottom:1.14rem}.mb-\\[2\\.28571rem\\]{margin-bottom:2.28571rem}.mb-\\[20rem\\]{margin-bottom:20rem}.mb-\\[6\\.85714rem\\]{margin-bottom:6.85714rem}.ml-0{margin-left:0}.ml-2{margin-left:.5rem}.ml-7{margin-left:1.75rem}.ml-\\[\\.13714rem\\]{margin-left:.13714rem}.ml-\\[0\\.12rem\\]{margin-left:.12rem}.ml-\\[0\\.14286rem\\]{margin-left:.14286rem}.ml-\\[0\\.286rem\\]{margin-left:.286rem}.ml-\\[0\\.29rem\\]{margin-left:.29rem}.ml-\\[0\\.571rem\\]{margin-left:.571rem}.ml-\\[0\\.57rem\\]{margin-left:.57rem}.ml-\\[0\\.5rem\\]{margin-left:.5rem}.ml-\\[0\\.86rem\\]{margin-left:.86rem}.ml-\\[1\\.14286rem\\]{margin-left:1.14286rem}.ml-\\[1\\.71428rem\\]{margin-left:1.71428rem}.ml-\\[1\\.71429rem\\]{margin-left:1.71429rem}.ml-auto{margin-left:auto}.mr-\\[0\\.57143rem\\]{margin-right:.57143rem}.mr-\\[1\\.14285rem\\]{margin-right:1.14285rem}.mr-\\[2\\.857rem\\]{margin-right:2.857rem}.mt-1{margin-top:.25rem}.mt-10{margin-top:2.5rem}.mt-4{margin-top:1rem}.mt-6{margin-top:1.5rem}.mt-\\[\\.28571rem\\]{margin-top:.28571rem}.mt-\\[\\.57143rem\\]{margin-top:.57143rem}.mt-\\[0\\.28571rem\\]{margin-top:.28571rem}.mt-\\[0\\.286rem\\]{margin-top:.286rem}.mt-\\[0\\.29rem\\]{margin-top:.29rem}.mt-\\[0\\.57142rem\\]{margin-top:.57142rem}.mt-\\[0\\.57143rem\\]{margin-top:.57143rem}.mt-\\[0\\.571rem\\]{margin-top:.571rem}.mt-\\[0\\.57rem\\]{margin-top:.57rem}.mt-\\[0\\.857rem\\]{margin-top:.857rem}.mt-\\[0\\.86rem\\]{margin-top:.86rem}.mt-\\[1\\.14285rem\\]{margin-top:1.14285rem}.mt-\\[1\\.14286rem\\]{margin-top:1.14286rem}.mt-\\[1\\.143rem\\]{margin-top:1.143rem}.mt-\\[1\\.14rem\\]{margin-top:1.14rem}.mt-\\[1\\.429rem\\]{margin-top:1.429rem}.mt-\\[1\\.71429rem\\]{margin-top:1.71429rem}.mt-\\[1\\.714rem\\]{margin-top:1.714rem}.mt-\\[1\\.71rem\\]{margin-top:1.71rem}.mt-\\[2\\.286rem\\]{margin-top:2.286rem}.mt-\\[2\\.29rem\\]{margin-top:2.29rem}.mt-\\[2\\.857rem\\]{margin-top:2.857rem}.mt-\\[2\\.86rem\\]{margin-top:2.86rem}.mt-\\[3\\.42857rem\\]{margin-top:3.42857rem}.mt-\\[3\\.43rem\\]{margin-top:3.43rem}.mt-\\[4rem\\]{margin-top:4rem}.mt-\\[7\\.75rem\\]{margin-top:7.75rem}.line-clamp-1{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}.line-clamp-2{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2}.line-clamp-3{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3}.line-clamp-4{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:4}.block{display:block}.inline-block{display:inline-block}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.contents{display:contents}.hidden{display:none}.aspect-\\[4\\/5\\]{aspect-ratio:4/5}.aspect-square{aspect-ratio:1 / 1}.size-10{width:2.5rem;height:2.5rem}.size-3{width:.75rem;height:.75rem}.size-4{width:1rem;height:1rem}.size-5{width:1.25rem;height:1.25rem}.size-6{width:1.5rem;height:1.5rem}.size-7{width:1.75rem;height:1.75rem}.size-8{width:2rem;height:2rem}.size-\\[\\.1429rem\\]{width:.1429rem;height:.1429rem}.size-\\[\\.22857rem\\]{width:.22857rem;height:.22857rem}.size-\\[\\.28571rem\\]{width:.28571rem;height:.28571rem}.size-\\[\\.85714rem\\]{width:.85714rem;height:.85714rem}.size-\\[0\\.14286rem\\]{width:.14286rem;height:.14286rem}.size-\\[0\\.143rem\\]{width:.143rem;height:.143rem}.size-\\[0\\.22857rem\\]{width:.22857rem;height:.22857rem}.size-\\[0\\.625rem\\]{width:.625rem;height:.625rem}.size-\\[0\\.71429rem\\]{width:.71429rem;height:.71429rem}.size-\\[0\\.85714rem\\]{width:.85714rem;height:.85714rem}.size-\\[0\\.857rem\\]{width:.857rem;height:.857rem}.size-\\[0\\.92857rem\\]{width:.92857rem;height:.92857rem}.size-\\[1\\.063rem\\]{width:1.063rem;height:1.063rem}.size-\\[1\\.14285rem\\]{width:1.14285rem;height:1.14285rem}.size-\\[1\\.14286rem\\]{width:1.14286rem;height:1.14286rem}.size-\\[1\\.143rem\\]{width:1.143rem;height:1.143rem}.size-\\[1\\.14rem\\]{width:1.14rem;height:1.14rem}.size-\\[1\\.21429rem\\]{width:1.21429rem;height:1.21429rem}.size-\\[1\\.28571rem\\]{width:1.28571rem;height:1.28571rem}.size-\\[1\\.375rem\\]{width:1.375rem;height:1.375rem}.size-\\[1\\.42857rem\\]{width:1.42857rem;height:1.42857rem}.size-\\[1\\.429rem\\]{width:1.429rem;height:1.429rem}.size-\\[1\\.71428rem\\]{width:1.71428rem;height:1.71428rem}.size-\\[1\\.71429rem\\]{width:1.71429rem;height:1.71429rem}.size-\\[1\\.71rem\\]{width:1.71rem;height:1.71rem}.size-\\[1\\.96429rem\\]{width:1.96429rem;height:1.96429rem}.size-\\[10\\.57143rem\\]{width:10.57143rem;height:10.57143rem}.size-\\[10rem\\]{width:10rem;height:10rem}.size-\\[11\\.42857rem\\]{width:11.42857rem;height:11.42857rem}.size-\\[11\\.429rem\\]{width:11.429rem;height:11.429rem}.size-\\[12\\.857rem\\]{width:12.857rem;height:12.857rem}.size-\\[14\\.28571rem\\]{width:14.28571rem;height:14.28571rem}.size-\\[15\\.71429rem\\]{width:15.71429rem;height:15.71429rem}.size-\\[15rem\\]{width:15rem;height:15rem}.size-\\[1rem\\]{width:1rem;height:1rem}.size-\\[2\\.28571rem\\]{width:2.28571rem;height:2.28571rem}.size-\\[2\\.286rem\\]{width:2.286rem;height:2.286rem}.size-\\[2\\.78571rem\\]{width:2.78571rem;height:2.78571rem}.size-\\[2\\.85714rem\\]{width:2.85714rem;height:2.85714rem}.size-\\[20rem\\]{width:20rem;height:20rem}.size-\\[22\\.85714rem\\]{width:22.85714rem;height:22.85714rem}.size-\\[24\\.57142rem\\]{width:24.57142rem;height:24.57142rem}.size-\\[24\\.57143rem\\]{width:24.57143rem;height:24.57143rem}.size-\\[24\\.571rem\\]{width:24.571rem;height:24.571rem}.size-\\[24rem\\]{width:24rem;height:24rem}.size-\\[27\\.71429rem\\]{width:27.71429rem;height:27.71429rem}.size-\\[28\\.57143rem\\]{width:28.57143rem;height:28.57143rem}.size-\\[28\\.571rem\\]{width:28.571rem;height:28.571rem}.size-\\[2rem\\]{width:2rem;height:2rem}.size-\\[3\\.10714rem\\]{width:3.10714rem;height:3.10714rem}.size-\\[3\\.14285rem\\]{width:3.14285rem;height:3.14285rem}.size-\\[3\\.14286rem\\]{width:3.14286rem;height:3.14286rem}.size-\\[3\\.16329rem\\]{width:3.16329rem;height:3.16329rem}.size-\\[3\\.42857rem\\]{width:3.42857rem;height:3.42857rem}.size-\\[3\\.60714rem\\]{width:3.60714rem;height:3.60714rem}.size-\\[3\\.85714rem\\]{width:3.85714rem;height:3.85714rem}.size-\\[33\\.71429rem\\]{width:33.71429rem;height:33.71429rem}.size-\\[3rem\\]{width:3rem;height:3rem}.size-\\[4\\.429rem\\]{width:4.429rem;height:4.429rem}.size-\\[4\\.57143rem\\]{width:4.57143rem;height:4.57143rem}.size-\\[400px\\]{width:400px;height:400px}.size-\\[5\\.14286rem\\]{width:5.14286rem;height:5.14286rem}.size-\\[5\\.71429rem\\]{width:5.71429rem;height:5.71429rem}.size-\\[5rem\\]{width:5rem;height:5rem}.size-\\[6\\.28571rem\\]{width:6.28571rem;height:6.28571rem}.size-\\[6\\.85714rem\\]{width:6.85714rem;height:6.85714rem}.size-\\[7\\.14286rem\\]{width:7.14286rem;height:7.14286rem}.size-\\[7\\.143rem\\]{width:7.143rem;height:7.143rem}.size-\\[7\\.42857rem\\]{width:7.42857rem;height:7.42857rem}.size-\\[8\\.57143rem\\]{width:8.57143rem;height:8.57143rem}.size-\\[8\\.571rem\\]{width:8.571rem;height:8.571rem}.size-\\[9\\.71429rem\\]{width:9.71429rem;height:9.71429rem}.size-full{width:100%;height:100%}.h-10{height:2.5rem}.h-12{height:3rem}.h-14{height:3.5rem}.h-16{height:4rem}.h-24{height:6rem}.h-4{height:1rem}.h-7{height:1.75rem}.h-8{height:2rem}.h-\\[\\.07142rem\\]{height:.07142rem}.h-\\[\\.14286rem\\]{height:.14286rem}.h-\\[\\.42857rem\\]{height:.42857rem}.h-\\[0\\.071rem\\]{height:.071rem}.h-\\[0\\.57143rem\\]{height:.57143rem}.h-\\[0\\.71429rem\\]{height:.71429rem}.h-\\[0\\.85714rem\\]{height:.85714rem}.h-\\[1\\.14285rem\\]{height:1.14285rem}.h-\\[1\\.14286rem\\]{height:1.14286rem}.h-\\[1\\.143rem\\]{height:1.143rem}.h-\\[1\\.21428rem\\]{height:1.21428rem}.h-\\[1\\.21429rem\\]{height:1.21429rem}.h-\\[1\\.214rem\\]{height:1.214rem}.h-\\[1\\.28571rem\\]{height:1.28571rem}.h-\\[1\\.375rem\\]{height:1.375rem}.h-\\[1\\.42857rem\\]{height:1.42857rem}.h-\\[1\\.429rem\\]{height:1.429rem}.h-\\[1\\.57142rem\\]{height:1.57142rem}.h-\\[1\\.57143rem\\]{height:1.57143rem}.h-\\[1\\.571rem\\]{height:1.571rem}.h-\\[1\\.71428rem\\]{height:1.71428rem}.h-\\[1\\.71429rem\\]{height:1.71429rem}.h-\\[1\\.714rem\\]{height:1.714rem}.h-\\[1\\.71rem\\]{height:1.71rem}.h-\\[1\\.72rem\\]{height:1.72rem}.h-\\[1\\.78571rem\\]{height:1.78571rem}.h-\\[1\\.857rem\\]{height:1.857rem}.h-\\[10\\.57143rem\\]{height:10.57143rem}.h-\\[13\\.14286rem\\]{height:13.14286rem}.h-\\[14\\.28571rem\\]{height:14.28571rem}.h-\\[14\\.85714rem\\]{height:14.85714rem}.h-\\[15\\.42857rem\\]{height:15.42857rem}.h-\\[15\\.6875rem\\]{height:15.6875rem}.h-\\[15\\.71429rem\\]{height:15.71429rem}.h-\\[17\\.14285rem\\]{height:17.14285rem}.h-\\[17\\.92857rem\\]{height:17.92857rem}.h-\\[19\\.35714rem\\]{height:19.35714rem}.h-\\[19\\.429rem\\]{height:19.429rem}.h-\\[19rem\\]{height:19rem}.h-\\[2\\.28571rem\\]{height:2.28571rem}.h-\\[2\\.286rem\\]{height:2.286rem}.h-\\[2\\.57143rem\\]{height:2.57143rem}.h-\\[2\\.85714rem\\]{height:2.85714rem}.h-\\[2\\.857rem\\]{height:2.857rem}.h-\\[2\\.86rem\\]{height:2.86rem}.h-\\[21\\.71428\\]{height:21.71428}.h-\\[22\\.5rem\\]{height:22.5rem}.h-\\[22\\.85714rem\\]{height:22.85714rem}.h-\\[24\\.92857rem\\]{height:24.92857rem}.h-\\[24rem\\]{height:24rem}.h-\\[25\\.71429rem\\]{height:25.71429rem}.h-\\[26\\.71429rem\\]{height:26.71429rem}.h-\\[27\\.14285rem\\]{height:27.14285rem}.h-\\[28\\.57143rem\\]{height:28.57143rem}.h-\\[28\\.571rem\\]{height:28.571rem}.h-\\[3\\.14286rem\\]{height:3.14286rem}.h-\\[3\\.42857rem\\]{height:3.42857rem}.h-\\[3\\.428rem\\]{height:3.428rem}.h-\\[3\\.71428rem\\]{height:3.71428rem}.h-\\[3\\.71429rem\\]{height:3.71429rem}.h-\\[3\\.85714rem\\]{height:3.85714rem}.h-\\[31\\.42857rem\\]{height:31.42857rem}.h-\\[34\\.28571rem\\]{height:34.28571rem}.h-\\[35\\.6875rem\\]{height:35.6875rem}.h-\\[35\\.71429rem\\]{height:35.71429rem}.h-\\[37\\.5rem\\]{height:37.5rem}.h-\\[4\\.28571rem\\]{height:4.28571rem}.h-\\[4\\.286rem\\]{height:4.286rem}.h-\\[4\\.571rem\\]{height:4.571rem}.h-\\[4\\.71429rem\\]{height:4.71429rem}.h-\\[40\\.786rem\\]{height:40.786rem}.h-\\[41\\.07142rem\\]{height:41.07142rem}.h-\\[41\\.12rem\\]{height:41.12rem}.h-\\[41\\.18rem\\]{height:41.18rem}.h-\\[42\\.85714rem\\]{height:42.85714rem}.h-\\[42\\.857rem\\]{height:42.857rem}.h-\\[43\\.857rem\\]{height:43.857rem}.h-\\[44\\.20975rem\\]{height:44.20975rem}.h-\\[45rem\\]{height:45rem}.h-\\[47\\.42857rem\\]{height:47.42857rem}.h-\\[4rem\\]{height:4rem}.h-\\[5\\.14285rem\\]{height:5.14285rem}.h-\\[5\\.14286rem\\]{height:5.14286rem}.h-\\[5\\.42857rem\\]{height:5.42857rem}.h-\\[5\\.71429rem\\]{height:5.71429rem}.h-\\[50rem\\]{height:50rem}.h-\\[51\\.42857rem\\]{height:51.42857rem}.h-\\[57\\.14285rem\\]{height:57.14285rem}.h-\\[6\\.285714rem\\]{height:6.285714rem}.h-\\[6\\.28571rem\\]{height:6.28571rem}.h-\\[6\\.64285rem\\]{height:6.64285rem}.h-\\[6\\.71429rem\\]{height:6.71429rem}.h-\\[6\\.85714rem\\]{height:6.85714rem}.h-\\[61\\.7rem\\]{height:61.7rem}.h-\\[7\\.07142rem\\]{height:7.07142rem}.h-\\[9\\.71429rem\\]{height:9.71429rem}.h-\\[calc\\(100\\%-12\\.28571rem\\)\\]{height:calc(100% - 12.28571rem)}.h-\\[calc\\(100\\%-4\\.28571rem\\)\\]{height:calc(100% - 4.28571rem)}.h-\\[calc\\(100\\%-4\\.28571rem-5\\.71428rem\\)\\]{height:calc(100% - 9.99999rem)}.h-\\[calc\\(100\\%-4\\.3571rem\\)\\]{height:calc(100% - 4.3571rem)}.h-\\[calc\\(100\\%-4\\.5714rem\\)\\]{height:calc(100% - 4.5714rem)}.h-\\[calc\\(100\\%-5\\.42857rem\\)\\]{height:calc(100% - 5.42857rem)}.h-\\[calc\\(100\\%-5\\.71428rem\\)\\]{height:calc(100% - 5.71428rem)}.h-fit{height:-moz-fit-content;height:fit-content}.h-full{height:100%}.max-h-\\[28\\.571rem\\]{max-height:28.571rem}.max-h-\\[39\\.42857rem\\]{max-height:39.42857rem}.max-h-\\[42\\.42857rem\\]{max-height:42.42857rem}.max-h-\\[51\\.42857rem\\]{max-height:51.42857rem}.max-h-\\[51\\.429rem\\]{max-height:51.429rem}.max-h-\\[6\\.85714rem\\]{max-height:6.85714rem}.max-h-\\[60rem\\]{max-height:60rem}.max-h-full{max-height:100%}.min-h-0{min-height:0px}.min-h-20{min-height:5rem}.min-h-6{min-height:1.5rem}.min-h-\\[2\\.57142rem\\]{min-height:2.57142rem}.min-h-\\[2\\.85714rem\\]{min-height:2.85714rem}.min-h-\\[25rem\\]{min-height:25rem}.min-h-\\[4\\.5rem\\]{min-height:4.5rem}.min-h-\\[4\\.71428rem\\]{min-height:4.71428rem}.min-h-\\[40\\.1rem\\]{min-height:40.1rem}.min-h-\\[8\\.714285rem\\]{min-height:8.714285rem}.w-1\\/2{width:50%}.w-1\\/4{width:25%}.w-11{width:2.75rem}.w-16{width:4rem}.w-2\\/6{width:33.333333%}.w-28{width:7rem}.w-4{width:1rem}.w-44{width:11rem}.w-56{width:14rem}.w-60{width:15rem}.w-\\[\\.85714rem\\]{width:.85714rem}.w-\\[0\\.07143rem\\]{width:.07143rem}.w-\\[0\\.07rem\\]{width:.07rem}.w-\\[0\\.14286rem\\]{width:.14286rem}.w-\\[0\\.286rem\\]{width:.286rem}.w-\\[0\\.85714rem\\]{width:.85714rem}.w-\\[1\\.14285rem\\]{width:1.14285rem}.w-\\[1\\.14286rem\\]{width:1.14286rem}.w-\\[1\\.143rem\\]{width:1.143rem}.w-\\[1\\.42857rem\\]{width:1.42857rem}.w-\\[1\\.429rem\\]{width:1.429rem}.w-\\[1\\.71429rem\\]{width:1.71429rem}.w-\\[10rem\\]{width:10rem}.w-\\[11\\.42857rem\\]{width:11.42857rem}.w-\\[11\\.96429rem\\]{width:11.96429rem}.w-\\[12\\.5rem\\]{width:12.5rem}.w-\\[13\\.71429rem\\]{width:13.71429rem}.w-\\[13\\.7rem\\]{width:13.7rem}.w-\\[14\\.28571rem\\]{width:14.28571rem}.w-\\[14\\.8rem\\]{width:14.8rem}.w-\\[14rem\\]{width:14rem}.w-\\[15\\.071rem\\]{width:15.071rem}.w-\\[16\\.571rem\\]{width:16.571rem}.w-\\[16\\.85714rem\\]{width:16.85714rem}.w-\\[17\\.14286rem\\]{width:17.14286rem}.w-\\[17\\.5rem\\]{width:17.5rem}.w-\\[18\\.2rem\\]{width:18.2rem}.w-\\[19\\.429rem\\]{width:19.429rem}.w-\\[19\\.75357rem\\]{width:19.75357rem}.w-\\[19rem\\]{width:19rem}.w-\\[2\\.125rem\\]{width:2.125rem}.w-\\[2\\.28571rem\\]{width:2.28571rem}.w-\\[2\\.286rem\\]{width:2.286rem}.w-\\[2\\.57142rem\\]{width:2.57142rem}.w-\\[2\\.85714rem\\]{width:2.85714rem}.w-\\[20\\%\\]{width:20%}.w-\\[20\\.57143rem\\]{width:20.57143rem}.w-\\[20\\.9375rem\\]{width:20.9375rem}.w-\\[20rem\\]{width:20rem}.w-\\[21\\.4286rem\\]{width:21.4286rem}.w-\\[21\\.85714rem\\]{width:21.85714rem}.w-\\[22\\.28571rem\\]{width:22.28571rem}.w-\\[22\\.85714rem\\]{width:22.85714rem}.w-\\[22rem\\]{width:22rem}.w-\\[24\\.49142rem\\]{width:24.49142rem}.w-\\[24\\.5rem\\]{width:24.5rem}.w-\\[25\\.14286rem\\]{width:25.14286rem}.w-\\[25rem\\]{width:25rem}.w-\\[26\\.28571rem\\]{width:26.28571rem}.w-\\[26\\.34143rem\\]{width:26.34143rem}.w-\\[26\\.42857rem\\]{width:26.42857rem}.w-\\[27\\.42857rem\\]{width:27.42857rem}.w-\\[28\\.57143rem\\]{width:28.57143rem}.w-\\[3\\.14285rem\\]{width:3.14285rem}.w-\\[3\\.42857rem\\]{width:3.42857rem}.w-\\[3\\.85714rem\\]{width:3.85714rem}.w-\\[30rem\\]{width:30rem}.w-\\[31\\.14286rem\\]{width:31.14286rem}.w-\\[31\\.143rem\\]{width:31.143rem}.w-\\[32\\.85714rem\\]{width:32.85714rem}.w-\\[32\\.857rem\\]{width:32.857rem}.w-\\[32rem\\]{width:32rem}.w-\\[34\\.286rem\\]{width:34.286rem}.w-\\[36\\.429rem\\]{width:36.429rem}.w-\\[38\\.28571rem\\]{width:38.28571rem}.w-\\[3rem\\]{width:3rem}.w-\\[4\\.28571em\\]{width:4.28571em}.w-\\[4\\.28571rem\\]{width:4.28571rem}.w-\\[4\\.286rem\\]{width:4.286rem}.w-\\[40\\.14286rem\\]{width:40.14286rem}.w-\\[42\\.14286rem\\]{width:42.14286rem}.w-\\[43\\.42857rem\\]{width:43.42857rem}.w-\\[43\\.429rem\\]{width:43.429rem}.w-\\[43\\.4rem\\]{width:43.4rem}.w-\\[48\\.57142rem\\]{width:48.57142rem}.w-\\[5\\.14286rem\\]{width:5.14286rem}.w-\\[5\\.71428rem\\]{width:5.71428rem}.w-\\[5\\.71429rem\\]{width:5.71429rem}.w-\\[5\\.71rem\\]{width:5.71rem}.w-\\[52rem\\]{width:52rem}.w-\\[5rem\\]{width:5rem}.w-\\[6\\.28571rem\\]{width:6.28571rem}.w-\\[6\\.85714rem\\]{width:6.85714rem}.w-\\[6\\.857rem\\]{width:6.857rem}.w-\\[64rem\\]{width:64rem}.w-\\[65\\.71428rem\\]{width:65.71428rem}.w-\\[65\\.71429rem\\]{width:65.71429rem}.w-\\[69\\.14285rem\\]{width:69.14285rem}.w-\\[69\\.71428rem\\]{width:69.71428rem}.w-\\[6rem\\]{width:6rem}.w-\\[7\\.14286rem\\]{width:7.14286rem}.w-\\[7\\.5rem\\]{width:7.5rem}.w-\\[8\\.25rem\\]{width:8.25rem}.w-\\[8\\.57143rem\\]{width:8.57143rem}.w-\\[8rem\\]{width:8rem}.w-\\[9\\.14286rem\\]{width:9.14286rem}.w-\\[9\\.143rem\\]{width:9.143rem}.w-\\[9\\.14rem\\]{width:9.14rem}.w-\\[9\\.57142rem\\]{width:9.57142rem}.w-\\[91\\.42857rem\\]{width:91.42857rem}.w-\\[93\\.6rem\\]{width:93.6rem}.w-\\[9rem\\]{width:9rem}.w-\\[calc\\(100\\%-13\\.71429rem-0\\.57143rem\\)\\]{width:calc(100% - 14.28572rem)}.w-\\[calc\\(100\\%-2\\.57142rem\\)\\]{width:calc(100% - 2.57142rem)}.w-\\[calc\\(100\\%-3\\.857rem\\)\\],.w-\\[calc\\(100\\%-3rem-0\\.857rem\\)\\]{width:calc(100% - 3.857rem)}.w-\\[calc\\(100\\%-5\\.71429rem\\)\\]{width:calc(100% - 5.71429rem)}.w-\\[calc\\(100\\%-5\\.71429rem-4\\.07rem\\)\\]{width:calc(100% - 9.78429rem)}.w-\\[calc\\(100\\%-6\\.28571rem\\)\\]{width:calc(100% - 6.28571rem)}.w-\\[calc\\(100\\%-6\\.85714rem\\)\\]{width:calc(100% - 6.85714rem)}.w-\\[calc\\(100\\%-6\\.85714rem-1\\.14rem\\)\\]{width:calc(100% - 7.99714rem)}.w-\\[calc\\(100\\%-7\\.14286rem-0\\.857rem\\)\\]{width:calc(100% - 7.99986rem)}.w-\\[var\\(--button-width\\)\\]{width:var(--button-width)}.w-fit{width:-moz-fit-content;width:fit-content}.w-full{width:100%}.w-max{width:-moz-max-content;width:max-content}.min-w-24{min-width:6rem}.min-w-\\[11\\.42857rem\\]{min-width:11.42857rem}.min-w-\\[14\\.857rem\\]{min-width:14.857rem}.min-w-\\[20\\.57142rem\\]{min-width:20.57142rem}.min-w-\\[20\\.57143rem\\]{min-width:20.57143rem}.min-w-\\[22\\.85714rem\\]{min-width:22.85714rem}.min-w-\\[25\\.71429rem\\]{min-width:25.71429rem}.min-w-\\[32\\.85714rem\\]{min-width:32.85714rem}.min-w-\\[37\\.57143rem\\]{min-width:37.57143rem}.min-w-\\[5\\.14285rem\\]{min-width:5.14285rem}.min-w-\\[6\\.85714rem\\]{min-width:6.85714rem}.min-w-\\[8\\.57142rem\\]{min-width:8.57142rem}.min-w-\\[8\\.57143rem\\]{min-width:8.57143rem}.min-w-\\[9\\.14285rem\\]{min-width:9.14285rem}.min-w-\\[9\\.42857rem\\]{min-width:9.42857rem}.min-w-full{min-width:100%}.max-w-\\[13\\.125rem\\]{max-width:13.125rem}.max-w-\\[13\\.42857rem\\]{max-width:13.42857rem}.max-w-\\[14\\.57143rem\\]{max-width:14.57143rem}.max-w-\\[14\\.8rem\\]{max-width:14.8rem}.max-w-\\[15\\.14286rem\\]{max-width:15.14286rem}.max-w-\\[16\\.5rem\\]{max-width:16.5rem}.max-w-\\[16\\.78571rem\\]{max-width:16.78571rem}.max-w-\\[18\\.2rem\\]{max-width:18.2rem}.max-w-\\[24\\.643rem\\]{max-width:24.643rem}.max-w-\\[28\\.57143rem\\]{max-width:28.57143rem}.max-w-\\[28\\.571rem\\]{max-width:28.571rem}.max-w-\\[3\\.5rem\\]{max-width:3.5rem}.max-w-\\[34\\.286rem\\]{max-width:34.286rem}.max-w-\\[35\\.71428rem\\]{max-width:35.71428rem}.max-w-\\[6\\.85714rem\\]{max-width:6.85714rem}.max-w-\\[65\\.71428rem\\]{max-width:65.71428rem}.max-w-\\[85\\.71429rem\\]{max-width:85.71429rem}.max-w-\\[87\\.85714rem\\]{max-width:87.85714rem}.max-w-full{max-width:100%}.flex-1{flex:1 1 0%}.flex-\\[1_0_0\\]{flex:1 0 0}.flex-\\[1_1_calc\\(50\\%-4px\\)\\]{flex:1 1 calc(50% - 4px)}.flex-shrink{flex-shrink:1}.flex-shrink-0,.shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.flex-grow-0{flex-grow:0}.grow{flex-grow:1}.-translate-x-1\\/2{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-y-1\\/2{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-\\[\\.14285rem\\]{--tw-translate-x: .14285rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-\\[0\\.145rem\\]{--tw-translate-x: .145rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-\\[0\\.188rem\\]{--tw-translate-x: .188rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-\\[1\\.14285rem\\]{--tw-translate-x: 1.14285rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-\\[\\.78571rem\\]{--tw-translate-y: .78571rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-rotate-180{--tw-rotate: -180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-rotate-90{--tw-rotate: -90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-180{--tw-rotate: 180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-90{--tw-rotate: 90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.cursor-default{cursor:default}.cursor-pointer{cursor:pointer}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.resize-none{resize:none}.list-decimal{list-style-type:decimal}.list-disc{list-style-type:disc}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-11{grid-template-columns:repeat(11,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-stretch{align-items:stretch}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.gap-\\[-0\\.07142rem\\]{gap:-.07142rem}.gap-\\[-0\\.07142rrem\\]{gap:-.07142rrem}.gap-\\[\\.14285rem\\]{gap:.14285rem}.gap-\\[\\.28571rem\\]{gap:.28571rem}.gap-\\[\\.29rem\\]{gap:.29rem}.gap-\\[\\.42857rem\\]{gap:.42857rem}.gap-\\[\\.57142rem\\]{gap:.57142rem}.gap-\\[\\.57143rem\\]{gap:.57143rem}.gap-\\[\\.57rem\\]{gap:.57rem}.gap-\\[\\.86rem\\]{gap:.86rem}.gap-\\[0\\.14286rem\\]{gap:.14286rem}.gap-\\[0\\.143rem\\]{gap:.143rem}.gap-\\[0\\.28571rem\\]{gap:.28571rem}.gap-\\[0\\.286rem\\]{gap:.286rem}.gap-\\[0\\.32143rem\\]{gap:.32143rem}.gap-\\[0\\.35714rem\\]{gap:.35714rem}.gap-\\[0\\.38rem\\]{gap:.38rem}.gap-\\[0\\.42857rem\\]{gap:.42857rem}.gap-\\[0\\.57142rem\\]{gap:.57142rem}.gap-\\[0\\.57143rem\\]{gap:.57143rem}.gap-\\[0\\.571rem\\]{gap:.571rem}.gap-\\[0\\.57rem\\]{gap:.57rem}.gap-\\[0\\.85714rem\\]{gap:.85714rem}.gap-\\[0\\.857rem\\]{gap:.857rem}.gap-\\[1\\.14285rem\\]{gap:1.14285rem}.gap-\\[1\\.14286rem\\]{gap:1.14286rem}.gap-\\[1\\.143rem\\]{gap:1.143rem}.gap-\\[1\\.71428rem\\]{gap:1.71428rem}.gap-\\[1\\.71429rem\\]{gap:1.71429rem}.gap-\\[1\\.714rem\\]{gap:1.714rem}.gap-\\[1\\.71rem\\]{gap:1.71rem}.gap-\\[2\\.28571rem\\]{gap:2.28571rem}.gap-\\[2\\.286rem\\]{gap:2.286rem}.gap-\\[3\\.42857rem\\]{gap:3.42857rem}.gap-\\[3\\.429rem\\]{gap:3.429rem}.gap-\\[3\\.5rem\\]{gap:3.5rem}.gap-\\[gap-\\[0\\.28571rem\\]\\]{gap:gap-[.28571rem]}.gap-x-1{-moz-column-gap:.25rem;column-gap:.25rem}.gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.gap-x-3{-moz-column-gap:.75rem;column-gap:.75rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.gap-x-6{-moz-column-gap:1.5rem;column-gap:1.5rem}.gap-x-\\[\\.13714rem\\]{-moz-column-gap:.13714rem;column-gap:.13714rem}.gap-x-\\[\\.14285rem\\]{-moz-column-gap:.14285rem;column-gap:.14285rem}.gap-x-\\[\\.28571rem\\]{-moz-column-gap:.28571rem;column-gap:.28571rem}.gap-x-\\[\\.57143rem\\]{-moz-column-gap:.57143rem;column-gap:.57143rem}.gap-x-\\[\\.85714rem\\]{-moz-column-gap:.85714rem;column-gap:.85714rem}.gap-x-\\[0\\.14286rem\\]{-moz-column-gap:.14286rem;column-gap:.14286rem}.gap-x-\\[0\\.1rem\\]{-moz-column-gap:.1rem;column-gap:.1rem}.gap-x-\\[0\\.28571rem\\]{-moz-column-gap:.28571rem;column-gap:.28571rem}.gap-x-\\[0\\.286rem\\]{-moz-column-gap:.286rem;column-gap:.286rem}.gap-x-\\[0\\.29rem\\]{-moz-column-gap:.29rem;column-gap:.29rem}.gap-x-\\[0\\.2rem\\]{-moz-column-gap:.2rem;column-gap:.2rem}.gap-x-\\[0\\.42857rem\\]{-moz-column-gap:.42857rem;column-gap:.42857rem}.gap-x-\\[0\\.57142rem\\]{-moz-column-gap:.57142rem;column-gap:.57142rem}.gap-x-\\[0\\.57143rem\\]{-moz-column-gap:.57143rem;column-gap:.57143rem}.gap-x-\\[0\\.571rem\\]{-moz-column-gap:.571rem;column-gap:.571rem}.gap-x-\\[0\\.57rem\\]{-moz-column-gap:.57rem;column-gap:.57rem}.gap-x-\\[0\\.71428rem\\]{-moz-column-gap:.71428rem;column-gap:.71428rem}.gap-x-\\[0\\.71429rem\\]{-moz-column-gap:.71429rem;column-gap:.71429rem}.gap-x-\\[0\\.714rem\\]{-moz-column-gap:.714rem;column-gap:.714rem}.gap-x-\\[0\\.85714rem\\]{-moz-column-gap:.85714rem;column-gap:.85714rem}.gap-x-\\[0\\.857rem\\]{-moz-column-gap:.857rem;column-gap:.857rem}.gap-x-\\[0\\.86rem\\]{-moz-column-gap:.86rem;column-gap:.86rem}.gap-x-\\[1\\.14285rem\\]{-moz-column-gap:1.14285rem;column-gap:1.14285rem}.gap-x-\\[1\\.14286rem\\]{-moz-column-gap:1.14286rem;column-gap:1.14286rem}.gap-x-\\[1\\.143rem\\]{-moz-column-gap:1.143rem;column-gap:1.143rem}.gap-x-\\[1\\.14rem\\]{-moz-column-gap:1.14rem;column-gap:1.14rem}.gap-x-\\[1\\.42857rem\\]{-moz-column-gap:1.42857rem;column-gap:1.42857rem}.gap-x-\\[1\\.71428rem\\]{-moz-column-gap:1.71428rem;column-gap:1.71428rem}.gap-x-\\[1\\.71429rem\\]{-moz-column-gap:1.71429rem;column-gap:1.71429rem}.gap-x-\\[1\\.71rem\\]{-moz-column-gap:1.71rem;column-gap:1.71rem}.gap-x-\\[2\\.28571rem\\]{-moz-column-gap:2.28571rem;column-gap:2.28571rem}.gap-x-\\[3\\.21rem\\]{-moz-column-gap:3.21rem;column-gap:3.21rem}.gap-x-\\[3\\.42857rem\\]{-moz-column-gap:3.42857rem;column-gap:3.42857rem}.gap-x-\\[3\\.429rem\\]{-moz-column-gap:3.429rem;column-gap:3.429rem}.gap-x-\\[3\\.43rem\\]{-moz-column-gap:3.43rem;column-gap:3.43rem}.gap-y-1{row-gap:.25rem}.gap-y-10{row-gap:2.5rem}.gap-y-2{row-gap:.5rem}.gap-y-3{row-gap:.75rem}.gap-y-4{row-gap:1rem}.gap-y-5{row-gap:1.25rem}.gap-y-6{row-gap:1.5rem}.gap-y-8{row-gap:2rem}.gap-y-\\[\\.28571rem\\]{row-gap:.28571rem}.gap-y-\\[\\.57143rem\\]{row-gap:.57143rem}.gap-y-\\[\\.85714rem\\]{row-gap:.85714rem}.gap-y-\\[0\\.14286rem\\]{row-gap:.14286rem}.gap-y-\\[0\\.14rem\\]{row-gap:.14rem}.gap-y-\\[0\\.28571rem\\]{row-gap:.28571rem}.gap-y-\\[0\\.286rem\\]{row-gap:.286rem}.gap-y-\\[0\\.29rem\\]{row-gap:.29rem}.gap-y-\\[0\\.571428rem\\]{row-gap:.571428rem}.gap-y-\\[0\\.57142rem\\]{row-gap:.57142rem}.gap-y-\\[0\\.57143rem\\]{row-gap:.57143rem}.gap-y-\\[0\\.571rem\\]{row-gap:.571rem}.gap-y-\\[0\\.57rem\\]{row-gap:.57rem}.gap-y-\\[0\\.85714rem\\]{row-gap:.85714rem}.gap-y-\\[0\\.857rem\\]{row-gap:.857rem}.gap-y-\\[0\\.86rem\\]{row-gap:.86rem}.gap-y-\\[1\\.14285rem\\]{row-gap:1.14285rem}.gap-y-\\[1\\.14286rem\\]{row-gap:1.14286rem}.gap-y-\\[1\\.143rem\\]{row-gap:1.143rem}.gap-y-\\[1\\.14rem\\]{row-gap:1.14rem}.gap-y-\\[1\\.2rem\\]{row-gap:1.2rem}.gap-y-\\[1\\.42857rem\\]{row-gap:1.42857rem}.gap-y-\\[1\\.71428rem\\]{row-gap:1.71428rem}.gap-y-\\[1\\.71429rem\\]{row-gap:1.71429rem}.gap-y-\\[1\\.714rem\\]{row-gap:1.714rem}.gap-y-\\[1\\.71rem\\]{row-gap:1.71rem}.gap-y-\\[2\\.26rem\\]{row-gap:2.26rem}.gap-y-\\[2\\.28571rem\\]{row-gap:2.28571rem}.gap-y-\\[2\\.5rem\\]{row-gap:2.5rem}.gap-y-\\[2\\.85714rem\\]{row-gap:2.85714rem}.gap-y-\\[2\\.86rem\\]{row-gap:2.86rem}.gap-y-\\[3\\.14286rem\\]{row-gap:3.14286rem}.gap-y-\\[3\\.42857rem\\]{row-gap:3.42857rem}.gap-y-\\[3\\.43rem\\]{row-gap:3.43rem}.gap-y-\\[4\\.28571rem\\]{row-gap:4.28571rem}.gap-y-\\[8\\.57143rem\\]{row-gap:8.57143rem}.space-y-\\[0\\.28571rem\\]>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.28571rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.28571rem * var(--tw-space-y-reverse))}.space-y-\\[1\\.14286rem\\]>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.14286rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.14286rem * var(--tw-space-y-reverse))}.space-y-\\[1\\.714rem\\]>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.714rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.714rem * var(--tw-space-y-reverse))}.self-start{align-self:flex-start}.self-end{align-self:flex-end}.self-center{align-self:center}.self-stretch{align-self:stretch}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.overflow-y-hidden{overflow-y:hidden}.overflow-y-scroll{overflow-y:scroll}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-ellipsis{text-overflow:ellipsis}.whitespace-nowrap{white-space:nowrap}.whitespace-pre{white-space:pre}.whitespace-pre-line{white-space:pre-line}.whitespace-pre-wrap{white-space:pre-wrap}.break-words{overflow-wrap:break-word}.break-all{word-break:break-all}.rounded{border-radius:.25rem}.rounded-3xl{border-radius:1.5rem}.rounded-\\[\\.26122rem\\]{border-radius:.26122rem}.rounded-\\[\\.28571rem\\]{border-radius:.28571rem}.rounded-\\[\\.32652rem\\]{border-radius:.32652rem}.rounded-\\[\\.42857rem\\]{border-radius:.42857rem}.rounded-\\[\\.48979rem\\]{border-radius:.48979rem}.rounded-\\[\\.57142rem\\]{border-radius:.57142rem}.rounded-\\[\\.65305rem\\]{border-radius:.65305rem}.rounded-\\[\\.85714rem\\]{border-radius:.85714rem}.rounded-\\[0\\.07143rem\\]{border-radius:.07143rem}.rounded-\\[0\\.14285rem\\]{border-radius:.14285rem}.rounded-\\[0\\.28571rem\\]{border-radius:.28571rem}.rounded-\\[0\\.286rem\\]{border-radius:.286rem}.rounded-\\[0\\.29rem\\]{border-radius:.29rem}.rounded-\\[0\\.42857rem\\]{border-radius:.42857rem}.rounded-\\[0\\.57142rem\\]{border-radius:.57142rem}.rounded-\\[0\\.57143rem\\]{border-radius:.57143rem}.rounded-\\[0\\.571rem\\]{border-radius:.571rem}.rounded-\\[0\\.57rem\\]{border-radius:.57rem}.rounded-\\[0\\.59036rem\\]{border-radius:.59036rem}.rounded-\\[0\\.85714rem\\]{border-radius:.85714rem}.rounded-\\[0\\.857rem\\]{border-radius:.857rem}.rounded-\\[1\\.14285rem\\]{border-radius:1.14285rem}.rounded-\\[1\\.14286rem\\]{border-radius:1.14286rem}.rounded-\\[1\\.143rem\\]{border-radius:1.143rem}.rounded-\\[1\\.14rem\\]{border-radius:1.14rem}.rounded-\\[1\\.30611rem\\]{border-radius:1.30611rem}.rounded-\\[1\\.71429rem\\]{border-radius:1.71429rem}.rounded-\\[1\\.714rem\\]{border-radius:1.714rem}.rounded-\\[1rem\\]{border-radius:1rem}.rounded-\\[2\\.5rem\\]{border-radius:2.5rem}.rounded-\\[6\\.1875rem\\]{border-radius:6.1875rem}.rounded-\\[6\\.25rem\\]{border-radius:6.25rem}.rounded-\\[62\\.4375rem\\]{border-radius:62.4375rem}.rounded-\\[7\\.07143rem\\]{border-radius:7.07143rem}.rounded-\\[71\\.35714rem\\]{border-radius:71.35714rem}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-none{border-radius:0}.rounded-xl{border-radius:.75rem}.rounded-b-\\[\\.28571rem\\]{border-bottom-right-radius:.28571rem;border-bottom-left-radius:.28571rem}.rounded-b-\\[\\.57142rem\\]{border-bottom-right-radius:.57142rem;border-bottom-left-radius:.57142rem}.rounded-b-\\[0\\.57rem\\]{border-bottom-right-radius:.57rem;border-bottom-left-radius:.57rem}.rounded-b-\\[1\\.143rem\\]{border-bottom-right-radius:1.143rem;border-bottom-left-radius:1.143rem}.rounded-bl-\\[\\.32652rem\\]{border-bottom-left-radius:.32652rem}.rounded-br-\\[\\.32652rem\\]{border-bottom-right-radius:.32652rem}.rounded-tl-\\[0\\.32652rem\\]{border-top-left-radius:.32652rem}.rounded-tr-\\[0\\.32652rem\\]{border-top-right-radius:.32652rem}.border{border-width:1px}.border-\\[0\\.143rem\\]{border-width:.143rem}.border-\\[0\\.35428rem\\]{border-width:.35428rem}.border-\\[1\\.5px\\]{border-width:1.5px}.border-\\[2px\\]{border-width:2px}.border-y{border-top-width:1px;border-bottom-width:1px}.border-b,.border-b-\\[1px\\]{border-bottom-width:1px}.border-l{border-left-width:1px}.border-l-0{border-left-width:0px}.border-r{border-right-width:1px}.border-r-0{border-right-width:0px}.border-t{border-top-width:1px}.border-t-0{border-top-width:0px}.border-solid{border-style:solid}.border-dashed{border-style:dashed}.border-ciety-dk-60{--tw-border-opacity: 1;border-color:rgb(119 119 124 / var(--tw-border-opacity))}.border-ciety-dk-80{--tw-border-opacity: 1;border-color:rgb(71 71 77 / var(--tw-border-opacity))}.border-ciety-dk-90{--tw-border-opacity: 1;border-color:rgb(50 50 57 / var(--tw-border-opacity))}.border-ciety-dk-95{--tw-border-opacity: 1;border-color:rgb(40 40 47 / var(--tw-border-opacity))}.border-ciety-gy{--tw-border-opacity: 1;border-color:rgb(177 177 177 / var(--tw-border-opacity))}.border-ciety-rd{--tw-border-opacity: 1;border-color:rgb(250 70 90 / var(--tw-border-opacity))}.border-mshop-black{--tw-border-opacity: 1;border-color:rgb(20 20 20 / var(--tw-border-opacity))}.border-mshop-blue-100{--tw-border-opacity: 1;border-color:rgb(28 117 255 / var(--tw-border-opacity))}.border-mshop-gray-10{--tw-border-opacity: 1;border-color:rgb(231 231 231 / var(--tw-border-opacity))}.border-mshop-gray-20{--tw-border-opacity: 1;border-color:rgb(217 217 217 / var(--tw-border-opacity))}.border-mshop-gray-5{--tw-border-opacity: 1;border-color:rgb(245 245 245 / var(--tw-border-opacity))}.border-mshop-gray-50{--tw-border-opacity: 1;border-color:rgb(162 162 162 / var(--tw-border-opacity))}.border-mshop-gray-80{--tw-border-opacity: 1;border-color:rgb(107 107 107 / var(--tw-border-opacity))}.border-mshop-red-80{--tw-border-opacity: 1;border-color:rgb(217 42 15 / var(--tw-border-opacity))}.border-transparent{border-color:transparent}.border-b-mshop-gray-10{--tw-border-opacity: 1;border-bottom-color:rgb(231 231 231 / var(--tw-border-opacity))}.border-b-mshop-gray-20{--tw-border-opacity: 1;border-bottom-color:rgb(217 217 217 / var(--tw-border-opacity))}.border-b-mshop-gray-5{--tw-border-opacity: 1;border-bottom-color:rgb(245 245 245 / var(--tw-border-opacity))}.border-b-mshop-red-80{--tw-border-opacity: 1;border-bottom-color:rgb(217 42 15 / var(--tw-border-opacity))}.border-l-mshop-gray-20{--tw-border-opacity: 1;border-left-color:rgb(217 217 217 / var(--tw-border-opacity))}.border-t-mshop-gray-5{--tw-border-opacity: 1;border-top-color:rgb(245 245 245 / var(--tw-border-opacity))}.border-t-transparent{border-top-color:transparent}.bg-black\\/30{background-color:#0000004d}.bg-ciety-dk{--tw-bg-opacity: 1;background-color:rgb(28 28 36 / var(--tw-bg-opacity))}.bg-ciety-dk-80{--tw-bg-opacity: 1;background-color:rgb(71 71 77 / var(--tw-bg-opacity))}.bg-ciety-dk-90{--tw-bg-opacity: 1;background-color:rgb(50 50 57 / var(--tw-bg-opacity))}.bg-ciety-dk-95{--tw-bg-opacity: 1;background-color:rgb(40 40 47 / var(--tw-bg-opacity))}.bg-ciety-dk\\/90{background-color:#1c1c24e6}.bg-ciety-gy-30{--tw-bg-opacity: 1;background-color:rgb(231 231 231 / var(--tw-bg-opacity))}.bg-ciety-lg{--tw-bg-opacity: 1;background-color:rgb(178 255 0 / var(--tw-bg-opacity))}.bg-ciety-rd{--tw-bg-opacity: 1;background-color:rgb(250 70 90 / var(--tw-bg-opacity))}.bg-ciety-wh{--tw-bg-opacity: 1;background-color:rgb(251 251 251 / var(--tw-bg-opacity))}.bg-mshop-black{--tw-bg-opacity: 1;background-color:rgb(20 20 20 / var(--tw-bg-opacity))}.bg-mshop-blue-10{--tw-bg-opacity: 1;background-color:rgb(235 243 254 / var(--tw-bg-opacity))}.bg-mshop-blue-100{--tw-bg-opacity: 1;background-color:rgb(28 117 255 / var(--tw-bg-opacity))}.bg-mshop-bright-20{background-color:#fff3}.bg-mshop-bright-5{background-color:#ffffff0d}.bg-mshop-bright-60{background-color:#fff9}.bg-mshop-bright-95{background-color:#fffffff2}.bg-mshop-brown-10{--tw-bg-opacity: 1;background-color:rgb(255 249 226 / var(--tw-bg-opacity))}.bg-mshop-dim-10{background-color:#1414141a}.bg-mshop-dim-30{background-color:#1414144d}.bg-mshop-dim-60{background-color:#14141499}.bg-mshop-gray-10{--tw-bg-opacity: 1;background-color:rgb(231 231 231 / var(--tw-bg-opacity))}.bg-mshop-gray-20{--tw-bg-opacity: 1;background-color:rgb(217 217 217 / var(--tw-bg-opacity))}.bg-mshop-gray-5{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.bg-mshop-gray-50{--tw-bg-opacity: 1;background-color:rgb(162 162 162 / var(--tw-bg-opacity))}.bg-mshop-gray-80{--tw-bg-opacity: 1;background-color:rgb(107 107 107 / var(--tw-bg-opacity))}.bg-mshop-green-10{--tw-bg-opacity: 1;background-color:rgb(235 254 243 / var(--tw-bg-opacity))}.bg-mshop-pink-20{--tw-bg-opacity: 1;background-color:rgb(255 228 255 / var(--tw-bg-opacity))}.bg-mshop-red-10{--tw-bg-opacity: 1;background-color:rgb(252 238 236 / var(--tw-bg-opacity))}.bg-mshop-red-80{--tw-bg-opacity: 1;background-color:rgb(217 42 15 / var(--tw-bg-opacity))}.bg-mshop-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-opacity-60{--tw-bg-opacity: .6}.bg-cover{background-size:cover}.bg-center{background-position:center}.bg-no-repeat{background-repeat:no-repeat}.fill-ciety-dk-80{fill:#47474d}.fill-ciety-gy{fill:#b1b1b1}.fill-ciety-wh{fill:#fbfbfb}.fill-mshop-black{fill:#141414}.fill-mshop-blue-100{fill:#1c75ff}.fill-mshop-gray-20{fill:#d9d9d9}.fill-mshop-gray-50{fill:#a2a2a2}.fill-mshop-gray-80{fill:#6b6b6b}.fill-mshop-red-80{fill:#d92a0f}.fill-mshop-white{fill:#fff}.object-cover{-o-object-fit:cover;object-fit:cover}.p-0{padding:0}.p-2{padding:.5rem}.p-6{padding:1.5rem}.p-\\[\\.28571rem\\]{padding:.28571rem}.p-\\[\\.57143rem\\]{padding:.57143rem}.p-\\[0\\.1875rem\\]{padding:.1875rem}.p-\\[0\\.28571rem\\]{padding:.28571rem}.p-\\[0\\.375rem\\]{padding:.375rem}.p-\\[0\\.57142rem\\]{padding:.57142rem}.p-\\[0\\.57143rem\\]{padding:.57143rem}.p-\\[0\\.57rem\\]{padding:.57rem}.p-\\[0\\.63rem\\]{padding:.63rem}.p-\\[0\\.85714rem\\]{padding:.85714rem}.p-\\[0\\.857rem\\]{padding:.857rem}.p-\\[0\\.86rem\\]{padding:.86rem}.p-\\[0\\.88557rem\\]{padding:.88557rem}.p-\\[1\\.14285rem\\]{padding:1.14285rem}.p-\\[1\\.14286rem\\]{padding:1.14286rem}.p-\\[1\\.143rem\\]{padding:1.143rem}.p-\\[1\\.14rem\\]{padding:1.14rem}.p-\\[1\\.42857rem\\]{padding:1.42857rem}.p-\\[1\\.71428rem\\]{padding:1.71428rem}.p-\\[1\\.71429rem\\]{padding:1.71429rem}.p-\\[1\\.7143rem\\]{padding:1.7143rem}.p-\\[1\\.714rem\\]{padding:1.714rem}.p-\\[1\\.71rem\\]{padding:1.71rem}.p-\\[2\\.28571rem\\]{padding:2.28571rem}.p-\\[2\\.29rem\\]{padding:2.29rem}.px-1{padding-left:.25rem;padding-right:.25rem}.px-10{padding-left:2.5rem;padding-right:2.5rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.px-\\[\\.57143rem\\]{padding-left:.57143rem;padding-right:.57143rem}.px-\\[\\.85714rem\\]{padding-left:.85714rem;padding-right:.85714rem}.px-\\[0\\.14285rem\\]{padding-left:.14285rem;padding-right:.14285rem}.px-\\[0\\.14286rem\\]{padding-left:.14286rem;padding-right:.14286rem}.px-\\[0\\.21429rem\\]{padding-left:.21429rem;padding-right:.21429rem}.px-\\[0\\.28571rem\\]{padding-left:.28571rem;padding-right:.28571rem}.px-\\[0\\.286rem\\]{padding-left:.286rem;padding-right:.286rem}.px-\\[0\\.29rem\\]{padding-left:.29rem;padding-right:.29rem}.px-\\[0\\.42857rem\\]{padding-left:.42857rem;padding-right:.42857rem}.px-\\[0\\.57143rem\\]{padding-left:.57143rem;padding-right:.57143rem}.px-\\[0\\.571rem\\]{padding-left:.571rem;padding-right:.571rem}.px-\\[0\\.57rem\\]{padding-left:.57rem;padding-right:.57rem}.px-\\[0\\.857142rem\\]{padding-left:.857142rem;padding-right:.857142rem}.px-\\[0\\.85714rem\\]{padding-left:.85714rem;padding-right:.85714rem}.px-\\[0\\.86rem\\]{padding-left:.86rem;padding-right:.86rem}.px-\\[1\\.14285rem\\]{padding-left:1.14285rem;padding-right:1.14285rem}.px-\\[1\\.14286rem\\]{padding-left:1.14286rem;padding-right:1.14286rem}.px-\\[1\\.1429rem\\]{padding-left:1.1429rem;padding-right:1.1429rem}.px-\\[1\\.142rem\\]{padding-left:1.142rem;padding-right:1.142rem}.px-\\[1\\.143rem\\]{padding-left:1.143rem;padding-right:1.143rem}.px-\\[1\\.14rem\\]{padding-left:1.14rem;padding-right:1.14rem}.px-\\[1\\.42857rem\\]{padding-left:1.42857rem;padding-right:1.42857rem}.px-\\[1\\.4286rem\\]{padding-left:1.4286rem;padding-right:1.4286rem}.px-\\[1\\.429rem\\]{padding-left:1.429rem;padding-right:1.429rem}.px-\\[1\\.43rem\\]{padding-left:1.43rem;padding-right:1.43rem}.px-\\[1\\.71428rem\\]{padding-left:1.71428rem;padding-right:1.71428rem}.px-\\[1\\.71429rem\\]{padding-left:1.71429rem;padding-right:1.71429rem}.px-\\[1\\.714rem\\]{padding-left:1.714rem;padding-right:1.714rem}.px-\\[2\\.28571rem\\]{padding-left:2.28571rem;padding-right:2.28571rem}.px-\\[2\\.29rem\\]{padding-left:2.29rem;padding-right:2.29rem}.px-\\[3\\.42857rem\\]{padding-left:3.42857rem;padding-right:3.42857rem}.px-\\[4\\.28571rem\\]{padding-left:4.28571rem;padding-right:4.28571rem}.px-\\[5\\.71429rem\\]{padding-left:5.71429rem;padding-right:5.71429rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-\\[\\.01785rem\\]{padding-top:.01785rem;padding-bottom:.01785rem}.py-\\[\\.28571rem\\]{padding-top:.28571rem;padding-bottom:.28571rem}.py-\\[\\.57143rem\\]{padding-top:.57143rem;padding-bottom:.57143rem}.py-\\[\\.85714rem\\]{padding-top:.85714rem;padding-bottom:.85714rem}.py-\\[0\\.07143rem\\]{padding-top:.07143rem;padding-bottom:.07143rem}.py-\\[0\\.10714rem\\]{padding-top:.10714rem;padding-bottom:.10714rem}.py-\\[0\\.21rem\\]{padding-top:.21rem;padding-bottom:.21rem}.py-\\[0\\.25rem\\]{padding-top:.25rem;padding-bottom:.25rem}.py-\\[0\\.28571rem\\]{padding-top:.28571rem;padding-bottom:.28571rem}.py-\\[0\\.286rem\\]{padding-top:.286rem;padding-bottom:.286rem}.py-\\[0\\.29rem\\]{padding-top:.29rem;padding-bottom:.29rem}.py-\\[0\\.35714rem\\]{padding-top:.35714rem;padding-bottom:.35714rem}.py-\\[0\\.375rem\\]{padding-top:.375rem;padding-bottom:.375rem}.py-\\[0\\.57142rem\\]{padding-top:.57142rem;padding-bottom:.57142rem}.py-\\[0\\.57143rem\\]{padding-top:.57143rem;padding-bottom:.57143rem}.py-\\[0\\.571rem\\]{padding-top:.571rem;padding-bottom:.571rem}.py-\\[0\\.57rem\\]{padding-top:.57rem;padding-bottom:.57rem}.py-\\[0\\.64285rem\\]{padding-top:.64285rem;padding-bottom:.64285rem}.py-\\[0\\.64286rem\\]{padding-top:.64286rem;padding-bottom:.64286rem}.py-\\[0\\.71429rem\\]{padding-top:.71429rem;padding-bottom:.71429rem}.py-\\[0\\.85714rem\\]{padding-top:.85714rem;padding-bottom:.85714rem}.py-\\[0\\.857rem\\]{padding-top:.857rem;padding-bottom:.857rem}.py-\\[0\\.86rem\\]{padding-top:.86rem;padding-bottom:.86rem}.py-\\[0\\.92857rem\\]{padding-top:.92857rem;padding-bottom:.92857rem}.py-\\[1\\.14285rem\\]{padding-top:1.14285rem;padding-bottom:1.14285rem}.py-\\[1\\.14286rem\\]{padding-top:1.14286rem;padding-bottom:1.14286rem}.py-\\[1\\.143rem\\]{padding-top:1.143rem;padding-bottom:1.143rem}.py-\\[1\\.14rem\\]{padding-top:1.14rem;padding-bottom:1.14rem}.py-\\[1\\.43rem\\]{padding-top:1.43rem;padding-bottom:1.43rem}.py-\\[1\\.64286rem\\]{padding-top:1.64286rem;padding-bottom:1.64286rem}.py-\\[1\\.71429rem\\]{padding-top:1.71429rem;padding-bottom:1.71429rem}.py-\\[1\\.714rem\\]{padding-top:1.714rem;padding-bottom:1.714rem}.py-\\[1\\.71rem\\]{padding-top:1.71rem;padding-bottom:1.71rem}.py-\\[11\\.42857rem\\]{padding-top:11.42857rem;padding-bottom:11.42857rem}.py-\\[11\\.429rem\\]{padding-top:11.429rem;padding-bottom:11.429rem}.py-\\[18rem\\]{padding-top:18rem;padding-bottom:18rem}.py-\\[2\\.28571rem\\]{padding-top:2.28571rem;padding-bottom:2.28571rem}.py-\\[2\\.29rem\\]{padding-top:2.29rem;padding-bottom:2.29rem}.py-\\[2\\.57143rem\\]{padding-top:2.57143rem;padding-bottom:2.57143rem}.py-\\[2\\.85714rem\\]{padding-top:2.85714rem;padding-bottom:2.85714rem}.py-\\[4\\.28571rem\\]{padding-top:4.28571rem;padding-bottom:4.28571rem}.py-\\[4\\.29rem\\]{padding-top:4.29rem;padding-bottom:4.29rem}.py-\\[6\\.85714rem\\]{padding-top:6.85714rem;padding-bottom:6.85714rem}.py-\\[8\\.57143rem\\]{padding-top:8.57143rem;padding-bottom:8.57143rem}.pb-6{padding-bottom:1.5rem}.pb-\\[\\.35428rem\\]{padding-bottom:.35428rem}.pb-\\[0\\.14286rem\\]{padding-bottom:.14286rem}.pb-\\[0\\.28571rem\\]{padding-bottom:.28571rem}.pb-\\[0\\.286rem\\]{padding-bottom:.286rem}.pb-\\[0\\.57143rem\\]{padding-bottom:.57143rem}.pb-\\[0\\.85714rem\\]{padding-bottom:.85714rem}.pb-\\[0\\.857rem\\]{padding-bottom:.857rem}.pb-\\[0\\.86rem\\]{padding-bottom:.86rem}.pb-\\[1\\.14286rem\\]{padding-bottom:1.14286rem}.pb-\\[1\\.143rem\\]{padding-bottom:1.143rem}.pb-\\[1\\.14rem\\]{padding-bottom:1.14rem}.pb-\\[1\\.71428rem\\]{padding-bottom:1.71428rem}.pb-\\[1\\.71429rem\\]{padding-bottom:1.71429rem}.pb-\\[1\\.714rem\\]{padding-bottom:1.714rem}.pb-\\[2\\.28571rem\\]{padding-bottom:2.28571rem}.pb-\\[2\\.29rem\\]{padding-bottom:2.29rem}.pb-\\[2\\.85714rem\\]{padding-bottom:2.85714rem}.pb-\\[2\\.86rem\\]{padding-bottom:2.86rem}.pb-\\[2rem\\]{padding-bottom:2rem}.pb-\\[3\\.42857rem\\]{padding-bottom:3.42857rem}.pb-\\[4\\.28571rem\\]{padding-bottom:4.28571rem}.pb-\\[6\\.28571rem\\]{padding-bottom:6.28571rem}.pb-\\[6\\.35714rem\\]{padding-bottom:6.35714rem}.pb-\\[6\\.85714rem\\]{padding-bottom:6.85714rem}.pb-\\[8\\.57143rem\\]{padding-bottom:8.57143rem}.pb-\\[calc\\(env\\(safe-area-inset-bottom\\)\\+1\\.14285rem\\)\\]{padding-bottom:calc(env(safe-area-inset-bottom) + 1.14285rem)}.pb-\\[calc\\(env\\(safe-area-inset-bottom\\)\\+1\\.14rem\\)\\]{padding-bottom:calc(env(safe-area-inset-bottom) + 1.14rem)}.pb-\\[env\\(safe-area-inset-bottom\\)\\]{padding-bottom:env(safe-area-inset-bottom)}.pl-4{padding-left:1rem}.pl-\\[\\.85714rem\\]{padding-left:.85714rem}.pl-\\[0\\.21429rem\\]{padding-left:.21429rem}.pl-\\[0\\.57143rem\\]{padding-left:.57143rem}.pl-\\[0\\.57rem\\]{padding-left:.57rem}.pl-\\[0\\.71429rem\\]{padding-left:.71429rem}.pl-\\[0\\.714rem\\]{padding-left:.714rem}.pl-\\[0\\.85714rem\\]{padding-left:.85714rem}.pl-\\[1\\.14286rem\\]{padding-left:1.14286rem}.pl-\\[1\\.143rem\\]{padding-left:1.143rem}.pl-\\[1\\.14rem\\]{padding-left:1.14rem}.pl-\\[1\\.17rem\\]{padding-left:1.17rem}.pl-\\[1\\.42857rem\\]{padding-left:1.42857rem}.pl-\\[1\\.71429rem\\]{padding-left:1.71429rem}.pl-\\[1\\.714rem\\]{padding-left:1.714rem}.pl-\\[1rem\\]{padding-left:1rem}.pl-\\[2\\.28571rem\\]{padding-left:2.28571rem}.pl-\\[2\\.28rem\\]{padding-left:2.28rem}.pl-\\[2\\.57143rem\\]{padding-left:2.57143rem}.pl-\\[3\\.14286rem\\]{padding-left:3.14286rem}.pr-3{padding-right:.75rem}.pr-\\[0\\.28571rem\\]{padding-right:.28571rem}.pr-\\[0\\.57143rem\\]{padding-right:.57143rem}.pr-\\[0\\.75rem\\]{padding-right:.75rem}.pr-\\[0\\.85714rem\\]{padding-right:.85714rem}.pr-\\[0\\.857rem\\]{padding-right:.857rem}.pr-\\[1\\.14285rem\\]{padding-right:1.14285rem}.pr-\\[1\\.14286rem\\]{padding-right:1.14286rem}.pr-\\[1\\.143rem\\]{padding-right:1.143rem}.pr-\\[1\\.14rem\\]{padding-right:1.14rem}.pr-\\[1\\.17rem\\]{padding-right:1.17rem}.pr-\\[2\\.286rem\\]{padding-right:2.286rem}.pr-\\[3\\.429rem\\]{padding-right:3.429rem}.pt-7{padding-top:1.75rem}.pt-\\[\\.28571rem\\]{padding-top:.28571rem}.pt-\\[\\.57143rem\\]{padding-top:.57143rem}.pt-\\[0\\.07143rem\\]{padding-top:.07143rem}.pt-\\[0\\.14286rem\\]{padding-top:.14286rem}.pt-\\[0\\.21429rem\\]{padding-top:.21429rem}.pt-\\[0\\.28571rem\\]{padding-top:.28571rem}.pt-\\[0\\.57143rem\\]{padding-top:.57143rem}.pt-\\[0\\.571rem\\]{padding-top:.571rem}.pt-\\[0\\.85714rem\\]{padding-top:.85714rem}.pt-\\[0\\.857rem\\]{padding-top:.857rem}.pt-\\[1\\.14285rem\\]{padding-top:1.14285rem}.pt-\\[1\\.14286rem\\]{padding-top:1.14286rem}.pt-\\[1\\.143rem\\]{padding-top:1.143rem}.pt-\\[1\\.14rem\\]{padding-top:1.14rem}.pt-\\[1\\.17rem\\]{padding-top:1.17rem}.pt-\\[1\\.4286rem\\]{padding-top:1.4286rem}.pt-\\[1\\.71429rem\\]{padding-top:1.71429rem}.pt-\\[1\\.71rem\\]{padding-top:1.71rem}.pt-\\[2\\.28571rem\\]{padding-top:2.28571rem}.pt-\\[2\\.29rem\\]{padding-top:2.29rem}.pt-\\[2\\.57142rem\\]{padding-top:2.57142rem}.pt-\\[2\\.57143rem\\]{padding-top:2.57143rem}.pt-\\[2rem\\]{padding-top:2rem}.pt-\\[3\\.42857rem\\]{padding-top:3.42857rem}.pt-\\[4\\.28571rem\\]{padding-top:4.28571rem}.pt-\\[4\\.57143rem\\]{padding-top:4.57143rem}.pt-\\[4rem\\]{padding-top:4rem}.pt-\\[5\\.14rem\\]{padding-top:5.14rem}.pt-\\[6\\.85714rem\\]{padding-top:6.85714rem}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.text-start{text-align:start}.text-\\[0\\.75rem\\]{font-size:.75rem}.text-\\[0\\.875rem\\]{font-size:.875rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.font-medium{font-weight:500}.font-normal{font-weight:400}.uppercase{text-transform:uppercase}.text-ciety-bk{--tw-text-opacity: 1;color:rgb(19 19 26 / var(--tw-text-opacity))}.text-ciety-dk{--tw-text-opacity: 1;color:rgb(28 28 36 / var(--tw-text-opacity))}.text-ciety-dk-60{--tw-text-opacity: 1;color:rgb(119 119 124 / var(--tw-text-opacity))}.text-ciety-dk-80{--tw-text-opacity: 1;color:rgb(71 71 77 / var(--tw-text-opacity))}.text-ciety-dk-90{--tw-text-opacity: 1;color:rgb(50 50 57 / var(--tw-text-opacity))}.text-ciety-gy{--tw-text-opacity: 1;color:rgb(177 177 177 / var(--tw-text-opacity))}.text-ciety-gy-10{--tw-text-opacity: 1;color:rgb(240 240 240 / var(--tw-text-opacity))}.text-ciety-gy-30{--tw-text-opacity: 1;color:rgb(231 231 231 / var(--tw-text-opacity))}.text-ciety-lg{--tw-text-opacity: 1;color:rgb(178 255 0 / var(--tw-text-opacity))}.text-ciety-wh{--tw-text-opacity: 1;color:rgb(251 251 251 / var(--tw-text-opacity))}.text-mshop-black{--tw-text-opacity: 1;color:rgb(20 20 20 / var(--tw-text-opacity))}.text-mshop-blue-10{--tw-text-opacity: 1;color:rgb(235 243 254 / var(--tw-text-opacity))}.text-mshop-blue-100{--tw-text-opacity: 1;color:rgb(28 117 255 / var(--tw-text-opacity))}.text-mshop-bright-70{color:#ffffffb3}.text-mshop-brown-100{--tw-text-opacity: 1;color:rgb(112 76 0 / var(--tw-text-opacity))}.text-mshop-gray-10{--tw-text-opacity: 1;color:rgb(231 231 231 / var(--tw-text-opacity))}.text-mshop-gray-20{--tw-text-opacity: 1;color:rgb(217 217 217 / var(--tw-text-opacity))}.text-mshop-gray-50{--tw-text-opacity: 1;color:rgb(162 162 162 / var(--tw-text-opacity))}.text-mshop-gray-80{--tw-text-opacity: 1;color:rgb(107 107 107 / var(--tw-text-opacity))}.text-mshop-green-100{--tw-text-opacity: 1;color:rgb(0 148 68 / var(--tw-text-opacity))}.text-mshop-red-80{--tw-text-opacity: 1;color:rgb(217 42 15 / var(--tw-text-opacity))}.text-mshop-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.underline{text-decoration-line:underline}.line-through{text-decoration-line:line-through}.underline-offset-2{text-underline-offset:2px}.underline-offset-4{text-underline-offset:4px}.underline-offset-8{text-underline-offset:8px}.placeholder-ciety-dk-60::-moz-placeholder{--tw-placeholder-opacity: 1;color:rgb(119 119 124 / var(--tw-placeholder-opacity))}.placeholder-ciety-dk-60::placeholder{--tw-placeholder-opacity: 1;color:rgb(119 119 124 / var(--tw-placeholder-opacity))}.placeholder-mshop-gray-50::-moz-placeholder{--tw-placeholder-opacity: 1;color:rgb(162 162 162 / var(--tw-placeholder-opacity))}.placeholder-mshop-gray-50::placeholder{--tw-placeholder-opacity: 1;color:rgb(162 162 162 / var(--tw-placeholder-opacity))}.caret-ciety-rd{caret-color:#fa465a}.caret-mshop-blue-100{caret-color:#1c75ff}.caret-mshop-red-80{caret-color:#d92a0f}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-30{opacity:.3}.opacity-40{opacity:.4}.opacity-50{opacity:.5}.opacity-\\[0\\.3\\]{opacity:.3}.outline-none{outline:2px solid transparent;outline-offset:2px}.outline{outline-style:solid}.outline-0{outline-width:0px}.blur-2xl{--tw-blur: blur(40px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.backdrop-blur-\\[10px\\]{--tw-backdrop-blur: blur(10px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.backdrop-blur-\\[20px\\]{--tw-backdrop-blur: blur(20px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.backdrop-blur-\\[30px\\]{--tw-backdrop-blur: blur(30px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.backdrop-blur-\\[40px\\]{--tw-backdrop-blur: blur(40px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.backdrop-blur-\\[5px\\]{--tw-backdrop-blur: blur(5px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-\\[grid-template-rows\\]{transition-property:grid-template-rows;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-width{transition-property:width;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-1000{transition-duration:1s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.duration-500{transition-duration:.5s}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.scrollbar-hide{-ms-overflow-style:none;scrollbar-width:none}.scrollbar-hide::-webkit-scrollbar{display:none}.text-security-disc{-webkit-text-security:disc}.text-security-circle{-webkit-text-security:circle}.text-security-square{-webkit-text-security:square}.flex-center{display:flex;align-items:center;justify-content:center}.flex-col-center{display:flex;flex-direction:column;justify-content:center}.typo-r0{font-size:1.125rem;font-weight:400;line-height:1.688rem;letter-spacing:0em}.typo-m1{font-size:1rem;font-weight:500;line-height:1.5rem;letter-spacing:0em}.typo-r1{font-size:1rem;font-weight:400;line-height:1.5rem;letter-spacing:0em}.typo-m2{font-size:.875rem;font-weight:500;line-height:1.313rem;letter-spacing:0em}.typo-r2{font-size:.875rem;font-weight:400;line-height:1.313rem;letter-spacing:0em}.typo-m3{font-size:.75rem;font-weight:500;line-height:1.125rem;letter-spacing:0em}.typo-r3{font-size:.75rem;font-weight:400;line-height:.938rem;letter-spacing:0em}.typo-mshop-kr-32-b{font-family:Pretendard;font-size:calc(32 / 14 * 1rem);font-weight:700;line-height:calc(45 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-28-b{font-family:Pretendard;font-size:2rem;font-weight:700;line-height:calc(39 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-24-b{font-family:Pretendard;font-size:calc(24 / 14 * 1rem);font-weight:700;line-height:calc(34 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-20-b{font-family:Pretendard;font-size:calc(20 / 14 * 1rem);font-weight:700;line-height:2rem;letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-16-b{font-family:Pretendard;font-size:calc(16 / 14 * 1rem);font-weight:700;line-height:calc(24 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-14-b{font-family:Pretendard;font-size:1rem;font-weight:700;line-height:calc(22 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-12-b{font-family:Pretendard;font-size:calc(12 / 14 * 1rem);font-weight:700;line-height:calc(17 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-24-m{font-family:Pretendard;font-size:calc(24 / 14 * 1rem);font-weight:500;line-height:calc(34 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-20-m{font-family:Pretendard;font-size:calc(20 / 14 * 1rem);font-weight:500;line-height:2rem;letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-16-m{font-family:Pretendard;font-size:calc(16 / 14 * 1rem);font-weight:500;line-height:calc(24 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-14-m{font-family:Pretendard;font-size:1rem;font-weight:500;line-height:calc(22 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-12-m{font-family:Pretendard;font-size:calc(12 / 14 * 1rem);font-weight:500;line-height:calc(17 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-10-m{font-family:Pretendard;font-size:calc(10 / 14 * 1rem);font-weight:500;line-height:1rem;letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-20-r{font-family:Pretendard;font-size:calc(20 / 14 * 1rem);font-weight:400;line-height:2rem;letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-16-r{font-family:Pretendard;font-size:calc(16 / 14 * 1rem);font-weight:400;line-height:calc(24 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-14-r{font-family:Pretendard;font-size:1rem;font-weight:400;line-height:calc(22 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-kr-12-r{font-family:Pretendard;font-size:calc(12 / 14 * 1rem);font-weight:400;line-height:calc(17 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-40-bebas-b{font-family:Bebas Neue Pro;font-size:calc(40 / 14 * 1rem);font-weight:700;line-height:calc(90% / 14 * 1rem)}.typo-mshop-en-32-bebas-b{font-family:Bebas Neue Pro;font-size:calc(32 / 14 * 1rem);font-weight:700;line-height:calc(32 / 14 * 1rem)}.typo-mshop-en-24-bebas-b{font-family:Bebas Neue Pro;font-size:calc(24 / 14 * 1rem);font-weight:700;line-height:calc(24 / 14 * 1rem)}.typo-mshop-en-24-unica-b{font-family:Neue Haas Unica Pro;font-size:calc(24 / 14 * 1rem);font-weight:700;line-height:calc(34 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-20-bebas-b{font-family:Bebas Neue Pro;font-size:calc(20 / 14 * 1rem);font-weight:700;line-height:2rem}.typo-mshop-en-20-unica-b{font-family:Neue Haas Unica Pro;font-size:calc(20 / 14 * 1rem);font-weight:700;line-height:2rem;letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-20-unica-m{font-family:Neue Haas Unica Pro;font-size:calc(20 / 14 * 1rem);font-weight:500;line-height:2rem;letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-16-bebas-b{font-family:Bebas Neue Pro;font-size:calc(16 / 14 * 1rem);font-weight:700;line-height:calc(24 / 14 * 1rem)}.typo-mshop-en-16-unica-b{font-family:Neue Haas Unica Pro;font-size:calc(16 / 14 * 1rem);font-weight:700;line-height:calc(22 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-16-unica-m{font-family:Neue Haas Unica Pro;font-size:calc(16 / 14 * 1rem);font-weight:500;line-height:calc(22 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-16-unica-r{font-family:Neue Haas Unica Pro;font-size:calc(16 / 14 * 1rem);font-weight:400;line-height:calc(22 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-14-bebas-b{font-family:Bebas Neue Pro;font-size:1rem;font-weight:700;line-height:calc(20 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-14-unica-b{font-family:Neue Haas Unica Pro;font-size:1rem;font-weight:700;line-height:calc(20 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-14-unica-m{font-family:Neue Haas Unica Pro;font-size:1rem;font-weight:500;line-height:calc(20 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-14-unica-r{font-family:Neue Haas Unica Pro;font-size:1rem;font-weight:400;line-height:calc(20 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-12-unica-m,.typo-mshop-en-12-unica-r{font-family:Neue Haas Unica Pro;font-size:calc(12 / 14 * 1rem);font-weight:500;line-height:calc(17 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.typo-mshop-en-10-unica-r{font-family:Neue Haas Unica Pro;font-size:calc(10 / 14 * 1rem);font-weight:500;line-height:1rem;letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.\\[--anchor-gap\\:0\\.5rem\\]{--anchor-gap: .5rem}.\\[--anchor-max-height\\:19\\.75rem\\]{--anchor-max-height: 19.75rem}.\\[--anchor-max-height\\:20rem\\]{--anchor-max-height: 20rem}.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-noneinput[type=number]::-webkit-inner-spin-button::-webkit-inner-spin-button,.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none input[type=number]::-webkit-inner-spin-button::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-noneinput[type=number]::-webkit-inner-spin-button{-moz-appearance:textfield}.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-noneinput[type=number]::-webkit-outer-spin-button::-webkit-inner-spin-button,.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none input[type=number]::-webkit-outer-spin-button::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-noneinput[type=number]::-webkit-outer-spin-button{-moz-appearance:textfield}.placeholder\\:text-mshop-gray-50::-moz-placeholder{--tw-text-opacity: 1;color:rgb(162 162 162 / var(--tw-text-opacity))}.placeholder\\:text-mshop-gray-50::placeholder{--tw-text-opacity: 1;color:rgb(162 162 162 / var(--tw-text-opacity))}.placeholder\\:typo-mshop-kr-14-m::-moz-placeholder{font-family:Pretendard;font-size:1rem;font-weight:500;line-height:calc(22 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.placeholder\\:typo-mshop-kr-14-m::placeholder{font-family:Pretendard;font-size:1rem;font-weight:500;line-height:calc(22 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.before\\:block:before{content:var(--tw-content);display:block}.before\\:h-\\[0\\.86rem\\]:before{content:var(--tw-content);height:.86rem}.before\\:w-\\[0\\.07rem\\]:before{content:var(--tw-content);width:.07rem}.before\\:bg-mshop-gray-20:before{content:var(--tw-content);--tw-bg-opacity: 1;background-color:rgb(217 217 217 / var(--tw-bg-opacity))}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:-bottom-px:after{content:var(--tw-content);bottom:-1px}.after\\:left-0:after{content:var(--tw-content);left:0}.after\\:block:after{content:var(--tw-content);display:block}.after\\:h-0\\.5:after{content:var(--tw-content);height:.125rem}.after\\:h-\\[2px\\]:after{content:var(--tw-content);height:2px}.after\\:w-full:after{content:var(--tw-content);width:100%}.after\\:flex-\\[1_1_calc\\(50\\%-4px\\)\\]:after{content:var(--tw-content);flex:1 1 calc(50% - 4px)}.after\\:bg-mshop-blue-100:after{content:var(--tw-content);--tw-bg-opacity: 1;background-color:rgb(28 117 255 / var(--tw-bg-opacity))}.first\\:ml-0:first-child{margin-left:0}.first\\:rounded-bl-\\[0\\.32652rem\\]:first-child{border-bottom-left-radius:.32652rem}.first\\:rounded-tl-\\[0\\.32652rem\\]:first-child{border-top-left-radius:.32652rem}.first\\:border-t-0:first-child{border-top-width:0px}.last\\:rounded-br-\\[0\\.32652rem\\]:last-child{border-bottom-right-radius:.32652rem}.last\\:rounded-tr-\\[0\\.32652rem\\]:last-child{border-top-right-radius:.32652rem}.read-only\\:bg-mshop-gray-5:-moz-read-only{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.read-only\\:bg-mshop-gray-5:read-only{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.focus-within\\:border-mshop-blue-100:focus-within{--tw-border-opacity: 1;border-color:rgb(28 117 255 / var(--tw-border-opacity))}.focus-within\\:caret-mshop-blue-100:focus-within{caret-color:#1c75ff}.hover\\:\\!flex:hover{display:flex!important}.hover\\:cursor-pointer:hover{cursor:pointer}.hover\\:border-ciety-dk-60:hover{--tw-border-opacity: 1;border-color:rgb(119 119 124 / var(--tw-border-opacity))}.hover\\:border-ciety-lg:hover{--tw-border-opacity: 1;border-color:rgb(178 255 0 / var(--tw-border-opacity))}.hover\\:border-mshop-blue-100:hover{--tw-border-opacity: 1;border-color:rgb(28 117 255 / var(--tw-border-opacity))}.hover\\:bg-ciety-dk-90:hover{--tw-bg-opacity: 1;background-color:rgb(50 50 57 / var(--tw-bg-opacity))}.hover\\:bg-ciety-lg:hover{--tw-bg-opacity: 1;background-color:rgb(178 255 0 / var(--tw-bg-opacity))}.hover\\:bg-mshop-blue-10:hover{--tw-bg-opacity: 1;background-color:rgb(235 243 254 / var(--tw-bg-opacity))}.hover\\:bg-mshop-blue-100:hover{--tw-bg-opacity: 1;background-color:rgb(28 117 255 / var(--tw-bg-opacity))}.hover\\:bg-mshop-bright-5:hover{background-color:#ffffff0d}.hover\\:bg-mshop-dim-60:hover{background-color:#14141499}.hover\\:bg-mshop-gray-10:hover{--tw-bg-opacity: 1;background-color:rgb(231 231 231 / var(--tw-bg-opacity))}.hover\\:bg-mshop-gray-5:hover{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.hover\\:text-mshop-black:hover{--tw-text-opacity: 1;color:rgb(20 20 20 / var(--tw-text-opacity))}.hover\\:text-mshop-blue-10:hover{--tw-text-opacity: 1;color:rgb(235 243 254 / var(--tw-text-opacity))}.hover\\:text-mshop-blue-100:hover{--tw-text-opacity: 1;color:rgb(28 117 255 / var(--tw-text-opacity))}.hover\\:text-mshop-white:hover{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.hover\\:opacity-100:hover{opacity:1}.focus\\:border-ciety-lg:focus{--tw-border-opacity: 1;border-color:rgb(178 255 0 / var(--tw-border-opacity))}.focus\\:text-mshop-blue-100:focus{--tw-text-opacity: 1;color:rgb(28 117 255 / var(--tw-text-opacity))}.focus\\:caret-ciety-lg:focus{caret-color:#b2ff00}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.disabled\\:cursor-default:disabled{cursor:default}.disabled\\:border-0:disabled{border-width:0px}.disabled\\:border-ciety-dk-80:disabled{--tw-border-opacity: 1;border-color:rgb(71 71 77 / var(--tw-border-opacity))}.disabled\\:border-transparent:disabled{border-color:transparent}.disabled\\:bg-ciety-dk-80:disabled{--tw-bg-opacity: 1;background-color:rgb(71 71 77 / var(--tw-bg-opacity))}.disabled\\:bg-ciety-dk-90:disabled{--tw-bg-opacity: 1;background-color:rgb(50 50 57 / var(--tw-bg-opacity))}.disabled\\:bg-ciety-dk-95:disabled{--tw-bg-opacity: 1;background-color:rgb(40 40 47 / var(--tw-bg-opacity))}.disabled\\:bg-mshop-gray-10:disabled{--tw-bg-opacity: 1;background-color:rgb(231 231 231 / var(--tw-bg-opacity))}.disabled\\:bg-mshop-gray-5:disabled{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.disabled\\:bg-mshop-gray-50:disabled{--tw-bg-opacity: 1;background-color:rgb(162 162 162 / var(--tw-bg-opacity))}.disabled\\:text-ciety-dk-60:disabled{--tw-text-opacity: 1;color:rgb(119 119 124 / var(--tw-text-opacity))}.disabled\\:text-ciety-dk-80:disabled{--tw-text-opacity: 1;color:rgb(71 71 77 / var(--tw-text-opacity))}.disabled\\:text-mshop-gray-20:disabled{--tw-text-opacity: 1;color:rgb(217 217 217 / var(--tw-text-opacity))}.disabled\\:text-mshop-gray-50:disabled{--tw-text-opacity: 1;color:rgb(162 162 162 / var(--tw-text-opacity))}.disabled\\:opacity-60:disabled{opacity:.6}.group:hover .group-hover\\:border-mshop-blue-100{--tw-border-opacity: 1;border-color:rgb(28 117 255 / var(--tw-border-opacity))}.group:hover .group-hover\\:text-mshop-black{--tw-text-opacity: 1;color:rgb(20 20 20 / var(--tw-text-opacity))}.peer:-moz-read-only~.peer-read-only\\:\\!hidden{display:none!important}.peer:read-only~.peer-read-only\\:\\!hidden{display:none!important}.peer:hover~.peer-hover\\:block{display:block}.peer:hover~.peer-hover\\:opacity-100{opacity:1}.peer:focus~.peer-focus\\:flex{display:flex}.has-\\[\\:focus\\]\\:border-b-mshop-red-80:has(:focus){--tw-border-opacity: 1;border-bottom-color:rgb(217 42 15 / var(--tw-border-opacity))}.has-\\[input\\:disabled\\]\\:border-b-mshop-gray-10:has(input:disabled){--tw-border-opacity: 1;border-bottom-color:rgb(231 231 231 / var(--tw-border-opacity))}.has-\\[input\\:focus\\]\\:border-b-mshop-blue-100:has(input:focus){--tw-border-opacity: 1;border-bottom-color:rgb(28 117 255 / var(--tw-border-opacity))}.has-\\[input\\:-moz-read-only\\]\\:border-b-mshop-gray-10:has(input:-moz-read-only){--tw-border-opacity: 1;border-bottom-color:rgb(231 231 231 / var(--tw-border-opacity))}.has-\\[input\\:read-only\\]\\:border-b-mshop-gray-10:has(input:read-only){--tw-border-opacity: 1;border-bottom-color:rgb(231 231 231 / var(--tw-border-opacity))}.has-\\[input\\:disabled\\]\\:bg-mshop-gray-5:has(input:disabled){--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.has-\\[input\\:-moz-read-only\\]\\:bg-mshop-gray-5:has(input:-moz-read-only){--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.has-\\[input\\:read-only\\]\\:bg-mshop-gray-5:has(input:read-only){--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.data-\\[closed\\]\\:translate-y-full[data-closed]{--tw-translate-y: 100%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.data-\\[disabled\\]\\:cursor-not-allowed[data-disabled]{cursor:not-allowed}.data-\\[open\\]\\:rounded-b-none[data-open]{border-bottom-right-radius:0;border-bottom-left-radius:0}.data-\\[checked\\]\\:border-\\[\\.35428rem\\][data-checked]{border-width:.35428rem}.data-\\[open\\]\\:border-b-0[data-open]{border-bottom-width:0px}.data-\\[checked\\]\\:border-none[data-checked],.data-\\[checked\\]\\:data-\\[disabled\\]\\:border-none[data-disabled][data-checked]{border-style:none}.data-\\[checked\\]\\:border-mshop-blue-100[data-checked]{--tw-border-opacity: 1;border-color:rgb(28 117 255 / var(--tw-border-opacity))}.data-\\[checked\\]\\:data-\\[disabled\\]\\:border-mshop-gray-20[data-disabled][data-checked]{--tw-border-opacity: 1;border-color:rgb(217 217 217 / var(--tw-border-opacity))}.data-\\[disabled\\]\\:border-mshop-gray-10[data-disabled]{--tw-border-opacity: 1;border-color:rgb(231 231 231 / var(--tw-border-opacity))}.data-\\[disabled\\]\\:border-mshop-gray-20[data-disabled]{--tw-border-opacity: 1;border-color:rgb(217 217 217 / var(--tw-border-opacity))}.data-\\[hover\\]\\:data-\\[selected\\]\\:border-mshop-blue-100[data-selected][data-hover]{--tw-border-opacity: 1;border-color:rgb(28 117 255 / var(--tw-border-opacity))}.data-\\[open\\]\\:border-ciety-dk-60[data-open]{--tw-border-opacity: 1;border-color:rgb(119 119 124 / var(--tw-border-opacity))}.data-\\[selected\\]\\:border-mshop-black[data-selected]{--tw-border-opacity: 1;border-color:rgb(20 20 20 / var(--tw-border-opacity))}.data-\\[open\\]\\:border-b-transparent[data-open]{border-bottom-color:transparent}.data-\\[checked\\]\\:bg-mshop-blue-100[data-checked]{--tw-bg-opacity: 1;background-color:rgb(28 117 255 / var(--tw-bg-opacity))}.data-\\[checked\\]\\:data-\\[disabled\\]\\:bg-mshop-gray-20[data-disabled][data-checked]{--tw-bg-opacity: 1;background-color:rgb(217 217 217 / var(--tw-bg-opacity))}.data-\\[checked\\]\\:data-\\[disabled\\]\\:bg-mshop-gray-5[data-disabled][data-checked]{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.data-\\[disabled\\]\\:bg-ciety-dk[data-disabled]{--tw-bg-opacity: 1;background-color:rgb(28 28 36 / var(--tw-bg-opacity))}.data-\\[disabled\\]\\:bg-mshop-gray-5[data-disabled]{--tw-bg-opacity: 1;background-color:rgb(245 245 245 / var(--tw-bg-opacity))}.data-\\[focus\\]\\:bg-ciety-dk-90[data-focus]{--tw-bg-opacity: 1;background-color:rgb(50 50 57 / var(--tw-bg-opacity))}.data-\\[selected\\]\\:bg-mshop-blue-10[data-selected]{--tw-bg-opacity: 1;background-color:rgb(235 243 254 / var(--tw-bg-opacity))}.data-\\[disabled\\]\\:text-ciety-dk-80[data-disabled]{--tw-text-opacity: 1;color:rgb(71 71 77 / var(--tw-text-opacity))}.data-\\[hover\\]\\:data-\\[selected\\]\\:text-mshop-blue-100[data-selected][data-hover],.data-\\[hover\\]\\:text-mshop-blue-100[data-hover]{--tw-text-opacity: 1;color:rgb(28 117 255 / var(--tw-text-opacity))}.data-\\[selected\\]\\:text-mshop-black[data-selected]{--tw-text-opacity: 1;color:rgb(20 20 20 / var(--tw-text-opacity))}.data-\\[disabled\\]\\:opacity-40[data-disabled]{opacity:.4}.data-\\[selected\\]\\:typo-mshop-kr-14-b[data-selected]{font-family:Pretendard;font-size:1rem;font-weight:700;line-height:calc(22 / 14 * 1rem);letter-spacing:calc(calc(.2 / 14 * 1rem) * -1)}.group[data-checked] .group-data-\\[checked\\]\\:translate-x-\\[0\\.918rem\\]{--tw-translate-x: .918rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group[data-checked] .group-data-\\[checked\\]\\:translate-x-\\[1\\.188rem\\]{--tw-translate-x: 1.188rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group[data-checked] .group-data-\\[checked\\]\\:translate-x-\\[1\\.28571rem\\]{--tw-translate-x: 1.28571rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group[data-checked] .group-data-\\[checked\\]\\:translate-x-\\[1\\.57142rem\\]{--tw-translate-x: 1.57142rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group[data-open] .group-data-\\[open\\]\\:rotate-180{--tw-rotate: 180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group[data-checked] .group-data-\\[checked\\]\\:bg-ciety-lg{--tw-bg-opacity: 1;background-color:rgb(178 255 0 / var(--tw-bg-opacity))}.group[data-disabled] .group-data-\\[disabled\\]\\:bg-ciety-dk-60{--tw-bg-opacity: 1;background-color:rgb(119 119 124 / var(--tw-bg-opacity))}.group[data-disabled][data-checked] .group-data-\\[disabled\\]\\:group-data-\\[checked\\]\\:bg-ciety-lg\\/50{background-color:#b2ff0080}.group[data-disabled] .group-data-\\[disabled\\]\\:text-ciety-dk-80{--tw-text-opacity: 1;color:rgb(71 71 77 / var(--tw-text-opacity))}.group[data-checked] .group-data-\\[checked\\]\\:opacity-100{opacity:1}@media (min-width: 1920px){.\\32xl\\:max-w-\\[50\\%\\]{max-width:50%}.\\32xl\\:flex-row{flex-direction:row}.\\32xl\\:gap-\\[0\\.85714rem\\]{gap:.85714rem}}@media print{.print\\:hidden{display:none}.print\\:p-0{padding:0}.print\\:text-mshop-gray-80{--tw-text-opacity: 1;color:rgb(107 107 107 / var(--tw-text-opacity))}}.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none}.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none}.rdp-root{--rdp-accent-color: blue;--rdp-accent-background-color: #f0f0ff;--rdp-day-height: 44px;--rdp-day-width: 44px;--rdp-day_button-border-radius: 100%;--rdp-day_button-border: 2px solid transparent;--rdp-day_button-height: 42px;--rdp-day_button-width: 42px;--rdp-selected-border: 2px solid var(--rdp-accent-color);--rdp-disabled-opacity: .5;--rdp-outside-opacity: .75;--rdp-today-color: var(--rdp-accent-color);--rdp-dropdown-gap: .5rem;--rdp-months-gap: 2rem;--rdp-nav_button-disabled-opacity: .5;--rdp-nav_button-height: 2.25rem;--rdp-nav_button-width: 2.25rem;--rdp-nav-height: 2.75rem;--rdp-range_middle-background-color: var(--rdp-accent-background-color);--rdp-range_middle-color: inherit;--rdp-range_start-color: white;--rdp-range_start-background: linear-gradient(var(--rdp-gradient-direction), transparent 50%, var(--rdp-range_middle-background-color) 50%);--rdp-range_start-date-background-color: var(--rdp-accent-color);--rdp-range_end-background: linear-gradient(var(--rdp-gradient-direction), var(--rdp-range_middle-background-color) 50%, transparent 50%);--rdp-range_end-color: white;--rdp-range_end-date-background-color: var(--rdp-accent-color);--rdp-week_number-border-radius: 100%;--rdp-week_number-border: 2px solid transparent;--rdp-week_number-height: var(--rdp-day-height);--rdp-week_number-opacity: .75;--rdp-week_number-width: var(--rdp-day-width);--rdp-weeknumber-text-align: center;--rdp-weekday-opacity: .75;--rdp-weekday-padding: .5rem 0rem;--rdp-weekday-text-align: center;--rdp-gradient-direction: 90deg;--rdp-animation_duration: .3s;--rdp-animation_timing: cubic-bezier(.4, 0, .2, 1)}.rdp-root[dir=rtl]{--rdp-gradient-direction: -90deg}.rdp-root[data-broadcast-calendar=true]{--rdp-outside-opacity: unset}.rdp-root{position:relative;box-sizing:border-box}.rdp-root *{box-sizing:border-box}.rdp-day{width:var(--rdp-day-width);height:var(--rdp-day-height);text-align:center}.rdp-day_button{background:none;padding:0;margin:0;cursor:pointer;font:inherit;color:inherit;justify-content:center;align-items:center;display:flex;width:var(--rdp-day_button-width);height:var(--rdp-day_button-height);border:var(--rdp-day_button-border);border-radius:var(--rdp-day_button-border-radius)}.rdp-day_button:disabled{cursor:revert}.rdp-caption_label{z-index:1;position:relative;display:inline-flex;align-items:center;white-space:nowrap;border:0}.rdp-dropdown:focus-visible~.rdp-caption_label{outline:5px auto Highlight;outline:5px auto -webkit-focus-ring-color}.rdp-button_next,.rdp-button_previous{border:none;background:none;padding:0;margin:0;cursor:pointer;font:inherit;color:inherit;-moz-appearance:none;-webkit-appearance:none;display:inline-flex;align-items:center;justify-content:center;position:relative;appearance:none;width:var(--rdp-nav_button-width);height:var(--rdp-nav_button-height)}.rdp-button_next:disabled,.rdp-button_next[aria-disabled=true],.rdp-button_previous:disabled,.rdp-button_previous[aria-disabled=true]{cursor:revert;opacity:var(--rdp-nav_button-disabled-opacity)}.rdp-chevron{display:inline-block;fill:var(--rdp-accent-color)}.rdp-root[dir=rtl] .rdp-nav .rdp-chevron{transform:rotate(180deg);transform-origin:50%}.rdp-dropdowns{position:relative;display:inline-flex;align-items:center;gap:var(--rdp-dropdown-gap)}.rdp-dropdown{z-index:2;opacity:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:absolute;inset-block-start:0;inset-block-end:0;inset-inline-start:0;width:100%;margin:0;padding:0;cursor:inherit;border:none;line-height:inherit}.rdp-dropdown_root{position:relative;display:inline-flex;align-items:center}.rdp-dropdown_root[data-disabled=true] .rdp-chevron{opacity:var(--rdp-disabled-opacity)}.rdp-month_caption{display:flex;align-content:center;height:var(--rdp-nav-height);font-weight:700;font-size:large}.rdp-months{position:relative;display:flex;flex-wrap:wrap;gap:var(--rdp-months-gap);max-width:-moz-fit-content;max-width:fit-content}.rdp-month_grid{border-collapse:collapse}.rdp-nav{position:absolute;inset-block-start:0;inset-inline-end:0;display:flex;align-items:center;height:var(--rdp-nav-height)}.rdp-weekday{opacity:var(--rdp-weekday-opacity);padding:var(--rdp-weekday-padding);font-weight:500;font-size:smaller;text-align:var(--rdp-weekday-text-align);text-transform:var(--rdp-weekday-text-transform)}.rdp-week_number{opacity:var(--rdp-week_number-opacity);font-weight:400;font-size:small;height:var(--rdp-week_number-height);width:var(--rdp-week_number-width);border:var(--rdp-week_number-border);border-radius:var(--rdp-week_number-border-radius);text-align:var(--rdp-weeknumber-text-align)}.rdp-today:not(.rdp-outside){color:var(--rdp-today-color)}.rdp-selected{font-weight:700;font-size:large}.rdp-selected .rdp-day_button{border:var(--rdp-selected-border)}.rdp-outside{opacity:var(--rdp-outside-opacity)}.rdp-disabled{opacity:var(--rdp-disabled-opacity)}.rdp-hidden{visibility:hidden;color:var(--rdp-range_start-color)}.rdp-range_start{background:var(--rdp-range_start-background)}.rdp-range_start .rdp-day_button{background-color:var(--rdp-range_start-date-background-color);color:var(--rdp-range_start-color)}.rdp-range_middle{background-color:var(--rdp-range_middle-background-color)}.rdp-range_middle .rdp-day_button{border-color:transparent;border:unset;border-radius:unset;color:var(--rdp-range_middle-color)}.rdp-range_end{background:var(--rdp-range_end-background);color:var(--rdp-range_end-color)}.rdp-range_end .rdp-day_button{color:var(--rdp-range_start-color);background-color:var(--rdp-range_end-date-background-color)}.rdp-range_start.rdp-range_end{background:revert}.rdp-focusable{cursor:pointer}@keyframes rdp-slide_in_left{0%{transform:translate(-100%)}to{transform:translate(0)}}@keyframes rdp-slide_in_right{0%{transform:translate(100%)}to{transform:translate(0)}}@keyframes rdp-slide_out_left{0%{transform:translate(0)}to{transform:translate(-100%)}}@keyframes rdp-slide_out_right{0%{transform:translate(0)}to{transform:translate(100%)}}.rdp-weeks_before_enter{animation:rdp-slide_in_left var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-weeks_before_exit{animation:rdp-slide_out_left var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-weeks_after_enter{animation:rdp-slide_in_right var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-weeks_after_exit{animation:rdp-slide_out_right var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-root[dir=rtl] .rdp-weeks_after_enter{animation:rdp-slide_in_left var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-root[dir=rtl] .rdp-weeks_before_exit{animation:rdp-slide_out_right var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-root[dir=rtl] .rdp-weeks_before_enter{animation:rdp-slide_in_right var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-root[dir=rtl] .rdp-weeks_after_exit{animation:rdp-slide_out_left var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}@keyframes rdp-fade_in{0%{opacity:0}to{opacity:1}}@keyframes rdp-fade_out{0%{opacity:1}to{opacity:0}}.rdp-caption_after_enter{animation:rdp-fade_in var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-caption_after_exit{animation:rdp-fade_out var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-caption_before_enter{animation:rdp-fade_in var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rdp-caption_before_exit{animation:rdp-fade_out var(--rdp-animation_duration) var(--rdp-animation_timing) forwards}.rc-slider{position:relative;width:100%;height:14px;padding:5px 0;border-radius:6px;touch-action:none;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}.rc-slider *{box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}.rc-slider-rail{position:absolute;width:100%;height:4px;background-color:#e9e9e9;border-radius:6px}.rc-slider-track,.rc-slider-tracks{position:absolute;height:4px;background-color:#abe2fb;border-radius:6px}.rc-slider-track-draggable{z-index:1;box-sizing:content-box;background-clip:content-box;border-top:5px solid rgba(0,0,0,0);border-bottom:5px solid rgba(0,0,0,0);transform:translateY(-5px)}.rc-slider-handle{position:absolute;z-index:1;width:14px;height:14px;margin-top:-5px;background-color:#fff;border:solid 2px #96dbfa;border-radius:50%;cursor:pointer;cursor:grab;opacity:.8;-webkit-user-select:none;-moz-user-select:none;user-select:none;touch-action:pan-x}.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging{border-color:#57c5f7;box-shadow:0 0 0 5px #96dbfa}.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging-delete{opacity:0}.rc-slider-handle:focus{outline:none;box-shadow:none}.rc-slider-handle:focus-visible{border-color:#2db7f5;box-shadow:0 0 0 3px #96dbfa}.rc-slider-handle-click-focused:focus{border-color:#96dbfa;box-shadow:unset}.rc-slider-handle:hover{border-color:#57c5f7}.rc-slider-handle:active{border-color:#57c5f7;box-shadow:0 0 5px #57c5f7;cursor:grabbing}.rc-slider-mark{position:absolute;top:18px;left:0;width:100%;font-size:12px}.rc-slider-mark-text{position:absolute;display:inline-block;color:#999;text-align:center;vertical-align:middle;cursor:pointer}.rc-slider-mark-text-active{color:#666}.rc-slider-step{position:absolute;width:100%;height:4px;background:transparent}.rc-slider-dot{position:absolute;bottom:-2px;width:8px;height:8px;vertical-align:middle;background-color:#fff;border:2px solid #e9e9e9;border-radius:50%;cursor:pointer}.rc-slider-dot-active{border-color:#96dbfa}.rc-slider-dot-reverse{margin-right:-4px}.rc-slider-disabled{background-color:#e9e9e9}.rc-slider-disabled .rc-slider-track{background-color:#ccc}.rc-slider-disabled .rc-slider-handle,.rc-slider-disabled .rc-slider-dot{background-color:#fff;border-color:#ccc;box-shadow:none;cursor:not-allowed}.rc-slider-disabled .rc-slider-mark-text,.rc-slider-disabled .rc-slider-dot{cursor:not-allowed!important}.rc-slider-vertical{width:14px;height:100%;padding:0 5px}.rc-slider-vertical .rc-slider-rail{width:4px;height:100%}.rc-slider-vertical .rc-slider-track{bottom:0;left:5px;width:4px}.rc-slider-vertical .rc-slider-track-draggable{border-top:0;border-right:5px solid rgba(0,0,0,0);border-bottom:0;border-left:5px solid rgba(0,0,0,0);transform:translate(-5px)}.rc-slider-vertical .rc-slider-handle{position:absolute;z-index:1;margin-top:0;margin-left:-5px;touch-action:pan-y}.rc-slider-vertical .rc-slider-mark{top:0;left:18px;height:100%}.rc-slider-vertical .rc-slider-step{width:4px;height:100%}.rc-slider-vertical .rc-slider-dot{margin-left:-2px}.rc-slider-tooltip-zoom-down-enter,.rc-slider-tooltip-zoom-down-appear,.rc-slider-tooltip-zoom-down-leave{display:block!important;animation-duration:.3s;animation-fill-mode:both;animation-play-state:paused}.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active{animation-name:rcSliderTooltipZoomDownIn;animation-play-state:running}.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active{animation-name:rcSliderTooltipZoomDownOut;animation-play-state:running}.rc-slider-tooltip-zoom-down-enter,.rc-slider-tooltip-zoom-down-appear{transform:scale(0);animation-timing-function:cubic-bezier(.23,1,.32,1)}.rc-slider-tooltip-zoom-down-leave{animation-timing-function:cubic-bezier(.755,.05,.855,.06)}@keyframes rcSliderTooltipZoomDownIn{0%{transform:scale(0);transform-origin:50% 100%;opacity:0}to{transform:scale(1);transform-origin:50% 100%}}@keyframes rcSliderTooltipZoomDownOut{0%{transform:scale(1);transform-origin:50% 100%}to{transform:scale(0);transform-origin:50% 100%;opacity:0}}.rc-slider-tooltip{position:absolute;top:-9999px;left:-9999px;visibility:visible;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}.rc-slider-tooltip *{box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0)}.rc-slider-tooltip-hidden{display:none}.rc-slider-tooltip-placement-top{padding:4px 0 8px}.rc-slider-tooltip-inner{min-width:24px;height:24px;padding:6px 2px;color:#fff;font-size:12px;line-height:1;text-align:center;text-decoration:none;background-color:#6c6c6c;border-radius:6px;box-shadow:0 0 4px #d9d9d9}.rc-slider-tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow{bottom:4px;left:50%;margin-left:-4px;border-width:4px 4px 0;border-top-color:#6c6c6c}@font-face{font-family:swiper-icons;src:url(data:application/font-woff;charset=utf-8;base64,\\ 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);font-weight:400;font-style:normal}:root{--swiper-theme-color: #007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function, initial);box-sizing:content-box}.swiper-android .swiper-slide,.swiper-ios .swiper-slide,.swiper-wrapper{transform:translateZ(0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}.swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}.swiper-slide-invisible-blank{visibility:hidden}.swiper-autoheight,.swiper-autoheight .swiper-slide{height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden .swiper-slide{transform:translateZ(0);backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-slide,.swiper-3d .swiper-cube-shadow{transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper:before{content:"";flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered>.swiper-wrapper>.swiper-slide{scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper>.swiper-slide:first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper:before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper>.swiper-slide:first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper:before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-3d .swiper-slide-shadow,.swiper-3d .swiper-slide-shadow-left,.swiper-3d .swiper-slide-shadow-right,.swiper-3d .swiper-slide-shadow-top,.swiper-3d .swiper-slide-shadow-bottom{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-3d .swiper-slide-shadow{background:#00000026}.swiper-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,#00000080,#0000)}.swiper-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,#00000080,#0000)}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color, var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear}.swiper-lazy-preloader-white{--swiper-preloader-color: #fff}.swiper-lazy-preloader-black{--swiper-preloader-color: #000}@keyframes swiper-preloader-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translateZ(0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-pagination-fraction,.swiper-pagination-custom,.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal{bottom:var(--swiper-pagination-bottom, 8px);top:var(--swiper-pagination-top, auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));height:var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius, 50%);background:var(--swiper-pagination-bullet-inactive-color, #000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color, var(--swiper-theme-color))}.swiper-vertical>.swiper-pagination-bullets,.swiper-pagination-vertical.swiper-pagination-bullets{right:var(--swiper-pagination-right, 8px);left:var(--swiper-pagination-left, auto);top:50%;transform:translate3d(0,-50%,0)}.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap, 6px) 0;display:block}.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap, 4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translate(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color, inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color, rgba(0, 0, 0, .25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color, var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size, 4px);left:0;top:0}.swiper-vertical>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite{width:var(--swiper-pagination-progressbar-size, 4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}')),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
var bZ = Object.defineProperty;
var SZ = (e, t, n) => t in e ? bZ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var BI = (e, t, n) => SZ(e, typeof t != "symbol" ? t + "" : t, n);
import * as re from "react";
import Ee, { version as wZ, createContext as ys, useRef as Rt, createElement as iV, useReducer as r5, useEffect as an, useDebugValue as CZ, useCallback as qa, useContext as Ra, forwardRef as yn, useState as Re, useMemo as dn, useLayoutEffect as a5, Fragment as jf, isValidElement as NZ, cloneElement as jZ, useId as Zl, useSyncExternalStore as EZ, createRef as Xj, useImperativeHandle as kZ } from "react";
(function() {
  try {
    var e = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, t = new e.Error().stack;
    t && (e._sentryDebugIds = e._sentryDebugIds || {}, e._sentryDebugIds[t] = "0c2322f1-ac88-4ecd-878f-411f4cba424a", e._sentryDebugIdIdentifier = "sentry-dbid-0c2322f1-ac88-4ecd-878f-411f4cba424a");
  } catch {
  }
})();
const Pi = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, P4 = "8.40.0", Us = globalThis;
function sE(e, t, n) {
  const r = n || Us, s = r.__SENTRY__ = r.__SENTRY__ || {}, o = s[P4] = s[P4] || {};
  return o[e] || (o[e] = t());
}
const s5 = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, _Z = "Sentry Logger ", XR = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], h9 = {};
function B3(e) {
  if (!("console" in Us))
    return e();
  const t = Us.console, n = {}, r = Object.keys(h9);
  r.forEach((s) => {
    const o = h9[s];
    n[s] = t[s], t[s] = o;
  });
  try {
    return e();
  } finally {
    r.forEach((s) => {
      t[s] = n[s];
    });
  }
}
function TZ() {
  let e = !1;
  const t = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return s5 ? XR.forEach((n) => {
    t[n] = (...r) => {
      e && B3(() => {
        Us.console[n](`${_Z}[${n}]:`, ...r);
      });
    };
  }) : XR.forEach((n) => {
    t[n] = () => {
    };
  }), t;
}
const qr = sE("logger", TZ), oV = 50, U4 = "?", HI = /\(error: (.*)\)/, VI = /captureMessage|captureException/;
function lV(...e) {
  const t = e.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0, s = 0) => {
    const o = [], c = n.split(`
`);
    for (let u = r; u < c.length; u++) {
      const m = c[u];
      if (m.length > 1024)
        continue;
      const y = HI.test(m) ? m.replace(HI, "$1") : m;
      if (!y.match(/\S*Error: /)) {
        for (const b of t) {
          const w = b(y);
          if (w) {
            o.push(w);
            break;
          }
        }
        if (o.length >= oV + s)
          break;
      }
    }
    return RZ(o.slice(s));
  };
}
function MZ(e) {
  return Array.isArray(e) ? lV(...e) : e;
}
function RZ(e) {
  if (!e.length)
    return [];
  const t = Array.from(e);
  return /sentryWrapped/.test(lj(t).function || "") && t.pop(), t.reverse(), VI.test(lj(t).function || "") && (t.pop(), VI.test(lj(t).function || "") && t.pop()), t.slice(0, oV).map((n) => ({
    ...n,
    filename: n.filename || lj(t).filename,
    function: n.function || U4
  }));
}
function lj(e) {
  return e[e.length - 1] || {};
}
const gM = "<anonymous>";
function L2(e) {
  try {
    return !e || typeof e != "function" ? gM : e.name || gM;
  } catch {
    return gM;
  }
}
function $I(e) {
  const t = e.exception;
  if (t) {
    const n = [];
    try {
      return t.values.forEach((r) => {
        r.stacktrace.frames && n.push(...r.stacktrace.frames);
      }), n;
    } catch {
      return;
    }
  }
}
const Qj = {}, GI = {};
function i5(e, t) {
  Qj[e] = Qj[e] || [], Qj[e].push(t);
}
function o5(e, t) {
  if (!GI[e]) {
    GI[e] = !0;
    try {
      t();
    } catch (n) {
      s5 && qr.error(`Error while instrumenting ${e}`, n);
    }
  }
}
function qg(e, t) {
  const n = e && Qj[e];
  if (n)
    for (const r of n)
      try {
        r(t);
      } catch (s) {
        s5 && qr.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${L2(r)}
Error:`,
          s
        );
      }
}
let cj = null;
function DZ(e) {
  const t = "error";
  i5(t, e), o5(t, PZ);
}
function PZ() {
  cj = Us.onerror, Us.onerror = function(e, t, n, r, s) {
    return qg("error", {
      column: r,
      error: s,
      line: n,
      msg: e,
      url: t
    }), cj && !cj.__SENTRY_LOADER__ ? cj.apply(this, arguments) : !1;
  }, Us.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let uj = null;
function OZ(e) {
  const t = "unhandledrejection";
  i5(t, e), o5(t, AZ);
}
function AZ() {
  uj = Us.onunhandledrejection, Us.onunhandledrejection = function(e) {
    return qg("unhandledrejection", e), uj && !uj.__SENTRY_LOADER__ ? uj.apply(this, arguments) : !0;
  }, Us.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
function iE() {
  return wP(Us), Us;
}
function wP(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || P4, t[P4] = t[P4] || {};
}
const cV = Object.prototype.toString;
function CP(e) {
  switch (cV.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return z4(e, Error);
  }
}
function sw(e, t) {
  return cV.call(e) === `[object ${t}]`;
}
function uV(e) {
  return sw(e, "ErrorEvent");
}
function WI(e) {
  return sw(e, "DOMError");
}
function LZ(e) {
  return sw(e, "DOMException");
}
function Lv(e) {
  return sw(e, "String");
}
function NP(e) {
  return typeof e == "object" && e !== null && "__sentry_template_string__" in e && "__sentry_template_values__" in e;
}
function jP(e) {
  return e === null || NP(e) || typeof e != "object" && typeof e != "function";
}
function F8(e) {
  return sw(e, "Object");
}
function oE(e) {
  return typeof Event < "u" && z4(e, Event);
}
function IZ(e) {
  return typeof Element < "u" && z4(e, Element);
}
function FZ(e) {
  return sw(e, "RegExp");
}
function lE(e) {
  return !!(e && e.then && typeof e.then == "function");
}
function UZ(e) {
  return F8(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function z4(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function dV(e) {
  return !!(typeof e == "object" && e !== null && (e.__isVue || e._isVue));
}
const EP = Us, zZ = 80;
function fV(e, t = {}) {
  if (!e)
    return "<unknown>";
  try {
    let n = e;
    const r = 5, s = [];
    let o = 0, c = 0;
    const u = " > ", m = u.length;
    let y;
    const b = Array.isArray(t) ? t : t.keyAttrs, w = !Array.isArray(t) && t.maxStringLength || zZ;
    for (; n && o++ < r && (y = BZ(n, b), !(y === "html" || o > 1 && c + s.length * m + y.length >= w)); )
      s.push(y), c += y.length, n = n.parentNode;
    return s.reverse().join(u);
  } catch {
    return "<unknown>";
  }
}
function BZ(e, t) {
  const n = e, r = [];
  if (!n || !n.tagName)
    return "";
  if (EP.HTMLElement && n instanceof HTMLElement && n.dataset) {
    if (n.dataset.sentryComponent)
      return n.dataset.sentryComponent;
    if (n.dataset.sentryElement)
      return n.dataset.sentryElement;
  }
  r.push(n.tagName.toLowerCase());
  const s = t && t.length ? t.filter((c) => n.getAttribute(c)).map((c) => [c, n.getAttribute(c)]) : null;
  if (s && s.length)
    s.forEach((c) => {
      r.push(`[${c[0]}="${c[1]}"]`);
    });
  else {
    n.id && r.push(`#${n.id}`);
    const c = n.className;
    if (c && Lv(c)) {
      const u = c.split(/\s+/);
      for (const m of u)
        r.push(`.${m}`);
    }
  }
  const o = ["aria-label", "type", "name", "title", "alt"];
  for (const c of o) {
    const u = n.getAttribute(c);
    u && r.push(`[${c}="${u}"]`);
  }
  return r.join("");
}
function HZ() {
  try {
    return EP.document.location.href;
  } catch {
    return "";
  }
}
function VZ(e) {
  if (!EP.HTMLElement)
    return null;
  let t = e;
  const n = 5;
  for (let r = 0; r < n; r++) {
    if (!t)
      return null;
    if (t instanceof HTMLElement) {
      if (t.dataset.sentryComponent)
        return t.dataset.sentryComponent;
      if (t.dataset.sentryElement)
        return t.dataset.sentryElement;
    }
    t = t.parentNode;
  }
  return null;
}
function k8(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function YI(e, t) {
  if (!Array.isArray(e))
    return "";
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    try {
      dV(s) ? n.push("[VueViewModel]") : n.push(String(s));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(t);
}
function $Z(e, t, n = !1) {
  return Lv(e) ? FZ(t) ? t.test(e) : Lv(t) ? n ? e === t : e.includes(t) : !1 : !1;
}
function cE(e, t = [], n = !1) {
  return t.some((r) => $Z(e, r, n));
}
function hp(e, t, n) {
  if (!(t in e))
    return;
  const r = e[t], s = n(r);
  typeof s == "function" && mV(s, r);
  try {
    e[t] = s;
  } catch {
    s5 && qr.log(`Failed to replace method "${t}" in object`, e);
  }
}
function B4(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    s5 && qr.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function mV(e, t) {
  try {
    const n = t.prototype || {};
    e.prototype = t.prototype = n, B4(e, "__sentry_original__", t);
  } catch {
  }
}
function kP(e) {
  return e.__sentry_original__;
}
function GZ(e) {
  return Object.keys(e).map((t) => `${encodeURIComponent(t)}=${encodeURIComponent(e[t])}`).join("&");
}
function hV(e) {
  if (CP(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...KI(e)
    };
  if (oE(e)) {
    const t = {
      type: e.type,
      target: qI(e.target),
      currentTarget: qI(e.currentTarget),
      ...KI(e)
    };
    return typeof CustomEvent < "u" && z4(e, CustomEvent) && (t.detail = e.detail), t;
  } else
    return e;
}
function qI(e) {
  try {
    return IZ(e) ? fV(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function KI(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t;
  } else
    return {};
}
function WZ(e, t = 40) {
  const n = Object.keys(hV(e));
  n.sort();
  const r = n[0];
  if (!r)
    return "[object has no keys]";
  if (r.length >= t)
    return k8(r, t);
  for (let s = n.length; s > 0; s--) {
    const o = n.slice(0, s).join(", ");
    if (!(o.length > t))
      return s === n.length ? o : k8(o, t);
  }
  return "";
}
function x1(e) {
  return QR(e, /* @__PURE__ */ new Map());
}
function QR(e, t) {
  if (YZ(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = {};
    t.set(e, r);
    for (const s of Object.getOwnPropertyNames(e))
      typeof e[s] < "u" && (r[s] = QR(e[s], t));
    return r;
  }
  if (Array.isArray(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = [];
    return t.set(e, r), e.forEach((s) => {
      r.push(QR(s, t));
    }), r;
  }
  return e;
}
function YZ(e) {
  if (!F8(e))
    return !1;
  try {
    const t = Object.getPrototypeOf(e).constructor.name;
    return !t || t === "Object";
  } catch {
    return !0;
  }
}
const pV = 1e3;
function H3() {
  return Date.now() / pV;
}
function qZ() {
  const { performance: e } = Us;
  if (!e || !e.now)
    return H3;
  const t = Date.now() - e.now(), n = e.timeOrigin == null ? t : e.timeOrigin;
  return () => (n + e.now()) / pV;
}
const Iv = qZ();
(() => {
  const { performance: e } = Us;
  if (!e || !e.now)
    return;
  const t = 3600 * 1e3, n = e.now(), r = Date.now(), s = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, o = s < t, c = e.timing && e.timing.navigationStart, m = typeof c == "number" ? Math.abs(c + n - r) : t, y = m < t;
  return o || y ? s <= m ? e.timeOrigin : c : r;
})();
function w1() {
  const e = Us, t = e.crypto || e.msCrypto;
  let n = () => Math.random() * 16;
  try {
    if (t && t.randomUUID)
      return t.randomUUID().replace(/-/g, "");
    t && t.getRandomValues && (n = () => {
      const r = new Uint8Array(1);
      return t.getRandomValues(r), r[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (n() & 15) >> r / 4).toString(16)
    )
  );
}
function gV(e) {
  return e.exception && e.exception.values ? e.exception.values[0] : void 0;
}
function y2(e) {
  const { message: t, event_id: n } = e;
  if (t)
    return t;
  const r = gV(e);
  return r ? r.type && r.value ? `${r.type}: ${r.value}` : r.type || r.value || n || "<unknown>" : n || "<unknown>";
}
function ZR(e, t, n) {
  const r = e.exception = e.exception || {}, s = r.values = r.values || [], o = s[0] = s[0] || {};
  o.value || (o.value = t || ""), o.type || (o.type = "Error");
}
function v3(e, t) {
  const n = gV(e);
  if (!n)
    return;
  const r = { type: "generic", handled: !0 }, s = n.mechanism;
  if (n.mechanism = { ...r, ...s, ...t }, t && "data" in t) {
    const o = { ...s && s.data, ...t.data };
    n.mechanism.data = o;
  }
}
function XI(e) {
  if (e && e.__sentry_captured__)
    return !0;
  try {
    B4(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
var kv;
(function(e) {
  e[e.PENDING = 0] = "PENDING";
  const n = 1;
  e[e.RESOLVED = n] = "RESOLVED";
  const r = 2;
  e[e.REJECTED = r] = "REJECTED";
})(kv || (kv = {}));
function H4(e) {
  return new g1((t) => {
    t(e);
  });
}
function p9(e) {
  return new g1((t, n) => {
    n(e);
  });
}
class g1 {
  constructor(t) {
    g1.prototype.__init.call(this), g1.prototype.__init2.call(this), g1.prototype.__init3.call(this), g1.prototype.__init4.call(this), this._state = kv.PENDING, this._handlers = [];
    try {
      t(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  /** JSDoc */
  then(t, n) {
    return new g1((r, s) => {
      this._handlers.push([
        !1,
        (o) => {
          if (!t)
            r(o);
          else
            try {
              r(t(o));
            } catch (c) {
              s(c);
            }
        },
        (o) => {
          if (!n)
            s(o);
          else
            try {
              r(n(o));
            } catch (c) {
              s(c);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(t) {
    return this.then((n) => n, t);
  }
  /** JSDoc */
  finally(t) {
    return new g1((n, r) => {
      let s, o;
      return this.then(
        (c) => {
          o = !1, s = c, t && t();
        },
        (c) => {
          o = !0, s = c, t && t();
        }
      ).then(() => {
        if (o) {
          r(s);
          return;
        }
        n(s);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (t) => {
      this._setResult(kv.RESOLVED, t);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (t) => {
      this._setResult(kv.REJECTED, t);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (t, n) => {
      if (this._state === kv.PENDING) {
        if (lE(n)) {
          n.then(this._resolve, this._reject);
          return;
        }
        this._state = t, this._value = n, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === kv.PENDING)
        return;
      const t = this._handlers.slice();
      this._handlers = [], t.forEach((n) => {
        n[0] || (this._state === kv.RESOLVED && n[1](this._value), this._state === kv.REJECTED && n[2](this._value), n[0] = !0);
      });
    };
  }
}
function KZ(e) {
  const t = Iv(), n = {
    sid: w1(),
    init: !0,
    timestamp: t,
    started: t,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => QZ(n)
  };
  return e && U8(n, e), n;
}
function U8(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Iv(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : w1()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function XZ(e, t) {
  let n = {};
  e.status === "ok" && (n = { status: "exited" }), U8(e, n);
}
function QZ(e) {
  return x1({
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    abnormal_mechanism: e.abnormal_mechanism,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  });
}
function QI() {
  return {
    traceId: w1(),
    spanId: w1().substring(16)
  };
}
function uE(e, t, n = 2) {
  if (!t || typeof t != "object" || n <= 0)
    return t;
  if (e && t && Object.keys(t).length === 0)
    return e;
  const r = { ...e };
  for (const s in t)
    Object.prototype.hasOwnProperty.call(t, s) && (r[s] = uE(r[s], t[s], n - 1));
  return r;
}
const JR = "_sentrySpan";
function ZI(e, t) {
  t ? B4(e, JR, t) : delete e[JR];
}
function JI(e) {
  return e[JR];
}
const ZZ = 100;
class _P {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = QI();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const t = new _P();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._requestSession = this._requestSession, t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, ZI(t, JI(this)), t;
  }
  /**
   * @inheritDoc
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * @inheritDoc
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && U8(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(t) {
    return this._requestSession = t, this;
  }
  /**
   * @inheritDoc
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t, [r, s] = n instanceof V4 ? [n.getScopeData(), n.getRequestSession()] : F8(n) ? [t, t.requestSession] : [], { tags: o, extra: c, user: u, contexts: m, level: y, fingerprint: b = [], propagationContext: w } = r || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...c }, this._contexts = { ...this._contexts, ...m }, u && Object.keys(u).length && (this._user = u), y && (this._level = y), b.length && (this._fingerprint = b), w && (this._propagationContext = w), s && (this._requestSession = s), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, ZI(this, void 0), this._attachments = [], this._propagationContext = QI(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(t, n) {
    const r = typeof n == "number" ? n : ZZ;
    if (r <= 0)
      return this;
    const s = {
      timestamp: H3(),
      ...t
    }, o = this._breadcrumbs;
    return o.push(s), this._breadcrumbs = o.length > r ? o.slice(-r) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: JI(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = uE(this._sdkProcessingMetadata, t, 2), this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(t, n) {
    const r = n && n.event_id ? n.event_id : w1();
    if (!this._client)
      return qr.warn("No client configured on scope - will not capture exception!"), r;
    const s = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: s,
        ...n,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, r) {
    const s = r && r.event_id ? r.event_id : w1();
    if (!this._client)
      return qr.warn("No client configured on scope - will not capture message!"), s;
    const o = new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: o,
        ...r,
        event_id: s
      },
      this
    ), s;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n) {
    const r = n && n.event_id ? n.event_id : w1();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: r }, this), r) : (qr.warn("No client configured on scope - will not capture event!"), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
const V4 = _P;
function JZ() {
  return sE("defaultCurrentScope", () => new V4());
}
function eJ() {
  return sE("defaultIsolationScope", () => new V4());
}
class tJ {
  constructor(t, n) {
    let r;
    t ? r = t : r = new V4();
    let s;
    n ? s = n : s = new V4(), this._stack = [{ scope: r }], this._isolationScope = s;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const n = this._pushScope();
    let r;
    try {
      r = t(n);
    } catch (s) {
      throw this._popScope(), s;
    }
    return lE(r) ? r.then(
      (s) => (this._popScope(), s),
      (s) => {
        throw this._popScope(), s;
      }
    ) : (this._popScope(), r);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function z8() {
  const e = iE(), t = wP(e);
  return t.stack = t.stack || new tJ(JZ(), eJ());
}
function nJ(e) {
  return z8().withScope(e);
}
function rJ(e, t) {
  const n = z8();
  return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function eF(e) {
  return z8().withScope(() => e(z8().getIsolationScope()));
}
function aJ() {
  return {
    withIsolationScope: eF,
    withScope: nJ,
    withSetScope: rJ,
    withSetIsolationScope: (e, t) => eF(t),
    getCurrentScope: () => z8().getScope(),
    getIsolationScope: () => z8().getIsolationScope()
  };
}
function TP(e) {
  const t = wP(e);
  return t.acs ? t.acs : aJ();
}
function K2() {
  const e = iE();
  return TP(e).getCurrentScope();
}
function iw() {
  const e = iE();
  return TP(e).getIsolationScope();
}
function sJ() {
  return sE("globalScope", () => new V4());
}
function iJ(...e) {
  const t = iE(), n = TP(t);
  if (e.length === 2) {
    const [r, s] = e;
    return r ? n.withSetScope(r, s) : n.withScope(s);
  }
  return n.withScope(e[0]);
}
function _f() {
  return K2().getClient();
}
const oJ = "_sentryMetrics";
function lJ(e) {
  const t = e[oJ];
  if (!t)
    return;
  const n = {};
  for (const [, [r, s]] of t)
    (n[r] || (n[r] = [])).push(x1(s));
  return n;
}
const cJ = "sentry.source", uJ = "sentry.sample_rate", dJ = "sentry.op", fJ = "sentry.origin", mJ = 0, hJ = 1, pJ = "sentry-", gJ = /^sentry-/;
function yJ(e) {
  const t = vJ(e);
  if (!t)
    return;
  const n = Object.entries(t).reduce((r, [s, o]) => {
    if (s.match(gJ)) {
      const c = s.slice(pJ.length);
      r[c] = o;
    }
    return r;
  }, {});
  if (Object.keys(n).length > 0)
    return n;
}
function vJ(e) {
  if (!(!e || !Lv(e) && !Array.isArray(e)))
    return Array.isArray(e) ? e.reduce((t, n) => {
      const r = tF(n);
      return Object.entries(r).forEach(([s, o]) => {
        t[s] = o;
      }), t;
    }, {}) : tF(e);
}
function tF(e) {
  return e.split(",").map((t) => t.split("=").map((n) => decodeURIComponent(n.trim()))).reduce((t, [n, r]) => (n && r && (t[n] = r), t), {});
}
const xJ = 1;
function bJ(e) {
  const { spanId: t, traceId: n } = e.spanContext(), { parent_span_id: r } = g9(e);
  return x1({ parent_span_id: r, span_id: t, trace_id: n });
}
function nF(e) {
  return typeof e == "number" ? rF(e) : Array.isArray(e) ? e[0] + e[1] / 1e9 : e instanceof Date ? rF(e.getTime()) : Iv();
}
function rF(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function g9(e) {
  if (wJ(e))
    return e.getSpanJSON();
  try {
    const { spanId: t, traceId: n } = e.spanContext();
    if (SJ(e)) {
      const { attributes: r, startTime: s, name: o, endTime: c, parentSpanId: u, status: m } = e;
      return x1({
        span_id: t,
        trace_id: n,
        data: r,
        description: o,
        parent_span_id: u,
        start_timestamp: nF(s),
        // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
        timestamp: nF(c) || void 0,
        status: NJ(m),
        op: r[dJ],
        origin: r[fJ],
        _metrics_summary: lJ(e)
      });
    }
    return {
      span_id: t,
      trace_id: n
    };
  } catch {
    return {};
  }
}
function SJ(e) {
  const t = e;
  return !!t.attributes && !!t.startTime && !!t.name && !!t.endTime && !!t.status;
}
function wJ(e) {
  return typeof e.getSpanJSON == "function";
}
function CJ(e) {
  const { traceFlags: t } = e.spanContext();
  return t === xJ;
}
function NJ(e) {
  if (!(!e || e.code === mJ))
    return e.code === hJ ? "ok" : e.message || "unknown_error";
}
const jJ = "_sentryRootSpan";
function yV(e) {
  return e[jJ] || e;
}
function EJ(e) {
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const t = _f(), n = t && t.getOptions();
  return !!n && (n.enableTracing || "tracesSampleRate" in n || "tracesSampler" in n);
}
const MP = "production", kJ = "_frozenDsc";
function vV(e, t) {
  const n = t.getOptions(), { publicKey: r } = t.getDsn() || {}, s = x1({
    environment: n.environment || MP,
    release: n.release,
    public_key: r,
    trace_id: e
  });
  return t.emit("createDsc", s), s;
}
function _J(e) {
  const t = _f();
  if (!t)
    return {};
  const n = vV(g9(e).trace_id || "", t), r = yV(e), s = r[kJ];
  if (s)
    return s;
  const o = r.spanContext().traceState, c = o && o.get("sentry.dsc"), u = c && yJ(c);
  if (u)
    return u;
  const m = g9(r), y = m.data || {}, b = y[uJ];
  b != null && (n.sample_rate = `${b}`);
  const w = y[cJ], k = m.description;
  return w !== "url" && k && (n.transaction = k), EJ() && (n.sampled = String(CJ(r))), t.emit("createDsc", n, r), n;
}
function TJ(e) {
  if (typeof e == "boolean")
    return Number(e);
  const t = typeof e == "string" ? parseFloat(e) : e;
  if (typeof t != "number" || isNaN(t) || t < 0 || t > 1) {
    Pi && qr.warn(
      `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
        e
      )} of type ${JSON.stringify(typeof e)}.`
    );
    return;
  }
  return t;
}
const MJ = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function RJ(e) {
  return e === "http" || e === "https";
}
function dE(e, t = !1) {
  const { host: n, path: r, pass: s, port: o, projectId: c, protocol: u, publicKey: m } = e;
  return `${u}://${m}${t && s ? `:${s}` : ""}@${n}${o ? `:${o}` : ""}/${r && `${r}/`}${c}`;
}
function DJ(e) {
  const t = MJ.exec(e);
  if (!t) {
    B3(() => {
      console.error(`Invalid Sentry Dsn: ${e}`);
    });
    return;
  }
  const [n, r, s = "", o = "", c = "", u = ""] = t.slice(1);
  let m = "", y = u;
  const b = y.split("/");
  if (b.length > 1 && (m = b.slice(0, -1).join("/"), y = b.pop()), y) {
    const w = y.match(/^\d+/);
    w && (y = w[0]);
  }
  return xV({ host: o, pass: s, path: m, projectId: y, port: c, protocol: n, publicKey: r });
}
function xV(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function PJ(e) {
  if (!s5)
    return !0;
  const { port: t, projectId: n, protocol: r } = e;
  return ["protocol", "publicKey", "host", "projectId"].find((c) => e[c] ? !1 : (qr.error(`Invalid Sentry Dsn: ${c} missing`), !0)) ? !1 : n.match(/^\d+$/) ? RJ(r) ? t && isNaN(parseInt(t, 10)) ? (qr.error(`Invalid Sentry Dsn: Invalid port ${t}`), !1) : !0 : (qr.error(`Invalid Sentry Dsn: Invalid protocol ${r}`), !1) : (qr.error(`Invalid Sentry Dsn: Invalid projectId ${n}`), !1);
}
function OJ(e) {
  const t = typeof e == "string" ? DJ(e) : xV(e);
  if (!(!t || !PJ(t)))
    return t;
}
function AJ() {
  const e = typeof WeakSet == "function", t = e ? /* @__PURE__ */ new WeakSet() : [];
  function n(s) {
    if (e)
      return t.has(s) ? !0 : (t.add(s), !1);
    for (let o = 0; o < t.length; o++)
      if (t[o] === s)
        return !0;
    return t.push(s), !1;
  }
  function r(s) {
    if (e)
      t.delete(s);
    else
      for (let o = 0; o < t.length; o++)
        if (t[o] === s) {
          t.splice(o, 1);
          break;
        }
  }
  return [n, r];
}
function v2(e, t = 100, n = 1 / 0) {
  try {
    return eD("", e, t, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function bV(e, t = 3, n = 100 * 1024) {
  const r = v2(e, t);
  return UJ(r) > n ? bV(e, t - 1, n) : r;
}
function eD(e, t, n = 1 / 0, r = 1 / 0, s = AJ()) {
  const [o, c] = s;
  if (t == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof t) || typeof t == "number" && Number.isFinite(t))
    return t;
  const u = LJ(e, t);
  if (!u.startsWith("[object "))
    return u;
  if (t.__sentry_skip_normalization__)
    return t;
  const m = typeof t.__sentry_override_normalization_depth__ == "number" ? t.__sentry_override_normalization_depth__ : n;
  if (m === 0)
    return u.replace("object ", "");
  if (o(t))
    return "[Circular ~]";
  const y = t;
  if (y && typeof y.toJSON == "function")
    try {
      const j = y.toJSON();
      return eD("", j, m - 1, r, s);
    } catch {
    }
  const b = Array.isArray(t) ? [] : {};
  let w = 0;
  const k = hV(t);
  for (const j in k) {
    if (!Object.prototype.hasOwnProperty.call(k, j))
      continue;
    if (w >= r) {
      b[j] = "[MaxProperties ~]";
      break;
    }
    const E = k[j];
    b[j] = eD(j, E, m - 1, r, s), w++;
  }
  return c(t), b;
}
function LJ(e, t) {
  try {
    if (e === "domain" && t && typeof t == "object" && t._events)
      return "[Domain]";
    if (e === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && t === global)
      return "[Global]";
    if (typeof window < "u" && t === window)
      return "[Window]";
    if (typeof document < "u" && t === document)
      return "[Document]";
    if (dV(t))
      return "[VueViewModel]";
    if (UZ(t))
      return "[SyntheticEvent]";
    if (typeof t == "number" && !Number.isFinite(t))
      return `[${t}]`;
    if (typeof t == "function")
      return `[Function: ${L2(t)}]`;
    if (typeof t == "symbol")
      return `[${String(t)}]`;
    if (typeof t == "bigint")
      return `[BigInt: ${String(t)}]`;
    const n = IJ(t);
    return /^HTML(\w*)Element$/.test(n) ? `[HTMLElement: ${n}]` : `[object ${n}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function IJ(e) {
  const t = Object.getPrototypeOf(e);
  return t ? t.constructor.name : "null prototype";
}
function FJ(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function UJ(e) {
  return FJ(JSON.stringify(e));
}
function V3(e, t = []) {
  return [e, t];
}
function zJ(e, t) {
  const [n, r] = e;
  return [n, [...r, t]];
}
function aF(e, t) {
  const n = e[1];
  for (const r of n) {
    const s = r[0].type;
    if (t(r, s))
      return !0;
  }
  return !1;
}
function tD(e) {
  return Us.__SENTRY__ && Us.__SENTRY__.encodePolyfill ? Us.__SENTRY__.encodePolyfill(e) : new TextEncoder().encode(e);
}
function BJ(e) {
  const [t, n] = e;
  let r = JSON.stringify(t);
  function s(o) {
    typeof r == "string" ? r = typeof o == "string" ? r + o : [tD(r), o] : r.push(typeof o == "string" ? tD(o) : o);
  }
  for (const o of n) {
    const [c, u] = o;
    if (s(`
${JSON.stringify(c)}
`), typeof u == "string" || u instanceof Uint8Array)
      s(u);
    else {
      let m;
      try {
        m = JSON.stringify(u);
      } catch {
        m = JSON.stringify(v2(u));
      }
      s(m);
    }
  }
  return typeof r == "string" ? r : HJ(r);
}
function HJ(e) {
  const t = e.reduce((s, o) => s + o.length, 0), n = new Uint8Array(t);
  let r = 0;
  for (const s of e)
    n.set(s, r), r += s.length;
  return n;
}
function VJ(e) {
  const t = typeof e.data == "string" ? tD(e.data) : e.data;
  return [
    x1({
      type: "attachment",
      length: t.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    }),
    t
  ];
}
const $J = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  statsd: "metric_bucket"
};
function sF(e) {
  return $J[e];
}
function SV(e) {
  if (!e || !e.sdk)
    return;
  const { name: t, version: n } = e.sdk;
  return { name: t, version: n };
}
function GJ(e, t, n, r) {
  const s = e.sdkProcessingMetadata && e.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && { sdk: t },
    ...!!n && r && { dsn: dE(r) },
    ...s && {
      trace: x1({ ...s })
    }
  };
}
function WJ(e, t) {
  return t && (e.sdk = e.sdk || {}, e.sdk.name = e.sdk.name || t.name, e.sdk.version = e.sdk.version || t.version, e.sdk.integrations = [...e.sdk.integrations || [], ...t.integrations || []], e.sdk.packages = [...e.sdk.packages || [], ...t.packages || []]), e;
}
function YJ(e, t, n, r) {
  const s = SV(n), o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...s && { sdk: s },
    ...!!r && t && { dsn: dE(t) }
  }, c = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e.toJSON()];
  return V3(o, [c]);
}
function qJ(e, t, n, r) {
  const s = SV(n), o = e.type && e.type !== "replay_event" ? e.type : "event";
  WJ(e, n && n.sdk);
  const c = GJ(e, s, r, t);
  return delete e.sdkProcessingMetadata, V3(c, [[{ type: o }, e]]);
}
function nD(e, t, n, r = 0) {
  return new g1((s, o) => {
    const c = e[r];
    if (t === null || typeof c != "function")
      s(t);
    else {
      const u = c({ ...t }, n);
      Pi && c.id && u === null && qr.log(`Event processor "${c.id}" dropped event`), lE(u) ? u.then((m) => nD(e, m, n, r + 1).then(s)).then(null, o) : nD(e, u, n, r + 1).then(s).then(null, o);
    }
  });
}
const iF = /* @__PURE__ */ new WeakMap();
function KJ(e) {
  const t = Us._sentryDebugIds;
  if (!t)
    return {};
  let n;
  const r = iF.get(e);
  return r ? n = r : (n = /* @__PURE__ */ new Map(), iF.set(e, n)), Object.keys(t).reduce((s, o) => {
    let c;
    const u = n.get(o);
    u ? c = u : (c = e(o), n.set(o, c));
    for (let m = c.length - 1; m >= 0; m--) {
      const y = c[m], b = y && y.filename;
      if (y && b) {
        s[b] = t[o];
        break;
      }
    }
    return s;
  }, {});
}
function XJ(e, t) {
  const { fingerprint: n, span: r, breadcrumbs: s, sdkProcessingMetadata: o } = t;
  QJ(e, t), r && eee(e, r), tee(e, n), ZJ(e, s), JJ(e, o);
}
function oF(e, t) {
  const {
    extra: n,
    tags: r,
    user: s,
    contexts: o,
    level: c,
    sdkProcessingMetadata: u,
    breadcrumbs: m,
    fingerprint: y,
    eventProcessors: b,
    attachments: w,
    propagationContext: k,
    transactionName: j,
    span: E
  } = t;
  dj(e, "extra", n), dj(e, "tags", r), dj(e, "user", s), dj(e, "contexts", o), e.sdkProcessingMetadata = uE(e.sdkProcessingMetadata, u, 2), c && (e.level = c), j && (e.transactionName = j), E && (e.span = E), m.length && (e.breadcrumbs = [...e.breadcrumbs, ...m]), y.length && (e.fingerprint = [...e.fingerprint, ...y]), b.length && (e.eventProcessors = [...e.eventProcessors, ...b]), w.length && (e.attachments = [...e.attachments, ...w]), e.propagationContext = { ...e.propagationContext, ...k };
}
function dj(e, t, n) {
  e[t] = uE(e[t], n, 1);
}
function QJ(e, t) {
  const { extra: n, tags: r, user: s, contexts: o, level: c, transactionName: u } = t, m = x1(n);
  m && Object.keys(m).length && (e.extra = { ...m, ...e.extra });
  const y = x1(r);
  y && Object.keys(y).length && (e.tags = { ...y, ...e.tags });
  const b = x1(s);
  b && Object.keys(b).length && (e.user = { ...b, ...e.user });
  const w = x1(o);
  w && Object.keys(w).length && (e.contexts = { ...w, ...e.contexts }), c && (e.level = c), u && e.type !== "transaction" && (e.transaction = u);
}
function ZJ(e, t) {
  const n = [...e.breadcrumbs || [], ...t];
  e.breadcrumbs = n.length ? n : void 0;
}
function JJ(e, t) {
  e.sdkProcessingMetadata = {
    ...e.sdkProcessingMetadata,
    ...t
  };
}
function eee(e, t) {
  e.contexts = {
    trace: bJ(t),
    ...e.contexts
  }, e.sdkProcessingMetadata = {
    dynamicSamplingContext: _J(t),
    ...e.sdkProcessingMetadata
  };
  const n = yV(t), r = g9(n).description;
  r && !e.transaction && e.type === "transaction" && (e.transaction = r);
}
function tee(e, t) {
  e.fingerprint = e.fingerprint ? Array.isArray(e.fingerprint) ? e.fingerprint : [e.fingerprint] : [], t && (e.fingerprint = e.fingerprint.concat(t)), e.fingerprint && !e.fingerprint.length && delete e.fingerprint;
}
function nee(e, t, n, r, s, o) {
  const { normalizeDepth: c = 3, normalizeMaxBreadth: u = 1e3 } = e, m = {
    ...t,
    event_id: t.event_id || n.event_id || w1(),
    timestamp: t.timestamp || H3()
  }, y = n.integrations || e.integrations.map((D) => D.name);
  ree(m, e), iee(m, y), s && s.emit("applyFrameMetadata", t), t.type === void 0 && aee(m, e.stackParser);
  const b = lee(r, n.captureContext);
  n.mechanism && v3(m, n.mechanism);
  const w = s ? s.getEventProcessors() : [], k = sJ().getScopeData();
  if (o) {
    const D = o.getScopeData();
    oF(k, D);
  }
  if (b) {
    const D = b.getScopeData();
    oF(k, D);
  }
  const j = [...n.attachments || [], ...k.attachments];
  j.length && (n.attachments = j), XJ(m, k);
  const E = [
    ...w,
    // Run scope event processors _after_ all other processors
    ...k.eventProcessors
  ];
  return nD(E, m, n).then((D) => (D && see(D), typeof c == "number" && c > 0 ? oee(D, c, u) : D));
}
function ree(e, t) {
  const { environment: n, release: r, dist: s, maxValueLength: o = 250 } = t;
  "environment" in e || (e.environment = "environment" in t ? n : MP), e.release === void 0 && r !== void 0 && (e.release = r), e.dist === void 0 && s !== void 0 && (e.dist = s), e.message && (e.message = k8(e.message, o));
  const c = e.exception && e.exception.values && e.exception.values[0];
  c && c.value && (c.value = k8(c.value, o));
  const u = e.request;
  u && u.url && (u.url = k8(u.url, o));
}
function aee(e, t) {
  const n = KJ(t);
  try {
    e.exception.values.forEach((r) => {
      r.stacktrace.frames.forEach((s) => {
        s.filename && (s.debug_id = n[s.filename]);
      });
    });
  } catch {
  }
}
function see(e) {
  const t = {};
  try {
    e.exception.values.forEach((r) => {
      r.stacktrace.frames.forEach((s) => {
        s.debug_id && (s.abs_path ? t[s.abs_path] = s.debug_id : s.filename && (t[s.filename] = s.debug_id), delete s.debug_id);
      });
    });
  } catch {
  }
  if (Object.keys(t).length === 0)
    return;
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const n = e.debug_meta.images;
  Object.entries(t).forEach(([r, s]) => {
    n.push({
      type: "sourcemap",
      code_file: r,
      debug_id: s
    });
  });
}
function iee(e, t) {
  t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...t]);
}
function oee(e, t, n) {
  if (!e)
    return null;
  const r = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((s) => ({
        ...s,
        ...s.data && {
          data: v2(s.data, t, n)
        }
      }))
    },
    ...e.user && {
      user: v2(e.user, t, n)
    },
    ...e.contexts && {
      contexts: v2(e.contexts, t, n)
    },
    ...e.extra && {
      extra: v2(e.extra, t, n)
    }
  };
  return e.contexts && e.contexts.trace && r.contexts && (r.contexts.trace = e.contexts.trace, e.contexts.trace.data && (r.contexts.trace.data = v2(e.contexts.trace.data, t, n))), e.spans && (r.spans = e.spans.map((s) => ({
    ...s,
    ...s.data && {
      data: v2(s.data, t, n)
    }
  }))), r;
}
function lee(e, t) {
  if (!t)
    return e;
  const n = e ? e.clone() : new V4();
  return n.update(t), n;
}
function cee(e, t) {
  return K2().captureException(e, void 0);
}
function wV(e, t) {
  return K2().captureEvent(e, t);
}
function uee(e, t) {
  iw().setContext(e, t);
}
function lF(e) {
  const t = _f(), n = iw(), r = K2(), { release: s, environment: o = MP } = t && t.getOptions() || {}, { userAgent: c } = Us.navigator || {}, u = KZ({
    release: s,
    environment: o,
    user: r.getUser() || n.getUser(),
    ...c && { userAgent: c },
    ...e
  }), m = n.getSession();
  return m && m.status === "ok" && U8(m, { status: "exited" }), CV(), n.setSession(u), r.setSession(u), u;
}
function CV() {
  const e = iw(), t = K2(), n = t.getSession() || e.getSession();
  n && XZ(n), NV(), e.setSession(), t.setSession();
}
function NV() {
  const e = iw(), t = K2(), n = _f(), r = t.getSession() || e.getSession();
  r && n && n.captureSession(r);
}
function cF(e = !1) {
  if (e) {
    CV();
    return;
  }
  NV();
}
const dee = "7";
function fee(e) {
  const t = e.protocol ? `${e.protocol}:` : "", n = e.port ? `:${e.port}` : "";
  return `${t}//${e.host}${n}${e.path ? `/${e.path}` : ""}/api/`;
}
function mee(e) {
  return `${fee(e)}${e.projectId}/envelope/`;
}
function hee(e, t) {
  return GZ({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: e.publicKey,
    sentry_version: dee,
    ...t && { sentry_client: `${t.name}/${t.version}` }
  });
}
function pee(e, t, n) {
  return t || `${mee(e)}?${hee(e, n)}`;
}
const uF = [];
function gee(e) {
  const t = {};
  return e.forEach((n) => {
    const { name: r } = n, s = t[r];
    s && !s.isDefaultInstance && n.isDefaultInstance || (t[r] = n);
  }), Object.values(t);
}
function yee(e) {
  const t = e.defaultIntegrations || [], n = e.integrations;
  t.forEach((c) => {
    c.isDefaultInstance = !0;
  });
  let r;
  if (Array.isArray(n))
    r = [...t, ...n];
  else if (typeof n == "function") {
    const c = n(t);
    r = Array.isArray(c) ? c : [c];
  } else
    r = t;
  const s = gee(r), o = s.findIndex((c) => c.name === "Debug");
  if (o > -1) {
    const [c] = s.splice(o, 1);
    s.push(c);
  }
  return s;
}
function vee(e, t) {
  const n = {};
  return t.forEach((r) => {
    r && jV(e, r, n);
  }), n;
}
function dF(e, t) {
  for (const n of t)
    n && n.afterAllSetup && n.afterAllSetup(e);
}
function jV(e, t, n) {
  if (n[t.name]) {
    Pi && qr.log(`Integration skipped because it was already installed: ${t.name}`);
    return;
  }
  if (n[t.name] = t, uF.indexOf(t.name) === -1 && typeof t.setupOnce == "function" && (t.setupOnce(), uF.push(t.name)), t.setup && typeof t.setup == "function" && t.setup(e), typeof t.preprocessEvent == "function") {
    const r = t.preprocessEvent.bind(t);
    e.on("preprocessEvent", (s, o) => r(s, o, e));
  }
  if (typeof t.processEvent == "function") {
    const r = t.processEvent.bind(t), s = Object.assign((o, c) => r(o, c, e), {
      id: t.name
    });
    e.addEventProcessor(s);
  }
  Pi && qr.log(`Integration installed: ${t.name}`);
}
function xee(e, t, n) {
  const r = [
    { type: "client_report" },
    {
      timestamp: H3(),
      discarded_events: e
    }
  ];
  return V3(t ? { dsn: t } : {}, [r]);
}
class ey extends Error {
  /** Display name of this error instance. */
  constructor(t, n = "warn") {
    super(t), this.message = t, this.name = new.target.prototype.constructor.name, Object.setPrototypeOf(this, new.target.prototype), this.logLevel = n;
  }
}
const fF = "Not capturing exception because it's already been captured.";
class bee {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(t) {
    if (this._options = t, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], t.dsn ? this._dsn = OJ(t.dsn) : Pi && qr.warn("No DSN provided, client will not send events."), this._dsn) {
      const n = pee(
        this._dsn,
        t.tunnel,
        t._metadata ? t._metadata.sdk : void 0
      );
      this._transport = t.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...t.transportOptions,
        url: n
      });
    }
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  captureException(t, n, r) {
    const s = w1();
    if (XI(t))
      return Pi && qr.log(fF), s;
    const o = {
      event_id: s,
      ...n
    };
    return this._process(
      this.eventFromException(t, o).then(
        (c) => this._captureEvent(c, o, r)
      )
    ), o.event_id;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, r, s) {
    const o = {
      event_id: w1(),
      ...r
    }, c = NP(t) ? t : String(t), u = jP(t) ? this.eventFromMessage(c, n, o) : this.eventFromException(t, o);
    return this._process(u.then((m) => this._captureEvent(m, o, s))), o.event_id;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n, r) {
    const s = w1();
    if (n && n.originalException && XI(n.originalException))
      return Pi && qr.log(fF), s;
    const o = {
      event_id: s,
      ...n
    }, u = (t.sdkProcessingMetadata || {}).capturedSpanScope;
    return this._process(this._captureEvent(t, o, u || r)), o.event_id;
  }
  /**
   * @inheritDoc
   */
  captureSession(t) {
    typeof t.release != "string" ? Pi && qr.warn("Discarded session because of missing or non-string release") : (this.sendSession(t), U8(t, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(t) {
    const n = this._transport;
    return n ? (this.emit("flush"), this._isClientDoneProcessing(t).then((r) => n.flush(t).then((s) => r && s))) : H4(!0);
  }
  /**
   * @inheritDoc
   */
  close(t) {
    return this.flush(t).then((n) => (this.getOptions().enabled = !1, this.emit("close"), n));
  }
  /** Get all installed event processors. */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /** @inheritDoc */
  addEventProcessor(t) {
    this._eventProcessors.push(t);
  }
  /** @inheritdoc */
  init() {
    (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name: t }) => t.startsWith("Spotlight"))) && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(t) {
    return this._integrations[t];
  }
  /**
   * @inheritDoc
   */
  addIntegration(t) {
    const n = this._integrations[t.name];
    jV(this, t, this._integrations), n || dF(this, [t]);
  }
  /**
   * @inheritDoc
   */
  sendEvent(t, n = {}) {
    this.emit("beforeSendEvent", t, n);
    let r = qJ(t, this._dsn, this._options._metadata, this._options.tunnel);
    for (const o of n.attachments || [])
      r = zJ(r, VJ(o));
    const s = this.sendEnvelope(r);
    s && s.then((o) => this.emit("afterSendEvent", t, o), null);
  }
  /**
   * @inheritDoc
   */
  sendSession(t) {
    const n = YJ(t, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(t, n, r) {
    if (this._options.sendClientReports) {
      const s = typeof r == "number" ? r : 1, o = `${t}:${n}`;
      Pi && qr.log(`Recording outcome: "${o}"${s > 1 ? ` (${s} times)` : ""}`), this._outcomes[o] = (this._outcomes[o] || 0) + s;
    }
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */
  /** @inheritdoc */
  /** @inheritdoc */
  on(t, n) {
    const r = this._hooks[t] = this._hooks[t] || [];
    return r.push(n), () => {
      const s = r.indexOf(n);
      s > -1 && r.splice(s, 1);
    };
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(t, ...n) {
    const r = this._hooks[t];
    r && r.forEach((s) => s(...n));
  }
  /**
   * @inheritdoc
   */
  sendEnvelope(t) {
    return this.emit("beforeEnvelope", t), this._isEnabled() && this._transport ? this._transport.send(t).then(null, (n) => (Pi && qr.error("Error while sending envelope:", n), n)) : (Pi && qr.error("Transport disabled"), H4({}));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: t } = this._options;
    this._integrations = vee(this, t), dF(this, t);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(t, n) {
    let r = !1, s = !1;
    const o = n.exception && n.exception.values;
    if (o) {
      s = !0;
      for (const m of o) {
        const y = m.mechanism;
        if (y && y.handled === !1) {
          r = !0;
          break;
        }
      }
    }
    const c = t.status === "ok";
    (c && t.errors === 0 || c && r) && (U8(t, {
      ...r && { status: "crashed" },
      errors: t.errors || Number(s || r)
    }), this.captureSession(t));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(t) {
    return new g1((n) => {
      let r = 0;
      const s = 1, o = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(o), n(!0)) : (r += s, t && r >= t && (clearInterval(o), n(!1)));
      }, s);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(t, n, r, s = iw()) {
    const o = this.getOptions(), c = Object.keys(this._integrations);
    return !n.integrations && c.length > 0 && (n.integrations = c), this.emit("preprocessEvent", t, n), t.type || s.setLastEventId(t.event_id || n.event_id), nee(o, t, n, r, this, s).then((u) => {
      if (u === null)
        return u;
      const m = {
        ...s.getPropagationContext(),
        ...r ? r.getPropagationContext() : void 0
      };
      if (!(u.contexts && u.contexts.trace) && m) {
        const { traceId: b, spanId: w, parentSpanId: k, dsc: j } = m;
        u.contexts = {
          trace: x1({
            trace_id: b,
            span_id: w,
            parent_span_id: k
          }),
          ...u.contexts
        };
        const E = j || vV(b, this);
        u.sdkProcessingMetadata = {
          dynamicSamplingContext: E,
          ...u.sdkProcessingMetadata
        };
      }
      return u;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(t, n = {}, r) {
    return this._processEvent(t, n, r).then(
      (s) => s.event_id,
      (s) => {
        if (Pi) {
          const o = s;
          o.logLevel === "log" ? qr.log(o.message) : qr.warn(o);
        }
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(t, n, r) {
    const s = this.getOptions(), { sampleRate: o } = s, c = kV(t), u = EV(t), m = t.type || "error", y = `before send for type \`${m}\``, b = typeof o > "u" ? void 0 : TJ(o);
    if (u && typeof b == "number" && Math.random() > b)
      return this.recordDroppedEvent("sample_rate", "error", t), p9(
        new ey(
          `Discarding event because it's not included in the random sample (sampling rate = ${o})`,
          "log"
        )
      );
    const w = m === "replay_event" ? "replay" : m, j = (t.sdkProcessingMetadata || {}).capturedSpanIsolationScope;
    return this._prepareEvent(t, n, r, j).then((E) => {
      if (E === null)
        throw this.recordDroppedEvent("event_processor", w, t), new ey("An event processor returned `null`, will not send event.", "log");
      if (n.data && n.data.__sentry__ === !0)
        return E;
      const D = wee(this, s, E, n);
      return See(D, y);
    }).then((E) => {
      if (E === null) {
        if (this.recordDroppedEvent("before_send", w, t), c) {
          const I = 1 + (t.spans || []).length;
          this.recordDroppedEvent("before_send", "span", I);
        }
        throw new ey(`${y} returned \`null\`, will not send event.`, "log");
      }
      const T = r && r.getSession();
      if (!c && T && this._updateSessionFromEvent(T, E), c) {
        const L = E.sdkProcessingMetadata && E.sdkProcessingMetadata.spanCountBeforeProcessing || 0, I = E.spans ? E.spans.length : 0, R = L - I;
        R > 0 && this.recordDroppedEvent("before_send", "span", R);
      }
      const D = E.transaction_info;
      if (c && D && E.transaction !== t.transaction) {
        const L = "custom";
        E.transaction_info = {
          ...D,
          source: L
        };
      }
      return this.sendEvent(E, n), E;
    }).then(null, (E) => {
      throw E instanceof ey ? E : (this.captureException(E, {
        data: {
          __sentry__: !0
        },
        originalException: E
      }), new ey(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${E}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(t) {
    this._numProcessing++, t.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.entries(t).map(([n, r]) => {
      const [s, o] = n.split(":");
      return {
        reason: s,
        category: o,
        quantity: r
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    Pi && qr.log("Flushing outcomes...");
    const t = this._clearOutcomes();
    if (t.length === 0) {
      Pi && qr.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      Pi && qr.log("No dsn provided, will not send outcomes");
      return;
    }
    Pi && qr.log("Sending outcomes:", t);
    const n = xee(t, this._options.tunnel && dE(this._dsn));
    this.sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}
function See(e, t) {
  const n = `${t} must return \`null\` or a valid event.`;
  if (lE(e))
    return e.then(
      (r) => {
        if (!F8(r) && r !== null)
          throw new ey(n);
        return r;
      },
      (r) => {
        throw new ey(`${t} rejected with ${r}`);
      }
    );
  if (!F8(e) && e !== null)
    throw new ey(n);
  return e;
}
function wee(e, t, n, r) {
  const { beforeSend: s, beforeSendTransaction: o, beforeSendSpan: c } = t;
  if (EV(n) && s)
    return s(n, r);
  if (kV(n)) {
    if (n.spans && c) {
      const u = [];
      for (const m of n.spans) {
        const y = c(m);
        y ? u.push(y) : e.recordDroppedEvent("before_send", "span");
      }
      n.spans = u;
    }
    if (o) {
      if (n.spans) {
        const u = n.spans.length;
        n.sdkProcessingMetadata = {
          ...n.sdkProcessingMetadata,
          spanCountBeforeProcessing: u
        };
      }
      return o(n, r);
    }
  }
  return n;
}
function EV(e) {
  return e.type === void 0;
}
function kV(e) {
  return e.type === "transaction";
}
function Cee(e, t) {
  t.debug === !0 && (Pi ? qr.enable() : B3(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), K2().update(t.initialScope);
  const r = new e(t);
  return Nee(r), r.init(), r;
}
function Nee(e) {
  K2().setClient(e);
}
function jee(e) {
  const t = [];
  function n() {
    return e === void 0 || t.length < e;
  }
  function r(c) {
    return t.splice(t.indexOf(c), 1)[0] || Promise.resolve(void 0);
  }
  function s(c) {
    if (!n())
      return p9(new ey("Not adding Promise because buffer limit was reached."));
    const u = c();
    return t.indexOf(u) === -1 && t.push(u), u.then(() => r(u)).then(
      null,
      () => r(u).then(null, () => {
      })
    ), u;
  }
  function o(c) {
    return new g1((u, m) => {
      let y = t.length;
      if (!y)
        return u(!0);
      const b = setTimeout(() => {
        c && c > 0 && u(!1);
      }, c);
      t.forEach((w) => {
        H4(w).then(() => {
          --y || (clearTimeout(b), u(!0));
        }, m);
      });
    });
  }
  return {
    $: t,
    add: s,
    drain: o
  };
}
const Eee = 60 * 1e3;
function kee(e, t = Date.now()) {
  const n = parseInt(`${e}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const r = Date.parse(`${e}`);
  return isNaN(r) ? Eee : r - t;
}
function _ee(e, t) {
  return e[t] || e.all || 0;
}
function Tee(e, t, n = Date.now()) {
  return _ee(e, t) > n;
}
function Mee(e, { statusCode: t, headers: n }, r = Date.now()) {
  const s = {
    ...e
  }, o = n && n["x-sentry-rate-limits"], c = n && n["retry-after"];
  if (o)
    for (const u of o.trim().split(",")) {
      const [m, y, , , b] = u.split(":", 5), w = parseInt(m, 10), k = (isNaN(w) ? 60 : w) * 1e3;
      if (!y)
        s.all = r + k;
      else
        for (const j of y.split(";"))
          j === "metric_bucket" ? (!b || b.split(";").includes("custom")) && (s[j] = r + k) : s[j] = r + k;
    }
  else c ? s.all = r + kee(c, r) : t === 429 && (s.all = r + 60 * 1e3);
  return s;
}
const Ree = 64;
function Dee(e, t, n = jee(
  e.bufferSize || Ree
)) {
  let r = {};
  const s = (c) => n.drain(c);
  function o(c) {
    const u = [];
    if (aF(c, (w, k) => {
      const j = sF(k);
      if (Tee(r, j)) {
        const E = mF(w, k);
        e.recordDroppedEvent("ratelimit_backoff", j, E);
      } else
        u.push(w);
    }), u.length === 0)
      return H4({});
    const m = V3(c[0], u), y = (w) => {
      aF(m, (k, j) => {
        const E = mF(k, j);
        e.recordDroppedEvent(w, sF(j), E);
      });
    }, b = () => t({ body: BJ(m) }).then(
      (w) => (w.statusCode !== void 0 && (w.statusCode < 200 || w.statusCode >= 300) && Pi && qr.warn(`Sentry responded with status code ${w.statusCode} to sent event.`), r = Mee(r, w), w),
      (w) => {
        throw y("network_error"), w;
      }
    );
    return n.add(b).then(
      (w) => w,
      (w) => {
        if (w instanceof ey)
          return Pi && qr.error("Skipped sending event because buffer is full."), y("queue_overflow"), H4({});
        throw w;
      }
    );
  }
  return {
    send: o,
    flush: s
  };
}
function mF(e, t) {
  if (!(t !== "event" && t !== "transaction"))
    return Array.isArray(e) ? e[1] : void 0;
}
function _V(e, t, n = [t], r = "npm") {
  const s = e._metadata || {};
  s.sdk || (s.sdk = {
    name: `sentry.javascript.${t}`,
    packages: n.map((o) => ({
      name: `${r}:@sentry/${o}`,
      version: P4
    })),
    version: P4
  }), e._metadata = s;
}
const Pee = 100;
function $4(e, t) {
  const n = _f(), r = iw();
  if (!n) return;
  const { beforeBreadcrumb: s = null, maxBreadcrumbs: o = Pee } = n.getOptions();
  if (o <= 0) return;
  const u = { timestamp: H3(), ...e }, m = s ? B3(() => s(u, t)) : u;
  m !== null && (n.emit && n.emit("beforeAddBreadcrumb", m, t), r.addBreadcrumb(m, o));
}
let hF;
const Oee = "FunctionToString", pF = /* @__PURE__ */ new WeakMap(), Aee = () => ({
  name: Oee,
  setupOnce() {
    hF = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...e) {
        const t = kP(this), n = pF.has(_f()) && t !== void 0 ? t : this;
        return hF.apply(n, e);
      };
    } catch {
    }
  },
  setup(e) {
    pF.set(e, !0);
  }
}), Lee = Aee, Iee = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  "undefined is not an object (evaluating 'a.L')",
  // Random error that happens but not actionable or noticeable to end-users.
  `can't redefine non-configurable property "solana"`,
  // Probably a browser extension or custom browser (Brave) throwing this error
  "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
  // Error thrown by GTM, seemingly not affecting end-users
  "Can't find variable: _AutofillCallbackHandler"
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
], Fee = "InboundFilters", Uee = (e = {}) => ({
  name: Fee,
  processEvent(t, n, r) {
    const s = r.getOptions(), o = Bee(e, s);
    return Hee(t, o) ? null : t;
  }
}), zee = Uee;
function Bee(e = {}, t = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...t.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...t.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...t.ignoreErrors || [],
      ...e.disableErrorDefaults ? [] : Iee
    ],
    ignoreTransactions: [...e.ignoreTransactions || [], ...t.ignoreTransactions || []],
    ignoreInternal: e.ignoreInternal !== void 0 ? e.ignoreInternal : !0
  };
}
function Hee(e, t) {
  return t.ignoreInternal && qee(e) ? (Pi && qr.warn(`Event dropped due to being internal Sentry Error.
Event: ${y2(e)}`), !0) : Vee(e, t.ignoreErrors) ? (Pi && qr.warn(
    `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${y2(e)}`
  ), !0) : Xee(e) ? (Pi && qr.warn(
    `Event dropped due to not having an error message, error type or stacktrace.
Event: ${y2(
      e
    )}`
  ), !0) : $ee(e, t.ignoreTransactions) ? (Pi && qr.warn(
    `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${y2(e)}`
  ), !0) : Gee(e, t.denyUrls) ? (Pi && qr.warn(
    `Event dropped due to being matched by \`denyUrls\` option.
Event: ${y2(
      e
    )}.
Url: ${y9(e)}`
  ), !0) : Wee(e, t.allowUrls) ? !1 : (Pi && qr.warn(
    `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${y2(
      e
    )}.
Url: ${y9(e)}`
  ), !0);
}
function Vee(e, t) {
  return e.type || !t || !t.length ? !1 : Yee(e).some((n) => cE(n, t));
}
function $ee(e, t) {
  if (e.type !== "transaction" || !t || !t.length)
    return !1;
  const n = e.transaction;
  return n ? cE(n, t) : !1;
}
function Gee(e, t) {
  if (!t || !t.length)
    return !1;
  const n = y9(e);
  return n ? cE(n, t) : !1;
}
function Wee(e, t) {
  if (!t || !t.length)
    return !0;
  const n = y9(e);
  return n ? cE(n, t) : !0;
}
function Yee(e) {
  const t = [];
  e.message && t.push(e.message);
  let n;
  try {
    n = e.exception.values[e.exception.values.length - 1];
  } catch {
  }
  return n && n.value && (t.push(n.value), n.type && t.push(`${n.type}: ${n.value}`)), t;
}
function qee(e) {
  try {
    return e.exception.values[0].type === "SentryError";
  } catch {
  }
  return !1;
}
function Kee(e = []) {
  for (let t = e.length - 1; t >= 0; t--) {
    const n = e[t];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function y9(e) {
  try {
    let t;
    try {
      t = e.exception.values[0].stacktrace.frames;
    } catch {
    }
    return t ? Kee(t) : null;
  } catch {
    return Pi && qr.error(`Cannot extract url for event ${y2(e)}`), null;
  }
}
function Xee(e) {
  return e.type || !e.exception || !e.exception.values || e.exception.values.length === 0 ? !1 : (
    // No top-level message
    !e.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !e.exception.values.some((t) => t.stacktrace || t.type && t.type !== "Error" || t.value)
  );
}
function Qee(e, t, n = 250, r, s, o, c) {
  if (!o.exception || !o.exception.values || !c || !z4(c.originalException, Error))
    return;
  const u = o.exception.values.length > 0 ? o.exception.values[o.exception.values.length - 1] : void 0;
  u && (o.exception.values = Zee(
    rD(
      e,
      t,
      s,
      c.originalException,
      r,
      o.exception.values,
      u,
      0
    ),
    n
  ));
}
function rD(e, t, n, r, s, o, c, u) {
  if (o.length >= n + 1)
    return o;
  let m = [...o];
  if (z4(r[s], Error)) {
    gF(c, u);
    const y = e(t, r[s]), b = m.length;
    yF(y, s, b, u), m = rD(
      e,
      t,
      n,
      r[s],
      s,
      [y, ...m],
      y,
      b
    );
  }
  return Array.isArray(r.errors) && r.errors.forEach((y, b) => {
    if (z4(y, Error)) {
      gF(c, u);
      const w = e(t, y), k = m.length;
      yF(w, `errors[${b}]`, k, u), m = rD(
        e,
        t,
        n,
        y,
        s,
        [w, ...m],
        w,
        k
      );
    }
  }), m;
}
function gF(e, t) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    ...e.type === "AggregateError" && { is_exception_group: !0 },
    exception_id: t
  };
}
function yF(e, t, n, r) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    type: "chained",
    source: t,
    exception_id: n,
    parent_id: r
  };
}
function Zee(e, t) {
  return e.map((n) => (n.value && (n.value = k8(n.value, t)), n));
}
function yM(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const n = t[6] || "", r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    search: n,
    hash: r,
    relative: t[5] + n + r
    // everything minus origin
  };
}
function Jee(e) {
  const t = "console";
  i5(t, e), o5(t, ete);
}
function ete() {
  "console" in Us && XR.forEach(function(e) {
    e in Us.console && hp(Us.console, e, function(t) {
      return h9[e] = t, function(...n) {
        qg("console", { args: n, level: e });
        const s = h9[e];
        s && s.apply(Us.console, n);
      };
    });
  });
}
const tte = ["fatal", "error", "warning", "log", "info", "debug"];
function nte(e) {
  return e === "warn" ? "warning" : tte.includes(e) ? e : "log";
}
const rte = "Dedupe", ate = () => {
  let e;
  return {
    name: rte,
    processEvent(t) {
      if (t.type)
        return t;
      try {
        if (ite(t, e))
          return Pi && qr.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return e = t;
    }
  };
}, ste = ate;
function ite(e, t) {
  return t ? !!(ote(e, t) || lte(e, t)) : !1;
}
function ote(e, t) {
  const n = e.message, r = t.message;
  return !(!n && !r || n && !r || !n && r || n !== r || !MV(e, t) || !TV(e, t));
}
function lte(e, t) {
  const n = vF(t), r = vF(e);
  return !(!n || !r || n.type !== r.type || n.value !== r.value || !MV(e, t) || !TV(e, t));
}
function TV(e, t) {
  let n = $I(e), r = $I(t);
  if (!n && !r)
    return !0;
  if (n && !r || !n && r || (n = n, r = r, r.length !== n.length))
    return !1;
  for (let s = 0; s < r.length; s++) {
    const o = r[s], c = n[s];
    if (o.filename !== c.filename || o.lineno !== c.lineno || o.colno !== c.colno || o.function !== c.function)
      return !1;
  }
  return !0;
}
function MV(e, t) {
  let n = e.fingerprint, r = t.fingerprint;
  if (!n && !r)
    return !0;
  if (n && !r || !n && r)
    return !1;
  n = n, r = r;
  try {
    return n.join("") === r.join("");
  } catch {
    return !1;
  }
}
function vF(e) {
  return e.exception && e.exception.values && e.exception.values[0];
}
function RV(e) {
  if (e !== void 0)
    return e >= 400 && e < 500 ? "warning" : e >= 500 ? "error" : void 0;
}
const aD = Us;
function DV() {
  if (!("fetch" in aD))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function sD(e) {
  return e && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function cte() {
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!DV())
    return !1;
  if (sD(aD.fetch))
    return !0;
  let e = !1;
  const t = aD.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = sD(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      s5 && qr.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
function ute(e, t) {
  const n = "fetch";
  i5(n, e), o5(n, () => dte(void 0, t));
}
function dte(e, t = !1) {
  t && !cte() || hp(Us, "fetch", function(n) {
    return function(...r) {
      const { method: s, url: o } = fte(r), c = {
        args: r,
        fetchData: {
          method: s,
          url: o
        },
        startTimestamp: Iv() * 1e3
      };
      qg("fetch", {
        ...c
      });
      const u = new Error().stack;
      return n.apply(Us, r).then(
        async (m) => (qg("fetch", {
          ...c,
          endTimestamp: Iv() * 1e3,
          response: m
        }), m),
        (m) => {
          throw qg("fetch", {
            ...c,
            endTimestamp: Iv() * 1e3,
            error: m
          }), CP(m) && m.stack === void 0 && (m.stack = u, B4(m, "framesToPop", 1)), m;
        }
      );
    };
  });
}
function iD(e, t) {
  return !!e && typeof e == "object" && !!e[t];
}
function xF(e) {
  return typeof e == "string" ? e : e ? iD(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
function fte(e) {
  if (e.length === 0)
    return { method: "GET", url: "" };
  if (e.length === 2) {
    const [n, r] = e;
    return {
      url: xF(n),
      method: iD(r, "method") ? String(r.method).toUpperCase() : "GET"
    };
  }
  const t = e[0];
  return {
    url: xF(t),
    method: iD(t, "method") ? String(t.method).toUpperCase() : "GET"
  };
}
function mte() {
  return "npm";
}
const fj = Us;
function hte() {
  const e = fj.chrome, t = e && e.app && e.app.runtime, n = "history" in fj && !!fj.history.pushState && !!fj.history.replaceState;
  return !t && n;
}
const Oi = Us;
let oD = 0;
function PV() {
  return oD > 0;
}
function pte() {
  oD++, setTimeout(() => {
    oD--;
  });
}
function B8(e, t = {}, n) {
  if (typeof e != "function")
    return e;
  try {
    const s = e.__sentry_wrapped__;
    if (s)
      return typeof s == "function" ? s : e;
    if (kP(e))
      return e;
  } catch {
    return e;
  }
  const r = function() {
    const s = Array.prototype.slice.call(arguments);
    try {
      const o = s.map((c) => B8(c, t));
      return e.apply(this, o);
    } catch (o) {
      throw pte(), iJ((c) => {
        c.addEventProcessor((u) => (t.mechanism && (ZR(u, void 0), v3(u, t.mechanism)), u.extra = {
          ...u.extra,
          arguments: s
        }, u)), cee(o);
      }), o;
    }
  };
  try {
    for (const s in e)
      Object.prototype.hasOwnProperty.call(e, s) && (r[s] = e[s]);
  } catch {
  }
  mV(r, e), B4(e, "__sentry_wrapped__", r);
  try {
    Object.getOwnPropertyDescriptor(r, "name").configurable && Object.defineProperty(r, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return r;
}
const $3 = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
function RP(e, t) {
  const n = DP(e, t), r = {
    type: bte(t),
    value: Ste(t)
  };
  return n.length && (r.stacktrace = { frames: n }), r.type === void 0 && r.value === "" && (r.value = "Unrecoverable error caught"), r;
}
function gte(e, t, n, r) {
  const s = _f(), o = s && s.getOptions().normalizeDepth, c = Ete(t), u = {
    __serialized__: bV(t, o)
  };
  if (c)
    return {
      exception: {
        values: [RP(e, c)]
      },
      extra: u
    };
  const m = {
    exception: {
      values: [
        {
          type: oE(t) ? t.constructor.name : r ? "UnhandledRejection" : "Error",
          value: Nte(t, { isUnhandledRejection: r })
        }
      ]
    },
    extra: u
  };
  if (n) {
    const y = DP(e, n);
    y.length && (m.exception.values[0].stacktrace = { frames: y });
  }
  return m;
}
function vM(e, t) {
  return {
    exception: {
      values: [RP(e, t)]
    }
  };
}
function DP(e, t) {
  const n = t.stacktrace || t.stack || "", r = vte(t), s = xte(t);
  try {
    return e(n, r, s);
  } catch {
  }
  return [];
}
const yte = /Minified React error #\d+;/i;
function vte(e) {
  return e && yte.test(e.message) ? 1 : 0;
}
function xte(e) {
  return typeof e.framesToPop == "number" ? e.framesToPop : 0;
}
function OV(e) {
  return typeof WebAssembly < "u" && typeof WebAssembly.Exception < "u" ? e instanceof WebAssembly.Exception : !1;
}
function bte(e) {
  const t = e && e.name;
  return !t && OV(e) ? e.message && Array.isArray(e.message) && e.message.length == 2 ? e.message[0] : "WebAssembly.Exception" : t;
}
function Ste(e) {
  const t = e && e.message;
  return t ? t.error && typeof t.error.message == "string" ? t.error.message : OV(e) && Array.isArray(e.message) && e.message.length == 2 ? e.message[1] : t : "No error message";
}
function wte(e, t, n, r) {
  const s = n && n.syntheticException || void 0, o = PP(e, t, s, r);
  return v3(o), o.level = "error", n && n.event_id && (o.event_id = n.event_id), H4(o);
}
function Cte(e, t, n = "info", r, s) {
  const o = r && r.syntheticException || void 0, c = lD(e, t, o, s);
  return c.level = n, r && r.event_id && (c.event_id = r.event_id), H4(c);
}
function PP(e, t, n, r, s) {
  let o;
  if (uV(t) && t.error)
    return vM(e, t.error);
  if (WI(t) || LZ(t)) {
    const c = t;
    if ("stack" in t)
      o = vM(e, t);
    else {
      const u = c.name || (WI(c) ? "DOMError" : "DOMException"), m = c.message ? `${u}: ${c.message}` : u;
      o = lD(e, m, n, r), ZR(o, m);
    }
    return "code" in c && (o.tags = { ...o.tags, "DOMException.code": `${c.code}` }), o;
  }
  return CP(t) ? vM(e, t) : F8(t) || oE(t) ? (o = gte(e, t, n, s), v3(o, {
    synthetic: !0
  }), o) : (o = lD(e, t, n, r), ZR(o, `${t}`), v3(o, {
    synthetic: !0
  }), o);
}
function lD(e, t, n, r) {
  const s = {};
  if (r && n) {
    const o = DP(e, n);
    o.length && (s.exception = {
      values: [{ value: t, stacktrace: { frames: o } }]
    });
  }
  if (NP(t)) {
    const { __sentry_template_string__: o, __sentry_template_values__: c } = t;
    return s.logentry = {
      message: o,
      params: c
    }, s;
  }
  return s.message = t, s;
}
function Nte(e, { isUnhandledRejection: t }) {
  const n = WZ(e), r = t ? "promise rejection" : "exception";
  return uV(e) ? `Event \`ErrorEvent\` captured as ${r} with message \`${e.message}\`` : oE(e) ? `Event \`${jte(e)}\` (type=${e.type}) captured as ${r}` : `Object captured as ${r} with keys: ${n}`;
}
function jte(e) {
  try {
    const t = Object.getPrototypeOf(e);
    return t ? t.constructor.name : void 0;
  } catch {
  }
}
function Ete(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      const n = e[t];
      if (n instanceof Error)
        return n;
    }
}
function kte(e, {
  metadata: t,
  tunnel: n,
  dsn: r
}) {
  const s = {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && t.sdk && {
      sdk: {
        name: t.sdk.name,
        version: t.sdk.version
      }
    },
    ...!!n && !!r && { dsn: dE(r) }
  }, o = _te(e);
  return V3(s, [o]);
}
function _te(e) {
  return [{
    type: "user_report"
  }, e];
}
class Tte extends bee {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(t) {
    const n = {
      // We default this to true, as it is the safer scenario
      parentSpanIsAlwaysRootSpan: !0,
      ...t
    }, r = Oi.SENTRY_SDK_SOURCE || mte();
    _V(n, "browser", ["browser"], r), super(n), n.sendClientReports && Oi.document && Oi.document.addEventListener("visibilitychange", () => {
      Oi.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  /**
   * @inheritDoc
   */
  eventFromException(t, n) {
    return wte(this._options.stackParser, t, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(t, n = "info", r) {
    return Cte(this._options.stackParser, t, n, r, this._options.attachStacktrace);
  }
  /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */
  captureUserFeedback(t) {
    if (!this._isEnabled()) {
      $3 && qr.warn("SDK not enabled, will not capture user feedback.");
      return;
    }
    const n = kte(t, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    });
    this.sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(t, n, r) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, n, r);
  }
}
const Mte = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, wf = Us, Rte = 1e3;
let bF, cD, uD;
function Dte(e) {
  const t = "dom";
  i5(t, e), o5(t, Pte);
}
function Pte() {
  if (!wf.document)
    return;
  const e = qg.bind(null, "dom"), t = SF(e, !0);
  wf.document.addEventListener("click", t, !1), wf.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((n) => {
    const r = wf[n] && wf[n].prototype;
    !r || !r.hasOwnProperty || !r.hasOwnProperty("addEventListener") || (hp(r, "addEventListener", function(s) {
      return function(o, c, u) {
        if (o === "click" || o == "keypress")
          try {
            const m = this, y = m.__sentry_instrumentation_handlers__ = m.__sentry_instrumentation_handlers__ || {}, b = y[o] = y[o] || { refCount: 0 };
            if (!b.handler) {
              const w = SF(e);
              b.handler = w, s.call(this, o, w, u);
            }
            b.refCount++;
          } catch {
          }
        return s.call(this, o, c, u);
      };
    }), hp(
      r,
      "removeEventListener",
      function(s) {
        return function(o, c, u) {
          if (o === "click" || o == "keypress")
            try {
              const m = this, y = m.__sentry_instrumentation_handlers__ || {}, b = y[o];
              b && (b.refCount--, b.refCount <= 0 && (s.call(this, o, b.handler, u), b.handler = void 0, delete y[o]), Object.keys(y).length === 0 && delete m.__sentry_instrumentation_handlers__);
            } catch {
            }
          return s.call(this, o, c, u);
        };
      }
    ));
  });
}
function Ote(e) {
  if (e.type !== cD)
    return !1;
  try {
    if (!e.target || e.target._sentryId !== uD)
      return !1;
  } catch {
  }
  return !0;
}
function Ate(e, t) {
  return e !== "keypress" ? !1 : !t || !t.tagName ? !0 : !(t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable);
}
function SF(e, t = !1) {
  return (n) => {
    if (!n || n._sentryCaptured)
      return;
    const r = Lte(n);
    if (Ate(n.type, r))
      return;
    B4(n, "_sentryCaptured", !0), r && !r._sentryId && B4(r, "_sentryId", w1());
    const s = n.type === "keypress" ? "input" : n.type;
    Ote(n) || (e({ event: n, name: s, global: t }), cD = n.type, uD = r ? r._sentryId : void 0), clearTimeout(bF), bF = wf.setTimeout(() => {
      uD = void 0, cD = void 0;
    }, Rte);
  };
}
function Lte(e) {
  try {
    return e.target;
  } catch {
    return null;
  }
}
let mj;
function AV(e) {
  const t = "history";
  i5(t, e), o5(t, Ite);
}
function Ite() {
  if (!hte())
    return;
  const e = wf.onpopstate;
  wf.onpopstate = function(...n) {
    const r = wf.location.href, s = mj;
    if (mj = r, qg("history", { from: s, to: r }), e)
      try {
        return e.apply(this, n);
      } catch {
      }
  };
  function t(n) {
    return function(...r) {
      const s = r.length > 2 ? r[2] : void 0;
      if (s) {
        const o = mj, c = String(s);
        mj = c, qg("history", { from: o, to: c });
      }
      return n.apply(this, r);
    };
  }
  hp(wf.history, "pushState", t), hp(wf.history, "replaceState", t);
}
const Zj = {};
function Fte(e) {
  const t = Zj[e];
  if (t)
    return t;
  let n = wf[e];
  if (sD(n))
    return Zj[e] = n.bind(wf);
  const r = wf.document;
  if (r && typeof r.createElement == "function")
    try {
      const s = r.createElement("iframe");
      s.hidden = !0, r.head.appendChild(s);
      const o = s.contentWindow;
      o && o[e] && (n = o[e]), r.head.removeChild(s);
    } catch (s) {
      Mte && qr.warn(`Could not create sandbox iframe for ${e} check, bailing to window.${e}: `, s);
    }
  return n && (Zj[e] = n.bind(wf));
}
function wF(e) {
  Zj[e] = void 0;
}
const K7 = "__sentry_xhr_v3__";
function Ute(e) {
  const t = "xhr";
  i5(t, e), o5(t, zte);
}
function zte() {
  if (!wf.XMLHttpRequest)
    return;
  const e = XMLHttpRequest.prototype;
  e.open = new Proxy(e.open, {
    apply(t, n, r) {
      const s = Iv() * 1e3, o = Lv(r[0]) ? r[0].toUpperCase() : void 0, c = Bte(r[1]);
      if (!o || !c)
        return t.apply(n, r);
      n[K7] = {
        method: o,
        url: c,
        request_headers: {}
      }, o === "POST" && c.match(/sentry_key/) && (n.__sentry_own_request__ = !0);
      const u = () => {
        const m = n[K7];
        if (m && n.readyState === 4) {
          try {
            m.status_code = n.status;
          } catch {
          }
          const y = {
            endTimestamp: Iv() * 1e3,
            startTimestamp: s,
            xhr: n
          };
          qg("xhr", y);
        }
      };
      return "onreadystatechange" in n && typeof n.onreadystatechange == "function" ? n.onreadystatechange = new Proxy(n.onreadystatechange, {
        apply(m, y, b) {
          return u(), m.apply(y, b);
        }
      }) : n.addEventListener("readystatechange", u), n.setRequestHeader = new Proxy(n.setRequestHeader, {
        apply(m, y, b) {
          const [w, k] = b, j = y[K7];
          return j && Lv(w) && Lv(k) && (j.request_headers[w.toLowerCase()] = k), m.apply(y, b);
        }
      }), t.apply(n, r);
    }
  }), e.send = new Proxy(e.send, {
    apply(t, n, r) {
      const s = n[K7];
      if (!s)
        return t.apply(n, r);
      r[0] !== void 0 && (s.body = r[0]);
      const o = {
        startTimestamp: Iv() * 1e3,
        xhr: n
      };
      return qg("xhr", o), t.apply(n, r);
    }
  });
}
function Bte(e) {
  if (Lv(e))
    return e;
  try {
    return e.toString();
  } catch {
  }
}
function Hte(e, t = Fte("fetch")) {
  let n = 0, r = 0;
  function s(o) {
    const c = o.body.length;
    n += c, r++;
    const u = {
      body: o.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && r < 15,
      ...e.fetchOptions
    };
    if (!t)
      return wF("fetch"), p9("No fetch implementation available");
    try {
      return t(e.url, u).then((m) => (n -= c, r--, {
        statusCode: m.status,
        headers: {
          "x-sentry-rate-limits": m.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": m.headers.get("Retry-After")
        }
      }));
    } catch (m) {
      return wF("fetch"), n -= c, r--, p9(m);
    }
  }
  return Dee(e, s);
}
const Vte = 30, $te = 50;
function dD(e, t, n, r) {
  const s = {
    filename: e,
    function: t === "<anonymous>" ? U4 : t,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (s.lineno = n), r !== void 0 && (s.colno = r), s;
}
const Gte = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, Wte = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, Yte = /\((\S*)(?::(\d+))(?::(\d+))\)/, qte = (e) => {
  const t = Gte.exec(e);
  if (t) {
    const [, r, s, o] = t;
    return dD(r, U4, +s, +o);
  }
  const n = Wte.exec(e);
  if (n) {
    if (n[2] && n[2].indexOf("eval") === 0) {
      const c = Yte.exec(n[2]);
      c && (n[2] = c[1], n[3] = c[2], n[4] = c[3]);
    }
    const [s, o] = LV(n[1] || U4, n[2]);
    return dD(o, s, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
  }
}, Kte = [Vte, qte], Xte = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, Qte = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, Zte = (e) => {
  const t = Xte.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const o = Qte.exec(t[3]);
      o && (t[1] = t[1] || "eval", t[3] = o[1], t[4] = o[2], t[5] = "");
    }
    let r = t[3], s = t[1] || U4;
    return [s, r] = LV(s, r), dD(r, s, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}, Jte = [$te, Zte], ene = [Kte, Jte], tne = lV(...ene), LV = (e, t) => {
  const n = e.indexOf("safari-extension") !== -1, r = e.indexOf("safari-web-extension") !== -1;
  return n || r ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : U4,
    n ? `safari-extension:${t}` : `safari-web-extension:${t}`
  ] : [e, t];
}, hj = 1024, nne = "Breadcrumbs", rne = (e = {}) => {
  const t = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...e
  };
  return {
    name: nne,
    setup(n) {
      t.console && Jee(one(n)), t.dom && Dte(ine(n, t.dom)), t.xhr && Ute(lne(n)), t.fetch && ute(cne(n)), t.history && AV(une(n)), t.sentry && n.on("beforeSendEvent", sne(n));
    }
  };
}, ane = rne;
function sne(e) {
  return function(n) {
    _f() === e && $4(
      {
        category: `sentry.${n.type === "transaction" ? "transaction" : "event"}`,
        event_id: n.event_id,
        level: n.level,
        message: y2(n)
      },
      {
        event: n
      }
    );
  };
}
function ine(e, t) {
  return function(r) {
    if (_f() !== e)
      return;
    let s, o, c = typeof t == "object" ? t.serializeAttribute : void 0, u = typeof t == "object" && typeof t.maxStringLength == "number" ? t.maxStringLength : void 0;
    u && u > hj && ($3 && qr.warn(
      `\`dom.maxStringLength\` cannot exceed ${hj}, but a value of ${u} was configured. Sentry will use ${hj} instead.`
    ), u = hj), typeof c == "string" && (c = [c]);
    try {
      const y = r.event, b = dne(y) ? y.target : y;
      s = fV(b, { keyAttrs: c, maxStringLength: u }), o = VZ(b);
    } catch {
      s = "<unknown>";
    }
    if (s.length === 0)
      return;
    const m = {
      category: `ui.${r.name}`,
      message: s
    };
    o && (m.data = { "ui.component_name": o }), $4(m, {
      event: r.event,
      name: r.name,
      global: r.global
    });
  };
}
function one(e) {
  return function(n) {
    if (_f() !== e)
      return;
    const r = {
      category: "console",
      data: {
        arguments: n.args,
        logger: "console"
      },
      level: nte(n.level),
      message: YI(n.args, " ")
    };
    if (n.level === "assert")
      if (n.args[0] === !1)
        r.message = `Assertion failed: ${YI(n.args.slice(1), " ") || "console.assert"}`, r.data.arguments = n.args.slice(1);
      else
        return;
    $4(r, {
      input: n.args,
      level: n.level
    });
  };
}
function lne(e) {
  return function(n) {
    if (_f() !== e)
      return;
    const { startTimestamp: r, endTimestamp: s } = n, o = n.xhr[K7];
    if (!r || !s || !o)
      return;
    const { method: c, url: u, status_code: m, body: y } = o, b = {
      method: c,
      url: u,
      status_code: m
    }, w = {
      xhr: n.xhr,
      input: y,
      startTimestamp: r,
      endTimestamp: s
    }, k = RV(m);
    $4(
      {
        category: "xhr",
        data: b,
        type: "http",
        level: k
      },
      w
    );
  };
}
function cne(e) {
  return function(n) {
    if (_f() !== e)
      return;
    const { startTimestamp: r, endTimestamp: s } = n;
    if (s && !(n.fetchData.url.match(/sentry_key/) && n.fetchData.method === "POST"))
      if (n.error) {
        const o = n.fetchData, c = {
          data: n.error,
          input: n.args,
          startTimestamp: r,
          endTimestamp: s
        };
        $4(
          {
            category: "fetch",
            data: o,
            level: "error",
            type: "http"
          },
          c
        );
      } else {
        const o = n.response, c = {
          ...n.fetchData,
          status_code: o && o.status
        }, u = {
          input: n.args,
          response: o,
          startTimestamp: r,
          endTimestamp: s
        }, m = RV(c.status_code);
        $4(
          {
            category: "fetch",
            data: c,
            type: "http",
            level: m
          },
          u
        );
      }
  };
}
function une(e) {
  return function(n) {
    if (_f() !== e)
      return;
    let r = n.from, s = n.to;
    const o = yM(Oi.location.href);
    let c = r ? yM(r) : void 0;
    const u = yM(s);
    (!c || !c.path) && (c = o), o.protocol === u.protocol && o.host === u.host && (s = u.relative), o.protocol === c.protocol && o.host === c.host && (r = c.relative), $4({
      category: "navigation",
      data: {
        from: r,
        to: s
      }
    });
  };
}
function dne(e) {
  return !!e && !!e.target;
}
const fne = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], mne = "BrowserApiErrors", hne = (e = {}) => {
  const t = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    ...e
  };
  return {
    name: mne,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      t.setTimeout && hp(Oi, "setTimeout", CF), t.setInterval && hp(Oi, "setInterval", CF), t.requestAnimationFrame && hp(Oi, "requestAnimationFrame", gne), t.XMLHttpRequest && "XMLHttpRequest" in Oi && hp(XMLHttpRequest.prototype, "send", yne);
      const n = t.eventTarget;
      n && (Array.isArray(n) ? n : fne).forEach(vne);
    }
  };
}, pne = hne;
function CF(e) {
  return function(...t) {
    const n = t[0];
    return t[0] = B8(n, {
      mechanism: {
        data: { function: L2(e) },
        handled: !1,
        type: "instrument"
      }
    }), e.apply(this, t);
  };
}
function gne(e) {
  return function(t) {
    return e.apply(this, [
      B8(t, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: L2(e)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function yne(e) {
  return function(...t) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((s) => {
      s in n && typeof n[s] == "function" && hp(n, s, function(o) {
        const c = {
          mechanism: {
            data: {
              function: s,
              handler: L2(o)
            },
            handled: !1,
            type: "instrument"
          }
        }, u = kP(o);
        return u && (c.mechanism.data.handler = L2(u)), B8(o, c);
      });
    }), e.apply(this, t);
  };
}
function vne(e) {
  const t = Oi, n = t[e] && t[e].prototype;
  !n || !n.hasOwnProperty || !n.hasOwnProperty("addEventListener") || (hp(n, "addEventListener", function(r) {
    return function(s, o, c) {
      try {
        typeof o.handleEvent == "function" && (o.handleEvent = B8(o.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: L2(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch {
      }
      return r.apply(this, [
        s,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        B8(o, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: L2(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }),
        c
      ]);
    };
  }), hp(
    n,
    "removeEventListener",
    function(r) {
      return function(s, o, c) {
        const u = o;
        try {
          const m = u && u.__sentry_wrapped__;
          m && r.call(this, s, m, c);
        } catch {
        }
        return r.call(this, s, u, c);
      };
    }
  ));
}
const xne = "GlobalHandlers", bne = (e = {}) => {
  const t = {
    onerror: !0,
    onunhandledrejection: !0,
    ...e
  };
  return {
    name: xne,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(n) {
      t.onerror && (wne(n), NF("onerror")), t.onunhandledrejection && (Cne(n), NF("onunhandledrejection"));
    }
  };
}, Sne = bne;
function wne(e) {
  DZ((t) => {
    const { stackParser: n, attachStacktrace: r } = IV();
    if (_f() !== e || PV())
      return;
    const { msg: s, url: o, line: c, column: u, error: m } = t, y = Ene(
      PP(n, m || s, void 0, r, !1),
      o,
      c,
      u
    );
    y.level = "error", wV(y, {
      originalException: m,
      mechanism: {
        handled: !1,
        type: "onerror"
      }
    });
  });
}
function Cne(e) {
  OZ((t) => {
    const { stackParser: n, attachStacktrace: r } = IV();
    if (_f() !== e || PV())
      return;
    const s = Nne(t), o = jP(s) ? jne(s) : PP(n, s, void 0, r, !0);
    o.level = "error", wV(o, {
      originalException: s,
      mechanism: {
        handled: !1,
        type: "onunhandledrejection"
      }
    });
  });
}
function Nne(e) {
  if (jP(e))
    return e;
  try {
    if ("reason" in e)
      return e.reason;
    if ("detail" in e && "reason" in e.detail)
      return e.detail.reason;
  } catch {
  }
  return e;
}
function jne(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function Ene(e, t, n, r) {
  const s = e.exception = e.exception || {}, o = s.values = s.values || [], c = o[0] = o[0] || {}, u = c.stacktrace = c.stacktrace || {}, m = u.frames = u.frames || [], y = isNaN(parseInt(r, 10)) ? void 0 : r, b = isNaN(parseInt(n, 10)) ? void 0 : n, w = Lv(t) && t.length > 0 ? t : HZ();
  return m.length === 0 && m.push({
    colno: y,
    filename: w,
    function: U4,
    in_app: !0,
    lineno: b
  }), e;
}
function NF(e) {
  $3 && qr.log(`Global Handler attached: ${e}`);
}
function IV() {
  const e = _f();
  return e && e.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
const kne = () => ({
  name: "HttpContext",
  preprocessEvent(e) {
    if (!Oi.navigator && !Oi.location && !Oi.document)
      return;
    const t = e.request && e.request.url || Oi.location && Oi.location.href, { referrer: n } = Oi.document || {}, { userAgent: r } = Oi.navigator || {}, s = {
      ...e.request && e.request.headers,
      ...n && { Referer: n },
      ...r && { "User-Agent": r }
    }, o = { ...e.request, ...t && { url: t }, headers: s };
    e.request = o;
  }
}), _ne = "cause", Tne = 5, Mne = "LinkedErrors", Rne = (e = {}) => {
  const t = e.limit || Tne, n = e.key || _ne;
  return {
    name: Mne,
    preprocessEvent(r, s, o) {
      const c = o.getOptions();
      Qee(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        RP,
        c.stackParser,
        c.maxValueLength,
        n,
        t,
        r,
        s
      );
    }
  };
}, Dne = Rne;
function Pne(e) {
  return [
    zee(),
    Lee(),
    pne(),
    ane(),
    Sne(),
    Dne(),
    ste(),
    kne()
  ];
}
function One(e = {}) {
  const t = {
    defaultIntegrations: Pne(),
    release: typeof __SENTRY_RELEASE__ == "string" ? __SENTRY_RELEASE__ : Oi.SENTRY_RELEASE && Oi.SENTRY_RELEASE.id ? Oi.SENTRY_RELEASE.id : void 0,
    autoSessionTracking: !0,
    sendClientReports: !0
  };
  return e.defaultIntegrations == null && delete e.defaultIntegrations, { ...t, ...e };
}
function Ane() {
  const e = typeof Oi.window < "u" && Oi;
  if (!e)
    return !1;
  const t = e.chrome ? "chrome" : "browser", n = e[t], r = n && n.runtime && n.runtime.id, s = Oi.location && Oi.location.href || "", o = ["chrome-extension:", "moz-extension:", "ms-browser-extension:", "safari-web-extension:"], c = !!r && Oi === Oi.top && o.some((m) => s.startsWith(`${m}//`)), u = typeof e.nw < "u";
  return !!r && !c && !u;
}
function Lne(e = {}) {
  const t = One(e);
  if (!t.skipBrowserExtensionCheck && Ane()) {
    B3(() => {
      console.error(
        "[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
      );
    });
    return;
  }
  $3 && (DV() || qr.warn(
    "No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill."
  ));
  const n = {
    ...t,
    stackParser: MZ(t.stackParser || tne),
    integrations: yee(t),
    transport: t.transport || Hte
  }, r = Cee(Tte, n);
  return t.autoSessionTracking && Ine(), r;
}
function Ine() {
  if (typeof Oi.document > "u") {
    $3 && qr.warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
    return;
  }
  lF({ ignoreDuration: !0 }), cF(), AV(({ from: e, to: t }) => {
    e !== void 0 && e !== t && (lF({ ignoreDuration: !0 }), cF());
  });
}
function Fne(e) {
  const t = {
    ...e
  };
  return _V(t, "react"), uee("react", { version: wZ }), Lne(t);
}
var Une = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
Une.SENTRY_RELEASE = { id: "3f5eac1e6eff17c417f5c57ebd92479f86a74234" };
var C1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fE(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function FV(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var s = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var fD = { exports: {} }, C7 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jF;
function zne() {
  if (jF) return C7;
  jF = 1;
  var e = Ee, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(u, m, y) {
    var b, w = {}, k = null, j = null;
    y !== void 0 && (k = "" + y), m.key !== void 0 && (k = "" + m.key), m.ref !== void 0 && (j = m.ref);
    for (b in m) r.call(m, b) && !o.hasOwnProperty(b) && (w[b] = m[b]);
    if (u && u.defaultProps) for (b in m = u.defaultProps, m) w[b] === void 0 && (w[b] = m[b]);
    return { $$typeof: t, type: u, key: k, ref: j, props: w, _owner: s.current };
  }
  return C7.Fragment = n, C7.jsx = c, C7.jsxs = c, C7;
}
var N7 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var EF;
function Bne() {
  return EF || (EF = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ee, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), u = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), j = Symbol.for("react.offscreen"), E = Symbol.iterator, T = "@@iterator";
    function D(_e) {
      if (_e === null || typeof _e != "object")
        return null;
      var _t = E && _e[E] || _e[T];
      return typeof _t == "function" ? _t : null;
    }
    var L = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function I(_e) {
      {
        for (var _t = arguments.length, Kt = new Array(_t > 1 ? _t - 1 : 0), On = 1; On < _t; On++)
          Kt[On - 1] = arguments[On];
        R("error", _e, Kt);
      }
    }
    function R(_e, _t, Kt) {
      {
        var On = L.ReactDebugCurrentFrame, vr = On.getStackAddendum();
        vr !== "" && (_t += "%s", Kt = Kt.concat([vr]));
        var Lr = Kt.map(function(Xn) {
          return String(Xn);
        });
        Lr.unshift("Warning: " + _t), Function.prototype.apply.call(console[_e], console, Lr);
      }
    }
    var U = !1, z = !1, H = !1, K = !1, q = !1, Q;
    Q = Symbol.for("react.module.reference");
    function Z(_e) {
      return !!(typeof _e == "string" || typeof _e == "function" || _e === r || _e === o || q || _e === s || _e === y || _e === b || K || _e === j || U || z || H || typeof _e == "object" && _e !== null && (_e.$$typeof === k || _e.$$typeof === w || _e.$$typeof === c || _e.$$typeof === u || _e.$$typeof === m || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      _e.$$typeof === Q || _e.getModuleId !== void 0));
    }
    function X(_e, _t, Kt) {
      var On = _e.displayName;
      if (On)
        return On;
      var vr = _t.displayName || _t.name || "";
      return vr !== "" ? Kt + "(" + vr + ")" : Kt;
    }
    function se(_e) {
      return _e.displayName || "Context";
    }
    function te(_e) {
      if (_e == null)
        return null;
      if (typeof _e.tag == "number" && I("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof _e == "function")
        return _e.displayName || _e.name || null;
      if (typeof _e == "string")
        return _e;
      switch (_e) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case s:
          return "StrictMode";
        case y:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof _e == "object")
        switch (_e.$$typeof) {
          case u:
            var _t = _e;
            return se(_t) + ".Consumer";
          case c:
            var Kt = _e;
            return se(Kt._context) + ".Provider";
          case m:
            return X(_e, _e.render, "ForwardRef");
          case w:
            var On = _e.displayName || null;
            return On !== null ? On : te(_e.type) || "Memo";
          case k: {
            var vr = _e, Lr = vr._payload, Xn = vr._init;
            try {
              return te(Xn(Lr));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var fe = Object.assign, ce = 0, pe, Se, oe, ue, he, ve, Te;
    function Ie() {
    }
    Ie.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ce === 0) {
          pe = console.log, Se = console.info, oe = console.warn, ue = console.error, he = console.group, ve = console.groupCollapsed, Te = console.groupEnd;
          var _e = {
            configurable: !0,
            enumerable: !0,
            value: Ie,
            writable: !0
          };
          Object.defineProperties(console, {
            info: _e,
            log: _e,
            warn: _e,
            error: _e,
            group: _e,
            groupCollapsed: _e,
            groupEnd: _e
          });
        }
        ce++;
      }
    }
    function qe() {
      {
        if (ce--, ce === 0) {
          var _e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: fe({}, _e, {
              value: pe
            }),
            info: fe({}, _e, {
              value: Se
            }),
            warn: fe({}, _e, {
              value: oe
            }),
            error: fe({}, _e, {
              value: ue
            }),
            group: fe({}, _e, {
              value: he
            }),
            groupCollapsed: fe({}, _e, {
              value: ve
            }),
            groupEnd: fe({}, _e, {
              value: Te
            })
          });
        }
        ce < 0 && I("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var it = L.ReactCurrentDispatcher, Ne;
    function Xe(_e, _t, Kt) {
      {
        if (Ne === void 0)
          try {
            throw Error();
          } catch (vr) {
            var On = vr.stack.trim().match(/\n( *(at )?)/);
            Ne = On && On[1] || "";
          }
        return `
` + Ne + _e;
      }
    }
    var xt = !1, rn;
    {
      var vt = typeof WeakMap == "function" ? WeakMap : Map;
      rn = new vt();
    }
    function At(_e, _t) {
      if (!_e || xt)
        return "";
      {
        var Kt = rn.get(_e);
        if (Kt !== void 0)
          return Kt;
      }
      var On;
      xt = !0;
      var vr = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Lr;
      Lr = it.current, it.current = null, Ue();
      try {
        if (_t) {
          var Xn = function() {
            throw Error();
          };
          if (Object.defineProperty(Xn.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Xn, []);
            } catch (zr) {
              On = zr;
            }
            Reflect.construct(_e, [], Xn);
          } else {
            try {
              Xn.call();
            } catch (zr) {
              On = zr;
            }
            _e.call(Xn.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (zr) {
            On = zr;
          }
          _e();
        }
      } catch (zr) {
        if (zr && On && typeof zr.stack == "string") {
          for (var wr = zr.stack.split(`
`), Ts = On.stack.split(`
`), pa = wr.length - 1, ga = Ts.length - 1; pa >= 1 && ga >= 0 && wr[pa] !== Ts[ga]; )
            ga--;
          for (; pa >= 1 && ga >= 0; pa--, ga--)
            if (wr[pa] !== Ts[ga]) {
              if (pa !== 1 || ga !== 1)
                do
                  if (pa--, ga--, ga < 0 || wr[pa] !== Ts[ga]) {
                    var Tr = `
` + wr[pa].replace(" at new ", " at ");
                    return _e.displayName && Tr.includes("<anonymous>") && (Tr = Tr.replace("<anonymous>", _e.displayName)), typeof _e == "function" && rn.set(_e, Tr), Tr;
                  }
                while (pa >= 1 && ga >= 0);
              break;
            }
        }
      } finally {
        xt = !1, it.current = Lr, qe(), Error.prepareStackTrace = vr;
      }
      var Fn = _e ? _e.displayName || _e.name : "", Gn = Fn ? Xe(Fn) : "";
      return typeof _e == "function" && rn.set(_e, Gn), Gn;
    }
    function He(_e, _t, Kt) {
      return At(_e, !1);
    }
    function Pt(_e) {
      var _t = _e.prototype;
      return !!(_t && _t.isReactComponent);
    }
    function Lt(_e, _t, Kt) {
      if (_e == null)
        return "";
      if (typeof _e == "function")
        return At(_e, Pt(_e));
      if (typeof _e == "string")
        return Xe(_e);
      switch (_e) {
        case y:
          return Xe("Suspense");
        case b:
          return Xe("SuspenseList");
      }
      if (typeof _e == "object")
        switch (_e.$$typeof) {
          case m:
            return He(_e.render);
          case w:
            return Lt(_e.type, _t, Kt);
          case k: {
            var On = _e, vr = On._payload, Lr = On._init;
            try {
              return Lt(Lr(vr), _t, Kt);
            } catch {
            }
          }
        }
      return "";
    }
    var er = Object.prototype.hasOwnProperty, It = {}, ye = L.ReactDebugCurrentFrame;
    function ke(_e) {
      if (_e) {
        var _t = _e._owner, Kt = Lt(_e.type, _e._source, _t ? _t.type : null);
        ye.setExtraStackFrame(Kt);
      } else
        ye.setExtraStackFrame(null);
    }
    function Pe(_e, _t, Kt, On, vr) {
      {
        var Lr = Function.call.bind(er);
        for (var Xn in _e)
          if (Lr(_e, Xn)) {
            var wr = void 0;
            try {
              if (typeof _e[Xn] != "function") {
                var Ts = Error((On || "React class") + ": " + Kt + " type `" + Xn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof _e[Xn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ts.name = "Invariant Violation", Ts;
              }
              wr = _e[Xn](_t, Xn, On, Kt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (pa) {
              wr = pa;
            }
            wr && !(wr instanceof Error) && (ke(vr), I("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", On || "React class", Kt, Xn, typeof wr), ke(null)), wr instanceof Error && !(wr.message in It) && (It[wr.message] = !0, ke(vr), I("Failed %s type: %s", Kt, wr.message), ke(null));
          }
      }
    }
    var tt = Array.isArray;
    function ot(_e) {
      return tt(_e);
    }
    function ut(_e) {
      {
        var _t = typeof Symbol == "function" && Symbol.toStringTag, Kt = _t && _e[Symbol.toStringTag] || _e.constructor.name || "Object";
        return Kt;
      }
    }
    function Vt(_e) {
      try {
        return bn(_e), !1;
      } catch {
        return !0;
      }
    }
    function bn(_e) {
      return "" + _e;
    }
    function mr(_e) {
      if (Vt(_e))
        return I("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ut(_e)), bn(_e);
    }
    var ur = L.ReactCurrentOwner, _r = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ai, ls, Ot;
    Ot = {};
    function En(_e) {
      if (er.call(_e, "ref")) {
        var _t = Object.getOwnPropertyDescriptor(_e, "ref").get;
        if (_t && _t.isReactWarning)
          return !1;
      }
      return _e.ref !== void 0;
    }
    function Xt(_e) {
      if (er.call(_e, "key")) {
        var _t = Object.getOwnPropertyDescriptor(_e, "key").get;
        if (_t && _t.isReactWarning)
          return !1;
      }
      return _e.key !== void 0;
    }
    function qt(_e, _t) {
      if (typeof _e.ref == "string" && ur.current && _t && ur.current.stateNode !== _t) {
        var Kt = te(ur.current.type);
        Ot[Kt] || (I('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', te(ur.current.type), _e.ref), Ot[Kt] = !0);
      }
    }
    function In(_e, _t) {
      {
        var Kt = function() {
          ai || (ai = !0, I("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _t));
        };
        Kt.isReactWarning = !0, Object.defineProperty(_e, "key", {
          get: Kt,
          configurable: !0
        });
      }
    }
    function st(_e, _t) {
      {
        var Kt = function() {
          ls || (ls = !0, I("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _t));
        };
        Kt.isReactWarning = !0, Object.defineProperty(_e, "ref", {
          get: Kt,
          configurable: !0
        });
      }
    }
    var lt = function(_e, _t, Kt, On, vr, Lr, Xn) {
      var wr = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: _e,
        key: _t,
        ref: Kt,
        props: Xn,
        // Record the component responsible for creating this element.
        _owner: Lr
      };
      return wr._store = {}, Object.defineProperty(wr._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(wr, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: On
      }), Object.defineProperty(wr, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: vr
      }), Object.freeze && (Object.freeze(wr.props), Object.freeze(wr)), wr;
    };
    function Nt(_e, _t, Kt, On, vr) {
      {
        var Lr, Xn = {}, wr = null, Ts = null;
        Kt !== void 0 && (mr(Kt), wr = "" + Kt), Xt(_t) && (mr(_t.key), wr = "" + _t.key), En(_t) && (Ts = _t.ref, qt(_t, vr));
        for (Lr in _t)
          er.call(_t, Lr) && !_r.hasOwnProperty(Lr) && (Xn[Lr] = _t[Lr]);
        if (_e && _e.defaultProps) {
          var pa = _e.defaultProps;
          for (Lr in pa)
            Xn[Lr] === void 0 && (Xn[Lr] = pa[Lr]);
        }
        if (wr || Ts) {
          var ga = typeof _e == "function" ? _e.displayName || _e.name || "Unknown" : _e;
          wr && In(Xn, ga), Ts && st(Xn, ga);
        }
        return lt(_e, wr, Ts, vr, On, ur.current, Xn);
      }
    }
    var Wt = L.ReactCurrentOwner, wn = L.ReactDebugCurrentFrame;
    function pt(_e) {
      if (_e) {
        var _t = _e._owner, Kt = Lt(_e.type, _e._source, _t ? _t.type : null);
        wn.setExtraStackFrame(Kt);
      } else
        wn.setExtraStackFrame(null);
    }
    var hr;
    hr = !1;
    function _o(_e) {
      return typeof _e == "object" && _e !== null && _e.$$typeof === t;
    }
    function Il() {
      {
        if (Wt.current) {
          var _e = te(Wt.current.type);
          if (_e)
            return `

Check the render method of \`` + _e + "`.";
        }
        return "";
      }
    }
    function Cr(_e) {
      return "";
    }
    var Wi = {};
    function Yi(_e) {
      {
        var _t = Il();
        if (!_t) {
          var Kt = typeof _e == "string" ? _e : _e.displayName || _e.name;
          Kt && (_t = `

Check the top-level render call using <` + Kt + ">.");
        }
        return _t;
      }
    }
    function To(_e, _t) {
      {
        if (!_e._store || _e._store.validated || _e.key != null)
          return;
        _e._store.validated = !0;
        var Kt = Yi(_t);
        if (Wi[Kt])
          return;
        Wi[Kt] = !0;
        var On = "";
        _e && _e._owner && _e._owner !== Wt.current && (On = " It was passed a child from " + te(_e._owner.type) + "."), pt(_e), I('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Kt, On), pt(null);
      }
    }
    function qi(_e, _t) {
      {
        if (typeof _e != "object")
          return;
        if (ot(_e))
          for (var Kt = 0; Kt < _e.length; Kt++) {
            var On = _e[Kt];
            _o(On) && To(On, _t);
          }
        else if (_o(_e))
          _e._store && (_e._store.validated = !0);
        else if (_e) {
          var vr = D(_e);
          if (typeof vr == "function" && vr !== _e.entries)
            for (var Lr = vr.call(_e), Xn; !(Xn = Lr.next()).done; )
              _o(Xn.value) && To(Xn.value, _t);
        }
      }
    }
    function Mo(_e) {
      {
        var _t = _e.type;
        if (_t == null || typeof _t == "string")
          return;
        var Kt;
        if (typeof _t == "function")
          Kt = _t.propTypes;
        else if (typeof _t == "object" && (_t.$$typeof === m || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _t.$$typeof === w))
          Kt = _t.propTypes;
        else
          return;
        if (Kt) {
          var On = te(_t);
          Pe(Kt, _e.props, "prop", On, _e);
        } else if (_t.PropTypes !== void 0 && !hr) {
          hr = !0;
          var vr = te(_t);
          I("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", vr || "Unknown");
        }
        typeof _t.getDefaultProps == "function" && !_t.getDefaultProps.isReactClassApproved && I("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ul(_e) {
      {
        for (var _t = Object.keys(_e.props), Kt = 0; Kt < _t.length; Kt++) {
          var On = _t[Kt];
          if (On !== "children" && On !== "key") {
            pt(_e), I("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", On), pt(null);
            break;
          }
        }
        _e.ref !== null && (pt(_e), I("Invalid attribute `ref` supplied to `React.Fragment`."), pt(null));
      }
    }
    var dl = {};
    function Dc(_e, _t, Kt, On, vr, Lr) {
      {
        var Xn = Z(_e);
        if (!Xn) {
          var wr = "";
          (_e === void 0 || typeof _e == "object" && _e !== null && Object.keys(_e).length === 0) && (wr += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ts = Cr();
          Ts ? wr += Ts : wr += Il();
          var pa;
          _e === null ? pa = "null" : ot(_e) ? pa = "array" : _e !== void 0 && _e.$$typeof === t ? (pa = "<" + (te(_e.type) || "Unknown") + " />", wr = " Did you accidentally export a JSX literal instead of a component?") : pa = typeof _e, I("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", pa, wr);
        }
        var ga = Nt(_e, _t, Kt, vr, Lr);
        if (ga == null)
          return ga;
        if (Xn) {
          var Tr = _t.children;
          if (Tr !== void 0)
            if (On)
              if (ot(Tr)) {
                for (var Fn = 0; Fn < Tr.length; Fn++)
                  qi(Tr[Fn], _e);
                Object.freeze && Object.freeze(Tr);
              } else
                I("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              qi(Tr, _e);
        }
        if (er.call(_t, "key")) {
          var Gn = te(_e), zr = Object.keys(_t).filter(function(Hs) {
            return Hs !== "key";
          }), ta = zr.length > 0 ? "{key: someKey, " + zr.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!dl[Gn + ta]) {
            var ir = zr.length > 0 ? "{" + zr.join(": ..., ") + ": ...}" : "{}";
            I(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ta, Gn, ir, Gn), dl[Gn + ta] = !0;
          }
        }
        return _e === r ? ul(ga) : Mo(ga), ga;
      }
    }
    function Ro(_e, _t, Kt) {
      return Dc(_e, _t, Kt, !0);
    }
    function Do(_e, _t, Kt) {
      return Dc(_e, _t, Kt, !1);
    }
    var _s = Do, fl = Ro;
    N7.Fragment = r, N7.jsx = _s, N7.jsxs = fl;
  }()), N7;
}
process.env.NODE_ENV === "production" ? fD.exports = zne() : fD.exports = Bne();
var a = fD.exports, mD = { exports: {} }, ah = {}, pj = { exports: {} }, xM = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kF;
function Hne() {
  return kF || (kF = 1, function(e) {
    function t(oe, ue) {
      var he = oe.length;
      oe.push(ue);
      e: for (; 0 < he; ) {
        var ve = he - 1 >>> 1, Te = oe[ve];
        if (0 < s(Te, ue)) oe[ve] = ue, oe[he] = Te, he = ve;
        else break e;
      }
    }
    function n(oe) {
      return oe.length === 0 ? null : oe[0];
    }
    function r(oe) {
      if (oe.length === 0) return null;
      var ue = oe[0], he = oe.pop();
      if (he !== ue) {
        oe[0] = he;
        e: for (var ve = 0, Te = oe.length, Ie = Te >>> 1; ve < Ie; ) {
          var Ue = 2 * (ve + 1) - 1, qe = oe[Ue], it = Ue + 1, Ne = oe[it];
          if (0 > s(qe, he)) it < Te && 0 > s(Ne, qe) ? (oe[ve] = Ne, oe[it] = he, ve = it) : (oe[ve] = qe, oe[Ue] = he, ve = Ue);
          else if (it < Te && 0 > s(Ne, he)) oe[ve] = Ne, oe[it] = he, ve = it;
          else break e;
        }
      }
      return ue;
    }
    function s(oe, ue) {
      var he = oe.sortIndex - ue.sortIndex;
      return he !== 0 ? he : oe.id - ue.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var o = performance;
      e.unstable_now = function() {
        return o.now();
      };
    } else {
      var c = Date, u = c.now();
      e.unstable_now = function() {
        return c.now() - u;
      };
    }
    var m = [], y = [], b = 1, w = null, k = 3, j = !1, E = !1, T = !1, D = typeof setTimeout == "function" ? setTimeout : null, L = typeof clearTimeout == "function" ? clearTimeout : null, I = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function R(oe) {
      for (var ue = n(y); ue !== null; ) {
        if (ue.callback === null) r(y);
        else if (ue.startTime <= oe) r(y), ue.sortIndex = ue.expirationTime, t(m, ue);
        else break;
        ue = n(y);
      }
    }
    function U(oe) {
      if (T = !1, R(oe), !E) if (n(m) !== null) E = !0, pe(z);
      else {
        var ue = n(y);
        ue !== null && Se(U, ue.startTime - oe);
      }
    }
    function z(oe, ue) {
      E = !1, T && (T = !1, L(q), q = -1), j = !0;
      var he = k;
      try {
        for (R(ue), w = n(m); w !== null && (!(w.expirationTime > ue) || oe && !X()); ) {
          var ve = w.callback;
          if (typeof ve == "function") {
            w.callback = null, k = w.priorityLevel;
            var Te = ve(w.expirationTime <= ue);
            ue = e.unstable_now(), typeof Te == "function" ? w.callback = Te : w === n(m) && r(m), R(ue);
          } else r(m);
          w = n(m);
        }
        if (w !== null) var Ie = !0;
        else {
          var Ue = n(y);
          Ue !== null && Se(U, Ue.startTime - ue), Ie = !1;
        }
        return Ie;
      } finally {
        w = null, k = he, j = !1;
      }
    }
    var H = !1, K = null, q = -1, Q = 5, Z = -1;
    function X() {
      return !(e.unstable_now() - Z < Q);
    }
    function se() {
      if (K !== null) {
        var oe = e.unstable_now();
        Z = oe;
        var ue = !0;
        try {
          ue = K(!0, oe);
        } finally {
          ue ? te() : (H = !1, K = null);
        }
      } else H = !1;
    }
    var te;
    if (typeof I == "function") te = function() {
      I(se);
    };
    else if (typeof MessageChannel < "u") {
      var fe = new MessageChannel(), ce = fe.port2;
      fe.port1.onmessage = se, te = function() {
        ce.postMessage(null);
      };
    } else te = function() {
      D(se, 0);
    };
    function pe(oe) {
      K = oe, H || (H = !0, te());
    }
    function Se(oe, ue) {
      q = D(function() {
        oe(e.unstable_now());
      }, ue);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(oe) {
      oe.callback = null;
    }, e.unstable_continueExecution = function() {
      E || j || (E = !0, pe(z));
    }, e.unstable_forceFrameRate = function(oe) {
      0 > oe || 125 < oe ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Q = 0 < oe ? Math.floor(1e3 / oe) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return k;
    }, e.unstable_getFirstCallbackNode = function() {
      return n(m);
    }, e.unstable_next = function(oe) {
      switch (k) {
        case 1:
        case 2:
        case 3:
          var ue = 3;
          break;
        default:
          ue = k;
      }
      var he = k;
      k = ue;
      try {
        return oe();
      } finally {
        k = he;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(oe, ue) {
      switch (oe) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          oe = 3;
      }
      var he = k;
      k = oe;
      try {
        return ue();
      } finally {
        k = he;
      }
    }, e.unstable_scheduleCallback = function(oe, ue, he) {
      var ve = e.unstable_now();
      switch (typeof he == "object" && he !== null ? (he = he.delay, he = typeof he == "number" && 0 < he ? ve + he : ve) : he = ve, oe) {
        case 1:
          var Te = -1;
          break;
        case 2:
          Te = 250;
          break;
        case 5:
          Te = 1073741823;
          break;
        case 4:
          Te = 1e4;
          break;
        default:
          Te = 5e3;
      }
      return Te = he + Te, oe = { id: b++, callback: ue, priorityLevel: oe, startTime: he, expirationTime: Te, sortIndex: -1 }, he > ve ? (oe.sortIndex = he, t(y, oe), n(m) === null && oe === n(y) && (T ? (L(q), q = -1) : T = !0, Se(U, he - ve))) : (oe.sortIndex = Te, t(m, oe), E || j || (E = !0, pe(z))), oe;
    }, e.unstable_shouldYield = X, e.unstable_wrapCallback = function(oe) {
      var ue = k;
      return function() {
        var he = k;
        k = ue;
        try {
          return oe.apply(this, arguments);
        } finally {
          k = he;
        }
      };
    };
  }(xM)), xM;
}
var bM = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _F;
function Vne() {
  return _F || (_F = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = !1, n = !1, r = 5;
      function s(Ot, En) {
        var Xt = Ot.length;
        Ot.push(En), u(Ot, En, Xt);
      }
      function o(Ot) {
        return Ot.length === 0 ? null : Ot[0];
      }
      function c(Ot) {
        if (Ot.length === 0)
          return null;
        var En = Ot[0], Xt = Ot.pop();
        return Xt !== En && (Ot[0] = Xt, m(Ot, Xt, 0)), En;
      }
      function u(Ot, En, Xt) {
        for (var qt = Xt; qt > 0; ) {
          var In = qt - 1 >>> 1, st = Ot[In];
          if (y(st, En) > 0)
            Ot[In] = En, Ot[qt] = st, qt = In;
          else
            return;
        }
      }
      function m(Ot, En, Xt) {
        for (var qt = Xt, In = Ot.length, st = In >>> 1; qt < st; ) {
          var lt = (qt + 1) * 2 - 1, Nt = Ot[lt], Wt = lt + 1, wn = Ot[Wt];
          if (y(Nt, En) < 0)
            Wt < In && y(wn, Nt) < 0 ? (Ot[qt] = wn, Ot[Wt] = En, qt = Wt) : (Ot[qt] = Nt, Ot[lt] = En, qt = lt);
          else if (Wt < In && y(wn, En) < 0)
            Ot[qt] = wn, Ot[Wt] = En, qt = Wt;
          else
            return;
        }
      }
      function y(Ot, En) {
        var Xt = Ot.sortIndex - En.sortIndex;
        return Xt !== 0 ? Xt : Ot.id - En.id;
      }
      var b = 1, w = 2, k = 3, j = 4, E = 5;
      function T(Ot, En) {
      }
      var D = typeof performance == "object" && typeof performance.now == "function";
      if (D) {
        var L = performance;
        e.unstable_now = function() {
          return L.now();
        };
      } else {
        var I = Date, R = I.now();
        e.unstable_now = function() {
          return I.now() - R;
        };
      }
      var U = 1073741823, z = -1, H = 250, K = 5e3, q = 1e4, Q = U, Z = [], X = [], se = 1, te = null, fe = k, ce = !1, pe = !1, Se = !1, oe = typeof setTimeout == "function" ? setTimeout : null, ue = typeof clearTimeout == "function" ? clearTimeout : null, he = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function ve(Ot) {
        for (var En = o(X); En !== null; ) {
          if (En.callback === null)
            c(X);
          else if (En.startTime <= Ot)
            c(X), En.sortIndex = En.expirationTime, s(Z, En);
          else
            return;
          En = o(X);
        }
      }
      function Te(Ot) {
        if (Se = !1, ve(Ot), !pe)
          if (o(Z) !== null)
            pe = !0, mr(Ie);
          else {
            var En = o(X);
            En !== null && ur(Te, En.startTime - Ot);
          }
      }
      function Ie(Ot, En) {
        pe = !1, Se && (Se = !1, _r()), ce = !0;
        var Xt = fe;
        try {
          var qt;
          if (!n) return Ue(Ot, En);
        } finally {
          te = null, fe = Xt, ce = !1;
        }
      }
      function Ue(Ot, En) {
        var Xt = En;
        for (ve(Xt), te = o(Z); te !== null && !t && !(te.expirationTime > Xt && (!Ot || ke())); ) {
          var qt = te.callback;
          if (typeof qt == "function") {
            te.callback = null, fe = te.priorityLevel;
            var In = te.expirationTime <= Xt, st = qt(In);
            Xt = e.unstable_now(), typeof st == "function" ? te.callback = st : te === o(Z) && c(Z), ve(Xt);
          } else
            c(Z);
          te = o(Z);
        }
        if (te !== null)
          return !0;
        var lt = o(X);
        return lt !== null && ur(Te, lt.startTime - Xt), !1;
      }
      function qe(Ot, En) {
        switch (Ot) {
          case b:
          case w:
          case k:
          case j:
          case E:
            break;
          default:
            Ot = k;
        }
        var Xt = fe;
        fe = Ot;
        try {
          return En();
        } finally {
          fe = Xt;
        }
      }
      function it(Ot) {
        var En;
        switch (fe) {
          case b:
          case w:
          case k:
            En = k;
            break;
          default:
            En = fe;
            break;
        }
        var Xt = fe;
        fe = En;
        try {
          return Ot();
        } finally {
          fe = Xt;
        }
      }
      function Ne(Ot) {
        var En = fe;
        return function() {
          var Xt = fe;
          fe = En;
          try {
            return Ot.apply(this, arguments);
          } finally {
            fe = Xt;
          }
        };
      }
      function Xe(Ot, En, Xt) {
        var qt = e.unstable_now(), In;
        if (typeof Xt == "object" && Xt !== null) {
          var st = Xt.delay;
          typeof st == "number" && st > 0 ? In = qt + st : In = qt;
        } else
          In = qt;
        var lt;
        switch (Ot) {
          case b:
            lt = z;
            break;
          case w:
            lt = H;
            break;
          case E:
            lt = Q;
            break;
          case j:
            lt = q;
            break;
          case k:
          default:
            lt = K;
            break;
        }
        var Nt = In + lt, Wt = {
          id: se++,
          callback: En,
          priorityLevel: Ot,
          startTime: In,
          expirationTime: Nt,
          sortIndex: -1
        };
        return In > qt ? (Wt.sortIndex = In, s(X, Wt), o(Z) === null && Wt === o(X) && (Se ? _r() : Se = !0, ur(Te, In - qt))) : (Wt.sortIndex = Nt, s(Z, Wt), !pe && !ce && (pe = !0, mr(Ie))), Wt;
      }
      function xt() {
      }
      function rn() {
        !pe && !ce && (pe = !0, mr(Ie));
      }
      function vt() {
        return o(Z);
      }
      function At(Ot) {
        Ot.callback = null;
      }
      function He() {
        return fe;
      }
      var Pt = !1, Lt = null, er = -1, It = r, ye = -1;
      function ke() {
        var Ot = e.unstable_now() - ye;
        return !(Ot < It);
      }
      function Pe() {
      }
      function tt(Ot) {
        if (Ot < 0 || Ot > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        Ot > 0 ? It = Math.floor(1e3 / Ot) : It = r;
      }
      var ot = function() {
        if (Lt !== null) {
          var Ot = e.unstable_now();
          ye = Ot;
          var En = !0, Xt = !0;
          try {
            Xt = Lt(En, Ot);
          } finally {
            Xt ? ut() : (Pt = !1, Lt = null);
          }
        } else
          Pt = !1;
      }, ut;
      if (typeof he == "function")
        ut = function() {
          he(ot);
        };
      else if (typeof MessageChannel < "u") {
        var Vt = new MessageChannel(), bn = Vt.port2;
        Vt.port1.onmessage = ot, ut = function() {
          bn.postMessage(null);
        };
      } else
        ut = function() {
          oe(ot, 0);
        };
      function mr(Ot) {
        Lt = Ot, Pt || (Pt = !0, ut());
      }
      function ur(Ot, En) {
        er = oe(function() {
          Ot(e.unstable_now());
        }, En);
      }
      function _r() {
        ue(er), er = -1;
      }
      var ai = Pe, ls = null;
      e.unstable_IdlePriority = E, e.unstable_ImmediatePriority = b, e.unstable_LowPriority = j, e.unstable_NormalPriority = k, e.unstable_Profiling = ls, e.unstable_UserBlockingPriority = w, e.unstable_cancelCallback = At, e.unstable_continueExecution = rn, e.unstable_forceFrameRate = tt, e.unstable_getCurrentPriorityLevel = He, e.unstable_getFirstCallbackNode = vt, e.unstable_next = it, e.unstable_pauseExecution = xt, e.unstable_requestPaint = ai, e.unstable_runWithPriority = qe, e.unstable_scheduleCallback = Xe, e.unstable_shouldYield = ke, e.unstable_wrapCallback = Ne, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(bM)), bM;
}
var TF;
function G3() {
  return TF || (TF = 1, process.env.NODE_ENV === "production" ? pj.exports = Hne() : pj.exports = Vne()), pj.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MF;
function $ne() {
  if (MF) return ah;
  MF = 1;
  var e = Ee, t = G3();
  function n(f) {
    for (var p = "https://reactjs.org/docs/error-decoder.html?invariant=" + f, N = 1; N < arguments.length; N++) p += "&args[]=" + encodeURIComponent(arguments[N]);
    return "Minified React error #" + f + "; visit " + p + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = /* @__PURE__ */ new Set(), s = {};
  function o(f, p) {
    c(f, p), c(f + "Capture", p);
  }
  function c(f, p) {
    for (s[f] = p, f = 0; f < p.length; f++) r.add(p[f]);
  }
  var u = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), m = Object.prototype.hasOwnProperty, y = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, b = {}, w = {};
  function k(f) {
    return m.call(w, f) ? !0 : m.call(b, f) ? !1 : y.test(f) ? w[f] = !0 : (b[f] = !0, !1);
  }
  function j(f, p, N, O) {
    if (N !== null && N.type === 0) return !1;
    switch (typeof p) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return O ? !1 : N !== null ? !N.acceptsBooleans : (f = f.toLowerCase().slice(0, 5), f !== "data-" && f !== "aria-");
      default:
        return !1;
    }
  }
  function E(f, p, N, O) {
    if (p === null || typeof p > "u" || j(f, p, N, O)) return !0;
    if (O) return !1;
    if (N !== null) switch (N.type) {
      case 3:
        return !p;
      case 4:
        return p === !1;
      case 5:
        return isNaN(p);
      case 6:
        return isNaN(p) || 1 > p;
    }
    return !1;
  }
  function T(f, p, N, O, V, J, me) {
    this.acceptsBooleans = p === 2 || p === 3 || p === 4, this.attributeName = O, this.attributeNamespace = V, this.mustUseProperty = N, this.propertyName = f, this.type = p, this.sanitizeURL = J, this.removeEmptyString = me;
  }
  var D = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(f) {
    D[f] = new T(f, 0, !1, f, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(f) {
    var p = f[0];
    D[p] = new T(p, 1, !1, f[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(f) {
    D[f] = new T(f, 2, !1, f.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(f) {
    D[f] = new T(f, 2, !1, f, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(f) {
    D[f] = new T(f, 3, !1, f.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(f) {
    D[f] = new T(f, 3, !0, f, null, !1, !1);
  }), ["capture", "download"].forEach(function(f) {
    D[f] = new T(f, 4, !1, f, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(f) {
    D[f] = new T(f, 6, !1, f, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(f) {
    D[f] = new T(f, 5, !1, f.toLowerCase(), null, !1, !1);
  });
  var L = /[\-:]([a-z])/g;
  function I(f) {
    return f[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(f) {
    var p = f.replace(
      L,
      I
    );
    D[p] = new T(p, 1, !1, f, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(f) {
    var p = f.replace(L, I);
    D[p] = new T(p, 1, !1, f, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(f) {
    var p = f.replace(L, I);
    D[p] = new T(p, 1, !1, f, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(f) {
    D[f] = new T(f, 1, !1, f.toLowerCase(), null, !1, !1);
  }), D.xlinkHref = new T("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(f) {
    D[f] = new T(f, 1, !1, f.toLowerCase(), null, !0, !0);
  });
  function R(f, p, N, O) {
    var V = D.hasOwnProperty(p) ? D[p] : null;
    (V !== null ? V.type !== 0 : O || !(2 < p.length) || p[0] !== "o" && p[0] !== "O" || p[1] !== "n" && p[1] !== "N") && (E(p, N, V, O) && (N = null), O || V === null ? k(p) && (N === null ? f.removeAttribute(p) : f.setAttribute(p, "" + N)) : V.mustUseProperty ? f[V.propertyName] = N === null ? V.type === 3 ? !1 : "" : N : (p = V.attributeName, O = V.attributeNamespace, N === null ? f.removeAttribute(p) : (V = V.type, N = V === 3 || V === 4 && N === !0 ? "" : "" + N, O ? f.setAttributeNS(O, p, N) : f.setAttribute(p, N))));
  }
  var U = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, z = Symbol.for("react.element"), H = Symbol.for("react.portal"), K = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), Q = Symbol.for("react.profiler"), Z = Symbol.for("react.provider"), X = Symbol.for("react.context"), se = Symbol.for("react.forward_ref"), te = Symbol.for("react.suspense"), fe = Symbol.for("react.suspense_list"), ce = Symbol.for("react.memo"), pe = Symbol.for("react.lazy"), Se = Symbol.for("react.offscreen"), oe = Symbol.iterator;
  function ue(f) {
    return f === null || typeof f != "object" ? null : (f = oe && f[oe] || f["@@iterator"], typeof f == "function" ? f : null);
  }
  var he = Object.assign, ve;
  function Te(f) {
    if (ve === void 0) try {
      throw Error();
    } catch (N) {
      var p = N.stack.trim().match(/\n( *(at )?)/);
      ve = p && p[1] || "";
    }
    return `
` + ve + f;
  }
  var Ie = !1;
  function Ue(f, p) {
    if (!f || Ie) return "";
    Ie = !0;
    var N = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (p) if (p = function() {
        throw Error();
      }, Object.defineProperty(p.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(p, []);
        } catch (Je) {
          var O = Je;
        }
        Reflect.construct(f, [], p);
      } else {
        try {
          p.call();
        } catch (Je) {
          O = Je;
        }
        f.call(p.prototype);
      }
      else {
        try {
          throw Error();
        } catch (Je) {
          O = Je;
        }
        f();
      }
    } catch (Je) {
      if (Je && O && typeof Je.stack == "string") {
        for (var V = Je.stack.split(`
`), J = O.stack.split(`
`), me = V.length - 1, je = J.length - 1; 1 <= me && 0 <= je && V[me] !== J[je]; ) je--;
        for (; 1 <= me && 0 <= je; me--, je--) if (V[me] !== J[je]) {
          if (me !== 1 || je !== 1)
            do
              if (me--, je--, 0 > je || V[me] !== J[je]) {
                var De = `
` + V[me].replace(" at new ", " at ");
                return f.displayName && De.includes("<anonymous>") && (De = De.replace("<anonymous>", f.displayName)), De;
              }
            while (1 <= me && 0 <= je);
          break;
        }
      }
    } finally {
      Ie = !1, Error.prepareStackTrace = N;
    }
    return (f = f ? f.displayName || f.name : "") ? Te(f) : "";
  }
  function qe(f) {
    switch (f.tag) {
      case 5:
        return Te(f.type);
      case 16:
        return Te("Lazy");
      case 13:
        return Te("Suspense");
      case 19:
        return Te("SuspenseList");
      case 0:
      case 2:
      case 15:
        return f = Ue(f.type, !1), f;
      case 11:
        return f = Ue(f.type.render, !1), f;
      case 1:
        return f = Ue(f.type, !0), f;
      default:
        return "";
    }
  }
  function it(f) {
    if (f == null) return null;
    if (typeof f == "function") return f.displayName || f.name || null;
    if (typeof f == "string") return f;
    switch (f) {
      case K:
        return "Fragment";
      case H:
        return "Portal";
      case Q:
        return "Profiler";
      case q:
        return "StrictMode";
      case te:
        return "Suspense";
      case fe:
        return "SuspenseList";
    }
    if (typeof f == "object") switch (f.$$typeof) {
      case X:
        return (f.displayName || "Context") + ".Consumer";
      case Z:
        return (f._context.displayName || "Context") + ".Provider";
      case se:
        var p = f.render;
        return f = f.displayName, f || (f = p.displayName || p.name || "", f = f !== "" ? "ForwardRef(" + f + ")" : "ForwardRef"), f;
      case ce:
        return p = f.displayName || null, p !== null ? p : it(f.type) || "Memo";
      case pe:
        p = f._payload, f = f._init;
        try {
          return it(f(p));
        } catch {
        }
    }
    return null;
  }
  function Ne(f) {
    var p = f.type;
    switch (f.tag) {
      case 24:
        return "Cache";
      case 9:
        return (p.displayName || "Context") + ".Consumer";
      case 10:
        return (p._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return f = p.render, f = f.displayName || f.name || "", p.displayName || (f !== "" ? "ForwardRef(" + f + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return p;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return it(p);
      case 8:
        return p === q ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof p == "function") return p.displayName || p.name || null;
        if (typeof p == "string") return p;
    }
    return null;
  }
  function Xe(f) {
    switch (typeof f) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return f;
      case "object":
        return f;
      default:
        return "";
    }
  }
  function xt(f) {
    var p = f.type;
    return (f = f.nodeName) && f.toLowerCase() === "input" && (p === "checkbox" || p === "radio");
  }
  function rn(f) {
    var p = xt(f) ? "checked" : "value", N = Object.getOwnPropertyDescriptor(f.constructor.prototype, p), O = "" + f[p];
    if (!f.hasOwnProperty(p) && typeof N < "u" && typeof N.get == "function" && typeof N.set == "function") {
      var V = N.get, J = N.set;
      return Object.defineProperty(f, p, { configurable: !0, get: function() {
        return V.call(this);
      }, set: function(me) {
        O = "" + me, J.call(this, me);
      } }), Object.defineProperty(f, p, { enumerable: N.enumerable }), { getValue: function() {
        return O;
      }, setValue: function(me) {
        O = "" + me;
      }, stopTracking: function() {
        f._valueTracker = null, delete f[p];
      } };
    }
  }
  function vt(f) {
    f._valueTracker || (f._valueTracker = rn(f));
  }
  function At(f) {
    if (!f) return !1;
    var p = f._valueTracker;
    if (!p) return !0;
    var N = p.getValue(), O = "";
    return f && (O = xt(f) ? f.checked ? "true" : "false" : f.value), f = O, f !== N ? (p.setValue(f), !0) : !1;
  }
  function He(f) {
    if (f = f || (typeof document < "u" ? document : void 0), typeof f > "u") return null;
    try {
      return f.activeElement || f.body;
    } catch {
      return f.body;
    }
  }
  function Pt(f, p) {
    var N = p.checked;
    return he({}, p, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: N ?? f._wrapperState.initialChecked });
  }
  function Lt(f, p) {
    var N = p.defaultValue == null ? "" : p.defaultValue, O = p.checked != null ? p.checked : p.defaultChecked;
    N = Xe(p.value != null ? p.value : N), f._wrapperState = { initialChecked: O, initialValue: N, controlled: p.type === "checkbox" || p.type === "radio" ? p.checked != null : p.value != null };
  }
  function er(f, p) {
    p = p.checked, p != null && R(f, "checked", p, !1);
  }
  function It(f, p) {
    er(f, p);
    var N = Xe(p.value), O = p.type;
    if (N != null) O === "number" ? (N === 0 && f.value === "" || f.value != N) && (f.value = "" + N) : f.value !== "" + N && (f.value = "" + N);
    else if (O === "submit" || O === "reset") {
      f.removeAttribute("value");
      return;
    }
    p.hasOwnProperty("value") ? ke(f, p.type, N) : p.hasOwnProperty("defaultValue") && ke(f, p.type, Xe(p.defaultValue)), p.checked == null && p.defaultChecked != null && (f.defaultChecked = !!p.defaultChecked);
  }
  function ye(f, p, N) {
    if (p.hasOwnProperty("value") || p.hasOwnProperty("defaultValue")) {
      var O = p.type;
      if (!(O !== "submit" && O !== "reset" || p.value !== void 0 && p.value !== null)) return;
      p = "" + f._wrapperState.initialValue, N || p === f.value || (f.value = p), f.defaultValue = p;
    }
    N = f.name, N !== "" && (f.name = ""), f.defaultChecked = !!f._wrapperState.initialChecked, N !== "" && (f.name = N);
  }
  function ke(f, p, N) {
    (p !== "number" || He(f.ownerDocument) !== f) && (N == null ? f.defaultValue = "" + f._wrapperState.initialValue : f.defaultValue !== "" + N && (f.defaultValue = "" + N));
  }
  var Pe = Array.isArray;
  function tt(f, p, N, O) {
    if (f = f.options, p) {
      p = {};
      for (var V = 0; V < N.length; V++) p["$" + N[V]] = !0;
      for (N = 0; N < f.length; N++) V = p.hasOwnProperty("$" + f[N].value), f[N].selected !== V && (f[N].selected = V), V && O && (f[N].defaultSelected = !0);
    } else {
      for (N = "" + Xe(N), p = null, V = 0; V < f.length; V++) {
        if (f[V].value === N) {
          f[V].selected = !0, O && (f[V].defaultSelected = !0);
          return;
        }
        p !== null || f[V].disabled || (p = f[V]);
      }
      p !== null && (p.selected = !0);
    }
  }
  function ot(f, p) {
    if (p.dangerouslySetInnerHTML != null) throw Error(n(91));
    return he({}, p, { value: void 0, defaultValue: void 0, children: "" + f._wrapperState.initialValue });
  }
  function ut(f, p) {
    var N = p.value;
    if (N == null) {
      if (N = p.children, p = p.defaultValue, N != null) {
        if (p != null) throw Error(n(92));
        if (Pe(N)) {
          if (1 < N.length) throw Error(n(93));
          N = N[0];
        }
        p = N;
      }
      p == null && (p = ""), N = p;
    }
    f._wrapperState = { initialValue: Xe(N) };
  }
  function Vt(f, p) {
    var N = Xe(p.value), O = Xe(p.defaultValue);
    N != null && (N = "" + N, N !== f.value && (f.value = N), p.defaultValue == null && f.defaultValue !== N && (f.defaultValue = N)), O != null && (f.defaultValue = "" + O);
  }
  function bn(f) {
    var p = f.textContent;
    p === f._wrapperState.initialValue && p !== "" && p !== null && (f.value = p);
  }
  function mr(f) {
    switch (f) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function ur(f, p) {
    return f == null || f === "http://www.w3.org/1999/xhtml" ? mr(p) : f === "http://www.w3.org/2000/svg" && p === "foreignObject" ? "http://www.w3.org/1999/xhtml" : f;
  }
  var _r, ai = function(f) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(p, N, O, V) {
      MSApp.execUnsafeLocalFunction(function() {
        return f(p, N, O, V);
      });
    } : f;
  }(function(f, p) {
    if (f.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in f) f.innerHTML = p;
    else {
      for (_r = _r || document.createElement("div"), _r.innerHTML = "<svg>" + p.valueOf().toString() + "</svg>", p = _r.firstChild; f.firstChild; ) f.removeChild(f.firstChild);
      for (; p.firstChild; ) f.appendChild(p.firstChild);
    }
  });
  function ls(f, p) {
    if (p) {
      var N = f.firstChild;
      if (N && N === f.lastChild && N.nodeType === 3) {
        N.nodeValue = p;
        return;
      }
    }
    f.textContent = p;
  }
  var Ot = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, En = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Ot).forEach(function(f) {
    En.forEach(function(p) {
      p = p + f.charAt(0).toUpperCase() + f.substring(1), Ot[p] = Ot[f];
    });
  });
  function Xt(f, p, N) {
    return p == null || typeof p == "boolean" || p === "" ? "" : N || typeof p != "number" || p === 0 || Ot.hasOwnProperty(f) && Ot[f] ? ("" + p).trim() : p + "px";
  }
  function qt(f, p) {
    f = f.style;
    for (var N in p) if (p.hasOwnProperty(N)) {
      var O = N.indexOf("--") === 0, V = Xt(N, p[N], O);
      N === "float" && (N = "cssFloat"), O ? f.setProperty(N, V) : f[N] = V;
    }
  }
  var In = he({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function st(f, p) {
    if (p) {
      if (In[f] && (p.children != null || p.dangerouslySetInnerHTML != null)) throw Error(n(137, f));
      if (p.dangerouslySetInnerHTML != null) {
        if (p.children != null) throw Error(n(60));
        if (typeof p.dangerouslySetInnerHTML != "object" || !("__html" in p.dangerouslySetInnerHTML)) throw Error(n(61));
      }
      if (p.style != null && typeof p.style != "object") throw Error(n(62));
    }
  }
  function lt(f, p) {
    if (f.indexOf("-") === -1) return typeof p.is == "string";
    switch (f) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Nt = null;
  function Wt(f) {
    return f = f.target || f.srcElement || window, f.correspondingUseElement && (f = f.correspondingUseElement), f.nodeType === 3 ? f.parentNode : f;
  }
  var wn = null, pt = null, hr = null;
  function _o(f) {
    if (f = $a(f)) {
      if (typeof wn != "function") throw Error(n(280));
      var p = f.stateNode;
      p && (p = mn(p), wn(f.stateNode, f.type, p));
    }
  }
  function Il(f) {
    pt ? hr ? hr.push(f) : hr = [f] : pt = f;
  }
  function Cr() {
    if (pt) {
      var f = pt, p = hr;
      if (hr = pt = null, _o(f), p) for (f = 0; f < p.length; f++) _o(p[f]);
    }
  }
  function Wi(f, p) {
    return f(p);
  }
  function Yi() {
  }
  var To = !1;
  function qi(f, p, N) {
    if (To) return f(p, N);
    To = !0;
    try {
      return Wi(f, p, N);
    } finally {
      To = !1, (pt !== null || hr !== null) && (Yi(), Cr());
    }
  }
  function Mo(f, p) {
    var N = f.stateNode;
    if (N === null) return null;
    var O = mn(N);
    if (O === null) return null;
    N = O[p];
    e: switch (p) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (O = !O.disabled) || (f = f.type, O = !(f === "button" || f === "input" || f === "select" || f === "textarea")), f = !O;
        break e;
      default:
        f = !1;
    }
    if (f) return null;
    if (N && typeof N != "function") throw Error(n(231, p, typeof N));
    return N;
  }
  var ul = !1;
  if (u) try {
    var dl = {};
    Object.defineProperty(dl, "passive", { get: function() {
      ul = !0;
    } }), window.addEventListener("test", dl, dl), window.removeEventListener("test", dl, dl);
  } catch {
    ul = !1;
  }
  function Dc(f, p, N, O, V, J, me, je, De) {
    var Je = Array.prototype.slice.call(arguments, 3);
    try {
      p.apply(N, Je);
    } catch (Mt) {
      this.onError(Mt);
    }
  }
  var Ro = !1, Do = null, _s = !1, fl = null, _e = { onError: function(f) {
    Ro = !0, Do = f;
  } };
  function _t(f, p, N, O, V, J, me, je, De) {
    Ro = !1, Do = null, Dc.apply(_e, arguments);
  }
  function Kt(f, p, N, O, V, J, me, je, De) {
    if (_t.apply(this, arguments), Ro) {
      if (Ro) {
        var Je = Do;
        Ro = !1, Do = null;
      } else throw Error(n(198));
      _s || (_s = !0, fl = Je);
    }
  }
  function On(f) {
    var p = f, N = f;
    if (f.alternate) for (; p.return; ) p = p.return;
    else {
      f = p;
      do
        p = f, p.flags & 4098 && (N = p.return), f = p.return;
      while (f);
    }
    return p.tag === 3 ? N : null;
  }
  function vr(f) {
    if (f.tag === 13) {
      var p = f.memoizedState;
      if (p === null && (f = f.alternate, f !== null && (p = f.memoizedState)), p !== null) return p.dehydrated;
    }
    return null;
  }
  function Lr(f) {
    if (On(f) !== f) throw Error(n(188));
  }
  function Xn(f) {
    var p = f.alternate;
    if (!p) {
      if (p = On(f), p === null) throw Error(n(188));
      return p !== f ? null : f;
    }
    for (var N = f, O = p; ; ) {
      var V = N.return;
      if (V === null) break;
      var J = V.alternate;
      if (J === null) {
        if (O = V.return, O !== null) {
          N = O;
          continue;
        }
        break;
      }
      if (V.child === J.child) {
        for (J = V.child; J; ) {
          if (J === N) return Lr(V), f;
          if (J === O) return Lr(V), p;
          J = J.sibling;
        }
        throw Error(n(188));
      }
      if (N.return !== O.return) N = V, O = J;
      else {
        for (var me = !1, je = V.child; je; ) {
          if (je === N) {
            me = !0, N = V, O = J;
            break;
          }
          if (je === O) {
            me = !0, O = V, N = J;
            break;
          }
          je = je.sibling;
        }
        if (!me) {
          for (je = J.child; je; ) {
            if (je === N) {
              me = !0, N = J, O = V;
              break;
            }
            if (je === O) {
              me = !0, O = J, N = V;
              break;
            }
            je = je.sibling;
          }
          if (!me) throw Error(n(189));
        }
      }
      if (N.alternate !== O) throw Error(n(190));
    }
    if (N.tag !== 3) throw Error(n(188));
    return N.stateNode.current === N ? f : p;
  }
  function wr(f) {
    return f = Xn(f), f !== null ? Ts(f) : null;
  }
  function Ts(f) {
    if (f.tag === 5 || f.tag === 6) return f;
    for (f = f.child; f !== null; ) {
      var p = Ts(f);
      if (p !== null) return p;
      f = f.sibling;
    }
    return null;
  }
  var pa = t.unstable_scheduleCallback, ga = t.unstable_cancelCallback, Tr = t.unstable_shouldYield, Fn = t.unstable_requestPaint, Gn = t.unstable_now, zr = t.unstable_getCurrentPriorityLevel, ta = t.unstable_ImmediatePriority, ir = t.unstable_UserBlockingPriority, Hs = t.unstable_NormalPriority, Pc = t.unstable_LowPriority, Fl = t.unstable_IdlePriority, Ki = null, Ms = null;
  function xr(f) {
    if (Ms && typeof Ms.onCommitFiberRoot == "function") try {
      Ms.onCommitFiberRoot(Ki, f, void 0, (f.current.flags & 128) === 128);
    } catch {
    }
  }
  var Mr = Math.clz32 ? Math.clz32 : ec, xu = Math.log, Po = Math.LN2;
  function ec(f) {
    return f >>>= 0, f === 0 ? 32 : 31 - (xu(f) / Po | 0) | 0;
  }
  var Yd = 64, Ju = 4194304;
  function fi(f) {
    switch (f & -f) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return f & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return f & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return f;
    }
  }
  function Ul(f, p) {
    var N = f.pendingLanes;
    if (N === 0) return 0;
    var O = 0, V = f.suspendedLanes, J = f.pingedLanes, me = N & 268435455;
    if (me !== 0) {
      var je = me & ~V;
      je !== 0 ? O = fi(je) : (J &= me, J !== 0 && (O = fi(J)));
    } else me = N & ~V, me !== 0 ? O = fi(me) : J !== 0 && (O = fi(J));
    if (O === 0) return 0;
    if (p !== 0 && p !== O && !(p & V) && (V = O & -O, J = p & -p, V >= J || V === 16 && (J & 4194240) !== 0)) return p;
    if (O & 4 && (O |= N & 16), p = f.entangledLanes, p !== 0) for (f = f.entanglements, p &= O; 0 < p; ) N = 31 - Mr(p), V = 1 << N, O |= f[N], p &= ~V;
    return O;
  }
  function P1(f, p) {
    switch (f) {
      case 1:
      case 2:
      case 4:
        return p + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return p + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function fh(f, p) {
    for (var N = f.suspendedLanes, O = f.pingedLanes, V = f.expirationTimes, J = f.pendingLanes; 0 < J; ) {
      var me = 31 - Mr(J), je = 1 << me, De = V[me];
      De === -1 ? (!(je & N) || je & O) && (V[me] = P1(je, p)) : De <= p && (f.expiredLanes |= je), J &= ~je;
    }
  }
  function mh(f) {
    return f = f.pendingLanes & -1073741825, f !== 0 ? f : f & 1073741824 ? 1073741824 : 0;
  }
  function jp() {
    var f = Yd;
    return Yd <<= 1, !(Yd & 4194240) && (Yd = 64), f;
  }
  function Oc(f) {
    for (var p = [], N = 0; 31 > N; N++) p.push(f);
    return p;
  }
  function Rf(f, p, N) {
    f.pendingLanes |= p, p !== 536870912 && (f.suspendedLanes = 0, f.pingedLanes = 0), f = f.eventTimes, p = 31 - Mr(p), f[p] = N;
  }
  function n0(f, p) {
    var N = f.pendingLanes & ~p;
    f.pendingLanes = p, f.suspendedLanes = 0, f.pingedLanes = 0, f.expiredLanes &= p, f.mutableReadLanes &= p, f.entangledLanes &= p, p = f.entanglements;
    var O = f.eventTimes;
    for (f = f.expirationTimes; 0 < N; ) {
      var V = 31 - Mr(N), J = 1 << V;
      p[V] = 0, O[V] = -1, f[V] = -1, N &= ~J;
    }
  }
  function O1(f, p) {
    var N = f.entangledLanes |= p;
    for (f = f.entanglements; N; ) {
      var O = 31 - Mr(N), V = 1 << O;
      V & p | f[O] & p && (f[O] |= p), N &= ~V;
    }
  }
  var Rr = 0;
  function Df(f) {
    return f &= -f, 1 < f ? 4 < f ? f & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var Oo, hh, Qa, rx, A1, Nr = !1, ph = [], Za = null, bu = null, tc = null, la = /* @__PURE__ */ new Map(), Vs = /* @__PURE__ */ new Map(), Va = [], ax = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function ed(f, p) {
    switch (f) {
      case "focusin":
      case "focusout":
        Za = null;
        break;
      case "dragenter":
      case "dragleave":
        bu = null;
        break;
      case "mouseover":
      case "mouseout":
        tc = null;
        break;
      case "pointerover":
      case "pointerout":
        la.delete(p.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Vs.delete(p.pointerId);
    }
  }
  function ml(f, p, N, O, V, J) {
    return f === null || f.nativeEvent !== J ? (f = { blockedOn: p, domEventName: N, eventSystemFlags: O, nativeEvent: J, targetContainers: [V] }, p !== null && (p = $a(p), p !== null && hh(p)), f) : (f.eventSystemFlags |= O, p = f.targetContainers, V !== null && p.indexOf(V) === -1 && p.push(V), f);
  }
  function Rs(f, p, N, O, V) {
    switch (p) {
      case "focusin":
        return Za = ml(Za, f, p, N, O, V), !0;
      case "dragenter":
        return bu = ml(bu, f, p, N, O, V), !0;
      case "mouseover":
        return tc = ml(tc, f, p, N, O, V), !0;
      case "pointerover":
        var J = V.pointerId;
        return la.set(J, ml(la.get(J) || null, f, p, N, O, V)), !0;
      case "gotpointercapture":
        return J = V.pointerId, Vs.set(J, ml(Vs.get(J) || null, f, p, N, O, V)), !0;
    }
    return !1;
  }
  function r0(f) {
    var p = $c(f.target);
    if (p !== null) {
      var N = On(p);
      if (N !== null) {
        if (p = N.tag, p === 13) {
          if (p = vr(N), p !== null) {
            f.blockedOn = p, A1(f.priority, function() {
              Qa(N);
            });
            return;
          }
        } else if (p === 3 && N.stateNode.current.memoizedState.isDehydrated) {
          f.blockedOn = N.tag === 3 ? N.stateNode.containerInfo : null;
          return;
        }
      }
    }
    f.blockedOn = null;
  }
  function Ep(f) {
    if (f.blockedOn !== null) return !1;
    for (var p = f.targetContainers; 0 < p.length; ) {
      var N = I1(f.domEventName, f.eventSystemFlags, p[0], f.nativeEvent);
      if (N === null) {
        N = f.nativeEvent;
        var O = new N.constructor(N.type, N);
        Nt = O, N.target.dispatchEvent(O), Nt = null;
      } else return p = $a(N), p !== null && hh(p), f.blockedOn = N, !1;
      p.shift();
    }
    return !0;
  }
  function L1(f, p, N) {
    Ep(f) && N.delete(p);
  }
  function sx() {
    Nr = !1, Za !== null && Ep(Za) && (Za = null), bu !== null && Ep(bu) && (bu = null), tc !== null && Ep(tc) && (tc = null), la.forEach(L1), Vs.forEach(L1);
  }
  function vm(f, p) {
    f.blockedOn === p && (f.blockedOn = null, Nr || (Nr = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, sx)));
  }
  function nc(f) {
    function p(V) {
      return vm(V, f);
    }
    if (0 < ph.length) {
      vm(ph[0], f);
      for (var N = 1; N < ph.length; N++) {
        var O = ph[N];
        O.blockedOn === f && (O.blockedOn = null);
      }
    }
    for (Za !== null && vm(Za, f), bu !== null && vm(bu, f), tc !== null && vm(tc, f), la.forEach(p), Vs.forEach(p), N = 0; N < Va.length; N++) O = Va[N], O.blockedOn === f && (O.blockedOn = null);
    for (; 0 < Va.length && (N = Va[0], N.blockedOn === null); ) r0(N), N.blockedOn === null && Va.shift();
  }
  var kp = U.ReactCurrentBatchConfig, xm = !0;
  function Su(f, p, N, O) {
    var V = Rr, J = kp.transition;
    kp.transition = null;
    try {
      Rr = 1, gh(f, p, N, O);
    } finally {
      Rr = V, kp.transition = J;
    }
  }
  function wu(f, p, N, O) {
    var V = Rr, J = kp.transition;
    kp.transition = null;
    try {
      Rr = 4, gh(f, p, N, O);
    } finally {
      Rr = V, kp.transition = J;
    }
  }
  function gh(f, p, N, O) {
    if (xm) {
      var V = I1(f, p, N, O);
      if (V === null) Uf(f, p, O, yh, N), ed(f, O);
      else if (Rs(V, f, p, N, O)) O.stopPropagation();
      else if (ed(f, O), p & 4 && -1 < ax.indexOf(f)) {
        for (; V !== null; ) {
          var J = $a(V);
          if (J !== null && Oo(J), J = I1(f, p, N, O), J === null && Uf(f, p, O, yh, N), J === V) break;
          V = J;
        }
        V !== null && O.stopPropagation();
      } else Uf(f, p, O, null, N);
    }
  }
  var yh = null;
  function I1(f, p, N, O) {
    if (yh = null, f = Wt(O), f = $c(f), f !== null) if (p = On(f), p === null) f = null;
    else if (N = p.tag, N === 13) {
      if (f = vr(p), f !== null) return f;
      f = null;
    } else if (N === 3) {
      if (p.stateNode.current.memoizedState.isDehydrated) return p.tag === 3 ? p.stateNode.containerInfo : null;
      f = null;
    } else p !== f && (f = null);
    return yh = f, null;
  }
  function My(f) {
    switch (f) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (zr()) {
          case ta:
            return 1;
          case ir:
            return 4;
          case Hs:
          case Pc:
            return 16;
          case Fl:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Xi = null, td = null, qd = null;
  function bm() {
    if (qd) return qd;
    var f, p = td, N = p.length, O, V = "value" in Xi ? Xi.value : Xi.textContent, J = V.length;
    for (f = 0; f < N && p[f] === V[f]; f++) ;
    var me = N - f;
    for (O = 1; O <= me && p[N - O] === V[J - O]; O++) ;
    return qd = V.slice(f, 1 < O ? 1 - O : void 0);
  }
  function Kd(f) {
    var p = f.keyCode;
    return "charCode" in f ? (f = f.charCode, f === 0 && p === 13 && (f = 13)) : f = p, f === 10 && (f = 13), 32 <= f || f === 13 ? f : 0;
  }
  function Ao() {
    return !0;
  }
  function Ac() {
    return !1;
  }
  function Qi(f) {
    function p(N, O, V, J, me) {
      this._reactName = N, this._targetInst = V, this.type = O, this.nativeEvent = J, this.target = me, this.currentTarget = null;
      for (var je in f) f.hasOwnProperty(je) && (N = f[je], this[je] = N ? N(J) : J[je]);
      return this.isDefaultPrevented = (J.defaultPrevented != null ? J.defaultPrevented : J.returnValue === !1) ? Ao : Ac, this.isPropagationStopped = Ac, this;
    }
    return he(p.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var N = this.nativeEvent;
      N && (N.preventDefault ? N.preventDefault() : typeof N.returnValue != "unknown" && (N.returnValue = !1), this.isDefaultPrevented = Ao);
    }, stopPropagation: function() {
      var N = this.nativeEvent;
      N && (N.stopPropagation ? N.stopPropagation() : typeof N.cancelBubble != "unknown" && (N.cancelBubble = !0), this.isPropagationStopped = Ao);
    }, persist: function() {
    }, isPersistent: Ao }), p;
  }
  var hl = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(f) {
    return f.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Lc = Qi(hl), rc = he({}, hl, { view: 0, detail: 0 }), Ry = Qi(rc), _p, Sm, Lo, Ja = he({}, rc, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: vh, button: 0, buttons: 0, relatedTarget: function(f) {
    return f.relatedTarget === void 0 ? f.fromElement === f.srcElement ? f.toElement : f.fromElement : f.relatedTarget;
  }, movementX: function(f) {
    return "movementX" in f ? f.movementX : (f !== Lo && (Lo && f.type === "mousemove" ? (_p = f.screenX - Lo.screenX, Sm = f.screenY - Lo.screenY) : Sm = _p = 0, Lo = f), _p);
  }, movementY: function(f) {
    return "movementY" in f ? f.movementY : Sm;
  } }), vs = Qi(Ja), Tp = he({}, Ja, { dataTransfer: 0 }), Cu = Qi(Tp), ix = he({}, rc, { relatedTarget: 0 }), Pf = Qi(ix), F1 = he({}, hl, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), a0 = Qi(F1), ox = he({}, hl, { clipboardData: function(f) {
    return "clipboardData" in f ? f.clipboardData : window.clipboardData;
  } }), s0 = Qi(ox), lx = he({}, hl, { data: 0 }), wm = Qi(lx), U1 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, cx = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, z1 = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function ux(f) {
    var p = this.nativeEvent;
    return p.getModifierState ? p.getModifierState(f) : (f = z1[f]) ? !!p[f] : !1;
  }
  function vh() {
    return ux;
  }
  var Nu = he({}, rc, { key: function(f) {
    if (f.key) {
      var p = U1[f.key] || f.key;
      if (p !== "Unidentified") return p;
    }
    return f.type === "keypress" ? (f = Kd(f), f === 13 ? "Enter" : String.fromCharCode(f)) : f.type === "keydown" || f.type === "keyup" ? cx[f.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: vh, charCode: function(f) {
    return f.type === "keypress" ? Kd(f) : 0;
  }, keyCode: function(f) {
    return f.type === "keydown" || f.type === "keyup" ? f.keyCode : 0;
  }, which: function(f) {
    return f.type === "keypress" ? Kd(f) : f.type === "keydown" || f.type === "keyup" ? f.keyCode : 0;
  } }), dx = Qi(Nu), i0 = he({}, Ja, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Of = Qi(i0), o0 = he({}, rc, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: vh }), l0 = Qi(o0), xh = he({}, hl, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), bh = Qi(xh), pl = he({}, Ja, {
    deltaX: function(f) {
      return "deltaX" in f ? f.deltaX : "wheelDeltaX" in f ? -f.wheelDeltaX : 0;
    },
    deltaY: function(f) {
      return "deltaY" in f ? f.deltaY : "wheelDeltaY" in f ? -f.wheelDeltaY : "wheelDelta" in f ? -f.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), zl = Qi(pl), mi = [9, 13, 27, 32], ac = u && "CompositionEvent" in window, Xd = null;
  u && "documentMode" in document && (Xd = document.documentMode);
  var Qd = u && "TextEvent" in window && !Xd, sc = u && (!ac || Xd && 8 < Xd && 11 >= Xd), Ic = " ", B1 = !1;
  function c0(f, p) {
    switch (f) {
      case "keyup":
        return mi.indexOf(p.keyCode) !== -1;
      case "keydown":
        return p.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Fc(f) {
    return f = f.detail, typeof f == "object" && "data" in f ? f.data : null;
  }
  var Uc = !1;
  function H1(f, p) {
    switch (f) {
      case "compositionend":
        return Fc(p);
      case "keypress":
        return p.which !== 32 ? null : (B1 = !0, Ic);
      case "textInput":
        return f = p.data, f === Ic && B1 ? null : f;
      default:
        return null;
    }
  }
  function u0(f, p) {
    if (Uc) return f === "compositionend" || !ac && c0(f, p) ? (f = bm(), qd = td = Xi = null, Uc = !1, f) : null;
    switch (f) {
      case "paste":
        return null;
      case "keypress":
        if (!(p.ctrlKey || p.altKey || p.metaKey) || p.ctrlKey && p.altKey) {
          if (p.char && 1 < p.char.length) return p.char;
          if (p.which) return String.fromCharCode(p.which);
        }
        return null;
      case "compositionend":
        return sc && p.locale !== "ko" ? null : p.data;
      default:
        return null;
    }
  }
  var Io = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function nd(f) {
    var p = f && f.nodeName && f.nodeName.toLowerCase();
    return p === "input" ? !!Io[f.type] : p === "textarea";
  }
  function Cm(f, p, N, O) {
    Il(O), p = Ch(p, "onChange"), 0 < p.length && (N = new Lc("onChange", "change", null, N, O), f.push({ event: N, listeners: p }));
  }
  var Mp = null, rd = null;
  function Sh(f) {
    tf(f, 0);
  }
  function ju(f) {
    var p = hi(f);
    if (At(p)) return f;
  }
  function zc(f, p) {
    if (f === "change") return p;
  }
  var Af = !1;
  if (u) {
    var Lf;
    if (u) {
      var Bc = "oninput" in document;
      if (!Bc) {
        var V1 = document.createElement("div");
        V1.setAttribute("oninput", "return;"), Bc = typeof V1.oninput == "function";
      }
      Lf = Bc;
    } else Lf = !1;
    Af = Lf && (!document.documentMode || 9 < document.documentMode);
  }
  function Zd() {
    Mp && (Mp.detachEvent("onpropertychange", Hc), rd = Mp = null);
  }
  function Hc(f) {
    if (f.propertyName === "value" && ju(rd)) {
      var p = [];
      Cm(p, rd, f, Wt(f)), qi(Sh, p);
    }
  }
  function $1(f, p, N) {
    f === "focusin" ? (Zd(), Mp = p, rd = N, Mp.attachEvent("onpropertychange", Hc)) : f === "focusout" && Zd();
  }
  function Cs(f) {
    if (f === "selectionchange" || f === "keyup" || f === "keydown") return ju(rd);
  }
  function Eu(f, p) {
    if (f === "click") return ju(p);
  }
  function ad(f, p) {
    if (f === "input" || f === "change") return ju(p);
  }
  function yo(f, p) {
    return f === p && (f !== 0 || 1 / f === 1 / p) || f !== f && p !== p;
  }
  var Pa = typeof Object.is == "function" ? Object.is : yo;
  function If(f, p) {
    if (Pa(f, p)) return !0;
    if (typeof f != "object" || f === null || typeof p != "object" || p === null) return !1;
    var N = Object.keys(f), O = Object.keys(p);
    if (N.length !== O.length) return !1;
    for (O = 0; O < N.length; O++) {
      var V = N[O];
      if (!m.call(p, V) || !Pa(f[V], p[V])) return !1;
    }
    return !0;
  }
  function Ii(f) {
    for (; f && f.firstChild; ) f = f.firstChild;
    return f;
  }
  function wa(f, p) {
    var N = Ii(f);
    f = 0;
    for (var O; N; ) {
      if (N.nodeType === 3) {
        if (O = f + N.textContent.length, f <= p && O >= p) return { node: N, offset: p - f };
        f = O;
      }
      e: {
        for (; N; ) {
          if (N.nextSibling) {
            N = N.nextSibling;
            break e;
          }
          N = N.parentNode;
        }
        N = void 0;
      }
      N = Ii(N);
    }
  }
  function es(f, p) {
    return f && p ? f === p ? !0 : f && f.nodeType === 3 ? !1 : p && p.nodeType === 3 ? es(f, p.parentNode) : "contains" in f ? f.contains(p) : f.compareDocumentPosition ? !!(f.compareDocumentPosition(p) & 16) : !1 : !1;
  }
  function si() {
    for (var f = window, p = He(); p instanceof f.HTMLIFrameElement; ) {
      try {
        var N = typeof p.contentWindow.location.href == "string";
      } catch {
        N = !1;
      }
      if (N) f = p.contentWindow;
      else break;
      p = He(f.document);
    }
    return p;
  }
  function Fo(f) {
    var p = f && f.nodeName && f.nodeName.toLowerCase();
    return p && (p === "input" && (f.type === "text" || f.type === "search" || f.type === "tel" || f.type === "url" || f.type === "password") || p === "textarea" || f.contentEditable === "true");
  }
  function Ff(f) {
    var p = si(), N = f.focusedElem, O = f.selectionRange;
    if (p !== N && N && N.ownerDocument && es(N.ownerDocument.documentElement, N)) {
      if (O !== null && Fo(N)) {
        if (p = O.start, f = O.end, f === void 0 && (f = p), "selectionStart" in N) N.selectionStart = p, N.selectionEnd = Math.min(f, N.value.length);
        else if (f = (p = N.ownerDocument || document) && p.defaultView || window, f.getSelection) {
          f = f.getSelection();
          var V = N.textContent.length, J = Math.min(O.start, V);
          O = O.end === void 0 ? J : Math.min(O.end, V), !f.extend && J > O && (V = O, O = J, J = V), V = wa(N, J);
          var me = wa(
            N,
            O
          );
          V && me && (f.rangeCount !== 1 || f.anchorNode !== V.node || f.anchorOffset !== V.offset || f.focusNode !== me.node || f.focusOffset !== me.offset) && (p = p.createRange(), p.setStart(V.node, V.offset), f.removeAllRanges(), J > O ? (f.addRange(p), f.extend(me.node, me.offset)) : (p.setEnd(me.node, me.offset), f.addRange(p)));
        }
      }
      for (p = [], f = N; f = f.parentNode; ) f.nodeType === 1 && p.push({ element: f, left: f.scrollLeft, top: f.scrollTop });
      for (typeof N.focus == "function" && N.focus(), N = 0; N < p.length; N++) f = p[N], f.element.scrollLeft = f.left, f.element.scrollTop = f.top;
    }
  }
  var sd = u && "documentMode" in document && 11 >= document.documentMode, ic = null, xs = null, Jd = null, wh = !1;
  function G1(f, p, N) {
    var O = N.window === N ? N.document : N.nodeType === 9 ? N : N.ownerDocument;
    wh || ic == null || ic !== He(O) || (O = ic, "selectionStart" in O && Fo(O) ? O = { start: O.selectionStart, end: O.selectionEnd } : (O = (O.ownerDocument && O.ownerDocument.defaultView || window).getSelection(), O = { anchorNode: O.anchorNode, anchorOffset: O.anchorOffset, focusNode: O.focusNode, focusOffset: O.focusOffset }), Jd && If(Jd, O) || (Jd = O, O = Ch(xs, "onSelect"), 0 < O.length && (p = new Lc("onSelect", "select", null, p, N), f.push({ event: p, listeners: O }), p.target = ic)));
  }
  function oc(f, p) {
    var N = {};
    return N[f.toLowerCase()] = p.toLowerCase(), N["Webkit" + f] = "webkit" + p, N["Moz" + f] = "moz" + p, N;
  }
  var Ci = { animationend: oc("Animation", "AnimationEnd"), animationiteration: oc("Animation", "AnimationIteration"), animationstart: oc("Animation", "AnimationStart"), transitionend: oc("Transition", "TransitionEnd") }, Nm = {}, W1 = {};
  u && (W1 = document.createElement("div").style, "AnimationEvent" in window || (delete Ci.animationend.animation, delete Ci.animationiteration.animation, delete Ci.animationstart.animation), "TransitionEvent" in window || delete Ci.transitionend.transition);
  function Ds(f) {
    if (Nm[f]) return Nm[f];
    if (!Ci[f]) return f;
    var p = Ci[f], N;
    for (N in p) if (p.hasOwnProperty(N) && N in W1) return Nm[f] = p[N];
    return f;
  }
  var Y1 = Ds("animationend"), Qn = Ds("animationiteration"), na = Ds("animationstart"), Ca = Ds("transitionend"), $s = /* @__PURE__ */ new Map(), ku = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function id(f, p) {
    $s.set(f, p), o(p, [f]);
  }
  for (var Rp = 0; Rp < ku.length; Rp++) {
    var od = ku[Rp], fx = od.toLowerCase(), ef = od[0].toUpperCase() + od.slice(1);
    id(fx, "on" + ef);
  }
  id(Y1, "onAnimationEnd"), id(Qn, "onAnimationIteration"), id(na, "onAnimationStart"), id("dblclick", "onDoubleClick"), id("focusin", "onFocus"), id("focusout", "onBlur"), id(Ca, "onTransitionEnd"), c("onMouseEnter", ["mouseout", "mouseover"]), c("onMouseLeave", ["mouseout", "mouseover"]), c("onPointerEnter", ["pointerout", "pointerover"]), c("onPointerLeave", ["pointerout", "pointerover"]), o("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), o("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), o("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), o("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), o("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), o("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var bt = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Zi = new Set("cancel close invalid load scroll toggle".split(" ").concat(bt));
  function rr(f, p, N) {
    var O = f.type || "unknown-event";
    f.currentTarget = N, Kt(O, p, void 0, f), f.currentTarget = null;
  }
  function tf(f, p) {
    p = (p & 4) !== 0;
    for (var N = 0; N < f.length; N++) {
      var O = f[N], V = O.event;
      O = O.listeners;
      e: {
        var J = void 0;
        if (p) for (var me = O.length - 1; 0 <= me; me--) {
          var je = O[me], De = je.instance, Je = je.currentTarget;
          if (je = je.listener, De !== J && V.isPropagationStopped()) break e;
          rr(V, je, Je), J = De;
        }
        else for (me = 0; me < O.length; me++) {
          if (je = O[me], De = je.instance, Je = je.currentTarget, je = je.listener, De !== J && V.isPropagationStopped()) break e;
          rr(V, je, Je), J = De;
        }
      }
    }
    if (_s) throw f = fl, _s = !1, fl = null, f;
  }
  function ca(f, p) {
    var N = p[_m];
    N === void 0 && (N = p[_m] = /* @__PURE__ */ new Set());
    var O = f + "__bubble";
    N.has(O) || (jm(p, f, 2, !1), N.add(O));
  }
  function Bl(f, p, N) {
    var O = 0;
    p && (O |= 4), jm(N, f, O, p);
  }
  var Ji = "_reactListening" + Math.random().toString(36).slice(2);
  function _u(f) {
    if (!f[Ji]) {
      f[Ji] = !0, r.forEach(function(N) {
        N !== "selectionchange" && (Zi.has(N) || Bl(N, !1, f), Bl(N, !0, f));
      });
      var p = f.nodeType === 9 ? f : f.ownerDocument;
      p === null || p[Ji] || (p[Ji] = !0, Bl("selectionchange", !1, p));
    }
  }
  function jm(f, p, N, O) {
    switch (My(p)) {
      case 1:
        var V = Su;
        break;
      case 4:
        V = wu;
        break;
      default:
        V = gh;
    }
    N = V.bind(null, p, N, f), V = void 0, !ul || p !== "touchstart" && p !== "touchmove" && p !== "wheel" || (V = !0), O ? V !== void 0 ? f.addEventListener(p, N, { capture: !0, passive: V }) : f.addEventListener(p, N, !0) : V !== void 0 ? f.addEventListener(p, N, { passive: V }) : f.addEventListener(p, N, !1);
  }
  function Uf(f, p, N, O, V) {
    var J = O;
    if (!(p & 1) && !(p & 2) && O !== null) e: for (; ; ) {
      if (O === null) return;
      var me = O.tag;
      if (me === 3 || me === 4) {
        var je = O.stateNode.containerInfo;
        if (je === V || je.nodeType === 8 && je.parentNode === V) break;
        if (me === 4) for (me = O.return; me !== null; ) {
          var De = me.tag;
          if ((De === 3 || De === 4) && (De = me.stateNode.containerInfo, De === V || De.nodeType === 8 && De.parentNode === V)) return;
          me = me.return;
        }
        for (; je !== null; ) {
          if (me = $c(je), me === null) return;
          if (De = me.tag, De === 5 || De === 6) {
            O = J = me;
            continue e;
          }
          je = je.parentNode;
        }
      }
      O = O.return;
    }
    qi(function() {
      var Je = J, Mt = Wt(N), Dt = [];
      e: {
        var Tt = $s.get(f);
        if (Tt !== void 0) {
          var vn = Lc, _n = f;
          switch (f) {
            case "keypress":
              if (Kd(N) === 0) break e;
            case "keydown":
            case "keyup":
              vn = dx;
              break;
            case "focusin":
              _n = "focus", vn = Pf;
              break;
            case "focusout":
              _n = "blur", vn = Pf;
              break;
            case "beforeblur":
            case "afterblur":
              vn = Pf;
              break;
            case "click":
              if (N.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              vn = vs;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              vn = Cu;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              vn = l0;
              break;
            case Y1:
            case Qn:
            case na:
              vn = a0;
              break;
            case Ca:
              vn = bh;
              break;
            case "scroll":
              vn = Ry;
              break;
            case "wheel":
              vn = zl;
              break;
            case "copy":
            case "cut":
            case "paste":
              vn = s0;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              vn = Of;
          }
          var An = (p & 4) !== 0, vi = !An && f === "scroll", Ve = An ? Tt !== null ? Tt + "Capture" : null : Tt;
          An = [];
          for (var Oe = Je, Ge; Oe !== null; ) {
            Ge = Oe;
            var zt = Ge.stateNode;
            if (Ge.tag === 5 && zt !== null && (Ge = zt, Ve !== null && (zt = Mo(Oe, Ve), zt != null && An.push(Em(Oe, zt, Ge)))), vi) break;
            Oe = Oe.return;
          }
          0 < An.length && (Tt = new vn(Tt, _n, null, N, Mt), Dt.push({ event: Tt, listeners: An }));
        }
      }
      if (!(p & 7)) {
        e: {
          if (Tt = f === "mouseover" || f === "pointerover", vn = f === "mouseout" || f === "pointerout", Tt && N !== Nt && (_n = N.relatedTarget || N.fromElement) && ($c(_n) || _n[ud])) break e;
          if ((vn || Tt) && (Tt = Mt.window === Mt ? Mt : (Tt = Mt.ownerDocument) ? Tt.defaultView || Tt.parentWindow : window, vn ? (_n = N.relatedTarget || N.toElement, vn = Je, _n = _n ? $c(_n) : null, _n !== null && (vi = On(_n), _n !== vi || _n.tag !== 5 && _n.tag !== 6) && (_n = null)) : (vn = null, _n = Je), vn !== _n)) {
            if (An = vs, zt = "onMouseLeave", Ve = "onMouseEnter", Oe = "mouse", (f === "pointerout" || f === "pointerover") && (An = Of, zt = "onPointerLeave", Ve = "onPointerEnter", Oe = "pointer"), vi = vn == null ? Tt : hi(vn), Ge = _n == null ? Tt : hi(_n), Tt = new An(zt, Oe + "leave", vn, N, Mt), Tt.target = vi, Tt.relatedTarget = Ge, zt = null, $c(Mt) === Je && (An = new An(Ve, Oe + "enter", _n, N, Mt), An.target = Ge, An.relatedTarget = vi, zt = An), vi = zt, vn && _n) t: {
              for (An = vn, Ve = _n, Oe = 0, Ge = An; Ge; Ge = nf(Ge)) Oe++;
              for (Ge = 0, zt = Ve; zt; zt = nf(zt)) Ge++;
              for (; 0 < Oe - Ge; ) An = nf(An), Oe--;
              for (; 0 < Ge - Oe; ) Ve = nf(Ve), Ge--;
              for (; Oe--; ) {
                if (An === Ve || Ve !== null && An === Ve.alternate) break t;
                An = nf(An), Ve = nf(Ve);
              }
              An = null;
            }
            else An = null;
            vn !== null && q1(Dt, Tt, vn, An, !1), _n !== null && vi !== null && q1(Dt, vi, _n, An, !0);
          }
        }
        e: {
          if (Tt = Je ? hi(Je) : window, vn = Tt.nodeName && Tt.nodeName.toLowerCase(), vn === "select" || vn === "input" && Tt.type === "file") var zn = zc;
          else if (nd(Tt)) if (Af) zn = ad;
          else {
            zn = Cs;
            var tr = $1;
          }
          else (vn = Tt.nodeName) && vn.toLowerCase() === "input" && (Tt.type === "checkbox" || Tt.type === "radio") && (zn = Eu);
          if (zn && (zn = zn(f, Je))) {
            Cm(Dt, zn, N, Mt);
            break e;
          }
          tr && tr(f, Tt, Je), f === "focusout" && (tr = Tt._wrapperState) && tr.controlled && Tt.type === "number" && ke(Tt, "number", Tt.value);
        }
        switch (tr = Je ? hi(Je) : window, f) {
          case "focusin":
            (nd(tr) || tr.contentEditable === "true") && (ic = tr, xs = Je, Jd = null);
            break;
          case "focusout":
            Jd = xs = ic = null;
            break;
          case "mousedown":
            wh = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            wh = !1, G1(Dt, N, Mt);
            break;
          case "selectionchange":
            if (sd) break;
          case "keydown":
          case "keyup":
            G1(Dt, N, Mt);
        }
        var Rn;
        if (ac) e: {
          switch (f) {
            case "compositionstart":
              var sr = "onCompositionStart";
              break e;
            case "compositionend":
              sr = "onCompositionEnd";
              break e;
            case "compositionupdate":
              sr = "onCompositionUpdate";
              break e;
          }
          sr = void 0;
        }
        else Uc ? c0(f, N) && (sr = "onCompositionEnd") : f === "keydown" && N.keyCode === 229 && (sr = "onCompositionStart");
        sr && (sc && N.locale !== "ko" && (Uc || sr !== "onCompositionStart" ? sr === "onCompositionEnd" && Uc && (Rn = bm()) : (Xi = Mt, td = "value" in Xi ? Xi.value : Xi.textContent, Uc = !0)), tr = Ch(Je, sr), 0 < tr.length && (sr = new wm(sr, f, null, N, Mt), Dt.push({ event: sr, listeners: tr }), Rn ? sr.data = Rn : (Rn = Fc(N), Rn !== null && (sr.data = Rn)))), (Rn = Qd ? H1(f, N) : u0(f, N)) && (Je = Ch(Je, "onBeforeInput"), 0 < Je.length && (Mt = new wm("onBeforeInput", "beforeinput", null, N, Mt), Dt.push({ event: Mt, listeners: Je }), Mt.data = Rn));
      }
      tf(Dt, p);
    });
  }
  function Em(f, p, N) {
    return { instance: f, listener: p, currentTarget: N };
  }
  function Ch(f, p) {
    for (var N = p + "Capture", O = []; f !== null; ) {
      var V = f, J = V.stateNode;
      V.tag === 5 && J !== null && (V = J, J = Mo(f, N), J != null && O.unshift(Em(f, J, V)), J = Mo(f, p), J != null && O.push(Em(f, J, V))), f = f.return;
    }
    return O;
  }
  function nf(f) {
    if (f === null) return null;
    do
      f = f.return;
    while (f && f.tag !== 5);
    return f || null;
  }
  function q1(f, p, N, O, V) {
    for (var J = p._reactName, me = []; N !== null && N !== O; ) {
      var je = N, De = je.alternate, Je = je.stateNode;
      if (De !== null && De === O) break;
      je.tag === 5 && Je !== null && (je = Je, V ? (De = Mo(N, J), De != null && me.unshift(Em(N, De, je))) : V || (De = Mo(N, J), De != null && me.push(Em(N, De, je)))), N = N.return;
    }
    me.length !== 0 && f.push({ event: p, listeners: me });
  }
  var K1 = /\r\n?/g, d0 = /\u0000|\uFFFD/g;
  function Dp(f) {
    return (typeof f == "string" ? f : "" + f).replace(K1, `
`).replace(d0, "");
  }
  function Nh(f, p, N) {
    if (p = Dp(p), Dp(f) !== p && N) throw Error(n(425));
  }
  function zf() {
  }
  var X1 = null, Bf = null;
  function jh(f, p) {
    return f === "textarea" || f === "noscript" || typeof p.children == "string" || typeof p.children == "number" || typeof p.dangerouslySetInnerHTML == "object" && p.dangerouslySetInnerHTML !== null && p.dangerouslySetInnerHTML.__html != null;
  }
  var eo = typeof setTimeout == "function" ? setTimeout : void 0, Pp = typeof clearTimeout == "function" ? clearTimeout : void 0, km = typeof Promise == "function" ? Promise : void 0, Eh = typeof queueMicrotask == "function" ? queueMicrotask : typeof km < "u" ? function(f) {
    return km.resolve(null).then(f).catch(kh);
  } : eo;
  function kh(f) {
    setTimeout(function() {
      throw f;
    });
  }
  function ld(f, p) {
    var N = p, O = 0;
    do {
      var V = N.nextSibling;
      if (f.removeChild(N), V && V.nodeType === 8) if (N = V.data, N === "/$") {
        if (O === 0) {
          f.removeChild(V), nc(p);
          return;
        }
        O--;
      } else N !== "$" && N !== "$?" && N !== "$!" || O++;
      N = V;
    } while (N);
    nc(p);
  }
  function Hl(f) {
    for (; f != null; f = f.nextSibling) {
      var p = f.nodeType;
      if (p === 1 || p === 3) break;
      if (p === 8) {
        if (p = f.data, p === "$" || p === "$!" || p === "$?") break;
        if (p === "/$") return null;
      }
    }
    return f;
  }
  function Tu(f) {
    f = f.previousSibling;
    for (var p = 0; f; ) {
      if (f.nodeType === 8) {
        var N = f.data;
        if (N === "$" || N === "$!" || N === "$?") {
          if (p === 0) return f;
          p--;
        } else N === "/$" && p++;
      }
      f = f.previousSibling;
    }
    return null;
  }
  var Mu = Math.random().toString(36).slice(2), Vc = "__reactFiber$" + Mu, cd = "__reactProps$" + Mu, ud = "__reactContainer$" + Mu, _m = "__reactEvents$" + Mu, Tm = "__reactListeners$" + Mu, gl = "__reactHandles$" + Mu;
  function $c(f) {
    var p = f[Vc];
    if (p) return p;
    for (var N = f.parentNode; N; ) {
      if (p = N[ud] || N[Vc]) {
        if (N = p.alternate, p.child !== null || N !== null && N.child !== null) for (f = Tu(f); f !== null; ) {
          if (N = f[Vc]) return N;
          f = Tu(f);
        }
        return p;
      }
      f = N, N = f.parentNode;
    }
    return null;
  }
  function $a(f) {
    return f = f[Vc] || f[ud], !f || f.tag !== 5 && f.tag !== 6 && f.tag !== 13 && f.tag !== 3 ? null : f;
  }
  function hi(f) {
    if (f.tag === 5 || f.tag === 6) return f.stateNode;
    throw Error(n(33));
  }
  function mn(f) {
    return f[cd] || null;
  }
  var Gc = [], ts = -1;
  function Dr(f) {
    return { current: f };
  }
  function Na(f) {
    0 > ts || (f.current = Gc[ts], Gc[ts] = null, ts--);
  }
  function Oa(f, p) {
    ts++, Gc[ts] = f.current, f.current = p;
  }
  var Ru = {}, or = Dr(Ru), Gs = Dr(!1), Uo = Ru;
  function lc(f, p) {
    var N = f.type.contextTypes;
    if (!N) return Ru;
    var O = f.stateNode;
    if (O && O.__reactInternalMemoizedUnmaskedChildContext === p) return O.__reactInternalMemoizedMaskedChildContext;
    var V = {}, J;
    for (J in N) V[J] = p[J];
    return O && (f = f.stateNode, f.__reactInternalMemoizedUnmaskedChildContext = p, f.__reactInternalMemoizedMaskedChildContext = V), V;
  }
  function Ns(f) {
    return f = f.childContextTypes, f != null;
  }
  function cc() {
    Na(Gs), Na(or);
  }
  function Du(f, p, N) {
    if (or.current !== Ru) throw Error(n(168));
    Oa(or, p), Oa(Gs, N);
  }
  function _h(f, p, N) {
    var O = f.stateNode;
    if (p = p.childContextTypes, typeof O.getChildContext != "function") return N;
    O = O.getChildContext();
    for (var V in O) if (!(V in p)) throw Error(n(108, Ne(f) || "Unknown", V));
    return he({}, N, O);
  }
  function Mm(f) {
    return f = (f = f.stateNode) && f.__reactInternalMemoizedMergedChildContext || Ru, Uo = or.current, Oa(or, f), Oa(Gs, Gs.current), !0;
  }
  function Dy(f, p, N) {
    var O = f.stateNode;
    if (!O) throw Error(n(169));
    N ? (f = _h(f, p, Uo), O.__reactInternalMemoizedMergedChildContext = f, Na(Gs), Na(or), Oa(or, f)) : Na(Gs), Oa(Gs, N);
  }
  var uc = null, js = !1, rf = !1;
  function Pu(f) {
    uc === null ? uc = [f] : uc.push(f);
  }
  function Wc(f) {
    js = !0, Pu(f);
  }
  function Es() {
    if (!rf && uc !== null) {
      rf = !0;
      var f = 0, p = Rr;
      try {
        var N = uc;
        for (Rr = 1; f < N.length; f++) {
          var O = N[f];
          do
            O = O(!0);
          while (O !== null);
        }
        uc = null, js = !1;
      } catch (V) {
        throw uc !== null && (uc = uc.slice(f + 1)), pa(ta, Es), V;
      } finally {
        Rr = p, rf = !1;
      }
    }
    return null;
  }
  var pi = [], Wn = 0, dc = null, dd = 0, yl = [], to = 0, Vl = null, Ps = 1, Ws = "";
  function fc(f, p) {
    pi[Wn++] = dd, pi[Wn++] = dc, dc = f, dd = p;
  }
  function Py(f, p, N) {
    yl[to++] = Ps, yl[to++] = Ws, yl[to++] = Vl, Vl = f;
    var O = Ps;
    f = Ws;
    var V = 32 - Mr(O) - 1;
    O &= ~(1 << V), N += 1;
    var J = 32 - Mr(p) + V;
    if (30 < J) {
      var me = V - V % 5;
      J = (O & (1 << me) - 1).toString(32), O >>= me, V -= me, Ps = 1 << 32 - Mr(p) + V | N << V | O, Ws = J + f;
    } else Ps = 1 << J | N << V | O, Ws = f;
  }
  function Hf(f) {
    f.return !== null && (fc(f, 1), Py(f, 1, 0));
  }
  function vo(f) {
    for (; f === dc; ) dc = pi[--Wn], pi[Wn] = null, dd = pi[--Wn], pi[Wn] = null;
    for (; f === Vl; ) Vl = yl[--to], yl[to] = null, Ws = yl[--to], yl[to] = null, Ps = yl[--to], yl[to] = null;
  }
  var mc = null, tn = null, Aa = !1, ii = null;
  function Rm(f, p) {
    var N = wc(5, null, null, 0);
    N.elementType = "DELETED", N.stateNode = p, N.return = f, p = f.deletions, p === null ? (f.deletions = [N], f.flags |= 16) : p.push(N);
  }
  function Op(f, p) {
    switch (f.tag) {
      case 5:
        var N = f.type;
        return p = p.nodeType !== 1 || N.toLowerCase() !== p.nodeName.toLowerCase() ? null : p, p !== null ? (f.stateNode = p, mc = f, tn = Hl(p.firstChild), !0) : !1;
      case 6:
        return p = f.pendingProps === "" || p.nodeType !== 3 ? null : p, p !== null ? (f.stateNode = p, mc = f, tn = null, !0) : !1;
      case 13:
        return p = p.nodeType !== 8 ? null : p, p !== null ? (N = Vl !== null ? { id: Ps, overflow: Ws } : null, f.memoizedState = { dehydrated: p, treeContext: N, retryLane: 1073741824 }, N = wc(18, null, null, 0), N.stateNode = p, N.return = f, f.child = N, mc = f, tn = null, !0) : !1;
      default:
        return !1;
    }
  }
  function af(f) {
    return (f.mode & 1) !== 0 && (f.flags & 128) === 0;
  }
  function fd(f) {
    if (Aa) {
      var p = tn;
      if (p) {
        var N = p;
        if (!Op(f, p)) {
          if (af(f)) throw Error(n(418));
          p = Hl(N.nextSibling);
          var O = mc;
          p && Op(f, p) ? Rm(O, N) : (f.flags = f.flags & -4097 | 2, Aa = !1, mc = f);
        }
      } else {
        if (af(f)) throw Error(n(418));
        f.flags = f.flags & -4097 | 2, Aa = !1, mc = f;
      }
    }
  }
  function hc(f) {
    for (f = f.return; f !== null && f.tag !== 5 && f.tag !== 3 && f.tag !== 13; ) f = f.return;
    mc = f;
  }
  function gi(f) {
    if (f !== mc) return !1;
    if (!Aa) return hc(f), Aa = !0, !1;
    var p;
    if ((p = f.tag !== 3) && !(p = f.tag !== 5) && (p = f.type, p = p !== "head" && p !== "body" && !jh(f.type, f.memoizedProps)), p && (p = tn)) {
      if (af(f)) throw Oy(), Error(n(418));
      for (; p; ) Rm(f, p), p = Hl(p.nextSibling);
    }
    if (hc(f), f.tag === 13) {
      if (f = f.memoizedState, f = f !== null ? f.dehydrated : null, !f) throw Error(n(317));
      e: {
        for (f = f.nextSibling, p = 0; f; ) {
          if (f.nodeType === 8) {
            var N = f.data;
            if (N === "/$") {
              if (p === 0) {
                tn = Hl(f.nextSibling);
                break e;
              }
              p--;
            } else N !== "$" && N !== "$!" && N !== "$?" || p++;
          }
          f = f.nextSibling;
        }
        tn = null;
      }
    } else tn = mc ? Hl(f.stateNode.nextSibling) : null;
    return !0;
  }
  function Oy() {
    for (var f = tn; f; ) f = Hl(f.nextSibling);
  }
  function Ys() {
    tn = mc = null, Aa = !1;
  }
  function Q1(f) {
    ii === null ? ii = [f] : ii.push(f);
  }
  var Th = U.ReactCurrentBatchConfig;
  function qs(f, p, N) {
    if (f = N.ref, f !== null && typeof f != "function" && typeof f != "object") {
      if (N._owner) {
        if (N = N._owner, N) {
          if (N.tag !== 1) throw Error(n(309));
          var O = N.stateNode;
        }
        if (!O) throw Error(n(147, f));
        var V = O, J = "" + f;
        return p !== null && p.ref !== null && typeof p.ref == "function" && p.ref._stringRef === J ? p.ref : (p = function(me) {
          var je = V.refs;
          me === null ? delete je[J] : je[J] = me;
        }, p._stringRef = J, p);
      }
      if (typeof f != "string") throw Error(n(284));
      if (!N._owner) throw Error(n(290, f));
    }
    return f;
  }
  function Ni(f, p) {
    throw f = Object.prototype.toString.call(p), Error(n(31, f === "[object Object]" ? "object with keys {" + Object.keys(p).join(", ") + "}" : f));
  }
  function md(f) {
    var p = f._init;
    return p(f._payload);
  }
  function Ap(f) {
    function p(Ve, Oe) {
      if (f) {
        var Ge = Ve.deletions;
        Ge === null ? (Ve.deletions = [Oe], Ve.flags |= 16) : Ge.push(Oe);
      }
    }
    function N(Ve, Oe) {
      if (!f) return null;
      for (; Oe !== null; ) p(Ve, Oe), Oe = Oe.sibling;
      return null;
    }
    function O(Ve, Oe) {
      for (Ve = /* @__PURE__ */ new Map(); Oe !== null; ) Oe.key !== null ? Ve.set(Oe.key, Oe) : Ve.set(Oe.index, Oe), Oe = Oe.sibling;
      return Ve;
    }
    function V(Ve, Oe) {
      return Ve = zu(Ve, Oe), Ve.index = 0, Ve.sibling = null, Ve;
    }
    function J(Ve, Oe, Ge) {
      return Ve.index = Ge, f ? (Ge = Ve.alternate, Ge !== null ? (Ge = Ge.index, Ge < Oe ? (Ve.flags |= 2, Oe) : Ge) : (Ve.flags |= 2, Oe)) : (Ve.flags |= 1048576, Oe);
    }
    function me(Ve) {
      return f && Ve.alternate === null && (Ve.flags |= 2), Ve;
    }
    function je(Ve, Oe, Ge, zt) {
      return Oe === null || Oe.tag !== 6 ? (Oe = cg(Ge, Ve.mode, zt), Oe.return = Ve, Oe) : (Oe = V(Oe, Ge), Oe.return = Ve, Oe);
    }
    function De(Ve, Oe, Ge, zt) {
      var zn = Ge.type;
      return zn === K ? Mt(Ve, Oe, Ge.props.children, zt, Ge.key) : Oe !== null && (Oe.elementType === zn || typeof zn == "object" && zn !== null && zn.$$typeof === pe && md(zn) === Oe.type) ? (zt = V(Oe, Ge.props), zt.ref = qs(Ve, Oe, Ge), zt.return = Ve, zt) : (zt = La(Ge.type, Ge.key, Ge.props, null, Ve.mode, zt), zt.ref = qs(Ve, Oe, Ge), zt.return = Ve, zt);
    }
    function Je(Ve, Oe, Ge, zt) {
      return Oe === null || Oe.tag !== 4 || Oe.stateNode.containerInfo !== Ge.containerInfo || Oe.stateNode.implementation !== Ge.implementation ? (Oe = Bh(Ge, Ve.mode, zt), Oe.return = Ve, Oe) : (Oe = V(Oe, Ge.children || []), Oe.return = Ve, Oe);
    }
    function Mt(Ve, Oe, Ge, zt, zn) {
      return Oe === null || Oe.tag !== 7 ? (Oe = li(Ge, Ve.mode, zt, zn), Oe.return = Ve, Oe) : (Oe = V(Oe, Ge), Oe.return = Ve, Oe);
    }
    function Dt(Ve, Oe, Ge) {
      if (typeof Oe == "string" && Oe !== "" || typeof Oe == "number") return Oe = cg("" + Oe, Ve.mode, Ge), Oe.return = Ve, Oe;
      if (typeof Oe == "object" && Oe !== null) {
        switch (Oe.$$typeof) {
          case z:
            return Ge = La(Oe.type, Oe.key, Oe.props, null, Ve.mode, Ge), Ge.ref = qs(Ve, null, Oe), Ge.return = Ve, Ge;
          case H:
            return Oe = Bh(Oe, Ve.mode, Ge), Oe.return = Ve, Oe;
          case pe:
            var zt = Oe._init;
            return Dt(Ve, zt(Oe._payload), Ge);
        }
        if (Pe(Oe) || ue(Oe)) return Oe = li(Oe, Ve.mode, Ge, null), Oe.return = Ve, Oe;
        Ni(Ve, Oe);
      }
      return null;
    }
    function Tt(Ve, Oe, Ge, zt) {
      var zn = Oe !== null ? Oe.key : null;
      if (typeof Ge == "string" && Ge !== "" || typeof Ge == "number") return zn !== null ? null : je(Ve, Oe, "" + Ge, zt);
      if (typeof Ge == "object" && Ge !== null) {
        switch (Ge.$$typeof) {
          case z:
            return Ge.key === zn ? De(Ve, Oe, Ge, zt) : null;
          case H:
            return Ge.key === zn ? Je(Ve, Oe, Ge, zt) : null;
          case pe:
            return zn = Ge._init, Tt(
              Ve,
              Oe,
              zn(Ge._payload),
              zt
            );
        }
        if (Pe(Ge) || ue(Ge)) return zn !== null ? null : Mt(Ve, Oe, Ge, zt, null);
        Ni(Ve, Ge);
      }
      return null;
    }
    function vn(Ve, Oe, Ge, zt, zn) {
      if (typeof zt == "string" && zt !== "" || typeof zt == "number") return Ve = Ve.get(Ge) || null, je(Oe, Ve, "" + zt, zn);
      if (typeof zt == "object" && zt !== null) {
        switch (zt.$$typeof) {
          case z:
            return Ve = Ve.get(zt.key === null ? Ge : zt.key) || null, De(Oe, Ve, zt, zn);
          case H:
            return Ve = Ve.get(zt.key === null ? Ge : zt.key) || null, Je(Oe, Ve, zt, zn);
          case pe:
            var tr = zt._init;
            return vn(Ve, Oe, Ge, tr(zt._payload), zn);
        }
        if (Pe(zt) || ue(zt)) return Ve = Ve.get(Ge) || null, Mt(Oe, Ve, zt, zn, null);
        Ni(Oe, zt);
      }
      return null;
    }
    function _n(Ve, Oe, Ge, zt) {
      for (var zn = null, tr = null, Rn = Oe, sr = Oe = 0, No = null; Rn !== null && sr < Ge.length; sr++) {
        Rn.index > sr ? (No = Rn, Rn = null) : No = Rn.sibling;
        var ka = Tt(Ve, Rn, Ge[sr], zt);
        if (ka === null) {
          Rn === null && (Rn = No);
          break;
        }
        f && Rn && ka.alternate === null && p(Ve, Rn), Oe = J(ka, Oe, sr), tr === null ? zn = ka : tr.sibling = ka, tr = ka, Rn = No;
      }
      if (sr === Ge.length) return N(Ve, Rn), Aa && fc(Ve, sr), zn;
      if (Rn === null) {
        for (; sr < Ge.length; sr++) Rn = Dt(Ve, Ge[sr], zt), Rn !== null && (Oe = J(Rn, Oe, sr), tr === null ? zn = Rn : tr.sibling = Rn, tr = Rn);
        return Aa && fc(Ve, sr), zn;
      }
      for (Rn = O(Ve, Rn); sr < Ge.length; sr++) No = vn(Rn, Ve, sr, Ge[sr], zt), No !== null && (f && No.alternate !== null && Rn.delete(No.key === null ? sr : No.key), Oe = J(No, Oe, sr), tr === null ? zn = No : tr.sibling = No, tr = No);
      return f && Rn.forEach(function(ff) {
        return p(Ve, ff);
      }), Aa && fc(Ve, sr), zn;
    }
    function An(Ve, Oe, Ge, zt) {
      var zn = ue(Ge);
      if (typeof zn != "function") throw Error(n(150));
      if (Ge = zn.call(Ge), Ge == null) throw Error(n(151));
      for (var tr = zn = null, Rn = Oe, sr = Oe = 0, No = null, ka = Ge.next(); Rn !== null && !ka.done; sr++, ka = Ge.next()) {
        Rn.index > sr ? (No = Rn, Rn = null) : No = Rn.sibling;
        var ff = Tt(Ve, Rn, ka.value, zt);
        if (ff === null) {
          Rn === null && (Rn = No);
          break;
        }
        f && Rn && ff.alternate === null && p(Ve, Rn), Oe = J(ff, Oe, sr), tr === null ? zn = ff : tr.sibling = ff, tr = ff, Rn = No;
      }
      if (ka.done) return N(
        Ve,
        Rn
      ), Aa && fc(Ve, sr), zn;
      if (Rn === null) {
        for (; !ka.done; sr++, ka = Ge.next()) ka = Dt(Ve, ka.value, zt), ka !== null && (Oe = J(ka, Oe, sr), tr === null ? zn = ka : tr.sibling = ka, tr = ka);
        return Aa && fc(Ve, sr), zn;
      }
      for (Rn = O(Ve, Rn); !ka.done; sr++, ka = Ge.next()) ka = vn(Rn, Ve, sr, ka.value, zt), ka !== null && (f && ka.alternate !== null && Rn.delete(ka.key === null ? sr : ka.key), Oe = J(ka, Oe, sr), tr === null ? zn = ka : tr.sibling = ka, tr = ka);
      return f && Rn.forEach(function(Ow) {
        return p(Ve, Ow);
      }), Aa && fc(Ve, sr), zn;
    }
    function vi(Ve, Oe, Ge, zt) {
      if (typeof Ge == "object" && Ge !== null && Ge.type === K && Ge.key === null && (Ge = Ge.props.children), typeof Ge == "object" && Ge !== null) {
        switch (Ge.$$typeof) {
          case z:
            e: {
              for (var zn = Ge.key, tr = Oe; tr !== null; ) {
                if (tr.key === zn) {
                  if (zn = Ge.type, zn === K) {
                    if (tr.tag === 7) {
                      N(Ve, tr.sibling), Oe = V(tr, Ge.props.children), Oe.return = Ve, Ve = Oe;
                      break e;
                    }
                  } else if (tr.elementType === zn || typeof zn == "object" && zn !== null && zn.$$typeof === pe && md(zn) === tr.type) {
                    N(Ve, tr.sibling), Oe = V(tr, Ge.props), Oe.ref = qs(Ve, tr, Ge), Oe.return = Ve, Ve = Oe;
                    break e;
                  }
                  N(Ve, tr);
                  break;
                } else p(Ve, tr);
                tr = tr.sibling;
              }
              Ge.type === K ? (Oe = li(Ge.props.children, Ve.mode, zt, Ge.key), Oe.return = Ve, Ve = Oe) : (zt = La(Ge.type, Ge.key, Ge.props, null, Ve.mode, zt), zt.ref = qs(Ve, Oe, Ge), zt.return = Ve, Ve = zt);
            }
            return me(Ve);
          case H:
            e: {
              for (tr = Ge.key; Oe !== null; ) {
                if (Oe.key === tr) if (Oe.tag === 4 && Oe.stateNode.containerInfo === Ge.containerInfo && Oe.stateNode.implementation === Ge.implementation) {
                  N(Ve, Oe.sibling), Oe = V(Oe, Ge.children || []), Oe.return = Ve, Ve = Oe;
                  break e;
                } else {
                  N(Ve, Oe);
                  break;
                }
                else p(Ve, Oe);
                Oe = Oe.sibling;
              }
              Oe = Bh(Ge, Ve.mode, zt), Oe.return = Ve, Ve = Oe;
            }
            return me(Ve);
          case pe:
            return tr = Ge._init, vi(Ve, Oe, tr(Ge._payload), zt);
        }
        if (Pe(Ge)) return _n(Ve, Oe, Ge, zt);
        if (ue(Ge)) return An(Ve, Oe, Ge, zt);
        Ni(Ve, Ge);
      }
      return typeof Ge == "string" && Ge !== "" || typeof Ge == "number" ? (Ge = "" + Ge, Oe !== null && Oe.tag === 6 ? (N(Ve, Oe.sibling), Oe = V(Oe, Ge), Oe.return = Ve, Ve = Oe) : (N(Ve, Oe), Oe = cg(Ge, Ve.mode, zt), Oe.return = Ve, Ve = Oe), me(Ve)) : N(Ve, Oe);
    }
    return vi;
  }
  var Mh = Ap(!0), ns = Ap(!1), Yc = Dr(null), rs = null, Zt = null, pc = null;
  function gc() {
    pc = Zt = rs = null;
  }
  function f0(f) {
    var p = Yc.current;
    Na(Yc), f._currentValue = p;
  }
  function Vf(f, p, N) {
    for (; f !== null; ) {
      var O = f.alternate;
      if ((f.childLanes & p) !== p ? (f.childLanes |= p, O !== null && (O.childLanes |= p)) : O !== null && (O.childLanes & p) !== p && (O.childLanes |= p), f === N) break;
      f = f.return;
    }
  }
  function Ks(f, p) {
    rs = f, pc = Zt = null, f = f.dependencies, f !== null && f.firstContext !== null && (f.lanes & p && (ne = !0), f.firstContext = null);
  }
  function Yt(f) {
    var p = f._currentValue;
    if (pc !== f) if (f = { context: f, memoizedValue: p, next: null }, Zt === null) {
      if (rs === null) throw Error(n(308));
      Zt = f, rs.dependencies = { lanes: 0, firstContext: f };
    } else Zt = Zt.next = f;
    return p;
  }
  var no = null;
  function ya(f) {
    no === null ? no = [f] : no.push(f);
  }
  function Z1(f, p, N, O) {
    var V = p.interleaved;
    return V === null ? (N.next = N, ya(p)) : (N.next = V.next, V.next = N), p.interleaved = N, qc(f, O);
  }
  function qc(f, p) {
    f.lanes |= p;
    var N = f.alternate;
    for (N !== null && (N.lanes |= p), N = f, f = f.return; f !== null; ) f.childLanes |= p, N = f.alternate, N !== null && (N.childLanes |= p), N = f, f = f.return;
    return N.tag === 3 ? N.stateNode : null;
  }
  var sf = !1;
  function Lp(f) {
    f.updateQueue = { baseState: f.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function Dm(f, p) {
    f = f.updateQueue, p.updateQueue === f && (p.updateQueue = { baseState: f.baseState, firstBaseUpdate: f.firstBaseUpdate, lastBaseUpdate: f.lastBaseUpdate, shared: f.shared, effects: f.effects });
  }
  function ja(f, p) {
    return { eventTime: f, lane: p, tag: 0, payload: null, callback: null, next: null };
  }
  function of(f, p, N) {
    var O = f.updateQueue;
    if (O === null) return null;
    if (O = O.shared, ra & 2) {
      var V = O.pending;
      return V === null ? p.next = p : (p.next = V.next, V.next = p), O.pending = p, qc(f, N);
    }
    return V = O.interleaved, V === null ? (p.next = p, ya(O)) : (p.next = V.next, V.next = p), O.interleaved = p, qc(f, N);
  }
  function m0(f, p, N) {
    if (p = p.updateQueue, p !== null && (p = p.shared, (N & 4194240) !== 0)) {
      var O = p.lanes;
      O &= f.pendingLanes, N |= O, p.lanes = N, O1(f, N);
    }
  }
  function J1(f, p) {
    var N = f.updateQueue, O = f.alternate;
    if (O !== null && (O = O.updateQueue, N === O)) {
      var V = null, J = null;
      if (N = N.firstBaseUpdate, N !== null) {
        do {
          var me = { eventTime: N.eventTime, lane: N.lane, tag: N.tag, payload: N.payload, callback: N.callback, next: null };
          J === null ? V = J = me : J = J.next = me, N = N.next;
        } while (N !== null);
        J === null ? V = J = p : J = J.next = p;
      } else V = J = p;
      N = { baseState: O.baseState, firstBaseUpdate: V, lastBaseUpdate: J, shared: O.shared, effects: O.effects }, f.updateQueue = N;
      return;
    }
    f = N.lastBaseUpdate, f === null ? N.firstBaseUpdate = p : f.next = p, N.lastBaseUpdate = p;
  }
  function Rh(f, p, N, O) {
    var V = f.updateQueue;
    sf = !1;
    var J = V.firstBaseUpdate, me = V.lastBaseUpdate, je = V.shared.pending;
    if (je !== null) {
      V.shared.pending = null;
      var De = je, Je = De.next;
      De.next = null, me === null ? J = Je : me.next = Je, me = De;
      var Mt = f.alternate;
      Mt !== null && (Mt = Mt.updateQueue, je = Mt.lastBaseUpdate, je !== me && (je === null ? Mt.firstBaseUpdate = Je : je.next = Je, Mt.lastBaseUpdate = De));
    }
    if (J !== null) {
      var Dt = V.baseState;
      me = 0, Mt = Je = De = null, je = J;
      do {
        var Tt = je.lane, vn = je.eventTime;
        if ((O & Tt) === Tt) {
          Mt !== null && (Mt = Mt.next = {
            eventTime: vn,
            lane: 0,
            tag: je.tag,
            payload: je.payload,
            callback: je.callback,
            next: null
          });
          e: {
            var _n = f, An = je;
            switch (Tt = p, vn = N, An.tag) {
              case 1:
                if (_n = An.payload, typeof _n == "function") {
                  Dt = _n.call(vn, Dt, Tt);
                  break e;
                }
                Dt = _n;
                break e;
              case 3:
                _n.flags = _n.flags & -65537 | 128;
              case 0:
                if (_n = An.payload, Tt = typeof _n == "function" ? _n.call(vn, Dt, Tt) : _n, Tt == null) break e;
                Dt = he({}, Dt, Tt);
                break e;
              case 2:
                sf = !0;
            }
          }
          je.callback !== null && je.lane !== 0 && (f.flags |= 64, Tt = V.effects, Tt === null ? V.effects = [je] : Tt.push(je));
        } else vn = { eventTime: vn, lane: Tt, tag: je.tag, payload: je.payload, callback: je.callback, next: null }, Mt === null ? (Je = Mt = vn, De = Dt) : Mt = Mt.next = vn, me |= Tt;
        if (je = je.next, je === null) {
          if (je = V.shared.pending, je === null) break;
          Tt = je, je = Tt.next, Tt.next = null, V.lastBaseUpdate = Tt, V.shared.pending = null;
        }
      } while (!0);
      if (Mt === null && (De = Dt), V.baseState = De, V.firstBaseUpdate = Je, V.lastBaseUpdate = Mt, p = V.shared.interleaved, p !== null) {
        V = p;
        do
          me |= V.lane, V = V.next;
        while (V !== p);
      } else J === null && (V.shared.lanes = 0);
      qp |= me, f.lanes = me, f.memoizedState = Dt;
    }
  }
  function ks(f, p, N) {
    if (f = p.effects, p.effects = null, f !== null) for (p = 0; p < f.length; p++) {
      var O = f[p], V = O.callback;
      if (V !== null) {
        if (O.callback = null, O = N, typeof V != "function") throw Error(n(191, V));
        V.call(O);
      }
    }
  }
  var br = {}, cs = Dr(br), Os = Dr(br), ji = Dr(br);
  function ro(f) {
    if (f === br) throw Error(n(174));
    return f;
  }
  function Pm(f, p) {
    switch (Oa(ji, p), Oa(Os, f), Oa(cs, br), f = p.nodeType, f) {
      case 9:
      case 11:
        p = (p = p.documentElement) ? p.namespaceURI : ur(null, "");
        break;
      default:
        f = f === 8 ? p.parentNode : p, p = f.namespaceURI || null, f = f.tagName, p = ur(p, f);
    }
    Na(cs), Oa(cs, p);
  }
  function Xs() {
    Na(cs), Na(Os), Na(ji);
  }
  function Dh(f) {
    ro(ji.current);
    var p = ro(cs.current), N = ur(p, f.type);
    p !== N && (Oa(Os, f), Oa(cs, N));
  }
  function lf(f) {
    Os.current === f && (Na(cs), Na(Os));
  }
  var bs = Dr(0);
  function Ip(f) {
    for (var p = f; p !== null; ) {
      if (p.tag === 13) {
        var N = p.memoizedState;
        if (N !== null && (N = N.dehydrated, N === null || N.data === "$?" || N.data === "$!")) return p;
      } else if (p.tag === 19 && p.memoizedProps.revealOrder !== void 0) {
        if (p.flags & 128) return p;
      } else if (p.child !== null) {
        p.child.return = p, p = p.child;
        continue;
      }
      if (p === f) break;
      for (; p.sibling === null; ) {
        if (p.return === null || p.return === f) return null;
        p = p.return;
      }
      p.sibling.return = p.return, p = p.sibling;
    }
    return null;
  }
  var Om = [];
  function vl() {
    for (var f = 0; f < Om.length; f++) Om[f]._workInProgressVersionPrimary = null;
    Om.length = 0;
  }
  var Fp = U.ReactCurrentDispatcher, Ph = U.ReactCurrentBatchConfig, Sn = 0, Mn = null, ar = null, $r = null, Fi = !1, hd = !1, Ou = 0, xl = 0;
  function us() {
    throw Error(n(321));
  }
  function $f(f, p) {
    if (p === null) return !1;
    for (var N = 0; N < p.length && N < f.length; N++) if (!Pa(f[N], p[N])) return !1;
    return !0;
  }
  function St(f, p, N, O, V, J) {
    if (Sn = J, Mn = p, p.memoizedState = null, p.updateQueue = null, p.lanes = 0, Fp.current = f === null || f.memoizedState === null ? mx : da, f = N(O, V), hd) {
      J = 0;
      do {
        if (hd = !1, Ou = 0, 25 <= J) throw Error(n(301));
        J += 1, $r = ar = null, p.updateQueue = null, Fp.current = Yf, f = N(O, V);
      } while (hd);
    }
    if (Fp.current = So, p = ar !== null && ar.next !== null, Sn = 0, $r = ar = Mn = null, Fi = !1, p) throw Error(n(300));
    return f;
  }
  function Qs() {
    var f = Ou !== 0;
    return Ou = 0, f;
  }
  function hn() {
    var f = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return $r === null ? Mn.memoizedState = $r = f : $r = $r.next = f, $r;
  }
  function As() {
    if (ar === null) {
      var f = Mn.alternate;
      f = f !== null ? f.memoizedState : null;
    } else f = ar.next;
    var p = $r === null ? Mn.memoizedState : $r.next;
    if (p !== null) $r = p, ar = f;
    else {
      if (f === null) throw Error(n(310));
      ar = f, f = { memoizedState: ar.memoizedState, baseState: ar.baseState, baseQueue: ar.baseQueue, queue: ar.queue, next: null }, $r === null ? Mn.memoizedState = $r = f : $r = $r.next = f;
    }
    return $r;
  }
  function va(f, p) {
    return typeof p == "function" ? p(f) : p;
  }
  function oi(f) {
    var p = As(), N = p.queue;
    if (N === null) throw Error(n(311));
    N.lastRenderedReducer = f;
    var O = ar, V = O.baseQueue, J = N.pending;
    if (J !== null) {
      if (V !== null) {
        var me = V.next;
        V.next = J.next, J.next = me;
      }
      O.baseQueue = V = J, N.pending = null;
    }
    if (V !== null) {
      J = V.next, O = O.baseState;
      var je = me = null, De = null, Je = J;
      do {
        var Mt = Je.lane;
        if ((Sn & Mt) === Mt) De !== null && (De = De.next = { lane: 0, action: Je.action, hasEagerState: Je.hasEagerState, eagerState: Je.eagerState, next: null }), O = Je.hasEagerState ? Je.eagerState : f(O, Je.action);
        else {
          var Dt = {
            lane: Mt,
            action: Je.action,
            hasEagerState: Je.hasEagerState,
            eagerState: Je.eagerState,
            next: null
          };
          De === null ? (je = De = Dt, me = O) : De = De.next = Dt, Mn.lanes |= Mt, qp |= Mt;
        }
        Je = Je.next;
      } while (Je !== null && Je !== J);
      De === null ? me = O : De.next = je, Pa(O, p.memoizedState) || (ne = !0), p.memoizedState = O, p.baseState = me, p.baseQueue = De, N.lastRenderedState = O;
    }
    if (f = N.interleaved, f !== null) {
      V = f;
      do
        J = V.lane, Mn.lanes |= J, qp |= J, V = V.next;
      while (V !== f);
    } else V === null && (N.lanes = 0);
    return [p.memoizedState, N.dispatch];
  }
  function xo(f) {
    var p = As(), N = p.queue;
    if (N === null) throw Error(n(311));
    N.lastRenderedReducer = f;
    var O = N.dispatch, V = N.pending, J = p.memoizedState;
    if (V !== null) {
      N.pending = null;
      var me = V = V.next;
      do
        J = f(J, me.action), me = me.next;
      while (me !== V);
      Pa(J, p.memoizedState) || (ne = !0), p.memoizedState = J, p.baseQueue === null && (p.baseState = J), N.lastRenderedState = J;
    }
    return [J, O];
  }
  function Kc() {
  }
  function Au(f, p) {
    var N = Mn, O = As(), V = p(), J = !Pa(O.memoizedState, V);
    if (J && (O.memoizedState = V, ne = !0), O = O.queue, Oh(bl.bind(null, N, O, f), [f]), O.getSnapshot !== p || J || $r !== null && $r.memoizedState.tag & 1) {
      if (N.flags |= 2048, Am(9, yi.bind(null, N, O, V, p), void 0, null), zi === null) throw Error(n(349));
      Sn & 30 || Gf(N, p, V);
    }
    return V;
  }
  function Gf(f, p, N) {
    f.flags |= 16384, f = { getSnapshot: p, value: N }, p = Mn.updateQueue, p === null ? (p = { lastEffect: null, stores: null }, Mn.updateQueue = p, p.stores = [f]) : (N = p.stores, N === null ? p.stores = [f] : N.push(f));
  }
  function yi(f, p, N, O) {
    p.value = N, p.getSnapshot = O, pd(p) && yc(f);
  }
  function bl(f, p, N) {
    return N(function() {
      pd(p) && yc(f);
    });
  }
  function pd(f) {
    var p = f.getSnapshot;
    f = f.value;
    try {
      var N = p();
      return !Pa(f, N);
    } catch {
      return !0;
    }
  }
  function yc(f) {
    var p = qc(f, 1);
    p !== null && ds(p, f, 1, -1);
  }
  function bo(f) {
    var p = hn();
    return typeof f == "function" && (f = f()), p.memoizedState = p.baseState = f, f = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: va, lastRenderedState: f }, p.queue = f, f = f.dispatch = Up.bind(null, Mn, f), [p.memoizedState, f];
  }
  function Am(f, p, N, O) {
    return f = { tag: f, create: p, destroy: N, deps: O, next: null }, p = Mn.updateQueue, p === null ? (p = { lastEffect: null, stores: null }, Mn.updateQueue = p, p.lastEffect = f.next = f) : (N = p.lastEffect, N === null ? p.lastEffect = f.next = f : (O = N.next, N.next = f, f.next = O, p.lastEffect = f)), f;
  }
  function eg() {
    return As().memoizedState;
  }
  function Lm(f, p, N, O) {
    var V = hn();
    Mn.flags |= f, V.memoizedState = Am(1 | p, N, void 0, O === void 0 ? null : O);
  }
  function $l(f, p, N, O) {
    var V = As();
    O = O === void 0 ? null : O;
    var J = void 0;
    if (ar !== null) {
      var me = ar.memoizedState;
      if (J = me.destroy, O !== null && $f(O, me.deps)) {
        V.memoizedState = Am(p, N, J, O);
        return;
      }
    }
    Mn.flags |= f, V.memoizedState = Am(1 | p, N, J, O);
  }
  function tg(f, p) {
    return Lm(8390656, 8, f, p);
  }
  function Oh(f, p) {
    return $l(2048, 8, f, p);
  }
  function Im(f, p) {
    return $l(4, 2, f, p);
  }
  function ng(f, p) {
    return $l(4, 4, f, p);
  }
  function Lu(f, p) {
    if (typeof p == "function") return f = f(), p(f), function() {
      p(null);
    };
    if (p != null) return f = f(), p.current = f, function() {
      p.current = null;
    };
  }
  function h0(f, p, N) {
    return N = N != null ? N.concat([f]) : null, $l(4, 4, Lu.bind(null, p, f), N);
  }
  function Iu() {
  }
  function vc(f, p) {
    var N = As();
    p = p === void 0 ? null : p;
    var O = N.memoizedState;
    return O !== null && p !== null && $f(p, O[1]) ? O[0] : (N.memoizedState = [f, p], f);
  }
  function Ir(f, p) {
    var N = As();
    p = p === void 0 ? null : p;
    var O = N.memoizedState;
    return O !== null && p !== null && $f(p, O[1]) ? O[0] : (f = f(), N.memoizedState = [f, p], f);
  }
  function Gl(f, p, N) {
    return Sn & 21 ? (Pa(N, p) || (N = jp(), Mn.lanes |= N, qp |= N, f.baseState = !0), p) : (f.baseState && (f.baseState = !1, ne = !0), f.memoizedState = N);
  }
  function xc(f, p) {
    var N = Rr;
    Rr = N !== 0 && 4 > N ? N : 4, f(!0);
    var O = Ph.transition;
    Ph.transition = {};
    try {
      f(!1), p();
    } finally {
      Rr = N, Ph.transition = O;
    }
  }
  function gd() {
    return As().memoizedState;
  }
  function Wf(f, p, N) {
    var O = bd(f);
    if (N = { lane: O, action: N, hasEagerState: !1, eagerState: null, next: null }, rg(f)) zp(p, N);
    else if (N = Z1(f, p, N, O), N !== null) {
      var V = Go();
      ds(N, f, O, V), ao(N, p, O);
    }
  }
  function Up(f, p, N) {
    var O = bd(f), V = { lane: O, action: N, hasEagerState: !1, eagerState: null, next: null };
    if (rg(f)) zp(p, V);
    else {
      var J = f.alternate;
      if (f.lanes === 0 && (J === null || J.lanes === 0) && (J = p.lastRenderedReducer, J !== null)) try {
        var me = p.lastRenderedState, je = J(me, N);
        if (V.hasEagerState = !0, V.eagerState = je, Pa(je, me)) {
          var De = p.interleaved;
          De === null ? (V.next = V, ya(p)) : (V.next = De.next, De.next = V), p.interleaved = V;
          return;
        }
      } catch {
      } finally {
      }
      N = Z1(f, p, V, O), N !== null && (V = Go(), ds(N, f, O, V), ao(N, p, O));
    }
  }
  function rg(f) {
    var p = f.alternate;
    return f === Mn || p !== null && p === Mn;
  }
  function zp(f, p) {
    hd = Fi = !0;
    var N = f.pending;
    N === null ? p.next = p : (p.next = N.next, N.next = p), f.pending = p;
  }
  function ao(f, p, N) {
    if (N & 4194240) {
      var O = p.lanes;
      O &= f.pendingLanes, N |= O, p.lanes = N, O1(f, N);
    }
  }
  var So = { readContext: Yt, useCallback: us, useContext: us, useEffect: us, useImperativeHandle: us, useInsertionEffect: us, useLayoutEffect: us, useMemo: us, useReducer: us, useRef: us, useState: us, useDebugValue: us, useDeferredValue: us, useTransition: us, useMutableSource: us, useSyncExternalStore: us, useId: us, unstable_isNewReconciler: !1 }, mx = { readContext: Yt, useCallback: function(f, p) {
    return hn().memoizedState = [f, p === void 0 ? null : p], f;
  }, useContext: Yt, useEffect: tg, useImperativeHandle: function(f, p, N) {
    return N = N != null ? N.concat([f]) : null, Lm(
      4194308,
      4,
      Lu.bind(null, p, f),
      N
    );
  }, useLayoutEffect: function(f, p) {
    return Lm(4194308, 4, f, p);
  }, useInsertionEffect: function(f, p) {
    return Lm(4, 2, f, p);
  }, useMemo: function(f, p) {
    var N = hn();
    return p = p === void 0 ? null : p, f = f(), N.memoizedState = [f, p], f;
  }, useReducer: function(f, p, N) {
    var O = hn();
    return p = N !== void 0 ? N(p) : p, O.memoizedState = O.baseState = p, f = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: f, lastRenderedState: p }, O.queue = f, f = f.dispatch = Wf.bind(null, Mn, f), [O.memoizedState, f];
  }, useRef: function(f) {
    var p = hn();
    return f = { current: f }, p.memoizedState = f;
  }, useState: bo, useDebugValue: Iu, useDeferredValue: function(f) {
    return hn().memoizedState = f;
  }, useTransition: function() {
    var f = bo(!1), p = f[0];
    return f = xc.bind(null, f[1]), hn().memoizedState = f, [p, f];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(f, p, N) {
    var O = Mn, V = hn();
    if (Aa) {
      if (N === void 0) throw Error(n(407));
      N = N();
    } else {
      if (N = p(), zi === null) throw Error(n(349));
      Sn & 30 || Gf(O, p, N);
    }
    V.memoizedState = N;
    var J = { value: N, getSnapshot: p };
    return V.queue = J, tg(bl.bind(
      null,
      O,
      J,
      f
    ), [f]), O.flags |= 2048, Am(9, yi.bind(null, O, J, N, p), void 0, null), N;
  }, useId: function() {
    var f = hn(), p = zi.identifierPrefix;
    if (Aa) {
      var N = Ws, O = Ps;
      N = (O & ~(1 << 32 - Mr(O) - 1)).toString(32) + N, p = ":" + p + "R" + N, N = Ou++, 0 < N && (p += "H" + N.toString(32)), p += ":";
    } else N = xl++, p = ":" + p + "r" + N.toString(32) + ":";
    return f.memoizedState = p;
  }, unstable_isNewReconciler: !1 }, da = {
    readContext: Yt,
    useCallback: vc,
    useContext: Yt,
    useEffect: Oh,
    useImperativeHandle: h0,
    useInsertionEffect: Im,
    useLayoutEffect: ng,
    useMemo: Ir,
    useReducer: oi,
    useRef: eg,
    useState: function() {
      return oi(va);
    },
    useDebugValue: Iu,
    useDeferredValue: function(f) {
      var p = As();
      return Gl(p, ar.memoizedState, f);
    },
    useTransition: function() {
      var f = oi(va)[0], p = As().memoizedState;
      return [f, p];
    },
    useMutableSource: Kc,
    useSyncExternalStore: Au,
    useId: gd,
    unstable_isNewReconciler: !1
  }, Yf = { readContext: Yt, useCallback: vc, useContext: Yt, useEffect: Oh, useImperativeHandle: h0, useInsertionEffect: Im, useLayoutEffect: ng, useMemo: Ir, useReducer: xo, useRef: eg, useState: function() {
    return xo(va);
  }, useDebugValue: Iu, useDeferredValue: function(f) {
    var p = As();
    return ar === null ? p.memoizedState = f : Gl(p, ar.memoizedState, f);
  }, useTransition: function() {
    var f = xo(va)[0], p = As().memoizedState;
    return [f, p];
  }, useMutableSource: Kc, useSyncExternalStore: Au, useId: gd, unstable_isNewReconciler: !1 };
  function Ei(f, p) {
    if (f && f.defaultProps) {
      p = he({}, p), f = f.defaultProps;
      for (var N in f) p[N] === void 0 && (p[N] = f[N]);
      return p;
    }
    return p;
  }
  function yd(f, p, N, O) {
    p = f.memoizedState, N = N(O, p), N = N == null ? p : he({}, p, N), f.memoizedState = N, f.lanes === 0 && (f.updateQueue.baseState = N);
  }
  var vd = { isMounted: function(f) {
    return (f = f._reactInternals) ? On(f) === f : !1;
  }, enqueueSetState: function(f, p, N) {
    f = f._reactInternals;
    var O = Go(), V = bd(f), J = ja(O, V);
    J.payload = p, N != null && (J.callback = N), p = of(f, J, V), p !== null && (ds(p, f, V, O), m0(p, f, V));
  }, enqueueReplaceState: function(f, p, N) {
    f = f._reactInternals;
    var O = Go(), V = bd(f), J = ja(O, V);
    J.tag = 1, J.payload = p, N != null && (J.callback = N), p = of(f, J, V), p !== null && (ds(p, f, V, O), m0(p, f, V));
  }, enqueueForceUpdate: function(f, p) {
    f = f._reactInternals;
    var N = Go(), O = bd(f), V = ja(N, O);
    V.tag = 2, p != null && (V.callback = p), p = of(f, V, O), p !== null && (ds(p, f, O, N), m0(p, f, O));
  } };
  function Bp(f, p, N, O, V, J, me) {
    return f = f.stateNode, typeof f.shouldComponentUpdate == "function" ? f.shouldComponentUpdate(O, J, me) : p.prototype && p.prototype.isPureReactComponent ? !If(N, O) || !If(V, J) : !0;
  }
  function p0(f, p, N) {
    var O = !1, V = Ru, J = p.contextType;
    return typeof J == "object" && J !== null ? J = Yt(J) : (V = Ns(p) ? Uo : or.current, O = p.contextTypes, J = (O = O != null) ? lc(f, V) : Ru), p = new p(N, J), f.memoizedState = p.state !== null && p.state !== void 0 ? p.state : null, p.updater = vd, f.stateNode = p, p._reactInternals = f, O && (f = f.stateNode, f.__reactInternalMemoizedUnmaskedChildContext = V, f.__reactInternalMemoizedMaskedChildContext = J), p;
  }
  function Ay(f, p, N, O) {
    f = p.state, typeof p.componentWillReceiveProps == "function" && p.componentWillReceiveProps(N, O), typeof p.UNSAFE_componentWillReceiveProps == "function" && p.UNSAFE_componentWillReceiveProps(N, O), p.state !== f && vd.enqueueReplaceState(p, p.state, null);
  }
  function g0(f, p, N, O) {
    var V = f.stateNode;
    V.props = N, V.state = f.memoizedState, V.refs = {}, Lp(f);
    var J = p.contextType;
    typeof J == "object" && J !== null ? V.context = Yt(J) : (J = Ns(p) ? Uo : or.current, V.context = lc(f, J)), V.state = f.memoizedState, J = p.getDerivedStateFromProps, typeof J == "function" && (yd(f, p, J, N), V.state = f.memoizedState), typeof p.getDerivedStateFromProps == "function" || typeof V.getSnapshotBeforeUpdate == "function" || typeof V.UNSAFE_componentWillMount != "function" && typeof V.componentWillMount != "function" || (p = V.state, typeof V.componentWillMount == "function" && V.componentWillMount(), typeof V.UNSAFE_componentWillMount == "function" && V.UNSAFE_componentWillMount(), p !== V.state && vd.enqueueReplaceState(V, V.state, null), Rh(f, N, V, O), V.state = f.memoizedState), typeof V.componentDidMount == "function" && (f.flags |= 4194308);
  }
  function qf(f, p) {
    try {
      var N = "", O = p;
      do
        N += qe(O), O = O.return;
      while (O);
      var V = N;
    } catch (J) {
      V = `
Error generating stack: ` + J.message + `
` + J.stack;
    }
    return { value: f, source: p, stack: V, digest: null };
  }
  function y0(f, p, N) {
    return { value: f, source: null, stack: N ?? null, digest: p ?? null };
  }
  function Kf(f, p) {
    try {
      console.error(p.value);
    } catch (N) {
      setTimeout(function() {
        throw N;
      });
    }
  }
  var ag = typeof WeakMap == "function" ? WeakMap : Map;
  function hx(f, p, N) {
    N = ja(-1, N), N.tag = 3, N.payload = { element: null };
    var O = p.value;
    return N.callback = function() {
      zy || (zy = !0, Jf = O), Kf(f, p);
    }, N;
  }
  function v(f, p, N) {
    N = ja(-1, N), N.tag = 3;
    var O = f.type.getDerivedStateFromError;
    if (typeof O == "function") {
      var V = p.value;
      N.payload = function() {
        return O(V);
      }, N.callback = function() {
        Kf(f, p);
      };
    }
    var J = f.stateNode;
    return J !== null && typeof J.componentDidCatch == "function" && (N.callback = function() {
      Kf(f, p), typeof O != "function" && ($o === null ? $o = /* @__PURE__ */ new Set([this]) : $o.add(this));
      var me = p.stack;
      this.componentDidCatch(p.value, { componentStack: me !== null ? me : "" });
    }), N;
  }
  function x(f, p, N) {
    var O = f.pingCache;
    if (O === null) {
      O = f.pingCache = new ag();
      var V = /* @__PURE__ */ new Set();
      O.set(p, V);
    } else V = O.get(p), V === void 0 && (V = /* @__PURE__ */ new Set(), O.set(p, V));
    V.has(N) || (V.add(N), f = Hm.bind(null, f, p, N), p.then(f, f));
  }
  function P(f) {
    do {
      var p;
      if ((p = f.tag === 13) && (p = f.memoizedState, p = p !== null ? p.dehydrated !== null : !0), p) return f;
      f = f.return;
    } while (f !== null);
    return null;
  }
  function B(f, p, N, O, V) {
    return f.mode & 1 ? (f.flags |= 65536, f.lanes = V, f) : (f === p ? f.flags |= 65536 : (f.flags |= 128, N.flags |= 131072, N.flags &= -52805, N.tag === 1 && (N.alternate === null ? N.tag = 17 : (p = ja(-1, 1), p.tag = 2, of(N, p, 1))), N.lanes |= 1), f);
  }
  var G = U.ReactCurrentOwner, ne = !1;
  function be(f, p, N, O) {
    p.child = f === null ? ns(p, null, N, O) : Mh(p, f.child, N, O);
  }
  function Fe(f, p, N, O, V) {
    N = N.render;
    var J = p.ref;
    return Ks(p, V), O = St(f, p, N, O, J, V), N = Qs(), f !== null && !ne ? (p.updateQueue = f.updateQueue, p.flags &= -2053, f.lanes &= ~V, Ea(f, p, V)) : (Aa && N && Hf(p), p.flags |= 1, be(f, p, O, V), p.child);
  }
  function Ze(f, p, N, O, V) {
    if (f === null) {
      var J = N.type;
      return typeof J == "function" && !Vy(J) && J.defaultProps === void 0 && N.compare === null && N.defaultProps === void 0 ? (p.tag = 15, p.type = J, Ft(f, p, J, O, V)) : (f = La(N.type, null, O, p, p.mode, V), f.ref = p.ref, f.return = p, p.child = f);
    }
    if (J = f.child, !(f.lanes & V)) {
      var me = J.memoizedProps;
      if (N = N.compare, N = N !== null ? N : If, N(me, O) && f.ref === p.ref) return Ea(f, p, V);
    }
    return p.flags |= 1, f = zu(J, O), f.ref = p.ref, f.return = p, p.child = f;
  }
  function Ft(f, p, N, O, V) {
    if (f !== null) {
      var J = f.memoizedProps;
      if (If(J, O) && f.ref === p.ref) if (ne = !1, p.pendingProps = O = J, (f.lanes & V) !== 0) f.flags & 131072 && (ne = !0);
      else return p.lanes = f.lanes, Ea(f, p, V);
    }
    return ct(f, p, N, O, V);
  }
  function sn(f, p, N) {
    var O = p.pendingProps, V = O.children, J = f !== null ? f.memoizedState : null;
    if (O.mode === "hidden") if (!(p.mode & 1)) p.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Oa(wo, Fu), Fu |= N;
    else {
      if (!(N & 1073741824)) return f = J !== null ? J.baseLanes | N : N, p.lanes = p.childLanes = 1073741824, p.memoizedState = { baseLanes: f, cachePool: null, transitions: null }, p.updateQueue = null, Oa(wo, Fu), Fu |= f, null;
      p.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, O = J !== null ? J.baseLanes : N, Oa(wo, Fu), Fu |= O;
    }
    else J !== null ? (O = J.baseLanes | N, p.memoizedState = null) : O = N, Oa(wo, Fu), Fu |= O;
    return be(f, p, V, N), p.child;
  }
  function dr(f, p) {
    var N = p.ref;
    (f === null && N !== null || f !== null && f.ref !== N) && (p.flags |= 512, p.flags |= 2097152);
  }
  function ct(f, p, N, O, V) {
    var J = Ns(N) ? Uo : or.current;
    return J = lc(p, J), Ks(p, V), N = St(f, p, N, O, J, V), O = Qs(), f !== null && !ne ? (p.updateQueue = f.updateQueue, p.flags &= -2053, f.lanes &= ~V, Ea(f, p, V)) : (Aa && O && Hf(p), p.flags |= 1, be(f, p, N, V), p.child);
  }
  function xa(f, p, N, O, V) {
    if (Ns(N)) {
      var J = !0;
      Mm(p);
    } else J = !1;
    if (Ks(p, V), p.stateNode === null) Wr(f, p), p0(p, N, O), g0(p, N, O, V), O = !0;
    else if (f === null) {
      var me = p.stateNode, je = p.memoizedProps;
      me.props = je;
      var De = me.context, Je = N.contextType;
      typeof Je == "object" && Je !== null ? Je = Yt(Je) : (Je = Ns(N) ? Uo : or.current, Je = lc(p, Je));
      var Mt = N.getDerivedStateFromProps, Dt = typeof Mt == "function" || typeof me.getSnapshotBeforeUpdate == "function";
      Dt || typeof me.UNSAFE_componentWillReceiveProps != "function" && typeof me.componentWillReceiveProps != "function" || (je !== O || De !== Je) && Ay(p, me, O, Je), sf = !1;
      var Tt = p.memoizedState;
      me.state = Tt, Rh(p, O, me, V), De = p.memoizedState, je !== O || Tt !== De || Gs.current || sf ? (typeof Mt == "function" && (yd(p, N, Mt, O), De = p.memoizedState), (je = sf || Bp(p, N, je, O, Tt, De, Je)) ? (Dt || typeof me.UNSAFE_componentWillMount != "function" && typeof me.componentWillMount != "function" || (typeof me.componentWillMount == "function" && me.componentWillMount(), typeof me.UNSAFE_componentWillMount == "function" && me.UNSAFE_componentWillMount()), typeof me.componentDidMount == "function" && (p.flags |= 4194308)) : (typeof me.componentDidMount == "function" && (p.flags |= 4194308), p.memoizedProps = O, p.memoizedState = De), me.props = O, me.state = De, me.context = Je, O = je) : (typeof me.componentDidMount == "function" && (p.flags |= 4194308), O = !1);
    } else {
      me = p.stateNode, Dm(f, p), je = p.memoizedProps, Je = p.type === p.elementType ? je : Ei(p.type, je), me.props = Je, Dt = p.pendingProps, Tt = me.context, De = N.contextType, typeof De == "object" && De !== null ? De = Yt(De) : (De = Ns(N) ? Uo : or.current, De = lc(p, De));
      var vn = N.getDerivedStateFromProps;
      (Mt = typeof vn == "function" || typeof me.getSnapshotBeforeUpdate == "function") || typeof me.UNSAFE_componentWillReceiveProps != "function" && typeof me.componentWillReceiveProps != "function" || (je !== Dt || Tt !== De) && Ay(p, me, O, De), sf = !1, Tt = p.memoizedState, me.state = Tt, Rh(p, O, me, V);
      var _n = p.memoizedState;
      je !== Dt || Tt !== _n || Gs.current || sf ? (typeof vn == "function" && (yd(p, N, vn, O), _n = p.memoizedState), (Je = sf || Bp(p, N, Je, O, Tt, _n, De) || !1) ? (Mt || typeof me.UNSAFE_componentWillUpdate != "function" && typeof me.componentWillUpdate != "function" || (typeof me.componentWillUpdate == "function" && me.componentWillUpdate(O, _n, De), typeof me.UNSAFE_componentWillUpdate == "function" && me.UNSAFE_componentWillUpdate(O, _n, De)), typeof me.componentDidUpdate == "function" && (p.flags |= 4), typeof me.getSnapshotBeforeUpdate == "function" && (p.flags |= 1024)) : (typeof me.componentDidUpdate != "function" || je === f.memoizedProps && Tt === f.memoizedState || (p.flags |= 4), typeof me.getSnapshotBeforeUpdate != "function" || je === f.memoizedProps && Tt === f.memoizedState || (p.flags |= 1024), p.memoizedProps = O, p.memoizedState = _n), me.props = O, me.state = _n, me.context = De, O = Je) : (typeof me.componentDidUpdate != "function" || je === f.memoizedProps && Tt === f.memoizedState || (p.flags |= 4), typeof me.getSnapshotBeforeUpdate != "function" || je === f.memoizedProps && Tt === f.memoizedState || (p.flags |= 1024), O = !1);
    }
    return Ga(f, p, N, O, J, V);
  }
  function Ga(f, p, N, O, V, J) {
    dr(f, p);
    var me = (p.flags & 128) !== 0;
    if (!O && !me) return V && Dy(p, N, !1), Ea(f, p, J);
    O = p.stateNode, G.current = p;
    var je = me && typeof N.getDerivedStateFromError != "function" ? null : O.render();
    return p.flags |= 1, f !== null && me ? (p.child = Mh(p, f.child, null, J), p.child = Mh(p, null, je, J)) : be(f, p, je, J), p.memoizedState = O.state, V && Dy(p, N, !0), p.child;
  }
  function bc(f) {
    var p = f.stateNode;
    p.pendingContext ? Du(f, p.pendingContext, p.pendingContext !== p.context) : p.context && Du(f, p.context, !1), Pm(f, p.containerInfo);
  }
  function Zs(f, p, N, O, V) {
    return Ys(), Q1(V), p.flags |= 256, be(f, p, N, O), p.child;
  }
  var Be = { dehydrated: null, treeContext: null, retryLane: 0 };
  function ze(f) {
    return { baseLanes: f, cachePool: null, transitions: null };
  }
  function rt(f, p, N) {
    var O = p.pendingProps, V = bs.current, J = !1, me = (p.flags & 128) !== 0, je;
    if ((je = me) || (je = f !== null && f.memoizedState === null ? !1 : (V & 2) !== 0), je ? (J = !0, p.flags &= -129) : (f === null || f.memoizedState !== null) && (V |= 1), Oa(bs, V & 1), f === null)
      return fd(p), f = p.memoizedState, f !== null && (f = f.dehydrated, f !== null) ? (p.mode & 1 ? f.data === "$!" ? p.lanes = 8 : p.lanes = 1073741824 : p.lanes = 1, null) : (me = O.children, f = O.fallback, J ? (O = p.mode, J = p.child, me = { mode: "hidden", children: me }, !(O & 1) && J !== null ? (J.childLanes = 0, J.pendingProps = me) : J = Bi(me, O, 0, null), f = li(f, O, N, null), J.return = p, f.return = p, J.sibling = f, p.child = J, p.child.memoizedState = ze(N), p.memoizedState = Be, f) : Jt(p, me));
    if (V = f.memoizedState, V !== null && (je = V.dehydrated, je !== null)) return pr(f, p, me, O, je, V, N);
    if (J) {
      J = O.fallback, me = p.mode, V = f.child, je = V.sibling;
      var De = { mode: "hidden", children: O.children };
      return !(me & 1) && p.child !== V ? (O = p.child, O.childLanes = 0, O.pendingProps = De, p.deletions = null) : (O = zu(V, De), O.subtreeFlags = V.subtreeFlags & 14680064), je !== null ? J = zu(je, J) : (J = li(J, me, N, null), J.flags |= 2), J.return = p, O.return = p, O.sibling = J, p.child = O, O = J, J = p.child, me = f.child.memoizedState, me = me === null ? ze(N) : { baseLanes: me.baseLanes | N, cachePool: null, transitions: me.transitions }, J.memoizedState = me, J.childLanes = f.childLanes & ~N, p.memoizedState = Be, O;
    }
    return J = f.child, f = J.sibling, O = zu(J, { mode: "visible", children: O.children }), !(p.mode & 1) && (O.lanes = N), O.return = p, O.sibling = null, f !== null && (N = p.deletions, N === null ? (p.deletions = [f], p.flags |= 16) : N.push(f)), p.child = O, p.memoizedState = null, O;
  }
  function Jt(f, p) {
    return p = Bi({ mode: "visible", children: p }, f.mode, 0, null), p.return = f, f.child = p;
  }
  function Yn(f, p, N, O) {
    return O !== null && Q1(O), Mh(p, f.child, null, N), f = Jt(p, p.pendingProps.children), f.flags |= 2, p.memoizedState = null, f;
  }
  function pr(f, p, N, O, V, J, me) {
    if (N)
      return p.flags & 256 ? (p.flags &= -257, O = y0(Error(n(422))), Yn(f, p, me, O)) : p.memoizedState !== null ? (p.child = f.child, p.flags |= 128, null) : (J = O.fallback, V = p.mode, O = Bi({ mode: "visible", children: O.children }, V, 0, null), J = li(J, V, me, null), J.flags |= 2, O.return = p, J.return = p, O.sibling = J, p.child = O, p.mode & 1 && Mh(p, f.child, null, me), p.child.memoizedState = ze(me), p.memoizedState = Be, J);
    if (!(p.mode & 1)) return Yn(f, p, me, null);
    if (V.data === "$!") {
      if (O = V.nextSibling && V.nextSibling.dataset, O) var je = O.dgst;
      return O = je, J = Error(n(419)), O = y0(J, O, void 0), Yn(f, p, me, O);
    }
    if (je = (me & f.childLanes) !== 0, ne || je) {
      if (O = zi, O !== null) {
        switch (me & -me) {
          case 4:
            V = 2;
            break;
          case 16:
            V = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            V = 32;
            break;
          case 536870912:
            V = 268435456;
            break;
          default:
            V = 0;
        }
        V = V & (O.suspendedLanes | me) ? 0 : V, V !== 0 && V !== J.retryLane && (J.retryLane = V, qc(f, V), ds(O, f, V, -1));
      }
      return Zc(), O = y0(Error(n(421))), Yn(f, p, me, O);
    }
    return V.data === "$?" ? (p.flags |= 128, p.child = f.child, p = Wo.bind(null, f), V._reactRetry = p, null) : (f = J.treeContext, tn = Hl(V.nextSibling), mc = p, Aa = !0, ii = null, f !== null && (yl[to++] = Ps, yl[to++] = Ws, yl[to++] = Vl, Ps = f.id, Ws = f.overflow, Vl = p), p = Jt(p, O.children), p.flags |= 4096, p);
  }
  function gr(f, p, N) {
    f.lanes |= p;
    var O = f.alternate;
    O !== null && (O.lanes |= p), Vf(f.return, p, N);
  }
  function Kr(f, p, N, O, V) {
    var J = f.memoizedState;
    J === null ? f.memoizedState = { isBackwards: p, rendering: null, renderingStartTime: 0, last: O, tail: N, tailMode: V } : (J.isBackwards = p, J.rendering = null, J.renderingStartTime = 0, J.last = O, J.tail = N, J.tailMode = V);
  }
  function Js(f, p, N) {
    var O = p.pendingProps, V = O.revealOrder, J = O.tail;
    if (be(f, p, O.children, N), O = bs.current, O & 2) O = O & 1 | 2, p.flags |= 128;
    else {
      if (f !== null && f.flags & 128) e: for (f = p.child; f !== null; ) {
        if (f.tag === 13) f.memoizedState !== null && gr(f, N, p);
        else if (f.tag === 19) gr(f, N, p);
        else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === p) break e;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === p) break e;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      O &= 1;
    }
    if (Oa(bs, O), !(p.mode & 1)) p.memoizedState = null;
    else switch (V) {
      case "forwards":
        for (N = p.child, V = null; N !== null; ) f = N.alternate, f !== null && Ip(f) === null && (V = N), N = N.sibling;
        N = V, N === null ? (V = p.child, p.child = null) : (V = N.sibling, N.sibling = null), Kr(p, !1, V, N, J);
        break;
      case "backwards":
        for (N = null, V = p.child, p.child = null; V !== null; ) {
          if (f = V.alternate, f !== null && Ip(f) === null) {
            p.child = V;
            break;
          }
          f = V.sibling, V.sibling = N, N = V, V = f;
        }
        Kr(p, !0, N, null, J);
        break;
      case "together":
        Kr(p, !1, null, null, void 0);
        break;
      default:
        p.memoizedState = null;
    }
    return p.child;
  }
  function Wr(f, p) {
    !(p.mode & 1) && f !== null && (f.alternate = null, p.alternate = null, p.flags |= 2);
  }
  function Ea(f, p, N) {
    if (f !== null && (p.dependencies = f.dependencies), qp |= p.lanes, !(N & p.childLanes)) return null;
    if (f !== null && p.child !== f.child) throw Error(n(153));
    if (p.child !== null) {
      for (f = p.child, N = zu(f, f.pendingProps), p.child = N, N.return = p; f.sibling !== null; ) f = f.sibling, N = N.sibling = zu(f, f.pendingProps), N.return = p;
      N.sibling = null;
    }
    return p.child;
  }
  function Xc(f, p, N) {
    switch (p.tag) {
      case 3:
        bc(p), Ys();
        break;
      case 5:
        Dh(p);
        break;
      case 1:
        Ns(p.type) && Mm(p);
        break;
      case 4:
        Pm(p, p.stateNode.containerInfo);
        break;
      case 10:
        var O = p.type._context, V = p.memoizedProps.value;
        Oa(Yc, O._currentValue), O._currentValue = V;
        break;
      case 13:
        if (O = p.memoizedState, O !== null)
          return O.dehydrated !== null ? (Oa(bs, bs.current & 1), p.flags |= 128, null) : N & p.child.childLanes ? rt(f, p, N) : (Oa(bs, bs.current & 1), f = Ea(f, p, N), f !== null ? f.sibling : null);
        Oa(bs, bs.current & 1);
        break;
      case 19:
        if (O = (N & p.childLanes) !== 0, f.flags & 128) {
          if (O) return Js(f, p, N);
          p.flags |= 128;
        }
        if (V = p.memoizedState, V !== null && (V.rendering = null, V.tail = null, V.lastEffect = null), Oa(bs, bs.current), O) break;
        return null;
      case 22:
      case 23:
        return p.lanes = 0, sn(f, p, N);
    }
    return Ea(f, p, N);
  }
  var Sc, Ah, sg, xd;
  Sc = function(f, p) {
    for (var N = p.child; N !== null; ) {
      if (N.tag === 5 || N.tag === 6) f.appendChild(N.stateNode);
      else if (N.tag !== 4 && N.child !== null) {
        N.child.return = N, N = N.child;
        continue;
      }
      if (N === p) break;
      for (; N.sibling === null; ) {
        if (N.return === null || N.return === p) return;
        N = N.return;
      }
      N.sibling.return = N.return, N = N.sibling;
    }
  }, Ah = function() {
  }, sg = function(f, p, N, O) {
    var V = f.memoizedProps;
    if (V !== O) {
      f = p.stateNode, ro(cs.current);
      var J = null;
      switch (N) {
        case "input":
          V = Pt(f, V), O = Pt(f, O), J = [];
          break;
        case "select":
          V = he({}, V, { value: void 0 }), O = he({}, O, { value: void 0 }), J = [];
          break;
        case "textarea":
          V = ot(f, V), O = ot(f, O), J = [];
          break;
        default:
          typeof V.onClick != "function" && typeof O.onClick == "function" && (f.onclick = zf);
      }
      st(N, O);
      var me;
      N = null;
      for (Je in V) if (!O.hasOwnProperty(Je) && V.hasOwnProperty(Je) && V[Je] != null) if (Je === "style") {
        var je = V[Je];
        for (me in je) je.hasOwnProperty(me) && (N || (N = {}), N[me] = "");
      } else Je !== "dangerouslySetInnerHTML" && Je !== "children" && Je !== "suppressContentEditableWarning" && Je !== "suppressHydrationWarning" && Je !== "autoFocus" && (s.hasOwnProperty(Je) ? J || (J = []) : (J = J || []).push(Je, null));
      for (Je in O) {
        var De = O[Je];
        if (je = V != null ? V[Je] : void 0, O.hasOwnProperty(Je) && De !== je && (De != null || je != null)) if (Je === "style") if (je) {
          for (me in je) !je.hasOwnProperty(me) || De && De.hasOwnProperty(me) || (N || (N = {}), N[me] = "");
          for (me in De) De.hasOwnProperty(me) && je[me] !== De[me] && (N || (N = {}), N[me] = De[me]);
        } else N || (J || (J = []), J.push(
          Je,
          N
        )), N = De;
        else Je === "dangerouslySetInnerHTML" ? (De = De ? De.__html : void 0, je = je ? je.__html : void 0, De != null && je !== De && (J = J || []).push(Je, De)) : Je === "children" ? typeof De != "string" && typeof De != "number" || (J = J || []).push(Je, "" + De) : Je !== "suppressContentEditableWarning" && Je !== "suppressHydrationWarning" && (s.hasOwnProperty(Je) ? (De != null && Je === "onScroll" && ca("scroll", f), J || je === De || (J = [])) : (J = J || []).push(Je, De));
      }
      N && (J = J || []).push("style", N);
      var Je = J;
      (p.updateQueue = Je) && (p.flags |= 4);
    }
  }, xd = function(f, p, N, O) {
    N !== O && (p.flags |= 4);
  };
  function ki(f, p) {
    if (!Aa) switch (f.tailMode) {
      case "hidden":
        p = f.tail;
        for (var N = null; p !== null; ) p.alternate !== null && (N = p), p = p.sibling;
        N === null ? f.tail = null : N.sibling = null;
        break;
      case "collapsed":
        N = f.tail;
        for (var O = null; N !== null; ) N.alternate !== null && (O = N), N = N.sibling;
        O === null ? p || f.tail === null ? f.tail = null : f.tail.sibling = null : O.sibling = null;
    }
  }
  function Sl(f) {
    var p = f.alternate !== null && f.alternate.child === f.child, N = 0, O = 0;
    if (p) for (var V = f.child; V !== null; ) N |= V.lanes | V.childLanes, O |= V.subtreeFlags & 14680064, O |= V.flags & 14680064, V.return = f, V = V.sibling;
    else for (V = f.child; V !== null; ) N |= V.lanes | V.childLanes, O |= V.subtreeFlags, O |= V.flags, V.return = f, V = V.sibling;
    return f.subtreeFlags |= O, f.childLanes = N, p;
  }
  function Mw(f, p, N) {
    var O = p.pendingProps;
    switch (vo(p), p.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Sl(p), null;
      case 1:
        return Ns(p.type) && cc(), Sl(p), null;
      case 3:
        return O = p.stateNode, Xs(), Na(Gs), Na(or), vl(), O.pendingContext && (O.context = O.pendingContext, O.pendingContext = null), (f === null || f.child === null) && (gi(p) ? p.flags |= 4 : f === null || f.memoizedState.isDehydrated && !(p.flags & 256) || (p.flags |= 1024, ii !== null && (By(ii), ii = null))), Ah(f, p), Sl(p), null;
      case 5:
        lf(p);
        var V = ro(ji.current);
        if (N = p.type, f !== null && p.stateNode != null) sg(f, p, N, O, V), f.ref !== p.ref && (p.flags |= 512, p.flags |= 2097152);
        else {
          if (!O) {
            if (p.stateNode === null) throw Error(n(166));
            return Sl(p), null;
          }
          if (f = ro(cs.current), gi(p)) {
            O = p.stateNode, N = p.type;
            var J = p.memoizedProps;
            switch (O[Vc] = p, O[cd] = J, f = (p.mode & 1) !== 0, N) {
              case "dialog":
                ca("cancel", O), ca("close", O);
                break;
              case "iframe":
              case "object":
              case "embed":
                ca("load", O);
                break;
              case "video":
              case "audio":
                for (V = 0; V < bt.length; V++) ca(bt[V], O);
                break;
              case "source":
                ca("error", O);
                break;
              case "img":
              case "image":
              case "link":
                ca(
                  "error",
                  O
                ), ca("load", O);
                break;
              case "details":
                ca("toggle", O);
                break;
              case "input":
                Lt(O, J), ca("invalid", O);
                break;
              case "select":
                O._wrapperState = { wasMultiple: !!J.multiple }, ca("invalid", O);
                break;
              case "textarea":
                ut(O, J), ca("invalid", O);
            }
            st(N, J), V = null;
            for (var me in J) if (J.hasOwnProperty(me)) {
              var je = J[me];
              me === "children" ? typeof je == "string" ? O.textContent !== je && (J.suppressHydrationWarning !== !0 && Nh(O.textContent, je, f), V = ["children", je]) : typeof je == "number" && O.textContent !== "" + je && (J.suppressHydrationWarning !== !0 && Nh(
                O.textContent,
                je,
                f
              ), V = ["children", "" + je]) : s.hasOwnProperty(me) && je != null && me === "onScroll" && ca("scroll", O);
            }
            switch (N) {
              case "input":
                vt(O), ye(O, J, !0);
                break;
              case "textarea":
                vt(O), bn(O);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof J.onClick == "function" && (O.onclick = zf);
            }
            O = V, p.updateQueue = O, O !== null && (p.flags |= 4);
          } else {
            me = V.nodeType === 9 ? V : V.ownerDocument, f === "http://www.w3.org/1999/xhtml" && (f = mr(N)), f === "http://www.w3.org/1999/xhtml" ? N === "script" ? (f = me.createElement("div"), f.innerHTML = "<script><\/script>", f = f.removeChild(f.firstChild)) : typeof O.is == "string" ? f = me.createElement(N, { is: O.is }) : (f = me.createElement(N), N === "select" && (me = f, O.multiple ? me.multiple = !0 : O.size && (me.size = O.size))) : f = me.createElementNS(f, N), f[Vc] = p, f[cd] = O, Sc(f, p, !1, !1), p.stateNode = f;
            e: {
              switch (me = lt(N, O), N) {
                case "dialog":
                  ca("cancel", f), ca("close", f), V = O;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  ca("load", f), V = O;
                  break;
                case "video":
                case "audio":
                  for (V = 0; V < bt.length; V++) ca(bt[V], f);
                  V = O;
                  break;
                case "source":
                  ca("error", f), V = O;
                  break;
                case "img":
                case "image":
                case "link":
                  ca(
                    "error",
                    f
                  ), ca("load", f), V = O;
                  break;
                case "details":
                  ca("toggle", f), V = O;
                  break;
                case "input":
                  Lt(f, O), V = Pt(f, O), ca("invalid", f);
                  break;
                case "option":
                  V = O;
                  break;
                case "select":
                  f._wrapperState = { wasMultiple: !!O.multiple }, V = he({}, O, { value: void 0 }), ca("invalid", f);
                  break;
                case "textarea":
                  ut(f, O), V = ot(f, O), ca("invalid", f);
                  break;
                default:
                  V = O;
              }
              st(N, V), je = V;
              for (J in je) if (je.hasOwnProperty(J)) {
                var De = je[J];
                J === "style" ? qt(f, De) : J === "dangerouslySetInnerHTML" ? (De = De ? De.__html : void 0, De != null && ai(f, De)) : J === "children" ? typeof De == "string" ? (N !== "textarea" || De !== "") && ls(f, De) : typeof De == "number" && ls(f, "" + De) : J !== "suppressContentEditableWarning" && J !== "suppressHydrationWarning" && J !== "autoFocus" && (s.hasOwnProperty(J) ? De != null && J === "onScroll" && ca("scroll", f) : De != null && R(f, J, De, me));
              }
              switch (N) {
                case "input":
                  vt(f), ye(f, O, !1);
                  break;
                case "textarea":
                  vt(f), bn(f);
                  break;
                case "option":
                  O.value != null && f.setAttribute("value", "" + Xe(O.value));
                  break;
                case "select":
                  f.multiple = !!O.multiple, J = O.value, J != null ? tt(f, !!O.multiple, J, !1) : O.defaultValue != null && tt(
                    f,
                    !!O.multiple,
                    O.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof V.onClick == "function" && (f.onclick = zf);
              }
              switch (N) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  O = !!O.autoFocus;
                  break e;
                case "img":
                  O = !0;
                  break e;
                default:
                  O = !1;
              }
            }
            O && (p.flags |= 4);
          }
          p.ref !== null && (p.flags |= 512, p.flags |= 2097152);
        }
        return Sl(p), null;
      case 6:
        if (f && p.stateNode != null) xd(f, p, f.memoizedProps, O);
        else {
          if (typeof O != "string" && p.stateNode === null) throw Error(n(166));
          if (N = ro(ji.current), ro(cs.current), gi(p)) {
            if (O = p.stateNode, N = p.memoizedProps, O[Vc] = p, (J = O.nodeValue !== N) && (f = mc, f !== null)) switch (f.tag) {
              case 3:
                Nh(O.nodeValue, N, (f.mode & 1) !== 0);
                break;
              case 5:
                f.memoizedProps.suppressHydrationWarning !== !0 && Nh(O.nodeValue, N, (f.mode & 1) !== 0);
            }
            J && (p.flags |= 4);
          } else O = (N.nodeType === 9 ? N : N.ownerDocument).createTextNode(O), O[Vc] = p, p.stateNode = O;
        }
        return Sl(p), null;
      case 13:
        if (Na(bs), O = p.memoizedState, f === null || f.memoizedState !== null && f.memoizedState.dehydrated !== null) {
          if (Aa && tn !== null && p.mode & 1 && !(p.flags & 128)) Oy(), Ys(), p.flags |= 98560, J = !1;
          else if (J = gi(p), O !== null && O.dehydrated !== null) {
            if (f === null) {
              if (!J) throw Error(n(318));
              if (J = p.memoizedState, J = J !== null ? J.dehydrated : null, !J) throw Error(n(317));
              J[Vc] = p;
            } else Ys(), !(p.flags & 128) && (p.memoizedState = null), p.flags |= 4;
            Sl(p), J = !1;
          } else ii !== null && (By(ii), ii = null), J = !0;
          if (!J) return p.flags & 65536 ? p : null;
        }
        return p.flags & 128 ? (p.lanes = N, p) : (O = O !== null, O !== (f !== null && f.memoizedState !== null) && O && (p.child.flags |= 8192, p.mode & 1 && (f === null || bs.current & 1 ? Ho === 0 && (Ho = 3) : Zc())), p.updateQueue !== null && (p.flags |= 4), Sl(p), null);
      case 4:
        return Xs(), Ah(f, p), f === null && _u(p.stateNode.containerInfo), Sl(p), null;
      case 10:
        return f0(p.type._context), Sl(p), null;
      case 17:
        return Ns(p.type) && cc(), Sl(p), null;
      case 19:
        if (Na(bs), J = p.memoizedState, J === null) return Sl(p), null;
        if (O = (p.flags & 128) !== 0, me = J.rendering, me === null) if (O) ki(J, !1);
        else {
          if (Ho !== 0 || f !== null && f.flags & 128) for (f = p.child; f !== null; ) {
            if (me = Ip(f), me !== null) {
              for (p.flags |= 128, ki(J, !1), O = me.updateQueue, O !== null && (p.updateQueue = O, p.flags |= 4), p.subtreeFlags = 0, O = N, N = p.child; N !== null; ) J = N, f = O, J.flags &= 14680066, me = J.alternate, me === null ? (J.childLanes = 0, J.lanes = f, J.child = null, J.subtreeFlags = 0, J.memoizedProps = null, J.memoizedState = null, J.updateQueue = null, J.dependencies = null, J.stateNode = null) : (J.childLanes = me.childLanes, J.lanes = me.lanes, J.child = me.child, J.subtreeFlags = 0, J.deletions = null, J.memoizedProps = me.memoizedProps, J.memoizedState = me.memoizedState, J.updateQueue = me.updateQueue, J.type = me.type, f = me.dependencies, J.dependencies = f === null ? null : { lanes: f.lanes, firstContext: f.firstContext }), N = N.sibling;
              return Oa(bs, bs.current & 1 | 2), p.child;
            }
            f = f.sibling;
          }
          J.tail !== null && Gn() > Ih && (p.flags |= 128, O = !0, ki(J, !1), p.lanes = 4194304);
        }
        else {
          if (!O) if (f = Ip(me), f !== null) {
            if (p.flags |= 128, O = !0, N = f.updateQueue, N !== null && (p.updateQueue = N, p.flags |= 4), ki(J, !0), J.tail === null && J.tailMode === "hidden" && !me.alternate && !Aa) return Sl(p), null;
          } else 2 * Gn() - J.renderingStartTime > Ih && N !== 1073741824 && (p.flags |= 128, O = !0, ki(J, !1), p.lanes = 4194304);
          J.isBackwards ? (me.sibling = p.child, p.child = me) : (N = J.last, N !== null ? N.sibling = me : p.child = me, J.last = me);
        }
        return J.tail !== null ? (p = J.tail, J.rendering = p, J.tail = p.sibling, J.renderingStartTime = Gn(), p.sibling = null, N = bs.current, Oa(bs, O ? N & 1 | 2 : N & 1), p) : (Sl(p), null);
      case 22:
      case 23:
        return wx(), O = p.memoizedState !== null, f !== null && f.memoizedState !== null !== O && (p.flags |= 8192), O && p.mode & 1 ? Fu & 1073741824 && (Sl(p), p.subtreeFlags & 6 && (p.flags |= 8192)) : Sl(p), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(n(156, p.tag));
  }
  function Rw(f, p) {
    switch (vo(p), p.tag) {
      case 1:
        return Ns(p.type) && cc(), f = p.flags, f & 65536 ? (p.flags = f & -65537 | 128, p) : null;
      case 3:
        return Xs(), Na(Gs), Na(or), vl(), f = p.flags, f & 65536 && !(f & 128) ? (p.flags = f & -65537 | 128, p) : null;
      case 5:
        return lf(p), null;
      case 13:
        if (Na(bs), f = p.memoizedState, f !== null && f.dehydrated !== null) {
          if (p.alternate === null) throw Error(n(340));
          Ys();
        }
        return f = p.flags, f & 65536 ? (p.flags = f & -65537 | 128, p) : null;
      case 19:
        return Na(bs), null;
      case 4:
        return Xs(), null;
      case 10:
        return f0(p.type._context), null;
      case 22:
      case 23:
        return wx(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Hp = !1, zo = !1, v0 = typeof WeakSet == "function" ? WeakSet : Set, kn = null;
  function Vp(f, p) {
    var N = f.ref;
    if (N !== null) if (typeof N == "function") try {
      N(null);
    } catch (O) {
      Qr(f, p, O);
    }
    else N.current = null;
  }
  function px(f, p, N) {
    try {
      N();
    } catch (O) {
      Qr(f, p, O);
    }
  }
  var gx = !1;
  function Ly(f, p) {
    if (X1 = xm, f = si(), Fo(f)) {
      if ("selectionStart" in f) var N = { start: f.selectionStart, end: f.selectionEnd };
      else e: {
        N = (N = f.ownerDocument) && N.defaultView || window;
        var O = N.getSelection && N.getSelection();
        if (O && O.rangeCount !== 0) {
          N = O.anchorNode;
          var V = O.anchorOffset, J = O.focusNode;
          O = O.focusOffset;
          try {
            N.nodeType, J.nodeType;
          } catch {
            N = null;
            break e;
          }
          var me = 0, je = -1, De = -1, Je = 0, Mt = 0, Dt = f, Tt = null;
          t: for (; ; ) {
            for (var vn; Dt !== N || V !== 0 && Dt.nodeType !== 3 || (je = me + V), Dt !== J || O !== 0 && Dt.nodeType !== 3 || (De = me + O), Dt.nodeType === 3 && (me += Dt.nodeValue.length), (vn = Dt.firstChild) !== null; )
              Tt = Dt, Dt = vn;
            for (; ; ) {
              if (Dt === f) break t;
              if (Tt === N && ++Je === V && (je = me), Tt === J && ++Mt === O && (De = me), (vn = Dt.nextSibling) !== null) break;
              Dt = Tt, Tt = Dt.parentNode;
            }
            Dt = vn;
          }
          N = je === -1 || De === -1 ? null : { start: je, end: De };
        } else N = null;
      }
      N = N || { start: 0, end: 0 };
    } else N = null;
    for (Bf = { focusedElem: f, selectionRange: N }, xm = !1, kn = p; kn !== null; ) if (p = kn, f = p.child, (p.subtreeFlags & 1028) !== 0 && f !== null) f.return = p, kn = f;
    else for (; kn !== null; ) {
      p = kn;
      try {
        var _n = p.alternate;
        if (p.flags & 1024) switch (p.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (_n !== null) {
              var An = _n.memoizedProps, vi = _n.memoizedState, Ve = p.stateNode, Oe = Ve.getSnapshotBeforeUpdate(p.elementType === p.type ? An : Ei(p.type, An), vi);
              Ve.__reactInternalSnapshotBeforeUpdate = Oe;
            }
            break;
          case 3:
            var Ge = p.stateNode.containerInfo;
            Ge.nodeType === 1 ? Ge.textContent = "" : Ge.nodeType === 9 && Ge.documentElement && Ge.removeChild(Ge.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(n(163));
        }
      } catch (zt) {
        Qr(p, p.return, zt);
      }
      if (f = p.sibling, f !== null) {
        f.return = p.return, kn = f;
        break;
      }
      kn = p.return;
    }
    return _n = gx, gx = !1, _n;
  }
  function Lh(f, p, N) {
    var O = p.updateQueue;
    if (O = O !== null ? O.lastEffect : null, O !== null) {
      var V = O = O.next;
      do {
        if ((V.tag & f) === f) {
          var J = V.destroy;
          V.destroy = void 0, J !== void 0 && px(p, N, J);
        }
        V = V.next;
      } while (V !== O);
    }
  }
  function ig(f, p) {
    if (p = p.updateQueue, p = p !== null ? p.lastEffect : null, p !== null) {
      var N = p = p.next;
      do {
        if ((N.tag & f) === f) {
          var O = N.create;
          N.destroy = O();
        }
        N = N.next;
      } while (N !== p);
    }
  }
  function Iy(f) {
    var p = f.ref;
    if (p !== null) {
      var N = f.stateNode;
      switch (f.tag) {
        case 5:
          f = N;
          break;
        default:
          f = N;
      }
      typeof p == "function" ? p(f) : p.current = f;
    }
  }
  function ib(f) {
    var p = f.alternate;
    p !== null && (f.alternate = null, ib(p)), f.child = null, f.deletions = null, f.sibling = null, f.tag === 5 && (p = f.stateNode, p !== null && (delete p[Vc], delete p[cd], delete p[_m], delete p[Tm], delete p[gl])), f.stateNode = null, f.return = null, f.dependencies = null, f.memoizedProps = null, f.memoizedState = null, f.pendingProps = null, f.stateNode = null, f.updateQueue = null;
  }
  function $p(f) {
    return f.tag === 5 || f.tag === 3 || f.tag === 4;
  }
  function ob(f) {
    e: for (; ; ) {
      for (; f.sibling === null; ) {
        if (f.return === null || $p(f.return)) return null;
        f = f.return;
      }
      for (f.sibling.return = f.return, f = f.sibling; f.tag !== 5 && f.tag !== 6 && f.tag !== 18; ) {
        if (f.flags & 2 || f.child === null || f.tag === 4) continue e;
        f.child.return = f, f = f.child;
      }
      if (!(f.flags & 2)) return f.stateNode;
    }
  }
  function Fy(f, p, N) {
    var O = f.tag;
    if (O === 5 || O === 6) f = f.stateNode, p ? N.nodeType === 8 ? N.parentNode.insertBefore(f, p) : N.insertBefore(f, p) : (N.nodeType === 8 ? (p = N.parentNode, p.insertBefore(f, N)) : (p = N, p.appendChild(f)), N = N._reactRootContainer, N != null || p.onclick !== null || (p.onclick = zf));
    else if (O !== 4 && (f = f.child, f !== null)) for (Fy(f, p, N), f = f.sibling; f !== null; ) Fy(f, p, N), f = f.sibling;
  }
  function x0(f, p, N) {
    var O = f.tag;
    if (O === 5 || O === 6) f = f.stateNode, p ? N.insertBefore(f, p) : N.appendChild(f);
    else if (O !== 4 && (f = f.child, f !== null)) for (x0(f, p, N), f = f.sibling; f !== null; ) x0(f, p, N), f = f.sibling;
  }
  var Ls = null, Ui = !1;
  function wl(f, p, N) {
    for (N = N.child; N !== null; ) Xf(f, p, N), N = N.sibling;
  }
  function Xf(f, p, N) {
    if (Ms && typeof Ms.onCommitFiberUnmount == "function") try {
      Ms.onCommitFiberUnmount(Ki, N);
    } catch {
    }
    switch (N.tag) {
      case 5:
        zo || Vp(N, p);
      case 6:
        var O = Ls, V = Ui;
        Ls = null, wl(f, p, N), Ls = O, Ui = V, Ls !== null && (Ui ? (f = Ls, N = N.stateNode, f.nodeType === 8 ? f.parentNode.removeChild(N) : f.removeChild(N)) : Ls.removeChild(N.stateNode));
        break;
      case 18:
        Ls !== null && (Ui ? (f = Ls, N = N.stateNode, f.nodeType === 8 ? ld(f.parentNode, N) : f.nodeType === 1 && ld(f, N), nc(f)) : ld(Ls, N.stateNode));
        break;
      case 4:
        O = Ls, V = Ui, Ls = N.stateNode.containerInfo, Ui = !0, wl(f, p, N), Ls = O, Ui = V;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!zo && (O = N.updateQueue, O !== null && (O = O.lastEffect, O !== null))) {
          V = O = O.next;
          do {
            var J = V, me = J.destroy;
            J = J.tag, me !== void 0 && (J & 2 || J & 4) && px(N, p, me), V = V.next;
          } while (V !== O);
        }
        wl(f, p, N);
        break;
      case 1:
        if (!zo && (Vp(N, p), O = N.stateNode, typeof O.componentWillUnmount == "function")) try {
          O.props = N.memoizedProps, O.state = N.memoizedState, O.componentWillUnmount();
        } catch (je) {
          Qr(N, p, je);
        }
        wl(f, p, N);
        break;
      case 21:
        wl(f, p, N);
        break;
      case 22:
        N.mode & 1 ? (zo = (O = zo) || N.memoizedState !== null, wl(f, p, N), zo = O) : wl(f, p, N);
        break;
      default:
        wl(f, p, N);
    }
  }
  function Gp(f) {
    var p = f.updateQueue;
    if (p !== null) {
      f.updateQueue = null;
      var N = f.stateNode;
      N === null && (N = f.stateNode = new v0()), p.forEach(function(O) {
        var V = db.bind(null, f, O);
        N.has(O) || (N.add(O), O.then(V, V));
      });
    }
  }
  function so(f, p) {
    var N = p.deletions;
    if (N !== null) for (var O = 0; O < N.length; O++) {
      var V = N[O];
      try {
        var J = f, me = p, je = me;
        e: for (; je !== null; ) {
          switch (je.tag) {
            case 5:
              Ls = je.stateNode, Ui = !1;
              break e;
            case 3:
              Ls = je.stateNode.containerInfo, Ui = !0;
              break e;
            case 4:
              Ls = je.stateNode.containerInfo, Ui = !0;
              break e;
          }
          je = je.return;
        }
        if (Ls === null) throw Error(n(160));
        Xf(J, me, V), Ls = null, Ui = !1;
        var De = V.alternate;
        De !== null && (De.return = null), V.return = null;
      } catch (Je) {
        Qr(V, p, Je);
      }
    }
    if (p.subtreeFlags & 12854) for (p = p.child; p !== null; ) Uy(p, f), p = p.sibling;
  }
  function Uy(f, p) {
    var N = f.alternate, O = f.flags;
    switch (f.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (so(p, f), Qf(f), O & 4) {
          try {
            Lh(3, f, f.return), ig(3, f);
          } catch (An) {
            Qr(f, f.return, An);
          }
          try {
            Lh(5, f, f.return);
          } catch (An) {
            Qr(f, f.return, An);
          }
        }
        break;
      case 1:
        so(p, f), Qf(f), O & 512 && N !== null && Vp(N, N.return);
        break;
      case 5:
        if (so(p, f), Qf(f), O & 512 && N !== null && Vp(N, N.return), f.flags & 32) {
          var V = f.stateNode;
          try {
            ls(V, "");
          } catch (An) {
            Qr(f, f.return, An);
          }
        }
        if (O & 4 && (V = f.stateNode, V != null)) {
          var J = f.memoizedProps, me = N !== null ? N.memoizedProps : J, je = f.type, De = f.updateQueue;
          if (f.updateQueue = null, De !== null) try {
            je === "input" && J.type === "radio" && J.name != null && er(V, J), lt(je, me);
            var Je = lt(je, J);
            for (me = 0; me < De.length; me += 2) {
              var Mt = De[me], Dt = De[me + 1];
              Mt === "style" ? qt(V, Dt) : Mt === "dangerouslySetInnerHTML" ? ai(V, Dt) : Mt === "children" ? ls(V, Dt) : R(V, Mt, Dt, Je);
            }
            switch (je) {
              case "input":
                It(V, J);
                break;
              case "textarea":
                Vt(V, J);
                break;
              case "select":
                var Tt = V._wrapperState.wasMultiple;
                V._wrapperState.wasMultiple = !!J.multiple;
                var vn = J.value;
                vn != null ? tt(V, !!J.multiple, vn, !1) : Tt !== !!J.multiple && (J.defaultValue != null ? tt(
                  V,
                  !!J.multiple,
                  J.defaultValue,
                  !0
                ) : tt(V, !!J.multiple, J.multiple ? [] : "", !1));
            }
            V[cd] = J;
          } catch (An) {
            Qr(f, f.return, An);
          }
        }
        break;
      case 6:
        if (so(p, f), Qf(f), O & 4) {
          if (f.stateNode === null) throw Error(n(162));
          V = f.stateNode, J = f.memoizedProps;
          try {
            V.nodeValue = J;
          } catch (An) {
            Qr(f, f.return, An);
          }
        }
        break;
      case 3:
        if (so(p, f), Qf(f), O & 4 && N !== null && N.memoizedState.isDehydrated) try {
          nc(p.containerInfo);
        } catch (An) {
          Qr(f, f.return, An);
        }
        break;
      case 4:
        so(p, f), Qf(f);
        break;
      case 13:
        so(p, f), Qf(f), V = f.child, V.flags & 8192 && (J = V.memoizedState !== null, V.stateNode.isHidden = J, !J || V.alternate !== null && V.alternate.memoizedState !== null || (S0 = Gn())), O & 4 && Gp(f);
        break;
      case 22:
        if (Mt = N !== null && N.memoizedState !== null, f.mode & 1 ? (zo = (Je = zo) || Mt, so(p, f), zo = Je) : so(p, f), Qf(f), O & 8192) {
          if (Je = f.memoizedState !== null, (f.stateNode.isHidden = Je) && !Mt && f.mode & 1) for (kn = f, Mt = f.child; Mt !== null; ) {
            for (Dt = kn = Mt; kn !== null; ) {
              switch (Tt = kn, vn = Tt.child, Tt.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Lh(4, Tt, Tt.return);
                  break;
                case 1:
                  Vp(Tt, Tt.return);
                  var _n = Tt.stateNode;
                  if (typeof _n.componentWillUnmount == "function") {
                    O = Tt, N = Tt.return;
                    try {
                      p = O, _n.props = p.memoizedProps, _n.state = p.memoizedState, _n.componentWillUnmount();
                    } catch (An) {
                      Qr(O, N, An);
                    }
                  }
                  break;
                case 5:
                  Vp(Tt, Tt.return);
                  break;
                case 22:
                  if (Tt.memoizedState !== null) {
                    vx(Dt);
                    continue;
                  }
              }
              vn !== null ? (vn.return = Tt, kn = vn) : vx(Dt);
            }
            Mt = Mt.sibling;
          }
          e: for (Mt = null, Dt = f; ; ) {
            if (Dt.tag === 5) {
              if (Mt === null) {
                Mt = Dt;
                try {
                  V = Dt.stateNode, Je ? (J = V.style, typeof J.setProperty == "function" ? J.setProperty("display", "none", "important") : J.display = "none") : (je = Dt.stateNode, De = Dt.memoizedProps.style, me = De != null && De.hasOwnProperty("display") ? De.display : null, je.style.display = Xt("display", me));
                } catch (An) {
                  Qr(f, f.return, An);
                }
              }
            } else if (Dt.tag === 6) {
              if (Mt === null) try {
                Dt.stateNode.nodeValue = Je ? "" : Dt.memoizedProps;
              } catch (An) {
                Qr(f, f.return, An);
              }
            } else if ((Dt.tag !== 22 && Dt.tag !== 23 || Dt.memoizedState === null || Dt === f) && Dt.child !== null) {
              Dt.child.return = Dt, Dt = Dt.child;
              continue;
            }
            if (Dt === f) break e;
            for (; Dt.sibling === null; ) {
              if (Dt.return === null || Dt.return === f) break e;
              Mt === Dt && (Mt = null), Dt = Dt.return;
            }
            Mt === Dt && (Mt = null), Dt.sibling.return = Dt.return, Dt = Dt.sibling;
          }
        }
        break;
      case 19:
        so(p, f), Qf(f), O & 4 && Gp(f);
        break;
      case 21:
        break;
      default:
        so(
          p,
          f
        ), Qf(f);
    }
  }
  function Qf(f) {
    var p = f.flags;
    if (p & 2) {
      try {
        e: {
          for (var N = f.return; N !== null; ) {
            if ($p(N)) {
              var O = N;
              break e;
            }
            N = N.return;
          }
          throw Error(n(160));
        }
        switch (O.tag) {
          case 5:
            var V = O.stateNode;
            O.flags & 32 && (ls(V, ""), O.flags &= -33);
            var J = ob(f);
            x0(f, J, V);
            break;
          case 3:
          case 4:
            var me = O.stateNode.containerInfo, je = ob(f);
            Fy(f, je, me);
            break;
          default:
            throw Error(n(161));
        }
      } catch (De) {
        Qr(f, f.return, De);
      }
      f.flags &= -3;
    }
    p & 4096 && (f.flags &= -4097);
  }
  function E5(f, p, N) {
    kn = f, yx(f);
  }
  function yx(f, p, N) {
    for (var O = (f.mode & 1) !== 0; kn !== null; ) {
      var V = kn, J = V.child;
      if (V.tag === 22 && O) {
        var me = V.memoizedState !== null || Hp;
        if (!me) {
          var je = V.alternate, De = je !== null && je.memoizedState !== null || zo;
          je = Hp;
          var Je = zo;
          if (Hp = me, (zo = De) && !Je) for (kn = V; kn !== null; ) me = kn, De = me.child, me.tag === 22 && me.memoizedState !== null ? lb(V) : De !== null ? (De.return = me, kn = De) : lb(V);
          for (; J !== null; ) kn = J, yx(J), J = J.sibling;
          kn = V, Hp = je, zo = Je;
        }
        Wp(f);
      } else V.subtreeFlags & 8772 && J !== null ? (J.return = V, kn = J) : Wp(f);
    }
  }
  function Wp(f) {
    for (; kn !== null; ) {
      var p = kn;
      if (p.flags & 8772) {
        var N = p.alternate;
        try {
          if (p.flags & 8772) switch (p.tag) {
            case 0:
            case 11:
            case 15:
              zo || ig(5, p);
              break;
            case 1:
              var O = p.stateNode;
              if (p.flags & 4 && !zo) if (N === null) O.componentDidMount();
              else {
                var V = p.elementType === p.type ? N.memoizedProps : Ei(p.type, N.memoizedProps);
                O.componentDidUpdate(V, N.memoizedState, O.__reactInternalSnapshotBeforeUpdate);
              }
              var J = p.updateQueue;
              J !== null && ks(p, J, O);
              break;
            case 3:
              var me = p.updateQueue;
              if (me !== null) {
                if (N = null, p.child !== null) switch (p.child.tag) {
                  case 5:
                    N = p.child.stateNode;
                    break;
                  case 1:
                    N = p.child.stateNode;
                }
                ks(p, me, N);
              }
              break;
            case 5:
              var je = p.stateNode;
              if (N === null && p.flags & 4) {
                N = je;
                var De = p.memoizedProps;
                switch (p.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    De.autoFocus && N.focus();
                    break;
                  case "img":
                    De.src && (N.src = De.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (p.memoizedState === null) {
                var Je = p.alternate;
                if (Je !== null) {
                  var Mt = Je.memoizedState;
                  if (Mt !== null) {
                    var Dt = Mt.dehydrated;
                    Dt !== null && nc(Dt);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(n(163));
          }
          zo || p.flags & 512 && Iy(p);
        } catch (Tt) {
          Qr(p, p.return, Tt);
        }
      }
      if (p === f) {
        kn = null;
        break;
      }
      if (N = p.sibling, N !== null) {
        N.return = p.return, kn = N;
        break;
      }
      kn = p.return;
    }
  }
  function vx(f) {
    for (; kn !== null; ) {
      var p = kn;
      if (p === f) {
        kn = null;
        break;
      }
      var N = p.sibling;
      if (N !== null) {
        N.return = p.return, kn = N;
        break;
      }
      kn = p.return;
    }
  }
  function lb(f) {
    for (; kn !== null; ) {
      var p = kn;
      try {
        switch (p.tag) {
          case 0:
          case 11:
          case 15:
            var N = p.return;
            try {
              ig(4, p);
            } catch (De) {
              Qr(p, N, De);
            }
            break;
          case 1:
            var O = p.stateNode;
            if (typeof O.componentDidMount == "function") {
              var V = p.return;
              try {
                O.componentDidMount();
              } catch (De) {
                Qr(p, V, De);
              }
            }
            var J = p.return;
            try {
              Iy(p);
            } catch (De) {
              Qr(p, J, De);
            }
            break;
          case 5:
            var me = p.return;
            try {
              Iy(p);
            } catch (De) {
              Qr(p, me, De);
            }
        }
      } catch (De) {
        Qr(p, p.return, De);
      }
      if (p === f) {
        kn = null;
        break;
      }
      var je = p.sibling;
      if (je !== null) {
        je.return = p.return, kn = je;
        break;
      }
      kn = p.return;
    }
  }
  var Dw = Math.ceil, cf = U.ReactCurrentDispatcher, _i = U.ReactCurrentOwner, Cl = U.ReactCurrentBatchConfig, ra = 0, zi = null, ei = null, Bo = 0, Fu = 0, wo = Dr(0), Ho = 0, Yp = null, qp = 0, og = 0, b0 = 0, Fm = null, Vo = null, S0 = 0, Ih = 1 / 0, Zf = null, zy = !1, Jf = null, $o = null, Fh = !1, Uu = null, xx = 0, Kp = 0, bx = null, w0 = -1, Um = 0;
  function Go() {
    return ra & 6 ? Gn() : w0 !== -1 ? w0 : w0 = Gn();
  }
  function bd(f) {
    return f.mode & 1 ? ra & 2 && Bo !== 0 ? Bo & -Bo : Th.transition !== null ? (Um === 0 && (Um = jp()), Um) : (f = Rr, f !== 0 || (f = window.event, f = f === void 0 ? 16 : My(f.type)), f) : 1;
  }
  function ds(f, p, N, O) {
    if (50 < Kp) throw Kp = 0, bx = null, Error(n(185));
    Rf(f, N, O), (!(ra & 2) || f !== zi) && (f === zi && (!(ra & 2) && (og |= N), Ho === 4 && Qc(f, Bo)), Ti(f, O), N === 1 && ra === 0 && !(p.mode & 1) && (Ih = Gn() + 500, js && Es()));
  }
  function Ti(f, p) {
    var N = f.callbackNode;
    fh(f, p);
    var O = Ul(f, f === zi ? Bo : 0);
    if (O === 0) N !== null && ga(N), f.callbackNode = null, f.callbackPriority = 0;
    else if (p = O & -O, f.callbackPriority !== p) {
      if (N != null && ga(N), p === 1) f.tag === 0 ? Wc(Bm.bind(null, f)) : Pu(Bm.bind(null, f)), Eh(function() {
        !(ra & 6) && Es();
      }), N = null;
      else {
        switch (Df(O)) {
          case 1:
            N = ta;
            break;
          case 4:
            N = ir;
            break;
          case 16:
            N = Hs;
            break;
          case 536870912:
            N = Fl;
            break;
          default:
            N = Hs;
        }
        N = _5(N, lg.bind(null, f));
      }
      f.callbackPriority = p, f.callbackNode = N;
    }
  }
  function lg(f, p) {
    if (w0 = -1, Um = 0, ra & 6) throw Error(n(327));
    var N = f.callbackNode;
    if (zh() && f.callbackNode !== N) return null;
    var O = Ul(f, f === zi ? Bo : 0);
    if (O === 0) return null;
    if (O & 30 || O & f.expiredLanes || p) p = N0(f, O);
    else {
      p = O;
      var V = ra;
      ra |= 2;
      var J = C0();
      (zi !== f || Bo !== p) && (Zf = null, Ih = Gn() + 500, Xp(f, p));
      do
        try {
          ub();
          break;
        } catch (je) {
          cb(f, je);
        }
      while (!0);
      gc(), cf.current = J, ra = V, ei !== null ? p = 0 : (zi = null, Bo = 0, p = Ho);
    }
    if (p !== 0) {
      if (p === 2 && (V = mh(f), V !== 0 && (O = V, p = zm(f, V))), p === 1) throw N = Yp, Xp(f, 0), Qc(f, O), Ti(f, Gn()), N;
      if (p === 6) Qc(f, O);
      else {
        if (V = f.current.alternate, !(O & 30) && !Hy(V) && (p = N0(f, O), p === 2 && (J = mh(f), J !== 0 && (O = J, p = zm(f, J))), p === 1)) throw N = Yp, Xp(f, 0), Qc(f, O), Ti(f, Gn()), N;
        switch (f.finishedWork = V, f.finishedLanes = O, p) {
          case 0:
          case 1:
            throw Error(n(345));
          case 2:
            Sd(f, Vo, Zf);
            break;
          case 3:
            if (Qc(f, O), (O & 130023424) === O && (p = S0 + 500 - Gn(), 10 < p)) {
              if (Ul(f, 0) !== 0) break;
              if (V = f.suspendedLanes, (V & O) !== O) {
                Go(), f.pingedLanes |= f.suspendedLanes & V;
                break;
              }
              f.timeoutHandle = eo(Sd.bind(null, f, Vo, Zf), p);
              break;
            }
            Sd(f, Vo, Zf);
            break;
          case 4:
            if (Qc(f, O), (O & 4194240) === O) break;
            for (p = f.eventTimes, V = -1; 0 < O; ) {
              var me = 31 - Mr(O);
              J = 1 << me, me = p[me], me > V && (V = me), O &= ~J;
            }
            if (O = V, O = Gn() - O, O = (120 > O ? 120 : 480 > O ? 480 : 1080 > O ? 1080 : 1920 > O ? 1920 : 3e3 > O ? 3e3 : 4320 > O ? 4320 : 1960 * Dw(O / 1960)) - O, 10 < O) {
              f.timeoutHandle = eo(Sd.bind(null, f, Vo, Zf), O);
              break;
            }
            Sd(f, Vo, Zf);
            break;
          case 5:
            Sd(f, Vo, Zf);
            break;
          default:
            throw Error(n(329));
        }
      }
    }
    return Ti(f, Gn()), f.callbackNode === N ? lg.bind(null, f) : null;
  }
  function zm(f, p) {
    var N = Fm;
    return f.current.memoizedState.isDehydrated && (Xp(f, p).flags |= 256), f = N0(f, p), f !== 2 && (p = Vo, Vo = N, p !== null && By(p)), f;
  }
  function By(f) {
    Vo === null ? Vo = f : Vo.push.apply(Vo, f);
  }
  function Hy(f) {
    for (var p = f; ; ) {
      if (p.flags & 16384) {
        var N = p.updateQueue;
        if (N !== null && (N = N.stores, N !== null)) for (var O = 0; O < N.length; O++) {
          var V = N[O], J = V.getSnapshot;
          V = V.value;
          try {
            if (!Pa(J(), V)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (N = p.child, p.subtreeFlags & 16384 && N !== null) N.return = p, p = N;
      else {
        if (p === f) break;
        for (; p.sibling === null; ) {
          if (p.return === null || p.return === f) return !0;
          p = p.return;
        }
        p.sibling.return = p.return, p = p.sibling;
      }
    }
    return !0;
  }
  function Qc(f, p) {
    for (p &= ~b0, p &= ~og, f.suspendedLanes |= p, f.pingedLanes &= ~p, f = f.expirationTimes; 0 < p; ) {
      var N = 31 - Mr(p), O = 1 << N;
      f[N] = -1, p &= ~O;
    }
  }
  function Bm(f) {
    if (ra & 6) throw Error(n(327));
    zh();
    var p = Ul(f, 0);
    if (!(p & 1)) return Ti(f, Gn()), null;
    var N = N0(f, p);
    if (f.tag !== 0 && N === 2) {
      var O = mh(f);
      O !== 0 && (p = O, N = zm(f, O));
    }
    if (N === 1) throw N = Yp, Xp(f, 0), Qc(f, p), Ti(f, Gn()), N;
    if (N === 6) throw Error(n(345));
    return f.finishedWork = f.current.alternate, f.finishedLanes = p, Sd(f, Vo, Zf), Ti(f, Gn()), null;
  }
  function Sx(f, p) {
    var N = ra;
    ra |= 1;
    try {
      return f(p);
    } finally {
      ra = N, ra === 0 && (Ih = Gn() + 500, js && Es());
    }
  }
  function uf(f) {
    Uu !== null && Uu.tag === 0 && !(ra & 6) && zh();
    var p = ra;
    ra |= 1;
    var N = Cl.transition, O = Rr;
    try {
      if (Cl.transition = null, Rr = 1, f) return f();
    } finally {
      Rr = O, Cl.transition = N, ra = p, !(ra & 6) && Es();
    }
  }
  function wx() {
    Fu = wo.current, Na(wo);
  }
  function Xp(f, p) {
    f.finishedWork = null, f.finishedLanes = 0;
    var N = f.timeoutHandle;
    if (N !== -1 && (f.timeoutHandle = -1, Pp(N)), ei !== null) for (N = ei.return; N !== null; ) {
      var O = N;
      switch (vo(O), O.tag) {
        case 1:
          O = O.type.childContextTypes, O != null && cc();
          break;
        case 3:
          Xs(), Na(Gs), Na(or), vl();
          break;
        case 5:
          lf(O);
          break;
        case 4:
          Xs();
          break;
        case 13:
          Na(bs);
          break;
        case 19:
          Na(bs);
          break;
        case 10:
          f0(O.type._context);
          break;
        case 22:
        case 23:
          wx();
      }
      N = N.return;
    }
    if (zi = f, ei = f = zu(f.current, null), Bo = Fu = p, Ho = 0, Yp = null, b0 = og = qp = 0, Vo = Fm = null, no !== null) {
      for (p = 0; p < no.length; p++) if (N = no[p], O = N.interleaved, O !== null) {
        N.interleaved = null;
        var V = O.next, J = N.pending;
        if (J !== null) {
          var me = J.next;
          J.next = V, O.next = me;
        }
        N.pending = O;
      }
      no = null;
    }
    return f;
  }
  function cb(f, p) {
    do {
      var N = ei;
      try {
        if (gc(), Fp.current = So, Fi) {
          for (var O = Mn.memoizedState; O !== null; ) {
            var V = O.queue;
            V !== null && (V.pending = null), O = O.next;
          }
          Fi = !1;
        }
        if (Sn = 0, $r = ar = Mn = null, hd = !1, Ou = 0, _i.current = null, N === null || N.return === null) {
          Ho = 1, Yp = p, ei = null;
          break;
        }
        e: {
          var J = f, me = N.return, je = N, De = p;
          if (p = Bo, je.flags |= 32768, De !== null && typeof De == "object" && typeof De.then == "function") {
            var Je = De, Mt = je, Dt = Mt.tag;
            if (!(Mt.mode & 1) && (Dt === 0 || Dt === 11 || Dt === 15)) {
              var Tt = Mt.alternate;
              Tt ? (Mt.updateQueue = Tt.updateQueue, Mt.memoizedState = Tt.memoizedState, Mt.lanes = Tt.lanes) : (Mt.updateQueue = null, Mt.memoizedState = null);
            }
            var vn = P(me);
            if (vn !== null) {
              vn.flags &= -257, B(vn, me, je, J, p), vn.mode & 1 && x(J, Je, p), p = vn, De = Je;
              var _n = p.updateQueue;
              if (_n === null) {
                var An = /* @__PURE__ */ new Set();
                An.add(De), p.updateQueue = An;
              } else _n.add(De);
              break e;
            } else {
              if (!(p & 1)) {
                x(J, Je, p), Zc();
                break e;
              }
              De = Error(n(426));
            }
          } else if (Aa && je.mode & 1) {
            var vi = P(me);
            if (vi !== null) {
              !(vi.flags & 65536) && (vi.flags |= 256), B(vi, me, je, J, p), Q1(qf(De, je));
              break e;
            }
          }
          J = De = qf(De, je), Ho !== 4 && (Ho = 2), Fm === null ? Fm = [J] : Fm.push(J), J = me;
          do {
            switch (J.tag) {
              case 3:
                J.flags |= 65536, p &= -p, J.lanes |= p;
                var Ve = hx(J, De, p);
                J1(J, Ve);
                break e;
              case 1:
                je = De;
                var Oe = J.type, Ge = J.stateNode;
                if (!(J.flags & 128) && (typeof Oe.getDerivedStateFromError == "function" || Ge !== null && typeof Ge.componentDidCatch == "function" && ($o === null || !$o.has(Ge)))) {
                  J.flags |= 65536, p &= -p, J.lanes |= p;
                  var zt = v(J, je, p);
                  J1(J, zt);
                  break e;
                }
            }
            J = J.return;
          } while (J !== null);
        }
        Uh(N);
      } catch (zn) {
        p = zn, ei === N && N !== null && (ei = N = N.return);
        continue;
      }
      break;
    } while (!0);
  }
  function C0() {
    var f = cf.current;
    return cf.current = So, f === null ? So : f;
  }
  function Zc() {
    (Ho === 0 || Ho === 3 || Ho === 2) && (Ho = 4), zi === null || !(qp & 268435455) && !(og & 268435455) || Qc(zi, Bo);
  }
  function N0(f, p) {
    var N = ra;
    ra |= 2;
    var O = C0();
    (zi !== f || Bo !== p) && (Zf = null, Xp(f, p));
    do
      try {
        j0();
        break;
      } catch (V) {
        cb(f, V);
      }
    while (!0);
    if (gc(), ra = N, cf.current = O, ei !== null) throw Error(n(261));
    return zi = null, Bo = 0, Ho;
  }
  function j0() {
    for (; ei !== null; ) k5(ei);
  }
  function ub() {
    for (; ei !== null && !Tr(); ) k5(ei);
  }
  function k5(f) {
    var p = Cx(f.alternate, f, Fu);
    f.memoizedProps = f.pendingProps, p === null ? Uh(f) : ei = p, _i.current = null;
  }
  function Uh(f) {
    var p = f;
    do {
      var N = p.alternate;
      if (f = p.return, p.flags & 32768) {
        if (N = Rw(N, p), N !== null) {
          N.flags &= 32767, ei = N;
          return;
        }
        if (f !== null) f.flags |= 32768, f.subtreeFlags = 0, f.deletions = null;
        else {
          Ho = 6, ei = null;
          return;
        }
      } else if (N = Mw(N, p, Fu), N !== null) {
        ei = N;
        return;
      }
      if (p = p.sibling, p !== null) {
        ei = p;
        return;
      }
      ei = p = f;
    } while (p !== null);
    Ho === 0 && (Ho = 5);
  }
  function Sd(f, p, N) {
    var O = Rr, V = Cl.transition;
    try {
      Cl.transition = null, Rr = 1, Pw(f, p, N, O);
    } finally {
      Cl.transition = V, Rr = O;
    }
    return null;
  }
  function Pw(f, p, N, O) {
    do
      zh();
    while (Uu !== null);
    if (ra & 6) throw Error(n(327));
    N = f.finishedWork;
    var V = f.finishedLanes;
    if (N === null) return null;
    if (f.finishedWork = null, f.finishedLanes = 0, N === f.current) throw Error(n(177));
    f.callbackNode = null, f.callbackPriority = 0;
    var J = N.lanes | N.childLanes;
    if (n0(f, J), f === zi && (ei = zi = null, Bo = 0), !(N.subtreeFlags & 2064) && !(N.flags & 2064) || Fh || (Fh = !0, _5(Hs, function() {
      return zh(), null;
    })), J = (N.flags & 15990) !== 0, N.subtreeFlags & 15990 || J) {
      J = Cl.transition, Cl.transition = null;
      var me = Rr;
      Rr = 1;
      var je = ra;
      ra |= 4, _i.current = null, Ly(f, N), Uy(N, f), Ff(Bf), xm = !!X1, Bf = X1 = null, f.current = N, E5(N), Fn(), ra = je, Rr = me, Cl.transition = J;
    } else f.current = N;
    if (Fh && (Fh = !1, Uu = f, xx = V), J = f.pendingLanes, J === 0 && ($o = null), xr(N.stateNode), Ti(f, Gn()), p !== null) for (O = f.onRecoverableError, N = 0; N < p.length; N++) V = p[N], O(V.value, { componentStack: V.stack, digest: V.digest });
    if (zy) throw zy = !1, f = Jf, Jf = null, f;
    return xx & 1 && f.tag !== 0 && zh(), J = f.pendingLanes, J & 1 ? f === bx ? Kp++ : (Kp = 0, bx = f) : Kp = 0, Es(), null;
  }
  function zh() {
    if (Uu !== null) {
      var f = Df(xx), p = Cl.transition, N = Rr;
      try {
        if (Cl.transition = null, Rr = 16 > f ? 16 : f, Uu === null) var O = !1;
        else {
          if (f = Uu, Uu = null, xx = 0, ra & 6) throw Error(n(331));
          var V = ra;
          for (ra |= 4, kn = f.current; kn !== null; ) {
            var J = kn, me = J.child;
            if (kn.flags & 16) {
              var je = J.deletions;
              if (je !== null) {
                for (var De = 0; De < je.length; De++) {
                  var Je = je[De];
                  for (kn = Je; kn !== null; ) {
                    var Mt = kn;
                    switch (Mt.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Lh(8, Mt, J);
                    }
                    var Dt = Mt.child;
                    if (Dt !== null) Dt.return = Mt, kn = Dt;
                    else for (; kn !== null; ) {
                      Mt = kn;
                      var Tt = Mt.sibling, vn = Mt.return;
                      if (ib(Mt), Mt === Je) {
                        kn = null;
                        break;
                      }
                      if (Tt !== null) {
                        Tt.return = vn, kn = Tt;
                        break;
                      }
                      kn = vn;
                    }
                  }
                }
                var _n = J.alternate;
                if (_n !== null) {
                  var An = _n.child;
                  if (An !== null) {
                    _n.child = null;
                    do {
                      var vi = An.sibling;
                      An.sibling = null, An = vi;
                    } while (An !== null);
                  }
                }
                kn = J;
              }
            }
            if (J.subtreeFlags & 2064 && me !== null) me.return = J, kn = me;
            else e: for (; kn !== null; ) {
              if (J = kn, J.flags & 2048) switch (J.tag) {
                case 0:
                case 11:
                case 15:
                  Lh(9, J, J.return);
              }
              var Ve = J.sibling;
              if (Ve !== null) {
                Ve.return = J.return, kn = Ve;
                break e;
              }
              kn = J.return;
            }
          }
          var Oe = f.current;
          for (kn = Oe; kn !== null; ) {
            me = kn;
            var Ge = me.child;
            if (me.subtreeFlags & 2064 && Ge !== null) Ge.return = me, kn = Ge;
            else e: for (me = Oe; kn !== null; ) {
              if (je = kn, je.flags & 2048) try {
                switch (je.tag) {
                  case 0:
                  case 11:
                  case 15:
                    ig(9, je);
                }
              } catch (zn) {
                Qr(je, je.return, zn);
              }
              if (je === me) {
                kn = null;
                break e;
              }
              var zt = je.sibling;
              if (zt !== null) {
                zt.return = je.return, kn = zt;
                break e;
              }
              kn = je.return;
            }
          }
          if (ra = V, Es(), Ms && typeof Ms.onPostCommitFiberRoot == "function") try {
            Ms.onPostCommitFiberRoot(Ki, f);
          } catch {
          }
          O = !0;
        }
        return O;
      } finally {
        Rr = N, Cl.transition = p;
      }
    }
    return !1;
  }
  function Jc(f, p, N) {
    p = qf(N, p), p = hx(f, p, 1), f = of(f, p, 1), p = Go(), f !== null && (Rf(f, 1, p), Ti(f, p));
  }
  function Qr(f, p, N) {
    if (f.tag === 3) Jc(f, f, N);
    else for (; p !== null; ) {
      if (p.tag === 3) {
        Jc(p, f, N);
        break;
      } else if (p.tag === 1) {
        var O = p.stateNode;
        if (typeof p.type.getDerivedStateFromError == "function" || typeof O.componentDidCatch == "function" && ($o === null || !$o.has(O))) {
          f = qf(N, f), f = v(p, f, 1), p = of(p, f, 1), f = Go(), p !== null && (Rf(p, 1, f), Ti(p, f));
          break;
        }
      }
      p = p.return;
    }
  }
  function Hm(f, p, N) {
    var O = f.pingCache;
    O !== null && O.delete(p), p = Go(), f.pingedLanes |= f.suspendedLanes & N, zi === f && (Bo & N) === N && (Ho === 4 || Ho === 3 && (Bo & 130023424) === Bo && 500 > Gn() - S0 ? Xp(f, 0) : b0 |= N), Ti(f, p);
  }
  function Co(f, p) {
    p === 0 && (f.mode & 1 ? (p = Ju, Ju <<= 1, !(Ju & 130023424) && (Ju = 4194304)) : p = 1);
    var N = Go();
    f = qc(f, p), f !== null && (Rf(f, p, N), Ti(f, N));
  }
  function Wo(f) {
    var p = f.memoizedState, N = 0;
    p !== null && (N = p.retryLane), Co(f, N);
  }
  function db(f, p) {
    var N = 0;
    switch (f.tag) {
      case 13:
        var O = f.stateNode, V = f.memoizedState;
        V !== null && (N = V.retryLane);
        break;
      case 19:
        O = f.stateNode;
        break;
      default:
        throw Error(n(314));
    }
    O !== null && O.delete(p), Co(f, N);
  }
  var Cx;
  Cx = function(f, p, N) {
    if (f !== null) if (f.memoizedProps !== p.pendingProps || Gs.current) ne = !0;
    else {
      if (!(f.lanes & N) && !(p.flags & 128)) return ne = !1, Xc(f, p, N);
      ne = !!(f.flags & 131072);
    }
    else ne = !1, Aa && p.flags & 1048576 && Py(p, dd, p.index);
    switch (p.lanes = 0, p.tag) {
      case 2:
        var O = p.type;
        Wr(f, p), f = p.pendingProps;
        var V = lc(p, or.current);
        Ks(p, N), V = St(null, p, O, f, V, N);
        var J = Qs();
        return p.flags |= 1, typeof V == "object" && V !== null && typeof V.render == "function" && V.$$typeof === void 0 ? (p.tag = 1, p.memoizedState = null, p.updateQueue = null, Ns(O) ? (J = !0, Mm(p)) : J = !1, p.memoizedState = V.state !== null && V.state !== void 0 ? V.state : null, Lp(p), V.updater = vd, p.stateNode = V, V._reactInternals = p, g0(p, O, f, N), p = Ga(null, p, O, !0, J, N)) : (p.tag = 0, Aa && J && Hf(p), be(null, p, V, N), p = p.child), p;
      case 16:
        O = p.elementType;
        e: {
          switch (Wr(f, p), f = p.pendingProps, V = O._init, O = V(O._payload), p.type = O, V = p.tag = E0(O), f = Ei(O, f), V) {
            case 0:
              p = ct(null, p, O, f, N);
              break e;
            case 1:
              p = xa(null, p, O, f, N);
              break e;
            case 11:
              p = Fe(null, p, O, f, N);
              break e;
            case 14:
              p = Ze(null, p, O, Ei(O.type, f), N);
              break e;
          }
          throw Error(n(
            306,
            O,
            ""
          ));
        }
        return p;
      case 0:
        return O = p.type, V = p.pendingProps, V = p.elementType === O ? V : Ei(O, V), ct(f, p, O, V, N);
      case 1:
        return O = p.type, V = p.pendingProps, V = p.elementType === O ? V : Ei(O, V), xa(f, p, O, V, N);
      case 3:
        e: {
          if (bc(p), f === null) throw Error(n(387));
          O = p.pendingProps, J = p.memoizedState, V = J.element, Dm(f, p), Rh(p, O, null, N);
          var me = p.memoizedState;
          if (O = me.element, J.isDehydrated) if (J = { element: O, isDehydrated: !1, cache: me.cache, pendingSuspenseBoundaries: me.pendingSuspenseBoundaries, transitions: me.transitions }, p.updateQueue.baseState = J, p.memoizedState = J, p.flags & 256) {
            V = qf(Error(n(423)), p), p = Zs(f, p, O, N, V);
            break e;
          } else if (O !== V) {
            V = qf(Error(n(424)), p), p = Zs(f, p, O, N, V);
            break e;
          } else for (tn = Hl(p.stateNode.containerInfo.firstChild), mc = p, Aa = !0, ii = null, N = ns(p, null, O, N), p.child = N; N; ) N.flags = N.flags & -3 | 4096, N = N.sibling;
          else {
            if (Ys(), O === V) {
              p = Ea(f, p, N);
              break e;
            }
            be(f, p, O, N);
          }
          p = p.child;
        }
        return p;
      case 5:
        return Dh(p), f === null && fd(p), O = p.type, V = p.pendingProps, J = f !== null ? f.memoizedProps : null, me = V.children, jh(O, V) ? me = null : J !== null && jh(O, J) && (p.flags |= 32), dr(f, p), be(f, p, me, N), p.child;
      case 6:
        return f === null && fd(p), null;
      case 13:
        return rt(f, p, N);
      case 4:
        return Pm(p, p.stateNode.containerInfo), O = p.pendingProps, f === null ? p.child = Mh(p, null, O, N) : be(f, p, O, N), p.child;
      case 11:
        return O = p.type, V = p.pendingProps, V = p.elementType === O ? V : Ei(O, V), Fe(f, p, O, V, N);
      case 7:
        return be(f, p, p.pendingProps, N), p.child;
      case 8:
        return be(f, p, p.pendingProps.children, N), p.child;
      case 12:
        return be(f, p, p.pendingProps.children, N), p.child;
      case 10:
        e: {
          if (O = p.type._context, V = p.pendingProps, J = p.memoizedProps, me = V.value, Oa(Yc, O._currentValue), O._currentValue = me, J !== null) if (Pa(J.value, me)) {
            if (J.children === V.children && !Gs.current) {
              p = Ea(f, p, N);
              break e;
            }
          } else for (J = p.child, J !== null && (J.return = p); J !== null; ) {
            var je = J.dependencies;
            if (je !== null) {
              me = J.child;
              for (var De = je.firstContext; De !== null; ) {
                if (De.context === O) {
                  if (J.tag === 1) {
                    De = ja(-1, N & -N), De.tag = 2;
                    var Je = J.updateQueue;
                    if (Je !== null) {
                      Je = Je.shared;
                      var Mt = Je.pending;
                      Mt === null ? De.next = De : (De.next = Mt.next, Mt.next = De), Je.pending = De;
                    }
                  }
                  J.lanes |= N, De = J.alternate, De !== null && (De.lanes |= N), Vf(
                    J.return,
                    N,
                    p
                  ), je.lanes |= N;
                  break;
                }
                De = De.next;
              }
            } else if (J.tag === 10) me = J.type === p.type ? null : J.child;
            else if (J.tag === 18) {
              if (me = J.return, me === null) throw Error(n(341));
              me.lanes |= N, je = me.alternate, je !== null && (je.lanes |= N), Vf(me, N, p), me = J.sibling;
            } else me = J.child;
            if (me !== null) me.return = J;
            else for (me = J; me !== null; ) {
              if (me === p) {
                me = null;
                break;
              }
              if (J = me.sibling, J !== null) {
                J.return = me.return, me = J;
                break;
              }
              me = me.return;
            }
            J = me;
          }
          be(f, p, V.children, N), p = p.child;
        }
        return p;
      case 9:
        return V = p.type, O = p.pendingProps.children, Ks(p, N), V = Yt(V), O = O(V), p.flags |= 1, be(f, p, O, N), p.child;
      case 14:
        return O = p.type, V = Ei(O, p.pendingProps), V = Ei(O.type, V), Ze(f, p, O, V, N);
      case 15:
        return Ft(f, p, p.type, p.pendingProps, N);
      case 17:
        return O = p.type, V = p.pendingProps, V = p.elementType === O ? V : Ei(O, V), Wr(f, p), p.tag = 1, Ns(O) ? (f = !0, Mm(p)) : f = !1, Ks(p, N), p0(p, O, V), g0(p, O, V, N), Ga(null, p, O, !0, f, N);
      case 19:
        return Js(f, p, N);
      case 22:
        return sn(f, p, N);
    }
    throw Error(n(156, p.tag));
  };
  function _5(f, p) {
    return pa(f, p);
  }
  function pn(f, p, N, O) {
    this.tag = f, this.key = N, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = p, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = O, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function wc(f, p, N, O) {
    return new pn(f, p, N, O);
  }
  function Vy(f) {
    return f = f.prototype, !(!f || !f.isReactComponent);
  }
  function E0(f) {
    if (typeof f == "function") return Vy(f) ? 1 : 0;
    if (f != null) {
      if (f = f.$$typeof, f === se) return 11;
      if (f === ce) return 14;
    }
    return 2;
  }
  function zu(f, p) {
    var N = f.alternate;
    return N === null ? (N = wc(f.tag, p, f.key, f.mode), N.elementType = f.elementType, N.type = f.type, N.stateNode = f.stateNode, N.alternate = f, f.alternate = N) : (N.pendingProps = p, N.type = f.type, N.flags = 0, N.subtreeFlags = 0, N.deletions = null), N.flags = f.flags & 14680064, N.childLanes = f.childLanes, N.lanes = f.lanes, N.child = f.child, N.memoizedProps = f.memoizedProps, N.memoizedState = f.memoizedState, N.updateQueue = f.updateQueue, p = f.dependencies, N.dependencies = p === null ? null : { lanes: p.lanes, firstContext: p.firstContext }, N.sibling = f.sibling, N.index = f.index, N.ref = f.ref, N;
  }
  function La(f, p, N, O, V, J) {
    var me = 2;
    if (O = f, typeof f == "function") Vy(f) && (me = 1);
    else if (typeof f == "string") me = 5;
    else e: switch (f) {
      case K:
        return li(N.children, V, J, p);
      case q:
        me = 8, V |= 8;
        break;
      case Q:
        return f = wc(12, N, p, V | 2), f.elementType = Q, f.lanes = J, f;
      case te:
        return f = wc(13, N, p, V), f.elementType = te, f.lanes = J, f;
      case fe:
        return f = wc(19, N, p, V), f.elementType = fe, f.lanes = J, f;
      case Se:
        return Bi(N, V, J, p);
      default:
        if (typeof f == "object" && f !== null) switch (f.$$typeof) {
          case Z:
            me = 10;
            break e;
          case X:
            me = 9;
            break e;
          case se:
            me = 11;
            break e;
          case ce:
            me = 14;
            break e;
          case pe:
            me = 16, O = null;
            break e;
        }
        throw Error(n(130, f == null ? f : typeof f, ""));
    }
    return p = wc(me, N, p, V), p.elementType = f, p.type = O, p.lanes = J, p;
  }
  function li(f, p, N, O) {
    return f = wc(7, f, O, p), f.lanes = N, f;
  }
  function Bi(f, p, N, O) {
    return f = wc(22, f, O, p), f.elementType = Se, f.lanes = N, f.stateNode = { isHidden: !1 }, f;
  }
  function cg(f, p, N) {
    return f = wc(6, f, null, p), f.lanes = N, f;
  }
  function Bh(f, p, N) {
    return p = wc(4, f.children !== null ? f.children : [], f.key, p), p.lanes = N, p.stateNode = { containerInfo: f.containerInfo, pendingChildren: null, implementation: f.implementation }, p;
  }
  function Hh(f, p, N, O, V) {
    this.tag = p, this.containerInfo = f, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Oc(0), this.expirationTimes = Oc(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Oc(0), this.identifierPrefix = O, this.onRecoverableError = V, this.mutableSourceEagerHydrationData = null;
  }
  function fb(f, p, N, O, V, J, me, je, De) {
    return f = new Hh(f, p, N, je, De), p === 1 ? (p = 1, J === !0 && (p |= 8)) : p = 0, J = wc(3, null, null, p), f.current = J, J.stateNode = f, J.memoizedState = { element: O, isDehydrated: N, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Lp(J), f;
  }
  function T5(f, p, N) {
    var O = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: H, key: O == null ? null : "" + O, children: f, containerInfo: p, implementation: N };
  }
  function ht(f) {
    if (!f) return Ru;
    f = f._reactInternals;
    e: {
      if (On(f) !== f || f.tag !== 1) throw Error(n(170));
      var p = f;
      do {
        switch (p.tag) {
          case 3:
            p = p.stateNode.context;
            break e;
          case 1:
            if (Ns(p.type)) {
              p = p.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        p = p.return;
      } while (p !== null);
      throw Error(n(171));
    }
    if (f.tag === 1) {
      var N = f.type;
      if (Ns(N)) return _h(f, N, p);
    }
    return p;
  }
  function Bu(f, p, N, O, V, J, me, je, De) {
    return f = fb(N, O, !0, f, V, J, me, je, De), f.context = ht(null), N = f.current, O = Go(), V = bd(N), J = ja(O, V), J.callback = p ?? null, of(N, J, V), f.current.lanes = V, Rf(f, V, O), Ti(f, O), f;
  }
  function em(f, p, N, O) {
    var V = p.current, J = Go(), me = bd(V);
    return N = ht(N), p.context === null ? p.context = N : p.pendingContext = N, p = ja(J, me), p.payload = { element: f }, O = O === void 0 ? null : O, O !== null && (p.callback = O), f = of(V, p, me), f !== null && (ds(f, V, me, J), m0(f, V, me)), me;
  }
  function ug(f) {
    if (f = f.current, !f.child) return null;
    switch (f.child.tag) {
      case 5:
        return f.child.stateNode;
      default:
        return f.child.stateNode;
    }
  }
  function Ia(f, p) {
    if (f = f.memoizedState, f !== null && f.dehydrated !== null) {
      var N = f.retryLane;
      f.retryLane = N !== 0 && N < p ? N : p;
    }
  }
  function nn(f, p) {
    Ia(f, p), (f = f.alternate) && Ia(f, p);
  }
  function k0() {
    return null;
  }
  var mb = typeof reportError == "function" ? reportError : function(f) {
    console.error(f);
  };
  function Yo(f) {
    this._internalRoot = f;
  }
  dg.prototype.render = Yo.prototype.render = function(f) {
    var p = this._internalRoot;
    if (p === null) throw Error(n(409));
    em(f, p, null, null);
  }, dg.prototype.unmount = Yo.prototype.unmount = function() {
    var f = this._internalRoot;
    if (f !== null) {
      this._internalRoot = null;
      var p = f.containerInfo;
      uf(function() {
        em(null, f, null, null);
      }), p[ud] = null;
    }
  };
  function dg(f) {
    this._internalRoot = f;
  }
  dg.prototype.unstable_scheduleHydration = function(f) {
    if (f) {
      var p = rx();
      f = { blockedOn: null, target: f, priority: p };
      for (var N = 0; N < Va.length && p !== 0 && p < Va[N].priority; N++) ;
      Va.splice(N, 0, f), N === 0 && r0(f);
    }
  };
  function wd(f) {
    return !(!f || f.nodeType !== 1 && f.nodeType !== 9 && f.nodeType !== 11);
  }
  function Vh(f) {
    return !(!f || f.nodeType !== 1 && f.nodeType !== 9 && f.nodeType !== 11 && (f.nodeType !== 8 || f.nodeValue !== " react-mount-point-unstable "));
  }
  function hb() {
  }
  function M5(f, p, N, O, V) {
    if (V) {
      if (typeof O == "function") {
        var J = O;
        O = function() {
          var Je = ug(me);
          J.call(Je);
        };
      }
      var me = Bu(p, O, f, 0, null, !1, !1, "", hb);
      return f._reactRootContainer = me, f[ud] = me.current, _u(f.nodeType === 8 ? f.parentNode : f), uf(), me;
    }
    for (; V = f.lastChild; ) f.removeChild(V);
    if (typeof O == "function") {
      var je = O;
      O = function() {
        var Je = ug(De);
        je.call(Je);
      };
    }
    var De = fb(f, 0, !1, null, null, !1, !1, "", hb);
    return f._reactRootContainer = De, f[ud] = De.current, _u(f.nodeType === 8 ? f.parentNode : f), uf(function() {
      em(p, De, N, O);
    }), De;
  }
  function Cd(f, p, N, O, V) {
    var J = N._reactRootContainer;
    if (J) {
      var me = J;
      if (typeof V == "function") {
        var je = V;
        V = function() {
          var De = ug(me);
          je.call(De);
        };
      }
      em(p, me, f, V);
    } else me = M5(N, p, f, V, O);
    return ug(me);
  }
  Oo = function(f) {
    switch (f.tag) {
      case 3:
        var p = f.stateNode;
        if (p.current.memoizedState.isDehydrated) {
          var N = fi(p.pendingLanes);
          N !== 0 && (O1(p, N | 1), Ti(p, Gn()), !(ra & 6) && (Ih = Gn() + 500, Es()));
        }
        break;
      case 13:
        uf(function() {
          var O = qc(f, 1);
          if (O !== null) {
            var V = Go();
            ds(O, f, 1, V);
          }
        }), nn(f, 1);
    }
  }, hh = function(f) {
    if (f.tag === 13) {
      var p = qc(f, 134217728);
      if (p !== null) {
        var N = Go();
        ds(p, f, 134217728, N);
      }
      nn(f, 134217728);
    }
  }, Qa = function(f) {
    if (f.tag === 13) {
      var p = bd(f), N = qc(f, p);
      if (N !== null) {
        var O = Go();
        ds(N, f, p, O);
      }
      nn(f, p);
    }
  }, rx = function() {
    return Rr;
  }, A1 = function(f, p) {
    var N = Rr;
    try {
      return Rr = f, p();
    } finally {
      Rr = N;
    }
  }, wn = function(f, p, N) {
    switch (p) {
      case "input":
        if (It(f, N), p = N.name, N.type === "radio" && p != null) {
          for (N = f; N.parentNode; ) N = N.parentNode;
          for (N = N.querySelectorAll("input[name=" + JSON.stringify("" + p) + '][type="radio"]'), p = 0; p < N.length; p++) {
            var O = N[p];
            if (O !== f && O.form === f.form) {
              var V = mn(O);
              if (!V) throw Error(n(90));
              At(O), It(O, V);
            }
          }
        }
        break;
      case "textarea":
        Vt(f, N);
        break;
      case "select":
        p = N.value, p != null && tt(f, !!N.multiple, p, !1);
    }
  }, Wi = Sx, Yi = uf;
  var df = { usingClientEntryPoint: !1, Events: [$a, hi, mn, Il, Cr, Sx] }, _0 = { findFiberByHostInstance: $c, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Nx = { bundleType: _0.bundleType, version: _0.version, rendererPackageName: _0.rendererPackageName, rendererConfig: _0.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: U.ReactCurrentDispatcher, findHostInstanceByFiber: function(f) {
    return f = wr(f), f === null ? null : f.stateNode;
  }, findFiberByHostInstance: _0.findFiberByHostInstance || k0, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var T0 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!T0.isDisabled && T0.supportsFiber) try {
      Ki = T0.inject(Nx), Ms = T0;
    } catch {
    }
  }
  return ah.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = df, ah.createPortal = function(f, p) {
    var N = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!wd(p)) throw Error(n(200));
    return T5(f, p, null, N);
  }, ah.createRoot = function(f, p) {
    if (!wd(f)) throw Error(n(299));
    var N = !1, O = "", V = mb;
    return p != null && (p.unstable_strictMode === !0 && (N = !0), p.identifierPrefix !== void 0 && (O = p.identifierPrefix), p.onRecoverableError !== void 0 && (V = p.onRecoverableError)), p = fb(f, 1, !1, null, null, N, !1, O, V), f[ud] = p.current, _u(f.nodeType === 8 ? f.parentNode : f), new Yo(p);
  }, ah.findDOMNode = function(f) {
    if (f == null) return null;
    if (f.nodeType === 1) return f;
    var p = f._reactInternals;
    if (p === void 0)
      throw typeof f.render == "function" ? Error(n(188)) : (f = Object.keys(f).join(","), Error(n(268, f)));
    return f = wr(p), f = f === null ? null : f.stateNode, f;
  }, ah.flushSync = function(f) {
    return uf(f);
  }, ah.hydrate = function(f, p, N) {
    if (!Vh(p)) throw Error(n(200));
    return Cd(null, f, p, !0, N);
  }, ah.hydrateRoot = function(f, p, N) {
    if (!wd(f)) throw Error(n(405));
    var O = N != null && N.hydratedSources || null, V = !1, J = "", me = mb;
    if (N != null && (N.unstable_strictMode === !0 && (V = !0), N.identifierPrefix !== void 0 && (J = N.identifierPrefix), N.onRecoverableError !== void 0 && (me = N.onRecoverableError)), p = Bu(p, null, f, 1, N ?? null, V, !1, J, me), f[ud] = p.current, _u(f), O) for (f = 0; f < O.length; f++) N = O[f], V = N._getVersion, V = V(N._source), p.mutableSourceEagerHydrationData == null ? p.mutableSourceEagerHydrationData = [N, V] : p.mutableSourceEagerHydrationData.push(
      N,
      V
    );
    return new dg(p);
  }, ah.render = function(f, p, N) {
    if (!Vh(p)) throw Error(n(200));
    return Cd(null, f, p, !1, N);
  }, ah.unmountComponentAtNode = function(f) {
    if (!Vh(f)) throw Error(n(40));
    return f._reactRootContainer ? (uf(function() {
      Cd(null, null, f, !1, function() {
        f._reactRootContainer = null, f[ud] = null;
      });
    }), !0) : !1;
  }, ah.unstable_batchedUpdates = Sx, ah.unstable_renderSubtreeIntoContainer = function(f, p, N, O) {
    if (!Vh(N)) throw Error(n(200));
    if (f == null || f._reactInternals === void 0) throw Error(n(38));
    return Cd(f, p, N, !1, O);
  }, ah.version = "18.3.1-next-f1338f8080-20240426", ah;
}
var sh = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var RF;
function Gne() {
  return RF || (RF = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Ee, t = G3(), n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, r = !1;
    function s(i) {
      r = i;
    }
    function o(i) {
      if (!r) {
        for (var l = arguments.length, g = new Array(l > 1 ? l - 1 : 0), S = 1; S < l; S++)
          g[S - 1] = arguments[S];
        u("warn", i, g);
      }
    }
    function c(i) {
      if (!r) {
        for (var l = arguments.length, g = new Array(l > 1 ? l - 1 : 0), S = 1; S < l; S++)
          g[S - 1] = arguments[S];
        u("error", i, g);
      }
    }
    function u(i, l, g) {
      {
        var S = n.ReactDebugCurrentFrame, _ = S.getStackAddendum();
        _ !== "" && (l += "%s", g = g.concat([_]));
        var F = g.map(function(Y) {
          return String(Y);
        });
        F.unshift("Warning: " + l), Function.prototype.apply.call(console[i], console, F);
      }
    }
    var m = 0, y = 1, b = 2, w = 3, k = 4, j = 5, E = 6, T = 7, D = 8, L = 9, I = 10, R = 11, U = 12, z = 13, H = 14, K = 15, q = 16, Q = 17, Z = 18, X = 19, se = 21, te = 22, fe = 23, ce = 24, pe = 25, Se = !0, oe = !1, ue = !1, he = !1, ve = !1, Te = !0, Ie = !1, Ue = !0, qe = !0, it = !0, Ne = !0, Xe = /* @__PURE__ */ new Set(), xt = {}, rn = {};
    function vt(i, l) {
      At(i, l), At(i + "Capture", l);
    }
    function At(i, l) {
      xt[i] && c("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", i), xt[i] = l;
      {
        var g = i.toLowerCase();
        rn[g] = i, i === "onDoubleClick" && (rn.ondblclick = i);
      }
      for (var S = 0; S < l.length; S++)
        Xe.add(l[S]);
    }
    var He = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Pt = Object.prototype.hasOwnProperty;
    function Lt(i) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, g = l && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return g;
      }
    }
    function er(i) {
      try {
        return It(i), !1;
      } catch {
        return !0;
      }
    }
    function It(i) {
      return "" + i;
    }
    function ye(i, l) {
      if (er(i))
        return c("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", l, Lt(i)), It(i);
    }
    function ke(i) {
      if (er(i))
        return c("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Lt(i)), It(i);
    }
    function Pe(i, l) {
      if (er(i))
        return c("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", l, Lt(i)), It(i);
    }
    function tt(i, l) {
      if (er(i))
        return c("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", l, Lt(i)), It(i);
    }
    function ot(i) {
      if (er(i))
        return c("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Lt(i)), It(i);
    }
    function ut(i) {
      if (er(i))
        return c("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Lt(i)), It(i);
    }
    var Vt = 0, bn = 1, mr = 2, ur = 3, _r = 4, ai = 5, ls = 6, Ot = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", En = Ot + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Xt = new RegExp("^[" + Ot + "][" + En + "]*$"), qt = {}, In = {};
    function st(i) {
      return Pt.call(In, i) ? !0 : Pt.call(qt, i) ? !1 : Xt.test(i) ? (In[i] = !0, !0) : (qt[i] = !0, c("Invalid attribute name: `%s`", i), !1);
    }
    function lt(i, l, g) {
      return l !== null ? l.type === Vt : g ? !1 : i.length > 2 && (i[0] === "o" || i[0] === "O") && (i[1] === "n" || i[1] === "N");
    }
    function Nt(i, l, g, S) {
      if (g !== null && g.type === Vt)
        return !1;
      switch (typeof l) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (S)
            return !1;
          if (g !== null)
            return !g.acceptsBooleans;
          var _ = i.toLowerCase().slice(0, 5);
          return _ !== "data-" && _ !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Wt(i, l, g, S) {
      if (l === null || typeof l > "u" || Nt(i, l, g, S))
        return !0;
      if (S)
        return !1;
      if (g !== null)
        switch (g.type) {
          case ur:
            return !l;
          case _r:
            return l === !1;
          case ai:
            return isNaN(l);
          case ls:
            return isNaN(l) || l < 1;
        }
      return !1;
    }
    function wn(i) {
      return hr.hasOwnProperty(i) ? hr[i] : null;
    }
    function pt(i, l, g, S, _, F, Y) {
      this.acceptsBooleans = l === mr || l === ur || l === _r, this.attributeName = S, this.attributeNamespace = _, this.mustUseProperty = g, this.propertyName = i, this.type = l, this.sanitizeURL = F, this.removeEmptyString = Y;
    }
    var hr = {}, _o = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    _o.forEach(function(i) {
      hr[i] = new pt(
        i,
        Vt,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
      var l = i[0], g = i[1];
      hr[l] = new pt(
        l,
        bn,
        !1,
        // mustUseProperty
        g,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
      hr[i] = new pt(
        i,
        mr,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
      hr[i] = new pt(
        i,
        mr,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(i) {
      hr[i] = new pt(
        i,
        ur,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      hr[i] = new pt(
        i,
        ur,
        !0,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      hr[i] = new pt(
        i,
        _r,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      hr[i] = new pt(
        i,
        ls,
        !1,
        // mustUseProperty
        i,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(i) {
      hr[i] = new pt(
        i,
        ai,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Il = /[\-\:]([a-z])/g, Cr = function(i) {
      return i[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      var l = i.replace(Il, Cr);
      hr[l] = new pt(
        l,
        bn,
        !1,
        // mustUseProperty
        i,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      var l = i.replace(Il, Cr);
      hr[l] = new pt(
        l,
        bn,
        !1,
        // mustUseProperty
        i,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(i) {
      var l = i.replace(Il, Cr);
      hr[l] = new pt(
        l,
        bn,
        !1,
        // mustUseProperty
        i,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(i) {
      hr[i] = new pt(
        i,
        bn,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Wi = "xlinkHref";
    hr[Wi] = new pt(
      "xlinkHref",
      bn,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(i) {
      hr[i] = new pt(
        i,
        bn,
        !1,
        // mustUseProperty
        i.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Yi = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, To = !1;
    function qi(i) {
      !To && Yi.test(i) && (To = !0, c("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(i)));
    }
    function Mo(i, l, g, S) {
      if (S.mustUseProperty) {
        var _ = S.propertyName;
        return i[_];
      } else {
        ye(g, l), S.sanitizeURL && qi("" + g);
        var F = S.attributeName, Y = null;
        if (S.type === _r) {
          if (i.hasAttribute(F)) {
            var ee = i.getAttribute(F);
            return ee === "" ? !0 : Wt(l, g, S, !1) ? ee : ee === "" + g ? g : ee;
          }
        } else if (i.hasAttribute(F)) {
          if (Wt(l, g, S, !1))
            return i.getAttribute(F);
          if (S.type === ur)
            return g;
          Y = i.getAttribute(F);
        }
        return Wt(l, g, S, !1) ? Y === null ? g : Y : Y === "" + g ? g : Y;
      }
    }
    function ul(i, l, g, S) {
      {
        if (!st(l))
          return;
        if (!i.hasAttribute(l))
          return g === void 0 ? void 0 : null;
        var _ = i.getAttribute(l);
        return ye(g, l), _ === "" + g ? g : _;
      }
    }
    function dl(i, l, g, S) {
      var _ = wn(l);
      if (!lt(l, _, S)) {
        if (Wt(l, g, _, S) && (g = null), S || _ === null) {
          if (st(l)) {
            var F = l;
            g === null ? i.removeAttribute(F) : (ye(g, l), i.setAttribute(F, "" + g));
          }
          return;
        }
        var Y = _.mustUseProperty;
        if (Y) {
          var ee = _.propertyName;
          if (g === null) {
            var ie = _.type;
            i[ee] = ie === ur ? !1 : "";
          } else
            i[ee] = g;
          return;
        }
        var xe = _.attributeName, we = _.attributeNamespace;
        if (g === null)
          i.removeAttribute(xe);
        else {
          var Le = _.type, Ae;
          Le === ur || Le === _r && g === !0 ? Ae = "" : (ye(g, xe), Ae = "" + g, _.sanitizeURL && qi(Ae.toString())), we ? i.setAttributeNS(we, xe, Ae) : i.setAttribute(xe, Ae);
        }
      }
    }
    var Dc = Symbol.for("react.element"), Ro = Symbol.for("react.portal"), Do = Symbol.for("react.fragment"), _s = Symbol.for("react.strict_mode"), fl = Symbol.for("react.profiler"), _e = Symbol.for("react.provider"), _t = Symbol.for("react.context"), Kt = Symbol.for("react.forward_ref"), On = Symbol.for("react.suspense"), vr = Symbol.for("react.suspense_list"), Lr = Symbol.for("react.memo"), Xn = Symbol.for("react.lazy"), wr = Symbol.for("react.scope"), Ts = Symbol.for("react.debug_trace_mode"), pa = Symbol.for("react.offscreen"), ga = Symbol.for("react.legacy_hidden"), Tr = Symbol.for("react.cache"), Fn = Symbol.for("react.tracing_marker"), Gn = Symbol.iterator, zr = "@@iterator";
    function ta(i) {
      if (i === null || typeof i != "object")
        return null;
      var l = Gn && i[Gn] || i[zr];
      return typeof l == "function" ? l : null;
    }
    var ir = Object.assign, Hs = 0, Pc, Fl, Ki, Ms, xr, Mr, xu;
    function Po() {
    }
    Po.__reactDisabledLog = !0;
    function ec() {
      {
        if (Hs === 0) {
          Pc = console.log, Fl = console.info, Ki = console.warn, Ms = console.error, xr = console.group, Mr = console.groupCollapsed, xu = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: Po,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        Hs++;
      }
    }
    function Yd() {
      {
        if (Hs--, Hs === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ir({}, i, {
              value: Pc
            }),
            info: ir({}, i, {
              value: Fl
            }),
            warn: ir({}, i, {
              value: Ki
            }),
            error: ir({}, i, {
              value: Ms
            }),
            group: ir({}, i, {
              value: xr
            }),
            groupCollapsed: ir({}, i, {
              value: Mr
            }),
            groupEnd: ir({}, i, {
              value: xu
            })
          });
        }
        Hs < 0 && c("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ju = n.ReactCurrentDispatcher, fi;
    function Ul(i, l, g) {
      {
        if (fi === void 0)
          try {
            throw Error();
          } catch (_) {
            var S = _.stack.trim().match(/\n( *(at )?)/);
            fi = S && S[1] || "";
          }
        return `
` + fi + i;
      }
    }
    var P1 = !1, fh;
    {
      var mh = typeof WeakMap == "function" ? WeakMap : Map;
      fh = new mh();
    }
    function jp(i, l) {
      if (!i || P1)
        return "";
      {
        var g = fh.get(i);
        if (g !== void 0)
          return g;
      }
      var S;
      P1 = !0;
      var _ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var F;
      F = Ju.current, Ju.current = null, ec();
      try {
        if (l) {
          var Y = function() {
            throw Error();
          };
          if (Object.defineProperty(Y.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Y, []);
            } catch (nt) {
              S = nt;
            }
            Reflect.construct(i, [], Y);
          } else {
            try {
              Y.call();
            } catch (nt) {
              S = nt;
            }
            i.call(Y.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (nt) {
            S = nt;
          }
          i();
        }
      } catch (nt) {
        if (nt && S && typeof nt.stack == "string") {
          for (var ee = nt.stack.split(`
`), ie = S.stack.split(`
`), xe = ee.length - 1, we = ie.length - 1; xe >= 1 && we >= 0 && ee[xe] !== ie[we]; )
            we--;
          for (; xe >= 1 && we >= 0; xe--, we--)
            if (ee[xe] !== ie[we]) {
              if (xe !== 1 || we !== 1)
                do
                  if (xe--, we--, we < 0 || ee[xe] !== ie[we]) {
                    var Le = `
` + ee[xe].replace(" at new ", " at ");
                    return i.displayName && Le.includes("<anonymous>") && (Le = Le.replace("<anonymous>", i.displayName)), typeof i == "function" && fh.set(i, Le), Le;
                  }
                while (xe >= 1 && we >= 0);
              break;
            }
        }
      } finally {
        P1 = !1, Ju.current = F, Yd(), Error.prepareStackTrace = _;
      }
      var Ae = i ? i.displayName || i.name : "", et = Ae ? Ul(Ae) : "";
      return typeof i == "function" && fh.set(i, et), et;
    }
    function Oc(i, l, g) {
      return jp(i, !0);
    }
    function Rf(i, l, g) {
      return jp(i, !1);
    }
    function n0(i) {
      var l = i.prototype;
      return !!(l && l.isReactComponent);
    }
    function O1(i, l, g) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return jp(i, n0(i));
      if (typeof i == "string")
        return Ul(i);
      switch (i) {
        case On:
          return Ul("Suspense");
        case vr:
          return Ul("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case Kt:
            return Rf(i.render);
          case Lr:
            return O1(i.type, l, g);
          case Xn: {
            var S = i, _ = S._payload, F = S._init;
            try {
              return O1(F(_), l, g);
            } catch {
            }
          }
        }
      return "";
    }
    function Rr(i) {
      switch (i._debugOwner && i._debugOwner.type, i._debugSource, i.tag) {
        case j:
          return Ul(i.type);
        case q:
          return Ul("Lazy");
        case z:
          return Ul("Suspense");
        case X:
          return Ul("SuspenseList");
        case m:
        case b:
        case K:
          return Rf(i.type);
        case R:
          return Rf(i.type.render);
        case y:
          return Oc(i.type);
        default:
          return "";
      }
    }
    function Df(i) {
      try {
        var l = "", g = i;
        do
          l += Rr(g), g = g.return;
        while (g);
        return l;
      } catch (S) {
        return `
Error generating stack: ` + S.message + `
` + S.stack;
      }
    }
    function Oo(i, l, g) {
      var S = i.displayName;
      if (S)
        return S;
      var _ = l.displayName || l.name || "";
      return _ !== "" ? g + "(" + _ + ")" : g;
    }
    function hh(i) {
      return i.displayName || "Context";
    }
    function Qa(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && c("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case Do:
          return "Fragment";
        case Ro:
          return "Portal";
        case fl:
          return "Profiler";
        case _s:
          return "StrictMode";
        case On:
          return "Suspense";
        case vr:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case _t:
            var l = i;
            return hh(l) + ".Consumer";
          case _e:
            var g = i;
            return hh(g._context) + ".Provider";
          case Kt:
            return Oo(i, i.render, "ForwardRef");
          case Lr:
            var S = i.displayName || null;
            return S !== null ? S : Qa(i.type) || "Memo";
          case Xn: {
            var _ = i, F = _._payload, Y = _._init;
            try {
              return Qa(Y(F));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function rx(i, l, g) {
      var S = l.displayName || l.name || "";
      return i.displayName || (S !== "" ? g + "(" + S + ")" : g);
    }
    function A1(i) {
      return i.displayName || "Context";
    }
    function Nr(i) {
      var l = i.tag, g = i.type;
      switch (l) {
        case ce:
          return "Cache";
        case L:
          var S = g;
          return A1(S) + ".Consumer";
        case I:
          var _ = g;
          return A1(_._context) + ".Provider";
        case Z:
          return "DehydratedFragment";
        case R:
          return rx(g, g.render, "ForwardRef");
        case T:
          return "Fragment";
        case j:
          return g;
        case k:
          return "Portal";
        case w:
          return "Root";
        case E:
          return "Text";
        case q:
          return Qa(g);
        case D:
          return g === _s ? "StrictMode" : "Mode";
        case te:
          return "Offscreen";
        case U:
          return "Profiler";
        case se:
          return "Scope";
        case z:
          return "Suspense";
        case X:
          return "SuspenseList";
        case pe:
          return "TracingMarker";
        case y:
        case m:
        case Q:
        case b:
        case H:
        case K:
          if (typeof g == "function")
            return g.displayName || g.name || null;
          if (typeof g == "string")
            return g;
          break;
      }
      return null;
    }
    var ph = n.ReactDebugCurrentFrame, Za = null, bu = !1;
    function tc() {
      {
        if (Za === null)
          return null;
        var i = Za._debugOwner;
        if (i !== null && typeof i < "u")
          return Nr(i);
      }
      return null;
    }
    function la() {
      return Za === null ? "" : Df(Za);
    }
    function Vs() {
      ph.getCurrentStack = null, Za = null, bu = !1;
    }
    function Va(i) {
      ph.getCurrentStack = i === null ? null : la, Za = i, bu = !1;
    }
    function ax() {
      return Za;
    }
    function ed(i) {
      bu = i;
    }
    function ml(i) {
      return "" + i;
    }
    function Rs(i) {
      switch (typeof i) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return i;
        case "object":
          return ut(i), i;
        default:
          return "";
      }
    }
    var r0 = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Ep(i, l) {
      r0[l.type] || l.onChange || l.onInput || l.readOnly || l.disabled || l.value == null || c("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), l.onChange || l.readOnly || l.disabled || l.checked == null || c("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function L1(i) {
      var l = i.type, g = i.nodeName;
      return g && g.toLowerCase() === "input" && (l === "checkbox" || l === "radio");
    }
    function sx(i) {
      return i._valueTracker;
    }
    function vm(i) {
      i._valueTracker = null;
    }
    function nc(i) {
      var l = "";
      return i && (L1(i) ? l = i.checked ? "true" : "false" : l = i.value), l;
    }
    function kp(i) {
      var l = L1(i) ? "checked" : "value", g = Object.getOwnPropertyDescriptor(i.constructor.prototype, l);
      ut(i[l]);
      var S = "" + i[l];
      if (!(i.hasOwnProperty(l) || typeof g > "u" || typeof g.get != "function" || typeof g.set != "function")) {
        var _ = g.get, F = g.set;
        Object.defineProperty(i, l, {
          configurable: !0,
          get: function() {
            return _.call(this);
          },
          set: function(ee) {
            ut(ee), S = "" + ee, F.call(this, ee);
          }
        }), Object.defineProperty(i, l, {
          enumerable: g.enumerable
        });
        var Y = {
          getValue: function() {
            return S;
          },
          setValue: function(ee) {
            ut(ee), S = "" + ee;
          },
          stopTracking: function() {
            vm(i), delete i[l];
          }
        };
        return Y;
      }
    }
    function xm(i) {
      sx(i) || (i._valueTracker = kp(i));
    }
    function Su(i) {
      if (!i)
        return !1;
      var l = sx(i);
      if (!l)
        return !0;
      var g = l.getValue(), S = nc(i);
      return S !== g ? (l.setValue(S), !0) : !1;
    }
    function wu(i) {
      if (i = i || (typeof document < "u" ? document : void 0), typeof i > "u")
        return null;
      try {
        return i.activeElement || i.body;
      } catch {
        return i.body;
      }
    }
    var gh = !1, yh = !1, I1 = !1, My = !1;
    function Xi(i) {
      var l = i.type === "checkbox" || i.type === "radio";
      return l ? i.checked != null : i.value != null;
    }
    function td(i, l) {
      var g = i, S = l.checked, _ = ir({}, l, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: S ?? g._wrapperState.initialChecked
      });
      return _;
    }
    function qd(i, l) {
      Ep("input", l), l.checked !== void 0 && l.defaultChecked !== void 0 && !yh && (c("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", tc() || "A component", l.type), yh = !0), l.value !== void 0 && l.defaultValue !== void 0 && !gh && (c("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", tc() || "A component", l.type), gh = !0);
      var g = i, S = l.defaultValue == null ? "" : l.defaultValue;
      g._wrapperState = {
        initialChecked: l.checked != null ? l.checked : l.defaultChecked,
        initialValue: Rs(l.value != null ? l.value : S),
        controlled: Xi(l)
      };
    }
    function bm(i, l) {
      var g = i, S = l.checked;
      S != null && dl(g, "checked", S, !1);
    }
    function Kd(i, l) {
      var g = i;
      {
        var S = Xi(l);
        !g._wrapperState.controlled && S && !My && (c("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), My = !0), g._wrapperState.controlled && !S && !I1 && (c("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), I1 = !0);
      }
      bm(i, l);
      var _ = Rs(l.value), F = l.type;
      if (_ != null)
        F === "number" ? (_ === 0 && g.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        g.value != _) && (g.value = ml(_)) : g.value !== ml(_) && (g.value = ml(_));
      else if (F === "submit" || F === "reset") {
        g.removeAttribute("value");
        return;
      }
      l.hasOwnProperty("value") ? hl(g, l.type, _) : l.hasOwnProperty("defaultValue") && hl(g, l.type, Rs(l.defaultValue)), l.checked == null && l.defaultChecked != null && (g.defaultChecked = !!l.defaultChecked);
    }
    function Ao(i, l, g) {
      var S = i;
      if (l.hasOwnProperty("value") || l.hasOwnProperty("defaultValue")) {
        var _ = l.type, F = _ === "submit" || _ === "reset";
        if (F && (l.value === void 0 || l.value === null))
          return;
        var Y = ml(S._wrapperState.initialValue);
        g || Y !== S.value && (S.value = Y), S.defaultValue = Y;
      }
      var ee = S.name;
      ee !== "" && (S.name = ""), S.defaultChecked = !S.defaultChecked, S.defaultChecked = !!S._wrapperState.initialChecked, ee !== "" && (S.name = ee);
    }
    function Ac(i, l) {
      var g = i;
      Kd(g, l), Qi(g, l);
    }
    function Qi(i, l) {
      var g = l.name;
      if (l.type === "radio" && g != null) {
        for (var S = i; S.parentNode; )
          S = S.parentNode;
        ye(g, "name");
        for (var _ = S.querySelectorAll("input[name=" + JSON.stringify("" + g) + '][type="radio"]'), F = 0; F < _.length; F++) {
          var Y = _[F];
          if (!(Y === i || Y.form !== i.form)) {
            var ee = Ib(Y);
            if (!ee)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Su(Y), Kd(Y, ee);
          }
        }
      }
    }
    function hl(i, l, g) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (l !== "number" || wu(i.ownerDocument) !== i) && (g == null ? i.defaultValue = ml(i._wrapperState.initialValue) : i.defaultValue !== ml(g) && (i.defaultValue = ml(g)));
    }
    var Lc = !1, rc = !1, Ry = !1;
    function _p(i, l) {
      l.value == null && (typeof l.children == "object" && l.children !== null ? e.Children.forEach(l.children, function(g) {
        g != null && (typeof g == "string" || typeof g == "number" || rc || (rc = !0, c("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : l.dangerouslySetInnerHTML != null && (Ry || (Ry = !0, c("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), l.selected != null && !Lc && (c("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Lc = !0);
    }
    function Sm(i, l) {
      l.value != null && i.setAttribute("value", ml(Rs(l.value)));
    }
    var Lo = Array.isArray;
    function Ja(i) {
      return Lo(i);
    }
    var vs;
    vs = !1;
    function Tp() {
      var i = tc();
      return i ? `

Check the render method of \`` + i + "`." : "";
    }
    var Cu = ["value", "defaultValue"];
    function ix(i) {
      {
        Ep("select", i);
        for (var l = 0; l < Cu.length; l++) {
          var g = Cu[l];
          if (i[g] != null) {
            var S = Ja(i[g]);
            i.multiple && !S ? c("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", g, Tp()) : !i.multiple && S && c("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", g, Tp());
          }
        }
      }
    }
    function Pf(i, l, g, S) {
      var _ = i.options;
      if (l) {
        for (var F = g, Y = {}, ee = 0; ee < F.length; ee++)
          Y["$" + F[ee]] = !0;
        for (var ie = 0; ie < _.length; ie++) {
          var xe = Y.hasOwnProperty("$" + _[ie].value);
          _[ie].selected !== xe && (_[ie].selected = xe), xe && S && (_[ie].defaultSelected = !0);
        }
      } else {
        for (var we = ml(Rs(g)), Le = null, Ae = 0; Ae < _.length; Ae++) {
          if (_[Ae].value === we) {
            _[Ae].selected = !0, S && (_[Ae].defaultSelected = !0);
            return;
          }
          Le === null && !_[Ae].disabled && (Le = _[Ae]);
        }
        Le !== null && (Le.selected = !0);
      }
    }
    function F1(i, l) {
      return ir({}, l, {
        value: void 0
      });
    }
    function a0(i, l) {
      var g = i;
      ix(l), g._wrapperState = {
        wasMultiple: !!l.multiple
      }, l.value !== void 0 && l.defaultValue !== void 0 && !vs && (c("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), vs = !0);
    }
    function ox(i, l) {
      var g = i;
      g.multiple = !!l.multiple;
      var S = l.value;
      S != null ? Pf(g, !!l.multiple, S, !1) : l.defaultValue != null && Pf(g, !!l.multiple, l.defaultValue, !0);
    }
    function s0(i, l) {
      var g = i, S = g._wrapperState.wasMultiple;
      g._wrapperState.wasMultiple = !!l.multiple;
      var _ = l.value;
      _ != null ? Pf(g, !!l.multiple, _, !1) : S !== !!l.multiple && (l.defaultValue != null ? Pf(g, !!l.multiple, l.defaultValue, !0) : Pf(g, !!l.multiple, l.multiple ? [] : "", !1));
    }
    function lx(i, l) {
      var g = i, S = l.value;
      S != null && Pf(g, !!l.multiple, S, !1);
    }
    var wm = !1;
    function U1(i, l) {
      var g = i;
      if (l.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var S = ir({}, l, {
        value: void 0,
        defaultValue: void 0,
        children: ml(g._wrapperState.initialValue)
      });
      return S;
    }
    function cx(i, l) {
      var g = i;
      Ep("textarea", l), l.value !== void 0 && l.defaultValue !== void 0 && !wm && (c("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", tc() || "A component"), wm = !0);
      var S = l.value;
      if (S == null) {
        var _ = l.children, F = l.defaultValue;
        if (_ != null) {
          c("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (F != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Ja(_)) {
              if (_.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              _ = _[0];
            }
            F = _;
          }
        }
        F == null && (F = ""), S = F;
      }
      g._wrapperState = {
        initialValue: Rs(S)
      };
    }
    function z1(i, l) {
      var g = i, S = Rs(l.value), _ = Rs(l.defaultValue);
      if (S != null) {
        var F = ml(S);
        F !== g.value && (g.value = F), l.defaultValue == null && g.defaultValue !== F && (g.defaultValue = F);
      }
      _ != null && (g.defaultValue = ml(_));
    }
    function ux(i, l) {
      var g = i, S = g.textContent;
      S === g._wrapperState.initialValue && S !== "" && S !== null && (g.value = S);
    }
    function vh(i, l) {
      z1(i, l);
    }
    var Nu = "http://www.w3.org/1999/xhtml", dx = "http://www.w3.org/1998/Math/MathML", i0 = "http://www.w3.org/2000/svg";
    function Of(i) {
      switch (i) {
        case "svg":
          return i0;
        case "math":
          return dx;
        default:
          return Nu;
      }
    }
    function o0(i, l) {
      return i == null || i === Nu ? Of(l) : i === i0 && l === "foreignObject" ? Nu : i;
    }
    var l0 = function(i) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(l, g, S, _) {
        MSApp.execUnsafeLocalFunction(function() {
          return i(l, g, S, _);
        });
      } : i;
    }, xh, bh = l0(function(i, l) {
      if (i.namespaceURI === i0 && !("innerHTML" in i)) {
        xh = xh || document.createElement("div"), xh.innerHTML = "<svg>" + l.valueOf().toString() + "</svg>";
        for (var g = xh.firstChild; i.firstChild; )
          i.removeChild(i.firstChild);
        for (; g.firstChild; )
          i.appendChild(g.firstChild);
        return;
      }
      i.innerHTML = l;
    }), pl = 1, zl = 3, mi = 8, ac = 9, Xd = 11, Qd = function(i, l) {
      if (l) {
        var g = i.firstChild;
        if (g && g === i.lastChild && g.nodeType === zl) {
          g.nodeValue = l;
          return;
        }
      }
      i.textContent = l;
    }, sc = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, Ic = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function B1(i, l) {
      return i + l.charAt(0).toUpperCase() + l.substring(1);
    }
    var c0 = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Ic).forEach(function(i) {
      c0.forEach(function(l) {
        Ic[B1(l, i)] = Ic[i];
      });
    });
    function Fc(i, l, g) {
      var S = l == null || typeof l == "boolean" || l === "";
      return S ? "" : !g && typeof l == "number" && l !== 0 && !(Ic.hasOwnProperty(i) && Ic[i]) ? l + "px" : (tt(l, i), ("" + l).trim());
    }
    var Uc = /([A-Z])/g, H1 = /^ms-/;
    function u0(i) {
      return i.replace(Uc, "-$1").toLowerCase().replace(H1, "-ms-");
    }
    var Io = function() {
    };
    {
      var nd = /^(?:webkit|moz|o)[A-Z]/, Cm = /^-ms-/, Mp = /-(.)/g, rd = /;\s*$/, Sh = {}, ju = {}, zc = !1, Af = !1, Lf = function(i) {
        return i.replace(Mp, function(l, g) {
          return g.toUpperCase();
        });
      }, Bc = function(i) {
        Sh.hasOwnProperty(i) && Sh[i] || (Sh[i] = !0, c(
          "Unsupported style property %s. Did you mean %s?",
          i,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Lf(i.replace(Cm, "ms-"))
        ));
      }, V1 = function(i) {
        Sh.hasOwnProperty(i) && Sh[i] || (Sh[i] = !0, c("Unsupported vendor-prefixed style property %s. Did you mean %s?", i, i.charAt(0).toUpperCase() + i.slice(1)));
      }, Zd = function(i, l) {
        ju.hasOwnProperty(l) && ju[l] || (ju[l] = !0, c(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, i, l.replace(rd, "")));
      }, Hc = function(i, l) {
        zc || (zc = !0, c("`NaN` is an invalid value for the `%s` css style property.", i));
      }, $1 = function(i, l) {
        Af || (Af = !0, c("`Infinity` is an invalid value for the `%s` css style property.", i));
      };
      Io = function(i, l) {
        i.indexOf("-") > -1 ? Bc(i) : nd.test(i) ? V1(i) : rd.test(l) && Zd(i, l), typeof l == "number" && (isNaN(l) ? Hc(i, l) : isFinite(l) || $1(i, l));
      };
    }
    var Cs = Io;
    function Eu(i) {
      {
        var l = "", g = "";
        for (var S in i)
          if (i.hasOwnProperty(S)) {
            var _ = i[S];
            if (_ != null) {
              var F = S.indexOf("--") === 0;
              l += g + (F ? S : u0(S)) + ":", l += Fc(S, _, F), g = ";";
            }
          }
        return l || null;
      }
    }
    function ad(i, l) {
      var g = i.style;
      for (var S in l)
        if (l.hasOwnProperty(S)) {
          var _ = S.indexOf("--") === 0;
          _ || Cs(S, l[S]);
          var F = Fc(S, l[S], _);
          S === "float" && (S = "cssFloat"), _ ? g.setProperty(S, F) : g[S] = F;
        }
    }
    function yo(i) {
      return i == null || typeof i == "boolean" || i === "";
    }
    function Pa(i) {
      var l = {};
      for (var g in i)
        for (var S = sc[g] || [g], _ = 0; _ < S.length; _++)
          l[S[_]] = g;
      return l;
    }
    function If(i, l) {
      {
        if (!l)
          return;
        var g = Pa(i), S = Pa(l), _ = {};
        for (var F in g) {
          var Y = g[F], ee = S[F];
          if (ee && Y !== ee) {
            var ie = Y + "," + ee;
            if (_[ie])
              continue;
            _[ie] = !0, c("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", yo(i[Y]) ? "Removing" : "Updating", Y, ee);
          }
        }
      }
    }
    var Ii = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, wa = ir({
      menuitem: !0
    }, Ii), es = "__html";
    function si(i, l) {
      if (l) {
        if (wa[i] && (l.children != null || l.dangerouslySetInnerHTML != null))
          throw new Error(i + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (l.dangerouslySetInnerHTML != null) {
          if (l.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof l.dangerouslySetInnerHTML != "object" || !(es in l.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!l.suppressContentEditableWarning && l.contentEditable && l.children != null && c("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), l.style != null && typeof l.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Fo(i, l) {
      if (i.indexOf("-") === -1)
        return typeof l.is == "string";
      switch (i) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Ff = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, sd = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, ic = {}, xs = new RegExp("^(aria)-[" + En + "]*$"), Jd = new RegExp("^(aria)[A-Z][" + En + "]*$");
    function wh(i, l) {
      {
        if (Pt.call(ic, l) && ic[l])
          return !0;
        if (Jd.test(l)) {
          var g = "aria-" + l.slice(4).toLowerCase(), S = sd.hasOwnProperty(g) ? g : null;
          if (S == null)
            return c("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", l), ic[l] = !0, !0;
          if (l !== S)
            return c("Invalid ARIA attribute `%s`. Did you mean `%s`?", l, S), ic[l] = !0, !0;
        }
        if (xs.test(l)) {
          var _ = l.toLowerCase(), F = sd.hasOwnProperty(_) ? _ : null;
          if (F == null)
            return ic[l] = !0, !1;
          if (l !== F)
            return c("Unknown ARIA attribute `%s`. Did you mean `%s`?", l, F), ic[l] = !0, !0;
        }
      }
      return !0;
    }
    function G1(i, l) {
      {
        var g = [];
        for (var S in l) {
          var _ = wh(i, S);
          _ || g.push(S);
        }
        var F = g.map(function(Y) {
          return "`" + Y + "`";
        }).join(", ");
        g.length === 1 ? c("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", F, i) : g.length > 1 && c("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", F, i);
      }
    }
    function oc(i, l) {
      Fo(i, l) || G1(i, l);
    }
    var Ci = !1;
    function Nm(i, l) {
      {
        if (i !== "input" && i !== "textarea" && i !== "select")
          return;
        l != null && l.value === null && !Ci && (Ci = !0, i === "select" && l.multiple ? c("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", i) : c("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", i));
      }
    }
    var W1 = function() {
    };
    {
      var Ds = {}, Y1 = /^on./, Qn = /^on[^A-Z]/, na = new RegExp("^(aria)-[" + En + "]*$"), Ca = new RegExp("^(aria)[A-Z][" + En + "]*$");
      W1 = function(i, l, g, S) {
        if (Pt.call(Ds, l) && Ds[l])
          return !0;
        var _ = l.toLowerCase();
        if (_ === "onfocusin" || _ === "onfocusout")
          return c("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Ds[l] = !0, !0;
        if (S != null) {
          var F = S.registrationNameDependencies, Y = S.possibleRegistrationNames;
          if (F.hasOwnProperty(l))
            return !0;
          var ee = Y.hasOwnProperty(_) ? Y[_] : null;
          if (ee != null)
            return c("Invalid event handler property `%s`. Did you mean `%s`?", l, ee), Ds[l] = !0, !0;
          if (Y1.test(l))
            return c("Unknown event handler property `%s`. It will be ignored.", l), Ds[l] = !0, !0;
        } else if (Y1.test(l))
          return Qn.test(l) && c("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", l), Ds[l] = !0, !0;
        if (na.test(l) || Ca.test(l))
          return !0;
        if (_ === "innerhtml")
          return c("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Ds[l] = !0, !0;
        if (_ === "aria")
          return c("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Ds[l] = !0, !0;
        if (_ === "is" && g !== null && g !== void 0 && typeof g != "string")
          return c("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof g), Ds[l] = !0, !0;
        if (typeof g == "number" && isNaN(g))
          return c("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", l), Ds[l] = !0, !0;
        var ie = wn(l), xe = ie !== null && ie.type === Vt;
        if (Ff.hasOwnProperty(_)) {
          var we = Ff[_];
          if (we !== l)
            return c("Invalid DOM property `%s`. Did you mean `%s`?", l, we), Ds[l] = !0, !0;
        } else if (!xe && l !== _)
          return c("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", l, _), Ds[l] = !0, !0;
        return typeof g == "boolean" && Nt(l, g, ie, !1) ? (g ? c('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', g, l, l, g, l) : c('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', g, l, l, g, l, l, l), Ds[l] = !0, !0) : xe ? !0 : Nt(l, g, ie, !1) ? (Ds[l] = !0, !1) : ((g === "false" || g === "true") && ie !== null && ie.type === ur && (c("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", g, l, g === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', l, g), Ds[l] = !0), !0);
      };
    }
    var $s = function(i, l, g) {
      {
        var S = [];
        for (var _ in l) {
          var F = W1(i, _, l[_], g);
          F || S.push(_);
        }
        var Y = S.map(function(ee) {
          return "`" + ee + "`";
        }).join(", ");
        S.length === 1 ? c("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Y, i) : S.length > 1 && c("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Y, i);
      }
    };
    function ku(i, l, g) {
      Fo(i, l) || $s(i, l, g);
    }
    var id = 1, Rp = 2, od = 4, fx = id | Rp | od, ef = null;
    function bt(i) {
      ef !== null && c("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), ef = i;
    }
    function Zi() {
      ef === null && c("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), ef = null;
    }
    function rr(i) {
      return i === ef;
    }
    function tf(i) {
      var l = i.target || i.srcElement || window;
      return l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === zl ? l.parentNode : l;
    }
    var ca = null, Bl = null, Ji = null;
    function _u(i) {
      var l = P0(i);
      if (l) {
        if (typeof ca != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var g = l.stateNode;
        if (g) {
          var S = Ib(g);
          ca(l.stateNode, l.type, S);
        }
      }
    }
    function jm(i) {
      ca = i;
    }
    function Uf(i) {
      Bl ? Ji ? Ji.push(i) : Ji = [i] : Bl = i;
    }
    function Em() {
      return Bl !== null || Ji !== null;
    }
    function Ch() {
      if (Bl) {
        var i = Bl, l = Ji;
        if (Bl = null, Ji = null, _u(i), l)
          for (var g = 0; g < l.length; g++)
            _u(l[g]);
      }
    }
    var nf = function(i, l) {
      return i(l);
    }, q1 = function() {
    }, K1 = !1;
    function d0() {
      var i = Em();
      i && (q1(), Ch());
    }
    function Dp(i, l, g) {
      if (K1)
        return i(l, g);
      K1 = !0;
      try {
        return nf(i, l, g);
      } finally {
        K1 = !1, d0();
      }
    }
    function Nh(i, l, g) {
      nf = i, q1 = g;
    }
    function zf(i) {
      return i === "button" || i === "input" || i === "select" || i === "textarea";
    }
    function X1(i, l, g) {
      switch (i) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(g.disabled && zf(l));
        default:
          return !1;
      }
    }
    function Bf(i, l) {
      var g = i.stateNode;
      if (g === null)
        return null;
      var S = Ib(g);
      if (S === null)
        return null;
      var _ = S[l];
      if (X1(l, i.type, S))
        return null;
      if (_ && typeof _ != "function")
        throw new Error("Expected `" + l + "` listener to be a function, instead got a value of `" + typeof _ + "` type.");
      return _;
    }
    var jh = !1;
    if (He)
      try {
        var eo = {};
        Object.defineProperty(eo, "passive", {
          get: function() {
            jh = !0;
          }
        }), window.addEventListener("test", eo, eo), window.removeEventListener("test", eo, eo);
      } catch {
        jh = !1;
      }
    function Pp(i, l, g, S, _, F, Y, ee, ie) {
      var xe = Array.prototype.slice.call(arguments, 3);
      try {
        l.apply(g, xe);
      } catch (we) {
        this.onError(we);
      }
    }
    var km = Pp;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Eh = document.createElement("react");
      km = function(l, g, S, _, F, Y, ee, ie, xe) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var we = document.createEvent("Event"), Le = !1, Ae = !0, et = window.event, nt = Object.getOwnPropertyDescriptor(window, "event");
        function dt() {
          Eh.removeEventListener(ft, fr, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = et);
        }
        var xn = Array.prototype.slice.call(arguments, 3);
        function fr() {
          Le = !0, dt(), g.apply(S, xn), Ae = !1;
        }
        var qn, Ua = !1, ba = !1;
        function We(Ye) {
          if (qn = Ye.error, Ua = !0, qn === null && Ye.colno === 0 && Ye.lineno === 0 && (ba = !0), Ye.defaultPrevented && qn != null && typeof qn == "object")
            try {
              qn._suppressLogging = !0;
            } catch {
            }
        }
        var ft = "react-" + (l || "invokeguardedcallback");
        if (window.addEventListener("error", We), Eh.addEventListener(ft, fr, !1), we.initEvent(ft, !1, !1), Eh.dispatchEvent(we), nt && Object.defineProperty(window, "event", nt), Le && Ae && (Ua ? ba && (qn = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : qn = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(qn)), window.removeEventListener("error", We), !Le)
          return dt(), Pp.apply(this, arguments);
      };
    }
    var kh = km, ld = !1, Hl = null, Tu = !1, Mu = null, Vc = {
      onError: function(i) {
        ld = !0, Hl = i;
      }
    };
    function cd(i, l, g, S, _, F, Y, ee, ie) {
      ld = !1, Hl = null, kh.apply(Vc, arguments);
    }
    function ud(i, l, g, S, _, F, Y, ee, ie) {
      if (cd.apply(this, arguments), ld) {
        var xe = gl();
        Tu || (Tu = !0, Mu = xe);
      }
    }
    function _m() {
      if (Tu) {
        var i = Mu;
        throw Tu = !1, Mu = null, i;
      }
    }
    function Tm() {
      return ld;
    }
    function gl() {
      if (ld) {
        var i = Hl;
        return ld = !1, Hl = null, i;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function $c(i) {
      return i._reactInternals;
    }
    function $a(i) {
      return i._reactInternals !== void 0;
    }
    function hi(i, l) {
      i._reactInternals = l;
    }
    var mn = (
      /*                      */
      0
    ), Gc = (
      /*                */
      1
    ), ts = (
      /*                    */
      2
    ), Dr = (
      /*                       */
      4
    ), Na = (
      /*                */
      16
    ), Oa = (
      /*                 */
      32
    ), Ru = (
      /*                     */
      64
    ), or = (
      /*                   */
      128
    ), Gs = (
      /*            */
      256
    ), Uo = (
      /*                          */
      512
    ), lc = (
      /*                     */
      1024
    ), Ns = (
      /*                      */
      2048
    ), cc = (
      /*                    */
      4096
    ), Du = (
      /*                   */
      8192
    ), _h = (
      /*             */
      16384
    ), Mm = Ns | Dr | Ru | Uo | lc | _h, Dy = (
      /*               */
      32767
    ), uc = (
      /*                   */
      32768
    ), js = (
      /*                */
      65536
    ), rf = (
      /* */
      131072
    ), Pu = (
      /*                       */
      1048576
    ), Wc = (
      /*                    */
      2097152
    ), Es = (
      /*                 */
      4194304
    ), pi = (
      /*                */
      8388608
    ), Wn = (
      /*               */
      16777216
    ), dc = (
      /*              */
      33554432
    ), dd = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Dr | lc | 0
    ), yl = ts | Dr | Na | Oa | Uo | cc | Du, to = Dr | Ru | Uo | Du, Vl = Ns | Na, Ps = Es | pi | Wc, Ws = n.ReactCurrentOwner;
    function fc(i) {
      var l = i, g = i;
      if (i.alternate)
        for (; l.return; )
          l = l.return;
      else {
        var S = l;
        do
          l = S, (l.flags & (ts | cc)) !== mn && (g = l.return), S = l.return;
        while (S);
      }
      return l.tag === w ? g : null;
    }
    function Py(i) {
      if (i.tag === z) {
        var l = i.memoizedState;
        if (l === null) {
          var g = i.alternate;
          g !== null && (l = g.memoizedState);
        }
        if (l !== null)
          return l.dehydrated;
      }
      return null;
    }
    function Hf(i) {
      return i.tag === w ? i.stateNode.containerInfo : null;
    }
    function vo(i) {
      return fc(i) === i;
    }
    function mc(i) {
      {
        var l = Ws.current;
        if (l !== null && l.tag === y) {
          var g = l, S = g.stateNode;
          S._warnedAboutRefsInRender || c("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Nr(g) || "A component"), S._warnedAboutRefsInRender = !0;
        }
      }
      var _ = $c(i);
      return _ ? fc(_) === _ : !1;
    }
    function tn(i) {
      if (fc(i) !== i)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Aa(i) {
      var l = i.alternate;
      if (!l) {
        var g = fc(i);
        if (g === null)
          throw new Error("Unable to find node on an unmounted component.");
        return g !== i ? null : i;
      }
      for (var S = i, _ = l; ; ) {
        var F = S.return;
        if (F === null)
          break;
        var Y = F.alternate;
        if (Y === null) {
          var ee = F.return;
          if (ee !== null) {
            S = _ = ee;
            continue;
          }
          break;
        }
        if (F.child === Y.child) {
          for (var ie = F.child; ie; ) {
            if (ie === S)
              return tn(F), i;
            if (ie === _)
              return tn(F), l;
            ie = ie.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (S.return !== _.return)
          S = F, _ = Y;
        else {
          for (var xe = !1, we = F.child; we; ) {
            if (we === S) {
              xe = !0, S = F, _ = Y;
              break;
            }
            if (we === _) {
              xe = !0, _ = F, S = Y;
              break;
            }
            we = we.sibling;
          }
          if (!xe) {
            for (we = Y.child; we; ) {
              if (we === S) {
                xe = !0, S = Y, _ = F;
                break;
              }
              if (we === _) {
                xe = !0, _ = Y, S = F;
                break;
              }
              we = we.sibling;
            }
            if (!xe)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (S.alternate !== _)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (S.tag !== w)
        throw new Error("Unable to find node on an unmounted component.");
      return S.stateNode.current === S ? i : l;
    }
    function ii(i) {
      var l = Aa(i);
      return l !== null ? Rm(l) : null;
    }
    function Rm(i) {
      if (i.tag === j || i.tag === E)
        return i;
      for (var l = i.child; l !== null; ) {
        var g = Rm(l);
        if (g !== null)
          return g;
        l = l.sibling;
      }
      return null;
    }
    function Op(i) {
      var l = Aa(i);
      return l !== null ? af(l) : null;
    }
    function af(i) {
      if (i.tag === j || i.tag === E)
        return i;
      for (var l = i.child; l !== null; ) {
        if (l.tag !== k) {
          var g = af(l);
          if (g !== null)
            return g;
        }
        l = l.sibling;
      }
      return null;
    }
    var fd = t.unstable_scheduleCallback, hc = t.unstable_cancelCallback, gi = t.unstable_shouldYield, Oy = t.unstable_requestPaint, Ys = t.unstable_now, Q1 = t.unstable_getCurrentPriorityLevel, Th = t.unstable_ImmediatePriority, qs = t.unstable_UserBlockingPriority, Ni = t.unstable_NormalPriority, md = t.unstable_LowPriority, Ap = t.unstable_IdlePriority, Mh = t.unstable_yieldValue, ns = t.unstable_setDisableYieldValue, Yc = null, rs = null, Zt = null, pc = !1, gc = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function f0(i) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var l = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (l.isDisabled)
        return !0;
      if (!l.supportsFiber)
        return c("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        qe && (i = ir({}, i, {
          getLaneLabelMap: qc,
          injectProfilingHooks: Z1
        })), Yc = l.inject(i), rs = l;
      } catch (g) {
        c("React instrumentation encountered an error: %s.", g);
      }
      return !!l.checkDCE;
    }
    function Vf(i, l) {
      if (rs && typeof rs.onScheduleFiberRoot == "function")
        try {
          rs.onScheduleFiberRoot(Yc, i, l);
        } catch (g) {
          pc || (pc = !0, c("React instrumentation encountered an error: %s", g));
        }
    }
    function Ks(i, l) {
      if (rs && typeof rs.onCommitFiberRoot == "function")
        try {
          var g = (i.current.flags & or) === or;
          if (it) {
            var S;
            switch (l) {
              case Ea:
                S = Th;
                break;
              case Xc:
                S = qs;
                break;
              case Sc:
                S = Ni;
                break;
              case Ah:
                S = Ap;
                break;
              default:
                S = Ni;
                break;
            }
            rs.onCommitFiberRoot(Yc, i, S, g);
          }
        } catch (_) {
          pc || (pc = !0, c("React instrumentation encountered an error: %s", _));
        }
    }
    function Yt(i) {
      if (rs && typeof rs.onPostCommitFiberRoot == "function")
        try {
          rs.onPostCommitFiberRoot(Yc, i);
        } catch (l) {
          pc || (pc = !0, c("React instrumentation encountered an error: %s", l));
        }
    }
    function no(i) {
      if (rs && typeof rs.onCommitFiberUnmount == "function")
        try {
          rs.onCommitFiberUnmount(Yc, i);
        } catch (l) {
          pc || (pc = !0, c("React instrumentation encountered an error: %s", l));
        }
    }
    function ya(i) {
      if (typeof Mh == "function" && (ns(i), s(i)), rs && typeof rs.setStrictMode == "function")
        try {
          rs.setStrictMode(Yc, i);
        } catch (l) {
          pc || (pc = !0, c("React instrumentation encountered an error: %s", l));
        }
    }
    function Z1(i) {
      Zt = i;
    }
    function qc() {
      {
        for (var i = /* @__PURE__ */ new Map(), l = 1, g = 0; g < $f; g++) {
          var S = mx(l);
          i.set(l, S), l *= 2;
        }
        return i;
      }
    }
    function sf(i) {
      Zt !== null && typeof Zt.markCommitStarted == "function" && Zt.markCommitStarted(i);
    }
    function Lp() {
      Zt !== null && typeof Zt.markCommitStopped == "function" && Zt.markCommitStopped();
    }
    function Dm(i) {
      Zt !== null && typeof Zt.markComponentRenderStarted == "function" && Zt.markComponentRenderStarted(i);
    }
    function ja() {
      Zt !== null && typeof Zt.markComponentRenderStopped == "function" && Zt.markComponentRenderStopped();
    }
    function of(i) {
      Zt !== null && typeof Zt.markComponentPassiveEffectMountStarted == "function" && Zt.markComponentPassiveEffectMountStarted(i);
    }
    function m0() {
      Zt !== null && typeof Zt.markComponentPassiveEffectMountStopped == "function" && Zt.markComponentPassiveEffectMountStopped();
    }
    function J1(i) {
      Zt !== null && typeof Zt.markComponentPassiveEffectUnmountStarted == "function" && Zt.markComponentPassiveEffectUnmountStarted(i);
    }
    function Rh() {
      Zt !== null && typeof Zt.markComponentPassiveEffectUnmountStopped == "function" && Zt.markComponentPassiveEffectUnmountStopped();
    }
    function ks(i) {
      Zt !== null && typeof Zt.markComponentLayoutEffectMountStarted == "function" && Zt.markComponentLayoutEffectMountStarted(i);
    }
    function br() {
      Zt !== null && typeof Zt.markComponentLayoutEffectMountStopped == "function" && Zt.markComponentLayoutEffectMountStopped();
    }
    function cs(i) {
      Zt !== null && typeof Zt.markComponentLayoutEffectUnmountStarted == "function" && Zt.markComponentLayoutEffectUnmountStarted(i);
    }
    function Os() {
      Zt !== null && typeof Zt.markComponentLayoutEffectUnmountStopped == "function" && Zt.markComponentLayoutEffectUnmountStopped();
    }
    function ji(i, l, g) {
      Zt !== null && typeof Zt.markComponentErrored == "function" && Zt.markComponentErrored(i, l, g);
    }
    function ro(i, l, g) {
      Zt !== null && typeof Zt.markComponentSuspended == "function" && Zt.markComponentSuspended(i, l, g);
    }
    function Pm(i) {
      Zt !== null && typeof Zt.markLayoutEffectsStarted == "function" && Zt.markLayoutEffectsStarted(i);
    }
    function Xs() {
      Zt !== null && typeof Zt.markLayoutEffectsStopped == "function" && Zt.markLayoutEffectsStopped();
    }
    function Dh(i) {
      Zt !== null && typeof Zt.markPassiveEffectsStarted == "function" && Zt.markPassiveEffectsStarted(i);
    }
    function lf() {
      Zt !== null && typeof Zt.markPassiveEffectsStopped == "function" && Zt.markPassiveEffectsStopped();
    }
    function bs(i) {
      Zt !== null && typeof Zt.markRenderStarted == "function" && Zt.markRenderStarted(i);
    }
    function Ip() {
      Zt !== null && typeof Zt.markRenderYielded == "function" && Zt.markRenderYielded();
    }
    function Om() {
      Zt !== null && typeof Zt.markRenderStopped == "function" && Zt.markRenderStopped();
    }
    function vl(i) {
      Zt !== null && typeof Zt.markRenderScheduled == "function" && Zt.markRenderScheduled(i);
    }
    function Fp(i, l) {
      Zt !== null && typeof Zt.markForceUpdateScheduled == "function" && Zt.markForceUpdateScheduled(i, l);
    }
    function Ph(i, l) {
      Zt !== null && typeof Zt.markStateUpdateScheduled == "function" && Zt.markStateUpdateScheduled(i, l);
    }
    var Sn = (
      /*                         */
      0
    ), Mn = (
      /*                 */
      1
    ), ar = (
      /*                    */
      2
    ), $r = (
      /*               */
      8
    ), Fi = (
      /*              */
      16
    ), hd = Math.clz32 ? Math.clz32 : us, Ou = Math.log, xl = Math.LN2;
    function us(i) {
      var l = i >>> 0;
      return l === 0 ? 32 : 31 - (Ou(l) / xl | 0) | 0;
    }
    var $f = 31, St = (
      /*                        */
      0
    ), Qs = (
      /*                          */
      0
    ), hn = (
      /*                        */
      1
    ), As = (
      /*    */
      2
    ), va = (
      /*             */
      4
    ), oi = (
      /*            */
      8
    ), xo = (
      /*                     */
      16
    ), Kc = (
      /*                */
      32
    ), Au = (
      /*                       */
      4194240
    ), Gf = (
      /*                        */
      64
    ), yi = (
      /*                        */
      128
    ), bl = (
      /*                        */
      256
    ), pd = (
      /*                        */
      512
    ), yc = (
      /*                        */
      1024
    ), bo = (
      /*                        */
      2048
    ), Am = (
      /*                        */
      4096
    ), eg = (
      /*                        */
      8192
    ), Lm = (
      /*                        */
      16384
    ), $l = (
      /*                       */
      32768
    ), tg = (
      /*                       */
      65536
    ), Oh = (
      /*                       */
      131072
    ), Im = (
      /*                       */
      262144
    ), ng = (
      /*                       */
      524288
    ), Lu = (
      /*                       */
      1048576
    ), h0 = (
      /*                       */
      2097152
    ), Iu = (
      /*                            */
      130023424
    ), vc = (
      /*                             */
      4194304
    ), Ir = (
      /*                             */
      8388608
    ), Gl = (
      /*                             */
      16777216
    ), xc = (
      /*                             */
      33554432
    ), gd = (
      /*                             */
      67108864
    ), Wf = vc, Up = (
      /*          */
      134217728
    ), rg = (
      /*                          */
      268435455
    ), zp = (
      /*               */
      268435456
    ), ao = (
      /*                        */
      536870912
    ), So = (
      /*                   */
      1073741824
    );
    function mx(i) {
      {
        if (i & hn)
          return "Sync";
        if (i & As)
          return "InputContinuousHydration";
        if (i & va)
          return "InputContinuous";
        if (i & oi)
          return "DefaultHydration";
        if (i & xo)
          return "Default";
        if (i & Kc)
          return "TransitionHydration";
        if (i & Au)
          return "Transition";
        if (i & Iu)
          return "Retry";
        if (i & Up)
          return "SelectiveHydration";
        if (i & zp)
          return "IdleHydration";
        if (i & ao)
          return "Idle";
        if (i & So)
          return "Offscreen";
      }
    }
    var da = -1, Yf = Gf, Ei = vc;
    function yd(i) {
      switch (be(i)) {
        case hn:
          return hn;
        case As:
          return As;
        case va:
          return va;
        case oi:
          return oi;
        case xo:
          return xo;
        case Kc:
          return Kc;
        case Gf:
        case yi:
        case bl:
        case pd:
        case yc:
        case bo:
        case Am:
        case eg:
        case Lm:
        case $l:
        case tg:
        case Oh:
        case Im:
        case ng:
        case Lu:
        case h0:
          return i & Au;
        case vc:
        case Ir:
        case Gl:
        case xc:
        case gd:
          return i & Iu;
        case Up:
          return Up;
        case zp:
          return zp;
        case ao:
          return ao;
        case So:
          return So;
        default:
          return c("Should have found matching lanes. This is a bug in React."), i;
      }
    }
    function vd(i, l) {
      var g = i.pendingLanes;
      if (g === St)
        return St;
      var S = St, _ = i.suspendedLanes, F = i.pingedLanes, Y = g & rg;
      if (Y !== St) {
        var ee = Y & ~_;
        if (ee !== St)
          S = yd(ee);
        else {
          var ie = Y & F;
          ie !== St && (S = yd(ie));
        }
      } else {
        var xe = g & ~_;
        xe !== St ? S = yd(xe) : F !== St && (S = yd(F));
      }
      if (S === St)
        return St;
      if (l !== St && l !== S && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (l & _) === St) {
        var we = be(S), Le = be(l);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          we >= Le || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          we === xo && (Le & Au) !== St
        )
          return l;
      }
      (S & va) !== St && (S |= g & xo);
      var Ae = i.entangledLanes;
      if (Ae !== St)
        for (var et = i.entanglements, nt = S & Ae; nt > 0; ) {
          var dt = Ze(nt), xn = 1 << dt;
          S |= et[dt], nt &= ~xn;
        }
      return S;
    }
    function Bp(i, l) {
      for (var g = i.eventTimes, S = da; l > 0; ) {
        var _ = Ze(l), F = 1 << _, Y = g[_];
        Y > S && (S = Y), l &= ~F;
      }
      return S;
    }
    function p0(i, l) {
      switch (i) {
        case hn:
        case As:
        case va:
          return l + 250;
        case oi:
        case xo:
        case Kc:
        case Gf:
        case yi:
        case bl:
        case pd:
        case yc:
        case bo:
        case Am:
        case eg:
        case Lm:
        case $l:
        case tg:
        case Oh:
        case Im:
        case ng:
        case Lu:
        case h0:
          return l + 5e3;
        case vc:
        case Ir:
        case Gl:
        case xc:
        case gd:
          return da;
        case Up:
        case zp:
        case ao:
        case So:
          return da;
        default:
          return c("Should have found matching lanes. This is a bug in React."), da;
      }
    }
    function Ay(i, l) {
      for (var g = i.pendingLanes, S = i.suspendedLanes, _ = i.pingedLanes, F = i.expirationTimes, Y = g; Y > 0; ) {
        var ee = Ze(Y), ie = 1 << ee, xe = F[ee];
        xe === da ? ((ie & S) === St || (ie & _) !== St) && (F[ee] = p0(ie, l)) : xe <= l && (i.expiredLanes |= ie), Y &= ~ie;
      }
    }
    function g0(i) {
      return yd(i.pendingLanes);
    }
    function qf(i) {
      var l = i.pendingLanes & ~So;
      return l !== St ? l : l & So ? So : St;
    }
    function y0(i) {
      return (i & hn) !== St;
    }
    function Kf(i) {
      return (i & rg) !== St;
    }
    function ag(i) {
      return (i & Iu) === i;
    }
    function hx(i) {
      var l = hn | va | xo;
      return (i & l) === St;
    }
    function v(i) {
      return (i & Au) === i;
    }
    function x(i, l) {
      var g = As | va | oi | xo;
      return (l & g) !== St;
    }
    function P(i, l) {
      return (l & i.expiredLanes) !== St;
    }
    function B(i) {
      return (i & Au) !== St;
    }
    function G() {
      var i = Yf;
      return Yf <<= 1, (Yf & Au) === St && (Yf = Gf), i;
    }
    function ne() {
      var i = Ei;
      return Ei <<= 1, (Ei & Iu) === St && (Ei = vc), i;
    }
    function be(i) {
      return i & -i;
    }
    function Fe(i) {
      return be(i);
    }
    function Ze(i) {
      return 31 - hd(i);
    }
    function Ft(i) {
      return Ze(i);
    }
    function sn(i, l) {
      return (i & l) !== St;
    }
    function dr(i, l) {
      return (i & l) === l;
    }
    function ct(i, l) {
      return i | l;
    }
    function xa(i, l) {
      return i & ~l;
    }
    function Ga(i, l) {
      return i & l;
    }
    function bc(i) {
      return i;
    }
    function Zs(i, l) {
      return i !== Qs && i < l ? i : l;
    }
    function Be(i) {
      for (var l = [], g = 0; g < $f; g++)
        l.push(i);
      return l;
    }
    function ze(i, l, g) {
      i.pendingLanes |= l, l !== ao && (i.suspendedLanes = St, i.pingedLanes = St);
      var S = i.eventTimes, _ = Ft(l);
      S[_] = g;
    }
    function rt(i, l) {
      i.suspendedLanes |= l, i.pingedLanes &= ~l;
      for (var g = i.expirationTimes, S = l; S > 0; ) {
        var _ = Ze(S), F = 1 << _;
        g[_] = da, S &= ~F;
      }
    }
    function Jt(i, l, g) {
      i.pingedLanes |= i.suspendedLanes & l;
    }
    function Yn(i, l) {
      var g = i.pendingLanes & ~l;
      i.pendingLanes = l, i.suspendedLanes = St, i.pingedLanes = St, i.expiredLanes &= l, i.mutableReadLanes &= l, i.entangledLanes &= l;
      for (var S = i.entanglements, _ = i.eventTimes, F = i.expirationTimes, Y = g; Y > 0; ) {
        var ee = Ze(Y), ie = 1 << ee;
        S[ee] = St, _[ee] = da, F[ee] = da, Y &= ~ie;
      }
    }
    function pr(i, l) {
      for (var g = i.entangledLanes |= l, S = i.entanglements, _ = g; _; ) {
        var F = Ze(_), Y = 1 << F;
        // Is this one of the newly entangled lanes?
        Y & l | // Is this lane transitively entangled with the newly entangled lanes?
        S[F] & l && (S[F] |= l), _ &= ~Y;
      }
    }
    function gr(i, l) {
      var g = be(l), S;
      switch (g) {
        case va:
          S = As;
          break;
        case xo:
          S = oi;
          break;
        case Gf:
        case yi:
        case bl:
        case pd:
        case yc:
        case bo:
        case Am:
        case eg:
        case Lm:
        case $l:
        case tg:
        case Oh:
        case Im:
        case ng:
        case Lu:
        case h0:
        case vc:
        case Ir:
        case Gl:
        case xc:
        case gd:
          S = Kc;
          break;
        case ao:
          S = zp;
          break;
        default:
          S = Qs;
          break;
      }
      return (S & (i.suspendedLanes | l)) !== Qs ? Qs : S;
    }
    function Kr(i, l, g) {
      if (gc)
        for (var S = i.pendingUpdatersLaneMap; g > 0; ) {
          var _ = Ft(g), F = 1 << _, Y = S[_];
          Y.add(l), g &= ~F;
        }
    }
    function Js(i, l) {
      if (gc)
        for (var g = i.pendingUpdatersLaneMap, S = i.memoizedUpdaters; l > 0; ) {
          var _ = Ft(l), F = 1 << _, Y = g[_];
          Y.size > 0 && (Y.forEach(function(ee) {
            var ie = ee.alternate;
            (ie === null || !S.has(ie)) && S.add(ee);
          }), Y.clear()), l &= ~F;
        }
    }
    function Wr(i, l) {
      return null;
    }
    var Ea = hn, Xc = va, Sc = xo, Ah = ao, sg = Qs;
    function xd() {
      return sg;
    }
    function ki(i) {
      sg = i;
    }
    function Sl(i, l) {
      var g = sg;
      try {
        return sg = i, l();
      } finally {
        sg = g;
      }
    }
    function Mw(i, l) {
      return i !== 0 && i < l ? i : l;
    }
    function Rw(i, l) {
      return i > l ? i : l;
    }
    function Hp(i, l) {
      return i !== 0 && i < l;
    }
    function zo(i) {
      var l = be(i);
      return Hp(Ea, l) ? Hp(Xc, l) ? Kf(l) ? Sc : Ah : Xc : Ea;
    }
    function v0(i) {
      var l = i.current.memoizedState;
      return l.isDehydrated;
    }
    var kn;
    function Vp(i) {
      kn = i;
    }
    function px(i) {
      kn(i);
    }
    var gx;
    function Ly(i) {
      gx = i;
    }
    var Lh;
    function ig(i) {
      Lh = i;
    }
    var Iy;
    function ib(i) {
      Iy = i;
    }
    var $p;
    function ob(i) {
      $p = i;
    }
    var Fy = !1, x0 = [], Ls = null, Ui = null, wl = null, Xf = /* @__PURE__ */ new Map(), Gp = /* @__PURE__ */ new Map(), so = [], Uy = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Qf(i) {
      return Uy.indexOf(i) > -1;
    }
    function E5(i, l, g, S, _) {
      return {
        blockedOn: i,
        domEventName: l,
        eventSystemFlags: g,
        nativeEvent: _,
        targetContainers: [S]
      };
    }
    function yx(i, l) {
      switch (i) {
        case "focusin":
        case "focusout":
          Ls = null;
          break;
        case "dragenter":
        case "dragleave":
          Ui = null;
          break;
        case "mouseover":
        case "mouseout":
          wl = null;
          break;
        case "pointerover":
        case "pointerout": {
          var g = l.pointerId;
          Xf.delete(g);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var S = l.pointerId;
          Gp.delete(S);
          break;
        }
      }
    }
    function Wp(i, l, g, S, _, F) {
      if (i === null || i.nativeEvent !== F) {
        var Y = E5(l, g, S, _, F);
        if (l !== null) {
          var ee = P0(l);
          ee !== null && gx(ee);
        }
        return Y;
      }
      i.eventSystemFlags |= S;
      var ie = i.targetContainers;
      return _ !== null && ie.indexOf(_) === -1 && ie.push(_), i;
    }
    function vx(i, l, g, S, _) {
      switch (l) {
        case "focusin": {
          var F = _;
          return Ls = Wp(Ls, i, l, g, S, F), !0;
        }
        case "dragenter": {
          var Y = _;
          return Ui = Wp(Ui, i, l, g, S, Y), !0;
        }
        case "mouseover": {
          var ee = _;
          return wl = Wp(wl, i, l, g, S, ee), !0;
        }
        case "pointerover": {
          var ie = _, xe = ie.pointerId;
          return Xf.set(xe, Wp(Xf.get(xe) || null, i, l, g, S, ie)), !0;
        }
        case "gotpointercapture": {
          var we = _, Le = we.pointerId;
          return Gp.set(Le, Wp(Gp.get(Le) || null, i, l, g, S, we)), !0;
        }
      }
      return !1;
    }
    function lb(i) {
      var l = Gm(i.target);
      if (l !== null) {
        var g = fc(l);
        if (g !== null) {
          var S = g.tag;
          if (S === z) {
            var _ = Py(g);
            if (_ !== null) {
              i.blockedOn = _, $p(i.priority, function() {
                Lh(g);
              });
              return;
            }
          } else if (S === w) {
            var F = g.stateNode;
            if (v0(F)) {
              i.blockedOn = Hf(g);
              return;
            }
          }
        }
      }
      i.blockedOn = null;
    }
    function Dw(i) {
      for (var l = Iy(), g = {
        blockedOn: null,
        target: i,
        priority: l
      }, S = 0; S < so.length && Hp(l, so[S].priority); S++)
        ;
      so.splice(S, 0, g), S === 0 && lb(g);
    }
    function cf(i) {
      if (i.blockedOn !== null)
        return !1;
      for (var l = i.targetContainers; l.length > 0; ) {
        var g = l[0], S = Vo(i.domEventName, i.eventSystemFlags, g, i.nativeEvent);
        if (S === null) {
          var _ = i.nativeEvent, F = new _.constructor(_.type, _);
          bt(F), _.target.dispatchEvent(F), Zi();
        } else {
          var Y = P0(S);
          return Y !== null && gx(Y), i.blockedOn = S, !1;
        }
        l.shift();
      }
      return !0;
    }
    function _i(i, l, g) {
      cf(i) && g.delete(l);
    }
    function Cl() {
      Fy = !1, Ls !== null && cf(Ls) && (Ls = null), Ui !== null && cf(Ui) && (Ui = null), wl !== null && cf(wl) && (wl = null), Xf.forEach(_i), Gp.forEach(_i);
    }
    function ra(i, l) {
      i.blockedOn === l && (i.blockedOn = null, Fy || (Fy = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, Cl)));
    }
    function zi(i) {
      if (x0.length > 0) {
        ra(x0[0], i);
        for (var l = 1; l < x0.length; l++) {
          var g = x0[l];
          g.blockedOn === i && (g.blockedOn = null);
        }
      }
      Ls !== null && ra(Ls, i), Ui !== null && ra(Ui, i), wl !== null && ra(wl, i);
      var S = function(ee) {
        return ra(ee, i);
      };
      Xf.forEach(S), Gp.forEach(S);
      for (var _ = 0; _ < so.length; _++) {
        var F = so[_];
        F.blockedOn === i && (F.blockedOn = null);
      }
      for (; so.length > 0; ) {
        var Y = so[0];
        if (Y.blockedOn !== null)
          break;
        lb(Y), Y.blockedOn === null && so.shift();
      }
    }
    var ei = n.ReactCurrentBatchConfig, Bo = !0;
    function Fu(i) {
      Bo = !!i;
    }
    function wo() {
      return Bo;
    }
    function Ho(i, l, g) {
      var S = S0(l), _;
      switch (S) {
        case Ea:
          _ = Yp;
          break;
        case Xc:
          _ = qp;
          break;
        case Sc:
        default:
          _ = og;
          break;
      }
      return _.bind(null, l, g, i);
    }
    function Yp(i, l, g, S) {
      var _ = xd(), F = ei.transition;
      ei.transition = null;
      try {
        ki(Ea), og(i, l, g, S);
      } finally {
        ki(_), ei.transition = F;
      }
    }
    function qp(i, l, g, S) {
      var _ = xd(), F = ei.transition;
      ei.transition = null;
      try {
        ki(Xc), og(i, l, g, S);
      } finally {
        ki(_), ei.transition = F;
      }
    }
    function og(i, l, g, S) {
      Bo && b0(i, l, g, S);
    }
    function b0(i, l, g, S) {
      var _ = Vo(i, l, g, S);
      if (_ === null) {
        $m(i, l, S, Fm, g), yx(i, S);
        return;
      }
      if (vx(_, i, l, g, S)) {
        S.stopPropagation();
        return;
      }
      if (yx(i, S), l & od && Qf(i)) {
        for (; _ !== null; ) {
          var F = P0(_);
          F !== null && px(F);
          var Y = Vo(i, l, g, S);
          if (Y === null && $m(i, l, S, Fm, g), Y === _)
            break;
          _ = Y;
        }
        _ !== null && S.stopPropagation();
        return;
      }
      $m(i, l, S, null, g);
    }
    var Fm = null;
    function Vo(i, l, g, S) {
      Fm = null;
      var _ = tf(S), F = Gm(_);
      if (F !== null) {
        var Y = fc(F);
        if (Y === null)
          F = null;
        else {
          var ee = Y.tag;
          if (ee === z) {
            var ie = Py(Y);
            if (ie !== null)
              return ie;
            F = null;
          } else if (ee === w) {
            var xe = Y.stateNode;
            if (v0(xe))
              return Hf(Y);
            F = null;
          } else Y !== F && (F = null);
        }
      }
      return Fm = F, null;
    }
    function S0(i) {
      switch (i) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Ea;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Xc;
        case "message": {
          var l = Q1();
          switch (l) {
            case Th:
              return Ea;
            case qs:
              return Xc;
            case Ni:
            case md:
              return Sc;
            case Ap:
              return Ah;
            default:
              return Sc;
          }
        }
        default:
          return Sc;
      }
    }
    function Ih(i, l, g) {
      return i.addEventListener(l, g, !1), g;
    }
    function Zf(i, l, g) {
      return i.addEventListener(l, g, !0), g;
    }
    function zy(i, l, g, S) {
      return i.addEventListener(l, g, {
        capture: !0,
        passive: S
      }), g;
    }
    function Jf(i, l, g, S) {
      return i.addEventListener(l, g, {
        passive: S
      }), g;
    }
    var $o = null, Fh = null, Uu = null;
    function xx(i) {
      return $o = i, Fh = w0(), !0;
    }
    function Kp() {
      $o = null, Fh = null, Uu = null;
    }
    function bx() {
      if (Uu)
        return Uu;
      var i, l = Fh, g = l.length, S, _ = w0(), F = _.length;
      for (i = 0; i < g && l[i] === _[i]; i++)
        ;
      var Y = g - i;
      for (S = 1; S <= Y && l[g - S] === _[F - S]; S++)
        ;
      var ee = S > 1 ? 1 - S : void 0;
      return Uu = _.slice(i, ee), Uu;
    }
    function w0() {
      return "value" in $o ? $o.value : $o.textContent;
    }
    function Um(i) {
      var l, g = i.keyCode;
      return "charCode" in i ? (l = i.charCode, l === 0 && g === 13 && (l = 13)) : l = g, l === 10 && (l = 13), l >= 32 || l === 13 ? l : 0;
    }
    function Go() {
      return !0;
    }
    function bd() {
      return !1;
    }
    function ds(i) {
      function l(g, S, _, F, Y) {
        this._reactName = g, this._targetInst = _, this.type = S, this.nativeEvent = F, this.target = Y, this.currentTarget = null;
        for (var ee in i)
          if (i.hasOwnProperty(ee)) {
            var ie = i[ee];
            ie ? this[ee] = ie(F) : this[ee] = F[ee];
          }
        var xe = F.defaultPrevented != null ? F.defaultPrevented : F.returnValue === !1;
        return xe ? this.isDefaultPrevented = Go : this.isDefaultPrevented = bd, this.isPropagationStopped = bd, this;
      }
      return ir(l.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var g = this.nativeEvent;
          g && (g.preventDefault ? g.preventDefault() : typeof g.returnValue != "unknown" && (g.returnValue = !1), this.isDefaultPrevented = Go);
        },
        stopPropagation: function() {
          var g = this.nativeEvent;
          g && (g.stopPropagation ? g.stopPropagation() : typeof g.cancelBubble != "unknown" && (g.cancelBubble = !0), this.isPropagationStopped = Go);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Go
      }), l;
    }
    var Ti = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(i) {
        return i.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, lg = ds(Ti), zm = ir({}, Ti, {
      view: 0,
      detail: 0
    }), By = ds(zm), Hy, Qc, Bm;
    function Sx(i) {
      i !== Bm && (Bm && i.type === "mousemove" ? (Hy = i.screenX - Bm.screenX, Qc = i.screenY - Bm.screenY) : (Hy = 0, Qc = 0), Bm = i);
    }
    var uf = ir({}, zm, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Wo,
      button: 0,
      buttons: 0,
      relatedTarget: function(i) {
        return i.relatedTarget === void 0 ? i.fromElement === i.srcElement ? i.toElement : i.fromElement : i.relatedTarget;
      },
      movementX: function(i) {
        return "movementX" in i ? i.movementX : (Sx(i), Hy);
      },
      movementY: function(i) {
        return "movementY" in i ? i.movementY : Qc;
      }
    }), wx = ds(uf), Xp = ir({}, uf, {
      dataTransfer: 0
    }), cb = ds(Xp), C0 = ir({}, zm, {
      relatedTarget: 0
    }), Zc = ds(C0), N0 = ir({}, Ti, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), j0 = ds(N0), ub = ir({}, Ti, {
      clipboardData: function(i) {
        return "clipboardData" in i ? i.clipboardData : window.clipboardData;
      }
    }), k5 = ds(ub), Uh = ir({}, Ti, {
      data: 0
    }), Sd = ds(Uh), Pw = Sd, zh = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, Jc = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Qr(i) {
      if (i.key) {
        var l = zh[i.key] || i.key;
        if (l !== "Unidentified")
          return l;
      }
      if (i.type === "keypress") {
        var g = Um(i);
        return g === 13 ? "Enter" : String.fromCharCode(g);
      }
      return i.type === "keydown" || i.type === "keyup" ? Jc[i.keyCode] || "Unidentified" : "";
    }
    var Hm = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function Co(i) {
      var l = this, g = l.nativeEvent;
      if (g.getModifierState)
        return g.getModifierState(i);
      var S = Hm[i];
      return S ? !!g[S] : !1;
    }
    function Wo(i) {
      return Co;
    }
    var db = ir({}, zm, {
      key: Qr,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Wo,
      // Legacy Interface
      charCode: function(i) {
        return i.type === "keypress" ? Um(i) : 0;
      },
      keyCode: function(i) {
        return i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
      },
      which: function(i) {
        return i.type === "keypress" ? Um(i) : i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
      }
    }), Cx = ds(db), _5 = ir({}, uf, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), pn = ds(_5), wc = ir({}, zm, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Wo
    }), Vy = ds(wc), E0 = ir({}, Ti, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), zu = ds(E0), La = ir({}, uf, {
      deltaX: function(i) {
        return "deltaX" in i ? i.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in i ? -i.wheelDeltaX : 0
        );
      },
      deltaY: function(i) {
        return "deltaY" in i ? i.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in i ? -i.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in i ? -i.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), li = ds(La), Bi = [9, 13, 27, 32], cg = 229, Bh = He && "CompositionEvent" in window, Hh = null;
    He && "documentMode" in document && (Hh = document.documentMode);
    var fb = He && "TextEvent" in window && !Hh, T5 = He && (!Bh || Hh && Hh > 8 && Hh <= 11), ht = 32, Bu = String.fromCharCode(ht);
    function em() {
      vt("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), vt("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), vt("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), vt("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var ug = !1;
    function Ia(i) {
      return (i.ctrlKey || i.altKey || i.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(i.ctrlKey && i.altKey);
    }
    function nn(i) {
      switch (i) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function k0(i, l) {
      return i === "keydown" && l.keyCode === cg;
    }
    function mb(i, l) {
      switch (i) {
        case "keyup":
          return Bi.indexOf(l.keyCode) !== -1;
        case "keydown":
          return l.keyCode !== cg;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Yo(i) {
      var l = i.detail;
      return typeof l == "object" && "data" in l ? l.data : null;
    }
    function dg(i) {
      return i.locale === "ko";
    }
    var wd = !1;
    function Vh(i, l, g, S, _) {
      var F, Y;
      if (Bh ? F = nn(l) : wd ? mb(l, S) && (F = "onCompositionEnd") : k0(l, S) && (F = "onCompositionStart"), !F)
        return null;
      T5 && !dg(S) && (!wd && F === "onCompositionStart" ? wd = xx(_) : F === "onCompositionEnd" && wd && (Y = bx()));
      var ee = Ex(g, F);
      if (ee.length > 0) {
        var ie = new Sd(F, l, null, S, _);
        if (i.push({
          event: ie,
          listeners: ee
        }), Y)
          ie.data = Y;
        else {
          var xe = Yo(S);
          xe !== null && (ie.data = xe);
        }
      }
    }
    function hb(i, l) {
      switch (i) {
        case "compositionend":
          return Yo(l);
        case "keypress":
          var g = l.which;
          return g !== ht ? null : (ug = !0, Bu);
        case "textInput":
          var S = l.data;
          return S === Bu && ug ? null : S;
        default:
          return null;
      }
    }
    function M5(i, l) {
      if (wd) {
        if (i === "compositionend" || !Bh && mb(i, l)) {
          var g = bx();
          return Kp(), wd = !1, g;
        }
        return null;
      }
      switch (i) {
        case "paste":
          return null;
        case "keypress":
          if (!Ia(l)) {
            if (l.char && l.char.length > 1)
              return l.char;
            if (l.which)
              return String.fromCharCode(l.which);
          }
          return null;
        case "compositionend":
          return T5 && !dg(l) ? null : l.data;
        default:
          return null;
      }
    }
    function Cd(i, l, g, S, _) {
      var F;
      if (fb ? F = hb(l, S) : F = M5(l, S), !F)
        return null;
      var Y = Ex(g, "onBeforeInput");
      if (Y.length > 0) {
        var ee = new Pw("onBeforeInput", "beforeinput", null, S, _);
        i.push({
          event: ee,
          listeners: Y
        }), ee.data = F;
      }
    }
    function df(i, l, g, S, _, F, Y) {
      Vh(i, l, g, S, _), Cd(i, l, g, S, _);
    }
    var _0 = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function Nx(i) {
      var l = i && i.nodeName && i.nodeName.toLowerCase();
      return l === "input" ? !!_0[i.type] : l === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function T0(i) {
      if (!He)
        return !1;
      var l = "on" + i, g = l in document;
      if (!g) {
        var S = document.createElement("div");
        S.setAttribute(l, "return;"), g = typeof S[l] == "function";
      }
      return g;
    }
    function f() {
      vt("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function p(i, l, g, S) {
      Uf(S);
      var _ = Ex(l, "onChange");
      if (_.length > 0) {
        var F = new lg("onChange", "change", null, g, S);
        i.push({
          event: F,
          listeners: _
        });
      }
    }
    var N = null, O = null;
    function V(i) {
      var l = i.nodeName && i.nodeName.toLowerCase();
      return l === "select" || l === "input" && i.type === "file";
    }
    function J(i) {
      var l = [];
      p(l, O, i, tf(i)), Dp(me, l);
    }
    function me(i) {
      U6(i, 0);
    }
    function je(i) {
      var l = Px(i);
      if (Su(l))
        return i;
    }
    function De(i, l) {
      if (i === "change")
        return l;
    }
    var Je = !1;
    He && (Je = T0("input") && (!document.documentMode || document.documentMode > 9));
    function Mt(i, l) {
      N = i, O = l, N.attachEvent("onpropertychange", Tt);
    }
    function Dt() {
      N && (N.detachEvent("onpropertychange", Tt), N = null, O = null);
    }
    function Tt(i) {
      i.propertyName === "value" && je(O) && J(i);
    }
    function vn(i, l, g) {
      i === "focusin" ? (Dt(), Mt(l, g)) : i === "focusout" && Dt();
    }
    function _n(i, l) {
      if (i === "selectionchange" || i === "keyup" || i === "keydown")
        return je(O);
    }
    function An(i) {
      var l = i.nodeName;
      return l && l.toLowerCase() === "input" && (i.type === "checkbox" || i.type === "radio");
    }
    function vi(i, l) {
      if (i === "click")
        return je(l);
    }
    function Ve(i, l) {
      if (i === "input" || i === "change")
        return je(l);
    }
    function Oe(i) {
      var l = i._wrapperState;
      !l || !l.controlled || i.type !== "number" || hl(i, "number", i.value);
    }
    function Ge(i, l, g, S, _, F, Y) {
      var ee = g ? Px(g) : window, ie, xe;
      if (V(ee) ? ie = De : Nx(ee) ? Je ? ie = Ve : (ie = _n, xe = vn) : An(ee) && (ie = vi), ie) {
        var we = ie(l, g);
        if (we) {
          p(i, we, S, _);
          return;
        }
      }
      xe && xe(l, ee, g), l === "focusout" && Oe(ee);
    }
    function zt() {
      At("onMouseEnter", ["mouseout", "mouseover"]), At("onMouseLeave", ["mouseout", "mouseover"]), At("onPointerEnter", ["pointerout", "pointerover"]), At("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function zn(i, l, g, S, _, F, Y) {
      var ee = l === "mouseover" || l === "pointerover", ie = l === "mouseout" || l === "pointerout";
      if (ee && !rr(S)) {
        var xe = S.relatedTarget || S.fromElement;
        if (xe && (Gm(xe) || t1(xe)))
          return;
      }
      if (!(!ie && !ee)) {
        var we;
        if (_.window === _)
          we = _;
        else {
          var Le = _.ownerDocument;
          Le ? we = Le.defaultView || Le.parentWindow : we = window;
        }
        var Ae, et;
        if (ie) {
          var nt = S.relatedTarget || S.toElement;
          if (Ae = g, et = nt ? Gm(nt) : null, et !== null) {
            var dt = fc(et);
            (et !== dt || et.tag !== j && et.tag !== E) && (et = null);
          }
        } else
          Ae = null, et = g;
        if (Ae !== et) {
          var xn = wx, fr = "onMouseLeave", qn = "onMouseEnter", Ua = "mouse";
          (l === "pointerout" || l === "pointerover") && (xn = pn, fr = "onPointerLeave", qn = "onPointerEnter", Ua = "pointer");
          var ba = Ae == null ? we : Px(Ae), We = et == null ? we : Px(et), ft = new xn(fr, Ua + "leave", Ae, S, _);
          ft.target = ba, ft.relatedTarget = We;
          var Ye = null, Ut = Gm(_);
          if (Ut === g) {
            var Tn = new xn(qn, Ua + "enter", et, S, _);
            Tn.target = We, Tn.relatedTarget = ba, Ye = Tn;
          }
          $w(i, ft, Ye, Ae, et);
        }
      }
    }
    function tr(i, l) {
      return i === l && (i !== 0 || 1 / i === 1 / l) || i !== i && l !== l;
    }
    var Rn = typeof Object.is == "function" ? Object.is : tr;
    function sr(i, l) {
      if (Rn(i, l))
        return !0;
      if (typeof i != "object" || i === null || typeof l != "object" || l === null)
        return !1;
      var g = Object.keys(i), S = Object.keys(l);
      if (g.length !== S.length)
        return !1;
      for (var _ = 0; _ < g.length; _++) {
        var F = g[_];
        if (!Pt.call(l, F) || !Rn(i[F], l[F]))
          return !1;
      }
      return !0;
    }
    function No(i) {
      for (; i && i.firstChild; )
        i = i.firstChild;
      return i;
    }
    function ka(i) {
      for (; i; ) {
        if (i.nextSibling)
          return i.nextSibling;
        i = i.parentNode;
      }
    }
    function ff(i, l) {
      for (var g = No(i), S = 0, _ = 0; g; ) {
        if (g.nodeType === zl) {
          if (_ = S + g.textContent.length, S <= l && _ >= l)
            return {
              node: g,
              offset: l - S
            };
          S = _;
        }
        g = No(ka(g));
      }
    }
    function Ow(i) {
      var l = i.ownerDocument, g = l && l.defaultView || window, S = g.getSelection && g.getSelection();
      if (!S || S.rangeCount === 0)
        return null;
      var _ = S.anchorNode, F = S.anchorOffset, Y = S.focusNode, ee = S.focusOffset;
      try {
        _.nodeType, Y.nodeType;
      } catch {
        return null;
      }
      return R5(i, _, F, Y, ee);
    }
    function R5(i, l, g, S, _) {
      var F = 0, Y = -1, ee = -1, ie = 0, xe = 0, we = i, Le = null;
      e: for (; ; ) {
        for (var Ae = null; we === l && (g === 0 || we.nodeType === zl) && (Y = F + g), we === S && (_ === 0 || we.nodeType === zl) && (ee = F + _), we.nodeType === zl && (F += we.nodeValue.length), (Ae = we.firstChild) !== null; )
          Le = we, we = Ae;
        for (; ; ) {
          if (we === i)
            break e;
          if (Le === l && ++ie === g && (Y = F), Le === S && ++xe === _ && (ee = F), (Ae = we.nextSibling) !== null)
            break;
          we = Le, Le = we.parentNode;
        }
        we = Ae;
      }
      return Y === -1 || ee === -1 ? null : {
        start: Y,
        end: ee
      };
    }
    function Aw(i, l) {
      var g = i.ownerDocument || document, S = g && g.defaultView || window;
      if (S.getSelection) {
        var _ = S.getSelection(), F = i.textContent.length, Y = Math.min(l.start, F), ee = l.end === void 0 ? Y : Math.min(l.end, F);
        if (!_.extend && Y > ee) {
          var ie = ee;
          ee = Y, Y = ie;
        }
        var xe = ff(i, Y), we = ff(i, ee);
        if (xe && we) {
          if (_.rangeCount === 1 && _.anchorNode === xe.node && _.anchorOffset === xe.offset && _.focusNode === we.node && _.focusOffset === we.offset)
            return;
          var Le = g.createRange();
          Le.setStart(xe.node, xe.offset), _.removeAllRanges(), Y > ee ? (_.addRange(Le), _.extend(we.node, we.offset)) : (Le.setEnd(we.node, we.offset), _.addRange(Le));
        }
      }
    }
    function pb(i) {
      return i && i.nodeType === zl;
    }
    function D5(i, l) {
      return !i || !l ? !1 : i === l ? !0 : pb(i) ? !1 : pb(l) ? D5(i, l.parentNode) : "contains" in i ? i.contains(l) : i.compareDocumentPosition ? !!(i.compareDocumentPosition(l) & 16) : !1;
    }
    function P5(i) {
      return i && i.ownerDocument && D5(i.ownerDocument.documentElement, i);
    }
    function Lw(i) {
      try {
        return typeof i.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function Iw() {
      for (var i = window, l = wu(); l instanceof i.HTMLIFrameElement; ) {
        if (Lw(l))
          i = l.contentWindow;
        else
          return l;
        l = wu(i.document);
      }
      return l;
    }
    function O5(i) {
      var l = i && i.nodeName && i.nodeName.toLowerCase();
      return l && (l === "input" && (i.type === "text" || i.type === "search" || i.type === "tel" || i.type === "url" || i.type === "password") || l === "textarea" || i.contentEditable === "true");
    }
    function R6() {
      var i = Iw();
      return {
        focusedElem: i,
        selectionRange: O5(i) ? Fw(i) : null
      };
    }
    function h_(i) {
      var l = Iw(), g = i.focusedElem, S = i.selectionRange;
      if (l !== g && P5(g)) {
        S !== null && O5(g) && D6(g, S);
        for (var _ = [], F = g; F = F.parentNode; )
          F.nodeType === pl && _.push({
            element: F,
            left: F.scrollLeft,
            top: F.scrollTop
          });
        typeof g.focus == "function" && g.focus();
        for (var Y = 0; Y < _.length; Y++) {
          var ee = _[Y];
          ee.element.scrollLeft = ee.left, ee.element.scrollTop = ee.top;
        }
      }
    }
    function Fw(i) {
      var l;
      return "selectionStart" in i ? l = {
        start: i.selectionStart,
        end: i.selectionEnd
      } : l = Ow(i), l || {
        start: 0,
        end: 0
      };
    }
    function D6(i, l) {
      var g = l.start, S = l.end;
      S === void 0 && (S = g), "selectionStart" in i ? (i.selectionStart = g, i.selectionEnd = Math.min(S, i.value.length)) : Aw(i, l);
    }
    var P6 = He && "documentMode" in document && document.documentMode <= 11;
    function O6() {
      vt("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var jx = null, gb = null, M0 = null, Uw = !1;
    function p_(i) {
      if ("selectionStart" in i && O5(i))
        return {
          start: i.selectionStart,
          end: i.selectionEnd
        };
      var l = i.ownerDocument && i.ownerDocument.defaultView || window, g = l.getSelection();
      return {
        anchorNode: g.anchorNode,
        anchorOffset: g.anchorOffset,
        focusNode: g.focusNode,
        focusOffset: g.focusOffset
      };
    }
    function A6(i) {
      return i.window === i ? i.document : i.nodeType === ac ? i : i.ownerDocument;
    }
    function zw(i, l, g) {
      var S = A6(g);
      if (!(Uw || jx == null || jx !== wu(S))) {
        var _ = p_(jx);
        if (!M0 || !sr(M0, _)) {
          M0 = _;
          var F = Ex(gb, "onSelect");
          if (F.length > 0) {
            var Y = new lg("onSelect", "select", null, l, g);
            i.push({
              event: Y,
              listeners: F
            }), Y.target = jx;
          }
        }
      }
    }
    function L6(i, l, g, S, _, F, Y) {
      var ee = g ? Px(g) : window;
      switch (l) {
        case "focusin":
          (Nx(ee) || ee.contentEditable === "true") && (jx = ee, gb = g, M0 = null);
          break;
        case "focusout":
          jx = null, gb = null, M0 = null;
          break;
        case "mousedown":
          Uw = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Uw = !1, zw(i, S, _);
          break;
        case "selectionchange":
          if (P6)
            break;
        case "keydown":
        case "keyup":
          zw(i, S, _);
      }
    }
    function yb(i, l) {
      var g = {};
      return g[i.toLowerCase()] = l.toLowerCase(), g["Webkit" + i] = "webkit" + l, g["Moz" + i] = "moz" + l, g;
    }
    var fg = {
      animationend: yb("Animation", "AnimationEnd"),
      animationiteration: yb("Animation", "AnimationIteration"),
      animationstart: yb("Animation", "AnimationStart"),
      transitionend: yb("Transition", "TransitionEnd")
    }, A5 = {}, Bw = {};
    He && (Bw = document.createElement("div").style, "AnimationEvent" in window || (delete fg.animationend.animation, delete fg.animationiteration.animation, delete fg.animationstart.animation), "TransitionEvent" in window || delete fg.transitionend.transition);
    function vb(i) {
      if (A5[i])
        return A5[i];
      if (!fg[i])
        return i;
      var l = fg[i];
      for (var g in l)
        if (l.hasOwnProperty(g) && g in Bw)
          return A5[i] = l[g];
      return i;
    }
    var Hw = vb("animationend"), $h = vb("animationiteration"), Vm = vb("animationstart"), xb = vb("transitionend"), L5 = /* @__PURE__ */ new Map(), jr = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Nd(i, l) {
      L5.set(i, l), vt(l, [i]);
    }
    function I6() {
      for (var i = 0; i < jr.length; i++) {
        var l = jr[i], g = l.toLowerCase(), S = l[0].toUpperCase() + l.slice(1);
        Nd(g, "on" + S);
      }
      Nd(Hw, "onAnimationEnd"), Nd($h, "onAnimationIteration"), Nd(Vm, "onAnimationStart"), Nd("dblclick", "onDoubleClick"), Nd("focusin", "onFocus"), Nd("focusout", "onBlur"), Nd(xb, "onTransitionEnd");
    }
    function I5(i, l, g, S, _, F, Y) {
      var ee = L5.get(l);
      if (ee !== void 0) {
        var ie = lg, xe = l;
        switch (l) {
          case "keypress":
            if (Um(S) === 0)
              return;
          case "keydown":
          case "keyup":
            ie = Cx;
            break;
          case "focusin":
            xe = "focus", ie = Zc;
            break;
          case "focusout":
            xe = "blur", ie = Zc;
            break;
          case "beforeblur":
          case "afterblur":
            ie = Zc;
            break;
          case "click":
            if (S.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            ie = wx;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            ie = cb;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            ie = Vy;
            break;
          case Hw:
          case $h:
          case Vm:
            ie = j0;
            break;
          case xb:
            ie = zu;
            break;
          case "scroll":
            ie = By;
            break;
          case "wheel":
            ie = li;
            break;
          case "copy":
          case "cut":
          case "paste":
            ie = k5;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            ie = pn;
            break;
        }
        var we = (F & od) !== 0;
        {
          var Le = !we && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          l === "scroll", Ae = Qp(g, ee, S.type, we, Le);
          if (Ae.length > 0) {
            var et = new ie(ee, xe, null, S, _);
            i.push({
              event: et,
              listeners: Ae
            });
          }
        }
      }
    }
    I6(), zt(), f(), O6(), em();
    function bb(i, l, g, S, _, F, Y) {
      I5(i, l, g, S, _, F);
      var ee = (F & fx) === 0;
      ee && (zn(i, l, g, S, _), Ge(i, l, g, S, _), L6(i, l, g, S, _), df(i, l, g, S, _));
    }
    var R0 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], Sb = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(R0));
    function wb(i, l, g) {
      var S = i.type || "unknown-event";
      i.currentTarget = g, ud(S, l, void 0, i), i.currentTarget = null;
    }
    function F6(i, l, g) {
      var S;
      if (g)
        for (var _ = l.length - 1; _ >= 0; _--) {
          var F = l[_], Y = F.instance, ee = F.currentTarget, ie = F.listener;
          if (Y !== S && i.isPropagationStopped())
            return;
          wb(i, ie, ee), S = Y;
        }
      else
        for (var xe = 0; xe < l.length; xe++) {
          var we = l[xe], Le = we.instance, Ae = we.currentTarget, et = we.listener;
          if (Le !== S && i.isPropagationStopped())
            return;
          wb(i, et, Ae), S = Le;
        }
    }
    function U6(i, l) {
      for (var g = (l & od) !== 0, S = 0; S < i.length; S++) {
        var _ = i[S], F = _.event, Y = _.listeners;
        F6(F, Y, g);
      }
      _m();
    }
    function g_(i, l, g, S, _) {
      var F = tf(g), Y = [];
      bb(Y, i, S, g, F, l), U6(Y, l);
    }
    function Mi(i, l) {
      Sb.has(i) || c('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', i);
      var g = !1, S = Y_(l), _ = Gw(i);
      S.has(_) || (Vw(l, i, Rp, g), S.add(_));
    }
    function F5(i, l, g) {
      Sb.has(i) && !l && c('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', i);
      var S = 0;
      l && (S |= od), Vw(g, i, S, l);
    }
    var Cb = "_reactListening" + Math.random().toString(36).slice(2);
    function $y(i) {
      if (!i[Cb]) {
        i[Cb] = !0, Xe.forEach(function(g) {
          g !== "selectionchange" && (Sb.has(g) || F5(g, !1, i), F5(g, !0, i));
        });
        var l = i.nodeType === ac ? i : i.ownerDocument;
        l !== null && (l[Cb] || (l[Cb] = !0, F5("selectionchange", !1, l)));
      }
    }
    function Vw(i, l, g, S, _) {
      var F = Ho(i, l, g), Y = void 0;
      jh && (l === "touchstart" || l === "touchmove" || l === "wheel") && (Y = !0), i = i, S ? Y !== void 0 ? zy(i, l, F, Y) : Zf(i, l, F) : Y !== void 0 ? Jf(i, l, F, Y) : Ih(i, l, F);
    }
    function Nb(i, l) {
      return i === l || i.nodeType === mi && i.parentNode === l;
    }
    function $m(i, l, g, S, _) {
      var F = S;
      if (!(l & id) && !(l & Rp)) {
        var Y = _;
        if (S !== null) {
          var ee = S;
          e: for (; ; ) {
            if (ee === null)
              return;
            var ie = ee.tag;
            if (ie === w || ie === k) {
              var xe = ee.stateNode.containerInfo;
              if (Nb(xe, Y))
                break;
              if (ie === k)
                for (var we = ee.return; we !== null; ) {
                  var Le = we.tag;
                  if (Le === w || Le === k) {
                    var Ae = we.stateNode.containerInfo;
                    if (Nb(Ae, Y))
                      return;
                  }
                  we = we.return;
                }
              for (; xe !== null; ) {
                var et = Gm(xe);
                if (et === null)
                  return;
                var nt = et.tag;
                if (nt === j || nt === E) {
                  ee = F = et;
                  continue e;
                }
                xe = xe.parentNode;
              }
            }
            ee = ee.return;
          }
        }
      }
      Dp(function() {
        return g_(i, l, g, F);
      });
    }
    function Gy(i, l, g) {
      return {
        instance: i,
        listener: l,
        currentTarget: g
      };
    }
    function Qp(i, l, g, S, _, F) {
      for (var Y = l !== null ? l + "Capture" : null, ee = S ? Y : l, ie = [], xe = i, we = null; xe !== null; ) {
        var Le = xe, Ae = Le.stateNode, et = Le.tag;
        if (et === j && Ae !== null && (we = Ae, ee !== null)) {
          var nt = Bf(xe, ee);
          nt != null && ie.push(Gy(xe, nt, we));
        }
        if (_)
          break;
        xe = xe.return;
      }
      return ie;
    }
    function Ex(i, l) {
      for (var g = l + "Capture", S = [], _ = i; _ !== null; ) {
        var F = _, Y = F.stateNode, ee = F.tag;
        if (ee === j && Y !== null) {
          var ie = Y, xe = Bf(_, g);
          xe != null && S.unshift(Gy(_, xe, ie));
          var we = Bf(_, l);
          we != null && S.push(Gy(_, we, ie));
        }
        _ = _.return;
      }
      return S;
    }
    function D0(i) {
      if (i === null)
        return null;
      do
        i = i.return;
      while (i && i.tag !== j);
      return i || null;
    }
    function Gh(i, l) {
      for (var g = i, S = l, _ = 0, F = g; F; F = D0(F))
        _++;
      for (var Y = 0, ee = S; ee; ee = D0(ee))
        Y++;
      for (; _ - Y > 0; )
        g = D0(g), _--;
      for (; Y - _ > 0; )
        S = D0(S), Y--;
      for (var ie = _; ie--; ) {
        if (g === S || S !== null && g === S.alternate)
          return g;
        g = D0(g), S = D0(S);
      }
      return null;
    }
    function U5(i, l, g, S, _) {
      for (var F = l._reactName, Y = [], ee = g; ee !== null && ee !== S; ) {
        var ie = ee, xe = ie.alternate, we = ie.stateNode, Le = ie.tag;
        if (xe !== null && xe === S)
          break;
        if (Le === j && we !== null) {
          var Ae = we;
          if (_) {
            var et = Bf(ee, F);
            et != null && Y.unshift(Gy(ee, et, Ae));
          } else if (!_) {
            var nt = Bf(ee, F);
            nt != null && Y.push(Gy(ee, nt, Ae));
          }
        }
        ee = ee.return;
      }
      Y.length !== 0 && i.push({
        event: l,
        listeners: Y
      });
    }
    function $w(i, l, g, S, _) {
      var F = S && _ ? Gh(S, _) : null;
      S !== null && U5(i, l, S, F, !1), _ !== null && g !== null && U5(i, g, _, F, !0);
    }
    function Gw(i, l) {
      return i + "__bubble";
    }
    var Hu = !1, Wy = "dangerouslySetInnerHTML", kx = "suppressContentEditableWarning", mg = "suppressHydrationWarning", jb = "autoFocus", hg = "children", pg = "style", _x = "__html", Yy, Eb, qy, z5, kb, z6, Ww;
    Yy = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, Eb = function(i, l) {
      oc(i, l), Nm(i, l), ku(i, l, {
        registrationNameDependencies: xt,
        possibleRegistrationNames: rn
      });
    }, z6 = He && !document.documentMode, qy = function(i, l, g) {
      if (!Hu) {
        var S = _b(g), _ = _b(l);
        _ !== S && (Hu = !0, c("Prop `%s` did not match. Server: %s Client: %s", i, JSON.stringify(_), JSON.stringify(S)));
      }
    }, z5 = function(i) {
      if (!Hu) {
        Hu = !0;
        var l = [];
        i.forEach(function(g) {
          l.push(g);
        }), c("Extra attributes from the server: %s", l);
      }
    }, kb = function(i, l) {
      l === !1 ? c("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", i, i, i) : c("Expected `%s` listener to be a function, instead got a value of `%s` type.", i, typeof l);
    }, Ww = function(i, l) {
      var g = i.namespaceURI === Nu ? i.ownerDocument.createElement(i.tagName) : i.ownerDocument.createElementNS(i.namespaceURI, i.tagName);
      return g.innerHTML = l, g.innerHTML;
    };
    var B6 = /\r\n?/g, y_ = /\u0000|\uFFFD/g;
    function _b(i) {
      ot(i);
      var l = typeof i == "string" ? i : "" + i;
      return l.replace(B6, `
`).replace(y_, "");
    }
    function Tx(i, l, g, S) {
      var _ = _b(l), F = _b(i);
      if (F !== _ && (S && (Hu || (Hu = !0, c('Text content did not match. Server: "%s" Client: "%s"', F, _))), g && Se))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function H6(i) {
      return i.nodeType === ac ? i : i.ownerDocument;
    }
    function v_() {
    }
    function Zp(i) {
      i.onclick = v_;
    }
    function Yw(i, l, g, S, _) {
      for (var F in S)
        if (S.hasOwnProperty(F)) {
          var Y = S[F];
          if (F === pg)
            Y && Object.freeze(Y), ad(l, Y);
          else if (F === Wy) {
            var ee = Y ? Y[_x] : void 0;
            ee != null && bh(l, ee);
          } else if (F === hg)
            if (typeof Y == "string") {
              var ie = i !== "textarea" || Y !== "";
              ie && Qd(l, Y);
            } else typeof Y == "number" && Qd(l, "" + Y);
          else F === kx || F === mg || F === jb || (xt.hasOwnProperty(F) ? Y != null && (typeof Y != "function" && kb(F, Y), F === "onScroll" && Mi("scroll", l)) : Y != null && dl(l, F, Y, _));
        }
    }
    function x_(i, l, g, S) {
      for (var _ = 0; _ < l.length; _ += 2) {
        var F = l[_], Y = l[_ + 1];
        F === pg ? ad(i, Y) : F === Wy ? bh(i, Y) : F === hg ? Qd(i, Y) : dl(i, F, Y, S);
      }
    }
    function qw(i, l, g, S) {
      var _, F = H6(g), Y, ee = S;
      if (ee === Nu && (ee = Of(i)), ee === Nu) {
        if (_ = Fo(i, l), !_ && i !== i.toLowerCase() && c("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", i), i === "script") {
          var ie = F.createElement("div");
          ie.innerHTML = "<script><\/script>";
          var xe = ie.firstChild;
          Y = ie.removeChild(xe);
        } else if (typeof l.is == "string")
          Y = F.createElement(i, {
            is: l.is
          });
        else if (Y = F.createElement(i), i === "select") {
          var we = Y;
          l.multiple ? we.multiple = !0 : l.size && (we.size = l.size);
        }
      } else
        Y = F.createElementNS(ee, i);
      return ee === Nu && !_ && Object.prototype.toString.call(Y) === "[object HTMLUnknownElement]" && !Pt.call(Yy, i) && (Yy[i] = !0, c("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", i)), Y;
    }
    function b_(i, l) {
      return H6(l).createTextNode(i);
    }
    function V6(i, l, g, S) {
      var _ = Fo(l, g);
      Eb(l, g);
      var F;
      switch (l) {
        case "dialog":
          Mi("cancel", i), Mi("close", i), F = g;
          break;
        case "iframe":
        case "object":
        case "embed":
          Mi("load", i), F = g;
          break;
        case "video":
        case "audio":
          for (var Y = 0; Y < R0.length; Y++)
            Mi(R0[Y], i);
          F = g;
          break;
        case "source":
          Mi("error", i), F = g;
          break;
        case "img":
        case "image":
        case "link":
          Mi("error", i), Mi("load", i), F = g;
          break;
        case "details":
          Mi("toggle", i), F = g;
          break;
        case "input":
          qd(i, g), F = td(i, g), Mi("invalid", i);
          break;
        case "option":
          _p(i, g), F = g;
          break;
        case "select":
          a0(i, g), F = F1(i, g), Mi("invalid", i);
          break;
        case "textarea":
          cx(i, g), F = U1(i, g), Mi("invalid", i);
          break;
        default:
          F = g;
      }
      switch (si(l, F), Yw(l, i, S, F, _), l) {
        case "input":
          xm(i), Ao(i, g, !1);
          break;
        case "textarea":
          xm(i), ux(i);
          break;
        case "option":
          Sm(i, g);
          break;
        case "select":
          ox(i, g);
          break;
        default:
          typeof F.onClick == "function" && Zp(i);
          break;
      }
    }
    function Kw(i, l, g, S, _) {
      Eb(l, S);
      var F = null, Y, ee;
      switch (l) {
        case "input":
          Y = td(i, g), ee = td(i, S), F = [];
          break;
        case "select":
          Y = F1(i, g), ee = F1(i, S), F = [];
          break;
        case "textarea":
          Y = U1(i, g), ee = U1(i, S), F = [];
          break;
        default:
          Y = g, ee = S, typeof Y.onClick != "function" && typeof ee.onClick == "function" && Zp(i);
          break;
      }
      si(l, ee);
      var ie, xe, we = null;
      for (ie in Y)
        if (!(ee.hasOwnProperty(ie) || !Y.hasOwnProperty(ie) || Y[ie] == null))
          if (ie === pg) {
            var Le = Y[ie];
            for (xe in Le)
              Le.hasOwnProperty(xe) && (we || (we = {}), we[xe] = "");
          } else ie === Wy || ie === hg || ie === kx || ie === mg || ie === jb || (xt.hasOwnProperty(ie) ? F || (F = []) : (F = F || []).push(ie, null));
      for (ie in ee) {
        var Ae = ee[ie], et = Y != null ? Y[ie] : void 0;
        if (!(!ee.hasOwnProperty(ie) || Ae === et || Ae == null && et == null))
          if (ie === pg)
            if (Ae && Object.freeze(Ae), et) {
              for (xe in et)
                et.hasOwnProperty(xe) && (!Ae || !Ae.hasOwnProperty(xe)) && (we || (we = {}), we[xe] = "");
              for (xe in Ae)
                Ae.hasOwnProperty(xe) && et[xe] !== Ae[xe] && (we || (we = {}), we[xe] = Ae[xe]);
            } else
              we || (F || (F = []), F.push(ie, we)), we = Ae;
          else if (ie === Wy) {
            var nt = Ae ? Ae[_x] : void 0, dt = et ? et[_x] : void 0;
            nt != null && dt !== nt && (F = F || []).push(ie, nt);
          } else ie === hg ? (typeof Ae == "string" || typeof Ae == "number") && (F = F || []).push(ie, "" + Ae) : ie === kx || ie === mg || (xt.hasOwnProperty(ie) ? (Ae != null && (typeof Ae != "function" && kb(ie, Ae), ie === "onScroll" && Mi("scroll", i)), !F && et !== Ae && (F = [])) : (F = F || []).push(ie, Ae));
      }
      return we && (If(we, ee[pg]), (F = F || []).push(pg, we)), F;
    }
    function $6(i, l, g, S, _) {
      g === "input" && _.type === "radio" && _.name != null && bm(i, _);
      var F = Fo(g, S), Y = Fo(g, _);
      switch (x_(i, l, F, Y), g) {
        case "input":
          Kd(i, _);
          break;
        case "textarea":
          z1(i, _);
          break;
        case "select":
          s0(i, _);
          break;
      }
    }
    function S_(i) {
      {
        var l = i.toLowerCase();
        return Ff.hasOwnProperty(l) && Ff[l] || null;
      }
    }
    function w_(i, l, g, S, _, F, Y) {
      var ee, ie;
      switch (ee = Fo(l, g), Eb(l, g), l) {
        case "dialog":
          Mi("cancel", i), Mi("close", i);
          break;
        case "iframe":
        case "object":
        case "embed":
          Mi("load", i);
          break;
        case "video":
        case "audio":
          for (var xe = 0; xe < R0.length; xe++)
            Mi(R0[xe], i);
          break;
        case "source":
          Mi("error", i);
          break;
        case "img":
        case "image":
        case "link":
          Mi("error", i), Mi("load", i);
          break;
        case "details":
          Mi("toggle", i);
          break;
        case "input":
          qd(i, g), Mi("invalid", i);
          break;
        case "option":
          _p(i, g);
          break;
        case "select":
          a0(i, g), Mi("invalid", i);
          break;
        case "textarea":
          cx(i, g), Mi("invalid", i);
          break;
      }
      si(l, g);
      {
        ie = /* @__PURE__ */ new Set();
        for (var we = i.attributes, Le = 0; Le < we.length; Le++) {
          var Ae = we[Le].name.toLowerCase();
          switch (Ae) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              ie.add(we[Le].name);
          }
        }
      }
      var et = null;
      for (var nt in g)
        if (g.hasOwnProperty(nt)) {
          var dt = g[nt];
          if (nt === hg)
            typeof dt == "string" ? i.textContent !== dt && (g[mg] !== !0 && Tx(i.textContent, dt, F, Y), et = [hg, dt]) : typeof dt == "number" && i.textContent !== "" + dt && (g[mg] !== !0 && Tx(i.textContent, dt, F, Y), et = [hg, "" + dt]);
          else if (xt.hasOwnProperty(nt))
            dt != null && (typeof dt != "function" && kb(nt, dt), nt === "onScroll" && Mi("scroll", i));
          else if (Y && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof ee == "boolean") {
            var xn = void 0, fr = ee && Ie ? null : wn(nt);
            if (g[mg] !== !0) {
              if (!(nt === kx || nt === mg || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              nt === "value" || nt === "checked" || nt === "selected")) {
                if (nt === Wy) {
                  var qn = i.innerHTML, Ua = dt ? dt[_x] : void 0;
                  if (Ua != null) {
                    var ba = Ww(i, Ua);
                    ba !== qn && qy(nt, qn, ba);
                  }
                } else if (nt === pg) {
                  if (ie.delete(nt), z6) {
                    var We = Eu(dt);
                    xn = i.getAttribute("style"), We !== xn && qy(nt, xn, We);
                  }
                } else if (ee && !Ie)
                  ie.delete(nt.toLowerCase()), xn = ul(i, nt, dt), dt !== xn && qy(nt, xn, dt);
                else if (!lt(nt, fr, ee) && !Wt(nt, dt, fr, ee)) {
                  var ft = !1;
                  if (fr !== null)
                    ie.delete(fr.attributeName), xn = Mo(i, nt, dt, fr);
                  else {
                    var Ye = S;
                    if (Ye === Nu && (Ye = Of(l)), Ye === Nu)
                      ie.delete(nt.toLowerCase());
                    else {
                      var Ut = S_(nt);
                      Ut !== null && Ut !== nt && (ft = !0, ie.delete(Ut)), ie.delete(nt);
                    }
                    xn = ul(i, nt, dt);
                  }
                  var Tn = Ie;
                  !Tn && dt !== xn && !ft && qy(nt, xn, dt);
                }
              }
            }
          }
        }
      switch (Y && // $FlowFixMe - Should be inferred as not undefined.
      ie.size > 0 && g[mg] !== !0 && z5(ie), l) {
        case "input":
          xm(i), Ao(i, g, !0);
          break;
        case "textarea":
          xm(i), ux(i);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof g.onClick == "function" && Zp(i);
          break;
      }
      return et;
    }
    function G6(i, l, g) {
      var S = i.nodeValue !== l;
      return S;
    }
    function B5(i, l) {
      {
        if (Hu)
          return;
        Hu = !0, c("Did not expect server HTML to contain a <%s> in <%s>.", l.nodeName.toLowerCase(), i.nodeName.toLowerCase());
      }
    }
    function Xw(i, l) {
      {
        if (Hu)
          return;
        Hu = !0, c('Did not expect server HTML to contain the text node "%s" in <%s>.', l.nodeValue, i.nodeName.toLowerCase());
      }
    }
    function Qw(i, l, g) {
      {
        if (Hu)
          return;
        Hu = !0, c("Expected server HTML to contain a matching <%s> in <%s>.", l, i.nodeName.toLowerCase());
      }
    }
    function Ky(i, l) {
      {
        if (l === "" || Hu)
          return;
        Hu = !0, c('Expected server HTML to contain a matching text node for "%s" in <%s>.', l, i.nodeName.toLowerCase());
      }
    }
    function Wh(i, l, g) {
      switch (l) {
        case "input":
          Ac(i, g);
          return;
        case "textarea":
          vh(i, g);
          return;
        case "select":
          lx(i, g);
          return;
      }
    }
    var Xy = function() {
    }, gg = function() {
    };
    {
      var Zw = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], H5 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], Jw = H5.concat(["button"]), Qy = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], V5 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      gg = function(i, l) {
        var g = ir({}, i || V5), S = {
          tag: l
        };
        return H5.indexOf(l) !== -1 && (g.aTagInScope = null, g.buttonTagInScope = null, g.nobrTagInScope = null), Jw.indexOf(l) !== -1 && (g.pTagInButtonScope = null), Zw.indexOf(l) !== -1 && l !== "address" && l !== "div" && l !== "p" && (g.listItemTagAutoclosing = null, g.dlItemTagAutoclosing = null), g.current = S, l === "form" && (g.formTag = S), l === "a" && (g.aTagInScope = S), l === "button" && (g.buttonTagInScope = S), l === "nobr" && (g.nobrTagInScope = S), l === "p" && (g.pTagInButtonScope = S), l === "li" && (g.listItemTagAutoclosing = S), (l === "dd" || l === "dt") && (g.dlItemTagAutoclosing = S), g;
      };
      var $5 = function(i, l) {
        switch (l) {
          case "select":
            return i === "option" || i === "optgroup" || i === "#text";
          case "optgroup":
            return i === "option" || i === "#text";
          case "option":
            return i === "#text";
          case "tr":
            return i === "th" || i === "td" || i === "style" || i === "script" || i === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return i === "tr" || i === "style" || i === "script" || i === "template";
          case "colgroup":
            return i === "col" || i === "template";
          case "table":
            return i === "caption" || i === "colgroup" || i === "tbody" || i === "tfoot" || i === "thead" || i === "style" || i === "script" || i === "template";
          case "head":
            return i === "base" || i === "basefont" || i === "bgsound" || i === "link" || i === "meta" || i === "title" || i === "noscript" || i === "noframes" || i === "style" || i === "script" || i === "template";
          case "html":
            return i === "head" || i === "body" || i === "frameset";
          case "frameset":
            return i === "frame";
          case "#document":
            return i === "html";
        }
        switch (i) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return l !== "h1" && l !== "h2" && l !== "h3" && l !== "h4" && l !== "h5" && l !== "h6";
          case "rp":
          case "rt":
            return Qy.indexOf(l) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return l == null;
        }
        return !0;
      }, Tb = function(i, l) {
        switch (i) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return l.pTagInButtonScope;
          case "form":
            return l.formTag || l.pTagInButtonScope;
          case "li":
            return l.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return l.dlItemTagAutoclosing;
          case "button":
            return l.buttonTagInScope;
          case "a":
            return l.aTagInScope;
          case "nobr":
            return l.nobrTagInScope;
        }
        return null;
      }, Vu = {};
      Xy = function(i, l, g) {
        g = g || V5;
        var S = g.current, _ = S && S.tag;
        l != null && (i != null && c("validateDOMNesting: when childText is passed, childTag should be null"), i = "#text");
        var F = $5(i, _) ? null : S, Y = F ? null : Tb(i, g), ee = F || Y;
        if (ee) {
          var ie = ee.tag, xe = !!F + "|" + i + "|" + ie;
          if (!Vu[xe]) {
            Vu[xe] = !0;
            var we = i, Le = "";
            if (i === "#text" ? /\S/.test(l) ? we = "Text nodes" : (we = "Whitespace text nodes", Le = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : we = "<" + i + ">", F) {
              var Ae = "";
              ie === "table" && i === "tr" && (Ae += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), c("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", we, ie, Le, Ae);
            } else
              c("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", we, ie);
          }
        }
      };
    }
    var G5 = "suppressHydrationWarning", Mb = "$", Rb = "/$", Mx = "$?", Rx = "$!", C_ = "style", eC = null, tC = null;
    function W6(i) {
      var l, g, S = i.nodeType;
      switch (S) {
        case ac:
        case Xd: {
          l = S === ac ? "#document" : "#fragment";
          var _ = i.documentElement;
          g = _ ? _.namespaceURI : o0(null, "");
          break;
        }
        default: {
          var F = S === mi ? i.parentNode : i, Y = F.namespaceURI || null;
          l = F.tagName, g = o0(Y, l);
          break;
        }
      }
      {
        var ee = l.toLowerCase(), ie = gg(null, ee);
        return {
          namespace: g,
          ancestorInfo: ie
        };
      }
    }
    function nC(i, l, g) {
      {
        var S = i, _ = o0(S.namespace, l), F = gg(S.ancestorInfo, l);
        return {
          namespace: _,
          ancestorInfo: F
        };
      }
    }
    function N_(i) {
      return i;
    }
    function rC(i) {
      eC = wo(), tC = R6();
      var l = null;
      return Fu(!1), l;
    }
    function Y6(i) {
      h_(tC), Fu(eC), eC = null, tC = null;
    }
    function j_(i, l, g, S, _) {
      var F;
      {
        var Y = S;
        if (Xy(i, null, Y.ancestorInfo), typeof l.children == "string" || typeof l.children == "number") {
          var ee = "" + l.children, ie = gg(Y.ancestorInfo, i);
          Xy(null, ee, ie);
        }
        F = Y.namespace;
      }
      var xe = qw(i, l, g, F);
      return qo(_, xe), Fb(xe, l), xe;
    }
    function q6(i, l) {
      i.appendChild(l);
    }
    function E_(i, l, g, S, _) {
      switch (V6(i, l, g, S), l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!g.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function k_(i, l, g, S, _, F) {
      {
        var Y = F;
        if (typeof S.children != typeof g.children && (typeof S.children == "string" || typeof S.children == "number")) {
          var ee = "" + S.children, ie = gg(Y.ancestorInfo, l);
          Xy(null, ee, ie);
        }
      }
      return Kw(i, l, g, S);
    }
    function aC(i, l) {
      return i === "textarea" || i === "noscript" || typeof l.children == "string" || typeof l.children == "number" || typeof l.dangerouslySetInnerHTML == "object" && l.dangerouslySetInnerHTML !== null && l.dangerouslySetInnerHTML.__html != null;
    }
    function __(i, l, g, S) {
      {
        var _ = g;
        Xy(null, i, _.ancestorInfo);
      }
      var F = b_(i, l);
      return qo(S, F), F;
    }
    function T_() {
      var i = window.event;
      return i === void 0 ? Sc : S0(i.type);
    }
    var Db = typeof setTimeout == "function" ? setTimeout : void 0, sC = typeof clearTimeout == "function" ? clearTimeout : void 0, Pb = -1, K6 = typeof Promise == "function" ? Promise : void 0, M_ = typeof queueMicrotask == "function" ? queueMicrotask : typeof K6 < "u" ? function(i) {
      return K6.resolve(null).then(i).catch(R_);
    } : Db;
    function R_(i) {
      setTimeout(function() {
        throw i;
      });
    }
    function X6(i, l, g, S) {
      switch (l) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          g.autoFocus && i.focus();
          return;
        case "img": {
          g.src && (i.src = g.src);
          return;
        }
      }
    }
    function iC(i, l, g, S, _, F) {
      $6(i, l, g, S, _), Fb(i, _);
    }
    function Q6(i) {
      Qd(i, "");
    }
    function oC(i, l, g) {
      i.nodeValue = g;
    }
    function Z6(i, l) {
      i.appendChild(l);
    }
    function D_(i, l) {
      var g;
      i.nodeType === mi ? (g = i.parentNode, g.insertBefore(l, i)) : (g = i, g.appendChild(l));
      var S = i._reactRootContainer;
      S == null && g.onclick === null && Zp(g);
    }
    function P_(i, l, g) {
      i.insertBefore(l, g);
    }
    function W5(i, l, g) {
      i.nodeType === mi ? i.parentNode.insertBefore(l, g) : i.insertBefore(l, g);
    }
    function O_(i, l) {
      i.removeChild(l);
    }
    function A_(i, l) {
      i.nodeType === mi ? i.parentNode.removeChild(l) : i.removeChild(l);
    }
    function lC(i, l) {
      var g = l, S = 0;
      do {
        var _ = g.nextSibling;
        if (i.removeChild(g), _ && _.nodeType === mi) {
          var F = _.data;
          if (F === Rb)
            if (S === 0) {
              i.removeChild(_), zi(l);
              return;
            } else
              S--;
          else (F === Mb || F === Mx || F === Rx) && S++;
        }
        g = _;
      } while (g);
      zi(l);
    }
    function J6(i, l) {
      i.nodeType === mi ? lC(i.parentNode, l) : i.nodeType === pl && lC(i, l), zi(i);
    }
    function L_(i) {
      i = i;
      var l = i.style;
      typeof l.setProperty == "function" ? l.setProperty("display", "none", "important") : l.display = "none";
    }
    function I_(i) {
      i.nodeValue = "";
    }
    function F_(i, l) {
      i = i;
      var g = l[C_], S = g != null && g.hasOwnProperty("display") ? g.display : null;
      i.style.display = Fc("display", S);
    }
    function U_(i, l) {
      i.nodeValue = l;
    }
    function eN(i) {
      i.nodeType === pl ? i.textContent = "" : i.nodeType === ac && i.documentElement && i.removeChild(i.documentElement);
    }
    function z_(i, l, g) {
      return i.nodeType !== pl || l.toLowerCase() !== i.nodeName.toLowerCase() ? null : i;
    }
    function cC(i, l) {
      return l === "" || i.nodeType !== zl ? null : i;
    }
    function tN(i) {
      return i.nodeType !== mi ? null : i;
    }
    function nN(i) {
      return i.data === Mx;
    }
    function Y5(i) {
      return i.data === Rx;
    }
    function B_(i) {
      var l = i.nextSibling && i.nextSibling.dataset, g, S, _;
      return l && (g = l.dgst, S = l.msg, _ = l.stck), {
        message: S,
        digest: g,
        stack: _
      };
    }
    function rN(i, l) {
      i._reactRetry = l;
    }
    function q5(i) {
      for (; i != null; i = i.nextSibling) {
        var l = i.nodeType;
        if (l === pl || l === zl)
          break;
        if (l === mi) {
          var g = i.data;
          if (g === Mb || g === Rx || g === Mx)
            break;
          if (g === Rb)
            return null;
        }
      }
      return i;
    }
    function yg(i) {
      return q5(i.nextSibling);
    }
    function K5(i) {
      return q5(i.firstChild);
    }
    function vg(i) {
      return q5(i.firstChild);
    }
    function H_(i) {
      return q5(i.nextSibling);
    }
    function uC(i, l, g, S, _, F, Y) {
      qo(F, i), Fb(i, g);
      var ee;
      {
        var ie = _;
        ee = ie.namespace;
      }
      var xe = (F.mode & Mn) !== Sn;
      return w_(i, l, g, ee, S, xe, Y);
    }
    function V_(i, l, g, S) {
      return qo(g, i), g.mode & Mn, G6(i, l);
    }
    function aN(i, l) {
      qo(l, i);
    }
    function Jp(i) {
      for (var l = i.nextSibling, g = 0; l; ) {
        if (l.nodeType === mi) {
          var S = l.data;
          if (S === Rb) {
            if (g === 0)
              return yg(l);
            g--;
          } else (S === Mb || S === Rx || S === Mx) && g++;
        }
        l = l.nextSibling;
      }
      return null;
    }
    function dC(i) {
      for (var l = i.previousSibling, g = 0; l; ) {
        if (l.nodeType === mi) {
          var S = l.data;
          if (S === Mb || S === Rx || S === Mx) {
            if (g === 0)
              return l;
            g--;
          } else S === Rb && g++;
        }
        l = l.previousSibling;
      }
      return null;
    }
    function sN(i) {
      zi(i);
    }
    function Ob(i) {
      zi(i);
    }
    function Ab(i) {
      return i !== "head" && i !== "body";
    }
    function X5(i, l, g, S) {
      var _ = !0;
      Tx(l.nodeValue, g, S, _);
    }
    function Q5(i, l, g, S, _, F) {
      if (l[G5] !== !0) {
        var Y = !0;
        Tx(S.nodeValue, _, F, Y);
      }
    }
    function iN(i, l) {
      l.nodeType === pl ? B5(i, l) : l.nodeType === mi || Xw(i, l);
    }
    function Lb(i, l) {
      {
        var g = i.parentNode;
        g !== null && (l.nodeType === pl ? B5(g, l) : l.nodeType === mi || Xw(g, l));
      }
    }
    function eu(i, l, g, S, _) {
      (_ || l[G5] !== !0) && (S.nodeType === pl ? B5(g, S) : S.nodeType === mi || Xw(g, S));
    }
    function $_(i, l, g) {
      Qw(i, l);
    }
    function oN(i, l) {
      Ky(i, l);
    }
    function G_(i, l, g) {
      {
        var S = i.parentNode;
        S !== null && Qw(S, l);
      }
    }
    function lN(i, l) {
      {
        var g = i.parentNode;
        g !== null && Ky(g, l);
      }
    }
    function cN(i, l, g, S, _, F) {
      (F || l[G5] !== !0) && Qw(g, S);
    }
    function uN(i, l, g, S, _) {
      (_ || l[G5] !== !0) && Ky(g, S);
    }
    function fC(i) {
      c("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", i.nodeName.toLowerCase());
    }
    function W_(i) {
      $y(i);
    }
    var e1 = Math.random().toString(36).slice(2), xg = "__reactFiber$" + e1, mC = "__reactProps$" + e1, Dx = "__reactContainer$" + e1, hC = "__reactEvents$" + e1, dN = "__reactListeners$" + e1, fN = "__reactHandles$" + e1;
    function Z5(i) {
      delete i[xg], delete i[mC], delete i[hC], delete i[dN], delete i[fN];
    }
    function qo(i, l) {
      l[xg] = i;
    }
    function J5(i, l) {
      l[Dx] = i;
    }
    function Dn(i) {
      i[Dx] = null;
    }
    function t1(i) {
      return !!i[Dx];
    }
    function Gm(i) {
      var l = i[xg];
      if (l)
        return l;
      for (var g = i.parentNode; g; ) {
        if (l = g[Dx] || g[xg], l) {
          var S = l.alternate;
          if (l.child !== null || S !== null && S.child !== null)
            for (var _ = dC(i); _ !== null; ) {
              var F = _[xg];
              if (F)
                return F;
              _ = dC(_);
            }
          return l;
        }
        i = g, g = i.parentNode;
      }
      return null;
    }
    function P0(i) {
      var l = i[xg] || i[Dx];
      return l && (l.tag === j || l.tag === E || l.tag === z || l.tag === w) ? l : null;
    }
    function Px(i) {
      if (i.tag === j || i.tag === E)
        return i.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function Ib(i) {
      return i[mC] || null;
    }
    function Fb(i, l) {
      i[mC] = l;
    }
    function Y_(i) {
      var l = i[hC];
      return l === void 0 && (l = i[hC] = /* @__PURE__ */ new Set()), l;
    }
    var pC = {}, Zy = n.ReactDebugCurrentFrame;
    function Jy(i) {
      if (i) {
        var l = i._owner, g = O1(i.type, i._source, l ? l.type : null);
        Zy.setExtraStackFrame(g);
      } else
        Zy.setExtraStackFrame(null);
    }
    function Wm(i, l, g, S, _) {
      {
        var F = Function.call.bind(Pt);
        for (var Y in i)
          if (F(i, Y)) {
            var ee = void 0;
            try {
              if (typeof i[Y] != "function") {
                var ie = Error((S || "React class") + ": " + g + " type `" + Y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[Y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ie.name = "Invariant Violation", ie;
              }
              ee = i[Y](l, Y, S, g, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (xe) {
              ee = xe;
            }
            ee && !(ee instanceof Error) && (Jy(_), c("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", S || "React class", g, Y, typeof ee), Jy(null)), ee instanceof Error && !(ee.message in pC) && (pC[ee.message] = !0, Jy(_), c("Failed %s type: %s", g, ee.message), Jy(null));
          }
      }
    }
    var gC = [], eS;
    eS = [];
    var bg = -1;
    function O0(i) {
      return {
        current: i
      };
    }
    function xi(i, l) {
      if (bg < 0) {
        c("Unexpected pop.");
        return;
      }
      l !== eS[bg] && c("Unexpected Fiber popped."), i.current = gC[bg], gC[bg] = null, eS[bg] = null, bg--;
    }
    function io(i, l, g) {
      bg++, gC[bg] = i.current, eS[bg] = g, i.current = l;
    }
    var yC;
    yC = {};
    var tm = {};
    Object.freeze(tm);
    var Sg = O0(tm), n1 = O0(!1), tS = tm;
    function Ox(i, l, g) {
      return g && Yh(l) ? tS : Sg.current;
    }
    function vC(i, l, g) {
      {
        var S = i.stateNode;
        S.__reactInternalMemoizedUnmaskedChildContext = l, S.__reactInternalMemoizedMaskedChildContext = g;
      }
    }
    function Ax(i, l) {
      {
        var g = i.type, S = g.contextTypes;
        if (!S)
          return tm;
        var _ = i.stateNode;
        if (_ && _.__reactInternalMemoizedUnmaskedChildContext === l)
          return _.__reactInternalMemoizedMaskedChildContext;
        var F = {};
        for (var Y in S)
          F[Y] = l[Y];
        {
          var ee = Nr(i) || "Unknown";
          Wm(S, F, "context", ee);
        }
        return _ && vC(i, l, F), F;
      }
    }
    function nS() {
      return n1.current;
    }
    function Yh(i) {
      {
        var l = i.childContextTypes;
        return l != null;
      }
    }
    function Ub(i) {
      xi(n1, i), xi(Sg, i);
    }
    function xC(i) {
      xi(n1, i), xi(Sg, i);
    }
    function rS(i, l, g) {
      {
        if (Sg.current !== tm)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        io(Sg, l, i), io(n1, g, i);
      }
    }
    function aS(i, l, g) {
      {
        var S = i.stateNode, _ = l.childContextTypes;
        if (typeof S.getChildContext != "function") {
          {
            var F = Nr(i) || "Unknown";
            yC[F] || (yC[F] = !0, c("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", F, F));
          }
          return g;
        }
        var Y = S.getChildContext();
        for (var ee in Y)
          if (!(ee in _))
            throw new Error((Nr(i) || "Unknown") + '.getChildContext(): key "' + ee + '" is not defined in childContextTypes.');
        {
          var ie = Nr(i) || "Unknown";
          Wm(_, Y, "child context", ie);
        }
        return ir({}, g, Y);
      }
    }
    function Nl(i) {
      {
        var l = i.stateNode, g = l && l.__reactInternalMemoizedMergedChildContext || tm;
        return tS = Sg.current, io(Sg, g, i), io(n1, n1.current, i), !0;
      }
    }
    function Ym(i, l, g) {
      {
        var S = i.stateNode;
        if (!S)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (g) {
          var _ = aS(i, l, tS);
          S.__reactInternalMemoizedMergedChildContext = _, xi(n1, i), xi(Sg, i), io(Sg, _, i), io(n1, g, i);
        } else
          xi(n1, i), io(n1, g, i);
      }
    }
    function q_(i) {
      {
        if (!vo(i) || i.tag !== y)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var l = i;
        do {
          switch (l.tag) {
            case w:
              return l.stateNode.context;
            case y: {
              var g = l.type;
              if (Yh(g))
                return l.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          l = l.return;
        } while (l !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var tu = 0, Lx = 1, wg = null, bC = !1, sS = !1;
    function mN(i) {
      wg === null ? wg = [i] : wg.push(i);
    }
    function qh(i) {
      bC = !0, mN(i);
    }
    function SC() {
      bC && nu();
    }
    function nu() {
      if (!sS && wg !== null) {
        sS = !0;
        var i = 0, l = xd();
        try {
          var g = !0, S = wg;
          for (ki(Ea); i < S.length; i++) {
            var _ = S[i];
            do
              _ = _(g);
            while (_ !== null);
          }
          wg = null, bC = !1;
        } catch (F) {
          throw wg !== null && (wg = wg.slice(i + 1)), fd(Th, nu), F;
        } finally {
          ki(l), sS = !1;
        }
      }
      return null;
    }
    var Ix = [], ev = 0, Fx = null, iS = 0, nm = [], qm = 0, A0 = null, Cg = 1, Ng = "";
    function K_(i) {
      return nv(), (i.flags & Pu) !== mn;
    }
    function X_(i) {
      return nv(), iS;
    }
    function Q_() {
      var i = Ng, l = Cg, g = l & ~Z_(l);
      return g.toString(32) + i;
    }
    function tv(i, l) {
      nv(), Ix[ev++] = iS, Ix[ev++] = Fx, Fx = i, iS = l;
    }
    function hN(i, l, g) {
      nv(), nm[qm++] = Cg, nm[qm++] = Ng, nm[qm++] = A0, A0 = i;
      var S = Cg, _ = Ng, F = oS(S) - 1, Y = S & ~(1 << F), ee = g + 1, ie = oS(l) + F;
      if (ie > 30) {
        var xe = F - F % 5, we = (1 << xe) - 1, Le = (Y & we).toString(32), Ae = Y >> xe, et = F - xe, nt = oS(l) + et, dt = ee << et, xn = dt | Ae, fr = Le + _;
        Cg = 1 << nt | xn, Ng = fr;
      } else {
        var qn = ee << F, Ua = qn | Y, ba = _;
        Cg = 1 << ie | Ua, Ng = ba;
      }
    }
    function wC(i) {
      nv();
      var l = i.return;
      if (l !== null) {
        var g = 1, S = 0;
        tv(i, g), hN(i, g, S);
      }
    }
    function oS(i) {
      return 32 - hd(i);
    }
    function Z_(i) {
      return 1 << oS(i) - 1;
    }
    function CC(i) {
      for (; i === Fx; )
        Fx = Ix[--ev], Ix[ev] = null, iS = Ix[--ev], Ix[ev] = null;
      for (; i === A0; )
        A0 = nm[--qm], nm[qm] = null, Ng = nm[--qm], nm[qm] = null, Cg = nm[--qm], nm[qm] = null;
    }
    function J_() {
      return nv(), A0 !== null ? {
        id: Cg,
        overflow: Ng
      } : null;
    }
    function eT(i, l) {
      nv(), nm[qm++] = Cg, nm[qm++] = Ng, nm[qm++] = A0, Cg = l.id, Ng = l.overflow, A0 = i;
    }
    function nv() {
      Wl() || c("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var ru = null, jd = null, mf = !1, r1 = !1, Kh = null;
    function lS() {
      mf && c("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function Ux() {
      r1 = !0;
    }
    function tT() {
      return r1;
    }
    function nT(i) {
      var l = i.stateNode.containerInfo;
      return jd = vg(l), ru = i, mf = !0, Kh = null, r1 = !1, !0;
    }
    function rT(i, l, g) {
      return jd = H_(l), ru = i, mf = !0, Kh = null, r1 = !1, g !== null && eT(i, g), !0;
    }
    function pN(i, l) {
      switch (i.tag) {
        case w: {
          iN(i.stateNode.containerInfo, l);
          break;
        }
        case j: {
          var g = (i.mode & Mn) !== Sn;
          eu(
            i.type,
            i.memoizedProps,
            i.stateNode,
            l,
            // TODO: Delete this argument when we remove the legacy root API.
            g
          );
          break;
        }
        case z: {
          var S = i.memoizedState;
          S.dehydrated !== null && Lb(S.dehydrated, l);
          break;
        }
      }
    }
    function gN(i, l) {
      pN(i, l);
      var g = BQ();
      g.stateNode = l, g.return = i;
      var S = i.deletions;
      S === null ? (i.deletions = [g], i.flags |= Na) : S.push(g);
    }
    function zb(i, l) {
      {
        if (r1)
          return;
        switch (i.tag) {
          case w: {
            var g = i.stateNode.containerInfo;
            switch (l.tag) {
              case j:
                var S = l.type;
                l.pendingProps, $_(g, S);
                break;
              case E:
                var _ = l.pendingProps;
                oN(g, _);
                break;
            }
            break;
          }
          case j: {
            var F = i.type, Y = i.memoizedProps, ee = i.stateNode;
            switch (l.tag) {
              case j: {
                var ie = l.type, xe = l.pendingProps, we = (i.mode & Mn) !== Sn;
                cN(
                  F,
                  Y,
                  ee,
                  ie,
                  xe,
                  // TODO: Delete this argument when we remove the legacy root API.
                  we
                );
                break;
              }
              case E: {
                var Le = l.pendingProps, Ae = (i.mode & Mn) !== Sn;
                uN(
                  F,
                  Y,
                  ee,
                  Le,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Ae
                );
                break;
              }
            }
            break;
          }
          case z: {
            var et = i.memoizedState, nt = et.dehydrated;
            if (nt !== null) switch (l.tag) {
              case j:
                var dt = l.type;
                l.pendingProps, G_(nt, dt);
                break;
              case E:
                var xn = l.pendingProps;
                lN(nt, xn);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function cS(i, l) {
      l.flags = l.flags & ~cc | ts, zb(i, l);
    }
    function uS(i, l) {
      switch (i.tag) {
        case j: {
          var g = i.type;
          i.pendingProps;
          var S = z_(l, g);
          return S !== null ? (i.stateNode = S, ru = i, jd = K5(S), !0) : !1;
        }
        case E: {
          var _ = i.pendingProps, F = cC(l, _);
          return F !== null ? (i.stateNode = F, ru = i, jd = null, !0) : !1;
        }
        case z: {
          var Y = tN(l);
          if (Y !== null) {
            var ee = {
              dehydrated: Y,
              treeContext: J_(),
              retryLane: So
            };
            i.memoizedState = ee;
            var ie = HQ(Y);
            return ie.return = i, i.child = ie, ru = i, jd = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function dS(i) {
      return (i.mode & Mn) !== Sn && (i.flags & or) === mn;
    }
    function NC(i) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function zx(i) {
      if (mf) {
        var l = jd;
        if (!l) {
          dS(i) && (zb(ru, i), NC()), cS(ru, i), mf = !1, ru = i;
          return;
        }
        var g = l;
        if (!uS(i, l)) {
          dS(i) && (zb(ru, i), NC()), l = yg(g);
          var S = ru;
          if (!l || !uS(i, l)) {
            cS(ru, i), mf = !1, ru = i;
            return;
          }
          gN(S, g);
        }
      }
    }
    function aT(i, l, g) {
      var S = i.stateNode, _ = !r1, F = uC(S, i.type, i.memoizedProps, l, g, i, _);
      return i.updateQueue = F, F !== null;
    }
    function sT(i) {
      var l = i.stateNode, g = i.memoizedProps, S = V_(l, g, i);
      if (S) {
        var _ = ru;
        if (_ !== null)
          switch (_.tag) {
            case w: {
              var F = _.stateNode.containerInfo, Y = (_.mode & Mn) !== Sn;
              X5(
                F,
                l,
                g,
                // TODO: Delete this argument when we remove the legacy root API.
                Y
              );
              break;
            }
            case j: {
              var ee = _.type, ie = _.memoizedProps, xe = _.stateNode, we = (_.mode & Mn) !== Sn;
              Q5(
                ee,
                ie,
                xe,
                l,
                g,
                // TODO: Delete this argument when we remove the legacy root API.
                we
              );
              break;
            }
          }
      }
      return S;
    }
    function iT(i) {
      var l = i.memoizedState, g = l !== null ? l.dehydrated : null;
      if (!g)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      aN(g, i);
    }
    function fS(i) {
      var l = i.memoizedState, g = l !== null ? l.dehydrated : null;
      if (!g)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return Jp(g);
    }
    function yN(i) {
      for (var l = i.return; l !== null && l.tag !== j && l.tag !== w && l.tag !== z; )
        l = l.return;
      ru = l;
    }
    function mS(i) {
      if (i !== ru)
        return !1;
      if (!mf)
        return yN(i), mf = !0, !1;
      if (i.tag !== w && (i.tag !== j || Ab(i.type) && !aC(i.type, i.memoizedProps))) {
        var l = jd;
        if (l)
          if (dS(i))
            vN(i), NC();
          else
            for (; l; )
              gN(i, l), l = yg(l);
      }
      return yN(i), i.tag === z ? jd = fS(i) : jd = ru ? yg(i.stateNode) : null, !0;
    }
    function oT() {
      return mf && jd !== null;
    }
    function vN(i) {
      for (var l = jd; l; )
        pN(i, l), l = yg(l);
    }
    function rv() {
      ru = null, jd = null, mf = !1, r1 = !1;
    }
    function xN() {
      Kh !== null && ($L(Kh), Kh = null);
    }
    function Wl() {
      return mf;
    }
    function Bb(i) {
      Kh === null ? Kh = [i] : Kh.push(i);
    }
    var oo = n.ReactCurrentBatchConfig, Xh = null;
    function jl() {
      return oo.transition;
    }
    var rm = {
      recordUnsafeLifecycleWarnings: function(i, l) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(i, l) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var au = function(i) {
        for (var l = null, g = i; g !== null; )
          g.mode & $r && (l = g), g = g.return;
        return l;
      }, Cc = function(i) {
        var l = [];
        return i.forEach(function(g) {
          l.push(g);
        }), l.sort().join(", ");
      }, am = [], jg = [], Qh = [], L0 = [], Eg = [], Bx = [], kg = /* @__PURE__ */ new Set();
      rm.recordUnsafeLifecycleWarnings = function(i, l) {
        kg.has(i.type) || (typeof l.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        l.componentWillMount.__suppressDeprecationWarning !== !0 && am.push(i), i.mode & $r && typeof l.UNSAFE_componentWillMount == "function" && jg.push(i), typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Qh.push(i), i.mode & $r && typeof l.UNSAFE_componentWillReceiveProps == "function" && L0.push(i), typeof l.componentWillUpdate == "function" && l.componentWillUpdate.__suppressDeprecationWarning !== !0 && Eg.push(i), i.mode & $r && typeof l.UNSAFE_componentWillUpdate == "function" && Bx.push(i));
      }, rm.flushPendingUnsafeLifecycleWarnings = function() {
        var i = /* @__PURE__ */ new Set();
        am.length > 0 && (am.forEach(function(Ae) {
          i.add(Nr(Ae) || "Component"), kg.add(Ae.type);
        }), am = []);
        var l = /* @__PURE__ */ new Set();
        jg.length > 0 && (jg.forEach(function(Ae) {
          l.add(Nr(Ae) || "Component"), kg.add(Ae.type);
        }), jg = []);
        var g = /* @__PURE__ */ new Set();
        Qh.length > 0 && (Qh.forEach(function(Ae) {
          g.add(Nr(Ae) || "Component"), kg.add(Ae.type);
        }), Qh = []);
        var S = /* @__PURE__ */ new Set();
        L0.length > 0 && (L0.forEach(function(Ae) {
          S.add(Nr(Ae) || "Component"), kg.add(Ae.type);
        }), L0 = []);
        var _ = /* @__PURE__ */ new Set();
        Eg.length > 0 && (Eg.forEach(function(Ae) {
          _.add(Nr(Ae) || "Component"), kg.add(Ae.type);
        }), Eg = []);
        var F = /* @__PURE__ */ new Set();
        if (Bx.length > 0 && (Bx.forEach(function(Ae) {
          F.add(Nr(Ae) || "Component"), kg.add(Ae.type);
        }), Bx = []), l.size > 0) {
          var Y = Cc(l);
          c(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, Y);
        }
        if (S.size > 0) {
          var ee = Cc(S);
          c(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, ee);
        }
        if (F.size > 0) {
          var ie = Cc(F);
          c(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, ie);
        }
        if (i.size > 0) {
          var xe = Cc(i);
          o(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, xe);
        }
        if (g.size > 0) {
          var we = Cc(g);
          o(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, we);
        }
        if (_.size > 0) {
          var Le = Cc(_);
          o(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Le);
        }
      };
      var Yr = /* @__PURE__ */ new Map(), $u = /* @__PURE__ */ new Set();
      rm.recordLegacyContextWarning = function(i, l) {
        var g = au(i);
        if (g === null) {
          c("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!$u.has(i.type)) {
          var S = Yr.get(g);
          (i.type.contextTypes != null || i.type.childContextTypes != null || l !== null && typeof l.getChildContext == "function") && (S === void 0 && (S = [], Yr.set(g, S)), S.push(i));
        }
      }, rm.flushLegacyContextWarning = function() {
        Yr.forEach(function(i, l) {
          if (i.length !== 0) {
            var g = i[0], S = /* @__PURE__ */ new Set();
            i.forEach(function(F) {
              S.add(Nr(F) || "Component"), $u.add(F.type);
            });
            var _ = Cc(S);
            try {
              Va(g), c(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, _);
            } finally {
              Vs();
            }
          }
        });
      }, rm.discardPendingWarnings = function() {
        am = [], jg = [], Qh = [], L0 = [], Eg = [], Bx = [], Yr = /* @__PURE__ */ new Map();
      };
    }
    var Ri, Ko, Km, Hb, Xo, Hx = function(i, l) {
    };
    Ri = !1, Ko = !1, Km = {}, Hb = {}, Xo = {}, Hx = function(i, l) {
      if (!(i === null || typeof i != "object") && !(!i._store || i._store.validated || i.key != null)) {
        if (typeof i._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        i._store.validated = !0;
        var g = Nr(l) || "Component";
        Hb[g] || (Hb[g] = !0, c('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function hS(i) {
      return i.prototype && i.prototype.isReactComponent;
    }
    function _g(i, l, g) {
      var S = g.ref;
      if (S !== null && typeof S != "function" && typeof S != "object") {
        if ((i.mode & $r || Ue) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(g._owner && g._self && g._owner.stateNode !== g._self) && // Will already throw with "Function components cannot have string refs"
        !(g._owner && g._owner.tag !== y) && // Will already warn with "Function components cannot be given refs"
        !(typeof g.type == "function" && !hS(g.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        g._owner) {
          var _ = Nr(i) || "Component";
          Km[_] || (c('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _, S), Km[_] = !0);
        }
        if (g._owner) {
          var F = g._owner, Y;
          if (F) {
            var ee = F;
            if (ee.tag !== y)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            Y = ee.stateNode;
          }
          if (!Y)
            throw new Error("Missing owner for string ref " + S + ". This error is likely caused by a bug in React. Please file an issue.");
          var ie = Y;
          Pe(S, "ref");
          var xe = "" + S;
          if (l !== null && l.ref !== null && typeof l.ref == "function" && l.ref._stringRef === xe)
            return l.ref;
          var we = function(Le) {
            var Ae = ie.refs;
            Le === null ? delete Ae[xe] : Ae[xe] = Le;
          };
          return we._stringRef = xe, we;
        } else {
          if (typeof S != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!g._owner)
            throw new Error("Element ref was specified as a string (" + S + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return S;
    }
    function av(i, l) {
      var g = Object.prototype.toString.call(l);
      throw new Error("Objects are not valid as a React child (found: " + (g === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : g) + "). If you meant to render a collection of children, use an array instead.");
    }
    function I0(i) {
      {
        var l = Nr(i) || "Component";
        if (Xo[l])
          return;
        Xo[l] = !0, c("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function Ed(i) {
      var l = i._payload, g = i._init;
      return g(l);
    }
    function pS(i) {
      function l(We, ft) {
        if (i) {
          var Ye = We.deletions;
          Ye === null ? (We.deletions = [ft], We.flags |= Na) : Ye.push(ft);
        }
      }
      function g(We, ft) {
        if (!i)
          return null;
        for (var Ye = ft; Ye !== null; )
          l(We, Ye), Ye = Ye.sibling;
        return null;
      }
      function S(We, ft) {
        for (var Ye = /* @__PURE__ */ new Map(), Ut = ft; Ut !== null; )
          Ut.key !== null ? Ye.set(Ut.key, Ut) : Ye.set(Ut.index, Ut), Ut = Ut.sibling;
        return Ye;
      }
      function _(We, ft) {
        var Ye = b4(We, ft);
        return Ye.index = 0, Ye.sibling = null, Ye;
      }
      function F(We, ft, Ye) {
        if (We.index = Ye, !i)
          return We.flags |= Pu, ft;
        var Ut = We.alternate;
        if (Ut !== null) {
          var Tn = Ut.index;
          return Tn < ft ? (We.flags |= ts, ft) : Tn;
        } else
          return We.flags |= ts, ft;
      }
      function Y(We) {
        return i && We.alternate === null && (We.flags |= ts), We;
      }
      function ee(We, ft, Ye, Ut) {
        if (ft === null || ft.tag !== E) {
          var Tn = iM(Ye, We.mode, Ut);
          return Tn.return = We, Tn;
        } else {
          var Nn = _(ft, Ye);
          return Nn.return = We, Nn;
        }
      }
      function ie(We, ft, Ye, Ut) {
        var Tn = Ye.type;
        if (Tn === Do)
          return we(We, ft, Ye.props.children, Ut, Ye.key);
        if (ft !== null && (ft.elementType === Tn || // Keep this check inline so it only runs on the false path:
        iI(ft, Ye) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Tn == "object" && Tn !== null && Tn.$$typeof === Xn && Ed(Tn) === ft.type)) {
          var Nn = _(ft, Ye.props);
          return Nn.ref = _g(We, ft, Ye), Nn.return = We, Nn._debugSource = Ye._source, Nn._debugOwner = Ye._owner, Nn;
        }
        var kr = sM(Ye, We.mode, Ut);
        return kr.ref = _g(We, ft, Ye), kr.return = We, kr;
      }
      function xe(We, ft, Ye, Ut) {
        if (ft === null || ft.tag !== k || ft.stateNode.containerInfo !== Ye.containerInfo || ft.stateNode.implementation !== Ye.implementation) {
          var Tn = oM(Ye, We.mode, Ut);
          return Tn.return = We, Tn;
        } else {
          var Nn = _(ft, Ye.children || []);
          return Nn.return = We, Nn;
        }
      }
      function we(We, ft, Ye, Ut, Tn) {
        if (ft === null || ft.tag !== T) {
          var Nn = r2(Ye, We.mode, Ut, Tn);
          return Nn.return = We, Nn;
        } else {
          var kr = _(ft, Ye);
          return kr.return = We, kr;
        }
      }
      function Le(We, ft, Ye) {
        if (typeof ft == "string" && ft !== "" || typeof ft == "number") {
          var Ut = iM("" + ft, We.mode, Ye);
          return Ut.return = We, Ut;
        }
        if (typeof ft == "object" && ft !== null) {
          switch (ft.$$typeof) {
            case Dc: {
              var Tn = sM(ft, We.mode, Ye);
              return Tn.ref = _g(We, null, ft), Tn.return = We, Tn;
            }
            case Ro: {
              var Nn = oM(ft, We.mode, Ye);
              return Nn.return = We, Nn;
            }
            case Xn: {
              var kr = ft._payload, Gr = ft._init;
              return Le(We, Gr(kr), Ye);
            }
          }
          if (Ja(ft) || ta(ft)) {
            var ti = r2(ft, We.mode, Ye, null);
            return ti.return = We, ti;
          }
          av(We, ft);
        }
        return typeof ft == "function" && I0(We), null;
      }
      function Ae(We, ft, Ye, Ut) {
        var Tn = ft !== null ? ft.key : null;
        if (typeof Ye == "string" && Ye !== "" || typeof Ye == "number")
          return Tn !== null ? null : ee(We, ft, "" + Ye, Ut);
        if (typeof Ye == "object" && Ye !== null) {
          switch (Ye.$$typeof) {
            case Dc:
              return Ye.key === Tn ? ie(We, ft, Ye, Ut) : null;
            case Ro:
              return Ye.key === Tn ? xe(We, ft, Ye, Ut) : null;
            case Xn: {
              var Nn = Ye._payload, kr = Ye._init;
              return Ae(We, ft, kr(Nn), Ut);
            }
          }
          if (Ja(Ye) || ta(Ye))
            return Tn !== null ? null : we(We, ft, Ye, Ut, null);
          av(We, Ye);
        }
        return typeof Ye == "function" && I0(We), null;
      }
      function et(We, ft, Ye, Ut, Tn) {
        if (typeof Ut == "string" && Ut !== "" || typeof Ut == "number") {
          var Nn = We.get(Ye) || null;
          return ee(ft, Nn, "" + Ut, Tn);
        }
        if (typeof Ut == "object" && Ut !== null) {
          switch (Ut.$$typeof) {
            case Dc: {
              var kr = We.get(Ut.key === null ? Ye : Ut.key) || null;
              return ie(ft, kr, Ut, Tn);
            }
            case Ro: {
              var Gr = We.get(Ut.key === null ? Ye : Ut.key) || null;
              return xe(ft, Gr, Ut, Tn);
            }
            case Xn:
              var ti = Ut._payload, hs = Ut._init;
              return et(We, ft, Ye, hs(ti), Tn);
          }
          if (Ja(Ut) || ta(Ut)) {
            var ql = We.get(Ye) || null;
            return we(ft, ql, Ut, Tn, null);
          }
          av(ft, Ut);
        }
        return typeof Ut == "function" && I0(ft), null;
      }
      function nt(We, ft, Ye) {
        {
          if (typeof We != "object" || We === null)
            return ft;
          switch (We.$$typeof) {
            case Dc:
            case Ro:
              Hx(We, Ye);
              var Ut = We.key;
              if (typeof Ut != "string")
                break;
              if (ft === null) {
                ft = /* @__PURE__ */ new Set(), ft.add(Ut);
                break;
              }
              if (!ft.has(Ut)) {
                ft.add(Ut);
                break;
              }
              c("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Ut);
              break;
            case Xn:
              var Tn = We._payload, Nn = We._init;
              nt(Nn(Tn), ft, Ye);
              break;
          }
        }
        return ft;
      }
      function dt(We, ft, Ye, Ut) {
        for (var Tn = null, Nn = 0; Nn < Ye.length; Nn++) {
          var kr = Ye[Nn];
          Tn = nt(kr, Tn, We);
        }
        for (var Gr = null, ti = null, hs = ft, ql = 0, ps = 0, _l = null; hs !== null && ps < Ye.length; ps++) {
          hs.index > ps ? (_l = hs, hs = null) : _l = hs.sibling;
          var yf = Ae(We, hs, Ye[ps], Ut);
          if (yf === null) {
            hs === null && (hs = _l);
            break;
          }
          i && hs && yf.alternate === null && l(We, hs), ql = F(yf, ql, ps), ti === null ? Gr = yf : ti.sibling = yf, ti = yf, hs = _l;
        }
        if (ps === Ye.length) {
          if (g(We, hs), Wl()) {
            var Ld = ps;
            tv(We, Ld);
          }
          return Gr;
        }
        if (hs === null) {
          for (; ps < Ye.length; ps++) {
            var sp = Le(We, Ye[ps], Ut);
            sp !== null && (ql = F(sp, ql, ps), ti === null ? Gr = sp : ti.sibling = sp, ti = sp);
          }
          if (Wl()) {
            var lm = ps;
            tv(We, lm);
          }
          return Gr;
        }
        for (var cm = S(We, hs); ps < Ye.length; ps++) {
          var vf = et(cm, We, ps, Ye[ps], Ut);
          vf !== null && (i && vf.alternate !== null && cm.delete(vf.key === null ? ps : vf.key), ql = F(vf, ql, ps), ti === null ? Gr = vf : ti.sibling = vf, ti = vf);
        }
        if (i && cm.forEach(function(t8) {
          return l(We, t8);
        }), Wl()) {
          var bv = ps;
          tv(We, bv);
        }
        return Gr;
      }
      function xn(We, ft, Ye, Ut) {
        var Tn = ta(Ye);
        if (typeof Tn != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          Ye[Symbol.toStringTag] === "Generator" && (Ko || c("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), Ko = !0), Ye.entries === Tn && (Ri || c("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Ri = !0);
          var Nn = Tn.call(Ye);
          if (Nn)
            for (var kr = null, Gr = Nn.next(); !Gr.done; Gr = Nn.next()) {
              var ti = Gr.value;
              kr = nt(ti, kr, We);
            }
        }
        var hs = Tn.call(Ye);
        if (hs == null)
          throw new Error("An iterable object provided no iterator.");
        for (var ql = null, ps = null, _l = ft, yf = 0, Ld = 0, sp = null, lm = hs.next(); _l !== null && !lm.done; Ld++, lm = hs.next()) {
          _l.index > Ld ? (sp = _l, _l = null) : sp = _l.sibling;
          var cm = Ae(We, _l, lm.value, Ut);
          if (cm === null) {
            _l === null && (_l = sp);
            break;
          }
          i && _l && cm.alternate === null && l(We, _l), yf = F(cm, yf, Ld), ps === null ? ql = cm : ps.sibling = cm, ps = cm, _l = sp;
        }
        if (lm.done) {
          if (g(We, _l), Wl()) {
            var vf = Ld;
            tv(We, vf);
          }
          return ql;
        }
        if (_l === null) {
          for (; !lm.done; Ld++, lm = hs.next()) {
            var bv = Le(We, lm.value, Ut);
            bv !== null && (yf = F(bv, yf, Ld), ps === null ? ql = bv : ps.sibling = bv, ps = bv);
          }
          if (Wl()) {
            var t8 = Ld;
            tv(We, t8);
          }
          return ql;
        }
        for (var w7 = S(We, _l); !lm.done; Ld++, lm = hs.next()) {
          var Y0 = et(w7, We, Ld, lm.value, Ut);
          Y0 !== null && (i && Y0.alternate !== null && w7.delete(Y0.key === null ? Ld : Y0.key), yf = F(Y0, yf, Ld), ps === null ? ql = Y0 : ps.sibling = Y0, ps = Y0);
        }
        if (i && w7.forEach(function(xZ) {
          return l(We, xZ);
        }), Wl()) {
          var vZ = Ld;
          tv(We, vZ);
        }
        return ql;
      }
      function fr(We, ft, Ye, Ut) {
        if (ft !== null && ft.tag === E) {
          g(We, ft.sibling);
          var Tn = _(ft, Ye);
          return Tn.return = We, Tn;
        }
        g(We, ft);
        var Nn = iM(Ye, We.mode, Ut);
        return Nn.return = We, Nn;
      }
      function qn(We, ft, Ye, Ut) {
        for (var Tn = Ye.key, Nn = ft; Nn !== null; ) {
          if (Nn.key === Tn) {
            var kr = Ye.type;
            if (kr === Do) {
              if (Nn.tag === T) {
                g(We, Nn.sibling);
                var Gr = _(Nn, Ye.props.children);
                return Gr.return = We, Gr._debugSource = Ye._source, Gr._debugOwner = Ye._owner, Gr;
              }
            } else if (Nn.elementType === kr || // Keep this check inline so it only runs on the false path:
            iI(Nn, Ye) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof kr == "object" && kr !== null && kr.$$typeof === Xn && Ed(kr) === Nn.type) {
              g(We, Nn.sibling);
              var ti = _(Nn, Ye.props);
              return ti.ref = _g(We, Nn, Ye), ti.return = We, ti._debugSource = Ye._source, ti._debugOwner = Ye._owner, ti;
            }
            g(We, Nn);
            break;
          } else
            l(We, Nn);
          Nn = Nn.sibling;
        }
        if (Ye.type === Do) {
          var hs = r2(Ye.props.children, We.mode, Ut, Ye.key);
          return hs.return = We, hs;
        } else {
          var ql = sM(Ye, We.mode, Ut);
          return ql.ref = _g(We, ft, Ye), ql.return = We, ql;
        }
      }
      function Ua(We, ft, Ye, Ut) {
        for (var Tn = Ye.key, Nn = ft; Nn !== null; ) {
          if (Nn.key === Tn)
            if (Nn.tag === k && Nn.stateNode.containerInfo === Ye.containerInfo && Nn.stateNode.implementation === Ye.implementation) {
              g(We, Nn.sibling);
              var kr = _(Nn, Ye.children || []);
              return kr.return = We, kr;
            } else {
              g(We, Nn);
              break;
            }
          else
            l(We, Nn);
          Nn = Nn.sibling;
        }
        var Gr = oM(Ye, We.mode, Ut);
        return Gr.return = We, Gr;
      }
      function ba(We, ft, Ye, Ut) {
        var Tn = typeof Ye == "object" && Ye !== null && Ye.type === Do && Ye.key === null;
        if (Tn && (Ye = Ye.props.children), typeof Ye == "object" && Ye !== null) {
          switch (Ye.$$typeof) {
            case Dc:
              return Y(qn(We, ft, Ye, Ut));
            case Ro:
              return Y(Ua(We, ft, Ye, Ut));
            case Xn:
              var Nn = Ye._payload, kr = Ye._init;
              return ba(We, ft, kr(Nn), Ut);
          }
          if (Ja(Ye))
            return dt(We, ft, Ye, Ut);
          if (ta(Ye))
            return xn(We, ft, Ye, Ut);
          av(We, Ye);
        }
        return typeof Ye == "string" && Ye !== "" || typeof Ye == "number" ? Y(fr(We, ft, "" + Ye, Ut)) : (typeof Ye == "function" && I0(We), g(We, ft));
      }
      return ba;
    }
    var sv = pS(!0), jC = pS(!1);
    function lT(i, l) {
      if (i !== null && l.child !== i.child)
        throw new Error("Resuming work not yet implemented.");
      if (l.child !== null) {
        var g = l.child, S = b4(g, g.pendingProps);
        for (l.child = S, S.return = l; g.sibling !== null; )
          g = g.sibling, S = S.sibling = b4(g, g.pendingProps), S.return = l;
        S.sibling = null;
      }
    }
    function Tg(i, l) {
      for (var g = i.child; g !== null; )
        LQ(g, l), g = g.sibling;
    }
    var F0 = O0(null), gS;
    gS = {};
    var iv = null, U0 = null, z0 = null, a1 = !1;
    function Zh() {
      iv = null, U0 = null, z0 = null, a1 = !1;
    }
    function Vx() {
      a1 = !0;
    }
    function yS() {
      a1 = !1;
    }
    function vS(i, l, g) {
      io(F0, l._currentValue, i), l._currentValue = g, l._currentRenderer !== void 0 && l._currentRenderer !== null && l._currentRenderer !== gS && c("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), l._currentRenderer = gS;
    }
    function EC(i, l) {
      var g = F0.current;
      xi(F0, l), i._currentValue = g;
    }
    function ov(i, l, g) {
      for (var S = i; S !== null; ) {
        var _ = S.alternate;
        if (dr(S.childLanes, l) ? _ !== null && !dr(_.childLanes, l) && (_.childLanes = ct(_.childLanes, l)) : (S.childLanes = ct(S.childLanes, l), _ !== null && (_.childLanes = ct(_.childLanes, l))), S === g)
          break;
        S = S.return;
      }
      S !== g && c("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function kC(i, l, g) {
      _C(i, l, g);
    }
    function _C(i, l, g) {
      var S = i.child;
      for (S !== null && (S.return = i); S !== null; ) {
        var _ = void 0, F = S.dependencies;
        if (F !== null) {
          _ = S.child;
          for (var Y = F.firstContext; Y !== null; ) {
            if (Y.context === l) {
              if (S.tag === y) {
                var ee = Fe(g), ie = Wu(da, ee);
                ie.tag = SS;
                var xe = S.updateQueue;
                if (xe !== null) {
                  var we = xe.shared, Le = we.pending;
                  Le === null ? ie.next = ie : (ie.next = Le.next, Le.next = ie), we.pending = ie;
                }
              }
              S.lanes = ct(S.lanes, g);
              var Ae = S.alternate;
              Ae !== null && (Ae.lanes = ct(Ae.lanes, g)), ov(S.return, g, i), F.lanes = ct(F.lanes, g);
              break;
            }
            Y = Y.next;
          }
        } else if (S.tag === I)
          _ = S.type === i.type ? null : S.child;
        else if (S.tag === Z) {
          var et = S.return;
          if (et === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          et.lanes = ct(et.lanes, g);
          var nt = et.alternate;
          nt !== null && (nt.lanes = ct(nt.lanes, g)), ov(et, g, i), _ = S.sibling;
        } else
          _ = S.child;
        if (_ !== null)
          _.return = S;
        else
          for (_ = S; _ !== null; ) {
            if (_ === i) {
              _ = null;
              break;
            }
            var dt = _.sibling;
            if (dt !== null) {
              dt.return = _.return, _ = dt;
              break;
            }
            _ = _.return;
          }
        S = _;
      }
    }
    function Mg(i, l) {
      iv = i, U0 = null, z0 = null;
      var g = i.dependencies;
      if (g !== null) {
        var S = g.firstContext;
        S !== null && (sn(g.lanes, l) && s7(), g.firstContext = null);
      }
    }
    function El(i) {
      a1 && c("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var l = i._currentValue;
      if (z0 !== i) {
        var g = {
          context: i,
          memoizedValue: l,
          next: null
        };
        if (U0 === null) {
          if (iv === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          U0 = g, iv.dependencies = {
            lanes: St,
            firstContext: g
          };
        } else
          U0 = U0.next = g;
      }
      return l;
    }
    var Xm = null;
    function $x(i) {
      Xm === null ? Xm = [i] : Xm.push(i);
    }
    function Vb() {
      if (Xm !== null) {
        for (var i = 0; i < Xm.length; i++) {
          var l = Xm[i], g = l.interleaved;
          if (g !== null) {
            l.interleaved = null;
            var S = g.next, _ = l.pending;
            if (_ !== null) {
              var F = _.next;
              _.next = S, g.next = F;
            }
            l.pending = g;
          }
        }
        Xm = null;
      }
    }
    function $b(i, l, g, S) {
      var _ = l.interleaved;
      return _ === null ? (g.next = g, $x(l)) : (g.next = _.next, _.next = g), l.interleaved = g, bS(i, S);
    }
    function bN(i, l, g, S) {
      var _ = l.interleaved;
      _ === null ? (g.next = g, $x(l)) : (g.next = _.next, _.next = g), l.interleaved = g;
    }
    function xS(i, l, g, S) {
      var _ = l.interleaved;
      return _ === null ? (g.next = g, $x(l)) : (g.next = _.next, _.next = g), l.interleaved = g, bS(i, S);
    }
    function Is(i, l) {
      return bS(i, l);
    }
    var B0 = bS;
    function bS(i, l) {
      i.lanes = ct(i.lanes, l);
      var g = i.alternate;
      g !== null && (g.lanes = ct(g.lanes, l)), g === null && (i.flags & (ts | cc)) !== mn && nI(i);
      for (var S = i, _ = i.return; _ !== null; )
        _.childLanes = ct(_.childLanes, l), g = _.alternate, g !== null ? g.childLanes = ct(g.childLanes, l) : (_.flags & (ts | cc)) !== mn && nI(i), S = _, _ = _.return;
      if (S.tag === w) {
        var F = S.stateNode;
        return F;
      } else
        return null;
    }
    var Qo = 0, SN = 1, SS = 2, Gu = 3, Gb = !1, Wb, Yb;
    Wb = !1, Yb = null;
    function TC(i) {
      var l = {
        baseState: i.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: St
        },
        effects: null
      };
      i.updateQueue = l;
    }
    function wN(i, l) {
      var g = l.updateQueue, S = i.updateQueue;
      if (g === S) {
        var _ = {
          baseState: S.baseState,
          firstBaseUpdate: S.firstBaseUpdate,
          lastBaseUpdate: S.lastBaseUpdate,
          shared: S.shared,
          effects: S.effects
        };
        l.updateQueue = _;
      }
    }
    function Wu(i, l) {
      var g = {
        eventTime: i,
        lane: l,
        tag: Qo,
        payload: null,
        callback: null,
        next: null
      };
      return g;
    }
    function Rg(i, l, g) {
      var S = i.updateQueue;
      if (S === null)
        return null;
      var _ = S.shared;
      if (Yb === _ && !Wb && (c("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), Wb = !0), JX()) {
        var F = _.pending;
        return F === null ? l.next = l : (l.next = F.next, F.next = l), _.pending = l, B0(i, g);
      } else
        return xS(i, _, l, g);
    }
    function wS(i, l, g) {
      var S = l.updateQueue;
      if (S !== null) {
        var _ = S.shared;
        if (B(g)) {
          var F = _.lanes;
          F = Ga(F, i.pendingLanes);
          var Y = ct(F, g);
          _.lanes = Y, pr(i, Y);
        }
      }
    }
    function MC(i, l) {
      var g = i.updateQueue, S = i.alternate;
      if (S !== null) {
        var _ = S.updateQueue;
        if (g === _) {
          var F = null, Y = null, ee = g.firstBaseUpdate;
          if (ee !== null) {
            var ie = ee;
            do {
              var xe = {
                eventTime: ie.eventTime,
                lane: ie.lane,
                tag: ie.tag,
                payload: ie.payload,
                callback: ie.callback,
                next: null
              };
              Y === null ? F = Y = xe : (Y.next = xe, Y = xe), ie = ie.next;
            } while (ie !== null);
            Y === null ? F = Y = l : (Y.next = l, Y = l);
          } else
            F = Y = l;
          g = {
            baseState: _.baseState,
            firstBaseUpdate: F,
            lastBaseUpdate: Y,
            shared: _.shared,
            effects: _.effects
          }, i.updateQueue = g;
          return;
        }
      }
      var we = g.lastBaseUpdate;
      we === null ? g.firstBaseUpdate = l : we.next = l, g.lastBaseUpdate = l;
    }
    function cT(i, l, g, S, _, F) {
      switch (g.tag) {
        case SN: {
          var Y = g.payload;
          if (typeof Y == "function") {
            Vx();
            var ee = Y.call(F, S, _);
            {
              if (i.mode & $r) {
                ya(!0);
                try {
                  Y.call(F, S, _);
                } finally {
                  ya(!1);
                }
              }
              yS();
            }
            return ee;
          }
          return Y;
        }
        case Gu:
          i.flags = i.flags & ~js | or;
        case Qo: {
          var ie = g.payload, xe;
          if (typeof ie == "function") {
            Vx(), xe = ie.call(F, S, _);
            {
              if (i.mode & $r) {
                ya(!0);
                try {
                  ie.call(F, S, _);
                } finally {
                  ya(!1);
                }
              }
              yS();
            }
          } else
            xe = ie;
          return xe == null ? S : ir({}, S, xe);
        }
        case SS:
          return Gb = !0, S;
      }
      return S;
    }
    function CS(i, l, g, S) {
      var _ = i.updateQueue;
      Gb = !1, Yb = _.shared;
      var F = _.firstBaseUpdate, Y = _.lastBaseUpdate, ee = _.shared.pending;
      if (ee !== null) {
        _.shared.pending = null;
        var ie = ee, xe = ie.next;
        ie.next = null, Y === null ? F = xe : Y.next = xe, Y = ie;
        var we = i.alternate;
        if (we !== null) {
          var Le = we.updateQueue, Ae = Le.lastBaseUpdate;
          Ae !== Y && (Ae === null ? Le.firstBaseUpdate = xe : Ae.next = xe, Le.lastBaseUpdate = ie);
        }
      }
      if (F !== null) {
        var et = _.baseState, nt = St, dt = null, xn = null, fr = null, qn = F;
        do {
          var Ua = qn.lane, ba = qn.eventTime;
          if (dr(S, Ua)) {
            if (fr !== null) {
              var ft = {
                eventTime: ba,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Qs,
                tag: qn.tag,
                payload: qn.payload,
                callback: qn.callback,
                next: null
              };
              fr = fr.next = ft;
            }
            et = cT(i, _, qn, et, l, g);
            var Ye = qn.callback;
            if (Ye !== null && // If the update was already committed, we should not queue its
            // callback again.
            qn.lane !== Qs) {
              i.flags |= Ru;
              var Ut = _.effects;
              Ut === null ? _.effects = [qn] : Ut.push(qn);
            }
          } else {
            var We = {
              eventTime: ba,
              lane: Ua,
              tag: qn.tag,
              payload: qn.payload,
              callback: qn.callback,
              next: null
            };
            fr === null ? (xn = fr = We, dt = et) : fr = fr.next = We, nt = ct(nt, Ua);
          }
          if (qn = qn.next, qn === null) {
            if (ee = _.shared.pending, ee === null)
              break;
            var Tn = ee, Nn = Tn.next;
            Tn.next = null, qn = Nn, _.lastBaseUpdate = Tn, _.shared.pending = null;
          }
        } while (!0);
        fr === null && (dt = et), _.baseState = dt, _.firstBaseUpdate = xn, _.lastBaseUpdate = fr;
        var kr = _.shared.interleaved;
        if (kr !== null) {
          var Gr = kr;
          do
            nt = ct(nt, Gr.lane), Gr = Gr.next;
          while (Gr !== kr);
        } else F === null && (_.shared.lanes = St);
        y7(nt), i.lanes = nt, i.memoizedState = et;
      }
      Yb = null;
    }
    function NS(i, l) {
      if (typeof i != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + i));
      i.call(l);
    }
    function CN() {
      Gb = !1;
    }
    function jS() {
      return Gb;
    }
    function qb(i, l, g) {
      var S = l.effects;
      if (l.effects = null, S !== null)
        for (var _ = 0; _ < S.length; _++) {
          var F = S[_], Y = F.callback;
          Y !== null && (F.callback = null, NS(Y, g));
        }
    }
    var lv = {}, hf = O0(lv), Gx = O0(lv), Kb = O0(lv);
    function Xb(i) {
      if (i === lv)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return i;
    }
    function NN() {
      var i = Xb(Kb.current);
      return i;
    }
    function cv(i, l) {
      io(Kb, l, i), io(Gx, i, i), io(hf, lv, i);
      var g = W6(l);
      xi(hf, i), io(hf, g, i);
    }
    function Wx(i) {
      xi(hf, i), xi(Gx, i), xi(Kb, i);
    }
    function Qb() {
      var i = Xb(hf.current);
      return i;
    }
    function jN(i) {
      Xb(Kb.current);
      var l = Xb(hf.current), g = nC(l, i.type);
      l !== g && (io(Gx, i, i), io(hf, g, i));
    }
    function RC(i) {
      Gx.current === i && (xi(hf, i), xi(Gx, i));
    }
    var ES = 0, EN = 1, kN = 1, Zb = 2, Qm = O0(ES);
    function kS(i, l) {
      return (i & l) !== 0;
    }
    function Zm(i) {
      return i & EN;
    }
    function DC(i, l) {
      return i & EN | l;
    }
    function s1(i, l) {
      return i | l;
    }
    function H0(i, l) {
      io(Qm, l, i);
    }
    function Yx(i) {
      xi(Qm, i);
    }
    function _N(i, l) {
      var g = i.memoizedState;
      return g !== null ? g.dehydrated !== null : (i.memoizedProps, !0);
    }
    function _S(i) {
      for (var l = i; l !== null; ) {
        if (l.tag === z) {
          var g = l.memoizedState;
          if (g !== null) {
            var S = g.dehydrated;
            if (S === null || nN(S) || Y5(S))
              return l;
          }
        } else if (l.tag === X && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        l.memoizedProps.revealOrder !== void 0) {
          var _ = (l.flags & or) !== mn;
          if (_)
            return l;
        } else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === i)
          return null;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === i)
            return null;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return null;
    }
    var pf = (
      /*   */
      0
    ), Yl = (
      /* */
      1
    ), Jh = (
      /*  */
      2
    ), Fr = (
      /*    */
      4
    ), su = (
      /*   */
      8
    ), TS = [];
    function PC() {
      for (var i = 0; i < TS.length; i++) {
        var l = TS[i];
        l._workInProgressVersionPrimary = null;
      }
      TS.length = 0;
    }
    function uT(i, l) {
      var g = l._getVersion, S = g(l._source);
      i.mutableSourceEagerHydrationData == null ? i.mutableSourceEagerHydrationData = [l, S] : i.mutableSourceEagerHydrationData.push(l, S);
    }
    var Cn = n.ReactCurrentDispatcher, Jb = n.ReactCurrentBatchConfig, OC, uv;
    OC = /* @__PURE__ */ new Set();
    var i1 = St, as = null, kl = null, Zo = null, MS = !1, qx = !1, dv = 0, dT = 0, e4 = 25, gt = null, kd = null, Dg = -1, RS = !1;
    function fs() {
      {
        var i = gt;
        kd === null ? kd = [i] : kd.push(i);
      }
    }
    function cn() {
      {
        var i = gt;
        kd !== null && (Dg++, kd[Dg] !== i && Jm(i));
      }
    }
    function o1(i) {
      i != null && !Ja(i) && c("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", gt, typeof i);
    }
    function Jm(i) {
      {
        var l = Nr(as);
        if (!OC.has(l) && (OC.add(l), kd !== null)) {
          for (var g = "", S = 30, _ = 0; _ <= Dg; _++) {
            for (var F = kd[_], Y = _ === Dg ? i : F, ee = _ + 1 + ". " + F; ee.length < S; )
              ee += " ";
            ee += Y + `
`, g += ee;
          }
          c(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, l, g);
        }
      }
    }
    function Jo() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function AC(i, l) {
      if (RS)
        return !1;
      if (l === null)
        return c("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", gt), !1;
      i.length !== l.length && c(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, gt, "[" + l.join(", ") + "]", "[" + i.join(", ") + "]");
      for (var g = 0; g < l.length && g < i.length; g++)
        if (!Rn(i[g], l[g]))
          return !1;
      return !0;
    }
    function ep(i, l, g, S, _, F) {
      i1 = F, as = l, kd = i !== null ? i._debugHookTypes : null, Dg = -1, RS = i !== null && i.type !== l.type, l.memoizedState = null, l.updateQueue = null, l.lanes = St, i !== null && i.memoizedState !== null ? Cn.current = QC : kd !== null ? Cn.current = XC : Cn.current = KC;
      var Y = g(S, _);
      if (qx) {
        var ee = 0;
        do {
          if (qx = !1, dv = 0, ee >= e4)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          ee += 1, RS = !1, kl = null, Zo = null, l.updateQueue = null, Dg = -1, Cn.current = ZC, Y = g(S, _);
        } while (qx);
      }
      Cn.current = f4, l._debugHookTypes = kd;
      var ie = kl !== null && kl.next !== null;
      if (i1 = St, as = null, kl = null, Zo = null, gt = null, kd = null, Dg = -1, i !== null && (i.flags & Ps) !== (l.flags & Ps) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (i.mode & Mn) !== Sn && c("Internal React error: Expected static flag was missing. Please notify the React team."), MS = !1, ie)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return Y;
    }
    function V0() {
      var i = dv !== 0;
      return dv = 0, i;
    }
    function DS(i, l, g) {
      l.updateQueue = i.updateQueue, (l.mode & Fi) !== Sn ? l.flags &= ~(dc | Wn | Ns | Dr) : l.flags &= ~(Ns | Dr), i.lanes = xa(i.lanes, g);
    }
    function LC() {
      if (Cn.current = f4, MS) {
        for (var i = as.memoizedState; i !== null; ) {
          var l = i.queue;
          l !== null && (l.pending = null), i = i.next;
        }
        MS = !1;
      }
      i1 = St, as = null, kl = null, Zo = null, kd = null, Dg = -1, gt = null, IN = !1, qx = !1, dv = 0;
    }
    function tp() {
      var i = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Zo === null ? as.memoizedState = Zo = i : Zo = Zo.next = i, Zo;
    }
    function eh() {
      var i;
      if (kl === null) {
        var l = as.alternate;
        l !== null ? i = l.memoizedState : i = null;
      } else
        i = kl.next;
      var g;
      if (Zo === null ? g = as.memoizedState : g = Zo.next, g !== null)
        Zo = g, g = Zo.next, kl = i;
      else {
        if (i === null)
          throw new Error("Rendered more hooks than during the previous render.");
        kl = i;
        var S = {
          memoizedState: kl.memoizedState,
          baseState: kl.baseState,
          baseQueue: kl.baseQueue,
          queue: kl.queue,
          next: null
        };
        Zo === null ? as.memoizedState = Zo = S : Zo = Zo.next = S;
      }
      return Zo;
    }
    function TN() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function t4(i, l) {
      return typeof l == "function" ? l(i) : l;
    }
    function IC(i, l, g) {
      var S = tp(), _;
      g !== void 0 ? _ = g(l) : _ = l, S.memoizedState = S.baseState = _;
      var F = {
        pending: null,
        interleaved: null,
        lanes: St,
        dispatch: null,
        lastRenderedReducer: i,
        lastRenderedState: _
      };
      S.queue = F;
      var Y = F.dispatch = FN.bind(null, as, F);
      return [S.memoizedState, Y];
    }
    function n4(i, l, g) {
      var S = eh(), _ = S.queue;
      if (_ === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      _.lastRenderedReducer = i;
      var F = kl, Y = F.baseQueue, ee = _.pending;
      if (ee !== null) {
        if (Y !== null) {
          var ie = Y.next, xe = ee.next;
          Y.next = xe, ee.next = ie;
        }
        F.baseQueue !== Y && c("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), F.baseQueue = Y = ee, _.pending = null;
      }
      if (Y !== null) {
        var we = Y.next, Le = F.baseState, Ae = null, et = null, nt = null, dt = we;
        do {
          var xn = dt.lane;
          if (dr(i1, xn)) {
            if (nt !== null) {
              var qn = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Qs,
                action: dt.action,
                hasEagerState: dt.hasEagerState,
                eagerState: dt.eagerState,
                next: null
              };
              nt = nt.next = qn;
            }
            if (dt.hasEagerState)
              Le = dt.eagerState;
            else {
              var Ua = dt.action;
              Le = i(Le, Ua);
            }
          } else {
            var fr = {
              lane: xn,
              action: dt.action,
              hasEagerState: dt.hasEagerState,
              eagerState: dt.eagerState,
              next: null
            };
            nt === null ? (et = nt = fr, Ae = Le) : nt = nt.next = fr, as.lanes = ct(as.lanes, xn), y7(xn);
          }
          dt = dt.next;
        } while (dt !== null && dt !== we);
        nt === null ? Ae = Le : nt.next = et, Rn(Le, S.memoizedState) || s7(), S.memoizedState = Le, S.baseState = Ae, S.baseQueue = nt, _.lastRenderedState = Le;
      }
      var ba = _.interleaved;
      if (ba !== null) {
        var We = ba;
        do {
          var ft = We.lane;
          as.lanes = ct(as.lanes, ft), y7(ft), We = We.next;
        } while (We !== ba);
      } else Y === null && (_.lanes = St);
      var Ye = _.dispatch;
      return [S.memoizedState, Ye];
    }
    function FC(i, l, g) {
      var S = eh(), _ = S.queue;
      if (_ === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      _.lastRenderedReducer = i;
      var F = _.dispatch, Y = _.pending, ee = S.memoizedState;
      if (Y !== null) {
        _.pending = null;
        var ie = Y.next, xe = ie;
        do {
          var we = xe.action;
          ee = i(ee, we), xe = xe.next;
        } while (xe !== ie);
        Rn(ee, S.memoizedState) || s7(), S.memoizedState = ee, S.baseQueue === null && (S.baseState = ee), _.lastRenderedState = ee;
      }
      return [ee, F];
    }
    function XA(i, l, g) {
    }
    function MN(i, l, g) {
    }
    function PS(i, l, g) {
      var S = as, _ = tp(), F, Y = Wl();
      if (Y) {
        if (g === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        F = g(), uv || F !== g() && (c("The result of getServerSnapshot should be cached to avoid an infinite loop"), uv = !0);
      } else {
        if (F = l(), !uv) {
          var ee = l();
          Rn(F, ee) || (c("The result of getSnapshot should be cached to avoid an infinite loop"), uv = !0);
        }
        var ie = JN();
        if (ie === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        x(ie, i1) || gf(S, l, F);
      }
      _.memoizedState = F;
      var xe = {
        value: F,
        getSnapshot: l
      };
      return _.queue = xe, s4(RN.bind(null, S, xe, i), [i]), S.flags |= Ns, fv(Yl | su, AS.bind(null, S, xe, F, l), void 0, null), F;
    }
    function OS(i, l, g) {
      var S = as, _ = eh(), F = l();
      if (!uv) {
        var Y = l();
        Rn(F, Y) || (c("The result of getSnapshot should be cached to avoid an infinite loop"), uv = !0);
      }
      var ee = _.memoizedState, ie = !Rn(ee, F);
      ie && (_.memoizedState = F, s7());
      var xe = _.queue;
      if (mv(RN.bind(null, S, xe, i), [i]), xe.getSnapshot !== l || ie || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Zo !== null && Zo.memoizedState.tag & Yl) {
        S.flags |= Ns, fv(Yl | su, AS.bind(null, S, xe, F, l), void 0, null);
        var we = JN();
        if (we === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        x(we, i1) || gf(S, l, F);
      }
      return F;
    }
    function gf(i, l, g) {
      i.flags |= _h;
      var S = {
        getSnapshot: l,
        value: g
      }, _ = as.updateQueue;
      if (_ === null)
        _ = TN(), as.updateQueue = _, _.stores = [S];
      else {
        var F = _.stores;
        F === null ? _.stores = [S] : F.push(S);
      }
    }
    function AS(i, l, g, S) {
      l.value = g, l.getSnapshot = S, DN(l) && $0(i);
    }
    function RN(i, l, g) {
      var S = function() {
        DN(l) && $0(i);
      };
      return g(S);
    }
    function DN(i) {
      var l = i.getSnapshot, g = i.value;
      try {
        var S = l();
        return !Rn(g, S);
      } catch {
        return !0;
      }
    }
    function $0(i) {
      var l = Is(i, hn);
      l !== null && cu(l, i, hn, da);
    }
    function LS(i) {
      var l = tp();
      typeof i == "function" && (i = i()), l.memoizedState = l.baseState = i;
      var g = {
        pending: null,
        interleaved: null,
        lanes: St,
        dispatch: null,
        lastRenderedReducer: t4,
        lastRenderedState: i
      };
      l.queue = g;
      var S = g.dispatch = UN.bind(null, as, g);
      return [l.memoizedState, S];
    }
    function UC(i) {
      return n4(t4);
    }
    function r4(i) {
      return FC(t4);
    }
    function fv(i, l, g, S) {
      var _ = {
        tag: i,
        create: l,
        destroy: g,
        deps: S,
        // Circular
        next: null
      }, F = as.updateQueue;
      if (F === null)
        F = TN(), as.updateQueue = F, F.lastEffect = _.next = _;
      else {
        var Y = F.lastEffect;
        if (Y === null)
          F.lastEffect = _.next = _;
        else {
          var ee = Y.next;
          Y.next = _, _.next = ee, F.lastEffect = _;
        }
      }
      return _;
    }
    function l1(i) {
      var l = tp();
      {
        var g = {
          current: i
        };
        return l.memoizedState = g, g;
      }
    }
    function IS(i) {
      var l = eh();
      return l.memoizedState;
    }
    function a4(i, l, g, S) {
      var _ = tp(), F = S === void 0 ? null : S;
      as.flags |= i, _.memoizedState = fv(Yl | l, g, void 0, F);
    }
    function FS(i, l, g, S) {
      var _ = eh(), F = S === void 0 ? null : S, Y = void 0;
      if (kl !== null) {
        var ee = kl.memoizedState;
        if (Y = ee.destroy, F !== null) {
          var ie = ee.deps;
          if (AC(F, ie)) {
            _.memoizedState = fv(l, g, Y, F);
            return;
          }
        }
      }
      as.flags |= i, _.memoizedState = fv(Yl | l, g, Y, F);
    }
    function s4(i, l) {
      return (as.mode & Fi) !== Sn ? a4(dc | Ns | pi, su, i, l) : a4(Ns | pi, su, i, l);
    }
    function mv(i, l) {
      return FS(Ns, su, i, l);
    }
    function zC(i, l) {
      return a4(Dr, Jh, i, l);
    }
    function US(i, l) {
      return FS(Dr, Jh, i, l);
    }
    function i4(i, l) {
      var g = Dr;
      return g |= Es, (as.mode & Fi) !== Sn && (g |= Wn), a4(g, Fr, i, l);
    }
    function o4(i, l) {
      return FS(Dr, Fr, i, l);
    }
    function PN(i, l) {
      if (typeof l == "function") {
        var g = l, S = i();
        return g(S), function() {
          g(null);
        };
      } else if (l != null) {
        var _ = l;
        _.hasOwnProperty("current") || c("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(_).join(", ") + "}");
        var F = i();
        return _.current = F, function() {
          _.current = null;
        };
      }
    }
    function zS(i, l, g) {
      typeof l != "function" && c("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", l !== null ? typeof l : "null");
      var S = g != null ? g.concat([i]) : null, _ = Dr;
      return _ |= Es, (as.mode & Fi) !== Sn && (_ |= Wn), a4(_, Fr, PN.bind(null, l, i), S);
    }
    function BS(i, l, g) {
      typeof l != "function" && c("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", l !== null ? typeof l : "null");
      var S = g != null ? g.concat([i]) : null;
      return FS(Dr, Fr, PN.bind(null, l, i), S);
    }
    function fT(i, l) {
    }
    var Kx = fT;
    function l4(i, l) {
      var g = tp(), S = l === void 0 ? null : l;
      return g.memoizedState = [i, S], i;
    }
    function c4(i, l) {
      var g = eh(), S = l === void 0 ? null : l, _ = g.memoizedState;
      if (_ !== null && S !== null) {
        var F = _[1];
        if (AC(S, F))
          return _[0];
      }
      return g.memoizedState = [i, S], i;
    }
    function BC(i, l) {
      var g = tp(), S = l === void 0 ? null : l, _ = i();
      return g.memoizedState = [_, S], _;
    }
    function HS(i, l) {
      var g = eh(), S = l === void 0 ? null : l, _ = g.memoizedState;
      if (_ !== null && S !== null) {
        var F = _[1];
        if (AC(S, F))
          return _[0];
      }
      var Y = i();
      return g.memoizedState = [Y, S], Y;
    }
    function HC(i) {
      var l = tp();
      return l.memoizedState = i, i;
    }
    function ON(i) {
      var l = eh(), g = kl, S = g.memoizedState;
      return AN(l, S, i);
    }
    function VC(i) {
      var l = eh();
      if (kl === null)
        return l.memoizedState = i, i;
      var g = kl.memoizedState;
      return AN(l, g, i);
    }
    function AN(i, l, g) {
      var S = !hx(i1);
      if (S) {
        if (!Rn(g, l)) {
          var _ = G();
          as.lanes = ct(as.lanes, _), y7(_), i.baseState = !0;
        }
        return l;
      } else
        return i.baseState && (i.baseState = !1, s7()), i.memoizedState = g, g;
    }
    function mT(i, l, g) {
      var S = xd();
      ki(Mw(S, Xc)), i(!0);
      var _ = Jb.transition;
      Jb.transition = {};
      var F = Jb.transition;
      Jb.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        i(!1), l();
      } finally {
        if (ki(S), Jb.transition = _, _ === null && F._updatedFibers) {
          var Y = F._updatedFibers.size;
          Y > 10 && o("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), F._updatedFibers.clear();
        }
      }
    }
    function VS() {
      var i = LS(!1), l = i[0], g = i[1], S = mT.bind(null, g), _ = tp();
      return _.memoizedState = S, [l, S];
    }
    function u4() {
      var i = UC(), l = i[0], g = eh(), S = g.memoizedState;
      return [l, S];
    }
    function LN() {
      var i = r4(), l = i[0], g = eh(), S = g.memoizedState;
      return [l, S];
    }
    var IN = !1;
    function hT() {
      return IN;
    }
    function $C() {
      var i = tp(), l = JN(), g = l.identifierPrefix, S;
      if (Wl()) {
        var _ = Q_();
        S = ":" + g + "R" + _;
        var F = dv++;
        F > 0 && (S += "H" + F.toString(32)), S += ":";
      } else {
        var Y = dT++;
        S = ":" + g + "r" + Y.toString(32) + ":";
      }
      return i.memoizedState = S, S;
    }
    function d4() {
      var i = eh(), l = i.memoizedState;
      return l;
    }
    function FN(i, l, g) {
      typeof arguments[3] == "function" && c("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var S = t2(i), _ = {
        lane: S,
        action: g,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (GC(i))
        WC(l, _);
      else {
        var F = $b(i, l, _, S);
        if (F !== null) {
          var Y = om();
          cu(F, i, S, Y), YC(F, l, S);
        }
      }
      qC(i, S);
    }
    function UN(i, l, g) {
      typeof arguments[3] == "function" && c("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var S = t2(i), _ = {
        lane: S,
        action: g,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (GC(i))
        WC(l, _);
      else {
        var F = i.alternate;
        if (i.lanes === St && (F === null || F.lanes === St)) {
          var Y = l.lastRenderedReducer;
          if (Y !== null) {
            var ee;
            ee = Cn.current, Cn.current = th;
            try {
              var ie = l.lastRenderedState, xe = Y(ie, g);
              if (_.hasEagerState = !0, _.eagerState = xe, Rn(xe, ie)) {
                bN(i, l, _, S);
                return;
              }
            } catch {
            } finally {
              Cn.current = ee;
            }
          }
        }
        var we = $b(i, l, _, S);
        if (we !== null) {
          var Le = om();
          cu(we, i, S, Le), YC(we, l, S);
        }
      }
      qC(i, S);
    }
    function GC(i) {
      var l = i.alternate;
      return i === as || l !== null && l === as;
    }
    function WC(i, l) {
      qx = MS = !0;
      var g = i.pending;
      g === null ? l.next = l : (l.next = g.next, g.next = l), i.pending = l;
    }
    function YC(i, l, g) {
      if (B(g)) {
        var S = l.lanes;
        S = Ga(S, i.pendingLanes);
        var _ = ct(S, g);
        l.lanes = _, pr(i, _);
      }
    }
    function qC(i, l, g) {
      Ph(i, l);
    }
    var f4 = {
      readContext: El,
      useCallback: Jo,
      useContext: Jo,
      useEffect: Jo,
      useImperativeHandle: Jo,
      useInsertionEffect: Jo,
      useLayoutEffect: Jo,
      useMemo: Jo,
      useReducer: Jo,
      useRef: Jo,
      useState: Jo,
      useDebugValue: Jo,
      useDeferredValue: Jo,
      useTransition: Jo,
      useMutableSource: Jo,
      useSyncExternalStore: Jo,
      useId: Jo,
      unstable_isNewReconciler: oe
    }, KC = null, XC = null, QC = null, ZC = null, np = null, th = null, m4 = null;
    {
      var $S = function() {
        c("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Er = function() {
        c("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      KC = {
        readContext: function(i) {
          return El(i);
        },
        useCallback: function(i, l) {
          return gt = "useCallback", fs(), o1(l), l4(i, l);
        },
        useContext: function(i) {
          return gt = "useContext", fs(), El(i);
        },
        useEffect: function(i, l) {
          return gt = "useEffect", fs(), o1(l), s4(i, l);
        },
        useImperativeHandle: function(i, l, g) {
          return gt = "useImperativeHandle", fs(), o1(g), zS(i, l, g);
        },
        useInsertionEffect: function(i, l) {
          return gt = "useInsertionEffect", fs(), o1(l), zC(i, l);
        },
        useLayoutEffect: function(i, l) {
          return gt = "useLayoutEffect", fs(), o1(l), i4(i, l);
        },
        useMemo: function(i, l) {
          gt = "useMemo", fs(), o1(l);
          var g = Cn.current;
          Cn.current = np;
          try {
            return BC(i, l);
          } finally {
            Cn.current = g;
          }
        },
        useReducer: function(i, l, g) {
          gt = "useReducer", fs();
          var S = Cn.current;
          Cn.current = np;
          try {
            return IC(i, l, g);
          } finally {
            Cn.current = S;
          }
        },
        useRef: function(i) {
          return gt = "useRef", fs(), l1(i);
        },
        useState: function(i) {
          gt = "useState", fs();
          var l = Cn.current;
          Cn.current = np;
          try {
            return LS(i);
          } finally {
            Cn.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return gt = "useDebugValue", fs(), void 0;
        },
        useDeferredValue: function(i) {
          return gt = "useDeferredValue", fs(), HC(i);
        },
        useTransition: function() {
          return gt = "useTransition", fs(), VS();
        },
        useMutableSource: function(i, l, g) {
          return gt = "useMutableSource", fs(), void 0;
        },
        useSyncExternalStore: function(i, l, g) {
          return gt = "useSyncExternalStore", fs(), PS(i, l, g);
        },
        useId: function() {
          return gt = "useId", fs(), $C();
        },
        unstable_isNewReconciler: oe
      }, XC = {
        readContext: function(i) {
          return El(i);
        },
        useCallback: function(i, l) {
          return gt = "useCallback", cn(), l4(i, l);
        },
        useContext: function(i) {
          return gt = "useContext", cn(), El(i);
        },
        useEffect: function(i, l) {
          return gt = "useEffect", cn(), s4(i, l);
        },
        useImperativeHandle: function(i, l, g) {
          return gt = "useImperativeHandle", cn(), zS(i, l, g);
        },
        useInsertionEffect: function(i, l) {
          return gt = "useInsertionEffect", cn(), zC(i, l);
        },
        useLayoutEffect: function(i, l) {
          return gt = "useLayoutEffect", cn(), i4(i, l);
        },
        useMemo: function(i, l) {
          gt = "useMemo", cn();
          var g = Cn.current;
          Cn.current = np;
          try {
            return BC(i, l);
          } finally {
            Cn.current = g;
          }
        },
        useReducer: function(i, l, g) {
          gt = "useReducer", cn();
          var S = Cn.current;
          Cn.current = np;
          try {
            return IC(i, l, g);
          } finally {
            Cn.current = S;
          }
        },
        useRef: function(i) {
          return gt = "useRef", cn(), l1(i);
        },
        useState: function(i) {
          gt = "useState", cn();
          var l = Cn.current;
          Cn.current = np;
          try {
            return LS(i);
          } finally {
            Cn.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return gt = "useDebugValue", cn(), void 0;
        },
        useDeferredValue: function(i) {
          return gt = "useDeferredValue", cn(), HC(i);
        },
        useTransition: function() {
          return gt = "useTransition", cn(), VS();
        },
        useMutableSource: function(i, l, g) {
          return gt = "useMutableSource", cn(), void 0;
        },
        useSyncExternalStore: function(i, l, g) {
          return gt = "useSyncExternalStore", cn(), PS(i, l, g);
        },
        useId: function() {
          return gt = "useId", cn(), $C();
        },
        unstable_isNewReconciler: oe
      }, QC = {
        readContext: function(i) {
          return El(i);
        },
        useCallback: function(i, l) {
          return gt = "useCallback", cn(), c4(i, l);
        },
        useContext: function(i) {
          return gt = "useContext", cn(), El(i);
        },
        useEffect: function(i, l) {
          return gt = "useEffect", cn(), mv(i, l);
        },
        useImperativeHandle: function(i, l, g) {
          return gt = "useImperativeHandle", cn(), BS(i, l, g);
        },
        useInsertionEffect: function(i, l) {
          return gt = "useInsertionEffect", cn(), US(i, l);
        },
        useLayoutEffect: function(i, l) {
          return gt = "useLayoutEffect", cn(), o4(i, l);
        },
        useMemo: function(i, l) {
          gt = "useMemo", cn();
          var g = Cn.current;
          Cn.current = th;
          try {
            return HS(i, l);
          } finally {
            Cn.current = g;
          }
        },
        useReducer: function(i, l, g) {
          gt = "useReducer", cn();
          var S = Cn.current;
          Cn.current = th;
          try {
            return n4(i, l, g);
          } finally {
            Cn.current = S;
          }
        },
        useRef: function(i) {
          return gt = "useRef", cn(), IS();
        },
        useState: function(i) {
          gt = "useState", cn();
          var l = Cn.current;
          Cn.current = th;
          try {
            return UC(i);
          } finally {
            Cn.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return gt = "useDebugValue", cn(), Kx();
        },
        useDeferredValue: function(i) {
          return gt = "useDeferredValue", cn(), ON(i);
        },
        useTransition: function() {
          return gt = "useTransition", cn(), u4();
        },
        useMutableSource: function(i, l, g) {
          return gt = "useMutableSource", cn(), void 0;
        },
        useSyncExternalStore: function(i, l, g) {
          return gt = "useSyncExternalStore", cn(), OS(i, l);
        },
        useId: function() {
          return gt = "useId", cn(), d4();
        },
        unstable_isNewReconciler: oe
      }, ZC = {
        readContext: function(i) {
          return El(i);
        },
        useCallback: function(i, l) {
          return gt = "useCallback", cn(), c4(i, l);
        },
        useContext: function(i) {
          return gt = "useContext", cn(), El(i);
        },
        useEffect: function(i, l) {
          return gt = "useEffect", cn(), mv(i, l);
        },
        useImperativeHandle: function(i, l, g) {
          return gt = "useImperativeHandle", cn(), BS(i, l, g);
        },
        useInsertionEffect: function(i, l) {
          return gt = "useInsertionEffect", cn(), US(i, l);
        },
        useLayoutEffect: function(i, l) {
          return gt = "useLayoutEffect", cn(), o4(i, l);
        },
        useMemo: function(i, l) {
          gt = "useMemo", cn();
          var g = Cn.current;
          Cn.current = m4;
          try {
            return HS(i, l);
          } finally {
            Cn.current = g;
          }
        },
        useReducer: function(i, l, g) {
          gt = "useReducer", cn();
          var S = Cn.current;
          Cn.current = m4;
          try {
            return FC(i, l, g);
          } finally {
            Cn.current = S;
          }
        },
        useRef: function(i) {
          return gt = "useRef", cn(), IS();
        },
        useState: function(i) {
          gt = "useState", cn();
          var l = Cn.current;
          Cn.current = m4;
          try {
            return r4(i);
          } finally {
            Cn.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return gt = "useDebugValue", cn(), Kx();
        },
        useDeferredValue: function(i) {
          return gt = "useDeferredValue", cn(), VC(i);
        },
        useTransition: function() {
          return gt = "useTransition", cn(), LN();
        },
        useMutableSource: function(i, l, g) {
          return gt = "useMutableSource", cn(), void 0;
        },
        useSyncExternalStore: function(i, l, g) {
          return gt = "useSyncExternalStore", cn(), OS(i, l);
        },
        useId: function() {
          return gt = "useId", cn(), d4();
        },
        unstable_isNewReconciler: oe
      }, np = {
        readContext: function(i) {
          return $S(), El(i);
        },
        useCallback: function(i, l) {
          return gt = "useCallback", Er(), fs(), l4(i, l);
        },
        useContext: function(i) {
          return gt = "useContext", Er(), fs(), El(i);
        },
        useEffect: function(i, l) {
          return gt = "useEffect", Er(), fs(), s4(i, l);
        },
        useImperativeHandle: function(i, l, g) {
          return gt = "useImperativeHandle", Er(), fs(), zS(i, l, g);
        },
        useInsertionEffect: function(i, l) {
          return gt = "useInsertionEffect", Er(), fs(), zC(i, l);
        },
        useLayoutEffect: function(i, l) {
          return gt = "useLayoutEffect", Er(), fs(), i4(i, l);
        },
        useMemo: function(i, l) {
          gt = "useMemo", Er(), fs();
          var g = Cn.current;
          Cn.current = np;
          try {
            return BC(i, l);
          } finally {
            Cn.current = g;
          }
        },
        useReducer: function(i, l, g) {
          gt = "useReducer", Er(), fs();
          var S = Cn.current;
          Cn.current = np;
          try {
            return IC(i, l, g);
          } finally {
            Cn.current = S;
          }
        },
        useRef: function(i) {
          return gt = "useRef", Er(), fs(), l1(i);
        },
        useState: function(i) {
          gt = "useState", Er(), fs();
          var l = Cn.current;
          Cn.current = np;
          try {
            return LS(i);
          } finally {
            Cn.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return gt = "useDebugValue", Er(), fs(), void 0;
        },
        useDeferredValue: function(i) {
          return gt = "useDeferredValue", Er(), fs(), HC(i);
        },
        useTransition: function() {
          return gt = "useTransition", Er(), fs(), VS();
        },
        useMutableSource: function(i, l, g) {
          return gt = "useMutableSource", Er(), fs(), void 0;
        },
        useSyncExternalStore: function(i, l, g) {
          return gt = "useSyncExternalStore", Er(), fs(), PS(i, l, g);
        },
        useId: function() {
          return gt = "useId", Er(), fs(), $C();
        },
        unstable_isNewReconciler: oe
      }, th = {
        readContext: function(i) {
          return $S(), El(i);
        },
        useCallback: function(i, l) {
          return gt = "useCallback", Er(), cn(), c4(i, l);
        },
        useContext: function(i) {
          return gt = "useContext", Er(), cn(), El(i);
        },
        useEffect: function(i, l) {
          return gt = "useEffect", Er(), cn(), mv(i, l);
        },
        useImperativeHandle: function(i, l, g) {
          return gt = "useImperativeHandle", Er(), cn(), BS(i, l, g);
        },
        useInsertionEffect: function(i, l) {
          return gt = "useInsertionEffect", Er(), cn(), US(i, l);
        },
        useLayoutEffect: function(i, l) {
          return gt = "useLayoutEffect", Er(), cn(), o4(i, l);
        },
        useMemo: function(i, l) {
          gt = "useMemo", Er(), cn();
          var g = Cn.current;
          Cn.current = th;
          try {
            return HS(i, l);
          } finally {
            Cn.current = g;
          }
        },
        useReducer: function(i, l, g) {
          gt = "useReducer", Er(), cn();
          var S = Cn.current;
          Cn.current = th;
          try {
            return n4(i, l, g);
          } finally {
            Cn.current = S;
          }
        },
        useRef: function(i) {
          return gt = "useRef", Er(), cn(), IS();
        },
        useState: function(i) {
          gt = "useState", Er(), cn();
          var l = Cn.current;
          Cn.current = th;
          try {
            return UC(i);
          } finally {
            Cn.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return gt = "useDebugValue", Er(), cn(), Kx();
        },
        useDeferredValue: function(i) {
          return gt = "useDeferredValue", Er(), cn(), ON(i);
        },
        useTransition: function() {
          return gt = "useTransition", Er(), cn(), u4();
        },
        useMutableSource: function(i, l, g) {
          return gt = "useMutableSource", Er(), cn(), void 0;
        },
        useSyncExternalStore: function(i, l, g) {
          return gt = "useSyncExternalStore", Er(), cn(), OS(i, l);
        },
        useId: function() {
          return gt = "useId", Er(), cn(), d4();
        },
        unstable_isNewReconciler: oe
      }, m4 = {
        readContext: function(i) {
          return $S(), El(i);
        },
        useCallback: function(i, l) {
          return gt = "useCallback", Er(), cn(), c4(i, l);
        },
        useContext: function(i) {
          return gt = "useContext", Er(), cn(), El(i);
        },
        useEffect: function(i, l) {
          return gt = "useEffect", Er(), cn(), mv(i, l);
        },
        useImperativeHandle: function(i, l, g) {
          return gt = "useImperativeHandle", Er(), cn(), BS(i, l, g);
        },
        useInsertionEffect: function(i, l) {
          return gt = "useInsertionEffect", Er(), cn(), US(i, l);
        },
        useLayoutEffect: function(i, l) {
          return gt = "useLayoutEffect", Er(), cn(), o4(i, l);
        },
        useMemo: function(i, l) {
          gt = "useMemo", Er(), cn();
          var g = Cn.current;
          Cn.current = th;
          try {
            return HS(i, l);
          } finally {
            Cn.current = g;
          }
        },
        useReducer: function(i, l, g) {
          gt = "useReducer", Er(), cn();
          var S = Cn.current;
          Cn.current = th;
          try {
            return FC(i, l, g);
          } finally {
            Cn.current = S;
          }
        },
        useRef: function(i) {
          return gt = "useRef", Er(), cn(), IS();
        },
        useState: function(i) {
          gt = "useState", Er(), cn();
          var l = Cn.current;
          Cn.current = th;
          try {
            return r4(i);
          } finally {
            Cn.current = l;
          }
        },
        useDebugValue: function(i, l) {
          return gt = "useDebugValue", Er(), cn(), Kx();
        },
        useDeferredValue: function(i) {
          return gt = "useDeferredValue", Er(), cn(), VC(i);
        },
        useTransition: function() {
          return gt = "useTransition", Er(), cn(), LN();
        },
        useMutableSource: function(i, l, g) {
          return gt = "useMutableSource", Er(), cn(), void 0;
        },
        useSyncExternalStore: function(i, l, g) {
          return gt = "useSyncExternalStore", Er(), cn(), OS(i, l);
        },
        useId: function() {
          return gt = "useId", Er(), cn(), d4();
        },
        unstable_isNewReconciler: oe
      };
    }
    var Pg = t.unstable_now, JC = 0, Xx = -1, h4 = -1, GS = -1, e7 = !1, WS = !1;
    function d() {
      return e7;
    }
    function h() {
      WS = !0;
    }
    function C() {
      e7 = !1, WS = !1;
    }
    function M() {
      e7 = WS, WS = !1;
    }
    function A() {
      return JC;
    }
    function W() {
      JC = Pg();
    }
    function ae(i) {
      h4 = Pg(), i.actualStartTime < 0 && (i.actualStartTime = Pg());
    }
    function de(i) {
      h4 = -1;
    }
    function ge(i, l) {
      if (h4 >= 0) {
        var g = Pg() - h4;
        i.actualDuration += g, l && (i.selfBaseDuration = g), h4 = -1;
      }
    }
    function Ce(i) {
      if (Xx >= 0) {
        var l = Pg() - Xx;
        Xx = -1;
        for (var g = i.return; g !== null; ) {
          switch (g.tag) {
            case w:
              var S = g.stateNode;
              S.effectDuration += l;
              return;
            case U:
              var _ = g.stateNode;
              _.effectDuration += l;
              return;
          }
          g = g.return;
        }
      }
    }
    function Me(i) {
      if (GS >= 0) {
        var l = Pg() - GS;
        GS = -1;
        for (var g = i.return; g !== null; ) {
          switch (g.tag) {
            case w:
              var S = g.stateNode;
              S !== null && (S.passiveEffectDuration += l);
              return;
            case U:
              var _ = g.stateNode;
              _ !== null && (_.passiveEffectDuration += l);
              return;
          }
          g = g.return;
        }
      }
    }
    function $e() {
      Xx = Pg();
    }
    function at() {
      GS = Pg();
    }
    function yt(i) {
      for (var l = i.child; l; )
        i.actualDuration += l.actualDuration, l = l.sibling;
    }
    function Ct(i, l) {
      if (i && i.defaultProps) {
        var g = ir({}, l), S = i.defaultProps;
        for (var _ in S)
          g[_] === void 0 && (g[_] = S[_]);
        return g;
      }
      return l;
    }
    var Et = {}, Pn, yr, Zn, ms, fa, Qe, mt, Ke, $t, Un, gn;
    {
      Pn = /* @__PURE__ */ new Set(), yr = /* @__PURE__ */ new Set(), Zn = /* @__PURE__ */ new Set(), ms = /* @__PURE__ */ new Set(), Ke = /* @__PURE__ */ new Set(), fa = /* @__PURE__ */ new Set(), $t = /* @__PURE__ */ new Set(), Un = /* @__PURE__ */ new Set(), gn = /* @__PURE__ */ new Set();
      var ma = /* @__PURE__ */ new Set();
      mt = function(i, l) {
        if (!(i === null || typeof i == "function")) {
          var g = l + "_" + i;
          ma.has(g) || (ma.add(g), c("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", l, i));
        }
      }, Qe = function(i, l) {
        if (l === void 0) {
          var g = Qa(i) || "Component";
          fa.has(g) || (fa.add(g), c("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", g));
        }
      }, Object.defineProperty(Et, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Et);
    }
    function Sr(i, l, g, S) {
      var _ = i.memoizedState, F = g(S, _);
      {
        if (i.mode & $r) {
          ya(!0);
          try {
            F = g(S, _);
          } finally {
            ya(!1);
          }
        }
        Qe(l, F);
      }
      var Y = F == null ? _ : ir({}, _, F);
      if (i.memoizedState = Y, i.lanes === St) {
        var ee = i.updateQueue;
        ee.baseState = Y;
      }
    }
    var _a = {
      isMounted: mc,
      enqueueSetState: function(i, l, g) {
        var S = $c(i), _ = om(), F = t2(S), Y = Wu(_, F);
        Y.payload = l, g != null && (mt(g, "setState"), Y.callback = g);
        var ee = Rg(S, Y, F);
        ee !== null && (cu(ee, S, F, _), wS(ee, S, F)), Ph(S, F);
      },
      enqueueReplaceState: function(i, l, g) {
        var S = $c(i), _ = om(), F = t2(S), Y = Wu(_, F);
        Y.tag = SN, Y.payload = l, g != null && (mt(g, "replaceState"), Y.callback = g);
        var ee = Rg(S, Y, F);
        ee !== null && (cu(ee, S, F, _), wS(ee, S, F)), Ph(S, F);
      },
      enqueueForceUpdate: function(i, l) {
        var g = $c(i), S = om(), _ = t2(g), F = Wu(S, _);
        F.tag = SS, l != null && (mt(l, "forceUpdate"), F.callback = l);
        var Y = Rg(g, F, _);
        Y !== null && (cu(Y, g, _, S), wS(Y, g, _)), Fp(g, _);
      }
    };
    function ua(i, l, g, S, _, F, Y) {
      var ee = i.stateNode;
      if (typeof ee.shouldComponentUpdate == "function") {
        var ie = ee.shouldComponentUpdate(S, F, Y);
        {
          if (i.mode & $r) {
            ya(!0);
            try {
              ie = ee.shouldComponentUpdate(S, F, Y);
            } finally {
              ya(!1);
            }
          }
          ie === void 0 && c("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Qa(l) || "Component");
        }
        return ie;
      }
      return l.prototype && l.prototype.isPureReactComponent ? !sr(g, S) || !sr(_, F) : !0;
    }
    function ci(i, l, g) {
      var S = i.stateNode;
      {
        var _ = Qa(l) || "Component", F = S.render;
        F || (l.prototype && typeof l.prototype.render == "function" ? c("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", _) : c("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", _)), S.getInitialState && !S.getInitialState.isReactClassApproved && !S.state && c("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", _), S.getDefaultProps && !S.getDefaultProps.isReactClassApproved && c("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", _), S.propTypes && c("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", _), S.contextType && c("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", _), l.childContextTypes && !gn.has(l) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (i.mode & $r) === Sn && (gn.add(l), c(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, _)), l.contextTypes && !gn.has(l) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (i.mode & $r) === Sn && (gn.add(l), c(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, _)), S.contextTypes && c("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", _), l.contextType && l.contextTypes && !$t.has(l) && ($t.add(l), c("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", _)), typeof S.componentShouldUpdate == "function" && c("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", _), l.prototype && l.prototype.isPureReactComponent && typeof S.shouldComponentUpdate < "u" && c("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Qa(l) || "A pure component"), typeof S.componentDidUnmount == "function" && c("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", _), typeof S.componentDidReceiveProps == "function" && c("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", _), typeof S.componentWillRecieveProps == "function" && c("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", _), typeof S.UNSAFE_componentWillRecieveProps == "function" && c("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", _);
        var Y = S.props !== g;
        S.props !== void 0 && Y && c("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", _, _), S.defaultProps && c("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", _, _), typeof S.getSnapshotBeforeUpdate == "function" && typeof S.componentDidUpdate != "function" && !Zn.has(l) && (Zn.add(l), c("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Qa(l))), typeof S.getDerivedStateFromProps == "function" && c("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", _), typeof S.getDerivedStateFromError == "function" && c("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", _), typeof l.getSnapshotBeforeUpdate == "function" && c("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", _);
        var ee = S.state;
        ee && (typeof ee != "object" || Ja(ee)) && c("%s.state: must be set to an object or null", _), typeof S.getChildContext == "function" && typeof l.childContextTypes != "object" && c("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", _);
      }
    }
    function lr(i, l) {
      l.updater = _a, i.stateNode = l, hi(l, i), l._reactInternalInstance = Et;
    }
    function lo(i, l, g) {
      var S = !1, _ = tm, F = tm, Y = l.contextType;
      if ("contextType" in l) {
        var ee = (
          // Allow null for conditional declaration
          Y === null || Y !== void 0 && Y.$$typeof === _t && Y._context === void 0
        );
        if (!ee && !Un.has(l)) {
          Un.add(l);
          var ie = "";
          Y === void 0 ? ie = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof Y != "object" ? ie = " However, it is set to a " + typeof Y + "." : Y.$$typeof === _e ? ie = " Did you accidentally pass the Context.Provider instead?" : Y._context !== void 0 ? ie = " Did you accidentally pass the Context.Consumer instead?" : ie = " However, it is set to an object with keys {" + Object.keys(Y).join(", ") + "}.", c("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Qa(l) || "Component", ie);
        }
      }
      if (typeof Y == "object" && Y !== null)
        F = El(Y);
      else {
        _ = Ox(i, l, !0);
        var xe = l.contextTypes;
        S = xe != null, F = S ? Ax(i, _) : tm;
      }
      var we = new l(g, F);
      if (i.mode & $r) {
        ya(!0);
        try {
          we = new l(g, F);
        } finally {
          ya(!1);
        }
      }
      var Le = i.memoizedState = we.state !== null && we.state !== void 0 ? we.state : null;
      lr(i, we);
      {
        if (typeof l.getDerivedStateFromProps == "function" && Le === null) {
          var Ae = Qa(l) || "Component";
          yr.has(Ae) || (yr.add(Ae), c("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Ae, we.state === null ? "null" : "undefined", Ae));
        }
        if (typeof l.getDerivedStateFromProps == "function" || typeof we.getSnapshotBeforeUpdate == "function") {
          var et = null, nt = null, dt = null;
          if (typeof we.componentWillMount == "function" && we.componentWillMount.__suppressDeprecationWarning !== !0 ? et = "componentWillMount" : typeof we.UNSAFE_componentWillMount == "function" && (et = "UNSAFE_componentWillMount"), typeof we.componentWillReceiveProps == "function" && we.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? nt = "componentWillReceiveProps" : typeof we.UNSAFE_componentWillReceiveProps == "function" && (nt = "UNSAFE_componentWillReceiveProps"), typeof we.componentWillUpdate == "function" && we.componentWillUpdate.__suppressDeprecationWarning !== !0 ? dt = "componentWillUpdate" : typeof we.UNSAFE_componentWillUpdate == "function" && (dt = "UNSAFE_componentWillUpdate"), et !== null || nt !== null || dt !== null) {
            var xn = Qa(l) || "Component", fr = typeof l.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            ms.has(xn) || (ms.add(xn), c(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, xn, fr, et !== null ? `
  ` + et : "", nt !== null ? `
  ` + nt : "", dt !== null ? `
  ` + dt : ""));
          }
        }
      }
      return S && vC(i, _, F), we;
    }
    function Yu(i, l) {
      var g = l.state;
      typeof l.componentWillMount == "function" && l.componentWillMount(), typeof l.UNSAFE_componentWillMount == "function" && l.UNSAFE_componentWillMount(), g !== l.state && (c("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Nr(i) || "Component"), _a.enqueueReplaceState(l, l.state, null));
    }
    function Nc(i, l, g, S) {
      var _ = l.state;
      if (typeof l.componentWillReceiveProps == "function" && l.componentWillReceiveProps(g, S), typeof l.UNSAFE_componentWillReceiveProps == "function" && l.UNSAFE_componentWillReceiveProps(g, S), l.state !== _) {
        {
          var F = Nr(i) || "Component";
          Pn.has(F) || (Pn.add(F), c("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", F));
        }
        _a.enqueueReplaceState(l, l.state, null);
      }
    }
    function _d(i, l, g, S) {
      ci(i, l, g);
      var _ = i.stateNode;
      _.props = g, _.state = i.memoizedState, _.refs = {}, TC(i);
      var F = l.contextType;
      if (typeof F == "object" && F !== null)
        _.context = El(F);
      else {
        var Y = Ox(i, l, !0);
        _.context = Ax(i, Y);
      }
      {
        if (_.state === g) {
          var ee = Qa(l) || "Component";
          Ke.has(ee) || (Ke.add(ee), c("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", ee));
        }
        i.mode & $r && rm.recordLegacyContextWarning(i, _), rm.recordUnsafeLifecycleWarnings(i, _);
      }
      _.state = i.memoizedState;
      var ie = l.getDerivedStateFromProps;
      if (typeof ie == "function" && (Sr(i, l, ie, g), _.state = i.memoizedState), typeof l.getDerivedStateFromProps != "function" && typeof _.getSnapshotBeforeUpdate != "function" && (typeof _.UNSAFE_componentWillMount == "function" || typeof _.componentWillMount == "function") && (Yu(i, _), CS(i, g, _, S), _.state = i.memoizedState), typeof _.componentDidMount == "function") {
        var xe = Dr;
        xe |= Es, (i.mode & Fi) !== Sn && (xe |= Wn), i.flags |= xe;
      }
    }
    function Td(i, l, g, S) {
      var _ = i.stateNode, F = i.memoizedProps;
      _.props = F;
      var Y = _.context, ee = l.contextType, ie = tm;
      if (typeof ee == "object" && ee !== null)
        ie = El(ee);
      else {
        var xe = Ox(i, l, !0);
        ie = Ax(i, xe);
      }
      var we = l.getDerivedStateFromProps, Le = typeof we == "function" || typeof _.getSnapshotBeforeUpdate == "function";
      !Le && (typeof _.UNSAFE_componentWillReceiveProps == "function" || typeof _.componentWillReceiveProps == "function") && (F !== g || Y !== ie) && Nc(i, _, g, ie), CN();
      var Ae = i.memoizedState, et = _.state = Ae;
      if (CS(i, g, _, S), et = i.memoizedState, F === g && Ae === et && !nS() && !jS()) {
        if (typeof _.componentDidMount == "function") {
          var nt = Dr;
          nt |= Es, (i.mode & Fi) !== Sn && (nt |= Wn), i.flags |= nt;
        }
        return !1;
      }
      typeof we == "function" && (Sr(i, l, we, g), et = i.memoizedState);
      var dt = jS() || ua(i, l, F, g, Ae, et, ie);
      if (dt) {
        if (!Le && (typeof _.UNSAFE_componentWillMount == "function" || typeof _.componentWillMount == "function") && (typeof _.componentWillMount == "function" && _.componentWillMount(), typeof _.UNSAFE_componentWillMount == "function" && _.UNSAFE_componentWillMount()), typeof _.componentDidMount == "function") {
          var xn = Dr;
          xn |= Es, (i.mode & Fi) !== Sn && (xn |= Wn), i.flags |= xn;
        }
      } else {
        if (typeof _.componentDidMount == "function") {
          var fr = Dr;
          fr |= Es, (i.mode & Fi) !== Sn && (fr |= Wn), i.flags |= fr;
        }
        i.memoizedProps = g, i.memoizedState = et;
      }
      return _.props = g, _.state = et, _.context = ie, dt;
    }
    function Md(i, l, g, S, _) {
      var F = l.stateNode;
      wN(i, l);
      var Y = l.memoizedProps, ee = l.type === l.elementType ? Y : Ct(l.type, Y);
      F.props = ee;
      var ie = l.pendingProps, xe = F.context, we = g.contextType, Le = tm;
      if (typeof we == "object" && we !== null)
        Le = El(we);
      else {
        var Ae = Ox(l, g, !0);
        Le = Ax(l, Ae);
      }
      var et = g.getDerivedStateFromProps, nt = typeof et == "function" || typeof F.getSnapshotBeforeUpdate == "function";
      !nt && (typeof F.UNSAFE_componentWillReceiveProps == "function" || typeof F.componentWillReceiveProps == "function") && (Y !== ie || xe !== Le) && Nc(l, F, S, Le), CN();
      var dt = l.memoizedState, xn = F.state = dt;
      if (CS(l, S, F, _), xn = l.memoizedState, Y === ie && dt === xn && !nS() && !jS() && !ue)
        return typeof F.componentDidUpdate == "function" && (Y !== i.memoizedProps || dt !== i.memoizedState) && (l.flags |= Dr), typeof F.getSnapshotBeforeUpdate == "function" && (Y !== i.memoizedProps || dt !== i.memoizedState) && (l.flags |= lc), !1;
      typeof et == "function" && (Sr(l, g, et, S), xn = l.memoizedState);
      var fr = jS() || ua(l, g, ee, S, dt, xn, Le) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      ue;
      return fr ? (!nt && (typeof F.UNSAFE_componentWillUpdate == "function" || typeof F.componentWillUpdate == "function") && (typeof F.componentWillUpdate == "function" && F.componentWillUpdate(S, xn, Le), typeof F.UNSAFE_componentWillUpdate == "function" && F.UNSAFE_componentWillUpdate(S, xn, Le)), typeof F.componentDidUpdate == "function" && (l.flags |= Dr), typeof F.getSnapshotBeforeUpdate == "function" && (l.flags |= lc)) : (typeof F.componentDidUpdate == "function" && (Y !== i.memoizedProps || dt !== i.memoizedState) && (l.flags |= Dr), typeof F.getSnapshotBeforeUpdate == "function" && (Y !== i.memoizedProps || dt !== i.memoizedState) && (l.flags |= lc), l.memoizedProps = S, l.memoizedState = xn), F.props = S, F.state = xn, F.context = Le, fr;
    }
    function jo(i, l) {
      return {
        value: i,
        source: l,
        stack: Df(l),
        digest: null
      };
    }
    function rp(i, l, g) {
      return {
        value: i,
        source: null,
        stack: g ?? null,
        digest: l ?? null
      };
    }
    function Qx(i, l) {
      return !0;
    }
    function hv(i, l) {
      try {
        var g = Qx(i, l);
        if (g === !1)
          return;
        var S = l.value, _ = l.source, F = l.stack, Y = F !== null ? F : "";
        if (S != null && S._suppressLogging) {
          if (i.tag === y)
            return;
          console.error(S);
        }
        var ee = _ ? Nr(_) : null, ie = ee ? "The above error occurred in the <" + ee + "> component:" : "The above error occurred in one of your React components:", xe;
        if (i.tag === w)
          xe = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var we = Nr(i) || "Anonymous";
          xe = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + we + ".");
        }
        var Le = ie + `
` + Y + `

` + ("" + xe);
        console.error(Le);
      } catch (Ae) {
        setTimeout(function() {
          throw Ae;
        });
      }
    }
    var c1 = typeof WeakMap == "function" ? WeakMap : Map;
    function zN(i, l, g) {
      var S = Wu(da, g);
      S.tag = Gu, S.payload = {
        element: null
      };
      var _ = l.value;
      return S.callback = function() {
        gQ(_), hv(i, l);
      }, S;
    }
    function t7(i, l, g) {
      var S = Wu(da, g);
      S.tag = Gu;
      var _ = i.type.getDerivedStateFromError;
      if (typeof _ == "function") {
        var F = l.value;
        S.payload = function() {
          return _(F);
        }, S.callback = function() {
          oI(i), hv(i, l);
        };
      }
      var Y = i.stateNode;
      return Y !== null && typeof Y.componentDidCatch == "function" && (S.callback = function() {
        oI(i), hv(i, l), typeof _ != "function" && hQ(this);
        var ie = l.value, xe = l.stack;
        this.componentDidCatch(ie, {
          componentStack: xe !== null ? xe : ""
        }), typeof _ != "function" && (sn(i.lanes, hn) || c("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Nr(i) || "Unknown"));
      }), S;
    }
    function QA(i, l, g) {
      var S = i.pingCache, _;
      if (S === null ? (S = i.pingCache = new c1(), _ = /* @__PURE__ */ new Set(), S.set(l, _)) : (_ = S.get(l), _ === void 0 && (_ = /* @__PURE__ */ new Set(), S.set(l, _))), !_.has(g)) {
        _.add(g);
        var F = yQ.bind(null, i, l, g);
        gc && v7(i, g), l.then(F, F);
      }
    }
    function jK(i, l, g, S) {
      var _ = i.updateQueue;
      if (_ === null) {
        var F = /* @__PURE__ */ new Set();
        F.add(g), i.updateQueue = F;
      } else
        _.add(g);
    }
    function EK(i, l) {
      var g = i.tag;
      if ((i.mode & Mn) === Sn && (g === m || g === R || g === K)) {
        var S = i.alternate;
        S ? (i.updateQueue = S.updateQueue, i.memoizedState = S.memoizedState, i.lanes = S.lanes) : (i.updateQueue = null, i.memoizedState = null);
      }
    }
    function ZA(i) {
      var l = i;
      do {
        if (l.tag === z && _N(l))
          return l;
        l = l.return;
      } while (l !== null);
      return null;
    }
    function JA(i, l, g, S, _) {
      if ((i.mode & Mn) === Sn) {
        if (i === l)
          i.flags |= js;
        else {
          if (i.flags |= or, g.flags |= rf, g.flags &= ~(Mm | uc), g.tag === y) {
            var F = g.alternate;
            if (F === null)
              g.tag = Q;
            else {
              var Y = Wu(da, hn);
              Y.tag = SS, Rg(g, Y, hn);
            }
          }
          g.lanes = ct(g.lanes, hn);
        }
        return i;
      }
      return i.flags |= js, i.lanes = _, i;
    }
    function kK(i, l, g, S, _) {
      if (g.flags |= uc, gc && v7(i, _), S !== null && typeof S == "object" && typeof S.then == "function") {
        var F = S;
        EK(g), Wl() && g.mode & Mn && Ux();
        var Y = ZA(l);
        if (Y !== null) {
          Y.flags &= ~Gs, JA(Y, l, g, i, _), Y.mode & Mn && QA(i, F, _), jK(Y, i, F);
          return;
        } else {
          if (!y0(_)) {
            QA(i, F, _), YT();
            return;
          }
          var ee = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          S = ee;
        }
      } else if (Wl() && g.mode & Mn) {
        Ux();
        var ie = ZA(l);
        if (ie !== null) {
          (ie.flags & js) === mn && (ie.flags |= Gs), JA(ie, l, g, i, _), Bb(jo(S, g));
          return;
        }
      }
      S = jo(S, g), iQ(S);
      var xe = l;
      do {
        switch (xe.tag) {
          case w: {
            var we = S;
            xe.flags |= js;
            var Le = Fe(_);
            xe.lanes = ct(xe.lanes, Le);
            var Ae = zN(xe, we, Le);
            MC(xe, Ae);
            return;
          }
          case y:
            var et = S, nt = xe.type, dt = xe.stateNode;
            if ((xe.flags & or) === mn && (typeof nt.getDerivedStateFromError == "function" || dt !== null && typeof dt.componentDidCatch == "function" && !ZL(dt))) {
              xe.flags |= js;
              var xn = Fe(_);
              xe.lanes = ct(xe.lanes, xn);
              var fr = t7(xe, et, xn);
              MC(xe, fr);
              return;
            }
            break;
        }
        xe = xe.return;
      } while (xe !== null);
    }
    function _K() {
      return null;
    }
    var n7 = n.ReactCurrentOwner, Og = !1, pT, r7, gT, yT, vT, p4, xT, BN, a7;
    pT = {}, r7 = {}, gT = {}, yT = {}, vT = {}, p4 = !1, xT = {}, BN = {}, a7 = {};
    function sm(i, l, g, S) {
      i === null ? l.child = jC(l, null, g, S) : l.child = sv(l, i.child, g, S);
    }
    function TK(i, l, g, S) {
      l.child = sv(l, i.child, null, S), l.child = sv(l, null, g, S);
    }
    function eL(i, l, g, S, _) {
      if (l.type !== l.elementType) {
        var F = g.propTypes;
        F && Wm(
          F,
          S,
          // Resolved props
          "prop",
          Qa(g)
        );
      }
      var Y = g.render, ee = l.ref, ie, xe;
      Mg(l, _), Dm(l);
      {
        if (n7.current = l, ed(!0), ie = ep(i, l, Y, S, ee, _), xe = V0(), l.mode & $r) {
          ya(!0);
          try {
            ie = ep(i, l, Y, S, ee, _), xe = V0();
          } finally {
            ya(!1);
          }
        }
        ed(!1);
      }
      return ja(), i !== null && !Og ? (DS(i, l, _), pv(i, l, _)) : (Wl() && xe && wC(l), l.flags |= Gc, sm(i, l, ie, _), l.child);
    }
    function tL(i, l, g, S, _) {
      if (i === null) {
        var F = g.type;
        if (OQ(F) && g.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        g.defaultProps === void 0) {
          var Y = F;
          return Y = e8(F), l.tag = K, l.type = Y, wT(l, F), nL(i, l, Y, S, _);
        }
        {
          var ee = F.propTypes;
          if (ee && Wm(
            ee,
            S,
            // Resolved props
            "prop",
            Qa(F)
          ), g.defaultProps !== void 0) {
            var ie = Qa(F) || "Unknown";
            a7[ie] || (c("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", ie), a7[ie] = !0);
          }
        }
        var xe = aM(g.type, null, S, l, l.mode, _);
        return xe.ref = l.ref, xe.return = l, l.child = xe, xe;
      }
      {
        var we = g.type, Le = we.propTypes;
        Le && Wm(
          Le,
          S,
          // Resolved props
          "prop",
          Qa(we)
        );
      }
      var Ae = i.child, et = _T(i, _);
      if (!et) {
        var nt = Ae.memoizedProps, dt = g.compare;
        if (dt = dt !== null ? dt : sr, dt(nt, S) && i.ref === l.ref)
          return pv(i, l, _);
      }
      l.flags |= Gc;
      var xn = b4(Ae, S);
      return xn.ref = l.ref, xn.return = l, l.child = xn, xn;
    }
    function nL(i, l, g, S, _) {
      if (l.type !== l.elementType) {
        var F = l.elementType;
        if (F.$$typeof === Xn) {
          var Y = F, ee = Y._payload, ie = Y._init;
          try {
            F = ie(ee);
          } catch {
            F = null;
          }
          var xe = F && F.propTypes;
          xe && Wm(
            xe,
            S,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Qa(F)
          );
        }
      }
      if (i !== null) {
        var we = i.memoizedProps;
        if (sr(we, S) && i.ref === l.ref && // Prevent bailout if the implementation changed due to hot reload.
        l.type === i.type)
          if (Og = !1, l.pendingProps = S = we, _T(i, _))
            (i.flags & rf) !== mn && (Og = !0);
          else return l.lanes = i.lanes, pv(i, l, _);
      }
      return bT(i, l, g, S, _);
    }
    function rL(i, l, g) {
      var S = l.pendingProps, _ = S.children, F = i !== null ? i.memoizedState : null;
      if (S.mode === "hidden" || he)
        if ((l.mode & Mn) === Sn) {
          var Y = {
            baseLanes: St,
            cachePool: null,
            transitions: null
          };
          l.memoizedState = Y, ej(l, g);
        } else if (sn(g, So)) {
          var Le = {
            baseLanes: St,
            cachePool: null,
            transitions: null
          };
          l.memoizedState = Le;
          var Ae = F !== null ? F.baseLanes : g;
          ej(l, Ae);
        } else {
          var ee = null, ie;
          if (F !== null) {
            var xe = F.baseLanes;
            ie = ct(xe, g);
          } else
            ie = g;
          l.lanes = l.childLanes = So;
          var we = {
            baseLanes: ie,
            cachePool: ee,
            transitions: null
          };
          return l.memoizedState = we, l.updateQueue = null, ej(l, ie), null;
        }
      else {
        var et;
        F !== null ? (et = ct(F.baseLanes, g), l.memoizedState = null) : et = g, ej(l, et);
      }
      return sm(i, l, _, g), l.child;
    }
    function MK(i, l, g) {
      var S = l.pendingProps;
      return sm(i, l, S, g), l.child;
    }
    function RK(i, l, g) {
      var S = l.pendingProps.children;
      return sm(i, l, S, g), l.child;
    }
    function DK(i, l, g) {
      {
        l.flags |= Dr;
        {
          var S = l.stateNode;
          S.effectDuration = 0, S.passiveEffectDuration = 0;
        }
      }
      var _ = l.pendingProps, F = _.children;
      return sm(i, l, F, g), l.child;
    }
    function aL(i, l) {
      var g = l.ref;
      (i === null && g !== null || i !== null && i.ref !== g) && (l.flags |= Uo, l.flags |= Wc);
    }
    function bT(i, l, g, S, _) {
      if (l.type !== l.elementType) {
        var F = g.propTypes;
        F && Wm(
          F,
          S,
          // Resolved props
          "prop",
          Qa(g)
        );
      }
      var Y;
      {
        var ee = Ox(l, g, !0);
        Y = Ax(l, ee);
      }
      var ie, xe;
      Mg(l, _), Dm(l);
      {
        if (n7.current = l, ed(!0), ie = ep(i, l, g, S, Y, _), xe = V0(), l.mode & $r) {
          ya(!0);
          try {
            ie = ep(i, l, g, S, Y, _), xe = V0();
          } finally {
            ya(!1);
          }
        }
        ed(!1);
      }
      return ja(), i !== null && !Og ? (DS(i, l, _), pv(i, l, _)) : (Wl() && xe && wC(l), l.flags |= Gc, sm(i, l, ie, _), l.child);
    }
    function sL(i, l, g, S, _) {
      {
        switch (KQ(l)) {
          case !1: {
            var F = l.stateNode, Y = l.type, ee = new Y(l.memoizedProps, F.context), ie = ee.state;
            F.updater.enqueueSetState(F, ie, null);
            break;
          }
          case !0: {
            l.flags |= or, l.flags |= js;
            var xe = new Error("Simulated error coming from DevTools"), we = Fe(_);
            l.lanes = ct(l.lanes, we);
            var Le = t7(l, jo(xe, l), we);
            MC(l, Le);
            break;
          }
        }
        if (l.type !== l.elementType) {
          var Ae = g.propTypes;
          Ae && Wm(
            Ae,
            S,
            // Resolved props
            "prop",
            Qa(g)
          );
        }
      }
      var et;
      Yh(g) ? (et = !0, Nl(l)) : et = !1, Mg(l, _);
      var nt = l.stateNode, dt;
      nt === null ? (VN(i, l), lo(l, g, S), _d(l, g, S, _), dt = !0) : i === null ? dt = Td(l, g, S, _) : dt = Md(i, l, g, S, _);
      var xn = ST(i, l, g, dt, et, _);
      {
        var fr = l.stateNode;
        dt && fr.props !== S && (p4 || c("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Nr(l) || "a component"), p4 = !0);
      }
      return xn;
    }
    function ST(i, l, g, S, _, F) {
      aL(i, l);
      var Y = (l.flags & or) !== mn;
      if (!S && !Y)
        return _ && Ym(l, g, !1), pv(i, l, F);
      var ee = l.stateNode;
      n7.current = l;
      var ie;
      if (Y && typeof g.getDerivedStateFromError != "function")
        ie = null, de();
      else {
        Dm(l);
        {
          if (ed(!0), ie = ee.render(), l.mode & $r) {
            ya(!0);
            try {
              ee.render();
            } finally {
              ya(!1);
            }
          }
          ed(!1);
        }
        ja();
      }
      return l.flags |= Gc, i !== null && Y ? TK(i, l, ie, F) : sm(i, l, ie, F), l.memoizedState = ee.state, _ && Ym(l, g, !0), l.child;
    }
    function iL(i) {
      var l = i.stateNode;
      l.pendingContext ? rS(i, l.pendingContext, l.pendingContext !== l.context) : l.context && rS(i, l.context, !1), cv(i, l.containerInfo);
    }
    function PK(i, l, g) {
      if (iL(l), i === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var S = l.pendingProps, _ = l.memoizedState, F = _.element;
      wN(i, l), CS(l, S, null, g);
      var Y = l.memoizedState;
      l.stateNode;
      var ee = Y.element;
      if (_.isDehydrated) {
        var ie = {
          element: ee,
          isDehydrated: !1,
          cache: Y.cache,
          pendingSuspenseBoundaries: Y.pendingSuspenseBoundaries,
          transitions: Y.transitions
        }, xe = l.updateQueue;
        if (xe.baseState = ie, l.memoizedState = ie, l.flags & Gs) {
          var we = jo(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), l);
          return oL(i, l, ee, g, we);
        } else if (ee !== F) {
          var Le = jo(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), l);
          return oL(i, l, ee, g, Le);
        } else {
          nT(l);
          var Ae = jC(l, null, ee, g);
          l.child = Ae;
          for (var et = Ae; et; )
            et.flags = et.flags & ~ts | cc, et = et.sibling;
        }
      } else {
        if (rv(), ee === F)
          return pv(i, l, g);
        sm(i, l, ee, g);
      }
      return l.child;
    }
    function oL(i, l, g, S, _) {
      return rv(), Bb(_), l.flags |= Gs, sm(i, l, g, S), l.child;
    }
    function OK(i, l, g) {
      jN(l), i === null && zx(l);
      var S = l.type, _ = l.pendingProps, F = i !== null ? i.memoizedProps : null, Y = _.children, ee = aC(S, _);
      return ee ? Y = null : F !== null && aC(S, F) && (l.flags |= Oa), aL(i, l), sm(i, l, Y, g), l.child;
    }
    function AK(i, l) {
      return i === null && zx(l), null;
    }
    function LK(i, l, g, S) {
      VN(i, l);
      var _ = l.pendingProps, F = g, Y = F._payload, ee = F._init, ie = ee(Y);
      l.type = ie;
      var xe = l.tag = AQ(ie), we = Ct(ie, _), Le;
      switch (xe) {
        case m:
          return wT(l, ie), l.type = ie = e8(ie), Le = bT(null, l, ie, we, S), Le;
        case y:
          return l.type = ie = ZT(ie), Le = sL(null, l, ie, we, S), Le;
        case R:
          return l.type = ie = JT(ie), Le = eL(null, l, ie, we, S), Le;
        case H: {
          if (l.type !== l.elementType) {
            var Ae = ie.propTypes;
            Ae && Wm(
              Ae,
              we,
              // Resolved for outer only
              "prop",
              Qa(ie)
            );
          }
          return Le = tL(
            null,
            l,
            ie,
            Ct(ie.type, we),
            // The inner type can have defaults too
            S
          ), Le;
        }
      }
      var et = "";
      throw ie !== null && typeof ie == "object" && ie.$$typeof === Xn && (et = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + ie + ". " + ("Lazy element type must resolve to a class or function." + et));
    }
    function IK(i, l, g, S, _) {
      VN(i, l), l.tag = y;
      var F;
      return Yh(g) ? (F = !0, Nl(l)) : F = !1, Mg(l, _), lo(l, g, S), _d(l, g, S, _), ST(null, l, g, !0, F, _);
    }
    function FK(i, l, g, S) {
      VN(i, l);
      var _ = l.pendingProps, F;
      {
        var Y = Ox(l, g, !1);
        F = Ax(l, Y);
      }
      Mg(l, S);
      var ee, ie;
      Dm(l);
      {
        if (g.prototype && typeof g.prototype.render == "function") {
          var xe = Qa(g) || "Unknown";
          pT[xe] || (c("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", xe, xe), pT[xe] = !0);
        }
        l.mode & $r && rm.recordLegacyContextWarning(l, null), ed(!0), n7.current = l, ee = ep(null, l, g, _, F, S), ie = V0(), ed(!1);
      }
      if (ja(), l.flags |= Gc, typeof ee == "object" && ee !== null && typeof ee.render == "function" && ee.$$typeof === void 0) {
        var we = Qa(g) || "Unknown";
        r7[we] || (c("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", we, we, we), r7[we] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof ee == "object" && ee !== null && typeof ee.render == "function" && ee.$$typeof === void 0
      ) {
        {
          var Le = Qa(g) || "Unknown";
          r7[Le] || (c("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Le, Le, Le), r7[Le] = !0);
        }
        l.tag = y, l.memoizedState = null, l.updateQueue = null;
        var Ae = !1;
        return Yh(g) ? (Ae = !0, Nl(l)) : Ae = !1, l.memoizedState = ee.state !== null && ee.state !== void 0 ? ee.state : null, TC(l), lr(l, ee), _d(l, g, _, S), ST(null, l, g, !0, Ae, S);
      } else {
        if (l.tag = m, l.mode & $r) {
          ya(!0);
          try {
            ee = ep(null, l, g, _, F, S), ie = V0();
          } finally {
            ya(!1);
          }
        }
        return Wl() && ie && wC(l), sm(null, l, ee, S), wT(l, g), l.child;
      }
    }
    function wT(i, l) {
      {
        if (l && l.childContextTypes && c("%s(...): childContextTypes cannot be defined on a function component.", l.displayName || l.name || "Component"), i.ref !== null) {
          var g = "", S = tc();
          S && (g += `

Check the render method of \`` + S + "`.");
          var _ = S || "", F = i._debugSource;
          F && (_ = F.fileName + ":" + F.lineNumber), vT[_] || (vT[_] = !0, c("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", g));
        }
        if (l.defaultProps !== void 0) {
          var Y = Qa(l) || "Unknown";
          a7[Y] || (c("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", Y), a7[Y] = !0);
        }
        if (typeof l.getDerivedStateFromProps == "function") {
          var ee = Qa(l) || "Unknown";
          yT[ee] || (c("%s: Function components do not support getDerivedStateFromProps.", ee), yT[ee] = !0);
        }
        if (typeof l.contextType == "object" && l.contextType !== null) {
          var ie = Qa(l) || "Unknown";
          gT[ie] || (c("%s: Function components do not support contextType.", ie), gT[ie] = !0);
        }
      }
    }
    var CT = {
      dehydrated: null,
      treeContext: null,
      retryLane: Qs
    };
    function NT(i) {
      return {
        baseLanes: i,
        cachePool: _K(),
        transitions: null
      };
    }
    function UK(i, l) {
      var g = null;
      return {
        baseLanes: ct(i.baseLanes, l),
        cachePool: g,
        transitions: i.transitions
      };
    }
    function zK(i, l, g, S) {
      if (l !== null) {
        var _ = l.memoizedState;
        if (_ === null)
          return !1;
      }
      return kS(i, Zb);
    }
    function BK(i, l) {
      return xa(i.childLanes, l);
    }
    function lL(i, l, g) {
      var S = l.pendingProps;
      XQ(l) && (l.flags |= or);
      var _ = Qm.current, F = !1, Y = (l.flags & or) !== mn;
      if (Y || zK(_, i) ? (F = !0, l.flags &= ~or) : (i === null || i.memoizedState !== null) && (_ = s1(_, kN)), _ = Zm(_), H0(l, _), i === null) {
        zx(l);
        var ee = l.memoizedState;
        if (ee !== null) {
          var ie = ee.dehydrated;
          if (ie !== null)
            return WK(l, ie);
        }
        var xe = S.children, we = S.fallback;
        if (F) {
          var Le = HK(l, xe, we, g), Ae = l.child;
          return Ae.memoizedState = NT(g), l.memoizedState = CT, Le;
        } else
          return jT(l, xe);
      } else {
        var et = i.memoizedState;
        if (et !== null) {
          var nt = et.dehydrated;
          if (nt !== null)
            return YK(i, l, Y, S, nt, et, g);
        }
        if (F) {
          var dt = S.fallback, xn = S.children, fr = $K(i, l, xn, dt, g), qn = l.child, Ua = i.child.memoizedState;
          return qn.memoizedState = Ua === null ? NT(g) : UK(Ua, g), qn.childLanes = BK(i, g), l.memoizedState = CT, fr;
        } else {
          var ba = S.children, We = VK(i, l, ba, g);
          return l.memoizedState = null, We;
        }
      }
    }
    function jT(i, l, g) {
      var S = i.mode, _ = {
        mode: "visible",
        children: l
      }, F = ET(_, S);
      return F.return = i, i.child = F, F;
    }
    function HK(i, l, g, S) {
      var _ = i.mode, F = i.child, Y = {
        mode: "hidden",
        children: l
      }, ee, ie;
      return (_ & Mn) === Sn && F !== null ? (ee = F, ee.childLanes = St, ee.pendingProps = Y, i.mode & ar && (ee.actualDuration = 0, ee.actualStartTime = -1, ee.selfBaseDuration = 0, ee.treeBaseDuration = 0), ie = r2(g, _, S, null)) : (ee = ET(Y, _), ie = r2(g, _, S, null)), ee.return = i, ie.return = i, ee.sibling = ie, i.child = ee, ie;
    }
    function ET(i, l, g) {
      return cI(i, l, St, null);
    }
    function cL(i, l) {
      return b4(i, l);
    }
    function VK(i, l, g, S) {
      var _ = i.child, F = _.sibling, Y = cL(_, {
        mode: "visible",
        children: g
      });
      if ((l.mode & Mn) === Sn && (Y.lanes = S), Y.return = l, Y.sibling = null, F !== null) {
        var ee = l.deletions;
        ee === null ? (l.deletions = [F], l.flags |= Na) : ee.push(F);
      }
      return l.child = Y, Y;
    }
    function $K(i, l, g, S, _) {
      var F = l.mode, Y = i.child, ee = Y.sibling, ie = {
        mode: "hidden",
        children: g
      }, xe;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (F & Mn) === Sn && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        l.child !== Y
      ) {
        var we = l.child;
        xe = we, xe.childLanes = St, xe.pendingProps = ie, l.mode & ar && (xe.actualDuration = 0, xe.actualStartTime = -1, xe.selfBaseDuration = Y.selfBaseDuration, xe.treeBaseDuration = Y.treeBaseDuration), l.deletions = null;
      } else
        xe = cL(Y, ie), xe.subtreeFlags = Y.subtreeFlags & Ps;
      var Le;
      return ee !== null ? Le = b4(ee, S) : (Le = r2(S, F, _, null), Le.flags |= ts), Le.return = l, xe.return = l, xe.sibling = Le, l.child = xe, Le;
    }
    function HN(i, l, g, S) {
      S !== null && Bb(S), sv(l, i.child, null, g);
      var _ = l.pendingProps, F = _.children, Y = jT(l, F);
      return Y.flags |= ts, l.memoizedState = null, Y;
    }
    function GK(i, l, g, S, _) {
      var F = l.mode, Y = {
        mode: "visible",
        children: g
      }, ee = ET(Y, F), ie = r2(S, F, _, null);
      return ie.flags |= ts, ee.return = l, ie.return = l, ee.sibling = ie, l.child = ee, (l.mode & Mn) !== Sn && sv(l, i.child, null, _), ie;
    }
    function WK(i, l, g) {
      return (i.mode & Mn) === Sn ? (c("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), i.lanes = hn) : Y5(l) ? i.lanes = oi : i.lanes = So, null;
    }
    function YK(i, l, g, S, _, F, Y) {
      if (g)
        if (l.flags & Gs) {
          l.flags &= ~Gs;
          var We = rp(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return HN(i, l, Y, We);
        } else {
          if (l.memoizedState !== null)
            return l.child = i.child, l.flags |= or, null;
          var ft = S.children, Ye = S.fallback, Ut = GK(i, l, ft, Ye, Y), Tn = l.child;
          return Tn.memoizedState = NT(Y), l.memoizedState = CT, Ut;
        }
      else {
        if (lS(), (l.mode & Mn) === Sn)
          return HN(
            i,
            l,
            Y,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (Y5(_)) {
          var ee, ie, xe;
          {
            var we = B_(_);
            ee = we.digest, ie = we.message, xe = we.stack;
          }
          var Le;
          ie ? Le = new Error(ie) : Le = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var Ae = rp(Le, ee, xe);
          return HN(i, l, Y, Ae);
        }
        var et = sn(Y, i.childLanes);
        if (Og || et) {
          var nt = JN();
          if (nt !== null) {
            var dt = gr(nt, Y);
            if (dt !== Qs && dt !== F.retryLane) {
              F.retryLane = dt;
              var xn = da;
              Is(i, dt), cu(nt, i, dt, xn);
            }
          }
          YT();
          var fr = rp(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return HN(i, l, Y, fr);
        } else if (nN(_)) {
          l.flags |= or, l.child = i.child;
          var qn = vQ.bind(null, i);
          return rN(_, qn), null;
        } else {
          rT(l, _, F.treeContext);
          var Ua = S.children, ba = jT(l, Ua);
          return ba.flags |= cc, ba;
        }
      }
    }
    function uL(i, l, g) {
      i.lanes = ct(i.lanes, l);
      var S = i.alternate;
      S !== null && (S.lanes = ct(S.lanes, l)), ov(i.return, l, g);
    }
    function qK(i, l, g) {
      for (var S = l; S !== null; ) {
        if (S.tag === z) {
          var _ = S.memoizedState;
          _ !== null && uL(S, g, i);
        } else if (S.tag === X)
          uL(S, g, i);
        else if (S.child !== null) {
          S.child.return = S, S = S.child;
          continue;
        }
        if (S === i)
          return;
        for (; S.sibling === null; ) {
          if (S.return === null || S.return === i)
            return;
          S = S.return;
        }
        S.sibling.return = S.return, S = S.sibling;
      }
    }
    function KK(i) {
      for (var l = i, g = null; l !== null; ) {
        var S = l.alternate;
        S !== null && _S(S) === null && (g = l), l = l.sibling;
      }
      return g;
    }
    function XK(i) {
      if (i !== void 0 && i !== "forwards" && i !== "backwards" && i !== "together" && !xT[i])
        if (xT[i] = !0, typeof i == "string")
          switch (i.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              c('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', i, i.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              c('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', i, i.toLowerCase());
              break;
            }
            default:
              c('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
              break;
          }
        else
          c('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
    }
    function QK(i, l) {
      i !== void 0 && !BN[i] && (i !== "collapsed" && i !== "hidden" ? (BN[i] = !0, c('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', i)) : l !== "forwards" && l !== "backwards" && (BN[i] = !0, c('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', i)));
    }
    function dL(i, l) {
      {
        var g = Ja(i), S = !g && typeof ta(i) == "function";
        if (g || S) {
          var _ = g ? "array" : "iterable";
          return c("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", _, l, _), !1;
        }
      }
      return !0;
    }
    function ZK(i, l) {
      if ((l === "forwards" || l === "backwards") && i !== void 0 && i !== null && i !== !1)
        if (Ja(i)) {
          for (var g = 0; g < i.length; g++)
            if (!dL(i[g], g))
              return;
        } else {
          var S = ta(i);
          if (typeof S == "function") {
            var _ = S.call(i);
            if (_)
              for (var F = _.next(), Y = 0; !F.done; F = _.next()) {
                if (!dL(F.value, Y))
                  return;
                Y++;
              }
          } else
            c('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', l);
        }
    }
    function kT(i, l, g, S, _) {
      var F = i.memoizedState;
      F === null ? i.memoizedState = {
        isBackwards: l,
        rendering: null,
        renderingStartTime: 0,
        last: S,
        tail: g,
        tailMode: _
      } : (F.isBackwards = l, F.rendering = null, F.renderingStartTime = 0, F.last = S, F.tail = g, F.tailMode = _);
    }
    function fL(i, l, g) {
      var S = l.pendingProps, _ = S.revealOrder, F = S.tail, Y = S.children;
      XK(_), QK(F, _), ZK(Y, _), sm(i, l, Y, g);
      var ee = Qm.current, ie = kS(ee, Zb);
      if (ie)
        ee = DC(ee, Zb), l.flags |= or;
      else {
        var xe = i !== null && (i.flags & or) !== mn;
        xe && qK(l, l.child, g), ee = Zm(ee);
      }
      if (H0(l, ee), (l.mode & Mn) === Sn)
        l.memoizedState = null;
      else
        switch (_) {
          case "forwards": {
            var we = KK(l.child), Le;
            we === null ? (Le = l.child, l.child = null) : (Le = we.sibling, we.sibling = null), kT(
              l,
              !1,
              // isBackwards
              Le,
              we,
              F
            );
            break;
          }
          case "backwards": {
            var Ae = null, et = l.child;
            for (l.child = null; et !== null; ) {
              var nt = et.alternate;
              if (nt !== null && _S(nt) === null) {
                l.child = et;
                break;
              }
              var dt = et.sibling;
              et.sibling = Ae, Ae = et, et = dt;
            }
            kT(
              l,
              !0,
              // isBackwards
              Ae,
              null,
              // last
              F
            );
            break;
          }
          case "together": {
            kT(
              l,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            l.memoizedState = null;
        }
      return l.child;
    }
    function JK(i, l, g) {
      cv(l, l.stateNode.containerInfo);
      var S = l.pendingProps;
      return i === null ? l.child = sv(l, null, S, g) : sm(i, l, S, g), l.child;
    }
    var mL = !1;
    function eX(i, l, g) {
      var S = l.type, _ = S._context, F = l.pendingProps, Y = l.memoizedProps, ee = F.value;
      {
        "value" in F || mL || (mL = !0, c("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var ie = l.type.propTypes;
        ie && Wm(ie, F, "prop", "Context.Provider");
      }
      if (vS(l, _, ee), Y !== null) {
        var xe = Y.value;
        if (Rn(xe, ee)) {
          if (Y.children === F.children && !nS())
            return pv(i, l, g);
        } else
          kC(l, _, g);
      }
      var we = F.children;
      return sm(i, l, we, g), l.child;
    }
    var hL = !1;
    function tX(i, l, g) {
      var S = l.type;
      S._context === void 0 ? S !== S.Consumer && (hL || (hL = !0, c("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : S = S._context;
      var _ = l.pendingProps, F = _.children;
      typeof F != "function" && c("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Mg(l, g);
      var Y = El(S);
      Dm(l);
      var ee;
      return n7.current = l, ed(!0), ee = F(Y), ed(!1), ja(), l.flags |= Gc, sm(i, l, ee, g), l.child;
    }
    function s7() {
      Og = !0;
    }
    function VN(i, l) {
      (l.mode & Mn) === Sn && i !== null && (i.alternate = null, l.alternate = null, l.flags |= ts);
    }
    function pv(i, l, g) {
      return i !== null && (l.dependencies = i.dependencies), de(), y7(l.lanes), sn(g, l.childLanes) ? (lT(i, l), l.child) : null;
    }
    function nX(i, l, g) {
      {
        var S = l.return;
        if (S === null)
          throw new Error("Cannot swap the root fiber.");
        if (i.alternate = null, l.alternate = null, g.index = l.index, g.sibling = l.sibling, g.return = l.return, g.ref = l.ref, l === S.child)
          S.child = g;
        else {
          var _ = S.child;
          if (_ === null)
            throw new Error("Expected parent to have a child.");
          for (; _.sibling !== l; )
            if (_ = _.sibling, _ === null)
              throw new Error("Expected to find the previous sibling.");
          _.sibling = g;
        }
        var F = S.deletions;
        return F === null ? (S.deletions = [i], S.flags |= Na) : F.push(i), g.flags |= ts, g;
      }
    }
    function _T(i, l) {
      var g = i.lanes;
      return !!sn(g, l);
    }
    function rX(i, l, g) {
      switch (l.tag) {
        case w:
          iL(l), l.stateNode, rv();
          break;
        case j:
          jN(l);
          break;
        case y: {
          var S = l.type;
          Yh(S) && Nl(l);
          break;
        }
        case k:
          cv(l, l.stateNode.containerInfo);
          break;
        case I: {
          var _ = l.memoizedProps.value, F = l.type._context;
          vS(l, F, _);
          break;
        }
        case U:
          {
            var Y = sn(g, l.childLanes);
            Y && (l.flags |= Dr);
            {
              var ee = l.stateNode;
              ee.effectDuration = 0, ee.passiveEffectDuration = 0;
            }
          }
          break;
        case z: {
          var ie = l.memoizedState;
          if (ie !== null) {
            if (ie.dehydrated !== null)
              return H0(l, Zm(Qm.current)), l.flags |= or, null;
            var xe = l.child, we = xe.childLanes;
            if (sn(g, we))
              return lL(i, l, g);
            H0(l, Zm(Qm.current));
            var Le = pv(i, l, g);
            return Le !== null ? Le.sibling : null;
          } else
            H0(l, Zm(Qm.current));
          break;
        }
        case X: {
          var Ae = (i.flags & or) !== mn, et = sn(g, l.childLanes);
          if (Ae) {
            if (et)
              return fL(i, l, g);
            l.flags |= or;
          }
          var nt = l.memoizedState;
          if (nt !== null && (nt.rendering = null, nt.tail = null, nt.lastEffect = null), H0(l, Qm.current), et)
            break;
          return null;
        }
        case te:
        case fe:
          return l.lanes = St, rL(i, l, g);
      }
      return pv(i, l, g);
    }
    function pL(i, l, g) {
      if (l._debugNeedsRemount && i !== null)
        return nX(i, l, aM(l.type, l.key, l.pendingProps, l._debugOwner || null, l.mode, l.lanes));
      if (i !== null) {
        var S = i.memoizedProps, _ = l.pendingProps;
        if (S !== _ || nS() || // Force a re-render if the implementation changed due to hot reload:
        l.type !== i.type)
          Og = !0;
        else {
          var F = _T(i, g);
          if (!F && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (l.flags & or) === mn)
            return Og = !1, rX(i, l, g);
          (i.flags & rf) !== mn ? Og = !0 : Og = !1;
        }
      } else if (Og = !1, Wl() && K_(l)) {
        var Y = l.index, ee = X_();
        hN(l, ee, Y);
      }
      switch (l.lanes = St, l.tag) {
        case b:
          return FK(i, l, l.type, g);
        case q: {
          var ie = l.elementType;
          return LK(i, l, ie, g);
        }
        case m: {
          var xe = l.type, we = l.pendingProps, Le = l.elementType === xe ? we : Ct(xe, we);
          return bT(i, l, xe, Le, g);
        }
        case y: {
          var Ae = l.type, et = l.pendingProps, nt = l.elementType === Ae ? et : Ct(Ae, et);
          return sL(i, l, Ae, nt, g);
        }
        case w:
          return PK(i, l, g);
        case j:
          return OK(i, l, g);
        case E:
          return AK(i, l);
        case z:
          return lL(i, l, g);
        case k:
          return JK(i, l, g);
        case R: {
          var dt = l.type, xn = l.pendingProps, fr = l.elementType === dt ? xn : Ct(dt, xn);
          return eL(i, l, dt, fr, g);
        }
        case T:
          return MK(i, l, g);
        case D:
          return RK(i, l, g);
        case U:
          return DK(i, l, g);
        case I:
          return eX(i, l, g);
        case L:
          return tX(i, l, g);
        case H: {
          var qn = l.type, Ua = l.pendingProps, ba = Ct(qn, Ua);
          if (l.type !== l.elementType) {
            var We = qn.propTypes;
            We && Wm(
              We,
              ba,
              // Resolved for outer only
              "prop",
              Qa(qn)
            );
          }
          return ba = Ct(qn.type, ba), tL(i, l, qn, ba, g);
        }
        case K:
          return nL(i, l, l.type, l.pendingProps, g);
        case Q: {
          var ft = l.type, Ye = l.pendingProps, Ut = l.elementType === ft ? Ye : Ct(ft, Ye);
          return IK(i, l, ft, Ut, g);
        }
        case X:
          return fL(i, l, g);
        case se:
          break;
        case te:
          return rL(i, l, g);
      }
      throw new Error("Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function YS(i) {
      i.flags |= Dr;
    }
    function gL(i) {
      i.flags |= Uo, i.flags |= Wc;
    }
    var yL, TT, vL, xL;
    yL = function(i, l, g, S) {
      for (var _ = l.child; _ !== null; ) {
        if (_.tag === j || _.tag === E)
          q6(i, _.stateNode);
        else if (_.tag !== k) {
          if (_.child !== null) {
            _.child.return = _, _ = _.child;
            continue;
          }
        }
        if (_ === l)
          return;
        for (; _.sibling === null; ) {
          if (_.return === null || _.return === l)
            return;
          _ = _.return;
        }
        _.sibling.return = _.return, _ = _.sibling;
      }
    }, TT = function(i, l) {
    }, vL = function(i, l, g, S, _) {
      var F = i.memoizedProps;
      if (F !== S) {
        var Y = l.stateNode, ee = Qb(), ie = k_(Y, g, F, S, _, ee);
        l.updateQueue = ie, ie && YS(l);
      }
    }, xL = function(i, l, g, S) {
      g !== S && YS(l);
    };
    function i7(i, l) {
      if (!Wl())
        switch (i.tailMode) {
          case "hidden": {
            for (var g = i.tail, S = null; g !== null; )
              g.alternate !== null && (S = g), g = g.sibling;
            S === null ? i.tail = null : S.sibling = null;
            break;
          }
          case "collapsed": {
            for (var _ = i.tail, F = null; _ !== null; )
              _.alternate !== null && (F = _), _ = _.sibling;
            F === null ? !l && i.tail !== null ? i.tail.sibling = null : i.tail = null : F.sibling = null;
            break;
          }
        }
    }
    function Rd(i) {
      var l = i.alternate !== null && i.alternate.child === i.child, g = St, S = mn;
      if (l) {
        if ((i.mode & ar) !== Sn) {
          for (var ie = i.selfBaseDuration, xe = i.child; xe !== null; )
            g = ct(g, ct(xe.lanes, xe.childLanes)), S |= xe.subtreeFlags & Ps, S |= xe.flags & Ps, ie += xe.treeBaseDuration, xe = xe.sibling;
          i.treeBaseDuration = ie;
        } else
          for (var we = i.child; we !== null; )
            g = ct(g, ct(we.lanes, we.childLanes)), S |= we.subtreeFlags & Ps, S |= we.flags & Ps, we.return = i, we = we.sibling;
        i.subtreeFlags |= S;
      } else {
        if ((i.mode & ar) !== Sn) {
          for (var _ = i.actualDuration, F = i.selfBaseDuration, Y = i.child; Y !== null; )
            g = ct(g, ct(Y.lanes, Y.childLanes)), S |= Y.subtreeFlags, S |= Y.flags, _ += Y.actualDuration, F += Y.treeBaseDuration, Y = Y.sibling;
          i.actualDuration = _, i.treeBaseDuration = F;
        } else
          for (var ee = i.child; ee !== null; )
            g = ct(g, ct(ee.lanes, ee.childLanes)), S |= ee.subtreeFlags, S |= ee.flags, ee.return = i, ee = ee.sibling;
        i.subtreeFlags |= S;
      }
      return i.childLanes = g, l;
    }
    function aX(i, l, g) {
      if (oT() && (l.mode & Mn) !== Sn && (l.flags & or) === mn)
        return vN(l), rv(), l.flags |= Gs | uc | js, !1;
      var S = mS(l);
      if (g !== null && g.dehydrated !== null)
        if (i === null) {
          if (!S)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (iT(l), Rd(l), (l.mode & ar) !== Sn) {
            var _ = g !== null;
            if (_) {
              var F = l.child;
              F !== null && (l.treeBaseDuration -= F.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (rv(), (l.flags & or) === mn && (l.memoizedState = null), l.flags |= Dr, Rd(l), (l.mode & ar) !== Sn) {
            var Y = g !== null;
            if (Y) {
              var ee = l.child;
              ee !== null && (l.treeBaseDuration -= ee.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return xN(), !0;
    }
    function bL(i, l, g) {
      var S = l.pendingProps;
      switch (CC(l), l.tag) {
        case b:
        case q:
        case K:
        case m:
        case R:
        case T:
        case D:
        case U:
        case L:
        case H:
          return Rd(l), null;
        case y: {
          var _ = l.type;
          return Yh(_) && Ub(l), Rd(l), null;
        }
        case w: {
          var F = l.stateNode;
          if (Wx(l), xC(l), PC(), F.pendingContext && (F.context = F.pendingContext, F.pendingContext = null), i === null || i.child === null) {
            var Y = mS(l);
            if (Y)
              YS(l);
            else if (i !== null) {
              var ee = i.memoizedState;
              // Check if this is a client root
              (!ee.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (l.flags & Gs) !== mn) && (l.flags |= lc, xN());
            }
          }
          return TT(i, l), Rd(l), null;
        }
        case j: {
          RC(l);
          var ie = NN(), xe = l.type;
          if (i !== null && l.stateNode != null)
            vL(i, l, xe, S, ie), i.ref !== l.ref && gL(l);
          else {
            if (!S) {
              if (l.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Rd(l), null;
            }
            var we = Qb(), Le = mS(l);
            if (Le)
              aT(l, ie, we) && YS(l);
            else {
              var Ae = j_(xe, S, ie, we, l);
              yL(Ae, l, !1, !1), l.stateNode = Ae, E_(Ae, xe, S, ie) && YS(l);
            }
            l.ref !== null && gL(l);
          }
          return Rd(l), null;
        }
        case E: {
          var et = S;
          if (i && l.stateNode != null) {
            var nt = i.memoizedProps;
            xL(i, l, nt, et);
          } else {
            if (typeof et != "string" && l.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var dt = NN(), xn = Qb(), fr = mS(l);
            fr ? sT(l) && YS(l) : l.stateNode = __(et, dt, xn, l);
          }
          return Rd(l), null;
        }
        case z: {
          Yx(l);
          var qn = l.memoizedState;
          if (i === null || i.memoizedState !== null && i.memoizedState.dehydrated !== null) {
            var Ua = aX(i, l, qn);
            if (!Ua)
              return l.flags & js ? l : null;
          }
          if ((l.flags & or) !== mn)
            return l.lanes = g, (l.mode & ar) !== Sn && yt(l), l;
          var ba = qn !== null, We = i !== null && i.memoizedState !== null;
          if (ba !== We && ba) {
            var ft = l.child;
            if (ft.flags |= Du, (l.mode & Mn) !== Sn) {
              var Ye = i === null && (l.memoizedProps.unstable_avoidThisFallback !== !0 || !ve);
              Ye || kS(Qm.current, kN) ? sQ() : YT();
            }
          }
          var Ut = l.updateQueue;
          if (Ut !== null && (l.flags |= Dr), Rd(l), (l.mode & ar) !== Sn && ba) {
            var Tn = l.child;
            Tn !== null && (l.treeBaseDuration -= Tn.treeBaseDuration);
          }
          return null;
        }
        case k:
          return Wx(l), TT(i, l), i === null && W_(l.stateNode.containerInfo), Rd(l), null;
        case I:
          var Nn = l.type._context;
          return EC(Nn, l), Rd(l), null;
        case Q: {
          var kr = l.type;
          return Yh(kr) && Ub(l), Rd(l), null;
        }
        case X: {
          Yx(l);
          var Gr = l.memoizedState;
          if (Gr === null)
            return Rd(l), null;
          var ti = (l.flags & or) !== mn, hs = Gr.rendering;
          if (hs === null)
            if (ti)
              i7(Gr, !1);
            else {
              var ql = oQ() && (i === null || (i.flags & or) === mn);
              if (!ql)
                for (var ps = l.child; ps !== null; ) {
                  var _l = _S(ps);
                  if (_l !== null) {
                    ti = !0, l.flags |= or, i7(Gr, !1);
                    var yf = _l.updateQueue;
                    return yf !== null && (l.updateQueue = yf, l.flags |= Dr), l.subtreeFlags = mn, Tg(l, g), H0(l, DC(Qm.current, Zb)), l.child;
                  }
                  ps = ps.sibling;
                }
              Gr.tail !== null && Ys() > BL() && (l.flags |= or, ti = !0, i7(Gr, !1), l.lanes = Wf);
            }
          else {
            if (!ti) {
              var Ld = _S(hs);
              if (Ld !== null) {
                l.flags |= or, ti = !0;
                var sp = Ld.updateQueue;
                if (sp !== null && (l.updateQueue = sp, l.flags |= Dr), i7(Gr, !0), Gr.tail === null && Gr.tailMode === "hidden" && !hs.alternate && !Wl())
                  return Rd(l), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              Ys() * 2 - Gr.renderingStartTime > BL() && g !== So && (l.flags |= or, ti = !0, i7(Gr, !1), l.lanes = Wf);
            }
            if (Gr.isBackwards)
              hs.sibling = l.child, l.child = hs;
            else {
              var lm = Gr.last;
              lm !== null ? lm.sibling = hs : l.child = hs, Gr.last = hs;
            }
          }
          if (Gr.tail !== null) {
            var cm = Gr.tail;
            Gr.rendering = cm, Gr.tail = cm.sibling, Gr.renderingStartTime = Ys(), cm.sibling = null;
            var vf = Qm.current;
            return ti ? vf = DC(vf, Zb) : vf = Zm(vf), H0(l, vf), cm;
          }
          return Rd(l), null;
        }
        case se:
          break;
        case te:
        case fe: {
          WT(l);
          var bv = l.memoizedState, t8 = bv !== null;
          if (i !== null) {
            var w7 = i.memoizedState, Y0 = w7 !== null;
            Y0 !== t8 && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !he && (l.flags |= Du);
          }
          return !t8 || (l.mode & Mn) === Sn ? Rd(l) : sn(W0, So) && (Rd(l), l.subtreeFlags & (ts | Dr) && (l.flags |= Du)), null;
        }
        case ce:
          return null;
        case pe:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + l.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function sX(i, l, g) {
      switch (CC(l), l.tag) {
        case y: {
          var S = l.type;
          Yh(S) && Ub(l);
          var _ = l.flags;
          return _ & js ? (l.flags = _ & ~js | or, (l.mode & ar) !== Sn && yt(l), l) : null;
        }
        case w: {
          l.stateNode, Wx(l), xC(l), PC();
          var F = l.flags;
          return (F & js) !== mn && (F & or) === mn ? (l.flags = F & ~js | or, l) : null;
        }
        case j:
          return RC(l), null;
        case z: {
          Yx(l);
          var Y = l.memoizedState;
          if (Y !== null && Y.dehydrated !== null) {
            if (l.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            rv();
          }
          var ee = l.flags;
          return ee & js ? (l.flags = ee & ~js | or, (l.mode & ar) !== Sn && yt(l), l) : null;
        }
        case X:
          return Yx(l), null;
        case k:
          return Wx(l), null;
        case I:
          var ie = l.type._context;
          return EC(ie, l), null;
        case te:
        case fe:
          return WT(l), null;
        case ce:
          return null;
        default:
          return null;
      }
    }
    function SL(i, l, g) {
      switch (CC(l), l.tag) {
        case y: {
          var S = l.type.childContextTypes;
          S != null && Ub(l);
          break;
        }
        case w: {
          l.stateNode, Wx(l), xC(l), PC();
          break;
        }
        case j: {
          RC(l);
          break;
        }
        case k:
          Wx(l);
          break;
        case z:
          Yx(l);
          break;
        case X:
          Yx(l);
          break;
        case I:
          var _ = l.type._context;
          EC(_, l);
          break;
        case te:
        case fe:
          WT(l);
          break;
      }
    }
    var wL = null;
    wL = /* @__PURE__ */ new Set();
    var $N = !1, Dd = !1, iX = typeof WeakSet == "function" ? WeakSet : Set, Bn = null, qS = null, KS = null;
    function oX(i) {
      cd(null, function() {
        throw i;
      }), gl();
    }
    var lX = function(i, l) {
      if (l.props = i.memoizedProps, l.state = i.memoizedState, i.mode & ar)
        try {
          $e(), l.componentWillUnmount();
        } finally {
          Ce(i);
        }
      else
        l.componentWillUnmount();
    };
    function CL(i, l) {
      try {
        Zx(Fr, i);
      } catch (g) {
        Di(i, l, g);
      }
    }
    function MT(i, l, g) {
      try {
        lX(i, g);
      } catch (S) {
        Di(i, l, S);
      }
    }
    function cX(i, l, g) {
      try {
        g.componentDidMount();
      } catch (S) {
        Di(i, l, S);
      }
    }
    function NL(i, l) {
      try {
        EL(i);
      } catch (g) {
        Di(i, l, g);
      }
    }
    function XS(i, l) {
      var g = i.ref;
      if (g !== null)
        if (typeof g == "function") {
          var S;
          try {
            if (it && Ne && i.mode & ar)
              try {
                $e(), S = g(null);
              } finally {
                Ce(i);
              }
            else
              S = g(null);
          } catch (_) {
            Di(i, l, _);
          }
          typeof S == "function" && c("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Nr(i));
        } else
          g.current = null;
    }
    function GN(i, l, g) {
      try {
        g();
      } catch (S) {
        Di(i, l, S);
      }
    }
    var jL = !1;
    function uX(i, l) {
      rC(i.containerInfo), Bn = l, dX();
      var g = jL;
      return jL = !1, g;
    }
    function dX() {
      for (; Bn !== null; ) {
        var i = Bn, l = i.child;
        (i.subtreeFlags & dd) !== mn && l !== null ? (l.return = i, Bn = l) : fX();
      }
    }
    function fX() {
      for (; Bn !== null; ) {
        var i = Bn;
        Va(i);
        try {
          mX(i);
        } catch (g) {
          Di(i, i.return, g);
        }
        Vs();
        var l = i.sibling;
        if (l !== null) {
          l.return = i.return, Bn = l;
          return;
        }
        Bn = i.return;
      }
    }
    function mX(i) {
      var l = i.alternate, g = i.flags;
      if ((g & lc) !== mn) {
        switch (Va(i), i.tag) {
          case m:
          case R:
          case K:
            break;
          case y: {
            if (l !== null) {
              var S = l.memoizedProps, _ = l.memoizedState, F = i.stateNode;
              i.type === i.elementType && !p4 && (F.props !== i.memoizedProps && c("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Nr(i) || "instance"), F.state !== i.memoizedState && c("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Nr(i) || "instance"));
              var Y = F.getSnapshotBeforeUpdate(i.elementType === i.type ? S : Ct(i.type, S), _);
              {
                var ee = wL;
                Y === void 0 && !ee.has(i.type) && (ee.add(i.type), c("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Nr(i)));
              }
              F.__reactInternalSnapshotBeforeUpdate = Y;
            }
            break;
          }
          case w: {
            {
              var ie = i.stateNode;
              eN(ie.containerInfo);
            }
            break;
          }
          case j:
          case E:
          case k:
          case Q:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Vs();
      }
    }
    function Ag(i, l, g) {
      var S = l.updateQueue, _ = S !== null ? S.lastEffect : null;
      if (_ !== null) {
        var F = _.next, Y = F;
        do {
          if ((Y.tag & i) === i) {
            var ee = Y.destroy;
            Y.destroy = void 0, ee !== void 0 && ((i & su) !== pf ? J1(l) : (i & Fr) !== pf && cs(l), (i & Jh) !== pf && x7(!0), GN(l, g, ee), (i & Jh) !== pf && x7(!1), (i & su) !== pf ? Rh() : (i & Fr) !== pf && Os());
          }
          Y = Y.next;
        } while (Y !== F);
      }
    }
    function Zx(i, l) {
      var g = l.updateQueue, S = g !== null ? g.lastEffect : null;
      if (S !== null) {
        var _ = S.next, F = _;
        do {
          if ((F.tag & i) === i) {
            (i & su) !== pf ? of(l) : (i & Fr) !== pf && ks(l);
            var Y = F.create;
            (i & Jh) !== pf && x7(!0), F.destroy = Y(), (i & Jh) !== pf && x7(!1), (i & su) !== pf ? m0() : (i & Fr) !== pf && br();
            {
              var ee = F.destroy;
              if (ee !== void 0 && typeof ee != "function") {
                var ie = void 0;
                (F.tag & Fr) !== mn ? ie = "useLayoutEffect" : (F.tag & Jh) !== mn ? ie = "useInsertionEffect" : ie = "useEffect";
                var xe = void 0;
                ee === null ? xe = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof ee.then == "function" ? xe = `

It looks like you wrote ` + ie + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + ie + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : xe = " You returned: " + ee, c("%s must not return anything besides a function, which is used for clean-up.%s", ie, xe);
              }
            }
          }
          F = F.next;
        } while (F !== _);
      }
    }
    function hX(i, l) {
      if ((l.flags & Dr) !== mn)
        switch (l.tag) {
          case U: {
            var g = l.stateNode.passiveEffectDuration, S = l.memoizedProps, _ = S.id, F = S.onPostCommit, Y = A(), ee = l.alternate === null ? "mount" : "update";
            d() && (ee = "nested-update"), typeof F == "function" && F(_, ee, g, Y);
            var ie = l.return;
            e: for (; ie !== null; ) {
              switch (ie.tag) {
                case w:
                  var xe = ie.stateNode;
                  xe.passiveEffectDuration += g;
                  break e;
                case U:
                  var we = ie.stateNode;
                  we.passiveEffectDuration += g;
                  break e;
              }
              ie = ie.return;
            }
            break;
          }
        }
    }
    function pX(i, l, g, S) {
      if ((g.flags & to) !== mn)
        switch (g.tag) {
          case m:
          case R:
          case K: {
            if (!Dd)
              if (g.mode & ar)
                try {
                  $e(), Zx(Fr | Yl, g);
                } finally {
                  Ce(g);
                }
              else
                Zx(Fr | Yl, g);
            break;
          }
          case y: {
            var _ = g.stateNode;
            if (g.flags & Dr && !Dd)
              if (l === null)
                if (g.type === g.elementType && !p4 && (_.props !== g.memoizedProps && c("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Nr(g) || "instance"), _.state !== g.memoizedState && c("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Nr(g) || "instance")), g.mode & ar)
                  try {
                    $e(), _.componentDidMount();
                  } finally {
                    Ce(g);
                  }
                else
                  _.componentDidMount();
              else {
                var F = g.elementType === g.type ? l.memoizedProps : Ct(g.type, l.memoizedProps), Y = l.memoizedState;
                if (g.type === g.elementType && !p4 && (_.props !== g.memoizedProps && c("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Nr(g) || "instance"), _.state !== g.memoizedState && c("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Nr(g) || "instance")), g.mode & ar)
                  try {
                    $e(), _.componentDidUpdate(F, Y, _.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Ce(g);
                  }
                else
                  _.componentDidUpdate(F, Y, _.__reactInternalSnapshotBeforeUpdate);
              }
            var ee = g.updateQueue;
            ee !== null && (g.type === g.elementType && !p4 && (_.props !== g.memoizedProps && c("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Nr(g) || "instance"), _.state !== g.memoizedState && c("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Nr(g) || "instance")), qb(g, ee, _));
            break;
          }
          case w: {
            var ie = g.updateQueue;
            if (ie !== null) {
              var xe = null;
              if (g.child !== null)
                switch (g.child.tag) {
                  case j:
                    xe = g.child.stateNode;
                    break;
                  case y:
                    xe = g.child.stateNode;
                    break;
                }
              qb(g, ie, xe);
            }
            break;
          }
          case j: {
            var we = g.stateNode;
            if (l === null && g.flags & Dr) {
              var Le = g.type, Ae = g.memoizedProps;
              X6(we, Le, Ae);
            }
            break;
          }
          case E:
            break;
          case k:
            break;
          case U: {
            {
              var et = g.memoizedProps, nt = et.onCommit, dt = et.onRender, xn = g.stateNode.effectDuration, fr = A(), qn = l === null ? "mount" : "update";
              d() && (qn = "nested-update"), typeof dt == "function" && dt(g.memoizedProps.id, qn, g.actualDuration, g.treeBaseDuration, g.actualStartTime, fr);
              {
                typeof nt == "function" && nt(g.memoizedProps.id, qn, xn, fr), fQ(g);
                var Ua = g.return;
                e: for (; Ua !== null; ) {
                  switch (Ua.tag) {
                    case w:
                      var ba = Ua.stateNode;
                      ba.effectDuration += xn;
                      break e;
                    case U:
                      var We = Ua.stateNode;
                      We.effectDuration += xn;
                      break e;
                  }
                  Ua = Ua.return;
                }
              }
            }
            break;
          }
          case z: {
            CX(i, g);
            break;
          }
          case X:
          case Q:
          case se:
          case te:
          case fe:
          case pe:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Dd || g.flags & Uo && EL(g);
    }
    function gX(i) {
      switch (i.tag) {
        case m:
        case R:
        case K: {
          if (i.mode & ar)
            try {
              $e(), CL(i, i.return);
            } finally {
              Ce(i);
            }
          else
            CL(i, i.return);
          break;
        }
        case y: {
          var l = i.stateNode;
          typeof l.componentDidMount == "function" && cX(i, i.return, l), NL(i, i.return);
          break;
        }
        case j: {
          NL(i, i.return);
          break;
        }
      }
    }
    function yX(i, l) {
      for (var g = null, S = i; ; ) {
        if (S.tag === j) {
          if (g === null) {
            g = S;
            try {
              var _ = S.stateNode;
              l ? L_(_) : F_(S.stateNode, S.memoizedProps);
            } catch (Y) {
              Di(i, i.return, Y);
            }
          }
        } else if (S.tag === E) {
          if (g === null)
            try {
              var F = S.stateNode;
              l ? I_(F) : U_(F, S.memoizedProps);
            } catch (Y) {
              Di(i, i.return, Y);
            }
        } else if (!((S.tag === te || S.tag === fe) && S.memoizedState !== null && S !== i)) {
          if (S.child !== null) {
            S.child.return = S, S = S.child;
            continue;
          }
        }
        if (S === i)
          return;
        for (; S.sibling === null; ) {
          if (S.return === null || S.return === i)
            return;
          g === S && (g = null), S = S.return;
        }
        g === S && (g = null), S.sibling.return = S.return, S = S.sibling;
      }
    }
    function EL(i) {
      var l = i.ref;
      if (l !== null) {
        var g = i.stateNode, S;
        switch (i.tag) {
          case j:
            S = g;
            break;
          default:
            S = g;
        }
        if (typeof l == "function") {
          var _;
          if (i.mode & ar)
            try {
              $e(), _ = l(S);
            } finally {
              Ce(i);
            }
          else
            _ = l(S);
          typeof _ == "function" && c("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Nr(i));
        } else
          l.hasOwnProperty("current") || c("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Nr(i)), l.current = S;
      }
    }
    function vX(i) {
      var l = i.alternate;
      l !== null && (l.return = null), i.return = null;
    }
    function kL(i) {
      var l = i.alternate;
      l !== null && (i.alternate = null, kL(l));
      {
        if (i.child = null, i.deletions = null, i.sibling = null, i.tag === j) {
          var g = i.stateNode;
          g !== null && Z5(g);
        }
        i.stateNode = null, i._debugOwner = null, i.return = null, i.dependencies = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.stateNode = null, i.updateQueue = null;
      }
    }
    function xX(i) {
      for (var l = i.return; l !== null; ) {
        if (_L(l))
          return l;
        l = l.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function _L(i) {
      return i.tag === j || i.tag === w || i.tag === k;
    }
    function TL(i) {
      var l = i;
      e: for (; ; ) {
        for (; l.sibling === null; ) {
          if (l.return === null || _L(l.return))
            return null;
          l = l.return;
        }
        for (l.sibling.return = l.return, l = l.sibling; l.tag !== j && l.tag !== E && l.tag !== Z; ) {
          if (l.flags & ts || l.child === null || l.tag === k)
            continue e;
          l.child.return = l, l = l.child;
        }
        if (!(l.flags & ts))
          return l.stateNode;
      }
    }
    function bX(i) {
      var l = xX(i);
      switch (l.tag) {
        case j: {
          var g = l.stateNode;
          l.flags & Oa && (Q6(g), l.flags &= ~Oa);
          var S = TL(i);
          DT(i, S, g);
          break;
        }
        case w:
        case k: {
          var _ = l.stateNode.containerInfo, F = TL(i);
          RT(i, F, _);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function RT(i, l, g) {
      var S = i.tag, _ = S === j || S === E;
      if (_) {
        var F = i.stateNode;
        l ? W5(g, F, l) : D_(g, F);
      } else if (S !== k) {
        var Y = i.child;
        if (Y !== null) {
          RT(Y, l, g);
          for (var ee = Y.sibling; ee !== null; )
            RT(ee, l, g), ee = ee.sibling;
        }
      }
    }
    function DT(i, l, g) {
      var S = i.tag, _ = S === j || S === E;
      if (_) {
        var F = i.stateNode;
        l ? P_(g, F, l) : Z6(g, F);
      } else if (S !== k) {
        var Y = i.child;
        if (Y !== null) {
          DT(Y, l, g);
          for (var ee = Y.sibling; ee !== null; )
            DT(ee, l, g), ee = ee.sibling;
        }
      }
    }
    var Pd = null, Lg = !1;
    function SX(i, l, g) {
      {
        var S = l;
        e: for (; S !== null; ) {
          switch (S.tag) {
            case j: {
              Pd = S.stateNode, Lg = !1;
              break e;
            }
            case w: {
              Pd = S.stateNode.containerInfo, Lg = !0;
              break e;
            }
            case k: {
              Pd = S.stateNode.containerInfo, Lg = !0;
              break e;
            }
          }
          S = S.return;
        }
        if (Pd === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        ML(i, l, g), Pd = null, Lg = !1;
      }
      vX(g);
    }
    function Jx(i, l, g) {
      for (var S = g.child; S !== null; )
        ML(i, l, S), S = S.sibling;
    }
    function ML(i, l, g) {
      switch (no(g), g.tag) {
        case j:
          Dd || XS(g, l);
        case E: {
          {
            var S = Pd, _ = Lg;
            Pd = null, Jx(i, l, g), Pd = S, Lg = _, Pd !== null && (Lg ? A_(Pd, g.stateNode) : O_(Pd, g.stateNode));
          }
          return;
        }
        case Z: {
          Pd !== null && (Lg ? J6(Pd, g.stateNode) : lC(Pd, g.stateNode));
          return;
        }
        case k: {
          {
            var F = Pd, Y = Lg;
            Pd = g.stateNode.containerInfo, Lg = !0, Jx(i, l, g), Pd = F, Lg = Y;
          }
          return;
        }
        case m:
        case R:
        case H:
        case K: {
          if (!Dd) {
            var ee = g.updateQueue;
            if (ee !== null) {
              var ie = ee.lastEffect;
              if (ie !== null) {
                var xe = ie.next, we = xe;
                do {
                  var Le = we, Ae = Le.destroy, et = Le.tag;
                  Ae !== void 0 && ((et & Jh) !== pf ? GN(g, l, Ae) : (et & Fr) !== pf && (cs(g), g.mode & ar ? ($e(), GN(g, l, Ae), Ce(g)) : GN(g, l, Ae), Os())), we = we.next;
                } while (we !== xe);
              }
            }
          }
          Jx(i, l, g);
          return;
        }
        case y: {
          if (!Dd) {
            XS(g, l);
            var nt = g.stateNode;
            typeof nt.componentWillUnmount == "function" && MT(g, l, nt);
          }
          Jx(i, l, g);
          return;
        }
        case se: {
          Jx(i, l, g);
          return;
        }
        case te: {
          if (
            // TODO: Remove this dead flag
            g.mode & Mn
          ) {
            var dt = Dd;
            Dd = dt || g.memoizedState !== null, Jx(i, l, g), Dd = dt;
          } else
            Jx(i, l, g);
          break;
        }
        default: {
          Jx(i, l, g);
          return;
        }
      }
    }
    function wX(i) {
      i.memoizedState;
    }
    function CX(i, l) {
      var g = l.memoizedState;
      if (g === null) {
        var S = l.alternate;
        if (S !== null) {
          var _ = S.memoizedState;
          if (_ !== null) {
            var F = _.dehydrated;
            F !== null && Ob(F);
          }
        }
      }
    }
    function RL(i) {
      var l = i.updateQueue;
      if (l !== null) {
        i.updateQueue = null;
        var g = i.stateNode;
        g === null && (g = i.stateNode = new iX()), l.forEach(function(S) {
          var _ = xQ.bind(null, i, S);
          if (!g.has(S)) {
            if (g.add(S), gc)
              if (qS !== null && KS !== null)
                v7(KS, qS);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            S.then(_, _);
          }
        });
      }
    }
    function NX(i, l, g) {
      qS = g, KS = i, Va(l), DL(l, i), Va(l), qS = null, KS = null;
    }
    function Ig(i, l, g) {
      var S = l.deletions;
      if (S !== null)
        for (var _ = 0; _ < S.length; _++) {
          var F = S[_];
          try {
            SX(i, l, F);
          } catch (ie) {
            Di(F, l, ie);
          }
        }
      var Y = ax();
      if (l.subtreeFlags & yl)
        for (var ee = l.child; ee !== null; )
          Va(ee), DL(ee, i), ee = ee.sibling;
      Va(Y);
    }
    function DL(i, l, g) {
      var S = i.alternate, _ = i.flags;
      switch (i.tag) {
        case m:
        case R:
        case H:
        case K: {
          if (Ig(l, i), G0(i), _ & Dr) {
            try {
              Ag(Jh | Yl, i, i.return), Zx(Jh | Yl, i);
            } catch (kr) {
              Di(i, i.return, kr);
            }
            if (i.mode & ar) {
              try {
                $e(), Ag(Fr | Yl, i, i.return);
              } catch (kr) {
                Di(i, i.return, kr);
              }
              Ce(i);
            } else
              try {
                Ag(Fr | Yl, i, i.return);
              } catch (kr) {
                Di(i, i.return, kr);
              }
          }
          return;
        }
        case y: {
          Ig(l, i), G0(i), _ & Uo && S !== null && XS(S, S.return);
          return;
        }
        case j: {
          Ig(l, i), G0(i), _ & Uo && S !== null && XS(S, S.return);
          {
            if (i.flags & Oa) {
              var F = i.stateNode;
              try {
                Q6(F);
              } catch (kr) {
                Di(i, i.return, kr);
              }
            }
            if (_ & Dr) {
              var Y = i.stateNode;
              if (Y != null) {
                var ee = i.memoizedProps, ie = S !== null ? S.memoizedProps : ee, xe = i.type, we = i.updateQueue;
                if (i.updateQueue = null, we !== null)
                  try {
                    iC(Y, we, xe, ie, ee, i);
                  } catch (kr) {
                    Di(i, i.return, kr);
                  }
              }
            }
          }
          return;
        }
        case E: {
          if (Ig(l, i), G0(i), _ & Dr) {
            if (i.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var Le = i.stateNode, Ae = i.memoizedProps, et = S !== null ? S.memoizedProps : Ae;
            try {
              oC(Le, et, Ae);
            } catch (kr) {
              Di(i, i.return, kr);
            }
          }
          return;
        }
        case w: {
          if (Ig(l, i), G0(i), _ & Dr && S !== null) {
            var nt = S.memoizedState;
            if (nt.isDehydrated)
              try {
                sN(l.containerInfo);
              } catch (kr) {
                Di(i, i.return, kr);
              }
          }
          return;
        }
        case k: {
          Ig(l, i), G0(i);
          return;
        }
        case z: {
          Ig(l, i), G0(i);
          var dt = i.child;
          if (dt.flags & Du) {
            var xn = dt.stateNode, fr = dt.memoizedState, qn = fr !== null;
            if (xn.isHidden = qn, qn) {
              var Ua = dt.alternate !== null && dt.alternate.memoizedState !== null;
              Ua || aQ();
            }
          }
          if (_ & Dr) {
            try {
              wX(i);
            } catch (kr) {
              Di(i, i.return, kr);
            }
            RL(i);
          }
          return;
        }
        case te: {
          var ba = S !== null && S.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            i.mode & Mn
          ) {
            var We = Dd;
            Dd = We || ba, Ig(l, i), Dd = We;
          } else
            Ig(l, i);
          if (G0(i), _ & Du) {
            var ft = i.stateNode, Ye = i.memoizedState, Ut = Ye !== null, Tn = i;
            if (ft.isHidden = Ut, Ut && !ba && (Tn.mode & Mn) !== Sn) {
              Bn = Tn;
              for (var Nn = Tn.child; Nn !== null; )
                Bn = Nn, EX(Nn), Nn = Nn.sibling;
            }
            yX(Tn, Ut);
          }
          return;
        }
        case X: {
          Ig(l, i), G0(i), _ & Dr && RL(i);
          return;
        }
        case se:
          return;
        default: {
          Ig(l, i), G0(i);
          return;
        }
      }
    }
    function G0(i) {
      var l = i.flags;
      if (l & ts) {
        try {
          bX(i);
        } catch (g) {
          Di(i, i.return, g);
        }
        i.flags &= ~ts;
      }
      l & cc && (i.flags &= ~cc);
    }
    function jX(i, l, g) {
      qS = g, KS = l, Bn = i, PL(i, l, g), qS = null, KS = null;
    }
    function PL(i, l, g) {
      for (var S = (i.mode & Mn) !== Sn; Bn !== null; ) {
        var _ = Bn, F = _.child;
        if (_.tag === te && S) {
          var Y = _.memoizedState !== null, ee = Y || $N;
          if (ee) {
            PT(i, l, g);
            continue;
          } else {
            var ie = _.alternate, xe = ie !== null && ie.memoizedState !== null, we = xe || Dd, Le = $N, Ae = Dd;
            $N = ee, Dd = we, Dd && !Ae && (Bn = _, kX(_));
            for (var et = F; et !== null; )
              Bn = et, PL(
                et,
                // New root; bubble back up to here and stop.
                l,
                g
              ), et = et.sibling;
            Bn = _, $N = Le, Dd = Ae, PT(i, l, g);
            continue;
          }
        }
        (_.subtreeFlags & to) !== mn && F !== null ? (F.return = _, Bn = F) : PT(i, l, g);
      }
    }
    function PT(i, l, g) {
      for (; Bn !== null; ) {
        var S = Bn;
        if ((S.flags & to) !== mn) {
          var _ = S.alternate;
          Va(S);
          try {
            pX(l, _, S, g);
          } catch (Y) {
            Di(S, S.return, Y);
          }
          Vs();
        }
        if (S === i) {
          Bn = null;
          return;
        }
        var F = S.sibling;
        if (F !== null) {
          F.return = S.return, Bn = F;
          return;
        }
        Bn = S.return;
      }
    }
    function EX(i) {
      for (; Bn !== null; ) {
        var l = Bn, g = l.child;
        switch (l.tag) {
          case m:
          case R:
          case H:
          case K: {
            if (l.mode & ar)
              try {
                $e(), Ag(Fr, l, l.return);
              } finally {
                Ce(l);
              }
            else
              Ag(Fr, l, l.return);
            break;
          }
          case y: {
            XS(l, l.return);
            var S = l.stateNode;
            typeof S.componentWillUnmount == "function" && MT(l, l.return, S);
            break;
          }
          case j: {
            XS(l, l.return);
            break;
          }
          case te: {
            var _ = l.memoizedState !== null;
            if (_) {
              OL(i);
              continue;
            }
            break;
          }
        }
        g !== null ? (g.return = l, Bn = g) : OL(i);
      }
    }
    function OL(i) {
      for (; Bn !== null; ) {
        var l = Bn;
        if (l === i) {
          Bn = null;
          return;
        }
        var g = l.sibling;
        if (g !== null) {
          g.return = l.return, Bn = g;
          return;
        }
        Bn = l.return;
      }
    }
    function kX(i) {
      for (; Bn !== null; ) {
        var l = Bn, g = l.child;
        if (l.tag === te) {
          var S = l.memoizedState !== null;
          if (S) {
            AL(i);
            continue;
          }
        }
        g !== null ? (g.return = l, Bn = g) : AL(i);
      }
    }
    function AL(i) {
      for (; Bn !== null; ) {
        var l = Bn;
        Va(l);
        try {
          gX(l);
        } catch (S) {
          Di(l, l.return, S);
        }
        if (Vs(), l === i) {
          Bn = null;
          return;
        }
        var g = l.sibling;
        if (g !== null) {
          g.return = l.return, Bn = g;
          return;
        }
        Bn = l.return;
      }
    }
    function _X(i, l, g, S) {
      Bn = l, TX(l, i, g, S);
    }
    function TX(i, l, g, S) {
      for (; Bn !== null; ) {
        var _ = Bn, F = _.child;
        (_.subtreeFlags & Vl) !== mn && F !== null ? (F.return = _, Bn = F) : MX(i, l, g, S);
      }
    }
    function MX(i, l, g, S) {
      for (; Bn !== null; ) {
        var _ = Bn;
        if ((_.flags & Ns) !== mn) {
          Va(_);
          try {
            RX(l, _, g, S);
          } catch (Y) {
            Di(_, _.return, Y);
          }
          Vs();
        }
        if (_ === i) {
          Bn = null;
          return;
        }
        var F = _.sibling;
        if (F !== null) {
          F.return = _.return, Bn = F;
          return;
        }
        Bn = _.return;
      }
    }
    function RX(i, l, g, S) {
      switch (l.tag) {
        case m:
        case R:
        case K: {
          if (l.mode & ar) {
            at();
            try {
              Zx(su | Yl, l);
            } finally {
              Me(l);
            }
          } else
            Zx(su | Yl, l);
          break;
        }
      }
    }
    function DX(i) {
      Bn = i, PX();
    }
    function PX() {
      for (; Bn !== null; ) {
        var i = Bn, l = i.child;
        if ((Bn.flags & Na) !== mn) {
          var g = i.deletions;
          if (g !== null) {
            for (var S = 0; S < g.length; S++) {
              var _ = g[S];
              Bn = _, LX(_, i);
            }
            {
              var F = i.alternate;
              if (F !== null) {
                var Y = F.child;
                if (Y !== null) {
                  F.child = null;
                  do {
                    var ee = Y.sibling;
                    Y.sibling = null, Y = ee;
                  } while (Y !== null);
                }
              }
            }
            Bn = i;
          }
        }
        (i.subtreeFlags & Vl) !== mn && l !== null ? (l.return = i, Bn = l) : OX();
      }
    }
    function OX() {
      for (; Bn !== null; ) {
        var i = Bn;
        (i.flags & Ns) !== mn && (Va(i), AX(i), Vs());
        var l = i.sibling;
        if (l !== null) {
          l.return = i.return, Bn = l;
          return;
        }
        Bn = i.return;
      }
    }
    function AX(i) {
      switch (i.tag) {
        case m:
        case R:
        case K: {
          i.mode & ar ? (at(), Ag(su | Yl, i, i.return), Me(i)) : Ag(su | Yl, i, i.return);
          break;
        }
      }
    }
    function LX(i, l) {
      for (; Bn !== null; ) {
        var g = Bn;
        Va(g), FX(g, l), Vs();
        var S = g.child;
        S !== null ? (S.return = g, Bn = S) : IX(i);
      }
    }
    function IX(i) {
      for (; Bn !== null; ) {
        var l = Bn, g = l.sibling, S = l.return;
        if (kL(l), l === i) {
          Bn = null;
          return;
        }
        if (g !== null) {
          g.return = S, Bn = g;
          return;
        }
        Bn = S;
      }
    }
    function FX(i, l) {
      switch (i.tag) {
        case m:
        case R:
        case K: {
          i.mode & ar ? (at(), Ag(su, i, l), Me(i)) : Ag(su, i, l);
          break;
        }
      }
    }
    function UX(i) {
      switch (i.tag) {
        case m:
        case R:
        case K: {
          try {
            Zx(Fr | Yl, i);
          } catch (g) {
            Di(i, i.return, g);
          }
          break;
        }
        case y: {
          var l = i.stateNode;
          try {
            l.componentDidMount();
          } catch (g) {
            Di(i, i.return, g);
          }
          break;
        }
      }
    }
    function zX(i) {
      switch (i.tag) {
        case m:
        case R:
        case K: {
          try {
            Zx(su | Yl, i);
          } catch (l) {
            Di(i, i.return, l);
          }
          break;
        }
      }
    }
    function BX(i) {
      switch (i.tag) {
        case m:
        case R:
        case K: {
          try {
            Ag(Fr | Yl, i, i.return);
          } catch (g) {
            Di(i, i.return, g);
          }
          break;
        }
        case y: {
          var l = i.stateNode;
          typeof l.componentWillUnmount == "function" && MT(i, i.return, l);
          break;
        }
      }
    }
    function HX(i) {
      switch (i.tag) {
        case m:
        case R:
        case K:
          try {
            Ag(su | Yl, i, i.return);
          } catch (l) {
            Di(i, i.return, l);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var o7 = Symbol.for;
      o7("selector.component"), o7("selector.has_pseudo_class"), o7("selector.role"), o7("selector.test_id"), o7("selector.text");
    }
    var VX = [];
    function $X() {
      VX.forEach(function(i) {
        return i();
      });
    }
    var GX = n.ReactCurrentActQueue;
    function WX(i) {
      {
        var l = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), g = typeof jest < "u";
        return g && l !== !1;
      }
    }
    function LL() {
      {
        var i = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !i && GX.current !== null && c("The current testing environment is not configured to support act(...)"), i;
      }
    }
    var YX = Math.ceil, OT = n.ReactCurrentDispatcher, AT = n.ReactCurrentOwner, Od = n.ReactCurrentBatchConfig, Fg = n.ReactCurrentActQueue, iu = (
      /*             */
      0
    ), IL = (
      /*               */
      1
    ), Ad = (
      /*                */
      2
    ), u1 = (
      /*                */
      4
    ), gv = 0, l7 = 1, g4 = 2, WN = 3, c7 = 4, FL = 5, LT = 6, Fa = iu, im = null, el = null, ou = St, W0 = St, IT = O0(St), lu = gv, u7 = null, YN = St, d7 = St, qN = St, f7 = null, nh = null, FT = 0, UL = 500, zL = 1 / 0, qX = 500, yv = null;
    function m7() {
      zL = Ys() + qX;
    }
    function BL() {
      return zL;
    }
    var KN = !1, UT = null, QS = null, y4 = !1, e2 = null, h7 = St, zT = [], BT = null, KX = 50, p7 = 0, HT = null, VT = !1, XN = !1, XX = 50, ZS = 0, QN = null, g7 = da, ZN = St, HL = !1;
    function JN() {
      return im;
    }
    function om() {
      return (Fa & (Ad | u1)) !== iu ? Ys() : (g7 !== da || (g7 = Ys()), g7);
    }
    function t2(i) {
      var l = i.mode;
      if ((l & Mn) === Sn)
        return hn;
      if ((Fa & Ad) !== iu && ou !== St)
        return Fe(ou);
      var g = jl() !== Xh;
      if (g) {
        if (Od.transition !== null) {
          var S = Od.transition;
          S._updatedFibers || (S._updatedFibers = /* @__PURE__ */ new Set()), S._updatedFibers.add(i);
        }
        return ZN === Qs && (ZN = G()), ZN;
      }
      var _ = xd();
      if (_ !== Qs)
        return _;
      var F = T_();
      return F;
    }
    function QX(i) {
      var l = i.mode;
      return (l & Mn) === Sn ? hn : ne();
    }
    function cu(i, l, g, S) {
      SQ(), HL && c("useInsertionEffect must not schedule updates."), VT && (XN = !0), ze(i, g, S), (Fa & Ad) !== St && i === im ? NQ(l) : (gc && Kr(i, l, g), jQ(l), i === im && ((Fa & Ad) === iu && (d7 = ct(d7, g)), lu === c7 && n2(i, ou)), rh(i, S), g === hn && Fa === iu && (l.mode & Mn) === Sn && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Fg.isBatchingLegacy && (m7(), SC()));
    }
    function ZX(i, l, g) {
      var S = i.current;
      S.lanes = l, ze(i, l, g), rh(i, g);
    }
    function JX(i) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Fa & Ad) !== iu
      );
    }
    function rh(i, l) {
      var g = i.callbackNode;
      Ay(i, l);
      var S = vd(i, i === im ? ou : St);
      if (S === St) {
        g !== null && aI(g), i.callbackNode = null, i.callbackPriority = Qs;
        return;
      }
      var _ = be(S), F = i.callbackPriority;
      if (F === _ && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Fg.current !== null && g !== XT)) {
        g == null && F !== hn && c("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      g != null && aI(g);
      var Y;
      if (_ === hn)
        i.tag === tu ? (Fg.isBatchingLegacy !== null && (Fg.didScheduleLegacyUpdate = !0), qh(GL.bind(null, i))) : mN(GL.bind(null, i)), Fg.current !== null ? Fg.current.push(nu) : M_(function() {
          (Fa & (Ad | u1)) === iu && nu();
        }), Y = null;
      else {
        var ee;
        switch (zo(S)) {
          case Ea:
            ee = Th;
            break;
          case Xc:
            ee = qs;
            break;
          case Sc:
            ee = Ni;
            break;
          case Ah:
            ee = Ap;
            break;
          default:
            ee = Ni;
            break;
        }
        Y = QT(ee, VL.bind(null, i));
      }
      i.callbackPriority = _, i.callbackNode = Y;
    }
    function VL(i, l) {
      if (C(), g7 = da, ZN = St, (Fa & (Ad | u1)) !== iu)
        throw new Error("Should not already be working.");
      var g = i.callbackNode, S = xv();
      if (S && i.callbackNode !== g)
        return null;
      var _ = vd(i, i === im ? ou : St);
      if (_ === St)
        return null;
      var F = !x(i, _) && !P(i, _) && !l, Y = F ? cQ(i, _) : tj(i, _);
      if (Y !== gv) {
        if (Y === g4) {
          var ee = qf(i);
          ee !== St && (_ = ee, Y = $T(i, ee));
        }
        if (Y === l7) {
          var ie = u7;
          throw v4(i, St), n2(i, _), rh(i, Ys()), ie;
        }
        if (Y === LT)
          n2(i, _);
        else {
          var xe = !x(i, _), we = i.current.alternate;
          if (xe && !tQ(we)) {
            if (Y = tj(i, _), Y === g4) {
              var Le = qf(i);
              Le !== St && (_ = Le, Y = $T(i, Le));
            }
            if (Y === l7) {
              var Ae = u7;
              throw v4(i, St), n2(i, _), rh(i, Ys()), Ae;
            }
          }
          i.finishedWork = we, i.finishedLanes = _, eQ(i, Y, _);
        }
      }
      return rh(i, Ys()), i.callbackNode === g ? VL.bind(null, i) : null;
    }
    function $T(i, l) {
      var g = f7;
      if (v0(i)) {
        var S = v4(i, l);
        S.flags |= Gs, fC(i.containerInfo);
      }
      var _ = tj(i, l);
      if (_ !== g4) {
        var F = nh;
        nh = g, F !== null && $L(F);
      }
      return _;
    }
    function $L(i) {
      nh === null ? nh = i : nh.push.apply(nh, i);
    }
    function eQ(i, l, g) {
      switch (l) {
        case gv:
        case l7:
          throw new Error("Root did not complete. This is a bug in React.");
        case g4: {
          x4(i, nh, yv);
          break;
        }
        case WN: {
          if (n2(i, g), ag(g) && // do not delay if we're inside an act() scope
          !sI()) {
            var S = FT + UL - Ys();
            if (S > 10) {
              var _ = vd(i, St);
              if (_ !== St)
                break;
              var F = i.suspendedLanes;
              if (!dr(F, g)) {
                om(), Jt(i, F);
                break;
              }
              i.timeoutHandle = Db(x4.bind(null, i, nh, yv), S);
              break;
            }
          }
          x4(i, nh, yv);
          break;
        }
        case c7: {
          if (n2(i, g), v(g))
            break;
          if (!sI()) {
            var Y = Bp(i, g), ee = Y, ie = Ys() - ee, xe = bQ(ie) - ie;
            if (xe > 10) {
              i.timeoutHandle = Db(x4.bind(null, i, nh, yv), xe);
              break;
            }
          }
          x4(i, nh, yv);
          break;
        }
        case FL: {
          x4(i, nh, yv);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function tQ(i) {
      for (var l = i; ; ) {
        if (l.flags & _h) {
          var g = l.updateQueue;
          if (g !== null) {
            var S = g.stores;
            if (S !== null)
              for (var _ = 0; _ < S.length; _++) {
                var F = S[_], Y = F.getSnapshot, ee = F.value;
                try {
                  if (!Rn(Y(), ee))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var ie = l.child;
        if (l.subtreeFlags & _h && ie !== null) {
          ie.return = l, l = ie;
          continue;
        }
        if (l === i)
          return !0;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === i)
            return !0;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return !0;
    }
    function n2(i, l) {
      l = xa(l, qN), l = xa(l, d7), rt(i, l);
    }
    function GL(i) {
      if (M(), (Fa & (Ad | u1)) !== iu)
        throw new Error("Should not already be working.");
      xv();
      var l = vd(i, St);
      if (!sn(l, hn))
        return rh(i, Ys()), null;
      var g = tj(i, l);
      if (i.tag !== tu && g === g4) {
        var S = qf(i);
        S !== St && (l = S, g = $T(i, S));
      }
      if (g === l7) {
        var _ = u7;
        throw v4(i, St), n2(i, l), rh(i, Ys()), _;
      }
      if (g === LT)
        throw new Error("Root did not complete. This is a bug in React.");
      var F = i.current.alternate;
      return i.finishedWork = F, i.finishedLanes = l, x4(i, nh, yv), rh(i, Ys()), null;
    }
    function nQ(i, l) {
      l !== St && (pr(i, ct(l, hn)), rh(i, Ys()), (Fa & (Ad | u1)) === iu && (m7(), nu()));
    }
    function GT(i, l) {
      var g = Fa;
      Fa |= IL;
      try {
        return i(l);
      } finally {
        Fa = g, Fa === iu && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Fg.isBatchingLegacy && (m7(), SC());
      }
    }
    function rQ(i, l, g, S, _) {
      var F = xd(), Y = Od.transition;
      try {
        return Od.transition = null, ki(Ea), i(l, g, S, _);
      } finally {
        ki(F), Od.transition = Y, Fa === iu && m7();
      }
    }
    function vv(i) {
      e2 !== null && e2.tag === tu && (Fa & (Ad | u1)) === iu && xv();
      var l = Fa;
      Fa |= IL;
      var g = Od.transition, S = xd();
      try {
        return Od.transition = null, ki(Ea), i ? i() : void 0;
      } finally {
        ki(S), Od.transition = g, Fa = l, (Fa & (Ad | u1)) === iu && nu();
      }
    }
    function WL() {
      return (Fa & (Ad | u1)) !== iu;
    }
    function ej(i, l) {
      io(IT, W0, i), W0 = ct(W0, l);
    }
    function WT(i) {
      W0 = IT.current, xi(IT, i);
    }
    function v4(i, l) {
      i.finishedWork = null, i.finishedLanes = St;
      var g = i.timeoutHandle;
      if (g !== Pb && (i.timeoutHandle = Pb, sC(g)), el !== null)
        for (var S = el.return; S !== null; ) {
          var _ = S.alternate;
          SL(_, S), S = S.return;
        }
      im = i;
      var F = b4(i.current, null);
      return el = F, ou = W0 = l, lu = gv, u7 = null, YN = St, d7 = St, qN = St, f7 = null, nh = null, Vb(), rm.discardPendingWarnings(), F;
    }
    function YL(i, l) {
      do {
        var g = el;
        try {
          if (Zh(), LC(), Vs(), AT.current = null, g === null || g.return === null) {
            lu = l7, u7 = l, el = null;
            return;
          }
          if (it && g.mode & ar && ge(g, !0), qe)
            if (ja(), l !== null && typeof l == "object" && typeof l.then == "function") {
              var S = l;
              ro(g, S, ou);
            } else
              ji(g, l, ou);
          kK(i, g.return, g, l, ou), QL(g);
        } catch (_) {
          l = _, el === g && g !== null ? (g = g.return, el = g) : g = el;
          continue;
        }
        return;
      } while (!0);
    }
    function qL() {
      var i = OT.current;
      return OT.current = f4, i === null ? f4 : i;
    }
    function KL(i) {
      OT.current = i;
    }
    function aQ() {
      FT = Ys();
    }
    function y7(i) {
      YN = ct(i, YN);
    }
    function sQ() {
      lu === gv && (lu = WN);
    }
    function YT() {
      (lu === gv || lu === WN || lu === g4) && (lu = c7), im !== null && (Kf(YN) || Kf(d7)) && n2(im, ou);
    }
    function iQ(i) {
      lu !== c7 && (lu = g4), f7 === null ? f7 = [i] : f7.push(i);
    }
    function oQ() {
      return lu === gv;
    }
    function tj(i, l) {
      var g = Fa;
      Fa |= Ad;
      var S = qL();
      if (im !== i || ou !== l) {
        if (gc) {
          var _ = i.memoizedUpdaters;
          _.size > 0 && (v7(i, ou), _.clear()), Js(i, l);
        }
        yv = Wr(), v4(i, l);
      }
      bs(l);
      do
        try {
          lQ();
          break;
        } catch (F) {
          YL(i, F);
        }
      while (!0);
      if (Zh(), Fa = g, KL(S), el !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Om(), im = null, ou = St, lu;
    }
    function lQ() {
      for (; el !== null; )
        XL(el);
    }
    function cQ(i, l) {
      var g = Fa;
      Fa |= Ad;
      var S = qL();
      if (im !== i || ou !== l) {
        if (gc) {
          var _ = i.memoizedUpdaters;
          _.size > 0 && (v7(i, ou), _.clear()), Js(i, l);
        }
        yv = Wr(), m7(), v4(i, l);
      }
      bs(l);
      do
        try {
          uQ();
          break;
        } catch (F) {
          YL(i, F);
        }
      while (!0);
      return Zh(), KL(S), Fa = g, el !== null ? (Ip(), gv) : (Om(), im = null, ou = St, lu);
    }
    function uQ() {
      for (; el !== null && !gi(); )
        XL(el);
    }
    function XL(i) {
      var l = i.alternate;
      Va(i);
      var g;
      (i.mode & ar) !== Sn ? (ae(i), g = qT(l, i, W0), ge(i, !0)) : g = qT(l, i, W0), Vs(), i.memoizedProps = i.pendingProps, g === null ? QL(i) : el = g, AT.current = null;
    }
    function QL(i) {
      var l = i;
      do {
        var g = l.alternate, S = l.return;
        if ((l.flags & uc) === mn) {
          Va(l);
          var _ = void 0;
          if ((l.mode & ar) === Sn ? _ = bL(g, l, W0) : (ae(l), _ = bL(g, l, W0), ge(l, !1)), Vs(), _ !== null) {
            el = _;
            return;
          }
        } else {
          var F = sX(g, l);
          if (F !== null) {
            F.flags &= Dy, el = F;
            return;
          }
          if ((l.mode & ar) !== Sn) {
            ge(l, !1);
            for (var Y = l.actualDuration, ee = l.child; ee !== null; )
              Y += ee.actualDuration, ee = ee.sibling;
            l.actualDuration = Y;
          }
          if (S !== null)
            S.flags |= uc, S.subtreeFlags = mn, S.deletions = null;
          else {
            lu = LT, el = null;
            return;
          }
        }
        var ie = l.sibling;
        if (ie !== null) {
          el = ie;
          return;
        }
        l = S, el = l;
      } while (l !== null);
      lu === gv && (lu = FL);
    }
    function x4(i, l, g) {
      var S = xd(), _ = Od.transition;
      try {
        Od.transition = null, ki(Ea), dQ(i, l, g, S);
      } finally {
        Od.transition = _, ki(S);
      }
      return null;
    }
    function dQ(i, l, g, S) {
      do
        xv();
      while (e2 !== null);
      if (wQ(), (Fa & (Ad | u1)) !== iu)
        throw new Error("Should not already be working.");
      var _ = i.finishedWork, F = i.finishedLanes;
      if (sf(F), _ === null)
        return Lp(), null;
      if (F === St && c("root.finishedLanes should not be empty during a commit. This is a bug in React."), i.finishedWork = null, i.finishedLanes = St, _ === i.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      i.callbackNode = null, i.callbackPriority = Qs;
      var Y = ct(_.lanes, _.childLanes);
      Yn(i, Y), i === im && (im = null, el = null, ou = St), ((_.subtreeFlags & Vl) !== mn || (_.flags & Vl) !== mn) && (y4 || (y4 = !0, BT = g, QT(Ni, function() {
        return xv(), null;
      })));
      var ee = (_.subtreeFlags & (dd | yl | to | Vl)) !== mn, ie = (_.flags & (dd | yl | to | Vl)) !== mn;
      if (ee || ie) {
        var xe = Od.transition;
        Od.transition = null;
        var we = xd();
        ki(Ea);
        var Le = Fa;
        Fa |= u1, AT.current = null, uX(i, _), W(), NX(i, _, F), Y6(i.containerInfo), i.current = _, Pm(F), jX(_, i, F), Xs(), Oy(), Fa = Le, ki(we), Od.transition = xe;
      } else
        i.current = _, W();
      var Ae = y4;
      if (y4 ? (y4 = !1, e2 = i, h7 = F) : (ZS = 0, QN = null), Y = i.pendingLanes, Y === St && (QS = null), Ae || tI(i.current, !1), Ks(_.stateNode, S), gc && i.memoizedUpdaters.clear(), $X(), rh(i, Ys()), l !== null)
        for (var et = i.onRecoverableError, nt = 0; nt < l.length; nt++) {
          var dt = l[nt], xn = dt.stack, fr = dt.digest;
          et(dt.value, {
            componentStack: xn,
            digest: fr
          });
        }
      if (KN) {
        KN = !1;
        var qn = UT;
        throw UT = null, qn;
      }
      return sn(h7, hn) && i.tag !== tu && xv(), Y = i.pendingLanes, sn(Y, hn) ? (h(), i === HT ? p7++ : (p7 = 0, HT = i)) : p7 = 0, nu(), Lp(), null;
    }
    function xv() {
      if (e2 !== null) {
        var i = zo(h7), l = Rw(Sc, i), g = Od.transition, S = xd();
        try {
          return Od.transition = null, ki(l), mQ();
        } finally {
          ki(S), Od.transition = g;
        }
      }
      return !1;
    }
    function fQ(i) {
      zT.push(i), y4 || (y4 = !0, QT(Ni, function() {
        return xv(), null;
      }));
    }
    function mQ() {
      if (e2 === null)
        return !1;
      var i = BT;
      BT = null;
      var l = e2, g = h7;
      if (e2 = null, h7 = St, (Fa & (Ad | u1)) !== iu)
        throw new Error("Cannot flush passive effects while already rendering.");
      VT = !0, XN = !1, Dh(g);
      var S = Fa;
      Fa |= u1, DX(l.current), _X(l, l.current, g, i);
      {
        var _ = zT;
        zT = [];
        for (var F = 0; F < _.length; F++) {
          var Y = _[F];
          hX(l, Y);
        }
      }
      lf(), tI(l.current, !0), Fa = S, nu(), XN ? l === QN ? ZS++ : (ZS = 0, QN = l) : ZS = 0, VT = !1, XN = !1, Yt(l);
      {
        var ee = l.current.stateNode;
        ee.effectDuration = 0, ee.passiveEffectDuration = 0;
      }
      return !0;
    }
    function ZL(i) {
      return QS !== null && QS.has(i);
    }
    function hQ(i) {
      QS === null ? QS = /* @__PURE__ */ new Set([i]) : QS.add(i);
    }
    function pQ(i) {
      KN || (KN = !0, UT = i);
    }
    var gQ = pQ;
    function JL(i, l, g) {
      var S = jo(g, l), _ = zN(i, S, hn), F = Rg(i, _, hn), Y = om();
      F !== null && (ze(F, hn, Y), rh(F, Y));
    }
    function Di(i, l, g) {
      if (oX(g), x7(!1), i.tag === w) {
        JL(i, i, g);
        return;
      }
      var S = null;
      for (S = l; S !== null; ) {
        if (S.tag === w) {
          JL(S, i, g);
          return;
        } else if (S.tag === y) {
          var _ = S.type, F = S.stateNode;
          if (typeof _.getDerivedStateFromError == "function" || typeof F.componentDidCatch == "function" && !ZL(F)) {
            var Y = jo(g, i), ee = t7(S, Y, hn), ie = Rg(S, ee, hn), xe = om();
            ie !== null && (ze(ie, hn, xe), rh(ie, xe));
            return;
          }
        }
        S = S.return;
      }
      c(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, g);
    }
    function yQ(i, l, g) {
      var S = i.pingCache;
      S !== null && S.delete(l);
      var _ = om();
      Jt(i, g), EQ(i), im === i && dr(ou, g) && (lu === c7 || lu === WN && ag(ou) && Ys() - FT < UL ? v4(i, St) : qN = ct(qN, g)), rh(i, _);
    }
    function eI(i, l) {
      l === Qs && (l = QX(i));
      var g = om(), S = Is(i, l);
      S !== null && (ze(S, l, g), rh(S, g));
    }
    function vQ(i) {
      var l = i.memoizedState, g = Qs;
      l !== null && (g = l.retryLane), eI(i, g);
    }
    function xQ(i, l) {
      var g = Qs, S;
      switch (i.tag) {
        case z:
          S = i.stateNode;
          var _ = i.memoizedState;
          _ !== null && (g = _.retryLane);
          break;
        case X:
          S = i.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      S !== null && S.delete(l), eI(i, g);
    }
    function bQ(i) {
      return i < 120 ? 120 : i < 480 ? 480 : i < 1080 ? 1080 : i < 1920 ? 1920 : i < 3e3 ? 3e3 : i < 4320 ? 4320 : YX(i / 1960) * 1960;
    }
    function SQ() {
      if (p7 > KX)
        throw p7 = 0, HT = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      ZS > XX && (ZS = 0, QN = null, c("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function wQ() {
      rm.flushLegacyContextWarning(), rm.flushPendingUnsafeLifecycleWarnings();
    }
    function tI(i, l) {
      Va(i), nj(i, Wn, BX), l && nj(i, dc, HX), nj(i, Wn, UX), l && nj(i, dc, zX), Vs();
    }
    function nj(i, l, g) {
      for (var S = i, _ = null; S !== null; ) {
        var F = S.subtreeFlags & l;
        S !== _ && S.child !== null && F !== mn ? S = S.child : ((S.flags & l) !== mn && g(S), S.sibling !== null ? S = S.sibling : S = _ = S.return);
      }
    }
    var rj = null;
    function nI(i) {
      {
        if ((Fa & Ad) !== iu || !(i.mode & Mn))
          return;
        var l = i.tag;
        if (l !== b && l !== w && l !== y && l !== m && l !== R && l !== H && l !== K)
          return;
        var g = Nr(i) || "ReactComponent";
        if (rj !== null) {
          if (rj.has(g))
            return;
          rj.add(g);
        } else
          rj = /* @__PURE__ */ new Set([g]);
        var S = Za;
        try {
          Va(i), c("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          S ? Va(i) : Vs();
        }
      }
    }
    var qT;
    {
      var CQ = null;
      qT = function(i, l, g) {
        var S = uI(CQ, l);
        try {
          return pL(i, l, g);
        } catch (F) {
          if (tT() || F !== null && typeof F == "object" && typeof F.then == "function")
            throw F;
          if (Zh(), LC(), SL(i, l), uI(l, S), l.mode & ar && ae(l), cd(null, pL, null, i, l, g), Tm()) {
            var _ = gl();
            typeof _ == "object" && _ !== null && _._suppressLogging && typeof F == "object" && F !== null && !F._suppressLogging && (F._suppressLogging = !0);
          }
          throw F;
        }
      };
    }
    var rI = !1, KT;
    KT = /* @__PURE__ */ new Set();
    function NQ(i) {
      if (bu && !hT())
        switch (i.tag) {
          case m:
          case R:
          case K: {
            var l = el && Nr(el) || "Unknown", g = l;
            if (!KT.has(g)) {
              KT.add(g);
              var S = Nr(i) || "Unknown";
              c("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", S, l, l);
            }
            break;
          }
          case y: {
            rI || (c("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), rI = !0);
            break;
          }
        }
    }
    function v7(i, l) {
      if (gc) {
        var g = i.memoizedUpdaters;
        g.forEach(function(S) {
          Kr(i, S, l);
        });
      }
    }
    var XT = {};
    function QT(i, l) {
      {
        var g = Fg.current;
        return g !== null ? (g.push(l), XT) : fd(i, l);
      }
    }
    function aI(i) {
      if (i !== XT)
        return hc(i);
    }
    function sI() {
      return Fg.current !== null;
    }
    function jQ(i) {
      {
        if (i.mode & Mn) {
          if (!LL())
            return;
        } else if (!WX() || Fa !== iu || i.tag !== m && i.tag !== R && i.tag !== K)
          return;
        if (Fg.current === null) {
          var l = Za;
          try {
            Va(i), c(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Nr(i));
          } finally {
            l ? Va(i) : Vs();
          }
        }
      }
    }
    function EQ(i) {
      i.tag !== tu && LL() && Fg.current === null && c(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function x7(i) {
      HL = i;
    }
    var d1 = null, JS = null, kQ = function(i) {
      d1 = i;
    };
    function e8(i) {
      {
        if (d1 === null)
          return i;
        var l = d1(i);
        return l === void 0 ? i : l.current;
      }
    }
    function ZT(i) {
      return e8(i);
    }
    function JT(i) {
      {
        if (d1 === null)
          return i;
        var l = d1(i);
        if (l === void 0) {
          if (i != null && typeof i.render == "function") {
            var g = e8(i.render);
            if (i.render !== g) {
              var S = {
                $$typeof: Kt,
                render: g
              };
              return i.displayName !== void 0 && (S.displayName = i.displayName), S;
            }
          }
          return i;
        }
        return l.current;
      }
    }
    function iI(i, l) {
      {
        if (d1 === null)
          return !1;
        var g = i.elementType, S = l.type, _ = !1, F = typeof S == "object" && S !== null ? S.$$typeof : null;
        switch (i.tag) {
          case y: {
            typeof S == "function" && (_ = !0);
            break;
          }
          case m: {
            (typeof S == "function" || F === Xn) && (_ = !0);
            break;
          }
          case R: {
            (F === Kt || F === Xn) && (_ = !0);
            break;
          }
          case H:
          case K: {
            (F === Lr || F === Xn) && (_ = !0);
            break;
          }
          default:
            return !1;
        }
        if (_) {
          var Y = d1(g);
          if (Y !== void 0 && Y === d1(S))
            return !0;
        }
        return !1;
      }
    }
    function oI(i) {
      {
        if (d1 === null || typeof WeakSet != "function")
          return;
        JS === null && (JS = /* @__PURE__ */ new WeakSet()), JS.add(i);
      }
    }
    var _Q = function(i, l) {
      {
        if (d1 === null)
          return;
        var g = l.staleFamilies, S = l.updatedFamilies;
        xv(), vv(function() {
          eM(i.current, S, g);
        });
      }
    }, TQ = function(i, l) {
      {
        if (i.context !== tm)
          return;
        xv(), vv(function() {
          b7(l, i, null, null);
        });
      }
    };
    function eM(i, l, g) {
      {
        var S = i.alternate, _ = i.child, F = i.sibling, Y = i.tag, ee = i.type, ie = null;
        switch (Y) {
          case m:
          case K:
          case y:
            ie = ee;
            break;
          case R:
            ie = ee.render;
            break;
        }
        if (d1 === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var xe = !1, we = !1;
        if (ie !== null) {
          var Le = d1(ie);
          Le !== void 0 && (g.has(Le) ? we = !0 : l.has(Le) && (Y === y ? we = !0 : xe = !0));
        }
        if (JS !== null && (JS.has(i) || S !== null && JS.has(S)) && (we = !0), we && (i._debugNeedsRemount = !0), we || xe) {
          var Ae = Is(i, hn);
          Ae !== null && cu(Ae, i, hn, da);
        }
        _ !== null && !we && eM(_, l, g), F !== null && eM(F, l, g);
      }
    }
    var MQ = function(i, l) {
      {
        var g = /* @__PURE__ */ new Set(), S = new Set(l.map(function(_) {
          return _.current;
        }));
        return tM(i.current, S, g), g;
      }
    };
    function tM(i, l, g) {
      {
        var S = i.child, _ = i.sibling, F = i.tag, Y = i.type, ee = null;
        switch (F) {
          case m:
          case K:
          case y:
            ee = Y;
            break;
          case R:
            ee = Y.render;
            break;
        }
        var ie = !1;
        ee !== null && l.has(ee) && (ie = !0), ie ? RQ(i, g) : S !== null && tM(S, l, g), _ !== null && tM(_, l, g);
      }
    }
    function RQ(i, l) {
      {
        var g = DQ(i, l);
        if (g)
          return;
        for (var S = i; ; ) {
          switch (S.tag) {
            case j:
              l.add(S.stateNode);
              return;
            case k:
              l.add(S.stateNode.containerInfo);
              return;
            case w:
              l.add(S.stateNode.containerInfo);
              return;
          }
          if (S.return === null)
            throw new Error("Expected to reach root first.");
          S = S.return;
        }
      }
    }
    function DQ(i, l) {
      for (var g = i, S = !1; ; ) {
        if (g.tag === j)
          S = !0, l.add(g.stateNode);
        else if (g.child !== null) {
          g.child.return = g, g = g.child;
          continue;
        }
        if (g === i)
          return S;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === i)
            return S;
          g = g.return;
        }
        g.sibling.return = g.return, g = g.sibling;
      }
      return !1;
    }
    var nM;
    {
      nM = !1;
      try {
        var lI = Object.preventExtensions({});
      } catch {
        nM = !0;
      }
    }
    function PQ(i, l, g, S) {
      this.tag = i, this.key = g, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = l, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = S, this.flags = mn, this.subtreeFlags = mn, this.deletions = null, this.lanes = St, this.childLanes = St, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !nM && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var ap = function(i, l, g, S) {
      return new PQ(i, l, g, S);
    };
    function rM(i) {
      var l = i.prototype;
      return !!(l && l.isReactComponent);
    }
    function OQ(i) {
      return typeof i == "function" && !rM(i) && i.defaultProps === void 0;
    }
    function AQ(i) {
      if (typeof i == "function")
        return rM(i) ? y : m;
      if (i != null) {
        var l = i.$$typeof;
        if (l === Kt)
          return R;
        if (l === Lr)
          return H;
      }
      return b;
    }
    function b4(i, l) {
      var g = i.alternate;
      g === null ? (g = ap(i.tag, l, i.key, i.mode), g.elementType = i.elementType, g.type = i.type, g.stateNode = i.stateNode, g._debugSource = i._debugSource, g._debugOwner = i._debugOwner, g._debugHookTypes = i._debugHookTypes, g.alternate = i, i.alternate = g) : (g.pendingProps = l, g.type = i.type, g.flags = mn, g.subtreeFlags = mn, g.deletions = null, g.actualDuration = 0, g.actualStartTime = -1), g.flags = i.flags & Ps, g.childLanes = i.childLanes, g.lanes = i.lanes, g.child = i.child, g.memoizedProps = i.memoizedProps, g.memoizedState = i.memoizedState, g.updateQueue = i.updateQueue;
      var S = i.dependencies;
      switch (g.dependencies = S === null ? null : {
        lanes: S.lanes,
        firstContext: S.firstContext
      }, g.sibling = i.sibling, g.index = i.index, g.ref = i.ref, g.selfBaseDuration = i.selfBaseDuration, g.treeBaseDuration = i.treeBaseDuration, g._debugNeedsRemount = i._debugNeedsRemount, g.tag) {
        case b:
        case m:
        case K:
          g.type = e8(i.type);
          break;
        case y:
          g.type = ZT(i.type);
          break;
        case R:
          g.type = JT(i.type);
          break;
      }
      return g;
    }
    function LQ(i, l) {
      i.flags &= Ps | ts;
      var g = i.alternate;
      if (g === null)
        i.childLanes = St, i.lanes = l, i.child = null, i.subtreeFlags = mn, i.memoizedProps = null, i.memoizedState = null, i.updateQueue = null, i.dependencies = null, i.stateNode = null, i.selfBaseDuration = 0, i.treeBaseDuration = 0;
      else {
        i.childLanes = g.childLanes, i.lanes = g.lanes, i.child = g.child, i.subtreeFlags = mn, i.deletions = null, i.memoizedProps = g.memoizedProps, i.memoizedState = g.memoizedState, i.updateQueue = g.updateQueue, i.type = g.type;
        var S = g.dependencies;
        i.dependencies = S === null ? null : {
          lanes: S.lanes,
          firstContext: S.firstContext
        }, i.selfBaseDuration = g.selfBaseDuration, i.treeBaseDuration = g.treeBaseDuration;
      }
      return i;
    }
    function IQ(i, l, g) {
      var S;
      return i === Lx ? (S = Mn, l === !0 && (S |= $r, S |= Fi)) : S = Sn, gc && (S |= ar), ap(w, null, null, S);
    }
    function aM(i, l, g, S, _, F) {
      var Y = b, ee = i;
      if (typeof i == "function")
        rM(i) ? (Y = y, ee = ZT(ee)) : ee = e8(ee);
      else if (typeof i == "string")
        Y = j;
      else
        e: switch (i) {
          case Do:
            return r2(g.children, _, F, l);
          case _s:
            Y = D, _ |= $r, (_ & Mn) !== Sn && (_ |= Fi);
            break;
          case fl:
            return FQ(g, _, F, l);
          case On:
            return UQ(g, _, F, l);
          case vr:
            return zQ(g, _, F, l);
          case pa:
            return cI(g, _, F, l);
          case ga:
          case wr:
          case Tr:
          case Fn:
          case Ts:
          default: {
            if (typeof i == "object" && i !== null)
              switch (i.$$typeof) {
                case _e:
                  Y = I;
                  break e;
                case _t:
                  Y = L;
                  break e;
                case Kt:
                  Y = R, ee = JT(ee);
                  break e;
                case Lr:
                  Y = H;
                  break e;
                case Xn:
                  Y = q, ee = null;
                  break e;
              }
            var ie = "";
            {
              (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (ie += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var xe = S ? Nr(S) : null;
              xe && (ie += `

Check the render method of \`` + xe + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (i == null ? i : typeof i) + "." + ie));
          }
        }
      var we = ap(Y, g, l, _);
      return we.elementType = i, we.type = ee, we.lanes = F, we._debugOwner = S, we;
    }
    function sM(i, l, g) {
      var S = null;
      S = i._owner;
      var _ = i.type, F = i.key, Y = i.props, ee = aM(_, F, Y, S, l, g);
      return ee._debugSource = i._source, ee._debugOwner = i._owner, ee;
    }
    function r2(i, l, g, S) {
      var _ = ap(T, i, S, l);
      return _.lanes = g, _;
    }
    function FQ(i, l, g, S) {
      typeof i.id != "string" && c('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof i.id);
      var _ = ap(U, i, S, l | ar);
      return _.elementType = fl, _.lanes = g, _.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, _;
    }
    function UQ(i, l, g, S) {
      var _ = ap(z, i, S, l);
      return _.elementType = On, _.lanes = g, _;
    }
    function zQ(i, l, g, S) {
      var _ = ap(X, i, S, l);
      return _.elementType = vr, _.lanes = g, _;
    }
    function cI(i, l, g, S) {
      var _ = ap(te, i, S, l);
      _.elementType = pa, _.lanes = g;
      var F = {
        isHidden: !1
      };
      return _.stateNode = F, _;
    }
    function iM(i, l, g) {
      var S = ap(E, i, null, l);
      return S.lanes = g, S;
    }
    function BQ() {
      var i = ap(j, null, null, Sn);
      return i.elementType = "DELETED", i;
    }
    function HQ(i) {
      var l = ap(Z, null, null, Sn);
      return l.stateNode = i, l;
    }
    function oM(i, l, g) {
      var S = i.children !== null ? i.children : [], _ = ap(k, S, i.key, l);
      return _.lanes = g, _.stateNode = {
        containerInfo: i.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: i.implementation
      }, _;
    }
    function uI(i, l) {
      return i === null && (i = ap(b, null, null, Sn)), i.tag = l.tag, i.key = l.key, i.elementType = l.elementType, i.type = l.type, i.stateNode = l.stateNode, i.return = l.return, i.child = l.child, i.sibling = l.sibling, i.index = l.index, i.ref = l.ref, i.pendingProps = l.pendingProps, i.memoizedProps = l.memoizedProps, i.updateQueue = l.updateQueue, i.memoizedState = l.memoizedState, i.dependencies = l.dependencies, i.mode = l.mode, i.flags = l.flags, i.subtreeFlags = l.subtreeFlags, i.deletions = l.deletions, i.lanes = l.lanes, i.childLanes = l.childLanes, i.alternate = l.alternate, i.actualDuration = l.actualDuration, i.actualStartTime = l.actualStartTime, i.selfBaseDuration = l.selfBaseDuration, i.treeBaseDuration = l.treeBaseDuration, i._debugSource = l._debugSource, i._debugOwner = l._debugOwner, i._debugNeedsRemount = l._debugNeedsRemount, i._debugHookTypes = l._debugHookTypes, i;
    }
    function VQ(i, l, g, S, _) {
      this.tag = l, this.containerInfo = i, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Pb, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Qs, this.eventTimes = Be(St), this.expirationTimes = Be(da), this.pendingLanes = St, this.suspendedLanes = St, this.pingedLanes = St, this.expiredLanes = St, this.mutableReadLanes = St, this.finishedLanes = St, this.entangledLanes = St, this.entanglements = Be(St), this.identifierPrefix = S, this.onRecoverableError = _, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var F = this.pendingUpdatersLaneMap = [], Y = 0; Y < $f; Y++)
          F.push(/* @__PURE__ */ new Set());
      }
      switch (l) {
        case Lx:
          this._debugRootType = g ? "hydrateRoot()" : "createRoot()";
          break;
        case tu:
          this._debugRootType = g ? "hydrate()" : "render()";
          break;
      }
    }
    function dI(i, l, g, S, _, F, Y, ee, ie, xe) {
      var we = new VQ(i, l, g, ee, ie), Le = IQ(l, F);
      we.current = Le, Le.stateNode = we;
      {
        var Ae = {
          element: S,
          isDehydrated: g,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        Le.memoizedState = Ae;
      }
      return TC(Le), we;
    }
    var lM = "18.3.1";
    function $Q(i, l, g) {
      var S = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return ke(S), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Ro,
        key: S == null ? null : "" + S,
        children: i,
        containerInfo: l,
        implementation: g
      };
    }
    var cM, uM;
    cM = !1, uM = {};
    function fI(i) {
      if (!i)
        return tm;
      var l = $c(i), g = q_(l);
      if (l.tag === y) {
        var S = l.type;
        if (Yh(S))
          return aS(l, S, g);
      }
      return g;
    }
    function GQ(i, l) {
      {
        var g = $c(i);
        if (g === void 0) {
          if (typeof i.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var S = Object.keys(i).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + S);
        }
        var _ = ii(g);
        if (_ === null)
          return null;
        if (_.mode & $r) {
          var F = Nr(g) || "Component";
          if (!uM[F]) {
            uM[F] = !0;
            var Y = Za;
            try {
              Va(_), g.mode & $r ? c("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", l, l, F) : c("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", l, l, F);
            } finally {
              Y ? Va(Y) : Vs();
            }
          }
        }
        return _.stateNode;
      }
    }
    function mI(i, l, g, S, _, F, Y, ee) {
      var ie = !1, xe = null;
      return dI(i, l, ie, xe, g, S, _, F, Y);
    }
    function hI(i, l, g, S, _, F, Y, ee, ie, xe) {
      var we = !0, Le = dI(g, S, we, i, _, F, Y, ee, ie);
      Le.context = fI(null);
      var Ae = Le.current, et = om(), nt = t2(Ae), dt = Wu(et, nt);
      return dt.callback = l ?? null, Rg(Ae, dt, nt), ZX(Le, nt, et), Le;
    }
    function b7(i, l, g, S) {
      Vf(l, i);
      var _ = l.current, F = om(), Y = t2(_);
      vl(Y);
      var ee = fI(g);
      l.context === null ? l.context = ee : l.pendingContext = ee, bu && Za !== null && !cM && (cM = !0, c(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Nr(Za) || "Unknown"));
      var ie = Wu(F, Y);
      ie.payload = {
        element: i
      }, S = S === void 0 ? null : S, S !== null && (typeof S != "function" && c("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", S), ie.callback = S);
      var xe = Rg(_, ie, Y);
      return xe !== null && (cu(xe, _, Y, F), wS(xe, _, Y)), Y;
    }
    function aj(i) {
      var l = i.current;
      if (!l.child)
        return null;
      switch (l.child.tag) {
        case j:
          return l.child.stateNode;
        default:
          return l.child.stateNode;
      }
    }
    function WQ(i) {
      switch (i.tag) {
        case w: {
          var l = i.stateNode;
          if (v0(l)) {
            var g = g0(l);
            nQ(l, g);
          }
          break;
        }
        case z: {
          vv(function() {
            var _ = Is(i, hn);
            if (_ !== null) {
              var F = om();
              cu(_, i, hn, F);
            }
          });
          var S = hn;
          dM(i, S);
          break;
        }
      }
    }
    function pI(i, l) {
      var g = i.memoizedState;
      g !== null && g.dehydrated !== null && (g.retryLane = Zs(g.retryLane, l));
    }
    function dM(i, l) {
      pI(i, l);
      var g = i.alternate;
      g && pI(g, l);
    }
    function YQ(i) {
      if (i.tag === z) {
        var l = Up, g = Is(i, l);
        if (g !== null) {
          var S = om();
          cu(g, i, l, S);
        }
        dM(i, l);
      }
    }
    function qQ(i) {
      if (i.tag === z) {
        var l = t2(i), g = Is(i, l);
        if (g !== null) {
          var S = om();
          cu(g, i, l, S);
        }
        dM(i, l);
      }
    }
    function gI(i) {
      var l = Op(i);
      return l === null ? null : l.stateNode;
    }
    var yI = function(i) {
      return null;
    };
    function KQ(i) {
      return yI(i);
    }
    var vI = function(i) {
      return !1;
    };
    function XQ(i) {
      return vI(i);
    }
    var xI = null, bI = null, SI = null, wI = null, CI = null, NI = null, jI = null, EI = null, kI = null;
    {
      var _I = function(i, l, g) {
        var S = l[g], _ = Ja(i) ? i.slice() : ir({}, i);
        return g + 1 === l.length ? (Ja(_) ? _.splice(S, 1) : delete _[S], _) : (_[S] = _I(i[S], l, g + 1), _);
      }, TI = function(i, l) {
        return _I(i, l, 0);
      }, MI = function(i, l, g, S) {
        var _ = l[S], F = Ja(i) ? i.slice() : ir({}, i);
        if (S + 1 === l.length) {
          var Y = g[S];
          F[Y] = F[_], Ja(F) ? F.splice(_, 1) : delete F[_];
        } else
          F[_] = MI(
            // $FlowFixMe number or string is fine here
            i[_],
            l,
            g,
            S + 1
          );
        return F;
      }, RI = function(i, l, g) {
        if (l.length !== g.length) {
          o("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var S = 0; S < g.length - 1; S++)
            if (l[S] !== g[S]) {
              o("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return MI(i, l, g, 0);
      }, DI = function(i, l, g, S) {
        if (g >= l.length)
          return S;
        var _ = l[g], F = Ja(i) ? i.slice() : ir({}, i);
        return F[_] = DI(i[_], l, g + 1, S), F;
      }, PI = function(i, l, g) {
        return DI(i, l, 0, g);
      }, fM = function(i, l) {
        for (var g = i.memoizedState; g !== null && l > 0; )
          g = g.next, l--;
        return g;
      };
      xI = function(i, l, g, S) {
        var _ = fM(i, l);
        if (_ !== null) {
          var F = PI(_.memoizedState, g, S);
          _.memoizedState = F, _.baseState = F, i.memoizedProps = ir({}, i.memoizedProps);
          var Y = Is(i, hn);
          Y !== null && cu(Y, i, hn, da);
        }
      }, bI = function(i, l, g) {
        var S = fM(i, l);
        if (S !== null) {
          var _ = TI(S.memoizedState, g);
          S.memoizedState = _, S.baseState = _, i.memoizedProps = ir({}, i.memoizedProps);
          var F = Is(i, hn);
          F !== null && cu(F, i, hn, da);
        }
      }, SI = function(i, l, g, S) {
        var _ = fM(i, l);
        if (_ !== null) {
          var F = RI(_.memoizedState, g, S);
          _.memoizedState = F, _.baseState = F, i.memoizedProps = ir({}, i.memoizedProps);
          var Y = Is(i, hn);
          Y !== null && cu(Y, i, hn, da);
        }
      }, wI = function(i, l, g) {
        i.pendingProps = PI(i.memoizedProps, l, g), i.alternate && (i.alternate.pendingProps = i.pendingProps);
        var S = Is(i, hn);
        S !== null && cu(S, i, hn, da);
      }, CI = function(i, l) {
        i.pendingProps = TI(i.memoizedProps, l), i.alternate && (i.alternate.pendingProps = i.pendingProps);
        var g = Is(i, hn);
        g !== null && cu(g, i, hn, da);
      }, NI = function(i, l, g) {
        i.pendingProps = RI(i.memoizedProps, l, g), i.alternate && (i.alternate.pendingProps = i.pendingProps);
        var S = Is(i, hn);
        S !== null && cu(S, i, hn, da);
      }, jI = function(i) {
        var l = Is(i, hn);
        l !== null && cu(l, i, hn, da);
      }, EI = function(i) {
        yI = i;
      }, kI = function(i) {
        vI = i;
      };
    }
    function QQ(i) {
      var l = ii(i);
      return l === null ? null : l.stateNode;
    }
    function ZQ(i) {
      return null;
    }
    function JQ() {
      return Za;
    }
    function eZ(i) {
      var l = i.findFiberByHostInstance, g = n.ReactCurrentDispatcher;
      return f0({
        bundleType: i.bundleType,
        version: i.version,
        rendererPackageName: i.rendererPackageName,
        rendererConfig: i.rendererConfig,
        overrideHookState: xI,
        overrideHookStateDeletePath: bI,
        overrideHookStateRenamePath: SI,
        overrideProps: wI,
        overridePropsDeletePath: CI,
        overridePropsRenamePath: NI,
        setErrorHandler: EI,
        setSuspenseHandler: kI,
        scheduleUpdate: jI,
        currentDispatcherRef: g,
        findHostInstanceByFiber: QQ,
        findFiberByHostInstance: l || ZQ,
        // React Refresh
        findHostInstancesForRefresh: MQ,
        scheduleRefresh: _Q,
        scheduleRoot: TQ,
        setRefreshHandler: kQ,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: JQ,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: lM
      });
    }
    var OI = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(i) {
      console.error(i);
    };
    function mM(i) {
      this._internalRoot = i;
    }
    sj.prototype.render = mM.prototype.render = function(i) {
      var l = this._internalRoot;
      if (l === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? c("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : ij(arguments[1]) ? c("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && c("You passed a second argument to root.render(...) but it only accepts one argument.");
        var g = l.containerInfo;
        if (g.nodeType !== mi) {
          var S = gI(l.current);
          S && S.parentNode !== g && c("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      b7(i, l, null, null);
    }, sj.prototype.unmount = mM.prototype.unmount = function() {
      typeof arguments[0] == "function" && c("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var i = this._internalRoot;
      if (i !== null) {
        this._internalRoot = null;
        var l = i.containerInfo;
        WL() && c("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), vv(function() {
          b7(null, i, null, null);
        }), Dn(l);
      }
    };
    function tZ(i, l) {
      if (!ij(i))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      AI(i);
      var g = !1, S = !1, _ = "", F = OI;
      l != null && (l.hydrate ? o("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof l == "object" && l !== null && l.$$typeof === Dc && c(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), l.unstable_strictMode === !0 && (g = !0), l.identifierPrefix !== void 0 && (_ = l.identifierPrefix), l.onRecoverableError !== void 0 && (F = l.onRecoverableError), l.transitionCallbacks !== void 0 && l.transitionCallbacks);
      var Y = mI(i, Lx, null, g, S, _, F);
      J5(Y.current, i);
      var ee = i.nodeType === mi ? i.parentNode : i;
      return $y(ee), new mM(Y);
    }
    function sj(i) {
      this._internalRoot = i;
    }
    function nZ(i) {
      i && Dw(i);
    }
    sj.prototype.unstable_scheduleHydration = nZ;
    function rZ(i, l, g) {
      if (!ij(i))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      AI(i), l === void 0 && c("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var S = g ?? null, _ = g != null && g.hydratedSources || null, F = !1, Y = !1, ee = "", ie = OI;
      g != null && (g.unstable_strictMode === !0 && (F = !0), g.identifierPrefix !== void 0 && (ee = g.identifierPrefix), g.onRecoverableError !== void 0 && (ie = g.onRecoverableError));
      var xe = hI(l, null, i, Lx, S, F, Y, ee, ie);
      if (J5(xe.current, i), $y(i), _)
        for (var we = 0; we < _.length; we++) {
          var Le = _[we];
          uT(xe, Le);
        }
      return new sj(xe);
    }
    function ij(i) {
      return !!(i && (i.nodeType === pl || i.nodeType === ac || i.nodeType === Xd || !Te));
    }
    function S7(i) {
      return !!(i && (i.nodeType === pl || i.nodeType === ac || i.nodeType === Xd || i.nodeType === mi && i.nodeValue === " react-mount-point-unstable "));
    }
    function AI(i) {
      i.nodeType === pl && i.tagName && i.tagName.toUpperCase() === "BODY" && c("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), t1(i) && (i._reactRootContainer ? c("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : c("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var aZ = n.ReactCurrentOwner, LI;
    LI = function(i) {
      if (i._reactRootContainer && i.nodeType !== mi) {
        var l = gI(i._reactRootContainer.current);
        l && l.parentNode !== i && c("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var g = !!i._reactRootContainer, S = hM(i), _ = !!(S && P0(S));
      _ && !g && c("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), i.nodeType === pl && i.tagName && i.tagName.toUpperCase() === "BODY" && c("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function hM(i) {
      return i ? i.nodeType === ac ? i.documentElement : i.firstChild : null;
    }
    function II() {
    }
    function sZ(i, l, g, S, _) {
      if (_) {
        if (typeof S == "function") {
          var F = S;
          S = function() {
            var Ae = aj(Y);
            F.call(Ae);
          };
        }
        var Y = hI(
          l,
          S,
          i,
          tu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          II
        );
        i._reactRootContainer = Y, J5(Y.current, i);
        var ee = i.nodeType === mi ? i.parentNode : i;
        return $y(ee), vv(), Y;
      } else {
        for (var ie; ie = i.lastChild; )
          i.removeChild(ie);
        if (typeof S == "function") {
          var xe = S;
          S = function() {
            var Ae = aj(we);
            xe.call(Ae);
          };
        }
        var we = mI(
          i,
          tu,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          II
        );
        i._reactRootContainer = we, J5(we.current, i);
        var Le = i.nodeType === mi ? i.parentNode : i;
        return $y(Le), vv(function() {
          b7(l, we, g, S);
        }), we;
      }
    }
    function iZ(i, l) {
      i !== null && typeof i != "function" && c("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", l, i);
    }
    function oj(i, l, g, S, _) {
      LI(g), iZ(_ === void 0 ? null : _, "render");
      var F = g._reactRootContainer, Y;
      if (!F)
        Y = sZ(g, l, i, _, S);
      else {
        if (Y = F, typeof _ == "function") {
          var ee = _;
          _ = function() {
            var ie = aj(Y);
            ee.call(ie);
          };
        }
        b7(l, Y, i, _);
      }
      return aj(Y);
    }
    var FI = !1;
    function oZ(i) {
      {
        FI || (FI = !0, c("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var l = aZ.current;
        if (l !== null && l.stateNode !== null) {
          var g = l.stateNode._warnedAboutRefsInRender;
          g || c("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Qa(l.type) || "A component"), l.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return i == null ? null : i.nodeType === pl ? i : GQ(i, "findDOMNode");
    }
    function lZ(i, l, g) {
      if (c("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !S7(l))
        throw new Error("Target container is not a DOM element.");
      {
        var S = t1(l) && l._reactRootContainer === void 0;
        S && c("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return oj(null, i, l, !0, g);
    }
    function cZ(i, l, g) {
      if (c("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !S7(l))
        throw new Error("Target container is not a DOM element.");
      {
        var S = t1(l) && l._reactRootContainer === void 0;
        S && c("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return oj(null, i, l, !1, g);
    }
    function uZ(i, l, g, S) {
      if (c("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !S7(g))
        throw new Error("Target container is not a DOM element.");
      if (i == null || !$a(i))
        throw new Error("parentComponent must be a valid React Component");
      return oj(i, l, g, !1, S);
    }
    var UI = !1;
    function dZ(i) {
      if (UI || (UI = !0, c("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !S7(i))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var l = t1(i) && i._reactRootContainer === void 0;
        l && c("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (i._reactRootContainer) {
        {
          var g = hM(i), S = g && !P0(g);
          S && c("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return vv(function() {
          oj(null, null, i, !1, function() {
            i._reactRootContainer = null, Dn(i);
          });
        }), !0;
      } else {
        {
          var _ = hM(i), F = !!(_ && P0(_)), Y = i.nodeType === pl && S7(i.parentNode) && !!i.parentNode._reactRootContainer;
          F && c("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", Y ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Vp(WQ), Ly(YQ), ig(qQ), ib(xd), ob(Sl), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && c("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), jm(Wh), Nh(GT, rQ, vv);
    function fZ(i, l) {
      var g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!ij(l))
        throw new Error("Target container is not a DOM element.");
      return $Q(i, l, null, g);
    }
    function mZ(i, l, g, S) {
      return uZ(i, l, g, S);
    }
    var pM = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [P0, Px, Ib, Uf, Ch, GT]
    };
    function hZ(i, l) {
      return pM.usingClientEntryPoint || c('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), tZ(i, l);
    }
    function pZ(i, l, g) {
      return pM.usingClientEntryPoint || c('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), rZ(i, l, g);
    }
    function gZ(i) {
      return WL() && c("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), vv(i);
    }
    var yZ = eZ({
      findFiberByHostInstance: Gm,
      bundleType: 1,
      version: lM,
      rendererPackageName: "react-dom"
    });
    if (!yZ && He && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var zI = window.location.protocol;
      /^(https?|file):$/.test(zI) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (zI === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    sh.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = pM, sh.createPortal = fZ, sh.createRoot = hZ, sh.findDOMNode = oZ, sh.flushSync = gZ, sh.hydrate = lZ, sh.hydrateRoot = pZ, sh.render = cZ, sh.unmountComponentAtNode = dZ, sh.unstable_batchedUpdates = GT, sh.unstable_renderSubtreeIntoContainer = mZ, sh.version = lM, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), sh;
}
function UV() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(UV);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (UV(), mD.exports = $ne()) : mD.exports = Gne();
var po = mD.exports, go, gj = po;
if (process.env.NODE_ENV === "production")
  go = gj.createRoot, gj.hydrateRoot;
else {
  var DF = gj.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  go = function(e, t) {
    DF.usingClientEntryPoint = !0;
    try {
      return gj.createRoot(e, t);
    } finally {
      DF.usingClientEntryPoint = !1;
    }
  };
}
const le = {
  Success: "000",
  /***
   * token 만료
   */
  TokenExpired: "001",
  Maximum: "003",
  NotFoundPaymentModel: "007",
  ExpiredInfo: "005",
  AlreadyMembershipSubscription: "006",
  InvalidImage: "008",
  ClosedMembership: "009",
  /***
   * 멤버십을 가입한 멤버가 있음
   */
  AlreadyMemberRegisterMembership: "010",
  NotRegisteredPayment: "012",
  /***
   * 혜택을 가지고 있지 않음
   */
  HasNoRewards: "013",
  AlreadyRegisteredName: "014",
  BadWordName: "015",
  /***
   * 멤버십 구독하고 있지 않음
   */
  HasNoMembershipSubscription: "016",
  /***
   * 커미션 횟수 전부 사용
   */
  HasNoCommission: "017",
  NoRefundItems: "018",
  AlreadyCancelledInfo: "019",
  InvalidPaymentInfo: "020",
  FailedPayment: "021",
  ExpiredProviderToken: "022",
  NoDeleteItem: "023",
  InvalidPaymentTarget: "024",
  NoProductsConnectWithRewards: "025",
  WorkInProcess: "027",
  /***
   * 요청을 처리할 수 있는 상태가 아님
   */
  UnableToProcessRequest: "028",
  InvalidDate: "029",
  AlreadyRequestCommission: "030",
  /*
   * 이미 구매 확정됨
   * */
  AlreadyCompleted: "031",
  NotFoundDao: "033",
  ForbiddenDao: "034",
  Unchangeable: "039",
  FailedUpdateMembershipPaymentType: "040",
  FailedUpdateMembershipPrice: "041",
  FailedUpdateMembershipStartTimeAt: "042",
  FailedUpdateMembershipEndTimeAt: "043",
  FailedSignedUpLimitReached: "045",
  CanNotChangeMembershipNotificationDueToTime: "046"
};
function Ba(e) {
  return typeof (e == null ? void 0 : e[Symbol.iterator]) == "function";
}
function Da(e) {
  return typeof (e == null ? void 0 : e[Symbol.asyncIterator]) == "function";
}
const Wne = function* () {
}, N1 = (e) => e instanceof Promise || e !== null && typeof e == "object" && typeof e.then == "function" && typeof e.catch == "function", x3 = (e) => typeof e == "number", OP = (e) => typeof e == "string";
function hD(e, t) {
  if (t === void 0)
    return (r) => hD(e, r);
  const n = N1(t) ? t.then(e) : e(t);
  return N1(n) ? n.then(() => t) : t;
}
class $v extends Error {
  constructor(t = $v.MESSAGE) {
    super(t);
  }
}
$v.MESSAGE = `'Iterable' can not used with async function.
If you want to deal with async function, see: [toAsync](https://fxts.dev/docs/toAsync)`;
function Yne(e, t) {
  const n = t[Symbol.iterator]();
  return {
    next() {
      const { done: r, value: s } = n.next();
      if (r)
        return {
          done: !0,
          value: void 0
        };
      const o = e(s);
      if (N1(o))
        throw new $v();
      return {
        done: !1,
        value: o
      };
    },
    [Symbol.iterator]() {
      return this;
    }
  };
}
function qne(e, t) {
  const n = t[Symbol.asyncIterator]();
  return {
    async next(r) {
      const { done: s, value: o } = await n.next(r);
      return s ? { done: s, value: o } : {
        done: !1,
        value: await e(o)
      };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function Vd(e, t) {
  if (t === void 0)
    return (n) => Vd(e, n);
  if (Ba(t))
    return Yne(e, t);
  if (Da(t))
    return qne(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function AP(e, t) {
  if (t === void 0)
    return (n) => AP(e, n);
  if (Ba(t) || Da(t))
    return Vd(hD(e), t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
const hy = (e, t) => N1(e) ? e.then(t) : t(e);
function PF(e, t, n) {
  for (const r of n)
    t = e(t, r);
  return t;
}
async function OF(e, t, n) {
  for await (const r of n)
    t = await hy(t, (s) => e(s, r));
  return t;
}
function Rc(e, t, n) {
  if (n === void 0) {
    if (t === void 0)
      return (r) => Rc(e, r);
    if (Ba(t)) {
      const r = t[Symbol.iterator](), { done: s, value: o } = r.next();
      if (s)
        throw new TypeError("'reduce' of empty iterable with no initial value");
      return PF(e, o, {
        [Symbol.iterator]() {
          return r;
        }
      });
    }
    if (Da(t)) {
      const r = t[Symbol.asyncIterator]();
      return r.next().then(({ done: s, value: o }) => {
        if (s)
          throw new TypeError("'reduce' of empty iterable with no initial value");
        return OF(e, o, {
          [Symbol.asyncIterator]() {
            return r;
          }
        });
      });
    }
    throw new TypeError("'iterable' must be type of Iterable or AsyncIterable. Are you looking for 'reduceLazy'?");
  }
  if (Ba(n))
    return PF(e, t, n);
  if (Da(n))
    return OF(e, Promise.resolve(t), n);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function Qu(e, ...t) {
  return Rc(hy, e, t);
}
const Kne = (e) => e === null, b3 = (e) => e === void 0, Xne = (e) => b3(e) || Kne(e);
function I2(e) {
  return Object.fromEntries(Object.entries(e).filter(([, t]) => !Xne(t)));
}
function* ow(e, t, n = 1) {
  if (t === void 0)
    return yield* ow(0, e);
  if (n < 0)
    for (; e > t; )
      yield e, e += n;
  else
    for (; e < t; )
      yield e, e += n;
}
function Qne(e, t) {
  const n = e[Symbol.iterator]();
  for (const r of ow(0, t))
    if (n.next().done)
      return;
}
async function Zne(e, t) {
  const n = e[Symbol.asyncIterator]();
  for await (const r of ow(0, t))
    if ((await n.next()).done)
      return;
}
function LP(e, t = 1 / 0) {
  if (Ba(e))
    return Qne(e, t);
  if (Da(e))
    return Zne(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function Jne(e, t) {
  for (const n of t)
    e(n);
}
async function ere(e, t) {
  for await (const n of t) {
    const r = e(n);
    N1(r) && await r;
  }
}
function IP(e, t) {
  if (t === void 0)
    return (n) => IP(e, n);
  if (Ba(t))
    return Jne(e, t);
  if (Da(t))
    return ere(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
class mE {
  constructor(t) {
    this.length = t;
  }
  static of(t) {
    return new mE(t);
  }
}
const Gv = (e) => e instanceof mE;
function gp(e, t) {
  if (t === void 0)
    return (j) => gp(e, j);
  if (!Number.isFinite(e) || e <= 0)
    throw new RangeError("'length' must be positive integer");
  if (!Da(t))
    throw new TypeError("'iterable' must be type of AsyncIterable");
  const n = t[Symbol.asyncIterator](), r = [];
  let s = Promise.resolve(), o = 0, c = 0, u = !1, m = !1;
  const y = [], b = () => {
    for (; r.length > 0 && o > c; ) {
      const j = r.shift(), [E, T] = y.shift();
      if (j.status === "fulfilled")
        c++, E(j.value), j.value.done && (u = !0);
      else {
        T(j.reason), u = !0;
        break;
      }
    }
  }, w = () => {
    if (m)
      s = s.then(() => void (!u && o > c && w()));
    else {
      const j = Promise.allSettled(Array.from({ length: e }, () => n.next(mE.of(e))));
      m = !0, s = s.then(() => j).then((E) => {
        r.push(...E), m = !1, k();
      });
    }
  };
  function k() {
    u || o === c || (r.length > 0 ? b() : w());
  }
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    next() {
      return o++, u ? { done: !0, value: void 0 } : new Promise((j, E) => {
        y.push([j, E]), k();
      });
    }
  };
}
function* tre(e, t) {
  for (const n of t) {
    yield n;
    const r = e(n);
    if (N1(r))
      throw new $v();
    if (r)
      break;
  }
}
function AF(e, t) {
  const n = t[Symbol.asyncIterator]();
  let r = !1;
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next(s) {
      if (r)
        return { done: !0, value: void 0 };
      const { done: o, value: c } = await n.next(s);
      if (o || r)
        return { done: !0, value: void 0 };
      const u = await e(c);
      return r ? { done: !0, value: void 0 } : (u && (r = !0), { done: !1, value: c });
    }
  };
}
function nre(e, t) {
  let n;
  return {
    async next(r) {
      return n === void 0 && (n = Gv(r) ? AF(e, gp(r.length, t)) : AF(e, t)), n.next(r);
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function G4(e, t) {
  if (t === void 0)
    return (n) => G4(e, n);
  if (Ba(t))
    return tre(e, t);
  if (Da(t))
    return nre(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function v9(e) {
  return !e;
}
function FP(e, t) {
  if (t === void 0)
    return (n) => FP(e, n);
  if (Ba(t))
    return Qu(Vd(e, t), G4(v9), (n) => Rc((r, s) => r && s, !0, n), (n) => n ?? !0, Boolean);
  if (Da(t))
    return Qu(Vd(e, t), G4(v9), (n) => Rc((r, s) => r && s, !0, n), (n) => n ?? !0, Boolean);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function LF(e) {
  return e;
}
function* rre(e, t) {
  const n = t[Symbol.iterator]();
  let r = null;
  for (; e-- > 0 && (r = n.next()).done === !1; )
    yield r.value;
}
function are(e, t) {
  const n = t[Symbol.asyncIterator]();
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next(r) {
      return e-- < 1 ? { done: !0, value: void 0 } : n.next(r);
    }
  };
}
function F2(e, t) {
  if (t === void 0)
    return (n) => F2(e, n);
  if (Ba(t))
    return rre(e, t);
  if (Da(t))
    return are(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
async function sre(e) {
  const t = [];
  for await (const n of e)
    t.push(n);
  return t;
}
function py(e) {
  return Da(e) ? sre(e) : Ba(e) ? Array.from(e) : [];
}
function IF(e) {
  if (Ba(e))
    return Qu(F2(1, e), py, ([t]) => t);
  if (Da(e))
    return Qu(F2(1, e), py, ([t]) => t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
async function* ire(e, t) {
  for await (const n of t)
    await e(n) && (yield n);
}
function ore(e) {
  const t = e[Symbol.asyncIterator](), n = [], r = [];
  let s = !1, o = 0, c = 0, u = Promise.resolve();
  function m(w) {
    const k = t.next(w);
    u = u.then(() => k).then(({ done: j, value: E }) => {
      if (j) {
        for (; n.length > 0; ) {
          const [L] = n.shift();
          L({ done: !0, value: void 0 });
        }
        return void (s = !0);
      }
      const [T, D] = E;
      T && r.push(D), b(w);
    }).catch((j) => {
      for (s = !0; n.length > 0; ) {
        const [, E] = n.shift();
        E(j);
      }
    });
  }
  function y() {
    for (; r.length > 0 && o > c; ) {
      const w = r.shift(), [k] = n.shift();
      k({ done: !1, value: w }), c++;
    }
  }
  function b(w) {
    s || o === c || (r.length > 0 ? y() : m(w));
  }
  return {
    async next(w) {
      return o++, s ? { done: !0, value: void 0 } : new Promise((k, j) => {
        n.push([k, j]), b(w);
      });
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function lre(e, t) {
  const n = t[Symbol.asyncIterator]();
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next(r) {
      const { done: s, value: o } = await n.next(r);
      return s ? {
        done: !0,
        value: void 0
      } : hy(e(o), (c) => ({
        done: s,
        value: [!!c, o]
      }));
    }
  };
}
function cre(e, t) {
  let n;
  return {
    async next(r) {
      return n === void 0 && (n = Gv(r) ? ore(gp(r.length, lre(e, t))) : ire(e, t)), n.next(r);
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function* ure(e, t) {
  for (const n of t) {
    const r = e(n);
    if (N1(r))
      throw new $v();
    r && (yield n);
  }
}
function j1(e, t) {
  if (t === void 0)
    return (n) => j1(e, n);
  if (Ba(t))
    return ure(e, t);
  if (Da(t))
    return cre(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function S3(e, t) {
  if (t === void 0)
    return (n) => S3(e, n);
  if (Ba(t) || Da(t))
    return IF(j1(e, t));
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function pD(e) {
  let t = -1;
  return Vd((n) => [++t, n], e);
}
function dre(e) {
  let t;
  return {
    async next(n) {
      return t === void 0 && (t = Gv(n) ? pD(gp(n.length, e)) : pD(e)), t.next(n);
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function FF(e) {
  if (Da(e))
    return dre(e);
  if (Ba(e))
    return pD(e);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function UP(e, t) {
  if (t === void 0)
    return (n) => UP(e, n);
  if (Ba(t))
    return Qu(FF(t), S3(([, n]) => e(n)), (n) => n ? n[0] : -1);
  if (Da(t))
    return Qu(FF(t), S3(([, n]) => hy(n, e)), (n) => n ? n[0] : -1);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function fre(e) {
  const t = {}, n = (r, [s, o]) => (r[s] = o, r);
  if (Da(e))
    return Rc(n, t, e);
  if (Ba(e))
    return Rc(n, t, e);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function W3(e, t) {
  if (t === void 0)
    return (r) => W3(e, r);
  const n = {};
  if (Ba(t))
    return Rc((r, s) => {
      const o = e(s);
      if (N1(o))
        throw new $v();
      return (r[o] || (r[o] = [])).push(s), r;
    }, n, t);
  if (Da(t))
    return Rc(async (r, s) => {
      const o = await e(s);
      return (r[o] || (r[o] = [])).push(s), r;
    }, n, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function zP(e, t) {
  if (t === void 0)
    return (n) => zP(e, n);
  if (Ba(t))
    return Qu(Vd(e, t), G4(LF), (n) => Rc((r, s) => r || s, !1, n), Boolean);
  if (Da(t))
    return Qu(Vd(e, t), G4(LF), (n) => Rc((r, s) => r || s, !1, n), Boolean);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function BP(e, t) {
  if (t === void 0)
    return (r) => BP(e, r);
  const n = {};
  if (Ba(t))
    return Rc((r, s) => {
      const o = e(s);
      if (N1(o))
        throw new $v();
      return r[o] = s, r;
    }, n, t);
  if (Da(t))
    return Rc(async (r, s) => {
      const o = await e(s);
      return r[o] = s, r;
    }, n, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
const zV = (e) => Array.isArray(e);
function mre(e, t) {
  const n = Rc((r, s) => r == "" ? `${s}` : `${r}${e}${s}`, "", t);
  return n == null ? "" : OP(n) ? n : String(n);
}
function hre(e, t) {
  return Rc((n, r) => n == "" ? `${r}` : `${n}${e}${r}`, "", t).then((n) => n == null ? "" : OP(n) ? n : String(n));
}
function hE(e, t) {
  if (t === void 0)
    return (n) => hE(e, n);
  if (Array.isArray(t) && t.length === 0)
    return "";
  if (Ba(t))
    return mre(e, t);
  if (Da(t))
    return hre(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function BV(e) {
  if (zV(e) || OP(e))
    return e[e.length - 1];
  if (Ba(e))
    return Rc((t, n) => n, e);
  if (Da(e))
    return Rc((t, n) => n, e);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function Gd() {
}
function HV(e, t) {
  return Object.fromEntries(Object.entries(e).filter(([n]) => !t.has(n)));
}
function pre(e, t) {
  const n = new Set(e);
  return HV(t, n);
}
async function gre(e, t) {
  const n = new Set(await py(e));
  return HV(t, n);
}
function VV(e, t) {
  if (t === void 0)
    return (n) => VV(e, n);
  if (Ba(e))
    return pre(e, t);
  if (Da(e))
    return gre(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function HP(e, t) {
  if (t === void 0)
    return (n) => HP(e, n);
  if (Ba(t))
    return j1((n) => hy(e(n), v9), t);
  if (Da(t))
    return j1((n) => hy(e(n), v9), t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function gD(e) {
  const t = e[Symbol.iterator]();
  return {
    async next() {
      const { value: n, done: r } = t.next();
      return N1(n) ? n.then((s) => ({ done: r, value: s })) : { done: r, value: n };
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function* yre(e, t) {
  for (const n of t) {
    const r = e(n);
    if (N1(r))
      throw new $v();
    if (!r)
      break;
    yield n;
  }
}
function UF(e, t) {
  const n = t[Symbol.asyncIterator]();
  let r = !1;
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next(s) {
      const { done: o, value: c } = await n.next(s);
      return o || r ? { done: !0, value: void 0 } : await e(c) ? { done: !1, value: c } : (r = !0, { done: !0, value: void 0 });
    }
  };
}
function vre(e, t) {
  let n;
  return {
    async next(r) {
      return n === void 0 && (n = Gv(r) ? UF(e, gp(r.length, t)) : UF(e, t)), n.next(r);
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function VP(e, t) {
  if (t === void 0)
    return (n) => VP(e, n);
  if (Ba(t))
    return yre(e, t);
  if (Da(t))
    return vre(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function $V(e, t) {
  if (t === void 0)
    return (n) => $V(e, n);
  if (zV(t))
    return t.sort(e);
  if (Ba(t))
    return hy(py(t), (n) => n.sort(e));
  if (Da(t))
    return hy(py(t), (n) => n.sort(e));
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
const GV = "\\ud800-\\udfff", xre = "\\u0300-\\u036f", bre = "\\ufe20-\\ufe2f", Sre = "\\u20d0-\\u20ff", wre = "\\u1ab0-\\u1aff", Cre = "\\u1dc0-\\u1dff", Nre = xre + bre + Sre + wre + Cre, jre = "\\ufe0e\\ufe0f", Ere = `[${GV}]`, $P = `[${Nre}]`, yD = "\\ud83c[\\udffb-\\udfff]", kre = `(?:${$P}|${yD})`, WV = `[^${GV}]`, YV = "(?:\\ud83c[\\udde6-\\uddff]){2}", qV = "[\\ud800-\\udbff][\\udc00-\\udfff]", _re = "\\u200d", KV = `${kre}?`, XV = `[${jre}]?`, Tre = `(?:${_re}(?:${[WV, YV, qV].join("|")})${XV + KV})*`, Mre = XV + KV + Tre, Rre = `${WV}${$P}?`, Dre = `(?:${[
  Rre,
  $P,
  YV,
  qV,
  Ere
].join("|")})`, Pre = RegExp(`${yD}(?=${yD})|${Dre + Mre}`, "g");
function Ore(e) {
  return e.match(Pre) || [];
}
function* Are(e, t) {
  yield* t, yield e;
}
function zF(e, t) {
  const n = t[Symbol.asyncIterator]();
  let r = !1;
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next() {
      if (r)
        return { done: !0, value: void 0 };
      const { value: s, done: o } = await n.next();
      return r ? { done: !0, value: void 0 } : o ? (r = !0, { done: !1, value: await e }) : { done: o, value: s };
    }
  };
}
function Lre(e, t) {
  let n = null;
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next(r) {
      return n === null && (n = Gv(r) ? zF(e, gp(r.length, t)) : zF(e, t)), n.next(r);
    }
  };
}
function QV(e, t) {
  if (t === void 0)
    return (n) => QV(e, n);
  if (Da(t))
    return Lre(N1(e) ? e : Promise.resolve(e), t);
  if (Ba(t))
    return Are(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function* Ire(e, t) {
  const n = t[Symbol.iterator]();
  for (; ; ) {
    const r = py(F2(e, {
      [Symbol.iterator]() {
        return n;
      }
    }));
    if (r.length > 0 && (yield r), r.length < e)
      return;
  }
}
async function* BF(e, t) {
  let n = 0, r = [];
  for await (const s of t)
    n++ < e && r.push(s), n === e && (yield r, n = 0, r = []);
  r.length && (yield r);
}
function Fre(e, t) {
  let n;
  return {
    async next(r) {
      return n === void 0 && (n = Gv(r) ? BF(e, gp(r.length, t)) : BF(e, t)), n.next(r);
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function ZV(e, t) {
  if (t === void 0)
    return (n) => ZV(e, n);
  if (Ba(t))
    return Ire(e, t);
  if (Da(t))
    return Fre(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function* Ure(e, t) {
  yield* e, yield* t;
}
function zre(e, t) {
  let n = !1;
  const r = e[Symbol.asyncIterator](), s = t[Symbol.asyncIterator]();
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next(o) {
      const c = n ? s : r, { done: u, value: m } = await c.next(o);
      return u ? (c === r && (n = !0), s.next(o)) : { done: u, value: m };
    }
  };
}
function HF(e) {
  if (Da(e))
    return e;
  const t = e[Symbol.iterator]();
  return {
    [Symbol.asyncIterator]() {
      return t;
    }
  };
}
function JV(e, t) {
  if (t === void 0)
    return (n) => JV(e, n);
  if (Da(e) || Da(t))
    return zre(HF(e), HF(t));
  if (Ba(e) && Ba(t))
    return Ure(e, t);
  throw new TypeError("'iterable1','iterable2' must be type of Iterable or AsyncIterable");
}
function e$(e, t) {
  if (t === void 0)
    return (s) => e$(e, s);
  const n = /* @__PURE__ */ new Set(), r = (s) => n.has(s) ? !1 : (n.add(s), !0);
  if (Ba(t))
    return Qu(t, j1((s) => hy(e(s), r)));
  if (Da(t))
    return Qu(t, j1((s) => hy(e(s), r)));
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function* Bre(e, t) {
  const n = t[Symbol.iterator](), r = {
    [Symbol.iterator]() {
      return n;
    }
  };
  return LP(r, e), yield* r;
}
async function* VF(e, t) {
  const n = t[Symbol.asyncIterator](), r = {
    [Symbol.asyncIterator]() {
      return n;
    }
  };
  return await LP(r, e), yield* r;
}
function Hre(e, t) {
  let n;
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    next(r) {
      return n === void 0 && (n = Gv(r) ? VF(e, gp(r.length, t)) : VF(e, t)), n.next(r);
    }
  };
}
function GP(e, t) {
  if (t === void 0)
    return (n) => GP(e, n);
  if (e < 0)
    throw new RangeError("'length' must be greater than 0");
  if (Ba(t))
    return Bre(e, t);
  if (Da(t))
    return Hre(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function* Vre(e) {
  for (const t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (yield [t, e[t]]);
}
const WP = function(e) {
  return typeof e != "string" && Ba(e);
};
function t$(e, t) {
  const r = [
    e[Symbol.iterator]()
  ];
  return {
    [Symbol.iterator]() {
      return this;
    },
    next() {
      for (; r.length > 0; ) {
        const s = BV(r), { value: o, done: c } = s.next();
        if (c) {
          r.pop();
          continue;
        }
        if (WP(o) && r.length < t + 1) {
          r.push(o[Symbol.iterator]());
          continue;
        }
        return {
          done: !1,
          value: o
        };
      }
      return {
        done: !0,
        value: void 0
      };
    }
  };
}
function $re(e, t) {
  const n = e[Symbol.asyncIterator]();
  let r = Promise.resolve(), s = Wne(), o = !1;
  const c = [], u = async () => {
    const { done: w, value: k } = await n.next();
    return w ? !1 : (WP(k) ? s = JV(t$(k, t - 1), s) : s = QV(k, s), !0);
  }, m = async () => {
    if (o)
      return { done: !0, value: void 0 };
    const { value: w, done: k } = s.next();
    return k ? await u() ? m() : { done: !0, value: void 0 } : { done: !1, value: w };
  }, y = ({ done: w, value: k }) => {
    if (w || o) {
      for (; c.length > 0; ) {
        const [E] = c.shift();
        E({ done: !0, value: void 0 });
      }
      return;
    }
    const [j] = c.shift();
    j({ done: w, value: k });
  }, b = (w) => {
    o = !0;
    const [k, j] = c.shift();
    j(w);
  };
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next() {
      return new Promise((w, k) => {
        c.push([w, k]), r = r.then(() => m()).then(y).catch(b);
      });
    }
  };
}
function Gre(e, t) {
  const r = [
    e[Symbol.asyncIterator]()
  ];
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next() {
      const s = BV(r);
      if (!s)
        return { done: !0, value: void 0 };
      const { value: o, done: c } = await s.next();
      return c ? (r.pop(), this.next()) : WP(o) && r.length < t + 1 ? (r.push(o[Symbol.iterator]()), this.next()) : {
        done: !1,
        value: o
      };
    }
  };
}
function Wre(e, t) {
  let n = null;
  return {
    async next(r) {
      return n === null && (n = Gv(r) ? $re(gp(r.length, e), t) : Gre(e, t)), n.next(r);
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function a3(e, t = 1) {
  if (Ba(e))
    return t$(e, t);
  if (Da(e))
    return Wre(e, t);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function YP(e, t) {
  if (t === void 0)
    return (n) => a3(Vd(e, n));
  if (Ba(t) || Da(t))
    return a3(Vd(e, t));
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function* Yre(e, t, n) {
  let r = 0;
  for (const s of n)
    r >= e && r < t && (yield s), r += 1;
}
async function* $F(e, t, n) {
  let r = 0;
  for await (const s of n)
    r >= e && r < t && (yield s), r += 1;
}
function qre(e, t, n) {
  let r;
  return {
    [Symbol.asyncIterator]() {
      return this;
    },
    async next(s) {
      return r === void 0 && (r = Gv(s) ? $F(e, t, gp(s.length, n)) : $F(e, t, n)), r.next(s);
    }
  };
}
function j7(e, t, n) {
  if (!x3(e) || !x3(t))
    throw new TypeError("'start' and 'end' must be type of number");
  if (Ba(n))
    return Yre(e, t, n);
  if (Da(n))
    return qre(e, t, n);
  throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
function x9(e, t, n) {
  return n === void 0 ? t === void 0 ? (r) => j7(e, 1 / 0, r) : Ba(t) || Da(t) ? j7(e, 1 / 0, t) : x3(t) ? (r) => j7(e, t, r) : (r) => j7(0, 1 / 0, r) : j7(e, t, n);
}
class Ud {
  constructor(t) {
    this.asyncIterable = t;
  }
  [Symbol.asyncIterator]() {
    return this.asyncIterable[Symbol.asyncIterator]();
  }
  /**
   * Returns AsyncIterable of values by running each applying `f`.
   *
   * see {@link https://fxts.dev/docs/map | map}
   */
  map(t) {
    return new Ud(Vd(t, this.asyncIterable));
  }
  /**
   * Returns flattened AsyncIterable of values by running each element
   * flattening the mapped results.
   *
   * see {@link https://fxts.dev/docs/flatMap | flatMap}
   */
  flatMap(t) {
    return new Ud(YP(t, this.asyncIterable));
  }
  /**
   * Returns flattened AsyncIterable.
   * If first argument is number, more perform flatten
   *
   * @example
   * ```
   * await fx([[1],[[2]]])
   *   .toAsync()
   *   .flat(2).toArray(); // [1,2]
   * ```
   *
   * see {@link https://fxts.dev/docs/flat | flat}
   */
  flat(t) {
    return new Ud(a3(this.asyncIterable, t));
  }
  /**
   * Return AsyncIterable of all elements `f` returns truthy for
   *
   * see {@link https://fxts.dev/docs/filter | filter}
   */
  filter(t) {
    return new Ud(j1(t, this.asyncIterable));
  }
  /**
   * The opposite of filter method
   * AsyncIterable of all elements `f` returns falsy for
   *
   * see {@link https://fxts.dev/docs/reject | reject}
   */
  reject(t) {
    return new Ud(HP(t, this.asyncIterable));
  }
  /**
   * Returns AsyncIterable that taken the first argument `l` values from asyncIterable
   *
   * see {@link https://fxts.dev/docs/take | take}
   */
  take(t) {
    return new Ud(F2(t, this.asyncIterable));
  }
  /**
   * Returns AsyncIterable that taken values until truthy when given `f` is applied.
   *
   * see {@link https://fxts.dev/docs/takeUntil | takeUntil}
   */
  takeUntil(t) {
    return new Ud(G4(t, this.asyncIterable));
  }
  /**
   * Returns AsyncIterable that taken values as long as each value satisfies the give `f`.
   *
   * see {@link https://fxts.dev/docs/takeWhile | takeWhile}
   */
  takeWhile(t) {
    return new Ud(VP(t, this.asyncIterable));
  }
  /**
   * Iterate over an input list,
   * calling a provided `f` for each element in the AsyncIterable.
   *
   * see {@link https://fxts.dev/docs/peek | peek}
   */
  peek(t) {
    return new Ud(AP(t, this.asyncIterable));
  }
  /**
   * Returns all but the first `length` elements of the given asyncIterable.
   *
   * see {@link https://fxts.dev/docs/drop | drop}
   */
  drop(t) {
    return new Ud(GP(t, this.asyncIterable));
  }
  /**
   * Returns AsyncIterable of the given elements from startIndex(inclusive) to endIndex(exclusive).
   *
   * see {@link https://fxts.dev/docs/slice | slice}
   */
  slice(t, n) {
    return b3(n) ? new Ud(x9(t, this.asyncIterable)) : new Ud(x9(t, n, this.asyncIterable));
  }
  /**
   *
   * `chain` allows you to use functions that are not provided in method chaining.
   * The functions available for the `chain` argument return an iterable.
   *
   * @example
   * ```
   * await fx(toAsync(range(1, 4)))
   *   .chain(append(4))
   *   .chain(append(5))
   *   .toArray(); // [1, 2, 3, 4, 5]
   * ```
   */
  chain(t) {
    return new Ud(t(this.asyncIterable));
  }
  /**
   * Concurrent is used to balance the load of multiple asynchronous requests.
   * The first argument receives a number that controls the number of loads, and the second argument is an AsyncIterable.
   *
   * see {@link https://fxts.dev/docs/concurrent | concurrent}
   */
  concurrent(t) {
    return new Ud(gp(t, this.asyncIterable));
  }
  async consume() {
    return LP(this.asyncIterable);
  }
  /**
   * Splits AsyncIterable into sets, grouped by the result of running each value through `f`.
   *
   * see {@link https://fxts.dev/docs/groupBy | groupBy}
   */
  async groupBy(t) {
    return W3(t, this.asyncIterable);
  }
  /**
   * Given `f` that generates a key,
   * turns a list of objects into an object indexing the objects by the given key.
   * Note that if multiple objects generate the same value for the indexing key only the last value will be included in the generated object.
   *
   * see {@link https://fxts.dev/docs/indexBy | indexBy}
   */
  async indexBy(t) {
    return BP(t, this.asyncIterable);
  }
  /**
   * Returns true if any of the values in AsyncIterable pass `f` truth test
   *
   * see {@link https://fxts.dev/docs/some | some}
   */
  async some(t) {
    return zP(t, this.asyncIterable);
  }
  /**
   * Returns true if all of the values in AsyncIterable pass the `f` truth test.
   *
   * see {@link https://fxts.dev/docs/every | every}
   */
  async every(t) {
    return FP(t, this.asyncIterable);
  }
  /**
   * Returns all elements in the given iterable into a string separated by separator.
   *
   * see {@link https://fxts.dev/docs/join | join}
   */
  async join(t) {
    return hE(t, this.asyncIterable);
  }
  /**
   * Looks through each value in AsyncIterable, returning the first one that passes a truth test `f`,
   * or `undefined` if no value passes the test.
   *
   * see {@link https://fxts.dev/docs/find | find}
   */
  async find(t) {
    return S3(t, this.asyncIterable);
  }
  /**
   * Returns the index of the first element of AsyncIterable which matches f, or -1 if no element matches.
   *
   * see {@link https://fxts.dev/docs/findIndex | findIndex}
   */
  async findIndex(t) {
    return UP(t, this.asyncIterable);
  }
  /**
   * Also known as foldl, this method boils down a list of values into a single value.
   *
   * see {@link https://fxts.dev/docs/reduce | reduce}
   */
  async reduce(t, n) {
    return b3(n) ? Rc(t, this.asyncIterable) : Rc(t, n, this.asyncIterable);
  }
  /**
   * Iterates over AsyncIterable, applying each in turn to `f`.
   *
   * see {@link https://fxts.dev/docs/each | each}
   */
  async each(t) {
    return IP(t, this.asyncIterable);
  }
  /**
   * Takes item from AsyncIterable and returns an array.
   *
   * see {@link https://fxts.dev/docs/toArray | toArray}
   */
  async toArray() {
    const t = [];
    for await (const n of this.asyncIterable)
      t.push(n);
    return t;
  }
}
class fm {
  constructor(t) {
    this.iterable = t;
  }
  [Symbol.iterator]() {
    return this.iterable[Symbol.iterator]();
  }
  /**
   * Returns Iterable of values by running each applying `f`.
   *
   * see {@link https://fxts.dev/docs/map | map}
   */
  map(t) {
    return new fm(Vd(t, this.iterable));
  }
  /**
   * Returns flattened Iterable of values by running each element
   * flattening the mapped results.
   *
   * see {@link https://fxts.dev/docs/flatMap | flatMap}
   */
  flatMap(t) {
    return new fm(YP(t, this.iterable));
  }
  /**
   * Returns flattened Iterable.
   * If first argument is number, more perform flatten
   *
   * @example
   * `fx([[1],[[2]]]).flat(2).toArray(); // [1,2]`
   *
   * see {@link https://fxts.dev/docs/flat | flat}
   */
  flat(t) {
    const n = a3(this.iterable, t);
    return new fm(n);
  }
  /**
   * Return Iterable of all elements `f` returns truthy for
   *
   * see {@link https://fxts.dev/docs/filter | filter}
   */
  filter(t) {
    return new fm(j1(t, this.iterable));
  }
  /**
   * The opposite of filter method
   * Iterable of all elements `f` returns falsy for
   *
   * see {@link https://fxts.dev/docs/reject | reject}
   */
  reject(t) {
    return new fm(HP(t, this.iterable));
  }
  /**
   * Returns Iterable that taken the first argument `l` values from iterable
   *
   * see {@link https://fxts.dev/docs/take | take}
   */
  take(t) {
    return new fm(F2(t, this.iterable));
  }
  /**
   * Returns Iterable that taken values until truthy when given `f` is applied.
   *
   * see {@link https://fxts.dev/docs/takeUntil | takeUntil}
   */
  takeUntil(t) {
    return new fm(G4(t, this.iterable));
  }
  /**
   * Returns Iterable that taken values as long as each value satisfies the give `f`.
   *
   * see {@link https://fxts.dev/docs/takeWhile | takeWhile}
   */
  takeWhile(t) {
    return new fm(VP(t, this.iterable));
  }
  /**
   * Iterate over an input list,
   * calling a provided `f` for each element in the Iterable.
   *
   * see {@link https://fxts.dev/docs/peek | peek}
   */
  peek(t) {
    return new fm(AP(t, this.iterable));
  }
  /**
   * Returns all but the first `length` elements of the given iterable.
   *
   * see {@link https://fxts.dev/docs/drop | drop}
   */
  drop(t) {
    return new fm(GP(t, this.iterable));
  }
  /**
   * Returns Iterable of the given elements from startIndex(inclusive) to endIndex(exclusive).
   *
   * see {@link https://fxts.dev/docs/slice | slice}
   */
  slice(t, n) {
    return b3(n) ? new fm(x9(t, this.iterable)) : new fm(x9(t, n, this.iterable));
  }
  /**
   *
   * `chain` allows you to use functions that are not provided in method chaining.
   * The functions available for the `chain` argument return an asyncIterable.
   *
   * @example
   * ```
   * fx(range(1, 4))
   *   .chain(append(4))
   *   .chain(append(5))
   *   .toArray(); // [1, 2, 3, 4, 5]
   * ```
   */
  chain(t) {
    return new fm(t(this.iterable));
  }
  /**
   * Returns AsyncIterable, `toAsync` used when you want to handle Promise values inside Iterable.
   *
   * see {@link https://fxts.dev/docs/toAsync | toAsync}
   */
  toAsync() {
    return new Ud(gD(this.iterable));
  }
  /**
   * Splits Iterable into sets, grouped by the result of running each value through `f`.
   *
   * see {@link https://fxts.dev/docs/groupBy | groupBy}
   */
  groupBy(t) {
    return W3(t, this.iterable);
  }
  /**
   * Given `f` that generates a key,
   * turns a list of objects into an object indexing the objects by the given key.
   * Note that if multiple objects generate the same value for the indexing key only the last value will be included in the generated object.
   *
   * see {@link https://fxts.dev/docs/indexBy | indexBy}
   */
  indexBy(t) {
    return BP(t, this.iterable);
  }
  /**
   * Returns true if any of the values in AsyncIterable pass `f` truth test
   *
   * see {@link https://fxts.dev/docs/some | some}
   */
  some(t) {
    return zP(t, this.iterable);
  }
  /**
   * Returns true if all of the values in AsyncIterable pass the `f` truth test.
   *
   * see {@link https://fxts.dev/docs/every | every}
   */
  every(t) {
    return FP(t, this.iterable);
  }
  /**
   * Returns all elements in the given iterable into a string separated by separator.
   *
   * see {@link https://fxts.dev/docs/join | join}
   */
  join(t) {
    return hE(t, this.iterable);
  }
  /**
   * Looks through each value in AsyncIterable, returning the first one that passes a truth test `f`,
   * or `undefined` if no value passes the test.
   *
   * see {@link https://fxts.dev/docs/find | find}
   */
  find(t) {
    return S3(t, this.iterable);
  }
  /**
   * Returns the index of the first element of AsyncIterable which matches f, or -1 if no element matches.
   *
   * see {@link https://fxts.dev/docs/findIndex | findIndex}
   */
  findIndex(t) {
    return UP(t, this.iterable);
  }
  /**
   * Also known as foldl, this method boils down a list of values into a single value.
   *
   * see {@link https://fxts.dev/docs/reduce | reduce}
   */
  reduce(t, n) {
    return b3(n) ? Rc(t, this.iterable) : Rc(t, n, this.iterable);
  }
  /**
   * Iterates over Iterable, applying each in turn to `f`.
   *
   * see {@link https://fxts.dev/docs/each | each}
   */
  each(t) {
    return IP(t, this.iterable);
  }
  /**
   * Takes item from Iterable and returns an array.
   *
   * see {@link https://fxts.dev/docs/toArray | toArray}
   */
  toArray() {
    return Array.from(this.iterable);
  }
  toIterator() {
    return Array.from(this.iterable);
  }
}
function n$(e) {
  if (Da(e))
    return new Ud(e);
  if (Ba(e))
    return new fm(e);
  throw new TypeError("'fx' must be type of Iterable or AsyncIterable");
}
let r$ = (e = 21) => crypto.getRandomValues(new Uint8Array(e)).reduce((t, n) => (n &= 63, n < 36 ? t += n.toString(36) : n < 62 ? t += (n - 26).toString(36).toUpperCase() : n > 62 ? t += "-" : t += "_", t), "");
const pE = "$", Kre = `ERROR_NOT_FOUND${pE}`, Xre = `ERROR_FORBIDDEN${pE}`, a$ = `ERROR_INTERNAL_SERVER_ERROR${pE}`, Ht = `ERROR_EXPIRED_TOKEN${pE}`, gE = (e, t) => {
  switch (e) {
    case 403:
      t(Xre);
      break;
    case 404:
      t(Kre);
      break;
    case 500:
    default:
      t(a$);
  }
};
async function jn(e, { body: t, init: n }, { client: r, onError: s }) {
  try {
    const o = {
      "x-api-key": await r.getToken()
    }, c = {
      method: "POST",
      referrerPolicy: "no-referrer-when-downgrade",
      credentials: "include",
      headers: {
        "x-mem-trace-id": `${Date.now()}-${r$(10)}`,
        accept: "application/json",
        "Content-Type": "application/json",
        ...I2(o)
      },
      cache: "no-store"
    };
    return fetch(`${r.getOrigin()}${e}`, {
      ...c,
      ...n,
      body: JSON.stringify(t)
    }).then((u) => {
      if (u.ok)
        return u.json();
      gE(u.status, s);
    });
  } catch {
    return {
      code: le.TokenExpired,
      data: null
    };
  }
}
async function Qre(e, t) {
  return jn(
    "/support-settings",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
        return n;
      default:
        throw new Error("postSupportSettings");
    }
  });
}
async function s$(e, t) {
  return jn(
    "/v2/create-support",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.Maximum:
      case le.InvalidImage:
      case le.BadWordName:
        return n;
      default:
        throw new Error("postV2CreateSupport");
    }
  });
}
class Ol {
  constructor({
    client: t,
    isMobile: n,
    isApp: r,
    toggleSpinner: s,
    onError: o,
    onScrollLock: c
  }) {
    this.client = t, this.isMobile = n, this.isApp = r, this.toggleSpinner = s, this.onError = o, this.onScrollLock = c;
  }
}
var i$ = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", c = 0; c < arguments.length; c++) {
        var u = arguments[c];
        u && (o = s(o, r(u)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var c = "";
      for (var u in o)
        t.call(o, u) && o[u] && (c = s(c, u));
      return c;
    }
    function s(o, c) {
      return c ? o ? o + " " + c : o + c : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(i$);
var Zre = i$.exports;
const $ = /* @__PURE__ */ fE(Zre);
var Hg = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_CHANNEL_KEY: "channel-key-e7694500-512d-450e-aedd-6f47dad28dd0", VITE_IMP_ACCOUNT_ID: "imp03882726", VITE_IMP_CHANNEL_KEY: "M3RpWnV1YjFWa3h5dXFyViszYjA5Zz09", VITE_IMP_STORE_ID: "MOImarshop", VITE_STORE_ID: "store-a1ec38af-8bea-4805-8cdb-17632e1ebfdf" };
let Jre = 0;
function Qt(e, t) {
  const n = `atom${++Jre}`, r = {
    toString() {
      return (Hg ? "production" : void 0) !== "production" && this.debugLabel ? n + ":" + this.debugLabel : n;
    }
  };
  return typeof e == "function" ? r.read = e : (r.init = e, r.read = eae, r.write = tae), t && (r.write = t), r;
}
function eae(e) {
  return e(this);
}
function tae(e, t, n) {
  return t(
    this,
    typeof n == "function" ? n(e(this)) : n
  );
}
const GF = (e, t) => e.unstable_is ? e.unstable_is(t) : t === e, SM = (e) => "init" in e, wM = (e) => !!e.write, s3 = Symbol(
  (Hg ? "production" : void 0) !== "production" ? "CONTINUE_PROMISE" : ""
), qP = "pending", nae = "fulfilled", rae = "rejected", aae = (e) => typeof e == "object" && e !== null && s3 in e, yj = /* @__PURE__ */ new WeakMap(), sae = (e, t, n) => {
  if (!yj.has(e)) {
    let r;
    const s = new Promise((o, c) => {
      let u = e;
      const m = (b) => (w) => {
        u === b && (s.status = nae, s.value = w, o(w), n());
      }, y = (b) => (w) => {
        u === b && (s.status = rae, s.reason = w, c(w), n());
      };
      e.then(m(e), y(e)), r = (b, w) => {
        b && (yj.set(b, s), u = b, b.then(m(b), y(b)), t(), t = w);
      };
    });
    s.status = qP, s[s3] = r, yj.set(e, s);
  }
  return yj.get(e);
}, iae = (e) => typeof (e == null ? void 0 : e.then) == "function", WF = (e) => "v" in e || "e" in e, vj = (e) => {
  if ("e" in e)
    throw e.e;
  if ((Hg ? "production" : void 0) !== "production" && !("v" in e))
    throw new Error("[Bug] atom state is not initialized");
  return e.v;
}, xj = (e) => {
  const t = e.v;
  return aae(t) && t.status === qP ? t : null;
}, YF = (e, t, n) => {
  n.p.has(e) || (n.p.add(e), t.then(
    () => {
      n.p.delete(e);
    },
    () => {
      n.p.delete(e);
    }
  ));
}, n8 = () => [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map(), /* @__PURE__ */ new Set()], CM = (e, t, n) => {
  e[0].has(t) || e[0].set(t, /* @__PURE__ */ new Set()), e[1].set(t, n);
}, oae = (e, t, n) => {
  const r = e[0].get(t);
  r && r.add(n);
}, lae = (e, t) => e[0].get(t), qF = (e, t) => {
  e[2].add(t);
}, S4 = (e) => {
  for (; e[1].size || e[2].size; ) {
    e[0].clear();
    const t = new Set(e[1].values());
    e[1].clear();
    const n = new Set(e[2]);
    e[2].clear(), t.forEach((r) => {
      var s;
      return (s = r.m) == null ? void 0 : s.l.forEach((o) => o());
    }), n.forEach((r) => r());
  }
}, X2 = () => {
  const e = /* @__PURE__ */ new WeakMap();
  let t;
  (Hg ? "production" : void 0) !== "production" && (t = /* @__PURE__ */ new Set());
  const n = (T) => {
    let D = e.get(T);
    return D || (D = { d: /* @__PURE__ */ new Map(), p: /* @__PURE__ */ new Set(), n: 0 }, e.set(T, D)), D;
  }, r = (T, D, L, I = () => {
  }, R = () => {
  }) => {
    const U = "v" in D, z = D.v, H = xj(D);
    if (iae(L))
      if (H)
        H !== L && (H[s3](L, I), ++D.n);
      else {
        const K = sae(
          L,
          I,
          R
        );
        if (K.status === qP)
          for (const q of D.d.keys()) {
            const Q = n(q);
            YF(
              T,
              K,
              Q
            );
          }
        D.v = K, delete D.e;
      }
    else
      H && H[s3](
        Promise.resolve(L),
        I
      ), D.v = L, delete D.e;
    (!U || !Object.is(z, D.v)) && ++D.n;
  }, s = (T, D, L, I) => {
    var R;
    if ((Hg ? "production" : void 0) !== "production" && L === D)
      throw new Error("[Bug] atom cannot depend on itself");
    const U = n(D);
    U.d.set(L, I.n);
    const z = xj(U);
    z && YF(D, z, I), (R = I.m) == null || R.t.add(D), T && oae(T, L, D);
  }, o = (T, D, L) => {
    const I = n(D);
    if (!(L != null && L(D)) && WF(I) && (I.m || Array.from(I.d).every(
      ([q, Q]) => (
        // Recursively, read the atom state of the dependency, and
        // check if the atom epoch number is unchanged
        o(T, q, L).n === Q
      )
    )))
      return I;
    I.d.clear();
    let R = !0;
    const U = (q) => {
      if (GF(D, q)) {
        const Z = n(q);
        if (!WF(Z))
          if (SM(q))
            r(q, Z, q.init);
          else
            throw new Error("no atom init");
        return vj(Z);
      }
      const Q = o(T, q, L);
      if (R)
        s(T, D, q, Q);
      else {
        const Z = n8();
        s(Z, D, q, Q), b(Z, D, I), S4(Z);
      }
      return vj(Q);
    };
    let z, H;
    const K = {
      get signal() {
        return z || (z = new AbortController()), z.signal;
      },
      get setSelf() {
        return (Hg ? "production" : void 0) !== "production" && !wM(D) && console.warn("setSelf function cannot be used with read-only atom"), !H && wM(D) && (H = (...q) => {
          if ((Hg ? "production" : void 0) !== "production" && R && console.warn("setSelf function cannot be called in sync"), !R)
            return y(D, ...q);
        }), H;
      }
    };
    try {
      const q = D.read(U, K);
      return r(
        D,
        I,
        q,
        () => z == null ? void 0 : z.abort(),
        () => {
          if (I.m) {
            const Q = n8();
            b(Q, D, I), S4(Q);
          }
        }
      ), I;
    } catch (q) {
      return delete I.v, I.e = q, ++I.n, I;
    } finally {
      R = !1;
    }
  }, c = (T) => vj(o(void 0, T)), u = (T, D) => {
    const L = (K) => {
      var q, Q;
      const Z = n(K), X = new Set((q = Z.m) == null ? void 0 : q.t);
      for (const se of Z.p)
        X.add(se);
      return (Q = lae(T, K)) == null || Q.forEach((se) => {
        X.add(se);
      }), X;
    }, I = [], R = /* @__PURE__ */ new Set(), U = (K) => {
      if (!R.has(K)) {
        R.add(K);
        for (const q of L(K))
          K !== q && U(q);
        I.push(K);
      }
    };
    U(D);
    const z = /* @__PURE__ */ new Set([D]), H = (K) => R.has(K);
    for (let K = I.length - 1; K >= 0; --K) {
      const q = I[K], Q = n(q), Z = Q.n;
      let X = !1;
      for (const se of Q.d.keys())
        if (se !== q && z.has(se)) {
          X = !0;
          break;
        }
      X && (o(T, q, H), b(T, q, Q), Z !== Q.n && (CM(T, q, Q), z.add(q))), R.delete(q);
    }
  }, m = (T, D, ...L) => {
    const I = (z) => vj(o(T, z)), R = (z, ...H) => {
      let K;
      if (GF(D, z)) {
        if (!SM(z))
          throw new Error("atom not writable");
        const q = n(z), Q = "v" in q, Z = q.v, X = H[0];
        r(z, q, X), b(T, z, q), (!Q || !Object.is(Z, q.v)) && (CM(T, z, q), u(T, z));
      } else
        K = m(T, z, ...H);
      return S4(T), K;
    };
    return D.write(I, R, ...L);
  }, y = (T, ...D) => {
    const L = n8(), I = m(L, T, ...D);
    return S4(L), I;
  }, b = (T, D, L) => {
    if (L.m && !xj(L)) {
      for (const I of L.d.keys())
        L.m.d.has(I) || (w(T, I).t.add(D), L.m.d.add(I));
      for (const I of L.m.d || [])
        if (!L.d.has(I)) {
          L.m.d.delete(I);
          const R = k(T, I);
          R == null || R.t.delete(D);
        }
    }
  }, w = (T, D) => {
    const L = n(D);
    if (!L.m) {
      o(T, D);
      for (const I of L.d.keys())
        w(T, I).t.add(D);
      if (L.m = {
        l: /* @__PURE__ */ new Set(),
        d: new Set(L.d.keys()),
        t: /* @__PURE__ */ new Set()
      }, (Hg ? "production" : void 0) !== "production" && t.add(D), wM(D) && D.onMount) {
        const I = L.m, { onMount: R } = D;
        qF(T, () => {
          const U = R(
            (...z) => m(T, D, ...z)
          );
          U && (I.u = U);
        });
      }
    }
    return L.m;
  }, k = (T, D) => {
    const L = n(D);
    if (L.m && !L.m.l.size && !Array.from(L.m.t).some((I) => {
      var R;
      return (R = n(I).m) == null ? void 0 : R.d.has(D);
    })) {
      const I = L.m.u;
      I && qF(T, I), delete L.m, (Hg ? "production" : void 0) !== "production" && t.delete(D);
      for (const U of L.d.keys()) {
        const z = k(T, U);
        z == null || z.t.delete(D);
      }
      const R = xj(L);
      R && R[s3](void 0, () => {
      });
      return;
    }
    return L.m;
  }, E = {
    get: c,
    set: y,
    sub: (T, D) => {
      const L = n8(), I = w(L, T);
      S4(L);
      const R = I.l;
      return R.add(D), () => {
        R.delete(D);
        const U = n8();
        k(U, T), S4(U);
      };
    }
  };
  return (Hg ? "production" : void 0) !== "production" && Object.assign(E, {
    // store dev methods (these are tentative and subject to change without notice)
    dev4_get_internal_weak_map: () => e,
    dev4_get_mounted_atoms: () => t,
    dev4_restore_atoms: (D) => {
      const L = n8();
      for (const [I, R] of D)
        if (SM(I)) {
          const U = n(I), z = "v" in U, H = U.v;
          r(I, U, R), b(L, I, U), (!z || !Object.is(H, U.v)) && (CM(L, I, U), u(L, I));
        }
      S4(L);
    }
  }), E;
};
let E7;
const cae = () => (E7 || (E7 = X2(), (Hg ? "production" : void 0) !== "production" && (globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = E7), globalThis.__JOTAI_DEFAULT_STORE__ !== E7 && console.warn(
  "Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044"
))), E7);
var uae = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_CHANNEL_KEY: "channel-key-e7694500-512d-450e-aedd-6f47dad28dd0", VITE_IMP_ACCOUNT_ID: "imp03882726", VITE_IMP_CHANNEL_KEY: "M3RpWnV1YjFWa3h5dXFyViszYjA5Zz09", VITE_IMP_STORE_ID: "MOImarshop", VITE_STORE_ID: "store-a1ec38af-8bea-4805-8cdb-17632e1ebfdf" };
const o$ = ys(
  void 0
), KP = (e) => Ra(o$) || cae(), lw = ({
  children: e,
  store: t
}) => {
  const n = Rt();
  return !t && !n.current && (n.current = X2()), iV(
    o$.Provider,
    {
      value: t || n.current
    },
    e
  );
}, dae = (e) => typeof (e == null ? void 0 : e.then) == "function", fae = Ee.use || ((e) => {
  if (e.status === "pending")
    throw e;
  if (e.status === "fulfilled")
    return e.value;
  throw e.status === "rejected" ? e.reason : (e.status = "pending", e.then(
    (t) => {
      e.status = "fulfilled", e.value = t;
    },
    (t) => {
      e.status = "rejected", e.reason = t;
    }
  ), e);
});
function Y3(e, t) {
  const n = KP(), [[r, s, o], c] = r5(
    (y) => {
      const b = n.get(e);
      return Object.is(y[0], b) && y[1] === n && y[2] === e ? y : [b, n, e];
    },
    void 0,
    () => [n.get(e), n, e]
  );
  let u = r;
  return (s !== n || o !== e) && (c(), u = n.get(e)), an(() => {
    const y = n.sub(e, () => {
      c();
    });
    return c(), y;
  }, [n, e, void 0]), CZ(u), dae(u) ? fae(u) : u;
}
function Ka(e, t) {
  const n = KP();
  return qa(
    (...s) => {
      if ((uae ? "production" : void 0) !== "production" && !("write" in e))
        throw new Error("not writable atom");
      return n.set(e, ...s);
    },
    [n, e]
  );
}
function Ar(e, t) {
  return [
    Y3(e),
    // We do wrong type assertion here, which results in throwing an error.
    Ka(e)
  ];
}
const KF = /* @__PURE__ */ new WeakMap();
function Al(e, t) {
  const n = KP(), r = mae(n);
  for (const [s, o] of e)
    r.has(s) || (r.add(s), n.set(s, o));
}
const mae = (e) => {
  let t = KF.get(e);
  return t || (t = /* @__PURE__ */ new WeakSet(), KF.set(e, t)), t;
};
var q3 = (e) => e.type === "checkbox", N8 = (e) => e instanceof Date, hm = (e) => e == null;
const l$ = (e) => typeof e == "object";
var hu = (e) => !hm(e) && !Array.isArray(e) && l$(e) && !N8(e), c$ = (e) => hu(e) && e.target ? q3(e.target) ? e.target.checked : e.target.value : e, hae = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, u$ = (e, t) => e.has(hae(t)), pae = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return hu(t) && t.hasOwnProperty("isPrototypeOf");
}, XP = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function du(e) {
  let t;
  const n = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(XP && (e instanceof Blob || e instanceof FileList)) && (n || hu(e)))
    if (t = n ? [] : {}, !n && !pae(e))
      t = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (t[r] = du(e[r]));
  else
    return e;
  return t;
}
var K3 = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Vi = (e) => e === void 0, on = (e, t, n) => {
  if (!t || !hu(e))
    return n;
  const r = K3(t.split(/[,[\].]+?/)).reduce((s, o) => hm(s) ? s : s[o], e);
  return Vi(r) || r === e ? Vi(e[t]) ? n : e[t] : r;
}, ty = (e) => typeof e == "boolean", QP = (e) => /^\w*$/.test(e), d$ = (e) => K3(e.replace(/["|']|\]/g, "").split(/\.|\[/)), bi = (e, t, n) => {
  let r = -1;
  const s = QP(t) ? [t] : d$(t), o = s.length, c = o - 1;
  for (; ++r < o; ) {
    const u = s[r];
    let m = n;
    if (r !== c) {
      const y = e[u];
      m = hu(y) || Array.isArray(y) ? y : isNaN(+s[r + 1]) ? {} : [];
    }
    if (u === "__proto__")
      return;
    e[u] = m, e = e[u];
  }
  return e;
};
const b9 = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, v1 = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Sv = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, f$ = Ee.createContext(null), xp = () => Ee.useContext(f$), S9 = (e) => {
  const { children: t, ...n } = e;
  return Ee.createElement(f$.Provider, { value: n }, t);
};
var m$ = (e, t, n, r = !0) => {
  const s = {
    defaultValues: t._defaultValues
  };
  for (const o in e)
    Object.defineProperty(s, o, {
      get: () => {
        const c = o;
        return t._proxyFormState[c] !== v1.all && (t._proxyFormState[c] = !r || v1.all), n && (n[c] = !0), e[c];
      }
    });
  return s;
}, mm = (e) => hu(e) && !Object.keys(e).length, h$ = (e, t, n, r) => {
  n(e);
  const { name: s, ...o } = e;
  return mm(o) || Object.keys(o).length >= Object.keys(t).length || Object.keys(o).find((c) => t[c] === (!r || v1.all));
}, lh = (e) => Array.isArray(e) ? e : [e], p$ = (e, t, n) => !e || !t || e === t || lh(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function yE(e) {
  const t = Ee.useRef(e);
  t.current = e, Ee.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function gae(e) {
  const t = xp(), { control: n = t.control, disabled: r, name: s, exact: o } = e || {}, [c, u] = Ee.useState(n._formState), m = Ee.useRef(!0), y = Ee.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), b = Ee.useRef(s);
  return b.current = s, yE({
    disabled: r,
    next: (w) => m.current && p$(b.current, w.name, o) && h$(w, y.current, n._updateFormState) && u({
      ...n._formState,
      ...w
    }),
    subject: n._subjects.state
  }), Ee.useEffect(() => (m.current = !0, y.current.isValid && n._updateValid(!0), () => {
    m.current = !1;
  }), [n]), m$(c, n, y.current, !1);
}
var oy = (e) => typeof e == "string", g$ = (e, t, n, r, s) => oy(e) ? (r && t.watch.add(e), on(n, e, s)) : Array.isArray(e) ? e.map((o) => (r && t.watch.add(o), on(n, o))) : (r && (t.watchAll = !0), n);
function yae(e) {
  const t = xp(), { control: n = t.control, name: r, defaultValue: s, disabled: o, exact: c } = e || {}, u = Ee.useRef(r);
  u.current = r, yE({
    disabled: o,
    subject: n._subjects.values,
    next: (b) => {
      p$(u.current, b.name, c) && y(du(g$(u.current, n._names, b.values || n._formValues, !1, s)));
    }
  });
  const [m, y] = Ee.useState(n._getWatch(r, s));
  return Ee.useEffect(() => n._removeUnmounted()), m;
}
function vae(e) {
  const t = xp(), { name: n, disabled: r, control: s = t.control, shouldUnregister: o } = e, c = u$(s._names.array, n), u = yae({
    control: s,
    name: n,
    defaultValue: on(s._formValues, n, on(s._defaultValues, n, e.defaultValue)),
    exact: !0
  }), m = gae({
    control: s,
    name: n,
    exact: !0
  }), y = Ee.useRef(s.register(n, {
    ...e.rules,
    value: u,
    ...ty(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return Ee.useEffect(() => {
    const b = s._options.shouldUnregister || o, w = (k, j) => {
      const E = on(s._fields, k);
      E && E._f && (E._f.mount = j);
    };
    if (w(n, !0), b) {
      const k = du(on(s._options.defaultValues, n));
      bi(s._defaultValues, n, k), Vi(on(s._formValues, n)) && bi(s._formValues, n, k);
    }
    return () => {
      (c ? b && !s._state.action : b) ? s.unregister(n) : w(n, !1);
    };
  }, [n, s, c, o]), Ee.useEffect(() => {
    on(s._fields, n) && s._updateDisabledField({
      disabled: r,
      fields: s._fields,
      name: n,
      value: on(s._fields, n)._f.value
    });
  }, [r, n, s]), {
    field: {
      name: n,
      value: u,
      ...ty(r) || m.disabled ? { disabled: m.disabled || r } : {},
      onChange: Ee.useCallback((b) => y.current.onChange({
        target: {
          value: c$(b),
          name: n
        },
        type: b9.CHANGE
      }), [n]),
      onBlur: Ee.useCallback(() => y.current.onBlur({
        target: {
          value: on(s._formValues, n),
          name: n
        },
        type: b9.BLUR
      }), [n, s]),
      ref: Ee.useCallback((b) => {
        const w = on(s._fields, n);
        w && b && (w._f.ref = {
          focus: () => b.focus(),
          select: () => b.select(),
          setCustomValidity: (k) => b.setCustomValidity(k),
          reportValidity: () => b.reportValidity()
        });
      }, [s._fields, n])
    },
    formState: m,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!on(m.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!on(m.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!on(m.touchedFields, n)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!on(m.validatingFields, n)
      },
      error: {
        enumerable: !0,
        get: () => on(m.errors, n)
      }
    })
  };
}
const vD = (e) => e.render(vae(e));
var xae = (e, t, n, r, s) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: s || !0
  }
} : {}, a2 = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
    const n = (Math.random() * 16 + e) % 16 | 0;
    return (t == "x" ? n : n & 3 | 8).toString(16);
  });
}, NM = (e, t, n = {}) => n.shouldFocus || Vi(n.shouldFocus) ? n.focusName || `${e}.${Vi(n.focusIndex) ? t : n.focusIndex}.` : "", i3 = (e) => ({
  isOnSubmit: !e || e === v1.onSubmit,
  isOnBlur: e === v1.onBlur,
  isOnChange: e === v1.onChange,
  isOnAll: e === v1.all,
  isOnTouch: e === v1.onTouched
}), xD = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const _8 = (e, t, n, r) => {
  for (const s of n || Object.keys(e)) {
    const o = on(e, s);
    if (o) {
      const { _f: c, ...u } = o;
      if (c) {
        if (c.refs && c.refs[0] && t(c.refs[0], s) && !r)
          break;
        if (c.ref && t(c.ref, c.name) && !r)
          break;
        _8(u, t);
      } else hu(u) && _8(u, t);
    }
  }
};
var y$ = (e, t, n) => {
  const r = lh(on(e, n));
  return bi(r, "root", t[n]), bi(e, n, r), e;
}, ZP = (e) => e.type === "file", j2 = (e) => typeof e == "function", w9 = (e) => {
  if (!XP)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, Jj = (e) => oy(e), JP = (e) => e.type === "radio", C9 = (e) => e instanceof RegExp;
const XF = {
  value: !1,
  isValid: !1
}, QF = { value: !0, isValid: !0 };
var v$ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Vi(e[0].attributes.value) ? Vi(e[0].value) || e[0].value === "" ? QF : { value: e[0].value, isValid: !0 } : QF
    ) : XF;
  }
  return XF;
};
const ZF = {
  isValid: !1,
  value: null
};
var x$ = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, ZF) : ZF;
function JF(e, t, n = "validate") {
  if (Jj(e) || Array.isArray(e) && e.every(Jj) || ty(e) && !e)
    return {
      type: n,
      message: Jj(e) ? e : "",
      ref: t
    };
}
var r8 = (e) => hu(e) && !C9(e) ? e : {
  value: e,
  message: ""
}, bD = async (e, t, n, r, s) => {
  const { ref: o, refs: c, required: u, maxLength: m, minLength: y, min: b, max: w, pattern: k, validate: j, name: E, valueAsNumber: T, mount: D, disabled: L } = e._f, I = on(t, E);
  if (!D || L)
    return {};
  const R = c ? c[0] : o, U = (se) => {
    r && R.reportValidity && (R.setCustomValidity(ty(se) ? "" : se || ""), R.reportValidity());
  }, z = {}, H = JP(o), K = q3(o), q = H || K, Q = (T || ZP(o)) && Vi(o.value) && Vi(I) || w9(o) && o.value === "" || I === "" || Array.isArray(I) && !I.length, Z = xae.bind(null, E, n, z), X = (se, te, fe, ce = Sv.maxLength, pe = Sv.minLength) => {
    const Se = se ? te : fe;
    z[E] = {
      type: se ? ce : pe,
      message: Se,
      ref: o,
      ...Z(se ? ce : pe, Se)
    };
  };
  if (s ? !Array.isArray(I) || !I.length : u && (!q && (Q || hm(I)) || ty(I) && !I || K && !v$(c).isValid || H && !x$(c).isValid)) {
    const { value: se, message: te } = Jj(u) ? { value: !!u, message: u } : r8(u);
    if (se && (z[E] = {
      type: Sv.required,
      message: te,
      ref: R,
      ...Z(Sv.required, te)
    }, !n))
      return U(te), z;
  }
  if (!Q && (!hm(b) || !hm(w))) {
    let se, te;
    const fe = r8(w), ce = r8(b);
    if (!hm(I) && !isNaN(I)) {
      const pe = o.valueAsNumber || I && +I;
      hm(fe.value) || (se = pe > fe.value), hm(ce.value) || (te = pe < ce.value);
    } else {
      const pe = o.valueAsDate || new Date(I), Se = (he) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + he), oe = o.type == "time", ue = o.type == "week";
      oy(fe.value) && I && (se = oe ? Se(I) > Se(fe.value) : ue ? I > fe.value : pe > new Date(fe.value)), oy(ce.value) && I && (te = oe ? Se(I) < Se(ce.value) : ue ? I < ce.value : pe < new Date(ce.value));
    }
    if ((se || te) && (X(!!se, fe.message, ce.message, Sv.max, Sv.min), !n))
      return U(z[E].message), z;
  }
  if ((m || y) && !Q && (oy(I) || s && Array.isArray(I))) {
    const se = r8(m), te = r8(y), fe = !hm(se.value) && I.length > +se.value, ce = !hm(te.value) && I.length < +te.value;
    if ((fe || ce) && (X(fe, se.message, te.message), !n))
      return U(z[E].message), z;
  }
  if (k && !Q && oy(I)) {
    const { value: se, message: te } = r8(k);
    if (C9(se) && !I.match(se) && (z[E] = {
      type: Sv.pattern,
      message: te,
      ref: o,
      ...Z(Sv.pattern, te)
    }, !n))
      return U(te), z;
  }
  if (j) {
    if (j2(j)) {
      const se = await j(I, t), te = JF(se, R);
      if (te && (z[E] = {
        ...te,
        ...Z(Sv.validate, te.message)
      }, !n))
        return U(te.message), z;
    } else if (hu(j)) {
      let se = {};
      for (const te in j) {
        if (!mm(se) && !n)
          break;
        const fe = JF(await j[te](I, t), R, te);
        fe && (se = {
          ...fe,
          ...Z(te, fe.message)
        }, U(fe.message), n && (z[E] = se));
      }
      if (!mm(se) && (z[E] = {
        ref: R,
        ...se
      }, !n))
        return z;
    }
  }
  return U(!0), z;
}, jM = (e, t) => [
  ...e,
  ...lh(t)
], EM = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function kM(e, t, n) {
  return [
    ...e.slice(0, t),
    ...lh(n),
    ...e.slice(t)
  ];
}
var _M = (e, t, n) => Array.isArray(e) ? (Vi(e[n]) && (e[n] = void 0), e.splice(n, 0, e.splice(t, 1)[0]), e) : [], TM = (e, t) => [
  ...lh(t),
  ...lh(e)
];
function bae(e, t) {
  let n = 0;
  const r = [...e];
  for (const s of t)
    r.splice(s - n, 1), n++;
  return K3(r).length ? r : [];
}
var MM = (e, t) => Vi(t) ? [] : bae(e, lh(t).sort((n, r) => n - r)), RM = (e, t, n) => {
  [e[t], e[n]] = [e[n], e[t]];
};
function Sae(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = Vi(e) ? r++ : e[t[r++]];
  return e;
}
function wae(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !Vi(e[t]))
      return !1;
  return !0;
}
function jc(e, t) {
  const n = Array.isArray(t) ? t : QP(t) ? [t] : d$(t), r = n.length === 1 ? e : Sae(e, n), s = n.length - 1, o = n[s];
  return r && delete r[o], s !== 0 && (hu(r) && mm(r) || Array.isArray(r) && wae(r)) && jc(e, n.slice(0, -1)), e;
}
var eU = (e, t, n) => (e[t] = n, e);
function Cae(e) {
  const t = xp(), { control: n = t.control, name: r, keyName: s = "id", shouldUnregister: o } = e, [c, u] = Ee.useState(n._getFieldArray(r)), m = Ee.useRef(n._getFieldArray(r).map(a2)), y = Ee.useRef(c), b = Ee.useRef(r), w = Ee.useRef(!1);
  b.current = r, y.current = c, n._names.array.add(r), e.rules && n.register(r, e.rules), yE({
    next: ({ values: z, name: H }) => {
      if (H === b.current || !H) {
        const K = on(z, b.current);
        Array.isArray(K) && (u(K), m.current = K.map(a2));
      }
    },
    subject: n._subjects.array
  });
  const k = Ee.useCallback((z) => {
    w.current = !0, n._updateFieldArray(r, z);
  }, [n, r]), j = (z, H) => {
    const K = lh(du(z)), q = jM(n._getFieldArray(r), K);
    n._names.focus = NM(r, q.length - 1, H), m.current = jM(m.current, K.map(a2)), k(q), u(q), n._updateFieldArray(r, q, jM, {
      argA: EM(z)
    });
  }, E = (z, H) => {
    const K = lh(du(z)), q = TM(n._getFieldArray(r), K);
    n._names.focus = NM(r, 0, H), m.current = TM(m.current, K.map(a2)), k(q), u(q), n._updateFieldArray(r, q, TM, {
      argA: EM(z)
    });
  }, T = (z) => {
    const H = MM(n._getFieldArray(r), z);
    m.current = MM(m.current, z), k(H), u(H), n._updateFieldArray(r, H, MM, {
      argA: z
    });
  }, D = (z, H, K) => {
    const q = lh(du(H)), Q = kM(n._getFieldArray(r), z, q);
    n._names.focus = NM(r, z, K), m.current = kM(m.current, z, q.map(a2)), k(Q), u(Q), n._updateFieldArray(r, Q, kM, {
      argA: z,
      argB: EM(H)
    });
  }, L = (z, H) => {
    const K = n._getFieldArray(r);
    RM(K, z, H), RM(m.current, z, H), k(K), u(K), n._updateFieldArray(r, K, RM, {
      argA: z,
      argB: H
    }, !1);
  }, I = (z, H) => {
    const K = n._getFieldArray(r);
    _M(K, z, H), _M(m.current, z, H), k(K), u(K), n._updateFieldArray(r, K, _M, {
      argA: z,
      argB: H
    }, !1);
  }, R = (z, H) => {
    const K = du(H), q = eU(n._getFieldArray(r), z, K);
    m.current = [...q].map((Q, Z) => !Q || Z === z ? a2() : m.current[Z]), k(q), u([...q]), n._updateFieldArray(r, q, eU, {
      argA: z,
      argB: K
    }, !0, !1);
  }, U = (z) => {
    const H = lh(du(z));
    m.current = H.map(a2), k([...H]), u([...H]), n._updateFieldArray(r, [...H], (K) => K, {}, !0, !1);
  };
  return Ee.useEffect(() => {
    if (n._state.action = !1, xD(r, n._names) && n._subjects.state.next({
      ...n._formState
    }), w.current && (!i3(n._options.mode).isOnSubmit || n._formState.isSubmitted))
      if (n._options.resolver)
        n._executeSchema([r]).then((z) => {
          const H = on(z.errors, r), K = on(n._formState.errors, r);
          (K ? !H && K.type || H && (K.type !== H.type || K.message !== H.message) : H && H.type) && (H ? bi(n._formState.errors, r, H) : jc(n._formState.errors, r), n._subjects.state.next({
            errors: n._formState.errors
          }));
        });
      else {
        const z = on(n._fields, r);
        z && z._f && !(i3(n._options.reValidateMode).isOnSubmit && i3(n._options.mode).isOnSubmit) && bD(z, n._formValues, n._options.criteriaMode === v1.all, n._options.shouldUseNativeValidation, !0).then((H) => !mm(H) && n._subjects.state.next({
          errors: y$(n._formState.errors, H, r)
        }));
      }
    n._subjects.values.next({
      name: r,
      values: { ...n._formValues }
    }), n._names.focus && _8(n._fields, (z, H) => {
      if (n._names.focus && H.startsWith(n._names.focus) && z.focus)
        return z.focus(), 1;
    }), n._names.focus = "", n._updateValid(), w.current = !1;
  }, [c, r, n]), Ee.useEffect(() => (!on(n._formValues, r) && n._updateFieldArray(r), () => {
    (n._options.shouldUnregister || o) && n.unregister(r);
  }), [r, n, s, o]), {
    swap: Ee.useCallback(L, [k, r, n]),
    move: Ee.useCallback(I, [k, r, n]),
    prepend: Ee.useCallback(E, [k, r, n]),
    append: Ee.useCallback(j, [k, r, n]),
    remove: Ee.useCallback(T, [k, r, n]),
    insert: Ee.useCallback(D, [k, r, n]),
    update: Ee.useCallback(R, [k, r, n]),
    replace: Ee.useCallback(U, [k, r, n]),
    fields: Ee.useMemo(() => c.map((z, H) => ({
      ...z,
      [s]: m.current[H] || a2()
    })), [c, s])
  };
}
var DM = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (s) => {
      for (const o of e)
        o.next && o.next(s);
    },
    subscribe: (s) => (e.push(s), {
      unsubscribe: () => {
        e = e.filter((o) => o !== s);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, N9 = (e) => hm(e) || !l$(e);
function M4(e, t) {
  if (N9(e) || N9(t))
    return e === t;
  if (N8(e) && N8(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const s of n) {
    const o = e[s];
    if (!r.includes(s))
      return !1;
    if (s !== "ref") {
      const c = t[s];
      if (N8(o) && N8(c) || hu(o) && hu(c) || Array.isArray(o) && Array.isArray(c) ? !M4(o, c) : o !== c)
        return !1;
    }
  }
  return !0;
}
var b$ = (e) => e.type === "select-multiple", Nae = (e) => JP(e) || q3(e), PM = (e) => w9(e) && e.isConnected, S$ = (e) => {
  for (const t in e)
    if (j2(e[t]))
      return !0;
  return !1;
};
function j9(e, t = {}) {
  const n = Array.isArray(e);
  if (hu(e) || n)
    for (const r in e)
      Array.isArray(e[r]) || hu(e[r]) && !S$(e[r]) ? (t[r] = Array.isArray(e[r]) ? [] : {}, j9(e[r], t[r])) : hm(e[r]) || (t[r] = !0);
  return t;
}
function w$(e, t, n) {
  const r = Array.isArray(e);
  if (hu(e) || r)
    for (const s in e)
      Array.isArray(e[s]) || hu(e[s]) && !S$(e[s]) ? Vi(t) || N9(n[s]) ? n[s] = Array.isArray(e[s]) ? j9(e[s], []) : { ...j9(e[s]) } : w$(e[s], hm(t) ? {} : t[s], n[s]) : n[s] = !M4(e[s], t[s]);
  return n;
}
var bj = (e, t) => w$(e, t, j9(t)), C$ = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => Vi(e) ? e : t ? e === "" ? NaN : e && +e : n && oy(e) ? new Date(e) : r ? r(e) : e;
function OM(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((n) => n.disabled) : t.disabled))
    return ZP(t) ? t.files : JP(t) ? x$(e.refs).value : b$(t) ? [...t.selectedOptions].map(({ value: n }) => n) : q3(t) ? v$(e.refs).value : C$(Vi(t.value) ? e.ref.value : t.value, e);
}
var jae = (e, t, n, r) => {
  const s = {};
  for (const o of e) {
    const c = on(t, o);
    c && bi(s, o, c._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: s,
    shouldUseNativeValidation: r
  };
}, k7 = (e) => Vi(e) ? e : C9(e) ? e.source : hu(e) ? C9(e.value) ? e.value.source : e.value : e, Eae = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function tU(e, t, n) {
  const r = on(e, n);
  if (r || QP(n))
    return {
      error: r,
      name: n
    };
  const s = n.split(".");
  for (; s.length; ) {
    const o = s.join("."), c = on(t, o), u = on(e, o);
    if (c && !Array.isArray(c) && n !== o)
      return { name: n };
    if (u && u.type)
      return {
        name: o,
        error: u
      };
    s.pop();
  }
  return {
    name: n
  };
}
var kae = (e, t, n, r, s) => s.isOnAll ? !1 : !n && s.isOnTouch ? !(t || e) : (n ? r.isOnBlur : s.isOnBlur) ? !e : (n ? r.isOnChange : s.isOnChange) ? e : !0, _ae = (e, t) => !K3(on(e, t)).length && jc(e, t);
const Tae = {
  mode: v1.onSubmit,
  reValidateMode: v1.onChange,
  shouldFocusError: !0
};
function Mae(e = {}) {
  let t = {
    ...Tae,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isLoading: j2(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, s = hu(t.defaultValues) || hu(t.values) ? du(t.defaultValues || t.values) || {} : {}, o = t.shouldUnregister ? {} : du(s), c = {
    action: !1,
    mount: !1,
    watch: !1
  }, u = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, m, y = 0;
  const b = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, w = {
    values: DM(),
    array: DM(),
    state: DM()
  }, k = i3(t.mode), j = i3(t.reValidateMode), E = t.criteriaMode === v1.all, T = (ye) => (ke) => {
    clearTimeout(y), y = setTimeout(ye, ke);
  }, D = async (ye) => {
    if (b.isValid || ye) {
      const ke = t.resolver ? mm((await q()).errors) : await Z(r, !0);
      ke !== n.isValid && w.state.next({
        isValid: ke
      });
    }
  }, L = (ye, ke) => {
    (b.isValidating || b.validatingFields) && ((ye || Array.from(u.mount)).forEach((Pe) => {
      Pe && (ke ? bi(n.validatingFields, Pe, ke) : jc(n.validatingFields, Pe));
    }), w.state.next({
      validatingFields: n.validatingFields,
      isValidating: !mm(n.validatingFields)
    }));
  }, I = (ye, ke = [], Pe, tt, ot = !0, ut = !0) => {
    if (tt && Pe) {
      if (c.action = !0, ut && Array.isArray(on(r, ye))) {
        const Vt = Pe(on(r, ye), tt.argA, tt.argB);
        ot && bi(r, ye, Vt);
      }
      if (ut && Array.isArray(on(n.errors, ye))) {
        const Vt = Pe(on(n.errors, ye), tt.argA, tt.argB);
        ot && bi(n.errors, ye, Vt), _ae(n.errors, ye);
      }
      if (b.touchedFields && ut && Array.isArray(on(n.touchedFields, ye))) {
        const Vt = Pe(on(n.touchedFields, ye), tt.argA, tt.argB);
        ot && bi(n.touchedFields, ye, Vt);
      }
      b.dirtyFields && (n.dirtyFields = bj(s, o)), w.state.next({
        name: ye,
        isDirty: se(ye, ke),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      bi(o, ye, ke);
  }, R = (ye, ke) => {
    bi(n.errors, ye, ke), w.state.next({
      errors: n.errors
    });
  }, U = (ye) => {
    n.errors = ye, w.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, z = (ye, ke, Pe, tt) => {
    const ot = on(r, ye);
    if (ot) {
      const ut = on(o, ye, Vi(Pe) ? on(s, ye) : Pe);
      Vi(ut) || tt && tt.defaultChecked || ke ? bi(o, ye, ke ? ut : OM(ot._f)) : ce(ye, ut), c.mount && D();
    }
  }, H = (ye, ke, Pe, tt, ot) => {
    let ut = !1, Vt = !1;
    const bn = {
      name: ye
    }, mr = !!(on(r, ye) && on(r, ye)._f && on(r, ye)._f.disabled);
    if (!Pe || tt) {
      b.isDirty && (Vt = n.isDirty, n.isDirty = bn.isDirty = se(), ut = Vt !== bn.isDirty);
      const ur = mr || M4(on(s, ye), ke);
      Vt = !!(!mr && on(n.dirtyFields, ye)), ur || mr ? jc(n.dirtyFields, ye) : bi(n.dirtyFields, ye, !0), bn.dirtyFields = n.dirtyFields, ut = ut || b.dirtyFields && Vt !== !ur;
    }
    if (Pe) {
      const ur = on(n.touchedFields, ye);
      ur || (bi(n.touchedFields, ye, Pe), bn.touchedFields = n.touchedFields, ut = ut || b.touchedFields && ur !== Pe);
    }
    return ut && ot && w.state.next(bn), ut ? bn : {};
  }, K = (ye, ke, Pe, tt) => {
    const ot = on(n.errors, ye), ut = b.isValid && ty(ke) && n.isValid !== ke;
    if (e.delayError && Pe ? (m = T(() => R(ye, Pe)), m(e.delayError)) : (clearTimeout(y), m = null, Pe ? bi(n.errors, ye, Pe) : jc(n.errors, ye)), (Pe ? !M4(ot, Pe) : ot) || !mm(tt) || ut) {
      const Vt = {
        ...tt,
        ...ut && ty(ke) ? { isValid: ke } : {},
        errors: n.errors,
        name: ye
      };
      n = {
        ...n,
        ...Vt
      }, w.state.next(Vt);
    }
  }, q = async (ye) => {
    L(ye, !0);
    const ke = await t.resolver(o, t.context, jae(ye || u.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
    return L(ye), ke;
  }, Q = async (ye) => {
    const { errors: ke } = await q(ye);
    if (ye)
      for (const Pe of ye) {
        const tt = on(ke, Pe);
        tt ? bi(n.errors, Pe, tt) : jc(n.errors, Pe);
      }
    else
      n.errors = ke;
    return ke;
  }, Z = async (ye, ke, Pe = {
    valid: !0
  }) => {
    for (const tt in ye) {
      const ot = ye[tt];
      if (ot) {
        const { _f: ut, ...Vt } = ot;
        if (ut) {
          const bn = u.array.has(ut.name);
          L([tt], !0);
          const mr = await bD(ot, o, E, t.shouldUseNativeValidation && !ke, bn);
          if (L([tt]), mr[ut.name] && (Pe.valid = !1, ke))
            break;
          !ke && (on(mr, ut.name) ? bn ? y$(n.errors, mr, ut.name) : bi(n.errors, ut.name, mr[ut.name]) : jc(n.errors, ut.name));
        }
        !mm(Vt) && await Z(Vt, ke, Pe);
      }
    }
    return Pe.valid;
  }, X = () => {
    for (const ye of u.unMount) {
      const ke = on(r, ye);
      ke && (ke._f.refs ? ke._f.refs.every((Pe) => !PM(Pe)) : !PM(ke._f.ref)) && it(ye);
    }
    u.unMount = /* @__PURE__ */ new Set();
  }, se = (ye, ke) => (ye && ke && bi(o, ye, ke), !M4(ve(), s)), te = (ye, ke, Pe) => g$(ye, u, {
    ...c.mount ? o : Vi(ke) ? s : oy(ye) ? { [ye]: ke } : ke
  }, Pe, ke), fe = (ye) => K3(on(c.mount ? o : s, ye, e.shouldUnregister ? on(s, ye, []) : [])), ce = (ye, ke, Pe = {}) => {
    const tt = on(r, ye);
    let ot = ke;
    if (tt) {
      const ut = tt._f;
      ut && (!ut.disabled && bi(o, ye, C$(ke, ut)), ot = w9(ut.ref) && hm(ke) ? "" : ke, b$(ut.ref) ? [...ut.ref.options].forEach((Vt) => Vt.selected = ot.includes(Vt.value)) : ut.refs ? q3(ut.ref) ? ut.refs.length > 1 ? ut.refs.forEach((Vt) => (!Vt.defaultChecked || !Vt.disabled) && (Vt.checked = Array.isArray(ot) ? !!ot.find((bn) => bn === Vt.value) : ot === Vt.value)) : ut.refs[0] && (ut.refs[0].checked = !!ot) : ut.refs.forEach((Vt) => Vt.checked = Vt.value === ot) : ZP(ut.ref) ? ut.ref.value = "" : (ut.ref.value = ot, ut.ref.type || w.values.next({
        name: ye,
        values: { ...o }
      })));
    }
    (Pe.shouldDirty || Pe.shouldTouch) && H(ye, ot, Pe.shouldTouch, Pe.shouldDirty, !0), Pe.shouldValidate && he(ye);
  }, pe = (ye, ke, Pe) => {
    for (const tt in ke) {
      const ot = ke[tt], ut = `${ye}.${tt}`, Vt = on(r, ut);
      (u.array.has(ye) || !N9(ot) || Vt && !Vt._f) && !N8(ot) ? pe(ut, ot, Pe) : ce(ut, ot, Pe);
    }
  }, Se = (ye, ke, Pe = {}) => {
    const tt = on(r, ye), ot = u.array.has(ye), ut = du(ke);
    bi(o, ye, ut), ot ? (w.array.next({
      name: ye,
      values: { ...o }
    }), (b.isDirty || b.dirtyFields) && Pe.shouldDirty && w.state.next({
      name: ye,
      dirtyFields: bj(s, o),
      isDirty: se(ye, ut)
    })) : tt && !tt._f && !hm(ut) ? pe(ye, ut, Pe) : ce(ye, ut, Pe), xD(ye, u) && w.state.next({ ...n }), w.values.next({
      name: c.mount ? ye : void 0,
      values: { ...o }
    });
  }, oe = async (ye) => {
    c.mount = !0;
    const ke = ye.target;
    let Pe = ke.name, tt = !0;
    const ot = on(r, Pe), ut = () => ke.type ? OM(ot._f) : c$(ye), Vt = (bn) => {
      tt = Number.isNaN(bn) || bn === on(o, Pe, bn);
    };
    if (ot) {
      let bn, mr;
      const ur = ut(), _r = ye.type === b9.BLUR || ye.type === b9.FOCUS_OUT, ai = !Eae(ot._f) && !t.resolver && !on(n.errors, Pe) && !ot._f.deps || kae(_r, on(n.touchedFields, Pe), n.isSubmitted, j, k), ls = xD(Pe, u, _r);
      bi(o, Pe, ur), _r ? (ot._f.onBlur && ot._f.onBlur(ye), m && m(0)) : ot._f.onChange && ot._f.onChange(ye);
      const Ot = H(Pe, ur, _r, !1), En = !mm(Ot) || ls;
      if (!_r && w.values.next({
        name: Pe,
        type: ye.type,
        values: { ...o }
      }), ai)
        return b.isValid && D(), En && w.state.next({ name: Pe, ...ls ? {} : Ot });
      if (!_r && ls && w.state.next({ ...n }), t.resolver) {
        const { errors: Xt } = await q([Pe]);
        if (Vt(ur), tt) {
          const qt = tU(n.errors, r, Pe), In = tU(Xt, r, qt.name || Pe);
          bn = In.error, Pe = In.name, mr = mm(Xt);
        }
      } else
        L([Pe], !0), bn = (await bD(ot, o, E, t.shouldUseNativeValidation))[Pe], L([Pe]), Vt(ur), tt && (bn ? mr = !1 : b.isValid && (mr = await Z(r, !0)));
      tt && (ot._f.deps && he(ot._f.deps), K(Pe, mr, bn, Ot));
    }
  }, ue = (ye, ke) => {
    if (on(n.errors, ke) && ye.focus)
      return ye.focus(), 1;
  }, he = async (ye, ke = {}) => {
    let Pe, tt;
    const ot = lh(ye);
    if (t.resolver) {
      const ut = await Q(Vi(ye) ? ye : ot);
      Pe = mm(ut), tt = ye ? !ot.some((Vt) => on(ut, Vt)) : Pe;
    } else ye ? (tt = (await Promise.all(ot.map(async (ut) => {
      const Vt = on(r, ut);
      return await Z(Vt && Vt._f ? { [ut]: Vt } : Vt);
    }))).every(Boolean), !(!tt && !n.isValid) && D()) : tt = Pe = await Z(r);
    return w.state.next({
      ...!oy(ye) || b.isValid && Pe !== n.isValid ? {} : { name: ye },
      ...t.resolver || !ye ? { isValid: Pe } : {},
      errors: n.errors
    }), ke.shouldFocus && !tt && _8(r, ue, ye ? ot : u.mount), tt;
  }, ve = (ye) => {
    const ke = {
      ...c.mount ? o : s
    };
    return Vi(ye) ? ke : oy(ye) ? on(ke, ye) : ye.map((Pe) => on(ke, Pe));
  }, Te = (ye, ke) => ({
    invalid: !!on((ke || n).errors, ye),
    isDirty: !!on((ke || n).dirtyFields, ye),
    error: on((ke || n).errors, ye),
    isValidating: !!on(n.validatingFields, ye),
    isTouched: !!on((ke || n).touchedFields, ye)
  }), Ie = (ye) => {
    ye && lh(ye).forEach((ke) => jc(n.errors, ke)), w.state.next({
      errors: ye ? n.errors : {}
    });
  }, Ue = (ye, ke, Pe) => {
    const tt = (on(r, ye, { _f: {} })._f || {}).ref, ot = on(n.errors, ye) || {}, { ref: ut, message: Vt, type: bn, ...mr } = ot;
    bi(n.errors, ye, {
      ...mr,
      ...ke,
      ref: tt
    }), w.state.next({
      name: ye,
      errors: n.errors,
      isValid: !1
    }), Pe && Pe.shouldFocus && tt && tt.focus && tt.focus();
  }, qe = (ye, ke) => j2(ye) ? w.values.subscribe({
    next: (Pe) => ye(te(void 0, ke), Pe)
  }) : te(ye, ke, !0), it = (ye, ke = {}) => {
    for (const Pe of ye ? lh(ye) : u.mount)
      u.mount.delete(Pe), u.array.delete(Pe), ke.keepValue || (jc(r, Pe), jc(o, Pe)), !ke.keepError && jc(n.errors, Pe), !ke.keepDirty && jc(n.dirtyFields, Pe), !ke.keepTouched && jc(n.touchedFields, Pe), !ke.keepIsValidating && jc(n.validatingFields, Pe), !t.shouldUnregister && !ke.keepDefaultValue && jc(s, Pe);
    w.values.next({
      values: { ...o }
    }), w.state.next({
      ...n,
      ...ke.keepDirty ? { isDirty: se() } : {}
    }), !ke.keepIsValid && D();
  }, Ne = ({ disabled: ye, name: ke, field: Pe, fields: tt, value: ot }) => {
    if (ty(ye) && c.mount || ye) {
      const ut = ye ? void 0 : Vi(ot) ? OM(Pe ? Pe._f : on(tt, ke)._f) : ot;
      bi(o, ke, ut), H(ke, ut, !1, !1, !0);
    }
  }, Xe = (ye, ke = {}) => {
    let Pe = on(r, ye);
    const tt = ty(ke.disabled);
    return bi(r, ye, {
      ...Pe || {},
      _f: {
        ...Pe && Pe._f ? Pe._f : { ref: { name: ye } },
        name: ye,
        mount: !0,
        ...ke
      }
    }), u.mount.add(ye), Pe ? Ne({
      field: Pe,
      disabled: ke.disabled,
      name: ye,
      value: ke.value
    }) : z(ye, !0, ke.value), {
      ...tt ? { disabled: ke.disabled } : {},
      ...t.progressive ? {
        required: !!ke.required,
        min: k7(ke.min),
        max: k7(ke.max),
        minLength: k7(ke.minLength),
        maxLength: k7(ke.maxLength),
        pattern: k7(ke.pattern)
      } : {},
      name: ye,
      onChange: oe,
      onBlur: oe,
      ref: (ot) => {
        if (ot) {
          Xe(ye, ke), Pe = on(r, ye);
          const ut = Vi(ot.value) && ot.querySelectorAll && ot.querySelectorAll("input,select,textarea")[0] || ot, Vt = Nae(ut), bn = Pe._f.refs || [];
          if (Vt ? bn.find((mr) => mr === ut) : ut === Pe._f.ref)
            return;
          bi(r, ye, {
            _f: {
              ...Pe._f,
              ...Vt ? {
                refs: [
                  ...bn.filter(PM),
                  ut,
                  ...Array.isArray(on(s, ye)) ? [{}] : []
                ],
                ref: { type: ut.type, name: ye }
              } : { ref: ut }
            }
          }), z(ye, !1, void 0, ut);
        } else
          Pe = on(r, ye, {}), Pe._f && (Pe._f.mount = !1), (t.shouldUnregister || ke.shouldUnregister) && !(u$(u.array, ye) && c.action) && u.unMount.add(ye);
      }
    };
  }, xt = () => t.shouldFocusError && _8(r, ue, u.mount), rn = (ye) => {
    ty(ye) && (w.state.next({ disabled: ye }), _8(r, (ke, Pe) => {
      const tt = on(r, Pe);
      tt && (ke.disabled = tt._f.disabled || ye, Array.isArray(tt._f.refs) && tt._f.refs.forEach((ot) => {
        ot.disabled = tt._f.disabled || ye;
      }));
    }, 0, !1));
  }, vt = (ye, ke) => async (Pe) => {
    let tt;
    Pe && (Pe.preventDefault && Pe.preventDefault(), Pe.persist && Pe.persist());
    let ot = du(o);
    if (w.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: ut, values: Vt } = await q();
      n.errors = ut, ot = Vt;
    } else
      await Z(r);
    if (jc(n.errors, "root"), mm(n.errors)) {
      w.state.next({
        errors: {}
      });
      try {
        await ye(ot, Pe);
      } catch (ut) {
        tt = ut;
      }
    } else
      ke && await ke({ ...n.errors }, Pe), xt(), setTimeout(xt);
    if (w.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: mm(n.errors) && !tt,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), tt)
      throw tt;
  }, At = (ye, ke = {}) => {
    on(r, ye) && (Vi(ke.defaultValue) ? Se(ye, du(on(s, ye))) : (Se(ye, ke.defaultValue), bi(s, ye, du(ke.defaultValue))), ke.keepTouched || jc(n.touchedFields, ye), ke.keepDirty || (jc(n.dirtyFields, ye), n.isDirty = ke.defaultValue ? se(ye, du(on(s, ye))) : se()), ke.keepError || (jc(n.errors, ye), b.isValid && D()), w.state.next({ ...n }));
  }, He = (ye, ke = {}) => {
    const Pe = ye ? du(ye) : s, tt = du(Pe), ot = mm(ye), ut = ot ? s : tt;
    if (ke.keepDefaultValues || (s = Pe), !ke.keepValues) {
      if (ke.keepDirtyValues)
        for (const Vt of u.mount)
          on(n.dirtyFields, Vt) ? bi(ut, Vt, on(o, Vt)) : Se(Vt, on(ut, Vt));
      else {
        if (XP && Vi(ye))
          for (const Vt of u.mount) {
            const bn = on(r, Vt);
            if (bn && bn._f) {
              const mr = Array.isArray(bn._f.refs) ? bn._f.refs[0] : bn._f.ref;
              if (w9(mr)) {
                const ur = mr.closest("form");
                if (ur) {
                  ur.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      o = e.shouldUnregister ? ke.keepDefaultValues ? du(s) : {} : du(ut), w.array.next({
        values: { ...ut }
      }), w.values.next({
        values: { ...ut }
      });
    }
    u = {
      mount: ke.keepDirtyValues ? u.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, c.mount = !b.isValid || !!ke.keepIsValid || !!ke.keepDirtyValues, c.watch = !!e.shouldUnregister, w.state.next({
      submitCount: ke.keepSubmitCount ? n.submitCount : 0,
      isDirty: ot ? !1 : ke.keepDirty ? n.isDirty : !!(ke.keepDefaultValues && !M4(ye, s)),
      isSubmitted: ke.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: ot ? {} : ke.keepDirtyValues ? ke.keepDefaultValues && o ? bj(s, o) : n.dirtyFields : ke.keepDefaultValues && ye ? bj(s, ye) : ke.keepDirty ? n.dirtyFields : {},
      touchedFields: ke.keepTouched ? n.touchedFields : {},
      errors: ke.keepErrors ? n.errors : {},
      isSubmitSuccessful: ke.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Pt = (ye, ke) => He(j2(ye) ? ye(o) : ye, ke);
  return {
    control: {
      register: Xe,
      unregister: it,
      getFieldState: Te,
      handleSubmit: vt,
      setError: Ue,
      _executeSchema: q,
      _getWatch: te,
      _getDirty: se,
      _updateValid: D,
      _removeUnmounted: X,
      _updateFieldArray: I,
      _updateDisabledField: Ne,
      _getFieldArray: fe,
      _reset: He,
      _resetDefaultValues: () => j2(t.defaultValues) && t.defaultValues().then((ye) => {
        Pt(ye, t.resetOptions), w.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (ye) => {
        n = {
          ...n,
          ...ye
        };
      },
      _disableForm: rn,
      _subjects: w,
      _proxyFormState: b,
      _setErrors: U,
      get _fields() {
        return r;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return c;
      },
      set _state(ye) {
        c = ye;
      },
      get _defaultValues() {
        return s;
      },
      get _names() {
        return u;
      },
      set _names(ye) {
        u = ye;
      },
      get _formState() {
        return n;
      },
      set _formState(ye) {
        n = ye;
      },
      get _options() {
        return t;
      },
      set _options(ye) {
        t = {
          ...t,
          ...ye
        };
      }
    },
    trigger: he,
    register: Xe,
    handleSubmit: vt,
    watch: qe,
    setValue: Se,
    getValues: ve,
    reset: Pt,
    resetField: At,
    clearErrors: Ie,
    unregister: it,
    setError: Ue,
    setFocus: (ye, ke = {}) => {
      const Pe = on(r, ye), tt = Pe && Pe._f;
      if (tt) {
        const ot = tt.refs ? tt.refs[0] : tt.ref;
        ot.focus && (ot.focus(), ke.shouldSelect && ot.select());
      }
    },
    getFieldState: Te
  };
}
function bp(e = {}) {
  const t = Ee.useRef(), n = Ee.useRef(), [r, s] = Ee.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: j2(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: j2(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...Mae(e),
    formState: r
  });
  const o = t.current.control;
  return o._options = e, yE({
    subject: o._subjects.state,
    next: (c) => {
      h$(c, o._proxyFormState, o._updateFormState, !0) && s({ ...o._formState });
    }
  }), Ee.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ee.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const c = o._getDirty();
      c !== r.isDirty && o._subjects.state.next({
        isDirty: c
      });
    }
  }, [o, r.isDirty]), Ee.useEffect(() => {
    e.values && !M4(e.values, n.current) ? (o._reset(e.values, o._options.resetOptions), n.current = e.values, s((c) => ({ ...c }))) : o._resetDefaultValues();
  }, [e.values, o]), Ee.useEffect(() => {
    e.errors && o._setErrors(e.errors);
  }, [e.errors, o]), Ee.useEffect(() => {
    o._state.mount || (o._updateValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ee.useEffect(() => {
    e.shouldUnregister && o._subjects.values.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), t.current.formState = m$(r, o), t.current;
}
async function eO(e, t) {
  return jn(
    "/update-order",
    {
      body: e
    },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
        return n;
      default:
        throw new Error("postUpdateOrder");
    }
  });
}
async function Rae(e, t) {
  return jn(
    "/delete-support",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
        return n;
      default:
        throw new Error("postDeleteSupport");
    }
  });
}
async function Dae(e, t) {
  return jn(
    "/open-support",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.InvalidImage:
      case le.BadWordName:
        return n;
      default:
        throw new Error("postOpenSupport");
    }
  });
}
async function nU(e, t) {
  return jn(
    "/update-support",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.BadWordName:
        return n;
      default:
        throw new Error("postV2UpdateSupport");
    }
  });
}
const Pae = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_696_77086)" }, /* @__PURE__ */ re.createElement("path", { d: "M6.62913 6.00125L10.3689 2.25625C10.5437 2.08125 10.5437 1.80125 10.3689 1.63125C10.1942 1.45625 9.91456 1.45625 9.73981 1.63125L6 5.37125L2.26019 1.63125C2.08544 1.45625 1.80583 1.45625 1.63107 1.63125C1.45631 1.80625 1.45631 2.08625 1.63107 2.25625L5.37087 6.00125L1.63107 9.74625C1.45631 9.92125 1.45631 10.2013 1.63107 10.3713C1.71595 10.4563 1.83079 10.5013 1.94563 10.5013C2.06047 10.5013 2.17032 10.4563 2.26019 10.3713L6 6.63125L9.73981 10.3713C9.82469 10.4563 9.93953 10.5013 10.0544 10.5013C10.1692 10.5013 10.2791 10.4563 10.3689 10.3713C10.5437 10.1962 10.5437 9.91625 10.3689 9.74625L6.62913 6.00125Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_696_77086" }, /* @__PURE__ */ re.createElement("rect", { width: 12, height: 12 })))), Wd = yn(Pae), Oae = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M12.8403 16.8711H7.15692C6.75692 16.8711 6.42358 17.1961 6.42358 17.6044C6.42358 18.0127 6.74858 18.3377 7.15692 18.3377H12.8403C13.2403 18.3377 13.5736 18.0127 13.5736 17.6044C13.5736 17.1961 13.2486 16.8711 12.8403 16.8711Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8.71525 1.78772C6.18192 2.27939 4.16525 4.33772 3.70692 6.87106C3.26525 9.29606 4.19858 11.5377 5.85692 12.9461C6.22358 13.2627 6.44025 13.7211 6.44025 14.2044V14.5794C6.44025 15.0377 6.81525 15.4127 7.27358 15.4127H12.7486C13.2069 15.4127 13.5819 15.0377 13.5819 14.5794V14.2044C13.5819 13.7211 13.7903 13.2627 14.1653 12.9461C15.5403 11.7711 16.4153 10.0211 16.4153 8.07106C16.4153 4.11272 12.8236 0.996057 8.72358 1.78772H8.71525ZM14.0236 7.16272C13.9319 7.20439 13.8319 7.22106 13.7403 7.22106C13.4569 7.22106 13.1819 7.05439 13.0653 6.77939C12.5403 5.54606 11.3403 4.74606 9.99858 4.74606C9.59858 4.74606 9.26525 4.42106 9.26525 4.01272C9.26525 3.60439 9.59025 3.27939 9.99858 3.27939C11.9236 3.27939 13.6569 4.42939 14.4153 6.20439C14.5736 6.57106 14.3986 7.00439 14.0319 7.16272H14.0236Z" })), tO = yn(Oae), Bt = "https://memb-static.prod.ct.marpplecorp.com/public", AM = `${Bt}/Membership-Community.png`, Ss = {
  membershipName: {
    required: !0,
    maxLength: { value: 28, message: "최대 글자수를 확인해 주세요." }
  },
  membershipDescription: {
    required: !1,
    maxLength: { value: 200, message: "최대 글자수를 확인해 주세요." }
  },
  membershipProductRewardTitle: {
    required: !0,
    maxLength: { value: 60, message: "최대 글자수를 확인해 주세요." }
  },
  membershipThumbnail: {
    required: !1
  },
  membershipPrice: {
    required: !0
  },
  membershipPeriod: {
    required: !0
  },
  rewardTitle: {
    required: !0,
    maxLength: { value: 60, message: "최대 글자수를 확인해 주세요." }
  },
  commissionGuideImage: {
    required: !0
  },
  commissionMessage: {
    required: !0,
    maxLength: { value: 400, message: "최대 글자수를 확인해 주세요." }
  },
  commissionCount: {
    required: !0
  },
  supportName: {
    required: !0,
    maxLength: { value: 28, message: "최대 글자수를 확인해 주세요." }
  },
  supportDescription: {
    maxLength: { value: 2e3, message: "최대 글자수를 확인해 주세요." }
  },
  supportThumbnail: {
    required: !0
  },
  supportThankDescription: {
    maxLength: { value: 200, message: "최대 글자수를 확인해 주세요." }
  },
  commissionDisplayName: {
    required: !0,
    maxLength: { value: 28, message: "최대 글자수를 확인해 주세요." }
  },
  commissionDescription: {
    required: !0,
    maxLength: { value: 120, message: "최대 글자수를 확인해 주세요." }
  },
  commissionThumbnailImageUrl: {
    required: !0
  },
  commissionEstimatedTime: {
    required: !0
  },
  commissionPrice: {
    required: !0
  },
  commissionRequestImages: {
    required: !0
  },
  commissionWorkDescription: {
    required: !0,
    maxLength: { value: 2e3, message: "최대 글자수를 확인해 주세요." }
  },
  commissionLicense: {
    required: !0
  },
  commissionLicenseText: {
    required: !1,
    maxLength: { value: 2e3, message: "최대 글자수를 확인해 주세요." }
  },
  CommissionPreQuestion: {
    required: !1,
    maxLength: { value: 2e3, message: "최대 글자수를 확인해 주세요." }
  },
  CommunityRewardTitle: {
    required: !0,
    maxLength: {
      value: 50,
      message: "최대 글자수를 확인해 주세요."
    }
  },
  membershipNoticeEmailContent: {
    required: !0,
    maxLength: { value: 2e3, message: "최대 글자수를 확인해 주세요." }
  }
}, uo = {
  Card: "card",
  NaverPay: "naverpay",
  KakaoPay: "kakaopay",
  Tosspay: "tosspay",
  Samsungpay: "samsung"
}, Aae = {
  ImageCard: `${Bt}/image-card.png`,
  CreatorProfileDefaultGray: `${Bt}/image-default-heart-creator-profile.png`
}, Lae = {
  ShopDefaultIcon: `${Bt}/client-shop-default-icon.png`
}, Iae = {
  RewardItemBuyDigitalGoods: `${Bt}/reward-item-buy-digital-goods.png`,
  RewardItemBuyGoods: `${Bt}/reward-item-buy-goods.png`,
  RewardItemBuyOrderMade: `${Bt}/reward-item-buy-order-made.png`,
  RewardItemCommission: `${Bt}/reward-item-commission.png`,
  RewardItemCustom: `${Bt}/reward-item-custom.png`,
  SupportCreateMobile: `${Bt}/support-create-mobile.png`,
  MembershipCreateMobile: `${Bt}/membership-create-mobile.png`,
  CommissionCreateMobile: `${Bt}/commission-create-mobile.png`,
  MembershipGuideModalStep1: `${Bt}/membership-guide-modal-step1.png`,
  MembershipGuideModalStep2: `${Bt}/membership-guide-modal-step2.png`,
  MembershipGuideModalStep3: `${Bt}/membership-guide-modal-step3.png`,
  MembershipGuideModalStep4: `${Bt}/membership-guide-modal-step4.png`,
  MembershipGuideModalStep5: `${Bt}/membership-guide-modal-step5.png`,
  MembershipGuideModalStep6: `${Bt}/membership-guide-modal-step6.png`,
  MembershipGuideModalRewardSetupComplete: `${Bt}/membership-guide-modal-reward-setup-complete.png`,
  MembershipGuideModalCommunityRewardAdd: `${Bt}/membership-guide-modal-community-reward-add.png`,
  MembershipGuideModalCommunityIntegration: `${Bt}/membership-guide-modal-community-Integration.png`,
  SupportGuideModalStep1: `${Bt}/support-guide-modal-step1.png`,
  SupportGuideModalStep2: `${Bt}/support-guide-modal-step2.png`,
  SupportGuideModalStep3: `${Bt}/support-guide-modal-step3.png`,
  CommissionGuideModalStep1: `${Bt}/commission-guide-modal-step1.png`,
  CommissionGuideModalStep2: `${Bt}/commission-guide-modal-step2.png`,
  CommissionGuideModalStep3: `${Bt}/commission-guide-modal-step3.png`,
  StudioSection2Product1: `${Bt}/studio-section2-product1.png`,
  StudioSection2Product2: `${Bt}/studio-section2-product2.png`,
  StudioSection2Product3: `${Bt}/studio-section2-product3.png`,
  StudioSection2Product4: `${Bt}/studio-section2-product4.png`,
  StudioSection2Product5: `${Bt}/studio-section2-product5.png`,
  StudioSection2Product6: `${Bt}/studio-section2-product6.png`,
  StudioSection2Product7: `${Bt}/studio-section2-product7.png`,
  StudioSection2Product8: `${Bt}/studio-section2-product8.png`,
  StudioSection2Product9: `${Bt}/studio-section2-product9.png`,
  StudioSection2Product10: `${Bt}/studio-section2-product10.png`,
  StudioSection2Product11: `${Bt}/studio-section2-product11.png`,
  StudioSection3Product1: `${Bt}/studio-section3-product1.png`,
  StudioSection3Product2: `${Bt}/studio-section3-product2.png`,
  StudioSection3Product3: `${Bt}/studio-section3-product3.png`,
  StudioSection3Product4: `${Bt}/studio-section3-product4.png`,
  StudioSection3Product5: `${Bt}/studio-section3-product5.png`,
  StudioSection3Product6: `${Bt}/studio-section3-product6.png`,
  StudioSection3Product7: `${Bt}/studio-section3-product7.png`,
  StudioSection3Product8: `${Bt}/studio-section3-product8.png`,
  StudioSection3Product9: `${Bt}/studio-section3-product9.png`,
  StudioSection3Product10: `${Bt}/studio-section3-product10.png`,
  StudioSection3Product11: `${Bt}/studio-section3-product11.png`,
  StudioSection4Plan1: `${Bt}/studio-section4-plan1-6.png`,
  StudioSection4Plan2: `${Bt}/studio-section4-plan2-6.png`,
  StudioSection4Plan3: `${Bt}/studio-section4-plan3-6.png`,
  StudioSection4Plan4: `${Bt}/studio-section4-plan4-6.png`,
  StudioSection4Plan5: `${Bt}/studio-section4-plan5-6.png`,
  StudioSection4Plan6: `${Bt}/studio-section4-plan6-6.png`,
  StudioSection4Plan7: `${Bt}/studio-section4-plan7-6.png`,
  StudioSection4Plan8: `${Bt}/studio-section4-plan8-6.png`,
  StudioSection5Thumbnail1: `${Bt}/studio-section5-thumbnail1.png`,
  StudioSection5Thumbnail2: `${Bt}/studio-section5-thumbnail2.png`,
  StudioSection5Thumbnail3: `${Bt}/studio-section5-thumbnail3.png`,
  StudioSection5Thumbnail4: `${Bt}/studio-section5-thumbnail4.png`,
  StudioSection5Thumbnail5: `${Bt}/studio-section5-thumbnail5.png`,
  StudioSection5Thumbnail6: `${Bt}/studio-section5-thumbnail6.png`,
  StudioSection6Profile1: `${Bt}/studio-section6-profile1.png`,
  StudioSection6Profile2: `${Bt}/studio-section6-profile2.png`,
  StudioSection6Profile3: `${Bt}/studio-section6-profile3.png`,
  StudioSection6Thumbnail: `${Bt}/studio-section6-thumbnail.png`,
  StudioSection7Ciety1: `${Bt}/studio-section7-ciety1.png`,
  StudioSection7Ciety2: `${Bt}/studio-section7-ciety2.png`,
  StudioSection7Ciety3: `${Bt}/studio-section7-ciety3.png`,
  StudioSection7Ciety4: `${Bt}/studio-section7-ciety4.png`,
  StudioSection7Ciety5: `${Bt}/studio-section7-ciety5.png`,
  StudioSection7Ciety6: `${Bt}/studio-section7-ciety6.png`,
  StudioSection7Ciety7: `${Bt}/studio-section7-ciety7.png`,
  StudioSection7Ciety8: `${Bt}/studio-section7-ciety8.png`,
  StudioSection7Ciety9: `${Bt}/studio-section7-ciety9.png`,
  StudioSection9Bg: `${Bt}/studio-section9-bg.png`,
  StudioSection9Bg2: `${Bt}/studio-section9-bg2.png`,
  CietyGuideImageLiveStream: `${Bt}/ciety-guide-image-live-stream.png`,
  CietyGuideImageChats: `${Bt}/ciety-guide-image-chats.png`,
  CietyGuideImagePosts: `${Bt}/ciety-guide-image-posts.png`,
  CietyGuideImageDm: `${Bt}/ciety-guide-image-message.png`
}, Fae = {
  CharacterMyLuvSad: `${Bt}/key-visual-3d-character-my-luv-sad.png`,
  DeliveryBox: `${Bt}/key-visual-3d-delivery-box.png`,
  MembershipBadge02Silver: `${Bt}/key-visual-3d-membership-badge02-silver.png`,
  MembershipCommissionBlue: `${Bt}/key-visual-3d-membership-commission-blue.png`,
  MembershipCommissionWhite: `${Bt}/key-visual-3d-membership-comission-white.png`,
  MembershipCommunity: `${Bt}/key-visual-3d-membership-communiuty.png`,
  MembershipMeetFan: `${Bt}/key-visual-3d-membership-meet-fan.png`,
  Search: `${Bt}/key-visual-3d-search.png`,
  LoudSpeaker: `${Bt}/key-visual-3d-loud-speaker.png`,
  PrepareStore02: `${Bt}/key-visual-3d-prepare-store-02.png`
}, Uae = {
  [uo.KakaoPay]: `${Bt}/icon-payment-kakaopay.png`,
  [uo.NaverPay]: `${Bt}/icon-payment-naverpay.png`,
  [uo.Samsungpay]: `${Bt}/icon-payment-samsungpay.png`,
  [uo.Tosspay]: `${Bt}/icon-payment-toss.png`
}, kt = {
  Common: Aae,
  Admin: Iae,
  Client: Lae,
  KeyVisual: Fae,
  Pg: Uae
}, nO = {
  Membership: "MEMBERSHIP",
  Support: "SUPPORT",
  Commission: "COMMISSION"
}, ni = {
  Hidden: "HIDDEN",
  Open: "OPEN",
  Closed: "CLOSED",
  Deleted: "DELETED"
}, N$ = (e) => {
  an(() => (window.addEventListener("beforeunload", e), () => {
    window.removeEventListener("beforeunload", e);
  }), [e]);
}, Vn = Symbol("$$hydrate"), ol = Qt(Vn), R1 = Qt(
  Vn
), ia = {
  Client: "client",
  ProjectId: "projectId",
  Supports: "supports",
  SupportMessages: "supportMessages",
  SettingMemberships: "SettingMemberships",
  SettingMembership: "SettingMembership",
  SettingSupports: "SettingSupports",
  SettingCommissions: "SettingCommission",
  PayMethod: "payMethod",
  Memberships: "memberships",
  Membership: "membership",
  ProjectCover: "projectCover",
  CommissionCover: "commissionCover",
  MypageSubscriptions: "mypageSubscriptions",
  MypageSubscriptionsMembershipDetail: "mypageSubscriptionsMembershipDetail",
  MembershipId: "membershipId",
  WidgetCore: "widgetCore",
  UserForPayment: "userForPayment",
  MembershipSupport: "membershipSupport",
  ManagementMembershipRewards: "managementMembershipRewards",
  SupportPayment: "supportPayment",
  PaymentReceipt: "paymentReceipt",
  CommissionsTemp: "commissionsTemp",
  MypageCommissions: "mypageCommissions",
  MypageCommission: "mypageCommission",
  Commissions: "commissions",
  Mainpage: "mainpage",
  MypageMemberships: "mypageMemberships",
  MypageSupports: "mypageSupports",
  ProjectDao: "projectDao"
}, Xr = (e) => `${e}Atom should be hydrated first`, gy = Qt(
  Vn
), zae = Qt(
  null,
  (e, t, n) => {
    const r = e(gy);
    if (r === Vn)
      throw new Error(Xr(ia.SettingSupports));
    t(gy, [
      ...r.filter((s) => s.state !== ni.Closed),
      n,
      ...r.filter((s) => s.state === ni.Closed)
    ]);
  }
), Bae = Qt(
  null,
  (e, t, n) => {
    const r = e(gy);
    if (r === Vn)
      throw new Error(Xr(ia.SettingSupports));
    t(gy, [
      ...r.map(
        (s) => s.id === n.id ? n : s
      )
    ]);
  }
), Hae = Qt(
  null,
  (e, t, n) => {
    const r = e(gy);
    if (r === Vn)
      throw new Error(Xr(ia.SettingSupports));
    t(
      gy,
      r.filter((s) => s.id !== n)
    );
  }
), Vae = Qt(
  null,
  (e, t, n) => {
    const r = e(gy);
    if (r === Vn)
      throw new Error(Xr(ia.SettingSupports));
    t(gy, [
      ...r.filter((s) => s.id !== n.id),
      n
    ]);
  }
), ll = Qt(
  Vn
), Ha = () => {
  const [e, t] = Ar(ol);
  if (e === Vn)
    throw new Error(Xr(ia.Client));
  return {
    client: e,
    setClient: t
  };
}, Tf = () => {
  const [e, t] = Ar(R1);
  if (e === Vn)
    throw new Error(Xr(ia.ProjectId));
  return {
    projectId: e,
    setProjectId: t
  };
};
function $ae() {
  const [e, t] = Ar(gy);
  if (e === Vn)
    throw new Error(Xr(ia.SettingSupports));
  const n = Ka(zae), r = Ka(Bae), s = Ka(Hae), o = Ka(
    Vae
  );
  return {
    settingSupports: e,
    setSettingSupports: t,
    setAddSettingSupport: n,
    setUpdateSettingSupport: r,
    setDeleteSettingSupport: s,
    setMoveToEndSettingSupport: o
  };
}
const Gt = () => {
  const [e, t] = Ar(ll);
  if (e === Vn)
    throw new Error(ia.WidgetCore);
  return {
    widgetCore: e,
    setWidgetCore: t
  };
}, j$ = (e) => new Promise((t) => {
  const n = document.createElement("div"), r = () => {
    var s;
    t(((s = n.firstElementChild) == null ? void 0 : s.innerHTML) || "");
  };
  go(n).render(/* @__PURE__ */ a.jsx("div", { ref: r, children: e }));
});
async function en({ body: e }) {
  const t = await j$(e({ id: "alert-button" }));
  return new Promise((n) => {
    var m, y;
    const r = `
      <div class="twp fixed inset-0 h-full w-full flex-center bg-mshop-dim-60 z-[200]">
        ${t}
      </div>`, s = document.createElement("div");
    s.innerHTML = r;
    const o = s.children[0], c = () => {
      var b;
      (b = document.querySelector("html")) == null || b.classList.remove("overflow-hidden"), document.removeEventListener("keydown", u), document.body.removeChild(o);
    }, u = (b) => {
      (b.key === "Enter" || b.key === "Escape") && (b.preventDefault(), c(), n());
    };
    (m = s.querySelector("#alert-button")) == null || m.addEventListener("click", () => {
      c(), n();
    }), document.addEventListener("keydown", u), (y = document.querySelector("html")) == null || y.classList.add("overflow-hidden"), document.body.appendChild(o);
  });
}
const Gae = (e) => /^[\s가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9]+$/.test(e), Wae = (e) => e.length == 0 ? "" : Qu(
  Ore(e),
  j1((t) => Gae(t)),
  hE("")
), rO = (e) => e.length !== 0 && Wae(e).length === 0;
async function ho({ body: e }) {
  const t = await j$(
    e({ id: "confirm-button" }, { id: "cancel-button" })
  );
  return new Promise((n) => {
    var m, y, b;
    const r = `
      <div class="twp fixed inset-0 h-full w-full flex-center bg-mshop-dim-60 z-[200]">
       ${t}
      </div>`, s = document.createElement("div");
    s.innerHTML = r;
    const o = s.children[0], c = () => {
      var w;
      (w = document.querySelector("html")) == null || w.classList.remove("overflow-hidden"), document.removeEventListener("keydown", u), document.body.removeChild(o);
    }, u = (w) => {
      (w.key === "Enter" || w.key === "Escape") && (w.preventDefault(), c(), w.key === "Enter" ? n(!0) : n(!1));
    };
    (m = s.querySelector("#confirm-button")) == null || m.addEventListener("click", () => {
      c(), n(!0);
    }), (y = s.querySelector("#cancel-button")) == null || y.addEventListener("click", () => {
      c(), n(!1);
    }), document.addEventListener("keydown", u), (b = document.querySelector("html")) == null || b.classList.add("overflow-hidden"), document.body.appendChild(o);
  });
}
const E9 = (e, t) => {
  if (e === null || t === null || typeof e != "object" || typeof t != "object")
    return e === t;
  const n = Array.isArray(e) && Array.isArray(t);
  if (Array.isArray(e) !== Array.isArray(t))
    return !1;
  if (n) {
    if (e.length !== t.length) return !1;
    for (let o = 0; o < e.length; o++)
      if (!E9(e[o], t[o])) return !1;
    return !0;
  }
  const r = Object.keys(e), s = Object.keys(t);
  if (r.length !== s.length)
    return !1;
  for (const o of r)
    if (!s.includes(o) || !E9(
      e[o],
      t[o]
    ))
      return !1;
  return !0;
}, Kl = (e, t) => E9(e, t) ? void 0 : t;
async function Yae(e, { params: t, init: n }, { client: r, onError: s }) {
  try {
    const o = {
      "x-api-key": await r.getToken()
    }, c = {
      method: "GET",
      referrerPolicy: "no-referrer-when-downgrade",
      credentials: "include",
      headers: {
        "x-mem-trace-id": `${Date.now()}-${r$(10)}`,
        accept: "application/json",
        ...I2(o)
      },
      cache: "no-store"
    };
    return fetch(`${r.getOrigin()}${e}${t || ""}`, {
      ...c,
      ...n
    }).then((u) => {
      if (u.ok)
        return u.json();
      gE(u.status, s);
    });
  } catch {
    return {
      code: le.TokenExpired,
      data: null
    };
  }
}
const qae = (e) => Object.entries(e).filter(([, t]) => t != null).map(
  ([t, n]) => `${encodeURIComponent(t)}=${encodeURIComponent(n)}`
).join("&");
async function cw(e, t) {
  return Yae(
    "/upload-image-url",
    {
      params: "?" + qae(e)
    },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
        return n;
      default:
        throw new Error();
    }
  });
}
const Kae = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M21.1202 11.9799C20.6402 11.9799 20.2402 12.3699 20.2402 12.8599V19.8899C20.2402 20.0899 20.0202 20.2599 19.7602 20.2599H4.23023C3.97023 20.2599 3.75023 20.0899 3.75023 19.8899V12.8599C3.75023 12.3799 3.36023 11.9799 2.87023 11.9799C2.38023 11.9799 1.99023 12.3699 1.99023 12.8599V19.8899C1.99023 21.0599 2.99023 22.0099 4.22023 22.0099H19.7502C20.9802 22.0099 21.9802 21.0599 21.9802 19.8899V12.8599C21.9802 12.3799 21.5902 11.9799 21.1002 11.9799H21.1202Z" }), /* @__PURE__ */ re.createElement("path", { d: "M9.36023 6.74993L11.1202 4.98993V15.7099C11.1202 16.1899 11.5102 16.5899 12.0002 16.5899C12.4902 16.5899 12.8802 16.1999 12.8802 15.7099V4.98993L14.6402 6.74993C14.8102 6.91993 15.0402 7.00993 15.2602 7.00993C15.4802 7.00993 15.7102 6.92993 15.8802 6.74993C16.2202 6.40993 16.2202 5.84993 15.8802 5.50993L12.6202 2.24993C12.6202 2.24993 12.5802 2.22993 12.5602 2.20993C12.4902 2.14993 12.4202 2.09993 12.3402 2.05993C12.1302 1.96993 11.8802 1.96993 11.6702 2.05993C11.5902 2.08993 11.5102 2.14993 11.4502 2.20993C11.4302 2.22993 11.4102 2.22993 11.3902 2.24993L8.13023 5.50993C7.79023 5.84993 7.79023 6.40993 8.13023 6.74993C8.47023 7.08993 9.03023 7.08993 9.37023 6.74993H9.36023Z" })), vE = yn(Kae);
function O4(e, t = new Error()) {
  if (!e)
    throw typeof t == "string" ? new Error(t) : t;
}
function wt(e, t = new Error()) {
  if (e == null)
    throw typeof t == "string" ? new Error(t) : t;
}
const aO = (e, t, n) => new Promise((r) => {
  const s = new Image();
  s.src = URL.createObjectURL(e), s.onload = () => {
    s.width < t || s.height < n ? r(!1) : r(!0);
  }, s.onerror = () => {
    throw r(!1), new Error();
  };
});
function Xae() {
  return document.createElement("img");
}
function Qae() {
  return document.createElement("canvas");
}
function Zae(e) {
  const t = atob(e.split(",")[1]), n = e.split(",")[0].split(":")[1].split(";")[0], r = new ArrayBuffer(t.length), s = new Uint8Array(r);
  for (let c = 0; c < t.length; c++)
    s[c] = t.charCodeAt(c);
  return new Blob([r], { type: n });
}
function Jae(e, t) {
  const n = t.width / t.height;
  let r = Math.min(
    t.width,
    e.maxWidth,
    n * e.maxHeight
  );
  return e.scaleRatio && (r = Math.min(r, Math.floor(e.scaleRatio * t.width))), r <= 0 && (r = 1), r;
}
function ese(e, t) {
  const n = document.createElement("canvas"), r = t.outputWidth / e.width;
  n.width = e.width * r, n.height = e.height * r;
  const s = e.getContext("2d").getImageData(0, 0, e.width, e.height), o = n.getContext("2d").createImageData(n.width, n.height);
  return nse(s, o, r), n.getContext("2d").putImageData(o, 0, 0), n;
}
function tse(e) {
  const t = document.createElement("canvas");
  return t.width = e.width / 2, t.height = e.height / 2, t.getContext("2d").drawImage(e, 0, 0, t.width, t.height), t;
}
function nse(e, t, n) {
  function r(K, q, Q, Z, X, se) {
    const te = 1 - X, fe = 1 - se;
    return K * te * fe + q * X * fe + Q * te * se + Z * X * se;
  }
  let s, o, c, u, m, y, b, w, k, j, E, T, D, L, I, R, U, z, H;
  for (s = 0; s < t.height; ++s)
    for (c = s / n, u = Math.floor(c), m = Math.ceil(c) > e.height - 1 ? e.height - 1 : Math.ceil(c), o = 0; o < t.width; ++o)
      y = o / n, b = Math.floor(y), w = Math.ceil(y) > e.width - 1 ? e.width - 1 : Math.ceil(y), k = (o + t.width * s) * 4, j = (b + e.width * u) * 4, E = (w + e.width * u) * 4, T = (b + e.width * m) * 4, D = (w + e.width * m) * 4, L = y - b, I = c - u, R = r(
        e.data[j],
        e.data[E],
        e.data[T],
        e.data[D],
        L,
        I
      ), t.data[k] = R, U = r(
        e.data[j + 1],
        e.data[E + 1],
        e.data[T + 1],
        e.data[D + 1],
        L,
        I
      ), t.data[k + 1] = U, z = r(
        e.data[j + 2],
        e.data[E + 2],
        e.data[T + 2],
        e.data[D + 2],
        L,
        I
      ), t.data[k + 2] = z, H = r(
        e.data[j + 3],
        e.data[E + 3],
        e.data[T + 3],
        e.data[D + 3],
        L,
        I
      ), t.data[k + 3] = H;
}
function rse({ img: e, config: t }) {
  let n = Qae();
  n.width = e.width, n.height = e.height;
  const r = n.getContext("2d");
  t.mimeType === "image/jpeg" && (r.fillStyle = "#ffffff", r.fillRect(0, 0, n.width, n.height), r.save()), r.drawImage(e, 0, 0), r.restore();
  const s = Jae(t, n);
  for (; n.width >= 2 * s; )
    n = tse(n);
  n.width > s && (n = ese(
    n,
    Object.assign(t, { outputWidth: s })
  ));
  const o = n.toDataURL(t.mimeType, t.quality);
  return typeof t.onScale == "function" && t.onScale(o), Zae(o);
}
const ase = {
  quality: 0.5,
  maxWidth: 800,
  maxHeight: 600,
  autoRotate: !0,
  mimeType: "image/jpeg"
};
function sse(e, t) {
  return new Promise((n, r) => {
    const s = Xae(), o = new FileReader(), c = Object.assign({}, ase, t);
    o.onload = function(u) {
      s.onerror = function() {
        r("cannot load image.");
      }, s.onload = function() {
        const m = { img: s, config: c };
        try {
          const y = rse(m);
          n(y);
        } catch (y) {
          r(y);
        }
      }, s.src = u.target.result;
    };
    try {
      o.onerror = function() {
        r("cannot read image file.");
      }, o.readAsDataURL(e);
    } catch (u) {
      r(u);
    }
  });
}
function sO(e, t) {
  return sse(e, t).then(
    ise
  );
}
function ise(e) {
  return new Promise((t) => {
    const n = new FileReader();
    n.onload = () => t(n.result), n.readAsDataURL(e);
  });
}
const ose = ["png", "jpg", "jpeg", "gif"], lse = 5 * 1024 * 1024, SD = yn(
  ({
    name: e,
    title: t,
    recommended: n,
    onLoading: r,
    onError: s,
    onSuccess: o,
    client: c,
    minImageWidth: u,
    minImageHeight: m,
    disabled: y = !1
  }, b) => {
    const w = async (E) => {
      wt(E.currentTarget.files);
      const T = E.currentTarget.files[0];
      await k(T) && await j(T);
    }, k = async (E) => ose.includes(E.type.split("/")[1]) ? E.size > lse ? (s("이미지 크기는 5MB 이하로 업로드해 주세요."), !1) : await aO(E, u, m) ? !0 : (s("이미지 해상도가 너무 낮습니다. 권장 크기를 확인해 주세요."), !1) : (s("PNG, JPG, JPEG, GIF 형식의 이미지만 업로드해 주세요."), !1), j = async (E) => {
      const T = await sO(E, {
        quality: 0.8,
        maxWidth: 120,
        maxHeight: 120
      });
      r(!0), o(T);
      const { code: D, data: L } = await cw({}, { client: c, onError: s });
      if (D === le.TokenExpired)
        return s(Ht);
      (await fetch(L.uploadUrl, {
        method: "PUT",
        referrerPolicy: "no-referrer-when-downgrade",
        headers: {
          "Content-Type": E.type
        },
        cache: "no-store",
        body: E
      })).status === 200 ? (o(L.url), r(!1)) : s("이미지 업로드 실패");
    };
    return /* @__PURE__ */ a.jsxs("div", { children: [
      /* @__PURE__ */ a.jsxs(
        "button",
        {
          type: "button",
          className: "flex max-w-[35.71428rem] cursor-pointer items-center gap-x-[1.14285rem] rounded-b-[0.57rem] bg-mshop-dim-60 p-[1.14285rem] text-left text-mshop-white",
          onClick: () => {
            var E;
            typeof b != "function" && !y && ((E = b == null ? void 0 : b.current) == null || E.click());
          },
          children: [
            /* @__PURE__ */ a.jsx("div", { className: "p-[0.57143rem]", children: /* @__PURE__ */ a.jsx(vE, { className: "size-[2.28571rem] flex-shrink-0 text-mshop-white" }) }),
            /* @__PURE__ */ a.jsxs("div", { children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-b", children: t }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-20", children: [
                n,
                " / PNG, JPG, GIF 형식 / 5MB 이하의 이미지를 업로드해 주세요."
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ a.jsx(
        "input",
        {
          name: e,
          type: "file",
          ref: b,
          className: "hidden",
          multiple: !1,
          accept: ".png, .jpg, .jpeg, .gif",
          onChange: w
        }
      )
    ] });
  }
);
function sl({ message: e }) {
  return /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: /* @__PURE__ */ a.jsx("p", { children: e }) });
}
function w3() {
  return /* @__PURE__ */ a.jsx("div", { className: "size-[.28571rem] shrink-0 rounded-full bg-mshop-blue-100" });
}
function Fs({ label: e, required: t = !1 }) {
  return /* @__PURE__ */ a.jsxs("div", { className: $({ "flex gap-x-[.28571rem]": t }), children: [
    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-black", children: e }),
    t && /* @__PURE__ */ a.jsx("span", { className: "mt-[.28571rem]", children: /* @__PURE__ */ a.jsx(w3, {}) })
  ] });
}
const E$ = typeof document < "u" ? Ee.useLayoutEffect : () => {
};
function cse(e) {
  const t = Rt(null);
  return E$(() => {
    t.current = e;
  }, [
    e
  ]), qa((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
const X3 = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, R4 = (e) => e && "window" in e && e.window === e ? e : X3(e).defaultView || window;
function use(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function dse(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function k$(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const fse = k$(function() {
  return dse(/^Mac/i);
}), mse = k$(function() {
  return use(/Android/i);
});
function hse(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : mse() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
class pse {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, n) {
    this.nativeEvent = n, this.target = n.target, this.currentTarget = n.currentTarget, this.relatedTarget = n.relatedTarget, this.bubbles = n.bubbles, this.cancelable = n.cancelable, this.defaultPrevented = n.defaultPrevented, this.eventPhase = n.eventPhase, this.isTrusted = n.isTrusted, this.timeStamp = n.timeStamp, this.type = t;
  }
}
function _$(e) {
  let t = Rt({
    isFocused: !1,
    observer: null
  });
  E$(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = cse((r) => {
    e == null || e(r);
  });
  return qa((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let s = r.target, o = (c) => {
        t.current.isFocused = !1, s.disabled && n(new pse("blur", c)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      s.addEventListener("focusout", o, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && s.disabled) {
          var c;
          (c = t.current.observer) === null || c === void 0 || c.disconnect();
          let u = s === document.activeElement ? null : document.activeElement;
          s.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: u
          })), s.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: u
          }));
        }
      }), t.current.observer.observe(s, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
function gse(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: s } = e;
  const o = qa((m) => {
    if (m.target === m.currentTarget)
      return r && r(m), s && s(!1), !0;
  }, [
    r,
    s
  ]), c = _$(o), u = qa((m) => {
    const y = X3(m.target);
    m.target === m.currentTarget && y.activeElement === m.target && (n && n(m), s && s(!0), c(m));
  }, [
    s,
    n,
    c
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || s || r) ? u : void 0,
      onBlur: !t && (r || s) ? o : void 0
    }
  };
}
let Q3 = null, wD = /* @__PURE__ */ new Set(), o3 = /* @__PURE__ */ new Map(), W4 = !1, CD = !1;
const yse = {
  Tab: !0,
  Escape: !0
};
function iO(e, t) {
  for (let n of wD) n(e, t);
}
function vse(e) {
  return !(e.metaKey || !fse() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function k9(e) {
  W4 = !0, vse(e) && (Q3 = "keyboard", iO("keyboard", e));
}
function y1(e) {
  Q3 = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (W4 = !0, iO("pointer", e));
}
function T$(e) {
  hse(e) && (W4 = !0, Q3 = "virtual");
}
function M$(e) {
  e.target === window || e.target === document || (!W4 && !CD && (Q3 = "virtual", iO("virtual", e)), W4 = !1, CD = !1);
}
function R$() {
  W4 = !1, CD = !0;
}
function ND(e) {
  if (typeof window > "u" || o3.get(R4(e))) return;
  const t = R4(e), n = X3(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    W4 = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", k9, !0), n.addEventListener("keyup", k9, !0), n.addEventListener("click", T$, !0), t.addEventListener("focus", M$, !0), t.addEventListener("blur", R$, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", y1, !0), n.addEventListener("pointermove", y1, !0), n.addEventListener("pointerup", y1, !0)) : (n.addEventListener("mousedown", y1, !0), n.addEventListener("mousemove", y1, !0), n.addEventListener("mouseup", y1, !0)), t.addEventListener("beforeunload", () => {
    D$(e);
  }, {
    once: !0
  }), o3.set(t, {
    focus: r
  });
}
const D$ = (e, t) => {
  const n = R4(e), r = X3(e);
  t && r.removeEventListener("DOMContentLoaded", t), o3.has(n) && (n.HTMLElement.prototype.focus = o3.get(n).focus, r.removeEventListener("keydown", k9, !0), r.removeEventListener("keyup", k9, !0), r.removeEventListener("click", T$, !0), n.removeEventListener("focus", M$, !0), n.removeEventListener("blur", R$, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", y1, !0), r.removeEventListener("pointermove", y1, !0), r.removeEventListener("pointerup", y1, !0)) : (r.removeEventListener("mousedown", y1, !0), r.removeEventListener("mousemove", y1, !0), r.removeEventListener("mouseup", y1, !0)), o3.delete(n));
};
function xse(e) {
  const t = X3(e);
  let n;
  return t.readyState !== "loading" ? ND(e) : (n = () => {
    ND(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => D$(e, n);
}
typeof document < "u" && xse();
function P$() {
  return Q3 !== "pointer";
}
const bse = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Sse(e, t, n) {
  var r;
  const s = typeof window < "u" ? R4(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, o = typeof window < "u" ? R4(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, c = typeof window < "u" ? R4(n == null ? void 0 : n.target).HTMLElement : HTMLElement, u = typeof window < "u" ? R4(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || (n == null ? void 0 : n.target) instanceof s && !bse.has(n == null || (r = n.target) === null || r === void 0 ? void 0 : r.type) || (n == null ? void 0 : n.target) instanceof o || (n == null ? void 0 : n.target) instanceof c && (n == null ? void 0 : n.target.isContentEditable), !(e && t === "keyboard" && n instanceof u && !yse[n.key]);
}
function wse(e, t, n) {
  ND(), an(() => {
    let r = (s, o) => {
      Sse(!!(n != null && n.isTextInput), s, o) && e(P$());
    };
    return wD.add(r), () => {
      wD.delete(r);
    };
  }, t);
}
function Cse(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: s } = e, o = Rt({
    isFocusWithin: !1
  }), c = qa((y) => {
    o.current.isFocusWithin && !y.currentTarget.contains(y.relatedTarget) && (o.current.isFocusWithin = !1, n && n(y), s && s(!1));
  }, [
    n,
    s,
    o
  ]), u = _$(c), m = qa((y) => {
    !o.current.isFocusWithin && document.activeElement === y.target && (r && r(y), s && s(!0), o.current.isFocusWithin = !0, u(y));
  }, [
    r,
    s,
    u
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: m,
      onBlur: c
    }
  };
}
let _9 = !1, LM = 0;
function jD() {
  _9 = !0, setTimeout(() => {
    _9 = !1;
  }, 50);
}
function rU(e) {
  e.pointerType === "touch" && jD();
}
function Nse() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", rU) : document.addEventListener("touchend", jD), LM++, () => {
      LM--, !(LM > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", rU) : document.removeEventListener("touchend", jD));
    };
}
function jy(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: s } = e, [o, c] = Re(!1), u = Rt({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  an(Nse, []);
  let { hoverProps: m, triggerHoverEnd: y } = dn(() => {
    let b = (j, E) => {
      if (u.pointerType = E, s || E === "touch" || u.isHovered || !j.currentTarget.contains(j.target)) return;
      u.isHovered = !0;
      let T = j.currentTarget;
      u.target = T, t && t({
        type: "hoverstart",
        target: T,
        pointerType: E
      }), n && n(!0), c(!0);
    }, w = (j, E) => {
      if (u.pointerType = "", u.target = null, E === "touch" || !u.isHovered) return;
      u.isHovered = !1;
      let T = j.currentTarget;
      r && r({
        type: "hoverend",
        target: T,
        pointerType: E
      }), n && n(!1), c(!1);
    }, k = {};
    return typeof PointerEvent < "u" ? (k.onPointerEnter = (j) => {
      _9 && j.pointerType === "mouse" || b(j, j.pointerType);
    }, k.onPointerLeave = (j) => {
      !s && j.currentTarget.contains(j.target) && w(j, j.pointerType);
    }) : (k.onTouchStart = () => {
      u.ignoreEmulatedMouseEvents = !0;
    }, k.onMouseEnter = (j) => {
      !u.ignoreEmulatedMouseEvents && !_9 && b(j, "mouse"), u.ignoreEmulatedMouseEvents = !1;
    }, k.onMouseLeave = (j) => {
      !s && j.currentTarget.contains(j.target) && w(j, "mouse");
    }), {
      hoverProps: k,
      triggerHoverEnd: w
    };
  }, [
    t,
    n,
    r,
    s,
    u
  ]);
  return an(() => {
    s && y({
      currentTarget: u.target
    }, u.pointerType);
  }, [
    s
  ]), {
    hoverProps: m,
    isHovered: o
  };
}
function Jg(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, s = Rt({
    isFocused: !1,
    isFocusVisible: t || P$()
  }), [o, c] = Re(!1), [u, m] = Re(() => s.current.isFocused && s.current.isFocusVisible), y = qa(() => m(s.current.isFocused && s.current.isFocusVisible), []), b = qa((j) => {
    s.current.isFocused = j, c(j), y();
  }, [
    y
  ]);
  wse((j) => {
    s.current.isFocusVisible = j, y();
  }, [], {
    isTextInput: n
  });
  let { focusProps: w } = gse({
    isDisabled: r,
    onFocusChange: b
  }), { focusWithinProps: k } = Cse({
    isDisabled: !r,
    onFocusWithinChange: b
  });
  return {
    isFocused: o,
    isFocusVisible: u,
    focusProps: r ? k : w
  };
}
var jse = Object.defineProperty, Ese = (e, t, n) => t in e ? jse(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, IM = (e, t, n) => (Ese(e, typeof t != "symbol" ? t + "" : t, n), n);
let kse = class {
  constructor() {
    IM(this, "current", this.detect()), IM(this, "handoffState", "pending"), IM(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, A4 = new kse();
function Ey(e) {
  return A4.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function oO(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Wv() {
  let e = [], t = { addEventListener(n, r, s, o) {
    return n.addEventListener(r, s, o), t.add(() => n.removeEventListener(r, s, o));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    return t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return oO(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, s) {
    let o = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: s }), this.add(() => {
      Object.assign(n.style, { [r]: o });
    });
  }, group(n) {
    let r = Wv();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.includes(n) || e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0) for (let s of e.splice(r, 1)) s();
    };
  }, dispose() {
    for (let n of e.splice(0)) n();
  } };
  return t;
}
function Yv() {
  let [e] = Re(Wv);
  return an(() => () => e.dispose(), [e]), e;
}
let gs = (e, t) => {
  A4.isServer ? an(e, t) : a5(e, t);
};
function $d(e) {
  let t = Rt(e);
  return gs(() => {
    t.current = e;
  }, [e]), t;
}
let ln = function(e) {
  let t = $d(e);
  return Ee.useCallback((...n) => t.current(...n), [t]);
};
function _se(e) {
  let t = e.width / 2, n = e.height / 2;
  return { top: e.clientY - n, right: e.clientX + t, bottom: e.clientY + n, left: e.clientX - t };
}
function Tse(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function l5({ disabled: e = !1 } = {}) {
  let t = Rt(null), [n, r] = Re(!1), s = Yv(), o = ln(() => {
    t.current = null, r(!1), s.dispose();
  }), c = ln((u) => {
    if (s.dispose(), t.current === null) {
      t.current = u.currentTarget, r(!0);
      {
        let m = Ey(u.currentTarget);
        s.addEventListener(m, "pointerup", o, !1), s.addEventListener(m, "pointermove", (y) => {
          if (t.current) {
            let b = _se(y);
            r(Tse(b, t.current.getBoundingClientRect()));
          }
        }, !1), s.addEventListener(m, "pointercancel", o, !1);
      }
    }
  });
  return { pressed: n, pressProps: e ? {} : { onPointerDown: c, onPointerUp: o, onClick: o } };
}
let O$ = ys(void 0);
function ky() {
  return Ra(O$);
}
function Mse({ value: e, children: t }) {
  return Ee.createElement(O$.Provider, { value: e }, t);
}
function ED(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function Ai(e, t, ...n) {
  if (e in t) {
    let s = t[e];
    return typeof s == "function" ? s(...n) : s;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((s) => `"${s}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, Ai), r;
}
var E1 = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(E1 || {}), E2 = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(E2 || {});
function is({ ourProps: e, theirProps: t, slot: n, defaultTag: r, features: s, visible: o = !0, name: c, mergeRefs: u }) {
  u = u ?? Rse;
  let m = A$(t, e);
  if (o) return Sj(m, n, r, c, u);
  let y = s ?? 0;
  if (y & 2) {
    let { static: b = !1, ...w } = m;
    if (b) return Sj(w, n, r, c, u);
  }
  if (y & 1) {
    let { unmount: b = !0, ...w } = m;
    return Ai(b ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return Sj({ ...w, hidden: !0, style: { display: "none" } }, n, r, c, u);
    } });
  }
  return Sj(m, n, r, c, u);
}
function Sj(e, t = {}, n, r, s) {
  let { as: o = n, children: c, refName: u = "ref", ...m } = FM(e, ["unmount", "static"]), y = e.ref !== void 0 ? { [u]: e.ref } : {}, b = typeof c == "function" ? c(t) : c;
  "className" in m && m.className && typeof m.className == "function" && (m.className = m.className(t)), m["aria-labelledby"] && m["aria-labelledby"] === m.id && (m["aria-labelledby"] = void 0);
  let w = {};
  if (t) {
    let k = !1, j = [];
    for (let [E, T] of Object.entries(t)) typeof T == "boolean" && (k = !0), T === !0 && j.push(E.replace(/([A-Z])/g, (D) => `-${D.toLowerCase()}`));
    if (k) {
      w["data-headlessui-state"] = j.join(" ");
      for (let E of j) w[`data-${E}`] = "";
    }
  }
  if (o === jf && (Object.keys(x2(m)).length > 0 || Object.keys(x2(w)).length > 0)) if (!NZ(b) || Array.isArray(b) && b.length > 1) {
    if (Object.keys(x2(m)).length > 0) throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(x2(m)).concat(Object.keys(x2(w))).map((k) => `  - ${k}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((k) => `  - ${k}`).join(`
`)].join(`
`));
  } else {
    let k = b.props, j = k == null ? void 0 : k.className, E = typeof j == "function" ? (...L) => ED(j(...L), m.className) : ED(j, m.className), T = E ? { className: E } : {}, D = A$(b.props, x2(FM(m, ["ref"])));
    for (let L in w) L in D && delete w[L];
    return jZ(b, Object.assign({}, D, w, y, { ref: s(b.ref, y.ref) }, T));
  }
  return iV(o, Object.assign({}, FM(m, ["ref"]), o !== jf && y, o !== jf && w), b);
}
function lO() {
  let e = Rt([]), t = qa((n) => {
    for (let r of e.current) r != null && (typeof r == "function" ? r(n) : r.current = n);
  }, []);
  return (...n) => {
    if (!n.every((r) => r == null)) return e.current = n, t;
  };
}
function Rse(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let n of e) n != null && (typeof n == "function" ? n(t) : n.current = t);
  };
}
function A$(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let s in r) s.startsWith("on") && typeof r[s] == "function" ? (n[s] != null || (n[s] = []), n[s].push(r[s])) : t[s] = r[s];
  if (t.disabled || t["aria-disabled"]) for (let r in n) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(r) && (n[r] = [(s) => {
    var o;
    return (o = s == null ? void 0 : s.preventDefault) == null ? void 0 : o.call(s);
  }]);
  for (let r in n) Object.assign(t, { [r](s, ...o) {
    let c = n[r];
    for (let u of c) {
      if ((s instanceof Event || (s == null ? void 0 : s.nativeEvent) instanceof Event) && s.defaultPrevented) return;
      u(s, ...o);
    }
  } });
  return t;
}
function gm(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let s in r) s.startsWith("on") && typeof r[s] == "function" ? (n[s] != null || (n[s] = []), n[s].push(r[s])) : t[s] = r[s];
  for (let r in n) Object.assign(t, { [r](...s) {
    let o = n[r];
    for (let c of o) c == null || c(...s);
  } });
  return t;
}
function Xa(e) {
  var t;
  return Object.assign(yn(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function x2(e) {
  let t = Object.assign({}, e);
  for (let n in t) t[n] === void 0 && delete t[n];
  return t;
}
function FM(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
let Dse = "button";
function Pse(e, t) {
  var n;
  let r = ky(), { disabled: s = r || !1, autoFocus: o = !1, ...c } = e, { isFocusVisible: u, focusProps: m } = Jg({ autoFocus: o }), { isHovered: y, hoverProps: b } = jy({ isDisabled: s }), { pressed: w, pressProps: k } = l5({ disabled: s }), j = gm({ ref: t, type: (n = c.type) != null ? n : "button", disabled: s || void 0, autoFocus: o }, m, b, k), E = dn(() => ({ disabled: s, hover: y, focus: u, active: w, autofocus: o }), [s, y, u, w, o]);
  return is({ ourProps: j, theirProps: c, slot: E, defaultTag: Dse, name: "Button" });
}
let pm = Xa(Pse);
function xE(e, t, n) {
  let [r, s] = Re(n), o = e !== void 0, c = Rt(o), u = Rt(!1), m = Rt(!1);
  return o && !c.current && !u.current ? (u.current = !0, c.current = o, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !o && c.current && !m.current && (m.current = !0, c.current = o, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [o ? e : r, ln((y) => (o || s(y), t == null ? void 0 : t(y)))];
}
function bE(e) {
  let [t] = Re(e);
  return t;
}
function L$(e = {}, t = null, n = []) {
  for (let [r, s] of Object.entries(e)) F$(n, I$(t, r), s);
  return n;
}
function I$(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function F$(e, t, n) {
  if (Array.isArray(n)) for (let [r, s] of n.entries()) F$(e, I$(t, r.toString()), s);
  else n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : L$(n, t, e);
}
function SE(e) {
  var t, n;
  let r = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (r) {
    for (let s of r.elements) if (s !== e && (s.tagName === "INPUT" && s.type === "submit" || s.tagName === "BUTTON" && s.type === "submit" || s.nodeName === "INPUT" && s.type === "image")) {
      s.click();
      return;
    }
    (n = r.requestSubmit) == null || n.call(r);
  }
}
let Ose = "span";
var Bv = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Bv || {});
function Ase(e, t) {
  var n;
  let { features: r = 1, ...s } = e, o = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : (n = s["aria-hidden"]) != null ? n : void 0, hidden: (r & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return is({ ourProps: o, theirProps: s, slot: {}, defaultTag: Ose, name: "Hidden" });
}
let Hv = Xa(Ase), U$ = ys(null);
function Lse(e) {
  let [t, n] = Re(null);
  return Ee.createElement(U$.Provider, { value: { target: t } }, e.children, Ee.createElement(Hv, { features: Bv.Hidden, ref: n }));
}
function Ise({ children: e }) {
  let t = Ra(U$);
  if (!t) return Ee.createElement(Ee.Fragment, null, e);
  let { target: n } = t;
  return n ? po.createPortal(Ee.createElement(Ee.Fragment, null, e), n) : null;
}
function wE({ data: e, form: t, disabled: n, onReset: r, overrides: s }) {
  let [o, c] = Re(null), u = Yv();
  return an(() => {
    if (r && o) return u.addEventListener(o, "reset", r);
  }, [o, t, r]), Ee.createElement(Ise, null, Ee.createElement(Fse, { setForm: c, formId: t }), L$(e).map(([m, y]) => Ee.createElement(Hv, { features: Bv.Hidden, ...x2({ key: m, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, disabled: n, name: m, value: y, ...s }) })));
}
function Fse({ setForm: e, formId: t }) {
  return an(() => {
    if (t) {
      let n = document.getElementById(t);
      n && e(n);
    }
  }, [e, t]), t ? null : Ee.createElement(Hv, { features: Bv.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (n) => {
    if (!n) return;
    let r = n.closest("form");
    r && e(r);
  } });
}
let z$ = ys(void 0);
function uw() {
  return Ra(z$);
}
function Use({ id: e, children: t }) {
  return Ee.createElement(z$.Provider, { value: e }, t);
}
function Q2(e) {
  let t = e.parentElement, n = null;
  for (; t && !(t instanceof HTMLFieldSetElement); ) t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && zse(n) ? !1 : r;
}
function zse(e) {
  if (!e) return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement) return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let B$ = Symbol();
function cO(e, t = !0) {
  return Object.assign(e, { [B$]: t });
}
function ri(...e) {
  let t = Rt(e);
  an(() => {
    t.current = e;
  }, [e]);
  let n = ln((r) => {
    for (let s of t.current) s != null && (typeof s == "function" ? s(r) : s.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[B$])) ? void 0 : n;
}
let CE = ys(null);
CE.displayName = "DescriptionContext";
function H$() {
  let e = Ra(CE);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, H$), t;
  }
  return e;
}
function Z3() {
  var e, t;
  return (t = (e = Ra(CE)) == null ? void 0 : e.value) != null ? t : void 0;
}
function NE() {
  let [e, t] = Re([]);
  return [e.length > 0 ? e.join(" ") : void 0, dn(() => function(n) {
    let r = ln((o) => (t((c) => [...c, o]), () => t((c) => {
      let u = c.slice(), m = u.indexOf(o);
      return m !== -1 && u.splice(m, 1), u;
    }))), s = dn(() => ({ register: r, slot: n.slot, name: n.name, props: n.props, value: n.value }), [r, n.slot, n.name, n.props, n.value]);
    return Ee.createElement(CE.Provider, { value: s }, n.children);
  }, [t])];
}
let Bse = "p";
function Hse(e, t) {
  let n = Zl(), r = ky(), { id: s = `headlessui-description-${n}`, ...o } = e, c = H$(), u = ri(t);
  gs(() => c.register(s), [s, c.register]);
  let m = r || !1, y = dn(() => ({ ...c.slot, disabled: m }), [c.slot, m]), b = { ref: u, ...c.props, id: s };
  return is({ ourProps: b, theirProps: o, slot: y, defaultTag: Bse, name: c.name || "Description" });
}
let Vse = Xa(Hse), V$ = Object.assign(Vse, {});
var Or = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Or || {});
let jE = ys(null);
jE.displayName = "LabelContext";
function $$() {
  let e = Ra(jE);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, $$), t;
  }
  return e;
}
function dw(e) {
  var t, n, r;
  let s = (n = (t = Ra(jE)) == null ? void 0 : t.value) != null ? n : void 0;
  return ((r = e == null ? void 0 : e.length) != null ? r : 0) > 0 ? [s, ...e].filter(Boolean).join(" ") : s;
}
function J3({ inherit: e = !1 } = {}) {
  let t = dw(), [n, r] = Re([]), s = e ? [t, ...n].filter(Boolean) : n;
  return [s.length > 0 ? s.join(" ") : void 0, dn(() => function(o) {
    let c = ln((m) => (r((y) => [...y, m]), () => r((y) => {
      let b = y.slice(), w = b.indexOf(m);
      return w !== -1 && b.splice(w, 1), b;
    }))), u = dn(() => ({ register: c, slot: o.slot, name: o.name, props: o.props, value: o.value }), [c, o.slot, o.name, o.props, o.value]);
    return Ee.createElement(jE.Provider, { value: u }, o.children);
  }, [r])];
}
let $se = "label";
function Gse(e, t) {
  var n;
  let r = Zl(), s = $$(), o = uw(), c = ky(), { id: u = `headlessui-label-${r}`, htmlFor: m = o ?? ((n = s.props) == null ? void 0 : n.htmlFor), passive: y = !1, ...b } = e, w = ri(t);
  gs(() => s.register(u), [u, s.register]);
  let k = ln((D) => {
    let L = D.currentTarget;
    if (L instanceof HTMLLabelElement && D.preventDefault(), s.props && "onClick" in s.props && typeof s.props.onClick == "function" && s.props.onClick(D), L instanceof HTMLLabelElement) {
      let I = document.getElementById(L.htmlFor);
      if (I) {
        let R = I.getAttribute("disabled");
        if (R === "true" || R === "") return;
        let U = I.getAttribute("aria-disabled");
        if (U === "true" || U === "") return;
        (I instanceof HTMLInputElement && (I.type === "radio" || I.type === "checkbox") || I.role === "radio" || I.role === "checkbox" || I.role === "switch") && I.click(), I.focus({ preventScroll: !0 });
      }
    }
  }), j = c || !1, E = dn(() => ({ ...s.slot, disabled: j }), [s.slot, j]), T = { ref: w, ...s.props, id: u, htmlFor: m, onClick: k };
  return y && ("onClick" in T && (delete T.htmlFor, delete T.onClick), "onClick" in b && delete b.onClick), is({ ourProps: T, theirProps: b, slot: E, defaultTag: m ? $se : "div", name: s.name || "Label" });
}
let Wse = Xa(Gse), _c = Object.assign(Wse, {}), Yse = "span";
function qse(e, t) {
  let n = Zl(), r = uw(), s = ky(), { id: o = r || `headlessui-checkbox-${n}`, disabled: c = s || !1, autoFocus: u = !1, checked: m, defaultChecked: y, onChange: b, name: w, value: k, form: j, indeterminate: E = !1, ...T } = e, D = bE(y), [L, I] = xE(m, b, D ?? !1), R = dw(), U = Z3(), z = Yv(), [H, K] = Re(!1), q = ln(() => {
    K(!0), I == null || I(!L), z.nextFrame(() => {
      K(!1);
    });
  }), Q = ln((ve) => {
    if (Q2(ve.currentTarget)) return ve.preventDefault();
    ve.preventDefault(), q();
  }), Z = ln((ve) => {
    ve.key === Or.Space ? (ve.preventDefault(), q()) : ve.key === Or.Enter && SE(ve.currentTarget);
  }), X = ln((ve) => ve.preventDefault()), { isFocusVisible: se, focusProps: te } = Jg({ autoFocus: u }), { isHovered: fe, hoverProps: ce } = jy({ isDisabled: c }), { pressed: pe, pressProps: Se } = l5({ disabled: c }), oe = gm({ ref: t, id: o, role: "checkbox", "aria-checked": E ? "mixed" : L ? "true" : "false", "aria-labelledby": R, "aria-describedby": U, "aria-disabled": c ? !0 : void 0, indeterminate: E ? "true" : void 0, tabIndex: c ? void 0 : 0, onKeyUp: c ? void 0 : Z, onKeyPress: c ? void 0 : X, onClick: c ? void 0 : Q }, te, ce, Se), ue = dn(() => ({ checked: L, disabled: c, hover: fe, focus: se, active: pe, indeterminate: E, changing: H, autofocus: u }), [L, E, c, fe, se, pe, H, u]), he = qa(() => {
    if (D !== void 0) return I == null ? void 0 : I(D);
  }, [I, D]);
  return Ee.createElement(Ee.Fragment, null, w != null && Ee.createElement(wE, { disabled: c, data: { [w]: k || "on" }, overrides: { type: "checkbox", checked: L }, form: j, onReset: he }), is({ ourProps: oe, theirProps: T, slot: ue, defaultTag: Yse, name: "Checkbox" }));
}
let G$ = Xa(qse), Kse = ys(() => {
});
function W$({ value: e, children: t }) {
  return Ee.createElement(Kse.Provider, { value: e }, t);
}
function Xse(e, t) {
  return e !== null && t !== null && typeof e == "object" && typeof t == "object" && "id" in e && "id" in t ? e.id === t.id : e === t;
}
function Y$(e = Xse) {
  return qa((t, n) => {
    if (typeof e == "string") {
      let r = e;
      return (t == null ? void 0 : t[r]) === (n == null ? void 0 : n[r]);
    }
    return e(t, n);
  }, [e]);
}
function Qse(e) {
  if (e === null) return { width: 0, height: 0 };
  let { width: t, height: n } = e.getBoundingClientRect();
  return { width: t, height: n };
}
function q$(e, t = !1) {
  let n = e === null ? null : "current" in e ? e.current : e, [r, s] = r5(() => ({}), {}), o = dn(() => Qse(n), [n, r]);
  return gs(() => {
    if (!n) return;
    let c = new ResizeObserver(s);
    return c.observe(n), () => {
      c.disconnect();
    };
  }, [n]), t ? { width: `${o.width}px`, height: `${o.height}px` } : o;
}
let Zse = class extends Map {
  constructor(t) {
    super(), this.factory = t;
  }
  get(t) {
    let n = super.get(t);
    return n === void 0 && (n = this.factory(t), this.set(t, n)), n;
  }
};
function K$(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(s) {
    return r.add(s), () => r.delete(s);
  }, dispatch(s, ...o) {
    let c = t[s].call(n, ...o);
    c && (n = c, r.forEach((u) => u()));
  } };
}
function X$(e) {
  return EZ(e.subscribe, e.getSnapshot, e.getSnapshot);
}
let Jse = new Zse(() => K$(() => [], { ADD(e) {
  return this.includes(e) ? this : [...this, e];
}, REMOVE(e) {
  let t = this.indexOf(e);
  if (t === -1) return this;
  let n = this.slice();
  return n.splice(t, 1), n;
} }));
function uO(e, t) {
  let n = Jse.get(t), r = Zl(), s = X$(n);
  if (gs(() => {
    if (e) return n.dispatch("ADD", r), () => n.dispatch("REMOVE", r);
  }, [n, e]), !e) return !1;
  let o = s.indexOf(r), c = s.length;
  return o === -1 && (o = c, c += 1), o === c - 1;
}
let kD = /* @__PURE__ */ new Map(), l3 = /* @__PURE__ */ new Map();
function aU(e) {
  var t;
  let n = (t = l3.get(e)) != null ? t : 0;
  return l3.set(e, n + 1), n !== 0 ? () => sU(e) : (kD.set(e, { "aria-hidden": e.getAttribute("aria-hidden"), inert: e.inert }), e.setAttribute("aria-hidden", "true"), e.inert = !0, () => sU(e));
}
function sU(e) {
  var t;
  let n = (t = l3.get(e)) != null ? t : 1;
  if (n === 1 ? l3.delete(e) : l3.set(e, n - 1), n !== 1) return;
  let r = kD.get(e);
  r && (r["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", r["aria-hidden"]), e.inert = r.inert, kD.delete(e));
}
function eie(e, { allowed: t, disallowed: n } = {}) {
  let r = uO(e, "inert-others");
  gs(() => {
    var s, o;
    if (!r) return;
    let c = Wv();
    for (let m of (s = n == null ? void 0 : n()) != null ? s : []) m && c.add(aU(m));
    let u = (o = t == null ? void 0 : t()) != null ? o : [];
    for (let m of u) {
      if (!m) continue;
      let y = Ey(m);
      if (!y) continue;
      let b = m.parentElement;
      for (; b && b !== y.body; ) {
        for (let w of b.children) u.some((k) => w.contains(k)) || c.add(aU(w));
        b = b.parentElement;
      }
    }
    return c.dispose;
  }, [r, t, n]);
}
function dO(e, t, n) {
  let r = $d((s) => {
    let o = s.getBoundingClientRect();
    o.x === 0 && o.y === 0 && o.width === 0 && o.height === 0 && n();
  });
  an(() => {
    if (!e) return;
    let s = t === null ? null : t instanceof HTMLElement ? t : t.current;
    if (!s) return;
    let o = Wv();
    if (typeof ResizeObserver < "u") {
      let c = new ResizeObserver(() => r.current(s));
      c.observe(s), o.add(() => c.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
      let c = new IntersectionObserver(() => r.current(s));
      c.observe(s), o.add(() => c.disconnect());
    }
    return () => o.dispose();
  }, [t, r, e]);
}
let _D = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(","), tie = ["[data-autofocus]"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var fo = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(fo || {}), ly = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(ly || {}), nie = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(nie || {});
function e6(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(_D)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function rie(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(tie)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var EE = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(EE || {});
function fO(e, t = 0) {
  var n;
  return e === ((n = Ey(e)) == null ? void 0 : n.body) ? !1 : Ai(t, { 0() {
    return e.matches(_D);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(_D)) return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var aie = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(aie || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
let sie = ["textarea", "input"].join(",");
function iie(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, sie)) != null ? n : !1;
}
function k2(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let s = t(n), o = t(r);
    if (s === null || o === null) return 0;
    let c = s.compareDocumentPosition(o);
    return c & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : c & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function oie(e, t) {
  return Sf(e6(), t, { relativeTo: e });
}
function Sf(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: s = [] } = {}) {
  let o = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, c = Array.isArray(e) ? n ? k2(e) : e : t & 64 ? rie(e) : e6(e);
  s.length > 0 && c.length > 1 && (c = c.filter((j) => !s.some((E) => E != null && "current" in E ? (E == null ? void 0 : E.current) === j : E === j))), r = r ?? o.activeElement;
  let u = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), m = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, c.indexOf(r)) - 1;
    if (t & 4) return Math.max(0, c.indexOf(r)) + 1;
    if (t & 8) return c.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), y = t & 32 ? { preventScroll: !0 } : {}, b = 0, w = c.length, k;
  do {
    if (b >= w || b + w <= 0) return 0;
    let j = m + b;
    if (t & 16) j = (j + w) % w;
    else {
      if (j < 0) return 3;
      if (j >= w) return 1;
    }
    k = c[j], k == null || k.focus(y), b += u;
  } while (k !== o.activeElement);
  return t & 6 && iie(k) && k.select(), 2;
}
function Q$() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function lie() {
  return /Android/gi.test(window.navigator.userAgent);
}
function cie() {
  return Q$() || lie();
}
function _7(e, t, n, r) {
  let s = $d(n);
  an(() => {
    if (!e) return;
    function o(c) {
      s.current(c);
    }
    return document.addEventListener(t, o, r), () => document.removeEventListener(t, o, r);
  }, [e, t, r]);
}
function Z$(e, t, n, r) {
  let s = $d(n);
  an(() => {
    if (!e) return;
    function o(c) {
      s.current(c);
    }
    return window.addEventListener(t, o, r), () => window.removeEventListener(t, o, r);
  }, [e, t, r]);
}
const iU = 30;
function J$(e, t, n) {
  let r = uO(e, "outside-click"), s = $d(n), o = qa(function(m, y) {
    if (m.defaultPrevented) return;
    let b = y(m);
    if (b === null || !b.getRootNode().contains(b) || !b.isConnected) return;
    let w = function k(j) {
      return typeof j == "function" ? k(j()) : Array.isArray(j) || j instanceof Set ? j : [j];
    }(t);
    for (let k of w) {
      if (k === null) continue;
      let j = k instanceof HTMLElement ? k : k.current;
      if (j != null && j.contains(b) || m.composed && m.composedPath().includes(j)) return;
    }
    return !fO(b, EE.Loose) && b.tabIndex !== -1 && m.preventDefault(), s.current(m, b);
  }, [s]), c = Rt(null);
  _7(r, "pointerdown", (m) => {
    var y, b;
    c.current = ((b = (y = m.composedPath) == null ? void 0 : y.call(m)) == null ? void 0 : b[0]) || m.target;
  }, !0), _7(r, "mousedown", (m) => {
    var y, b;
    c.current = ((b = (y = m.composedPath) == null ? void 0 : y.call(m)) == null ? void 0 : b[0]) || m.target;
  }, !0), _7(r, "click", (m) => {
    cie() || c.current && (o(m, () => c.current), c.current = null);
  }, !0);
  let u = Rt({ x: 0, y: 0 });
  _7(r, "touchstart", (m) => {
    u.current.x = m.touches[0].clientX, u.current.y = m.touches[0].clientY;
  }, !0), _7(r, "touchend", (m) => {
    let y = { x: m.changedTouches[0].clientX, y: m.changedTouches[0].clientY };
    if (!(Math.abs(y.x - u.current.x) >= iU || Math.abs(y.y - u.current.y) >= iU)) return o(m, () => m.target instanceof HTMLElement ? m.target : null);
  }, !0), Z$(r, "blur", (m) => o(m, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function c5(...e) {
  return dn(() => Ey(...e), [...e]);
}
function uie(e, t, n, r) {
  let s = $d(n);
  an(() => {
    e = e ?? window;
    function o(c) {
      s.current(c);
    }
    return e.addEventListener(t, o, r), () => e.removeEventListener(t, o, r);
  }, [e, t, r]);
}
function oU(e) {
  var t;
  if (e.type) return e.type;
  let n = (t = e.as) != null ? t : "button";
  if (typeof n == "string" && n.toLowerCase() === "button") return "button";
}
function t6(e, t) {
  let [n, r] = Re(() => oU(e));
  return gs(() => {
    r(oU(e));
  }, [e.type, e.as]), gs(() => {
    n || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && r("button");
  }, [n, t]), n;
}
function die() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement, s = (n = t.defaultView) != null ? n : window;
    e = Math.max(0, s.innerWidth - r.clientWidth);
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, s = Math.max(0, r.clientWidth - r.offsetWidth), o = Math.max(0, e - s);
    n.style(r, "paddingRight", `${o}px`);
  } };
}
function fie() {
  return Q$() ? { before({ doc: e, d: t, meta: n }) {
    function r(s) {
      return n.containers.flatMap((o) => o()).some((o) => o.contains(s));
    }
    t.microTask(() => {
      var s;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let u = Wv();
        u.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => u.dispose()));
      }
      let o = (s = window.scrollY) != null ? s : window.pageYOffset, c = null;
      t.addEventListener(e, "click", (u) => {
        if (u.target instanceof HTMLElement) try {
          let m = u.target.closest("a");
          if (!m) return;
          let { hash: y } = new URL(m.href), b = e.querySelector(y);
          b && !r(b) && (c = b);
        } catch {
        }
      }, !0), t.addEventListener(e, "touchstart", (u) => {
        if (u.target instanceof HTMLElement) if (r(u.target)) {
          let m = u.target;
          for (; m.parentElement && r(m.parentElement); ) m = m.parentElement;
          t.style(m, "overscrollBehavior", "contain");
        } else t.style(u.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (u) => {
        if (u.target instanceof HTMLElement) {
          if (u.target.tagName === "INPUT") return;
          if (r(u.target)) {
            let m = u.target;
            for (; m.parentElement && m.dataset.headlessuiPortal !== "" && !(m.scrollHeight > m.clientHeight || m.scrollWidth > m.clientWidth); ) m = m.parentElement;
            m.dataset.headlessuiPortal === "" && u.preventDefault();
          } else u.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var u;
        let m = (u = window.scrollY) != null ? u : window.pageYOffset;
        o !== m && window.scrollTo(0, o), c && c.isConnected && (c.scrollIntoView({ block: "nearest" }), c = null);
      });
    });
  } } : {};
}
function mie() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function hie(e) {
  let t = {};
  for (let n of e) Object.assign(t, n(t));
  return t;
}
let D4 = K$(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: Wv(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: hie(n) }, s = [fie(), die(), mie()];
  s.forEach(({ before: o }) => o == null ? void 0 : o(r)), s.forEach(({ after: o }) => o == null ? void 0 : o(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
D4.subscribe(() => {
  let e = D4.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e) t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", s = n.count !== 0;
    (s && !r || !s && r) && D4.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && D4.dispatch("TEARDOWN", n);
  }
});
function pie(e, t, n = () => ({ containers: [] })) {
  let r = X$(D4), s = t ? r.get(t) : void 0, o = s ? s.count > 0 : !1;
  return gs(() => {
    if (!(!t || !e)) return D4.dispatch("PUSH", t, n), () => D4.dispatch("POP", t, n);
  }, [e, t]), o;
}
function eG(e, t, n = () => [document.body]) {
  let r = uO(e, "scroll-lock");
  pie(r, t, (s) => {
    var o;
    return { containers: [...(o = s.containers) != null ? o : [], n] };
  });
}
function lU(e) {
  return [e.screenX, e.screenY];
}
function gie() {
  let e = Rt([-1, -1]);
  return { wasMoved(t) {
    let n = lU(t);
    return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
  }, update(t) {
    e.current = lU(t);
  } };
}
function yie(e) {
  let t = { called: !1 };
  return (...n) => {
    if (!t.called) return t.called = !0, e(...n);
  };
}
function vie(e = 0) {
  let [t, n] = Re(e), r = qa((m) => n(m), [t]), s = qa((m) => n((y) => y | m), [t]), o = qa((m) => (t & m) === m, [t]), c = qa((m) => n((y) => y & ~m), [n]), u = qa((m) => n((y) => y ^ m), [n]);
  return { flags: t, setFlag: r, addFlag: s, hasFlag: o, removeFlag: c, toggleFlag: u };
}
var xie = ((e) => (e[e.None = 0] = "None", e[e.Closed = 1] = "Closed", e[e.Enter = 2] = "Enter", e[e.Leave = 4] = "Leave", e))(xie || {});
function n6(e) {
  let t = {};
  for (let n in e) e[n] === !0 && (t[`data-${n}`] = "");
  return t;
}
function r6(e, t, n, r) {
  let [s, o] = Re(n), { hasFlag: c, addFlag: u, removeFlag: m } = vie(e && s ? 3 : 0), y = Rt(!1), b = Rt(!1), w = Yv();
  return gs(function k() {
    var j;
    if (!e) return;
    n && o(!0);
    let E = t.current;
    return E ? ((j = r == null ? void 0 : r.start) == null || j.call(r, n), bie(E, { inFlight: y, prepare() {
      b.current ? b.current = !1 : b.current = y.current, y.current = !0, !b.current && (n ? (u(3), m(4)) : (u(4), m(2)));
    }, run() {
      b.current ? n ? (m(3), u(4)) : (m(4), u(3)) : n ? m(1) : u(1);
    }, done() {
      var T;
      b.current && typeof E.getAnimations == "function" && E.getAnimations().length > 0 || (y.current = !1, m(7), n || o(!1), (T = r == null ? void 0 : r.end) == null || T.call(r, n));
    } })) : n ? (u(3), w.nextFrame(() => k())) : void 0;
  }, [e, n, t, w]), e ? [s, { closed: c(1), enter: c(2), leave: c(4), transition: c(2) || c(4) }] : [n, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function bie(e, { prepare: t, run: n, done: r, inFlight: s }) {
  let o = Wv();
  return wie(e, { prepare: t, inFlight: s }), o.nextFrame(() => {
    o.add(Sie(e, r)), n();
  }), o.dispose;
}
function Sie(e, t) {
  let n = yie(t), r = Wv();
  if (!e) return r.dispose;
  let { transitionDuration: s, transitionDelay: o } = getComputedStyle(e), [c, u] = [s, o].map((y) => {
    let [b = 0] = y.split(",").filter(Boolean).map((w) => w.includes("ms") ? parseFloat(w) : parseFloat(w) * 1e3).sort((w, k) => k - w);
    return b;
  }), m = c + u;
  if (m !== 0) {
    let y = r.group((b) => {
      let w = b.setTimeout(() => {
        n(), b.dispose();
      }, m);
      b.addEventListener(e, "transitionrun", (k) => {
        k.target === k.currentTarget && (w(), b.addEventListener(e, "transitioncancel", (j) => {
          j.target === j.currentTarget && (n(), y());
        }));
      });
    });
    r.addEventListener(e, "transitionend", (b) => {
      b.target === b.currentTarget && (n(), r.dispose());
    });
  } else n();
  return r.dispose;
}
function wie(e, { inFlight: t, prepare: n }) {
  if (t != null && t.current) {
    n();
    return;
  }
  let r = e.style.transition;
  e.style.transition = "none", n(), e.offsetHeight, e.style.transition = r;
}
function fw(e) {
  return tG(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function pp(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function qv(e) {
  var t;
  return (t = (tG(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function tG(e) {
  return e instanceof Node || e instanceof pp(e).Node;
}
function Cf(e) {
  return e instanceof Element || e instanceof pp(e).Element;
}
function yy(e) {
  return e instanceof HTMLElement || e instanceof pp(e).HTMLElement;
}
function cU(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof pp(e).ShadowRoot;
}
function a6(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: s
  } = Qg(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(s);
}
function Cie(e) {
  return ["table", "td", "th"].includes(fw(e));
}
function kE(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function mO(e) {
  const t = hO(), n = Cf(e) ? Qg(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Nie(e) {
  let t = U2(e);
  for (; yy(t) && !H8(t); ) {
    if (mO(t))
      return t;
    if (kE(t))
      return null;
    t = U2(t);
  }
  return null;
}
function hO() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function H8(e) {
  return ["html", "body", "#document"].includes(fw(e));
}
function Qg(e) {
  return pp(e).getComputedStyle(e);
}
function _E(e) {
  return Cf(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function U2(e) {
  if (fw(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    cU(e) && e.host || // Fallback.
    qv(e)
  );
  return cU(t) ? t.host : t;
}
function nG(e) {
  const t = U2(e);
  return H8(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : yy(t) && a6(t) ? t : nG(t);
}
function C3(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = nG(e), o = s === ((r = e.ownerDocument) == null ? void 0 : r.body), c = pp(s);
  if (o) {
    const u = TD(c);
    return t.concat(c, c.visualViewport || [], a6(s) ? s : [], u && n ? C3(u) : []);
  }
  return t.concat(s, C3(s, [], n));
}
function TD(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function jie() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
const _2 = Math.min, fp = Math.max, T9 = Math.round, wj = Math.floor, z2 = (e) => ({
  x: e,
  y: e
}), Eie = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, kie = {
  start: "end",
  end: "start"
};
function uU(e, t, n) {
  return fp(e, _2(t, n));
}
function mw(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function B2(e) {
  return e.split("-")[0];
}
function s6(e) {
  return e.split("-")[1];
}
function rG(e) {
  return e === "x" ? "y" : "x";
}
function aG(e) {
  return e === "y" ? "height" : "width";
}
function Y4(e) {
  return ["top", "bottom"].includes(B2(e)) ? "y" : "x";
}
function sG(e) {
  return rG(Y4(e));
}
function _ie(e, t, n) {
  n === void 0 && (n = !1);
  const r = s6(e), s = sG(e), o = aG(s);
  let c = s === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (c = M9(c)), [c, M9(c)];
}
function Tie(e) {
  const t = M9(e);
  return [MD(e), t, MD(t)];
}
function MD(e) {
  return e.replace(/start|end/g, (t) => kie[t]);
}
function Mie(e, t, n) {
  const r = ["left", "right"], s = ["right", "left"], o = ["top", "bottom"], c = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? s : r : t ? r : s;
    case "left":
    case "right":
      return t ? o : c;
    default:
      return [];
  }
}
function Rie(e, t, n, r) {
  const s = s6(e);
  let o = Mie(B2(e), n === "start", r);
  return s && (o = o.map((c) => c + "-" + s), t && (o = o.concat(o.map(MD)))), o;
}
function M9(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Eie[t]);
}
function Die(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Pie(e) {
  return typeof e != "number" ? Die(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function R9(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: s
  } = e;
  return {
    width: r,
    height: s,
    top: n,
    left: t,
    right: t + r,
    bottom: n + s,
    x: t,
    y: n
  };
}
function dU(e, t, n) {
  let {
    reference: r,
    floating: s
  } = e;
  const o = Y4(t), c = sG(t), u = aG(c), m = B2(t), y = o === "y", b = r.x + r.width / 2 - s.width / 2, w = r.y + r.height / 2 - s.height / 2, k = r[u] / 2 - s[u] / 2;
  let j;
  switch (m) {
    case "top":
      j = {
        x: b,
        y: r.y - s.height
      };
      break;
    case "bottom":
      j = {
        x: b,
        y: r.y + r.height
      };
      break;
    case "right":
      j = {
        x: r.x + r.width,
        y: w
      };
      break;
    case "left":
      j = {
        x: r.x - s.width,
        y: w
      };
      break;
    default:
      j = {
        x: r.x,
        y: r.y
      };
  }
  switch (s6(t)) {
    case "start":
      j[c] -= k * (n && y ? -1 : 1);
      break;
    case "end":
      j[c] += k * (n && y ? -1 : 1);
      break;
  }
  return j;
}
const Oie = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: o = [],
    platform: c
  } = n, u = o.filter(Boolean), m = await (c.isRTL == null ? void 0 : c.isRTL(t));
  let y = await c.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: b,
    y: w
  } = dU(y, r, m), k = r, j = {}, E = 0;
  for (let T = 0; T < u.length; T++) {
    const {
      name: D,
      fn: L
    } = u[T], {
      x: I,
      y: R,
      data: U,
      reset: z
    } = await L({
      x: b,
      y: w,
      initialPlacement: r,
      placement: k,
      strategy: s,
      middlewareData: j,
      rects: y,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    b = I ?? b, w = R ?? w, j = {
      ...j,
      [D]: {
        ...j[D],
        ...U
      }
    }, z && E <= 50 && (E++, typeof z == "object" && (z.placement && (k = z.placement), z.rects && (y = z.rects === !0 ? await c.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : z.rects), {
      x: b,
      y: w
    } = dU(y, k, m)), T = -1);
  }
  return {
    x: b,
    y: w,
    placement: k,
    strategy: s,
    middlewareData: j
  };
};
async function TE(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: s,
    platform: o,
    rects: c,
    elements: u,
    strategy: m
  } = e, {
    boundary: y = "clippingAncestors",
    rootBoundary: b = "viewport",
    elementContext: w = "floating",
    altBoundary: k = !1,
    padding: j = 0
  } = mw(t, e), E = Pie(j), D = u[k ? w === "floating" ? "reference" : "floating" : w], L = R9(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(D))) == null || n ? D : D.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(u.floating)),
    boundary: y,
    rootBoundary: b,
    strategy: m
  })), I = w === "floating" ? {
    x: r,
    y: s,
    width: c.floating.width,
    height: c.floating.height
  } : c.reference, R = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u.floating)), U = await (o.isElement == null ? void 0 : o.isElement(R)) ? await (o.getScale == null ? void 0 : o.getScale(R)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, z = R9(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: u,
    rect: I,
    offsetParent: R,
    strategy: m
  }) : I);
  return {
    top: (L.top - z.top + E.top) / U.y,
    bottom: (z.bottom - L.bottom + E.bottom) / U.y,
    left: (L.left - z.left + E.left) / U.x,
    right: (z.right - L.right + E.right) / U.x
  };
}
const Aie = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        middlewareData: o,
        rects: c,
        initialPlacement: u,
        platform: m,
        elements: y
      } = t, {
        mainAxis: b = !0,
        crossAxis: w = !0,
        fallbackPlacements: k,
        fallbackStrategy: j = "bestFit",
        fallbackAxisSideDirection: E = "none",
        flipAlignment: T = !0,
        ...D
      } = mw(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const L = B2(s), I = Y4(u), R = B2(u) === u, U = await (m.isRTL == null ? void 0 : m.isRTL(y.floating)), z = k || (R || !T ? [M9(u)] : Tie(u)), H = E !== "none";
      !k && H && z.push(...Rie(u, T, E, U));
      const K = [u, ...z], q = await TE(t, D), Q = [];
      let Z = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (b && Q.push(q[L]), w) {
        const fe = _ie(s, c, U);
        Q.push(q[fe[0]], q[fe[1]]);
      }
      if (Z = [...Z, {
        placement: s,
        overflows: Q
      }], !Q.every((fe) => fe <= 0)) {
        var X, se;
        const fe = (((X = o.flip) == null ? void 0 : X.index) || 0) + 1, ce = K[fe];
        if (ce)
          return {
            data: {
              index: fe,
              overflows: Z
            },
            reset: {
              placement: ce
            }
          };
        let pe = (se = Z.filter((Se) => Se.overflows[0] <= 0).sort((Se, oe) => Se.overflows[1] - oe.overflows[1])[0]) == null ? void 0 : se.placement;
        if (!pe)
          switch (j) {
            case "bestFit": {
              var te;
              const Se = (te = Z.filter((oe) => {
                if (H) {
                  const ue = Y4(oe.placement);
                  return ue === I || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ue === "y";
                }
                return !0;
              }).map((oe) => [oe.placement, oe.overflows.filter((ue) => ue > 0).reduce((ue, he) => ue + he, 0)]).sort((oe, ue) => oe[1] - ue[1])[0]) == null ? void 0 : te[0];
              Se && (pe = Se);
              break;
            }
            case "initialPlacement":
              pe = u;
              break;
          }
        if (s !== pe)
          return {
            reset: {
              placement: pe
            }
          };
      }
      return {};
    }
  };
};
async function Lie(e, t) {
  const {
    placement: n,
    platform: r,
    elements: s
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)), c = B2(n), u = s6(n), m = Y4(n) === "y", y = ["left", "top"].includes(c) ? -1 : 1, b = o && m ? -1 : 1, w = mw(t, e);
  let {
    mainAxis: k,
    crossAxis: j,
    alignmentAxis: E
  } = typeof w == "number" ? {
    mainAxis: w,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...w
  };
  return u && typeof E == "number" && (j = u === "end" ? E * -1 : E), m ? {
    x: j * b,
    y: k * y
  } : {
    x: k * y,
    y: j * b
  };
}
const Iie = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: s,
        y: o,
        placement: c,
        middlewareData: u
      } = t, m = await Lie(t, e);
      return c === ((n = u.offset) == null ? void 0 : n.placement) && (r = u.arrow) != null && r.alignmentOffset ? {} : {
        x: s + m.x,
        y: o + m.y,
        data: {
          ...m,
          placement: c
        }
      };
    }
  };
}, Fie = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: s
      } = t, {
        mainAxis: o = !0,
        crossAxis: c = !1,
        limiter: u = {
          fn: (D) => {
            let {
              x: L,
              y: I
            } = D;
            return {
              x: L,
              y: I
            };
          }
        },
        ...m
      } = mw(e, t), y = {
        x: n,
        y: r
      }, b = await TE(t, m), w = Y4(B2(s)), k = rG(w);
      let j = y[k], E = y[w];
      if (o) {
        const D = k === "y" ? "top" : "left", L = k === "y" ? "bottom" : "right", I = j + b[D], R = j - b[L];
        j = uU(I, j, R);
      }
      if (c) {
        const D = w === "y" ? "top" : "left", L = w === "y" ? "bottom" : "right", I = E + b[D], R = E - b[L];
        E = uU(I, E, R);
      }
      const T = u.fn({
        ...t,
        [k]: j,
        [w]: E
      });
      return {
        ...T,
        data: {
          x: T.x - n,
          y: T.y - r
        }
      };
    }
  };
}, Uie = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: s,
        elements: o
      } = t, {
        apply: c = () => {
        },
        ...u
      } = mw(e, t), m = await TE(t, u), y = B2(n), b = s6(n), w = Y4(n) === "y", {
        width: k,
        height: j
      } = r.floating;
      let E, T;
      y === "top" || y === "bottom" ? (E = y, T = b === (await (s.isRTL == null ? void 0 : s.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (T = y, E = b === "end" ? "top" : "bottom");
      const D = j - m.top - m.bottom, L = k - m.left - m.right, I = _2(j - m[E], D), R = _2(k - m[T], L), U = !t.middlewareData.shift;
      let z = I, H = R;
      if (w ? H = b || U ? _2(R, L) : L : z = b || U ? _2(I, D) : D, U && !b) {
        const q = fp(m.left, 0), Q = fp(m.right, 0), Z = fp(m.top, 0), X = fp(m.bottom, 0);
        w ? H = k - 2 * (q !== 0 || Q !== 0 ? q + Q : fp(m.left, m.right)) : z = j - 2 * (Z !== 0 || X !== 0 ? Z + X : fp(m.top, m.bottom));
      }
      await c({
        ...t,
        availableWidth: H,
        availableHeight: z
      });
      const K = await s.getDimensions(o.floating);
      return k !== K.width || j !== K.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function iG(e) {
  const t = Qg(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const s = yy(e), o = s ? e.offsetWidth : n, c = s ? e.offsetHeight : r, u = T9(n) !== o || T9(r) !== c;
  return u && (n = o, r = c), {
    width: n,
    height: r,
    $: u
  };
}
function pO(e) {
  return Cf(e) ? e : e.contextElement;
}
function T8(e) {
  const t = pO(e);
  if (!yy(t))
    return z2(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: s,
    $: o
  } = iG(t);
  let c = (o ? T9(n.width) : n.width) / r, u = (o ? T9(n.height) : n.height) / s;
  return (!c || !Number.isFinite(c)) && (c = 1), (!u || !Number.isFinite(u)) && (u = 1), {
    x: c,
    y: u
  };
}
const zie = /* @__PURE__ */ z2(0);
function oG(e) {
  const t = pp(e);
  return !hO() || !t.visualViewport ? zie : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Bie(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== pp(e) ? !1 : t;
}
function q4(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), o = pO(e);
  let c = z2(1);
  t && (r ? Cf(r) && (c = T8(r)) : c = T8(e));
  const u = Bie(o, n, r) ? oG(o) : z2(0);
  let m = (s.left + u.x) / c.x, y = (s.top + u.y) / c.y, b = s.width / c.x, w = s.height / c.y;
  if (o) {
    const k = pp(o), j = r && Cf(r) ? pp(r) : r;
    let E = k, T = TD(E);
    for (; T && r && j !== E; ) {
      const D = T8(T), L = T.getBoundingClientRect(), I = Qg(T), R = L.left + (T.clientLeft + parseFloat(I.paddingLeft)) * D.x, U = L.top + (T.clientTop + parseFloat(I.paddingTop)) * D.y;
      m *= D.x, y *= D.y, b *= D.x, w *= D.y, m += R, y += U, E = pp(T), T = TD(E);
    }
  }
  return R9({
    width: b,
    height: w,
    x: m,
    y
  });
}
function Hie(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: s
  } = e;
  const o = s === "fixed", c = qv(r), u = t ? kE(t.floating) : !1;
  if (r === c || u && o)
    return n;
  let m = {
    scrollLeft: 0,
    scrollTop: 0
  }, y = z2(1);
  const b = z2(0), w = yy(r);
  if ((w || !w && !o) && ((fw(r) !== "body" || a6(c)) && (m = _E(r)), yy(r))) {
    const k = q4(r);
    y = T8(r), b.x = k.x + r.clientLeft, b.y = k.y + r.clientTop;
  }
  return {
    width: n.width * y.x,
    height: n.height * y.y,
    x: n.x * y.x - m.scrollLeft * y.x + b.x,
    y: n.y * y.y - m.scrollTop * y.y + b.y
  };
}
function Vie(e) {
  return Array.from(e.getClientRects());
}
function lG(e) {
  return q4(qv(e)).left + _E(e).scrollLeft;
}
function $ie(e) {
  const t = qv(e), n = _E(e), r = e.ownerDocument.body, s = fp(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = fp(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let c = -n.scrollLeft + lG(e);
  const u = -n.scrollTop;
  return Qg(r).direction === "rtl" && (c += fp(t.clientWidth, r.clientWidth) - s), {
    width: s,
    height: o,
    x: c,
    y: u
  };
}
function Gie(e, t) {
  const n = pp(e), r = qv(e), s = n.visualViewport;
  let o = r.clientWidth, c = r.clientHeight, u = 0, m = 0;
  if (s) {
    o = s.width, c = s.height;
    const y = hO();
    (!y || y && t === "fixed") && (u = s.offsetLeft, m = s.offsetTop);
  }
  return {
    width: o,
    height: c,
    x: u,
    y: m
  };
}
function Wie(e, t) {
  const n = q4(e, !0, t === "fixed"), r = n.top + e.clientTop, s = n.left + e.clientLeft, o = yy(e) ? T8(e) : z2(1), c = e.clientWidth * o.x, u = e.clientHeight * o.y, m = s * o.x, y = r * o.y;
  return {
    width: c,
    height: u,
    x: m,
    y
  };
}
function fU(e, t, n) {
  let r;
  if (t === "viewport")
    r = Gie(e, n);
  else if (t === "document")
    r = $ie(qv(e));
  else if (Cf(t))
    r = Wie(t, n);
  else {
    const s = oG(e);
    r = {
      ...t,
      x: t.x - s.x,
      y: t.y - s.y
    };
  }
  return R9(r);
}
function cG(e, t) {
  const n = U2(e);
  return n === t || !Cf(n) || H8(n) ? !1 : Qg(n).position === "fixed" || cG(n, t);
}
function Yie(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = C3(e, [], !1).filter((u) => Cf(u) && fw(u) !== "body"), s = null;
  const o = Qg(e).position === "fixed";
  let c = o ? U2(e) : e;
  for (; Cf(c) && !H8(c); ) {
    const u = Qg(c), m = mO(c);
    !m && u.position === "fixed" && (s = null), (o ? !m && !s : !m && u.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || a6(c) && !m && cG(e, c)) ? r = r.filter((b) => b !== c) : s = u, c = U2(c);
  }
  return t.set(e, r), r;
}
function qie(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: s
  } = e;
  const c = [...n === "clippingAncestors" ? kE(t) ? [] : Yie(t, this._c) : [].concat(n), r], u = c[0], m = c.reduce((y, b) => {
    const w = fU(t, b, s);
    return y.top = fp(w.top, y.top), y.right = _2(w.right, y.right), y.bottom = _2(w.bottom, y.bottom), y.left = fp(w.left, y.left), y;
  }, fU(t, u, s));
  return {
    width: m.right - m.left,
    height: m.bottom - m.top,
    x: m.left,
    y: m.top
  };
}
function Kie(e) {
  const {
    width: t,
    height: n
  } = iG(e);
  return {
    width: t,
    height: n
  };
}
function Xie(e, t, n) {
  const r = yy(t), s = qv(t), o = n === "fixed", c = q4(e, !0, o, t);
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const m = z2(0);
  if (r || !r && !o)
    if ((fw(t) !== "body" || a6(s)) && (u = _E(t)), r) {
      const w = q4(t, !0, o, t);
      m.x = w.x + t.clientLeft, m.y = w.y + t.clientTop;
    } else s && (m.x = lG(s));
  const y = c.left + u.scrollLeft - m.x, b = c.top + u.scrollTop - m.y;
  return {
    x: y,
    y: b,
    width: c.width,
    height: c.height
  };
}
function UM(e) {
  return Qg(e).position === "static";
}
function mU(e, t) {
  return !yy(e) || Qg(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function uG(e, t) {
  const n = pp(e);
  if (kE(e))
    return n;
  if (!yy(e)) {
    let s = U2(e);
    for (; s && !H8(s); ) {
      if (Cf(s) && !UM(s))
        return s;
      s = U2(s);
    }
    return n;
  }
  let r = mU(e, t);
  for (; r && Cie(r) && UM(r); )
    r = mU(r, t);
  return r && H8(r) && UM(r) && !mO(r) ? n : r || Nie(e) || n;
}
const Qie = async function(e) {
  const t = this.getOffsetParent || uG, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Xie(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Zie(e) {
  return Qg(e).direction === "rtl";
}
const Jie = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Hie,
  getDocumentElement: qv,
  getClippingRect: qie,
  getOffsetParent: uG,
  getElementRects: Qie,
  getClientRects: Vie,
  getDimensions: Kie,
  getScale: T8,
  isElement: Cf,
  isRTL: Zie
};
function eoe(e, t) {
  let n = null, r;
  const s = qv(e);
  function o() {
    var u;
    clearTimeout(r), (u = n) == null || u.disconnect(), n = null;
  }
  function c(u, m) {
    u === void 0 && (u = !1), m === void 0 && (m = 1), o();
    const {
      left: y,
      top: b,
      width: w,
      height: k
    } = e.getBoundingClientRect();
    if (u || t(), !w || !k)
      return;
    const j = wj(b), E = wj(s.clientWidth - (y + w)), T = wj(s.clientHeight - (b + k)), D = wj(y), I = {
      rootMargin: -j + "px " + -E + "px " + -T + "px " + -D + "px",
      threshold: fp(0, _2(1, m)) || 1
    };
    let R = !0;
    function U(z) {
      const H = z[0].intersectionRatio;
      if (H !== m) {
        if (!R)
          return c();
        H ? c(!1, H) : r = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      R = !1;
    }
    try {
      n = new IntersectionObserver(U, {
        ...I,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(U, I);
    }
    n.observe(e);
  }
  return c(!0), o;
}
function toe(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: o = !0,
    elementResize: c = typeof ResizeObserver == "function",
    layoutShift: u = typeof IntersectionObserver == "function",
    animationFrame: m = !1
  } = r, y = pO(e), b = s || o ? [...y ? C3(y) : [], ...C3(t)] : [];
  b.forEach((L) => {
    s && L.addEventListener("scroll", n, {
      passive: !0
    }), o && L.addEventListener("resize", n);
  });
  const w = y && u ? eoe(y, n) : null;
  let k = -1, j = null;
  c && (j = new ResizeObserver((L) => {
    let [I] = L;
    I && I.target === y && j && (j.unobserve(t), cancelAnimationFrame(k), k = requestAnimationFrame(() => {
      var R;
      (R = j) == null || R.observe(t);
    })), n();
  }), y && !m && j.observe(y), j.observe(t));
  let E, T = m ? q4(e) : null;
  m && D();
  function D() {
    const L = q4(e);
    T && (L.x !== T.x || L.y !== T.y || L.width !== T.width || L.height !== T.height) && n(), T = L, E = requestAnimationFrame(D);
  }
  return n(), () => {
    var L;
    b.forEach((I) => {
      s && I.removeEventListener("scroll", n), o && I.removeEventListener("resize", n);
    }), w == null || w(), (L = j) == null || L.disconnect(), j = null, m && cancelAnimationFrame(E);
  };
}
const zM = TE, noe = Iie, roe = Fie, aoe = Aie, soe = Uie, ioe = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), s = {
    platform: Jie,
    ...n
  }, o = {
    ...s.platform,
    _c: r
  };
  return Oie(e, t, {
    ...s,
    platform: o
  });
};
var e9 = typeof document < "u" ? a5 : an;
function D9(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, s;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!D9(e[r], t[r]))
          return !1;
      return !0;
    }
    if (s = Object.keys(e), n = s.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, s[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = s[r];
      if (!(o === "_owner" && e.$$typeof) && !D9(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function dG(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function hU(e, t) {
  const n = dG(e);
  return Math.round(t * n) / n;
}
function pU(e) {
  const t = re.useRef(e);
  return e9(() => {
    t.current = e;
  }), t;
}
function ooe(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: s,
    elements: {
      reference: o,
      floating: c
    } = {},
    transform: u = !0,
    whileElementsMounted: m,
    open: y
  } = e, [b, w] = re.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [k, j] = re.useState(r);
  D9(k, r) || j(r);
  const [E, T] = re.useState(null), [D, L] = re.useState(null), I = re.useCallback((Se) => {
    Se !== H.current && (H.current = Se, T(Se));
  }, []), R = re.useCallback((Se) => {
    Se !== K.current && (K.current = Se, L(Se));
  }, []), U = o || E, z = c || D, H = re.useRef(null), K = re.useRef(null), q = re.useRef(b), Q = m != null, Z = pU(m), X = pU(s), se = re.useCallback(() => {
    if (!H.current || !K.current)
      return;
    const Se = {
      placement: t,
      strategy: n,
      middleware: k
    };
    X.current && (Se.platform = X.current), ioe(H.current, K.current, Se).then((oe) => {
      const ue = {
        ...oe,
        isPositioned: !0
      };
      te.current && !D9(q.current, ue) && (q.current = ue, po.flushSync(() => {
        w(ue);
      }));
    });
  }, [k, t, n, X]);
  e9(() => {
    y === !1 && q.current.isPositioned && (q.current.isPositioned = !1, w((Se) => ({
      ...Se,
      isPositioned: !1
    })));
  }, [y]);
  const te = re.useRef(!1);
  e9(() => (te.current = !0, () => {
    te.current = !1;
  }), []), e9(() => {
    if (U && (H.current = U), z && (K.current = z), U && z) {
      if (Z.current)
        return Z.current(U, z, se);
      se();
    }
  }, [U, z, se, Z, Q]);
  const fe = re.useMemo(() => ({
    reference: H,
    floating: K,
    setReference: I,
    setFloating: R
  }), [I, R]), ce = re.useMemo(() => ({
    reference: U,
    floating: z
  }), [U, z]), pe = re.useMemo(() => {
    const Se = {
      position: n,
      left: 0,
      top: 0
    };
    if (!ce.floating)
      return Se;
    const oe = hU(ce.floating, b.x), ue = hU(ce.floating, b.y);
    return u ? {
      ...Se,
      transform: "translate(" + oe + "px, " + ue + "px)",
      ...dG(ce.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: oe,
      top: ue
    };
  }, [n, u, ce.floating, b.x, b.y]);
  return re.useMemo(() => ({
    ...b,
    update: se,
    refs: fe,
    elements: ce,
    floatingStyles: pe
  }), [b, se, fe, ce, pe]);
}
const fG = (e, t) => ({
  ...noe(e),
  options: [e, t]
}), loe = (e, t) => ({
  ...roe(e),
  options: [e, t]
}), coe = (e, t) => ({
  ...aoe(e),
  options: [e, t]
}), uoe = (e, t) => ({
  ...soe(e),
  options: [e, t]
}), mG = {
  ...re
}, doe = mG.useInsertionEffect, foe = doe || ((e) => e());
function hG(e) {
  const t = re.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return foe(() => {
    t.current = e;
  }), re.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), s = 0; s < n; s++)
      r[s] = arguments[s];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
var RD = typeof document < "u" ? a5 : an;
let gU = !1, moe = 0;
const yU = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + moe++
);
function hoe() {
  const [e, t] = re.useState(() => gU ? yU() : void 0);
  return RD(() => {
    e == null && t(yU());
  }, []), re.useEffect(() => {
    gU = !0;
  }, []), e;
}
const poe = mG.useId, goe = poe || hoe;
let N3;
process.env.NODE_ENV !== "production" && (N3 = /* @__PURE__ */ new Set());
function yoe() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const s = "Floating UI: " + n.join(" ");
  if (!((e = N3) != null && e.has(s))) {
    var o;
    (o = N3) == null || o.add(s), console.warn(s);
  }
}
function voe() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const s = "Floating UI: " + n.join(" ");
  if (!((e = N3) != null && e.has(s))) {
    var o;
    (o = N3) == null || o.add(s), console.error(s);
  }
}
function xoe() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((s) => s(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((s) => s !== n)) || []);
    }
  };
}
const boe = /* @__PURE__ */ re.createContext(null), Soe = /* @__PURE__ */ re.createContext(null), woe = () => {
  var e;
  return ((e = re.useContext(boe)) == null ? void 0 : e.id) || null;
}, Coe = () => re.useContext(Soe);
function Noe(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, s = goe(), o = re.useRef({}), [c] = re.useState(() => xoe()), u = woe() != null;
  if (process.env.NODE_ENV !== "production") {
    const j = r.reference;
    j && !Cf(j) && voe("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [m, y] = re.useState(r.reference), b = hG((j, E, T) => {
    o.current.openEvent = j ? E : void 0, c.emit("openchange", {
      open: j,
      event: E,
      reason: T,
      nested: u
    }), n == null || n(j, E, T);
  }), w = re.useMemo(() => ({
    setPositionReference: y
  }), []), k = re.useMemo(() => ({
    reference: m || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [m, r.reference, r.floating]);
  return re.useMemo(() => ({
    dataRef: o,
    open: t,
    onOpenChange: b,
    elements: k,
    events: c,
    floatingId: s,
    refs: w
  }), [t, b, k, c, s, w]);
}
function joe(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = Noe({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, s = r.elements, [o, c] = re.useState(null), [u, m] = re.useState(null), b = (s == null ? void 0 : s.reference) || o, w = re.useRef(null), k = Coe();
  RD(() => {
    b && (w.current = b);
  }, [b]);
  const j = ooe({
    ...e,
    elements: {
      ...s,
      ...u && {
        reference: u
      }
    }
  }), E = re.useCallback((R) => {
    const U = Cf(R) ? {
      getBoundingClientRect: () => R.getBoundingClientRect(),
      contextElement: R
    } : R;
    m(U), j.refs.setReference(U);
  }, [j.refs]), T = re.useCallback((R) => {
    (Cf(R) || R === null) && (w.current = R, c(R)), (Cf(j.refs.reference.current) || j.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    R !== null && !Cf(R)) && j.refs.setReference(R);
  }, [j.refs]), D = re.useMemo(() => ({
    ...j.refs,
    setReference: T,
    setPositionReference: E,
    domReference: w
  }), [j.refs, T, E]), L = re.useMemo(() => ({
    ...j.elements,
    domReference: b
  }), [j.elements, b]), I = re.useMemo(() => ({
    ...j,
    ...r,
    refs: D,
    elements: L,
    nodeId: t
  }), [j, D, L, t, r]);
  return RD(() => {
    r.dataRef.current.floatingContext = I;
    const R = k == null ? void 0 : k.nodesRef.current.find((U) => U.id === t);
    R && (R.context = I);
  }), re.useMemo(() => ({
    ...j,
    context: I,
    refs: D,
    elements: L
  }), [j, D, L, I]);
}
const vU = "active", xU = "selected";
function BM(e, t, n) {
  const r = /* @__PURE__ */ new Map(), s = n === "item";
  let o = e;
  if (s && e) {
    const {
      [vU]: c,
      [xU]: u,
      ...m
    } = e;
    o = m;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1
    },
    ...o,
    ...t.map((c) => {
      const u = c ? c[n] : null;
      return typeof u == "function" ? e ? u(e) : null : u;
    }).concat(e).reduce((c, u) => (u && Object.entries(u).forEach((m) => {
      let [y, b] = m;
      if (!(s && [vU, xU].includes(y)))
        if (y.indexOf("on") === 0) {
          if (r.has(y) || r.set(y, []), typeof b == "function") {
            var w;
            (w = r.get(y)) == null || w.push(b), c[y] = function() {
              for (var k, j = arguments.length, E = new Array(j), T = 0; T < j; T++)
                E[T] = arguments[T];
              return (k = r.get(y)) == null ? void 0 : k.map((D) => D(...E)).find((D) => D !== void 0);
            };
          }
        } else
          c[y] = b;
    }), c), {})
  };
}
function Eoe(e) {
  e === void 0 && (e = []);
  const t = e.map((u) => u == null ? void 0 : u.reference), n = e.map((u) => u == null ? void 0 : u.floating), r = e.map((u) => u == null ? void 0 : u.item), s = re.useCallback(
    (u) => BM(u, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), o = re.useCallback(
    (u) => BM(u, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), c = re.useCallback(
    (u) => BM(u, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return re.useMemo(() => ({
    getReferenceProps: s,
    getFloatingProps: o,
    getItemProps: c
  }), [s, o, c]);
}
function bU(e, t) {
  return {
    ...e,
    rects: {
      ...e.rects,
      floating: {
        ...e.rects.floating,
        height: t
      }
    }
  };
}
const koe = (e) => ({
  name: "inner",
  options: e,
  async fn(t) {
    const {
      listRef: n,
      overflowRef: r,
      onFallbackChange: s,
      offset: o = 0,
      index: c = 0,
      minItemsVisible: u = 4,
      referenceOverflowThreshold: m = 0,
      scrollRef: y,
      ...b
    } = mw(e, t), {
      rects: w,
      elements: {
        floating: k
      }
    } = t, j = n.current[c];
    if (process.env.NODE_ENV !== "production" && (t.placement.startsWith("bottom") || yoe('`placement` side must be "bottom" when using the `inner`', "middleware.")), !j)
      return {};
    const E = {
      ...t,
      ...await fG(-j.offsetTop - k.clientTop - w.reference.height / 2 - j.offsetHeight / 2 - o).fn(t)
    }, T = (y == null ? void 0 : y.current) || k, D = await zM(bU(E, T.scrollHeight), b), L = await zM(E, {
      ...b,
      elementContext: "reference"
    }), I = Math.max(0, D.top), R = E.y + I, U = Math.max(0, T.scrollHeight - I - Math.max(0, D.bottom));
    return T.style.maxHeight = U + "px", T.scrollTop = I, s && (T.offsetHeight < j.offsetHeight * Math.min(u, n.current.length - 1) - 1 || L.top >= -m || L.bottom >= -m ? po.flushSync(() => s(!0)) : po.flushSync(() => s(!1))), r && (r.current = await zM(bU({
      ...E,
      y: R
    }, T.offsetHeight), b)), {
      y: R
    };
  }
});
function _oe(e, t) {
  const {
    open: n,
    elements: r
  } = e, {
    enabled: s = !0,
    overflowRef: o,
    scrollRef: c,
    onChange: u
  } = t, m = hG(u), y = re.useRef(!1), b = re.useRef(null), w = re.useRef(null);
  re.useEffect(() => {
    if (!s) return;
    function j(T) {
      if (T.ctrlKey || !E || o.current == null)
        return;
      const D = T.deltaY, L = o.current.top >= -0.5, I = o.current.bottom >= -0.5, R = E.scrollHeight - E.clientHeight, U = D < 0 ? -1 : 1, z = D < 0 ? "max" : "min";
      E.scrollHeight <= E.clientHeight || (!L && D > 0 || !I && D < 0 ? (T.preventDefault(), po.flushSync(() => {
        m((H) => H + Math[z](D, R * U));
      })) : /firefox/i.test(jie()) && (E.scrollTop += D));
    }
    const E = (c == null ? void 0 : c.current) || r.floating;
    if (n && E)
      return E.addEventListener("wheel", j), requestAnimationFrame(() => {
        b.current = E.scrollTop, o.current != null && (w.current = {
          ...o.current
        });
      }), () => {
        b.current = null, w.current = null, E.removeEventListener("wheel", j);
      };
  }, [s, n, r.floating, o, c, m]);
  const k = re.useMemo(() => ({
    onKeyDown() {
      y.current = !0;
    },
    onWheel() {
      y.current = !1;
    },
    onPointerMove() {
      y.current = !1;
    },
    onScroll() {
      const j = (c == null ? void 0 : c.current) || r.floating;
      if (!(!o.current || !j || !y.current)) {
        if (b.current !== null) {
          const E = j.scrollTop - b.current;
          (o.current.bottom < -0.5 && E < -1 || o.current.top < -0.5 && E > 1) && po.flushSync(() => m((T) => T + E));
        }
        requestAnimationFrame(() => {
          b.current = j.scrollTop;
        });
      }
    }
  }), [r.floating, m, o, c]);
  return re.useMemo(() => s ? {
    floating: k
  } : {}, [s, k]);
}
let hw = ys({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
hw.displayName = "FloatingContext";
let gO = ys(null);
gO.displayName = "PlacementContext";
function pG(e) {
  return dn(() => e ? typeof e == "string" ? { to: e } : e : null, [e]);
}
function gG() {
  return Ra(hw).setReference;
}
function Toe() {
  return Ra(hw).getReferenceProps;
}
function yG() {
  let { getFloatingProps: e, slot: t } = Ra(hw);
  return qa((...n) => Object.assign({}, e(...n), { "data-anchor": t.anchor }), [e, t]);
}
function vG(e = null) {
  e === !1 && (e = null), typeof e == "string" && (e = { to: e });
  let t = Ra(gO), n = dn(() => e, [JSON.stringify(e, typeof HTMLElement < "u" ? (s, o) => o instanceof HTMLElement ? o.outerHTML : o : void 0)]);
  gs(() => {
    t == null || t(n ?? null);
  }, [t, n]);
  let r = Ra(hw);
  return dn(() => [r.setFloating, e ? r.styles : {}], [r.setFloating, e, r.styles]);
}
let SU = 4;
function xG({ children: e, enabled: t = !0 }) {
  let [n, r] = Re(null), [s, o] = Re(0), c = Rt(null), [u, m] = Re(null);
  Moe(u);
  let y = t && n !== null && u !== null, { to: b = "bottom", gap: w = 0, offset: k = 0, padding: j = 0, inner: E } = Roe(n, u), [T, D = "center"] = b.split(" ");
  gs(() => {
    y && o(0);
  }, [y]);
  let { refs: L, floatingStyles: I, context: R } = joe({ open: y, placement: T === "selection" ? D === "center" ? "bottom" : `bottom-${D}` : D === "center" ? `${T}` : `${T}-${D}`, strategy: "absolute", transform: !1, middleware: [fG({ mainAxis: T === "selection" ? 0 : w, crossAxis: k }), loe({ padding: j }), T !== "selection" && coe({ padding: j }), T === "selection" && E ? koe({ ...E, padding: j, overflowRef: c, offset: s, minItemsVisible: SU, referenceOverflowThreshold: j, onFallbackChange(X) {
    var se, te;
    if (!X) return;
    let fe = R.elements.floating;
    if (!fe) return;
    let ce = parseFloat(getComputedStyle(fe).scrollPaddingBottom) || 0, pe = Math.min(SU, fe.childElementCount), Se = 0, oe = 0;
    for (let ue of (te = (se = R.elements.floating) == null ? void 0 : se.childNodes) != null ? te : []) if (ue instanceof HTMLElement) {
      let he = ue.offsetTop, ve = he + ue.clientHeight + ce, Te = fe.scrollTop, Ie = Te + fe.clientHeight;
      if (he >= Te && ve <= Ie) pe--;
      else {
        oe = Math.max(0, Math.min(ve, Ie) - Math.max(he, Te)), Se = ue.clientHeight;
        break;
      }
    }
    pe >= 1 && o((ue) => {
      let he = Se * pe - oe + ce;
      return ue >= he ? ue : he;
    });
  } }) : null, uoe({ padding: j, apply({ availableWidth: X, availableHeight: se, elements: te }) {
    Object.assign(te.floating.style, { overflow: "auto", maxWidth: `${X}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${se}px)` });
  } })].filter(Boolean), whileElementsMounted: toe }), [U = T, z = D] = R.placement.split("-");
  T === "selection" && (U = "selection");
  let H = dn(() => ({ anchor: [U, z].filter(Boolean).join(" ") }), [U, z]), K = _oe(R, { overflowRef: c, onChange: o }), { getReferenceProps: q, getFloatingProps: Q } = Eoe([K]), Z = ln((X) => {
    m(X), L.setFloating(X);
  });
  return re.createElement(gO.Provider, { value: r }, re.createElement(hw.Provider, { value: { setFloating: Z, setReference: L.setReference, styles: I, getReferenceProps: q, getFloatingProps: Q, slot: H } }, e));
}
function Moe(e) {
  gs(() => {
    if (!e) return;
    let t = new MutationObserver(() => {
      let n = window.getComputedStyle(e).maxHeight, r = parseFloat(n);
      if (isNaN(r)) return;
      let s = parseInt(n);
      isNaN(s) || r !== s && (e.style.maxHeight = `${Math.ceil(r)}px`);
    });
    return t.observe(e, { attributes: !0, attributeFilter: ["style"] }), () => {
      t.disconnect();
    };
  }, [e]);
}
function Roe(e, t) {
  var n, r, s;
  let o = HM((n = e == null ? void 0 : e.gap) != null ? n : "var(--anchor-gap, 0)", t), c = HM((r = e == null ? void 0 : e.offset) != null ? r : "var(--anchor-offset, 0)", t), u = HM((s = e == null ? void 0 : e.padding) != null ? s : "var(--anchor-padding, 0)", t);
  return { ...e, gap: o, offset: c, padding: u };
}
function HM(e, t, n = void 0) {
  let r = Yv(), s = ln((m, y) => {
    if (m == null) return [n, null];
    if (typeof m == "number") return [m, null];
    if (typeof m == "string") {
      if (!y) return [n, null];
      let b = wU(m, y);
      return [b, (w) => {
        let k = bG(m);
        {
          let j = k.map((E) => window.getComputedStyle(y).getPropertyValue(E));
          r.requestAnimationFrame(function E() {
            r.nextFrame(E);
            let T = !1;
            for (let [L, I] of k.entries()) {
              let R = window.getComputedStyle(y).getPropertyValue(I);
              if (j[L] !== R) {
                j[L] = R, T = !0;
                break;
              }
            }
            if (!T) return;
            let D = wU(m, y);
            b !== D && (w(D), b = D);
          });
        }
        return r.dispose;
      }];
    }
    return [n, null];
  }), o = dn(() => s(e, t)[0], [e, t]), [c = o, u] = Re();
  return gs(() => {
    let [m, y] = s(e, t);
    if (u(m), !!y) return y(u);
  }, [e, t]), c;
}
function bG(e) {
  let t = /var\((.*)\)/.exec(e);
  if (t) {
    let n = t[1].indexOf(",");
    if (n === -1) return [t[1]];
    let r = t[1].slice(0, n).trim(), s = t[1].slice(n + 1).trim();
    return s ? [r, ...bG(s)] : [r];
  }
  return [];
}
function wU(e, t) {
  let n = document.createElement("div");
  t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
  let r = parseFloat(window.getComputedStyle(n).marginTop) || 0;
  return t.removeChild(n), r;
}
function Doe(e, t) {
  let [n, r] = Re(t);
  return !e && n !== t && r(t), e ? n : t;
}
let ME = ys(null);
ME.displayName = "OpenClosedContext";
var Xl = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Xl || {});
function pw() {
  return Ra(ME);
}
function RE({ value: e, children: t }) {
  return Ee.createElement(ME.Provider, { value: e }, t);
}
function SG({ children: e }) {
  return Ee.createElement(ME.Provider, { value: null }, e);
}
function Poe(e) {
  throw new Error("Unexpected object: " + e);
}
var mu = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(mu || {});
function VM(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0) return null;
  let r = t.resolveActiveIndex(), s = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let o = 0; o < n.length; ++o) if (!t.resolveDisabled(n[o], o, n)) return o;
      return r;
    }
    case 1: {
      s === -1 && (s = n.length);
      for (let o = s - 1; o >= 0; --o) if (!t.resolveDisabled(n[o], o, n)) return o;
      return r;
    }
    case 2: {
      for (let o = s + 1; o < n.length; ++o) if (!t.resolveDisabled(n[o], o, n)) return o;
      return r;
    }
    case 3: {
      for (let o = n.length - 1; o >= 0; --o) if (!t.resolveDisabled(n[o], o, n)) return o;
      return r;
    }
    case 4: {
      for (let o = 0; o < n.length; ++o) if (t.resolveId(n[o], o, n) === e.id) return o;
      return r;
    }
    case 5:
      return null;
    default:
      Poe(e);
  }
}
function Ooe(e) {
  let t = ln(e), n = Rt(!1);
  an(() => (n.current = !1, () => {
    n.current = !0, oO(() => {
      n.current && t();
    });
  }), [t]);
}
function Aoe() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in re ? ((t) => t.useSyncExternalStore)(re)(() => () => {
  }, () => !1, () => !e) : !1;
}
function yO() {
  let e = Aoe(), [t, n] = re.useState(A4.isHandoffComplete);
  return t && A4.isHandoffComplete === !1 && n(!1), re.useEffect(() => {
    t !== !0 && n(!0);
  }, [t]), re.useEffect(() => A4.handoff(), []), e ? !1 : t;
}
let Loe = ys(!1);
function Ioe() {
  return Ra(Loe);
}
function Foe(e) {
  let t = Ioe(), n = Ra(CG), r = c5(e), [s, o] = Re(() => {
    var c;
    if (!t && n !== null) return (c = n.current) != null ? c : null;
    if (A4.isServer) return null;
    let u = r == null ? void 0 : r.getElementById("headlessui-portal-root");
    if (u) return u;
    if (r === null) return null;
    let m = r.createElement("div");
    return m.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(m);
  });
  return an(() => {
    s !== null && (r != null && r.body.contains(s) || r == null || r.body.appendChild(s));
  }, [s, r]), an(() => {
    t || n !== null && o(n.current);
  }, [n, o, t]), s;
}
let wG = jf, Uoe = Xa(function(e, t) {
  let n = e, r = Rt(null), s = ri(cO((b) => {
    r.current = b;
  }), t), o = c5(r), c = Foe(r), [u] = Re(() => {
    var b;
    return A4.isServer ? null : (b = o == null ? void 0 : o.createElement("div")) != null ? b : null;
  }), m = Ra(DD), y = yO();
  return gs(() => {
    !c || !u || c.contains(u) || (u.setAttribute("data-headlessui-portal", ""), c.appendChild(u));
  }, [c, u]), gs(() => {
    if (u && m) return m.register(u);
  }, [m, u]), Ooe(() => {
    var b;
    !c || !u || (u instanceof Node && c.contains(u) && c.removeChild(u), c.childNodes.length <= 0 && ((b = c.parentElement) == null || b.removeChild(c)));
  }), y ? !c || !u ? null : po.createPortal(is({ ourProps: { ref: s }, theirProps: n, slot: {}, defaultTag: wG, name: "Portal" }), u) : null;
});
function zoe(e, t) {
  let n = ri(t), { enabled: r = !0, ...s } = e;
  return r ? Ee.createElement(Uoe, { ...s, ref: n }) : is({ ourProps: { ref: n }, theirProps: s, slot: {}, defaultTag: wG, name: "Portal" });
}
let Boe = jf, CG = ys(null);
function Hoe(e, t) {
  let { target: n, ...r } = e, s = { ref: ri(t) };
  return Ee.createElement(CG.Provider, { value: n }, is({ ourProps: s, theirProps: r, defaultTag: Boe, name: "Popover.Group" }));
}
let DD = ys(null);
function Voe() {
  let e = Ra(DD), t = Rt([]), n = ln((o) => (t.current.push(o), e && e.register(o), () => r(o))), r = ln((o) => {
    let c = t.current.indexOf(o);
    c !== -1 && t.current.splice(c, 1), e && e.unregister(o);
  }), s = dn(() => ({ register: n, unregister: r, portals: t }), [n, r, t]);
  return [t, dn(() => function({ children: o }) {
    return Ee.createElement(DD.Provider, { value: s }, o);
  }, [s])];
}
let $oe = Xa(zoe), Goe = Xa(Hoe), NG = Object.assign($oe, { Group: Goe });
function Woe({ defaultContainers: e = [], portals: t, mainTreeNode: n } = {}) {
  let r = c5(n), s = ln(() => {
    var o, c;
    let u = [];
    for (let m of e) m !== null && (m instanceof HTMLElement ? u.push(m) : "current" in m && m.current instanceof HTMLElement && u.push(m.current));
    if (t != null && t.current) for (let m of t.current) u.push(m);
    for (let m of (o = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? o : []) m !== document.body && m !== document.head && m instanceof HTMLElement && m.id !== "headlessui-portal-root" && (n && (m.contains(n) || m.contains((c = n == null ? void 0 : n.getRootNode()) == null ? void 0 : c.host)) || u.some((y) => m.contains(y)) || u.push(m));
    return u;
  });
  return { resolveContainers: s, contains: ln((o) => s().some((c) => c.contains(o))) };
}
let jG = ys(null);
function EG({ children: e, node: t }) {
  let [n, r] = Re(null), s = kG(t ?? n);
  return Ee.createElement(jG.Provider, { value: s }, e, s === null && Ee.createElement(Hv, { features: Bv.Hidden, ref: (o) => {
    var c, u;
    if (o) {
      for (let m of (u = (c = Ey(o)) == null ? void 0 : c.querySelectorAll("html > *, body > *")) != null ? u : []) if (m !== document.body && m !== document.head && m instanceof HTMLElement && m != null && m.contains(o)) {
        r(m);
        break;
      }
    }
  } }));
}
function kG(e = null) {
  var t;
  return (t = Ra(jG)) != null ? t : e;
}
function _G() {
  let e = Rt(!1);
  return gs(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
var Dv = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Dv || {});
function TG() {
  let e = Rt(0);
  return Z$(!0, "keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function MG(e) {
  var t;
  return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : DG) !== jf || Ee.Children.count(e.children) === 1;
}
let DE = ys(null);
DE.displayName = "TransitionContext";
var Yoe = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(Yoe || {});
function qoe() {
  let e = Ra(DE);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function Koe() {
  let e = Ra(PE);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let PE = ys(null);
PE.displayName = "NestingContext";
function OE(e) {
  return "children" in e ? OE(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function RG(e, t) {
  let n = $d(e), r = Rt([]), s = _G(), o = Yv(), c = ln((j, E = E2.Hidden) => {
    let T = r.current.findIndex(({ el: D }) => D === j);
    T !== -1 && (Ai(E, { [E2.Unmount]() {
      r.current.splice(T, 1);
    }, [E2.Hidden]() {
      r.current[T].state = "hidden";
    } }), o.microTask(() => {
      var D;
      !OE(r) && s.current && ((D = n.current) == null || D.call(n));
    }));
  }), u = ln((j) => {
    let E = r.current.find(({ el: T }) => T === j);
    return E ? E.state !== "visible" && (E.state = "visible") : r.current.push({ el: j, state: "visible" }), () => c(j, E2.Unmount);
  }), m = Rt([]), y = Rt(Promise.resolve()), b = Rt({ enter: [], leave: [] }), w = ln((j, E, T) => {
    m.current.splice(0), t && (t.chains.current[E] = t.chains.current[E].filter(([D]) => D !== j)), t == null || t.chains.current[E].push([j, new Promise((D) => {
      m.current.push(D);
    })]), t == null || t.chains.current[E].push([j, new Promise((D) => {
      Promise.all(b.current[E].map(([L, I]) => I)).then(() => D());
    })]), E === "enter" ? y.current = y.current.then(() => t == null ? void 0 : t.wait.current).then(() => T(E)) : T(E);
  }), k = ln((j, E, T) => {
    Promise.all(b.current[E].splice(0).map(([D, L]) => L)).then(() => {
      var D;
      (D = m.current.shift()) == null || D();
    }).then(() => T(E));
  });
  return dn(() => ({ children: r, register: u, unregister: c, onStart: w, onStop: k, wait: y, chains: b }), [u, c, r, w, k, b, y]);
}
let DG = jf, PG = E1.RenderStrategy;
function Xoe(e, t) {
  var n, r;
  let { transition: s = !0, beforeEnter: o, afterEnter: c, beforeLeave: u, afterLeave: m, enter: y, enterFrom: b, enterTo: w, entered: k, leave: j, leaveFrom: E, leaveTo: T, ...D } = e, L = Rt(null), I = MG(e), R = ri(...I ? [L, t] : t === null ? [] : [t]), U = (n = D.unmount) == null || n ? E2.Unmount : E2.Hidden, { show: z, appear: H, initial: K } = qoe(), [q, Q] = Re(z ? "visible" : "hidden"), Z = Koe(), { register: X, unregister: se } = Z;
  gs(() => X(L), [X, L]), gs(() => {
    if (U === E2.Hidden && L.current) {
      if (z && q !== "visible") {
        Q("visible");
        return;
      }
      return Ai(q, { hidden: () => se(L), visible: () => X(L) });
    }
  }, [q, L, X, se, z, U]);
  let te = yO();
  gs(() => {
    if (I && te && q === "visible" && L.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [L, q, te, I]);
  let fe = K && !H, ce = H && z && K, pe = Rt(!1), Se = RG(() => {
    pe.current || (Q("hidden"), se(L));
  }, Z), oe = ln((Ue) => {
    pe.current = !0;
    let qe = Ue ? "enter" : "leave";
    Se.onStart(L, qe, (it) => {
      it === "enter" ? o == null || o() : it === "leave" && (u == null || u());
    });
  }), ue = ln((Ue) => {
    let qe = Ue ? "enter" : "leave";
    pe.current = !1, Se.onStop(L, qe, (it) => {
      it === "enter" ? c == null || c() : it === "leave" && (m == null || m());
    }), qe === "leave" && !OE(Se) && (Q("hidden"), se(L));
  });
  an(() => {
    I && s || (oe(z), ue(z));
  }, [z, I, s]);
  let he = !(!s || !I || !te || fe), [, ve] = r6(he, L, z, { start: oe, end: ue }), Te = x2({ ref: R, className: ((r = ED(D.className, ce && y, ce && b, ve.enter && y, ve.enter && ve.closed && b, ve.enter && !ve.closed && w, ve.leave && j, ve.leave && !ve.closed && E, ve.leave && ve.closed && T, !ve.transition && z && k)) == null ? void 0 : r.trim()) || void 0, ...n6(ve) }), Ie = 0;
  return q === "visible" && (Ie |= Xl.Open), q === "hidden" && (Ie |= Xl.Closed), ve.enter && (Ie |= Xl.Opening), ve.leave && (Ie |= Xl.Closing), Ee.createElement(PE.Provider, { value: Se }, Ee.createElement(RE, { value: Ie }, is({ ourProps: Te, theirProps: D, defaultTag: DG, features: PG, visible: q === "visible", name: "Transition.Child" })));
}
function Qoe(e, t) {
  let { show: n, appear: r = !1, unmount: s = !0, ...o } = e, c = Rt(null), u = MG(e), m = ri(...u ? [c, t] : t === null ? [] : [t]);
  yO();
  let y = pw();
  if (n === void 0 && y !== null && (n = (y & Xl.Open) === Xl.Open), n === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [b, w] = Re(n ? "visible" : "hidden"), k = RG(() => {
    n || w("hidden");
  }), [j, E] = Re(!0), T = Rt([n]);
  gs(() => {
    j !== !1 && T.current[T.current.length - 1] !== n && (T.current.push(n), E(!1));
  }, [T, n]);
  let D = dn(() => ({ show: n, appear: r, initial: j }), [n, r, j]);
  dO(n, c, () => w("hidden")), gs(() => {
    n ? w("visible") : !OE(k) && c.current !== null && w("hidden");
  }, [n, k]);
  let L = { unmount: s }, I = ln(() => {
    var U;
    j && E(!1), (U = e.beforeEnter) == null || U.call(e);
  }), R = ln(() => {
    var U;
    j && E(!1), (U = e.beforeLeave) == null || U.call(e);
  });
  return Ee.createElement(PE.Provider, { value: k }, Ee.createElement(DE.Provider, { value: D }, is({ ourProps: { ...L, as: jf, children: Ee.createElement(OG, { ref: m, ...L, ...o, beforeEnter: I, beforeLeave: R }) }, theirProps: {}, defaultTag: jf, features: PG, visible: b === "visible", name: "Transition" })));
}
function Zoe(e, t) {
  let n = Ra(DE) !== null, r = pw() !== null;
  return Ee.createElement(Ee.Fragment, null, !n && r ? Ee.createElement(PD, { ref: t, ...e }) : Ee.createElement(OG, { ref: t, ...e }));
}
let PD = Xa(Qoe), OG = Xa(Xoe), AE = Xa(Zoe), vO = Object.assign(PD, { Child: AE, Root: PD });
var CU;
let Joe = (CU = Ee.startTransition) != null ? CU : function(e) {
  e();
};
var ele = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(ele || {}), tle = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.LinkPanel = 4] = "LinkPanel", e[e.UnlinkPanel = 5] = "UnlinkPanel", e))(tle || {});
let nle = { 0: (e) => ({ ...e, disclosureState: Ai(e.disclosureState, { 0: 1, 1: 0 }) }), 1: (e) => e.disclosureState === 1 ? e : { ...e, disclosureState: 1 }, 4(e) {
  return e.linkedPanel === !0 ? e : { ...e, linkedPanel: !0 };
}, 5(e) {
  return e.linkedPanel === !1 ? e : { ...e, linkedPanel: !1 };
}, 2(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 3(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, xO = ys(null);
xO.displayName = "DisclosureContext";
function bO(e) {
  let t = Ra(xO);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, bO), n;
  }
  return t;
}
let SO = ys(null);
SO.displayName = "DisclosureAPIContext";
function AG(e) {
  let t = Ra(SO);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, AG), n;
  }
  return t;
}
let wO = ys(null);
wO.displayName = "DisclosurePanelContext";
function rle() {
  return Ra(wO);
}
function ale(e, t) {
  return Ai(t.type, nle, e, t);
}
let sle = jf;
function ile(e, t) {
  let { defaultOpen: n = !1, ...r } = e, s = Rt(null), o = ri(t, cO((D) => {
    s.current = D;
  }, e.as === void 0 || e.as === jf)), c = Rt(null), u = Rt(null), m = r5(ale, { disclosureState: n ? 0 : 1, linkedPanel: !1, buttonRef: u, panelRef: c, buttonId: null, panelId: null }), [{ disclosureState: y, buttonId: b }, w] = m, k = ln((D) => {
    w({ type: 1 });
    let L = Ey(s);
    if (!L || !b) return;
    let I = D ? D instanceof HTMLElement ? D : D.current instanceof HTMLElement ? D.current : L.getElementById(b) : L.getElementById(b);
    I == null || I.focus();
  }), j = dn(() => ({ close: k }), [k]), E = dn(() => ({ open: y === 0, close: k }), [y, k]), T = { ref: o };
  return Ee.createElement(xO.Provider, { value: m }, Ee.createElement(SO.Provider, { value: j }, Ee.createElement(W$, { value: k }, Ee.createElement(RE, { value: Ai(y, { 0: Xl.Open, 1: Xl.Closed }) }, is({ ourProps: T, theirProps: r, slot: E, defaultTag: sle, name: "Disclosure" })))));
}
let ole = "button";
function lle(e, t) {
  let n = Zl(), { id: r = `headlessui-disclosure-button-${n}`, disabled: s = !1, autoFocus: o = !1, ...c } = e, [u, m] = bO("Disclosure.Button"), y = rle(), b = y === null ? !1 : y === u.panelId, w = Rt(null), k = ri(w, t, b ? null : u.buttonRef), j = lO();
  an(() => {
    if (!b) return m({ type: 2, buttonId: r }), () => {
      m({ type: 2, buttonId: null });
    };
  }, [r, m, b]);
  let E = ln((Z) => {
    var X;
    if (b) {
      if (u.disclosureState === 1) return;
      switch (Z.key) {
        case Or.Space:
        case Or.Enter:
          Z.preventDefault(), Z.stopPropagation(), m({ type: 0 }), (X = u.buttonRef.current) == null || X.focus();
          break;
      }
    } else switch (Z.key) {
      case Or.Space:
      case Or.Enter:
        Z.preventDefault(), Z.stopPropagation(), m({ type: 0 });
        break;
    }
  }), T = ln((Z) => {
    switch (Z.key) {
      case Or.Space:
        Z.preventDefault();
        break;
    }
  }), D = ln((Z) => {
    var X;
    Q2(Z.currentTarget) || s || (b ? (m({ type: 0 }), (X = u.buttonRef.current) == null || X.focus()) : m({ type: 0 }));
  }), { isFocusVisible: L, focusProps: I } = Jg({ autoFocus: o }), { isHovered: R, hoverProps: U } = jy({ isDisabled: s }), { pressed: z, pressProps: H } = l5({ disabled: s }), K = dn(() => ({ open: u.disclosureState === 0, hover: R, active: z, disabled: s, focus: L, autofocus: o }), [u, R, z, L, s, o]), q = t6(e, w), Q = gm(b ? { ref: k, type: q, disabled: s || void 0, autoFocus: o, onKeyDown: E, onClick: D } : { ref: k, id: r, type: q, "aria-expanded": u.disclosureState === 0, "aria-controls": u.linkedPanel ? u.panelId : void 0, disabled: s || void 0, autoFocus: o, onKeyDown: E, onKeyUp: T, onClick: D }, I, U, H);
  return is({ mergeRefs: j, ourProps: Q, theirProps: c, slot: K, defaultTag: ole, name: "Disclosure.Button" });
}
let cle = "div", ule = E1.RenderStrategy | E1.Static;
function dle(e, t) {
  let n = Zl(), { id: r = `headlessui-disclosure-panel-${n}`, transition: s = !1, ...o } = e, [c, u] = bO("Disclosure.Panel"), { close: m } = AG("Disclosure.Panel"), y = lO(), b = ri(t, c.panelRef, (D) => {
    Joe(() => u({ type: D ? 4 : 5 }));
  });
  an(() => (u({ type: 3, panelId: r }), () => {
    u({ type: 3, panelId: null });
  }), [r, u]);
  let w = pw(), [k, j] = r6(s, c.panelRef, w !== null ? (w & Xl.Open) === Xl.Open : c.disclosureState === 0), E = dn(() => ({ open: c.disclosureState === 0, close: m }), [c.disclosureState, m]), T = { ref: b, id: r, ...n6(j) };
  return Ee.createElement(SG, null, Ee.createElement(wO.Provider, { value: c.panelId }, is({ mergeRefs: y, ourProps: T, theirProps: o, slot: E, defaultTag: cle, features: ule, visible: k, name: "Disclosure.Panel" })));
}
let fle = Xa(ile), V8 = Xa(lle), w2 = Xa(dle), Mv = Object.assign(fle, { Button: V8, Panel: w2 }), mle = "div";
function hle(e, t) {
  let n = `headlessui-control-${Zl()}`, [r, s] = J3(), [o, c] = NE(), u = ky(), { disabled: m = u || !1, ...y } = e, b = dn(() => ({ disabled: m }), [m]);
  return Ee.createElement(Mse, { value: m }, Ee.createElement(s, { value: r }, Ee.createElement(c, { value: o }, Ee.createElement(Use, { id: n }, is({ ourProps: { ref: t, disabled: m || void 0, "aria-disabled": m || void 0 }, theirProps: { ...y, children: Ee.createElement(Lse, null, typeof y.children == "function" ? y.children(b) : y.children) }, slot: b, defaultTag: mle, name: "Field" })))));
}
let Bd = Xa(hle), ple = "input";
function gle(e, t) {
  let n = Zl(), r = uw(), s = ky(), { id: o = r || `headlessui-input-${n}`, disabled: c = s || !1, autoFocus: u = !1, invalid: m = !1, ...y } = e, b = dw(), w = Z3(), { isFocused: k, focusProps: j } = Jg({ autoFocus: u }), { isHovered: E, hoverProps: T } = jy({ isDisabled: c }), D = gm({ ref: t, id: o, "aria-labelledby": b, "aria-describedby": w, "aria-invalid": m ? "" : void 0, disabled: c || void 0, autoFocus: u }, j, T), L = dn(() => ({ disabled: c, invalid: m, hover: E, focus: k, autofocus: u }), [c, m, E, k, u]);
  return is({ ourProps: D, theirProps: y, slot: L, defaultTag: ple, name: "Input" });
}
let LE = Xa(gle);
function yle(e, t) {
  let [n, r] = Re(e), s = $d(e);
  return gs(() => r(s.current), [s, r, ...t]), n;
}
function vle(e, t) {
  let n = Rt({ left: 0, top: 0 });
  if (gs(() => {
    let s = t.current;
    if (!s) return;
    let o = s.getBoundingClientRect();
    o && (n.current = o);
  }, [e]), t.current == null || !e || t.current === document.activeElement) return !1;
  let r = t.current.getBoundingClientRect();
  return r.top !== n.current.top || r.left !== n.current.left;
}
let NU = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function jU(e) {
  var t, n;
  let r = (t = e.innerText) != null ? t : "", s = e.cloneNode(!0);
  if (!(s instanceof HTMLElement)) return r;
  let o = !1;
  for (let u of s.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) u.remove(), o = !0;
  let c = o ? (n = s.innerText) != null ? n : "" : r;
  return NU.test(c) && (c = c.replace(NU, "")), c;
}
function xle(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string") return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let r = n.split(" ").map((s) => {
      let o = document.getElementById(s);
      if (o) {
        let c = o.getAttribute("aria-label");
        return typeof c == "string" ? c.trim() : jU(o).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0) return r.join(", ");
  }
  return jU(e).trim();
}
function ble(e) {
  let t = Rt(""), n = Rt("");
  return ln(() => {
    let r = e.current;
    if (!r) return "";
    let s = r.innerText;
    if (t.current === s) return n.current;
    let o = xle(r).trim().toLowerCase();
    return t.current = s, n.current = o, o;
  });
}
var Sle = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Sle || {}), wle = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(wle || {}), Cle = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Cle || {}), Nle = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e))(Nle || {});
function $M(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = k2(t(e.options.slice()), (o) => o.dataRef.current.domRef.current), s = n ? r.indexOf(n) : null;
  return s === -1 && (s = null), { options: r, activeOptionIndex: s };
}
let jle = { 1(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1, __demoMode: !1 };
}, 0(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0) return e;
  let t = e.activeOptionIndex, { isSelected: n } = e.dataRef.current, r = e.options.findIndex((s) => n(s.dataRef.current.value));
  return r !== -1 && (t = r), { ...e, listboxState: 0, activeOptionIndex: t, __demoMode: !1 };
}, 2(e, t) {
  var n, r, s, o, c;
  if (e.dataRef.current.disabled || e.listboxState === 1) return e;
  let u = { ...e, searchQuery: "", activationTrigger: (n = t.trigger) != null ? n : 1, __demoMode: !1 };
  if (t.focus === mu.Nothing) return { ...u, activeOptionIndex: null };
  if (t.focus === mu.Specific) return { ...u, activeOptionIndex: e.options.findIndex((b) => b.id === t.id) };
  if (t.focus === mu.Previous) {
    let b = e.activeOptionIndex;
    if (b !== null) {
      let w = e.options[b].dataRef.current.domRef, k = VM(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (j) => j.id, resolveDisabled: (j) => j.dataRef.current.disabled });
      if (k !== null) {
        let j = e.options[k].dataRef.current.domRef;
        if (((r = w.current) == null ? void 0 : r.previousElementSibling) === j.current || ((s = j.current) == null ? void 0 : s.previousElementSibling) === null) return { ...u, activeOptionIndex: k };
      }
    }
  } else if (t.focus === mu.Next) {
    let b = e.activeOptionIndex;
    if (b !== null) {
      let w = e.options[b].dataRef.current.domRef, k = VM(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (j) => j.id, resolveDisabled: (j) => j.dataRef.current.disabled });
      if (k !== null) {
        let j = e.options[k].dataRef.current.domRef;
        if (((o = w.current) == null ? void 0 : o.nextElementSibling) === j.current || ((c = j.current) == null ? void 0 : c.nextElementSibling) === null) return { ...u, activeOptionIndex: k };
      }
    }
  }
  let m = $M(e), y = VM(t, { resolveItems: () => m.options, resolveActiveIndex: () => m.activeOptionIndex, resolveId: (b) => b.id, resolveDisabled: (b) => b.dataRef.current.disabled });
  return { ...u, ...m, activeOptionIndex: y };
}, 3: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1) return e;
  let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + t.value.toLowerCase(), s = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + n).concat(e.options.slice(0, e.activeOptionIndex + n)) : e.options).find((c) => {
    var u;
    return !c.dataRef.current.disabled && ((u = c.dataRef.current.textValue) == null ? void 0 : u.startsWith(r));
  }), o = s ? e.options.indexOf(s) : -1;
  return o === -1 || o === e.activeOptionIndex ? { ...e, searchQuery: r } : { ...e, searchQuery: r, activeOptionIndex: o, activationTrigger: 1 };
}, 4(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, 5: (e, t) => {
  let n = { id: t.id, dataRef: t.dataRef }, r = $M(e, (s) => [...s, n]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(n)), { ...e, ...r };
}, 6: (e, t) => {
  let n = $M(e, (r) => {
    let s = r.findIndex((o) => o.id === t.id);
    return s !== -1 && r.splice(s, 1), r;
  });
  return { ...e, ...n, activationTrigger: 1 };
} }, CO = ys(null);
CO.displayName = "ListboxActionsContext";
function IE(e) {
  let t = Ra(CO);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, IE), n;
  }
  return t;
}
let FE = ys(null);
FE.displayName = "ListboxDataContext";
function i6(e) {
  let t = Ra(FE);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, i6), n;
  }
  return t;
}
function Ele(e, t) {
  return Ai(t.type, jle, e, t);
}
let kle = jf;
function _le(e, t) {
  var n;
  let r = ky(), { value: s, defaultValue: o, form: c, name: u, onChange: m, by: y, invalid: b = !1, disabled: w = r || !1, horizontal: k = !1, multiple: j = !1, __demoMode: E = !1, ...T } = e;
  const D = k ? "horizontal" : "vertical";
  let L = ri(t), I = bE(o), [R = j ? [] : void 0, U] = xE(s, m, I), [z, H] = r5(Ele, { dataRef: Xj(), listboxState: E ? 0 : 1, options: [], searchQuery: "", activeOptionIndex: null, activationTrigger: 1, optionsVisible: !1, __demoMode: E }), K = Rt({ static: !1, hold: !1 }), q = Rt(null), Q = Rt(null), Z = Rt(/* @__PURE__ */ new Map()), X = Y$(y), se = qa((vt) => Ai(te.mode, { 1: () => R.some((At) => X(At, vt)), 0: () => X(R, vt) }), [R]), te = dn(() => ({ ...z, value: R, disabled: w, invalid: b, mode: j ? 1 : 0, orientation: D, compare: X, isSelected: se, optionsPropsRef: K, buttonRef: q, optionsRef: Q, listRef: Z }), [R, w, b, j, z, Z]);
  gs(() => {
    z.dataRef.current = te;
  }, [te]);
  let fe = te.listboxState === 0;
  J$(fe, [te.buttonRef, te.optionsRef], (vt, At) => {
    var He;
    H({ type: 1 }), fO(At, EE.Loose) || (vt.preventDefault(), (He = te.buttonRef.current) == null || He.focus());
  });
  let ce = dn(() => ({ open: te.listboxState === 0, disabled: w, invalid: b, value: R }), [te, w, R, b]), pe = ln((vt) => {
    let At = te.options.find((He) => He.id === vt);
    At && Ie(At.dataRef.current.value);
  }), Se = ln(() => {
    if (te.activeOptionIndex !== null) {
      let { dataRef: vt, id: At } = te.options[te.activeOptionIndex];
      Ie(vt.current.value), H({ type: 2, focus: mu.Specific, id: At });
    }
  }), oe = ln(() => H({ type: 0 })), ue = ln(() => H({ type: 1 })), he = Yv(), ve = ln((vt, At, He) => {
    he.dispose(), he.microTask(() => vt === mu.Specific ? H({ type: 2, focus: mu.Specific, id: At, trigger: He }) : H({ type: 2, focus: vt, trigger: He }));
  }), Te = ln((vt, At) => (H({ type: 5, id: vt, dataRef: At }), () => H({ type: 6, id: vt }))), Ie = ln((vt) => Ai(te.mode, { 0() {
    return U == null ? void 0 : U(vt);
  }, 1() {
    let At = te.value.slice(), He = At.findIndex((Pt) => X(Pt, vt));
    return He === -1 ? At.push(vt) : At.splice(He, 1), U == null ? void 0 : U(At);
  } })), Ue = ln((vt) => H({ type: 3, value: vt })), qe = ln(() => H({ type: 4 })), it = dn(() => ({ onChange: Ie, registerOption: Te, goToOption: ve, closeListbox: ue, openListbox: oe, selectActiveOption: Se, selectOption: pe, search: Ue, clearSearch: qe }), []), [Ne, Xe] = J3({ inherit: !0 }), xt = { ref: L }, rn = qa(() => {
    if (I !== void 0) return U == null ? void 0 : U(I);
  }, [U, I]);
  return Ee.createElement(Xe, { value: Ne, props: { htmlFor: (n = te.buttonRef.current) == null ? void 0 : n.id }, slot: { open: te.listboxState === 0, disabled: w } }, Ee.createElement(xG, null, Ee.createElement(CO.Provider, { value: it }, Ee.createElement(FE.Provider, { value: te }, Ee.createElement(RE, { value: Ai(te.listboxState, { 0: Xl.Open, 1: Xl.Closed }) }, u != null && R != null && Ee.createElement(wE, { disabled: w, data: { [u]: R }, form: c, onReset: rn }), is({ ourProps: xt, theirProps: T, slot: ce, defaultTag: kle, name: "Listbox" }))))));
}
let Tle = "button";
function Mle(e, t) {
  var n;
  let r = i6("Listbox.Button"), s = IE("Listbox.Button"), o = Zl(), c = uw(), { id: u = c || `headlessui-listbox-button-${o}`, disabled: m = r.disabled || !1, autoFocus: y = !1, ...b } = e, w = ri(r.buttonRef, t, gG()), k = Toe(), j = ln((X) => {
    switch (X.key) {
      case Or.Enter:
        SE(X.currentTarget);
        break;
      case Or.Space:
      case Or.ArrowDown:
        X.preventDefault(), po.flushSync(() => s.openListbox()), r.value || s.goToOption(mu.First);
        break;
      case Or.ArrowUp:
        X.preventDefault(), po.flushSync(() => s.openListbox()), r.value || s.goToOption(mu.Last);
        break;
    }
  }), E = ln((X) => {
    switch (X.key) {
      case Or.Space:
        X.preventDefault();
        break;
    }
  }), T = ln((X) => {
    var se;
    if (Q2(X.currentTarget)) return X.preventDefault();
    r.listboxState === 0 ? (po.flushSync(() => s.closeListbox()), (se = r.buttonRef.current) == null || se.focus({ preventScroll: !0 })) : (X.preventDefault(), s.openListbox());
  }), D = ln((X) => X.preventDefault()), L = dw([u]), I = Z3(), { isFocusVisible: R, focusProps: U } = Jg({ autoFocus: y }), { isHovered: z, hoverProps: H } = jy({ isDisabled: m }), { pressed: K, pressProps: q } = l5({ disabled: m }), Q = dn(() => ({ open: r.listboxState === 0, active: K || r.listboxState === 0, disabled: m, invalid: r.invalid, value: r.value, hover: z, focus: R, autofocus: y }), [r.listboxState, r.value, m, z, R, K, r.invalid, y]), Z = gm(k(), { ref: w, id: u, type: t6(e, r.buttonRef), "aria-haspopup": "listbox", "aria-controls": (n = r.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": r.listboxState === 0, "aria-labelledby": L, "aria-describedby": I, disabled: m || void 0, autoFocus: y, onKeyDown: j, onKeyUp: E, onKeyPress: D, onClick: T }, U, H, q);
  return is({ ourProps: Z, theirProps: b, slot: Q, defaultTag: Tle, name: "Listbox.Button" });
}
let LG = ys(!1), Rle = "div", Dle = E1.RenderStrategy | E1.Static;
function Ple(e, t) {
  var n;
  let r = Zl(), { id: s = `headlessui-listbox-options-${r}`, anchor: o, portal: c = !1, modal: u = !0, transition: m = !1, ...y } = e, b = pG(o);
  b && (c = !0);
  let w = i6("Listbox.Options"), k = IE("Listbox.Options"), j = c5(w.optionsRef), E = pw(), [T, D] = r6(m, w.optionsRef, E !== null ? (E & Xl.Open) === Xl.Open : w.listboxState === 0);
  dO(T, w.buttonRef, k.closeListbox);
  let L = w.__demoMode ? !1 : u && w.listboxState === 0;
  eG(L, j);
  let I = w.__demoMode ? !1 : u && w.listboxState === 0;
  eie(I, { allowed: ln(() => [w.buttonRef.current, w.optionsRef.current]) });
  let R = w.listboxState !== 0, U = vle(R, w.buttonRef) ? !1 : T, z = T && w.listboxState === 1, H = Doe(z, w.value), K = ln((ue) => w.compare(H, ue)), q = dn(() => {
    var ue;
    if (b == null || !((ue = b == null ? void 0 : b.to) != null && ue.includes("selection"))) return null;
    let he = w.options.findIndex((ve) => K(ve.dataRef.current.value));
    return he === -1 && (he = 0), he;
  }, [b, w.options]), Q = (() => {
    if (b == null) return;
    if (q === null) return { ...b, inner: void 0 };
    let ue = Array.from(w.listRef.current.values());
    return { ...b, inner: { listRef: { current: ue }, index: q } };
  })(), [Z, X] = vG(Q), se = yG(), te = ri(w.optionsRef, t, b ? Z : null), fe = Yv();
  an(() => {
    var ue;
    let he = w.optionsRef.current;
    he && w.listboxState === 0 && he !== ((ue = Ey(he)) == null ? void 0 : ue.activeElement) && (he == null || he.focus({ preventScroll: !0 }));
  }, [w.listboxState, w.optionsRef, w.optionsRef.current]);
  let ce = ln((ue) => {
    var he, ve;
    switch (fe.dispose(), ue.key) {
      case Or.Space:
        if (w.searchQuery !== "") return ue.preventDefault(), ue.stopPropagation(), k.search(ue.key);
      case Or.Enter:
        if (ue.preventDefault(), ue.stopPropagation(), w.activeOptionIndex !== null) {
          let { dataRef: Te } = w.options[w.activeOptionIndex];
          k.onChange(Te.current.value);
        }
        w.mode === 0 && (po.flushSync(() => k.closeListbox()), (he = w.buttonRef.current) == null || he.focus({ preventScroll: !0 }));
        break;
      case Ai(w.orientation, { vertical: Or.ArrowDown, horizontal: Or.ArrowRight }):
        return ue.preventDefault(), ue.stopPropagation(), k.goToOption(mu.Next);
      case Ai(w.orientation, { vertical: Or.ArrowUp, horizontal: Or.ArrowLeft }):
        return ue.preventDefault(), ue.stopPropagation(), k.goToOption(mu.Previous);
      case Or.Home:
      case Or.PageUp:
        return ue.preventDefault(), ue.stopPropagation(), k.goToOption(mu.First);
      case Or.End:
      case Or.PageDown:
        return ue.preventDefault(), ue.stopPropagation(), k.goToOption(mu.Last);
      case Or.Escape:
        ue.preventDefault(), ue.stopPropagation(), po.flushSync(() => k.closeListbox()), (ve = w.buttonRef.current) == null || ve.focus({ preventScroll: !0 });
        return;
      case Or.Tab:
        ue.preventDefault(), ue.stopPropagation(), po.flushSync(() => k.closeListbox()), oie(w.buttonRef.current, ue.shiftKey ? fo.Previous : fo.Next);
        break;
      default:
        ue.key.length === 1 && (k.search(ue.key), fe.setTimeout(() => k.clearSearch(), 350));
        break;
    }
  }), pe = yle(() => {
    var ue;
    return (ue = w.buttonRef.current) == null ? void 0 : ue.id;
  }, [w.buttonRef.current]), Se = dn(() => ({ open: w.listboxState === 0 }), [w.listboxState]), oe = gm(b ? se() : {}, { id: s, ref: te, "aria-activedescendant": w.activeOptionIndex === null || (n = w.options[w.activeOptionIndex]) == null ? void 0 : n.id, "aria-multiselectable": w.mode === 1 ? !0 : void 0, "aria-labelledby": pe, "aria-orientation": w.orientation, onKeyDown: ce, role: "listbox", tabIndex: w.listboxState === 0 ? 0 : void 0, style: { ...y.style, ...X, "--button-width": q$(w.buttonRef, !0).width }, ...n6(D) });
  return Ee.createElement(NG, { enabled: c ? e.static || T : !1 }, Ee.createElement(FE.Provider, { value: w.mode === 1 ? w : { ...w, isSelected: K } }, is({ ourProps: oe, theirProps: y, slot: Se, defaultTag: Rle, features: Dle, visible: U, name: "Listbox.Options" })));
}
let Ole = "div";
function Ale(e, t) {
  let n = Zl(), { id: r = `headlessui-listbox-option-${n}`, disabled: s = !1, value: o, ...c } = e, u = Ra(LG) === !0, m = i6("Listbox.Option"), y = IE("Listbox.Option"), b = m.activeOptionIndex !== null ? m.options[m.activeOptionIndex].id === r : !1, w = m.isSelected(o), k = Rt(null), j = ble(k), E = $d({ disabled: s, value: o, domRef: k, get textValue() {
    return j();
  } }), T = ri(t, k, (q) => {
    q ? m.listRef.current.set(r, q) : m.listRef.current.delete(r);
  });
  gs(() => {
    if (!m.__demoMode && m.listboxState === 0 && b && m.activationTrigger !== 0) return Wv().requestAnimationFrame(() => {
      var q, Q;
      (Q = (q = k.current) == null ? void 0 : q.scrollIntoView) == null || Q.call(q, { block: "nearest" });
    });
  }, [k, b, m.__demoMode, m.listboxState, m.activationTrigger, m.activeOptionIndex]), gs(() => {
    if (!u) return y.registerOption(r, E);
  }, [E, r, u]);
  let D = ln((q) => {
    var Q;
    if (s) return q.preventDefault();
    y.onChange(o), m.mode === 0 && (po.flushSync(() => y.closeListbox()), (Q = m.buttonRef.current) == null || Q.focus({ preventScroll: !0 }));
  }), L = ln(() => {
    if (s) return y.goToOption(mu.Nothing);
    y.goToOption(mu.Specific, r);
  }), I = gie(), R = ln((q) => {
    I.update(q), !s && (b || y.goToOption(mu.Specific, r, 0));
  }), U = ln((q) => {
    I.wasMoved(q) && (s || b || y.goToOption(mu.Specific, r, 0));
  }), z = ln((q) => {
    I.wasMoved(q) && (s || b && y.goToOption(mu.Nothing));
  }), H = dn(() => ({ active: b, focus: b, selected: w, disabled: s, selectedOption: w && u }), [b, w, s, u]);
  return !w && u ? null : is({ ourProps: u ? {} : { id: r, ref: T, role: "option", tabIndex: s === !0 ? void 0 : -1, "aria-disabled": s === !0 ? !0 : void 0, "aria-selected": w, disabled: void 0, onClick: D, onFocus: L, onPointerEnter: R, onMouseEnter: R, onPointerMove: U, onMouseMove: U, onPointerLeave: z, onMouseLeave: z }, theirProps: c, slot: H, defaultTag: Ole, name: "Listbox.Option" });
}
let Lle = jf;
function Ile(e, t) {
  let { options: n, placeholder: r, ...s } = e, o = { ref: ri(t) }, c = i6("ListboxSelectedOption"), u = dn(() => ({}), []), m = c.value === void 0 || c.value === null || c.mode === 1 && Array.isArray(c.value) && c.value.length === 0;
  return Ee.createElement(LG.Provider, { value: !0 }, is({ ourProps: o, theirProps: { ...s, children: Ee.createElement(Ee.Fragment, null, r && m ? r : n) }, slot: u, defaultTag: Lle, name: "ListboxSelectedOption" }));
}
let Fle = Xa(_le), NO = Xa(Mle), Ule = _c, jO = Xa(Ple), EO = Xa(Ale), zle = Xa(Ile), yp = Object.assign(Fle, { Button: NO, Label: Ule, Options: jO, Option: EO, SelectedOption: zle });
var Ble = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ble || {}), Hle = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(Hle || {});
let Vle = { 0: (e) => ({ ...e, popoverState: Ai(e.popoverState, { 0: 1, 1: 0 }), __demoMode: !1 }), 1(e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1, __demoMode: !1 };
}, 2(e, t) {
  return e.button === t.button ? e : { ...e, button: t.button };
}, 3(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 4(e, t) {
  return e.panel === t.panel ? e : { ...e, panel: t.panel };
}, 5(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, kO = ys(null);
kO.displayName = "PopoverContext";
function UE(e) {
  let t = Ra(kO);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, UE), n;
  }
  return t;
}
let zE = ys(null);
zE.displayName = "PopoverAPIContext";
function _O(e) {
  let t = Ra(zE);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, _O), n;
  }
  return t;
}
let TO = ys(null);
TO.displayName = "PopoverGroupContext";
function IG() {
  return Ra(TO);
}
let BE = ys(null);
BE.displayName = "PopoverPanelContext";
function $le() {
  return Ra(BE);
}
function Gle(e, t) {
  return Ai(t.type, Vle, e, t);
}
let Wle = "div";
function Yle(e, t) {
  var n;
  let { __demoMode: r = !1, ...s } = e, o = Rt(null), c = ri(t, cO((oe) => {
    o.current = oe;
  })), u = Rt([]), m = r5(Gle, { __demoMode: r, popoverState: r ? 0 : 1, buttons: u, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: Xj(), afterPanelSentinel: Xj(), afterButtonSentinel: Xj() }), [{ popoverState: y, button: b, buttonId: w, panel: k, panelId: j, beforePanelSentinel: E, afterPanelSentinel: T, afterButtonSentinel: D }, L] = m, I = c5((n = o.current) != null ? n : b), R = dn(() => {
    if (!b || !k) return !1;
    for (let Ue of document.querySelectorAll("body > *")) if (Number(Ue == null ? void 0 : Ue.contains(b)) ^ Number(Ue == null ? void 0 : Ue.contains(k))) return !0;
    let oe = e6(), ue = oe.indexOf(b), he = (ue + oe.length - 1) % oe.length, ve = (ue + 1) % oe.length, Te = oe[he], Ie = oe[ve];
    return !k.contains(Te) && !k.contains(Ie);
  }, [b, k]), U = $d(w), z = $d(j), H = dn(() => ({ buttonId: U, panelId: z, close: () => L({ type: 1 }) }), [U, z, L]), K = IG(), q = K == null ? void 0 : K.registerPopover, Q = ln(() => {
    var oe;
    return (oe = K == null ? void 0 : K.isFocusWithinPopoverGroup()) != null ? oe : (I == null ? void 0 : I.activeElement) && ((b == null ? void 0 : b.contains(I.activeElement)) || (k == null ? void 0 : k.contains(I.activeElement)));
  });
  an(() => q == null ? void 0 : q(H), [q, H]);
  let [Z, X] = Voe(), se = kG(b), te = Woe({ mainTreeNode: se, portals: Z, defaultContainers: [b, k] });
  uie(I == null ? void 0 : I.defaultView, "focus", (oe) => {
    var ue, he, ve, Te, Ie, Ue;
    oe.target !== window && oe.target instanceof HTMLElement && y === 0 && (Q() || b && k && (te.contains(oe.target) || (he = (ue = E.current) == null ? void 0 : ue.contains) != null && he.call(ue, oe.target) || (Te = (ve = T.current) == null ? void 0 : ve.contains) != null && Te.call(ve, oe.target) || (Ue = (Ie = D.current) == null ? void 0 : Ie.contains) != null && Ue.call(Ie, oe.target) || L({ type: 1 })));
  }, !0), J$(y === 0, te.resolveContainers, (oe, ue) => {
    L({ type: 1 }), fO(ue, EE.Loose) || (oe.preventDefault(), b == null || b.focus());
  });
  let fe = ln((oe) => {
    L({ type: 1 });
    let ue = oe ? oe instanceof HTMLElement ? oe : "current" in oe && oe.current instanceof HTMLElement ? oe.current : b : b;
    ue == null || ue.focus();
  }), ce = dn(() => ({ close: fe, isPortalled: R }), [fe, R]), pe = dn(() => ({ open: y === 0, close: fe }), [y, fe]), Se = { ref: c };
  return Ee.createElement(EG, { node: se }, Ee.createElement(xG, null, Ee.createElement(BE.Provider, { value: null }, Ee.createElement(kO.Provider, { value: m }, Ee.createElement(zE.Provider, { value: ce }, Ee.createElement(W$, { value: fe }, Ee.createElement(RE, { value: Ai(y, { 0: Xl.Open, 1: Xl.Closed }) }, Ee.createElement(X, null, is({ ourProps: Se, theirProps: s, slot: pe, defaultTag: Wle, name: "Popover" })))))))));
}
let qle = "button";
function Kle(e, t) {
  let n = Zl(), { id: r = `headlessui-popover-button-${n}`, disabled: s = !1, autoFocus: o = !1, ...c } = e, [u, m] = UE("Popover.Button"), { isPortalled: y } = _O("Popover.Button"), b = Rt(null), w = `headlessui-focus-sentinel-${Zl()}`, k = IG(), j = k == null ? void 0 : k.closeOthers, E = $le() !== null;
  an(() => {
    if (!E) return m({ type: 3, buttonId: r }), () => {
      m({ type: 3, buttonId: null });
    };
  }, [E, r, m]);
  let [T] = Re(() => Symbol()), D = ri(b, t, gG(), E ? null : (ue) => {
    if (ue) u.buttons.current.push(T);
    else {
      let he = u.buttons.current.indexOf(T);
      he !== -1 && u.buttons.current.splice(he, 1);
    }
    u.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), ue && m({ type: 2, button: ue });
  }), L = ri(b, t), I = c5(b), R = ln((ue) => {
    var he, ve, Te;
    if (E) {
      if (u.popoverState === 1) return;
      switch (ue.key) {
        case Or.Space:
        case Or.Enter:
          ue.preventDefault(), (ve = (he = ue.target).click) == null || ve.call(he), m({ type: 1 }), (Te = u.button) == null || Te.focus();
          break;
      }
    } else switch (ue.key) {
      case Or.Space:
      case Or.Enter:
        ue.preventDefault(), ue.stopPropagation(), u.popoverState === 1 && (j == null || j(u.buttonId)), m({ type: 0 });
        break;
      case Or.Escape:
        if (u.popoverState !== 0) return j == null ? void 0 : j(u.buttonId);
        if (!b.current || I != null && I.activeElement && !b.current.contains(I.activeElement)) return;
        ue.preventDefault(), ue.stopPropagation(), m({ type: 1 });
        break;
    }
  }), U = ln((ue) => {
    E || ue.key === Or.Space && ue.preventDefault();
  }), z = ln((ue) => {
    var he, ve;
    Q2(ue.currentTarget) || s || (E ? (m({ type: 1 }), (he = u.button) == null || he.focus()) : (ue.preventDefault(), ue.stopPropagation(), u.popoverState === 1 && (j == null || j(u.buttonId)), m({ type: 0 }), (ve = u.button) == null || ve.focus()));
  }), H = ln((ue) => {
    ue.preventDefault(), ue.stopPropagation();
  }), { isFocusVisible: K, focusProps: q } = Jg({ autoFocus: o }), { isHovered: Q, hoverProps: Z } = jy({ isDisabled: s }), { pressed: X, pressProps: se } = l5({ disabled: s }), te = u.popoverState === 0, fe = dn(() => ({ open: te, active: X || te, disabled: s, hover: Q, focus: K, autofocus: o }), [te, Q, K, X, s, o]), ce = t6(e, b), pe = gm(E ? { ref: L, type: ce, onKeyDown: R, onClick: z, disabled: s || void 0, autoFocus: o } : { ref: D, id: u.buttonId, type: ce, "aria-expanded": u.popoverState === 0, "aria-controls": u.panel ? u.panelId : void 0, disabled: s || void 0, autoFocus: o, onKeyDown: R, onKeyUp: U, onClick: z, onMouseDown: H }, q, Z, se), Se = TG(), oe = ln(() => {
    let ue = u.panel;
    if (!ue) return;
    function he() {
      Ai(Se.current, { [Dv.Forwards]: () => Sf(ue, fo.First), [Dv.Backwards]: () => Sf(ue, fo.Last) }) === ly.Error && Sf(e6().filter((ve) => ve.dataset.headlessuiFocusGuard !== "true"), Ai(Se.current, { [Dv.Forwards]: fo.Next, [Dv.Backwards]: fo.Previous }), { relativeTo: u.button });
    }
    he();
  });
  return Ee.createElement(Ee.Fragment, null, is({ ourProps: pe, theirProps: c, slot: fe, defaultTag: qle, name: "Popover.Button" }), te && !E && y && Ee.createElement(Hv, { id: w, ref: u.afterButtonSentinel, features: Bv.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: oe }));
}
let Xle = "div", Qle = E1.RenderStrategy | E1.Static;
function FG(e, t) {
  let n = Zl(), { id: r = `headlessui-popover-backdrop-${n}`, transition: s = !1, ...o } = e, [{ popoverState: c }, u] = UE("Popover.Backdrop"), m = Rt(null), y = ri(t, m), b = pw(), [w, k] = r6(s, m, b !== null ? (b & Xl.Open) === Xl.Open : c === 0), j = ln((D) => {
    if (Q2(D.currentTarget)) return D.preventDefault();
    u({ type: 1 });
  }), E = dn(() => ({ open: c === 0 }), [c]), T = { ref: y, id: r, "aria-hidden": !0, onClick: j, ...n6(k) };
  return is({ ourProps: T, theirProps: o, slot: E, defaultTag: Xle, features: Qle, visible: w, name: "Popover.Backdrop" });
}
let Zle = "div", Jle = E1.RenderStrategy | E1.Static;
function ece(e, t) {
  let n = Zl(), { id: r = `headlessui-popover-panel-${n}`, focus: s = !1, anchor: o, portal: c = !1, modal: u = !1, transition: m = !1, ...y } = e, [b, w] = UE("Popover.Panel"), { close: k, isPortalled: j } = _O("Popover.Panel"), E = `headlessui-focus-sentinel-before-${n}`, T = `headlessui-focus-sentinel-after-${n}`, D = Rt(null), L = pG(o), [I, R] = vG(L), U = yG();
  L && (c = !0);
  let z = ri(D, t, L ? I : null, (oe) => {
    w({ type: 4, panel: oe });
  }), H = c5(D), K = lO();
  gs(() => (w({ type: 5, panelId: r }), () => {
    w({ type: 5, panelId: null });
  }), [r, w]);
  let q = pw(), [Q, Z] = r6(m, D, q !== null ? (q & Xl.Open) === Xl.Open : b.popoverState === 0);
  dO(Q, b.button, () => {
    w({ type: 1 });
  });
  let X = b.__demoMode ? !1 : u && Q;
  eG(X, H);
  let se = ln((oe) => {
    var ue;
    switch (oe.key) {
      case Or.Escape:
        if (b.popoverState !== 0 || !D.current || H != null && H.activeElement && !D.current.contains(H.activeElement)) return;
        oe.preventDefault(), oe.stopPropagation(), w({ type: 1 }), (ue = b.button) == null || ue.focus();
        break;
    }
  });
  an(() => {
    var oe;
    e.static || b.popoverState === 1 && ((oe = e.unmount) == null || oe) && w({ type: 4, panel: null });
  }, [b.popoverState, e.unmount, e.static, w]), an(() => {
    if (b.__demoMode || !s || b.popoverState !== 0 || !D.current) return;
    let oe = H == null ? void 0 : H.activeElement;
    D.current.contains(oe) || Sf(D.current, fo.First);
  }, [b.__demoMode, s, D.current, b.popoverState]);
  let te = dn(() => ({ open: b.popoverState === 0, close: k }), [b.popoverState, k]), fe = gm(L ? U() : {}, { ref: z, id: r, onKeyDown: se, onBlur: s && b.popoverState === 0 ? (oe) => {
    var ue, he, ve, Te, Ie;
    let Ue = oe.relatedTarget;
    Ue && D.current && ((ue = D.current) != null && ue.contains(Ue) || (w({ type: 1 }), ((ve = (he = b.beforePanelSentinel.current) == null ? void 0 : he.contains) != null && ve.call(he, Ue) || (Ie = (Te = b.afterPanelSentinel.current) == null ? void 0 : Te.contains) != null && Ie.call(Te, Ue)) && Ue.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1, style: { ...y.style, ...R, "--button-width": q$(b.button, !0).width }, ...n6(Z) }), ce = TG(), pe = ln(() => {
    let oe = D.current;
    if (!oe) return;
    function ue() {
      Ai(ce.current, { [Dv.Forwards]: () => {
        var he;
        Sf(oe, fo.First) === ly.Error && ((he = b.afterPanelSentinel.current) == null || he.focus());
      }, [Dv.Backwards]: () => {
        var he;
        (he = b.button) == null || he.focus({ preventScroll: !0 });
      } });
    }
    ue();
  }), Se = ln(() => {
    let oe = D.current;
    if (!oe) return;
    function ue() {
      Ai(ce.current, { [Dv.Forwards]: () => {
        var he;
        if (!b.button) return;
        let ve = e6(), Te = ve.indexOf(b.button), Ie = ve.slice(0, Te + 1), Ue = [...ve.slice(Te + 1), ...Ie];
        for (let qe of Ue.slice()) if (qe.dataset.headlessuiFocusGuard === "true" || (he = b.panel) != null && he.contains(qe)) {
          let it = Ue.indexOf(qe);
          it !== -1 && Ue.splice(it, 1);
        }
        Sf(Ue, fo.First, { sorted: !1 });
      }, [Dv.Backwards]: () => {
        var he;
        Sf(oe, fo.Previous) === ly.Error && ((he = b.button) == null || he.focus());
      } });
    }
    ue();
  });
  return Ee.createElement(SG, null, Ee.createElement(BE.Provider, { value: r }, Ee.createElement(zE.Provider, { value: { close: k, isPortalled: j } }, Ee.createElement(NG, { enabled: c ? e.static || Q : !1 }, Q && j && Ee.createElement(Hv, { id: E, ref: b.beforePanelSentinel, features: Bv.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: pe }), is({ mergeRefs: K, ourProps: fe, theirProps: y, slot: te, defaultTag: Zle, features: Jle, visible: Q, name: "Popover.Panel" }), Q && j && Ee.createElement(Hv, { id: T, ref: b.afterPanelSentinel, features: Bv.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: Se })))));
}
let tce = "div";
function nce(e, t) {
  let n = Rt(null), r = ri(n, t), [s, o] = Re([]), c = ln((E) => {
    o((T) => {
      let D = T.indexOf(E);
      if (D !== -1) {
        let L = T.slice();
        return L.splice(D, 1), L;
      }
      return T;
    });
  }), u = ln((E) => (o((T) => [...T, E]), () => c(E))), m = ln(() => {
    var E;
    let T = Ey(n);
    if (!T) return !1;
    let D = T.activeElement;
    return (E = n.current) != null && E.contains(D) ? !0 : s.some((L) => {
      var I, R;
      return ((I = T.getElementById(L.buttonId.current)) == null ? void 0 : I.contains(D)) || ((R = T.getElementById(L.panelId.current)) == null ? void 0 : R.contains(D));
    });
  }), y = ln((E) => {
    for (let T of s) T.buttonId.current !== E && T.close();
  }), b = dn(() => ({ registerPopover: u, unregisterPopover: c, isFocusWithinPopoverGroup: m, closeOthers: y }), [u, c, m, y]), w = dn(() => ({}), []), k = e, j = { ref: r };
  return Ee.createElement(EG, null, Ee.createElement(TO.Provider, { value: b }, is({ ourProps: j, theirProps: k, slot: w, defaultTag: tce, name: "Popover.Group" })));
}
let rce = Xa(Yle), K4 = Xa(Kle), ace = Xa(FG), sce = Xa(FG), X4 = Xa(ece), ice = Xa(nce), $8 = Object.assign(rce, { Button: K4, Backdrop: sce, Overlay: ace, Panel: X4, Group: ice });
var oce = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(oce || {});
let lce = { 0(e, t) {
  let n = [...e.options, { id: t.id, element: t.element, propsRef: t.propsRef }];
  return { ...e, options: k2(n, (r) => r.element.current) };
}, 1(e, t) {
  let n = e.options.slice(), r = e.options.findIndex((s) => s.id === t.id);
  return r === -1 ? e : (n.splice(r, 1), { ...e, options: n });
} }, MO = ys(null);
MO.displayName = "RadioGroupDataContext";
function RO(e) {
  let t = Ra(MO);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, RO), n;
  }
  return t;
}
let DO = ys(null);
DO.displayName = "RadioGroupActionsContext";
function PO(e) {
  let t = Ra(DO);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, PO), n;
  }
  return t;
}
function cce(e, t) {
  return Ai(t.type, lce, e, t);
}
let uce = "div";
function dce(e, t) {
  let n = Zl(), r = ky(), { id: s = `headlessui-radiogroup-${n}`, value: o, form: c, name: u, onChange: m, by: y, disabled: b = r || !1, defaultValue: w, ...k } = e, j = Y$(y), [E, T] = r5(cce, { options: [] }), D = E.options, [L, I] = J3(), [R, U] = NE(), z = Rt(null), H = ri(z, t), K = bE(w), [q, Q] = xE(o, m, K), Z = dn(() => D.find((he) => !he.propsRef.current.disabled), [D]), X = dn(() => D.some((he) => j(he.propsRef.current.value, q)), [D, q]), se = ln((he) => {
    var ve;
    if (b || j(he, q)) return !1;
    let Te = (ve = D.find((Ie) => j(Ie.propsRef.current.value, he))) == null ? void 0 : ve.propsRef.current;
    return Te != null && Te.disabled ? !1 : (Q == null || Q(he), !0);
  }), te = ln((he) => {
    let ve = z.current;
    if (!ve) return;
    let Te = Ey(ve), Ie = D.filter((Ue) => Ue.propsRef.current.disabled === !1).map((Ue) => Ue.element.current);
    switch (he.key) {
      case Or.Enter:
        SE(he.currentTarget);
        break;
      case Or.ArrowLeft:
      case Or.ArrowUp:
        if (he.preventDefault(), he.stopPropagation(), Sf(Ie, fo.Previous | fo.WrapAround) === ly.Success) {
          let Ue = D.find((qe) => qe.element.current === (Te == null ? void 0 : Te.activeElement));
          Ue && se(Ue.propsRef.current.value);
        }
        break;
      case Or.ArrowRight:
      case Or.ArrowDown:
        if (he.preventDefault(), he.stopPropagation(), Sf(Ie, fo.Next | fo.WrapAround) === ly.Success) {
          let Ue = D.find((qe) => qe.element.current === (Te == null ? void 0 : Te.activeElement));
          Ue && se(Ue.propsRef.current.value);
        }
        break;
      case Or.Space:
        {
          he.preventDefault(), he.stopPropagation();
          let Ue = D.find((qe) => qe.element.current === (Te == null ? void 0 : Te.activeElement));
          Ue && se(Ue.propsRef.current.value);
        }
        break;
    }
  }), fe = ln((he) => (T({ type: 0, ...he }), () => T({ type: 1, id: he.id }))), ce = dn(() => ({ value: q, firstOption: Z, containsCheckedOption: X, disabled: b, compare: j, ...E }), [q, Z, X, b, j, E]), pe = dn(() => ({ registerOption: fe, change: se }), [fe, se]), Se = { ref: H, id: s, role: "radiogroup", "aria-labelledby": L, "aria-describedby": R, onKeyDown: te }, oe = dn(() => ({ value: q }), [q]), ue = qa(() => {
    if (K !== void 0) return se(K);
  }, [se, K]);
  return Ee.createElement(U, { name: "RadioGroup.Description" }, Ee.createElement(I, { name: "RadioGroup.Label" }, Ee.createElement(DO.Provider, { value: pe }, Ee.createElement(MO.Provider, { value: ce }, u != null && Ee.createElement(wE, { disabled: b, data: { [u]: q || "on" }, overrides: { type: "radio", checked: q != null }, form: c, onReset: ue }), is({ ourProps: Se, theirProps: k, slot: oe, defaultTag: uce, name: "RadioGroup" })))));
}
let fce = "div";
function mce(e, t) {
  var n;
  let r = RO("RadioGroup.Option"), s = PO("RadioGroup.Option"), o = Zl(), { id: c = `headlessui-radiogroup-option-${o}`, value: u, disabled: m = r.disabled || !1, autoFocus: y = !1, ...b } = e, w = Rt(null), k = ri(w, t), [j, E] = J3(), [T, D] = NE(), L = $d({ value: u, disabled: m });
  gs(() => s.registerOption({ id: c, element: w, propsRef: L }), [c, s, w, L]);
  let I = ln((X) => {
    var se;
    if (Q2(X.currentTarget)) return X.preventDefault();
    s.change(u) && ((se = w.current) == null || se.focus());
  }), R = ((n = r.firstOption) == null ? void 0 : n.id) === c, { isFocusVisible: U, focusProps: z } = Jg({ autoFocus: y }), { isHovered: H, hoverProps: K } = jy({ isDisabled: m }), q = r.compare(r.value, u), Q = gm({ ref: k, id: c, role: "radio", "aria-checked": q ? "true" : "false", "aria-labelledby": j, "aria-describedby": T, "aria-disabled": m ? !0 : void 0, tabIndex: m ? -1 : q || !r.containsCheckedOption && R ? 0 : -1, onClick: m ? void 0 : I, autoFocus: y }, z, K), Z = dn(() => ({ checked: q, disabled: m, active: U, hover: H, focus: U, autofocus: y }), [q, m, H, U, y]);
  return Ee.createElement(D, { name: "RadioGroup.Description" }, Ee.createElement(E, { name: "RadioGroup.Label" }, is({ ourProps: Q, theirProps: b, slot: Z, defaultTag: fce, name: "RadioGroup.Option" })));
}
let hce = "span";
function pce(e, t) {
  var n;
  let r = RO("Radio"), s = PO("Radio"), o = Zl(), c = uw(), u = ky(), { id: m = c || `headlessui-radio-${o}`, value: y, disabled: b = r.disabled || u || !1, autoFocus: w = !1, ...k } = e, j = Rt(null), E = ri(j, t), T = dw(), D = Z3(), L = $d({ value: y, disabled: b });
  gs(() => s.registerOption({ id: m, element: j, propsRef: L }), [m, s, j, L]);
  let I = ln((X) => {
    var se;
    if (Q2(X.currentTarget)) return X.preventDefault();
    s.change(y) && ((se = j.current) == null || se.focus());
  }), { isFocusVisible: R, focusProps: U } = Jg({ autoFocus: w }), { isHovered: z, hoverProps: H } = jy({ isDisabled: b }), K = ((n = r.firstOption) == null ? void 0 : n.id) === m, q = r.compare(r.value, y), Q = gm({ ref: E, id: m, role: "radio", "aria-checked": q ? "true" : "false", "aria-labelledby": T, "aria-describedby": D, "aria-disabled": b ? !0 : void 0, tabIndex: b ? -1 : q || !r.containsCheckedOption && K ? 0 : -1, autoFocus: w, onClick: b ? void 0 : I }, U, H), Z = dn(() => ({ checked: q, disabled: b, hover: z, focus: R, autofocus: w }), [q, b, z, R, w]);
  return is({ ourProps: Q, theirProps: k, slot: Z, defaultTag: hce, name: "Radio" });
}
let gce = Xa(dce), yce = Xa(mce), HE = Xa(pce), vce = _c, xce = V$, P9 = Object.assign(gce, { Option: yce, Radio: HE, Label: vce, Description: xce }), OO = ys(null);
OO.displayName = "GroupContext";
let bce = jf;
function Sce(e) {
  var t;
  let [n, r] = Re(null), [s, o] = J3(), [c, u] = NE(), m = dn(() => ({ switch: n, setSwitch: r }), [n, r]), y = {}, b = e;
  return Ee.createElement(u, { name: "Switch.Description", value: c }, Ee.createElement(o, { name: "Switch.Label", value: s, props: { htmlFor: (t = m.switch) == null ? void 0 : t.id, onClick(w) {
    n && (w.currentTarget instanceof HTMLLabelElement && w.preventDefault(), n.click(), n.focus({ preventScroll: !0 }));
  } } }, Ee.createElement(OO.Provider, { value: m }, is({ ourProps: y, theirProps: b, slot: {}, defaultTag: bce, name: "Switch.Group" }))));
}
let wce = "button";
function Cce(e, t) {
  var n;
  let r = Zl(), s = uw(), o = ky(), { id: c = s || `headlessui-switch-${r}`, disabled: u = o || !1, checked: m, defaultChecked: y, onChange: b, name: w, value: k, form: j, autoFocus: E = !1, ...T } = e, D = Ra(OO), L = Rt(null), I = ri(L, t, D === null ? null : D.setSwitch), R = bE(y), [U, z] = xE(m, b, R ?? !1), H = Yv(), [K, q] = Re(!1), Q = ln(() => {
    q(!0), z == null || z(!U), H.nextFrame(() => {
      q(!1);
    });
  }), Z = ln((Ue) => {
    if (Q2(Ue.currentTarget)) return Ue.preventDefault();
    Ue.preventDefault(), Q();
  }), X = ln((Ue) => {
    Ue.key === Or.Space ? (Ue.preventDefault(), Q()) : Ue.key === Or.Enter && SE(Ue.currentTarget);
  }), se = ln((Ue) => Ue.preventDefault()), te = dw(), fe = Z3(), { isFocusVisible: ce, focusProps: pe } = Jg({ autoFocus: E }), { isHovered: Se, hoverProps: oe } = jy({ isDisabled: u }), { pressed: ue, pressProps: he } = l5({ disabled: u }), ve = dn(() => ({ checked: U, disabled: u, hover: Se, focus: ce, active: ue, autofocus: E, changing: K }), [U, Se, ce, ue, u, K, E]), Te = gm({ id: c, ref: I, role: "switch", type: t6(e, L), tabIndex: e.tabIndex === -1 ? 0 : (n = e.tabIndex) != null ? n : 0, "aria-checked": U, "aria-labelledby": te, "aria-describedby": fe, disabled: u || void 0, autoFocus: E, onClick: Z, onKeyUp: X, onKeyPress: se }, pe, oe, he), Ie = qa(() => {
    if (R !== void 0) return z == null ? void 0 : z(R);
  }, [z, R]);
  return Ee.createElement(Ee.Fragment, null, w != null && Ee.createElement(wE, { disabled: u, data: { [w]: k || "on" }, overrides: { type: "checkbox", checked: U }, form: j, onReset: Ie }), is({ ourProps: Te, theirProps: T, slot: ve, defaultTag: wce, name: "Switch" }));
}
let Nce = Xa(Cce), jce = Sce, Ece = _c, kce = V$, _ce = Object.assign(Nce, { Group: jce, Label: Ece, Description: kce });
function Tce({ onFocus: e }) {
  let [t, n] = Re(!0), r = _G();
  return t ? Ee.createElement(Hv, { as: "button", type: "button", features: Bv.Focusable, onFocus: (s) => {
    s.preventDefault();
    let o, c = 50;
    function u() {
      if (c-- <= 0) {
        o && cancelAnimationFrame(o);
        return;
      }
      if (e()) {
        if (cancelAnimationFrame(o), !r.current) return;
        n(!1);
        return;
      }
      o = requestAnimationFrame(u);
    }
    o = requestAnimationFrame(u);
  } }) : null;
}
const UG = re.createContext(null);
function Mce() {
  return { groups: /* @__PURE__ */ new Map(), get(e, t) {
    var n;
    let r = this.groups.get(e);
    r || (r = /* @__PURE__ */ new Map(), this.groups.set(e, r));
    let s = (n = r.get(t)) != null ? n : 0;
    r.set(t, s + 1);
    let o = Array.from(r.keys()).indexOf(t);
    function c() {
      let u = r.get(t);
      u > 1 ? r.set(t, u - 1) : r.delete(t);
    }
    return [o, c];
  } };
}
function Rce({ children: e }) {
  let t = re.useRef(Mce());
  return re.createElement(UG.Provider, { value: t }, e);
}
function zG(e) {
  let t = re.useContext(UG);
  if (!t) throw new Error("You must wrap your component in a <StableCollection>");
  let n = re.useId(), [r, s] = t.current.get(e, n);
  return re.useEffect(() => s, []), r;
}
var Dce = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Dce || {}), Pce = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(Pce || {}), Oce = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(Oce || {});
let Ace = { 0(e, t) {
  var n;
  let r = k2(e.tabs, (b) => b.current), s = k2(e.panels, (b) => b.current), o = r.filter((b) => {
    var w;
    return !((w = b.current) != null && w.hasAttribute("disabled"));
  }), c = { ...e, tabs: r, panels: s };
  if (t.index < 0 || t.index > r.length - 1) {
    let b = Ai(Math.sign(t.index - e.selectedIndex), { [-1]: () => 1, 0: () => Ai(Math.sign(t.index), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 });
    if (o.length === 0) return c;
    let w = Ai(b, { 0: () => r.indexOf(o[0]), 1: () => r.indexOf(o[o.length - 1]) });
    return { ...c, selectedIndex: w === -1 ? e.selectedIndex : w };
  }
  let u = r.slice(0, t.index), m = [...r.slice(t.index), ...u].find((b) => o.includes(b));
  if (!m) return c;
  let y = (n = r.indexOf(m)) != null ? n : e.selectedIndex;
  return y === -1 && (y = e.selectedIndex), { ...c, selectedIndex: y };
}, 1(e, t) {
  if (e.tabs.includes(t.tab)) return e;
  let n = e.tabs[e.selectedIndex], r = k2([...e.tabs, t.tab], (o) => o.current), s = e.selectedIndex;
  return e.info.current.isControlled || (s = r.indexOf(n), s === -1 && (s = e.selectedIndex)), { ...e, tabs: r, selectedIndex: s };
}, 2(e, t) {
  return { ...e, tabs: e.tabs.filter((n) => n !== t.tab) };
}, 3(e, t) {
  return e.panels.includes(t.panel) ? e : { ...e, panels: k2([...e.panels, t.panel], (n) => n.current) };
}, 4(e, t) {
  return { ...e, panels: e.panels.filter((n) => n !== t.panel) };
} }, AO = ys(null);
AO.displayName = "TabsDataContext";
function G8(e) {
  let t = Ra(AO);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, G8), n;
  }
  return t;
}
let LO = ys(null);
LO.displayName = "TabsActionsContext";
function IO(e) {
  let t = Ra(LO);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, IO), n;
  }
  return t;
}
function Lce(e, t) {
  return Ai(t.type, Ace, e, t);
}
let Ice = "div";
function Fce(e, t) {
  let { defaultIndex: n = 0, vertical: r = !1, manual: s = !1, onChange: o, selectedIndex: c = null, ...u } = e;
  const m = r ? "vertical" : "horizontal", y = s ? "manual" : "auto";
  let b = c !== null, w = $d({ isControlled: b }), k = ri(t), [j, E] = r5(Lce, { info: w, selectedIndex: c ?? n, tabs: [], panels: [] }), T = dn(() => ({ selectedIndex: j.selectedIndex }), [j.selectedIndex]), D = $d(o || (() => {
  })), L = $d(j.tabs), I = dn(() => ({ orientation: m, activation: y, ...j }), [m, y, j]), R = ln((Q) => (E({ type: 1, tab: Q }), () => E({ type: 2, tab: Q }))), U = ln((Q) => (E({ type: 3, panel: Q }), () => E({ type: 4, panel: Q }))), z = ln((Q) => {
    H.current !== Q && D.current(Q), b || E({ type: 0, index: Q });
  }), H = $d(b ? e.selectedIndex : j.selectedIndex), K = dn(() => ({ registerTab: R, registerPanel: U, change: z }), []);
  gs(() => {
    E({ type: 0, index: c ?? n });
  }, [c]), gs(() => {
    if (H.current === void 0 || j.tabs.length <= 0) return;
    let Q = k2(j.tabs, (Z) => Z.current);
    Q.some((Z, X) => j.tabs[X] !== Z) && z(Q.indexOf(j.tabs[H.current]));
  });
  let q = { ref: k };
  return Ee.createElement(Rce, null, Ee.createElement(LO.Provider, { value: K }, Ee.createElement(AO.Provider, { value: I }, I.tabs.length <= 0 && Ee.createElement(Tce, { onFocus: () => {
    var Q, Z;
    for (let X of L.current) if (((Q = X.current) == null ? void 0 : Q.tabIndex) === 0) return (Z = X.current) == null || Z.focus(), !0;
    return !1;
  } }), is({ ourProps: q, theirProps: u, slot: T, defaultTag: Ice, name: "Tabs" }))));
}
let Uce = "div";
function zce(e, t) {
  let { orientation: n, selectedIndex: r } = G8("Tab.List"), s = ri(t), o = dn(() => ({ selectedIndex: r }), [r]);
  return is({ ourProps: { ref: s, role: "tablist", "aria-orientation": n }, theirProps: e, slot: o, defaultTag: Uce, name: "Tabs.List" });
}
let Bce = "button";
function Hce(e, t) {
  var n, r;
  let s = Zl(), { id: o = `headlessui-tabs-tab-${s}`, disabled: c = !1, autoFocus: u = !1, ...m } = e, { orientation: y, activation: b, selectedIndex: w, tabs: k, panels: j } = G8("Tab"), E = IO("Tab"), T = G8("Tab"), D = Rt(null), L = ri(D, t);
  gs(() => E.registerTab(D), [E, D]);
  let I = zG("tabs"), R = k.indexOf(D);
  R === -1 && (R = I);
  let U = R === w, z = ln((oe) => {
    var ue;
    let he = oe();
    if (he === ly.Success && b === "auto") {
      let ve = (ue = Ey(D)) == null ? void 0 : ue.activeElement, Te = T.tabs.findIndex((Ie) => Ie.current === ve);
      Te !== -1 && E.change(Te);
    }
    return he;
  }), H = ln((oe) => {
    let ue = k.map((he) => he.current).filter(Boolean);
    if (oe.key === Or.Space || oe.key === Or.Enter) {
      oe.preventDefault(), oe.stopPropagation(), E.change(R);
      return;
    }
    switch (oe.key) {
      case Or.Home:
      case Or.PageUp:
        return oe.preventDefault(), oe.stopPropagation(), z(() => Sf(ue, fo.First));
      case Or.End:
      case Or.PageDown:
        return oe.preventDefault(), oe.stopPropagation(), z(() => Sf(ue, fo.Last));
    }
    if (z(() => Ai(y, { vertical() {
      return oe.key === Or.ArrowUp ? Sf(ue, fo.Previous | fo.WrapAround) : oe.key === Or.ArrowDown ? Sf(ue, fo.Next | fo.WrapAround) : ly.Error;
    }, horizontal() {
      return oe.key === Or.ArrowLeft ? Sf(ue, fo.Previous | fo.WrapAround) : oe.key === Or.ArrowRight ? Sf(ue, fo.Next | fo.WrapAround) : ly.Error;
    } })) === ly.Success) return oe.preventDefault();
  }), K = Rt(!1), q = ln(() => {
    var oe;
    K.current || (K.current = !0, (oe = D.current) == null || oe.focus({ preventScroll: !0 }), E.change(R), oO(() => {
      K.current = !1;
    }));
  }), Q = ln((oe) => {
    oe.preventDefault();
  }), { isFocusVisible: Z, focusProps: X } = Jg({ autoFocus: u }), { isHovered: se, hoverProps: te } = jy({ isDisabled: c }), { pressed: fe, pressProps: ce } = l5({ disabled: c }), pe = dn(() => ({ selected: U, hover: se, active: fe, focus: Z, autofocus: u, disabled: c }), [U, se, Z, fe, u, c]), Se = gm({ ref: L, onKeyDown: H, onMouseDown: Q, onClick: q, id: o, role: "tab", type: t6(e, D), "aria-controls": (r = (n = j[R]) == null ? void 0 : n.current) == null ? void 0 : r.id, "aria-selected": U, tabIndex: U ? 0 : -1, disabled: c || void 0, autoFocus: u }, X, te, ce);
  return is({ ourProps: Se, theirProps: m, slot: pe, defaultTag: Bce, name: "Tabs.Tab" });
}
let Vce = "div";
function $ce(e, t) {
  let { selectedIndex: n } = G8("Tab.Panels"), r = ri(t), s = dn(() => ({ selectedIndex: n }), [n]);
  return is({ ourProps: { ref: r }, theirProps: e, slot: s, defaultTag: Vce, name: "Tabs.Panels" });
}
let Gce = "div", Wce = E1.RenderStrategy | E1.Static;
function Yce(e, t) {
  var n, r, s, o;
  let c = Zl(), { id: u = `headlessui-tabs-panel-${c}`, tabIndex: m = 0, ...y } = e, { selectedIndex: b, tabs: w, panels: k } = G8("Tab.Panel"), j = IO("Tab.Panel"), E = Rt(null), T = ri(E, t);
  gs(() => j.registerPanel(E), [j, E]);
  let D = zG("panels"), L = k.indexOf(E);
  L === -1 && (L = D);
  let I = L === b, { isFocusVisible: R, focusProps: U } = Jg(), z = dn(() => ({ selected: I, focus: R }), [I, R]), H = gm({ ref: T, id: u, role: "tabpanel", "aria-labelledby": (r = (n = w[L]) == null ? void 0 : n.current) == null ? void 0 : r.id, tabIndex: I ? m : -1 }, U);
  return !I && ((s = y.unmount) == null || s) && !((o = y.static) != null && o) ? Ee.createElement(Hv, { "aria-hidden": "true", ...H }) : is({ ourProps: H, theirProps: y, slot: z, defaultTag: Gce, features: Wce, visible: I, name: "Tabs.Panel" });
}
let qce = Xa(Hce), VE = Xa(Fce), j3 = Xa(zce), $E = Xa($ce), $i = Xa(Yce), GE = Object.assign(qce, { Group: VE, List: j3, Panels: $E, Panel: $i });
const FO = (e = !1, t = !1, n = 0) => {
  let r = "";
  return n === 0 || t ? r = "text-mshop-gray-50" : r = e ? "text-mshop-red-80" : "text-mshop-blue-100", r;
}, UO = (e = !1, t = !1, n = !1) => $(e ? "caret-mshop-red-80" : "focus-within:border-mshop-blue-100 focus-within:caret-mshop-blue-100", t && !n ? "text-mshop-gray-50" : "text-mshop-black", e && !n ? "border-mshop-red-80" : "border-mshop-gray-10", n || t ? "bg-mshop-gray-5" : "bg-mshop-white"), M8 = yn(
  ({ watch: e, maxLength: t, ...n }, r) => {
    const s = UO(
      n.invalid,
      n.disabled,
      n.readOnly
    ), o = FO(
      n.invalid,
      n.disabled,
      e.length
    );
    return /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "typo-mshop-kr-14-m flex w-full gap-x-[.57143rem] rounded-[.28571rem] border px-[0.85714rem]",
          s
        ),
        children: [
          /* @__PURE__ */ a.jsx(
            LE,
            {
              ref: r,
              type: "text",
              ...n,
              className: "h-[2.85714rem] w-full flex-grow bg-transparent py-[0.85714rem] placeholder-mshop-gray-50 focus:outline-none"
            }
          ),
          /* @__PURE__ */ a.jsxs("p", { className: "flex-center", children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: $("typo-mshop-en-12-unica-m", o),
                children: e.length
              }
            ),
            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-12-unica-m ml-[0.12rem] text-mshop-gray-50", children: [
              "/ ",
              t
            ] }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: "자" })
          ] })
        ]
      }
    ) });
  }
), il = ({ children: e }) => /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[.57142rem]", children: [
  /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.57142rem] flex-shrink-0 items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[.22857rem] rounded-full bg-mshop-gray-80" }) }),
  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m flex-1 text-mshop-gray-80", children: e })
] }), a8 = {
  Lv100: "100",
  Lv90: "90",
  Lv80: "80",
  Lv110: "110",
  Lv40: "40"
}, Kce = {
  GLOBAL: {
    MODAL: a8.Lv100,
    CONFIRM: a8.Lv110,
    ALERT: a8.Lv110,
    TOOLTIP: a8.Lv90,
    MOBILE_HEADER: a8.Lv40,
    LIST_BOX: a8.Lv80
  }
}, Tc = Kce, GM = "headlessui-portal-root", zO = ({
  show: e,
  onClose: t
}) => {
  const {
    widgetCore: { onScrollLock: n }
  } = Gt(), r = Rt(null);
  an(() => (n(e), () => {
    n(!1);
  }), [e]);
  const s = (u) => {
    if (!t)
      return;
    const m = r.current;
    u.target instanceof HTMLElement && m && !m.contains(u.target) && m.parentElement === u.target && (t(), n(!1));
  };
  if (document.getElementById(GM) === null) {
    const u = document.createElement("div");
    u.setAttribute("id", GM), document.body.appendChild(u);
  }
  const c = document.getElementById(GM);
  return wt(c), {
    container: c,
    panelRef: r,
    handleMouseDown: s
  };
};
function Zu({
  show: e,
  onClose: t,
  children: n,
  isCloseOnClickOutside: r = !0,
  transition: s,
  ...o
}) {
  const {
    widgetCore: { isMobile: c }
  } = Gt(), u = s ?? c, { panelRef: m, container: y, handleMouseDown: b } = zO({
    show: e,
    onClose: t
  });
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: po.createPortal(
    /* @__PURE__ */ a.jsx(vO, { ...o, show: e, transition: u, children: /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: "twp relative",
        style: {
          zIndex: Tc.GLOBAL.MODAL
        },
        children: [
          !c && /* @__PURE__ */ a.jsx("div", { className: $("fixed inset-0 bg-mshop-dim-60") }),
          /* @__PURE__ */ a.jsx(AE, { transition: u, children: /* @__PURE__ */ a.jsx(
            "div",
            {
              className: "flex-center fixed inset-0 transition duration-500 ease-out data-[closed]:translate-y-full",
              onMouseDown: r ? b : Gd,
              children: /* @__PURE__ */ a.jsx(
                "div",
                {
                  ref: m,
                  className: $({
                    "flex h-full w-full flex-col": c
                  }),
                  children: n
                }
              )
            }
          ) })
        ]
      }
    ) }),
    y
  ) });
}
function BO({
  stepInfos: e,
  modalTitle: t,
  show: n,
  onClose: r
}) {
  const [s, o] = Re(0);
  return /* @__PURE__ */ a.jsx(
    Zu,
    {
      show: n,
      onClose: r,
      afterLeave: () => {
        o(0);
      },
      children: /* @__PURE__ */ a.jsxs("div", { className: "flex h-[50rem] w-[64rem] overflow-hidden rounded-[1.14286rem]", children: [
        /* @__PURE__ */ a.jsxs("section", { className: "flex w-[21.85714rem] flex-col justify-between bg-mshop-white px-[3.42857rem] pb-[3.42857rem] pt-[4.28571rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[4.28571rem]", children: [
            /* @__PURE__ */ a.jsxs("h1", { className: "typo-mshop-kr-24-b flex flex-col gap-y-[0.28571rem] text-mshop-black", children: [
              /* @__PURE__ */ a.jsx("span", { children: t[0] }),
              /* @__PURE__ */ a.jsx("span", { children: t[1] })
            ] }),
            /* @__PURE__ */ a.jsx("div", { className: "flex flex-col gap-y-[1.71429rem]", children: e.map((c, u) => /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                onClick: () => o(u),
                children: /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: $(
                      "typo-mshop-kr-16-m flex items-center gap-x-[1.14286rem]",
                      u === s ? "text-mshop-blue-100" : "text-mshop-gray-50"
                    ),
                    children: [
                      /* @__PURE__ */ a.jsx(
                        "div",
                        {
                          className: $(
                            "h-[1.14286rem] w-[0.14286rem] rounded-[0.07143rem]",
                            u === s ? "bg-mshop-blue-100" : "bg-transparent"
                          )
                        }
                      ),
                      /* @__PURE__ */ a.jsx("span", { children: c.title })
                    ]
                  }
                )
              },
              c.title
            )) })
          ] }),
          /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              className: "flex-center typo-mshop-kr-16-b w-fit rounded-[71.35714rem] bg-mshop-blue-10 px-[1.71429rem] py-[0.57143rem] text-mshop-blue-100",
              onClick: () => {
                s === e.length - 1 ? r() : o(s + 1);
              },
              children: s === e.length - 1 ? "시작하기" : "다음"
            }
          )
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "relative h-full w-[42.14286rem] bg-mshop-blue-100", children: [
          e.map((c, u) => /* @__PURE__ */ a.jsx(
            "section",
            {
              className: $(
                "absolute inset-0 flex flex-col bg-cover bg-center bg-no-repeat transition duration-500 ease-out",
                u === s ? "opacity-100" : "opacity-0"
              ),
              style: {
                backgroundImage: `url(${c.imgSrc})`,
                zIndex: u === s ? Tc.GLOBAL.MODAL + 1 : Tc.GLOBAL.MODAL
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "absolute bottom-0 flex w-full flex-col gap-y-[.85714rem] bg-mshop-dim-60 px-[2.28571rem] pb-[3.42857rem] pt-[2.28571rem] text-mshop-white backdrop-blur-[30px]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b", children: c.title }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m whitespace-pre-wrap", children: c.description })
              ] })
            },
            c.title
          )),
          /* @__PURE__ */ a.jsx(
            "button",
            {
              onClick: r,
              type: "button",
              className: "absolute right-[1.71429rem] top-[1.71429rem] size-[1.71429rem]",
              children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.71429rem] fill-mshop-white" })
            }
          )
        ] })
      ] })
    }
  );
}
const Xce = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M21.12 11.12H12.87V2.88C12.87 2.4 12.48 2 11.99 2C11.5 2 11.11 2.39 11.11 2.88V11.13H2.88C2.4 11.13 2 11.52 2 12.01C2 12.5 2.39 12.89 2.88 12.89H11.13V21.14C11.13 21.62 11.52 22.02 12.01 22.02C12.5 22.02 12.89 21.63 12.89 21.14V12.89H21.14C21.62 12.89 22.02 12.5 22.02 12.01C22.02 11.52 21.63 11.13 21.14 11.13L21.12 11.12Z" })), HO = yn(Xce), Qce = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_4353_61745)" }, /* @__PURE__ */ re.createElement("path", { d: "M20.231 8.21974L5.22998 3.63478C4.46387 3.40138 3.65576 3.54005 3.01172 4.01759C2.36865 4.49415 2 5.22657 2 6.02638V17.9737C2 18.7735 2.36865 19.5059 3.01172 19.9824C3.45068 20.3076 3.96631 20.4756 4.49317 20.4756C4.73878 20.4756 4.98682 20.4385 5.23096 20.3643L12.166 18.245V19.0742C12.166 19.7774 12.7378 20.3496 13.4409 20.3496H16.8911C17.5942 20.3496 18.166 19.7774 18.166 19.0742V16.4113L20.231 15.7803C21.2891 15.458 22 14.4971 22 13.3897V10.6104C22 9.50295 21.2886 8.542 20.231 8.21974ZM16.416 18.5996H13.916V17.7101L16.416 16.9461V18.5996ZM20 13.3897C20 13.6113 19.8579 13.8037 19.647 13.8682L13.916 15.619V8.38057L19.647 10.1319C19.8579 10.1963 20 10.3887 20 10.6104V13.3897Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_4353_61745" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), t9 = yn(Qce), Zce = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_1345_3538)" }, /* @__PURE__ */ re.createElement("path", { d: "M17.13 13.12C16.65 13.12 16.25 13.51 16.25 14V20.25H3.75V7.75H10C10.48 7.75 10.88 7.36 10.88 6.87C10.88 6.38 10.49 5.99 10 5.99H3.7C2.76 5.99 2 6.75 2 7.69V20.29C2 21.23 2.76 21.99 3.7 21.99H16.3C17.24 21.99 18 21.23 18 20.29V13.99C18 13.51 17.61 13.11 17.12 13.11L17.13 13.12Z" }), /* @__PURE__ */ re.createElement("path", { d: "M21.93 2.54C21.84 2.33 21.67 2.16 21.46 2.07C21.35 2.03 21.24 2 21.13 2H12.63C12.15 2 11.75 2.39 11.75 2.88C11.75 3.37 12.14 3.76 12.63 3.76H19.02L12.01 10.77C11.67 11.11 11.67 11.67 12.01 12.01C12.18 12.18 12.4 12.27 12.63 12.27C12.86 12.27 13.08 12.18 13.25 12.01L20.26 5V11.39C20.26 11.87 20.65 12.27 21.14 12.27C21.63 12.27 22.02 11.88 22.02 11.39V2.88C22.02 2.77 22 2.65 21.95 2.55L21.93 2.54Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_1345_3538" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), WE = yn(Zce), EU = {
  add: HO,
  outlink: WE,
  upload: vE,
  clap: t9
}, Jce = {
  md: $(
    "typo-mshop-kr-14-m h-[3.42857rem] min-w-[9.42857rem] gap-x-[.57143rem] rounded-[.28571rem] px-[1.71428rem]"
  ),
  sm: $(
    "typo-mshop-kr-14-m h-[2.85714rem] min-w-[6.85714rem] gap-x-[.28571rem] rounded-[.28571rem] px-[1.71428rem]"
  ),
  ss: $(
    "typo-mshop-kr-14-m h-[2.28571rem] gap-x-[0.28571rem] rounded-[0.57143rem] px-[0.85714rem]"
  )
}, eue = {
  lineGray: $(
    "border border-mshop-gray-10 bg-mshop-white text-mshop-gray-80 disabled:border-transparent disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50"
  ),
  lineSky: $(
    "border border-mshop-blue-100 bg-mshop-white text-mshop-blue-100 disabled:border-transparent disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50"
  ),
  white: $(
    "bg-mshop-blue-10 text-mshop-blue-100 disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50"
  ),
  blue: $(
    "bg-mshop-blue-100 text-mshop-white disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50"
  )
}, kU = {
  md: "size-[1.28571rem]",
  sm: "size-[1.14285rem]",
  ss: "size-[0.85714rem]"
};
function za({
  children: e,
  variant: t,
  theme: n,
  iconFront: r,
  iconRear: s,
  widthFull: o = !1,
  ...c
}) {
  const u = r ? EU[r] : null, m = s ? EU[s] : null;
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...c,
      className: $(
        "flex-center",
        Jce[t],
        eue[n],
        {
          "w-full": o
        }
      ),
      children: (y) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        u && /* @__PURE__ */ a.jsx(
          u,
          {
            className: $("shrink-0", kU[t])
          }
        ),
        /* @__PURE__ */ a.jsx("span", { className: "shrink-0", children: typeof e == "function" ? e(y) : e }),
        m && /* @__PURE__ */ a.jsx(m, { className: $("shrink-0", kU[t]) })
      ] })
    }
  );
}
function BG({
  show: e,
  onClose: t,
  imgUrl: n,
  title: r,
  descriptions: s,
  confirmButton: o,
  guidLineButton: c
}) {
  return /* @__PURE__ */ a.jsx(Zu, { show: e, onClose: t, children: /* @__PURE__ */ a.jsxs("div", { className: "flex w-[32rem] min-w-[20.57142rem] flex-col overflow-hidden rounded-[1.14285rem] bg-mshop-blue-100", children: [
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: "relative flex h-[22.5rem] flex-col items-center justify-end bg-cover bg-center",
        style: {
          backgroundImage: `url(${n})`
        },
        children: [
          /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              className: "flex-center absolute right-[.57143rem] top-[.57143rem] size-[2.85714rem] rounded-full bg-mshop-dim-10",
              onClick: t,
              children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.42857rem] fill-mshop-white" })
            }
          ),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-40-bebas-b absolute mb-[2.28571rem] text-center text-mshop-white", children: r })
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[2.28571rem] bg-mshop-white p-[1.71428rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center gap-y-[.85714rem]", children: [
        /* @__PURE__ */ a.jsx("ul", { className: "typo-mshop-kr-14-m w-full list-disc whitespace-pre-wrap pl-[1.42857rem] text-mshop-black", children: s.map((u, m) => /* @__PURE__ */ a.jsx("li", { children: u }, u + m)) }),
        /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: "typo-mshop-kr-14-m w-fit text-mshop-blue-100 underline underline-offset-8",
            onClick: c.onClick,
            children: c.title
          }
        )
      ] }),
      /* @__PURE__ */ a.jsx(
        za,
        {
          variant: "md",
          theme: "blue",
          widthFull: !0,
          type: "button",
          onClick: o.onClick,
          children: o.title
        }
      )
    ] })
  ] }) });
}
function sa({ children: e, button: t }) {
  return /* @__PURE__ */ a.jsxs("div", { className: "flex-col-center w-[24.5rem] min-w-[20.57143rem] gap-y-[2.28571rem] rounded-[0.57143rem] bg-mshop-white px-[1.71428rem] pb-[1.71428rem] pt-[2.57142rem]", children: [
    /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m text-center text-mshop-gray-80", children: e }),
    /* @__PURE__ */ a.jsx(
      "button",
      {
        ...t.props,
        type: "button",
        className: "typo-mshop-kr-16-b h-[3.71428rem] w-full min-w-[11.42857rem] rounded-[0.57143rem] bg-mshop-blue-100 px-[1.14286rem] text-mshop-white",
        children: "확인"
      }
    )
  ] });
}
function qu({
  children: e,
  cancelButton: t,
  confirmButton: n
}) {
  return /* @__PURE__ */ a.jsxs("div", { className: "flex-col-center w-[24.5rem] gap-y-[2.28571rem] rounded-[0.57143rem] bg-mshop-white px-[1.71428rem] pb-[1.71428rem] pt-[2.57142rem]", children: [
    /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m text-center text-mshop-gray-80", children: e }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.85714rem]", children: [
      /* @__PURE__ */ a.jsx(
        "button",
        {
          ...t.props,
          type: "button",
          className: "flex-center typo-mshop-kr-16-b h-[3.71429rem] w-full rounded-[0.57142rem] border border-mshop-gray-20 bg-mshop-white px-[1.71429rem] text-mshop-gray-80",
          children: t.text ?? "취소"
        }
      ),
      /* @__PURE__ */ a.jsx(
        "button",
        {
          ...n.props,
          type: "button",
          className: $(
            "flex-center typo-mshop-kr-16-b h-[3.71429rem] w-full rounded-[0.57142rem] px-[1.71429rem] text-mshop-white",
            n.color === "red" ? "bg-mshop-red-80" : "bg-mshop-blue-100"
          ),
          children: n.text ?? "확인"
        }
      )
    ] })
  ] });
}
function W8() {
  return W8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, W8.apply(null, arguments);
}
function HG(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
var tue = a5, nue = function(t) {
  var n = re.useRef(t);
  return tue(function() {
    n.current = t;
  }), n;
}, _U = function(t, n) {
  if (typeof t == "function") {
    t(n);
    return;
  }
  t.current = n;
}, rue = function(t, n) {
  var r = Rt();
  return qa(function(s) {
    t.current = s, r.current && _U(r.current, null), r.current = n, n && _U(n, s);
  }, [n]);
}, TU = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, aue = function(t) {
  Object.keys(TU).forEach(function(n) {
    t.style.setProperty(n, TU[n], "important");
  });
}, MU = aue, um = null, RU = function(t, n) {
  var r = t.scrollHeight;
  return n.sizingStyle.boxSizing === "border-box" ? r + n.borderSize : r - n.paddingSize;
};
function sue(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = 1 / 0), um || (um = document.createElement("textarea"), um.setAttribute("tabindex", "-1"), um.setAttribute("aria-hidden", "true"), MU(um)), um.parentNode === null && document.body.appendChild(um);
  var s = e.paddingSize, o = e.borderSize, c = e.sizingStyle, u = c.boxSizing;
  Object.keys(c).forEach(function(k) {
    var j = k;
    um.style[j] = c[j];
  }), MU(um), um.value = t;
  var m = RU(um, e);
  um.value = t, m = RU(um, e), um.value = "x";
  var y = um.scrollHeight - s, b = y * n;
  u === "border-box" && (b = b + s + o), m = Math.max(b, m);
  var w = y * r;
  return u === "border-box" && (w = w + s + o), m = Math.min(w, m), [m, y];
}
var DU = function() {
}, iue = function(t, n) {
  return t.reduce(function(r, s) {
    return r[s] = n[s], r;
  }, {});
}, oue = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], lue = !!document.documentElement.currentStyle, cue = function(t) {
  var n = window.getComputedStyle(t);
  if (n === null)
    return null;
  var r = iue(oue, n), s = r.boxSizing;
  if (s === "")
    return null;
  lue && s === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var o = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), c = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: o,
    borderSize: c
  };
}, uue = cue;
function VG(e, t, n) {
  var r = nue(n);
  re.useLayoutEffect(function() {
    var s = function(c) {
      return r.current(c);
    };
    if (e)
      return e.addEventListener(t, s), function() {
        return e.removeEventListener(t, s);
      };
  }, []);
}
var due = function(t) {
  VG(window, "resize", t);
}, fue = function(t) {
  VG(document.fonts, "loadingdone", t);
}, mue = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], hue = function(t, n) {
  var r = t.cacheMeasurements, s = t.maxRows, o = t.minRows, c = t.onChange, u = c === void 0 ? DU : c, m = t.onHeightChange, y = m === void 0 ? DU : m, b = HG(t, mue), w = b.value !== void 0, k = re.useRef(null), j = rue(k, n), E = re.useRef(0), T = re.useRef(), D = function() {
    var R = k.current, U = r && T.current ? T.current : uue(R);
    if (U) {
      T.current = U;
      var z = sue(U, R.value || R.placeholder || "x", o, s), H = z[0], K = z[1];
      E.current !== H && (E.current = H, R.style.setProperty("height", H + "px", "important"), y(H, {
        rowHeight: K
      }));
    }
  }, L = function(R) {
    w || D(), u(R);
  };
  return re.useLayoutEffect(D), due(D), fue(D), /* @__PURE__ */ re.createElement("textarea", W8({}, b, {
    onChange: L,
    ref: j
  }));
}, YE = /* @__PURE__ */ re.forwardRef(hue);
const vy = yn(
  ({ watch: e, maxLength: t, minRows: n, invalid: r, ...s }, o) => {
    const c = UO(
      r,
      s.disabled,
      s.readOnly
    ), u = FO(
      r,
      s.disabled,
      e.length
    );
    return /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex gap-x-[.57143rem] px-[.57143rem] py-[.85714rem]",
          "rounded-[.32652rem] border",
          c
        ),
        children: [
          /* @__PURE__ */ a.jsx(
            YE,
            {
              ref: o,
              ...s,
              className: $(
                "w-full resize-none overflow-hidden outline-none",
                "typo-mshop-kr-14-m",
                "placeholder:text-mshop-gray-50",
                s.readOnly || s.disabled ? "bg-mshop-gray-5" : "bg-mshop-white"
              ),
              minRows: n || 3
            }
          ),
          /* @__PURE__ */ a.jsxs("span", { className: "flex items-end", children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: $("typo-mshop-en-12-unica-m", u),
                children: e.length
              }
            ),
            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-12-unica-m ml-[.13714rem] text-mshop-gray-50", children: [
              "/ ",
              t
            ] }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: "자" })
          ] })
        ]
      }
    );
  }
), pue = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_10144_88808)" }, /* @__PURE__ */ re.createElement("path", { d: "M12 21H11.98C11.87 21 11.77 20.98 11.67 20.94C11.57 20.9 11.47 20.83 11.38 20.75L3.38 12.74C3.04 12.4 3.04 11.84 3.38 11.5C3.72 11.16 4.28 11.16 4.62 11.5L11.13 18.01V3.88C11.13 3.4 11.52 3 12.01 3C12.5 3 12.89 3.39 12.89 3.88V18.02L19.4 11.51C19.74 11.17 20.3 11.17 20.64 11.51C20.98 11.85 20.98 12.41 20.64 12.75L12.64 20.75C12.56 20.83 12.46 20.9 12.35 20.94C12.25 20.98 12.15 21 12.04 21H12.02H12Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_10144_88808" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), gue = yn(pue), yue = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_10144_88802)" }, /* @__PURE__ */ re.createElement("path", { d: "M12.12 20.88C11.9 20.88 11.67 20.79 11.5 20.62C11.16 20.28 11.16 19.72 11.5 19.38L18.01 12.87H3.88C3.4 12.87 3 12.48 3 11.99C3 11.5 3.39 11.11 3.88 11.11H18.02L11.51 4.59998C11.17 4.25998 11.17 3.69998 11.51 3.35998C11.85 3.01998 12.41 3.01998 12.75 3.35998L20.75 11.36C20.83 11.44 20.9 11.54 20.94 11.65C20.98 11.75 21 11.85 21.01 11.96V11.99C21.01 12.1 20.98 12.21 20.94 12.3C20.9 12.41 20.83 12.5 20.75 12.59L12.75 20.59C12.58 20.76 12.35 20.85 12.13 20.85L12.12 20.88Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_10144_88802" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), VO = yn(yue), vue = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_608_22142)" }, /* @__PURE__ */ re.createElement("path", { d: "M21.1202 11.98C20.6402 11.98 20.2402 12.37 20.2402 12.86V19.89C20.2402 20.09 20.0202 20.26 19.7602 20.26H4.23023C3.97023 20.26 3.75023 20.09 3.75023 19.89V12.86C3.75023 12.38 3.36023 11.98 2.87023 11.98C2.38023 11.98 1.99023 12.37 1.99023 12.86V19.89C1.99023 21.06 2.99023 22.01 4.22023 22.01H19.7502C20.9802 22.01 21.9802 21.06 21.9802 19.89V12.86C21.9802 12.38 21.5902 11.98 21.1002 11.98H21.1202Z" }), /* @__PURE__ */ re.createElement("path", { d: "M11.3802 16.32C11.4602 16.4 11.5602 16.46 11.6602 16.51C11.7702 16.55 11.8802 16.58 12.0002 16.58C12.1202 16.58 12.2302 16.56 12.3402 16.51C12.4502 16.47 12.5402 16.4 12.6202 16.32L15.8802 13.06C16.2202 12.72 16.2202 12.16 15.8802 11.82C15.5402 11.48 14.9802 11.48 14.6402 11.82L12.8802 13.58V2.88C12.8802 2.4 12.4902 2 12.0002 2C11.5102 2 11.1202 2.39 11.1202 2.88V13.6L9.36023 11.84C9.02023 11.5 8.46023 11.5 8.12023 11.84C7.78023 12.18 7.78023 12.74 8.12023 13.08L11.3802 16.34V16.32Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_608_22142" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), Y8 = yn(vue), xue = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_2950_392407)" }, /* @__PURE__ */ re.createElement("path", { d: "M17.13 13.12C16.65 13.12 16.25 13.51 16.25 14V20.25H3.75V7.75H10C10.48 7.75 10.88 7.36 10.88 6.87C10.88 6.38 10.49 5.99 10 5.99H3.7C2.76 5.99 2 6.75 2 7.69V20.29C2 21.23 2.76 21.99 3.7 21.99H16.3C17.24 21.99 18 21.23 18 20.29V13.99C18 13.51 17.61 13.11 17.12 13.11L17.13 13.12Z" }), /* @__PURE__ */ re.createElement("path", { d: "M21.93 2.54C21.84 2.33 21.67 2.16 21.46 2.07C21.35 2.03 21.24 2 21.13 2H12.63C12.15 2 11.75 2.39 11.75 2.88C11.75 3.37 12.14 3.76 12.63 3.76H19.02L12.01 10.77C11.67 11.11 11.67 11.67 12.01 12.01C12.18 12.18 12.4 12.27 12.63 12.27C12.86 12.27 13.08 12.18 13.25 12.01L20.26 5V11.39C20.26 11.87 20.65 12.27 21.14 12.27C21.63 12.27 22.02 11.88 22.02 11.39V2.88C22.02 2.77 22 2.65 21.95 2.55L21.93 2.54Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_2950_392407" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), bue = yn(xue), Sue = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_705_98856)" }, /* @__PURE__ */ re.createElement("path", { d: "M21.54 6.25001C20.7 4.18001 18.8 2.89001 16.57 2.89001C14.69 2.89001 12.95 3.84001 12 5.39001C11.05 3.84001 9.31002 2.89001 7.43002 2.89001C5.21002 2.89001 3.30002 4.18001 2.46002 6.25001C1.90002 7.63001 1.85002 9.12001 2.32002 10.8C2.46002 11.3 2.64002 11.81 2.87002 12.3C3.12002 12.85 3.42002 13.39 3.78002 13.93L3.82002 13.98C4.03002 14.29 4.25002 14.59 4.48002 14.88C6.33002 17.22 8.71002 19.23 11.77 21.05C11.83 21.09 11.91 21.11 12 21.11C12.05 21.11 12.15 21.11 12.23 21.05C15.29 19.24 17.68 17.22 19.52 14.88C19.75 14.59 19.97 14.29 20.18 13.98L20.22 13.91C20.57 13.38 20.88 12.84 21.12 12.29C21.35 11.8 21.53 11.29 21.67 10.79C22.14 9.11001 22.09 7.62001 21.53 6.24001L21.54 6.25001ZM16.37 15.78C15.94 16.2 15.48 16.61 15 17C15.18 16.66 15.35 16.31 15.52 15.96C15.81 15.91 16.09 15.85 16.37 15.78ZM14.31 14.39C12.81 14.58 11.2 14.58 9.70002 14.39C9.24002 13.26 8.93002 12.14 8.76002 10.97V10.95C10.85 11.26 13.16 11.26 15.25 10.95V10.97C15.08 12.14 14.77 13.26 14.31 14.39ZM8.48002 15.96C8.64002 16.31 8.82002 16.66 9.00002 17C8.52002 16.6 8.06002 16.19 7.63002 15.78C7.91002 15.85 8.19002 15.91 8.48002 15.96ZM14.27 5.43001C14.38 5.46001 14.89 5.88001 15.19 7.31001C15.32 7.90001 15.38 8.52001 15.38 9.18001C13.26 9.54001 10.74 9.54001 8.62002 9.18001C8.62002 8.51001 8.68002 7.90001 8.81002 7.31001C9.11002 5.88001 9.62002 5.46001 9.70002 5.43001C9.79002 5.45001 10.21 5.76001 10.51 6.79001L10.58 7.00001C10.77 7.63001 11.35 8.05001 12.01 8.05001C12.67 8.05001 13.24 7.63001 13.44 7.00001L13.51 6.79001C13.81 5.77001 14.24 5.45001 14.29 5.43001H14.27ZM7.10002 6.94001C6.98002 7.52001 6.90002 8.14001 6.88002 8.78001C6.59002 8.69001 6.32002 8.60001 6.07002 8.51001C4.95002 8.08001 4.18002 7.52001 4.06002 7.04001C4.05002 7.00001 4.06002 6.95002 4.07002 6.90001C4.37002 6.16001 4.84002 5.58001 5.46002 5.19001C6.20002 4.72001 7.13002 4.54001 8.02002 4.68001C7.61002 5.24001 7.29002 6.01001 7.09002 6.94001H7.10002ZM6.95002 10.6C6.97002 10.81 7.00002 11.01 7.03002 11.22C7.17002 12.17 7.39002 13.09 7.69002 14C7.24002 13.88 6.82002 13.74 6.43002 13.57C5.61002 13.23 4.94002 12.59 4.55002 11.78L4.52002 11.72C4.49002 11.61 4.45002 11.51 4.40002 11.45C4.24002 11.08 4.10002 10.7 4.00002 10.33C3.90002 9.97001 3.83002 9.62001 3.79002 9.29001C4.57002 9.83001 5.65002 10.28 6.96002 10.6H6.95002ZM16.97 11.22C17 11.01 17.03 10.81 17.05 10.6C18.35 10.27 19.44 9.82001 20.22 9.29001C20.18 9.63001 20.11 9.98001 20.01 10.33C19.91 10.7 19.77 11.08 19.63 11.42C19.56 11.52 19.51 11.62 19.5 11.7L19.46 11.78C19.06 12.59 18.4 13.23 17.56 13.58C17.18 13.74 16.76 13.88 16.31 14C16.62 13.08 16.83 12.17 16.97 11.22ZM20.16 6.81001L19.93 6.90001C19.93 6.90001 19.95 7.00001 19.94 7.04001C19.82 7.51001 19.05 8.08001 17.93 8.51001C17.68 8.61001 17.41 8.70001 17.12 8.78001C17.1 8.14001 17.03 7.52001 16.9 6.94001C16.7 6.01001 16.38 5.23001 15.97 4.67001C16.86 4.53001 17.79 4.71001 18.53 5.18001C19.15 5.58001 19.62 6.15001 19.92 6.89001L20.15 6.80001L20.16 6.81001ZM12 18.53C11.47 17.8 10.99 17.04 10.55 16.22C11.52 16.29 12.48 16.29 13.44 16.22C13 17.04 12.53 17.8 11.99 18.53H12Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_705_98856" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), ch = yn(Sue), PU = {
  arrowRight: VO,
  shopDefault: ch,
  arrowBottom: gue,
  outLink: bue,
  download: Y8
}, wue = {
  sm: $(
    "typo-mshop-kr-14-b h-[2.85714rem] min-w-[8.57142rem] gap-x-[.28571rem] rounded-[.57142rem] px-[1.71428rem]"
  ),
  md: $(
    "typo-mshop-kr-14-b h-[3.42857rem] min-w-[11.42857rem] gap-x-[.28571rem] rounded-[.57142rem] px-[1.71428rem]"
  ),
  lg: $(
    "typo-mshop-kr-16-b h-[4rem] min-w-[11.42857rem] gap-x-[.57143rem] rounded-[.85714rem] px-[1.71428rem]"
  )
}, OU = {
  sm: "size-[1.14285rem]",
  md: "size-[1.14285rem]",
  lg: "size-[1.42857rem]"
};
function fn({
  children: e,
  variant: t,
  theme: n,
  iconFront: r,
  iconRear: s,
  widthFull: o = !1,
  ...c
}) {
  const {
    widgetCore: { isMobile: u }
  } = Gt(), m = r ? PU[r] : null, y = s ? PU[s] : null, b = dn(
    () => ({
      white: $(
        "bg-mshop-blue-10 text-mshop-blue-100 disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50",
        {
          "hover:bg-mshop-blue-100 hover:text-mshop-blue-10": !u
        }
      ),
      blue: $(
        "bg-mshop-blue-100 text-mshop-white disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50",
        {
          "hover:bg-mshop-blue-10 hover:text-mshop-blue-100": !u
        }
      ),
      line: $(
        "border border-mshop-gray-20 bg-mshop-white text-mshop-gray-80 disabled:border-transparent disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50",
        {
          "hover:border-mshop-blue-100 hover:text-mshop-blue-100": !u
        }
      ),
      black: $("bg-mshop-black text-mshop-white")
    }),
    [u]
  );
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...c,
      className: $(
        "flex-center transition duration-200 hover:cursor-pointer disabled:cursor-default",
        wue[t],
        b[n],
        {
          "w-full": o
        }
      ),
      children: (w) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        m && /* @__PURE__ */ a.jsx(
          m,
          {
            className: $("shrink-0", OU[t])
          }
        ),
        /* @__PURE__ */ a.jsx("span", { className: "shrink-0", children: typeof e == "function" ? e(w) : e }),
        y && /* @__PURE__ */ a.jsx(y, { className: $("shrink-0", OU[t]) })
      ] })
    }
  );
}
const Cue = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M9.86965 18.8201C9.59965 18.8201 9.32965 18.7101 9.14965 18.5101L2.27965 11.3301C1.89965 10.9301 1.90965 10.3001 2.30965 9.91007C2.70965 9.53007 3.33965 9.54006 3.72965 9.94006L9.86965 16.3701L20.2696 5.49007C20.6496 5.09007 21.2896 5.08007 21.6896 5.46007C22.0896 5.84007 22.0996 6.48007 21.7196 6.88007L10.5896 18.5201C10.3996 18.7201 10.1396 18.8301 9.86965 18.8301V18.8201Z" })), Nue = yn(Cue);
function $O(e) {
  return /* @__PURE__ */ a.jsx(
    G$,
    {
      ...e,
      className: $(
        "flex-center group size-[1.14285rem] shrink-0 rounded-[.28571rem]",
        "cursor-pointer border border-mshop-gray-10 bg-mshop-white",
        "data-[checked]:border-none data-[checked]:bg-mshop-blue-100",
        "data-[disabled]:cursor-not-allowed data-[disabled]:border-mshop-gray-10 data-[disabled]:bg-mshop-gray-5",
        "data-[checked]:data-[disabled]:border-none data-[checked]:data-[disabled]:bg-mshop-gray-20"
      ),
      children: /* @__PURE__ */ a.jsx(Nue, { className: "size-[0.92857rem] text-mshop-white opacity-0 group-data-[checked]:opacity-100" })
    }
  );
}
function jue({
  show: e,
  onClose: t,
  onOpenSupport: n,
  onTermsTextClick: r,
  onCreatorGuideTextClick: s
}) {
  const [o, c] = Re(!1);
  return an(() => () => {
    e && c(!1);
  }, [e]), /* @__PURE__ */ a.jsx(Zu, { show: e, onClose: t, children: /* @__PURE__ */ a.jsxs("section", { className: "typo-mshop-kr-14-m flex w-[32rem] flex-col gap-y-[1.71rem] rounded-[1rem] bg-mshop-white px-[1.71429rem] pb-[1.71429rem] pt-[2.57143rem] text-mshop-black", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14285rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex-col-center items-center gap-y-[0.29rem]", children: [
        /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: "후원 시작하기" }),
        /* @__PURE__ */ a.jsx("p", { children: "크리에이터 샵에 후원 플랜을 공개할까요?" })
      ] }),
      /* @__PURE__ */ a.jsx("div", { className: "rounded-[0.571rem] bg-mshop-gray-5 text-left", children: /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m list-disc py-[0.857rem] pl-[1.714rem] pr-[0.857rem] text-mshop-gray-80", children: [
        /* @__PURE__ */ a.jsxs(il, { children: [
          "후원 서비스를 이용하기 전",
          " ",
          /* @__PURE__ */ a.jsx(
            "button",
            {
              className: "typo-mshop-kr-14-m underline underline-offset-2",
              type: "button",
              onClick: r,
              children: "이용약관"
            }
          ),
          "을 확인해 주세요."
        ] }),
        /* @__PURE__ */ a.jsx(il, { children: "(주)마플코퍼레이션(이하 '회사')은 회원 간 콘텐츠 거래를 중개하며 거래의 책임은 거래 당사자에게 있습니다." }),
        /* @__PURE__ */ a.jsx(il, { children: "팬들에게 받는 후원금은 취소, 환불이 불가능합니다." }),
        /* @__PURE__ */ a.jsx(il, { children: "크리에이터는 후원금의 사용 목적을 명확히 안내하며, 공개 모금 등의 활동이 진행되는 후원은 이를 신뢰할 수 있도록 사용 내역을 투명하게 공개해야 합니다." }),
        /* @__PURE__ */ a.jsxs(il, { children: [
          "더 자세한 내용은",
          " ",
          /* @__PURE__ */ a.jsx(
            "button",
            {
              className: "typo-mshop-kr-14-m underline underline-offset-2",
              type: "button",
              onClick: s,
              children: "크리에이터 가이드"
            }
          ),
          "를 참고해주세요."
        ] })
      ] }) }),
      /* @__PURE__ */ a.jsxs(Bd, { className: "flex items-center gap-x-[0.571rem]", children: [
        /* @__PURE__ */ a.jsx(
          $O,
          {
            checked: o,
            onChange: c
          }
        ),
        /* @__PURE__ */ a.jsx(_c, { className: "typo-mshop-kr-14-b cursor-pointer text-mshop-gray-80", children: "위 이용약관을 충분히 읽고 이해하였으며, 약관에 동의합니다." })
      ] })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.85714rem]", children: [
      /* @__PURE__ */ a.jsx(
        fn,
        {
          type: "button",
          variant: "md",
          theme: "line",
          widthFull: !0,
          onClick: t,
          children: "취소"
        }
      ),
      /* @__PURE__ */ a.jsx(
        fn,
        {
          type: "button",
          variant: "md",
          theme: "blue",
          widthFull: !0,
          disabled: !o,
          onClick: n,
          children: "후원 시작하기"
        }
      )
    ] })
  ] }) });
}
var $G = { exports: {} };
/**!
 * Sortable 1.15.3
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function AU(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xy(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? AU(Object(n), !0).forEach(function(r) {
      Eue(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : AU(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function n9(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n9 = function(t) {
    return typeof t;
  } : n9 = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, n9(e);
}
function Eue(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function k1() {
  return k1 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, k1.apply(this, arguments);
}
function kue(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), s, o;
  for (o = 0; o < r.length; o++)
    s = r[o], !(t.indexOf(s) >= 0) && (n[s] = e[s]);
  return n;
}
function _ue(e, t) {
  if (e == null) return {};
  var n = kue(e, t), r, s;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (s = 0; s < o.length; s++)
      r = o[s], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Tue(e) {
  return Mue(e) || Rue(e) || Due(e) || Pue();
}
function Mue(e) {
  if (Array.isArray(e)) return OD(e);
}
function Rue(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Due(e, t) {
  if (e) {
    if (typeof e == "string") return OD(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return OD(e, t);
  }
}
function OD(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Pue() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Oue = "1.15.3";
function Fv(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var Kv = Fv(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), o6 = Fv(/Edge/i), LU = Fv(/firefox/i), c3 = Fv(/safari/i) && !Fv(/chrome/i) && !Fv(/android/i), GG = Fv(/iP(ad|od|hone)/i), WG = Fv(/chrome/i) && Fv(/android/i), YG = {
  capture: !1,
  passive: !1
};
function Ya(e, t, n) {
  e.addEventListener(t, n, !Kv && YG);
}
function Ta(e, t, n) {
  e.removeEventListener(t, n, !Kv && YG);
}
function O9(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function qG(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function p1(e, t, n, r) {
  if (e) {
    n = n || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === n && O9(e, t) : O9(e, t)) || r && e === n)
        return e;
      if (e === n) break;
    } while (e = qG(e));
  }
  return null;
}
var IU = /\s+/g;
function rl(e, t, n) {
  if (e && t)
    if (e.classList)
      e.classList[n ? "add" : "remove"](t);
    else {
      var r = (" " + e.className + " ").replace(IU, " ").replace(" " + t + " ", " ");
      e.className = (r + (n ? " " + t : "")).replace(IU, " ");
    }
}
function Kn(e, t, n) {
  var r = e && e.style;
  if (r) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
    !(t in r) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), r[t] = n + (typeof n == "string" ? "" : "px");
  }
}
function L4(e, t) {
  var n = "";
  if (typeof e == "string")
    n = e;
  else
    do {
      var r = Kn(e, "transform");
      r && r !== "none" && (n = r + " " + n);
    } while (!t && (e = e.parentNode));
  var s = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return s && new s(n);
}
function KG(e, t, n) {
  if (e) {
    var r = e.getElementsByTagName(t), s = 0, o = r.length;
    if (n)
      for (; s < o; s++)
        n(r[s], s);
    return r;
  }
  return [];
}
function fy() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function mo(e, t, n, r, s) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var o, c, u, m, y, b, w;
    if (e !== window && e.parentNode && e !== fy() ? (o = e.getBoundingClientRect(), c = o.top, u = o.left, m = o.bottom, y = o.right, b = o.height, w = o.width) : (c = 0, u = 0, m = window.innerHeight, y = window.innerWidth, b = window.innerHeight, w = window.innerWidth), (t || n) && e !== window && (s = s || e.parentNode, !Kv))
      do
        if (s && s.getBoundingClientRect && (Kn(s, "transform") !== "none" || n && Kn(s, "position") !== "static")) {
          var k = s.getBoundingClientRect();
          c -= k.top + parseInt(Kn(s, "border-top-width")), u -= k.left + parseInt(Kn(s, "border-left-width")), m = c + o.height, y = u + o.width;
          break;
        }
      while (s = s.parentNode);
    if (r && e !== window) {
      var j = L4(s || e), E = j && j.a, T = j && j.d;
      j && (c /= T, u /= E, w /= E, b /= T, m = c + b, y = u + w);
    }
    return {
      top: c,
      left: u,
      bottom: m,
      right: y,
      width: w,
      height: b
    };
  }
}
function FU(e, t, n) {
  for (var r = T2(e, !0), s = mo(e)[t]; r; ) {
    var o = mo(r)[n], c = void 0;
    if (c = s >= o, !c) return r;
    if (r === fy()) break;
    r = T2(r, !1);
  }
  return !1;
}
function q8(e, t, n, r) {
  for (var s = 0, o = 0, c = e.children; o < c.length; ) {
    if (c[o].style.display !== "none" && c[o] !== Ur.ghost && (r || c[o] !== Ur.dragged) && p1(c[o], n.draggable, e, !1)) {
      if (s === t)
        return c[o];
      s++;
    }
    o++;
  }
  return null;
}
function GO(e, t) {
  for (var n = e.lastElementChild; n && (n === Ur.ghost || Kn(n, "display") === "none" || t && !O9(n, t)); )
    n = n.previousElementSibling;
  return n || null;
}
function Dl(e, t) {
  var n = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== Ur.clone && (!t || O9(e, t)) && n++;
  return n;
}
function UU(e) {
  var t = 0, n = 0, r = fy();
  if (e)
    do {
      var s = L4(e), o = s.a, c = s.d;
      t += e.scrollLeft * o, n += e.scrollTop * c;
    } while (e !== r && (e = e.parentNode));
  return [t, n];
}
function Aue(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n)) {
      for (var r in t)
        if (t.hasOwnProperty(r) && t[r] === e[n][r]) return Number(n);
    }
  return -1;
}
function T2(e, t) {
  if (!e || !e.getBoundingClientRect) return fy();
  var n = e, r = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var s = Kn(n);
      if (n.clientWidth < n.scrollWidth && (s.overflowX == "auto" || s.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (s.overflowY == "auto" || s.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body) return fy();
        if (r || t) return n;
        r = !0;
      }
    }
  while (n = n.parentNode);
  return fy();
}
function Lue(e, t) {
  if (e && t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
function WM(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var u3;
function XG(e, t) {
  return function() {
    if (!u3) {
      var n = arguments, r = this;
      n.length === 1 ? e.call(r, n[0]) : e.apply(r, n), u3 = setTimeout(function() {
        u3 = void 0;
      }, t);
    }
  };
}
function Iue() {
  clearTimeout(u3), u3 = void 0;
}
function QG(e, t, n) {
  e.scrollLeft += t, e.scrollTop += n;
}
function WO(e) {
  var t = window.Polymer, n = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
function zU(e, t) {
  Kn(e, "position", "absolute"), Kn(e, "top", t.top), Kn(e, "left", t.left), Kn(e, "width", t.width), Kn(e, "height", t.height);
}
function YM(e) {
  Kn(e, "position", ""), Kn(e, "top", ""), Kn(e, "left", ""), Kn(e, "width", ""), Kn(e, "height", "");
}
function ZG(e, t, n) {
  var r = {};
  return Array.from(e.children).forEach(function(s) {
    var o, c, u, m;
    if (!(!p1(s, t.draggable, e, !1) || s.animated || s === n)) {
      var y = mo(s);
      r.left = Math.min((o = r.left) !== null && o !== void 0 ? o : 1 / 0, y.left), r.top = Math.min((c = r.top) !== null && c !== void 0 ? c : 1 / 0, y.top), r.right = Math.max((u = r.right) !== null && u !== void 0 ? u : -1 / 0, y.right), r.bottom = Math.max((m = r.bottom) !== null && m !== void 0 ? m : -1 / 0, y.bottom);
    }
  }), r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
var Hd = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function Fue() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var r = [].slice.call(this.el.children);
        r.forEach(function(s) {
          if (!(Kn(s, "display") === "none" || s === Ur.ghost)) {
            e.push({
              target: s,
              rect: mo(s)
            });
            var o = xy({}, e[e.length - 1].rect);
            if (s.thisAnimationDuration) {
              var c = L4(s, !0);
              c && (o.top -= c.f, o.left -= c.e);
            }
            s.fromRect = o;
          }
        });
      }
    },
    addAnimationState: function(r) {
      e.push(r);
    },
    removeAnimationState: function(r) {
      e.splice(Aue(e, {
        target: r
      }), 1);
    },
    animateAll: function(r) {
      var s = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof r == "function" && r();
        return;
      }
      var o = !1, c = 0;
      e.forEach(function(u) {
        var m = 0, y = u.target, b = y.fromRect, w = mo(y), k = y.prevFromRect, j = y.prevToRect, E = u.rect, T = L4(y, !0);
        T && (w.top -= T.f, w.left -= T.e), y.toRect = w, y.thisAnimationDuration && WM(k, w) && !WM(b, w) && // Make sure animatingRect is on line between toRect & fromRect
        (E.top - w.top) / (E.left - w.left) === (b.top - w.top) / (b.left - w.left) && (m = zue(E, k, j, s.options)), WM(w, b) || (y.prevFromRect = b, y.prevToRect = w, m || (m = s.options.animation), s.animate(y, E, w, m)), m && (o = !0, c = Math.max(c, m), clearTimeout(y.animationResetTimer), y.animationResetTimer = setTimeout(function() {
          y.animationTime = 0, y.prevFromRect = null, y.fromRect = null, y.prevToRect = null, y.thisAnimationDuration = null;
        }, m), y.thisAnimationDuration = m);
      }), clearTimeout(t), o ? t = setTimeout(function() {
        typeof r == "function" && r();
      }, c) : typeof r == "function" && r(), e = [];
    },
    animate: function(r, s, o, c) {
      if (c) {
        Kn(r, "transition", ""), Kn(r, "transform", "");
        var u = L4(this.el), m = u && u.a, y = u && u.d, b = (s.left - o.left) / (m || 1), w = (s.top - o.top) / (y || 1);
        r.animatingX = !!b, r.animatingY = !!w, Kn(r, "transform", "translate3d(" + b + "px," + w + "px,0)"), this.forRepaintDummy = Uue(r), Kn(r, "transition", "transform " + c + "ms" + (this.options.easing ? " " + this.options.easing : "")), Kn(r, "transform", "translate3d(0,0,0)"), typeof r.animated == "number" && clearTimeout(r.animated), r.animated = setTimeout(function() {
          Kn(r, "transition", ""), Kn(r, "transform", ""), r.animated = !1, r.animatingX = !1, r.animatingY = !1;
        }, c);
      }
    }
  };
}
function Uue(e) {
  return e.offsetWidth;
}
function zue(e, t, n, r) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * r.animation;
}
var s8 = [], qM = {
  initializeByDefault: !0
}, l6 = {
  mount: function(t) {
    for (var n in qM)
      qM.hasOwnProperty(n) && !(n in t) && (t[n] = qM[n]);
    s8.forEach(function(r) {
      if (r.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), s8.push(t);
  },
  pluginEvent: function(t, n, r) {
    var s = this;
    this.eventCanceled = !1, r.cancel = function() {
      s.eventCanceled = !0;
    };
    var o = t + "Global";
    s8.forEach(function(c) {
      n[c.pluginName] && (n[c.pluginName][o] && n[c.pluginName][o](xy({
        sortable: n
      }, r)), n.options[c.pluginName] && n[c.pluginName][t] && n[c.pluginName][t](xy({
        sortable: n
      }, r)));
    });
  },
  initializePlugins: function(t, n, r, s) {
    s8.forEach(function(u) {
      var m = u.pluginName;
      if (!(!t.options[m] && !u.initializeByDefault)) {
        var y = new u(t, n, t.options);
        y.sortable = t, y.options = t.options, t[m] = y, k1(r, y.defaults);
      }
    });
    for (var o in t.options)
      if (t.options.hasOwnProperty(o)) {
        var c = this.modifyOption(t, o, t.options[o]);
        typeof c < "u" && (t.options[o] = c);
      }
  },
  getEventProperties: function(t, n) {
    var r = {};
    return s8.forEach(function(s) {
      typeof s.eventProperties == "function" && k1(r, s.eventProperties.call(n[s.pluginName], t));
    }), r;
  },
  modifyOption: function(t, n, r) {
    var s;
    return s8.forEach(function(o) {
      t[o.pluginName] && o.optionListeners && typeof o.optionListeners[n] == "function" && (s = o.optionListeners[n].call(t[o.pluginName], r));
    }), s;
  }
};
function X7(e) {
  var t = e.sortable, n = e.rootEl, r = e.name, s = e.targetEl, o = e.cloneEl, c = e.toEl, u = e.fromEl, m = e.oldIndex, y = e.newIndex, b = e.oldDraggableIndex, w = e.newDraggableIndex, k = e.originalEvent, j = e.putSortable, E = e.extraEventProperties;
  if (t = t || n && n[Hd], !!t) {
    var T, D = t.options, L = "on" + r.charAt(0).toUpperCase() + r.substr(1);
    window.CustomEvent && !Kv && !o6 ? T = new CustomEvent(r, {
      bubbles: !0,
      cancelable: !0
    }) : (T = document.createEvent("Event"), T.initEvent(r, !0, !0)), T.to = c || n, T.from = u || n, T.item = s || n, T.clone = o, T.oldIndex = m, T.newIndex = y, T.oldDraggableIndex = b, T.newDraggableIndex = w, T.originalEvent = k, T.pullMode = j ? j.lastPutMode : void 0;
    var I = xy(xy({}, E), l6.getEventProperties(r, t));
    for (var R in I)
      T[R] = I[R];
    n && n.dispatchEvent(T), D[L] && D[L].call(t, T);
  }
}
var Bue = ["evt"], ih = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = r.evt, o = _ue(r, Bue);
  l6.pluginEvent.bind(Ur)(t, n, xy({
    dragEl: un,
    parentEl: Ml,
    ghostEl: Jr,
    rootEl: Eo,
    nextEl: E4,
    lastDownEl: r9,
    cloneEl: tl,
    cloneHidden: C2,
    dragStarted: Q7,
    putSortable: Fd,
    activeSortable: Ur.active,
    originalEvent: s,
    oldIndex: j8,
    oldDraggableIndex: d3,
    newIndex: cp,
    newDraggableIndex: b2,
    hideGhostForTarget: nW,
    unhideGhostForTarget: rW,
    cloneNowHidden: function() {
      C2 = !0;
    },
    cloneNowShown: function() {
      C2 = !1;
    },
    dispatchSortableEvent: function(u) {
      dm({
        sortable: n,
        name: u,
        originalEvent: s
      });
    }
  }, o));
};
function dm(e) {
  X7(xy({
    putSortable: Fd,
    cloneEl: tl,
    targetEl: un,
    rootEl: Eo,
    oldIndex: j8,
    oldDraggableIndex: d3,
    newIndex: cp,
    newDraggableIndex: b2
  }, e));
}
var un, Ml, Jr, Eo, E4, r9, tl, C2, j8, cp, d3, b2, Cj, Fd, S8 = !1, A9 = !1, L9 = [], w4, Ug, KM, XM, BU, HU, Q7, i8, f3, m3 = !1, Nj = !1, a9, xf, QM = [], AD = !1, I9 = [], qE = typeof document < "u", jj = GG, VU = o6 || Kv ? "cssFloat" : "float", Hue = qE && !WG && !GG && "draggable" in document.createElement("div"), JG = function() {
  if (qE) {
    if (Kv)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), eW = function(t, n) {
  var r = Kn(t), s = parseInt(r.width) - parseInt(r.paddingLeft) - parseInt(r.paddingRight) - parseInt(r.borderLeftWidth) - parseInt(r.borderRightWidth), o = q8(t, 0, n), c = q8(t, 1, n), u = o && Kn(o), m = c && Kn(c), y = u && parseInt(u.marginLeft) + parseInt(u.marginRight) + mo(o).width, b = m && parseInt(m.marginLeft) + parseInt(m.marginRight) + mo(c).width;
  if (r.display === "flex")
    return r.flexDirection === "column" || r.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (r.display === "grid")
    return r.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (o && u.float && u.float !== "none") {
    var w = u.float === "left" ? "left" : "right";
    return c && (m.clear === "both" || m.clear === w) ? "vertical" : "horizontal";
  }
  return o && (u.display === "block" || u.display === "flex" || u.display === "table" || u.display === "grid" || y >= s && r[VU] === "none" || c && r[VU] === "none" && y + b > s) ? "vertical" : "horizontal";
}, Vue = function(t, n, r) {
  var s = r ? t.left : t.top, o = r ? t.right : t.bottom, c = r ? t.width : t.height, u = r ? n.left : n.top, m = r ? n.right : n.bottom, y = r ? n.width : n.height;
  return s === u || o === m || s + c / 2 === u + y / 2;
}, $ue = function(t, n) {
  var r;
  return L9.some(function(s) {
    var o = s[Hd].options.emptyInsertThreshold;
    if (!(!o || GO(s))) {
      var c = mo(s), u = t >= c.left - o && t <= c.right + o, m = n >= c.top - o && n <= c.bottom + o;
      if (u && m)
        return r = s;
    }
  }), r;
}, tW = function(t) {
  function n(o, c) {
    return function(u, m, y, b) {
      var w = u.options.group.name && m.options.group.name && u.options.group.name === m.options.group.name;
      if (o == null && (c || w))
        return !0;
      if (o == null || o === !1)
        return !1;
      if (c && o === "clone")
        return o;
      if (typeof o == "function")
        return n(o(u, m, y, b), c)(u, m, y, b);
      var k = (c ? u : m).options.group.name;
      return o === !0 || typeof o == "string" && o === k || o.join && o.indexOf(k) > -1;
    };
  }
  var r = {}, s = t.group;
  (!s || n9(s) != "object") && (s = {
    name: s
  }), r.name = s.name, r.checkPull = n(s.pull, !0), r.checkPut = n(s.put), r.revertClone = s.revertClone, t.group = r;
}, nW = function() {
  !JG && Jr && Kn(Jr, "display", "none");
}, rW = function() {
  !JG && Jr && Kn(Jr, "display", "");
};
qE && !WG && document.addEventListener("click", function(e) {
  if (A9)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), A9 = !1, !1;
}, !0);
var C4 = function(t) {
  if (un) {
    t = t.touches ? t.touches[0] : t;
    var n = $ue(t.clientX, t.clientY);
    if (n) {
      var r = {};
      for (var s in t)
        t.hasOwnProperty(s) && (r[s] = t[s]);
      r.target = r.rootEl = n, r.preventDefault = void 0, r.stopPropagation = void 0, n[Hd]._onDragOver(r);
    }
  }
}, Gue = function(t) {
  un && un.parentNode[Hd]._isOutsideThisEl(t.target);
};
function Ur(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = k1({}, t), e[Hd] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return eW(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(c, u) {
      c.setData("Text", u.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Ur.supportPointer !== !1 && "PointerEvent" in window && !c3,
    emptyInsertThreshold: 5
  };
  l6.initializePlugins(this, e, n);
  for (var r in n)
    !(r in t) && (t[r] = n[r]);
  tW(t);
  for (var s in this)
    s.charAt(0) === "_" && typeof this[s] == "function" && (this[s] = this[s].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : Hue, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? Ya(e, "pointerdown", this._onTapStart) : (Ya(e, "mousedown", this._onTapStart), Ya(e, "touchstart", this._onTapStart)), this.nativeDraggable && (Ya(e, "dragover", this), Ya(e, "dragenter", this)), L9.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), k1(this, Fue());
}
Ur.prototype = /** @lends Sortable.prototype */
{
  constructor: Ur,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (i8 = null);
  },
  _getDirection: function(t, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, n, un) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var n = this, r = this.el, s = this.options, o = s.preventOnFilter, c = t.type, u = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, m = (u || t).target, y = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || m, b = s.filter;
      if (Jue(r), !un && !(/mousedown|pointerdown/.test(c) && t.button !== 0 || s.disabled) && !y.isContentEditable && !(!this.nativeDraggable && c3 && m && m.tagName.toUpperCase() === "SELECT") && (m = p1(m, s.draggable, r, !1), !(m && m.animated) && r9 !== m)) {
        if (j8 = Dl(m), d3 = Dl(m, s.draggable), typeof b == "function") {
          if (b.call(this, t, m, this)) {
            dm({
              sortable: n,
              rootEl: y,
              name: "filter",
              targetEl: m,
              toEl: r,
              fromEl: r
            }), ih("filter", n, {
              evt: t
            }), o && t.cancelable && t.preventDefault();
            return;
          }
        } else if (b && (b = b.split(",").some(function(w) {
          if (w = p1(y, w.trim(), r, !1), w)
            return dm({
              sortable: n,
              rootEl: w,
              name: "filter",
              targetEl: m,
              fromEl: r,
              toEl: r
            }), ih("filter", n, {
              evt: t
            }), !0;
        }), b)) {
          o && t.cancelable && t.preventDefault();
          return;
        }
        s.handle && !p1(y, s.handle, r, !1) || this._prepareDragStart(t, u, m);
      }
    }
  },
  _prepareDragStart: function(t, n, r) {
    var s = this, o = s.el, c = s.options, u = o.ownerDocument, m;
    if (r && !un && r.parentNode === o) {
      var y = mo(r);
      if (Eo = o, un = r, Ml = un.parentNode, E4 = un.nextSibling, r9 = r, Cj = c.group, Ur.dragged = un, w4 = {
        target: un,
        clientX: (n || t).clientX,
        clientY: (n || t).clientY
      }, BU = w4.clientX - y.left, HU = w4.clientY - y.top, this._lastX = (n || t).clientX, this._lastY = (n || t).clientY, un.style["will-change"] = "all", m = function() {
        if (ih("delayEnded", s, {
          evt: t
        }), Ur.eventCanceled) {
          s._onDrop();
          return;
        }
        s._disableDelayedDragEvents(), !LU && s.nativeDraggable && (un.draggable = !0), s._triggerDragStart(t, n), dm({
          sortable: s,
          name: "choose",
          originalEvent: t
        }), rl(un, c.chosenClass, !0);
      }, c.ignore.split(",").forEach(function(b) {
        KG(un, b.trim(), ZM);
      }), Ya(u, "dragover", C4), Ya(u, "mousemove", C4), Ya(u, "touchmove", C4), Ya(u, "mouseup", s._onDrop), Ya(u, "touchend", s._onDrop), Ya(u, "touchcancel", s._onDrop), LU && this.nativeDraggable && (this.options.touchStartThreshold = 4, un.draggable = !0), ih("delayStart", this, {
        evt: t
      }), c.delay && (!c.delayOnTouchOnly || n) && (!this.nativeDraggable || !(o6 || Kv))) {
        if (Ur.eventCanceled) {
          this._onDrop();
          return;
        }
        Ya(u, "mouseup", s._disableDelayedDrag), Ya(u, "touchend", s._disableDelayedDrag), Ya(u, "touchcancel", s._disableDelayedDrag), Ya(u, "mousemove", s._delayedDragTouchMoveHandler), Ya(u, "touchmove", s._delayedDragTouchMoveHandler), c.supportPointer && Ya(u, "pointermove", s._delayedDragTouchMoveHandler), s._dragStartTimer = setTimeout(m, c.delay);
      } else
        m();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var n = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    un && ZM(un), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    Ta(t, "mouseup", this._disableDelayedDrag), Ta(t, "touchend", this._disableDelayedDrag), Ta(t, "touchcancel", this._disableDelayedDrag), Ta(t, "mousemove", this._delayedDragTouchMoveHandler), Ta(t, "touchmove", this._delayedDragTouchMoveHandler), Ta(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, n) {
    n = n || t.pointerType == "touch" && t, !this.nativeDraggable || n ? this.options.supportPointer ? Ya(document, "pointermove", this._onTouchMove) : n ? Ya(document, "touchmove", this._onTouchMove) : Ya(document, "mousemove", this._onTouchMove) : (Ya(un, "dragend", this), Ya(Eo, "dragstart", this._onDragStart));
    try {
      document.selection ? s9(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, n) {
    if (S8 = !1, Eo && un) {
      ih("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && Ya(document, "dragover", Gue);
      var r = this.options;
      !t && rl(un, r.dragClass, !1), rl(un, r.ghostClass, !0), Ur.active = this, t && this._appendGhost(), dm({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (Ug) {
      this._lastX = Ug.clientX, this._lastY = Ug.clientY, nW();
      for (var t = document.elementFromPoint(Ug.clientX, Ug.clientY), n = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(Ug.clientX, Ug.clientY), t !== n); )
        n = t;
      if (un.parentNode[Hd]._isOutsideThisEl(t), n)
        do {
          if (n[Hd]) {
            var r = void 0;
            if (r = n[Hd]._onDragOver({
              clientX: Ug.clientX,
              clientY: Ug.clientY,
              target: t,
              rootEl: n
            }), r && !this.options.dragoverBubble)
              break;
          }
          t = n;
        } while (n = qG(n));
      rW();
    }
  },
  _onTouchMove: function(t) {
    if (w4) {
      var n = this.options, r = n.fallbackTolerance, s = n.fallbackOffset, o = t.touches ? t.touches[0] : t, c = Jr && L4(Jr, !0), u = Jr && c && c.a, m = Jr && c && c.d, y = jj && xf && UU(xf), b = (o.clientX - w4.clientX + s.x) / (u || 1) + (y ? y[0] - QM[0] : 0) / (u || 1), w = (o.clientY - w4.clientY + s.y) / (m || 1) + (y ? y[1] - QM[1] : 0) / (m || 1);
      if (!Ur.active && !S8) {
        if (r && Math.max(Math.abs(o.clientX - this._lastX), Math.abs(o.clientY - this._lastY)) < r)
          return;
        this._onDragStart(t, !0);
      }
      if (Jr) {
        c ? (c.e += b - (KM || 0), c.f += w - (XM || 0)) : c = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: b,
          f: w
        };
        var k = "matrix(".concat(c.a, ",").concat(c.b, ",").concat(c.c, ",").concat(c.d, ",").concat(c.e, ",").concat(c.f, ")");
        Kn(Jr, "webkitTransform", k), Kn(Jr, "mozTransform", k), Kn(Jr, "msTransform", k), Kn(Jr, "transform", k), KM = b, XM = w, Ug = o;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!Jr) {
      var t = this.options.fallbackOnBody ? document.body : Eo, n = mo(un, !0, jj, !0, t), r = this.options;
      if (jj) {
        for (xf = t; Kn(xf, "position") === "static" && Kn(xf, "transform") === "none" && xf !== document; )
          xf = xf.parentNode;
        xf !== document.body && xf !== document.documentElement ? (xf === document && (xf = fy()), n.top += xf.scrollTop, n.left += xf.scrollLeft) : xf = fy(), QM = UU(xf);
      }
      Jr = un.cloneNode(!0), rl(Jr, r.ghostClass, !1), rl(Jr, r.fallbackClass, !0), rl(Jr, r.dragClass, !0), Kn(Jr, "transition", ""), Kn(Jr, "transform", ""), Kn(Jr, "box-sizing", "border-box"), Kn(Jr, "margin", 0), Kn(Jr, "top", n.top), Kn(Jr, "left", n.left), Kn(Jr, "width", n.width), Kn(Jr, "height", n.height), Kn(Jr, "opacity", "0.8"), Kn(Jr, "position", jj ? "absolute" : "fixed"), Kn(Jr, "zIndex", "100000"), Kn(Jr, "pointerEvents", "none"), Ur.ghost = Jr, t.appendChild(Jr), Kn(Jr, "transform-origin", BU / parseInt(Jr.style.width) * 100 + "% " + HU / parseInt(Jr.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, n) {
    var r = this, s = t.dataTransfer, o = r.options;
    if (ih("dragStart", this, {
      evt: t
    }), Ur.eventCanceled) {
      this._onDrop();
      return;
    }
    ih("setupClone", this), Ur.eventCanceled || (tl = WO(un), tl.removeAttribute("id"), tl.draggable = !1, tl.style["will-change"] = "", this._hideClone(), rl(tl, this.options.chosenClass, !1), Ur.clone = tl), r.cloneId = s9(function() {
      ih("clone", r), !Ur.eventCanceled && (r.options.removeCloneOnHide || Eo.insertBefore(tl, un), r._hideClone(), dm({
        sortable: r,
        name: "clone"
      }));
    }), !n && rl(un, o.dragClass, !0), n ? (A9 = !0, r._loopId = setInterval(r._emulateDragOver, 50)) : (Ta(document, "mouseup", r._onDrop), Ta(document, "touchend", r._onDrop), Ta(document, "touchcancel", r._onDrop), s && (s.effectAllowed = "move", o.setData && o.setData.call(r, s, un)), Ya(document, "drop", r), Kn(un, "transform", "translateZ(0)")), S8 = !0, r._dragStartId = s9(r._dragStarted.bind(r, n, t)), Ya(document, "selectstart", r), Q7 = !0, c3 && Kn(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var n = this.el, r = t.target, s, o, c, u = this.options, m = u.group, y = Ur.active, b = Cj === m, w = u.sort, k = Fd || y, j, E = this, T = !1;
    if (AD) return;
    function D(oe, ue) {
      ih(oe, E, xy({
        evt: t,
        isOwner: b,
        axis: j ? "vertical" : "horizontal",
        revert: c,
        dragRect: s,
        targetRect: o,
        canSort: w,
        fromSortable: k,
        target: r,
        completed: I,
        onMove: function(ve, Te) {
          return Ej(Eo, n, un, s, ve, mo(ve), t, Te);
        },
        changed: R
      }, ue));
    }
    function L() {
      D("dragOverAnimationCapture"), E.captureAnimationState(), E !== k && k.captureAnimationState();
    }
    function I(oe) {
      return D("dragOverCompleted", {
        insertion: oe
      }), oe && (b ? y._hideClone() : y._showClone(E), E !== k && (rl(un, Fd ? Fd.options.ghostClass : y.options.ghostClass, !1), rl(un, u.ghostClass, !0)), Fd !== E && E !== Ur.active ? Fd = E : E === Ur.active && Fd && (Fd = null), k === E && (E._ignoreWhileAnimating = r), E.animateAll(function() {
        D("dragOverAnimationComplete"), E._ignoreWhileAnimating = null;
      }), E !== k && (k.animateAll(), k._ignoreWhileAnimating = null)), (r === un && !un.animated || r === n && !r.animated) && (i8 = null), !u.dragoverBubble && !t.rootEl && r !== document && (un.parentNode[Hd]._isOutsideThisEl(t.target), !oe && C4(t)), !u.dragoverBubble && t.stopPropagation && t.stopPropagation(), T = !0;
    }
    function R() {
      cp = Dl(un), b2 = Dl(un, u.draggable), dm({
        sortable: E,
        name: "change",
        toEl: n,
        newIndex: cp,
        newDraggableIndex: b2,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), r = p1(r, u.draggable, n, !0), D("dragOver"), Ur.eventCanceled) return T;
    if (un.contains(t.target) || r.animated && r.animatingX && r.animatingY || E._ignoreWhileAnimating === r)
      return I(!1);
    if (A9 = !1, y && !u.disabled && (b ? w || (c = Ml !== Eo) : Fd === this || (this.lastPutMode = Cj.checkPull(this, y, un, t)) && m.checkPut(this, y, un, t))) {
      if (j = this._getDirection(t, r) === "vertical", s = mo(un), D("dragOverValid"), Ur.eventCanceled) return T;
      if (c)
        return Ml = Eo, L(), this._hideClone(), D("revert"), Ur.eventCanceled || (E4 ? Eo.insertBefore(un, E4) : Eo.appendChild(un)), I(!0);
      var U = GO(n, u.draggable);
      if (!U || Kue(t, j, this) && !U.animated) {
        if (U === un)
          return I(!1);
        if (U && n === t.target && (r = U), r && (o = mo(r)), Ej(Eo, n, un, s, r, o, t, !!r) !== !1)
          return L(), U && U.nextSibling ? n.insertBefore(un, U.nextSibling) : n.appendChild(un), Ml = n, R(), I(!0);
      } else if (U && que(t, j, this)) {
        var z = q8(n, 0, u, !0);
        if (z === un)
          return I(!1);
        if (r = z, o = mo(r), Ej(Eo, n, un, s, r, o, t, !1) !== !1)
          return L(), n.insertBefore(un, z), Ml = n, R(), I(!0);
      } else if (r.parentNode === n) {
        o = mo(r);
        var H = 0, K, q = un.parentNode !== n, Q = !Vue(un.animated && un.toRect || s, r.animated && r.toRect || o, j), Z = j ? "top" : "left", X = FU(r, "top", "top") || FU(un, "top", "top"), se = X ? X.scrollTop : void 0;
        i8 !== r && (K = o[Z], m3 = !1, Nj = !Q && u.invertSwap || q), H = Xue(t, r, o, j, Q ? 1 : u.swapThreshold, u.invertedSwapThreshold == null ? u.swapThreshold : u.invertedSwapThreshold, Nj, i8 === r);
        var te;
        if (H !== 0) {
          var fe = Dl(un);
          do
            fe -= H, te = Ml.children[fe];
          while (te && (Kn(te, "display") === "none" || te === Jr));
        }
        if (H === 0 || te === r)
          return I(!1);
        i8 = r, f3 = H;
        var ce = r.nextElementSibling, pe = !1;
        pe = H === 1;
        var Se = Ej(Eo, n, un, s, r, o, t, pe);
        if (Se !== !1)
          return (Se === 1 || Se === -1) && (pe = Se === 1), AD = !0, setTimeout(Yue, 30), L(), pe && !ce ? n.appendChild(un) : r.parentNode.insertBefore(un, pe ? ce : r), X && QG(X, 0, se - X.scrollTop), Ml = un.parentNode, K !== void 0 && !Nj && (a9 = Math.abs(K - mo(r)[Z])), R(), I(!0);
      }
      if (n.contains(un))
        return I(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    Ta(document, "mousemove", this._onTouchMove), Ta(document, "touchmove", this._onTouchMove), Ta(document, "pointermove", this._onTouchMove), Ta(document, "dragover", C4), Ta(document, "mousemove", C4), Ta(document, "touchmove", C4);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    Ta(t, "mouseup", this._onDrop), Ta(t, "touchend", this._onDrop), Ta(t, "pointerup", this._onDrop), Ta(t, "touchcancel", this._onDrop), Ta(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var n = this.el, r = this.options;
    if (cp = Dl(un), b2 = Dl(un, r.draggable), ih("drop", this, {
      evt: t
    }), Ml = un && un.parentNode, cp = Dl(un), b2 = Dl(un, r.draggable), Ur.eventCanceled) {
      this._nulling();
      return;
    }
    S8 = !1, Nj = !1, m3 = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), LD(this.cloneId), LD(this._dragStartId), this.nativeDraggable && (Ta(document, "drop", this), Ta(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), c3 && Kn(document.body, "user-select", ""), Kn(un, "transform", ""), t && (Q7 && (t.cancelable && t.preventDefault(), !r.dropBubble && t.stopPropagation()), Jr && Jr.parentNode && Jr.parentNode.removeChild(Jr), (Eo === Ml || Fd && Fd.lastPutMode !== "clone") && tl && tl.parentNode && tl.parentNode.removeChild(tl), un && (this.nativeDraggable && Ta(un, "dragend", this), ZM(un), un.style["will-change"] = "", Q7 && !S8 && rl(un, Fd ? Fd.options.ghostClass : this.options.ghostClass, !1), rl(un, this.options.chosenClass, !1), dm({
      sortable: this,
      name: "unchoose",
      toEl: Ml,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), Eo !== Ml ? (cp >= 0 && (dm({
      rootEl: Ml,
      name: "add",
      toEl: Ml,
      fromEl: Eo,
      originalEvent: t
    }), dm({
      sortable: this,
      name: "remove",
      toEl: Ml,
      originalEvent: t
    }), dm({
      rootEl: Ml,
      name: "sort",
      toEl: Ml,
      fromEl: Eo,
      originalEvent: t
    }), dm({
      sortable: this,
      name: "sort",
      toEl: Ml,
      originalEvent: t
    })), Fd && Fd.save()) : cp !== j8 && cp >= 0 && (dm({
      sortable: this,
      name: "update",
      toEl: Ml,
      originalEvent: t
    }), dm({
      sortable: this,
      name: "sort",
      toEl: Ml,
      originalEvent: t
    })), Ur.active && ((cp == null || cp === -1) && (cp = j8, b2 = d3), dm({
      sortable: this,
      name: "end",
      toEl: Ml,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    ih("nulling", this), Eo = un = Ml = Jr = E4 = tl = r9 = C2 = w4 = Ug = Q7 = cp = b2 = j8 = d3 = i8 = f3 = Fd = Cj = Ur.dragged = Ur.ghost = Ur.clone = Ur.active = null, I9.forEach(function(t) {
      t.checked = !0;
    }), I9.length = KM = XM = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        un && (this._onDragOver(t), Wue(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], n, r = this.el.children, s = 0, o = r.length, c = this.options; s < o; s++)
      n = r[s], p1(n, c.draggable, this.el, !1) && t.push(n.getAttribute(c.dataIdAttr) || Zue(n));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t, n) {
    var r = {}, s = this.el;
    this.toArray().forEach(function(o, c) {
      var u = s.children[c];
      p1(u, this.options.draggable, s, !1) && (r[o] = u);
    }, this), n && this.captureAnimationState(), t.forEach(function(o) {
      r[o] && (s.removeChild(r[o]), s.appendChild(r[o]));
    }), n && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, n) {
    return p1(t, n || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, n) {
    var r = this.options;
    if (n === void 0)
      return r[t];
    var s = l6.modifyOption(this, t, n);
    typeof s < "u" ? r[t] = s : r[t] = n, t === "group" && tW(r);
  },
  /**
   * Destroy
   */
  destroy: function() {
    ih("destroy", this);
    var t = this.el;
    t[Hd] = null, Ta(t, "mousedown", this._onTapStart), Ta(t, "touchstart", this._onTapStart), Ta(t, "pointerdown", this._onTapStart), this.nativeDraggable && (Ta(t, "dragover", this), Ta(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), L9.splice(L9.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!C2) {
      if (ih("hideClone", this), Ur.eventCanceled) return;
      Kn(tl, "display", "none"), this.options.removeCloneOnHide && tl.parentNode && tl.parentNode.removeChild(tl), C2 = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (C2) {
      if (ih("showClone", this), Ur.eventCanceled) return;
      un.parentNode == Eo && !this.options.group.revertClone ? Eo.insertBefore(tl, un) : E4 ? Eo.insertBefore(tl, E4) : Eo.appendChild(tl), this.options.group.revertClone && this.animate(un, tl), Kn(tl, "display", ""), C2 = !1;
    }
  }
};
function Wue(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function Ej(e, t, n, r, s, o, c, u) {
  var m, y = e[Hd], b = y.options.onMove, w;
  return window.CustomEvent && !Kv && !o6 ? m = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (m = document.createEvent("Event"), m.initEvent("move", !0, !0)), m.to = t, m.from = e, m.dragged = n, m.draggedRect = r, m.related = s || t, m.relatedRect = o || mo(t), m.willInsertAfter = u, m.originalEvent = c, e.dispatchEvent(m), b && (w = b.call(y, m, c)), w;
}
function ZM(e) {
  e.draggable = !1;
}
function Yue() {
  AD = !1;
}
function que(e, t, n) {
  var r = mo(q8(n.el, 0, n.options, !0)), s = ZG(n.el, n.options, Jr), o = 10;
  return t ? e.clientX < s.left - o || e.clientY < r.top && e.clientX < r.right : e.clientY < s.top - o || e.clientY < r.bottom && e.clientX < r.left;
}
function Kue(e, t, n) {
  var r = mo(GO(n.el, n.options.draggable)), s = ZG(n.el, n.options, Jr), o = 10;
  return t ? e.clientX > s.right + o || e.clientY > r.bottom && e.clientX > r.left : e.clientY > s.bottom + o || e.clientX > r.right && e.clientY > r.top;
}
function Xue(e, t, n, r, s, o, c, u) {
  var m = r ? e.clientY : e.clientX, y = r ? n.height : n.width, b = r ? n.top : n.left, w = r ? n.bottom : n.right, k = !1;
  if (!c) {
    if (u && a9 < y * s) {
      if (!m3 && (f3 === 1 ? m > b + y * o / 2 : m < w - y * o / 2) && (m3 = !0), m3)
        k = !0;
      else if (f3 === 1 ? m < b + a9 : m > w - a9)
        return -f3;
    } else if (m > b + y * (1 - s) / 2 && m < w - y * (1 - s) / 2)
      return Que(t);
  }
  return k = k || c, k && (m < b + y * o / 2 || m > w - y * o / 2) ? m > b + y / 2 ? 1 : -1 : 0;
}
function Que(e) {
  return Dl(un) < Dl(e) ? 1 : -1;
}
function Zue(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, r = 0; n--; )
    r += t.charCodeAt(n);
  return r.toString(36);
}
function Jue(e) {
  I9.length = 0;
  for (var t = e.getElementsByTagName("input"), n = t.length; n--; ) {
    var r = t[n];
    r.checked && I9.push(r);
  }
}
function s9(e) {
  return setTimeout(e, 0);
}
function LD(e) {
  return clearTimeout(e);
}
qE && Ya(document, "touchmove", function(e) {
  (Ur.active || S8) && e.cancelable && e.preventDefault();
});
Ur.utils = {
  on: Ya,
  off: Ta,
  css: Kn,
  find: KG,
  is: function(t, n) {
    return !!p1(t, n, t, !1);
  },
  extend: Lue,
  throttle: XG,
  closest: p1,
  toggleClass: rl,
  clone: WO,
  index: Dl,
  nextTick: s9,
  cancelNextTick: LD,
  detectDirection: eW,
  getChild: q8,
  expando: Hd
};
Ur.get = function(e) {
  return e[Hd];
};
Ur.mount = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(r) {
    if (!r.prototype || !r.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(r));
    r.utils && (Ur.utils = xy(xy({}, Ur.utils), r.utils)), l6.mount(r);
  });
};
Ur.create = function(e, t) {
  return new Ur(e, t);
};
Ur.version = Oue;
var Ec = [], Z7, ID, FD = !1, JM, eR, F9, J7;
function ede() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(n) {
      var r = n.originalEvent;
      this.sortable.nativeDraggable ? Ya(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? Ya(document, "pointermove", this._handleFallbackAutoScroll) : r.touches ? Ya(document, "touchmove", this._handleFallbackAutoScroll) : Ya(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var r = n.originalEvent;
      !this.options.dragOverBubble && !r.rootEl && this._handleAutoScroll(r);
    },
    drop: function() {
      this.sortable.nativeDraggable ? Ta(document, "dragover", this._handleAutoScroll) : (Ta(document, "pointermove", this._handleFallbackAutoScroll), Ta(document, "touchmove", this._handleFallbackAutoScroll), Ta(document, "mousemove", this._handleFallbackAutoScroll)), $U(), i9(), Iue();
    },
    nulling: function() {
      F9 = ID = Z7 = FD = J7 = JM = eR = null, Ec.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, !0);
    },
    _handleAutoScroll: function(n, r) {
      var s = this, o = (n.touches ? n.touches[0] : n).clientX, c = (n.touches ? n.touches[0] : n).clientY, u = document.elementFromPoint(o, c);
      if (F9 = n, r || this.options.forceAutoScrollFallback || o6 || Kv || c3) {
        tR(n, this.options, u, r);
        var m = T2(u, !0);
        FD && (!J7 || o !== JM || c !== eR) && (J7 && $U(), J7 = setInterval(function() {
          var y = T2(document.elementFromPoint(o, c), !0);
          y !== m && (m = y, i9()), tR(n, s.options, y, r);
        }, 10), JM = o, eR = c);
      } else {
        if (!this.options.bubbleScroll || T2(u, !0) === fy()) {
          i9();
          return;
        }
        tR(n, this.options, T2(u, !1), !1);
      }
    }
  }, k1(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function i9() {
  Ec.forEach(function(e) {
    clearInterval(e.pid);
  }), Ec = [];
}
function $U() {
  clearInterval(J7);
}
var tR = XG(function(e, t, n, r) {
  if (t.scroll) {
    var s = (e.touches ? e.touches[0] : e).clientX, o = (e.touches ? e.touches[0] : e).clientY, c = t.scrollSensitivity, u = t.scrollSpeed, m = fy(), y = !1, b;
    ID !== n && (ID = n, i9(), Z7 = t.scroll, b = t.scrollFn, Z7 === !0 && (Z7 = T2(n, !0)));
    var w = 0, k = Z7;
    do {
      var j = k, E = mo(j), T = E.top, D = E.bottom, L = E.left, I = E.right, R = E.width, U = E.height, z = void 0, H = void 0, K = j.scrollWidth, q = j.scrollHeight, Q = Kn(j), Z = j.scrollLeft, X = j.scrollTop;
      j === m ? (z = R < K && (Q.overflowX === "auto" || Q.overflowX === "scroll" || Q.overflowX === "visible"), H = U < q && (Q.overflowY === "auto" || Q.overflowY === "scroll" || Q.overflowY === "visible")) : (z = R < K && (Q.overflowX === "auto" || Q.overflowX === "scroll"), H = U < q && (Q.overflowY === "auto" || Q.overflowY === "scroll"));
      var se = z && (Math.abs(I - s) <= c && Z + R < K) - (Math.abs(L - s) <= c && !!Z), te = H && (Math.abs(D - o) <= c && X + U < q) - (Math.abs(T - o) <= c && !!X);
      if (!Ec[w])
        for (var fe = 0; fe <= w; fe++)
          Ec[fe] || (Ec[fe] = {});
      (Ec[w].vx != se || Ec[w].vy != te || Ec[w].el !== j) && (Ec[w].el = j, Ec[w].vx = se, Ec[w].vy = te, clearInterval(Ec[w].pid), (se != 0 || te != 0) && (y = !0, Ec[w].pid = setInterval((function() {
        r && this.layer === 0 && Ur.active._onTouchMove(F9);
        var ce = Ec[this.layer].vy ? Ec[this.layer].vy * u : 0, pe = Ec[this.layer].vx ? Ec[this.layer].vx * u : 0;
        typeof b == "function" && b.call(Ur.dragged.parentNode[Hd], pe, ce, e, F9, Ec[this.layer].el) !== "continue" || QG(Ec[this.layer].el, pe, ce);
      }).bind({
        layer: w
      }), 24))), w++;
    } while (t.bubbleScroll && k !== m && (k = T2(k, !1)));
    FD = y;
  }
}, 30), aW = function(t) {
  var n = t.originalEvent, r = t.putSortable, s = t.dragEl, o = t.activeSortable, c = t.dispatchSortableEvent, u = t.hideGhostForTarget, m = t.unhideGhostForTarget;
  if (n) {
    var y = r || o;
    u();
    var b = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, w = document.elementFromPoint(b.clientX, b.clientY);
    m(), y && !y.el.contains(w) && (c("spill"), this.onSpill({
      dragEl: s,
      putSortable: r
    }));
  }
};
function YO() {
}
YO.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var n = t.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable;
    this.sortable.captureAnimationState(), r && r.captureAnimationState();
    var s = q8(this.sortable.el, this.startIndex, this.options);
    s ? this.sortable.el.insertBefore(n, s) : this.sortable.el.appendChild(n), this.sortable.animateAll(), r && r.animateAll();
  },
  drop: aW
};
k1(YO, {
  pluginName: "revertOnSpill"
});
function qO() {
}
qO.prototype = {
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable, s = r || this.sortable;
    s.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), s.animateAll();
  },
  drop: aW
};
k1(qO, {
  pluginName: "removeOnSpill"
});
var f1;
function tde() {
  function e() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  return e.prototype = {
    dragStart: function(n) {
      var r = n.dragEl;
      f1 = r;
    },
    dragOverValid: function(n) {
      var r = n.completed, s = n.target, o = n.onMove, c = n.activeSortable, u = n.changed, m = n.cancel;
      if (c.options.swap) {
        var y = this.sortable.el, b = this.options;
        if (s && s !== y) {
          var w = f1;
          o(s) !== !1 ? (rl(s, b.swapClass, !0), f1 = s) : f1 = null, w && w !== f1 && rl(w, b.swapClass, !1);
        }
        u(), r(!0), m();
      }
    },
    drop: function(n) {
      var r = n.activeSortable, s = n.putSortable, o = n.dragEl, c = s || this.sortable, u = this.options;
      f1 && rl(f1, u.swapClass, !1), f1 && (u.swap || s && s.options.swap) && o !== f1 && (c.captureAnimationState(), c !== r && r.captureAnimationState(), nde(o, f1), c.animateAll(), c !== r && r.animateAll());
    },
    nulling: function() {
      f1 = null;
    }
  }, k1(e, {
    pluginName: "swap",
    eventProperties: function() {
      return {
        swapItem: f1
      };
    }
  });
}
function nde(e, t) {
  var n = e.parentNode, r = t.parentNode, s, o;
  !n || !r || n.isEqualNode(t) || r.isEqualNode(e) || (s = Dl(e), o = Dl(t), n.isEqualNode(r) && s < o && o++, n.insertBefore(t, n.children[s]), r.insertBefore(e, r.children[o]));
}
var Zr = [], op = [], T7, zg, M7 = !1, oh = !1, o8 = !1, Hi, R7, kj;
function rde() {
  function e(t) {
    for (var n in this)
      n.charAt(0) === "_" && typeof this[n] == "function" && (this[n] = this[n].bind(this));
    t.options.avoidImplicitDeselect || (t.options.supportPointer ? Ya(document, "pointerup", this._deselectMultiDrag) : (Ya(document, "mouseup", this._deselectMultiDrag), Ya(document, "touchend", this._deselectMultiDrag))), Ya(document, "keydown", this._checkKeyDown), Ya(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      avoidImplicitDeselect: !1,
      setData: function(s, o) {
        var c = "";
        Zr.length && zg === t ? Zr.forEach(function(u, m) {
          c += (m ? ", " : "") + u.textContent;
        }) : c = o.textContent, s.setData("Text", c);
      }
    };
  }
  return e.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function(n) {
      var r = n.dragEl;
      Hi = r;
    },
    delayEnded: function() {
      this.isMultiDrag = ~Zr.indexOf(Hi);
    },
    setupClone: function(n) {
      var r = n.sortable, s = n.cancel;
      if (this.isMultiDrag) {
        for (var o = 0; o < Zr.length; o++)
          op.push(WO(Zr[o])), op[o].sortableIndex = Zr[o].sortableIndex, op[o].draggable = !1, op[o].style["will-change"] = "", rl(op[o], this.options.selectedClass, !1), Zr[o] === Hi && rl(op[o], this.options.chosenClass, !1);
        r._hideClone(), s();
      }
    },
    clone: function(n) {
      var r = n.sortable, s = n.rootEl, o = n.dispatchSortableEvent, c = n.cancel;
      this.isMultiDrag && (this.options.removeCloneOnHide || Zr.length && zg === r && (GU(!0, s), o("clone"), c()));
    },
    showClone: function(n) {
      var r = n.cloneNowShown, s = n.rootEl, o = n.cancel;
      this.isMultiDrag && (GU(!1, s), op.forEach(function(c) {
        Kn(c, "display", "");
      }), r(), kj = !1, o());
    },
    hideClone: function(n) {
      var r = this;
      n.sortable;
      var s = n.cloneNowHidden, o = n.cancel;
      this.isMultiDrag && (op.forEach(function(c) {
        Kn(c, "display", "none"), r.options.removeCloneOnHide && c.parentNode && c.parentNode.removeChild(c);
      }), s(), kj = !0, o());
    },
    dragStartGlobal: function(n) {
      n.sortable, !this.isMultiDrag && zg && zg.multiDrag._deselectMultiDrag(), Zr.forEach(function(r) {
        r.sortableIndex = Dl(r);
      }), Zr = Zr.sort(function(r, s) {
        return r.sortableIndex - s.sortableIndex;
      }), o8 = !0;
    },
    dragStarted: function(n) {
      var r = this, s = n.sortable;
      if (this.isMultiDrag) {
        if (this.options.sort && (s.captureAnimationState(), this.options.animation)) {
          Zr.forEach(function(c) {
            c !== Hi && Kn(c, "position", "absolute");
          });
          var o = mo(Hi, !1, !0, !0);
          Zr.forEach(function(c) {
            c !== Hi && zU(c, o);
          }), oh = !0, M7 = !0;
        }
        s.animateAll(function() {
          oh = !1, M7 = !1, r.options.animation && Zr.forEach(function(c) {
            YM(c);
          }), r.options.sort && _j();
        });
      }
    },
    dragOver: function(n) {
      var r = n.target, s = n.completed, o = n.cancel;
      oh && ~Zr.indexOf(r) && (s(!1), o());
    },
    revert: function(n) {
      var r = n.fromSortable, s = n.rootEl, o = n.sortable, c = n.dragRect;
      Zr.length > 1 && (Zr.forEach(function(u) {
        o.addAnimationState({
          target: u,
          rect: oh ? mo(u) : c
        }), YM(u), u.fromRect = c, r.removeAnimationState(u);
      }), oh = !1, ade(!this.options.removeCloneOnHide, s));
    },
    dragOverCompleted: function(n) {
      var r = n.sortable, s = n.isOwner, o = n.insertion, c = n.activeSortable, u = n.parentEl, m = n.putSortable, y = this.options;
      if (o) {
        if (s && c._hideClone(), M7 = !1, y.animation && Zr.length > 1 && (oh || !s && !c.options.sort && !m)) {
          var b = mo(Hi, !1, !0, !0);
          Zr.forEach(function(k) {
            k !== Hi && (zU(k, b), u.appendChild(k));
          }), oh = !0;
        }
        if (!s)
          if (oh || _j(), Zr.length > 1) {
            var w = kj;
            c._showClone(r), c.options.animation && !kj && w && op.forEach(function(k) {
              c.addAnimationState({
                target: k,
                rect: R7
              }), k.fromRect = R7, k.thisAnimationDuration = null;
            });
          } else
            c._showClone(r);
      }
    },
    dragOverAnimationCapture: function(n) {
      var r = n.dragRect, s = n.isOwner, o = n.activeSortable;
      if (Zr.forEach(function(u) {
        u.thisAnimationDuration = null;
      }), o.options.animation && !s && o.multiDrag.isMultiDrag) {
        R7 = k1({}, r);
        var c = L4(Hi, !0);
        R7.top -= c.f, R7.left -= c.e;
      }
    },
    dragOverAnimationComplete: function() {
      oh && (oh = !1, _j());
    },
    drop: function(n) {
      var r = n.originalEvent, s = n.rootEl, o = n.parentEl, c = n.sortable, u = n.dispatchSortableEvent, m = n.oldIndex, y = n.putSortable, b = y || this.sortable;
      if (r) {
        var w = this.options, k = o.children;
        if (!o8)
          if (w.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), rl(Hi, w.selectedClass, !~Zr.indexOf(Hi)), ~Zr.indexOf(Hi))
            Zr.splice(Zr.indexOf(Hi), 1), T7 = null, X7({
              sortable: c,
              rootEl: s,
              name: "deselect",
              targetEl: Hi,
              originalEvent: r
            });
          else {
            if (Zr.push(Hi), X7({
              sortable: c,
              rootEl: s,
              name: "select",
              targetEl: Hi,
              originalEvent: r
            }), r.shiftKey && T7 && c.el.contains(T7)) {
              var j = Dl(T7), E = Dl(Hi);
              if (~j && ~E && j !== E) {
                var T, D;
                for (E > j ? (D = j, T = E) : (D = E, T = j + 1); D < T; D++)
                  ~Zr.indexOf(k[D]) || (rl(k[D], w.selectedClass, !0), Zr.push(k[D]), X7({
                    sortable: c,
                    rootEl: s,
                    name: "select",
                    targetEl: k[D],
                    originalEvent: r
                  }));
              }
            } else
              T7 = Hi;
            zg = b;
          }
        if (o8 && this.isMultiDrag) {
          if (oh = !1, (o[Hd].options.sort || o !== s) && Zr.length > 1) {
            var L = mo(Hi), I = Dl(Hi, ":not(." + this.options.selectedClass + ")");
            if (!M7 && w.animation && (Hi.thisAnimationDuration = null), b.captureAnimationState(), !M7 && (w.animation && (Hi.fromRect = L, Zr.forEach(function(U) {
              if (U.thisAnimationDuration = null, U !== Hi) {
                var z = oh ? mo(U) : L;
                U.fromRect = z, b.addAnimationState({
                  target: U,
                  rect: z
                });
              }
            })), _j(), Zr.forEach(function(U) {
              k[I] ? o.insertBefore(U, k[I]) : o.appendChild(U), I++;
            }), m === Dl(Hi))) {
              var R = !1;
              Zr.forEach(function(U) {
                if (U.sortableIndex !== Dl(U)) {
                  R = !0;
                  return;
                }
              }), R && (u("update"), u("sort"));
            }
            Zr.forEach(function(U) {
              YM(U);
            }), b.animateAll();
          }
          zg = b;
        }
        (s === o || y && y.lastPutMode !== "clone") && op.forEach(function(U) {
          U.parentNode && U.parentNode.removeChild(U);
        });
      }
    },
    nullingGlobal: function() {
      this.isMultiDrag = o8 = !1, op.length = 0;
    },
    destroyGlobal: function() {
      this._deselectMultiDrag(), Ta(document, "pointerup", this._deselectMultiDrag), Ta(document, "mouseup", this._deselectMultiDrag), Ta(document, "touchend", this._deselectMultiDrag), Ta(document, "keydown", this._checkKeyDown), Ta(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function(n) {
      if (!(typeof o8 < "u" && o8) && zg === this.sortable && !(n && p1(n.target, this.options.draggable, this.sortable.el, !1)) && !(n && n.button !== 0))
        for (; Zr.length; ) {
          var r = Zr[0];
          rl(r, this.options.selectedClass, !1), Zr.shift(), X7({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: "deselect",
            targetEl: r,
            originalEvent: n
          });
        }
    },
    _checkKeyDown: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, k1(e, {
    // Static methods & properties
    pluginName: "multiDrag",
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function(n) {
        var r = n.parentNode[Hd];
        !r || !r.options.multiDrag || ~Zr.indexOf(n) || (zg && zg !== r && (zg.multiDrag._deselectMultiDrag(), zg = r), rl(n, r.options.selectedClass, !0), Zr.push(n));
      },
      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function(n) {
        var r = n.parentNode[Hd], s = Zr.indexOf(n);
        !r || !r.options.multiDrag || !~s || (rl(n, r.options.selectedClass, !1), Zr.splice(s, 1));
      }
    },
    eventProperties: function() {
      var n = this, r = [], s = [];
      return Zr.forEach(function(o) {
        r.push({
          multiDragElement: o,
          index: o.sortableIndex
        });
        var c;
        oh && o !== Hi ? c = -1 : oh ? c = Dl(o, ":not(." + n.options.selectedClass + ")") : c = Dl(o), s.push({
          multiDragElement: o,
          index: c
        });
      }), {
        items: Tue(Zr),
        clones: [].concat(op),
        oldIndicies: r,
        newIndicies: s
      };
    },
    optionListeners: {
      multiDragKey: function(n) {
        return n = n.toLowerCase(), n === "ctrl" ? n = "Control" : n.length > 1 && (n = n.charAt(0).toUpperCase() + n.substr(1)), n;
      }
    }
  });
}
function ade(e, t) {
  Zr.forEach(function(n, r) {
    var s = t.children[n.sortableIndex + (e ? Number(r) : 0)];
    s ? t.insertBefore(n, s) : t.appendChild(n);
  });
}
function GU(e, t) {
  op.forEach(function(n, r) {
    var s = t.children[n.sortableIndex + (e ? Number(r) : 0)];
    s ? t.insertBefore(n, s) : t.appendChild(n);
  });
}
function _j() {
  Zr.forEach(function(e) {
    e !== Hi && e.parentNode && e.parentNode.removeChild(e);
  });
}
Ur.mount(new ede());
Ur.mount(qO, YO);
const sde = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MultiDrag: rde,
  Sortable: Ur,
  Swap: tde,
  default: Ur
}, Symbol.toStringTag, { value: "Module" })), ide = /* @__PURE__ */ FV(sde);
var sW = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], s = 0; s < arguments.length; s++) {
        var o = arguments[s];
        if (o) {
          var c = typeof o;
          if (c === "string" || c === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var u = n.apply(null, o);
              u && r.push(u);
            }
          } else if (c === "object")
            if (o.toString === Object.prototype.toString)
              for (var m in o)
                t.call(o, m) && o[m] && r.push(m);
            else
              r.push(o.toString());
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(sW);
var ode = sW.exports, lde = process.env.NODE_ENV === "production", nR = "Invariant failed";
function cde(e, t) {
  if (!e) {
    if (lde)
      throw new Error(nR);
    var n = typeof t == "function" ? t() : t, r = n ? nR + ": " + n : nR;
    throw new Error(r);
  }
}
const ude = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cde
}, Symbol.toStringTag, { value: "Module" })), dde = /* @__PURE__ */ FV(ude);
(function(e) {
  var t = ide, n = ode, r = Ee, s = dde;
  function o(H) {
    return H && H.__esModule ? H.default : H;
  }
  function c(H, K, q, Q) {
    Object.defineProperty(H, K, { get: q, set: Q, enumerable: !0, configurable: !0 });
  }
  function u(H, K) {
    return Object.keys(K).forEach(function(q) {
      q === "default" || q === "__esModule" || H.hasOwnProperty(q) || Object.defineProperty(H, q, {
        enumerable: !0,
        get: function() {
          return K[q];
        }
      });
    }), H;
  }
  c(e.exports, "Sortable", () => $882b6d93070905b3$re_export$Sortable), c(e.exports, "Direction", () => $882b6d93070905b3$re_export$Direction), c(e.exports, "DOMRect", () => $882b6d93070905b3$re_export$DOMRect), c(e.exports, "GroupOptions", () => $882b6d93070905b3$re_export$GroupOptions), c(e.exports, "MoveEvent", () => $882b6d93070905b3$re_export$MoveEvent), c(e.exports, "Options", () => $882b6d93070905b3$re_export$Options), c(e.exports, "PullResult", () => $882b6d93070905b3$re_export$PullResult), c(e.exports, "PutResult", () => $882b6d93070905b3$re_export$PutResult), c(e.exports, "SortableEvent", () => $882b6d93070905b3$re_export$SortableEvent), c(e.exports, "SortableOptions", () => $882b6d93070905b3$re_export$SortableOptions), c(e.exports, "Utils", () => $882b6d93070905b3$re_export$Utils), c(e.exports, "ReactSortable", () => U);
  function m(H) {
    H.parentElement !== null && H.parentElement.removeChild(H);
  }
  function y(H, K, q) {
    const Q = H.children[q] || null;
    H.insertBefore(K, Q);
  }
  function b(H) {
    H.forEach((K) => m(K.element));
  }
  function w(H) {
    H.forEach((K) => {
      y(K.parentElement, K.element, K.oldIndex);
    });
  }
  function k(H, K) {
    const q = D(H), Q = {
      parentElement: H.from
    };
    let Z = [];
    switch (q) {
      case "normal":
        Z = [
          {
            element: H.item,
            newIndex: H.newIndex,
            oldIndex: H.oldIndex,
            parentElement: H.from
          }
        ];
        break;
      case "swap":
        const te = {
          element: H.item,
          oldIndex: H.oldIndex,
          newIndex: H.newIndex,
          ...Q
        }, fe = {
          element: H.swapItem,
          oldIndex: H.newIndex,
          newIndex: H.oldIndex,
          ...Q
        };
        Z = [
          te,
          fe
        ];
        break;
      case "multidrag":
        Z = H.oldIndicies.map((ce, pe) => ({
          element: ce.multiDragElement,
          oldIndex: ce.index,
          newIndex: H.newIndicies[pe].index,
          ...Q
        }));
        break;
    }
    return L(Z, K);
  }
  function j(H, K) {
    const q = E(H, K);
    return T(H, q);
  }
  function E(H, K) {
    const q = [
      ...K
    ];
    return H.concat().reverse().forEach((Q) => q.splice(Q.oldIndex, 1)), q;
  }
  function T(H, K, q, Q) {
    const Z = [
      ...K
    ];
    return H.forEach((X) => {
      const se = Q && q && Q(X.item, q);
      Z.splice(X.newIndex, 0, se || X.item);
    }), Z;
  }
  function D(H) {
    return H.oldIndicies && H.oldIndicies.length > 0 ? "multidrag" : H.swapItem ? "swap" : "normal";
  }
  function L(H, K) {
    return H.map((Q) => ({
      ...Q,
      item: K[Q.oldIndex]
    })).sort((Q, Z) => Q.oldIndex - Z.oldIndex);
  }
  function I(H) {
    const { list: K, setList: q, children: Q, tag: Z, style: X, className: se, clone: te, onAdd: fe, onChange: ce, onChoose: pe, onClone: Se, onEnd: oe, onFilter: ue, onRemove: he, onSort: ve, onStart: Te, onUnchoose: Ie, onUpdate: Ue, onMove: qe, onSpill: it, onSelect: Ne, onDeselect: Xe, ...xt } = H;
    return xt;
  }
  const R = {
    dragging: null
  };
  class U extends r.Component {
    constructor(K) {
      super(K), this.ref = /* @__PURE__ */ (0, r.createRef)();
      const q = [
        ...K.list
      ].map((Q) => Object.assign(Q, {
        chosen: !1,
        selected: !1
      }));
      K.setList(q, this.sortable, R), o(s)(
        //@ts-expect-error: Doesn't exist. Will deprecate soon.
        !K.plugins,
        `
Plugins prop is no longer supported.
Instead, mount it with "Sortable.mount(new MultiDrag())"
Please read the updated README.md at https://github.com/SortableJS/react-sortablejs.
      `
      );
    }
    componentDidMount() {
      if (this.ref.current === null) return;
      const K = this.makeOptions();
      o(t).create(this.ref.current, K);
    }
    componentDidUpdate(K) {
      K.disabled !== this.props.disabled && this.sortable && this.sortable.option("disabled", this.props.disabled);
    }
    render() {
      const { tag: K, style: q, className: Q, id: Z } = this.props, X = {
        style: q,
        className: Q,
        id: Z
      }, se = !K || K === null ? "div" : K;
      return /* @__PURE__ */ (0, r.createElement)(se, {
        // @todo - find a way (perhaps with the callback) to allow AntD components to work
        ref: this.ref,
        ...X
      }, this.getChildren());
    }
    getChildren() {
      const { children: K, dataIdAttr: q, selectedClass: Q = "sortable-selected", chosenClass: Z = "sortable-chosen", dragClass: X = "sortable-drag", fallbackClass: se = "sortable-falback", ghostClass: te = "sortable-ghost", swapClass: fe = "sortable-swap-highlight", filter: ce = "sortable-filter", list: pe } = this.props;
      if (!K || K == null) return null;
      const Se = q || "data-id";
      return r.Children.map(K, (oe, ue) => {
        if (oe === void 0) return;
        const he = pe[ue] || {}, { className: ve } = oe.props, Te = typeof ce == "string" && {
          [ce.replace(".", "")]: !!he.filtered
        }, Ie = o(n)(ve, {
          [Q]: he.selected,
          [Z]: he.chosen,
          ...Te
        });
        return /* @__PURE__ */ (0, r.cloneElement)(oe, {
          [Se]: oe.key,
          className: Ie
        });
      });
    }
    /** Appends the `sortable` property to this component */
    get sortable() {
      const K = this.ref.current;
      if (K === null) return null;
      const q = Object.keys(K).find((Q) => Q.includes("Sortable"));
      return q ? K[q] : null;
    }
    /** Converts all the props from `ReactSortable` into the `options` object that `Sortable.create(el, [options])` can use. */
    makeOptions() {
      const K = [
        "onAdd",
        "onChoose",
        "onDeselect",
        "onEnd",
        "onRemove",
        "onSelect",
        "onSpill",
        "onStart",
        "onUnchoose",
        "onUpdate"
      ], q = [
        "onChange",
        "onClone",
        "onFilter",
        "onSort"
      ], Q = I(this.props);
      return K.forEach((X) => Q[X] = this.prepareOnHandlerPropAndDOM(X)), q.forEach((X) => Q[X] = this.prepareOnHandlerProp(X)), {
        ...Q,
        onMove: (X, se) => {
          const { onMove: te } = this.props, fe = X.willInsertAfter || -1;
          if (!te) return fe;
          const ce = te(X, se, this.sortable, R);
          return typeof ce > "u" ? !1 : ce;
        }
      };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop & an `on[Handler]` ReactSortable method.  */
    prepareOnHandlerPropAndDOM(K) {
      return (q) => {
        this.callOnHandlerProp(q, K), this[K](q);
      };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop */
    prepareOnHandlerProp(K) {
      return (q) => {
        this.callOnHandlerProp(q, K);
      };
    }
    /** Calls the `props.on[Handler]` function */
    callOnHandlerProp(K, q) {
      const Q = this.props[q];
      Q && Q(K, this.sortable, R);
    }
    // SORTABLE DOM HANDLING
    onAdd(K) {
      const { list: q, setList: Q, clone: Z } = this.props, X = [
        ...R.dragging.props.list
      ], se = k(K, X);
      b(se);
      const te = T(se, q, K, Z).map((fe) => Object.assign(fe, {
        selected: !1
      }));
      Q(te, this.sortable, R);
    }
    onRemove(K) {
      const { list: q, setList: Q } = this.props, Z = D(K), X = k(K, q);
      w(X);
      let se = [
        ...q
      ];
      if (K.pullMode !== "clone") se = E(X, se);
      else {
        let te = X;
        switch (Z) {
          case "multidrag":
            te = X.map((fe, ce) => ({
              ...fe,
              element: K.clones[ce]
            }));
            break;
          case "normal":
            te = X.map((fe) => ({
              ...fe,
              element: K.clone
            }));
            break;
          case "swap":
          default:
            o(s)(!0, `mode "${Z}" cannot clone. Please remove "props.clone" from <ReactSortable/> when using the "${Z}" plugin`);
        }
        b(te), X.forEach((fe) => {
          const ce = fe.oldIndex, pe = this.props.clone(fe.item, K);
          se.splice(ce, 1, pe);
        });
      }
      se = se.map((te) => Object.assign(te, {
        selected: !1
      })), Q(se, this.sortable, R);
    }
    onUpdate(K) {
      const { list: q, setList: Q } = this.props, Z = k(K, q);
      b(Z), w(Z);
      const X = j(Z, q);
      return Q(X, this.sortable, R);
    }
    onStart() {
      R.dragging = this;
    }
    onEnd() {
      R.dragging = null;
    }
    onChoose(K) {
      const { list: q, setList: Q } = this.props, Z = q.map((X, se) => {
        let te = X;
        return se === K.oldIndex && (te = Object.assign(X, {
          chosen: !0
        })), te;
      });
      Q(Z, this.sortable, R);
    }
    onUnchoose(K) {
      const { list: q, setList: Q } = this.props, Z = q.map((X, se) => {
        let te = X;
        return se === K.oldIndex && (te = Object.assign(te, {
          chosen: !1
        })), te;
      });
      Q(Z, this.sortable, R);
    }
    onSpill(K) {
      const { removeOnSpill: q, revertOnSpill: Q } = this.props;
      q && !Q && m(K.item);
    }
    onSelect(K) {
      const { list: q, setList: Q } = this.props, Z = q.map((X) => Object.assign(X, {
        selected: !1
      }));
      K.newIndicies.forEach((X) => {
        const se = X.index;
        if (se === -1) {
          console.log(`"${K.type}" had indice of "${X.index}", which is probably -1 and doesn't usually happen here.`), console.log(K);
          return;
        }
        Z[se].selected = !0;
      }), Q(Z, this.sortable, R);
    }
    onDeselect(K) {
      const { list: q, setList: Q } = this.props, Z = q.map((X) => Object.assign(X, {
        selected: !1
      }));
      K.newIndicies.forEach((X) => {
        const se = X.index;
        se !== -1 && (Z[se].selected = !0);
      }), Q(Z, this.sortable, R);
    }
  }
  /* eslint-disable-next-line */
  BI(U, "defaultProps", {
    clone: (K) => K
  });
  var z = {};
  u(e.exports, z);
})($G);
var gw = $G.exports;
const fde = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M8.25 2.88086C9.08 2.88086 9.75 3.55086 9.75 4.38086C9.75 5.21086 9.08 5.88086 8.25 5.88086C7.42 5.88086 6.75 5.21086 6.75 4.38086C6.75 3.55086 7.42 2.88086 8.25 2.88086Z" }), /* @__PURE__ */ re.createElement("path", { d: "M15.75 2.88086C16.58 2.88086 17.25 3.55086 17.25 4.38086C17.25 5.21086 16.58 5.88086 15.75 5.88086C14.92 5.88086 14.25 5.21086 14.25 4.38086C14.25 3.55086 14.92 2.88086 15.75 2.88086Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8.25 10.5009C9.08 10.5009 9.75 11.1709 9.75 12.0009C9.75 12.8309 9.08 13.5009 8.25 13.5009C7.42 13.5009 6.75 12.8309 6.75 12.0009C6.75 11.1709 7.42 10.5009 8.25 10.5009Z" }), /* @__PURE__ */ re.createElement("path", { d: "M15.75 10.5009C16.58 10.5009 17.25 11.1709 17.25 12.0009C17.25 12.8309 16.58 13.5009 15.75 13.5009C14.92 13.5009 14.25 12.8309 14.25 12.0009C14.25 11.1709 14.92 10.5009 15.75 10.5009Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8.25 18.1209C9.08 18.1209 9.75 18.7909 9.75 19.6209C9.75 20.4509 9.08 21.1209 8.25 21.1209C7.42 21.1209 6.75 20.4509 6.75 19.6209C6.75 18.7909 7.42 18.1209 8.25 18.1209Z" }), /* @__PURE__ */ re.createElement("path", { d: "M15.75 18.1209C16.58 18.1209 17.25 18.7909 17.25 19.6209C17.25 20.4509 16.58 21.1209 15.75 21.1209C14.92 21.1209 14.25 20.4509 14.25 19.6209C14.25 18.7909 14.92 18.1209 15.75 18.1209Z" })), yw = yn(fde), mde = (e, t) => e === ni.Closed ? "text-mshop-gray-50" : t ? "text-mshop-black" : "text-mshop-gray-50 hover:text-mshop-black";
function hde({
  selectedItem: e,
  sortedList: t,
  onSortedList: n,
  onClickItem: r,
  onAddItem: s
}) {
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: "flex h-[57.14285rem] w-[20rem] flex-shrink-0 flex-col gap-y-[1.71428rem] overflow-hidden rounded-[.57142rem] bg-mshop-gray-5 px-[1.14286rem] py-[1.71429rem]",
      id: "support-create-plan-list",
      children: [
        t && /* @__PURE__ */ a.jsx("div", { className: "overflow-y-auto", children: /* @__PURE__ */ a.jsx(
          gw.ReactSortable,
          {
            className: "flex flex-col gap-y-[.28571rem]",
            list: t,
            setList: n,
            animation: 150,
            handle: ".sortable-handle",
            draggable: ".sortable-item",
            children: t.map((o) => /* @__PURE__ */ a.jsxs(
              "button",
              {
                type: "button",
                className: $(
                  "flex-0 flex min-h-[2.85714rem] items-center gap-x-[0.28571rem] rounded-[.28571rem] border bg-mshop-white px-[.85714rem]",
                  {
                    "border-mshop-blue-100": e.id === o.id
                  },
                  {
                    "sortable-item": o.state !== ni.Closed
                  }
                ),
                onClick: () => {
                  e.id !== o.id && r(o);
                },
                children: [
                  /* @__PURE__ */ a.jsx("div", { className: "size-[1.14285rem] flex-shrink-0", children: ni.Closed !== e.state && e.id === o.id ? /* @__PURE__ */ a.jsx(yw, { className: "sortable-handle size-full cursor-pointer fill-mshop-gray-20" }) : /* @__PURE__ */ a.jsx("div", { className: "bg-transparent" }) }),
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "typo-mshop-kr-14-m line-clamp-1 flex-grow text-ellipsis text-start",
                        mde(
                          o.state,
                          e.id === o.id
                        )
                      ),
                      children: o.displayName
                    }
                  ),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m flex-shrink-0 text-mshop-gray-50", children: pde(o.state) })
                ]
              },
              o.id
            ))
          }
        ) }),
        /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx(
          za,
          {
            widthFull: !0,
            variant: "sm",
            theme: "blue",
            iconFront: "add",
            type: "button",
            onClick: s,
            children: "후원 플랜 만들기"
          }
        ) })
      ]
    }
  );
}
function pde(e) {
  switch (e) {
    case ni.Open:
      return "";
    case ni.Closed:
      return "종료";
    case "DELETED":
      return "";
    case "HIDDEN":
      return "비공개";
    default:
      throw new Error(`Does not exist state: ${e}`);
  }
}
const WU = `후원 감사합니다!
앞으로 더 재밌고 알찬 콘텐츠로 보답할게요. 계속 지켜봐 주세요! ✨`, rR = "https://memb-static.prod.ct.marpplecorp.com/public/thumbnail-Image-support.png", gde = [
  {
    title: "후원 정보 입력",
    description: `후원 이름, 소개 등 기본 정보를 입력해 주세요.
팬들이 후원 내용을 이해하기 쉽도록 상세하게 작성해 주세요!`,
    imgSrc: kt.Admin.SupportGuideModalStep1
  },
  {
    title: "감사 메시지 입력",
    description: `팬이 후원 결제를 완료하면 자동으로 전달될 감사 메시지를 설정해 주세요.
후원해 준 팬에게 감사 이미지와 함께 팬에게 고마운 마음을 표현해 보세요.`,
    imgSrc: kt.Admin.SupportGuideModalStep2
  },
  {
    title: "후원 시작",
    description: `팬들이 크리에이터에게 전하는 마음, 마플샵 크리에이터 후원
마플샵 후원으로 팬덤에게 응원받고 더 힘차게 소통하세요!`,
    imgSrc: kt.Admin.SupportGuideModalStep3
  }
];
function yde(e) {
  var er, It;
  Al([
    [ol, e.client],
    [
      ll,
      {
        isMobile: e.isMobile,
        isApp: e.isApp,
        toggleSpinner: e.toggleSpinner,
        onError: e.onError,
        onScrollLock: e.onScrollLock
      }
    ],
    [R1, e.projectId],
    [gy, e.supportSettings]
  ]);
  const {
    settingSupports: t,
    setSettingSupports: n,
    setDeleteSettingSupport: r,
    setAddSettingSupport: s,
    setUpdateSettingSupport: o,
    setMoveToEndSettingSupport: c
  } = $ae();
  N$((ye) => {
    D && ye.preventDefault();
  });
  const { client: u } = Ha(), { projectId: m } = Tf(), {
    widgetCore: { onError: y, toggleSpinner: b }
  } = Gt(), w = (ye) => {
    const { thumbnailImage: ke, thankImage: Pe, thankDescription: tt, ...ot } = ye;
    return {
      ...ot,
      thumbnailImageUrl: ke.url || rR,
      thankImageUrl: Pe.url || AM,
      thankDescription: tt || WU
    };
  }, k = bp({
    reValidateMode: "onChange",
    mode: "onChange",
    defaultValues: w(e.selectedSupportSetting)
  }), {
    register: j,
    watch: E,
    formState: { errors: T, isDirty: D, isValid: L },
    reset: I,
    setValue: R,
    setError: U,
    getValues: z
  } = k, H = E("thumbnailImageUrl"), K = Rt(null), q = j(
    "thumbnailImageUrl",
    Ss.supportThumbnail
  ), Q = E("thankImageUrl"), Z = Rt(null), X = j("thankImageUrl"), [se, te] = Re(!1), [fe, ce] = Re(!1), [pe, Se] = Re(!1), [oe, ue] = Re(!1), [he, ve] = Re(!1), Te = async (ye) => {
    if (ye.map((tt) => tt.id).join("_") === (t == null ? void 0 : t.map((tt) => tt.id).join("_")))
      return;
    const ke = {
      projectId: m,
      type: nO.Support,
      items: ye.map((tt) => ({
        id: tt.id
      }))
    };
    n(ye);
    const { code: Pe } = await eO(ke, { client: u, onError: y });
    if (Pe === le.TokenExpired)
      return e.onError(Ht);
  }, Ie = async () => D ? await ho({
    body: (ye, ke) => /* @__PURE__ */ a.jsx(
      qu,
      {
        confirmButton: {
          props: ye,
          text: "삭제"
        },
        cancelButton: {
          props: ke
        },
        children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "저장되지 않은 입력 내용" }),
          /* @__PURE__ */ a.jsxs("div", { children: [
            "입력한 내용이 저장되지 않았습니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "저장하지 않고 내용을 삭제할까요?"
          ] })
        ] })
      }
    )
  }) : !0, Ue = (ye) => {
    e.onSelectedSupportSetting(ye), I(w(ye));
  }, qe = async (ye = !1) => {
    if (!ye && !await Ie())
      return;
    if (t.length >= 50) {
      await en({
        body: (Pe) => /* @__PURE__ */ a.jsx(
          sa,
          {
            button: {
              props: Pe
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "후원 개수 초과" }),
              /* @__PURE__ */ a.jsxs("div", { children: [
                "최대 50개의 플랜만 생성할 수 있습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "추가하려면 기존 후원을 삭제해 주세요."
              ] })
            ] })
          }
        )
      });
      return;
    }
    b(!0);
    const ke = await s$(
      { projectId: m },
      { client: u, onError: y }
    );
    ke.code === le.Success ? (s(ke.data), Ue(ke.data)) : await Xe(ke), b(!1);
  }, it = async () => {
    const ye = z();
    b(!0);
    const ke = await Dae(
      {
        supportId: e.selectedSupportSetting.id,
        displayName: ye.displayName,
        description: ye.description,
        thumbnailImageUrl: ye.thumbnailImageUrl,
        thankImageUrl: ye.thankImageUrl,
        thankDescription: ye.thankDescription
      },
      { client: u, onError: y }
    );
    ve(!1), ke.code === le.Success ? (o(ke.data), Ue(ke.data), Se(!0)) : await Xe(ke), b(!1);
  }, Ne = async () => {
    if (D)
      return en({
        body: (ye) => /* @__PURE__ */ a.jsx(
          sa,
          {
            button: {
              props: ye
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "저장되지 않은 입력 내용" }),
              /* @__PURE__ */ a.jsxs("div", { children: [
                "입력한 내용이 저장되지 않았습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "먼저 저장하기 버튼을 눌러 저장해 주세요."
              ] })
            ] })
          }
        )
      });
    ve(!0);
  }, Xe = async (ye) => {
    switch (ye.code) {
      case le.BadWordName: {
        const ke = ye.data.column;
        U(ke, {
          message: ke === "displayName" ? "부적절한 단어가 포함되어 있습니다. 다른 이름을 입력해 주세요." : "부적절한 단어가 포함되어 있습니다. 입력 텍스트를 확인해 주세요."
        });
        return;
      }
      case le.TokenExpired:
        return y(Ht);
      default:
        await en({
          body: (ke) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: ke
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "예기치 못한 오류로 인해 진행할 수 없습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "동일한 문제가 반복적으로 발생할 경우",
                  /* @__PURE__ */ a.jsx("br", {}),
                  /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                  "로 문의해 주세요."
                ] })
              ] })
            }
          )
        }), I();
    }
  }, xt = async () => {
    if (await ho({
      body: (ke, Pe) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: ke,
            color: "red",
            text: "삭제하기"
          },
          cancelButton: {
            props: Pe
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.143rem]", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "후원 삭제" }),
            /* @__PURE__ */ a.jsxs("p", { className: "mt-[0.286rem]", children: [
              "삭제된 후원은 복구가 불가능합니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "후원을 삭제하시겠어요?"
            ] })
          ] })
        }
      )
    })) {
      b(!0);
      const ke = await Rae(
        {
          supportId: e.selectedSupportSetting.id
        },
        { client: u, onError: y }
      );
      if (ke.code === le.Success) {
        if (ke.data.hasNoMoreData)
          await qe(!0), r(e.selectedSupportSetting.id);
        else {
          r(e.selectedSupportSetting.id);
          const Pe = t.filter(
            (tt) => tt.id !== e.selectedSupportSetting.id
          );
          Ue(Pe[0]);
        }
        return b(!1), en({
          body: (Pe) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Pe
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "후원 삭제 완료" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "후원 플랜이 삭제되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "새로운 플랜을 만들어보세요!"
                ] })
              ] })
            }
          )
        });
      }
      b(!1), await Xe(ke);
    }
  }, rn = async () => {
    let ye = !0;
    if (e.selectedSupportSetting.state === ni.Open && (ye = await ho({
      body: (ke, Pe) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: ke,
            text: "변경 저장하기"
          },
          cancelButton: {
            props: Pe
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.143rem]", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "후원 변경하기" }),
            /* @__PURE__ */ a.jsxs("p", { className: "mt-[0.286rem]", children: [
              "변경된 내용으로 바로 적용됩니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "후원을 변경하시겠어요?"
            ] })
          ] })
        }
      )
    })), ye) {
      const ke = {
        supportId: e.selectedSupportSetting.id,
        thumbnailImageUrl: Kl(
          e.selectedSupportSetting.thumbnailImage.url,
          H
        ),
        displayName: Kl(
          e.selectedSupportSetting.displayName,
          E("displayName")
        ),
        description: Kl(
          e.selectedSupportSetting.description,
          E("description")
        ),
        thankImageUrl: Kl(
          e.selectedSupportSetting.thankImage.url,
          Q
        ),
        thankDescription: Kl(
          e.selectedSupportSetting.thankDescription,
          E("thankDescription")
        )
      };
      b(!0);
      const Pe = await nU(ke, { client: u, onError: y });
      b(!1), Pe.code === le.Success ? (o(Pe.data), Ue(Pe.data)) : await Xe(Pe);
    }
  }, vt = async () => {
    if (await ho({
      body: (ke, Pe) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: ke,
            text: "종료하기"
          },
          cancelButton: {
            props: Pe
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.143rem]", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "후원 종료하기" }),
            /* @__PURE__ */ a.jsxs("p", { className: "mt-[0.286rem]", children: [
              "후원 목록에서 종료된 후원으로 변경됩니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "후원을 종료하시겠어요?"
            ] })
          ] })
        }
      )
    })) {
      b(!0);
      const ke = await nU(
        {
          supportId: e.selectedSupportSetting.id,
          state: ni.Closed
        },
        { client: u, onError: y }
      );
      b(!1), ke.code === le.Success ? (Ue(ke.data), c(ke.data)) : await Xe(ke);
    }
  }, At = (ye) => {
    const ke = E(ye).trim();
    R(ye, ke === "" ? "" : ke, {
      shouldValidate: !0
    });
  }, He = e.selectedSupportSetting.state === ni.Closed, Pt = !He && E("thumbnailImageUrl") !== rR, Lt = !He && E("thankImageUrl") !== AM;
  return /* @__PURE__ */ a.jsx("div", { className: "twp", children: e.isMobile ? /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex flex-col bg-mshop-white px-[1.14286rem] pt-[6.85714rem] text-center text-mshop-black", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
      /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-24-b", children: [
        "후원 만들기 기능은",
        /* @__PURE__ */ a.jsx("br", {}),
        "PC에서 이용해 주세요."
      ] }),
      /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m", children: [
        "더 나은 경험을 위해 PC 마플샵 스튜디오로",
        /* @__PURE__ */ a.jsx("br", {}),
        "후원을 만들고 관리해 보세요."
      ] })
    ] }),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: "size-[20rem] bg-cover bg-center bg-no-repeat",
        style: {
          backgroundImage: `url(${kt.Admin.SupportCreateMobile})`
        }
      }
    )
  ] }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsxs(S9, { ...k, children: [
    /* @__PURE__ */ a.jsxs("form", { className: "mb-[6.85714rem] w-full", children: [
      /* @__PURE__ */ a.jsxs(
        "header",
        {
          className: "flex w-full flex-col gap-y-[0.571rem]",
          id: "support-create-header",
          children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-start gap-x-[0.571rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-28-b text-mshop-black", children: "후원 만들기" }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => ue(!0),
                  className: "py-[0.28571rem]",
                  children: /* @__PURE__ */ a.jsx(tO, { className: "size-[1.42857rem] fill-mshop-black" })
                }
              )
            ] }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "다양한 목적의 후원을 만들어 팬들의 응원을 받아보세요!" })
          ]
        }
      ),
      /* @__PURE__ */ a.jsxs("main", { className: "mt-[2.857rem] flex h-full gap-x-[1.14286rem]", children: [
        /* @__PURE__ */ a.jsx(
          hde,
          {
            selectedItem: e.selectedSupportSetting,
            sortedList: t,
            onSortedList: Te,
            onClickItem: async (ye) => {
              await Ie() && Ue(ye);
            },
            onAddItem: () => qe()
          }
        ),
        /* @__PURE__ */ a.jsxs("div", { className: "flex min-w-[37.57143rem] max-w-[85.71429rem] flex-1 flex-col gap-y-[1.143rem]", children: [
          /* @__PURE__ */ a.jsxs(
            "section",
            {
              className: "flex w-full flex-col gap-[1.143rem] rounded-lg border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]",
              id: "support-create-info-section",
              children: [
                /* @__PURE__ */ a.jsx("header", { className: "typo-mshop-kr-20-b text-mshop-black", children: "후원 정보" }),
                /* @__PURE__ */ a.jsxs("main", { className: "flex flex-col gap-y-[1.714rem]", children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "후원 이름", required: !0 }),
                    /* @__PURE__ */ a.jsx(
                      M8,
                      {
                        ...j("displayName", {
                          ...Ss.supportName,
                          validate: {
                            notOnlySpecialChars: (ye) => rO(ye) ? "특수문자만으로 이름을 작성할 수 없습니다. 문자를 포함해 입력해 주세요." : !0
                          }
                        }),
                        watch: E("displayName"),
                        maxLength: Ss.supportName.maxLength.value,
                        placeholder: "후원 이름을 설정해 주세요.",
                        invalid: !!T.displayName,
                        disabled: He,
                        onBlur: () => {
                          At("displayName");
                        }
                      }
                    ),
                    T.displayName && T.displayName.message && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: T.displayName.message
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "후원 소개" }),
                    /* @__PURE__ */ a.jsx(
                      vy,
                      {
                        ...j(
                          "description",
                          Ss.supportDescription
                        ),
                        watch: E("description"),
                        maxLength: Ss.supportDescription.maxLength.value,
                        placeholder: "후원에 대해 간략하게 소개해 주세요.",
                        invalid: !!T.description,
                        disabled: He,
                        minRows: 3.6,
                        onBlur: () => {
                          At("description");
                        }
                      }
                    ),
                    T.description && T.description.message && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: T.description.message
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "썸네일 이미지" }),
                    /* @__PURE__ */ a.jsxs("div", { className: "relative size-[28.571rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        "img",
                        {
                          src: H,
                          className: "h-full w-full rounded-[0.57142rem] object-cover",
                          alt: ""
                        }
                      ),
                      Pt && /* @__PURE__ */ a.jsx(
                        "button",
                        {
                          type: "button",
                          className: "flex-center absolute -right-[0.571rem] -top-[0.571rem] size-[2.286rem] rounded-full bg-mshop-gray-80",
                          onClick: () => R(
                            "thumbnailImageUrl",
                            rR,
                            {
                              shouldValidate: !0,
                              shouldDirty: !0
                            }
                          ),
                          children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[0.857rem] fill-mshop-white" })
                        }
                      ),
                      !He && /* @__PURE__ */ a.jsx("div", { className: "absolute bottom-0 left-0 right-0 w-full", children: /* @__PURE__ */ a.jsx(
                        SD,
                        {
                          minImageHeight: 400,
                          minImageWidth: 400,
                          name: q.name,
                          title: "이미지 업로드하기",
                          ref: K,
                          recommended: "비율 1:1, 400*400px 이상",
                          onLoading: (ye) => {
                            te(ye);
                          },
                          onError: (ye) => U("thumbnailImageUrl", { message: ye }),
                          onSuccess: (ye) => R("thumbnailImageUrl", ye, {
                            shouldValidate: !0,
                            shouldDirty: !0
                          }),
                          client: u
                        }
                      ) })
                    ] }),
                    ((er = T.thumbnailImageUrl) == null ? void 0 : er.message) && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: T.thumbnailImageUrl.message
                      }
                    )
                  ] })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs(
            "section",
            {
              className: "flex w-full flex-col gap-y-[1.143rem] rounded-[0.571rem] border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]",
              id: "support-create-thanks-message-section",
              children: [
                /* @__PURE__ */ a.jsx("header", { className: "typo-mshop-kr-20-b pb-[0.286rem] text-mshop-black", children: "후원 감사 메시지" }),
                /* @__PURE__ */ a.jsxs("main", { className: "flex flex-col gap-y-[1.714rem]", children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "감사 이미지" }),
                    /* @__PURE__ */ a.jsxs("div", { className: "relative size-[28.57143rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        "img",
                        {
                          src: Q,
                          className: "h-full w-full rounded-[0.57142rem] object-cover",
                          alt: ""
                        }
                      ),
                      Lt && /* @__PURE__ */ a.jsx(
                        "button",
                        {
                          type: "button",
                          className: "flex-center absolute -right-[0.571rem] -top-[0.571rem] size-[2.286rem] rounded-full bg-mshop-gray-80",
                          onClick: () => R(
                            "thankImageUrl",
                            AM,
                            {
                              shouldValidate: !0,
                              shouldDirty: !0
                            }
                          ),
                          children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[0.857rem] fill-mshop-white" })
                        }
                      ),
                      !He && /* @__PURE__ */ a.jsx("div", { className: "absolute bottom-0 left-0 right-0 w-full", children: /* @__PURE__ */ a.jsx(
                        SD,
                        {
                          minImageHeight: 400,
                          minImageWidth: 400,
                          name: X.name,
                          title: "이미지 업로드하기",
                          ref: Z,
                          recommended: "비율 1:1, 400*400px 이상",
                          onLoading: (ye) => te(ye),
                          onError: (ye) => U("thankImageUrl", { message: ye }),
                          onSuccess: (ye) => R("thankImageUrl", ye, {
                            shouldValidate: !0,
                            shouldDirty: !0
                          }),
                          client: u
                        }
                      ) })
                    ] }),
                    ((It = T.thankImageUrl) == null ? void 0 : It.message) && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: T.thankImageUrl.message
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "감사 메시지" }),
                    /* @__PURE__ */ a.jsx(
                      vy,
                      {
                        ...j(
                          "thankDescription",
                          Ss.supportThankDescription
                        ),
                        watch: E("thankDescription"),
                        maxLength: Ss.supportThankDescription.maxLength.value,
                        placeholder: `후원자에게 감사의 마음을 전할 수 있는 메시지를 작성해 주세요.
예시 : 따뜻한 후원에 깊이 감사드립니다. 여러분 덕분에 더 큰 꿈을 꾸게 됩니다.`,
                        invalid: !!T.thankDescription,
                        disabled: e.selectedSupportSetting.state === ni.Closed,
                        minRows: 3.6,
                        onBlur: () => {
                          At("thankDescription");
                        }
                      }
                    ),
                    T.thankDescription && T.thankDescription.message && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: T.thankDescription.message
                      }
                    )
                  ] })
                ] }),
                e.selectedSupportSetting.state !== ni.Closed && /* @__PURE__ */ a.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ a.jsx(
                  za,
                  {
                    type: "button",
                    theme: "lineGray",
                    variant: "sm",
                    onClick: () => ce(!0),
                    children: "감사카드 미리 보기"
                  }
                ) })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ a.jsxs(
          "section",
          {
            className: "sticky top-[2.85714rem] h-fit w-[36.429rem] min-w-[25.71429rem] flex-shrink",
            id: "support-create-support-status",
            children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.714rem] rounded-lg border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[1.14286rem]", children: [
                  /* @__PURE__ */ a.jsx("div", { className: "flex-center size-[6.28571rem] overflow-hidden rounded-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
                    "img",
                    {
                      src: E("thumbnailImageUrl"),
                      className: "size-full object-cover",
                      alt: ""
                    }
                  ) }),
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b", children: E("displayName") })
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[3.21rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-gray-50", children: "후원 상태" }),
                  /* @__PURE__ */ a.jsx(
                    "div",
                    {
                      className: $(
                        "typo-mshop-kr-12-m flex-center flex w-fit rounded-[0.28571rem] px-[0.57143rem] pb-[0.28571rem] pt-[0.21429rem]",
                        {
                          "bg-mshop-gray-5 text-mshop-gray-80": He
                        },
                        {
                          "bg-mshop-blue-100 text-mshop-white": e.selectedSupportSetting.state === ni.Open
                        },
                        {
                          "bg-mshop-gray-5 text-mshop-gray-80": e.selectedSupportSetting.state === ni.Hidden
                        }
                      ),
                      children: vde(
                        e.selectedSupportSetting.state
                      )
                    }
                  )
                ] }),
                /* @__PURE__ */ a.jsx("div", { className: "rounded-[0.571rem] bg-mshop-gray-5", children: /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m list-disc py-[0.857rem] pl-[1.714rem] pr-[0.857rem] text-mshop-gray-80", children: [
                  /* @__PURE__ */ a.jsx(il, { children: "후원금의 사용 목적을 명확히 안내해 주세요." }),
                  /* @__PURE__ */ a.jsx(il, { children: "공개 모금 등 활동을 진행하실 경우, 신뢰를 위해 사용 내역을 공개해 주세요." })
                ] }) }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.714rem]", children: [
                  !He && /* @__PURE__ */ a.jsx(
                    za,
                    {
                      type: "button",
                      theme: "lineSky",
                      variant: "md",
                      disabled: !D || !L || se || Object.keys(T).length > 0,
                      onClick: rn,
                      widthFull: !0,
                      children: "저장하기"
                    }
                  ),
                  e.selectedSupportSetting.state === ni.Open ? /* @__PURE__ */ a.jsx(
                    za,
                    {
                      type: "button",
                      theme: "lineGray",
                      variant: "md",
                      disabled: !e.selectedSupportSetting.state,
                      onClick: vt,
                      widthFull: !0,
                      children: "후원 종료하기"
                    }
                  ) : /* @__PURE__ */ a.jsx(
                    za,
                    {
                      type: "button",
                      theme: "blue",
                      variant: "md",
                      disabled: !L || se || Object.keys(T).length > 0 || e.selectedSupportSetting.state !== ni.Hidden,
                      widthFull: !0,
                      onClick: Ne,
                      children: e.selectedSupportSetting.state === ni.Closed ? "종료된 후원입니다" : "후원 시작하기"
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "mt-[1.429rem] text-right", children: /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: "typo-mshop-kr-14-m text-mshop-gray-50 underline underline-offset-2",
                  onClick: xt,
                  children: "이 후원 플랜 삭제하기"
                }
              ) })
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a.jsx(
      Zu,
      {
        show: fe,
        onClose: () => ce(!1),
        children: /* @__PURE__ */ a.jsxs("div", { className: "flex max-h-[51.429rem] w-[43.429rem] flex-col overflow-hidden rounded-[1.143rem] bg-mshop-white", children: [
          /* @__PURE__ */ a.jsxs("header", { className: "flex justify-between border-b border-mshop-gray-5 px-[2.29rem] py-[1.71rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "감사카드 미리 보기" }),
            /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                onClick: () => ce(!1),
                children: /* @__PURE__ */ a.jsx(Wd, { className: 'fill-mshop-black" size-[1.429rem]' })
              }
            )
          ] }),
          /* @__PURE__ */ a.jsxs("section", { className: "max-h-[60rem] min-h-[40.1rem] overflow-y-auto px-[2.29rem] pb-[2.29rem] pt-[1.14rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "flex-center", children: /* @__PURE__ */ a.jsx(
              "img",
              {
                src: Q,
                className: "size-[24.571rem] flex-shrink-0 rounded-[1.14286rem] object-cover",
                alt: ""
              }
            ) }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col gap-y-[1.14rem] pt-[2.29rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-center text-mshop-black", children: "크리에이터의 감사 인사가 도착했어요!" }),
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m w-full whitespace-pre-wrap break-words rounded-[0.571rem] border border-mshop-gray-10 p-[1.143rem] text-mshop-black", children: E("thankDescription") || WU })
            ] })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ a.jsx(
      BG,
      {
        show: pe,
        onClose: () => Se(!1),
        imgUrl: kt.KeyVisual.MembershipBadge02Silver,
        title: "SUPPORT OPEN!",
        descriptions: [
          "목적이 있는 후원 금액이었다면, 반드시 약속을 지켜 주세요.",
          "팬들이 후원하며 보낸 메시지를 확인해 주세요.",
          "후원자의 개인 정보는 철저히 보호해 주세요."
        ],
        guidLineButton: {
          title: "크리에이터 가이드 보러가기",
          onClick: e.onCreatorGuideTextClick
        },
        confirmButton: {
          title: "내 후원 확인하기",
          onClick: async () => {
            e.onGoToMyShopToCheckSupportButtonClick(), Se(!1);
          }
        }
      }
    ),
    /* @__PURE__ */ a.jsx(
      BO,
      {
        show: oe,
        modalTitle: ["마플샵 후원", "시작하기"],
        onClose: () => ue(!1),
        stepInfos: gde
      }
    ),
    /* @__PURE__ */ a.jsx(
      jue,
      {
        show: he,
        onClose: () => ve(!1),
        onOpenSupport: it,
        onTermsTextClick: e.onTermsTextClick,
        onCreatorGuideTextClick: e.onCreatorGuideTextClick
      }
    )
  ] }) }) });
}
function vde(e) {
  switch (e) {
    case ni.Open:
      return "진행 중";
    case ni.Hidden:
      return "비공개";
    case ni.Closed:
      return "종료";
    default:
      throw new Error("");
  }
}
function xde({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  projectId: s,
  onGoToMyShopToCheckSupportButtonClick: o,
  onTermsTextClick: c,
  onCreatorGuideTextClick: u,
  onError: m,
  onScrollLock: y
}) {
  const [b, w] = Re(!0), [k, j] = Re(), [E, T] = Re();
  return an(() => {
    (async () => {
      const { code: D, data: L } = await Qre(
        { projectId: s },
        { client: e, onError: m }
      );
      if (D !== le.Success)
        return m(Ht);
      if (L.items.length > 0)
        T(L.items), j(L.items[0]);
      else {
        const I = await s$(
          { projectId: s },
          { client: e, onError: m }
        );
        if (I.code !== le.Success)
          return m(Ht);
        T([I.data]), j(I.data);
      }
      w(!1);
    })();
  }, []), b || !k || !E ? null : /* @__PURE__ */ a.jsx(
    yde,
    {
      client: e,
      isMobile: t,
      isApp: n,
      toggleSpinner: r,
      projectId: s,
      selectedSupportSetting: k,
      supportSettings: E,
      onSelectedSupportSetting: j,
      onGoToMyShopToCheckSupportButtonClick: o,
      onTermsTextClick: c,
      onCreatorGuideTextClick: u,
      onError: m,
      onScrollLock: y
    }
  );
}
class Dje extends Ol {
  constructor({
    projectId: t,
    onGoToMyShopToCheckSupportButtonClick: n,
    onTermsTextClick: r,
    onCreatorGuideTextClick: s,
    ...o
  }) {
    super(o), this.render = (c) => go(c).render(
      /* @__PURE__ */ a.jsx(
        xde,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          projectId: this.projectId,
          onGoToMyShopToCheckSupportButtonClick: this.onGoToMyShopToCheckSupportButtonClick,
          onCreatorGuideTextClick: this.onCreatorGuideTextClick,
          onTermsTextClick: this.onTermsTextClick,
          onError: this.onError,
          onScrollLock: this.onScrollLock
        }
      )
    ), this.projectId = t, this.onGoToMyShopToCheckSupportButtonClick = n, this.onTermsTextClick = r, this.onCreatorGuideTextClick = s;
  }
}
async function KO(e, t) {
  return jn(
    "/v2/create-membership",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.Maximum:
        return n;
      default:
        throw new Error("postV2CreateMembership");
    }
  });
}
async function bde(e, t) {
  return jn(
    "/v2/membership-settings",
    {
      body: e
    },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
        return n;
      default:
        throw new Error("postV2MembershipSettings");
    }
  });
}
function Vr(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function kf(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function E3(e, t) {
  const n = Vr(e);
  return isNaN(t) ? kf(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function KE(e, t) {
  const n = Vr(e);
  if (isNaN(t)) return kf(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), s = kf(e, n.getTime());
  s.setMonth(n.getMonth() + t + 1, 0);
  const o = s.getDate();
  return r >= o ? s : (n.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    r
  ), n);
}
function D7(e, t) {
  const {
    years: n = 0,
    months: r = 0,
    weeks: s = 0,
    days: o = 0,
    hours: c = 0,
    minutes: u = 0,
    seconds: m = 0
  } = t, y = Vr(e), b = r || n ? KE(y, r + n * 12) : y, w = o || s ? E3(b, o + s * 7) : b, k = u + c * 60, E = (m + k * 60) * 1e3;
  return kf(e, w.getTime() + E);
}
function Sde(e, t) {
  const n = +Vr(e);
  return kf(e, n + t);
}
const iW = 6048e5, wde = 864e5, XE = 6e4, XO = 36e5;
let Cde = {};
function QE() {
  return Cde;
}
function k3(e, t) {
  var u, m, y, b;
  const n = QE(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((m = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : m.weekStartsOn) ?? n.weekStartsOn ?? ((b = (y = n.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = Vr(e), o = s.getDay(), c = (o < r ? 7 : 0) + o - r;
  return s.setDate(s.getDate() - c), s.setHours(0, 0, 0, 0), s;
}
function U9(e) {
  return k3(e, { weekStartsOn: 1 });
}
function oW(e) {
  const t = Vr(e), n = t.getFullYear(), r = kf(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const s = U9(r), o = kf(e, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const c = U9(o);
  return t.getTime() >= s.getTime() ? n + 1 : t.getTime() >= c.getTime() ? n : n - 1;
}
function Q4(e) {
  const t = Vr(e);
  return t.setHours(0, 0, 0, 0), t;
}
function YU(e) {
  const t = Vr(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function lW(e, t) {
  const n = Q4(e), r = Q4(t), s = +n - YU(n), o = +r - YU(r);
  return Math.round((s - o) / wde);
}
function Nde(e) {
  const t = oW(e), n = kf(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), U9(n);
}
function QO(e, t) {
  return Sde(e, t * XE);
}
function qU(e, t) {
  return KE(e, t * 12);
}
function h3(e, t) {
  const n = Vr(e), r = Vr(t), s = n.getTime() - r.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
function jde(e, t) {
  const n = Q4(e), r = Q4(t);
  return +n == +r;
}
function Ede(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function kde(e) {
  if (!Ede(e) && typeof e != "number")
    return !1;
  const t = Vr(e);
  return !isNaN(Number(t));
}
function _de(e, t) {
  const n = Vr(e), r = Vr(t), s = n.getFullYear() - r.getFullYear(), o = n.getMonth() - r.getMonth();
  return s * 12 + o;
}
function Tde(e, t) {
  const n = Vr(e), r = Vr(t);
  return n.getFullYear() - r.getFullYear();
}
function ZO(e, t) {
  const n = Vr(e), r = Vr(t), s = KU(n, r), o = Math.abs(lW(n, r));
  n.setDate(n.getDate() - s * o);
  const c = +(KU(n, r) === -s), u = s * (o - c);
  return u === 0 ? 0 : u;
}
function KU(e, t) {
  const n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function JO(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function eA(e, t) {
  return +Vr(e) - +Vr(t);
}
function Mde(e, t, n) {
  const r = eA(e, t) / XO;
  return JO(n == null ? void 0 : n.roundingMethod)(r);
}
function Rde(e, t, n) {
  const r = eA(e, t) / XE;
  return JO(n == null ? void 0 : n.roundingMethod)(r);
}
function cW(e) {
  const t = Vr(e);
  return t.setHours(23, 59, 59, 999), t;
}
function Dde(e) {
  const t = Vr(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Pde(e) {
  const t = Vr(e);
  return +cW(t) == +Dde(t);
}
function Ode(e, t) {
  const n = Vr(e), r = Vr(t), s = h3(n, r), o = Math.abs(
    _de(n, r)
  );
  let c;
  if (o < 1)
    c = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - s * o);
    let u = h3(n, r) === -s;
    Pde(Vr(e)) && o === 1 && h3(e, r) === 1 && (u = !1), c = s * (o - Number(u));
  }
  return c === 0 ? 0 : c;
}
function Ade(e, t, n) {
  const r = eA(e, t) / 1e3;
  return JO(n == null ? void 0 : n.roundingMethod)(r);
}
function Lde(e, t) {
  const n = Vr(e), r = Vr(t), s = h3(n, r), o = Math.abs(Tde(n, r));
  n.setFullYear(1584), r.setFullYear(1584);
  const c = h3(n, r) === -s, u = s * (o - +c);
  return u === 0 ? 0 : u;
}
function Ide(e) {
  const t = Vr(e), n = kf(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Fde = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ude = (e, t, n) => {
  let r;
  const s = Fde[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function R8(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const zde = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Bde = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Hde = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Vde = {
  date: R8({
    formats: zde,
    defaultWidth: "full"
  }),
  time: R8({
    formats: Bde,
    defaultWidth: "full"
  }),
  dateTime: R8({
    formats: Hde,
    defaultWidth: "full"
  })
}, $de = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Gde = (e, t, n, r) => $de[e];
function ny(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let s;
    if (r === "formatting" && e.formattingValues) {
      const c = e.defaultFormattingWidth || e.defaultWidth, u = n != null && n.width ? String(n.width) : c;
      s = e.formattingValues[u] || e.formattingValues[c];
    } else {
      const c = e.defaultWidth, u = n != null && n.width ? String(n.width) : e.defaultWidth;
      s = e.values[u] || e.values[c];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return s[o];
  };
}
const Wde = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Yde = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, qde = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Kde = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Xde = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Qde = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Zde = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Jde = {
  ordinalNumber: Zde,
  era: ny({
    values: Wde,
    defaultWidth: "wide"
  }),
  quarter: ny({
    values: Yde,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ny({
    values: qde,
    defaultWidth: "wide"
  }),
  day: ny({
    values: Kde,
    defaultWidth: "wide"
  }),
  dayPeriod: ny({
    values: Xde,
    defaultWidth: "wide",
    formattingValues: Qde,
    defaultFormattingWidth: "wide"
  })
};
function ry(e) {
  return (t, n = {}) => {
    const r = n.width, s = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(s);
    if (!o)
      return null;
    const c = o[0], u = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], m = Array.isArray(u) ? tfe(u, (w) => w.test(c)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      efe(u, (w) => w.test(c))
    );
    let y;
    y = e.valueCallback ? e.valueCallback(m) : m, y = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(y)
    ) : y;
    const b = t.slice(c.length);
    return { value: y, rest: b };
  };
}
function efe(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function tfe(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function uW(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const s = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let c = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    c = n.valueCallback ? n.valueCallback(c) : c;
    const u = t.slice(s.length);
    return { value: c, rest: u };
  };
}
const nfe = /^(\d+)(th|st|nd|rd)?/i, rfe = /\d+/i, afe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, sfe = {
  any: [/^b/i, /^(a|c)/i]
}, ife = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ofe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, lfe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, cfe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ufe = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, dfe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ffe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, mfe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, hfe = {
  ordinalNumber: uW({
    matchPattern: nfe,
    parsePattern: rfe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ry({
    matchPatterns: afe,
    defaultMatchWidth: "wide",
    parsePatterns: sfe,
    defaultParseWidth: "any"
  }),
  quarter: ry({
    matchPatterns: ife,
    defaultMatchWidth: "wide",
    parsePatterns: ofe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ry({
    matchPatterns: lfe,
    defaultMatchWidth: "wide",
    parsePatterns: cfe,
    defaultParseWidth: "any"
  }),
  day: ry({
    matchPatterns: ufe,
    defaultMatchWidth: "wide",
    parsePatterns: dfe,
    defaultParseWidth: "any"
  }),
  dayPeriod: ry({
    matchPatterns: ffe,
    defaultMatchWidth: "any",
    parsePatterns: mfe,
    defaultParseWidth: "any"
  })
}, pfe = {
  code: "en-US",
  formatDistance: Ude,
  formatLong: Vde,
  formatRelative: Gde,
  localize: Jde,
  match: hfe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function gfe(e) {
  const t = Vr(e);
  return lW(t, Ide(t)) + 1;
}
function yfe(e) {
  const t = Vr(e), n = +U9(t) - +Nde(t);
  return Math.round(n / iW) + 1;
}
function dW(e, t) {
  var b, w, k, j;
  const n = Vr(e), r = n.getFullYear(), s = QE(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((w = (b = t == null ? void 0 : t.locale) == null ? void 0 : b.options) == null ? void 0 : w.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((j = (k = s.locale) == null ? void 0 : k.options) == null ? void 0 : j.firstWeekContainsDate) ?? 1, c = kf(e, 0);
  c.setFullYear(r + 1, 0, o), c.setHours(0, 0, 0, 0);
  const u = k3(c, t), m = kf(e, 0);
  m.setFullYear(r, 0, o), m.setHours(0, 0, 0, 0);
  const y = k3(m, t);
  return n.getTime() >= u.getTime() ? r + 1 : n.getTime() >= y.getTime() ? r : r - 1;
}
function vfe(e, t) {
  var u, m, y, b;
  const n = QE(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((m = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : m.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((b = (y = n.locale) == null ? void 0 : y.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, s = dW(e, t), o = kf(e, 0);
  return o.setFullYear(s, 0, r), o.setHours(0, 0, 0, 0), k3(o, t);
}
function xfe(e, t) {
  const n = Vr(e), r = +k3(n, t) - +vfe(n, t);
  return Math.round(r / iW) + 1;
}
function ui(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const s2 = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return ui(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : ui(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return ui(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return ui(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return ui(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return ui(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return ui(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), s = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return ui(s, t.length);
  }
}, l8 = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, XU = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), s = r > 0 ? r : 1 - r;
      return n.ordinalNumber(s, { unit: "year" });
    }
    return s2.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const s = dW(e, r), o = s > 0 ? s : 1 - s;
    if (t === "YY") {
      const c = o % 100;
      return ui(c, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : ui(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = oW(e);
    return ui(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return ui(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return ui(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return ui(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return s2.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return ui(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const s = xfe(e, r);
    return t === "wo" ? n.ordinalNumber(s, { unit: "week" }) : ui(s, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = yfe(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : ui(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : s2.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = gfe(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : ui(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const s = e.getDay(), o = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return ui(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const s = e.getDay(), o = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return ui(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(s, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(s, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), s = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(s);
      case "ii":
        return ui(s, t.length);
      case "io":
        return n.ordinalNumber(s, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let s;
    switch (r === 12 ? s = l8.noon : r === 0 ? s = l8.midnight : s = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let s;
    switch (r >= 17 ? s = l8.evening : r >= 12 ? s = l8.afternoon : r >= 4 ? s = l8.morning : s = l8.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return s2.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : s2.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : ui(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : ui(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : s2.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : s2.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return s2.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return ZU(r);
      case "XXXX":
      case "XX":
        return k4(r);
      case "XXXXX":
      case "XXX":
      default:
        return k4(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return ZU(r);
      case "xxxx":
      case "xx":
        return k4(r);
      case "xxxxx":
      case "xxx":
      default:
        return k4(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + QU(r, ":");
      case "OOOO":
      default:
        return "GMT" + k4(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + QU(r, ":");
      case "zzzz":
      default:
        return "GMT" + k4(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return ui(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return ui(r, t.length);
  }
};
function QU(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), s = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(s) : n + String(s) + t + ui(o, 2);
}
function ZU(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ui(Math.abs(e) / 60, 2) : k4(e, t);
}
function k4(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), s = ui(Math.trunc(r / 60), 2), o = ui(r % 60, 2);
  return n + s + t + o;
}
const JU = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, fW = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, bfe = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], s = n[2];
  if (!s)
    return JU(e, t);
  let o;
  switch (r) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", JU(r, t)).replace("{{time}}", fW(s, t));
}, Sfe = {
  p: fW,
  P: bfe
}, wfe = /^D+$/, Cfe = /^Y+$/, Nfe = ["D", "DD", "YY", "YYYY"];
function jfe(e) {
  return wfe.test(e);
}
function Efe(e) {
  return Cfe.test(e);
}
function kfe(e, t, n) {
  const r = _fe(e, t, n);
  if (console.warn(r), Nfe.includes(e)) throw new RangeError(r);
}
function _fe(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Tfe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Mfe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Rfe = /^'([^]*?)'?$/, Dfe = /''/g, Pfe = /[a-zA-Z]/;
function jt(e, t, n) {
  var b, w, k, j, E, T, D, L;
  const r = QE(), s = (n == null ? void 0 : n.locale) ?? r.locale ?? pfe, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((w = (b = n == null ? void 0 : n.locale) == null ? void 0 : b.options) == null ? void 0 : w.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((j = (k = r.locale) == null ? void 0 : k.options) == null ? void 0 : j.firstWeekContainsDate) ?? 1, c = (n == null ? void 0 : n.weekStartsOn) ?? ((T = (E = n == null ? void 0 : n.locale) == null ? void 0 : E.options) == null ? void 0 : T.weekStartsOn) ?? r.weekStartsOn ?? ((L = (D = r.locale) == null ? void 0 : D.options) == null ? void 0 : L.weekStartsOn) ?? 0, u = Vr(e);
  if (!kde(u))
    throw new RangeError("Invalid time value");
  let m = t.match(Mfe).map((I) => {
    const R = I[0];
    if (R === "p" || R === "P") {
      const U = Sfe[R];
      return U(I, s.formatLong);
    }
    return I;
  }).join("").match(Tfe).map((I) => {
    if (I === "''")
      return { isToken: !1, value: "'" };
    const R = I[0];
    if (R === "'")
      return { isToken: !1, value: Ofe(I) };
    if (XU[R])
      return { isToken: !0, value: I };
    if (R.match(Pfe))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + R + "`"
      );
    return { isToken: !1, value: I };
  });
  s.localize.preprocessor && (m = s.localize.preprocessor(u, m));
  const y = {
    firstWeekContainsDate: o,
    weekStartsOn: c,
    locale: s
  };
  return m.map((I) => {
    if (!I.isToken) return I.value;
    const R = I.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Efe(R) || !(n != null && n.useAdditionalDayOfYearTokens) && jfe(R)) && kfe(R, t, String(e));
    const U = XU[R[0]];
    return U(u, R, s.localize, y);
  }).join("");
}
function Ofe(e) {
  const t = e.match(Rfe);
  return t ? t[1].replace(Dfe, "'") : e;
}
function Afe(e) {
  const t = Vr(e), n = t.getFullYear(), r = t.getMonth(), s = kf(e, 0);
  return s.setFullYear(n, r + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function Lfe(e) {
  return Vr(e).getHours();
}
function Ife(e) {
  const t = Vr(e.start), n = Vr(e.end), r = {}, s = Lde(n, t);
  s && (r.years = s);
  const o = D7(t, { years: r.years }), c = Ode(n, o);
  c && (r.months = c);
  const u = D7(o, { months: r.months }), m = ZO(n, u);
  m && (r.days = m);
  const y = D7(u, { days: r.days }), b = Mde(n, y);
  b && (r.hours = b);
  const w = D7(y, { hours: r.hours }), k = Rde(n, w);
  k && (r.minutes = k);
  const j = D7(w, { minutes: r.minutes }), E = Ade(n, j);
  return E && (r.seconds = E), r;
}
function Ffe(e, t) {
  const n = Vr(e), r = Vr(t);
  return n.getTime() > r.getTime();
}
function Uv(e, t) {
  const n = Vr(e), r = Vr(t);
  return +n < +r;
}
function Ufe(e, t) {
  return E3(e, -t);
}
function o9(e, t) {
  const r = Vfe(e);
  let s;
  if (r.date) {
    const m = $fe(r.date, 2);
    s = Gfe(m.restDateString, m.year);
  }
  if (!s || isNaN(s.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = s.getTime();
  let c = 0, u;
  if (r.time && (c = Wfe(r.time), isNaN(c)))
    return /* @__PURE__ */ new Date(NaN);
  if (r.timezone) {
    if (u = Yfe(r.timezone), isNaN(u))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const m = new Date(o + c), y = /* @__PURE__ */ new Date(0);
    return y.setFullYear(
      m.getUTCFullYear(),
      m.getUTCMonth(),
      m.getUTCDate()
    ), y.setHours(
      m.getUTCHours(),
      m.getUTCMinutes(),
      m.getUTCSeconds(),
      m.getUTCMilliseconds()
    ), y;
  }
  return new Date(o + c + u);
}
const Tj = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, zfe = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Bfe = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Hfe = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Vfe(e) {
  const t = {}, n = e.split(Tj.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Tj.timeZoneDelimiter.test(t.date) && (t.date = e.split(Tj.timeZoneDelimiter)[0], r = e.substr(
    t.date.length,
    e.length
  ))), r) {
    const s = Tj.timezone.exec(r);
    s ? (t.time = r.replace(s[1], ""), t.timezone = s[1]) : t.time = r;
  }
  return t;
}
function $fe(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), r = e.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const s = r[1] ? parseInt(r[1]) : null, o = r[2] ? parseInt(r[2]) : null;
  return {
    year: o === null ? s : o * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function Gfe(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(zfe);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], s = P7(n[1]), o = P7(n[2]) - 1, c = P7(n[3]), u = P7(n[4]), m = P7(n[5]) - 1;
  if (r)
    return Zfe(t, u, m) ? qfe(t, u, m) : /* @__PURE__ */ new Date(NaN);
  {
    const y = /* @__PURE__ */ new Date(0);
    return !Xfe(t, o, c) || !Qfe(t, s) ? /* @__PURE__ */ new Date(NaN) : (y.setUTCFullYear(t, o, Math.max(s, c)), y);
  }
}
function P7(e) {
  return e ? parseInt(e) : 1;
}
function Wfe(e) {
  const t = e.match(Bfe);
  if (!t) return NaN;
  const n = aR(t[1]), r = aR(t[2]), s = aR(t[3]);
  return Jfe(n, r, s) ? n * XO + r * XE + s * 1e3 : NaN;
}
function aR(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Yfe(e) {
  if (e === "Z") return 0;
  const t = e.match(Hfe);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), s = t[3] && parseInt(t[3]) || 0;
  return eme(r, s) ? n * (r * XO + s * XE) : NaN;
}
function qfe(e, t, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const s = r.getUTCDay() || 7, o = (t - 1) * 7 + n + 1 - s;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
const Kfe = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function mW(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Xfe(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (Kfe[t] || (mW(e) ? 29 : 28));
}
function Qfe(e, t) {
  return t >= 1 && t <= (mW(e) ? 366 : 365);
}
function Zfe(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function Jfe(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function eme(e, t) {
  return t >= 0 && t <= 59;
}
function hW(e, t) {
  const n = Vr(e), r = n.getFullYear(), s = n.getDate(), o = kf(e, 0);
  o.setFullYear(r, t, 15), o.setHours(0, 0, 0, 0);
  const c = Afe(o);
  return n.setMonth(t, Math.min(s, c)), n;
}
function tme(e, t) {
  let n = Vr(e);
  return isNaN(+n) ? kf(e, NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = hW(n, t.month)), t.date != null && n.setDate(t.date), t.hours != null && n.setHours(t.hours), t.minutes != null && n.setMinutes(t.minutes), t.seconds != null && n.setSeconds(t.seconds), t.milliseconds != null && n.setMilliseconds(t.milliseconds), n);
}
function pW(e, t) {
  const n = Vr(e);
  return n.setHours(t), n;
}
function nme(e, t) {
  const n = Vr(e);
  return n.setMilliseconds(t), n;
}
function rme(e, t) {
  const n = Vr(e);
  return n.setMinutes(t), n;
}
function ame(e, t) {
  const n = Vr(e);
  return n.setSeconds(t), n;
}
function ez(e, t) {
  const n = Vr(e);
  return isNaN(+n) ? kf(e, NaN) : (n.setFullYear(t), n);
}
function tz(e, t) {
  return QO(e, -t);
}
async function gW(e, t) {
  return jn(
    "/v2/membership-setting",
    {
      body: e
    },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
        return n;
      default:
        throw new Error("postV2MembershipSetting");
    }
  });
}
const sR = {
  Product: "PRODUCT",
  Creator: "CREATOR",
  Community: "COMMUNITY"
}, ss = {
  /***
   * 멤버십 디지털 상품 등록 판매
   */
  BuyDigitalGoods: "BUY_DIGITAL_GOODS",
  /***
   * 멤버십 굿즈 제작 판매
   */
  BuyGoods: "BUY_GOODS",
  /***
   * 멤버십 상품 등록 판매
   */
  BuyOrderMade: "BUY_ORDER_MADE",
  /***
   * 커미션
   */
  Commission: "COMMISSION",
  /***
   * 멤버십 전용 커뮤니티 개설
   */
  Community: "COMMUNITY",
  /***
   * 멤버십 전용 디지털 컨텐츠 제공
   */
  DigitalContent: "DIGITAL_CONTENT",
  /***
   * 1:1대화
   */
  Dm: "DM",
  /***
   * 라이브스트리밍
   */
  LiveStreaming: "LIVE_STREAMING",
  /***
   * 온라인 클래스 제공
   */
  OnlineClass: "ONLINE_CLASS",
  /***
   * 멤버십 전용 채널 참여
   */
  Channel: "CHANNEL",
  /***
   * 크리에이터 특별 혜택
   */
  Custom: "CUSTOM"
}, tA = {
  [sR.Product]: {
    title: "상품 혜택",
    rewardTypes: [
      ss.BuyGoods,
      ss.BuyOrderMade,
      ss.BuyDigitalGoods
    ]
  },
  [sR.Creator]: {
    title: "크리에이터 혜택",
    rewardTypes: [ss.Custom]
  },
  [sR.Community]: {
    title: "사이어티 커뮤니티 혜택",
    rewardTypes: [
      ss.DigitalContent,
      ss.Dm,
      ss.LiveStreaming,
      ss.Channel
    ]
  }
}, c6 = {
  /**
   * 마플샵제작배송 상품 판매
   */
  BUY_GOODS: "멤버십 회원만을 위한 특별한 굿즈를 만나보세요!",
  /**
   * 크리에이터배송 상품 판매
   */
  BUY_ORDER_MADE: "멤버십 회원을 위해 직접 만든 상품을 구매해 보세요!",
  /**
   * 디지털/전자책 상품 판매
   */
  BUY_DIGITAL_GOODS: "멤버십 전용 디지털 상품을 다운로드하실 수 있어요!"
}, $n = {
  SubscriptionPass: "SUBSCRIPTION_PASS",
  ShortTermPass: "SHORT_TERM_PASS"
}, K8 = Qt(
  Vn
), sme = Qt(null, (e, t) => {
  const n = e(K8);
  if (n === Vn)
    throw new Error(Xr(ia.SettingMembership));
  t(K8, { ...n, notification: null });
}), ime = Qt(
  null,
  (e, t, n) => {
    const r = e(K8);
    if (r === Vn)
      throw new Error(Xr(ia.SettingMembership));
    t(K8, { ...r, notification: n });
  }
), nl = {
  Hidden: "HIDDEN",
  Open: "OPEN",
  Closed: "CLOSED",
  Deleted: "DELETED",
  DeletionPending: "DELETION_PENDING"
}, pu = Qt(Vn), ome = Qt(
  null,
  (e, t, n) => {
    const r = e(pu);
    if (r === Vn)
      throw new Error(Xr(ia.SettingMemberships));
    t(pu, [...r, n]);
  }
), lme = Qt(
  null,
  (e, t, n) => {
    const r = e(pu);
    if (r === Vn)
      throw new Error(Xr(ia.SettingMemberships));
    t(
      pu,
      r.map(
        (s) => s.id === n.id ? n : s
      )
    );
  }
), cme = Qt(
  null,
  (e, t, n) => {
    const r = e(pu);
    if (r === Vn)
      throw new Error(Xr(ia.SettingMemberships));
    t(
      pu,
      r.filter((s) => s.id !== n)
    );
  }
), ume = Qt(
  null,
  (e, t, n) => {
    const r = e(pu);
    if (r === Vn)
      throw new Error(Xr(ia.SettingMemberships));
    t(
      pu,
      r.map(
        (s) => s.id === n ? { ...s, state: nl.Open } : s
      )
    );
  }
), dme = Qt(
  null,
  (e, t, n) => {
    const r = e(pu);
    if (r === Vn)
      throw new Error(Xr(ia.SettingMemberships));
    t(
      pu,
      r.map(
        (s) => s.id === n ? { ...s, state: nl.Hidden } : s
      )
    );
  }
), fme = Qt(
  null,
  (e, t, n) => {
    const r = e(pu);
    if (r === Vn)
      throw new Error(Xr(ia.SettingMemberships));
    t(
      pu,
      r.map(
        (s) => s.id === n.id ? {
          ...s,
          state: nl.DeletionPending,
          deletionAt: n.deletionAt,
          changeable: !1
        } : s
      )
    );
  }
), mme = Qt(
  null,
  (e, t, n) => {
    const r = e(pu);
    if (r === Vn)
      throw new Error(Xr(ia.SettingMemberships));
    t(
      pu,
      r.map(
        (s) => s.id === n ? { ...s, notification: null } : s
      )
    );
  }
), hme = Qt(
  null,
  (e, t, n) => {
    const r = e(pu);
    if (r === Vn)
      throw new Error(Xr(ia.SettingMemberships));
    t(
      pu,
      r.map(
        (s) => s.id === n.targetId ? { ...s, notification: n.updateNotification } : s
      )
    );
  }
), pme = Qt((e) => {
  const t = e(pu);
  if (t === Vn)
    throw new Error(Xr(ia.SettingMemberships));
  return t.find((n) => n.isRecommended);
});
function ZE() {
  const [e, t] = Ar(
    pu
  );
  if (e === Vn)
    throw new Error(Xr(ia.SettingMemberships));
  const n = Ka(ome), r = Ka(
    lme
  ), s = Ka(
    cme
  ), o = Ka(ume), c = Ka(
    dme
  ), u = Ka(
    fme
  ), m = Ka(
    mme
  ), y = Ka(
    hme
  ), b = Y3(pme);
  return {
    settingMemberships: e,
    setSettingMemberships: t,
    setAddSettingMembership: n,
    setUpdateSettingMembership: r,
    setDeleteSettingMembership: s,
    setOpenSettingMembership: o,
    setHiddenSettingMembership: c,
    setDeletePendingSettingMembership: u,
    setCancelNotificationSettingMembership: m,
    setUpdateNotificationSettingMembership: y,
    recommendedMembership: b
  };
}
function u5() {
  const [e, t] = Ar(
    K8
  );
  if (e === Vn)
    throw new Error(Xr(ia.SettingMembership));
  const n = Ka(sme), r = Ka(ime);
  return {
    settingMembership: e,
    setSettingMembership: t,
    setCancelNotification: n,
    setUpdateNotification: r
  };
}
const gme = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 80, height: 16, viewBox: "0 0 80 16", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M12.0215 12.6171C13.0754 12.6079 14.1386 12.4063 15.2201 12.0122C16.297 11.6181 17.2501 10.9445 18.075 10.0005V13.1578C16.9523 13.946 15.6233 14.4822 14.0882 14.7617C12.553 15.0412 10.995 15.0687 9.4186 14.8396C7.84221 14.6105 6.42621 14.1568 5.18435 13.4694C5.50054 13.2082 5.85339 12.9699 6.25207 12.7591C6.64617 12.5484 7.08609 12.4017 7.56726 12.3238C8.04842 12.2459 8.53417 12.2505 9.02908 12.3376C9.97766 12.53 10.9767 12.6217 12.0261 12.6125L12.0215 12.6171ZM4.51072 2.92048C6.48578 1.66028 8.79079 1.01873 11.4303 1.0004C14.0699 0.982068 16.2832 1.59613 18.075 2.84257V5.99993C17.3372 5.15674 16.4069 4.51519 15.2842 4.06611C14.1615 3.61702 12.9746 3.38331 11.719 3.35581C10.4634 3.32832 9.2857 3.48412 8.18132 3.81407C6.91654 4.18067 5.92213 4.70308 5.19351 5.38129C4.46489 6.05492 4.03872 6.79271 3.91957 7.59006C3.79584 8.38742 3.98831 9.14812 4.49697 9.86758C4.96897 10.5366 5.22559 11.2148 5.25767 11.9068C5.29891 12.6904 5.17976 13.474 5.17976 13.474C4.05705 12.86 3.16804 12.0901 2.50815 11.1598C1.85744 10.2296 1.51833 9.17562 1.5 8.00249C1.53666 5.8762 2.54023 4.18525 4.51072 2.92048Z" }), /* @__PURE__ */ re.createElement("path", { d: "M22.8087 1.42199V14.5738H20.4396V1.42199H22.8087Z" }), /* @__PURE__ */ re.createElement("path", { d: "M39.2921 3.90572C38.1602 3.54828 36.7029 3.36498 34.9112 3.36498C33.541 3.36498 32.3633 3.47954 31.3735 3.70867C30.3836 3.93779 29.6138 4.18067 29.073 4.44645C28.5277 4.70766 28.1519 4.92762 27.9411 5.10634C27.8357 5.23007 27.7762 5.35838 27.7578 5.48669C27.7395 5.61958 27.8037 5.73873 27.9411 5.84412C28.1153 5.99993 28.3811 6.16948 28.7293 6.34362L29.2838 6.60482C29.6871 6.76063 29.962 7.03558 30.1133 7.42051C30.2599 7.80544 30.2599 8.19037 30.1133 8.57989C29.962 8.96482 29.6871 9.23977 29.2838 9.39558C28.8989 9.55138 28.5919 9.70261 28.3627 9.84466C28.1886 9.96839 28.0465 10.0738 27.9411 10.1609C27.8174 10.2479 27.7578 10.3717 27.7578 10.5275C27.7578 10.6833 27.8174 10.807 27.9411 10.8941C28.5735 11.3844 29.4855 11.7968 30.6769 12.1313C31.8684 12.4659 33.2798 12.6308 34.9112 12.6308C36.208 12.6308 37.3353 12.53 38.2931 12.3284C39.2508 12.1268 39.9978 11.9068 40.5431 11.6685C41.0884 11.4302 41.4917 11.2194 41.7529 11.0224V13.7077C40.8593 14.111 39.819 14.4272 38.6367 14.6563C37.4545 14.8854 36.2126 15 34.9157 15C33.1606 15 31.5384 14.7984 30.0491 14.3951C28.5598 13.9918 27.3729 13.4465 26.4977 12.7637C25.6224 12.0809 25.1825 11.334 25.1825 10.5275C25.1825 9.59721 25.7507 8.75402 26.8917 8.00249C25.7507 7.24637 25.1825 6.40777 25.1825 5.47752C25.1825 4.671 25.6224 3.92405 26.4977 3.24125C27.3729 2.55846 28.5598 2.01314 30.0491 1.60987C31.5338 1.20203 33.1561 1.0004 34.9112 1.0004C36.208 1.0004 37.4499 1.11496 38.6322 1.34409C39.8145 1.57321 40.8547 1.88941 41.7483 2.29267V4.97803C41.2396 4.62517 40.4193 4.27232 39.2875 3.91488L39.2921 3.90572Z" }), /* @__PURE__ */ re.createElement("path", { d: "M60.6924 1.42199V3.79115H54.2494C54.0753 3.79115 53.9195 3.85073 53.7911 3.97445C53.6583 4.09818 53.5941 4.25399 53.5941 4.44645V14.5738H51.2249V4.44645C51.2249 4.25399 51.1654 4.0936 51.0416 3.97445C50.9179 3.85073 50.7621 3.79115 50.5696 3.79115H44.1266V1.42199H60.7016H60.6924Z" }), /* @__PURE__ */ re.createElement("path", { d: "M64.8992 1.42199L69.7154 6.07783C69.8391 6.20156 69.9904 6.26113 70.1737 6.26113C70.357 6.26113 70.5128 6.20156 70.6319 6.07783L75.4207 1.42199H78.4451L71.553 8.1308C71.4109 8.2362 71.3422 8.392 71.3422 8.6028V14.5738H68.973V8.6028C68.973 8.41033 68.9135 8.24995 68.7897 8.1308L61.8747 1.42199H64.8992Z" })), nz = yn(gme), yme = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M9.9508 3.04834H5.83514C5.69141 3.04834 5.55843 3.12444 5.48562 3.24836L2.05648 9.08466C1.8977 9.3549 2.09256 9.69541 2.406 9.69541H6.02129C6.15618 9.69541 6.28223 9.62832 6.35756 9.51643L10.2871 3.68013C10.4684 3.41086 10.2754 3.04834 9.9508 3.04834Z" }), /* @__PURE__ */ re.createElement("path", { d: "M15.1687 9.6954C15.4933 9.6954 15.6862 9.33288 15.5049 9.06361L12.3363 4.35736C12.1756 4.11872 11.8244 4.11872 11.6637 4.35736L8.49506 9.06361C8.31376 9.33288 8.50671 9.6954 8.83133 9.6954H15.1687Z" }), /* @__PURE__ */ re.createElement("path", { d: "M21.9435 9.08466L18.5144 3.24836C18.4416 3.12444 18.3086 3.04834 18.1649 3.04834H14.0492C13.7246 3.04834 13.5316 3.41086 13.7129 3.68013L17.6424 9.51643C17.7178 9.62832 17.8438 9.69541 17.9787 9.69541H21.594C21.9074 9.69541 22.1023 9.35491 21.9435 9.08466Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8.41019 11.2156C8.1191 11.2156 7.92288 11.5133 8.03764 11.7808L11.6274 20.7079C11.7679 21.0353 12.2321 21.0353 12.3725 20.7079L15.9624 11.7808C16.0771 11.5133 15.8809 11.2156 15.5898 11.2156H8.41019Z" }), /* @__PURE__ */ re.createElement("path", { d: "M15.607 18.7936L21.8923 11.8953C22.1311 11.6354 21.9468 11.2156 21.5938 11.2156H18.1268C17.9647 11.2156 17.8182 11.3122 17.7543 11.4612L14.936 18.3594C14.7562 18.7786 15.2984 19.1294 15.607 18.7936Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8.39299 18.7936L2.10771 11.8953C1.86886 11.6354 2.05321 11.2156 2.40618 11.2156H5.87316C6.03527 11.2156 6.1818 11.3122 6.24571 11.4612L9.06401 18.3594C9.24383 18.7786 8.70162 19.1294 8.39299 18.7936Z" })), JE = yn(yme), vme = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_608_22088)" }, /* @__PURE__ */ re.createElement("path", { d: "M21.0903 7.60472L16.3842 2.89147C15.7297 2.23605 14.5845 2.23605 13.93 2.89147L7.70325 9.12761L2.91047 13.9276C2.58325 14.2553 2.40039 14.6891 2.40039 15.1517V19.865C2.40039 20.8288 3.17994 21.5999 4.13272 21.5999H8.83889C9.30084 21.5999 9.73393 21.4168 10.0708 21.0891L21.0903 10.0529C21.4175 9.7252 21.6004 9.29147 21.6004 8.81918C21.6004 8.34689 21.4175 7.92279 21.0903 7.58544V7.60472ZM17.9625 10.8047L13.1793 6.01436L15.1138 4.07701H15.1908L19.8969 8.86737L17.9625 10.8047Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_608_22088" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), nA = yn(vme), l9 = "https://www.ciety.xyz/", xme = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M9.37489 7.08268V1.66602H5.83322C4.45822 1.66602 3.33322 2.79102 3.33322 4.16602V15.8327C3.33322 16.0707 3.37206 16.2976 3.43615 16.5179L5.90938 14.0358L8.57401 16.6577L6.90501 18.3327H14.1666C15.5499 18.3327 16.6666 17.216 16.6666 15.8327V8.95768H11.2499C10.2166 8.95768 9.37489 8.11602 9.37489 7.08268Z" }), /* @__PURE__ */ re.createElement("path", { d: "M2.56305 18.7178C2.72055 18.8067 2.93086 18.7857 3.0707 18.655L5.9177 15.7969L6.8003 16.6653L6.80067 16.6665L3.95367 19.5236L3.9481 19.5291C3.93758 19.5394 3.92696 19.5494 3.91623 19.5593C3.7547 19.7087 3.57042 19.8193 3.37492 19.8923C3.37476 19.8922 3.37507 19.8923 3.37492 19.8923C3.18369 19.9636 2.98125 19.9986 2.77928 19.9986H2.77095C2.3463 19.9986 1.92166 19.843 1.59693 19.5234L0 17.9714L0.609727 17.3714L0.599772 17.3616L0.883536 17.0824L2.4799 18.6552C2.50514 18.68 2.53314 18.7009 2.56305 18.7178Z" }), /* @__PURE__ */ re.createElement("path", { d: "M10.6188 7.0761C10.6188 7.42566 10.9019 7.70032 11.2433 7.70032H16.5056C16.3807 7.35076 16.1892 7.02616 15.9227 6.76815L11.5597 2.39861C11.2933 2.13228 10.9685 1.94085 10.6271 1.81601V7.0761H10.6188Z" })), bme = yn(xme), Sme = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M21.1791 15.091C20.5487 16.331 20.2185 17.591 20.1684 18.881C20.152 19.3164 20.1626 19.7653 20.1724 20.1833L20.1725 20.1851C20.1746 20.2753 20.1767 20.3641 20.1784 20.451C20.1985 20.901 19.6981 21.171 19.3579 20.881C19.1978 20.741 19.0277 20.601 18.8576 20.471C18.3372 20.081 17.7568 19.811 17.1164 19.661C16.476 19.511 15.8356 19.521 15.1851 19.681C14.1644 19.971 13.1037 20.131 11.993 20.181C10.8047 20.181 9.66457 20.0037 8.60688 19.6782L10.2887 17.9887L7.0915 14.8428L4.57798 17.3661C2.96774 15.8445 1.98633 13.8235 1.98633 11.601C1.98633 6.85098 6.45931 3.00098 11.983 3.00098C13.504 3.00098 14.945 3.28098 16.2959 3.85098C17.967 4.53098 19.2878 5.50098 20.2585 6.76098C21.2191 8.01098 21.7795 9.38098 21.9396 10.861C22.0997 12.341 21.8496 13.751 21.1691 15.091H21.1791Z" }), /* @__PURE__ */ re.createElement("path", { d: "M6.16858 20.001H6.16729L4.74396 21.4299C4.35428 21.8133 3.84471 22.0001 3.33513 22.0001H3.32514C2.81556 22.0001 2.30599 21.8133 1.91631 21.4299L0 19.5674L1.05912 18.5253L2.97543 20.3877C3.16527 20.5745 3.48501 20.5745 3.68484 20.3877L7.10124 16.958L8.16036 18.0001L6.16858 20.001Z" })), wme = yn(Sme), Cme = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 2.00098H19C20.66 2.00098 22 3.34098 22 5.00098V19.001C22 20.661 20.66 22.001 19 22.001H8.28613L10.2889 19.991L7.09139 16.8447L3.32423 20.6254L2.01874 19.3391C2.00636 19.2282 2 19.1153 2 19.001V5.00098C2 3.34098 3.34 2.00098 5 2.00098ZM9.06001 16.421L16 12.411V12.421C16.33 12.231 16.33 11.781 16 11.591L9.06001 7.58098C8.71 7.37098 8.25 7.61098 8.25 7.99098V16.011C8.25 16.391 8.71 16.621 9.06001 16.421Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8.16051 20.0019L8.15953 20.001L4.74396 23.4299C4.35428 23.8133 3.84471 24.0001 3.33513 24.0001H3.32514C2.81556 24.0001 2.30599 23.8133 1.91631 23.4299L0 21.5674L1.05912 20.5253L2.97543 22.3877C3.16527 22.5745 3.48501 22.5745 3.68484 22.3877L7.10124 18.958L8.16036 20.0001L8.16051 20.0019Z" })), Nme = yn(Cme), u6 = {
  SNS: bme,
  LIVE_STREAMING: Nme,
  CHAT: wme
}, d6 = {
  DIGITAL_CONTENT: "멤버십 전용 디지털 콘텐츠",
  LIVE_STREAMING: "멤버십 전용 라이브 방송",
  CHANNEL: "멤버십 전용 채팅 채널",
  DM: "크리에이터와 1:1 메시지 혜택"
}, yW = {
  /**
   * 멤버십 전용 디지털 컨텐츠 제공
   */
  DigitalContent: "DIGITAL_CONTENT",
  /**
   * 라이브스트리밍
   */
  LiveStreaming: "LIVE_STREAMING",
  /**
   * 1:1대화
   */
  Dm: "DM",
  /**
   * 멤버십 전용 채널 참여
   */
  Channel: "CHANNEL"
}, jme = "marpple.tw", Eme = "ciety.dev", kme = "ciety.xyz", c8 = (e) => `@${e}`, Ku = (e) => {
  const n = `https://${window.location.host === jme ? Eme : kme}`;
  if (e.type === "home")
    return `${n}/${c8(e.subdomain)}`;
  if (e.type === "channel")
    return `${n}/${c8(e.subdomain)}/channels/${e.channelId}`;
  if (e.type === "settingsInfo")
    return `${n}/${c8(e.subdomain)}/settings/info`;
  if (e.type === "settingsChannel")
    return `${n}/${c8(e.subdomain)}/settings/channel`;
  if (e.type === "settingsGroup")
    return `${n}/${c8(e.subdomain)}/settings/group`;
  if (e.type === "settingsMember")
    return `${n}/${c8(e.subdomain)}/settings/member`;
  throw new Error("Unexpected params");
}, _me = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M21.75 9.59105C20.8667 8.57439 19.7333 7.79105 18.3833 7.25772C17.0333 6.72439 15.6 6.42438 14.0833 6.40772C12.5667 6.37438 11.15 6.55772 9.81667 6.95772C8.3 7.40772 7.08333 8.02439 6.21667 8.84105C5.33333 9.65772 4.81667 10.5411 4.68333 11.5077C4.53333 12.4744 4.76667 13.3911 5.38333 14.2577C5.95 15.0577 6.26667 15.8911 6.3 16.7244C6.35 17.6744 6.2 18.6077 6.2 18.6077C6.58333 18.2911 7.01667 18.0077 7.48333 17.7577C7.96667 17.5077 8.48333 17.3244 9.06667 17.2411C9.65 17.1411 10.2333 17.1577 10.8333 17.2411C11.9833 17.4744 13.1833 17.5911 14.45 17.5744C15.7167 17.5744 17 17.3244 18.3 16.8411C19.6 16.3577 20.75 15.5577 21.75 14.4077V18.2244C20.4 19.1744 18.8 19.8244 16.9333 20.1577C15.0833 20.4911 13.2 20.5244 11.3 20.2577C9.4 19.9744 7.68333 19.4244 6.18333 18.6077C4.83333 17.8744 3.75 16.9411 2.96667 15.8077C2.16667 14.6911 1.76667 13.4077 1.75 11.9911C1.8 9.42439 3 7.39105 5.38333 5.85772C7.76667 4.34105 10.55 3.55772 13.7333 3.54105C16.9167 3.52438 19.5833 4.25772 21.75 5.75772V9.59105Z" })), ek = yn(_me);
function Tme({ children: e, widthFull: t = !1, ...n }) {
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...n,
      className: $(
        "inline-flex shrink-0 items-center justify-center",
        "h-[2.85714rem] min-w-[6.85714rem] gap-[0.57143rem] rounded-[0.28571rem] px-[1.71429rem]",
        "bg-mshop-black text-ciety-lg disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50",
        {
          "w-full": t
        }
      ),
      children: (r) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsx(ek, { className: "size-[1.42857rem]" }),
        /* @__PURE__ */ a.jsx("span", { children: typeof e == "function" ? e(r) : e })
      ] })
    }
  );
}
const Mme = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M21.12 4.81H16.62V4.38C16.62 3.07 15.55 2 14.24 2H9.74C8.43 2 7.36 3.07 7.36 4.38V4.81H2.88C2.4 4.81 2 5.2 2 5.69C2 6.18 2.39 6.57 2.88 6.57H4.49L5.95 20.67C6.03 21.43 6.65 22.01 7.4 22.01H16.61C17.35 22.01 17.98 21.43 18.06 20.67L19.52 6.57H21.13C21.61 6.57 22.01 6.18 22.01 5.69C22.01 5.2 21.62 4.81 21.13 4.81H21.12ZM9.13 4.38C9.13 4.04 9.41 3.76 9.75 3.76H14.25C14.59 3.76 14.87 4.04 14.87 4.38V4.81H9.12V4.38H9.13ZM10.04 14.12C10.04 14.6 9.65 15 9.16 15C8.67 15 8.28 14.61 8.28 14.12V9.87C8.28 9.39 8.67 8.99 9.16 8.99C9.65 8.99 10.04 9.38 10.04 9.87V14.12ZM15.71 14.12C15.71 14.6 15.32 15 14.83 15C14.34 15 13.95 14.61 13.95 14.12V9.87C13.95 9.39 14.34 8.99 14.83 8.99C15.32 8.99 15.71 9.38 15.71 9.87V14.12Z" })), tk = yn(Mme);
function rz(e) {
  const { property1: t, ...n } = e;
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    t === "Edit" && /* @__PURE__ */ a.jsx(
      pm,
      {
        ...n,
        className: $(
          "flex size-[2.85714rem] shrink-0 items-center justify-center rounded-[0.57143rem] border border-mshop-gray-10 bg-mshop-white",
          "disabled:border-0 disabled:bg-mshop-gray-5"
        ),
        children: /* @__PURE__ */ a.jsx(nA, { className: "size-[1.42857rem] shrink-0 text-mshop-gray-20" })
      }
    ),
    t === "Delete" && /* @__PURE__ */ a.jsx(
      pm,
      {
        ...n,
        className: $(
          "flex size-[2.85714rem] shrink-0 items-center justify-center rounded-[0.57143rem] border border-mshop-gray-10 bg-mshop-white",
          "disabled:border-0 disabled:bg-mshop-gray-5"
        ),
        children: /* @__PURE__ */ a.jsx(tk, { className: "size-[1.42857rem] shrink-0 text-mshop-gray-20" })
      }
    ),
    t === "CIETY" && /* @__PURE__ */ a.jsx(
      pm,
      {
        ...n,
        className: $(
          "flex size-[2.85714rem] shrink-0 items-center justify-center rounded-[0.57143rem]",
          {
            "bg-ciety-lg": e.status === "Green",
            "border border-mshop-gray-10 bg-mshop-white": e.status === "Black"
          }
        ),
        children: /* @__PURE__ */ a.jsx(
          ek,
          {
            className: $("size-[1.42857rem] shrink-0", {
              "text-ciety-bk": e.status === "Green",
              "text-mshop-gray-20": e.status === "Black"
            })
          }
        )
      }
    )
  ] });
}
const Mj = "https://www.marppleshop.help", Rme = 60, Dme = 2, Pme = {
  DIGITAL_CONTENT: {
    title: "멤버십 전용 디지털 콘텐츠",
    descriptoin: `멤버십 회원만 볼 수 있는 독점 콘텐츠 채널을 만들어 보세요!
비하인드 컷, 미공개 콘텐츠 등 멤버십 회원들만 볼 수 있는 특별한 콘텐츠를 만들어 보세요.`,
    placeholder: "예시 : 멤버십 회원만 볼 수 있는 미공개 콘텐츠 혜택",
    rewardInformationList: [
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: "채널 설정에서 멤버십 그룹만 접근할 수 있도록 설정할 수 있습니다." }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: "편리한 에디터를 통해 이미지, 영상, 텍스트를 쉽게 업로드하고 관리할 수 있습니다." }),
      /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: [
        "멤버십 관련 궁금한 사항은",
        " ",
        /* @__PURE__ */ a.jsx("a", { className: "underline", href: Mj, target: "_blank", children: "크리에이터 가이드" }),
        "를 참고해 주세요."
      ] })
    ],
    cietyGuideImageUrl: kt.Admin.CietyGuideImagePosts
  },
  LIVE_STREAMING: {
    title: "멤버십 전용 라이브 스트림 채널",
    descriptoin: `멤버십 회원만 참여할 수 있는 단독 라이브 방송을 진행해 보세요.
실시간 Q&A, 창작 과정 공개, 비공개 팬미팅 등 특별한 시간을 만들어 보세요.`,
    placeholder: "예시 : 멤버십과 함께하는 라이브 스트리밍",
    rewardInformationList: [
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: "채널 설정에서 멤버십 그룹만 접근할 수 있도록 설정할 수 있습니다." }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: "라이브 방송 후, 다시 보기 영상을 멤버십 회원만 볼 수 있도록 업로드할 수 있어요." }),
      /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: [
        "멤버십 관련 궁금한 사항은",
        " ",
        /* @__PURE__ */ a.jsx("a", { className: "underline", href: Mj, target: "_blank", children: "크리에이터 가이드" }),
        "를 참고해 주세요."
      ] })
    ],
    cietyGuideImageUrl: kt.Admin.CietyGuideImageLiveStream
  },
  CHANNEL: {
    title: "멤버십 전용 채팅 채널",
    descriptoin: `멤버십 회원들과 함께 실시간으로 대화할 수 있는 전용 채팅방을 만들어 보세요!
라이브 전후 소통, 팬들과의 친밀한 대화, 창작 과정 공유까지 자유롭게 활용할 수 있어요.`,
    placeholder: "예시 : 멤버십 회원만 참여하는 채팅",
    rewardInformationList: [
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: "채널 설정에서 멤버십 그룹만 접근할 수 있도록 설정할 수 있습니다." }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: "멤버십 그룹만 참여해서 의견을 나누는 채팅 채널로 활용할 수 있습니다." }),
      /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: [
        "멤버십 관련 궁금한 사항은",
        " ",
        /* @__PURE__ */ a.jsx("a", { className: "underline", href: Mj, target: "_blank", children: "크리에이터 가이드" }),
        "를 참고해 주세요."
      ] })
    ],
    cietyGuideImageUrl: kt.Admin.CietyGuideImageChats
  },
  DM: {
    title: "크리에이터와 1:1 메시지 혜택",
    descriptoin: `멤버십 회원에게 크리에이터와 1:1 혹은 그룹으로 대화할 수 있는 혜택을 줄 수 있어요.
멤버십 그룹에게만 1:1 메시지 혜택을 제공하여 더욱 특별한 관계를 만들어 보세요.`,
    placeholder: "예시 : 저와 1:1 비밀 메시지로 이야기해요",
    rewardInformationList: [
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: "그룹 설정에서 멤버십 그룹의 메시지 권한을 허용하면 메시지 혜택이 설정됩니다." }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: "멤버십 그룸에게만 제공되는 1:1 대화 혜택으로 팬들과 직접 소통해 보세요." }),
      /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: [
        "멤버십 관련 궁금한 사항은",
        " ",
        /* @__PURE__ */ a.jsx("a", { className: "underline", href: Mj, target: "_blank", children: "크리에이터 가이드" }),
        "를 참고해 주세요."
      ] })
    ],
    cietyGuideImageUrl: kt.Admin.CietyGuideImageDm
  }
};
function Ome({
  communityRewardToEdit: e,
  selectedMembershipDaoSubdomain: t,
  onClose: n,
  onSubmit: r
}) {
  const {
    formState: { errors: s, isValid: o, isDirty: c },
    register: u,
    watch: m,
    handleSubmit: y
  } = bp({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      title: e.title ?? d6[e.type]
    }
  }), b = Pme[e.type], w = (k) => {
    r(k), n();
  };
  return /* @__PURE__ */ a.jsx(Zu, { show: !0, onClose: n, children: /* @__PURE__ */ a.jsxs("div", { className: "isolate flex max-h-[51.42857rem] flex-col overflow-hidden rounded-[1.14286rem] bg-mshop-white", children: [
    /* @__PURE__ */ a.jsxs("header", { className: "flex items-center justify-between border border-mshop-gray-5 p-[1.14286rem]", children: [
      /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-16-b text-mshop-black", children: "커뮤니티 혜택 설정하기" }),
      /* @__PURE__ */ a.jsx("button", { type: "button", onClick: n, children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.42857rem] text-mshop-black" }) })
    ] }),
    /* @__PURE__ */ a.jsxs("main", { className: "flex", children: [
      /* @__PURE__ */ a.jsxs(
        "form",
        {
          className: "flex w-[38.28571rem] flex-col border-r border-mshop-gray-5",
          onSubmit: y(w),
          children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[1.71429rem] px-[1.42857rem] py-[1.14286rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b pb-[0.28571rem] text-mshop-black", children: b.title }),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m whitespace-pre-wrap text-mshop-black", children: b.descriptoin })
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
                /* @__PURE__ */ a.jsx(Fs, { label: "혜택 제목", required: !0 }),
                /* @__PURE__ */ a.jsx(
                  vy,
                  {
                    ...u("title", Ss.rewardTitle),
                    placeholder: b.placeholder,
                    minRows: Dme,
                    maxLength: Rme,
                    watch: m("title"),
                    invalid: !!s.title
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "flex flex-col gap-[0.28571rem] rounded-[0.57143rem] bg-mshop-gray-5 p-[1.14286rem]", children: b.rewardInformationList.map((k, j) => /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[0.42857rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "size-[0.14286rem] rounded-full bg-mshop-gray-80" }),
                k
              ] }, j)) })
            ] }),
            /* @__PURE__ */ a.jsx("div", { className: "border-t border-mshop-gray-5 p-[1.42857rem]", children: /* @__PURE__ */ a.jsx(
              fn,
              {
                type: "submit",
                theme: "blue",
                variant: "lg",
                widthFull: !0,
                disabled: !o || !c,
                children: "혜택 설정하기"
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ a.jsxs("section", { className: "flex w-[27.42857rem] flex-col gap-[0.57143rem] px-[1.14286rem] pb-[2rem] pt-[1.14286rem]", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ a.jsx(Fs, { label: "커뮤니티 혜택 채널" }),
          /* @__PURE__ */ a.jsxs(
            "a",
            {
              className: "flex items-center gap-[0.28571rem]",
              href: Ku({
                type: e.type === "DM" ? "settingsGroup" : "settingsChannel",
                subdomain: t
              }),
              target: "_blank",
              children: [
                /* @__PURE__ */ a.jsx(HO, { className: "size-[1.14286rem] text-mshop-blue-100" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-blue-100", children: e.type === "DM" ? "그룹 설정하기" : "채널 설정하기" })
              ]
            }
          )
        ] }),
        e.type !== "DM" && e.channels.length ? /* @__PURE__ */ a.jsx("div", { className: "flex h-[26.71429rem] flex-col gap-[0.28571rem] overflow-y-auto rounded-[0.85714rem] border border-mshop-gray-10 pb-[1.14286rem] pl-[0.57143rem] pt-[0.57143rem]", children: [
          ...e.channels.filter(
            (k) => k.visibility !== "PRIVATE"
          ),
          ...e.channels.filter(
            (k) => k.visibility === "PRIVATE"
          )
        ].map((k) => {
          const j = u6[k.type];
          return /* @__PURE__ */ a.jsxs(
            "a",
            {
              className: "flex h-[2.85714rem] items-center gap-[0.28571rem] p-[0.57143rem] hover:bg-mshop-gray-5",
              href: k.visibility === "PRIVATE" ? Ku({
                type: "home",
                subdomain: t
              }) : Ku({
                type: "channel",
                subdomain: t,
                channelId: k.id
              }),
              target: "_blank",
              children: [
                /* @__PURE__ */ a.jsx(j, { className: "size-[1.42857rem] shrink-0 text-mshop-gray-80" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 grow text-left text-mshop-black", children: k.displayName ?? `비공개 채널 ${k.count}개` })
              ]
            },
            k.id
          );
        }) }) : /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.85714rem]", children: [
          /* @__PURE__ */ a.jsx(
            "img",
            {
              alt: "",
              src: b.cietyGuideImageUrl,
              className: "h-[19rem] w-[25.14286rem]"
            }
          ),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m whitespace-pre-wrap text-center text-mshop-gray-80", children: e.type === "DM" ? `커뮤니티 설정 그룹 설정 탭에서 멤버십 그룹의
메시지 권한을 허용하면 1:1 메시지 혜택이 추가됩니다.
메시지 혜택은 설정 완료 시, 사이어티 커뮤니티 혜택과
마플샵 멤버십 플랜에서 바로 확인할 수 있습니다.` : `제한 채널을 만들고 멤버십 그룹을 선택하면,
해당 채널이 멤버십 전용 커뮤니티 혜택으로 추가됩니다.
혜택 채널은 이곳에 자동으로 노출되며,
마플샵 멤버십 플랜에서도 확인할 수 있습니다.` })
        ] })
      ] })
    ] })
  ] }) });
}
const Ame = 150, vW = "sortable-handle", Lme = `.${vW}`, Ime = {
  DIGITAL_CONTENT: {
    description: "포스팅 채널",
    errorMessage: "버튼을 눌러 커뮤니티 혜택 제목과 채널을 설정해 주세요."
  },
  LIVE_STREAMING: {
    description: "라이브 스트림 채널",
    errorMessage: "버튼을 눌러 커뮤니티 혜택 제목과 채널을 설정해 주세요."
  },
  CHANNEL: {
    description: "채팅 채널",
    errorMessage: "버튼을 눌러 커뮤니티 혜택 제목과 채널을 설정해 주세요."
  },
  DM: {
    description: "크리에이터 1:1 메시지",
    errorMessage: "버튼을 눌러 커뮤니티 혜택 제목과 멤버십 그룹의 권한을 설정해 주세요."
  }
};
function Fme({
  communityRewards: e,
  selectedMembership: t,
  connectWithCietyCommunityButtonDiabled: n,
  isDeletionPending: r,
  onCommunityRewardsChange: s,
  onConnectWithCietyCommunityButtonClick: o
}) {
  const [c, u] = Re(null), m = (y) => {
    wt(c), s(
      e.map(
        (b) => b.type === c.type ? {
          ...b,
          title: y
        } : b
      )
    );
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "section",
      {
        className: $(
          "flex flex-col rounded-[0.57143rem] border border-mshop-gray-10 p-[1.42857rem]",
          t.dao && t.role ? "gap-[1.14286rem]" : "gap-[1.71429rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-end justify-between", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: "사이어티 커뮤니티 혜택" }),
              t.dao && t.role && /* @__PURE__ */ a.jsxs("span", { className: "flex gap-[0.57143rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-m text-mshop-gray-50", children: "Powered by" }),
                /* @__PURE__ */ a.jsx("a", { target: "_blank", href: l9, children: /* @__PURE__ */ a.jsx(nz, { className: "h-[1.14286rem] w-[5.71429rem] text-mshop-gray-50" }) })
              ] })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m whitespace-pre-wrap text-mshop-gray-80", children: `멤버십 회원이 마플샵 연동 사이어티에 가입하면, 사이어티에서 해당 멤버십 그룹에 자동으로 소속됩니다.
멤버십 그룹을 설정해 멤버십 전용 디지털 콘텐츠, 라이브 방송 등 다양한 혜택을 제공할 수 있습니다.` }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-wrap gap-[0.28571rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "사이어티의 자세한 소개는" }),
                /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.14286rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "a",
                    {
                      className: "typo-mshop-kr-14-m text-mshop-gray-80 underline",
                      target: "_blank",
                      href: l9,
                      children: "사이어티 홈페이지"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(WE, { className: "size-[1.14286rem] text-mshop-gray-80" })
                ] }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "를 확인해 주세요." })
              ] })
            ] })
          ] }),
          t.dao && t.role ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.28571rem] rounded-[0.85714rem] bg-mshop-gray-5 px-[1.42857rem] py-[1.71429rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[0.57143rem] rounded-[0.57143rem] bg-mshop-white py-[0.85714rem] pl-[3.14286rem] pr-[0.85714rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "멤버십 그룹명" }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex min-h-[2.85714rem] flex-grow items-center gap-[0.57143rem] rounded-[0.28571rem] bg-mshop-gray-5 pl-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx(JE, { className: "size-[1.14286rem] text-mshop-gray-80" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: t.role.displayName })
              ] }),
              /* @__PURE__ */ a.jsx(
                rz,
                {
                  type: "button",
                  property1: "Edit",
                  disabled: r,
                  onClick: () => window.open(
                    Ku({
                      type: "settingsGroup",
                      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                      subdomain: t.dao.subdomain
                    })
                  )
                }
              )
            ] }),
            /* @__PURE__ */ a.jsx(
              gw.ReactSortable,
              {
                list: e,
                animation: Ame,
                handle: Lme,
                className: "flex flex-col gap-[0.28571rem]",
                disabled: r,
                setList: s,
                children: e.map((y) => {
                  const b = Ime[y.type], w = y.type === yW.Dm ? y.dm : y.channels.length > 0;
                  return /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: "flex flex-col gap-[0.85714rem] rounded-[0.57143rem] bg-mshop-white px-[0.85714rem] pb-[1.14286rem] pt-[0.85714rem]",
                      children: [
                        /* @__PURE__ */ a.jsxs("div", { className: "flex h-[3.14286rem] items-center gap-[0.57143rem]", children: [
                          /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: vW,
                              disabled: r,
                              children: /* @__PURE__ */ a.jsx(yw, { className: "size-[1.71429rem] text-mshop-gray-20" })
                            }
                          ),
                          /* @__PURE__ */ a.jsxs("div", { className: "flex grow flex-col", children: [
                            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-b line-clamp-1 break-all text-mshop-black", children: y.title ?? d6[y.type] }),
                            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-black", children: b.description })
                          ] }),
                          /* @__PURE__ */ a.jsx(
                            rz,
                            {
                              type: "button",
                              property1: "Edit",
                              disabled: r,
                              onClick: () => u(y)
                            }
                          )
                        ] }),
                        w ? y.type === "DM" ? y.dm && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m pl-[2.28571rem] text-mshop-blue-100", children: "현재 플랜의 멤버십 그룹은 크리에이터에게 메시지를 보낼 수 있습니다." }) : /* @__PURE__ */ a.jsx("div", { className: "flex flex-wrap gap-[0.28571rem] pl-[2.28571rem]", children: [
                          ...y.channels.filter(
                            (k) => k.visibility !== "PRIVATE"
                          ),
                          ...y.channels.filter(
                            (k) => k.visibility === "PRIVATE"
                          )
                        ].map((k) => {
                          wt(t.dao);
                          const j = u6[k.type];
                          return /* @__PURE__ */ a.jsxs(
                            "a",
                            {
                              className: "flex min-h-[2.85714rem] max-w-[13.42857rem] items-center gap-[0.28571rem] rounded-[0.28571rem] bg-mshop-gray-5 px-[0.85714rem]",
                              href: k.visibility === "PRIVATE" ? Ku({
                                type: "home",
                                subdomain: t.dao.subdomain
                              }) : Ku({
                                type: "channel",
                                subdomain: t.dao.subdomain,
                                channelId: k.id
                              }),
                              target: "_blank",
                              children: [
                                /* @__PURE__ */ a.jsx(j, { className: "size-[1.14286rem] shrink-0 text-mshop-gray-80" }),
                                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m truncate text-mshop-gray-80", children: k.displayName ?? `비공개 채널 ${k.count}개` })
                              ]
                            },
                            k.id
                          );
                        }) }) : /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.28571rem] pl-[2.28571rem] text-mshop-red-80", children: [
                          /* @__PURE__ */ a.jsx(nA, { className: "size-[1.14286rem] shrink-0" }),
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m", children: b.errorMessage })
                        ] })
                      ]
                    },
                    y.id
                  );
                })
              }
            )
          ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex items-end justify-between", children: [
            /* @__PURE__ */ a.jsx(
              Tme,
              {
                type: "button",
                disabled: n,
                onClick: o,
                children: "사이어티 커뮤니티 연동하기"
              }
            ),
            /* @__PURE__ */ a.jsxs("span", { className: "flex gap-[0.57143rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-m text-mshop-gray-50", children: "Powered by" }),
              /* @__PURE__ */ a.jsx("a", { target: "_blank", href: l9, children: /* @__PURE__ */ a.jsx(nz, { className: "h-[1.14286rem] w-[5.71429rem] text-mshop-gray-50" }) })
            ] })
          ] })
        ]
      }
    ),
    c && /* @__PURE__ */ a.jsx(
      Ome,
      {
        communityRewardToEdit: c,
        selectedMembershipDaoSubdomain: t.dao.subdomain,
        onClose: () => u(null),
        onSubmit: (y) => m(y.title)
      }
    )
  ] });
}
const Ume = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M11.0485 10.0021L17.2816 3.76042C17.5728 3.46875 17.5728 3.00208 17.2816 2.71875C16.9903 2.42708 16.5243 2.42708 16.233 2.71875L10 8.95208L3.76699 2.71875C3.47573 2.42708 3.00971 2.42708 2.71845 2.71875C2.42718 3.01042 2.42718 3.47708 2.71845 3.76042L8.95146 10.0021L2.71845 16.2437C2.42718 16.5354 2.42718 17.0021 2.71845 17.2854C2.85992 17.4271 3.05132 17.5021 3.24272 17.5021C3.43412 17.5021 3.6172 17.4271 3.76699 17.2854L10 11.0521L16.233 17.2854C16.3745 17.4271 16.5659 17.5021 16.7573 17.5021C16.9487 17.5021 17.1318 17.4271 17.2816 17.2854C17.5728 16.9937 17.5728 16.5271 17.2816 16.2437L11.0485 10.0021Z" })), Zg = yn(Ume);
function zme({
  selectedMembershipDaoSubdomain: e,
  onClose: t,
  onCreatorGuideTextClick: n,
  onCheckMyMembershipButtonClick: r
}) {
  return /* @__PURE__ */ a.jsx(Zu, { show: !0, onClose: t, children: /* @__PURE__ */ a.jsxs("div", { className: "relative flex w-[32rem] flex-col overflow-hidden rounded-[1.14286rem] bg-mshop-blue-100", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex-center relative h-[25.71429rem] overflow-hidden", children: [
      /* @__PURE__ */ a.jsx(
        "img",
        {
          alt: "",
          src: kt.KeyVisual.MembershipMeetFan,
          className: "object-cover"
        }
      ),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-40-bebas-b absolute bottom-[2.29rem] left-1/2 -translate-x-1/2 whitespace-nowrap text-center text-mshop-white", children: "MEMBERSHIP OPEN!" })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[2.28571rem] bg-mshop-white p-[1.71429rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center gap-[0.85714rem]", children: [
        /* @__PURE__ */ a.jsx("ul", { className: "list-disc pl-[1.42857rem]", children: [
          "멤버십 결제 금액은 판매가 시작되면 변경할 수 없습니다.",
          "멤버십에서 약속한 혜택은 반드시 계획한 대로 제공해 주세요.",
          "멤버십 회원의 개인정보는 외부로 유출되지 않도록 주의해 주세요.",
          "멤버십 회원과 커뮤니티에서 활발히 소통하고, 커뮤니티 혜택을 알차게 제공해 보세요!"
        ].map((s, o) => /* @__PURE__ */ a.jsx("li", { className: "typo-mshop-kr-14-m text-mshop-black", children: s }, o)) }),
        /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: "typo-mshop-kr-14-m w-fit text-mshop-blue-100 underline",
            onClick: n,
            children: "크리에이터 가이드 보러가기"
          }
        )
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.85714rem]", children: [
        /* @__PURE__ */ a.jsx(
          fn,
          {
            type: "button",
            variant: "md",
            theme: "blue",
            widthFull: !0,
            onClick: () => {
              t(), r();
            },
            children: "내 멤버십 확인하기"
          }
        ),
        /* @__PURE__ */ a.jsx(
          fn,
          {
            type: "button",
            variant: "md",
            theme: "line",
            widthFull: !0,
            onClick: () => {
              t(), window.open(
                Ku({
                  type: "home",
                  subdomain: e
                })
              );
            },
            children: "내 커뮤니티 보러가기"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a.jsx("div", { className: "absolute right-[0.57143rem] top-[0.57143rem]", children: /* @__PURE__ */ a.jsx(
      "button",
      {
        type: "button",
        className: "flex-center size-[2.85714rem] shrink-0 rounded-full bg-mshop-dim-10",
        onClick: t,
        children: /* @__PURE__ */ a.jsx(Zg, { className: "size-[1.42857rem] text-mshop-gray-20" })
      }
    ) })
  ] }) });
}
var Id = [];
for (var iR = 0; iR < 256; ++iR)
  Id.push((iR + 256).toString(16).slice(1));
function Bme(e, t = 0) {
  return (Id[e[t + 0]] + Id[e[t + 1]] + Id[e[t + 2]] + Id[e[t + 3]] + "-" + Id[e[t + 4]] + Id[e[t + 5]] + "-" + Id[e[t + 6]] + Id[e[t + 7]] + "-" + Id[e[t + 8]] + Id[e[t + 9]] + "-" + Id[e[t + 10]] + Id[e[t + 11]] + Id[e[t + 12]] + Id[e[t + 13]] + Id[e[t + 14]] + Id[e[t + 15]]).toLowerCase();
}
var Rj, Hme = new Uint8Array(16);
function Vme() {
  if (!Rj && (Rj = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Rj))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Rj(Hme);
}
var $me = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const az = {
  randomUUID: $me
};
function Gme(e, t, n) {
  if (az.randomUUID && !t && !e)
    return az.randomUUID();
  e = e || {};
  var r = e.random || (e.rng || Vme)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Bme(r);
}
const Wme = ({
  show: e,
  prevFormInfo: t,
  onClose: n,
  onClickAdd: r,
  onClickUpdate: s,
  onCreatorGuideTextClick: o
}) => {
  const {
    register: c,
    watch: u,
    handleSubmit: m,
    reset: y,
    formState: { isDirty: b, isValid: w, errors: k },
    setValue: j
  } = bp({
    reValidateMode: "onChange",
    mode: "onChange",
    defaultValues: { title: "" }
  }), E = () => {
    const D = u("title").trim();
    j("title", D === "" ? "" : D, {
      shouldValidate: !0
    });
  }, T = (D) => {
    const { id: L, title: I } = D;
    t ? s(L, I) : r(L, I);
  };
  return /* @__PURE__ */ a.jsx(
    Zu,
    {
      onClose: () => n(!!t),
      show: e,
      beforeEnter: () => {
        y(
          t ? { ...t, title: t.title || "" } : { title: "", type: ss.Custom, id: Gme() }
        );
      },
      isCloseOnClickOutside: !1,
      children: e && /* @__PURE__ */ a.jsxs(
        "form",
        {
          className: "flex max-h-[51.429rem] w-[43.429rem] flex-col rounded-[1.143rem] bg-mshop-white",
          onSubmit: m(T),
          children: [
            /* @__PURE__ */ a.jsxs("header", { className: "flex items-center justify-between border-b border-mshop-gray-5 p-[1.143rem]", children: [
              /* @__PURE__ */ a.jsxs("span", { className: "text-mshop-mshop-black typo-mshop-kr-16-b", children: [
                "사이어티 커뮤니티 혜택 ",
                t ? "변경하기" : "추가하기"
              ] }),
              /* @__PURE__ */ a.jsx("button", { onClick: () => n(!!t), type: "button", children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.429rem] fill-mshop-black" }) })
            ] }),
            /* @__PURE__ */ a.jsxs("main", { className: "flex grow flex-col gap-y-[1.714rem] overflow-y-auto px-[1.429rem] py-[1.143rem]", children: [
              /* @__PURE__ */ a.jsxs("section", { className: "text-mshop-black", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b", children: "크리에이터 커스텀 혜택" }),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m whitespace-pre", children: "멤버십 회원들에게 제공할 혜택을 자유롭게 작성할 수 있습니다." })
              ] }),
              /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.571rem]", children: [
                /* @__PURE__ */ a.jsx(Fs, { label: "혜택 제목", required: !0 }),
                /* @__PURE__ */ a.jsx(
                  vy,
                  {
                    ...c("title", Ss.rewardTitle),
                    watch: u("title"),
                    maxLength: Ss.rewardTitle.maxLength.value,
                    placeholder: "예시 : 공개 라이브 방송에서 멤버십 닉네임 불러드릴게요!",
                    invalid: !!k.title,
                    minRows: 2,
                    onBlur: E
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsx("section", { className: "rounded-[0.571rem] bg-mshop-gray-5", children: /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m flex flex-col gap-y-[0.286rem] p-[1.143rem] text-mshop-gray-80", children: [
                /* @__PURE__ */ a.jsx(il, { children: "이 혜택은 설정이 따로 필요없는 크리에이터 커스텀 혜택 메뉴입니다." }),
                /* @__PURE__ */ a.jsx(il, { children: "텍스트로 자유롭게 멤버십에 대한 매력과 어필을 표현해 멤버십 혜택을 꾸며 보세요." }),
                /* @__PURE__ */ a.jsxs(il, { children: [
                  "멤버십 관련 궁금한 사항은",
                  " ",
                  /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      type: "button",
                      className: "typo-mshop-kr-14-m underline underline-offset-2",
                      onClick: o,
                      children: "크리에이터 가이드"
                    }
                  ),
                  "를 참고해 주세요."
                ] })
              ] }) })
            ] }),
            /* @__PURE__ */ a.jsx("footer", { className: "border-t border-mshop-gray-5 px-[1.429rem] py-[1.143rem]", children: /* @__PURE__ */ a.jsx(
              za,
              {
                variant: "md",
                theme: "blue",
                widthFull: !0,
                type: "submit",
                disabled: !w || !b,
                children: t ? "혜택 변경하기" : "혜택 추가하기"
              }
            ) })
          ]
        }
      )
    }
  );
};
function Yme(e) {
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...e,
      className: $(
        "flex-center size-[2.85714rem] rounded-[.28571rem] bg-mshop-blue-100",
        "disabled:bg-mshop-gray-10"
      ),
      children: /* @__PURE__ */ a.jsx(HO, { className: "size-[1.71428rem] text-mshop-white" })
    }
  );
}
const kc = (e) => {
  const t = window.getComputedStyle(
    document.documentElement
  ).fontSize;
  return parseFloat(t) * e;
}, qme = 3, sz = (e, t) => Qu(
  e,
  parseFloat,
  (n) => n * t,
  kc,
  Math.ceil,
  String
);
function aa({
  src: e,
  alt: t = "",
  width: n,
  height: r,
  multiplicationFactor: s = qme,
  objectFit: o,
  ...c
}) {
  const u = new URLSearchParams();
  n && u.append("width", sz(n, s)), r && u.append("height", sz(r, s));
  const m = u.toString(), y = `${e}${m ? `?${m}` : ""}`;
  return /* @__PURE__ */ a.jsx(
    "img",
    {
      ...c,
      src: y,
      alt: t,
      className: "size-full",
      style: {
        objectFit: o
      }
    }
  );
}
const Kme = [
  {
    title: "커뮤니티 이벤트 우선 참여 혜택",
    description: "마플샵 멤버십과 연동된 커뮤니티에서 이벤트 우선 참여 혜택을 줄 수 있습니다."
  },
  {
    title: "SNS 메시지에 답변해주기",
    description: "운영중인 SNS에서 멤버십 회원 메시지에 답변해 줄 수 있습니다."
  },
  {
    title: "멤버십 독점 라이브 방송 초대 링크",
    description: "멤버십 회원만을 위한 비공개 라이브 방송에 초대받을 수 있는 혜택을 제공합니다."
  },
  {
    title: "공개 라이브 방송에서 멤버십 닉네임 외치기",
    description: "공개 라이브 방송 중 멤버십 회원의 닉네임을 불러주거나 메시지를 전할 수 있습니다."
  },
  {
    title: "오프라인 행사 우선 입장권",
    description: "오프라인 이벤트에 우선 입장할 수 있는 기회로 특별한 경험을 만들어 줄 수 있습니다."
  }
], Xme = ({
  show: e,
  onClose: t,
  onClickAdd: n
}) => /* @__PURE__ */ a.jsx(Zu, { onClose: t, show: e, children: /* @__PURE__ */ a.jsxs("div", { className: "w-[43.429rem] overflow-hidden rounded-[1.143rem] border-mshop-gray-5 bg-mshop-white", children: [
  /* @__PURE__ */ a.jsxs("header", { className: "flex items-center justify-between p-[1.143rem]", children: [
    /* @__PURE__ */ a.jsx("span", { className: "text-mshop-mshop-black typo-mshop-kr-16-b", children: "크리에이터 혜택 추가하기" }),
    /* @__PURE__ */ a.jsx("button", { onClick: t, type: "button", children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.429rem] fill-mshop-black" }) })
  ] }),
  /* @__PURE__ */ a.jsx("ul", { children: /* @__PURE__ */ a.jsxs("li", { className: "group flex justify-between gap-x-[0.857rem] px-[1.143rem] py-[0.857rem] hover:bg-mshop-gray-5", children: [
    /* @__PURE__ */ a.jsx("div", { className: "size-[7.143rem]", children: /* @__PURE__ */ a.jsx(
      aa,
      {
        src: kt.Admin.RewardItemCustom,
        width: "7.1429rem",
        height: "7.1429rem",
        objectFit: "cover",
        alt: ""
      }
    ) }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex-1", children: [
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "크리에이터 커스텀 혜택" }),
      /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m whitespace-pre-line text-mshop-gray-80 group-hover:text-mshop-black", children: "멤버십 회원들에게 제공할 혜택을 자유롭게 작성할 수 있습니다." })
    ] }),
    /* @__PURE__ */ a.jsx("div", { className: "flex-shrink-0 self-center", children: /* @__PURE__ */ a.jsx(Yme, { type: "button", onClick: n }) })
  ] }) }),
  /* @__PURE__ */ a.jsx("div", { className: "pb-[1.14286rem] pl-[1.14286rem] pr-[1.14286rem] pt-[0.57143rem]", children: /* @__PURE__ */ a.jsxs("div", { className: "border-gray-5 flex flex-col gap-y-[0.57143rem] rounded-[0.57143rem] border px-[1.71429rem] py-[1.14286rem]", children: [
    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "크리에이터 커스텀 혜택, 이렇게 활용해 보세요!" }),
    Kme.map(({ title: r, description: s }) => /* @__PURE__ */ a.jsxs("div", { children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m text-mshop-black", children: r }),
      /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m flex items-center gap-x-[0.42857rem] text-mshop-gray-80", children: [
        /* @__PURE__ */ a.jsx("span", { className: "inline-block size-[0.14286rem] rounded-full bg-mshop-gray-80" }),
        s
      ] })
    ] }, r))
  ] }) })
] }) }), Qme = 150, Zme = ({ onCreatorGuideTextClick: e }) => {
  const { watch: t, setValue: n } = xp(), { settingMembership: r } = u5(), s = t("creatorReward") || [], o = s.length === 0, c = !r.changeable, [u, m] = Re(!1), [y, b] = Re(!1), [w, k] = Re(null), j = async (D) => {
    wt(r), await ho({
      body: (I, R) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: I,
            text: "삭제",
            color: r.state === nl.Open ? "red" : "blue"
          },
          cancelButton: {
            props: R
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 혜택 삭제" }),
            /* @__PURE__ */ a.jsx("div", { children: r.state === nl.Open ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              "설정된 혜택이 삭제되며 복구할 수 없습니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "기존 회원들에게 이메일 안내가 발송됩니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "정말 삭제할까요?"
            ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              "혜택 설정값이 모두 삭제됩니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "해당 멤버십 혜택을 삭제할까요?"
            ] }) })
          ] })
        }
      )
    }) && n(
      "creatorReward",
      s.filter((I) => I.id !== D),
      { shouldValidate: !0, shouldDirty: !0 }
    );
  }, E = (D, L) => {
    n(
      "creatorReward",
      [...s, { title: L, id: D, type: ss.Custom }],
      { shouldValidate: !0, shouldDirty: !0 }
    ), b(!1);
  }, T = (D, L) => {
    wt(s), n(
      "creatorReward",
      s.map(
        (I) => I.id === D ? { ...I, title: L } : I
      ),
      { shouldValidate: !0, shouldDirty: !0 }
    ), b(!1), k(null);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "section",
      {
        className: $(
          "flex w-full flex-col rounded-lg border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]",
          o ? "gap-y-[1.714rem]" : "gap-y-[1.143rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "크리에이터 혜택" }),
            o && /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "어떤 멤버십 혜택을 줄지 자유롭게 작성할 수 있는 크리에이터 혜택입니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "멤버십 회원에게만 주는 특별한 혜택을 구성해 멤버십을 매력적으로 만들어서 성공적으로 판매해 보세요."
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
            /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx(
              za,
              {
                variant: "sm",
                theme: "white",
                iconFront: "add",
                onClick: () => m(!0),
                disabled: c,
                type: "button",
                children: "혜택 추가하기"
              }
            ) }),
            !o && /* @__PURE__ */ a.jsx(
              gw.ReactSortable,
              {
                className: "flex flex-col gap-y-[0.286rem] rounded-xl bg-mshop-gray-5 px-[1.43rem] py-[1.71rem]",
                list: t("creatorReward"),
                setList: (D) => {
                  E9(t("creatorReward"), D) || n("creatorReward", D, {
                    shouldValidate: !0,
                    shouldDirty: !0
                  });
                },
                animation: Qme,
                group: "creator-reward",
                children: s.map((D) => /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: "rounded-lg bg-mshop-white p-[0.86rem]",
                    children: /* @__PURE__ */ a.jsxs("div", { className: "product-reward flex items-center gap-x-[0.57142rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        yw,
                        {
                          className: $(
                            "sortable-handle size-[1.71429rem] fill-mshop-gray-20",
                            { "cursor-pointer": !c }
                          )
                        }
                      ),
                      /* @__PURE__ */ a.jsxs("div", { className: "flex-1", children: [
                        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-b line-clamp-1 text-ellipsis break-all text-mshop-black", children: D.title }),
                        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-black", children: "크리에이터 커스텀 혜택" })
                      ] }),
                      /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.286rem]", children: [
                        /* @__PURE__ */ a.jsx(
                          "button",
                          {
                            type: "button",
                            className: "flex-center border-mhsop-gray-20 rounded-lg border p-[0.63rem]",
                            onClick: () => {
                              b(!0), k(D.id);
                            },
                            disabled: c,
                            children: /* @__PURE__ */ a.jsx(nA, { className: "size-5 fill-mshop-gray-20" })
                          }
                        ),
                        /* @__PURE__ */ a.jsx(
                          "button",
                          {
                            type: "button",
                            className: "flex-center border-mhsop-gray-20 rounded-lg border p-[0.63rem]",
                            onClick: () => j(D.id),
                            disabled: c,
                            children: /* @__PURE__ */ a.jsx(tk, { className: "size-5 fill-mshop-gray-20" })
                          }
                        )
                      ] })
                    ] })
                  },
                  D.id
                ))
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(
      Xme,
      {
        show: u,
        onClose: () => m(!1),
        onClickAdd: () => {
          m(!1), b(!0);
        }
      }
    ),
    /* @__PURE__ */ a.jsx(
      Wme,
      {
        show: y,
        onClose: (D) => {
          b(!1), D ? k(null) : m(!0);
        },
        onCreatorGuideTextClick: e,
        onClickUpdate: T,
        onClickAdd: E,
        prevFormInfo: (s == null ? void 0 : s.find(
          (D) => D.id === w
        )) || null
      }
    )
  ] });
}, z9 = `${Bt}/thumbnail-Image-membership.png`, Jme = ({
  selectedMembership: e,
  setIsFileUploadLoading: t
}) => {
  var E;
  const {
    register: n,
    watch: r,
    formState: { errors: s },
    setValue: o,
    setError: c
  } = xp(), { client: u } = Ha(), m = (T) => {
    var L;
    const D = ((L = r(T)) == null ? void 0 : L.trim()) || "";
    o(T, D === "" ? "" : D, {
      shouldValidate: !0
    });
  }, y = r("thumbnailImageUrl"), b = Rt(null), w = n(
    "thumbnailImageUrl",
    Ss.membershipThumbnail
  ), k = y === z9, j = !e.changeable;
  return /* @__PURE__ */ a.jsx(
    "section",
    {
      className: "flex w-full flex-col gap-y-[2.86rem] rounded-lg border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]",
      id: "membership-create-info-section",
      children: /* @__PURE__ */ a.jsxs("div", { children: [
        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b mb-[1.14rem] text-mshop-black", children: "멤버십 정보" }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.71rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
            /* @__PURE__ */ a.jsx(Fs, { label: "멤버십 이름", required: !0 }),
            /* @__PURE__ */ a.jsx(
              M8,
              {
                ...n("displayName", {
                  ...Ss.membershipName,
                  validate: {
                    notOnlySpecialChars: (T) => rO(T) ? "특수문자만으로 이름을 작성할 수 없습니다. 문자를 포함해 입력해 주세요." : !0
                  }
                }),
                disabled: j,
                watch: r("displayName") || "",
                maxLength: Ss.membershipName.maxLength.value,
                placeholder: "멤버십 이름을 설정해 주세요.",
                invalid: !!s.displayName,
                onBlur: () => {
                  m("displayName");
                }
              }
            ),
            s.displayName && s.displayName.message && /* @__PURE__ */ a.jsx(sl, { message: s.displayName.message })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
            /* @__PURE__ */ a.jsx(Fs, { label: "멤버십 소개" }),
            /* @__PURE__ */ a.jsx(
              vy,
              {
                ...n("description", Ss.membershipDescription),
                disabled: j,
                watch: r("description") || "",
                maxLength: Ss.membershipDescription.maxLength.value,
                placeholder: "멤버십에 대해 간략하게 소개해 주세요.",
                invalid: !!s.description,
                minRows: 2,
                onBlur: () => {
                  m("description");
                }
              }
            ),
            s.description && s.description.message && /* @__PURE__ */ a.jsx(sl, { message: s.description.message })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
            /* @__PURE__ */ a.jsx(Fs, { label: "썸네일 이미지" }),
            /* @__PURE__ */ a.jsx(
              "div",
              {
                className: "relative flex size-[28.57143rem] flex-col justify-end rounded-[0.57143rem] border border-mshop-gray-20 bg-cover bg-center bg-no-repeat",
                style: {
                  backgroundImage: `url(${y || z9})`
                },
                children: !j && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                  /* @__PURE__ */ a.jsx(
                    SD,
                    {
                      ref: b,
                      name: w.name,
                      title: "이미지 업로드하기",
                      onLoading: t,
                      onError: (T) => c("thumbnailImageUrl", {
                        message: T
                      }),
                      onSuccess: (T) => {
                        o("thumbnailImageUrl", T, {
                          shouldValidate: !0,
                          shouldDirty: !0
                        });
                      },
                      recommended: "664*664px 이상",
                      client: u,
                      minImageWidth: 664,
                      minImageHeight: 664
                    }
                  ),
                  y && !k && /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      type: "button",
                      className: "flex-center absolute -right-[0.571rem] -top-[0.571rem] h-[2.28571rem] w-[2.28571rem] rounded-full bg-mshop-gray-80",
                      onClick: () => o("thumbnailImageUrl", "", {
                        shouldValidate: !0,
                        shouldDirty: !0
                      }),
                      children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[0.85714rem] fill-mshop-white" })
                    }
                  )
                ] })
              }
            ),
            ((E = s.thumbnailImageUrl) == null ? void 0 : E.message) && /* @__PURE__ */ a.jsx(
              sl,
              {
                message: s.thumbnailImageUrl.message
              }
            )
          ] })
        ] })
      ] })
    }
  );
}, ehe = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, the = (e, t, n) => {
  let r;
  const s = ehe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " 후" : r + " 전" : r;
}, nhe = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, rhe = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ahe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, she = {
  date: R8({
    formats: nhe,
    defaultWidth: "full"
  }),
  time: R8({
    formats: rhe,
    defaultWidth: "full"
  }),
  dateTime: R8({
    formats: ahe,
    defaultWidth: "full"
  })
}, ihe = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, ohe = (e, t, n, r) => ihe[e], lhe = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, che = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, uhe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ],
  wide: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ]
}, dhe = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, fhe = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, mhe = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, hhe = (e, t) => {
  const n = Number(e);
  switch (String(t == null ? void 0 : t.unit)) {
    case "minute":
    case "second":
      return String(n);
    case "date":
      return n + "일";
    default:
      return n + "번째";
  }
}, phe = {
  ordinalNumber: hhe,
  era: ny({
    values: lhe,
    defaultWidth: "wide"
  }),
  quarter: ny({
    values: che,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ny({
    values: uhe,
    defaultWidth: "wide"
  }),
  day: ny({
    values: dhe,
    defaultWidth: "wide"
  }),
  dayPeriod: ny({
    values: fhe,
    defaultWidth: "wide",
    formattingValues: mhe,
    defaultFormattingWidth: "wide"
  })
}, ghe = /^(\d+)(일|번째)?/i, yhe = /\d+/i, vhe = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, xhe = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, bhe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, She = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, whe = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, Che = {
  any: [
    /^1월?$/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, Nhe = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, jhe = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, Ehe = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, khe = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, _he = {
  ordinalNumber: uW({
    matchPattern: ghe,
    parsePattern: yhe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ry({
    matchPatterns: vhe,
    defaultMatchWidth: "wide",
    parsePatterns: xhe,
    defaultParseWidth: "any"
  }),
  quarter: ry({
    matchPatterns: bhe,
    defaultMatchWidth: "wide",
    parsePatterns: She,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ry({
    matchPatterns: whe,
    defaultMatchWidth: "wide",
    parsePatterns: Che,
    defaultParseWidth: "any"
  }),
  day: ry({
    matchPatterns: Nhe,
    defaultMatchWidth: "wide",
    parsePatterns: jhe,
    defaultParseWidth: "any"
  }),
  dayPeriod: ry({
    matchPatterns: Ehe,
    defaultMatchWidth: "any",
    parsePatterns: khe,
    defaultParseWidth: "any"
  })
}, I4 = {
  code: "ko",
  formatDistance: the,
  formatLong: she,
  formatRelative: ohe,
  localize: phe,
  match: _he,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, The = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M7.42998 11.6671C7.7466 12.1424 8.44493 12.1424 8.76156 11.6671L13.0409 5.24337C13.395 4.71171 13.0139 3.99984 12.3751 3.99984H3.81647C3.17764 3.99984 2.7965 4.71171 3.15067 5.24337L7.42998 11.6671Z" })), Z4 = yn(The), Mhe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.25 16.88C13.25 17.57 12.69 18.13 12 18.13C11.31 18.13 10.75 17.57 10.75 16.88V11.63C10.75 10.94 11.31 10.38 12 10.38C12.69 10.38 13.25 10.94 13.25 11.63V16.88ZM12 8.38C11.31 8.38 10.75 7.82 10.75 7.13C10.75 6.44 11.31 5.88 12 5.88C12.69 5.88 13.25 6.44 13.25 7.13C13.25 7.82 12.69 8.38 12 8.38Z" })), D8 = yn(Mhe), cr = {
  Ko: "ko-KR"
}, iz = {
  P100: 100,
  // 개발 모드에서만 사용
  P900: 900,
  P1900: 1900,
  P2900: 2900,
  P3900: 3900,
  P4900: 4900,
  P5900: 5900,
  P6900: 6900,
  P7900: 7900,
  P8900: 8900,
  P9900: 9900,
  P15000: 15e3,
  P20000: 2e4,
  P25000: 25e3,
  P30000: 3e4,
  P35000: 35e3,
  P40000: 4e4,
  P45000: 45e3,
  P50000: 5e4,
  P55000: 55e3,
  P60000: 6e4,
  P65000: 65e3,
  P70000: 7e4,
  P75000: 75e3,
  P80000: 8e4,
  P85000: 85e3,
  P90000: 9e4,
  P95000: 95e3,
  P100000: 1e5,
  P200000: 2e5,
  P300000: 3e5,
  P400000: 4e5,
  P500000: 5e5,
  P600000: 6e5,
  P700000: 7e5,
  P800000: 8e5,
  P900000: 9e5,
  P1000000: 1e6
}, Rhe = Qt({
  isDevMode: window.location.href.includes("marpple.tw") || !1
}), f6 = () => {
  const [e, t] = Ar(Rhe);
  return {
    ...e,
    setAppConfig: t
  };
}, S2 = (e) => nme(ame(e, 0), 0), Dhe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_16141_31452)" }, /* @__PURE__ */ re.createElement("path", { d: "M7.92169 12.8334H6.08419C5.80419 12.8334 5.57085 12.6059 5.57085 12.3201C5.57085 12.0342 5.79835 11.8067 6.08419 11.8067H7.92169C8.20169 11.8067 8.43502 12.0342 8.43502 12.3201C8.43502 12.6059 8.20752 12.8334 7.92169 12.8334Z" }), /* @__PURE__ */ re.createElement("path", { d: "M11.62 7.29172L10.2375 6.36422C10.2375 6.27672 10.2375 6.22422 10.2375 6.22422C10.1909 5.58839 10.045 4.95839 9.80585 4.36339C9.15252 2.72422 7.98002 1.69756 7.50752 1.33006C7.36752 1.21922 7.19252 1.16089 7.01169 1.16089C6.83085 1.16089 6.65585 1.21922 6.51585 1.33006C6.04335 1.69756 4.87085 2.72422 4.21752 4.36339C3.97835 4.95839 3.83252 5.58256 3.78002 6.22422C3.78002 6.22422 3.78002 6.27672 3.78002 6.36422L2.39752 7.29172C2.13502 7.45506 2.01252 7.71756 2.07669 7.97422L2.57252 11.4159C2.66002 11.7717 3.06252 12.0051 3.49419 12.0051C3.64002 12.0051 3.79169 11.9759 3.93169 11.9234L5.72835 10.8967C5.72835 10.8967 5.75169 10.9026 5.75752 10.9026H8.27752C8.27752 10.9026 8.30085 10.8967 8.30669 10.8967L10.1034 11.9234C10.2434 11.9817 10.395 12.0051 10.5409 12.0051C10.9725 12.0051 11.375 11.7717 11.4625 11.4159L11.9584 7.97422C12.0167 7.71756 11.8942 7.46089 11.6375 7.29172H11.62ZM3.52335 10.9609L3.10335 8.03839L3.87335 7.51922C4.00169 8.24256 4.29335 9.18756 4.92335 10.1617L3.52335 10.9609ZM6.41669 5.82756C6.41669 5.50672 6.67919 5.24422 7.00002 5.24422C7.32085 5.24422 7.58335 5.50672 7.58335 5.82756C7.58335 6.14839 7.32085 6.41089 7.00002 6.41089C6.67919 6.41089 6.41669 6.14839 6.41669 5.82756ZM10.4767 10.9609L9.07669 10.1617C9.70085 9.19339 9.99252 8.24256 10.1267 7.51922L10.8967 8.03839L10.4767 10.9609Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_16141_31452" }, /* @__PURE__ */ re.createElement("rect", { width: 14, height: 14 })))), q0 = yn(Dhe), Phe = (e) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
  e.state === "Default" && e.size === "Medium" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.28571rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-4 shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-red-80", children: "출시예정" })
  ] }),
  e.state === "Day" && e.size === "Medium" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.28571rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-4 shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m text-mshop-red-80", children: [
      e.count,
      "일 남음"
    ] })
  ] }),
  e.state === "Hour" && e.size === "Medium" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.28571rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-4 shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m text-mshop-red-80", children: [
      e.count,
      "시간 남음"
    ] })
  ] }),
  e.state === "Min" && e.size === "Medium" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.28571rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-4 shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m text-mshop-red-80", children: [
      e.count,
      "분 남음"
    ] })
  ] }),
  e.state === "Sec" && e.size === "Medium" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.28571rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-4 shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m text-mshop-red-80", children: [
      e.count,
      "초 남음"
    ] })
  ] }),
  e.state === "Default" && e.size === "Small" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.28571rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.21429rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-[0.85714rem] shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: "출시예정" })
  ] }),
  e.state === "Day" && e.size === "Small" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.28571rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.21429rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-[0.85714rem] shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: [
      e.count,
      "일 남음"
    ] })
  ] }),
  e.state === "Hour" && e.size === "Small" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.28571rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.21429rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-[0.85714rem] shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: [
      e.count,
      "시간 남음"
    ] })
  ] }),
  e.state === "Min" && e.size === "Small" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.28571rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.21429rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-[0.85714rem] shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: [
      e.count,
      "분 남음"
    ] })
  ] }),
  e.state === "Sec" && e.size === "Small" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.28571rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-pink-20 px-[0.21429rem]", children: [
    /* @__PURE__ */ a.jsx(q0, { className: "size-[0.85714rem] shrink-0 fill-mshop-red-80" }),
    /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: [
      e.count,
      "초 남음"
    ] })
  ] })
] });
var Pr;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(Pr || (Pr = {}));
var al;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(al || (al = {}));
var Gg;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Gg || (Gg = {}));
var up;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(up || (up = {}));
const oR = {}, e3 = {};
function p3(e, t) {
  try {
    const r = (oR[e] || (oR[e] = new Intl.DateTimeFormat("en-GB", {
      timeZone: e,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1] || "";
    return r in e3 ? e3[r] : oz(r, r.split(":"));
  } catch {
    if (e in e3) return e3[e];
    const n = e == null ? void 0 : e.match(Ohe);
    return n ? oz(e, n.slice(1)) : NaN;
  }
}
const Ohe = /([+-]\d\d):?(\d\d)?/;
function oz(e, t) {
  const n = +t[0], r = +(t[1] || 0);
  return e3[e] = n > 0 ? n * 60 + r : n * 60 - r;
}
class cy extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(p3(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), xW(this), UD(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new cy(...n, t) : new cy(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new cy(+this, t);
  }
  getTimezoneOffset() {
    return -p3(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), UD(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new cy(+new Date(t), this.timeZone);
  }
  //#endregion
}
const lz = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!lz.test(e)) return;
  const t = e.replace(lz, "$1UTC");
  cy.prototype[t] && (e.startsWith("get") ? cy.prototype[e] = function() {
    return this.internal[t]();
  } : (cy.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), Ahe(this), +this;
  }, cy.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), UD(this), +this;
  }));
});
function UD(e) {
  e.internal.setTime(+e), e.internal.setUTCMinutes(e.internal.getUTCMinutes() - e.getTimezoneOffset());
}
function Ahe(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), xW(e);
}
function xW(e) {
  const t = p3(e.timeZone, e), n = /* @__PURE__ */ new Date(+e);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), s = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), o = r - s, c = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  o && c && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + o);
  const u = r - t;
  u && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + u);
  const m = p3(e.timeZone, e), b = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - m, w = m !== t, k = b - u;
  if (w && k) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + k);
    const j = p3(e.timeZone, e), E = m - j;
    E && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + E), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + E));
  }
}
class M2 extends cy {
  //#region static
  static tz(t, ...n) {
    return n.length ? new M2(...n, t) : new M2(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), s = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + s;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, s] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${s}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, s] = this.tzComponents();
    return `${t} GMT${n}${r}${s} (${Lhe(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), s = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, s];
  }
  //#endregion
  withTimeZone(t) {
    return new M2(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new M2(+new Date(t), this.timeZone);
  }
  //#endregion
}
function Lhe(e, t) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: e,
    timeZoneName: "long"
  }).format(t).slice(12);
}
const bW = 6048e5, Ihe = 864e5, cz = Symbol.for("constructDateFrom");
function gu(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && cz in e ? e[cz](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function wi(e, t) {
  return gu(t || e, e);
}
function SW(e, t, n) {
  const r = wi(e, n == null ? void 0 : n.in);
  return isNaN(t) ? gu(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function wW(e, t, n) {
  const r = wi(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return gu(e, NaN);
  if (!t)
    return r;
  const s = r.getDate(), o = gu(e, r.getTime());
  o.setMonth(r.getMonth() + t + 1, 0);
  const c = o.getDate();
  return s >= c ? o : (r.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    s
  ), r);
}
let Fhe = {};
function m6() {
  return Fhe;
}
function X8(e, t) {
  var u, m, y, b;
  const n = m6(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((m = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : m.weekStartsOn) ?? n.weekStartsOn ?? ((b = (y = n.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = wi(e, t == null ? void 0 : t.in), o = s.getDay(), c = (o < r ? 7 : 0) + o - r;
  return s.setDate(s.getDate() - c), s.setHours(0, 0, 0, 0), s;
}
function _3(e, t) {
  return X8(e, { ...t, weekStartsOn: 1 });
}
function CW(e, t) {
  const n = wi(e, t == null ? void 0 : t.in), r = n.getFullYear(), s = gu(n, 0);
  s.setFullYear(r + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const o = _3(s), c = gu(n, 0);
  c.setFullYear(r, 0, 4), c.setHours(0, 0, 0, 0);
  const u = _3(c);
  return n.getTime() >= o.getTime() ? r + 1 : n.getTime() >= u.getTime() ? r : r - 1;
}
function uz(e) {
  const t = wi(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function vw(e, ...t) {
  const n = gu.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function T3(e, t) {
  const n = wi(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function NW(e, t, n) {
  const [r, s] = vw(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = T3(r), c = T3(s), u = +o - uz(o), m = +c - uz(c);
  return Math.round((u - m) / Ihe);
}
function Uhe(e, t) {
  const n = CW(e, t), r = gu(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), _3(r);
}
function zhe(e, t, n) {
  return SW(e, t * 7, n);
}
function Bhe(e, t, n) {
  return wW(e, t * 12, n);
}
function Hhe(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((s) => {
    !r && typeof s == "object" && (r = gu.bind(null, s));
    const o = wi(s, r);
    (!n || n < o || isNaN(+o)) && (n = o);
  }), gu(r, n || NaN);
}
function Vhe(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((s) => {
    !r && typeof s == "object" && (r = gu.bind(null, s));
    const o = wi(s, r);
    (!n || n > o || isNaN(+o)) && (n = o);
  }), gu(r, n || NaN);
}
function $he(e, t, n) {
  const [r, s] = vw(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +T3(r) == +T3(s);
}
function jW(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ghe(e) {
  return !(!jW(e) && typeof e != "number" || isNaN(+wi(e)));
}
function Whe(e, t, n) {
  const [r, s] = vw(
    n == null ? void 0 : n.in,
    e,
    t
  ), o = r.getFullYear() - s.getFullYear(), c = r.getMonth() - s.getMonth();
  return o * 12 + c;
}
function Yhe(e, t) {
  const n = wi(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function qhe(e, t) {
  const [n, r] = vw(e, t.start, t.end);
  return { start: n, end: r };
}
function Khe(e, t) {
  const { start: n, end: r } = qhe(t == null ? void 0 : t.in, e);
  let s = +n > +r;
  const o = s ? +n : +r, c = s ? r : n;
  c.setHours(0, 0, 0, 0), c.setDate(1);
  let u = 1;
  const m = [];
  for (; +c <= o; )
    m.push(gu(n, c)), c.setMonth(c.getMonth() + u);
  return s ? m.reverse() : m;
}
function Xhe(e, t) {
  const n = wi(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function Qhe(e, t) {
  const n = wi(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function EW(e, t) {
  const n = wi(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function kW(e, t) {
  var u, m, y, b;
  const n = m6(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((m = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : m.weekStartsOn) ?? n.weekStartsOn ?? ((b = (y = n.locale) == null ? void 0 : y.options) == null ? void 0 : b.weekStartsOn) ?? 0, s = wi(e, t == null ? void 0 : t.in), o = s.getDay(), c = (o < r ? -7 : 0) + 6 - (o - r);
  return s.setDate(s.getDate() + c), s.setHours(23, 59, 59, 999), s;
}
function Zhe(e, t) {
  return kW(e, { ...t, weekStartsOn: 1 });
}
const Jhe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, epe = (e, t, n) => {
  let r;
  const s = Jhe[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function P8(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const tpe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, npe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, rpe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ape = {
  date: P8({
    formats: tpe,
    defaultWidth: "full"
  }),
  time: P8({
    formats: npe,
    defaultWidth: "full"
  }),
  dateTime: P8({
    formats: rpe,
    defaultWidth: "full"
  })
}, spe = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ipe = (e, t, n, r) => spe[e];
function ay(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let s;
    if (r === "formatting" && e.formattingValues) {
      const c = e.defaultFormattingWidth || e.defaultWidth, u = n != null && n.width ? String(n.width) : c;
      s = e.formattingValues[u] || e.formattingValues[c];
    } else {
      const c = e.defaultWidth, u = n != null && n.width ? String(n.width) : e.defaultWidth;
      s = e.values[u] || e.values[c];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return s[o];
  };
}
const ope = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, lpe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, cpe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, upe = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, dpe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, fpe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, mpe = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, hpe = {
  ordinalNumber: mpe,
  era: ay({
    values: ope,
    defaultWidth: "wide"
  }),
  quarter: ay({
    values: lpe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ay({
    values: cpe,
    defaultWidth: "wide"
  }),
  day: ay({
    values: upe,
    defaultWidth: "wide"
  }),
  dayPeriod: ay({
    values: dpe,
    defaultWidth: "wide",
    formattingValues: fpe,
    defaultFormattingWidth: "wide"
  })
};
function sy(e) {
  return (t, n = {}) => {
    const r = n.width, s = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(s);
    if (!o)
      return null;
    const c = o[0], u = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], m = Array.isArray(u) ? gpe(u, (w) => w.test(c)) : (
      // [TODO] -- I challenge you to fix the type
      ppe(u, (w) => w.test(c))
    );
    let y;
    y = e.valueCallback ? e.valueCallback(m) : m, y = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(y)
    ) : y;
    const b = t.slice(c.length);
    return { value: y, rest: b };
  };
}
function ppe(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function gpe(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function _W(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const s = r[0], o = t.match(e.parsePattern);
    if (!o) return null;
    let c = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    c = n.valueCallback ? n.valueCallback(c) : c;
    const u = t.slice(s.length);
    return { value: c, rest: u };
  };
}
const ype = /^(\d+)(th|st|nd|rd)?/i, vpe = /\d+/i, xpe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, bpe = {
  any: [/^b/i, /^(a|c)/i]
}, Spe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, wpe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Cpe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Npe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, jpe = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Epe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, kpe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, _pe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Tpe = {
  ordinalNumber: _W({
    matchPattern: ype,
    parsePattern: vpe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: sy({
    matchPatterns: xpe,
    defaultMatchWidth: "wide",
    parsePatterns: bpe,
    defaultParseWidth: "any"
  }),
  quarter: sy({
    matchPatterns: Spe,
    defaultMatchWidth: "wide",
    parsePatterns: wpe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: sy({
    matchPatterns: Cpe,
    defaultMatchWidth: "wide",
    parsePatterns: Npe,
    defaultParseWidth: "any"
  }),
  day: sy({
    matchPatterns: jpe,
    defaultMatchWidth: "wide",
    parsePatterns: Epe,
    defaultParseWidth: "any"
  }),
  dayPeriod: sy({
    matchPatterns: kpe,
    defaultMatchWidth: "any",
    parsePatterns: _pe,
    defaultParseWidth: "any"
  })
}, rA = {
  code: "en-US",
  formatDistance: epe,
  formatLong: ape,
  formatRelative: ipe,
  localize: hpe,
  match: Tpe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Mpe(e, t) {
  const n = wi(e, t == null ? void 0 : t.in);
  return NW(n, EW(n)) + 1;
}
function TW(e, t) {
  const n = wi(e, t == null ? void 0 : t.in), r = +_3(n) - +Uhe(n);
  return Math.round(r / bW) + 1;
}
function MW(e, t) {
  var b, w, k, j;
  const n = wi(e, t == null ? void 0 : t.in), r = n.getFullYear(), s = m6(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((w = (b = t == null ? void 0 : t.locale) == null ? void 0 : b.options) == null ? void 0 : w.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((j = (k = s.locale) == null ? void 0 : k.options) == null ? void 0 : j.firstWeekContainsDate) ?? 1, c = gu((t == null ? void 0 : t.in) || e, 0);
  c.setFullYear(r + 1, 0, o), c.setHours(0, 0, 0, 0);
  const u = X8(c, t), m = gu((t == null ? void 0 : t.in) || e, 0);
  m.setFullYear(r, 0, o), m.setHours(0, 0, 0, 0);
  const y = X8(m, t);
  return +n >= +u ? r + 1 : +n >= +y ? r : r - 1;
}
function Rpe(e, t) {
  var u, m, y, b;
  const n = m6(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((m = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : m.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((b = (y = n.locale) == null ? void 0 : y.options) == null ? void 0 : b.firstWeekContainsDate) ?? 1, s = MW(e, t), o = gu((t == null ? void 0 : t.in) || e, 0);
  return o.setFullYear(s, 0, r), o.setHours(0, 0, 0, 0), X8(o, t);
}
function RW(e, t) {
  const n = wi(e, t == null ? void 0 : t.in), r = +X8(n, t) - +Rpe(n, t);
  return Math.round(r / bW) + 1;
}
function di(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const i2 = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return di(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : di(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return di(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return di(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return di(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return di(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return di(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), s = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return di(s, t.length);
  }
}, u8 = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, dz = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), s = r > 0 ? r : 1 - r;
      return n.ordinalNumber(s, { unit: "year" });
    }
    return i2.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const s = MW(e, r), o = s > 0 ? s : 1 - s;
    if (t === "YY") {
      const c = o % 100;
      return di(c, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : di(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = CW(e);
    return di(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return di(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return di(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return di(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return i2.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return di(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const s = RW(e, r);
    return t === "wo" ? n.ordinalNumber(s, { unit: "week" }) : di(s, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = TW(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : di(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : i2.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Mpe(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : di(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const s = e.getDay(), o = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return di(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const s = e.getDay(), o = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return di(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(s, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(s, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), s = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(s);
      case "ii":
        return di(s, t.length);
      case "io":
        return n.ordinalNumber(s, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let s;
    switch (r === 12 ? s = u8.noon : r === 0 ? s = u8.midnight : s = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let s;
    switch (r >= 17 ? s = u8.evening : r >= 12 ? s = u8.afternoon : r >= 4 ? s = u8.morning : s = u8.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return i2.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : i2.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : di(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : di(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : i2.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : i2.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return i2.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return mz(r);
      case "XXXX":
      case "XX":
        return _4(r);
      case "XXXXX":
      case "XXX":
      default:
        return _4(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return mz(r);
      case "xxxx":
      case "xx":
        return _4(r);
      case "xxxxx":
      case "xxx":
      default:
        return _4(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + fz(r, ":");
      case "OOOO":
      default:
        return "GMT" + _4(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + fz(r, ":");
      case "zzzz":
      default:
        return "GMT" + _4(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return di(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return di(+e, t.length);
  }
};
function fz(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), s = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? n + String(s) : n + String(s) + t + di(o, 2);
}
function mz(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + di(Math.abs(e) / 60, 2) : _4(e, t);
}
function _4(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), s = di(Math.trunc(r / 60), 2), o = di(r % 60, 2);
  return n + s + t + o;
}
const hz = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, DW = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Dpe = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], s = n[2];
  if (!s)
    return hz(e, t);
  let o;
  switch (r) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", hz(r, t)).replace("{{time}}", DW(s, t));
}, Ppe = {
  p: DW,
  P: Dpe
}, Ope = /^D+$/, Ape = /^Y+$/, Lpe = ["D", "DD", "YY", "YYYY"];
function Ipe(e) {
  return Ope.test(e);
}
function Fpe(e) {
  return Ape.test(e);
}
function Upe(e, t, n) {
  const r = zpe(e, t, n);
  if (console.warn(r), Lpe.includes(e)) throw new RangeError(r);
}
function zpe(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Bpe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Hpe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Vpe = /^'([^]*?)'?$/, $pe = /''/g, Gpe = /[a-zA-Z]/;
function Wpe(e, t, n) {
  var b, w, k, j, E, T, D, L;
  const r = m6(), s = (n == null ? void 0 : n.locale) ?? r.locale ?? rA, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((w = (b = n == null ? void 0 : n.locale) == null ? void 0 : b.options) == null ? void 0 : w.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((j = (k = r.locale) == null ? void 0 : k.options) == null ? void 0 : j.firstWeekContainsDate) ?? 1, c = (n == null ? void 0 : n.weekStartsOn) ?? ((T = (E = n == null ? void 0 : n.locale) == null ? void 0 : E.options) == null ? void 0 : T.weekStartsOn) ?? r.weekStartsOn ?? ((L = (D = r.locale) == null ? void 0 : D.options) == null ? void 0 : L.weekStartsOn) ?? 0, u = wi(e, n == null ? void 0 : n.in);
  if (!Ghe(u))
    throw new RangeError("Invalid time value");
  let m = t.match(Hpe).map((I) => {
    const R = I[0];
    if (R === "p" || R === "P") {
      const U = Ppe[R];
      return U(I, s.formatLong);
    }
    return I;
  }).join("").match(Bpe).map((I) => {
    if (I === "''")
      return { isToken: !1, value: "'" };
    const R = I[0];
    if (R === "'")
      return { isToken: !1, value: Ype(I) };
    if (dz[R])
      return { isToken: !0, value: I };
    if (R.match(Gpe))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + R + "`"
      );
    return { isToken: !1, value: I };
  });
  s.localize.preprocessor && (m = s.localize.preprocessor(u, m));
  const y = {
    firstWeekContainsDate: o,
    weekStartsOn: c,
    locale: s
  };
  return m.map((I) => {
    if (!I.isToken) return I.value;
    const R = I.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Fpe(R) || !(n != null && n.useAdditionalDayOfYearTokens) && Ipe(R)) && Upe(R, t, String(e));
    const U = dz[R[0]];
    return U(u, R, s.localize, y);
  }).join("");
}
function Ype(e) {
  const t = e.match(Vpe);
  return t ? t[1].replace($pe, "'") : e;
}
function qpe(e, t) {
  const n = wi(e, t == null ? void 0 : t.in), r = n.getFullYear(), s = n.getMonth(), o = gu(n, 0);
  return o.setFullYear(r, s + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function Kpe(e, t) {
  return wi(e, t == null ? void 0 : t.in).getMonth();
}
function Xpe(e, t) {
  return wi(e, t == null ? void 0 : t.in).getFullYear();
}
function Qpe(e, t) {
  return +wi(e) > +wi(t);
}
function Zpe(e, t) {
  return +wi(e) < +wi(t);
}
function Jpe(e, t, n) {
  const [r, s] = vw(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === s.getFullYear() && r.getMonth() === s.getMonth();
}
function e1e(e, t, n) {
  const [r, s] = vw(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === s.getFullYear();
}
function t1e(e, t, n) {
  const r = wi(e, n == null ? void 0 : n.in), s = r.getFullYear(), o = r.getDate(), c = gu(e, 0);
  c.setFullYear(s, t, 15), c.setHours(0, 0, 0, 0);
  const u = qpe(c);
  return r.setMonth(t, Math.min(o, u)), r;
}
function n1e(e, t, n) {
  const r = wi(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? gu(e, NaN) : (r.setFullYear(t), r);
}
const pz = 5, r1e = 4;
function a1e(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, s = t.addDays(e, -r + 1), o = t.addDays(s, pz * 7 - 1);
  return t.getMonth(e) === t.getMonth(o) ? pz : r1e;
}
function PW(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function s1e(e, t) {
  const n = PW(e, t), r = a1e(e, t);
  return t.addDays(n, r * 7 - 1);
}
class Xv {
  /**
   * Creates an instance of DateLib.
   *
   * @param options The options for the date library.
   * @param overrides Overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => {
      var r;
      return (r = this.overrides) != null && r.today ? this.overrides.today() : this.options.timeZone ? M2.tz(this.options.timeZone) : new this.Date();
    }, this.newDate = (r, s, o) => {
      var c;
      return (c = this.overrides) != null && c.newDate ? this.overrides.newDate(r, s, o) : this.options.timeZone ? new M2(r, s, o, this.options.timeZone) : new Date(r, s, o);
    }, this.addDays = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.addDays ? this.overrides.addDays(r, s) : SW(r, s);
    }, this.addMonths = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.addMonths ? this.overrides.addMonths(r, s) : wW(r, s);
    }, this.addWeeks = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.addWeeks ? this.overrides.addWeeks(r, s) : zhe(r, s);
    }, this.addYears = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.addYears ? this.overrides.addYears(r, s) : Bhe(r, s);
    }, this.differenceInCalendarDays = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, s) : NW(r, s);
    }, this.differenceInCalendarMonths = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, s) : Whe(r, s);
    }, this.eachMonthOfInterval = (r) => {
      var s;
      return (s = this.overrides) != null && s.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : Khe(r);
    }, this.endOfBroadcastWeek = (r) => {
      var s;
      return (s = this.overrides) != null && s.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r, this) : s1e(r, this);
    }, this.endOfISOWeek = (r) => {
      var s;
      return (s = this.overrides) != null && s.endOfISOWeek ? this.overrides.endOfISOWeek(r) : Zhe(r);
    }, this.endOfMonth = (r) => {
      var s;
      return (s = this.overrides) != null && s.endOfMonth ? this.overrides.endOfMonth(r) : Yhe(r);
    }, this.endOfWeek = (r) => {
      var s;
      return (s = this.overrides) != null && s.endOfWeek ? this.overrides.endOfWeek(r, this.options) : kW(r, this.options);
    }, this.endOfYear = (r) => {
      var s;
      return (s = this.overrides) != null && s.endOfYear ? this.overrides.endOfYear(r) : Qhe(r);
    }, this.format = (r, s) => {
      var c;
      const o = (c = this.overrides) != null && c.format ? this.overrides.format(r, s, this.options) : Wpe(r, s, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(o) : o;
    }, this.getISOWeek = (r) => {
      var s;
      return (s = this.overrides) != null && s.getISOWeek ? this.overrides.getISOWeek(r) : TW(r);
    }, this.getMonth = (r) => {
      var s;
      return (s = this.overrides) != null && s.getMonth ? this.overrides.getMonth(r, this.options) : Kpe(r, this.options);
    }, this.getYear = (r) => {
      var s;
      return (s = this.overrides) != null && s.getYear ? this.overrides.getYear(r, this.options) : Xpe(r, this.options);
    }, this.getWeek = (r) => {
      var s;
      return (s = this.overrides) != null && s.getWeek ? this.overrides.getWeek(r, this.options) : RW(r, this.options);
    }, this.isAfter = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.isAfter ? this.overrides.isAfter(r, s) : Qpe(r, s);
    }, this.isBefore = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.isBefore ? this.overrides.isBefore(r, s) : Zpe(r, s);
    }, this.isDate = (r) => {
      var s;
      return (s = this.overrides) != null && s.isDate ? this.overrides.isDate(r) : jW(r);
    }, this.isSameDay = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.isSameDay ? this.overrides.isSameDay(r, s) : $he(r, s);
    }, this.isSameMonth = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.isSameMonth ? this.overrides.isSameMonth(r, s) : Jpe(r, s);
    }, this.isSameYear = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.isSameYear ? this.overrides.isSameYear(r, s) : e1e(r, s);
    }, this.max = (r) => {
      var s;
      return (s = this.overrides) != null && s.max ? this.overrides.max(r) : Hhe(r);
    }, this.min = (r) => {
      var s;
      return (s = this.overrides) != null && s.min ? this.overrides.min(r) : Vhe(r);
    }, this.setMonth = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.setMonth ? this.overrides.setMonth(r, s) : t1e(r, s);
    }, this.setYear = (r, s) => {
      var o;
      return (o = this.overrides) != null && o.setYear ? this.overrides.setYear(r, s) : n1e(r, s);
    }, this.startOfBroadcastWeek = (r) => {
      var s;
      return (s = this.overrides) != null && s.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : PW(r, this);
    }, this.startOfDay = (r) => {
      var s;
      return (s = this.overrides) != null && s.startOfDay ? this.overrides.startOfDay(r) : T3(r);
    }, this.startOfISOWeek = (r) => {
      var s;
      return (s = this.overrides) != null && s.startOfISOWeek ? this.overrides.startOfISOWeek(r) : _3(r);
    }, this.startOfMonth = (r) => {
      var s;
      return (s = this.overrides) != null && s.startOfMonth ? this.overrides.startOfMonth(r) : Xhe(r);
    }, this.startOfWeek = (r) => {
      var s;
      return (s = this.overrides) != null && s.startOfWeek ? this.overrides.startOfWeek(r, this.options) : X8(r, this.options);
    }, this.startOfYear = (r) => {
      var s;
      return (s = this.overrides) != null && s.startOfYear ? this.overrides.startOfYear(r) : EW(r);
    }, this.options = { locale: rA, ...t }, this.overrides = n;
  }
  /**
   * Generate digit map dynamically using Intl.NumberFormat.
   *
   * @since 9.5.0
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let s = 0; s < 10; s++)
      r[s.toString()] = n.format(s);
    return r;
  }
  /**
   * Replace Arabic digits with the target numbering system digits.
   *
   * @since 9.5.0
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Format number using the custom numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
}
const Qv = new Xv();
function i1e(e, t, n = {}) {
  return Object.entries(e).filter(([, s]) => s === !0).reduce((s, [o]) => (n[o] ? s.push(n[o]) : t[al[o]] ? s.push(t[al[o]]) : t[Gg[o]] && s.push(t[Gg[o]]), s), [t[Pr.Day]]);
}
function o1e(e) {
  return Ee.createElement("button", { ...e });
}
function l1e(e) {
  return Ee.createElement("span", { ...e });
}
function c1e(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return Ee.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && Ee.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && Ee.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && Ee.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && Ee.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function u1e(e) {
  const { day: t, modifiers: n, ...r } = e;
  return Ee.createElement("td", { ...r });
}
function d1e(e) {
  const { day: t, modifiers: n, ...r } = e, s = Ee.useRef(null);
  return Ee.useEffect(() => {
    var o;
    n.focused && ((o = s.current) == null || o.focus());
  }, [n.focused]), Ee.createElement("button", { ref: s, ...r });
}
function f1e(e) {
  const { options: t, className: n, components: r, classNames: s, ...o } = e, c = [s[Pr.Dropdown], n].join(" "), u = t == null ? void 0 : t.find(({ value: m }) => m === o.value);
  return Ee.createElement(
    "span",
    { "data-disabled": o.disabled, className: s[Pr.DropdownRoot] },
    Ee.createElement(r.Select, { className: c, ...o }, t == null ? void 0 : t.map(({ value: m, label: y, disabled: b }) => Ee.createElement(r.Option, { key: m, value: m, disabled: b }, y))),
    Ee.createElement(
      "span",
      { className: s[Pr.CaptionLabel], "aria-hidden": !0 },
      u == null ? void 0 : u.label,
      Ee.createElement(r.Chevron, { orientation: "down", size: 18, className: s[Pr.Chevron] })
    )
  );
}
function m1e(e) {
  return Ee.createElement("div", { ...e });
}
function h1e(e) {
  return Ee.createElement("div", { ...e });
}
function p1e(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return Ee.createElement("div", { ...r }, e.children);
}
function g1e(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return Ee.createElement("div", { ...r });
}
function y1e(e) {
  return Ee.createElement("table", { ...e });
}
function v1e(e) {
  return Ee.createElement("div", { ...e });
}
const OW = ys(void 0);
function d5() {
  const e = Ra(OW);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function x1e(e) {
  const { components: t } = d5();
  return Ee.createElement(t.Dropdown, { ...e });
}
function b1e(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: s, ...o } = e, { components: c, classNames: u, labels: { labelPrevious: m, labelNext: y } } = d5(), b = qa((k) => {
    s && (n == null || n(k));
  }, [s, n]), w = qa((k) => {
    r && (t == null || t(k));
  }, [r, t]);
  return Ee.createElement(
    "nav",
    { ...o },
    Ee.createElement(
      c.PreviousMonthButton,
      { type: "button", className: u[Pr.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": m(r), onClick: w },
      Ee.createElement(c.Chevron, { disabled: r ? void 0 : !0, className: u[Pr.Chevron], orientation: "left" })
    ),
    Ee.createElement(
      c.NextMonthButton,
      { type: "button", className: u[Pr.NextMonthButton], tabIndex: s ? void 0 : -1, "aria-disabled": s ? void 0 : !0, "aria-label": y(s), onClick: b },
      Ee.createElement(c.Chevron, { disabled: s ? void 0 : !0, orientation: "right", className: u[Pr.Chevron] })
    )
  );
}
function S1e(e) {
  const { components: t } = d5();
  return Ee.createElement(t.Button, { ...e });
}
function w1e(e) {
  return Ee.createElement("option", { ...e });
}
function C1e(e) {
  const { components: t } = d5();
  return Ee.createElement(t.Button, { ...e });
}
function N1e(e) {
  const { rootRef: t, ...n } = e;
  return Ee.createElement("div", { ...n, ref: t });
}
function j1e(e) {
  return Ee.createElement("select", { ...e });
}
function E1e(e) {
  const { week: t, ...n } = e;
  return Ee.createElement("tr", { ...n });
}
function k1e(e) {
  return Ee.createElement("th", { ...e });
}
function _1e(e) {
  return Ee.createElement(
    "thead",
    { "aria-hidden": !0 },
    Ee.createElement("tr", { ...e })
  );
}
function T1e(e) {
  const { week: t, ...n } = e;
  return Ee.createElement("th", { ...n });
}
function M1e(e) {
  return Ee.createElement("th", { ...e });
}
function R1e(e) {
  return Ee.createElement("tbody", { ...e });
}
function D1e(e) {
  const { components: t } = d5();
  return Ee.createElement(t.Dropdown, { ...e });
}
const P1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: o1e,
  CaptionLabel: l1e,
  Chevron: c1e,
  Day: u1e,
  DayButton: d1e,
  Dropdown: f1e,
  DropdownNav: m1e,
  Footer: h1e,
  Month: p1e,
  MonthCaption: g1e,
  MonthGrid: y1e,
  Months: v1e,
  MonthsDropdown: x1e,
  Nav: b1e,
  NextMonthButton: S1e,
  Option: w1e,
  PreviousMonthButton: C1e,
  Root: N1e,
  Select: j1e,
  Week: E1e,
  WeekNumber: T1e,
  WeekNumberHeader: M1e,
  Weekday: k1e,
  Weekdays: _1e,
  Weeks: R1e,
  YearsDropdown: D1e
}, Symbol.toStringTag, { value: "Module" }));
function O1e(e) {
  return {
    ...P1e,
    ...e
  };
}
function A1e(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function L1e() {
  const e = {};
  for (const t in Pr)
    e[Pr[t]] = `rdp-${Pr[t]}`;
  for (const t in al)
    e[al[t]] = `rdp-${al[t]}`;
  for (const t in Gg)
    e[Gg[t]] = `rdp-${Gg[t]}`;
  for (const t in up)
    e[up[t]] = `rdp-${up[t]}`;
  return e;
}
function AW(e, t, n) {
  return (n ?? new Xv(t)).format(e, "LLLL y");
}
const I1e = AW;
function F1e(e, t, n) {
  return (n ?? new Xv(t)).format(e, "d");
}
function U1e(e, t = Qv) {
  return t.format(e, "LLLL");
}
function z1e(e) {
  return e < 10 ? `0${e.toLocaleString()}` : `${e.toLocaleString()}`;
}
function B1e() {
  return "";
}
function H1e(e, t, n) {
  return (n ?? new Xv(t)).format(e, "cccccc");
}
function LW(e, t = Qv) {
  return t.format(e, "yyyy");
}
const V1e = LW, $1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: AW,
  formatDay: F1e,
  formatMonthCaption: I1e,
  formatMonthDropdown: U1e,
  formatWeekNumber: z1e,
  formatWeekNumberHeader: B1e,
  formatWeekdayName: H1e,
  formatYearCaption: V1e,
  formatYearDropdown: LW
}, Symbol.toStringTag, { value: "Module" }));
function G1e(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...$1e,
    ...e
  };
}
function W1e(e, t, n, r, s) {
  const { startOfMonth: o, startOfYear: c, endOfYear: u, eachMonthOfInterval: m, getMonth: y } = s;
  return m({
    start: c(e),
    end: u(e)
  }).map((k) => {
    const j = r.formatMonthDropdown(k, s), E = y(k), T = t && k < o(t) || n && k > o(n) || !1;
    return { value: E, label: j, disabled: T };
  });
}
function Y1e(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[Pr.Day] };
  return Object.entries(e).filter(([, s]) => s === !0).forEach(([s]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[s]
    };
  }), r;
}
function q1e(e, t, n) {
  const r = e.today(), s = t ? e.startOfISOWeek(r) : e.startOfWeek(r), o = [];
  for (let c = 0; c < 7; c++) {
    const u = e.addDays(s, c);
    o.push(u);
  }
  return o;
}
function K1e(e, t, n, r) {
  if (!e || !t)
    return;
  const { startOfYear: s, endOfYear: o, addYears: c, getYear: u, isBefore: m, isSameYear: y } = r, b = s(e), w = o(t), k = [];
  let j = b;
  for (; m(j, w) || y(j, w); )
    k.push(j), j = c(j, 1);
  return k.map((E) => {
    const T = n.formatYearDropdown(E, r);
    return {
      value: u(E),
      label: T,
      disabled: !1
    };
  });
}
function IW(e, t, n) {
  return (n ?? new Xv(t)).format(e, "LLLL y");
}
const X1e = IW;
function Q1e(e, t, n, r) {
  let s = (r ?? new Xv(n)).format(e, "PPPP");
  return t != null && t.today && (s = `Today, ${s}`), s;
}
function FW(e, t, n, r) {
  let s = (r ?? new Xv(n)).format(e, "PPPP");
  return t.today && (s = `Today, ${s}`), t.selected && (s = `${s}, selected`), s;
}
const Z1e = FW;
function J1e() {
  return "";
}
function ege(e) {
  return "Choose the Month";
}
function tge(e) {
  return "Go to the Next Month";
}
function nge(e) {
  return "Go to the Previous Month";
}
function rge(e, t, n) {
  return (n ?? new Xv(t)).format(e, "cccc");
}
function age(e, t) {
  return `Week ${e}`;
}
function sge(e) {
  return "Week Number";
}
function ige(e) {
  return "Choose the Year";
}
const oge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: X1e,
  labelDay: Z1e,
  labelDayButton: FW,
  labelGrid: IW,
  labelGridcell: Q1e,
  labelMonthDropdown: ege,
  labelNav: J1e,
  labelNext: tge,
  labelPrevious: nge,
  labelWeekNumber: age,
  labelWeekNumberHeader: sge,
  labelWeekday: rge,
  labelYearDropdown: ige
}, Symbol.toStringTag, { value: "Module" })), h6 = (e) => e instanceof HTMLElement ? e : null, lR = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], lge = (e) => h6(e.querySelector("[data-animated-month]")), cR = (e) => h6(e.querySelector("[data-animated-caption]")), uR = (e) => h6(e.querySelector("[data-animated-weeks]")), cge = (e) => h6(e.querySelector("[data-animated-nav]")), uge = (e) => h6(e.querySelector("[data-animated-weekdays]"));
function dge(e, t, { classNames: n, months: r, focused: s, dateLib: o }) {
  const c = Rt(null), u = Rt(r), m = Rt(!1);
  a5(() => {
    const y = u.current;
    if (u.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || y.length === 0 || r.length !== y.length)
      return;
    const b = o.isSameMonth(r[0].date, y[0].date), w = o.isAfter(r[0].date, y[0].date), k = w ? n[up.caption_after_enter] : n[up.caption_before_enter], j = w ? n[up.weeks_after_enter] : n[up.weeks_before_enter], E = c.current, T = e.current.cloneNode(!0);
    if (T instanceof HTMLElement ? (lR(T).forEach((R) => {
      if (!(R instanceof HTMLElement))
        return;
      const U = lge(R);
      U && R.contains(U) && R.removeChild(U);
      const z = cR(R);
      z && z.classList.remove(k);
      const H = uR(R);
      H && H.classList.remove(j);
    }), c.current = T) : c.current = null, m.current || b || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    s)
      return;
    const D = E instanceof HTMLElement ? lR(E) : [], L = lR(e.current);
    if (L && L.every((I) => I instanceof HTMLElement) && D && D.every((I) => I instanceof HTMLElement)) {
      m.current = !0, e.current.style.isolation = "isolate";
      const I = cge(e.current);
      I && (I.style.zIndex = "1"), L.forEach((R, U) => {
        const z = D[U];
        if (!z)
          return;
        R.style.position = "relative", R.style.overflow = "hidden";
        const H = cR(R);
        H && H.classList.add(k);
        const K = uR(R);
        K && K.classList.add(j);
        const q = () => {
          m.current = !1, e.current && (e.current.style.isolation = ""), I && (I.style.zIndex = ""), H && H.classList.remove(k), K && K.classList.remove(j), R.style.position = "", R.style.overflow = "", R.contains(z) && R.removeChild(z);
        };
        z.style.pointerEvents = "none", z.style.position = "absolute", z.style.overflow = "hidden", z.setAttribute("aria-hidden", "true");
        const Q = uge(z);
        Q && (Q.style.opacity = "0");
        const Z = cR(z);
        Z && (Z.classList.add(w ? n[up.caption_before_exit] : n[up.caption_after_exit]), Z.addEventListener("animationend", q));
        const X = uR(z);
        X && X.classList.add(w ? n[up.weeks_before_exit] : n[up.weeks_after_exit]), R.insertBefore(z, R.firstChild);
      });
    }
  });
}
function fge(e, t, n, r) {
  const s = e[0], o = e[e.length - 1], { ISOWeek: c, fixedWeeks: u, broadcastCalendar: m } = n ?? {}, { addDays: y, differenceInCalendarDays: b, differenceInCalendarMonths: w, endOfBroadcastWeek: k, endOfISOWeek: j, endOfMonth: E, endOfWeek: T, isAfter: D, startOfBroadcastWeek: L, startOfISOWeek: I, startOfWeek: R } = r, U = m ? L(s, r) : c ? I(s) : R(s), z = m ? k(o, r) : c ? j(E(o)) : T(E(o)), H = b(z, U), K = w(o, s) + 1, q = [];
  for (let X = 0; X <= H; X++) {
    const se = y(U, X);
    if (t && D(se, t))
      break;
    q.push(se);
  }
  const Z = (m ? 35 : 42) * K;
  if (u && q.length < Z) {
    const X = Z - q.length;
    for (let se = 0; se < X; se++) {
      const te = y(q[q.length - 1], 1);
      q.push(te);
    }
  }
  return q;
}
function mge(e) {
  const t = [];
  return e.reduce((n, r) => {
    const s = [], o = r.weeks.reduce((c, u) => [...c, ...u.days], s);
    return [...n, ...o];
  }, t);
}
function hge(e, t, n, r) {
  const { numberOfMonths: s = 1 } = n, o = [];
  for (let c = 0; c < s; c++) {
    const u = r.addMonths(e, c);
    if (t && u > t)
      break;
    o.push(u);
  }
  return o;
}
function gz(e, t) {
  const { month: n, defaultMonth: r, today: s = t.today(), numberOfMonths: o = 1, endMonth: c, startMonth: u, timeZone: m } = e;
  let y = n || r || s;
  const { differenceInCalendarMonths: b, addMonths: w, startOfMonth: k } = t;
  if (c && b(c, y) < 0) {
    const j = -1 * (o - 1);
    y = w(c, j);
  }
  return u && b(y, u) < 0 && (y = u), y = m ? new M2(y, m) : y, k(y);
}
class UW {
  constructor(t, n, r = Qv) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Check if the day is the same as the given day: considering if it is in the
   * same display month.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class pge {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class gge {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function yge(e, t, n, r) {
  const { addDays: s, endOfBroadcastWeek: o, endOfISOWeek: c, endOfMonth: u, endOfWeek: m, getISOWeek: y, getWeek: b, startOfBroadcastWeek: w, startOfISOWeek: k, startOfWeek: j } = r, E = e.reduce((T, D) => {
    const L = n.broadcastCalendar ? w(D, r) : n.ISOWeek ? k(D) : j(D), I = n.broadcastCalendar ? o(D, r) : n.ISOWeek ? c(u(D)) : m(u(D)), R = t.filter((K) => K >= L && K <= I), U = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && R.length < U) {
      const K = t.filter((q) => {
        const Q = U - R.length;
        return q > I && q <= s(I, Q);
      });
      R.push(...K);
    }
    const z = R.reduce((K, q) => {
      const Q = n.ISOWeek ? y(q) : b(q), Z = K.find((se) => se.weekNumber === Q), X = new UW(q, D, r);
      return Z ? Z.days.push(X) : K.push(new gge(Q, [X])), K;
    }, []), H = new pge(D, z);
    return T.push(H), T;
  }, []);
  return n.reverseMonths ? E.reverse() : E;
}
function vge(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: s, startOfDay: o, startOfMonth: c, endOfMonth: u, addYears: m, endOfYear: y, newDate: b, today: w } = t, { fromYear: k, toYear: j, fromMonth: E, toMonth: T } = e;
  !n && E && (n = E), !n && k && (n = t.newDate(k, 0, 1)), !r && T && (r = T), !r && j && (r = b(j, 11, 31));
  const D = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = c(n) : k ? n = b(k, 0, 1) : !n && D && (n = s(m(e.today ?? w(), -100))), r ? r = u(r) : j ? r = b(j, 11, 31) : !r && D && (r = y(e.today ?? w())), [
    n && o(n),
    r && o(r)
  ];
}
function xge(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: s, numberOfMonths: o = 1 } = n, { startOfMonth: c, addMonths: u, differenceInCalendarMonths: m } = r, y = s ? o : 1, b = c(e);
  if (!t)
    return u(b, y);
  if (!(m(t, e) < o))
    return u(b, y);
}
function bge(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: s, numberOfMonths: o } = n, { startOfMonth: c, addMonths: u, differenceInCalendarMonths: m } = r, y = s ? o ?? 1 : 1, b = c(e);
  if (!t)
    return u(b, -y);
  if (!(m(b, t) <= 0))
    return u(b, -y);
}
function Sge(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function nk(e, t) {
  const [n, r] = Re(e);
  return [t === void 0 ? n : t, r];
}
function wge(e, t) {
  const [n, r] = vge(e, t), { startOfMonth: s, endOfMonth: o } = t, c = gz(e, t), [u, m] = nk(
    c,
    // initialMonth is always computed from props.month if provided
    e.month ? c : void 0
  );
  an(() => {
    const H = gz(e, t);
    m(H);
  }, [e.timeZone]);
  const y = hge(u, r, e, t), b = fge(y, e.endMonth ? o(e.endMonth) : void 0, e, t), w = yge(y, b, e, t), k = Sge(w), j = mge(w), E = bge(u, n, e, t), T = xge(u, r, e, t), { disableNavigation: D, onMonthChange: L } = e, I = (H) => k.some((K) => K.days.some((q) => q.isEqualTo(H))), R = (H) => {
    if (D)
      return;
    let K = s(H);
    n && K < s(n) && (K = s(n)), r && K > s(r) && (K = s(r)), m(K), L == null || L(K);
  };
  return {
    months: w,
    weeks: k,
    days: j,
    navStart: n,
    navEnd: r,
    previousMonth: E,
    nextMonth: T,
    goToMonth: R,
    goToDay: (H) => {
      I(H) || R(H.date);
    }
  };
}
var Q0;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(Q0 || (Q0 = {}));
function yz(e) {
  return !e[al.disabled] && !e[al.hidden] && !e[al.outside];
}
function Cge(e, t, n, r) {
  let s, o = -1;
  for (const c of e) {
    const u = t(c);
    yz(u) && (u[al.focused] && o < Q0.FocusedModifier ? (s = c, o = Q0.FocusedModifier) : r != null && r.isEqualTo(c) && o < Q0.LastFocused ? (s = c, o = Q0.LastFocused) : n(c.date) && o < Q0.Selected ? (s = c, o = Q0.Selected) : u[al.today] && o < Q0.Today && (s = c, o = Q0.Today));
  }
  return s || (s = e.find((c) => yz(t(c)))), s;
}
function Pv(e, t, n = !1, r = Qv) {
  let { from: s, to: o } = e;
  const { differenceInCalendarDays: c, isSameDay: u } = r;
  return s && o ? (c(o, s) < 0 && ([s, o] = [o, s]), c(t, s) >= (n ? 1 : 0) && c(o, t) >= (n ? 1 : 0)) : !n && o ? u(o, t) : !n && s ? u(s, t) : !1;
}
function zW(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function aA(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function BW(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function HW(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function VW(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function $W(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Ov(e, t, n = Qv) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: s, differenceInCalendarDays: o, isAfter: c } = n;
  return r.some((u) => {
    if (typeof u == "boolean")
      return u;
    if (n.isDate(u))
      return s(e, u);
    if ($W(u, n))
      return u.includes(e);
    if (aA(u))
      return Pv(u, e, !1, n);
    if (VW(u))
      return Array.isArray(u.dayOfWeek) ? u.dayOfWeek.includes(e.getDay()) : u.dayOfWeek === e.getDay();
    if (zW(u)) {
      const m = o(u.before, e), y = o(u.after, e), b = m > 0, w = y < 0;
      return c(u.before, u.after) ? w && b : b || w;
    }
    return BW(u) ? o(e, u.after) > 0 : HW(u) ? o(u.before, e) > 0 : typeof u == "function" ? u(e) : !1;
  });
}
function Nge(e, t, n, r, s, o, c) {
  const { ISOWeek: u, broadcastCalendar: m } = o, { addDays: y, addMonths: b, addWeeks: w, addYears: k, endOfBroadcastWeek: j, endOfISOWeek: E, endOfWeek: T, max: D, min: L, startOfBroadcastWeek: I, startOfISOWeek: R, startOfWeek: U } = c;
  let H = {
    day: y,
    week: w,
    month: b,
    year: k,
    startOfWeek: (K) => m ? I(K, c) : u ? R(K) : U(K),
    endOfWeek: (K) => m ? j(K, c) : u ? E(K) : T(K)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? H = D([r, H]) : t === "after" && s && (H = L([s, H])), H;
}
function GW(e, t, n, r, s, o, c, u = 0) {
  if (u > 365)
    return;
  const m = Nge(
    e,
    t,
    n.date,
    // should be refDay? or refDay.date?
    r,
    s,
    o,
    c
  ), y = !!(o.disabled && Ov(m, o.disabled, c)), b = !!(o.hidden && Ov(m, o.hidden, c)), w = m, k = new UW(m, w, c);
  return !y && !b ? k : GW(e, t, k, r, s, o, c, u + 1);
}
function jge(e, t, n, r, s) {
  const { autoFocus: o } = e, [c, u] = Re(), m = Cge(t.days, n, r || (() => !1), c), [y, b] = Re(o ? m : void 0);
  return {
    isFocusTarget: (T) => !!(m != null && m.isEqualTo(T)),
    setFocused: b,
    focused: y,
    blur: () => {
      u(y), b(void 0);
    },
    moveFocus: (T, D) => {
      if (!y)
        return;
      const L = GW(T, D, y, t.navStart, t.navEnd, e, s);
      L && (t.goToDay(L), b(L));
    }
  };
}
function Ege(e, t, n) {
  const { disabled: r, hidden: s, modifiers: o, showOutsideDays: c, broadcastCalendar: u, today: m } = t, { isSameDay: y, isSameMonth: b, startOfMonth: w, isBefore: k, endOfMonth: j, isAfter: E } = n, T = t.startMonth && w(t.startMonth), D = t.endMonth && j(t.endMonth), L = {
    [al.focused]: [],
    [al.outside]: [],
    [al.disabled]: [],
    [al.hidden]: [],
    [al.today]: []
  }, I = {};
  for (const R of e) {
    const { date: U, displayMonth: z } = R, H = !!(z && !b(U, z)), K = !!(T && k(U, T)), q = !!(D && E(U, D)), Q = !!(r && Ov(U, r, n)), Z = !!(s && Ov(U, s, n)) || K || q || // Broadcast calendar will show outside days as default
    !u && !c && H || u && c === !1 && H, X = y(U, m ?? n.today());
    H && L.outside.push(R), Q && L.disabled.push(R), Z && L.hidden.push(R), X && L.today.push(R), o && Object.keys(o).forEach((se) => {
      const te = o == null ? void 0 : o[se];
      te && Ov(U, te, n) && (I[se] ? I[se].push(R) : I[se] = [R]);
    });
  }
  return (R) => {
    const U = {
      [al.focused]: !1,
      [al.disabled]: !1,
      [al.hidden]: !1,
      [al.outside]: !1,
      [al.today]: !1
    }, z = {};
    for (const H in L) {
      const K = L[H];
      U[H] = K.some((q) => q === R);
    }
    for (const H in I)
      z[H] = I[H].some((K) => K === R);
    return {
      ...U,
      // custom modifiers should override all the previous ones
      ...z
    };
  };
}
function kge(e, t) {
  const { selected: n, required: r, onSelect: s } = e, [o, c] = nk(n, s ? n : void 0), u = s ? n : o, { isSameDay: m } = t, y = (j) => (u == null ? void 0 : u.some((E) => m(E, j))) ?? !1, { min: b, max: w } = e;
  return {
    selected: u,
    select: (j, E, T) => {
      let D = [...u ?? []];
      if (y(j)) {
        if ((u == null ? void 0 : u.length) === b || r && (u == null ? void 0 : u.length) === 1)
          return;
        D = u == null ? void 0 : u.filter((L) => !m(L, j));
      } else
        (u == null ? void 0 : u.length) === w ? D = [j] : D = [...D, j];
      return s || c(D), s == null || s(D, j, E, T), D;
    },
    isSelected: y
  };
}
function _ge(e, t, n = 0, r = 0, s = !1, o = Qv) {
  const { from: c, to: u } = t || {}, { isSameDay: m, isAfter: y, isBefore: b } = o;
  let w;
  if (!c && !u)
    w = { from: e, to: n > 0 ? void 0 : e };
  else if (c && !u)
    m(c, e) ? s ? w = { from: c, to: void 0 } : w = void 0 : b(e, c) ? w = { from: e, to: c } : w = { from: c, to: e };
  else if (c && u)
    if (m(c, e) && m(u, e))
      s ? w = { from: c, to: u } : w = void 0;
    else if (m(c, e))
      w = { from: c, to: n > 0 ? void 0 : e };
    else if (m(u, e))
      w = { from: e, to: n > 0 ? void 0 : e };
    else if (b(e, c))
      w = { from: e, to: u };
    else if (y(e, c))
      w = { from: c, to: e };
    else if (y(e, u))
      w = { from: c, to: e };
    else
      throw new Error("Invalid range");
  if (w != null && w.from && (w != null && w.to)) {
    const k = o.differenceInCalendarDays(w.to, w.from);
    r > 0 && k > r ? w = { from: e, to: void 0 } : n > 1 && k < n && (w = { from: e, to: void 0 });
  }
  return w;
}
function Tge(e, t, n = Qv) {
  const r = Array.isArray(t) ? t : [t];
  let s = e.from;
  const o = n.differenceInCalendarDays(e.to, e.from), c = Math.min(o, 6);
  for (let u = 0; u <= c; u++) {
    if (r.includes(s.getDay()))
      return !0;
    s = n.addDays(s, 1);
  }
  return !1;
}
function vz(e, t, n = Qv) {
  return Pv(e, t.from, !1, n) || Pv(e, t.to, !1, n) || Pv(t, e.from, !1, n) || Pv(t, e.to, !1, n);
}
function Mge(e, t, n = Qv) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((u) => typeof u != "function").some((u) => typeof u == "boolean" ? u : n.isDate(u) ? Pv(e, u, !1, n) : $W(u, n) ? u.some((m) => Pv(e, m, !1, n)) : aA(u) ? u.from && u.to ? vz(e, { from: u.from, to: u.to }, n) : !1 : VW(u) ? Tge(e, u.dayOfWeek, n) : zW(u) ? n.isAfter(u.before, u.after) ? vz(e, {
    from: n.addDays(u.after, 1),
    to: n.addDays(u.before, -1)
  }, n) : Ov(e.from, u, n) || Ov(e.to, u, n) : BW(u) || HW(u) ? Ov(e.from, u, n) || Ov(e.to, u, n) : !1))
    return !0;
  const c = r.filter((u) => typeof u == "function");
  if (c.length) {
    let u = e.from;
    const m = n.differenceInCalendarDays(e.to, e.from);
    for (let y = 0; y <= m; y++) {
      if (c.some((b) => b(u)))
        return !0;
      u = n.addDays(u, 1);
    }
  }
  return !1;
}
function Rge(e, t) {
  const { disabled: n, excludeDisabled: r, selected: s, required: o, onSelect: c } = e, [u, m] = nk(s, c ? s : void 0), y = c ? s : u;
  return {
    selected: y,
    select: (k, j, E) => {
      const { min: T, max: D } = e, L = k ? _ge(k, y, T, D, o, t) : void 0;
      return r && n && (L != null && L.from) && L.to && Mge({ from: L.from, to: L.to }, n, t) && (L.from = k, L.to = void 0), c || m(L), c == null || c(L, k, j, E), L;
    },
    isSelected: (k) => y && Pv(y, k, !1, t)
  };
}
function Dge(e, t) {
  const { selected: n, required: r, onSelect: s } = e, [o, c] = nk(n, s ? n : void 0), u = s ? n : o, { isSameDay: m } = t;
  return {
    selected: u,
    select: (w, k, j) => {
      let E = w;
      return !r && u && u && m(w, u) && (E = void 0), s || c(E), s == null || s(E, w, k, j), E;
    },
    isSelected: (w) => u ? m(u, w) : !1
  };
}
function Pge(e, t) {
  const n = Dge(e, t), r = kge(e, t), s = Rge(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return s;
    default:
      return;
  }
}
function Oge(e) {
  const { components: t, formatters: n, labels: r, dateLib: s, locale: o, classNames: c } = dn(() => {
    const Xt = { ...rA, ...e.locale };
    return {
      dateLib: new Xv({
        locale: Xt,
        weekStartsOn: e.broadcastCalendar ? 1 : e.weekStartsOn,
        firstWeekContainsDate: e.firstWeekContainsDate,
        useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
        timeZone: e.timeZone,
        numerals: e.numerals
      }, e.dateLib),
      components: O1e(e.components),
      formatters: G1e(e.formatters),
      labels: { ...oge, ...e.labels },
      locale: Xt,
      classNames: { ...L1e(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]), { captionLayout: u, mode: m, onDayBlur: y, onDayClick: b, onDayFocus: w, onDayKeyDown: k, onDayMouseEnter: j, onDayMouseLeave: E, onNextClick: T, onPrevClick: D, showWeekNumber: L, styles: I } = e, { formatCaption: R, formatDay: U, formatMonthDropdown: z, formatWeekNumber: H, formatWeekNumberHeader: K, formatWeekdayName: q, formatYearDropdown: Q } = n, Z = wge(e, s), { days: X, months: se, navStart: te, navEnd: fe, previousMonth: ce, nextMonth: pe, goToMonth: Se } = Z, oe = Ege(X, e, s), { isSelected: ue, select: he, selected: ve } = Pge(e, s) ?? {}, { blur: Te, focused: Ie, isFocusTarget: Ue, moveFocus: qe, setFocused: it } = jge(e, Z, oe, ue ?? (() => !1), s), { labelDayButton: Ne, labelGridcell: Xe, labelGrid: xt, labelMonthDropdown: rn, labelNav: vt, labelWeekday: At, labelWeekNumber: He, labelWeekNumberHeader: Pt, labelYearDropdown: Lt } = r, er = dn(() => q1e(s, e.ISOWeek), [s, e.ISOWeek]), It = m !== void 0 || b !== void 0, ye = qa(() => {
    ce && (Se(ce), D == null || D(ce));
  }, [ce, Se, D]), ke = qa(() => {
    pe && (Se(pe), T == null || T(pe));
  }, [Se, pe, T]), Pe = qa((Xt, qt) => (In) => {
    In.preventDefault(), In.stopPropagation(), it(Xt), he == null || he(Xt.date, qt, In), b == null || b(Xt.date, qt, In);
  }, [he, b, it]), tt = qa((Xt, qt) => (In) => {
    it(Xt), w == null || w(Xt.date, qt, In);
  }, [w, it]), ot = qa((Xt, qt) => (In) => {
    Te(), y == null || y(Xt.date, qt, In);
  }, [Te, y]), ut = qa((Xt, qt) => (In) => {
    const st = {
      ArrowLeft: ["day", e.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", e.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [In.shiftKey ? "year" : "month", "before"],
      PageDown: [In.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (st[In.key]) {
      In.preventDefault(), In.stopPropagation();
      const [lt, Nt] = st[In.key];
      qe(lt, Nt);
    }
    k == null || k(Xt.date, qt, In);
  }, [qe, k, e.dir]), Vt = qa((Xt, qt) => (In) => {
    j == null || j(Xt.date, qt, In);
  }, [j]), bn = qa((Xt, qt) => (In) => {
    E == null || E(Xt.date, qt, In);
  }, [E]), mr = qa((Xt) => (qt) => {
    const In = Number(qt.target.value), st = s.setMonth(s.startOfMonth(Xt), In);
    Se(st);
  }, [s, Se]), ur = qa((Xt) => (qt) => {
    const In = Number(qt.target.value), st = s.setYear(s.startOfMonth(Xt), In);
    Se(st);
  }, [s, Se]), { className: _r, style: ai } = dn(() => ({
    className: [c[Pr.Root], e.className].filter(Boolean).join(" "),
    style: { ...I == null ? void 0 : I[Pr.Root], ...e.style }
  }), [c, e.className, e.style, I]), ls = A1e(e), Ot = Rt(null);
  dge(Ot, !!e.animate, {
    classNames: c,
    months: se,
    focused: Ie,
    dateLib: s
  });
  const En = {
    dayPickerProps: e,
    selected: ve,
    select: he,
    isSelected: ue,
    months: se,
    nextMonth: pe,
    previousMonth: ce,
    goToMonth: Se,
    getModifiers: oe,
    components: t,
    classNames: c,
    styles: I,
    labels: r,
    formatters: n
  };
  return Ee.createElement(
    OW.Provider,
    { value: En },
    Ee.createElement(
      t.Root,
      { rootRef: e.animate ? Ot : void 0, className: _r, style: ai, dir: e.dir, id: e.id, lang: e.lang, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], ...ls },
      Ee.createElement(
        t.Months,
        { className: c[Pr.Months], style: I == null ? void 0 : I[Pr.Months] },
        !e.hideNavigation && Ee.createElement(t.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: c[Pr.Nav], style: I == null ? void 0 : I[Pr.Nav], "aria-label": vt(), onPreviousClick: ye, onNextClick: ke, previousMonth: ce, nextMonth: pe }),
        se.map((Xt, qt) => {
          const In = W1e(Xt.date, te, fe, n, s), st = K1e(te, fe, n, s);
          return Ee.createElement(
            t.Month,
            { "data-animated-month": e.animate ? "true" : void 0, className: c[Pr.Month], style: I == null ? void 0 : I[Pr.Month], key: qt, displayIndex: qt, calendarMonth: Xt },
            Ee.createElement(t.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: c[Pr.MonthCaption], style: I == null ? void 0 : I[Pr.MonthCaption], calendarMonth: Xt, displayIndex: qt }, u != null && u.startsWith("dropdown") ? Ee.createElement(
              t.DropdownNav,
              { className: c[Pr.Dropdowns], style: I == null ? void 0 : I[Pr.Dropdowns] },
              u === "dropdown" || u === "dropdown-months" ? Ee.createElement(t.MonthsDropdown, { className: c[Pr.MonthsDropdown], "aria-label": rn(), classNames: c, components: t, disabled: !!e.disableNavigation, onChange: mr(Xt.date), options: In, style: I == null ? void 0 : I[Pr.Dropdown], value: s.getMonth(Xt.date) }) : Ee.createElement("span", null, z(Xt.date, s)),
              u === "dropdown" || u === "dropdown-years" ? Ee.createElement(t.YearsDropdown, { className: c[Pr.YearsDropdown], "aria-label": Lt(s.options), classNames: c, components: t, disabled: !!e.disableNavigation, onChange: ur(Xt.date), options: st, style: I == null ? void 0 : I[Pr.Dropdown], value: s.getYear(Xt.date) }) : Ee.createElement("span", null, Q(Xt.date, s)),
              Ee.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, R(Xt.date, s.options, s))
            ) : Ee.createElement(t.CaptionLabel, { className: c[Pr.CaptionLabel], role: "status", "aria-live": "polite" }, R(Xt.date, s.options, s))),
            Ee.createElement(
              t.MonthGrid,
              { role: "grid", "aria-multiselectable": m === "multiple" || m === "range", "aria-label": xt(Xt.date, s.options, s) || void 0, className: c[Pr.MonthGrid], style: I == null ? void 0 : I[Pr.MonthGrid] },
              !e.hideWeekdays && Ee.createElement(
                t.Weekdays,
                { "data-animated-weekdays": e.animate ? "true" : void 0, className: c[Pr.Weekdays], style: I == null ? void 0 : I[Pr.Weekdays] },
                L && Ee.createElement(t.WeekNumberHeader, { "aria-label": Pt(s.options), className: c[Pr.WeekNumberHeader], style: I == null ? void 0 : I[Pr.WeekNumberHeader], scope: "col" }, K()),
                er.map((lt, Nt) => Ee.createElement(t.Weekday, { "aria-label": At(lt, s.options, s), className: c[Pr.Weekday], key: Nt, style: I == null ? void 0 : I[Pr.Weekday], scope: "col" }, q(lt, s.options, s)))
              ),
              Ee.createElement(t.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: c[Pr.Weeks], style: I == null ? void 0 : I[Pr.Weeks] }, Xt.weeks.map((lt, Nt) => Ee.createElement(
                t.Week,
                { className: c[Pr.Week], key: lt.weekNumber, style: I == null ? void 0 : I[Pr.Week], week: lt },
                L && Ee.createElement(t.WeekNumber, { week: lt, style: I == null ? void 0 : I[Pr.WeekNumber], "aria-label": He(lt.weekNumber, {
                  locale: o
                }), className: c[Pr.WeekNumber], scope: "row", role: "rowheader" }, H(lt.weekNumber)),
                lt.days.map((Wt) => {
                  const { date: wn } = Wt, pt = oe(Wt);
                  if (pt[al.focused] = !pt.hidden && !!(Ie != null && Ie.isEqualTo(Wt)), pt[Gg.selected] = (ue == null ? void 0 : ue(wn)) || pt.selected, aA(ve)) {
                    const { from: Cr, to: Wi } = ve;
                    pt[Gg.range_start] = !!(Cr && Wi && s.isSameDay(wn, Cr)), pt[Gg.range_end] = !!(Cr && Wi && s.isSameDay(wn, Wi)), pt[Gg.range_middle] = Pv(ve, wn, !0, s);
                  }
                  const hr = Y1e(pt, I, e.modifiersStyles), _o = i1e(pt, c, e.modifiersClassNames), Il = !It && !pt.hidden ? Xe(wn, pt, s.options, s) : void 0;
                  return Ee.createElement(t.Day, { key: `${s.format(wn, "yyyy-MM-dd")}_${s.format(Wt.displayMonth, "yyyy-MM")}`, day: Wt, modifiers: pt, className: _o.join(" "), style: hr, role: "gridcell", "aria-selected": pt.selected || void 0, "aria-label": Il, "data-day": s.format(wn, "yyyy-MM-dd"), "data-month": Wt.outside ? s.format(wn, "yyyy-MM") : void 0, "data-selected": pt.selected || void 0, "data-disabled": pt.disabled || void 0, "data-hidden": pt.hidden || void 0, "data-outside": Wt.outside || void 0, "data-focused": pt.focused || void 0, "data-today": pt.today || void 0 }, !pt.hidden && It ? Ee.createElement(t.DayButton, { className: c[Pr.DayButton], style: I == null ? void 0 : I[Pr.DayButton], type: "button", day: Wt, modifiers: pt, disabled: pt.disabled || void 0, tabIndex: Ue(Wt) ? 0 : -1, "aria-label": Ne(wn, pt, s.options, s), onClick: Pe(Wt, pt), onBlur: ot(Wt, pt), onFocus: tt(Wt, pt), onKeyDown: ut(Wt, pt), onMouseEnter: Vt(Wt, pt), onMouseLeave: bn(Wt, pt) }, U(wn, s.options, s)) : !pt.hidden && U(Wt.date, s.options, s));
                })
              )))
            )
          );
        })
      ),
      e.footer && Ee.createElement(t.Footer, { className: c[Pr.Footer], style: I == null ? void 0 : I[Pr.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
const Age = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, Lge = (e, t, n) => {
  let r;
  const s = Age[e];
  return typeof s == "string" ? r = s : t === 1 ? r = s.one : r = s.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " 후" : r + " 전" : r;
}, Ige = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, Fge = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Uge = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, zge = {
  date: P8({
    formats: Ige,
    defaultWidth: "full"
  }),
  time: P8({
    formats: Fge,
    defaultWidth: "full"
  }),
  dateTime: P8({
    formats: Uge,
    defaultWidth: "full"
  })
}, Bge = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, Hge = (e, t, n, r) => Bge[e], Vge = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, $ge = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, Gge = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ],
  wide: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ]
}, Wge = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, Yge = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, qge = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, Kge = (e, t) => {
  const n = Number(e);
  switch (String(t == null ? void 0 : t.unit)) {
    case "minute":
    case "second":
      return String(n);
    case "date":
      return n + "일";
    default:
      return n + "번째";
  }
}, Xge = {
  ordinalNumber: Kge,
  era: ay({
    values: Vge,
    defaultWidth: "wide"
  }),
  quarter: ay({
    values: $ge,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ay({
    values: Gge,
    defaultWidth: "wide"
  }),
  day: ay({
    values: Wge,
    defaultWidth: "wide"
  }),
  dayPeriod: ay({
    values: Yge,
    defaultWidth: "wide",
    formattingValues: qge,
    defaultFormattingWidth: "wide"
  })
}, Qge = /^(\d+)(일|번째)?/i, Zge = /\d+/i, Jge = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, e0e = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, t0e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, n0e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, r0e = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, a0e = {
  any: [
    /^1월?$/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, s0e = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, i0e = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, o0e = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, l0e = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, c0e = {
  ordinalNumber: _W({
    matchPattern: Qge,
    parsePattern: Zge,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: sy({
    matchPatterns: Jge,
    defaultMatchWidth: "wide",
    parsePatterns: e0e,
    defaultParseWidth: "any"
  }),
  quarter: sy({
    matchPatterns: t0e,
    defaultMatchWidth: "wide",
    parsePatterns: n0e,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: sy({
    matchPatterns: r0e,
    defaultMatchWidth: "wide",
    parsePatterns: a0e,
    defaultParseWidth: "any"
  }),
  day: sy({
    matchPatterns: s0e,
    defaultMatchWidth: "wide",
    parsePatterns: i0e,
    defaultParseWidth: "any"
  }),
  dayPeriod: sy({
    matchPatterns: o0e,
    defaultMatchWidth: "any",
    parsePatterns: l0e,
    defaultParseWidth: "any"
  })
}, u0e = {
  code: "ko",
  formatDistance: Lge,
  formatLong: zge,
  formatRelative: Hge,
  localize: Xge,
  match: c0e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function d0e(e) {
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    e.property1 === "Unselected" && /* @__PURE__ */ a.jsx("div", { className: "flex w-[5rem] items-center justify-center p-[0.28571rem]", children: /* @__PURE__ */ a.jsxs(
      "button",
      {
        type: "button",
        className: "typo-mshop-en-16-unica-r flex h-[2.85714rem] flex-[1_0_0] items-center justify-center rounded-[0.57143rem] text-mshop-black hover:bg-mshop-gray-10",
        onClick: e.onClick,
        children: [
          e.displayMonth,
          "월"
        ]
      }
    ) }),
    e.property1 === "Today" && /* @__PURE__ */ a.jsx("div", { className: "flex w-[5rem] items-center justify-center p-[0.28571rem]", children: /* @__PURE__ */ a.jsxs(
      "button",
      {
        type: "button",
        className: "typo-mshop-en-16-unica-r flex h-[2.85714rem] flex-[1_0_0] items-center justify-center rounded-[0.57143rem] border border-mshop-blue-100 text-mshop-blue-100",
        onClick: e.onClick,
        children: [
          e.displayMonth,
          "월"
        ]
      }
    ) }),
    e.property1 === "Selected" && /* @__PURE__ */ a.jsx("div", { className: "flex w-[5rem] items-center justify-center p-[0.28571rem]", children: /* @__PURE__ */ a.jsxs(
      "button",
      {
        type: "button",
        className: "typo-mshop-en-16-unica-r flex h-[2.85714rem] flex-[1_0_0] items-center justify-center rounded-[0.57143rem] bg-mshop-blue-100 text-mshop-white",
        onClick: e.onClick,
        children: [
          e.displayMonth,
          "월"
        ]
      }
    ) }),
    e.property1 === "After" && /* @__PURE__ */ a.jsx("div", { className: "flex w-[5rem] items-center justify-center p-[0.28571rem]", children: /* @__PURE__ */ a.jsxs(
      "button",
      {
        type: "button",
        className: "typo-mshop-en-16-unica-r flex h-[2.85714rem] flex-[1_0_0] items-center justify-center text-mshop-gray-50",
        disabled: !0,
        children: [
          e.displayMonth,
          "월"
        ]
      }
    ) })
  ] });
}
const f0e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M4 7.125C4.22 7.125 4.45 7.205 4.62 7.385L12 14.765L19.38 7.385C19.72 7.045 20.28 7.045 20.62 7.385C20.96 7.725 20.96 8.285 20.62 8.625L12.62 16.625C12.28 16.965 11.72 16.965 11.38 16.625L3.38 8.625C3.04 8.285 3.04 7.725 3.38 7.385C3.55 7.215 3.78 7.125 4 7.125Z" })), sA = yn(f0e);
function WW({ disabled: e, onClick: t }) {
  return /* @__PURE__ */ a.jsx(
    "button",
    {
      type: "button",
      className: "flex size-[2.85714rem] shrink-0 items-center justify-end text-mshop-black disabled:text-mshop-gray-20",
      disabled: e,
      onClick: t,
      children: /* @__PURE__ */ a.jsx(sA, { className: "size-[1.42857rem] shrink-0 -rotate-90 transform" })
    }
  );
}
function YW({ disabled: e, onClick: t }) {
  return /* @__PURE__ */ a.jsx(
    "button",
    {
      type: "button",
      className: "flex size-[2.85714rem] shrink-0 items-center text-mshop-black disabled:text-mshop-gray-20",
      disabled: e,
      onClick: t,
      children: /* @__PURE__ */ a.jsx(sA, { className: "size-[1.42857rem] shrink-0 rotate-90 transform" })
    }
  );
}
function m0e({ onPickerToShowToggle: e }) {
  const t = d5(), [n, r] = Re(
    t.months[0].date
  ), s = () => {
    const u = ez(n, n.getFullYear() - 1);
    r(u);
  }, o = () => {
    const u = ez(n, n.getFullYear() + 1);
    r(u);
  }, c = (u) => {
    t.goToMonth(hW(n, u)), e();
  };
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: "inline-flex w-[22.28571rem] flex-col gap-[0.28571rem] rounded-[0.28571rem] border border-mshop-gray-20 bg-mshop-white p-[1.14286rem]",
      style: { boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.08)" },
      children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ a.jsx(
            YW,
            {
              disabled: t.dayPickerProps.startMonth && n.getFullYear() <= t.dayPickerProps.startMonth.getFullYear(),
              onClick: s
            }
          ),
          /* @__PURE__ */ a.jsxs(
            "button",
            {
              type: "button",
              className: "flex items-center gap-[0.57143rem]",
              onClick: e,
              children: [
                /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: [
                  jt(n, "yyyy"),
                  "년"
                ] }),
                /* @__PURE__ */ a.jsx("span", { className: "flex size-[2rem] items-center justify-start", children: /* @__PURE__ */ a.jsx(Z4, { className: "size-[1.14286rem] text-mshop-black" }) })
              ]
            }
          ),
          /* @__PURE__ */ a.jsx(
            WW,
            {
              disabled: t.dayPickerProps.endMonth && n.getFullYear() >= t.dayPickerProps.endMonth.getFullYear(),
              onClick: o
            }
          )
        ] }),
        Qu(ow(12), ZV(4), py).map((u, m) => /* @__PURE__ */ a.jsx("div", { className: "flex", children: u.map((y) => /* @__PURE__ */ a.jsx(
          d0e,
          {
            displayMonth: y + 1,
            property1: t.dayPickerProps.startMonth && t.dayPickerProps.startMonth.getFullYear() === n.getFullYear() && y < t.dayPickerProps.startMonth.getMonth() || t.dayPickerProps.endMonth && t.dayPickerProps.endMonth.getFullYear() === n.getFullYear() && y > t.dayPickerProps.endMonth.getMonth() ? "After" : t.selected && t.selected.getFullYear() === n.getFullYear() && y === t.selected.getMonth() ? "Selected" : y === (/* @__PURE__ */ new Date()).getMonth() ? "Today" : "Unselected",
            onClick: () => c(y)
          },
          y
        )) }, m))
      ]
    }
  );
}
function h0e({
  pickerToShow: e,
  onPickerToShowToggle: t
}) {
  const n = d5(), r = document.getElementById(
    "date-picker-calendar-year-portal-root"
  );
  return e === "Year" && r ? po.createPortal(
    /* @__PURE__ */ a.jsx(m0e, { onPickerToShowToggle: t }),
    r
  ) : /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ a.jsx(
      YW,
      {
        disabled: !n.previousMonth,
        onClick: () => n.goToMonth(n.previousMonth)
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "button",
      {
        type: "button",
        className: "flex items-center gap-[0.57143rem]",
        onClick: t,
        children: [
          /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: [
            jt(n.months[0].date, "yyyy"),
            "년"
          ] }),
          /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: [
            jt(n.months[0].date, "M"),
            "월"
          ] }),
          /* @__PURE__ */ a.jsx(Z4, { className: "size-[1.14286rem] text-mshop-black" })
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(
      WW,
      {
        disabled: !n.nextMonth,
        onClick: () => n.goToMonth(n.nextMonth)
      }
    )
  ] });
}
function p0e(e) {
  const { day: t, modifiers: n, ...r } = e, s = Rt(null);
  return an(() => {
    var o;
    n.focused && ((o = s.current) == null || o.focus());
  }, [n.focused]), /* @__PURE__ */ a.jsx(
    "button",
    {
      ...r,
      ref: s,
      type: "button",
      className: (() => {
        let o = "typo-mshop-en-16-unica-r size-[2.85714rem] rounded-full text-mshop-black hover:bg-mshop-gray-10";
        return n.disabled ? o = $(
          "typo-mshop-en-16-unica-r size-[2.85714rem] rounded-full",
          "text-mshop-gray-20"
        ) : n.selected ? o = $(
          "typo-mshop-en-16-unica-r size-[2.85714rem] rounded-full",
          "bg-mshop-blue-100 text-mshop-white"
        ) : n.today && (o = $(
          "typo-mshop-en-16-unica-r size-[2.85714rem] rounded-full",
          "border border-mshop-blue-100"
        )), o;
      })()
    }
  );
}
const g0e = "12", y0e = "00", v0e = "am", B9 = 10, xz = (e) => e.length === 1 ? `0${e}` : e, bz = (e) => {
  const t = parseInt(e, B9);
  return x3(t) && 0 <= t && t <= 24;
}, Sz = (e) => {
  const t = parseInt(e, B9);
  return x3(t) && 0 <= t && t <= 59;
}, x0e = (e, t) => {
  let n = t;
  return e === "am" && t === 0 ? n = 12 : e === "pm" && 13 <= t && t <= 23 && (n = t - 12), n;
}, b0e = (e) => pW(e, (Lfe(e) + 12) % 24);
function zD({
  selected: e,
  onSelect: t,
  ...n
}) {
  const r = e && e.getHours() >= 12 ? "pm" : v0e, s = e ? String(x0e(r, e.getHours())) : g0e, o = e ? xz(String(e.getMinutes())) : y0e, [c, u] = Re(s), [m, y] = Re(o), [b, w] = Re(r), [k, j] = Re("Month"), E = Rt(e ? e.getHours() : 0), T = Rt(
    e ? e.getMinutes() : 0
  ), D = (U) => {
    const z = new Date(
      U.getFullYear(),
      U.getMonth(),
      U.getDate(),
      E.current,
      T.current
    );
    t == null || t(z);
  }, L = () => {
    if (w(b === "am" ? "pm" : "am"), E.current = (E.current + 12) % 24, e) {
      const z = b0e(e);
      t == null || t(z);
    }
  }, I = () => {
    if (!bz(c))
      return;
    const z = parseInt(c, B9) % 12;
    u(String(z === 0 ? 12 : z));
    const H = b === "am" ? z : z + 12;
    if (E.current = H, e) {
      const K = pW(e, H);
      t == null || t(K);
    }
  }, R = () => {
    if (!Sz(m))
      return;
    const U = xz(m);
    y(U);
    const z = parseInt(m, B9);
    if (T.current = z, e) {
      const H = rme(e, z);
      t == null || t(H);
    }
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "isolate inline-flex w-[22.28571rem] flex-col overflow-hidden rounded-[0.28571rem] border border-mshop-gray-20 bg-mshop-white",
          { hidden: k === "Year" }
        ),
        style: { boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.08)" },
        children: [
          /* @__PURE__ */ a.jsx(
            Oge,
            {
              ...n,
              selected: e,
              mode: "single",
              locale: u0e,
              required: !0,
              classNames: {
                months: "w-full",
                month: "p-[1.14286rem] flex flex-col gap-[0.28571rem]",
                month_grid: "flex flex-col gap-[0.28571rem]",
                weekdays: "flex justify-center",
                weekday: "size-[2.78571rem] typo-mshop-kr-14-r text-mshop-gray-80 p-0 flex justify-center items-center",
                weeks: "flex flex-col gap-[0.28571rem]",
                week: "flex",
                day: "size-[2.85714rem]"
              },
              hideNavigation: !0,
              components: {
                MonthCaption: () => h0e({
                  pickerToShow: k,
                  onPickerToShowToggle: () => j(
                    (U) => U === "Month" ? "Year" : "Month"
                  )
                }),
                DayButton: p0e
              },
              onSelect: D
            }
          ),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[0.28571rem] border-t border-mshop-gray-20 p-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "typo-mshop-kr-16-m flex h-[2.85714rem] w-full items-center justify-center rounded-[0.28571rem] hover:bg-mshop-gray-5",
                onClick: L,
                children: b === "am" ? "오전" : "오후"
              }
            ),
            /* @__PURE__ */ a.jsx(
              "input",
              {
                className: $(
                  "typo-mshop-en-16-unica-m flex h-[2.85714rem] w-full items-center justify-center rounded-[0.28571rem] text-center text-mshop-black caret-mshop-blue-100 outline-none hover:bg-mshop-gray-5",
                  !c || bz(c) ? "border border-transparent focus:text-mshop-blue-100" : "border border-mshop-red-80"
                ),
                value: c,
                maxLength: 2,
                onChange: (U) => u(U.target.value),
                onBlur: I
              }
            ),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-r flex h-[2.85714rem] items-center text-mshop-black", children: ":" }),
            /* @__PURE__ */ a.jsx(
              "input",
              {
                className: $(
                  "typo-mshop-en-16-unica-m flex h-[2.85714rem] w-full items-center justify-center rounded-[0.28571rem] text-center text-mshop-black caret-mshop-blue-100 outline-none hover:bg-mshop-gray-5",
                  !m || Sz(m) ? "border border-transparent focus:text-mshop-blue-100" : "border border-mshop-red-80"
                ),
                value: m,
                maxLength: 2,
                onChange: (U) => y(U.target.value),
                onBlur: R
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ a.jsx("div", { id: "date-picker-calendar-year-portal-root" })
  ] });
}
const J4 = yn(
  ({ padding: e, ...t }, n) => {
    const r = UO(
      t.invalid,
      t.disabled,
      t.readOnly
    );
    return /* @__PURE__ */ a.jsx(
      LE,
      {
        ref: n,
        style: {
          paddingRight: e == null ? void 0 : e.right,
          paddingLeft: e == null ? void 0 : e.left
        },
        ...t,
        className: $(
          "[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
          { "pr-3": !(e != null && e.right) },
          "typo-mshop-kr-14-m h-[2.85714rem] w-full rounded-[.26122rem] border pl-[.85714rem] placeholder-mshop-gray-50 focus:outline-none",
          r
        )
      }
    );
  }
);
function _1({ children: e, ...t }) {
  return /* @__PURE__ */ a.jsx(
    NO,
    {
      ...t,
      className: "typo-mshop-kr-14-m flex w-full items-center justify-between gap-x-[.57143rem] rounded-[.28571rem] border border-mshop-gray-10 bg-mshop-white px-[.85714rem] py-[.57143rem] data-[open]:rounded-b-none data-[open]:border-b-transparent data-[disabled]:bg-mshop-gray-5",
      children: (n) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        typeof e == "function" ? e(n) : e,
        /* @__PURE__ */ a.jsx(
          Z4,
          {
            className: $(
              { "-rotate-180": n.open },
              n.disabled ? "fill-mshop-gray-50" : "fill-mshop-black",
              "flex-shrink-0"
            )
          }
        )
      ] })
    }
  );
}
function T1({
  children: e,
  isSelected: t,
  disabled: n,
  ...r
}) {
  return /* @__PURE__ */ a.jsx(
    EO,
    {
      ...r,
      disabled: n,
      className: $(
        "typo-mshop-kr-14-m select-none px-3 py-2 hover:bg-mshop-gray-5",
        {
          "bg-mshop-gray-5": t
        },
        {
          "cursor-pointer": !n
        }
      ),
      children: (s) => /* @__PURE__ */ a.jsx(a.Fragment, { children: typeof e == "function" ? e(s) : e })
    }
  );
}
function M1({
  children: e,
  anchor: t = "bottom",
  height: n,
  ...r
}) {
  return /* @__PURE__ */ a.jsx(
    jO,
    {
      ...r,
      anchor: t,
      className: $(
        "twp w-[var(--button-width)] overflow-auto rounded-b-[.28571rem] border border-t-0 border-mshop-gray-10 bg-mshop-white text-mshop-black scrollbar-hide",
        { "[--anchor-max-height:20rem]": !n }
      ),
      style: { height: n, zIndex: Tc.GLOBAL.LIST_BOX },
      children: (s) => /* @__PURE__ */ a.jsx(a.Fragment, { children: typeof e == "function" ? e(s) : e })
    }
  );
}
function H9(e) {
  return /* @__PURE__ */ a.jsx(
    HE,
    {
      ...e,
      className: $(
        "group block size-[1.14285rem] rounded-full",
        "cursor-pointer border border-mshop-gray-10 bg-mshop-white",
        "data-[checked]:border-[.35428rem] data-[checked]:border-mshop-blue-100",
        "data-[disabled]:cursor-not-allowed data-[disabled]:border-mshop-gray-10 data-[disabled]:bg-mshop-gray-5",
        "data-[checked]:data-[disabled]:border-mshop-gray-20 data-[checked]:data-[disabled]:bg-mshop-gray-5"
      )
    }
  );
}
const S0e = [
  {
    title: "정기 구독 플랜",
    descriptions: [
      "월 자동 결제로 꾸준한 수익 확보",
      "팬과의 지속적인 소통에 적합한 멤버십 유형"
    ],
    value: $n.SubscriptionPass
  },
  {
    title: "기간 한정 플랜",
    descriptions: [
      "1회 결제로 멤버십 종료일까지 혜택 이용 가능",
      "이벤트/클래스 등 한정 기간 운영으로 단기간 수익 집중"
    ],
    value: $n.ShortTermPass
  }
], w0e = ({
  changeable: e,
  isOpenedBefore: t,
  membershipState: n
}) => {
  var R;
  const {
    register: r,
    watch: s,
    setValue: o,
    control: c,
    formState: { errors: u },
    setError: m,
    clearErrors: y
  } = xp(), { isDevMode: b } = f6(), w = s("payment.startTimeAt"), k = s("payment.endTimeAt"), j = s("payment.price"), E = s("payment.type"), { settingMembership: T } = u5();
  wt(T);
  const D = s("limitCount") !== null, L = b ? Object.values(iz) : Object.values(iz).slice(1), I = {
    type: !e || t,
    price: !e || t,
    startTimeAt: !e || n !== nl.Hidden,
    endTimeAt: !e,
    limitCount: !e
  };
  return /* @__PURE__ */ a.jsxs("section", { className: "flex w-full flex-col gap-y-[2.86rem] rounded-lg border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57143rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 유형" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "최초 공개 후에는 변경할 수 없습니다." })
      ] }),
      /* @__PURE__ */ a.jsx(
        P9,
        {
          ...r("payment.type"),
          className: "flex gap-x-[1.14286rem]",
          value: E,
          onChange: async (U) => {
            o("payment.type", U, {
              shouldDirty: !0,
              shouldValidate: !0
            });
          },
          disabled: I.type,
          children: S0e.map((U) => /* @__PURE__ */ a.jsx(
            HE,
            {
              value: U.value,
              className: "flex w-[26.28571rem] flex-1 cursor-pointer flex-col gap-y-[1.14286rem] rounded-[0.57143rem] border border-mshop-gray-20 p-[1.14286rem] data-[checked]:border-mshop-blue-100 data-[disabled]:border-mshop-gray-10 data-[disabled]:bg-mshop-gray-5",
              children: ({ checked: z, disabled: H }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "block size-[1.14285rem] shrink-0 rounded-full border bg-mshop-white",
                      {
                        "border-[0.35428rem] border-mshop-blue-100": z
                      },
                      {
                        "border-mshop-gray-10 bg-mshop-gray-5": H
                      },
                      {
                        "border-mshop-gray-20 bg-mshop-gray-5": H && z
                      }
                    )
                  }
                ),
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $("typo-mshop-kr-16-b", {
                        "text-mshop-blue-100": z,
                        "text-mshop-gray-50": H,
                        "text-mshop-black": !z && !H
                      }),
                      children: U.title
                    }
                  ),
                  /* @__PURE__ */ a.jsx("ul", { className: "typo-mshop-kr-14-m flex flex-col gap-y-[0.14286rem]", children: U.descriptions.map((K) => /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[.57142rem]", children: [
                    /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.57142rem] flex-shrink-0 items-center", children: /* @__PURE__ */ a.jsx(
                      "div",
                      {
                        className: $(
                          "size-[.22857rem] rounded-full",
                          H ? "bg-mshop-gray-50" : "bg-mshop-gray-80"
                        )
                      }
                    ) }),
                    /* @__PURE__ */ a.jsx(
                      "p",
                      {
                        className: $(
                          "typo-mshop-kr-14-m flex-1",
                          H ? "text-mshop-gray-50" : "text-mshop-gray-80"
                        ),
                        children: K
                      }
                    )
                  ] }, K)) })
                ] })
              ] })
            },
            U.value
          ))
        }
      )
    ] }),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $("flex flex-col gap-y-[1.14286rem]", {
          hidden: E !== $n.ShortTermPass
        }),
        children: [
          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "기간 설정" }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.2rem] 2xl:flex-row 2xl:gap-[0.85714rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 flex-col gap-y-[0.57143rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.28571rem]", children: [
                /* @__PURE__ */ a.jsx(Fs, { label: "멤버십 판매 시작일" }),
                /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                  /* @__PURE__ */ a.jsx(D8, { className: "peer size-[1.429rem] fill-mshop-gray-50" }),
                  /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: "typo-mshop-kr-14-m pointer-events-none absolute top-[2rem] whitespace-nowrap rounded-[1.143rem] bg-mshop-blue-10 bg-opacity-60 p-[1.143rem] text-mshop-blue-100 opacity-0 backdrop-blur-[20px] peer-hover:opacity-100",
                      style: {
                        zIndex: Tc.GLOBAL.TOOLTIP
                      },
                      children: [
                        "공개 중이거나 가입자가 있으면 변경할 수 없습니다. ",
                        /* @__PURE__ */ a.jsx("br", {}),
                        "비공개 상태로 전환 후 변경해 주세요."
                      ]
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(
                vD,
                {
                  name: "payment.startTimeAt",
                  control: c,
                  rules: {
                    validate: (U) => {
                      if (I.startTimeAt || s("payment.type") !== $n.ShortTermPass || !U)
                        return y("payment.startTimeAt"), !0;
                      if (Uv(
                        S2(new Date(U)),
                        S2(/* @__PURE__ */ new Date())
                      )) {
                        const z = "판매 시작일은 현재 시점보다 나중으로 설정해 주세요.";
                        return m("payment.startTimeAt", {
                          message: z
                        }), z;
                      }
                      return y("payment.startTimeAt"), !0;
                    }
                  },
                  render: ({ fieldState: { error: U } }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsxs($8, { className: "relative", children: [
                      /* @__PURE__ */ a.jsx(K4, { as: "div", children: /* @__PURE__ */ a.jsx(
                        "button",
                        {
                          type: "button",
                          className: $(
                            "typo-mshop-kr-14-m flex h-[2.85714rem] w-full items-center rounded-[0.28571rem] border px-[0.85714rem]",
                            !w || I.startTimeAt ? "text-mshop-gray-50" : "text-mshop-black",
                            I.startTimeAt ? "bg-mshop-gray-5" : "bg-mshop-white",
                            U != null && U.message ? "border-mshop-red-80" : "border-mshop-gray-10"
                          ),
                          disabled: I.startTimeAt,
                          children: w ? jt(w, "yyyy-MM-dd a h:mm", {
                            locale: I4
                          }) : "시작일을 선택해 주세요."
                        }
                      ) }),
                      /* @__PURE__ */ a.jsx(
                        X4,
                        {
                          className: "absolute top-[3.4285rem]",
                          style: {
                            zIndex: Tc.GLOBAL.MODAL
                          },
                          children: /* @__PURE__ */ a.jsx(
                            zD,
                            {
                              onSelect: (z) => {
                                o(
                                  "payment.startTimeAt",
                                  jt(z, "yyyy-MM-dd HH:mm"),
                                  {
                                    shouldValidate: !0,
                                    shouldDirty: !0
                                  }
                                );
                              },
                              selected: w ? new Date(w) : void 0,
                              disabled: {
                                before: /* @__PURE__ */ new Date(),
                                after: qU(/* @__PURE__ */ new Date(), 1)
                              },
                              startMonth: /* @__PURE__ */ new Date(),
                              ...w && {
                                defaultMonth: new Date(w)
                              }
                            }
                          )
                        }
                      )
                    ] }),
                    (U == null ? void 0 : U.message) && /* @__PURE__ */ a.jsx(sl, { message: U.message })
                  ] })
                }
              ),
              /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-12-m flex items-center whitespace-pre text-mshop-gray-50", children: [
                "설정한 시작일 전에 플랜은",
                " ",
                /* @__PURE__ */ a.jsx(Phe, { state: "Default", size: "Small" }),
                " 으로 표시되며, 시작일이 되면 자동으로 판매가 시작됩니다."
              ] })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 flex-col gap-y-[0.57143rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.28571rem]", children: [
                /* @__PURE__ */ a.jsx(Fs, { label: "멤버십 종료일", required: !0 }),
                /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                  /* @__PURE__ */ a.jsx(D8, { className: "peer size-[1.429rem] fill-mshop-gray-50" }),
                  /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: "typo-mshop-kr-14-m pointer-events-none absolute top-[2rem] whitespace-nowrap rounded-[1.143rem] bg-mshop-blue-10 bg-opacity-60 p-[1.143rem] text-mshop-blue-100 opacity-0 backdrop-blur-[20px] peer-hover:opacity-100",
                      style: {
                        zIndex: Tc.GLOBAL.TOOLTIP
                      },
                      children: [
                        "최초 공개 후에는 기존 종료일보다 앞당길 수 없으며",
                        /* @__PURE__ */ a.jsx("br", {}),
                        "종료일을 나중으로 연장할 수는 있습니다."
                      ]
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(
                vD,
                {
                  name: "payment.endTimeAt",
                  rules: {
                    required: s("payment.type") === $n.ShortTermPass,
                    validate: (U) => {
                      if (I.endTimeAt || s("payment.type") !== $n.ShortTermPass || !U)
                        return y("payment.endTimeAt"), !0;
                      if (Uv(S2(U), S2(/* @__PURE__ */ new Date()))) {
                        const z = "멤버십 종료일은 현재 시점보다 나중으로 설정해 주세요.";
                        return m("payment.endTimeAt", {
                          message: z
                        }), z;
                      }
                      if (w && Uv(
                        S2(U),
                        S2(QO(new Date(w), 1))
                      )) {
                        const z = "멤버십 종료일은 판매 시작일보다 나중으로 설정해 주세요.";
                        return m("payment.endTimeAt", {
                          message: z
                        }), z;
                      }
                      return y("payment.endTimeAt"), !0;
                    }
                  },
                  render: ({ fieldState: { error: U } }) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsxs($8, { className: "relative", children: [
                      /* @__PURE__ */ a.jsx(K4, { as: "div", children: /* @__PURE__ */ a.jsx(
                        "button",
                        {
                          type: "button",
                          className: $(
                            "typo-mshop-kr-14-m flex h-[2.85714rem] w-full items-center rounded-[0.28571rem] border px-[0.85714rem]",
                            !k || I.endTimeAt ? "text-mshop-gray-50" : "text-mshop-black",
                            I.endTimeAt ? "bg-mshop-gray-5" : "bg-mshop-white",
                            U != null && U.message ? "border-mshop-red-80" : "border-mshop-gray-10"
                          ),
                          disabled: I.endTimeAt,
                          children: k ? jt(k, "yyyy-MM-dd a h:mm", {
                            locale: I4
                          }) : "종료일을 선택해 주세요."
                        }
                      ) }),
                      /* @__PURE__ */ a.jsx(
                        X4,
                        {
                          className: "absolute top-[3.4285rem]",
                          style: {
                            zIndex: Tc.GLOBAL.MODAL
                          },
                          children: /* @__PURE__ */ a.jsx(
                            zD,
                            {
                              onSelect: (z) => {
                                o(
                                  "payment.endTimeAt",
                                  jt(z, "yyyy-MM-dd HH:mm"),
                                  {
                                    shouldValidate: !0,
                                    shouldDirty: !0
                                  }
                                );
                              },
                              selected: k ? new Date(k) : void 0,
                              disabled: {
                                before: /* @__PURE__ */ new Date(),
                                after: qU(/* @__PURE__ */ new Date(), 1)
                              },
                              startMonth: /* @__PURE__ */ new Date(),
                              ...k && {
                                defaultMonth: new Date(k)
                              }
                            }
                          )
                        }
                      )
                    ] }),
                    (U == null ? void 0 : U.message) && /* @__PURE__ */ a.jsx(sl, { message: U.message })
                  ] })
                }
              )
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57143rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 가격" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "최초 공개 후에는 변경할 수 없습니다." })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.71rem] 2xl:flex-row 2xl:gap-[0.85714rem]", children: [
        E === $n.SubscriptionPass && /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col gap-[0.571rem]", children: [
          /* @__PURE__ */ a.jsx(Fs, { label: "결제 주기" }),
          /* @__PURE__ */ a.jsx(J4, { readOnly: !0, value: "1개월" })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col gap-[0.571rem] 2xl:max-w-[50%]", children: [
          /* @__PURE__ */ a.jsx(Fs, { label: "결제 금액" }),
          /* @__PURE__ */ a.jsxs(
            yp,
            {
              ...r("payment.price", Ss.membershipPrice),
              onChange: (U) => {
                o("payment.price", U, {
                  shouldDirty: !0,
                  shouldValidate: !0
                });
              },
              disabled: I.price,
              as: "div",
              children: [
                /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsxs("span", { className: "text-mshop-black", children: [
                  j.toLocaleString(cr.Ko),
                  "원"
                ] }) }),
                /* @__PURE__ */ a.jsx(M1, { height: "20.57142rem", children: L.map((U) => /* @__PURE__ */ a.jsxs(
                  T1,
                  {
                    value: U,
                    isSelected: j === U,
                    children: [
                      U.toLocaleString(),
                      "원"
                    ]
                  },
                  U
                )) })
              ]
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57143rem]", children: [
        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "회원 수 제한" }),
        /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ a.jsx(D8, { className: "peer size-[1.429rem] fill-mshop-gray-50" }),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: "typo-mshop-kr-14-m pointer-events-none absolute top-[2rem] whitespace-nowrap rounded-[1.143rem] bg-mshop-blue-10 bg-opacity-60 p-[1.143rem] text-mshop-blue-100 opacity-0 backdrop-blur-[20px] peer-hover:opacity-100",
              style: {
                zIndex: Tc.GLOBAL.TOOLTIP
              },
              children: [
                "가입 인원이 설정한 수에 도달하면 자동으로 가입이 마감됩니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "회원 수는 언제든 조정할 수 있으니,",
                /* @__PURE__ */ a.jsx("br", {}),
                "운영하면서 내 플랜에 맞는 적정 인원을 찾아보세요."
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex w-[26.42857rem] gap-x-[1.71429rem]", children: [
        /* @__PURE__ */ a.jsxs(
          P9,
          {
            value: D,
            onChange: (U) => {
              o("limitCount", U === !1 ? null : 1, {
                shouldValidate: !0,
                shouldDirty: !0
              });
            },
            className: "flex h-[2.85714rem] flex-shrink-0 gap-x-[1.71429rem]",
            disabled: I.limitCount,
            children: [
              /* @__PURE__ */ a.jsxs(Bd, { className: "flex items-center gap-[0.57143rem]", children: [
                /* @__PURE__ */ a.jsx(H9, { value: !1 }),
                /* @__PURE__ */ a.jsx(
                  _c,
                  {
                    className: I.limitCount ? "" : "cursor-pointer",
                    children: "제한 없음"
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsxs(Bd, { className: "flex items-center gap-[0.57143rem]", children: [
                /* @__PURE__ */ a.jsx(H9, { value: !0 }),
                /* @__PURE__ */ a.jsx(
                  _c,
                  {
                    className: I.limitCount ? "" : "cursor-pointer",
                    children: "제한 있음"
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("flex items-center gap-x-[0.57143rem]", {
              hidden: !D
            }),
            children: [
              /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                /* @__PURE__ */ a.jsx(
                  J4,
                  {
                    ...r("limitCount", {
                      validate: (U) => {
                        if (U === null)
                          return !0;
                        const z = Number(U);
                        return z < 1 || z > 9999 ? "회원 수는 최소 1명에서 최대 9,999명까지 설정 가능합니다." : z < T.memberCount ? "현재 가입 중인 회원 수보다 적게 설정할 수 없습니다." : !0;
                      }
                    }),
                    type: "text",
                    padding: { right: "4.571rem" },
                    disabled: I.limitCount,
                    onChange: (U) => {
                      const z = U.target.value.replace(/[^0-9]/g, "");
                      o("limitCount", Number(z), {
                        shouldValidate: !0,
                        shouldDirty: !0
                      });
                    },
                    invalid: !!u.limitCount
                  }
                ),
                /* @__PURE__ */ a.jsxs("div", { className: "absolute inset-y-0 right-0 flex flex-col justify-center pr-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      className: "size-[0.85714rem]",
                      onClick: () => o(
                        "limitCount",
                        Number(s("limitCount") || 0) + 1,
                        {
                          shouldValidate: !0,
                          shouldDirty: !0
                        }
                      ),
                      type: "button",
                      disabled: I.limitCount,
                      children: /* @__PURE__ */ a.jsx(
                        Z4,
                        {
                          className: $(
                            "size-full rotate-180",
                            I.limitCount ? "fill-mshop-gray-50" : "fill-mshop-black"
                          )
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      className: "size-[0.85714rem]",
                      type: "button",
                      onClick: () => o(
                        "limitCount",
                        Number(s("limitCount") || 0) - 1,
                        {
                          shouldValidate: !0,
                          shouldDirty: !0
                        }
                      ),
                      disabled: I.limitCount,
                      children: /* @__PURE__ */ a.jsx(
                        Z4,
                        {
                          className: $(
                            "size-full",
                            I.limitCount ? "fill-mshop-gray-50" : "fill-mshop-black"
                          )
                        }
                      )
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "명" })
            ]
          }
        )
      ] }),
      ((R = u.limitCount) == null ? void 0 : R.message) && /* @__PURE__ */ a.jsx(sl, { message: u.limitCount.message })
    ] })
  ] });
}, C0e = 150, N0e = "sortable-handle", j0e = `.${N0e}`, E0e = ({
  onCreatorGuideTextClick: e,
  onSetUpGoodsInStudioButtonClick: t,
  onSetUpOrderMadeInStudioButtonClick: n,
  onSetUpDigitalContentsInStudioButtonClick: r,
  onOrderMadeClick: s,
  onDigitalContentsClick: o,
  onGoodsClick: c
}) => {
  const {
    formState: { errors: u },
    watch: m,
    register: y,
    control: b
  } = xp(), { settingMembership: w } = u5();
  wt(w);
  const { fields: k, move: j } = Cae({
    control: b,
    name: "productReward"
  }), E = !w.changeable, T = {
    [ss.BuyGoods]: {
      imageUrl: kt.Admin.RewardItemBuyGoods,
      title: "마플샵제작배송 상품 판매",
      tooltip: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "상품을 직접 만들지 않아도 내가 디자인한 굿즈를 판매할 수 있습니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        "마플샵 멤버십 회원에게만 독점 판매해 보세요."
      ] }),
      outLinkCallback: t
    },
    [ss.BuyOrderMade]: {
      imageUrl: kt.Admin.RewardItemBuyOrderMade,
      title: "크리에이터배송 상품 판매",
      tooltip: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "내가 직접 만들었거나 가지고 있는 상품을 마플샵에서 판매할 수 있습",
        /* @__PURE__ */ a.jsx("br", {}),
        "니다. 직접 배송할 수 있는 상품을 등록하고 멤버십 회원 한정으로 판",
        /* @__PURE__ */ a.jsx("br", {}),
        "매해 보세요."
      ] }),
      outLinkCallback: n
    },
    [ss.BuyDigitalGoods]: {
      imageUrl: kt.Admin.RewardItemBuyDigitalGoods,
      title: "디지털/전자책 상품 판매",
      tooltip: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "전자책, 배경화면, 굿노트, 동영상, 음악 등의 디지털 상품을 등록하여",
        " ",
        /* @__PURE__ */ a.jsx("br", {}),
        "판매할 수 있습니다. 멤버십 회원 한정으로 판매해 보세요."
      ] }),
      outLinkCallback: r
    }
  };
  return /* @__PURE__ */ a.jsxs("section", { className: "flex w-full flex-col gap-y-[1.71429rem] rounded-[0.57143rem] border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]", children: [
    /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[0.57143rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-back", children: "멤버십 전용 상품" }),
      /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
        "아래 상품 추가하기 버튼을 누르고 상품을 만든 뒤 멤버십 상품으로 설정해 주세요. 미리 만들어둔 상품을 설정할 수도 있습니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        "더 자세한 내용은",
        " ",
        /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: "underline underline-offset-2",
            onClick: e,
            children: "크리에이터 가이드"
          }
        ),
        " ",
        /* @__PURE__ */ a.jsx(WE, { className: "inline-block h-[1.14286rem] w-[1.14286rem] fill-mshop-gray-80" }),
        " ",
        "를 참고해 주세요."
      ] })
    ] }),
    /* @__PURE__ */ a.jsx(
      gw.ReactSortable,
      {
        className: "flex flex-col gap-y-[0.28571rem] rounded-[0.85714rem] bg-mshop-gray-5 px-[1.42857rem] py-[1.71429rem]",
        list: k,
        setList: Gd,
        onEnd: ({ oldIndex: D, newIndex: L }) => {
          D === void 0 || L === void 0 || j(D, L);
        },
        animation: C0e,
        group: "product-reward",
        disabled: E,
        handle: j0e,
        children: k.map((D, L) => {
          var I, R, U;
          return /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: "flex flex-col gap-y-[0.85714rem] rounded-[0.57143rem] bg-mshop-white px-[1.14286rem] py-[0.85714rem]",
              children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.85714rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    yw,
                    {
                      className: $(
                        "sortable-handle size-[1.71429rem] flex-shrink-0 fill-mshop-gray-20",
                        { "cursor-pointer": !E }
                      )
                    }
                  ),
                  /* @__PURE__ */ a.jsx("div", { className: "size-[5rem] flex-shrink-0", children: /* @__PURE__ */ a.jsx(
                    aa,
                    {
                      src: T[D.type].imageUrl,
                      width: "5rem",
                      height: "5rem",
                      objectFit: "cover",
                      alt: ""
                    }
                  ) }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 flex-col gap-y-[0.57143rem]", children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.28571rem]", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-black", children: T[D.type].title }),
                      /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                        /* @__PURE__ */ a.jsx(D8, { className: "peer size-[1.14286rem] fill-mshop-gray-50" }),
                        /* @__PURE__ */ a.jsx(
                          "div",
                          {
                            className: "typo-mshop-kr-14-m pointer-events-none absolute top-[2rem] whitespace-nowrap rounded-[1.143rem] bg-mshop-blue-10 bg-opacity-60 p-[1.143rem] text-mshop-blue-100 opacity-0 backdrop-blur-[20px] peer-hover:opacity-100",
                            style: {
                              zIndex: Tc.GLOBAL.TOOLTIP
                            },
                            children: T[D.type].tooltip
                          }
                        )
                      ] })
                    ] }),
                    /* @__PURE__ */ a.jsx(
                      M8,
                      {
                        ...y(`productReward.${L}.title`, {
                          ...Ss.membershipProductRewardTitle
                        }),
                        watch: m(`productReward.${L}.title`) || "",
                        maxLength: 60,
                        disabled: E,
                        invalid: !!((R = (I = u.productReward) == null ? void 0 : I[L]) != null && R.title)
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ a.jsx("div", { className: "flex flex-1 flex-wrap gap-[0.32143rem] pl-[2.57143rem]", children: (U = D.products) == null ? void 0 : U.map((z) => /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                    /* @__PURE__ */ a.jsx(
                      "img",
                      {
                        src: z.image,
                        className: "peer size-[2.85714rem] rounded",
                        alt: "",
                        onClick: () => {
                          switch (D.type) {
                            case ss.BuyGoods:
                              c(z);
                              return;
                            case ss.BuyOrderMade:
                              s(z);
                              return;
                            case ss.BuyDigitalGoods:
                              o(z);
                              return;
                          }
                        }
                      },
                      z.id
                    ),
                    /* @__PURE__ */ a.jsx(
                      "div",
                      {
                        className: "typo-mshop-kr-12-m absolute -top-[0.571rem] left-[1.43rem] whitespace-nowrap rounded-[7.07143rem] border border-mshop-gray-80 bg-mshop-dim-60 px-[0.86rem] py-[0.286rem] text-mshop-white opacity-0 backdrop-blur-[10px] peer-hover:opacity-100",
                        style: {
                          zIndex: Tc.GLOBAL.TOOLTIP
                        },
                        children: z.name
                      }
                    )
                  ] }, z.id)) }),
                  /* @__PURE__ */ a.jsx(
                    za,
                    {
                      variant: "sm",
                      theme: "white",
                      type: "button",
                      iconRear: "outlink",
                      onClick: T[D.type].outLinkCallback,
                      disabled: E,
                      children: "상품 추가하기"
                    }
                  )
                ] })
              ]
            },
            D.id
          );
        })
      }
    )
  ] });
}, k0e = ({
  onCreatorGuideTextClick: e,
  onGoodsClick: t,
  onOrderMadeClick: n,
  onDigitalContentsClick: r,
  onConnectWithCietyCommunityButtonClick: s,
  onSetUpOrderMadeInStudioButtonClick: o,
  onSetUpDigitalContentsInStudioButtonClick: c,
  onSetUpGoodsInStudioButtonClick: u,
  onCheckMyMembershipButtonClick: m,
  setIsFileUploadLoading: y
}) => {
  const { settingMembership: b } = u5();
  wt(b);
  const [w, k] = Re(!1), { watch: j, setValue: E } = xp();
  return /* @__PURE__ */ a.jsxs("section", { className: "flex min-w-[37.57143rem] max-w-[85.71429rem] flex-1 flex-col gap-y-[1.14rem]", children: [
    /* @__PURE__ */ a.jsx(
      Jme,
      {
        selectedMembership: b,
        setIsFileUploadLoading: y
      }
    ),
    /* @__PURE__ */ a.jsx(
      w0e,
      {
        changeable: b.changeable,
        isOpenedBefore: !!b.openAt,
        membershipState: b.state
      }
    ),
    /* @__PURE__ */ a.jsx(
      E0e,
      {
        onCreatorGuideTextClick: e,
        onSetUpGoodsInStudioButtonClick: u,
        onSetUpDigitalContentsInStudioButtonClick: c,
        onSetUpOrderMadeInStudioButtonClick: o,
        onDigitalContentsClick: r,
        onGoodsClick: t,
        onOrderMadeClick: n
      }
    ),
    /* @__PURE__ */ a.jsx(
      Fme,
      {
        communityRewards: j("communityRewards"),
        selectedMembership: b,
        connectWithCietyCommunityButtonDiabled: !b.changeable,
        isDeletionPending: !b.changeable,
        onCommunityRewardsChange: (T) => E("communityRewards", T, {
          shouldDirty: !0
        }),
        onConnectWithCietyCommunityButtonClick: s
      }
    ),
    /* @__PURE__ */ a.jsx(
      Zme,
      {
        onCreatorGuideTextClick: e
      }
    ),
    w && b && /* @__PURE__ */ a.jsx(
      zme,
      {
        selectedMembershipDaoSubdomain: (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          b.dao.subdomain
        ),
        onClose: () => k(!0),
        onCreatorGuideTextClick: e,
        onCheckMyMembershipButtonClick: m
      }
    )
  ] });
};
async function wz(e, t) {
  return jn(
    "/delete-membership",
    {
      body: e
    },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.UnableToProcessRequest:
      case le.TokenExpired:
        return n;
      default:
        throw new Error("PostDeleteMembership");
    }
  });
}
async function dR(e, t) {
  return jn(
    "/v2/update-membership",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.Maximum:
      case le.InvalidImage:
      case le.AlreadyMemberRegisterMembership:
      case le.BadWordName:
      case le.Unchangeable:
      case le.FailedUpdateMembershipPaymentType:
      case le.FailedUpdateMembershipPrice:
      case le.FailedUpdateMembershipStartTimeAt:
      case le.FailedUpdateMembershipEndTimeAt:
      case le.FailedSignedUpLimitReached:
      case le.UnableToProcessRequest:
        return n;
      default:
        throw new Error("postV2UpdateMembership");
    }
  });
}
const Cz = {
  /** 삭제된 상태 */
  Delete: "DELETE",
  /** 멤버십 가입한 멤버가 있어 삭제 예약된 상태 */
  Reserve: "RESERVE"
};
function V9({
  children: e,
  cancelButton: t,
  confirmButton: n
}) {
  const {
    widgetCore: { isMobile: r }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "flex-col-center gap-y-[1.71429rem] rounded-[1.14286rem] bg-mshop-white px-[1.71429rem] pb-[1.71429rem] pt-[2.57143rem]",
        {
          "w-[32rem]": !r,
          "w-[24.5rem]": r
        }
      ),
      children: [
        /* @__PURE__ */ a.jsx("div", { className: "text-center", children: e }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.85714rem] text-center", children: [
          /* @__PURE__ */ a.jsx(
            "button",
            {
              ...t.props,
              type: "button",
              className: $(
                "flex-center typo-mshop-kr-14-b border-gray-20 h-[3.42857rem] w-full rounded-[.57142rem] border bg-mshop-white px-[1.71428rem] text-mshop-gray-80"
              ),
              children: t.text ?? "취소"
            }
          ),
          /* @__PURE__ */ a.jsx(
            "button",
            {
              ...n.props,
              type: "button",
              className: $(
                "flex-center typo-mshop-kr-14-b h-[3.42857rem] w-full rounded-[.57142rem] px-[1.71428rem] text-mshop-white",
                n.color === "red" ? "bg-mshop-red-80" : "bg-mshop-blue-100"
              ),
              children: n.text ?? "확인"
            }
          )
        ] })
      ]
    }
  );
}
function qW(e) {
  return /* @__PURE__ */ a.jsx(
    _ce,
    {
      ...e,
      className: $(
        "group flex h-[1.42857rem] w-[2.57142rem] items-center rounded-full transition",
        "bg-mshop-gray-50",
        "data-[checked]:bg-mshop-blue-100",
        "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-40"
      ),
      children: /* @__PURE__ */ a.jsx(
        "span",
        {
          className: $(
            "size-[1.14285rem] rounded-full bg-mshop-white transition",
            "translate-x-[.14285rem]",
            "group-data-[checked]:translate-x-[1.28571rem]"
          )
        }
      )
    }
  );
}
async function _0e(e, t) {
  return jn(
    "/cancel-membership-notification",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.CanNotChangeMembershipNotificationDueToTime:
        return n;
      default:
        throw new Error("postCancelMembershipNotification");
    }
  });
}
async function T0e(e, t) {
  return jn(
    "/create-membership-notification",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.UnableToProcessRequest:
      case le.TokenExpired:
        return n;
      default:
        throw new Error("postCreateMembershipNotification");
    }
  });
}
async function M0e(e, t) {
  return jn(
    "/update-membership-notification",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.CanNotChangeMembershipNotificationDueToTime:
        return n;
      default:
        throw new Error("postUpdateMembershipNotification");
    }
  });
}
const R0e = ({
  membershipId: e,
  show: t,
  onClose: n,
  prevForm: r
}) => {
  var he, ve;
  const {
    getValues: s,
    watch: o,
    register: c,
    control: u,
    setValue: m,
    setError: y,
    reset: b,
    clearErrors: w,
    trigger: k,
    formState: { errors: j, isValid: E, isDirty: T }
  } = bp({
    reValidateMode: "onChange",
    mode: "onChange"
  }), { setCancelNotification: D, setUpdateNotification: L } = u5(), {
    setCancelNotificationSettingMembership: I,
    setUpdateNotificationSettingMembership: R
  } = ZE(), { client: U } = Ha(), {
    widgetCore: { onError: z, toggleSpinner: H }
  } = Gt(), K = o("reservedAt"), [q, Q] = Re(!1), [Z, X] = Re(!1), [se, te] = Re(!1), fe = () => {
    te(!0), X(!1);
  }, ce = async () => {
    if (!T)
      return !0;
    const Te = await ho({
      body: (Ie, Ue) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: Ie,
            text: "삭제"
          },
          cancelButton: {
            props: Ue
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "작성 내용 초기화" }),
            /* @__PURE__ */ a.jsxs("div", { children: [
              "작성 중인 내용이 초기화됩니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "화면을 닫으시겠습니까?"
            ] })
          ] })
        }
      )
    });
    return Te && b(), Te;
  }, pe = async () => {
    if (!await k())
      return;
    const Te = o("reservedAt");
    await ho({
      body: (Ue, qe) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: Ue,
            text: "메일 보내기"
          },
          cancelButton: {
            props: qe
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: q ? "공지 메일 발송" : "공지 메일 예약 발송" }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: q ? "플랜 가입자 전원에게 공지 메일을 보낼까요?" : "설정한 시간에 맞춰 공지 메일을 보낼까요?" }),
            !q && Te && /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m w-full rounded-[0.57143rem] bg-mshop-blue-10 p-[0.57143rem] text-center text-mshop-blue-100", children: jt(Te, "yyyy-MM-dd a h:mm", {
              locale: I4
            }) })
          ] })
        }
      )
    }) && (se ? await oe() : await Se());
  }, Se = async () => {
    const Te = s();
    H(!0);
    const Ie = await T0e(
      {
        membershipId: e,
        reservedAt: Te.reservedAt,
        content: Te.content
      },
      { client: U, onError: z }
    );
    switch (H(!1), Ie.code) {
      case le.Success: {
        n();
        const Ue = Ie.data.id === null ? null : { ...Te, id: Ie.data.id };
        L(Ue), R({
          targetId: e,
          updateNotification: Ue
        }), b(), await en({
          body: (qe) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: qe
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: q ? "공지 메일 발송 완료" : "공지 메일 예약 완료" }),
                /* @__PURE__ */ a.jsx("div", { children: q ? "공지 메일 발송이 완료되었습니다." : "공지 메일 발송 예약이 완료되었습니다." })
              ] })
            }
          )
        });
        return;
      }
      case le.UnableToProcessRequest:
        await en({
          body: (Ue) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Ue
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "해당 플랜의 가입 멤버 정보나 상태가 변경되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "변경된 정보를 확인해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.TokenExpired:
        z(Ht);
    }
    n();
  }, oe = async () => {
    const Te = s();
    H(!0);
    const Ie = await M0e(
      {
        membershipNotificationId: Te.id,
        content: Te.content,
        reservedAt: Te.reservedAt
      },
      {
        client: U,
        onError: z
      }
    );
    switch (H(!1), Ie.code) {
      case le.Success:
        n(), b(), L(Te), R({
          targetId: e,
          updateNotification: Te
        }), await en({
          body: (Ue) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Ue
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: q ? "공지 메일 발송 완료" : "공지 메일 예약 완료" }),
                /* @__PURE__ */ a.jsx("div", { children: q ? "공지 메일 발송이 완료되었습니다." : "공지 메일 발송 예약이 완료되었습니다." })
              ] })
            }
          )
        });
        return;
      case le.CanNotChangeMembershipNotificationDueToTime:
        await en({
          body: (Ue) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Ue
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "예기치 못한 오류로 인해 진행할 수 없습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "동일한 문제가 반복적으로 발생할 경우",
                  /* @__PURE__ */ a.jsx("br", {}),
                  /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                  "로 문의해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.TokenExpired:
        z(Ht);
        return;
    }
  }, ue = async () => {
    if (wt(r), !await ho({
      body: (Ue, qe) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: Ue,
            text: "네"
          },
          cancelButton: {
            props: qe,
            text: "아니요"
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "예약 발송 취소" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "공지 메일 예약 발송을 취소하고",
              /* @__PURE__ */ a.jsx("br", {}),
              "모든 내용을 초기화하시겠습니까?"
            ] })
          ] })
        }
      )
    }))
      return;
    switch ((await _0e(
      { membershipNotificationId: r.id },
      { client: U, onError: z }
    )).code) {
      case le.Success:
        n(), b(), D(), I(e);
        return;
      case le.CanNotChangeMembershipNotificationDueToTime:
        await en({
          body: (Ue) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Ue
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "예기치 못한 오류로 인해 진행할 수 없습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "동일한 문제가 반복적으로 발생할 경우",
                  /* @__PURE__ */ a.jsx("br", {}),
                  /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                  "로 문의해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.TokenExpired:
        z(Ht);
        return;
    }
  };
  return /* @__PURE__ */ a.jsx(
    Zu,
    {
      show: t,
      onClose: async () => {
        await ce() && n();
      },
      beforeEnter: () => {
        b(r || { reservedAt: null, content: "" }), X(!!r), Q(!r), te(!1);
      },
      children: /* @__PURE__ */ a.jsxs("form", { className: "w-[43.42857rem] overflow-hidden rounded-[1.14286rem] border bg-mshop-white", children: [
        /* @__PURE__ */ a.jsxs("header", { className: "flex items-center justify-between border-b border-b-mshop-gray-5 p-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "공지 메일 보내기" }),
          /* @__PURE__ */ a.jsx(
            Wd,
            {
              className: "size-[1.42857rem] cursor-pointer text-mshop-black",
              onClick: async () => {
                await ce() && n();
              }
            }
          )
        ] }),
        /* @__PURE__ */ a.jsxs("main", { className: "flex max-h-[51.42857rem] flex-col gap-y-[1.71429rem] overflow-y-auto p-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m text-mshop-black", children: [
            "가입한 회원의 이메일로 공지사항을 전달할 수 있어요.",
            /* @__PURE__ */ a.jsx("br", {}),
            " 발송된 이메일은 취소할 수 없으니 신중하게 작성해 주세요."
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsx(Fs, { label: "보내는 시간", required: !0 }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[1.71429rem]", children: [
              /* @__PURE__ */ a.jsxs(
                P9,
                {
                  className: "flex h-[2.85714rem] flex-shrink-0 gap-x-[1.71429rem]",
                  value: q,
                  disabled: Z,
                  onChange: async (Te) => {
                    Q(Te), m("reservedAt", null, {
                      shouldValidate: !0,
                      shouldDirty: !0
                    }), await k();
                  },
                  children: [
                    /* @__PURE__ */ a.jsxs(Bd, { className: "flex items-center gap-[0.57143rem]", children: [
                      /* @__PURE__ */ a.jsx(H9, { value: !0 }),
                      /* @__PURE__ */ a.jsx(_c, { className: $({ "cursor-pointer": !Z }), children: "즉시 발송" })
                    ] }),
                    /* @__PURE__ */ a.jsxs(Bd, { className: "flex items-center gap-[0.57143rem]", children: [
                      /* @__PURE__ */ a.jsx(H9, { value: !1 }),
                      /* @__PURE__ */ a.jsx(_c, { className: $({ "cursor-pointer": !Z }), children: "예약 발송" })
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx("div", { className: $("flex-1", { hidden: q }), children: /* @__PURE__ */ a.jsx(
                vD,
                {
                  name: "reservedAt",
                  control: u,
                  rules: {
                    required: !q,
                    validate: (Te) => {
                      if (q || Z)
                        return w("reservedAt"), !0;
                      if (wt(Te), Uv(
                        S2(new Date(Te)),
                        S2(/* @__PURE__ */ new Date())
                      )) {
                        const Ie = "메일 전송일을 현재 시점보다 나중으로 설정해 주세요.";
                        return y("reservedAt", {
                          message: Ie
                        }), y("reservedAt", { message: Ie }), Ie;
                      }
                      return w("reservedAt"), !0;
                    }
                  },
                  render: ({ fieldState: { error: Te } }) => /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsxs($8, { className: "relative", children: [
                    /* @__PURE__ */ a.jsx(K4, { as: "div", children: /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        disabled: Z,
                        type: "button",
                        className: $(
                          "typo-mshop-kr-14-m flex h-[2.85714rem] w-full items-center rounded-[0.28571rem] border px-[0.85714rem]",
                          !K || Z ? "text-mshop-gray-50" : "text-mshop-black",
                          Z ? "bg-mshop-gray-5" : "bg-mshop-white",
                          Te != null && Te.message ? "border-mshop-red-80" : "border-mshop-gray-10",
                          { "cursor-pointer": !Z }
                        ),
                        children: K ? jt(K, "yyyy-MM-dd a h:mm", {
                          locale: I4
                        }) : "선택"
                      }
                    ) }),
                    /* @__PURE__ */ a.jsx(
                      X4,
                      {
                        className: "absolute top-[3.4285rem]",
                        style: {
                          zIndex: Tc.GLOBAL.MODAL
                        },
                        children: /* @__PURE__ */ a.jsx(
                          zD,
                          {
                            onSelect: (Ie) => {
                              m(
                                "reservedAt",
                                jt(Ie, "yyyy-MM-dd HH:mm"),
                                {
                                  shouldValidate: !0,
                                  shouldDirty: !0
                                }
                              );
                            },
                            selected: K ? new Date(K) : void 0,
                            disabled: {
                              before: /* @__PURE__ */ new Date(),
                              after: KE(/* @__PURE__ */ new Date(), 1)
                            },
                            startMonth: /* @__PURE__ */ new Date(),
                            ...K && {
                              defaultMonth: new Date(K)
                            }
                          }
                        )
                      }
                    )
                  ] }) })
                }
              ) })
            ] }),
            (he = j == null ? void 0 : j.reservedAt) != null && he.message ? /* @__PURE__ */ a.jsx(sl, { message: j.reservedAt.message }) : !q && /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m text-mshop-gray-80", children: "공지 메일 수정, 취소는 발송 5분 전까지만 가능합니다." })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex min-h-[25rem] flex-col gap-y-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsx(Fs, { label: "공지사항", required: !0 }),
            /* @__PURE__ */ a.jsx(
              vy,
              {
                ...c("content", Ss.membershipNoticeEmailContent),
                watch: o("content") || "",
                maxLength: Ss.membershipNoticeEmailContent.maxLength.value,
                invalid: !!(j != null && j.content),
                disabled: Z,
                minRows: 13,
                placeholder: `안녕하세요!
멤버십 공지사항이 있어서 메일로 전달드립니다.

1. 멤버십 상품이 추가되었어요.
2. 커뮤니티 혜택이 변경되었어요.

항상 멤버십을 통해 많은 관심과 사랑을 주셔서 감사드립니다.
앞으로도 많은 활동 기대해 주세요!`
              }
            ),
            ((ve = j == null ? void 0 : j.content) == null ? void 0 : ve.message) && /* @__PURE__ */ a.jsx(sl, { message: j.content.message })
          ] })
        ] }),
        /* @__PURE__ */ a.jsx(
          "footer",
          {
            className: $("border-t border-t-mshop-gray-5 p-[1.14286rem]", {
              "flex gap-x-[1.14286rem]": Z
            }),
            children: Z ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "md",
                  theme: "line",
                  type: "button",
                  widthFull: !0,
                  onClick: ue,
                  disabled: !Uv(
                    /* @__PURE__ */ new Date(),
                    tz(new Date(o("reservedAt")), 4)
                  ),
                  children: "예약 발송 취소"
                }
              ),
              /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "md",
                  theme: "blue",
                  type: "button",
                  widthFull: !0,
                  onClick: fe,
                  disabled: !Uv(
                    /* @__PURE__ */ new Date(),
                    tz(new Date(o("reservedAt")), 4)
                  ),
                  children: "수정하기"
                }
              )
            ] }) : /* @__PURE__ */ a.jsx(
              fn,
              {
                variant: "md",
                theme: "blue",
                type: "button",
                disabled: !E || !T || Object.keys(j).length > 0,
                onClick: pe,
                widthFull: !0,
                children: se ? "수정 완료" : "메일 작성 완료"
              }
            )
          }
        )
      ] })
    }
  );
}, D0e = ({
  show: e,
  onClose: t,
  onConfirm: n,
  onTermsTextClick: r
}) => {
  const { watch: s } = xp(), [o, c] = Re(!1);
  return /* @__PURE__ */ a.jsx(
    Zu,
    {
      show: e,
      onClose: t,
      afterLeave: () => {
        c(!1);
      },
      children: /* @__PURE__ */ a.jsxs("div", { className: "flex w-[32rem] flex-col gap-y-[1.71429rem] rounded-[1.14286rem] bg-mshop-white px-[1.71429rem] pb-[1.71429rem] pt-[2.57143rem]", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] text-center text-mshop-black", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b", children: s("payment.type") === $n.ShortTermPass ? "멤버십 판매 예약하기" : "멤버십 판매하기" }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m", children: "크리에이터 샵에 멤버십을 공개하고 멤버십 판매를 시작할까요?" })
          ] }),
          /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m rounded-[0.57143rem] bg-mshop-gray-5 p-[0.857rem] text-mshop-gray-80", children: [
            /* @__PURE__ */ a.jsxs(il, { children: [
              "멤버십 서비스를 이용하기 전",
              " ",
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  onClick: r,
                  className: "typo-mshop-kr-14-m underline underline-offset-2",
                  children: "이용약관"
                }
              ),
              "을 확인해 주세요."
            ] }),
            /* @__PURE__ */ a.jsxs(il, { children: [
              "(주)마플코퍼레이션(이하 '회사')은 회원 간 콘텐츠 거래를 중개하며,",
              " ",
              /* @__PURE__ */ a.jsx("br", {}),
              "환불·취소 등 거래의 책임은 거래 당사자에게 있습니다."
            ] }),
            /* @__PURE__ */ a.jsx(il, { children: "크리에이터는 서비스 정책을 준수하며, 성실히 이행해야 합니다." }),
            /* @__PURE__ */ a.jsx(il, { children: "멤버십 콘텐츠 미제공 등 정책 위반으로 발생한 손해는 크리에이터가 회원과 회사에 배상해야 합니다." })
          ] }),
          /* @__PURE__ */ a.jsxs(Bd, { className: "flex items-center gap-x-[0.571rem]", children: [
            /* @__PURE__ */ a.jsx(
              $O,
              {
                onChange: (u) => c(u),
                checked: o
              }
            ),
            /* @__PURE__ */ a.jsx(_c, { className: "typo-mshop-kr-14-b cursor-pointer text-mshop-gray-80", children: "위 이용약관을 충분히 읽고 이해하였으며, 약관에 동의합니다." })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.85714rem]", children: [
          /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "md",
              widthFull: !0,
              theme: "line",
              type: "button",
              onClick: t,
              children: "취소"
            }
          ),
          /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "md",
              widthFull: !0,
              theme: "blue",
              type: "button",
              disabled: !o,
              onClick: n,
              children: s("payment.type") === $n.ShortTermPass ? "공개하기" : "판매 시작하기"
            }
          )
        ] })
      ] })
    }
  );
}, fR = (e) => {
  let t;
  return wt(e.price), e.type === $n.SubscriptionPass ? t = {
    type: e.type,
    price: e.price,
    period: 1,
    currency: e.currency
  } : (wt(e.endTimeAt), t = {
    type: e.type,
    price: e.price,
    currency: e.currency,
    endTimeAt: $9(e.endTimeAt),
    ...e.startTimeAt && {
      startTimeAt: $9(e.startTimeAt)
    }
  }), t;
}, P0e = (e) => e.map(
  (t) => XW(t) || KW(t) ? {
    type: t.type,
    title: t.title === null ? void 0 : t.title
  } : { type: t.type, title: t.title }
), O0e = ({
  onClickMembership: e,
  onCreatorGuideTextClick: t,
  onCheckMyMembershipButtonClick: n,
  isFileUploadLoading: r,
  onTermsTextClick: s
}) => {
  var vt, At, He, Pt, Lt, er;
  const {
    watch: o,
    setValue: c,
    setError: u,
    reset: m,
    getValues: y,
    formState: { isValid: b, isDirty: w, errors: k }
  } = xp(), {
    recommendedMembership: j,
    settingMemberships: E,
    setDeleteSettingMembership: T,
    setAddSettingMembership: D,
    setUpdateSettingMembership: L,
    setOpenSettingMembership: I,
    setHiddenSettingMembership: R,
    setDeletePendingSettingMembership: U
  } = ZE(), { settingMembership: z } = u5();
  wt(z);
  const {
    widgetCore: { onError: H, toggleSpinner: K }
  } = Gt(), { client: q } = Ha(), { projectId: Q } = Tf(), [Z, X] = Re(!1), [se, te] = Re(!1), [fe, ce] = Re(!1), pe = !!((vt = z.notification) != null && vt.reservedAt), Se = {
    isRecommended: o("state") === nl.Hidden || !z.changeable,
    hiddenButton: z.memberCount > 0,
    openButton: !z.changeable,
    noticeMailButton: !pe && z.state === nl.Hidden,
    saveButton: !z.changeable || !w || !b || Object.keys(k).length > 0 || r
  }, oe = o("payment.startTimeAt"), ue = o("payment.endTimeAt"), he = z.payment.type === $n.ShortTermPass && z.payment.startTimeAt || null, ve = (At = z.notification) == null ? void 0 : At.reservedAt, Te = dn(() => z.payment.type === $n.ShortTermPass && !!z.payment.startTimeAt && new Date(z.payment.startTimeAt) > /* @__PURE__ */ new Date() ? "판매 예정" : z.limitCount && z.memberCount === z.limitCount ? "가입 마감" : "판매 중", [
    he,
    z.payment.type,
    z.memberCount,
    z.limitCount
  ]), Ie = {
    [nl.Hidden]: {
      text: "비공개",
      badgeStyle: "text-mshop-gray-80 bg-mshop-gray-5"
    },
    [nl.Open]: {
      text: Te,
      badgeStyle: Te === "가입 마감" ? "text-mshop-gray-80 bg-mshop-gray-5" : "text-mshop-white bg-mshop-blue-100"
    },
    [nl.DeletionPending]: {
      text: "삭제 예정",
      badgeStyle: "text-mshop-white bg-mshop-red-80"
    }
  }, Ue = async () => {
    if (z.memberCount > 0 && z.payment.type === $n.ShortTermPass) {
      await en({
        body: (It) => /* @__PURE__ */ a.jsx(
          sa,
          {
            button: {
              props: It
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 삭제 불가" }),
              /* @__PURE__ */ a.jsxs("div", { children: [
                "기간 한정 멤버십은 ",
                /* @__PURE__ */ a.jsx("br", {}),
                "가입자가 있는 경우 삭제가 불가능합니다."
              ] })
            ] })
          }
        )
      });
      return;
    }
    z.memberCount > 0 ? await it() : await qe();
  }, qe = async () => {
    if (!await ho({
      body: (Pe, tt) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: Pe,
            text: "삭제하기",
            color: "red"
          },
          cancelButton: {
            props: tt
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 삭제" }),
            /* @__PURE__ */ a.jsxs("div", { children: [
              "삭제된 멤버십은 복구가 불가능합니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "멤버십을 삭제하시겠어요?"
            ] })
          ] })
        }
      )
    }))
      return;
    K(!0);
    const { code: ye, data: ke } = await wz(
      { membershipId: z.id, state: "DELETED" },
      { client: q, onError: H }
    );
    switch (K(!1), ye) {
      case le.Success: {
        if (wt(ke), O4(
          ke.type === Cz.Delete,
          `Invalid membership delete type: expected "Delete", but got "${ke.type}"`
        ), T(z.id), await en({
          body: (Pe) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Pe
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 삭제 완료" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "멤버십 플랜이 삭제되었습니다. ",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "새로운 플랜을 만들어보세요!"
                ] })
              ] })
            }
          )
        }), ke.hasNoMoreData) {
          K(!0);
          const Pe = await KO(
            { projectId: Q },
            { client: q, onError: H }
          );
          switch (K(!1), Pe.code) {
            case le.Success:
              e(Pe.data), D(Pe.data);
              return;
            case le.Maximum:
              await en({
                body: (tt) => /* @__PURE__ */ a.jsx(
                  sa,
                  {
                    button: {
                      props: tt
                    },
                    children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                      /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                      /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                        "예기치 못한 오류로 인해 진행할 수 없습니다.",
                        /* @__PURE__ */ a.jsx("br", {}),
                        "동일한 문제가 반복적으로 발생할 경우",
                        /* @__PURE__ */ a.jsx("br", {}),
                        /* @__PURE__ */ a.jsx(
                          "a",
                          {
                            href: "mailto:cs@marppleshop.com",
                            className: "underline",
                            children: "cs@marppleshop.com"
                          }
                        ),
                        "로 문의해 주세요."
                      ] })
                    ] })
                  }
                )
              }), window.location.reload();
              return;
            case le.TokenExpired:
            default:
              return H(Ht);
          }
        } else {
          const Pe = E.filter(
            (tt) => tt.id !== z.id
          );
          e(Pe[0]);
        }
        return;
      }
      case le.UnableToProcessRequest: {
        await en({
          body: (Pe) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Pe
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "해당 플랜의 가입 멤버 정보나 상태가 변경되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "변경된 정보를 확인해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      }
      case le.TokenExpired:
      default:
        return H(Ht);
    }
  }, it = async () => {
    if (!await ho({
      body: (Pe, tt) => /* @__PURE__ */ a.jsx(
        V9,
        {
          confirmButton: {
            props: Pe,
            text: "삭제 예약하기",
            color: "red"
          },
          cancelButton: {
            props: tt
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14285rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 삭제 예약" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m mt-[0.28571rem]", children: [
                "멤버십 삭제 예약 1시간 뒤, 약관에 따라 멤버십 회원들에게",
                /* @__PURE__ */ a.jsx("br", {}),
                "자동 안내 메일이 발송됩니다. 아래 내용을 꼭 확인해 주세요."
              ] })
            ] }),
            /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m list-disc rounded-lg bg-mshop-gray-5 py-[0.57143rem] pl-[2.28571rem] pr-[0.57143rem] text-left text-mshop-gray-80", children: [
              /* @__PURE__ */ a.jsx("li", { children: "멤버십 가입 회원들에게 멤버십 삭제에 대해 안내해 주세요." }),
              /* @__PURE__ */ a.jsx("li", { children: "삭제 예약 시점부터 멤버십 회원들의 정기결제가 해지됩니다." }),
              /* @__PURE__ */ a.jsx("li", { children: "삭제 예약 중에는 멤버십 변경이 불가합니다." }),
              /* @__PURE__ */ a.jsxs("li", { children: [
                "연동된 커뮤니티가 있다면, 커뮤니티 내 멤버십 그룹이 삭제됩니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "(커뮤니티 회원은 보존되며, 멤버십 권한만 삭제됩니다.)"
              ] }),
              /* @__PURE__ */ a.jsx("li", { children: "삭제 예정 날짜에 멤버십이 완전히 삭제되며, 복구가 불가능합니다." })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m rounded-lg bg-mshop-red-10 px-[0.85714rem] py-[0.57143rem] text-center text-mshop-red-80", children: [
              "삭제를 예약한 멤버십 플랜은 30일 후 자동 삭제되며, ",
              /* @__PURE__ */ a.jsx("br", {}),
              "예약 후 취소는 불가능합니다."
            ] })
          ] })
        }
      )
    }))
      return;
    K(!0);
    const { code: ye, data: ke } = await wz(
      { membershipId: z.id, state: "DELETION_PENDING" },
      { client: q, onError: H }
    );
    switch (K(!1), ye) {
      case le.Success: {
        wt(ke), O4(
          ke.type === Cz.Reserve,
          `Invalid membership delete type: expected "RESERVE", but got "${ke.type}"`
        ), await en({
          body: (Pe) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Pe
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 삭제 예약 완료" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "멤버십 삭제가 예약되었습니다. ",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "멤버십 회원들에게 멤버십 삭제에 대해 안내해 주세요."
                ] })
              ] })
            }
          )
        }), U({
          id: z.id,
          deletionAt: ke.deletionAt
        }), e({
          ...z,
          state: nl.DeletionPending,
          deletionAt: ke.deletionAt,
          changeable: !1
        });
        return;
      }
      case le.UnableToProcessRequest: {
        await en({
          body: (Pe) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Pe
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "해당 플랜의 가입 멤버 정보나 상태가 변경되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "변경된 정보를 확인해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      }
      case le.TokenExpired:
      default:
        return H(Ht);
    }
  }, Ne = async () => {
    if (E.filter(
      (Pe) => Pe.state === nl.Open || Pe.state === nl.DeletionPending
    ).length >= 5) {
      await en({
        body: (Pe) => /* @__PURE__ */ a.jsx(
          sa,
          {
            button: {
              props: Pe
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 개수 초과" }),
              /* @__PURE__ */ a.jsxs("div", { children: [
                "최대 5개의 플랜만 마플샵에 공개할 수 있습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "추가 플랜을 공개하려면 공개 중인 플랜을 비공개하거나 삭제해 주세요."
              ] })
            ] })
          }
        )
      });
      return;
    }
    K(!0);
    let ye;
    o("payment.type") === $n.ShortTermPass && !o("payment.startTimeAt") && (ye = jt(
      QO(/* @__PURE__ */ new Date(), 30),
      "yyyy-MM-dd HH':'mm"
    ));
    const ke = await dR(
      {
        membershipId: z.id,
        state: nl.Open,
        ...!z.openAt && { isTermsChecked: !0 },
        ...ye && {
          payment: fR({
            ...o("payment"),
            startTimeAt: ye
          })
        }
      },
      { client: q, onError: H }
    );
    K(!1), ke.code === le.Success && (X(!0), I(z.id)), await rn(ke);
  }, Xe = async () => {
    if (w) {
      await en({
        body: (ye) => /* @__PURE__ */ a.jsx(
          sa,
          {
            button: {
              props: ye
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "저장되지 않은 입력 내용" }),
              /* @__PURE__ */ a.jsxs("div", { children: [
                "입력한 내용이 저장되지 않았습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "먼저 저장하기 버튼을 눌러 저장해 주세요."
              ] })
            ] })
          }
        )
      });
      return;
    }
    K(!0);
    const It = await dR(
      {
        membershipId: z.id,
        isRecommended: !1,
        state: nl.Hidden
      },
      { client: q, onError: H }
    );
    K(!1), It.code === le.Success && (R(z.id), await en({
      body: (ye) => /* @__PURE__ */ a.jsx(
        sa,
        {
          button: {
            props: ye
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 비공개 완료" }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "멤버십 플랜이 비공개 상태로 변경되었습니다." })
          ] })
        }
      )
    })), await rn(It);
  }, xt = async () => {
    var ut, Vt;
    if (z.memberCount > 0 && !await ho({
      body: (mr, ur) => /* @__PURE__ */ a.jsx(
        V9,
        {
          confirmButton: {
            props: mr,
            text: "변경 저장하기"
          },
          cancelButton: {
            props: ur
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14285rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 변경 저장" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m mt-[0.28571rem]", children: [
                "멤버십 변경 사항에 대해 멤버들에게 충분히 안내해 주세요.",
                /* @__PURE__ */ a.jsx("br", {}),
                "변경 적용 전 다음 사항을 꼭 확인해 주세요."
              ] })
            ] }),
            /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m list-disc rounded-lg bg-mshop-gray-5 py-[0.57143rem] pl-[2.28571rem] pr-[0.57143rem] text-left text-mshop-gray-80", children: [
              /* @__PURE__ */ a.jsx("li", { children: "변경 내용은 즉시 멤버십 전체에 적용됩니다." }),
              /* @__PURE__ */ a.jsx("li", { children: "단, 상품 혜택은 멤버십 상품이 설정되어야 노출됩니다." }),
              /* @__PURE__ */ a.jsxs("li", { children: [
                "멤버십에 변경 사항이 있을 경우",
                " ",
                /* @__PURE__ */ a.jsx(t9, { className: "inline-block size-[1.42857rem]" }),
                " 공지 기능을 활용해 주세요."
              ] })
            ] })
          ] })
        }
      )
    }))
      return;
    const It = y(), ye = QW(z.payment), ke = Kl(
      fR(ye),
      fR({
        ...It.payment
      })
    ), Pe = [
      ...(o("productReward") || []).map((bn) => ({
        ...bn,
        title: bn.title === c6[bn.type] ? null : bn.title
      })),
      ...o("communityRewards") || [],
      ...o("creatorReward") || []
    ], tt = Kl(
      (ut = z.rewards) == null ? void 0 : ut.map(({ type: bn, title: mr }) => ({
        type: bn,
        title: mr
      })),
      Pe.map(({ type: bn, title: mr }) => ({
        type: bn,
        title: mr
      }))
    );
    K(!0);
    const ot = await dR(
      {
        thumbnailImageUrl: Kl(
          (Vt = z == null ? void 0 : z.thumbnailImage) == null ? void 0 : Vt.url,
          (It == null ? void 0 : It.thumbnailImageUrl) || z9
        ),
        displayName: Kl(
          z.displayName,
          It.displayName
        ),
        description: Kl(
          z.description,
          It.description || null
        ),
        isRecommended: Kl(
          z.isRecommended,
          It.isRecommended
        ),
        limitCount: Kl(
          z.limitCount === null ? 0 : z.limitCount,
          It.limitCount === null ? 0 : Number(It.limitCount)
        ),
        membershipId: z.id,
        ...tt && {
          rewards: P0e(Pe)
        },
        ...ke && {
          payment: ke
        }
      },
      { client: q, onError: H }
    );
    K(!1), ot.code === le.Success && await en({
      body: (bn) => /* @__PURE__ */ a.jsx(
        sa,
        {
          button: {
            props: bn
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "변경 저장 완료" }),
            /* @__PURE__ */ a.jsx("div", { children: "멤버십 변경이 저장되었습니다." })
          ] })
        }
      )
    }), await rn(ot);
  }, rn = async (It) => {
    switch (It.code) {
      case le.Success:
        e(It.data), L(It.data);
        return;
      case le.BadWordName: {
        const ye = It.data.column;
        O4(
          ye === "displayName" || ye === "description",
          `Unexpected column value: ${It.data.column}. Expected "displayName" or "description".`
        ), u(ye, {
          message: ye === "displayName" ? "부적절한 단어가 포함되어 있습니다. 다른 이름을 입력해 주세요." : "부적절한 단어가 포함되어 있습니다. 입력 텍스트를 확인해 주세요."
        });
        return;
      }
      case le.FailedUpdateMembershipStartTimeAt: {
        It.data.column === "state" ? (await en({
          body: (ye) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: ye
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "해당 플랜의 가입 멤버 정보나 상태가 변경되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "변경된 정보를 확인해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload()) : u("payment.startTimeAt", {
          message: "판매 시작일은 현재 시점보다 나중으로 설정해 주세요."
        });
        return;
      }
      case le.FailedUpdateMembershipEndTimeAt: {
        u("payment.endTimeAt", {
          message: It.data.column === "greaterThenNow" ? "멤버십 종료일은 현재 시점보다 나중으로 설정해 주세요." : "멤버십 종료일은 판매 시작일보다 나중으로 설정해 주세요."
        });
        return;
      }
      case le.TokenExpired:
        return H(Ht);
      case le.FailedSignedUpLimitReached:
      case le.AlreadyMemberRegisterMembership:
      case le.Unchangeable:
      case le.Maximum:
        await en({
          body: (ye) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: ye
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "해당 플랜의 가입 멤버 정보나 상태가 변경되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "변경된 정보를 확인해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.UnableToProcessRequest:
      case le.FailedUpdateMembershipPaymentType:
      case le.FailedUpdateMembershipPrice:
      case le.InvalidImage:
      default:
        await en({
          body: (ye) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: ye
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "예기치 못한 오류로 인해 진행할 수 없습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "동일한 문제가 반복적으로 발생할 경우",
                  /* @__PURE__ */ a.jsx("br", {}),
                  /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                  "로 문의해 주세요."
                ] })
              ] })
            }
          )
        }), m();
        return;
    }
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs("section", { className: "sticky top-[2.85714rem] h-fit w-[36.429rem] min-w-[25.71429rem] flex-shrink", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.71429rem] rounded-[0.57143rem] border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsx(
            "img",
            {
              src: o("thumbnailImageUrl") || z9,
              className: "size-[6.28571rem] flex-shrink-0 rounded-[1.14286rem] object-cover",
              alt: ""
            }
          ),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b line-clamp-2 break-all text-mshop-black", children: o("displayName") }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.28571rem]", children: [
              /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: [
                (He = o("payment.price")) == null ? void 0 : He.toLocaleString(cr.Ko),
                "원"
              ] }),
              /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: [
                " ",
                "/",
                " ",
                o("payment.type") === $n.ShortTermPass ? "단건 결제" : "정기 결제"
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[1.14286rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b w-[6.28571rem] flex-shrink-0 text-mshop-gray-50", children: "멤버십 상태" }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57143rem]", children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "typo-mshop-kr-12-m flex-center flex w-fit rounded-[0.28571rem] px-[0.57143rem] pb-[0.28571rem] pt-[0.21429rem]",
                    Ie[z.state].badgeStyle
                  ),
                  children: Ie[z.state].text
                }
              ),
              z.state === nl.DeletionPending && z.deletionAt && /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                jt(
                  new Date(z.deletionAt),
                  "yyyy.MM.dd HH':'mm"
                ),
                "까지"
              ] })
            ] })
          ] }),
          o("payment.type") === $n.ShortTermPass && /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[1.14286rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b w-[6.28571rem] flex-shrink-0 text-mshop-gray-50", children: "판매 / 종료" }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] text-mshop-black", children: [
              oe ? /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.57143rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.28571rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m", children: jt(oe, "yyyy-MM-dd") }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: jt(oe, "a", {
                    locale: I4
                  }) }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m", children: jt(oe, "h:mm") })
                ] }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "판매 시작" })
              ] }) : /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m", children: "판매 예약 후 30분 뒤 자동으로 판매가 시작됩니다." }),
              ue ? /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.57143rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.28571rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m", children: jt(ue, "yyyy-MM-dd") }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: jt(ue, "a", {
                    locale: I4
                  }) }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m", children: jt(ue, "h:mm") })
                ] }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "멤버십 종료" })
              ] }) : /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m", children: "멤버십 종료일을 설정해 주세요." })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b w-[6.28571rem] flex-shrink-0 text-mshop-gray-50", children: "혜택" }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-wrap items-center gap-x-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.28571rem] text-mshop-black", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "멤버십 상품" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m", children: ((Pt = o("productReward")) == null ? void 0 : Pt.flatMap((It) => It.products).length) || 0 })
            ] }),
            /* @__PURE__ */ a.jsx("div", { className: "h-[0.85714rem] w-[0.07143rem] flex-shrink-0 bg-mshop-gray-20" }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.28571rem] text-mshop-black", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "커뮤니티" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m", children: ((Lt = o("communityRewards")) == null ? void 0 : Lt.filter(
                (It) => It.type === yW.Dm ? It.dm : It.channels.length > 0
              ).length) || 0 })
            ] }),
            /* @__PURE__ */ a.jsx("div", { className: "h-[0.85714rem] w-[0.07143rem] flex-shrink-0 bg-mshop-gray-20" }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.28571rem] text-mshop-black", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "크리에이터" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m", children: ((er = o("creatorReward")) == null ? void 0 : er.length) || 0 })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-wrap gap-y-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 items-center gap-x-[1.14286rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex w-[6.28571rem] flex-shrink-0 items-center gap-x-[0.29rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-gray-50", children: "추천 여부" }),
              /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                /* @__PURE__ */ a.jsx(D8, { className: "peer size-[1.429rem] fill-mshop-gray-80" }),
                /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: "typo-mshop-kr-14-m pointer-events-none absolute left-1/2 top-[2rem] -translate-x-1/2 whitespace-nowrap rounded-[1.143rem] bg-mshop-blue-10 bg-opacity-60 p-[1.143rem] text-center text-mshop-blue-100 opacity-0 backdrop-blur-[40px] peer-hover:opacity-100",
                    style: {
                      zIndex: Tc.GLOBAL.TOOLTIP
                    },
                    children: [
                      "판매/판매 예약 중인 플랜 중",
                      /* @__PURE__ */ a.jsx("br", {}),
                      "1개의 플랜만 추천할 수 있어요.",
                      /* @__PURE__ */ a.jsx("br", {}),
                      "팬들에게 멤버십을 추천해 보세요!"
                    ]
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ a.jsx(
              qW,
              {
                checked: o("isRecommended"),
                disabled: Se.isRecommended,
                onChange: async (It) => {
                  let ye = It;
                  It && j && j.id !== z.id && (ye = await ho({
                    body: (ke, Pe) => /* @__PURE__ */ a.jsx(
                      qu,
                      {
                        confirmButton: {
                          props: ke,
                          text: "변경"
                        },
                        cancelButton: {
                          props: Pe
                        },
                        children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 추천 변경" }),
                          /* @__PURE__ */ a.jsxs("div", { children: [
                            "다른 멤버십 추천 여부를 해지하고",
                            /* @__PURE__ */ a.jsx("br", {}),
                            "이 멤버십으로 추천 멤버십을 변경할까요?"
                          ] })
                        ] })
                      }
                    )
                  })), c("isRecommended", ye, {
                    shouldValidate: !0,
                    shouldDirty: !0
                  });
                }
              }
            )
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-[1.14286rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b w-[6.28571rem] flex-shrink-0 text-mshop-gray-50", children: "회원 수" }),
            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-16-b w-[6.28571rem] text-mshop-black", children: [
              z.memberCount,
              " ",
              o("limitCount") !== null && `/ ${o("limitCount")}`
            ] })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-start gap-x-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b w-[6.28571rem] flex-shrink-0 text-mshop-gray-50", children: "공지사항" }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsxs(
              "button",
              {
                type: "button",
                className: $(
                  "flex-center flex h-[2.28571rem] w-fit gap-x-[0.28571rem] rounded-[0.57143rem] px-[0.85714rem]",
                  Se.noticeMailButton ? "bg-mshop-gray-5 text-mshop-gray-50" : "bg-mshop-blue-10 text-mshop-blue-100"
                ),
                onClick: () => te(!0),
                disabled: Se.noticeMailButton,
                children: [
                  /* @__PURE__ */ a.jsx(t9, { className: "size-[1.14286rem]" }),
                  /* @__PURE__ */ a.jsx("span", { children: pe ? "공지 메일 예약 완료" : "공지 메일 보내기" }),
                  pe && /* @__PURE__ */ a.jsx("span", { className: "h-[1.57143rem] pt-[0.28571rem]", children: /* @__PURE__ */ a.jsx(w3, {}) })
                ]
              }
            ),
            ve && /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.57143rem] text-mshop-black", children: [
              /* @__PURE__ */ a.jsxs("p", { className: "flex gap-x-[0.28571rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m", children: jt(
                  ve,
                  "yyyy-MM-dd"
                ) }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: jt(ve, "a", {
                  locale: I4
                }) }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m", children: jt(ve, "h:mm") })
              ] }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "메일 발송 예정" })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m rounded-lg border bg-mshop-gray-5 p-[0.857rem] text-mshop-gray-80", children: [
          /* @__PURE__ */ a.jsx(il, { children: "결제 금액은 판매가 시작되면 변경할 수 없습니다." }),
          /* @__PURE__ */ a.jsx(il, { children: /* @__PURE__ */ a.jsxs("span", { className: "flex flex-wrap items-center gap-x-[0.28571rem]", children: [
            "멤버십에 변경 사항이 있을 경우",
            /* @__PURE__ */ a.jsx(t9, { className: "size-[1.42857rem]" }),
            "공지 메일 보내기 기능을 활용해 주세요."
          ] }) })
        ] }),
        z.state === nl.DeletionPending || z.state === nl.Hidden && !z.changeable ? /* @__PURE__ */ a.jsx(za, { type: "button", theme: "blue", variant: "md", disabled: !0, children: z.state === nl.DeletionPending ? "삭제 예정인 멤버십입니다" : "종료된 멤버십입니다 " }) : /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.71429rem]", children: [
          /* @__PURE__ */ a.jsx(
            za,
            {
              widthFull: !0,
              type: "button",
              theme: "lineSky",
              variant: "md",
              disabled: Se.saveButton,
              onClick: xt,
              children: "저장하기"
            }
          ),
          z.state === nl.Open ? /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              className: $(
                "typo-mshop-kr-14-m w-full rounded-[0.28571rem] px-[1.71429rem] py-[0.92857rem]",
                Se.hiddenButton ? "bg-mshop-gray-5 text-mshop-gray-50" : "bg-mshop-red-80 text-mshop-white"
              ),
              disabled: Se.hiddenButton,
              onClick: Xe,
              children: "멤버십 비공개하기"
            }
          ) : /* @__PURE__ */ a.jsx(
            za,
            {
              widthFull: !0,
              type: "button",
              theme: "blue",
              variant: "md",
              disabled: Se.openButton,
              onClick: async () => {
                if (w) {
                  await en({
                    body: (It) => /* @__PURE__ */ a.jsx(
                      sa,
                      {
                        button: {
                          props: It
                        },
                        children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "저장되지 않은 입력 내용" }),
                          /* @__PURE__ */ a.jsxs("div", { children: [
                            "입력한 내용이 저장되지 않았습니다.",
                            /* @__PURE__ */ a.jsx("br", {}),
                            "먼저 저장하기 버튼을 눌러 저장해 주세요."
                          ] })
                        ] })
                      }
                    )
                  });
                  return;
                }
                z.openAt ? await Ne() : ce(!0);
              },
              children: o("payment.type") === $n.SubscriptionPass ? "멤버십 판매하기" : "멤버십 판매 예약하기"
            }
          )
        ] })
      ] }),
      z.state !== nl.DeletionPending && /* @__PURE__ */ a.jsx("div", { className: "mt-[1.429rem] text-right", children: /* @__PURE__ */ a.jsx(
        "button",
        {
          type: "button",
          className: "typo-mshop-kr-14-m text-mshop-gray-50 underline underline-offset-2",
          onClick: Ue,
          children: "이 멤버십 삭제하기"
        }
      ) })
    ] }),
    /* @__PURE__ */ a.jsx(
      BG,
      {
        show: Z,
        onClose: () => X(!1),
        imgUrl: kt.KeyVisual.MembershipMeetFan,
        title: "MEMBERSHIP OPEN!",
        descriptions: [
          "멤버십 결제 금액은 판매가 시작되면 변경할 수 없습니다.",
          "멤버십에서 약속한 혜택은 반드시 계획한 대로 제공해 주세요.",
          `멤버십 회원의 개인 정보는 철저히 보호해 주시고,
외부로 유출되지 않도록 주의해 주세요.`
        ],
        confirmButton: {
          title: "내 멤버십 확인하기",
          onClick: () => {
            X(!1), n();
          }
        },
        guidLineButton: {
          title: "크리에이터 가이드 보러가기",
          onClick: t
        }
      }
    ),
    /* @__PURE__ */ a.jsx(
      R0e,
      {
        show: se,
        onClose: () => te(!1),
        membershipId: o("id"),
        prevForm: pe ? z.notification : null
      }
    ),
    /* @__PURE__ */ a.jsx(
      D0e,
      {
        show: fe,
        onClose: () => {
          ce(!1);
        },
        onConfirm: async () => {
          ce(!1), await Ne();
        },
        onTermsTextClick: s
      }
    )
  ] });
};
function A0e({
  onClickMembership: e,
  selectedItem: t,
  sortedList: n
}) {
  const {
    formState: { isDirty: r }
  } = xp(), {
    settingMemberships: s,
    setSettingMemberships: o,
    setAddSettingMembership: c,
    setUpdateSettingMembership: u
  } = ZE(), {
    widgetCore: { onError: m, toggleSpinner: y }
  } = Gt(), { projectId: b } = Tf(), { client: w } = Ha(), k = async (D) => {
    if (D.map((R) => R.id).join("_") === (s == null ? void 0 : s.map((R) => R.id).join("_")))
      return;
    const L = {
      projectId: b,
      type: nO.Membership,
      items: D.map((R) => ({
        id: R.id
      }))
    };
    o(D), y(!0);
    const { code: I } = await eO(L, {
      client: w,
      onError: m
    });
    if (y(!1), I === le.TokenExpired)
      return m(Ht);
  }, j = async () => r ? await ho({
    body: (D, L) => /* @__PURE__ */ a.jsx(
      qu,
      {
        confirmButton: {
          props: D,
          text: "삭제"
        },
        cancelButton: {
          props: L
        },
        children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "저장되지 않은 입력 내용" }),
          /* @__PURE__ */ a.jsxs("div", { children: [
            "입력한 내용이 저장되지 않았습니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "저장하지 않고 내용을 삭제할까요?"
          ] })
        ] })
      }
    )
  }) : !0, E = async () => {
    if (!await j())
      return;
    if (s && s.length >= 50) {
      await en({
        body: (L) => /* @__PURE__ */ a.jsx(
          sa,
          {
            button: {
              props: L
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "멤버십 개수 초과" }),
              /* @__PURE__ */ a.jsxs("div", { children: [
                "최대 50개의 플랜만 생성할 수 있습니다. ",
                /* @__PURE__ */ a.jsx("br", {}),
                "추가 플랜을 만들려면 기존 플랜을 삭제해 주세요."
              ] })
            ] })
          }
        )
      });
      return;
    }
    y(!0);
    const D = await KO(
      { projectId: b },
      { client: w, onError: m }
    );
    switch (y(!1), D.code) {
      case le.Success:
        e(D.data), c(D.data);
        return;
      case le.Maximum:
        await en({
          body: (L) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: L
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "해당 플랜의 가입 멤버 정보나 상태가 변경되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "변경된 정보를 확인해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.TokenExpired:
      default:
        return m(Ht);
    }
  }, T = async (D) => {
    if ((t == null ? void 0 : t.id) === D.id || !await j())
      return;
    y(!0);
    const L = await gW(
      { membershipId: D.id },
      { client: w, onError: m }
    );
    switch (y(!1), L.code) {
      case le.Success:
        e(L.data), u(L.data);
        return;
      case le.TokenExpired:
      default:
        return m(Ht);
    }
  };
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: "flex h-[57.14285rem] w-[20rem] flex-shrink-0 flex-col gap-y-[1.71428rem] overflow-hidden rounded-[.57142rem] bg-mshop-gray-5 px-[1.14286rem] py-[1.71429rem]",
      id: "membership-create-plan-list",
      children: [
        n && /* @__PURE__ */ a.jsx("div", { className: "overflow-y-auto", children: /* @__PURE__ */ a.jsx(
          gw.ReactSortable,
          {
            className: "flex flex-col gap-y-[.28571rem]",
            list: n,
            setList: k,
            animation: 150,
            handle: ".sortable-handle",
            children: n.map((D) => /* @__PURE__ */ a.jsxs(
              "button",
              {
                type: "button",
                className: $(
                  "flex-0 flex min-h-[2.85714rem] items-center gap-x-[0.28571rem] rounded-[.28571rem] border bg-mshop-white px-[.85714rem]",
                  {
                    "border-mshop-blue-100": (t == null ? void 0 : t.id) === D.id
                  }
                ),
                onClick: async () => {
                  await T(D);
                },
                children: [
                  /* @__PURE__ */ a.jsx("div", { className: "size-[1.14285rem] flex-shrink-0", children: (t == null ? void 0 : t.id) === D.id ? /* @__PURE__ */ a.jsx(yw, { className: "sortable-handle size-full cursor-pointer fill-mshop-gray-20" }) : /* @__PURE__ */ a.jsx("div", { className: "bg-transparent" }) }),
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "typo-mshop-kr-14-m line-clamp-1 flex-grow break-all text-start",
                        (t == null ? void 0 : t.id) === D.id ? "text-mshop-black" : "text-mshop-gray-50 hover:text-mshop-black"
                      ),
                      children: D.displayName
                    }
                  ),
                  nl.Hidden === D.state && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m flex-shrink-0 text-mshop-gray-50", children: "비공개" })
                ]
              },
              D.id
            ))
          }
        ) }),
        /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx(
          za,
          {
            widthFull: !0,
            variant: "sm",
            theme: "blue",
            iconFront: "add",
            type: "button",
            onClick: E,
            children: "멤버십 플랜 만들기"
          }
        ) })
      ]
    }
  );
}
const L0e = [
  {
    title: "멤버십 정보 입력",
    description: `멤버십 이름, 썸네일, 가격 등 기본 정보를 입력해 주세요. 
모든 정보를 입력 후, 하단 저장 버튼을 클릭하면 다음 단계 혜택 추가하기로 넘어갑니다.`,
    imgSrc: kt.Admin.MembershipGuideModalStep1
  },
  {
    title: "멤버십 전용 상품 혜택 추가",
    description: `멤버십 가입 회원에게 제공할 상품 관련 혜택을 설정해 주세요.
마플샵제작배송 상품 / 크리에이터배송 상품 / 디지털 상품 유형별로 1개씩 추가가 가능합니다.`,
    imgSrc: kt.Admin.MembershipGuideModalStep2
  },
  {
    title: "멤버십 상품 설정",
    description: "상품 등록 - 상품 상세 정보 페이지에서 멤버십 플랜명을 선택하면 해당 플랜에 멤버십 혜택으로 상품 설정이 완료되어요. 설정이 완료되면 자동으로 멤버십 혜택 아래 상품이 노출됩니다.",
    imgSrc: kt.Admin.MembershipGuideModalStep3
  },
  {
    title: "커뮤니티 연동",
    description: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      "샵 관리 - 샵 정보 페이지에서 사이어티 커뮤니티를 연동해 주세요. 사이어티를 연동하면 멤버십에 커뮤니티 혜택을 제공할 수 있습니다. 자세한 소개는",
      " ",
      /* @__PURE__ */ a.jsxs(
        "a",
        {
          className: "inline-flex cursor-pointer items-center gap-x-[0.14286rem] underline underline-offset-2",
          href: "https://ciety.xyz",
          target: "_blank",
          children: [
            "사이어티 홈페이지",
            /* @__PURE__ */ a.jsx(WE, { className: "size-[1.14286rem] shrink-0" })
          ]
        }
      ),
      "를 확인해 주세요."
    ] }),
    imgSrc: kt.Admin.MembershipGuideModalCommunityIntegration
  },
  {
    title: "커뮤니티 혜택 추가",
    description: "사이어티 커뮤니티 설정에서 제한 채널을 만들고 멤버십 그룹을 선택하면, 해당 채널이 멤버십 전용 커뮤니티 혜택으로 추가되어요. 혜택 채널은 마플샵 멤버십 플랜에서 바로 확인할 수 있어요!",
    imgSrc: kt.Admin.MembershipGuideModalCommunityRewardAdd
  },
  {
    title: "크리에이터 혜택 추가",
    description: `크리에이터가 직접 작성하는 맞춤형 혜택이에요. 자유롭게 추가할 수 있어요.
팬들이 좋아할 만한 혜택을 작성해 매력적인 멤버십으로 만들어 보세요!`,
    imgSrc: kt.Admin.MembershipGuideModalStep5
  },
  {
    title: "멤버십 혜택 설정 완료",
    description: `혜택 설정이 완료되면 멤버십 전용 상품 아래 상품 썸네일, 커뮤니티 혜택 아래 채널명이 노출됩니다.
크리에이터 커머스 마플샵에서 멤버십 혜택을 다양하게 제공해 보세요!`,
    imgSrc: kt.Admin.MembershipGuideModalRewardSetupComplete
  },
  {
    title: "멤버십 판매 시작",
    description: `크리에이터와 팬을 더 단단하게 이어줄, 마플샵 크리에이터 멤버십 기능
크리에이터님만의 소중한 팬덤을 모아보고 새로운 수익을 창출하세요!`,
    imgSrc: kt.Admin.MembershipGuideModalStep6
  }
], KW = (e) => tA.PRODUCT.rewardTypes.includes(e.type), XW = (e) => tA.COMMUNITY.rewardTypes.includes(e.type), I0e = (e) => tA.CREATOR.rewardTypes.includes(e.type), $9 = (e) => /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(e) ? e : jt(e, "yyyy-MM-dd HH':'mm"), QW = (e) => {
  let t;
  return e.type === $n.SubscriptionPass ? t = {
    type: e.type,
    period: 1,
    currency: e.currency,
    price: e.price,
    startTimeAt: null,
    endTimeAt: null
  } : t = {
    type: e.type,
    currency: e.currency,
    endTimeAt: $9(e.endTimeAt),
    startTimeAt: e.startTimeAt ? $9(e.startTimeAt) : null,
    price: e.price
  }, t;
}, Nz = (e) => {
  const { thumbnailImage: t, rewards: n, payment: r, limitCount: s, ...o } = VV(
    ["index", "deletionAt", "memberCount", "projectId"],
    e
  );
  return {
    ...o,
    limitCount: s === 0 ? null : s,
    thumbnailImageUrl: (t == null ? void 0 : t.url) || "",
    payment: {
      ...QW(r)
    },
    productReward: n.filter(KW).map(
      (c) => c.title ? c : {
        ...c,
        title: c6[c.type]
      }
    ),
    communityRewards: n.filter(XW),
    creatorReward: n.filter(I0e)
  };
}, jz = (e, t) => e.get(t);
function F0e(e) {
  Al([
    [ol, e.client],
    [
      ll,
      {
        isMobile: e.isMobile,
        isApp: e.isApp,
        toggleSpinner: e.toggleSpinner,
        onError: e.onError,
        onScrollLock: e.onScrollLock
      }
    ],
    [R1, e.projectId],
    [pu, e.fetchedSettingMemberships],
    [K8, e.selectedMembership]
  ]);
  const { settingMemberships: t } = ZE(), {
    settingMembership: n,
    setSettingMembership: r
  } = u5(), { client: s } = Ha(), {
    widgetCore: { onError: o, toggleSpinner: c }
  } = Gt(), [u, m] = Re(!1);
  wt(t);
  const [y, b] = Re(!1), w = bp({
    reValidateMode: "onChange",
    mode: "onChange",
    ...n && {
      defaultValues: Nz(n)
    }
  }), {
    formState: { isDirty: k },
    reset: j,
    trigger: E,
    setValue: T,
    watch: D
  } = w;
  an(() => {
    const I = async () => {
      if (!D("id"))
        return;
      c(!0);
      const R = await gW(
        { membershipId: D("id") },
        { client: s, onError: o }
      );
      switch (c(!1), R.code) {
        case le.Success: {
          const U = new Map(
            R.data.rewards.map((K) => [K.type, K])
          ), z = D("productReward").map(
            (K) => {
              const q = jz(U, K.type);
              return wt(q), { ...K, products: q.products };
            }
          );
          T("productReward", z);
          const H = D("communityRewards");
          if (H) {
            const K = H.map(
              (q) => {
                const Q = jz(U, q.type);
                return wt(Q), {
                  ...q,
                  ...Q.type === ss.Dm ? {
                    dm: Q.dm
                  } : {
                    channels: Q.channels
                  }
                };
              }
            );
            T("communityRewards", K);
          }
          return;
        }
        case le.TokenExpired:
        default:
          return o(Ht);
      }
    };
    return window.addEventListener("focus", I), () => {
      window.removeEventListener("focus", I);
    };
  }, []), an(() => {
    (async () => await E("payment.startTimeAt"))();
  }, []), N$((I) => {
    k && I.preventDefault();
  });
  const L = async (I) => {
    r(I), j(Nz(I)), await E("payment.startTimeAt");
  };
  return /* @__PURE__ */ a.jsx("div", { className: "twp", children: e.isMobile ? /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex flex-col bg-mshop-white px-[1.14286rem] pt-[6.85714rem] text-center text-mshop-black", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
      /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-24-b", children: [
        "멤버십 만들기 기능은",
        /* @__PURE__ */ a.jsx("br", {}),
        "PC에서 이용해 주세요."
      ] }),
      /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m", children: [
        "더 나은 경험을 위해 PC 마플샵 스튜디오로",
        /* @__PURE__ */ a.jsx("br", {}),
        "멤버십을 만들고 관리해 보세요."
      ] })
    ] }),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: "size-[20rem] bg-cover bg-center bg-no-repeat",
        style: {
          backgroundImage: `url(${kt.Admin.MembershipCreateMobile})`
        }
      }
    )
  ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(S9, { ...w, children: /* @__PURE__ */ a.jsxs("form", { className: "mb-[6.85714rem] w-full", children: [
      /* @__PURE__ */ a.jsxs(
        "header",
        {
          className: "flex w-full flex-col gap-y-[0.571rem]",
          id: "membership-create-header",
          children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-start gap-x-[0.571rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-28-b text-mshop-black", children: "멤버십 만들기" }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => m(!0),
                  className: "py-[0.28571rem]",
                  children: /* @__PURE__ */ a.jsx(tO, { className: "size-[1.42857rem] fill-mshop-black" })
                }
              )
            ] }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "마플샵에서 내 찐 팬을 위한 멤버십을 만들어 보세요!" })
          ]
        }
      ),
      /* @__PURE__ */ a.jsxs("main", { className: "mt-[2.86rem] flex h-full gap-x-[1.14286rem]", children: [
        /* @__PURE__ */ a.jsx(
          A0e,
          {
            onClickMembership: L,
            selectedItem: n,
            sortedList: t
          }
        ),
        /* @__PURE__ */ a.jsx(
          k0e,
          {
            setIsFileUploadLoading: b,
            onCreatorGuideTextClick: e.onCreatorGuideTextClick,
            onGoodsClick: e.onGoodsClick,
            onOrderMadeClick: e.onOrderMadeClick,
            onDigitalContentsClick: e.onDigitalContentsClick,
            onConnectWithCietyCommunityButtonClick: e.onConnectWithCietyCommunityButtonClick,
            onSetUpOrderMadeInStudioButtonClick: e.onSetUpOrderMadeInStudioButtonClick,
            onSetUpDigitalContentsInStudioButtonClick: e.onSetUpDigitalContentsInStudioButtonClick,
            onSetUpGoodsInStudioButtonClick: e.onSetUpGoodsInStudioButtonClick,
            onCheckMyMembershipButtonClick: e.onCheckMyMembershipButtonClick
          }
        ),
        /* @__PURE__ */ a.jsx(
          O0e,
          {
            isFileUploadLoading: y,
            onClickMembership: L,
            onCheckMyMembershipButtonClick: e.onCheckMyMembershipButtonClick,
            onCreatorGuideTextClick: e.onCreatorGuideTextClick,
            onTermsTextClick: e.onTermsTextClick
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ a.jsx(
      BO,
      {
        show: u,
        modalTitle: ["마플샵 멤버십", "판매하기"],
        onClose: () => m(!1),
        stepInfos: L0e
      }
    )
  ] }) });
}
function U0e({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  onScrollLock: s,
  onError: o,
  projectId: c,
  onCheckMyMembershipButtonClick: u,
  onSetUpGoodsInStudioButtonClick: m,
  onSetUpOrderMadeInStudioButtonClick: y,
  onSetUpDigitalContentsInStudioButtonClick: b,
  onGoodsClick: w,
  onOrderMadeClick: k,
  onDigitalContentsClick: j,
  onCreatorGuideTextClick: E,
  onTermsTextClick: T,
  onMarppleShopStudioTextClick: D,
  onConnectWithCietyCommunityButtonClick: L
}) {
  const [I, R] = Re(!0), [U, z] = Re(null), [H, K] = Re(null);
  an(() => {
    (async () => {
      const Q = await bde(
        { projectId: c },
        { client: e, onError: o }
      );
      switch (Q.code) {
        case le.Success:
          if (Q.data.items.length > 0) {
            const Z = Q.data.items;
            K(Z), z(Z[0]);
          } else
            await q();
          R(!1);
          return;
        case le.TokenExpired:
        default:
          return o(Ht);
      }
    })();
  }, []);
  const q = async () => {
    const Q = await KO(
      { projectId: c },
      { client: e, onError: o }
    );
    switch (Q.code) {
      case le.Success:
        K([Q.data]), z(Q.data);
        return;
      case le.Maximum:
        await en({
          body: (Z) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Z
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "예기치 못한 오류로 인해 진행할 수 없습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "동일한 문제가 반복적으로 발생할 경우",
                  /* @__PURE__ */ a.jsx("br", {}),
                  /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                  "로 문의해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.TokenExpired:
      default:
        return o(Ht);
    }
  };
  return I || !H || (H || []).length === 0 || !U ? null : /* @__PURE__ */ a.jsx(
    F0e,
    {
      client: e,
      isMobile: t,
      isApp: n,
      toggleSpinner: r,
      onScrollLock: s,
      onError: o,
      projectId: c,
      selectedMembership: U,
      fetchedSettingMemberships: H,
      onCheckMyMembershipButtonClick: u,
      onSetUpGoodsInStudioButtonClick: m,
      onSetUpOrderMadeInStudioButtonClick: y,
      onSetUpDigitalContentsInStudioButtonClick: b,
      onGoodsClick: w,
      onOrderMadeClick: k,
      onDigitalContentsClick: j,
      onCreatorGuideTextClick: E,
      onTermsTextClick: T,
      onMarppleShopStudioTextClick: D,
      onConnectWithCietyCommunityButtonClick: L
    }
  );
}
class Pje extends Ol {
  constructor({
    projectId: t,
    onCheckMyMembershipButtonClick: n,
    onSetUpGoodsInStudioButtonClick: r,
    onSetUpOrderMadeInStudioButtonClick: s,
    onSetUpDigitalContentsInStudioButtonClick: o,
    onGoodsClick: c,
    onOrderMadeClick: u,
    onDigitalContentsClick: m,
    onCreatorGuideTextClick: y,
    onTermsTextClick: b,
    onMarppleShopStudioTextClick: w,
    onConnectWithCietyCommunityButtonClick: k,
    ...j
  }) {
    super(j), this.render = (E) => go(E).render(
      /* @__PURE__ */ a.jsx(
        U0e,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onScrollLock: this.onScrollLock,
          onError: this.onError,
          projectId: this.projectId,
          onCheckMyMembershipButtonClick: this.onCheckMyMembershipButtonClick,
          onSetUpGoodsInStudioButtonClick: this.onSetUpGoodsInStudioButtonClick,
          onSetUpOrderMadeInStudioButtonClick: this.onSetUpOrderMadeInStudioButtonClick,
          onSetUpDigitalContentsInStudioButtonClick: this.onSetUpDigitalContentsInStudioButtonClick,
          onGoodsClick: this.onGoodsClick,
          onOrderMadeClick: this.onOrderMadeClick,
          onDigitalContentsClick: this.onDigitalContentsClick,
          onCreatorGuideTextClick: this.onCreatorGuideTextClick,
          onTermsTextClick: this.onTermsTextClick,
          onMarppleShopStudioTextClick: this.onMarppleShopStudioTextClick,
          onConnectWithCietyCommunityButtonClick: this.onConnectWithCietyCommunityButtonClick
        }
      )
    ), this.projectId = t, this.onCheckMyMembershipButtonClick = n, this.onSetUpGoodsInStudioButtonClick = r, this.onSetUpOrderMadeInStudioButtonClick = s, this.onSetUpDigitalContentsInStudioButtonClick = o, this.onGoodsClick = c, this.onOrderMadeClick = u, this.onDigitalContentsClick = m, this.onCreatorGuideTextClick = y, this.onTermsTextClick = b, this.onMarppleShopStudioTextClick = w, this.onConnectWithCietyCommunityButtonClick = k;
  }
}
const G9 = async (e, t) => jn(
  "/support-messages",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), iA = async (e, t) => jn(
  "/supports",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error("postSupports");
  }
});
async function Q8(e) {
  return jn("/me", { body: {} }, e).then(
    (t) => {
      switch (t.code) {
        case le.Success:
        case le.TokenExpired:
          return t;
        default:
          throw new Error();
      }
    }
  );
}
const M3 = Qt(null), z0e = Qt(null, (e, t, n) => {
  const r = e(M3);
  wt(r), t(M3, {
    ...r,
    mobile: n
  });
}), by = () => {
  const [e, t] = Ar(M3), n = Ka(z0e);
  return {
    me: e,
    setMe: t,
    setUpdateMobile: n
  };
}, B0e = Qt(null), oA = () => {
  const [e, t] = Ar(B0e);
  return {
    supportMessages: e,
    setSupportMessages: t,
    updateSupportMessage: (s) => {
      if (!e)
        throw new Error(Xr(ia.SupportMessages));
      t({
        ...e,
        items: e.items.map(
          (o) => o.id === s.id ? s : o
        )
      });
    },
    removeSupportMessage: (s) => {
      if (!e)
        throw new Error(Xr(ia.SupportMessages));
      t({
        ...e,
        items: e.items.filter((o) => o.id !== s),
        totalCount: e.totalCount - 1
      });
    }
  };
}, H0e = Qt(null), lA = () => {
  const [e, t] = Ar(H0e);
  return {
    supports: e,
    setSupports: t,
    getSupportById: (r) => {
      var s;
      return ((s = e == null ? void 0 : e.items) == null ? void 0 : s.find((o) => o.id === r)) ?? null;
    }
  };
};
function f5({ title: e, description: t, renderButton: n, renderImage: r }) {
  return /* @__PURE__ */ a.jsxs("section", { className: "twp flex-center flex-col gap-y-[1.71428rem]", children: [
    r && /* @__PURE__ */ a.jsx("div", { className: "size-[11.42857rem] overflow-hidden", children: r }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex-col gap-y-[.57143rem]", children: [
      e && /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-gray-80", children: e }),
      t && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-m whitespace-pre text-center text-mshop-gray-50", children: t })
    ] }),
    n && /* @__PURE__ */ a.jsx("div", { className: "w-[14rem]", children: n })
  ] });
}
const m5 = Qt(
  Vn
), O2 = Qt({
  defaultTabIndex: 0,
  tabIndex: 0,
  nextTabIndex: null
}), V0e = Qt(
  (e) => {
    const { tabIndex: t } = e(O2);
    return t;
  },
  (e, t, n) => {
    const r = e(O2);
    t(O2, {
      ...r,
      tabIndex: n
    });
  }
), $0e = Qt((e) => {
  const { defaultTabIndex: t } = e(O2);
  return t;
}), G0e = Qt(
  (e) => {
    const { nextTabIndex: t } = e(O2);
    return t;
  },
  (e, t, n) => {
    const r = e(O2);
    t(O2, {
      ...r,
      nextTabIndex: n
    });
  }
), ZW = () => {
  const [e, t] = Ar(V0e), [n, r] = Ar(G0e), s = Y3($0e);
  return {
    tabIndex: e,
    setTabIndex: t,
    defaultTabIndex: s,
    nextTabIndex: n,
    setNextTabIndex: r
  };
};
function Ez(e) {
  return /* @__PURE__ */ a.jsx(
    GE,
    {
      ...e,
      className: $(
        "typo-mshop-kr-14-m w-full border-b border-transparent px-[0.85714rem] py-[0.64286rem] text-mshop-gray-50 outline-0",
        "data-[selected]:typo-mshop-kr-14-b data-[selected]:border-mshop-black data-[selected]:text-mshop-black"
      )
    }
  );
}
function kz(e) {
  return /* @__PURE__ */ a.jsx(
    GE,
    {
      ...e,
      className: $(
        "typo-mshop-kr-16-m border-b border-transparent text-mshop-gray-50 outline-0",
        "data-[hover]:text-mshop-blue-100",
        // hover
        "data-[selected]:border-mshop-black data-[selected]:text-mshop-black",
        // selected
        "data-[hover]:data-[selected]:border-mshop-blue-100 data-[hover]:data-[selected]:text-mshop-blue-100"
        // hover + selected
      ),
      style: {
        outline: "none"
      }
    }
  );
}
function p6({
  description: e,
  title: t,
  renderButton: n,
  renderImage: r
}) {
  return /* @__PURE__ */ a.jsxs("section", { className: "flex-center flex-col gap-y-[1.71429rem]", children: [
    r && /* @__PURE__ */ a.jsx("div", { className: "isolate size-[8.57143rem] overflow-hidden", children: r }),
    (t || e) && /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex-col gap-y-[0.57143rem]", children: [
      t && /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-gray-80", children: t }),
      e && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-m whitespace-pre-wrap text-center text-mshop-gray-50", children: e })
    ] }),
    n && /* @__PURE__ */ a.jsx("div", { className: "w-[14rem]", children: n })
  ] });
}
function H2(e) {
  "@babel/helpers - typeof";
  return H2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, H2(e);
}
function W0e(e, t) {
  if (H2(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (H2(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Y0e(e) {
  var t = W0e(e, "string");
  return H2(t) == "symbol" ? t : t + "";
}
function b1(e, t, n) {
  return (t = Y0e(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function _z(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Nf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _z(Object(n), !0).forEach(function(r) {
      b1(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _z(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function BD(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function q0e(e) {
  if (Array.isArray(e)) return BD(e);
}
function K0e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function JW(e, t) {
  if (e) {
    if (typeof e == "string") return BD(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? BD(e, t) : void 0;
  }
}
function X0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rv(e) {
  return q0e(e) || K0e(e) || JW(e) || X0e();
}
function Q0e(e) {
  if (Array.isArray(e)) return e;
}
function Z0e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, s, o, c, u = [], m = !0, y = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        m = !1;
      } else for (; !(m = (r = o.call(n)).done) && (u.push(r.value), u.length !== t); m = !0) ;
    } catch (b) {
      y = !0, s = b;
    } finally {
      try {
        if (!m && n.return != null && (c = n.return(), Object(c) !== c)) return;
      } finally {
        if (y) throw s;
      }
    }
    return u;
  }
}
function J0e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zd(e, t) {
  return Q0e(e) || Z0e(e, t) || JW(e, t) || J0e();
}
function O8(e) {
  var t = re.useRef();
  t.current = e;
  var n = re.useCallback(function() {
    for (var r, s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function eye() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Tz = process.env.NODE_ENV !== "test" && eye() ? re.useLayoutEffect : re.useEffect, eY = function(t, n) {
  var r = re.useRef(!0);
  Tz(function() {
    return t(r.current);
  }, n), Tz(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, Mz = function(t, n) {
  eY(function(r) {
    if (!r)
      return t();
  }, n);
};
function Rz(e) {
  var t = re.useRef(!1), n = re.useState(e), r = zd(n, 2), s = r[0], o = r[1];
  re.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function c(u, m) {
    m && t.current || o(u);
  }
  return [s, c];
}
function mR(e) {
  return e !== void 0;
}
function tye(e, t) {
  var n = t || {}, r = n.defaultValue, s = n.value, o = n.onChange, c = n.postState, u = Rz(function() {
    return mR(s) ? s : mR(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), m = zd(u, 2), y = m[0], b = m[1], w = s !== void 0 ? s : y, k = c ? c(w) : w, j = O8(o), E = Rz([w]), T = zd(E, 2), D = T[0], L = T[1];
  Mz(function() {
    var R = D[0];
    y !== R && j(y, R);
  }, [D]), Mz(function() {
    mR(s) || b(s);
  }, [s]);
  var I = O8(function(R, U) {
    b(R, U), L([w], U);
  });
  return [k, I];
}
var HD = {}, cA = [], nye = function(t) {
  cA.push(t);
};
function tY(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = cA.reduce(function(r, s) {
      return s(r ?? "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function rye(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = cA.reduce(function(r, s) {
      return s(r ?? "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function aye() {
  HD = {};
}
function nY(e, t, n) {
  !t && !HD[n] && (e(!1, n), HD[n] = !0);
}
function F4(e, t) {
  nY(tY, e, t);
}
function sye(e, t) {
  nY(rye, e, t);
}
F4.preMessage = nye;
F4.resetWarned = aye;
F4.noteOnce = sye;
function iye(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function s(o, c) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, m = r.has(o);
    if (F4(!m, "Warning: There may be circular references"), m)
      return !1;
    if (o === c)
      return !0;
    if (n && u > 1)
      return !1;
    r.add(o);
    var y = u + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(c) || o.length !== c.length)
        return !1;
      for (var b = 0; b < o.length; b++)
        if (!s(o[b], c[b], y))
          return !1;
      return !0;
    }
    if (o && c && H2(o) === "object" && H2(c) === "object") {
      var w = Object.keys(o);
      return w.length !== Object.keys(c).length ? !1 : w.every(function(k) {
        return s(o[k], c[k], y);
      });
    }
    return !1;
  }
  return s(e, t);
}
function rY(e, t) {
  if (e == null) return {};
  var n, r, s = HG(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++) n = o[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (s[n] = e[n]);
  }
  return s;
}
function VD(e, t, n) {
  return (e - t) / (n - t);
}
function uA(e, t, n, r) {
  var s = VD(t, n, r), o = {};
  switch (e) {
    case "rtl":
      o.right = "".concat(s * 100, "%"), o.transform = "translateX(50%)";
      break;
    case "btt":
      o.bottom = "".concat(s * 100, "%"), o.transform = "translateY(50%)";
      break;
    case "ttb":
      o.top = "".concat(s * 100, "%"), o.transform = "translateY(-50%)";
      break;
    default:
      o.left = "".concat(s * 100, "%"), o.transform = "translateX(-50%)";
      break;
  }
  return o;
}
function E8(e, t) {
  return Array.isArray(e) ? e[t] : e;
}
var Hn = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= Hn.F1 && n <= Hn.F12)
      return !1;
    switch (n) {
      case Hn.ALT:
      case Hn.CAPS_LOCK:
      case Hn.CONTEXT_MENU:
      case Hn.CTRL:
      case Hn.DOWN:
      case Hn.END:
      case Hn.ESC:
      case Hn.HOME:
      case Hn.INSERT:
      case Hn.LEFT:
      case Hn.MAC_FF_META:
      case Hn.META:
      case Hn.NUMLOCK:
      case Hn.NUM_CENTER:
      case Hn.PAGE_DOWN:
      case Hn.PAGE_UP:
      case Hn.PAUSE:
      case Hn.PRINT_SCREEN:
      case Hn.RIGHT:
      case Hn.SHIFT:
      case Hn.UP:
      case Hn.WIN_KEY:
      case Hn.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= Hn.ZERO && t <= Hn.NINE || t >= Hn.NUM_ZERO && t <= Hn.NUM_MULTIPLY || t >= Hn.A && t <= Hn.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case Hn.SPACE:
      case Hn.QUESTION_MARK:
      case Hn.NUM_PLUS:
      case Hn.NUM_MINUS:
      case Hn.NUM_PERIOD:
      case Hn.NUM_DIVISION:
      case Hn.SEMICOLON:
      case Hn.DASH:
      case Hn.EQUALS:
      case Hn.COMMA:
      case Hn.PERIOD:
      case Hn.SLASH:
      case Hn.APOSTROPHE:
      case Hn.SINGLE_QUOTE:
      case Hn.OPEN_SQUARE_BRACKET:
      case Hn.BACKSLASH:
      case Hn.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, h5 = /* @__PURE__ */ re.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
}), oye = /* @__PURE__ */ re.createContext({}), lye = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"], $D = /* @__PURE__ */ re.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.value, s = e.valueIndex, o = e.onStartMove, c = e.onDelete, u = e.style, m = e.render, y = e.dragging, b = e.draggingDelete, w = e.onOffsetChange, k = e.onChangeComplete, j = e.onFocus, E = e.onMouseEnter, T = rY(e, lye), D = re.useContext(h5), L = D.min, I = D.max, R = D.direction, U = D.disabled, z = D.keyboard, H = D.range, K = D.tabIndex, q = D.ariaLabelForHandle, Q = D.ariaLabelledByForHandle, Z = D.ariaValueTextFormatterForHandle, X = D.styles, se = D.classNames, te = "".concat(n, "-handle"), fe = function(Ue) {
    U || o(Ue, s);
  }, ce = function(Ue) {
    j == null || j(Ue, s);
  }, pe = function(Ue) {
    E(Ue, s);
  }, Se = function(Ue) {
    if (!U && z) {
      var qe = null;
      switch (Ue.which || Ue.keyCode) {
        case Hn.LEFT:
          qe = R === "ltr" || R === "btt" ? -1 : 1;
          break;
        case Hn.RIGHT:
          qe = R === "ltr" || R === "btt" ? 1 : -1;
          break;
        case Hn.UP:
          qe = R !== "ttb" ? 1 : -1;
          break;
        case Hn.DOWN:
          qe = R !== "ttb" ? -1 : 1;
          break;
        case Hn.HOME:
          qe = "min";
          break;
        case Hn.END:
          qe = "max";
          break;
        case Hn.PAGE_UP:
          qe = 2;
          break;
        case Hn.PAGE_DOWN:
          qe = -2;
          break;
        case Hn.BACKSPACE:
        case Hn.DELETE:
          c(s);
          break;
      }
      qe !== null && (Ue.preventDefault(), w(qe, s));
    }
  }, oe = function(Ue) {
    switch (Ue.which || Ue.keyCode) {
      case Hn.LEFT:
      case Hn.RIGHT:
      case Hn.UP:
      case Hn.DOWN:
      case Hn.HOME:
      case Hn.END:
      case Hn.PAGE_UP:
      case Hn.PAGE_DOWN:
        k == null || k();
        break;
    }
  }, ue = uA(R, r, L, I), he = {};
  if (s !== null) {
    var ve;
    he = {
      tabIndex: U ? null : E8(K, s),
      role: "slider",
      "aria-valuemin": L,
      "aria-valuemax": I,
      "aria-valuenow": r,
      "aria-disabled": U,
      "aria-label": E8(q, s),
      "aria-labelledby": E8(Q, s),
      "aria-valuetext": (ve = E8(Z, s)) === null || ve === void 0 ? void 0 : ve(r),
      "aria-orientation": R === "ltr" || R === "rtl" ? "horizontal" : "vertical",
      onMouseDown: fe,
      onTouchStart: fe,
      onFocus: ce,
      onMouseEnter: pe,
      onKeyDown: Se,
      onKeyUp: oe
    };
  }
  var Te = /* @__PURE__ */ re.createElement("div", W8({
    ref: t,
    className: $(te, b1(b1(b1({}, "".concat(te, "-").concat(s + 1), s !== null && H), "".concat(te, "-dragging"), y), "".concat(te, "-dragging-delete"), b), se.handle),
    style: Nf(Nf(Nf({}, ue), u), X.handle)
  }, he, T));
  return m && (Te = m(Te, {
    index: s,
    prefixCls: n,
    value: r,
    dragging: y,
    draggingDelete: b
  })), Te;
});
process.env.NODE_ENV !== "production" && ($D.displayName = "Handle");
var cye = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"], aY = /* @__PURE__ */ re.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.style, s = e.onStartMove, o = e.onOffsetChange, c = e.values, u = e.handleRender, m = e.activeHandleRender, y = e.draggingIndex, b = e.draggingDelete, w = e.onFocus, k = rY(e, cye), j = re.useRef({}), E = re.useState(!1), T = zd(E, 2), D = T[0], L = T[1], I = re.useState(-1), R = zd(I, 2), U = R[0], z = R[1], H = function(X) {
    z(X), L(!0);
  }, K = function(X, se) {
    H(se), w == null || w(X);
  }, q = function(X, se) {
    H(se);
  };
  re.useImperativeHandle(t, function() {
    return {
      focus: function(X) {
        var se;
        (se = j.current[X]) === null || se === void 0 || se.focus();
      },
      hideHelp: function() {
        po.flushSync(function() {
          L(!1);
        });
      }
    };
  });
  var Q = Nf({
    prefixCls: n,
    onStartMove: s,
    onOffsetChange: o,
    render: u,
    onFocus: K,
    onMouseEnter: q
  }, k);
  return /* @__PURE__ */ re.createElement(re.Fragment, null, c.map(function(Z, X) {
    var se = y === X;
    return /* @__PURE__ */ re.createElement($D, W8({
      ref: function(fe) {
        fe ? j.current[X] = fe : delete j.current[X];
      },
      dragging: se,
      draggingDelete: se && b,
      style: E8(r, X),
      key: X,
      value: Z,
      valueIndex: X
    }, Q));
  }), m && D && /* @__PURE__ */ re.createElement($D, W8({
    key: "a11y"
  }, Q, {
    value: c[U],
    valueIndex: null,
    dragging: y !== -1,
    draggingDelete: b,
    render: m,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": !0
  })));
});
process.env.NODE_ENV !== "production" && (aY.displayName = "Handles");
var uye = function(t) {
  var n = t.prefixCls, r = t.style, s = t.children, o = t.value, c = t.onClick, u = re.useContext(h5), m = u.min, y = u.max, b = u.direction, w = u.includedStart, k = u.includedEnd, j = u.included, E = "".concat(n, "-text"), T = uA(b, o, m, y);
  return /* @__PURE__ */ re.createElement("span", {
    className: $(E, b1({}, "".concat(E, "-active"), j && w <= o && o <= k)),
    style: Nf(Nf({}, T), r),
    onMouseDown: function(L) {
      L.stopPropagation();
    },
    onClick: function() {
      c(o);
    }
  }, s);
}, dye = function(t) {
  var n = t.prefixCls, r = t.marks, s = t.onClick, o = "".concat(n, "-mark");
  return r.length ? /* @__PURE__ */ re.createElement("div", {
    className: o
  }, r.map(function(c) {
    var u = c.value, m = c.style, y = c.label;
    return /* @__PURE__ */ re.createElement(uye, {
      key: u,
      prefixCls: o,
      style: m,
      value: u,
      onClick: s
    }, y);
  })) : null;
}, fye = function(t) {
  var n = t.prefixCls, r = t.value, s = t.style, o = t.activeStyle, c = re.useContext(h5), u = c.min, m = c.max, y = c.direction, b = c.included, w = c.includedStart, k = c.includedEnd, j = "".concat(n, "-dot"), E = b && w <= r && r <= k, T = Nf(Nf({}, uA(y, r, u, m)), typeof s == "function" ? s(r) : s);
  return E && (T = Nf(Nf({}, T), typeof o == "function" ? o(r) : o)), /* @__PURE__ */ re.createElement("span", {
    className: $(j, b1({}, "".concat(j, "-active"), E)),
    style: T
  });
}, mye = function(t) {
  var n = t.prefixCls, r = t.marks, s = t.dots, o = t.style, c = t.activeStyle, u = re.useContext(h5), m = u.min, y = u.max, b = u.step, w = re.useMemo(function() {
    var k = /* @__PURE__ */ new Set();
    if (r.forEach(function(E) {
      k.add(E.value);
    }), s && b !== null)
      for (var j = m; j <= y; )
        k.add(j), j += b;
    return Array.from(k);
  }, [m, y, b, s, r]);
  return /* @__PURE__ */ re.createElement("div", {
    className: "".concat(n, "-step")
  }, w.map(function(k) {
    return /* @__PURE__ */ re.createElement(fye, {
      prefixCls: n,
      key: k,
      value: k,
      style: o,
      activeStyle: c
    });
  }));
}, Dz = function(t) {
  var n = t.prefixCls, r = t.style, s = t.start, o = t.end, c = t.index, u = t.onStartMove, m = t.replaceCls, y = re.useContext(h5), b = y.direction, w = y.min, k = y.max, j = y.disabled, E = y.range, T = y.classNames, D = "".concat(n, "-track"), L = VD(s, w, k), I = VD(o, w, k), R = function(K) {
    !j && u && u(K, -1);
  }, U = {};
  switch (b) {
    case "rtl":
      U.right = "".concat(L * 100, "%"), U.width = "".concat(I * 100 - L * 100, "%");
      break;
    case "btt":
      U.bottom = "".concat(L * 100, "%"), U.height = "".concat(I * 100 - L * 100, "%");
      break;
    case "ttb":
      U.top = "".concat(L * 100, "%"), U.height = "".concat(I * 100 - L * 100, "%");
      break;
    default:
      U.left = "".concat(L * 100, "%"), U.width = "".concat(I * 100 - L * 100, "%");
  }
  var z = m || $(D, b1(b1({}, "".concat(D, "-").concat(c + 1), c !== null && E), "".concat(n, "-track-draggable"), u), T.track);
  return /* @__PURE__ */ re.createElement("div", {
    className: z,
    style: Nf(Nf({}, U), r),
    onMouseDown: R,
    onTouchStart: R
  });
}, hye = function(t) {
  var n = t.prefixCls, r = t.style, s = t.values, o = t.startPoint, c = t.onStartMove, u = re.useContext(h5), m = u.included, y = u.range, b = u.min, w = u.styles, k = u.classNames, j = re.useMemo(function() {
    if (!y) {
      if (s.length === 0)
        return [];
      var T = o ?? b, D = s[0];
      return [{
        start: Math.min(T, D),
        end: Math.max(T, D)
      }];
    }
    for (var L = [], I = 0; I < s.length - 1; I += 1)
      L.push({
        start: s[I],
        end: s[I + 1]
      });
    return L;
  }, [s, y, o, b]);
  if (!m)
    return null;
  var E = k.tracks || w.tracks ? /* @__PURE__ */ re.createElement(Dz, {
    index: null,
    prefixCls: n,
    start: j[0].start,
    end: j[j.length - 1].end,
    replaceCls: $(k.tracks, "".concat(n, "-tracks")),
    style: w.tracks
  }) : null;
  return /* @__PURE__ */ re.createElement(re.Fragment, null, E, j.map(function(T, D) {
    var L = T.start, I = T.end;
    return /* @__PURE__ */ re.createElement(Dz, {
      index: D,
      prefixCls: n,
      style: Nf(Nf({}, E8(r, D)), w.track),
      start: L,
      end: I,
      key: D,
      onStartMove: c
    });
  }));
}, pye = 130;
function Pz(e) {
  var t = "targetTouches" in e ? e.targetTouches[0] : e;
  return {
    pageX: t.pageX,
    pageY: t.pageY
  };
}
function gye(e, t, n, r, s, o, c, u, m, y, b) {
  var w = re.useState(null), k = zd(w, 2), j = k[0], E = k[1], T = re.useState(-1), D = zd(T, 2), L = D[0], I = D[1], R = re.useState(!1), U = zd(R, 2), z = U[0], H = U[1], K = re.useState(n), q = zd(K, 2), Q = q[0], Z = q[1], X = re.useState(n), se = zd(X, 2), te = se[0], fe = se[1], ce = re.useRef(null), pe = re.useRef(null), Se = re.useRef(null), oe = re.useContext(oye), ue = oe.onDragStart, he = oe.onDragChange;
  eY(function() {
    L === -1 && Z(n);
  }, [n, L]), re.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", ce.current), document.removeEventListener("mouseup", pe.current), Se.current && (Se.current.removeEventListener("touchmove", ce.current), Se.current.removeEventListener("touchend", pe.current));
    };
  }, []);
  var ve = function(it, Ne, Xe) {
    Ne !== void 0 && E(Ne), Z(it);
    var xt = it;
    Xe && (xt = it.filter(function(rn, vt) {
      return vt !== L;
    })), c(xt), he && he({
      rawValues: it,
      deleteIndex: Xe ? L : -1,
      draggingIndex: L,
      draggingValue: Ne
    });
  }, Te = O8(function(qe, it, Ne) {
    if (qe === -1) {
      var Xe = te[0], xt = te[te.length - 1], rn = r - Xe, vt = s - xt, At = it * (s - r);
      At = Math.max(At, rn), At = Math.min(At, vt);
      var He = o(Xe + At);
      At = He - Xe;
      var Pt = te.map(function(ye) {
        return ye + At;
      });
      ve(Pt);
    } else {
      var Lt = (s - r) * it, er = Rv(Q);
      er[qe] = te[qe];
      var It = m(er, Lt, qe, "dist");
      ve(It.values, It.value, Ne);
    }
  }), Ie = function(it, Ne, Xe) {
    it.stopPropagation();
    var xt = Xe || n, rn = xt[Ne];
    I(Ne), E(rn), fe(xt), Z(xt), H(!1);
    var vt = Pz(it), At = vt.pageX, He = vt.pageY, Pt = !1;
    ue && ue({
      rawValues: xt,
      draggingIndex: Ne,
      draggingValue: rn
    });
    var Lt = function(ye) {
      ye.preventDefault();
      var ke = Pz(ye), Pe = ke.pageX, tt = ke.pageY, ot = Pe - At, ut = tt - He, Vt = e.current.getBoundingClientRect(), bn = Vt.width, mr = Vt.height, ur, _r;
      switch (t) {
        case "btt":
          ur = -ut / mr, _r = ot;
          break;
        case "ttb":
          ur = ut / mr, _r = ot;
          break;
        case "rtl":
          ur = -ot / bn, _r = ut;
          break;
        default:
          ur = ot / bn, _r = ut;
      }
      Pt = y ? Math.abs(_r) > pye && b < Q.length : !1, H(Pt), Te(Ne, ur, Pt);
    }, er = function It(ye) {
      ye.preventDefault(), document.removeEventListener("mouseup", It), document.removeEventListener("mousemove", Lt), Se.current && (Se.current.removeEventListener("touchmove", ce.current), Se.current.removeEventListener("touchend", pe.current)), ce.current = null, pe.current = null, Se.current = null, u(Pt), I(-1), H(!1);
    };
    document.addEventListener("mouseup", er), document.addEventListener("mousemove", Lt), it.currentTarget.addEventListener("touchend", er), it.currentTarget.addEventListener("touchmove", Lt), ce.current = Lt, pe.current = er, Se.current = it.currentTarget;
  }, Ue = re.useMemo(function() {
    var qe = Rv(n).sort(function(rn, vt) {
      return rn - vt;
    }), it = Rv(Q).sort(function(rn, vt) {
      return rn - vt;
    }), Ne = {};
    it.forEach(function(rn) {
      Ne[rn] = (Ne[rn] || 0) + 1;
    }), qe.forEach(function(rn) {
      Ne[rn] = (Ne[rn] || 0) - 1;
    });
    var Xe = y ? 1 : 0, xt = Object.values(Ne).reduce(function(rn, vt) {
      return rn + Math.abs(vt);
    }, 0);
    return xt <= Xe ? Q : n;
  }, [n, Q, y]);
  return [L, j, z, Ue, Ie];
}
function yye(e, t, n, r, s, o) {
  var c = re.useCallback(function(j) {
    return Math.max(e, Math.min(t, j));
  }, [e, t]), u = re.useCallback(function(j) {
    if (n !== null) {
      var E = e + Math.round((c(j) - e) / n) * n, T = function(R) {
        return (String(R).split(".")[1] || "").length;
      }, D = Math.max(T(n), T(t), T(e)), L = Number(E.toFixed(D));
      return e <= L && L <= t ? L : null;
    }
    return null;
  }, [n, e, t, c]), m = re.useCallback(function(j) {
    var E = c(j), T = r.map(function(I) {
      return I.value;
    });
    n !== null && T.push(u(j)), T.push(e, t);
    var D = T[0], L = t - e;
    return T.forEach(function(I) {
      var R = Math.abs(E - I);
      R <= L && (D = I, L = R);
    }), D;
  }, [e, t, r, n, c, u]), y = function j(E, T, D) {
    var L = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof T == "number") {
      var I, R = E[D], U = R + T, z = [];
      r.forEach(function(Z) {
        z.push(Z.value);
      }), z.push(e, t), z.push(u(R));
      var H = T > 0 ? 1 : -1;
      L === "unit" ? z.push(u(R + H * n)) : z.push(u(U)), z = z.filter(function(Z) {
        return Z !== null;
      }).filter(function(Z) {
        return T < 0 ? Z <= R : Z >= R;
      }), L === "unit" && (z = z.filter(function(Z) {
        return Z !== R;
      }));
      var K = L === "unit" ? R : U;
      I = z[0];
      var q = Math.abs(I - K);
      if (z.forEach(function(Z) {
        var X = Math.abs(Z - K);
        X < q && (I = Z, q = X);
      }), I === void 0)
        return T < 0 ? e : t;
      if (L === "dist")
        return I;
      if (Math.abs(T) > 1) {
        var Q = Rv(E);
        return Q[D] = I, j(Q, T - H, D, L);
      }
      return I;
    } else {
      if (T === "min")
        return e;
      if (T === "max")
        return t;
    }
  }, b = function(E, T, D) {
    var L = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", I = E[D], R = y(E, T, D, L);
    return {
      value: R,
      changed: R !== I
    };
  }, w = function(E) {
    return o === null && E === 0 || typeof o == "number" && E < o;
  }, k = function(E, T, D) {
    var L = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", I = E.map(m), R = I[D], U = y(I, T, D, L);
    if (I[D] = U, s === !1) {
      var z = o || 0;
      D > 0 && I[D - 1] !== R && (I[D] = Math.max(I[D], I[D - 1] + z)), D < I.length - 1 && I[D + 1] !== R && (I[D] = Math.min(I[D], I[D + 1] - z));
    } else if (typeof o == "number" || o === null) {
      for (var H = D + 1; H < I.length; H += 1)
        for (var K = !0; w(I[H] - I[H - 1]) && K; ) {
          var q = b(I, 1, H);
          I[H] = q.value, K = q.changed;
        }
      for (var Q = D; Q > 0; Q -= 1)
        for (var Z = !0; w(I[Q] - I[Q - 1]) && Z; ) {
          var X = b(I, -1, Q - 1);
          I[Q - 1] = X.value, Z = X.changed;
        }
      for (var se = I.length - 1; se > 0; se -= 1)
        for (var te = !0; w(I[se] - I[se - 1]) && te; ) {
          var fe = b(I, -1, se - 1);
          I[se - 1] = fe.value, te = fe.changed;
        }
      for (var ce = 0; ce < I.length - 1; ce += 1)
        for (var pe = !0; w(I[ce + 1] - I[ce]) && pe; ) {
          var Se = b(I, 1, ce + 1);
          I[ce + 1] = Se.value, pe = Se.changed;
        }
    }
    return {
      value: I[D],
      values: I
    };
  };
  return [m, k];
}
function vye(e) {
  return dn(function() {
    if (e === !0 || !e)
      return [!!e, !1, !1, 0];
    var t = e.editable, n = e.draggableTrack, r = e.minCount, s = e.maxCount;
    return process.env.NODE_ENV !== "production" && tY(!t || !n, "`editable` can not work with `draggableTrack`."), [!0, t, !t && n, r || 0, s];
  }, [e]);
}
var sY = /* @__PURE__ */ re.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-slider" : n, s = e.className, o = e.style, c = e.classNames, u = e.styles, m = e.id, y = e.disabled, b = y === void 0 ? !1 : y, w = e.keyboard, k = w === void 0 ? !0 : w, j = e.autoFocus, E = e.onFocus, T = e.onBlur, D = e.min, L = D === void 0 ? 0 : D, I = e.max, R = I === void 0 ? 100 : I, U = e.step, z = U === void 0 ? 1 : U, H = e.value, K = e.defaultValue, q = e.range, Q = e.count, Z = e.onChange, X = e.onBeforeChange, se = e.onAfterChange, te = e.onChangeComplete, fe = e.allowCross, ce = fe === void 0 ? !0 : fe, pe = e.pushable, Se = pe === void 0 ? !1 : pe, oe = e.reverse, ue = e.vertical, he = e.included, ve = he === void 0 ? !0 : he, Te = e.startPoint, Ie = e.trackStyle, Ue = e.handleStyle, qe = e.railStyle, it = e.dotStyle, Ne = e.activeDotStyle, Xe = e.marks, xt = e.dots, rn = e.handleRender, vt = e.activeHandleRender, At = e.track, He = e.tabIndex, Pt = He === void 0 ? 0 : He, Lt = e.ariaLabelForHandle, er = e.ariaLabelledByForHandle, It = e.ariaValueTextFormatterForHandle, ye = re.useRef(null), ke = re.useRef(null), Pe = re.useMemo(function() {
    return ue ? oe ? "ttb" : "btt" : oe ? "rtl" : "ltr";
  }, [oe, ue]), tt = vye(q), ot = zd(tt, 5), ut = ot[0], Vt = ot[1], bn = ot[2], mr = ot[3], ur = ot[4], _r = re.useMemo(function() {
    return isFinite(L) ? L : 0;
  }, [L]), ai = re.useMemo(function() {
    return isFinite(R) ? R : 100;
  }, [R]), ls = re.useMemo(function() {
    return z !== null && z <= 0 ? 1 : z;
  }, [z]), Ot = re.useMemo(function() {
    return typeof Se == "boolean" ? Se ? ls : !1 : Se >= 0 ? Se : !1;
  }, [Se, ls]), En = re.useMemo(function() {
    return Object.keys(Xe || {}).map(function(Tr) {
      var Fn = Xe[Tr], Gn = {
        value: Number(Tr)
      };
      return Fn && H2(Fn) === "object" && !/* @__PURE__ */ re.isValidElement(Fn) && ("label" in Fn || "style" in Fn) ? (Gn.style = Fn.style, Gn.label = Fn.label) : Gn.label = Fn, Gn;
    }).filter(function(Tr) {
      var Fn = Tr.label;
      return Fn || typeof Fn == "number";
    }).sort(function(Tr, Fn) {
      return Tr.value - Fn.value;
    });
  }, [Xe]), Xt = yye(_r, ai, ls, En, ce, Ot), qt = zd(Xt, 2), In = qt[0], st = qt[1], lt = tye(K, {
    value: H
  }), Nt = zd(lt, 2), Wt = Nt[0], wn = Nt[1], pt = re.useMemo(function() {
    var Tr = Wt == null ? [] : Array.isArray(Wt) ? Wt : [Wt], Fn = zd(Tr, 1), Gn = Fn[0], zr = Gn === void 0 ? _r : Gn, ta = Wt === null ? [] : [zr];
    if (ut) {
      if (ta = Rv(Tr), Q || Wt === void 0) {
        var ir = Q >= 0 ? Q + 1 : 2;
        for (ta = ta.slice(0, ir); ta.length < ir; ) {
          var Hs;
          ta.push((Hs = ta[ta.length - 1]) !== null && Hs !== void 0 ? Hs : _r);
        }
      }
      ta.sort(function(Pc, Fl) {
        return Pc - Fl;
      });
    }
    return ta.forEach(function(Pc, Fl) {
      ta[Fl] = In(Pc);
    }), ta;
  }, [Wt, ut, _r, Q, In]), hr = function(Fn) {
    return ut ? Fn : Fn[0];
  }, _o = O8(function(Tr) {
    var Fn = Rv(Tr).sort(function(Gn, zr) {
      return Gn - zr;
    });
    Z && !iye(Fn, pt, !0) && Z(hr(Fn)), wn(Fn);
  }), Il = O8(function(Tr) {
    Tr && ye.current.hideHelp();
    var Fn = hr(pt);
    se == null || se(Fn), F4(!se, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), te == null || te(Fn);
  }), Cr = function(Fn) {
    if (!(b || !Vt || pt.length <= mr)) {
      var Gn = Rv(pt);
      Gn.splice(Fn, 1), X == null || X(hr(Gn)), _o(Gn);
      var zr = Math.max(0, Fn - 1);
      ye.current.hideHelp(), ye.current.focus(zr);
    }
  }, Wi = gye(ke, Pe, pt, _r, ai, In, _o, Il, st, Vt, mr), Yi = zd(Wi, 5), To = Yi[0], qi = Yi[1], Mo = Yi[2], ul = Yi[3], dl = Yi[4], Dc = function(Fn, Gn) {
    if (!b) {
      var zr = Rv(pt), ta = 0, ir = 0, Hs = ai - _r;
      pt.forEach(function(xr, Mr) {
        var xu = Math.abs(Fn - xr);
        xu <= Hs && (Hs = xu, ta = Mr), xr < Fn && (ir = Mr);
      });
      var Pc = ta;
      Vt && Hs !== 0 && (!ur || pt.length < ur) ? (zr.splice(ir + 1, 0, Fn), Pc = ir + 1) : zr[ta] = Fn, ut && !pt.length && Q === void 0 && zr.push(Fn);
      var Fl = hr(zr);
      if (X == null || X(Fl), _o(zr), Gn) {
        var Ki, Ms;
        (Ki = document.activeElement) === null || Ki === void 0 || (Ms = Ki.blur) === null || Ms === void 0 || Ms.call(Ki), ye.current.focus(Pc), dl(Gn, Pc, zr);
      } else
        se == null || se(Fl), F4(!se, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), te == null || te(Fl);
    }
  }, Ro = function(Fn) {
    Fn.preventDefault();
    var Gn = ke.current.getBoundingClientRect(), zr = Gn.width, ta = Gn.height, ir = Gn.left, Hs = Gn.top, Pc = Gn.bottom, Fl = Gn.right, Ki = Fn.clientX, Ms = Fn.clientY, xr;
    switch (Pe) {
      case "btt":
        xr = (Pc - Ms) / ta;
        break;
      case "ttb":
        xr = (Ms - Hs) / ta;
        break;
      case "rtl":
        xr = (Fl - Ki) / zr;
        break;
      default:
        xr = (Ki - ir) / zr;
    }
    var Mr = _r + xr * (ai - _r);
    Dc(In(Mr), Fn);
  }, Do = re.useState(null), _s = zd(Do, 2), fl = _s[0], _e = _s[1], _t = function(Fn, Gn) {
    if (!b) {
      var zr = st(pt, Fn, Gn);
      X == null || X(hr(pt)), _o(zr.values), _e(zr.value);
    }
  };
  re.useEffect(function() {
    if (fl !== null) {
      var Tr = pt.indexOf(fl);
      Tr >= 0 && ye.current.focus(Tr);
    }
    _e(null);
  }, [fl]);
  var Kt = re.useMemo(function() {
    return bn && ls === null ? (process.env.NODE_ENV !== "production" && F4(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : bn;
  }, [bn, ls]), On = O8(function(Tr, Fn) {
    dl(Tr, Fn), X == null || X(hr(pt));
  }), vr = To !== -1;
  re.useEffect(function() {
    if (!vr) {
      var Tr = pt.lastIndexOf(qi);
      ye.current.focus(Tr);
    }
  }, [vr]);
  var Lr = re.useMemo(function() {
    return Rv(ul).sort(function(Tr, Fn) {
      return Tr - Fn;
    });
  }, [ul]), Xn = re.useMemo(function() {
    return ut ? [Lr[0], Lr[Lr.length - 1]] : [_r, Lr[0]];
  }, [Lr, ut, _r]), wr = zd(Xn, 2), Ts = wr[0], pa = wr[1];
  re.useImperativeHandle(t, function() {
    return {
      focus: function() {
        ye.current.focus(0);
      },
      blur: function() {
        var Fn, Gn = document, zr = Gn.activeElement;
        (Fn = ke.current) !== null && Fn !== void 0 && Fn.contains(zr) && (zr == null || zr.blur());
      }
    };
  }), re.useEffect(function() {
    j && ye.current.focus(0);
  }, []);
  var ga = re.useMemo(function() {
    return {
      min: _r,
      max: ai,
      direction: Pe,
      disabled: b,
      keyboard: k,
      step: ls,
      included: ve,
      includedStart: Ts,
      includedEnd: pa,
      range: ut,
      tabIndex: Pt,
      ariaLabelForHandle: Lt,
      ariaLabelledByForHandle: er,
      ariaValueTextFormatterForHandle: It,
      styles: u || {},
      classNames: c || {}
    };
  }, [_r, ai, Pe, b, k, ls, ve, Ts, pa, ut, Pt, Lt, er, It, u, c]);
  return /* @__PURE__ */ re.createElement(h5.Provider, {
    value: ga
  }, /* @__PURE__ */ re.createElement("div", {
    ref: ke,
    className: $(r, s, b1(b1(b1(b1({}, "".concat(r, "-disabled"), b), "".concat(r, "-vertical"), ue), "".concat(r, "-horizontal"), !ue), "".concat(r, "-with-marks"), En.length)),
    style: o,
    onMouseDown: Ro,
    id: m
  }, /* @__PURE__ */ re.createElement("div", {
    className: $("".concat(r, "-rail"), c == null ? void 0 : c.rail),
    style: Nf(Nf({}, qe), u == null ? void 0 : u.rail)
  }), At !== !1 && /* @__PURE__ */ re.createElement(hye, {
    prefixCls: r,
    style: Ie,
    values: pt,
    startPoint: Te,
    onStartMove: Kt ? On : void 0
  }), /* @__PURE__ */ re.createElement(mye, {
    prefixCls: r,
    marks: En,
    dots: xt,
    style: it,
    activeStyle: Ne
  }), /* @__PURE__ */ re.createElement(aY, {
    ref: ye,
    prefixCls: r,
    style: Ue,
    values: ul,
    draggingIndex: To,
    draggingDelete: Mo,
    onStartMove: On,
    onOffsetChange: _t,
    onFocus: E,
    onBlur: T,
    handleRender: rn,
    activeHandleRender: vt,
    onChangeComplete: Il,
    onDelete: Vt ? Cr : void 0
  }), /* @__PURE__ */ re.createElement(dye, {
    prefixCls: r,
    marks: En,
    onClick: Dc
  })));
});
process.env.NODE_ENV !== "production" && (sY.displayName = "Slider");
const xye = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { width: 62, height: 62, viewBox: "0 0 62 62", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("rect", { x: 1, y: 1, width: 60, height: 60, rx: 8, fill: "white" }), /* @__PURE__ */ re.createElement("rect", { x: 1, y: 1, width: 60, height: 60, rx: 8, stroke: "#D9D9D9", strokeLinecap: "round", strokeLinejoin: "round", strokeDasharray: "3 4" }), /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_3579_183315)" }, /* @__PURE__ */ re.createElement("path", { d: "M37.0826 30.4159H31.5826V24.9226C31.5826 24.6026 31.3226 24.3359 30.9959 24.3359C30.6693 24.3359 30.4093 24.5959 30.4093 24.9226V30.4226H24.9226C24.6026 30.4226 24.3359 30.6826 24.3359 31.0093C24.3359 31.3359 24.5959 31.5959 24.9226 31.5959H30.4226V37.0959C30.4226 37.4159 30.6826 37.6826 31.0093 37.6826C31.3359 37.6826 31.5959 37.4226 31.5959 37.0959V31.5959H37.0959C37.4159 31.5959 37.6826 31.3359 37.6826 31.0093C37.6826 30.6826 37.4226 30.4226 37.0959 30.4226L37.0826 30.4159Z", fill: "#D9D9D9" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_3579_183315" }, /* @__PURE__ */ re.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(23 23)" })))), dA = yn(xye);
function dh({
  show: e,
  onClose: t,
  variant: n,
  transition: r,
  children: s,
  ...o
}) {
  const {
    widgetCore: { isMobile: c }
  } = Gt(), u = r ?? c, { panelRef: m, container: y, handleMouseDown: b } = zO({
    show: e,
    onClose: t
  });
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: po.createPortal(
    /* @__PURE__ */ a.jsx(vO, { ...o, show: e, transition: u, children: /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: "twp relative",
        style: {
          zIndex: Tc.GLOBAL.MODAL
        },
        children: [
          !c && e && /* @__PURE__ */ a.jsx("div", { className: $("fixed inset-0 bg-mshop-dim-60") }),
          /* @__PURE__ */ a.jsx(AE, { transition: u, children: /* @__PURE__ */ a.jsx(
            "div",
            {
              className: "flex-center fixed inset-0 transition duration-500 ease-out data-[closed]:translate-y-full",
              onMouseDown: b,
              children: /* @__PURE__ */ a.jsx(
                "div",
                {
                  ref: m,
                  className: $(
                    "bg-mshop-white",
                    { "w-[32rem]": n === "TYPE01" && !c },
                    { "w-[43.42857rem]": n === "TYPE02" && !c },
                    {
                      "min-w-[32.85714rem] max-w-[65.71428rem]": n === "TYPE03" && !c
                    },
                    c ? "flex h-full w-full flex-col" : "m-[1.14285rem] max-h-[60rem] overflow-hidden rounded-[1.14285rem]"
                  ),
                  children: s
                }
              )
            }
          ) })
        ]
      }
    ) }),
    y
  ) });
}
const g6 = async (e) => jn("/pay-method", {}, e).then(
  (t) => {
    switch (t.code) {
      case le.Success:
      case le.TokenExpired:
        return t;
      default:
        throw new Error("postPayment");
    }
  }
), bye = async (e, t) => jn(
  "/create-support-payment",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.NotRegisteredPayment:
    case le.FailedPayment:
    case le.InvalidPaymentTarget:
      return n;
    default:
      throw new Error("postCreateSupportPayment");
  }
}), V2 = {
  Krw: "KRW"
}, fA = {
  InsufficientBalance: "INSUFFICIENT_BALANCE",
  Unknown: "UNKNOWN"
}, Wg = {
  InvalidFormat: "INVALID_FORMAT",
  FileTooLarge: "FILE_TOO_LARGE",
  LowResolution: "LOW_RESOLUTION",
  Success: "SUCCESS"
}, m1 = {
  P100: 100,
  // 개발 모드에서만 사용
  P1000: 1e3,
  P2000: 2e3,
  P3000: 3e3,
  P5000: 5e3,
  P10000: 1e4,
  P20000: 2e4,
  P30000: 3e4,
  P50000: 5e4,
  P100000: 1e5,
  P300000: 3e5,
  P500000: 5e5
}, mA = {
  "image/png": "png",
  "image/jpeg": "jpg",
  "image/svg+xml": "svg",
  "image/gif": "gif",
  "image/webp": "webp",
  "video/mp4": "mp4",
  "application/pdf": "pdf",
  "application/zip": "zip",
  "application/zip-compressed": "zip",
  "application/x-zip-compressed": "zip"
}, hA = ({
  maxUploadCount: e,
  initialUploadedImages: t = []
}) => {
  const [n, r] = Re(!1), [s, o] = Re(
    t
  ), { client: c } = Ha(), {
    widgetCore: { toggleSpinner: u, onError: m }
  } = Gt(), y = Rt(null);
  return {
    ref: y,
    isUploading: n,
    uploadedImages: s,
    handleClickUploadImage: () => {
      var T;
      (T = y.current) == null || T.click();
    },
    handleChangeFileInput: async ({
      files: T,
      isPrivate: D,
      onSuccess: L
    }) => {
      if (T.length == 0)
        return;
      r(!0), u(!0);
      const I = s, R = e - s.length;
      try {
        const U = await Qu(
          gD(T),
          F2(R),
          Vd((H) => sO(H, {
            quality: 0.8,
            maxWidth: 120,
            maxHeight: 120
          })),
          Vd((H) => H),
          gp(T.length),
          py
        ), z = [...s, ...U];
        o(z), L && L(z), await Qu(
          gD(T),
          F2(R),
          Vd(async (H) => {
            const { code: K, data: q } = await cw(
              {
                ext: mA[H.type],
                name: H.name,
                isPrivate: D
              },
              {
                client: c,
                onError: m
              }
            );
            if (K !== le.Success)
              throw new Error(Ht);
            return { data: q, file: H };
          }),
          Vd(async ({ data: H, file: K }) => {
            if ((await fetch(H.uploadUrl, {
              method: "PUT",
              referrerPolicy: "no-referrer-when-downgrade",
              headers: {
                "Content-Type": K.type
              },
              cache: "no-store",
              body: K
            })).status !== 200)
              throw new Error();
            return H.url;
          }),
          gp(T.length),
          py,
          (H) => {
            const K = [
              ...I,
              ...H
            ];
            o(K), L && L(K);
          }
        ), y.current && (y.current.value = "");
      } catch (U) {
        m(U === Ht ? U : a$);
      } finally {
        r(!1), u(!1);
      }
    },
    handleRemoveUploadedImage: (T, D) => (L) => {
      L.preventDefault();
      const I = s.filter(
        (R, U) => T !== U
      );
      o(I), D && D(I);
    },
    handleResetUploadedImage: (T) => {
      o(T ? [...T] : []);
    },
    handleValidateImageFiles: async (T, D) => {
      const { imageFormats: L, minImageResolution: I, maxFileSize: R } = D;
      for (const U of T) {
        if (L && !L.includes(U.type.split("/")[1]))
          return Wg.InvalidFormat;
        if (R && U.size > R)
          return Wg.FileTooLarge;
        if (I && !await aO(
          U,
          I,
          I
        ))
          return Wg.LowResolution;
      }
      return Wg.Success;
    }
  };
}, xw = () => {
  const [e, t] = Ar(m5);
  if (e === Vn)
    throw new Error(Xr(ia.PayMethod));
  return {
    payMethod: e,
    setPayMethod: t
  };
}, Sye = async (e, t) => jn(
  "/check-payment-statement",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error("postCheckPaymentStatement");
  }
}), GD = {
  // 결제 대행사에서 결제가 이뤄지지 않음
  Padding: "PADDING",
  // 결제 취소가 이뤄짐
  Cancel: "CANCEL",
  // 결제 완료
  Paid: "PAID"
}, pA = ({
  merchantUid: e,
  onPaid: t,
  onFailed: n,
  onCanceled: r,
  onError: s,
  client: o
}) => {
  const u = Date.now();
  let m = 1e3;
  (async function y() {
    if (Date.now() - u >= 12e4)
      return n();
    const w = await Sye(
      {
        merchantUid: e
      },
      {
        client: o,
        onError: s
      }
    );
    if (w.code === le.TokenExpired)
      return s(Ht);
    if (w.data.status === GD.Paid)
      return t();
    if (w.data.status === GD.Cancel)
      return r == null ? void 0 : r();
    m = Math.min(m * 2, 8e3), setTimeout(y, m);
  })();
}, Ef = (e) => e == null ? "비활성화된 샵" : e.name;
function ea({ children: e, button: t }) {
  return /* @__PURE__ */ a.jsxs("div", { className: "flex-col-center w-[24.5rem] min-w-[20.57143rem] gap-y-[2.28571rem] rounded-[1.14286rem] bg-mshop-white px-[1.71428rem] pb-[1.71428rem] pt-[2.57142rem]", children: [
    /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m text-center text-mshop-gray-80", children: e }),
    /* @__PURE__ */ a.jsx(
      "button",
      {
        ...t.props,
        type: "button",
        className: "typo-mshop-kr-16-b h-[3.71428rem] w-full min-w-[11.42857rem] rounded-[0.57143rem] bg-mshop-blue-100 px-[1.14286rem] text-mshop-white",
        children: "확인"
      }
    )
  ] });
}
const wye = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { id: "Editor-Icon" }, /* @__PURE__ */ re.createElement("path", { id: "Vector", d: "M21.12 4.81H16.62V4.38C16.62 3.07 15.55 2 14.24 2H9.74C8.43 2 7.36 3.07 7.36 4.38V4.81H2.88C2.4 4.81 2 5.2 2 5.69C2 6.18 2.39 6.57 2.88 6.57H4.49L5.95 20.67C6.03 21.43 6.65 22.01 7.4 22.01H16.61C17.35 22.01 17.98 21.43 18.06 20.67L19.52 6.57H21.13C21.61 6.57 22.01 6.18 22.01 5.69C22.01 5.2 21.62 4.81 21.13 4.81H21.12ZM9.13 4.38C9.13 4.04 9.41 3.76 9.75 3.76H14.25C14.59 3.76 14.87 4.04 14.87 4.38V4.81H9.12V4.38H9.13ZM10.04 14.12C10.04 14.6 9.65 15 9.16 15C8.67 15 8.28 14.61 8.28 14.12V9.87C8.28 9.39 8.67 8.99 9.16 8.99C9.65 8.99 10.04 9.38 10.04 9.87V14.12ZM15.71 14.12C15.71 14.6 15.32 15 14.83 15C14.34 15 13.95 14.61 13.95 14.12V9.87C13.95 9.39 14.34 8.99 14.83 8.99C15.32 8.99 15.71 9.38 15.71 9.87V14.12Z" }))), gA = yn(wye), Cye = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_10144_88846)" }, /* @__PURE__ */ re.createElement("path", { d: "M17.5998 9.26663H10.7248V2.39996C10.7248 1.99996 10.3998 1.66663 9.9915 1.66663C9.58317 1.66663 9.25817 1.99163 9.25817 2.39996V9.27496H2.39984C1.99984 9.27496 1.6665 9.59996 1.6665 10.0083C1.6665 10.4166 1.9915 10.7416 2.39984 10.7416H9.27484V17.6166C9.27484 18.0166 9.59984 18.35 10.0082 18.35C10.4165 18.35 10.7415 18.025 10.7415 17.6166V10.7416H17.6165C18.0165 10.7416 18.3498 10.4166 18.3498 10.0083C18.3498 9.59996 18.0248 9.27496 17.6165 9.27496L17.5998 9.26663Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_10144_88846" }, /* @__PURE__ */ re.createElement("rect", { width: 20, height: 20 })))), iY = yn(Cye), Nye = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.25 3.00098H3.75C2.22833 3.00098 1 4.34098 1 6.00098V7.00098H23V6.00098C23 4.34098 21.7717 3.00098 20.25 3.00098ZM23 10.001H1V18.001C1 19.661 2.22833 21.001 3.75 21.001H20.25C21.7717 21.001 23 19.661 23 18.001V10.001ZM3 13.001H15V14.501H3V13.001ZM11 16.001H3V17.501H11V16.001ZM19.5 19.001C20.3284 19.001 21 18.3294 21 17.501C21 16.6725 20.3284 16.001 19.5 16.001C18.6716 16.001 18 16.6725 18 17.501C18 18.3294 18.6716 19.001 19.5 19.001Z" })), W9 = yn(Nye), Oz = (e) => e.slice(12, 15) + "●";
function WD(e) {
  if (e.variant === "add")
    return /* @__PURE__ */ a.jsxs(
      "button",
      {
        onClick: e.onAddClick,
        className: "flex h-[5.71429rem] w-full flex-col items-center justify-center gap-[0.57143rem] rounded-[0.57142rem] border border-dashed border-mshop-gray-20 text-mshop-gray-50",
        type: "button",
        children: [
          /* @__PURE__ */ a.jsx(iY, { className: "size-[1.42857rem]" }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "결제 수단 등록하기" })
        ]
      }
    );
  if (e.variant === "creditCard")
    return /* @__PURE__ */ a.jsxs("div", { className: "flex h-[5.71429rem] items-center gap-[0.85714rem] rounded-[0.57142rem] border border-mshop-blue-100 p-[0.85714rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "flex-center h-[4rem] w-[6.28571rem] rounded-[0.57142rem] bg-mshop-gray-5", children: /* @__PURE__ */ a.jsx(W9, { className: "size-[1.71429rem] text-mshop-blue-100" }) }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex grow flex-col gap-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-b", children: [
          "신용카드 (",
          e.paymentMethod.name,
          ")"
        ] }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: Oz(e.paymentMethod.number) })
      ] }),
      e.onRemoveClick && /* @__PURE__ */ a.jsx("button", { onClick: e.onRemoveClick, type: "button", children: /* @__PURE__ */ a.jsx(gA, { className: "size-[1.71429rem] text-mshop-gray-50" }) })
    ] });
  if (e.variant === "readOnly")
    return /* @__PURE__ */ a.jsxs("div", { className: "flex h-[5.71429rem] items-center gap-[0.85714rem] rounded-[0.57142rem] border border-transparent bg-mshop-gray-5 p-[0.85714rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "flex-center h-[4rem] w-[6.28571rem] rounded-[0.57142rem] bg-mshop-white", children: /* @__PURE__ */ a.jsx(W9, { className: "size-[1.71429rem] text-mshop-blue-100" }) }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-b", children: [
          "신용카드 (",
          e.paymentMethod.name,
          ")"
        ] }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: Oz(e.paymentMethod.number) })
      ] })
    ] });
  throw new Error("Unexpected variant");
}
const Az = (e) => e.slice(12, 15) + "●";
function $2({
  isMobile: e = !1,
  ...t
}) {
  if (t.variant === "add")
    return /* @__PURE__ */ a.jsxs(
      "button",
      {
        onClick: t.onAddClick,
        className: "flex h-[6.285714rem] w-full flex-col items-center justify-center gap-[.57143rem] rounded-[.57142rem] border border-dashed border-mshop-gray-20 text-mshop-gray-50",
        type: "button",
        children: [
          /* @__PURE__ */ a.jsx(iY, { className: "size-[1.42857rem]" }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "결제 수단 등록하기" })
        ]
      }
    );
  if (t.variant === "creditCard")
    return /* @__PURE__ */ a.jsxs("div", { className: "flex h-[6.285714rem] items-center gap-[1.14285rem] rounded-[.57142rem] border border-mshop-blue-100 p-[1.14285rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "flex-center h-[4rem] w-[8rem] rounded-[.57142rem] bg-mshop-gray-5", children: /* @__PURE__ */ a.jsx(W9, { className: "size-[1.42857rem] text-mshop-blue-100" }) }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex grow flex-col gap-[.28571rem]", children: [
        /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-16-b", children: [
          "신용카드 (",
          t.paymentMethod.name,
          ")"
        ] }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: Az(t.paymentMethod.number) })
      ] }),
      t.onRemoveClick && /* @__PURE__ */ a.jsx("button", { onClick: t.onRemoveClick, type: "button", children: /* @__PURE__ */ a.jsx(gA, { className: "size-[1.71428rem] text-mshop-gray-50" }) })
    ] });
  if (t.variant === "readOnly")
    return /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex items-center rounded-[.57142rem] border border-transparent bg-mshop-gray-5",
          e ? "h-[5.71429rem] gap-[0.85714rem] p-[0.85714rem]" : "h-[6.28571rem] gap-[1.14285rem] p-[1.14285rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx(
            "div",
            {
              className: $(
                "flex-center h-[4rem] rounded-[.57142rem] bg-mshop-white",
                e ? "w-[6.28571rem]" : "w-[8rem]"
              ),
              children: /* @__PURE__ */ a.jsx(W9, { className: "size-[1.42857rem] text-mshop-blue-100" })
            }
          ),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[.28571rem]", children: [
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: e ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: [
                  "신용카드 (",
                  t.paymentMethod.name,
                  ")"
                ]
              }
            ),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: Az(t.paymentMethod.number) })
          ] })
        ]
      }
    );
  throw new Error("Unexpected variant");
}
const jye = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M5.80964 10.7624C5.2968 10.2496 4.46533 10.2496 3.9525 10.7624C3.43966 11.2753 3.43966 12.1067 3.9525 12.6196L8.9818 17.6489C9.45186 18.1189 10.214 18.1189 10.684 17.6489L20.0472 8.28571C20.56 7.77288 20.56 6.94141 20.0472 6.42857C19.5344 5.91574 18.7029 5.91574 18.1901 6.42857L10.4519 14.1667C10.11 14.5086 9.55579 14.5086 9.21394 14.1667L5.80964 10.7624Z" })), Eye = yn(jye), Z0 = yn(
  ({ marginTop: e, ...t }, n) => /* @__PURE__ */ a.jsx(
    G$,
    {
      ...t,
      ref: n,
      className: $(
        "flex-center group size-[1.14285rem] shrink-0 rounded-[.28571rem]",
        "cursor-pointer border border-mshop-gray-20 bg-mshop-white transition-colors duration-300 ease-out hover:border-mshop-blue-100 group-hover:border-mshop-blue-100",
        "data-[checked]:border-none data-[checked]:bg-mshop-blue-100",
        "data-[disabled]:cursor-not-allowed data-[disabled]:border-mshop-gray-20 data-[disabled]:bg-mshop-gray-5"
      ),
      style: { marginTop: e },
      children: /* @__PURE__ */ a.jsx(Eye, { className: "size-[0.92857rem] text-mshop-white opacity-0 group-data-[checked]:opacity-100" })
    }
  )
), kye = {
  circle: "text-security-circle",
  disc: "text-security-disc",
  square: "text-security-square",
  none: ""
}, A8 = yn(
  ({ padding: e, forceWritableStyle: t = !1, textSecurity: n = "none", ...r }, s) => {
    const {
      widgetCore: { isMobile: o }
    } = Gt();
    return /* @__PURE__ */ a.jsx(
      LE,
      {
        ref: s,
        style: {
          paddingRight: e == null ? void 0 : e.right,
          paddingLeft: e == null ? void 0 : e.left
        },
        ...r,
        className: $(
          "flex w-full items-center gap-x-[.28571rem] border-b border-mshop-gray-10 py-3 text-mshop-black focus:outline-none",
          r.readOnly && !t ? "bg-mshop-gray-5" : {
            "bg-mshop-white focus-within:border-mshop-blue-100 focus-within:caret-mshop-blue-100": !r.invalid && !r.disabled && !t,
            "border-mshop-red-80 caret-mshop-red-80": r.invalid,
            "bg-mshop-gray-5 text-mshop-gray-50": r.disabled
          },
          { "typo-mshop-kr-16-m": !o },
          { "typo-mshop-kr-14-m": o },
          { "appearance-none": r.type === "number" },
          kye[n]
        )
      }
    );
  }
), _ye = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_20161_9879)" }, /* @__PURE__ */ re.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.217 17.5132L2.56017 10.9022C2.05858 10.4041 2.05858 9.59602 2.56017 9.09788L9.217 2.48686C9.64022 2.06655 10.3265 2.06655 10.7497 2.48686C11.1728 2.90718 11.1729 3.58878 10.7497 4.00904L5.80481 8.91992L16.783 8.91992C17.3794 8.91992 17.863 9.40353 17.863 10C17.863 10.5965 17.3794 11.0801 16.783 11.0801H5.80474L10.7497 15.991C11.1729 16.4113 11.1728 17.0929 10.7497 17.5132C10.3265 17.9335 9.64022 17.9335 9.217 17.5132Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_20161_9879" }, /* @__PURE__ */ re.createElement("rect", { width: 20, height: 20 })))), Tye = yn(_ye), Mye = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_18375_51785)" }, /* @__PURE__ */ re.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.13482 19.3398C2.71308 19.7616 2.71308 20.4455 3.13482 20.8673C3.55656 21.2891 4.24033 21.2891 4.66206 20.8673L12.0006 13.5277L19.3398 20.868C19.7615 21.2898 20.4453 21.2898 20.867 20.868C21.2888 20.4462 21.2888 19.7623 20.867 19.3405L13.5278 12.0003L20.8631 4.66391C21.2849 4.24212 21.2849 3.55825 20.8631 3.13646C20.4414 2.71466 19.7576 2.71466 19.3359 3.13646L12.0006 10.4728L4.66597 3.13716C4.24423 2.71537 3.56046 2.71537 3.13873 3.13716C2.71699 3.55896 2.71699 4.24283 3.13873 4.66462L10.4733 12.0003L3.13482 19.3398Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_18375_51785" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), Rye = yn(Mye);
function D1(e) {
  const { back: t, label: n, close: r, widthFull: s = !0 } = e;
  return /* @__PURE__ */ a.jsxs(
    "header",
    {
      className: $(
        "flex min-w-[22.85714rem] items-center justify-between bg-mshop-white px-[2.28571rem] py-[1.71429rem]",
        {
          "w-full": s
        }
      ),
      children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-[1_0_0] items-center gap-[0.57143rem] overflow-hidden", children: [
          t && /* @__PURE__ */ a.jsx(Tye, { className: "size-[1.42857rem] shrink-0 text-mshop-black" }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b truncate text-mshop-black", children: n })
        ] }),
        r && /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: "flex items-center justify-center",
            disabled: e.isCloseButtonDisabled,
            onClick: e.onCloseButtonClick,
            children: /* @__PURE__ */ a.jsx(Rye, { className: "size-[1.42857rem] shrink-0 text-mshop-black" })
          }
        )
      ]
    }
  );
}
function p5({ title: e, onClose: t, disabled: n = !1 }) {
  const {
    widgetCore: { isMobile: r }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(
    "header",
    {
      className: $(
        "relative flex w-full items-center justify-between p-[1.14285rem]",
        { "h-[4.28571rem]": r }
      ),
      children: [
        /* @__PURE__ */ a.jsx(
          "h1",
          {
            className: $("typo-mshop-kr-16-b", {
              "w-full text-center": r
            }),
            children: e
          }
        ),
        /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: "absolute right-[1.14285rem]",
            onClick: t,
            disabled: n,
            children: /* @__PURE__ */ a.jsx(
              Zg,
              {
                className: $(
                  "text-mshop-black",
                  r ? "size-[1.71429rem]" : "size-[1.42857rem]"
                )
              }
            )
          }
        )
      ]
    }
  );
}
var Dye = {
  visa: {
    niceType: "Visa",
    type: "visa",
    patterns: [4],
    gaps: [4, 8, 12],
    lengths: [16, 18, 19],
    code: {
      name: "CVV",
      size: 3
    }
  },
  mastercard: {
    niceType: "Mastercard",
    type: "mastercard",
    patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: "CVC",
      size: 3
    }
  },
  "american-express": {
    niceType: "American Express",
    type: "american-express",
    patterns: [34, 37],
    gaps: [4, 10],
    lengths: [15],
    code: {
      name: "CID",
      size: 4
    }
  },
  "diners-club": {
    niceType: "Diners Club",
    type: "diners-club",
    patterns: [[300, 305], 36, 38, 39],
    gaps: [4, 10],
    lengths: [14, 16, 19],
    code: {
      name: "CVV",
      size: 3
    }
  },
  discover: {
    niceType: "Discover",
    type: "discover",
    patterns: [6011, [644, 649], 65],
    gaps: [4, 8, 12],
    lengths: [16, 19],
    code: {
      name: "CID",
      size: 3
    }
  },
  jcb: {
    niceType: "JCB",
    type: "jcb",
    patterns: [2131, 1800, [3528, 3589]],
    gaps: [4, 8, 12],
    lengths: [16, 17, 18, 19],
    code: {
      name: "CVV",
      size: 3
    }
  },
  unionpay: {
    niceType: "UnionPay",
    type: "unionpay",
    patterns: [
      620,
      [624, 626],
      [62100, 62182],
      [62184, 62187],
      [62185, 62197],
      [62200, 62205],
      [622010, 622999],
      622018,
      [622019, 622999],
      [62207, 62209],
      [622126, 622925],
      [623, 626],
      6270,
      6272,
      6276,
      [627700, 627779],
      [627781, 627799],
      [6282, 6289],
      6291,
      6292,
      810,
      [8110, 8131],
      [8132, 8151],
      [8152, 8163],
      [8164, 8171]
    ],
    gaps: [4, 8, 12],
    lengths: [14, 15, 16, 17, 18, 19],
    code: {
      name: "CVN",
      size: 3
    }
  },
  maestro: {
    niceType: "Maestro",
    type: "maestro",
    patterns: [
      493698,
      [5e5, 504174],
      [504176, 506698],
      [506779, 508999],
      [56, 59],
      63,
      67,
      6
    ],
    gaps: [4, 8, 12],
    lengths: [12, 13, 14, 15, 16, 17, 18, 19],
    code: {
      name: "CVC",
      size: 3
    }
  },
  elo: {
    niceType: "Elo",
    type: "elo",
    patterns: [
      401178,
      401179,
      438935,
      457631,
      457632,
      431274,
      451416,
      457393,
      504175,
      [506699, 506778],
      [509e3, 509999],
      627780,
      636297,
      636368,
      [650031, 650033],
      [650035, 650051],
      [650405, 650439],
      [650485, 650538],
      [650541, 650598],
      [650700, 650718],
      [650720, 650727],
      [650901, 650978],
      [651652, 651679],
      [655e3, 655019],
      [655021, 655058]
    ],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: "CVE",
      size: 3
    }
  },
  mir: {
    niceType: "Mir",
    type: "mir",
    patterns: [[2200, 2204]],
    gaps: [4, 8, 12],
    lengths: [16, 17, 18, 19],
    code: {
      name: "CVP2",
      size: 3
    }
  },
  hiper: {
    niceType: "Hiper",
    type: "hiper",
    patterns: [637095, 63737423, 63743358, 637568, 637599, 637609, 637612],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: "CVC",
      size: 3
    }
  },
  hipercard: {
    niceType: "Hipercard",
    type: "hipercard",
    patterns: [606282],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: "CVC",
      size: 3
    }
  }
}, Pye = Dye, rk = {}, y6 = {};
Object.defineProperty(y6, "__esModule", { value: !0 });
y6.clone = void 0;
function Oye(e) {
  return e ? JSON.parse(JSON.stringify(e)) : null;
}
y6.clone = Oye;
var ak = {};
Object.defineProperty(ak, "__esModule", { value: !0 });
ak.matches = void 0;
function Aye(e, t, n) {
  var r = String(t).length, s = e.substr(0, r), o = parseInt(s, 10);
  return t = parseInt(String(t).substr(0, s.length), 10), n = parseInt(String(n).substr(0, s.length), 10), o >= t && o <= n;
}
function Lye(e, t) {
  return t = String(t), t.substring(0, e.length) === e.substring(0, t.length);
}
function Iye(e, t) {
  return Array.isArray(t) ? Aye(e, t[0], t[1]) : Lye(e, t);
}
ak.matches = Iye;
Object.defineProperty(rk, "__esModule", { value: !0 });
rk.addMatchingCardsToResults = void 0;
var Fye = y6, Uye = ak;
function zye(e, t, n) {
  var r, s;
  for (r = 0; r < t.patterns.length; r++) {
    var o = t.patterns[r];
    if (Uye.matches(e, o)) {
      var c = Fye.clone(t);
      Array.isArray(o) ? s = String(o[0]).length : s = String(o).length, e.length >= s && (c.matchStrength = s), n.push(c);
      break;
    }
  }
}
rk.addMatchingCardsToResults = zye;
var sk = {};
Object.defineProperty(sk, "__esModule", { value: !0 });
sk.isValidInputType = void 0;
function Bye(e) {
  return typeof e == "string" || e instanceof String;
}
sk.isValidInputType = Bye;
var ik = {};
Object.defineProperty(ik, "__esModule", { value: !0 });
ik.findBestMatch = void 0;
function Hye(e) {
  var t = e.filter(function(n) {
    return n.matchStrength;
  }).length;
  return t > 0 && t === e.length;
}
function Vye(e) {
  return Hye(e) ? e.reduce(function(t, n) {
    return !t || Number(t.matchStrength) < Number(n.matchStrength) ? n : t;
  }) : null;
}
ik.findBestMatch = Vye;
var Y9 = C1 && C1.__assign || function() {
  return Y9 = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, Y9.apply(this, arguments);
}, oY = Pye, $ye = rk, Gye = sk, Wye = ik, v6 = y6, R3 = {}, lp = {
  VISA: "visa",
  MASTERCARD: "mastercard",
  AMERICAN_EXPRESS: "american-express",
  DINERS_CLUB: "diners-club",
  DISCOVER: "discover",
  JCB: "jcb",
  UNIONPAY: "unionpay",
  MAESTRO: "maestro",
  ELO: "elo",
  MIR: "mir",
  HIPER: "hiper",
  HIPERCARD: "hipercard"
}, lY = [
  lp.VISA,
  lp.MASTERCARD,
  lp.AMERICAN_EXPRESS,
  lp.DINERS_CLUB,
  lp.DISCOVER,
  lp.JCB,
  lp.UNIONPAY,
  lp.MAESTRO,
  lp.ELO,
  lp.MIR,
  lp.HIPER,
  lp.HIPERCARD
], G2 = v6.clone(lY);
function yA(e) {
  return R3[e] || oY[e];
}
function Yye() {
  return G2.map(function(e) {
    return v6.clone(yA(e));
  });
}
function vA(e, t) {
  t === void 0 && (t = !1);
  var n = G2.indexOf(e);
  if (!t && n === -1)
    throw new Error('"' + e + '" is not a supported card type.');
  return n;
}
function Z2(e) {
  var t = [];
  if (!Gye.isValidInputType(e))
    return t;
  if (e.length === 0)
    return Yye();
  G2.forEach(function(r) {
    var s = yA(r);
    $ye.addMatchingCardsToResults(e, s, t);
  });
  var n = Wye.findBestMatch(t);
  return n ? [n] : t;
}
Z2.getTypeInfo = function(e) {
  return v6.clone(yA(e));
};
Z2.removeCard = function(e) {
  var t = vA(e);
  G2.splice(t, 1);
};
Z2.addCard = function(e) {
  var t = vA(e.type, !0);
  R3[e.type] = e, t === -1 && G2.push(e.type);
};
Z2.updateCard = function(e, t) {
  var n = R3[e] || oY[e];
  if (!n)
    throw new Error('"' + e + "\" is not a recognized type. Use `addCard` instead.'");
  if (t.type && n.type !== t.type)
    throw new Error("Cannot overwrite type parameter.");
  var r = v6.clone(n);
  r = Y9(Y9({}, r), t), R3[r.type] = r;
};
Z2.changeOrder = function(e, t) {
  var n = vA(e);
  G2.splice(n, 1), G2.splice(t, 0, e);
};
Z2.resetModifications = function() {
  G2 = v6.clone(lY), R3 = {};
};
Z2.types = lp;
var cY = Z2, ok = {};
Object.defineProperty(ok, "__esModule", { value: !0 });
ok.cardholderName = void 0;
var qye = /^[\d\s-]*$/, Kye = 255;
function O7(e, t) {
  return { isValid: e, isPotentiallyValid: t };
}
function Xye(e) {
  return typeof e != "string" ? O7(!1, !1) : e.length === 0 ? O7(!1, !0) : e.length > Kye ? O7(!1, !1) : qye.test(e) ? O7(!1, !0) : O7(!0, !0);
}
ok.cardholderName = Xye;
var lk = {};
function Qye(e) {
  for (var t = 0, n = !1, r = e.length - 1, s; r >= 0; )
    s = parseInt(e.charAt(r), 10), n && (s *= 2, s > 9 && (s = s % 10 + 1)), n = !n, t += s, r--;
  return t % 10 === 0;
}
var Zye = Qye;
Object.defineProperty(lk, "__esModule", { value: !0 });
lk.cardNumber = void 0;
var Jye = Zye, Lz = cY;
function N4(e, t, n) {
  return {
    card: e,
    isPotentiallyValid: t,
    isValid: n
  };
}
function eve(e, t) {
  t === void 0 && (t = {});
  var n, r, s;
  if (typeof e != "string" && typeof e != "number")
    return N4(null, !1, !1);
  var o = String(e).replace(/-|\s/g, "");
  if (!/^\d*$/.test(o))
    return N4(null, !1, !1);
  var c = Lz(o);
  if (c.length === 0)
    return N4(null, !1, !1);
  if (c.length !== 1)
    return N4(null, !0, !1);
  var u = c[0];
  if (t.maxLength && o.length > t.maxLength)
    return N4(u, !1, !1);
  t.skipLuhnValidation === !0 || u.type === Lz.types.UNIONPAY && t.luhnValidateUnionPay !== !0 ? r = !0 : r = Jye(o), s = Math.max.apply(null, u.lengths), t.maxLength && (s = Math.min(t.maxLength, s));
  for (var m = 0; m < u.lengths.length; m++)
    if (u.lengths[m] === o.length)
      return n = o.length < s || r, N4(u, n, r);
  return N4(u, o.length < s, !1);
}
lk.cardNumber = eve;
var ck = {}, uk = {}, bw = {};
Object.defineProperty(bw, "__esModule", { value: !0 });
bw.expirationYear = void 0;
var tve = 19;
function o2(e, t, n) {
  return {
    isValid: e,
    isPotentiallyValid: t,
    isCurrentYear: n || !1
  };
}
function nve(e, t) {
  t === void 0 && (t = tve);
  var n;
  if (typeof e != "string")
    return o2(!1, !1);
  if (e.replace(/\s/g, "") === "")
    return o2(!1, !0);
  if (!/^\d*$/.test(e))
    return o2(!1, !1);
  var r = e.length;
  if (r < 2)
    return o2(!1, !0);
  var s = (/* @__PURE__ */ new Date()).getFullYear();
  if (r === 3) {
    var o = e.slice(0, 2), c = String(s).slice(0, 2);
    return o2(!1, o === c);
  }
  if (r > 4)
    return o2(!1, !1);
  var u = parseInt(e, 10), m = Number(String(s).substr(2, 2)), y = !1;
  if (r === 2) {
    if (String(s).substr(0, 2) === e)
      return o2(!1, !0);
    n = m === u, y = u >= m && u <= m + t;
  } else r === 4 && (n = s === u, y = u >= s && u <= s + t);
  return o2(y, y, n);
}
bw.expirationYear = nve;
var dk = {};
Object.defineProperty(dk, "__esModule", { value: !0 });
dk.isArray = void 0;
dk.isArray = Array.isArray || function(e) {
  return Object.prototype.toString.call(e) === "[object Array]";
};
Object.defineProperty(uk, "__esModule", { value: !0 });
uk.parseDate = void 0;
var rve = bw, ave = dk;
function sve(e) {
  var t = Number(e[0]), n;
  return t === 0 ? 2 : t > 1 || t === 1 && Number(e[1]) > 2 ? 1 : t === 1 ? (n = e.substr(1), (0, rve.expirationYear)(n).isPotentiallyValid ? 1 : 2) : e.length === 5 ? 1 : e.length > 5 ? 2 : 1;
}
function ive(e) {
  var t;
  if (/^\d{4}-\d{1,2}$/.test(e) ? t = e.split("-").reverse() : /\//.test(e) ? t = e.split(/\s*\/\s*/g) : /\s/.test(e) && (t = e.split(/ +/g)), (0, ave.isArray)(t))
    return {
      month: t[0] || "",
      year: t.slice(1).join()
    };
  var n = sve(e), r = e.substr(0, n);
  return {
    month: r,
    year: e.substr(r.length)
  };
}
uk.parseDate = ive;
var x6 = {};
Object.defineProperty(x6, "__esModule", { value: !0 });
x6.expirationMonth = void 0;
function A7(e, t, n) {
  return {
    isValid: e,
    isPotentiallyValid: t,
    isValidForThisYear: n || !1
  };
}
function ove(e) {
  var t = (/* @__PURE__ */ new Date()).getMonth() + 1;
  if (typeof e != "string")
    return A7(!1, !1);
  if (e.replace(/\s/g, "") === "" || e === "0")
    return A7(!1, !0);
  if (!/^\d*$/.test(e))
    return A7(!1, !1);
  var n = parseInt(e, 10);
  if (isNaN(Number(e)))
    return A7(!1, !1);
  var r = n > 0 && n < 13;
  return A7(r, r, r && n >= t);
}
x6.expirationMonth = ove;
var YD = C1 && C1.__assign || function() {
  return YD = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, YD.apply(this, arguments);
};
Object.defineProperty(ck, "__esModule", { value: !0 });
ck.expirationDate = void 0;
var lve = uk, cve = x6, uve = bw;
function L7(e, t, n, r) {
  return {
    isValid: e,
    isPotentiallyValid: t,
    month: n,
    year: r
  };
}
function dve(e, t) {
  var n;
  if (typeof e == "string")
    e = e.replace(/^(\d\d) (\d\d(\d\d)?)$/, "$1/$2"), n = (0, lve.parseDate)(String(e));
  else if (e !== null && typeof e == "object") {
    var r = YD({}, e);
    n = {
      month: String(r.month),
      year: String(r.year)
    };
  } else
    return L7(!1, !1, null, null);
  var s = (0, cve.expirationMonth)(n.month), o = (0, uve.expirationYear)(n.year, t);
  if (s.isValid) {
    if (o.isCurrentYear) {
      var c = s.isValidForThisYear;
      return L7(c, c, n.month, n.year);
    }
    if (o.isValid)
      return L7(!0, !0, n.month, n.year);
  }
  return s.isPotentiallyValid && o.isPotentiallyValid ? L7(!1, !0, null, null) : L7(!1, !1, null, null);
}
ck.expirationDate = dve;
var fk = {};
Object.defineProperty(fk, "__esModule", { value: !0 });
fk.cvv = void 0;
var uY = 3;
function fve(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t === e[n])
      return !0;
  return !1;
}
function mve(e) {
  for (var t = uY, n = 0; n < e.length; n++)
    t = e[n] > t ? e[n] : t;
  return t;
}
function d8(e, t) {
  return { isValid: e, isPotentiallyValid: t };
}
function hve(e, t) {
  return t === void 0 && (t = uY), t = t instanceof Array ? t : [t], typeof e != "string" || !/^\d*$/.test(e) ? d8(!1, !1) : fve(t, e.length) ? d8(!0, !0) : e.length < Math.min.apply(null, t) ? d8(!1, !0) : e.length > mve(t) ? d8(!1, !1) : d8(!0, !0);
}
fk.cvv = hve;
var mk = {};
Object.defineProperty(mk, "__esModule", { value: !0 });
mk.postalCode = void 0;
var pve = 3, gve = new RegExp(/^[a-z0-9]+$/i);
function Dj(e, t) {
  return { isValid: e, isPotentiallyValid: t };
}
function yve(e, t) {
  t === void 0 && (t = {});
  var n = t.minLength || pve;
  return typeof e != "string" ? Dj(!1, !1) : e.length < n ? Dj(!1, !0) : gve.test(e.trim().slice(0, n)) ? Dj(!0, !0) : Dj(!1, !0);
}
mk.postalCode = yve;
var vve = C1 && C1.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var s = Object.getOwnPropertyDescriptor(t, n);
  (!s || ("get" in s ? !t.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, s);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), xve = C1 && C1.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), bve = C1 && C1.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var n in e) n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && vve(t, e, n);
  return xve(t, e), t;
}, Sve = bve(cY), wve = ok, Cve = lk, Nve = ck, jve = x6, Eve = bw, kve = fk, _ve = mk, Tve = {
  creditCardType: Sve,
  cardholderName: wve.cardholderName,
  number: Cve.cardNumber,
  expirationDate: Nve.expirationDate,
  expirationMonth: jve.expirationMonth,
  expirationYear: Eve.expirationYear,
  cvv: kve.cvv,
  postalCode: _ve.postalCode
}, Mve = Tve;
const Rve = /* @__PURE__ */ fE(Mve), Dve = async (e, t) => jn(
  "/change-pay-method",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.InvalidPaymentInfo:
      return n;
    default:
      throw new Error("postChangePayment");
  }
}), T4 = {
  CardNum: "CARD_NUM",
  ExpiryDay: "EXPIRY_DAY",
  Birth: "BIRTH",
  Pass: "PASS",
  UnavailablePayMethod: "UNAVAILABLE_PAY_METHOD"
}, Yg = (e) => e.replace(/[^0-9]/g, ""), Pve = (e, t) => e.slice(0, t), Ove = (e) => {
  const t = /^\d{4}-?\d{2}-?\d{2}$/, n = /^\d{6}$/;
  if (!t.test(e) && !n.test(e))
    return !1;
  let r, s, o;
  if (t.test(e))
    e.includes("-") ? [r, s, o] = e.split("-").map(Number) : (r = Number(e.slice(0, 4)), s = Number(e.slice(4, 6)), o = Number(e.slice(6, 8)));
  else if (n.test(e)) {
    r = Number(e.slice(0, 2)), s = Number(e.slice(2, 4)), o = Number(e.slice(4, 6));
    const m = (/* @__PURE__ */ new Date()).getFullYear() % 100;
    r += r <= m ? 2e3 : 1900;
  }
  if (!r || !s)
    return !1;
  const c = new Date(r, s - 1, o), u = /* @__PURE__ */ new Date();
  return c.getFullYear() !== r || c.getMonth() + 1 !== s || c.getDate() !== o ? !1 : c <= u;
}, Iz = {
  shopDefault: ch
};
function uh({ children: e, theme: t, iconFront: n, iconRear: r, widthFull: s, ...o }) {
  const {
    widgetCore: { isMobile: c }
  } = Gt(), u = n ? Iz[n] : null, m = r ? Iz[r] : null, y = dn(
    () => ({
      white: $(
        "bg-mshop-blue-10 text-mshop-blue-100 disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50",
        {
          "hover:bg-mshop-blue-100 hover:text-mshop-blue-10": !c
        }
      ),
      blue: $(
        "bg-mshop-blue-100 text-mshop-white disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50",
        {
          "hover:bg-mshop-blue-10 hover:text-mshop-blue-100": !c
        }
      ),
      line: $(
        "border border-mshop-gray-20 bg-mshop-white text-mshop-gray-80 disabled:border-transparent disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50",
        {
          "hover:border-mshop-blue-100 hover:text-mshop-blue-100": !c
        }
      )
    }),
    [c]
  );
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...o,
      className: $(
        "flex-center transition duration-200",
        "typo-mshop-kr-16-b h-[3.71429rem] gap-x-[0.28571rem] rounded-[0.57143rem] px-[1.71429rem]",
        y[t],
        {
          "w-full": s
        }
      ),
      children: (b) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        u && /* @__PURE__ */ a.jsx(u, { className: "size-[1.14286rem] shrink-0" }),
        /* @__PURE__ */ a.jsx("span", { className: "shrink-0", children: typeof e == "function" ? e(b) : e }),
        m && /* @__PURE__ */ a.jsx(m, { className: "size-[1.14286rem] shrink-0" })
      ] })
    }
  );
}
const Fz = {
  arrowRight: VO
}, Ave = {
  lg: $(
    "typo-mshop-kr-16-b h-[4rem] gap-x-[.28571rem] rounded-[.57142rem] px-[1.71428rem]"
  ),
  sm: $(
    "typo-mshop-kr-14-b h-[2.85714rem] gap-x-[.28571rem] rounded-[.57142rem] px-[1.71428rem]"
  )
}, Uz = {
  lg: "size-[1.42857rem]",
  sm: "size-[1.14285rem]"
};
function Lve({
  children: e,
  variant: t,
  isSelected: n,
  iconFront: r,
  iconRear: s,
  widthFull: o = !1,
  ...c
}) {
  const u = r ? Fz[r] : null, m = s ? Fz[s] : null;
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...c,
      className: $(
        "flex-center transition duration-200",
        "disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50",
        Ave[t],
        n ? "cursor-default bg-mshop-blue-100 text-mshop-white" : "border border-mshop-gray-20 bg-mshop-white text-mshop-gray-80 hover:border-mshop-blue-100 hover:text-mshop-blue-100",
        {
          "w-full": o
        }
      ),
      children: (y) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        u && /* @__PURE__ */ a.jsx(u, { className: Uz[t] }),
        typeof e == "function" ? e(y) : e,
        m && /* @__PURE__ */ a.jsx(m, { className: Uz[t] })
      ] })
    }
  );
}
const Ive = {
  circle: "text-security-circle",
  disc: "text-security-disc",
  square: "text-security-square",
  none: ""
}, dY = yn(
  function({
    helperText: t,
    forceWritableStyle: n = !1,
    readOnly: r,
    onDeleteButtonClick: s,
    textSecurity: o = "none",
    ...c
  }, u) {
    let m = $(
      "bg-mshop-white has-[input:focus]:border-b-mshop-blue-100",
      "has-[input:disabled]:border-b-mshop-gray-10 has-[input:disabled]:bg-mshop-gray-5",
      "has-[input:read-only]:border-b-mshop-gray-10 has-[input:read-only]:bg-mshop-gray-5"
    ), y = $(
      "text-mshop-black caret-mshop-blue-100 placeholder:text-mshop-gray-50",
      "disabled:text-mshop-gray-50",
      "read-only:bg-mshop-gray-5"
    );
    return n ? (m = $("bg-mshop-white"), y = $("text-mshop-black")) : c.invalid && (m = $("bg-mshop-white has-[:focus]:border-b-mshop-red-80"), y = $(
      "text-mshop-black caret-mshop-red-80 placeholder:text-mshop-gray-50"
    )), /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
      /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: $(
            "flex h-[2.85714rem] items-center border-y border-b-mshop-gray-10 border-t-transparent py-[0.64286rem]",
            m
          ),
          children: [
            /* @__PURE__ */ a.jsx(
              LE,
              {
                ref: u,
                className: $(
                  "placeholder:typo-mshop-kr-14-m typo-mshop-kr-14-m peer w-full grow focus:outline-none",
                  y,
                  { "appearance-none": c.type === "number" },
                  Ive[o]
                ),
                readOnly: r || n,
                ...c
              }
            ),
            s && /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "mr-[0.57143rem] hidden size-[1.14286rem] shrink-0 items-center justify-center rounded-full bg-mshop-gray-50 hover:!flex peer-read-only:!hidden peer-focus:flex",
                onClick: s,
                children: /* @__PURE__ */ a.jsx(Zg, { className: "size-[0.71429rem] text-mshop-white" })
              }
            )
          ]
        }
      ),
      t && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m whitespace-pre-wrap text-mshop-gray-50", children: t })
    ] });
  }
), hR = {
  [T4.CardNum]: "카드 번호를 다시 입력해주세요.",
  [T4.ExpiryDay]: "유효 기간을 다시 입력해주세요.",
  [T4.Birth]: "생년월일을 다시 입력해주세요.",
  [T4.Pass]: "비밀번호를 다시 입력해주세요.",
  [T4.UnavailablePayMethod]: "거래 정지된 카드입니다."
}, Tl = {
  number: {
    required: !0,
    minLength: 4,
    maxLength: 4
  },
  expiry: {
    required: !0,
    minLength: 4,
    maxLength: 4
  },
  password: {
    required: !0,
    minLength: 2,
    maxLength: 2
  },
  birthday: {
    required: !0,
    minLength: 6,
    maxLength: 6
  }
};
function Fve({
  onRegister: e,
  registeredPayMethod: t,
  onClickPersonalInfoOutsourcing: n,
  onClickThirdPartyConsent: r,
  onClickInicisTerms: s
}) {
  const [o, c] = Re(!1), [u, m] = Re(!1), [y, b] = Re(!1), [w, k] = Re(!1), [j, E] = Re(null), {
    widgetCore: { toggleSpinner: T, isMobile: D, onError: L }
  } = Gt(), I = D ? dY : A8, R = D ? uh : fn, { client: U } = Ha(), {
    formState: { isValid: z, isSubmitting: H },
    register: K,
    handleSubmit: q,
    setFocus: Q
  } = bp(), Z = Rt(null), X = Rt(null), se = Rt(null), te = () => {
    var ve;
    return (ve = se.current) == null ? void 0 : ve.scrollIntoView(!0);
  };
  an(() => {
    te();
  }, [j]);
  const fe = !z || H || !o || !u || !y || !!(t && !w), ce = async (ve) => {
    E(null);
    const Te = [
      ve.number.first,
      ve.number.second,
      ve.number.third,
      ve.number.fourth
    ].join("");
    if (!pe(ve))
      return te();
    T(!0);
    const Ie = await Dve(
      {
        card: {
          number: Te,
          birthOrBusinessRegistrationNumber: ve.birthday,
          expiryMonth: ve.expiry.slice(0, 2),
          expiryYear: ve.expiry.slice(2, 4),
          passwordTwoDigits: ve.password
        }
      },
      { client: U, onError: L }
    );
    if (T(!1), Ie.code === le.InvalidPaymentInfo)
      return te(), E(hR[Ie.data.column]);
    if (Ie.code === le.TokenExpired)
      return L(Ht);
    e(Ie.data);
  }, pe = (ve) => {
    const { isValid: Te } = Rve.expirationDate(
      ve.expiry
    );
    return Te ? Ove(ve.birthday) ? !0 : (E(hR[T4.Birth]), !1) : (E(hR[T4.ExpiryDay]), !1);
  }, Se = (ve, Te) => {
    ve.target.value = Yg(
      Pve(ve.target.value, Tl.number.maxLength)
    ), ve.target.value.length === Tl.number.maxLength && Q(Te);
  }, oe = (ve) => {
    ve.target.value = Yg(ve.target.value), ve.target.value.length === Tl.expiry.maxLength && Q("password");
  }, ue = (ve) => {
    ve.target.value = Yg(ve.target.value), ve.target.value.length === Tl.password.maxLength && Q("birthday");
  }, he = (ve) => {
    var Te;
    ve.target.value = Yg(ve.target.value), ve.target.value.length === Tl.birthday.maxLength && !u && ((Te = X.current) == null || Te.focus());
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "main",
      {
        ref: Z,
        className: $(
          "flex flex-col overflow-y-scroll",
          D ? "flex-grow gap-[2.28571rem] p-[1.14285rem]" : "gap-[2.28571rem] px-[2.28571rem] pb-[2.28571rem] pt-[1.14286rem]"
        ),
        children: [
          t && /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ a.jsx(
              "h2",
              {
                className: D ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b gap-[.57143rem]",
                children: "기존 결제 수단"
              }
            ),
            /* @__PURE__ */ a.jsx("div", { className: "pt-[.57143rem]", children: /* @__PURE__ */ a.jsx(
              $2,
              {
                isMobile: D,
                variant: "readOnly",
                paymentMethod: t
              }
            ) })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[.57143rem]", children: [
            /* @__PURE__ */ a.jsx(
              "h2",
              {
                className: D ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "결제 수단"
              }
            ),
            /* @__PURE__ */ a.jsx(
              "div",
              {
                className: $(
                  "flex",
                  D ? "w-[11.96429rem]" : "w-[9.57142rem] pt-[.57143rem]"
                ),
                children: D ? /* @__PURE__ */ a.jsx(uh, { widthFull: !0, theme: "blue", type: "button", children: "신용카드" }) : /* @__PURE__ */ a.jsx(
                  Lve,
                  {
                    variant: "sm",
                    isSelected: !0,
                    widthFull: !0,
                    type: "button",
                    children: "신용카드"
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "flex flex-col",
                D ? "gap-[0.57143rem]" : "gap-[0.28571rem]"
              ),
              children: [
                /* @__PURE__ */ a.jsx(
                  "h3",
                  {
                    className: D ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                    children: "카드 번호"
                  }
                ),
                /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[.57143rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    I,
                    {
                      ...K("number.first", {
                        required: Tl.number.required,
                        minLength: Tl.number.minLength,
                        onChange: (ve) => Se(ve, "number.second")
                      }),
                      placeholder: "0000",
                      type: "number",
                      pattern: "\\d*"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    I,
                    {
                      ...K("number.second", {
                        required: Tl.number.required,
                        minLength: Tl.number.minLength,
                        onChange: (ve) => Se(ve, "number.third")
                      }),
                      placeholder: "0000",
                      type: "number",
                      textSecurity: "disc",
                      pattern: "\\d*"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    I,
                    {
                      ...K("number.third", {
                        required: Tl.number.required,
                        minLength: Tl.number.minLength,
                        onChange: (ve) => Se(ve, "number.fourth")
                      }),
                      placeholder: "0000",
                      type: "number",
                      textSecurity: "disc",
                      pattern: "\\d*"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    I,
                    {
                      ...K("number.fourth", {
                        required: Tl.number.required,
                        minLength: Tl.number.minLength,
                        onChange: (ve) => Se(ve, "expiry")
                      }),
                      placeholder: "0000",
                      type: "number",
                      pattern: "\\d*"
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "flex flex-col",
                D ? "gap-[0.57143rem]" : "gap-[0.28571rem]"
              ),
              children: [
                /* @__PURE__ */ a.jsx(
                  "h3",
                  {
                    className: D ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                    children: "유효 기간"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  I,
                  {
                    ...K("expiry", {
                      required: Tl.expiry.required,
                      minLength: Tl.expiry.minLength,
                      onChange: oe
                    }),
                    placeholder: "MMYY",
                    type: "number",
                    pattern: "\\d*",
                    maxLength: Tl.expiry.maxLength
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "flex flex-col",
                D ? "gap-[0.57143rem]" : "gap-[0.28571rem]"
              ),
              children: [
                /* @__PURE__ */ a.jsx(
                  "h3",
                  {
                    className: D ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                    children: "비밀 번호"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  I,
                  {
                    ...K("password", {
                      required: Tl.password.required,
                      minLength: Tl.password.minLength,
                      onChange: ue
                    }),
                    placeholder: "비밀번호 앞 2자리를 입력해 주세요.",
                    type: "number",
                    textSecurity: "disc",
                    pattern: "\\d*",
                    maxLength: Tl.password.maxLength
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "flex flex-col",
                D ? "gap-[0.57143rem]" : "gap-[0.28571rem]"
              ),
              children: [
                /* @__PURE__ */ a.jsx(
                  "h3",
                  {
                    className: D ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                    children: "생년 월일"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  I,
                  {
                    ...K("birthday", {
                      required: Tl.birthday.required,
                      minLength: Tl.birthday.minLength,
                      onChange: he
                    }),
                    placeholder: "YYMMDD",
                    type: "number",
                    pattern: "\\d*",
                    maxLength: Tl.birthday.maxLength
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "flex items-center border-b border-mshop-gray-20 pb-[0.85714rem]", children: /* @__PURE__ */ a.jsxs(Bd, { className: "group flex items-center gap-[.57143rem]", children: [
              /* @__PURE__ */ a.jsx(
                Z0,
                {
                  ref: X,
                  checked: o && u && y && (t ? w : !0),
                  onChange: (ve) => {
                    c(ve), m(ve), b(ve), k(ve);
                  }
                }
              ),
              /* @__PURE__ */ a.jsx(_c, { className: "flex cursor-pointer", children: /* @__PURE__ */ a.jsx(
                "span",
                {
                  className: $(
                    "whitespace-pre",
                    D ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b"
                  ),
                  children: "전체 동의"
                }
              ) })
            ] }) }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ a.jsxs(Bd, { className: "group flex items-center gap-[.57143rem]", children: [
                /* @__PURE__ */ a.jsx(
                  Z0,
                  {
                    checked: o,
                    onChange: (ve) => c(ve)
                  }
                ),
                /* @__PURE__ */ a.jsx(_c, { className: "flex cursor-pointer", children: /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $(
                      "whitespace-pre",
                      D ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-m"
                    ),
                    children: "KG이니시스 전자금융거래 이용약관"
                  }
                ) })
              ] }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: $(
                    "text-mshop-gray-80 underline underline-offset-2",
                    D ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-r"
                  ),
                  onClick: s,
                  children: "보기"
                }
              )
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ a.jsxs(Bd, { className: "group flex items-center gap-[.57143rem]", children: [
                /* @__PURE__ */ a.jsx(
                  Z0,
                  {
                    checked: u,
                    onChange: (ve) => m(ve)
                  }
                ),
                /* @__PURE__ */ a.jsx(_c, { className: "flex cursor-pointer", children: /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $(
                      "whitespace-pre",
                      D ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-m"
                    ),
                    children: "개인정보의 수집 및 이용안내"
                  }
                ) })
              ] }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: $(
                    "text-mshop-gray-80 underline underline-offset-2",
                    D ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-r"
                  ),
                  onClick: r,
                  children: "보기"
                }
              )
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ a.jsxs(Bd, { className: "group flex items-center gap-[.57143rem]", children: [
                /* @__PURE__ */ a.jsx(
                  Z0,
                  {
                    checked: y,
                    onChange: (ve) => b(ve)
                  }
                ),
                /* @__PURE__ */ a.jsx(_c, { className: "flex cursor-pointer", children: /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $(
                      "whitespace-pre",
                      D ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-m"
                    ),
                    children: "개인정보 제공 및 위탁안내"
                  }
                ) })
              ] }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: $(
                    "text-mshop-gray-80 underline underline-offset-2",
                    D ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-r"
                  ),
                  onClick: n,
                  children: "보기"
                }
              )
            ] }),
            t && /* @__PURE__ */ a.jsx("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ a.jsxs(
              Bd,
              {
                className: $(
                  "group flex gap-[.57143rem]",
                  D ? "items-start" : "items-center"
                ),
                children: [
                  D ? /* @__PURE__ */ a.jsx("span", { className: "py-[0.21rem]", children: /* @__PURE__ */ a.jsx(
                    Z0,
                    {
                      checked: w,
                      onChange: k
                    }
                  ) }) : /* @__PURE__ */ a.jsx(
                    Z0,
                    {
                      checked: w,
                      onChange: k
                    }
                  ),
                  /* @__PURE__ */ a.jsx(_c, { className: "flex cursor-pointer", children: /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "whitespace-pre-wrap",
                        D ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-m"
                      ),
                      children: "해당 결제 수단과 연결된 서비스가 있을 경우 함께 적용됩니다."
                    }
                  ) })
                ]
              }
            ) })
          ] }),
          j && /* @__PURE__ */ a.jsx(
            "p",
            {
              ref: se,
              className: "typo-mshop-kr-14-m text-mshop-red-80",
              children: j
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(
      "footer",
      {
        className: $(
          "flex border-t border-mshop-gray-5",
          D ? "p-[1.14285rem]" : "px-[2.28571rem] py-[1.14285rem]"
        ),
        children: /* @__PURE__ */ a.jsx(
          R,
          {
            variant: "lg",
            theme: "blue",
            disabled: fe,
            widthFull: !0,
            type: "submit",
            onClick: q(ce),
            children: t ? "변경하기" : "등록하기"
          }
        )
      }
    )
  ] });
}
function Z8({
  show: e = !0,
  registeredPayMethod: t,
  onClickPersonalInfoOutsourcing: n,
  onClickThirdPartyConsent: r,
  onClickInicisTerms: s,
  onClose: o,
  onRegister: c,
  isMobile: u = !1,
  disabled: m = !1,
  onAfterLeave: y,
  transition: b
}) {
  return /* @__PURE__ */ a.jsxs(
    dh,
    {
      show: e,
      variant: "TYPE02",
      onClose: o,
      transition: b,
      afterLeave: y,
      children: [
        u ? /* @__PURE__ */ a.jsx(
          p5,
          {
            title: `결제 수단 ${t ? "변경" : "등록"}`,
            onClose: o,
            disabled: m
          }
        ) : /* @__PURE__ */ a.jsx(
          D1,
          {
            titleAlign: "Left",
            back: !1,
            close: !0,
            label: `결제 수단 ${t ? "변경" : "등록"}`,
            onCloseButtonClick: o
          }
        ),
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $(
              "flex flex-col",
              u ? "h-full overflow-hidden" : "h-[47.42857rem]"
            ),
            children: /* @__PURE__ */ a.jsx(
              Fve,
              {
                onRegister: c,
                registeredPayMethod: t,
                onClickPersonalInfoOutsourcing: n,
                onClickThirdPartyConsent: r,
                onClickInicisTerms: s
              }
            )
          }
        )
      ]
    }
  );
}
function Uve({ show: e, ...t }) {
  const {
    widgetCore: { isMobile: n }
  } = Gt(), { setNextTabIndex: r } = ZW(), s = () => {
    if (t.type === "MyPage")
      t.onMySupportMessageButtonClick();
    else if (t.type === "SupportGuide")
      r(1), t.onClose();
    else
      throw new Error("Unexpected type");
  };
  return /* @__PURE__ */ a.jsx(dh, { show: e, onClose: t.onClose, variant: "TYPE02", children: t.thankImage && t.thankDescription && /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "flex-center flex w-full flex-col overflow-hidden text-mshop-black",
        n ? "h-full" : "max-h-[51.42857rem]"
      ),
      children: [
        n ? /* @__PURE__ */ a.jsx(p5, { title: "후원 완료", onClose: t.onClose }) : /* @__PURE__ */ a.jsx(
          D1,
          {
            titleAlign: "Left",
            back: !1,
            close: !0,
            label: "후원 완료",
            onCloseButtonClick: t.onClose
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "section",
          {
            className: $(
              "flex w-full flex-1 flex-col overflow-y-auto",
              n ? "gap-y-[1.71429rem] p-[1.14286rem]" : "items-center gap-y-[2.28571rem] px-[2.28571rem] pb-[2.28571rem] pt-[1.14286rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "isolate flex-shrink-0 overflow-hidden rounded-[1.30611rem]",
                    {
                      "size-[24.57142rem]": !n
                    },
                    {
                      "aspect-square w-full": n
                    }
                  ),
                  children: /* @__PURE__ */ a.jsx(
                    "img",
                    {
                      src: t.thankImage.url,
                      className: $("h-full w-full object-cover"),
                      alt: ""
                    }
                  )
                }
              ),
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    "flex flex-col self-stretch",
                    n ? "gap-[1.71429rem]" : "gap-[1.14286rem]"
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-20-b text-center", children: "크리에이터의 감사 인사가 도착했어요!" }),
                    /* @__PURE__ */ a.jsx(
                      "p",
                      {
                        className: $(
                          "typo-mshop-kr-14-m w-full whitespace-pre-wrap break-words",
                          {
                            "rounded-[.48979rem] border border-mshop-gray-10 p-[1.14285rem]": !n
                          }
                        ),
                        children: t.thankDescription
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "section",
          {
            className: $(
              "flex w-full items-center border-t border-mshop-gray-5",
              n ? "gap-[1.14285rem] p-[1.14285rem]" : "gap-[0.85714rem] px-[2.28571rem] py-[1.14285rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "lg",
                  theme: "line",
                  widthFull: !0,
                  type: "button",
                  onClick: t.onSeeSupportDetailButtonClick,
                  children: "후원 내역 상세보기"
                }
              ),
              /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "lg",
                  theme: "blue",
                  widthFull: !0,
                  type: "button",
                  onClick: s,
                  children: "내 후원 메세지"
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}
const zve = ["png", "jpg", "jpeg", "gif"], zz = 6;
function qD(e) {
  const {
    supportId: t,
    thankDescription: n,
    thankImage: r,
    shop: s,
    supportThanksMessageModalType: o,
    show: c = !0,
    onClose: u,
    onSeeSupportDetailButtonClick: m,
    onSuccess: y,
    onIntegratedPaidServiceTermsTextClick: b,
    onClickPersonalInfoOutsourcing: w,
    onClickThirdPartyConsent: k,
    onClickInicisTerms: j
  } = e, { client: E } = Ha(), {
    widgetCore: { toggleSpinner: T, onError: D, isMobile: L }
  } = Gt(), { payMethod: I, setPayMethod: R } = xw(), { isDevMode: U } = f6(), { me: z } = by(), {
    isUploading: H,
    uploadedImages: K,
    ref: q,
    handleClickUploadImage: Q,
    handleRemoveUploadedImage: Z,
    handleChangeFileInput: X,
    handleValidateImageFiles: se,
    handleResetUploadedImage: te
  } = hA({ maxUploadCount: zz }), fe = dn(
    () => ({
      0: U ? m1.P100 : m1.P1000,
      10: m1.P2000,
      20: m1.P3000,
      30: m1.P5000,
      40: m1.P10000,
      50: m1.P20000,
      60: m1.P30000,
      70: m1.P50000,
      80: m1.P100000,
      90: m1.P300000,
      100: m1.P500000
    }),
    [U]
  ), [ce, pe] = Re(fe[0]), [Se, oe] = Re(0), [ue, he] = Re(!1), [ve, Te] = Re(""), [Ie, Ue] = Re(!1), [qe, it] = Re(null), [Ne, Xe] = Re(""), [xt, rn] = Re(0), vt = Rt(null), At = () => {
    if (Se < 2)
      return u();
    oe(Se - 1);
  }, He = (tt) => {
    po.flushSync(() => it(tt)), wt(vt.current), vt.current.scrollIntoView(!0);
  }, Pt = async () => {
    if (wt(t), !I)
      return;
    Ue(!0), T(!0);
    const { code: tt, data: ot } = await bye(
      {
        supportId: t,
        currency: V2.Krw,
        imageUrls: K,
        message: ve,
        price: ce,
        payMethodId: I.id,
        username: Ne
      },
      {
        client: E,
        onError: D
      }
    );
    if (tt !== le.Success)
      switch (Ue(!1), T(!1), tt) {
        case le.NotRegisteredPayment:
          return He(
            "유효하지 않은 결제 수단입니다. 결제 수단을 확인해 주세요."
          );
        case le.InvalidPaymentTarget:
          return await en({
            body: (ut) => /* @__PURE__ */ a.jsx(
              ea,
              {
                button: {
                  props: ut
                },
                children: /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex-col gap-y-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                    "해당 후원의 상태나 정보가 변경되었습니다.",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "후원 가능 여부 또는 변경된 정보를 확인 후",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "다시 시도해 주세요."
                  ] })
                ] })
              }
            )
          }), window.location.reload();
        case le.TokenExpired:
          return D(Ht);
        case le.FailedPayment:
          return ot.column === fA.InsufficientBalance ? He(
            "계좌 잔액이 부족합니다. 확인 후 다시 시도해 주세요."
          ) : He("결제수단 확인 후 다시 시도해 주세요.");
        default:
          return He(
            /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              "예기치 못한 오류로 인해 진행할 수 없습니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "동일한 문제가 반복적으로 발생할 경우",
              " ",
              /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
              "로 문의해 주세요."
            ] })
          );
      }
    return (ot == null ? void 0 : ot.portone) === null ? (y == null || y(), oe(4)) : pA({
      merchantUid: ot.portone.merchantUid,
      onPaid: () => {
        y == null || y(), oe(4), Ue(!1), T(!1);
      },
      onFailed: () => {
        He(
          /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
            "예기치 못한 오류로 인해 진행할 수 없습니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "동일한 문제가 반복적으로 발생할 경우",
            " ",
            /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
            "로 문의해 주세요."
          ] })
        ), Ue(!1), T(!1);
      },
      onCanceled: () => {
        T(!1), He(
          /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
            "결제에 실패 했습니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "나중에 다시 시도해 주세요."
          ] })
        );
      },
      onError: D,
      client: E
    });
  }, Lt = Rt(!1), er = async () => {
    const tt = await g6({
      client: E,
      onError: D
    });
    if (tt.code === le.TokenExpired)
      return D(Ht);
    R(tt.data), Lt.current = !0;
  }, It = K.length, ye = L ? WD : $2, ke = () => {
    pe(fe[0]), oe(0), he(!1), Te(""), Ue(!1), it(null), te();
  };
  an(() => {
    Xe((z == null ? void 0 : z.username) ?? "");
  }, [c]);
  const Pe = dn(() => xt == 0 ? 8 : xt == 100 ? -8 : "", [xt]);
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(
      dh,
      {
        show: c,
        onClose: Se == 0 ? At : Gd,
        variant: "TYPE02",
        beforeLeave: Se == 0 ? ke : Gd,
        children: /* @__PURE__ */ a.jsx(
          "div",
          {
            id: "support-guide-form-modal",
            className: $("overflow-hidden", { "h-full": L }),
            children: /* @__PURE__ */ a.jsxs(
              "section",
              {
                className: $(
                  "flex-center flex h-full w-full flex-col text-mshop-black",
                  { "max-h-[51.42857rem]": !L }
                ),
                children: [
                  L ? /* @__PURE__ */ a.jsx(
                    p5,
                    {
                      title: L ? "크리에이터 후원하기" : `${Ef(s)} 후원하기`,
                      onClose: At,
                      disabled: Ie
                    }
                  ) : /* @__PURE__ */ a.jsx(
                    D1,
                    {
                      titleAlign: "Left",
                      back: !1,
                      close: !0,
                      label: L ? "크리에이터 후원하기" : `${Ef(s)} 후원하기`,
                      isCloseButtonDisabled: Ie,
                      onCloseButtonClick: At
                    }
                  ),
                  /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: $(
                        "flex w-full flex-col gap-y-[2.28571rem] overflow-y-auto",
                        {
                          "sr-only absolute -z-[2.85714rem] opacity-0": Se !== 0
                        },
                        L ? "flex-grow p-[1.14285rem]" : "max-h-[39.42857rem] px-[2.28571rem] pb-[2.28571rem] pt-[1.14286rem]"
                      ),
                      tabIndex: Se !== 0 ? -1 : void 0,
                      children: [
                        /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $("flex flex-col", {
                              "gap-[0.28571rem]": !L
                            }),
                            children: [
                              /* @__PURE__ */ a.jsxs("h2", { className: "flex gap-x-[.28571rem]", children: [
                                /* @__PURE__ */ a.jsx(
                                  "span",
                                  {
                                    className: L ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                                    children: "후원 금액 설정"
                                  }
                                ),
                                /* @__PURE__ */ a.jsx("span", { className: "mt-[.28571rem]", children: /* @__PURE__ */ a.jsx(w3, {}) })
                              ] }),
                              /* @__PURE__ */ a.jsxs("div", { className: "mt-[.57143rem] flex flex-col gap-y-[.57143rem]", children: [
                                /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-20-unica-b py-[.28571rem] text-mshop-blue-100", children: [
                                  ce.toLocaleString(cr.Ko),
                                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b", children: "원" })
                                ] }),
                                /* @__PURE__ */ a.jsx(
                                  sY,
                                  {
                                    step: 10,
                                    dots: !0,
                                    onChange: (tt) => {
                                      typeof tt == "number" && (rn(tt), pe(fe[tt]));
                                    },
                                    styles: {
                                      // default style
                                      rail: {
                                        backgroundColor: "#ebf3fe",
                                        height: 8
                                      },
                                      // active style
                                      track: {
                                        backgroundColor: "#1C75FF",
                                        height: 8
                                      },
                                      handle: {
                                        backgroundColor: "#1C75FF",
                                        borderWidth: 0,
                                        opacity: 1,
                                        width: 16,
                                        height: 16,
                                        marginLeft: Pe
                                      }
                                    },
                                    activeDotStyle: {
                                      borderWidth: 0,
                                      width: 0,
                                      height: 0
                                    },
                                    dotStyle: {
                                      borderWidth: 0,
                                      width: 2,
                                      height: 8,
                                      backgroundColor: "#fff"
                                    }
                                  }
                                ),
                                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
                                  /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-50", children: [
                                    "1,000",
                                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "원" })
                                  ] }),
                                  /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-50", children: [
                                    "500,000",
                                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "원" })
                                  ] })
                                ] })
                              ] })
                            ]
                          }
                        ),
                        /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $("flex flex-col", {
                              "gap-[0.28571rem]": !L
                            }),
                            children: [
                              /* @__PURE__ */ a.jsx(
                                "h2",
                                {
                                  className: L ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                                  children: "후원 메세지 작성"
                                }
                              ),
                              /* @__PURE__ */ a.jsx(
                                YE,
                                {
                                  className: "typo-mshop-kr-14-m my-[.85714rem] min-h-[4.71428rem] w-full resize-none rounded-none border-b border-mshop-gray-10 outline-0 scrollbar-hide",
                                  style: { outline: "none" },
                                  minRows: L ? 6 : 3,
                                  maxRows: L ? 6 : 13,
                                  placeholder: "크리에이터에게 당신의 마음을 전해 보세요!",
                                  onChange: (tt) => {
                                    tt.target.value.length >= 5e3 && (tt.target.value = tt.target.value.slice(0, 5e3)), Te(tt.target.value);
                                  }
                                }
                              ),
                              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: "크리에이터와 무관하거나 서비스 운영정책에 위배되는 메시지는 사전 고지 없이 삭제될 수 있으며, 해당 회원에게 별도의 제재가 적용될 수 있습니다." })
                            ]
                          }
                        ),
                        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                          /* @__PURE__ */ a.jsxs(
                            "h2",
                            {
                              className: $(
                                "flex items-center gap-x-[.57143rem]",
                                L ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b"
                              ),
                              children: [
                                "이미지 첨부",
                                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: "최대 6장까지 첨부 가능합니다." })
                              ]
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            "div",
                            {
                              className: $(
                                "flex items-center gap-[.57143rem] py-[.57143rem]",
                                { "flex-wrap": L }
                              ),
                              children: [
                                K.map((tt, ot) => /* @__PURE__ */ a.jsxs(
                                  "div",
                                  {
                                    className: "relative aspect-square w-[4.28571rem] overflow-hidden rounded-[.65305rem]",
                                    children: [
                                      /* @__PURE__ */ a.jsx("img", { src: tt, className: "h-full w-full", alt: "" }),
                                      /* @__PURE__ */ a.jsx(
                                        "button",
                                        {
                                          type: "button",
                                          className: "absolute right-0 top-0 rounded-[.65305rem] bg-mshop-black p-[.28571rem]",
                                          onClick: Z(ot),
                                          children: /* @__PURE__ */ a.jsx(Zg, { className: "size-[.85714rem] text-mshop-white" })
                                        }
                                      )
                                    ]
                                  },
                                  ot
                                )),
                                It !== zz && /* @__PURE__ */ a.jsxs("div", { children: [
                                  /* @__PURE__ */ a.jsx(
                                    "button",
                                    {
                                      type: "button",
                                      onClick: Q,
                                      className: "flex aspect-square w-[4.28571em] items-center justify-center rounded-[.48979rem]",
                                      disabled: H,
                                      children: /* @__PURE__ */ a.jsx(dA, { className: "h-full w-full text-mshop-gray-20" })
                                    }
                                  ),
                                  /* @__PURE__ */ a.jsx(
                                    "input",
                                    {
                                      ref: q,
                                      type: "file",
                                      className: "sr-only",
                                      multiple: !0,
                                      onChange: async (tt) => {
                                        const ot = tt.target.files;
                                        wt(ot), await se(ot, {
                                          imageFormats: zve
                                        }) === Wg.Success && await X({ files: ot });
                                      },
                                      accept: "image/jpeg, image/png, image/gif, image/jpg"
                                    }
                                  )
                                ] })
                              ]
                            }
                          )
                        ] }),
                        /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $(
                              "flex flex-col",
                              L ? "gap-y-[0.571rem]" : "gap-[0.28571rem]"
                            ),
                            children: [
                              /* @__PURE__ */ a.jsxs("h2", { className: "flex gap-x-[.28571rem]", children: [
                                /* @__PURE__ */ a.jsx(
                                  "span",
                                  {
                                    className: L ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                                    children: "이름"
                                  }
                                ),
                                /* @__PURE__ */ a.jsx("span", { className: "mt-[.28571rem]", children: /* @__PURE__ */ a.jsx(w3, {}) })
                              ] }),
                              /* @__PURE__ */ a.jsx(
                                A8,
                                {
                                  type: "text",
                                  placeholder: "이름을 입력해 주세요.",
                                  value: Ne,
                                  onChange: (tt) => {
                                    Xe(tt.target.value);
                                  }
                                }
                              )
                            ]
                          }
                        ),
                        L && /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between text-mshop-black", children: [
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총 결제 금액" }),
                          /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-20-b", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-20-unica-b", children: ce.toLocaleString(cr.Ko) }),
                            "원"
                          ] })
                        ] })
                      ]
                    }
                  ),
                  /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: $(
                        "flex w-full flex-col overflow-y-auto",
                        {
                          "sr-only absolute -z-[2.85714rem] opacity-0": Se < 1
                        },
                        L ? "flex-grow gap-y-[2.28571rem] p-[1.14285rem]" : "max-h-[39.42857rem] gap-y-[2.28571rem] px-[2.28571rem] pb-[2.28571rem] pt-[1.14286rem]"
                      ),
                      tabIndex: Se !== 1 ? -1 : void 0,
                      children: [
                        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                          /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b mb-[.57143rem]", children: "결제 금액" }),
                          /* @__PURE__ */ a.jsx("div", { className: "mt-[.57143rem] flex h-[3.428rem] w-full select-none items-center rounded-[.57142rem] bg-mshop-gray-5 px-[1.14285rem] text-mshop-blue-100", children: /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.1rem]", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m -mt-[0.28571rem]", children: ce.toLocaleString(cr.Ko) }),
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m", children: "원" })
                          ] }) })
                        ] }),
                        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                          /* @__PURE__ */ a.jsxs("div", { className: "mb-[.57143rem] flex justify-between", children: [
                            /* @__PURE__ */ a.jsx(
                              "span",
                              {
                                className: $(
                                  "text-mshop-black",
                                  L ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b"
                                ),
                                children: "결제 수단"
                              }
                            ),
                            I && /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                className: "typo-mshop-kr-14-m text-mshop-blue-100",
                                onClick: () => {
                                  oe(2);
                                },
                                type: "button",
                                children: "결제 수단 변경"
                              }
                            )
                          ] }),
                          I ? /* @__PURE__ */ a.jsx(
                            ye,
                            {
                              variant: "creditCard",
                              paymentMethod: I
                            }
                          ) : /* @__PURE__ */ a.jsx(
                            ye,
                            {
                              onAddClick: () => oe(2),
                              variant: "add"
                            }
                          )
                        ] }),
                        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
                          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.28571rem] rounded-[0.57143rem] bg-mshop-gray-5 p-[1.14286rem]", children: [
                            /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.42857rem]", children: [
                              /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.21429rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.14286rem] rounded-full bg-mshop-gray-80" }) }),
                              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-12-m text-mshop-gray-80", children: [
                                "후원하기 서비스를 이용하기 전에",
                                " ",
                                /* @__PURE__ */ a.jsx(
                                  "button",
                                  {
                                    type: "button",
                                    onClick: b,
                                    className: "typo-mshop-kr-12-m underline underline-offset-2",
                                    children: "이용약관"
                                  }
                                ),
                                "을 확인해주세요."
                              ] })
                            ] }),
                            /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.42857rem]", children: [
                              /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.21429rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.14286rem] rounded-full bg-mshop-gray-80" }) }),
                              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-gray-80", children: "후원은 후원자의 자발적인 선택에 의해 이루어지며, 완료된 후에는 취소나 환불이 불가능합니다. 법률상 의무가 요구되는 경우를 제외하고, 환불이 이루어지지 않음을 안내드립니다." })
                            ] }),
                            /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.42857rem]", children: [
                              /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.21429rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.14286rem] rounded-full bg-mshop-gray-80" }) }),
                              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-gray-80", children: "후원금은 크리에이터가 명시한 창작 활동이나 목적에 사용되며, 그 사용 방식이나 결과에 대한 책임은 크리에이터에게 있습니다. 회사는 후원금 사용에 대해 관여하거나 보증하지 않습니다." })
                            ] }),
                            /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.42857rem]", children: [
                              /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.21429rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.14286rem] rounded-full bg-mshop-gray-80" }) }),
                              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-gray-80", children: "후원은 크리에이터의 창작 활동 지원을 목적으로 하며, 불법적 사용이나 비정상적 목적으로의 후원은 엄격히 금지됩니다." })
                            ] })
                          ] }),
                          /* @__PURE__ */ a.jsxs(
                            Bd,
                            {
                              className: $(
                                "group flex flex-row gap-x-[.57143rem]",
                                L ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-m items-center"
                              ),
                              children: [
                                /* @__PURE__ */ a.jsx(
                                  Z0,
                                  {
                                    onChange: (tt) => {
                                      he(tt);
                                    },
                                    marginTop: L ? "0.25714rem" : ""
                                  }
                                ),
                                /* @__PURE__ */ a.jsxs(_c, { className: "typo-mshop-kr-14-m cursor-pointer", children: [
                                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "(필수)" }),
                                  " 주문 내용 및 위의 내용을 모두 확인하였으며, 결제에 동의합니다."
                                ] })
                              ]
                            }
                          )
                        ] }),
                        qe && /* @__PURE__ */ a.jsx(
                          "div",
                          {
                            ref: vt,
                            className: "typo-mshop-kr-14-m text-mshop-red-80",
                            children: qe
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: $(
                        "flex w-full items-center justify-between",
                        {
                          "border-t border-mshop-gray-5 px-[2.28571rem] py-[1.14285rem]": !L
                        },
                        { "p-[1.14285rem]": L }
                      ),
                      children: [
                        Se === 0 && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                          !L && /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[.57143rem]", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "총 결제 금액" }),
                            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-20-b", children: [
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-20-unica-b", children: ce.toLocaleString(cr.Ko) }),
                              "원"
                            ] })
                          ] }),
                          /* @__PURE__ */ a.jsx(
                            fn,
                            {
                              variant: "lg",
                              theme: "blue",
                              disabled: H || Ne.trim() === "",
                              type: "button",
                              widthFull: L,
                              onClick: () => {
                                oe(1);
                              },
                              onMouseEnter: async () => {
                                Lt.current || await er();
                              },
                              children: "결제 방법 선택"
                            }
                          )
                        ] }),
                        Se === 1 && /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $(
                              "flex w-full items-center",
                              L ? "gap-[1.14285rem]" : "gap-[0.85714rem]"
                            ),
                            children: [
                              /* @__PURE__ */ a.jsx("div", { className: "w-[11.42857rem]", children: /* @__PURE__ */ a.jsx(
                                fn,
                                {
                                  variant: "lg",
                                  theme: "line",
                                  widthFull: !0,
                                  type: "button",
                                  onClick: () => {
                                    oe(0);
                                  },
                                  children: "이전"
                                }
                              ) }),
                              /* @__PURE__ */ a.jsx(
                                fn,
                                {
                                  variant: "lg",
                                  theme: "blue",
                                  disabled: !ue || I == null || Ie,
                                  widthFull: !0,
                                  type: "button",
                                  onClick: Pt,
                                  children: "결제하기"
                                }
                              )
                            ]
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ a.jsx(
      Z8,
      {
        show: c && Se === 2,
        registeredPayMethod: I,
        onClose: At,
        onRegister: (tt) => {
          oe(1), R(tt);
        },
        isMobile: L,
        disabled: Ie,
        onClickPersonalInfoOutsourcing: w,
        onClickThirdPartyConsent: k,
        onClickInicisTerms: j
      }
    ),
    /* @__PURE__ */ a.jsx(
      Uve,
      {
        show: c && Se == 4,
        ...o === "MyPage" ? {
          type: "MyPage",
          onMySupportMessageButtonClick: e.onMySupportMessageButtonClick
        } : {
          type: "SupportGuide"
        },
        thankImage: r,
        thankDescription: n,
        onClose: u,
        onSeeSupportDetailButtonClick: m
      }
    )
  ] });
}
function Xu(e) {
  var t;
  return e == null ? null : ((t = e.shop) == null ? void 0 : t.profileImageUrl) ?? e.imageUrl;
}
const Bve = {
  new: "New",
  best: "Best",
  soldOut: "Sold out",
  closed: "Closed"
};
function Hve({ variant: e }) {
  return /* @__PURE__ */ a.jsx(
    "span",
    {
      className: $(
        "typo-mshop-en-12-unica-r inline-flex items-start rounded-[0.28571rem] px-[0.28571rem] pb-[0.14286rem] pt-[0.07143rem] backdrop-blur-[5px]",
        {
          "bg-mshop-white text-mshop-blue-100": e === "new",
          "bg-mshop-black text-mshop-white": e === "best",
          "bg-mshop-gray-50 text-mshop-white": e === "soldOut" || e === "closed"
        }
      ),
      children: Bve[e]
    }
  );
}
const Vve = {
  new: "New",
  best: "Best",
  soldOut: "Sold out",
  closed: "Closed"
};
function $ve({ variant: e }) {
  return /* @__PURE__ */ a.jsx(
    "span",
    {
      className: $(
        "typo-mshop-en-14-unica-r inline-flex items-start rounded-[.28571rem] px-[.57143rem] pb-[.35428rem] pt-[.28571rem] backdrop-blur-[5px]",
        {
          "bg-mshop-white text-mshop-blue-100": e === "new",
          "bg-mshop-black text-mshop-white": e === "best",
          "bg-mshop-gray-50 text-mshop-white": e === "soldOut" || e === "closed"
        }
      ),
      children: Vve[e]
    }
  );
}
const Gve = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { width: 12, height: 6, viewBox: "0 0 12 6", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { id: "Target", d: "M6.8 0.327273L12 6H0L5.2 0.327273C5.6 -0.109091 6.4 -0.109091 6.8 0.327273Z" })), Wve = yn(Gve);
function Bz({ arrowPosition: e = "bottom", children: t }) {
  return /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m relative inline-flex min-h-[2.57142rem] flex-grow items-center justify-center rounded-full bg-mshop-blue-10 px-[1.14285rem] text-mshop-blue-100", children: [
    t,
    /* @__PURE__ */ a.jsx(
      Wve,
      {
        className: $(
          "absolute left-1/2 h-[.42857rem] w-[.85714rem] -translate-x-1/2 text-mshop-blue-10",
          e === "top" ? "-top-[.42857rem]" : "-bottom-[.42857rem] -rotate-180"
        )
      }
    )
  ] });
}
const Yve = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { width: 800, height: 800, viewBox: "0 0 800 800", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_3521_216308)" }, /* @__PURE__ */ re.createElement("rect", { width: 800, height: 800, fill: "#F6F6F6" }), /* @__PURE__ */ re.createElement("circle", { cx: 400, cy: 280, r: 120, fill: "#D8D8D8" }), /* @__PURE__ */ re.createElement("circle", { cx: 400, cy: 800, r: 340, fill: "#D8D8D8" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_3521_216308" }, /* @__PURE__ */ re.createElement("rect", { width: 800, height: 800, fill: "white" })))), qve = yn(Yve);
function Ql({ imageUrl: e }) {
  return e ? /* @__PURE__ */ a.jsx(
    "img",
    {
      src: e,
      className: "aspect-square h-full w-full rounded-full",
      alt: ""
    }
  ) : /* @__PURE__ */ a.jsx(qve, { className: "aspect-square h-full w-full rounded-full" });
}
const Hz = 5;
function fY({
  profileImageUrls: e,
  count: t,
  size: n,
  theme: r,
  variant: s
}) {
  return /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center gap-[.57143rem]", children: [
    /* @__PURE__ */ a.jsx("div", { className: "flex", children: e.slice(0, Hz).map((o, c) => /* @__PURE__ */ a.jsx(
      "div",
      {
        className: $(
          "relative rounded-full",
          {
            "size-[2.28571rem]": n === "medium",
            "size-[3.42857rem]": n === "large"
          },
          {
            "-ml-[.85714rem]": c !== 0 && n === "medium",
            "-ml-[1.14285rem]": c !== 0 && n === "large"
          }
        ),
        style: {
          zIndex: Hz - c
        },
        children: /* @__PURE__ */ a.jsx(Ql, { imageUrl: o })
      },
      c
    )) }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[.28571rem]", children: [
      /* @__PURE__ */ a.jsx(
        "div",
        {
          className: $("typo-mshop-en-14-unica-m", {
            "text-mshop-gray-50": r === "light",
            "text-mshop-gray-20": r === "dark"
          }),
          children: t.toLocaleString(cr.Ko)
        }
      ),
      /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: $("typo-mshop-kr-14-m", {
            "text-mshop-gray-50": r === "light",
            "text-mshop-gray-20": r === "dark"
          }),
          children: [
            s === "member" && "멤버",
            s === "supporter" && "명이 후원했어요."
          ]
        }
      )
    ] })
  ] });
}
var Kve = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_CHANNEL_KEY: "channel-key-e7694500-512d-450e-aedd-6f47dad28dd0", VITE_IMP_ACCOUNT_ID: "imp03882726", VITE_IMP_CHANNEL_KEY: "M3RpWnV1YjFWa3h5dXFyViszYjA5Zz09", VITE_IMP_STORE_ID: "MOImarshop", VITE_STORE_ID: "store-a1ec38af-8bea-4805-8cdb-17632e1ebfdf" };
const Xve = 88, Qve = 66;
function Zve({
  support: e,
  onToggleModal: t,
  onCreatorSupportButtonClick: n
}) {
  const {
    id: r,
    displayName: s,
    description: o,
    users: c,
    state: u,
    thumbnailImage: m,
    supportedUserTotalCount: y,
    isSupported: b,
    openedAt: w,
    closedAt: k
  } = e, j = Rt(null), [E, T] = Re("more"), [D, L] = Re(!1), { me: I } = by(), {
    widgetCore: { isApp: R, isMobile: U }
  } = Gt();
  a5(() => {
    const Q = j.current;
    if (Q) {
      const Z = Q.scrollHeight > (U ? Qve : Xve);
      L(Z), T(Z ? "more" : "less");
    }
  }, []);
  const z = y > 0, H = (() => {
    if (w && k) {
      const Q = jt(w, "yyyy.MM.dd"), Z = jt(k, "yyyy.MM.dd");
      return `${Q} ~ ${Z}`;
    }
    if (w)
      return `${jt(w, "yyyy.MM.dd")} ~ Current`;
    throw new Error("Does not exist openedAt and closedAt.");
  })(), K = () => {
    T((Q) => Q === "more" ? "less" : "more");
  }, q = (Q) => {
    if (Kve.STORYBOOK)
      return I == null ? en({
        body: (Z) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: Z
            },
            children: /* @__PURE__ */ a.jsx("div", { children: "로그인 해주세요 (개발 환경용 Alert)" })
          }
        )
      }) : t(Q);
    n(() => t(Q));
  };
  return /* @__PURE__ */ a.jsx(
    "section",
    {
      className: $(
        "relative flex gap-x-[3.429rem] rounded-[1.14286rem] border border-mshop-gray-10 p-[1.14286rem]",
        { "flex-col": U }
      ),
      children: U ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem]", children: [
        /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex gap-x-[1.14286rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "relative aspect-square h-full max-h-[6.85714rem] w-full max-w-[6.85714rem] flex-shrink-0 overflow-hidden rounded-[1.714rem]", children: [
              /* @__PURE__ */ a.jsx(
                "img",
                {
                  src: m.url,
                  className: "h-full w-full object-cover",
                  alt: ""
                }
              ),
              u === ni.Closed && /* @__PURE__ */ a.jsx("div", { className: "absolute inset-0 bg-mshop-gray-5 opacity-50" })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-grow flex-col gap-y-[0.28571rem]", children: [
              u === ni.Closed && /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx(Hve, { variant: "closed" }) }),
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-16-b text-mshop-black", children: s }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m block text-mshop-gray-50", children: H })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                D && E === "less" ? "h-full" : "h-[6.71429rem]"
              ),
              children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    ref: j,
                    className: $(
                      "typo-mshop-kr-14-m overflow-hidden whitespace-pre-wrap break-all text-mshop-gray-80",
                      D && E === "less" ? "h-full" : "line-clamp-3 h-[4.71429rem]"
                    ),
                    children: o
                  }
                ),
                D && /* @__PURE__ */ a.jsx(
                  "button",
                  {
                    type: "button",
                    className: "typo-mshop-kr-14-b mt-[0.57143rem] text-mshop-gray-50",
                    onClick: K,
                    children: E === "more" ? "후원 안내 더보기" : "후원 안내 접기"
                  }
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ a.jsx("div", { className: "w-full", children: /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $("ml-auto w-[11.42857rem]", {
              relative: b
            }),
            children: R && u !== ni.Closed ? /* @__PURE__ */ a.jsx(
              fn,
              {
                onClick: Gd,
                theme: "blue",
                variant: "md",
                type: "button",
                widthFull: !0,
                disabled: !0,
                children: "PC에서만 가능해요"
              }
            ) : /* @__PURE__ */ a.jsxs(
              fn,
              {
                onClick: () => q(r),
                theme: "blue",
                variant: "md",
                type: "button",
                widthFull: !0,
                disabled: u === ni.Closed,
                children: [
                  u === ni.Closed ? "종료된 후원이에요" : "크리에이터 후원하기",
                  b && u !== ni.Closed && /* @__PURE__ */ a.jsx(
                    "div",
                    {
                      className: $(
                        "absolute -top-[2.057rem] left-1/2 w-[9rem] -translate-x-1/2"
                      ),
                      children: /* @__PURE__ */ a.jsx(Bz, { arrowPosition: "bottom", children: "한 번 더 후원하기" })
                    }
                  )
                ]
              }
            )
          }
        ) })
      ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsxs("div", { className: "relative aspect-square h-full max-h-[28.571rem] w-full max-w-[28.571rem] flex-shrink-0 overflow-hidden rounded-[1.714rem]", children: [
          /* @__PURE__ */ a.jsx(
            "img",
            {
              src: m.url,
              className: "h-full w-full object-cover",
              alt: ""
            }
          ),
          u === ni.Closed && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
            /* @__PURE__ */ a.jsx("div", { className: "absolute inset-0 bg-mshop-gray-5 opacity-50" }),
            /* @__PURE__ */ a.jsx("div", { className: "absolute left-[1.143rem] top-[1.143rem] w-[4.286rem] select-none", children: /* @__PURE__ */ a.jsx($ve, { variant: "closed" }) })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col justify-between gap-y-[1.714rem] py-[1.143rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "text-mshop-black", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-28-b", children: s }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m mt-[0.571rem] block text-mshop-gray-80", children: H }),
            /* @__PURE__ */ a.jsxs("div", { className: "mt-[1.714rem] py-[0.571rem] pb-[1.714rem] pr-[3.429rem]", children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  ref: j,
                  className: $(
                    "typo-mshop-kr-14-m overflow-hidden whitespace-pre-wrap break-all",
                    E === "less" ? "max-h-full" : "line-clamp-4"
                  ),
                  children: o
                }
              ),
              D && /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: "typo-mshop-kr-14-b mt-[0.857rem] text-mshop-gray-50",
                  onClick: K,
                  children: E === "more" ? "후원 안내 더보기" : "후원 안내 접기"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "flex flex-wrap items-center",
                z ? "justify-between" : "justify-end"
              ),
              children: [
                z && /* @__PURE__ */ a.jsx("div", { className: "mt-[1.143rem] flex min-w-[14.857rem] items-center gap-x-[1.143rem]", children: /* @__PURE__ */ a.jsx("div", { className: "flex", children: /* @__PURE__ */ a.jsx(
                  fY,
                  {
                    profileImageUrls: c.map(
                      (Q) => Xu(Q)
                    ),
                    count: y,
                    size: "large",
                    theme: "light",
                    variant: "supporter"
                  }
                ) }) }),
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $("flex w-[14rem]", {
                      relative: b
                    }),
                    children: /* @__PURE__ */ a.jsxs(
                      fn,
                      {
                        onClick: () => q(r),
                        theme: "blue",
                        variant: "lg",
                        type: "button",
                        widthFull: !0,
                        disabled: u === ni.Closed,
                        children: [
                          u === ni.Closed ? "종료된 후원이에요" : "크리에이터 후원하기",
                          b && u !== ni.Closed && /* @__PURE__ */ a.jsx(
                            "div",
                            {
                              className: $(
                                "absolute -top-[2.057rem] left-1/2 w-[9rem] -translate-x-1/2"
                              ),
                              children: /* @__PURE__ */ a.jsx(Bz, { arrowPosition: "bottom", children: "한 번 더 후원하기" })
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              ]
            }
          )
        ] })
      ] })
    },
    r
  );
}
function Jve({
  onGoToExploreProductsButtonClick: e,
  onSeeSupportDetailButtonClick: t,
  onIntegratedPaidServiceTermsTextClick: n,
  onClickPersonalInfoOutsourcing: r,
  onClickThirdPartyConsent: s,
  onClickInicisTerms: o,
  onCreatorSupportButtonClick: c
}) {
  const { supports: u, getSupportById: m, setSupports: y } = lA();
  wt(u);
  const { projectId: b } = Tf(), { client: w } = Ha(), {
    widgetCore: { onError: k, isMobile: j }
  } = Gt(), [E, T] = Re(
    null
  ), D = (U) => {
    T(U);
  }, L = async () => {
    const U = await iA(
      {
        projectId: b
      },
      {
        client: w,
        onError: k
      }
    );
    if (U.code === le.TokenExpired)
      return k(Ht);
    y(U.data);
  }, I = u.items.length == 0, R = E ? m(E) : null;
  return /* @__PURE__ */ a.jsx("div", { id: "support-guide", children: I ? /* @__PURE__ */ a.jsx("div", { className: j ? "py-[11.429rem]" : "py-[8.57143rem]", children: j ? /* @__PURE__ */ a.jsx(
    p6,
    {
      description: `크리에이터가 후원을 준비하는 동안
마플샵에서 내 취향의 상품을 찾아볼까요?`,
      renderButton: /* @__PURE__ */ a.jsx(
        fn,
        {
          theme: "blue",
          type: "button",
          variant: "lg",
          widthFull: !0,
          onClick: e,
          children: "상품 구경하러 가기"
        }
      ),
      renderImage: /* @__PURE__ */ a.jsx("img", { alt: "", src: kt.KeyVisual.LoudSpeaker }),
      title: "후원 준비 중입니다."
    }
  ) : /* @__PURE__ */ a.jsx(
    f5,
    {
      description: `크리에이터가 후원을 준비하는 동안
마플샵에서 내 취향의 상품을 찾아볼까요?`,
      renderButton: /* @__PURE__ */ a.jsx(
        fn,
        {
          theme: "blue",
          type: "button",
          variant: "lg",
          widthFull: !0,
          onClick: e,
          children: "상품 구경하러 가기"
        }
      ),
      renderImage: /* @__PURE__ */ a.jsx("img", { alt: "", src: kt.KeyVisual.LoudSpeaker }),
      title: "후원 준비 중입니다."
    }
  ) }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: j ? "space-y-[1.14286rem] px-[1.14286rem] pb-[1.14286rem] pt-[1.71429rem]" : "w-full space-y-[1.714rem]",
        children: u.items.map((U) => /* @__PURE__ */ a.jsx(
          Zve,
          {
            support: U,
            onToggleModal: D,
            onCreatorSupportButtonClick: c
          },
          U.id
        ))
      }
    ),
    /* @__PURE__ */ a.jsx(
      qD,
      {
        show: !!R,
        supportId: (R == null ? void 0 : R.id) || null,
        thankDescription: (R == null ? void 0 : R.thankDescription) || null,
        thankImage: (R == null ? void 0 : R.thankImage) || null,
        shop: (R == null ? void 0 : R.shop) || null,
        supportThanksMessageModalType: "SupportGuide",
        onClose: () => D(null),
        onSeeSupportDetailButtonClick: () => {
          wt(R), t(R.id);
        },
        onIntegratedPaidServiceTermsTextClick: n,
        onClickPersonalInfoOutsourcing: r,
        onClickThirdPartyConsent: s,
        onClickInicisTerms: o,
        onSuccess: L
      }
    )
  ] }) });
}
const exe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M21.5327 7.26C20.6335 5.06 18.6552 4 16.6768 4C14.8783 4 13.0898 4.88 12.1106 6.58C12.0907 6.61 12.0707 6.65 12.0507 6.68C12.0307 6.71 12.0107 6.72 11.9808 6.72C11.9508 6.72 11.9308 6.71 11.9108 6.68C11.8908 6.65 11.8708 6.61 11.8509 6.58C10.8817 4.88 9.08319 4 7.2847 4C5.32634 4 3.348 5.06 2.44876 7.26C1.23977 10.22 2.65858 13.49 4.50703 15.86C8.22391 20.28 11.2514 21.71 11.8808 21.98C11.9608 22.01 12.0407 22.01 12.1206 21.98C12.7501 21.72 15.7676 20.29 19.4944 15.86C21.3329 13.49 22.7617 10.22 21.5527 7.26H21.5327Z" })), q9 = yn(exe), mY = {
  SupportMessage: "SUPPORT_MESSAGE"
}, Sy = {
  Create: "CREATE",
  Delete: "DELETE"
}, txe = async (e, t) => jn(
  "/create-reaction",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error("postCreateReaction");
  }
}), nxe = async (e, t) => jn(
  "/delete-reaction",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error("postDeleteReaction");
  }
}), hY = (e) => {
  const { client: t } = Ha(), {
    widgetCore: { onError: n }
  } = Gt();
  return {
    handleToggleReaction: async (s, o, c) => {
      const u = !o;
      if (o) {
        if (c(u), (await nxe(
          {
            id: s,
            type: e
          },
          {
            client: t,
            onError: n
          }
        )).code !== le.Success)
          return n(Ht);
      } else if (c(u), (await txe(
        {
          id: s,
          type: e
        },
        {
          client: t,
          onError: n
        }
      )).code !== le.Success)
        return n(Ht);
    }
  };
}, rxe = {
  Create: "CREATE",
  Delete: "DELETE",
  Kick: "KICK"
}, Mc = (e) => {
  var t;
  return e == null || e.state === Sy.Delete ? "비활성화된 계정" : ((t = e.shop) == null ? void 0 : t.name) ?? e.displayName;
}, axe = (e) => e.state === rxe.Delete ? "비활성화된 계정" : e.nickname, sxe = async (e, t) => jn(
  "/delete-support-message",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.NoDeleteItem:
      return n;
    default:
      throw new Error();
  }
});
function wy({ direction: e, background: t, ...n }) {
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...n,
      className: $("flex-center size-[2.85714rem] rounded-full", {
        "bg-mshop-bright-20 hover:bg-mshop-bright-5": t === "bright",
        "bg-mshop-dim-30 hover:bg-mshop-dim-60": t === "dim"
      }),
      children: /* @__PURE__ */ a.jsx(
        VO,
        {
          className: $("size-[1.42857rem] text-mshop-white", {
            "rotate-180": e === "left"
          })
        }
      )
    }
  );
}
function D3({
  children: e,
  confirmButton: t,
  cancelButton: n
}) {
  return /* @__PURE__ */ a.jsxs("div", { className: "flex-col-center w-[24.5rem] gap-y-[2.28571rem] rounded-[1.14286rem] bg-mshop-white px-[1.71428rem] py-[2.57143rem]", children: [
    /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m text-center text-mshop-gray-80", children: e }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.85714rem]", children: [
      /* @__PURE__ */ a.jsx(
        "button",
        {
          ...n.props,
          type: "button",
          className: "flex-center typo-mshop-kr-16-b h-[3.71429rem] w-full rounded-[0.57142rem] border border-mshop-gray-20 bg-mshop-white px-[1.71429rem] text-mshop-gray-80",
          children: n.text ?? "취소"
        }
      ),
      /* @__PURE__ */ a.jsx(
        "button",
        {
          ...t.props,
          type: "button",
          className: $(
            "flex-center typo-mshop-kr-16-b h-[3.71429rem] w-full rounded-[0.57142rem] bg-mshop-blue-100 px-[1.71429rem] text-mshop-white"
          ),
          children: t.text ?? "확인"
        }
      )
    ] })
  ] });
}
const ixe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M8 3.92188C8.55228 3.92188 9 3.47416 9 2.92188C9 2.36959 8.55228 1.92188 8 1.92188C7.44772 1.92188 7 2.36959 7 2.92188C7 3.47416 7.44772 3.92188 8 3.92188Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8 9.00187C8.55228 9.00187 9 8.55416 9 8.00187C9 7.44959 8.55228 7.00187 8 7.00187C7.44772 7.00187 7 7.44959 7 8.00187C7 8.55416 7.44772 9.00187 8 9.00187Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8 14.0819C8.55228 14.0819 9 13.6342 9 13.0819C9 12.5296 8.55228 12.0819 8 12.0819C7.44772 12.0819 7 12.5296 7 13.0819C7 13.6342 7.44772 14.0819 8 14.0819Z" })), oxe = yn(ixe);
function Vz({ as: e, children: t }) {
  return /* @__PURE__ */ a.jsxs($8, { className: "twp relative", children: [
    /* @__PURE__ */ a.jsx(K4, { as: e, className: "twp block outline-0", children: /* @__PURE__ */ a.jsx(oxe, { className: "h-[1.14285rem] w-[1.14285rem] text-mshop-gray-50" }) }),
    /* @__PURE__ */ a.jsx(
      X4,
      {
        anchor: "bottom end",
        className: "twp mr-[1.14285rem] flex min-w-[9.14285rem] translate-x-[1.14285rem] translate-y-[.78571rem] flex-col rounded-[.42857rem] border border-mshop-black bg-mshop-bright-95 py-[.01785rem] backdrop-blur-[30px]",
        style: { zIndex: Tc.GLOBAL.MODAL },
        children: t
      }
    )
  ] });
}
function $z({ children: e, onClose: t, onClick: n, ...r }) {
  const s = (o) => {
    n == null || n(o), t();
  };
  return /* @__PURE__ */ a.jsx(
    "button",
    {
      ...r,
      type: "button",
      className: "typo-mshop-kr-14-m flex w-full items-center px-[1.14285rem] py-[.57143rem] text-mshop-gray-80",
      onClick: s,
      children: /* @__PURE__ */ a.jsx(a.Fragment, { children: e })
    }
  );
}
function pY({
  show: e = !0,
  onClose: t,
  supportMessage: n,
  onSuccessDeleteMessage: r,
  onToggleReactionUpdater: s,
  initialImageIndex: o = 0
}) {
  const [c, u] = Re(o), m = n == null ? void 0 : n.images[c], {
    widgetCore: { onError: y, toggleSpinner: b, isMobile: w }
  } = Gt(), { me: k } = by(), { client: j } = Ha(), [E, T] = Re(!1);
  an(() => {
    (async () => {
      try {
        const H = await j.getToken();
        T(!!H);
      } catch {
        y(Ht);
      }
    })();
  }, [j]);
  const { handleToggleReaction: D } = hY(mY.SupportMessage), L = (H) => async () => {
    await D(
      H.id,
      H.reaction.reacted,
      (K) => {
        s({
          ...H,
          reaction: {
            ...H.reaction,
            count: K ? H.reaction.count + 1 : H.reaction.count - 1,
            reacted: K,
            creatorReacted: H.creator.id === (k == null ? void 0 : k.id) ? K : H.reaction.creatorReacted
          }
        });
      }
    );
  }, I = (H) => {
    u(H);
  }, R = (H) => async (K) => {
    if (K.stopPropagation(), !await ho({
      body: (Z, X) => /* @__PURE__ */ a.jsx(
        D3,
        {
          confirmButton: {
            props: Z,
            text: "삭제하기"
          },
          cancelButton: {
            props: X
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem] text-center", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "후원 메시지 삭제하기" }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "등록된 후원 메시지를 삭제하시겠어요?" })
          ] })
        }
      )
    }))
      return;
    b(!0);
    const Q = await sxe(
      {
        id: H
      },
      { client: j, onError: y }
    );
    if (b(!1), Q.code !== le.Success)
      switch (Q.code) {
        case le.NoDeleteItem:
          await en({
            body: (Z) => /* @__PURE__ */ a.jsx(
              ea,
              {
                button: {
                  props: Z
                },
                children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "삭제 불가" }),
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "해당 메시지는 이미 삭제되었습니다." })
                ] })
              }
            )
          });
          return;
        case le.TokenExpired:
          return y(Ht);
        default:
          await en({
            body: (Z) => /* @__PURE__ */ a.jsx(
              ea,
              {
                button: {
                  props: Z
                },
                children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m whitespace-pre-wrap text-center text-mshop-gray-80", children: [
                    "예기치 못한 오류로 인해 진행할 수 없습니다.",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "동일한 문제가 반복적으로 발생할 경우",
                    /* @__PURE__ */ a.jsx("br", {}),
                    /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                    "로 문의해 주세요."
                  ] })
                ] })
              }
            )
          });
          return;
      }
    await r(), U();
  }, U = () => {
    u(0), t();
  }, z = ((n == null ? void 0 : n.images.length) ?? 0) > 0;
  return /* @__PURE__ */ a.jsx("div", { id: "CommonSupportMessageSupportDetailModal", children: /* @__PURE__ */ a.jsx(dh, { show: e, onClose: U, variant: "TYPE03", children: n && (w ? /* @__PURE__ */ a.jsxs("div", { className: "flex h-full flex-col overflow-hidden pb-[env(safe-area-inset-bottom)]", children: [
    /* @__PURE__ */ a.jsx(p5, { title: "후원 상세", onClose: U }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex-grow overflow-y-auto scrollbar-hide", children: [
      m && /* @__PURE__ */ a.jsxs("div", { className: "relative h-[35.71429rem] w-full overflow-hidden", children: [
        /* @__PURE__ */ a.jsx(
          "img",
          {
            src: m.url,
            className: "h-full w-full object-cover blur-2xl",
            alt: ""
          }
        ),
        /* @__PURE__ */ a.jsx(
          "img",
          {
            src: m.url,
            className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
            alt: ""
          }
        )
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col", children: [
        /* @__PURE__ */ a.jsx("div", { className: "flex items-center gap-x-[0.571rem] px-[1.14286rem] py-[0.57143rem]", children: n.images.map((H, K) => /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: "block flex-shrink-0",
            onClick: () => I(K),
            children: /* @__PURE__ */ a.jsx(
              "img",
              {
                src: H.url,
                className: $(
                  "size-[3.60714rem] rounded-md border-[0.143rem] object-cover",
                  {
                    "border-mshop-blue-100": K == c
                  },
                  {
                    "border-transparent opacity-50 hover:opacity-100": K != c
                  }
                ),
                alt: ""
              }
            )
          },
          K
        )) }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem] p-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between gap-x-[0.857rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "w-[3rem] flex-shrink-0", children: /* @__PURE__ */ a.jsx(
              Ql,
              {
                imageUrl: Xu(n.user)
              }
            ) }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex w-[calc(100%-3rem-0.857rem)] flex-col", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $("block truncate", {
                      "typo-mshop-kr-14-b": n.user,
                      "typo-mshop-kr-14-m text-mshop-gray-50": !n.user
                    }),
                    children: Mc(n.user)
                  }
                ),
                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.571rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m block text-mshop-gray-50", children: jt(n.createdAt, "yyyy.MM.dd") }),
                  n.isMine && /* @__PURE__ */ a.jsx(Vz, { children: ({ close: H }) => /* @__PURE__ */ a.jsx(
                    $z,
                    {
                      onClick: R(
                        n.id
                      ),
                      onClose: H,
                      children: "삭제하기"
                    }
                  ) })
                ] })
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m block truncate text-mshop-gray-80", children: n.support.displayName })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-20-b text-mshop-blue-100", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-20-unica-b", children: n.price.toLocaleString(cr.Ko) }),
            "원"
          ] }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m h-[19.429rem] whitespace-pre-wrap break-words", children: n.message || `${Mc(
            n.user
          )} 님께서 ${n.price.toLocaleString(cr.Ko)}원을 후원하셨습니다.` })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between gap-x-[1.14286rem] border-t border-mshop-gray-5 p-[1.143rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.286rem]", children: [
        n.reaction.creatorReacted && /* @__PURE__ */ a.jsx("div", { className: "size-[2.286rem]", children: /* @__PURE__ */ a.jsx(
          Ql,
          {
            imageUrl: Xu(n.creator)
          }
        ) }),
        /* @__PURE__ */ a.jsxs(
          "button",
          {
            type: "button",
            className: $("flex flex-col items-center"),
            disabled: !E,
            onClick: L(n),
            children: [
              /* @__PURE__ */ a.jsx(
                q9,
                {
                  className: $("size-[1.429rem]", {
                    "text-mshop-blue-100": n.reaction.reacted,
                    "text-mshop-gray-20": !n.reaction.reacted
                  })
                }
              ),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-10-unica-r text-mshop-gray-50", children: n.reaction.count.toLocaleString(cr.Ko) })
            ]
          }
        )
      ] }),
      n.reaction.creatorReacted && /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-b w-full rounded-[0.57143rem] bg-mshop-blue-10 px-[0.85714rem] py-[0.71429rem] text-center text-mshop-blue-100", children: "크리에이터가 회원님의 후원에 감동했어요!" })
    ] })
  ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex h-[43.857rem]", children: [
    m && /* @__PURE__ */ a.jsxs("div", { className: "relative h-full w-[32.857rem] overflow-hidden", children: [
      /* @__PURE__ */ a.jsx(
        "img",
        {
          src: m.url,
          className: "h-full w-full object-cover blur-2xl",
          alt: ""
        }
      ),
      /* @__PURE__ */ a.jsx(
        "img",
        {
          src: m.url,
          className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
          alt: ""
        }
      ),
      c > 0 && /* @__PURE__ */ a.jsx("div", { className: "absolute left-[0.57143rem] top-1/2 -translate-y-1/2", children: /* @__PURE__ */ a.jsx(
        wy,
        {
          direction: "left",
          background: "dim",
          type: "button",
          onClick: () => u(c - 1)
        }
      ) }),
      c < ((n == null ? void 0 : n.images) || []).length - 1 && /* @__PURE__ */ a.jsx("div", { className: "absolute right-[0.57143rem] top-1/2 -translate-y-1/2", children: /* @__PURE__ */ a.jsx(
        wy,
        {
          direction: "right",
          background: "dim",
          type: "button",
          onClick: () => u(c + 1)
        }
      ) })
    ] }),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex flex-col",
          m ? "w-[31.143rem]" : "w-full"
        ),
        children: [
          /* @__PURE__ */ a.jsx(
            D1,
            {
              titleAlign: "Left",
              back: !1,
              close: !0,
              label: "후원 상세",
              onCloseButtonClick: U
            }
          ),
          /* @__PURE__ */ a.jsxs("div", { className: "flex h-[calc(100%-5.42857rem)] flex-col justify-between", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex h-[calc(100%-4.5714rem)] w-full flex-col justify-between gap-y-[1.42857rem] overflow-y-hidden px-[2.28571rem] pb-[2.28571rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.143rem] overflow-y-auto pr-[1.143rem] scrollbar-hide", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between gap-x-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx("div", { className: "w-[3rem] flex-shrink-0", children: /* @__PURE__ */ a.jsx(
                    Ql,
                    {
                      imageUrl: Xu(n.user)
                    }
                  ) }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex w-[calc(100%-3rem-0.857rem)] flex-col", children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $("block truncate", {
                            "typo-mshop-kr-14-b": n.user,
                            "typo-mshop-kr-14-m text-mshop-gray-50": !n.user
                          }),
                          children: Mc(n.user)
                        }
                      ),
                      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.571rem]", children: [
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-r block text-mshop-gray-50", children: jt(n.createdAt, "yyyy.MM.dd") }),
                        n.isMine && /* @__PURE__ */ a.jsx(Vz, { children: ({ close: H }) => /* @__PURE__ */ a.jsx(
                          $z,
                          {
                            onClick: R(
                              n.id
                            ),
                            onClose: H,
                            children: "삭제하기"
                          }
                        ) })
                      ] })
                    ] }),
                    /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m block truncate text-mshop-gray-80", children: n.support.displayName })
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-20-b text-mshop-blue-100", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-20-unica-b", children: n.price.toLocaleString(cr.Ko) }),
                  "원"
                ] }),
                /* @__PURE__ */ a.jsx(
                  "p",
                  {
                    className: $(
                      "typo-mshop-kr-14-m whitespace-pre-wrap",
                      z ? "h-[19.429rem] w-full" : "h-[calc(100%-4.3571rem)] w-[32.85714rem]"
                    ),
                    children: n.message || `${Mc(
                      n.user
                    )} 님께서 ${n.price.toLocaleString(cr.Ko)}원을 후원하셨습니다.`
                  }
                )
              ] }),
              z && /* @__PURE__ */ a.jsx("div", { className: "mt-[0.286rem] flex items-center gap-x-[0.571rem]", children: n.images.map((H, K) => /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: "block",
                  onClick: () => I(K),
                  children: /* @__PURE__ */ a.jsx(
                    "img",
                    {
                      src: H.url,
                      className: $(
                        "size-[4.429rem] rounded-md border-[0.143rem] object-cover",
                        {
                          "border-mshop-blue-100": K == c
                        },
                        {
                          "border-transparent opacity-50 hover:opacity-100": K != c
                        }
                      ),
                      alt: ""
                    }
                  )
                },
                K
              )) })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between gap-x-[1.14286rem] border-t border-mshop-gray-5 px-[1.42857rem] py-[1.143rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.286rem]", children: [
                n.reaction.creatorReacted && /* @__PURE__ */ a.jsx("div", { className: "size-[2.286rem]", children: /* @__PURE__ */ a.jsx(
                  Ql,
                  {
                    imageUrl: Xu(
                      n.creator
                    )
                  }
                ) }),
                /* @__PURE__ */ a.jsxs(
                  "button",
                  {
                    type: "button",
                    className: $(
                      "flex items-center gap-x-[0.286rem] py-[0.286rem]"
                    ),
                    disabled: !E,
                    onClick: L(n),
                    children: [
                      /* @__PURE__ */ a.jsx(
                        q9,
                        {
                          className: $("size-[1.429rem]", {
                            "text-mshop-blue-100": n.reaction.reacted,
                            "text-mshop-gray-20": !n.reaction.reacted
                          })
                        }
                      ),
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-m text-mshop-gray-50", children: n.reaction.count.toLocaleString(
                        cr.Ko
                      ) })
                    ]
                  }
                )
              ] }),
              n.reaction.creatorReacted && /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-b flex h-[2.286rem] w-full max-w-[24.643rem] items-center justify-center rounded-md bg-mshop-blue-10 text-mshop-blue-100", children: "크리에이터가 회원님의 후원 메세지에 감동했어요!" })
            ] })
          ] })
        ]
      }
    )
  ] })) }) });
}
const lxe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M17 16.1028C17 15.99 16.959 15.8721 16.8667 15.785L13.0841 12.0023L16.8667 8.21964C17.041 8.04537 17.041 7.75834 16.8667 7.58407C16.6925 7.4098 16.4054 7.4098 16.2312 7.58407L12.1307 11.6845C11.9564 11.8588 11.9564 12.1458 12.1307 12.3201L16.2312 16.4206C16.4054 16.5948 16.6925 16.5948 16.8667 16.4206C16.9539 16.3334 17 16.2155 17 16.1028Z" }), /* @__PURE__ */ re.createElement("path", { d: "M12 16.1028C12 15.99 11.959 15.8721 11.8667 15.785L8.08406 12.0023L11.8667 8.21964C12.041 8.04537 12.041 7.75834 11.8667 7.58407C11.6925 7.4098 11.4054 7.4098 11.2312 7.58407L7.1307 11.6845C6.95643 11.8588 6.95643 12.1458 7.1307 12.3201L11.2312 16.4206C11.4054 16.5948 11.6925 16.5948 11.8667 16.4206C11.9539 16.3334 12 16.2155 12 16.1028Z" })), Gz = yn(lxe), cxe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M14.5 16.1029C14.5 15.9901 14.459 15.8723 14.3667 15.7851L10.5841 12.0024L14.3667 8.21977C14.541 8.0455 14.541 7.75846 14.3667 7.58419C14.1925 7.40992 13.9054 7.40992 13.7312 7.58419L9.6307 11.6847C9.45643 11.8589 9.45643 12.146 9.6307 12.3202L13.7312 16.4207C13.9054 16.595 14.1925 16.595 14.3667 16.4207C14.4539 16.3336 14.5 16.2157 14.5 16.1029Z" })), Wz = yn(cxe), uxe = {
  first: /* @__PURE__ */ a.jsx(Gz, {}),
  prev: /* @__PURE__ */ a.jsx(Wz, {}),
  next: /* @__PURE__ */ a.jsx(Wz, { className: "rotate-180" }),
  last: /* @__PURE__ */ a.jsx(Gz, { className: "rotate-180" })
};
function f8({ variant: e, onClick: t, disabled: n }) {
  return /* @__PURE__ */ a.jsx(
    "button",
    {
      type: "button",
      onClick: t,
      disabled: n,
      className: "size-6 text-mshop-black disabled:text-mshop-gray-20",
      children: uxe[e]
    }
  );
}
function dxe({ isSelected: e, onClick: t, children: n }) {
  return /* @__PURE__ */ a.jsx(
    "button",
    {
      type: "button",
      onClick: t,
      className: $(
        "typo-mshop-kr-16-m size-[2.28571rem]",
        e ? "text-mshop-black" : "text-mshop-gray-50"
      ),
      children: n
    }
  );
}
const fxe = (e, t) => Math.floor((e - 1) / t) * t + 1;
function J2({
  windowSize: e = 10,
  count: t,
  onChange: n,
  page: r,
  showFirstButton: s,
  showLastButton: o
}) {
  const c = fxe(r, e), u = n$(ow(c, t + 1)).take(e).toArray(), m = c <= 1, y = r <= 1, b = r >= t, w = Math.max(c - e, 1), k = Math.min(c + e, t), j = k >= t;
  return /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center gap-x-[1.14285rem]", children: [
    s ? /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[.28571rem]", children: [
      /* @__PURE__ */ a.jsx(
        f8,
        {
          variant: "first",
          onClick: (E) => n(E, w),
          disabled: m
        }
      ),
      /* @__PURE__ */ a.jsx(
        f8,
        {
          variant: "prev",
          onClick: (E) => n(E, r - 1),
          disabled: y
        }
      )
    ] }) : /* @__PURE__ */ a.jsx(
      f8,
      {
        variant: "prev",
        onClick: (E) => n(E, r - 1),
        disabled: y
      }
    ),
    /* @__PURE__ */ a.jsx("div", { className: "flex gap-x-[.28571rem]", children: u.map((E) => /* @__PURE__ */ a.jsx(
      dxe,
      {
        onClick: (T) => n(T, E),
        isSelected: E === r,
        children: E
      },
      E
    )) }),
    o ? /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[.28571rem]", children: [
      /* @__PURE__ */ a.jsx(
        f8,
        {
          variant: "next",
          onClick: (E) => n(E, r + 1),
          disabled: b
        }
      ),
      /* @__PURE__ */ a.jsx(
        f8,
        {
          variant: "last",
          onClick: (E) => n(E, k),
          disabled: j
        }
      )
    ] }) : /* @__PURE__ */ a.jsx(
      f8,
      {
        variant: "next",
        onClick: (E) => n(E, r + 1),
        disabled: b
      }
    )
  ] });
}
const Yz = 9, mxe = 5, hxe = 10;
function pxe({ onClickMoveToSupportInfoPage: e }) {
  const { supportMessages: t, setSupportMessages: n, updateSupportMessage: r } = oA(), { client: s } = Ha(), { me: o } = by(), { projectId: c } = Tf();
  wt(t);
  const {
    widgetCore: { isMobile: u, onError: m }
  } = Gt(), [y, b] = Re(null), [w, k] = Re(1), j = () => {
    b(null);
  }, { handleToggleReaction: E } = hY(mY.SupportMessage), T = (R) => async (U) => {
    U.stopPropagation(), await E(
      R.id,
      R.reaction.reacted,
      (z) => r({
        ...R,
        reaction: {
          ...R.reaction,
          count: z ? R.reaction.count + 1 : R.reaction.count - 1,
          reacted: z,
          creatorReacted: R.creator.id === (o == null ? void 0 : o.id) ? z : R.reaction.creatorReacted
        }
      })
    );
  }, D = async () => {
    const R = await G9(
      {
        projectId: c,
        page: w,
        size: Yz,
        order: "desc"
      },
      {
        client: s,
        onError: m
      }
    );
    if (R.code !== le.Success)
      return m(Ht);
    n(R.data);
  }, L = t.items.find(
    (R) => R.id === y
  ), I = t.items.length === 0;
  return /* @__PURE__ */ a.jsx("div", { id: "support-message", className: "px-[1.14286rem] pt-[1.71429rem]", children: I ? /* @__PURE__ */ a.jsx(a.Fragment, { children: u ? /* @__PURE__ */ a.jsx("div", { className: "py-[8.57143rem]", children: /* @__PURE__ */ a.jsx(
    p6,
    {
      description: `후원하기를 통해 크리에이터에게 감사 인사를 남기고,
창작 활동을 지원해 보세요!`,
      renderButton: /* @__PURE__ */ a.jsx(
        fn,
        {
          theme: "blue",
          type: "button",
          variant: "lg",
          widthFull: !0,
          onClick: e,
          children: "후원하러 가기"
        }
      ),
      renderImage: /* @__PURE__ */ a.jsx(
        "img",
        {
          alt: "",
          src: kt.KeyVisual.MembershipCommunity
        }
      ),
      title: "크리에이터에게 힘을 주세요!"
    }
  ) }) : /* @__PURE__ */ a.jsx("div", { className: "py-[11.429rem]", children: /* @__PURE__ */ a.jsx(
    f5,
    {
      description: `후원하기를 통해 크리에이터에게 감사 인사를 남기고,
창작 활동을 지원해 보세요!`,
      renderButton: /* @__PURE__ */ a.jsx(
        fn,
        {
          theme: "blue",
          type: "button",
          variant: "lg",
          widthFull: !0,
          onClick: e,
          children: "후원하러 가기"
        }
      ),
      renderImage: /* @__PURE__ */ a.jsx(
        "img",
        {
          alt: "",
          src: kt.KeyVisual.MembershipCommunity
        }
      ),
      title: "크리에이터에게 힘을 주세요!"
    }
  ) }) }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    u ? /* @__PURE__ */ a.jsx("div", { className: "flex flex-col gap-y-[1.14286rem]", children: t.items.map((R) => {
      var U, z, H;
      return /* @__PURE__ */ a.jsxs(
        "button",
        {
          type: "button",
          className: $(
            "flex flex-col gap-x-[0.57143rem] rounded-[1.14286rem] border p-[1.143rem]",
            {
              "border-mshop-blue-100": R.isMine,
              "border-mshop-gray-10": !R.isMine
            }
          ),
          onClick: () => {
            b(R.id);
          },
          children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex w-full gap-x-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "size-[2.28571rem] flex-shrink-0", children: /* @__PURE__ */ a.jsx(
                  Ql,
                  {
                    imageUrl: ((U = R.user) == null ? void 0 : U.state) === Sy.Delete ? null : Xu(R.user)
                  }
                ) }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 items-center justify-between", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $({
                        "typo-mshop-kr-14-b": R.user,
                        "typo-mshop-kr-14-m text-mshop-gray-50": !R.user
                      }),
                      children: Mc(R.user)
                    }
                  ),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: jt(R.createdAt, "yyyy.MM.dd") })
                ] })
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "mt-[0.571rem] flex items-center", children: [
                /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-20-unica-b flex-shrink-0 text-mshop-blue-100", children: [
                  R.price.toLocaleString("ko"),
                  "원"
                ] }),
                /* @__PURE__ */ a.jsx("div", { className: "mx-[0.571rem] h-[0.57143rem] w-[0.07143rem] flex-shrink-0 bg-mshop-gray-10" }),
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m cursor-default truncate outline-0", children: R.support.displayName })
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "mb-[0.57143rem] mt-[1.14286rem] flex h-[6.85714rem] items-start gap-x-[1.143rem]", children: [
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m line-clamp-4 w-full break-words text-left text-mshop-black", children: R.message || `${Mc(R.user)}님께서 ${R.price.toLocaleString(cr.Ko)}원을 후원하셨습니다.` }),
                ((z = R.images[0]) == null ? void 0 : z.url) && /* @__PURE__ */ a.jsx(
                  "img",
                  {
                    src: (H = R.images[0]) == null ? void 0 : H.url,
                    className: "aspect-square w-[6.857rem] flex-shrink-0 rounded-xl object-cover",
                    alt: ""
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.286rem]", children: [
              R.reaction.creatorReacted && /* @__PURE__ */ a.jsx("div", { className: "size-[2.286rem]", children: /* @__PURE__ */ a.jsx(
                Ql,
                {
                  imageUrl: Xu(R.creator)
                }
              ) }),
              /* @__PURE__ */ a.jsxs(
                pm,
                {
                  as: "div",
                  className: "flex items-center gap-x-[0.286rem]",
                  disabled: o == null,
                  onClick: T(R),
                  children: [
                    /* @__PURE__ */ a.jsx(
                      q9,
                      {
                        className: $("size-[1.429rem]", {
                          "text-mshop-blue-100": R.reaction.reacted,
                          "text-mshop-gray-20": !R.reaction.reacted
                        })
                      }
                    ),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-m text-mshop-gray-50", children: R.reaction.count.toLocaleString("ko") })
                  ]
                }
              )
            ] })
          ]
        },
        R.id
      );
    }) }) : /* @__PURE__ */ a.jsx("div", { className: "grid grid-cols-3 gap-[1.143rem]", children: t.items.map((R) => {
      var U, z, H;
      return /* @__PURE__ */ a.jsxs(
        "button",
        {
          type: "button",
          className: $(
            "flex gap-x-[0.857rem] rounded-[1.14286rem] border p-[1.143rem]",
            {
              "border-mshop-blue-100": R.isMine,
              "border-mshop-gray-10": !R.isMine
            }
          ),
          onClick: () => {
            b(R.id);
          },
          children: [
            /* @__PURE__ */ a.jsx("div", { className: "size-[3rem] flex-shrink-0", children: /* @__PURE__ */ a.jsx(
              Ql,
              {
                imageUrl: ((U = R.user) == null ? void 0 : U.state) === Sy.Delete ? null : Xu(R.user)
              }
            ) }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex h-full w-[calc(100%-3.857rem)] flex-col justify-between", children: [
              /* @__PURE__ */ a.jsxs("div", { children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $({
                        "typo-mshop-kr-14-b": R.user,
                        "typo-mshop-kr-14-m text-mshop-gray-50": !R.user
                      }),
                      children: Mc(R.user)
                    }
                  ),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: jt(R.createdAt, "yyyy.MM.dd") })
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "mt-[0.571rem] flex items-center", children: [
                  /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-20-unica-b flex-shrink-0 text-mshop-blue-100", children: [
                    R.price.toLocaleString("ko"),
                    "원"
                  ] }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m mx-[0.571rem] h-[1.214rem] w-[0.286rem] flex-shrink-0 text-mshop-gray-50", children: "l" }),
                  /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m cursor-default truncate outline-0", children: R.support.displayName })
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "my-[0.857rem] flex h-[6.85714rem] items-start gap-x-[1.143rem]", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m line-clamp-4 w-full break-words text-left text-mshop-black", children: R.message || `${Mc(R.user)}님께서 ${R.price.toLocaleString(cr.Ko)}원을 후원하셨습니다.` }),
                  ((z = R.images[0]) == null ? void 0 : z.url) && /* @__PURE__ */ a.jsx(
                    "img",
                    {
                      src: (H = R.images[0]) == null ? void 0 : H.url,
                      className: "aspect-square w-[6.857rem] flex-shrink-0 rounded-xl object-cover",
                      alt: ""
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.286rem]", children: [
                R.reaction.creatorReacted && /* @__PURE__ */ a.jsx("div", { className: "size-[2.286rem]", children: /* @__PURE__ */ a.jsx(
                  Ql,
                  {
                    imageUrl: Xu(R.creator)
                  }
                ) }),
                /* @__PURE__ */ a.jsxs(
                  pm,
                  {
                    as: "div",
                    className: "flex items-center gap-x-[0.286rem]",
                    disabled: o == null,
                    onClick: T(R),
                    children: [
                      /* @__PURE__ */ a.jsx(
                        q9,
                        {
                          className: $("size-[1.429rem]", {
                            "text-mshop-blue-100": R.reaction.reacted,
                            "text-mshop-gray-20": !R.reaction.reacted
                          })
                        }
                      ),
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-m text-mshop-gray-50", children: R.reaction.count.toLocaleString("ko") })
                    ]
                  }
                )
              ] })
            ] })
          ]
        },
        R.id
      );
    }) }),
    t.totalPage > 1 && /* @__PURE__ */ a.jsx(
      "div",
      {
        className: $(
          "flex items-center justify-center",
          u ? "pt-[3.42857rem]" : "pt-[4rem]"
        ),
        children: /* @__PURE__ */ a.jsx(
          J2,
          {
            count: t.totalPage || w,
            onChange: async (R, U) => {
              k(U);
              const z = await G9(
                {
                  projectId: c,
                  page: U,
                  size: Yz,
                  order: "desc"
                },
                {
                  client: s,
                  onError: m
                }
              );
              if (z.code !== le.Success)
                return m(Ht);
              n(z.data), window.scrollTo(0, 0);
            },
            page: w,
            windowSize: u ? mxe : hxe,
            showFirstButton: !0,
            showLastButton: !0
          }
        )
      }
    ),
    /* @__PURE__ */ a.jsx(
      pY,
      {
        show: !!L,
        supportMessage: L,
        onClose: j,
        onSuccessDeleteMessage: D,
        onToggleReactionUpdater: r
      }
    )
  ] }) });
}
function gxe({
  client: e,
  widgetCore: t,
  projectId: n,
  selectedTabIndex: r,
  onGoToExploreProductsButtonClick: s,
  onSeeSupportDetailButtonClick: o,
  onIntegratedPaidServiceTermsTextClick: c,
  onClickPersonalInfoOutsourcing: u,
  onClickThirdPartyConsent: m,
  onClickInicisTerms: y,
  onClickMoveToSupportInfoPage: b,
  onCreatorSupportButtonClick: w
}) {
  Al([
    [ol, e],
    [ll, t],
    [R1, n],
    [m5, null],
    [
      O2,
      {
        defaultTabIndex: r,
        tabIndex: r,
        nextTabIndex: null
      }
    ]
  ]);
  const { supports: k, setSupports: j } = lA(), { supportMessages: E, setSupportMessages: T } = oA(), {
    widgetCore: { onError: D }
  } = Gt(), L = (E == null ? void 0 : E.totalCount) ?? (k == null ? void 0 : k.totalSupportMessageCount) ?? 0, [I, R] = Re(!1), {
    tabIndex: U,
    setTabIndex: z,
    defaultTabIndex: H,
    nextTabIndex: K,
    setNextTabIndex: q
  } = ZW(), Q = async (Z) => {
    if (R(!0), Z === 0)
      try {
        const X = await iA(
          {
            projectId: n
          },
          { client: e, onError: D }
        );
        if (X.code !== le.Success)
          return D(Ht);
        j(X.data), E && T({
          ...E,
          totalCount: X.data.totalSupportMessageCount
        }), z(Z);
      } catch (X) {
        console.log(X);
      }
    else {
      const X = await G9(
        {
          projectId: n,
          page: 1,
          size: 9,
          order: "desc"
        },
        {
          client: e,
          onError: D
        }
      );
      if (X.code !== le.Success)
        return D(Ht);
      T(X.data), k && j({
        ...k,
        totalSupportMessageCount: X.data.totalCount
      }), z(Z);
    }
    R(!1);
  };
  return an(() => {
    (async () => K !== null && (q(null), await Q(K)))();
  }, [K]), /* @__PURE__ */ a.jsx("div", { className: "twp", children: /* @__PURE__ */ a.jsxs(
    VE,
    {
      defaultIndex: H,
      selectedIndex: U,
      onChange: Q,
      children: [
        t.isMobile ? /* @__PURE__ */ a.jsxs(j3, { className: "flex border-b border-mshop-gray-20 pt-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsx(Ez, { children: "후원 안내" }),
          /* @__PURE__ */ a.jsx(Ez, { children: /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-center gap-x-[0.28571rem]", children: [
            "후원 메시지",
            L > 0 && /* @__PURE__ */ a.jsx("span", { children: L })
          ] }) })
        ] }) : /* @__PURE__ */ a.jsxs(j3, { className: "flex gap-x-[0.857rem] py-[1.714rem]", children: [
          /* @__PURE__ */ a.jsx(kz, { children: "후원 안내" }),
          /* @__PURE__ */ a.jsx(kz, { children: /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-center gap-x-[0.286rem]", children: [
            "후원 메시지",
            L > 0 && /* @__PURE__ */ a.jsx("span", { children: L })
          ] }) })
        ] }),
        I ? /* @__PURE__ */ a.jsx("div", { className: "h-[40.786rem]" }) : /* @__PURE__ */ a.jsxs($E, { className: $({ "py-[1.143rem]": !t.isMobile }), children: [
          /* @__PURE__ */ a.jsx($i, { children: /* @__PURE__ */ a.jsx(
            Jve,
            {
              onGoToExploreProductsButtonClick: s,
              onSeeSupportDetailButtonClick: o,
              onIntegratedPaidServiceTermsTextClick: c,
              onClickPersonalInfoOutsourcing: u,
              onClickThirdPartyConsent: m,
              onClickInicisTerms: y,
              onCreatorSupportButtonClick: w
            }
          ) }),
          /* @__PURE__ */ a.jsx($i, { children: /* @__PURE__ */ a.jsx(
            pxe,
            {
              onClickMoveToSupportInfoPage: b
            }
          ) })
        ] })
      ]
    }
  ) });
}
function yxe({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  projectId: s,
  selectedTabIndex: o = 0,
  onSeeSupportDetailButtonClick: c,
  onGoToExploreProductsButtonClick: u,
  onError: m,
  onIntegratedPaidServiceTermsTextClick: y,
  onClickPersonalInfoOutsourcing: b,
  onClickThirdPartyConsent: w,
  onClickInicisTerms: k,
  onClickMoveToSupportInfoPage: j,
  onCreatorSupportButtonClick: E,
  onScrollLock: T
}) {
  const [D, L] = Re(!0), { setSupports: I } = lA(), { setSupportMessages: R } = oA(), { setMe: U } = by();
  return an(() => {
    (async () => {
      if (!s)
        return L(!1);
      const z = !!await e.getToken();
      if (o === 0) {
        const [H, K] = await Promise.all([
          iA(
            {
              projectId: s
            },
            { client: e, onError: m }
          ),
          z ? Q8({ client: e, onError: m }) : Promise.resolve({ code: le.Success, data: null })
        ]);
        return H.code !== le.Success || K.code !== le.Success ? m(Ht) : (I(H.data), U(K.data), L(!1));
      } else if (o == 1) {
        const [H, K] = await Promise.all([
          G9(
            {
              projectId: s,
              page: 1,
              size: 9,
              order: "desc"
            },
            {
              client: e,
              onError: m
            }
          ),
          z ? Q8({ client: e, onError: m }) : Promise.resolve({ code: le.Success, data: null })
        ]);
        if (K.code !== le.Success || H.code !== le.Success)
          return m(Ht);
        U(K.data), R(H.data), L(!1);
        return;
      }
      throw new Error("invalid tabIndex");
    })();
  }, [s, e, o]), D ? /* @__PURE__ */ a.jsx("div", { className: "h-[35.6875rem]" }) : s ? /* @__PURE__ */ a.jsx(
    gxe,
    {
      client: e,
      widgetCore: {
        isMobile: t,
        isApp: n,
        toggleSpinner: r,
        onError: m,
        onScrollLock: T
      },
      projectId: s,
      selectedTabIndex: o,
      onGoToExploreProductsButtonClick: u,
      onSeeSupportDetailButtonClick: c,
      onIntegratedPaidServiceTermsTextClick: y,
      onClickPersonalInfoOutsourcing: b,
      onClickThirdPartyConsent: w,
      onClickInicisTerms: k,
      onClickMoveToSupportInfoPage: j,
      onCreatorSupportButtonClick: E
    }
  ) : /* @__PURE__ */ a.jsx("main", { className: "twp py-[11.429rem]", children: /* @__PURE__ */ a.jsx(
    f5,
    {
      renderImage: /* @__PURE__ */ a.jsx("img", { src: kt.KeyVisual.LoudSpeaker, alt: "" }),
      title: "후원 준비 중입니다.",
      description: `크리에이터가 후원을 준비하는 동안
마플샵에서 내 취향의 상품을 찾아볼까요?`,
      renderButton: /* @__PURE__ */ a.jsx(
        fn,
        {
          variant: "lg",
          theme: "blue",
          widthFull: !0,
          type: "button",
          onClick: u,
          children: "상품 구경하러 가기"
        }
      )
    }
  ) });
}
class Oje extends Ol {
  constructor({
    selectedTabIndex: t,
    projectId: n,
    onGoToExploreProductsButtonClick: r,
    onSeeSupportDetailButtonClick: s,
    onIntegratedPaidServiceTermsTextClick: o,
    onClickPersonalInfoOutsourcing: c,
    onClickThirdPartyConsent: u,
    onClickInicisTerms: m,
    onClickMoveToSupportInfoPage: y,
    onCreatorSupportButtonClick: b,
    ...w
  }) {
    super(w), this.render = (k) => go(k).render(
      /* @__PURE__ */ a.jsx(
        yxe,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          projectId: this.projectId,
          selectedTabIndex: this.selectedTabIndex,
          onGoToExploreProductsButtonClick: this.onGoToExploreProductsButtonClick,
          onSeeSupportDetailButtonClick: this.onSeeSupportDetailButtonClick,
          onError: this.onError,
          onIntegratedPaidServiceTermsTextClick: this.onIntegratedPaidServiceTermsTextClick,
          onScrollLock: this.onScrollLock,
          onClickInicisTerms: this.onClickInicisTerms,
          onClickPersonalInfoOutsourcing: this.onClickPersonalInfoOutsourcing,
          onClickThirdPartyConsent: this.onClickThirdPartyConsent,
          onClickMoveToSupportInfoPage: this.onClickMoveToSupportInfoPage,
          onCreatorSupportButtonClick: this.onCreatorSupportButtonClick
        }
      )
    ), this.projectId = n, this.selectedTabIndex = t ?? 0, this.onGoToExploreProductsButtonClick = r, this.onSeeSupportDetailButtonClick = s, this.onIntegratedPaidServiceTermsTextClick = o, this.onClickPersonalInfoOutsourcing = c, this.onClickThirdPartyConsent = u, this.onClickInicisTerms = m, this.onClickMoveToSupportInfoPage = y, this.onCreatorSupportButtonClick = b;
  }
}
const vxe = (e, t) => jn(
  "/membership",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), xxe = async (e, t) => jn(
  "/create-membership-payment",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.ExpiredInfo:
    case le.AlreadyMembershipSubscription:
    case le.ClosedMembership:
    case le.NotRegisteredPayment:
    case le.NotFoundPaymentModel:
    case le.FailedPayment:
    case le.FailedSignedUpLimitReached:
      return n;
    default:
      throw new Error("postCreateMembershipPayment");
  }
}), bxe = async (e, t) => jn("/create-payment", { body: e }, t).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.NotFoundPaymentModel:
    case le.AlreadyMembershipSubscription:
      return n;
    default:
      throw new Error("postCompletePayment");
  }
}), Sxe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M8.57002 11.6673C8.2534 12.1425 7.55507 12.1425 7.23844 11.6673L2.95914 5.24355C2.60496 4.71189 2.9861 4.00002 3.62493 4.00002L12.1835 4.00002C12.8224 4.00002 13.2035 4.71189 12.8493 5.24355L8.57002 11.6673Z" })), gY = yn(Sxe), yY = Qt(
  Vn
), b6 = () => {
  const [e, t] = Ar(yY);
  if (e === Vn)
    throw new Error(Xr(ia.Membership));
  return {
    membership: e,
    setMemberships: t
  };
}, K9 = (e) => {
  const t = e.replace(/[^0-9]/g, "");
  return /^01[016789]\d{7,8}$/.test(t) ? t.replace(/^(01[016789])(\d{3,4})(\d{4})$/, "$1-$2-$3") : /^0[2-9]\d{7,8}$/.test(t) ? t.replace(/^(0[2-9]\d?)(\d{3,4})(\d{4})$/, "$1-$2-$3") : /^0\d{3,4}\d{7}$/.test(t) ? t.replace(/^(0\d{2,3})(\d{4})(\d{4})$/, "$1-$2-$3") : e;
}, wxe = {
  KRW: "원"
}, zs = (e) => wxe[e];
function Cxe() {
  return new Promise((e, t) => {
    const n = "https://cdn.iamport.kr/v1/iamport.js";
    if ("IMP" in window)
      e({
        exist: !0
      });
    else {
      const s = document.createElement("script");
      s.src = n, s.async = !0, document.head.appendChild(s), s.onload = () => e({
        exist: !1
      }), s.onerror = () => t(new Error("Failed to load IAMPORT script."));
    }
  });
}
var vY = { exports: {} }, hk = {}, X9 = {}, ha = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e._registerNode = e.Konva = e.glob = void 0;
  const t = Math.PI / 180;
  function n() {
    return typeof window < "u" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
  }
  e.glob = typeof C1 < "u" ? C1 : typeof window < "u" ? window : typeof WorkerGlobalScope < "u" ? self : {}, e.Konva = {
    _global: e.glob,
    version: "9.3.15",
    isBrowser: n(),
    isUnminified: /param/.test((function(s) {
    }).toString()),
    dblClickWindow: 400,
    getAngle(s) {
      return e.Konva.angleDeg ? s * t : s;
    },
    enableTrace: !1,
    pointerEventsEnabled: !0,
    autoDrawEnabled: !0,
    hitOnDragEnabled: !1,
    capturePointerEventsEnabled: !1,
    _mouseListenClick: !1,
    _touchListenClick: !1,
    _pointerListenClick: !1,
    _mouseInDblClickWindow: !1,
    _touchInDblClickWindow: !1,
    _pointerInDblClickWindow: !1,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    _fixTextRendering: !1,
    pixelRatio: typeof window < "u" && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: !0,
    showWarnings: !0,
    dragButtons: [0, 1],
    isDragging() {
      return e.Konva.DD.isDragging;
    },
    isTransforming() {
      var s;
      return (s = e.Konva.Transformer) === null || s === void 0 ? void 0 : s.isTransforming();
    },
    isDragReady() {
      return !!e.Konva.DD.node;
    },
    releaseCanvasOnDestroy: !0,
    document: e.glob.document,
    _injectGlobal(s) {
      e.glob.Konva = s;
    }
  };
  const r = (s) => {
    e.Konva[s.prototype.getClassName()] = s;
  };
  e._registerNode = r, e.Konva._injectGlobal(e.Konva);
})(ha);
var cl = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Util = e.Transform = void 0;
  const t = ha;
  class n {
    constructor(U = [1, 0, 0, 1, 0, 0]) {
      this.dirty = !1, this.m = U && U.slice() || [1, 0, 0, 1, 0, 0];
    }
    reset() {
      this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
    }
    copy() {
      return new n(this.m);
    }
    copyInto(U) {
      U.m[0] = this.m[0], U.m[1] = this.m[1], U.m[2] = this.m[2], U.m[3] = this.m[3], U.m[4] = this.m[4], U.m[5] = this.m[5];
    }
    point(U) {
      var z = this.m;
      return {
        x: z[0] * U.x + z[2] * U.y + z[4],
        y: z[1] * U.x + z[3] * U.y + z[5]
      };
    }
    translate(U, z) {
      return this.m[4] += this.m[0] * U + this.m[2] * z, this.m[5] += this.m[1] * U + this.m[3] * z, this;
    }
    scale(U, z) {
      return this.m[0] *= U, this.m[1] *= U, this.m[2] *= z, this.m[3] *= z, this;
    }
    rotate(U) {
      var z = Math.cos(U), H = Math.sin(U), K = this.m[0] * z + this.m[2] * H, q = this.m[1] * z + this.m[3] * H, Q = this.m[0] * -H + this.m[2] * z, Z = this.m[1] * -H + this.m[3] * z;
      return this.m[0] = K, this.m[1] = q, this.m[2] = Q, this.m[3] = Z, this;
    }
    getTranslation() {
      return {
        x: this.m[4],
        y: this.m[5]
      };
    }
    skew(U, z) {
      var H = this.m[0] + this.m[2] * z, K = this.m[1] + this.m[3] * z, q = this.m[2] + this.m[0] * U, Q = this.m[3] + this.m[1] * U;
      return this.m[0] = H, this.m[1] = K, this.m[2] = q, this.m[3] = Q, this;
    }
    multiply(U) {
      var z = this.m[0] * U.m[0] + this.m[2] * U.m[1], H = this.m[1] * U.m[0] + this.m[3] * U.m[1], K = this.m[0] * U.m[2] + this.m[2] * U.m[3], q = this.m[1] * U.m[2] + this.m[3] * U.m[3], Q = this.m[0] * U.m[4] + this.m[2] * U.m[5] + this.m[4], Z = this.m[1] * U.m[4] + this.m[3] * U.m[5] + this.m[5];
      return this.m[0] = z, this.m[1] = H, this.m[2] = K, this.m[3] = q, this.m[4] = Q, this.m[5] = Z, this;
    }
    invert() {
      var U = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), z = this.m[3] * U, H = -this.m[1] * U, K = -this.m[2] * U, q = this.m[0] * U, Q = U * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), Z = U * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
      return this.m[0] = z, this.m[1] = H, this.m[2] = K, this.m[3] = q, this.m[4] = Q, this.m[5] = Z, this;
    }
    getMatrix() {
      return this.m;
    }
    decompose() {
      var U = this.m[0], z = this.m[1], H = this.m[2], K = this.m[3], q = this.m[4], Q = this.m[5], Z = U * K - z * H;
      let X = {
        x: q,
        y: Q,
        rotation: 0,
        scaleX: 0,
        scaleY: 0,
        skewX: 0,
        skewY: 0
      };
      if (U != 0 || z != 0) {
        var se = Math.sqrt(U * U + z * z);
        X.rotation = z > 0 ? Math.acos(U / se) : -Math.acos(U / se), X.scaleX = se, X.scaleY = Z / se, X.skewX = (U * H + z * K) / Z, X.skewY = 0;
      } else if (H != 0 || K != 0) {
        var te = Math.sqrt(H * H + K * K);
        X.rotation = Math.PI / 2 - (K > 0 ? Math.acos(-H / te) : -Math.acos(H / te)), X.scaleX = Z / te, X.scaleY = te, X.skewX = 0, X.skewY = (U * H + z * K) / Z;
      }
      return X.rotation = e.Util._getRotation(X.rotation), X;
    }
  }
  e.Transform = n;
  var r = "[object Array]", s = "[object Number]", o = "[object String]", c = "[object Boolean]", u = Math.PI / 180, m = 180 / Math.PI, y = "#", b = "", w = "0", k = "Konva warning: ", j = "Konva error: ", E = "rgb(", T = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 132, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 255, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 203],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [119, 128, 144],
    slategrey: [119, 128, 144],
    snow: [255, 255, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    transparent: [255, 255, 255, 0],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 5]
  }, D = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, L = [];
  const I = typeof requestAnimationFrame < "u" && requestAnimationFrame || function(R) {
    setTimeout(R, 60);
  };
  e.Util = {
    _isElement(R) {
      return !!(R && R.nodeType == 1);
    },
    _isFunction(R) {
      return !!(R && R.constructor && R.call && R.apply);
    },
    _isPlainObject(R) {
      return !!R && R.constructor === Object;
    },
    _isArray(R) {
      return Object.prototype.toString.call(R) === r;
    },
    _isNumber(R) {
      return Object.prototype.toString.call(R) === s && !isNaN(R) && isFinite(R);
    },
    _isString(R) {
      return Object.prototype.toString.call(R) === o;
    },
    _isBoolean(R) {
      return Object.prototype.toString.call(R) === c;
    },
    isObject(R) {
      return R instanceof Object;
    },
    isValidSelector(R) {
      if (typeof R != "string")
        return !1;
      var U = R[0];
      return U === "#" || U === "." || U === U.toUpperCase();
    },
    _sign(R) {
      return R === 0 || R > 0 ? 1 : -1;
    },
    requestAnimFrame(R) {
      L.push(R), L.length === 1 && I(function() {
        const U = L;
        L = [], U.forEach(function(z) {
          z();
        });
      });
    },
    createCanvasElement() {
      var R = document.createElement("canvas");
      try {
        R.style = R.style || {};
      } catch {
      }
      return R;
    },
    createImageElement() {
      return document.createElement("img");
    },
    _isInDocument(R) {
      for (; R = R.parentNode; )
        if (R == document)
          return !0;
      return !1;
    },
    _urlToImage(R, U) {
      var z = e.Util.createImageElement();
      z.onload = function() {
        U(z);
      }, z.src = R;
    },
    _rgbToHex(R, U, z) {
      return ((1 << 24) + (R << 16) + (U << 8) + z).toString(16).slice(1);
    },
    _hexToRgb(R) {
      R = R.replace(y, b);
      var U = parseInt(R, 16);
      return {
        r: U >> 16 & 255,
        g: U >> 8 & 255,
        b: U & 255
      };
    },
    getRandomColor() {
      for (var R = (Math.random() * 16777215 << 0).toString(16); R.length < 6; )
        R = w + R;
      return y + R;
    },
    getRGB(R) {
      var U;
      return R in T ? (U = T[R], {
        r: U[0],
        g: U[1],
        b: U[2]
      }) : R[0] === y ? this._hexToRgb(R.substring(1)) : R.substr(0, 4) === E ? (U = D.exec(R.replace(/ /g, "")), {
        r: parseInt(U[1], 10),
        g: parseInt(U[2], 10),
        b: parseInt(U[3], 10)
      }) : {
        r: 0,
        g: 0,
        b: 0
      };
    },
    colorToRGBA(R) {
      return R = R || "black", e.Util._namedColorToRBA(R) || e.Util._hex3ColorToRGBA(R) || e.Util._hex4ColorToRGBA(R) || e.Util._hex6ColorToRGBA(R) || e.Util._hex8ColorToRGBA(R) || e.Util._rgbColorToRGBA(R) || e.Util._rgbaColorToRGBA(R) || e.Util._hslColorToRGBA(R);
    },
    _namedColorToRBA(R) {
      var U = T[R.toLowerCase()];
      return U ? {
        r: U[0],
        g: U[1],
        b: U[2],
        a: 1
      } : null;
    },
    _rgbColorToRGBA(R) {
      if (R.indexOf("rgb(") === 0) {
        R = R.match(/rgb\(([^)]+)\)/)[1];
        var U = R.split(/ *, */).map(Number);
        return {
          r: U[0],
          g: U[1],
          b: U[2],
          a: 1
        };
      }
    },
    _rgbaColorToRGBA(R) {
      if (R.indexOf("rgba(") === 0) {
        R = R.match(/rgba\(([^)]+)\)/)[1];
        var U = R.split(/ *, */).map((z, H) => z.slice(-1) === "%" ? H === 3 ? parseInt(z) / 100 : parseInt(z) / 100 * 255 : Number(z));
        return {
          r: U[0],
          g: U[1],
          b: U[2],
          a: U[3]
        };
      }
    },
    _hex8ColorToRGBA(R) {
      if (R[0] === "#" && R.length === 9)
        return {
          r: parseInt(R.slice(1, 3), 16),
          g: parseInt(R.slice(3, 5), 16),
          b: parseInt(R.slice(5, 7), 16),
          a: parseInt(R.slice(7, 9), 16) / 255
        };
    },
    _hex6ColorToRGBA(R) {
      if (R[0] === "#" && R.length === 7)
        return {
          r: parseInt(R.slice(1, 3), 16),
          g: parseInt(R.slice(3, 5), 16),
          b: parseInt(R.slice(5, 7), 16),
          a: 1
        };
    },
    _hex4ColorToRGBA(R) {
      if (R[0] === "#" && R.length === 5)
        return {
          r: parseInt(R[1] + R[1], 16),
          g: parseInt(R[2] + R[2], 16),
          b: parseInt(R[3] + R[3], 16),
          a: parseInt(R[4] + R[4], 16) / 255
        };
    },
    _hex3ColorToRGBA(R) {
      if (R[0] === "#" && R.length === 4)
        return {
          r: parseInt(R[1] + R[1], 16),
          g: parseInt(R[2] + R[2], 16),
          b: parseInt(R[3] + R[3], 16),
          a: 1
        };
    },
    _hslColorToRGBA(R) {
      if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(R)) {
        const [U, ...z] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(R), H = Number(z[0]) / 360, K = Number(z[1]) / 100, q = Number(z[2]) / 100;
        let Q, Z, X;
        if (K === 0)
          return X = q * 255, {
            r: Math.round(X),
            g: Math.round(X),
            b: Math.round(X),
            a: 1
          };
        q < 0.5 ? Q = q * (1 + K) : Q = q + K - q * K;
        const se = 2 * q - Q, te = [0, 0, 0];
        for (let fe = 0; fe < 3; fe++)
          Z = H + 1 / 3 * -(fe - 1), Z < 0 && Z++, Z > 1 && Z--, 6 * Z < 1 ? X = se + (Q - se) * 6 * Z : 2 * Z < 1 ? X = Q : 3 * Z < 2 ? X = se + (Q - se) * (2 / 3 - Z) * 6 : X = se, te[fe] = X * 255;
        return {
          r: Math.round(te[0]),
          g: Math.round(te[1]),
          b: Math.round(te[2]),
          a: 1
        };
      }
    },
    haveIntersection(R, U) {
      return !(U.x > R.x + R.width || U.x + U.width < R.x || U.y > R.y + R.height || U.y + U.height < R.y);
    },
    cloneObject(R) {
      var U = {};
      for (var z in R)
        this._isPlainObject(R[z]) ? U[z] = this.cloneObject(R[z]) : this._isArray(R[z]) ? U[z] = this.cloneArray(R[z]) : U[z] = R[z];
      return U;
    },
    cloneArray(R) {
      return R.slice(0);
    },
    degToRad(R) {
      return R * u;
    },
    radToDeg(R) {
      return R * m;
    },
    _degToRad(R) {
      return e.Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), e.Util.degToRad(R);
    },
    _radToDeg(R) {
      return e.Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), e.Util.radToDeg(R);
    },
    _getRotation(R) {
      return t.Konva.angleDeg ? e.Util.radToDeg(R) : R;
    },
    _capitalize(R) {
      return R.charAt(0).toUpperCase() + R.slice(1);
    },
    throw(R) {
      throw new Error(j + R);
    },
    error(R) {
      console.error(j + R);
    },
    warn(R) {
      t.Konva.showWarnings && console.warn(k + R);
    },
    each(R, U) {
      for (var z in R)
        U(z, R[z]);
    },
    _inRange(R, U, z) {
      return U <= R && R < z;
    },
    _getProjectionToSegment(R, U, z, H, K, q) {
      var Q, Z, X, se = (R - z) * (R - z) + (U - H) * (U - H);
      if (se == 0)
        Q = R, Z = U, X = (K - z) * (K - z) + (q - H) * (q - H);
      else {
        var te = ((K - R) * (z - R) + (q - U) * (H - U)) / se;
        te < 0 ? (Q = R, Z = U, X = (R - K) * (R - K) + (U - q) * (U - q)) : te > 1 ? (Q = z, Z = H, X = (z - K) * (z - K) + (H - q) * (H - q)) : (Q = R + te * (z - R), Z = U + te * (H - U), X = (Q - K) * (Q - K) + (Z - q) * (Z - q));
      }
      return [Q, Z, X];
    },
    _getProjectionToLine(R, U, z) {
      var H = e.Util.cloneObject(R), K = Number.MAX_VALUE;
      return U.forEach(function(q, Q) {
        if (!(!z && Q === U.length - 1)) {
          var Z = U[(Q + 1) % U.length], X = e.Util._getProjectionToSegment(q.x, q.y, Z.x, Z.y, R.x, R.y), se = X[0], te = X[1], fe = X[2];
          fe < K && (H.x = se, H.y = te, K = fe);
        }
      }), H;
    },
    _prepareArrayForTween(R, U, z) {
      var H, K = [], q = [];
      if (R.length > U.length) {
        var Q = U;
        U = R, R = Q;
      }
      for (H = 0; H < R.length; H += 2)
        K.push({
          x: R[H],
          y: R[H + 1]
        });
      for (H = 0; H < U.length; H += 2)
        q.push({
          x: U[H],
          y: U[H + 1]
        });
      var Z = [];
      return q.forEach(function(X) {
        var se = e.Util._getProjectionToLine(X, K, z);
        Z.push(se.x), Z.push(se.y);
      }), Z;
    },
    _prepareToStringify(R) {
      var U;
      R.visitedByCircularReferenceRemoval = !0;
      for (var z in R)
        if (R.hasOwnProperty(z) && R[z] && typeof R[z] == "object") {
          if (U = Object.getOwnPropertyDescriptor(R, z), R[z].visitedByCircularReferenceRemoval || e.Util._isElement(R[z]))
            if (U.configurable)
              delete R[z];
            else
              return null;
          else if (e.Util._prepareToStringify(R[z]) === null)
            if (U.configurable)
              delete R[z];
            else
              return null;
        }
      return delete R.visitedByCircularReferenceRemoval, R;
    },
    _assign(R, U) {
      for (var z in U)
        R[z] = U[z];
      return R;
    },
    _getFirstPointerId(R) {
      return R.touches ? R.changedTouches[0].identifier : R.pointerId || 999;
    },
    releaseCanvas(...R) {
      t.Konva.releaseCanvasOnDestroy && R.forEach((U) => {
        U.width = 0, U.height = 0;
      });
    },
    drawRoundedRectPath(R, U, z, H) {
      let K = 0, q = 0, Q = 0, Z = 0;
      typeof H == "number" ? K = q = Q = Z = Math.min(H, U / 2, z / 2) : (K = Math.min(H[0] || 0, U / 2, z / 2), q = Math.min(H[1] || 0, U / 2, z / 2), Z = Math.min(H[2] || 0, U / 2, z / 2), Q = Math.min(H[3] || 0, U / 2, z / 2)), R.moveTo(K, 0), R.lineTo(U - q, 0), R.arc(U - q, q, q, Math.PI * 3 / 2, 0, !1), R.lineTo(U, z - Z), R.arc(U - Z, z - Z, Z, 0, Math.PI / 2, !1), R.lineTo(Q, z), R.arc(Q, z - Q, Q, Math.PI / 2, Math.PI, !1), R.lineTo(0, K), R.arc(K, K, K, Math.PI, Math.PI * 3 / 2, !1);
    }
  };
})(cl);
var ko = {}, Sa = {}, Jn = {};
Object.defineProperty(Jn, "__esModule", { value: !0 });
Jn.getComponentValidator = Jn.getBooleanValidator = Jn.getNumberArrayValidator = Jn.getFunctionValidator = Jn.getStringOrGradientValidator = Jn.getStringValidator = Jn.getNumberOrAutoValidator = Jn.getNumberOrArrayOfNumbersValidator = Jn.getNumberValidator = Jn.alphaComponent = Jn.RGBComponent = void 0;
const Zv = ha, Pl = cl;
function Jv(e) {
  return Pl.Util._isString(e) ? '"' + e + '"' : Object.prototype.toString.call(e) === "[object Number]" || Pl.Util._isBoolean(e) ? e : Object.prototype.toString.call(e);
}
function Nxe(e) {
  return e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
}
Jn.RGBComponent = Nxe;
function jxe(e) {
  return e > 1 ? 1 : e < 1e-4 ? 1e-4 : e;
}
Jn.alphaComponent = jxe;
function Exe() {
  if (Zv.Konva.isUnminified)
    return function(e, t) {
      return Pl.Util._isNumber(e) || Pl.Util.warn(Jv(e) + ' is a not valid value for "' + t + '" attribute. The value should be a number.'), e;
    };
}
Jn.getNumberValidator = Exe;
function kxe(e) {
  if (Zv.Konva.isUnminified)
    return function(t, n) {
      let r = Pl.Util._isNumber(t), s = Pl.Util._isArray(t) && t.length == e;
      return !r && !s && Pl.Util.warn(Jv(t) + ' is a not valid value for "' + n + '" attribute. The value should be a number or Array<number>(' + e + ")"), t;
    };
}
Jn.getNumberOrArrayOfNumbersValidator = kxe;
function _xe() {
  if (Zv.Konva.isUnminified)
    return function(e, t) {
      var n = Pl.Util._isNumber(e), r = e === "auto";
      return n || r || Pl.Util.warn(Jv(e) + ' is a not valid value for "' + t + '" attribute. The value should be a number or "auto".'), e;
    };
}
Jn.getNumberOrAutoValidator = _xe;
function Txe() {
  if (Zv.Konva.isUnminified)
    return function(e, t) {
      return Pl.Util._isString(e) || Pl.Util.warn(Jv(e) + ' is a not valid value for "' + t + '" attribute. The value should be a string.'), e;
    };
}
Jn.getStringValidator = Txe;
function Mxe() {
  if (Zv.Konva.isUnminified)
    return function(e, t) {
      const n = Pl.Util._isString(e), r = Object.prototype.toString.call(e) === "[object CanvasGradient]" || e && e.addColorStop;
      return n || r || Pl.Util.warn(Jv(e) + ' is a not valid value for "' + t + '" attribute. The value should be a string or a native gradient.'), e;
    };
}
Jn.getStringOrGradientValidator = Mxe;
function Rxe() {
  if (Zv.Konva.isUnminified)
    return function(e, t) {
      return Pl.Util._isFunction(e) || Pl.Util.warn(Jv(e) + ' is a not valid value for "' + t + '" attribute. The value should be a function.'), e;
    };
}
Jn.getFunctionValidator = Rxe;
function Dxe() {
  if (Zv.Konva.isUnminified)
    return function(e, t) {
      const n = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
      return n && e instanceof n || (Pl.Util._isArray(e) ? e.forEach(function(r) {
        Pl.Util._isNumber(r) || Pl.Util.warn('"' + t + '" attribute has non numeric element ' + r + ". Make sure that all elements are numbers.");
      }) : Pl.Util.warn(Jv(e) + ' is a not valid value for "' + t + '" attribute. The value should be a array of numbers.')), e;
    };
}
Jn.getNumberArrayValidator = Dxe;
function Pxe() {
  if (Zv.Konva.isUnminified)
    return function(e, t) {
      var n = e === !0 || e === !1;
      return n || Pl.Util.warn(Jv(e) + ' is a not valid value for "' + t + '" attribute. The value should be a boolean.'), e;
    };
}
Jn.getBooleanValidator = Pxe;
function Oxe(e) {
  if (Zv.Konva.isUnminified)
    return function(t, n) {
      return t == null || Pl.Util.isObject(t) || Pl.Util.warn(Jv(t) + ' is a not valid value for "' + n + '" attribute. The value should be an object with properties ' + e), t;
    };
}
Jn.getComponentValidator = Oxe;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Factory = void 0;
  const t = cl, n = Jn;
  var r = "get", s = "set";
  e.Factory = {
    addGetterSetter(o, c, u, m, y) {
      e.Factory.addGetter(o, c, u), e.Factory.addSetter(o, c, m, y), e.Factory.addOverloadedGetterSetter(o, c);
    },
    addGetter(o, c, u) {
      var m = r + t.Util._capitalize(c);
      o.prototype[m] = o.prototype[m] || function() {
        var y = this.attrs[c];
        return y === void 0 ? u : y;
      };
    },
    addSetter(o, c, u, m) {
      var y = s + t.Util._capitalize(c);
      o.prototype[y] || e.Factory.overWriteSetter(o, c, u, m);
    },
    overWriteSetter(o, c, u, m) {
      var y = s + t.Util._capitalize(c);
      o.prototype[y] = function(b) {
        return u && b !== void 0 && b !== null && (b = u.call(this, b, c)), this._setAttr(c, b), m && m.call(this), this;
      };
    },
    addComponentsGetterSetter(o, c, u, m, y) {
      var b = u.length, w = t.Util._capitalize, k = r + w(c), j = s + w(c), E, T;
      o.prototype[k] = function() {
        var L = {};
        for (E = 0; E < b; E++)
          T = u[E], L[T] = this.getAttr(c + w(T));
        return L;
      };
      var D = (0, n.getComponentValidator)(u);
      o.prototype[j] = function(L) {
        var I = this.attrs[c], R;
        m && (L = m.call(this, L)), D && D.call(this, L, c);
        for (R in L)
          L.hasOwnProperty(R) && this._setAttr(c + w(R), L[R]);
        return L || u.forEach((U) => {
          this._setAttr(c + w(U), void 0);
        }), this._fireChangeEvent(c, I, L), y && y.call(this), this;
      }, e.Factory.addOverloadedGetterSetter(o, c);
    },
    addOverloadedGetterSetter(o, c) {
      var u = t.Util._capitalize(c), m = s + u, y = r + u;
      o.prototype[c] = function() {
        return arguments.length ? (this[m](arguments[0]), this) : this[y]();
      };
    },
    addDeprecatedGetterSetter(o, c, u, m) {
      t.Util.error("Adding deprecated " + c);
      var y = r + t.Util._capitalize(c), b = c + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
      o.prototype[y] = function() {
        t.Util.error(b);
        var w = this.attrs[c];
        return w === void 0 ? u : w;
      }, e.Factory.addSetter(o, c, m, function() {
        t.Util.error(b);
      }), e.Factory.addOverloadedGetterSetter(o, c);
    },
    backCompat(o, c) {
      t.Util.each(c, function(u, m) {
        var y = o.prototype[m], b = r + t.Util._capitalize(u), w = s + t.Util._capitalize(u);
        function k() {
          y.apply(this, arguments), t.Util.error('"' + u + '" method is deprecated and will be removed soon. Use ""' + m + '" instead.');
        }
        o.prototype[u] = k, o.prototype[b] = k, o.prototype[w] = k;
      });
    },
    afterSetFilter() {
      this._filterUpToDate = !1;
    }
  };
})(Sa);
var Kg = {}, zv = {};
Object.defineProperty(zv, "__esModule", { value: !0 });
zv.HitContext = zv.SceneContext = zv.Context = void 0;
const xY = cl, Axe = ha;
function Lxe(e) {
  var t = [], n = e.length, r = xY.Util, s, o;
  for (s = 0; s < n; s++)
    o = e[s], r._isNumber(o) ? o = Math.round(o * 1e3) / 1e3 : r._isString(o) || (o = o + ""), t.push(o);
  return t;
}
var qz = ",", Ixe = "(", Fxe = ")", Uxe = "([", zxe = "])", Bxe = ";", Hxe = "()", Vxe = "=", Kz = [
  "arc",
  "arcTo",
  "beginPath",
  "bezierCurveTo",
  "clearRect",
  "clip",
  "closePath",
  "createLinearGradient",
  "createPattern",
  "createRadialGradient",
  "drawImage",
  "ellipse",
  "fill",
  "fillText",
  "getImageData",
  "createImageData",
  "lineTo",
  "moveTo",
  "putImageData",
  "quadraticCurveTo",
  "rect",
  "roundRect",
  "restore",
  "rotate",
  "save",
  "scale",
  "setLineDash",
  "setTransform",
  "stroke",
  "strokeText",
  "transform",
  "translate"
], $xe = [
  "fillStyle",
  "strokeStyle",
  "shadowColor",
  "shadowBlur",
  "shadowOffsetX",
  "shadowOffsetY",
  "letterSpacing",
  "lineCap",
  "lineDashOffset",
  "lineJoin",
  "lineWidth",
  "miterLimit",
  "direction",
  "font",
  "textAlign",
  "textBaseline",
  "globalAlpha",
  "globalCompositeOperation",
  "imageSmoothingEnabled"
];
const Gxe = 100;
class pk {
  constructor(t) {
    this.canvas = t, Axe.Konva.enableTrace && (this.traceArr = [], this._enableTrace());
  }
  fillShape(t) {
    t.fillEnabled() && this._fill(t);
  }
  _fill(t) {
  }
  strokeShape(t) {
    t.hasStroke() && this._stroke(t);
  }
  _stroke(t) {
  }
  fillStrokeShape(t) {
    t.attrs.fillAfterStrokeEnabled ? (this.strokeShape(t), this.fillShape(t)) : (this.fillShape(t), this.strokeShape(t));
  }
  getTrace(t, n) {
    var r = this.traceArr, s = r.length, o = "", c, u, m, y;
    for (c = 0; c < s; c++)
      u = r[c], m = u.method, m ? (y = u.args, o += m, t ? o += Hxe : xY.Util._isArray(y[0]) ? o += Uxe + y.join(qz) + zxe : (n && (y = y.map((b) => typeof b == "number" ? Math.floor(b) : b)), o += Ixe + y.join(qz) + Fxe)) : (o += u.property, t || (o += Vxe + u.val)), o += Bxe;
    return o;
  }
  clearTrace() {
    this.traceArr = [];
  }
  _trace(t) {
    var n = this.traceArr, r;
    n.push(t), r = n.length, r >= Gxe && n.shift();
  }
  reset() {
    var t = this.getCanvas().getPixelRatio();
    this.setTransform(1 * t, 0, 0, 1 * t, 0, 0);
  }
  getCanvas() {
    return this.canvas;
  }
  clear(t) {
    var n = this.getCanvas();
    t ? this.clearRect(t.x || 0, t.y || 0, t.width || 0, t.height || 0) : this.clearRect(0, 0, n.getWidth() / n.pixelRatio, n.getHeight() / n.pixelRatio);
  }
  _applyLineCap(t) {
    const n = t.attrs.lineCap;
    n && this.setAttr("lineCap", n);
  }
  _applyOpacity(t) {
    var n = t.getAbsoluteOpacity();
    n !== 1 && this.setAttr("globalAlpha", n);
  }
  _applyLineJoin(t) {
    const n = t.attrs.lineJoin;
    n && this.setAttr("lineJoin", n);
  }
  setAttr(t, n) {
    this._context[t] = n;
  }
  arc(t, n, r, s, o, c) {
    this._context.arc(t, n, r, s, o, c);
  }
  arcTo(t, n, r, s, o) {
    this._context.arcTo(t, n, r, s, o);
  }
  beginPath() {
    this._context.beginPath();
  }
  bezierCurveTo(t, n, r, s, o, c) {
    this._context.bezierCurveTo(t, n, r, s, o, c);
  }
  clearRect(t, n, r, s) {
    this._context.clearRect(t, n, r, s);
  }
  clip(...t) {
    this._context.clip.apply(this._context, t);
  }
  closePath() {
    this._context.closePath();
  }
  createImageData(t, n) {
    var r = arguments;
    if (r.length === 2)
      return this._context.createImageData(t, n);
    if (r.length === 1)
      return this._context.createImageData(t);
  }
  createLinearGradient(t, n, r, s) {
    return this._context.createLinearGradient(t, n, r, s);
  }
  createPattern(t, n) {
    return this._context.createPattern(t, n);
  }
  createRadialGradient(t, n, r, s, o, c) {
    return this._context.createRadialGradient(t, n, r, s, o, c);
  }
  drawImage(t, n, r, s, o, c, u, m, y) {
    var b = arguments, w = this._context;
    b.length === 3 ? w.drawImage(t, n, r) : b.length === 5 ? w.drawImage(t, n, r, s, o) : b.length === 9 && w.drawImage(t, n, r, s, o, c, u, m, y);
  }
  ellipse(t, n, r, s, o, c, u, m) {
    this._context.ellipse(t, n, r, s, o, c, u, m);
  }
  isPointInPath(t, n, r, s) {
    return r ? this._context.isPointInPath(r, t, n, s) : this._context.isPointInPath(t, n, s);
  }
  fill(...t) {
    this._context.fill.apply(this._context, t);
  }
  fillRect(t, n, r, s) {
    this._context.fillRect(t, n, r, s);
  }
  strokeRect(t, n, r, s) {
    this._context.strokeRect(t, n, r, s);
  }
  fillText(t, n, r, s) {
    s ? this._context.fillText(t, n, r, s) : this._context.fillText(t, n, r);
  }
  measureText(t) {
    return this._context.measureText(t);
  }
  getImageData(t, n, r, s) {
    return this._context.getImageData(t, n, r, s);
  }
  lineTo(t, n) {
    this._context.lineTo(t, n);
  }
  moveTo(t, n) {
    this._context.moveTo(t, n);
  }
  rect(t, n, r, s) {
    this._context.rect(t, n, r, s);
  }
  roundRect(t, n, r, s, o) {
    this._context.roundRect(t, n, r, s, o);
  }
  putImageData(t, n, r) {
    this._context.putImageData(t, n, r);
  }
  quadraticCurveTo(t, n, r, s) {
    this._context.quadraticCurveTo(t, n, r, s);
  }
  restore() {
    this._context.restore();
  }
  rotate(t) {
    this._context.rotate(t);
  }
  save() {
    this._context.save();
  }
  scale(t, n) {
    this._context.scale(t, n);
  }
  setLineDash(t) {
    this._context.setLineDash ? this._context.setLineDash(t) : "mozDash" in this._context ? this._context.mozDash = t : "webkitLineDash" in this._context && (this._context.webkitLineDash = t);
  }
  getLineDash() {
    return this._context.getLineDash();
  }
  setTransform(t, n, r, s, o, c) {
    this._context.setTransform(t, n, r, s, o, c);
  }
  stroke(t) {
    t ? this._context.stroke(t) : this._context.stroke();
  }
  strokeText(t, n, r, s) {
    this._context.strokeText(t, n, r, s);
  }
  transform(t, n, r, s, o, c) {
    this._context.transform(t, n, r, s, o, c);
  }
  translate(t, n) {
    this._context.translate(t, n);
  }
  _enableTrace() {
    var t = this, n = Kz.length, r = this.setAttr, s, o, c = function(u) {
      var m = t[u], y;
      t[u] = function() {
        return o = Lxe(Array.prototype.slice.call(arguments, 0)), y = m.apply(t, arguments), t._trace({
          method: u,
          args: o
        }), y;
      };
    };
    for (s = 0; s < n; s++)
      c(Kz[s]);
    t.setAttr = function() {
      r.apply(t, arguments);
      var u = arguments[0], m = arguments[1];
      (u === "shadowOffsetX" || u === "shadowOffsetY" || u === "shadowBlur") && (m = m / this.canvas.getPixelRatio()), t._trace({
        property: u,
        val: m
      });
    };
  }
  _applyGlobalCompositeOperation(t) {
    const n = t.attrs.globalCompositeOperation;
    var r = !n || n === "source-over";
    r || this.setAttr("globalCompositeOperation", n);
  }
}
zv.Context = pk;
$xe.forEach(function(e) {
  Object.defineProperty(pk.prototype, e, {
    get() {
      return this._context[e];
    },
    set(t) {
      this._context[e] = t;
    }
  });
});
class Wxe extends pk {
  constructor(t, { willReadFrequently: n = !1 } = {}) {
    super(t), this._context = t._canvas.getContext("2d", {
      willReadFrequently: n
    });
  }
  _fillColor(t) {
    var n = t.fill();
    this.setAttr("fillStyle", n), t._fillFunc(this);
  }
  _fillPattern(t) {
    this.setAttr("fillStyle", t._getFillPattern()), t._fillFunc(this);
  }
  _fillLinearGradient(t) {
    var n = t._getLinearGradient();
    n && (this.setAttr("fillStyle", n), t._fillFunc(this));
  }
  _fillRadialGradient(t) {
    const n = t._getRadialGradient();
    n && (this.setAttr("fillStyle", n), t._fillFunc(this));
  }
  _fill(t) {
    const n = t.fill(), r = t.getFillPriority();
    if (n && r === "color") {
      this._fillColor(t);
      return;
    }
    const s = t.getFillPatternImage();
    if (s && r === "pattern") {
      this._fillPattern(t);
      return;
    }
    const o = t.getFillLinearGradientColorStops();
    if (o && r === "linear-gradient") {
      this._fillLinearGradient(t);
      return;
    }
    const c = t.getFillRadialGradientColorStops();
    if (c && r === "radial-gradient") {
      this._fillRadialGradient(t);
      return;
    }
    n ? this._fillColor(t) : s ? this._fillPattern(t) : o ? this._fillLinearGradient(t) : c && this._fillRadialGradient(t);
  }
  _strokeLinearGradient(t) {
    const n = t.getStrokeLinearGradientStartPoint(), r = t.getStrokeLinearGradientEndPoint(), s = t.getStrokeLinearGradientColorStops(), o = this.createLinearGradient(n.x, n.y, r.x, r.y);
    if (s) {
      for (var c = 0; c < s.length; c += 2)
        o.addColorStop(s[c], s[c + 1]);
      this.setAttr("strokeStyle", o);
    }
  }
  _stroke(t) {
    var n = t.dash(), r = t.getStrokeScaleEnabled();
    if (t.hasStroke()) {
      if (!r) {
        this.save();
        var s = this.getCanvas().getPixelRatio();
        this.setTransform(s, 0, 0, s, 0, 0);
      }
      this._applyLineCap(t), n && t.dashEnabled() && (this.setLineDash(n), this.setAttr("lineDashOffset", t.dashOffset())), this.setAttr("lineWidth", t.strokeWidth()), t.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)");
      var o = t.getStrokeLinearGradientColorStops();
      o ? this._strokeLinearGradient(t) : this.setAttr("strokeStyle", t.stroke()), t._strokeFunc(this), r || this.restore();
    }
  }
  _applyShadow(t) {
    var n, r, s, o = (n = t.getShadowRGBA()) !== null && n !== void 0 ? n : "black", c = (r = t.getShadowBlur()) !== null && r !== void 0 ? r : 5, u = (s = t.getShadowOffset()) !== null && s !== void 0 ? s : {
      x: 0,
      y: 0
    }, m = t.getAbsoluteScale(), y = this.canvas.getPixelRatio(), b = m.x * y, w = m.y * y;
    this.setAttr("shadowColor", o), this.setAttr("shadowBlur", c * Math.min(Math.abs(b), Math.abs(w))), this.setAttr("shadowOffsetX", u.x * b), this.setAttr("shadowOffsetY", u.y * w);
  }
}
zv.SceneContext = Wxe;
class Yxe extends pk {
  constructor(t) {
    super(t), this._context = t._canvas.getContext("2d", {
      willReadFrequently: !0
    });
  }
  _fill(t) {
    this.save(), this.setAttr("fillStyle", t.colorKey), t._fillFuncHit(this), this.restore();
  }
  strokeShape(t) {
    t.hasHitStroke() && this._stroke(t);
  }
  _stroke(t) {
    if (t.hasHitStroke()) {
      const o = t.getStrokeScaleEnabled();
      if (!o) {
        this.save();
        var n = this.getCanvas().getPixelRatio();
        this.setTransform(n, 0, 0, n, 0, 0);
      }
      this._applyLineCap(t);
      var r = t.hitStrokeWidth(), s = r === "auto" ? t.strokeWidth() : r;
      this.setAttr("lineWidth", s), this.setAttr("strokeStyle", t.colorKey), t._strokeFuncHit(this), o || this.restore();
    }
  }
}
zv.HitContext = Yxe;
Object.defineProperty(Kg, "__esModule", { value: !0 });
Kg.HitCanvas = Kg.SceneCanvas = Kg.Canvas = void 0;
const Q9 = cl, bY = zv, SY = ha, qxe = Sa, Kxe = Jn;
var Pj;
function Xxe() {
  if (Pj)
    return Pj;
  var e = Q9.Util.createCanvasElement(), t = e.getContext("2d");
  return Pj = function() {
    var n = SY.Konva._global.devicePixelRatio || 1, r = t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1;
    return n / r;
  }(), Q9.Util.releaseCanvas(e), Pj;
}
class gk {
  constructor(t) {
    this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
    var n = t || {}, r = n.pixelRatio || SY.Konva.pixelRatio || Xxe();
    this.pixelRatio = r, this._canvas = Q9.Util.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
  }
  getContext() {
    return this.context;
  }
  getPixelRatio() {
    return this.pixelRatio;
  }
  setPixelRatio(t) {
    var n = this.pixelRatio;
    this.pixelRatio = t, this.setSize(this.getWidth() / n, this.getHeight() / n);
  }
  setWidth(t) {
    this.width = this._canvas.width = t * this.pixelRatio, this._canvas.style.width = t + "px";
    var n = this.pixelRatio, r = this.getContext()._context;
    r.scale(n, n);
  }
  setHeight(t) {
    this.height = this._canvas.height = t * this.pixelRatio, this._canvas.style.height = t + "px";
    var n = this.pixelRatio, r = this.getContext()._context;
    r.scale(n, n);
  }
  getWidth() {
    return this.width;
  }
  getHeight() {
    return this.height;
  }
  setSize(t, n) {
    this.setWidth(t || 0), this.setHeight(n || 0);
  }
  toDataURL(t, n) {
    try {
      return this._canvas.toDataURL(t, n);
    } catch {
      try {
        return this._canvas.toDataURL();
      } catch (s) {
        return Q9.Util.error("Unable to get data URL. " + s.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
      }
    }
  }
}
Kg.Canvas = gk;
qxe.Factory.addGetterSetter(gk, "pixelRatio", void 0, (0, Kxe.getNumberValidator)());
class Qxe extends gk {
  constructor(t = { width: 0, height: 0, willReadFrequently: !1 }) {
    super(t), this.context = new bY.SceneContext(this, {
      willReadFrequently: t.willReadFrequently
    }), this.setSize(t.width, t.height);
  }
}
Kg.SceneCanvas = Qxe;
class Zxe extends gk {
  constructor(t = { width: 0, height: 0 }) {
    super(t), this.hitCanvas = !0, this.context = new bY.HitContext(this), this.setSize(t.width, t.height);
  }
}
Kg.HitCanvas = Zxe;
var yk = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DD = void 0;
  const t = ha, n = cl;
  e.DD = {
    get isDragging() {
      var r = !1;
      return e.DD._dragElements.forEach((s) => {
        s.dragStatus === "dragging" && (r = !0);
      }), r;
    },
    justDragged: !1,
    get node() {
      var r;
      return e.DD._dragElements.forEach((s) => {
        r = s.node;
      }), r;
    },
    _dragElements: /* @__PURE__ */ new Map(),
    _drag(r) {
      const s = [];
      e.DD._dragElements.forEach((o, c) => {
        const { node: u } = o, m = u.getStage();
        m.setPointersPositions(r), o.pointerId === void 0 && (o.pointerId = n.Util._getFirstPointerId(r));
        const y = m._changedPointerPositions.find((k) => k.id === o.pointerId);
        if (y) {
          if (o.dragStatus !== "dragging") {
            var b = u.dragDistance(), w = Math.max(Math.abs(y.x - o.startPointerPos.x), Math.abs(y.y - o.startPointerPos.y));
            if (w < b || (u.startDrag({ evt: r }), !u.isDragging()))
              return;
          }
          u._setDragPosition(r, o), s.push(u);
        }
      }), s.forEach((o) => {
        o.fire("dragmove", {
          type: "dragmove",
          target: o,
          evt: r
        }, !0);
      });
    },
    _endDragBefore(r) {
      const s = [];
      e.DD._dragElements.forEach((o) => {
        const { node: c } = o, u = c.getStage();
        if (r && u.setPointersPositions(r), !u._changedPointerPositions.find((b) => b.id === o.pointerId))
          return;
        (o.dragStatus === "dragging" || o.dragStatus === "stopped") && (e.DD.justDragged = !0, t.Konva._mouseListenClick = !1, t.Konva._touchListenClick = !1, t.Konva._pointerListenClick = !1, o.dragStatus = "stopped");
        const y = o.node.getLayer() || o.node instanceof t.Konva.Stage && o.node;
        y && s.indexOf(y) === -1 && s.push(y);
      }), s.forEach((o) => {
        o.draw();
      });
    },
    _endDragAfter(r) {
      e.DD._dragElements.forEach((s, o) => {
        s.dragStatus === "stopped" && s.node.fire("dragend", {
          type: "dragend",
          target: s.node,
          evt: r
        }, !0), s.dragStatus !== "dragging" && e.DD._dragElements.delete(o);
      });
    }
  }, t.Konva.isBrowser && (window.addEventListener("mouseup", e.DD._endDragBefore, !0), window.addEventListener("touchend", e.DD._endDragBefore, !0), window.addEventListener("mousemove", e.DD._drag), window.addEventListener("touchmove", e.DD._drag), window.addEventListener("mouseup", e.DD._endDragAfter, !1), window.addEventListener("touchend", e.DD._endDragAfter, !1));
})(yk);
Object.defineProperty(ko, "__esModule", { value: !0 });
ko.Node = void 0;
const Wa = cl, S6 = Sa, I7 = Kg, l2 = ha, h1 = yk, Jl = Jn;
var c9 = "absoluteOpacity", Oj = "allEventListeners", jv = "absoluteTransform", Xz = "absoluteScale", j4 = "canvas", Jxe = "Change", e2e = "children", t2e = "konva", KD = "listening", Qz = "mouseenter", Zz = "mouseleave", Jz = "set", eB = "Shape", u9 = " ", tB = "stage", g2 = "transform", n2e = "Stage", XD = "visible", r2e = [
  "xChange.konva",
  "yChange.konva",
  "scaleXChange.konva",
  "scaleYChange.konva",
  "skewXChange.konva",
  "skewYChange.konva",
  "rotationChange.konva",
  "offsetXChange.konva",
  "offsetYChange.konva",
  "transformsEnabledChange.konva"
].join(u9);
let a2e = 1, oa = class QD {
  constructor(t) {
    this._id = a2e++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(t), this._shouldFireChangeEvents = !0;
  }
  hasChildren() {
    return !1;
  }
  _clearCache(t) {
    (t === g2 || t === jv) && this._cache.get(t) ? this._cache.get(t).dirty = !0 : t ? this._cache.delete(t) : this._cache.clear();
  }
  _getCache(t, n) {
    var r = this._cache.get(t), s = t === g2 || t === jv, o = r === void 0 || s && r.dirty === !0;
    return o && (r = n.call(this), this._cache.set(t, r)), r;
  }
  _calculate(t, n, r) {
    if (!this._attachedDepsListeners.get(t)) {
      const s = n.map((o) => o + "Change.konva").join(u9);
      this.on(s, () => {
        this._clearCache(t);
      }), this._attachedDepsListeners.set(t, !0);
    }
    return this._getCache(t, r);
  }
  _getCanvasCache() {
    return this._cache.get(j4);
  }
  _clearSelfAndDescendantCache(t) {
    this._clearCache(t), t === jv && this.fire("absoluteTransformChange");
  }
  clearCache() {
    if (this._cache.has(j4)) {
      const { scene: t, filter: n, hit: r } = this._cache.get(j4);
      Wa.Util.releaseCanvas(t, n, r), this._cache.delete(j4);
    }
    return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
  }
  cache(t) {
    var n = t || {}, r = {};
    (n.x === void 0 || n.y === void 0 || n.width === void 0 || n.height === void 0) && (r = this.getClientRect({
      skipTransform: !0,
      relativeTo: this.getParent() || void 0
    }));
    var s = Math.ceil(n.width || r.width), o = Math.ceil(n.height || r.height), c = n.pixelRatio, u = n.x === void 0 ? Math.floor(r.x) : n.x, m = n.y === void 0 ? Math.floor(r.y) : n.y, y = n.offset || 0, b = n.drawBorder || !1, w = n.hitCanvasPixelRatio || 1;
    if (!s || !o) {
      Wa.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
      return;
    }
    const k = Math.abs(Math.round(r.x) - u) > 0.5 ? 1 : 0, j = Math.abs(Math.round(r.y) - m) > 0.5 ? 1 : 0;
    s += y * 2 + k, o += y * 2 + j, u -= y, m -= y;
    var E = new I7.SceneCanvas({
      pixelRatio: c,
      width: s,
      height: o
    }), T = new I7.SceneCanvas({
      pixelRatio: c,
      width: 0,
      height: 0,
      willReadFrequently: !0
    }), D = new I7.HitCanvas({
      pixelRatio: w,
      width: s,
      height: o
    }), L = E.getContext(), I = D.getContext();
    return D.isCache = !0, E.isCache = !0, this._cache.delete(j4), this._filterUpToDate = !1, n.imageSmoothingEnabled === !1 && (E.getContext()._context.imageSmoothingEnabled = !1, T.getContext()._context.imageSmoothingEnabled = !1), L.save(), I.save(), L.translate(-u, -m), I.translate(-u, -m), this._isUnderCache = !0, this._clearSelfAndDescendantCache(c9), this._clearSelfAndDescendantCache(Xz), this.drawScene(E, this), this.drawHit(D, this), this._isUnderCache = !1, L.restore(), I.restore(), b && (L.save(), L.beginPath(), L.rect(0, 0, s, o), L.closePath(), L.setAttr("strokeStyle", "red"), L.setAttr("lineWidth", 5), L.stroke(), L.restore()), this._cache.set(j4, {
      scene: E,
      filter: T,
      hit: D,
      x: u,
      y: m
    }), this._requestDraw(), this;
  }
  isCached() {
    return this._cache.has(j4);
  }
  getClientRect(t) {
    throw new Error('abstract "getClientRect" method call');
  }
  _transformedRect(t, n) {
    var r = [
      { x: t.x, y: t.y },
      { x: t.x + t.width, y: t.y },
      { x: t.x + t.width, y: t.y + t.height },
      { x: t.x, y: t.y + t.height }
    ], s = 1 / 0, o = 1 / 0, c = -1 / 0, u = -1 / 0, m = this.getAbsoluteTransform(n);
    return r.forEach(function(y) {
      var b = m.point(y);
      s === void 0 && (s = c = b.x, o = u = b.y), s = Math.min(s, b.x), o = Math.min(o, b.y), c = Math.max(c, b.x), u = Math.max(u, b.y);
    }), {
      x: s,
      y: o,
      width: c - s,
      height: u - o
    };
  }
  _drawCachedSceneCanvas(t) {
    t.save(), t._applyOpacity(this), t._applyGlobalCompositeOperation(this);
    const n = this._getCanvasCache();
    t.translate(n.x, n.y);
    var r = this._getCachedSceneCanvas(), s = r.pixelRatio;
    t.drawImage(r._canvas, 0, 0, r.width / s, r.height / s), t.restore();
  }
  _drawCachedHitCanvas(t) {
    var n = this._getCanvasCache(), r = n.hit;
    t.save(), t.translate(n.x, n.y), t.drawImage(r._canvas, 0, 0, r.width / r.pixelRatio, r.height / r.pixelRatio), t.restore();
  }
  _getCachedSceneCanvas() {
    var t = this.filters(), n = this._getCanvasCache(), r = n.scene, s = n.filter, o = s.getContext(), c, u, m, y;
    if (t) {
      if (!this._filterUpToDate) {
        var b = r.pixelRatio;
        s.setSize(r.width / r.pixelRatio, r.height / r.pixelRatio);
        try {
          for (c = t.length, o.clear(), o.drawImage(r._canvas, 0, 0, r.getWidth() / b, r.getHeight() / b), u = o.getImageData(0, 0, s.getWidth(), s.getHeight()), m = 0; m < c; m++) {
            if (y = t[m], typeof y != "function") {
              Wa.Util.error("Filter should be type of function, but got " + typeof y + " instead. Please check correct filters");
              continue;
            }
            y.call(this, u), o.putImageData(u, 0, 0);
          }
        } catch (w) {
          Wa.Util.error("Unable to apply filter. " + w.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
        }
        this._filterUpToDate = !0;
      }
      return s;
    }
    return r;
  }
  on(t, n) {
    if (this._cache && this._cache.delete(Oj), arguments.length === 3)
      return this._delegate.apply(this, arguments);
    var r = t.split(u9), s = r.length, o, c, u, m, y;
    for (o = 0; o < s; o++)
      c = r[o], u = c.split("."), m = u[0], y = u[1] || "", this.eventListeners[m] || (this.eventListeners[m] = []), this.eventListeners[m].push({
        name: y,
        handler: n
      });
    return this;
  }
  off(t, n) {
    var r = (t || "").split(u9), s = r.length, o, c, u, m, y, b;
    if (this._cache && this._cache.delete(Oj), !t)
      for (c in this.eventListeners)
        this._off(c);
    for (o = 0; o < s; o++)
      if (u = r[o], m = u.split("."), y = m[0], b = m[1], y)
        this.eventListeners[y] && this._off(y, b, n);
      else
        for (c in this.eventListeners)
          this._off(c, b, n);
    return this;
  }
  dispatchEvent(t) {
    var n = {
      target: this,
      type: t.type,
      evt: t
    };
    return this.fire(t.type, n), this;
  }
  addEventListener(t, n) {
    return this.on(t, function(r) {
      n.call(this, r.evt);
    }), this;
  }
  removeEventListener(t) {
    return this.off(t), this;
  }
  _delegate(t, n, r) {
    var s = this;
    this.on(t, function(o) {
      for (var c = o.target.findAncestors(n, !0, s), u = 0; u < c.length; u++)
        o = Wa.Util.cloneObject(o), o.currentTarget = c[u], r.call(c[u], o);
    });
  }
  remove() {
    return this.isDragging() && this.stopDrag(), h1.DD._dragElements.delete(this._id), this._remove(), this;
  }
  _clearCaches() {
    this._clearSelfAndDescendantCache(jv), this._clearSelfAndDescendantCache(c9), this._clearSelfAndDescendantCache(Xz), this._clearSelfAndDescendantCache(tB), this._clearSelfAndDescendantCache(XD), this._clearSelfAndDescendantCache(KD);
  }
  _remove() {
    this._clearCaches();
    var t = this.getParent();
    t && t.children && (t.children.splice(this.index, 1), t._setChildrenIndices(), this.parent = null);
  }
  destroy() {
    return this.remove(), this.clearCache(), this;
  }
  getAttr(t) {
    var n = "get" + Wa.Util._capitalize(t);
    return Wa.Util._isFunction(this[n]) ? this[n]() : this.attrs[t];
  }
  getAncestors() {
    for (var t = this.getParent(), n = []; t; )
      n.push(t), t = t.getParent();
    return n;
  }
  getAttrs() {
    return this.attrs || {};
  }
  setAttrs(t) {
    return this._batchTransformChanges(() => {
      var n, r;
      if (!t)
        return this;
      for (n in t)
        n !== e2e && (r = Jz + Wa.Util._capitalize(n), Wa.Util._isFunction(this[r]) ? this[r](t[n]) : this._setAttr(n, t[n]));
    }), this;
  }
  isListening() {
    return this._getCache(KD, this._isListening);
  }
  _isListening(t) {
    if (!this.listening())
      return !1;
    const r = this.getParent();
    return r && r !== t && this !== t ? r._isListening(t) : !0;
  }
  isVisible() {
    return this._getCache(XD, this._isVisible);
  }
  _isVisible(t) {
    if (!this.visible())
      return !1;
    const r = this.getParent();
    return r && r !== t && this !== t ? r._isVisible(t) : !0;
  }
  shouldDrawHit(t, n = !1) {
    if (t)
      return this._isVisible(t) && this._isListening(t);
    var r = this.getLayer(), s = !1;
    h1.DD._dragElements.forEach((c) => {
      c.dragStatus === "dragging" && (c.node.nodeType === "Stage" || c.node.getLayer() === r) && (s = !0);
    });
    var o = !n && !l2.Konva.hitOnDragEnabled && (s || l2.Konva.isTransforming());
    return this.isListening() && this.isVisible() && !o;
  }
  show() {
    return this.visible(!0), this;
  }
  hide() {
    return this.visible(!1), this;
  }
  getZIndex() {
    return this.index || 0;
  }
  getAbsoluteZIndex() {
    var t = this.getDepth(), n = this, r = 0, s, o, c, u;
    function m(b) {
      for (s = [], o = b.length, c = 0; c < o; c++)
        u = b[c], r++, u.nodeType !== eB && (s = s.concat(u.getChildren().slice())), u._id === n._id && (c = o);
      s.length > 0 && s[0].getDepth() <= t && m(s);
    }
    const y = this.getStage();
    return n.nodeType !== n2e && y && m(y.getChildren()), r;
  }
  getDepth() {
    for (var t = 0, n = this.parent; n; )
      t++, n = n.parent;
    return t;
  }
  _batchTransformChanges(t) {
    this._batchingTransformChange = !0, t(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache(g2), this._clearSelfAndDescendantCache(jv)), this._needClearTransformCache = !1;
  }
  setPosition(t) {
    return this._batchTransformChanges(() => {
      this.x(t.x), this.y(t.y);
    }), this;
  }
  getPosition() {
    return {
      x: this.x(),
      y: this.y()
    };
  }
  getRelativePointerPosition() {
    const t = this.getStage();
    if (!t)
      return null;
    var n = t.getPointerPosition();
    if (!n)
      return null;
    var r = this.getAbsoluteTransform().copy();
    return r.invert(), r.point(n);
  }
  getAbsolutePosition(t) {
    let n = !1, r = this.parent;
    for (; r; ) {
      if (r.isCached()) {
        n = !0;
        break;
      }
      r = r.parent;
    }
    n && !t && (t = !0);
    var s = this.getAbsoluteTransform(t).getMatrix(), o = new Wa.Transform(), c = this.offset();
    return o.m = s.slice(), o.translate(c.x, c.y), o.getTranslation();
  }
  setAbsolutePosition(t) {
    const { x: n, y: r, ...s } = this._clearTransform();
    this.attrs.x = n, this.attrs.y = r, this._clearCache(g2);
    var o = this._getAbsoluteTransform().copy();
    return o.invert(), o.translate(t.x, t.y), t = {
      x: this.attrs.x + o.getTranslation().x,
      y: this.attrs.y + o.getTranslation().y
    }, this._setTransform(s), this.setPosition({ x: t.x, y: t.y }), this._clearCache(g2), this._clearSelfAndDescendantCache(jv), this;
  }
  _setTransform(t) {
    var n;
    for (n in t)
      this.attrs[n] = t[n];
  }
  _clearTransform() {
    var t = {
      x: this.x(),
      y: this.y(),
      rotation: this.rotation(),
      scaleX: this.scaleX(),
      scaleY: this.scaleY(),
      offsetX: this.offsetX(),
      offsetY: this.offsetY(),
      skewX: this.skewX(),
      skewY: this.skewY()
    };
    return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, t;
  }
  move(t) {
    var n = t.x, r = t.y, s = this.x(), o = this.y();
    return n !== void 0 && (s += n), r !== void 0 && (o += r), this.setPosition({ x: s, y: o }), this;
  }
  _eachAncestorReverse(t, n) {
    var r = [], s = this.getParent(), o, c;
    if (!(n && n._id === this._id)) {
      for (r.unshift(this); s && (!n || s._id !== n._id); )
        r.unshift(s), s = s.parent;
      for (o = r.length, c = 0; c < o; c++)
        t(r[c]);
    }
  }
  rotate(t) {
    return this.rotation(this.rotation() + t), this;
  }
  moveToTop() {
    if (!this.parent)
      return Wa.Util.warn("Node has no parent. moveToTop function is ignored."), !1;
    var t = this.index, n = this.parent.getChildren().length;
    return t < n - 1 ? (this.parent.children.splice(t, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveUp() {
    if (!this.parent)
      return Wa.Util.warn("Node has no parent. moveUp function is ignored."), !1;
    var t = this.index, n = this.parent.getChildren().length;
    return t < n - 1 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveDown() {
    if (!this.parent)
      return Wa.Util.warn("Node has no parent. moveDown function is ignored."), !1;
    var t = this.index;
    return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveToBottom() {
    if (!this.parent)
      return Wa.Util.warn("Node has no parent. moveToBottom function is ignored."), !1;
    var t = this.index;
    return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
  }
  setZIndex(t) {
    if (!this.parent)
      return Wa.Util.warn("Node has no parent. zIndex parameter is ignored."), this;
    (t < 0 || t >= this.parent.children.length) && Wa.Util.warn("Unexpected value " + t + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
    var n = this.index;
    return this.parent.children.splice(n, 1), this.parent.children.splice(t, 0, this), this.parent._setChildrenIndices(), this;
  }
  getAbsoluteOpacity() {
    return this._getCache(c9, this._getAbsoluteOpacity);
  }
  _getAbsoluteOpacity() {
    var t = this.opacity(), n = this.getParent();
    return n && !n._isUnderCache && (t *= n.getAbsoluteOpacity()), t;
  }
  moveTo(t) {
    return this.getParent() !== t && (this._remove(), t.add(this)), this;
  }
  toObject() {
    var t = this.getAttrs(), n, r, s, o, c;
    const u = {
      attrs: {},
      className: this.getClassName()
    };
    for (n in t)
      r = t[n], c = Wa.Util.isObject(r) && !Wa.Util._isPlainObject(r) && !Wa.Util._isArray(r), !c && (s = typeof this[n] == "function" && this[n], delete t[n], o = s ? s.call(this) : null, t[n] = r, o !== r && (u.attrs[n] = r));
    return Wa.Util._prepareToStringify(u);
  }
  toJSON() {
    return JSON.stringify(this.toObject());
  }
  getParent() {
    return this.parent;
  }
  findAncestors(t, n, r) {
    var s = [];
    n && this._isMatch(t) && s.push(this);
    for (var o = this.parent; o; ) {
      if (o === r)
        return s;
      o._isMatch(t) && s.push(o), o = o.parent;
    }
    return s;
  }
  isAncestorOf(t) {
    return !1;
  }
  findAncestor(t, n, r) {
    return this.findAncestors(t, n, r)[0];
  }
  _isMatch(t) {
    if (!t)
      return !1;
    if (typeof t == "function")
      return t(this);
    var n = t.replace(/ /g, "").split(","), r = n.length, s, o;
    for (s = 0; s < r; s++)
      if (o = n[s], Wa.Util.isValidSelector(o) || (Wa.Util.warn('Selector "' + o + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), Wa.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), Wa.Util.warn("Konva is awesome, right?")), o.charAt(0) === "#") {
        if (this.id() === o.slice(1))
          return !0;
      } else if (o.charAt(0) === ".") {
        if (this.hasName(o.slice(1)))
          return !0;
      } else if (this.className === o || this.nodeType === o)
        return !0;
    return !1;
  }
  getLayer() {
    var t = this.getParent();
    return t ? t.getLayer() : null;
  }
  getStage() {
    return this._getCache(tB, this._getStage);
  }
  _getStage() {
    var t = this.getParent();
    return t ? t.getStage() : null;
  }
  fire(t, n = {}, r) {
    return n.target = n.target || this, r ? this._fireAndBubble(t, n) : this._fire(t, n), this;
  }
  getAbsoluteTransform(t) {
    return t ? this._getAbsoluteTransform(t) : this._getCache(jv, this._getAbsoluteTransform);
  }
  _getAbsoluteTransform(t) {
    var n;
    if (t)
      return n = new Wa.Transform(), this._eachAncestorReverse(function(s) {
        var o = s.transformsEnabled();
        o === "all" ? n.multiply(s.getTransform()) : o === "position" && n.translate(s.x() - s.offsetX(), s.y() - s.offsetY());
      }, t), n;
    n = this._cache.get(jv) || new Wa.Transform(), this.parent ? this.parent.getAbsoluteTransform().copyInto(n) : n.reset();
    var r = this.transformsEnabled();
    if (r === "all")
      n.multiply(this.getTransform());
    else if (r === "position") {
      const s = this.attrs.x || 0, o = this.attrs.y || 0, c = this.attrs.offsetX || 0, u = this.attrs.offsetY || 0;
      n.translate(s - c, o - u);
    }
    return n.dirty = !1, n;
  }
  getAbsoluteScale(t) {
    for (var n = this; n; )
      n._isUnderCache && (t = n), n = n.getParent();
    const s = this.getAbsoluteTransform(t).decompose();
    return {
      x: s.scaleX,
      y: s.scaleY
    };
  }
  getAbsoluteRotation() {
    return this.getAbsoluteTransform().decompose().rotation;
  }
  getTransform() {
    return this._getCache(g2, this._getTransform);
  }
  _getTransform() {
    var t, n, r = this._cache.get(g2) || new Wa.Transform();
    r.reset();
    var s = this.x(), o = this.y(), c = l2.Konva.getAngle(this.rotation()), u = (t = this.attrs.scaleX) !== null && t !== void 0 ? t : 1, m = (n = this.attrs.scaleY) !== null && n !== void 0 ? n : 1, y = this.attrs.skewX || 0, b = this.attrs.skewY || 0, w = this.attrs.offsetX || 0, k = this.attrs.offsetY || 0;
    return (s !== 0 || o !== 0) && r.translate(s, o), c !== 0 && r.rotate(c), (y !== 0 || b !== 0) && r.skew(y, b), (u !== 1 || m !== 1) && r.scale(u, m), (w !== 0 || k !== 0) && r.translate(-1 * w, -1 * k), r.dirty = !1, r;
  }
  clone(t) {
    var n = Wa.Util.cloneObject(this.attrs), r, s, o, c, u;
    for (r in t)
      n[r] = t[r];
    var m = new this.constructor(n);
    for (r in this.eventListeners)
      for (s = this.eventListeners[r], o = s.length, c = 0; c < o; c++)
        u = s[c], u.name.indexOf(t2e) < 0 && (m.eventListeners[r] || (m.eventListeners[r] = []), m.eventListeners[r].push(u));
    return m;
  }
  _toKonvaCanvas(t) {
    t = t || {};
    var n = this.getClientRect(), r = this.getStage(), s = t.x !== void 0 ? t.x : Math.floor(n.x), o = t.y !== void 0 ? t.y : Math.floor(n.y), c = t.pixelRatio || 1, u = new I7.SceneCanvas({
      width: t.width || Math.ceil(n.width) || (r ? r.width() : 0),
      height: t.height || Math.ceil(n.height) || (r ? r.height() : 0),
      pixelRatio: c
    }), m = u.getContext();
    const y = new I7.SceneCanvas({
      width: u.width / u.pixelRatio + Math.abs(s),
      height: u.height / u.pixelRatio + Math.abs(o),
      pixelRatio: u.pixelRatio
    });
    return t.imageSmoothingEnabled === !1 && (m._context.imageSmoothingEnabled = !1), m.save(), (s || o) && m.translate(-1 * s, -1 * o), this.drawScene(u, void 0, y), m.restore(), u;
  }
  toCanvas(t) {
    return this._toKonvaCanvas(t)._canvas;
  }
  toDataURL(t) {
    t = t || {};
    var n = t.mimeType || null, r = t.quality || null, s = this._toKonvaCanvas(t).toDataURL(n, r);
    return t.callback && t.callback(s), s;
  }
  toImage(t) {
    return new Promise((n, r) => {
      try {
        const s = t == null ? void 0 : t.callback;
        s && delete t.callback, Wa.Util._urlToImage(this.toDataURL(t), function(o) {
          n(o), s == null || s(o);
        });
      } catch (s) {
        r(s);
      }
    });
  }
  toBlob(t) {
    return new Promise((n, r) => {
      try {
        const s = t == null ? void 0 : t.callback;
        s && delete t.callback, this.toCanvas(t).toBlob((o) => {
          n(o), s == null || s(o);
        }, t == null ? void 0 : t.mimeType, t == null ? void 0 : t.quality);
      } catch (s) {
        r(s);
      }
    });
  }
  setSize(t) {
    return this.width(t.width), this.height(t.height), this;
  }
  getSize() {
    return {
      width: this.width(),
      height: this.height()
    };
  }
  getClassName() {
    return this.className || this.nodeType;
  }
  getType() {
    return this.nodeType;
  }
  getDragDistance() {
    return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : l2.Konva.dragDistance;
  }
  _off(t, n, r) {
    var s = this.eventListeners[t], o, c, u;
    for (o = 0; o < s.length; o++)
      if (c = s[o].name, u = s[o].handler, (c !== "konva" || n === "konva") && (!n || c === n) && (!r || r === u)) {
        if (s.splice(o, 1), s.length === 0) {
          delete this.eventListeners[t];
          break;
        }
        o--;
      }
  }
  _fireChangeEvent(t, n, r) {
    this._fire(t + Jxe, {
      oldVal: n,
      newVal: r
    });
  }
  addName(t) {
    if (!this.hasName(t)) {
      var n = this.name(), r = n ? n + " " + t : t;
      this.name(r);
    }
    return this;
  }
  hasName(t) {
    if (!t)
      return !1;
    const n = this.name();
    if (!n)
      return !1;
    var r = (n || "").split(/\s/g);
    return r.indexOf(t) !== -1;
  }
  removeName(t) {
    var n = (this.name() || "").split(/\s/g), r = n.indexOf(t);
    return r !== -1 && (n.splice(r, 1), this.name(n.join(" "))), this;
  }
  setAttr(t, n) {
    var r = this[Jz + Wa.Util._capitalize(t)];
    return Wa.Util._isFunction(r) ? r.call(this, n) : this._setAttr(t, n), this;
  }
  _requestDraw() {
    if (l2.Konva.autoDrawEnabled) {
      const t = this.getLayer() || this.getStage();
      t == null || t.batchDraw();
    }
  }
  _setAttr(t, n) {
    var r = this.attrs[t];
    r === n && !Wa.Util.isObject(n) || (n == null ? delete this.attrs[t] : this.attrs[t] = n, this._shouldFireChangeEvents && this._fireChangeEvent(t, r, n), this._requestDraw());
  }
  _setComponentAttr(t, n, r) {
    var s;
    r !== void 0 && (s = this.attrs[t], s || (this.attrs[t] = this.getAttr(t)), this.attrs[t][n] = r, this._fireChangeEvent(t, s, r));
  }
  _fireAndBubble(t, n, r) {
    n && this.nodeType === eB && (n.target = this);
    var s = (t === Qz || t === Zz) && (r && (this === r || this.isAncestorOf && this.isAncestorOf(r)) || this.nodeType === "Stage" && !r);
    if (!s) {
      this._fire(t, n);
      var o = (t === Qz || t === Zz) && r && r.isAncestorOf && r.isAncestorOf(this) && !r.isAncestorOf(this.parent);
      (n && !n.cancelBubble || !n) && this.parent && this.parent.isListening() && !o && (r && r.parent ? this._fireAndBubble.call(this.parent, t, n, r) : this._fireAndBubble.call(this.parent, t, n));
    }
  }
  _getProtoListeners(t) {
    var n, r, s;
    const o = (n = this._cache.get(Oj)) !== null && n !== void 0 ? n : {};
    let c = o == null ? void 0 : o[t];
    if (c === void 0) {
      c = [];
      let u = Object.getPrototypeOf(this);
      for (; u; ) {
        const m = (s = (r = u.eventListeners) === null || r === void 0 ? void 0 : r[t]) !== null && s !== void 0 ? s : [];
        c.push(...m), u = Object.getPrototypeOf(u);
      }
      o[t] = c, this._cache.set(Oj, o);
    }
    return c;
  }
  _fire(t, n) {
    n = n || {}, n.currentTarget = this, n.type = t;
    const r = this._getProtoListeners(t);
    if (r)
      for (var s = 0; s < r.length; s++)
        r[s].handler.call(this, n);
    const o = this.eventListeners[t];
    if (o)
      for (var s = 0; s < o.length; s++)
        o[s].handler.call(this, n);
  }
  draw() {
    return this.drawScene(), this.drawHit(), this;
  }
  _createDragElement(t) {
    var n = t ? t.pointerId : void 0, r = this.getStage(), s = this.getAbsolutePosition();
    if (r) {
      var o = r._getPointerById(n) || r._changedPointerPositions[0] || s;
      h1.DD._dragElements.set(this._id, {
        node: this,
        startPointerPos: o,
        offset: {
          x: o.x - s.x,
          y: o.y - s.y
        },
        dragStatus: "ready",
        pointerId: n
      });
    }
  }
  startDrag(t, n = !0) {
    h1.DD._dragElements.has(this._id) || this._createDragElement(t);
    const r = h1.DD._dragElements.get(this._id);
    r.dragStatus = "dragging", this.fire("dragstart", {
      type: "dragstart",
      target: this,
      evt: t && t.evt
    }, n);
  }
  _setDragPosition(t, n) {
    const r = this.getStage()._getPointerById(n.pointerId);
    if (r) {
      var s = {
        x: r.x - n.offset.x,
        y: r.y - n.offset.y
      }, o = this.dragBoundFunc();
      if (o !== void 0) {
        const c = o.call(this, s, t);
        c ? s = c : Wa.Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
      }
      (!this._lastPos || this._lastPos.x !== s.x || this._lastPos.y !== s.y) && (this.setAbsolutePosition(s), this._requestDraw()), this._lastPos = s;
    }
  }
  stopDrag(t) {
    const n = h1.DD._dragElements.get(this._id);
    n && (n.dragStatus = "stopped"), h1.DD._endDragBefore(t), h1.DD._endDragAfter(t);
  }
  setDraggable(t) {
    this._setAttr("draggable", t), this._dragChange();
  }
  isDragging() {
    const t = h1.DD._dragElements.get(this._id);
    return t ? t.dragStatus === "dragging" : !1;
  }
  _listenDrag() {
    this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(t) {
      var n = t.evt.button !== void 0, r = !n || l2.Konva.dragButtons.indexOf(t.evt.button) >= 0;
      if (r && !this.isDragging()) {
        var s = !1;
        h1.DD._dragElements.forEach((o) => {
          this.isAncestorOf(o.node) && (s = !0);
        }), s || this._createDragElement(t);
      }
    });
  }
  _dragChange() {
    if (this.attrs.draggable)
      this._listenDrag();
    else {
      this._dragCleanup();
      var t = this.getStage();
      if (!t)
        return;
      const n = h1.DD._dragElements.get(this._id), r = n && n.dragStatus === "dragging", s = n && n.dragStatus === "ready";
      r ? this.stopDrag() : s && h1.DD._dragElements.delete(this._id);
    }
  }
  _dragCleanup() {
    this.off("mousedown.konva"), this.off("touchstart.konva");
  }
  isClientRectOnScreen(t = { x: 0, y: 0 }) {
    const n = this.getStage();
    if (!n)
      return !1;
    const r = {
      x: -t.x,
      y: -t.y,
      width: n.width() + 2 * t.x,
      height: n.height() + 2 * t.y
    };
    return Wa.Util.haveIntersection(r, this.getClientRect());
  }
  static create(t, n) {
    return Wa.Util._isString(t) && (t = JSON.parse(t)), this._createNode(t, n);
  }
  static _createNode(t, n) {
    var r = QD.prototype.getClassName.call(t), s = t.children, o, c, u;
    n && (t.attrs.container = n), l2.Konva[r] || (Wa.Util.warn('Can not find a node with class name "' + r + '". Fallback to "Shape".'), r = "Shape");
    const m = l2.Konva[r];
    if (o = new m(t.attrs), s)
      for (c = s.length, u = 0; u < c; u++)
        o.add(QD._createNode(s[u]));
    return o;
  }
};
ko.Node = oa;
oa.prototype.nodeType = "Node";
oa.prototype._attrsAffectingSize = [];
oa.prototype.eventListeners = {};
oa.prototype.on.call(oa.prototype, r2e, function() {
  if (this._batchingTransformChange) {
    this._needClearTransformCache = !0;
    return;
  }
  this._clearCache(g2), this._clearSelfAndDescendantCache(jv);
});
oa.prototype.on.call(oa.prototype, "visibleChange.konva", function() {
  this._clearSelfAndDescendantCache(XD);
});
oa.prototype.on.call(oa.prototype, "listeningChange.konva", function() {
  this._clearSelfAndDescendantCache(KD);
});
oa.prototype.on.call(oa.prototype, "opacityChange.konva", function() {
  this._clearSelfAndDescendantCache(c9);
});
const Li = S6.Factory.addGetterSetter;
Li(oa, "zIndex");
Li(oa, "absolutePosition");
Li(oa, "position");
Li(oa, "x", 0, (0, Jl.getNumberValidator)());
Li(oa, "y", 0, (0, Jl.getNumberValidator)());
Li(oa, "globalCompositeOperation", "source-over", (0, Jl.getStringValidator)());
Li(oa, "opacity", 1, (0, Jl.getNumberValidator)());
Li(oa, "name", "", (0, Jl.getStringValidator)());
Li(oa, "id", "", (0, Jl.getStringValidator)());
Li(oa, "rotation", 0, (0, Jl.getNumberValidator)());
S6.Factory.addComponentsGetterSetter(oa, "scale", ["x", "y"]);
Li(oa, "scaleX", 1, (0, Jl.getNumberValidator)());
Li(oa, "scaleY", 1, (0, Jl.getNumberValidator)());
S6.Factory.addComponentsGetterSetter(oa, "skew", ["x", "y"]);
Li(oa, "skewX", 0, (0, Jl.getNumberValidator)());
Li(oa, "skewY", 0, (0, Jl.getNumberValidator)());
S6.Factory.addComponentsGetterSetter(oa, "offset", ["x", "y"]);
Li(oa, "offsetX", 0, (0, Jl.getNumberValidator)());
Li(oa, "offsetY", 0, (0, Jl.getNumberValidator)());
Li(oa, "dragDistance", null, (0, Jl.getNumberValidator)());
Li(oa, "width", 0, (0, Jl.getNumberValidator)());
Li(oa, "height", 0, (0, Jl.getNumberValidator)());
Li(oa, "listening", !0, (0, Jl.getBooleanValidator)());
Li(oa, "preventDefault", !0, (0, Jl.getBooleanValidator)());
Li(oa, "filters", null, function(e) {
  return this._filterUpToDate = !1, e;
});
Li(oa, "visible", !0, (0, Jl.getBooleanValidator)());
Li(oa, "transformsEnabled", "all", (0, Jl.getStringValidator)());
Li(oa, "size");
Li(oa, "dragBoundFunc");
Li(oa, "draggable", !1, (0, Jl.getBooleanValidator)());
S6.Factory.backCompat(oa, {
  rotateDeg: "rotate",
  setRotationDeg: "setRotation",
  getRotationDeg: "getRotation"
});
var g5 = {};
Object.defineProperty(g5, "__esModule", { value: !0 });
g5.Container = void 0;
const Sw = Sa, pR = ko, vk = Jn;
class y5 extends pR.Node {
  constructor() {
    super(...arguments), this.children = [];
  }
  getChildren(t) {
    if (!t)
      return this.children || [];
    const n = this.children || [];
    var r = [];
    return n.forEach(function(s) {
      t(s) && r.push(s);
    }), r;
  }
  hasChildren() {
    return this.getChildren().length > 0;
  }
  removeChildren() {
    return this.getChildren().forEach((t) => {
      t.parent = null, t.index = 0, t.remove();
    }), this.children = [], this._requestDraw(), this;
  }
  destroyChildren() {
    return this.getChildren().forEach((t) => {
      t.parent = null, t.index = 0, t.destroy();
    }), this.children = [], this._requestDraw(), this;
  }
  add(...t) {
    if (t.length === 0)
      return this;
    if (t.length > 1) {
      for (var n = 0; n < t.length; n++)
        this.add(t[n]);
      return this;
    }
    const r = t[0];
    return r.getParent() ? (r.moveTo(this), this) : (this._validateAdd(r), r.index = this.getChildren().length, r.parent = this, r._clearCaches(), this.getChildren().push(r), this._fire("add", {
      child: r
    }), this._requestDraw(), this);
  }
  destroy() {
    return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
  }
  find(t) {
    return this._generalFind(t, !1);
  }
  findOne(t) {
    var n = this._generalFind(t, !0);
    return n.length > 0 ? n[0] : void 0;
  }
  _generalFind(t, n) {
    var r = [];
    return this._descendants((s) => {
      const o = s._isMatch(t);
      return o && r.push(s), !!(o && n);
    }), r;
  }
  _descendants(t) {
    let n = !1;
    const r = this.getChildren();
    for (const s of r) {
      if (n = t(s), n)
        return !0;
      if (s.hasChildren() && (n = s._descendants(t), n))
        return !0;
    }
    return !1;
  }
  toObject() {
    var t = pR.Node.prototype.toObject.call(this);
    return t.children = [], this.getChildren().forEach((n) => {
      t.children.push(n.toObject());
    }), t;
  }
  isAncestorOf(t) {
    for (var n = t.getParent(); n; ) {
      if (n._id === this._id)
        return !0;
      n = n.getParent();
    }
    return !1;
  }
  clone(t) {
    var n = pR.Node.prototype.clone.call(this, t);
    return this.getChildren().forEach(function(r) {
      n.add(r.clone());
    }), n;
  }
  getAllIntersections(t) {
    var n = [];
    return this.find("Shape").forEach((r) => {
      r.isVisible() && r.intersects(t) && n.push(r);
    }), n;
  }
  _clearSelfAndDescendantCache(t) {
    var n;
    super._clearSelfAndDescendantCache(t), !this.isCached() && ((n = this.children) === null || n === void 0 || n.forEach(function(r) {
      r._clearSelfAndDescendantCache(t);
    }));
  }
  _setChildrenIndices() {
    var t;
    (t = this.children) === null || t === void 0 || t.forEach(function(n, r) {
      n.index = r;
    }), this._requestDraw();
  }
  drawScene(t, n, r) {
    var s = this.getLayer(), o = t || s && s.getCanvas(), c = o && o.getContext(), u = this._getCanvasCache(), m = u && u.scene, y = o && o.isCache;
    if (!this.isVisible() && !y)
      return this;
    if (m) {
      c.save();
      var b = this.getAbsoluteTransform(n).getMatrix();
      c.transform(b[0], b[1], b[2], b[3], b[4], b[5]), this._drawCachedSceneCanvas(c), c.restore();
    } else
      this._drawChildren("drawScene", o, n, r);
    return this;
  }
  drawHit(t, n) {
    if (!this.shouldDrawHit(n))
      return this;
    var r = this.getLayer(), s = t || r && r.hitCanvas, o = s && s.getContext(), c = this._getCanvasCache(), u = c && c.hit;
    if (u) {
      o.save();
      var m = this.getAbsoluteTransform(n).getMatrix();
      o.transform(m[0], m[1], m[2], m[3], m[4], m[5]), this._drawCachedHitCanvas(o), o.restore();
    } else
      this._drawChildren("drawHit", s, n);
    return this;
  }
  _drawChildren(t, n, r, s) {
    var o, c = n && n.getContext(), u = this.clipWidth(), m = this.clipHeight(), y = this.clipFunc(), b = typeof u == "number" && typeof m == "number" || y;
    const w = r === this;
    if (b) {
      c.save();
      var k = this.getAbsoluteTransform(r), j = k.getMatrix();
      c.transform(j[0], j[1], j[2], j[3], j[4], j[5]), c.beginPath();
      let L;
      if (y)
        L = y.call(this, c, this);
      else {
        var E = this.clipX(), T = this.clipY();
        c.rect(E || 0, T || 0, u, m);
      }
      c.clip.apply(c, L), j = k.copy().invert().getMatrix(), c.transform(j[0], j[1], j[2], j[3], j[4], j[5]);
    }
    var D = !w && this.globalCompositeOperation() !== "source-over" && t === "drawScene";
    D && (c.save(), c._applyGlobalCompositeOperation(this)), (o = this.children) === null || o === void 0 || o.forEach(function(L) {
      L[t](n, r, s);
    }), D && c.restore(), b && c.restore();
  }
  getClientRect(t = {}) {
    var n, r = t.skipTransform, s = t.relativeTo, o, c, u, m, y = {
      x: 1 / 0,
      y: 1 / 0,
      width: 0,
      height: 0
    }, b = this;
    (n = this.children) === null || n === void 0 || n.forEach(function(T) {
      if (T.visible()) {
        var D = T.getClientRect({
          relativeTo: b,
          skipShadow: t.skipShadow,
          skipStroke: t.skipStroke
        });
        D.width === 0 && D.height === 0 || (o === void 0 ? (o = D.x, c = D.y, u = D.x + D.width, m = D.y + D.height) : (o = Math.min(o, D.x), c = Math.min(c, D.y), u = Math.max(u, D.x + D.width), m = Math.max(m, D.y + D.height)));
      }
    });
    for (var w = this.find("Shape"), k = !1, j = 0; j < w.length; j++) {
      var E = w[j];
      if (E._isVisible(this)) {
        k = !0;
        break;
      }
    }
    return k && o !== void 0 ? y = {
      x: o,
      y: c,
      width: u - o,
      height: m - c
    } : y = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }, r ? y : this._transformedRect(y, s);
  }
}
g5.Container = y5;
Sw.Factory.addComponentsGetterSetter(y5, "clip", [
  "x",
  "y",
  "width",
  "height"
]);
Sw.Factory.addGetterSetter(y5, "clipX", void 0, (0, vk.getNumberValidator)());
Sw.Factory.addGetterSetter(y5, "clipY", void 0, (0, vk.getNumberValidator)());
Sw.Factory.addGetterSetter(y5, "clipWidth", void 0, (0, vk.getNumberValidator)());
Sw.Factory.addGetterSetter(y5, "clipHeight", void 0, (0, vk.getNumberValidator)());
Sw.Factory.addGetterSetter(y5, "clipFunc");
var wY = {}, mp = {};
Object.defineProperty(mp, "__esModule", { value: !0 });
mp.releaseCapture = mp.setPointerCapture = mp.hasPointerCapture = mp.createEvent = mp.getCapturedShape = void 0;
const s2e = ha, P3 = /* @__PURE__ */ new Map(), CY = s2e.Konva._global.PointerEvent !== void 0;
function i2e(e) {
  return P3.get(e);
}
mp.getCapturedShape = i2e;
function xA(e) {
  return {
    evt: e,
    pointerId: e.pointerId
  };
}
mp.createEvent = xA;
function o2e(e, t) {
  return P3.get(e) === t;
}
mp.hasPointerCapture = o2e;
function l2e(e, t) {
  NY(e), t.getStage() && (P3.set(e, t), CY && t._fire("gotpointercapture", xA(new PointerEvent("gotpointercapture"))));
}
mp.setPointerCapture = l2e;
function NY(e, t) {
  const n = P3.get(e);
  if (!n)
    return;
  const r = n.getStage();
  r && r.content, P3.delete(e), CY && n._fire("lostpointercapture", xA(new PointerEvent("lostpointercapture")));
}
mp.releaseCapture = NY;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Stage = e.stages = void 0;
  const t = cl, n = Sa, r = g5, s = ha, o = Kg, c = yk, u = ha, m = mp;
  var y = "Stage", b = "string", w = "px", k = "mouseout", j = "mouseleave", E = "mouseover", T = "mouseenter", D = "mousemove", L = "mousedown", I = "mouseup", R = "pointermove", U = "pointerdown", z = "pointerup", H = "pointercancel", K = "lostpointercapture", q = "pointerout", Q = "pointerleave", Z = "pointerover", X = "pointerenter", se = "contextmenu", te = "touchstart", fe = "touchend", ce = "touchmove", pe = "touchcancel", Se = "wheel", oe = 5, ue = [
    [T, "_pointerenter"],
    [L, "_pointerdown"],
    [D, "_pointermove"],
    [I, "_pointerup"],
    [j, "_pointerleave"],
    [te, "_pointerdown"],
    [ce, "_pointermove"],
    [fe, "_pointerup"],
    [pe, "_pointercancel"],
    [E, "_pointerover"],
    [Se, "_wheel"],
    [se, "_contextmenu"],
    [U, "_pointerdown"],
    [R, "_pointermove"],
    [z, "_pointerup"],
    [H, "_pointercancel"],
    [K, "_lostpointercapture"]
  ];
  const he = {
    mouse: {
      [q]: k,
      [Q]: j,
      [Z]: E,
      [X]: T,
      [R]: D,
      [U]: L,
      [z]: I,
      [H]: "mousecancel",
      pointerclick: "click",
      pointerdblclick: "dblclick"
    },
    touch: {
      [q]: "touchout",
      [Q]: "touchleave",
      [Z]: "touchover",
      [X]: "touchenter",
      [R]: ce,
      [U]: te,
      [z]: fe,
      [H]: pe,
      pointerclick: "tap",
      pointerdblclick: "dbltap"
    },
    pointer: {
      [q]: q,
      [Q]: Q,
      [Z]: Z,
      [X]: X,
      [R]: R,
      [U]: U,
      [z]: z,
      [H]: H,
      pointerclick: "pointerclick",
      pointerdblclick: "pointerdblclick"
    }
  }, ve = (it) => it.indexOf("pointer") >= 0 ? "pointer" : it.indexOf("touch") >= 0 ? "touch" : "mouse", Te = (it) => {
    const Ne = ve(it);
    if (Ne === "pointer")
      return s.Konva.pointerEventsEnabled && he.pointer;
    if (Ne === "touch")
      return he.touch;
    if (Ne === "mouse")
      return he.mouse;
  };
  function Ie(it = {}) {
    return (it.clipFunc || it.clipWidth || it.clipHeight) && t.Util.warn("Stage does not support clipping. Please use clip for Layers or Groups."), it;
  }
  const Ue = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
  e.stages = [];
  class qe extends r.Container {
    constructor(Ne) {
      super(Ie(Ne)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), e.stages.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
        Ie(this.attrs);
      }), this._checkVisibility();
    }
    _validateAdd(Ne) {
      const Xe = Ne.getType() === "Layer", xt = Ne.getType() === "FastLayer";
      Xe || xt || t.Util.throw("You may only add layers to the stage.");
    }
    _checkVisibility() {
      if (!this.content)
        return;
      const Ne = this.visible() ? "" : "none";
      this.content.style.display = Ne;
    }
    setContainer(Ne) {
      if (typeof Ne === b) {
        if (Ne.charAt(0) === ".") {
          var Xe = Ne.slice(1);
          Ne = document.getElementsByClassName(Xe)[0];
        } else {
          var xt;
          Ne.charAt(0) !== "#" ? xt = Ne : xt = Ne.slice(1), Ne = document.getElementById(xt);
        }
        if (!Ne)
          throw "Can not find container in document with id " + xt;
      }
      return this._setAttr("container", Ne), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), Ne.appendChild(this.content)), this;
    }
    shouldDrawHit() {
      return !0;
    }
    clear() {
      var Ne = this.children, Xe = Ne.length, xt;
      for (xt = 0; xt < Xe; xt++)
        Ne[xt].clear();
      return this;
    }
    clone(Ne) {
      return Ne || (Ne = {}), Ne.container = typeof document < "u" && document.createElement("div"), r.Container.prototype.clone.call(this, Ne);
    }
    destroy() {
      super.destroy();
      var Ne = this.content;
      Ne && t.Util._isInDocument(Ne) && this.container().removeChild(Ne);
      var Xe = e.stages.indexOf(this);
      return Xe > -1 && e.stages.splice(Xe, 1), t.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
    }
    getPointerPosition() {
      const Ne = this._pointerPositions[0] || this._changedPointerPositions[0];
      return Ne ? {
        x: Ne.x,
        y: Ne.y
      } : (t.Util.warn(Ue), null);
    }
    _getPointerById(Ne) {
      return this._pointerPositions.find((Xe) => Xe.id === Ne);
    }
    getPointersPositions() {
      return this._pointerPositions;
    }
    getStage() {
      return this;
    }
    getContent() {
      return this.content;
    }
    _toKonvaCanvas(Ne) {
      Ne = Ne || {}, Ne.x = Ne.x || 0, Ne.y = Ne.y || 0, Ne.width = Ne.width || this.width(), Ne.height = Ne.height || this.height();
      var Xe = new o.SceneCanvas({
        width: Ne.width,
        height: Ne.height,
        pixelRatio: Ne.pixelRatio || 1
      }), xt = Xe.getContext()._context, rn = this.children;
      return (Ne.x || Ne.y) && xt.translate(-1 * Ne.x, -1 * Ne.y), rn.forEach(function(vt) {
        if (vt.isVisible()) {
          var At = vt._toKonvaCanvas(Ne);
          xt.drawImage(At._canvas, Ne.x, Ne.y, At.getWidth() / At.getPixelRatio(), At.getHeight() / At.getPixelRatio());
        }
      }), Xe;
    }
    getIntersection(Ne) {
      if (!Ne)
        return null;
      var Xe = this.children, xt = Xe.length, rn = xt - 1, vt;
      for (vt = rn; vt >= 0; vt--) {
        const At = Xe[vt].getIntersection(Ne);
        if (At)
          return At;
      }
      return null;
    }
    _resizeDOM() {
      var Ne = this.width(), Xe = this.height();
      this.content && (this.content.style.width = Ne + w, this.content.style.height = Xe + w), this.bufferCanvas.setSize(Ne, Xe), this.bufferHitCanvas.setSize(Ne, Xe), this.children.forEach((xt) => {
        xt.setSize({ width: Ne, height: Xe }), xt.draw();
      });
    }
    add(Ne, ...Xe) {
      if (arguments.length > 1) {
        for (var xt = 0; xt < arguments.length; xt++)
          this.add(arguments[xt]);
        return this;
      }
      super.add(Ne);
      var rn = this.children.length;
      return rn > oe && t.Util.warn("The stage has " + rn + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), Ne.setSize({ width: this.width(), height: this.height() }), Ne.draw(), s.Konva.isBrowser && this.content.appendChild(Ne.canvas._canvas), this;
    }
    getParent() {
      return null;
    }
    getLayer() {
      return null;
    }
    hasPointerCapture(Ne) {
      return m.hasPointerCapture(Ne, this);
    }
    setPointerCapture(Ne) {
      m.setPointerCapture(Ne, this);
    }
    releaseCapture(Ne) {
      m.releaseCapture(Ne, this);
    }
    getLayers() {
      return this.children;
    }
    _bindContentEvents() {
      s.Konva.isBrowser && ue.forEach(([Ne, Xe]) => {
        this.content.addEventListener(Ne, (xt) => {
          this[Xe](xt);
        }, { passive: !1 });
      });
    }
    _pointerenter(Ne) {
      this.setPointersPositions(Ne);
      const Xe = Te(Ne.type);
      Xe && this._fire(Xe.pointerenter, {
        evt: Ne,
        target: this,
        currentTarget: this
      });
    }
    _pointerover(Ne) {
      this.setPointersPositions(Ne);
      const Xe = Te(Ne.type);
      Xe && this._fire(Xe.pointerover, {
        evt: Ne,
        target: this,
        currentTarget: this
      });
    }
    _getTargetShape(Ne) {
      let Xe = this[Ne + "targetShape"];
      return Xe && !Xe.getStage() && (Xe = null), Xe;
    }
    _pointerleave(Ne) {
      const Xe = Te(Ne.type), xt = ve(Ne.type);
      if (Xe) {
        this.setPointersPositions(Ne);
        var rn = this._getTargetShape(xt), vt = !(s.Konva.isDragging() || s.Konva.isTransforming()) || s.Konva.hitOnDragEnabled;
        rn && vt ? (rn._fireAndBubble(Xe.pointerout, { evt: Ne }), rn._fireAndBubble(Xe.pointerleave, { evt: Ne }), this._fire(Xe.pointerleave, {
          evt: Ne,
          target: this,
          currentTarget: this
        }), this[xt + "targetShape"] = null) : vt && (this._fire(Xe.pointerleave, {
          evt: Ne,
          target: this,
          currentTarget: this
        }), this._fire(Xe.pointerout, {
          evt: Ne,
          target: this,
          currentTarget: this
        })), this.pointerPos = null, this._pointerPositions = [];
      }
    }
    _pointerdown(Ne) {
      const Xe = Te(Ne.type), xt = ve(Ne.type);
      if (Xe) {
        this.setPointersPositions(Ne);
        var rn = !1;
        this._changedPointerPositions.forEach((vt) => {
          var At = this.getIntersection(vt);
          if (c.DD.justDragged = !1, s.Konva["_" + xt + "ListenClick"] = !0, !At || !At.isListening()) {
            this[xt + "ClickStartShape"] = void 0;
            return;
          }
          s.Konva.capturePointerEventsEnabled && At.setPointerCapture(vt.id), this[xt + "ClickStartShape"] = At, At._fireAndBubble(Xe.pointerdown, {
            evt: Ne,
            pointerId: vt.id
          }), rn = !0;
          const He = Ne.type.indexOf("touch") >= 0;
          At.preventDefault() && Ne.cancelable && He && Ne.preventDefault();
        }), rn || this._fire(Xe.pointerdown, {
          evt: Ne,
          target: this,
          currentTarget: this,
          pointerId: this._pointerPositions[0].id
        });
      }
    }
    _pointermove(Ne) {
      const Xe = Te(Ne.type), xt = ve(Ne.type);
      if (!Xe)
        return;
      s.Konva.isDragging() && c.DD.node.preventDefault() && Ne.cancelable && Ne.preventDefault(), this.setPointersPositions(Ne);
      var rn = !(s.Konva.isDragging() || s.Konva.isTransforming()) || s.Konva.hitOnDragEnabled;
      if (!rn)
        return;
      var vt = {};
      let At = !1;
      var He = this._getTargetShape(xt);
      this._changedPointerPositions.forEach((Pt) => {
        const Lt = m.getCapturedShape(Pt.id) || this.getIntersection(Pt), er = Pt.id, It = { evt: Ne, pointerId: er };
        var ye = He !== Lt;
        if (ye && He && (He._fireAndBubble(Xe.pointerout, { ...It }, Lt), He._fireAndBubble(Xe.pointerleave, { ...It }, Lt)), Lt) {
          if (vt[Lt._id])
            return;
          vt[Lt._id] = !0;
        }
        Lt && Lt.isListening() ? (At = !0, ye && (Lt._fireAndBubble(Xe.pointerover, { ...It }, He), Lt._fireAndBubble(Xe.pointerenter, { ...It }, He), this[xt + "targetShape"] = Lt), Lt._fireAndBubble(Xe.pointermove, { ...It })) : He && (this._fire(Xe.pointerover, {
          evt: Ne,
          target: this,
          currentTarget: this,
          pointerId: er
        }), this[xt + "targetShape"] = null);
      }), At || this._fire(Xe.pointermove, {
        evt: Ne,
        target: this,
        currentTarget: this,
        pointerId: this._changedPointerPositions[0].id
      });
    }
    _pointerup(Ne) {
      const Xe = Te(Ne.type), xt = ve(Ne.type);
      if (!Xe)
        return;
      this.setPointersPositions(Ne);
      const rn = this[xt + "ClickStartShape"], vt = this[xt + "ClickEndShape"];
      var At = {};
      let He = !1;
      this._changedPointerPositions.forEach((Pt) => {
        const Lt = m.getCapturedShape(Pt.id) || this.getIntersection(Pt);
        if (Lt) {
          if (Lt.releaseCapture(Pt.id), At[Lt._id])
            return;
          At[Lt._id] = !0;
        }
        const er = Pt.id, It = { evt: Ne, pointerId: er };
        let ye = !1;
        s.Konva["_" + xt + "InDblClickWindow"] ? (ye = !0, clearTimeout(this[xt + "DblTimeout"])) : c.DD.justDragged || (s.Konva["_" + xt + "InDblClickWindow"] = !0, clearTimeout(this[xt + "DblTimeout"])), this[xt + "DblTimeout"] = setTimeout(function() {
          s.Konva["_" + xt + "InDblClickWindow"] = !1;
        }, s.Konva.dblClickWindow), Lt && Lt.isListening() ? (He = !0, this[xt + "ClickEndShape"] = Lt, Lt._fireAndBubble(Xe.pointerup, { ...It }), s.Konva["_" + xt + "ListenClick"] && rn && rn === Lt && (Lt._fireAndBubble(Xe.pointerclick, { ...It }), ye && vt && vt === Lt && Lt._fireAndBubble(Xe.pointerdblclick, { ...It }))) : (this[xt + "ClickEndShape"] = null, s.Konva["_" + xt + "ListenClick"] && this._fire(Xe.pointerclick, {
          evt: Ne,
          target: this,
          currentTarget: this,
          pointerId: er
        }), ye && this._fire(Xe.pointerdblclick, {
          evt: Ne,
          target: this,
          currentTarget: this,
          pointerId: er
        }));
      }), He || this._fire(Xe.pointerup, {
        evt: Ne,
        target: this,
        currentTarget: this,
        pointerId: this._changedPointerPositions[0].id
      }), s.Konva["_" + xt + "ListenClick"] = !1, Ne.cancelable && xt !== "touch" && Ne.preventDefault();
    }
    _contextmenu(Ne) {
      this.setPointersPositions(Ne);
      var Xe = this.getIntersection(this.getPointerPosition());
      Xe && Xe.isListening() ? Xe._fireAndBubble(se, { evt: Ne }) : this._fire(se, {
        evt: Ne,
        target: this,
        currentTarget: this
      });
    }
    _wheel(Ne) {
      this.setPointersPositions(Ne);
      var Xe = this.getIntersection(this.getPointerPosition());
      Xe && Xe.isListening() ? Xe._fireAndBubble(Se, { evt: Ne }) : this._fire(Se, {
        evt: Ne,
        target: this,
        currentTarget: this
      });
    }
    _pointercancel(Ne) {
      this.setPointersPositions(Ne);
      const Xe = m.getCapturedShape(Ne.pointerId) || this.getIntersection(this.getPointerPosition());
      Xe && Xe._fireAndBubble(z, m.createEvent(Ne)), m.releaseCapture(Ne.pointerId);
    }
    _lostpointercapture(Ne) {
      m.releaseCapture(Ne.pointerId);
    }
    setPointersPositions(Ne) {
      var Xe = this._getContentPosition(), xt = null, rn = null;
      Ne = Ne || window.event, Ne.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(Ne.touches, (vt) => {
        this._pointerPositions.push({
          id: vt.identifier,
          x: (vt.clientX - Xe.left) / Xe.scaleX,
          y: (vt.clientY - Xe.top) / Xe.scaleY
        });
      }), Array.prototype.forEach.call(Ne.changedTouches || Ne.touches, (vt) => {
        this._changedPointerPositions.push({
          id: vt.identifier,
          x: (vt.clientX - Xe.left) / Xe.scaleX,
          y: (vt.clientY - Xe.top) / Xe.scaleY
        });
      })) : (xt = (Ne.clientX - Xe.left) / Xe.scaleX, rn = (Ne.clientY - Xe.top) / Xe.scaleY, this.pointerPos = {
        x: xt,
        y: rn
      }, this._pointerPositions = [{ x: xt, y: rn, id: t.Util._getFirstPointerId(Ne) }], this._changedPointerPositions = [
        { x: xt, y: rn, id: t.Util._getFirstPointerId(Ne) }
      ]);
    }
    _setPointerPosition(Ne) {
      t.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(Ne);
    }
    _getContentPosition() {
      if (!this.content || !this.content.getBoundingClientRect)
        return {
          top: 0,
          left: 0,
          scaleX: 1,
          scaleY: 1
        };
      var Ne = this.content.getBoundingClientRect();
      return {
        top: Ne.top,
        left: Ne.left,
        scaleX: Ne.width / this.content.clientWidth || 1,
        scaleY: Ne.height / this.content.clientHeight || 1
      };
    }
    _buildDOM() {
      if (this.bufferCanvas = new o.SceneCanvas({
        width: this.width(),
        height: this.height()
      }), this.bufferHitCanvas = new o.HitCanvas({
        pixelRatio: 1,
        width: this.width(),
        height: this.height()
      }), !!s.Konva.isBrowser) {
        var Ne = this.container();
        if (!Ne)
          throw "Stage has no container. A container is required.";
        Ne.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), Ne.appendChild(this.content), this._resizeDOM();
      }
    }
    cache() {
      return t.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
    }
    clearCache() {
      return this;
    }
    batchDraw() {
      return this.getChildren().forEach(function(Ne) {
        Ne.batchDraw();
      }), this;
    }
  }
  e.Stage = qe, qe.prototype.nodeType = y, (0, u._registerNode)(qe), n.Factory.addGetterSetter(qe, "container"), s.Konva.isBrowser && document.addEventListener("visibilitychange", () => {
    e.stages.forEach((it) => {
      it.batchDraw();
    });
  });
})(wY);
var w6 = {}, yu = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Shape = e.shapes = void 0;
  const t = ha, n = cl, r = Sa, s = ko, o = Jn, c = ha, u = mp;
  var m = "hasShadow", y = "shadowRGBA", b = "patternImage", w = "linearGradient", k = "radialGradient";
  let j;
  function E() {
    return j || (j = n.Util.createCanvasElement().getContext("2d"), j);
  }
  e.shapes = {};
  function T(Q) {
    const Z = this.attrs.fillRule;
    Z ? Q.fill(Z) : Q.fill();
  }
  function D(Q) {
    Q.stroke();
  }
  function L(Q) {
    const Z = this.attrs.fillRule;
    Z ? Q.fill(Z) : Q.fill();
  }
  function I(Q) {
    Q.stroke();
  }
  function R() {
    this._clearCache(m);
  }
  function U() {
    this._clearCache(y);
  }
  function z() {
    this._clearCache(b);
  }
  function H() {
    this._clearCache(w);
  }
  function K() {
    this._clearCache(k);
  }
  class q extends s.Node {
    constructor(Z) {
      super(Z);
      let X;
      for (; X = n.Util.getRandomColor(), !(X && !(X in e.shapes)); )
        ;
      this.colorKey = X, e.shapes[X] = this;
    }
    getContext() {
      return n.Util.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
    }
    getCanvas() {
      return n.Util.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
    }
    getSceneFunc() {
      return this.attrs.sceneFunc || this._sceneFunc;
    }
    getHitFunc() {
      return this.attrs.hitFunc || this._hitFunc;
    }
    hasShadow() {
      return this._getCache(m, this._hasShadow);
    }
    _hasShadow() {
      return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
      return this._getCache(b, this.__getFillPattern);
    }
    __getFillPattern() {
      if (this.fillPatternImage()) {
        var Z = E();
        const X = Z.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
        if (X && X.setTransform) {
          const se = new n.Transform();
          se.translate(this.fillPatternX(), this.fillPatternY()), se.rotate(t.Konva.getAngle(this.fillPatternRotation())), se.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), se.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
          const te = se.getMatrix(), fe = typeof DOMMatrix > "u" ? {
            a: te[0],
            b: te[1],
            c: te[2],
            d: te[3],
            e: te[4],
            f: te[5]
          } : new DOMMatrix(te);
          X.setTransform(fe);
        }
        return X;
      }
    }
    _getLinearGradient() {
      return this._getCache(w, this.__getLinearGradient);
    }
    __getLinearGradient() {
      var Z = this.fillLinearGradientColorStops();
      if (Z) {
        for (var X = E(), se = this.fillLinearGradientStartPoint(), te = this.fillLinearGradientEndPoint(), fe = X.createLinearGradient(se.x, se.y, te.x, te.y), ce = 0; ce < Z.length; ce += 2)
          fe.addColorStop(Z[ce], Z[ce + 1]);
        return fe;
      }
    }
    _getRadialGradient() {
      return this._getCache(k, this.__getRadialGradient);
    }
    __getRadialGradient() {
      var Z = this.fillRadialGradientColorStops();
      if (Z) {
        for (var X = E(), se = this.fillRadialGradientStartPoint(), te = this.fillRadialGradientEndPoint(), fe = X.createRadialGradient(se.x, se.y, this.fillRadialGradientStartRadius(), te.x, te.y, this.fillRadialGradientEndRadius()), ce = 0; ce < Z.length; ce += 2)
          fe.addColorStop(Z[ce], Z[ce + 1]);
        return fe;
      }
    }
    getShadowRGBA() {
      return this._getCache(y, this._getShadowRGBA);
    }
    _getShadowRGBA() {
      if (this.hasShadow()) {
        var Z = n.Util.colorToRGBA(this.shadowColor());
        if (Z)
          return "rgba(" + Z.r + "," + Z.g + "," + Z.b + "," + Z.a * (this.shadowOpacity() || 1) + ")";
      }
    }
    hasFill() {
      return this._calculate("hasFill", [
        "fillEnabled",
        "fill",
        "fillPatternImage",
        "fillLinearGradientColorStops",
        "fillRadialGradientColorStops"
      ], () => this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
    }
    hasStroke() {
      return this._calculate("hasStroke", [
        "strokeEnabled",
        "strokeWidth",
        "stroke",
        "strokeLinearGradientColorStops"
      ], () => this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
    }
    hasHitStroke() {
      const Z = this.hitStrokeWidth();
      return Z === "auto" ? this.hasStroke() : this.strokeEnabled() && !!Z;
    }
    intersects(Z) {
      var X = this.getStage();
      if (!X)
        return !1;
      const se = X.bufferHitCanvas;
      return se.getContext().clear(), this.drawHit(se, void 0, !0), se.context.getImageData(Math.round(Z.x), Math.round(Z.y), 1, 1).data[3] > 0;
    }
    destroy() {
      return s.Node.prototype.destroy.call(this), delete e.shapes[this.colorKey], delete this.colorKey, this;
    }
    _useBufferCanvas(Z) {
      var X;
      if (!((X = this.attrs.perfectDrawEnabled) !== null && X !== void 0 ? X : !0))
        return !1;
      const te = Z || this.hasFill(), fe = this.hasStroke(), ce = this.getAbsoluteOpacity() !== 1;
      if (te && fe && ce)
        return !0;
      const pe = this.hasShadow(), Se = this.shadowForStrokeEnabled();
      return !!(te && fe && pe && Se);
    }
    setStrokeHitEnabled(Z) {
      n.Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), Z ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
      return this.hitStrokeWidth() !== 0;
    }
    getSelfRect() {
      var Z = this.size();
      return {
        x: this._centroid ? -Z.width / 2 : 0,
        y: this._centroid ? -Z.height / 2 : 0,
        width: Z.width,
        height: Z.height
      };
    }
    getClientRect(Z = {}) {
      let X = !1, se = this.getParent();
      for (; se; ) {
        if (se.isCached()) {
          X = !0;
          break;
        }
        se = se.getParent();
      }
      const te = Z.skipTransform, fe = Z.relativeTo || X && this.getStage() || void 0, ce = this.getSelfRect(), Se = !Z.skipStroke && this.hasStroke() && this.strokeWidth() || 0, oe = ce.width + Se, ue = ce.height + Se, he = !Z.skipShadow && this.hasShadow(), ve = he ? this.shadowOffsetX() : 0, Te = he ? this.shadowOffsetY() : 0, Ie = oe + Math.abs(ve), Ue = ue + Math.abs(Te), qe = he && this.shadowBlur() || 0, it = Ie + qe * 2, Ne = Ue + qe * 2, Xe = {
        width: it,
        height: Ne,
        x: -(Se / 2 + qe) + Math.min(ve, 0) + ce.x,
        y: -(Se / 2 + qe) + Math.min(Te, 0) + ce.y
      };
      return te ? Xe : this._transformedRect(Xe, fe);
    }
    drawScene(Z, X, se) {
      var te = this.getLayer(), fe = Z || te.getCanvas(), ce = fe.getContext(), pe = this._getCanvasCache(), Se = this.getSceneFunc(), oe = this.hasShadow(), ue, he, ve = fe.isCache, Te = X === this;
      if (!this.isVisible() && !Te)
        return this;
      if (pe) {
        ce.save();
        var Ie = this.getAbsoluteTransform(X).getMatrix();
        return ce.transform(Ie[0], Ie[1], Ie[2], Ie[3], Ie[4], Ie[5]), this._drawCachedSceneCanvas(ce), ce.restore(), this;
      }
      if (!Se)
        return this;
      if (ce.save(), this._useBufferCanvas() && !ve) {
        ue = this.getStage();
        const it = se || ue.bufferCanvas;
        he = it.getContext(), he.clear(), he.save(), he._applyLineJoin(this);
        var Ue = this.getAbsoluteTransform(X).getMatrix();
        he.transform(Ue[0], Ue[1], Ue[2], Ue[3], Ue[4], Ue[5]), Se.call(this, he, this), he.restore();
        var qe = it.pixelRatio;
        oe && ce._applyShadow(this), ce._applyOpacity(this), ce._applyGlobalCompositeOperation(this), ce.drawImage(it._canvas, 0, 0, it.width / qe, it.height / qe);
      } else {
        if (ce._applyLineJoin(this), !Te) {
          var Ue = this.getAbsoluteTransform(X).getMatrix();
          ce.transform(Ue[0], Ue[1], Ue[2], Ue[3], Ue[4], Ue[5]), ce._applyOpacity(this), ce._applyGlobalCompositeOperation(this);
        }
        oe && ce._applyShadow(this), Se.call(this, ce, this);
      }
      return ce.restore(), this;
    }
    drawHit(Z, X, se = !1) {
      if (!this.shouldDrawHit(X, se))
        return this;
      var te = this.getLayer(), fe = Z || te.hitCanvas, ce = fe && fe.getContext(), pe = this.hitFunc() || this.sceneFunc(), Se = this._getCanvasCache(), oe = Se && Se.hit;
      if (this.colorKey || n.Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), oe) {
        ce.save();
        var ue = this.getAbsoluteTransform(X).getMatrix();
        return ce.transform(ue[0], ue[1], ue[2], ue[3], ue[4], ue[5]), this._drawCachedHitCanvas(ce), ce.restore(), this;
      }
      if (!pe)
        return this;
      if (ce.save(), ce._applyLineJoin(this), !(this === X)) {
        var ve = this.getAbsoluteTransform(X).getMatrix();
        ce.transform(ve[0], ve[1], ve[2], ve[3], ve[4], ve[5]);
      }
      return pe.call(this, ce, this), ce.restore(), this;
    }
    drawHitFromCache(Z = 0) {
      var X = this._getCanvasCache(), se = this._getCachedSceneCanvas(), te = X.hit, fe = te.getContext(), ce = te.getWidth(), pe = te.getHeight(), Se, oe, ue, he, ve, Te;
      fe.clear(), fe.drawImage(se._canvas, 0, 0, ce, pe);
      try {
        for (Se = fe.getImageData(0, 0, ce, pe), oe = Se.data, ue = oe.length, he = n.Util._hexToRgb(this.colorKey), ve = 0; ve < ue; ve += 4)
          Te = oe[ve + 3], Te > Z ? (oe[ve] = he.r, oe[ve + 1] = he.g, oe[ve + 2] = he.b, oe[ve + 3] = 255) : oe[ve + 3] = 0;
        fe.putImageData(Se, 0, 0);
      } catch (Ie) {
        n.Util.error("Unable to draw hit graph from cached scene canvas. " + Ie.message);
      }
      return this;
    }
    hasPointerCapture(Z) {
      return u.hasPointerCapture(Z, this);
    }
    setPointerCapture(Z) {
      u.setPointerCapture(Z, this);
    }
    releaseCapture(Z) {
      u.releaseCapture(Z, this);
    }
  }
  e.Shape = q, q.prototype._fillFunc = T, q.prototype._strokeFunc = D, q.prototype._fillFuncHit = L, q.prototype._strokeFuncHit = I, q.prototype._centroid = !1, q.prototype.nodeType = "Shape", (0, c._registerNode)(q), q.prototype.eventListeners = {}, q.prototype.on.call(q.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", R), q.prototype.on.call(q.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", U), q.prototype.on.call(q.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", z), q.prototype.on.call(q.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", H), q.prototype.on.call(q.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", K), r.Factory.addGetterSetter(q, "stroke", void 0, (0, o.getStringOrGradientValidator)()), r.Factory.addGetterSetter(q, "strokeWidth", 2, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(q, "fillAfterStrokeEnabled", !1), r.Factory.addGetterSetter(q, "hitStrokeWidth", "auto", (0, o.getNumberOrAutoValidator)()), r.Factory.addGetterSetter(q, "strokeHitEnabled", !0, (0, o.getBooleanValidator)()), r.Factory.addGetterSetter(q, "perfectDrawEnabled", !0, (0, o.getBooleanValidator)()), r.Factory.addGetterSetter(q, "shadowForStrokeEnabled", !0, (0, o.getBooleanValidator)()), r.Factory.addGetterSetter(q, "lineJoin"), r.Factory.addGetterSetter(q, "lineCap"), r.Factory.addGetterSetter(q, "sceneFunc"), r.Factory.addGetterSetter(q, "hitFunc"), r.Factory.addGetterSetter(q, "dash"), r.Factory.addGetterSetter(q, "dashOffset", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(q, "shadowColor", void 0, (0, o.getStringValidator)()), r.Factory.addGetterSetter(q, "shadowBlur", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(q, "shadowOpacity", 1, (0, o.getNumberValidator)()), r.Factory.addComponentsGetterSetter(q, "shadowOffset", ["x", "y"]), r.Factory.addGetterSetter(q, "shadowOffsetX", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(q, "shadowOffsetY", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(q, "fillPatternImage"), r.Factory.addGetterSetter(q, "fill", void 0, (0, o.getStringOrGradientValidator)()), r.Factory.addGetterSetter(q, "fillPatternX", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(q, "fillPatternY", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(q, "fillLinearGradientColorStops"), r.Factory.addGetterSetter(q, "strokeLinearGradientColorStops"), r.Factory.addGetterSetter(q, "fillRadialGradientStartRadius", 0), r.Factory.addGetterSetter(q, "fillRadialGradientEndRadius", 0), r.Factory.addGetterSetter(q, "fillRadialGradientColorStops"), r.Factory.addGetterSetter(q, "fillPatternRepeat", "repeat"), r.Factory.addGetterSetter(q, "fillEnabled", !0), r.Factory.addGetterSetter(q, "strokeEnabled", !0), r.Factory.addGetterSetter(q, "shadowEnabled", !0), r.Factory.addGetterSetter(q, "dashEnabled", !0), r.Factory.addGetterSetter(q, "strokeScaleEnabled", !0), r.Factory.addGetterSetter(q, "fillPriority", "color"), r.Factory.addComponentsGetterSetter(q, "fillPatternOffset", ["x", "y"]), r.Factory.addGetterSetter(q, "fillPatternOffsetX", 0, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(q, "fillPatternOffsetY", 0, (0, o.getNumberValidator)()), r.Factory.addComponentsGetterSetter(q, "fillPatternScale", ["x", "y"]), r.Factory.addGetterSetter(q, "fillPatternScaleX", 1, (0, o.getNumberValidator)()), r.Factory.addGetterSetter(q, "fillPatternScaleY", 1, (0, o.getNumberValidator)()), r.Factory.addComponentsGetterSetter(q, "fillLinearGradientStartPoint", [
    "x",
    "y"
  ]), r.Factory.addComponentsGetterSetter(q, "strokeLinearGradientStartPoint", [
    "x",
    "y"
  ]), r.Factory.addGetterSetter(q, "fillLinearGradientStartPointX", 0), r.Factory.addGetterSetter(q, "strokeLinearGradientStartPointX", 0), r.Factory.addGetterSetter(q, "fillLinearGradientStartPointY", 0), r.Factory.addGetterSetter(q, "strokeLinearGradientStartPointY", 0), r.Factory.addComponentsGetterSetter(q, "fillLinearGradientEndPoint", [
    "x",
    "y"
  ]), r.Factory.addComponentsGetterSetter(q, "strokeLinearGradientEndPoint", [
    "x",
    "y"
  ]), r.Factory.addGetterSetter(q, "fillLinearGradientEndPointX", 0), r.Factory.addGetterSetter(q, "strokeLinearGradientEndPointX", 0), r.Factory.addGetterSetter(q, "fillLinearGradientEndPointY", 0), r.Factory.addGetterSetter(q, "strokeLinearGradientEndPointY", 0), r.Factory.addComponentsGetterSetter(q, "fillRadialGradientStartPoint", [
    "x",
    "y"
  ]), r.Factory.addGetterSetter(q, "fillRadialGradientStartPointX", 0), r.Factory.addGetterSetter(q, "fillRadialGradientStartPointY", 0), r.Factory.addComponentsGetterSetter(q, "fillRadialGradientEndPoint", [
    "x",
    "y"
  ]), r.Factory.addGetterSetter(q, "fillRadialGradientEndPointX", 0), r.Factory.addGetterSetter(q, "fillRadialGradientEndPointY", 0), r.Factory.addGetterSetter(q, "fillPatternRotation", 0), r.Factory.addGetterSetter(q, "fillRule", void 0, (0, o.getStringValidator)()), r.Factory.backCompat(q, {
    dashArray: "dash",
    getDashArray: "getDash",
    setDashArray: "getDash",
    drawFunc: "sceneFunc",
    getDrawFunc: "getSceneFunc",
    setDrawFunc: "setSceneFunc",
    drawHitFunc: "hitFunc",
    getDrawHitFunc: "getHitFunc",
    setDrawHitFunc: "setHitFunc"
  });
})(yu);
Object.defineProperty(w6, "__esModule", { value: !0 });
w6.Layer = void 0;
const wv = cl, gR = g5, m8 = ko, bA = Sa, nB = Kg, c2e = Jn, u2e = yu, d2e = ha;
var f2e = "#", m2e = "beforeDraw", h2e = "draw", jY = [
  { x: 0, y: 0 },
  { x: -1, y: -1 },
  { x: 1, y: -1 },
  { x: 1, y: 1 },
  { x: -1, y: 1 }
], p2e = jY.length;
let ww = class extends gR.Container {
  constructor(t) {
    super(t), this.canvas = new nB.SceneCanvas(), this.hitCanvas = new nB.HitCanvas({
      pixelRatio: 1
    }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
  }
  createPNGStream() {
    return this.canvas._canvas.createPNGStream();
  }
  getCanvas() {
    return this.canvas;
  }
  getNativeCanvasElement() {
    return this.canvas._canvas;
  }
  getHitCanvas() {
    return this.hitCanvas;
  }
  getContext() {
    return this.getCanvas().getContext();
  }
  clear(t) {
    return this.getContext().clear(t), this.getHitCanvas().getContext().clear(t), this;
  }
  setZIndex(t) {
    super.setZIndex(t);
    var n = this.getStage();
    return n && n.content && (n.content.removeChild(this.getNativeCanvasElement()), t < n.children.length - 1 ? n.content.insertBefore(this.getNativeCanvasElement(), n.children[t + 1].getCanvas()._canvas) : n.content.appendChild(this.getNativeCanvasElement())), this;
  }
  moveToTop() {
    m8.Node.prototype.moveToTop.call(this);
    var t = this.getStage();
    return t && t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.appendChild(this.getNativeCanvasElement())), !0;
  }
  moveUp() {
    var t = m8.Node.prototype.moveUp.call(this);
    if (!t)
      return !1;
    var n = this.getStage();
    return !n || !n.content ? !1 : (n.content.removeChild(this.getNativeCanvasElement()), this.index < n.children.length - 1 ? n.content.insertBefore(this.getNativeCanvasElement(), n.children[this.index + 1].getCanvas()._canvas) : n.content.appendChild(this.getNativeCanvasElement()), !0);
  }
  moveDown() {
    if (m8.Node.prototype.moveDown.call(this)) {
      var t = this.getStage();
      if (t) {
        var n = t.children;
        t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), n[this.index + 1].getCanvas()._canvas));
      }
      return !0;
    }
    return !1;
  }
  moveToBottom() {
    if (m8.Node.prototype.moveToBottom.call(this)) {
      var t = this.getStage();
      if (t) {
        var n = t.children;
        t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), n[1].getCanvas()._canvas));
      }
      return !0;
    }
    return !1;
  }
  getLayer() {
    return this;
  }
  remove() {
    var t = this.getNativeCanvasElement();
    return m8.Node.prototype.remove.call(this), t && t.parentNode && wv.Util._isInDocument(t) && t.parentNode.removeChild(t), this;
  }
  getStage() {
    return this.parent;
  }
  setSize({ width: t, height: n }) {
    return this.canvas.setSize(t, n), this.hitCanvas.setSize(t, n), this._setSmoothEnabled(), this;
  }
  _validateAdd(t) {
    var n = t.getType();
    n !== "Group" && n !== "Shape" && wv.Util.throw("You may only add groups and shapes to a layer.");
  }
  _toKonvaCanvas(t) {
    return t = t || {}, t.width = t.width || this.getWidth(), t.height = t.height || this.getHeight(), t.x = t.x !== void 0 ? t.x : this.x(), t.y = t.y !== void 0 ? t.y : this.y(), m8.Node.prototype._toKonvaCanvas.call(this, t);
  }
  _checkVisibility() {
    this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
  }
  _setSmoothEnabled() {
    this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
  }
  getWidth() {
    if (this.parent)
      return this.parent.width();
  }
  setWidth() {
    wv.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
  }
  getHeight() {
    if (this.parent)
      return this.parent.height();
  }
  setHeight() {
    wv.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
  }
  batchDraw() {
    return this._waitingForDraw || (this._waitingForDraw = !0, wv.Util.requestAnimFrame(() => {
      this.draw(), this._waitingForDraw = !1;
    })), this;
  }
  getIntersection(t) {
    if (!this.isListening() || !this.isVisible())
      return null;
    for (var n = 1, r = !1; ; ) {
      for (let s = 0; s < p2e; s++) {
        const o = jY[s], c = this._getIntersection({
          x: t.x + o.x * n,
          y: t.y + o.y * n
        }), u = c.shape;
        if (u)
          return u;
        if (r = !!c.antialiased, !c.antialiased)
          break;
      }
      if (r)
        n += 1;
      else
        return null;
    }
  }
  _getIntersection(t) {
    const n = this.hitCanvas.pixelRatio, r = this.hitCanvas.context.getImageData(Math.round(t.x * n), Math.round(t.y * n), 1, 1).data, s = r[3];
    if (s === 255) {
      const o = wv.Util._rgbToHex(r[0], r[1], r[2]), c = u2e.shapes[f2e + o];
      return c ? {
        shape: c
      } : {
        antialiased: !0
      };
    } else if (s > 0)
      return {
        antialiased: !0
      };
    return {};
  }
  drawScene(t, n) {
    var r = this.getLayer(), s = t || r && r.getCanvas();
    return this._fire(m2e, {
      node: this
    }), this.clearBeforeDraw() && s.getContext().clear(), gR.Container.prototype.drawScene.call(this, s, n), this._fire(h2e, {
      node: this
    }), this;
  }
  drawHit(t, n) {
    var r = this.getLayer(), s = t || r && r.hitCanvas;
    return r && r.clearBeforeDraw() && r.getHitCanvas().getContext().clear(), gR.Container.prototype.drawHit.call(this, s, n), this;
  }
  enableHitGraph() {
    return this.hitGraphEnabled(!0), this;
  }
  disableHitGraph() {
    return this.hitGraphEnabled(!1), this;
  }
  setHitGraphEnabled(t) {
    wv.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(t);
  }
  getHitGraphEnabled(t) {
    return wv.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
  }
  toggleHitCanvas() {
    if (!(!this.parent || !this.parent.content)) {
      var t = this.parent, n = !!this.hitCanvas._canvas.parentNode;
      n ? t.content.removeChild(this.hitCanvas._canvas) : t.content.appendChild(this.hitCanvas._canvas);
    }
  }
  destroy() {
    return wv.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
  }
};
w6.Layer = ww;
ww.prototype.nodeType = "Layer";
(0, d2e._registerNode)(ww);
bA.Factory.addGetterSetter(ww, "imageSmoothingEnabled", !0);
bA.Factory.addGetterSetter(ww, "clearBeforeDraw", !0);
bA.Factory.addGetterSetter(ww, "hitGraphEnabled", !0, (0, c2e.getBooleanValidator)());
var xk = {};
Object.defineProperty(xk, "__esModule", { value: !0 });
xk.FastLayer = void 0;
const g2e = cl, y2e = w6, v2e = ha;
class SA extends y2e.Layer {
  constructor(t) {
    super(t), this.listening(!1), g2e.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
  }
}
xk.FastLayer = SA;
SA.prototype.nodeType = "FastLayer";
(0, v2e._registerNode)(SA);
var Cw = {};
Object.defineProperty(Cw, "__esModule", { value: !0 });
Cw.Group = void 0;
const x2e = cl, b2e = g5, S2e = ha;
let wA = class extends b2e.Container {
  _validateAdd(t) {
    var n = t.getType();
    n !== "Group" && n !== "Shape" && x2e.Util.throw("You may only add groups and shapes to groups.");
  }
};
Cw.Group = wA;
wA.prototype.nodeType = "Group";
(0, S2e._registerNode)(wA);
var Nw = {};
Object.defineProperty(Nw, "__esModule", { value: !0 });
Nw.Animation = void 0;
const yR = ha, rB = cl, vR = function() {
  return yR.glob.performance && yR.glob.performance.now ? function() {
    return yR.glob.performance.now();
  } : function() {
    return (/* @__PURE__ */ new Date()).getTime();
  };
}();
class iy {
  constructor(t, n) {
    this.id = iy.animIdCounter++, this.frame = {
      time: 0,
      timeDiff: 0,
      lastTime: vR(),
      frameRate: 0
    }, this.func = t, this.setLayers(n);
  }
  setLayers(t) {
    let n = [];
    return t && (n = Array.isArray(t) ? t : [t]), this.layers = n, this;
  }
  getLayers() {
    return this.layers;
  }
  addLayer(t) {
    const n = this.layers, r = n.length;
    for (let s = 0; s < r; s++)
      if (n[s]._id === t._id)
        return !1;
    return this.layers.push(t), !0;
  }
  isRunning() {
    const n = iy.animations, r = n.length;
    for (let s = 0; s < r; s++)
      if (n[s].id === this.id)
        return !0;
    return !1;
  }
  start() {
    return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = vR(), iy._addAnimation(this), this;
  }
  stop() {
    return iy._removeAnimation(this), this;
  }
  _updateFrameObject(t) {
    this.frame.timeDiff = t - this.frame.lastTime, this.frame.lastTime = t, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
  }
  static _addAnimation(t) {
    this.animations.push(t), this._handleAnimation();
  }
  static _removeAnimation(t) {
    const n = t.id, r = this.animations, s = r.length;
    for (let o = 0; o < s; o++)
      if (r[o].id === n) {
        this.animations.splice(o, 1);
        break;
      }
  }
  static _runFrames() {
    const t = {}, n = this.animations;
    for (let r = 0; r < n.length; r++) {
      const s = n[r], o = s.layers, c = s.func;
      s._updateFrameObject(vR());
      const u = o.length;
      let m;
      if (c ? m = c.call(s, s.frame) !== !1 : m = !0, !!m)
        for (let y = 0; y < u; y++) {
          const b = o[y];
          b._id !== void 0 && (t[b._id] = b);
        }
    }
    for (let r in t)
      t.hasOwnProperty(r) && t[r].batchDraw();
  }
  static _animationLoop() {
    const t = iy;
    t.animations.length ? (t._runFrames(), rB.Util.requestAnimFrame(t._animationLoop)) : t.animRunning = !1;
  }
  static _handleAnimation() {
    this.animRunning || (this.animRunning = !0, rB.Util.requestAnimFrame(this._animationLoop));
  }
}
Nw.Animation = iy;
iy.animations = [];
iy.animIdCounter = 0;
iy.animRunning = !1;
var EY = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Easings = e.Tween = void 0;
  const t = cl, n = Nw, r = ko, s = ha;
  var o = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
  }, c = 1, u = 2, m = 3, y = 0, b = ["fill", "stroke", "shadowColor"];
  class w {
    constructor(E, T, D, L, I, R, U) {
      this.prop = E, this.propFunc = T, this.begin = L, this._pos = L, this.duration = R, this._change = 0, this.prevPos = 0, this.yoyo = U, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = D, this._change = I - this.begin, this.pause();
    }
    fire(E) {
      var T = this[E];
      T && T();
    }
    setTime(E) {
      E > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : E < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = E, this.update());
    }
    getTime() {
      return this._time;
    }
    setPosition(E) {
      this.prevPos = this._pos, this.propFunc(E), this._pos = E;
    }
    getPosition(E) {
      return E === void 0 && (E = this._time), this.func(E, this.begin, this._change, this.duration);
    }
    play() {
      this.state = u, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
    }
    reverse() {
      this.state = m, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
    }
    seek(E) {
      this.pause(), this._time = E, this.update(), this.fire("onSeek");
    }
    reset() {
      this.pause(), this._time = 0, this.update(), this.fire("onReset");
    }
    finish() {
      this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
    }
    update() {
      this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
    }
    onEnterFrame() {
      var E = this.getTimer() - this._startTime;
      this.state === u ? this.setTime(E) : this.state === m && this.setTime(this.duration - E);
    }
    pause() {
      this.state = c, this.fire("onPause");
    }
    getTimer() {
      return (/* @__PURE__ */ new Date()).getTime();
    }
  }
  class k {
    constructor(E) {
      var T = this, D = E.node, L = D._id, I, R = E.easing || e.Easings.Linear, U = !!E.yoyo, z;
      typeof E.duration > "u" ? I = 0.3 : E.duration === 0 ? I = 1e-3 : I = E.duration, this.node = D, this._id = y++;
      var H = D.getLayer() || (D instanceof s.Konva.Stage ? D.getLayers() : null);
      H || t.Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new n.Animation(function() {
        T.tween.onEnterFrame();
      }, H), this.tween = new w(z, function(K) {
        T._tweenFunc(K);
      }, R, 0, 1, I * 1e3, U), this._addListeners(), k.attrs[L] || (k.attrs[L] = {}), k.attrs[L][this._id] || (k.attrs[L][this._id] = {}), k.tweens[L] || (k.tweens[L] = {});
      for (z in E)
        o[z] === void 0 && this._addAttr(z, E[z]);
      this.reset(), this.onFinish = E.onFinish, this.onReset = E.onReset, this.onUpdate = E.onUpdate;
    }
    _addAttr(E, T) {
      var D = this.node, L = D._id, I, R, U, z, H, K, q, Q;
      if (U = k.tweens[L][E], U && delete k.attrs[L][U][E], I = D.getAttr(E), t.Util._isArray(T))
        if (R = [], H = Math.max(T.length, I.length), E === "points" && T.length !== I.length && (T.length > I.length ? (q = I, I = t.Util._prepareArrayForTween(I, T, D.closed())) : (K = T, T = t.Util._prepareArrayForTween(T, I, D.closed()))), E.indexOf("fill") === 0)
          for (z = 0; z < H; z++)
            if (z % 2 === 0)
              R.push(T[z] - I[z]);
            else {
              var Z = t.Util.colorToRGBA(I[z]);
              Q = t.Util.colorToRGBA(T[z]), I[z] = Z, R.push({
                r: Q.r - Z.r,
                g: Q.g - Z.g,
                b: Q.b - Z.b,
                a: Q.a - Z.a
              });
            }
        else
          for (z = 0; z < H; z++)
            R.push(T[z] - I[z]);
      else b.indexOf(E) !== -1 ? (I = t.Util.colorToRGBA(I), Q = t.Util.colorToRGBA(T), R = {
        r: Q.r - I.r,
        g: Q.g - I.g,
        b: Q.b - I.b,
        a: Q.a - I.a
      }) : R = T - I;
      k.attrs[L][this._id][E] = {
        start: I,
        diff: R,
        end: T,
        trueEnd: K,
        trueStart: q
      }, k.tweens[L][E] = this._id;
    }
    _tweenFunc(E) {
      var T = this.node, D = k.attrs[T._id][this._id], L, I, R, U, z, H, K, q;
      for (L in D) {
        if (I = D[L], R = I.start, U = I.diff, q = I.end, t.Util._isArray(R))
          if (z = [], K = Math.max(R.length, q.length), L.indexOf("fill") === 0)
            for (H = 0; H < K; H++)
              H % 2 === 0 ? z.push((R[H] || 0) + U[H] * E) : z.push("rgba(" + Math.round(R[H].r + U[H].r * E) + "," + Math.round(R[H].g + U[H].g * E) + "," + Math.round(R[H].b + U[H].b * E) + "," + (R[H].a + U[H].a * E) + ")");
          else
            for (H = 0; H < K; H++)
              z.push((R[H] || 0) + U[H] * E);
        else b.indexOf(L) !== -1 ? z = "rgba(" + Math.round(R.r + U.r * E) + "," + Math.round(R.g + U.g * E) + "," + Math.round(R.b + U.b * E) + "," + (R.a + U.a * E) + ")" : z = R + U * E;
        T.setAttr(L, z);
      }
    }
    _addListeners() {
      this.tween.onPlay = () => {
        this.anim.start();
      }, this.tween.onReverse = () => {
        this.anim.start();
      }, this.tween.onPause = () => {
        this.anim.stop();
      }, this.tween.onFinish = () => {
        var E = this.node, T = k.attrs[E._id][this._id];
        T.points && T.points.trueEnd && E.setAttr("points", T.points.trueEnd), this.onFinish && this.onFinish.call(this);
      }, this.tween.onReset = () => {
        var E = this.node, T = k.attrs[E._id][this._id];
        T.points && T.points.trueStart && E.points(T.points.trueStart), this.onReset && this.onReset();
      }, this.tween.onUpdate = () => {
        this.onUpdate && this.onUpdate.call(this);
      };
    }
    play() {
      return this.tween.play(), this;
    }
    reverse() {
      return this.tween.reverse(), this;
    }
    reset() {
      return this.tween.reset(), this;
    }
    seek(E) {
      return this.tween.seek(E * 1e3), this;
    }
    pause() {
      return this.tween.pause(), this;
    }
    finish() {
      return this.tween.finish(), this;
    }
    destroy() {
      var E = this.node._id, T = this._id, D = k.tweens[E], L;
      this.pause();
      for (L in D)
        delete k.tweens[E][L];
      delete k.attrs[E][T];
    }
  }
  e.Tween = k, k.attrs = {}, k.tweens = {}, r.Node.prototype.to = function(j) {
    var E = j.onFinish;
    j.node = this, j.onFinish = function() {
      this.destroy(), E && E();
    };
    var T = new k(j);
    T.play();
  }, e.Easings = {
    BackEaseIn(j, E, T, D) {
      var L = 1.70158;
      return T * (j /= D) * j * ((L + 1) * j - L) + E;
    },
    BackEaseOut(j, E, T, D) {
      var L = 1.70158;
      return T * ((j = j / D - 1) * j * ((L + 1) * j + L) + 1) + E;
    },
    BackEaseInOut(j, E, T, D) {
      var L = 1.70158;
      return (j /= D / 2) < 1 ? T / 2 * (j * j * (((L *= 1.525) + 1) * j - L)) + E : T / 2 * ((j -= 2) * j * (((L *= 1.525) + 1) * j + L) + 2) + E;
    },
    ElasticEaseIn(j, E, T, D, L, I) {
      var R = 0;
      return j === 0 ? E : (j /= D) === 1 ? E + T : (I || (I = D * 0.3), !L || L < Math.abs(T) ? (L = T, R = I / 4) : R = I / (2 * Math.PI) * Math.asin(T / L), -(L * Math.pow(2, 10 * (j -= 1)) * Math.sin((j * D - R) * (2 * Math.PI) / I)) + E);
    },
    ElasticEaseOut(j, E, T, D, L, I) {
      var R = 0;
      return j === 0 ? E : (j /= D) === 1 ? E + T : (I || (I = D * 0.3), !L || L < Math.abs(T) ? (L = T, R = I / 4) : R = I / (2 * Math.PI) * Math.asin(T / L), L * Math.pow(2, -10 * j) * Math.sin((j * D - R) * (2 * Math.PI) / I) + T + E);
    },
    ElasticEaseInOut(j, E, T, D, L, I) {
      var R = 0;
      return j === 0 ? E : (j /= D / 2) === 2 ? E + T : (I || (I = D * (0.3 * 1.5)), !L || L < Math.abs(T) ? (L = T, R = I / 4) : R = I / (2 * Math.PI) * Math.asin(T / L), j < 1 ? -0.5 * (L * Math.pow(2, 10 * (j -= 1)) * Math.sin((j * D - R) * (2 * Math.PI) / I)) + E : L * Math.pow(2, -10 * (j -= 1)) * Math.sin((j * D - R) * (2 * Math.PI) / I) * 0.5 + T + E);
    },
    BounceEaseOut(j, E, T, D) {
      return (j /= D) < 1 / 2.75 ? T * (7.5625 * j * j) + E : j < 2 / 2.75 ? T * (7.5625 * (j -= 1.5 / 2.75) * j + 0.75) + E : j < 2.5 / 2.75 ? T * (7.5625 * (j -= 2.25 / 2.75) * j + 0.9375) + E : T * (7.5625 * (j -= 2.625 / 2.75) * j + 0.984375) + E;
    },
    BounceEaseIn(j, E, T, D) {
      return T - e.Easings.BounceEaseOut(D - j, 0, T, D) + E;
    },
    BounceEaseInOut(j, E, T, D) {
      return j < D / 2 ? e.Easings.BounceEaseIn(j * 2, 0, T, D) * 0.5 + E : e.Easings.BounceEaseOut(j * 2 - D, 0, T, D) * 0.5 + T * 0.5 + E;
    },
    EaseIn(j, E, T, D) {
      return T * (j /= D) * j + E;
    },
    EaseOut(j, E, T, D) {
      return -T * (j /= D) * (j - 2) + E;
    },
    EaseInOut(j, E, T, D) {
      return (j /= D / 2) < 1 ? T / 2 * j * j + E : -T / 2 * (--j * (j - 2) - 1) + E;
    },
    StrongEaseIn(j, E, T, D) {
      return T * (j /= D) * j * j * j * j + E;
    },
    StrongEaseOut(j, E, T, D) {
      return T * ((j = j / D - 1) * j * j * j * j + 1) + E;
    },
    StrongEaseInOut(j, E, T, D) {
      return (j /= D / 2) < 1 ? T / 2 * j * j * j * j * j + E : T / 2 * ((j -= 2) * j * j * j * j + 2) + E;
    },
    Linear(j, E, T, D) {
      return T * j / D + E;
    }
  };
})(EY);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Konva = void 0;
  const t = ha, n = cl, r = ko, s = g5, o = wY, c = w6, u = xk, m = Cw, y = yk, b = yu, w = Nw, k = EY, j = zv, E = Kg;
  e.Konva = n.Util._assign(t.Konva, {
    Util: n.Util,
    Transform: n.Transform,
    Node: r.Node,
    Container: s.Container,
    Stage: o.Stage,
    stages: o.stages,
    Layer: c.Layer,
    FastLayer: u.FastLayer,
    Group: m.Group,
    DD: y.DD,
    Shape: b.Shape,
    shapes: b.shapes,
    Animation: w.Animation,
    Tween: k.Tween,
    Easings: k.Easings,
    Context: j.Context,
    Canvas: E.Canvas
  }), e.default = e.Konva;
})(X9);
var bk = {};
Object.defineProperty(bk, "__esModule", { value: !0 });
bk.Arc = void 0;
const Sk = Sa, w2e = yu, aB = ha, wk = Jn, C2e = ha;
class ex extends w2e.Shape {
  _sceneFunc(t) {
    var n = aB.Konva.getAngle(this.angle()), r = this.clockwise();
    t.beginPath(), t.arc(0, 0, this.outerRadius(), 0, n, r), t.arc(0, 0, this.innerRadius(), n, 0, !r), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
  getSelfRect() {
    const t = this.innerRadius(), n = this.outerRadius(), r = this.clockwise(), s = aB.Konva.getAngle(r ? 360 - this.angle() : this.angle()), o = Math.cos(Math.min(s, Math.PI)), c = 1, u = Math.sin(Math.min(Math.max(Math.PI, s), 3 * Math.PI / 2)), m = Math.sin(Math.min(s, Math.PI / 2)), y = o * (o > 0 ? t : n), b = c * n, w = u * (u > 0 ? t : n), k = m * (m > 0 ? n : t);
    return {
      x: y,
      y: r ? -1 * k : w,
      width: b - y,
      height: k - w
    };
  }
}
bk.Arc = ex;
ex.prototype._centroid = !0;
ex.prototype.className = "Arc";
ex.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
(0, C2e._registerNode)(ex);
Sk.Factory.addGetterSetter(ex, "innerRadius", 0, (0, wk.getNumberValidator)());
Sk.Factory.addGetterSetter(ex, "outerRadius", 0, (0, wk.getNumberValidator)());
Sk.Factory.addGetterSetter(ex, "angle", 0, (0, wk.getNumberValidator)());
Sk.Factory.addGetterSetter(ex, "clockwise", !1, (0, wk.getBooleanValidator)());
var Ck = {}, C6 = {};
Object.defineProperty(C6, "__esModule", { value: !0 });
C6.Line = void 0;
const Nk = Sa, N2e = yu, kY = Jn, j2e = ha;
function ZD(e, t, n, r, s, o, c) {
  var u = Math.sqrt(Math.pow(n - e, 2) + Math.pow(r - t, 2)), m = Math.sqrt(Math.pow(s - n, 2) + Math.pow(o - r, 2)), y = c * u / (u + m), b = c * m / (u + m), w = n - y * (s - e), k = r - y * (o - t), j = n + b * (s - e), E = r + b * (o - t);
  return [w, k, j, E];
}
function sB(e, t) {
  var n = e.length, r = [], s, o;
  for (s = 2; s < n - 2; s += 2)
    o = ZD(e[s - 2], e[s - 1], e[s], e[s + 1], e[s + 2], e[s + 3], t), !isNaN(o[0]) && (r.push(o[0]), r.push(o[1]), r.push(e[s]), r.push(e[s + 1]), r.push(o[2]), r.push(o[3]));
  return r;
}
class eb extends N2e.Shape {
  constructor(t) {
    super(t), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
      this._clearCache("tensionPoints");
    });
  }
  _sceneFunc(t) {
    var n = this.points(), r = n.length, s = this.tension(), o = this.closed(), c = this.bezier(), u, m, y;
    if (r) {
      if (t.beginPath(), t.moveTo(n[0], n[1]), s !== 0 && r > 4) {
        for (u = this.getTensionPoints(), m = u.length, y = o ? 0 : 4, o || t.quadraticCurveTo(u[0], u[1], u[2], u[3]); y < m - 2; )
          t.bezierCurveTo(u[y++], u[y++], u[y++], u[y++], u[y++], u[y++]);
        o || t.quadraticCurveTo(u[m - 2], u[m - 1], n[r - 2], n[r - 1]);
      } else if (c)
        for (y = 2; y < r; )
          t.bezierCurveTo(n[y++], n[y++], n[y++], n[y++], n[y++], n[y++]);
      else
        for (y = 2; y < r; y += 2)
          t.lineTo(n[y], n[y + 1]);
      o ? (t.closePath(), t.fillStrokeShape(this)) : t.strokeShape(this);
    }
  }
  getTensionPoints() {
    return this._getCache("tensionPoints", this._getTensionPoints);
  }
  _getTensionPoints() {
    return this.closed() ? this._getTensionPointsClosed() : sB(this.points(), this.tension());
  }
  _getTensionPointsClosed() {
    var t = this.points(), n = t.length, r = this.tension(), s = ZD(t[n - 2], t[n - 1], t[0], t[1], t[2], t[3], r), o = ZD(t[n - 4], t[n - 3], t[n - 2], t[n - 1], t[0], t[1], r), c = sB(t, r), u = [s[2], s[3]].concat(c).concat([
      o[0],
      o[1],
      t[n - 2],
      t[n - 1],
      o[2],
      o[3],
      s[0],
      s[1],
      t[0],
      t[1]
    ]);
    return u;
  }
  getWidth() {
    return this.getSelfRect().width;
  }
  getHeight() {
    return this.getSelfRect().height;
  }
  getSelfRect() {
    var t = this.points();
    if (t.length < 4)
      return {
        x: t[0] || 0,
        y: t[1] || 0,
        width: 0,
        height: 0
      };
    this.tension() !== 0 ? t = [
      t[0],
      t[1],
      ...this._getTensionPoints(),
      t[t.length - 2],
      t[t.length - 1]
    ] : t = this.points();
    for (var n = t[0], r = t[0], s = t[1], o = t[1], c, u, m = 0; m < t.length / 2; m++)
      c = t[m * 2], u = t[m * 2 + 1], n = Math.min(n, c), r = Math.max(r, c), s = Math.min(s, u), o = Math.max(o, u);
    return {
      x: n,
      y: s,
      width: r - n,
      height: o - s
    };
  }
}
C6.Line = eb;
eb.prototype.className = "Line";
eb.prototype._attrsAffectingSize = ["points", "bezier", "tension"];
(0, j2e._registerNode)(eb);
Nk.Factory.addGetterSetter(eb, "closed", !1);
Nk.Factory.addGetterSetter(eb, "bezier", !1);
Nk.Factory.addGetterSetter(eb, "tension", 0, (0, kY.getNumberValidator)());
Nk.Factory.addGetterSetter(eb, "points", [], (0, kY.getNumberArrayValidator)());
var jw = {}, _Y = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.t2length = e.getQuadraticArcLength = e.getCubicArcLength = e.binomialCoefficients = e.cValues = e.tValues = void 0, e.tValues = [
    [],
    [],
    [
      -0.5773502691896257,
      0.5773502691896257
    ],
    [
      0,
      -0.7745966692414834,
      0.7745966692414834
    ],
    [
      -0.33998104358485626,
      0.33998104358485626,
      -0.8611363115940526,
      0.8611363115940526
    ],
    [
      0,
      -0.5384693101056831,
      0.5384693101056831,
      -0.906179845938664,
      0.906179845938664
    ],
    [
      0.6612093864662645,
      -0.6612093864662645,
      -0.2386191860831969,
      0.2386191860831969,
      -0.932469514203152,
      0.932469514203152
    ],
    [
      0,
      0.4058451513773972,
      -0.4058451513773972,
      -0.7415311855993945,
      0.7415311855993945,
      -0.9491079123427585,
      0.9491079123427585
    ],
    [
      -0.1834346424956498,
      0.1834346424956498,
      -0.525532409916329,
      0.525532409916329,
      -0.7966664774136267,
      0.7966664774136267,
      -0.9602898564975363,
      0.9602898564975363
    ],
    [
      0,
      -0.8360311073266358,
      0.8360311073266358,
      -0.9681602395076261,
      0.9681602395076261,
      -0.3242534234038089,
      0.3242534234038089,
      -0.6133714327005904,
      0.6133714327005904
    ],
    [
      -0.14887433898163122,
      0.14887433898163122,
      -0.4333953941292472,
      0.4333953941292472,
      -0.6794095682990244,
      0.6794095682990244,
      -0.8650633666889845,
      0.8650633666889845,
      -0.9739065285171717,
      0.9739065285171717
    ],
    [
      0,
      -0.26954315595234496,
      0.26954315595234496,
      -0.5190961292068118,
      0.5190961292068118,
      -0.7301520055740494,
      0.7301520055740494,
      -0.8870625997680953,
      0.8870625997680953,
      -0.978228658146057,
      0.978228658146057
    ],
    [
      -0.1252334085114689,
      0.1252334085114689,
      -0.3678314989981802,
      0.3678314989981802,
      -0.5873179542866175,
      0.5873179542866175,
      -0.7699026741943047,
      0.7699026741943047,
      -0.9041172563704749,
      0.9041172563704749,
      -0.9815606342467192,
      0.9815606342467192
    ],
    [
      0,
      -0.2304583159551348,
      0.2304583159551348,
      -0.44849275103644687,
      0.44849275103644687,
      -0.6423493394403402,
      0.6423493394403402,
      -0.8015780907333099,
      0.8015780907333099,
      -0.9175983992229779,
      0.9175983992229779,
      -0.9841830547185881,
      0.9841830547185881
    ],
    [
      -0.10805494870734367,
      0.10805494870734367,
      -0.31911236892788974,
      0.31911236892788974,
      -0.5152486363581541,
      0.5152486363581541,
      -0.6872929048116855,
      0.6872929048116855,
      -0.827201315069765,
      0.827201315069765,
      -0.9284348836635735,
      0.9284348836635735,
      -0.9862838086968123,
      0.9862838086968123
    ],
    [
      0,
      -0.20119409399743451,
      0.20119409399743451,
      -0.3941513470775634,
      0.3941513470775634,
      -0.5709721726085388,
      0.5709721726085388,
      -0.7244177313601701,
      0.7244177313601701,
      -0.8482065834104272,
      0.8482065834104272,
      -0.937273392400706,
      0.937273392400706,
      -0.9879925180204854,
      0.9879925180204854
    ],
    [
      -0.09501250983763744,
      0.09501250983763744,
      -0.2816035507792589,
      0.2816035507792589,
      -0.45801677765722737,
      0.45801677765722737,
      -0.6178762444026438,
      0.6178762444026438,
      -0.755404408355003,
      0.755404408355003,
      -0.8656312023878318,
      0.8656312023878318,
      -0.9445750230732326,
      0.9445750230732326,
      -0.9894009349916499,
      0.9894009349916499
    ],
    [
      0,
      -0.17848418149584785,
      0.17848418149584785,
      -0.3512317634538763,
      0.3512317634538763,
      -0.5126905370864769,
      0.5126905370864769,
      -0.6576711592166907,
      0.6576711592166907,
      -0.7815140038968014,
      0.7815140038968014,
      -0.8802391537269859,
      0.8802391537269859,
      -0.9506755217687678,
      0.9506755217687678,
      -0.9905754753144174,
      0.9905754753144174
    ],
    [
      -0.0847750130417353,
      0.0847750130417353,
      -0.2518862256915055,
      0.2518862256915055,
      -0.41175116146284263,
      0.41175116146284263,
      -0.5597708310739475,
      0.5597708310739475,
      -0.6916870430603532,
      0.6916870430603532,
      -0.8037049589725231,
      0.8037049589725231,
      -0.8926024664975557,
      0.8926024664975557,
      -0.9558239495713977,
      0.9558239495713977,
      -0.9915651684209309,
      0.9915651684209309
    ],
    [
      0,
      -0.16035864564022537,
      0.16035864564022537,
      -0.31656409996362983,
      0.31656409996362983,
      -0.46457074137596094,
      0.46457074137596094,
      -0.600545304661681,
      0.600545304661681,
      -0.7209661773352294,
      0.7209661773352294,
      -0.8227146565371428,
      0.8227146565371428,
      -0.9031559036148179,
      0.9031559036148179,
      -0.96020815213483,
      0.96020815213483,
      -0.9924068438435844,
      0.9924068438435844
    ],
    [
      -0.07652652113349734,
      0.07652652113349734,
      -0.22778585114164507,
      0.22778585114164507,
      -0.37370608871541955,
      0.37370608871541955,
      -0.5108670019508271,
      0.5108670019508271,
      -0.636053680726515,
      0.636053680726515,
      -0.7463319064601508,
      0.7463319064601508,
      -0.8391169718222188,
      0.8391169718222188,
      -0.912234428251326,
      0.912234428251326,
      -0.9639719272779138,
      0.9639719272779138,
      -0.9931285991850949,
      0.9931285991850949
    ],
    [
      0,
      -0.1455618541608951,
      0.1455618541608951,
      -0.2880213168024011,
      0.2880213168024011,
      -0.4243421202074388,
      0.4243421202074388,
      -0.5516188358872198,
      0.5516188358872198,
      -0.6671388041974123,
      0.6671388041974123,
      -0.7684399634756779,
      0.7684399634756779,
      -0.8533633645833173,
      0.8533633645833173,
      -0.9200993341504008,
      0.9200993341504008,
      -0.9672268385663063,
      0.9672268385663063,
      -0.9937521706203895,
      0.9937521706203895
    ],
    [
      -0.06973927331972223,
      0.06973927331972223,
      -0.20786042668822127,
      0.20786042668822127,
      -0.34193582089208424,
      0.34193582089208424,
      -0.469355837986757,
      0.469355837986757,
      -0.5876404035069116,
      0.5876404035069116,
      -0.6944872631866827,
      0.6944872631866827,
      -0.7878168059792081,
      0.7878168059792081,
      -0.8658125777203002,
      0.8658125777203002,
      -0.926956772187174,
      0.926956772187174,
      -0.9700604978354287,
      0.9700604978354287,
      -0.9942945854823992,
      0.9942945854823992
    ],
    [
      0,
      -0.1332568242984661,
      0.1332568242984661,
      -0.26413568097034495,
      0.26413568097034495,
      -0.3903010380302908,
      0.3903010380302908,
      -0.5095014778460075,
      0.5095014778460075,
      -0.6196098757636461,
      0.6196098757636461,
      -0.7186613631319502,
      0.7186613631319502,
      -0.8048884016188399,
      0.8048884016188399,
      -0.8767523582704416,
      0.8767523582704416,
      -0.9329710868260161,
      0.9329710868260161,
      -0.9725424712181152,
      0.9725424712181152,
      -0.9947693349975522,
      0.9947693349975522
    ],
    [
      -0.06405689286260563,
      0.06405689286260563,
      -0.1911188674736163,
      0.1911188674736163,
      -0.3150426796961634,
      0.3150426796961634,
      -0.4337935076260451,
      0.4337935076260451,
      -0.5454214713888396,
      0.5454214713888396,
      -0.6480936519369755,
      0.6480936519369755,
      -0.7401241915785544,
      0.7401241915785544,
      -0.820001985973903,
      0.820001985973903,
      -0.8864155270044011,
      0.8864155270044011,
      -0.9382745520027328,
      0.9382745520027328,
      -0.9747285559713095,
      0.9747285559713095,
      -0.9951872199970213,
      0.9951872199970213
    ]
  ], e.cValues = [
    [],
    [],
    [1, 1],
    [
      0.8888888888888888,
      0.5555555555555556,
      0.5555555555555556
    ],
    [
      0.6521451548625461,
      0.6521451548625461,
      0.34785484513745385,
      0.34785484513745385
    ],
    [
      0.5688888888888889,
      0.47862867049936647,
      0.47862867049936647,
      0.23692688505618908,
      0.23692688505618908
    ],
    [
      0.3607615730481386,
      0.3607615730481386,
      0.46791393457269104,
      0.46791393457269104,
      0.17132449237917036,
      0.17132449237917036
    ],
    [
      0.4179591836734694,
      0.3818300505051189,
      0.3818300505051189,
      0.27970539148927664,
      0.27970539148927664,
      0.1294849661688697,
      0.1294849661688697
    ],
    [
      0.362683783378362,
      0.362683783378362,
      0.31370664587788727,
      0.31370664587788727,
      0.22238103445337448,
      0.22238103445337448,
      0.10122853629037626,
      0.10122853629037626
    ],
    [
      0.3302393550012598,
      0.1806481606948574,
      0.1806481606948574,
      0.08127438836157441,
      0.08127438836157441,
      0.31234707704000286,
      0.31234707704000286,
      0.26061069640293544,
      0.26061069640293544
    ],
    [
      0.29552422471475287,
      0.29552422471475287,
      0.26926671930999635,
      0.26926671930999635,
      0.21908636251598204,
      0.21908636251598204,
      0.1494513491505806,
      0.1494513491505806,
      0.06667134430868814,
      0.06667134430868814
    ],
    [
      0.2729250867779006,
      0.26280454451024665,
      0.26280454451024665,
      0.23319376459199048,
      0.23319376459199048,
      0.18629021092773426,
      0.18629021092773426,
      0.1255803694649046,
      0.1255803694649046,
      0.05566856711617366,
      0.05566856711617366
    ],
    [
      0.24914704581340277,
      0.24914704581340277,
      0.2334925365383548,
      0.2334925365383548,
      0.20316742672306592,
      0.20316742672306592,
      0.16007832854334622,
      0.16007832854334622,
      0.10693932599531843,
      0.10693932599531843,
      0.04717533638651183,
      0.04717533638651183
    ],
    [
      0.2325515532308739,
      0.22628318026289723,
      0.22628318026289723,
      0.2078160475368885,
      0.2078160475368885,
      0.17814598076194574,
      0.17814598076194574,
      0.13887351021978725,
      0.13887351021978725,
      0.09212149983772845,
      0.09212149983772845,
      0.04048400476531588,
      0.04048400476531588
    ],
    [
      0.2152638534631578,
      0.2152638534631578,
      0.2051984637212956,
      0.2051984637212956,
      0.18553839747793782,
      0.18553839747793782,
      0.15720316715819355,
      0.15720316715819355,
      0.12151857068790319,
      0.12151857068790319,
      0.08015808715976021,
      0.08015808715976021,
      0.03511946033175186,
      0.03511946033175186
    ],
    [
      0.2025782419255613,
      0.19843148532711158,
      0.19843148532711158,
      0.1861610000155622,
      0.1861610000155622,
      0.16626920581699392,
      0.16626920581699392,
      0.13957067792615432,
      0.13957067792615432,
      0.10715922046717194,
      0.10715922046717194,
      0.07036604748810812,
      0.07036604748810812,
      0.03075324199611727,
      0.03075324199611727
    ],
    [
      0.1894506104550685,
      0.1894506104550685,
      0.18260341504492358,
      0.18260341504492358,
      0.16915651939500254,
      0.16915651939500254,
      0.14959598881657674,
      0.14959598881657674,
      0.12462897125553388,
      0.12462897125553388,
      0.09515851168249279,
      0.09515851168249279,
      0.062253523938647894,
      0.062253523938647894,
      0.027152459411754096,
      0.027152459411754096
    ],
    [
      0.17944647035620653,
      0.17656270536699264,
      0.17656270536699264,
      0.16800410215645004,
      0.16800410215645004,
      0.15404576107681028,
      0.15404576107681028,
      0.13513636846852548,
      0.13513636846852548,
      0.11188384719340397,
      0.11188384719340397,
      0.08503614831717918,
      0.08503614831717918,
      0.0554595293739872,
      0.0554595293739872,
      0.02414830286854793,
      0.02414830286854793
    ],
    [
      0.1691423829631436,
      0.1691423829631436,
      0.16427648374583273,
      0.16427648374583273,
      0.15468467512626524,
      0.15468467512626524,
      0.14064291467065065,
      0.14064291467065065,
      0.12255520671147846,
      0.12255520671147846,
      0.10094204410628717,
      0.10094204410628717,
      0.07642573025488905,
      0.07642573025488905,
      0.0497145488949698,
      0.0497145488949698,
      0.02161601352648331,
      0.02161601352648331
    ],
    [
      0.1610544498487837,
      0.15896884339395434,
      0.15896884339395434,
      0.15276604206585967,
      0.15276604206585967,
      0.1426067021736066,
      0.1426067021736066,
      0.12875396253933621,
      0.12875396253933621,
      0.11156664554733399,
      0.11156664554733399,
      0.09149002162245,
      0.09149002162245,
      0.06904454273764123,
      0.06904454273764123,
      0.0448142267656996,
      0.0448142267656996,
      0.019461788229726478,
      0.019461788229726478
    ],
    [
      0.15275338713072584,
      0.15275338713072584,
      0.14917298647260374,
      0.14917298647260374,
      0.14209610931838204,
      0.14209610931838204,
      0.13168863844917664,
      0.13168863844917664,
      0.11819453196151841,
      0.11819453196151841,
      0.10193011981724044,
      0.10193011981724044,
      0.08327674157670475,
      0.08327674157670475,
      0.06267204833410907,
      0.06267204833410907,
      0.04060142980038694,
      0.04060142980038694,
      0.017614007139152118,
      0.017614007139152118
    ],
    [
      0.14608113364969041,
      0.14452440398997005,
      0.14452440398997005,
      0.13988739479107315,
      0.13988739479107315,
      0.13226893863333747,
      0.13226893863333747,
      0.12183141605372853,
      0.12183141605372853,
      0.10879729916714838,
      0.10879729916714838,
      0.09344442345603386,
      0.09344442345603386,
      0.0761001136283793,
      0.0761001136283793,
      0.057134425426857205,
      0.057134425426857205,
      0.036953789770852494,
      0.036953789770852494,
      0.016017228257774335,
      0.016017228257774335
    ],
    [
      0.13925187285563198,
      0.13925187285563198,
      0.13654149834601517,
      0.13654149834601517,
      0.13117350478706238,
      0.13117350478706238,
      0.12325237681051242,
      0.12325237681051242,
      0.11293229608053922,
      0.11293229608053922,
      0.10041414444288096,
      0.10041414444288096,
      0.08594160621706773,
      0.08594160621706773,
      0.06979646842452049,
      0.06979646842452049,
      0.052293335152683286,
      0.052293335152683286,
      0.03377490158481415,
      0.03377490158481415,
      0.0146279952982722,
      0.0146279952982722
    ],
    [
      0.13365457218610619,
      0.1324620394046966,
      0.1324620394046966,
      0.12890572218808216,
      0.12890572218808216,
      0.12304908430672953,
      0.12304908430672953,
      0.11499664022241136,
      0.11499664022241136,
      0.10489209146454141,
      0.10489209146454141,
      0.09291576606003515,
      0.09291576606003515,
      0.07928141177671895,
      0.07928141177671895,
      0.06423242140852585,
      0.06423242140852585,
      0.04803767173108467,
      0.04803767173108467,
      0.030988005856979445,
      0.030988005856979445,
      0.013411859487141771,
      0.013411859487141771
    ],
    [
      0.12793819534675216,
      0.12793819534675216,
      0.1258374563468283,
      0.1258374563468283,
      0.12167047292780339,
      0.12167047292780339,
      0.1155056680537256,
      0.1155056680537256,
      0.10744427011596563,
      0.10744427011596563,
      0.09761865210411388,
      0.09761865210411388,
      0.08619016153195327,
      0.08619016153195327,
      0.0733464814110803,
      0.0733464814110803,
      0.05929858491543678,
      0.05929858491543678,
      0.04427743881741981,
      0.04427743881741981,
      0.028531388628933663,
      0.028531388628933663,
      0.0123412297999872,
      0.0123412297999872
    ]
  ], e.binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
  const t = (c, u, m) => {
    let y, b, w;
    y = m / 2, b = 0;
    for (let j = 0; j < 20; j++)
      w = y * e.tValues[20][j] + y, b += e.cValues[20][j] * r(c, u, w);
    return y * b;
  };
  e.getCubicArcLength = t;
  const n = (c, u, m) => {
    m === void 0 && (m = 1);
    const y = c[0] - 2 * c[1] + c[2], b = u[0] - 2 * u[1] + u[2], w = 2 * c[1] - 2 * c[0], k = 2 * u[1] - 2 * u[0], j = 4 * (y * y + b * b), E = 4 * (y * w + b * k), T = w * w + k * k;
    if (j === 0)
      return m * Math.sqrt(Math.pow(c[2] - c[0], 2) + Math.pow(u[2] - u[0], 2));
    const D = E / (2 * j), L = T / j, I = m + D, R = L - D * D, U = I * I + R > 0 ? Math.sqrt(I * I + R) : 0, z = D * D + R > 0 ? Math.sqrt(D * D + R) : 0, H = D + Math.sqrt(D * D + R) !== 0 ? R * Math.log(Math.abs((I + U) / (D + z))) : 0;
    return Math.sqrt(j) / 2 * (I * U - D * z + H);
  };
  e.getQuadraticArcLength = n;
  function r(c, u, m) {
    const y = s(1, m, c), b = s(1, m, u), w = y * y + b * b;
    return Math.sqrt(w);
  }
  const s = (c, u, m) => {
    const y = m.length - 1;
    let b, w;
    if (y === 0)
      return 0;
    if (c === 0) {
      w = 0;
      for (let k = 0; k <= y; k++)
        w += e.binomialCoefficients[y][k] * Math.pow(1 - u, y - k) * Math.pow(u, k) * m[k];
      return w;
    } else {
      b = new Array(y);
      for (let k = 0; k < y; k++)
        b[k] = y * (m[k + 1] - m[k]);
      return s(c - 1, u, b);
    }
  }, o = (c, u, m) => {
    let y = 1, b = c / u, w = (c - m(b)) / u, k = 0;
    for (; y > 1e-3; ) {
      const j = m(b + w), E = Math.abs(c - j) / u;
      if (E < y)
        y = E, b += w;
      else {
        const T = m(b - w), D = Math.abs(c - T) / u;
        D < y ? (y = D, b -= w) : w /= 2;
      }
      if (k++, k > 500)
        break;
    }
    return b;
  };
  e.t2length = o;
})(_Y);
Object.defineProperty(jw, "__esModule", { value: !0 });
jw.Path = void 0;
const E2e = Sa, k2e = yu, _2e = ha, h8 = _Y;
class uu extends k2e.Shape {
  constructor(t) {
    super(t), this.dataArray = [], this.pathLength = 0, this._readDataAttribute(), this.on("dataChange.konva", function() {
      this._readDataAttribute();
    });
  }
  _readDataAttribute() {
    this.dataArray = uu.parsePathData(this.data()), this.pathLength = uu.getPathLength(this.dataArray);
  }
  _sceneFunc(t) {
    var n = this.dataArray;
    t.beginPath();
    for (var r = !1, s = 0; s < n.length; s++) {
      var o = n[s].command, c = n[s].points;
      switch (o) {
        case "L":
          t.lineTo(c[0], c[1]);
          break;
        case "M":
          t.moveTo(c[0], c[1]);
          break;
        case "C":
          t.bezierCurveTo(c[0], c[1], c[2], c[3], c[4], c[5]);
          break;
        case "Q":
          t.quadraticCurveTo(c[0], c[1], c[2], c[3]);
          break;
        case "A":
          var u = c[0], m = c[1], y = c[2], b = c[3], w = c[4], k = c[5], j = c[6], E = c[7], T = y > b ? y : b, D = y > b ? 1 : y / b, L = y > b ? b / y : 1;
          t.translate(u, m), t.rotate(j), t.scale(D, L), t.arc(0, 0, T, w, w + k, 1 - E), t.scale(1 / D, 1 / L), t.rotate(-j), t.translate(-u, -m);
          break;
        case "z":
          r = !0, t.closePath();
          break;
      }
    }
    !r && !this.hasFill() ? t.strokeShape(this) : t.fillStrokeShape(this);
  }
  getSelfRect() {
    var t = [];
    this.dataArray.forEach(function(y) {
      if (y.command === "A") {
        var b = y.points[4], w = y.points[5], k = y.points[4] + w, j = Math.PI / 180;
        if (Math.abs(b - k) < j && (j = Math.abs(b - k)), w < 0)
          for (let E = b - j; E > k; E -= j) {
            const T = uu.getPointOnEllipticalArc(y.points[0], y.points[1], y.points[2], y.points[3], E, 0);
            t.push(T.x, T.y);
          }
        else
          for (let E = b + j; E < k; E += j) {
            const T = uu.getPointOnEllipticalArc(y.points[0], y.points[1], y.points[2], y.points[3], E, 0);
            t.push(T.x, T.y);
          }
      } else if (y.command === "C")
        for (let E = 0; E <= 1; E += 0.01) {
          const T = uu.getPointOnCubicBezier(E, y.start.x, y.start.y, y.points[0], y.points[1], y.points[2], y.points[3], y.points[4], y.points[5]);
          t.push(T.x, T.y);
        }
      else
        t = t.concat(y.points);
    });
    for (var n = t[0], r = t[0], s = t[1], o = t[1], c, u, m = 0; m < t.length / 2; m++)
      c = t[m * 2], u = t[m * 2 + 1], isNaN(c) || (n = Math.min(n, c), r = Math.max(r, c)), isNaN(u) || (s = Math.min(s, u), o = Math.max(o, u));
    return {
      x: n,
      y: s,
      width: r - n,
      height: o - s
    };
  }
  getLength() {
    return this.pathLength;
  }
  getPointAtLength(t) {
    return uu.getPointAtLengthOfDataArray(t, this.dataArray);
  }
  static getLineLength(t, n, r, s) {
    return Math.sqrt((r - t) * (r - t) + (s - n) * (s - n));
  }
  static getPathLength(t) {
    let n = 0;
    for (var r = 0; r < t.length; ++r)
      n += t[r].pathLength;
    return n;
  }
  static getPointAtLengthOfDataArray(t, n) {
    var r, s = 0, o = n.length;
    if (!o)
      return null;
    for (; s < o && t > n[s].pathLength; )
      t -= n[s].pathLength, ++s;
    if (s === o)
      return r = n[s - 1].points.slice(-2), {
        x: r[0],
        y: r[1]
      };
    if (t < 0.01)
      return r = n[s].points.slice(0, 2), {
        x: r[0],
        y: r[1]
      };
    var c = n[s], u = c.points;
    switch (c.command) {
      case "L":
        return uu.getPointOnLine(t, c.start.x, c.start.y, u[0], u[1]);
      case "C":
        return uu.getPointOnCubicBezier((0, h8.t2length)(t, uu.getPathLength(n), (T) => (0, h8.getCubicArcLength)([c.start.x, u[0], u[2], u[4]], [c.start.y, u[1], u[3], u[5]], T)), c.start.x, c.start.y, u[0], u[1], u[2], u[3], u[4], u[5]);
      case "Q":
        return uu.getPointOnQuadraticBezier((0, h8.t2length)(t, uu.getPathLength(n), (T) => (0, h8.getQuadraticArcLength)([c.start.x, u[0], u[2]], [c.start.y, u[1], u[3]], T)), c.start.x, c.start.y, u[0], u[1], u[2], u[3]);
      case "A":
        var m = u[0], y = u[1], b = u[2], w = u[3], k = u[4], j = u[5], E = u[6];
        return k += j * t / c.pathLength, uu.getPointOnEllipticalArc(m, y, b, w, k, E);
    }
    return null;
  }
  static getPointOnLine(t, n, r, s, o, c, u) {
    c = c ?? n, u = u ?? r;
    const m = this.getLineLength(n, r, s, o);
    if (m < 1e-10)
      return { x: n, y: r };
    if (s === n)
      return { x: c, y: u + (o > r ? t : -t) };
    const y = (o - r) / (s - n), b = Math.sqrt(t * t / (1 + y * y)) * (s < n ? -1 : 1), w = y * b;
    if (Math.abs(u - r - y * (c - n)) < 1e-10)
      return { x: c + b, y: u + w };
    const k = ((c - n) * (s - n) + (u - r) * (o - r)) / (m * m), j = n + k * (s - n), E = r + k * (o - r), T = this.getLineLength(c, u, j, E), D = Math.sqrt(t * t - T * T), L = Math.sqrt(D * D / (1 + y * y)) * (s < n ? -1 : 1), I = y * L;
    return { x: j + L, y: E + I };
  }
  static getPointOnCubicBezier(t, n, r, s, o, c, u, m, y) {
    function b(D) {
      return D * D * D;
    }
    function w(D) {
      return 3 * D * D * (1 - D);
    }
    function k(D) {
      return 3 * D * (1 - D) * (1 - D);
    }
    function j(D) {
      return (1 - D) * (1 - D) * (1 - D);
    }
    var E = m * b(t) + c * w(t) + s * k(t) + n * j(t), T = y * b(t) + u * w(t) + o * k(t) + r * j(t);
    return {
      x: E,
      y: T
    };
  }
  static getPointOnQuadraticBezier(t, n, r, s, o, c, u) {
    function m(j) {
      return j * j;
    }
    function y(j) {
      return 2 * j * (1 - j);
    }
    function b(j) {
      return (1 - j) * (1 - j);
    }
    var w = c * m(t) + s * y(t) + n * b(t), k = u * m(t) + o * y(t) + r * b(t);
    return {
      x: w,
      y: k
    };
  }
  static getPointOnEllipticalArc(t, n, r, s, o, c) {
    var u = Math.cos(c), m = Math.sin(c), y = {
      x: r * Math.cos(o),
      y: s * Math.sin(o)
    };
    return {
      x: t + (y.x * u - y.y * m),
      y: n + (y.x * m + y.y * u)
    };
  }
  static parsePathData(t) {
    if (!t)
      return [];
    var n = t, r = [
      "m",
      "M",
      "l",
      "L",
      "v",
      "V",
      "h",
      "H",
      "z",
      "Z",
      "c",
      "C",
      "q",
      "Q",
      "t",
      "T",
      "s",
      "S",
      "a",
      "A"
    ];
    n = n.replace(new RegExp(" ", "g"), ",");
    for (var s = 0; s < r.length; s++)
      n = n.replace(new RegExp(r[s], "g"), "|" + r[s]);
    var o = n.split("|"), c = [], u = [], m = 0, y = 0, b = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi, w;
    for (s = 1; s < o.length; s++) {
      var k = o[s], j = k.charAt(0);
      for (k = k.slice(1), u.length = 0; w = b.exec(k); )
        u.push(w[0]);
      for (var E = [], T = 0, D = u.length; T < D; T++) {
        if (u[T] === "00") {
          E.push(0, 0);
          continue;
        }
        var L = parseFloat(u[T]);
        isNaN(L) ? E.push(0) : E.push(L);
      }
      for (; E.length > 0 && !isNaN(E[0]); ) {
        var I = "", R = [], U = m, z = y, H, K, q, Q, Z, X, se, te, fe, ce;
        switch (j) {
          case "l":
            m += E.shift(), y += E.shift(), I = "L", R.push(m, y);
            break;
          case "L":
            m = E.shift(), y = E.shift(), R.push(m, y);
            break;
          case "m":
            var pe = E.shift(), Se = E.shift();
            if (m += pe, y += Se, I = "M", c.length > 2 && c[c.length - 1].command === "z") {
              for (var oe = c.length - 2; oe >= 0; oe--)
                if (c[oe].command === "M") {
                  m = c[oe].points[0] + pe, y = c[oe].points[1] + Se;
                  break;
                }
            }
            R.push(m, y), j = "l";
            break;
          case "M":
            m = E.shift(), y = E.shift(), I = "M", R.push(m, y), j = "L";
            break;
          case "h":
            m += E.shift(), I = "L", R.push(m, y);
            break;
          case "H":
            m = E.shift(), I = "L", R.push(m, y);
            break;
          case "v":
            y += E.shift(), I = "L", R.push(m, y);
            break;
          case "V":
            y = E.shift(), I = "L", R.push(m, y);
            break;
          case "C":
            R.push(E.shift(), E.shift(), E.shift(), E.shift()), m = E.shift(), y = E.shift(), R.push(m, y);
            break;
          case "c":
            R.push(m + E.shift(), y + E.shift(), m + E.shift(), y + E.shift()), m += E.shift(), y += E.shift(), I = "C", R.push(m, y);
            break;
          case "S":
            K = m, q = y, H = c[c.length - 1], H.command === "C" && (K = m + (m - H.points[2]), q = y + (y - H.points[3])), R.push(K, q, E.shift(), E.shift()), m = E.shift(), y = E.shift(), I = "C", R.push(m, y);
            break;
          case "s":
            K = m, q = y, H = c[c.length - 1], H.command === "C" && (K = m + (m - H.points[2]), q = y + (y - H.points[3])), R.push(K, q, m + E.shift(), y + E.shift()), m += E.shift(), y += E.shift(), I = "C", R.push(m, y);
            break;
          case "Q":
            R.push(E.shift(), E.shift()), m = E.shift(), y = E.shift(), R.push(m, y);
            break;
          case "q":
            R.push(m + E.shift(), y + E.shift()), m += E.shift(), y += E.shift(), I = "Q", R.push(m, y);
            break;
          case "T":
            K = m, q = y, H = c[c.length - 1], H.command === "Q" && (K = m + (m - H.points[0]), q = y + (y - H.points[1])), m = E.shift(), y = E.shift(), I = "Q", R.push(K, q, m, y);
            break;
          case "t":
            K = m, q = y, H = c[c.length - 1], H.command === "Q" && (K = m + (m - H.points[0]), q = y + (y - H.points[1])), m += E.shift(), y += E.shift(), I = "Q", R.push(K, q, m, y);
            break;
          case "A":
            Q = E.shift(), Z = E.shift(), X = E.shift(), se = E.shift(), te = E.shift(), fe = m, ce = y, m = E.shift(), y = E.shift(), I = "A", R = this.convertEndpointToCenterParameterization(fe, ce, m, y, se, te, Q, Z, X);
            break;
          case "a":
            Q = E.shift(), Z = E.shift(), X = E.shift(), se = E.shift(), te = E.shift(), fe = m, ce = y, m += E.shift(), y += E.shift(), I = "A", R = this.convertEndpointToCenterParameterization(fe, ce, m, y, se, te, Q, Z, X);
            break;
        }
        c.push({
          command: I || j,
          points: R,
          start: {
            x: U,
            y: z
          },
          pathLength: this.calcLength(U, z, I || j, R)
        });
      }
      (j === "z" || j === "Z") && c.push({
        command: "z",
        points: [],
        start: void 0,
        pathLength: 0
      });
    }
    return c;
  }
  static calcLength(t, n, r, s) {
    var o, c, u, m, y = uu;
    switch (r) {
      case "L":
        return y.getLineLength(t, n, s[0], s[1]);
      case "C":
        return (0, h8.getCubicArcLength)([t, s[0], s[2], s[4]], [n, s[1], s[3], s[5]], 1);
      case "Q":
        return (0, h8.getQuadraticArcLength)([t, s[0], s[2]], [n, s[1], s[3]], 1);
      case "A":
        o = 0;
        var b = s[4], w = s[5], k = s[4] + w, j = Math.PI / 180;
        if (Math.abs(b - k) < j && (j = Math.abs(b - k)), c = y.getPointOnEllipticalArc(s[0], s[1], s[2], s[3], b, 0), w < 0)
          for (m = b - j; m > k; m -= j)
            u = y.getPointOnEllipticalArc(s[0], s[1], s[2], s[3], m, 0), o += y.getLineLength(c.x, c.y, u.x, u.y), c = u;
        else
          for (m = b + j; m < k; m += j)
            u = y.getPointOnEllipticalArc(s[0], s[1], s[2], s[3], m, 0), o += y.getLineLength(c.x, c.y, u.x, u.y), c = u;
        return u = y.getPointOnEllipticalArc(s[0], s[1], s[2], s[3], k, 0), o += y.getLineLength(c.x, c.y, u.x, u.y), o;
    }
    return 0;
  }
  static convertEndpointToCenterParameterization(t, n, r, s, o, c, u, m, y) {
    var b = y * (Math.PI / 180), w = Math.cos(b) * (t - r) / 2 + Math.sin(b) * (n - s) / 2, k = -1 * Math.sin(b) * (t - r) / 2 + Math.cos(b) * (n - s) / 2, j = w * w / (u * u) + k * k / (m * m);
    j > 1 && (u *= Math.sqrt(j), m *= Math.sqrt(j));
    var E = Math.sqrt((u * u * (m * m) - u * u * (k * k) - m * m * (w * w)) / (u * u * (k * k) + m * m * (w * w)));
    o === c && (E *= -1), isNaN(E) && (E = 0);
    var T = E * u * k / m, D = E * -m * w / u, L = (t + r) / 2 + Math.cos(b) * T - Math.sin(b) * D, I = (n + s) / 2 + Math.sin(b) * T + Math.cos(b) * D, R = function(Z) {
      return Math.sqrt(Z[0] * Z[0] + Z[1] * Z[1]);
    }, U = function(Z, X) {
      return (Z[0] * X[0] + Z[1] * X[1]) / (R(Z) * R(X));
    }, z = function(Z, X) {
      return (Z[0] * X[1] < Z[1] * X[0] ? -1 : 1) * Math.acos(U(Z, X));
    }, H = z([1, 0], [(w - T) / u, (k - D) / m]), K = [(w - T) / u, (k - D) / m], q = [(-1 * w - T) / u, (-1 * k - D) / m], Q = z(K, q);
    return U(K, q) <= -1 && (Q = Math.PI), U(K, q) >= 1 && (Q = 0), c === 0 && Q > 0 && (Q = Q - 2 * Math.PI), c === 1 && Q < 0 && (Q = Q + 2 * Math.PI), [L, I, u, m, H, Q, b, c];
  }
}
jw.Path = uu;
uu.prototype.className = "Path";
uu.prototype._attrsAffectingSize = ["data"];
(0, _2e._registerNode)(uu);
E2e.Factory.addGetterSetter(uu, "data");
Object.defineProperty(Ck, "__esModule", { value: !0 });
Ck.Arrow = void 0;
const jk = Sa, T2e = C6, TY = Jn, M2e = ha, iB = jw;
class v5 extends T2e.Line {
  _sceneFunc(t) {
    super._sceneFunc(t);
    var n = Math.PI * 2, r = this.points(), s = r, o = this.tension() !== 0 && r.length > 4;
    o && (s = this.getTensionPoints());
    var c = this.pointerLength(), u = r.length, m, y;
    if (o) {
      const k = [
        s[s.length - 4],
        s[s.length - 3],
        s[s.length - 2],
        s[s.length - 1],
        r[u - 2],
        r[u - 1]
      ], j = iB.Path.calcLength(s[s.length - 4], s[s.length - 3], "C", k), E = iB.Path.getPointOnQuadraticBezier(Math.min(1, 1 - c / j), k[0], k[1], k[2], k[3], k[4], k[5]);
      m = r[u - 2] - E.x, y = r[u - 1] - E.y;
    } else
      m = r[u - 2] - r[u - 4], y = r[u - 1] - r[u - 3];
    var b = (Math.atan2(y, m) + n) % n, w = this.pointerWidth();
    this.pointerAtEnding() && (t.save(), t.beginPath(), t.translate(r[u - 2], r[u - 1]), t.rotate(b), t.moveTo(0, 0), t.lineTo(-c, w / 2), t.lineTo(-c, -w / 2), t.closePath(), t.restore(), this.__fillStroke(t)), this.pointerAtBeginning() && (t.save(), t.beginPath(), t.translate(r[0], r[1]), o ? (m = (s[0] + s[2]) / 2 - r[0], y = (s[1] + s[3]) / 2 - r[1]) : (m = r[2] - r[0], y = r[3] - r[1]), t.rotate((Math.atan2(-y, -m) + n) % n), t.moveTo(0, 0), t.lineTo(-c, w / 2), t.lineTo(-c, -w / 2), t.closePath(), t.restore(), this.__fillStroke(t));
  }
  __fillStroke(t) {
    var n = this.dashEnabled();
    n && (this.attrs.dashEnabled = !1, t.setLineDash([])), t.fillStrokeShape(this), n && (this.attrs.dashEnabled = !0);
  }
  getSelfRect() {
    const t = super.getSelfRect(), n = this.pointerWidth() / 2;
    return {
      x: t.x - n,
      y: t.y - n,
      width: t.width + n * 2,
      height: t.height + n * 2
    };
  }
}
Ck.Arrow = v5;
v5.prototype.className = "Arrow";
(0, M2e._registerNode)(v5);
jk.Factory.addGetterSetter(v5, "pointerLength", 10, (0, TY.getNumberValidator)());
jk.Factory.addGetterSetter(v5, "pointerWidth", 10, (0, TY.getNumberValidator)());
jk.Factory.addGetterSetter(v5, "pointerAtBeginning", !1);
jk.Factory.addGetterSetter(v5, "pointerAtEnding", !0);
var Ek = {};
Object.defineProperty(Ek, "__esModule", { value: !0 });
Ek.Circle = void 0;
const R2e = Sa, D2e = yu, P2e = Jn, O2e = ha;
class Ew extends D2e.Shape {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius() !== t / 2 && this.radius(t / 2);
  }
  setHeight(t) {
    this.radius() !== t / 2 && this.radius(t / 2);
  }
}
Ek.Circle = Ew;
Ew.prototype._centroid = !0;
Ew.prototype.className = "Circle";
Ew.prototype._attrsAffectingSize = ["radius"];
(0, O2e._registerNode)(Ew);
R2e.Factory.addGetterSetter(Ew, "radius", 0, (0, P2e.getNumberValidator)());
var kk = {};
Object.defineProperty(kk, "__esModule", { value: !0 });
kk.Ellipse = void 0;
const CA = Sa, A2e = yu, MY = Jn, L2e = ha;
class tb extends A2e.Shape {
  _sceneFunc(t) {
    var n = this.radiusX(), r = this.radiusY();
    t.beginPath(), t.save(), n !== r && t.scale(1, r / n), t.arc(0, 0, n, 0, Math.PI * 2, !1), t.restore(), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radiusX() * 2;
  }
  getHeight() {
    return this.radiusY() * 2;
  }
  setWidth(t) {
    this.radiusX(t / 2);
  }
  setHeight(t) {
    this.radiusY(t / 2);
  }
}
kk.Ellipse = tb;
tb.prototype.className = "Ellipse";
tb.prototype._centroid = !0;
tb.prototype._attrsAffectingSize = ["radiusX", "radiusY"];
(0, L2e._registerNode)(tb);
CA.Factory.addComponentsGetterSetter(tb, "radius", ["x", "y"]);
CA.Factory.addGetterSetter(tb, "radiusX", 0, (0, MY.getNumberValidator)());
CA.Factory.addGetterSetter(tb, "radiusY", 0, (0, MY.getNumberValidator)());
var _k = {};
Object.defineProperty(_k, "__esModule", { value: !0 });
_k.Image = void 0;
const xR = cl, x5 = Sa, I2e = yu, F2e = ha, N6 = Jn;
let _y = class RY extends I2e.Shape {
  constructor(t) {
    super(t), this.on("imageChange.konva", () => {
      this._setImageLoad();
    }), this._setImageLoad();
  }
  _setImageLoad() {
    const t = this.image();
    t && t.complete || t && t.readyState === 4 || t && t.addEventListener && t.addEventListener("load", () => {
      this._requestDraw();
    });
  }
  _useBufferCanvas() {
    const t = !!this.cornerRadius(), n = this.hasShadow();
    return t && n ? !0 : super._useBufferCanvas(!0);
  }
  _sceneFunc(t) {
    const n = this.getWidth(), r = this.getHeight(), s = this.cornerRadius(), o = this.attrs.image;
    let c;
    if (o) {
      const u = this.attrs.cropWidth, m = this.attrs.cropHeight;
      u && m ? c = [
        o,
        this.cropX(),
        this.cropY(),
        u,
        m,
        0,
        0,
        n,
        r
      ] : c = [o, 0, 0, n, r];
    }
    (this.hasFill() || this.hasStroke() || s) && (t.beginPath(), s ? xR.Util.drawRoundedRectPath(t, n, r, s) : t.rect(0, 0, n, r), t.closePath(), t.fillStrokeShape(this)), o && (s && t.clip(), t.drawImage.apply(t, c));
  }
  _hitFunc(t) {
    var n = this.width(), r = this.height(), s = this.cornerRadius();
    t.beginPath(), s ? xR.Util.drawRoundedRectPath(t, n, r, s) : t.rect(0, 0, n, r), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    var t, n;
    return (t = this.attrs.width) !== null && t !== void 0 ? t : (n = this.image()) === null || n === void 0 ? void 0 : n.width;
  }
  getHeight() {
    var t, n;
    return (t = this.attrs.height) !== null && t !== void 0 ? t : (n = this.image()) === null || n === void 0 ? void 0 : n.height;
  }
  static fromURL(t, n, r = null) {
    var s = xR.Util.createImageElement();
    s.onload = function() {
      var o = new RY({
        image: s
      });
      n(o);
    }, s.onerror = r, s.crossOrigin = "Anonymous", s.src = t;
  }
};
_k.Image = _y;
_y.prototype.className = "Image";
(0, F2e._registerNode)(_y);
x5.Factory.addGetterSetter(_y, "cornerRadius", 0, (0, N6.getNumberOrArrayOfNumbersValidator)(4));
x5.Factory.addGetterSetter(_y, "image");
x5.Factory.addComponentsGetterSetter(_y, "crop", ["x", "y", "width", "height"]);
x5.Factory.addGetterSetter(_y, "cropX", 0, (0, N6.getNumberValidator)());
x5.Factory.addGetterSetter(_y, "cropY", 0, (0, N6.getNumberValidator)());
x5.Factory.addGetterSetter(_y, "cropWidth", 0, (0, N6.getNumberValidator)());
x5.Factory.addGetterSetter(_y, "cropHeight", 0, (0, N6.getNumberValidator)());
var J8 = {};
Object.defineProperty(J8, "__esModule", { value: !0 });
J8.Tag = J8.Label = void 0;
const Tk = Sa, U2e = yu, z2e = Cw, NA = Jn, DY = ha;
var PY = [
  "fontFamily",
  "fontSize",
  "fontStyle",
  "padding",
  "lineHeight",
  "text",
  "width",
  "height",
  "pointerDirection",
  "pointerWidth",
  "pointerHeight"
], B2e = "Change.konva", H2e = "none", JD = "up", eP = "right", tP = "down", nP = "left", V2e = PY.length;
class jA extends z2e.Group {
  constructor(t) {
    super(t), this.on("add.konva", function(n) {
      this._addListeners(n.child), this._sync();
    });
  }
  getText() {
    return this.find("Text")[0];
  }
  getTag() {
    return this.find("Tag")[0];
  }
  _addListeners(t) {
    var n = this, r, s = function() {
      n._sync();
    };
    for (r = 0; r < V2e; r++)
      t.on(PY[r] + B2e, s);
  }
  getWidth() {
    return this.getText().width();
  }
  getHeight() {
    return this.getText().height();
  }
  _sync() {
    var t = this.getText(), n = this.getTag(), r, s, o, c, u, m, y;
    if (t && n) {
      switch (r = t.width(), s = t.height(), o = n.pointerDirection(), c = n.pointerWidth(), y = n.pointerHeight(), u = 0, m = 0, o) {
        case JD:
          u = r / 2, m = -1 * y;
          break;
        case eP:
          u = r + c, m = s / 2;
          break;
        case tP:
          u = r / 2, m = s + y;
          break;
        case nP:
          u = -1 * c, m = s / 2;
          break;
      }
      n.setAttrs({
        x: -1 * u,
        y: -1 * m,
        width: r,
        height: s
      }), t.setAttrs({
        x: -1 * u,
        y: -1 * m
      });
    }
  }
}
J8.Label = jA;
jA.prototype.className = "Label";
(0, DY._registerNode)(jA);
class b5 extends U2e.Shape {
  _sceneFunc(t) {
    var n = this.width(), r = this.height(), s = this.pointerDirection(), o = this.pointerWidth(), c = this.pointerHeight(), u = this.cornerRadius();
    let m = 0, y = 0, b = 0, w = 0;
    typeof u == "number" ? m = y = b = w = Math.min(u, n / 2, r / 2) : (m = Math.min(u[0] || 0, n / 2, r / 2), y = Math.min(u[1] || 0, n / 2, r / 2), w = Math.min(u[2] || 0, n / 2, r / 2), b = Math.min(u[3] || 0, n / 2, r / 2)), t.beginPath(), t.moveTo(m, 0), s === JD && (t.lineTo((n - o) / 2, 0), t.lineTo(n / 2, -1 * c), t.lineTo((n + o) / 2, 0)), t.lineTo(n - y, 0), t.arc(n - y, y, y, Math.PI * 3 / 2, 0, !1), s === eP && (t.lineTo(n, (r - c) / 2), t.lineTo(n + o, r / 2), t.lineTo(n, (r + c) / 2)), t.lineTo(n, r - w), t.arc(n - w, r - w, w, 0, Math.PI / 2, !1), s === tP && (t.lineTo((n + o) / 2, r), t.lineTo(n / 2, r + c), t.lineTo((n - o) / 2, r)), t.lineTo(b, r), t.arc(b, r - b, b, Math.PI / 2, Math.PI, !1), s === nP && (t.lineTo(0, (r + c) / 2), t.lineTo(-1 * o, r / 2), t.lineTo(0, (r - c) / 2)), t.lineTo(0, m), t.arc(m, m, m, Math.PI, Math.PI * 3 / 2, !1), t.closePath(), t.fillStrokeShape(this);
  }
  getSelfRect() {
    var t = 0, n = 0, r = this.pointerWidth(), s = this.pointerHeight(), o = this.pointerDirection(), c = this.width(), u = this.height();
    return o === JD ? (n -= s, u += s) : o === tP ? u += s : o === nP ? (t -= r * 1.5, c += r) : o === eP && (c += r * 1.5), {
      x: t,
      y: n,
      width: c,
      height: u
    };
  }
}
J8.Tag = b5;
b5.prototype.className = "Tag";
(0, DY._registerNode)(b5);
Tk.Factory.addGetterSetter(b5, "pointerDirection", H2e);
Tk.Factory.addGetterSetter(b5, "pointerWidth", 0, (0, NA.getNumberValidator)());
Tk.Factory.addGetterSetter(b5, "pointerHeight", 0, (0, NA.getNumberValidator)());
Tk.Factory.addGetterSetter(b5, "cornerRadius", 0, (0, NA.getNumberOrArrayOfNumbersValidator)(4));
var j6 = {};
Object.defineProperty(j6, "__esModule", { value: !0 });
j6.Rect = void 0;
const $2e = Sa, G2e = yu, W2e = ha, Y2e = cl, q2e = Jn;
let Mk = class extends G2e.Shape {
  _sceneFunc(t) {
    var n = this.cornerRadius(), r = this.width(), s = this.height();
    t.beginPath(), n ? Y2e.Util.drawRoundedRectPath(t, r, s, n) : t.rect(0, 0, r, s), t.closePath(), t.fillStrokeShape(this);
  }
};
j6.Rect = Mk;
Mk.prototype.className = "Rect";
(0, W2e._registerNode)(Mk);
$2e.Factory.addGetterSetter(Mk, "cornerRadius", 0, (0, q2e.getNumberOrArrayOfNumbersValidator)(4));
var Rk = {};
Object.defineProperty(Rk, "__esModule", { value: !0 });
Rk.RegularPolygon = void 0;
const OY = Sa, K2e = yu, AY = Jn, X2e = ha;
class S5 extends K2e.Shape {
  _sceneFunc(t) {
    const n = this._getPoints();
    t.beginPath(), t.moveTo(n[0].x, n[0].y);
    for (var r = 1; r < n.length; r++)
      t.lineTo(n[r].x, n[r].y);
    t.closePath(), t.fillStrokeShape(this);
  }
  _getPoints() {
    const t = this.attrs.sides, n = this.attrs.radius || 0, r = [];
    for (var s = 0; s < t; s++)
      r.push({
        x: n * Math.sin(s * 2 * Math.PI / t),
        y: -1 * n * Math.cos(s * 2 * Math.PI / t)
      });
    return r;
  }
  getSelfRect() {
    const t = this._getPoints();
    var n = t[0].x, r = t[0].y, s = t[0].x, o = t[0].y;
    return t.forEach((c) => {
      n = Math.min(n, c.x), r = Math.max(r, c.x), s = Math.min(s, c.y), o = Math.max(o, c.y);
    }), {
      x: n,
      y: s,
      width: r - n,
      height: o - s
    };
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius(t / 2);
  }
  setHeight(t) {
    this.radius(t / 2);
  }
}
Rk.RegularPolygon = S5;
S5.prototype.className = "RegularPolygon";
S5.prototype._centroid = !0;
S5.prototype._attrsAffectingSize = ["radius"];
(0, X2e._registerNode)(S5);
OY.Factory.addGetterSetter(S5, "radius", 0, (0, AY.getNumberValidator)());
OY.Factory.addGetterSetter(S5, "sides", 0, (0, AY.getNumberValidator)());
var Dk = {};
Object.defineProperty(Dk, "__esModule", { value: !0 });
Dk.Ring = void 0;
const LY = Sa, Q2e = yu, IY = Jn, Z2e = ha;
var oB = Math.PI * 2;
class w5 extends Q2e.Shape {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.innerRadius(), 0, oB, !1), t.moveTo(this.outerRadius(), 0), t.arc(0, 0, this.outerRadius(), oB, 0, !0), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
}
Dk.Ring = w5;
w5.prototype.className = "Ring";
w5.prototype._centroid = !0;
w5.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
(0, Z2e._registerNode)(w5);
LY.Factory.addGetterSetter(w5, "innerRadius", 0, (0, IY.getNumberValidator)());
LY.Factory.addGetterSetter(w5, "outerRadius", 0, (0, IY.getNumberValidator)());
var Pk = {};
Object.defineProperty(Pk, "__esModule", { value: !0 });
Pk.Sprite = void 0;
const C5 = Sa, J2e = yu, ebe = Nw, FY = Jn, tbe = ha;
class Ty extends J2e.Shape {
  constructor(t) {
    super(t), this._updated = !0, this.anim = new ebe.Animation(() => {
      var n = this._updated;
      return this._updated = !1, n;
    }), this.on("animationChange.konva", function() {
      this.frameIndex(0);
    }), this.on("frameIndexChange.konva", function() {
      this._updated = !0;
    }), this.on("frameRateChange.konva", function() {
      this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
    });
  }
  _sceneFunc(t) {
    var n = this.animation(), r = this.frameIndex(), s = r * 4, o = this.animations()[n], c = this.frameOffsets(), u = o[s + 0], m = o[s + 1], y = o[s + 2], b = o[s + 3], w = this.image();
    if ((this.hasFill() || this.hasStroke()) && (t.beginPath(), t.rect(0, 0, y, b), t.closePath(), t.fillStrokeShape(this)), w)
      if (c) {
        var k = c[n], j = r * 2;
        t.drawImage(w, u, m, y, b, k[j + 0], k[j + 1], y, b);
      } else
        t.drawImage(w, u, m, y, b, 0, 0, y, b);
  }
  _hitFunc(t) {
    var n = this.animation(), r = this.frameIndex(), s = r * 4, o = this.animations()[n], c = this.frameOffsets(), u = o[s + 2], m = o[s + 3];
    if (t.beginPath(), c) {
      var y = c[n], b = r * 2;
      t.rect(y[b + 0], y[b + 1], u, m);
    } else
      t.rect(0, 0, u, m);
    t.closePath(), t.fillShape(this);
  }
  _useBufferCanvas() {
    return super._useBufferCanvas(!0);
  }
  _setInterval() {
    var t = this;
    this.interval = setInterval(function() {
      t._updateIndex();
    }, 1e3 / this.frameRate());
  }
  start() {
    if (!this.isRunning()) {
      var t = this.getLayer();
      this.anim.setLayers(t), this._setInterval(), this.anim.start();
    }
  }
  stop() {
    this.anim.stop(), clearInterval(this.interval);
  }
  isRunning() {
    return this.anim.isRunning();
  }
  _updateIndex() {
    var t = this.frameIndex(), n = this.animation(), r = this.animations(), s = r[n], o = s.length / 4;
    t < o - 1 ? this.frameIndex(t + 1) : this.frameIndex(0);
  }
}
Pk.Sprite = Ty;
Ty.prototype.className = "Sprite";
(0, tbe._registerNode)(Ty);
C5.Factory.addGetterSetter(Ty, "animation");
C5.Factory.addGetterSetter(Ty, "animations");
C5.Factory.addGetterSetter(Ty, "frameOffsets");
C5.Factory.addGetterSetter(Ty, "image");
C5.Factory.addGetterSetter(Ty, "frameIndex", 0, (0, FY.getNumberValidator)());
C5.Factory.addGetterSetter(Ty, "frameRate", 17, (0, FY.getNumberValidator)());
C5.Factory.backCompat(Ty, {
  index: "frameIndex",
  getIndex: "getFrameIndex",
  setIndex: "setFrameIndex"
});
var Ok = {};
Object.defineProperty(Ok, "__esModule", { value: !0 });
Ok.Star = void 0;
const EA = Sa, nbe = yu, kA = Jn, rbe = ha;
class nb extends nbe.Shape {
  _sceneFunc(t) {
    var n = this.innerRadius(), r = this.outerRadius(), s = this.numPoints();
    t.beginPath(), t.moveTo(0, 0 - r);
    for (var o = 1; o < s * 2; o++) {
      var c = o % 2 === 0 ? r : n, u = c * Math.sin(o * Math.PI / s), m = -1 * c * Math.cos(o * Math.PI / s);
      t.lineTo(u, m);
    }
    t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
}
Ok.Star = nb;
nb.prototype.className = "Star";
nb.prototype._centroid = !0;
nb.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
(0, rbe._registerNode)(nb);
EA.Factory.addGetterSetter(nb, "numPoints", 5, (0, kA.getNumberValidator)());
EA.Factory.addGetterSetter(nb, "innerRadius", 0, (0, kA.getNumberValidator)());
EA.Factory.addGetterSetter(nb, "outerRadius", 0, (0, kA.getNumberValidator)());
var e5 = {};
Object.defineProperty(e5, "__esModule", { value: !0 });
e5.Text = e5.stringToArray = void 0;
const rP = cl, Mf = Sa, abe = yu, bR = ha, rb = Jn, sbe = ha;
function UY(e) {
  return [...e].reduce((t, n, r, s) => (new RegExp("\\p{Emoji_Modifier_Base}\\p{Emoji_Modifier}?(?:\\u200D\\p{Emoji_Presentation})+", "u").test(n) ? t.push(n) : new RegExp("\\p{Regional_Indicator}{2}", "u").test(n + (s[r + 1] || "")) ? t.push(n + s[r + 1]) : r > 0 && new RegExp("\\p{Mn}|\\p{Me}|\\p{Mc}", "u").test(n) ? t[t.length - 1] += n : t.push(n), t), []);
}
e5.stringToArray = UY;
var p8 = "auto", ibe = "center", zY = "inherit", F7 = "justify", obe = "Change.konva", lbe = "2d", lB = "-", BY = "left", cbe = "text", ube = "Text", dbe = "top", fbe = "bottom", cB = "middle", HY = "normal", mbe = "px ", Aj = " ", hbe = "right", uB = "rtl", pbe = "word", gbe = "char", dB = "none", SR = "…", VY = [
  "direction",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontVariant",
  "padding",
  "align",
  "verticalAlign",
  "lineHeight",
  "text",
  "width",
  "height",
  "wrap",
  "ellipsis",
  "letterSpacing"
], ybe = VY.length;
function vbe(e) {
  return e.split(",").map((t) => {
    t = t.trim();
    const n = t.indexOf(" ") >= 0, r = t.indexOf('"') >= 0 || t.indexOf("'") >= 0;
    return n && !r && (t = `"${t}"`), t;
  }).join(", ");
}
var Lj;
function wR() {
  return Lj || (Lj = rP.Util.createCanvasElement().getContext(lbe), Lj);
}
function xbe(e) {
  e.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function bbe(e) {
  e.setAttr("miterLimit", 2), e.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function Sbe(e) {
  return e = e || {}, !e.fillLinearGradientColorStops && !e.fillRadialGradientColorStops && !e.fillPatternImage && (e.fill = e.fill || "black"), e;
}
let Ll = class extends abe.Shape {
  constructor(t) {
    super(Sbe(t)), this._partialTextX = 0, this._partialTextY = 0;
    for (var n = 0; n < ybe; n++)
      this.on(VY[n] + obe, this._setTextData);
    this._setTextData();
  }
  _sceneFunc(t) {
    var n = this.textArr, r = n.length;
    if (this.text()) {
      var s = this.padding(), o = this.fontSize(), c = this.lineHeight() * o, u = this.verticalAlign(), m = this.direction(), y = 0, b = this.align(), w = this.getWidth(), k = this.letterSpacing(), j = this.fill(), E = this.textDecoration(), T = E.indexOf("underline") !== -1, D = E.indexOf("line-through") !== -1, L;
      m = m === zY ? t.direction : m;
      var I = c / 2, R = cB;
      if (bR.Konva._fixTextRendering) {
        var U = this.measureSize("M");
        R = "alphabetic", I = (U.fontBoundingBoxAscent - U.fontBoundingBoxDescent) / 2 + c / 2;
      }
      var z = 0, H = 0;
      for (m === uB && t.setAttr("direction", m), t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", R), t.setAttr("textAlign", BY), u === cB ? y = (this.getHeight() - r * c - s * 2) / 2 : u === fbe && (y = this.getHeight() - r * c - s * 2), t.translate(s, y + s), L = 0; L < r; L++) {
        var z = 0, H = 0, K = n[L], q = K.text, Q = K.width, Z = K.lastInParagraph, X, se, te;
        if (t.save(), b === hbe ? z += w - Q - s * 2 : b === ibe && (z += (w - Q - s * 2) / 2), T) {
          t.save(), t.beginPath();
          let ue = bR.Konva._fixTextRendering ? Math.round(o / 4) : Math.round(o / 2);
          const he = z, ve = I + H + ue;
          t.moveTo(he, ve), X = q.split(" ").length - 1, se = X === 0, te = b === F7 && !Z ? w - s * 2 : Q, t.lineTo(he + Math.round(te), ve), t.lineWidth = o / 15;
          const Te = this._getLinearGradient();
          t.strokeStyle = Te || j, t.stroke(), t.restore();
        }
        if (D) {
          t.save(), t.beginPath();
          let ue = bR.Konva._fixTextRendering ? -Math.round(o / 4) : 0;
          t.moveTo(z, I + H + ue), X = q.split(" ").length - 1, se = X === 0, te = b === F7 && Z && !se ? w - s * 2 : Q, t.lineTo(z + Math.round(te), I + H + ue), t.lineWidth = o / 15;
          const he = this._getLinearGradient();
          t.strokeStyle = he || j, t.stroke(), t.restore();
        }
        if (m !== uB && (k !== 0 || b === F7)) {
          X = q.split(" ").length - 1;
          for (var fe = UY(q), ce = 0; ce < fe.length; ce++) {
            var pe = fe[ce];
            pe === " " && !Z && b === F7 && (z += (w - s * 2 - Q) / X), this._partialTextX = z, this._partialTextY = I + H, this._partialText = pe, t.fillStrokeShape(this), z += this.measureSize(pe).width + k;
          }
        } else
          k !== 0 && t.setAttr("letterSpacing", `${k}px`), this._partialTextX = z, this._partialTextY = I + H, this._partialText = q, t.fillStrokeShape(this);
        t.restore(), r > 1 && (I += c);
      }
    }
  }
  _hitFunc(t) {
    var n = this.getWidth(), r = this.getHeight();
    t.beginPath(), t.rect(0, 0, n, r), t.closePath(), t.fillStrokeShape(this);
  }
  setText(t) {
    var n = rP.Util._isString(t) ? t : t == null ? "" : t + "";
    return this._setAttr(cbe, n), this;
  }
  getWidth() {
    var t = this.attrs.width === p8 || this.attrs.width === void 0;
    return t ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
  }
  getHeight() {
    var t = this.attrs.height === p8 || this.attrs.height === void 0;
    return t ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
  }
  getTextWidth() {
    return this.textWidth;
  }
  getTextHeight() {
    return rP.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
  }
  measureSize(t) {
    var n, r, s, o, c, u, m, y, b, w, k, j = wR(), E = this.fontSize(), T;
    j.save(), j.font = this._getContextFont(), T = j.measureText(t), j.restore();
    const D = E / 100;
    return {
      actualBoundingBoxAscent: (n = T.actualBoundingBoxAscent) !== null && n !== void 0 ? n : 71.58203125 * D,
      actualBoundingBoxDescent: (r = T.actualBoundingBoxDescent) !== null && r !== void 0 ? r : 0,
      actualBoundingBoxLeft: (s = T.actualBoundingBoxLeft) !== null && s !== void 0 ? s : -7.421875 * D,
      actualBoundingBoxRight: (o = T.actualBoundingBoxRight) !== null && o !== void 0 ? o : 75.732421875 * D,
      alphabeticBaseline: (c = T.alphabeticBaseline) !== null && c !== void 0 ? c : 0,
      emHeightAscent: (u = T.emHeightAscent) !== null && u !== void 0 ? u : 100 * D,
      emHeightDescent: (m = T.emHeightDescent) !== null && m !== void 0 ? m : -20 * D,
      fontBoundingBoxAscent: (y = T.fontBoundingBoxAscent) !== null && y !== void 0 ? y : 91 * D,
      fontBoundingBoxDescent: (b = T.fontBoundingBoxDescent) !== null && b !== void 0 ? b : 21 * D,
      hangingBaseline: (w = T.hangingBaseline) !== null && w !== void 0 ? w : 72.80000305175781 * D,
      ideographicBaseline: (k = T.ideographicBaseline) !== null && k !== void 0 ? k : -21 * D,
      width: T.width,
      height: E
    };
  }
  _getContextFont() {
    return this.fontStyle() + Aj + this.fontVariant() + Aj + (this.fontSize() + mbe) + vbe(this.fontFamily());
  }
  _addTextLine(t) {
    this.align() === F7 && (t = t.trim());
    var r = this._getTextWidth(t);
    return this.textArr.push({
      text: t,
      width: r,
      lastInParagraph: !1
    });
  }
  _getTextWidth(t) {
    var n = this.letterSpacing(), r = t.length;
    return wR().measureText(t).width + (r ? n * (r - 1) : 0);
  }
  _setTextData() {
    var t = this.text().split(`
`), n = +this.fontSize(), r = 0, s = this.lineHeight() * n, o = this.attrs.width, c = this.attrs.height, u = o !== p8 && o !== void 0, m = c !== p8 && c !== void 0, y = this.padding(), b = o - y * 2, w = c - y * 2, k = 0, j = this.wrap(), E = j !== dB, T = j !== gbe && E, D = this.ellipsis();
    this.textArr = [], wR().font = this._getContextFont();
    for (var L = D ? this._getTextWidth(SR) : 0, I = 0, R = t.length; I < R; ++I) {
      var U = t[I], z = this._getTextWidth(U);
      if (u && z > b)
        for (; U.length > 0; ) {
          for (var H = 0, K = U.length, q = "", Q = 0; H < K; ) {
            var Z = H + K >>> 1, X = U.slice(0, Z + 1), se = this._getTextWidth(X) + L;
            se <= b ? (H = Z + 1, q = X, Q = se) : K = Z;
          }
          if (q) {
            if (T) {
              var te, fe = U[q.length], ce = fe === Aj || fe === lB;
              ce && Q <= b ? te = q.length : te = Math.max(q.lastIndexOf(Aj), q.lastIndexOf(lB)) + 1, te > 0 && (H = te, q = q.slice(0, H), Q = this._getTextWidth(q));
            }
            q = q.trimRight(), this._addTextLine(q), r = Math.max(r, Q), k += s;
            var pe = this._shouldHandleEllipsis(k);
            if (pe) {
              this._tryToAddEllipsisToLastLine();
              break;
            }
            if (U = U.slice(H), U = U.trimLeft(), U.length > 0 && (z = this._getTextWidth(U), z <= b)) {
              this._addTextLine(U), k += s, r = Math.max(r, z);
              break;
            }
          } else
            break;
        }
      else
        this._addTextLine(U), k += s, r = Math.max(r, z), this._shouldHandleEllipsis(k) && I < R - 1 && this._tryToAddEllipsisToLastLine();
      if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), m && k + s > w)
        break;
    }
    this.textHeight = n, this.textWidth = r;
  }
  _shouldHandleEllipsis(t) {
    var n = +this.fontSize(), r = this.lineHeight() * n, s = this.attrs.height, o = s !== p8 && s !== void 0, c = this.padding(), u = s - c * 2, m = this.wrap(), y = m !== dB;
    return !y || o && t + r > u;
  }
  _tryToAddEllipsisToLastLine() {
    var t = this.attrs.width, n = t !== p8 && t !== void 0, r = this.padding(), s = t - r * 2, o = this.ellipsis(), c = this.textArr[this.textArr.length - 1];
    if (!(!c || !o)) {
      if (n) {
        var u = this._getTextWidth(c.text + SR) < s;
        u || (c.text = c.text.slice(0, c.text.length - 3));
      }
      this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(c.text + SR);
    }
  }
  getStrokeScaleEnabled() {
    return !0;
  }
  _useBufferCanvas() {
    const t = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1, n = this.hasShadow();
    return t && n ? !0 : super._useBufferCanvas();
  }
};
e5.Text = Ll;
Ll.prototype._fillFunc = xbe;
Ll.prototype._strokeFunc = bbe;
Ll.prototype.className = ube;
Ll.prototype._attrsAffectingSize = [
  "text",
  "fontSize",
  "padding",
  "wrap",
  "lineHeight",
  "letterSpacing"
];
(0, sbe._registerNode)(Ll);
Mf.Factory.overWriteSetter(Ll, "width", (0, rb.getNumberOrAutoValidator)());
Mf.Factory.overWriteSetter(Ll, "height", (0, rb.getNumberOrAutoValidator)());
Mf.Factory.addGetterSetter(Ll, "direction", zY);
Mf.Factory.addGetterSetter(Ll, "fontFamily", "Arial");
Mf.Factory.addGetterSetter(Ll, "fontSize", 12, (0, rb.getNumberValidator)());
Mf.Factory.addGetterSetter(Ll, "fontStyle", HY);
Mf.Factory.addGetterSetter(Ll, "fontVariant", HY);
Mf.Factory.addGetterSetter(Ll, "padding", 0, (0, rb.getNumberValidator)());
Mf.Factory.addGetterSetter(Ll, "align", BY);
Mf.Factory.addGetterSetter(Ll, "verticalAlign", dbe);
Mf.Factory.addGetterSetter(Ll, "lineHeight", 1, (0, rb.getNumberValidator)());
Mf.Factory.addGetterSetter(Ll, "wrap", pbe);
Mf.Factory.addGetterSetter(Ll, "ellipsis", !1, (0, rb.getBooleanValidator)());
Mf.Factory.addGetterSetter(Ll, "letterSpacing", 0, (0, rb.getNumberValidator)());
Mf.Factory.addGetterSetter(Ll, "text", "", (0, rb.getStringValidator)());
Mf.Factory.addGetterSetter(Ll, "textDecoration", "");
var Ak = {};
Object.defineProperty(Ak, "__esModule", { value: !0 });
Ak.TextPath = void 0;
const CR = cl, e0 = Sa, wbe = yu, U7 = jw, NR = e5, $Y = Jn, Cbe = ha;
var Nbe = "", GY = "normal";
function WY(e) {
  e.fillText(this.partialText, 0, 0);
}
function YY(e) {
  e.strokeText(this.partialText, 0, 0);
}
class vu extends wbe.Shape {
  constructor(t) {
    super(t), this.dummyCanvas = CR.Util.createCanvasElement(), this.dataArray = [], this._readDataAttribute(), this.on("dataChange.konva", function() {
      this._readDataAttribute(), this._setTextData();
    }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
  }
  _getTextPathLength() {
    return U7.Path.getPathLength(this.dataArray);
  }
  _getPointAtLength(t) {
    if (!this.attrs.data)
      return null;
    const n = this.pathLength;
    return t - 1 > n ? null : U7.Path.getPointAtLengthOfDataArray(t, this.dataArray);
  }
  _readDataAttribute() {
    this.dataArray = U7.Path.parsePathData(this.attrs.data), this.pathLength = this._getTextPathLength();
  }
  _sceneFunc(t) {
    t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", this.textBaseline()), t.setAttr("textAlign", "left"), t.save();
    var n = this.textDecoration(), r = this.fill(), s = this.fontSize(), o = this.glyphInfo;
    n === "underline" && t.beginPath();
    for (var c = 0; c < o.length; c++) {
      t.save();
      var u = o[c].p0;
      t.translate(u.x, u.y), t.rotate(o[c].rotation), this.partialText = o[c].text, t.fillStrokeShape(this), n === "underline" && (c === 0 && t.moveTo(0, s / 2 + 1), t.lineTo(s, s / 2 + 1)), t.restore();
    }
    n === "underline" && (t.strokeStyle = r, t.lineWidth = s / 20, t.stroke()), t.restore();
  }
  _hitFunc(t) {
    t.beginPath();
    var n = this.glyphInfo;
    if (n.length >= 1) {
      var r = n[0].p0;
      t.moveTo(r.x, r.y);
    }
    for (var s = 0; s < n.length; s++) {
      var o = n[s].p1;
      t.lineTo(o.x, o.y);
    }
    t.setAttr("lineWidth", this.fontSize()), t.setAttr("strokeStyle", this.colorKey), t.stroke();
  }
  getTextWidth() {
    return this.textWidth;
  }
  getTextHeight() {
    return CR.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
  }
  setText(t) {
    return NR.Text.prototype.setText.call(this, t);
  }
  _getContextFont() {
    return NR.Text.prototype._getContextFont.call(this);
  }
  _getTextSize(t) {
    var n = this.dummyCanvas, r = n.getContext("2d");
    r.save(), r.font = this._getContextFont();
    var s = r.measureText(t);
    return r.restore(), {
      width: s.width,
      height: parseInt(`${this.fontSize()}`, 10)
    };
  }
  _setTextData() {
    const { width: t, height: n } = this._getTextSize(this.attrs.text);
    if (this.textWidth = t, this.textHeight = n, this.glyphInfo = [], !this.attrs.data)
      return null;
    const r = this.letterSpacing(), s = this.align(), o = this.kerningFunc(), c = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * r, 0);
    let u = 0;
    s === "center" && (u = Math.max(0, this.pathLength / 2 - c / 2)), s === "right" && (u = Math.max(0, this.pathLength - c));
    const m = (0, NR.stringToArray)(this.text());
    let y = u;
    for (var b = 0; b < m.length; b++) {
      const w = this._getPointAtLength(y);
      if (!w)
        return;
      let k = this._getTextSize(m[b]).width + r;
      if (m[b] === " " && s === "justify") {
        const I = this.text().split(" ").length - 1;
        k += (this.pathLength - c) / I;
      }
      const j = this._getPointAtLength(y + k);
      if (!j)
        return;
      const E = U7.Path.getLineLength(w.x, w.y, j.x, j.y);
      let T = 0;
      if (o)
        try {
          T = o(m[b - 1], m[b]) * this.fontSize();
        } catch {
          T = 0;
        }
      w.x += T, j.x += T, this.textWidth += T;
      const D = U7.Path.getPointOnLine(T + E / 2, w.x, w.y, j.x, j.y), L = Math.atan2(j.y - w.y, j.x - w.x);
      this.glyphInfo.push({
        transposeX: D.x,
        transposeY: D.y,
        text: m[b],
        rotation: L,
        p0: w,
        p1: j
      }), y += k;
    }
  }
  getSelfRect() {
    if (!this.glyphInfo.length)
      return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    var t = [];
    this.glyphInfo.forEach(function(b) {
      t.push(b.p0.x), t.push(b.p0.y), t.push(b.p1.x), t.push(b.p1.y);
    });
    for (var n = t[0] || 0, r = t[0] || 0, s = t[1] || 0, o = t[1] || 0, c, u, m = 0; m < t.length / 2; m++)
      c = t[m * 2], u = t[m * 2 + 1], n = Math.min(n, c), r = Math.max(r, c), s = Math.min(s, u), o = Math.max(o, u);
    var y = this.fontSize();
    return {
      x: n - y / 2,
      y: s - y / 2,
      width: r - n + y,
      height: o - s + y
    };
  }
  destroy() {
    return CR.Util.releaseCanvas(this.dummyCanvas), super.destroy();
  }
}
Ak.TextPath = vu;
vu.prototype._fillFunc = WY;
vu.prototype._strokeFunc = YY;
vu.prototype._fillFuncHit = WY;
vu.prototype._strokeFuncHit = YY;
vu.prototype.className = "TextPath";
vu.prototype._attrsAffectingSize = ["text", "fontSize", "data"];
(0, Cbe._registerNode)(vu);
e0.Factory.addGetterSetter(vu, "data");
e0.Factory.addGetterSetter(vu, "fontFamily", "Arial");
e0.Factory.addGetterSetter(vu, "fontSize", 12, (0, $Y.getNumberValidator)());
e0.Factory.addGetterSetter(vu, "fontStyle", GY);
e0.Factory.addGetterSetter(vu, "align", "left");
e0.Factory.addGetterSetter(vu, "letterSpacing", 0, (0, $Y.getNumberValidator)());
e0.Factory.addGetterSetter(vu, "textBaseline", "middle");
e0.Factory.addGetterSetter(vu, "fontVariant", GY);
e0.Factory.addGetterSetter(vu, "text", Nbe);
e0.Factory.addGetterSetter(vu, "textDecoration", null);
e0.Factory.addGetterSetter(vu, "kerningFunc", null);
var Lk = {};
Object.defineProperty(Lk, "__esModule", { value: !0 });
Lk.Transformer = void 0;
const Si = cl, Bs = Sa, fB = ko, jbe = yu, Ebe = j6, mB = Cw, Bg = ha, ab = Jn, kbe = ha;
var qY = "tr-konva", _be = [
  "resizeEnabledChange",
  "rotateAnchorOffsetChange",
  "rotateEnabledChange",
  "enabledAnchorsChange",
  "anchorSizeChange",
  "borderEnabledChange",
  "borderStrokeChange",
  "borderStrokeWidthChange",
  "borderDashChange",
  "anchorStrokeChange",
  "anchorStrokeWidthChange",
  "anchorFillChange",
  "anchorCornerRadiusChange",
  "ignoreStrokeChange",
  "anchorStyleFuncChange"
].map((e) => e + `.${qY}`).join(" "), hB = "nodesRect", Tbe = [
  "widthChange",
  "heightChange",
  "scaleXChange",
  "scaleYChange",
  "skewXChange",
  "skewYChange",
  "rotationChange",
  "offsetXChange",
  "offsetYChange",
  "transformsEnabledChange",
  "strokeWidthChange"
], Mbe = {
  "top-left": -45,
  "top-center": 0,
  "top-right": 45,
  "middle-right": -90,
  "middle-left": 90,
  "bottom-left": -135,
  "bottom-center": 180,
  "bottom-right": 135
};
const Rbe = "ontouchstart" in Bg.Konva._global;
function Dbe(e, t, n) {
  if (e === "rotater")
    return n;
  t += Si.Util.degToRad(Mbe[e] || 0);
  var r = (Si.Util.radToDeg(t) % 360 + 360) % 360;
  return Si.Util._inRange(r, 315 + 22.5, 360) || Si.Util._inRange(r, 0, 22.5) ? "ns-resize" : Si.Util._inRange(r, 45 - 22.5, 45 + 22.5) ? "nesw-resize" : Si.Util._inRange(r, 90 - 22.5, 90 + 22.5) ? "ew-resize" : Si.Util._inRange(r, 135 - 22.5, 135 + 22.5) ? "nwse-resize" : Si.Util._inRange(r, 180 - 22.5, 180 + 22.5) ? "ns-resize" : Si.Util._inRange(r, 225 - 22.5, 225 + 22.5) ? "nesw-resize" : Si.Util._inRange(r, 270 - 22.5, 270 + 22.5) ? "ew-resize" : Si.Util._inRange(r, 315 - 22.5, 315 + 22.5) ? "nwse-resize" : (Si.Util.error("Transformer has unknown angle for cursor detection: " + r), "pointer");
}
var Z9 = [
  "top-left",
  "top-center",
  "top-right",
  "middle-right",
  "middle-left",
  "bottom-left",
  "bottom-center",
  "bottom-right"
], pB = 1e8;
function Pbe(e) {
  return {
    x: e.x + e.width / 2 * Math.cos(e.rotation) + e.height / 2 * Math.sin(-e.rotation),
    y: e.y + e.height / 2 * Math.cos(e.rotation) + e.width / 2 * Math.sin(e.rotation)
  };
}
function KY(e, t, n) {
  const r = n.x + (e.x - n.x) * Math.cos(t) - (e.y - n.y) * Math.sin(t), s = n.y + (e.x - n.x) * Math.sin(t) + (e.y - n.y) * Math.cos(t);
  return {
    ...e,
    rotation: e.rotation + t,
    x: r,
    y: s
  };
}
function Obe(e, t) {
  const n = Pbe(e);
  return KY(e, t, n);
}
function Abe(e, t, n) {
  let r = t;
  for (let s = 0; s < e.length; s++) {
    const o = Bg.Konva.getAngle(e[s]), c = Math.abs(o - t) % (Math.PI * 2);
    Math.min(c, Math.PI * 2 - c) < n && (r = o);
  }
  return r;
}
let aP = 0;
class os extends mB.Group {
  constructor(t) {
    super(t), this._movingAnchorName = null, this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on(_be, this.update), this.getNode() && this.update();
  }
  attachTo(t) {
    return this.setNode(t), this;
  }
  setNode(t) {
    return Si.Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([t]);
  }
  getNode() {
    return this._nodes && this._nodes[0];
  }
  _getEventNamespace() {
    return qY + this._id;
  }
  setNodes(t = []) {
    this._nodes && this._nodes.length && this.detach();
    const n = t.filter((s) => s.isAncestorOf(this) ? (Si.Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
    this._nodes = t = n, t.length === 1 && this.useSingleNodeRotation() ? this.rotation(t[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((s) => {
      const o = () => {
        this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
      }, c = s._attrsAffectingSize.map((u) => u + "Change." + this._getEventNamespace()).join(" ");
      s.on(c, o), s.on(Tbe.map((u) => u + `.${this._getEventNamespace()}`).join(" "), o), s.on(`absoluteTransformChange.${this._getEventNamespace()}`, o), this._proxyDrag(s);
    }), this._resetTransformCache();
    var r = !!this.findOne(".top-left");
    return r && this.update(), this;
  }
  _proxyDrag(t) {
    let n;
    t.on(`dragstart.${this._getEventNamespace()}`, (r) => {
      n = t.getAbsolutePosition(), !this.isDragging() && t !== this.findOne(".back") && this.startDrag(r, !1);
    }), t.on(`dragmove.${this._getEventNamespace()}`, (r) => {
      if (!n)
        return;
      const s = t.getAbsolutePosition(), o = s.x - n.x, c = s.y - n.y;
      this.nodes().forEach((u) => {
        if (u === t || u.isDragging())
          return;
        const m = u.getAbsolutePosition();
        u.setAbsolutePosition({
          x: m.x + o,
          y: m.y + c
        }), u.startDrag(r);
      }), n = null;
    });
  }
  getNodes() {
    return this._nodes || [];
  }
  getActiveAnchor() {
    return this._movingAnchorName;
  }
  detach() {
    this._nodes && this._nodes.forEach((t) => {
      t.off("." + this._getEventNamespace());
    }), this._nodes = [], this._resetTransformCache();
  }
  _resetTransformCache() {
    this._clearCache(hB), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
  }
  _getNodeRect() {
    return this._getCache(hB, this.__getNodeRect);
  }
  __getNodeShape(t, n = this.rotation(), r) {
    var s = t.getClientRect({
      skipTransform: !0,
      skipShadow: !0,
      skipStroke: this.ignoreStroke()
    }), o = t.getAbsoluteScale(r), c = t.getAbsolutePosition(r), u = s.x * o.x - t.offsetX() * o.x, m = s.y * o.y - t.offsetY() * o.y;
    const y = (Bg.Konva.getAngle(t.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), b = {
      x: c.x + u * Math.cos(y) + m * Math.sin(-y),
      y: c.y + m * Math.cos(y) + u * Math.sin(y),
      width: s.width * o.x,
      height: s.height * o.y,
      rotation: y
    };
    return KY(b, -Bg.Konva.getAngle(n), {
      x: 0,
      y: 0
    });
  }
  __getNodeRect() {
    var t = this.getNode();
    if (!t)
      return {
        x: -pB,
        y: -pB,
        width: 0,
        height: 0,
        rotation: 0
      };
    const n = [];
    this.nodes().map((y) => {
      const b = y.getClientRect({
        skipTransform: !0,
        skipShadow: !0,
        skipStroke: this.ignoreStroke()
      });
      var w = [
        { x: b.x, y: b.y },
        { x: b.x + b.width, y: b.y },
        { x: b.x + b.width, y: b.y + b.height },
        { x: b.x, y: b.y + b.height }
      ], k = y.getAbsoluteTransform();
      w.forEach(function(j) {
        var E = k.point(j);
        n.push(E);
      });
    });
    const r = new Si.Transform();
    r.rotate(-Bg.Konva.getAngle(this.rotation()));
    var s = 1 / 0, o = 1 / 0, c = -1 / 0, u = -1 / 0;
    n.forEach(function(y) {
      var b = r.point(y);
      s === void 0 && (s = c = b.x, o = u = b.y), s = Math.min(s, b.x), o = Math.min(o, b.y), c = Math.max(c, b.x), u = Math.max(u, b.y);
    }), r.invert();
    const m = r.point({ x: s, y: o });
    return {
      x: m.x,
      y: m.y,
      width: c - s,
      height: u - o,
      rotation: Bg.Konva.getAngle(this.rotation())
    };
  }
  getX() {
    return this._getNodeRect().x;
  }
  getY() {
    return this._getNodeRect().y;
  }
  getWidth() {
    return this._getNodeRect().width;
  }
  getHeight() {
    return this._getNodeRect().height;
  }
  _createElements() {
    this._createBack(), Z9.forEach((t) => {
      this._createAnchor(t);
    }), this._createAnchor("rotater");
  }
  _createAnchor(t) {
    var n = new Ebe.Rect({
      stroke: "rgb(0, 161, 255)",
      fill: "white",
      strokeWidth: 1,
      name: t + " _anchor",
      dragDistance: 0,
      draggable: !0,
      hitStrokeWidth: Rbe ? 10 : "auto"
    }), r = this;
    n.on("mousedown touchstart", function(s) {
      r._handleMouseDown(s);
    }), n.on("dragstart", (s) => {
      n.stopDrag(), s.cancelBubble = !0;
    }), n.on("dragend", (s) => {
      s.cancelBubble = !0;
    }), n.on("mouseenter", () => {
      var s = Bg.Konva.getAngle(this.rotation()), o = this.rotateAnchorCursor(), c = Dbe(t, s, o);
      n.getStage().content && (n.getStage().content.style.cursor = c), this._cursorChange = !0;
    }), n.on("mouseout", () => {
      n.getStage().content && (n.getStage().content.style.cursor = ""), this._cursorChange = !1;
    }), this.add(n);
  }
  _createBack() {
    var t = new jbe.Shape({
      name: "back",
      width: 0,
      height: 0,
      draggable: !0,
      sceneFunc(n, r) {
        var s = r.getParent(), o = s.padding();
        n.beginPath(), n.rect(-o, -o, r.width() + o * 2, r.height() + o * 2), n.moveTo(r.width() / 2, -o), s.rotateEnabled() && s.rotateLineVisible() && n.lineTo(r.width() / 2, -s.rotateAnchorOffset() * Si.Util._sign(r.height()) - o), n.fillStrokeShape(r);
      },
      hitFunc: (n, r) => {
        if (this.shouldOverdrawWholeArea()) {
          var s = this.padding();
          n.beginPath(), n.rect(-s, -s, r.width() + s * 2, r.height() + s * 2), n.fillStrokeShape(r);
        }
      }
    });
    this.add(t), this._proxyDrag(t), t.on("dragstart", (n) => {
      n.cancelBubble = !0;
    }), t.on("dragmove", (n) => {
      n.cancelBubble = !0;
    }), t.on("dragend", (n) => {
      n.cancelBubble = !0;
    }), this.on("dragmove", (n) => {
      this.update();
    });
  }
  _handleMouseDown(t) {
    if (!this._transforming) {
      this._movingAnchorName = t.target.name().split(" ")[0];
      var n = this._getNodeRect(), r = n.width, s = n.height, o = Math.sqrt(Math.pow(r, 2) + Math.pow(s, 2));
      this.sin = Math.abs(s / o), this.cos = Math.abs(r / o), typeof window < "u" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
      var c = t.target.getAbsolutePosition(), u = t.target.getStage().getPointerPosition();
      this._anchorDragOffset = {
        x: u.x - c.x,
        y: u.y - c.y
      }, aP++, this._fire("transformstart", { evt: t.evt, target: this.getNode() }), this._nodes.forEach((m) => {
        m._fire("transformstart", { evt: t.evt, target: m });
      });
    }
  }
  _handleMouseMove(t) {
    var n, r, s, o = this.findOne("." + this._movingAnchorName), c = o.getStage();
    c.setPointersPositions(t);
    const u = c.getPointerPosition();
    let m = {
      x: u.x - this._anchorDragOffset.x,
      y: u.y - this._anchorDragOffset.y
    };
    const y = o.getAbsolutePosition();
    this.anchorDragBoundFunc() && (m = this.anchorDragBoundFunc()(y, m, t)), o.setAbsolutePosition(m);
    const b = o.getAbsolutePosition();
    if (!(y.x === b.x && y.y === b.y)) {
      if (this._movingAnchorName === "rotater") {
        var w = this._getNodeRect();
        n = o.x() - w.width / 2, r = -o.y() + w.height / 2;
        let te = Math.atan2(-r, n) + Math.PI / 2;
        w.height < 0 && (te -= Math.PI);
        var k = Bg.Konva.getAngle(this.rotation());
        const fe = k + te, ce = Bg.Konva.getAngle(this.rotationSnapTolerance()), Se = Abe(this.rotationSnaps(), fe, ce) - w.rotation, oe = Obe(w, Se);
        this._fitNodesInto(oe, t);
        return;
      }
      var j = this.shiftBehavior(), E;
      j === "inverted" ? E = this.keepRatio() && !t.shiftKey : j === "none" ? E = this.keepRatio() : E = this.keepRatio() || t.shiftKey;
      var R = this.centeredScaling() || t.altKey;
      if (this._movingAnchorName === "top-left") {
        if (E) {
          var T = R ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-right").x(),
            y: this.findOne(".bottom-right").y()
          };
          s = Math.sqrt(Math.pow(T.x - o.x(), 2) + Math.pow(T.y - o.y(), 2));
          var D = this.findOne(".top-left").x() > T.x ? -1 : 1, L = this.findOne(".top-left").y() > T.y ? -1 : 1;
          n = s * this.cos * D, r = s * this.sin * L, this.findOne(".top-left").x(T.x - n), this.findOne(".top-left").y(T.y - r);
        }
      } else if (this._movingAnchorName === "top-center")
        this.findOne(".top-left").y(o.y());
      else if (this._movingAnchorName === "top-right") {
        if (E) {
          var T = R ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-left").x(),
            y: this.findOne(".bottom-left").y()
          };
          s = Math.sqrt(Math.pow(o.x() - T.x, 2) + Math.pow(T.y - o.y(), 2));
          var D = this.findOne(".top-right").x() < T.x ? -1 : 1, L = this.findOne(".top-right").y() > T.y ? -1 : 1;
          n = s * this.cos * D, r = s * this.sin * L, this.findOne(".top-right").x(T.x + n), this.findOne(".top-right").y(T.y - r);
        }
        var I = o.position();
        this.findOne(".top-left").y(I.y), this.findOne(".bottom-right").x(I.x);
      } else if (this._movingAnchorName === "middle-left")
        this.findOne(".top-left").x(o.x());
      else if (this._movingAnchorName === "middle-right")
        this.findOne(".bottom-right").x(o.x());
      else if (this._movingAnchorName === "bottom-left") {
        if (E) {
          var T = R ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-right").x(),
            y: this.findOne(".top-right").y()
          };
          s = Math.sqrt(Math.pow(T.x - o.x(), 2) + Math.pow(o.y() - T.y, 2));
          var D = T.x < o.x() ? -1 : 1, L = o.y() < T.y ? -1 : 1;
          n = s * this.cos * D, r = s * this.sin * L, o.x(T.x - n), o.y(T.y + r);
        }
        I = o.position(), this.findOne(".top-left").x(I.x), this.findOne(".bottom-right").y(I.y);
      } else if (this._movingAnchorName === "bottom-center")
        this.findOne(".bottom-right").y(o.y());
      else if (this._movingAnchorName === "bottom-right") {
        if (E) {
          var T = R ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-left").x(),
            y: this.findOne(".top-left").y()
          };
          s = Math.sqrt(Math.pow(o.x() - T.x, 2) + Math.pow(o.y() - T.y, 2));
          var D = this.findOne(".bottom-right").x() < T.x ? -1 : 1, L = this.findOne(".bottom-right").y() < T.y ? -1 : 1;
          n = s * this.cos * D, r = s * this.sin * L, this.findOne(".bottom-right").x(T.x + n), this.findOne(".bottom-right").y(T.y + r);
        }
      } else
        console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
      var R = this.centeredScaling() || t.altKey;
      if (R) {
        var U = this.findOne(".top-left"), z = this.findOne(".bottom-right"), H = U.x(), K = U.y(), q = this.getWidth() - z.x(), Q = this.getHeight() - z.y();
        z.move({
          x: -H,
          y: -K
        }), U.move({
          x: q,
          y: Q
        });
      }
      var Z = this.findOne(".top-left").getAbsolutePosition();
      n = Z.x, r = Z.y;
      var X = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), se = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
      this._fitNodesInto({
        x: n,
        y: r,
        width: X,
        height: se,
        rotation: Bg.Konva.getAngle(this.rotation())
      }, t);
    }
  }
  _handleMouseUp(t) {
    this._removeEvents(t);
  }
  getAbsoluteTransform() {
    return this.getTransform();
  }
  _removeEvents(t) {
    var n;
    if (this._transforming) {
      this._transforming = !1, typeof window < "u" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
      var r = this.getNode();
      aP--, this._fire("transformend", { evt: t, target: r }), (n = this.getLayer()) === null || n === void 0 || n.batchDraw(), r && this._nodes.forEach((s) => {
        var o;
        s._fire("transformend", { evt: t, target: s }), (o = s.getLayer()) === null || o === void 0 || o.batchDraw();
      }), this._movingAnchorName = null;
    }
  }
  _fitNodesInto(t, n) {
    var r = this._getNodeRect();
    const s = 1;
    if (Si.Util._inRange(t.width, -this.padding() * 2 - s, s)) {
      this.update();
      return;
    }
    if (Si.Util._inRange(t.height, -this.padding() * 2 - s, s)) {
      this.update();
      return;
    }
    var o = new Si.Transform();
    if (o.rotate(Bg.Konva.getAngle(this.rotation())), this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
      const k = o.point({
        x: -this.padding() * 2,
        y: 0
      });
      t.x += k.x, t.y += k.y, t.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= k.x, this._anchorDragOffset.y -= k.y;
    } else if (this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
      const k = o.point({
        x: this.padding() * 2,
        y: 0
      });
      this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= k.x, this._anchorDragOffset.y -= k.y, t.width += this.padding() * 2;
    }
    if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
      const k = o.point({
        x: 0,
        y: -this.padding() * 2
      });
      t.x += k.x, t.y += k.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= k.x, this._anchorDragOffset.y -= k.y, t.height += this.padding() * 2;
    } else if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
      const k = o.point({
        x: 0,
        y: this.padding() * 2
      });
      this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= k.x, this._anchorDragOffset.y -= k.y, t.height += this.padding() * 2;
    }
    if (this.boundBoxFunc()) {
      const k = this.boundBoxFunc()(r, t);
      k ? t = k : Si.Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
    }
    const c = 1e7, u = new Si.Transform();
    u.translate(r.x, r.y), u.rotate(r.rotation), u.scale(r.width / c, r.height / c);
    const m = new Si.Transform(), y = t.width / c, b = t.height / c;
    this.flipEnabled() === !1 ? (m.translate(t.x, t.y), m.rotate(t.rotation), m.translate(t.width < 0 ? t.width : 0, t.height < 0 ? t.height : 0), m.scale(Math.abs(y), Math.abs(b))) : (m.translate(t.x, t.y), m.rotate(t.rotation), m.scale(y, b));
    const w = m.multiply(u.invert());
    this._nodes.forEach((k) => {
      var j;
      const E = k.getParent().getAbsoluteTransform(), T = k.getTransform().copy();
      T.translate(k.offsetX(), k.offsetY());
      const D = new Si.Transform();
      D.multiply(E.copy().invert()).multiply(w).multiply(E).multiply(T);
      const L = D.decompose();
      k.setAttrs(L), (j = k.getLayer()) === null || j === void 0 || j.batchDraw();
    }), this.rotation(Si.Util._getRotation(t.rotation)), this._nodes.forEach((k) => {
      this._fire("transform", { evt: n, target: k }), k._fire("transform", { evt: n, target: k });
    }), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
  }
  forceUpdate() {
    this._resetTransformCache(), this.update();
  }
  _batchChangeChild(t, n) {
    this.findOne(t).setAttrs(n);
  }
  update() {
    var t, n = this._getNodeRect();
    this.rotation(Si.Util._getRotation(n.rotation));
    var r = n.width, s = n.height, o = this.enabledAnchors(), c = this.resizeEnabled(), u = this.padding(), m = this.anchorSize();
    const y = this.find("._anchor");
    y.forEach((w) => {
      w.setAttrs({
        width: m,
        height: m,
        offsetX: m / 2,
        offsetY: m / 2,
        stroke: this.anchorStroke(),
        strokeWidth: this.anchorStrokeWidth(),
        fill: this.anchorFill(),
        cornerRadius: this.anchorCornerRadius()
      });
    }), this._batchChangeChild(".top-left", {
      x: 0,
      y: 0,
      offsetX: m / 2 + u,
      offsetY: m / 2 + u,
      visible: c && o.indexOf("top-left") >= 0
    }), this._batchChangeChild(".top-center", {
      x: r / 2,
      y: 0,
      offsetY: m / 2 + u,
      visible: c && o.indexOf("top-center") >= 0
    }), this._batchChangeChild(".top-right", {
      x: r,
      y: 0,
      offsetX: m / 2 - u,
      offsetY: m / 2 + u,
      visible: c && o.indexOf("top-right") >= 0
    }), this._batchChangeChild(".middle-left", {
      x: 0,
      y: s / 2,
      offsetX: m / 2 + u,
      visible: c && o.indexOf("middle-left") >= 0
    }), this._batchChangeChild(".middle-right", {
      x: r,
      y: s / 2,
      offsetX: m / 2 - u,
      visible: c && o.indexOf("middle-right") >= 0
    }), this._batchChangeChild(".bottom-left", {
      x: 0,
      y: s,
      offsetX: m / 2 + u,
      offsetY: m / 2 - u,
      visible: c && o.indexOf("bottom-left") >= 0
    }), this._batchChangeChild(".bottom-center", {
      x: r / 2,
      y: s,
      offsetY: m / 2 - u,
      visible: c && o.indexOf("bottom-center") >= 0
    }), this._batchChangeChild(".bottom-right", {
      x: r,
      y: s,
      offsetX: m / 2 - u,
      offsetY: m / 2 - u,
      visible: c && o.indexOf("bottom-right") >= 0
    }), this._batchChangeChild(".rotater", {
      x: r / 2,
      y: -this.rotateAnchorOffset() * Si.Util._sign(s) - u,
      visible: this.rotateEnabled()
    }), this._batchChangeChild(".back", {
      width: r,
      height: s,
      visible: this.borderEnabled(),
      stroke: this.borderStroke(),
      strokeWidth: this.borderStrokeWidth(),
      dash: this.borderDash(),
      x: 0,
      y: 0
    });
    const b = this.anchorStyleFunc();
    b && y.forEach((w) => {
      b(w);
    }), (t = this.getLayer()) === null || t === void 0 || t.batchDraw();
  }
  isTransforming() {
    return this._transforming;
  }
  stopTransform() {
    if (this._transforming) {
      this._removeEvents();
      var t = this.findOne("." + this._movingAnchorName);
      t && t.stopDrag();
    }
  }
  destroy() {
    return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), mB.Group.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
  }
  toObject() {
    return fB.Node.prototype.toObject.call(this);
  }
  clone(t) {
    var n = fB.Node.prototype.clone.call(this, t);
    return n;
  }
  getClientRect() {
    return this.nodes().length > 0 ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 };
  }
}
Lk.Transformer = os;
os.isTransforming = () => aP > 0;
function Lbe(e) {
  return e instanceof Array || Si.Util.warn("enabledAnchors value should be an array"), e instanceof Array && e.forEach(function(t) {
    Z9.indexOf(t) === -1 && Si.Util.warn("Unknown anchor name: " + t + ". Available names are: " + Z9.join(", "));
  }), e || [];
}
os.prototype.className = "Transformer";
(0, kbe._registerNode)(os);
Bs.Factory.addGetterSetter(os, "enabledAnchors", Z9, Lbe);
Bs.Factory.addGetterSetter(os, "flipEnabled", !0, (0, ab.getBooleanValidator)());
Bs.Factory.addGetterSetter(os, "resizeEnabled", !0);
Bs.Factory.addGetterSetter(os, "anchorSize", 10, (0, ab.getNumberValidator)());
Bs.Factory.addGetterSetter(os, "rotateEnabled", !0);
Bs.Factory.addGetterSetter(os, "rotateLineVisible", !0);
Bs.Factory.addGetterSetter(os, "rotationSnaps", []);
Bs.Factory.addGetterSetter(os, "rotateAnchorOffset", 50, (0, ab.getNumberValidator)());
Bs.Factory.addGetterSetter(os, "rotateAnchorCursor", "crosshair");
Bs.Factory.addGetterSetter(os, "rotationSnapTolerance", 5, (0, ab.getNumberValidator)());
Bs.Factory.addGetterSetter(os, "borderEnabled", !0);
Bs.Factory.addGetterSetter(os, "anchorStroke", "rgb(0, 161, 255)");
Bs.Factory.addGetterSetter(os, "anchorStrokeWidth", 1, (0, ab.getNumberValidator)());
Bs.Factory.addGetterSetter(os, "anchorFill", "white");
Bs.Factory.addGetterSetter(os, "anchorCornerRadius", 0, (0, ab.getNumberValidator)());
Bs.Factory.addGetterSetter(os, "borderStroke", "rgb(0, 161, 255)");
Bs.Factory.addGetterSetter(os, "borderStrokeWidth", 1, (0, ab.getNumberValidator)());
Bs.Factory.addGetterSetter(os, "borderDash");
Bs.Factory.addGetterSetter(os, "keepRatio", !0);
Bs.Factory.addGetterSetter(os, "shiftBehavior", "default");
Bs.Factory.addGetterSetter(os, "centeredScaling", !1);
Bs.Factory.addGetterSetter(os, "ignoreStroke", !1);
Bs.Factory.addGetterSetter(os, "padding", 0, (0, ab.getNumberValidator)());
Bs.Factory.addGetterSetter(os, "node");
Bs.Factory.addGetterSetter(os, "nodes");
Bs.Factory.addGetterSetter(os, "boundBoxFunc");
Bs.Factory.addGetterSetter(os, "anchorDragBoundFunc");
Bs.Factory.addGetterSetter(os, "anchorStyleFunc");
Bs.Factory.addGetterSetter(os, "shouldOverdrawWholeArea", !1);
Bs.Factory.addGetterSetter(os, "useSingleNodeRotation", !0);
Bs.Factory.backCompat(os, {
  lineEnabled: "borderEnabled",
  rotateHandlerOffset: "rotateAnchorOffset",
  enabledHandlers: "enabledAnchors"
});
var Ik = {};
Object.defineProperty(Ik, "__esModule", { value: !0 });
Ik.Wedge = void 0;
const Fk = Sa, Ibe = yu, Fbe = ha, XY = Jn, Ube = ha;
class tx extends Ibe.Shape {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.radius(), 0, Fbe.Konva.getAngle(this.angle()), this.clockwise()), t.lineTo(0, 0), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius(t / 2);
  }
  setHeight(t) {
    this.radius(t / 2);
  }
}
Ik.Wedge = tx;
tx.prototype.className = "Wedge";
tx.prototype._centroid = !0;
tx.prototype._attrsAffectingSize = ["radius"];
(0, Ube._registerNode)(tx);
Fk.Factory.addGetterSetter(tx, "radius", 0, (0, XY.getNumberValidator)());
Fk.Factory.addGetterSetter(tx, "angle", 0, (0, XY.getNumberValidator)());
Fk.Factory.addGetterSetter(tx, "clockwise", !1);
Fk.Factory.backCompat(tx, {
  angleDeg: "angle",
  getAngleDeg: "getAngle",
  setAngleDeg: "setAngle"
});
var Uk = {};
Object.defineProperty(Uk, "__esModule", { value: !0 });
Uk.Blur = void 0;
const gB = Sa, zbe = ko, Bbe = Jn;
function yB() {
  this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
}
var Hbe = [
  512,
  512,
  456,
  512,
  328,
  456,
  335,
  512,
  405,
  328,
  271,
  456,
  388,
  335,
  292,
  512,
  454,
  405,
  364,
  328,
  298,
  271,
  496,
  456,
  420,
  388,
  360,
  335,
  312,
  292,
  273,
  512,
  482,
  454,
  428,
  405,
  383,
  364,
  345,
  328,
  312,
  298,
  284,
  271,
  259,
  496,
  475,
  456,
  437,
  420,
  404,
  388,
  374,
  360,
  347,
  335,
  323,
  312,
  302,
  292,
  282,
  273,
  265,
  512,
  497,
  482,
  468,
  454,
  441,
  428,
  417,
  405,
  394,
  383,
  373,
  364,
  354,
  345,
  337,
  328,
  320,
  312,
  305,
  298,
  291,
  284,
  278,
  271,
  265,
  259,
  507,
  496,
  485,
  475,
  465,
  456,
  446,
  437,
  428,
  420,
  412,
  404,
  396,
  388,
  381,
  374,
  367,
  360,
  354,
  347,
  341,
  335,
  329,
  323,
  318,
  312,
  307,
  302,
  297,
  292,
  287,
  282,
  278,
  273,
  269,
  265,
  261,
  512,
  505,
  497,
  489,
  482,
  475,
  468,
  461,
  454,
  447,
  441,
  435,
  428,
  422,
  417,
  411,
  405,
  399,
  394,
  389,
  383,
  378,
  373,
  368,
  364,
  359,
  354,
  350,
  345,
  341,
  337,
  332,
  328,
  324,
  320,
  316,
  312,
  309,
  305,
  301,
  298,
  294,
  291,
  287,
  284,
  281,
  278,
  274,
  271,
  268,
  265,
  262,
  259,
  257,
  507,
  501,
  496,
  491,
  485,
  480,
  475,
  470,
  465,
  460,
  456,
  451,
  446,
  442,
  437,
  433,
  428,
  424,
  420,
  416,
  412,
  408,
  404,
  400,
  396,
  392,
  388,
  385,
  381,
  377,
  374,
  370,
  367,
  363,
  360,
  357,
  354,
  350,
  347,
  344,
  341,
  338,
  335,
  332,
  329,
  326,
  323,
  320,
  318,
  315,
  312,
  310,
  307,
  304,
  302,
  299,
  297,
  294,
  292,
  289,
  287,
  285,
  282,
  280,
  278,
  275,
  273,
  271,
  269,
  267,
  265,
  263,
  261,
  259
], Vbe = [
  9,
  11,
  12,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24
];
function $be(e, t) {
  var n = e.data, r = e.width, s = e.height, o, c, u, m, y, b, w, k, j, E, T, D, L, I, R, U, z, H, K, q, Q, Z, X, se, te = t + t + 1, fe = r - 1, ce = s - 1, pe = t + 1, Se = pe * (pe + 1) / 2, oe = new yB(), ue = null, he = oe, ve = null, Te = null, Ie = Hbe[t], Ue = Vbe[t];
  for (u = 1; u < te; u++)
    he = he.next = new yB(), u === pe && (ue = he);
  for (he.next = oe, w = b = 0, c = 0; c < s; c++) {
    for (U = z = H = K = k = j = E = T = 0, D = pe * (q = n[b]), L = pe * (Q = n[b + 1]), I = pe * (Z = n[b + 2]), R = pe * (X = n[b + 3]), k += Se * q, j += Se * Q, E += Se * Z, T += Se * X, he = oe, u = 0; u < pe; u++)
      he.r = q, he.g = Q, he.b = Z, he.a = X, he = he.next;
    for (u = 1; u < pe; u++)
      m = b + ((fe < u ? fe : u) << 2), k += (he.r = q = n[m]) * (se = pe - u), j += (he.g = Q = n[m + 1]) * se, E += (he.b = Z = n[m + 2]) * se, T += (he.a = X = n[m + 3]) * se, U += q, z += Q, H += Z, K += X, he = he.next;
    for (ve = oe, Te = ue, o = 0; o < r; o++)
      n[b + 3] = X = T * Ie >> Ue, X !== 0 ? (X = 255 / X, n[b] = (k * Ie >> Ue) * X, n[b + 1] = (j * Ie >> Ue) * X, n[b + 2] = (E * Ie >> Ue) * X) : n[b] = n[b + 1] = n[b + 2] = 0, k -= D, j -= L, E -= I, T -= R, D -= ve.r, L -= ve.g, I -= ve.b, R -= ve.a, m = w + ((m = o + t + 1) < fe ? m : fe) << 2, U += ve.r = n[m], z += ve.g = n[m + 1], H += ve.b = n[m + 2], K += ve.a = n[m + 3], k += U, j += z, E += H, T += K, ve = ve.next, D += q = Te.r, L += Q = Te.g, I += Z = Te.b, R += X = Te.a, U -= q, z -= Q, H -= Z, K -= X, Te = Te.next, b += 4;
    w += r;
  }
  for (o = 0; o < r; o++) {
    for (z = H = K = U = j = E = T = k = 0, b = o << 2, D = pe * (q = n[b]), L = pe * (Q = n[b + 1]), I = pe * (Z = n[b + 2]), R = pe * (X = n[b + 3]), k += Se * q, j += Se * Q, E += Se * Z, T += Se * X, he = oe, u = 0; u < pe; u++)
      he.r = q, he.g = Q, he.b = Z, he.a = X, he = he.next;
    for (y = r, u = 1; u <= t; u++)
      b = y + o << 2, k += (he.r = q = n[b]) * (se = pe - u), j += (he.g = Q = n[b + 1]) * se, E += (he.b = Z = n[b + 2]) * se, T += (he.a = X = n[b + 3]) * se, U += q, z += Q, H += Z, K += X, he = he.next, u < ce && (y += r);
    for (b = o, ve = oe, Te = ue, c = 0; c < s; c++)
      m = b << 2, n[m + 3] = X = T * Ie >> Ue, X > 0 ? (X = 255 / X, n[m] = (k * Ie >> Ue) * X, n[m + 1] = (j * Ie >> Ue) * X, n[m + 2] = (E * Ie >> Ue) * X) : n[m] = n[m + 1] = n[m + 2] = 0, k -= D, j -= L, E -= I, T -= R, D -= ve.r, L -= ve.g, I -= ve.b, R -= ve.a, m = o + ((m = c + pe) < ce ? m : ce) * r << 2, k += U += ve.r = n[m], j += z += ve.g = n[m + 1], E += H += ve.b = n[m + 2], T += K += ve.a = n[m + 3], ve = ve.next, D += q = Te.r, L += Q = Te.g, I += Z = Te.b, R += X = Te.a, U -= q, z -= Q, H -= Z, K -= X, Te = Te.next, b += r;
  }
}
const Gbe = function(t) {
  var n = Math.round(this.blurRadius());
  n > 0 && $be(t, n);
};
Uk.Blur = Gbe;
gB.Factory.addGetterSetter(zbe.Node, "blurRadius", 0, (0, Bbe.getNumberValidator)(), gB.Factory.afterSetFilter);
var zk = {};
Object.defineProperty(zk, "__esModule", { value: !0 });
zk.Brighten = void 0;
const vB = Sa, Wbe = ko, Ybe = Jn, qbe = function(e) {
  var t = this.brightness() * 255, n = e.data, r = n.length, s;
  for (s = 0; s < r; s += 4)
    n[s] += t, n[s + 1] += t, n[s + 2] += t;
};
zk.Brighten = qbe;
vB.Factory.addGetterSetter(Wbe.Node, "brightness", 0, (0, Ybe.getNumberValidator)(), vB.Factory.afterSetFilter);
var Bk = {};
Object.defineProperty(Bk, "__esModule", { value: !0 });
Bk.Contrast = void 0;
const xB = Sa, Kbe = ko, Xbe = Jn, Qbe = function(e) {
  var t = Math.pow((this.contrast() + 100) / 100, 2), n = e.data, r = n.length, s = 150, o = 150, c = 150, u;
  for (u = 0; u < r; u += 4)
    s = n[u], o = n[u + 1], c = n[u + 2], s /= 255, s -= 0.5, s *= t, s += 0.5, s *= 255, o /= 255, o -= 0.5, o *= t, o += 0.5, o *= 255, c /= 255, c -= 0.5, c *= t, c += 0.5, c *= 255, s = s < 0 ? 0 : s > 255 ? 255 : s, o = o < 0 ? 0 : o > 255 ? 255 : o, c = c < 0 ? 0 : c > 255 ? 255 : c, n[u] = s, n[u + 1] = o, n[u + 2] = c;
};
Bk.Contrast = Qbe;
xB.Factory.addGetterSetter(Kbe.Node, "contrast", 0, (0, Xbe.getNumberValidator)(), xB.Factory.afterSetFilter);
var Hk = {};
Object.defineProperty(Hk, "__esModule", { value: !0 });
Hk.Emboss = void 0;
const W2 = Sa, Vk = ko, Zbe = cl, QY = Jn, Jbe = function(e) {
  var t = this.embossStrength() * 10, n = this.embossWhiteLevel() * 255, r = this.embossDirection(), s = this.embossBlend(), o = 0, c = 0, u = e.data, m = e.width, y = e.height, b = m * 4, w = y;
  switch (r) {
    case "top-left":
      o = -1, c = -1;
      break;
    case "top":
      o = -1, c = 0;
      break;
    case "top-right":
      o = -1, c = 1;
      break;
    case "right":
      o = 0, c = 1;
      break;
    case "bottom-right":
      o = 1, c = 1;
      break;
    case "bottom":
      o = 1, c = 0;
      break;
    case "bottom-left":
      o = 1, c = -1;
      break;
    case "left":
      o = 0, c = -1;
      break;
    default:
      Zbe.Util.error("Unknown emboss direction: " + r);
  }
  do {
    var k = (w - 1) * b, j = o;
    w + j < 1 && (j = 0), w + j > y && (j = 0);
    var E = (w - 1 + j) * m * 4, T = m;
    do {
      var D = k + (T - 1) * 4, L = c;
      T + L < 1 && (L = 0), T + L > m && (L = 0);
      var I = E + (T - 1 + L) * 4, R = u[D] - u[I], U = u[D + 1] - u[I + 1], z = u[D + 2] - u[I + 2], H = R, K = H > 0 ? H : -H, q = U > 0 ? U : -U, Q = z > 0 ? z : -z;
      if (q > K && (H = U), Q > K && (H = z), H *= t, s) {
        var Z = u[D] + H, X = u[D + 1] + H, se = u[D + 2] + H;
        u[D] = Z > 255 ? 255 : Z < 0 ? 0 : Z, u[D + 1] = X > 255 ? 255 : X < 0 ? 0 : X, u[D + 2] = se > 255 ? 255 : se < 0 ? 0 : se;
      } else {
        var te = n - H;
        te < 0 ? te = 0 : te > 255 && (te = 255), u[D] = u[D + 1] = u[D + 2] = te;
      }
    } while (--T);
  } while (--w);
};
Hk.Emboss = Jbe;
W2.Factory.addGetterSetter(Vk.Node, "embossStrength", 0.5, (0, QY.getNumberValidator)(), W2.Factory.afterSetFilter);
W2.Factory.addGetterSetter(Vk.Node, "embossWhiteLevel", 0.5, (0, QY.getNumberValidator)(), W2.Factory.afterSetFilter);
W2.Factory.addGetterSetter(Vk.Node, "embossDirection", "top-left", null, W2.Factory.afterSetFilter);
W2.Factory.addGetterSetter(Vk.Node, "embossBlend", !1, null, W2.Factory.afterSetFilter);
var $k = {};
Object.defineProperty($k, "__esModule", { value: !0 });
$k.Enhance = void 0;
const bB = Sa, e4e = ko, t4e = Jn;
function jR(e, t, n, r, s) {
  var o = n - t, c = s - r, u;
  return o === 0 ? r + c / 2 : c === 0 ? r : (u = (e - t) / o, u = c * u + r, u);
}
const n4e = function(e) {
  var t = e.data, n = t.length, r = t[0], s = r, o, c = t[1], u = c, m, y = t[2], b = y, w, k, j = this.enhance();
  if (j !== 0) {
    for (k = 0; k < n; k += 4)
      o = t[k + 0], o < r ? r = o : o > s && (s = o), m = t[k + 1], m < c ? c = m : m > u && (u = m), w = t[k + 2], w < y ? y = w : w > b && (b = w);
    s === r && (s = 255, r = 0), u === c && (u = 255, c = 0), b === y && (b = 255, y = 0);
    var E, T, D, L, I, R, U, z, H;
    for (j > 0 ? (T = s + j * (255 - s), D = r - j * (r - 0), I = u + j * (255 - u), R = c - j * (c - 0), z = b + j * (255 - b), H = y - j * (y - 0)) : (E = (s + r) * 0.5, T = s + j * (s - E), D = r + j * (r - E), L = (u + c) * 0.5, I = u + j * (u - L), R = c + j * (c - L), U = (b + y) * 0.5, z = b + j * (b - U), H = y + j * (y - U)), k = 0; k < n; k += 4)
      t[k + 0] = jR(t[k + 0], r, s, D, T), t[k + 1] = jR(t[k + 1], c, u, R, I), t[k + 2] = jR(t[k + 2], y, b, H, z);
  }
};
$k.Enhance = n4e;
bB.Factory.addGetterSetter(e4e.Node, "enhance", 0, (0, t4e.getNumberValidator)(), bB.Factory.afterSetFilter);
var Gk = {};
Object.defineProperty(Gk, "__esModule", { value: !0 });
Gk.Grayscale = void 0;
const r4e = function(e) {
  var t = e.data, n = t.length, r, s;
  for (r = 0; r < n; r += 4)
    s = 0.34 * t[r] + 0.5 * t[r + 1] + 0.16 * t[r + 2], t[r] = s, t[r + 1] = s, t[r + 2] = s;
};
Gk.Grayscale = r4e;
var Wk = {};
Object.defineProperty(Wk, "__esModule", { value: !0 });
Wk.HSL = void 0;
const ew = Sa, _A = ko, TA = Jn;
ew.Factory.addGetterSetter(_A.Node, "hue", 0, (0, TA.getNumberValidator)(), ew.Factory.afterSetFilter);
ew.Factory.addGetterSetter(_A.Node, "saturation", 0, (0, TA.getNumberValidator)(), ew.Factory.afterSetFilter);
ew.Factory.addGetterSetter(_A.Node, "luminance", 0, (0, TA.getNumberValidator)(), ew.Factory.afterSetFilter);
const a4e = function(e) {
  var t = e.data, n = t.length, r = 1, s = Math.pow(2, this.saturation()), o = Math.abs(this.hue() + 360) % 360, c = this.luminance() * 127, u, m = r * s * Math.cos(o * Math.PI / 180), y = r * s * Math.sin(o * Math.PI / 180), b = 0.299 * r + 0.701 * m + 0.167 * y, w = 0.587 * r - 0.587 * m + 0.33 * y, k = 0.114 * r - 0.114 * m - 0.497 * y, j = 0.299 * r - 0.299 * m - 0.328 * y, E = 0.587 * r + 0.413 * m + 0.035 * y, T = 0.114 * r - 0.114 * m + 0.293 * y, D = 0.299 * r - 0.3 * m + 1.25 * y, L = 0.587 * r - 0.586 * m - 1.05 * y, I = 0.114 * r + 0.886 * m - 0.2 * y, R, U, z, H;
  for (u = 0; u < n; u += 4)
    R = t[u + 0], U = t[u + 1], z = t[u + 2], H = t[u + 3], t[u + 0] = b * R + w * U + k * z + c, t[u + 1] = j * R + E * U + T * z + c, t[u + 2] = D * R + L * U + I * z + c, t[u + 3] = H;
};
Wk.HSL = a4e;
var Yk = {};
Object.defineProperty(Yk, "__esModule", { value: !0 });
Yk.HSV = void 0;
const tw = Sa, MA = ko, RA = Jn, s4e = function(e) {
  var t = e.data, n = t.length, r = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), o = Math.abs(this.hue() + 360) % 360, c, u = r * s * Math.cos(o * Math.PI / 180), m = r * s * Math.sin(o * Math.PI / 180), y = 0.299 * r + 0.701 * u + 0.167 * m, b = 0.587 * r - 0.587 * u + 0.33 * m, w = 0.114 * r - 0.114 * u - 0.497 * m, k = 0.299 * r - 0.299 * u - 0.328 * m, j = 0.587 * r + 0.413 * u + 0.035 * m, E = 0.114 * r - 0.114 * u + 0.293 * m, T = 0.299 * r - 0.3 * u + 1.25 * m, D = 0.587 * r - 0.586 * u - 1.05 * m, L = 0.114 * r + 0.886 * u - 0.2 * m, I, R, U, z;
  for (c = 0; c < n; c += 4)
    I = t[c + 0], R = t[c + 1], U = t[c + 2], z = t[c + 3], t[c + 0] = y * I + b * R + w * U, t[c + 1] = k * I + j * R + E * U, t[c + 2] = T * I + D * R + L * U, t[c + 3] = z;
};
Yk.HSV = s4e;
tw.Factory.addGetterSetter(MA.Node, "hue", 0, (0, RA.getNumberValidator)(), tw.Factory.afterSetFilter);
tw.Factory.addGetterSetter(MA.Node, "saturation", 0, (0, RA.getNumberValidator)(), tw.Factory.afterSetFilter);
tw.Factory.addGetterSetter(MA.Node, "value", 0, (0, RA.getNumberValidator)(), tw.Factory.afterSetFilter);
var qk = {};
Object.defineProperty(qk, "__esModule", { value: !0 });
qk.Invert = void 0;
const i4e = function(e) {
  var t = e.data, n = t.length, r;
  for (r = 0; r < n; r += 4)
    t[r] = 255 - t[r], t[r + 1] = 255 - t[r + 1], t[r + 2] = 255 - t[r + 2];
};
qk.Invert = i4e;
var Kk = {};
Object.defineProperty(Kk, "__esModule", { value: !0 });
Kk.Kaleidoscope = void 0;
const J9 = Sa, ZY = ko, SB = cl, JY = Jn;
var o4e = function(e, t, n) {
  var r = e.data, s = t.data, o = e.width, c = e.height, u = n.polarCenterX || o / 2, m = n.polarCenterY || c / 2, y, b, w, k = 0, j = 0, E = 0, T = 0, D, L = Math.sqrt(u * u + m * m);
  b = o - u, w = c - m, D = Math.sqrt(b * b + w * w), L = D > L ? D : L;
  var I = c, R = o, U, z, H = 360 / R * Math.PI / 180, K, q;
  for (z = 0; z < R; z += 1)
    for (K = Math.sin(z * H), q = Math.cos(z * H), U = 0; U < I; U += 1)
      b = Math.floor(u + L * U / I * q), w = Math.floor(m + L * U / I * K), y = (w * o + b) * 4, k = r[y + 0], j = r[y + 1], E = r[y + 2], T = r[y + 3], y = (z + U * o) * 4, s[y + 0] = k, s[y + 1] = j, s[y + 2] = E, s[y + 3] = T;
}, l4e = function(e, t, n) {
  var r = e.data, s = t.data, o = e.width, c = e.height, u = n.polarCenterX || o / 2, m = n.polarCenterY || c / 2, y, b, w, k, j, E = 0, T = 0, D = 0, L = 0, I, R = Math.sqrt(u * u + m * m);
  b = o - u, w = c - m, I = Math.sqrt(b * b + w * w), R = I > R ? I : R;
  var U = c, z = o, H, K, q = 0, Q, Z;
  for (b = 0; b < o; b += 1)
    for (w = 0; w < c; w += 1)
      k = b - u, j = w - m, H = Math.sqrt(k * k + j * j) * U / R, K = (Math.atan2(j, k) * 180 / Math.PI + 360 + q) % 360, K = K * z / 360, Q = Math.floor(K), Z = Math.floor(H), y = (Z * o + Q) * 4, E = r[y + 0], T = r[y + 1], D = r[y + 2], L = r[y + 3], y = (w * o + b) * 4, s[y + 0] = E, s[y + 1] = T, s[y + 2] = D, s[y + 3] = L;
};
const c4e = function(e) {
  var t = e.width, n = e.height, r, s, o, c, u, m, y, b, w, k, j = Math.round(this.kaleidoscopePower()), E = Math.round(this.kaleidoscopeAngle()), T = Math.floor(t * (E % 360) / 360);
  if (!(j < 1)) {
    var D = SB.Util.createCanvasElement();
    D.width = t, D.height = n;
    var L = D.getContext("2d").getImageData(0, 0, t, n);
    SB.Util.releaseCanvas(D), o4e(e, L, {
      polarCenterX: t / 2,
      polarCenterY: n / 2
    });
    for (var I = t / Math.pow(2, j); I <= 8; )
      I = I * 2, j -= 1;
    I = Math.ceil(I);
    var R = I, U = 0, z = R, H = 1;
    for (T + I > t && (U = R, z = 0, H = -1), s = 0; s < n; s += 1)
      for (r = U; r !== z; r += H)
        o = Math.round(r + T) % t, w = (t * s + o) * 4, u = L.data[w + 0], m = L.data[w + 1], y = L.data[w + 2], b = L.data[w + 3], k = (t * s + r) * 4, L.data[k + 0] = u, L.data[k + 1] = m, L.data[k + 2] = y, L.data[k + 3] = b;
    for (s = 0; s < n; s += 1)
      for (R = Math.floor(I), c = 0; c < j; c += 1) {
        for (r = 0; r < R + 1; r += 1)
          w = (t * s + r) * 4, u = L.data[w + 0], m = L.data[w + 1], y = L.data[w + 2], b = L.data[w + 3], k = (t * s + R * 2 - r - 1) * 4, L.data[k + 0] = u, L.data[k + 1] = m, L.data[k + 2] = y, L.data[k + 3] = b;
        R *= 2;
      }
    l4e(L, e, { polarRotation: 0 });
  }
};
Kk.Kaleidoscope = c4e;
J9.Factory.addGetterSetter(ZY.Node, "kaleidoscopePower", 2, (0, JY.getNumberValidator)(), J9.Factory.afterSetFilter);
J9.Factory.addGetterSetter(ZY.Node, "kaleidoscopeAngle", 0, (0, JY.getNumberValidator)(), J9.Factory.afterSetFilter);
var Xk = {};
Object.defineProperty(Xk, "__esModule", { value: !0 });
Xk.Mask = void 0;
const wB = Sa, u4e = ko, d4e = Jn;
function Ij(e, t, n) {
  var r = (n * e.width + t) * 4, s = [];
  return s.push(e.data[r++], e.data[r++], e.data[r++], e.data[r++]), s;
}
function z7(e, t) {
  return Math.sqrt(Math.pow(e[0] - t[0], 2) + Math.pow(e[1] - t[1], 2) + Math.pow(e[2] - t[2], 2));
}
function f4e(e) {
  for (var t = [0, 0, 0], n = 0; n < e.length; n++)
    t[0] += e[n][0], t[1] += e[n][1], t[2] += e[n][2];
  return t[0] /= e.length, t[1] /= e.length, t[2] /= e.length, t;
}
function m4e(e, t) {
  var n = Ij(e, 0, 0), r = Ij(e, e.width - 1, 0), s = Ij(e, 0, e.height - 1), o = Ij(e, e.width - 1, e.height - 1), c = t || 10;
  if (z7(n, r) < c && z7(r, o) < c && z7(o, s) < c && z7(s, n) < c) {
    for (var u = f4e([r, n, o, s]), m = [], y = 0; y < e.width * e.height; y++) {
      var b = z7(u, [
        e.data[y * 4],
        e.data[y * 4 + 1],
        e.data[y * 4 + 2]
      ]);
      m[y] = b < c ? 0 : 255;
    }
    return m;
  }
}
function h4e(e, t) {
  for (var n = 0; n < e.width * e.height; n++)
    e.data[4 * n + 3] = t[n];
}
function p4e(e, t, n) {
  for (var r = [1, 1, 1, 1, 0, 1, 1, 1, 1], s = Math.round(Math.sqrt(r.length)), o = Math.floor(s / 2), c = [], u = 0; u < n; u++)
    for (var m = 0; m < t; m++) {
      for (var y = u * t + m, b = 0, w = 0; w < s; w++)
        for (var k = 0; k < s; k++) {
          var j = u + w - o, E = m + k - o;
          if (j >= 0 && j < n && E >= 0 && E < t) {
            var T = j * t + E, D = r[w * s + k];
            b += e[T] * D;
          }
        }
      c[y] = b === 255 * 8 ? 255 : 0;
    }
  return c;
}
function g4e(e, t, n) {
  for (var r = [1, 1, 1, 1, 1, 1, 1, 1, 1], s = Math.round(Math.sqrt(r.length)), o = Math.floor(s / 2), c = [], u = 0; u < n; u++)
    for (var m = 0; m < t; m++) {
      for (var y = u * t + m, b = 0, w = 0; w < s; w++)
        for (var k = 0; k < s; k++) {
          var j = u + w - o, E = m + k - o;
          if (j >= 0 && j < n && E >= 0 && E < t) {
            var T = j * t + E, D = r[w * s + k];
            b += e[T] * D;
          }
        }
      c[y] = b >= 255 * 4 ? 255 : 0;
    }
  return c;
}
function y4e(e, t, n) {
  for (var r = [0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111], s = Math.round(Math.sqrt(r.length)), o = Math.floor(s / 2), c = [], u = 0; u < n; u++)
    for (var m = 0; m < t; m++) {
      for (var y = u * t + m, b = 0, w = 0; w < s; w++)
        for (var k = 0; k < s; k++) {
          var j = u + w - o, E = m + k - o;
          if (j >= 0 && j < n && E >= 0 && E < t) {
            var T = j * t + E, D = r[w * s + k];
            b += e[T] * D;
          }
        }
      c[y] = b;
    }
  return c;
}
const v4e = function(e) {
  var t = this.threshold(), n = m4e(e, t);
  return n && (n = p4e(n, e.width, e.height), n = g4e(n, e.width, e.height), n = y4e(n, e.width, e.height), h4e(e, n)), e;
};
Xk.Mask = v4e;
wB.Factory.addGetterSetter(u4e.Node, "threshold", 0, (0, d4e.getNumberValidator)(), wB.Factory.afterSetFilter);
var Qk = {};
Object.defineProperty(Qk, "__esModule", { value: !0 });
Qk.Noise = void 0;
const CB = Sa, x4e = ko, b4e = Jn, S4e = function(e) {
  var t = this.noise() * 255, n = e.data, r = n.length, s = t / 2, o;
  for (o = 0; o < r; o += 4)
    n[o + 0] += s - 2 * s * Math.random(), n[o + 1] += s - 2 * s * Math.random(), n[o + 2] += s - 2 * s * Math.random();
};
Qk.Noise = S4e;
CB.Factory.addGetterSetter(x4e.Node, "noise", 0.2, (0, b4e.getNumberValidator)(), CB.Factory.afterSetFilter);
var Zk = {};
Object.defineProperty(Zk, "__esModule", { value: !0 });
Zk.Pixelate = void 0;
const NB = Sa, w4e = cl, C4e = ko, N4e = Jn, j4e = function(e) {
  var t = Math.ceil(this.pixelSize()), n = e.width, r = e.height, s, o, c, u, m, y, b, w = Math.ceil(n / t), k = Math.ceil(r / t), j, E, T, D, L, I, R, U = e.data;
  if (t <= 0) {
    w4e.Util.error("pixelSize value can not be <= 0");
    return;
  }
  for (L = 0; L < w; L += 1)
    for (I = 0; I < k; I += 1) {
      for (u = 0, m = 0, y = 0, b = 0, j = L * t, E = j + t, T = I * t, D = T + t, R = 0, s = j; s < E; s += 1)
        if (!(s >= n))
          for (o = T; o < D; o += 1)
            o >= r || (c = (n * o + s) * 4, u += U[c + 0], m += U[c + 1], y += U[c + 2], b += U[c + 3], R += 1);
      for (u = u / R, m = m / R, y = y / R, b = b / R, s = j; s < E; s += 1)
        if (!(s >= n))
          for (o = T; o < D; o += 1)
            o >= r || (c = (n * o + s) * 4, U[c + 0] = u, U[c + 1] = m, U[c + 2] = y, U[c + 3] = b);
    }
};
Zk.Pixelate = j4e;
NB.Factory.addGetterSetter(C4e.Node, "pixelSize", 8, (0, N4e.getNumberValidator)(), NB.Factory.afterSetFilter);
var Jk = {};
Object.defineProperty(Jk, "__esModule", { value: !0 });
Jk.Posterize = void 0;
const jB = Sa, E4e = ko, k4e = Jn, _4e = function(e) {
  var t = Math.round(this.levels() * 254) + 1, n = e.data, r = n.length, s = 255 / t, o;
  for (o = 0; o < r; o += 1)
    n[o] = Math.floor(n[o] / s) * s;
};
Jk.Posterize = _4e;
jB.Factory.addGetterSetter(E4e.Node, "levels", 0.5, (0, k4e.getNumberValidator)(), jB.Factory.afterSetFilter);
var e_ = {};
Object.defineProperty(e_, "__esModule", { value: !0 });
e_.RGB = void 0;
const eE = Sa, DA = ko, T4e = Jn, M4e = function(e) {
  var t = e.data, n = t.length, r = this.red(), s = this.green(), o = this.blue(), c, u;
  for (c = 0; c < n; c += 4)
    u = (0.34 * t[c] + 0.5 * t[c + 1] + 0.16 * t[c + 2]) / 255, t[c] = u * r, t[c + 1] = u * s, t[c + 2] = u * o, t[c + 3] = t[c + 3];
};
e_.RGB = M4e;
eE.Factory.addGetterSetter(DA.Node, "red", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
eE.Factory.addGetterSetter(DA.Node, "green", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
eE.Factory.addGetterSetter(DA.Node, "blue", 0, T4e.RGBComponent, eE.Factory.afterSetFilter);
var t_ = {};
Object.defineProperty(t_, "__esModule", { value: !0 });
t_.RGBA = void 0;
const O3 = Sa, n_ = ko, R4e = Jn, D4e = function(e) {
  var t = e.data, n = t.length, r = this.red(), s = this.green(), o = this.blue(), c = this.alpha(), u, m;
  for (u = 0; u < n; u += 4)
    m = 1 - c, t[u] = r * c + t[u] * m, t[u + 1] = s * c + t[u + 1] * m, t[u + 2] = o * c + t[u + 2] * m;
};
t_.RGBA = D4e;
O3.Factory.addGetterSetter(n_.Node, "red", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
O3.Factory.addGetterSetter(n_.Node, "green", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
O3.Factory.addGetterSetter(n_.Node, "blue", 0, R4e.RGBComponent, O3.Factory.afterSetFilter);
O3.Factory.addGetterSetter(n_.Node, "alpha", 1, function(e) {
  return this._filterUpToDate = !1, e > 1 ? 1 : e < 0 ? 0 : e;
});
var r_ = {};
Object.defineProperty(r_, "__esModule", { value: !0 });
r_.Sepia = void 0;
const P4e = function(e) {
  var t = e.data, n = t.length, r, s, o, c;
  for (r = 0; r < n; r += 4)
    s = t[r + 0], o = t[r + 1], c = t[r + 2], t[r + 0] = Math.min(255, s * 0.393 + o * 0.769 + c * 0.189), t[r + 1] = Math.min(255, s * 0.349 + o * 0.686 + c * 0.168), t[r + 2] = Math.min(255, s * 0.272 + o * 0.534 + c * 0.131);
};
r_.Sepia = P4e;
var a_ = {};
Object.defineProperty(a_, "__esModule", { value: !0 });
a_.Solarize = void 0;
const O4e = function(e) {
  var t = e.data, n = e.width, r = e.height, s = n * 4, o = r;
  do {
    var c = (o - 1) * s, u = n;
    do {
      var m = c + (u - 1) * 4, y = t[m], b = t[m + 1], w = t[m + 2];
      y > 127 && (y = 255 - y), b > 127 && (b = 255 - b), w > 127 && (w = 255 - w), t[m] = y, t[m + 1] = b, t[m + 2] = w;
    } while (--u);
  } while (--o);
};
a_.Solarize = O4e;
var s_ = {};
Object.defineProperty(s_, "__esModule", { value: !0 });
s_.Threshold = void 0;
const EB = Sa, A4e = ko, L4e = Jn, I4e = function(e) {
  var t = this.threshold() * 255, n = e.data, r = n.length, s;
  for (s = 0; s < r; s += 1)
    n[s] = n[s] < t ? 0 : 255;
};
s_.Threshold = I4e;
EB.Factory.addGetterSetter(A4e.Node, "threshold", 0.5, (0, L4e.getNumberValidator)(), EB.Factory.afterSetFilter);
Object.defineProperty(hk, "__esModule", { value: !0 });
hk.Konva = void 0;
const kB = X9, F4e = bk, U4e = Ck, z4e = Ek, B4e = kk, H4e = _k, _B = J8, V4e = C6, $4e = jw, G4e = j6, W4e = Rk, Y4e = Dk, q4e = Pk, K4e = Ok, X4e = e5, Q4e = Ak, Z4e = Lk, J4e = Ik, e5e = Uk, t5e = zk, n5e = Bk, r5e = Hk, a5e = $k, s5e = Gk, i5e = Wk, o5e = Yk, l5e = qk, c5e = Kk, u5e = Xk, d5e = Qk, f5e = Zk, m5e = Jk, h5e = e_, p5e = t_, g5e = r_, y5e = a_, v5e = s_;
hk.Konva = kB.Konva.Util._assign(kB.Konva, {
  Arc: F4e.Arc,
  Arrow: U4e.Arrow,
  Circle: z4e.Circle,
  Ellipse: B4e.Ellipse,
  Image: H4e.Image,
  Label: _B.Label,
  Tag: _B.Tag,
  Line: V4e.Line,
  Path: $4e.Path,
  Rect: G4e.Rect,
  RegularPolygon: W4e.RegularPolygon,
  Ring: Y4e.Ring,
  Sprite: q4e.Sprite,
  Star: K4e.Star,
  Text: X4e.Text,
  TextPath: Q4e.TextPath,
  Transformer: Z4e.Transformer,
  Wedge: J4e.Wedge,
  Filters: {
    Blur: e5e.Blur,
    Brighten: t5e.Brighten,
    Contrast: n5e.Contrast,
    Emboss: r5e.Emboss,
    Enhance: a5e.Enhance,
    Grayscale: s5e.Grayscale,
    HSL: i5e.HSL,
    HSV: o5e.HSV,
    Invert: l5e.Invert,
    Kaleidoscope: c5e.Kaleidoscope,
    Mask: u5e.Mask,
    Noise: d5e.Noise,
    Pixelate: f5e.Pixelate,
    Posterize: m5e.Posterize,
    RGB: h5e.RGB,
    RGBA: p5e.RGBA,
    Sepia: g5e.Sepia,
    Solarize: y5e.Solarize,
    Threshold: v5e.Threshold
  }
});
var x5e = vY.exports;
Object.defineProperty(x5e, "__esModule", { value: !0 });
const b5e = hk;
vY.exports = b5e.Konva;
var sP = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.Konva = void 0;
  var n = X9;
  Object.defineProperty(t, "Konva", { enumerable: !0, get: function() {
    return n.Konva;
  } });
  const r = X9;
  e.exports = r.Konva;
})(sP, sP.exports);
var S5e = sP.exports;
const A3 = /* @__PURE__ */ fE(S5e);
var iP = { exports: {} };
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ER, TB;
function w5e() {
  return TB || (TB = 1, ER = function(t) {
    var n = {}, r = Ee, s = G3(), o = Object.assign;
    function c(v) {
      for (var x = "https://reactjs.org/docs/error-decoder.html?invariant=" + v, P = 1; P < arguments.length; P++) x += "&args[]=" + encodeURIComponent(arguments[P]);
      return "Minified React error #" + v + "; visit " + x + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var u = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, m = Symbol.for("react.element"), y = Symbol.for("react.portal"), b = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), k = Symbol.for("react.profiler"), j = Symbol.for("react.provider"), E = Symbol.for("react.context"), T = Symbol.for("react.forward_ref"), D = Symbol.for("react.suspense"), L = Symbol.for("react.suspense_list"), I = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), U = Symbol.for("react.offscreen"), z = Symbol.iterator;
    function H(v) {
      return v === null || typeof v != "object" ? null : (v = z && v[z] || v["@@iterator"], typeof v == "function" ? v : null);
    }
    function K(v) {
      if (v == null) return null;
      if (typeof v == "function") return v.displayName || v.name || null;
      if (typeof v == "string") return v;
      switch (v) {
        case b:
          return "Fragment";
        case y:
          return "Portal";
        case k:
          return "Profiler";
        case w:
          return "StrictMode";
        case D:
          return "Suspense";
        case L:
          return "SuspenseList";
      }
      if (typeof v == "object") switch (v.$$typeof) {
        case E:
          return (v.displayName || "Context") + ".Consumer";
        case j:
          return (v._context.displayName || "Context") + ".Provider";
        case T:
          var x = v.render;
          return v = v.displayName, v || (v = x.displayName || x.name || "", v = v !== "" ? "ForwardRef(" + v + ")" : "ForwardRef"), v;
        case I:
          return x = v.displayName || null, x !== null ? x : K(v.type) || "Memo";
        case R:
          x = v._payload, v = v._init;
          try {
            return K(v(x));
          } catch {
          }
      }
      return null;
    }
    function q(v) {
      var x = v.type;
      switch (v.tag) {
        case 24:
          return "Cache";
        case 9:
          return (x.displayName || "Context") + ".Consumer";
        case 10:
          return (x._context.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return v = x.render, v = v.displayName || v.name || "", x.displayName || (v !== "" ? "ForwardRef(" + v + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 5:
          return x;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return K(x);
        case 8:
          return x === w ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
          if (typeof x == "function") return x.displayName || x.name || null;
          if (typeof x == "string") return x;
      }
      return null;
    }
    function Q(v) {
      var x = v, P = v;
      if (v.alternate) for (; x.return; ) x = x.return;
      else {
        v = x;
        do
          x = v, x.flags & 4098 && (P = x.return), v = x.return;
        while (v);
      }
      return x.tag === 3 ? P : null;
    }
    function Z(v) {
      if (Q(v) !== v) throw Error(c(188));
    }
    function X(v) {
      var x = v.alternate;
      if (!x) {
        if (x = Q(v), x === null) throw Error(c(188));
        return x !== v ? null : v;
      }
      for (var P = v, B = x; ; ) {
        var G = P.return;
        if (G === null) break;
        var ne = G.alternate;
        if (ne === null) {
          if (B = G.return, B !== null) {
            P = B;
            continue;
          }
          break;
        }
        if (G.child === ne.child) {
          for (ne = G.child; ne; ) {
            if (ne === P) return Z(G), v;
            if (ne === B) return Z(G), x;
            ne = ne.sibling;
          }
          throw Error(c(188));
        }
        if (P.return !== B.return) P = G, B = ne;
        else {
          for (var be = !1, Fe = G.child; Fe; ) {
            if (Fe === P) {
              be = !0, P = G, B = ne;
              break;
            }
            if (Fe === B) {
              be = !0, B = G, P = ne;
              break;
            }
            Fe = Fe.sibling;
          }
          if (!be) {
            for (Fe = ne.child; Fe; ) {
              if (Fe === P) {
                be = !0, P = ne, B = G;
                break;
              }
              if (Fe === B) {
                be = !0, B = ne, P = G;
                break;
              }
              Fe = Fe.sibling;
            }
            if (!be) throw Error(c(189));
          }
        }
        if (P.alternate !== B) throw Error(c(190));
      }
      if (P.tag !== 3) throw Error(c(188));
      return P.stateNode.current === P ? v : x;
    }
    function se(v) {
      return v = X(v), v !== null ? te(v) : null;
    }
    function te(v) {
      if (v.tag === 5 || v.tag === 6) return v;
      for (v = v.child; v !== null; ) {
        var x = te(v);
        if (x !== null) return x;
        v = v.sibling;
      }
      return null;
    }
    function fe(v) {
      if (v.tag === 5 || v.tag === 6) return v;
      for (v = v.child; v !== null; ) {
        if (v.tag !== 4) {
          var x = fe(v);
          if (x !== null) return x;
        }
        v = v.sibling;
      }
      return null;
    }
    var ce = Array.isArray, pe = t.getPublicInstance, Se = t.getRootHostContext, oe = t.getChildHostContext, ue = t.prepareForCommit, he = t.resetAfterCommit, ve = t.createInstance, Te = t.appendInitialChild, Ie = t.finalizeInitialChildren, Ue = t.prepareUpdate, qe = t.shouldSetTextContent, it = t.createTextInstance, Ne = t.scheduleTimeout, Xe = t.cancelTimeout, xt = t.noTimeout, rn = t.isPrimaryRenderer, vt = t.supportsMutation, At = t.supportsPersistence, He = t.supportsHydration, Pt = t.getInstanceFromNode, Lt = t.preparePortalMount, er = t.getCurrentEventPriority, It = t.detachDeletedInstance, ye = t.supportsMicrotasks, ke = t.scheduleMicrotask, Pe = t.supportsTestSelectors, tt = t.findFiberRoot, ot = t.getBoundingRect, ut = t.getTextContent, Vt = t.isHiddenSubtree, bn = t.matchAccessibilityRole, mr = t.setFocusIfFocusable, ur = t.setupIntersectionObserver, _r = t.appendChild, ai = t.appendChildToContainer, ls = t.commitTextUpdate, Ot = t.commitMount, En = t.commitUpdate, Xt = t.insertBefore, qt = t.insertInContainerBefore, In = t.removeChild, st = t.removeChildFromContainer, lt = t.resetTextContent, Nt = t.hideInstance, Wt = t.hideTextInstance, wn = t.unhideInstance, pt = t.unhideTextInstance, hr = t.clearContainer, _o = t.cloneInstance, Il = t.createContainerChildSet, Cr = t.appendChildToContainerChildSet, Wi = t.finalizeContainerChildren, Yi = t.replaceContainerChildren, To = t.cloneHiddenInstance, qi = t.cloneHiddenTextInstance, Mo = t.canHydrateInstance, ul = t.canHydrateTextInstance, dl = t.canHydrateSuspenseInstance, Dc = t.isSuspenseInstancePending, Ro = t.isSuspenseInstanceFallback, Do = t.getSuspenseInstanceFallbackErrorDetails, _s = t.registerSuspenseInstanceRetry, fl = t.getNextHydratableSibling, _e = t.getFirstHydratableChild, _t = t.getFirstHydratableChildWithinContainer, Kt = t.getFirstHydratableChildWithinSuspenseInstance, On = t.hydrateInstance, vr = t.hydrateTextInstance, Lr = t.hydrateSuspenseInstance, Xn = t.getNextHydratableInstanceAfterSuspenseInstance, wr = t.commitHydratedContainer, Ts = t.commitHydratedSuspenseInstance, pa = t.clearSuspenseBoundary, ga = t.clearSuspenseBoundaryFromContainer, Tr = t.shouldDeleteUnhydratedTailInstances, Fn = t.didNotMatchHydratedContainerTextInstance, Gn = t.didNotMatchHydratedTextInstance, zr;
    function ta(v) {
      if (zr === void 0) try {
        throw Error();
      } catch (P) {
        var x = P.stack.trim().match(/\n( *(at )?)/);
        zr = x && x[1] || "";
      }
      return `
` + zr + v;
    }
    var ir = !1;
    function Hs(v, x) {
      if (!v || ir) return "";
      ir = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        if (x) if (x = function() {
          throw Error();
        }, Object.defineProperty(x.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(x, []);
          } catch (Ft) {
            var B = Ft;
          }
          Reflect.construct(v, [], x);
        } else {
          try {
            x.call();
          } catch (Ft) {
            B = Ft;
          }
          v.call(x.prototype);
        }
        else {
          try {
            throw Error();
          } catch (Ft) {
            B = Ft;
          }
          v();
        }
      } catch (Ft) {
        if (Ft && B && typeof Ft.stack == "string") {
          for (var G = Ft.stack.split(`
`), ne = B.stack.split(`
`), be = G.length - 1, Fe = ne.length - 1; 1 <= be && 0 <= Fe && G[be] !== ne[Fe]; ) Fe--;
          for (; 1 <= be && 0 <= Fe; be--, Fe--) if (G[be] !== ne[Fe]) {
            if (be !== 1 || Fe !== 1)
              do
                if (be--, Fe--, 0 > Fe || G[be] !== ne[Fe]) {
                  var Ze = `
` + G[be].replace(" at new ", " at ");
                  return v.displayName && Ze.includes("<anonymous>") && (Ze = Ze.replace("<anonymous>", v.displayName)), Ze;
                }
              while (1 <= be && 0 <= Fe);
            break;
          }
        }
      } finally {
        ir = !1, Error.prepareStackTrace = P;
      }
      return (v = v ? v.displayName || v.name : "") ? ta(v) : "";
    }
    var Pc = Object.prototype.hasOwnProperty, Fl = [], Ki = -1;
    function Ms(v) {
      return { current: v };
    }
    function xr(v) {
      0 > Ki || (v.current = Fl[Ki], Fl[Ki] = null, Ki--);
    }
    function Mr(v, x) {
      Ki++, Fl[Ki] = v.current, v.current = x;
    }
    var xu = {}, Po = Ms(xu), ec = Ms(!1), Yd = xu;
    function Ju(v, x) {
      var P = v.type.contextTypes;
      if (!P) return xu;
      var B = v.stateNode;
      if (B && B.__reactInternalMemoizedUnmaskedChildContext === x) return B.__reactInternalMemoizedMaskedChildContext;
      var G = {}, ne;
      for (ne in P) G[ne] = x[ne];
      return B && (v = v.stateNode, v.__reactInternalMemoizedUnmaskedChildContext = x, v.__reactInternalMemoizedMaskedChildContext = G), G;
    }
    function fi(v) {
      return v = v.childContextTypes, v != null;
    }
    function Ul() {
      xr(ec), xr(Po);
    }
    function P1(v, x, P) {
      if (Po.current !== xu) throw Error(c(168));
      Mr(Po, x), Mr(ec, P);
    }
    function fh(v, x, P) {
      var B = v.stateNode;
      if (x = x.childContextTypes, typeof B.getChildContext != "function") return P;
      B = B.getChildContext();
      for (var G in B) if (!(G in x)) throw Error(c(108, q(v) || "Unknown", G));
      return o({}, P, B);
    }
    function mh(v) {
      return v = (v = v.stateNode) && v.__reactInternalMemoizedMergedChildContext || xu, Yd = Po.current, Mr(Po, v), Mr(ec, ec.current), !0;
    }
    function jp(v, x, P) {
      var B = v.stateNode;
      if (!B) throw Error(c(169));
      P ? (v = fh(v, x, Yd), B.__reactInternalMemoizedMergedChildContext = v, xr(ec), xr(Po), Mr(Po, v)) : xr(ec), Mr(ec, P);
    }
    var Oc = Math.clz32 ? Math.clz32 : O1, Rf = Math.log, n0 = Math.LN2;
    function O1(v) {
      return v >>>= 0, v === 0 ? 32 : 31 - (Rf(v) / n0 | 0) | 0;
    }
    var Rr = 64, Df = 4194304;
    function Oo(v) {
      switch (v & -v) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return v & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return v & 130023424;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 1073741824;
        default:
          return v;
      }
    }
    function hh(v, x) {
      var P = v.pendingLanes;
      if (P === 0) return 0;
      var B = 0, G = v.suspendedLanes, ne = v.pingedLanes, be = P & 268435455;
      if (be !== 0) {
        var Fe = be & ~G;
        Fe !== 0 ? B = Oo(Fe) : (ne &= be, ne !== 0 && (B = Oo(ne)));
      } else be = P & ~G, be !== 0 ? B = Oo(be) : ne !== 0 && (B = Oo(ne));
      if (B === 0) return 0;
      if (x !== 0 && x !== B && !(x & G) && (G = B & -B, ne = x & -x, G >= ne || G === 16 && (ne & 4194240) !== 0)) return x;
      if (B & 4 && (B |= P & 16), x = v.entangledLanes, x !== 0) for (v = v.entanglements, x &= B; 0 < x; ) P = 31 - Oc(x), G = 1 << P, B |= v[P], x &= ~G;
      return B;
    }
    function Qa(v, x) {
      switch (v) {
        case 1:
        case 2:
        case 4:
          return x + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return x + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return -1;
      }
    }
    function rx(v, x) {
      for (var P = v.suspendedLanes, B = v.pingedLanes, G = v.expirationTimes, ne = v.pendingLanes; 0 < ne; ) {
        var be = 31 - Oc(ne), Fe = 1 << be, Ze = G[be];
        Ze === -1 ? (!(Fe & P) || Fe & B) && (G[be] = Qa(Fe, x)) : Ze <= x && (v.expiredLanes |= Fe), ne &= ~Fe;
      }
    }
    function A1(v) {
      return v = v.pendingLanes & -1073741825, v !== 0 ? v : v & 1073741824 ? 1073741824 : 0;
    }
    function Nr() {
      var v = Rr;
      return Rr <<= 1, !(Rr & 4194240) && (Rr = 64), v;
    }
    function ph(v) {
      for (var x = [], P = 0; 31 > P; P++) x.push(v);
      return x;
    }
    function Za(v, x, P) {
      v.pendingLanes |= x, x !== 536870912 && (v.suspendedLanes = 0, v.pingedLanes = 0), v = v.eventTimes, x = 31 - Oc(x), v[x] = P;
    }
    function bu(v, x) {
      var P = v.pendingLanes & ~x;
      v.pendingLanes = x, v.suspendedLanes = 0, v.pingedLanes = 0, v.expiredLanes &= x, v.mutableReadLanes &= x, v.entangledLanes &= x, x = v.entanglements;
      var B = v.eventTimes;
      for (v = v.expirationTimes; 0 < P; ) {
        var G = 31 - Oc(P), ne = 1 << G;
        x[G] = 0, B[G] = -1, v[G] = -1, P &= ~ne;
      }
    }
    function tc(v, x) {
      var P = v.entangledLanes |= x;
      for (v = v.entanglements; P; ) {
        var B = 31 - Oc(P), G = 1 << B;
        G & x | v[B] & x && (v[B] |= x), P &= ~G;
      }
    }
    var la = 0;
    function Vs(v) {
      return v &= -v, 1 < v ? 4 < v ? v & 268435455 ? 16 : 536870912 : 4 : 1;
    }
    var Va = s.unstable_scheduleCallback, ax = s.unstable_cancelCallback, ed = s.unstable_shouldYield, ml = s.unstable_requestPaint, Rs = s.unstable_now, r0 = s.unstable_ImmediatePriority, Ep = s.unstable_UserBlockingPriority, L1 = s.unstable_NormalPriority, sx = s.unstable_IdlePriority, vm = null, nc = null;
    function kp(v) {
      if (nc && typeof nc.onCommitFiberRoot == "function") try {
        nc.onCommitFiberRoot(vm, v, void 0, (v.current.flags & 128) === 128);
      } catch {
      }
    }
    function xm(v, x) {
      return v === x && (v !== 0 || 1 / v === 1 / x) || v !== v && x !== x;
    }
    var Su = typeof Object.is == "function" ? Object.is : xm, wu = null, gh = !1, yh = !1;
    function I1(v) {
      wu === null ? wu = [v] : wu.push(v);
    }
    function My(v) {
      gh = !0, I1(v);
    }
    function Xi() {
      if (!yh && wu !== null) {
        yh = !0;
        var v = 0, x = la;
        try {
          var P = wu;
          for (la = 1; v < P.length; v++) {
            var B = P[v];
            do
              B = B(!0);
            while (B !== null);
          }
          wu = null, gh = !1;
        } catch (G) {
          throw wu !== null && (wu = wu.slice(v + 1)), Va(r0, Xi), G;
        } finally {
          la = x, yh = !1;
        }
      }
      return null;
    }
    var td = [], qd = 0, bm = null, Kd = 0, Ao = [], Ac = 0, Qi = null, hl = 1, Lc = "";
    function rc(v, x) {
      td[qd++] = Kd, td[qd++] = bm, bm = v, Kd = x;
    }
    function Ry(v, x, P) {
      Ao[Ac++] = hl, Ao[Ac++] = Lc, Ao[Ac++] = Qi, Qi = v;
      var B = hl;
      v = Lc;
      var G = 32 - Oc(B) - 1;
      B &= ~(1 << G), P += 1;
      var ne = 32 - Oc(x) + G;
      if (30 < ne) {
        var be = G - G % 5;
        ne = (B & (1 << be) - 1).toString(32), B >>= be, G -= be, hl = 1 << 32 - Oc(x) + G | P << G | B, Lc = ne + v;
      } else hl = 1 << ne | P << G | B, Lc = v;
    }
    function _p(v) {
      v.return !== null && (rc(v, 1), Ry(v, 1, 0));
    }
    function Sm(v) {
      for (; v === bm; ) bm = td[--qd], td[qd] = null, Kd = td[--qd], td[qd] = null;
      for (; v === Qi; ) Qi = Ao[--Ac], Ao[Ac] = null, Lc = Ao[--Ac], Ao[Ac] = null, hl = Ao[--Ac], Ao[Ac] = null;
    }
    var Lo = null, Ja = null, vs = !1, Tp = !1, Cu = null;
    function ix(v, x) {
      var P = ao(5, null, null, 0);
      P.elementType = "DELETED", P.stateNode = x, P.return = v, x = v.deletions, x === null ? (v.deletions = [P], v.flags |= 16) : x.push(P);
    }
    function Pf(v, x) {
      switch (v.tag) {
        case 5:
          return x = Mo(x, v.type, v.pendingProps), x !== null ? (v.stateNode = x, Lo = v, Ja = _e(x), !0) : !1;
        case 6:
          return x = ul(x, v.pendingProps), x !== null ? (v.stateNode = x, Lo = v, Ja = null, !0) : !1;
        case 13:
          if (x = dl(x), x !== null) {
            var P = Qi !== null ? { id: hl, overflow: Lc } : null;
            return v.memoizedState = { dehydrated: x, treeContext: P, retryLane: 1073741824 }, P = ao(18, null, null, 0), P.stateNode = x, P.return = v, v.child = P, Lo = v, Ja = null, !0;
          }
          return !1;
        default:
          return !1;
      }
    }
    function F1(v) {
      return (v.mode & 1) !== 0 && (v.flags & 128) === 0;
    }
    function a0(v) {
      if (vs) {
        var x = Ja;
        if (x) {
          var P = x;
          if (!Pf(v, x)) {
            if (F1(v)) throw Error(c(418));
            x = fl(P);
            var B = Lo;
            x && Pf(v, x) ? ix(B, P) : (v.flags = v.flags & -4097 | 2, vs = !1, Lo = v);
          }
        } else {
          if (F1(v)) throw Error(c(418));
          v.flags = v.flags & -4097 | 2, vs = !1, Lo = v;
        }
      }
    }
    function ox(v) {
      for (v = v.return; v !== null && v.tag !== 5 && v.tag !== 3 && v.tag !== 13; ) v = v.return;
      Lo = v;
    }
    function s0(v) {
      if (!He || v !== Lo) return !1;
      if (!vs) return ox(v), vs = !0, !1;
      if (v.tag !== 3 && (v.tag !== 5 || Tr(v.type) && !qe(v.type, v.memoizedProps))) {
        var x = Ja;
        if (x) {
          if (F1(v)) throw lx(), Error(c(418));
          for (; x; ) ix(v, x), x = fl(x);
        }
      }
      if (ox(v), v.tag === 13) {
        if (!He) throw Error(c(316));
        if (v = v.memoizedState, v = v !== null ? v.dehydrated : null, !v) throw Error(c(317));
        Ja = Xn(v);
      } else Ja = Lo ? fl(v.stateNode) : null;
      return !0;
    }
    function lx() {
      for (var v = Ja; v; ) v = fl(v);
    }
    function wm() {
      He && (Ja = Lo = null, Tp = vs = !1);
    }
    function U1(v) {
      Cu === null ? Cu = [v] : Cu.push(v);
    }
    var cx = u.ReactCurrentBatchConfig;
    function z1(v, x) {
      if (Su(v, x)) return !0;
      if (typeof v != "object" || v === null || typeof x != "object" || x === null) return !1;
      var P = Object.keys(v), B = Object.keys(x);
      if (P.length !== B.length) return !1;
      for (B = 0; B < P.length; B++) {
        var G = P[B];
        if (!Pc.call(x, G) || !Su(v[G], x[G])) return !1;
      }
      return !0;
    }
    function ux(v) {
      switch (v.tag) {
        case 5:
          return ta(v.type);
        case 16:
          return ta("Lazy");
        case 13:
          return ta("Suspense");
        case 19:
          return ta("SuspenseList");
        case 0:
        case 2:
        case 15:
          return v = Hs(v.type, !1), v;
        case 11:
          return v = Hs(v.type.render, !1), v;
        case 1:
          return v = Hs(v.type, !0), v;
        default:
          return "";
      }
    }
    function vh(v, x, P) {
      if (v = P.ref, v !== null && typeof v != "function" && typeof v != "object") {
        if (P._owner) {
          if (P = P._owner, P) {
            if (P.tag !== 1) throw Error(c(309));
            var B = P.stateNode;
          }
          if (!B) throw Error(c(147, v));
          var G = B, ne = "" + v;
          return x !== null && x.ref !== null && typeof x.ref == "function" && x.ref._stringRef === ne ? x.ref : (x = function(be) {
            var Fe = G.refs;
            be === null ? delete Fe[ne] : Fe[ne] = be;
          }, x._stringRef = ne, x);
        }
        if (typeof v != "string") throw Error(c(284));
        if (!P._owner) throw Error(c(290, v));
      }
      return v;
    }
    function Nu(v, x) {
      throw v = Object.prototype.toString.call(x), Error(c(31, v === "[object Object]" ? "object with keys {" + Object.keys(x).join(", ") + "}" : v));
    }
    function dx(v) {
      var x = v._init;
      return x(v._payload);
    }
    function i0(v) {
      function x(Be, ze) {
        if (v) {
          var rt = Be.deletions;
          rt === null ? (Be.deletions = [ze], Be.flags |= 16) : rt.push(ze);
        }
      }
      function P(Be, ze) {
        if (!v) return null;
        for (; ze !== null; ) x(Be, ze), ze = ze.sibling;
        return null;
      }
      function B(Be, ze) {
        for (Be = /* @__PURE__ */ new Map(); ze !== null; ) ze.key !== null ? Be.set(ze.key, ze) : Be.set(ze.index, ze), ze = ze.sibling;
        return Be;
      }
      function G(Be, ze) {
        return Be = da(Be, ze), Be.index = 0, Be.sibling = null, Be;
      }
      function ne(Be, ze, rt) {
        return Be.index = rt, v ? (rt = Be.alternate, rt !== null ? (rt = rt.index, rt < ze ? (Be.flags |= 2, ze) : rt) : (Be.flags |= 2, ze)) : (Be.flags |= 1048576, ze);
      }
      function be(Be) {
        return v && Be.alternate === null && (Be.flags |= 2), Be;
      }
      function Fe(Be, ze, rt, Jt) {
        return ze === null || ze.tag !== 6 ? (ze = vd(rt, Be.mode, Jt), ze.return = Be, ze) : (ze = G(ze, rt), ze.return = Be, ze);
      }
      function Ze(Be, ze, rt, Jt) {
        var Yn = rt.type;
        return Yn === b ? sn(Be, ze, rt.props.children, Jt, rt.key) : ze !== null && (ze.elementType === Yn || typeof Yn == "object" && Yn !== null && Yn.$$typeof === R && dx(Yn) === ze.type) ? (Jt = G(ze, rt.props), Jt.ref = vh(Be, ze, rt), Jt.return = Be, Jt) : (Jt = Yf(rt.type, rt.key, rt.props, null, Be.mode, Jt), Jt.ref = vh(Be, ze, rt), Jt.return = Be, Jt);
      }
      function Ft(Be, ze, rt, Jt) {
        return ze === null || ze.tag !== 4 || ze.stateNode.containerInfo !== rt.containerInfo || ze.stateNode.implementation !== rt.implementation ? (ze = Bp(rt, Be.mode, Jt), ze.return = Be, ze) : (ze = G(ze, rt.children || []), ze.return = Be, ze);
      }
      function sn(Be, ze, rt, Jt, Yn) {
        return ze === null || ze.tag !== 7 ? (ze = Ei(rt, Be.mode, Jt, Yn), ze.return = Be, ze) : (ze = G(ze, rt), ze.return = Be, ze);
      }
      function dr(Be, ze, rt) {
        if (typeof ze == "string" && ze !== "" || typeof ze == "number") return ze = vd("" + ze, Be.mode, rt), ze.return = Be, ze;
        if (typeof ze == "object" && ze !== null) {
          switch (ze.$$typeof) {
            case m:
              return rt = Yf(ze.type, ze.key, ze.props, null, Be.mode, rt), rt.ref = vh(Be, null, ze), rt.return = Be, rt;
            case y:
              return ze = Bp(ze, Be.mode, rt), ze.return = Be, ze;
            case R:
              var Jt = ze._init;
              return dr(Be, Jt(ze._payload), rt);
          }
          if (ce(ze) || H(ze)) return ze = Ei(ze, Be.mode, rt, null), ze.return = Be, ze;
          Nu(Be, ze);
        }
        return null;
      }
      function ct(Be, ze, rt, Jt) {
        var Yn = ze !== null ? ze.key : null;
        if (typeof rt == "string" && rt !== "" || typeof rt == "number") return Yn !== null ? null : Fe(Be, ze, "" + rt, Jt);
        if (typeof rt == "object" && rt !== null) {
          switch (rt.$$typeof) {
            case m:
              return rt.key === Yn ? Ze(Be, ze, rt, Jt) : null;
            case y:
              return rt.key === Yn ? Ft(Be, ze, rt, Jt) : null;
            case R:
              return Yn = rt._init, ct(
                Be,
                ze,
                Yn(rt._payload),
                Jt
              );
          }
          if (ce(rt) || H(rt)) return Yn !== null ? null : sn(Be, ze, rt, Jt, null);
          Nu(Be, rt);
        }
        return null;
      }
      function xa(Be, ze, rt, Jt, Yn) {
        if (typeof Jt == "string" && Jt !== "" || typeof Jt == "number") return Be = Be.get(rt) || null, Fe(ze, Be, "" + Jt, Yn);
        if (typeof Jt == "object" && Jt !== null) {
          switch (Jt.$$typeof) {
            case m:
              return Be = Be.get(Jt.key === null ? rt : Jt.key) || null, Ze(ze, Be, Jt, Yn);
            case y:
              return Be = Be.get(Jt.key === null ? rt : Jt.key) || null, Ft(ze, Be, Jt, Yn);
            case R:
              var pr = Jt._init;
              return xa(Be, ze, rt, pr(Jt._payload), Yn);
          }
          if (ce(Jt) || H(Jt)) return Be = Be.get(rt) || null, sn(ze, Be, Jt, Yn, null);
          Nu(ze, Jt);
        }
        return null;
      }
      function Ga(Be, ze, rt, Jt) {
        for (var Yn = null, pr = null, gr = ze, Kr = ze = 0, Js = null; gr !== null && Kr < rt.length; Kr++) {
          gr.index > Kr ? (Js = gr, gr = null) : Js = gr.sibling;
          var Wr = ct(Be, gr, rt[Kr], Jt);
          if (Wr === null) {
            gr === null && (gr = Js);
            break;
          }
          v && gr && Wr.alternate === null && x(Be, gr), ze = ne(Wr, ze, Kr), pr === null ? Yn = Wr : pr.sibling = Wr, pr = Wr, gr = Js;
        }
        if (Kr === rt.length) return P(Be, gr), vs && rc(Be, Kr), Yn;
        if (gr === null) {
          for (; Kr < rt.length; Kr++) gr = dr(Be, rt[Kr], Jt), gr !== null && (ze = ne(gr, ze, Kr), pr === null ? Yn = gr : pr.sibling = gr, pr = gr);
          return vs && rc(Be, Kr), Yn;
        }
        for (gr = B(Be, gr); Kr < rt.length; Kr++) Js = xa(gr, Be, Kr, rt[Kr], Jt), Js !== null && (v && Js.alternate !== null && gr.delete(Js.key === null ? Kr : Js.key), ze = ne(Js, ze, Kr), pr === null ? Yn = Js : pr.sibling = Js, pr = Js);
        return v && gr.forEach(function(Ea) {
          return x(Be, Ea);
        }), vs && rc(Be, Kr), Yn;
      }
      function bc(Be, ze, rt, Jt) {
        var Yn = H(rt);
        if (typeof Yn != "function") throw Error(c(150));
        if (rt = Yn.call(rt), rt == null) throw Error(c(151));
        for (var pr = Yn = null, gr = ze, Kr = ze = 0, Js = null, Wr = rt.next(); gr !== null && !Wr.done; Kr++, Wr = rt.next()) {
          gr.index > Kr ? (Js = gr, gr = null) : Js = gr.sibling;
          var Ea = ct(Be, gr, Wr.value, Jt);
          if (Ea === null) {
            gr === null && (gr = Js);
            break;
          }
          v && gr && Ea.alternate === null && x(Be, gr), ze = ne(Ea, ze, Kr), pr === null ? Yn = Ea : pr.sibling = Ea, pr = Ea, gr = Js;
        }
        if (Wr.done) return P(
          Be,
          gr
        ), vs && rc(Be, Kr), Yn;
        if (gr === null) {
          for (; !Wr.done; Kr++, Wr = rt.next()) Wr = dr(Be, Wr.value, Jt), Wr !== null && (ze = ne(Wr, ze, Kr), pr === null ? Yn = Wr : pr.sibling = Wr, pr = Wr);
          return vs && rc(Be, Kr), Yn;
        }
        for (gr = B(Be, gr); !Wr.done; Kr++, Wr = rt.next()) Wr = xa(gr, Be, Kr, Wr.value, Jt), Wr !== null && (v && Wr.alternate !== null && gr.delete(Wr.key === null ? Kr : Wr.key), ze = ne(Wr, ze, Kr), pr === null ? Yn = Wr : pr.sibling = Wr, pr = Wr);
        return v && gr.forEach(function(Xc) {
          return x(Be, Xc);
        }), vs && rc(Be, Kr), Yn;
      }
      function Zs(Be, ze, rt, Jt) {
        if (typeof rt == "object" && rt !== null && rt.type === b && rt.key === null && (rt = rt.props.children), typeof rt == "object" && rt !== null) {
          switch (rt.$$typeof) {
            case m:
              e: {
                for (var Yn = rt.key, pr = ze; pr !== null; ) {
                  if (pr.key === Yn) {
                    if (Yn = rt.type, Yn === b) {
                      if (pr.tag === 7) {
                        P(Be, pr.sibling), ze = G(pr, rt.props.children), ze.return = Be, Be = ze;
                        break e;
                      }
                    } else if (pr.elementType === Yn || typeof Yn == "object" && Yn !== null && Yn.$$typeof === R && dx(Yn) === pr.type) {
                      P(Be, pr.sibling), ze = G(pr, rt.props), ze.ref = vh(Be, pr, rt), ze.return = Be, Be = ze;
                      break e;
                    }
                    P(Be, pr);
                    break;
                  } else x(Be, pr);
                  pr = pr.sibling;
                }
                rt.type === b ? (ze = Ei(rt.props.children, Be.mode, Jt, rt.key), ze.return = Be, Be = ze) : (Jt = Yf(rt.type, rt.key, rt.props, null, Be.mode, Jt), Jt.ref = vh(Be, ze, rt), Jt.return = Be, Be = Jt);
              }
              return be(Be);
            case y:
              e: {
                for (pr = rt.key; ze !== null; ) {
                  if (ze.key === pr) if (ze.tag === 4 && ze.stateNode.containerInfo === rt.containerInfo && ze.stateNode.implementation === rt.implementation) {
                    P(Be, ze.sibling), ze = G(ze, rt.children || []), ze.return = Be, Be = ze;
                    break e;
                  } else {
                    P(Be, ze);
                    break;
                  }
                  else x(Be, ze);
                  ze = ze.sibling;
                }
                ze = Bp(rt, Be.mode, Jt), ze.return = Be, Be = ze;
              }
              return be(Be);
            case R:
              return pr = rt._init, Zs(Be, ze, pr(rt._payload), Jt);
          }
          if (ce(rt)) return Ga(Be, ze, rt, Jt);
          if (H(rt)) return bc(Be, ze, rt, Jt);
          Nu(Be, rt);
        }
        return typeof rt == "string" && rt !== "" || typeof rt == "number" ? (rt = "" + rt, ze !== null && ze.tag === 6 ? (P(Be, ze.sibling), ze = G(ze, rt), ze.return = Be, Be = ze) : (P(Be, ze), ze = vd(rt, Be.mode, Jt), ze.return = Be, Be = ze), be(Be)) : P(Be, ze);
      }
      return Zs;
    }
    var Of = i0(!0), o0 = i0(!1), l0 = Ms(null), xh = null, bh = null, pl = null;
    function zl() {
      pl = bh = xh = null;
    }
    function mi(v, x, P) {
      rn ? (Mr(l0, x._currentValue), x._currentValue = P) : (Mr(l0, x._currentValue2), x._currentValue2 = P);
    }
    function ac(v) {
      var x = l0.current;
      xr(l0), rn ? v._currentValue = x : v._currentValue2 = x;
    }
    function Xd(v, x, P) {
      for (; v !== null; ) {
        var B = v.alternate;
        if ((v.childLanes & x) !== x ? (v.childLanes |= x, B !== null && (B.childLanes |= x)) : B !== null && (B.childLanes & x) !== x && (B.childLanes |= x), v === P) break;
        v = v.return;
      }
    }
    function Qd(v, x) {
      xh = v, pl = bh = null, v = v.dependencies, v !== null && v.firstContext !== null && (v.lanes & x && (hi = !0), v.firstContext = null);
    }
    function sc(v) {
      var x = rn ? v._currentValue : v._currentValue2;
      if (pl !== v) if (v = { context: v, memoizedValue: x, next: null }, bh === null) {
        if (xh === null) throw Error(c(308));
        bh = v, xh.dependencies = { lanes: 0, firstContext: v };
      } else bh = bh.next = v;
      return x;
    }
    var Ic = null;
    function B1(v) {
      Ic === null ? Ic = [v] : Ic.push(v);
    }
    function c0(v, x, P, B) {
      var G = x.interleaved;
      return G === null ? (P.next = P, B1(x)) : (P.next = G.next, G.next = P), x.interleaved = P, Fc(v, B);
    }
    function Fc(v, x) {
      v.lanes |= x;
      var P = v.alternate;
      for (P !== null && (P.lanes |= x), P = v, v = v.return; v !== null; ) v.childLanes |= x, P = v.alternate, P !== null && (P.childLanes |= x), P = v, v = v.return;
      return P.tag === 3 ? P.stateNode : null;
    }
    var Uc = !1;
    function H1(v) {
      v.updateQueue = { baseState: v.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
    }
    function u0(v, x) {
      v = v.updateQueue, x.updateQueue === v && (x.updateQueue = { baseState: v.baseState, firstBaseUpdate: v.firstBaseUpdate, lastBaseUpdate: v.lastBaseUpdate, shared: v.shared, effects: v.effects });
    }
    function Io(v, x) {
      return { eventTime: v, lane: x, tag: 0, payload: null, callback: null, next: null };
    }
    function nd(v, x, P) {
      var B = v.updateQueue;
      if (B === null) return null;
      if (B = B.shared, br & 2) {
        var G = B.pending;
        return G === null ? x.next = x : (x.next = G.next, G.next = x), B.pending = x, Fc(v, P);
      }
      return G = B.interleaved, G === null ? (x.next = x, B1(B)) : (x.next = G.next, G.next = x), B.interleaved = x, Fc(v, P);
    }
    function Cm(v, x, P) {
      if (x = x.updateQueue, x !== null && (x = x.shared, (P & 4194240) !== 0)) {
        var B = x.lanes;
        B &= v.pendingLanes, P |= B, x.lanes = P, tc(v, P);
      }
    }
    function Mp(v, x) {
      var P = v.updateQueue, B = v.alternate;
      if (B !== null && (B = B.updateQueue, P === B)) {
        var G = null, ne = null;
        if (P = P.firstBaseUpdate, P !== null) {
          do {
            var be = { eventTime: P.eventTime, lane: P.lane, tag: P.tag, payload: P.payload, callback: P.callback, next: null };
            ne === null ? G = ne = be : ne = ne.next = be, P = P.next;
          } while (P !== null);
          ne === null ? G = ne = x : ne = ne.next = x;
        } else G = ne = x;
        P = { baseState: B.baseState, firstBaseUpdate: G, lastBaseUpdate: ne, shared: B.shared, effects: B.effects }, v.updateQueue = P;
        return;
      }
      v = P.lastBaseUpdate, v === null ? P.firstBaseUpdate = x : v.next = x, P.lastBaseUpdate = x;
    }
    function rd(v, x, P, B) {
      var G = v.updateQueue;
      Uc = !1;
      var ne = G.firstBaseUpdate, be = G.lastBaseUpdate, Fe = G.shared.pending;
      if (Fe !== null) {
        G.shared.pending = null;
        var Ze = Fe, Ft = Ze.next;
        Ze.next = null, be === null ? ne = Ft : be.next = Ft, be = Ze;
        var sn = v.alternate;
        sn !== null && (sn = sn.updateQueue, Fe = sn.lastBaseUpdate, Fe !== be && (Fe === null ? sn.firstBaseUpdate = Ft : Fe.next = Ft, sn.lastBaseUpdate = Ze));
      }
      if (ne !== null) {
        var dr = G.baseState;
        be = 0, sn = Ft = Ze = null, Fe = ne;
        do {
          var ct = Fe.lane, xa = Fe.eventTime;
          if ((B & ct) === ct) {
            sn !== null && (sn = sn.next = {
              eventTime: xa,
              lane: 0,
              tag: Fe.tag,
              payload: Fe.payload,
              callback: Fe.callback,
              next: null
            });
            e: {
              var Ga = v, bc = Fe;
              switch (ct = x, xa = P, bc.tag) {
                case 1:
                  if (Ga = bc.payload, typeof Ga == "function") {
                    dr = Ga.call(xa, dr, ct);
                    break e;
                  }
                  dr = Ga;
                  break e;
                case 3:
                  Ga.flags = Ga.flags & -65537 | 128;
                case 0:
                  if (Ga = bc.payload, ct = typeof Ga == "function" ? Ga.call(xa, dr, ct) : Ga, ct == null) break e;
                  dr = o({}, dr, ct);
                  break e;
                case 2:
                  Uc = !0;
              }
            }
            Fe.callback !== null && Fe.lane !== 0 && (v.flags |= 64, ct = G.effects, ct === null ? G.effects = [Fe] : ct.push(Fe));
          } else xa = { eventTime: xa, lane: ct, tag: Fe.tag, payload: Fe.payload, callback: Fe.callback, next: null }, sn === null ? (Ft = sn = xa, Ze = dr) : sn = sn.next = xa, be |= ct;
          if (Fe = Fe.next, Fe === null) {
            if (Fe = G.shared.pending, Fe === null) break;
            ct = Fe, Fe = ct.next, ct.next = null, G.lastBaseUpdate = ct, G.shared.pending = null;
          }
        } while (!0);
        if (sn === null && (Ze = dr), G.baseState = Ze, G.firstBaseUpdate = Ft, G.lastBaseUpdate = sn, x = G.shared.interleaved, x !== null) {
          G = x;
          do
            be |= G.lane, G = G.next;
          while (G !== x);
        } else ne === null && (G.shared.lanes = 0);
        lf |= be, v.lanes = be, v.memoizedState = dr;
      }
    }
    function Sh(v, x, P) {
      if (v = x.effects, x.effects = null, v !== null) for (x = 0; x < v.length; x++) {
        var B = v[x], G = B.callback;
        if (G !== null) {
          if (B.callback = null, B = P, typeof G != "function") throw Error(c(191, G));
          G.call(B);
        }
      }
    }
    var ju = {}, zc = Ms(ju), Af = Ms(ju), Lf = Ms(ju);
    function Bc(v) {
      if (v === ju) throw Error(c(174));
      return v;
    }
    function V1(v, x) {
      Mr(Lf, x), Mr(Af, v), Mr(zc, ju), v = Se(x), xr(zc), Mr(zc, v);
    }
    function Zd() {
      xr(zc), xr(Af), xr(Lf);
    }
    function Hc(v) {
      var x = Bc(Lf.current), P = Bc(zc.current);
      x = oe(P, v.type, x), P !== x && (Mr(Af, v), Mr(zc, x));
    }
    function $1(v) {
      Af.current === v && (xr(zc), xr(Af));
    }
    var Cs = Ms(0);
    function Eu(v) {
      for (var x = v; x !== null; ) {
        if (x.tag === 13) {
          var P = x.memoizedState;
          if (P !== null && (P = P.dehydrated, P === null || Dc(P) || Ro(P))) return x;
        } else if (x.tag === 19 && x.memoizedProps.revealOrder !== void 0) {
          if (x.flags & 128) return x;
        } else if (x.child !== null) {
          x.child.return = x, x = x.child;
          continue;
        }
        if (x === v) break;
        for (; x.sibling === null; ) {
          if (x.return === null || x.return === v) return null;
          x = x.return;
        }
        x.sibling.return = x.return, x = x.sibling;
      }
      return null;
    }
    var ad = [];
    function yo() {
      for (var v = 0; v < ad.length; v++) {
        var x = ad[v];
        rn ? x._workInProgressVersionPrimary = null : x._workInProgressVersionSecondary = null;
      }
      ad.length = 0;
    }
    var Pa = u.ReactCurrentDispatcher, If = u.ReactCurrentBatchConfig, Ii = 0, wa = null, es = null, si = null, Fo = !1, Ff = !1, sd = 0, ic = 0;
    function xs() {
      throw Error(c(321));
    }
    function Jd(v, x) {
      if (x === null) return !1;
      for (var P = 0; P < x.length && P < v.length; P++) if (!Su(v[P], x[P])) return !1;
      return !0;
    }
    function wh(v, x, P, B, G, ne) {
      if (Ii = ne, wa = x, x.memoizedState = null, x.updateQueue = null, x.lanes = 0, Pa.current = v === null || v.memoizedState === null ? X1 : Bf, v = P(B, G), Ff) {
        ne = 0;
        do {
          if (Ff = !1, sd = 0, 25 <= ne) throw Error(c(301));
          ne += 1, si = es = null, x.updateQueue = null, Pa.current = jh, v = P(B, G);
        } while (Ff);
      }
      if (Pa.current = zf, x = es !== null && es.next !== null, Ii = 0, si = es = wa = null, Fo = !1, x) throw Error(c(300));
      return v;
    }
    function G1() {
      var v = sd !== 0;
      return sd = 0, v;
    }
    function oc() {
      var v = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
      return si === null ? wa.memoizedState = si = v : si = si.next = v, si;
    }
    function Ci() {
      if (es === null) {
        var v = wa.alternate;
        v = v !== null ? v.memoizedState : null;
      } else v = es.next;
      var x = si === null ? wa.memoizedState : si.next;
      if (x !== null) si = x, es = v;
      else {
        if (v === null) throw Error(c(310));
        es = v, v = { memoizedState: es.memoizedState, baseState: es.baseState, baseQueue: es.baseQueue, queue: es.queue, next: null }, si === null ? wa.memoizedState = si = v : si = si.next = v;
      }
      return si;
    }
    function Nm(v, x) {
      return typeof x == "function" ? x(v) : x;
    }
    function W1(v) {
      var x = Ci(), P = x.queue;
      if (P === null) throw Error(c(311));
      P.lastRenderedReducer = v;
      var B = es, G = B.baseQueue, ne = P.pending;
      if (ne !== null) {
        if (G !== null) {
          var be = G.next;
          G.next = ne.next, ne.next = be;
        }
        B.baseQueue = G = ne, P.pending = null;
      }
      if (G !== null) {
        ne = G.next, B = B.baseState;
        var Fe = be = null, Ze = null, Ft = ne;
        do {
          var sn = Ft.lane;
          if ((Ii & sn) === sn) Ze !== null && (Ze = Ze.next = { lane: 0, action: Ft.action, hasEagerState: Ft.hasEagerState, eagerState: Ft.eagerState, next: null }), B = Ft.hasEagerState ? Ft.eagerState : v(B, Ft.action);
          else {
            var dr = {
              lane: sn,
              action: Ft.action,
              hasEagerState: Ft.hasEagerState,
              eagerState: Ft.eagerState,
              next: null
            };
            Ze === null ? (Fe = Ze = dr, be = B) : Ze = Ze.next = dr, wa.lanes |= sn, lf |= sn;
          }
          Ft = Ft.next;
        } while (Ft !== null && Ft !== ne);
        Ze === null ? be = B : Ze.next = Fe, Su(B, x.memoizedState) || (hi = !0), x.memoizedState = B, x.baseState = be, x.baseQueue = Ze, P.lastRenderedState = B;
      }
      if (v = P.interleaved, v !== null) {
        G = v;
        do
          ne = G.lane, wa.lanes |= ne, lf |= ne, G = G.next;
        while (G !== v);
      } else G === null && (P.lanes = 0);
      return [x.memoizedState, P.dispatch];
    }
    function Ds(v) {
      var x = Ci(), P = x.queue;
      if (P === null) throw Error(c(311));
      P.lastRenderedReducer = v;
      var B = P.dispatch, G = P.pending, ne = x.memoizedState;
      if (G !== null) {
        P.pending = null;
        var be = G = G.next;
        do
          ne = v(ne, be.action), be = be.next;
        while (be !== G);
        Su(ne, x.memoizedState) || (hi = !0), x.memoizedState = ne, x.baseQueue === null && (x.baseState = ne), P.lastRenderedState = ne;
      }
      return [ne, B];
    }
    function Y1() {
    }
    function Qn(v, x) {
      var P = wa, B = Ci(), G = x(), ne = !Su(B.memoizedState, G);
      if (ne && (B.memoizedState = G, hi = !0), B = B.queue, rr($s.bind(null, P, B, v), [v]), B.getSnapshot !== x || ne || si !== null && si.memoizedState.tag & 1) {
        if (P.flags |= 2048, od(9, Ca.bind(null, P, B, G, x), void 0, null), cs === null) throw Error(c(349));
        Ii & 30 || na(P, x, G);
      }
      return G;
    }
    function na(v, x, P) {
      v.flags |= 16384, v = { getSnapshot: x, value: P }, x = wa.updateQueue, x === null ? (x = { lastEffect: null, stores: null }, wa.updateQueue = x, x.stores = [v]) : (P = x.stores, P === null ? x.stores = [v] : P.push(v));
    }
    function Ca(v, x, P, B) {
      x.value = P, x.getSnapshot = B, ku(x) && id(v);
    }
    function $s(v, x, P) {
      return P(function() {
        ku(x) && id(v);
      });
    }
    function ku(v) {
      var x = v.getSnapshot;
      v = v.value;
      try {
        var P = x();
        return !Su(v, P);
      } catch {
        return !0;
      }
    }
    function id(v) {
      var x = Fc(v, 1);
      x !== null && va(x, v, 1, -1);
    }
    function Rp(v) {
      var x = oc();
      return typeof v == "function" && (v = v()), x.memoizedState = x.baseState = v, v = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Nm, lastRenderedState: v }, x.queue = v, v = v.dispatch = K1.bind(null, wa, v), [x.memoizedState, v];
    }
    function od(v, x, P, B) {
      return v = { tag: v, create: x, destroy: P, deps: B, next: null }, x = wa.updateQueue, x === null ? (x = { lastEffect: null, stores: null }, wa.updateQueue = x, x.lastEffect = v.next = v) : (P = x.lastEffect, P === null ? x.lastEffect = v.next = v : (B = P.next, P.next = v, v.next = B, x.lastEffect = v)), v;
    }
    function fx() {
      return Ci().memoizedState;
    }
    function ef(v, x, P, B) {
      var G = oc();
      wa.flags |= v, G.memoizedState = od(1 | x, P, void 0, B === void 0 ? null : B);
    }
    function bt(v, x, P, B) {
      var G = Ci();
      B = B === void 0 ? null : B;
      var ne = void 0;
      if (es !== null) {
        var be = es.memoizedState;
        if (ne = be.destroy, B !== null && Jd(B, be.deps)) {
          G.memoizedState = od(x, P, ne, B);
          return;
        }
      }
      wa.flags |= v, G.memoizedState = od(1 | x, P, ne, B);
    }
    function Zi(v, x) {
      return ef(8390656, 8, v, x);
    }
    function rr(v, x) {
      return bt(2048, 8, v, x);
    }
    function tf(v, x) {
      return bt(4, 2, v, x);
    }
    function ca(v, x) {
      return bt(4, 4, v, x);
    }
    function Bl(v, x) {
      if (typeof x == "function") return v = v(), x(v), function() {
        x(null);
      };
      if (x != null) return v = v(), x.current = v, function() {
        x.current = null;
      };
    }
    function Ji(v, x, P) {
      return P = P != null ? P.concat([v]) : null, bt(4, 4, Bl.bind(null, x, v), P);
    }
    function _u() {
    }
    function jm(v, x) {
      var P = Ci();
      x = x === void 0 ? null : x;
      var B = P.memoizedState;
      return B !== null && x !== null && Jd(x, B[1]) ? B[0] : (P.memoizedState = [v, x], v);
    }
    function Uf(v, x) {
      var P = Ci();
      x = x === void 0 ? null : x;
      var B = P.memoizedState;
      return B !== null && x !== null && Jd(x, B[1]) ? B[0] : (v = v(), P.memoizedState = [v, x], v);
    }
    function Em(v, x, P) {
      return Ii & 21 ? (Su(P, x) || (P = Nr(), wa.lanes |= P, lf |= P, v.baseState = !0), x) : (v.baseState && (v.baseState = !1, hi = !0), v.memoizedState = P);
    }
    function Ch(v, x) {
      var P = la;
      la = P !== 0 && 4 > P ? P : 4, v(!0);
      var B = If.transition;
      If.transition = {};
      try {
        v(!1), x();
      } finally {
        la = P, If.transition = B;
      }
    }
    function nf() {
      return Ci().memoizedState;
    }
    function q1(v, x, P) {
      var B = As(v);
      if (P = { lane: B, action: P, hasEagerState: !1, eagerState: null, next: null }, d0(v)) Dp(x, P);
      else if (P = c0(v, x, P, B), P !== null) {
        var G = hn();
        va(P, v, B, G), Nh(P, x, B);
      }
    }
    function K1(v, x, P) {
      var B = As(v), G = { lane: B, action: P, hasEagerState: !1, eagerState: null, next: null };
      if (d0(v)) Dp(x, G);
      else {
        var ne = v.alternate;
        if (v.lanes === 0 && (ne === null || ne.lanes === 0) && (ne = x.lastRenderedReducer, ne !== null)) try {
          var be = x.lastRenderedState, Fe = ne(be, P);
          if (G.hasEagerState = !0, G.eagerState = Fe, Su(Fe, be)) {
            var Ze = x.interleaved;
            Ze === null ? (G.next = G, B1(x)) : (G.next = Ze.next, Ze.next = G), x.interleaved = G;
            return;
          }
        } catch {
        } finally {
        }
        P = c0(v, x, G, B), P !== null && (G = hn(), va(P, v, B, G), Nh(P, x, B));
      }
    }
    function d0(v) {
      var x = v.alternate;
      return v === wa || x !== null && x === wa;
    }
    function Dp(v, x) {
      Ff = Fo = !0;
      var P = v.pending;
      P === null ? x.next = x : (x.next = P.next, P.next = x), v.pending = x;
    }
    function Nh(v, x, P) {
      if (P & 4194240) {
        var B = x.lanes;
        B &= v.pendingLanes, P |= B, x.lanes = P, tc(v, P);
      }
    }
    var zf = { readContext: sc, useCallback: xs, useContext: xs, useEffect: xs, useImperativeHandle: xs, useInsertionEffect: xs, useLayoutEffect: xs, useMemo: xs, useReducer: xs, useRef: xs, useState: xs, useDebugValue: xs, useDeferredValue: xs, useTransition: xs, useMutableSource: xs, useSyncExternalStore: xs, useId: xs, unstable_isNewReconciler: !1 }, X1 = { readContext: sc, useCallback: function(v, x) {
      return oc().memoizedState = [v, x === void 0 ? null : x], v;
    }, useContext: sc, useEffect: Zi, useImperativeHandle: function(v, x, P) {
      return P = P != null ? P.concat([v]) : null, ef(
        4194308,
        4,
        Bl.bind(null, x, v),
        P
      );
    }, useLayoutEffect: function(v, x) {
      return ef(4194308, 4, v, x);
    }, useInsertionEffect: function(v, x) {
      return ef(4, 2, v, x);
    }, useMemo: function(v, x) {
      var P = oc();
      return x = x === void 0 ? null : x, v = v(), P.memoizedState = [v, x], v;
    }, useReducer: function(v, x, P) {
      var B = oc();
      return x = P !== void 0 ? P(x) : x, B.memoizedState = B.baseState = x, v = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: v, lastRenderedState: x }, B.queue = v, v = v.dispatch = q1.bind(null, wa, v), [B.memoizedState, v];
    }, useRef: function(v) {
      var x = oc();
      return v = { current: v }, x.memoizedState = v;
    }, useState: Rp, useDebugValue: _u, useDeferredValue: function(v) {
      return oc().memoizedState = v;
    }, useTransition: function() {
      var v = Rp(!1), x = v[0];
      return v = Ch.bind(null, v[1]), oc().memoizedState = v, [x, v];
    }, useMutableSource: function() {
    }, useSyncExternalStore: function(v, x, P) {
      var B = wa, G = oc();
      if (vs) {
        if (P === void 0) throw Error(c(407));
        P = P();
      } else {
        if (P = x(), cs === null) throw Error(c(349));
        Ii & 30 || na(B, x, P);
      }
      G.memoizedState = P;
      var ne = { value: P, getSnapshot: x };
      return G.queue = ne, Zi($s.bind(
        null,
        B,
        ne,
        v
      ), [v]), B.flags |= 2048, od(9, Ca.bind(null, B, ne, P, x), void 0, null), P;
    }, useId: function() {
      var v = oc(), x = cs.identifierPrefix;
      if (vs) {
        var P = Lc, B = hl;
        P = (B & ~(1 << 32 - Oc(B) - 1)).toString(32) + P, x = ":" + x + "R" + P, P = sd++, 0 < P && (x += "H" + P.toString(32)), x += ":";
      } else P = ic++, x = ":" + x + "r" + P.toString(32) + ":";
      return v.memoizedState = x;
    }, unstable_isNewReconciler: !1 }, Bf = {
      readContext: sc,
      useCallback: jm,
      useContext: sc,
      useEffect: rr,
      useImperativeHandle: Ji,
      useInsertionEffect: tf,
      useLayoutEffect: ca,
      useMemo: Uf,
      useReducer: W1,
      useRef: fx,
      useState: function() {
        return W1(Nm);
      },
      useDebugValue: _u,
      useDeferredValue: function(v) {
        var x = Ci();
        return Em(x, es.memoizedState, v);
      },
      useTransition: function() {
        var v = W1(Nm)[0], x = Ci().memoizedState;
        return [v, x];
      },
      useMutableSource: Y1,
      useSyncExternalStore: Qn,
      useId: nf,
      unstable_isNewReconciler: !1
    }, jh = { readContext: sc, useCallback: jm, useContext: sc, useEffect: rr, useImperativeHandle: Ji, useInsertionEffect: tf, useLayoutEffect: ca, useMemo: Uf, useReducer: Ds, useRef: fx, useState: function() {
      return Ds(Nm);
    }, useDebugValue: _u, useDeferredValue: function(v) {
      var x = Ci();
      return es === null ? x.memoizedState = v : Em(x, es.memoizedState, v);
    }, useTransition: function() {
      var v = Ds(Nm)[0], x = Ci().memoizedState;
      return [v, x];
    }, useMutableSource: Y1, useSyncExternalStore: Qn, useId: nf, unstable_isNewReconciler: !1 };
    function eo(v, x) {
      if (v && v.defaultProps) {
        x = o({}, x), v = v.defaultProps;
        for (var P in v) x[P] === void 0 && (x[P] = v[P]);
        return x;
      }
      return x;
    }
    function Pp(v, x, P, B) {
      x = v.memoizedState, P = P(B, x), P = P == null ? x : o({}, x, P), v.memoizedState = P, v.lanes === 0 && (v.updateQueue.baseState = P);
    }
    var km = { isMounted: function(v) {
      return (v = v._reactInternals) ? Q(v) === v : !1;
    }, enqueueSetState: function(v, x, P) {
      v = v._reactInternals;
      var B = hn(), G = As(v), ne = Io(B, G);
      ne.payload = x, P != null && (ne.callback = P), x = nd(v, ne, G), x !== null && (va(x, v, G, B), Cm(x, v, G));
    }, enqueueReplaceState: function(v, x, P) {
      v = v._reactInternals;
      var B = hn(), G = As(v), ne = Io(B, G);
      ne.tag = 1, ne.payload = x, P != null && (ne.callback = P), x = nd(v, ne, G), x !== null && (va(x, v, G, B), Cm(x, v, G));
    }, enqueueForceUpdate: function(v, x) {
      v = v._reactInternals;
      var P = hn(), B = As(v), G = Io(P, B);
      G.tag = 2, x != null && (G.callback = x), x = nd(v, G, B), x !== null && (va(x, v, B, P), Cm(x, v, B));
    } };
    function Eh(v, x, P, B, G, ne, be) {
      return v = v.stateNode, typeof v.shouldComponentUpdate == "function" ? v.shouldComponentUpdate(B, ne, be) : x.prototype && x.prototype.isPureReactComponent ? !z1(P, B) || !z1(G, ne) : !0;
    }
    function kh(v, x, P) {
      var B = !1, G = xu, ne = x.contextType;
      return typeof ne == "object" && ne !== null ? ne = sc(ne) : (G = fi(x) ? Yd : Po.current, B = x.contextTypes, ne = (B = B != null) ? Ju(v, G) : xu), x = new x(P, ne), v.memoizedState = x.state !== null && x.state !== void 0 ? x.state : null, x.updater = km, v.stateNode = x, x._reactInternals = v, B && (v = v.stateNode, v.__reactInternalMemoizedUnmaskedChildContext = G, v.__reactInternalMemoizedMaskedChildContext = ne), x;
    }
    function ld(v, x, P, B) {
      v = x.state, typeof x.componentWillReceiveProps == "function" && x.componentWillReceiveProps(P, B), typeof x.UNSAFE_componentWillReceiveProps == "function" && x.UNSAFE_componentWillReceiveProps(P, B), x.state !== v && km.enqueueReplaceState(x, x.state, null);
    }
    function Hl(v, x, P, B) {
      var G = v.stateNode;
      G.props = P, G.state = v.memoizedState, G.refs = {}, H1(v);
      var ne = x.contextType;
      typeof ne == "object" && ne !== null ? G.context = sc(ne) : (ne = fi(x) ? Yd : Po.current, G.context = Ju(v, ne)), G.state = v.memoizedState, ne = x.getDerivedStateFromProps, typeof ne == "function" && (Pp(v, x, ne, P), G.state = v.memoizedState), typeof x.getDerivedStateFromProps == "function" || typeof G.getSnapshotBeforeUpdate == "function" || typeof G.UNSAFE_componentWillMount != "function" && typeof G.componentWillMount != "function" || (x = G.state, typeof G.componentWillMount == "function" && G.componentWillMount(), typeof G.UNSAFE_componentWillMount == "function" && G.UNSAFE_componentWillMount(), x !== G.state && km.enqueueReplaceState(G, G.state, null), rd(v, P, G, B), G.state = v.memoizedState), typeof G.componentDidMount == "function" && (v.flags |= 4194308);
    }
    function Tu(v, x) {
      try {
        var P = "", B = x;
        do
          P += ux(B), B = B.return;
        while (B);
        var G = P;
      } catch (ne) {
        G = `
Error generating stack: ` + ne.message + `
` + ne.stack;
      }
      return { value: v, source: x, stack: G, digest: null };
    }
    function Mu(v, x, P) {
      return { value: v, source: null, stack: P ?? null, digest: x ?? null };
    }
    function Vc(v, x) {
      try {
        console.error(x.value);
      } catch (P) {
        setTimeout(function() {
          throw P;
        });
      }
    }
    var cd = typeof WeakMap == "function" ? WeakMap : Map;
    function ud(v, x, P) {
      P = Io(-1, P), P.tag = 3, P.payload = { element: null };
      var B = x.value;
      return P.callback = function() {
        ar || (ar = !0, $r = B), Vc(v, x);
      }, P;
    }
    function _m(v, x, P) {
      P = Io(-1, P), P.tag = 3;
      var B = v.type.getDerivedStateFromError;
      if (typeof B == "function") {
        var G = x.value;
        P.payload = function() {
          return B(G);
        }, P.callback = function() {
          Vc(v, x);
        };
      }
      var ne = v.stateNode;
      return ne !== null && typeof ne.componentDidCatch == "function" && (P.callback = function() {
        Vc(v, x), typeof B != "function" && (Fi === null ? Fi = /* @__PURE__ */ new Set([this]) : Fi.add(this));
        var be = x.stack;
        this.componentDidCatch(x.value, { componentStack: be !== null ? be : "" });
      }), P;
    }
    function Tm(v, x, P) {
      var B = v.pingCache;
      if (B === null) {
        B = v.pingCache = new cd();
        var G = /* @__PURE__ */ new Set();
        B.set(x, G);
      } else G = B.get(x), G === void 0 && (G = /* @__PURE__ */ new Set(), B.set(x, G));
      G.has(P) || (G.add(P), v = Gl.bind(null, v, x, P), x.then(v, v));
    }
    function gl(v) {
      do {
        var x;
        if ((x = v.tag === 13) && (x = v.memoizedState, x = x !== null ? x.dehydrated !== null : !0), x) return v;
        v = v.return;
      } while (v !== null);
      return null;
    }
    function $c(v, x, P, B, G) {
      return v.mode & 1 ? (v.flags |= 65536, v.lanes = G, v) : (v === x ? v.flags |= 65536 : (v.flags |= 128, P.flags |= 131072, P.flags &= -52805, P.tag === 1 && (P.alternate === null ? P.tag = 17 : (x = Io(-1, 1), x.tag = 2, nd(P, x, 1))), P.lanes |= 1), v);
    }
    var $a = u.ReactCurrentOwner, hi = !1;
    function mn(v, x, P, B) {
      x.child = v === null ? o0(x, null, P, B) : Of(x, v.child, P, B);
    }
    function Gc(v, x, P, B, G) {
      P = P.render;
      var ne = x.ref;
      return Qd(x, G), B = wh(v, x, P, B, ne, G), P = G1(), v !== null && !hi ? (x.updateQueue = v.updateQueue, x.flags &= -2053, v.lanes &= ~G, Wc(v, x, G)) : (vs && P && _p(x), x.flags |= 1, mn(v, x, B, G), x.child);
    }
    function ts(v, x, P, B, G) {
      if (v === null) {
        var ne = P.type;
        return typeof ne == "function" && !So(ne) && ne.defaultProps === void 0 && P.compare === null && P.defaultProps === void 0 ? (x.tag = 15, x.type = ne, Dr(v, x, ne, B, G)) : (v = Yf(P.type, null, B, x, x.mode, G), v.ref = x.ref, v.return = x, x.child = v);
      }
      if (ne = v.child, !(v.lanes & G)) {
        var be = ne.memoizedProps;
        if (P = P.compare, P = P !== null ? P : z1, P(be, B) && v.ref === x.ref) return Wc(v, x, G);
      }
      return x.flags |= 1, v = da(ne, B), v.ref = x.ref, v.return = x, x.child = v;
    }
    function Dr(v, x, P, B, G) {
      if (v !== null) {
        var ne = v.memoizedProps;
        if (z1(ne, B) && v.ref === x.ref) if (hi = !1, x.pendingProps = B = ne, (v.lanes & G) !== 0) v.flags & 131072 && (hi = !0);
        else return x.lanes = v.lanes, Wc(v, x, G);
      }
      return Ru(v, x, P, B, G);
    }
    function Na(v, x, P) {
      var B = x.pendingProps, G = B.children, ne = v !== null ? v.memoizedState : null;
      if (B.mode === "hidden") if (!(x.mode & 1)) x.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Mr(Pm, ro), ro |= P;
      else {
        if (!(P & 1073741824)) return v = ne !== null ? ne.baseLanes | P : P, x.lanes = x.childLanes = 1073741824, x.memoizedState = { baseLanes: v, cachePool: null, transitions: null }, x.updateQueue = null, Mr(Pm, ro), ro |= v, null;
        x.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, B = ne !== null ? ne.baseLanes : P, Mr(Pm, ro), ro |= B;
      }
      else ne !== null ? (B = ne.baseLanes | P, x.memoizedState = null) : B = P, Mr(Pm, ro), ro |= B;
      return mn(v, x, G, P), x.child;
    }
    function Oa(v, x) {
      var P = x.ref;
      (v === null && P !== null || v !== null && v.ref !== P) && (x.flags |= 512, x.flags |= 2097152);
    }
    function Ru(v, x, P, B, G) {
      var ne = fi(P) ? Yd : Po.current;
      return ne = Ju(x, ne), Qd(x, G), P = wh(v, x, P, B, ne, G), B = G1(), v !== null && !hi ? (x.updateQueue = v.updateQueue, x.flags &= -2053, v.lanes &= ~G, Wc(v, x, G)) : (vs && B && _p(x), x.flags |= 1, mn(v, x, P, G), x.child);
    }
    function or(v, x, P, B, G) {
      if (fi(P)) {
        var ne = !0;
        mh(x);
      } else ne = !1;
      if (Qd(x, G), x.stateNode === null) Pu(v, x), kh(x, P, B), Hl(x, P, B, G), B = !0;
      else if (v === null) {
        var be = x.stateNode, Fe = x.memoizedProps;
        be.props = Fe;
        var Ze = be.context, Ft = P.contextType;
        typeof Ft == "object" && Ft !== null ? Ft = sc(Ft) : (Ft = fi(P) ? Yd : Po.current, Ft = Ju(x, Ft));
        var sn = P.getDerivedStateFromProps, dr = typeof sn == "function" || typeof be.getSnapshotBeforeUpdate == "function";
        dr || typeof be.UNSAFE_componentWillReceiveProps != "function" && typeof be.componentWillReceiveProps != "function" || (Fe !== B || Ze !== Ft) && ld(x, be, B, Ft), Uc = !1;
        var ct = x.memoizedState;
        be.state = ct, rd(x, B, be, G), Ze = x.memoizedState, Fe !== B || ct !== Ze || ec.current || Uc ? (typeof sn == "function" && (Pp(x, P, sn, B), Ze = x.memoizedState), (Fe = Uc || Eh(x, P, Fe, B, ct, Ze, Ft)) ? (dr || typeof be.UNSAFE_componentWillMount != "function" && typeof be.componentWillMount != "function" || (typeof be.componentWillMount == "function" && be.componentWillMount(), typeof be.UNSAFE_componentWillMount == "function" && be.UNSAFE_componentWillMount()), typeof be.componentDidMount == "function" && (x.flags |= 4194308)) : (typeof be.componentDidMount == "function" && (x.flags |= 4194308), x.memoizedProps = B, x.memoizedState = Ze), be.props = B, be.state = Ze, be.context = Ft, B = Fe) : (typeof be.componentDidMount == "function" && (x.flags |= 4194308), B = !1);
      } else {
        be = x.stateNode, u0(v, x), Fe = x.memoizedProps, Ft = x.type === x.elementType ? Fe : eo(x.type, Fe), be.props = Ft, dr = x.pendingProps, ct = be.context, Ze = P.contextType, typeof Ze == "object" && Ze !== null ? Ze = sc(Ze) : (Ze = fi(P) ? Yd : Po.current, Ze = Ju(x, Ze));
        var xa = P.getDerivedStateFromProps;
        (sn = typeof xa == "function" || typeof be.getSnapshotBeforeUpdate == "function") || typeof be.UNSAFE_componentWillReceiveProps != "function" && typeof be.componentWillReceiveProps != "function" || (Fe !== dr || ct !== Ze) && ld(x, be, B, Ze), Uc = !1, ct = x.memoizedState, be.state = ct, rd(x, B, be, G);
        var Ga = x.memoizedState;
        Fe !== dr || ct !== Ga || ec.current || Uc ? (typeof xa == "function" && (Pp(x, P, xa, B), Ga = x.memoizedState), (Ft = Uc || Eh(x, P, Ft, B, ct, Ga, Ze) || !1) ? (sn || typeof be.UNSAFE_componentWillUpdate != "function" && typeof be.componentWillUpdate != "function" || (typeof be.componentWillUpdate == "function" && be.componentWillUpdate(B, Ga, Ze), typeof be.UNSAFE_componentWillUpdate == "function" && be.UNSAFE_componentWillUpdate(B, Ga, Ze)), typeof be.componentDidUpdate == "function" && (x.flags |= 4), typeof be.getSnapshotBeforeUpdate == "function" && (x.flags |= 1024)) : (typeof be.componentDidUpdate != "function" || Fe === v.memoizedProps && ct === v.memoizedState || (x.flags |= 4), typeof be.getSnapshotBeforeUpdate != "function" || Fe === v.memoizedProps && ct === v.memoizedState || (x.flags |= 1024), x.memoizedProps = B, x.memoizedState = Ga), be.props = B, be.state = Ga, be.context = Ze, B = Ft) : (typeof be.componentDidUpdate != "function" || Fe === v.memoizedProps && ct === v.memoizedState || (x.flags |= 4), typeof be.getSnapshotBeforeUpdate != "function" || Fe === v.memoizedProps && ct === v.memoizedState || (x.flags |= 1024), B = !1);
      }
      return Gs(v, x, P, B, ne, G);
    }
    function Gs(v, x, P, B, G, ne) {
      Oa(v, x);
      var be = (x.flags & 128) !== 0;
      if (!B && !be) return G && jp(x, P, !1), Wc(v, x, ne);
      B = x.stateNode, $a.current = x;
      var Fe = be && typeof P.getDerivedStateFromError != "function" ? null : B.render();
      return x.flags |= 1, v !== null && be ? (x.child = Of(x, v.child, null, ne), x.child = Of(x, null, Fe, ne)) : mn(v, x, Fe, ne), x.memoizedState = B.state, G && jp(x, P, !0), x.child;
    }
    function Uo(v) {
      var x = v.stateNode;
      x.pendingContext ? P1(v, x.pendingContext, x.pendingContext !== x.context) : x.context && P1(v, x.context, !1), V1(v, x.containerInfo);
    }
    function lc(v, x, P, B, G) {
      return wm(), U1(G), x.flags |= 256, mn(v, x, P, B), x.child;
    }
    var Ns = { dehydrated: null, treeContext: null, retryLane: 0 };
    function cc(v) {
      return { baseLanes: v, cachePool: null, transitions: null };
    }
    function Du(v, x, P) {
      var B = x.pendingProps, G = Cs.current, ne = !1, be = (x.flags & 128) !== 0, Fe;
      if ((Fe = be) || (Fe = v !== null && v.memoizedState === null ? !1 : (G & 2) !== 0), Fe ? (ne = !0, x.flags &= -129) : (v === null || v.memoizedState !== null) && (G |= 1), Mr(Cs, G & 1), v === null)
        return a0(x), v = x.memoizedState, v !== null && (v = v.dehydrated, v !== null) ? (x.mode & 1 ? Ro(v) ? x.lanes = 8 : x.lanes = 1073741824 : x.lanes = 1, null) : (be = B.children, v = B.fallback, ne ? (B = x.mode, ne = x.child, be = { mode: "hidden", children: be }, !(B & 1) && ne !== null ? (ne.childLanes = 0, ne.pendingProps = be) : ne = yd(be, B, 0, null), v = Ei(v, B, P, null), ne.return = x, v.return = x, ne.sibling = v, x.child = ne, x.child.memoizedState = cc(P), x.memoizedState = Ns, v) : _h(x, be));
      if (G = v.memoizedState, G !== null && (Fe = G.dehydrated, Fe !== null)) return Dy(v, x, be, B, Fe, G, P);
      if (ne) {
        ne = B.fallback, be = x.mode, G = v.child, Fe = G.sibling;
        var Ze = { mode: "hidden", children: B.children };
        return !(be & 1) && x.child !== G ? (B = x.child, B.childLanes = 0, B.pendingProps = Ze, x.deletions = null) : (B = da(G, Ze), B.subtreeFlags = G.subtreeFlags & 14680064), Fe !== null ? ne = da(Fe, ne) : (ne = Ei(ne, be, P, null), ne.flags |= 2), ne.return = x, B.return = x, B.sibling = ne, x.child = B, B = ne, ne = x.child, be = v.child.memoizedState, be = be === null ? cc(P) : { baseLanes: be.baseLanes | P, cachePool: null, transitions: be.transitions }, ne.memoizedState = be, ne.childLanes = v.childLanes & ~P, x.memoizedState = Ns, B;
      }
      return ne = v.child, v = ne.sibling, B = da(ne, { mode: "visible", children: B.children }), !(x.mode & 1) && (B.lanes = P), B.return = x, B.sibling = null, v !== null && (P = x.deletions, P === null ? (x.deletions = [v], x.flags |= 16) : P.push(v)), x.child = B, x.memoizedState = null, B;
    }
    function _h(v, x) {
      return x = yd({ mode: "visible", children: x }, v.mode, 0, null), x.return = v, v.child = x;
    }
    function Mm(v, x, P, B) {
      return B !== null && U1(B), Of(x, v.child, null, P), v = _h(x, x.pendingProps.children), v.flags |= 2, x.memoizedState = null, v;
    }
    function Dy(v, x, P, B, G, ne, be) {
      if (P)
        return x.flags & 256 ? (x.flags &= -257, B = Mu(Error(c(422))), Mm(v, x, be, B)) : x.memoizedState !== null ? (x.child = v.child, x.flags |= 128, null) : (ne = B.fallback, G = x.mode, B = yd({ mode: "visible", children: B.children }, G, 0, null), ne = Ei(ne, G, be, null), ne.flags |= 2, B.return = x, ne.return = x, B.sibling = ne, x.child = B, x.mode & 1 && Of(x, v.child, null, be), x.child.memoizedState = cc(be), x.memoizedState = Ns, ne);
      if (!(x.mode & 1)) return Mm(v, x, be, null);
      if (Ro(G)) return B = Do(G).digest, ne = Error(c(419)), B = Mu(
        ne,
        B,
        void 0
      ), Mm(v, x, be, B);
      if (P = (be & v.childLanes) !== 0, hi || P) {
        if (B = cs, B !== null) {
          switch (be & -be) {
            case 4:
              G = 2;
              break;
            case 16:
              G = 8;
              break;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              G = 32;
              break;
            case 536870912:
              G = 268435456;
              break;
            default:
              G = 0;
          }
          G = G & (B.suspendedLanes | be) ? 0 : G, G !== 0 && G !== ne.retryLane && (ne.retryLane = G, Fc(v, G), va(
            B,
            v,
            G,
            -1
          ));
        }
        return Lm(), B = Mu(Error(c(421))), Mm(v, x, be, B);
      }
      return Dc(G) ? (x.flags |= 128, x.child = v.child, x = gd.bind(null, v), _s(G, x), null) : (v = ne.treeContext, He && (Ja = Kt(G), Lo = x, vs = !0, Cu = null, Tp = !1, v !== null && (Ao[Ac++] = hl, Ao[Ac++] = Lc, Ao[Ac++] = Qi, hl = v.id, Lc = v.overflow, Qi = x)), x = _h(x, B.children), x.flags |= 4096, x);
    }
    function uc(v, x, P) {
      v.lanes |= x;
      var B = v.alternate;
      B !== null && (B.lanes |= x), Xd(v.return, x, P);
    }
    function js(v, x, P, B, G) {
      var ne = v.memoizedState;
      ne === null ? v.memoizedState = { isBackwards: x, rendering: null, renderingStartTime: 0, last: B, tail: P, tailMode: G } : (ne.isBackwards = x, ne.rendering = null, ne.renderingStartTime = 0, ne.last = B, ne.tail = P, ne.tailMode = G);
    }
    function rf(v, x, P) {
      var B = x.pendingProps, G = B.revealOrder, ne = B.tail;
      if (mn(v, x, B.children, P), B = Cs.current, B & 2) B = B & 1 | 2, x.flags |= 128;
      else {
        if (v !== null && v.flags & 128) e: for (v = x.child; v !== null; ) {
          if (v.tag === 13) v.memoizedState !== null && uc(v, P, x);
          else if (v.tag === 19) uc(v, P, x);
          else if (v.child !== null) {
            v.child.return = v, v = v.child;
            continue;
          }
          if (v === x) break e;
          for (; v.sibling === null; ) {
            if (v.return === null || v.return === x) break e;
            v = v.return;
          }
          v.sibling.return = v.return, v = v.sibling;
        }
        B &= 1;
      }
      if (Mr(Cs, B), !(x.mode & 1)) x.memoizedState = null;
      else switch (G) {
        case "forwards":
          for (P = x.child, G = null; P !== null; ) v = P.alternate, v !== null && Eu(v) === null && (G = P), P = P.sibling;
          P = G, P === null ? (G = x.child, x.child = null) : (G = P.sibling, P.sibling = null), js(x, !1, G, P, ne);
          break;
        case "backwards":
          for (P = null, G = x.child, x.child = null; G !== null; ) {
            if (v = G.alternate, v !== null && Eu(v) === null) {
              x.child = G;
              break;
            }
            v = G.sibling, G.sibling = P, P = G, G = v;
          }
          js(x, !0, P, null, ne);
          break;
        case "together":
          js(x, !1, null, null, void 0);
          break;
        default:
          x.memoizedState = null;
      }
      return x.child;
    }
    function Pu(v, x) {
      !(x.mode & 1) && v !== null && (v.alternate = null, x.alternate = null, x.flags |= 2);
    }
    function Wc(v, x, P) {
      if (v !== null && (x.dependencies = v.dependencies), lf |= x.lanes, !(P & x.childLanes)) return null;
      if (v !== null && x.child !== v.child) throw Error(c(153));
      if (x.child !== null) {
        for (v = x.child, P = da(v, v.pendingProps), x.child = P, P.return = x; v.sibling !== null; ) v = v.sibling, P = P.sibling = da(v, v.pendingProps), P.return = x;
        P.sibling = null;
      }
      return x.child;
    }
    function Es(v, x, P) {
      switch (x.tag) {
        case 3:
          Uo(x), wm();
          break;
        case 5:
          Hc(x);
          break;
        case 1:
          fi(x.type) && mh(x);
          break;
        case 4:
          V1(x, x.stateNode.containerInfo);
          break;
        case 10:
          mi(x, x.type._context, x.memoizedProps.value);
          break;
        case 13:
          var B = x.memoizedState;
          if (B !== null)
            return B.dehydrated !== null ? (Mr(Cs, Cs.current & 1), x.flags |= 128, null) : P & x.child.childLanes ? Du(v, x, P) : (Mr(Cs, Cs.current & 1), v = Wc(v, x, P), v !== null ? v.sibling : null);
          Mr(Cs, Cs.current & 1);
          break;
        case 19:
          if (B = (P & x.childLanes) !== 0, v.flags & 128) {
            if (B) return rf(
              v,
              x,
              P
            );
            x.flags |= 128;
          }
          var G = x.memoizedState;
          if (G !== null && (G.rendering = null, G.tail = null, G.lastEffect = null), Mr(Cs, Cs.current), B) break;
          return null;
        case 22:
        case 23:
          return x.lanes = 0, Na(v, x, P);
      }
      return Wc(v, x, P);
    }
    function pi(v) {
      v.flags |= 4;
    }
    function Wn(v, x) {
      if (v !== null && v.child === x.child) return !0;
      if (x.flags & 16) return !1;
      for (v = x.child; v !== null; ) {
        if (v.flags & 12854 || v.subtreeFlags & 12854) return !1;
        v = v.sibling;
      }
      return !0;
    }
    var dc, dd, yl, to;
    if (vt) dc = function(v, x) {
      for (var P = x.child; P !== null; ) {
        if (P.tag === 5 || P.tag === 6) Te(v, P.stateNode);
        else if (P.tag !== 4 && P.child !== null) {
          P.child.return = P, P = P.child;
          continue;
        }
        if (P === x) break;
        for (; P.sibling === null; ) {
          if (P.return === null || P.return === x) return;
          P = P.return;
        }
        P.sibling.return = P.return, P = P.sibling;
      }
    }, dd = function() {
    }, yl = function(v, x, P, B, G) {
      if (v = v.memoizedProps, v !== B) {
        var ne = x.stateNode, be = Bc(zc.current);
        P = Ue(ne, P, v, B, G, be), (x.updateQueue = P) && pi(x);
      }
    }, to = function(v, x, P, B) {
      P !== B && pi(x);
    };
    else if (At) {
      dc = function(v, x, P, B) {
        for (var G = x.child; G !== null; ) {
          if (G.tag === 5) {
            var ne = G.stateNode;
            P && B && (ne = To(ne, G.type, G.memoizedProps, G)), Te(v, ne);
          } else if (G.tag === 6) ne = G.stateNode, P && B && (ne = qi(ne, G.memoizedProps, G)), Te(v, ne);
          else if (G.tag !== 4) {
            if (G.tag === 22 && G.memoizedState !== null) ne = G.child, ne !== null && (ne.return = G), dc(v, G, !0, !0);
            else if (G.child !== null) {
              G.child.return = G, G = G.child;
              continue;
            }
          }
          if (G === x) break;
          for (; G.sibling === null; ) {
            if (G.return === null || G.return === x) return;
            G = G.return;
          }
          G.sibling.return = G.return, G = G.sibling;
        }
      };
      var Vl = function(v, x, P, B) {
        for (var G = x.child; G !== null; ) {
          if (G.tag === 5) {
            var ne = G.stateNode;
            P && B && (ne = To(ne, G.type, G.memoizedProps, G)), Cr(v, ne);
          } else if (G.tag === 6) ne = G.stateNode, P && B && (ne = qi(ne, G.memoizedProps, G)), Cr(v, ne);
          else if (G.tag !== 4) {
            if (G.tag === 22 && G.memoizedState !== null) ne = G.child, ne !== null && (ne.return = G), Vl(v, G, !0, !0);
            else if (G.child !== null) {
              G.child.return = G, G = G.child;
              continue;
            }
          }
          if (G === x) break;
          for (; G.sibling === null; ) {
            if (G.return === null || G.return === x) return;
            G = G.return;
          }
          G.sibling.return = G.return, G = G.sibling;
        }
      };
      dd = function(v, x) {
        var P = x.stateNode;
        if (!Wn(v, x)) {
          v = P.containerInfo;
          var B = Il(v);
          Vl(B, x, !1, !1), P.pendingChildren = B, pi(x), Wi(v, B);
        }
      }, yl = function(v, x, P, B, G) {
        var ne = v.stateNode, be = v.memoizedProps;
        if ((v = Wn(v, x)) && be === B) x.stateNode = ne;
        else {
          var Fe = x.stateNode, Ze = Bc(zc.current), Ft = null;
          be !== B && (Ft = Ue(Fe, P, be, B, G, Ze)), v && Ft === null ? x.stateNode = ne : (ne = _o(ne, Ft, P, be, B, x, v, Fe), Ie(ne, P, B, G, Ze) && pi(x), x.stateNode = ne, v ? pi(x) : dc(ne, x, !1, !1));
        }
      }, to = function(v, x, P, B) {
        P !== B ? (v = Bc(Lf.current), P = Bc(zc.current), x.stateNode = it(B, v, P, x), pi(x)) : x.stateNode = v.stateNode;
      };
    } else dd = function() {
    }, yl = function() {
    }, to = function() {
    };
    function Ps(v, x) {
      if (!vs) switch (v.tailMode) {
        case "hidden":
          x = v.tail;
          for (var P = null; x !== null; ) x.alternate !== null && (P = x), x = x.sibling;
          P === null ? v.tail = null : P.sibling = null;
          break;
        case "collapsed":
          P = v.tail;
          for (var B = null; P !== null; ) P.alternate !== null && (B = P), P = P.sibling;
          B === null ? x || v.tail === null ? v.tail = null : v.tail.sibling = null : B.sibling = null;
      }
    }
    function Ws(v) {
      var x = v.alternate !== null && v.alternate.child === v.child, P = 0, B = 0;
      if (x) for (var G = v.child; G !== null; ) P |= G.lanes | G.childLanes, B |= G.subtreeFlags & 14680064, B |= G.flags & 14680064, G.return = v, G = G.sibling;
      else for (G = v.child; G !== null; ) P |= G.lanes | G.childLanes, B |= G.subtreeFlags, B |= G.flags, G.return = v, G = G.sibling;
      return v.subtreeFlags |= B, v.childLanes = P, x;
    }
    function fc(v, x, P) {
      var B = x.pendingProps;
      switch (Sm(x), x.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return Ws(x), null;
        case 1:
          return fi(x.type) && Ul(), Ws(x), null;
        case 3:
          return P = x.stateNode, Zd(), xr(ec), xr(Po), yo(), P.pendingContext && (P.context = P.pendingContext, P.pendingContext = null), (v === null || v.child === null) && (s0(x) ? pi(x) : v === null || v.memoizedState.isDehydrated && !(x.flags & 256) || (x.flags |= 1024, Cu !== null && (Au(Cu), Cu = null))), dd(v, x), Ws(x), null;
        case 5:
          $1(x), P = Bc(Lf.current);
          var G = x.type;
          if (v !== null && x.stateNode != null) yl(v, x, G, B, P), v.ref !== x.ref && (x.flags |= 512, x.flags |= 2097152);
          else {
            if (!B) {
              if (x.stateNode === null) throw Error(c(166));
              return Ws(x), null;
            }
            if (v = Bc(zc.current), s0(x)) {
              if (!He) throw Error(c(175));
              v = On(x.stateNode, x.type, x.memoizedProps, P, v, x, !Tp), x.updateQueue = v, v !== null && pi(x);
            } else {
              var ne = ve(G, B, P, v, x);
              dc(ne, x, !1, !1), x.stateNode = ne, Ie(ne, G, B, P, v) && pi(x);
            }
            x.ref !== null && (x.flags |= 512, x.flags |= 2097152);
          }
          return Ws(x), null;
        case 6:
          if (v && x.stateNode != null) to(v, x, v.memoizedProps, B);
          else {
            if (typeof B != "string" && x.stateNode === null) throw Error(c(166));
            if (v = Bc(Lf.current), P = Bc(zc.current), s0(x)) {
              if (!He) throw Error(c(176));
              if (v = x.stateNode, P = x.memoizedProps, (B = vr(v, P, x, !Tp)) && (G = Lo, G !== null)) switch (G.tag) {
                case 3:
                  Fn(G.stateNode.containerInfo, v, P, (G.mode & 1) !== 0);
                  break;
                case 5:
                  Gn(G.type, G.memoizedProps, G.stateNode, v, P, (G.mode & 1) !== 0);
              }
              B && pi(x);
            } else x.stateNode = it(B, v, P, x);
          }
          return Ws(x), null;
        case 13:
          if (xr(Cs), B = x.memoizedState, v === null || v.memoizedState !== null && v.memoizedState.dehydrated !== null) {
            if (vs && Ja !== null && x.mode & 1 && !(x.flags & 128)) lx(), wm(), x.flags |= 98560, G = !1;
            else if (G = s0(x), B !== null && B.dehydrated !== null) {
              if (v === null) {
                if (!G) throw Error(c(318));
                if (!He) throw Error(c(344));
                if (G = x.memoizedState, G = G !== null ? G.dehydrated : null, !G) throw Error(c(317));
                Lr(G, x);
              } else wm(), !(x.flags & 128) && (x.memoizedState = null), x.flags |= 4;
              Ws(x), G = !1;
            } else Cu !== null && (Au(Cu), Cu = null), G = !0;
            if (!G) return x.flags & 65536 ? x : null;
          }
          return x.flags & 128 ? (x.lanes = P, x) : (P = B !== null, P !== (v !== null && v.memoizedState !== null) && P && (x.child.flags |= 8192, x.mode & 1 && (v === null || Cs.current & 1 ? Xs === 0 && (Xs = 3) : Lm())), x.updateQueue !== null && (x.flags |= 4), Ws(x), null);
        case 4:
          return Zd(), dd(v, x), v === null && Lt(x.stateNode.containerInfo), Ws(x), null;
        case 10:
          return ac(x.type._context), Ws(x), null;
        case 17:
          return fi(x.type) && Ul(), Ws(x), null;
        case 19:
          if (xr(Cs), G = x.memoizedState, G === null) return Ws(x), null;
          if (B = (x.flags & 128) !== 0, ne = G.rendering, ne === null) if (B) Ps(G, !1);
          else {
            if (Xs !== 0 || v !== null && v.flags & 128) for (v = x.child; v !== null; ) {
              if (ne = Eu(v), ne !== null) {
                for (x.flags |= 128, Ps(G, !1), v = ne.updateQueue, v !== null && (x.updateQueue = v, x.flags |= 4), x.subtreeFlags = 0, v = P, P = x.child; P !== null; ) B = P, G = v, B.flags &= 14680066, ne = B.alternate, ne === null ? (B.childLanes = 0, B.lanes = G, B.child = null, B.subtreeFlags = 0, B.memoizedProps = null, B.memoizedState = null, B.updateQueue = null, B.dependencies = null, B.stateNode = null) : (B.childLanes = ne.childLanes, B.lanes = ne.lanes, B.child = ne.child, B.subtreeFlags = 0, B.deletions = null, B.memoizedProps = ne.memoizedProps, B.memoizedState = ne.memoizedState, B.updateQueue = ne.updateQueue, B.type = ne.type, G = ne.dependencies, B.dependencies = G === null ? null : { lanes: G.lanes, firstContext: G.firstContext }), P = P.sibling;
                return Mr(Cs, Cs.current & 1 | 2), x.child;
              }
              v = v.sibling;
            }
            G.tail !== null && Rs() > Ph && (x.flags |= 128, B = !0, Ps(G, !1), x.lanes = 4194304);
          }
          else {
            if (!B) if (v = Eu(ne), v !== null) {
              if (x.flags |= 128, B = !0, v = v.updateQueue, v !== null && (x.updateQueue = v, x.flags |= 4), Ps(G, !0), G.tail === null && G.tailMode === "hidden" && !ne.alternate && !vs) return Ws(x), null;
            } else 2 * Rs() - G.renderingStartTime > Ph && P !== 1073741824 && (x.flags |= 128, B = !0, Ps(G, !1), x.lanes = 4194304);
            G.isBackwards ? (ne.sibling = x.child, x.child = ne) : (v = G.last, v !== null ? v.sibling = ne : x.child = ne, G.last = ne);
          }
          return G.tail !== null ? (x = G.tail, G.rendering = x, G.tail = x.sibling, G.renderingStartTime = Rs(), x.sibling = null, v = Cs.current, Mr(Cs, B ? v & 1 | 2 : v & 1), x) : (Ws(x), null);
        case 22:
        case 23:
          return yc(), P = x.memoizedState !== null, v !== null && v.memoizedState !== null !== P && (x.flags |= 8192), P && x.mode & 1 ? ro & 1073741824 && (Ws(x), vt && x.subtreeFlags & 6 && (x.flags |= 8192)) : Ws(x), null;
        case 24:
          return null;
        case 25:
          return null;
      }
      throw Error(c(
        156,
        x.tag
      ));
    }
    function Py(v, x) {
      switch (Sm(x), x.tag) {
        case 1:
          return fi(x.type) && Ul(), v = x.flags, v & 65536 ? (x.flags = v & -65537 | 128, x) : null;
        case 3:
          return Zd(), xr(ec), xr(Po), yo(), v = x.flags, v & 65536 && !(v & 128) ? (x.flags = v & -65537 | 128, x) : null;
        case 5:
          return $1(x), null;
        case 13:
          if (xr(Cs), v = x.memoizedState, v !== null && v.dehydrated !== null) {
            if (x.alternate === null) throw Error(c(340));
            wm();
          }
          return v = x.flags, v & 65536 ? (x.flags = v & -65537 | 128, x) : null;
        case 19:
          return xr(Cs), null;
        case 4:
          return Zd(), null;
        case 10:
          return ac(x.type._context), null;
        case 22:
        case 23:
          return yc(), null;
        case 24:
          return null;
        default:
          return null;
      }
    }
    var Hf = !1, vo = !1, mc = typeof WeakSet == "function" ? WeakSet : Set, tn = null;
    function Aa(v, x) {
      var P = v.ref;
      if (P !== null) if (typeof P == "function") try {
        P(null);
      } catch (B) {
        Ir(v, x, B);
      }
      else P.current = null;
    }
    function ii(v, x, P) {
      try {
        P();
      } catch (B) {
        Ir(v, x, B);
      }
    }
    var Rm = !1;
    function Op(v, x) {
      for (ue(v.containerInfo), tn = x; tn !== null; ) if (v = tn, x = v.child, (v.subtreeFlags & 1028) !== 0 && x !== null) x.return = v, tn = x;
      else for (; tn !== null; ) {
        v = tn;
        try {
          var P = v.alternate;
          if (v.flags & 1024) switch (v.tag) {
            case 0:
            case 11:
            case 15:
              break;
            case 1:
              if (P !== null) {
                var B = P.memoizedProps, G = P.memoizedState, ne = v.stateNode, be = ne.getSnapshotBeforeUpdate(v.elementType === v.type ? B : eo(v.type, B), G);
                ne.__reactInternalSnapshotBeforeUpdate = be;
              }
              break;
            case 3:
              vt && hr(v.stateNode.containerInfo);
              break;
            case 5:
            case 6:
            case 4:
            case 17:
              break;
            default:
              throw Error(c(163));
          }
        } catch (Fe) {
          Ir(v, v.return, Fe);
        }
        if (x = v.sibling, x !== null) {
          x.return = v.return, tn = x;
          break;
        }
        tn = v.return;
      }
      return P = Rm, Rm = !1, P;
    }
    function af(v, x, P) {
      var B = x.updateQueue;
      if (B = B !== null ? B.lastEffect : null, B !== null) {
        var G = B = B.next;
        do {
          if ((G.tag & v) === v) {
            var ne = G.destroy;
            G.destroy = void 0, ne !== void 0 && ii(x, P, ne);
          }
          G = G.next;
        } while (G !== B);
      }
    }
    function fd(v, x) {
      if (x = x.updateQueue, x = x !== null ? x.lastEffect : null, x !== null) {
        var P = x = x.next;
        do {
          if ((P.tag & v) === v) {
            var B = P.create;
            P.destroy = B();
          }
          P = P.next;
        } while (P !== x);
      }
    }
    function hc(v) {
      var x = v.ref;
      if (x !== null) {
        var P = v.stateNode;
        switch (v.tag) {
          case 5:
            v = pe(P);
            break;
          default:
            v = P;
        }
        typeof x == "function" ? x(v) : x.current = v;
      }
    }
    function gi(v) {
      var x = v.alternate;
      x !== null && (v.alternate = null, gi(x)), v.child = null, v.deletions = null, v.sibling = null, v.tag === 5 && (x = v.stateNode, x !== null && It(x)), v.stateNode = null, v.return = null, v.dependencies = null, v.memoizedProps = null, v.memoizedState = null, v.pendingProps = null, v.stateNode = null, v.updateQueue = null;
    }
    function Oy(v) {
      return v.tag === 5 || v.tag === 3 || v.tag === 4;
    }
    function Ys(v) {
      e: for (; ; ) {
        for (; v.sibling === null; ) {
          if (v.return === null || Oy(v.return)) return null;
          v = v.return;
        }
        for (v.sibling.return = v.return, v = v.sibling; v.tag !== 5 && v.tag !== 6 && v.tag !== 18; ) {
          if (v.flags & 2 || v.child === null || v.tag === 4) continue e;
          v.child.return = v, v = v.child;
        }
        if (!(v.flags & 2)) return v.stateNode;
      }
    }
    function Q1(v, x, P) {
      var B = v.tag;
      if (B === 5 || B === 6) v = v.stateNode, x ? qt(P, v, x) : ai(P, v);
      else if (B !== 4 && (v = v.child, v !== null)) for (Q1(v, x, P), v = v.sibling; v !== null; ) Q1(v, x, P), v = v.sibling;
    }
    function Th(v, x, P) {
      var B = v.tag;
      if (B === 5 || B === 6) v = v.stateNode, x ? Xt(P, v, x) : _r(P, v);
      else if (B !== 4 && (v = v.child, v !== null)) for (Th(v, x, P), v = v.sibling; v !== null; ) Th(v, x, P), v = v.sibling;
    }
    var qs = null, Ni = !1;
    function md(v, x, P) {
      for (P = P.child; P !== null; ) Ap(v, x, P), P = P.sibling;
    }
    function Ap(v, x, P) {
      if (nc && typeof nc.onCommitFiberUnmount == "function") try {
        nc.onCommitFiberUnmount(vm, P);
      } catch {
      }
      switch (P.tag) {
        case 5:
          vo || Aa(P, x);
        case 6:
          if (vt) {
            var B = qs, G = Ni;
            qs = null, md(v, x, P), qs = B, Ni = G, qs !== null && (Ni ? st(qs, P.stateNode) : In(qs, P.stateNode));
          } else md(v, x, P);
          break;
        case 18:
          vt && qs !== null && (Ni ? ga(qs, P.stateNode) : pa(qs, P.stateNode));
          break;
        case 4:
          vt ? (B = qs, G = Ni, qs = P.stateNode.containerInfo, Ni = !0, md(v, x, P), qs = B, Ni = G) : (At && (B = P.stateNode.containerInfo, G = Il(B), Yi(B, G)), md(v, x, P));
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          if (!vo && (B = P.updateQueue, B !== null && (B = B.lastEffect, B !== null))) {
            G = B = B.next;
            do {
              var ne = G, be = ne.destroy;
              ne = ne.tag, be !== void 0 && (ne & 2 || ne & 4) && ii(P, x, be), G = G.next;
            } while (G !== B);
          }
          md(v, x, P);
          break;
        case 1:
          if (!vo && (Aa(P, x), B = P.stateNode, typeof B.componentWillUnmount == "function")) try {
            B.props = P.memoizedProps, B.state = P.memoizedState, B.componentWillUnmount();
          } catch (Fe) {
            Ir(P, x, Fe);
          }
          md(v, x, P);
          break;
        case 21:
          md(v, x, P);
          break;
        case 22:
          P.mode & 1 ? (vo = (B = vo) || P.memoizedState !== null, md(v, x, P), vo = B) : md(v, x, P);
          break;
        default:
          md(
            v,
            x,
            P
          );
      }
    }
    function Mh(v) {
      var x = v.updateQueue;
      if (x !== null) {
        v.updateQueue = null;
        var P = v.stateNode;
        P === null && (P = v.stateNode = new mc()), x.forEach(function(B) {
          var G = Wf.bind(null, v, B);
          P.has(B) || (P.add(B), B.then(G, G));
        });
      }
    }
    function ns(v, x) {
      var P = x.deletions;
      if (P !== null) for (var B = 0; B < P.length; B++) {
        var G = P[B];
        try {
          var ne = v, be = x;
          if (vt) {
            var Fe = be;
            e: for (; Fe !== null; ) {
              switch (Fe.tag) {
                case 5:
                  qs = Fe.stateNode, Ni = !1;
                  break e;
                case 3:
                  qs = Fe.stateNode.containerInfo, Ni = !0;
                  break e;
                case 4:
                  qs = Fe.stateNode.containerInfo, Ni = !0;
                  break e;
              }
              Fe = Fe.return;
            }
            if (qs === null) throw Error(c(160));
            Ap(ne, be, G), qs = null, Ni = !1;
          } else Ap(ne, be, G);
          var Ze = G.alternate;
          Ze !== null && (Ze.return = null), G.return = null;
        } catch (Ft) {
          Ir(G, x, Ft);
        }
      }
      if (x.subtreeFlags & 12854) for (x = x.child; x !== null; ) Yc(x, v), x = x.sibling;
    }
    function Yc(v, x) {
      var P = v.alternate, B = v.flags;
      switch (v.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          if (ns(x, v), rs(v), B & 4) {
            try {
              af(3, v, v.return), fd(3, v);
            } catch (ct) {
              Ir(v, v.return, ct);
            }
            try {
              af(5, v, v.return);
            } catch (ct) {
              Ir(v, v.return, ct);
            }
          }
          break;
        case 1:
          ns(x, v), rs(v), B & 512 && P !== null && Aa(P, P.return);
          break;
        case 5:
          if (ns(x, v), rs(v), B & 512 && P !== null && Aa(P, P.return), vt) {
            if (v.flags & 32) {
              var G = v.stateNode;
              try {
                lt(G);
              } catch (ct) {
                Ir(v, v.return, ct);
              }
            }
            if (B & 4 && (G = v.stateNode, G != null)) {
              var ne = v.memoizedProps;
              if (P = P !== null ? P.memoizedProps : ne, B = v.type, x = v.updateQueue, v.updateQueue = null, x !== null) try {
                En(G, x, B, P, ne, v);
              } catch (ct) {
                Ir(v, v.return, ct);
              }
            }
          }
          break;
        case 6:
          if (ns(x, v), rs(v), B & 4 && vt) {
            if (v.stateNode === null) throw Error(c(162));
            G = v.stateNode, ne = v.memoizedProps, P = P !== null ? P.memoizedProps : ne;
            try {
              ls(G, P, ne);
            } catch (ct) {
              Ir(v, v.return, ct);
            }
          }
          break;
        case 3:
          if (ns(x, v), rs(v), B & 4) {
            if (vt && He && P !== null && P.memoizedState.isDehydrated) try {
              wr(x.containerInfo);
            } catch (ct) {
              Ir(v, v.return, ct);
            }
            if (At) {
              G = x.containerInfo, ne = x.pendingChildren;
              try {
                Yi(G, ne);
              } catch (ct) {
                Ir(v, v.return, ct);
              }
            }
          }
          break;
        case 4:
          if (ns(
            x,
            v
          ), rs(v), B & 4 && At) {
            ne = v.stateNode, G = ne.containerInfo, ne = ne.pendingChildren;
            try {
              Yi(G, ne);
            } catch (ct) {
              Ir(v, v.return, ct);
            }
          }
          break;
        case 13:
          ns(x, v), rs(v), G = v.child, G.flags & 8192 && (ne = G.memoizedState !== null, G.stateNode.isHidden = ne, !ne || G.alternate !== null && G.alternate.memoizedState !== null || (Fp = Rs())), B & 4 && Mh(v);
          break;
        case 22:
          var be = P !== null && P.memoizedState !== null;
          if (v.mode & 1 ? (vo = (P = vo) || be, ns(x, v), vo = P) : ns(x, v), rs(v), B & 8192) {
            if (P = v.memoizedState !== null, (v.stateNode.isHidden = P) && !be && v.mode & 1) for (tn = v, B = v.child; B !== null; ) {
              for (x = tn = B; tn !== null; ) {
                be = tn;
                var Fe = be.child;
                switch (be.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    af(4, be, be.return);
                    break;
                  case 1:
                    Aa(be, be.return);
                    var Ze = be.stateNode;
                    if (typeof Ze.componentWillUnmount == "function") {
                      var Ft = be, sn = be.return;
                      try {
                        var dr = Ft;
                        Ze.props = dr.memoizedProps, Ze.state = dr.memoizedState, Ze.componentWillUnmount();
                      } catch (ct) {
                        Ir(Ft, sn, ct);
                      }
                    }
                    break;
                  case 5:
                    Aa(be, be.return);
                    break;
                  case 22:
                    if (be.memoizedState !== null) {
                      f0(x);
                      continue;
                    }
                }
                Fe !== null ? (Fe.return = be, tn = Fe) : f0(x);
              }
              B = B.sibling;
            }
            if (vt) {
              e: if (B = null, vt) for (x = v; ; ) {
                if (x.tag === 5) {
                  if (B === null) {
                    B = x;
                    try {
                      G = x.stateNode, P ? Nt(G) : wn(x.stateNode, x.memoizedProps);
                    } catch (ct) {
                      Ir(v, v.return, ct);
                    }
                  }
                } else if (x.tag === 6) {
                  if (B === null) try {
                    ne = x.stateNode, P ? Wt(ne) : pt(ne, x.memoizedProps);
                  } catch (ct) {
                    Ir(v, v.return, ct);
                  }
                } else if ((x.tag !== 22 && x.tag !== 23 || x.memoizedState === null || x === v) && x.child !== null) {
                  x.child.return = x, x = x.child;
                  continue;
                }
                if (x === v) break e;
                for (; x.sibling === null; ) {
                  if (x.return === null || x.return === v) break e;
                  B === x && (B = null), x = x.return;
                }
                B === x && (B = null), x.sibling.return = x.return, x = x.sibling;
              }
            }
          }
          break;
        case 19:
          ns(x, v), rs(v), B & 4 && Mh(v);
          break;
        case 21:
          break;
        default:
          ns(x, v), rs(v);
      }
    }
    function rs(v) {
      var x = v.flags;
      if (x & 2) {
        try {
          if (vt) {
            e: {
              for (var P = v.return; P !== null; ) {
                if (Oy(P)) {
                  var B = P;
                  break e;
                }
                P = P.return;
              }
              throw Error(c(160));
            }
            switch (B.tag) {
              case 5:
                var G = B.stateNode;
                B.flags & 32 && (lt(G), B.flags &= -33);
                var ne = Ys(v);
                Th(v, ne, G);
                break;
              case 3:
              case 4:
                var be = B.stateNode.containerInfo, Fe = Ys(v);
                Q1(v, Fe, be);
                break;
              default:
                throw Error(c(161));
            }
          }
        } catch (Ze) {
          Ir(v, v.return, Ze);
        }
        v.flags &= -3;
      }
      x & 4096 && (v.flags &= -4097);
    }
    function Zt(v, x, P) {
      tn = v, pc(v);
    }
    function pc(v, x, P) {
      for (var B = (v.mode & 1) !== 0; tn !== null; ) {
        var G = tn, ne = G.child;
        if (G.tag === 22 && B) {
          var be = G.memoizedState !== null || Hf;
          if (!be) {
            var Fe = G.alternate, Ze = Fe !== null && Fe.memoizedState !== null || vo;
            Fe = Hf;
            var Ft = vo;
            if (Hf = be, (vo = Ze) && !Ft) for (tn = G; tn !== null; ) be = tn, Ze = be.child, be.tag === 22 && be.memoizedState !== null ? Vf(G) : Ze !== null ? (Ze.return = be, tn = Ze) : Vf(G);
            for (; ne !== null; ) tn = ne, pc(ne), ne = ne.sibling;
            tn = G, Hf = Fe, vo = Ft;
          }
          gc(v);
        } else G.subtreeFlags & 8772 && ne !== null ? (ne.return = G, tn = ne) : gc(v);
      }
    }
    function gc(v) {
      for (; tn !== null; ) {
        var x = tn;
        if (x.flags & 8772) {
          var P = x.alternate;
          try {
            if (x.flags & 8772) switch (x.tag) {
              case 0:
              case 11:
              case 15:
                vo || fd(5, x);
                break;
              case 1:
                var B = x.stateNode;
                if (x.flags & 4 && !vo) if (P === null) B.componentDidMount();
                else {
                  var G = x.elementType === x.type ? P.memoizedProps : eo(x.type, P.memoizedProps);
                  B.componentDidUpdate(G, P.memoizedState, B.__reactInternalSnapshotBeforeUpdate);
                }
                var ne = x.updateQueue;
                ne !== null && Sh(x, ne, B);
                break;
              case 3:
                var be = x.updateQueue;
                if (be !== null) {
                  if (P = null, x.child !== null) switch (x.child.tag) {
                    case 5:
                      P = pe(x.child.stateNode);
                      break;
                    case 1:
                      P = x.child.stateNode;
                  }
                  Sh(x, be, P);
                }
                break;
              case 5:
                var Fe = x.stateNode;
                P === null && x.flags & 4 && Ot(Fe, x.type, x.memoizedProps, x);
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (He && x.memoizedState === null) {
                  var Ze = x.alternate;
                  if (Ze !== null) {
                    var Ft = Ze.memoizedState;
                    if (Ft !== null) {
                      var sn = Ft.dehydrated;
                      sn !== null && Ts(sn);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(c(163));
            }
            vo || x.flags & 512 && hc(x);
          } catch (dr) {
            Ir(x, x.return, dr);
          }
        }
        if (x === v) {
          tn = null;
          break;
        }
        if (P = x.sibling, P !== null) {
          P.return = x.return, tn = P;
          break;
        }
        tn = x.return;
      }
    }
    function f0(v) {
      for (; tn !== null; ) {
        var x = tn;
        if (x === v) {
          tn = null;
          break;
        }
        var P = x.sibling;
        if (P !== null) {
          P.return = x.return, tn = P;
          break;
        }
        tn = x.return;
      }
    }
    function Vf(v) {
      for (; tn !== null; ) {
        var x = tn;
        try {
          switch (x.tag) {
            case 0:
            case 11:
            case 15:
              var P = x.return;
              try {
                fd(4, x);
              } catch (Ze) {
                Ir(x, P, Ze);
              }
              break;
            case 1:
              var B = x.stateNode;
              if (typeof B.componentDidMount == "function") {
                var G = x.return;
                try {
                  B.componentDidMount();
                } catch (Ze) {
                  Ir(x, G, Ze);
                }
              }
              var ne = x.return;
              try {
                hc(x);
              } catch (Ze) {
                Ir(x, ne, Ze);
              }
              break;
            case 5:
              var be = x.return;
              try {
                hc(x);
              } catch (Ze) {
                Ir(x, be, Ze);
              }
          }
        } catch (Ze) {
          Ir(x, x.return, Ze);
        }
        if (x === v) {
          tn = null;
          break;
        }
        var Fe = x.sibling;
        if (Fe !== null) {
          Fe.return = x.return, tn = Fe;
          break;
        }
        tn = x.return;
      }
    }
    var Ks = 0, Yt = 1, no = 2, ya = 3, Z1 = 4;
    if (typeof Symbol == "function" && Symbol.for) {
      var qc = Symbol.for;
      Ks = qc("selector.component"), Yt = qc("selector.has_pseudo_class"), no = qc("selector.role"), ya = qc("selector.test_id"), Z1 = qc("selector.text");
    }
    function sf(v) {
      var x = Pt(v);
      if (x != null) {
        if (typeof x.memoizedProps["data-testname"] != "string") throw Error(c(364));
        return x;
      }
      if (v = tt(v), v === null) throw Error(c(362));
      return v.stateNode.current;
    }
    function Lp(v, x) {
      switch (x.$$typeof) {
        case Ks:
          if (v.type === x.value) return !0;
          break;
        case Yt:
          e: {
            x = x.value, v = [v, 0];
            for (var P = 0; P < v.length; ) {
              var B = v[P++], G = v[P++], ne = x[G];
              if (B.tag !== 5 || !Vt(B)) {
                for (; ne != null && Lp(B, ne); ) G++, ne = x[G];
                if (G === x.length) {
                  x = !0;
                  break e;
                } else for (B = B.child; B !== null; ) v.push(B, G), B = B.sibling;
              }
            }
            x = !1;
          }
          return x;
        case no:
          if (v.tag === 5 && bn(v.stateNode, x.value)) return !0;
          break;
        case Z1:
          if ((v.tag === 5 || v.tag === 6) && (v = ut(v), v !== null && 0 <= v.indexOf(x.value))) return !0;
          break;
        case ya:
          if (v.tag === 5 && (v = v.memoizedProps["data-testname"], typeof v == "string" && v.toLowerCase() === x.value.toLowerCase())) return !0;
          break;
        default:
          throw Error(c(365));
      }
      return !1;
    }
    function Dm(v) {
      switch (v.$$typeof) {
        case Ks:
          return "<" + (K(v.value) || "Unknown") + ">";
        case Yt:
          return ":has(" + (Dm(v) || "") + ")";
        case no:
          return '[role="' + v.value + '"]';
        case Z1:
          return '"' + v.value + '"';
        case ya:
          return '[data-testname="' + v.value + '"]';
        default:
          throw Error(c(365));
      }
    }
    function ja(v, x) {
      var P = [];
      v = [v, 0];
      for (var B = 0; B < v.length; ) {
        var G = v[B++], ne = v[B++], be = x[ne];
        if (G.tag !== 5 || !Vt(G)) {
          for (; be != null && Lp(G, be); ) ne++, be = x[ne];
          if (ne === x.length) P.push(G);
          else for (G = G.child; G !== null; ) v.push(G, ne), G = G.sibling;
        }
      }
      return P;
    }
    function of(v, x) {
      if (!Pe) throw Error(c(363));
      v = sf(v), v = ja(v, x), x = [], v = Array.from(v);
      for (var P = 0; P < v.length; ) {
        var B = v[P++];
        if (B.tag === 5) Vt(B) || x.push(B.stateNode);
        else for (B = B.child; B !== null; ) v.push(B), B = B.sibling;
      }
      return x;
    }
    var m0 = Math.ceil, J1 = u.ReactCurrentDispatcher, Rh = u.ReactCurrentOwner, ks = u.ReactCurrentBatchConfig, br = 0, cs = null, Os = null, ji = 0, ro = 0, Pm = Ms(0), Xs = 0, Dh = null, lf = 0, bs = 0, Ip = 0, Om = null, vl = null, Fp = 0, Ph = 1 / 0, Sn = null;
    function Mn() {
      Ph = Rs() + 500;
    }
    var ar = !1, $r = null, Fi = null, hd = !1, Ou = null, xl = 0, us = 0, $f = null, St = -1, Qs = 0;
    function hn() {
      return br & 6 ? Rs() : St !== -1 ? St : St = Rs();
    }
    function As(v) {
      return v.mode & 1 ? br & 2 && ji !== 0 ? ji & -ji : cx.transition !== null ? (Qs === 0 && (Qs = Nr()), Qs) : (v = la, v !== 0 ? v : er()) : 1;
    }
    function va(v, x, P, B) {
      if (50 < us) throw us = 0, $f = null, Error(c(185));
      Za(v, P, B), (!(br & 2) || v !== cs) && (v === cs && (!(br & 2) && (bs |= P), Xs === 4 && yi(v, ji)), oi(v, B), P === 1 && br === 0 && !(x.mode & 1) && (Mn(), gh && Xi()));
    }
    function oi(v, x) {
      var P = v.callbackNode;
      rx(v, x);
      var B = hh(v, v === cs ? ji : 0);
      if (B === 0) P !== null && ax(P), v.callbackNode = null, v.callbackPriority = 0;
      else if (x = B & -B, v.callbackPriority !== x) {
        if (P != null && ax(P), x === 1) v.tag === 0 ? My(bl.bind(null, v)) : I1(bl.bind(null, v)), ye ? ke(function() {
          !(br & 6) && Xi();
        }) : Va(r0, Xi), P = null;
        else {
          switch (Vs(B)) {
            case 1:
              P = r0;
              break;
            case 4:
              P = Ep;
              break;
            case 16:
              P = L1;
              break;
            case 536870912:
              P = sx;
              break;
            default:
              P = L1;
          }
          P = rg(P, xo.bind(null, v));
        }
        v.callbackPriority = x, v.callbackNode = P;
      }
    }
    function xo(v, x) {
      if (St = -1, Qs = 0, br & 6) throw Error(c(327));
      var P = v.callbackNode;
      if (Iu() && v.callbackNode !== P) return null;
      var B = hh(v, v === cs ? ji : 0);
      if (B === 0) return null;
      if (B & 30 || B & v.expiredLanes || x) x = $l(v, B);
      else {
        x = B;
        var G = br;
        br |= 2;
        var ne = eg();
        (cs !== v || ji !== x) && (Sn = null, Mn(), bo(v, x));
        do
          try {
            Oh();
            break;
          } catch (Fe) {
            Am(v, Fe);
          }
        while (!0);
        zl(), J1.current = ne, br = G, Os !== null ? x = 0 : (cs = null, ji = 0, x = Xs);
      }
      if (x !== 0) {
        if (x === 2 && (G = A1(v), G !== 0 && (B = G, x = Kc(v, G))), x === 1) throw P = Dh, bo(v, 0), yi(v, B), oi(v, Rs()), P;
        if (x === 6) yi(v, B);
        else {
          if (G = v.current.alternate, !(B & 30) && !Gf(G) && (x = $l(v, B), x === 2 && (ne = A1(v), ne !== 0 && (B = ne, x = Kc(v, ne))), x === 1)) throw P = Dh, bo(v, 0), yi(v, B), oi(v, Rs()), P;
          switch (v.finishedWork = G, v.finishedLanes = B, x) {
            case 0:
            case 1:
              throw Error(c(345));
            case 2:
              Lu(v, vl, Sn);
              break;
            case 3:
              if (yi(v, B), (B & 130023424) === B && (x = Fp + 500 - Rs(), 10 < x)) {
                if (hh(v, 0) !== 0) break;
                if (G = v.suspendedLanes, (G & B) !== B) {
                  hn(), v.pingedLanes |= v.suspendedLanes & G;
                  break;
                }
                v.timeoutHandle = Ne(Lu.bind(null, v, vl, Sn), x);
                break;
              }
              Lu(v, vl, Sn);
              break;
            case 4:
              if (yi(v, B), (B & 4194240) === B) break;
              for (x = v.eventTimes, G = -1; 0 < B; ) {
                var be = 31 - Oc(B);
                ne = 1 << be, be = x[be], be > G && (G = be), B &= ~ne;
              }
              if (B = G, B = Rs() - B, B = (120 > B ? 120 : 480 > B ? 480 : 1080 > B ? 1080 : 1920 > B ? 1920 : 3e3 > B ? 3e3 : 4320 > B ? 4320 : 1960 * m0(B / 1960)) - B, 10 < B) {
                v.timeoutHandle = Ne(Lu.bind(null, v, vl, Sn), B);
                break;
              }
              Lu(v, vl, Sn);
              break;
            case 5:
              Lu(v, vl, Sn);
              break;
            default:
              throw Error(c(329));
          }
        }
      }
      return oi(v, Rs()), v.callbackNode === P ? xo.bind(null, v) : null;
    }
    function Kc(v, x) {
      var P = Om;
      return v.current.memoizedState.isDehydrated && (bo(v, x).flags |= 256), v = $l(v, x), v !== 2 && (x = vl, vl = P, x !== null && Au(x)), v;
    }
    function Au(v) {
      vl === null ? vl = v : vl.push.apply(vl, v);
    }
    function Gf(v) {
      for (var x = v; ; ) {
        if (x.flags & 16384) {
          var P = x.updateQueue;
          if (P !== null && (P = P.stores, P !== null)) for (var B = 0; B < P.length; B++) {
            var G = P[B], ne = G.getSnapshot;
            G = G.value;
            try {
              if (!Su(ne(), G)) return !1;
            } catch {
              return !1;
            }
          }
        }
        if (P = x.child, x.subtreeFlags & 16384 && P !== null) P.return = x, x = P;
        else {
          if (x === v) break;
          for (; x.sibling === null; ) {
            if (x.return === null || x.return === v) return !0;
            x = x.return;
          }
          x.sibling.return = x.return, x = x.sibling;
        }
      }
      return !0;
    }
    function yi(v, x) {
      for (x &= ~Ip, x &= ~bs, v.suspendedLanes |= x, v.pingedLanes &= ~x, v = v.expirationTimes; 0 < x; ) {
        var P = 31 - Oc(x), B = 1 << P;
        v[P] = -1, x &= ~B;
      }
    }
    function bl(v) {
      if (br & 6) throw Error(c(327));
      Iu();
      var x = hh(v, 0);
      if (!(x & 1)) return oi(v, Rs()), null;
      var P = $l(v, x);
      if (v.tag !== 0 && P === 2) {
        var B = A1(v);
        B !== 0 && (x = B, P = Kc(v, B));
      }
      if (P === 1) throw P = Dh, bo(v, 0), yi(v, x), oi(v, Rs()), P;
      if (P === 6) throw Error(c(345));
      return v.finishedWork = v.current.alternate, v.finishedLanes = x, Lu(v, vl, Sn), oi(v, Rs()), null;
    }
    function pd(v) {
      Ou !== null && Ou.tag === 0 && !(br & 6) && Iu();
      var x = br;
      br |= 1;
      var P = ks.transition, B = la;
      try {
        if (ks.transition = null, la = 1, v) return v();
      } finally {
        la = B, ks.transition = P, br = x, !(br & 6) && Xi();
      }
    }
    function yc() {
      ro = Pm.current, xr(Pm);
    }
    function bo(v, x) {
      v.finishedWork = null, v.finishedLanes = 0;
      var P = v.timeoutHandle;
      if (P !== xt && (v.timeoutHandle = xt, Xe(P)), Os !== null) for (P = Os.return; P !== null; ) {
        var B = P;
        switch (Sm(B), B.tag) {
          case 1:
            B = B.type.childContextTypes, B != null && Ul();
            break;
          case 3:
            Zd(), xr(ec), xr(Po), yo();
            break;
          case 5:
            $1(B);
            break;
          case 4:
            Zd();
            break;
          case 13:
            xr(Cs);
            break;
          case 19:
            xr(Cs);
            break;
          case 10:
            ac(B.type._context);
            break;
          case 22:
          case 23:
            yc();
        }
        P = P.return;
      }
      if (cs = v, Os = v = da(v.current, null), ji = ro = x, Xs = 0, Dh = null, Ip = bs = lf = 0, vl = Om = null, Ic !== null) {
        for (x = 0; x < Ic.length; x++) if (P = Ic[x], B = P.interleaved, B !== null) {
          P.interleaved = null;
          var G = B.next, ne = P.pending;
          if (ne !== null) {
            var be = ne.next;
            ne.next = G, B.next = be;
          }
          P.pending = B;
        }
        Ic = null;
      }
      return v;
    }
    function Am(v, x) {
      do {
        var P = Os;
        try {
          if (zl(), Pa.current = zf, Fo) {
            for (var B = wa.memoizedState; B !== null; ) {
              var G = B.queue;
              G !== null && (G.pending = null), B = B.next;
            }
            Fo = !1;
          }
          if (Ii = 0, si = es = wa = null, Ff = !1, sd = 0, Rh.current = null, P === null || P.return === null) {
            Xs = 1, Dh = x, Os = null;
            break;
          }
          e: {
            var ne = v, be = P.return, Fe = P, Ze = x;
            if (x = ji, Fe.flags |= 32768, Ze !== null && typeof Ze == "object" && typeof Ze.then == "function") {
              var Ft = Ze, sn = Fe, dr = sn.tag;
              if (!(sn.mode & 1) && (dr === 0 || dr === 11 || dr === 15)) {
                var ct = sn.alternate;
                ct ? (sn.updateQueue = ct.updateQueue, sn.memoizedState = ct.memoizedState, sn.lanes = ct.lanes) : (sn.updateQueue = null, sn.memoizedState = null);
              }
              var xa = gl(be);
              if (xa !== null) {
                xa.flags &= -257, $c(xa, be, Fe, ne, x), xa.mode & 1 && Tm(ne, Ft, x), x = xa, Ze = Ft;
                var Ga = x.updateQueue;
                if (Ga === null) {
                  var bc = /* @__PURE__ */ new Set();
                  bc.add(Ze), x.updateQueue = bc;
                } else Ga.add(Ze);
                break e;
              } else {
                if (!(x & 1)) {
                  Tm(ne, Ft, x), Lm();
                  break e;
                }
                Ze = Error(c(426));
              }
            } else if (vs && Fe.mode & 1) {
              var Zs = gl(be);
              if (Zs !== null) {
                !(Zs.flags & 65536) && (Zs.flags |= 256), $c(Zs, be, Fe, ne, x), U1(Tu(Ze, Fe));
                break e;
              }
            }
            ne = Ze = Tu(Ze, Fe), Xs !== 4 && (Xs = 2), Om === null ? Om = [ne] : Om.push(ne), ne = be;
            do {
              switch (ne.tag) {
                case 3:
                  ne.flags |= 65536, x &= -x, ne.lanes |= x;
                  var Be = ud(ne, Ze, x);
                  Mp(ne, Be);
                  break e;
                case 1:
                  Fe = Ze;
                  var ze = ne.type, rt = ne.stateNode;
                  if (!(ne.flags & 128) && (typeof ze.getDerivedStateFromError == "function" || rt !== null && typeof rt.componentDidCatch == "function" && (Fi === null || !Fi.has(rt)))) {
                    ne.flags |= 65536, x &= -x, ne.lanes |= x;
                    var Jt = _m(ne, Fe, x);
                    Mp(ne, Jt);
                    break e;
                  }
              }
              ne = ne.return;
            } while (ne !== null);
          }
          ng(P);
        } catch (Yn) {
          x = Yn, Os === P && P !== null && (Os = P = P.return);
          continue;
        }
        break;
      } while (!0);
    }
    function eg() {
      var v = J1.current;
      return J1.current = zf, v === null ? zf : v;
    }
    function Lm() {
      (Xs === 0 || Xs === 3 || Xs === 2) && (Xs = 4), cs === null || !(lf & 268435455) && !(bs & 268435455) || yi(cs, ji);
    }
    function $l(v, x) {
      var P = br;
      br |= 2;
      var B = eg();
      (cs !== v || ji !== x) && (Sn = null, bo(v, x));
      do
        try {
          tg();
          break;
        } catch (G) {
          Am(v, G);
        }
      while (!0);
      if (zl(), br = P, J1.current = B, Os !== null) throw Error(c(261));
      return cs = null, ji = 0, Xs;
    }
    function tg() {
      for (; Os !== null; ) Im(Os);
    }
    function Oh() {
      for (; Os !== null && !ed(); ) Im(Os);
    }
    function Im(v) {
      var x = Up(v.alternate, v, ro);
      v.memoizedProps = v.pendingProps, x === null ? ng(v) : Os = x, Rh.current = null;
    }
    function ng(v) {
      var x = v;
      do {
        var P = x.alternate;
        if (v = x.return, x.flags & 32768) {
          if (P = Py(P, x), P !== null) {
            P.flags &= 32767, Os = P;
            return;
          }
          if (v !== null) v.flags |= 32768, v.subtreeFlags = 0, v.deletions = null;
          else {
            Xs = 6, Os = null;
            return;
          }
        } else if (P = fc(P, x, ro), P !== null) {
          Os = P;
          return;
        }
        if (x = x.sibling, x !== null) {
          Os = x;
          return;
        }
        Os = x = v;
      } while (x !== null);
      Xs === 0 && (Xs = 5);
    }
    function Lu(v, x, P) {
      var B = la, G = ks.transition;
      try {
        ks.transition = null, la = 1, h0(v, x, P, B);
      } finally {
        ks.transition = G, la = B;
      }
      return null;
    }
    function h0(v, x, P, B) {
      do
        Iu();
      while (Ou !== null);
      if (br & 6) throw Error(c(327));
      P = v.finishedWork;
      var G = v.finishedLanes;
      if (P === null) return null;
      if (v.finishedWork = null, v.finishedLanes = 0, P === v.current) throw Error(c(177));
      v.callbackNode = null, v.callbackPriority = 0;
      var ne = P.lanes | P.childLanes;
      if (bu(v, ne), v === cs && (Os = cs = null, ji = 0), !(P.subtreeFlags & 2064) && !(P.flags & 2064) || hd || (hd = !0, rg(L1, function() {
        return Iu(), null;
      })), ne = (P.flags & 15990) !== 0, P.subtreeFlags & 15990 || ne) {
        ne = ks.transition, ks.transition = null;
        var be = la;
        la = 1;
        var Fe = br;
        br |= 4, Rh.current = null, Op(v, P), Yc(P, v), he(v.containerInfo), v.current = P, Zt(P), ml(), br = Fe, la = be, ks.transition = ne;
      } else v.current = P;
      if (hd && (hd = !1, Ou = v, xl = G), ne = v.pendingLanes, ne === 0 && (Fi = null), kp(P.stateNode), oi(v, Rs()), x !== null) for (B = v.onRecoverableError, P = 0; P < x.length; P++) G = x[P], B(G.value, { componentStack: G.stack, digest: G.digest });
      if (ar) throw ar = !1, v = $r, $r = null, v;
      return xl & 1 && v.tag !== 0 && Iu(), ne = v.pendingLanes, ne & 1 ? v === $f ? us++ : (us = 0, $f = v) : us = 0, Xi(), null;
    }
    function Iu() {
      if (Ou !== null) {
        var v = Vs(xl), x = ks.transition, P = la;
        try {
          if (ks.transition = null, la = 16 > v ? 16 : v, Ou === null) var B = !1;
          else {
            if (v = Ou, Ou = null, xl = 0, br & 6) throw Error(c(331));
            var G = br;
            for (br |= 4, tn = v.current; tn !== null; ) {
              var ne = tn, be = ne.child;
              if (tn.flags & 16) {
                var Fe = ne.deletions;
                if (Fe !== null) {
                  for (var Ze = 0; Ze < Fe.length; Ze++) {
                    var Ft = Fe[Ze];
                    for (tn = Ft; tn !== null; ) {
                      var sn = tn;
                      switch (sn.tag) {
                        case 0:
                        case 11:
                        case 15:
                          af(8, sn, ne);
                      }
                      var dr = sn.child;
                      if (dr !== null) dr.return = sn, tn = dr;
                      else for (; tn !== null; ) {
                        sn = tn;
                        var ct = sn.sibling, xa = sn.return;
                        if (gi(sn), sn === Ft) {
                          tn = null;
                          break;
                        }
                        if (ct !== null) {
                          ct.return = xa, tn = ct;
                          break;
                        }
                        tn = xa;
                      }
                    }
                  }
                  var Ga = ne.alternate;
                  if (Ga !== null) {
                    var bc = Ga.child;
                    if (bc !== null) {
                      Ga.child = null;
                      do {
                        var Zs = bc.sibling;
                        bc.sibling = null, bc = Zs;
                      } while (bc !== null);
                    }
                  }
                  tn = ne;
                }
              }
              if (ne.subtreeFlags & 2064 && be !== null) be.return = ne, tn = be;
              else e: for (; tn !== null; ) {
                if (ne = tn, ne.flags & 2048) switch (ne.tag) {
                  case 0:
                  case 11:
                  case 15:
                    af(9, ne, ne.return);
                }
                var Be = ne.sibling;
                if (Be !== null) {
                  Be.return = ne.return, tn = Be;
                  break e;
                }
                tn = ne.return;
              }
            }
            var ze = v.current;
            for (tn = ze; tn !== null; ) {
              be = tn;
              var rt = be.child;
              if (be.subtreeFlags & 2064 && rt !== null) rt.return = be, tn = rt;
              else e: for (be = ze; tn !== null; ) {
                if (Fe = tn, Fe.flags & 2048) try {
                  switch (Fe.tag) {
                    case 0:
                    case 11:
                    case 15:
                      fd(9, Fe);
                  }
                } catch (Yn) {
                  Ir(Fe, Fe.return, Yn);
                }
                if (Fe === be) {
                  tn = null;
                  break e;
                }
                var Jt = Fe.sibling;
                if (Jt !== null) {
                  Jt.return = Fe.return, tn = Jt;
                  break e;
                }
                tn = Fe.return;
              }
            }
            if (br = G, Xi(), nc && typeof nc.onPostCommitFiberRoot == "function") try {
              nc.onPostCommitFiberRoot(vm, v);
            } catch {
            }
            B = !0;
          }
          return B;
        } finally {
          la = P, ks.transition = x;
        }
      }
      return !1;
    }
    function vc(v, x, P) {
      x = Tu(P, x), x = ud(v, x, 1), v = nd(v, x, 1), x = hn(), v !== null && (Za(v, 1, x), oi(v, x));
    }
    function Ir(v, x, P) {
      if (v.tag === 3) vc(v, v, P);
      else for (; x !== null; ) {
        if (x.tag === 3) {
          vc(x, v, P);
          break;
        } else if (x.tag === 1) {
          var B = x.stateNode;
          if (typeof x.type.getDerivedStateFromError == "function" || typeof B.componentDidCatch == "function" && (Fi === null || !Fi.has(B))) {
            v = Tu(P, v), v = _m(x, v, 1), x = nd(x, v, 1), v = hn(), x !== null && (Za(x, 1, v), oi(x, v));
            break;
          }
        }
        x = x.return;
      }
    }
    function Gl(v, x, P) {
      var B = v.pingCache;
      B !== null && B.delete(x), x = hn(), v.pingedLanes |= v.suspendedLanes & P, cs === v && (ji & P) === P && (Xs === 4 || Xs === 3 && (ji & 130023424) === ji && 500 > Rs() - Fp ? bo(v, 0) : Ip |= P), oi(v, x);
    }
    function xc(v, x) {
      x === 0 && (v.mode & 1 ? (x = Df, Df <<= 1, !(Df & 130023424) && (Df = 4194304)) : x = 1);
      var P = hn();
      v = Fc(v, x), v !== null && (Za(v, x, P), oi(v, P));
    }
    function gd(v) {
      var x = v.memoizedState, P = 0;
      x !== null && (P = x.retryLane), xc(v, P);
    }
    function Wf(v, x) {
      var P = 0;
      switch (v.tag) {
        case 13:
          var B = v.stateNode, G = v.memoizedState;
          G !== null && (P = G.retryLane);
          break;
        case 19:
          B = v.stateNode;
          break;
        default:
          throw Error(c(314));
      }
      B !== null && B.delete(x), xc(v, P);
    }
    var Up;
    Up = function(v, x, P) {
      if (v !== null) if (v.memoizedProps !== x.pendingProps || ec.current) hi = !0;
      else {
        if (!(v.lanes & P) && !(x.flags & 128)) return hi = !1, Es(v, x, P);
        hi = !!(v.flags & 131072);
      }
      else hi = !1, vs && x.flags & 1048576 && Ry(x, Kd, x.index);
      switch (x.lanes = 0, x.tag) {
        case 2:
          var B = x.type;
          Pu(v, x), v = x.pendingProps;
          var G = Ju(x, Po.current);
          Qd(x, P), G = wh(null, x, B, v, G, P);
          var ne = G1();
          return x.flags |= 1, typeof G == "object" && G !== null && typeof G.render == "function" && G.$$typeof === void 0 ? (x.tag = 1, x.memoizedState = null, x.updateQueue = null, fi(B) ? (ne = !0, mh(x)) : ne = !1, x.memoizedState = G.state !== null && G.state !== void 0 ? G.state : null, H1(x), G.updater = km, x.stateNode = G, G._reactInternals = x, Hl(x, B, v, P), x = Gs(null, x, B, !0, ne, P)) : (x.tag = 0, vs && ne && _p(x), mn(null, x, G, P), x = x.child), x;
        case 16:
          B = x.elementType;
          e: {
            switch (Pu(v, x), v = x.pendingProps, G = B._init, B = G(B._payload), x.type = B, G = x.tag = mx(B), v = eo(B, v), G) {
              case 0:
                x = Ru(null, x, B, v, P);
                break e;
              case 1:
                x = or(null, x, B, v, P);
                break e;
              case 11:
                x = Gc(null, x, B, v, P);
                break e;
              case 14:
                x = ts(null, x, B, eo(B.type, v), P);
                break e;
            }
            throw Error(c(
              306,
              B,
              ""
            ));
          }
          return x;
        case 0:
          return B = x.type, G = x.pendingProps, G = x.elementType === B ? G : eo(B, G), Ru(v, x, B, G, P);
        case 1:
          return B = x.type, G = x.pendingProps, G = x.elementType === B ? G : eo(B, G), or(v, x, B, G, P);
        case 3:
          e: {
            if (Uo(x), v === null) throw Error(c(387));
            B = x.pendingProps, ne = x.memoizedState, G = ne.element, u0(v, x), rd(x, B, null, P);
            var be = x.memoizedState;
            if (B = be.element, He && ne.isDehydrated) if (ne = { element: B, isDehydrated: !1, cache: be.cache, pendingSuspenseBoundaries: be.pendingSuspenseBoundaries, transitions: be.transitions }, x.updateQueue.baseState = ne, x.memoizedState = ne, x.flags & 256) {
              G = Tu(Error(c(423)), x), x = lc(v, x, B, P, G);
              break e;
            } else if (B !== G) {
              G = Tu(Error(c(424)), x), x = lc(v, x, B, P, G);
              break e;
            } else for (He && (Ja = _t(x.stateNode.containerInfo), Lo = x, vs = !0, Cu = null, Tp = !1), P = o0(x, null, B, P), x.child = P; P; ) P.flags = P.flags & -3 | 4096, P = P.sibling;
            else {
              if (wm(), B === G) {
                x = Wc(v, x, P);
                break e;
              }
              mn(v, x, B, P);
            }
            x = x.child;
          }
          return x;
        case 5:
          return Hc(x), v === null && a0(x), B = x.type, G = x.pendingProps, ne = v !== null ? v.memoizedProps : null, be = G.children, qe(B, G) ? be = null : ne !== null && qe(B, ne) && (x.flags |= 32), Oa(v, x), mn(v, x, be, P), x.child;
        case 6:
          return v === null && a0(x), null;
        case 13:
          return Du(v, x, P);
        case 4:
          return V1(x, x.stateNode.containerInfo), B = x.pendingProps, v === null ? x.child = Of(x, null, B, P) : mn(v, x, B, P), x.child;
        case 11:
          return B = x.type, G = x.pendingProps, G = x.elementType === B ? G : eo(B, G), Gc(v, x, B, G, P);
        case 7:
          return mn(v, x, x.pendingProps, P), x.child;
        case 8:
          return mn(v, x, x.pendingProps.children, P), x.child;
        case 12:
          return mn(v, x, x.pendingProps.children, P), x.child;
        case 10:
          e: {
            if (B = x.type._context, G = x.pendingProps, ne = x.memoizedProps, be = G.value, mi(x, B, be), ne !== null) if (Su(ne.value, be)) {
              if (ne.children === G.children && !ec.current) {
                x = Wc(v, x, P);
                break e;
              }
            } else for (ne = x.child, ne !== null && (ne.return = x); ne !== null; ) {
              var Fe = ne.dependencies;
              if (Fe !== null) {
                be = ne.child;
                for (var Ze = Fe.firstContext; Ze !== null; ) {
                  if (Ze.context === B) {
                    if (ne.tag === 1) {
                      Ze = Io(-1, P & -P), Ze.tag = 2;
                      var Ft = ne.updateQueue;
                      if (Ft !== null) {
                        Ft = Ft.shared;
                        var sn = Ft.pending;
                        sn === null ? Ze.next = Ze : (Ze.next = sn.next, sn.next = Ze), Ft.pending = Ze;
                      }
                    }
                    ne.lanes |= P, Ze = ne.alternate, Ze !== null && (Ze.lanes |= P), Xd(ne.return, P, x), Fe.lanes |= P;
                    break;
                  }
                  Ze = Ze.next;
                }
              } else if (ne.tag === 10) be = ne.type === x.type ? null : ne.child;
              else if (ne.tag === 18) {
                if (be = ne.return, be === null) throw Error(c(341));
                be.lanes |= P, Fe = be.alternate, Fe !== null && (Fe.lanes |= P), Xd(be, P, x), be = ne.sibling;
              } else be = ne.child;
              if (be !== null) be.return = ne;
              else for (be = ne; be !== null; ) {
                if (be === x) {
                  be = null;
                  break;
                }
                if (ne = be.sibling, ne !== null) {
                  ne.return = be.return, be = ne;
                  break;
                }
                be = be.return;
              }
              ne = be;
            }
            mn(v, x, G.children, P), x = x.child;
          }
          return x;
        case 9:
          return G = x.type, B = x.pendingProps.children, Qd(x, P), G = sc(G), B = B(G), x.flags |= 1, mn(v, x, B, P), x.child;
        case 14:
          return B = x.type, G = eo(B, x.pendingProps), G = eo(B.type, G), ts(v, x, B, G, P);
        case 15:
          return Dr(v, x, x.type, x.pendingProps, P);
        case 17:
          return B = x.type, G = x.pendingProps, G = x.elementType === B ? G : eo(B, G), Pu(v, x), x.tag = 1, fi(B) ? (v = !0, mh(x)) : v = !1, Qd(x, P), kh(x, B, G), Hl(x, B, G, P), Gs(null, x, B, !0, v, P);
        case 19:
          return rf(v, x, P);
        case 22:
          return Na(v, x, P);
      }
      throw Error(c(156, x.tag));
    };
    function rg(v, x) {
      return Va(v, x);
    }
    function zp(v, x, P, B) {
      this.tag = v, this.key = P, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = x, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = B, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
    }
    function ao(v, x, P, B) {
      return new zp(v, x, P, B);
    }
    function So(v) {
      return v = v.prototype, !(!v || !v.isReactComponent);
    }
    function mx(v) {
      if (typeof v == "function") return So(v) ? 1 : 0;
      if (v != null) {
        if (v = v.$$typeof, v === T) return 11;
        if (v === I) return 14;
      }
      return 2;
    }
    function da(v, x) {
      var P = v.alternate;
      return P === null ? (P = ao(v.tag, x, v.key, v.mode), P.elementType = v.elementType, P.type = v.type, P.stateNode = v.stateNode, P.alternate = v, v.alternate = P) : (P.pendingProps = x, P.type = v.type, P.flags = 0, P.subtreeFlags = 0, P.deletions = null), P.flags = v.flags & 14680064, P.childLanes = v.childLanes, P.lanes = v.lanes, P.child = v.child, P.memoizedProps = v.memoizedProps, P.memoizedState = v.memoizedState, P.updateQueue = v.updateQueue, x = v.dependencies, P.dependencies = x === null ? null : { lanes: x.lanes, firstContext: x.firstContext }, P.sibling = v.sibling, P.index = v.index, P.ref = v.ref, P;
    }
    function Yf(v, x, P, B, G, ne) {
      var be = 2;
      if (B = v, typeof v == "function") So(v) && (be = 1);
      else if (typeof v == "string") be = 5;
      else e: switch (v) {
        case b:
          return Ei(P.children, G, ne, x);
        case w:
          be = 8, G |= 8;
          break;
        case k:
          return v = ao(12, P, x, G | 2), v.elementType = k, v.lanes = ne, v;
        case D:
          return v = ao(13, P, x, G), v.elementType = D, v.lanes = ne, v;
        case L:
          return v = ao(19, P, x, G), v.elementType = L, v.lanes = ne, v;
        case U:
          return yd(P, G, ne, x);
        default:
          if (typeof v == "object" && v !== null) switch (v.$$typeof) {
            case j:
              be = 10;
              break e;
            case E:
              be = 9;
              break e;
            case T:
              be = 11;
              break e;
            case I:
              be = 14;
              break e;
            case R:
              be = 16, B = null;
              break e;
          }
          throw Error(c(130, v == null ? v : typeof v, ""));
      }
      return x = ao(be, P, x, G), x.elementType = v, x.type = B, x.lanes = ne, x;
    }
    function Ei(v, x, P, B) {
      return v = ao(7, v, B, x), v.lanes = P, v;
    }
    function yd(v, x, P, B) {
      return v = ao(22, v, B, x), v.elementType = U, v.lanes = P, v.stateNode = { isHidden: !1 }, v;
    }
    function vd(v, x, P) {
      return v = ao(6, v, null, x), v.lanes = P, v;
    }
    function Bp(v, x, P) {
      return x = ao(4, v.children !== null ? v.children : [], v.key, x), x.lanes = P, x.stateNode = { containerInfo: v.containerInfo, pendingChildren: null, implementation: v.implementation }, x;
    }
    function p0(v, x, P, B, G) {
      this.tag = x, this.containerInfo = v, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = xt, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = ph(0), this.expirationTimes = ph(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ph(0), this.identifierPrefix = B, this.onRecoverableError = G, He && (this.mutableSourceEagerHydrationData = null);
    }
    function Ay(v, x, P, B, G, ne, be, Fe, Ze) {
      return v = new p0(v, x, P, Fe, Ze), x === 1 ? (x = 1, ne === !0 && (x |= 8)) : x = 0, ne = ao(3, null, null, x), v.current = ne, ne.stateNode = v, ne.memoizedState = { element: B, isDehydrated: P, cache: null, transitions: null, pendingSuspenseBoundaries: null }, H1(ne), v;
    }
    function g0(v) {
      if (!v) return xu;
      v = v._reactInternals;
      e: {
        if (Q(v) !== v || v.tag !== 1) throw Error(c(170));
        var x = v;
        do {
          switch (x.tag) {
            case 3:
              x = x.stateNode.context;
              break e;
            case 1:
              if (fi(x.type)) {
                x = x.stateNode.__reactInternalMemoizedMergedChildContext;
                break e;
              }
          }
          x = x.return;
        } while (x !== null);
        throw Error(c(171));
      }
      if (v.tag === 1) {
        var P = v.type;
        if (fi(P)) return fh(v, P, x);
      }
      return x;
    }
    function qf(v) {
      var x = v._reactInternals;
      if (x === void 0)
        throw typeof v.render == "function" ? Error(c(188)) : (v = Object.keys(v).join(","), Error(c(268, v)));
      return v = se(x), v === null ? null : v.stateNode;
    }
    function y0(v, x) {
      if (v = v.memoizedState, v !== null && v.dehydrated !== null) {
        var P = v.retryLane;
        v.retryLane = P !== 0 && P < x ? P : x;
      }
    }
    function Kf(v, x) {
      y0(v, x), (v = v.alternate) && y0(v, x);
    }
    function ag(v) {
      return v = se(v), v === null ? null : v.stateNode;
    }
    function hx() {
      return null;
    }
    return n.attemptContinuousHydration = function(v) {
      if (v.tag === 13) {
        var x = Fc(v, 134217728);
        if (x !== null) {
          var P = hn();
          va(x, v, 134217728, P);
        }
        Kf(v, 134217728);
      }
    }, n.attemptDiscreteHydration = function(v) {
      if (v.tag === 13) {
        var x = Fc(v, 1);
        if (x !== null) {
          var P = hn();
          va(x, v, 1, P);
        }
        Kf(v, 1);
      }
    }, n.attemptHydrationAtCurrentPriority = function(v) {
      if (v.tag === 13) {
        var x = As(v), P = Fc(v, x);
        if (P !== null) {
          var B = hn();
          va(P, v, x, B);
        }
        Kf(v, x);
      }
    }, n.attemptSynchronousHydration = function(v) {
      switch (v.tag) {
        case 3:
          var x = v.stateNode;
          if (x.current.memoizedState.isDehydrated) {
            var P = Oo(x.pendingLanes);
            P !== 0 && (tc(x, P | 1), oi(x, Rs()), !(br & 6) && (Mn(), Xi()));
          }
          break;
        case 13:
          pd(function() {
            var B = Fc(v, 1);
            if (B !== null) {
              var G = hn();
              va(B, v, 1, G);
            }
          }), Kf(v, 1);
      }
    }, n.batchedUpdates = function(v, x) {
      var P = br;
      br |= 1;
      try {
        return v(x);
      } finally {
        br = P, br === 0 && (Mn(), gh && Xi());
      }
    }, n.createComponentSelector = function(v) {
      return { $$typeof: Ks, value: v };
    }, n.createContainer = function(v, x, P, B, G, ne, be) {
      return Ay(v, x, !1, null, P, B, G, ne, be);
    }, n.createHasPseudoClassSelector = function(v) {
      return { $$typeof: Yt, value: v };
    }, n.createHydrationContainer = function(v, x, P, B, G, ne, be, Fe, Ze) {
      return v = Ay(P, B, !0, v, G, ne, be, Fe, Ze), v.context = g0(null), P = v.current, B = hn(), G = As(P), ne = Io(B, G), ne.callback = x ?? null, nd(P, ne, G), v.current.lanes = G, Za(v, G, B), oi(v, B), v;
    }, n.createPortal = function(v, x, P) {
      var B = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      return { $$typeof: y, key: B == null ? null : "" + B, children: v, containerInfo: x, implementation: P };
    }, n.createRoleSelector = function(v) {
      return { $$typeof: no, value: v };
    }, n.createTestNameSelector = function(v) {
      return { $$typeof: ya, value: v };
    }, n.createTextSelector = function(v) {
      return { $$typeof: Z1, value: v };
    }, n.deferredUpdates = function(v) {
      var x = la, P = ks.transition;
      try {
        return ks.transition = null, la = 16, v();
      } finally {
        la = x, ks.transition = P;
      }
    }, n.discreteUpdates = function(v, x, P, B, G) {
      var ne = la, be = ks.transition;
      try {
        return ks.transition = null, la = 1, v(x, P, B, G);
      } finally {
        la = ne, ks.transition = be, br === 0 && Mn();
      }
    }, n.findAllNodes = of, n.findBoundingRects = function(v, x) {
      if (!Pe) throw Error(c(363));
      x = of(v, x), v = [];
      for (var P = 0; P < x.length; P++) v.push(ot(x[P]));
      for (x = v.length - 1; 0 < x; x--) {
        P = v[x];
        for (var B = P.x, G = B + P.width, ne = P.y, be = ne + P.height, Fe = x - 1; 0 <= Fe; Fe--) if (x !== Fe) {
          var Ze = v[Fe], Ft = Ze.x, sn = Ft + Ze.width, dr = Ze.y, ct = dr + Ze.height;
          if (B >= Ft && ne >= dr && G <= sn && be <= ct) {
            v.splice(x, 1);
            break;
          } else if (B !== Ft || P.width !== Ze.width || ct < ne || dr > be) {
            if (!(ne !== dr || P.height !== Ze.height || sn < B || Ft > G)) {
              Ft > B && (Ze.width += Ft - B, Ze.x = B), sn < G && (Ze.width = G - Ft), v.splice(x, 1);
              break;
            }
          } else {
            dr > ne && (Ze.height += dr - ne, Ze.y = ne), ct < be && (Ze.height = be - dr), v.splice(x, 1);
            break;
          }
        }
      }
      return v;
    }, n.findHostInstance = qf, n.findHostInstanceWithNoPortals = function(v) {
      return v = X(v), v = v !== null ? fe(v) : null, v === null ? null : v.stateNode;
    }, n.findHostInstanceWithWarning = function(v) {
      return qf(v);
    }, n.flushControlled = function(v) {
      var x = br;
      br |= 1;
      var P = ks.transition, B = la;
      try {
        ks.transition = null, la = 1, v();
      } finally {
        la = B, ks.transition = P, br = x, br === 0 && (Mn(), Xi());
      }
    }, n.flushPassiveEffects = Iu, n.flushSync = pd, n.focusWithin = function(v, x) {
      if (!Pe) throw Error(c(363));
      for (v = sf(v), x = ja(v, x), x = Array.from(x), v = 0; v < x.length; ) {
        var P = x[v++];
        if (!Vt(P)) {
          if (P.tag === 5 && mr(P.stateNode)) return !0;
          for (P = P.child; P !== null; ) x.push(P), P = P.sibling;
        }
      }
      return !1;
    }, n.getCurrentUpdatePriority = function() {
      return la;
    }, n.getFindAllNodesFailureDescription = function(v, x) {
      if (!Pe) throw Error(c(363));
      var P = 0, B = [];
      v = [sf(v), 0];
      for (var G = 0; G < v.length; ) {
        var ne = v[G++], be = v[G++], Fe = x[be];
        if ((ne.tag !== 5 || !Vt(ne)) && (Lp(ne, Fe) && (B.push(Dm(Fe)), be++, be > P && (P = be)), be < x.length)) for (ne = ne.child; ne !== null; ) v.push(ne, be), ne = ne.sibling;
      }
      if (P < x.length) {
        for (v = []; P < x.length; P++) v.push(Dm(x[P]));
        return `findAllNodes was able to match part of the selector:
  ` + (B.join(" > ") + `

No matching component was found for:
  `) + v.join(" > ");
      }
      return null;
    }, n.getPublicRootInstance = function(v) {
      if (v = v.current, !v.child) return null;
      switch (v.child.tag) {
        case 5:
          return pe(v.child.stateNode);
        default:
          return v.child.stateNode;
      }
    }, n.injectIntoDevTools = function(v) {
      if (v = { bundleType: v.bundleType, version: v.version, rendererPackageName: v.rendererPackageName, rendererConfig: v.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: u.ReactCurrentDispatcher, findHostInstanceByFiber: ag, findFiberByHostInstance: v.findFiberByHostInstance || hx, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1" }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") v = !1;
      else {
        var x = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (x.isDisabled || !x.supportsFiber) v = !0;
        else {
          try {
            vm = x.inject(v), nc = x;
          } catch {
          }
          v = !!x.checkDCE;
        }
      }
      return v;
    }, n.isAlreadyRendering = function() {
      return !1;
    }, n.observeVisibleRects = function(v, x, P, B) {
      if (!Pe) throw Error(c(363));
      v = of(v, x);
      var G = ur(v, P, B).disconnect;
      return { disconnect: function() {
        G();
      } };
    }, n.registerMutableSourceForHydration = function(v, x) {
      var P = x._getVersion;
      P = P(x._source), v.mutableSourceEagerHydrationData == null ? v.mutableSourceEagerHydrationData = [x, P] : v.mutableSourceEagerHydrationData.push(x, P);
    }, n.runWithPriority = function(v, x) {
      var P = la;
      try {
        return la = v, x();
      } finally {
        la = P;
      }
    }, n.shouldError = function() {
      return null;
    }, n.shouldSuspend = function() {
      return !1;
    }, n.updateContainer = function(v, x, P, B) {
      var G = x.current, ne = hn(), be = As(G);
      return P = g0(P), x.context === null ? x.context = P : x.pendingContext = P, x = Io(ne, be), x.payload = { element: v }, B = B === void 0 ? null : B, B !== null && (x.callback = B), v = nd(G, x, be), v !== null && (va(v, G, be, ne), Cm(v, G, be)), be;
    }, n;
  }), ER;
}
var kR = { exports: {} };
/**
 * @license React
 * react-reconciler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MB;
function C5e() {
  return MB || (MB = 1, process.env.NODE_ENV !== "production" && (kR.exports = function(t) {
    var n = {}, r = Ee, s = G3(), o = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, c = !1;
    function u(d) {
      c = d;
    }
    function m(d) {
      if (!c) {
        for (var h = arguments.length, C = new Array(h > 1 ? h - 1 : 0), M = 1; M < h; M++)
          C[M - 1] = arguments[M];
        b("warn", d, C);
      }
    }
    function y(d) {
      if (!c) {
        for (var h = arguments.length, C = new Array(h > 1 ? h - 1 : 0), M = 1; M < h; M++)
          C[M - 1] = arguments[M];
        b("error", d, C);
      }
    }
    function b(d, h, C) {
      {
        var M = o.ReactDebugCurrentFrame, A = M.getStackAddendum();
        A !== "" && (h += "%s", C = C.concat([A]));
        var W = C.map(function(ae) {
          return String(ae);
        });
        W.unshift("Warning: " + h), Function.prototype.apply.call(console[d], console, W);
      }
    }
    var w = Object.assign;
    function k(d) {
      return d._reactInternals;
    }
    function j(d, h) {
      d._reactInternals = h;
    }
    var E = !1, T = !1, D = !1, L = !1, I = !0, R = !0, U = !0, z = !0, H = 0, K = 1, q = 2, Q = 3, Z = 4, X = 5, se = 6, te = 7, fe = 8, ce = 9, pe = 10, Se = 11, oe = 12, ue = 13, he = 14, ve = 15, Te = 16, Ie = 17, Ue = 18, qe = 19, it = 21, Ne = 22, Xe = 23, xt = 24, rn = 25, vt = Symbol.for("react.element"), At = Symbol.for("react.portal"), He = Symbol.for("react.fragment"), Pt = Symbol.for("react.strict_mode"), Lt = Symbol.for("react.profiler"), er = Symbol.for("react.provider"), It = Symbol.for("react.context"), ye = Symbol.for("react.forward_ref"), ke = Symbol.for("react.suspense"), Pe = Symbol.for("react.suspense_list"), tt = Symbol.for("react.memo"), ot = Symbol.for("react.lazy"), ut = Symbol.for("react.scope"), Vt = Symbol.for("react.debug_trace_mode"), bn = Symbol.for("react.offscreen"), mr = Symbol.for("react.legacy_hidden"), ur = Symbol.for("react.cache"), _r = Symbol.for("react.tracing_marker"), ai = Symbol.iterator, ls = "@@iterator";
    function Ot(d) {
      if (d === null || typeof d != "object")
        return null;
      var h = ai && d[ai] || d[ls];
      return typeof h == "function" ? h : null;
    }
    function En(d, h, C) {
      var M = d.displayName;
      if (M)
        return M;
      var A = h.displayName || h.name || "";
      return A !== "" ? C + "(" + A + ")" : C;
    }
    function Xt(d) {
      return d.displayName || "Context";
    }
    function qt(d) {
      if (d == null)
        return null;
      if (typeof d.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof d == "function")
        return d.displayName || d.name || null;
      if (typeof d == "string")
        return d;
      switch (d) {
        case He:
          return "Fragment";
        case At:
          return "Portal";
        case Lt:
          return "Profiler";
        case Pt:
          return "StrictMode";
        case ke:
          return "Suspense";
        case Pe:
          return "SuspenseList";
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case It:
            var h = d;
            return Xt(h) + ".Consumer";
          case er:
            var C = d;
            return Xt(C._context) + ".Provider";
          case ye:
            return En(d, d.render, "ForwardRef");
          case tt:
            var M = d.displayName || null;
            return M !== null ? M : qt(d.type) || "Memo";
          case ot: {
            var A = d, W = A._payload, ae = A._init;
            try {
              return qt(ae(W));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function In(d, h, C) {
      var M = h.displayName || h.name || "";
      return d.displayName || (M !== "" ? C + "(" + M + ")" : C);
    }
    function st(d) {
      return d.displayName || "Context";
    }
    function lt(d) {
      var h = d.tag, C = d.type;
      switch (h) {
        case xt:
          return "Cache";
        case ce:
          var M = C;
          return st(M) + ".Consumer";
        case pe:
          var A = C;
          return st(A._context) + ".Provider";
        case Ue:
          return "DehydratedFragment";
        case Se:
          return In(C, C.render, "ForwardRef");
        case te:
          return "Fragment";
        case X:
          return C;
        case Z:
          return "Portal";
        case Q:
          return "Root";
        case se:
          return "Text";
        case Te:
          return qt(C);
        case fe:
          return C === Pt ? "StrictMode" : "Mode";
        case Ne:
          return "Offscreen";
        case oe:
          return "Profiler";
        case it:
          return "Scope";
        case ue:
          return "Suspense";
        case qe:
          return "SuspenseList";
        case rn:
          return "TracingMarker";
        case K:
        case H:
        case Ie:
        case q:
        case he:
        case ve:
          if (typeof C == "function")
            return C.displayName || C.name || null;
          if (typeof C == "string")
            return C;
          break;
      }
      return null;
    }
    var Nt = (
      /*                      */
      0
    ), Wt = (
      /*                */
      1
    ), wn = (
      /*                    */
      2
    ), pt = (
      /*                       */
      4
    ), hr = (
      /*                */
      16
    ), _o = (
      /*                 */
      32
    ), Il = (
      /*                     */
      64
    ), Cr = (
      /*                   */
      128
    ), Wi = (
      /*            */
      256
    ), Yi = (
      /*                          */
      512
    ), To = (
      /*                     */
      1024
    ), qi = (
      /*                      */
      2048
    ), Mo = (
      /*                    */
      4096
    ), ul = (
      /*                   */
      8192
    ), dl = (
      /*             */
      16384
    ), Dc = qi | pt | Il | Yi | To | dl, Ro = (
      /*               */
      32767
    ), Do = (
      /*                   */
      32768
    ), _s = (
      /*                */
      65536
    ), fl = (
      /* */
      131072
    ), _e = (
      /*                       */
      1048576
    ), _t = (
      /*                    */
      2097152
    ), Kt = (
      /*                 */
      4194304
    ), On = (
      /*                */
      8388608
    ), vr = (
      /*               */
      16777216
    ), Lr = (
      /*              */
      33554432
    ), Xn = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      pt | To | 0
    ), wr = wn | pt | hr | _o | Yi | Mo | ul, Ts = pt | Il | Yi | ul, pa = qi | hr, ga = Kt | On | _t, Tr = o.ReactCurrentOwner;
    function Fn(d) {
      var h = d, C = d;
      if (d.alternate)
        for (; h.return; )
          h = h.return;
      else {
        var M = h;
        do
          h = M, (h.flags & (wn | Mo)) !== Nt && (C = h.return), M = h.return;
        while (M);
      }
      return h.tag === Q ? C : null;
    }
    function Gn(d) {
      return Fn(d) === d;
    }
    function zr(d) {
      {
        var h = Tr.current;
        if (h !== null && h.tag === K) {
          var C = h, M = C.stateNode;
          M._warnedAboutRefsInRender || y("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", lt(C) || "A component"), M._warnedAboutRefsInRender = !0;
        }
      }
      var A = k(d);
      return A ? Fn(A) === A : !1;
    }
    function ta(d) {
      if (Fn(d) !== d)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function ir(d) {
      var h = d.alternate;
      if (!h) {
        var C = Fn(d);
        if (C === null)
          throw new Error("Unable to find node on an unmounted component.");
        return C !== d ? null : d;
      }
      for (var M = d, A = h; ; ) {
        var W = M.return;
        if (W === null)
          break;
        var ae = W.alternate;
        if (ae === null) {
          var de = W.return;
          if (de !== null) {
            M = A = de;
            continue;
          }
          break;
        }
        if (W.child === ae.child) {
          for (var ge = W.child; ge; ) {
            if (ge === M)
              return ta(W), d;
            if (ge === A)
              return ta(W), h;
            ge = ge.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (M.return !== A.return)
          M = W, A = ae;
        else {
          for (var Ce = !1, Me = W.child; Me; ) {
            if (Me === M) {
              Ce = !0, M = W, A = ae;
              break;
            }
            if (Me === A) {
              Ce = !0, A = W, M = ae;
              break;
            }
            Me = Me.sibling;
          }
          if (!Ce) {
            for (Me = ae.child; Me; ) {
              if (Me === M) {
                Ce = !0, M = ae, A = W;
                break;
              }
              if (Me === A) {
                Ce = !0, A = ae, M = W;
                break;
              }
              Me = Me.sibling;
            }
            if (!Ce)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (M.alternate !== A)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (M.tag !== Q)
        throw new Error("Unable to find node on an unmounted component.");
      return M.stateNode.current === M ? d : h;
    }
    function Hs(d) {
      var h = ir(d);
      return h !== null ? Pc(h) : null;
    }
    function Pc(d) {
      if (d.tag === X || d.tag === se)
        return d;
      for (var h = d.child; h !== null; ) {
        var C = Pc(h);
        if (C !== null)
          return C;
        h = h.sibling;
      }
      return null;
    }
    function Fl(d) {
      var h = ir(d);
      return h !== null ? Ki(h) : null;
    }
    function Ki(d) {
      if (d.tag === X || d.tag === se)
        return d;
      for (var h = d.child; h !== null; ) {
        if (h.tag !== Z) {
          var C = Ki(h);
          if (C !== null)
            return C;
        }
        h = h.sibling;
      }
      return null;
    }
    var Ms = Array.isArray;
    function xr(d) {
      return Ms(d);
    }
    var Mr = t.getPublicInstance, xu = t.getRootHostContext, Po = t.getChildHostContext, ec = t.prepareForCommit, Yd = t.resetAfterCommit, Ju = t.createInstance, fi = t.appendInitialChild, Ul = t.finalizeInitialChildren, P1 = t.prepareUpdate, fh = t.shouldSetTextContent, mh = t.createTextInstance, jp = t.scheduleTimeout, Oc = t.cancelTimeout, Rf = t.noTimeout, n0 = t.isPrimaryRenderer, O1 = t.warnsIfNotActing, Rr = t.supportsMutation, Df = t.supportsPersistence, Oo = t.supportsHydration, hh = t.getInstanceFromNode;
    t.beforeActiveInstanceBlur, t.afterActiveInstanceBlur;
    var Qa = t.preparePortalMount;
    t.prepareScopeUpdate, t.getInstanceFromScope;
    var rx = t.getCurrentEventPriority, A1 = t.detachDeletedInstance, Nr = t.supportsMicrotasks, ph = t.scheduleMicrotask, Za = t.supportsTestSelectors, bu = t.findFiberRoot, tc = t.getBoundingRect, la = t.getTextContent, Vs = t.isHiddenSubtree, Va = t.matchAccessibilityRole, ax = t.setFocusIfFocusable, ed = t.setupIntersectionObserver, ml = t.appendChild, Rs = t.appendChildToContainer, r0 = t.commitTextUpdate, Ep = t.commitMount, L1 = t.commitUpdate, sx = t.insertBefore, vm = t.insertInContainerBefore, nc = t.removeChild, kp = t.removeChildFromContainer, xm = t.resetTextContent, Su = t.hideInstance, wu = t.hideTextInstance, gh = t.unhideInstance, yh = t.unhideTextInstance, I1 = t.clearContainer, My = t.cloneInstance, Xi = t.createContainerChildSet, td = t.appendChildToContainerChildSet, qd = t.finalizeContainerChildren, bm = t.replaceContainerChildren, Kd = t.cloneHiddenInstance, Ao = t.cloneHiddenTextInstance, Ac = t.canHydrateInstance, Qi = t.canHydrateTextInstance, hl = t.canHydrateSuspenseInstance, Lc = t.isSuspenseInstancePending, rc = t.isSuspenseInstanceFallback, Ry = t.getSuspenseInstanceFallbackErrorDetails, _p = t.registerSuspenseInstanceRetry, Sm = t.getNextHydratableSibling, Lo = t.getFirstHydratableChild, Ja = t.getFirstHydratableChildWithinContainer, vs = t.getFirstHydratableChildWithinSuspenseInstance, Tp = t.hydrateInstance, Cu = t.hydrateTextInstance, ix = t.hydrateSuspenseInstance, Pf = t.getNextHydratableInstanceAfterSuspenseInstance, F1 = t.commitHydratedContainer, a0 = t.commitHydratedSuspenseInstance, ox = t.clearSuspenseBoundary, s0 = t.clearSuspenseBoundaryFromContainer, lx = t.shouldDeleteUnhydratedTailInstances, wm = t.didNotMatchHydratedContainerTextInstance, U1 = t.didNotMatchHydratedTextInstance, cx = t.didNotHydrateInstanceWithinContainer, z1 = t.didNotHydrateInstanceWithinSuspenseInstance, ux = t.didNotHydrateInstance, vh = t.didNotFindHydratableInstanceWithinContainer, Nu = t.didNotFindHydratableTextInstanceWithinContainer, dx = t.didNotFindHydratableSuspenseInstanceWithinContainer, i0 = t.didNotFindHydratableInstanceWithinSuspenseInstance, Of = t.didNotFindHydratableTextInstanceWithinSuspenseInstance, o0 = t.didNotFindHydratableSuspenseInstanceWithinSuspenseInstance, l0 = t.didNotFindHydratableInstance, xh = t.didNotFindHydratableTextInstance, bh = t.didNotFindHydratableSuspenseInstance, pl = t.errorHydratingContainer, zl = 0, mi, ac, Xd, Qd, sc, Ic, B1;
    function c0() {
    }
    c0.__reactDisabledLog = !0;
    function Fc() {
      {
        if (zl === 0) {
          mi = console.log, ac = console.info, Xd = console.warn, Qd = console.error, sc = console.group, Ic = console.groupCollapsed, B1 = console.groupEnd;
          var d = {
            configurable: !0,
            enumerable: !0,
            value: c0,
            writable: !0
          };
          Object.defineProperties(console, {
            info: d,
            log: d,
            warn: d,
            error: d,
            group: d,
            groupCollapsed: d,
            groupEnd: d
          });
        }
        zl++;
      }
    }
    function Uc() {
      {
        if (zl--, zl === 0) {
          var d = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: w({}, d, {
              value: mi
            }),
            info: w({}, d, {
              value: ac
            }),
            warn: w({}, d, {
              value: Xd
            }),
            error: w({}, d, {
              value: Qd
            }),
            group: w({}, d, {
              value: sc
            }),
            groupCollapsed: w({}, d, {
              value: Ic
            }),
            groupEnd: w({}, d, {
              value: B1
            })
          });
        }
        zl < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var H1 = o.ReactCurrentDispatcher, u0;
    function Io(d, h, C) {
      {
        if (u0 === void 0)
          try {
            throw Error();
          } catch (A) {
            var M = A.stack.trim().match(/\n( *(at )?)/);
            u0 = M && M[1] || "";
          }
        return `
` + u0 + d;
      }
    }
    var nd = !1, Cm;
    {
      var Mp = typeof WeakMap == "function" ? WeakMap : Map;
      Cm = new Mp();
    }
    function rd(d, h) {
      if (!d || nd)
        return "";
      {
        var C = Cm.get(d);
        if (C !== void 0)
          return C;
      }
      var M;
      nd = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var W;
      W = H1.current, H1.current = null, Fc();
      try {
        if (h) {
          var ae = function() {
            throw Error();
          };
          if (Object.defineProperty(ae.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ae, []);
            } catch (Ct) {
              M = Ct;
            }
            Reflect.construct(d, [], ae);
          } else {
            try {
              ae.call();
            } catch (Ct) {
              M = Ct;
            }
            d.call(ae.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ct) {
            M = Ct;
          }
          d();
        }
      } catch (Ct) {
        if (Ct && M && typeof Ct.stack == "string") {
          for (var de = Ct.stack.split(`
`), ge = M.stack.split(`
`), Ce = de.length - 1, Me = ge.length - 1; Ce >= 1 && Me >= 0 && de[Ce] !== ge[Me]; )
            Me--;
          for (; Ce >= 1 && Me >= 0; Ce--, Me--)
            if (de[Ce] !== ge[Me]) {
              if (Ce !== 1 || Me !== 1)
                do
                  if (Ce--, Me--, Me < 0 || de[Ce] !== ge[Me]) {
                    var $e = `
` + de[Ce].replace(" at new ", " at ");
                    return d.displayName && $e.includes("<anonymous>") && ($e = $e.replace("<anonymous>", d.displayName)), typeof d == "function" && Cm.set(d, $e), $e;
                  }
                while (Ce >= 1 && Me >= 0);
              break;
            }
        }
      } finally {
        nd = !1, H1.current = W, Uc(), Error.prepareStackTrace = A;
      }
      var at = d ? d.displayName || d.name : "", yt = at ? Io(at) : "";
      return typeof d == "function" && Cm.set(d, yt), yt;
    }
    function Sh(d, h, C) {
      return rd(d, !0);
    }
    function ju(d, h, C) {
      return rd(d, !1);
    }
    function zc(d) {
      var h = d.prototype;
      return !!(h && h.isReactComponent);
    }
    function Af(d, h, C) {
      if (d == null)
        return "";
      if (typeof d == "function")
        return rd(d, zc(d));
      if (typeof d == "string")
        return Io(d);
      switch (d) {
        case ke:
          return Io("Suspense");
        case Pe:
          return Io("SuspenseList");
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case ye:
            return ju(d.render);
          case tt:
            return Af(d.type, h, C);
          case ot: {
            var M = d, A = M._payload, W = M._init;
            try {
              return Af(W(A), h, C);
            } catch {
            }
          }
        }
      return "";
    }
    var Lf = Object.prototype.hasOwnProperty, Bc = {}, V1 = o.ReactDebugCurrentFrame;
    function Zd(d) {
      if (d) {
        var h = d._owner, C = Af(d.type, d._source, h ? h.type : null);
        V1.setExtraStackFrame(C);
      } else
        V1.setExtraStackFrame(null);
    }
    function Hc(d, h, C, M, A) {
      {
        var W = Function.call.bind(Lf);
        for (var ae in d)
          if (W(d, ae)) {
            var de = void 0;
            try {
              if (typeof d[ae] != "function") {
                var ge = Error((M || "React class") + ": " + C + " type `" + ae + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[ae] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ge.name = "Invariant Violation", ge;
              }
              de = d[ae](h, ae, M, C, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ce) {
              de = Ce;
            }
            de && !(de instanceof Error) && (Zd(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", M || "React class", C, ae, typeof de), Zd(null)), de instanceof Error && !(de.message in Bc) && (Bc[de.message] = !0, Zd(A), y("Failed %s type: %s", C, de.message), Zd(null));
          }
      }
    }
    var $1 = [], Cs;
    Cs = [];
    var Eu = -1;
    function ad(d) {
      return {
        current: d
      };
    }
    function yo(d, h) {
      if (Eu < 0) {
        y("Unexpected pop.");
        return;
      }
      h !== Cs[Eu] && y("Unexpected Fiber popped."), d.current = $1[Eu], $1[Eu] = null, Cs[Eu] = null, Eu--;
    }
    function Pa(d, h, C) {
      Eu++, $1[Eu] = d.current, Cs[Eu] = C, d.current = h;
    }
    var If;
    If = {};
    var Ii = {};
    Object.freeze(Ii);
    var wa = ad(Ii), es = ad(!1), si = Ii;
    function Fo(d, h, C) {
      return C && xs(h) ? si : wa.current;
    }
    function Ff(d, h, C) {
      {
        var M = d.stateNode;
        M.__reactInternalMemoizedUnmaskedChildContext = h, M.__reactInternalMemoizedMaskedChildContext = C;
      }
    }
    function sd(d, h) {
      {
        var C = d.type, M = C.contextTypes;
        if (!M)
          return Ii;
        var A = d.stateNode;
        if (A && A.__reactInternalMemoizedUnmaskedChildContext === h)
          return A.__reactInternalMemoizedMaskedChildContext;
        var W = {};
        for (var ae in M)
          W[ae] = h[ae];
        {
          var de = lt(d) || "Unknown";
          Hc(M, W, "context", de);
        }
        return A && Ff(d, h, W), W;
      }
    }
    function ic() {
      return es.current;
    }
    function xs(d) {
      {
        var h = d.childContextTypes;
        return h != null;
      }
    }
    function Jd(d) {
      yo(es, d), yo(wa, d);
    }
    function wh(d) {
      yo(es, d), yo(wa, d);
    }
    function G1(d, h, C) {
      {
        if (wa.current !== Ii)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Pa(wa, h, d), Pa(es, C, d);
      }
    }
    function oc(d, h, C) {
      {
        var M = d.stateNode, A = h.childContextTypes;
        if (typeof M.getChildContext != "function") {
          {
            var W = lt(d) || "Unknown";
            If[W] || (If[W] = !0, y("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", W, W));
          }
          return C;
        }
        var ae = M.getChildContext();
        for (var de in ae)
          if (!(de in A))
            throw new Error((lt(d) || "Unknown") + '.getChildContext(): key "' + de + '" is not defined in childContextTypes.');
        {
          var ge = lt(d) || "Unknown";
          Hc(A, ae, "child context", ge);
        }
        return w({}, C, ae);
      }
    }
    function Ci(d) {
      {
        var h = d.stateNode, C = h && h.__reactInternalMemoizedMergedChildContext || Ii;
        return si = wa.current, Pa(wa, C, d), Pa(es, es.current, d), !0;
      }
    }
    function Nm(d, h, C) {
      {
        var M = d.stateNode;
        if (!M)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (C) {
          var A = oc(d, h, si);
          M.__reactInternalMemoizedMergedChildContext = A, yo(es, d), yo(wa, d), Pa(wa, A, d), Pa(es, C, d);
        } else
          yo(es, d), Pa(es, C, d);
      }
    }
    function W1(d) {
      {
        if (!Gn(d) || d.tag !== K)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var h = d;
        do {
          switch (h.tag) {
            case Q:
              return h.stateNode.context;
            case K: {
              var C = h.type;
              if (xs(C))
                return h.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          h = h.return;
        } while (h !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Ds = 0, Y1 = 1, Qn = (
      /*                         */
      0
    ), na = (
      /*                 */
      1
    ), Ca = (
      /*                    */
      2
    ), $s = (
      /*               */
      8
    ), ku = (
      /*              */
      16
    ), id = Math.clz32 ? Math.clz32 : fx, Rp = Math.log, od = Math.LN2;
    function fx(d) {
      var h = d >>> 0;
      return h === 0 ? 32 : 31 - (Rp(h) / od | 0) | 0;
    }
    var ef = 31, bt = (
      /*                        */
      0
    ), Zi = (
      /*                          */
      0
    ), rr = (
      /*                        */
      1
    ), tf = (
      /*    */
      2
    ), ca = (
      /*             */
      4
    ), Bl = (
      /*            */
      8
    ), Ji = (
      /*                     */
      16
    ), _u = (
      /*                */
      32
    ), jm = (
      /*                       */
      4194240
    ), Uf = (
      /*                        */
      64
    ), Em = (
      /*                        */
      128
    ), Ch = (
      /*                        */
      256
    ), nf = (
      /*                        */
      512
    ), q1 = (
      /*                        */
      1024
    ), K1 = (
      /*                        */
      2048
    ), d0 = (
      /*                        */
      4096
    ), Dp = (
      /*                        */
      8192
    ), Nh = (
      /*                        */
      16384
    ), zf = (
      /*                       */
      32768
    ), X1 = (
      /*                       */
      65536
    ), Bf = (
      /*                       */
      131072
    ), jh = (
      /*                       */
      262144
    ), eo = (
      /*                       */
      524288
    ), Pp = (
      /*                       */
      1048576
    ), km = (
      /*                       */
      2097152
    ), Eh = (
      /*                            */
      130023424
    ), kh = (
      /*                             */
      4194304
    ), ld = (
      /*                             */
      8388608
    ), Hl = (
      /*                             */
      16777216
    ), Tu = (
      /*                             */
      33554432
    ), Mu = (
      /*                             */
      67108864
    ), Vc = kh, cd = (
      /*          */
      134217728
    ), ud = (
      /*                          */
      268435455
    ), _m = (
      /*               */
      268435456
    ), Tm = (
      /*                        */
      536870912
    ), gl = (
      /*                   */
      1073741824
    );
    function $c(d) {
      {
        if (d & rr)
          return "Sync";
        if (d & tf)
          return "InputContinuousHydration";
        if (d & ca)
          return "InputContinuous";
        if (d & Bl)
          return "DefaultHydration";
        if (d & Ji)
          return "Default";
        if (d & _u)
          return "TransitionHydration";
        if (d & jm)
          return "Transition";
        if (d & Eh)
          return "Retry";
        if (d & cd)
          return "SelectiveHydration";
        if (d & _m)
          return "IdleHydration";
        if (d & Tm)
          return "Idle";
        if (d & gl)
          return "Offscreen";
      }
    }
    var $a = -1, hi = Uf, mn = kh;
    function Gc(d) {
      switch (js(d)) {
        case rr:
          return rr;
        case tf:
          return tf;
        case ca:
          return ca;
        case Bl:
          return Bl;
        case Ji:
          return Ji;
        case _u:
          return _u;
        case Uf:
        case Em:
        case Ch:
        case nf:
        case q1:
        case K1:
        case d0:
        case Dp:
        case Nh:
        case zf:
        case X1:
        case Bf:
        case jh:
        case eo:
        case Pp:
        case km:
          return d & jm;
        case kh:
        case ld:
        case Hl:
        case Tu:
        case Mu:
          return d & Eh;
        case cd:
          return cd;
        case _m:
          return _m;
        case Tm:
          return Tm;
        case gl:
          return gl;
        default:
          return y("Should have found matching lanes. This is a bug in React."), d;
      }
    }
    function ts(d, h) {
      var C = d.pendingLanes;
      if (C === bt)
        return bt;
      var M = bt, A = d.suspendedLanes, W = d.pingedLanes, ae = C & ud;
      if (ae !== bt) {
        var de = ae & ~A;
        if (de !== bt)
          M = Gc(de);
        else {
          var ge = ae & W;
          ge !== bt && (M = Gc(ge));
        }
      } else {
        var Ce = C & ~A;
        Ce !== bt ? M = Gc(Ce) : W !== bt && (M = Gc(W));
      }
      if (M === bt)
        return bt;
      if (h !== bt && h !== M && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (h & A) === bt) {
        var Me = js(M), $e = js(h);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          Me >= $e || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          Me === Ji && ($e & jm) !== bt
        )
          return h;
      }
      (M & ca) !== bt && (M |= C & Ji);
      var at = d.entangledLanes;
      if (at !== bt)
        for (var yt = d.entanglements, Ct = M & at; Ct > 0; ) {
          var Et = Pu(Ct), Pn = 1 << Et;
          M |= yt[Et], Ct &= ~Pn;
        }
      return M;
    }
    function Dr(d, h) {
      for (var C = d.eventTimes, M = $a; h > 0; ) {
        var A = Pu(h), W = 1 << A, ae = C[A];
        ae > M && (M = ae), h &= ~W;
      }
      return M;
    }
    function Na(d, h) {
      switch (d) {
        case rr:
        case tf:
        case ca:
          return h + 250;
        case Bl:
        case Ji:
        case _u:
        case Uf:
        case Em:
        case Ch:
        case nf:
        case q1:
        case K1:
        case d0:
        case Dp:
        case Nh:
        case zf:
        case X1:
        case Bf:
        case jh:
        case eo:
        case Pp:
        case km:
          return h + 5e3;
        case kh:
        case ld:
        case Hl:
        case Tu:
        case Mu:
          return $a;
        case cd:
        case _m:
        case Tm:
        case gl:
          return $a;
        default:
          return y("Should have found matching lanes. This is a bug in React."), $a;
      }
    }
    function Oa(d, h) {
      for (var C = d.pendingLanes, M = d.suspendedLanes, A = d.pingedLanes, W = d.expirationTimes, ae = C; ae > 0; ) {
        var de = Pu(ae), ge = 1 << de, Ce = W[de];
        Ce === $a ? ((ge & M) === bt || (ge & A) !== bt) && (W[de] = Na(ge, h)) : Ce <= h && (d.expiredLanes |= ge), ae &= ~ge;
      }
    }
    function Ru(d) {
      return Gc(d.pendingLanes);
    }
    function or(d) {
      var h = d.pendingLanes & ~gl;
      return h !== bt ? h : h & gl ? gl : bt;
    }
    function Gs(d) {
      return (d & rr) !== bt;
    }
    function Uo(d) {
      return (d & ud) !== bt;
    }
    function lc(d) {
      return (d & Eh) === d;
    }
    function Ns(d) {
      var h = rr | ca | Ji;
      return (d & h) === bt;
    }
    function cc(d) {
      return (d & jm) === d;
    }
    function Du(d, h) {
      var C = tf | ca | Bl | Ji;
      return (h & C) !== bt;
    }
    function _h(d, h) {
      return (h & d.expiredLanes) !== bt;
    }
    function Mm(d) {
      return (d & jm) !== bt;
    }
    function Dy() {
      var d = hi;
      return hi <<= 1, (hi & jm) === bt && (hi = Uf), d;
    }
    function uc() {
      var d = mn;
      return mn <<= 1, (mn & Eh) === bt && (mn = kh), d;
    }
    function js(d) {
      return d & -d;
    }
    function rf(d) {
      return js(d);
    }
    function Pu(d) {
      return 31 - id(d);
    }
    function Wc(d) {
      return Pu(d);
    }
    function Es(d, h) {
      return (d & h) !== bt;
    }
    function pi(d, h) {
      return (d & h) === h;
    }
    function Wn(d, h) {
      return d | h;
    }
    function dc(d, h) {
      return d & ~h;
    }
    function dd(d, h) {
      return d & h;
    }
    function yl(d) {
      return d;
    }
    function to(d, h) {
      return d !== Zi && d < h ? d : h;
    }
    function Vl(d) {
      for (var h = [], C = 0; C < ef; C++)
        h.push(d);
      return h;
    }
    function Ps(d, h, C) {
      d.pendingLanes |= h, h !== Tm && (d.suspendedLanes = bt, d.pingedLanes = bt);
      var M = d.eventTimes, A = Wc(h);
      M[A] = C;
    }
    function Ws(d, h) {
      d.suspendedLanes |= h, d.pingedLanes &= ~h;
      for (var C = d.expirationTimes, M = h; M > 0; ) {
        var A = Pu(M), W = 1 << A;
        C[A] = $a, M &= ~W;
      }
    }
    function fc(d, h, C) {
      d.pingedLanes |= d.suspendedLanes & h;
    }
    function Py(d, h) {
      var C = d.pendingLanes & ~h;
      d.pendingLanes = h, d.suspendedLanes = bt, d.pingedLanes = bt, d.expiredLanes &= h, d.mutableReadLanes &= h, d.entangledLanes &= h;
      for (var M = d.entanglements, A = d.eventTimes, W = d.expirationTimes, ae = C; ae > 0; ) {
        var de = Pu(ae), ge = 1 << de;
        M[de] = bt, A[de] = $a, W[de] = $a, ae &= ~ge;
      }
    }
    function Hf(d, h) {
      for (var C = d.entangledLanes |= h, M = d.entanglements, A = C; A; ) {
        var W = Pu(A), ae = 1 << W;
        // Is this one of the newly entangled lanes?
        ae & h | // Is this lane transitively entangled with the newly entangled lanes?
        M[W] & h && (M[W] |= h), A &= ~ae;
      }
    }
    function vo(d, h) {
      var C = js(h), M;
      switch (C) {
        case ca:
          M = tf;
          break;
        case Ji:
          M = Bl;
          break;
        case Uf:
        case Em:
        case Ch:
        case nf:
        case q1:
        case K1:
        case d0:
        case Dp:
        case Nh:
        case zf:
        case X1:
        case Bf:
        case jh:
        case eo:
        case Pp:
        case km:
        case kh:
        case ld:
        case Hl:
        case Tu:
        case Mu:
          M = _u;
          break;
        case Tm:
          M = _m;
          break;
        default:
          M = Zi;
          break;
      }
      return (M & (d.suspendedLanes | h)) !== Zi ? Zi : M;
    }
    function mc(d, h, C) {
      if (ya)
        for (var M = d.pendingUpdatersLaneMap; C > 0; ) {
          var A = Wc(C), W = 1 << A, ae = M[A];
          ae.add(h), C &= ~W;
        }
    }
    function tn(d, h) {
      if (ya)
        for (var C = d.pendingUpdatersLaneMap, M = d.memoizedUpdaters; h > 0; ) {
          var A = Wc(h), W = 1 << A, ae = C[A];
          ae.size > 0 && (ae.forEach(function(de) {
            var ge = de.alternate;
            (ge === null || !M.has(ge)) && M.add(de);
          }), ae.clear()), h &= ~W;
        }
    }
    function Aa(d, h) {
      return null;
    }
    var ii = rr, Rm = ca, Op = Ji, af = Tm, fd = Zi;
    function hc() {
      return fd;
    }
    function gi(d) {
      fd = d;
    }
    function Oy(d, h) {
      var C = fd;
      try {
        return fd = d, h();
      } finally {
        fd = C;
      }
    }
    function Ys(d, h) {
      return d !== 0 && d < h ? d : h;
    }
    function Q1(d, h) {
      return d > h ? d : h;
    }
    function Th(d, h) {
      return d !== 0 && d < h;
    }
    function qs(d) {
      var h = js(d);
      return Th(ii, h) ? Th(Rm, h) ? Uo(h) ? Op : af : Rm : ii;
    }
    var Ni = s.unstable_scheduleCallback, md = s.unstable_cancelCallback, Ap = s.unstable_shouldYield, Mh = s.unstable_requestPaint, ns = s.unstable_now, Yc = s.unstable_ImmediatePriority, rs = s.unstable_UserBlockingPriority, Zt = s.unstable_NormalPriority, pc = s.unstable_IdlePriority, gc = s.unstable_yieldValue, f0 = s.unstable_setDisableYieldValue, Vf = null, Ks = null, Yt = null, no = !1, ya = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Z1(d) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var h = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (h.isDisabled)
        return !0;
      if (!h.supportsFiber)
        return y("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        R && (d = w({}, d, {
          getLaneLabelMap: m0,
          injectProfilingHooks: of
        })), Vf = h.inject(d), Ks = h;
      } catch (C) {
        y("React instrumentation encountered an error: %s.", C);
      }
      return !!h.checkDCE;
    }
    function qc(d, h) {
      if (Ks && typeof Ks.onScheduleFiberRoot == "function")
        try {
          Ks.onScheduleFiberRoot(Vf, d, h);
        } catch (C) {
          no || (no = !0, y("React instrumentation encountered an error: %s", C));
        }
    }
    function sf(d, h) {
      if (Ks && typeof Ks.onCommitFiberRoot == "function")
        try {
          var C = (d.current.flags & Cr) === Cr;
          if (U) {
            var M;
            switch (h) {
              case ii:
                M = Yc;
                break;
              case Rm:
                M = rs;
                break;
              case Op:
                M = Zt;
                break;
              case af:
                M = pc;
                break;
              default:
                M = Zt;
                break;
            }
            Ks.onCommitFiberRoot(Vf, d, M, C);
          }
        } catch (A) {
          no || (no = !0, y("React instrumentation encountered an error: %s", A));
        }
    }
    function Lp(d) {
      if (Ks && typeof Ks.onPostCommitFiberRoot == "function")
        try {
          Ks.onPostCommitFiberRoot(Vf, d);
        } catch (h) {
          no || (no = !0, y("React instrumentation encountered an error: %s", h));
        }
    }
    function Dm(d) {
      if (Ks && typeof Ks.onCommitFiberUnmount == "function")
        try {
          Ks.onCommitFiberUnmount(Vf, d);
        } catch (h) {
          no || (no = !0, y("React instrumentation encountered an error: %s", h));
        }
    }
    function ja(d) {
      if (typeof gc == "function" && (f0(d), u(d)), Ks && typeof Ks.setStrictMode == "function")
        try {
          Ks.setStrictMode(Vf, d);
        } catch (h) {
          no || (no = !0, y("React instrumentation encountered an error: %s", h));
        }
    }
    function of(d) {
      Yt = d;
    }
    function m0() {
      {
        for (var d = /* @__PURE__ */ new Map(), h = 1, C = 0; C < ef; C++) {
          var M = $c(h);
          d.set(h, M), h *= 2;
        }
        return d;
      }
    }
    function J1(d) {
      Yt !== null && typeof Yt.markCommitStarted == "function" && Yt.markCommitStarted(d);
    }
    function Rh() {
      Yt !== null && typeof Yt.markCommitStopped == "function" && Yt.markCommitStopped();
    }
    function ks(d) {
      Yt !== null && typeof Yt.markComponentRenderStarted == "function" && Yt.markComponentRenderStarted(d);
    }
    function br() {
      Yt !== null && typeof Yt.markComponentRenderStopped == "function" && Yt.markComponentRenderStopped();
    }
    function cs(d) {
      Yt !== null && typeof Yt.markComponentPassiveEffectMountStarted == "function" && Yt.markComponentPassiveEffectMountStarted(d);
    }
    function Os() {
      Yt !== null && typeof Yt.markComponentPassiveEffectMountStopped == "function" && Yt.markComponentPassiveEffectMountStopped();
    }
    function ji(d) {
      Yt !== null && typeof Yt.markComponentPassiveEffectUnmountStarted == "function" && Yt.markComponentPassiveEffectUnmountStarted(d);
    }
    function ro() {
      Yt !== null && typeof Yt.markComponentPassiveEffectUnmountStopped == "function" && Yt.markComponentPassiveEffectUnmountStopped();
    }
    function Pm(d) {
      Yt !== null && typeof Yt.markComponentLayoutEffectMountStarted == "function" && Yt.markComponentLayoutEffectMountStarted(d);
    }
    function Xs() {
      Yt !== null && typeof Yt.markComponentLayoutEffectMountStopped == "function" && Yt.markComponentLayoutEffectMountStopped();
    }
    function Dh(d) {
      Yt !== null && typeof Yt.markComponentLayoutEffectUnmountStarted == "function" && Yt.markComponentLayoutEffectUnmountStarted(d);
    }
    function lf() {
      Yt !== null && typeof Yt.markComponentLayoutEffectUnmountStopped == "function" && Yt.markComponentLayoutEffectUnmountStopped();
    }
    function bs(d, h, C) {
      Yt !== null && typeof Yt.markComponentErrored == "function" && Yt.markComponentErrored(d, h, C);
    }
    function Ip(d, h, C) {
      Yt !== null && typeof Yt.markComponentSuspended == "function" && Yt.markComponentSuspended(d, h, C);
    }
    function Om(d) {
      Yt !== null && typeof Yt.markLayoutEffectsStarted == "function" && Yt.markLayoutEffectsStarted(d);
    }
    function vl() {
      Yt !== null && typeof Yt.markLayoutEffectsStopped == "function" && Yt.markLayoutEffectsStopped();
    }
    function Fp(d) {
      Yt !== null && typeof Yt.markPassiveEffectsStarted == "function" && Yt.markPassiveEffectsStarted(d);
    }
    function Ph() {
      Yt !== null && typeof Yt.markPassiveEffectsStopped == "function" && Yt.markPassiveEffectsStopped();
    }
    function Sn(d) {
      Yt !== null && typeof Yt.markRenderStarted == "function" && Yt.markRenderStarted(d);
    }
    function Mn() {
      Yt !== null && typeof Yt.markRenderYielded == "function" && Yt.markRenderYielded();
    }
    function ar() {
      Yt !== null && typeof Yt.markRenderStopped == "function" && Yt.markRenderStopped();
    }
    function $r(d) {
      Yt !== null && typeof Yt.markRenderScheduled == "function" && Yt.markRenderScheduled(d);
    }
    function Fi(d, h) {
      Yt !== null && typeof Yt.markForceUpdateScheduled == "function" && Yt.markForceUpdateScheduled(d, h);
    }
    function hd(d, h) {
      Yt !== null && typeof Yt.markStateUpdateScheduled == "function" && Yt.markStateUpdateScheduled(d, h);
    }
    function Ou(d, h) {
      return d === h && (d !== 0 || 1 / d === 1 / h) || d !== d && h !== h;
    }
    var xl = typeof Object.is == "function" ? Object.is : Ou, us = null, $f = !1, St = !1;
    function Qs(d) {
      us === null ? us = [d] : us.push(d);
    }
    function hn(d) {
      $f = !0, Qs(d);
    }
    function As() {
      $f && va();
    }
    function va() {
      if (!St && us !== null) {
        St = !0;
        var d = 0, h = hc();
        try {
          var C = !0, M = us;
          for (gi(ii); d < M.length; d++) {
            var A = M[d];
            do
              A = A(C);
            while (A !== null);
          }
          us = null, $f = !1;
        } catch (W) {
          throw us !== null && (us = us.slice(d + 1)), Ni(Yc, va), W;
        } finally {
          gi(h), St = !1;
        }
      }
      return null;
    }
    function oi(d) {
      var h = d.current.memoizedState;
      return h.isDehydrated;
    }
    var xo = [], Kc = 0, Au = null, Gf = 0, yi = [], bl = 0, pd = null, yc = 1, bo = "";
    function Am(d) {
      return vc(), (d.flags & _e) !== Nt;
    }
    function eg(d) {
      return vc(), Gf;
    }
    function Lm() {
      var d = bo, h = yc, C = h & ~ng(h);
      return C.toString(32) + d;
    }
    function $l(d, h) {
      vc(), xo[Kc++] = Gf, xo[Kc++] = Au, Au = d, Gf = h;
    }
    function tg(d, h, C) {
      vc(), yi[bl++] = yc, yi[bl++] = bo, yi[bl++] = pd, pd = d;
      var M = yc, A = bo, W = Im(M) - 1, ae = M & ~(1 << W), de = C + 1, ge = Im(h) + W;
      if (ge > 30) {
        var Ce = W - W % 5, Me = (1 << Ce) - 1, $e = (ae & Me).toString(32), at = ae >> Ce, yt = W - Ce, Ct = Im(h) + yt, Et = de << yt, Pn = Et | at, yr = $e + A;
        yc = 1 << Ct | Pn, bo = yr;
      } else {
        var Zn = de << W, ms = Zn | ae, fa = A;
        yc = 1 << ge | ms, bo = fa;
      }
    }
    function Oh(d) {
      vc();
      var h = d.return;
      if (h !== null) {
        var C = 1, M = 0;
        $l(d, C), tg(d, C, M);
      }
    }
    function Im(d) {
      return 32 - id(d);
    }
    function ng(d) {
      return 1 << Im(d) - 1;
    }
    function Lu(d) {
      for (; d === Au; )
        Au = xo[--Kc], xo[Kc] = null, Gf = xo[--Kc], xo[Kc] = null;
      for (; d === pd; )
        pd = yi[--bl], yi[bl] = null, bo = yi[--bl], yi[bl] = null, yc = yi[--bl], yi[bl] = null;
    }
    function h0() {
      return vc(), pd !== null ? {
        id: yc,
        overflow: bo
      } : null;
    }
    function Iu(d, h) {
      vc(), yi[bl++] = yc, yi[bl++] = bo, yi[bl++] = pd, yc = h.id, bo = h.overflow, pd = d;
    }
    function vc() {
      B() || y("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var Ir = null, Gl = null, xc = !1, gd = !1, Wf = null;
    function Up() {
      xc && y("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function rg() {
      gd = !0;
    }
    function zp() {
      return gd;
    }
    function ao(d) {
      if (!Oo)
        return !1;
      var h = d.stateNode.containerInfo;
      return Gl = Ja(h), Ir = d, xc = !0, Wf = null, gd = !1, !0;
    }
    function So(d, h, C) {
      return Oo ? (Gl = vs(h), Ir = d, xc = !0, Wf = null, gd = !1, C !== null && Iu(d, C), !0) : !1;
    }
    function mx(d, h) {
      switch (d.tag) {
        case Q: {
          cx(d.stateNode.containerInfo, h);
          break;
        }
        case X: {
          var C = (d.mode & na) !== Qn;
          ux(
            d.type,
            d.memoizedProps,
            d.stateNode,
            h,
            // TODO: Delete this argument when we remove the legacy root API.
            C
          );
          break;
        }
        case ue: {
          var M = d.memoizedState;
          M.dehydrated !== null && z1(M.dehydrated, h);
          break;
        }
      }
    }
    function da(d, h) {
      mx(d, h);
      var C = zC();
      C.stateNode = h, C.return = d;
      var M = d.deletions;
      M === null ? (d.deletions = [C], d.flags |= hr) : M.push(C);
    }
    function Yf(d, h) {
      {
        if (gd)
          return;
        switch (d.tag) {
          case Q: {
            var C = d.stateNode.containerInfo;
            switch (h.tag) {
              case X:
                var M = h.type, A = h.pendingProps;
                vh(C, M, A);
                break;
              case se:
                var W = h.pendingProps;
                Nu(C, W);
                break;
              case ue:
                dx(C);
                break;
            }
            break;
          }
          case X: {
            var ae = d.type, de = d.memoizedProps, ge = d.stateNode;
            switch (h.tag) {
              case X: {
                var Ce = h.type, Me = h.pendingProps, $e = (d.mode & na) !== Qn;
                l0(
                  ae,
                  de,
                  ge,
                  Ce,
                  Me,
                  // TODO: Delete this argument when we remove the legacy root API.
                  $e
                );
                break;
              }
              case se: {
                var at = h.pendingProps, yt = (d.mode & na) !== Qn;
                xh(
                  ae,
                  de,
                  ge,
                  at,
                  // TODO: Delete this argument when we remove the legacy root API.
                  yt
                );
                break;
              }
              case ue: {
                bh(ae, de, ge);
                break;
              }
            }
            break;
          }
          case ue: {
            var Ct = d.memoizedState, Et = Ct.dehydrated;
            if (Et !== null) switch (h.tag) {
              case X:
                var Pn = h.type, yr = h.pendingProps;
                i0(Et, Pn, yr);
                break;
              case se:
                var Zn = h.pendingProps;
                Of(Et, Zn);
                break;
              case ue:
                o0(Et);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function Ei(d, h) {
      h.flags = h.flags & ~Mo | wn, Yf(d, h);
    }
    function yd(d, h) {
      switch (d.tag) {
        case X: {
          var C = d.type, M = d.pendingProps, A = Ac(h, C, M);
          return A !== null ? (d.stateNode = A, Ir = d, Gl = Lo(A), !0) : !1;
        }
        case se: {
          var W = d.pendingProps, ae = Qi(h, W);
          return ae !== null ? (d.stateNode = ae, Ir = d, Gl = null, !0) : !1;
        }
        case ue: {
          var de = hl(h);
          if (de !== null) {
            var ge = {
              dehydrated: de,
              treeContext: h0(),
              retryLane: gl
            };
            d.memoizedState = ge;
            var Ce = US(de);
            return Ce.return = d, d.child = Ce, Ir = d, Gl = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function vd(d) {
      return (d.mode & na) !== Qn && (d.flags & Cr) === Nt;
    }
    function Bp(d) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function p0(d) {
      if (xc) {
        var h = Gl;
        if (!h) {
          vd(d) && (Yf(Ir, d), Bp()), Ei(Ir, d), xc = !1, Ir = d;
          return;
        }
        var C = h;
        if (!yd(d, h)) {
          vd(d) && (Yf(Ir, d), Bp()), h = Sm(C);
          var M = Ir;
          if (!h || !yd(d, h)) {
            Ei(Ir, d), xc = !1, Ir = d;
            return;
          }
          da(M, C);
        }
      }
    }
    function Ay(d, h, C) {
      if (!Oo)
        throw new Error("Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
      var M = d.stateNode, A = !gd, W = Tp(M, d.type, d.memoizedProps, h, C, d, A);
      return d.updateQueue = W, W !== null;
    }
    function g0(d) {
      if (!Oo)
        throw new Error("Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
      var h = d.stateNode, C = d.memoizedProps, M = !gd, A = Cu(h, C, d, M);
      if (A) {
        var W = Ir;
        if (W !== null)
          switch (W.tag) {
            case Q: {
              var ae = W.stateNode.containerInfo, de = (W.mode & na) !== Qn;
              wm(
                ae,
                h,
                C,
                // TODO: Delete this argument when we remove the legacy root API.
                de
              );
              break;
            }
            case X: {
              var ge = W.type, Ce = W.memoizedProps, Me = W.stateNode, $e = (W.mode & na) !== Qn;
              U1(
                ge,
                Ce,
                Me,
                h,
                C,
                // TODO: Delete this argument when we remove the legacy root API.
                $e
              );
              break;
            }
          }
      }
      return A;
    }
    function qf(d) {
      if (!Oo)
        throw new Error("Expected prepareToHydrateHostSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
      var h = d.memoizedState, C = h !== null ? h.dehydrated : null;
      if (!C)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      ix(C, d);
    }
    function y0(d) {
      if (!Oo)
        throw new Error("Expected skipPastDehydratedSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
      var h = d.memoizedState, C = h !== null ? h.dehydrated : null;
      if (!C)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return Pf(C);
    }
    function Kf(d) {
      for (var h = d.return; h !== null && h.tag !== X && h.tag !== Q && h.tag !== ue; )
        h = h.return;
      Ir = h;
    }
    function ag(d) {
      if (!Oo || d !== Ir)
        return !1;
      if (!xc)
        return Kf(d), xc = !0, !1;
      if (d.tag !== Q && (d.tag !== X || lx(d.type) && !fh(d.type, d.memoizedProps))) {
        var h = Gl;
        if (h)
          if (vd(d))
            v(d), Bp();
          else
            for (; h; )
              da(d, h), h = Sm(h);
      }
      return Kf(d), d.tag === ue ? Gl = y0(d) : Gl = Ir ? Sm(d.stateNode) : null, !0;
    }
    function hx() {
      return xc && Gl !== null;
    }
    function v(d) {
      for (var h = Gl; h; )
        mx(d, h), h = Sm(h);
    }
    function x() {
      Oo && (Ir = null, Gl = null, xc = !1, gd = !1);
    }
    function P() {
      Wf !== null && (Yb(Wf), Wf = null);
    }
    function B() {
      return xc;
    }
    function G(d) {
      Wf === null ? Wf = [d] : Wf.push(d);
    }
    var ne = o.ReactCurrentBatchConfig, be = null;
    function Fe() {
      return ne.transition;
    }
    function Ze(d, h) {
      if (xl(d, h))
        return !0;
      if (typeof d != "object" || d === null || typeof h != "object" || h === null)
        return !1;
      var C = Object.keys(d), M = Object.keys(h);
      if (C.length !== M.length)
        return !1;
      for (var A = 0; A < C.length; A++) {
        var W = C[A];
        if (!Lf.call(h, W) || !xl(d[W], h[W]))
          return !1;
      }
      return !0;
    }
    function Ft(d) {
      switch (d._debugOwner && d._debugOwner.type, d._debugSource, d.tag) {
        case X:
          return Io(d.type);
        case Te:
          return Io("Lazy");
        case ue:
          return Io("Suspense");
        case qe:
          return Io("SuspenseList");
        case H:
        case q:
        case ve:
          return ju(d.type);
        case Se:
          return ju(d.type.render);
        case K:
          return Sh(d.type);
        default:
          return "";
      }
    }
    function sn(d) {
      try {
        var h = "", C = d;
        do
          h += Ft(C), C = C.return;
        while (C);
        return h;
      } catch (M) {
        return `
Error generating stack: ` + M.message + `
` + M.stack;
      }
    }
    var dr = o.ReactDebugCurrentFrame, ct = null, xa = !1;
    function Ga() {
      {
        if (ct === null)
          return null;
        var d = ct._debugOwner;
        if (d !== null && typeof d < "u")
          return lt(d);
      }
      return null;
    }
    function bc() {
      return ct === null ? "" : sn(ct);
    }
    function Zs() {
      dr.getCurrentStack = null, ct = null, xa = !1;
    }
    function Be(d) {
      dr.getCurrentStack = d === null ? null : bc, ct = d, xa = !1;
    }
    function ze() {
      return ct;
    }
    function rt(d) {
      xa = d;
    }
    var Jt = {
      recordUnsafeLifecycleWarnings: function(d, h) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(d, h) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var Yn = function(d) {
        for (var h = null, C = d; C !== null; )
          C.mode & $s && (h = C), C = C.return;
        return h;
      }, pr = function(d) {
        var h = [];
        return d.forEach(function(C) {
          h.push(C);
        }), h.sort().join(", ");
      }, gr = [], Kr = [], Js = [], Wr = [], Ea = [], Xc = [], Sc = /* @__PURE__ */ new Set();
      Jt.recordUnsafeLifecycleWarnings = function(d, h) {
        Sc.has(d.type) || (typeof h.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        h.componentWillMount.__suppressDeprecationWarning !== !0 && gr.push(d), d.mode & $s && typeof h.UNSAFE_componentWillMount == "function" && Kr.push(d), typeof h.componentWillReceiveProps == "function" && h.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Js.push(d), d.mode & $s && typeof h.UNSAFE_componentWillReceiveProps == "function" && Wr.push(d), typeof h.componentWillUpdate == "function" && h.componentWillUpdate.__suppressDeprecationWarning !== !0 && Ea.push(d), d.mode & $s && typeof h.UNSAFE_componentWillUpdate == "function" && Xc.push(d));
      }, Jt.flushPendingUnsafeLifecycleWarnings = function() {
        var d = /* @__PURE__ */ new Set();
        gr.length > 0 && (gr.forEach(function(at) {
          d.add(lt(at) || "Component"), Sc.add(at.type);
        }), gr = []);
        var h = /* @__PURE__ */ new Set();
        Kr.length > 0 && (Kr.forEach(function(at) {
          h.add(lt(at) || "Component"), Sc.add(at.type);
        }), Kr = []);
        var C = /* @__PURE__ */ new Set();
        Js.length > 0 && (Js.forEach(function(at) {
          C.add(lt(at) || "Component"), Sc.add(at.type);
        }), Js = []);
        var M = /* @__PURE__ */ new Set();
        Wr.length > 0 && (Wr.forEach(function(at) {
          M.add(lt(at) || "Component"), Sc.add(at.type);
        }), Wr = []);
        var A = /* @__PURE__ */ new Set();
        Ea.length > 0 && (Ea.forEach(function(at) {
          A.add(lt(at) || "Component"), Sc.add(at.type);
        }), Ea = []);
        var W = /* @__PURE__ */ new Set();
        if (Xc.length > 0 && (Xc.forEach(function(at) {
          W.add(lt(at) || "Component"), Sc.add(at.type);
        }), Xc = []), h.size > 0) {
          var ae = pr(h);
          y(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, ae);
        }
        if (M.size > 0) {
          var de = pr(M);
          y(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, de);
        }
        if (W.size > 0) {
          var ge = pr(W);
          y(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, ge);
        }
        if (d.size > 0) {
          var Ce = pr(d);
          m(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Ce);
        }
        if (C.size > 0) {
          var Me = pr(C);
          m(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Me);
        }
        if (A.size > 0) {
          var $e = pr(A);
          m(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, $e);
        }
      };
      var Ah = /* @__PURE__ */ new Map(), sg = /* @__PURE__ */ new Set();
      Jt.recordLegacyContextWarning = function(d, h) {
        var C = Yn(d);
        if (C === null) {
          y("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!sg.has(d.type)) {
          var M = Ah.get(C);
          (d.type.contextTypes != null || d.type.childContextTypes != null || h !== null && typeof h.getChildContext == "function") && (M === void 0 && (M = [], Ah.set(C, M)), M.push(d));
        }
      }, Jt.flushLegacyContextWarning = function() {
        Ah.forEach(function(d, h) {
          if (d.length !== 0) {
            var C = d[0], M = /* @__PURE__ */ new Set();
            d.forEach(function(W) {
              M.add(lt(W) || "Component"), sg.add(W.type);
            });
            var A = pr(M);
            try {
              Be(C), y(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, A);
            } finally {
              Zs();
            }
          }
        });
      }, Jt.discardPendingWarnings = function() {
        gr = [], Kr = [], Js = [], Wr = [], Ea = [], Xc = [], Ah = /* @__PURE__ */ new Map();
      };
    }
    function xd(d) {
      {
        var h = typeof Symbol == "function" && Symbol.toStringTag, C = h && d[Symbol.toStringTag] || d.constructor.name || "Object";
        return C;
      }
    }
    function ki(d) {
      try {
        return Sl(d), !1;
      } catch {
        return !0;
      }
    }
    function Sl(d) {
      return "" + d;
    }
    function Mw(d) {
      if (ki(d))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", xd(d)), Sl(d);
    }
    function Rw(d, h) {
      if (ki(d))
        return y("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", h, xd(d)), Sl(d);
    }
    var Hp, zo, v0, kn, Vp, px = function(d, h) {
    };
    Hp = !1, zo = !1, v0 = {}, kn = {}, Vp = {}, px = function(d, h) {
      if (!(d === null || typeof d != "object") && !(!d._store || d._store.validated || d.key != null)) {
        if (typeof d._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        d._store.validated = !0;
        var C = lt(h) || "Component";
        kn[C] || (kn[C] = !0, y('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function gx(d) {
      return d.prototype && d.prototype.isReactComponent;
    }
    function Ly(d, h, C) {
      var M = C.ref;
      if (M !== null && typeof M != "function" && typeof M != "object") {
        if ((d.mode & $s || I) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(C._owner && C._self && C._owner.stateNode !== C._self) && // Will already throw with "Function components cannot have string refs"
        !(C._owner && C._owner.tag !== K) && // Will already warn with "Function components cannot be given refs"
        !(typeof C.type == "function" && !gx(C.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        C._owner) {
          var A = lt(d) || "Component";
          v0[A] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', A, M), v0[A] = !0);
        }
        if (C._owner) {
          var W = C._owner, ae;
          if (W) {
            var de = W;
            if (de.tag !== K)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            ae = de.stateNode;
          }
          if (!ae)
            throw new Error("Missing owner for string ref " + M + ". This error is likely caused by a bug in React. Please file an issue.");
          var ge = ae;
          Rw(M, "ref");
          var Ce = "" + M;
          if (h !== null && h.ref !== null && typeof h.ref == "function" && h.ref._stringRef === Ce)
            return h.ref;
          var Me = function($e) {
            var at = ge.refs;
            $e === null ? delete at[Ce] : at[Ce] = $e;
          };
          return Me._stringRef = Ce, Me;
        } else {
          if (typeof M != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!C._owner)
            throw new Error("Element ref was specified as a string (" + M + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return M;
    }
    function Lh(d, h) {
      var C = Object.prototype.toString.call(h);
      throw new Error("Objects are not valid as a React child (found: " + (C === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : C) + "). If you meant to render a collection of children, use an array instead.");
    }
    function ig(d) {
      {
        var h = lt(d) || "Component";
        if (Vp[h])
          return;
        Vp[h] = !0, y("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function Iy(d) {
      var h = d._payload, C = d._init;
      return C(h);
    }
    function ib(d) {
      function h(Qe, mt) {
        if (d) {
          var Ke = Qe.deletions;
          Ke === null ? (Qe.deletions = [mt], Qe.flags |= hr) : Ke.push(mt);
        }
      }
      function C(Qe, mt) {
        if (!d)
          return null;
        for (var Ke = mt; Ke !== null; )
          h(Qe, Ke), Ke = Ke.sibling;
        return null;
      }
      function M(Qe, mt) {
        for (var Ke = /* @__PURE__ */ new Map(), $t = mt; $t !== null; )
          $t.key !== null ? Ke.set($t.key, $t) : Ke.set($t.index, $t), $t = $t.sibling;
        return Ke;
      }
      function A(Qe, mt) {
        var Ke = $0(Qe, mt);
        return Ke.index = 0, Ke.sibling = null, Ke;
      }
      function W(Qe, mt, Ke) {
        if (Qe.index = Ke, !d)
          return Qe.flags |= _e, mt;
        var $t = Qe.alternate;
        if ($t !== null) {
          var Un = $t.index;
          return Un < mt ? (Qe.flags |= wn, mt) : Un;
        } else
          return Qe.flags |= wn, mt;
      }
      function ae(Qe) {
        return d && Qe.alternate === null && (Qe.flags |= wn), Qe;
      }
      function de(Qe, mt, Ke, $t) {
        if (mt === null || mt.tag !== se) {
          var Un = mv(Ke, Qe.mode, $t);
          return Un.return = Qe, Un;
        } else {
          var gn = A(mt, Ke);
          return gn.return = Qe, gn;
        }
      }
      function ge(Qe, mt, Ke, $t) {
        var Un = Ke.type;
        if (Un === He)
          return Me(Qe, mt, Ke.props.children, $t, Ke.key);
        if (mt !== null && (mt.elementType === Un || // Keep this check inline so it only runs on the false path:
        LC(mt, Ke) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Un == "object" && Un !== null && Un.$$typeof === ot && Iy(Un) === mt.type)) {
          var gn = A(mt, Ke.props);
          return gn.ref = Ly(Qe, mt, Ke), gn.return = Qe, gn._debugSource = Ke._source, gn._debugOwner = Ke._owner, gn;
        }
        var ma = fv(Ke, Qe.mode, $t);
        return ma.ref = Ly(Qe, mt, Ke), ma.return = Qe, ma;
      }
      function Ce(Qe, mt, Ke, $t) {
        if (mt === null || mt.tag !== Z || mt.stateNode.containerInfo !== Ke.containerInfo || mt.stateNode.implementation !== Ke.implementation) {
          var Un = i4(Ke, Qe.mode, $t);
          return Un.return = Qe, Un;
        } else {
          var gn = A(mt, Ke.children || []);
          return gn.return = Qe, gn;
        }
      }
      function Me(Qe, mt, Ke, $t, Un) {
        if (mt === null || mt.tag !== te) {
          var gn = l1(Ke, Qe.mode, $t, Un);
          return gn.return = Qe, gn;
        } else {
          var ma = A(mt, Ke);
          return ma.return = Qe, ma;
        }
      }
      function $e(Qe, mt, Ke) {
        if (typeof mt == "string" && mt !== "" || typeof mt == "number") {
          var $t = mv("" + mt, Qe.mode, Ke);
          return $t.return = Qe, $t;
        }
        if (typeof mt == "object" && mt !== null) {
          switch (mt.$$typeof) {
            case vt: {
              var Un = fv(mt, Qe.mode, Ke);
              return Un.ref = Ly(Qe, null, mt), Un.return = Qe, Un;
            }
            case At: {
              var gn = i4(mt, Qe.mode, Ke);
              return gn.return = Qe, gn;
            }
            case ot: {
              var ma = mt._payload, Sr = mt._init;
              return $e(Qe, Sr(ma), Ke);
            }
          }
          if (xr(mt) || Ot(mt)) {
            var _a = l1(mt, Qe.mode, Ke, null);
            return _a.return = Qe, _a;
          }
          Lh(Qe, mt);
        }
        return typeof mt == "function" && ig(Qe), null;
      }
      function at(Qe, mt, Ke, $t) {
        var Un = mt !== null ? mt.key : null;
        if (typeof Ke == "string" && Ke !== "" || typeof Ke == "number")
          return Un !== null ? null : de(Qe, mt, "" + Ke, $t);
        if (typeof Ke == "object" && Ke !== null) {
          switch (Ke.$$typeof) {
            case vt:
              return Ke.key === Un ? ge(Qe, mt, Ke, $t) : null;
            case At:
              return Ke.key === Un ? Ce(Qe, mt, Ke, $t) : null;
            case ot: {
              var gn = Ke._payload, ma = Ke._init;
              return at(Qe, mt, ma(gn), $t);
            }
          }
          if (xr(Ke) || Ot(Ke))
            return Un !== null ? null : Me(Qe, mt, Ke, $t, null);
          Lh(Qe, Ke);
        }
        return typeof Ke == "function" && ig(Qe), null;
      }
      function yt(Qe, mt, Ke, $t, Un) {
        if (typeof $t == "string" && $t !== "" || typeof $t == "number") {
          var gn = Qe.get(Ke) || null;
          return de(mt, gn, "" + $t, Un);
        }
        if (typeof $t == "object" && $t !== null) {
          switch ($t.$$typeof) {
            case vt: {
              var ma = Qe.get($t.key === null ? Ke : $t.key) || null;
              return ge(mt, ma, $t, Un);
            }
            case At: {
              var Sr = Qe.get($t.key === null ? Ke : $t.key) || null;
              return Ce(mt, Sr, $t, Un);
            }
            case ot:
              var _a = $t._payload, ua = $t._init;
              return yt(Qe, mt, Ke, ua(_a), Un);
          }
          if (xr($t) || Ot($t)) {
            var ci = Qe.get(Ke) || null;
            return Me(mt, ci, $t, Un, null);
          }
          Lh(mt, $t);
        }
        return typeof $t == "function" && ig(mt), null;
      }
      function Ct(Qe, mt, Ke) {
        {
          if (typeof Qe != "object" || Qe === null)
            return mt;
          switch (Qe.$$typeof) {
            case vt:
            case At:
              px(Qe, Ke);
              var $t = Qe.key;
              if (typeof $t != "string")
                break;
              if (mt === null) {
                mt = /* @__PURE__ */ new Set(), mt.add($t);
                break;
              }
              if (!mt.has($t)) {
                mt.add($t);
                break;
              }
              y("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", $t);
              break;
            case ot:
              var Un = Qe._payload, gn = Qe._init;
              Ct(gn(Un), mt, Ke);
              break;
          }
        }
        return mt;
      }
      function Et(Qe, mt, Ke, $t) {
        for (var Un = null, gn = 0; gn < Ke.length; gn++) {
          var ma = Ke[gn];
          Un = Ct(ma, Un, Qe);
        }
        for (var Sr = null, _a = null, ua = mt, ci = 0, lr = 0, lo = null; ua !== null && lr < Ke.length; lr++) {
          ua.index > lr ? (lo = ua, ua = null) : lo = ua.sibling;
          var Yu = at(Qe, ua, Ke[lr], $t);
          if (Yu === null) {
            ua === null && (ua = lo);
            break;
          }
          d && ua && Yu.alternate === null && h(Qe, ua), ci = W(Yu, ci, lr), _a === null ? Sr = Yu : _a.sibling = Yu, _a = Yu, ua = lo;
        }
        if (lr === Ke.length) {
          if (C(Qe, ua), B()) {
            var Nc = lr;
            $l(Qe, Nc);
          }
          return Sr;
        }
        if (ua === null) {
          for (; lr < Ke.length; lr++) {
            var _d = $e(Qe, Ke[lr], $t);
            _d !== null && (ci = W(_d, ci, lr), _a === null ? Sr = _d : _a.sibling = _d, _a = _d);
          }
          if (B()) {
            var Td = lr;
            $l(Qe, Td);
          }
          return Sr;
        }
        for (var Md = M(Qe, ua); lr < Ke.length; lr++) {
          var jo = yt(Md, Qe, lr, Ke[lr], $t);
          jo !== null && (d && jo.alternate !== null && Md.delete(jo.key === null ? lr : jo.key), ci = W(jo, ci, lr), _a === null ? Sr = jo : _a.sibling = jo, _a = jo);
        }
        if (d && Md.forEach(function(Qx) {
          return h(Qe, Qx);
        }), B()) {
          var rp = lr;
          $l(Qe, rp);
        }
        return Sr;
      }
      function Pn(Qe, mt, Ke, $t) {
        var Un = Ot(Ke);
        if (typeof Un != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          Ke[Symbol.toStringTag] === "Generator" && (zo || y("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), zo = !0), Ke.entries === Un && (Hp || y("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Hp = !0);
          var gn = Un.call(Ke);
          if (gn)
            for (var ma = null, Sr = gn.next(); !Sr.done; Sr = gn.next()) {
              var _a = Sr.value;
              ma = Ct(_a, ma, Qe);
            }
        }
        var ua = Un.call(Ke);
        if (ua == null)
          throw new Error("An iterable object provided no iterator.");
        for (var ci = null, lr = null, lo = mt, Yu = 0, Nc = 0, _d = null, Td = ua.next(); lo !== null && !Td.done; Nc++, Td = ua.next()) {
          lo.index > Nc ? (_d = lo, lo = null) : _d = lo.sibling;
          var Md = at(Qe, lo, Td.value, $t);
          if (Md === null) {
            lo === null && (lo = _d);
            break;
          }
          d && lo && Md.alternate === null && h(Qe, lo), Yu = W(Md, Yu, Nc), lr === null ? ci = Md : lr.sibling = Md, lr = Md, lo = _d;
        }
        if (Td.done) {
          if (C(Qe, lo), B()) {
            var jo = Nc;
            $l(Qe, jo);
          }
          return ci;
        }
        if (lo === null) {
          for (; !Td.done; Nc++, Td = ua.next()) {
            var rp = $e(Qe, Td.value, $t);
            rp !== null && (Yu = W(rp, Yu, Nc), lr === null ? ci = rp : lr.sibling = rp, lr = rp);
          }
          if (B()) {
            var Qx = Nc;
            $l(Qe, Qx);
          }
          return ci;
        }
        for (var hv = M(Qe, lo); !Td.done; Nc++, Td = ua.next()) {
          var c1 = yt(hv, Qe, Nc, Td.value, $t);
          c1 !== null && (d && c1.alternate !== null && hv.delete(c1.key === null ? Nc : c1.key), Yu = W(c1, Yu, Nc), lr === null ? ci = c1 : lr.sibling = c1, lr = c1);
        }
        if (d && hv.forEach(function(t7) {
          return h(Qe, t7);
        }), B()) {
          var zN = Nc;
          $l(Qe, zN);
        }
        return ci;
      }
      function yr(Qe, mt, Ke, $t) {
        if (mt !== null && mt.tag === se) {
          C(Qe, mt.sibling);
          var Un = A(mt, Ke);
          return Un.return = Qe, Un;
        }
        C(Qe, mt);
        var gn = mv(Ke, Qe.mode, $t);
        return gn.return = Qe, gn;
      }
      function Zn(Qe, mt, Ke, $t) {
        for (var Un = Ke.key, gn = mt; gn !== null; ) {
          if (gn.key === Un) {
            var ma = Ke.type;
            if (ma === He) {
              if (gn.tag === te) {
                C(Qe, gn.sibling);
                var Sr = A(gn, Ke.props.children);
                return Sr.return = Qe, Sr._debugSource = Ke._source, Sr._debugOwner = Ke._owner, Sr;
              }
            } else if (gn.elementType === ma || // Keep this check inline so it only runs on the false path:
            LC(gn, Ke) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof ma == "object" && ma !== null && ma.$$typeof === ot && Iy(ma) === gn.type) {
              C(Qe, gn.sibling);
              var _a = A(gn, Ke.props);
              return _a.ref = Ly(Qe, gn, Ke), _a.return = Qe, _a._debugSource = Ke._source, _a._debugOwner = Ke._owner, _a;
            }
            C(Qe, gn);
            break;
          } else
            h(Qe, gn);
          gn = gn.sibling;
        }
        if (Ke.type === He) {
          var ua = l1(Ke.props.children, Qe.mode, $t, Ke.key);
          return ua.return = Qe, ua;
        } else {
          var ci = fv(Ke, Qe.mode, $t);
          return ci.ref = Ly(Qe, mt, Ke), ci.return = Qe, ci;
        }
      }
      function ms(Qe, mt, Ke, $t) {
        for (var Un = Ke.key, gn = mt; gn !== null; ) {
          if (gn.key === Un)
            if (gn.tag === Z && gn.stateNode.containerInfo === Ke.containerInfo && gn.stateNode.implementation === Ke.implementation) {
              C(Qe, gn.sibling);
              var ma = A(gn, Ke.children || []);
              return ma.return = Qe, ma;
            } else {
              C(Qe, gn);
              break;
            }
          else
            h(Qe, gn);
          gn = gn.sibling;
        }
        var Sr = i4(Ke, Qe.mode, $t);
        return Sr.return = Qe, Sr;
      }
      function fa(Qe, mt, Ke, $t) {
        var Un = typeof Ke == "object" && Ke !== null && Ke.type === He && Ke.key === null;
        if (Un && (Ke = Ke.props.children), typeof Ke == "object" && Ke !== null) {
          switch (Ke.$$typeof) {
            case vt:
              return ae(Zn(Qe, mt, Ke, $t));
            case At:
              return ae(ms(Qe, mt, Ke, $t));
            case ot:
              var gn = Ke._payload, ma = Ke._init;
              return fa(Qe, mt, ma(gn), $t);
          }
          if (xr(Ke))
            return Et(Qe, mt, Ke, $t);
          if (Ot(Ke))
            return Pn(Qe, mt, Ke, $t);
          Lh(Qe, Ke);
        }
        return typeof Ke == "string" && Ke !== "" || typeof Ke == "number" ? ae(yr(Qe, mt, "" + Ke, $t)) : (typeof Ke == "function" && ig(Qe), C(Qe, mt));
      }
      return fa;
    }
    var $p = ib(!0), ob = ib(!1);
    function Fy(d, h) {
      if (d !== null && h.child !== d.child)
        throw new Error("Resuming work not yet implemented.");
      if (h.child !== null) {
        var C = h.child, M = $0(C, C.pendingProps);
        for (h.child = M, M.return = h; C.sibling !== null; )
          C = C.sibling, M = M.sibling = $0(C, C.pendingProps), M.return = h;
        M.sibling = null;
      }
    }
    function x0(d, h) {
      for (var C = d.child; C !== null; )
        LS(C, h), C = C.sibling;
    }
    var Ls = ad(null), Ui;
    Ui = {};
    var wl = null, Xf = null, Gp = null, so = !1;
    function Uy() {
      wl = null, Xf = null, Gp = null, so = !1;
    }
    function Qf() {
      so = !0;
    }
    function E5() {
      so = !1;
    }
    function yx(d, h, C) {
      n0 ? (Pa(Ls, h._currentValue, d), h._currentValue = C, h._currentRenderer !== void 0 && h._currentRenderer !== null && h._currentRenderer !== Ui && y("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), h._currentRenderer = Ui) : (Pa(Ls, h._currentValue2, d), h._currentValue2 = C, h._currentRenderer2 !== void 0 && h._currentRenderer2 !== null && h._currentRenderer2 !== Ui && y("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), h._currentRenderer2 = Ui);
    }
    function Wp(d, h) {
      var C = Ls.current;
      yo(Ls, h), n0 ? d._currentValue = C : d._currentValue2 = C;
    }
    function vx(d, h, C) {
      for (var M = d; M !== null; ) {
        var A = M.alternate;
        if (pi(M.childLanes, h) ? A !== null && !pi(A.childLanes, h) && (A.childLanes = Wn(A.childLanes, h)) : (M.childLanes = Wn(M.childLanes, h), A !== null && (A.childLanes = Wn(A.childLanes, h))), M === C)
          break;
        M = M.return;
      }
      M !== C && y("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function lb(d, h, C) {
      Dw(d, h, C);
    }
    function Dw(d, h, C) {
      var M = d.child;
      for (M !== null && (M.return = d); M !== null; ) {
        var A = void 0, W = M.dependencies;
        if (W !== null) {
          A = M.child;
          for (var ae = W.firstContext; ae !== null; ) {
            if (ae.context === h) {
              if (M.tag === K) {
                var de = rf(C), ge = Jf($a, de);
                ge.tag = b0;
                var Ce = M.updateQueue;
                if (Ce !== null) {
                  var Me = Ce.shared, $e = Me.pending;
                  $e === null ? ge.next = ge : (ge.next = $e.next, $e.next = ge), Me.pending = ge;
                }
              }
              M.lanes = Wn(M.lanes, C);
              var at = M.alternate;
              at !== null && (at.lanes = Wn(at.lanes, C)), vx(M.return, C, d), W.lanes = Wn(W.lanes, C);
              break;
            }
            ae = ae.next;
          }
        } else if (M.tag === pe)
          A = M.type === d.type ? null : M.child;
        else if (M.tag === Ue) {
          var yt = M.return;
          if (yt === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          yt.lanes = Wn(yt.lanes, C);
          var Ct = yt.alternate;
          Ct !== null && (Ct.lanes = Wn(Ct.lanes, C)), vx(yt, C, d), A = M.sibling;
        } else
          A = M.child;
        if (A !== null)
          A.return = M;
        else
          for (A = M; A !== null; ) {
            if (A === d) {
              A = null;
              break;
            }
            var Et = A.sibling;
            if (Et !== null) {
              Et.return = A.return, A = Et;
              break;
            }
            A = A.return;
          }
        M = A;
      }
    }
    function cf(d, h) {
      wl = d, Xf = null, Gp = null;
      var C = d.dependencies;
      if (C !== null) {
        var M = C.firstContext;
        M !== null && (Es(C.lanes, h) && yg(), C.firstContext = null);
      }
    }
    function _i(d) {
      so && y("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var h = n0 ? d._currentValue : d._currentValue2;
      if (Gp !== d) {
        var C = {
          context: d,
          memoizedValue: h,
          next: null
        };
        if (Xf === null) {
          if (wl === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          Xf = C, wl.dependencies = {
            lanes: bt,
            firstContext: C
          };
        } else
          Xf = Xf.next = C;
      }
      return h;
    }
    var Cl = null;
    function ra(d) {
      Cl === null ? Cl = [d] : Cl.push(d);
    }
    function zi() {
      if (Cl !== null) {
        for (var d = 0; d < Cl.length; d++) {
          var h = Cl[d], C = h.interleaved;
          if (C !== null) {
            h.interleaved = null;
            var M = C.next, A = h.pending;
            if (A !== null) {
              var W = A.next;
              A.next = M, C.next = W;
            }
            h.pending = C;
          }
        }
        Cl = null;
      }
    }
    function ei(d, h, C, M) {
      var A = h.interleaved;
      return A === null ? (C.next = C, ra(h)) : (C.next = A.next, A.next = C), h.interleaved = C, Yp(d, M);
    }
    function Bo(d, h, C, M) {
      var A = h.interleaved;
      A === null ? (C.next = C, ra(h)) : (C.next = A.next, A.next = C), h.interleaved = C;
    }
    function Fu(d, h, C, M) {
      var A = h.interleaved;
      return A === null ? (C.next = C, ra(h)) : (C.next = A.next, A.next = C), h.interleaved = C, Yp(d, M);
    }
    function wo(d, h) {
      return Yp(d, h);
    }
    var Ho = Yp;
    function Yp(d, h) {
      d.lanes = Wn(d.lanes, h);
      var C = d.alternate;
      C !== null && (C.lanes = Wn(C.lanes, h)), C === null && (d.flags & (wn | Mo)) !== Nt && kl(d);
      for (var M = d, A = d.return; A !== null; )
        A.childLanes = Wn(A.childLanes, h), C = A.alternate, C !== null ? C.childLanes = Wn(C.childLanes, h) : (A.flags & (wn | Mo)) !== Nt && kl(d), M = A, A = A.return;
      if (M.tag === Q) {
        var W = M.stateNode;
        return W;
      } else
        return null;
    }
    var qp = 0, og = 1, b0 = 2, Fm = 3, Vo = !1, S0, Ih;
    S0 = !1, Ih = null;
    function Zf(d) {
      var h = {
        baseState: d.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: bt
        },
        effects: null
      };
      d.updateQueue = h;
    }
    function zy(d, h) {
      var C = h.updateQueue, M = d.updateQueue;
      if (C === M) {
        var A = {
          baseState: M.baseState,
          firstBaseUpdate: M.firstBaseUpdate,
          lastBaseUpdate: M.lastBaseUpdate,
          shared: M.shared,
          effects: M.effects
        };
        h.updateQueue = A;
      }
    }
    function Jf(d, h) {
      var C = {
        eventTime: d,
        lane: h,
        tag: qp,
        payload: null,
        callback: null,
        next: null
      };
      return C;
    }
    function $o(d, h, C) {
      var M = d.updateQueue;
      if (M === null)
        return null;
      var A = M.shared;
      if (Ih === A && !S0 && (y("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), S0 = !0), SS()) {
        var W = A.pending;
        return W === null ? h.next = h : (h.next = W.next, W.next = h), A.pending = h, Ho(d, C);
      } else
        return Fu(d, A, h, C);
    }
    function Fh(d, h, C) {
      var M = h.updateQueue;
      if (M !== null) {
        var A = M.shared;
        if (Mm(C)) {
          var W = A.lanes;
          W = dd(W, d.pendingLanes);
          var ae = Wn(W, C);
          A.lanes = ae, Hf(d, ae);
        }
      }
    }
    function Uu(d, h) {
      var C = d.updateQueue, M = d.alternate;
      if (M !== null) {
        var A = M.updateQueue;
        if (C === A) {
          var W = null, ae = null, de = C.firstBaseUpdate;
          if (de !== null) {
            var ge = de;
            do {
              var Ce = {
                eventTime: ge.eventTime,
                lane: ge.lane,
                tag: ge.tag,
                payload: ge.payload,
                callback: ge.callback,
                next: null
              };
              ae === null ? W = ae = Ce : (ae.next = Ce, ae = Ce), ge = ge.next;
            } while (ge !== null);
            ae === null ? W = ae = h : (ae.next = h, ae = h);
          } else
            W = ae = h;
          C = {
            baseState: A.baseState,
            firstBaseUpdate: W,
            lastBaseUpdate: ae,
            shared: A.shared,
            effects: A.effects
          }, d.updateQueue = C;
          return;
        }
      }
      var Me = C.lastBaseUpdate;
      Me === null ? C.firstBaseUpdate = h : Me.next = h, C.lastBaseUpdate = h;
    }
    function xx(d, h, C, M, A, W) {
      switch (C.tag) {
        case og: {
          var ae = C.payload;
          if (typeof ae == "function") {
            Qf();
            var de = ae.call(W, M, A);
            {
              if (d.mode & $s) {
                ja(!0);
                try {
                  ae.call(W, M, A);
                } finally {
                  ja(!1);
                }
              }
              E5();
            }
            return de;
          }
          return ae;
        }
        case Fm:
          d.flags = d.flags & ~_s | Cr;
        case qp: {
          var ge = C.payload, Ce;
          if (typeof ge == "function") {
            Qf(), Ce = ge.call(W, M, A);
            {
              if (d.mode & $s) {
                ja(!0);
                try {
                  ge.call(W, M, A);
                } finally {
                  ja(!1);
                }
              }
              E5();
            }
          } else
            Ce = ge;
          return Ce == null ? M : w({}, M, Ce);
        }
        case b0:
          return Vo = !0, M;
      }
      return M;
    }
    function Kp(d, h, C, M) {
      var A = d.updateQueue;
      Vo = !1, Ih = A.shared;
      var W = A.firstBaseUpdate, ae = A.lastBaseUpdate, de = A.shared.pending;
      if (de !== null) {
        A.shared.pending = null;
        var ge = de, Ce = ge.next;
        ge.next = null, ae === null ? W = Ce : ae.next = Ce, ae = ge;
        var Me = d.alternate;
        if (Me !== null) {
          var $e = Me.updateQueue, at = $e.lastBaseUpdate;
          at !== ae && (at === null ? $e.firstBaseUpdate = Ce : at.next = Ce, $e.lastBaseUpdate = ge);
        }
      }
      if (W !== null) {
        var yt = A.baseState, Ct = bt, Et = null, Pn = null, yr = null, Zn = W;
        do {
          var ms = Zn.lane, fa = Zn.eventTime;
          if (pi(M, ms)) {
            if (yr !== null) {
              var mt = {
                eventTime: fa,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Zi,
                tag: Zn.tag,
                payload: Zn.payload,
                callback: Zn.callback,
                next: null
              };
              yr = yr.next = mt;
            }
            yt = xx(d, A, Zn, yt, h, C);
            var Ke = Zn.callback;
            if (Ke !== null && // If the update was already committed, we should not queue its
            // callback again.
            Zn.lane !== Zi) {
              d.flags |= Il;
              var $t = A.effects;
              $t === null ? A.effects = [Zn] : $t.push(Zn);
            }
          } else {
            var Qe = {
              eventTime: fa,
              lane: ms,
              tag: Zn.tag,
              payload: Zn.payload,
              callback: Zn.callback,
              next: null
            };
            yr === null ? (Pn = yr = Qe, Et = yt) : yr = yr.next = Qe, Ct = Wn(Ct, ms);
          }
          if (Zn = Zn.next, Zn === null) {
            if (de = A.shared.pending, de === null)
              break;
            var Un = de, gn = Un.next;
            Un.next = null, Zn = gn, A.lastBaseUpdate = Un, A.shared.pending = null;
          }
        } while (!0);
        yr === null && (Et = yt), A.baseState = Et, A.firstBaseUpdate = Pn, A.lastBaseUpdate = yr;
        var ma = A.shared.interleaved;
        if (ma !== null) {
          var Sr = ma;
          do
            Ct = Wn(Ct, Sr.lane), Sr = Sr.next;
          while (Sr !== ma);
        } else W === null && (A.shared.lanes = bt);
        cv(Ct), d.lanes = Ct, d.memoizedState = yt;
      }
      Ih = null;
    }
    function bx(d, h) {
      if (typeof d != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + d));
      d.call(h);
    }
    function w0() {
      Vo = !1;
    }
    function Um() {
      return Vo;
    }
    function Go(d, h, C) {
      var M = h.effects;
      if (h.effects = null, M !== null)
        for (var A = 0; A < M.length; A++) {
          var W = M[A], ae = W.callback;
          ae !== null && (W.callback = null, bx(ae, C));
        }
    }
    var bd = {}, ds = ad(bd), Ti = ad(bd), lg = ad(bd);
    function zm(d) {
      if (d === bd)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return d;
    }
    function By() {
      var d = zm(lg.current);
      return d;
    }
    function Hy(d, h) {
      Pa(lg, h, d), Pa(Ti, d, d), Pa(ds, bd, d);
      var C = xu(h);
      yo(ds, d), Pa(ds, C, d);
    }
    function Qc(d) {
      yo(ds, d), yo(Ti, d), yo(lg, d);
    }
    function Bm() {
      var d = zm(ds.current);
      return d;
    }
    function Sx(d) {
      var h = zm(lg.current), C = zm(ds.current), M = Po(C, d.type, h);
      C !== M && (Pa(Ti, d, d), Pa(ds, M, d));
    }
    function uf(d) {
      Ti.current === d && (yo(ds, d), yo(Ti, d));
    }
    var wx = 0, Xp = 1, cb = 1, C0 = 2, Zc = ad(wx);
    function N0(d, h) {
      return (d & h) !== 0;
    }
    function j0(d) {
      return d & Xp;
    }
    function ub(d, h) {
      return d & Xp | h;
    }
    function k5(d, h) {
      return d | h;
    }
    function Uh(d, h) {
      Pa(Zc, h, d);
    }
    function Sd(d) {
      yo(Zc, d);
    }
    function Pw(d, h) {
      var C = d.memoizedState;
      return C !== null ? C.dehydrated !== null : (d.memoizedProps, !0);
    }
    function zh(d) {
      for (var h = d; h !== null; ) {
        if (h.tag === ue) {
          var C = h.memoizedState;
          if (C !== null) {
            var M = C.dehydrated;
            if (M === null || Lc(M) || rc(M))
              return h;
          }
        } else if (h.tag === qe && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        h.memoizedProps.revealOrder !== void 0) {
          var A = (h.flags & Cr) !== Nt;
          if (A)
            return h;
        } else if (h.child !== null) {
          h.child.return = h, h = h.child;
          continue;
        }
        if (h === d)
          return null;
        for (; h.sibling === null; ) {
          if (h.return === null || h.return === d)
            return null;
          h = h.return;
        }
        h.sibling.return = h.return, h = h.sibling;
      }
      return null;
    }
    var Jc = (
      /*   */
      0
    ), Qr = (
      /* */
      1
    ), Hm = (
      /*  */
      2
    ), Co = (
      /*    */
      4
    ), Wo = (
      /*   */
      8
    ), db = [];
    function Cx() {
      for (var d = 0; d < db.length; d++) {
        var h = db[d];
        n0 ? h._workInProgressVersionPrimary = null : h._workInProgressVersionSecondary = null;
      }
      db.length = 0;
    }
    function _5(d, h) {
      var C = h._getVersion, M = C(h._source);
      d.mutableSourceEagerHydrationData == null ? d.mutableSourceEagerHydrationData = [h, M] : d.mutableSourceEagerHydrationData.push(h, M);
    }
    var pn = o.ReactCurrentDispatcher, wc = o.ReactCurrentBatchConfig, Vy, E0;
    Vy = /* @__PURE__ */ new Set();
    var zu = bt, La = null, li = null, Bi = null, cg = !1, Bh = !1, Hh = 0, fb = 0, T5 = 25, ht = null, Bu = null, em = -1, ug = !1;
    function Ia() {
      {
        var d = ht;
        Bu === null ? Bu = [d] : Bu.push(d);
      }
    }
    function nn() {
      {
        var d = ht;
        Bu !== null && (em++, Bu[em] !== d && mb(d));
      }
    }
    function k0(d) {
      d != null && !xr(d) && y("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", ht, typeof d);
    }
    function mb(d) {
      {
        var h = lt(La);
        if (!Vy.has(h) && (Vy.add(h), Bu !== null)) {
          for (var C = "", M = 30, A = 0; A <= em; A++) {
            for (var W = Bu[A], ae = A === em ? d : W, de = A + 1 + ". " + W; de.length < M; )
              de += " ";
            de += ae + `
`, C += de;
          }
          y(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, h, C);
        }
      }
    }
    function Yo() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function dg(d, h) {
      if (ug)
        return !1;
      if (h === null)
        return y("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ht), !1;
      d.length !== h.length && y(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ht, "[" + h.join(", ") + "]", "[" + d.join(", ") + "]");
      for (var C = 0; C < h.length && C < d.length; C++)
        if (!xl(d[C], h[C]))
          return !1;
      return !0;
    }
    function wd(d, h, C, M, A, W) {
      zu = W, La = h, Bu = d !== null ? d._debugHookTypes : null, em = -1, ug = d !== null && d.type !== h.type, h.memoizedState = null, h.updateQueue = null, h.lanes = bt, d !== null && d.memoizedState !== null ? pn.current = vb : Bu !== null ? pn.current = Bw : pn.current = A5;
      var ae = C(M, A);
      if (Bh) {
        var de = 0;
        do {
          if (Bh = !1, Hh = 0, de >= T5)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          de += 1, ug = !1, li = null, Bi = null, h.updateQueue = null, em = -1, pn.current = Hw, ae = C(M, A);
        } while (Bh);
      }
      pn.current = fg, h._debugHookTypes = Bu;
      var ge = li !== null && li.next !== null;
      if (zu = bt, La = null, li = null, Bi = null, ht = null, Bu = null, em = -1, d !== null && (d.flags & ga) !== (h.flags & ga) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (d.mode & na) !== Qn && y("Internal React error: Expected static flag was missing. Please notify the React team."), cg = !1, ge)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return ae;
    }
    function Vh() {
      var d = Hh !== 0;
      return Hh = 0, d;
    }
    function hb(d, h, C) {
      h.updateQueue = d.updateQueue, (h.mode & ku) !== Qn ? h.flags &= ~(Lr | vr | qi | pt) : h.flags &= ~(qi | pt), d.lanes = dc(d.lanes, C);
    }
    function M5() {
      if (pn.current = fg, cg) {
        for (var d = La.memoizedState; d !== null; ) {
          var h = d.queue;
          h !== null && (h.pending = null), d = d.next;
        }
        cg = !1;
      }
      zu = bt, La = null, li = null, Bi = null, Bu = null, em = -1, ht = null, O6 = !1, Bh = !1, Hh = 0;
    }
    function Cd() {
      var d = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Bi === null ? La.memoizedState = Bi = d : Bi = Bi.next = d, Bi;
    }
    function df() {
      var d;
      if (li === null) {
        var h = La.alternate;
        h !== null ? d = h.memoizedState : d = null;
      } else
        d = li.next;
      var C;
      if (Bi === null ? C = La.memoizedState : C = Bi.next, C !== null)
        Bi = C, C = Bi.next, li = d;
      else {
        if (d === null)
          throw new Error("Rendered more hooks than during the previous render.");
        li = d;
        var M = {
          memoizedState: li.memoizedState,
          baseState: li.baseState,
          baseQueue: li.baseQueue,
          queue: li.queue,
          next: null
        };
        Bi === null ? La.memoizedState = Bi = M : Bi = Bi.next = M;
      }
      return Bi;
    }
    function _0() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function Nx(d, h) {
      return typeof h == "function" ? h(d) : h;
    }
    function T0(d, h, C) {
      var M = Cd(), A;
      C !== void 0 ? A = C(h) : A = h, M.memoizedState = M.baseState = A;
      var W = {
        pending: null,
        interleaved: null,
        lanes: bt,
        dispatch: null,
        lastRenderedReducer: d,
        lastRenderedState: A
      };
      M.queue = W;
      var ae = W.dispatch = Uw.bind(null, La, W);
      return [M.memoizedState, ae];
    }
    function f(d, h, C) {
      var M = df(), A = M.queue;
      if (A === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      A.lastRenderedReducer = d;
      var W = li, ae = W.baseQueue, de = A.pending;
      if (de !== null) {
        if (ae !== null) {
          var ge = ae.next, Ce = de.next;
          ae.next = Ce, de.next = ge;
        }
        W.baseQueue !== ae && y("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), W.baseQueue = ae = de, A.pending = null;
      }
      if (ae !== null) {
        var Me = ae.next, $e = W.baseState, at = null, yt = null, Ct = null, Et = Me;
        do {
          var Pn = Et.lane;
          if (pi(zu, Pn)) {
            if (Ct !== null) {
              var Zn = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Zi,
                action: Et.action,
                hasEagerState: Et.hasEagerState,
                eagerState: Et.eagerState,
                next: null
              };
              Ct = Ct.next = Zn;
            }
            if (Et.hasEagerState)
              $e = Et.eagerState;
            else {
              var ms = Et.action;
              $e = d($e, ms);
            }
          } else {
            var yr = {
              lane: Pn,
              action: Et.action,
              hasEagerState: Et.hasEagerState,
              eagerState: Et.eagerState,
              next: null
            };
            Ct === null ? (yt = Ct = yr, at = $e) : Ct = Ct.next = yr, La.lanes = Wn(La.lanes, Pn), cv(Pn);
          }
          Et = Et.next;
        } while (Et !== null && Et !== Me);
        Ct === null ? at = $e : Ct.next = yt, xl($e, M.memoizedState) || yg(), M.memoizedState = $e, M.baseState = at, M.baseQueue = Ct, A.lastRenderedState = $e;
      }
      var fa = A.interleaved;
      if (fa !== null) {
        var Qe = fa;
        do {
          var mt = Qe.lane;
          La.lanes = Wn(La.lanes, mt), cv(mt), Qe = Qe.next;
        } while (Qe !== fa);
      } else ae === null && (A.lanes = bt);
      var Ke = A.dispatch;
      return [M.memoizedState, Ke];
    }
    function p(d, h, C) {
      var M = df(), A = M.queue;
      if (A === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      A.lastRenderedReducer = d;
      var W = A.dispatch, ae = A.pending, de = M.memoizedState;
      if (ae !== null) {
        A.pending = null;
        var ge = ae.next, Ce = ge;
        do {
          var Me = Ce.action;
          de = d(de, Me), Ce = Ce.next;
        } while (Ce !== ge);
        xl(de, M.memoizedState) || yg(), M.memoizedState = de, M.baseQueue === null && (M.baseState = de), A.lastRenderedState = de;
      }
      return [de, W];
    }
    function N(d, h, C) {
    }
    function O(d, h, C) {
    }
    function V(d, h, C) {
      var M = La, A = Cd(), W, ae = B();
      if (ae) {
        if (C === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        W = C(), E0 || W !== C() && (y("The result of getServerSnapshot should be cached to avoid an infinite loop"), E0 = !0);
      } else {
        if (W = h(), !E0) {
          var de = h();
          xl(W, de) || (y("The result of getSnapshot should be cached to avoid an infinite loop"), E0 = !0);
        }
        var ge = xS();
        if (ge === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Du(ge, zu) || me(M, h, W);
      }
      A.memoizedState = W;
      var Ce = {
        value: W,
        getSnapshot: h
      };
      return A.queue = Ce, Ge(De.bind(null, M, Ce, d), [d]), M.flags |= qi, _n(Qr | Wo, je.bind(null, M, Ce, W, h), void 0, null), W;
    }
    function J(d, h, C) {
      var M = La, A = df(), W = h();
      if (!E0) {
        var ae = h();
        xl(W, ae) || (y("The result of getSnapshot should be cached to avoid an infinite loop"), E0 = !0);
      }
      var de = A.memoizedState, ge = !xl(de, W);
      ge && (A.memoizedState = W, yg());
      var Ce = A.queue;
      if (zt(De.bind(null, M, Ce, d), [d]), Ce.getSnapshot !== h || ge || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Bi !== null && Bi.memoizedState.tag & Qr) {
        M.flags |= qi, _n(Qr | Wo, je.bind(null, M, Ce, W, h), void 0, null);
        var Me = xS();
        if (Me === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Du(Me, zu) || me(M, h, W);
      }
      return W;
    }
    function me(d, h, C) {
      d.flags |= dl;
      var M = {
        getSnapshot: h,
        value: C
      }, A = La.updateQueue;
      if (A === null)
        A = _0(), La.updateQueue = A, A.stores = [M];
      else {
        var W = A.stores;
        W === null ? A.stores = [M] : W.push(M);
      }
    }
    function je(d, h, C, M) {
      h.value = C, h.getSnapshot = M, Je(h) && Mt(d);
    }
    function De(d, h, C) {
      var M = function() {
        Je(h) && Mt(d);
      };
      return C(M);
    }
    function Je(d) {
      var h = d.getSnapshot, C = d.value;
      try {
        var M = h();
        return !xl(C, M);
      } catch {
        return !0;
      }
    }
    function Mt(d) {
      var h = wo(d, rr);
      h !== null && Qo(h, d, rr, $a);
    }
    function Dt(d) {
      var h = Cd();
      typeof d == "function" && (d = d()), h.memoizedState = h.baseState = d;
      var C = {
        pending: null,
        interleaved: null,
        lanes: bt,
        dispatch: null,
        lastRenderedReducer: Nx,
        lastRenderedState: d
      };
      h.queue = C;
      var M = C.dispatch = p_.bind(null, La, C);
      return [h.memoizedState, M];
    }
    function Tt(d) {
      return f(Nx);
    }
    function vn(d) {
      return p(Nx);
    }
    function _n(d, h, C, M) {
      var A = {
        tag: d,
        create: h,
        destroy: C,
        deps: M,
        // Circular
        next: null
      }, W = La.updateQueue;
      if (W === null)
        W = _0(), La.updateQueue = W, W.lastEffect = A.next = A;
      else {
        var ae = W.lastEffect;
        if (ae === null)
          W.lastEffect = A.next = A;
        else {
          var de = ae.next;
          ae.next = A, A.next = de, W.lastEffect = A;
        }
      }
      return A;
    }
    function An(d) {
      var h = Cd();
      {
        var C = {
          current: d
        };
        return h.memoizedState = C, C;
      }
    }
    function vi(d) {
      var h = df();
      return h.memoizedState;
    }
    function Ve(d, h, C, M) {
      var A = Cd(), W = M === void 0 ? null : M;
      La.flags |= d, A.memoizedState = _n(Qr | h, C, void 0, W);
    }
    function Oe(d, h, C, M) {
      var A = df(), W = M === void 0 ? null : M, ae = void 0;
      if (li !== null) {
        var de = li.memoizedState;
        if (ae = de.destroy, W !== null) {
          var ge = de.deps;
          if (dg(W, ge)) {
            A.memoizedState = _n(h, C, ae, W);
            return;
          }
        }
      }
      La.flags |= d, A.memoizedState = _n(Qr | h, C, ae, W);
    }
    function Ge(d, h) {
      return (La.mode & ku) !== Qn ? Ve(Lr | qi | On, Wo, d, h) : Ve(qi | On, Wo, d, h);
    }
    function zt(d, h) {
      return Oe(qi, Wo, d, h);
    }
    function zn(d, h) {
      return Ve(pt, Hm, d, h);
    }
    function tr(d, h) {
      return Oe(pt, Hm, d, h);
    }
    function Rn(d, h) {
      var C = pt;
      return C |= Kt, (La.mode & ku) !== Qn && (C |= vr), Ve(C, Co, d, h);
    }
    function sr(d, h) {
      return Oe(pt, Co, d, h);
    }
    function No(d, h) {
      if (typeof h == "function") {
        var C = h, M = d();
        return C(M), function() {
          C(null);
        };
      } else if (h != null) {
        var A = h;
        A.hasOwnProperty("current") || y("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(A).join(", ") + "}");
        var W = d();
        return A.current = W, function() {
          A.current = null;
        };
      }
    }
    function ka(d, h, C) {
      typeof h != "function" && y("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", h !== null ? typeof h : "null");
      var M = C != null ? C.concat([d]) : null, A = pt;
      return A |= Kt, (La.mode & ku) !== Qn && (A |= vr), Ve(A, Co, No.bind(null, h, d), M);
    }
    function ff(d, h, C) {
      typeof h != "function" && y("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", h !== null ? typeof h : "null");
      var M = C != null ? C.concat([d]) : null;
      return Oe(pt, Co, No.bind(null, h, d), M);
    }
    function Ow(d, h) {
    }
    var R5 = Ow;
    function Aw(d, h) {
      var C = Cd(), M = h === void 0 ? null : h;
      return C.memoizedState = [d, M], d;
    }
    function pb(d, h) {
      var C = df(), M = h === void 0 ? null : h, A = C.memoizedState;
      if (A !== null && M !== null) {
        var W = A[1];
        if (dg(M, W))
          return A[0];
      }
      return C.memoizedState = [d, M], d;
    }
    function D5(d, h) {
      var C = Cd(), M = h === void 0 ? null : h, A = d();
      return C.memoizedState = [A, M], A;
    }
    function P5(d, h) {
      var C = df(), M = h === void 0 ? null : h, A = C.memoizedState;
      if (A !== null && M !== null) {
        var W = A[1];
        if (dg(M, W))
          return A[0];
      }
      var ae = d();
      return C.memoizedState = [ae, M], ae;
    }
    function Lw(d) {
      var h = Cd();
      return h.memoizedState = d, d;
    }
    function Iw(d) {
      var h = df(), C = li, M = C.memoizedState;
      return R6(h, M, d);
    }
    function O5(d) {
      var h = df();
      if (li === null)
        return h.memoizedState = d, d;
      var C = li.memoizedState;
      return R6(h, C, d);
    }
    function R6(d, h, C) {
      var M = !Ns(zu);
      if (M) {
        if (!xl(C, h)) {
          var A = Dy();
          La.lanes = Wn(La.lanes, A), cv(A), d.baseState = !0;
        }
        return h;
      } else
        return d.baseState && (d.baseState = !1, yg()), d.memoizedState = C, C;
    }
    function h_(d, h, C) {
      var M = hc();
      gi(Ys(M, Rm)), d(!0);
      var A = wc.transition;
      wc.transition = {};
      var W = wc.transition;
      wc.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        d(!1), h();
      } finally {
        if (gi(M), wc.transition = A, A === null && W._updatedFibers) {
          var ae = W._updatedFibers.size;
          ae > 10 && m("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), W._updatedFibers.clear();
        }
      }
    }
    function Fw() {
      var d = Dt(!1), h = d[0], C = d[1], M = h_.bind(null, C), A = Cd();
      return A.memoizedState = M, [h, M];
    }
    function D6() {
      var d = Tt(), h = d[0], C = df(), M = C.memoizedState;
      return [h, M];
    }
    function P6() {
      var d = vn(), h = d[0], C = df(), M = C.memoizedState;
      return [h, M];
    }
    var O6 = !1;
    function jx() {
      return O6;
    }
    function gb() {
      var d = Cd(), h = xS(), C = h.identifierPrefix, M;
      if (B()) {
        var A = Lm();
        M = ":" + C + "R" + A;
        var W = Hh++;
        W > 0 && (M += "H" + W.toString(32)), M += ":";
      } else {
        var ae = fb++;
        M = ":" + C + "r" + ae.toString(32) + ":";
      }
      return d.memoizedState = M, M;
    }
    function M0() {
      var d = df(), h = d.memoizedState;
      return h;
    }
    function Uw(d, h, C) {
      typeof arguments[3] == "function" && y("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var M = B0(d), A = {
        lane: M,
        action: C,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (A6(d))
        zw(h, A);
      else {
        var W = ei(d, h, A, M);
        if (W !== null) {
          var ae = Is();
          Qo(W, d, M, ae), L6(W, h, M);
        }
      }
      yb(d, M);
    }
    function p_(d, h, C) {
      typeof arguments[3] == "function" && y("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var M = B0(d), A = {
        lane: M,
        action: C,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (A6(d))
        zw(h, A);
      else {
        var W = d.alternate;
        if (d.lanes === bt && (W === null || W.lanes === bt)) {
          var ae = h.lastRenderedReducer;
          if (ae !== null) {
            var de;
            de = pn.current, pn.current = Vm;
            try {
              var ge = h.lastRenderedState, Ce = ae(ge, C);
              if (A.hasEagerState = !0, A.eagerState = Ce, xl(Ce, ge)) {
                Bo(d, h, A, M);
                return;
              }
            } catch {
            } finally {
              pn.current = de;
            }
          }
        }
        var Me = ei(d, h, A, M);
        if (Me !== null) {
          var $e = Is();
          Qo(Me, d, M, $e), L6(Me, h, M);
        }
      }
      yb(d, M);
    }
    function A6(d) {
      var h = d.alternate;
      return d === La || h !== null && h === La;
    }
    function zw(d, h) {
      Bh = cg = !0;
      var C = d.pending;
      C === null ? h.next = h : (h.next = C.next, C.next = h), d.pending = h;
    }
    function L6(d, h, C) {
      if (Mm(C)) {
        var M = h.lanes;
        M = dd(M, d.pendingLanes);
        var A = Wn(M, C);
        h.lanes = A, Hf(d, A);
      }
    }
    function yb(d, h, C) {
      hd(d, h);
    }
    var fg = {
      readContext: _i,
      useCallback: Yo,
      useContext: Yo,
      useEffect: Yo,
      useImperativeHandle: Yo,
      useInsertionEffect: Yo,
      useLayoutEffect: Yo,
      useMemo: Yo,
      useReducer: Yo,
      useRef: Yo,
      useState: Yo,
      useDebugValue: Yo,
      useDeferredValue: Yo,
      useTransition: Yo,
      useMutableSource: Yo,
      useSyncExternalStore: Yo,
      useId: Yo,
      unstable_isNewReconciler: E
    }, A5 = null, Bw = null, vb = null, Hw = null, $h = null, Vm = null, xb = null;
    {
      var L5 = function() {
        y("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, jr = function() {
        y("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      A5 = {
        readContext: function(d) {
          return _i(d);
        },
        useCallback: function(d, h) {
          return ht = "useCallback", Ia(), k0(h), Aw(d, h);
        },
        useContext: function(d) {
          return ht = "useContext", Ia(), _i(d);
        },
        useEffect: function(d, h) {
          return ht = "useEffect", Ia(), k0(h), Ge(d, h);
        },
        useImperativeHandle: function(d, h, C) {
          return ht = "useImperativeHandle", Ia(), k0(C), ka(d, h, C);
        },
        useInsertionEffect: function(d, h) {
          return ht = "useInsertionEffect", Ia(), k0(h), zn(d, h);
        },
        useLayoutEffect: function(d, h) {
          return ht = "useLayoutEffect", Ia(), k0(h), Rn(d, h);
        },
        useMemo: function(d, h) {
          ht = "useMemo", Ia(), k0(h);
          var C = pn.current;
          pn.current = $h;
          try {
            return D5(d, h);
          } finally {
            pn.current = C;
          }
        },
        useReducer: function(d, h, C) {
          ht = "useReducer", Ia();
          var M = pn.current;
          pn.current = $h;
          try {
            return T0(d, h, C);
          } finally {
            pn.current = M;
          }
        },
        useRef: function(d) {
          return ht = "useRef", Ia(), An(d);
        },
        useState: function(d) {
          ht = "useState", Ia();
          var h = pn.current;
          pn.current = $h;
          try {
            return Dt(d);
          } finally {
            pn.current = h;
          }
        },
        useDebugValue: function(d, h) {
          return ht = "useDebugValue", Ia(), void 0;
        },
        useDeferredValue: function(d) {
          return ht = "useDeferredValue", Ia(), Lw(d);
        },
        useTransition: function() {
          return ht = "useTransition", Ia(), Fw();
        },
        useMutableSource: function(d, h, C) {
          return ht = "useMutableSource", Ia(), void 0;
        },
        useSyncExternalStore: function(d, h, C) {
          return ht = "useSyncExternalStore", Ia(), V(d, h, C);
        },
        useId: function() {
          return ht = "useId", Ia(), gb();
        },
        unstable_isNewReconciler: E
      }, Bw = {
        readContext: function(d) {
          return _i(d);
        },
        useCallback: function(d, h) {
          return ht = "useCallback", nn(), Aw(d, h);
        },
        useContext: function(d) {
          return ht = "useContext", nn(), _i(d);
        },
        useEffect: function(d, h) {
          return ht = "useEffect", nn(), Ge(d, h);
        },
        useImperativeHandle: function(d, h, C) {
          return ht = "useImperativeHandle", nn(), ka(d, h, C);
        },
        useInsertionEffect: function(d, h) {
          return ht = "useInsertionEffect", nn(), zn(d, h);
        },
        useLayoutEffect: function(d, h) {
          return ht = "useLayoutEffect", nn(), Rn(d, h);
        },
        useMemo: function(d, h) {
          ht = "useMemo", nn();
          var C = pn.current;
          pn.current = $h;
          try {
            return D5(d, h);
          } finally {
            pn.current = C;
          }
        },
        useReducer: function(d, h, C) {
          ht = "useReducer", nn();
          var M = pn.current;
          pn.current = $h;
          try {
            return T0(d, h, C);
          } finally {
            pn.current = M;
          }
        },
        useRef: function(d) {
          return ht = "useRef", nn(), An(d);
        },
        useState: function(d) {
          ht = "useState", nn();
          var h = pn.current;
          pn.current = $h;
          try {
            return Dt(d);
          } finally {
            pn.current = h;
          }
        },
        useDebugValue: function(d, h) {
          return ht = "useDebugValue", nn(), void 0;
        },
        useDeferredValue: function(d) {
          return ht = "useDeferredValue", nn(), Lw(d);
        },
        useTransition: function() {
          return ht = "useTransition", nn(), Fw();
        },
        useMutableSource: function(d, h, C) {
          return ht = "useMutableSource", nn(), void 0;
        },
        useSyncExternalStore: function(d, h, C) {
          return ht = "useSyncExternalStore", nn(), V(d, h, C);
        },
        useId: function() {
          return ht = "useId", nn(), gb();
        },
        unstable_isNewReconciler: E
      }, vb = {
        readContext: function(d) {
          return _i(d);
        },
        useCallback: function(d, h) {
          return ht = "useCallback", nn(), pb(d, h);
        },
        useContext: function(d) {
          return ht = "useContext", nn(), _i(d);
        },
        useEffect: function(d, h) {
          return ht = "useEffect", nn(), zt(d, h);
        },
        useImperativeHandle: function(d, h, C) {
          return ht = "useImperativeHandle", nn(), ff(d, h, C);
        },
        useInsertionEffect: function(d, h) {
          return ht = "useInsertionEffect", nn(), tr(d, h);
        },
        useLayoutEffect: function(d, h) {
          return ht = "useLayoutEffect", nn(), sr(d, h);
        },
        useMemo: function(d, h) {
          ht = "useMemo", nn();
          var C = pn.current;
          pn.current = Vm;
          try {
            return P5(d, h);
          } finally {
            pn.current = C;
          }
        },
        useReducer: function(d, h, C) {
          ht = "useReducer", nn();
          var M = pn.current;
          pn.current = Vm;
          try {
            return f(d, h, C);
          } finally {
            pn.current = M;
          }
        },
        useRef: function(d) {
          return ht = "useRef", nn(), vi();
        },
        useState: function(d) {
          ht = "useState", nn();
          var h = pn.current;
          pn.current = Vm;
          try {
            return Tt(d);
          } finally {
            pn.current = h;
          }
        },
        useDebugValue: function(d, h) {
          return ht = "useDebugValue", nn(), R5();
        },
        useDeferredValue: function(d) {
          return ht = "useDeferredValue", nn(), Iw(d);
        },
        useTransition: function() {
          return ht = "useTransition", nn(), D6();
        },
        useMutableSource: function(d, h, C) {
          return ht = "useMutableSource", nn(), void 0;
        },
        useSyncExternalStore: function(d, h, C) {
          return ht = "useSyncExternalStore", nn(), J(d, h);
        },
        useId: function() {
          return ht = "useId", nn(), M0();
        },
        unstable_isNewReconciler: E
      }, Hw = {
        readContext: function(d) {
          return _i(d);
        },
        useCallback: function(d, h) {
          return ht = "useCallback", nn(), pb(d, h);
        },
        useContext: function(d) {
          return ht = "useContext", nn(), _i(d);
        },
        useEffect: function(d, h) {
          return ht = "useEffect", nn(), zt(d, h);
        },
        useImperativeHandle: function(d, h, C) {
          return ht = "useImperativeHandle", nn(), ff(d, h, C);
        },
        useInsertionEffect: function(d, h) {
          return ht = "useInsertionEffect", nn(), tr(d, h);
        },
        useLayoutEffect: function(d, h) {
          return ht = "useLayoutEffect", nn(), sr(d, h);
        },
        useMemo: function(d, h) {
          ht = "useMemo", nn();
          var C = pn.current;
          pn.current = xb;
          try {
            return P5(d, h);
          } finally {
            pn.current = C;
          }
        },
        useReducer: function(d, h, C) {
          ht = "useReducer", nn();
          var M = pn.current;
          pn.current = xb;
          try {
            return p(d, h, C);
          } finally {
            pn.current = M;
          }
        },
        useRef: function(d) {
          return ht = "useRef", nn(), vi();
        },
        useState: function(d) {
          ht = "useState", nn();
          var h = pn.current;
          pn.current = xb;
          try {
            return vn(d);
          } finally {
            pn.current = h;
          }
        },
        useDebugValue: function(d, h) {
          return ht = "useDebugValue", nn(), R5();
        },
        useDeferredValue: function(d) {
          return ht = "useDeferredValue", nn(), O5(d);
        },
        useTransition: function() {
          return ht = "useTransition", nn(), P6();
        },
        useMutableSource: function(d, h, C) {
          return ht = "useMutableSource", nn(), void 0;
        },
        useSyncExternalStore: function(d, h, C) {
          return ht = "useSyncExternalStore", nn(), J(d, h);
        },
        useId: function() {
          return ht = "useId", nn(), M0();
        },
        unstable_isNewReconciler: E
      }, $h = {
        readContext: function(d) {
          return L5(), _i(d);
        },
        useCallback: function(d, h) {
          return ht = "useCallback", jr(), Ia(), Aw(d, h);
        },
        useContext: function(d) {
          return ht = "useContext", jr(), Ia(), _i(d);
        },
        useEffect: function(d, h) {
          return ht = "useEffect", jr(), Ia(), Ge(d, h);
        },
        useImperativeHandle: function(d, h, C) {
          return ht = "useImperativeHandle", jr(), Ia(), ka(d, h, C);
        },
        useInsertionEffect: function(d, h) {
          return ht = "useInsertionEffect", jr(), Ia(), zn(d, h);
        },
        useLayoutEffect: function(d, h) {
          return ht = "useLayoutEffect", jr(), Ia(), Rn(d, h);
        },
        useMemo: function(d, h) {
          ht = "useMemo", jr(), Ia();
          var C = pn.current;
          pn.current = $h;
          try {
            return D5(d, h);
          } finally {
            pn.current = C;
          }
        },
        useReducer: function(d, h, C) {
          ht = "useReducer", jr(), Ia();
          var M = pn.current;
          pn.current = $h;
          try {
            return T0(d, h, C);
          } finally {
            pn.current = M;
          }
        },
        useRef: function(d) {
          return ht = "useRef", jr(), Ia(), An(d);
        },
        useState: function(d) {
          ht = "useState", jr(), Ia();
          var h = pn.current;
          pn.current = $h;
          try {
            return Dt(d);
          } finally {
            pn.current = h;
          }
        },
        useDebugValue: function(d, h) {
          return ht = "useDebugValue", jr(), Ia(), void 0;
        },
        useDeferredValue: function(d) {
          return ht = "useDeferredValue", jr(), Ia(), Lw(d);
        },
        useTransition: function() {
          return ht = "useTransition", jr(), Ia(), Fw();
        },
        useMutableSource: function(d, h, C) {
          return ht = "useMutableSource", jr(), Ia(), void 0;
        },
        useSyncExternalStore: function(d, h, C) {
          return ht = "useSyncExternalStore", jr(), Ia(), V(d, h, C);
        },
        useId: function() {
          return ht = "useId", jr(), Ia(), gb();
        },
        unstable_isNewReconciler: E
      }, Vm = {
        readContext: function(d) {
          return L5(), _i(d);
        },
        useCallback: function(d, h) {
          return ht = "useCallback", jr(), nn(), pb(d, h);
        },
        useContext: function(d) {
          return ht = "useContext", jr(), nn(), _i(d);
        },
        useEffect: function(d, h) {
          return ht = "useEffect", jr(), nn(), zt(d, h);
        },
        useImperativeHandle: function(d, h, C) {
          return ht = "useImperativeHandle", jr(), nn(), ff(d, h, C);
        },
        useInsertionEffect: function(d, h) {
          return ht = "useInsertionEffect", jr(), nn(), tr(d, h);
        },
        useLayoutEffect: function(d, h) {
          return ht = "useLayoutEffect", jr(), nn(), sr(d, h);
        },
        useMemo: function(d, h) {
          ht = "useMemo", jr(), nn();
          var C = pn.current;
          pn.current = Vm;
          try {
            return P5(d, h);
          } finally {
            pn.current = C;
          }
        },
        useReducer: function(d, h, C) {
          ht = "useReducer", jr(), nn();
          var M = pn.current;
          pn.current = Vm;
          try {
            return f(d, h, C);
          } finally {
            pn.current = M;
          }
        },
        useRef: function(d) {
          return ht = "useRef", jr(), nn(), vi();
        },
        useState: function(d) {
          ht = "useState", jr(), nn();
          var h = pn.current;
          pn.current = Vm;
          try {
            return Tt(d);
          } finally {
            pn.current = h;
          }
        },
        useDebugValue: function(d, h) {
          return ht = "useDebugValue", jr(), nn(), R5();
        },
        useDeferredValue: function(d) {
          return ht = "useDeferredValue", jr(), nn(), Iw(d);
        },
        useTransition: function() {
          return ht = "useTransition", jr(), nn(), D6();
        },
        useMutableSource: function(d, h, C) {
          return ht = "useMutableSource", jr(), nn(), void 0;
        },
        useSyncExternalStore: function(d, h, C) {
          return ht = "useSyncExternalStore", jr(), nn(), J(d, h);
        },
        useId: function() {
          return ht = "useId", jr(), nn(), M0();
        },
        unstable_isNewReconciler: E
      }, xb = {
        readContext: function(d) {
          return L5(), _i(d);
        },
        useCallback: function(d, h) {
          return ht = "useCallback", jr(), nn(), pb(d, h);
        },
        useContext: function(d) {
          return ht = "useContext", jr(), nn(), _i(d);
        },
        useEffect: function(d, h) {
          return ht = "useEffect", jr(), nn(), zt(d, h);
        },
        useImperativeHandle: function(d, h, C) {
          return ht = "useImperativeHandle", jr(), nn(), ff(d, h, C);
        },
        useInsertionEffect: function(d, h) {
          return ht = "useInsertionEffect", jr(), nn(), tr(d, h);
        },
        useLayoutEffect: function(d, h) {
          return ht = "useLayoutEffect", jr(), nn(), sr(d, h);
        },
        useMemo: function(d, h) {
          ht = "useMemo", jr(), nn();
          var C = pn.current;
          pn.current = Vm;
          try {
            return P5(d, h);
          } finally {
            pn.current = C;
          }
        },
        useReducer: function(d, h, C) {
          ht = "useReducer", jr(), nn();
          var M = pn.current;
          pn.current = Vm;
          try {
            return p(d, h, C);
          } finally {
            pn.current = M;
          }
        },
        useRef: function(d) {
          return ht = "useRef", jr(), nn(), vi();
        },
        useState: function(d) {
          ht = "useState", jr(), nn();
          var h = pn.current;
          pn.current = Vm;
          try {
            return vn(d);
          } finally {
            pn.current = h;
          }
        },
        useDebugValue: function(d, h) {
          return ht = "useDebugValue", jr(), nn(), R5();
        },
        useDeferredValue: function(d) {
          return ht = "useDeferredValue", jr(), nn(), O5(d);
        },
        useTransition: function() {
          return ht = "useTransition", jr(), nn(), P6();
        },
        useMutableSource: function(d, h, C) {
          return ht = "useMutableSource", jr(), nn(), void 0;
        },
        useSyncExternalStore: function(d, h, C) {
          return ht = "useSyncExternalStore", jr(), nn(), J(d, h);
        },
        useId: function() {
          return ht = "useId", jr(), nn(), M0();
        },
        unstable_isNewReconciler: E
      };
    }
    var Nd = s.unstable_now, I6 = 0, I5 = -1, bb = -1, R0 = -1, Sb = !1, wb = !1;
    function F6() {
      return Sb;
    }
    function U6() {
      wb = !0;
    }
    function g_() {
      Sb = !1, wb = !1;
    }
    function Mi() {
      Sb = wb, wb = !1;
    }
    function F5() {
      return I6;
    }
    function Cb() {
      I6 = Nd();
    }
    function $y(d) {
      bb = Nd(), d.actualStartTime < 0 && (d.actualStartTime = Nd());
    }
    function Vw(d) {
      bb = -1;
    }
    function Nb(d, h) {
      if (bb >= 0) {
        var C = Nd() - bb;
        d.actualDuration += C, h && (d.selfBaseDuration = C), bb = -1;
      }
    }
    function $m(d) {
      if (I5 >= 0) {
        var h = Nd() - I5;
        I5 = -1;
        for (var C = d.return; C !== null; ) {
          switch (C.tag) {
            case Q:
              var M = C.stateNode;
              M.effectDuration += h;
              return;
            case oe:
              var A = C.stateNode;
              A.effectDuration += h;
              return;
          }
          C = C.return;
        }
      }
    }
    function Gy(d) {
      if (R0 >= 0) {
        var h = Nd() - R0;
        R0 = -1;
        for (var C = d.return; C !== null; ) {
          switch (C.tag) {
            case Q:
              var M = C.stateNode;
              M !== null && (M.passiveEffectDuration += h);
              return;
            case oe:
              var A = C.stateNode;
              A !== null && (A.passiveEffectDuration += h);
              return;
          }
          C = C.return;
        }
      }
    }
    function Qp() {
      I5 = Nd();
    }
    function Ex() {
      R0 = Nd();
    }
    function D0(d) {
      for (var h = d.child; h; )
        d.actualDuration += h.actualDuration, h = h.sibling;
    }
    function Gh(d, h) {
      if (d && d.defaultProps) {
        var C = w({}, h), M = d.defaultProps;
        for (var A in M)
          C[A] === void 0 && (C[A] = M[A]);
        return C;
      }
      return h;
    }
    var U5 = {}, $w, Gw, Hu, Wy, kx, mg, jb, hg, pg, _x, Yy;
    {
      $w = /* @__PURE__ */ new Set(), Gw = /* @__PURE__ */ new Set(), Hu = /* @__PURE__ */ new Set(), Wy = /* @__PURE__ */ new Set(), hg = /* @__PURE__ */ new Set(), kx = /* @__PURE__ */ new Set(), pg = /* @__PURE__ */ new Set(), _x = /* @__PURE__ */ new Set(), Yy = /* @__PURE__ */ new Set();
      var Eb = /* @__PURE__ */ new Set();
      jb = function(d, h) {
        if (!(d === null || typeof d == "function")) {
          var C = h + "_" + d;
          Eb.has(C) || (Eb.add(C), y("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", h, d));
        }
      }, mg = function(d, h) {
        if (h === void 0) {
          var C = qt(d) || "Component";
          kx.has(C) || (kx.add(C), y("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", C));
        }
      }, Object.defineProperty(U5, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(U5);
    }
    function qy(d, h, C, M) {
      var A = d.memoizedState, W = C(M, A);
      {
        if (d.mode & $s) {
          ja(!0);
          try {
            W = C(M, A);
          } finally {
            ja(!1);
          }
        }
        mg(h, W);
      }
      var ae = W == null ? A : w({}, A, W);
      if (d.memoizedState = ae, d.lanes === bt) {
        var de = d.updateQueue;
        de.baseState = ae;
      }
    }
    var z5 = {
      isMounted: zr,
      enqueueSetState: function(d, h, C) {
        var M = k(d), A = Is(), W = B0(M), ae = Jf(A, W);
        ae.payload = h, C != null && (jb(C, "setState"), ae.callback = C);
        var de = $o(M, ae, W);
        de !== null && (Qo(de, M, W, A), Fh(de, M, W)), hd(M, W);
      },
      enqueueReplaceState: function(d, h, C) {
        var M = k(d), A = Is(), W = B0(M), ae = Jf(A, W);
        ae.tag = og, ae.payload = h, C != null && (jb(C, "replaceState"), ae.callback = C);
        var de = $o(M, ae, W);
        de !== null && (Qo(de, M, W, A), Fh(de, M, W)), hd(M, W);
      },
      enqueueForceUpdate: function(d, h) {
        var C = k(d), M = Is(), A = B0(C), W = Jf(M, A);
        W.tag = b0, h != null && (jb(h, "forceUpdate"), W.callback = h);
        var ae = $o(C, W, A);
        ae !== null && (Qo(ae, C, A, M), Fh(ae, C, A)), Fi(C, A);
      }
    };
    function kb(d, h, C, M, A, W, ae) {
      var de = d.stateNode;
      if (typeof de.shouldComponentUpdate == "function") {
        var ge = de.shouldComponentUpdate(M, W, ae);
        {
          if (d.mode & $s) {
            ja(!0);
            try {
              ge = de.shouldComponentUpdate(M, W, ae);
            } finally {
              ja(!1);
            }
          }
          ge === void 0 && y("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", qt(h) || "Component");
        }
        return ge;
      }
      return h.prototype && h.prototype.isPureReactComponent ? !Ze(C, M) || !Ze(A, W) : !0;
    }
    function z6(d, h, C) {
      var M = d.stateNode;
      {
        var A = qt(h) || "Component", W = M.render;
        W || (h.prototype && typeof h.prototype.render == "function" ? y("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", A) : y("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", A)), M.getInitialState && !M.getInitialState.isReactClassApproved && !M.state && y("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", A), M.getDefaultProps && !M.getDefaultProps.isReactClassApproved && y("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", A), M.propTypes && y("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", A), M.contextType && y("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", A), h.childContextTypes && !Yy.has(h) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (d.mode & $s) === Qn && (Yy.add(h), y(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, A)), h.contextTypes && !Yy.has(h) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (d.mode & $s) === Qn && (Yy.add(h), y(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, A)), M.contextTypes && y("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", A), h.contextType && h.contextTypes && !pg.has(h) && (pg.add(h), y("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", A)), typeof M.componentShouldUpdate == "function" && y("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", A), h.prototype && h.prototype.isPureReactComponent && typeof M.shouldComponentUpdate < "u" && y("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", qt(h) || "A pure component"), typeof M.componentDidUnmount == "function" && y("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", A), typeof M.componentDidReceiveProps == "function" && y("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", A), typeof M.componentWillRecieveProps == "function" && y("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", A), typeof M.UNSAFE_componentWillRecieveProps == "function" && y("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", A);
        var ae = M.props !== C;
        M.props !== void 0 && ae && y("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", A, A), M.defaultProps && y("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", A, A), typeof M.getSnapshotBeforeUpdate == "function" && typeof M.componentDidUpdate != "function" && !Hu.has(h) && (Hu.add(h), y("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", qt(h))), typeof M.getDerivedStateFromProps == "function" && y("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", A), typeof M.getDerivedStateFromError == "function" && y("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", A), typeof h.getSnapshotBeforeUpdate == "function" && y("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", A);
        var de = M.state;
        de && (typeof de != "object" || xr(de)) && y("%s.state: must be set to an object or null", A), typeof M.getChildContext == "function" && typeof h.childContextTypes != "object" && y("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", A);
      }
    }
    function Ww(d, h) {
      h.updater = z5, d.stateNode = h, j(h, d), h._reactInternalInstance = U5;
    }
    function B6(d, h, C) {
      var M = !1, A = Ii, W = Ii, ae = h.contextType;
      if ("contextType" in h) {
        var de = (
          // Allow null for conditional declaration
          ae === null || ae !== void 0 && ae.$$typeof === It && ae._context === void 0
        );
        if (!de && !_x.has(h)) {
          _x.add(h);
          var ge = "";
          ae === void 0 ? ge = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof ae != "object" ? ge = " However, it is set to a " + typeof ae + "." : ae.$$typeof === er ? ge = " Did you accidentally pass the Context.Provider instead?" : ae._context !== void 0 ? ge = " Did you accidentally pass the Context.Consumer instead?" : ge = " However, it is set to an object with keys {" + Object.keys(ae).join(", ") + "}.", y("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", qt(h) || "Component", ge);
        }
      }
      if (typeof ae == "object" && ae !== null)
        W = _i(ae);
      else {
        A = Fo(d, h, !0);
        var Ce = h.contextTypes;
        M = Ce != null, W = M ? sd(d, A) : Ii;
      }
      var Me = new h(C, W);
      if (d.mode & $s) {
        ja(!0);
        try {
          Me = new h(C, W);
        } finally {
          ja(!1);
        }
      }
      var $e = d.memoizedState = Me.state !== null && Me.state !== void 0 ? Me.state : null;
      Ww(d, Me);
      {
        if (typeof h.getDerivedStateFromProps == "function" && $e === null) {
          var at = qt(h) || "Component";
          Gw.has(at) || (Gw.add(at), y("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", at, Me.state === null ? "null" : "undefined", at));
        }
        if (typeof h.getDerivedStateFromProps == "function" || typeof Me.getSnapshotBeforeUpdate == "function") {
          var yt = null, Ct = null, Et = null;
          if (typeof Me.componentWillMount == "function" && Me.componentWillMount.__suppressDeprecationWarning !== !0 ? yt = "componentWillMount" : typeof Me.UNSAFE_componentWillMount == "function" && (yt = "UNSAFE_componentWillMount"), typeof Me.componentWillReceiveProps == "function" && Me.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ct = "componentWillReceiveProps" : typeof Me.UNSAFE_componentWillReceiveProps == "function" && (Ct = "UNSAFE_componentWillReceiveProps"), typeof Me.componentWillUpdate == "function" && Me.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Et = "componentWillUpdate" : typeof Me.UNSAFE_componentWillUpdate == "function" && (Et = "UNSAFE_componentWillUpdate"), yt !== null || Ct !== null || Et !== null) {
            var Pn = qt(h) || "Component", yr = typeof h.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Wy.has(Pn) || (Wy.add(Pn), y(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Pn, yr, yt !== null ? `
  ` + yt : "", Ct !== null ? `
  ` + Ct : "", Et !== null ? `
  ` + Et : ""));
          }
        }
      }
      return M && Ff(d, A, W), Me;
    }
    function y_(d, h) {
      var C = h.state;
      typeof h.componentWillMount == "function" && h.componentWillMount(), typeof h.UNSAFE_componentWillMount == "function" && h.UNSAFE_componentWillMount(), C !== h.state && (y("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", lt(d) || "Component"), z5.enqueueReplaceState(h, h.state, null));
    }
    function _b(d, h, C, M) {
      var A = h.state;
      if (typeof h.componentWillReceiveProps == "function" && h.componentWillReceiveProps(C, M), typeof h.UNSAFE_componentWillReceiveProps == "function" && h.UNSAFE_componentWillReceiveProps(C, M), h.state !== A) {
        {
          var W = lt(d) || "Component";
          $w.has(W) || ($w.add(W), y("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", W));
        }
        z5.enqueueReplaceState(h, h.state, null);
      }
    }
    function Tx(d, h, C, M) {
      z6(d, h, C);
      var A = d.stateNode;
      A.props = C, A.state = d.memoizedState, A.refs = {}, Zf(d);
      var W = h.contextType;
      if (typeof W == "object" && W !== null)
        A.context = _i(W);
      else {
        var ae = Fo(d, h, !0);
        A.context = sd(d, ae);
      }
      {
        if (A.state === C) {
          var de = qt(h) || "Component";
          hg.has(de) || (hg.add(de), y("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", de));
        }
        d.mode & $s && Jt.recordLegacyContextWarning(d, A), Jt.recordUnsafeLifecycleWarnings(d, A);
      }
      A.state = d.memoizedState;
      var ge = h.getDerivedStateFromProps;
      if (typeof ge == "function" && (qy(d, h, ge, C), A.state = d.memoizedState), typeof h.getDerivedStateFromProps != "function" && typeof A.getSnapshotBeforeUpdate != "function" && (typeof A.UNSAFE_componentWillMount == "function" || typeof A.componentWillMount == "function") && (y_(d, A), Kp(d, C, A, M), A.state = d.memoizedState), typeof A.componentDidMount == "function") {
        var Ce = pt;
        Ce |= Kt, (d.mode & ku) !== Qn && (Ce |= vr), d.flags |= Ce;
      }
    }
    function H6(d, h, C, M) {
      var A = d.stateNode, W = d.memoizedProps;
      A.props = W;
      var ae = A.context, de = h.contextType, ge = Ii;
      if (typeof de == "object" && de !== null)
        ge = _i(de);
      else {
        var Ce = Fo(d, h, !0);
        ge = sd(d, Ce);
      }
      var Me = h.getDerivedStateFromProps, $e = typeof Me == "function" || typeof A.getSnapshotBeforeUpdate == "function";
      !$e && (typeof A.UNSAFE_componentWillReceiveProps == "function" || typeof A.componentWillReceiveProps == "function") && (W !== C || ae !== ge) && _b(d, A, C, ge), w0();
      var at = d.memoizedState, yt = A.state = at;
      if (Kp(d, C, A, M), yt = d.memoizedState, W === C && at === yt && !ic() && !Um()) {
        if (typeof A.componentDidMount == "function") {
          var Ct = pt;
          Ct |= Kt, (d.mode & ku) !== Qn && (Ct |= vr), d.flags |= Ct;
        }
        return !1;
      }
      typeof Me == "function" && (qy(d, h, Me, C), yt = d.memoizedState);
      var Et = Um() || kb(d, h, W, C, at, yt, ge);
      if (Et) {
        if (!$e && (typeof A.UNSAFE_componentWillMount == "function" || typeof A.componentWillMount == "function") && (typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount()), typeof A.componentDidMount == "function") {
          var Pn = pt;
          Pn |= Kt, (d.mode & ku) !== Qn && (Pn |= vr), d.flags |= Pn;
        }
      } else {
        if (typeof A.componentDidMount == "function") {
          var yr = pt;
          yr |= Kt, (d.mode & ku) !== Qn && (yr |= vr), d.flags |= yr;
        }
        d.memoizedProps = C, d.memoizedState = yt;
      }
      return A.props = C, A.state = yt, A.context = ge, Et;
    }
    function v_(d, h, C, M, A) {
      var W = h.stateNode;
      zy(d, h);
      var ae = h.memoizedProps, de = h.type === h.elementType ? ae : Gh(h.type, ae);
      W.props = de;
      var ge = h.pendingProps, Ce = W.context, Me = C.contextType, $e = Ii;
      if (typeof Me == "object" && Me !== null)
        $e = _i(Me);
      else {
        var at = Fo(h, C, !0);
        $e = sd(h, at);
      }
      var yt = C.getDerivedStateFromProps, Ct = typeof yt == "function" || typeof W.getSnapshotBeforeUpdate == "function";
      !Ct && (typeof W.UNSAFE_componentWillReceiveProps == "function" || typeof W.componentWillReceiveProps == "function") && (ae !== ge || Ce !== $e) && _b(h, W, M, $e), w0();
      var Et = h.memoizedState, Pn = W.state = Et;
      if (Kp(h, M, W, A), Pn = h.memoizedState, ae === ge && Et === Pn && !ic() && !Um() && !T)
        return typeof W.componentDidUpdate == "function" && (ae !== d.memoizedProps || Et !== d.memoizedState) && (h.flags |= pt), typeof W.getSnapshotBeforeUpdate == "function" && (ae !== d.memoizedProps || Et !== d.memoizedState) && (h.flags |= To), !1;
      typeof yt == "function" && (qy(h, C, yt, M), Pn = h.memoizedState);
      var yr = Um() || kb(h, C, de, M, Et, Pn, $e) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      T;
      return yr ? (!Ct && (typeof W.UNSAFE_componentWillUpdate == "function" || typeof W.componentWillUpdate == "function") && (typeof W.componentWillUpdate == "function" && W.componentWillUpdate(M, Pn, $e), typeof W.UNSAFE_componentWillUpdate == "function" && W.UNSAFE_componentWillUpdate(M, Pn, $e)), typeof W.componentDidUpdate == "function" && (h.flags |= pt), typeof W.getSnapshotBeforeUpdate == "function" && (h.flags |= To)) : (typeof W.componentDidUpdate == "function" && (ae !== d.memoizedProps || Et !== d.memoizedState) && (h.flags |= pt), typeof W.getSnapshotBeforeUpdate == "function" && (ae !== d.memoizedProps || Et !== d.memoizedState) && (h.flags |= To), h.memoizedProps = M, h.memoizedState = Pn), W.props = M, W.state = Pn, W.context = $e, yr;
    }
    function Zp(d, h) {
      return {
        value: d,
        source: h,
        stack: sn(h),
        digest: null
      };
    }
    function Yw(d, h, C) {
      return {
        value: d,
        source: null,
        stack: C ?? null,
        digest: h ?? null
      };
    }
    function x_(d, h) {
      return !0;
    }
    function qw(d, h) {
      try {
        var C = x_(d, h);
        if (C === !1)
          return;
        var M = h.value, A = h.source, W = h.stack, ae = W !== null ? W : "";
        if (M != null && M._suppressLogging) {
          if (d.tag === K)
            return;
          console.error(M);
        }
        var de = A ? lt(A) : null, ge = de ? "The above error occurred in the <" + de + "> component:" : "The above error occurred in one of your React components:", Ce;
        if (d.tag === Q)
          Ce = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var Me = lt(d) || "Anonymous";
          Ce = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + Me + ".");
        }
        var $e = ge + `
` + ae + `

` + ("" + Ce);
        console.error($e);
      } catch (at) {
        setTimeout(function() {
          throw at;
        });
      }
    }
    var b_ = typeof WeakMap == "function" ? WeakMap : Map;
    function V6(d, h, C) {
      var M = Jf($a, C);
      M.tag = Fm, M.payload = {
        element: null
      };
      var A = h.value;
      return M.callback = function() {
        Yl(A), qw(d, h);
      }, M;
    }
    function Kw(d, h, C) {
      var M = Jf($a, C);
      M.tag = Fm;
      var A = d.type.getDerivedStateFromError;
      if (typeof A == "function") {
        var W = h.value;
        M.payload = function() {
          return A(W);
        }, M.callback = function() {
          tp(d), qw(d, h);
        };
      }
      var ae = d.stateNode;
      return ae !== null && typeof ae.componentDidCatch == "function" && (M.callback = function() {
        tp(d), qw(d, h), typeof A != "function" && _S(this);
        var ge = h.value, Ce = h.stack;
        this.componentDidCatch(ge, {
          componentStack: Ce !== null ? Ce : ""
        }), typeof A != "function" && (Es(d.lanes, rr) || y("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", lt(d) || "Unknown"));
      }), M;
    }
    function $6(d, h, C) {
      var M = d.pingCache, A;
      if (M === null ? (M = d.pingCache = new b_(), A = /* @__PURE__ */ new Set(), M.set(h, A)) : (A = M.get(h), A === void 0 && (A = /* @__PURE__ */ new Set(), M.set(h, A))), !A.has(C)) {
        A.add(C);
        var W = su.bind(null, d, h, C);
        ya && e4(d, C), h.then(W, W);
      }
    }
    function S_(d, h, C, M) {
      var A = d.updateQueue;
      if (A === null) {
        var W = /* @__PURE__ */ new Set();
        W.add(C), d.updateQueue = W;
      } else
        A.add(C);
    }
    function w_(d, h) {
      var C = d.tag;
      if ((d.mode & na) === Qn && (C === H || C === Se || C === ve)) {
        var M = d.alternate;
        M ? (d.updateQueue = M.updateQueue, d.memoizedState = M.memoizedState, d.lanes = M.lanes) : (d.updateQueue = null, d.memoizedState = null);
      }
    }
    function G6(d) {
      var h = d;
      do {
        if (h.tag === ue && Pw(h))
          return h;
        h = h.return;
      } while (h !== null);
      return null;
    }
    function B5(d, h, C, M, A) {
      if ((d.mode & na) === Qn) {
        if (d === h)
          d.flags |= _s;
        else {
          if (d.flags |= Cr, C.flags |= fl, C.flags &= ~(Dc | Do), C.tag === K) {
            var W = C.alternate;
            if (W === null)
              C.tag = Ie;
            else {
              var ae = Jf($a, rr);
              ae.tag = b0, $o(C, ae, rr);
            }
          }
          C.lanes = Wn(C.lanes, rr);
        }
        return d;
      }
      return d.flags |= _s, d.lanes = A, d;
    }
    function Xw(d, h, C, M, A) {
      if (C.flags |= Do, ya && e4(d, A), M !== null && typeof M == "object" && typeof M.then == "function") {
        var W = M;
        w_(C), B() && C.mode & na && rg();
        var ae = G6(h);
        if (ae !== null) {
          ae.flags &= ~Wi, B5(ae, h, C, d, A), ae.mode & na && $6(d, W, A), S_(ae, d, W);
          return;
        } else {
          if (!Gs(A)) {
            $6(d, W, A), Qb();
            return;
          }
          var de = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          M = de;
        }
      } else if (B() && C.mode & na) {
        rg();
        var ge = G6(h);
        if (ge !== null) {
          (ge.flags & _s) === Nt && (ge.flags |= Wi), B5(ge, h, C, d, A), G(Zp(M, C));
          return;
        }
      }
      M = Zp(M, C), jN(M);
      var Ce = h;
      do {
        switch (Ce.tag) {
          case Q: {
            var Me = M;
            Ce.flags |= _s;
            var $e = rf(A);
            Ce.lanes = Wn(Ce.lanes, $e);
            var at = V6(Ce, Me, $e);
            Uu(Ce, at);
            return;
          }
          case K:
            var yt = M, Ct = Ce.type, Et = Ce.stateNode;
            if ((Ce.flags & Cr) === Nt && (typeof Ct.getDerivedStateFromError == "function" || Et !== null && typeof Et.componentDidCatch == "function" && !_N(Et))) {
              Ce.flags |= _s;
              var Pn = rf(A);
              Ce.lanes = Wn(Ce.lanes, Pn);
              var yr = Kw(Ce, yt, Pn);
              Uu(Ce, yr);
              return;
            }
            break;
        }
        Ce = Ce.return;
      } while (Ce !== null);
    }
    function Qw() {
      return null;
    }
    var Ky = o.ReactCurrentOwner, Wh = !1, Xy, gg, Zw, H5, Jw, Qy, V5, $5, Tb;
    Xy = {}, gg = {}, Zw = {}, H5 = {}, Jw = {}, Qy = !1, V5 = {}, $5 = {}, Tb = {};
    function Vu(d, h, C, M) {
      d === null ? h.child = ob(h, null, C, M) : h.child = $p(h, d.child, C, M);
    }
    function G5(d, h, C, M) {
      h.child = $p(h, d.child, null, M), h.child = $p(h, null, C, M);
    }
    function Mb(d, h, C, M, A) {
      if (h.type !== h.elementType) {
        var W = C.propTypes;
        W && Hc(
          W,
          M,
          // Resolved props
          "prop",
          qt(C)
        );
      }
      var ae = C.render, de = h.ref, ge, Ce;
      cf(h, A), ks(h);
      {
        if (Ky.current = h, rt(!0), ge = wd(d, h, ae, M, de, A), Ce = Vh(), h.mode & $s) {
          ja(!0);
          try {
            ge = wd(d, h, ae, M, de, A), Ce = Vh();
          } finally {
            ja(!1);
          }
        }
        rt(!1);
      }
      return br(), d !== null && !Wh ? (hb(d, h, A), vg(d, h, A)) : (B() && Ce && Oh(h), h.flags |= Wt, Vu(d, h, ge, A), h.child);
    }
    function Rb(d, h, C, M, A) {
      if (d === null) {
        var W = C.type;
        if (RN(W) && C.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        C.defaultProps === void 0) {
          var ae = W;
          return ae = ep(W), h.tag = ve, h.type = ae, Db(h, W), Mx(d, h, ae, M, A);
        }
        {
          var de = W.propTypes;
          if (de && Hc(
            de,
            M,
            // Resolved props
            "prop",
            qt(W)
          ), C.defaultProps !== void 0) {
            var ge = qt(W) || "Unknown";
            Tb[ge] || (y("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", ge), Tb[ge] = !0);
          }
        }
        var Ce = r4(C.type, null, M, h, h.mode, A);
        return Ce.ref = h.ref, Ce.return = h, h.child = Ce, Ce;
      }
      {
        var Me = C.type, $e = Me.propTypes;
        $e && Hc(
          $e,
          M,
          // Resolved props
          "prop",
          qt(Me)
        );
      }
      var at = d.child, yt = uC(d, A);
      if (!yt) {
        var Ct = at.memoizedProps, Et = C.compare;
        if (Et = Et !== null ? Et : Ze, Et(Ct, M) && d.ref === h.ref)
          return vg(d, h, A);
      }
      h.flags |= Wt;
      var Pn = $0(at, M);
      return Pn.ref = h.ref, Pn.return = h, h.child = Pn, Pn;
    }
    function Mx(d, h, C, M, A) {
      if (h.type !== h.elementType) {
        var W = h.elementType;
        if (W.$$typeof === ot) {
          var ae = W, de = ae._payload, ge = ae._init;
          try {
            W = ge(de);
          } catch {
            W = null;
          }
          var Ce = W && W.propTypes;
          Ce && Hc(
            Ce,
            M,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            qt(W)
          );
        }
      }
      if (d !== null) {
        var Me = d.memoizedProps;
        if (Ze(Me, M) && d.ref === h.ref && // Prevent bailout if the implementation changed due to hot reload.
        h.type === d.type)
          if (Wh = !1, h.pendingProps = M = Me, uC(d, A))
            (d.flags & fl) !== Nt && (Wh = !0);
          else return h.lanes = d.lanes, vg(d, h, A);
      }
      return nC(d, h, C, M, A);
    }
    function Rx(d, h, C) {
      var M = h.pendingProps, A = M.children, W = d !== null ? d.memoizedState : null;
      if (M.mode === "hidden" || D)
        if ((h.mode & na) === Qn) {
          var ae = {
            baseLanes: bt,
            cachePool: null,
            transitions: null
          };
          h.memoizedState = ae, qb(h, C);
        } else if (Es(C, gl)) {
          var $e = {
            baseLanes: bt,
            cachePool: null,
            transitions: null
          };
          h.memoizedState = $e;
          var at = W !== null ? W.baseLanes : C;
          qb(h, at);
        } else {
          var de = null, ge;
          if (W !== null) {
            var Ce = W.baseLanes;
            ge = Wn(Ce, C);
          } else
            ge = C;
          h.lanes = h.childLanes = gl;
          var Me = {
            baseLanes: ge,
            cachePool: de,
            transitions: null
          };
          return h.memoizedState = Me, h.updateQueue = null, qb(h, ge), null;
        }
      else {
        var yt;
        W !== null ? (yt = Wn(W.baseLanes, C), h.memoizedState = null) : yt = C, qb(h, yt);
      }
      return Vu(d, h, A, C), h.child;
    }
    function C_(d, h, C) {
      var M = h.pendingProps;
      return Vu(d, h, M, C), h.child;
    }
    function eC(d, h, C) {
      var M = h.pendingProps.children;
      return Vu(d, h, M, C), h.child;
    }
    function tC(d, h, C) {
      {
        h.flags |= pt;
        {
          var M = h.stateNode;
          M.effectDuration = 0, M.passiveEffectDuration = 0;
        }
      }
      var A = h.pendingProps, W = A.children;
      return Vu(d, h, W, C), h.child;
    }
    function W6(d, h) {
      var C = h.ref;
      (d === null && C !== null || d !== null && d.ref !== C) && (h.flags |= Yi, h.flags |= _t);
    }
    function nC(d, h, C, M, A) {
      if (h.type !== h.elementType) {
        var W = C.propTypes;
        W && Hc(
          W,
          M,
          // Resolved props
          "prop",
          qt(C)
        );
      }
      var ae;
      {
        var de = Fo(h, C, !0);
        ae = sd(h, de);
      }
      var ge, Ce;
      cf(h, A), ks(h);
      {
        if (Ky.current = h, rt(!0), ge = wd(d, h, C, M, ae, A), Ce = Vh(), h.mode & $s) {
          ja(!0);
          try {
            ge = wd(d, h, C, M, ae, A), Ce = Vh();
          } finally {
            ja(!1);
          }
        }
        rt(!1);
      }
      return br(), d !== null && !Wh ? (hb(d, h, A), vg(d, h, A)) : (B() && Ce && Oh(h), h.flags |= Wt, Vu(d, h, ge, A), h.child);
    }
    function N_(d, h, C, M, A) {
      {
        switch (FN(h)) {
          case !1: {
            var W = h.stateNode, ae = h.type, de = new ae(h.memoizedProps, W.context), ge = de.state;
            W.updater.enqueueSetState(W, ge, null);
            break;
          }
          case !0: {
            h.flags |= Cr, h.flags |= _s;
            var Ce = new Error("Simulated error coming from DevTools"), Me = rf(A);
            h.lanes = Wn(h.lanes, Me);
            var $e = Kw(h, Zp(Ce, h), Me);
            Uu(h, $e);
            break;
          }
        }
        if (h.type !== h.elementType) {
          var at = C.propTypes;
          at && Hc(
            at,
            M,
            // Resolved props
            "prop",
            qt(C)
          );
        }
      }
      var yt;
      xs(C) ? (yt = !0, Ci(h)) : yt = !1, cf(h, A);
      var Ct = h.stateNode, Et;
      Ct === null ? (K5(d, h), B6(h, C, M), Tx(h, C, M, A), Et = !0) : d === null ? Et = H6(h, C, M, A) : Et = v_(d, h, C, M, A);
      var Pn = rC(d, h, C, Et, yt, A);
      {
        var yr = h.stateNode;
        Et && yr.props !== M && (Qy || y("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", lt(h) || "a component"), Qy = !0);
      }
      return Pn;
    }
    function rC(d, h, C, M, A, W) {
      W6(d, h);
      var ae = (h.flags & Cr) !== Nt;
      if (!M && !ae)
        return A && Nm(h, C, !1), vg(d, h, W);
      var de = h.stateNode;
      Ky.current = h;
      var ge;
      if (ae && typeof C.getDerivedStateFromError != "function")
        ge = null, Vw();
      else {
        ks(h);
        {
          if (rt(!0), ge = de.render(), h.mode & $s) {
            ja(!0);
            try {
              de.render();
            } finally {
              ja(!1);
            }
          }
          rt(!1);
        }
        br();
      }
      return h.flags |= Wt, d !== null && ae ? G5(d, h, ge, W) : Vu(d, h, ge, W), h.memoizedState = de.state, A && Nm(h, C, !0), h.child;
    }
    function Y6(d) {
      var h = d.stateNode;
      h.pendingContext ? G1(d, h.pendingContext, h.pendingContext !== h.context) : h.context && G1(d, h.context, !1), Hy(d, h.containerInfo);
    }
    function j_(d, h, C) {
      if (Y6(h), d === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var M = h.pendingProps, A = h.memoizedState, W = A.element;
      zy(d, h), Kp(h, M, null, C);
      var ae = h.memoizedState;
      h.stateNode;
      var de = ae.element;
      if (Oo && A.isDehydrated) {
        var ge = {
          element: de,
          isDehydrated: !1,
          cache: ae.cache,
          pendingSuspenseBoundaries: ae.pendingSuspenseBoundaries,
          transitions: ae.transitions
        }, Ce = h.updateQueue;
        if (Ce.baseState = ge, h.memoizedState = ge, h.flags & Wi) {
          var Me = Zp(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), h);
          return q6(d, h, de, C, Me);
        } else if (de !== W) {
          var $e = Zp(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), h);
          return q6(d, h, de, C, $e);
        } else {
          ao(h);
          var at = ob(h, null, de, C);
          h.child = at;
          for (var yt = at; yt; )
            yt.flags = yt.flags & ~wn | Mo, yt = yt.sibling;
        }
      } else {
        if (x(), de === W)
          return vg(d, h, C);
        Vu(d, h, de, C);
      }
      return h.child;
    }
    function q6(d, h, C, M, A) {
      return x(), G(A), h.flags |= Wi, Vu(d, h, C, M), h.child;
    }
    function E_(d, h, C) {
      Sx(h), d === null && p0(h);
      var M = h.type, A = h.pendingProps, W = d !== null ? d.memoizedProps : null, ae = A.children, de = fh(M, A);
      return de ? ae = null : W !== null && fh(M, W) && (h.flags |= _o), W6(d, h), Vu(d, h, ae, C), h.child;
    }
    function k_(d, h) {
      return d === null && p0(h), null;
    }
    function aC(d, h, C, M) {
      K5(d, h);
      var A = h.pendingProps, W = C, ae = W._payload, de = W._init, ge = de(ae);
      h.type = ge;
      var Ce = h.tag = DN(ge), Me = Gh(ge, A), $e;
      switch (Ce) {
        case H:
          return Db(h, ge), h.type = ge = ep(ge), $e = nC(null, h, ge, Me, M), $e;
        case K:
          return h.type = ge = V0(ge), $e = N_(null, h, ge, Me, M), $e;
        case Se:
          return h.type = ge = DS(ge), $e = Mb(null, h, ge, Me, M), $e;
        case he: {
          if (h.type !== h.elementType) {
            var at = ge.propTypes;
            at && Hc(
              at,
              Me,
              // Resolved for outer only
              "prop",
              qt(ge)
            );
          }
          return $e = Rb(
            null,
            h,
            ge,
            Gh(ge.type, Me),
            // The inner type can have defaults too
            M
          ), $e;
        }
      }
      var yt = "";
      throw ge !== null && typeof ge == "object" && ge.$$typeof === ot && (yt = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + ge + ". " + ("Lazy element type must resolve to a class or function." + yt));
    }
    function __(d, h, C, M, A) {
      K5(d, h), h.tag = K;
      var W;
      return xs(C) ? (W = !0, Ci(h)) : W = !1, cf(h, A), B6(h, C, M), Tx(h, C, M, A), rC(null, h, C, !0, W, A);
    }
    function T_(d, h, C, M) {
      K5(d, h);
      var A = h.pendingProps, W;
      {
        var ae = Fo(h, C, !1);
        W = sd(h, ae);
      }
      cf(h, M);
      var de, ge;
      ks(h);
      {
        if (C.prototype && typeof C.prototype.render == "function") {
          var Ce = qt(C) || "Unknown";
          Xy[Ce] || (y("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Ce, Ce), Xy[Ce] = !0);
        }
        h.mode & $s && Jt.recordLegacyContextWarning(h, null), rt(!0), Ky.current = h, de = wd(null, h, C, A, W, M), ge = Vh(), rt(!1);
      }
      if (br(), h.flags |= Wt, typeof de == "object" && de !== null && typeof de.render == "function" && de.$$typeof === void 0) {
        var Me = qt(C) || "Unknown";
        gg[Me] || (y("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Me, Me, Me), gg[Me] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof de == "object" && de !== null && typeof de.render == "function" && de.$$typeof === void 0
      ) {
        {
          var $e = qt(C) || "Unknown";
          gg[$e] || (y("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", $e, $e, $e), gg[$e] = !0);
        }
        h.tag = K, h.memoizedState = null, h.updateQueue = null;
        var at = !1;
        return xs(C) ? (at = !0, Ci(h)) : at = !1, h.memoizedState = de.state !== null && de.state !== void 0 ? de.state : null, Zf(h), Ww(h, de), Tx(h, C, A, M), rC(null, h, C, !0, at, M);
      } else {
        if (h.tag = H, h.mode & $s) {
          ja(!0);
          try {
            de = wd(null, h, C, A, W, M), ge = Vh();
          } finally {
            ja(!1);
          }
        }
        return B() && ge && Oh(h), Vu(null, h, de, M), Db(h, C), h.child;
      }
    }
    function Db(d, h) {
      {
        if (h && h.childContextTypes && y("%s(...): childContextTypes cannot be defined on a function component.", h.displayName || h.name || "Component"), d.ref !== null) {
          var C = "", M = Ga();
          M && (C += `

Check the render method of \`` + M + "`.");
          var A = M || "", W = d._debugSource;
          W && (A = W.fileName + ":" + W.lineNumber), Jw[A] || (Jw[A] = !0, y("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", C));
        }
        if (h.defaultProps !== void 0) {
          var ae = qt(h) || "Unknown";
          Tb[ae] || (y("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", ae), Tb[ae] = !0);
        }
        if (typeof h.getDerivedStateFromProps == "function") {
          var de = qt(h) || "Unknown";
          H5[de] || (y("%s: Function components do not support getDerivedStateFromProps.", de), H5[de] = !0);
        }
        if (typeof h.contextType == "object" && h.contextType !== null) {
          var ge = qt(h) || "Unknown";
          Zw[ge] || (y("%s: Function components do not support contextType.", ge), Zw[ge] = !0);
        }
      }
    }
    var sC = {
      dehydrated: null,
      treeContext: null,
      retryLane: Zi
    };
    function Pb(d) {
      return {
        baseLanes: d,
        cachePool: Qw(),
        transitions: null
      };
    }
    function K6(d, h) {
      var C = null;
      return {
        baseLanes: Wn(d.baseLanes, h),
        cachePool: C,
        transitions: d.transitions
      };
    }
    function M_(d, h, C, M) {
      if (h !== null) {
        var A = h.memoizedState;
        if (A === null)
          return !1;
      }
      return N0(d, C0);
    }
    function R_(d, h) {
      return dc(d.childLanes, h);
    }
    function X6(d, h, C) {
      var M = h.pendingProps;
      GC(h) && (h.flags |= Cr);
      var A = Zc.current, W = !1, ae = (h.flags & Cr) !== Nt;
      if (ae || M_(A, d) ? (W = !0, h.flags &= ~Cr) : (d === null || d.memoizedState !== null) && (A = k5(A, cb)), A = j0(A), Uh(h, A), d === null) {
        p0(h);
        var de = h.memoizedState;
        if (de !== null) {
          var ge = de.dehydrated;
          if (ge !== null)
            return A_(h, ge);
        }
        var Ce = M.children, Me = M.fallback;
        if (W) {
          var $e = Q6(h, Ce, Me, C), at = h.child;
          return at.memoizedState = Pb(C), h.memoizedState = sC, $e;
        } else
          return iC(h, Ce);
      } else {
        var yt = d.memoizedState;
        if (yt !== null) {
          var Ct = yt.dehydrated;
          if (Ct !== null)
            return lC(d, h, ae, M, Ct, yt, C);
        }
        if (W) {
          var Et = M.fallback, Pn = M.children, yr = P_(d, h, Pn, Et, C), Zn = h.child, ms = d.child.memoizedState;
          return Zn.memoizedState = ms === null ? Pb(C) : K6(ms, C), Zn.childLanes = R_(d, C), h.memoizedState = sC, yr;
        } else {
          var fa = M.children, Qe = D_(d, h, fa, C);
          return h.memoizedState = null, Qe;
        }
      }
    }
    function iC(d, h, C) {
      var M = d.mode, A = {
        mode: "visible",
        children: h
      }, W = oC(A, M);
      return W.return = d, d.child = W, W;
    }
    function Q6(d, h, C, M) {
      var A = d.mode, W = d.child, ae = {
        mode: "hidden",
        children: h
      }, de, ge;
      return (A & na) === Qn && W !== null ? (de = W, de.childLanes = bt, de.pendingProps = ae, d.mode & Ca && (de.actualDuration = 0, de.actualStartTime = -1, de.selfBaseDuration = 0, de.treeBaseDuration = 0), ge = l1(C, A, M, null)) : (de = oC(ae, A), ge = l1(C, A, M, null)), de.return = d, ge.return = d, de.sibling = ge, d.child = de, ge;
    }
    function oC(d, h, C) {
      return s4(d, h, bt, null);
    }
    function Z6(d, h) {
      return $0(d, h);
    }
    function D_(d, h, C, M) {
      var A = d.child, W = A.sibling, ae = Z6(A, {
        mode: "visible",
        children: C
      });
      if ((h.mode & na) === Qn && (ae.lanes = M), ae.return = h, ae.sibling = null, W !== null) {
        var de = h.deletions;
        de === null ? (h.deletions = [W], h.flags |= hr) : de.push(W);
      }
      return h.child = ae, ae;
    }
    function P_(d, h, C, M, A) {
      var W = h.mode, ae = d.child, de = ae.sibling, ge = {
        mode: "hidden",
        children: C
      }, Ce;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (W & na) === Qn && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        h.child !== ae
      ) {
        var Me = h.child;
        Ce = Me, Ce.childLanes = bt, Ce.pendingProps = ge, h.mode & Ca && (Ce.actualDuration = 0, Ce.actualStartTime = -1, Ce.selfBaseDuration = ae.selfBaseDuration, Ce.treeBaseDuration = ae.treeBaseDuration), h.deletions = null;
      } else
        Ce = Z6(ae, ge), Ce.subtreeFlags = ae.subtreeFlags & ga;
      var $e;
      return de !== null ? $e = $0(de, M) : ($e = l1(M, W, A, null), $e.flags |= wn), $e.return = h, Ce.return = h, Ce.sibling = $e, h.child = Ce, $e;
    }
    function W5(d, h, C, M) {
      M !== null && G(M), $p(h, d.child, null, C);
      var A = h.pendingProps, W = A.children, ae = iC(h, W);
      return ae.flags |= wn, h.memoizedState = null, ae;
    }
    function O_(d, h, C, M, A) {
      var W = h.mode, ae = {
        mode: "visible",
        children: C
      }, de = oC(ae, W), ge = l1(M, W, A, null);
      return ge.flags |= wn, de.return = h, ge.return = h, de.sibling = ge, h.child = de, (h.mode & na) !== Qn && $p(h, d.child, null, A), ge;
    }
    function A_(d, h, C) {
      return (d.mode & na) === Qn ? (y("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), d.lanes = rr) : rc(h) ? d.lanes = Bl : d.lanes = gl, null;
    }
    function lC(d, h, C, M, A, W, ae) {
      if (C)
        if (h.flags & Wi) {
          h.flags &= ~Wi;
          var Qe = Yw(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return W5(d, h, ae, Qe);
        } else {
          if (h.memoizedState !== null)
            return h.child = d.child, h.flags |= Cr, null;
          var mt = M.children, Ke = M.fallback, $t = O_(d, h, mt, Ke, ae), Un = h.child;
          return Un.memoizedState = Pb(ae), h.memoizedState = sC, $t;
        }
      else {
        if (Up(), (h.mode & na) === Qn)
          return W5(
            d,
            h,
            ae,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (rc(A)) {
          var de, ge, Ce;
          {
            var Me = Ry(A);
            de = Me.digest, ge = Me.message, Ce = Me.stack;
          }
          var $e;
          ge ? $e = new Error(ge) : $e = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var at = Yw($e, de, Ce);
          return W5(d, h, ae, at);
        }
        var yt = Es(ae, d.childLanes);
        if (Wh || yt) {
          var Ct = xS();
          if (Ct !== null) {
            var Et = vo(Ct, ae);
            if (Et !== Zi && Et !== W.retryLane) {
              W.retryLane = Et;
              var Pn = $a;
              wo(d, Et), Qo(Ct, d, Et, Pn);
            }
          }
          Qb();
          var yr = Yw(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return W5(d, h, ae, yr);
        } else if (Lc(A)) {
          h.flags |= Cr, h.child = d.child;
          var Zn = PC.bind(null, d);
          return _p(A, Zn), null;
        } else {
          So(h, A, W.treeContext);
          var ms = M.children, fa = iC(h, ms);
          return fa.flags |= Mo, fa;
        }
      }
    }
    function J6(d, h, C) {
      d.lanes = Wn(d.lanes, h);
      var M = d.alternate;
      M !== null && (M.lanes = Wn(M.lanes, h)), vx(d.return, h, C);
    }
    function L_(d, h, C) {
      for (var M = h; M !== null; ) {
        if (M.tag === ue) {
          var A = M.memoizedState;
          A !== null && J6(M, C, d);
        } else if (M.tag === qe)
          J6(M, C, d);
        else if (M.child !== null) {
          M.child.return = M, M = M.child;
          continue;
        }
        if (M === d)
          return;
        for (; M.sibling === null; ) {
          if (M.return === null || M.return === d)
            return;
          M = M.return;
        }
        M.sibling.return = M.return, M = M.sibling;
      }
    }
    function I_(d) {
      for (var h = d, C = null; h !== null; ) {
        var M = h.alternate;
        M !== null && zh(M) === null && (C = h), h = h.sibling;
      }
      return C;
    }
    function F_(d) {
      if (d !== void 0 && d !== "forwards" && d !== "backwards" && d !== "together" && !V5[d])
        if (V5[d] = !0, typeof d == "string")
          switch (d.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              y('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', d, d.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              y('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', d, d.toLowerCase());
              break;
            }
            default:
              y('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', d);
              break;
          }
        else
          y('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', d);
    }
    function U_(d, h) {
      d !== void 0 && !$5[d] && (d !== "collapsed" && d !== "hidden" ? ($5[d] = !0, y('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', d)) : h !== "forwards" && h !== "backwards" && ($5[d] = !0, y('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', d)));
    }
    function eN(d, h) {
      {
        var C = xr(d), M = !C && typeof Ot(d) == "function";
        if (C || M) {
          var A = C ? "array" : "iterable";
          return y("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", A, h, A), !1;
        }
      }
      return !0;
    }
    function z_(d, h) {
      if ((h === "forwards" || h === "backwards") && d !== void 0 && d !== null && d !== !1)
        if (xr(d)) {
          for (var C = 0; C < d.length; C++)
            if (!eN(d[C], C))
              return;
        } else {
          var M = Ot(d);
          if (typeof M == "function") {
            var A = M.call(d);
            if (A)
              for (var W = A.next(), ae = 0; !W.done; W = A.next()) {
                if (!eN(W.value, ae))
                  return;
                ae++;
              }
          } else
            y('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', h);
        }
    }
    function cC(d, h, C, M, A) {
      var W = d.memoizedState;
      W === null ? d.memoizedState = {
        isBackwards: h,
        rendering: null,
        renderingStartTime: 0,
        last: M,
        tail: C,
        tailMode: A
      } : (W.isBackwards = h, W.rendering = null, W.renderingStartTime = 0, W.last = M, W.tail = C, W.tailMode = A);
    }
    function tN(d, h, C) {
      var M = h.pendingProps, A = M.revealOrder, W = M.tail, ae = M.children;
      F_(A), U_(W, A), z_(ae, A), Vu(d, h, ae, C);
      var de = Zc.current, ge = N0(de, C0);
      if (ge)
        de = ub(de, C0), h.flags |= Cr;
      else {
        var Ce = d !== null && (d.flags & Cr) !== Nt;
        Ce && L_(h, h.child, C), de = j0(de);
      }
      if (Uh(h, de), (h.mode & na) === Qn)
        h.memoizedState = null;
      else
        switch (A) {
          case "forwards": {
            var Me = I_(h.child), $e;
            Me === null ? ($e = h.child, h.child = null) : ($e = Me.sibling, Me.sibling = null), cC(
              h,
              !1,
              // isBackwards
              $e,
              Me,
              W
            );
            break;
          }
          case "backwards": {
            var at = null, yt = h.child;
            for (h.child = null; yt !== null; ) {
              var Ct = yt.alternate;
              if (Ct !== null && zh(Ct) === null) {
                h.child = yt;
                break;
              }
              var Et = yt.sibling;
              yt.sibling = at, at = yt, yt = Et;
            }
            cC(
              h,
              !0,
              // isBackwards
              at,
              null,
              // last
              W
            );
            break;
          }
          case "together": {
            cC(
              h,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            h.memoizedState = null;
        }
      return h.child;
    }
    function nN(d, h, C) {
      Hy(h, h.stateNode.containerInfo);
      var M = h.pendingProps;
      return d === null ? h.child = $p(h, null, M, C) : Vu(d, h, M, C), h.child;
    }
    var Y5 = !1;
    function B_(d, h, C) {
      var M = h.type, A = M._context, W = h.pendingProps, ae = h.memoizedProps, de = W.value;
      {
        "value" in W || Y5 || (Y5 = !0, y("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var ge = h.type.propTypes;
        ge && Hc(ge, W, "prop", "Context.Provider");
      }
      if (yx(h, A, de), ae !== null) {
        var Ce = ae.value;
        if (xl(Ce, de)) {
          if (ae.children === W.children && !ic())
            return vg(d, h, C);
        } else
          lb(h, A, C);
      }
      var Me = W.children;
      return Vu(d, h, Me, C), h.child;
    }
    var rN = !1;
    function q5(d, h, C) {
      var M = h.type;
      M._context === void 0 ? M !== M.Consumer && (rN || (rN = !0, y("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : M = M._context;
      var A = h.pendingProps, W = A.children;
      typeof W != "function" && y("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), cf(h, C);
      var ae = _i(M);
      ks(h);
      var de;
      return Ky.current = h, rt(!0), de = W(ae), rt(!1), br(), h.flags |= Wt, Vu(d, h, de, C), h.child;
    }
    function yg() {
      Wh = !0;
    }
    function K5(d, h) {
      (h.mode & na) === Qn && d !== null && (d.alternate = null, h.alternate = null, h.flags |= wn);
    }
    function vg(d, h, C) {
      return d !== null && (h.dependencies = d.dependencies), Vw(), cv(h.lanes), Es(C, h.childLanes) ? (Fy(d, h), h.child) : null;
    }
    function H_(d, h, C) {
      {
        var M = h.return;
        if (M === null)
          throw new Error("Cannot swap the root fiber.");
        if (d.alternate = null, h.alternate = null, C.index = h.index, C.sibling = h.sibling, C.return = h.return, C.ref = h.ref, h === M.child)
          M.child = C;
        else {
          var A = M.child;
          if (A === null)
            throw new Error("Expected parent to have a child.");
          for (; A.sibling !== h; )
            if (A = A.sibling, A === null)
              throw new Error("Expected to find the previous sibling.");
          A.sibling = C;
        }
        var W = M.deletions;
        return W === null ? (M.deletions = [d], M.flags |= hr) : W.push(d), C.flags |= wn, C;
      }
    }
    function uC(d, h) {
      var C = d.lanes;
      return !!Es(C, h);
    }
    function V_(d, h, C) {
      switch (h.tag) {
        case Q:
          Y6(h), h.stateNode, x();
          break;
        case X:
          Sx(h);
          break;
        case K: {
          var M = h.type;
          xs(M) && Ci(h);
          break;
        }
        case Z:
          Hy(h, h.stateNode.containerInfo);
          break;
        case pe: {
          var A = h.memoizedProps.value, W = h.type._context;
          yx(h, W, A);
          break;
        }
        case oe:
          {
            var ae = Es(C, h.childLanes);
            ae && (h.flags |= pt);
            {
              var de = h.stateNode;
              de.effectDuration = 0, de.passiveEffectDuration = 0;
            }
          }
          break;
        case ue: {
          var ge = h.memoizedState;
          if (ge !== null) {
            if (ge.dehydrated !== null)
              return Uh(h, j0(Zc.current)), h.flags |= Cr, null;
            var Ce = h.child, Me = Ce.childLanes;
            if (Es(C, Me))
              return X6(d, h, C);
            Uh(h, j0(Zc.current));
            var $e = vg(d, h, C);
            return $e !== null ? $e.sibling : null;
          } else
            Uh(h, j0(Zc.current));
          break;
        }
        case qe: {
          var at = (d.flags & Cr) !== Nt, yt = Es(C, h.childLanes);
          if (at) {
            if (yt)
              return tN(d, h, C);
            h.flags |= Cr;
          }
          var Ct = h.memoizedState;
          if (Ct !== null && (Ct.rendering = null, Ct.tail = null, Ct.lastEffect = null), Uh(h, Zc.current), yt)
            break;
          return null;
        }
        case Ne:
        case Xe:
          return h.lanes = bt, Rx(d, h, C);
      }
      return vg(d, h, C);
    }
    function aN(d, h, C) {
      if (h._debugNeedsRemount && d !== null)
        return H_(d, h, r4(h.type, h.key, h.pendingProps, h._debugOwner || null, h.mode, h.lanes));
      if (d !== null) {
        var M = d.memoizedProps, A = h.pendingProps;
        if (M !== A || ic() || // Force a re-render if the implementation changed due to hot reload:
        h.type !== d.type)
          Wh = !0;
        else {
          var W = uC(d, C);
          if (!W && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (h.flags & Cr) === Nt)
            return Wh = !1, V_(d, h, C);
          (d.flags & fl) !== Nt ? Wh = !0 : Wh = !1;
        }
      } else if (Wh = !1, B() && Am(h)) {
        var ae = h.index, de = eg();
        tg(h, de, ae);
      }
      switch (h.lanes = bt, h.tag) {
        case q:
          return T_(d, h, h.type, C);
        case Te: {
          var ge = h.elementType;
          return aC(d, h, ge, C);
        }
        case H: {
          var Ce = h.type, Me = h.pendingProps, $e = h.elementType === Ce ? Me : Gh(Ce, Me);
          return nC(d, h, Ce, $e, C);
        }
        case K: {
          var at = h.type, yt = h.pendingProps, Ct = h.elementType === at ? yt : Gh(at, yt);
          return N_(d, h, at, Ct, C);
        }
        case Q:
          return j_(d, h, C);
        case X:
          return E_(d, h, C);
        case se:
          return k_(d, h);
        case ue:
          return X6(d, h, C);
        case Z:
          return nN(d, h, C);
        case Se: {
          var Et = h.type, Pn = h.pendingProps, yr = h.elementType === Et ? Pn : Gh(Et, Pn);
          return Mb(d, h, Et, yr, C);
        }
        case te:
          return C_(d, h, C);
        case fe:
          return eC(d, h, C);
        case oe:
          return tC(d, h, C);
        case pe:
          return B_(d, h, C);
        case ce:
          return q5(d, h, C);
        case he: {
          var Zn = h.type, ms = h.pendingProps, fa = Gh(Zn, ms);
          if (h.type !== h.elementType) {
            var Qe = Zn.propTypes;
            Qe && Hc(
              Qe,
              fa,
              // Resolved for outer only
              "prop",
              qt(Zn)
            );
          }
          return fa = Gh(Zn.type, fa), Rb(d, h, Zn, fa, C);
        }
        case ve:
          return Mx(d, h, h.type, h.pendingProps, C);
        case Ie: {
          var mt = h.type, Ke = h.pendingProps, $t = h.elementType === mt ? Ke : Gh(mt, Ke);
          return __(d, h, mt, $t, C);
        }
        case qe:
          return tN(d, h, C);
        case it:
          break;
        case Ne:
          return Rx(d, h, C);
      }
      throw new Error("Unknown unit of work tag (" + h.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Jp(d) {
      d.flags |= pt;
    }
    function dC(d) {
      d.flags |= Yi, d.flags |= _t;
    }
    function sN(d, h) {
      var C = d !== null && d.child === h.child;
      if (C)
        return !0;
      if ((h.flags & hr) !== Nt)
        return !1;
      for (var M = h.child; M !== null; ) {
        if ((M.flags & wr) !== Nt || (M.subtreeFlags & wr) !== Nt)
          return !1;
        M = M.sibling;
      }
      return !0;
    }
    var Ob, Ab, X5, Q5;
    if (Rr)
      Ob = function(d, h, C, M) {
        for (var A = h.child; A !== null; ) {
          if (A.tag === X || A.tag === se)
            fi(d, A.stateNode);
          else if (A.tag !== Z) {
            if (A.child !== null) {
              A.child.return = A, A = A.child;
              continue;
            }
          }
          if (A === h)
            return;
          for (; A.sibling === null; ) {
            if (A.return === null || A.return === h)
              return;
            A = A.return;
          }
          A.sibling.return = A.return, A = A.sibling;
        }
      }, Ab = function(d, h) {
      }, X5 = function(d, h, C, M, A) {
        var W = d.memoizedProps;
        if (W !== M) {
          var ae = h.stateNode, de = Bm(), ge = P1(ae, C, W, M, A, de);
          h.updateQueue = ge, ge && Jp(h);
        }
      }, Q5 = function(d, h, C, M) {
        C !== M && Jp(h);
      };
    else if (Df) {
      Ob = function(d, h, C, M) {
        for (var A = h.child; A !== null; ) {
          if (A.tag === X) {
            var W = A.stateNode;
            if (C && M) {
              var ae = A.memoizedProps, de = A.type;
              W = Kd(W, de, ae, A);
            }
            fi(d, W);
          } else if (A.tag === se) {
            var ge = A.stateNode;
            if (C && M) {
              var Ce = A.memoizedProps;
              ge = Ao(ge, Ce, A);
            }
            fi(d, ge);
          } else if (A.tag !== Z) {
            if (A.tag === Ne && A.memoizedState !== null) {
              var Me = A.child;
              Me !== null && (Me.return = A), Ob(d, A, !0, !0);
            } else if (A.child !== null) {
              A.child.return = A, A = A.child;
              continue;
            }
          }
          if (A = A, A === h)
            return;
          for (; A.sibling === null; ) {
            if (A.return === null || A.return === h)
              return;
            A = A.return;
          }
          A.sibling.return = A.return, A = A.sibling;
        }
      };
      var iN = function(d, h, C, M) {
        for (var A = h.child; A !== null; ) {
          if (A.tag === X) {
            var W = A.stateNode;
            if (C && M) {
              var ae = A.memoizedProps, de = A.type;
              W = Kd(W, de, ae, A);
            }
            td(d, W);
          } else if (A.tag === se) {
            var ge = A.stateNode;
            if (C && M) {
              var Ce = A.memoizedProps;
              ge = Ao(ge, Ce, A);
            }
            td(d, ge);
          } else if (A.tag !== Z) {
            if (A.tag === Ne && A.memoizedState !== null) {
              var Me = A.child;
              Me !== null && (Me.return = A), iN(d, A, !0, !0);
            } else if (A.child !== null) {
              A.child.return = A, A = A.child;
              continue;
            }
          }
          if (A = A, A === h)
            return;
          for (; A.sibling === null; ) {
            if (A.return === null || A.return === h)
              return;
            A = A.return;
          }
          A.sibling.return = A.return, A = A.sibling;
        }
      };
      Ab = function(d, h) {
        var C = h.stateNode, M = sN(d, h);
        if (!M) {
          var A = C.containerInfo, W = Xi(A);
          iN(W, h, !1, !1), C.pendingChildren = W, Jp(h), qd(A, W);
        }
      }, X5 = function(d, h, C, M, A) {
        var W = d.stateNode, ae = d.memoizedProps, de = sN(d, h);
        if (de && ae === M) {
          h.stateNode = W;
          return;
        }
        var ge = h.stateNode, Ce = Bm(), Me = null;
        if (ae !== M && (Me = P1(ge, C, ae, M, A, Ce)), de && Me === null) {
          h.stateNode = W;
          return;
        }
        var $e = My(W, Me, C, ae, M, h, de, ge);
        Ul($e, C, M, A, Ce) && Jp(h), h.stateNode = $e, de ? Jp(h) : Ob($e, h, !1, !1);
      }, Q5 = function(d, h, C, M) {
        if (C !== M) {
          var A = By(), W = Bm();
          h.stateNode = mh(M, A, W, h), Jp(h);
        } else
          h.stateNode = d.stateNode;
      };
    } else
      Ab = function(d, h) {
      }, X5 = function(d, h, C, M, A) {
      }, Q5 = function(d, h, C, M) {
      };
    function Lb(d, h) {
      if (!B())
        switch (d.tailMode) {
          case "hidden": {
            for (var C = d.tail, M = null; C !== null; )
              C.alternate !== null && (M = C), C = C.sibling;
            M === null ? d.tail = null : M.sibling = null;
            break;
          }
          case "collapsed": {
            for (var A = d.tail, W = null; A !== null; )
              A.alternate !== null && (W = A), A = A.sibling;
            W === null ? !h && d.tail !== null ? d.tail.sibling = null : d.tail = null : W.sibling = null;
            break;
          }
        }
    }
    function eu(d) {
      var h = d.alternate !== null && d.alternate.child === d.child, C = bt, M = Nt;
      if (h) {
        if ((d.mode & Ca) !== Qn) {
          for (var ge = d.selfBaseDuration, Ce = d.child; Ce !== null; )
            C = Wn(C, Wn(Ce.lanes, Ce.childLanes)), M |= Ce.subtreeFlags & ga, M |= Ce.flags & ga, ge += Ce.treeBaseDuration, Ce = Ce.sibling;
          d.treeBaseDuration = ge;
        } else
          for (var Me = d.child; Me !== null; )
            C = Wn(C, Wn(Me.lanes, Me.childLanes)), M |= Me.subtreeFlags & ga, M |= Me.flags & ga, Me.return = d, Me = Me.sibling;
        d.subtreeFlags |= M;
      } else {
        if ((d.mode & Ca) !== Qn) {
          for (var A = d.actualDuration, W = d.selfBaseDuration, ae = d.child; ae !== null; )
            C = Wn(C, Wn(ae.lanes, ae.childLanes)), M |= ae.subtreeFlags, M |= ae.flags, A += ae.actualDuration, W += ae.treeBaseDuration, ae = ae.sibling;
          d.actualDuration = A, d.treeBaseDuration = W;
        } else
          for (var de = d.child; de !== null; )
            C = Wn(C, Wn(de.lanes, de.childLanes)), M |= de.subtreeFlags, M |= de.flags, de.return = d, de = de.sibling;
        d.subtreeFlags |= M;
      }
      return d.childLanes = C, h;
    }
    function $_(d, h, C) {
      if (hx() && (h.mode & na) !== Qn && (h.flags & Cr) === Nt)
        return v(h), x(), h.flags |= Wi | Do | _s, !1;
      var M = ag(h);
      if (C !== null && C.dehydrated !== null)
        if (d === null) {
          if (!M)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (qf(h), eu(h), (h.mode & Ca) !== Qn) {
            var A = C !== null;
            if (A) {
              var W = h.child;
              W !== null && (h.treeBaseDuration -= W.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (x(), (h.flags & Cr) === Nt && (h.memoizedState = null), h.flags |= pt, eu(h), (h.mode & Ca) !== Qn) {
            var ae = C !== null;
            if (ae) {
              var de = h.child;
              de !== null && (h.treeBaseDuration -= de.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return P(), !0;
    }
    function oN(d, h, C) {
      var M = h.pendingProps;
      switch (Lu(h), h.tag) {
        case q:
        case Te:
        case ve:
        case H:
        case Se:
        case te:
        case fe:
        case oe:
        case ce:
        case he:
          return eu(h), null;
        case K: {
          var A = h.type;
          return xs(A) && Jd(h), eu(h), null;
        }
        case Q: {
          var W = h.stateNode;
          if (Qc(h), wh(h), Cx(), W.pendingContext && (W.context = W.pendingContext, W.pendingContext = null), d === null || d.child === null) {
            var ae = ag(h);
            if (ae)
              Jp(h);
            else if (d !== null) {
              var de = d.memoizedState;
              // Check if this is a client root
              (!de.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (h.flags & Wi) !== Nt) && (h.flags |= To, P());
            }
          }
          return Ab(d, h), eu(h), null;
        }
        case X: {
          uf(h);
          var ge = By(), Ce = h.type;
          if (d !== null && h.stateNode != null)
            X5(d, h, Ce, M, ge), d.ref !== h.ref && dC(h);
          else {
            if (!M) {
              if (h.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return eu(h), null;
            }
            var Me = Bm(), $e = ag(h);
            if ($e)
              Ay(h, ge, Me) && Jp(h);
            else {
              var at = Ju(Ce, M, ge, Me, h);
              Ob(at, h, !1, !1), h.stateNode = at, Ul(at, Ce, M, ge, Me) && Jp(h);
            }
            h.ref !== null && dC(h);
          }
          return eu(h), null;
        }
        case se: {
          var yt = M;
          if (d && h.stateNode != null) {
            var Ct = d.memoizedProps;
            Q5(d, h, Ct, yt);
          } else {
            if (typeof yt != "string" && h.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Et = By(), Pn = Bm(), yr = ag(h);
            yr ? g0(h) && Jp(h) : h.stateNode = mh(yt, Et, Pn, h);
          }
          return eu(h), null;
        }
        case ue: {
          Sd(h);
          var Zn = h.memoizedState;
          if (d === null || d.memoizedState !== null && d.memoizedState.dehydrated !== null) {
            var ms = $_(d, h, Zn);
            if (!ms)
              return h.flags & _s ? h : null;
          }
          if ((h.flags & Cr) !== Nt)
            return h.lanes = C, (h.mode & Ca) !== Qn && D0(h), h;
          var fa = Zn !== null, Qe = d !== null && d.memoizedState !== null;
          if (fa !== Qe && fa) {
            var mt = h.child;
            if (mt.flags |= ul, (h.mode & na) !== Qn) {
              var Ke = d === null && (h.memoizedProps.unstable_avoidThisFallback !== !0 || !L);
              Ke || N0(Zc.current, cb) ? Wx() : Qb();
            }
          }
          var $t = h.updateQueue;
          if ($t !== null && (h.flags |= pt), eu(h), (h.mode & Ca) !== Qn && fa) {
            var Un = h.child;
            Un !== null && (h.treeBaseDuration -= Un.treeBaseDuration);
          }
          return null;
        }
        case Z:
          return Qc(h), Ab(d, h), d === null && Qa(h.stateNode.containerInfo), eu(h), null;
        case pe:
          var gn = h.type._context;
          return Wp(gn, h), eu(h), null;
        case Ie: {
          var ma = h.type;
          return xs(ma) && Jd(h), eu(h), null;
        }
        case qe: {
          Sd(h);
          var Sr = h.memoizedState;
          if (Sr === null)
            return eu(h), null;
          var _a = (h.flags & Cr) !== Nt, ua = Sr.rendering;
          if (ua === null)
            if (_a)
              Lb(Sr, !1);
            else {
              var ci = RC() && (d === null || (d.flags & Cr) === Nt);
              if (!ci)
                for (var lr = h.child; lr !== null; ) {
                  var lo = zh(lr);
                  if (lo !== null) {
                    _a = !0, h.flags |= Cr, Lb(Sr, !1);
                    var Yu = lo.updateQueue;
                    return Yu !== null && (h.updateQueue = Yu, h.flags |= pt), h.subtreeFlags = Nt, x0(h, C), Uh(h, ub(Zc.current, C0)), h.child;
                  }
                  lr = lr.sibling;
                }
              Sr.tail !== null && ns() > gS() && (h.flags |= Cr, _a = !0, Lb(Sr, !1), h.lanes = Vc);
            }
          else {
            if (!_a) {
              var Nc = zh(ua);
              if (Nc !== null) {
                h.flags |= Cr, _a = !0;
                var _d = Nc.updateQueue;
                if (_d !== null && (h.updateQueue = _d, h.flags |= pt), Lb(Sr, !0), Sr.tail === null && Sr.tailMode === "hidden" && !ua.alternate && !B())
                  return eu(h), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              ns() * 2 - Sr.renderingStartTime > gS() && C !== gl && (h.flags |= Cr, _a = !0, Lb(Sr, !1), h.lanes = Vc);
            }
            if (Sr.isBackwards)
              ua.sibling = h.child, h.child = ua;
            else {
              var Td = Sr.last;
              Td !== null ? Td.sibling = ua : h.child = ua, Sr.last = ua;
            }
          }
          if (Sr.tail !== null) {
            var Md = Sr.tail;
            Sr.rendering = Md, Sr.tail = Md.sibling, Sr.renderingStartTime = ns(), Md.sibling = null;
            var jo = Zc.current;
            return _a ? jo = ub(jo, C0) : jo = j0(jo), Uh(h, jo), Md;
          }
          return eu(h), null;
        }
        case it:
          break;
        case Ne:
        case Xe: {
          lv(h);
          var rp = h.memoizedState, Qx = rp !== null;
          if (d !== null) {
            var hv = d.memoizedState, c1 = hv !== null;
            c1 !== Qx && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !D && (h.flags |= ul);
          }
          return !Qx || (h.mode & na) === Qn ? eu(h) : Es(Km, gl) && (eu(h), Rr && h.subtreeFlags & (wn | pt) && (h.flags |= ul)), null;
        }
        case xt:
          return null;
        case rn:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + h.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function G_(d, h, C) {
      switch (Lu(h), h.tag) {
        case K: {
          var M = h.type;
          xs(M) && Jd(h);
          var A = h.flags;
          return A & _s ? (h.flags = A & ~_s | Cr, (h.mode & Ca) !== Qn && D0(h), h) : null;
        }
        case Q: {
          h.stateNode, Qc(h), wh(h), Cx();
          var W = h.flags;
          return (W & _s) !== Nt && (W & Cr) === Nt ? (h.flags = W & ~_s | Cr, h) : null;
        }
        case X:
          return uf(h), null;
        case ue: {
          Sd(h);
          var ae = h.memoizedState;
          if (ae !== null && ae.dehydrated !== null) {
            if (h.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            x();
          }
          var de = h.flags;
          return de & _s ? (h.flags = de & ~_s | Cr, (h.mode & Ca) !== Qn && D0(h), h) : null;
        }
        case qe:
          return Sd(h), null;
        case Z:
          return Qc(h), null;
        case pe:
          var ge = h.type._context;
          return Wp(ge, h), null;
        case Ne:
        case Xe:
          return lv(h), null;
        case xt:
          return null;
        default:
          return null;
      }
    }
    function lN(d, h, C) {
      switch (Lu(h), h.tag) {
        case K: {
          var M = h.type.childContextTypes;
          M != null && Jd(h);
          break;
        }
        case Q: {
          h.stateNode, Qc(h), wh(h), Cx();
          break;
        }
        case X: {
          uf(h);
          break;
        }
        case Z:
          Qc(h);
          break;
        case ue:
          Sd(h);
          break;
        case qe:
          Sd(h);
          break;
        case pe:
          var A = h.type._context;
          Wp(A, h);
          break;
        case Ne:
        case Xe:
          lv(h);
          break;
      }
    }
    function cN(d, h, C, M, A, W, ae, de, ge) {
      var Ce = Array.prototype.slice.call(arguments, 3);
      try {
        h.apply(C, Ce);
      } catch (Me) {
        this.onError(Me);
      }
    }
    var uN = cN;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var fC = document.createElement("react");
      uN = function(h, C, M, A, W, ae, de, ge, Ce) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var Me = document.createEvent("Event"), $e = !1, at = !0, yt = window.event, Ct = Object.getOwnPropertyDescriptor(window, "event");
        function Et() {
          fC.removeEventListener(mt, yr, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = yt);
        }
        var Pn = Array.prototype.slice.call(arguments, 3);
        function yr() {
          $e = !0, Et(), C.apply(M, Pn), at = !1;
        }
        var Zn, ms = !1, fa = !1;
        function Qe(Ke) {
          if (Zn = Ke.error, ms = !0, Zn === null && Ke.colno === 0 && Ke.lineno === 0 && (fa = !0), Ke.defaultPrevented && Zn != null && typeof Zn == "object")
            try {
              Zn._suppressLogging = !0;
            } catch {
            }
        }
        var mt = "react-" + (h || "invokeguardedcallback");
        if (window.addEventListener("error", Qe), fC.addEventListener(mt, yr, !1), Me.initEvent(mt, !1, !1), fC.dispatchEvent(Me), Ct && Object.defineProperty(window, "event", Ct), $e && at && (ms ? fa && (Zn = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Zn = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Zn)), window.removeEventListener("error", Qe), !$e)
          return Et(), cN.apply(this, arguments);
      };
    }
    var W_ = uN, e1 = !1, xg = null, mC = {
      onError: function(d) {
        e1 = !0, xg = d;
      }
    };
    function Dx(d, h, C, M, A, W, ae, de, ge) {
      e1 = !1, xg = null, W_.apply(mC, arguments);
    }
    function hC() {
      return e1;
    }
    function dN() {
      if (e1) {
        var d = xg;
        return e1 = !1, xg = null, d;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    var fN = null;
    fN = /* @__PURE__ */ new Set();
    var Z5 = !1, qo = !1, J5 = typeof WeakSet == "function" ? WeakSet : Set, Dn = null, t1 = null, Gm = null;
    function P0(d) {
      Dx(null, function() {
        throw d;
      }), dN();
    }
    var Px = function(d, h) {
      if (h.props = d.memoizedProps, h.state = d.memoizedState, d.mode & Ca)
        try {
          Qp(), h.componentWillUnmount();
        } finally {
          $m(d);
        }
      else
        h.componentWillUnmount();
    };
    function Ib(d, h) {
      try {
        io(Co, d);
      } catch (C) {
        Fr(d, h, C);
      }
    }
    function Fb(d, h, C) {
      try {
        Px(d, C);
      } catch (M) {
        Fr(d, h, M);
      }
    }
    function Y_(d, h, C) {
      try {
        C.componentDidMount();
      } catch (M) {
        Fr(d, h, M);
      }
    }
    function pC(d, h) {
      try {
        tS(d);
      } catch (C) {
        Fr(d, h, C);
      }
    }
    function Zy(d, h) {
      var C = d.ref;
      if (C !== null)
        if (typeof C == "function") {
          var M;
          try {
            if (U && z && d.mode & Ca)
              try {
                Qp(), M = C(null);
              } finally {
                $m(d);
              }
            else
              M = C(null);
          } catch (A) {
            Fr(d, h, A);
          }
          typeof M == "function" && y("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", lt(d));
        } else
          C.current = null;
    }
    function Jy(d, h, C) {
      try {
        C();
      } catch (M) {
        Fr(d, h, M);
      }
    }
    var Wm = !1;
    function gC(d, h) {
      ec(d.containerInfo), Dn = h, eS();
      var C = Wm;
      return Wm = !1, C;
    }
    function eS() {
      for (; Dn !== null; ) {
        var d = Dn, h = d.child;
        (d.subtreeFlags & Xn) !== Nt && h !== null ? (h.return = d, Dn = h) : bg();
      }
    }
    function bg() {
      for (; Dn !== null; ) {
        var d = Dn;
        Be(d);
        try {
          O0(d);
        } catch (C) {
          Fr(d, d.return, C);
        }
        Zs();
        var h = d.sibling;
        if (h !== null) {
          h.return = d.return, Dn = h;
          return;
        }
        Dn = d.return;
      }
    }
    function O0(d) {
      var h = d.alternate, C = d.flags;
      if ((C & To) !== Nt) {
        switch (Be(d), d.tag) {
          case H:
          case Se:
          case ve:
            break;
          case K: {
            if (h !== null) {
              var M = h.memoizedProps, A = h.memoizedState, W = d.stateNode;
              d.type === d.elementType && !Qy && (W.props !== d.memoizedProps && y("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", lt(d) || "instance"), W.state !== d.memoizedState && y("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", lt(d) || "instance"));
              var ae = W.getSnapshotBeforeUpdate(d.elementType === d.type ? M : Gh(d.type, M), A);
              {
                var de = fN;
                ae === void 0 && !de.has(d.type) && (de.add(d.type), y("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", lt(d)));
              }
              W.__reactInternalSnapshotBeforeUpdate = ae;
            }
            break;
          }
          case Q: {
            if (Rr) {
              var ge = d.stateNode;
              I1(ge.containerInfo);
            }
            break;
          }
          case X:
          case se:
          case Z:
          case Ie:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Zs();
      }
    }
    function xi(d, h, C) {
      var M = h.updateQueue, A = M !== null ? M.lastEffect : null;
      if (A !== null) {
        var W = A.next, ae = W;
        do {
          if ((ae.tag & d) === d) {
            var de = ae.destroy;
            ae.destroy = void 0, de !== void 0 && ((d & Wo) !== Jc ? ji(h) : (d & Co) !== Jc && Dh(h), (d & Hm) !== Jc && o1(!0), Jy(h, C, de), (d & Hm) !== Jc && o1(!1), (d & Wo) !== Jc ? ro() : (d & Co) !== Jc && lf());
          }
          ae = ae.next;
        } while (ae !== W);
      }
    }
    function io(d, h) {
      var C = h.updateQueue, M = C !== null ? C.lastEffect : null;
      if (M !== null) {
        var A = M.next, W = A;
        do {
          if ((W.tag & d) === d) {
            (d & Wo) !== Jc ? cs(h) : (d & Co) !== Jc && Pm(h);
            var ae = W.create;
            (d & Hm) !== Jc && o1(!0), W.destroy = ae(), (d & Hm) !== Jc && o1(!1), (d & Wo) !== Jc ? Os() : (d & Co) !== Jc && Xs();
            {
              var de = W.destroy;
              if (de !== void 0 && typeof de != "function") {
                var ge = void 0;
                (W.tag & Co) !== Nt ? ge = "useLayoutEffect" : (W.tag & Hm) !== Nt ? ge = "useInsertionEffect" : ge = "useEffect";
                var Ce = void 0;
                de === null ? Ce = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof de.then == "function" ? Ce = `

It looks like you wrote ` + ge + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + ge + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : Ce = " You returned: " + de, y("%s must not return anything besides a function, which is used for clean-up.%s", ge, Ce);
              }
            }
          }
          W = W.next;
        } while (W !== A);
      }
    }
    function yC(d, h) {
      if ((h.flags & pt) !== Nt)
        switch (h.tag) {
          case oe: {
            var C = h.stateNode.passiveEffectDuration, M = h.memoizedProps, A = M.id, W = M.onPostCommit, ae = F5(), de = h.alternate === null ? "mount" : "update";
            F6() && (de = "nested-update"), typeof W == "function" && W(A, de, C, ae);
            var ge = h.return;
            e: for (; ge !== null; ) {
              switch (ge.tag) {
                case Q:
                  var Ce = ge.stateNode;
                  Ce.passiveEffectDuration += C;
                  break e;
                case oe:
                  var Me = ge.stateNode;
                  Me.passiveEffectDuration += C;
                  break e;
              }
              ge = ge.return;
            }
            break;
          }
        }
    }
    function tm(d, h, C, M) {
      if ((C.flags & Ts) !== Nt)
        switch (C.tag) {
          case H:
          case Se:
          case ve: {
            if (!qo)
              if (C.mode & Ca)
                try {
                  Qp(), io(Co | Qr, C);
                } finally {
                  $m(C);
                }
              else
                io(Co | Qr, C);
            break;
          }
          case K: {
            var A = C.stateNode;
            if (C.flags & pt && !qo)
              if (h === null)
                if (C.type === C.elementType && !Qy && (A.props !== C.memoizedProps && y("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", lt(C) || "instance"), A.state !== C.memoizedState && y("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", lt(C) || "instance")), C.mode & Ca)
                  try {
                    Qp(), A.componentDidMount();
                  } finally {
                    $m(C);
                  }
                else
                  A.componentDidMount();
              else {
                var W = C.elementType === C.type ? h.memoizedProps : Gh(C.type, h.memoizedProps), ae = h.memoizedState;
                if (C.type === C.elementType && !Qy && (A.props !== C.memoizedProps && y("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", lt(C) || "instance"), A.state !== C.memoizedState && y("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", lt(C) || "instance")), C.mode & Ca)
                  try {
                    Qp(), A.componentDidUpdate(W, ae, A.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    $m(C);
                  }
                else
                  A.componentDidUpdate(W, ae, A.__reactInternalSnapshotBeforeUpdate);
              }
            var de = C.updateQueue;
            de !== null && (C.type === C.elementType && !Qy && (A.props !== C.memoizedProps && y("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", lt(C) || "instance"), A.state !== C.memoizedState && y("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", lt(C) || "instance")), Go(C, de, A));
            break;
          }
          case Q: {
            var ge = C.updateQueue;
            if (ge !== null) {
              var Ce = null;
              if (C.child !== null)
                switch (C.child.tag) {
                  case X:
                    Ce = Mr(C.child.stateNode);
                    break;
                  case K:
                    Ce = C.child.stateNode;
                    break;
                }
              Go(C, ge, Ce);
            }
            break;
          }
          case X: {
            var Me = C.stateNode;
            if (h === null && C.flags & pt) {
              var $e = C.type, at = C.memoizedProps;
              Ep(Me, $e, at, C);
            }
            break;
          }
          case se:
            break;
          case Z:
            break;
          case oe: {
            {
              var yt = C.memoizedProps, Ct = yt.onCommit, Et = yt.onRender, Pn = C.stateNode.effectDuration, yr = F5(), Zn = h === null ? "mount" : "update";
              F6() && (Zn = "nested-update"), typeof Et == "function" && Et(C.memoizedProps.id, Zn, C.actualDuration, C.treeBaseDuration, C.actualStartTime, yr);
              {
                typeof Ct == "function" && Ct(C.memoizedProps.id, Zn, Pn, yr), H0(C);
                var ms = C.return;
                e: for (; ms !== null; ) {
                  switch (ms.tag) {
                    case Q:
                      var fa = ms.stateNode;
                      fa.effectDuration += Pn;
                      break e;
                    case oe:
                      var Qe = ms.stateNode;
                      Qe.effectDuration += Pn;
                      break e;
                  }
                  ms = ms.return;
                }
              }
            }
            break;
          }
          case ue: {
            bC(d, C);
            break;
          }
          case qe:
          case Ie:
          case it:
          case Ne:
          case Xe:
          case rn:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      qo || C.flags & Yi && tS(C);
    }
    function Sg(d) {
      switch (d.tag) {
        case H:
        case Se:
        case ve: {
          if (d.mode & Ca)
            try {
              Qp(), Ib(d, d.return);
            } finally {
              $m(d);
            }
          else
            Ib(d, d.return);
          break;
        }
        case K: {
          var h = d.stateNode;
          typeof h.componentDidMount == "function" && Y_(d, d.return, h), pC(d, d.return);
          break;
        }
        case X: {
          pC(d, d.return);
          break;
        }
      }
    }
    function n1(d, h) {
      var C = null;
      if (Rr)
        for (var M = d; ; ) {
          if (M.tag === X) {
            if (C === null) {
              C = M;
              try {
                var A = M.stateNode;
                h ? Su(A) : gh(M.stateNode, M.memoizedProps);
              } catch (ae) {
                Fr(d, d.return, ae);
              }
            }
          } else if (M.tag === se) {
            if (C === null)
              try {
                var W = M.stateNode;
                h ? wu(W) : yh(W, M.memoizedProps);
              } catch (ae) {
                Fr(d, d.return, ae);
              }
          } else if (!((M.tag === Ne || M.tag === Xe) && M.memoizedState !== null && M !== d)) {
            if (M.child !== null) {
              M.child.return = M, M = M.child;
              continue;
            }
          }
          if (M === d)
            return;
          for (; M.sibling === null; ) {
            if (M.return === null || M.return === d)
              return;
            C === M && (C = null), M = M.return;
          }
          C === M && (C = null), M.sibling.return = M.return, M = M.sibling;
        }
    }
    function tS(d) {
      var h = d.ref;
      if (h !== null) {
        var C = d.stateNode, M;
        switch (d.tag) {
          case X:
            M = Mr(C);
            break;
          default:
            M = C;
        }
        if (typeof h == "function") {
          var A;
          if (d.mode & Ca)
            try {
              Qp(), A = h(M);
            } finally {
              $m(d);
            }
          else
            A = h(M);
          typeof A == "function" && y("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", lt(d));
        } else
          h.hasOwnProperty("current") || y("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", lt(d)), h.current = M;
      }
    }
    function Ox(d) {
      var h = d.alternate;
      h !== null && (h.return = null), d.return = null;
    }
    function vC(d) {
      var h = d.alternate;
      h !== null && (d.alternate = null, vC(h));
      {
        if (d.child = null, d.deletions = null, d.sibling = null, d.tag === X) {
          var C = d.stateNode;
          C !== null && A1(C);
        }
        d.stateNode = null, d._debugOwner = null, d.return = null, d.dependencies = null, d.memoizedProps = null, d.memoizedState = null, d.pendingProps = null, d.stateNode = null, d.updateQueue = null;
      }
    }
    function Ax(d) {
      if (Df) {
        var h = d.stateNode, C = h.containerInfo, M = Xi(C);
        bm(C, M);
      }
    }
    function nS(d) {
      for (var h = d.return; h !== null; ) {
        if (Yh(h))
          return h;
        h = h.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Yh(d) {
      return d.tag === X || d.tag === Q || d.tag === Z;
    }
    function Ub(d) {
      var h = d;
      e: for (; ; ) {
        for (; h.sibling === null; ) {
          if (h.return === null || Yh(h.return))
            return null;
          h = h.return;
        }
        for (h.sibling.return = h.return, h = h.sibling; h.tag !== X && h.tag !== se && h.tag !== Ue; ) {
          if (h.flags & wn || h.child === null || h.tag === Z)
            continue e;
          h.child.return = h, h = h.child;
        }
        if (!(h.flags & wn))
          return h.stateNode;
      }
    }
    function xC(d) {
      if (Rr) {
        var h = nS(d);
        switch (h.tag) {
          case X: {
            var C = h.stateNode;
            h.flags & _o && (xm(C), h.flags &= ~_o);
            var M = Ub(d);
            aS(d, M, C);
            break;
          }
          case Q:
          case Z: {
            var A = h.stateNode.containerInfo, W = Ub(d);
            rS(d, W, A);
            break;
          }
          default:
            throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
    }
    function rS(d, h, C) {
      var M = d.tag, A = M === X || M === se;
      if (A) {
        var W = d.stateNode;
        h ? vm(C, W, h) : Rs(C, W);
      } else if (M !== Z) {
        var ae = d.child;
        if (ae !== null) {
          rS(ae, h, C);
          for (var de = ae.sibling; de !== null; )
            rS(de, h, C), de = de.sibling;
        }
      }
    }
    function aS(d, h, C) {
      var M = d.tag, A = M === X || M === se;
      if (A) {
        var W = d.stateNode;
        h ? sx(C, W, h) : ml(C, W);
      } else if (M !== Z) {
        var ae = d.child;
        if (ae !== null) {
          aS(ae, h, C);
          for (var de = ae.sibling; de !== null; )
            aS(de, h, C), de = de.sibling;
        }
      }
    }
    var Nl = null, Ym = !1;
    function q_(d, h, C) {
      if (Rr) {
        var M = h;
        e: for (; M !== null; ) {
          switch (M.tag) {
            case X: {
              Nl = M.stateNode, Ym = !1;
              break e;
            }
            case Q: {
              Nl = M.stateNode.containerInfo, Ym = !0;
              break e;
            }
            case Z: {
              Nl = M.stateNode.containerInfo, Ym = !0;
              break e;
            }
          }
          M = M.return;
        }
        if (Nl === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        Lx(d, h, C), Nl = null, Ym = !1;
      } else
        Lx(d, h, C);
      Ox(C);
    }
    function tu(d, h, C) {
      for (var M = C.child; M !== null; )
        Lx(d, h, M), M = M.sibling;
    }
    function Lx(d, h, C) {
      switch (Dm(C), C.tag) {
        case X:
          qo || Zy(C, h);
        case se: {
          if (Rr) {
            var M = Nl, A = Ym;
            Nl = null, tu(d, h, C), Nl = M, Ym = A, Nl !== null && (Ym ? kp(Nl, C.stateNode) : nc(Nl, C.stateNode));
          } else
            tu(d, h, C);
          return;
        }
        case Ue: {
          Rr && Nl !== null && (Ym ? s0(Nl, C.stateNode) : ox(Nl, C.stateNode));
          return;
        }
        case Z: {
          if (Rr) {
            var W = Nl, ae = Ym;
            Nl = C.stateNode.containerInfo, Ym = !0, tu(d, h, C), Nl = W, Ym = ae;
          } else
            Ax(C), tu(d, h, C);
          return;
        }
        case H:
        case Se:
        case he:
        case ve: {
          if (!qo) {
            var de = C.updateQueue;
            if (de !== null) {
              var ge = de.lastEffect;
              if (ge !== null) {
                var Ce = ge.next, Me = Ce;
                do {
                  var $e = Me, at = $e.destroy, yt = $e.tag;
                  at !== void 0 && ((yt & Hm) !== Jc ? Jy(C, h, at) : (yt & Co) !== Jc && (Dh(C), C.mode & Ca ? (Qp(), Jy(C, h, at), $m(C)) : Jy(C, h, at), lf())), Me = Me.next;
                } while (Me !== Ce);
              }
            }
          }
          tu(d, h, C);
          return;
        }
        case K: {
          if (!qo) {
            Zy(C, h);
            var Ct = C.stateNode;
            typeof Ct.componentWillUnmount == "function" && Fb(C, h, Ct);
          }
          tu(d, h, C);
          return;
        }
        case it: {
          tu(d, h, C);
          return;
        }
        case Ne: {
          if (
            // TODO: Remove this dead flag
            C.mode & na
          ) {
            var Et = qo;
            qo = Et || C.memoizedState !== null, tu(d, h, C), qo = Et;
          } else
            tu(d, h, C);
          break;
        }
        default: {
          tu(d, h, C);
          return;
        }
      }
    }
    function wg(d) {
      d.memoizedState;
    }
    function bC(d, h) {
      if (Oo) {
        var C = h.memoizedState;
        if (C === null) {
          var M = h.alternate;
          if (M !== null) {
            var A = M.memoizedState;
            if (A !== null) {
              var W = A.dehydrated;
              W !== null && a0(W);
            }
          }
        }
      }
    }
    function sS(d) {
      var h = d.updateQueue;
      if (h !== null) {
        d.updateQueue = null;
        var C = d.stateNode;
        C === null && (C = d.stateNode = new J5()), h.forEach(function(M) {
          var A = uT.bind(null, d, M);
          if (!C.has(M)) {
            if (C.add(M), ya)
              if (t1 !== null && Gm !== null)
                e4(Gm, t1);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            M.then(A, A);
          }
        });
      }
    }
    function mN(d, h, C) {
      t1 = C, Gm = d, Be(h), SC(h, d), Be(h), t1 = null, Gm = null;
    }
    function qh(d, h, C) {
      var M = h.deletions;
      if (M !== null)
        for (var A = 0; A < M.length; A++) {
          var W = M[A];
          try {
            q_(d, h, W);
          } catch (ge) {
            Fr(W, h, ge);
          }
        }
      var ae = ze();
      if (h.subtreeFlags & wr)
        for (var de = h.child; de !== null; )
          Be(de), SC(de, d), de = de.sibling;
      Be(ae);
    }
    function SC(d, h, C) {
      var M = d.alternate, A = d.flags;
      switch (d.tag) {
        case H:
        case Se:
        case he:
        case ve: {
          if (qh(h, d), nu(d), A & pt) {
            try {
              xi(Hm | Qr, d, d.return), io(Hm | Qr, d);
            } catch (lr) {
              Fr(d, d.return, lr);
            }
            if (d.mode & Ca) {
              try {
                Qp(), xi(Co | Qr, d, d.return);
              } catch (lr) {
                Fr(d, d.return, lr);
              }
              $m(d);
            } else
              try {
                xi(Co | Qr, d, d.return);
              } catch (lr) {
                Fr(d, d.return, lr);
              }
          }
          return;
        }
        case K: {
          qh(h, d), nu(d), A & Yi && M !== null && Zy(M, M.return);
          return;
        }
        case X: {
          if (qh(h, d), nu(d), A & Yi && M !== null && Zy(M, M.return), Rr) {
            if (d.flags & _o) {
              var W = d.stateNode;
              try {
                xm(W);
              } catch (lr) {
                Fr(d, d.return, lr);
              }
            }
            if (A & pt) {
              var ae = d.stateNode;
              if (ae != null) {
                var de = d.memoizedProps, ge = M !== null ? M.memoizedProps : de, Ce = d.type, Me = d.updateQueue;
                if (d.updateQueue = null, Me !== null)
                  try {
                    L1(ae, Me, Ce, ge, de, d);
                  } catch (lr) {
                    Fr(d, d.return, lr);
                  }
              }
            }
          }
          return;
        }
        case se: {
          if (qh(h, d), nu(d), A & pt && Rr) {
            if (d.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var $e = d.stateNode, at = d.memoizedProps, yt = M !== null ? M.memoizedProps : at;
            try {
              r0($e, yt, at);
            } catch (lr) {
              Fr(d, d.return, lr);
            }
          }
          return;
        }
        case Q: {
          if (qh(h, d), nu(d), A & pt) {
            if (Rr && Oo && M !== null) {
              var Ct = M.memoizedState;
              if (Ct.isDehydrated)
                try {
                  F1(h.containerInfo);
                } catch (lr) {
                  Fr(d, d.return, lr);
                }
            }
            if (Df) {
              var Et = h.containerInfo, Pn = h.pendingChildren;
              try {
                bm(Et, Pn);
              } catch (lr) {
                Fr(d, d.return, lr);
              }
            }
          }
          return;
        }
        case Z: {
          if (qh(h, d), nu(d), A & pt && Df) {
            var yr = d.stateNode, Zn = yr.containerInfo, ms = yr.pendingChildren;
            try {
              bm(Zn, ms);
            } catch (lr) {
              Fr(d, d.return, lr);
            }
          }
          return;
        }
        case ue: {
          qh(h, d), nu(d);
          var fa = d.child;
          if (fa.flags & ul) {
            var Qe = fa.stateNode, mt = fa.memoizedState, Ke = mt !== null;
            if (Qe.isHidden = Ke, Ke) {
              var $t = fa.alternate !== null && fa.alternate.memoizedState !== null;
              $t || NN();
            }
          }
          if (A & pt) {
            try {
              wg(d);
            } catch (lr) {
              Fr(d, d.return, lr);
            }
            sS(d);
          }
          return;
        }
        case Ne: {
          var Un = M !== null && M.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            d.mode & na
          ) {
            var gn = qo;
            qo = gn || Un, qh(h, d), qo = gn;
          } else
            qh(h, d);
          if (nu(d), A & ul) {
            var ma = d.stateNode, Sr = d.memoizedState, _a = Sr !== null, ua = d;
            if (ma.isHidden = _a, _a && !Un && (ua.mode & na) !== Qn) {
              Dn = ua;
              for (var ci = ua.child; ci !== null; )
                Dn = ci, iS(ci), ci = ci.sibling;
            }
            Rr && n1(ua, _a);
          }
          return;
        }
        case qe: {
          qh(h, d), nu(d), A & pt && sS(d);
          return;
        }
        case it:
          return;
        default: {
          qh(h, d), nu(d);
          return;
        }
      }
    }
    function nu(d) {
      var h = d.flags;
      if (h & wn) {
        try {
          xC(d);
        } catch (C) {
          Fr(d, d.return, C);
        }
        d.flags &= ~wn;
      }
      h & Mo && (d.flags &= ~Mo);
    }
    function Ix(d, h, C) {
      t1 = C, Gm = h, Dn = d, ev(d, h, C), t1 = null, Gm = null;
    }
    function ev(d, h, C) {
      for (var M = (d.mode & na) !== Qn; Dn !== null; ) {
        var A = Dn, W = A.child;
        if (A.tag === Ne && M) {
          var ae = A.memoizedState !== null, de = ae || Z5;
          if (de) {
            Fx(d, h, C);
            continue;
          } else {
            var ge = A.alternate, Ce = ge !== null && ge.memoizedState !== null, Me = Ce || qo, $e = Z5, at = qo;
            Z5 = de, qo = Me, qo && !at && (Dn = A, qm(A));
            for (var yt = W; yt !== null; )
              Dn = yt, ev(
                yt,
                // New root; bubble back up to here and stop.
                h,
                C
              ), yt = yt.sibling;
            Dn = A, Z5 = $e, qo = at, Fx(d, h, C);
            continue;
          }
        }
        (A.subtreeFlags & Ts) !== Nt && W !== null ? (W.return = A, Dn = W) : Fx(d, h, C);
      }
    }
    function Fx(d, h, C) {
      for (; Dn !== null; ) {
        var M = Dn;
        if ((M.flags & Ts) !== Nt) {
          var A = M.alternate;
          Be(M);
          try {
            tm(h, A, M, C);
          } catch (ae) {
            Fr(M, M.return, ae);
          }
          Zs();
        }
        if (M === d) {
          Dn = null;
          return;
        }
        var W = M.sibling;
        if (W !== null) {
          W.return = M.return, Dn = W;
          return;
        }
        Dn = M.return;
      }
    }
    function iS(d) {
      for (; Dn !== null; ) {
        var h = Dn, C = h.child;
        switch (h.tag) {
          case H:
          case Se:
          case he:
          case ve: {
            if (h.mode & Ca)
              try {
                Qp(), xi(Co, h, h.return);
              } finally {
                $m(h);
              }
            else
              xi(Co, h, h.return);
            break;
          }
          case K: {
            Zy(h, h.return);
            var M = h.stateNode;
            typeof M.componentWillUnmount == "function" && Fb(h, h.return, M);
            break;
          }
          case X: {
            Zy(h, h.return);
            break;
          }
          case Ne: {
            var A = h.memoizedState !== null;
            if (A) {
              nm(d);
              continue;
            }
            break;
          }
        }
        C !== null ? (C.return = h, Dn = C) : nm(d);
      }
    }
    function nm(d) {
      for (; Dn !== null; ) {
        var h = Dn;
        if (h === d) {
          Dn = null;
          return;
        }
        var C = h.sibling;
        if (C !== null) {
          C.return = h.return, Dn = C;
          return;
        }
        Dn = h.return;
      }
    }
    function qm(d) {
      for (; Dn !== null; ) {
        var h = Dn, C = h.child;
        if (h.tag === Ne) {
          var M = h.memoizedState !== null;
          if (M) {
            A0(d);
            continue;
          }
        }
        C !== null ? (C.return = h, Dn = C) : A0(d);
      }
    }
    function A0(d) {
      for (; Dn !== null; ) {
        var h = Dn;
        Be(h);
        try {
          Sg(h);
        } catch (M) {
          Fr(h, h.return, M);
        }
        if (Zs(), h === d) {
          Dn = null;
          return;
        }
        var C = h.sibling;
        if (C !== null) {
          C.return = h.return, Dn = C;
          return;
        }
        Dn = h.return;
      }
    }
    function Cg(d, h, C, M) {
      Dn = h, Ng(h, d, C, M);
    }
    function Ng(d, h, C, M) {
      for (; Dn !== null; ) {
        var A = Dn, W = A.child;
        (A.subtreeFlags & pa) !== Nt && W !== null ? (W.return = A, Dn = W) : K_(d, h, C, M);
      }
    }
    function K_(d, h, C, M) {
      for (; Dn !== null; ) {
        var A = Dn;
        if ((A.flags & qi) !== Nt) {
          Be(A);
          try {
            X_(h, A, C, M);
          } catch (ae) {
            Fr(A, A.return, ae);
          }
          Zs();
        }
        if (A === d) {
          Dn = null;
          return;
        }
        var W = A.sibling;
        if (W !== null) {
          W.return = A.return, Dn = W;
          return;
        }
        Dn = A.return;
      }
    }
    function X_(d, h, C, M) {
      switch (h.tag) {
        case H:
        case Se:
        case ve: {
          if (h.mode & Ca) {
            Ex();
            try {
              io(Wo | Qr, h);
            } finally {
              Gy(h);
            }
          } else
            io(Wo | Qr, h);
          break;
        }
      }
    }
    function Q_(d) {
      Dn = d, tv();
    }
    function tv() {
      for (; Dn !== null; ) {
        var d = Dn, h = d.child;
        if ((Dn.flags & hr) !== Nt) {
          var C = d.deletions;
          if (C !== null) {
            for (var M = 0; M < C.length; M++) {
              var A = C[M];
              Dn = A, oS(A, d);
            }
            {
              var W = d.alternate;
              if (W !== null) {
                var ae = W.child;
                if (ae !== null) {
                  W.child = null;
                  do {
                    var de = ae.sibling;
                    ae.sibling = null, ae = de;
                  } while (ae !== null);
                }
              }
            }
            Dn = d;
          }
        }
        (d.subtreeFlags & pa) !== Nt && h !== null ? (h.return = d, Dn = h) : hN();
      }
    }
    function hN() {
      for (; Dn !== null; ) {
        var d = Dn;
        (d.flags & qi) !== Nt && (Be(d), wC(d), Zs());
        var h = d.sibling;
        if (h !== null) {
          h.return = d.return, Dn = h;
          return;
        }
        Dn = d.return;
      }
    }
    function wC(d) {
      switch (d.tag) {
        case H:
        case Se:
        case ve: {
          d.mode & Ca ? (Ex(), xi(Wo | Qr, d, d.return), Gy(d)) : xi(Wo | Qr, d, d.return);
          break;
        }
      }
    }
    function oS(d, h) {
      for (; Dn !== null; ) {
        var C = Dn;
        Be(C), CC(C, h), Zs();
        var M = C.child;
        M !== null ? (M.return = C, Dn = M) : Z_(d);
      }
    }
    function Z_(d) {
      for (; Dn !== null; ) {
        var h = Dn, C = h.sibling, M = h.return;
        if (vC(h), h === d) {
          Dn = null;
          return;
        }
        if (C !== null) {
          C.return = M, Dn = C;
          return;
        }
        Dn = M;
      }
    }
    function CC(d, h) {
      switch (d.tag) {
        case H:
        case Se:
        case ve: {
          d.mode & Ca ? (Ex(), xi(Wo, d, h), Gy(d)) : xi(Wo, d, h);
          break;
        }
      }
    }
    function J_(d) {
      switch (d.tag) {
        case H:
        case Se:
        case ve: {
          try {
            io(Co | Qr, d);
          } catch (C) {
            Fr(d, d.return, C);
          }
          break;
        }
        case K: {
          var h = d.stateNode;
          try {
            h.componentDidMount();
          } catch (C) {
            Fr(d, d.return, C);
          }
          break;
        }
      }
    }
    function eT(d) {
      switch (d.tag) {
        case H:
        case Se:
        case ve: {
          try {
            io(Wo | Qr, d);
          } catch (h) {
            Fr(d, d.return, h);
          }
          break;
        }
      }
    }
    function nv(d) {
      switch (d.tag) {
        case H:
        case Se:
        case ve: {
          try {
            xi(Co | Qr, d, d.return);
          } catch (C) {
            Fr(d, d.return, C);
          }
          break;
        }
        case K: {
          var h = d.stateNode;
          typeof h.componentWillUnmount == "function" && Fb(d, d.return, h);
          break;
        }
      }
    }
    function ru(d) {
      switch (d.tag) {
        case H:
        case Se:
        case ve:
          try {
            xi(Wo | Qr, d, d.return);
          } catch (h) {
            Fr(d, d.return, h);
          }
      }
    }
    var jd = 0, mf = 1, r1 = 2, Kh = 3, lS = 4;
    if (typeof Symbol == "function" && Symbol.for) {
      var Ux = Symbol.for;
      jd = Ux("selector.component"), mf = Ux("selector.has_pseudo_class"), r1 = Ux("selector.role"), Kh = Ux("selector.test_id"), lS = Ux("selector.text");
    }
    function tT(d) {
      return {
        $$typeof: jd,
        value: d
      };
    }
    function nT(d) {
      return {
        $$typeof: mf,
        value: d
      };
    }
    function rT(d) {
      return {
        $$typeof: r1,
        value: d
      };
    }
    function pN(d) {
      return {
        $$typeof: lS,
        value: d
      };
    }
    function gN(d) {
      return {
        $$typeof: Kh,
        value: d
      };
    }
    function zb(d) {
      var h = hh(d);
      if (h != null) {
        if (typeof h.memoizedProps["data-testname"] != "string")
          throw new Error("Invalid host root specified. Should be either a React container or a node with a testname attribute.");
        return h;
      } else {
        var C = bu(d);
        if (C === null)
          throw new Error("Could not find React container within specified host subtree.");
        return C.stateNode.current;
      }
    }
    function cS(d, h) {
      switch (h.$$typeof) {
        case jd:
          if (d.type === h.value)
            return !0;
          break;
        case mf:
          return NC(d, h.value);
        case r1:
          if (d.tag === X) {
            var C = d.stateNode;
            if (Va(C, h.value))
              return !0;
          }
          break;
        case lS:
          if (d.tag === X || d.tag === se) {
            var M = la(d);
            if (M !== null && M.indexOf(h.value) >= 0)
              return !0;
          }
          break;
        case Kh:
          if (d.tag === X) {
            var A = d.memoizedProps["data-testname"];
            if (typeof A == "string" && A.toLowerCase() === h.value.toLowerCase())
              return !0;
          }
          break;
        default:
          throw new Error("Invalid selector type specified.");
      }
      return !1;
    }
    function uS(d) {
      switch (d.$$typeof) {
        case jd:
          var h = qt(d.value) || "Unknown";
          return "<" + h + ">";
        case mf:
          return ":has(" + (uS(d) || "") + ")";
        case r1:
          return '[role="' + d.value + '"]';
        case lS:
          return '"' + d.value + '"';
        case Kh:
          return '[data-testname="' + d.value + '"]';
        default:
          throw new Error("Invalid selector type specified.");
      }
    }
    function dS(d, h) {
      for (var C = [], M = [d, 0], A = 0; A < M.length; ) {
        var W = M[A++], ae = M[A++], de = h[ae];
        if (!(W.tag === X && Vs(W))) {
          for (; de != null && cS(W, de); )
            ae++, de = h[ae];
          if (ae === h.length)
            C.push(W);
          else
            for (var ge = W.child; ge !== null; )
              M.push(ge, ae), ge = ge.sibling;
        }
      }
      return C;
    }
    function NC(d, h) {
      for (var C = [d, 0], M = 0; M < C.length; ) {
        var A = C[M++], W = C[M++], ae = h[W];
        if (!(A.tag === X && Vs(A))) {
          for (; ae != null && cS(A, ae); )
            W++, ae = h[W];
          if (W === h.length)
            return !0;
          for (var de = A.child; de !== null; )
            C.push(de, W), de = de.sibling;
        }
      }
      return !1;
    }
    function zx(d, h) {
      if (!Za)
        throw new Error("Test selector API is not supported by this renderer.");
      for (var C = zb(d), M = dS(C, h), A = [], W = Array.from(M), ae = 0; ae < W.length; ) {
        var de = W[ae++];
        if (de.tag === X) {
          if (Vs(de))
            continue;
          A.push(de.stateNode);
        } else
          for (var ge = de.child; ge !== null; )
            W.push(ge), ge = ge.sibling;
      }
      return A;
    }
    function aT(d, h) {
      if (!Za)
        throw new Error("Test selector API is not supported by this renderer.");
      for (var C = zb(d), M = 0, A = [], W = [C, 0], ae = 0; ae < W.length; ) {
        var de = W[ae++], ge = W[ae++], Ce = h[ge];
        if (!(de.tag === X && Vs(de)) && (cS(de, Ce) && (A.push(uS(Ce)), ge++, ge > M && (M = ge)), ge < h.length))
          for (var Me = de.child; Me !== null; )
            W.push(Me, ge), Me = Me.sibling;
      }
      if (M < h.length) {
        for (var $e = [], at = M; at < h.length; at++)
          $e.push(uS(h[at]));
        return `findAllNodes was able to match part of the selector:
` + ("  " + A.join(" > ") + `

`) + `No matching component was found for:
` + ("  " + $e.join(" > "));
      }
      return null;
    }
    function sT(d, h) {
      if (!Za)
        throw new Error("Test selector API is not supported by this renderer.");
      for (var C = zx(d, h), M = [], A = 0; A < C.length; A++)
        M.push(tc(C[A]));
      for (var W = M.length - 1; W > 0; W--)
        for (var ae = M[W], de = ae.x, ge = de + ae.width, Ce = ae.y, Me = Ce + ae.height, $e = W - 1; $e >= 0; $e--)
          if (W !== $e) {
            var at = M[$e], yt = at.x, Ct = yt + at.width, Et = at.y, Pn = Et + at.height;
            if (de >= yt && Ce >= Et && ge <= Ct && Me <= Pn) {
              M.splice(W, 1);
              break;
            } else if (de === yt && ae.width === at.width && !(Pn < Ce) && !(Et > Me)) {
              Et > Ce && (at.height += Et - Ce, at.y = Ce), Pn < Me && (at.height = Me - Et), M.splice(W, 1);
              break;
            } else if (Ce === Et && ae.height === at.height && !(Ct < de) && !(yt > ge)) {
              yt > de && (at.width += yt - de, at.x = de), Ct < ge && (at.width = ge - yt), M.splice(W, 1);
              break;
            }
          }
      return M;
    }
    function iT(d, h) {
      if (!Za)
        throw new Error("Test selector API is not supported by this renderer.");
      for (var C = zb(d), M = dS(C, h), A = Array.from(M), W = 0; W < A.length; ) {
        var ae = A[W++];
        if (!Vs(ae)) {
          if (ae.tag === X) {
            var de = ae.stateNode;
            if (ax(de))
              return !0;
          }
          for (var ge = ae.child; ge !== null; )
            A.push(ge), ge = ge.sibling;
        }
      }
      return !1;
    }
    var fS = [];
    function yN() {
      Za && fS.forEach(function(d) {
        return d();
      });
    }
    function mS(d, h, C, M) {
      if (!Za)
        throw new Error("Test selector API is not supported by this renderer.");
      var A = zx(d, h), W = ed(A, C, M), ae = W.disconnect, de = W.observe, ge = W.unobserve, Ce = function() {
        var Me = zx(d, h);
        A.forEach(function($e) {
          Me.indexOf($e) < 0 && ge($e);
        }), Me.forEach(function($e) {
          A.indexOf($e) < 0 && de($e);
        });
      };
      return fS.push(Ce), {
        disconnect: function() {
          var Me = fS.indexOf(Ce);
          Me >= 0 && fS.splice(Me, 1), ae();
        }
      };
    }
    var oT = o.ReactCurrentActQueue;
    function vN(d) {
      {
        var h = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), C = typeof jest < "u";
        return O1 && C && h !== !1;
      }
    }
    function rv() {
      {
        var d = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !d && oT.current !== null && y("The current testing environment is not configured to support act(...)"), d;
      }
    }
    var xN = Math.ceil, Wl = o.ReactCurrentDispatcher, Bb = o.ReactCurrentOwner, oo = o.ReactCurrentBatchConfig, Xh = o.ReactCurrentActQueue, jl = (
      /*             */
      0
    ), rm = (
      /*               */
      1
    ), au = (
      /*                */
      2
    ), Cc = (
      /*                */
      4
    ), am = 0, jg = 1, Qh = 2, L0 = 3, Eg = 4, Bx = 5, kg = 6, Yr = jl, $u = null, Ri = null, Ko = bt, Km = bt, Hb = ad(bt), Xo = am, Hx = null, hS = bt, _g = bt, av = bt, I0 = null, Ed = null, pS = 0, sv = 500, jC = 1 / 0, lT = 500, Tg = null;
    function F0() {
      jC = ns() + lT;
    }
    function gS() {
      return jC;
    }
    var iv = !1, U0 = null, z0 = null, a1 = !1, Zh = null, Vx = bt, yS = [], vS = null, EC = 50, ov = 0, kC = null, _C = !1, Mg = !1, El = 50, Xm = 0, $x = null, Vb = $a, $b = bt, bN = !1;
    function xS() {
      return $u;
    }
    function Is() {
      return (Yr & (au | Cc)) !== jl ? ns() : (Vb !== $a || (Vb = ns()), Vb);
    }
    function B0(d) {
      var h = d.mode;
      if ((h & na) === Qn)
        return rr;
      if ((Yr & au) !== jl && Ko !== bt)
        return rf(Ko);
      var C = Fe() !== be;
      if (C) {
        if (oo.transition !== null) {
          var M = oo.transition;
          M._updatedFibers || (M._updatedFibers = /* @__PURE__ */ new Set()), M._updatedFibers.add(d);
        }
        return $b === Zi && ($b = Dy()), $b;
      }
      var A = hc();
      if (A !== Zi)
        return A;
      var W = rx();
      return W;
    }
    function bS(d) {
      var h = d.mode;
      return (h & na) === Qn ? rr : uc();
    }
    function Qo(d, h, C, M) {
      Jb(), bN && y("useInsertionEffect must not schedule updates."), _C && (Mg = !0), Ps(d, C, M), (Yr & au) !== bt && d === $u ? dT(h) : (ya && mc(d, h, C), fs(h), d === $u && ((Yr & au) === jl && (_g = Wn(_g, C)), Xo === Eg && Wu(d, Ko)), Gu(d, M), C === rr && Yr === jl && (h.mode & na) === Qn && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Xh.isBatchingLegacy && (F0(), As()));
    }
    function SN(d, h, C) {
      var M = d.current;
      M.lanes = h, Ps(d, h, C), Gu(d, C);
    }
    function SS(d) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Yr & au) !== jl
      );
    }
    function Gu(d, h) {
      var C = d.callbackNode;
      Oa(d, h);
      var M = ts(d, d === $u ? Ko : bt);
      if (M === bt) {
        C !== null && Dg(C), d.callbackNode = null, d.callbackPriority = Zi;
        return;
      }
      var A = js(M), W = d.callbackPriority;
      if (W === A && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Xh.current !== null && C !== gt)) {
        C == null && W !== rr && y("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      C != null && Dg(C);
      var ae;
      if (A === rr)
        d.tag === Ds ? (Xh.isBatchingLegacy !== null && (Xh.didScheduleLegacyUpdate = !0), hn(Rg.bind(null, d))) : Qs(Rg.bind(null, d)), Nr ? Xh.current !== null ? Xh.current.push(va) : ph(function() {
          (Yr & (au | Cc)) === jl && va();
        }) : kd(Yc, va), ae = null;
      else {
        var de;
        switch (qs(M)) {
          case ii:
            de = Yc;
            break;
          case Rm:
            de = rs;
            break;
          case Op:
            de = Zt;
            break;
          case af:
            de = pc;
            break;
          default:
            de = Zt;
            break;
        }
        ae = kd(de, Gb.bind(null, d));
      }
      d.callbackPriority = A, d.callbackNode = ae;
    }
    function Gb(d, h) {
      if (g_(), Vb = $a, $b = bt, (Yr & (au | Cc)) !== jl)
        throw new Error("Should not already be working.");
      var C = d.callbackNode, M = s1();
      if (M && d.callbackNode !== C)
        return null;
      var A = ts(d, d === $u ? Ko : bt);
      if (A === bt)
        return null;
      var W = !Du(d, A) && !_h(d, A) && !h, ae = W ? kN(d, A) : ES(d, A);
      if (ae !== am) {
        if (ae === Qh) {
          var de = or(d);
          de !== bt && (A = de, ae = Wb(d, de));
        }
        if (ae === jg) {
          var ge = Hx;
          throw hf(d, bt), Wu(d, A), Gu(d, ns()), ge;
        }
        if (ae === kg)
          Wu(d, A);
        else {
          var Ce = !Du(d, A), Me = d.current.alternate;
          if (Ce && !wN(Me)) {
            if (ae = ES(d, A), ae === Qh) {
              var $e = or(d);
              $e !== bt && (A = $e, ae = Wb(d, $e));
            }
            if (ae === jg) {
              var at = Hx;
              throw hf(d, bt), Wu(d, A), Gu(d, ns()), at;
            }
          }
          d.finishedWork = Me, d.finishedLanes = A, TC(d, ae, A);
        }
      }
      return Gu(d, ns()), d.callbackNode === C ? Gb.bind(null, d) : null;
    }
    function Wb(d, h) {
      var C = I0;
      if (oi(d)) {
        var M = hf(d, h);
        M.flags |= Wi, pl(d.containerInfo);
      }
      var A = ES(d, h);
      if (A !== Qh) {
        var W = Ed;
        Ed = C, W !== null && Yb(W);
      }
      return A;
    }
    function Yb(d) {
      Ed === null ? Ed = d : Ed.push.apply(Ed, d);
    }
    function TC(d, h, C) {
      switch (h) {
        case am:
        case jg:
          throw new Error("Root did not complete. This is a bug in React.");
        case Qh: {
          Zm(d, Ed, Tg);
          break;
        }
        case L0: {
          if (Wu(d, C), lc(C) && // do not delay if we're inside an act() scope
          !RS()) {
            var M = pS + sv - ns();
            if (M > 10) {
              var A = ts(d, bt);
              if (A !== bt)
                break;
              var W = d.suspendedLanes;
              if (!pi(W, C)) {
                Is(), fc(d, W);
                break;
              }
              d.timeoutHandle = jp(Zm.bind(null, d, Ed, Tg), M);
              break;
            }
          }
          Zm(d, Ed, Tg);
          break;
        }
        case Eg: {
          if (Wu(d, C), cc(C))
            break;
          if (!RS()) {
            var ae = Dr(d, C), de = ae, ge = ns() - de, Ce = Cn(ge) - ge;
            if (Ce > 10) {
              d.timeoutHandle = jp(Zm.bind(null, d, Ed, Tg), Ce);
              break;
            }
          }
          Zm(d, Ed, Tg);
          break;
        }
        case Bx: {
          Zm(d, Ed, Tg);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function wN(d) {
      for (var h = d; ; ) {
        if (h.flags & dl) {
          var C = h.updateQueue;
          if (C !== null) {
            var M = C.stores;
            if (M !== null)
              for (var A = 0; A < M.length; A++) {
                var W = M[A], ae = W.getSnapshot, de = W.value;
                try {
                  if (!xl(ae(), de))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var ge = h.child;
        if (h.subtreeFlags & dl && ge !== null) {
          ge.return = h, h = ge;
          continue;
        }
        if (h === d)
          return !0;
        for (; h.sibling === null; ) {
          if (h.return === null || h.return === d)
            return !0;
          h = h.return;
        }
        h.sibling.return = h.return, h = h.sibling;
      }
      return !0;
    }
    function Wu(d, h) {
      h = dc(h, av), h = dc(h, _g), Ws(d, h);
    }
    function Rg(d) {
      if (Mi(), (Yr & (au | Cc)) !== jl)
        throw new Error("Should not already be working.");
      s1();
      var h = ts(d, bt);
      if (!Es(h, rr))
        return Gu(d, ns()), null;
      var C = ES(d, h);
      if (d.tag !== Ds && C === Qh) {
        var M = or(d);
        M !== bt && (h = M, C = Wb(d, M));
      }
      if (C === jg) {
        var A = Hx;
        throw hf(d, bt), Wu(d, h), Gu(d, ns()), A;
      }
      if (C === kg)
        throw new Error("Root did not complete. This is a bug in React.");
      var W = d.current.alternate;
      return d.finishedWork = W, d.finishedLanes = h, Zm(d, Ed, Tg), Gu(d, ns()), null;
    }
    function wS(d, h) {
      h !== bt && (Hf(d, Wn(h, rr)), Gu(d, ns()), (Yr & (au | Cc)) === jl && (F0(), va()));
    }
    function MC(d) {
      var h = hc(), C = oo.transition;
      try {
        return oo.transition = null, gi(Op), d();
      } finally {
        gi(h), oo.transition = C;
      }
    }
    function cT(d, h) {
      var C = Yr;
      Yr |= rm;
      try {
        return d(h);
      } finally {
        Yr = C, Yr === jl && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Xh.isBatchingLegacy && (F0(), As());
      }
    }
    function CS(d, h, C, M, A) {
      var W = hc(), ae = oo.transition;
      try {
        return oo.transition = null, gi(ii), d(h, C, M, A);
      } finally {
        gi(W), oo.transition = ae, Yr === jl && F0();
      }
    }
    function NS(d) {
      Zh !== null && Zh.tag === Ds && (Yr & (au | Cc)) === jl && s1();
      var h = Yr;
      Yr |= rm;
      var C = oo.transition, M = hc();
      try {
        return oo.transition = null, gi(ii), d ? d() : void 0;
      } finally {
        gi(M), oo.transition = C, Yr = h, (Yr & (au | Cc)) === jl && va();
      }
    }
    function CN() {
      return (Yr & (au | Cc)) !== jl;
    }
    function jS(d) {
      var h = Yr;
      Yr |= rm;
      var C = oo.transition, M = hc();
      try {
        oo.transition = null, gi(ii), d();
      } finally {
        gi(M), oo.transition = C, Yr = h, Yr === jl && (F0(), va());
      }
    }
    function qb(d, h) {
      Pa(Hb, Km, d), Km = Wn(Km, h);
    }
    function lv(d) {
      Km = Hb.current, yo(Hb, d);
    }
    function hf(d, h) {
      d.finishedWork = null, d.finishedLanes = bt;
      var C = d.timeoutHandle;
      if (C !== Rf && (d.timeoutHandle = Rf, Oc(C)), Ri !== null)
        for (var M = Ri.return; M !== null; ) {
          var A = M.alternate;
          lN(A, M), M = M.return;
        }
      $u = d;
      var W = $0(d.current, null);
      return Ri = W, Ko = Km = h, Xo = am, Hx = null, hS = bt, _g = bt, av = bt, I0 = null, Ed = null, zi(), Jt.discardPendingWarnings(), W;
    }
    function Gx(d, h) {
      do {
        var C = Ri;
        try {
          if (Uy(), M5(), Zs(), Bb.current = null, C === null || C.return === null) {
            Xo = jg, Hx = h, Ri = null;
            return;
          }
          if (U && C.mode & Ca && Nb(C, !0), R)
            if (br(), h !== null && typeof h == "object" && typeof h.then == "function") {
              var M = h;
              Ip(C, M, Ko);
            } else
              bs(C, h, Ko);
          Xw(d, C.return, C, h, Ko), kS(C);
        } catch (A) {
          h = A, Ri === C && C !== null ? (C = C.return, Ri = C) : C = Ri;
          continue;
        }
        return;
      } while (!0);
    }
    function Kb() {
      var d = Wl.current;
      return Wl.current = fg, d === null ? fg : d;
    }
    function Xb(d) {
      Wl.current = d;
    }
    function NN() {
      pS = ns();
    }
    function cv(d) {
      hS = Wn(d, hS);
    }
    function Wx() {
      Xo === am && (Xo = L0);
    }
    function Qb() {
      (Xo === am || Xo === L0 || Xo === Qh) && (Xo = Eg), $u !== null && (Uo(hS) || Uo(_g)) && Wu($u, Ko);
    }
    function jN(d) {
      Xo !== Eg && (Xo = Qh), I0 === null ? I0 = [d] : I0.push(d);
    }
    function RC() {
      return Xo === am;
    }
    function ES(d, h) {
      var C = Yr;
      Yr |= au;
      var M = Kb();
      if ($u !== d || Ko !== h) {
        if (ya) {
          var A = d.memoizedUpdaters;
          A.size > 0 && (e4(d, Ko), A.clear()), tn(d, h);
        }
        Tg = Aa(), hf(d, h);
      }
      Sn(h);
      do
        try {
          EN();
          break;
        } catch (W) {
          Gx(d, W);
        }
      while (!0);
      if (Uy(), Yr = C, Xb(M), Ri !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return ar(), $u = null, Ko = bt, Xo;
    }
    function EN() {
      for (; Ri !== null; )
        Qm(Ri);
    }
    function kN(d, h) {
      var C = Yr;
      Yr |= au;
      var M = Kb();
      if ($u !== d || Ko !== h) {
        if (ya) {
          var A = d.memoizedUpdaters;
          A.size > 0 && (e4(d, Ko), A.clear()), tn(d, h);
        }
        Tg = Aa(), F0(), hf(d, h);
      }
      Sn(h);
      do
        try {
          Zb();
          break;
        } catch (W) {
          Gx(d, W);
        }
      while (!0);
      return Uy(), Xb(M), Yr = C, Ri !== null ? (Mn(), am) : (ar(), $u = null, Ko = bt, Xo);
    }
    function Zb() {
      for (; Ri !== null && !Ap(); )
        Qm(Ri);
    }
    function Qm(d) {
      var h = d.alternate;
      Be(d);
      var C;
      (d.mode & Ca) !== Qn ? ($y(d), C = Zo(h, d, Km), Nb(d, !0)) : C = Zo(h, d, Km), Zs(), d.memoizedProps = d.pendingProps, C === null ? kS(d) : Ri = C, Bb.current = null;
    }
    function kS(d) {
      var h = d;
      do {
        var C = h.alternate, M = h.return;
        if ((h.flags & Do) === Nt) {
          Be(h);
          var A = void 0;
          if ((h.mode & Ca) === Qn ? A = oN(C, h, Km) : ($y(h), A = oN(C, h, Km), Nb(h, !1)), Zs(), A !== null) {
            Ri = A;
            return;
          }
        } else {
          var W = G_(C, h);
          if (W !== null) {
            W.flags &= Ro, Ri = W;
            return;
          }
          if ((h.mode & Ca) !== Qn) {
            Nb(h, !1);
            for (var ae = h.actualDuration, de = h.child; de !== null; )
              ae += de.actualDuration, de = de.sibling;
            h.actualDuration = ae;
          }
          if (M !== null)
            M.flags |= Do, M.subtreeFlags = Nt, M.deletions = null;
          else {
            Xo = kg, Ri = null;
            return;
          }
        }
        var ge = h.sibling;
        if (ge !== null) {
          Ri = ge;
          return;
        }
        h = M, Ri = h;
      } while (h !== null);
      Xo === am && (Xo = Bx);
    }
    function Zm(d, h, C) {
      var M = hc(), A = oo.transition;
      try {
        oo.transition = null, gi(ii), DC(d, h, C, M);
      } finally {
        oo.transition = A, gi(M);
      }
      return null;
    }
    function DC(d, h, C, M) {
      do
        s1();
      while (Zh !== null);
      if (OC(), (Yr & (au | Cc)) !== jl)
        throw new Error("Should not already be working.");
      var A = d.finishedWork, W = d.finishedLanes;
      if (J1(W), A === null)
        return Rh(), null;
      if (W === bt && y("root.finishedLanes should not be empty during a commit. This is a bug in React."), d.finishedWork = null, d.finishedLanes = bt, A === d.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      d.callbackNode = null, d.callbackPriority = Zi;
      var ae = Wn(A.lanes, A.childLanes);
      Py(d, ae), d === $u && ($u = null, Ri = null, Ko = bt), ((A.subtreeFlags & pa) !== Nt || (A.flags & pa) !== Nt) && (a1 || (a1 = !0, vS = C, kd(Zt, function() {
        return s1(), null;
      })));
      var de = (A.subtreeFlags & (Xn | wr | Ts | pa)) !== Nt, ge = (A.flags & (Xn | wr | Ts | pa)) !== Nt;
      if (de || ge) {
        var Ce = oo.transition;
        oo.transition = null;
        var Me = hc();
        gi(ii);
        var $e = Yr;
        Yr |= Cc, Bb.current = null, gC(d, A), Cb(), mN(d, A, W), Yd(d.containerInfo), d.current = A, Om(W), Ix(A, d, W), vl(), Mh(), Yr = $e, gi(Me), oo.transition = Ce;
      } else
        d.current = A, Cb();
      var at = a1;
      if (a1 ? (a1 = !1, Zh = d, Vx = W) : (Xm = 0, $x = null), ae = d.pendingLanes, ae === bt && (z0 = null), at || uv(d.current, !1), sf(A.stateNode, M), ya && d.memoizedUpdaters.clear(), yN(), Gu(d, ns()), h !== null)
        for (var yt = d.onRecoverableError, Ct = 0; Ct < h.length; Ct++) {
          var Et = h[Ct], Pn = Et.stack, yr = Et.digest;
          yt(Et.value, {
            componentStack: Pn,
            digest: yr
          });
        }
      if (iv) {
        iv = !1;
        var Zn = U0;
        throw U0 = null, Zn;
      }
      return Es(Vx, rr) && d.tag !== Ds && s1(), ae = d.pendingLanes, Es(ae, rr) ? (U6(), d === kC ? ov++ : (ov = 0, kC = d)) : ov = 0, va(), Rh(), null;
    }
    function s1() {
      if (Zh !== null) {
        var d = qs(Vx), h = Q1(Op, d), C = oo.transition, M = hc();
        try {
          return oo.transition = null, gi(h), Yx();
        } finally {
          gi(M), oo.transition = C;
        }
      }
      return !1;
    }
    function H0(d) {
      yS.push(d), a1 || (a1 = !0, kd(Zt, function() {
        return s1(), null;
      }));
    }
    function Yx() {
      if (Zh === null)
        return !1;
      var d = vS;
      vS = null;
      var h = Zh, C = Vx;
      if (Zh = null, Vx = bt, (Yr & (au | Cc)) !== jl)
        throw new Error("Cannot flush passive effects while already rendering.");
      _C = !0, Mg = !1, Fp(C);
      var M = Yr;
      Yr |= Cc, Q_(h.current), Cg(h, h.current, C, d);
      {
        var A = yS;
        yS = [];
        for (var W = 0; W < A.length; W++) {
          var ae = A[W];
          yC(h, ae);
        }
      }
      Ph(), uv(h.current, !0), Yr = M, va(), Mg ? h === $x ? Xm++ : (Xm = 0, $x = h) : Xm = 0, _C = !1, Mg = !1, Lp(h);
      {
        var de = h.current.stateNode;
        de.effectDuration = 0, de.passiveEffectDuration = 0;
      }
      return !0;
    }
    function _N(d) {
      return z0 !== null && z0.has(d);
    }
    function _S(d) {
      z0 === null ? z0 = /* @__PURE__ */ new Set([d]) : z0.add(d);
    }
    function pf(d) {
      iv || (iv = !0, U0 = d);
    }
    var Yl = pf;
    function Jh(d, h, C) {
      var M = Zp(C, h), A = V6(d, M, rr), W = $o(d, A, rr), ae = Is();
      W !== null && (Ps(W, rr, ae), Gu(W, ae));
    }
    function Fr(d, h, C) {
      if (P0(C), o1(!1), d.tag === Q) {
        Jh(d, d, C);
        return;
      }
      var M = null;
      for (M = h; M !== null; ) {
        if (M.tag === Q) {
          Jh(M, d, C);
          return;
        } else if (M.tag === K) {
          var A = M.type, W = M.stateNode;
          if (typeof A.getDerivedStateFromError == "function" || typeof W.componentDidCatch == "function" && !_N(W)) {
            var ae = Zp(C, d), de = Kw(M, ae, rr), ge = $o(M, de, rr), Ce = Is();
            ge !== null && (Ps(ge, rr, Ce), Gu(ge, Ce));
            return;
          }
        }
        M = M.return;
      }
      y(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, C);
    }
    function su(d, h, C) {
      var M = d.pingCache;
      M !== null && M.delete(h);
      var A = Is();
      fc(d, C), cn(d), $u === d && pi(Ko, C) && (Xo === Eg || Xo === L0 && lc(Ko) && ns() - pS < sv ? hf(d, bt) : av = Wn(av, C)), Gu(d, A);
    }
    function TS(d, h) {
      h === Zi && (h = bS(d));
      var C = Is(), M = wo(d, h);
      M !== null && (Ps(M, h, C), Gu(M, C));
    }
    function PC(d) {
      var h = d.memoizedState, C = Zi;
      h !== null && (C = h.retryLane), TS(d, C);
    }
    function uT(d, h) {
      var C = Zi, M;
      switch (d.tag) {
        case ue:
          M = d.stateNode;
          var A = d.memoizedState;
          A !== null && (C = A.retryLane);
          break;
        case qe:
          M = d.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      M !== null && M.delete(h), TS(d, C);
    }
    function Cn(d) {
      return d < 120 ? 120 : d < 480 ? 480 : d < 1080 ? 1080 : d < 1920 ? 1920 : d < 3e3 ? 3e3 : d < 4320 ? 4320 : xN(d / 1960) * 1960;
    }
    function Jb() {
      if (ov > EC)
        throw ov = 0, kC = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Xm > El && (Xm = 0, $x = null, y("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function OC() {
      Jt.flushLegacyContextWarning(), Jt.flushPendingUnsafeLifecycleWarnings();
    }
    function uv(d, h) {
      Be(d), i1(d, vr, nv), h && i1(d, Lr, ru), i1(d, vr, J_), h && i1(d, Lr, eT), Zs();
    }
    function i1(d, h, C) {
      for (var M = d, A = null; M !== null; ) {
        var W = M.subtreeFlags & h;
        M !== A && M.child !== null && W !== Nt ? M = M.child : ((M.flags & h) !== Nt && C(M), M.sibling !== null ? M = M.sibling : M = A = M.return);
      }
    }
    var as = null;
    function kl(d) {
      {
        if ((Yr & au) !== jl || !(d.mode & na))
          return;
        var h = d.tag;
        if (h !== q && h !== Q && h !== K && h !== H && h !== Se && h !== he && h !== ve)
          return;
        var C = lt(d) || "ReactComponent";
        if (as !== null) {
          if (as.has(C))
            return;
          as.add(C);
        } else
          as = /* @__PURE__ */ new Set([C]);
        var M = ct;
        try {
          Be(d), y("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          M ? Be(d) : Zs();
        }
      }
    }
    var Zo;
    {
      var MS = null;
      Zo = function(d, h, C) {
        var M = o4(MS, h);
        try {
          return aN(d, h, C);
        } catch (W) {
          if (zp() || W !== null && typeof W == "object" && typeof W.then == "function")
            throw W;
          if (Uy(), M5(), lN(d, h), o4(h, M), h.mode & Ca && $y(h), Dx(null, aN, null, d, h, C), hC()) {
            var A = dN();
            typeof A == "object" && A !== null && A._suppressLogging && typeof W == "object" && W !== null && !W._suppressLogging && (W._suppressLogging = !0);
          }
          throw W;
        }
      };
    }
    var qx = !1, dv;
    dv = /* @__PURE__ */ new Set();
    function dT(d) {
      if (xa && !jx())
        switch (d.tag) {
          case H:
          case Se:
          case ve: {
            var h = Ri && lt(Ri) || "Unknown", C = h;
            if (!dv.has(C)) {
              dv.add(C);
              var M = lt(d) || "Unknown";
              y("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", M, h, h);
            }
            break;
          }
          case K: {
            qx || (y("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), qx = !0);
            break;
          }
        }
    }
    function e4(d, h) {
      if (ya) {
        var C = d.memoizedUpdaters;
        C.forEach(function(M) {
          mc(d, M, h);
        });
      }
    }
    var gt = {};
    function kd(d, h) {
      {
        var C = Xh.current;
        return C !== null ? (C.push(h), gt) : Ni(d, h);
      }
    }
    function Dg(d) {
      if (d !== gt)
        return md(d);
    }
    function RS() {
      return Xh.current !== null;
    }
    function fs(d) {
      {
        if (d.mode & na) {
          if (!rv())
            return;
        } else if (!vN() || Yr !== jl || d.tag !== H && d.tag !== Se && d.tag !== ve)
          return;
        if (Xh.current === null) {
          var h = ct;
          try {
            Be(d), y(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, lt(d));
          } finally {
            h ? Be(d) : Zs();
          }
        }
      }
    }
    function cn(d) {
      d.tag !== Ds && rv() && Xh.current === null && y(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function o1(d) {
      bN = d;
    }
    var Jm = null, Jo = null, AC = function(d) {
      Jm = d;
    };
    function ep(d) {
      {
        if (Jm === null)
          return d;
        var h = Jm(d);
        return h === void 0 ? d : h.current;
      }
    }
    function V0(d) {
      return ep(d);
    }
    function DS(d) {
      {
        if (Jm === null)
          return d;
        var h = Jm(d);
        if (h === void 0) {
          if (d != null && typeof d.render == "function") {
            var C = ep(d.render);
            if (d.render !== C) {
              var M = {
                $$typeof: ye,
                render: C
              };
              return d.displayName !== void 0 && (M.displayName = d.displayName), M;
            }
          }
          return d;
        }
        return h.current;
      }
    }
    function LC(d, h) {
      {
        if (Jm === null)
          return !1;
        var C = d.elementType, M = h.type, A = !1, W = typeof M == "object" && M !== null ? M.$$typeof : null;
        switch (d.tag) {
          case K: {
            typeof M == "function" && (A = !0);
            break;
          }
          case H: {
            (typeof M == "function" || W === ot) && (A = !0);
            break;
          }
          case Se: {
            (W === ye || W === ot) && (A = !0);
            break;
          }
          case he:
          case ve: {
            (W === tt || W === ot) && (A = !0);
            break;
          }
          default:
            return !1;
        }
        if (A) {
          var ae = Jm(C);
          if (ae !== void 0 && ae === Jm(M))
            return !0;
        }
        return !1;
      }
    }
    function tp(d) {
      {
        if (Jm === null || typeof WeakSet != "function")
          return;
        Jo === null && (Jo = /* @__PURE__ */ new WeakSet()), Jo.add(d);
      }
    }
    var eh = function(d, h) {
      {
        if (Jm === null)
          return;
        var C = h.staleFamilies, M = h.updatedFamilies;
        s1(), NS(function() {
          t4(d.current, M, C);
        });
      }
    }, TN = function(d, h) {
      {
        if (d.context !== Ii)
          return;
        s1(), NS(function() {
          VC(h, d, null, null);
        });
      }
    };
    function t4(d, h, C) {
      {
        var M = d.alternate, A = d.child, W = d.sibling, ae = d.tag, de = d.type, ge = null;
        switch (ae) {
          case H:
          case ve:
          case K:
            ge = de;
            break;
          case Se:
            ge = de.render;
            break;
        }
        if (Jm === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var Ce = !1, Me = !1;
        if (ge !== null) {
          var $e = Jm(ge);
          $e !== void 0 && (C.has($e) ? Me = !0 : h.has($e) && (ae === K ? Me = !0 : Ce = !0));
        }
        if (Jo !== null && (Jo.has(d) || M !== null && Jo.has(M)) && (Me = !0), Me && (d._debugNeedsRemount = !0), Me || Ce) {
          var at = wo(d, rr);
          at !== null && Qo(at, d, rr, $a);
        }
        A !== null && !Me && t4(A, h, C), W !== null && t4(W, h, C);
      }
    }
    var IC = function(d, h) {
      {
        var C = /* @__PURE__ */ new Set(), M = new Set(h.map(function(A) {
          return A.current;
        }));
        return n4(d.current, M, C), C;
      }
    };
    function n4(d, h, C) {
      {
        var M = d.child, A = d.sibling, W = d.tag, ae = d.type, de = null;
        switch (W) {
          case H:
          case ve:
          case K:
            de = ae;
            break;
          case Se:
            de = ae.render;
            break;
        }
        var ge = !1;
        de !== null && h.has(de) && (ge = !0), ge ? FC(d, C) : M !== null && n4(M, h, C), A !== null && n4(A, h, C);
      }
    }
    function FC(d, h) {
      {
        var C = XA(d, h);
        if (C)
          return;
        for (var M = d; ; ) {
          switch (M.tag) {
            case X:
              h.add(M.stateNode);
              return;
            case Z:
              h.add(M.stateNode.containerInfo);
              return;
            case Q:
              h.add(M.stateNode.containerInfo);
              return;
          }
          if (M.return === null)
            throw new Error("Expected to reach root first.");
          M = M.return;
        }
      }
    }
    function XA(d, h) {
      for (var C = d, M = !1; ; ) {
        if (C.tag === X)
          M = !0, h.add(C.stateNode);
        else if (C.child !== null) {
          C.child.return = C, C = C.child;
          continue;
        }
        if (C === d)
          return M;
        for (; C.sibling === null; ) {
          if (C.return === null || C.return === d)
            return M;
          C = C.return;
        }
        C.sibling.return = C.return, C = C.sibling;
      }
      return !1;
    }
    var MN;
    {
      MN = !1;
      try {
        var PS = Object.preventExtensions({});
      } catch {
        MN = !0;
      }
    }
    function OS(d, h, C, M) {
      this.tag = d, this.key = C, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = h, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = M, this.flags = Nt, this.subtreeFlags = Nt, this.deletions = null, this.lanes = bt, this.childLanes = bt, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !MN && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var gf = function(d, h, C, M) {
      return new OS(d, h, C, M);
    };
    function AS(d) {
      var h = d.prototype;
      return !!(h && h.isReactComponent);
    }
    function RN(d) {
      return typeof d == "function" && !AS(d) && d.defaultProps === void 0;
    }
    function DN(d) {
      if (typeof d == "function")
        return AS(d) ? K : H;
      if (d != null) {
        var h = d.$$typeof;
        if (h === ye)
          return Se;
        if (h === tt)
          return he;
      }
      return q;
    }
    function $0(d, h) {
      var C = d.alternate;
      C === null ? (C = gf(d.tag, h, d.key, d.mode), C.elementType = d.elementType, C.type = d.type, C.stateNode = d.stateNode, C._debugSource = d._debugSource, C._debugOwner = d._debugOwner, C._debugHookTypes = d._debugHookTypes, C.alternate = d, d.alternate = C) : (C.pendingProps = h, C.type = d.type, C.flags = Nt, C.subtreeFlags = Nt, C.deletions = null, C.actualDuration = 0, C.actualStartTime = -1), C.flags = d.flags & ga, C.childLanes = d.childLanes, C.lanes = d.lanes, C.child = d.child, C.memoizedProps = d.memoizedProps, C.memoizedState = d.memoizedState, C.updateQueue = d.updateQueue;
      var M = d.dependencies;
      switch (C.dependencies = M === null ? null : {
        lanes: M.lanes,
        firstContext: M.firstContext
      }, C.sibling = d.sibling, C.index = d.index, C.ref = d.ref, C.selfBaseDuration = d.selfBaseDuration, C.treeBaseDuration = d.treeBaseDuration, C._debugNeedsRemount = d._debugNeedsRemount, C.tag) {
        case q:
        case H:
        case ve:
          C.type = ep(d.type);
          break;
        case K:
          C.type = V0(d.type);
          break;
        case Se:
          C.type = DS(d.type);
          break;
      }
      return C;
    }
    function LS(d, h) {
      d.flags &= ga | wn;
      var C = d.alternate;
      if (C === null)
        d.childLanes = bt, d.lanes = h, d.child = null, d.subtreeFlags = Nt, d.memoizedProps = null, d.memoizedState = null, d.updateQueue = null, d.dependencies = null, d.stateNode = null, d.selfBaseDuration = 0, d.treeBaseDuration = 0;
      else {
        d.childLanes = C.childLanes, d.lanes = C.lanes, d.child = C.child, d.subtreeFlags = Nt, d.deletions = null, d.memoizedProps = C.memoizedProps, d.memoizedState = C.memoizedState, d.updateQueue = C.updateQueue, d.type = C.type;
        var M = C.dependencies;
        d.dependencies = M === null ? null : {
          lanes: M.lanes,
          firstContext: M.firstContext
        }, d.selfBaseDuration = C.selfBaseDuration, d.treeBaseDuration = C.treeBaseDuration;
      }
      return d;
    }
    function UC(d, h, C) {
      var M;
      return d === Y1 ? (M = na, h === !0 && (M |= $s, M |= ku)) : M = Qn, ya && (M |= Ca), gf(Q, null, null, M);
    }
    function r4(d, h, C, M, A, W) {
      var ae = q, de = d;
      if (typeof d == "function")
        AS(d) ? (ae = K, de = V0(de)) : de = ep(de);
      else if (typeof d == "string")
        ae = X;
      else
        e: switch (d) {
          case He:
            return l1(C.children, A, W, h);
          case Pt:
            ae = fe, A |= $s, (A & na) !== Qn && (A |= ku);
            break;
          case Lt:
            return IS(C, A, W, h);
          case ke:
            return a4(C, A, W, h);
          case Pe:
            return FS(C, A, W, h);
          case bn:
            return s4(C, A, W, h);
          case mr:
          case ut:
          case ur:
          case _r:
          case Vt:
          default: {
            if (typeof d == "object" && d !== null)
              switch (d.$$typeof) {
                case er:
                  ae = pe;
                  break e;
                case It:
                  ae = ce;
                  break e;
                case ye:
                  ae = Se, de = DS(de);
                  break e;
                case tt:
                  ae = he;
                  break e;
                case ot:
                  ae = Te, de = null;
                  break e;
              }
            var ge = "";
            {
              (d === void 0 || typeof d == "object" && d !== null && Object.keys(d).length === 0) && (ge += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var Ce = M ? lt(M) : null;
              Ce && (ge += `

Check the render method of \`` + Ce + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (d == null ? d : typeof d) + "." + ge));
          }
        }
      var Me = gf(ae, C, h, A);
      return Me.elementType = d, Me.type = de, Me.lanes = W, Me._debugOwner = M, Me;
    }
    function fv(d, h, C) {
      var M = null;
      M = d._owner;
      var A = d.type, W = d.key, ae = d.props, de = r4(A, W, ae, M, h, C);
      return de._debugSource = d._source, de._debugOwner = d._owner, de;
    }
    function l1(d, h, C, M) {
      var A = gf(te, d, M, h);
      return A.lanes = C, A;
    }
    function IS(d, h, C, M) {
      typeof d.id != "string" && y('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof d.id);
      var A = gf(oe, d, M, h | Ca);
      return A.elementType = Lt, A.lanes = C, A.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, A;
    }
    function a4(d, h, C, M) {
      var A = gf(ue, d, M, h);
      return A.elementType = ke, A.lanes = C, A;
    }
    function FS(d, h, C, M) {
      var A = gf(qe, d, M, h);
      return A.elementType = Pe, A.lanes = C, A;
    }
    function s4(d, h, C, M) {
      var A = gf(Ne, d, M, h);
      A.elementType = bn, A.lanes = C;
      var W = {
        isHidden: !1
      };
      return A.stateNode = W, A;
    }
    function mv(d, h, C) {
      var M = gf(se, d, null, h);
      return M.lanes = C, M;
    }
    function zC() {
      var d = gf(X, null, null, Qn);
      return d.elementType = "DELETED", d;
    }
    function US(d) {
      var h = gf(Ue, null, null, Qn);
      return h.stateNode = d, h;
    }
    function i4(d, h, C) {
      var M = d.children !== null ? d.children : [], A = gf(Z, M, d.key, h);
      return A.lanes = C, A.stateNode = {
        containerInfo: d.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: d.implementation
      }, A;
    }
    function o4(d, h) {
      return d === null && (d = gf(q, null, null, Qn)), d.tag = h.tag, d.key = h.key, d.elementType = h.elementType, d.type = h.type, d.stateNode = h.stateNode, d.return = h.return, d.child = h.child, d.sibling = h.sibling, d.index = h.index, d.ref = h.ref, d.pendingProps = h.pendingProps, d.memoizedProps = h.memoizedProps, d.updateQueue = h.updateQueue, d.memoizedState = h.memoizedState, d.dependencies = h.dependencies, d.mode = h.mode, d.flags = h.flags, d.subtreeFlags = h.subtreeFlags, d.deletions = h.deletions, d.lanes = h.lanes, d.childLanes = h.childLanes, d.alternate = h.alternate, d.actualDuration = h.actualDuration, d.actualStartTime = h.actualStartTime, d.selfBaseDuration = h.selfBaseDuration, d.treeBaseDuration = h.treeBaseDuration, d._debugSource = h._debugSource, d._debugOwner = h._debugOwner, d._debugNeedsRemount = h._debugNeedsRemount, d._debugHookTypes = h._debugHookTypes, d;
    }
    function PN(d, h, C, M, A) {
      this.tag = h, this.containerInfo = d, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Rf, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Zi, this.eventTimes = Vl(bt), this.expirationTimes = Vl($a), this.pendingLanes = bt, this.suspendedLanes = bt, this.pingedLanes = bt, this.expiredLanes = bt, this.mutableReadLanes = bt, this.finishedLanes = bt, this.entangledLanes = bt, this.entanglements = Vl(bt), this.identifierPrefix = M, this.onRecoverableError = A, Oo && (this.mutableSourceEagerHydrationData = null), this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var W = this.pendingUpdatersLaneMap = [], ae = 0; ae < ef; ae++)
          W.push(/* @__PURE__ */ new Set());
      }
      switch (h) {
        case Y1:
          this._debugRootType = C ? "hydrateRoot()" : "createRoot()";
          break;
        case Ds:
          this._debugRootType = C ? "hydrate()" : "render()";
          break;
      }
    }
    function zS(d, h, C, M, A, W, ae, de, ge, Ce) {
      var Me = new PN(d, h, C, de, ge), $e = UC(h, W);
      Me.current = $e, $e.stateNode = Me;
      {
        var at = {
          element: M,
          isDehydrated: C,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        $e.memoizedState = at;
      }
      return Zf($e), Me;
    }
    var BS = "18.3.1";
    function fT(d, h, C) {
      var M = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return Mw(M), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: At,
        key: M == null ? null : "" + M,
        children: d,
        containerInfo: h,
        implementation: C
      };
    }
    var Kx, l4;
    Kx = !1, l4 = {};
    function c4(d) {
      if (!d)
        return Ii;
      var h = k(d), C = W1(h);
      if (h.tag === K) {
        var M = h.type;
        if (xs(M))
          return oc(h, M, C);
      }
      return C;
    }
    function BC(d) {
      var h = k(d);
      if (h === void 0) {
        if (typeof d.render == "function")
          throw new Error("Unable to find node on an unmounted component.");
        var C = Object.keys(d).join(",");
        throw new Error("Argument appears to not be a ReactComponent. Keys: " + C);
      }
      var M = Hs(h);
      return M === null ? null : M.stateNode;
    }
    function HS(d, h) {
      {
        var C = k(d);
        if (C === void 0) {
          if (typeof d.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var M = Object.keys(d).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + M);
        }
        var A = Hs(C);
        if (A === null)
          return null;
        if (A.mode & $s) {
          var W = lt(C) || "Component";
          if (!l4[W]) {
            l4[W] = !0;
            var ae = ct;
            try {
              Be(A), C.mode & $s ? y("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", h, h, W) : y("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", h, h, W);
            } finally {
              ae ? Be(ae) : Zs();
            }
          }
        }
        return A.stateNode;
      }
    }
    function HC(d, h, C, M, A, W, ae, de) {
      var ge = !1, Ce = null;
      return zS(d, h, ge, Ce, C, M, A, W, ae);
    }
    function ON(d, h, C, M, A, W, ae, de, ge, Ce) {
      var Me = !0, $e = zS(C, M, Me, d, A, W, ae, de, ge);
      $e.context = c4(null);
      var at = $e.current, yt = Is(), Ct = B0(at), Et = Jf(yt, Ct);
      return Et.callback = h ?? null, $o(at, Et, Ct), SN($e, Ct, yt), $e;
    }
    function VC(d, h, C, M) {
      qc(h, d);
      var A = h.current, W = Is(), ae = B0(A);
      $r(ae);
      var de = c4(C);
      h.context === null ? h.context = de : h.pendingContext = de, xa && ct !== null && !Kx && (Kx = !0, y(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, lt(ct) || "Unknown"));
      var ge = Jf(W, ae);
      ge.payload = {
        element: d
      }, M = M === void 0 ? null : M, M !== null && (typeof M != "function" && y("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", M), ge.callback = M);
      var Ce = $o(A, ge, ae);
      return Ce !== null && (Qo(Ce, A, ae, W), Fh(Ce, A, ae)), ae;
    }
    function AN(d) {
      var h = d.current;
      if (!h.child)
        return null;
      switch (h.child.tag) {
        case X:
          return Mr(h.child.stateNode);
        default:
          return h.child.stateNode;
      }
    }
    function mT(d) {
      switch (d.tag) {
        case Q: {
          var h = d.stateNode;
          if (oi(h)) {
            var C = Ru(h);
            wS(h, C);
          }
          break;
        }
        case ue: {
          NS(function() {
            var A = wo(d, rr);
            if (A !== null) {
              var W = Is();
              Qo(A, d, rr, W);
            }
          });
          var M = rr;
          u4(d, M);
          break;
        }
      }
    }
    function VS(d, h) {
      var C = d.memoizedState;
      C !== null && C.dehydrated !== null && (C.retryLane = to(C.retryLane, h));
    }
    function u4(d, h) {
      VS(d, h);
      var C = d.alternate;
      C && VS(C, h);
    }
    function LN(d) {
      if (d.tag === ue) {
        var h = rr, C = wo(d, h);
        if (C !== null) {
          var M = Is();
          Qo(C, d, h, M);
        }
        u4(d, h);
      }
    }
    function IN(d) {
      if (d.tag === ue) {
        var h = cd, C = wo(d, h);
        if (C !== null) {
          var M = Is();
          Qo(C, d, h, M);
        }
        u4(d, h);
      }
    }
    function hT(d) {
      if (d.tag === ue) {
        var h = B0(d), C = wo(d, h);
        if (C !== null) {
          var M = Is();
          Qo(C, d, h, M);
        }
        u4(d, h);
      }
    }
    function $C(d) {
      var h = Fl(d);
      return h === null ? null : h.stateNode;
    }
    var d4 = function(d) {
      return null;
    };
    function FN(d) {
      return d4(d);
    }
    var UN = function(d) {
      return !1;
    };
    function GC(d) {
      return UN(d);
    }
    var WC = null, YC = null, qC = null, f4 = null, KC = null, XC = null, QC = null, ZC = null, np = null;
    {
      var th = function(d, h, C) {
        var M = h[C], A = xr(d) ? d.slice() : w({}, d);
        return C + 1 === h.length ? (xr(A) ? A.splice(M, 1) : delete A[M], A) : (A[M] = th(d[M], h, C + 1), A);
      }, m4 = function(d, h) {
        return th(d, h, 0);
      }, $S = function(d, h, C, M) {
        var A = h[M], W = xr(d) ? d.slice() : w({}, d);
        if (M + 1 === h.length) {
          var ae = C[M];
          W[ae] = W[A], xr(W) ? W.splice(A, 1) : delete W[A];
        } else
          W[A] = $S(
            // $FlowFixMe number or string is fine here
            d[A],
            h,
            C,
            M + 1
          );
        return W;
      }, Er = function(d, h, C) {
        if (h.length !== C.length) {
          m("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var M = 0; M < C.length - 1; M++)
            if (h[M] !== C[M]) {
              m("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return $S(d, h, C, 0);
      }, Pg = function(d, h, C, M) {
        if (C >= h.length)
          return M;
        var A = h[C], W = xr(d) ? d.slice() : w({}, d);
        return W[A] = Pg(d[A], h, C + 1, M), W;
      }, JC = function(d, h, C) {
        return Pg(d, h, 0, C);
      }, Xx = function(d, h) {
        for (var C = d.memoizedState; C !== null && h > 0; )
          C = C.next, h--;
        return C;
      };
      WC = function(d, h, C, M) {
        var A = Xx(d, h);
        if (A !== null) {
          var W = JC(A.memoizedState, C, M);
          A.memoizedState = W, A.baseState = W, d.memoizedProps = w({}, d.memoizedProps);
          var ae = wo(d, rr);
          ae !== null && Qo(ae, d, rr, $a);
        }
      }, YC = function(d, h, C) {
        var M = Xx(d, h);
        if (M !== null) {
          var A = m4(M.memoizedState, C);
          M.memoizedState = A, M.baseState = A, d.memoizedProps = w({}, d.memoizedProps);
          var W = wo(d, rr);
          W !== null && Qo(W, d, rr, $a);
        }
      }, qC = function(d, h, C, M) {
        var A = Xx(d, h);
        if (A !== null) {
          var W = Er(A.memoizedState, C, M);
          A.memoizedState = W, A.baseState = W, d.memoizedProps = w({}, d.memoizedProps);
          var ae = wo(d, rr);
          ae !== null && Qo(ae, d, rr, $a);
        }
      }, f4 = function(d, h, C) {
        d.pendingProps = JC(d.memoizedProps, h, C), d.alternate && (d.alternate.pendingProps = d.pendingProps);
        var M = wo(d, rr);
        M !== null && Qo(M, d, rr, $a);
      }, KC = function(d, h) {
        d.pendingProps = m4(d.memoizedProps, h), d.alternate && (d.alternate.pendingProps = d.pendingProps);
        var C = wo(d, rr);
        C !== null && Qo(C, d, rr, $a);
      }, XC = function(d, h, C) {
        d.pendingProps = Er(d.memoizedProps, h, C), d.alternate && (d.alternate.pendingProps = d.pendingProps);
        var M = wo(d, rr);
        M !== null && Qo(M, d, rr, $a);
      }, QC = function(d) {
        var h = wo(d, rr);
        h !== null && Qo(h, d, rr, $a);
      }, ZC = function(d) {
        d4 = d;
      }, np = function(d) {
        UN = d;
      };
    }
    function h4(d) {
      var h = Hs(d);
      return h === null ? null : h.stateNode;
    }
    function GS(d) {
      return null;
    }
    function e7() {
      return ct;
    }
    function WS(d) {
      var h = d.findFiberByHostInstance, C = o.ReactCurrentDispatcher;
      return Z1({
        bundleType: d.bundleType,
        version: d.version,
        rendererPackageName: d.rendererPackageName,
        rendererConfig: d.rendererConfig,
        overrideHookState: WC,
        overrideHookStateDeletePath: YC,
        overrideHookStateRenamePath: qC,
        overrideProps: f4,
        overridePropsDeletePath: KC,
        overridePropsRenamePath: XC,
        setErrorHandler: ZC,
        setSuspenseHandler: np,
        scheduleUpdate: QC,
        currentDispatcherRef: C,
        findHostInstanceByFiber: h4,
        findFiberByHostInstance: h || GS,
        // React Refresh
        findHostInstancesForRefresh: IC,
        scheduleRefresh: eh,
        scheduleRoot: TN,
        setRefreshHandler: AC,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: e7,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: BS
      });
    }
    return n.attemptContinuousHydration = IN, n.attemptDiscreteHydration = LN, n.attemptHydrationAtCurrentPriority = hT, n.attemptSynchronousHydration = mT, n.batchedUpdates = cT, n.createComponentSelector = tT, n.createContainer = HC, n.createHasPseudoClassSelector = nT, n.createHydrationContainer = ON, n.createPortal = fT, n.createRoleSelector = rT, n.createTestNameSelector = gN, n.createTextSelector = pN, n.deferredUpdates = MC, n.discreteUpdates = CS, n.findAllNodes = zx, n.findBoundingRects = sT, n.findHostInstance = BC, n.findHostInstanceWithNoPortals = $C, n.findHostInstanceWithWarning = HS, n.flushControlled = jS, n.flushPassiveEffects = s1, n.flushSync = NS, n.focusWithin = iT, n.getCurrentUpdatePriority = hc, n.getFindAllNodesFailureDescription = aT, n.getPublicRootInstance = AN, n.injectIntoDevTools = WS, n.isAlreadyRendering = CN, n.observeVisibleRects = mS, n.registerMutableSourceForHydration = _5, n.runWithPriority = Oy, n.shouldError = FN, n.shouldSuspend = GC, n.updateContainer = VC, n;
  })), kR.exports;
}
process.env.NODE_ENV === "production" ? iP.exports = w5e() : iP.exports = C5e();
var N5e = iP.exports;
const j5e = /* @__PURE__ */ fE(N5e);
var oP = { exports: {} }, c2 = {};
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var RB;
function E5e() {
  return RB || (RB = 1, c2.ConcurrentRoot = 1, c2.ContinuousEventPriority = 4, c2.DefaultEventPriority = 16, c2.DiscreteEventPriority = 1, c2.IdleEventPriority = 536870912, c2.LegacyRoot = 0), c2;
}
var u2 = {};
/**
 * @license React
 * react-reconciler-constants.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var DB;
function k5e() {
  return DB || (DB = 1, process.env.NODE_ENV !== "production" && function() {
    var e = (
      /*                        */
      1
    ), t = (
      /*             */
      4
    ), n = (
      /*                     */
      16
    ), r = (
      /*                        */
      536870912
    ), s = e, o = t, c = n, u = r, m = 0, y = 1;
    u2.ConcurrentRoot = y, u2.ContinuousEventPriority = o, u2.DefaultEventPriority = c, u2.DiscreteEventPriority = s, u2.IdleEventPriority = u, u2.LegacyRoot = m;
  }()), u2;
}
process.env.NODE_ENV === "production" ? oP.exports = E5e() : oP.exports = k5e();
var eq = oP.exports;
const PB = {
  children: !0,
  ref: !0,
  key: !0,
  style: !0,
  forwardedRef: !0,
  unstable_applyCache: !0,
  unstable_applyDrawHitFromCache: !0
};
let OB = !1, AB = !1;
const PA = ".react-konva-event", _5e = `ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.
Position of a node will be changed during drag&drop, so you should update state of the react app as well.
Consider to add onDragMove or onDragEnd events.
For more info see: https://github.com/konvajs/react-konva/issues/256
`, T5e = `ReactKonva: You are using "zIndex" attribute for a Konva node.
react-konva may get confused with ordering. Just define correct order of elements in your render function of a component.
For more info see: https://github.com/konvajs/react-konva/issues/194
`, M5e = {};
function i_(e, t, n = M5e) {
  if (!OB && "zIndex" in t && (console.warn(T5e), OB = !0), !AB && t.draggable) {
    var r = t.x !== void 0 || t.y !== void 0, s = t.onDragEnd || t.onDragMove;
    r && !s && (console.warn(_5e), AB = !0);
  }
  for (var o in n)
    if (!PB[o]) {
      var c = o.slice(0, 2) === "on", u = n[o] !== t[o];
      if (c && u) {
        var m = o.substr(2).toLowerCase();
        m.substr(0, 7) === "content" && (m = "content" + m.substr(7, 1).toUpperCase() + m.substr(8)), e.off(m, n[o]);
      }
      var y = !t.hasOwnProperty(o);
      y && e.setAttr(o, void 0);
    }
  var b = t._useStrictMode, w = {}, k = !1;
  const j = {};
  for (var o in t)
    if (!PB[o]) {
      var c = o.slice(0, 2) === "on", E = n[o] !== t[o];
      if (c && E) {
        var m = o.substr(2).toLowerCase();
        m.substr(0, 7) === "content" && (m = "content" + m.substr(7, 1).toUpperCase() + m.substr(8)), t[o] && (j[m] = t[o]);
      }
      !c && (t[o] !== n[o] || b && t[o] !== e.getAttr(o)) && (k = !0, w[o] = t[o]);
    }
  k && (e.setAttrs(w), sb(e));
  for (var m in j)
    e.on(m + PA, j[m]);
}
function sb(e) {
  if (!ha.Konva.autoDrawEnabled) {
    var t = e.getLayer() || e.getStage();
    t && t.batchDraw();
  }
}
var _R = G3();
const tq = {}, R5e = {};
A3.Node.prototype._applyProps = i_;
function D5e(e, t) {
  if (typeof t == "string") {
    console.error(`Do not use plain text as child of Konva.Node. You are using text: ${t}`);
    return;
  }
  e.add(t), sb(e);
}
function P5e(e, t, n) {
  let r = A3[e];
  r || (console.error(`Konva has no node with the type ${e}. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/${e}"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html`), r = A3.Group);
  const s = {}, o = {};
  for (var c in t) {
    var u = c.slice(0, 2) === "on";
    u ? o[c] = t[c] : s[c] = t[c];
  }
  const m = new r(s);
  return i_(m, o), m;
}
function O5e(e, t, n) {
  console.error(`Text components are not supported for now in ReactKonva. Your text is: "${e}"`);
}
function A5e(e, t, n) {
  return !1;
}
function L5e(e) {
  return e;
}
function I5e() {
  return null;
}
function F5e() {
  return null;
}
function U5e(e, t, n, r) {
  return R5e;
}
function z5e() {
}
function B5e(e) {
}
function H5e(e, t) {
  return !1;
}
function V5e() {
  return tq;
}
function $5e() {
  return tq;
}
const G5e = setTimeout, W5e = clearTimeout, Y5e = -1;
function q5e(e, t) {
  return !1;
}
const K5e = !1, X5e = !0, Q5e = !0;
function Z5e(e, t) {
  t.parent === e ? t.moveToTop() : e.add(t), sb(e);
}
function J5e(e, t) {
  t.parent === e ? t.moveToTop() : e.add(t), sb(e);
}
function nq(e, t, n) {
  t._remove(), e.add(t), t.setZIndex(n.getZIndex()), sb(e);
}
function eSe(e, t, n) {
  nq(e, t, n);
}
function tSe(e, t) {
  t.destroy(), t.off(PA), sb(e);
}
function nSe(e, t) {
  t.destroy(), t.off(PA), sb(e);
}
function rSe(e, t, n) {
  console.error(`Text components are not yet supported in ReactKonva. You text is: "${n}"`);
}
function aSe(e, t, n) {
}
function sSe(e, t, n, r, s) {
  i_(e, s, r);
}
function iSe(e) {
  e.hide(), sb(e);
}
function oSe(e) {
}
function lSe(e, t) {
  (t.visible == null || t.visible) && e.show();
}
function cSe(e, t) {
}
function uSe(e) {
}
function dSe() {
}
const fSe = () => eq.DefaultEventPriority, mSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  appendChild: Z5e,
  appendChildToContainer: J5e,
  appendInitialChild: D5e,
  cancelTimeout: W5e,
  clearContainer: uSe,
  commitMount: aSe,
  commitTextUpdate: rSe,
  commitUpdate: sSe,
  createInstance: P5e,
  createTextInstance: O5e,
  detachDeletedInstance: dSe,
  finalizeInitialChildren: A5e,
  getChildHostContext: $5e,
  getCurrentEventPriority: fSe,
  getPublicInstance: L5e,
  getRootHostContext: V5e,
  hideInstance: iSe,
  hideTextInstance: oSe,
  idlePriority: _R.unstable_IdlePriority,
  insertBefore: nq,
  insertInContainerBefore: eSe,
  isPrimaryRenderer: K5e,
  noTimeout: Y5e,
  now: _R.unstable_now,
  prepareForCommit: I5e,
  preparePortalMount: F5e,
  prepareUpdate: U5e,
  removeChild: tSe,
  removeChildFromContainer: nSe,
  resetAfterCommit: z5e,
  resetTextContent: B5e,
  run: _R.unstable_runWithPriority,
  scheduleTimeout: G5e,
  shouldDeprioritizeSubtree: H5e,
  shouldSetTextContent: q5e,
  supportsMutation: Q5e,
  unhideInstance: lSe,
  unhideTextInstance: cSe,
  warnsIfNotActing: X5e
}, Symbol.toStringTag, { value: "Module" }));
var hSe = Object.defineProperty, pSe = Object.defineProperties, gSe = Object.getOwnPropertyDescriptors, LB = Object.getOwnPropertySymbols, ySe = Object.prototype.hasOwnProperty, vSe = Object.prototype.propertyIsEnumerable, IB = (e, t, n) => t in e ? hSe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, FB = (e, t) => {
  for (var n in t || (t = {}))
    ySe.call(t, n) && IB(e, n, t[n]);
  if (LB)
    for (var n of LB(t))
      vSe.call(t, n) && IB(e, n, t[n]);
  return e;
}, xSe = (e, t) => pSe(e, gSe(t)), UB, zB;
typeof window < "u" && ((UB = window.document) != null && UB.createElement || ((zB = window.navigator) == null ? void 0 : zB.product) === "ReactNative") ? re.useLayoutEffect : re.useEffect;
function rq(e, t, n) {
  if (!e)
    return;
  if (n(e) === !0)
    return e;
  let r = e.child;
  for (; r; ) {
    const s = rq(r, t, n);
    if (s)
      return s;
    r = r.sibling;
  }
}
function aq(e) {
  try {
    return Object.defineProperties(e, {
      _currentRenderer: {
        get() {
          return null;
        },
        set() {
        }
      },
      _currentRenderer2: {
        get() {
          return null;
        },
        set() {
        }
      }
    });
  } catch {
    return e;
  }
}
const BB = console.error;
console.error = function() {
  const e = [...arguments].join("");
  if (e != null && e.startsWith("Warning:") && e.includes("useContext")) {
    console.error = BB;
    return;
  }
  return BB.apply(this, arguments);
};
const OA = aq(re.createContext(null));
class sq extends re.Component {
  render() {
    return /* @__PURE__ */ re.createElement(OA.Provider, {
      value: this._reactInternals
    }, this.props.children);
  }
}
function bSe() {
  const e = re.useContext(OA);
  if (e === null)
    throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
  const t = re.useId();
  return re.useMemo(() => {
    for (const r of [e, e == null ? void 0 : e.alternate]) {
      if (!r)
        continue;
      const s = rq(r, !1, (o) => {
        let c = o.memoizedState;
        for (; c; ) {
          if (c.memoizedState === t)
            return !0;
          c = c.next;
        }
      });
      if (s)
        return s;
    }
  }, [e, t]);
}
function SSe() {
  const e = bSe(), [t] = re.useState(() => /* @__PURE__ */ new Map());
  t.clear();
  let n = e;
  for (; n; ) {
    if (n.type && typeof n.type == "object") {
      const s = n.type._context === void 0 && n.type.Provider === n.type ? n.type : n.type._context;
      s && s !== OA && !t.has(s) && t.set(s, re.useContext(aq(s)));
    }
    n = n.return;
  }
  return t;
}
function wSe() {
  const e = SSe();
  return re.useMemo(
    () => Array.from(e.keys()).reduce(
      (t, n) => (r) => /* @__PURE__ */ re.createElement(t, null, /* @__PURE__ */ re.createElement(n.Provider, xSe(FB({}, r), {
        value: e.get(n)
      }))),
      (t) => /* @__PURE__ */ re.createElement(sq, FB({}, t))
    ),
    [e]
  );
}
function CSe(e) {
  const t = Ee.useRef({});
  return Ee.useLayoutEffect(() => {
    t.current = e;
  }), Ee.useLayoutEffect(() => () => {
    t.current = {};
  }, []), t.current;
}
const NSe = (e) => {
  const t = Ee.useRef(), n = Ee.useRef(), r = Ee.useRef(), s = CSe(e), o = wSe(), c = (u) => {
    const { forwardedRef: m } = e;
    m && (typeof m == "function" ? m(u) : m.current = u);
  };
  return Ee.useLayoutEffect(() => (n.current = new A3.Stage({
    width: e.width,
    height: e.height,
    container: t.current
  }), c(n.current), r.current = t3.createContainer(n.current, eq.LegacyRoot, !1, null), t3.updateContainer(Ee.createElement(o, {}, e.children), r.current), () => {
    A3.isBrowser && (c(null), t3.updateContainer(null, r.current, null), n.current.destroy());
  }), []), Ee.useLayoutEffect(() => {
    c(n.current), i_(n.current, e, s), t3.updateContainer(Ee.createElement(o, {}, e.children), r.current, null);
  }), Ee.createElement("div", {
    ref: t,
    id: e.id,
    accessKey: e.accessKey,
    className: e.className,
    role: e.role,
    style: e.style,
    tabIndex: e.tabIndex,
    title: e.title
  });
}, jSe = "Layer", Fj = "Group", HB = "Rect", ESe = "Image", d2 = "Text", t3 = j5e(mSe);
t3.injectIntoDevTools({
  // @ts-ignore
  findHostInstanceByFiber: () => null,
  bundleType: process.env.NODE_ENV !== "production" ? 1 : 0,
  version: Ee.version,
  rendererPackageName: "react-konva"
});
const kSe = Ee.forwardRef((e, t) => Ee.createElement(sq, {}, Ee.createElement(NSe, { ...e, forwardedRef: t }))), _Se = (e, t) => new Promise((n) => {
  const s = document.createElement("canvas").getContext("2d");
  wt(s), s.font = `${t} 20px ${e}`;
  let o = !1;
  const c = "Some test text;", m = s.measureText(c).width;
  function y(b, w) {
    if (w === void 0 && (w = 0), w >= 20) {
      b();
      return;
    }
    if (o) {
      b();
      return;
    }
    wt(s), s.measureText(c).width !== m ? (o = !0, b()) : setTimeout(function() {
      y(b, w + 1);
    }, 100);
  }
  y(n);
}), TSe = {
  primary: "#ffffff",
  secondary: "#d9d9d9",
  memberName: "#1C75FF",
  dim: {
    color: "#141414",
    opacity: 0.6
  }
}, Cv = 664, K0 = 400, Uj = 3, iq = yn(
  function({
    thumbnailImageUrl: t,
    displayName: n,
    user: r,
    memberSince: s,
    shopUrl: o,
    shopName: c,
    color: u = TSe
  }, m) {
    const y = Rt(null), b = Rt(null), w = Rt(null), [k, j] = Re(null), [E, T] = Re(null), [D, L] = Re(0), [I, R] = Re(
      null
    ), [U, z] = Re(!1);
    if (kZ(
      m,
      () => ({
        getBlob() {
          return (E !== null && k !== null && D !== 0 && (o ? I !== null : !0) && U === !0) === !1 ? null : (wt(y.current), y.current.toBlob());
        }
      }),
      [
        E,
        k,
        D,
        I,
        U
      ]
    ), an(() => {
      Promise.all(
        [
          ["Bebas Neue Pro", "bold"],
          ["Pretendard", "bold"],
          ["Pretendard", "500"]
        ].map(
          ([X, se]) => _Se(X, se)
        )
      ).then(() => z(!0));
    }, []), an(() => {
      const X = new window.Image();
      X.src = t, X.crossOrigin = "anonymous", X.onload = () => {
        T(X);
      };
    }, []), an(() => {
      const X = new window.Image();
      X.src = kt.Client.ShopDefaultIcon, X.crossOrigin = "anonymous", X.onload = () => {
        j(X);
      };
    }, []), an(() => {
      if (E === null || U === !1)
        return;
      wt(b.current);
      const X = b.current.getTextWidth();
      if (L(X), o) {
        wt(w.current);
        const { height: se } = w.current.getSelfRect(), te = w.current.fontSize(), fe = se > te;
        R(fe);
      }
    }, [E, U]), E == null)
      return null;
    const H = Cv / E.width, K = K0 / E.height, q = Math.max(H, K), Q = { x: q, y: q }, Z = {
      x: (E.width * q - Cv) / 2 / q,
      y: (E.height * q - K0) / 2 / q
    };
    return /* @__PURE__ */ a.jsx(
      "div",
      {
        style: {
          position: "absolute",
          top: -9999,
          left: -9999,
          zIndex: -1
        },
        children: /* @__PURE__ */ a.jsx(
          kSe,
          {
            width: Cv * Uj,
            height: K0 * Uj,
            scale: { x: Uj, y: Uj },
            ref: y,
            children: /* @__PURE__ */ a.jsxs(
              jSe,
              {
                clipFunc: (X) => {
                  X.beginPath(), X.moveTo(16, 0), X.arcTo(Cv, 0, Cv, K0, 16), X.arcTo(Cv, K0, 0, K0, 16), X.arcTo(0, K0, 0, 0, 16), X.arcTo(0, 0, Cv, 0, 16), X.closePath();
                },
                children: [
                  /* @__PURE__ */ a.jsx(
                    HB,
                    {
                      width: Cv,
                      height: K0,
                      fillPatternImage: E,
                      fillPatternScale: Q,
                      fillPatternOffset: Z
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    HB,
                    {
                      width: Cv,
                      height: K0,
                      opacity: u.dim.opacity,
                      fill: u.dim.color
                    }
                  ),
                  /* @__PURE__ */ a.jsxs(Fj, { x: 24, y: 24, children: [
                    /* @__PURE__ */ a.jsx(
                      d2,
                      {
                        text: `MARPPLESHOP
CREATOR MEMBERSHIP`,
                        fontSize: 36,
                        fontFamily: "Bebas Neue Pro",
                        fill: u.primary,
                        fontStyle: "bold"
                      }
                    ),
                    /* @__PURE__ */ a.jsxs(Fj, { y: K0 - 24 - 122, children: [
                      /* @__PURE__ */ a.jsx(
                        d2,
                        {
                          ref: b,
                          text: c,
                          fontSize: 14,
                          fill: u.primary,
                          fontFamily: "Pretendard",
                          fontStyle: "bold"
                        }
                      ),
                      k && /* @__PURE__ */ a.jsx(
                        ESe,
                        {
                          x: D + 4,
                          y: -3,
                          width: 20,
                          height: 20,
                          image: k
                        }
                      ),
                      /* @__PURE__ */ a.jsx(
                        d2,
                        {
                          text: n,
                          fontSize: 24,
                          fill: u.primary,
                          fontFamily: "Pretendard",
                          fontStyle: "bold",
                          y: 26
                        }
                      ),
                      /* @__PURE__ */ a.jsxs(Fj, { y: 68, children: [
                        /* @__PURE__ */ a.jsx(
                          d2,
                          {
                            text: "Member",
                            fill: u.secondary,
                            fontStyle: "500",
                            fontFamily: "Pretendard"
                          }
                        ),
                        /* @__PURE__ */ a.jsx(
                          d2,
                          {
                            text: `@${Mc(r)}`,
                            fill: u.memberName,
                            fontStyle: "bold",
                            fontFamily: "Pretendard",
                            x: 71
                          }
                        ),
                        /* @__PURE__ */ a.jsx(
                          d2,
                          {
                            text: "Member Since",
                            fill: u.secondary,
                            fontFamily: "Pretendard",
                            fontStyle: "500",
                            y: 20
                          }
                        ),
                        /* @__PURE__ */ a.jsx(
                          d2,
                          {
                            text: s,
                            fill: u.secondary,
                            fontFamily: "Pretendard",
                            fontStyle: "500",
                            x: 109,
                            y: 20
                          }
                        ),
                        /* @__PURE__ */ a.jsx(Fj, { x: 312, children: o && /* @__PURE__ */ a.jsx(
                          d2,
                          {
                            ref: w,
                            text: o,
                            fill: u.secondary,
                            fontFamily: "Pretendard",
                            fontStyle: "500",
                            fontSize: 14,
                            y: I ? 0 : 20,
                            width: 304,
                            wrap: "word",
                            align: "right"
                          }
                        ) })
                      ] })
                    ] })
                  ] })
                ]
              }
            )
          }
        )
      }
    );
  }
);
function zj({
  children: e
}) {
  return /* @__PURE__ */ a.jsxs(V8, { className: "group flex items-center justify-between px-[1.14286rem] py-[1.71429rem]", children: [
    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: e }),
    /* @__PURE__ */ a.jsx(gY, { className: "size-[1.14286rem] group-data-[open]:rotate-180" })
  ] });
}
function Bj() {
  return /* @__PURE__ */ a.jsx("div", { className: "h-[0.57143rem] bg-mshop-gray-5" });
}
const g8 = {
  email: {
    required: !0
  },
  username: {
    required: !0,
    minLength: 1,
    maxLength: 26
  },
  mobile: {
    required: !0,
    maxLength: 12
  }
};
function VB({
  errors: e,
  register: t,
  onAccountSettingsButtonClick: n
}) {
  const { me: r, setMe: s, setUpdateMobile: o } = by();
  wt(r);
  const {
    widgetCore: { isMobile: c }
  } = Gt(), u = c ? dY : A8, m = (k) => {
    s({ ...r, username: k.target.value });
  }, y = (k) => {
    k.target.value = Yg(k.target.value), o(k.target.value);
  }, b = (k) => {
    k.target.value = K9(k.target.value);
  }, w = (k) => {
    k.target.value = Yg(k.target.value);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
      /* @__PURE__ */ a.jsxs("label", { className: "flex items-start justify-between", children: [
        /* @__PURE__ */ a.jsx("p", { className: c ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b", children: "이메일" }),
        /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: $(
              "text-mshop-gray-50",
              c ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
            ),
            onClick: n,
            children: "계정 설정"
          }
        )
      ] }),
      /* @__PURE__ */ a.jsx(
        u,
        {
          ...t("email", {
            required: g8.email.required
          }),
          readOnly: !0,
          forceWritableStyle: !0
        }
      ),
      /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: "해당 이메일로 주문 내역 메일이 전송됩니다. 사용 가능한 메일인지 확인해주세요." })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
      /* @__PURE__ */ a.jsx(
        "label",
        {
          className: c ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
          children: "이름"
        }
      ),
      /* @__PURE__ */ a.jsx(
        u,
        {
          ...t("username", {
            required: g8.username.required,
            minLength: g8.username.minLength,
            maxLength: g8.username.maxLength,
            onChange: m
          }),
          placeholder: "이름을 입력해 주세요.",
          invalid: !!e.username
        }
      )
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
      /* @__PURE__ */ a.jsx(
        "label",
        {
          className: c ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
          children: "연락처"
        }
      ),
      /* @__PURE__ */ a.jsx(
        u,
        {
          ...t("mobile", {
            required: g8.mobile.required,
            onChange: y,
            onBlur: b
          }),
          placeholder: "- 없이 숫자만 입력하세요.",
          maxLength: g8.mobile.maxLength,
          invalid: !!e.mobile,
          onFocus: w
        }
      )
    ] })
  ] });
}
function $B() {
  const { membership: e } = b6(), {
    widgetCore: { isMobile: t }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "border-b border-dashed border-mshop-gray-50 pb-[1.143rem]",
          {
            "pt-[0.571rem]": !t
          }
        ),
        children: [
          e.payment.type === $n.SubscriptionPass && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex items-start justify-between",
                  t ? "py-[0.57143rem]" : "py-[0.857rem]"
                ),
                children: [
                  /* @__PURE__ */ a.jsxs("span", { className: "flex gap-[0.286rem]", children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "월간 멤버십" }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "(부가세 포함)" })
                  ] }),
                  /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: e.payment.price.toLocaleString(cr.Ko) }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(e.payment.currency) })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex items-start justify-between",
                  t ? "py-[0.57143rem]" : "py-[0.857rem]"
                ),
                children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "결제 시작일" }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: jt(/* @__PURE__ */ new Date(), "yyyy. MM. dd") })
                ]
              }
            )
          ] }),
          e.payment.type === $n.ShortTermPass && /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "flex items-start justify-between",
                t ? "py-[0.57143rem]" : "py-[0.857rem]"
              ),
              children: [
                /* @__PURE__ */ a.jsxs("span", { className: "flex gap-[0.286rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "멤버십 단건 결제" }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "(부가세 포함)" })
                ] }),
                /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: e.payment.price.toLocaleString(cr.Ko) }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(e.payment.currency) })
                ] })
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem] py-[1.143rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "결제금액" }),
        e.payment.type == $n.SubscriptionPass ? /* @__PURE__ */ a.jsxs("span", { className: "flex items-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "매월" }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-20-unica-b ml-[0.571rem]", children: e.payment.price.toLocaleString(cr.Ko) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b", children: zs(e.payment.currency) })
        ] }) : /* @__PURE__ */ a.jsxs("span", { className: "flex items-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-20-unica-b ml-[0.571rem]", children: e.payment.price.toLocaleString(cr.Ko) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b", children: zs(e.payment.currency) })
        ] })
      ] }),
      e.payment.type === $n.SubscriptionPass && /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.14286rem]", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-end gap-[0.286rem] text-mshop-blue-100", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "다음 결제일은" }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b", children: jt(KE(/* @__PURE__ */ new Date(), 1), "yyyy. MM. dd") }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "입니다." })
        ] }),
        /* @__PURE__ */ a.jsx(
          "p",
          {
            className: $(
              "typo-mshop-kr-12-m text-right text-mshop-gray-50",
              {
                "whitespace-pre-wrap": t
              }
            ),
            children: `월별 일수의 차이로 동일 일자에 결제가 불가할 경우
해당 월 말일에 결제됩니다.`
          }
        )
      ] })
    ] })
  ] });
}
const MSe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_10144_88812)" }, /* @__PURE__ */ re.createElement("path", { d: "M20 16.88C19.78 16.88 19.55 16.8 19.38 16.62L12 9.24L4.62 16.62C4.28 16.96 3.72 16.96 3.38 16.62C3.04 16.28 3.04 15.72 3.38 15.38L11.38 7.38C11.72 7.04 12.28 7.04 12.62 7.38L20.62 15.38C20.96 15.72 20.96 16.28 20.62 16.62C20.45 16.79 20.22 16.88 20 16.88Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_10144_88812" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), RSe = yn(MSe);
function GB({
  isAgreed: e,
  membershipPaymentType: t,
  onIsAgreedChange: n,
  onClickPrivacy: r,
  onClickTerms: s
}) {
  const [o, c] = Re(!0), {
    widgetCore: { isMobile: u }
  } = Gt();
  return /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[1.143rem]", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
      /* @__PURE__ */ a.jsxs(
        "button",
        {
          type: "button",
          className: "flex items-center justify-between",
          onClick: () => c((m) => !m),
          children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m", children: "구매 동의" }),
            /* @__PURE__ */ a.jsx(
              RSe,
              {
                className: $(
                  "text-mshop-gray-80",
                  {
                    "-rotate-180": !o
                  },
                  "size-[1.14286rem]"
                )
              }
            )
          ]
        }
      ),
      o && /* @__PURE__ */ a.jsx(a.Fragment, { children: t === $n.ShortTermPass ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
          "멤버십 서비스를 이용하기전에,",
          " ",
          /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              className: "underline",
              onClick: s,
              children: "이용약관"
            }
          ),
          "을 반드시 확인해주세요."
        ] }),
        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "기간 한정 멤버십은 가입일시와 관계 없이 지정된 이용 기간에만 이용할 수 있습니다. 가입 전 이용기간을 확인해 주세요." }),
        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "멤버십 혜택을 이미 이용하였거나 결제일로부터 7일이 경과한 후에는 어떤 사유로도 취소나 환불이 불가합니다." })
      ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
          "멤버십 서비스를 이용하기 전에,",
          " ",
          /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              className: "underline",
              onClick: s,
              children: "이용약관"
            }
          ),
          "을 반드시 확인해주세요."
        ] }),
        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "멤버십은 최초 결제일을 기준으로 매월 동일 일자에 자동 갱신됩니다. 월별 일수 차이로 동일 일자에 결제가 불가능한 경우, 해당 월의 마지막 날에 결제가 진행됩니다." }),
        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "멤버십은 마이페이지에서 언제든지 해지 신청이 가능하며, 해지 신청 시 다음 정기결제일부터 멤버십이 종료됩니다." }),
        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "멤버십 혜택을 이미 이용하였거나 결제일로부터 7일이 경과한 경우에는 어떤 사유로도 취소나 환불이 불가합니다." })
      ] }) })
    ] }),
    [
      ["개인 정보 수집 및 이용 동의", r],
      ["이용약관 동의", s]
    ].map(([m, y]) => /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: "flex items-start justify-between gap-[1.714rem]",
        children: [
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m", children: m }),
          /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              className: "typo-mshop-kr-14-m text-mshop-gray-80 underline",
              onClick: y,
              children: "보기"
            }
          )
        ]
      },
      m
    )),
    /* @__PURE__ */ a.jsxs(
      Bd,
      {
        className: $(
          "group flex gap-[0.571rem]",
          u ? "items-start" : "items-center"
        ),
        children: [
          u ? /* @__PURE__ */ a.jsx("span", { className: "py-[0.21rem]", children: /* @__PURE__ */ a.jsx(Z0, { checked: e, onChange: n }) }) : /* @__PURE__ */ a.jsx(Z0, { checked: e, onChange: n }),
          /* @__PURE__ */ a.jsxs(_c, { className: "typo-mshop-kr-14-m cursor-pointer", children: [
            /* @__PURE__ */ a.jsx("strong", { className: "typo-mshop-kr-14-b", children: "(필수)" }),
            " 주문 내용 및 위의 내용을 모두 확인하였으며, 결제에 동의합니다."
          ] })
        ]
      }
    )
  ] });
}
const w8 = {
  Html5Inicis: "html5_inicis",
  // 신용카드
  NaverPay: "naverpay"
};
function WB(e) {
  return /* @__PURE__ */ a.jsx(
    HE,
    {
      ...e,
      className: $(
        "group block size-[1.14285rem] rounded-full",
        "cursor-pointer border border-mshop-gray-10 bg-mshop-white",
        "data-[checked]:border-[.35428rem] data-[checked]:border-mshop-blue-100",
        "data-[disabled]:cursor-not-allowed data-[disabled]:border-mshop-gray-10 data-[disabled]:bg-mshop-gray-5",
        "data-[checked]:data-[disabled]:border-mshop-gray-20 data-[checked]:data-[disabled]:bg-mshop-gray-5"
      )
    }
  );
}
const C8 = {
  Registered: "registered",
  Other: "other"
};
function YB({
  payMethod: e,
  membershipPayMethodType: t,
  setMembershipPayMethodType: n,
  openPayMethodModal: r
}) {
  const { watch: s, setValue: o } = xp(), { membership: c } = b6(), {
    widgetCore: { isMobile: u }
  } = Gt(), m = u ? uh : fn, y = Object.values(C8).filter(
    (b) => b === C8.Other ? c.payment.type === $n.ShortTermPass : b
  );
  return /* @__PURE__ */ a.jsx(
    P9,
    {
      value: t,
      onChange: (b) => {
        n(b), b === C8.Other && !s("otherPayMethod.pg") && o("otherPayMethod", {
          pg: w8.Html5Inicis,
          pay_method: "card"
        });
      },
      className: "flex flex-col gap-y-[1.71rem]",
      children: y.map((b) => {
        const w = t === C8.Registered;
        return b === C8.Registered ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ a.jsxs(Bd, { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ a.jsx(WB, { value: b }),
              /* @__PURE__ */ a.jsx(
                _c,
                {
                  className: $(
                    "cursor-pointer",
                    { "typo-mshop-kr-16-b": !u },
                    { "typo-mshop-kr-14-b": u }
                  ),
                  children: qB(b)
                }
              )
            ] }),
            w && e && /* @__PURE__ */ a.jsx(
              "button",
              {
                className: $(
                  "text-mshop-blue-100",
                  { "typo-mshop-kr-16-m": !u },
                  { "typo-mshop-kr-14-m": u }
                ),
                type: "button",
                onClick: r,
                children: "결제 수단 변경"
              }
            )
          ] }),
          w && (e ? /* @__PURE__ */ a.jsx(
            $2,
            {
              variant: "creditCard",
              paymentMethod: e
            }
          ) : /* @__PURE__ */ a.jsx(
            $2,
            {
              variant: "add",
              onAddClick: r
            }
          ))
        ] }, b) : /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ a.jsxs(Bd, { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ a.jsx(WB, { value: b }),
            /* @__PURE__ */ a.jsx(
              _c,
              {
                className: $(
                  "cursor-pointer",
                  { "typo-mshop-kr-16-b": !u },
                  { "typo-mshop-kr-14-b": u }
                ),
                children: qB(b)
              }
            )
          ] }) }),
          /* @__PURE__ */ a.jsx(
            "div",
            {
              className: $("flex items-center gap-x-[0.57rem]", {
                "flex-wrap gap-y-[0.57rem] after:flex-[1_1_calc(50%-4px)]": u
              }),
              children: !w && Object.values(uo).map((k) => {
                var j;
                return /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      { "flex-1": !u },
                      {
                        "flex-[1_1_calc(50%-4px)]": u
                      }
                    ),
                    children: /* @__PURE__ */ a.jsx(
                      m,
                      {
                        widthFull: !0,
                        variant: "lg",
                        type: "button",
                        theme: ((j = s("otherPayMethod")) == null ? void 0 : j.pay_method) === k ? "blue" : "line",
                        onClick: () => {
                          o("otherPayMethod", PSe(k));
                        },
                        children: /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $("flex items-center gap-x-[0.57rem]", {
                              "typo-mshop-kr-14-b": u
                            }),
                            children: [
                              k === uo.Card ? null : /* @__PURE__ */ a.jsx(
                                "img",
                                {
                                  src: OSe(k),
                                  className: $(
                                    { "h-[1.71429rem] w-[1.71429rem]": !u },
                                    { "h-[1.42857rem] w-[1.42857rem]": u }
                                  ),
                                  alt: ""
                                }
                              ),
                              DSe(k)
                            ]
                          }
                        )
                      }
                    )
                  },
                  k
                );
              })
            }
          )
        ] }, b);
      })
    }
  );
}
function qB(e) {
  return e === C8.Registered ? "등록한 결제 수단" : "다른 결제 수단";
}
function DSe(e) {
  switch (e) {
    case uo.Card:
      return "신용카드";
    case uo.NaverPay:
      return "네이버페이";
    case uo.KakaoPay:
      return "카카오페이";
    case uo.Tosspay:
      return "토스페이";
    case uo.Samsungpay:
      return "삼성페이";
    default:
      throw new Error(`Does not exist ${e}`);
  }
}
function PSe(e) {
  switch (e) {
    case uo.Card:
      return {
        pg: `${w8.Html5Inicis}.MOImarshop`,
        pay_method: uo.Card
      };
    case uo.KakaoPay:
      return {
        pg: `${w8.Html5Inicis}.MOImarshop`,
        pay_method: uo.KakaoPay
      };
    case uo.NaverPay:
      return {
        pg: w8.NaverPay,
        pay_method: uo.NaverPay,
        naverPopupMode: !0
      };
    case uo.Tosspay:
      return {
        pg: `${w8.Html5Inicis}.MOImarshop`,
        pay_method: uo.Tosspay
      };
    case uo.Samsungpay:
      return {
        pg: `${w8.Html5Inicis}.MOImarshop`,
        pay_method: uo.Samsungpay
      };
    default:
      throw new Error(`Does not exsist ${e}`);
  }
}
function OSe(e) {
  switch (e) {
    case uo.KakaoPay:
      return kt.Pg.kakaopay;
    case uo.NaverPay:
      return kt.Pg.naverpay;
    case uo.Tosspay:
      return kt.Pg.tosspay;
    case uo.Samsungpay:
      return kt.Pg.samsung;
  }
}
const ASe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M9.9508 3.04749H5.83514C5.69141 3.04749 5.55843 3.12359 5.48562 3.24751L2.05648 9.08381C1.8977 9.35404 2.09256 9.69456 2.406 9.69456H6.02129C6.15618 9.69456 6.28223 9.62747 6.35756 9.51558L10.2871 3.67928C10.4684 3.41001 10.2754 3.04749 9.9508 3.04749Z" }), /* @__PURE__ */ re.createElement("path", { d: "M15.1687 9.69454C15.4933 9.69454 15.6862 9.33202 15.5049 9.06275L12.3363 4.35651C12.1756 4.11787 11.8244 4.11787 11.6637 4.35651L8.49506 9.06275C8.31376 9.33202 8.50671 9.69454 8.83133 9.69454H15.1687Z" }), /* @__PURE__ */ re.createElement("path", { d: "M21.9435 9.08381L18.5144 3.24751C18.4416 3.12359 18.3086 3.04749 18.1649 3.04749H14.0492C13.7246 3.04749 13.5316 3.41001 13.7129 3.67928L17.6424 9.51558C17.7178 9.62747 17.8438 9.69456 17.9787 9.69456H21.594C21.9074 9.69456 22.1023 9.35405 21.9435 9.08381Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8.41019 11.2147C8.1191 11.2147 7.92288 11.5124 8.03764 11.78L11.6274 20.7071C11.7679 21.0345 12.2321 21.0345 12.3725 20.7071L15.9624 11.78C16.0771 11.5124 15.8809 11.2147 15.5898 11.2147H8.41019Z" }), /* @__PURE__ */ re.createElement("path", { d: "M15.607 18.7927L21.8923 11.8944C22.1311 11.6345 21.9468 11.2147 21.5938 11.2147H18.1268C17.9647 11.2147 17.8182 11.3113 17.7543 11.4603L14.936 18.3586C14.7562 18.7777 15.2984 19.1285 15.607 18.7927Z" }), /* @__PURE__ */ re.createElement("path", { d: "M8.39299 18.7927L2.10771 11.8944C1.86886 11.6346 2.05321 11.2147 2.40618 11.2147H5.87316C6.03527 11.2147 6.1818 11.3113 6.24571 11.4603L9.06401 18.3586C9.24383 18.7777 8.70162 19.1285 8.39299 18.7927Z" })), fu = yn(ASe), LSe = [
  "BUY_GOODS",
  "BUY_ORDER_MADE",
  "BUY_DIGITAL_GOODS"
], ISe = [
  "COMMUNITY",
  "DIGITAL_CONTENT",
  "ONLINE_CLASS",
  "LIVE_STREAMING",
  "DM",
  "CHANNEL"
], FSe = ["COMMISSION", "CUSTOM"], o_ = (e) => W3((t) => {
  if (LSe.includes(t.type))
    return "productRewards";
  if (ISe.includes(t.type))
    return "communityRewards";
  if (FSe.includes(t.type))
    return "creatorRewards";
  throw new Error(`Unexpected type: ${t.type}`);
}, e), Vv = {
  // Product Rewards
  [ss.BuyGoods]: "멤버십 굿즈 구매",
  [ss.BuyOrderMade]: "멤버십 상품 구매",
  [ss.Community]: "멤버십 커뮤니티 가입",
  [ss.BuyDigitalGoods]: "멤버십 전용 디지털 콘텐츠",
  [ss.OnlineClass]: "온라인 클래스 수강",
  // Community Rewards
  [ss.DigitalContent]: "멤버십 전용 디지털 콘텐츠",
  [ss.LiveStreaming]: "멤버십 전용 라이브 방송",
  [ss.Channel]: "멤버십 전용 채팅 채널",
  [ss.Dm]: "크리에이터와 1:1 메시지 혜택",
  // Creator Rewards
  [ss.Commission]: "개인 맞춤 콘텐츠(커미션) 요청",
  [ss.Custom]: "크리에이터 특별 혜택"
};
function USe({
  communityRewards: e
}) {
  const {
    widgetCore: { isMobile: t }
  } = Gt(), { membership: n } = b6();
  return /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
    /* @__PURE__ */ a.jsx(
      "p",
      {
        className: $(
          "text-mshop-black",
          t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b"
        ),
        children: "사이어티 커뮤니티 혜택"
      }
    ),
    /* @__PURE__ */ a.jsx("ul", { className: "flex flex-col gap-[0.85714rem] rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem]", children: e.map((r) => /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[0.57143rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.57143rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[.1429rem] bg-mshop-black" }) }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-b whitespace-pre-wrap break-all text-mshop-black", children: r.title ?? d6[r.type] }),
        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: Vv[r.type] }),
        r.type !== "DM" && /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $(
              "flex flex-wrap pt-[0.28571rem]",
              t ? "gap-[0.28571rem]" : "gap-[0.57143rem]"
            ),
            children: [
              ...r.channels.filter(
                (s) => s.visibility !== "PRIVATE"
              ),
              ...r.channels.filter(
                (s) => s.visibility === "PRIVATE"
              )
            ].map((s) => {
              const o = u6[s.type];
              return /* @__PURE__ */ a.jsxs(
                "a",
                {
                  className: $(
                    "flex items-center gap-[0.28571rem] rounded-[0.28571rem] bg-mshop-gray-5",
                    t ? "max-w-[14.57143rem] px-[0.57143rem] py-[0.28571rem]" : "min-h-[2.85714rem] max-w-[15.14286rem] px-[0.85714rem]"
                  ),
                  href: s.visibility === "PRIVATE" ? Ku({
                    type: "home",
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    subdomain: n.dao.subdomain
                  }) : Ku({
                    type: "channel",
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    subdomain: n.dao.subdomain,
                    channelId: s.id
                  }),
                  target: "_blank",
                  children: [
                    /* @__PURE__ */ a.jsx(o, { className: "size-[1.14286rem] shrink-0 text-mshop-gray-80" }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: s.displayName ?? `비공개 채널 ${s.count}개` })
                  ]
                },
                s.id
              );
            })
          }
        )
      ] })
    ] }, r.id)) })
  ] });
}
function KB({ rewards: e, title: t }) {
  const {
    widgetCore: { isMobile: n }
  } = Gt();
  return /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
    /* @__PURE__ */ a.jsx(
      "span",
      {
        className: $(
          "line-clamp-2 break-all text-mshop-black",
          n ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b"
        ),
        children: t
      }
    ),
    /* @__PURE__ */ a.jsx("ul", { className: "flex flex-col gap-[0.857rem] rounded-[0.85714rem] border border-mshop-gray-10 p-[1.143rem]", children: e.map((r) => /* @__PURE__ */ a.jsxs(
      "li",
      {
        className: "relative flex items-start gap-[0.571rem]",
        children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.571rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.143rem] rounded-full bg-mshop-black" }) }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex grow flex-col", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-b whitespace-pre-wrap break-all text-mshop-black", children: XB(r) ? r.title ?? c6[r.type] : r.title }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m break-all text-mshop-gray-80", children: Vv[r.type] }),
            XB(r) && /* @__PURE__ */ a.jsx(
              "div",
              {
                className: $(
                  "mt-[0.29rem] grid gap-[0.57143rem]",
                  {
                    "grid-cols-7": !n
                  },
                  {
                    "grid-cols-6": n
                  }
                ),
                children: r.products.sort((s, o) => o.price - s.price).map((s) => /* @__PURE__ */ a.jsx(
                  "a",
                  {
                    href: s.link,
                    className: $(
                      "flex-center overflow-hidden rounded-[0.57143rem] bg-mshop-gray-5",
                      { "size-[3.16329rem]": !n },
                      { "size-[3.10714rem]": n }
                    ),
                    children: /* @__PURE__ */ a.jsx(
                      "img",
                      {
                        alt: "",
                        src: s.image,
                        className: "aspect-square object-cover",
                        style: {
                          width: `${s.imageRatio}%`
                        }
                      },
                      s.id
                    )
                  }
                ))
              }
            )
          ] })
        ]
      },
      r.id
    )) })
  ] });
}
function XB(e) {
  return e.type === "BUY_DIGITAL_GOODS" || e.type === "BUY_GOODS" || e.type === "BUY_ORDER_MADE";
}
function QB({ onShopButtonClick: e }) {
  const { membership: t } = b6(), {
    widgetCore: { isMobile: n }
  } = Gt(), r = o_(t.rewards), s = () => {
    t.shop && e(t.shop.url);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "button",
      {
        type: "button",
        onClick: s,
        className: $(
          "flex items-center gap-[0.286rem] border-b border-mshop-black",
          n ? "pb-[0.57143rem]" : "pb-[0.857rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b", children: Ef(t.shop) }),
          /* @__PURE__ */ a.jsx(ch, { className: "size-[1.429rem]" })
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex items-center gap-[0.286rem]",
          n ? "pt-[0.857rem]" : "border-b border-mshop-gray-20 py-[0.857rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("h3", { className: n ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b", children: "멤버십" }),
          /* @__PURE__ */ a.jsx(fu, { className: "size-[1.429rem]" })
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[1.143rem] py-[1.143rem]", children: [
      /* @__PURE__ */ a.jsx(
        "img",
        {
          alt: "",
          src: t.thumbnailImage.url,
          className: $(
            "rounded-[1.143rem] object-cover",
            n ? "size-[7.14286rem]" : "size-[8.571rem]"
          )
        }
      ),
      n ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.14286rem]", children: [
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m", children: t.displayName }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: ZB(t.payment.type) })
        ] }),
        /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.28571rem]", children: [
          /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b", children: t.payment.price.toLocaleString(cr.Ko) }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: zs(t.payment.currency) })
          ] }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-r", children: t.payment.type === $n.SubscriptionPass ? "/ 월간" : "/ 단건 결제" })
        ] })
      ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.286rem]", children: [
        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-m line-clamp-2 break-all", children: t.displayName }),
        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: ZB(t.payment.type) }),
        /* @__PURE__ */ a.jsxs("span", { className: "flex items-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-20-unica-b", children: t.payment.price.toLocaleString(cr.Ko) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b", children: zs(t.payment.currency) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-r ml-[0.286rem]", children: t.payment.type === $n.SubscriptionPass ? "/ 월간" : "/ 단건 결제" })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[1.143rem]", children: [
      r.productRewards && /* @__PURE__ */ a.jsx(
        KB,
        {
          title: "멤버십 전용 상품",
          rewards: r.productRewards
        }
      ),
      r.communityRewards && /* @__PURE__ */ a.jsx(
        USe,
        {
          communityRewards: r.communityRewards
        }
      ),
      r.creatorRewards && /* @__PURE__ */ a.jsx(
        KB,
        {
          title: "크리에이터 혜택",
          rewards: r.creatorRewards
        }
      )
    ] })
  ] });
}
function ZB(e) {
  switch (e) {
    case $n.SubscriptionPass:
      return "정기 구독 멤버십";
    case $n.ShortTermPass:
      return "기간 한정 멤버십";
    default:
      throw new Error("Unknown membership payment type");
  }
}
const JB = {
  Registered: "registered",
  Other: "other"
};
function zSe(e) {
  Al([
    [ol, e.client],
    [
      ll,
      {
        isMobile: e.isMobile,
        isApp: e.isApp,
        toggleSpinner: e.toggleSpinner,
        onError: e.onError,
        onScrollLock: e.onScrollLock
      }
    ],
    [R1, e.projectId],
    [m5, e.payMethod],
    [yY, e.membership],
    [M3, e.me]
  ]);
  const [t, n] = Re(!1), [r, s] = Re(!1), [o, c] = Re(
    !!new URLSearchParams(window.location.href).get("success")
  ), u = Rt(null), { membership: m } = b6();
  wt(m.shop);
  const { payMethod: y, setPayMethod: b } = xw(), { client: w } = Ha(), { me: k } = by(), {
    widgetCore: { toggleSpinner: j, onError: E, isMobile: T }
  } = Gt();
  wt(k);
  const [D, L] = Re(!1), [I, R] = Re(!1), [U, z] = Re(JB.Registered), H = bp({
    defaultValues: {
      email: k.email,
      mobile: k.mobile === null ? null : K9(k.mobile),
      username: k.username ?? ""
    }
  }), {
    formState: { errors: K },
    register: q,
    handleSubmit: Q
  } = H;
  let Z;
  if (m.payment.type === $n.SubscriptionPass)
    Z = m.expiredAt ? jt(m.expiredAt, "yyyy. MM. dd") : "Current";
  else if (m.payment.type === $n.ShortTermPass)
    Z = jt(m.payment.endTimeAt, "yyyy. MM. dd");
  else
    throw new Error("Unexpected membership type");
  const X = Rt(null);
  an(() => {
    m.payment.type !== $n.SubscriptionPass && (async () => {
      try {
        const { exist: Se } = await Cxe();
        "IMP" in window && (X.current = window.IMP, Se || await X.current.init("imp03882726"));
      } catch {
      }
    })();
  }, []), an(() => {
    (async () => {
      if (K.username || K.mobile)
        return en({
          body: (Se) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: Se
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "주문자 정보 입력" }),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m", children: "입력되지 않은 필수 정보가 있습니다." })
              ] })
            }
          )
        });
    })();
  }, [K]);
  const se = async (Se) => {
    if (wt(k.mobile), wt(k.email), !t)
      return en({
        body: (oe) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: oe
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.857rem]", children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 동의" }),
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "결제를 위해 모든 약관에 동의해 주세요." })
            ] })
          }
        )
      });
    if (U === JB.Registered)
      return te();
    await fe(Se);
  }, te = async () => {
    if (!y)
      return en({
        body: (ue) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: ue
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.857rem]", children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 수단 등록" }),
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m", children: "결제 수단을 등록해 주세요." })
            ] })
          }
        )
      });
    wt(k.username), wt(k.mobile), L(!0), j(!0);
    const { code: Se, data: oe } = await xxe(
      {
        paymentModelId: m.payment.id,
        payMethodId: y.id,
        mobile: k.mobile,
        username: k.username
      },
      {
        client: w,
        onError: E
      }
    );
    if (Se !== le.Success)
      switch (L(!1), j(!1), Se) {
        case le.ExpiredInfo:
        case le.NotRegisteredPayment:
          return en({
            body: (ue) => /* @__PURE__ */ a.jsx(
              ea,
              {
                button: {
                  props: ue
                },
                children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 수단 확인" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                    "유효하지 않은 결제 수단입니다.",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "결제 수단을 확인해 주세요."
                  ] })
                ] })
              }
            )
          });
        case le.AlreadyMembershipSubscription:
        case le.NotFoundPaymentModel:
        case le.ClosedMembership:
          return await en({
            body: (ue) => /* @__PURE__ */ a.jsx(
              ea,
              {
                button: {
                  props: ue
                },
                children: /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex-col gap-y-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                    "해당 멤버십의 상태나 정보가 변경되었습니다.",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "가입 가능 여부 또는 변경된 정보를 확인 후",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "다시 시도해 주세요."
                  ] })
                ] })
              }
            )
          }), window.location.reload();
        case le.TokenExpired:
          return E(Ht);
        case le.FailedPayment:
          return en({
            body: (ue) => /* @__PURE__ */ a.jsx(
              ea,
              {
                button: {
                  props: ue
                },
                children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 실패" }),
                  oe.column === fA.InsufficientBalance ? /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                    "계좌 잔액이 부족합니다.",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "확인 후 다시 시도해 주세요."
                  ] }) : /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "결제 수단 확인 후 다시 시도해 주세요." })
                ] })
              }
            )
          });
        case le.FailedSignedUpLimitReached:
          return await en({
            body: (ue) => /* @__PURE__ */ a.jsx(
              ea,
              {
                button: {
                  props: ue
                },
                children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "가입 인원 마감" }),
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "현재 가입 가능한 인원이 마감되어 가입할 수 없습니다." })
                ] })
              }
            )
          }), e.onSignedUpLimitReachedAlertButtonClick();
        default:
          return en({
            body: (ue) => /* @__PURE__ */ a.jsx(
              ea,
              {
                button: {
                  props: ue
                },
                children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                    "예기치 못한 오류로 인해 진행할 수 없습니다.",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "동일한 문제가 반복적으로 발생할 경우",
                    /* @__PURE__ */ a.jsx("br", {}),
                    /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                    "로 문의해 주세요."
                  ] })
                ] })
              }
            )
          });
      }
    if ((oe == null ? void 0 : oe.portone) === null) {
      L(!1), j(!1), c(!0), e.onPaySuccess(), window.scrollTo(0, 0);
      return;
    }
    return pA({
      merchantUid: oe.portone.merchantUid,
      onPaid: () => {
        c(!0), e.onPaySuccess(), L(!1), j(!1), window.scrollTo(0, 0);
      },
      onFailed: () => (L(!1), j(!1), en({
        body: (ue) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: ue
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                "예기치 못한 오류로 인해 진행할 수 없습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "동일한 문제가 반복적으로 발생할 경우",
                /* @__PURE__ */ a.jsx("br", {}),
                /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                "로 문의해 주세요."
              ] })
            ] })
          }
        )
      })),
      onCanceled: () => (j(!1), en({
        body: (ue) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: ue
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 실패" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                "결제에 실패 했습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "나중에 다시 시도해 주세요."
              ] })
            ] })
          }
        )
      })),
      client: w,
      onError: E
    });
  }, fe = async (Se) => {
    L(!0), j(!0);
    const oe = X.current;
    wt(oe), wt(Se.otherPayMethod);
    const { code: ue, data: he } = await bxe(
      {
        payload: {
          type: "MEMBERSHIP",
          paymentModelId: m.payment.id
        }
      },
      {
        client: w,
        onError: E
      }
    );
    if (ue === le.TokenExpired)
      return e.onError(Ht);
    if (ue === le.AlreadyMembershipSubscription || ue === le.NotFoundPaymentModel)
      return await en({
        body: (Te) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: Te
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex-col gap-y-[0.857rem]", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                "해당 멤버십의 상태나 정보가 변경되었습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "가입 가능 여부 또는 변경된 정보를 확인 후",
                /* @__PURE__ */ a.jsx("br", {}),
                "다시 시도해 주세요."
              ] })
            ] })
          }
        )
      }), window.location.reload();
    const ve = {
      buyer_email: he.buyerEmail,
      buyer_name: he.buyerName,
      custom_data: he.customData,
      notice_url: he.noticeUrl,
      display: {
        // 할부결제는 5만원 이상 결제 요청시에만 이용 가능
        card_quota: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      },
      merchant_uid: he.merchantUid,
      name: he.name,
      amount: he.amount,
      m_redirect_url: `${window.location.href}&success=true`,
      ...Se.otherPayMethod
    };
    oe.request_pay(ve, (Te) => {
      if (!Te.success)
        return L(!1), Te.error_msg ? en({
          body: (Ie) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: Ie
              },
              children: /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: Te.error_msg })
            }
          )
        }) : en({
          body: (Ie) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: Ie
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "예기치 못한 오류로 인해 진행할 수 없습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "동일한 문제가 반복적으로 발생할 경우",
                  /* @__PURE__ */ a.jsx("br", {}),
                  /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                  "로 문의해 주세요."
                ] })
              ] })
            }
          )
        });
      console.log(Te), c(!0);
    }), j(!1);
  }, ce = (Se) => {
    b(Se), s(!1);
  }, pe = async () => {
    wt(u.current);
    const Se = await u.current.getBlob();
    if (Se === null)
      return await en({
        body: (he) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: he
            },
            children: /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: "다시 시도해 주세요." })
          }
        )
      });
    R(!0), j(!0);
    const oe = await cw(
      {},
      {
        client: w,
        onError: E
      }
    );
    if (oe.code === le.TokenExpired)
      return R(!1), j(!1), E(Ht);
    const ue = await fetch(oe.data.uploadUrl, {
      method: "PUT",
      referrerPolicy: "no-referrer-when-downgrade",
      headers: {
        "Content-Type": Se.type
      },
      cache: "no-store",
      body: Se
    });
    if (R(!1), j(!1), ue.ok === !1)
      return gE(ue.status, E);
    e.onMembershipCardDownloadButtonClick(
      oe.data.url,
      m.displayName
    );
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    !T && !o && /* @__PURE__ */ a.jsx(S9, { ...H, children: /* @__PURE__ */ a.jsxs("div", { className: "twp flex flex-col gap-[1.714rem]", children: [
      /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-28-b", children: "멤버십 결제하기" }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[2.286rem]", children: [
        /* @__PURE__ */ a.jsxs(
          "form",
          {
            className: "flex grow flex-col gap-[3.429rem]",
            onSubmit: Q(se),
            children: [
              /* @__PURE__ */ a.jsxs(
                "section",
                {
                  id: "membership-payment-orderer-info",
                  className: "flex flex-col gap-[1.714rem]",
                  children: [
                    /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-20-b flex items-center border-b border-mshop-black py-[0.857rem]", children: "주문자 정보" }),
                    /* @__PURE__ */ a.jsx(
                      VB,
                      {
                        errors: K,
                        register: q,
                        onAccountSettingsButtonClick: e.onAccountSettingsButtonClick
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ a.jsxs(
                "section",
                {
                  id: "membership-payment-method",
                  className: "flex flex-col gap-[1.714rem]",
                  children: [
                    /* @__PURE__ */ a.jsx("div", { className: "border-b border-mshop-black pb-[0.857rem]", children: /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 방법 선택" }) }),
                    /* @__PURE__ */ a.jsx(
                      YB,
                      {
                        payMethod: y,
                        openPayMethodModal: () => s(!0),
                        membershipPayMethodType: U,
                        setMembershipPayMethodType: z
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ a.jsxs(
                "section",
                {
                  id: "membership-payment-delivery-agree",
                  className: "flex flex-col gap-[1.714rem]",
                  children: [
                    /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-20-b border-b border-mshop-black pb-[0.857rem]", children: "결제 동의" }),
                    /* @__PURE__ */ a.jsx(
                      GB,
                      {
                        membershipPaymentType: m.payment.type,
                        isAgreed: t,
                        onIsAgreedChange: n,
                        onClickPrivacy: e.onClickPrivacy,
                        onClickTerms: e.onClickTerms
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "submit",
                  className: $(
                    "flex-center transition duration-200",
                    "typo-mshop-kr-20-b h-[4.286rem] gap-[0.286rem] rounded-xl px-[1.714rem]",
                    "bg-mshop-blue-100 text-mshop-white hover:bg-mshop-blue-10 hover:text-mshop-blue-100 disabled:bg-mshop-gray-5 disabled:text-mshop-gray-50"
                  ),
                  disabled: D,
                  children: "결제하기"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs("aside", { className: "flex w-[32rem] shrink-0 flex-col gap-[1.143rem]", children: [
          /* @__PURE__ */ a.jsxs(
            "section",
            {
              id: "membership-payment-product-info",
              className: "flex flex-col gap-y-[1.14rem] rounded-[0.57143rem] border border-mshop-gray-20 px-[1.71429rem] pb-[1.71429rem] pt-[1.14286rem]",
              children: [
                m.payment.type === $n.ShortTermPass && /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-16-m rounded-[0.57143rem] bg-mshop-blue-10 p-[0.85714rem] text-mshop-blue-100", children: [
                  jt(m.payment.endTimeAt, "yyyy.MM.dd"),
                  "까지 이용 가능한 멤버십입니다."
                ] }),
                /* @__PURE__ */ a.jsx(
                  QB,
                  {
                    onShopButtonClick: e.onShopButtonClick
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs(
            "section",
            {
              id: "membership-payment-order-info",
              className: "rounded-lg border border-mshop-gray-20 px-[1.714rem]",
              children: [
                /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b border-b border-mshop-black py-[1.143rem]", children: "주문 정보" }),
                /* @__PURE__ */ a.jsx($B, {})
              ]
            }
          )
        ] })
      ] })
    ] }) }),
    !T && o && /* @__PURE__ */ a.jsxs(
      "main",
      {
        id: "twp membership-payment-completed",
        className: "flex flex-col items-center justify-center gap-[2.28571rem] py-[6.85714rem]",
        children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center gap-[1.71429rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "size-[8.57143rem]", children: /* @__PURE__ */ a.jsx(
              "img",
              {
                alt: "",
                src: kt.KeyVisual.MembershipMeetFan,
                className: "size-[8.57143rem] object-cover"
              }
            ) }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.28571rem]", children: [
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-24-b text-center text-mshop-black", children: `${k.displayName}님! 멤버십 가입이 완료되었습니다.` }),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-24-b text-center text-mshop-black", children: "멤버십 카드를 다운로드해 보세요." })
              ] }),
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-m whitespace-pre text-center text-mshop-gray-50", children: `멤버십 회원을 인증할 수 있는 카드를 준비했어요.
지금 바로 다운로드해서 친구들과 공유해 보세요! ` })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "relative isolate h-[24.92857rem] w-[17.14286rem] overflow-hidden rounded-[1.14286rem] bg-mshop-white", children: [
            m.shop.coverImageUrl && /* @__PURE__ */ a.jsx("div", { className: "absolute size-full", children: /* @__PURE__ */ a.jsx(
              "img",
              {
                alt: "",
                className: "h-[24.92857rem] w-[17.14286rem] object-cover",
                src: m.shop.coverImageUrl
              }
            ) }),
            /* @__PURE__ */ a.jsxs("div", { className: "absolute flex size-full flex-col items-center gap-[1.14286rem] bg-mshop-dim-30 p-[1.71429rem] backdrop-blur-[30px]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "isolate size-[5.14286rem] overflow-hidden rounded-full", children: /* @__PURE__ */ a.jsx(
                "img",
                {
                  alt: "",
                  className: "h-[5.14286rem] w-[5.14286rem] object-cover",
                  src: m.shop.profileImageUrl ?? kt.Common.CreatorProfileDefaultGray
                }
              ) }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center gap-[0.14286rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b line-clamp-1 break-words text-center text-mshop-white", children: m.displayName }),
                /* @__PURE__ */ a.jsxs("span", { className: "flex flex-col items-center", children: [
                  /* @__PURE__ */ a.jsxs("span", { className: "flex", children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-white", children: jt(Date.now(), "yyyy. MM. dd") }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-bright-70", children: "부터" })
                  ] }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-bright-70", children: "가입한 팬이에요!" })
                ] })
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "isolate size-[6.28571rem] overflow-hidden rounded-[0.57143rem]", children: /* @__PURE__ */ a.jsx(
                aa,
                {
                  height: "6.28571rem",
                  width: "6.28571rem",
                  src: m.thumbnailImage.url
                }
              ) }),
              /* @__PURE__ */ a.jsxs(
                "button",
                {
                  type: "button",
                  className: "flex gap-[0.57143rem] rounded-[0.57143rem] bg-mshop-bright-20 px-[1.14286rem] py-[0.57143rem]",
                  disabled: I,
                  onClick: pe,
                  children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-b text-mshop-white", children: "카드 다운로드" }),
                    /* @__PURE__ */ a.jsx(Y8, { className: "size-[1.14286rem] shrink-0 text-mshop-white" })
                  ]
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ a.jsx("div", { className: "flex w-[34.286rem] flex-col items-center gap-[1.714rem]", children: /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[1.143rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "w-[16.571rem]", children: /* @__PURE__ */ a.jsx(
              fn,
              {
                theme: "white",
                variant: "lg",
                widthFull: !0,
                type: "button",
                onClick: e.onGoToCreatorHomeButtonClick,
                children: "크리에이터 샵 가기"
              }
            ) }),
            /* @__PURE__ */ a.jsx("div", { className: "w-[16.571rem]", children: /* @__PURE__ */ a.jsx(
              fn,
              {
                theme: "blue",
                variant: "lg",
                widthFull: !0,
                type: "button",
                onClick: () => e.onCheckMembershipInfoButtonClick(m.id),
                children: "멤버십 정보 확인"
              }
            ) })
          ] }) })
        ]
      }
    ),
    T && !o && /* @__PURE__ */ a.jsx(S9, { ...H, children: /* @__PURE__ */ a.jsxs(
      "form",
      {
        className: "twp flex flex-col",
        onSubmit: Q(se),
        children: [
          /* @__PURE__ */ a.jsxs(Mv, { children: [
            /* @__PURE__ */ a.jsxs(V8, { className: "group flex items-center justify-between px-[1.14286rem] py-[1.71429rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "상품 정보" }),
              /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.85714rem]", children: [
                /* @__PURE__ */ a.jsxs("span", { className: "flex items-start gap-[0.28571rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "총 결제금액" }),
                  /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b text-mshop-gray-50", children: m.payment.price.toLocaleString(cr.Ko) }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-gray-50", children: zs(m.payment.currency) })
                  ] }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "/ 월간" })
                ] }),
                /* @__PURE__ */ a.jsx(gY, { className: "size-[1.14286rem] group-data-[open]:rotate-180" })
              ] })
            ] }),
            /* @__PURE__ */ a.jsx(
              w2,
              {
                id: "membership-payment-product-info",
                className: "flex flex-col px-[1.4286rem] pb-[1.71429rem]",
                children: /* @__PURE__ */ a.jsx(
                  QB,
                  {
                    onShopButtonClick: e.onShopButtonClick
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ a.jsx(Bj, {}),
          /* @__PURE__ */ a.jsxs(Mv, { defaultOpen: !0, children: [
            /* @__PURE__ */ a.jsx(zj, { children: "주문자 정보" }),
            /* @__PURE__ */ a.jsx(
              w2,
              {
                id: "membership-payment-orderer-info",
                className: "flex flex-col gap-[1.71429rem] px-[1.4286rem] py-[1.71429rem]",
                children: /* @__PURE__ */ a.jsx(
                  VB,
                  {
                    errors: K,
                    register: q,
                    onAccountSettingsButtonClick: e.onAccountSettingsButtonClick
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ a.jsx(Bj, {}),
          /* @__PURE__ */ a.jsxs(Mv, { defaultOpen: !0, children: [
            /* @__PURE__ */ a.jsx(zj, { children: "총 주문 금액" }),
            /* @__PURE__ */ a.jsx(w2, { className: "flex flex-col px-[1.14286rem] py-[1.71429rem]", children: /* @__PURE__ */ a.jsx($B, {}) })
          ] }),
          /* @__PURE__ */ a.jsx(Bj, {}),
          /* @__PURE__ */ a.jsxs(Mv, { defaultOpen: !0, children: [
            /* @__PURE__ */ a.jsx(zj, { children: "결제 방법 선택" }),
            /* @__PURE__ */ a.jsx(w2, { className: "flex flex-col px-[1.14286rem] pb-[1.71429rem]", children: /* @__PURE__ */ a.jsx(
              YB,
              {
                payMethod: y,
                openPayMethodModal: () => s(!0),
                membershipPayMethodType: U,
                setMembershipPayMethodType: z
              }
            ) })
          ] }),
          /* @__PURE__ */ a.jsx(Bj, {}),
          /* @__PURE__ */ a.jsxs(Mv, { defaultOpen: !0, children: [
            /* @__PURE__ */ a.jsx(zj, { children: "결제 동의" }),
            /* @__PURE__ */ a.jsx(w2, { className: "flex flex-col px-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
              GB,
              {
                isAgreed: t,
                membershipPaymentType: m.payment.type,
                onIsAgreedChange: n,
                onClickPrivacy: e.onClickPrivacy,
                onClickTerms: e.onClickTerms
              }
            ) })
          ] }),
          /* @__PURE__ */ a.jsx("div", { className: "mt-[1.71429rem] p-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
            uh,
            {
              theme: "blue",
              type: "submit",
              disabled: D,
              widthFull: !0,
              children: "결제하기"
            }
          ) })
        ]
      }
    ) }),
    T && o && /* @__PURE__ */ a.jsxs(
      "main",
      {
        id: "membership-payment-completed",
        className: "twp flex flex-col items-center justify-center gap-[1.71429rem] py-[2.28571rem]",
        children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center gap-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "size-[6.85714rem]", children: /* @__PURE__ */ a.jsx(
              "img",
              {
                alt: "",
                src: kt.KeyVisual.MembershipMeetFan,
                className: "size-[6.85714rem] object-cover"
              }
            ) }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-center text-mshop-black", children: `${k.displayName}님!` }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-center text-mshop-black", children: "멤버십 가입이 완료되었습니다." }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-center text-mshop-black", children: "멤버십 카드를 다운로드해 보세요." })
              ] }),
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m whitespace-pre text-center text-mshop-gray-50", children: `멤버십 회원을 인증할 수 있는 카드를 준비했어요.
지금 바로 다운로드해서 친구들과 공유해 보세요! ` })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "relative isolate h-[19.35714rem] w-[14.28571rem] overflow-hidden rounded-[1.14286rem] bg-mshop-white", children: [
            m.shop.coverImageUrl && /* @__PURE__ */ a.jsx("div", { className: "absolute size-full", children: /* @__PURE__ */ a.jsx(
              "img",
              {
                alt: "",
                className: "h-[19.35714rem] w-[14.28571rem] object-cover",
                src: m.shop.coverImageUrl
              }
            ) }),
            /* @__PURE__ */ a.jsxs("div", { className: "absolute flex size-full flex-col items-center gap-[0.85714rem] bg-mshop-dim-30 p-[1.14286rem] backdrop-blur-[30px]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "isolate size-[3.85714rem] overflow-hidden rounded-full", children: /* @__PURE__ */ a.jsx(
                "img",
                {
                  alt: "",
                  className: "h-[3.85714rem] w-[3.85714rem] object-cover",
                  src: m.shop.profileImageUrl ?? kt.Common.CreatorProfileDefaultGray
                }
              ) }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-b line-clamp-1 break-words text-center text-mshop-white", children: m.displayName }),
                /* @__PURE__ */ a.jsxs("span", { className: "flex", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-b text-mshop-white", children: jt(Date.now(), "yyyy. MM. dd") }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-b text-mshop-bright-70", children: "부터" })
                ] }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-b text-mshop-bright-70", children: "가입한 팬이에요!" })
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "isolate size-[4.57143rem] overflow-hidden rounded-[0.57143rem]", children: /* @__PURE__ */ a.jsx(
                aa,
                {
                  height: "4.57143rem",
                  width: "4.57143rem",
                  src: m.thumbnailImage.url
                }
              ) }),
              /* @__PURE__ */ a.jsxs(
                "button",
                {
                  type: "button",
                  className: "flex items-center gap-[0.57143rem] rounded-[0.57143rem] bg-mshop-bright-20 px-[1.14286rem] py-[0.57143rem]",
                  disabled: I,
                  onClick: pe,
                  children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-white", children: "다운로드" }),
                    /* @__PURE__ */ a.jsx(Y8, { className: "size-[1.14286rem] shrink-0 text-mshop-white" })
                  ]
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsx(
              fn,
              {
                theme: "white",
                variant: "lg",
                widthFull: !0,
                type: "button",
                onClick: e.onGoToCreatorHomeButtonClick,
                children: "크리에이터 샵 가기"
              }
            ),
            /* @__PURE__ */ a.jsx(
              fn,
              {
                theme: "blue",
                variant: "lg",
                widthFull: !0,
                type: "button",
                onClick: () => e.onCheckMembershipInfoButtonClick(m.id),
                children: "멤버십 정보 확인"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(
      Z8,
      {
        show: r,
        isMobile: T,
        onClose: () => s(!1),
        onRegister: ce,
        registeredPayMethod: y,
        onClickThirdPartyConsent: e.onClickThirdPartyConsent,
        onClickInicisTerms: e.onClickInicisTerms,
        onClickPersonalInfoOutsourcing: e.onClickPersonalInfoOutsourcing
      }
    ),
    /* @__PURE__ */ a.jsx(
      iq,
      {
        ref: u,
        thumbnailImageUrl: m.thumbnailImage.url,
        displayName: m.displayName,
        user: k,
        memberSince: `${jt(Date.now(), "yyyy. MM. dd")} ~ ${Z}`,
        shopUrl: m.shop.url ?? "",
        shopName: Ef(m.shop)
      }
    )
  ] });
}
function BSe({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  projectId: s,
  membershipId: o,
  onGoToCreatorHomeButtonClick: c,
  onCheckMembershipInfoButtonClick: u,
  onAccountSettingsButtonClick: m,
  onClickPrivacy: y,
  onClickTerms: b,
  onPaySuccess: w,
  onError: k,
  onClickPersonalInfoOutsourcing: j,
  onClickThirdPartyConsent: E,
  onClickInicisTerms: T,
  onScrollLock: D,
  onShopButtonClick: L,
  onMembershipCardDownloadButtonClick: I,
  onSignedUpLimitReachedAlertButtonClick: R
}) {
  const [U, z] = Re(!0), [H, K] = Re(null), [q, Q] = Re(null), [Z, X] = Re(null);
  return an(() => {
    (async () => {
      const [se, te, fe] = await Promise.all([
        Q8({ client: e, onError: k }),
        vxe(
          {
            membershipId: o
          },
          {
            client: e,
            onError: k
          }
        ),
        g6({
          client: e,
          onError: k
        })
      ]);
      if (se.code !== le.Success || fe.code !== le.Success || te.code !== le.Success)
        return k(Ht);
      Q(te.data), K(fe.data), X(se.data), z(!1);
    })();
  }, []), U || !q || !Z ? null : /* @__PURE__ */ a.jsx(
    zSe,
    {
      client: e,
      isMobile: t,
      isApp: n,
      toggleSpinner: r,
      projectId: s,
      payMethod: H,
      membership: q,
      me: Z,
      onGoToCreatorHomeButtonClick: c,
      onCheckMembershipInfoButtonClick: u,
      onAccountSettingsButtonClick: m,
      onClickPrivacy: y,
      onClickTerms: b,
      onPaySuccess: w,
      onError: k,
      onClickPersonalInfoOutsourcing: j,
      onClickThirdPartyConsent: E,
      onClickInicisTerms: T,
      onScrollLock: D,
      onShopButtonClick: L,
      onMembershipCardDownloadButtonClick: I,
      onSignedUpLimitReachedAlertButtonClick: R
    }
  );
}
class Uje extends Ol {
  constructor({
    projectId: t,
    membershipId: n,
    onGoToCreatorHomeButtonClick: r,
    onCheckMembershipInfoButtonClick: s,
    onAccountSettingsButtonClick: o,
    onClickPrivacy: c,
    onClickTerms: u,
    onPaySuccess: m,
    onClickPersonalInfoOutsourcing: y,
    onClickThirdPartyConsent: b,
    onClickInicisTerms: w,
    onShopButtonClick: k,
    onMembershipCardDownloadButtonClick: j,
    onSignedUpLimitReachedAlertButtonClick: E,
    ...T
  }) {
    super(T), this.render = (D) => go(D).render(
      /* @__PURE__ */ a.jsx(
        BSe,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          projectId: this.projectId,
          membershipId: this.membershipId,
          onGoToCreatorHomeButtonClick: this.onGoToCreatorHomeButtonClick,
          onCheckMembershipInfoButtonClick: this.onCheckMembershipInfoButtonClick,
          onAccountSettingsButtonClick: this.onAccountSettingsButtonClick,
          onClickPrivacy: this.onClickPrivacy,
          onClickTerms: this.onClickTerms,
          onPaySuccess: this.onPaySuccess,
          onError: this.onError,
          onClickInicisTerms: this.onClickInicisTerms,
          onClickPersonalInfoOutsourcing: this.onClickPersonalInfoOutsourcing,
          onClickThirdPartyConsent: this.onClickThirdPartyConsent,
          onScrollLock: this.onScrollLock,
          onShopButtonClick: this.onShopButtonClick,
          onMembershipCardDownloadButtonClick: this.onMembershipCardDownloadButtonClick,
          onSignedUpLimitReachedAlertButtonClick: this.onSignedUpLimitReachedAlertButtonClick
        }
      )
    ), this.projectId = t, this.membershipId = n, this.onGoToCreatorHomeButtonClick = r, this.onCheckMembershipInfoButtonClick = s, this.onAccountSettingsButtonClick = o, this.onClickPrivacy = c, this.onClickTerms = u, this.onPaySuccess = m, this.onClickPersonalInfoOutsourcing = y, this.onClickThirdPartyConsent = b, this.onClickInicisTerms = w, this.onShopButtonClick = k, this.onMembershipCardDownloadButtonClick = j, this.onSignedUpLimitReachedAlertButtonClick = E;
  }
}
const HSe = async (e, t) => jn(
  "/delete-pay-method",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.AlreadyMembershipSubscription:
    case le.NotRegisteredPayment:
      return n;
    default:
      throw new Error("postDeletePayMethod");
  }
});
function VSe({
  show: e,
  onClose: t,
  onMoveMyPageMembershipSupportPage: n,
  ...r
}) {
  const s = Rt(null), { panelRef: o, container: c, handleMouseDown: u } = zO({
    show: e,
    onClose: t
  });
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: po.createPortal(
    /* @__PURE__ */ a.jsx(vO, { ...r, show: e, children: /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: "twp relative",
        style: {
          zIndex: Tc.GLOBAL.MODAL
        },
        children: [
          /* @__PURE__ */ a.jsx("div", { className: $("fixed inset-0 bg-mshop-dim-60") }),
          /* @__PURE__ */ a.jsx(AE, { children: /* @__PURE__ */ a.jsx(
            "div",
            {
              ref: s,
              className: "flex-center fixed inset-0",
              onMouseDown: u,
              children: /* @__PURE__ */ a.jsx("div", { ref: o, children: /* @__PURE__ */ a.jsxs("div", { className: "flex-center w-[24.49142rem] flex-col gap-y-[2.28571rem] rounded-[1.14286rem] bg-mshop-white px-[1.71429rem] pb-[1.71429rem] pt-[2.57143rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex flex-col gap-y-[0.85714rem]", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 수단 삭제 불가" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                    "해당 수단은 정기 결제 수단으로 설정되어 있어요.",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "가입 중인 멤버십을 해지하고 다시 시도해 주세요."
                  ] }),
                  /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      className: "typo-mshop-kr-14-m w-fit text-mshop-blue-100 underline underline-offset-4",
                      type: "button",
                      onClick: () => {
                        n(), t();
                      },
                      children: "멤버십 가입 내역 확인"
                    }
                  )
                ] }),
                /* @__PURE__ */ a.jsx(
                  "button",
                  {
                    type: "button",
                    className: "typo-mshop-kr-16-b w-full rounded-[.57142rem] bg-mshop-blue-100 px-[1.71428rem] py-[1.14285rem] text-center text-mshop-white",
                    onClick: t,
                    children: "확인"
                  }
                )
              ] }) })
            }
          ) })
        ]
      }
    ) }),
    c
  ) });
}
function $Se({ onError: e, onScrollLock: t, ...n }) {
  Al([
    [ol, n.client],
    [
      ll,
      {
        isMobile: n.isMobile,
        isApp: n.isApp,
        toggleSpinner: n.toggleSpinner,
        onError: e,
        onScrollLock: t
      }
    ],
    [m5, n.payMethod]
  ]);
  const { client: r } = Ha(), { payMethod: s, setPayMethod: o } = xw(), {
    widgetCore: { isMobile: c }
  } = Gt(), [u, m] = Re(!1), [
    y,
    b
  ] = Re(!1), w = (j) => {
    o(j), m(!1);
  }, k = async () => {
    if (wt(s), !await ho({
      body: (T, D) => /* @__PURE__ */ a.jsx(
        D3,
        {
          confirmButton: {
            props: T,
            text: "삭제"
          },
          cancelButton: {
            props: D
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem] text-center", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 수단 삭제" }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "등록된 결제 수단을 삭제하시겠습니까?" })
          ] })
        }
      )
    }))
      return;
    n.toggleSpinner(!0);
    const { code: E } = await HSe(
      {
        payMethodId: s.id
      },
      {
        client: r,
        onError: e
      }
    );
    if (n.toggleSpinner(!1), E === le.Success)
      await en({
        body: (T) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: T
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem] text-center", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 수단 삭제 완료" }),
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "결제 수단이 삭제되었습니다." })
            ] })
          }
        )
      }), o(null);
    else if (E === le.AlreadyMembershipSubscription)
      b(!0);
    else if (E === le.NotRegisteredPayment) {
      await en({
        body: (L) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: L
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem] text-center", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "결제 수단 삭제 불가" }),
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "해당 결제 수단은 이미 삭제 또는 변경되었습니다." })
            ] })
          }
        )
      });
      const { code: T, data: D } = await g6({
        client: r,
        onError: e
      });
      if (T !== le.Success)
        return e(Ht);
      o(D);
    } else
      e(Ht);
  };
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      id: "my-page-pay-method",
      className: $(
        "twp flex flex-col items-center",
        c ? "py-[8.57143rem]" : "py-[11.42857rem]"
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "flex w-full flex-col items-center",
              c ? "gap-y-[1.714rem]" : "max-w-[34.286rem] gap-y-[2.28571rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx("div", { className: c ? "size-[8.57143rem]" : "size-[12.857rem]", children: /* @__PURE__ */ a.jsx(
                "img",
                {
                  src: kt.Common.ImageCard,
                  className: "size-full",
                  alt: ""
                }
              ) }),
              c ? /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col gap-y-[0.57143rem] px-[1.14286rem] pb-[1.71429rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-16-b", children: "결제 수단" }),
                  s && /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      className: "typo-mshop-kr-14-m text-mshop-blue-100",
                      onClick: () => {
                        m(!0);
                      },
                      type: "button",
                      children: "결제 수단 변경"
                    }
                  )
                ] }),
                s === null ? /* @__PURE__ */ a.jsx(
                  WD,
                  {
                    variant: "add",
                    onAddClick: () => {
                      m(!0);
                    }
                  }
                ) : /* @__PURE__ */ a.jsx(
                  WD,
                  {
                    variant: "creditCard",
                    paymentMethod: s,
                    onRemoveClick: k
                  }
                ),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "현재 결제 수단은 멤버십/커미션/후원 결제만 지원합니다." })
              ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col gap-y-[1.143rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: "결제 수단 관리" }),
                  s && /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      className: "typo-mshop-kr-16-m text-mshop-blue-100",
                      onClick: () => {
                        m(!0);
                      },
                      type: "button",
                      children: "결제 수단 변경"
                    }
                  )
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem]", children: [
                  s === null ? /* @__PURE__ */ a.jsx(
                    $2,
                    {
                      variant: "add",
                      onAddClick: () => {
                        m(!0);
                      }
                    }
                  ) : /* @__PURE__ */ a.jsx(
                    $2,
                    {
                      variant: "creditCard",
                      paymentMethod: s,
                      onRemoveClick: k
                    }
                  ),
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-m text-mshop-gray-50", children: "현재 결제 수단은 멤버십/커미션/후원 결제만 지원합니다." })
                ] })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsx(
          Z8,
          {
            isMobile: c,
            show: u,
            registeredPayMethod: s,
            onRegister: w,
            onClose: () => {
              m(!1);
            },
            onClickThirdPartyConsent: n.onClickThirdPartyConsent,
            onClickInicisTerms: n.onClickInicisTerms,
            onClickPersonalInfoOutsourcing: n.onClickPersonalInfoOutsourcing
          }
        ),
        /* @__PURE__ */ a.jsx(
          VSe,
          {
            show: y,
            onClose: () => {
              b(!1);
            },
            onMoveMyPageMembershipSupportPage: n.onMoveMyPageMembershipSupportPage
          }
        )
      ]
    }
  );
}
const GSe = X2();
function WSe({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  onMoveMyPageMembershipSupportPage: s,
  onClickPersonalInfoOutsourcing: o,
  onClickThirdPartyConsent: c,
  onClickInicisTerms: u,
  onError: m,
  onScrollLock: y
}) {
  const [b, w] = Re(!0), [k, j] = Re(null);
  return an(() => {
    (async () => {
      const E = await g6({
        client: e,
        onError: m
      });
      if (E.code !== le.Success)
        return m(Ht);
      j(E.data), w(!1);
    })();
  }, []), b ? null : /* @__PURE__ */ a.jsx(lw, { store: GSe, children: /* @__PURE__ */ a.jsx(
    $Se,
    {
      client: e,
      isMobile: t,
      isApp: n,
      toggleSpinner: r,
      onError: m,
      payMethod: k,
      onMoveMyPageMembershipSupportPage: s,
      onClickPersonalInfoOutsourcing: o,
      onClickThirdPartyConsent: c,
      onClickInicisTerms: u,
      onScrollLock: y
    }
  ) });
}
class zje extends Ol {
  constructor({
    onMoveMyPageMembershipSupportPage: t,
    onClickPersonalInfoOutsourcing: n,
    onClickThirdPartyConsent: r,
    onClickInicisTerms: s,
    ...o
  }) {
    super(o), this.render = (c) => go(c).render(
      /* @__PURE__ */ a.jsx(
        WSe,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onError: this.onError,
          onScrollLock: this.onScrollLock,
          onMoveMyPageMembershipSupportPage: this.onMoveMyPageMembershipSupportPage,
          onClickInicisTerms: this.onClickInicisTerms,
          onClickPersonalInfoOutsourcing: this.onClickPersonalInfoOutsourcing,
          onClickThirdPartyConsent: this.onClickThirdPartyConsent
        }
      )
    ), this.onMoveMyPageMembershipSupportPage = t, this.onClickPersonalInfoOutsourcing = n, this.onClickThirdPartyConsent = r, this.onClickInicisTerms = s;
  }
}
const YSe = async (e, t) => jn(
  "/support-payment",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error("postSupportPayment");
  }
});
async function oq(e, t) {
  return jn("/user", { body: e }, t).then(
    (n) => {
      switch (n.code) {
        case le.Success:
        case le.TokenExpired:
          return n;
        default:
          throw new Error();
      }
    }
  );
}
const kw = (e, t) => jn(
  "/payment-receipt",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), AA = async (e, t) => jn(
  "/refund-payment",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.NoRefundItems:
    case le.AlreadyCancelledInfo:
      return n;
    default:
      throw new Error("postRefundPayment");
  }
}), qSe = async (e, t) => jn(
  "/refund-support",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.NoRefundItems:
    case le.AlreadyCancelledInfo:
      return n;
    default:
      throw new Error("postRefundSupport");
  }
}), S1 = {
  Paid: "PAID",
  Cancelled: "CANCELLED"
}, lq = Qt(
  Vn
), cq = Qt(null), uq = Qt(null), dq = () => {
  const [e, t] = Ar(uq);
  return {
    paymentReceipt: e,
    setPaymentReceipt: t
  };
}, KSe = () => {
  const [e, t] = Ar(lq);
  if (e === Vn)
    throw new Error(Xr(ia.SupportPayment));
  return {
    supportPayment: e,
    setSupportPayment: t
  };
}, eH = 608, tH = 720, E6 = (e) => {
  const t = (window.screen.height - tH) / 2, n = (document.body.offsetWidth - eH) / 2 + window.screenLeft;
  window.open(
    `${window.location.origin}/@/membership/receipt/${e}`,
    "_blank",
    `scrollbars=1,menubar=1,width=${eH},height=${tH},top=${t},left=${n}`
  );
}, XSe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_11381_99432)" }, /* @__PURE__ */ re.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.25 16.88C13.25 17.57 12.69 18.13 12 18.13C11.31 18.13 10.75 17.57 10.75 16.88V11.63C10.75 10.94 11.31 10.38 12 10.38C12.69 10.38 13.25 10.94 13.25 11.63V16.88ZM12 8.38C11.31 8.38 10.75 7.82 10.75 7.13C10.75 6.44 11.31 5.88 12 5.88C12.69 5.88 13.25 6.44 13.25 7.13C13.25 7.82 12.69 8.38 12 8.38Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_11381_99432" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), l_ = yn(XSe), $g = {
  Card: "CARD",
  Naverpay: "NAVERPAY",
  KakaoPay: "KAKAOPAY",
  Tosspay: "TOSSPAY",
  Samsungpay: "SAMSUNGPAY"
}, c_ = {
  [$g.Card]: "신용카드",
  [$g.Naverpay]: "네이버페이",
  [$g.KakaoPay]: "카카오페이",
  [$g.Tosspay]: "토스페이",
  [$g.Samsungpay]: "삼성페이"
}, QSe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_1740_192141)" }, /* @__PURE__ */ re.createElement("path", { d: "M11.88 20.88C11.66 20.88 11.43 20.79 11.26 20.62L3.26 12.62C3.18 12.54 3.11 12.44 3.07 12.33C3.03 12.23 3.01 12.13 3 12.02V11.99C3 11.88 3.03 11.77 3.07 11.68C3.11 11.57 3.18 11.48 3.26 11.39L11.26 3.38C11.6 3.04 12.16 3.04 12.5 3.38C12.84 3.72 12.84 4.28 12.5 4.62L5.99 11.13H20.13C20.61 11.13 21.01 11.52 21.01 12.01C21.01 12.5 20.62 12.89 20.13 12.89H5.99L12.5 19.4C12.84 19.74 12.84 20.3 12.5 20.64C12.33 20.81 12.1 20.9 11.88 20.9V20.88Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_1740_192141" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), ZSe = yn(QSe), JSe = "4.28571rem";
function LA(e) {
  return /* @__PURE__ */ a.jsxs(
    "header",
    {
      className: $(
        "relative flex items-center px-[1.14286rem]",
        {
          "justify-end": e.variant === "Text+Close"
        },
        {
          "bg-mshop-white": e.theme === "Light"
        }
      ),
      style: {
        height: JSe
      },
      children: [
        e.variant === "Back+Title" && /* @__PURE__ */ a.jsx("button", { type: "button", onClick: e.onBackButtonClick, children: /* @__PURE__ */ a.jsx(
          ZSe,
          {
            className: $("size-[1.71429rem]", {
              "text-mshop-black": e.theme === "Light"
            })
          }
        ) }),
        (e.variant === "Title" || e.variant === "Back+Title" || e.variant === "Text+Close") && /* @__PURE__ */ a.jsx(
          "span",
          {
            className: $(
              "typo-mshop-kr-16-b absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
              {
                "text-mshop-black": e.theme === "Light"
              }
            ),
            children: e.title
          }
        ),
        e.variant === "Text+Close" && /* @__PURE__ */ a.jsx("button", { type: "button", onClick: e.onCloseButtonClick, children: /* @__PURE__ */ a.jsx(
          Zg,
          {
            className: $("size-[1.71429rem]", {
              "text-mshop-black": e.theme === "Light"
            })
          }
        ) })
      ]
    }
  );
}
function k6(e) {
  var n;
  const t = ((n = e.paymentDetails) == null ? void 0 : n.cancelledAmount) !== null;
  return /* @__PURE__ */ a.jsx(dh, { variant: "TYPE02", show: e.show, onClose: e.onClose, children: e.paymentRecord && e.business && e.paymentDetails && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(
      LA,
      {
        variant: "Text+Close",
        theme: "Light",
        title: "결제 영수증",
        onCloseButtonClick: e.onClose
      }
    ),
    /* @__PURE__ */ a.jsxs("main", { className: "flex flex-col gap-[1.71428rem] overflow-y-auto px-[1.14285rem] pb-[2.28571rem] pt-[1.14285rem]", children: [
      t && /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[.42857rem] rounded-[.65305rem] bg-mshop-red-10 p-[1.14285rem]", children: [
        /* @__PURE__ */ a.jsx(l_, { className: "size-[1.42857rem] text-mshop-red-80" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-red-80", children: "취소된 결제입니다." })
      ] }),
      /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[0.85714rem] border-b border-mshop-gray-5 pb-[1.71428rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "결제 정보" }),
        e.paymentRecord.payMethod === $g.Card && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex items-start justify-between", children: e.paymentRecord.approvalNumber === null ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "카드사" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: e.paymentRecord.cardName })
          ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "카드사 / 승인번호" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: `${e.paymentRecord.cardName} / ${e.paymentRecord.approvalNumber}` })
          ] }) }),
          e.paymentRecord.cardNumber && /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "카드번호" }),
            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: [
              "****-****-****-",
              e.paymentRecord.cardNumber.slice(-4)
            ] })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "거래종류/할부" }),
          /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.28571rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: e.paymentRecord.payMethod === $g.Card ? "신용(개인)" : c_[e.paymentRecord.payMethod] }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: "/" }),
            /* @__PURE__ */ a.jsx("span", {
              className: "typo-mshop-kr-14-m text-mshop-black",
              // https://ciety.xyz/@ciety-work/channels/1286?channelType=CHAT&highlightId=29160
              children: `${e.paymentRecord.cardQuota === 0 ? "일시불" : `할부 (${e.paymentRecord.cardQuota}개월)`}${t ? " 취소" : ""}`
            })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "결제일자" }),
          /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[.28571rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: jt(e.paymentRecord.paidAt, "yyyy.MM.dd") }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: jt(e.paymentRecord.paidAt, "HH:mm:ss") })
          ] })
        ] }),
        e.paymentRecord.cancelledAt && /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "취소일자" }),
          /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[.28571rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: jt(e.paymentRecord.cancelledAt, "yyyy.MM.dd") }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: jt(e.paymentRecord.cancelledAt, "HH:mm:ss") })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "구매자명" }),
          e.paymentRecord.username && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: e.paymentRecord.username })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "상품명" }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: e.paymentRecord.productName })
        ] }),
        e.target === "MEMBERSHIP" && e.startTimeAt && e.endTimeAt && /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "이용 기간" }),
          /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[.28571rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: jt(e.startTimeAt, "yyyy.MM.dd") }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: "~" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: jt(e.endTimeAt, "yyyy.MM.dd") })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "구매번호" }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: e.paymentRecord.paymentNo })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "상품번호" }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: e.paymentRecord.paymentProductNo })
        ] })
      ] }),
      /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[0.85714rem] border-b border-mshop-gray-5 pb-[1.71428rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-black", children: "판매자 정보" }),
        [
          ["상호", e.business.businessName],
          ["대표자명", e.business.representative],
          ["사업자등록번호", e.business.corporateRegistrationNum],
          ["전화번호", e.business.phoneNum],
          ["사업장주소", e.business.address]
        ].map(([r, s]) => /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m w-[8.57143rem] shrink-0 text-mshop-gray-50", children: r }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-right text-mshop-black", children: s })
        ] }, r))
      ] }),
      /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[0.85714rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-black", children: "금액" }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "승인금액" }),
          /* @__PURE__ */ a.jsxs("span", { children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: e.paymentDetails.approvedAmount.toLocaleString(
              cr.Ko
            ) }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: zs(e.paymentDetails.currency) })
          ] })
        ] }),
        [
          t ? [
            "취소금액",
            `-${e.paymentDetails.approvedAmount.toLocaleString(
              cr.Ko
            )}`
          ] : [],
          [
            "공급가액",
            `${t ? "-" : ""}${e.paymentDetails.supplyAmount.toLocaleString(cr.Ko)}`
          ],
          [
            "부가세액",
            `${t ? "-" : ""}${e.paymentDetails.tax.toLocaleString(cr.Ko)}`
          ]
        ].map(
          ([r, s]) => r && /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: r }),
            /* @__PURE__ */ a.jsxs("span", { children: [
              /* @__PURE__ */ a.jsx(
                "span",
                {
                  className: $("typo-mshop-kr-14-m", {
                    "text-mshop-red-80": t
                  }),
                  children: s
                }
              ),
              /* @__PURE__ */ a.jsx(
                "span",
                {
                  className: $("typo-mshop-kr-14-m", {
                    "text-mshop-red-80": t
                  }),
                  children: zs(e.paymentDetails.currency)
                }
              )
            ] })
          ] }, r)
        ),
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-gray-80", children: t ? "취소 금액 합계" : "합계" }),
          /* @__PURE__ */ a.jsxs("span", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: $("typo-mshop-en-20-unica-b", {
                  "text-mshop-red-80": t
                }),
                children: `${t ? "-" : ""}${parseInt(
                  e.paymentDetails.total,
                  10
                ).toLocaleString(cr.Ko)}`
              }
            ),
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: $("typo-mshop-kr-20-b", {
                  "text-mshop-red-80": t
                }),
                children: zs(e.paymentDetails.currency)
              }
            )
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ a.jsx("footer", { className: "border-t border-mshop-gray-5 bg-mshop-white px-[1.14285rem] pb-[calc(env(safe-area-inset-bottom)+1.14285rem)] pt-[1.14285rem]", children: /* @__PURE__ */ a.jsx(
      uh,
      {
        theme: "blue",
        type: "button",
        widthFull: !0,
        disabled: !0,
        children: "영수증 인쇄는 PC에서 가능합니다"
      }
    ) })
  ] }) });
}
const nH = 1376, e8e = 832, t8e = 496;
function n8e({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  projectId: s,
  user: o,
  onGoBackToMembershipSupportListButtonClick: c,
  onContactButtonClick: u,
  onScrollLock: m,
  onError: y,
  onShopButtonClick: b,
  ...w
}) {
  Al([
    [ol, e],
    [
      ll,
      {
        isMobile: t,
        isApp: n,
        toggleSpinner: r,
        onError: y,
        onScrollLock: m
      }
    ],
    [R1, s],
    [cq, o],
    [lq, w.supportPayment]
  ]);
  const [k, j] = Re(!1), [E, T] = Re(!1), { widgetCore: D } = Gt(), L = Ha(), { paymentReceipt: I, setPaymentReceipt: R } = dq(), U = Tf(), { supportPayment: z } = KSe(), { isDevMode: H } = f6(), K = async (Q) => {
    if (D.isMobile) {
      T(!0), D.toggleSpinner(!0);
      const Z = await kw(
        {
          paymentStatementId: Q
        },
        {
          client: L.client,
          onError: D.onError
        }
      );
      if (T(!1), D.toggleSpinner(!1), Z.code !== le.Success)
        return D.onError(Ht);
      R(Z.data), j(!0);
    } else
      E6(Q);
  }, q = () => {
    const {
      support: { shop: Q }
    } = z;
    Q && b(Q.url);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "section",
      {
        id: "my-page-support-detail",
        className: $("twp w-full text-mshop-black", {
          "px-[1.142rem]": t
        }),
        children: [
          !t && /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: "후원 메시지" }),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "pt-[1.143rem]",
                {
                  "flex justify-between": !t
                },
                {
                  "flex flex-col gap-y-[3.43rem]": t
                }
              ),
              children: [
                /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    style: t ? {} : {
                      width: `calc((${e8e}/${nH}) * 100%)`
                    },
                    children: [
                      /* @__PURE__ */ a.jsxs(
                        "button",
                        {
                          type: "button",
                          onClick: q,
                          className: "flex w-full items-center gap-x-[0.286rem] border-b border-mshop-black pb-[0.857rem]",
                          children: [
                            /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b line-clamp-1 text-start", children: Ef(z.support.shop) }),
                            /* @__PURE__ */ a.jsx(ch, { className: "size-[1.429rem] text-mshop-black" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ a.jsxs(
                        "div",
                        {
                          className: $(
                            "pt-[1.143rem]",
                            {
                              "flex items-center justify-between gap-x-[1.143rem]": !t
                            },
                            {
                              "flex flex-col gap-y-[0.86rem]": t
                            }
                          ),
                          children: [
                            /* @__PURE__ */ a.jsxs(
                              "div",
                              {
                                className: $(
                                  "flex w-full items-center",
                                  { "gap-x-[0.857rem]": !t },
                                  { "gap-x-[1.14rem]": t }
                                ),
                                children: [
                                  /* @__PURE__ */ a.jsx(
                                    "img",
                                    {
                                      src: z.support.thumbnailImage.url,
                                      className: "size-[7.14286rem] flex-shrink-0 rounded-[1.143rem] object-cover",
                                      alt: ""
                                    }
                                  ),
                                  /* @__PURE__ */ a.jsxs("div", { className: "w-[calc(100%-7.14286rem-0.857rem)] gap-y-[0.286rem]", children: [
                                    /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-m break-words", children: z.support.displayName }),
                                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "후원" }),
                                    /* @__PURE__ */ a.jsxs(
                                      "div",
                                      {
                                        className: $(
                                          "flex",
                                          { "items-start": !t },
                                          { "items-center": t }
                                        ),
                                        children: [
                                          /* @__PURE__ */ a.jsxs(
                                            "div",
                                            {
                                              className: $(
                                                "flex items-center gap-x-[0.286rem]",
                                                { "typo-mshop-en-16-unica-b": !t },
                                                { "typo-mshop-en-14-unica-b": t }
                                              ),
                                              children: [
                                                /* @__PURE__ */ a.jsx("span", { children: "Total" }),
                                                /* @__PURE__ */ a.jsx("span", { children: z.totalPrice.toLocaleString("ko") })
                                              ]
                                            }
                                          ),
                                          /* @__PURE__ */ a.jsx(
                                            "span",
                                            {
                                              className: $(
                                                {
                                                  "typo-mshop-kr-16-b": !t
                                                },
                                                { "typo-mshop-kr-14-b": t }
                                              ),
                                              children: "원"
                                            }
                                          )
                                        ]
                                      }
                                    )
                                  ] })
                                ]
                              }
                            ),
                            /* @__PURE__ */ a.jsx(
                              "div",
                              {
                                className: $(
                                  { "w-[10rem]": !t },
                                  { "w-full": t }
                                ),
                                children: /* @__PURE__ */ a.jsx(
                                  fn,
                                  {
                                    variant: "sm",
                                    theme: "line",
                                    widthFull: !0,
                                    type: "button",
                                    onClick: () => u(U.projectId),
                                    children: "후원 문의하기"
                                  }
                                )
                              }
                            )
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: "flex flex-col gap-y-[0.571rem]",
                    style: t ? {} : {
                      width: `calc((${t8e}/${nH}) * 100%)`
                    },
                    children: [
                      /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b border-b border-mshop-black pb-[0.857rem]", children: "결제 내역" }),
                      /* @__PURE__ */ a.jsxs(
                        "dl",
                        {
                          className: $(
                            "flex items-center py-[0.857rem]",
                            { "gap-x-[3.43rem]": !t },
                            { "gap-x-[1.14rem]": t }
                          ),
                          children: [
                            /* @__PURE__ */ a.jsx(
                              "dt",
                              {
                                className: $(
                                  "typo-mshop-kr-14-m text-mshop-gray-50",
                                  {
                                    "w-[9.143rem]": !t
                                  },
                                  {
                                    "w-[5.71rem]": t
                                  }
                                ),
                                children: "총 결제 금액"
                              }
                            ),
                            /* @__PURE__ */ a.jsxs("dd", { children: [
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-b", children: z.totalPrice.toLocaleString("ko") }),
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "원" })
                            ] })
                          ]
                        }
                      ),
                      /* @__PURE__ */ a.jsx("ul", { className: "flex flex-col gap-y-[0.571rem]", children: z.paymentStatements.map(
                        (Q, Z) => t ? /* @__PURE__ */ a.jsxs("li", { className: "flex py-[0.571rem]", children: [
                          /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m w-[5.71429rem] flex-shrink-0 text-mshop-gray-50", children: [
                            z.paymentStatements.length - Z,
                            "회차"
                          ] }),
                          /* @__PURE__ */ a.jsx("div", { className: "flex w-[calc(100%-5.71429rem-4.07rem)] pl-[1.14rem]", children: /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-en-14-unica-m flex w-full flex-col gap-y-[0.29rem]", children: [
                            /* @__PURE__ */ a.jsx("span", { children: jt(Q.paidAt, "yyyy.MM.dd HH:mm") }),
                            /* @__PURE__ */ a.jsxs("div", { className: "flex w-[13.7rem] flex-col items-start gap-y-[0.29rem]", children: [
                              /* @__PURE__ */ a.jsxs("div", { className: "flex items-center", children: [
                                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b", children: Q.price.toLocaleString("ko") }),
                                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "원" })
                              ] }),
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: Q.cardName })
                            ] })
                          ] }) }),
                          H ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-2 pl-[0.57rem]", children: [
                            /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                type: "button",
                                className: "typo-mshop-kr-12-m h-[1.78571rem] max-w-[3.5rem] flex-shrink-0 items-center rounded-[0.286rem] border border-mshop-gray-20 px-[0.571rem] py-[0.29rem] backdrop-blur-[20px]",
                                disabled: E,
                                onClick: () => K(Q.id),
                                children: "영수증"
                              }
                            ),
                            Q.paymentState === S1.Paid && /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                type: "button",
                                className: "typo-mshop-kr-12-m flex h-[1.78571rem] flex-shrink-0 items-center justify-center rounded-[0.286rem] border border-mshop-gray-20 px-[0.571rem] py-[0.29rem] backdrop-blur-[20px]",
                                disabled: E,
                                onClick: async () => {
                                  switch ((await qSe(
                                    { supportMessageId: Q.id },
                                    { client: e, onError: Gd }
                                  )).code) {
                                    case le.NoRefundItems:
                                      await en({
                                        body: (se) => /* @__PURE__ */ a.jsx(
                                          ea,
                                          {
                                            button: {
                                              props: se
                                            },
                                            children: /* @__PURE__ */ a.jsx("div", { children: "환불할 데이터가 없음" })
                                          }
                                        )
                                      });
                                      return;
                                    case le.AlreadyCancelledInfo:
                                      await en({
                                        body: (se) => /* @__PURE__ */ a.jsx(
                                          ea,
                                          {
                                            button: {
                                              props: se
                                            },
                                            children: /* @__PURE__ */ a.jsx("div", { children: "환불할 데이터가 없음" })
                                          }
                                        )
                                      });
                                      return;
                                    case le.TokenExpired:
                                      await en({
                                        body: (se) => /* @__PURE__ */ a.jsx(
                                          ea,
                                          {
                                            button: {
                                              props: se
                                            },
                                            children: /* @__PURE__ */ a.jsx("div", { children: "환불할 데이터가 없음" })
                                          }
                                        )
                                      });
                                      return;
                                  }
                                },
                                children: "취소"
                              }
                            )
                          ] }) : /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "typo-mshop-kr-12-m flex h-[1.78571rem] w-full flex-shrink-0 items-center rounded-[0.286rem] border border-mshop-gray-20 px-[0.571rem] py-[0.29rem] backdrop-blur-[20px]",
                              disabled: E,
                              onClick: () => K(Q.id),
                              children: "영수증"
                            }
                          )
                        ] }, Q.id) : /* @__PURE__ */ a.jsxs(
                          "li",
                          {
                            className: "flex items-center gap-x-[3.43rem] py-[0.571rem]",
                            children: [
                              /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m w-[9.14rem] flex-shrink-0 text-mshop-gray-50", children: [
                                z.paymentStatements.length - Z,
                                "회차"
                              ] }),
                              /* @__PURE__ */ a.jsxs("div", { className: "flex w-full items-center", children: [
                                /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-en-14-unica-m flex w-full flex-col gap-y-[0.571rem]", children: [
                                  /* @__PURE__ */ a.jsx("span", { children: jt(Q.paidAt, "yyyy.MM.dd HH:mm") }),
                                  /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.571rem]", children: [
                                    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center", children: [
                                      /* @__PURE__ */ a.jsx("span", { children: Q.price.toLocaleString("ko") }),
                                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "원" })
                                    ] }),
                                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-gray-10", children: "|" }),
                                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: Q.cardName })
                                  ] })
                                ] }),
                                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-1", children: [
                                  /* @__PURE__ */ a.jsx(
                                    "button",
                                    {
                                      type: "button",
                                      className: "typo-mshop-kr-12-m inline-flex h-[1.857rem] flex-shrink-0 items-center rounded-[0.286rem] border border-mshop-gray-20 px-[0.571rem] backdrop-blur-[20px]",
                                      disabled: E,
                                      onClick: () => K(Q.id),
                                      children: "영수증"
                                    }
                                  ),
                                  Q.paymentState === "PAID" && H && /* @__PURE__ */ a.jsx(
                                    "button",
                                    {
                                      type: "button",
                                      className: "typo-mshop-kr-12-m inline-flex h-[1.78571rem] flex-shrink-0 items-center rounded-[0.286rem] border border-mshop-gray-20 px-[0.571rem] py-[0.29rem] backdrop-blur-[20px]",
                                      disabled: E,
                                      onClick: async () => {
                                        switch ((await AA(
                                          { portonePaymentStatementId: Q.id },
                                          { client: e, onError: Gd }
                                        )).code) {
                                          case "000":
                                            await en({
                                              body: (se) => /* @__PURE__ */ a.jsx(
                                                ea,
                                                {
                                                  button: {
                                                    props: se
                                                  },
                                                  children: /* @__PURE__ */ a.jsx("div", { children: "환불 완료" })
                                                }
                                              )
                                            });
                                            return;
                                          case "018":
                                            await en({
                                              body: (se) => /* @__PURE__ */ a.jsx(
                                                ea,
                                                {
                                                  button: {
                                                    props: se
                                                  },
                                                  children: /* @__PURE__ */ a.jsx("div", { children: "환불할 데이터가 없음" })
                                                }
                                              )
                                            });
                                            return;
                                          case "019":
                                            await en({
                                              body: (se) => /* @__PURE__ */ a.jsx(
                                                ea,
                                                {
                                                  button: {
                                                    props: se
                                                  },
                                                  children: /* @__PURE__ */ a.jsx("div", { children: "이미 취소된 정보" })
                                                }
                                              )
                                            });
                                            return;
                                          case "001":
                                            await en({
                                              body: (se) => /* @__PURE__ */ a.jsx(
                                                ea,
                                                {
                                                  button: {
                                                    props: se
                                                  },
                                                  children: /* @__PURE__ */ a.jsx("div", { children: "token 만료" })
                                                }
                                              )
                                            });
                                            return;
                                        }
                                      },
                                      children: "결제 취소"
                                    }
                                  )
                                ] })
                              ] })
                            ]
                          },
                          Q.id
                        )
                      ) })
                    ]
                  }
                )
              ]
            }
          ),
          !t && /* @__PURE__ */ a.jsx("div", { className: "mt-6 flex justify-center", children: /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "md",
              theme: "blue",
              type: "button",
              onClick: c,
              children: "후원 내역으로 돌아가기"
            }
          ) })
        ]
      }
    ),
    t && /* @__PURE__ */ a.jsx(
      k6,
      {
        show: k,
        target: "SUPPORT",
        business: (I == null ? void 0 : I.business) ?? null,
        paymentDetails: (I == null ? void 0 : I.paymentDetails) ?? null,
        paymentRecord: (I == null ? void 0 : I.paymentRecord) ?? null,
        onClose: () => j(!1)
      }
    )
  ] });
}
function r8e({
  supportId: e,
  onGoBackToMembershipSupportListButtonClick: t,
  onContactButtonClick: n,
  onShopButtonClick: r,
  ...s
}) {
  const [o, c] = Re(!0), [u, m] = Re(null), [y, b] = Re(
    null
  );
  return an(() => {
    (async () => {
      c(!0);
      const [w, k] = await Promise.all([
        oq(
          {
            projectId: s.projectId
          },
          { client: s.client, onError: s.onError }
        ),
        YSe(
          {
            supportId: e
          },
          {
            client: s.client,
            onError: s.onError
          }
        )
      ]);
      if (w.code !== le.Success || k.code !== le.Success)
        return s.onError(Ht);
      m(w.data), b(k.data), c(!1);
    })();
  }, []), o || !u || !y ? null : /* @__PURE__ */ a.jsx(
    n8e,
    {
      ...s,
      user: u,
      supportPayment: y,
      onGoBackToMembershipSupportListButtonClick: t,
      onContactButtonClick: n,
      onShopButtonClick: r
    }
  );
}
class Bje extends Ol {
  constructor({
    projectId: t,
    supportId: n,
    onGoBackToMembershipSupportListButtonClick: r,
    onContactButtonClick: s,
    onShopButtonClick: o,
    ...c
  }) {
    super(c), this.render = (u) => go(u).render(
      /* @__PURE__ */ a.jsx(
        r8e,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onScrollLock: this.onScrollLock,
          projectId: this.projectId,
          supportId: this.supportId,
          onGoBackToMembershipSupportListButtonClick: this.onGoBackToMembershipSupportListButtonClick,
          onContactButtonClick: this.onContactButtonClick,
          onShopButtonClick: this.onShopButtonClick,
          onError: this.onError
        }
      )
    ), this.projectId = t, this.supportId = n, this.onGoBackToMembershipSupportListButtonClick = r, this.onContactButtonClick = s, this.onShopButtonClick = o;
  }
}
const a8e = (e, t) => jn(
  "/memberships",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), s8e = (e, t) => jn(
  "/project-cover",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
});
function i8e({ children: e }) {
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      className: "h-full w-full",
      style: {
        WebkitMaskImage: 'url("//s3.marpple.co/files/u_218933/2024/5/original/4dbeb505a99f381b35350b029c408df5bfdbe3f61.png")',
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskImage: 'url("//s3.marpple.co/files/u_218933/2024/5/original/4dbeb505a99f381b35350b029c408df5bfdbe3f61.png")',
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center"
      },
      children: e
    }
  );
}
function rH(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function IA(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {}), Object.keys(t).forEach((n) => {
    typeof e[n] > "u" ? e[n] = t[n] : rH(t[n]) && rH(e[n]) && Object.keys(t[n]).length > 0 && IA(e[n], t[n]);
  });
}
const fq = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function my() {
  const e = typeof document < "u" ? document : {};
  return IA(e, fq), e;
}
const o8e = {
  document: fq,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function Sp() {
  const e = typeof window < "u" ? window : {};
  return IA(e, o8e), e;
}
function l8e(e) {
  return e === void 0 && (e = ""), e.trim().split(" ").filter((t) => !!t.trim());
}
function c8e(e) {
  const t = e;
  Object.keys(t).forEach((n) => {
    try {
      t[n] = null;
    } catch {
    }
    try {
      delete t[n];
    } catch {
    }
  });
}
function lP(e, t) {
  return t === void 0 && (t = 0), setTimeout(e, t);
}
function tE() {
  return Date.now();
}
function u8e(e) {
  const t = Sp();
  let n;
  return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n;
}
function d8e(e, t) {
  t === void 0 && (t = "x");
  const n = Sp();
  let r, s, o;
  const c = u8e(e);
  return n.WebKitCSSMatrix ? (s = c.transform || c.webkitTransform, s.split(",").length > 6 && (s = s.split(", ").map((u) => u.replace(",", ".")).join(", ")), o = new n.WebKitCSSMatrix(s === "none" ? "" : s)) : (o = c.MozTransform || c.OTransform || c.MsTransform || c.msTransform || c.transform || c.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = o.toString().split(",")), t === "x" && (n.WebKitCSSMatrix ? s = o.m41 : r.length === 16 ? s = parseFloat(r[12]) : s = parseFloat(r[4])), t === "y" && (n.WebKitCSSMatrix ? s = o.m42 : r.length === 16 ? s = parseFloat(r[13]) : s = parseFloat(r[5])), s || 0;
}
function Hj(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function f8e(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function dp() {
  const e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < arguments.length; n += 1) {
    const r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (r != null && !f8e(r)) {
      const s = Object.keys(Object(r)).filter((o) => t.indexOf(o) < 0);
      for (let o = 0, c = s.length; o < c; o += 1) {
        const u = s[o], m = Object.getOwnPropertyDescriptor(r, u);
        m !== void 0 && m.enumerable && (Hj(e[u]) && Hj(r[u]) ? r[u].__swiper__ ? e[u] = r[u] : dp(e[u], r[u]) : !Hj(e[u]) && Hj(r[u]) ? (e[u] = {}, r[u].__swiper__ ? e[u] = r[u] : dp(e[u], r[u])) : e[u] = r[u]);
      }
    }
  }
  return e;
}
function n3(e, t, n) {
  e.style.setProperty(t, n);
}
function mq(e) {
  let {
    swiper: t,
    targetPosition: n,
    side: r
  } = e;
  const s = Sp(), o = -t.translate;
  let c = null, u;
  const m = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", s.cancelAnimationFrame(t.cssModeFrameID);
  const y = n > o ? "next" : "prev", b = (k, j) => y === "next" && k >= j || y === "prev" && k <= j, w = () => {
    u = (/* @__PURE__ */ new Date()).getTime(), c === null && (c = u);
    const k = Math.max(Math.min((u - c) / m, 1), 0), j = 0.5 - Math.cos(k * Math.PI) / 2;
    let E = o + j * (n - o);
    if (b(E, n) && (E = n), t.wrapperEl.scrollTo({
      [r]: E
    }), b(E, n)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [r]: E
        });
      }), s.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = s.requestAnimationFrame(w);
  };
  w();
}
function uy(e, t) {
  t === void 0 && (t = "");
  const n = [...e.children];
  return e instanceof HTMLSlotElement && n.push(...e.assignedElements()), t ? n.filter((r) => r.matches(t)) : n;
}
function m8e(e, t) {
  const n = t.contains(e);
  return !n && t instanceof HTMLSlotElement ? [...t.assignedElements()].includes(e) : n;
}
function nE(e) {
  try {
    console.warn(e);
    return;
  } catch {
  }
}
function L3(e, t) {
  t === void 0 && (t = []);
  const n = document.createElement(e);
  return n.classList.add(...Array.isArray(t) ? t : l8e(t)), n;
}
function h8e(e, t) {
  const n = [];
  for (; e.previousElementSibling; ) {
    const r = e.previousElementSibling;
    t ? r.matches(t) && n.push(r) : n.push(r), e = r;
  }
  return n;
}
function p8e(e, t) {
  const n = [];
  for (; e.nextElementSibling; ) {
    const r = e.nextElementSibling;
    t ? r.matches(t) && n.push(r) : n.push(r), e = r;
  }
  return n;
}
function R2(e, t) {
  return Sp().getComputedStyle(e, null).getPropertyValue(t);
}
function aH(e) {
  let t = e, n;
  if (t) {
    for (n = 0; (t = t.previousSibling) !== null; )
      t.nodeType === 1 && (n += 1);
    return n;
  }
}
function g8e(e, t) {
  const n = [];
  let r = e.parentElement;
  for (; r; )
    n.push(r), r = r.parentElement;
  return n;
}
function sH(e, t, n) {
  const r = Sp();
  return e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(r.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(r.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom"));
}
let TR;
function y8e() {
  const e = Sp(), t = my();
  return {
    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
  };
}
function hq() {
  return TR || (TR = y8e()), TR;
}
let MR;
function v8e(e) {
  let {
    userAgent: t
  } = e === void 0 ? {} : e;
  const n = hq(), r = Sp(), s = r.navigator.platform, o = t || r.navigator.userAgent, c = {
    ios: !1,
    android: !1
  }, u = r.screen.width, m = r.screen.height, y = o.match(/(Android);?[\s\/]+([\d.]+)?/);
  let b = o.match(/(iPad).*OS\s([\d_]+)/);
  const w = o.match(/(iPod)(.*OS\s([\d_]+))?/), k = !b && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/), j = s === "Win32";
  let E = s === "MacIntel";
  const T = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !b && E && n.touch && T.indexOf(`${u}x${m}`) >= 0 && (b = o.match(/(Version)\/([\d.]+)/), b || (b = [0, 1, "13_0_0"]), E = !1), y && !j && (c.os = "android", c.android = !0), (b || k || w) && (c.os = "ios", c.ios = !0), c;
}
function pq(e) {
  return e === void 0 && (e = {}), MR || (MR = v8e(e)), MR;
}
let RR;
function x8e() {
  const e = Sp(), t = pq();
  let n = !1;
  function r() {
    const u = e.navigator.userAgent.toLowerCase();
    return u.indexOf("safari") >= 0 && u.indexOf("chrome") < 0 && u.indexOf("android") < 0;
  }
  if (r()) {
    const u = String(e.navigator.userAgent);
    if (u.includes("Version/")) {
      const [m, y] = u.split("Version/")[1].split(" ")[0].split(".").map((b) => Number(b));
      n = m < 16 || m === 16 && y < 2;
    }
  }
  const s = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), o = r(), c = o || s && t.ios;
  return {
    isSafari: n || o,
    needPerspectiveFix: n,
    need3dFix: c,
    isWebView: s
  };
}
function b8e() {
  return RR || (RR = x8e()), RR;
}
function S8e(e) {
  let {
    swiper: t,
    on: n,
    emit: r
  } = e;
  const s = Sp();
  let o = null, c = null;
  const u = () => {
    !t || t.destroyed || !t.initialized || (r("beforeResize"), r("resize"));
  }, m = () => {
    !t || t.destroyed || !t.initialized || (o = new ResizeObserver((w) => {
      c = s.requestAnimationFrame(() => {
        const {
          width: k,
          height: j
        } = t;
        let E = k, T = j;
        w.forEach((D) => {
          let {
            contentBoxSize: L,
            contentRect: I,
            target: R
          } = D;
          R && R !== t.el || (E = I ? I.width : (L[0] || L).inlineSize, T = I ? I.height : (L[0] || L).blockSize);
        }), (E !== k || T !== j) && u();
      });
    }), o.observe(t.el));
  }, y = () => {
    c && s.cancelAnimationFrame(c), o && o.unobserve && t.el && (o.unobserve(t.el), o = null);
  }, b = () => {
    !t || t.destroyed || !t.initialized || r("orientationchange");
  };
  n("init", () => {
    if (t.params.resizeObserver && typeof s.ResizeObserver < "u") {
      m();
      return;
    }
    s.addEventListener("resize", u), s.addEventListener("orientationchange", b);
  }), n("destroy", () => {
    y(), s.removeEventListener("resize", u), s.removeEventListener("orientationchange", b);
  });
}
function w8e(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: s
  } = e;
  const o = [], c = Sp(), u = function(b, w) {
    w === void 0 && (w = {});
    const k = c.MutationObserver || c.WebkitMutationObserver, j = new k((E) => {
      if (t.__preventObserver__) return;
      if (E.length === 1) {
        s("observerUpdate", E[0]);
        return;
      }
      const T = function() {
        s("observerUpdate", E[0]);
      };
      c.requestAnimationFrame ? c.requestAnimationFrame(T) : c.setTimeout(T, 0);
    });
    j.observe(b, {
      attributes: typeof w.attributes > "u" ? !0 : w.attributes,
      childList: t.isElement || (typeof w.childList > "u" ? !0 : w).childList,
      characterData: typeof w.characterData > "u" ? !0 : w.characterData
    }), o.push(j);
  }, m = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const b = g8e(t.hostEl);
        for (let w = 0; w < b.length; w += 1)
          u(b[w]);
      }
      u(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), u(t.wrapperEl, {
        attributes: !1
      });
    }
  }, y = () => {
    o.forEach((b) => {
      b.disconnect();
    }), o.splice(0, o.length);
  };
  n({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), r("init", m), r("destroy", y);
}
var C8e = {
  on(e, t, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
    const s = n ? "unshift" : "push";
    return e.split(" ").forEach((o) => {
      r.eventsListeners[o] || (r.eventsListeners[o] = []), r.eventsListeners[o][s](t);
    }), r;
  },
  once(e, t, n) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
    function s() {
      r.off(e, s), s.__emitterProxy && delete s.__emitterProxy;
      for (var o = arguments.length, c = new Array(o), u = 0; u < o; u++)
        c[u] = arguments[u];
      t.apply(r, c);
    }
    return s.__emitterProxy = t, r.on(e, s, n);
  },
  onAny(e, t) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    const r = t ? "unshift" : "push";
    return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
    const n = t.eventsAnyListeners.indexOf(e);
    return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
  },
  off(e, t) {
    const n = this;
    return !n.eventsListeners || n.destroyed || !n.eventsListeners || e.split(" ").forEach((r) => {
      typeof t > "u" ? n.eventsListeners[r] = [] : n.eventsListeners[r] && n.eventsListeners[r].forEach((s, o) => {
        (s === t || s.__emitterProxy && s.__emitterProxy === t) && n.eventsListeners[r].splice(o, 1);
      });
    }), n;
  },
  emit() {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
    let t, n, r;
    for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
      o[c] = arguments[c];
    return typeof o[0] == "string" || Array.isArray(o[0]) ? (t = o[0], n = o.slice(1, o.length), r = e) : (t = o[0].events, n = o[0].data, r = o[0].context || e), n.unshift(r), (Array.isArray(t) ? t : t.split(" ")).forEach((m) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((y) => {
        y.apply(r, [m, ...n]);
      }), e.eventsListeners && e.eventsListeners[m] && e.eventsListeners[m].forEach((y) => {
        y.apply(r, n);
      });
    }), e;
  }
};
function N8e() {
  const e = this;
  let t, n;
  const r = e.el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = r.clientWidth, typeof e.params.height < "u" && e.params.height !== null ? n = e.params.height : n = r.clientHeight, !(t === 0 && e.isHorizontal() || n === 0 && e.isVertical()) && (t = t - parseInt(R2(r, "padding-left") || 0, 10) - parseInt(R2(r, "padding-right") || 0, 10), n = n - parseInt(R2(r, "padding-top") || 0, 10) - parseInt(R2(r, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
    width: t,
    height: n,
    size: e.isHorizontal() ? t : n
  }));
}
function j8e() {
  const e = this;
  function t(Z, X) {
    return parseFloat(Z.getPropertyValue(e.getDirectionLabel(X)) || 0);
  }
  const n = e.params, {
    wrapperEl: r,
    slidesEl: s,
    size: o,
    rtlTranslate: c,
    wrongRTL: u
  } = e, m = e.virtual && n.virtual.enabled, y = m ? e.virtual.slides.length : e.slides.length, b = uy(s, `.${e.params.slideClass}, swiper-slide`), w = m ? e.virtual.slides.length : b.length;
  let k = [];
  const j = [], E = [];
  let T = n.slidesOffsetBefore;
  typeof T == "function" && (T = n.slidesOffsetBefore.call(e));
  let D = n.slidesOffsetAfter;
  typeof D == "function" && (D = n.slidesOffsetAfter.call(e));
  const L = e.snapGrid.length, I = e.slidesGrid.length;
  let R = n.spaceBetween, U = -T, z = 0, H = 0;
  if (typeof o > "u")
    return;
  typeof R == "string" && R.indexOf("%") >= 0 ? R = parseFloat(R.replace("%", "")) / 100 * o : typeof R == "string" && (R = parseFloat(R)), e.virtualSize = -R, b.forEach((Z) => {
    c ? Z.style.marginLeft = "" : Z.style.marginRight = "", Z.style.marginBottom = "", Z.style.marginTop = "";
  }), n.centeredSlides && n.cssMode && (n3(r, "--swiper-centered-offset-before", ""), n3(r, "--swiper-centered-offset-after", ""));
  const K = n.grid && n.grid.rows > 1 && e.grid;
  K ? e.grid.initSlides(b) : e.grid && e.grid.unsetSlides();
  let q;
  const Q = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((Z) => typeof n.breakpoints[Z].slidesPerView < "u").length > 0;
  for (let Z = 0; Z < w; Z += 1) {
    q = 0;
    let X;
    if (b[Z] && (X = b[Z]), K && e.grid.updateSlide(Z, X, b), !(b[Z] && R2(X, "display") === "none")) {
      if (n.slidesPerView === "auto") {
        Q && (b[Z].style[e.getDirectionLabel("width")] = "");
        const se = getComputedStyle(X), te = X.style.transform, fe = X.style.webkitTransform;
        if (te && (X.style.transform = "none"), fe && (X.style.webkitTransform = "none"), n.roundLengths)
          q = e.isHorizontal() ? sH(X, "width") : sH(X, "height");
        else {
          const ce = t(se, "width"), pe = t(se, "padding-left"), Se = t(se, "padding-right"), oe = t(se, "margin-left"), ue = t(se, "margin-right"), he = se.getPropertyValue("box-sizing");
          if (he && he === "border-box")
            q = ce + oe + ue;
          else {
            const {
              clientWidth: ve,
              offsetWidth: Te
            } = X;
            q = ce + pe + Se + oe + ue + (Te - ve);
          }
        }
        te && (X.style.transform = te), fe && (X.style.webkitTransform = fe), n.roundLengths && (q = Math.floor(q));
      } else
        q = (o - (n.slidesPerView - 1) * R) / n.slidesPerView, n.roundLengths && (q = Math.floor(q)), b[Z] && (b[Z].style[e.getDirectionLabel("width")] = `${q}px`);
      b[Z] && (b[Z].swiperSlideSize = q), E.push(q), n.centeredSlides ? (U = U + q / 2 + z / 2 + R, z === 0 && Z !== 0 && (U = U - o / 2 - R), Z === 0 && (U = U - o / 2 - R), Math.abs(U) < 1 / 1e3 && (U = 0), n.roundLengths && (U = Math.floor(U)), H % n.slidesPerGroup === 0 && k.push(U), j.push(U)) : (n.roundLengths && (U = Math.floor(U)), (H - Math.min(e.params.slidesPerGroupSkip, H)) % e.params.slidesPerGroup === 0 && k.push(U), j.push(U), U = U + q + R), e.virtualSize += q + R, z = q, H += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, o) + D, c && u && (n.effect === "slide" || n.effect === "coverflow") && (r.style.width = `${e.virtualSize + R}px`), n.setWrapperSize && (r.style[e.getDirectionLabel("width")] = `${e.virtualSize + R}px`), K && e.grid.updateWrapperSize(q, k), !n.centeredSlides) {
    const Z = [];
    for (let X = 0; X < k.length; X += 1) {
      let se = k[X];
      n.roundLengths && (se = Math.floor(se)), k[X] <= e.virtualSize - o && Z.push(se);
    }
    k = Z, Math.floor(e.virtualSize - o) - Math.floor(k[k.length - 1]) > 1 && k.push(e.virtualSize - o);
  }
  if (m && n.loop) {
    const Z = E[0] + R;
    if (n.slidesPerGroup > 1) {
      const X = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / n.slidesPerGroup), se = Z * n.slidesPerGroup;
      for (let te = 0; te < X; te += 1)
        k.push(k[k.length - 1] + se);
    }
    for (let X = 0; X < e.virtual.slidesBefore + e.virtual.slidesAfter; X += 1)
      n.slidesPerGroup === 1 && k.push(k[k.length - 1] + Z), j.push(j[j.length - 1] + Z), e.virtualSize += Z;
  }
  if (k.length === 0 && (k = [0]), R !== 0) {
    const Z = e.isHorizontal() && c ? "marginLeft" : e.getDirectionLabel("marginRight");
    b.filter((X, se) => !n.cssMode || n.loop ? !0 : se !== b.length - 1).forEach((X) => {
      X.style[Z] = `${R}px`;
    });
  }
  if (n.centeredSlides && n.centeredSlidesBounds) {
    let Z = 0;
    E.forEach((se) => {
      Z += se + (R || 0);
    }), Z -= R;
    const X = Z > o ? Z - o : 0;
    k = k.map((se) => se <= 0 ? -T : se > X ? X + D : se);
  }
  if (n.centerInsufficientSlides) {
    let Z = 0;
    E.forEach((se) => {
      Z += se + (R || 0);
    }), Z -= R;
    const X = (n.slidesOffsetBefore || 0) + (n.slidesOffsetAfter || 0);
    if (Z + X < o) {
      const se = (o - Z - X) / 2;
      k.forEach((te, fe) => {
        k[fe] = te - se;
      }), j.forEach((te, fe) => {
        j[fe] = te + se;
      });
    }
  }
  if (Object.assign(e, {
    slides: b,
    snapGrid: k,
    slidesGrid: j,
    slidesSizesGrid: E
  }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
    n3(r, "--swiper-centered-offset-before", `${-k[0]}px`), n3(r, "--swiper-centered-offset-after", `${e.size / 2 - E[E.length - 1] / 2}px`);
    const Z = -e.snapGrid[0], X = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((se) => se + Z), e.slidesGrid = e.slidesGrid.map((se) => se + X);
  }
  if (w !== y && e.emit("slidesLengthChange"), k.length !== L && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), j.length !== I && e.emit("slidesGridLengthChange"), n.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !m && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
    const Z = `${n.containerModifierClass}backface-hidden`, X = e.el.classList.contains(Z);
    w <= n.maxBackfaceHiddenSlides ? X || e.el.classList.add(Z) : X && e.el.classList.remove(Z);
  }
}
function E8e(e) {
  const t = this, n = [], r = t.virtual && t.params.virtual.enabled;
  let s = 0, o;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const c = (u) => r ? t.slides[t.getSlideIndexByData(u)] : t.slides[u];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || []).forEach((u) => {
        n.push(u);
      });
    else
      for (o = 0; o < Math.ceil(t.params.slidesPerView); o += 1) {
        const u = t.activeIndex + o;
        if (u > t.slides.length && !r) break;
        n.push(c(u));
      }
  else
    n.push(c(t.activeIndex));
  for (o = 0; o < n.length; o += 1)
    if (typeof n[o] < "u") {
      const u = n[o].offsetHeight;
      s = u > s ? u : s;
    }
  (s || s === 0) && (t.wrapperEl.style.height = `${s}px`);
}
function k8e() {
  const e = this, t = e.slides, n = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
  for (let r = 0; r < t.length; r += 1)
    t[r].swiperSlideOffset = (e.isHorizontal() ? t[r].offsetLeft : t[r].offsetTop) - n - e.cssOverflowAdjustment();
}
const iH = (e, t, n) => {
  t && !e.classList.contains(n) ? e.classList.add(n) : !t && e.classList.contains(n) && e.classList.remove(n);
};
function _8e(e) {
  e === void 0 && (e = this && this.translate || 0);
  const t = this, n = t.params, {
    slides: r,
    rtlTranslate: s,
    snapGrid: o
  } = t;
  if (r.length === 0) return;
  typeof r[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let c = -e;
  s && (c = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  let u = n.spaceBetween;
  typeof u == "string" && u.indexOf("%") >= 0 ? u = parseFloat(u.replace("%", "")) / 100 * t.size : typeof u == "string" && (u = parseFloat(u));
  for (let m = 0; m < r.length; m += 1) {
    const y = r[m];
    let b = y.swiperSlideOffset;
    n.cssMode && n.centeredSlides && (b -= r[0].swiperSlideOffset);
    const w = (c + (n.centeredSlides ? t.minTranslate() : 0) - b) / (y.swiperSlideSize + u), k = (c - o[0] + (n.centeredSlides ? t.minTranslate() : 0) - b) / (y.swiperSlideSize + u), j = -(c - b), E = j + t.slidesSizesGrid[m], T = j >= 0 && j <= t.size - t.slidesSizesGrid[m], D = j >= 0 && j < t.size - 1 || E > 1 && E <= t.size || j <= 0 && E >= t.size;
    D && (t.visibleSlides.push(y), t.visibleSlidesIndexes.push(m)), iH(y, D, n.slideVisibleClass), iH(y, T, n.slideFullyVisibleClass), y.progress = s ? -w : w, y.originalProgress = s ? -k : k;
  }
}
function T8e(e) {
  const t = this;
  if (typeof e > "u") {
    const b = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * b || 0;
  }
  const n = t.params, r = t.maxTranslate() - t.minTranslate();
  let {
    progress: s,
    isBeginning: o,
    isEnd: c,
    progressLoop: u
  } = t;
  const m = o, y = c;
  if (r === 0)
    s = 0, o = !0, c = !0;
  else {
    s = (e - t.minTranslate()) / r;
    const b = Math.abs(e - t.minTranslate()) < 1, w = Math.abs(e - t.maxTranslate()) < 1;
    o = b || s <= 0, c = w || s >= 1, b && (s = 0), w && (s = 1);
  }
  if (n.loop) {
    const b = t.getSlideIndexByData(0), w = t.getSlideIndexByData(t.slides.length - 1), k = t.slidesGrid[b], j = t.slidesGrid[w], E = t.slidesGrid[t.slidesGrid.length - 1], T = Math.abs(e);
    T >= k ? u = (T - k) / E : u = (T + E - j) / E, u > 1 && (u -= 1);
  }
  Object.assign(t, {
    progress: s,
    progressLoop: u,
    isBeginning: o,
    isEnd: c
  }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), o && !m && t.emit("reachBeginning toEdge"), c && !y && t.emit("reachEnd toEdge"), (m && !o || y && !c) && t.emit("fromEdge"), t.emit("progress", s);
}
const DR = (e, t, n) => {
  t && !e.classList.contains(n) ? e.classList.add(n) : !t && e.classList.contains(n) && e.classList.remove(n);
};
function M8e() {
  const e = this, {
    slides: t,
    params: n,
    slidesEl: r,
    activeIndex: s
  } = e, o = e.virtual && n.virtual.enabled, c = e.grid && n.grid && n.grid.rows > 1, u = (w) => uy(r, `.${n.slideClass}${w}, swiper-slide${w}`)[0];
  let m, y, b;
  if (o)
    if (n.loop) {
      let w = s - e.virtual.slidesBefore;
      w < 0 && (w = e.virtual.slides.length + w), w >= e.virtual.slides.length && (w -= e.virtual.slides.length), m = u(`[data-swiper-slide-index="${w}"]`);
    } else
      m = u(`[data-swiper-slide-index="${s}"]`);
  else
    c ? (m = t.filter((w) => w.column === s)[0], b = t.filter((w) => w.column === s + 1)[0], y = t.filter((w) => w.column === s - 1)[0]) : m = t[s];
  m && (c || (b = p8e(m, `.${n.slideClass}, swiper-slide`)[0], n.loop && !b && (b = t[0]), y = h8e(m, `.${n.slideClass}, swiper-slide`)[0], n.loop && !y === 0 && (y = t[t.length - 1]))), t.forEach((w) => {
    DR(w, w === m, n.slideActiveClass), DR(w, w === b, n.slideNextClass), DR(w, w === y, n.slidePrevClass);
  }), e.emitSlidesClasses();
}
const d9 = (e, t) => {
  if (!e || e.destroyed || !e.params) return;
  const n = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, r = t.closest(n());
  if (r) {
    let s = r.querySelector(`.${e.params.lazyPreloaderClass}`);
    !s && e.isElement && (r.shadowRoot ? s = r.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      r.shadowRoot && (s = r.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), s && s.remove());
    })), s && s.remove();
  }
}, PR = (e, t) => {
  if (!e.slides[t]) return;
  const n = e.slides[t].querySelector('[loading="lazy"]');
  n && n.removeAttribute("loading");
}, cP = (e) => {
  if (!e || e.destroyed || !e.params) return;
  let t = e.params.lazyPreloadPrevNext;
  const n = e.slides.length;
  if (!n || !t || t < 0) return;
  t = Math.min(t, n);
  const r = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), s = e.activeIndex;
  if (e.params.grid && e.params.grid.rows > 1) {
    const c = s, u = [c - t];
    u.push(...Array.from({
      length: t
    }).map((m, y) => c + r + y)), e.slides.forEach((m, y) => {
      u.includes(m.column) && PR(e, y);
    });
    return;
  }
  const o = s + r - 1;
  if (e.params.rewind || e.params.loop)
    for (let c = s - t; c <= o + t; c += 1) {
      const u = (c % n + n) % n;
      (u < s || u > o) && PR(e, u);
    }
  else
    for (let c = Math.max(s - t, 0); c <= Math.min(o + t, n - 1); c += 1)
      c !== s && (c > o || c < s) && PR(e, c);
};
function R8e(e) {
  const {
    slidesGrid: t,
    params: n
  } = e, r = e.rtlTranslate ? e.translate : -e.translate;
  let s;
  for (let o = 0; o < t.length; o += 1)
    typeof t[o + 1] < "u" ? r >= t[o] && r < t[o + 1] - (t[o + 1] - t[o]) / 2 ? s = o : r >= t[o] && r < t[o + 1] && (s = o + 1) : r >= t[o] && (s = o);
  return n.normalizeSlideIndex && (s < 0 || typeof s > "u") && (s = 0), s;
}
function D8e(e) {
  const t = this, n = t.rtlTranslate ? t.translate : -t.translate, {
    snapGrid: r,
    params: s,
    activeIndex: o,
    realIndex: c,
    snapIndex: u
  } = t;
  let m = e, y;
  const b = (j) => {
    let E = j - t.virtual.slidesBefore;
    return E < 0 && (E = t.virtual.slides.length + E), E >= t.virtual.slides.length && (E -= t.virtual.slides.length), E;
  };
  if (typeof m > "u" && (m = R8e(t)), r.indexOf(n) >= 0)
    y = r.indexOf(n);
  else {
    const j = Math.min(s.slidesPerGroupSkip, m);
    y = j + Math.floor((m - j) / s.slidesPerGroup);
  }
  if (y >= r.length && (y = r.length - 1), m === o && !t.params.loop) {
    y !== u && (t.snapIndex = y, t.emit("snapIndexChange"));
    return;
  }
  if (m === o && t.params.loop && t.virtual && t.params.virtual.enabled) {
    t.realIndex = b(m);
    return;
  }
  const w = t.grid && s.grid && s.grid.rows > 1;
  let k;
  if (t.virtual && s.virtual.enabled && s.loop)
    k = b(m);
  else if (w) {
    const j = t.slides.filter((T) => T.column === m)[0];
    let E = parseInt(j.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(E) && (E = Math.max(t.slides.indexOf(j), 0)), k = Math.floor(E / s.grid.rows);
  } else if (t.slides[m]) {
    const j = t.slides[m].getAttribute("data-swiper-slide-index");
    j ? k = parseInt(j, 10) : k = m;
  } else
    k = m;
  Object.assign(t, {
    previousSnapIndex: u,
    snapIndex: y,
    previousRealIndex: c,
    realIndex: k,
    previousIndex: o,
    activeIndex: m
  }), t.initialized && cP(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (c !== k && t.emit("realIndexChange"), t.emit("slideChange"));
}
function P8e(e, t) {
  const n = this, r = n.params;
  let s = e.closest(`.${r.slideClass}, swiper-slide`);
  !s && n.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((u) => {
    !s && u.matches && u.matches(`.${r.slideClass}, swiper-slide`) && (s = u);
  });
  let o = !1, c;
  if (s) {
    for (let u = 0; u < n.slides.length; u += 1)
      if (n.slides[u] === s) {
        o = !0, c = u;
        break;
      }
  }
  if (s && o)
    n.clickedSlide = s, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(s.getAttribute("data-swiper-slide-index"), 10) : n.clickedIndex = c;
  else {
    n.clickedSlide = void 0, n.clickedIndex = void 0;
    return;
  }
  r.slideToClickedSlide && n.clickedIndex !== void 0 && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
}
var O8e = {
  updateSize: N8e,
  updateSlides: j8e,
  updateAutoHeight: E8e,
  updateSlidesOffset: k8e,
  updateSlidesProgress: _8e,
  updateProgress: T8e,
  updateSlidesClasses: M8e,
  updateActiveIndex: D8e,
  updateClickedSlide: P8e
};
function A8e(e) {
  e === void 0 && (e = this.isHorizontal() ? "x" : "y");
  const t = this, {
    params: n,
    rtlTranslate: r,
    translate: s,
    wrapperEl: o
  } = t;
  if (n.virtualTranslate)
    return r ? -s : s;
  if (n.cssMode)
    return s;
  let c = d8e(o, e);
  return c += t.cssOverflowAdjustment(), r && (c = -c), c || 0;
}
function L8e(e, t) {
  const n = this, {
    rtlTranslate: r,
    params: s,
    wrapperEl: o,
    progress: c
  } = n;
  let u = 0, m = 0;
  const y = 0;
  n.isHorizontal() ? u = r ? -e : e : m = e, s.roundLengths && (u = Math.floor(u), m = Math.floor(m)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? u : m, s.cssMode ? o[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -u : -m : s.virtualTranslate || (n.isHorizontal() ? u -= n.cssOverflowAdjustment() : m -= n.cssOverflowAdjustment(), o.style.transform = `translate3d(${u}px, ${m}px, ${y}px)`);
  let b;
  const w = n.maxTranslate() - n.minTranslate();
  w === 0 ? b = 0 : b = (e - n.minTranslate()) / w, b !== c && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
}
function I8e() {
  return -this.snapGrid[0];
}
function F8e() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function U8e(e, t, n, r, s) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), r === void 0 && (r = !0);
  const o = this, {
    params: c,
    wrapperEl: u
  } = o;
  if (o.animating && c.preventInteractionOnTransition)
    return !1;
  const m = o.minTranslate(), y = o.maxTranslate();
  let b;
  if (r && e > m ? b = m : r && e < y ? b = y : b = e, o.updateProgress(b), c.cssMode) {
    const w = o.isHorizontal();
    if (t === 0)
      u[w ? "scrollLeft" : "scrollTop"] = -b;
    else {
      if (!o.support.smoothScroll)
        return mq({
          swiper: o,
          targetPosition: -b,
          side: w ? "left" : "top"
        }), !0;
      u.scrollTo({
        [w ? "left" : "top"]: -b,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (o.setTransition(0), o.setTranslate(b), n && (o.emit("beforeTransitionStart", t, s), o.emit("transitionEnd"))) : (o.setTransition(t), o.setTranslate(b), n && (o.emit("beforeTransitionStart", t, s), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(k) {
    !o || o.destroyed || k.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, o.animating = !1, n && o.emit("transitionEnd"));
  }), o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), !0;
}
var z8e = {
  getTranslate: A8e,
  setTranslate: L8e,
  minTranslate: I8e,
  maxTranslate: F8e,
  translateTo: U8e
};
function B8e(e, t) {
  const n = this;
  n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${e}ms`, n.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), n.emit("setTransition", e, t);
}
function gq(e) {
  let {
    swiper: t,
    runCallbacks: n,
    direction: r,
    step: s
  } = e;
  const {
    activeIndex: o,
    previousIndex: c
  } = t;
  let u = r;
  if (u || (o > c ? u = "next" : o < c ? u = "prev" : u = "reset"), t.emit(`transition${s}`), n && o !== c) {
    if (u === "reset") {
      t.emit(`slideResetTransition${s}`);
      return;
    }
    t.emit(`slideChangeTransition${s}`), u === "next" ? t.emit(`slideNextTransition${s}`) : t.emit(`slidePrevTransition${s}`);
  }
}
function H8e(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: r
  } = n;
  r.cssMode || (r.autoHeight && n.updateAutoHeight(), gq({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function V8e(e, t) {
  e === void 0 && (e = !0);
  const n = this, {
    params: r
  } = n;
  n.animating = !1, !r.cssMode && (n.setTransition(0), gq({
    swiper: n,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
var $8e = {
  setTransition: B8e,
  transitionStart: H8e,
  transitionEnd: V8e
};
function G8e(e, t, n, r, s) {
  e === void 0 && (e = 0), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
  const o = this;
  let c = e;
  c < 0 && (c = 0);
  const {
    params: u,
    snapGrid: m,
    slidesGrid: y,
    previousIndex: b,
    activeIndex: w,
    rtlTranslate: k,
    wrapperEl: j,
    enabled: E
  } = o;
  if (!E && !r && !s || o.destroyed || o.animating && u.preventInteractionOnTransition)
    return !1;
  typeof t > "u" && (t = o.params.speed);
  const T = Math.min(o.params.slidesPerGroupSkip, c);
  let D = T + Math.floor((c - T) / o.params.slidesPerGroup);
  D >= m.length && (D = m.length - 1);
  const L = -m[D];
  if (u.normalizeSlideIndex)
    for (let z = 0; z < y.length; z += 1) {
      const H = -Math.floor(L * 100), K = Math.floor(y[z] * 100), q = Math.floor(y[z + 1] * 100);
      typeof y[z + 1] < "u" ? H >= K && H < q - (q - K) / 2 ? c = z : H >= K && H < q && (c = z + 1) : H >= K && (c = z);
    }
  if (o.initialized && c !== w && (!o.allowSlideNext && (k ? L > o.translate && L > o.minTranslate() : L < o.translate && L < o.minTranslate()) || !o.allowSlidePrev && L > o.translate && L > o.maxTranslate() && (w || 0) !== c))
    return !1;
  c !== (b || 0) && n && o.emit("beforeSlideChangeStart"), o.updateProgress(L);
  let I;
  c > w ? I = "next" : c < w ? I = "prev" : I = "reset";
  const R = o.virtual && o.params.virtual.enabled;
  if (!(R && s) && (k && -L === o.translate || !k && L === o.translate))
    return o.updateActiveIndex(c), u.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), u.effect !== "slide" && o.setTranslate(L), I !== "reset" && (o.transitionStart(n, I), o.transitionEnd(n, I)), !1;
  if (u.cssMode) {
    const z = o.isHorizontal(), H = k ? L : -L;
    if (t === 0)
      R && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = !0), R && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        j[z ? "scrollLeft" : "scrollTop"] = H;
      })) : j[z ? "scrollLeft" : "scrollTop"] = H, R && requestAnimationFrame(() => {
        o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = !1;
      });
    else {
      if (!o.support.smoothScroll)
        return mq({
          swiper: o,
          targetPosition: H,
          side: z ? "left" : "top"
        }), !0;
      j.scrollTo({
        [z ? "left" : "top"]: H,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return o.setTransition(t), o.setTranslate(L), o.updateActiveIndex(c), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, r), o.transitionStart(n, I), t === 0 ? o.transitionEnd(n, I) : o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(H) {
    !o || o.destroyed || H.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(n, I));
  }), o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), !0;
}
function W8e(e, t, n, r) {
  e === void 0 && (e = 0), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
  const s = this;
  if (s.destroyed) return;
  typeof t > "u" && (t = s.params.speed);
  const o = s.grid && s.params.grid && s.params.grid.rows > 1;
  let c = e;
  if (s.params.loop)
    if (s.virtual && s.params.virtual.enabled)
      c = c + s.virtual.slidesBefore;
    else {
      let u;
      if (o) {
        const k = c * s.params.grid.rows;
        u = s.slides.filter((j) => j.getAttribute("data-swiper-slide-index") * 1 === k)[0].column;
      } else
        u = s.getSlideIndexByData(c);
      const m = o ? Math.ceil(s.slides.length / s.params.grid.rows) : s.slides.length, {
        centeredSlides: y
      } = s.params;
      let b = s.params.slidesPerView;
      b === "auto" ? b = s.slidesPerViewDynamic() : (b = Math.ceil(parseFloat(s.params.slidesPerView, 10)), y && b % 2 === 0 && (b = b + 1));
      let w = m - u < b;
      if (y && (w = w || u < Math.ceil(b / 2)), r && y && s.params.slidesPerView !== "auto" && !o && (w = !1), w) {
        const k = y ? u < s.activeIndex ? "prev" : "next" : u - s.activeIndex - 1 < s.params.slidesPerView ? "next" : "prev";
        s.loopFix({
          direction: k,
          slideTo: !0,
          activeSlideIndex: k === "next" ? u + 1 : u - m + 1,
          slideRealIndex: k === "next" ? s.realIndex : void 0
        });
      }
      if (o) {
        const k = c * s.params.grid.rows;
        c = s.slides.filter((j) => j.getAttribute("data-swiper-slide-index") * 1 === k)[0].column;
      } else
        c = s.getSlideIndexByData(c);
    }
  return requestAnimationFrame(() => {
    s.slideTo(c, t, n, r);
  }), s;
}
function Y8e(e, t, n) {
  t === void 0 && (t = !0);
  const r = this, {
    enabled: s,
    params: o,
    animating: c
  } = r;
  if (!s || r.destroyed) return r;
  typeof e > "u" && (e = r.params.speed);
  let u = o.slidesPerGroup;
  o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (u = Math.max(r.slidesPerViewDynamic("current", !0), 1));
  const m = r.activeIndex < o.slidesPerGroupSkip ? 1 : u, y = r.virtual && o.virtual.enabled;
  if (o.loop) {
    if (c && !y && o.loopPreventsSliding) return !1;
    if (r.loopFix({
      direction: "next"
    }), r._clientLeft = r.wrapperEl.clientLeft, r.activeIndex === r.slides.length - 1 && o.cssMode)
      return requestAnimationFrame(() => {
        r.slideTo(r.activeIndex + m, e, t, n);
      }), !0;
  }
  return o.rewind && r.isEnd ? r.slideTo(0, e, t, n) : r.slideTo(r.activeIndex + m, e, t, n);
}
function q8e(e, t, n) {
  t === void 0 && (t = !0);
  const r = this, {
    params: s,
    snapGrid: o,
    slidesGrid: c,
    rtlTranslate: u,
    enabled: m,
    animating: y
  } = r;
  if (!m || r.destroyed) return r;
  typeof e > "u" && (e = r.params.speed);
  const b = r.virtual && s.virtual.enabled;
  if (s.loop) {
    if (y && !b && s.loopPreventsSliding) return !1;
    r.loopFix({
      direction: "prev"
    }), r._clientLeft = r.wrapperEl.clientLeft;
  }
  const w = u ? r.translate : -r.translate;
  function k(L) {
    return L < 0 ? -Math.floor(Math.abs(L)) : Math.floor(L);
  }
  const j = k(w), E = o.map((L) => k(L));
  let T = o[E.indexOf(j) - 1];
  if (typeof T > "u" && s.cssMode) {
    let L;
    o.forEach((I, R) => {
      j >= I && (L = R);
    }), typeof L < "u" && (T = o[L > 0 ? L - 1 : L]);
  }
  let D = 0;
  if (typeof T < "u" && (D = c.indexOf(T), D < 0 && (D = r.activeIndex - 1), s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto && (D = D - r.slidesPerViewDynamic("previous", !0) + 1, D = Math.max(D, 0))), s.rewind && r.isBeginning) {
    const L = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
    return r.slideTo(L, e, t, n);
  } else if (s.loop && r.activeIndex === 0 && s.cssMode)
    return requestAnimationFrame(() => {
      r.slideTo(D, e, t, n);
    }), !0;
  return r.slideTo(D, e, t, n);
}
function K8e(e, t, n) {
  t === void 0 && (t = !0);
  const r = this;
  if (!r.destroyed)
    return typeof e > "u" && (e = r.params.speed), r.slideTo(r.activeIndex, e, t, n);
}
function X8e(e, t, n, r) {
  t === void 0 && (t = !0), r === void 0 && (r = 0.5);
  const s = this;
  if (s.destroyed) return;
  typeof e > "u" && (e = s.params.speed);
  let o = s.activeIndex;
  const c = Math.min(s.params.slidesPerGroupSkip, o), u = c + Math.floor((o - c) / s.params.slidesPerGroup), m = s.rtlTranslate ? s.translate : -s.translate;
  if (m >= s.snapGrid[u]) {
    const y = s.snapGrid[u], b = s.snapGrid[u + 1];
    m - y > (b - y) * r && (o += s.params.slidesPerGroup);
  } else {
    const y = s.snapGrid[u - 1], b = s.snapGrid[u];
    m - y <= (b - y) * r && (o -= s.params.slidesPerGroup);
  }
  return o = Math.max(o, 0), o = Math.min(o, s.slidesGrid.length - 1), s.slideTo(o, e, t, n);
}
function Q8e() {
  const e = this;
  if (e.destroyed) return;
  const {
    params: t,
    slidesEl: n
  } = e, r = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let s = e.clickedIndex, o;
  const c = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
  if (t.loop) {
    if (e.animating) return;
    o = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? s < e.loopedSlides - r / 2 || s > e.slides.length - e.loopedSlides + r / 2 ? (e.loopFix(), s = e.getSlideIndex(uy(n, `${c}[data-swiper-slide-index="${o}"]`)[0]), lP(() => {
      e.slideTo(s);
    })) : e.slideTo(s) : s > e.slides.length - r ? (e.loopFix(), s = e.getSlideIndex(uy(n, `${c}[data-swiper-slide-index="${o}"]`)[0]), lP(() => {
      e.slideTo(s);
    })) : e.slideTo(s);
  } else
    e.slideTo(s);
}
var Z8e = {
  slideTo: G8e,
  slideToLoop: W8e,
  slideNext: Y8e,
  slidePrev: q8e,
  slideReset: K8e,
  slideToClosest: X8e,
  slideToClickedSlide: Q8e
};
function J8e(e) {
  const t = this, {
    params: n,
    slidesEl: r
  } = t;
  if (!n.loop || t.virtual && t.params.virtual.enabled) return;
  const s = () => {
    uy(r, `.${n.slideClass}, swiper-slide`).forEach((w, k) => {
      w.setAttribute("data-swiper-slide-index", k);
    });
  }, o = t.grid && n.grid && n.grid.rows > 1, c = n.slidesPerGroup * (o ? n.grid.rows : 1), u = t.slides.length % c !== 0, m = o && t.slides.length % n.grid.rows !== 0, y = (b) => {
    for (let w = 0; w < b; w += 1) {
      const k = t.isElement ? L3("swiper-slide", [n.slideBlankClass]) : L3("div", [n.slideClass, n.slideBlankClass]);
      t.slidesEl.append(k);
    }
  };
  if (u) {
    if (n.loopAddBlankSlides) {
      const b = c - t.slides.length % c;
      y(b), t.recalcSlides(), t.updateSlides();
    } else
      nE("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    s();
  } else if (m) {
    if (n.loopAddBlankSlides) {
      const b = n.grid.rows - t.slides.length % n.grid.rows;
      y(b), t.recalcSlides(), t.updateSlides();
    } else
      nE("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    s();
  } else
    s();
  t.loopFix({
    slideRealIndex: e,
    direction: n.centeredSlides ? void 0 : "next"
  });
}
function ewe(e) {
  let {
    slideRealIndex: t,
    slideTo: n = !0,
    direction: r,
    setTranslate: s,
    activeSlideIndex: o,
    byController: c,
    byMousewheel: u
  } = e === void 0 ? {} : e;
  const m = this;
  if (!m.params.loop) return;
  m.emit("beforeLoopFix");
  const {
    slides: y,
    allowSlidePrev: b,
    allowSlideNext: w,
    slidesEl: k,
    params: j
  } = m, {
    centeredSlides: E
  } = j;
  if (m.allowSlidePrev = !0, m.allowSlideNext = !0, m.virtual && j.virtual.enabled) {
    n && (!j.centeredSlides && m.snapIndex === 0 ? m.slideTo(m.virtual.slides.length, 0, !1, !0) : j.centeredSlides && m.snapIndex < j.slidesPerView ? m.slideTo(m.virtual.slides.length + m.snapIndex, 0, !1, !0) : m.snapIndex === m.snapGrid.length - 1 && m.slideTo(m.virtual.slidesBefore, 0, !1, !0)), m.allowSlidePrev = b, m.allowSlideNext = w, m.emit("loopFix");
    return;
  }
  let T = j.slidesPerView;
  T === "auto" ? T = m.slidesPerViewDynamic() : (T = Math.ceil(parseFloat(j.slidesPerView, 10)), E && T % 2 === 0 && (T = T + 1));
  const D = j.slidesPerGroupAuto ? T : j.slidesPerGroup;
  let L = D;
  L % D !== 0 && (L += D - L % D), L += j.loopAdditionalSlides, m.loopedSlides = L;
  const I = m.grid && j.grid && j.grid.rows > 1;
  y.length < T + L ? nE("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : I && j.grid.fill === "row" && nE("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const R = [], U = [];
  let z = m.activeIndex;
  typeof o > "u" ? o = m.getSlideIndex(y.filter((te) => te.classList.contains(j.slideActiveClass))[0]) : z = o;
  const H = r === "next" || !r, K = r === "prev" || !r;
  let q = 0, Q = 0;
  const Z = I ? Math.ceil(y.length / j.grid.rows) : y.length, se = (I ? y[o].column : o) + (E && typeof s > "u" ? -T / 2 + 0.5 : 0);
  if (se < L) {
    q = Math.max(L - se, D);
    for (let te = 0; te < L - se; te += 1) {
      const fe = te - Math.floor(te / Z) * Z;
      if (I) {
        const ce = Z - fe - 1;
        for (let pe = y.length - 1; pe >= 0; pe -= 1)
          y[pe].column === ce && R.push(pe);
      } else
        R.push(Z - fe - 1);
    }
  } else if (se + T > Z - L) {
    Q = Math.max(se - (Z - L * 2), D);
    for (let te = 0; te < Q; te += 1) {
      const fe = te - Math.floor(te / Z) * Z;
      I ? y.forEach((ce, pe) => {
        ce.column === fe && U.push(pe);
      }) : U.push(fe);
    }
  }
  if (m.__preventObserver__ = !0, requestAnimationFrame(() => {
    m.__preventObserver__ = !1;
  }), K && R.forEach((te) => {
    y[te].swiperLoopMoveDOM = !0, k.prepend(y[te]), y[te].swiperLoopMoveDOM = !1;
  }), H && U.forEach((te) => {
    y[te].swiperLoopMoveDOM = !0, k.append(y[te]), y[te].swiperLoopMoveDOM = !1;
  }), m.recalcSlides(), j.slidesPerView === "auto" ? m.updateSlides() : I && (R.length > 0 && K || U.length > 0 && H) && m.slides.forEach((te, fe) => {
    m.grid.updateSlide(fe, te, m.slides);
  }), j.watchSlidesProgress && m.updateSlidesOffset(), n) {
    if (R.length > 0 && K) {
      if (typeof t > "u") {
        const te = m.slidesGrid[z], ce = m.slidesGrid[z + q] - te;
        u ? m.setTranslate(m.translate - ce) : (m.slideTo(z + Math.ceil(q), 0, !1, !0), s && (m.touchEventsData.startTranslate = m.touchEventsData.startTranslate - ce, m.touchEventsData.currentTranslate = m.touchEventsData.currentTranslate - ce));
      } else if (s) {
        const te = I ? R.length / j.grid.rows : R.length;
        m.slideTo(m.activeIndex + te, 0, !1, !0), m.touchEventsData.currentTranslate = m.translate;
      }
    } else if (U.length > 0 && H)
      if (typeof t > "u") {
        const te = m.slidesGrid[z], ce = m.slidesGrid[z - Q] - te;
        u ? m.setTranslate(m.translate - ce) : (m.slideTo(z - Q, 0, !1, !0), s && (m.touchEventsData.startTranslate = m.touchEventsData.startTranslate - ce, m.touchEventsData.currentTranslate = m.touchEventsData.currentTranslate - ce));
      } else {
        const te = I ? U.length / j.grid.rows : U.length;
        m.slideTo(m.activeIndex - te, 0, !1, !0);
      }
  }
  if (m.allowSlidePrev = b, m.allowSlideNext = w, m.controller && m.controller.control && !c) {
    const te = {
      slideRealIndex: t,
      direction: r,
      setTranslate: s,
      activeSlideIndex: o,
      byController: !0
    };
    Array.isArray(m.controller.control) ? m.controller.control.forEach((fe) => {
      !fe.destroyed && fe.params.loop && fe.loopFix({
        ...te,
        slideTo: fe.params.slidesPerView === j.slidesPerView ? n : !1
      });
    }) : m.controller.control instanceof m.constructor && m.controller.control.params.loop && m.controller.control.loopFix({
      ...te,
      slideTo: m.controller.control.params.slidesPerView === j.slidesPerView ? n : !1
    });
  }
  m.emit("loopFix");
}
function twe() {
  const e = this, {
    params: t,
    slidesEl: n
  } = e;
  if (!t.loop || e.virtual && e.params.virtual.enabled) return;
  e.recalcSlides();
  const r = [];
  e.slides.forEach((s) => {
    const o = typeof s.swiperSlideIndex > "u" ? s.getAttribute("data-swiper-slide-index") * 1 : s.swiperSlideIndex;
    r[o] = s;
  }), e.slides.forEach((s) => {
    s.removeAttribute("data-swiper-slide-index");
  }), r.forEach((s) => {
    n.append(s);
  }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
var nwe = {
  loopCreate: J8e,
  loopFix: ewe,
  loopDestroy: twe
};
function rwe(e) {
  const t = this;
  if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
  const n = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  t.isElement && (t.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  });
}
function awe() {
  const e = this;
  e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  }));
}
var swe = {
  setGrabCursor: rwe,
  unsetGrabCursor: awe
};
function iwe(e, t) {
  t === void 0 && (t = this);
  function n(r) {
    if (!r || r === my() || r === Sp()) return null;
    r.assignedSlot && (r = r.assignedSlot);
    const s = r.closest(e);
    return !s && !r.getRootNode ? null : s || n(r.getRootNode().host);
  }
  return n(t);
}
function oH(e, t, n) {
  const r = Sp(), {
    params: s
  } = e, o = s.edgeSwipeDetection, c = s.edgeSwipeThreshold;
  return o && (n <= c || n >= r.innerWidth - c) ? o === "prevent" ? (t.preventDefault(), !0) : !1 : !0;
}
function owe(e) {
  const t = this, n = my();
  let r = e;
  r.originalEvent && (r = r.originalEvent);
  const s = t.touchEventsData;
  if (r.type === "pointerdown") {
    if (s.pointerId !== null && s.pointerId !== r.pointerId)
      return;
    s.pointerId = r.pointerId;
  } else r.type === "touchstart" && r.targetTouches.length === 1 && (s.touchId = r.targetTouches[0].identifier);
  if (r.type === "touchstart") {
    oH(t, r, r.targetTouches[0].pageX);
    return;
  }
  const {
    params: o,
    touches: c,
    enabled: u
  } = t;
  if (!u || !o.simulateTouch && r.pointerType === "mouse" || t.animating && o.preventInteractionOnTransition)
    return;
  !t.animating && o.cssMode && o.loop && t.loopFix();
  let m = r.target;
  if (o.touchEventsTarget === "wrapper" && !m8e(m, t.wrapperEl) || "which" in r && r.which === 3 || "button" in r && r.button > 0 || s.isTouched && s.isMoved) return;
  const y = !!o.noSwipingClass && o.noSwipingClass !== "", b = r.composedPath ? r.composedPath() : r.path;
  y && r.target && r.target.shadowRoot && b && (m = b[0]);
  const w = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, k = !!(r.target && r.target.shadowRoot);
  if (o.noSwiping && (k ? iwe(w, m) : m.closest(w))) {
    t.allowClick = !0;
    return;
  }
  if (o.swipeHandler && !m.closest(o.swipeHandler))
    return;
  c.currentX = r.pageX, c.currentY = r.pageY;
  const j = c.currentX, E = c.currentY;
  if (!oH(t, r, j))
    return;
  Object.assign(s, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), c.startX = j, c.startY = E, s.touchStartTime = tE(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, o.threshold > 0 && (s.allowThresholdMove = !1);
  let T = !0;
  m.matches(s.focusableElements) && (T = !1, m.nodeName === "SELECT" && (s.isTouched = !1)), n.activeElement && n.activeElement.matches(s.focusableElements) && n.activeElement !== m && (r.pointerType === "mouse" || r.pointerType !== "mouse" && !m.matches(s.focusableElements)) && n.activeElement.blur();
  const D = T && t.allowTouchMove && o.touchStartPreventDefault;
  (o.touchStartForcePreventDefault || D) && !m.isContentEditable && r.preventDefault(), o.freeMode && o.freeMode.enabled && t.freeMode && t.animating && !o.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", r);
}
function lwe(e) {
  const t = my(), n = this, r = n.touchEventsData, {
    params: s,
    touches: o,
    rtlTranslate: c,
    enabled: u
  } = n;
  if (!u || !s.simulateTouch && e.pointerType === "mouse") return;
  let m = e;
  if (m.originalEvent && (m = m.originalEvent), m.type === "pointermove" && (r.touchId !== null || m.pointerId !== r.pointerId))
    return;
  let y;
  if (m.type === "touchmove") {
    if (y = [...m.changedTouches].filter((H) => H.identifier === r.touchId)[0], !y || y.identifier !== r.touchId) return;
  } else
    y = m;
  if (!r.isTouched) {
    r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", m);
    return;
  }
  const b = y.pageX, w = y.pageY;
  if (m.preventedByNestedSwiper) {
    o.startX = b, o.startY = w;
    return;
  }
  if (!n.allowTouchMove) {
    m.target.matches(r.focusableElements) || (n.allowClick = !1), r.isTouched && (Object.assign(o, {
      startX: b,
      startY: w,
      currentX: b,
      currentY: w
    }), r.touchStartTime = tE());
    return;
  }
  if (s.touchReleaseOnEdges && !s.loop) {
    if (n.isVertical()) {
      if (w < o.startY && n.translate <= n.maxTranslate() || w > o.startY && n.translate >= n.minTranslate()) {
        r.isTouched = !1, r.isMoved = !1;
        return;
      }
    } else if (b < o.startX && n.translate <= n.maxTranslate() || b > o.startX && n.translate >= n.minTranslate())
      return;
  }
  if (t.activeElement && t.activeElement.matches(r.focusableElements) && t.activeElement !== m.target && m.pointerType !== "mouse" && t.activeElement.blur(), t.activeElement && m.target === t.activeElement && m.target.matches(r.focusableElements)) {
    r.isMoved = !0, n.allowClick = !1;
    return;
  }
  r.allowTouchCallbacks && n.emit("touchMove", m), o.previousX = o.currentX, o.previousY = o.currentY, o.currentX = b, o.currentY = w;
  const k = o.currentX - o.startX, j = o.currentY - o.startY;
  if (n.params.threshold && Math.sqrt(k ** 2 + j ** 2) < n.params.threshold) return;
  if (typeof r.isScrolling > "u") {
    let H;
    n.isHorizontal() && o.currentY === o.startY || n.isVertical() && o.currentX === o.startX ? r.isScrolling = !1 : k * k + j * j >= 25 && (H = Math.atan2(Math.abs(j), Math.abs(k)) * 180 / Math.PI, r.isScrolling = n.isHorizontal() ? H > s.touchAngle : 90 - H > s.touchAngle);
  }
  if (r.isScrolling && n.emit("touchMoveOpposite", m), typeof r.startMoving > "u" && (o.currentX !== o.startX || o.currentY !== o.startY) && (r.startMoving = !0), r.isScrolling || m.type === "touchmove" && r.preventTouchMoveFromPointerMove) {
    r.isTouched = !1;
    return;
  }
  if (!r.startMoving)
    return;
  n.allowClick = !1, !s.cssMode && m.cancelable && m.preventDefault(), s.touchMoveStopPropagation && !s.nested && m.stopPropagation();
  let E = n.isHorizontal() ? k : j, T = n.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
  s.oneWayMovement && (E = Math.abs(E) * (c ? 1 : -1), T = Math.abs(T) * (c ? 1 : -1)), o.diff = E, E *= s.touchRatio, c && (E = -E, T = -T);
  const D = n.touchesDirection;
  n.swipeDirection = E > 0 ? "prev" : "next", n.touchesDirection = T > 0 ? "prev" : "next";
  const L = n.params.loop && !s.cssMode, I = n.touchesDirection === "next" && n.allowSlideNext || n.touchesDirection === "prev" && n.allowSlidePrev;
  if (!r.isMoved) {
    if (L && I && n.loopFix({
      direction: n.swipeDirection
    }), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
      const H = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      n.wrapperEl.dispatchEvent(H);
    }
    r.allowMomentumBounce = !1, s.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", m);
  }
  let R;
  if ((/* @__PURE__ */ new Date()).getTime(), r.isMoved && r.allowThresholdMove && D !== n.touchesDirection && L && I && Math.abs(E) >= 1) {
    Object.assign(o, {
      startX: b,
      startY: w,
      currentX: b,
      currentY: w,
      startTranslate: r.currentTranslate
    }), r.loopSwapReset = !0, r.startTranslate = r.currentTranslate;
    return;
  }
  n.emit("sliderMove", m), r.isMoved = !0, r.currentTranslate = E + r.startTranslate;
  let U = !0, z = s.resistanceRatio;
  if (s.touchReleaseOnEdges && (z = 0), E > 0 ? (L && I && !R && r.allowThresholdMove && r.currentTranslate > (s.centeredSlides ? n.minTranslate() - n.slidesSizesGrid[n.activeIndex + 1] - (s.slidesPerView !== "auto" && n.slides.length - s.slidesPerView >= 2 ? n.slidesSizesGrid[n.activeIndex + 1] + n.params.spaceBetween : 0) - n.params.spaceBetween : n.minTranslate()) && n.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), r.currentTranslate > n.minTranslate() && (U = !1, s.resistance && (r.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + r.startTranslate + E) ** z))) : E < 0 && (L && I && !R && r.allowThresholdMove && r.currentTranslate < (s.centeredSlides ? n.maxTranslate() + n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween + (s.slidesPerView !== "auto" && n.slides.length - s.slidesPerView >= 2 ? n.slidesSizesGrid[n.slidesSizesGrid.length - 1] + n.params.spaceBetween : 0) : n.maxTranslate()) && n.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: n.slides.length - (s.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(s.slidesPerView, 10)))
  }), r.currentTranslate < n.maxTranslate() && (U = !1, s.resistance && (r.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - r.startTranslate - E) ** z))), U && (m.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (r.currentTranslate = r.startTranslate), s.threshold > 0)
    if (Math.abs(E) > s.threshold || r.allowThresholdMove) {
      if (!r.allowThresholdMove) {
        r.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, r.currentTranslate = r.startTranslate, o.diff = n.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
        return;
      }
    } else {
      r.currentTranslate = r.startTranslate;
      return;
    }
  !s.followFinger || s.cssMode || ((s.freeMode && s.freeMode.enabled && n.freeMode || s.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), s.freeMode && s.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate));
}
function cwe(e) {
  const t = this, n = t.touchEventsData;
  let r = e;
  r.originalEvent && (r = r.originalEvent);
  let s;
  if (r.type === "touchend" || r.type === "touchcancel") {
    if (s = [...r.changedTouches].filter((z) => z.identifier === n.touchId)[0], !s || s.identifier !== n.touchId) return;
  } else {
    if (n.touchId !== null || r.pointerId !== n.pointerId) return;
    s = r;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(r.type) && !(["pointercancel", "contextmenu"].includes(r.type) && (t.browser.isSafari || t.browser.isWebView)))
    return;
  n.pointerId = null, n.touchId = null;
  const {
    params: c,
    touches: u,
    rtlTranslate: m,
    slidesGrid: y,
    enabled: b
  } = t;
  if (!b || !c.simulateTouch && r.pointerType === "mouse") return;
  if (n.allowTouchCallbacks && t.emit("touchEnd", r), n.allowTouchCallbacks = !1, !n.isTouched) {
    n.isMoved && c.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
    return;
  }
  c.grabCursor && n.isMoved && n.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const w = tE(), k = w - n.touchStartTime;
  if (t.allowClick) {
    const z = r.path || r.composedPath && r.composedPath();
    t.updateClickedSlide(z && z[0] || r.target, z), t.emit("tap click", r), k < 300 && w - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", r);
  }
  if (n.lastClickTime = tE(), lP(() => {
    t.destroyed || (t.allowClick = !0);
  }), !n.isTouched || !n.isMoved || !t.swipeDirection || u.diff === 0 && !n.loopSwapReset || n.currentTranslate === n.startTranslate && !n.loopSwapReset) {
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    return;
  }
  n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
  let j;
  if (c.followFinger ? j = m ? t.translate : -t.translate : j = -n.currentTranslate, c.cssMode)
    return;
  if (c.freeMode && c.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: j
    });
    return;
  }
  const E = j >= -t.maxTranslate() && !t.params.loop;
  let T = 0, D = t.slidesSizesGrid[0];
  for (let z = 0; z < y.length; z += z < c.slidesPerGroupSkip ? 1 : c.slidesPerGroup) {
    const H = z < c.slidesPerGroupSkip - 1 ? 1 : c.slidesPerGroup;
    typeof y[z + H] < "u" ? (E || j >= y[z] && j < y[z + H]) && (T = z, D = y[z + H] - y[z]) : (E || j >= y[z]) && (T = z, D = y[y.length - 1] - y[y.length - 2]);
  }
  let L = null, I = null;
  c.rewind && (t.isBeginning ? I = c.virtual && c.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (L = 0));
  const R = (j - y[T]) / D, U = T < c.slidesPerGroupSkip - 1 ? 1 : c.slidesPerGroup;
  if (k > c.longSwipesMs) {
    if (!c.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (R >= c.longSwipesRatio ? t.slideTo(c.rewind && t.isEnd ? L : T + U) : t.slideTo(T)), t.swipeDirection === "prev" && (R > 1 - c.longSwipesRatio ? t.slideTo(T + U) : I !== null && R < 0 && Math.abs(R) > c.longSwipesRatio ? t.slideTo(I) : t.slideTo(T));
  } else {
    if (!c.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (r.target === t.navigation.nextEl || r.target === t.navigation.prevEl) ? r.target === t.navigation.nextEl ? t.slideTo(T + U) : t.slideTo(T) : (t.swipeDirection === "next" && t.slideTo(L !== null ? L : T + U), t.swipeDirection === "prev" && t.slideTo(I !== null ? I : T));
  }
}
function lH() {
  const e = this, {
    params: t,
    el: n
  } = e;
  if (n && n.offsetWidth === 0) return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: r,
    allowSlidePrev: s,
    snapGrid: o
  } = e, c = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const u = c && t.loop;
  (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !u ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !c ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = s, e.allowSlideNext = r, e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
}
function uwe(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function dwe() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: n,
    enabled: r
  } = e;
  if (!r) return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let s;
  const o = e.maxTranslate() - e.minTranslate();
  o === 0 ? s = 0 : s = (e.translate - e.minTranslate()) / o, s !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function fwe(e) {
  const t = this;
  d9(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
function mwe() {
  const e = this;
  e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
const yq = (e, t) => {
  const n = my(), {
    params: r,
    el: s,
    wrapperEl: o,
    device: c
  } = e, u = !!r.nested, m = t === "on" ? "addEventListener" : "removeEventListener", y = t;
  !s || typeof s == "string" || (n[m]("touchstart", e.onDocumentTouchStart, {
    passive: !1,
    capture: u
  }), s[m]("touchstart", e.onTouchStart, {
    passive: !1
  }), s[m]("pointerdown", e.onTouchStart, {
    passive: !1
  }), n[m]("touchmove", e.onTouchMove, {
    passive: !1,
    capture: u
  }), n[m]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: u
  }), n[m]("touchend", e.onTouchEnd, {
    passive: !0
  }), n[m]("pointerup", e.onTouchEnd, {
    passive: !0
  }), n[m]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), n[m]("touchcancel", e.onTouchEnd, {
    passive: !0
  }), n[m]("pointerout", e.onTouchEnd, {
    passive: !0
  }), n[m]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), n[m]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (r.preventClicks || r.preventClicksPropagation) && s[m]("click", e.onClick, !0), r.cssMode && o[m]("scroll", e.onScroll), r.updateOnWindowResize ? e[y](c.ios || c.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", lH, !0) : e[y]("observerUpdate", lH, !0), s[m]("load", e.onLoad, {
    capture: !0
  }));
};
function hwe() {
  const e = this, {
    params: t
  } = e;
  e.onTouchStart = owe.bind(e), e.onTouchMove = lwe.bind(e), e.onTouchEnd = cwe.bind(e), e.onDocumentTouchStart = mwe.bind(e), t.cssMode && (e.onScroll = dwe.bind(e)), e.onClick = uwe.bind(e), e.onLoad = fwe.bind(e), yq(e, "on");
}
function pwe() {
  yq(this, "off");
}
var gwe = {
  attachEvents: hwe,
  detachEvents: pwe
};
const cH = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function ywe() {
  const e = this, {
    realIndex: t,
    initialized: n,
    params: r,
    el: s
  } = e, o = r.breakpoints;
  if (!o || o && Object.keys(o).length === 0) return;
  const c = e.getBreakpoint(o, e.params.breakpointsBase, e.el);
  if (!c || e.currentBreakpoint === c) return;
  const m = (c in o ? o[c] : void 0) || e.originalParams, y = cH(e, r), b = cH(e, m), w = e.params.grabCursor, k = m.grabCursor, j = r.enabled;
  y && !b ? (s.classList.remove(`${r.containerModifierClass}grid`, `${r.containerModifierClass}grid-column`), e.emitContainerClasses()) : !y && b && (s.classList.add(`${r.containerModifierClass}grid`), (m.grid.fill && m.grid.fill === "column" || !m.grid.fill && r.grid.fill === "column") && s.classList.add(`${r.containerModifierClass}grid-column`), e.emitContainerClasses()), w && !k ? e.unsetGrabCursor() : !w && k && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((R) => {
    if (typeof m[R] > "u") return;
    const U = r[R] && r[R].enabled, z = m[R] && m[R].enabled;
    U && !z && e[R].disable(), !U && z && e[R].enable();
  });
  const E = m.direction && m.direction !== r.direction, T = r.loop && (m.slidesPerView !== r.slidesPerView || E), D = r.loop;
  E && n && e.changeDirection(), dp(e.params, m);
  const L = e.params.enabled, I = e.params.loop;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), j && !L ? e.disable() : !j && L && e.enable(), e.currentBreakpoint = c, e.emit("_beforeBreakpoint", m), n && (T ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !D && I ? (e.loopCreate(t), e.updateSlides()) : D && !I && e.loopDestroy()), e.emit("breakpoint", m);
}
function vwe(e, t, n) {
  if (t === void 0 && (t = "window"), !e || t === "container" && !n) return;
  let r = !1;
  const s = Sp(), o = t === "window" ? s.innerHeight : n.clientHeight, c = Object.keys(e).map((u) => {
    if (typeof u == "string" && u.indexOf("@") === 0) {
      const m = parseFloat(u.substr(1));
      return {
        value: o * m,
        point: u
      };
    }
    return {
      value: u,
      point: u
    };
  });
  c.sort((u, m) => parseInt(u.value, 10) - parseInt(m.value, 10));
  for (let u = 0; u < c.length; u += 1) {
    const {
      point: m,
      value: y
    } = c[u];
    t === "window" ? s.matchMedia(`(min-width: ${y}px)`).matches && (r = m) : y <= n.clientWidth && (r = m);
  }
  return r || "max";
}
var xwe = {
  setBreakpoint: ywe,
  getBreakpoint: vwe
};
function bwe(e, t) {
  const n = [];
  return e.forEach((r) => {
    typeof r == "object" ? Object.keys(r).forEach((s) => {
      r[s] && n.push(t + s);
    }) : typeof r == "string" && n.push(t + r);
  }), n;
}
function Swe() {
  const e = this, {
    classNames: t,
    params: n,
    rtl: r,
    el: s,
    device: o
  } = e, c = bwe(["initialized", n.direction, {
    "free-mode": e.params.freeMode && n.freeMode.enabled
  }, {
    autoheight: n.autoHeight
  }, {
    rtl: r
  }, {
    grid: n.grid && n.grid.rows > 1
  }, {
    "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
  }, {
    android: o.android
  }, {
    ios: o.ios
  }, {
    "css-mode": n.cssMode
  }, {
    centered: n.cssMode && n.centeredSlides
  }, {
    "watch-progress": n.watchSlidesProgress
  }], n.containerModifierClass);
  t.push(...c), s.classList.add(...t), e.emitContainerClasses();
}
function wwe() {
  const e = this, {
    el: t,
    classNames: n
  } = e;
  !t || typeof t == "string" || (t.classList.remove(...n), e.emitContainerClasses());
}
var Cwe = {
  addClasses: Swe,
  removeClasses: wwe
};
function Nwe() {
  const e = this, {
    isLocked: t,
    params: n
  } = e, {
    slidesOffsetBefore: r
  } = n;
  if (r) {
    const s = e.slides.length - 1, o = e.slidesGrid[s] + e.slidesSizesGrid[s] + r * 2;
    e.isLocked = e.size > o;
  } else
    e.isLocked = e.snapGrid.length === 1;
  n.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), n.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
var jwe = {
  checkOverflow: Nwe
}, uP = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function Ewe(e, t) {
  return function(r) {
    r === void 0 && (r = {});
    const s = Object.keys(r)[0], o = r[s];
    if (typeof o != "object" || o === null) {
      dp(t, r);
      return;
    }
    if (e[s] === !0 && (e[s] = {
      enabled: !0
    }), s === "navigation" && e[s] && e[s].enabled && !e[s].prevEl && !e[s].nextEl && (e[s].auto = !0), ["pagination", "scrollbar"].indexOf(s) >= 0 && e[s] && e[s].enabled && !e[s].el && (e[s].auto = !0), !(s in e && "enabled" in o)) {
      dp(t, r);
      return;
    }
    typeof e[s] == "object" && !("enabled" in e[s]) && (e[s].enabled = !0), e[s] || (e[s] = {
      enabled: !1
    }), dp(t, r);
  };
}
const OR = {
  eventsEmitter: C8e,
  update: O8e,
  translate: z8e,
  transition: $8e,
  slide: Z8e,
  loop: nwe,
  grabCursor: swe,
  events: gwe,
  breakpoints: xwe,
  checkOverflow: jwe,
  classes: Cwe
}, AR = {};
let FA = class Ev {
  constructor() {
    let t, n;
    for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++)
      s[o] = arguments[o];
    s.length === 1 && s[0].constructor && Object.prototype.toString.call(s[0]).slice(8, -1) === "Object" ? n = s[0] : [t, n] = s, n || (n = {}), n = dp({}, n), t && !n.el && (n.el = t);
    const c = my();
    if (n.el && typeof n.el == "string" && c.querySelectorAll(n.el).length > 1) {
      const b = [];
      return c.querySelectorAll(n.el).forEach((w) => {
        const k = dp({}, n, {
          el: w
        });
        b.push(new Ev(k));
      }), b;
    }
    const u = this;
    u.__swiper__ = !0, u.support = hq(), u.device = pq({
      userAgent: n.userAgent
    }), u.browser = b8e(), u.eventsListeners = {}, u.eventsAnyListeners = [], u.modules = [...u.__modules__], n.modules && Array.isArray(n.modules) && u.modules.push(...n.modules);
    const m = {};
    u.modules.forEach((b) => {
      b({
        params: n,
        swiper: u,
        extendParams: Ewe(n, m),
        on: u.on.bind(u),
        once: u.once.bind(u),
        off: u.off.bind(u),
        emit: u.emit.bind(u)
      });
    });
    const y = dp({}, uP, m);
    return u.params = dp({}, y, AR, n), u.originalParams = dp({}, u.params), u.passedParams = dp({}, n), u.params && u.params.on && Object.keys(u.params.on).forEach((b) => {
      u.on(b, u.params.on[b]);
    }), u.params && u.params.onAny && u.onAny(u.params.onAny), Object.assign(u, {
      enabled: u.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return u.params.direction === "horizontal";
      },
      isVertical() {
        return u.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: u.params.allowSlideNext,
      allowSlidePrev: u.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: u.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: u.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), u.emit("_swiper"), u.params.init && u.init(), u;
  }
  getDirectionLabel(t) {
    return this.isHorizontal() ? t : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[t];
  }
  getSlideIndex(t) {
    const {
      slidesEl: n,
      params: r
    } = this, s = uy(n, `.${r.slideClass}, swiper-slide`), o = aH(s[0]);
    return aH(t) - o;
  }
  getSlideIndexByData(t) {
    return this.getSlideIndex(this.slides.filter((n) => n.getAttribute("data-swiper-slide-index") * 1 === t)[0]);
  }
  recalcSlides() {
    const t = this, {
      slidesEl: n,
      params: r
    } = t;
    t.slides = uy(n, `.${r.slideClass}, swiper-slide`);
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, n) {
    const r = this;
    t = Math.min(Math.max(t, 0), 1);
    const s = r.minTranslate(), c = (r.maxTranslate() - s) * t + s;
    r.translateTo(c, typeof n > "u" ? 0 : n), r.updateActiveIndex(), r.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const n = t.el.className.split(" ").filter((r) => r.indexOf("swiper") === 0 || r.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", n.join(" "));
  }
  getSlideClasses(t) {
    const n = this;
    return n.destroyed ? "" : t.className.split(" ").filter((r) => r.indexOf("swiper-slide") === 0 || r.indexOf(n.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const n = [];
    t.slides.forEach((r) => {
      const s = t.getSlideClasses(r);
      n.push({
        slideEl: r,
        classNames: s
      }), t.emit("_slideClass", r, s);
    }), t.emit("_slideClasses", n);
  }
  slidesPerViewDynamic(t, n) {
    t === void 0 && (t = "current"), n === void 0 && (n = !1);
    const r = this, {
      params: s,
      slides: o,
      slidesGrid: c,
      slidesSizesGrid: u,
      size: m,
      activeIndex: y
    } = r;
    let b = 1;
    if (typeof s.slidesPerView == "number") return s.slidesPerView;
    if (s.centeredSlides) {
      let w = o[y] ? Math.ceil(o[y].swiperSlideSize) : 0, k;
      for (let j = y + 1; j < o.length; j += 1)
        o[j] && !k && (w += Math.ceil(o[j].swiperSlideSize), b += 1, w > m && (k = !0));
      for (let j = y - 1; j >= 0; j -= 1)
        o[j] && !k && (w += o[j].swiperSlideSize, b += 1, w > m && (k = !0));
    } else if (t === "current")
      for (let w = y + 1; w < o.length; w += 1)
        (n ? c[w] + u[w] - c[y] < m : c[w] - c[y] < m) && (b += 1);
    else
      for (let w = y - 1; w >= 0; w -= 1)
        c[y] - c[w] < m && (b += 1);
    return b;
  }
  update() {
    const t = this;
    if (!t || t.destroyed) return;
    const {
      snapGrid: n,
      params: r
    } = t;
    r.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((c) => {
      c.complete && d9(t, c);
    }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function s() {
      const c = t.rtlTranslate ? t.translate * -1 : t.translate, u = Math.min(Math.max(c, t.maxTranslate()), t.minTranslate());
      t.setTranslate(u), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let o;
    if (r.freeMode && r.freeMode.enabled && !r.cssMode)
      s(), r.autoHeight && t.updateAutoHeight();
    else {
      if ((r.slidesPerView === "auto" || r.slidesPerView > 1) && t.isEnd && !r.centeredSlides) {
        const c = t.virtual && r.virtual.enabled ? t.virtual.slides : t.slides;
        o = t.slideTo(c.length - 1, 0, !1, !0);
      } else
        o = t.slideTo(t.activeIndex, 0, !1, !0);
      o || s();
    }
    r.watchOverflow && n !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, n) {
    n === void 0 && (n = !0);
    const r = this, s = r.params.direction;
    return t || (t = s === "horizontal" ? "vertical" : "horizontal"), t === s || t !== "horizontal" && t !== "vertical" || (r.el.classList.remove(`${r.params.containerModifierClass}${s}`), r.el.classList.add(`${r.params.containerModifierClass}${t}`), r.emitContainerClasses(), r.params.direction = t, r.slides.forEach((o) => {
      t === "vertical" ? o.style.width = "" : o.style.height = "";
    }), r.emit("changeDirection"), n && r.update()), r;
  }
  changeLanguageDirection(t) {
    const n = this;
    n.rtl && t === "rtl" || !n.rtl && t === "ltr" || (n.rtl = t === "rtl", n.rtlTranslate = n.params.direction === "horizontal" && n.rtl, n.rtl ? (n.el.classList.add(`${n.params.containerModifierClass}rtl`), n.el.dir = "rtl") : (n.el.classList.remove(`${n.params.containerModifierClass}rtl`), n.el.dir = "ltr"), n.update());
  }
  mount(t) {
    const n = this;
    if (n.mounted) return !0;
    let r = t || n.params.el;
    if (typeof r == "string" && (r = document.querySelector(r)), !r)
      return !1;
    r.swiper = n, r.parentNode && r.parentNode.host && r.parentNode.host.nodeName === n.params.swiperElementNodeName.toUpperCase() && (n.isElement = !0);
    const s = () => `.${(n.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let c = r && r.shadowRoot && r.shadowRoot.querySelector ? r.shadowRoot.querySelector(s()) : uy(r, s())[0];
    return !c && n.params.createElements && (c = L3("div", n.params.wrapperClass), r.append(c), uy(r, `.${n.params.slideClass}`).forEach((u) => {
      c.append(u);
    })), Object.assign(n, {
      el: r,
      wrapperEl: c,
      slidesEl: n.isElement && !r.parentNode.host.slideSlots ? r.parentNode.host : c,
      hostEl: n.isElement ? r.parentNode.host : r,
      mounted: !0,
      // RTL
      rtl: r.dir.toLowerCase() === "rtl" || R2(r, "direction") === "rtl",
      rtlTranslate: n.params.direction === "horizontal" && (r.dir.toLowerCase() === "rtl" || R2(r, "direction") === "rtl"),
      wrongRTL: R2(c, "display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const n = this;
    if (n.initialized || n.mount(t) === !1) return n;
    n.emit("beforeInit"), n.params.breakpoints && n.setBreakpoint(), n.addClasses(), n.updateSize(), n.updateSlides(), n.params.watchOverflow && n.checkOverflow(), n.params.grabCursor && n.enabled && n.setGrabCursor(), n.params.loop && n.virtual && n.params.virtual.enabled ? n.slideTo(n.params.initialSlide + n.virtual.slidesBefore, 0, n.params.runCallbacksOnInit, !1, !0) : n.slideTo(n.params.initialSlide, 0, n.params.runCallbacksOnInit, !1, !0), n.params.loop && n.loopCreate(), n.attachEvents();
    const s = [...n.el.querySelectorAll('[loading="lazy"]')];
    return n.isElement && s.push(...n.hostEl.querySelectorAll('[loading="lazy"]')), s.forEach((o) => {
      o.complete ? d9(n, o) : o.addEventListener("load", (c) => {
        d9(n, c.target);
      });
    }), cP(n), n.initialized = !0, cP(n), n.emit("init"), n.emit("afterInit"), n;
  }
  destroy(t, n) {
    t === void 0 && (t = !0), n === void 0 && (n = !0);
    const r = this, {
      params: s,
      el: o,
      wrapperEl: c,
      slides: u
    } = r;
    return typeof r.params > "u" || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), s.loop && r.loopDestroy(), n && (r.removeClasses(), o && typeof o != "string" && o.removeAttribute("style"), c && c.removeAttribute("style"), u && u.length && u.forEach((m) => {
      m.classList.remove(s.slideVisibleClass, s.slideFullyVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass), m.removeAttribute("style"), m.removeAttribute("data-swiper-slide-index");
    })), r.emit("destroy"), Object.keys(r.eventsListeners).forEach((m) => {
      r.off(m);
    }), t !== !1 && (r.el && typeof r.el != "string" && (r.el.swiper = null), c8e(r)), r.destroyed = !0), null;
  }
  static extendDefaults(t) {
    dp(AR, t);
  }
  static get extendedDefaults() {
    return AR;
  }
  static get defaults() {
    return uP;
  }
  static installModule(t) {
    Ev.prototype.__modules__ || (Ev.prototype.__modules__ = []);
    const n = Ev.prototype.__modules__;
    typeof t == "function" && n.indexOf(t) < 0 && n.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((n) => Ev.installModule(n)), Ev) : (Ev.installModule(t), Ev);
  }
};
Object.keys(OR).forEach((e) => {
  Object.keys(OR[e]).forEach((t) => {
    FA.prototype[t] = OR[e][t];
  });
});
FA.use([S8e, w8e]);
const vq = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function t5(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object" && !e.__swiper__;
}
function L8(e, t) {
  const n = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((r) => n.indexOf(r) < 0).forEach((r) => {
    typeof e[r] > "u" ? e[r] = t[r] : t5(t[r]) && t5(e[r]) && Object.keys(t[r]).length > 0 ? t[r].__swiper__ ? e[r] = t[r] : L8(e[r], t[r]) : e[r] = t[r];
  });
}
function xq(e) {
  return e === void 0 && (e = {}), e.navigation && typeof e.navigation.nextEl > "u" && typeof e.navigation.prevEl > "u";
}
function bq(e) {
  return e === void 0 && (e = {}), e.pagination && typeof e.pagination.el > "u";
}
function Sq(e) {
  return e === void 0 && (e = {}), e.scrollbar && typeof e.scrollbar.el > "u";
}
function wq(e) {
  e === void 0 && (e = "");
  const t = e.split(" ").map((r) => r.trim()).filter((r) => !!r), n = [];
  return t.forEach((r) => {
    n.indexOf(r) < 0 && n.push(r);
  }), n.join(" ");
}
function kwe(e) {
  return e === void 0 && (e = ""), e ? e.includes("swiper-wrapper") ? e : `swiper-wrapper ${e}` : "swiper-wrapper";
}
function _we(e) {
  let {
    swiper: t,
    slides: n,
    passedParams: r,
    changedParams: s,
    nextEl: o,
    prevEl: c,
    scrollbarEl: u,
    paginationEl: m
  } = e;
  const y = s.filter((Q) => Q !== "children" && Q !== "direction" && Q !== "wrapperClass"), {
    params: b,
    pagination: w,
    navigation: k,
    scrollbar: j,
    virtual: E,
    thumbs: T
  } = t;
  let D, L, I, R, U, z, H, K;
  s.includes("thumbs") && r.thumbs && r.thumbs.swiper && b.thumbs && !b.thumbs.swiper && (D = !0), s.includes("controller") && r.controller && r.controller.control && b.controller && !b.controller.control && (L = !0), s.includes("pagination") && r.pagination && (r.pagination.el || m) && (b.pagination || b.pagination === !1) && w && !w.el && (I = !0), s.includes("scrollbar") && r.scrollbar && (r.scrollbar.el || u) && (b.scrollbar || b.scrollbar === !1) && j && !j.el && (R = !0), s.includes("navigation") && r.navigation && (r.navigation.prevEl || c) && (r.navigation.nextEl || o) && (b.navigation || b.navigation === !1) && k && !k.prevEl && !k.nextEl && (U = !0);
  const q = (Q) => {
    t[Q] && (t[Q].destroy(), Q === "navigation" ? (t.isElement && (t[Q].prevEl.remove(), t[Q].nextEl.remove()), b[Q].prevEl = void 0, b[Q].nextEl = void 0, t[Q].prevEl = void 0, t[Q].nextEl = void 0) : (t.isElement && t[Q].el.remove(), b[Q].el = void 0, t[Q].el = void 0));
  };
  s.includes("loop") && t.isElement && (b.loop && !r.loop ? z = !0 : !b.loop && r.loop ? H = !0 : K = !0), y.forEach((Q) => {
    if (t5(b[Q]) && t5(r[Q]))
      Object.assign(b[Q], r[Q]), (Q === "navigation" || Q === "pagination" || Q === "scrollbar") && "enabled" in r[Q] && !r[Q].enabled && q(Q);
    else {
      const Z = r[Q];
      (Z === !0 || Z === !1) && (Q === "navigation" || Q === "pagination" || Q === "scrollbar") ? Z === !1 && q(Q) : b[Q] = r[Q];
    }
  }), y.includes("controller") && !L && t.controller && t.controller.control && b.controller && b.controller.control && (t.controller.control = b.controller.control), s.includes("children") && n && E && b.virtual.enabled ? (E.slides = n, E.update(!0)) : s.includes("virtual") && E && b.virtual.enabled && (n && (E.slides = n), E.update(!0)), s.includes("children") && n && b.loop && (K = !0), D && T.init() && T.update(!0), L && (t.controller.control = b.controller.control), I && (t.isElement && (!m || typeof m == "string") && (m = document.createElement("div"), m.classList.add("swiper-pagination"), m.part.add("pagination"), t.el.appendChild(m)), m && (b.pagination.el = m), w.init(), w.render(), w.update()), R && (t.isElement && (!u || typeof u == "string") && (u = document.createElement("div"), u.classList.add("swiper-scrollbar"), u.part.add("scrollbar"), t.el.appendChild(u)), u && (b.scrollbar.el = u), j.init(), j.updateSize(), j.setTranslate()), U && (t.isElement && ((!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-button-next"), o.innerHTML = t.hostEl.constructor.nextButtonSvg, o.part.add("button-next"), t.el.appendChild(o)), (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-button-prev"), c.innerHTML = t.hostEl.constructor.prevButtonSvg, c.part.add("button-prev"), t.el.appendChild(c))), o && (b.navigation.nextEl = o), c && (b.navigation.prevEl = c), k.init(), k.update()), s.includes("allowSlideNext") && (t.allowSlideNext = r.allowSlideNext), s.includes("allowSlidePrev") && (t.allowSlidePrev = r.allowSlidePrev), s.includes("direction") && t.changeDirection(r.direction, !1), (z || K) && t.loopDestroy(), (H || K) && t.loopCreate(), t.update();
}
function Twe(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = !0);
  const n = {
    on: {}
  }, r = {}, s = {};
  L8(n, uP), n._emitClasses = !0, n.init = !1;
  const o = {}, c = vq.map((m) => m.replace(/_/, "")), u = Object.assign({}, e);
  return Object.keys(u).forEach((m) => {
    typeof e[m] > "u" || (c.indexOf(m) >= 0 ? t5(e[m]) ? (n[m] = {}, s[m] = {}, L8(n[m], e[m]), L8(s[m], e[m])) : (n[m] = e[m], s[m] = e[m]) : m.search(/on[A-Z]/) === 0 && typeof e[m] == "function" ? t ? r[`${m[2].toLowerCase()}${m.substr(3)}`] = e[m] : n.on[`${m[2].toLowerCase()}${m.substr(3)}`] = e[m] : o[m] = e[m]);
  }), ["navigation", "pagination", "scrollbar"].forEach((m) => {
    n[m] === !0 && (n[m] = {}), n[m] === !1 && delete n[m];
  }), {
    params: n,
    passedParams: s,
    rest: o,
    events: r
  };
}
function Mwe(e, t) {
  let {
    el: n,
    nextEl: r,
    prevEl: s,
    paginationEl: o,
    scrollbarEl: c,
    swiper: u
  } = e;
  xq(t) && r && s && (u.params.navigation.nextEl = r, u.originalParams.navigation.nextEl = r, u.params.navigation.prevEl = s, u.originalParams.navigation.prevEl = s), bq(t) && o && (u.params.pagination.el = o, u.originalParams.pagination.el = o), Sq(t) && c && (u.params.scrollbar.el = c, u.originalParams.scrollbar.el = c), u.init(n);
}
function Rwe(e, t, n, r, s) {
  const o = [];
  if (!t) return o;
  const c = (m) => {
    o.indexOf(m) < 0 && o.push(m);
  };
  if (n && r) {
    const m = r.map(s), y = n.map(s);
    m.join("") !== y.join("") && c("children"), r.length !== n.length && c("children");
  }
  return vq.filter((m) => m[0] === "_").map((m) => m.replace(/_/, "")).forEach((m) => {
    if (m in e && m in t)
      if (t5(e[m]) && t5(t[m])) {
        const y = Object.keys(e[m]), b = Object.keys(t[m]);
        y.length !== b.length ? c(m) : (y.forEach((w) => {
          e[m][w] !== t[m][w] && c(m);
        }), b.forEach((w) => {
          e[m][w] !== t[m][w] && c(m);
        }));
      } else e[m] !== t[m] && c(m);
  }), o;
}
const Dwe = (e) => {
  !e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
};
function rE() {
  return rE = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rE.apply(this, arguments);
}
function Cq(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function Nq(e) {
  const t = [];
  return Ee.Children.toArray(e).forEach((n) => {
    Cq(n) ? t.push(n) : n.props && n.props.children && Nq(n.props.children).forEach((r) => t.push(r));
  }), t;
}
function Pwe(e) {
  const t = [], n = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return Ee.Children.toArray(e).forEach((r) => {
    if (Cq(r))
      t.push(r);
    else if (r.props && r.props.slot && n[r.props.slot])
      n[r.props.slot].push(r);
    else if (r.props && r.props.children) {
      const s = Nq(r.props.children);
      s.length > 0 ? s.forEach((o) => t.push(o)) : n["container-end"].push(r);
    } else
      n["container-end"].push(r);
  }), {
    slides: t,
    slots: n
  };
}
function Owe(e, t, n) {
  if (!n) return null;
  const r = (b) => {
    let w = b;
    return b < 0 ? w = t.length + b : w >= t.length && (w = w - t.length), w;
  }, s = e.isHorizontal() ? {
    [e.rtlTranslate ? "right" : "left"]: `${n.offset}px`
  } : {
    top: `${n.offset}px`
  }, {
    from: o,
    to: c
  } = n, u = e.params.loop ? -t.length : 0, m = e.params.loop ? t.length * 2 : t.length, y = [];
  for (let b = u; b < m; b += 1)
    b >= o && b <= c && y.push(t[r(b)]);
  return y.map((b, w) => /* @__PURE__ */ Ee.cloneElement(b, {
    swiper: e,
    style: s,
    key: b.props.virtualIndex || b.key || `slide-${w}`
  }));
}
function g3(e, t) {
  return typeof window > "u" ? an(e, t) : a5(e, t);
}
const uH = /* @__PURE__ */ ys(null), Awe = /* @__PURE__ */ ys(null), Av = /* @__PURE__ */ yn(function(e, t) {
  let {
    className: n,
    tag: r = "div",
    wrapperTag: s = "div",
    children: o,
    onSwiper: c,
    ...u
  } = e === void 0 ? {} : e, m = !1;
  const [y, b] = Re("swiper"), [w, k] = Re(null), [j, E] = Re(!1), T = Rt(!1), D = Rt(null), L = Rt(null), I = Rt(null), R = Rt(null), U = Rt(null), z = Rt(null), H = Rt(null), K = Rt(null), {
    params: q,
    passedParams: Q,
    rest: Z,
    events: X
  } = Twe(u), {
    slides: se,
    slots: te
  } = Pwe(o), fe = () => {
    E(!j);
  };
  Object.assign(q.on, {
    _containerClasses(ue, he) {
      b(he);
    }
  });
  const ce = () => {
    Object.assign(q.on, X), m = !0;
    const ue = {
      ...q
    };
    if (delete ue.wrapperClass, L.current = new FA(ue), L.current.virtual && L.current.params.virtual.enabled) {
      L.current.virtual.slides = se;
      const he = {
        cache: !1,
        slides: se,
        renderExternal: k,
        renderExternalUpdate: !1
      };
      L8(L.current.params.virtual, he), L8(L.current.originalParams.virtual, he);
    }
  };
  D.current || ce(), L.current && L.current.on("_beforeBreakpoint", fe);
  const pe = () => {
    m || !X || !L.current || Object.keys(X).forEach((ue) => {
      L.current.on(ue, X[ue]);
    });
  }, Se = () => {
    !X || !L.current || Object.keys(X).forEach((ue) => {
      L.current.off(ue, X[ue]);
    });
  };
  an(() => () => {
    L.current && L.current.off("_beforeBreakpoint", fe);
  }), an(() => {
    !T.current && L.current && (L.current.emitSlidesClasses(), T.current = !0);
  }), g3(() => {
    if (t && (t.current = D.current), !!D.current)
      return L.current.destroyed && ce(), Mwe({
        el: D.current,
        nextEl: U.current,
        prevEl: z.current,
        paginationEl: H.current,
        scrollbarEl: K.current,
        swiper: L.current
      }, q), c && !L.current.destroyed && c(L.current), () => {
        L.current && !L.current.destroyed && L.current.destroy(!0, !1);
      };
  }, []), g3(() => {
    pe();
    const ue = Rwe(Q, I.current, se, R.current, (he) => he.key);
    return I.current = Q, R.current = se, ue.length && L.current && !L.current.destroyed && _we({
      swiper: L.current,
      slides: se,
      passedParams: Q,
      changedParams: ue,
      nextEl: U.current,
      prevEl: z.current,
      scrollbarEl: K.current,
      paginationEl: H.current
    }), () => {
      Se();
    };
  }), g3(() => {
    Dwe(L.current);
  }, [w]);
  function oe() {
    return q.virtual ? Owe(L.current, se, w) : se.map((ue, he) => /* @__PURE__ */ Ee.cloneElement(ue, {
      swiper: L.current,
      swiperSlideIndex: he
    }));
  }
  return /* @__PURE__ */ Ee.createElement(r, rE({
    ref: D,
    className: wq(`${y}${n ? ` ${n}` : ""}`)
  }, Z), /* @__PURE__ */ Ee.createElement(Awe.Provider, {
    value: L.current
  }, te["container-start"], /* @__PURE__ */ Ee.createElement(s, {
    className: kwe(q.wrapperClass)
  }, te["wrapper-start"], oe(), te["wrapper-end"]), xq(q) && /* @__PURE__ */ Ee.createElement(Ee.Fragment, null, /* @__PURE__ */ Ee.createElement("div", {
    ref: z,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ Ee.createElement("div", {
    ref: U,
    className: "swiper-button-next"
  })), Sq(q) && /* @__PURE__ */ Ee.createElement("div", {
    ref: K,
    className: "swiper-scrollbar"
  }), bq(q) && /* @__PURE__ */ Ee.createElement("div", {
    ref: H,
    className: "swiper-pagination"
  }), te["container-end"]));
});
Av.displayName = "Swiper";
const Vg = /* @__PURE__ */ yn(function(e, t) {
  let {
    tag: n = "div",
    children: r,
    className: s = "",
    swiper: o,
    zoom: c,
    lazy: u,
    virtualIndex: m,
    swiperSlideIndex: y,
    ...b
  } = e === void 0 ? {} : e;
  const w = Rt(null), [k, j] = Re("swiper-slide"), [E, T] = Re(!1);
  function D(U, z, H) {
    z === w.current && j(H);
  }
  g3(() => {
    if (typeof y < "u" && (w.current.swiperSlideIndex = y), t && (t.current = w.current), !(!w.current || !o)) {
      if (o.destroyed) {
        k !== "swiper-slide" && j("swiper-slide");
        return;
      }
      return o.on("_slideClass", D), () => {
        o && o.off("_slideClass", D);
      };
    }
  }), g3(() => {
    o && w.current && !o.destroyed && j(o.getSlideClasses(w.current));
  }, [o]);
  const L = {
    isActive: k.indexOf("swiper-slide-active") >= 0,
    isVisible: k.indexOf("swiper-slide-visible") >= 0,
    isPrev: k.indexOf("swiper-slide-prev") >= 0,
    isNext: k.indexOf("swiper-slide-next") >= 0
  }, I = () => typeof r == "function" ? r(L) : r, R = () => {
    T(!0);
  };
  return /* @__PURE__ */ Ee.createElement(n, rE({
    ref: w,
    className: wq(`${k}${s ? ` ${s}` : ""}`),
    "data-swiper-slide-index": m,
    onLoad: R
  }, b), c && /* @__PURE__ */ Ee.createElement(uH.Provider, {
    value: L
  }, /* @__PURE__ */ Ee.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof c == "number" ? c : void 0
  }, I(), u && !E && /* @__PURE__ */ Ee.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !c && /* @__PURE__ */ Ee.createElement(uH.Provider, {
    value: L
  }, I(), u && !E && /* @__PURE__ */ Ee.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
Vg.displayName = "SwiperSlide";
const UA = Qt(Vn), Lwe = Qt((e) => {
  const t = e(UA);
  if (t === Vn)
    throw new Error(Xr(ia.Memberships));
  return t.items.filter((n) => n.state === "OPEN");
}), jq = Qt(
  Vn
), Iwe = () => {
  const [e, t] = Ar(UA), n = Y3(Lwe);
  if (e === Vn)
    throw new Error(Xr("memberships"));
  return {
    memberships: e,
    openMembershipsItems: n,
    setMemberships: t
  };
}, Fwe = () => {
  const [e, t] = Ar(jq);
  if (e === Vn)
    throw new Error(Xr("projectCover"));
  return {
    projectCover: e,
    setProjectCover: t
  };
}, dH = {
  cietySymbol: ek
}, Uwe = {
  lg: $(
    "typo-mshop-kr-16-b h-[4rem] gap-x-[.57143rem] rounded-[.85714rem] px-[1.71428rem] py-[1.14285rem]"
  ),
  sm: $(
    "typo-mshop-kr-14-b h-[2.85714rem] gap-x-[.28571rem] rounded-[.57142rem] px-[1.71428rem] py-[0.64285rem]"
  )
}, zwe = {
  lg: $(
    "bg-mshop-black text-ciety-lg",
    "hover:bg-ciety-lg hover:text-mshop-black",
    "disabled:bg-mshop-gray-5 disabled:bg-mshop-gray-50"
  ),
  bright: $(
    "border border-mshop-gray-20 bg-mshop-bright-20 text-mshop-white",
    "hover:bg-mshop-bright-5",
    "disabled:bg-mshop-gray-5 disabled:bg-mshop-gray-50"
  )
}, fH = {
  lg: "size-[1.42857rem]",
  sm: "size-[1.14285rem]"
};
function Y2({
  children: e,
  variant: t,
  theme: n,
  iconFront: r,
  iconRear: s,
  widthFull: o,
  ...c
}) {
  const u = r ? dH[r] : null, m = s ? dH[s] : null;
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...c,
      className: $(
        "flex-center transition duration-200",
        Uwe[t],
        zwe[n],
        {
          "w-full": o
        }
      ),
      children: (y) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        u && /* @__PURE__ */ a.jsx(u, { className: $("shrink-0", fH[t]) }),
        /* @__PURE__ */ a.jsx("span", { className: "shrink-0", children: typeof e == "function" ? e(y) : e }),
        m && /* @__PURE__ */ a.jsx(m, { className: $("shrink-0", fH[t]) })
      ] })
    }
  );
}
function Eq({
  communityRewards: e,
  subdomain: t
}) {
  const {
    widgetCore: { isMobile: n }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "flex flex-col",
        n ? "gap-[0.85714rem]" : "gap-[.57rem]"
      ),
      children: [
        /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-b text-mshop-black", children: "사이어티 커뮤니티 혜택" }),
        /* @__PURE__ */ a.jsx(
          "ul",
          {
            className: $("flex flex-col gap-[.86rem]", {
              "rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14rem]": !n
            }),
            children: e.map((r) => /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[.57rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.57143rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[.1429rem] bg-mshop-black" }) }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "whitespace-pre-wrap break-all text-mshop-black",
                      n ? "typo-mshop-kr-14-m" : "typo-mshop-kr-14-b"
                    ),
                    children: r.title ?? d6[r.type]
                  }
                ),
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: Vv[r.type] }),
                r.type !== "DM" && /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "flex flex-wrap",
                      n ? "gap-[0.57143rem] py-[0.28571rem]" : "gap-[0.28571rem] pt-[0.28571rem]"
                    ),
                    children: [
                      ...r.channels.filter(
                        (s) => s.visibility !== "PRIVATE"
                      ),
                      ...r.channels.filter(
                        (s) => s.visibility === "PRIVATE"
                      )
                    ].map((s) => {
                      const o = u6[s.type];
                      return /* @__PURE__ */ a.jsxs(
                        "a",
                        {
                          className: $(
                            "flex items-center gap-[0.28571rem] rounded-[0.28571rem] bg-mshop-gray-5",
                            n ? "max-w-[14.57143rem] px-[0.57143rem] py-[0.28571rem]" : "min-h-[2.85714rem] max-w-[15.14286rem] px-[0.85714rem]"
                          ),
                          href: s.visibility === "PRIVATE" ? Ku({
                            type: "home",
                            subdomain: t
                          }) : Ku({
                            type: "channel",
                            subdomain: t,
                            channelId: s.id
                          }),
                          target: "_blank",
                          children: [
                            /* @__PURE__ */ a.jsx(o, { className: "size-[1.14286rem] shrink-0 text-mshop-gray-80" }),
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: s.displayName ?? `비공개 채널 ${s.count}개` })
                          ]
                        },
                        s.id
                      );
                    })
                  }
                )
              ] })
            ] }, r.id))
          }
        )
      ]
    }
  );
}
function kq({ creatorRewards: e }) {
  const {
    widgetCore: { isMobile: t }
  } = Gt();
  return /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[.57rem]", children: [
    /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-b text-mshop-black", children: "크리에이터 혜택" }),
    /* @__PURE__ */ a.jsx("ul", { className: "flex flex-col gap-[.86rem] rounded-[0.85714rem]", children: e.map(({ id: n, title: r, type: s }) => /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[.57rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.57143rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[.1429rem] bg-mshop-black" }) }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $(
              "whitespace-pre-wrap break-all text-mshop-black",
              t ? "typo-mshop-kr-14-m" : "typo-mshop-kr-14-b"
            ),
            children: r
          }
        ),
        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: Vv[s] })
      ] })
    ] }, n)) })
  ] });
}
const Bwe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, viewBox: "0 0 25 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M20.4559 17.6584L18.1591 19.9553C17.8091 20.3053 17.233 20.3126 16.8757 19.9553C16.5184 19.598 16.5184 19.0292 16.8757 18.672L19.1726 16.3751C19.5226 16.0251 20.0987 16.0178 20.4559 16.3751C20.8132 16.7324 20.8132 17.3011 20.4559 17.6584Z" }), /* @__PURE__ */ re.createElement("path", { d: "M18.1518 6.10841L15.2643 6.67716C15.1549 6.56778 15.0893 6.50216 15.0893 6.50216C14.2362 5.7657 13.2664 5.16049 12.2237 4.7157C9.35803 3.48341 6.60907 3.6657 5.55907 3.79695C5.24553 3.83341 4.95386 3.97924 4.72782 4.20528C4.50178 4.43132 4.35595 4.72299 4.31949 5.03653C4.18824 6.08653 4.00595 8.83549 5.23824 11.7011C5.68303 12.7438 6.28095 13.7063 7.01741 14.574C7.01741 14.574 7.08303 14.6397 7.1924 14.749L6.62365 17.6365C6.4997 18.1688 6.6747 18.6501 7.07574 18.8907L11.9976 22.573C12.5518 22.9084 13.3466 22.697 13.8862 22.1574C14.0684 21.9751 14.2216 21.749 14.3309 21.5084L15.2934 17.9792C15.2934 17.9792 15.3299 17.9574 15.3372 17.9501L18.4872 14.8001C18.4872 14.8001 18.5091 14.7636 18.5164 14.7563L22.0455 13.7938C22.2934 13.6917 22.5122 13.5313 22.6945 13.349C23.2341 12.8094 23.4455 12.0147 23.1101 11.4605L19.4278 6.53862C19.1799 6.14487 18.7059 5.97716 18.1737 6.08653L18.1518 6.10841ZM12.6174 20.8157L8.43928 17.6876L8.75282 16.0761C9.81741 16.8199 11.3632 17.6365 13.3684 18.0667L12.6174 20.8157ZM9.8174 10.7824C9.41636 10.3813 9.41636 9.72508 9.81741 9.32403C10.2184 8.92299 10.8747 8.92299 11.2757 9.32403C11.6768 9.72508 11.6768 10.3813 11.2757 10.7824C10.8747 11.1834 10.2184 11.1834 9.8174 10.7824ZM21.3091 12.124L18.5601 12.8751C18.1299 10.8844 17.3059 9.33133 16.5695 8.25945L18.1809 7.94591L21.3091 12.124Z" })), Hwe = yn(Bwe), LR = (e) => e.toString().padStart(2, "0");
function _q({
  payment: e,
  planVariant: t,
  onJoinMembershipButtonClick: n,
  onSeeMyMembershipRewardsButtonClick: r
}) {
  const [s, o] = Re(/* @__PURE__ */ new Date()), {
    widgetCore: { isApp: c }
  } = Gt(), u = c && (t === "default" || t === "recommended");
  if (an(() => {
    const m = setInterval(() => {
      o(/* @__PURE__ */ new Date());
    }, 1e3);
    return () => clearInterval(m);
  }, []), e.type === $n.ShortTermPass && e.startTimeAt && Uv(s, o9(e.startTimeAt))) {
    const m = ZO(o9(e.startTimeAt), s), {
      hours: y = 0,
      minutes: b = 0,
      seconds: w = 0
    } = Ife({
      start: s,
      end: o9(e.startTimeAt)
    });
    return (
      // Detached component
      /* @__PURE__ */ a.jsxs(
        "button",
        {
          type: "button",
          disabled: !0,
          className: $(
            "flex-center transition duration-200 hover:cursor-pointer disabled:cursor-default",
            "typo-mshop-kr-14-b h-[3.42857rem] min-w-[11.42857rem] gap-x-[.28571rem] rounded-[.57142rem] px-[1.71428rem]",
            "bg-mshop-pink-20 text-mshop-red-80",
            "w-full"
          ),
          children: [
            /* @__PURE__ */ a.jsx(Hwe, { className: "size-[1.14285rem] shrink-0" }),
            /* @__PURE__ */ a.jsx("span", { children: `${`${m > 0 ? `${m}D ` : ""}${LR(y)}:${LR(b)}:${LR(w)}`} 출시예정` })
          ]
        }
      )
    );
  } else return u ? /* @__PURE__ */ a.jsx(
    fn,
    {
      type: "button",
      variant: "md",
      theme: "blue",
      disabled: !0,
      widthFull: !0,
      children: "멤버십은 PC에서만 가입 가능해요"
    }
  ) : t === "joined" ? /* @__PURE__ */ a.jsx(
    fn,
    {
      type: "button",
      variant: "md",
      theme: "white",
      widthFull: !0,
      onClick: r,
      children: "내 멤버십 상세 보기"
    }
  ) : t === "closed" ? /* @__PURE__ */ a.jsx(
    fn,
    {
      type: "button",
      variant: "md",
      theme: "blue",
      disabled: !0,
      widthFull: !0,
      children: "가입이 마감되었어요"
    }
  ) : /* @__PURE__ */ a.jsx(
    fn,
    {
      type: "button",
      variant: "md",
      theme: "blue",
      widthFull: !0,
      onClick: n,
      children: "멤버십 가입하기"
    }
  );
}
function dy(e) {
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    e.property1 === "Membership" && e.property2 === "Icon" && /* @__PURE__ */ a.jsx("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black px-[0.21429rem] py-[0.07143rem]", children: /* @__PURE__ */ a.jsx(fu, { className: "size-[1.14286rem] shrink-0 text-mshop-white" }) }),
    e.property1 === "Membership" && e.property2 === "Icon+Text" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem]", children: [
      /* @__PURE__ */ a.jsx(fu, { className: "size-[1.14286rem] shrink-0 text-mshop-white" }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-white", children: "멤버십" })
    ] }),
    e.property1 === "Membership" && e.property2 === "Number" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[1.14286rem] shrink-0 text-mshop-white" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-white", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex h-[1.57143rem] items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-en-14-unica-r flex items-center justify-center self-stretch pb-[0.14286rem] text-mshop-white", children: e.count }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-white", children: "회차" })
      ] })
    ] }),
    e.property1 === "Membership" && e.property2 === "Expired" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-white py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[1.14286rem] shrink-0 text-mshop-black" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m flex h-[1.57143rem] items-center rounded-[0.28571rem] bg-mshop-white px-[0.28571rem] py-[0.07143rem] text-mshop-black", children: "만료" })
    ] }),
    e.property1 === "Membership" && e.property2 === "Closed" && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.28571rem] py-[0.07143rem] text-mshop-white", children: "가입 마감" }),
    e.property1 === "Support" && e.property2 === "Default" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m flex h-[1.57143rem] items-center rounded-[0.28571rem] bg-mshop-black px-[0.28571rem] py-[0.07143rem] text-mshop-white", children: "후원" }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex h-[1.57143rem] items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-en-14-unica-r flex items-center justify-center self-stretch pb-[0.14286rem] text-mshop-white", children: e.count }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-white", children: "회" })
      ] })
    ] }),
    e.property1 === "Support" && e.property2 === "Closed" && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.28571rem] py-[0.07143rem] text-mshop-white", children: "종료" }),
    e.property1 === "Commission" && e.property2 === "Text" && /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "커미션" }),
    e.property1 === "Commission" && e.property2 === "Awaiting" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "수락 대기" })
    ] }),
    e.property1 === "Commission" && e.property2 === "In Progress" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "작업 중" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Done" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "작업 완료" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Refund" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "환불 예정" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Refunded" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-white", children: "환불 완료" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Confirmed" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-white py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-black", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-white py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem] text-mshop-black", children: "구매 확정" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Pause" && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.28571rem] py-[0.07143rem] text-mshop-white", children: "일시 중단" })
  ] });
}
const Vwe = 7, $we = 5;
function Tq({
  productRewards: e,
  onDimThumbnailClick: t
}) {
  const [n, r] = Re(!1), {
    widgetCore: { isMobile: s }
  } = Gt(), o = s ? $we : Vwe;
  return /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
    /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-b", children: "멤버십 전용 상품" }),
    /* @__PURE__ */ a.jsx(
      "ul",
      {
        className: $("flex flex-col gap-[0.85714rem]", {
          "rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem]": !s
        }),
        children: e.map(({ id: c, title: u, type: m, products: y }) => /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[0.57143rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.57143rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[.1429rem] bg-mshop-black" }) }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex grow flex-col", children: [
            /* @__PURE__ */ a.jsx(
              "div",
              {
                className: $(
                  "whitespace-pre-wrap break-all text-mshop-black",
                  s ? "typo-mshop-kr-14-m" : "typo-mshop-kr-14-b"
                ),
                children: u ?? c6[m]
              }
            ),
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: Vv[m] }),
            y.length > 0 && /* @__PURE__ */ a.jsx(
              "div",
              {
                className: $(
                  "grid gap-[0.57143rem] pt-[0.28571rem]",
                  s ? "grid-cols-5" : "grid-cols-7"
                ),
                children: y.slice(0, o).sort((b, w) => w.price - b.price).map(
                  ({ id: b, image: w, imageRatio: k, link: j }, E) => E === o - 1 && y.length > o ? /* @__PURE__ */ a.jsxs(
                    "button",
                    {
                      type: "button",
                      className: "flex-center relative isolate aspect-square overflow-hidden rounded-[0.57143rem] bg-mshop-gray-5",
                      onClick: t,
                      children: [
                        /* @__PURE__ */ a.jsx(
                          "img",
                          {
                            alt: "",
                            src: w,
                            className: "aspect-square object-cover",
                            style: {
                              width: `${k}%`
                            },
                            onLoad: () => r(!0)
                          }
                        ),
                        n && /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $(
                              "flex-center absolute top-0 size-full bg-mshop-dim-30 text-mshop-white",
                              s ? "typo-mshop-en-20-unica-m" : "typo-mshop-en-16-unica-m"
                            ),
                            children: [
                              "+ ",
                              y.length - o
                            ]
                          }
                        )
                      ]
                    },
                    b
                  ) : /* @__PURE__ */ a.jsx(
                    "a",
                    {
                      className: "flex-center isolate aspect-square overflow-hidden rounded-[0.57143rem] bg-mshop-gray-5",
                      href: j,
                      children: /* @__PURE__ */ a.jsx(
                        "img",
                        {
                          alt: "",
                          src: w,
                          className: "aspect-square object-cover",
                          style: {
                            width: `${k}%`
                          }
                        }
                      )
                    },
                    b
                  )
                )
              }
            )
          ] })
        ] }, c))
      }
    )
  ] });
}
const Mq = {
  default: "",
  joined: "bg-mshop-black",
  closed: "bg-mshop-gray-50",
  recommended: "bg-mshop-blue-100"
}, Rq = {
  default: "",
  joined: "가입 중",
  closed: "가입 마감",
  recommended: "추천 멤버십"
}, aE = {
  default: "border-mshop-gray-10",
  joined: "border-mshop-black",
  closed: "border-mshop-gray-10",
  recommended: "border-mshop-blue-100"
}, Dq = ({
  status: e,
  state: t,
  isRecommended: n,
  memberCount: r,
  limitCount: s
}) => {
  let o = "default";
  return e === "JOINED" ? o = "joined" : t === "CLOSED" || t === "DELETION_PENDING" || // https://github.com/marpple/mco-membership/pull/3740#issuecomment-2896753589
  s !== 0 && r >= s ? o = "closed" : n && (o = "recommended"), o;
};
function Gwe({
  description: e,
  displayName: t,
  isRecommended: n,
  payment: r,
  rewards: s,
  state: o,
  thumbnailImage: c,
  subdomain: u,
  status: m,
  memberCount: y,
  limitCount: b,
  onJoinMembershipButtonClick: w,
  onSeeMyMembershipRewardsButtonClick: k,
  onDimThumbnailClick: j
}) {
  const E = Dq({
    status: m,
    state: o,
    isRecommended: n,
    limitCount: b,
    memberCount: y
  }), T = E === "joined" || E === "recommended", D = o_(s);
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "flex h-full flex-col",
        T ? $(
          "isolate overflow-hidden rounded-[1.71429rem] border-[2px]",
          aE[E]
        ) : null
      ),
      children: [
        T ? /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $(
              "flex-center typo-mshop-kr-20-b h-[3.71429rem] text-mshop-white",
              Mq[E]
            ),
            children: Rq[E]
          }
        ) : /* @__PURE__ */ a.jsx("div", { className: "h-[3.71429rem]" }),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "flex grow flex-col gap-[1.71429rem] bg-mshop-white p-[1.7143rem]",
              T ? null : $(
                "isolate overflow-hidden rounded-[1.71429rem] border-[2px]",
                aE[E]
              )
            ),
            children: [
              /* @__PURE__ */ a.jsxs("section", { className: "relative", children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "isolate aspect-square w-full overflow-hidden rounded-[1.14286rem]",
                      {
                        "opacity-30": E === "closed"
                      }
                    ),
                    children: /* @__PURE__ */ a.jsx(
                      aa,
                      {
                        src: c.url,
                        width: "28.5714rem",
                        height: "28.5714rem",
                        objectFit: "cover"
                      }
                    )
                  }
                ),
                E === "closed" && /* @__PURE__ */ a.jsx("span", { className: "absolute left-[1.14rem] top-[1.14rem]", children: /* @__PURE__ */ a.jsx(
                  dy,
                  {
                    property1: "Membership",
                    property2: "Closed"
                  }
                ) })
              ] }),
              /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[1.14286rem]", children: [
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-24-b line-clamp-2 break-words", children: t }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex items-center", children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-20-unica-b text-mshop-black-", children: r.price.toLocaleString(cr.Ko) }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: zs(r.currency) })
                  ] }),
                  /* @__PURE__ */ a.jsx("div", { className: "h-4 w-[0.07143rem] bg-mshop-gray-20" }),
                  /* @__PURE__ */ a.jsxs(
                    "span",
                    {
                      className: $(
                        "typo-mshop-kr-16-b text-center",
                        E === "closed" ? "text-mshop-gray-50" : "text-mshop-blue-100"
                      ),
                      children: [
                        r.type === $n.ShortTermPass && "기간 한정",
                        r.type === $n.SubscriptionPass && "월 정기 구독"
                      ]
                    }
                  ),
                  r.type === $n.ShortTermPass && E !== "closed" && /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[0.14286rem]", children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-cneter text-mshop-black", children: jt(r.endTimeAt, "yyyy. MM. dd") }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-cneter text-mshop-black", children: "까지 이용 가능" })
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(
                _q,
                {
                  payment: r,
                  planVariant: E,
                  onJoinMembershipButtonClick: w,
                  onSeeMyMembershipRewardsButtonClick: k
                }
              ),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[1.71429rem]", children: [
                e && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m whitespace-pre-wrap break-words text-mshop-black", children: e }),
                /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[1.14286rem]", children: [
                  D.productRewards && /* @__PURE__ */ a.jsx(
                    Tq,
                    {
                      productRewards: D.productRewards,
                      onDimThumbnailClick: j
                    }
                  ),
                  D.communityRewards && /* @__PURE__ */ a.jsx(
                    Eq,
                    {
                      communityRewards: D.communityRewards,
                      subdomain: u
                    }
                  ),
                  D.creatorRewards && /* @__PURE__ */ a.jsx(
                    kq,
                    {
                      creatorRewards: D.creatorRewards
                    }
                  )
                ] })
              ] })
            ]
          }
        )
      ]
    }
  );
}
function Wwe({
  description: e,
  displayName: t,
  isRecommended: n,
  payment: r,
  rewards: s,
  state: o,
  thumbnailImage: c,
  subdomain: u,
  status: m,
  memberCount: y,
  limitCount: b,
  onJoinMembershipButtonClick: w,
  onSeeMyMembershipRewardsButtonClick: k,
  onDimThumbnailClick: j
}) {
  const [E, T] = Re(!1), D = Dq({
    status: m,
    state: o,
    isRecommended: n,
    limitCount: b,
    memberCount: y
  }), L = D === "joined" || D === "recommended" || // https://www.notion.so/marpple/MO-1bb5328163528020a3a3e02e4d7a2d58?pvs=4
  D === "closed", I = o_(s);
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "flex h-full flex-col",
        L ? $(
          "isolate overflow-hidden rounded-[1.14286rem] border",
          aE[D]
        ) : null
      ),
      children: [
        L && /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $(
              "flex-center typo-mshop-kr-16-b h-[2.57143rem] text-mshop-white",
              Mq[D]
            ),
            children: Rq[D]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "flex grow flex-col bg-mshop-white px-[1.1429rem] pt-[1.4286rem]",
              L ? null : $(
                "isolate overflow-hidden rounded-[1.14286rem] border",
                aE[D]
              )
            ),
            children: [
              /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[1.14286rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[1.14286rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "div",
                    {
                      className: $(
                        "isolate size-[6.28571rem] shrink-0 overflow-hidden rounded-[1.14286rem]",
                        {
                          "opacity-30": D === "closed"
                        }
                      ),
                      children: /* @__PURE__ */ a.jsx(
                        aa,
                        {
                          src: c.url,
                          width: "6.2857rem",
                          height: "6.2857rem",
                          objectFit: "cover"
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.28571rem]", children: [
                    /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-b line-clamp-2 break-all", children: t }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[0.28571rem]", children: [
                      /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b", children: r.price.toLocaleString(cr.Ko) }),
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: zs(r.currency) })
                      ] }),
                      /* @__PURE__ */ a.jsx("div", { className: "h-[0.71429rem] w-[0.07143rem] bg-mshop-gray-20" }),
                      /* @__PURE__ */ a.jsxs(
                        "span",
                        {
                          className: $(
                            "typo-mshop-kr-14-b text-center",
                            D === "closed" ? "text-mshop-gray-50" : "text-mshop-blue-100"
                          ),
                          children: [
                            r.type === $n.ShortTermPass && "기간 한정",
                            r.type === $n.SubscriptionPass && "월 정기 구독"
                          ]
                        }
                      )
                    ] }),
                    r.type === $n.ShortTermPass && D !== "closed" && /* @__PURE__ */ a.jsxs("div", { className: "flex flex-wrap items-start gap-[0.14286rem]", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-cneter text-mshop-black", children: jt(r.endTimeAt, "yyyy. MM. dd") }),
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-cneter text-mshop-black", children: "까지 이용 가능" })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ a.jsx(
                  _q,
                  {
                    payment: r,
                    planVariant: D,
                    onJoinMembershipButtonClick: w,
                    onSeeMyMembershipRewardsButtonClick: k
                  }
                )
              ] }),
              E ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                /* @__PURE__ */ a.jsxs("section", { className: "relative flex flex-col gap-[1.71429rem] pt-[1.71429rem]", children: [
                  e && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m whitespace-pre-wrap break-words text-mshop-black", children: e }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[1.14286rem]", children: [
                    I.productRewards && /* @__PURE__ */ a.jsx(
                      Tq,
                      {
                        productRewards: I.productRewards,
                        onDimThumbnailClick: j
                      }
                    ),
                    I.communityRewards && /* @__PURE__ */ a.jsx(
                      Eq,
                      {
                        communityRewards: I.communityRewards,
                        subdomain: u
                      }
                    ),
                    I.creatorRewards && /* @__PURE__ */ a.jsx(
                      kq,
                      {
                        creatorRewards: I.creatorRewards
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ a.jsx(
                  "button",
                  {
                    type: "button",
                    className: "typo-mshop-kr-14-b flex items-center justify-center py-[1.14286rem] text-mshop-gray-50",
                    onClick: () => T(!1),
                    children: "접기"
                  }
                )
              ] }) : /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: "typo-mshop-kr-14-b flex items-center justify-center py-[1.14286rem] text-mshop-gray-50",
                  onClick: () => T(!0),
                  children: "더보기"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const Ywe = 3, qwe = 300, Kwe = [
  ss.DigitalContent,
  ss.Dm,
  ss.LiveStreaming,
  ss.Channel
], Xwe = (e) => Kwe.includes(e.type);
function Qwe(e) {
  Al([
    [ol, e.client],
    [ll, e.widgetCore],
    [R1, e.projectId],
    [jq, e.projectCover],
    [UA, e.memberships]
  ]);
  const t = Rt(null), { projectCover: n } = Fwe(), { memberships: r } = Iwe(), { projectId: s } = Tf(), {
    widgetCore: { isMobile: o }
  } = Gt(), c = [...r.items].sort(
    (m, y) => m.index - y.index
  ), u = r.items.flatMap((m) => m.rewards).some(Xwe);
  return /* @__PURE__ */ a.jsxs("div", { className: "twp flex flex-col gap-[1.71429rem]", children: [
    o ? /* @__PURE__ */ a.jsx(a.Fragment, { children: u && /* @__PURE__ */ a.jsxs("div", { className: "relative isolate h-[5.42857rem] overflow-hidden rounded-[1.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "absolute size-full", children: /* @__PURE__ */ a.jsx(
        aa,
        {
          width: "24.5rem",
          height: "5.42857rem",
          objectFit: "cover",
          src: n.profileImageUrl ?? kt.Common.CreatorProfileDefaultGray
        }
      ) }),
      /* @__PURE__ */ a.jsxs("div", { className: "absolute flex size-full items-center gap-[0.57143rem] bg-mshop-dim-60 p-[1.14286rem] backdrop-blur-[30px]", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex w-full grow flex-col", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b line-clamp-1 overflow-hidden text-ellipsis text-mshop-white", children: Ef(c[0].shop) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-white", children: "커뮤니티 바로가기" })
        ] }),
        /* @__PURE__ */ a.jsx("div", { className: "shrink-0", children: /* @__PURE__ */ a.jsx(
          Y2,
          {
            theme: "lg",
            variant: "sm",
            iconFront: "cietySymbol",
            as: "a",
            href: Ku({
              type: "home",
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              subdomain: n.communityUrl
            }),
            target: "_blank",
            rel: "noopener noreferrer",
            children: "커뮤니티"
          }
        ) })
      ] })
    ] }) }) : /* @__PURE__ */ a.jsxs(
      "div",
      {
        id: "membership-join-banner",
        className: "relative h-[28.57143rem] overflow-hidden rounded-[1.71429rem]",
        children: [
          n.profileImageUrl && /* @__PURE__ */ a.jsx(
            "img",
            {
              alt: "",
              src: n.profileImageUrl,
              className: "size-full object-cover"
            }
          ),
          /* @__PURE__ */ a.jsx("div", { className: "absolute top-0 h-[28.57143rem] w-full bg-mshop-dim-60 backdrop-blur-[30px]" }),
          /* @__PURE__ */ a.jsx("div", { className: "absolute left-1/2 top-1/2 h-[24rem] w-[26.34143rem] -translate-x-1/2 -translate-y-1/2", children: /* @__PURE__ */ a.jsx(i8e, { children: /* @__PURE__ */ a.jsx(
            "img",
            {
              alt: "",
              src: n.profileImageUrl ?? kt.Common.CreatorProfileDefaultGray,
              className: "size-full object-cover"
            }
          ) }) }),
          /* @__PURE__ */ a.jsxs("div", { className: "absolute top-0 flex h-[28.57143rem] w-full items-end justify-between p-[2.29rem]", children: [
            /* @__PURE__ */ a.jsxs("span", { className: "flex flex-col justify-between self-stretch", children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-32-b whitespace-pre-wrap text-mshop-white", children: `멤버십에 가입하고
특별한 혜택을 받아보세요!` }),
              n.users.length > 0 && /* @__PURE__ */ a.jsx(
                fY,
                {
                  size: "large",
                  theme: "dark",
                  count: n.memberCount,
                  profileImageUrls: n.users.map(
                    ({ imageUrl: m }) => m
                  ),
                  variant: "member"
                }
              )
            ] }),
            u && /* @__PURE__ */ a.jsx(
              Y2,
              {
                theme: "lg",
                variant: "lg",
                iconFront: "cietySymbol",
                as: "a",
                href: Ku({
                  type: "home",
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  subdomain: n.communityUrl
                }),
                target: "_blank",
                children: "커뮤니티 바로가기"
              }
            )
          ] })
        ]
      }
    ),
    o ? /* @__PURE__ */ a.jsx(
      "div",
      {
        id: "membership-join-picker",
        className: "flex flex-col gap-[1.71429rem] pb-[1.14286rem]",
        children: c.map((m) => {
          var y;
          return /* @__PURE__ */ a.jsx(
            Wwe,
            {
              description: m.description,
              displayName: m.displayName,
              isRecommended: m.isRecommended,
              payment: m.payment,
              rewards: m.rewards,
              state: m.state,
              thumbnailImage: m.thumbnailImage,
              subdomain: ((y = m.dao) == null ? void 0 : y.subdomain) ?? null,
              status: m.status,
              memberCount: m.memberCount,
              limitCount: m.limitCount,
              onJoinMembershipButtonClick: () => e.onJoinMembershipButtonClick(m.id),
              onSeeMyMembershipRewardsButtonClick: () => e.onSeeMyMembershipRewardsButtonClick(
                m.id
              ),
              onDimThumbnailClick: e.onDimThumbnailClick
            },
            m.id
          );
        })
      }
    ) : /* @__PURE__ */ a.jsxs(
      "div",
      {
        id: "membership-join-picker",
        className: "flex flex-col gap-[1.71429rem] pt-[2.28571rem]",
        children: [
          /* @__PURE__ */ a.jsxs("header", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-24-b flex-center", children: "멤버십 플랜" }),
            c.length >= 4 && /* @__PURE__ */ a.jsxs("span", { className: "flex gap-[.57rem]", children: [
              /* @__PURE__ */ a.jsx(
                wy,
                {
                  background: "dim",
                  direction: "left",
                  type: "button",
                  onClick: () => t.current.slidePrev()
                }
              ),
              /* @__PURE__ */ a.jsx(
                wy,
                {
                  background: "dim",
                  direction: "right",
                  type: "button",
                  onClick: () => t.current.slideNext()
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ a.jsx("div", { className: "flex flex-col gap-[0.57143rem]", children: /* @__PURE__ */ a.jsx("div", { className: "flex", children: /* @__PURE__ */ a.jsx(
            Av,
            {
              slidesPerView: Ywe,
              speed: qwe,
              loop: c.length >= 4,
              spaceBetween: kc(1.1429),
              className: "grow",
              onSwiper: (m) => {
                t.current = m;
              },
              children: c.map((m) => {
                var y;
                return /* @__PURE__ */ a.jsx(Vg, { children: /* @__PURE__ */ a.jsx(
                  Gwe,
                  {
                    description: m.description,
                    displayName: m.displayName,
                    isRecommended: m.isRecommended,
                    payment: m.payment,
                    rewards: m.rewards,
                    state: m.state,
                    thumbnailImage: m.thumbnailImage,
                    subdomain: ((y = m.dao) == null ? void 0 : y.subdomain) ?? null,
                    status: m.status,
                    memberCount: m.memberCount,
                    limitCount: m.limitCount,
                    onJoinMembershipButtonClick: () => e.onJoinMembershipButtonClick(
                      m.id
                    ),
                    onSeeMyMembershipRewardsButtonClick: () => e.onSeeMyMembershipRewardsButtonClick(
                      m.id
                    ),
                    onDimThumbnailClick: e.onDimThumbnailClick
                  }
                ) }, m.id);
              })
            }
          ) }) })
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex justify-center gap-[0.57143rem]",
          o ? "pt-[2.28571rem]" : "mt-[3.42857rem] pt-[1.71429rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("div", { className: o ? void 0 : "w-[17.14286rem]", children: /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "md",
              theme: "line",
              type: "button",
              widthFull: !0,
              onClick: () => e.onContactButtonClick(s),
              children: "멤버십 문의하기"
            }
          ) }),
          /* @__PURE__ */ a.jsx("div", { className: o ? void 0 : "w-[17.14286rem]", children: /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "md",
              theme: "line",
              type: "button",
              widthFull: !0,
              onClick: e.onGoToSeeMembershipFaqButtonClick,
              children: "멤버십 FAQ 보러가기"
            }
          ) })
        ]
      }
    )
  ] });
}
function mH({
  isMobile: e,
  onGoToExploreProductsButtonClick: t
}) {
  const n = e ? p6 : f5;
  return /* @__PURE__ */ a.jsx("main", { className: "twp py-[11.42857rem]", children: /* @__PURE__ */ a.jsx(
    n,
    {
      renderImage: /* @__PURE__ */ a.jsx(
        "img",
        {
          alt: "",
          crossOrigin: "anonymous",
          src: kt.KeyVisual.PrepareStore02
        }
      ),
      title: "멤버십 준비 중입니다.",
      description: `크리에이터가 멤버십을 준비하는 동안
크리에이터 샵에서 내 취향의 상품을 찾아볼까요?`,
      renderButton: /* @__PURE__ */ a.jsx(
        fn,
        {
          theme: "blue",
          variant: "lg",
          widthFull: !0,
          type: "button",
          onClick: t,
          children: "상품 구경하러 가기"
        }
      )
    }
  ) });
}
function Zwe({
  client: e,
  isMobile: t,
  isApp: n,
  projectId: r,
  toggleSpinner: s,
  onJoinMembershipButtonClick: o,
  onSeeMyMembershipRewardsButtonClick: c,
  onGoToExploreProductsButtonClick: u,
  onDimThumbnailClick: m,
  onContactButtonClick: y,
  onGoToSeeMembershipFaqButtonClick: b,
  onScrollLock: w,
  onError: k
}) {
  const [j, E] = Re(!0), [T, D] = Re(null);
  return an(() => {
    if (!r)
      return E(!1);
    (async () => {
      const [L, I] = await Promise.all([
        s8e(
          {
            projectId: r
          },
          {
            client: e,
            onError: k
          }
        ),
        a8e(
          {
            projectId: r
          },
          {
            client: e,
            onError: k
          }
        )
      ]);
      if (L.code === le.TokenExpired || I.code === le.TokenExpired)
        return k(Ht);
      D({
        projectCover: L.data,
        memberships: I.data
      }), E(!1);
    })();
  }, []), r ? j || T === null ? null : T.memberships.items.length === 0 ? /* @__PURE__ */ a.jsx(
    mH,
    {
      isMobile: t,
      onGoToExploreProductsButtonClick: u
    }
  ) : /* @__PURE__ */ a.jsx(
    Qwe,
    {
      client: e,
      widgetCore: {
        isMobile: t,
        isApp: n,
        toggleSpinner: s,
        onError: k,
        onScrollLock: w
      },
      projectId: r,
      projectCover: T.projectCover,
      memberships: T.memberships,
      onJoinMembershipButtonClick: o,
      onSeeMyMembershipRewardsButtonClick: c,
      onDimThumbnailClick: m,
      onContactButtonClick: y,
      onGoToSeeMembershipFaqButtonClick: b
    }
  ) : /* @__PURE__ */ a.jsx(
    mH,
    {
      isMobile: t,
      onGoToExploreProductsButtonClick: u
    }
  );
}
class Hje extends Ol {
  constructor({
    client: t,
    isMobile: n,
    isApp: r,
    projectId: s,
    toggleSpinner: o,
    onGoToExploreProductsButtonClick: c,
    onJoinMembershipButtonClick: u,
    onSeeMyMembershipRewardsButtonClick: m,
    onDimThumbnailClick: y,
    onContactButtonClick: b,
    onGoToSeeMembershipFaqButtonClick: w,
    onError: k,
    onScrollLock: j
  }) {
    super({
      client: t,
      isMobile: n,
      isApp: r,
      toggleSpinner: o,
      onError: k,
      onScrollLock: j
    }), this.render = (E) => {
      go(E).render(
        /* @__PURE__ */ a.jsx(
          Zwe,
          {
            client: this.client,
            isMobile: this.isMobile,
            isApp: this.isApp,
            toggleSpinner: this.toggleSpinner,
            projectId: this.projectId,
            onJoinMembershipButtonClick: this.onJoinMembershipButtonClick,
            onSeeMyMembershipRewardsButtonClick: this.onSeeMyMembershipRewardsButtonClick,
            onGoToExploreProductsButtonClick: this.onGoToExploreProductsButtonClick,
            onDimThumbnailClick: this.onDimThumbnailClick,
            onContactButtonClick: this.onContactButtonClick,
            onGoToSeeMembershipFaqButtonClick: this.onGoToSeeMembershipFaqButtonClick,
            onError: this.onError,
            onScrollLock: this.onScrollLock
          }
        )
      );
    }, this.projectId = s, this.onGoToExploreProductsButtonClick = c, this.onJoinMembershipButtonClick = u, this.onSeeMyMembershipRewardsButtonClick = m, this.onDimThumbnailClick = y, this.onContactButtonClick = b, this.onGoToSeeMembershipFaqButtonClick = w;
  }
}
const Jwe = (e) => jn(
  "/mypage-memberships",
  {},
  e
).then((t) => {
  switch (t.code) {
    case le.Success:
    case le.TokenExpired:
      return t;
    default:
      throw new Error();
  }
});
function zA(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: s
  } = e;
  n({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let o;
  const c = my();
  t.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const u = c.createElement("div");
  function m(E, T) {
    const D = t.params.virtual;
    if (D.cache && t.virtual.cache[T])
      return t.virtual.cache[T];
    let L;
    return D.renderSlide ? (L = D.renderSlide.call(t, E, T), typeof L == "string" && (u.innerHTML = L, L = u.children[0])) : t.isElement ? L = L3("swiper-slide") : L = L3("div", t.params.slideClass), L.setAttribute("data-swiper-slide-index", T), D.renderSlide || (L.innerHTML = E), D.cache && (t.virtual.cache[T] = L), L;
  }
  function y(E, T) {
    const {
      slidesPerView: D,
      slidesPerGroup: L,
      centeredSlides: I,
      loop: R,
      initialSlide: U
    } = t.params;
    if (T && !R && U > 0)
      return;
    const {
      addSlidesBefore: z,
      addSlidesAfter: H
    } = t.params.virtual, {
      from: K,
      to: q,
      slides: Q,
      slidesGrid: Z,
      offset: X
    } = t.virtual;
    t.params.cssMode || t.updateActiveIndex();
    const se = t.activeIndex || 0;
    let te;
    t.rtlTranslate ? te = "right" : te = t.isHorizontal() ? "left" : "top";
    let fe, ce;
    I ? (fe = Math.floor(D / 2) + L + H, ce = Math.floor(D / 2) + L + z) : (fe = D + (L - 1) + H, ce = (R ? D : L) + z);
    let pe = se - ce, Se = se + fe;
    R || (pe = Math.max(pe, 0), Se = Math.min(Se, Q.length - 1));
    let oe = (t.slidesGrid[pe] || 0) - (t.slidesGrid[0] || 0);
    R && se >= ce ? (pe -= ce, I || (oe += t.slidesGrid[0])) : R && se < ce && (pe = -ce, I && (oe += t.slidesGrid[0])), Object.assign(t.virtual, {
      from: pe,
      to: Se,
      offset: oe,
      slidesGrid: t.slidesGrid,
      slidesBefore: ce,
      slidesAfter: fe
    });
    function ue() {
      t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), s("virtualUpdate");
    }
    if (K === pe && q === Se && !E) {
      t.slidesGrid !== Z && oe !== X && t.slides.forEach((qe) => {
        qe.style[te] = `${oe - Math.abs(t.cssOverflowAdjustment())}px`;
      }), t.updateProgress(), s("virtualUpdate");
      return;
    }
    if (t.params.virtual.renderExternal) {
      t.params.virtual.renderExternal.call(t, {
        offset: oe,
        from: pe,
        to: Se,
        slides: function() {
          const it = [];
          for (let Ne = pe; Ne <= Se; Ne += 1)
            it.push(Q[Ne]);
          return it;
        }()
      }), t.params.virtual.renderExternalUpdate ? ue() : s("virtualUpdate");
      return;
    }
    const he = [], ve = [], Te = (qe) => {
      let it = qe;
      return qe < 0 ? it = Q.length + qe : it >= Q.length && (it = it - Q.length), it;
    };
    if (E)
      t.slides.filter((qe) => qe.matches(`.${t.params.slideClass}, swiper-slide`)).forEach((qe) => {
        qe.remove();
      });
    else
      for (let qe = K; qe <= q; qe += 1)
        if (qe < pe || qe > Se) {
          const it = Te(qe);
          t.slides.filter((Ne) => Ne.matches(`.${t.params.slideClass}[data-swiper-slide-index="${it}"], swiper-slide[data-swiper-slide-index="${it}"]`)).forEach((Ne) => {
            Ne.remove();
          });
        }
    const Ie = R ? -Q.length : 0, Ue = R ? Q.length * 2 : Q.length;
    for (let qe = Ie; qe < Ue; qe += 1)
      if (qe >= pe && qe <= Se) {
        const it = Te(qe);
        typeof q > "u" || E ? ve.push(it) : (qe > q && ve.push(it), qe < K && he.push(it));
      }
    if (ve.forEach((qe) => {
      t.slidesEl.append(m(Q[qe], qe));
    }), R)
      for (let qe = he.length - 1; qe >= 0; qe -= 1) {
        const it = he[qe];
        t.slidesEl.prepend(m(Q[it], it));
      }
    else
      he.sort((qe, it) => it - qe), he.forEach((qe) => {
        t.slidesEl.prepend(m(Q[qe], qe));
      });
    uy(t.slidesEl, ".swiper-slide, swiper-slide").forEach((qe) => {
      qe.style[te] = `${oe - Math.abs(t.cssOverflowAdjustment())}px`;
    }), ue();
  }
  function b(E) {
    if (typeof E == "object" && "length" in E)
      for (let T = 0; T < E.length; T += 1)
        E[T] && t.virtual.slides.push(E[T]);
    else
      t.virtual.slides.push(E);
    y(!0);
  }
  function w(E) {
    const T = t.activeIndex;
    let D = T + 1, L = 1;
    if (Array.isArray(E)) {
      for (let I = 0; I < E.length; I += 1)
        E[I] && t.virtual.slides.unshift(E[I]);
      D = T + E.length, L = E.length;
    } else
      t.virtual.slides.unshift(E);
    if (t.params.virtual.cache) {
      const I = t.virtual.cache, R = {};
      Object.keys(I).forEach((U) => {
        const z = I[U], H = z.getAttribute("data-swiper-slide-index");
        H && z.setAttribute("data-swiper-slide-index", parseInt(H, 10) + L), R[parseInt(U, 10) + L] = z;
      }), t.virtual.cache = R;
    }
    y(!0), t.slideTo(D, 0);
  }
  function k(E) {
    if (typeof E > "u" || E === null) return;
    let T = t.activeIndex;
    if (Array.isArray(E))
      for (let D = E.length - 1; D >= 0; D -= 1)
        t.params.virtual.cache && (delete t.virtual.cache[E[D]], Object.keys(t.virtual.cache).forEach((L) => {
          L > E && (t.virtual.cache[L - 1] = t.virtual.cache[L], t.virtual.cache[L - 1].setAttribute("data-swiper-slide-index", L - 1), delete t.virtual.cache[L]);
        })), t.virtual.slides.splice(E[D], 1), E[D] < T && (T -= 1), T = Math.max(T, 0);
    else
      t.params.virtual.cache && (delete t.virtual.cache[E], Object.keys(t.virtual.cache).forEach((D) => {
        D > E && (t.virtual.cache[D - 1] = t.virtual.cache[D], t.virtual.cache[D - 1].setAttribute("data-swiper-slide-index", D - 1), delete t.virtual.cache[D]);
      })), t.virtual.slides.splice(E, 1), E < T && (T -= 1), T = Math.max(T, 0);
    y(!0), t.slideTo(T, 0);
  }
  function j() {
    t.virtual.slides = [], t.params.virtual.cache && (t.virtual.cache = {}), y(!0), t.slideTo(0, 0);
  }
  r("beforeInit", () => {
    if (!t.params.virtual.enabled) return;
    let E;
    if (typeof t.passedParams.virtual.slides > "u") {
      const T = [...t.slidesEl.children].filter((D) => D.matches(`.${t.params.slideClass}, swiper-slide`));
      T && T.length && (t.virtual.slides = [...T], E = !0, T.forEach((D, L) => {
        D.setAttribute("data-swiper-slide-index", L), t.virtual.cache[L] = D, D.remove();
      }));
    }
    E || (t.virtual.slides = t.params.virtual.slides), t.classNames.push(`${t.params.containerModifierClass}virtual`), t.params.watchSlidesProgress = !0, t.originalParams.watchSlidesProgress = !0, y(!1, !0);
  }), r("setTranslate", () => {
    t.params.virtual.enabled && (t.params.cssMode && !t._immediateVirtual ? (clearTimeout(o), o = setTimeout(() => {
      y();
    }, 100)) : y());
  }), r("init update resize", () => {
    t.params.virtual.enabled && t.params.cssMode && n3(t.wrapperEl, "--swiper-virtual-size", `${t.virtualSize}px`);
  }), Object.assign(t.virtual, {
    appendSlide: b,
    prependSlide: w,
    removeSlide: k,
    removeAllSlides: j,
    update: y
  });
}
function eCe(e) {
  let {
    swiper: t,
    extendParams: n,
    on: r,
    emit: s,
    params: o
  } = e;
  t.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, n({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let c, u, m = o && o.autoplay ? o.autoplay.delay : 3e3, y = o && o.autoplay ? o.autoplay.delay : 3e3, b, w = (/* @__PURE__ */ new Date()).getTime(), k, j, E, T, D, L, I;
  function R(oe) {
    !t || t.destroyed || !t.wrapperEl || oe.target === t.wrapperEl && (t.wrapperEl.removeEventListener("transitionend", R), !(I || oe.detail && oe.detail.bySwiperTouchMove) && Z());
  }
  const U = () => {
    if (t.destroyed || !t.autoplay.running) return;
    t.autoplay.paused ? k = !0 : k && (y = b, k = !1);
    const oe = t.autoplay.paused ? b : w + y - (/* @__PURE__ */ new Date()).getTime();
    t.autoplay.timeLeft = oe, s("autoplayTimeLeft", oe, oe / m), u = requestAnimationFrame(() => {
      U();
    });
  }, z = () => {
    let oe;
    return t.virtual && t.params.virtual.enabled ? oe = t.slides.filter((he) => he.classList.contains("swiper-slide-active"))[0] : oe = t.slides[t.activeIndex], oe ? parseInt(oe.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, H = (oe) => {
    if (t.destroyed || !t.autoplay.running) return;
    cancelAnimationFrame(u), U();
    let ue = typeof oe > "u" ? t.params.autoplay.delay : oe;
    m = t.params.autoplay.delay, y = t.params.autoplay.delay;
    const he = z();
    !Number.isNaN(he) && he > 0 && typeof oe > "u" && (ue = he, m = he, y = he), b = ue;
    const ve = t.params.speed, Te = () => {
      !t || t.destroyed || (t.params.autoplay.reverseDirection ? !t.isBeginning || t.params.loop || t.params.rewind ? (t.slidePrev(ve, !0, !0), s("autoplay")) : t.params.autoplay.stopOnLastSlide || (t.slideTo(t.slides.length - 1, ve, !0, !0), s("autoplay")) : !t.isEnd || t.params.loop || t.params.rewind ? (t.slideNext(ve, !0, !0), s("autoplay")) : t.params.autoplay.stopOnLastSlide || (t.slideTo(0, ve, !0, !0), s("autoplay")), t.params.cssMode && (w = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        H();
      })));
    };
    return ue > 0 ? (clearTimeout(c), c = setTimeout(() => {
      Te();
    }, ue)) : requestAnimationFrame(() => {
      Te();
    }), ue;
  }, K = () => {
    w = (/* @__PURE__ */ new Date()).getTime(), t.autoplay.running = !0, H(), s("autoplayStart");
  }, q = () => {
    t.autoplay.running = !1, clearTimeout(c), cancelAnimationFrame(u), s("autoplayStop");
  }, Q = (oe, ue) => {
    if (t.destroyed || !t.autoplay.running) return;
    clearTimeout(c), oe || (L = !0);
    const he = () => {
      s("autoplayPause"), t.params.autoplay.waitForTransition ? t.wrapperEl.addEventListener("transitionend", R) : Z();
    };
    if (t.autoplay.paused = !0, ue) {
      D && (b = t.params.autoplay.delay), D = !1, he();
      return;
    }
    b = (b || t.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - w), !(t.isEnd && b < 0 && !t.params.loop) && (b < 0 && (b = 0), he());
  }, Z = () => {
    t.isEnd && b < 0 && !t.params.loop || t.destroyed || !t.autoplay.running || (w = (/* @__PURE__ */ new Date()).getTime(), L ? (L = !1, H(b)) : H(), t.autoplay.paused = !1, s("autoplayResume"));
  }, X = () => {
    if (t.destroyed || !t.autoplay.running) return;
    const oe = my();
    oe.visibilityState === "hidden" && (L = !0, Q(!0)), oe.visibilityState === "visible" && Z();
  }, se = (oe) => {
    oe.pointerType === "mouse" && (L = !0, I = !0, !(t.animating || t.autoplay.paused) && Q(!0));
  }, te = (oe) => {
    oe.pointerType === "mouse" && (I = !1, t.autoplay.paused && Z());
  }, fe = () => {
    t.params.autoplay.pauseOnMouseEnter && (t.el.addEventListener("pointerenter", se), t.el.addEventListener("pointerleave", te));
  }, ce = () => {
    t.el && typeof t.el != "string" && (t.el.removeEventListener("pointerenter", se), t.el.removeEventListener("pointerleave", te));
  }, pe = () => {
    my().addEventListener("visibilitychange", X);
  }, Se = () => {
    my().removeEventListener("visibilitychange", X);
  };
  r("init", () => {
    t.params.autoplay.enabled && (fe(), pe(), K());
  }), r("destroy", () => {
    ce(), Se(), t.autoplay.running && q();
  }), r("_freeModeStaticRelease", () => {
    (E || L) && Z();
  }), r("_freeModeNoMomentumRelease", () => {
    t.params.autoplay.disableOnInteraction ? q() : Q(!0, !0);
  }), r("beforeTransitionStart", (oe, ue, he) => {
    t.destroyed || !t.autoplay.running || (he || !t.params.autoplay.disableOnInteraction ? Q(!0, !0) : q());
  }), r("sliderFirstMove", () => {
    if (!(t.destroyed || !t.autoplay.running)) {
      if (t.params.autoplay.disableOnInteraction) {
        q();
        return;
      }
      j = !0, E = !1, L = !1, T = setTimeout(() => {
        L = !0, E = !0, Q(!0);
      }, 200);
    }
  }), r("touchEnd", () => {
    if (!(t.destroyed || !t.autoplay.running || !j)) {
      if (clearTimeout(T), clearTimeout(c), t.params.autoplay.disableOnInteraction) {
        E = !1, j = !1;
        return;
      }
      E && t.params.cssMode && Z(), E = !1, j = !1;
    }
  }), r("slideChange", () => {
    t.destroyed || !t.autoplay.running || (D = !0);
  }), Object.assign(t.autoplay, {
    start: K,
    stop: q,
    pause: Q,
    resume: Z
  });
}
const Pq = Qt(Vn), tCe = () => {
  const [e, t] = Ar(
    Pq
  );
  if (e === Vn)
    throw new Error(Xr(ia.MypageMemberships));
  return {
    mypageMemberships: e,
    setMypageMemberships: t
  };
};
function nCe(e) {
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    e.state === "Icon" && e.size === "Medium" && /* @__PURE__ */ a.jsx("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black px-[0.21429rem] py-[0.07143rem]", children: /* @__PURE__ */ a.jsx(fu, { className: "size-[1.14286rem] shrink-0 text-mshop-white" }) }),
    e.state === "Default" && e.size === "Medium" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem]", children: [
      /* @__PURE__ */ a.jsx(fu, { className: "size-[1.14286rem] shrink-0 text-mshop-white" }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-white", children: "멤버십" })
    ] }),
    e.state === "Round" && e.size === "Medium" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[1.14286rem] shrink-0 text-mshop-white" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-white", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex h-[1.57143rem] items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-en-14-unica-r flex items-center justify-center self-stretch pb-[0.14286rem] text-mshop-white", children: e.round }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-white", children: "회차" })
      ] })
    ] }),
    e.state === "Seasonal" && e.size === "Medium" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[1.14286rem] shrink-0 text-mshop-white" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-white", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m flex h-[1.57143rem] items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.28571rem] text-mshop-white", children: "기간 한정" })
    ] }),
    e.state === "Expired" && e.size === "Medium" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex h-[1.57143rem] shrink-0 items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-white py-[0.07143rem] pl-[0.21429rem] pr-[0.28571rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[1.14286rem] shrink-0 text-mshop-black" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m flex h-[1.57143rem] items-center rounded-[0.28571rem] bg-mshop-white px-[0.28571rem] py-[0.07143rem] text-mshop-black", children: "만료" })
    ] }),
    e.state === "Closed" && e.size === "Medium" && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m inline-flex h-[1.57143rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.28571rem] py-[0.07143rem] text-mshop-white", children: "가입 마감" }),
    e.state === "Icon" && e.size === "Small" && /* @__PURE__ */ a.jsx("div", { className: "flex size-[1.21429rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: /* @__PURE__ */ a.jsx(fu, { className: "size-[0.85714rem] shrink-0 text-mshop-white" }) }),
    e.state === "Default" && e.size === "Small" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx(fu, { className: "size-[0.85714rem] shrink-0 text-mshop-white" }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-white", children: "멤버십" })
    ] }),
    e.state === "Round" && e.size === "Small" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[0.85714rem] shrink-0 text-mshop-white" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-white", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-r pb-[0.14286rem] text-mshop-white", children: e.round }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-white", children: "회차" })
      ] })
    ] }),
    e.state === "Seasonal" && e.size === "Small" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[0.85714rem] shrink-0 text-mshop-white" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-white", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem] text-mshop-white", children: "기간 한정" })
    ] }),
    e.state === "Expired" && e.size === "Small" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-white px-[0.14286rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[0.85714rem] shrink-0 text-mshop-black" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-black", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m items-center justify-center rounded-[0.28571rem] bg-mshop-white px-[0.14286rem] text-mshop-black", children: "만료" })
    ] }),
    e.state === "Closed" && e.size === "Small" && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.14286rem] text-center text-mshop-white", children: "가입 마감" })
  ] });
}
function _6(e) {
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    e.property1 === "Membership" && e.property2 === "Icon" && /* @__PURE__ */ a.jsx("div", { className: "flex size-[1.21429rem] shrink-0 items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: /* @__PURE__ */ a.jsx(fu, { className: "size-[0.85714rem] shrink-0 text-mshop-white" }) }),
    e.property1 === "Membership" && e.property2 === "Icon+Text" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx(fu, { className: "size-[0.85714rem] shrink-0 text-mshop-white" }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-white", children: "멤버십" })
    ] }),
    e.property1 === "Membership" && e.property2 === "Number" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[0.85714rem] shrink-0 text-mshop-white" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-white", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-r pb-[0.14286rem] text-mshop-white", children: e.count }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-white", children: "회차" })
      ] })
    ] }),
    e.property1 === "Membership" && e.property2 === "Expired" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center justify-center gap-[0.14286rem] rounded-[0.28571rem] bg-mshop-white px-[0.14286rem]", children: [
        /* @__PURE__ */ a.jsx(fu, { className: "size-[0.85714rem] shrink-0 text-mshop-black" }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-black", children: "멤버십" })
      ] }),
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m items-center justify-center rounded-[0.28571rem] bg-mshop-white px-[0.14286rem] text-mshop-black", children: "만료" })
    ] }),
    e.property1 === "Membership" && e.property2 === "Closed" && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.14286rem] text-center text-mshop-white", children: "가입 마감" }),
    e.property1 === "Support" && e.property2 === "Default" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem] text-mshop-white", children: "후원" }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-r pb-[0.14286rem] text-mshop-white", children: e.count }),
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-white", children: "회" })
      ] })
    ] }),
    e.property1 === "Support" && e.property2 === "Closed" && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.14286rem] text-center text-mshop-white", children: "종료" }),
    e.property1 === "Commission" && e.property2 === "Text" && /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem] text-mshop-white", children: "커미션" }),
    e.property1 === "Commission" && e.property2 === "Awaiting" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem] text-mshop-white", children: "수락 대기" })
    ] }),
    e.property1 === "Commission" && e.property2 === "In Progress" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem] text-mshop-white", children: "작업 중" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Done" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-black px-[0.14286rem] text-mshop-white", children: "작업 완료" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Refund" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.14286rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.14286rem] text-mshop-white", children: "환불 예정" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Refunded" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.14286rem] text-mshop-white", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.14286rem] text-mshop-white", children: "환불 완료" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Confirmed" && /* @__PURE__ */ a.jsxs("div", { className: "inline-flex gap-[0.14286rem]", children: [
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-white px-[0.14286rem] text-mshop-black", children: "커미션" }),
      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-white px-[0.14286rem] text-mshop-black", children: "구매 확정" })
    ] }),
    e.property1 === "Commission" && e.property2 === "Pause" && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m inline-flex items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.14286rem] text-center text-mshop-white", children: "일시 중단" })
  ] });
}
function hH({
  displayName: e,
  expiredAt: t,
  joinedAt: n,
  payment: r,
  streakCount: s,
  thumbnailImage: o,
  isActive: c,
  status: u,
  state: m,
  shop: y,
  dao: b,
  onCreatorShopButtonClick: w,
  onSeeMembershipDetailButtonClick: k,
  onReJoinMembershipButtonClick: j,
  onShopButtonClick: E
}) {
  const {
    widgetCore: { isMobile: T, isApp: D }
  } = Gt(), L = u === "EXPIRED", I = T ? _6 : dy, R = () => {
    y && E(y.url);
  };
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      id: "my-page-membership-card",
      className: $(
        "relative rounded-[1.143rem] border border-mshop-gray-5",
        T ? "h-[34.28571rem]" : "h-[42.857rem]"
      ),
      children: [
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $(
              "isolate size-full overflow-hidden rounded-[1.143rem] bg-cover bg-center",
              {
                "opacity-50": L
              }
            ),
            style: {
              backgroundImage: `url(${o.url}?width=${3 * (T ? 288 : 326)}}&height=${3 * (T ? 480 : 600)})`
            },
            children: /* @__PURE__ */ a.jsx("div", { className: "aspect-[4/5] w-full bg-mshop-white", children: /* @__PURE__ */ a.jsx(
              aa,
              {
                src: o.url,
                width: T ? "20.5714rem" : "23.2857rem",
                height: T ? "25.7143rem" : "29.1071rem",
                objectFit: "cover"
              }
            ) })
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "absolute bottom-0 left-0 right-0 flex flex-col justify-end rounded-b-[1.143rem] bg-mshop-dim-60 backdrop-blur-[30px]",
              T ? "h-[25.71429rem] gap-[1.14286rem] p-[1.14286rem]" : "h-[31.42857rem] gap-[2.286rem] px-[1.429rem] pb-[2rem] pt-[1.143rem]"
            ),
            style: {
              mask: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 42.05%)"
            },
            children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.286rem]", children: [
                  /* @__PURE__ */ a.jsxs(
                    "button",
                    {
                      type: "button",
                      onClick: R,
                      className: "flex items-center gap-[0.286rem]",
                      children: [
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b line-clamp-1 text-start text-mshop-white", children: Ef(y) }),
                        /* @__PURE__ */ a.jsx(ch, { className: "size-[1.143rem] shrink-0 text-mshop-white" })
                      ]
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    "h2",
                    {
                      className: $(
                        "line-clamp-2 break-words text-mshop-white",
                        T ? "typo-mshop-kr-20-b" : "typo-mshop-kr-24-b"
                      ),
                      children: e
                    }
                  )
                ] }),
                /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: $(
                      "flex flex-col",
                      T ? "gap-[0.14286rem]" : "gap-[0.286rem]"
                    ),
                    children: [
                      /* @__PURE__ */ a.jsxs("span", { className: "flex items-start gap-[0.286rem]", children: [
                        /* @__PURE__ */ a.jsx(
                          "span",
                          {
                            className: $(
                              "text-mshop-gray-20",
                              T ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m"
                            ),
                            children: jt(n, "yyyy. MM. dd")
                          }
                        ),
                        /* @__PURE__ */ a.jsx(
                          "span",
                          {
                            className: $(
                              "text-mshop-gray-20",
                              T ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m"
                            ),
                            children: "~"
                          }
                        ),
                        /* @__PURE__ */ a.jsxs(
                          "span",
                          {
                            className: $(
                              "text-mshop-gray-20",
                              T ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m"
                            ),
                            children: [
                              r.type === $n.ShortTermPass && jt(r.endTimeAt, "yyyy. MM. dd"),
                              r.type === $n.SubscriptionPass && /* @__PURE__ */ a.jsx(a.Fragment, { children: u === "JOINED" && c ? "Current" : jt(t, "yyyy. MM. dd") })
                            ]
                          }
                        )
                      ] }),
                      /* @__PURE__ */ a.jsxs("span", { className: "flex items-start gap-[0.286rem]", children: [
                        /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $(
                                "text-mshop-gray-20",
                                T ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m"
                              ),
                              children: r.price.toLocaleString(cr.Ko)
                            }
                          ),
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $(
                                "text-mshop-gray-20",
                                T ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                              ),
                              children: zs(r.currency)
                            }
                          )
                        ] }),
                        r.type !== $n.ShortTermPass && c && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $(
                                "text-mshop-gray-20",
                                T ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                              ),
                              children: "/"
                            }
                          ),
                          /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.286rem]", children: [
                            /* @__PURE__ */ a.jsx(
                              "span",
                              {
                                className: $(
                                  "text-mshop-gray-20",
                                  T ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m"
                                ),
                                children: jt(t, "yyyy. MM. dd")
                              }
                            ),
                            /* @__PURE__ */ a.jsx(
                              "span",
                              {
                                className: $(
                                  "text-mshop-gray-20",
                                  T ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                                ),
                                children: "결제 예정"
                              }
                            )
                          ] })
                        ] })
                      ] })
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex-1", children: [
                    u === "JOINED" && /* @__PURE__ */ a.jsx(
                      fn,
                      {
                        variant: "sm",
                        theme: "blue",
                        widthFull: !0,
                        iconFront: "shopDefault",
                        type: "button",
                        onClick: w,
                        children: "크리에이터 샵"
                      }
                    ),
                    L && /* @__PURE__ */ a.jsx(
                      fn,
                      {
                        variant: "sm",
                        theme: "blue",
                        widthFull: !0,
                        type: "button",
                        disabled: !(!D && m === "OPEN"),
                        onClick: j,
                        children: !D && m === "OPEN" ? "멤버십 재가입" : "만료된 멤버십"
                      }
                    )
                  ] }),
                  // https://ciety.xyz/@ciety-work/channels/1286?channelType=CHAT&highlightId=25982
                  b && !L && /* @__PURE__ */ a.jsx("div", { className: "flex-1", children: /* @__PURE__ */ a.jsx(
                    Y2,
                    {
                      theme: "lg",
                      variant: "sm",
                      iconFront: "cietySymbol",
                      widthFull: !0,
                      as: "a",
                      href: Ku({
                        type: "home",
                        subdomain: b.subdomain
                      }),
                      target: "_blank",
                      children: "커뮤니티"
                    }
                  ) })
                ] }),
                /* @__PURE__ */ a.jsx(
                  Y2,
                  {
                    variant: "sm",
                    theme: "bright",
                    widthFull: !0,
                    type: "button",
                    onClick: k,
                    children: "멤버십 상세보기"
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "span",
          {
            className: $(
              "absolute",
              T ? "left-[1.14rem] top-[1.14rem]" : "left-[1.429rem] top-[1.429rem]"
            ),
            children: [
              u === "JOINED" && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                r.type === $n.ShortTermPass && /* @__PURE__ */ a.jsx(
                  nCe,
                  {
                    state: "Seasonal",
                    size: T ? "Small" : "Medium"
                  }
                ),
                r.type === $n.SubscriptionPass && /* @__PURE__ */ a.jsx(
                  I,
                  {
                    property1: "Membership",
                    property2: "Number",
                    count: s
                  }
                )
              ] }),
              L && /* @__PURE__ */ a.jsx(I, { property1: "Membership", property2: "Expired" })
            ]
          }
        )
      ]
    }
  );
}
const rCe = 1.25;
function aCe(e) {
  Al([
    [ol, e.client],
    [ll, e.widgetCore],
    [Pq, e.mypageMemberships],
    [m5, null]
  ]);
  const { mypageMemberships: t } = tCe(), {
    widgetCore: { isMobile: n }
  } = Gt();
  return n ? /* @__PURE__ */ a.jsx("div", { className: "twp pt-[2.28571rem]", children: /* @__PURE__ */ a.jsx(
    Av,
    {
      slidesPerView: rCe,
      spaceBetween: kc(1.14286),
      slidesOffsetBefore: kc(1.14286),
      slidesOffsetAfter: kc(1.14286),
      modules: [zA],
      virtual: !0,
      children: t.items.map((r, s) => /* @__PURE__ */ a.jsx(Vg, { virtualIndex: s, children: /* @__PURE__ */ a.jsx(
        hH,
        {
          displayName: r.displayName,
          expiredAt: r.expiredAt,
          joinedAt: r.joinedAt,
          payment: r.payment,
          streakCount: r.streakCount,
          thumbnailImage: r.thumbnailImage,
          isActive: r.isActive,
          status: r.status,
          state: r.state,
          shop: r.shop,
          dao: r.dao,
          onCreatorShopButtonClick: () => e.onCreatorShopButtonClick(r.projectId),
          onSeeMembershipDetailButtonClick: () => e.onSeeMembershipDetailButtonClick(r.id),
          onReJoinMembershipButtonClick: () => e.onReJoinMembershipButtonClick(
            r.projectId,
            r.id
          ),
          onShopButtonClick: e.onShopButtonClick
        }
      ) }, r.id))
    }
  ) }) : /* @__PURE__ */ a.jsx("div", { className: "twp grid grid-cols-4 gap-[1.714rem] pt-[2.28571rem]", children: t.items.map((r) => /* @__PURE__ */ a.jsx(
    hH,
    {
      displayName: r.displayName,
      expiredAt: r.expiredAt,
      joinedAt: r.joinedAt,
      payment: r.payment,
      streakCount: r.streakCount,
      thumbnailImage: r.thumbnailImage,
      isActive: r.isActive,
      status: r.status,
      shop: r.shop,
      state: r.state,
      dao: r.dao,
      onCreatorShopButtonClick: () => e.onCreatorShopButtonClick(r.projectId),
      onSeeMembershipDetailButtonClick: () => e.onSeeMembershipDetailButtonClick(r.id),
      onReJoinMembershipButtonClick: () => e.onReJoinMembershipButtonClick(
        r.projectId,
        r.id
      ),
      onShopButtonClick: e.onShopButtonClick
    },
    r.id
  )) });
}
const sCe = X2();
function iCe({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  onError: s,
  onScrollLock: o,
  onCreatorShopButtonClick: c,
  onSeeMembershipDetailButtonClick: u,
  onReJoinMembershipButtonClick: m,
  onShopButtonClick: y
}) {
  const [b, w] = Re(!0), [k, j] = Re(null);
  return an(() => {
    (async () => {
      const E = await Jwe({
        client: e,
        onError: s
      });
      if (E.code === le.TokenExpired)
        return s(Ht);
      j({
        mypageMemberships: E.data
      }), w(!1);
    })();
  }, []), b || k === null ? null : k.mypageMemberships.items.length === 0 ? t ? /* @__PURE__ */ a.jsx("div", { className: "py-[11.42857rem]", children: /* @__PURE__ */ a.jsx(
    p6,
    {
      title: "가입한 멤버십이 없어요.",
      description: "좋아하는 크리에이터의 멤버십을 확인해 보세요!",
      renderImage: /* @__PURE__ */ a.jsx(
        aa,
        {
          src: kt.KeyVisual.MembershipMeetFan,
          width: "8.5714rem",
          height: "8.5714rem"
        }
      )
    }
  ) }) : /* @__PURE__ */ a.jsx("div", { className: "py-[11.42857rem]", children: /* @__PURE__ */ a.jsx(
    f5,
    {
      title: "가입한 멤버십이 없어요.",
      description: "좋아하는 크리에이터의 멤버십을 확인해 보세요!",
      renderImage: /* @__PURE__ */ a.jsx(
        aa,
        {
          src: kt.KeyVisual.MembershipMeetFan,
          width: "11.4286rem",
          height: "11.4286rem"
        }
      )
    }
  ) }) : /* @__PURE__ */ a.jsx(lw, { store: sCe, children: /* @__PURE__ */ a.jsx(
    aCe,
    {
      client: e,
      widgetCore: {
        isMobile: t,
        isApp: n,
        toggleSpinner: r,
        onError: s,
        onScrollLock: o
      },
      mypageMemberships: k.mypageMemberships,
      onCreatorShopButtonClick: c,
      onSeeMembershipDetailButtonClick: u,
      onReJoinMembershipButtonClick: m,
      onShopButtonClick: y
    }
  ) });
}
class Vje extends Ol {
  constructor({
    client: t,
    isMobile: n,
    isApp: r,
    toggleSpinner: s,
    onError: o,
    onScrollLock: c,
    onCreatorShopButtonClick: u,
    onReJoinMembershipButtonClick: m,
    onSeeMembershipDetailButtonClick: y,
    onShopButtonClick: b
  }) {
    super({
      client: t,
      isApp: r,
      isMobile: n,
      toggleSpinner: s,
      onError: o,
      onScrollLock: c
    }), this.render = (w) => {
      go(w).render(
        /* @__PURE__ */ a.jsx(
          iCe,
          {
            client: this.client,
            isApp: this.isApp,
            isMobile: this.isMobile,
            toggleSpinner: this.toggleSpinner,
            onError: this.onError,
            onScrollLock: this.onScrollLock,
            onCreatorShopButtonClick: this.onCreatorShopButtonClick,
            onReJoinMembershipButtonClick: this.onReJoinMembershipButtonClick,
            onSeeMembershipDetailButtonClick: this.onSeeMembershipDetailButtonClick,
            onShopButtonClick: this.onShopButtonClick
          }
        )
      );
    }, this.onCreatorShopButtonClick = u, this.onSeeMembershipDetailButtonClick = y, this.onReJoinMembershipButtonClick = m, this.onShopButtonClick = b;
  }
}
const Oq = (e, t) => jn(
  "/mypage-subscriptions-membership",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), Aq = Qt(
  Vn
), I3 = Qt(Vn), oCe = Qt(
  null,
  (e, t, n) => {
    const r = e(I3);
    if (r === Vn)
      throw new Error(
        Xr(ia.MypageSubscriptionsMembershipDetail)
      );
    t(I3, {
      ...r,
      payMethod: n
    });
  }
), lCe = Qt((e) => {
  const t = e(
    I3
  );
  if (t === Vn)
    throw new Error(Xr(ia.MypageSubscriptions));
  return W3(
    ({ paymentState: n }) => n,
    t.paymentStatements
  );
}), nx = () => {
  const [
    e,
    t
  ] = Ar(I3), n = Y3(
    lCe
  ), r = Ka(oCe);
  if (e === Vn)
    throw new Error(
      Xr(ia.MypageSubscriptionsMembershipDetail)
    );
  return {
    mypageMembershipSubscriptionsMembershipDetail: e,
    paymentStatementsGroupedByPaymentState: n,
    setMypageMembershipSubscriptionsMembershipDetail: t,
    setUpdatePayMethod: r
  };
}, cCe = (e, t) => jn(
  "/cancel-membership",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.HasNoMembershipSubscription:
      return n;
    default:
      throw new Error();
  }
}), uCe = () => {
  const [e, t] = Ar(Aq);
  if (e === Vn)
    throw new Error(Xr("membershipId"));
  return {
    membershipId: e,
    setMembershipId: t
  };
};
function pH(e) {
  const { client: t } = Ha(), {
    widgetCore: { toggleSpinner: n, onError: r, isMobile: s }
  } = Gt(), {
    mypageMembershipSubscriptionsMembershipDetail: o,
    setMypageMembershipSubscriptionsMembershipDetail: c
  } = nx(), [u, m] = Re(!1), { membershipId: y } = uCe(), b = tme(new Date(o.joinedAt), {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  }), w = async () => {
    try {
      m(!0), n(!0);
      const j = await cCe(
        { membershipId: o.id },
        {
          client: t,
          onError: r
        }
      );
      if (j.code === le.TokenExpired)
        return r(Ht);
      if (j.code === le.HasNoMembershipSubscription)
        return en({
          body: (E) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: E
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-center text-mshop-black", children: "해지 요청 불가" }),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-center text-mshop-gray-80", children: "해당 멤버십은 이미 해지되었거나, 해지 예정입니다." })
              ] })
            }
          )
        });
    } catch {
      return en({
        body: (j) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: j
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.857rem]", children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-center text-mshop-black", children: "요청 처리 불가" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m whitespace-pre-wrap text-center text-mshop-gray-80", children: [
                `예기치 못한 오류로 인해 진행할 수 없습니다.
동일한 문제가 반복적으로 발생할 경우
`,
                /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                "로 문의해 주세요."
              ] })
            ] })
          }
        )
      });
    } finally {
      m(!1), n(!1);
    }
    const k = await Oq(
      {
        membershipId: y
      },
      {
        client: t,
        onError: r
      }
    );
    if (m(!1), n(!1), k.code === le.TokenExpired)
      return r(Ht);
    c(
      k.data
    ), e.onClose(), await en({
      body: (j) => /* @__PURE__ */ a.jsx(
        ea,
        {
          button: {
            props: j
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.857rem]", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-center text-mshop-black", children: "멤버십 해지 요청 완료" }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-center text-mshop-gray-80", children: "지금까지 멤버십을 이용해 주셔서 감사합니다." }),
              /* @__PURE__ */ a.jsxs("span", { className: "flex items-start justify-center gap-[0.286rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "멤버십은" }),
                /* @__PURE__ */ a.jsxs("span", { className: "flex items-start gap-[0.286rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b text-mshop-blue-100", children: jt(o.expiredAt, "yyyy.MM.dd") }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b text-mshop-blue-100", children: "23:59" })
                ] }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "까지 유지됩니다." })
              ] })
            ] })
          ] })
        }
      )
    });
  };
  return /* @__PURE__ */ a.jsxs(
    dh,
    {
      show: e.show ?? !0,
      variant: "TYPE01",
      onClose: e.onClose,
      children: [
        s ? /* @__PURE__ */ a.jsx(
          LA,
          {
            variant: "Text+Close",
            title: "멤버십 해지하기",
            theme: "Light",
            onCloseButtonClick: e.onClose
          }
        ) : /* @__PURE__ */ a.jsx(
          D1,
          {
            titleAlign: "Left",
            back: !1,
            close: !0,
            label: "멤버십 해지하기",
            onCloseButtonClick: e.onClose
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "main",
          {
            className: $(
              "flex flex-col bg-mshop-white",
              s ? "h-full px-[1.143rem] py-[2.85714rem]" : "px-[2.28571rem] pb-[2.28571rem] pt-[1.14286rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                "img",
                {
                  alt: "",
                  src: kt.KeyVisual.CharacterMyLuvSad,
                  className: $(
                    "shrink-0 self-center object-cover",
                    s ? "size-[8.57143rem]" : "size-[11.429rem]"
                  )
                }
              ),
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    "flex flex-col",
                    s ? "gap-[1.71429rem]" : "gap-[2.28571rem]"
                  ),
                  children: [
                    /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[0.57143rem]", children: [
                      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.28571rem]", children: [
                        /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $(
                              "flex items-start justify-center",
                              s ? "gap-[0.14286rem]" : "gap-[gap-[0.28571rem]]"
                            ),
                            children: [
                              /* @__PURE__ */ a.jsxs(
                                "span",
                                {
                                  className: $(
                                    "text-mshop-blue-100",
                                    s ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b"
                                  ),
                                  children: [
                                    "크리에이터와 함께한 지",
                                    " "
                                  ]
                                }
                              ),
                              /* @__PURE__ */ a.jsxs("span", { children: [
                                /* @__PURE__ */ a.jsx(
                                  "span",
                                  {
                                    className: $(
                                      "text-mshop-blue-100",
                                      s ? "typo-mshop-en-14-unica-b" : "typo-mshop-en-16-unica-b"
                                    ),
                                    children: ZO(/* @__PURE__ */ new Date(), b) + 1
                                  }
                                ),
                                /* @__PURE__ */ a.jsx(
                                  "span",
                                  {
                                    className: $(
                                      "text-mshop-blue-100",
                                      s ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b"
                                    ),
                                    children: "일"
                                  }
                                )
                              ] }),
                              /* @__PURE__ */ a.jsx(
                                "span",
                                {
                                  className: $(
                                    "text-mshop-blue-100",
                                    s ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b"
                                  ),
                                  children: "되었어요."
                                }
                              )
                            ]
                          }
                        ),
                        /* @__PURE__ */ a.jsx(
                          "h2",
                          {
                            className: $(
                              "text-center",
                              s ? "typo-mshop-kr-20-b" : "typo-mshop-kr-24-b"
                            ),
                            children: "정말 멤버십을 해지하시겠어요?"
                          }
                        )
                      ] }),
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m whitespace-pre-wrap text-center text-mshop-gray-80", children: `멤버십을 해지하시면 누적 회차가 소멸되고,
이용 기간 종료 후 아래 멤버십을 이용하실 수 없어요.` })
                    ] }),
                    /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[0.57143rem]", children: [
                      /* @__PURE__ */ a.jsx("div", { className: "flex flex-col pt-[0.57143rem]", children: /* @__PURE__ */ a.jsx("div", { className: "border-b border-mshop-black pb-[0.85714rem]", children: /* @__PURE__ */ a.jsxs(
                        "button",
                        {
                          type: "button",
                          onClick: e.onShopButtonClick,
                          className: "flex items-center gap-[.29rem]",
                          children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: Ef(o.shop) }),
                            /* @__PURE__ */ a.jsx(ch, { className: "size-[1.42857rem]" })
                          ]
                        }
                      ) }) }),
                      /* @__PURE__ */ a.jsxs(
                        "div",
                        {
                          className: $(
                            "flex items-center justify-between py-[1.14286rem]",
                            {
                              "gap-[0.57143rem]": s
                            }
                          ),
                          children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m", children: o.displayName }),
                            /* @__PURE__ */ a.jsxs("span", { className: "flex flex-col items-center gap-[0.14286rem]", children: [
                              /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-16-b text-mshop-blue-100", children: [
                                o.streakCount,
                                "회차 가입 중"
                              ] }),
                              /* @__PURE__ */ a.jsxs("span", { className: "flex items-start gap-[.29rem]", children: [
                                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-50", children: jt(o.expiredAt, "yyyy.MM.dd") }),
                                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-50", children: "해지 예정" })
                              ] })
                            ] })
                          ]
                        }
                      ),
                      /* @__PURE__ */ a.jsx("div", { className: "flex-center typo-mshop-kr-14-m rounded-[0.57143rem] bg-mshop-red-10 p-[0.57143rem] text-mshop-red-80", children: "해지하기를 누를 경우 취소할 수 없습니다." })
                    ] })
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "footer",
          {
            className: $(
              "flex border-t border-mshop-gray-5 bg-mshop-white",
              s ? "p-[1.143rem] gap-[1.143rem]" : "px-[2.28571rem] py-[1.143rem] gap-[0.85714rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "lg",
                  theme: "line",
                  widthFull: !0,
                  type: "button",
                  onClick: e.onClose,
                  children: "취소"
                }
              ),
              /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "lg",
                  theme: "blue",
                  widthFull: !0,
                  type: "button",
                  disabled: u,
                  onClick: w,
                  children: "해지하기"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function gH({
  communityRewards: e
}) {
  const { mypageMembershipSubscriptionsMembershipDetail: t } = nx();
  wt(t.dao);
  const {
    widgetCore: { isMobile: n }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $("flex flex-col", {
        "gap-[0.57143rem]": !n
      }),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("flex items-end justify-between", {
              "pb-[0.85714rem]": n
            }),
            children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "사이어티 커뮤니티 혜택" }),
              n ? /* @__PURE__ */ a.jsxs(
                "a",
                {
                  className: "flex items-center gap-[0.28571rem] rounded-[0.28571rem] bg-mshop-black px-[0.57143rem] py-[0.28571rem]",
                  href: Ku({
                    type: "home",
                    subdomain: t.dao.subdomain
                  }),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: [
                    /* @__PURE__ */ a.jsx(ek, { className: "size-[1.14286rem] shrink-0 text-ciety-lg" }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-ciety-lg", children: "커뮤니티" })
                  ]
                }
              ) : /* @__PURE__ */ a.jsx(
                Y2,
                {
                  theme: "lg",
                  variant: "sm",
                  iconFront: "cietySymbol",
                  as: "a",
                  href: Ku({
                    type: "home",
                    subdomain: t.dao.subdomain
                  }),
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: "커뮤니티"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsx(
          "ul",
          {
            className: $(
              "flex flex-col gap-[0.85714rem] rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem]",
              {
                "mt-[0.57143rem]": !n
              }
            ),
            children: e.map((r) => /* @__PURE__ */ a.jsxs(
              "li",
              {
                className: "flex flex-col gap-[0.57143rem]",
                children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.57143rem]", children: [
                    /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.57143rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[.1429rem] bg-mshop-black" }) }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b whitespace-pre-wrap break-all text-mshop-black", children: r.title ?? d6[r.type] }),
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: Vv[r.type] })
                    ] })
                  ] }),
                  r.type !== "DM" && /* @__PURE__ */ a.jsx(
                    "div",
                    {
                      className: $(
                        "flex flex-wrap py-[0.28571rem] pl-[0.71429rem]",
                        n ? "gap-[0.57143rem]" : "gap-[0.28571rem]"
                      ),
                      children: [
                        ...r.channels.filter(
                          (s) => s.visibility !== "PRIVATE"
                        ),
                        ...r.channels.filter(
                          (s) => s.visibility === "PRIVATE"
                        )
                      ].map((s) => {
                        wt(t.dao);
                        const o = u6[s.type];
                        return /* @__PURE__ */ a.jsxs(
                          "a",
                          {
                            className: $(
                              "flex items-center gap-[0.28571rem] rounded-[0.28571rem] bg-mshop-gray-5",
                              n ? "max-w-[14.57143rem] px-[0.57143rem] py-[0.28571rem]" : "min-h-[2.85714rem] max-w-[15.14286rem] px-[0.85714rem]"
                            ),
                            href: s.visibility === "PRIVATE" ? Ku({
                              type: "home",
                              subdomain: t.dao.subdomain
                            }) : Ku({
                              type: "channel",
                              subdomain: t.dao.subdomain,
                              channelId: s.id
                            }),
                            target: "_blank",
                            children: [
                              /* @__PURE__ */ a.jsx(o, { className: "size-[1.14286rem] shrink-0 text-mshop-gray-80" }),
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m line-clamp-1 text-mshop-gray-80", children: s.displayName ?? `비공개 채널 ${s.count}개` })
                            ]
                          },
                          s.id
                        );
                      })
                    }
                  )
                ]
              },
              r.id
            ))
          }
        )
      ]
    }
  );
}
function yH({
  creatorRewards: e
}) {
  const {
    widgetCore: { isMobile: t }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      id: "my-page-membership-detail-creator-reward-list",
      className: $("flex flex-col", {
        "gap-[0.571rem]": !t
      }),
      children: [
        /* @__PURE__ */ a.jsx(
          "h2",
          {
            className: $("typo-mshop-kr-16-b", {
              "pb-[0.85714rem]": t
            }),
            children: "크리에이터 혜택"
          }
        ),
        /* @__PURE__ */ a.jsx(
          "ul",
          {
            className: $(
              "flex flex-col gap-[0.857rem] rounded-[0.857rem] border border-mshop-gray-10 p-[1.143rem]",
              {
                "mt-[0.571rem]": !t
              }
            ),
            children: e.map((n) => /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[0.571rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.571rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.143rem] rounded-full bg-mshop-black" }) }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex grow flex-col", children: [
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-b whitespace-pre-wrap break-all text-mshop-black", children: n.title }),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: Vv[n.type] })
              ] })
            ] }, n.id))
          }
        )
      ]
    }
  );
}
function vH({
  onMembershipCardDownloadButtonClick: e,
  onContactButtonClick: t,
  onShopButtonClick: n
}) {
  const { mypageMembershipSubscriptionsMembershipDetail: r } = nx(), s = Rt(null), {
    widgetCore: { isMobile: o, onError: c, toggleSpinner: u }
  } = Gt(), { client: m } = Ha(), [y, b] = Re(!1), w = r.membershipCard.shopUrl === null ? null : r.membershipCard.shopUrl.replace(/^https:\/\//, "").replace(/\/(kr|en|jp)\//, "/"), k = async () => {
    wt(s.current);
    const j = await s.current.getBlob();
    if (j === null)
      return en({
        body: (D) => /* @__PURE__ */ a.jsx(
          ea,
          {
            button: {
              props: D
            },
            children: /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: "다시 시도해 주세요." })
          }
        )
      });
    b(!0), u(!0);
    const E = await cw(
      {},
      {
        client: m,
        onError: c
      }
    );
    if (E.code === le.TokenExpired)
      return b(!1), u(!1), c(Ht);
    const T = await fetch(E.data.uploadUrl, {
      method: "PUT",
      referrerPolicy: "no-referrer-when-downgrade",
      headers: {
        "Content-Type": j.type
      },
      cache: "no-store",
      body: j
    });
    if (b(!1), u(!1), T.ok === !1)
      return gE(T.status, c);
    e(
      E.data.url,
      r.membershipCard.displayName
    );
  };
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $(
        "flex w-full flex-col",
        o ? "gap-[0.85714rem]" : "items-center gap-[1.714rem]"
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "article",
          {
            id: "my-page-membership-detail-membership-card",
            className: $(
              "relative isolate w-full overflow-hidden",
              o ? "h-[14.85714rem] rounded-[0.59036rem]" : "h-[28.571rem] rounded-[1.143rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                aa,
                {
                  src: r.membershipCard.thumbnailImage.url,
                  width: o ? "24.5rem" : "47.4286rem",
                  height: o ? "14.7593rem" : "28.5714rem",
                  objectFit: "cover"
                }
              ),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "absolute top-0 w-full bg-mshop-dim-60",
                    o ? "h-[14.85714rem]" : "h-[28.571rem]"
                  )
                }
              ),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "absolute top-0 flex w-full flex-col justify-between",
                    o ? "h-[14.85714rem] p-[0.88557rem]" : "h-[28.571rem] p-[1.714rem]"
                  ),
                  children: o ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-bebas-b text-mshop-white", children: "MARPPLESHOP" }),
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-bebas-b -mt-[0.57143rem] text-mshop-white", children: "CREATOR MEMBERSHIP" })
                    ] }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex items-end gap-[0.57143rem]", children: [
                      /* @__PURE__ */ a.jsxs("div", { className: "flex w-[13.71429rem] shrink-0 flex-col gap-[0.28571rem]", children: [
                        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.14286rem]", children: [
                          /* @__PURE__ */ a.jsxs(
                            "button",
                            {
                              type: "button",
                              onClick: n,
                              className: "flex items-center gap-[0.14286rem]",
                              children: [
                                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-10-m line-clamp-1 text-start text-mshop-white", children: Ef(r.shop) }),
                                /* @__PURE__ */ a.jsx(ch, { className: "size-[0.71429rem] shrink-0 text-mshop-white" })
                              ]
                            }
                          ),
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-b text-mshop-white", children: r.membershipCard.displayName })
                        ] }),
                        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
                          /* @__PURE__ */ a.jsxs("span", { className: "flex gap-[0.57143rem]", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-10-unica-r text-mshop-gray-20", children: "Member" }),
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-10-m text-mshop-blue-100", children: `@${Mc(r.membershipCard.user)}` })
                          ] }),
                          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.57143rem]", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-10-unica-r text-mshop-gray-20", children: "Member Since" }),
                            /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.14286rem]", children: [
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-10-unica-r text-mshop-gray-20", children: jt(
                                r.membershipCard.startDate,
                                "yyyy. MM. dd"
                              ) }),
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-10-unica-r text-mshop-gray-20", children: "~" }),
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-10-unica-r text-mshop-gray-20", children: r.membershipCard.endDate ? jt(
                                r.membershipCard.endDate,
                                "yyyy. MM. dd"
                              ) : "Current" })
                            ] })
                          ] })
                        ] })
                      ] }),
                      w && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-10-unica-r w-[calc(100%-13.71429rem-0.57143rem)] break-words text-right text-mshop-white", children: w })
                    ] })
                  ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-32-bebas-b whitespace-pre text-mshop-white", children: `MARPPLESHOP
CREATOR MEMBERSHIP` }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
                      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.28571rem]", children: [
                        /* @__PURE__ */ a.jsxs(
                          "button",
                          {
                            type: "button",
                            onClick: n,
                            className: "flex items-center gap-[0.28571rem]",
                            children: [
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-white", children: Ef(r.shop) }),
                              /* @__PURE__ */ a.jsx(ch, { className: "size-[1.42857rem] shrink-0 text-mshop-white" })
                            ]
                          }
                        ),
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-24-b text-mshop-white", children: r.membershipCard.displayName })
                      ] }),
                      /* @__PURE__ */ a.jsxs("div", { className: "flex items-end gap-[0.571rem]", children: [
                        /* @__PURE__ */ a.jsxs("div", { className: "flex w-1/2 flex-col gap-[0.143rem]", children: [
                          /* @__PURE__ */ a.jsxs("span", { className: "flex items-start gap-[1.143rem]", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-20", children: "Member" }),
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-blue-100", children: `@${Mc(r.membershipCard.user)}` })
                          ] }),
                          /* @__PURE__ */ a.jsxs("span", { className: "flex items-start gap-[1.143rem]", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-20", children: "Member Since" }),
                            /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.14286rem]", children: [
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-20", children: jt(
                                r.membershipCard.startDate,
                                "yyyy. MM. dd"
                              ) }),
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-20", children: "~" }),
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-20", children: r.membershipCard.endDate ? jt(
                                r.membershipCard.endDate,
                                "yyyy. MM. dd"
                              ) : "Current" })
                            ] })
                          ] })
                        ] }),
                        w && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-14-unica-m w-1/2 break-words text-right text-mshop-gray-20", children: w })
                      ] })
                    ] })
                  ] })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsx(
          iq,
          {
            ref: s,
            thumbnailImageUrl: r.membershipCard.thumbnailImage.url,
            displayName: r.membershipCard.displayName,
            user: r.membershipCard.user,
            memberSince: `${jt(
              r.membershipCard.startDate,
              "yyyy. MM. dd"
            )} ~ ${r.membershipCard.endDate ? jt(r.membershipCard.endDate, "yyyy. MM. dd") : "Current"}`,
            shopUrl: w,
            shopName: Ef(r.shop)
          }
        ),
        o ? /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.57143rem]", children: [
          /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "sm",
              theme: "line",
              iconRear: "download",
              type: "button",
              widthFull: !0,
              disabled: y,
              onClick: k,
              children: "멤버십 카드 저장"
            }
          ),
          /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "sm",
              theme: "line",
              type: "button",
              widthFull: !0,
              onClick: t,
              children: "멤버십 문의하기"
            }
          )
        ] }) : /* @__PURE__ */ a.jsx(
          fn,
          {
            variant: "md",
            theme: "line",
            iconRear: "download",
            type: "button",
            disabled: y,
            onClick: k,
            children: "멤버십 카드 다운로드"
          }
        )
      ]
    }
  );
}
function IR(e) {
  const [t, n] = Re(!1), { client: r } = Ha(), [s, o] = Re(null), {
    widgetCore: { toggleSpinner: c, onError: u, isMobile: m }
  } = Gt(), { isDevMode: y } = f6(), [b, w] = Re(!1), k = e.variant === "settled", j = e.variant === "refunded", E = e.variant === "reversed", T = async () => {
    if (m) {
      w(!0), c(!0);
      const D = await kw(
        {
          paymentStatementId: e.paymentStatementId
        },
        {
          client: r,
          onError: u
        }
      );
      if (w(!1), c(!1), D.code === le.TokenExpired)
        return u(Ht);
      O4(D.data.target === "MEMBERSHIP"), o(D.data), n(!0);
    } else
      E6(e.paymentStatementId);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex py-[0.571rem]",
          m ? "items-start gap-[1.14286rem]" : "items-center gap-[3.429rem]"
        ),
        children: [
          E ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ a.jsxs(
              "span",
              {
                className: $(
                  "typo-mshop-kr-14-m text-mshop-gray-50",
                  m ? "w-[5.71429rem]" : "w-[9.143rem]"
                ),
                children: [
                  e.streakCount,
                  "회차"
                ]
              }
            ),
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: $(
                  "typo-mshop-kr-14-m text-mshop-gray-50",
                  m ? "w-[5.71429rem]" : "w-[9.143rem]"
                ),
                children: "결제 취소"
              }
            )
          ] }) : /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "typo-mshop-kr-14-m text-mshop-gray-50",
                m ? "w-[5.71429rem]" : "w-[9.143rem]"
              ),
              children: [
                e.streakCount,
                "회차"
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "flex grow flex-col",
                m ? "gap-[0.28571rem]" : "gap-[0.571rem]"
              ),
              children: [
                /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $(
                      "typo-mshop-en-14-unica-m",
                      j ? "text-mshop-gray-50" : "text-mshop-black"
                    ),
                    children: jt(e.paidAt, "yyyy.MM.dd HH:mm")
                  }
                ),
                m ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                  /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
                    /* @__PURE__ */ a.jsxs(
                      "span",
                      {
                        className: $("typo-mshop-en-14-unica-b", {
                          "text-mshop-black": k,
                          "text-mshop-red-80": E,
                          "text-mshop-gray-50": j
                        }),
                        children: [
                          E && "-",
                          e.price.toLocaleString(cr.Ko)
                        ]
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $("typo-mshop-kr-14-b", {
                          "text-mshop-black": k,
                          "text-mshop-red-80": E,
                          "text-mshop-gray-50": j
                        }),
                        children: "원"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.28571rem]", children: [
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $(
                          "typo-mshop-kr-14-m",
                          j ? "text-mshop-gray-50" : "text-mshop-gray-80"
                        ),
                        children: "신용카드"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $(
                          "typo-mshop-kr-14-m",
                          j ? "text-mshop-gray-50" : "text-mshop-gray-80"
                        ),
                        children: `(${e.cardName})`
                      }
                    )
                  ] })
                ] }) : /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.571rem]", children: [
                  /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
                    /* @__PURE__ */ a.jsxs(
                      "span",
                      {
                        className: $(
                          "typo-mshop-en-14-unica-m",
                          {
                            "text-mshop-black": k,
                            "text-mshop-red-80": E,
                            "text-mshop-gray-50": j
                          }
                        ),
                        children: [
                          E && "-",
                          e.price.toLocaleString(cr.Ko)
                        ]
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $("typo-mshop-kr-14-m", {
                          "text-mshop-black": k,
                          "text-mshop-red-80": E,
                          "text-mshop-gray-50": j
                        }),
                        children: "원"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-gray-10", children: "|" }),
                  /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.286rem]", children: [
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $(
                          "typo-mshop-kr-14-m",
                          j ? "text-mshop-gray-50" : "text-mshop-gray-80"
                        ),
                        children: "신용카드"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $(
                          "typo-mshop-kr-14-m",
                          j ? "text-mshop-gray-50" : "text-mshop-gray-80"
                        ),
                        children: `(${e.cardName})`
                      }
                    )
                  ] })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-end gap-1", children: [
            /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "flex-center typo-mshop-kr-12-m rounded border border-mshop-gray-20 bg-mshop-white px-[0.571rem] py-[0.286rem] text-mshop-gray-80",
                disabled: b,
                onClick: T,
                children: "영수증"
              }
            ),
            e.variant === "settled" && y && /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "flex-center typo-mshop-kr-12-m rounded border border-mshop-gray-20 bg-mshop-white px-[0.571rem] py-[0.286rem] text-mshop-gray-80",
                onClick: async () => {
                  switch ((await AA(
                    { portonePaymentStatementId: e.paymentStatementId },
                    { client: r, onError: Gd }
                  )).code) {
                    case "000":
                      await en({
                        body: (L) => /* @__PURE__ */ a.jsx(
                          ea,
                          {
                            button: {
                              props: L
                            },
                            children: /* @__PURE__ */ a.jsx("div", { children: "환불 완료" })
                          }
                        )
                      });
                      return;
                    case "018":
                      await en({
                        body: (L) => /* @__PURE__ */ a.jsx(
                          ea,
                          {
                            button: {
                              props: L
                            },
                            children: /* @__PURE__ */ a.jsx("div", { children: "환불할 데이터가 없음" })
                          }
                        )
                      });
                      return;
                    case "019":
                      await en({
                        body: (L) => /* @__PURE__ */ a.jsx(
                          ea,
                          {
                            button: {
                              props: L
                            },
                            children: /* @__PURE__ */ a.jsx("div", { children: "이미 취소된 정보" })
                          }
                        )
                      });
                      return;
                    case "001":
                      await en({
                        body: (L) => /* @__PURE__ */ a.jsx(
                          ea,
                          {
                            button: {
                              props: L
                            },
                            children: /* @__PURE__ */ a.jsx("div", { children: "token 만료" })
                          }
                        )
                      });
                      return;
                  }
                },
                children: "결제 취소"
              }
            )
          ] })
        ]
      }
    ),
    m && /* @__PURE__ */ a.jsx(
      k6,
      {
        show: t,
        target: "MEMBERSHIP",
        business: (s == null ? void 0 : s.business) ?? null,
        endTimeAt: (s == null ? void 0 : s.endTimeAt) ?? null,
        paymentDetails: (s == null ? void 0 : s.paymentDetails) ?? null,
        paymentRecord: (s == null ? void 0 : s.paymentRecord) ?? null,
        startTimeAt: (s == null ? void 0 : s.startTimeAt) ?? null,
        onClose: () => n(!1)
      }
    )
  ] });
}
function xH() {
  const { paymentStatementsGroupedByPaymentState: e } = nx(), {
    widgetCore: { isMobile: t }
  } = Gt(), n = [
    ...e.PAID
  ].reverse();
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      id: "my-page-membership-detail-order-list",
      className: $("flex flex-col", {
        "gap-[0.571rem]": !t
      }),
      children: [
        /* @__PURE__ */ a.jsx(
          "header",
          {
            className: $(
              "flex items-center border-b border-mshop-black pb-[0.857rem]",
              { "mb-[0.57143rem]": t }
            ),
            children: /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b text-mshop-black", children: "결제 내역" })
          }
        ),
        n.map(
          ({
            id: r,
            paidAt: s,
            payMethod: o,
            price: c,
            streakCount: u,
            cardName: m,
            paymentRequestId: y
          }, b) => {
            var E;
            const w = (E = e.CANCELLED) == null ? void 0 : E.find(
              (T) => T.paymentRequestId === y
            ), k = b === n.length - 1, j = u === 1 && !k;
            return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              w ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                /* @__PURE__ */ a.jsx(
                  IR,
                  {
                    variant: "reversed",
                    paidAt: w.paidAt,
                    payMethod: w.payMethod,
                    price: w.price,
                    streakCount: w.streakCount,
                    paymentStatementId: w.id,
                    cardName: w.cardName
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  IR,
                  {
                    variant: "refunded",
                    paidAt: s,
                    payMethod: o,
                    price: c,
                    streakCount: u,
                    paymentStatementId: r,
                    cardName: m
                  }
                )
              ] }) : /* @__PURE__ */ a.jsx(
                IR,
                {
                  variant: "settled",
                  paidAt: s,
                  payMethod: o,
                  price: c,
                  streakCount: u,
                  paymentStatementId: r,
                  cardName: m
                }
              ),
              j && /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[1.714rem] py-[0.571rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "h-[0.071rem] grow bg-mshop-gray-10" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "멤버십 재가입" }),
                /* @__PURE__ */ a.jsx("div", { className: "h-[0.071rem] grow bg-mshop-gray-10" })
              ] })
            ] }, r);
          }
        )
      ]
    }
  );
}
function bH() {
  const { mypageMembershipSubscriptionsMembershipDetail: e } = nx(), {
    widgetCore: { isMobile: t, toggleSpinner: n, onError: r }
  } = Gt(), { client: s } = Ha(), [o, c] = Re(!1), [u, m] = Re(null), [y, b] = Re(!1), { isDevMode: w } = f6(), k = [...e.paymentStatements].reverse().find((T) => T.paymentState === "PAID");
  wt(k);
  const j = async () => {
    if (t) {
      c(!0), n(!0);
      const T = await kw(
        {
          paymentStatementId: k.id
        },
        {
          client: s,
          onError: r
        }
      );
      if (c(!1), n(!1), T.code === le.TokenExpired)
        return r(Ht);
      O4(T.data.target === "MEMBERSHIP"), m(T.data), b(!0);
    } else
      E6(k.id);
  }, E = async () => {
    const T = await AA(
      { portonePaymentStatementId: k.id },
      { client: s, onError: Gd }
    );
    T.code === "000" ? alert("환불 완료") : T.code === "018" ? alert("환불할 데이터가 없음") : T.code === "019" ? alert("이미 취소된 정보") : T.code === "001" && alert("토큰 만료");
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "section",
      {
        id: "my-page-membership-detail-payment-info",
        className: "flex flex-col gap-[0.571rem]",
        children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between border-b border-mshop-black pb-[0.857rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "결제 정보" }),
            w && /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "typo-mshop-kr-12-m flex items-center justify-center rounded-[0.28571rem] bg-mshop-blue-10 px-[0.57143rem] py-[0.28571rem] text-mshop-blue-100",
                onClick: E,
                children: "결제 취소"
              }
            ),
            /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "typo-mshop-kr-12-m flex items-center justify-center rounded-[0.28571rem] bg-mshop-blue-10 px-[0.57143rem] py-[0.28571rem] text-mshop-blue-100",
                disabled: o,
                onClick: j,
                children: "영수증 조회"
              }
            )
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex items-center",
                  t ? "gap-[1.14286rem] py-[0.57143rem]" : "gap-[3.429rem] py-[0.857rem]"
                ),
                children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "typo-mshop-kr-14-m text-mshop-gray-50",
                        t ? "w-[5.71429rem]" : "w-[9.143rem]"
                      ),
                      children: "결제 금액"
                    }
                  ),
                  /* @__PURE__ */ a.jsx("span", { className: "flex items-center gap-[0.286rem]", children: /* @__PURE__ */ a.jsxs("span", { className: "flex items-center", children: [
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $(
                          "text-mshop-black",
                          t ? "typo-mshop-en-14-unica-b" : "typo-mshop-en-20-unica-b"
                        ),
                        children: k.price.toLocaleString(cr.Ko)
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $(
                          "text-mshop-black",
                          t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-20-b"
                        ),
                        children: "원"
                      }
                    )
                  ] }) })
                ]
              }
            ),
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex items-center",
                  t ? "gap-[1.14286rem] py-[0.57143rem]" : "gap-[3.429rem] py-[0.857rem]"
                ),
                children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "typo-mshop-kr-14-m text-mshop-gray-50",
                        t ? "w-[5.71429rem]" : "w-[9.143rem]"
                      ),
                      children: "결제 수단"
                    }
                  ),
                  k.payMethod === $g.Card ? /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.286rem]", children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: "신용카드" }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: `(${k.cardName})` })
                  ] }) : /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: c_[k.payMethod] })
                ]
              }
            ),
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex items-center",
                  t ? "gap-[1.14286rem] py-[0.57143rem]" : "gap-[3.429rem] py-[0.857rem]"
                ),
                children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "typo-mshop-kr-14-m text-mshop-gray-50",
                        t ? "w-[5.71429rem]" : "w-[9.143rem]"
                      ),
                      children: "승인 시간"
                    }
                  ),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-black", children: jt(k.paidAt, "yyyy.MM.dd") })
                ]
              }
            )
          ] })
        ]
      }
    ),
    t && /* @__PURE__ */ a.jsx(
      k6,
      {
        show: y,
        target: "MEMBERSHIP",
        business: (u == null ? void 0 : u.business) ?? null,
        endTimeAt: (u == null ? void 0 : u.endTimeAt) ?? null,
        paymentDetails: (u == null ? void 0 : u.paymentDetails) ?? null,
        paymentRecord: (u == null ? void 0 : u.paymentRecord) ?? null,
        startTimeAt: (u == null ? void 0 : u.startTimeAt) ?? null,
        onClose: () => b(!1)
      }
    )
  ] });
}
function SH(e) {
  const {
    mypageMembershipSubscriptionsMembershipDetail: t,
    setUpdatePayMethod: n
  } = nx();
  wt(t.payMethod);
  const [r, s] = Re(!1), {
    widgetCore: { isMobile: o }
  } = Gt(), c = (u) => {
    n(u), s(!1);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "section",
      {
        id: "my-page-membership-detail-payment-info",
        className: "flex flex-col gap-[0.571rem]",
        children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex justify-between border-b border-mshop-black pb-[0.857rem]", children: /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "결제 정보" }) }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex items-center",
                  o ? "gap-[1.14286rem] py-[0.57143rem]" : "gap-[3.429rem] py-[0.857rem]"
                ),
                children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "typo-mshop-kr-14-m text-mshop-gray-50",
                        o ? "w-[5.71429rem]" : "w-[9.143rem]"
                      ),
                      children: "결제 금액"
                    }
                  ),
                  /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.286rem]", children: [
                    /* @__PURE__ */ a.jsxs("span", { className: "flex items-center", children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $(
                            "text-mshop-black",
                            o ? "typo-mshop-en-14-unica-b" : "typo-mshop-en-20-unica-b"
                          ),
                          children: t.payment.price.toLocaleString(cr.Ko)
                        }
                      ),
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $(
                            "text-mshop-black",
                            o ? "typo-mshop-kr-14-b" : "typo-mshop-kr-20-b"
                          ),
                          children: zs(t.payment.currency)
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $(
                          "text-mshop-black",
                          o ? "typo-mshop-kr-14-m" : "typo-mshop-kr-12-m"
                        ),
                        children: "/ 월"
                      }
                    )
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex items-center",
                  o ? "gap-[1.14286rem] py-[0.57143rem]" : "gap-[3.429rem] py-[0.857rem]"
                ),
                children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "typo-mshop-kr-14-m text-mshop-gray-50",
                        o ? "w-[5.71429rem]" : "w-[9.143rem]"
                      ),
                      children: "결제 수단"
                    }
                  ),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex grow items-center justify-between", children: [
                    /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.286rem]", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: "신용카드" }),
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: `(${t.payMethod.name})` })
                    ] }),
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        type: "button",
                        className: "flex-center typo-mshop-kr-12-m rounded-[0.286rem] border border-mshop-gray-20 bg-mshop-bright-20 px-[0.571rem] py-[0.286rem] text-mshop-gray-80",
                        onClick: () => s(!0),
                        children: "결제 수단 변경"
                      }
                    )
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex items-center",
                  o ? "gap-[1.14286rem] py-[0.57143rem]" : "gap-[3.429rem] py-[0.857rem]"
                ),
                children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "typo-mshop-kr-14-m text-mshop-gray-50",
                        o ? "w-[5.71429rem]" : "w-[9.143rem]"
                      ),
                      children: "다음 결제일"
                    }
                  ),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-black", children: jt(t.expiredAt, "yyyy.MM.dd") })
                ]
              }
            )
          ] })
        ]
      }
    ),
    o ? /* @__PURE__ */ a.jsx(
      Z8,
      {
        isMobile: !0,
        show: r,
        registeredPayMethod: t.payMethod,
        onClose: () => s(!1),
        onRegister: c,
        onClickPersonalInfoOutsourcing: e.onClickPersonalInfoOutsourcing,
        onClickThirdPartyConsent: e.onClickThirdPartyConsent,
        onClickInicisTerms: e.onClickInicisTerms
      }
    ) : r && t.payMethod && /* @__PURE__ */ a.jsx(
      Z8,
      {
        registeredPayMethod: t.payMethod,
        onClose: () => s(!1),
        onRegister: c,
        onClickPersonalInfoOutsourcing: e.onClickPersonalInfoOutsourcing,
        onClickThirdPartyConsent: e.onClickThirdPartyConsent,
        onClickInicisTerms: e.onClickInicisTerms
      }
    )
  ] });
}
function wH({
  productRewards: e,
  onMembershipProductsButtonClick: t
}) {
  const {
    widgetCore: { isMobile: n }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      id: "my-page-membership-detail-product-reward-list",
      className: $("flex flex-col", { "gap-[0.571rem]": !n }),
      children: [
        /* @__PURE__ */ a.jsxs(
          "header",
          {
            className: $("flex items-end justify-between", {
              "pb-[0.85714rem]": n
            }),
            children: [
              /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b text-mshop-black", children: "멤버십 전용 상품" }),
              n ? (
                // https://www.figma.com/design/tTvmWtcT6TaDLZhmCNE8kk?node-id=8326-229517&m=dev#1046984834
                /* @__PURE__ */ a.jsxs(
                  "button",
                  {
                    type: "button",
                    className: "flex-center gap-x-[0.28571rem] rounded-[0.28571rem] bg-mshop-blue-100 px-[0.57143rem] py-[0.28571rem]",
                    onClick: t,
                    children: [
                      /* @__PURE__ */ a.jsx(ch, { className: "size-[1.14286rem] text-mshop-white" }),
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-white", children: "멤버십 상품" })
                    ]
                  }
                )
              ) : /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "sm",
                  theme: "blue",
                  iconFront: "shopDefault",
                  type: "button",
                  onClick: t,
                  children: "멤버십 상품"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsx(
          "ul",
          {
            className: $(
              "flex flex-col gap-[0.857rem] rounded-[0.857rem] border border-mshop-gray-10 p-[1.143rem]",
              {
                "mt-[0.571rem]": !n
              }
            ),
            children: e.map(({ id: r, title: s, type: o, products: c }) => {
              const u = c.length > 0, m = [...c].sort(
                (y, b) => b.price - y.price
              );
              return n ? /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[0.57143rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "flex-center h-[1.57143rem]", children: /* @__PURE__ */ a.jsx("div", { className: "rouned-full size-[0.14286rem] bg-mshop-black" }) }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-grow flex-col", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b whitespace-pre-wrap break-all text-mshop-black", children: s ?? c6[o] }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: Vv[o] }),
                  u && /* @__PURE__ */ a.jsx("div", { className: "grid grid-cols-6 gap-[0.57143rem] pt-[0.28571rem]", children: m.map(({ id: y, image: b, imageRatio: w, link: k }) => /* @__PURE__ */ a.jsx(
                    "a",
                    {
                      className: "flex-center isolate aspect-square overflow-hidden rounded-[0.57143rem] bg-mshop-gray-5",
                      href: k,
                      children: /* @__PURE__ */ a.jsx(
                        "img",
                        {
                          alt: "",
                          className: "aspect-square object-cover",
                          src: b,
                          style: {
                            width: `${w}%`
                          }
                        }
                      )
                    },
                    y
                  )) })
                ] })
              ] }, r) : /* @__PURE__ */ a.jsxs("li", { className: "flex flex-col gap-[0.571rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.571rem]", children: [
                  /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.571rem] items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.143rem] rounded-full bg-mshop-black" }) }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex grow flex-col", children: [
                    /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-b whitespace-pre-wrap break-all text-mshop-black", children: s }),
                    /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: Vv[o] })
                  ] })
                ] }),
                u && /* @__PURE__ */ a.jsx("div", { className: "grid grid-cols-11 gap-[0.571rem] py-[0.286rem] pl-[0.714rem]", children: m.map(({ id: y, image: b, imageRatio: w, link: k }) => /* @__PURE__ */ a.jsx(
                  "a",
                  {
                    className: "flex-center isolate aspect-square overflow-hidden rounded-[0.571rem] bg-mshop-gray-5",
                    href: k,
                    children: /* @__PURE__ */ a.jsx(
                      "img",
                      {
                        alt: "",
                        className: "aspect-square object-cover",
                        style: {
                          width: `${w}%`
                        },
                        src: b
                      }
                    )
                  },
                  y
                )) })
              ] }, r);
            })
          }
        )
      ]
    }
  );
}
function CH() {
  const { mypageMembershipSubscriptionsMembershipDetail: e } = nx(), {
    widgetCore: { isMobile: t, toggleSpinner: n, onError: r }
  } = Gt(), { client: s } = Ha(), [o, c] = Re(!1), [u, m] = Re(null), [y, b] = Re(!1), w = e.paymentStatements.at(-1);
  wt(w);
  const k = async () => {
    if (t) {
      c(!0), n(!0);
      const j = await kw(
        {
          paymentStatementId: w.id
        },
        {
          client: s,
          onError: r
        }
      );
      if (c(!1), n(!1), j.code === le.TokenExpired)
        return r(Ht);
      O4(j.data.target === "MEMBERSHIP"), m(j.data), b(!0);
    } else
      E6(w.id);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between border-b border-mshop-black pb-[0.85714rem]", children: [
        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "환불 정보" }),
        /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: "typo-mshop-kr-12-m flex items-center justify-center rounded-[0.28571rem] bg-mshop-blue-10 px-[0.57143rem] py-[0.28571rem] text-mshop-blue-100",
            disabled: o,
            onClick: k,
            children: "영수증 조회"
          }
        )
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[1.14286rem] py-[0.57143rem]", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m w-[5.71429rem] text-mshop-gray-50", children: "취소 금액" }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex", children: [
            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-14-unica-m text-mshop-red-80", children: [
              "-",
              w.price
            ] }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-red-80", children: "원" })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[1.14286rem] py-[0.57143rem]", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m w-[5.71429rem] text-mshop-gray-50", children: "환불수단" }),
          w.payMethod === $g.Card ? /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.286rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: "신용카드" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: `(${w.cardName})` })
          ] }) : /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: c_[w.payMethod] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[1.14286rem] py-[0.57143rem]", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m w-[5.71429rem] text-mshop-gray-50", children: "승인 시간" }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-black", children: jt(
            o9(w.paidAt),
            "yyyy.MM.dd HH:mm"
          ) })
        ] })
      ] })
    ] }),
    t && /* @__PURE__ */ a.jsx(
      k6,
      {
        show: y,
        target: "MEMBERSHIP",
        business: (u == null ? void 0 : u.business) ?? null,
        endTimeAt: (u == null ? void 0 : u.endTimeAt) ?? null,
        paymentDetails: (u == null ? void 0 : u.paymentDetails) ?? null,
        paymentRecord: (u == null ? void 0 : u.paymentRecord) ?? null,
        startTimeAt: (u == null ? void 0 : u.startTimeAt) ?? null,
        onClose: () => b(!1)
      }
    )
  ] });
}
const dCe = {
  big: $(
    "h-[2.85714rem] gap-x-[.14285rem] px-[1.14285rem] py-[.57143rem]",
    "typo-mshop-kr-14-m rounded-[.57142rem] bg-mshop-blue-10 text-mshop-blue-100"
  ),
  smallBlue: $(
    "h-[1.71428rem] px-[.57143rem] py-[.28571rem]",
    "typo-mshop-kr-14-m rounded-[.28571rem] bg-mshop-blue-10 text-mshop-blue-100 backdrop-blur-[5px]"
  ),
  green: $(
    "h-[1.71428rem] px-[.57143rem] py-[.28571rem]",
    "typo-mshop-kr-14-m rounded-[.28571rem] bg-mshop-green-10 text-mshop-green-100 backdrop-blur-[5px]"
  ),
  brown: $(
    "h-[1.71428rem] px-[.57143rem] py-[.28571rem]",
    "typo-mshop-kr-14-m rounded-[.28571rem] bg-mshop-brown-10 text-mshop-brown-100 backdrop-blur-[5px]"
  ),
  red: $(
    "h-[1.71428rem] px-[.57143rem] py-[.28571rem]",
    "typo-mshop-kr-14-m rounded-[.28571rem] bg-mshop-red-10 text-mshop-red-80 backdrop-blur-[5px]"
  ),
  smallBlack: $(
    "h-[1.71428rem] px-[.57143rem] py-[.28571rem]",
    "typo-mshop-kr-14-m rounded-[.28571rem] bg-mshop-gray-5 text-mshop-gray-80 backdrop-blur-[5px]"
  )
};
function fCe({ variant: e, children: t }) {
  return /* @__PURE__ */ a.jsx(
    "span",
    {
      className: $(
        "inline-flex shrink-0 items-center justify-center",
        dCe[e]
      ),
      children: t
    }
  );
}
function mCe({ variant: e, children: t }) {
  return /* @__PURE__ */ a.jsx(
    "span",
    {
      className: $("inline-flex shrink-0 items-center justify-center", {
        "typo-mshop-kr-12-m rounded-[0.28571rem] bg-mshop-blue-10 px-[0.28571rem] py-[0.10714rem] text-mshop-blue-100 backdrop-blur-[5px]": e === "smallBlue",
        "typo-mshop-kr-12-m rounded-[0.28571rem] bg-mshop-gray-5 px-[0.28571rem] py-[0.10714rem] text-mshop-gray-80 backdrop-blur-[5px]": e === "smallBlack",
        "typo-mshop-kr-12-m rounded-[0.28571rem] bg-mshop-green-10 px-[0.28571rem] py-[0.10714rem] text-mshop-green-100 backdrop-blur-[5px]": e === "green",
        "typo-mshop-kr-12-m rounded-[0.28571rem] bg-mshop-brown-10 px-[0.28571rem] py-[0.10714rem] text-mshop-brown-100 backdrop-blur-[5px]": e === "brown",
        "typo-mshop-kr-12-m rounded-[0.28571rem] bg-mshop-red-10 px-[0.28571rem] py-[0.10714rem] text-mshop-red-80 backdrop-blur-[5px]": e === "red"
      }),
      children: t
    }
  );
}
function NH({
  onContactButtonClick: e
}) {
  const { mypageMembershipSubscriptionsMembershipDetail: t } = nx(), {
    widgetCore: { isMobile: n }
  } = Gt(), r = n ? mCe : fCe;
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      id: "my-page-membership-detail-title",
      className: $(
        "flex gap-[1.143rem]",
        n ? "border-t border-mshop-gray-10 pt-[2.28571rem]" : "justify-between"
      ),
      children: [
        n && /* @__PURE__ */ a.jsx("div", { className: "isolate size-[7.14286rem] shrink-0 overflow-hidden rounded-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
          aa,
          {
            src: t.membershipCard.thumbnailImage.url,
            width: "7.1429rem",
            height: "7.1429rem",
            objectFit: "cover"
          }
        ) }),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("flex flex-col items-start gap-[0.286rem]", {
              "justify-center": n
            }),
            children: [
              t.payment.type === $n.SubscriptionPass && !t.isActive && /* @__PURE__ */ a.jsx(a.Fragment, { children: t.status === "EXPIRED" ? /* @__PURE__ */ a.jsx(r, { variant: "smallBlack", children: "만료" }) : /* @__PURE__ */ a.jsx(r, { variant: "red", children: `${jt(t.expiredAt, "yyyy. MM. dd")} ${t.cancelledAt === null ? "삭제" : "해지"} 예정` }) }),
              // https://ciety.xyz/@ciety-work/channels/1286?channelType=CHAT&highlightId=29243
              t.payment.type === $n.ShortTermPass && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                t.status === "JOINED" && /* @__PURE__ */ a.jsxs(r, { variant: "smallBlue", children: [
                  /* @__PURE__ */ a.jsx("span", { children: jt(t.payment.endTimeAt, "yyyy. MM. dd") }),
                  /* @__PURE__ */ a.jsx("span", { className: "ml-[0.14286rem]", children: "까지 이용가능" })
                ] }),
                t.status === "EXPIRED" && /* @__PURE__ */ a.jsx(r, { variant: "smallBlack", children: "만료" })
              ] }),
              /* @__PURE__ */ a.jsx(
                "h2",
                {
                  className: $(
                    n ? "typo-mshop-kr-14-b" : "typo-mshop-kr-24-b",
                    {
                      "text-mshop-gray-50": t.status === "EXPIRED"
                    }
                  ),
                  children: t.displayName
                }
              ),
              /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: [
                t.payment.type === $n.SubscriptionPass && "정기 구독 멤버십",
                t.payment.type === $n.ShortTermPass && "기간 한정 멤버십"
              ] }),
              /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.286rem]", children: [
                /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        n ? "typo-mshop-en-14-unica-b" : "typo-mshop-en-16-unica-m",
                        {
                          "text-mshop-gray-50": t.status === "EXPIRED"
                        }
                      ),
                      children: t.payment.price.toLocaleString(cr.Ko)
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        n ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                        {
                          "text-mshop-gray-50": t.status === "EXPIRED"
                        }
                      ),
                      children: zs(t.payment.currency)
                    }
                  )
                ] }),
                /* @__PURE__ */ a.jsxs(
                  "span",
                  {
                    className: $(
                      n ? "typo-mshop-kr-12-r" : "typo-mshop-kr-12-m",
                      {
                        "text-mshop-gray-50": t.status === "EXPIRED"
                      }
                    ),
                    children: [
                      t.payment.type === $n.SubscriptionPass && "/ 월간",
                      t.payment.type === $n.ShortTermPass && "/ 단건 결제"
                    ]
                  }
                )
              ] })
            ]
          }
        ),
        !n && /* @__PURE__ */ a.jsx("div", { className: "w-[10rem]", children: /* @__PURE__ */ a.jsx(
          fn,
          {
            variant: "sm",
            theme: "line",
            widthFull: !0,
            type: "button",
            onClick: e,
            children: "멤버십 문의하기"
          }
        ) })
      ]
    }
  );
}
function hCe(e) {
  var u, m;
  Al([
    [ol, e.client],
    [ll, e.widgetCore],
    [Aq, e.membershipId],
    [
      I3,
      e.mypageSubscriptionsMembershipDetail
    ]
  ]);
  const [t, n] = Re(!1), { mypageMembershipSubscriptionsMembershipDetail: r } = nx(), {
    widgetCore: { isMobile: s }
  } = Gt(), o = o_(r.rewards), c = () => {
    r.shop && e.onShopButtonClick(r.shop.url);
  };
  return s ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs("div", { className: "twp flex flex-col gap-[3.42857rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[2.28571rem]", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[1.14286rem]", children: [
          /* @__PURE__ */ a.jsx("header", { className: "border-b border-mshop-black pb-[0.57143rem]", children: /* @__PURE__ */ a.jsxs(
            "button",
            {
              type: "button",
              onClick: c,
              className: "flex items-center gap-[0.28571rem]",
              children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b line-clamp-1 text-start text-mshop-black", children: Ef(r.shop) }),
                /* @__PURE__ */ a.jsx(ch, { className: "size-[1.42857rem] text-mshop-black" })
              ]
            }
          ) }),
          /* @__PURE__ */ a.jsx(
            vH,
            {
              onContactButtonClick: () => e.onContactButtonClick(r.projectId),
              onMembershipCardDownloadButtonClick: e.onMembershipCardDownloadButtonClick,
              onShopButtonClick: c
            }
          )
        ] }),
        /* @__PURE__ */ a.jsx(
          NH,
          {
            onContactButtonClick: () => e.onContactButtonClick(r.projectId)
          }
        )
      ] }),
      o.productRewards && /* @__PURE__ */ a.jsx(
        wH,
        {
          productRewards: o.productRewards,
          onMembershipProductsButtonClick: () => e.onMembershipProductsButtonClick(r.projectId)
        }
      ),
      o.communityRewards && /* @__PURE__ */ a.jsx(
        gH,
        {
          communityRewards: o.communityRewards
        }
      ),
      o.creatorRewards && /* @__PURE__ */ a.jsx(
        yH,
        {
          creatorRewards: o.creatorRewards
        }
      ),
      r.payment.type === $n.SubscriptionPass && r.isActive && r.payMethod && /* @__PURE__ */ a.jsx(
        SH,
        {
          onClickPersonalInfoOutsourcing: e.onClickPersonalInfoOutsourcing,
          onClickThirdPartyConsent: e.onClickThirdPartyConsent,
          onClickInicisTerms: e.onClickInicisTerms
        }
      ),
      r.payment.type === $n.ShortTermPass && /* @__PURE__ */ a.jsx(bH, {}),
      r.payment.type === $n.SubscriptionPass && /* @__PURE__ */ a.jsx(xH, {}),
      r.payment.type === $n.ShortTermPass && ((u = r.paymentStatements.at(-1)) == null ? void 0 : u.paymentState) === "CANCELLED" && /* @__PURE__ */ a.jsx(CH, {}),
      r.payment.type === $n.SubscriptionPass && r.isActive && /* @__PURE__ */ a.jsx(
        "button",
        {
          type: "button",
          className: "typo-mshop-kr-14-b self-start text-mshop-gray-50 underline",
          onClick: () => n(!0),
          children: "멤버십 해지하기"
        }
      ),
      r.payment.type === $n.ShortTermPass && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "결제일로부터 7일 이내, 혜택 미이용 시에만 환불이 가능합니다." })
    ] }),
    /* @__PURE__ */ a.jsx(
      pH,
      {
        show: t,
        onClose: () => n(!1),
        onShopButtonClick: c
      }
    )
  ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs("div", { className: "twp flex flex-col gap-[1.714rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[3.429rem]", children: [
        /* @__PURE__ */ a.jsx(
          vH,
          {
            onMembershipCardDownloadButtonClick: e.onMembershipCardDownloadButtonClick,
            onShopButtonClick: c
          }
        ),
        /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col gap-[3.429rem]", children: [
          /* @__PURE__ */ a.jsx(
            NH,
            {
              onContactButtonClick: () => e.onContactButtonClick(r.projectId)
            }
          ),
          o.productRewards && /* @__PURE__ */ a.jsx(
            wH,
            {
              productRewards: o.productRewards,
              onMembershipProductsButtonClick: () => e.onMembershipProductsButtonClick(r.projectId)
            }
          ),
          o.communityRewards && /* @__PURE__ */ a.jsx(
            gH,
            {
              communityRewards: o.communityRewards
            }
          ),
          o.creatorRewards && /* @__PURE__ */ a.jsx(
            yH,
            {
              creatorRewards: o.creatorRewards
            }
          ),
          r.payment.type === $n.SubscriptionPass && r.isActive && r.payMethod && /* @__PURE__ */ a.jsx(
            SH,
            {
              onClickPersonalInfoOutsourcing: e.onClickPersonalInfoOutsourcing,
              onClickThirdPartyConsent: e.onClickThirdPartyConsent,
              onClickInicisTerms: e.onClickInicisTerms
            }
          ),
          r.payment.type === $n.ShortTermPass && /* @__PURE__ */ a.jsx(bH, {}),
          r.payment.type === $n.SubscriptionPass && /* @__PURE__ */ a.jsx(xH, {}),
          r.payment.type === $n.ShortTermPass && ((m = r.paymentStatements.at(-1)) == null ? void 0 : m.paymentState) === "CANCELLED" && /* @__PURE__ */ a.jsx(CH, {})
        ] })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center gap-[1.714rem]", children: [
        /* @__PURE__ */ a.jsx("div", { className: "w-[15.071rem]", children: /* @__PURE__ */ a.jsx(
          fn,
          {
            variant: "md",
            theme: "blue",
            widthFull: !0,
            type: "button",
            onClick: e.onGoBackToMembershipSupportListButtonClick,
            children: "멤버십 내역으로 돌아가기"
          }
        ) }),
        r.payment.type === $n.SubscriptionPass && r.isActive && /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: "typo-mshop-kr-14-b text-mshop-gray-50 underline",
            onClick: () => n(!0),
            children: "멤버십 해지하기"
          }
        ),
        r.payment.type === $n.ShortTermPass && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "결제일로부터 7일 이내, 혜택 미이용 시에만 환불이 가능합니다." })
      ] })
    ] }),
    t && /* @__PURE__ */ a.jsx(
      pH,
      {
        onClose: () => n(!1),
        onShopButtonClick: c
      }
    )
  ] });
}
function pCe({
  client: e,
  isMobile: t,
  isApp: n,
  membershipId: r,
  toggleSpinner: s,
  onMembershipProductsButtonClick: o,
  onGoBackToMembershipSupportListButtonClick: c,
  onContactButtonClick: u,
  onClickPersonalInfoOutsourcing: m,
  onClickThirdPartyConsent: y,
  onClickInicisTerms: b,
  onError: w,
  onMembershipCardDownloadButtonClick: k,
  onScrollLock: j,
  onShopButtonClick: E
}) {
  const [T, D] = Re(!0), [L, I] = Re(null);
  return an(() => {
    (async () => {
      const R = await Oq(
        {
          membershipId: r
        },
        {
          client: e,
          onError: w
        }
      );
      if (R.code === le.TokenExpired)
        return w(Ht);
      I({
        mypageSubscriptionsMembershipDetail: R.data
      }), D(!1);
    })();
  }, []), T || L === null ? null : /* @__PURE__ */ a.jsx(
    hCe,
    {
      client: e,
      widgetCore: {
        isMobile: t,
        isApp: n,
        toggleSpinner: s,
        onError: w,
        onScrollLock: j
      },
      membershipId: r,
      mypageSubscriptionsMembershipDetail: L.mypageSubscriptionsMembershipDetail,
      onMembershipProductsButtonClick: o,
      onGoBackToMembershipSupportListButtonClick: c,
      onContactButtonClick: u,
      onClickPersonalInfoOutsourcing: m,
      onClickThirdPartyConsent: y,
      onClickInicisTerms: b,
      onMembershipCardDownloadButtonClick: k,
      onShopButtonClick: E
    }
  );
}
class $je extends Ol {
  constructor({
    client: t,
    isMobile: n,
    isApp: r,
    membershipId: s,
    toggleSpinner: o,
    onMembershipProductsButtonClick: c,
    onGoBackToMembershipSupportListButtonClick: u,
    onContactButtonClick: m,
    onError: y,
    onClickPersonalInfoOutsourcing: b,
    onClickThirdPartyConsent: w,
    onClickInicisTerms: k,
    onMembershipCardDownloadButtonClick: j,
    onScrollLock: E,
    onShopButtonClick: T
  }) {
    super({
      client: t,
      isMobile: n,
      isApp: r,
      toggleSpinner: o,
      onError: y,
      onScrollLock: E
    }), this.render = (D) => {
      go(D).render(
        /* @__PURE__ */ a.jsx(
          pCe,
          {
            client: this.client,
            isApp: this.isApp,
            isMobile: this.isMobile,
            membershipId: this.membershipId,
            toggleSpinner: this.toggleSpinner,
            onError: this.onError,
            onMembershipProductsButtonClick: this.onMembershipProductsButtonClick,
            onGoBackToMembershipSupportListButtonClick: this.onGoBackToMembershipSupportListButtonClick,
            onContactButtonClick: this.onContactButtonClick,
            onClickInicisTerms: this.onClickInicisTerms,
            onClickPersonalInfoOutsourcing: this.onClickPersonalInfoOutsourcing,
            onClickThirdPartyConsent: this.onClickThirdPartyConsent,
            onMembershipCardDownloadButtonClick: this.onMembershipCardDownloadButtonClick,
            onScrollLock: this.onScrollLock,
            onShopButtonClick: this.onShopButtonClick
          }
        )
      );
    }, this.membershipId = s, this.onMembershipProductsButtonClick = c, this.onGoBackToMembershipSupportListButtonClick = u, this.onContactButtonClick = m, this.onClickPersonalInfoOutsourcing = b, this.onClickThirdPartyConsent = w, this.onClickInicisTerms = k, this.onMembershipCardDownloadButtonClick = j, this.onShopButtonClick = T;
  }
}
const gCe = (e, t) => jn(
  "/project-dao",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), Lq = (e, t) => jn(
  "/management-membership-users",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), Iq = Qt(Vn), Fq = Qt(Vn), yCe = () => {
  const [e, t] = Ar(Fq);
  if (e === Vn)
    throw new Error(Xr(ia.ProjectDao));
  return {
    projectDao: e,
    setProjectDao: t,
    hasConnectedCommunity: e !== null
  };
}, vCe = (e, t) => jn(
  "/management-commission-user-statements",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), dP = (e, t) => jn(
  "/management-dao-user",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), y8 = (e, t) => jn(
  "/management-membership-user",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), xCe = (e, t) => jn(
  "/management-membership-user-statements",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), bCe = (e, t) => jn(
  "/management-membership-product-user-statements",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), SCe = (e, t) => jn(
  "/management-support-user",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
      return {
        ...n,
        data: {
          ...n.data,
          items: n.data.items.map((r) => ({
            ...r,
            state: r.state,
            paymentState: r.paymentState
          }))
        }
      };
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), wCe = (e, t) => jn(
  "/management-user-note",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), ws = {
  Asc: "asc",
  Desc: "desc"
}, CCe = Qt(null), Uq = () => {
  const [e, t] = Ar(
    CCe
  );
  return {
    commissionPayment: e,
    setCommissionPayment: t
  };
}, zq = Qt(null), BA = () => {
  const [e, t] = Ar(
    zq
  );
  return {
    managementDaoUser: e,
    setManagementDaoUser: t
  };
}, NCe = Qt(
  null
), Bq = () => {
  const [e, t] = Ar(
    NCe
  );
  return {
    managementSupportUser: e,
    setManagementSupportUser: t
  };
}, jCe = Qt(null), HA = () => {
  const [e, t] = Ar(jCe);
  return {
    managementUser: e,
    setManagementUser: t
  };
}, fP = Qt(null), ECe = Qt(
  null,
  (e, t, n) => {
    const r = e(fP);
    if (r == null)
      return null;
    t(fP, {
      ...r,
      selectedTabIndex: n.selectedTabIndex
    });
  }
), N5 = () => {
  const [e, t] = Ar(
    fP
  ), n = Ka(ECe);
  return {
    membershipUserDetail: e,
    setMembershipUserDetail: t,
    setSelectedTabIndex: n
  };
}, kCe = Qt(
  null
), Hq = () => {
  const [e, t] = Ar(
    kCe
  );
  return {
    membershipUserStatements: e,
    setMembershipUserStatements: t
  };
}, _Ce = Qt(null), Vq = () => {
  const [e, t] = Ar(
    _Ce
  );
  return {
    productPurchase: e,
    setProductPurchase: t
  };
}, F3 = Qt(null), TCe = Qt(
  null,
  (e, t, n) => {
    const r = e(F3);
    r && t(F3, { ...r, ...n });
  }
), MCe = Qt(
  null,
  (e, t, n) => {
    const r = e(F3);
    r && t(F3, { ...r, ...n });
  }
), mP = () => {
  const [e, t] = Ar(F3), n = Ka(TCe), r = Ka(MCe), s = dn(() => e ? e.note !== e.copiedNote : !1, [e]);
  return {
    userNote: e,
    setUserNote: t,
    setNote: n,
    setCopiedNote: r,
    isDirtyUserNote: s,
    checkUnSavedUserNote: async () => {
      if (s && e)
        return await ho({
          body: (u, m) => /* @__PURE__ */ a.jsx(
            qu,
            {
              confirmButton: {
                props: u
              },
              cancelButton: {
                props: m
              },
              children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.86rem] text-mshop-black", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: "저장되지 않은 변경 사항" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "변경된 내용이 저장되지 않았습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "저장하지 않고 내용을 삭제할까요?"
                ] })
              ] })
            }
          )
        }) ? (r({ copiedNote: e.note }), !1) : !0;
    }
  };
};
function $q({ variant: e, children: t }) {
  return /* @__PURE__ */ a.jsx(
    "span",
    {
      className: $(
        "typo-mshop-kr-14-m inline-flex h-[1.714rem] flex-shrink-0 items-center justify-center truncate rounded px-[0.571rem] backdrop-blur-[5px]",
        { "bg-mshop-black text-mshop-white": e === "black" },
        { "bg-mshop-gray-5 text-mshop-gray-80": e === "gray" }
      ),
      children: t
    }
  );
}
function RCe() {
  const { managementUser: e } = HA(), {
    widgetCore: { isMobile: t }
  } = Gt();
  return e == null ? null : /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $("flex items-start gap-x-[0.85714rem]", {
        "px-[1.14285rem]": t
      }),
      children: [
        /* @__PURE__ */ a.jsx("div", { className: "w-[5.71429rem]", children: /* @__PURE__ */ a.jsx(Ql, { imageUrl: Xu(e) }) }),
        /* @__PURE__ */ a.jsxs("div", { className: "w-[calc(100%-5.71429rem)]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-b", children: Mc(e) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m block w-full truncate text-mshop-gray-50", children: e.email }),
          e.memberships.length > 0 && /* @__PURE__ */ a.jsx("div", { className: "mt-[0.57142rem] flex flex-wrap items-center gap-[0.28571rem]", children: e.memberships.map((n) => /* @__PURE__ */ a.jsx($q, { variant: "black", children: t ? /* @__PURE__ */ a.jsx("span", { className: "max-w-[16.78571rem] truncate", children: n.displayName }) : n.displayName }, n.id)) })
        ] })
      ]
    }
  );
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function wp() {
  return {
    accessor: (e, t) => typeof e == "function" ? {
      ...t,
      accessorFn: e
    } : {
      ...t,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function D2(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function vp(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: D2(n, r[e])
    }));
  };
}
function u_(e) {
  return e instanceof Function;
}
function DCe(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function PCe(e, t) {
  const n = [], r = (s) => {
    s.forEach((o) => {
      n.push(o);
      const c = t(o);
      c != null && c.length && r(c);
    });
  };
  return r(e), n;
}
function Br(e, t, n) {
  let r = [], s;
  return (o) => {
    let c;
    n.key && n.debug && (c = Date.now());
    const u = e(o);
    if (!(u.length !== r.length || u.some((b, w) => r[w] !== b)))
      return s;
    r = u;
    let y;
    if (n.key && n.debug && (y = Date.now()), s = t(...u), n == null || n.onChange == null || n.onChange(s), n.key && n.debug && n != null && n.debug()) {
      const b = Math.round((Date.now() - c) * 100) / 100, w = Math.round((Date.now() - y) * 100) / 100, k = w / 16, j = (E, T) => {
        for (E = String(E); E.length < T; )
          E = " " + E;
        return E;
      };
      console.info(`%c⏱ ${j(w, 5)} /${j(b, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * k, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return s;
  };
}
function Hr(e, t, n, r) {
  return {
    debug: () => {
      var s;
      return (s = e == null ? void 0 : e.debugAll) != null ? s : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function OCe(e, t, n, r) {
  const s = () => {
    var c;
    return (c = o.getValue()) != null ? c : e.options.renderFallbackValue;
  }, o = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: s,
    getContext: Br(() => [e, n, t, o], (c, u, m, y) => ({
      table: c,
      column: u,
      row: m,
      cell: y,
      getValue: y.getValue,
      renderValue: y.renderValue
    }), Hr(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((c) => {
    c.createCell == null || c.createCell(o, n, t, e);
  }, {}), o;
}
function ACe(e, t, n, r) {
  var s, o;
  const u = {
    ...e._getDefaultColumnDef(),
    ...t
  }, m = u.accessorKey;
  let y = (s = (o = u.id) != null ? o : m ? typeof String.prototype.replaceAll == "function" ? m.replaceAll(".", "_") : m.replace(/\./g, "_") : void 0) != null ? s : typeof u.header == "string" ? u.header : void 0, b;
  if (u.accessorFn ? b = u.accessorFn : m && (m.includes(".") ? b = (k) => {
    let j = k;
    for (const T of m.split(".")) {
      var E;
      j = (E = j) == null ? void 0 : E[T], process.env.NODE_ENV !== "production" && j === void 0 && console.warn(`"${T}" in deeply nested key "${m}" returned undefined.`);
    }
    return j;
  } : b = (k) => k[u.accessorKey]), !y)
    throw process.env.NODE_ENV !== "production" ? new Error(u.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let w = {
    id: `${String(y)}`,
    accessorFn: b,
    parent: r,
    depth: n,
    columnDef: u,
    columns: [],
    getFlatColumns: Br(() => [!0], () => {
      var k;
      return [w, ...(k = w.columns) == null ? void 0 : k.flatMap((j) => j.getFlatColumns())];
    }, Hr(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: Br(() => [e._getOrderColumnsFn()], (k) => {
      var j;
      if ((j = w.columns) != null && j.length) {
        let E = w.columns.flatMap((T) => T.getLeafColumns());
        return k(E);
      }
      return [w];
    }, Hr(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const k of e._features)
    k.createColumn == null || k.createColumn(w, e);
  return w;
}
const bf = "debugHeaders";
function jH(e, t, n) {
  var r;
  let o = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const c = [], u = (m) => {
        m.subHeaders && m.subHeaders.length && m.subHeaders.map(u), c.push(m);
      };
      return u(o), c;
    },
    getContext: () => ({
      table: e,
      header: o,
      column: t
    })
  };
  return e._features.forEach((c) => {
    c.createHeader == null || c.createHeader(o, e);
  }), o;
}
const LCe = {
  createTable: (e) => {
    e.getHeaderGroups = Br(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, s) => {
      var o, c;
      const u = (o = r == null ? void 0 : r.map((w) => n.find((k) => k.id === w)).filter(Boolean)) != null ? o : [], m = (c = s == null ? void 0 : s.map((w) => n.find((k) => k.id === w)).filter(Boolean)) != null ? c : [], y = n.filter((w) => !(r != null && r.includes(w.id)) && !(s != null && s.includes(w.id)));
      return Vj(t, [...u, ...y, ...m], e);
    }, Hr(e.options, bf, "getHeaderGroups")), e.getCenterHeaderGroups = Br(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, s) => (n = n.filter((o) => !(r != null && r.includes(o.id)) && !(s != null && s.includes(o.id))), Vj(t, n, e, "center")), Hr(e.options, bf, "getCenterHeaderGroups")), e.getLeftHeaderGroups = Br(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var s;
      const o = (s = r == null ? void 0 : r.map((c) => n.find((u) => u.id === c)).filter(Boolean)) != null ? s : [];
      return Vj(t, o, e, "left");
    }, Hr(e.options, bf, "getLeftHeaderGroups")), e.getRightHeaderGroups = Br(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var s;
      const o = (s = r == null ? void 0 : r.map((c) => n.find((u) => u.id === c)).filter(Boolean)) != null ? s : [];
      return Vj(t, o, e, "right");
    }, Hr(e.options, bf, "getRightHeaderGroups")), e.getFooterGroups = Br(() => [e.getHeaderGroups()], (t) => [...t].reverse(), Hr(e.options, bf, "getFooterGroups")), e.getLeftFooterGroups = Br(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), Hr(e.options, bf, "getLeftFooterGroups")), e.getCenterFooterGroups = Br(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), Hr(e.options, bf, "getCenterFooterGroups")), e.getRightFooterGroups = Br(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), Hr(e.options, bf, "getRightFooterGroups")), e.getFlatHeaders = Br(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Hr(e.options, bf, "getFlatHeaders")), e.getLeftFlatHeaders = Br(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Hr(e.options, bf, "getLeftFlatHeaders")), e.getCenterFlatHeaders = Br(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Hr(e.options, bf, "getCenterFlatHeaders")), e.getRightFlatHeaders = Br(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Hr(e.options, bf, "getRightFlatHeaders")), e.getCenterLeafHeaders = Br(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Hr(e.options, bf, "getCenterLeafHeaders")), e.getLeftLeafHeaders = Br(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Hr(e.options, bf, "getLeftLeafHeaders")), e.getRightLeafHeaders = Br(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Hr(e.options, bf, "getRightLeafHeaders")), e.getLeafHeaders = Br(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var s, o, c, u, m, y;
      return [...(s = (o = t[0]) == null ? void 0 : o.headers) != null ? s : [], ...(c = (u = n[0]) == null ? void 0 : u.headers) != null ? c : [], ...(m = (y = r[0]) == null ? void 0 : y.headers) != null ? m : []].map((b) => b.getLeafHeaders()).flat();
    }, Hr(e.options, bf, "getLeafHeaders"));
  }
};
function Vj(e, t, n, r) {
  var s, o;
  let c = 0;
  const u = function(k, j) {
    j === void 0 && (j = 1), c = Math.max(c, j), k.filter((E) => E.getIsVisible()).forEach((E) => {
      var T;
      (T = E.columns) != null && T.length && u(E.columns, j + 1);
    }, 0);
  };
  u(e);
  let m = [];
  const y = (k, j) => {
    const E = {
      depth: j,
      id: [r, `${j}`].filter(Boolean).join("_"),
      headers: []
    }, T = [];
    k.forEach((D) => {
      const L = [...T].reverse()[0], I = D.column.depth === E.depth;
      let R, U = !1;
      if (I && D.column.parent ? R = D.column.parent : (R = D.column, U = !0), L && (L == null ? void 0 : L.column) === R)
        L.subHeaders.push(D);
      else {
        const z = jH(n, R, {
          id: [r, j, R.id, D == null ? void 0 : D.id].filter(Boolean).join("_"),
          isPlaceholder: U,
          placeholderId: U ? `${T.filter((H) => H.column === R).length}` : void 0,
          depth: j,
          index: T.length
        });
        z.subHeaders.push(D), T.push(z);
      }
      E.headers.push(D), D.headerGroup = E;
    }), m.push(E), j > 0 && y(T, j - 1);
  }, b = t.map((k, j) => jH(n, k, {
    depth: c,
    index: j
  }));
  y(b, c - 1), m.reverse();
  const w = (k) => k.filter((E) => E.column.getIsVisible()).map((E) => {
    let T = 0, D = 0, L = [0];
    E.subHeaders && E.subHeaders.length ? (L = [], w(E.subHeaders).forEach((R) => {
      let {
        colSpan: U,
        rowSpan: z
      } = R;
      T += U, L.push(z);
    })) : T = 1;
    const I = Math.min(...L);
    return D = D + I, E.colSpan = T, E.rowSpan = D, {
      colSpan: T,
      rowSpan: D
    };
  });
  return w((s = (o = m[0]) == null ? void 0 : o.headers) != null ? s : []), m;
}
const ICe = (e, t, n, r, s, o, c) => {
  let u = {
    id: t,
    index: r,
    original: n,
    depth: s,
    parentId: c,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (m) => {
      if (u._valuesCache.hasOwnProperty(m))
        return u._valuesCache[m];
      const y = e.getColumn(m);
      if (y != null && y.accessorFn)
        return u._valuesCache[m] = y.accessorFn(u.original, r), u._valuesCache[m];
    },
    getUniqueValues: (m) => {
      if (u._uniqueValuesCache.hasOwnProperty(m))
        return u._uniqueValuesCache[m];
      const y = e.getColumn(m);
      if (y != null && y.accessorFn)
        return y.columnDef.getUniqueValues ? (u._uniqueValuesCache[m] = y.columnDef.getUniqueValues(u.original, r), u._uniqueValuesCache[m]) : (u._uniqueValuesCache[m] = [u.getValue(m)], u._uniqueValuesCache[m]);
    },
    renderValue: (m) => {
      var y;
      return (y = u.getValue(m)) != null ? y : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => PCe(u.subRows, (m) => m.subRows),
    getParentRow: () => u.parentId ? e.getRow(u.parentId, !0) : void 0,
    getParentRows: () => {
      let m = [], y = u;
      for (; ; ) {
        const b = y.getParentRow();
        if (!b) break;
        m.push(b), y = b;
      }
      return m.reverse();
    },
    getAllCells: Br(() => [e.getAllLeafColumns()], (m) => m.map((y) => OCe(e, u, y, y.id)), Hr(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: Br(() => [u.getAllCells()], (m) => m.reduce((y, b) => (y[b.column.id] = b, y), {}), Hr(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let m = 0; m < e._features.length; m++) {
    const y = e._features[m];
    y == null || y.createRow == null || y.createRow(u, e);
  }
  return u;
}, FCe = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Gq = (e, t, n) => {
  var r, s;
  const o = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((s = e.getValue(t)) == null || (s = s.toString()) == null || (s = s.toLowerCase()) == null) && s.includes(o));
};
Gq.autoRemove = (e) => Xg(e);
const Wq = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
Wq.autoRemove = (e) => Xg(e);
const Yq = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
Yq.autoRemove = (e) => Xg(e);
const qq = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
qq.autoRemove = (e) => Xg(e) || !(e != null && e.length);
const Kq = (e, t, n) => !n.some((r) => {
  var s;
  return !((s = e.getValue(t)) != null && s.includes(r));
});
Kq.autoRemove = (e) => Xg(e) || !(e != null && e.length);
const Xq = (e, t, n) => n.some((r) => {
  var s;
  return (s = e.getValue(t)) == null ? void 0 : s.includes(r);
});
Xq.autoRemove = (e) => Xg(e) || !(e != null && e.length);
const Qq = (e, t, n) => e.getValue(t) === n;
Qq.autoRemove = (e) => Xg(e);
const Zq = (e, t, n) => e.getValue(t) == n;
Zq.autoRemove = (e) => Xg(e);
const VA = (e, t, n) => {
  let [r, s] = n;
  const o = e.getValue(t);
  return o >= r && o <= s;
};
VA.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, s = typeof n != "number" ? parseFloat(n) : n, o = t === null || Number.isNaN(r) ? -1 / 0 : r, c = n === null || Number.isNaN(s) ? 1 / 0 : s;
  if (o > c) {
    const u = o;
    o = c, c = u;
  }
  return [o, c];
};
VA.autoRemove = (e) => Xg(e) || Xg(e[0]) && Xg(e[1]);
const _v = {
  includesString: Gq,
  includesStringSensitive: Wq,
  equalsString: Yq,
  arrIncludes: qq,
  arrIncludesAll: Kq,
  arrIncludesSome: Xq,
  equals: Qq,
  weakEquals: Zq,
  inNumberRange: VA
};
function Xg(e) {
  return e == null || e === "";
}
const UCe = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: vp("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? _v.includesString : typeof r == "number" ? _v.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? _v.equals : Array.isArray(r) ? _v.arrIncludes : _v.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return u_(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : _v[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, s;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((s = t.options.enableFilters) != null ? s : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((s) => s.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const s = e.getFilterFn(), o = r == null ? void 0 : r.find((b) => b.id === e.id), c = D2(n, o ? o.value : void 0);
        if (EH(s, c, e)) {
          var u;
          return (u = r == null ? void 0 : r.filter((b) => b.id !== e.id)) != null ? u : [];
        }
        const m = {
          id: e.id,
          value: c
        };
        if (o) {
          var y;
          return (y = r == null ? void 0 : r.map((b) => b.id === e.id ? m : b)) != null ? y : [];
        }
        return r != null && r.length ? [...r, m] : [m];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (s) => {
        var o;
        return (o = D2(t, s)) == null ? void 0 : o.filter((c) => {
          const u = n.find((m) => m.id === c.id);
          if (u) {
            const m = u.getFilterFn();
            if (EH(m, c.value, u))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function EH(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const zCe = (e, t, n) => n.reduce((r, s) => {
  const o = s.getValue(e);
  return r + (typeof o == "number" ? o : 0);
}, 0), BCe = (e, t, n) => {
  let r;
  return n.forEach((s) => {
    const o = s.getValue(e);
    o != null && (r > o || r === void 0 && o >= o) && (r = o);
  }), r;
}, HCe = (e, t, n) => {
  let r;
  return n.forEach((s) => {
    const o = s.getValue(e);
    o != null && (r < o || r === void 0 && o >= o) && (r = o);
  }), r;
}, VCe = (e, t, n) => {
  let r, s;
  return n.forEach((o) => {
    const c = o.getValue(e);
    c != null && (r === void 0 ? c >= c && (r = s = c) : (r > c && (r = c), s < c && (s = c)));
  }), [r, s];
}, $Ce = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((s) => {
    let o = s.getValue(e);
    o != null && (o = +o) >= o && (++n, r += o);
  }), n) return r / n;
}, GCe = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((o) => o.getValue(e));
  if (!DCe(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), s = n.sort((o, c) => o - c);
  return n.length % 2 !== 0 ? s[r] : (s[r - 1] + s[r]) / 2;
}, WCe = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), YCe = (e, t) => new Set(t.map((n) => n.getValue(e))).size, qCe = (e, t) => t.length, FR = {
  sum: zCe,
  min: BCe,
  max: HCe,
  extent: VCe,
  mean: $Ce,
  median: GCe,
  unique: WCe,
  uniqueCount: YCe,
  count: qCe
}, KCe = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: vp("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return FR.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return FR.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return u_(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : FR[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var s;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((s = n.subRows) != null && s.length);
    };
  }
};
function XCe(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((o) => !t.includes(o.id));
  return n === "remove" ? r : [...t.map((o) => e.find((c) => c.id === o)).filter(Boolean), ...r];
}
const QCe = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: vp("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = Br((n) => [y3(t, n)], (n) => n.findIndex((r) => r.id === e.id), Hr(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = y3(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const s = y3(t, n);
      return ((r = s[s.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = Br(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (s) => {
      let o = [];
      if (!(t != null && t.length))
        o = s;
      else {
        const c = [...t], u = [...s];
        for (; u.length && c.length; ) {
          const m = c.shift(), y = u.findIndex((b) => b.id === m);
          y > -1 && o.push(u.splice(y, 1)[0]);
        }
        o = [...o, ...u];
      }
      return XCe(o, n, r);
    }, Hr(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, UR = () => ({
  left: [],
  right: []
}), ZCe = {
  getInitialState: (e) => ({
    columnPinning: UR(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: vp("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((s) => s.id).filter(Boolean);
      t.setColumnPinning((s) => {
        var o, c;
        if (n === "right") {
          var u, m;
          return {
            left: ((u = s == null ? void 0 : s.left) != null ? u : []).filter((w) => !(r != null && r.includes(w))),
            right: [...((m = s == null ? void 0 : s.right) != null ? m : []).filter((w) => !(r != null && r.includes(w))), ...r]
          };
        }
        if (n === "left") {
          var y, b;
          return {
            left: [...((y = s == null ? void 0 : s.left) != null ? y : []).filter((w) => !(r != null && r.includes(w))), ...r],
            right: ((b = s == null ? void 0 : s.right) != null ? b : []).filter((w) => !(r != null && r.includes(w)))
          };
        }
        return {
          left: ((o = s == null ? void 0 : s.left) != null ? o : []).filter((w) => !(r != null && r.includes(w))),
          right: ((c = s == null ? void 0 : s.right) != null ? c : []).filter((w) => !(r != null && r.includes(w)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var s, o, c;
      return ((s = r.columnDef.enablePinning) != null ? s : !0) && ((o = (c = t.options.enableColumnPinning) != null ? c : t.options.enablePinning) != null ? o : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((u) => u.id), {
        left: r,
        right: s
      } = t.getState().columnPinning, o = n.some((u) => r == null ? void 0 : r.includes(u)), c = n.some((u) => s == null ? void 0 : s.includes(u));
      return o ? "left" : c ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const s = e.getIsPinned();
      return s ? (n = (r = t.getState().columnPinning) == null || (r = r[s]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = Br(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, s) => {
      const o = [...r ?? [], ...s ?? []];
      return n.filter((c) => !o.includes(c.column.id));
    }, Hr(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = Br(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((o) => n.find((c) => c.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "left"
    })), Hr(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = Br(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((o) => n.find((c) => c.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "right"
    })), Hr(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? UR() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : UR());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var s, o;
        return !!((s = r.left) != null && s.length || (o = r.right) != null && o.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = Br(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((s) => s.id === r)).filter(Boolean), Hr(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = Br(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((s) => s.id === r)).filter(Boolean), Hr(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = Br(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const s = [...n ?? [], ...r ?? []];
      return t.filter((o) => !s.includes(o.id));
    }, Hr(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, $j = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, zR = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), JCe = {
  getDefaultColumnDef: () => $j,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: zR(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: vp("columnSizing", e),
    onColumnSizingInfoChange: vp("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, s;
      const o = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : $j.minSize, (r = o ?? e.columnDef.size) != null ? r : $j.size), (s = e.columnDef.maxSize) != null ? s : $j.maxSize);
    }, e.getStart = Br((n) => [n, y3(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((s, o) => s + o.getSize(), 0), Hr(t.options, "debugColumns", "getStart")), e.getAfter = Br((n) => [n, y3(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((s, o) => s + o.getSize(), 0), Hr(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...s
        } = n;
        return s;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (s) => {
        if (s.subHeaders.length)
          s.subHeaders.forEach(r);
        else {
          var o;
          n += (o = s.column.getSize()) != null ? o : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), s = r == null ? void 0 : r.getCanResize();
      return (o) => {
        if (!r || !s || (o.persist == null || o.persist(), BR(o) && o.touches && o.touches.length > 1))
          return;
        const c = e.getSize(), u = e ? e.getLeafHeaders().map((L) => [L.column.id, L.column.getSize()]) : [[r.id, r.getSize()]], m = BR(o) ? Math.round(o.touches[0].clientX) : o.clientX, y = {}, b = (L, I) => {
          typeof I == "number" && (t.setColumnSizingInfo((R) => {
            var U, z;
            const H = t.options.columnResizeDirection === "rtl" ? -1 : 1, K = (I - ((U = R == null ? void 0 : R.startOffset) != null ? U : 0)) * H, q = Math.max(K / ((z = R == null ? void 0 : R.startSize) != null ? z : 0), -0.999999);
            return R.columnSizingStart.forEach((Q) => {
              let [Z, X] = Q;
              y[Z] = Math.round(Math.max(X + X * q, 0) * 100) / 100;
            }), {
              ...R,
              deltaOffset: K,
              deltaPercentage: q
            };
          }), (t.options.columnResizeMode === "onChange" || L === "end") && t.setColumnSizing((R) => ({
            ...R,
            ...y
          })));
        }, w = (L) => b("move", L), k = (L) => {
          b("end", L), t.setColumnSizingInfo((I) => ({
            ...I,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, j = n || typeof document < "u" ? document : null, E = {
          moveHandler: (L) => w(L.clientX),
          upHandler: (L) => {
            j == null || j.removeEventListener("mousemove", E.moveHandler), j == null || j.removeEventListener("mouseup", E.upHandler), k(L.clientX);
          }
        }, T = {
          moveHandler: (L) => (L.cancelable && (L.preventDefault(), L.stopPropagation()), w(L.touches[0].clientX), !1),
          upHandler: (L) => {
            var I;
            j == null || j.removeEventListener("touchmove", T.moveHandler), j == null || j.removeEventListener("touchend", T.upHandler), L.cancelable && (L.preventDefault(), L.stopPropagation()), k((I = L.touches[0]) == null ? void 0 : I.clientX);
          }
        }, D = e7e() ? {
          passive: !1
        } : !1;
        BR(o) ? (j == null || j.addEventListener("touchmove", T.moveHandler, D), j == null || j.addEventListener("touchend", T.upHandler, D)) : (j == null || j.addEventListener("mousemove", E.moveHandler, D), j == null || j.addEventListener("mouseup", E.upHandler, D)), t.setColumnSizingInfo((L) => ({
          ...L,
          startOffset: m,
          startSize: c,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: u,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? zR() : (n = e.initialState.columnSizingInfo) != null ? n : zR());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, s) => r + s.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, s) => r + s.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, s) => r + s.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, s) => r + s.getSize(), 0)) != null ? t : 0;
    };
  }
};
let Gj = null;
function e7e() {
  if (typeof Gj == "boolean") return Gj;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return Gj = e, Gj;
}
function BR(e) {
  return e.type === "touchstart";
}
const t7e = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: vp("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const s = e.columns;
      return (n = s.length ? s.some((o) => o.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = Br(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), Hr(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = Br(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, s) => [...n, ...r, ...s], Hr(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => Br(() => [r(), r().filter((s) => s.getIsVisible()).map((s) => s.id).join("_")], (s) => s.filter((o) => o.getIsVisible == null ? void 0 : o.getIsVisible()), Hr(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((s, o) => ({
        ...s,
        [o.id]: n || !(o.getCanHide != null && o.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function y3(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const n7e = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, r7e = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: vp("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, s, o;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((s = t.options.enableFilters) != null ? s : !0) && ((o = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? o : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => _v.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return u_(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : _v[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, a7e = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: vp("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, s;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (s = e.options.autoResetAll) != null ? s : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var s, o;
      e.setExpanded(r ? {} : (s = (o = e.initialState) == null ? void 0 : o.expanded) != null ? s : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((s) => !s.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((o) => {
        const c = o.split(".");
        r = Math.max(r, c.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var s;
        const o = r === !0 ? !0 : !!(r != null && r[e.id]);
        let c = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((u) => {
          c[u] = !0;
        }) : c = r, n = (s = n) != null ? s : !o, !o && n)
          return {
            ...c,
            [e.id]: !0
          };
        if (o && !n) {
          const {
            [e.id]: u,
            ...m
          } = c;
          return m;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, s;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((s = e.subRows) != null && s.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, hP = 0, pP = 10, HR = () => ({
  pageIndex: hP,
  pageSize: pP
}), s7e = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...HR(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: vp("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, s;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (s = e.options.autoResetAll) != null ? s : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const s = (o) => D2(r, o);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(s);
    }, e.resetPagination = (r) => {
      var s;
      e.setPagination(r ? HR() : (s = e.initialState.pagination) != null ? s : HR());
    }, e.setPageIndex = (r) => {
      e.setPagination((s) => {
        let o = D2(r, s.pageIndex);
        const c = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return o = Math.max(0, Math.min(o, c)), {
          ...s,
          pageIndex: o
        };
      });
    }, e.resetPageIndex = (r) => {
      var s, o;
      e.setPageIndex(r ? hP : (s = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageIndex) != null ? s : hP);
    }, e.resetPageSize = (r) => {
      var s, o;
      e.setPageSize(r ? pP : (s = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageSize) != null ? s : pP);
    }, e.setPageSize = (r) => {
      e.setPagination((s) => {
        const o = Math.max(1, D2(r, s.pageSize)), c = s.pageSize * s.pageIndex, u = Math.floor(c / o);
        return {
          ...s,
          pageIndex: u,
          pageSize: o
        };
      });
    }, e.setPageCount = (r) => e.setPagination((s) => {
      var o;
      let c = D2(r, (o = e.options.pageCount) != null ? o : -1);
      return typeof c == "number" && (c = Math.max(-1, c)), {
        ...s,
        pageCount: c
      };
    }), e.getPageOptions = Br(() => [e.getPageCount()], (r) => {
      let s = [];
      return r && r > 0 && (s = [...new Array(r)].fill(null).map((o, c) => c)), s;
    }, Hr(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, s = e.getPageCount();
      return s === -1 ? !0 : s === 0 ? !1 : r < s - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, VR = () => ({
  top: [],
  bottom: []
}), i7e = {
  getInitialState: (e) => ({
    rowPinning: VR(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: vp("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, s) => {
      const o = r ? e.getLeafRows().map((m) => {
        let {
          id: y
        } = m;
        return y;
      }) : [], c = s ? e.getParentRows().map((m) => {
        let {
          id: y
        } = m;
        return y;
      }) : [], u = /* @__PURE__ */ new Set([...c, e.id, ...o]);
      t.setRowPinning((m) => {
        var y, b;
        if (n === "bottom") {
          var w, k;
          return {
            top: ((w = m == null ? void 0 : m.top) != null ? w : []).filter((T) => !(u != null && u.has(T))),
            bottom: [...((k = m == null ? void 0 : m.bottom) != null ? k : []).filter((T) => !(u != null && u.has(T))), ...Array.from(u)]
          };
        }
        if (n === "top") {
          var j, E;
          return {
            top: [...((j = m == null ? void 0 : m.top) != null ? j : []).filter((T) => !(u != null && u.has(T))), ...Array.from(u)],
            bottom: ((E = m == null ? void 0 : m.bottom) != null ? E : []).filter((T) => !(u != null && u.has(T)))
          };
        }
        return {
          top: ((y = m == null ? void 0 : m.top) != null ? y : []).filter((T) => !(u != null && u.has(T))),
          bottom: ((b = m == null ? void 0 : m.bottom) != null ? b : []).filter((T) => !(u != null && u.has(T)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: s
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? s) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: s
      } = t.getState().rowPinning, o = n.some((u) => r == null ? void 0 : r.includes(u)), c = n.some((u) => s == null ? void 0 : s.includes(u));
      return o ? "top" : c ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const s = e.getIsPinned();
      if (!s) return -1;
      const o = (n = s === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((c) => {
        let {
          id: u
        } = c;
        return u;
      });
      return (r = o == null ? void 0 : o.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? VR() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : VR());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var s, o;
        return !!((s = r.top) != null && s.length || (o = r.bottom) != null && o.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var s;
      return ((s = e.options.keepPinnedRows) == null || s ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((c) => {
          const u = e.getRow(c, !0);
          return u.getIsAllParentsExpanded() ? u : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((c) => t.find((u) => u.id === c))
      )).filter(Boolean).map((c) => ({
        ...c,
        position: r
      }));
    }, e.getTopRows = Br(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), Hr(e.options, "debugRows", "getTopRows")), e.getBottomRows = Br(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), Hr(e.options, "debugRows", "getBottomRows")), e.getCenterRows = Br(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const s = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((o) => !s.has(o.id));
    }, Hr(e.options, "debugRows", "getCenterRows"));
  }
}, o7e = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: vp("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, s = e.getPreGroupedRowModel().flatRows;
        return t ? s.forEach((o) => {
          o.getCanSelect() && (r[o.id] = !0);
        }) : s.forEach((o) => {
          delete r[o.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), s = {
        ...n
      };
      return e.getRowModel().rows.forEach((o) => {
        gP(s, o.id, r, !0, e);
      }), s;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = Br(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? $R(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Hr(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = Br(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? $R(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Hr(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = Br(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? $R(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Hr(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((s) => s.getCanSelect() && !n[s.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((s) => s.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((s) => !n[s.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const s = e.getIsSelected();
      t.setRowSelection((o) => {
        var c;
        if (n = typeof n < "u" ? n : !s, e.getCanSelect() && s === n)
          return o;
        const u = {
          ...o
        };
        return gP(u, e.id, n, (c = r == null ? void 0 : r.selectChildren) != null ? c : !0, t), u;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return $A(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return yP(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return yP(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var s;
        n && e.toggleSelected((s = r.target) == null ? void 0 : s.checked);
      };
    };
  }
}, gP = (e, t, n, r, s) => {
  var o;
  const c = s.getRow(t, !0);
  n ? (c.getCanMultiSelect() || Object.keys(e).forEach((u) => delete e[u]), c.getCanSelect() && (e[t] = !0)) : delete e[t], r && (o = c.subRows) != null && o.length && c.getCanSelectSubRows() && c.subRows.forEach((u) => gP(e, u.id, n, r, s));
};
function $R(e, t) {
  const n = e.getState().rowSelection, r = [], s = {}, o = function(c, u) {
    return c.map((m) => {
      var y;
      const b = $A(m, n);
      if (b && (r.push(m), s[m.id] = m), (y = m.subRows) != null && y.length && (m = {
        ...m,
        subRows: o(m.subRows)
      }), b)
        return m;
    }).filter(Boolean);
  };
  return {
    rows: o(t.rows),
    flatRows: r,
    rowsById: s
  };
}
function $A(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function yP(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let s = !0, o = !1;
  return e.subRows.forEach((c) => {
    if (!(o && !s) && (c.getCanSelect() && ($A(c, t) ? o = !0 : s = !1), c.subRows && c.subRows.length)) {
      const u = yP(c, t);
      u === "all" ? o = !0 : (u === "some" && (o = !0), s = !1);
    }
  }), s ? "all" : o ? "some" : !1;
}
const vP = /([0-9]+)/gm, l7e = (e, t, n) => Jq(q2(e.getValue(n)).toLowerCase(), q2(t.getValue(n)).toLowerCase()), c7e = (e, t, n) => Jq(q2(e.getValue(n)), q2(t.getValue(n))), u7e = (e, t, n) => GA(q2(e.getValue(n)).toLowerCase(), q2(t.getValue(n)).toLowerCase()), d7e = (e, t, n) => GA(q2(e.getValue(n)), q2(t.getValue(n))), f7e = (e, t, n) => {
  const r = e.getValue(n), s = t.getValue(n);
  return r > s ? 1 : r < s ? -1 : 0;
}, m7e = (e, t, n) => GA(e.getValue(n), t.getValue(n));
function GA(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function q2(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Jq(e, t) {
  const n = e.split(vP).filter(Boolean), r = t.split(vP).filter(Boolean);
  for (; n.length && r.length; ) {
    const s = n.shift(), o = r.shift(), c = parseInt(s, 10), u = parseInt(o, 10), m = [c, u].sort();
    if (isNaN(m[0])) {
      if (s > o)
        return 1;
      if (o > s)
        return -1;
      continue;
    }
    if (isNaN(m[1]))
      return isNaN(c) ? -1 : 1;
    if (c > u)
      return 1;
    if (u > c)
      return -1;
  }
  return n.length - r.length;
}
const B7 = {
  alphanumeric: l7e,
  alphanumericCaseSensitive: c7e,
  text: u7e,
  textCaseSensitive: d7e,
  datetime: f7e,
  basic: m7e
}, h7e = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: vp("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const s of n) {
        const o = s == null ? void 0 : s.getValue(e.id);
        if (Object.prototype.toString.call(o) === "[object Date]")
          return B7.datetime;
        if (typeof o == "string" && (r = !0, o.split(vP).length > 1))
          return B7.alphanumeric;
      }
      return r ? B7.text : B7.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return u_(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : B7[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const s = e.getNextSortingOrder(), o = typeof n < "u" && n !== null;
      t.setSorting((c) => {
        const u = c == null ? void 0 : c.find((j) => j.id === e.id), m = c == null ? void 0 : c.findIndex((j) => j.id === e.id);
        let y = [], b, w = o ? n : s === "desc";
        if (c != null && c.length && e.getCanMultiSort() && r ? u ? b = "toggle" : b = "add" : c != null && c.length && m !== c.length - 1 ? b = "replace" : u ? b = "toggle" : b = "replace", b === "toggle" && (o || s || (b = "remove")), b === "add") {
          var k;
          y = [...c, {
            id: e.id,
            desc: w
          }], y.splice(0, y.length - ((k = t.options.maxMultiSortColCount) != null ? k : Number.MAX_SAFE_INTEGER));
        } else b === "toggle" ? y = c.map((j) => j.id === e.id ? {
          ...j,
          desc: w
        } : j) : b === "remove" ? y = c.filter((j) => j.id !== e.id) : y = [{
          id: e.id,
          desc: w
        }];
        return y;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, s;
      const o = e.getFirstSortDir(), c = e.getIsSorted();
      return c ? c !== o && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (s = t.options.enableMultiRemove) != null) || s) ? !1 : c === "desc" ? "asc" : "desc" : o;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((s) => s.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((s) => s.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, p7e = [
  LCe,
  t7e,
  QCe,
  ZCe,
  FCe,
  UCe,
  n7e,
  //depends on ColumnFaceting
  r7e,
  //depends on ColumnFiltering
  h7e,
  KCe,
  //depends on RowSorting
  a7e,
  s7e,
  i7e,
  o7e,
  JCe
];
function g7e(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...p7e, ...(t = e._features) != null ? t : []];
  let s = {
    _features: r
  };
  const o = s._features.reduce((k, j) => Object.assign(k, j.getDefaultOptions == null ? void 0 : j.getDefaultOptions(s)), {}), c = (k) => s.options.mergeOptions ? s.options.mergeOptions(o, k) : {
    ...o,
    ...k
  };
  let m = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  s._features.forEach((k) => {
    var j;
    m = (j = k.getInitialState == null ? void 0 : k.getInitialState(m)) != null ? j : m;
  });
  const y = [];
  let b = !1;
  const w = {
    _features: r,
    options: {
      ...o,
      ...e
    },
    initialState: m,
    _queue: (k) => {
      y.push(k), b || (b = !0, Promise.resolve().then(() => {
        for (; y.length; )
          y.shift()();
        b = !1;
      }).catch((j) => setTimeout(() => {
        throw j;
      })));
    },
    reset: () => {
      s.setState(s.initialState);
    },
    setOptions: (k) => {
      const j = D2(k, s.options);
      s.options = c(j);
    },
    getState: () => s.options.state,
    setState: (k) => {
      s.options.onStateChange == null || s.options.onStateChange(k);
    },
    _getRowId: (k, j, E) => {
      var T;
      return (T = s.options.getRowId == null ? void 0 : s.options.getRowId(k, j, E)) != null ? T : `${E ? [E.id, j].join(".") : j}`;
    },
    getCoreRowModel: () => (s._getCoreRowModel || (s._getCoreRowModel = s.options.getCoreRowModel(s)), s._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => s.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (k, j) => {
      let E = (j ? s.getPrePaginationRowModel() : s.getRowModel()).rowsById[k];
      if (!E && (E = s.getCoreRowModel().rowsById[k], !E))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${k}`) : new Error();
      return E;
    },
    _getDefaultColumnDef: Br(() => [s.options.defaultColumn], (k) => {
      var j;
      return k = (j = k) != null ? j : {}, {
        header: (E) => {
          const T = E.header.column.columnDef;
          return T.accessorKey ? T.accessorKey : T.accessorFn ? T.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (E) => {
          var T, D;
          return (T = (D = E.renderValue()) == null || D.toString == null ? void 0 : D.toString()) != null ? T : null;
        },
        ...s._features.reduce((E, T) => Object.assign(E, T.getDefaultColumnDef == null ? void 0 : T.getDefaultColumnDef()), {}),
        ...k
      };
    }, Hr(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => s.options.columns,
    getAllColumns: Br(() => [s._getColumnDefs()], (k) => {
      const j = function(E, T, D) {
        return D === void 0 && (D = 0), E.map((L) => {
          const I = ACe(s, L, D, T), R = L;
          return I.columns = R.columns ? j(R.columns, I, D + 1) : [], I;
        });
      };
      return j(k);
    }, Hr(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: Br(() => [s.getAllColumns()], (k) => k.flatMap((j) => j.getFlatColumns()), Hr(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: Br(() => [s.getAllFlatColumns()], (k) => k.reduce((j, E) => (j[E.id] = E, j), {}), Hr(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: Br(() => [s.getAllColumns(), s._getOrderColumnsFn()], (k, j) => {
      let E = k.flatMap((T) => T.getLeafColumns());
      return j(E);
    }, Hr(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (k) => {
      const j = s._getAllFlatColumnsById()[k];
      return process.env.NODE_ENV !== "production" && !j && console.error(`[Table] Column with id '${k}' does not exist.`), j;
    }
  };
  Object.assign(s, w);
  for (let k = 0; k < s._features.length; k++) {
    const j = s._features[k];
    j == null || j.createTable == null || j.createTable(s);
  }
  return s;
}
function Cp() {
  return (e) => Br(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(s, o, c) {
      o === void 0 && (o = 0);
      const u = [];
      for (let y = 0; y < s.length; y++) {
        const b = ICe(e, e._getRowId(s[y], y, c), s[y], y, o, void 0, c == null ? void 0 : c.id);
        if (n.flatRows.push(b), n.rowsById[b.id] = b, u.push(b), e.options.getSubRows) {
          var m;
          b.originalSubRows = e.options.getSubRows(s[y], y), (m = b.originalSubRows) != null && m.length && (b.subRows = r(b.originalSubRows, o + 1, b));
        }
      }
      return u;
    };
    return n.rows = r(t), n;
  }, Hr(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function j5() {
  return (e) => Br(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const r = e.getState().sorting, s = [], o = r.filter((m) => {
      var y;
      return (y = e.getColumn(m.id)) == null ? void 0 : y.getCanSort();
    }), c = {};
    o.forEach((m) => {
      const y = e.getColumn(m.id);
      y && (c[m.id] = {
        sortUndefined: y.columnDef.sortUndefined,
        invertSorting: y.columnDef.invertSorting,
        sortingFn: y.getSortingFn()
      });
    });
    const u = (m) => {
      const y = m.map((b) => ({
        ...b
      }));
      return y.sort((b, w) => {
        for (let j = 0; j < o.length; j += 1) {
          var k;
          const E = o[j], T = c[E.id], D = T.sortUndefined, L = (k = E == null ? void 0 : E.desc) != null ? k : !1;
          let I = 0;
          if (D) {
            const R = b.getValue(E.id), U = w.getValue(E.id), z = R === void 0, H = U === void 0;
            if (z || H) {
              if (D === "first") return z ? -1 : 1;
              if (D === "last") return z ? 1 : -1;
              I = z && H ? 0 : z ? D : -D;
            }
          }
          if (I === 0 && (I = T.sortingFn(b, w, E.id)), I !== 0)
            return L && (I *= -1), T.invertSorting && (I *= -1), I;
        }
        return b.index - w.index;
      }), y.forEach((b) => {
        var w;
        s.push(b), (w = b.subRows) != null && w.length && (b.subRows = u(b.subRows));
      }), y;
    };
    return {
      rows: u(n.rows),
      flatRows: s,
      rowsById: n.rowsById
    };
  }, Hr(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Gi(e, t) {
  return e ? y7e(e) ? /* @__PURE__ */ re.createElement(e, t) : e : null;
}
function y7e(e) {
  return v7e(e) || typeof e == "function" || x7e(e);
}
function v7e(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function x7e(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function Np(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = re.useState(() => ({
    current: g7e(t)
  })), [r, s] = re.useState(() => n.current.initialState);
  return n.current.setOptions((o) => ({
    ...o,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (c) => {
      s(c), e.onStateChange == null || e.onStateChange(c);
    }
  })), n.current;
}
const b7e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { id: "System Icon=Align" }, /* @__PURE__ */ re.createElement("g", { id: "Vector" }, /* @__PURE__ */ re.createElement("path", { d: "M7.97355 2.08398C8.08355 2.12399 8.17355 2.19399 8.25355 2.27399L11.5136 5.53399C11.8536 5.87399 11.8536 6.43399 11.5136 6.77399C11.1736 7.11399 10.6136 7.11399 10.2736 6.77399L8.51355 5.01399L8.51355 21.134C8.51355 21.614 8.12356 22.014 7.63356 22.014C7.14356 22.014 6.75355 21.624 6.75355 21.134L6.75355 4.99398L4.99355 6.75399C4.65355 7.09399 4.09355 7.09399 3.75355 6.75399C3.58355 6.58399 3.49355 6.36399 3.49355 6.13399C3.49355 5.90399 3.58355 5.68399 3.75355 5.51399L7.01355 2.25399C7.09355 2.17399 7.19355 2.10399 7.30355 2.06398C7.51355 1.97398 7.75355 1.97398 7.97355 2.06398L7.97355 2.08398Z" }), /* @__PURE__ */ re.createElement("path", { d: "M16.0536 21.944C15.9436 21.904 15.8536 21.834 15.7636 21.754L12.5036 18.494C12.3336 18.324 12.2436 18.104 12.2436 17.874C12.2436 17.644 12.3336 17.424 12.5036 17.254C12.8436 16.914 13.4036 16.914 13.7436 17.254L15.5036 19.014L15.5036 2.87399C15.5036 2.39399 15.8936 1.99398 16.3836 1.99398C16.8736 1.99398 17.2636 2.38399 17.2636 2.87399L17.2636 19.024L19.0236 17.264C19.3636 16.924 19.9236 16.924 20.2636 17.264C20.6036 17.604 20.6036 18.164 20.2636 18.504L17.0036 21.764C16.9236 21.844 16.8236 21.914 16.7236 21.954C16.5136 22.044 16.2736 22.044 16.0536 21.954L16.0536 21.944Z" })))), t0 = yn(b7e);
function nw(e, t) {
  return `${t === S1.Cancelled && e > 0 ? "-" : ""} ${e.toLocaleString(cr.Ko)}`;
}
const I8 = (e) => e === S1.Paid ? "결제완료" : "환불";
function d_({ description: e, isEmptyRows: t }) {
  return t && /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m flex-center px-[0.286rem] py-[4.28571rem] text-mshop-gray-50", children: e });
}
const H7 = wp(), S7e = [];
function w7e() {
  const { commissionPayment: e } = Uq(), {
    widgetCore: { isMobile: t }
  } = Gt(), n = dn(
    () => [
      H7.accessor("createdAt", {
        header: "신청일",
        cell: (o) => jt(o.getValue(), "yyyy.MM.dd"),
        size: 128,
        enableSorting: !0
      }),
      H7.accessor("displayName", {
        header: "커미션 플랜",
        cell: (o) => o.getValue(),
        enableSorting: !1,
        size: t ? 320 : 376
      }),
      H7.accessor("streakCount", {
        header: "회차",
        cell: (o) => o.getValue(),
        enableSorting: !1,
        size: 128
      }),
      H7.accessor("paymentState", {
        header: "상태",
        cell: (o) => I8(o.getValue()),
        enableSorting: !1,
        size: 96
      }),
      H7.accessor(
        (o) => /* @__PURE__ */ a.jsxs("div", { className: "flex w-full items-center justify-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: nw(
            o.price,
            o.paymentState === S1.Cancelled ? S1.Cancelled : S1.Paid
          ) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(V2.Krw) })
        ] }),
        {
          header: "결제 금액",
          cell: (o) => o.getValue(),
          enableSorting: !1,
          size: 128
        }
      )
    ],
    []
  ), r = Np({
    columns: n,
    data: (e == null ? void 0 : e.statements) ?? S7e,
    getCoreRowModel: Cp(),
    getSortedRowModel: j5(),
    initialState: {
      sorting: [
        {
          id: "requestAt",
          desc: !0
        }
      ]
    }
  });
  if (e == null)
    return /* @__PURE__ */ a.jsx($i, {});
  const s = e.statements.length === 0;
  return /* @__PURE__ */ a.jsxs(
    $i,
    {
      className: $("mt-[1.14285rem] flex flex-col gap-y-[1.14285rem]", {
        "pb-[2.85714rem]": t
      }),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "flex w-full items-center justify-between gap-x-[1.71428rem] rounded-[1.143rem] bg-mshop-gray-5",
              { "p-[1.71428rem]": !t },
              {
                "flex-col gap-y-[0.571428rem] p-[1.14285rem]": t
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs("div", { className: $("flex gap-x-[0.57142rem]", { "w-full": t }), children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "typo-mshop-kr-14-b",
                      { "w-[8rem]": !t },
                      { "w-[5.71428rem] flex-shrink-0": t }
                    ),
                    children: "신청 커미션"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "ul",
                  {
                    className: $(
                      "typo-mshop-kr-14-m text-mshop-gray-80",
                      { "w-[19.429rem]": !t },
                      { "w-full max-w-[16.5rem]": t }
                    ),
                    children: e.plans.map(({ displayName: o }, c) => /* @__PURE__ */ a.jsx("li", { className: "", children: o }, c))
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: $("flex gap-x-[0.57142rem]", { "w-full": t }), children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "typo-mshop-kr-14-b",
                      { "w-[8rem]": !t },
                      { "w-[5.71428rem] flex-shrink-0": t }
                    ),
                    children: "총 결제 금액"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "ul",
                  {
                    className: $(
                      "typo-mshop-kr-14-m text-mshop-gray-80",
                      { "w-[19.429rem]": !t },
                      { "w-full max-w-[16.5rem]": t }
                    ),
                    children: e.plans.map(({ totalPrice: o, streakCount: c }, u) => /* @__PURE__ */ a.jsxs("li", { className: "flex items-center whitespace-pre", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: c }),
                      /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m", children: [
                        "회",
                        " / "
                      ] }),
                      /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-14-unica-m", children: [
                        nw(
                          o,
                          S1.Paid
                        ),
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(V2.Krw) })
                      ] })
                    ] }, u))
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("overflow-hidden rounded-lg border border-mshop-gray-5", {
              "w-full scrollbar-hide": t,
              "overflow-x-auto": t && !s
            }),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !t
                    },
                    {
                      "w-[48.57142rem]": t
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: r.getHeaderGroups().map((o) => /* @__PURE__ */ a.jsx("tr", { children: o.headers.map((c) => /* @__PURE__ */ a.jsx(
                      "th",
                      {
                        className: "typo-mshop-kr-12-b h-[2.857rem] bg-mshop-gray-5 px-[0.571rem] text-mshop-gray-50",
                        style: { width: c.getSize() },
                        children: c.isPlaceholder ? null : /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.29rem]", children: [
                          Gi(
                            c.column.columnDef.header,
                            c.getContext()
                          ),
                          c.column.getCanSort() && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "block size-[0.85714rem]",
                              onClick: () => {
                                c.column.toggleSorting(
                                  c.column.getNextSortingOrder() === "desc"
                                );
                              },
                              children: /* @__PURE__ */ a.jsx(t0, { className: "h-full w-full text-mshop-gray-50" })
                            }
                          )
                        ] })
                      },
                      c.id
                    )) }, o.id)) }),
                    !s && /* @__PURE__ */ a.jsx("tbody", { children: r.getRowModel().rows.map((o) => /* @__PURE__ */ a.jsx("tr", { children: o.getVisibleCells().map((c) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: "typo-mshop-en-14-unica-r h-[2.857rem] border-t border-t-mshop-gray-5 px-[0.29rem] py-[0.29rem] text-center text-mshop-gray-80 first:border-t-0",
                        style: {
                          width: c.column.getSize()
                        },
                        children: Gi(
                          c.column.columnDef.cell,
                          c.getContext()
                        )
                      },
                      c.id
                    )) }, o.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                d_,
                {
                  isEmptyRows: s,
                  description: "커미션 결제 내역이 없습니다."
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function C7e() {
  const { managementDaoUser: e } = BA(), {
    widgetCore: { isMobile: t }
  } = Gt();
  return e === null ? /* @__PURE__ */ a.jsx($i, {}) : /* @__PURE__ */ a.jsx(
    $i,
    {
      className: $("mt-4 flex flex-col gap-y-[1.14285rem]", {
        "pb-[2.85714rem]": t
      }),
      children: /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: $(
            "flex flex-col rounded-[1.14286rem] bg-mshop-gray-5 p-[1.71rem]",
            {
              "gap-y-[1.14rem]": !t
            },
            {
              "gap-y-[0.57rem]": t
            }
          ),
          children: [
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex",
                  { "items-center": !t },
                  { "flex-col gap-y-[0.57rem]": t }
                ),
                children: [
                  /* @__PURE__ */ a.jsxs("dl", { className: "flex flex-1", children: [
                    /* @__PURE__ */ a.jsx("dt", { className: "typo-mshop-kr-14-b w-[8rem]", children: "커뮤니티 닉네임" }),
                    /* @__PURE__ */ a.jsx("dd", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: e.nickname })
                  ] }),
                  /* @__PURE__ */ a.jsxs("dl", { className: "flex flex-1", children: [
                    /* @__PURE__ */ a.jsx("dt", { className: "typo-mshop-kr-14-b w-[8rem]", children: "커뮤니티 가입일" }),
                    /* @__PURE__ */ a.jsx("dd", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: jt(e.joinedAt, "yyyy.MM.dd") })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ a.jsxs(
              "div",
              {
                className: $(
                  "flex",
                  { "items-start": !t },
                  { "flex-col gap-y-[0.57rem]": t }
                ),
                children: [
                  /* @__PURE__ */ a.jsxs("dl", { className: "flex flex-1", children: [
                    /* @__PURE__ */ a.jsx("dt", { className: "typo-mshop-kr-14-b w-[8rem]", children: "멤버십 그룹명" }),
                    /* @__PURE__ */ a.jsx("dd", { className: "typo-mshop-kr-14-m flex flex-col text-mshop-gray-80", children: e.plans.map((n) => /* @__PURE__ */ a.jsx("span", { children: n.role.displayName }, n.role.id)) })
                  ] }),
                  /* @__PURE__ */ a.jsxs("dl", { className: "flex flex-1", children: [
                    /* @__PURE__ */ a.jsx("dt", { className: "typo-mshop-kr-14-b w-[8rem]", children: "마지막 접속일" }),
                    /* @__PURE__ */ a.jsx("dd", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: jt(e.lastActiveAt, "yyyy.MM.dd") })
                  ] })
                ]
              }
            )
          ]
        }
      )
    }
  );
}
const V7 = wp(), N7e = [];
function j7e() {
  const {
    widgetCore: { isMobile: e }
  } = Gt(), { membershipUserStatements: t } = Hq(), n = dn(
    () => [
      V7.accessor(
        (c) => `${jt(c.startTimeAt, "yyyy.MM.dd")}${c.endTimeAt ? ` ~ ${jt(c.endTimeAt, "yyyy.MM.dd")}` : ""}`,
        {
          id: "paymentDate",
          header: "결제일 ~ 이용기간",
          cell: (c) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: c.getValue() }),
          size: e ? 180 : 268
        }
      ),
      V7.accessor("membership.displayName", {
        header: "멤버십 플랜",
        cell: (c) => /* @__PURE__ */ a.jsx("span", { className: "line-clamp-1 break-words", children: c.getValue() }),
        enableSorting: !1,
        size: e ? 180 : 268
      }),
      V7.accessor(
        (c) => c.payment.type === $n.ShortTermPass ? "기간한정" : c.membership.streakCount,
        {
          header: "회차",
          cell: (c) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: c.getValue() }),
          enableSorting: !1,
          size: 96
        }
      ),
      V7.accessor("paymentState", {
        header: "상태",
        cell: (c) => I8(c.getValue()),
        enableSorting: !1,
        size: 96
      }),
      V7.accessor(
        (c) => /* @__PURE__ */ a.jsxs("div", { className: "flex w-full items-center justify-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: `${c.paymentState === S1.Cancelled ? "-" : ""} ${c.price.toLocaleString(cr.Ko)}` }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(c.currency) })
        ] }),
        {
          header: "결제 금액",
          cell: (c) => c.getValue(),
          enableSorting: !1,
          size: 128
        }
      )
    ],
    []
  ), r = Np({
    columns: n,
    data: (t == null ? void 0 : t.statements) ?? N7e,
    getCoreRowModel: Cp(),
    getSortedRowModel: j5(),
    initialState: {
      sorting: [
        {
          id: "paymentDate",
          desc: !0
        }
      ]
    }
  });
  if (t == null)
    return /* @__PURE__ */ a.jsx($i, {});
  const o = r.getRowModel().rows.length === 0;
  return /* @__PURE__ */ a.jsxs(
    $i,
    {
      className: $("mt-4 flex flex-col gap-y-[1.14285rem]", {
        "pb-[2.85714rem]": e
      }),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "flex w-full items-center justify-between gap-x-[1.71428rem] rounded-[1.143rem] bg-mshop-gray-5",
              { "p-[1.71428rem]": !e },
              {
                "flex-col gap-y-[0.571428rem] p-[1.14285rem]": e
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs("div", { className: $("flex gap-x-[0.57142rem]", { "w-full": e }), children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "typo-mshop-kr-14-b",
                      { "w-[8rem]": !e },
                      { "w-[5.71428rem] flex-shrink-0": e }
                    ),
                    children: "멤버십 플랜"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "ul",
                  {
                    className: $(
                      "typo-mshop-kr-14-m text-mshop-gray-80",
                      { "w-[19.429rem]": !e },
                      { "w-full max-w-[16.5rem]": e }
                    ),
                    children: t.membershipPlan.memberships.map(
                      ({ id: c, displayName: u, status: m }) => /* @__PURE__ */ a.jsxs("li", { className: "", children: [
                        u,
                        m === "EXPIRED" ? " (해지)" : ""
                      ] }, c)
                    )
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: $("flex gap-x-[0.57142rem]", { "w-full": e }), children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "typo-mshop-kr-14-b",
                      { "w-[8rem]": !e },
                      { "w-[5.71428rem] flex-shrink-0": e }
                    ),
                    children: "총 결제 금액"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "ul",
                  {
                    className: $(
                      "typo-mshop-kr-14-m text-mshop-gray-80",
                      { "w-[19.429rem]": !e },
                      { "w-full max-w-[16.5rem]": e }
                    ),
                    children: t.membershipPlan.memberships.map(
                      ({ id: c, totalPrice: u, currency: m }) => /* @__PURE__ */ a.jsxs("li", { className: "flex items-center", children: [
                        /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-14-unica-m", children: [
                          u.toLocaleString(cr.Ko),
                          " "
                        ] }),
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(m) })
                      ] }, c)
                    )
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("overflow-hidden rounded-lg border border-mshop-gray-5", {
              "w-full scrollbar-hide": e,
              "overflow-x-auto": e && !o
            }),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !e
                    },
                    {
                      "w-[48.57142rem]": e
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: r.getHeaderGroups().map((c) => /* @__PURE__ */ a.jsx("tr", { children: c.headers.map((u) => /* @__PURE__ */ a.jsx(
                      "th",
                      {
                        className: "typo-mshop-kr-12-b h-[2.857rem] bg-mshop-gray-5 px-[0.571rem] text-mshop-gray-50",
                        style: { width: u.getSize() },
                        children: u.isPlaceholder ? null : /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.29rem]", children: [
                          Gi(
                            u.column.columnDef.header,
                            u.getContext()
                          ),
                          u.column.getCanSort() && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "block size-[0.85714rem]",
                              onClick: () => {
                                u.column.toggleSorting(
                                  u.column.getNextSortingOrder() === "desc"
                                );
                              },
                              children: /* @__PURE__ */ a.jsx(t0, { className: "h-full w-full text-mshop-gray-50" })
                            }
                          )
                        ] })
                      },
                      u.id
                    )) }, c.id)) }),
                    !o && /* @__PURE__ */ a.jsx("tbody", { children: r.getRowModel().rows.map((c) => /* @__PURE__ */ a.jsx("tr", { children: c.getVisibleCells().map((u) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: "typo-mshop-kr-14-m h-[2.857rem] border-t border-t-mshop-gray-5 px-[0.29rem] py-[0.29rem] text-center text-mshop-gray-80 first:border-t-0",
                        style: {
                          width: u.column.getSize()
                        },
                        children: Gi(
                          u.column.columnDef.cell,
                          u.getContext()
                        )
                      },
                      u.id
                    )) }, c.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                d_,
                {
                  isEmptyRows: o,
                  description: "멤버십 결제 내역이 없습니다."
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const P2 = {
  Goods: "GOODS",
  OrderMade: "ORDER_MADE",
  DigitalGoods: "DIGITAL_GOODS"
}, xP = (e, t) => {
  switch (e) {
    case P2.Goods:
      return "마플샵제작배송";
    case P2.DigitalGoods:
      return "디지털/전자책";
    case P2.OrderMade:
      return t ? "마플샵배송" : "크리에이터배송";
    default:
      throw new Error(`Does not Exist goodsTypeId: ${e}`);
  }
}, E7e = {
  [`${P2.Goods}`]: "bg-mshop-blue-10 text-mshop-blue-100",
  // 마플샵 제작배송
  [`${P2.DigitalGoods}`]: "bg-mshop-brown-10 text-mshop-brown-100",
  // 디지털/전자책
  [`${P2.OrderMade}`]: "bg-mshop-green-10 text-mshop-green-100",
  // 크리에이터 배송
  [`${P2.OrderMade}:true`]: "bg-mshop-pink-20 text-mshop-red-80"
  // 마플샵 배송
};
function eK({ goodsTypeId: e, isTpl: t }) {
  return /* @__PURE__ */ a.jsx(
    "span",
    {
      className: $(
        "typo-mshop-kr-12-m inline-flex h-[1.57143rem] flex-shrink-0 items-center justify-center truncate rounded-[0.28571rem] px-[0.42857rem]",
        E7e[t ? `${e}:${t}` : e]
      ),
      children: xP(e, t)
    }
  );
}
const v8 = wp(), k7e = [];
function _7e() {
  const { productPurchase: e } = Vq(), {
    widgetCore: { isMobile: t }
  } = Gt(), n = dn(
    () => [
      v8.accessor("id", {
        header: "주문일시",
        cell: (c) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: jt(c.row.original.orderedAt, "yyyy.MM.dd") }),
        size: 128
      }),
      v8.accessor("membership.displayName", {
        header: "멤버십 플랜",
        cell: (c) => /* @__PURE__ */ a.jsx("span", { className: "line-clamp-1 break-words", children: c.getValue() }),
        enableSorting: !1,
        size: t ? 164 : 232
      }),
      v8.accessor(
        ({ goodsTypeId: c, product: { isTpl: u } }) => ({ goodsTypeId: c, isTpl: u }),
        {
          header: "상품 종류",
          cell: (c) => /* @__PURE__ */ a.jsx(eK, { ...c.getValue() }),
          enableSorting: !1,
          size: 96
        }
      ),
      v8.accessor("product", {
        header: "상품명",
        cell: (c) => {
          const u = c.getValue();
          return /* @__PURE__ */ a.jsxs(
            "a",
            {
              href: u.link,
              className: "flex items-center gap-x-[0.571rem]",
              children: [
                /* @__PURE__ */ a.jsx("div", { className: "flex-center size-[2.85714rem] overflow-hidden rounded-[0.29rem] bg-mshop-gray-5", children: /* @__PURE__ */ a.jsx(
                  "img",
                  {
                    src: u.image,
                    className: "aspect-square object-cover",
                    style: {
                      width: `${u.imageRatio}%`
                    },
                    alt: ""
                  }
                ) }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80 underline", children: u.name })
              ]
            }
          );
        },
        enableSorting: !1,
        size: t ? 164 : 232
      }),
      v8.accessor("quantity", {
        header: "수량",
        cell: (c) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: c.getValue() }),
        size: 40,
        enableSorting: !1
      }),
      v8.accessor("product.price", {
        header: "상품 금액",
        cell: (c) => /* @__PURE__ */ a.jsxs("div", { className: "flex w-full items-center justify-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: c.getValue().toLocaleString(cr.Ko) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(V2.Krw) })
        ] }),
        enableSorting: !1,
        size: 128
      })
    ],
    []
  ), r = Np({
    columns: n,
    data: (e == null ? void 0 : e.items) ?? k7e,
    getCoreRowModel: Cp(),
    getSortedRowModel: j5(),
    initialState: {
      sorting: [
        {
          id: "id",
          desc: !0
        }
      ]
    }
  });
  if (e == null)
    return /* @__PURE__ */ a.jsx($i, {});
  const o = r.getRowModel().rows.length === 0;
  return /* @__PURE__ */ a.jsxs(
    $i,
    {
      className: $("mt-4 flex flex-col gap-y-[1.14285rem]", {
        "pb-[2.85714rem]": t
      }),
      children: [
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $(
              "flex w-full items-center justify-between gap-x-[1.71428rem] rounded-[1.143rem] bg-mshop-gray-5",
              { "p-[1.71428rem]": !t },
              {
                "flex-col gap-y-[0.571428rem] p-[1.14285rem]": t
              }
            ),
            children: /* @__PURE__ */ a.jsxs("div", { className: $("flex gap-x-[0.571rem]", { "w-full": t }), children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "typo-mshop-kr-14-b",
                    { "w-[8rem]": !t },
                    { "w-[5.71428rem] flex-shrink-0": t }
                  ),
                  children: "총 구매 개수"
                }
              ),
              /* @__PURE__ */ a.jsxs(
                "span",
                {
                  className: $(
                    "typo-mshop-kr-14-m text-mshop-gray-80",
                    { "w-[19.429rem]": !t },
                    { "w-full max-w-[16.5rem]": t }
                  ),
                  children: [
                    e.totalOrderCount.toLocaleString(cr.Ko),
                    " 개"
                  ]
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("overflow-hidden rounded-lg border border-mshop-gray-5", {
              "w-full scrollbar-hide": t,
              "overflow-x-auto": t && !o
            }),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !t
                    },
                    {
                      "w-[48.57142rem]": t
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: r.getHeaderGroups().map((c) => /* @__PURE__ */ a.jsx("tr", { children: c.headers.map((u) => /* @__PURE__ */ a.jsx(
                      "th",
                      {
                        className: "typo-mshop-kr-12-b h-[2.857rem] bg-mshop-gray-5 px-[0.571rem] text-mshop-gray-50",
                        style: { width: u.getSize() },
                        children: u.isPlaceholder ? null : /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.29rem]", children: [
                          Gi(
                            u.column.columnDef.header,
                            u.getContext()
                          ),
                          u.column.getCanSort() && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "block size-[0.85714rem]",
                              onClick: () => u.column.toggleSorting(
                                u.column.getNextSortingOrder() === "desc"
                              ),
                              children: /* @__PURE__ */ a.jsx(t0, { className: "h-full w-full text-mshop-gray-50" })
                            }
                          )
                        ] })
                      },
                      u.id
                    )) }, c.id)) }),
                    !o && /* @__PURE__ */ a.jsx("tbody", { children: r.getRowModel().rows.map((c) => /* @__PURE__ */ a.jsx("tr", { children: c.getVisibleCells().map((u) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: "typo-mshop-kr-14-m h-[4.28571rem] border-t border-t-mshop-gray-5 px-[0.29rem] py-[0.29rem] text-center text-mshop-gray-80 first:border-t-0",
                        style: {
                          width: u.column.getSize()
                        },
                        children: Gi(
                          u.column.columnDef.cell,
                          u.getContext()
                        )
                      },
                      u.id
                    )) }, c.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                d_,
                {
                  isEmptyRows: o,
                  description: "상품 구매 내역이 없습니다."
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const $7 = wp(), T7e = [];
function M7e() {
  const { managementSupportUser: e } = Bq(), {
    widgetCore: { isMobile: t }
  } = Gt(), n = dn(
    () => [
      $7.accessor("createdAt", {
        header: "후원일",
        cell: (o) => jt(o.getValue(), "yyyy.MM.dd"),
        size: 128
      }),
      $7.accessor("displayName", {
        header: "후원 플랜",
        cell: (o) => o.getValue(),
        enableSorting: !1,
        size: t ? 320 : 376
      }),
      $7.accessor("streakCount", {
        header: "회차",
        cell: (o) => o.getValue(),
        enableSorting: !1,
        size: 128
      }),
      $7.accessor("paymentState", {
        header: "상태",
        cell: (o) => o.getValue() === GD.Paid ? "결제완료" : "환불",
        enableSorting: !1,
        size: t ? 96 : 112
      }),
      $7.accessor(
        (o) => /* @__PURE__ */ a.jsxs("div", { className: "flex w-full items-center justify-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: nw(o.price, o.paymentState) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(V2.Krw) })
        ] }),
        {
          header: "후원 금액",
          cell: (o) => o.getValue(),
          enableSorting: !1,
          size: 128
        }
      )
    ],
    []
  ), r = Np({
    columns: n,
    data: (e == null ? void 0 : e.items) ?? T7e,
    getCoreRowModel: Cp(),
    getSortedRowModel: j5(),
    initialState: {
      sorting: [
        {
          id: "createdAt",
          desc: !0
        }
      ]
    }
  });
  if (e == null)
    return /* @__PURE__ */ a.jsx($i, {});
  const s = e.items.length === 0;
  return /* @__PURE__ */ a.jsxs(
    $i,
    {
      className: $("mt-[1.14285rem] flex flex-col gap-y-[1.14285rem]", {
        "pb-[2.85714rem]": t
      }),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "flex w-full items-center justify-between gap-x-[1.71428rem] rounded-[1.143rem] bg-mshop-gray-5",
              { "p-[1.71428rem]": !t },
              {
                "flex-col gap-y-[0.571428rem] p-[1.14285rem]": t
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs("div", { className: $("flex gap-x-[0.57142rem]", { "w-full": t }), children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "typo-mshop-kr-14-b",
                      { "w-[8rem]": !t },
                      { "w-[5.71428rem] flex-shrink-0": t }
                    ),
                    children: "참여 후원 플랜"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "ul",
                  {
                    className: $(
                      "typo-mshop-kr-14-m text-mshop-gray-80",
                      { "w-[19.429rem]": !t },
                      { "w-full max-w-[16.5rem]": t }
                    ),
                    children: e.summaries.map(({ displayName: o }, c) => /* @__PURE__ */ a.jsx("li", { className: "", children: o }, c))
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: $("flex gap-x-[0.57142rem]", { "w-full": t }), children: [
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "typo-mshop-kr-14-b",
                      { "w-[8rem]": !t },
                      { "w-[5.71428rem] flex-shrink-0": t }
                    ),
                    children: "총 결제 금액"
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "ul",
                  {
                    className: $(
                      "typo-mshop-kr-14-m text-mshop-gray-80",
                      { "w-[19.429rem]": !t },
                      { "w-full max-w-[16.5rem]": t }
                    ),
                    children: e.summaries.map(
                      ({ totalCount: o, totalPrice: c }, u) => /* @__PURE__ */ a.jsxs("li", { className: "flex items-center whitespace-pre", children: [
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: o }),
                        /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m", children: [
                          "회",
                          " / "
                        ] }),
                        /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-14-unica-m", children: [
                          nw(
                            c,
                            S1.Paid
                          ),
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(V2.Krw) })
                        ] })
                      ] }, u)
                    )
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("overflow-hidden rounded-lg border border-mshop-gray-5", {
              "w-full scrollbar-hide": t,
              "overflow-x-auto": t && !s
            }),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !t
                    },
                    {
                      "w-[48.57142rem]": t
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: r.getHeaderGroups().map((o) => /* @__PURE__ */ a.jsx("tr", { children: o.headers.map((c) => /* @__PURE__ */ a.jsx(
                      "th",
                      {
                        className: "typo-mshop-kr-12-b h-[2.857rem] bg-mshop-gray-5 px-[0.571rem] text-mshop-gray-50",
                        style: { width: c.getSize() },
                        children: c.isPlaceholder ? null : /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.29rem]", children: [
                          Gi(
                            c.column.columnDef.header,
                            c.getContext()
                          ),
                          c.column.getCanSort() && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "block size-[0.85714rem]",
                              onClick: () => {
                                c.column.toggleSorting(
                                  c.column.getNextSortingOrder() === "desc"
                                );
                              },
                              children: /* @__PURE__ */ a.jsx(t0, { className: "h-full w-full text-mshop-gray-50" })
                            }
                          )
                        ] })
                      },
                      c.id
                    )) }, o.id)) }),
                    !s && /* @__PURE__ */ a.jsx("tbody", { children: r.getRowModel().rows.map((o) => /* @__PURE__ */ a.jsx("tr", { children: o.getVisibleCells().map((c) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: "typo-mshop-en-14-unica-r h-[2.857rem] border-t border-t-mshop-gray-5 px-[0.29rem] py-[0.29rem] text-center text-mshop-gray-80 first:border-t-0",
                        style: {
                          width: c.column.getSize()
                        },
                        children: Gi(
                          c.column.columnDef.cell,
                          c.getContext()
                        )
                      },
                      c.id
                    )) }, o.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                d_,
                {
                  isEmptyRows: s,
                  description: "후원 내역이 없습니다."
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const R7e = (e, t) => jn(
  "/management-update-user-note",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), kH = 5e3;
function D7e({ show: e }) {
  const { managementUser: t } = HA(), {
    userNote: n,
    setUserNote: r,
    setCopiedNote: s,
    isDirtyUserNote: o,
    checkUnSavedUserNote: c
  } = mP(), { projectId: u } = Tf(), { client: m } = Ha(), {
    widgetCore: { isMobile: y, onError: b }
  } = Gt(), w = (T) => {
    const D = T.target.value;
    D.length > kH ? s({ copiedNote: D.slice(0, kH) }) : s({ copiedNote: D });
  }, k = async () => {
    await c();
  }, j = async () => {
    if (!o || !t || !n)
      return;
    const { code: T } = await R7e(
      {
        note: n.copiedNote,
        userId: t.id,
        projectId: u
      },
      {
        client: m,
        onError: b
      }
    );
    if (T !== le.Success)
      return b(Ht);
    await en({
      body: (D) => /* @__PURE__ */ a.jsx(
        sa,
        {
          button: {
            props: D
          },
          children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.86rem] text-mshop-black", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: "메모 저장" }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "메모를 저장했습니다." })
          ] })
        }
      )
    }), r({
      note: n.copiedNote,
      copiedNote: n.copiedNote
    });
  }, E = () => {
    r(null);
  };
  return an(() => {
    e || E();
  }, []), n == null ? /* @__PURE__ */ a.jsx($i, {}) : /* @__PURE__ */ a.jsxs($i, { className: "mt-[1.143rem] flex flex-col gap-y-[1.14285rem]", children: [
    /* @__PURE__ */ a.jsxs("dl", { className: "flex flex-col gap-y-[0.57rem]", children: [
      /* @__PURE__ */ a.jsx("dt", { className: "typo-mshop-kr-14-b text-mshop-black", children: "비공개 메모" }),
      /* @__PURE__ */ a.jsx("dd", { children: /* @__PURE__ */ a.jsx(
        YE,
        {
          className: "twp w-full resize-none rounded-[0.29rem] border border-mshop-gray-10 p-[0.86rem] outline-0 placeholder:text-mshop-gray-50",
          placeholder: "회원에 대해 기억해야 하는 내용을 기록해 보세요.",
          value: n.copiedNote,
          onChange: w,
          minRows: y ? 12 : 20,
          maxRows: y ? 12 : 20,
          style: { outline: "none" }
        }
      ) })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-end gap-x-[0.57142rem]", children: [
      /* @__PURE__ */ a.jsx(
        za,
        {
          variant: "sm",
          theme: "lineGray",
          type: "button",
          onClick: k,
          children: "취소"
        }
      ),
      /* @__PURE__ */ a.jsx(
        za,
        {
          variant: "sm",
          theme: "blue",
          type: "button",
          onClick: j,
          disabled: !o,
          children: "저장"
        }
      )
    ] })
  ] });
}
const f2 = {
  MembershipPayment: "멤버십 결제",
  ProductPurchase: "상품 구매",
  CommunityInfo: "커뮤니티 정보",
  CommissionPayment: "커미션 결제",
  SupportPayment: "후원 결제",
  UserNote: "메모"
};
function P7e() {
  var ce;
  const [e, t] = Re(!1), {
    widgetCore: { toggleSpinner: n, isMobile: r, onError: s }
  } = Gt(), { client: o } = Ha(), { projectId: c } = Tf(), { membershipUserDetail: u, setMembershipUserDetail: m, setSelectedTabIndex: y } = N5(), { managementUser: b, setManagementUser: w } = HA(), k = !!((ce = b == null ? void 0 : b.member) != null && ce.id), j = Object.values(f2).filter(
    (pe) => pe === f2.CommunityInfo ? k : pe
  ), { setMembershipUserStatements: E } = Hq(), { setManagementSupportUser: T } = Bq(), { setUserNote: D } = mP(), { setProductPurchase: L } = Vq(), { setCommissionPayment: I } = Uq(), { setManagementDaoUser: R } = BA();
  an(() => {
    if (!u)
      return;
    n(!0);
    const pe = j[u.selectedTabIndex];
    (async () => {
      try {
        switch (pe) {
          case f2.MembershipPayment:
            await U();
            break;
          case f2.ProductPurchase:
            await z();
            break;
          case f2.CommunityInfo:
            await H();
            break;
          case f2.CommissionPayment:
            await K();
            break;
          case f2.SupportPayment:
            await q();
            break;
          case f2.UserNote:
            await Q();
            break;
          default:
            throw new Error(
              "등록 되지 않은 탭 이름 입니다. 탭 이름을 확인해 주세요."
            );
        }
      } catch {
        console.log("error");
      } finally {
        n(!1);
      }
    })();
  }, [b, u, o]);
  async function U() {
    wt(u);
    const { userId: pe } = u, [Se, oe] = await Promise.all([
      (b == null ? void 0 : b.id) === pe ? Promise.resolve({
        code: le.Success,
        data: b
      }) : y8(
        { userId: pe, projectId: c },
        {
          client: o,
          onError: s
        }
      ),
      xCe(
        {
          userId: pe,
          projectId: c
        },
        {
          client: o,
          onError: s
        }
      )
    ]);
    if (Se.code !== le.Success || oe.code !== le.Success)
      return s(Ht);
    w(Se.data), E(oe.data);
  }
  async function z() {
    wt(u);
    const { userId: pe } = u, [Se, oe] = await Promise.all([
      (b == null ? void 0 : b.id) === pe ? Promise.resolve({
        code: le.Success,
        data: b
      }) : y8(
        { userId: pe, projectId: c },
        {
          client: o,
          onError: s
        }
      ),
      bCe(
        {
          userId: pe,
          projectId: c,
          sort: {
            order: ws.Desc,
            by: "orderedAt"
          }
        },
        {
          client: o,
          onError: s
        }
      )
    ]);
    if (Se.code !== le.Success || oe.code !== le.Success)
      return s(Ht);
    w(Se.data), L(oe.data);
  }
  async function H() {
    var he;
    wt(u);
    const { userId: pe, memberId: Se } = u, [oe, ue] = await Promise.all([
      (b == null ? void 0 : b.id) === pe ? Promise.resolve({
        code: le.Success,
        data: b
      }) : y8(
        { userId: pe, projectId: c },
        {
          client: o,
          onError: s
        }
      ),
      Se ? dP(
        {
          projectId: c,
          memberId: Se
        },
        {
          client: o,
          onError: s
        }
      ) : Promise.resolve({ code: "NOT_EXECUTED", data: null })
    ]);
    if (oe.code !== le.Success)
      return s(Ht);
    if (w(oe.data), ue.code === "NOT_EXECUTED" && ((he = oe.data.member) != null && he.id)) {
      const { code: ve, data: Te } = await dP(
        {
          projectId: c,
          memberId: oe.data.member.id
        },
        { client: o, onError: s }
      );
      return ve !== le.Success ? s(Ht) : R(Te);
    }
    if (ue.code !== le.Success)
      return s(Ht);
    R(ue.data);
  }
  async function K() {
    wt(u);
    const { userId: pe } = u, [Se, oe] = await Promise.all([
      (b == null ? void 0 : b.id) === pe ? Promise.resolve({
        code: le.Success,
        data: b
      }) : y8(
        { userId: pe, projectId: c },
        {
          client: o,
          onError: s
        }
      ),
      vCe(
        {
          userId: pe,
          projectId: c
        },
        { client: o, onError: s }
      )
    ]);
    if (Se.code !== le.Success || oe.code !== le.Success)
      return s(Ht);
    w(Se.data), I(oe.data);
  }
  async function q() {
    wt(u);
    const { userId: pe } = u, [Se, oe] = await Promise.all([
      (b == null ? void 0 : b.id) === pe ? Promise.resolve({
        code: le.Success,
        data: b
      }) : y8(
        { userId: pe, projectId: c },
        {
          client: o,
          onError: s
        }
      ),
      SCe(
        {
          userId: pe,
          page: 1,
          projectId: c
        },
        {
          client: o,
          onError: s
        }
      )
    ]);
    if (Se.code !== le.Success || oe.code !== le.Success)
      return s(Ht);
    w(Se.data), T(oe.data);
  }
  async function Q() {
    wt(u);
    const { userId: pe } = u, [Se, oe] = await Promise.all([
      (b == null ? void 0 : b.id) === pe ? Promise.resolve({
        code: le.Success,
        data: b
      }) : y8(
        { userId: pe, projectId: c },
        {
          client: o,
          onError: s
        }
      ),
      wCe(
        {
          userId: pe,
          projectId: c
        },
        {
          client: o,
          onError: s
        }
      )
    ]);
    if (Se.code !== le.Success || oe.code !== le.Success)
      return s(Ht);
    w(Se.data), D({
      copiedNote: oe.data.note,
      note: oe.data.note
    });
  }
  const { isDirtyUserNote: Z, checkUnSavedUserNote: X } = mP(), se = () => {
    Z || (w(null), m(null), T(null), D(null), L(null), I(null), R(null));
  }, te = Rt(u);
  an(() => {
    te.current === null && u && b && (t(!0), te.current = u);
  }, [u, b]);
  const fe = async () => {
    await X() || (t(!1), te.current = null);
  };
  return /* @__PURE__ */ a.jsx(Zu, { show: e, onClose: fe, afterLeave: se, children: /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $(
        "flex flex-col bg-mshop-white",
        {
          "h-[51.42857rem] w-[65.71428rem] overflow-hidden rounded-[1.143rem]": !r
        },
        { "h-full w-full": r }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "relative flex items-center border-b border-mshop-gray-5 px-[1.714rem]",
              r ? "h-[4.571rem] justify-center" : "py-[1.14286rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-16-b", children: "회원 상세 정보" }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: "flex-center absolute right-[1.14286rem]",
                  onClick: fe,
                  children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.429rem]" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsx("div", { className: "flex h-full flex-col gap-y-[1.14285rem] overflow-y-scroll scrollbar-hide", children: /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "flex h-full flex-col gap-y-[1.14285rem]",
              { "p-[1.71428rem]": !r },
              { "py-[1.14285rem]": r }
            ),
            children: [
              /* @__PURE__ */ a.jsx(RCe, {}),
              /* @__PURE__ */ a.jsxs(
                VE,
                {
                  selectedIndex: u == null ? void 0 : u.selectedTabIndex,
                  onChange: async (pe) => {
                    await X() || y({ selectedTabIndex: pe });
                  },
                  children: [
                    /* @__PURE__ */ a.jsx(
                      "div",
                      {
                        className: $({
                          "overflow-x-auto scrollbar-hide": r
                        }),
                        children: /* @__PURE__ */ a.jsx(
                          j3,
                          {
                            className: $(
                              "flex border-b border-mshop-gray-20",
                              { "gap-x-[1.71428rem]": !r },
                              { "mx-[1.14285rem]": r }
                            ),
                            children: j.map((pe) => /* @__PURE__ */ a.jsx(GE, { as: jf, children: ({ selected: Se }) => /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                type: "button",
                                className: $(
                                  "relative h-[2.857rem] outline-0",
                                  {
                                    "after:absolute after:-bottom-px after:left-0 after:block after:h-[2px] after:w-full after:bg-mshop-blue-100": Se
                                  },
                                  {
                                    "typo-mshop-kr-14-b text-mshop-black": Se
                                  },
                                  {
                                    "typo-mshop-kr-14-m text-mshop-gray-80": !Se
                                  },
                                  {
                                    "mx-[0.57142rem] flex-shrink-0 first:ml-0": r
                                  }
                                ),
                                children: pe
                              }
                            ) }, pe))
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ a.jsxs($E, { className: $({ "px-[1.14285rem]": r }), children: [
                      /* @__PURE__ */ a.jsx(j7e, {}),
                      /* @__PURE__ */ a.jsx(_7e, {}),
                      k && /* @__PURE__ */ a.jsx(C7e, {}),
                      /* @__PURE__ */ a.jsx(w7e, {}),
                      /* @__PURE__ */ a.jsx(M7e, {}),
                      /* @__PURE__ */ a.jsx(D7e, { show: e })
                    ] })
                  ]
                }
              )
            ]
          }
        ) })
      ]
    }
  ) });
}
const WA = (e, t) => jn(
  "/management-dao-users",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), O7e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M4.9754 2H2.91757C2.8457 2 2.77921 2.03805 2.74281 2.10001L1.02824 5.01816C0.948849 5.15328 1.04628 5.32353 1.203 5.32353H3.01064C3.07809 5.32353 3.14111 5.28999 3.17878 5.23405L5.14354 2.31589C5.23419 2.18126 5.13771 2 4.9754 2Z" }), /* @__PURE__ */ re.createElement("path", { d: "M7.58434 5.32353C7.74664 5.32353 7.84312 5.14227 7.75247 5.00763L6.16814 2.65451C6.0878 2.53519 5.9122 2.53519 5.83186 2.65451L4.24753 5.00763C4.15688 5.14227 4.25335 5.32353 4.41566 5.32353H7.58434Z" }), /* @__PURE__ */ re.createElement("path", { d: "M10.9718 5.01816L9.25719 2.10001C9.22079 2.03805 9.15429 2 9.08243 2H7.0246C6.86229 2 6.76581 2.18126 6.85646 2.31589L8.82122 5.23405C8.85889 5.28999 8.92191 5.32353 8.98936 5.32353H10.797C10.9537 5.32353 11.0512 5.15328 10.9718 5.01816Z" }), /* @__PURE__ */ re.createElement("path", { d: "M4.20509 6.08363C4.05955 6.08363 3.96144 6.23247 4.01882 6.36623L5.81372 10.8298C5.88396 10.9935 6.11604 10.9935 6.18628 10.8298L7.98118 6.36623C8.03856 6.23247 7.94046 6.08363 7.79491 6.08363H4.20509Z" }), /* @__PURE__ */ re.createElement("path", { d: "M7.80351 9.87261L10.9461 6.42347C11.0656 6.29353 10.9734 6.08362 10.7969 6.08362H9.06342C8.98237 6.08362 8.9091 6.13192 8.87715 6.20641L7.468 9.65554C7.37809 9.86512 7.64919 10.0405 7.80351 9.87261Z" }), /* @__PURE__ */ re.createElement("path", { d: "M4.1965 9.87261L1.05385 6.42348C0.934429 6.29354 1.0266 6.08363 1.20309 6.08363H2.93658C3.01763 6.08363 3.0909 6.13192 3.12285 6.20641L4.53201 9.65555C4.62192 9.86513 4.35081 10.0405 4.1965 9.87261Z" })), A7e = yn(O7e), L7e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { id: "System Icon=Refund", clipPath: "url(#clip0_608_22169)" }, /* @__PURE__ */ re.createElement("path", { id: "Vector", d: "M14.8796 6.68994H4.93957L7.06957 4.55994C7.40957 4.21994 7.40957 3.65994 7.06957 3.31994C6.72957 2.97994 6.16957 2.97994 5.82957 3.31994L2.28957 6.85994C1.89957 7.24994 1.89957 7.87994 2.28957 8.26994L5.82957 11.8099C6.16957 12.1499 6.72957 12.1499 7.06957 11.8099C7.40957 11.4699 7.40957 10.9099 7.06957 10.5699L4.93957 8.43994H14.8796C17.8396 8.43994 20.2596 10.8499 20.2596 13.8199C20.2596 16.7899 17.8496 19.1999 14.8796 19.1999H7.03957C6.55957 19.1999 6.15957 19.5899 6.15957 20.0799C6.15957 20.5699 6.54957 20.9599 7.03957 20.9599H14.8796C18.8096 20.9599 21.9996 17.7599 21.9996 13.8399C21.9996 9.91994 18.7996 6.71994 14.8796 6.71994V6.68994Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_608_22169" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), Cy = yn(L7e), _w = () => {
  const e = Rt(!1);
  return an(() => {
    e.current = !0;
  }, []), e.current;
}, I7e = Qt(null), F7e = () => {
  const [e, t] = Ar(
    I7e
  );
  return {
    managementCommunityMember: e,
    setManagementCommunityMember: t
  };
}, U3 = {
  Joined: "JOINED",
  Expired: "EXPIRED"
};
function tK({ status: e, children: t }) {
  return /* @__PURE__ */ a.jsx(
    "span",
    {
      className: $(
        "typo-mshop-kr-12-m inline-flex h-[1.714rem] flex-shrink-0 items-center justify-center truncate rounded px-[0.571rem] backdrop-blur-[5px]",
        {
          "bg-mshop-black text-mshop-white": e === U3.Joined
        },
        {
          "bg-mshop-gray-5 text-mshop-gray-50 line-through": e === U3.Expired
        }
      ),
      children: t
    }
  );
}
function Tw({ description: e, isEmptyRows: t }) {
  const {
    widgetCore: { isMobile: n }
  } = Gt();
  return t && /* @__PURE__ */ a.jsx(
    "div",
    {
      className: $(
        "typo-mshop-kr-14-m flex-center px-[0.286rem] py-[4.29rem] text-mshop-gray-80",
        {
          "h-[42.85714rem]": !n
        },
        {
          "h-[22.85714rem]": n
        }
      ),
      children: e
    }
  );
}
const U7e = {
  JoinedAt: "joinedAt",
  LastActiveAt: "lastActiveAt"
}, z7e = 10, B7e = [], Wj = {
  by: U7e.JoinedAt,
  order: ws.Desc
}, G7 = wp();
function H7e({ isFocusedTab: e }) {
  var X;
  const {
    widgetCore: { toggleSpinner: t, isMobile: n, onError: r }
  } = Gt(), { managementCommunityMember: s, setManagementCommunityMember: o } = F7e(), { client: c } = Ha(), { projectId: u } = Tf(), [m, y] = Re(
    null
  ), [b, w] = Re(1), [k, j] = Re(Wj), E = async (se) => {
    t(!0);
    const { code: te, data: fe } = await WA(
      I2({
        page: se.page,
        size: z7e,
        sort: se.sort,
        projectId: u,
        membershipId: se.membershipId
      }),
      {
        client: c,
        onError: r
      }
    );
    if (t(!1), te === le.TokenExpired)
      return r(Ht);
    o(fe);
  }, T = _w();
  an(() => {
    !T || !e || (async () => (await E({
      page: 1
    }), w(1), y(null), j(Wj)))();
  }, [e]);
  const D = async (se) => {
    y(se), await E({
      page: b,
      ..._H(se)
    });
  }, L = async (se, te) => {
    w(te), await E({
      page: te,
      sort: k,
      ..._H(m)
    });
  }, I = async () => {
    y(null), w(1), j(Wj), await E({
      page: 1,
      sort: Wj
    });
  }, { setMembershipUserDetail: R } = N5(), U = (se, te) => {
    R({
      userId: se,
      memberId: te,
      selectedTabIndex: 2
    });
  }, z = async ({ by: se }) => {
    const te = k.by === se ? {
      ...k,
      order: k.order === ws.Asc ? ws.Desc : ws.Asc
    } : { by: se, order: ws.Desc };
    await E({
      page: b,
      sort: te,
      membershipId: m == null ? void 0 : m.id
    }), j(te);
  }, H = dn(
    () => [
      G7.accessor("joinedAt", {
        header: "커뮤니티 가입일",
        cell: (se) => jt(se.getValue(), "yyyy.MM.dd"),
        size: n ? 112 : 128
      }),
      G7.accessor("lastActiveAt", {
        header: "마지막 접속일",
        cell: (se) => jt(se.getValue(), "yyyy.MM.dd"),
        size: n ? 112 : 128
      }),
      G7.accessor("user", {
        header: "마플샵 닉네임",
        cell: (se) => {
          const te = se.getValue();
          wt(te);
          const fe = se.row.original.id;
          return /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.57142rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "h-[2.286rem] w-[2.286rem]", children: /* @__PURE__ */ a.jsx(Ql, { imageUrl: Xu(te) }) }),
            /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "block underline",
                onClick: () => U(te.id, fe),
                disabled: te.state === Sy.Delete,
                children: Mc(te)
              }
            )
          ] });
        },
        size: n ? 176 : 240,
        enableSorting: !1
      }),
      G7.accessor("imageUrl", {
        header: "커뮤니티 닉네임",
        cell: (se) => {
          const te = se.getValue(), { nickname: fe, state: ce } = se.row.original;
          return /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex gap-x-[0.57142rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "h-[2.286rem] w-[2.286rem]", children: /* @__PURE__ */ a.jsx(Ql, { imageUrl: te }) }),
            axe({
              nickname: fe,
              state: ce
            })
          ] });
        },
        size: n ? 176 : 240,
        enableSorting: !1
      }),
      G7.accessor("plans", {
        header: "멤버십 플랜 / 커뮤니티 그룹",
        cell: (se) => /* @__PURE__ */ a.jsx("div", { className: "flex flex-wrap items-center gap-x-[1.14rem] gap-y-[0.28571rem]", children: se.getValue().map(({ role: te, membership: fe }) => /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: "flex flex-wrap items-center gap-x-[0.28571rem]",
            children: [
              /* @__PURE__ */ a.jsx(tK, { status: fe.status, children: fe.displayName }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex-center h-[1.71rem] gap-x-[0.28571rem] rounded-full bg-mshop-gray-5 px-[0.57rem] text-mshop-black", children: [
                /* @__PURE__ */ a.jsx(A7e, { className: "size-[0.85714rem] text-mshop-black" }),
                te.displayName
              ] })
            ]
          },
          te.id
        )) }),
        size: n ? 400 : 894,
        enableSorting: !1
      })
    ],
    []
  ), K = Np({
    columns: H,
    data: (s == null ? void 0 : s.items) ?? B7e,
    getCoreRowModel: Cp(),
    getSortedRowModel: j5()
  }), Q = K.getRowModel().rows.length === 0, Z = ((s == null ? void 0 : s.totalPage) ?? 0) > 1;
  return s ? /* @__PURE__ */ a.jsxs(
    $i,
    {
      className: $(
        {
          "pb-[6.85714rem] pt-[2.29rem]": !n
        },
        {
          "px-[1.14rem] pt-[2.29rem]": n
        }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("flex items-center justify-between text-mshop-gray-80", {
              "w-full flex-col justify-start gap-y-[0.86rem]": n
            }),
            children: [
              !n && /* @__PURE__ */ a.jsxs("span", { className: "flex items-end gap-x-[0.2rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                " ",
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: `${s.totalCount}명` })
              ] }),
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $("flex items-center", {
                    "w-full justify-between gap-x-[0.57rem]": n
                  }),
                  children: [
                    /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $(
                          "flex items-center",
                          { "gap-x-[0.85714rem]": !n },
                          {
                            "w-full justify-between": n
                          }
                        ),
                        children: [
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $("flex-shrink-0", { "w-[5.71429rem]": n }),
                              children: "멤버십 플랜"
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            yp,
                            {
                              className: $(
                                { "w-[17.5rem]": !n },
                                { "w-full max-w-[14.8rem]": n }
                              ),
                              as: "div",
                              value: m,
                              onChange: D,
                              children: [
                                /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: (m == null ? void 0 : m.displayName) ?? "멤버십 플랜별로 보기" }) }),
                                /* @__PURE__ */ a.jsx(M1, { children: (X = s == null ? void 0 : s.memberships) == null ? void 0 : X.map(
                                  ({ id: se, displayName: te }) => /* @__PURE__ */ a.jsx(
                                    T1,
                                    {
                                      value: { id: se, displayName: te },
                                      isSelected: se === (m == null ? void 0 : m.id),
                                      children: /* @__PURE__ */ a.jsx("div", { className: "max-w-[13.125rem] truncate", children: te })
                                    },
                                    se
                                  )
                                ) })
                              ]
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "div",
                      {
                        className: $("flex items-center", {
                          "ml-2 gap-x-[1.14285rem]": !n
                        }),
                        children: /* @__PURE__ */ a.jsx(
                          "button",
                          {
                            type: "button",
                            className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                            onClick: I,
                            children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                          }
                        )
                      }
                    )
                  ]
                }
              ),
              n && /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m flex h-[2.85714rem] w-full items-end gap-x-[0.2rem] text-mshop-gray-80", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                " ",
                `${s.totalCount}명`
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "rounded-lg border border-mshop-gray-10",
              n ? "mt-[0.57142rem] w-full overflow-hidden" : "mt-[1.14285rem]",
              {
                "w-full overflow-x-auto scrollbar-hide": n && !Q
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !n
                    },
                    {
                      "w-[91.42857rem]": n
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: K.getHeaderGroups().map((se) => /* @__PURE__ */ a.jsx("tr", { children: se.headers.map((te) => /* @__PURE__ */ a.jsx(
                      "th",
                      {
                        className: "typo-mshop-kr-14-m h-[4rem] bg-mshop-gray-5 p-[0.57142rem] text-mshop-black",
                        style: {
                          width: te.getSize()
                        },
                        children: te.isPlaceholder ? null : /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.29rem]", children: [
                          Gi(
                            te.column.columnDef.header,
                            te.getContext()
                          ),
                          te.column.getCanSort() && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "block size-[0.85714rem]",
                              onClick: async () => {
                                await z({
                                  by: te.column.id
                                });
                              },
                              children: /* @__PURE__ */ a.jsx(t0, { className: "h-full w-full text-mshop-black" })
                            }
                          )
                        ] })
                      },
                      te.id
                    )) }, se.id)) }),
                    !Q && /* @__PURE__ */ a.jsx("tbody", { children: K.getRowModel().rows.map((se, te) => /* @__PURE__ */ a.jsx("tr", { children: se.getVisibleCells().map((fe) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: $(
                          "typo-mshop-kr-14-m h-[5.14285rem] px-[0.571rem] py-[0.29rem] text-mshop-gray-80",
                          { "border-t border-t-mshop-gray-5": te > 0 }
                        ),
                        style: {
                          width: fe.column.getSize()
                        },
                        children: Gi(
                          fe.column.columnDef.cell,
                          fe.getContext()
                        )
                      },
                      fe.id
                    )) }, se.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                Tw,
                {
                  isEmptyRows: Q,
                  description: "커뮤니티 회원 내역이 없습니다."
                }
              )
            ]
          }
        ),
        Z && /* @__PURE__ */ a.jsx("div", { className: "flex-center mt-[2.857rem]", children: /* @__PURE__ */ a.jsx(
          J2,
          {
            count: s.totalPage,
            onChange: L,
            page: b,
            showFirstButton: !0,
            showLastButton: !0,
            windowSize: n ? 5 : 10
          }
        ) })
      ]
    }
  ) : /* @__PURE__ */ a.jsx($i, {});
}
function _H(e) {
  return {
    membershipId: e == null ? void 0 : e.id
  };
}
const V7e = (e, t) => jn(
  "/management-membership-payments",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), $7e = Qt(null), G7e = () => {
  const [e, t] = Ar(
    $7e
  );
  return {
    membershipPayments: e,
    setMembershipPayments: t
  };
}, W7e = 10, Y7e = [], W7 = wp();
function q7e({ isFocusedTab: e }) {
  const { client: t } = Ha(), { projectId: n } = Tf(), {
    widgetCore: { toggleSpinner: r, isMobile: s, onError: o }
  } = Gt(), { setMembershipPayments: c, membershipPayments: u } = G7e(), [m, y] = Re(null), [b, w] = Re(null), [k, j] = Re(1), [E, T] = Re(
    ws.Desc
  ), D = async (ce) => {
    r(!0);
    const { code: pe, data: Se } = await V7e(
      {
        ...ce,
        page: ce.page ?? k,
        projectId: n,
        size: W7e
      },
      { client: t, onError: o }
    );
    if (r(!1), pe !== le.Success)
      return o(Ht);
    c(Se);
  }, L = _w();
  an(() => {
    !L || !e || (async () => (await D({
      page: 1
    }), y(null), w(null), j(1), T(ws.Desc)))();
  }, [e]);
  const I = async (ce) => {
    y(ce), await D({
      page: 1,
      ...GR(ce, b)
    });
  }, R = async (ce) => {
    w(ce), await D({
      page: 1,
      ...GR(m, ce)
    });
  }, U = async (ce, pe) => {
    j(pe), await D({
      page: pe,
      ...GR(
        m,
        b
      )
    });
  }, z = async () => {
    !m && !b || (y(null), w(null), await D({
      page: 1
    }));
  }, H = async () => {
    const ce = E === ws.Asc ? ws.Desc : ws.Asc;
    T(ce), await D({
      page: k,
      order: ce,
      membershipId: m == null ? void 0 : m.id
    });
  }, { setMembershipUserDetail: K } = N5(), q = async (ce) => {
    K({
      userId: ce,
      selectedTabIndex: 0
    });
  }, Q = dn(
    () => [
      W7.accessor("createdAt", {
        header: "결제일",
        cell: (ce) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: jt(ce.getValue(), "yyyy.MM.dd") }),
        size: s ? 112 : 128
      }),
      W7.accessor("user", {
        header: "마플샵 닉네임",
        cell: (ce) => {
          const pe = ce.getValue();
          return /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-start gap-x-[0.57142rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "h-[2.286rem] w-[2.286rem]", children: /* @__PURE__ */ a.jsx(Ql, { imageUrl: Xu(pe) }) }),
            /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "block underline",
                onClick: () => q(ce.row.original.user.id),
                disabled: pe.state === Sy.Delete,
                children: Mc(pe)
              }
            )
          ] });
        },
        size: 240
      }),
      W7.accessor("membership.displayName", {
        header: "멤버십 플랜",
        cell: (ce) => ce.getValue(),
        size: s ? 392 : 878
      }),
      W7.accessor("paymentState", {
        header: "결제 상태",
        cell: (ce) => I8(ce.getValue()),
        size: s ? 112 : 128
      }),
      W7.accessor("price", {
        header: "결제 금액",
        cell: (ce) => /* @__PURE__ */ a.jsxs("div", { className: "flex-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: nw(
            ce.getValue(),
            ce.row.original.paymentState
          ) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(ce.row.original.currency) })
        ] }),
        size: s ? 112 : 224
      })
    ],
    [s]
  ), Z = Np({
    columns: Q,
    data: (u == null ? void 0 : u.items) ?? Y7e,
    getCoreRowModel: Cp()
  });
  if (!u)
    return /* @__PURE__ */ a.jsx($i, {});
  const se = Z.getRowModel().rows.length === 0, te = u.totalPage > 1, fe = u.memberships.map(
    ({ displayName: ce, id: pe, memberCount: Se }) => ({
      id: pe,
      displayName: ce,
      memberCount: Se
    })
  );
  return /* @__PURE__ */ a.jsxs(
    $i,
    {
      className: $(
        {
          "pb-[6.85714rem] pt-[2.29rem]": !s
        },
        {
          "px-[1.14rem] pt-[2.29rem]": s
        }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("flex items-center justify-between text-mshop-gray-80", {
              "w-full": s
            }),
            children: [
              !s && /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-x-[0.2rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: `${u.totalCount}건` })
              ] }),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    { "flex items-center": !s },
                    { "w-full": s }
                  ),
                  children: /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: $(
                        "flex",
                        {
                          "items-center": !s
                        },
                        {
                          "flex-col gap-y-[0.86rem]": s
                        }
                      ),
                      children: [
                        /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $(
                              "flex items-center",
                              { "gap-x-[0.85714rem]": !s },
                              { "gap-x-[0.57rem]": s }
                            ),
                            children: [
                              /* @__PURE__ */ a.jsx(
                                "span",
                                {
                                  className: $("flex-shrink-0", { "w-[5.71429rem]": s }),
                                  children: "멤버십 플랜"
                                }
                              ),
                              /* @__PURE__ */ a.jsxs(
                                yp,
                                {
                                  className: $(
                                    { "w-[17.5rem]": !s },
                                    { "w-[18.2rem]": s }
                                  ),
                                  as: "div",
                                  value: m,
                                  onChange: I,
                                  children: [
                                    /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: (m == null ? void 0 : m.displayName) ?? "멤버십 플랜별로 보기" }) }),
                                    /* @__PURE__ */ a.jsx(M1, { children: fe.map(({ id: ce, displayName: pe }) => /* @__PURE__ */ a.jsx(
                                      T1,
                                      {
                                        value: { id: ce, displayName: pe },
                                        isSelected: ce === (m == null ? void 0 : m.id),
                                        children: /* @__PURE__ */ a.jsx("div", { className: "max-w-[13.125rem] truncate", children: pe })
                                      },
                                      ce
                                    )) })
                                  ]
                                }
                              )
                            ]
                          }
                        ),
                        /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $(
                              "flex items-center",
                              { "ml-7 gap-x-[0.85714rem]": !s },
                              { "gap-x-[0.57rem]": s }
                            ),
                            children: [
                              /* @__PURE__ */ a.jsx(
                                "span",
                                {
                                  className: $("flex-shrink-0", { "w-[5.71429rem]": s }),
                                  children: "결제 상태"
                                }
                              ),
                              /* @__PURE__ */ a.jsxs(
                                yp,
                                {
                                  className: $(
                                    { "w-[17.5rem]": !s },
                                    { "w-[14.8rem]": s }
                                  ),
                                  as: "div",
                                  value: b,
                                  onChange: R,
                                  children: [
                                    /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: b ? I8(b) : "결제 상태별로 보기" }) }),
                                    /* @__PURE__ */ a.jsx(M1, { children: Object.values(S1).map((ce, pe) => /* @__PURE__ */ a.jsx(
                                      T1,
                                      {
                                        value: ce,
                                        isSelected: b === ce,
                                        children: /* @__PURE__ */ a.jsx("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ a.jsx("div", { className: "max-w-[13.125rem] truncate", children: I8(ce) }) })
                                      },
                                      pe
                                    )) })
                                  ]
                                }
                              ),
                              s && /* @__PURE__ */ a.jsx(
                                "button",
                                {
                                  type: "button",
                                  className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                                  onClick: z,
                                  children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                                }
                              )
                            ]
                          }
                        ),
                        !s && /* @__PURE__ */ a.jsx("div", { className: "ml-2 flex items-center gap-x-[1.14285rem]", children: /* @__PURE__ */ a.jsx(
                          "button",
                          {
                            type: "button",
                            className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                            onClick: z,
                            children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                          }
                        ) }),
                        s && /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m flex h-[2.85714rem] w-full items-end gap-x-[0.2rem] text-mshop-gray-80", children: [
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: `${u.totalCount}건` })
                        ] })
                      ]
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "rounded-lg border border-mshop-gray-10",
              s ? "mt-[0.57142rem] w-full overflow-hidden" : "mt-[1.14285rem]",
              {
                "w-full overflow-x-auto scrollbar-hide": s && !se
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !s
                    },
                    {
                      "w-[52rem]": s
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: Z.getHeaderGroups().map((ce) => /* @__PURE__ */ a.jsx("tr", { children: ce.headers.map((pe) => /* @__PURE__ */ a.jsx(
                      "th",
                      {
                        className: "typo-mshop-kr-14-m h-[4rem] bg-mshop-gray-5 p-[0.57142rem] text-mshop-black",
                        style: s ? {
                          maxWidth: pe.getSize()
                        } : {
                          width: pe.getSize()
                        },
                        children: pe.isPlaceholder ? null : /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.71428rem]", children: [
                          Gi(
                            pe.column.columnDef.header,
                            pe.getContext()
                          ),
                          pe.column.id === "createdAt" && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "block h-[1.143rem] w-[1.143rem]",
                              onClick: H,
                              children: /* @__PURE__ */ a.jsx(t0, { className: "h-full w-full text-mshop-black" })
                            }
                          )
                        ] })
                      },
                      pe.id
                    )) }, ce.id)) }),
                    !se && /* @__PURE__ */ a.jsx("tbody", { children: Z.getRowModel().rows.map((ce, pe) => /* @__PURE__ */ a.jsx("tr", { children: ce.getVisibleCells().map((Se) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: $(
                          "typo-mshop-kr-14-m h-[5.14285rem] px-[0.571rem] py-[0.29rem] text-mshop-gray-80",
                          { "border-t border-t-mshop-gray-5": pe > 0 }
                        ),
                        style: s ? {
                          maxWidth: Se.column.getSize()
                        } : {
                          width: Se.column.getSize()
                        },
                        children: Gi(
                          Se.column.columnDef.cell,
                          Se.getContext()
                        )
                      },
                      Se.id
                    )) }, ce.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                Tw,
                {
                  isEmptyRows: se,
                  description: "멤버십 결제 내역이 없습니다."
                }
              )
            ]
          }
        ),
        te && /* @__PURE__ */ a.jsx("div", { className: "flex-center mt-[2.857rem]", children: /* @__PURE__ */ a.jsx(
          J2,
          {
            count: u.totalPage,
            onChange: U,
            page: k,
            showFirstButton: !0,
            showLastButton: !0,
            windowSize: s ? 5 : 10
          }
        ) })
      ]
    }
  );
}
function GR(e, t) {
  return {
    membershipId: e == null ? void 0 : e.id,
    ...t ? { state: t } : {}
  };
}
const n5 = async ({
  url: e,
  init: t,
  filename: n,
  onDownloadFailed: r
}) => fetch(e, t).then((s) => s.blob()).then((s) => {
  const o = document.createElement("a");
  o.href = URL.createObjectURL(s), o.download = n, o.click(), o.remove(), URL.revokeObjectURL(e);
}).catch(r), K7e = async ({
  filename: e,
  onDownloadFailed: t,
  ...n
}, { client: r }) => {
  const s = I2({
    accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "Content-Type": "application/json",
    referrerPolicy: "no-referrer-when-downgrade",
    credentials: "include",
    cache: "no-store",
    "x-api-key": await r.getToken()
  });
  return n5({
    url: `${r.getOrigin()}/management-membership-users-export`,
    filename: e,
    init: {
      method: "POST",
      headers: s,
      body: JSON.stringify({
        ...I2(n),
        format: "xlsx"
      })
    },
    onDownloadFailed: t
  });
}, X7e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_14026_123775)" }, /* @__PURE__ */ re.createElement("path", { d: "M17.5979 9.98073C17.1979 9.98073 16.8646 10.3057 16.8646 10.7141V16.5724C16.8646 16.7391 16.6812 16.8807 16.4646 16.8807H3.52292C3.30625 16.8807 3.12292 16.7391 3.12292 16.5724V10.7141C3.12292 10.3141 2.79792 9.98073 2.38958 9.98073C1.98125 9.98073 1.65625 10.3057 1.65625 10.7141V16.5724C1.65625 17.5474 2.48958 18.3391 3.51458 18.3391H16.4563C17.4812 18.3391 18.3146 17.5474 18.3146 16.5724V10.7141C18.3146 10.3141 17.9896 9.98073 17.5813 9.98073H17.5979Z" }), /* @__PURE__ */ re.createElement("path", { d: "M9.48125 13.5974C9.54792 13.6641 9.63125 13.7141 9.71458 13.7557C9.80625 13.7891 9.89792 13.8141 9.99792 13.8141C10.0979 13.8141 10.1896 13.7974 10.2812 13.7557C10.3729 13.7224 10.4479 13.6641 10.5146 13.5974L13.2312 10.8807C13.5146 10.5974 13.5146 10.1307 13.2312 9.8474C12.9479 9.56406 12.4812 9.56406 12.1979 9.8474L10.7312 11.3141V2.3974C10.7312 1.9974 10.4062 1.66406 9.99792 1.66406C9.58958 1.66406 9.26458 1.98906 9.26458 2.3974V11.3307L7.79792 9.86406C7.51458 9.58073 7.04792 9.58073 6.76458 9.86406C6.48125 10.1474 6.48125 10.6141 6.76458 10.8974L9.48125 13.6141V13.5974Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_14026_123775" }, /* @__PURE__ */ re.createElement("rect", { width: 20, height: 20 })))), z3 = yn(X7e), Q7e = () => {
  const [e, t] = Ar(
    Iq
  );
  if (e === Vn)
    throw new Error(Xr(ia.MembershipSupport));
  return {
    managementMembershipUsers: e,
    setManagementMembershipUsers: t
  };
}, TH = (e) => e === U3.Joined ? "가입중" : "가입 해지", Z7e = 10, WR = wp();
function J7e({ isFocusedTab: e }) {
  const { client: t } = Ha(), {
    widgetCore: { toggleSpinner: n, isMobile: r, onError: s }
  } = Gt(), { managementMembershipUsers: o, setManagementMembershipUsers: c } = Q7e(), { projectId: u } = Tf(), m = o.memberships.map(
    ({ displayName: te, id: fe, memberCount: ce }) => ({
      id: fe,
      displayName: te,
      memberCount: ce
    })
  ), [y, b] = Re(null), [w, k] = Re(null), [j, E] = Re(1), T = async (te) => {
    n(!0);
    const { code: fe, data: ce } = await Lq(
      {
        ...te,
        size: Z7e,
        projectId: u
      },
      { client: t, onError: s }
    );
    if (n(!1), fe !== le.Success)
      return s(Ht);
    c(ce);
  }, D = _w();
  an(() => {
    !D || !e || (async () => (await T({
      page: 1
    }), b(null), k(null), E(1)))();
  }, [e]);
  const L = async (te) => {
    b(te), await T({
      page: j,
      ...YR(te, w)
    });
  }, I = async (te) => {
    k(te), await T({
      page: j,
      ...YR(y, te)
    });
  }, R = async (te, fe) => {
    E(fe), await T({
      page: fe,
      ...YR(y, w)
    });
  }, U = async () => {
    !y && !w || (b(null), k(null), await T({
      page: 1
    }));
  }, { setMembershipUserDetail: z } = N5(), H = async (te) => {
    z({
      userId: te,
      selectedTabIndex: 0
    });
  }, K = async () => {
    await K7e(
      {
        projectId: u,
        membershipId: y == null ? void 0 : y.id,
        ...w ? { membershipStatus: w } : {},
        filename: `${jt(/* @__PURE__ */ new Date(), "yyyyMMdd")}_membership_members.xlsx`,
        onDownloadFailed: () => {
          en({
            body: (te) => /* @__PURE__ */ a.jsx(
              sa,
              {
                button: {
                  props: te
                },
                children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.86rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: "다운로드 실패" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                    "파일 다운로드에 실패했습니다.",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "다시 시도해주세요."
                  ] })
                ] })
              }
            )
          });
        }
      },
      {
        client: t
      }
    );
  }, q = dn(
    () => [
      WR.accessor("user", {
        header: "마플샵 닉네임",
        cell: (te) => {
          const fe = te.getValue();
          return /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-start gap-x-[0.57142rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "h-[2.286rem] w-[2.286rem] flex-shrink-0", children: /* @__PURE__ */ a.jsx(Ql, { imageUrl: Xu(fe) }) }),
            /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "block underline",
                onClick: () => H(te.row.original.id),
                disabled: fe.state === Sy.Delete,
                children: Mc(fe)
              }
            )
          ] });
        },
        size: r ? 176 : 240
      }),
      WR.accessor("memberships", {
        header: "멤버십 플랜",
        cell: (te) => /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $(
              "flex flex-wrap items-center gap-x-[0.571rem] gap-y-[0.571rem]",
              {
                "justify-center": !r
              },
              {
                "justify-start": r
              }
            ),
            children: te.row.original.memberships.map(
              ({ id: fe, status: ce, displayName: pe }) => /* @__PURE__ */ a.jsx(tK, { status: ce, children: pe }, fe)
            )
          }
        ),
        size: r ? 680 : 1134
      }),
      WR.accessor("totalPrice", {
        header: "총 결제 금액",
        cell: (te) => /* @__PURE__ */ a.jsxs("div", { className: "flex-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: te.getValue().toLocaleString() }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(te.row.original.currency) })
        ] }),
        size: r ? 112 : 240
      })
    ],
    []
  ), Q = Np({
    columns: q,
    data: o.items,
    getCoreRowModel: Cp()
  }), X = Q.getRowModel().rows.length === 0, se = o.totalPage > 1;
  return /* @__PURE__ */ a.jsxs(
    $i,
    {
      className: $(
        {
          "pb-[6.85714rem] pt-[2.29rem]": !r
        },
        {
          "px-[1.14rem] pt-[2.29rem]": r
        }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("flex items-center justify-between text-mshop-gray-80"),
            children: [
              !r && /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-x-[0.2rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: `${o.totalCount}명` })
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: $({ "flex items-center": !r }), children: /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    "flex",
                    {
                      "items-center": !r
                    },
                    {
                      "flex-col gap-y-[0.86rem]": r
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $(
                          "flex items-center",
                          { "gap-x-[0.85714rem]": !r },
                          { "gap-x-[0.57rem]": r }
                        ),
                        children: [
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $("flex-shrink-0", { "w-[5.71429rem]": r }),
                              children: "멤버십 플랜"
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            yp,
                            {
                              className: $(
                                { "w-[17.5rem]": !r },
                                { "w-[18.2rem]": r }
                              ),
                              as: "div",
                              value: y,
                              onChange: L,
                              children: [
                                /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: (y == null ? void 0 : y.displayName) ?? "멤버십 플랜별로 보기" }) }),
                                /* @__PURE__ */ a.jsx(M1, { children: m.map(({ id: te, displayName: fe }) => /* @__PURE__ */ a.jsx(
                                  T1,
                                  {
                                    value: { id: te, displayName: fe },
                                    isSelected: te === (y == null ? void 0 : y.id),
                                    children: /* @__PURE__ */ a.jsx("div", { className: "max-w-[13.125rem] truncate", children: fe })
                                  },
                                  te
                                )) })
                              ]
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $(
                          "flex items-center",
                          { "ml-7 gap-x-[0.85714rem]": !r },
                          { "gap-x-[0.57rem]": r }
                        ),
                        children: [
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $("flex-shrink-0", { "w-[5.71429rem]": r }),
                              children: "멤버십 상태"
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            yp,
                            {
                              className: $(
                                { "w-[17.5rem]": !r },
                                { "w-[14.8rem]": r }
                              ),
                              as: "div",
                              value: w,
                              onChange: I,
                              children: [
                                /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: w ? TH(w) : "멤버십 상태별로 보기" }) }),
                                /* @__PURE__ */ a.jsx(M1, { children: o.membershipStates.map(
                                  ({ id: te, status: fe }) => /* @__PURE__ */ a.jsx(
                                    T1,
                                    {
                                      value: fe,
                                      isSelected: fe === w,
                                      children: /* @__PURE__ */ a.jsx("div", { className: "max-w-[13.125rem] truncate", children: TH(fe) })
                                    },
                                    te
                                  )
                                ) })
                              ]
                            }
                          ),
                          r && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                              onClick: U,
                              children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                            }
                          )
                        ]
                      }
                    ),
                    !r && /* @__PURE__ */ a.jsxs("div", { className: "ml-2 flex items-center gap-x-[1.14285rem]", children: [
                      !r && /* @__PURE__ */ a.jsx(
                        "button",
                        {
                          type: "button",
                          className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                          onClick: U,
                          children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                        }
                      ),
                      /* @__PURE__ */ a.jsx(
                        za,
                        {
                          variant: "sm",
                          theme: "lineGray",
                          type: "button",
                          onClick: K,
                          children: /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.286rem]", children: [
                            /* @__PURE__ */ a.jsx(z3, { className: "h-[1.429rem] w-[1.429rem]" }),
                            " 엑셀 다운로드"
                          ] })
                        }
                      )
                    ] }),
                    r && /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m flex h-[2.85714rem] w-full items-end gap-x-[0.2rem] text-mshop-gray-80", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: `${o.totalCount}명` })
                    ] })
                  ]
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "rounded-lg border border-mshop-gray-10",
              r ? "mt-[0.57142rem] w-full overflow-hidden" : "mt-[1.14285rem]",
              {
                "w-full overflow-x-auto scrollbar-hide": r && !X
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !r
                    },
                    {
                      "w-[69.14285rem]": r
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: Q.getHeaderGroups().map((te) => /* @__PURE__ */ a.jsx("tr", { children: te.headers.map((fe) => /* @__PURE__ */ a.jsx(
                      "th",
                      {
                        className: "typo-mshop-kr-14-m h-[4rem] bg-mshop-gray-5 p-[0.57142rem] text-mshop-black",
                        style: r ? {
                          maxWidth: fe.getSize()
                        } : {
                          width: fe.getSize()
                        },
                        children: fe.isPlaceholder ? null : Gi(
                          fe.column.columnDef.header,
                          fe.getContext()
                        )
                      },
                      fe.id
                    )) }, te.id)) }),
                    !X && /* @__PURE__ */ a.jsx("tbody", { children: Q.getRowModel().rows.map((te, fe) => /* @__PURE__ */ a.jsx("tr", { children: te.getVisibleCells().map((ce) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: $(
                          "typo-mshop-kr-14-m h-[5.14285rem] px-[0.571rem] py-[0.29rem] text-mshop-gray-80",
                          { "border-t border-t-mshop-gray-5": fe > 0 }
                        ),
                        style: r ? {
                          maxWidth: ce.column.getSize()
                        } : {
                          width: ce.column.getSize()
                        },
                        children: Gi(
                          ce.column.columnDef.cell,
                          ce.getContext()
                        )
                      },
                      ce.id
                    )) }, te.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                Tw,
                {
                  isEmptyRows: X,
                  description: "멤버십 회원이 없습니다."
                }
              )
            ]
          }
        ),
        se && /* @__PURE__ */ a.jsx("div", { className: "flex-center mt-[2.857rem]", children: /* @__PURE__ */ a.jsx(
          J2,
          {
            count: o.totalPage,
            onChange: R,
            page: j,
            showFirstButton: !0,
            showLastButton: !0,
            windowSize: r ? 5 : 10
          }
        ) })
      ]
    }
  );
}
function YR(e, t) {
  return {
    membershipId: e == null ? void 0 : e.id,
    ...t ? { membershipStatus: t } : {}
  };
}
const e3e = (e, t) => jn(
  "/management-membership-product-statements",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), t3e = Qt(null), n3e = () => {
  const [
    e,
    t
  ] = Ar(t3e);
  return {
    managementMembershipProductStatements: e,
    setManagementMembershipProductStatements: t
  };
}, m2 = wp(), r3e = [];
function a3e({ isFocusedTab: e }) {
  const {
    widgetCore: { toggleSpinner: t, isMobile: n, onError: r }
  } = Gt(), { client: s } = Ha(), { projectId: o } = Tf(), {
    managementMembershipProductStatements: c,
    setManagementMembershipProductStatements: u
  } = n3e(), { setMembershipUserDetail: m } = N5(), [y, b] = Re(
    ws.Desc
  ), [w, k] = Re(1), [j, E] = Re(null), [T, D] = Re(null), L = _w();
  an(() => {
    !L || !e || (async () => (await I({
      page: 1,
      reset: !0
    }), b(ws.Desc), k(1), E(null), D(null)))();
  }, [e]);
  const I = async ({
    page: fe = w,
    order: ce = y,
    goodsTypeId: pe = T,
    membershipId: Se,
    reset: oe = !1
  }) => {
    t(!0);
    const { code: ue, data: he } = await e3e(
      {
        projectId: o,
        size: 10,
        page: fe,
        ...oe ? {
          sort: {
            order: "desc",
            by: "orderedAt"
          }
        } : {
          ...pe ? { goodsTypeId: pe } : {},
          membershipId: Se ?? (j == null ? void 0 : j.id),
          sort: {
            order: ce,
            by: "orderedAt"
          }
        }
      },
      { client: s, onError: r }
    );
    if (t(!1), ue !== le.Success)
      return r(Ht);
    u(he);
  }, R = async (fe) => {
    D(fe), k(1), await I({
      ...j != null && j.id ? { membershipId: j == null ? void 0 : j.id } : {},
      order: y,
      page: 1,
      goodsTypeId: fe
    });
  }, U = async (fe) => {
    wt(fe), E(fe), k(1), await I({
      membershipId: fe.id,
      page: 1
    });
  }, z = async (fe, ce) => {
    k(ce), await I({
      membershipId: j == null ? void 0 : j.id,
      page: ce
    });
  }, H = async () => {
    const fe = y === ws.Asc ? ws.Desc : ws.Asc;
    b(fe), await I({
      order: fe
    });
  }, K = async () => {
    E(null), b(ws.Desc), k(1), D(null), await I({
      page: 1,
      order: ws.Desc,
      reset: !0
    });
  }, q = (fe) => {
    m({
      userId: fe,
      selectedTabIndex: 1
    });
  }, Q = dn(
    () => [
      m2.accessor("orderedAt", {
        header: "주문일시",
        cell: (fe) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: jt(fe.getValue(), "yyyy.MM.dd") }),
        size: n ? 112 : 128
      }),
      m2.accessor("sid", {
        header: "주문번호",
        cell: (fe) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-r", children: fe.getValue() }),
        size: n ? 112 : 128
      }),
      m2.accessor("user", {
        header: "마플샵 닉네임",
        cell: (fe) => {
          const ce = fe.getValue();
          return /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-start gap-x-[0.57142rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "h-[2.286rem] w-[2.286rem]", children: /* @__PURE__ */ a.jsx(Ql, { imageUrl: Xu(ce) }) }),
            /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "block underline",
                onClick: () => q(fe.row.original.user.id),
                disabled: ce.state === Sy.Delete,
                children: Mc(ce)
              }
            )
          ] });
        },
        size: n ? 176 : 240
      }),
      m2.accessor("membership.displayName", {
        header: "멤버십 플랜",
        cell: (fe) => /* @__PURE__ */ a.jsx($q, { variant: "black", children: fe.getValue() }),
        size: n ? 176 : 240
      }),
      m2.accessor(
        ({ goodsTypeId: fe, product: { isTpl: ce } }) => ({ goodsTypeId: fe, isTpl: ce }),
        {
          header: "상품 종류",
          cell: (fe) => /* @__PURE__ */ a.jsx(eK, { ...fe.getValue() }),
          size: n ? 112 : 128
        }
      ),
      m2.accessor("product", {
        header: "상품명",
        cell: (fe) => {
          const ce = fe.getValue();
          return /* @__PURE__ */ a.jsxs(
            "a",
            {
              href: ce.link,
              className: "flex items-center gap-x-[0.85714rem]",
              children: [
                /* @__PURE__ */ a.jsx("div", { className: "flex-center size-[2.85714rem] flex-shrink-0 overflow-hidden rounded-[0.29rem] bg-mshop-gray-5", children: /* @__PURE__ */ a.jsx(
                  "img",
                  {
                    src: ce.image,
                    className: "aspect-square object-cover",
                    style: {
                      width: `${ce.imageRatio}%`
                    },
                    alt: ""
                  }
                ) }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m truncate text-mshop-gray-80 underline", children: ce.name })
              ]
            }
          );
        },
        size: n ? 248 : 486
      }),
      m2.accessor("quantity", {
        header: "수량",
        cell: (fe) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: fe.getValue() }),
        size: 40
      }),
      m2.accessor("product.price", {
        header: "상품 금액",
        cell: (fe) => /* @__PURE__ */ a.jsxs("div", { className: "flex-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: fe.getValue().toLocaleString() }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(V2.Krw) })
        ] }),
        size: n ? 112 : 240
      })
    ],
    []
  ), Z = Np({
    columns: Q,
    data: (c == null ? void 0 : c.items) ?? r3e,
    getCoreRowModel: Cp()
  }), se = Z.getRowModel().rows.length === 0, te = ((c == null ? void 0 : c.totalPage) ?? 0) > 1;
  return c ? /* @__PURE__ */ a.jsxs(
    $i,
    {
      className: $(
        {
          "pb-[6.85714rem] pt-[2.29rem]": !n
        },
        {
          "px-[1.14rem] pt-[2.29rem]": n
        }
      ),
      unmount: !0,
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("flex items-center justify-between text-mshop-gray-80", {
              "w-full flex-col justify-start gap-y-[0.86rem]": n
            }),
            children: [
              !n && /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-x-[0.2rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: `${c.totalCount}건` })
              ] }),
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $("flex items-center", {
                    "w-full flex-col gap-x-[0.86rem] gap-y-[0.86rem]": n
                  }),
                  children: [
                    /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $("flex items-center gap-x-[0.57rem]", {
                          "w-full": n
                        }),
                        children: [
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $("flex-shrink-0", { "w-[5.71429rem]": n }),
                              children: "멤버십 플랜"
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            yp,
                            {
                              className: $(
                                { "w-[17.5rem]": !n },
                                { "w-full max-w-[18.2rem]": n }
                              ),
                              as: "div",
                              value: j,
                              onChange: U,
                              children: [
                                /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: (j == null ? void 0 : j.displayName) ?? "멤버십 플랜별로 보기" }) }),
                                /* @__PURE__ */ a.jsx(M1, { children: c.memberships.map(
                                  ({ id: fe, displayName: ce }) => /* @__PURE__ */ a.jsx(
                                    T1,
                                    {
                                      value: { id: fe, displayName: ce },
                                      isSelected: (j == null ? void 0 : j.id) === fe,
                                      children: ce
                                    },
                                    fe
                                  )
                                ) })
                              ]
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $(
                          "flex items-center",
                          { "ml-7 ml-[1.71428rem] gap-x-[0.85714rem]": !n },
                          { "w-full gap-x-[0.57rem]": n }
                        ),
                        children: [
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $("flex-shrink-0", { "w-[5.71429rem]": n }),
                              children: "상품 종류"
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            yp,
                            {
                              className: $(
                                { "w-[17.5rem]": !n },
                                { "w-full max-w-[14.8rem]": n }
                              ),
                              as: "div",
                              value: T,
                              onChange: R,
                              children: [
                                /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: T ? xP(T, !1) : "상품 종류별로 보기" }) }),
                                /* @__PURE__ */ a.jsx(M1, { children: Object.values(P2).map((fe) => /* @__PURE__ */ a.jsx(
                                  T1,
                                  {
                                    value: fe,
                                    isSelected: T === fe,
                                    children: xP(fe, !1)
                                  },
                                  fe
                                )) })
                              ]
                            }
                          ),
                          n && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                              onClick: K,
                              children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                            }
                          )
                        ]
                      }
                    ),
                    !n && /* @__PURE__ */ a.jsx("div", { className: "ml-2 flex items-center gap-x-[1.14285rem]", children: /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        type: "button",
                        className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                        onClick: K,
                        children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                      }
                    ) })
                  ]
                }
              ),
              n && /* @__PURE__ */ a.jsxs("span", { className: "flex h-[2.86rem] w-full items-end gap-x-[0.2rem] text-mshop-gray-80", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: `${c.totalCount}건` })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "rounded-lg border border-mshop-gray-10",
              n ? "mt-[0.57142rem] w-full overflow-hidden" : "mt-[1.14285rem]",
              {
                "w-full overflow-x-auto scrollbar-hide": n && !se
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !n
                    },
                    {
                      "w-[69.71428rem]": n
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: Z.getHeaderGroups().map((fe) => /* @__PURE__ */ a.jsx("tr", { children: fe.headers.map((ce) => /* @__PURE__ */ a.jsx(
                      "th",
                      {
                        className: "typo-mshop-kr-14-m h-[4rem] bg-mshop-gray-5 p-[0.57142rem] text-mshop-black",
                        style: {
                          width: ce.getSize()
                        },
                        children: ce.isPlaceholder ? null : /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.71428rem]", children: [
                          Gi(
                            ce.column.columnDef.header,
                            ce.getContext()
                          ),
                          ce.column.id === "orderedAt" && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "block h-[1.143rem] w-[1.143rem]",
                              onClick: H,
                              children: /* @__PURE__ */ a.jsx(t0, { className: "h-full w-full text-mshop-black" })
                            }
                          )
                        ] })
                      },
                      ce.id
                    )) }, fe.id)) }),
                    !se && /* @__PURE__ */ a.jsx("tbody", { children: Z.getRowModel().rows.map((fe, ce) => /* @__PURE__ */ a.jsx("tr", { children: fe.getVisibleCells().map((pe) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: $(
                          "typo-mshop-kr-14-m h-[5.14285rem] px-[0.571rem] py-[0.29rem] text-mshop-gray-80",
                          { "border-t border-t-mshop-gray-5": ce > 0 }
                        ),
                        style: {
                          width: pe.column.getSize(),
                          maxWidth: pe.id.includes("_product") ? pe.column.getSize() : "none"
                        },
                        children: Gi(
                          pe.column.columnDef.cell,
                          pe.getContext()
                        )
                      },
                      pe.id
                    )) }, fe.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                Tw,
                {
                  isEmptyRows: se,
                  description: "상품 주문 내역이 없습니다."
                }
              )
            ]
          }
        ),
        te && /* @__PURE__ */ a.jsx("div", { className: "flex-center mt-[2.857rem]", children: /* @__PURE__ */ a.jsx(
          J2,
          {
            count: c.totalPage,
            onChange: z,
            page: w,
            showFirstButton: !0,
            showLastButton: !0,
            windowSize: n ? 5 : 10
          }
        ) })
      ]
    }
  ) : /* @__PURE__ */ a.jsx($i, {});
}
const nK = (e, t) => jn(
  "/commission-request",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), s3e = (e, t) => jn(
  "/management-commissions",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), i3e = (e, t) => jn(
  "/management-commission-status",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), Ln = {
  /**
   * 수락 대기
   * */
  Pending: "PENDING",
  /**
   * 작업 중
   * */
  Accepted: "ACCEPTED",
  /**
   * 작업 완료
   * */
  TaskDone: "TASK_DONE",
  /**
   * 구매 확정
   * */
  End: "END",
  /**
   * 취소/환불 (신청 취소, 신청 거절, 환불)
   * */
  Refunded: "REFUNDED",
  /**
   * 환불 예정
   * */
  OnRefund: "ON_REFUND"
}, bP = Qt(null), o3e = Qt(
  null,
  (e, t, n) => {
    const r = e(bP);
    wt(r), t(bP, {
      ...r,
      dueDate: n.updatedDueDate,
      updatedDueDate: r.dueDate
    });
  }
), f_ = () => {
  const [e, t] = Ar(
    bP
  ), n = Ka(o3e);
  return {
    commissionRequest: e,
    setCommissionRequest: t,
    setUpdatedDueDate: n
  };
}, ym = Qt(
  null
), l3e = Qt(
  null,
  (e, t, n) => {
    const r = e(ym);
    wt(r), t(ym, {
      ...r,
      items: r.items.map((s) => s.id === n.commissionId ? {
        ...s,
        request: {
          ...s.request,
          state: n.nextState
        }
      } : s)
    });
  }
), c3e = Qt(
  null,
  (e, t, n) => {
    const r = e(ym);
    wt(r), t(ym, {
      ...r,
      items: r.items.map((s) => s.id === n.commissionId ? {
        ...s,
        request: {
          ...s.request,
          state: s.commissionFiles.filter(
            (o) => o.file
          ).length == 1 ? Ln.Accepted : s.request.state
        },
        commissionFiles: s.commissionFiles.map((o) => o.id === n.commissionFileId ? {
          ...o,
          file: null
        } : o)
      } : s)
    });
  }
), u3e = Qt(
  null,
  (e, t, n) => {
    const r = e(ym);
    wt(r), t(ym, {
      ...r,
      items: r.items.map((s) => s.id === n.commissionId ? {
        ...s,
        request: {
          ...s.request,
          state: s.request.state === Ln.Accepted ? Ln.TaskDone : s.request.state
        },
        commissionFiles: [n.commissionFile, ...s.commissionFiles]
      } : s)
    });
  }
), d3e = Qt(
  null,
  (e, t, n) => {
    const r = e(ym);
    wt(r), t(ym, {
      ...r,
      items: r.items.map((s) => s.request.id === n.commissionRequestId ? {
        ...s,
        request: {
          ...s.request,
          dueDate: n.nextDueDate,
          updatedDueDate: s.request.dueDate
        }
      } : s)
    });
  }
), f3e = Qt(
  null,
  (e, t, n) => {
    const r = e(ym);
    wt(r), t(ym, {
      ...r,
      items: r.items.map((s) => s.request.id === n.commissionRequestId ? {
        ...s,
        request: {
          ...s.request,
          state: Ln.OnRefund
        }
      } : s)
    });
  }
), m3e = Qt(
  null,
  (e, t, n) => {
    const r = e(ym);
    wt(r), t(ym, {
      ...r,
      items: r.items.map((s) => s.request.id === n.commissionRequestId ? {
        ...s,
        request: {
          ...s.request,
          isRead: n.nextIsRead
        }
      } : s)
    });
  }
), h3e = Qt(
  null,
  (e, t, n) => {
    const r = e(ym);
    wt(r), t(ym, {
      ...r,
      items: r.items.map((s) => s.id === n.commissionId ? (wt(s.inquiry), {
        ...s,
        inquiry: {
          ...s.inquiry,
          isRead: n.nextIsRead
        }
      }) : s)
    });
  }
), T6 = () => {
  const [e, t] = Ar(
    ym
  ), n = Ka(u3e), r = Ka(
    c3e
  ), s = Ka(
    l3e
  ), o = Ka(
    d3e
  ), c = Ka(
    m3e
  ), u = Ka(
    h3e
  ), m = Ka(
    f3e
  );
  return {
    managementCommissions: e,
    setManagementCommissions: t,
    getCommissionByCommissionItemId: (k) => e == null ? void 0 : e.items.find((j) => j.id === k),
    setCommission: (k) => {
      wt(e), t({
        ...e,
        items: e.items.map((j) => j.id === k.id ? k : j)
      });
    },
    addCommissionFile: n,
    removeCommissionFile: r,
    setCommissionRequestState: s,
    acceptCommissionWithDueDate: ({
      commissionRequestId: k,
      dueDate: j
    }) => {
      wt(e), t({
        ...e,
        items: e.items.map((E) => E.request.id === k ? {
          ...E,
          request: {
            ...E.request,
            state: Ln.Accepted,
            dueDate: j
          }
        } : E)
      });
    },
    setCommissionDueDate: o,
    setCommissionRejection: m,
    setApplicationIsRead: c,
    setInquiryIsRead: u
  };
}, A2 = Qt(null), p3e = Qt(
  null,
  (e, t, n) => {
    const r = e(A2);
    wt(r), n.upload ? t(A2, {
      ...r,
      TASK_DONE: (r.TASK_DONE ?? 0) + 1,
      ACCEPTED: (r.ACCEPTED ?? 0) - 1
    }) : t(A2, {
      ...r,
      TASK_DONE: (r.TASK_DONE ?? 0) - 1,
      ACCEPTED: (r.ACCEPTED ?? 0) + 1
    });
  }
), g3e = Qt(
  null,
  (e, t) => {
    const n = e(A2);
    wt(n), t(A2, {
      ...n,
      PENDING: n.PENDING - 1,
      ACCEPTED: (n.ACCEPTED ?? 0) + 1
    });
  }
), y3e = Qt(
  null,
  (e, t) => {
    const n = e(A2);
    wt(n), t(A2, {
      ...n,
      PENDING: n.PENDING - 1,
      ON_REFUND: (n.ON_REFUND ?? 0) + 1
    });
  }
), m_ = () => {
  const [e, t] = Ar(
    A2
  ), n = Ka(
    p3e
  ), r = Ka(
    g3e
  ), s = Ka(
    y3e
  );
  return {
    managementCommissionStatus: e,
    setManagementCommissionStatus: t,
    setManagementCommissionStatusCountsAtom: n,
    setManagementCommissionStatusAcceptingToInProgress: r,
    setManagementCommissionStatusInProgressToOnRefunded: s
  };
}, f9 = (e) => {
  switch (e) {
    case Ln.Pending:
      return "수락 대기";
    case Ln.Accepted:
      return "작업 중";
    case Ln.TaskDone:
      return "작업 완료";
    case Ln.Refunded:
      return "취소/환불";
    case Ln.End:
      return "구매 확정";
    case Ln.OnRefund:
      return "환불 예정";
    default:
      throw new Error(`Does not Exist planState: ${e}`);
  }
}, v3e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M13.69 2H5.27C4.29 2 3.5 2.79 3.5 3.77V20.23C3.5 21.21 4.29 22 5.27 22H18.73C19.71 22 20.5 21.21 20.5 20.23V8.81L13.69 2ZM13.69 4.47L18.03 8.81H13.69V4.47Z" })), SP = yn(v3e);
function rw(e) {
  const t = e.lastIndexOf(".");
  return t !== -1 && e.substring(t + 1).length < 5 ? e.substring(0, t) : e;
}
function aw(e) {
  return e.includes("/") ? e.split("/")[1] : e;
}
const x3e = {
  [Ln.Pending]: "bg-mshop-gray-5 text-mshop-gray-80",
  [Ln.TaskDone]: "bg-mshop-gray-5 text-mshop-gray-80",
  [Ln.End]: "bg-mshop-gray-5 text-mshop-gray-80",
  [Ln.Accepted]: "bg-mshop-blue-10 text-mshop-blue-100",
  [Ln.Refunded]: "bg-mshop-red-10 text-mshop-red-80",
  [Ln.OnRefund]: "bg-mshop-red-10 text-mshop-red-80"
};
function rK({ state: e }) {
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      className: $(
        "typo-mshop-kr-12-m inline-flex h-[1.71rem] items-center justify-center rounded-[0.28571rem] px-[0.57143rem]",
        x3e[e]
      ),
      children: f9(e)
    }
  );
}
function aK({
  isClient: e = !1,
  onAcceptButtonClick: t = Gd,
  onRejectButtonClick: n = Gd,
  onDueDateChangeButtonClick: r = Gd,
  onClose: s
}) {
  const { commissionRequest: o } = f_();
  wt(o);
  const {
    widgetCore: { isMobile: c }
  } = Gt(), [u, m] = Re(!1), y = dn(() => e || o.state == Ln.OnRefund || o.state == Ln.Refunded || o.state == Ln.End || o.updatedDueDate != null ? !1 : !!(o.dueDate && o.acceptDate && Uv(
    Q4(new Date(o.dueDate)),
    E3(Q4(o.acceptDate), 89)
  )), [o]), b = o.state === Ln.Refunded || o.state === Ln.OnRefund, w = () => {
    e || (wt(o.dueDate), wt(o.acceptDate), r({
      commissionRequestId: o.id,
      initialDueDate: o.dueDate,
      acceptDate: o.acceptDate
    }));
  };
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $(
        "flex flex-col bg-mshop-white text-mshop-gray-80",
        { "w-[65.71429rem] rounded-[1rem]": !c },
        { "h-full w-full overflow-hidden": c }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "header",
          {
            className: $(
              "flex items-center border-b border-b-mshop-gray-5 p-[1.14rem]",
              { "justify-between": !c },
              {
                "absolute left-0 top-0 z-10 h-[4rem] w-full justify-center bg-mshop-white px-[1.14rem]": c
              }
            ),
            children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "커미션 신청서" }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  onClick: s,
                  type: "button",
                  className: $("block", {
                    "absolute right-[1.14rem] top-1/2 -translate-y-1/2": c
                  }),
                  children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.429rem] fill-mshop-black" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "relative overflow-y-auto",
              { "typo-mshop-kr-16-m h-[41.12rem] p-[1.14rem]": !c },
              {
                "typo-mshop-kr-14-m px-[1.14rem] pb-[6.28571rem] pt-[5.14rem] scrollbar-hide": c
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs("ul", { className: "flex flex-col gap-y-[0.86rem] border-b border-b-mshop-gray-10 pb-[0.86rem]", children: [
                /* @__PURE__ */ a.jsxs("li", { className: "flex gap-x-[1.71rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "w-[6.85714rem] flex-shrink-0 text-mshop-black",
                        { "typo-mshop-kr-16-b": !c },
                        { "typo-mshop-kr-14-b": c }
                      ),
                      children: "닉네임"
                    }
                  ),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.57142rem]", children: [
                    /* @__PURE__ */ a.jsx("div", { className: "size-[1.71rem] flex-shrink-0", children: /* @__PURE__ */ a.jsx(
                      Ql,
                      {
                        imageUrl: Xu(o.user)
                      }
                    ) }),
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $("text-mshop-gray-80", {
                          "typo-mshop-kr-14-m": c
                        }),
                        children: Mc(o.user)
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("li", { className: "flex gap-x-[1.71rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "w-[6.85714rem] flex-shrink-0 text-mshop-black",
                        { "typo-mshop-kr-16-b": !c },
                        { "typo-mshop-kr-14-b": c }
                      ),
                      children: "커미션 이름"
                    }
                  ),
                  /* @__PURE__ */ a.jsx("span", { className: $("w-full truncate"), children: o.commissionSnapshot.displayName })
                ] }),
                /* @__PURE__ */ a.jsxs("li", { className: "flex gap-x-[1.71rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "w-[6.85714rem] flex-shrink-0 text-mshop-black",
                        { "typo-mshop-kr-16-b": !c },
                        { "typo-mshop-kr-14-b": c }
                      ),
                      children: "신청 번호"
                    }
                  ),
                  /* @__PURE__ */ a.jsx("span", { className: $("w-full truncate"), children: o.id })
                ] }),
                /* @__PURE__ */ a.jsxs("li", { className: "flex gap-x-[1.71rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "w-[6.85714rem] flex-shrink-0 text-mshop-black",
                        { "typo-mshop-kr-16-b": !c },
                        { "typo-mshop-kr-14-b": c }
                      ),
                      children: "신청 일시"
                    }
                  ),
                  /* @__PURE__ */ a.jsx("span", { className: $("w-full truncate"), children: jt(o.createdAt, "yyyy.MM.dd HH:mm") })
                ] }),
                /* @__PURE__ */ a.jsxs("li", { className: "flex gap-x-[1.71rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "w-[6.85714rem] flex-shrink-0 text-mshop-black",
                        { "typo-mshop-kr-16-b": !c },
                        { "typo-mshop-kr-14-b": c }
                      ),
                      children: "진행 상태"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(rK, { state: o.state })
                ] }),
                o.dueDate && /* @__PURE__ */ a.jsxs("li", { className: "flex items-center justify-start gap-x-[1.71rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: $(
                        "w-[6.85714rem] flex-shrink-0 text-mshop-black",
                        { "typo-mshop-kr-16-b": !c },
                        { "typo-mshop-kr-14-b": c }
                      ),
                      children: "작업 기한"
                    }
                  ),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57rem]", children: [
                    /* @__PURE__ */ a.jsx("span", { children: jt(o.dueDate, "yyyy.MM.dd") }),
                    y && /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        type: "button",
                        className: "flex-center typo-mshop-kr-14-m h-[2.28571rem] rounded-[0.57143rem] border border-mshop-gray-10 bg-mshop-white px-[0.85714rem] text-mshop-gray-80",
                        onClick: w,
                        children: "마감 기한 변경"
                      }
                    )
                  ] })
                ] })
              ] }),
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $("relative flex flex-col gap-y-[1.71rem] py-[1.71rem]", {
                    "select-none": b
                  }),
                  children: [
                    o.commissionSnapshot.preQuestion && /* @__PURE__ */ a.jsxs("div", { className: "border-b border-b-mshop-gray-10 pb-[0.86rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $(
                            "text-mshop-black",
                            { "typo-mshop-kr-16-b": !c },
                            { "typo-mshop-kr-14-b": c }
                          ),
                          children: o.commissionSnapshot.preQuestion
                        }
                      ),
                      /* @__PURE__ */ a.jsx("p", { className: "whitespace-pre-line break-words py-[0.86rem]", children: o.preQuestionAnswer })
                    ] }),
                    o.message && /* @__PURE__ */ a.jsxs("div", { className: "border-b border-b-mshop-gray-10 pb-[0.86rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $(
                            "text-mshop-black",
                            { "typo-mshop-kr-16-b": !c },
                            { "typo-mshop-kr-14-b": c }
                          ),
                          children: "기타 요청 사항"
                        }
                      ),
                      /* @__PURE__ */ a.jsx("p", { className: "whitespace-pre-line break-words py-[0.86rem]", children: o.message })
                    ] }),
                    o.files.length > 0 && /* @__PURE__ */ a.jsxs("div", { children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $(
                            "text-mshop-black",
                            { "typo-mshop-kr-16-b": !c },
                            { "typo-mshop-kr-14-b": c }
                          ),
                          children: "참고 이미지 파일"
                        }
                      ),
                      /* @__PURE__ */ a.jsx("div", { className: "mt-[0.57rem] rounded-[0.28571rem] border border-mshop-gray-10 p-[1.14rem]", children: o.files.map((k) => /* @__PURE__ */ a.jsxs(
                        "div",
                        {
                          className: $("flex items-center justify-between", {
                            "w-full": c
                          }),
                          children: [
                            /* @__PURE__ */ a.jsxs(
                              "div",
                              {
                                className: $("flex items-center gap-x-[0.57rem]", {
                                  "w-[calc(100%-2.57142rem)]": c
                                }),
                                children: [
                                  /* @__PURE__ */ a.jsx("div", { className: "flex-center size-[1.71429rem] flex-shrink-0 rounded-[0.28571rem] bg-mshop-gray-5", children: /* @__PURE__ */ a.jsx(SP, { className: "size-[1.14286rem] text-mshop-gray-80" }) }),
                                  /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m flex max-w-full", children: [
                                    /* @__PURE__ */ a.jsx("span", { className: "line-clamp-1 break-all", children: k.name ? rw(k.name) : "참고 이미지 파일" }),
                                    k.ext && /* @__PURE__ */ a.jsxs("span", { children: [
                                      ".",
                                      aw(k.ext)
                                    ] })
                                  ] })
                                ]
                              }
                            ),
                            /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                type: "button",
                                className: "flex-center size-[2.28571rem] flex-shrink-0",
                                onClick: async () => {
                                  m(!1), await n5({
                                    url: k.url,
                                    filename: k.name ?? "커미션 작업 파일",
                                    onDownloadFailed: () => {
                                      m(!0);
                                    }
                                  });
                                },
                                disabled: o.state === Ln.Refunded || o.state === Ln.OnRefund,
                                children: /* @__PURE__ */ a.jsx(z3, { className: "size-[1.42857rem] text-mshop-gray-50" })
                              }
                            )
                          ]
                        },
                        k.id
                      )) }),
                      u && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m mt-[0.57rem] text-mshop-red-80", children: "파일 다운로드에 실패했습니다. 다시 시도해 주세요." })
                    ] }),
                    /* @__PURE__ */ a.jsxs("div", { className: "border-b border-b-mshop-gray-10 pb-[0.86rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $(
                            "text-mshop-black",
                            { "typo-mshop-kr-16-b": !c },
                            { "typo-mshop-kr-14-b": c }
                          ),
                          children: "작업 상세 내용"
                        }
                      ),
                      /* @__PURE__ */ a.jsx("p", { className: "whitespace-pre-line break-words py-[0.86rem]", children: o.commissionSnapshot.workDescription })
                    ] }),
                    b && /* @__PURE__ */ a.jsx("div", { className: "absolute inset-0 bg-mshop-white opacity-40" })
                  ]
                }
              )
            ]
          }
        ),
        o.state === Ln.Pending && !e && /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "flex items-center gap-x-[1.14rem] border-t border-mshop-gray-5",
              {
                "p-[1.14rem]": !c
              },
              {
                "absolute bottom-0 left-0 right-0 bg-mshop-white pb-[calc(env(safe-area-inset-bottom)+1.14rem)] pl-[1.14rem] pr-[1.14rem] pt-[1.14rem]": c
              }
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                za,
                {
                  variant: "md",
                  theme: "lineGray",
                  type: "button",
                  widthFull: !0,
                  onClick: () => n(o.id),
                  children: "신청 거절"
                }
              ),
              /* @__PURE__ */ a.jsx(
                za,
                {
                  variant: "md",
                  theme: "blue",
                  type: "button",
                  widthFull: !0,
                  onClick: () => t(o.id),
                  children: "신청 수락"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function b3e({
  show: e,
  onClose: t,
  transition: n,
  ...r
}) {
  const {
    widgetCore: { isMobile: s }
  } = Gt(), o = n ?? s;
  return /* @__PURE__ */ a.jsx(Zu, { show: e, onClose: t, transition: o, children: /* @__PURE__ */ a.jsx(
    aK,
    {
      ...r,
      onClose: t
    }
  ) });
}
const S3e = (e, t) => jn(
  "/accept-commission-request",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.UnableToProcessRequest:
      return n;
    default:
      throw new Error();
  }
}), sK = (e) => e.replace(/[^0-9]/g, "").replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3"), iK = ({
  initialDueDate: e,
  acceptDate: t,
  clearErrors: n
}) => (r) => {
  const s = new Date(r), o = /* @__PURE__ */ new Date(), c = Date.parse(r);
  if (!w3e(r) || isNaN(c))
    return "유효하지 않은 날짜이거나 형식이 올바르지 않습니다. 입력한 날짜를 확인해 주세요.";
  const u = Ffe(
    s,
    cW(Ufe(e ?? o, 1))
  );
  if (e && jde(e, r))
    return "마감기한은 현재 설정된 날짜와 동일한 날짜로 설정할 수 없습니다.";
  if (!u)
    return "마감기한은 현재 설정된 날짜보다 이전으로 설정할 수 없습니다.";
  const m = Uv(
    s,
    Q4(E3(t ?? o, 90))
  );
  return u && m ? (n(), !0) : t ? `마감 기한은 수락일로부터 최대 90일까지 설정 가능합니다. ${jt(E3(t, 89), "yyyy-MM-dd")}까지만 변경이 가능합니다.` : "작업 마감 기한은 최소 1일에서 최대 90일 내로 설정 가능합니다.";
};
function w3e(e) {
  const [t, n, r] = e.split("-").map((o) => Number(o)), s = new Date(Number(t), Number(n), 0).getDate();
  return Number(r) >= 1 && Number(r) <= s;
}
function C3e({
  show: e,
  commissionRequestId: t,
  onAccepted: n,
  onClose: r
}) {
  var z, H;
  const { client: s } = Ha(), {
    widgetCore: { onError: o, toggleSpinner: c, isMobile: u }
  } = Gt(), { acceptCommissionWithDueDate: m } = T6(), { setManagementCommissionStatusAcceptingToInProgress: y } = m_(), {
    watch: b,
    register: w,
    handleSubmit: k,
    formState: { isValid: j, errors: E },
    setValue: T,
    clearErrors: D,
    reset: L
  } = bp({
    defaultValues: {
      dueDate: "",
      message: ""
    },
    mode: "onChange"
  }), I = async (K) => {
    wt(t), c(!0);
    const { code: q } = await S3e(
      {
        commissionRequestId: t,
        dueDate: K.dueDate,
        ...K.message !== "" ? { message: K.message } : {}
      },
      {
        client: s,
        onError: o
      }
    );
    return c(!1), q === le.UnableToProcessRequest ? en({
      body: (Q) => /* @__PURE__ */ a.jsx(
        sa,
        {
          button: {
            props: Q
          },
          children: /* @__PURE__ */ a.jsxs("section", { className: "flex-center flex-col gap-y-[0.86rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "신청 상태 변경 불가" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "이미 수락되었거나 거절된 신청서입니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "상태를 변경할 수 없습니다."
            ] })
          ] })
        }
      )
    }) : q === le.TokenExpired ? o(Ht) : (L(), n(), m({
      commissionRequestId: t,
      dueDate: K.dueDate
    }), y(), en({
      body: (Q) => /* @__PURE__ */ a.jsx(
        sa,
        {
          button: {
            props: Q
          },
          children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col items-center justify-center gap-y-[0.86rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 신청 수락 완료" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "커미션 요청을 수락하였습니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "신청자와 작업 내용을 확인하고 진행하세요."
            ] })
          ] })
        }
      )
    }));
  }, R = () => {
    L(), r();
  }, U = (K) => {
    T("dueDate", sK(Yg(K.target.value)), {
      shouldValidate: !0
    });
  };
  return /* @__PURE__ */ a.jsx(Zu, { show: e, transition: !1, children: /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $(
        "flex flex-col rounded-[1rem] bg-mshop-white text-mshop-black",
        { "w-[43.4rem]": !u },
        { "h-full w-full": u }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "header",
          {
            className: $(
              "flex items-center border-b border-b-mshop-gray-5",
              { "justify-between p-[1.143rem]": !u },
              {
                "absolute left-0 top-0 z-10 h-[4rem] w-full justify-center bg-mshop-white px-[1.14rem]": u
              }
            ),
            children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "커미션 신청 수락" }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  onClick: R,
                  className: $("block", {
                    "absolute right-[1.14rem] top-1/2 -translate-y-1/2": u
                  }),
                  children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.429rem] fill-mshop-black" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "form",
          {
            onSubmit: k(I),
            className: $(
              "typo-mshop-kr-14-m flex flex-col gap-y-[1.71rem] overflow-y-auto",
              {
                "p-[1.14rem]": !u
              },
              {
                "h-full p-[1.14rem] pb-[6.28571rem] pt-[5.14rem] scrollbar-hide": u
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs("p", { children: [
                "커미션 요청을 수락하면 작업이 시작되며, 신청자에게 수락 알림이 전송됩니다. 작업 마감 기한은 수락 일로부터 최대 90일까지 설정할 수 있습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "설정한 기한까지 파일을 업로드 하지 않으면 자동으로 환불처리 됩니다."
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
                /* @__PURE__ */ a.jsx(Fs, { label: "작업 마감 기한 설정", required: !0 }),
                /* @__PURE__ */ a.jsx(
                  J4,
                  {
                    ...w("dueDate", {
                      required: !0,
                      validate: iK({
                        clearErrors: () => {
                          D("dueDate");
                        }
                      }),
                      onChange: U
                    }),
                    type: "text",
                    placeholder: "작업물 전달 예상 기한을 입력해 주세요. YYYY-MM-DD"
                  }
                ),
                ((z = E.dueDate) == null ? void 0 : z.message) && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: E.dueDate.message })
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
                /* @__PURE__ */ a.jsx(Fs, { label: "추가 안내" }),
                /* @__PURE__ */ a.jsx(
                  vy,
                  {
                    ...w("message", {
                      maxLength: {
                        value: 200,
                        message: "200자까지 입력 가능합니다."
                      }
                    }),
                    placeholder: "신청자에게 추가로 안내할 사항이 있다면 입력해 주세요.",
                    watch: b("message") ?? "",
                    maxLength: 200,
                    maxRows: 13,
                    invalid: !!E.message
                  }
                ),
                ((H = E.message) == null ? void 0 : H.message) && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: E.message.message })
              ] }),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "flex items-center gap-x-[1.14rem] border-t border-mshop-gray-5",
                    {
                      "p-[1.14rem]": !u
                    },
                    {
                      "absolute bottom-0 left-0 right-0 bg-mshop-white pb-[calc(env(safe-area-inset-bottom)+1.14rem)] pl-[1.14rem] pr-[1.14rem] pt-[1.14rem]": u
                    }
                  ),
                  children: u ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx(
                      uh,
                      {
                        theme: "line",
                        type: "button",
                        widthFull: !0,
                        onClick: R,
                        children: "취소"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      uh,
                      {
                        theme: "blue",
                        type: "submit",
                        widthFull: !0,
                        disabled: !j,
                        children: "수락하기"
                      }
                    )
                  ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx(
                      za,
                      {
                        variant: "md",
                        theme: "lineGray",
                        type: "button",
                        widthFull: !0,
                        onClick: R,
                        children: "취소"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      za,
                      {
                        variant: "md",
                        theme: "blue",
                        type: "submit",
                        widthFull: !0,
                        disabled: !j,
                        children: "수락하기"
                      }
                    )
                  ] })
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}
const N3e = (e, t) => jn(
  "/update-commission-request-due-date",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.Maximum:
    case le.InvalidDate:
      return n;
    default:
      throw new Error();
  }
});
function j3e({
  commissionRequestId: e,
  initialDueDate: t,
  acceptDate: n,
  onClose: r
}) {
  wt(n), wt(t);
  const { client: s } = Ha(), {
    widgetCore: { onError: o, toggleSpinner: c, isMobile: u }
  } = Gt(), { setCommissionDueDate: m } = T6(), { setUpdatedDueDate: y } = f_(), {
    register: b,
    handleSubmit: w,
    formState: { isValid: k, errors: j },
    clearErrors: E,
    setValue: T
  } = bp({
    mode: "onChange"
  }), D = async (I) => {
    wt(e), wt(t), c(!0);
    const { code: R } = await N3e(
      {
        commissionRequestId: e,
        dueDate: I.nextDueDate
      },
      {
        client: s,
        onError: o
      }
    );
    return c(!1), R === le.TokenExpired ? o(Ht) : (r(), m({
      commissionRequestId: e,
      nextDueDate: I.nextDueDate
    }), y({
      updatedDueDate: I.nextDueDate
    }), en({
      body: (U) => /* @__PURE__ */ a.jsx(
        sa,
        {
          button: {
            props: U
          },
          children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col items-center justify-center gap-y-[0.86rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "기한 변경 완료" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "신청자에게 작업 기한 변경 알림이 발송됩니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "변경된 마감 기한을 꼭 지켜주세요."
            ] })
          ] })
        }
      )
    }));
  }, L = (I) => {
    T(
      "nextDueDate",
      sK(Yg(I.target.value)),
      {
        shouldValidate: !0
      }
    );
  };
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $(
        "flex flex-col rounded-[1rem] bg-mshop-white text-mshop-black",
        { "w-[43.4rem]": !u },
        { "h-full w-full": u }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "header",
          {
            className: $(
              "flex items-center border-b border-b-mshop-gray-5",
              { "justify-between p-[1.143rem]": !u },
              {
                "absolute left-0 top-0 z-10 h-[4rem] w-full justify-center bg-mshop-white px-[1.14rem]": u
              }
            ),
            children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "마감 기한 변경" }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  onClick: r,
                  className: $("block", {
                    "absolute right-[1.14rem] top-1/2 -translate-y-1/2": u
                  }),
                  children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.429rem] fill-mshop-black" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "form",
          {
            onSubmit: w(D),
            className: $(
              "typo-mshop-kr-14-m flex flex-col gap-y-[1.71rem] overflow-y-auto",
              {
                "p-[1.14rem]": !u
              },
              {
                "h-full p-[1.14rem] pb-[6.28571rem] pt-[5.14rem] scrollbar-hide": u
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs("p", { children: [
                "작업 마감 기한은 한 번만 변경할 수 있습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "변경된 기한 내에 작업물을 업로드 하지 않으면 자동으로 환불 처리됩니다."
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
                /* @__PURE__ */ a.jsx(Fs, { label: "기존 작업 마감 기한" }),
                /* @__PURE__ */ a.jsx(
                  J4,
                  {
                    type: "text",
                    placeholder: "작업물 전달 예상 기한을 입력해 주세요. YYYY-MM-DD",
                    defaultValue: t,
                    readOnly: !0
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
                /* @__PURE__ */ a.jsx(Fs, { label: "변경 희망 기한 설정", required: !0 }),
                /* @__PURE__ */ a.jsx(
                  J4,
                  {
                    type: "text",
                    placeholder: "변경 희망하는 기한을 입력해 주세요. YYYY-MM-DD",
                    ...b("nextDueDate", {
                      required: !0,
                      onChange: L,
                      validate: iK({
                        initialDueDate: t,
                        acceptDate: n,
                        clearErrors: () => {
                          E("nextDueDate");
                        }
                      })
                    })
                  }
                ),
                j.nextDueDate && j.nextDueDate.message && /* @__PURE__ */ a.jsx(sl, { message: j.nextDueDate.message })
              ] }),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "flex items-center gap-x-[1.14rem] border-t border-mshop-gray-5",
                    {
                      "p-[1.14rem]": !u
                    },
                    {
                      "absolute bottom-0 left-0 right-0 bg-mshop-white pb-[calc(env(safe-area-inset-bottom)+1.14rem)] pl-[1.14rem] pr-[1.14rem] pt-[1.14rem]": u
                    }
                  ),
                  children: u ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx(
                      uh,
                      {
                        theme: "line",
                        type: "button",
                        widthFull: !0,
                        onClick: r,
                        children: "취소"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      uh,
                      {
                        theme: "blue",
                        type: "submit",
                        widthFull: !0,
                        disabled: !k,
                        children: "변경하기"
                      }
                    )
                  ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx(
                      za,
                      {
                        variant: "md",
                        theme: "lineGray",
                        type: "button",
                        widthFull: !0,
                        onClick: r,
                        children: "취소"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      za,
                      {
                        variant: "md",
                        theme: "blue",
                        type: "submit",
                        widthFull: !0,
                        disabled: !k,
                        children: "변경하기"
                      }
                    )
                  ] })
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function E3e({ show: e, onClose: t, ...n }) {
  return /* @__PURE__ */ a.jsx(Zu, { show: e, onClose: t, transition: !1, children: /* @__PURE__ */ a.jsx(j3e, { ...n, onClose: t }) });
}
async function k3e(e, t) {
  return jn(
    "/delete-commission-file",
    {
      body: e
    },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.UnableToProcessRequest:
        return n;
      default:
        throw new Error("PostDeleteCommission");
    }
  });
}
const _3e = (e, t) => jn(
  "/upload-commission-file",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.InvalidImage:
      return n;
    default:
      throw new Error();
  }
}), T3e = (e) => e < 1e3 * 1e3 ? `${(e / 1e3).toFixed(1)} KB` : e < 1e3 * 1e3 * 1e3 ? `${(e / (1e3 * 1e3)).toFixed(1)} MB` : `${(e / (1e3 * 1e3 * 1e3)).toFixed(1)} GB`, x8 = {
  size: "파일 크기가 너무 큽니다. 2GB 이하의 파일만 업로드해 주세요.",
  type: "지원 하지 않는 파일 형식입니다. 업로드 가능한 파일 형식을 확인해 주세요.",
  failed: "파일 업로드에 실패했습니다. 다시 시도해 주세요.",
  downloadFailed: "파일 다운로드에 실패했습니다. 다시 시도해 주세요."
};
function M3e({
  id: e,
  onClose: t,
  show: n,
  onFileDownloadButtonClick: r
}) {
  const [s, o] = Re(!1), [c, u] = Re(null), [m, y] = Re(null), {
    getCommissionByCommissionItemId: b,
    addCommissionFile: w,
    removeCommissionFile: k
  } = T6(), j = b(e), E = (j == null ? void 0 : j.commissionFiles) ?? [], T = dn(
    () => E.filter(({ file: te }) => te).length,
    [j]
  ), {
    managementCommissionStatus: D,
    setManagementCommissionStatusCountsAtom: L
  } = m_();
  wt(D);
  const { client: I } = Ha(), {
    widgetCore: { onError: R, toggleSpinner: U, isMobile: z }
  } = Gt(), H = Rt(null), K = async (te) => {
    const { files: fe } = te.target;
    if (y(null), fe && fe.length > 0) {
      const [ce] = fe;
      if (!R3e(ce.type))
        return y(x8.type);
      if (P3e(ce.size))
        return y(x8.size);
      const pe = mA[ce.type];
      try {
        U(!0);
        const { code: Se, data: oe } = await cw(
          {
            ext: pe,
            name: ce.name
          },
          {
            client: I,
            onError: R
          }
        );
        if (Se !== le.Success)
          return R(Ht);
        await fetch(oe.uploadUrl, {
          method: "PUT",
          referrerPolicy: "no-referrer-when-downgrade",
          headers: {
            "Content-Type": ce.type
          },
          cache: "no-store",
          body: ce
        }), u({
          ext: pe,
          size: ce.size,
          name: ce.name,
          url: oe.url
        });
      } catch {
        y(x8.failed);
      } finally {
        U(!1);
      }
    }
  };
  an(() => {
    e == null && (u(null), o(!1));
  }, [e]);
  const q = async () => {
    wt(c), wt(j);
    try {
      U(!0);
      const { code: te, data: fe } = await _3e(
        {
          url: c.url,
          commissionRequestId: j.request.id
        },
        {
          client: I,
          onError: R
        }
      );
      return te === le.TokenExpired ? R(Ht) : te === le.InvalidImage ? y(x8.type) : (fe && (T === 0 && L({
        upload: !0
      }), w({
        commissionId: j.id,
        commissionFile: fe.commissionFile
      }), u(null)), en({
        body: (ce) => /* @__PURE__ */ a.jsx(
          sa,
          {
            button: {
              props: ce
            },
            children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col items-center justify-center gap-y-[0.86rem]", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "파일 저장 완료" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                "작업 파일이 성공적으로 저장되었습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "마감 기한 또는 구매 확정 전까지 파일을 추가하거나 삭제할 수 있습니다."
              ] })
            ] })
          }
        )
      }));
    } catch {
      y(x8.failed);
    } finally {
      U(!1);
    }
  }, Q = async (te) => {
    const fe = E.filter((Se) => Se.file).length === 1;
    if (!await ho({
      body: (Se, oe) => fe ? /* @__PURE__ */ a.jsx(
        V9,
        {
          cancelButton: {
            props: oe,
            text: "취소"
          },
          confirmButton: {
            props: Se,
            text: "삭제하기"
          },
          children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col items-center justify-center", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "모든 파일 삭제 확인" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m mt-[0.29rem] text-mshop-black", children: [
              "삭제 전 다음 사항을 꼭 확인하고",
              /* @__PURE__ */ a.jsx("br", {}),
              "삭제를 신중히 결정해 주세요."
            ] }),
            /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m mt-[1.14286rem] list-disc rounded-[0.57143rem] bg-mshop-gray-5 p-[0.57rem] pl-[2.28rem] text-left text-mshop-gray-80", children: [
              /* @__PURE__ */ a.jsx("li", { children: "삭제된 파일은 복구할 수 없으며, 신청자 페이지에서도 삭제됩니다." }),
              /* @__PURE__ */ a.jsx("li", { children: "파일 내역이 없으면 [작업 중] 상태로 변경됩니다." }),
              /* @__PURE__ */ a.jsx("li", { children: "파일 업로드는 마감 기한까지만 가능합니다." }),
              /* @__PURE__ */ a.jsx("li", { children: "마감 기한 내 작업 파일 미업로드 시 자동 환불됩니다." })
            ] })
          ] })
        }
      ) : /* @__PURE__ */ a.jsx(
        qu,
        {
          cancelButton: {
            props: oe,
            text: "취소"
          },
          confirmButton: {
            props: Se,
            text: "삭제하기"
          },
          children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col items-center justify-center gap-y-[0.86rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "파일 삭제 확인" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "삭제된 파일은 복구할 수 없으며,",
              /* @__PURE__ */ a.jsx("br", {}),
              "커미션 신청자도 삭제된 파일을 확인할 수 없습니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "정말 삭제하시겠습니까?"
            ] })
          ] })
        }
      )
    }))
      return;
    wt(j), U(!0);
    const { code: pe } = await k3e(
      {
        commissionFileId: te
      },
      { client: I, onError: R }
    );
    if (pe === le.TokenExpired)
      return R(Ht);
    if (pe === le.UnableToProcessRequest)
      return U(!1), en({
        body: (Se) => /* @__PURE__ */ a.jsx(
          sa,
          {
            button: {
              props: Se
            },
            children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col items-center justify-center gap-y-[0.86rem]", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "파일 삭제 불가" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                "커미션 상태가 변경되어 파일을 삭제할 수 없습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "최신 상태를 확인해 주세요."
              ] })
            ] })
          }
        )
      });
    T === 1 && L({
      upload: !1
    }), k({
      commissionId: j.id,
      commissionFileId: te
    }), U(!1);
  }, Z = () => {
    y(x8.downloadFailed);
  }, X = async (te) => {
    if (te) {
      if (z)
        return r(
          te.url,
          te.name ?? "커미션 작업 파일"
        );
      await n5({
        url: te.url,
        filename: te.name ?? "커미션 작업 파일",
        onDownloadFailed: Z
      });
    }
  }, se = async () => {
    if (c)
      return z ? r(c.url, c.name) : n5({
        url: c.url,
        filename: c.name,
        onDownloadFailed: Z
      });
  };
  return an(() => {
    n || y(null);
  }, [n]), /* @__PURE__ */ a.jsx(Zu, { show: !!e, onClose: s ? Gd : t, children: /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $(
        "flex flex-col rounded-[1rem] bg-mshop-white text-mshop-black",
        { "w-[43.4rem]": !z },
        { "h-full w-full": z }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "header",
          {
            className: $(
              "flex items-center border-b border-b-mshop-gray-5",
              { "justify-between p-[1.143rem]": !z },
              {
                "absolute left-0 top-0 z-10 h-[4rem] w-full justify-center bg-mshop-white px-[1.14rem]": z
              }
            ),
            children: [
              /* @__PURE__ */ a.jsx("span", { className: "text-mshop-mshop-black typo-mshop-kr-16-b", children: "파일 업로드" }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  onClick: s ? Gd : t,
                  className: $("block", {
                    "absolute right-[1.14rem] top-1/2 -translate-y-1/2": z
                  }),
                  children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.429rem] fill-mshop-black" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "typo-mshop-kr-14-m flex flex-col gap-y-[1.71rem] overflow-y-auto",
              {
                "p-[1.14rem]": !z
              },
              {
                "h-full p-[1.14rem] pt-[5.14rem] scrollbar-hide": z
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs("p", { children: [
                "마감 기한 내에만 파일 업로드가 가능하며, 기한 내 작업 파일이 없을 경우 커미션은 자동 환불됩니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "마지막 파일 업로드일로부터 7일 후에는 자동으로 구매 확정됩니다." }),
                /* @__PURE__ */ a.jsx("br", {}),
                "업로드 이후 발생하는 문의는 신청자와 원활히 소통해 주세요."
              ] }),
              (j == null ? void 0 : j.request.state) !== Ln.End && /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-14-b", children: "작업 파일" }),
                c ? /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between rounded-[0.28571rem] border border-mshop-blue-100 p-[1.14rem]", children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex items-center", children: [
                    /* @__PURE__ */ a.jsx("span", { className: "flex-center size-[3.14286rem] flex-shrink-0 rounded-[0.28571rem] bg-mshop-blue-10", children: /* @__PURE__ */ a.jsx(SP, { className: "size-[1.96429rem] text-mshop-blue-100" }) }),
                    /* @__PURE__ */ a.jsxs("div", { className: "px-[1.14rem]", children: [
                      /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-16-m flex text-mshop-blue-100", children: [
                        /* @__PURE__ */ a.jsx("span", { className: "line-clamp-1 break-all", children: rw(c.name) }),
                        /* @__PURE__ */ a.jsxs("span", { children: [
                          ".",
                          aw(c.ext)
                        ] })
                      ] }),
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-en-14-unica-r text-mshop-gray-50", children: T3e(c.size) })
                    ] })
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-shrink-0 items-center gap-x-[0.29rem]", children: [
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        type: "button",
                        className: "flex-center size-[2.28571rem]",
                        onClick: se,
                        children: /* @__PURE__ */ a.jsx(z3, { className: "size-[1.42857rem] text-mshop-gray-50" })
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        type: "button",
                        className: "flex-center size-[2.28571rem]",
                        onClick: () => {
                          u(null);
                        },
                        children: /* @__PURE__ */ a.jsx(tk, { className: "size-[1.42857rem] text-mshop-gray-50" })
                      }
                    )
                  ] })
                ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                  /* @__PURE__ */ a.jsxs(
                    "button",
                    {
                      type: "button",
                      className: "flex gap-x-[1.14rem] rounded-[0.28571rem] bg-mshop-blue-10 p-[1.14rem] text-left disabled:opacity-60",
                      onClick: () => {
                        var te;
                        (te = H.current) == null || te.click();
                      },
                      disabled: s,
                      children: [
                        /* @__PURE__ */ a.jsx("span", { className: "flex-center flex size-[3.14286rem] flex-shrink-0 rounded-[0.28571rem] bg-mshop-blue-100", children: /* @__PURE__ */ a.jsx(vE, { className: "size-[2rem] text-mshop-white" }) }),
                        /* @__PURE__ */ a.jsxs("span", { className: "flex flex-col items-start", children: [
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-blue-100", children: "최종 작업 파일을 업로드해 주세요." }),
                          /* @__PURE__ */ a.jsx("span", { className: "text-mshop-gray-80", children: "업로드 가능 형식 : png, jpg, gif, svg, mp4, pdf, zip 등 / 파일당 2GB 이하" })
                        ] })
                      ]
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    "input",
                    {
                      ref: H,
                      type: "file",
                      accept: ".png, .jpg, .jpeg, .gif, .zip, .svg, .webp, .mp4, .pdf",
                      onChange: K,
                      className: "sr-only"
                    }
                  )
                ] }),
                m && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: m })
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-14-b", children: "파일 내역" }),
                /* @__PURE__ */ a.jsx("div", { className: "flex flex-col gap-y-[0.57rem] rounded-[0.28571rem] border border-mshop-gray-10 p-[1.14rem]", children: E.length > 0 ? E.map((te) => /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: $("w-full", {
                      "flex items-center gap-x-[0.86rem]": !z
                    }),
                    children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-r flex-shrink-0 text-mshop-gray-50", children: jt(te.createdAt, "yyyy.MM.dd HH:mm") }),
                      /* @__PURE__ */ a.jsxs("div", { className: "flex w-full items-center justify-between", children: [
                        /* @__PURE__ */ a.jsx("div", { className: "flex-center size-[1.71429rem] flex-shrink-0 rounded-[0.28571rem] bg-mshop-gray-5", children: /* @__PURE__ */ a.jsx(
                          SP,
                          {
                            className: $(
                              "size-[1.14286rem]",
                              te.file ? "text-mshop-gray-80" : "text-mshop-gray-50"
                            )
                          }
                        ) }),
                        te.file ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                          /* @__PURE__ */ a.jsxs("div", { className: "ml-[0.57rem] flex w-full text-mshop-gray-80", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "line-clamp-1 break-all", children: te.file.name ? rw(te.file.name) : "커미션 작업 파일" }),
                            te.file.ext && /* @__PURE__ */ a.jsxs("span", { children: [
                              ".",
                              aw(te.file.ext)
                            ] })
                          ] }),
                          /* @__PURE__ */ a.jsxs("div", { className: "ml-[0.86rem] flex items-center gap-x-[0.29rem]", children: [
                            /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                type: "button",
                                className: "flex-center size-[2.28571rem] flex-shrink-0",
                                onClick: () => X(
                                  te.file
                                ),
                                children: /* @__PURE__ */ a.jsx(z3, { className: "size-[1.42857rem] text-mshop-gray-50" })
                              }
                            ),
                            (j == null ? void 0 : j.request.state) !== Ln.End && /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                type: "button",
                                className: "flex-center size-[2.28571rem] flex-shrink-0",
                                onClick: async () => {
                                  wt(te.file), await Q(te.id);
                                },
                                children: /* @__PURE__ */ a.jsx(gA, { className: "size-[1.42857rem] text-mshop-gray-50" })
                              }
                            )
                          ] })
                        ] }) : /* @__PURE__ */ a.jsx("span", { className: "ml-[0.57rem] w-full truncate text-mshop-gray-50", children: "삭제된 파일입니다." })
                      ] })
                    ]
                  },
                  te.id
                )) : /* @__PURE__ */ a.jsx("span", { className: "block text-center text-mshop-gray-50", children: "작업 파일 내역이 없습니다." }) })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsx("div", { className: "flex gap-x-[1.14rem] p-[1.14rem]", children: z ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsx(
            uh,
            {
              theme: "line",
              type: "button",
              widthFull: !0,
              onClick: t,
              children: "취소"
            }
          ),
          /* @__PURE__ */ a.jsx(
            uh,
            {
              theme: "blue",
              type: "button",
              disabled: !(c != null && c.url) || s,
              widthFull: !0,
              onClick: q,
              children: "저장하기"
            }
          )
        ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsx(
            za,
            {
              variant: "md",
              theme: "lineGray",
              type: "button",
              widthFull: !0,
              onClick: t,
              children: "취소"
            }
          ),
          /* @__PURE__ */ a.jsx(
            za,
            {
              variant: "md",
              theme: "blue",
              type: "button",
              disabled: !(c != null && c.url) || s,
              widthFull: !0,
              onClick: q,
              children: "저장하기"
            }
          )
        ] }) })
      ]
    }
  ) });
}
function R3e(e) {
  return !!mA[e];
}
const D3e = 2 * 1e3 * 1e3 * 1e3;
function P3e(e, t = D3e) {
  return e > t;
}
const O3e = (e, t) => jn(
  "/reject-commission-request",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.UnableToProcessRequest:
    case le.AlreadyCancelledInfo:
      return n;
    default:
      throw new Error();
  }
});
function A3e({
  show: e,
  commissionRequestId: t,
  onRejected: n,
  onClose: r
}) {
  const { client: s } = Ha(), {
    widgetCore: { onError: o, toggleSpinner: c, isMobile: u }
  } = Gt(), {
    watch: m,
    register: y,
    handleSubmit: b,
    formState: { isValid: w, errors: k },
    reset: j
  } = bp({
    defaultValues: {
      message: ""
    },
    mode: "onChange"
  }), { setCommissionRejection: E } = T6(), { setManagementCommissionStatusInProgressToOnRefunded: T } = m_(), D = async (I) => {
    wt(t), c(!0);
    const { code: R } = await O3e(
      {
        commissionRequestId: t,
        message: I.message
      },
      {
        client: s,
        onError: o
      }
    );
    return c(!1), R === le.UnableToProcessRequest || R === le.AlreadyCancelledInfo ? en({
      body: (U) => /* @__PURE__ */ a.jsx(
        sa,
        {
          button: {
            props: U
          },
          children: /* @__PURE__ */ a.jsxs("section", { className: "flex-center flex-col gap-y-[0.86rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "신청 상태 변경 불가" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "이미 수락되었거나 거절된 신청서입니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "상태를 변경할 수 없습니다."
            ] })
          ] })
        }
      )
    }) : R === le.TokenExpired ? o(Ht) : (E({ commissionRequestId: t }), T(), n(), en({
      body: (U) => /* @__PURE__ */ a.jsx(
        sa,
        {
          button: {
            props: U
          },
          children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col items-center justify-center gap-y-[0.86rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 신청 거절 완료" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "커미션 요청이 거절되었습니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "신청자에게 거절 사유와 함께 전달됩니다."
            ] })
          ] })
        }
      )
    }));
  }, L = () => {
    r(), j();
  };
  return /* @__PURE__ */ a.jsx(Zu, { show: e, transition: !1, children: /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $(
        "flex flex-col rounded-[1rem] bg-mshop-white text-mshop-black",
        { "w-[43.4rem]": !u },
        { "h-full w-full": u }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "header",
          {
            className: $(
              "flex items-center border-b border-b-mshop-gray-5",
              { "justify-between p-[1.143rem]": !u },
              {
                "absolute left-0 top-0 z-10 h-[4rem] w-full justify-center bg-mshop-white px-[1.14rem]": u
              }
            ),
            children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "커미션 신청 거절" }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  onClick: L,
                  className: $("block", {
                    "absolute right-[1.14rem] top-1/2 -translate-y-1/2": u
                  }),
                  children: /* @__PURE__ */ a.jsx(Wd, { className: "size-[1.429rem] fill-mshop-black" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "form",
          {
            onSubmit: b(D),
            className: $(
              "typo-mshop-kr-14-m flex flex-col gap-y-[1.71rem] overflow-y-auto",
              {
                "p-[1.14rem]": !u
              },
              {
                "h-full p-[1.14rem] pb-[6.28571rem] pt-[5.14rem] scrollbar-hide": u
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs("p", { children: [
                "커미션 요청을 거절하면 신청자에게 거절 알림이 전송됩니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "신청자에게 보낼 거절 사유를 작성해 주세요."
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
                /* @__PURE__ */ a.jsx(Fs, { label: "거절 사유", required: !0 }),
                /* @__PURE__ */ a.jsx(
                  vy,
                  {
                    ...y("message", {
                      required: !0,
                      maxLength: {
                        value: 200,
                        message: "최대 글자수를 확인해 주세요."
                      }
                    }),
                    placeholder: "요청을 거절하는 사유를 입력해 주세요.",
                    watch: m("message"),
                    maxLength: 200,
                    maxRows: 13,
                    invalid: !!k.message
                  }
                )
              ] }),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "flex items-center gap-x-[1.14rem] border-t border-mshop-gray-5",
                    {
                      "p-[1.14rem]": !u
                    },
                    {
                      "absolute bottom-0 left-0 right-0 bg-mshop-white pb-[calc(env(safe-area-inset-bottom)+1.14rem)] pl-[1.14rem] pr-[1.14rem] pt-[1.14rem]": u
                    }
                  ),
                  children: u ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx(
                      uh,
                      {
                        theme: "line",
                        type: "button",
                        widthFull: !0,
                        onClick: L,
                        children: "취소"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      uh,
                      {
                        theme: "blue",
                        type: "submit",
                        widthFull: !0,
                        disabled: !w,
                        children: "거절하기"
                      }
                    )
                  ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx(
                      za,
                      {
                        variant: "md",
                        theme: "lineGray",
                        type: "button",
                        widthFull: !0,
                        onClick: L,
                        children: "취소"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      za,
                      {
                        variant: "md",
                        theme: "blue",
                        type: "submit",
                        widthFull: !0,
                        disabled: !w,
                        children: "거절하기"
                      }
                    )
                  ] })
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}
const oK = {
  CreatedAt: "createdAt",
  DueDate: "dueDate"
}, Nv = {
  Application: "APPLICATION",
  Accept: "ACCEPT",
  Reject: "REJECT",
  DueDate: "DUEDATE"
}, L3e = [], MH = {
  by: oK.CreatedAt,
  order: ws.Desc
}, X0 = wp();
function I3e({
  isFocusedTab: e,
  onFileDownloadButtonClick: t
}) {
  const { client: n } = Ha(), { projectId: r } = Tf(), {
    widgetCore: { isMobile: s, toggleSpinner: o, onError: c }
  } = Gt(), { setMembershipUserDetail: u } = N5(), {
    managementCommissions: m,
    setManagementCommissions: y,
    setApplicationIsRead: b,
    setInquiryIsRead: w
  } = T6(), { managementCommissionStatus: k, setManagementCommissionStatus: j } = m_(), { setCommissionRequest: E } = f_(), [T, D] = Re(1), [L, I] = Re(null), [R, U] = Re(null), [z, H] = Re(MH), [K, q] = Re(null), [Q, Z] = Re(null), [X, se] = Re(null), te = Rt(null), fe = _w();
  an(() => {
    !fe || !e || (async () => {
      const [He] = await Promise.all([
        i3e(
          {
            projectId: r
          },
          {
            client: n,
            onError: c
          }
        ),
        ce({
          page: 1,
          reset: !0
        })
      ]);
      He.code === le.TokenExpired && c(Ht), j(He.data), D(1), I(null), U(null);
    })();
  }, [e]), an(() => {
    Q === null && se(null);
  }, [Q]);
  const ce = async ({
    page: He = T,
    commissionId: Pt,
    commissionRequestState: Lt,
    sort: er = z,
    reset: It = !1,
    resetTableScrollX: ye = !1
  }) => {
    var tt;
    o(!0);
    const { code: ke, data: Pe } = await s3e(
      {
        projectId: r,
        size: 10,
        page: He,
        ...It ? {
          sort: MH
        } : {
          commissionRequestState: Lt ?? (R == null ? void 0 : R.state),
          commissionId: Pt ?? (L == null ? void 0 : L.id),
          ...er ? { sort: er } : {}
        }
      },
      { client: n, onError: c }
    );
    if (o(!1), ke !== le.Success)
      return c(Ht);
    y(Pe), (ye || It) && ((tt = te.current) == null || tt.scrollTo(0, 0));
  }, pe = async (He) => {
    wt(He), I(He), D(1), await ce({
      commissionId: He.id,
      page: 1,
      resetTableScrollX: !0
    });
  }, Se = async (He) => {
    U(He), D(1), await ce({
      page: 1,
      commissionRequestState: He.state,
      resetTableScrollX: !0
    });
  }, oe = (He) => {
    u({
      userId: He,
      selectedTabIndex: 3
    });
  }, ue = async () => {
    I(null), D(1), U(null), await ce({
      page: 1,
      reset: !0
    });
  }, he = async (He, Pt) => {
    D(Pt), await ce({
      page: Pt,
      resetTableScrollX: !0
    }), window.scrollTo(0, 0);
  }, ve = async (He) => {
    o(!0);
    const { code: Pt, data: Lt } = await nK(
      {
        commissionRequestId: He
      },
      {
        client: n,
        onError: c
      }
    );
    if (o(!1), Pt === le.TokenExpired)
      return c(Ht);
    b({
      commissionRequestId: He,
      nextIsRead: !0
    }), E(Lt), Z(Nv.Application);
  }, Te = (He) => {
    se((Pt) => ({
      ...Pt,
      commissionRequestId: He
    })), Z(Nv.Accept);
  }, Ie = (He) => {
    se((Pt) => ({
      ...Pt,
      commissionRequestId: He
    })), Z(Nv.Reject);
  }, Ue = ({
    commissionRequestId: He,
    initialDueDate: Pt,
    acceptDate: Lt
  }) => {
    Z(Nv.DueDate), se({
      commissionRequestId: He,
      initialDueDate: jt(Pt, "yyyy-MM-dd"),
      acceptDate: jt(Lt, "yyyy-MM-dd")
    });
  }, qe = () => {
    Z(null);
  }, it = () => {
    Z(Nv.Application);
  }, Ne = async ({ by: He }) => {
    const Pt = z.by === He ? {
      ...z,
      order: z.order === ws.Asc ? ws.Desc : ws.Asc
    } : { by: He, order: ws.Desc };
    await ce({
      sort: {
        order: Pt.order,
        by: Pt.by
      }
    }), H(Pt);
  }, Xe = dn(
    () => [
      X0.accessor("request.createdAt", {
        header: "신청 일시",
        id: "createdAt",
        cell: (He) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-r", children: jt(He.getValue(), "yyyy.MM.dd HH:mm") }),
        size: 96
      }),
      X0.accessor("no", {
        header: "신청 번호",
        cell: (He) => /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-r", children: He.getValue() }),
        size: s ? 96 : 128
      }),
      X0.accessor("user", {
        header: "마플샵 닉네임",
        cell: (He) => {
          const Pt = He.getValue();
          return /* @__PURE__ */ a.jsxs(
            "button",
            {
              type: "button",
              className: "flex-center inline-flex appearance-none gap-x-[0.57142rem]",
              onClick: () => oe(Pt.id),
              disabled: Pt.state === Sy.Delete,
              children: [
                /* @__PURE__ */ a.jsx("div", { className: "h-[2.286rem] w-[2.286rem]", children: /* @__PURE__ */ a.jsx(Ql, { imageUrl: Xu(Pt) }) }),
                /* @__PURE__ */ a.jsx("span", { className: "underline", children: Mc(Pt) })
              ]
            }
          );
        },
        size: s ? 160 : 240
      }),
      X0.accessor("displayName", {
        header: "커미션 이름",
        cell: (He) => He.getValue(),
        size: s ? 200 : 278
      }),
      X0.accessor("request.price", {
        header: "결제금액",
        cell: (He) => {
          const {
            row: {
              original: {
                request: { state: Pt }
              }
            },
            getValue: Lt
          } = He;
          return /* @__PURE__ */ a.jsxs("div", { className: "flex-center", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: Pt === Ln.Refunded ? 0 : Lt().toLocaleString() }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(V2.Krw) })
          ] });
        },
        size: s ? 96 : 128
      }),
      X0.accessor("request.state", {
        header: "진행 상태",
        cell: (He) => /* @__PURE__ */ a.jsx(rK, { state: He.getValue() }),
        size: s ? 96 : 128
      }),
      X0.accessor("request.isRead", {
        header: "커미션 신청",
        cell: (He) => {
          const Pt = He.getValue();
          return /* @__PURE__ */ a.jsx("div", { className: "flex-center", children: /* @__PURE__ */ a.jsx(
            za,
            {
              variant: "ss",
              theme: Pt ? "lineGray" : "lineSky",
              type: "button",
              onClick: () => ve(He.row.original.request.id),
              children: "신청서 확인"
            }
          ) });
        },
        size: s ? 112 : 128
      }),
      X0.accessor("inquiry", {
        header: "작업 문의",
        cell: (He) => {
          const Pt = He.getValue();
          return Pt ? /* @__PURE__ */ a.jsx("div", { className: "flex-center", children: /* @__PURE__ */ a.jsx(
            za,
            {
              variant: "ss",
              theme: Pt.isRead ? "lineGray" : "lineSky",
              type: "button",
              onClick: () => {
                w({
                  commissionId: He.row.original.id,
                  nextIsRead: !0
                }), window.open(Pt.url);
              },
              children: "고객 문의 확인"
            }
          ) }) : null;
        },
        size: s ? 112 : 128
      }),
      X0.accessor("request.dueDate", {
        header: "마감 기한",
        id: "dueDate",
        cell: ({
          getValue: He,
          row: {
            original: { request: Pt }
          }
        }) => {
          const Lt = He();
          return /* @__PURE__ */ a.jsx(
            "span",
            {
              className: $("typo-mshop-en-14-unica-m", {
                "text-mshop-black": Pt.state !== Ln.TaskDone && Pt.state !== Ln.End
              }),
              children: Lt ? jt(Lt, "yyyy.MM.dd") : "-"
            }
          );
        },
        size: 96
      }),
      X0.accessor("commissionFiles", {
        header: "파일 업로드",
        cell: ({
          getValue: He,
          row: {
            original: {
              request: { state: Pt, id: Lt }
            }
          }
        }) => {
          const It = He().filter(({ file: ye }) => ye).length > 0;
          return Pt === Ln.Pending || Pt === Ln.OnRefund || Pt === Ln.Refunded ? null : /* @__PURE__ */ a.jsx("div", { className: "flex-center gap-x-[0.28571rem]", children: /* @__PURE__ */ a.jsx(
            za,
            {
              variant: "ss",
              theme: It ? "lineGray" : "blue",
              type: "button",
              onClick: () => {
                q(Lt);
              },
              children: "파일 업로드"
            }
          ) });
        },
        size: s ? 112 : 240
      })
    ],
    []
  ), xt = Np({
    columns: Xe,
    data: (m == null ? void 0 : m.items) ?? L3e,
    getCoreRowModel: Cp()
  }), vt = xt.getRowModel().rows.length === 0, At = ((m == null ? void 0 : m.totalPage) ?? 0) > 1;
  return m == null || k == null ? /* @__PURE__ */ a.jsx($i, {}) : /* @__PURE__ */ a.jsxs($i, { children: [
    /* @__PURE__ */ a.jsx("div", { className: "py-[2.29rem]", children: /* @__PURE__ */ a.jsx(
      "div",
      {
        className: $(
          "flex gap-x-[0.57rem] overflow-x-auto text-mshop-black scrollbar-hide",
          { "px-[1.14rem]": s }
        ),
        children: Object.values(Ln).filter((He) => He !== Ln.OnRefund).map((He) => /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "rounded-[0.57rem] border border-mshop-gray-10",
              {
                "w-[20%] px-[1.14rem] py-[0.86rem]": !s
              },
              {
                "min-w-[5.14285rem] px-[0.857142rem] py-[0.57rem]": s
              }
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    {
                      "typo-mshop-kr-14-m": !s
                    },
                    {
                      "typo-mshop-kr-12-m text-center": s
                    }
                  ),
                  children: f9(He)
                }
              ),
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    "flex items-end gap-x-1",
                    {
                      "justify-end": !s
                    },
                    {
                      "justify-center": s
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $(
                          { "typo-mshop-en-24-unica-b": !s },
                          { "typo-mshop-en-16-unica-b": s },
                          {
                            "text-mshop-blue-100": He === Ln.Accepted
                          }
                        ),
                        children: He === Ln.Refunded ? ((k == null ? void 0 : k.ON_REFUND) ?? 0) + ((k == null ? void 0 : k.REFUNDED) ?? 0) : (k == null ? void 0 : k[He]) ?? 0
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "span",
                      {
                        className: $("text-mshop-gray-80", {
                          "typo-mshop-kr-12-m": s
                        }),
                        children: "건"
                      }
                    )
                  ]
                }
              )
            ]
          },
          He
        ))
      }
    ) }),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $("flex items-center justify-between text-mshop-gray-80", {
          "w-full flex-col justify-start gap-y-[0.86rem] px-[1.14rem]": s
        }),
        children: [
          !s && /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-x-[0.2rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m", children: [
              m.totalCount,
              "건"
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $("flex items-center", {
                "w-full flex-col gap-x-[0.86rem] gap-y-[0.86rem]": s
              }),
              children: [
                /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: $("flex items-center gap-x-[0.57rem]", {
                      "w-full": s
                    }),
                    children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $("flex-shrink-0", { "w-[5.71429rem]": s }),
                          children: "커미션 종류"
                        }
                      ),
                      /* @__PURE__ */ a.jsxs(
                        yp,
                        {
                          className: $(
                            { "w-[17.5rem]": !s },
                            { "w-full max-w-[18.2rem]": s }
                          ),
                          as: "div",
                          value: L,
                          onChange: pe,
                          children: [
                            /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: (L == null ? void 0 : L.displayName) ?? "커미션 종류별로 보기" }) }),
                            /* @__PURE__ */ a.jsx(M1, { children: m.plans.map(({ id: He, displayName: Pt }) => /* @__PURE__ */ a.jsx(
                              T1,
                              {
                                value: { id: He, displayName: Pt },
                                isSelected: (L == null ? void 0 : L.id) === He,
                                children: Pt
                              },
                              He
                            )) })
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: $(
                      "flex items-center",
                      { "ml-[1.71428rem] gap-x-[0.85714rem]": !s },
                      { "w-full gap-x-[0.57rem]": s }
                    ),
                    children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $("flex-shrink-0", { "w-[5.71429rem]": s }),
                          children: "진행 상태"
                        }
                      ),
                      /* @__PURE__ */ a.jsxs(
                        yp,
                        {
                          className: $(
                            { "w-[17.5rem]": !s },
                            { "w-full max-w-[14.8rem]": s }
                          ),
                          as: "div",
                          value: R,
                          onChange: Se,
                          children: [
                            /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: R ? f9(R.state) : "커미션 진행 상태별로 보기" }) }),
                            /* @__PURE__ */ a.jsx(M1, { children: m.planState.map((He) => /* @__PURE__ */ a.jsx(
                              T1,
                              {
                                value: He,
                                isSelected: (R == null ? void 0 : R.state) === He.state,
                                children: f9(He.state)
                              },
                              He.id
                            )) })
                          ]
                        }
                      ),
                      s && /* @__PURE__ */ a.jsx(
                        "button",
                        {
                          type: "button",
                          className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                          onClick: ue,
                          children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                        }
                      )
                    ]
                  }
                ),
                !s && /* @__PURE__ */ a.jsx("div", { className: "ml-2 flex items-center gap-x-[1.14285rem]", children: /* @__PURE__ */ a.jsx(
                  "button",
                  {
                    type: "button",
                    className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                    onClick: ue,
                    children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                  }
                ) })
              ]
            }
          ),
          s && /* @__PURE__ */ a.jsxs("span", { className: "flex h-[2.86rem] w-full items-end gap-x-[0.2rem] text-mshop-gray-80", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m", children: [
              m.totalCount,
              "건"
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: $({
          "px-[1.14rem]": s
        }),
        children: /* @__PURE__ */ a.jsxs(
          "div",
          {
            ref: te,
            className: $(
              "rounded-lg border border-mshop-gray-10",
              s ? "mt-[0.57142rem] w-full overflow-hidden" : "mt-[1.14285rem]",
              {
                "w-full overflow-x-auto scrollbar-hide": s && !vt
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !s
                    },
                    {
                      "w-[93.6rem]": s
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: xt.getHeaderGroups().map((He) => {
                      const Pt = Object.values(oK);
                      return /* @__PURE__ */ a.jsx("tr", { children: He.headers.map((Lt) => /* @__PURE__ */ a.jsx(
                        "th",
                        {
                          className: "typo-mshop-kr-14-m h-[4rem] select-none bg-mshop-gray-5 p-[0.57142rem] text-mshop-black",
                          style: {
                            width: Lt.getSize()
                          },
                          children: Lt.isPlaceholder ? null : /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.71428rem]", children: [
                            Gi(
                              Lt.column.columnDef.header,
                              Lt.getContext()
                            ),
                            Pt.includes(Lt.column.id) && /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                type: "button",
                                className: "block h-[1.143rem] w-[1.143rem]",
                                onClick: () => Ne({
                                  by: Lt.column.id
                                }),
                                children: /* @__PURE__ */ a.jsx(t0, { className: "h-full w-full text-mshop-black" })
                              }
                            )
                          ] })
                        },
                        Lt.id
                      )) }, He.id);
                    }) }),
                    !vt && /* @__PURE__ */ a.jsx("tbody", { children: xt.getRowModel().rows.map((He, Pt) => /* @__PURE__ */ a.jsx("tr", { children: He.getVisibleCells().map((Lt) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: $(
                          "typo-mshop-kr-14-m h-[5.14285rem] px-[0.571rem] py-[0.29rem] text-mshop-gray-80",
                          { "border-t border-t-mshop-gray-5": Pt > 0 }
                        ),
                        style: {
                          width: Lt.column.getSize()
                        },
                        children: Gi(
                          Lt.column.columnDef.cell,
                          Lt.getContext()
                        )
                      },
                      Lt.id
                    )) }, He.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                Tw,
                {
                  isEmptyRows: vt,
                  description: "커미션 신청 내역이 없습니다."
                }
              )
            ]
          }
        )
      }
    ),
    At && /* @__PURE__ */ a.jsx("div", { className: "flex-center mt-[2.857rem]", children: /* @__PURE__ */ a.jsx(
      J2,
      {
        count: m.totalPage,
        onChange: he,
        page: T,
        showFirstButton: !0,
        showLastButton: !0,
        windowSize: s ? 5 : 10
      }
    ) }),
    /* @__PURE__ */ a.jsx(
      M3e,
      {
        id: K,
        show: !!K,
        onClose: () => q(null),
        onFileDownloadButtonClick: t
      }
    ),
    /* @__PURE__ */ a.jsx(
      b3e,
      {
        show: Q === Nv.Application,
        onAcceptButtonClick: Te,
        onRejectButtonClick: Ie,
        onDueDateChangeButtonClick: Ue,
        onClose: qe,
        transition: !!(s && Q === null) || !!(s && !(X != null && X.commissionRequestId))
      }
    ),
    /* @__PURE__ */ a.jsx(
      C3e,
      {
        show: Q === Nv.Accept,
        commissionRequestId: X == null ? void 0 : X.commissionRequestId,
        onAccepted: () => {
          Z(null);
        },
        onClose: it
      }
    ),
    /* @__PURE__ */ a.jsx(
      A3e,
      {
        show: Q === Nv.Reject,
        commissionRequestId: X == null ? void 0 : X.commissionRequestId,
        onRejected: () => {
          Z(null);
        },
        onClose: it
      }
    ),
    /* @__PURE__ */ a.jsx(
      E3e,
      {
        show: Q === Nv.DueDate,
        commissionRequestId: X == null ? void 0 : X.commissionRequestId,
        initialDueDate: X == null ? void 0 : X.initialDueDate,
        acceptDate: X == null ? void 0 : X.acceptDate,
        onClose: it
      }
    )
  ] });
}
const F3e = (e, t) => jn(
  "/management-support-users",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), U3e = async ({
  filename: e,
  onDownloadFailed: t,
  ...n
}, { client: r }) => {
  const s = I2({
    accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "Content-Type": "application/json",
    referrerPolicy: "no-referrer-when-downgrade",
    credentials: "include",
    cache: "no-store",
    "x-api-key": await r.getToken()
  });
  return n5({
    url: `${r.getOrigin()}/management-support-users-export`,
    filename: e,
    init: {
      method: "POST",
      headers: s,
      body: JSON.stringify({
        ...I2(n),
        format: "xlsx"
      })
    },
    onDownloadFailed: t
  });
}, z3e = Qt(
  null
), B3e = () => {
  const [e, t] = Ar(
    z3e
  );
  return {
    managementSupportUsers: e,
    setManagementSupportUsers: t
  };
}, lK = {
  CreatedAt: "createdAt",
  Price: "price",
  Streak: "streakCount"
}, H3e = [], V3e = 10, Yj = {
  by: lK.CreatedAt,
  order: ws.Desc
}, b8 = wp();
function $3e({ isFocusedTab: e }) {
  var fe;
  const { client: t } = Ha(), { projectId: n } = Tf(), {
    widgetCore: { toggleSpinner: r, isMobile: s, onError: o }
  } = Gt(), { managementSupportUsers: c, setManagementSupportUsers: u } = B3e(), [m, y] = Re(null), [b, w] = Re(1), [k, j] = Re(null), [E, T] = Re(Yj), D = async (ce) => {
    r(!0);
    const { code: pe, data: Se } = await F3e(
      {
        ...ce,
        size: V3e,
        projectId: n
      },
      { client: t, onError: o }
    );
    if (r(!1), pe === le.TokenExpired)
      return o(Ht);
    u({
      items: Se.items,
      supports: Se.supports,
      totalPage: Se.totalPage,
      totalCount: Se.totalCount
    });
  }, L = _w();
  an(() => {
    !L || !e || (async () => (await D({
      page: 1
    }), w(1), y(null), j(null), T(Yj)))();
  }, [e]);
  const I = async (ce) => {
    y(ce), await D({
      page: b,
      ...RH(ce)
    });
  }, R = async (ce, pe) => {
    w(pe), await D({
      page: pe,
      sort: E,
      ...RH(m)
    });
  }, U = async () => {
    m && (y(null), w(1), T(Yj), await D({
      page: 1,
      sort: Yj
    }));
  }, { setMembershipUserDetail: z } = N5(), H = (ce) => {
    z({
      userId: ce,
      selectedTabIndex: 4
    });
  }, K = async ({ by: ce }) => {
    const pe = E.by === ce ? {
      ...E,
      order: E.order === ws.Asc ? ws.Desc : ws.Asc
    } : { by: ce, order: ws.Desc };
    await D({
      page: b,
      sort: {
        order: pe.order,
        by: pe.by
      },
      supportId: m == null ? void 0 : m.id
    }), T(pe);
  }, q = async () => {
    await U3e(
      {
        projectId: n,
        supportId: m == null ? void 0 : m.id,
        filename: `${jt(/* @__PURE__ */ new Date(), "yyyyMMdd")}_support_members.xlsx`,
        onDownloadFailed: () => {
          en({
            body: (ce) => /* @__PURE__ */ a.jsx(
              sa,
              {
                button: {
                  props: ce
                },
                children: /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.86rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: "다운로드 실패" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                    "파일 다운로드에 실패했습니다.",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "다시 시도해주세요."
                  ] })
                ] })
              }
            )
          });
        }
      },
      {
        client: t
      }
    );
  }, Q = dn(
    () => [
      b8.accessor("createdAt", {
        header: "후원일",
        cell: (ce) => jt(ce.getValue(), "yyyy.MM.dd"),
        size: s ? 112 : 128
      }),
      b8.accessor("user", {
        header: "마플샵 닉네임",
        cell: (ce) => {
          const pe = ce.getValue();
          return wt(pe), /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-start gap-x-[0.57142rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "h-[2.286rem] w-[2.286rem]", children: /* @__PURE__ */ a.jsx(Ql, { imageUrl: Xu(pe) }) }),
            /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "block underline",
                onClick: () => H(pe.id),
                disabled: pe.state === Sy.Delete,
                children: Mc(pe)
              }
            )
          ] });
        },
        size: s ? 176 : 240
      }),
      b8.accessor("support.displayName", {
        header: "후원 플랜",
        cell: (ce) => ce.getValue(),
        size: s ? 344 : 734
      }),
      b8.accessor("streakCount", {
        header: "후원 회차",
        cell: (ce) => ce.row.original.paymentState === S1.Paid ? `${ce.getValue()}` : `${ce.getValue()} (환불)`,
        size: s ? 112 : 128
      }),
      b8.accessor(
        (ce) => /* @__PURE__ */ a.jsxs("div", { className: "flex-center", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: nw(ce.price, ce.paymentState) }),
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: zs(ce.currency) })
        ] }),
        {
          header: "후원 금액",
          cell: (ce) => ce.getValue(),
          id: "price",
          size: s ? 112 : 240
        }
      ),
      b8.accessor("supportMessage", {
        header: "후원 메시지",
        cell: (ce) => {
          const pe = !!ce.getValue();
          return /* @__PURE__ */ a.jsx("div", { className: "inline-block w-[6.85714rem]", children: /* @__PURE__ */ a.jsx(
            za,
            {
              variant: "sm",
              theme: "lineSky",
              type: "button",
              onClick: () => j(ce.getValue()),
              disabled: !pe,
              widthFull: !0,
              children: pe ? "메세지 확인" : "삭제된 메세지"
            }
          ) });
        },
        size: s ? 112 : 160
      })
    ],
    []
  ), Z = Np({
    columns: Q,
    data: (c == null ? void 0 : c.items) ?? H3e,
    getCoreRowModel: Cp()
  }), se = Z.getRowModel().rows.length === 0, te = ((c == null ? void 0 : c.totalPage) ?? 0) > 1;
  return c ? /* @__PURE__ */ a.jsxs(
    $i,
    {
      className: $(
        {
          "pb-[6.85714rem] pt-[2.29rem]": !s
        },
        {
          "px-[1.14rem] pt-[2.29rem]": s
        }
      ),
      children: [
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $("flex items-center justify-between text-mshop-gray-80", {
              "w-full flex-col justify-start gap-y-[0.86rem]": s
            }),
            children: [
              !s && /* @__PURE__ */ a.jsxs("span", { className: "flex items-end gap-x-[0.2rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                " ",
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: `${c.totalCount}건` })
              ] }),
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $("flex items-center", {
                    "w-full justify-between gap-x-[0.57rem]": s
                  }),
                  children: [
                    /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $(
                          "flex items-center",
                          { "gap-x-[0.85714rem]": !s },
                          {
                            "w-full justify-between": s
                          }
                        ),
                        children: [
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $("flex-shrink-0", { "w-[5.71429rem]": s }),
                              children: "후원 플랜"
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            yp,
                            {
                              className: $(
                                { "w-[17.5rem]": !s },
                                { "w-full max-w-[14.8rem]": s }
                              ),
                              as: "div",
                              value: m,
                              onChange: I,
                              children: [
                                /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx("span", { className: "truncate text-mshop-gray-50", children: (m == null ? void 0 : m.displayName) ?? "후원 플랜별로 보기" }) }),
                                /* @__PURE__ */ a.jsx(M1, { children: (fe = c == null ? void 0 : c.supports) == null ? void 0 : fe.map(
                                  ({ id: ce, displayName: pe }) => /* @__PURE__ */ a.jsx(
                                    T1,
                                    {
                                      value: { id: ce, displayName: pe },
                                      isSelected: ce === (m == null ? void 0 : m.id),
                                      children: /* @__PURE__ */ a.jsx("div", { className: "max-w-[13.125rem] truncate", children: pe })
                                    },
                                    ce
                                  )
                                ) })
                              ]
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $("flex items-center", {
                          "ml-2 gap-x-[1.14285rem]": !s
                        }),
                        children: [
                          /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "h-[2.857rem] rounded border border-mshop-gray-10 px-[0.571rem]",
                              onClick: U,
                              children: /* @__PURE__ */ a.jsx(Cy, { className: "h-[1.429rem] w-[1.429rem] text-mshop-gray-50" })
                            }
                          ),
                          !s && /* @__PURE__ */ a.jsx(
                            za,
                            {
                              variant: "sm",
                              theme: "lineGray",
                              type: "button",
                              onClick: q,
                              children: /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.286rem]", children: [
                                /* @__PURE__ */ a.jsx(z3, { className: "h-[1.429rem] w-[1.429rem]" }),
                                " 엑셀 다운로드"
                              ] })
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ),
              s && /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m flex h-[2.85714rem] w-full items-end gap-x-[0.2rem] text-mshop-gray-80", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "총" }),
                " ",
                `${c.totalCount}건`
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "rounded-lg border border-mshop-gray-10",
              s ? "mt-[0.57142rem] w-full overflow-hidden" : "mt-[1.14285rem]",
              {
                "w-full overflow-x-auto scrollbar-hide": s && !se
              }
            ),
            children: [
              /* @__PURE__ */ a.jsxs(
                "table",
                {
                  className: $(
                    "text-center",
                    {
                      "w-full": !s
                    },
                    {
                      "w-[69.14285rem]": s
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx("thead", { children: Z.getHeaderGroups().map((ce) => /* @__PURE__ */ a.jsx("tr", { children: ce.headers.map((pe) => /* @__PURE__ */ a.jsx(
                      "th",
                      {
                        className: "typo-mshop-kr-14-m h-[4rem] bg-mshop-gray-5 p-[0.57142rem] text-mshop-black",
                        style: {
                          width: pe.getSize()
                        },
                        children: pe.isPlaceholder ? null : /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.71428rem]", children: [
                          Gi(
                            pe.column.columnDef.header,
                            pe.getContext()
                          ),
                          Object.values(lK).includes(
                            pe.column.id
                          ) && /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              type: "button",
                              className: "block h-[1.143rem] w-[1.143rem]",
                              onClick: () => K({
                                by: pe.column.id
                              }),
                              children: /* @__PURE__ */ a.jsx(t0, { className: "h-full w-full text-mshop-black" })
                            }
                          )
                        ] })
                      },
                      pe.id
                    )) }, ce.id)) }),
                    !se && /* @__PURE__ */ a.jsx("tbody", { children: Z.getRowModel().rows.map((ce, pe) => /* @__PURE__ */ a.jsx("tr", { children: ce.getVisibleCells().map((Se) => /* @__PURE__ */ a.jsx(
                      "td",
                      {
                        className: $(
                          "typo-mshop-kr-14-m h-[5.14285rem] px-[0.571rem] py-[0.29rem] text-mshop-gray-80",
                          { "border-t border-t-mshop-gray-5": pe > 0 }
                        ),
                        style: {
                          width: Se.column.getSize()
                        },
                        children: Gi(
                          Se.column.columnDef.cell,
                          Se.getContext()
                        )
                      },
                      Se.id
                    )) }, ce.id)) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                Tw,
                {
                  isEmptyRows: se,
                  description: "후원 내역이 없습니다."
                }
              )
            ]
          }
        ),
        te && /* @__PURE__ */ a.jsx("div", { className: "flex-center mt-[2.857rem]", children: /* @__PURE__ */ a.jsx(
          J2,
          {
            count: c.totalPage,
            onChange: R,
            page: b,
            showFirstButton: !0,
            showLastButton: !0,
            windowSize: s ? 5 : 10
          }
        ) }),
        /* @__PURE__ */ a.jsx(
          pY,
          {
            show: !!k,
            onClose: () => j(null),
            supportMessage: k,
            onSuccessDeleteMessage: () => Promise.resolve(),
            onToggleReactionUpdater: (ce) => {
              j({
                ...ce,
                reaction: {
                  ...ce.reaction,
                  creatorReacted: ce.reaction.reacted
                }
              });
            }
          }
        )
      ]
    }
  ) : /* @__PURE__ */ a.jsx($i, {});
}
function RH(e) {
  return {
    supportId: e == null ? void 0 : e.id
  };
}
const G3e = [3];
function W3e({
  managementMembershipUsers: e,
  projectDao: t,
  onFileDownloadButtonClick: n,
  ...r
}) {
  Al([
    [ol, r.client],
    [R1, r.projectId],
    [Iq, e],
    [
      ll,
      {
        isMobile: r.isMobile,
        isApp: r.isApp,
        toggleSpinner: r.toggleSpinner,
        onError: r.onError,
        onScrollLock: r.onScrollLock
      }
    ],
    [Fq, t]
  ]);
  const {
    widgetCore: { isMobile: s }
  } = Gt(), { hasConnectedCommunity: o } = yCe(), u = [
    { name: "멤버십 회원", Component: J7e },
    { name: "멤버십 결제", Component: q7e },
    { name: "상품 혜택", Component: a3e },
    { name: "커뮤니티 회원", Component: H7e },
    {
      name: "커미션 신청",
      Component: (m) => /* @__PURE__ */ a.jsx(
        I3e,
        {
          ...m,
          onFileDownloadButtonClick: n
        }
      )
    },
    { name: "후원 결제", Component: $3e }
  ].filter(
    (m, y) => o ? m : !G3e.includes(y)
  );
  return /* @__PURE__ */ a.jsxs("section", { id: "membership-support-manager", className: "twp", children: [
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $({
          "px-[1.43rem] py-[2.29rem]": s
        }),
        children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex items-start gap-x-[0.57142rem]", children: /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-28-b", children: "멤버십/커미션/후원 관리" }) }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m mt-[0.571rem] text-mshop-gray-80", children: "멤버십/커미션/후원 회원의 결제 내역, 혜택 이용 내역 확인 및 관리를 할 수 있습니다." })
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs(
      VE,
      {
        className: $(
          { "mt-[2.286rem]": !s },
          { "pb-[2.86rem]": s }
        ),
        children: [
          /* @__PURE__ */ a.jsx(
            j3,
            {
              className: $(
                "flex gap-x-[1.71428rem] border-b border-mshop-gray-5",
                {
                  "overflow-x-auto overflow-y-hidden px-[1.14rem] scrollbar-hide": s
                }
              ),
              children: u.map(({ name: m }) => /* @__PURE__ */ a.jsx(GE, { as: jf, children: ({ selected: y }) => /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: $(
                    "relative h-[2.857rem] outline-0",
                    {
                      "after:absolute after:-bottom-px after:left-0 after:block after:h-0.5 after:w-full after:bg-mshop-blue-100": y
                    },
                    {
                      "typo-mshop-kr-14-b text-mshop-black": y
                    },
                    {
                      "typo-mshop-kr-14-m text-mshop-gray-80": !y
                    },
                    {
                      "flex-shrink-0": s
                    }
                  ),
                  style: { outline: "none" },
                  children: m
                }
              ) }, m))
            }
          ),
          /* @__PURE__ */ a.jsx($E, { children: ({ selectedIndex: m }) => /* @__PURE__ */ a.jsx(a.Fragment, { children: u.map(({ Component: y }, b) => /* @__PURE__ */ a.jsx(
            y,
            {
              isFocusedTab: m === b
            },
            b
          )) }) })
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(P7e, {})
  ] });
}
function Y3e({ client: e, ...t }) {
  const [n, r] = Re(!0), [s, o] = Re(null), [c, u] = Re(null);
  return an(() => {
    (async () => {
      const [m, y] = await Promise.all([
        Lq(
          {
            size: 10,
            page: 1,
            projectId: t.projectId
          },
          { client: e, onError: t.onError }
        ),
        gCe(
          {
            projectId: t.projectId
          },
          { client: e, onError: t.onError }
        )
      ]);
      if (m.code !== le.Success || y.code !== le.Success)
        return t.onError(Ht);
      r(!1), o(m.data), u(y.data);
    })();
  }, []), n || s === null ? null : /* @__PURE__ */ a.jsx(
    W3e,
    {
      ...t,
      client: e,
      managementMembershipUsers: s,
      projectDao: c
    }
  );
}
class Gje extends Ol {
  constructor({
    projectId: t,
    onFileDownloadButtonClick: n,
    ...r
  }) {
    super(r), this.render = (s) => go(s).render(
      /* @__PURE__ */ a.jsx(
        Y3e,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          projectId: this.projectId,
          onError: this.onError,
          onScrollLock: this.onScrollLock,
          onFileDownloadButtonClick: this.onFileDownloadButtonClick
        }
      )
    ), this.projectId = t, this.onFileDownloadButtonClick = n;
  }
}
var cK = {};
function q3e(e) {
  if (typeof window > "u")
    return;
  const t = document.createElement("style");
  return t.setAttribute("type", "text/css"), t.innerHTML = e, document.head.appendChild(t), e;
}
Object.defineProperty(cK, "__esModule", { value: !0 });
var Rl = Ee;
function K3e(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
var h2 = /* @__PURE__ */ K3e(Rl);
q3e(`.rfm-marquee-container {
  overflow-x: hidden;
  display: flex;
  flex-direction: row;
  position: relative;
  width: var(--width);
  transform: var(--transform);
}
.rfm-marquee-container:hover div {
  animation-play-state: var(--pause-on-hover);
}
.rfm-marquee-container:active div {
  animation-play-state: var(--pause-on-click);
}

.rfm-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
}
.rfm-overlay::before, .rfm-overlay::after {
  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));
  content: "";
  height: 100%;
  position: absolute;
  width: var(--gradient-width);
  z-index: 2;
  pointer-events: none;
  touch-action: none;
}
.rfm-overlay::after {
  right: 0;
  top: 0;
  transform: rotateZ(180deg);
}
.rfm-overlay::before {
  left: 0;
  top: 0;
}

.rfm-marquee {
  flex: 0 0 auto;
  min-width: var(--min-width);
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);
  animation-play-state: var(--play);
  animation-delay: var(--delay);
  animation-direction: var(--direction);
}
@keyframes scroll {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.rfm-initial-child-container {
  flex: 0 0 auto;
  display: flex;
  min-width: auto;
  flex-direction: row;
  align-items: center;
}

.rfm-child {
  transform: var(--transform);
}`);
const X3e = Rl.forwardRef(function({ style: t = {}, className: n = "", autoFill: r = !1, play: s = !0, pauseOnHover: o = !1, pauseOnClick: c = !1, direction: u = "left", speed: m = 50, delay: y = 0, loop: b = 0, gradient: w = !1, gradientColor: k = "white", gradientWidth: j = 200, onFinish: E, onCycleComplete: T, onMount: D, children: L }, I) {
  const [R, U] = Rl.useState(0), [z, H] = Rl.useState(0), [K, q] = Rl.useState(1), [Q, Z] = Rl.useState(!1), X = Rl.useRef(null), se = I || X, te = Rl.useRef(null), fe = Rl.useCallback(() => {
    if (te.current && se.current) {
      const ve = se.current.getBoundingClientRect(), Te = te.current.getBoundingClientRect();
      let Ie = ve.width, Ue = Te.width;
      (u === "up" || u === "down") && (Ie = ve.height, Ue = Te.height), q(r && Ie && Ue && Ue < Ie ? Math.ceil(Ie / Ue) : 1), U(Ie), H(Ue);
    }
  }, [r, se, u]);
  Rl.useEffect(() => {
    if (Q && (fe(), te.current && se.current)) {
      const ve = new ResizeObserver(() => fe());
      return ve.observe(se.current), ve.observe(te.current), () => {
        ve && ve.disconnect();
      };
    }
  }, [fe, se, Q]), Rl.useEffect(() => {
    fe();
  }, [fe, L]), Rl.useEffect(() => {
    Z(!0);
  }, []), Rl.useEffect(() => {
    typeof D == "function" && D();
  }, []);
  const ce = Rl.useMemo(() => r ? z * K / m : z < R ? R / m : z / m, [r, R, z, K, m]), pe = Rl.useMemo(() => Object.assign(Object.assign({}, t), { "--pause-on-hover": !s || o ? "paused" : "running", "--pause-on-click": !s || o && !c || c ? "paused" : "running", "--width": u === "up" || u === "down" ? "100vh" : "100%", "--transform": u === "up" ? "rotate(-90deg)" : u === "down" ? "rotate(90deg)" : "none" }), [t, s, o, c, u]), Se = Rl.useMemo(() => ({
    "--gradient-color": k,
    "--gradient-width": typeof j == "number" ? `${j}px` : j
  }), [k, j]), oe = Rl.useMemo(() => ({
    "--play": s ? "running" : "paused",
    "--direction": u === "left" ? "normal" : "reverse",
    "--duration": `${ce}s`,
    "--delay": `${y}s`,
    "--iteration-count": b ? `${b}` : "infinite",
    "--min-width": r ? "auto" : "100%"
  }), [s, u, ce, y, b, r]), ue = Rl.useMemo(() => ({
    "--transform": u === "up" ? "rotate(90deg)" : u === "down" ? "rotate(-90deg)" : "none"
  }), [u]), he = Rl.useCallback((ve) => [
    ...Array(Number.isFinite(ve) && ve >= 0 ? ve : 0)
  ].map((Te, Ie) => h2.default.createElement(Rl.Fragment, { key: Ie }, Rl.Children.map(L, (Ue) => h2.default.createElement("div", { style: ue, className: "rfm-child" }, Ue)))), [ue, L]);
  return Q ? h2.default.createElement(
    "div",
    { ref: se, style: pe, className: "rfm-marquee-container " + n },
    w && h2.default.createElement("div", { style: Se, className: "rfm-overlay" }),
    h2.default.createElement(
      "div",
      { className: "rfm-marquee", style: oe, onAnimationIteration: T, onAnimationEnd: E },
      h2.default.createElement("div", { className: "rfm-initial-child-container", ref: te }, Rl.Children.map(L, (ve) => h2.default.createElement("div", { style: ue, className: "rfm-child" }, ve))),
      he(K - 1)
    ),
    h2.default.createElement("div", { className: "rfm-marquee", style: oe }, he(K))
  ) : null;
});
var p2 = cK.default = X3e;
const Q3e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 120, height: 25, viewBox: "0 0 120 25", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M18.0322 19.2108C19.6132 19.197 21.2079 18.8946 22.8301 18.3035C24.4454 17.7123 25.8752 16.7019 27.1125 15.2859V20.0219C25.4284 21.2042 23.435 22.0084 21.1323 22.4277C18.8296 22.847 16.4925 22.8883 14.1279 22.5446C11.7633 22.2009 9.63932 21.5204 7.77652 20.4893C8.25081 20.0975 8.78009 19.7401 9.37811 19.4239C9.96926 19.1077 10.6291 18.8877 11.3509 18.7709C12.0726 18.654 12.8013 18.6609 13.5436 18.7915C14.9665 19.0802 16.465 19.2177 18.0391 19.2039L18.0322 19.2108ZM6.76607 4.66587C9.72867 2.77558 13.1862 1.81325 17.1455 1.78575C21.1048 1.75826 24.4248 2.67935 27.1125 4.54901V9.28505C26.0058 8.02027 24.6104 7.05794 22.9263 6.38431C21.2423 5.71068 19.4619 5.36012 17.5785 5.31888C15.6951 5.27763 13.9286 5.51134 12.272 6.00626C10.3748 6.55616 8.8832 7.33977 7.79027 8.35709C6.69734 9.36754 6.05807 10.4742 5.87936 11.6703C5.69376 12.8663 5.98246 14.0073 6.74545 15.0865C7.45345 16.0901 7.83838 17.1074 7.8865 18.1454C7.94836 19.3208 7.76965 20.4962 7.76965 20.4962C6.08557 19.5751 4.75206 18.4203 3.76223 17.0249C2.78615 15.6295 2.2775 14.0486 2.25 12.2889C2.30499 9.09946 3.81035 6.56303 6.76607 4.66587Z" }), /* @__PURE__ */ re.createElement("path", { d: "M34.2131 2.41814V22.1459H30.6593V2.41814H34.2131Z" }), /* @__PURE__ */ re.createElement("path", { d: "M58.9381 6.14373C57.2403 5.60758 55.0544 5.33263 52.3667 5.33263C50.3115 5.33263 48.5449 5.50447 47.0602 5.84816C45.5754 6.19185 44.4206 6.55616 43.6095 6.95484C42.7916 7.34664 42.2279 7.67658 41.9117 7.94466C41.7536 8.13025 41.6643 8.32272 41.6368 8.51519C41.6093 8.71453 41.7055 8.89324 41.9117 9.05134C42.1729 9.28505 42.5716 9.53938 43.094 9.80058L43.9257 10.1924C44.5306 10.4261 44.9431 10.8385 45.1699 11.4159C45.3899 11.9933 45.3899 12.5707 45.1699 13.155C44.9431 13.7324 44.5306 14.1448 43.9257 14.3785C43.3483 14.6122 42.8878 14.8391 42.5441 15.0522C42.2829 15.2377 42.0698 15.3958 41.9117 15.5264C41.7261 15.657 41.6368 15.8426 41.6368 16.0763C41.6368 16.3101 41.7261 16.4956 41.9117 16.6262C42.8603 17.3617 44.2282 17.9804 46.0154 18.4822C47.8026 18.984 49.9197 19.2314 52.3667 19.2314C54.312 19.2314 56.003 19.0802 57.4396 18.7777C58.8762 18.4753 59.9966 18.1454 60.8146 17.7879C61.6326 17.4305 62.2375 17.1143 62.6293 16.8187V20.8467C61.2889 21.4516 59.7286 21.9259 57.9551 22.2696C56.1817 22.6133 54.3189 22.7852 52.3736 22.7852C49.741 22.7852 47.3076 22.4827 45.0737 21.8778C42.8397 21.2729 41.0594 20.4549 39.7465 19.4307C38.4336 18.4066 37.7737 17.2861 37.7737 16.0763C37.7737 14.681 38.626 13.4162 40.3376 12.2889C38.626 11.1547 37.7737 9.89682 37.7737 8.50144C37.7737 7.29165 38.4336 6.17123 39.7465 5.14703C41.0594 4.12284 42.8397 3.30486 45.0737 2.69997C47.3008 2.0882 49.7341 1.78575 52.3667 1.78575C54.312 1.78575 56.1748 1.9576 57.9482 2.30129C59.7217 2.64498 61.282 3.11927 62.6224 3.72416V7.7522C61.8594 7.22292 60.629 6.69363 58.9312 6.15748L58.9381 6.14373Z" }), /* @__PURE__ */ re.createElement("path", { d: "M91.0386 2.41814V5.97189H81.3741C81.1129 5.97189 80.8792 6.06125 80.6867 6.24684C80.4874 6.43243 80.3911 6.66614 80.3911 6.95484V22.1459H76.8374V6.95484C76.8374 6.66614 76.748 6.42556 76.5624 6.24684C76.3769 6.06125 76.1432 5.97189 75.8544 5.97189H66.1899V2.41814H91.0524H91.0386Z" }), /* @__PURE__ */ re.createElement("path", { d: "M97.3488 2.41814L104.573 9.4019C104.759 9.5875 104.986 9.67685 105.26 9.67685C105.535 9.67685 105.769 9.5875 105.948 9.4019L113.131 2.41814H117.668L107.329 12.4814C107.116 12.6395 107.013 12.8732 107.013 13.1894V22.1459H103.46V13.1894C103.46 12.9007 103.37 12.6601 103.185 12.4814L92.8121 2.41814H97.3488Z" })), DH = yn(Q3e), Z3e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 25, viewBox: "0 0 24 25", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_8621_246561)" }, /* @__PURE__ */ re.createElement("path", { d: "M21.0011 13.3108H3.00109C2.52109 13.3108 2.12109 12.9208 2.12109 12.4308C2.12109 11.9408 2.51109 11.5508 3.00109 11.5508H21.0011C21.4811 11.5508 21.8811 11.9408 21.8811 12.4308C21.8811 12.9208 21.4911 13.3108 21.0011 13.3108Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_8621_246561" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24, transform: "translate(0 0.429688)" })))), PH = yn(Z3e), J3e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { id: "Plus", clipPath: "url(#clip0_3560_154870)" }, /* @__PURE__ */ re.createElement("path", { id: "Vector", d: "M14.0826 7.41594H8.5826V1.9226C8.5826 1.6026 8.3226 1.33594 7.99594 1.33594C7.66927 1.33594 7.40927 1.59594 7.40927 1.9226V7.4226H1.9226C1.6026 7.4226 1.33594 7.6826 1.33594 8.00927C1.33594 8.33594 1.59594 8.59594 1.9226 8.59594H7.4226V14.0959C7.4226 14.4159 7.6826 14.6826 8.00927 14.6826C8.33594 14.6826 8.59594 14.4226 8.59594 14.0959V8.59594H14.0959C14.4159 8.59594 14.6826 8.33594 14.6826 8.00927C14.6826 7.6826 14.4226 7.4226 14.0959 7.4226L14.0826 7.41594Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_3560_154870" }, /* @__PURE__ */ re.createElement("rect", { width: 16, height: 16 })))), OH = yn(J3e), AH = [
  {
    imgUrl: kt.Admin.StudioSection2Product1,
    title: "핸드폰 케이스",
    price: 22e3
  },
  {
    imgUrl: kt.Admin.StudioSection2Product2,
    title: "아크릴 키링",
    price: 25e3
  },
  {
    imgUrl: kt.Admin.StudioSection2Product3,
    title: "슬리퍼",
    price: 19e3
  },
  {
    imgUrl: kt.Admin.StudioSection2Product4,
    title: "비닐 대신 백",
    price: 15e3
  },
  {
    imgUrl: kt.Admin.StudioSection2Product5,
    title: "에어팟 케이스",
    price: 19e3
  },
  {
    imgUrl: kt.Admin.StudioSection2Product6,
    title: "마우스패드",
    price: 12e3
  },
  {
    imgUrl: kt.Admin.StudioSection2Product7,
    title: "비즈 인형",
    price: 17600
  },
  {
    imgUrl: kt.Admin.StudioSection2Product8,
    title: "에어팟 맥스 케이스",
    price: 25e3
  },
  {
    imgUrl: kt.Admin.StudioSection2Product9,
    title: "메탈 액자",
    price: 34e3
  },
  {
    imgUrl: kt.Admin.StudioSection2Product10,
    title: "스마트 톡",
    price: 14500
  },
  {
    imgUrl: kt.Admin.StudioSection2Product11,
    title: "에코백",
    price: 12600
  }
], LH = [
  {
    imgUrl: kt.Admin.StudioSection3Product1,
    title: "태블릿 배경화면",
    price: 2600
  },
  {
    imgUrl: kt.Admin.StudioSection3Product2,
    title: "나무조각 만들기 KIT",
    price: 34e3
  },
  {
    imgUrl: kt.Admin.StudioSection3Product3,
    title: "전자책 (PDF 파일)",
    price: 18e3
  },
  {
    imgUrl: kt.Admin.StudioSection3Product4,
    title: "핸드폰 배경화면",
    price: 1e3
  },
  {
    imgUrl: kt.Admin.StudioSection3Product5,
    title: "직접만든 도자기 그릇",
    price: 42e3
  },
  {
    imgUrl: kt.Admin.StudioSection3Product6,
    title: "배경화면 이미지",
    price: 6e3
  },
  {
    imgUrl: kt.Admin.StudioSection3Product7,
    title: "핸드메이드 캔들",
    price: 21e3
  },
  {
    imgUrl: kt.Admin.StudioSection3Product8,
    title: "이벤트 액세서리",
    price: 19e3
  },
  {
    imgUrl: kt.Admin.StudioSection3Product9,
    title: "이미지 파일 상품",
    price: 8200
  },
  {
    imgUrl: kt.Admin.StudioSection3Product10,
    title: "핸드메이드 초콜릿",
    price: 15e3
  },
  {
    imgUrl: kt.Admin.StudioSection3Product11,
    title: "직접 제작 재고 상품",
    price: 19900
  }
], IH = [
  {
    imgUrl: kt.Admin.StudioSection4Plan1,
    height: "42.36928rem",
    heightMo: "30.50515rem"
  },
  {
    imgUrl: kt.Admin.StudioSection4Plan2,
    height: "53.40584rem",
    heightMo: "38.44206rem"
  },
  {
    imgUrl: kt.Admin.StudioSection4Plan3,
    height: "58.75328rem",
    heightMo: "42.22772rem"
  },
  {
    imgUrl: kt.Admin.StudioSection4Plan4,
    height: "58.79826rem",
    heightMo: "42.36035rem"
  },
  {
    imgUrl: kt.Admin.StudioSection4Plan5,
    height: "56.49019rem",
    heightMo: "40.61208rem"
  },
  {
    imgUrl: kt.Admin.StudioSection4Plan6,
    height: "59.89465rem",
    heightMo: "43.14435rem"
  },
  {
    imgUrl: kt.Admin.StudioSection4Plan7,
    height: "56.15035rem",
    heightMo: "40.28722rem"
  },
  {
    imgUrl: kt.Admin.StudioSection4Plan8,
    height: "59.11723rem",
    heightMo: "42.28053rem"
  }
], e6e = [
  {
    imgUrl: kt.Admin.StudioSection5Thumbnail1,
    badge: "웹툰 작가",
    title: `새로운 시즌의
웹툰 제작 비용을 지원해주세요!`,
    description: `후원해주신 분들께 특별한 미공개 스케치와
제작 비하인드 스토리를 공개합니다.`
  },
  {
    imgUrl: kt.Admin.StudioSection5Thumbnail2,
    badge: "유튜브 크리에이터",
    title: `작은 후원이 패션 콘텐츠의
퀄리티를 높이는 큰 힘이 됩니다.`,
    description: "여러분의 후원은 패션을 사랑하는 마음을 더 크게 만들어요. 오늘도 신상 쇼핑에 나섭니다! 영차!"
  },
  {
    imgUrl: kt.Admin.StudioSection5Thumbnail3,
    badge: "여행 인플루언서",
    title: `여행을 사랑하는 여행자 여러분,
여행 콘텐츠 제작을 도와주세요!`,
    description: "여러분의 후원은 새로운 이야기를 탄생시키는 밑거름입니다. 더 반짝이는 여행 콘텐츠를 만들어 낼게요!"
  },
  {
    imgUrl: kt.Admin.StudioSection5Thumbnail4,
    badge: "웹소설 작가",
    title: `여러분의 후원이 책 한 권의
마지막 장을 완성합니다.`,
    description: "팬분들의 사랑과 응원이 이야기 속에 고스란히 녹아들어가요. 기대를 넘어선 스토리로 찾아뵙겠습니다!"
  },
  {
    imgUrl: kt.Admin.StudioSection5Thumbnail5,
    badge: "틱톡커",
    title: `틱톡 감성 풀파워로 업그레이드!
후원해 주세요!`,
    description: `소중한 후원 덕분에 더 많은 웃음과 감동을 전달할 수
있습니다. 앞으로도 좋은 콘텐츠로 보답할게요!`
  },
  {
    imgUrl: kt.Admin.StudioSection5Thumbnail6,
    badge: "일러스트레이터",
    title: `후원 덕분에 더 귀엽고
재미있는 콘텐츠를 제작할 수 있어요.`,
    description: `여러분의 후원으로 더 사랑스럽고 귀여운 
콘텐츠를 제작할 수 있습니댜오! 77ㅑ!`
  }
], t6e = [
  {
    imgUrl: kt.Admin.StudioSection5Thumbnail1,
    badge: "웹툰 작가",
    title: `새로운 시즌의 웹툰 제작
비용을 지원해주세요!`,
    description: `후원해주신 분들께 특별한 미공개 스케치와
제작 비하인드 스토리를 공개합니다.`
  },
  {
    imgUrl: kt.Admin.StudioSection5Thumbnail2,
    badge: "유튜브 크리에이터",
    title: `작은 후원이 패션 콘텐츠의
퀄리티를 높이는 큰 힘이 됩니다.`,
    description: "여러분의 후원은 패션을 사랑하는 마음을 더 크게 만들어요. 오늘도 신상 쇼핑에 나섭니다! 영차!"
  },
  {
    imgUrl: kt.Admin.StudioSection5Thumbnail3,
    badge: "여행 인플루언서",
    title: `여행을 사랑하는 여행자 여러분,
여행 콘텐츠 제작을 도와주세요!`,
    description: "여러분의 후원은 새로운 이야기를 탄생시키는 밑거름입니다. 더 반짝이는 여행 콘텐츠를 만들어 낼게요!"
  }
], n6e = [
  {
    imgUrl: kt.Admin.StudioSection6Profile1,
    title: `동양화 느낌으로
프로필을 그려드릴게요!`,
    estimatedTime: 7
  },
  {
    imgUrl: kt.Admin.StudioSection6Profile2,
    title: `원하는 단어로 프리스타일
1분 음원 파일을 보내드려요`,
    estimatedTime: 20
  },
  {
    imgUrl: kt.Admin.StudioSection6Profile3,
    title: `사랑스러운 반려동물 그림을 
그려드릴게요 🐶`,
    estimatedTime: 3
  }
], qj = {
  imgUrl: kt.Admin.StudioSection6Profile1,
  title: `동양화 느낌으로
프로필을 그려드릴게요!`,
  estimatedTime: 7
}, FH = [
  {
    imgUrl: kt.Admin.StudioSection7Ciety1,
    title: "다이렉트 메시지, 커뮤니티 채널",
    description: `다양한 방식으로 나의 소식을 전하고
댓글과 이모티콘으로 활발하게 소통해요`
  },
  {
    imgUrl: kt.Admin.StudioSection7Ciety2,
    title: "멤버십 전용 콘텐츠",
    description: `멤버십 회원들만 볼 수 있는
콘텐츠로 팬들의 로열티를 높여보세요`
  },
  {
    imgUrl: kt.Admin.StudioSection7Ciety3,
    title: "멤버십 전용 라이브스트림",
    description: `다른 스트리밍 플랫폼이 아닌, 사이어티에서
오직 우리끼리만 실시간으로 소통해요`
  },
  {
    imgUrl: kt.Admin.StudioSection7Ciety4,
    title: "채널별 등급/권한 설정",
    description: `채널 목적 별로 다양하게 권한을 부여하고
멤버십 회원들과 소통해요`
  },
  {
    imgUrl: kt.Admin.StudioSection7Ciety5,
    title: "커뮤니티 디자인 커스텀",
    description: `커뮤니티 커버 및 프로필 등으로
크리에이터 브랜딩을 표현해요`
  },
  {
    imgUrl: kt.Admin.StudioSection7Ciety6,
    title: "오픈 / 비공개 커뮤니티 설정",
    description: `멤버십 회원만 가입 가능 설정으로
멤버십 독점 커뮤니티로 관리 할수도 있어요`
  },
  {
    imgUrl: kt.Admin.StudioSection7Ciety7,
    title: "마플샵 상품 동 커뮤니티 샵",
    description: `마플샵에서 판매중인 상품을
커뮤니티에서 그대로 노출하고 판매는 마플샵에서!`
  },
  {
    imgUrl: kt.Admin.StudioSection7Ciety8,
    title: "자유로운 커뮤니케이션",
    description: `텍스트, 이미지, 영상, 이모지, 링크, NFT 등
팬들과 소통하는 데 필요한 모든 기능을 지원해요`
  },
  {
    imgUrl: kt.Admin.StudioSection7Ciety9,
    title: "동시 라이브 송출 가능",
    description: `라이브 방송을 커뮤니티에도 연결해서
동시에 송출할 수 있어요`
  }
];
function r6e(e) {
  Al([
    [ol, e.client],
    [
      ll,
      {
        isMobile: e.isMobile,
        isApp: e.isApp,
        toggleSpinner: e.toggleSpinner,
        onError: e.onError,
        onScrollLock: e.onScrollLock
      }
    ]
  ]);
  const {
    widgetCore: { isMobile: t }
  } = Gt(), n = [
    {
      question: "멤버십 가격은 어떻게 설정하나요?",
      answer: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "멤버십 가격은 팬들에게 제공하는 혜택과 서비스의 가치를 고려해 신중히 설정해 주세요. ",
        /* @__PURE__ */ a.jsx("br", {}),
        "멤버십 만들기가 완료되면 멤버십 가격은 수정할 수 없습니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsx("br", {}),
        "멤버십 가격은 최소 900원에서 1,000,000원 사이의 선택지 내에서 설정할 수 있습니다. ",
        /* @__PURE__ */ a.jsx("br", {}),
        "팬들이 부담 없이 가입할 수 있는 금액으로 시작하는 것을 추천합니다!",
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsxs("ul", { className: "list-disc pl-[1.71429rem]", children: [
          /* @__PURE__ */ a.jsx("li", { children: "10,000원 미만 가격 : 900원 / 1,900원 / 2,900원 / ⋯ / 9,900원" }),
          /* @__PURE__ */ a.jsx("li", { children: "50,000원 이상 100,000원 미만 가격 : 15,000원 / 20,000원 / ⋯ / 100,000원" }),
          /* @__PURE__ */ a.jsx("li", { children: "100,000원 이상 가격 : 100,000원 / 200,000원 / ⋯ / 1,000,000원" })
        ] })
      ] })
    },
    {
      question: "멤버십 혜택으로 어떤 것을 제공할 수 있나요?",
      answer: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "멤버십 혜택은 팬들이 결제 금액만큼의 가치와 소속감을 느낄 수 있도록 독점적이고 특별한 요소로 구성하는 것이 중요합니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        "멤버십 혜택은 마플샵 상품 혜택, 사이어티 커뮤니티 혜택, 크리에이터 혜택 세 가지 유형으로 지원되고 있습니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsxs("ul", { className: "list-disc pl-[1.71429rem]", children: [
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "마플샵 상품 혜택 (멤버십 전용 상품)"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "멤버십 회원만 구매할 수 있는 특별한 전용 상품 구매 혜택을 제공해 보세요. ",
            /* @__PURE__ */ a.jsx("br", {}),
            "마플샵 굿즈 제작 상품, 크리에이터 등록 상품, 디지털 상품 유형별 추가가 가능합니다."
          ] }),
          /* @__PURE__ */ a.jsx("br", {}),
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "사이어티 커뮤니티 혜택"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "사이어티 커뮤니티를 연동하면 멤버십 그룹에 커뮤니티 혜택을 줄 수 있어요.",
            /* @__PURE__ */ a.jsx("br", {}),
            "디지털 콘텐츠, 라이브 방송, 채팅 채널, 1:1 메시지 혜택 등을 멤버십에게만 제공해 보세요."
          ] }),
          /* @__PURE__ */ a.jsx("br", {}),
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "크리에이터 혜택"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "크리에이터가 자유롭게 작성할 수 있는 혜택입니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "팬들이 좋아할 만한 혜택을 직접 작성해 제공할 수 있습니다."
          ] })
        ] })
      ] })
    },
    {
      question: "어떤 상품을 멤버십 전용으로 제공하나요?",
      answer: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "마플샵에서는 3가지 유형의 상품을 제작/등록해 판매할 수 있습니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        "아래 3가지 유형의 상품 모두 멤버십 상품 혜택으로 추가해 특정 멤버십 플랜의 상품 혜택으로 설정할 수 있습니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        "플랜 1개에 여러 가지 상품을 추가하거나, 1개 상품을 여러 가지 플랜의 혜택으로 설정할 수 있습니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsxs("ul", { className: "list-disc pl-[1.71429rem]", children: [
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "마플샵제작배송 상품"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "크리에이터가 보유한 디자인을 마플샵 제작 배송 상품에 적용후 판매를 시작해 보세요. ",
            /* @__PURE__ */ a.jsx("br", {}),
            "제작 비용과 재고 없이 상품 제작부터 배송, CS까지 마플샵이 모두 전담합니다."
          ] }),
          /* @__PURE__ */ a.jsx("br", {}),
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "크리에이터배송 상품"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "크리에이터가 직접 주문, 배송, CS 관리를 전담하는 상품으로 크리에이터가 직접 제작하거나 보유한 상품을 판매할 수 있습니다."
          ] }),
          /* @__PURE__ */ a.jsx("br", {}),
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "디지털/전자책 상품"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "디지털 상품은 구매자가 온라인에서 다운로드하여 사용할 수 있는 상품입니다. ",
            /* @__PURE__ */ a.jsx("br", {}),
            "( 디지털 상품 유형: 전자책, 배경화면 이미지, 보이스 팩, PDF 등 다양한 형식 )"
          ] })
        ] })
      ] })
    },
    {
      question: "팬들과의 소통은 어떻게 진행하면 좋을까요?",
      answer: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "마플샵 멤버십에서는 1:1 문의하기 게시판을 통해 팬들과 직접 소통할 수 있습니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsx("br", {}),
        "마플샵 멤버십 혜택에 커뮤니티 기능이 연동되어 마플샵과 연동된 커뮤니티에서 팬들과 다양한 방법으로 소통할 수 있습니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        "멤버십 커뮤니티에서는 독점 콘텐츠, 라이브 스트리밍, 1:1 대화 등의 기능을 커뮤니티 혜택으로 추가해 멤버십 회원들에게 특별한 경험을 선사할 수 있습니다."
      ] })
    },
    {
      question: "마플샵 멤버십은 어떻게 정산되나요?",
      answer: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "멤버십 서비스의 정산 방식은 일반 마플샵 상품 정산 방식과 동일합니다.",
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsxs("ul", { className: "list-disc pl-[1.71429rem]", children: [
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "정산 주기"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "매월 1일~말일까지의 ‘구매 확정’ 수익에 대해 익월 20~25일 입금됩니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "마플샵 크리에이터 수익 출금 방법은",
            " ",
            /* @__PURE__ */ a.jsx(
              "button",
              {
                onClick: e.onCreatorGuideClick,
                type: "button",
                className: t ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-m",
                children: "[크리에이터 가이드 - 정산 및 수익 출금하기]"
              }
            ),
            "를 참고해 주세요."
          ] }),
          /* @__PURE__ */ a.jsx("br", {}),
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-m",
                children: "‘구매 확정’ 기준"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "고객의 멤버십 결제 금액은 멤버십 결제일 기준 9일 후에 구매 확정 상태로 자동 변경됩니다. ",
            /* @__PURE__ */ a.jsx("br", {}),
            "e.g. 12/1 멤버십 결제 → 12/10 구매 확정 및 정산 반영"
          ] }),
          /* @__PURE__ */ a.jsx("br", {}),
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-m",
                children: "실제 입금액"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "{",
            "총 멤버십 매출",
            "}",
            " - ",
            "{",
            "멤버십 수수료(마플샵 수수료)",
            "}",
            " ",
            "-",
            "{",
            "PG사 수수료 3.2%(VAT 별도)",
            "}",
            " 공제 ",
            /* @__PURE__ */ a.jsx("br", {}),
            "개인 크리에이터의 경우, 마플샵에서 크리에이터 수익에 대한 세금을 대리 신고하고 있으므로 부가세 10%와 원천징수세 3.3% 공제 후 입금됩니다."
          ] }),
          /* @__PURE__ */ a.jsx("br", {})
        ] })
      ] })
    },
    {
      question: "멤버십 운영 유의사항",
      answer: /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        "멤버십을 운영하기 전, 아래 4가지만 꼭 기억해주세요!",
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsx("br", {}),
        /* @__PURE__ */ a.jsxs("ul", { className: "list-decimal pl-[1.71429rem]", children: [
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "멤버십 취소/환불"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "마플샵 멤버십은 멤버십 회원이 혜택을 이용하지 못했을 경우 관련 법에 따라, 결제일 기준 7일 이내 요청 시 취소/환불이 가능합니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "마플샵의 멤버십 취소/환불 기준은 ‘마플샵 전용 상품 혜택’ 이용 여부에 따르며,",
            /* @__PURE__ */ a.jsx("br", {}),
            "이 외 크리에이터가 멤버십 회원에게 개별 제공한 혜택은 포함되지 않으므로 이용에 참고를 부탁드립니다."
          ] }),
          /* @__PURE__ */ a.jsx("br", {}),
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "멤버십 개설 후 혜택 변경"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            " 최초 멤버십 개설 시 혜택과 다른 혜택으로 변경 시에 기존 멤버십 회원들의 불만이 생길 수 있습니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            " 따라서 멤버십 혜택은 신중하게 고민하고 변경해 주세요! (혜택 변경 1시간 후, 기존 멤버십 회원들에게 이메일이 자동 발송됩니다.)"
          ] }),
          /* @__PURE__ */ a.jsx("br", {}),
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "멤버십 플랜 종료/삭제"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            " 정기 구독 멤버십 회원이 있다면 해당 플랜의 종료는 최소 30일 전에 고지가 필요합니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "멤버십 종료 예약을 한 즉시, 해당 플랜의 신규 가입이 제한되며 1시간 후에 기존 회원들에게 멤버십 종료 고지가 이메일로 자동 발송됩니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "기존 멤버십 회원들은 마지막 구매일로부터 1달 간 혜택을 이용할 수 있으며, 그 이후의 정기 결제는 이뤄지지 않습니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "단, 기간 한정 멤버십은 회원이 있을 경우 삭제가 불가하니 참고해 주세요."
          ] }),
          /* @__PURE__ */ a.jsx("br", {}),
          /* @__PURE__ */ a.jsxs("li", { children: [
            /* @__PURE__ */ a.jsx(
              "span",
              {
                className: t ? "typo-mshop-kr-14-b" : "typo-mshop-kr-16-b",
                children: "멤버십 혜택 미이행"
              }
            ),
            /* @__PURE__ */ a.jsx("br", {}),
            "멤버십 혜택을 예정대로 회원에게 제공하지 않을 경우, 팬들과의 신뢰 관계가 깨질 수 있으니 꼭 약속을 이행해주세요.",
            /* @__PURE__ */ a.jsx("br", {}),
            "(주)마플코퍼레이션은 회원 상호 간 콘텐츠 거래를 위한 통신판매중개 시스템을 제공하는 통신판매중개자이며 통신판매자를 대리하지 않습니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "회원 간 성립된 거래에 대한 모든 책임은 판매자 회원과 구매자 회원이 직접 부담합니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "자세한 내용은",
            " ",
            /* @__PURE__ */ a.jsx(
              "button",
              {
                onClick: e.onIntegratedPaidServiceTermsTextClick,
                type: "button",
                className: $(
                  "cursor-pointer underline underline-offset-2",
                  t ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-m"
                ),
                children: "이용약관"
              }
            ),
            "을 확인해 주세요."
          ] })
        ] })
      ] })
    }
  ];
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "twp flex flex-col gap-y-[8.57143rem] bg-mshop-white pb-[8.57143rem] pt-[4.57143rem]"
      ),
      children: [
        /* @__PURE__ */ a.jsx("section", { className: "flex flex-col items-center text-center", children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.14286rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] text-mshop-black", children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-20-bebas-b uppercase", children: "MarppleShop Creator Membership" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-24-b", children: [
                "크리에이터와 팬을 단단하게 이어줄",
                /* @__PURE__ */ a.jsx("br", {}),
                " 마플샵 크리에이터",
                /* @__PURE__ */ a.jsx("br", {}),
                "멤버십/커미션/후원 서비스 소개"
              ] })
            ] }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m", children: [
              "크리에이터님만의 소중한 팬덤과",
              /* @__PURE__ */ a.jsx("br", {}),
              "특별한 추억만들고 새로운 수익도 창출할 수 있는",
              /* @__PURE__ */ a.jsx("br", {}),
              "마플샵의 새로운 기능, 멤버십/커미션/후원 서비스를 소개할게요."
            ] })
          ] }),
          /* @__PURE__ */ a.jsx("div", { className: "size-[15.71429rem]", children: /* @__PURE__ */ a.jsx(
            aa,
            {
              width: "15.7143rem",
              height: "15.7143rem",
              src: kt.KeyVisual.MembershipMeetFan,
              alt: "",
              objectFit: "cover"
            }
          ) })
        ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.71429rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem] text-mshop-black", children: [
              /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-24-bebas-b uppercase", children: "MarppleShop Creator Membership" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-32-b", children: [
                "크리에이터와 팬을 더 단단하게 이어줄",
                /* @__PURE__ */ a.jsx("br", {}),
                "마플샵 크리에이터 멤버십/커미션/후원 서비스 소개"
              ] })
            ] }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m", children: [
              "크리에이터님만의 소중한 팬덤과 특별한 추억만들고 새로운 수익도 창출할 수 있는",
              /* @__PURE__ */ a.jsx("br", {}),
              "마플샵의 새로운 기능, 멤버십/커미션/후원 서비스를 소개할게요."
            ] })
          ] }),
          /* @__PURE__ */ a.jsx("div", { className: "size-[22.85714rem]", children: /* @__PURE__ */ a.jsx(
            aa,
            {
              width: "22.8571rem",
              height: "22.8571rem",
              src: kt.KeyVisual.MembershipMeetFan,
              alt: "",
              objectFit: "cover"
            }
          ) })
        ] }) }),
        /* @__PURE__ */ a.jsx(
          "section",
          {
            className: $(
              "flex flex-col items-center pb-[2.85714rem] text-center",
              t ? "gap-y-[3.14286rem]" : "gap-y-[4.28571rem]"
            ),
            children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.14286rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-20-bebas-b uppercase", children: "Membership Goods" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-24-b", children: [
                    "마플샵이 가장 잘하는 굿즈 제작으로",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "멤버십 굿즈 제작 판매"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m", children: [
                  "오직 멤버십 회원만 구매할 수 있는 상품을 만들어 보세요.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "멤버십 혜택으로 멤버십 회원 한정 굿즈를 쉽게 판매할 수 있어요.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "굿즈 제작 - 배송 - 재고 관리까지 마플샵이 다 할게요."
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(p2, { direction: "left", autoFill: !0, children: AH.map((r) => /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: "ml-[1.71429rem] flex flex-col items-center gap-y-[1.14286rem]",
                  children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "relative size-[10.57143rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        aa,
                        {
                          src: r.imgUrl,
                          width: "10.5714rem",
                          height: "10.5714rem",
                          objectFit: "cover"
                        }
                      ),
                      /* @__PURE__ */ a.jsx("div", { className: "absolute left-[1.14286rem] top-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
                        dy,
                        {
                          property1: "Membership",
                          property2: "Icon"
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-16-b text-mshop-black", children: [
                      /* @__PURE__ */ a.jsx("p", { children: r.title }),
                      /* @__PURE__ */ a.jsxs("p", { children: [
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-b", children: r.price.toLocaleString(cr.Ko) }),
                        "원"
                      ] })
                    ] })
                  ]
                },
                r.title
              )) })
            ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.71429rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-24-bebas-b uppercase", children: "Membership Goods" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-32-b", children: [
                    "마플샵이 가장 잘하는 굿즈 제작으로",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "멤버십 굿즈 제작 판매"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m", children: [
                  "오직 멤버십 회원만 구매할 수 있는 유니크한 상품을 만들어 보세요.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "멤버십 혜택으로 멤버십 회원 한정 굿즈를 쉽게 판매할 수 있어요.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "굿즈 제작 - 배송 - 재고 관리까지 마플샵이 다 할게요."
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(p2, { direction: "left", autoFill: !0, gradient: !0, gradientWidth: 400, children: AH.map((r) => /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: "ml-[1.71429rem] flex flex-col items-center gap-y-[1.14286rem]",
                  children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "relative size-[14.28571rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        aa,
                        {
                          src: r.imgUrl,
                          width: "14.2857rem",
                          height: "14.2857rem",
                          objectFit: "cover"
                        }
                      ),
                      /* @__PURE__ */ a.jsx("div", { className: "absolute left-[1.14286rem] top-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
                        dy,
                        {
                          property1: "Membership",
                          property2: "Icon"
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-16-b text-mshop-black", children: [
                      /* @__PURE__ */ a.jsx("p", { children: r.title }),
                      /* @__PURE__ */ a.jsxs("p", { children: [
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-b", children: r.price.toLocaleString(cr.Ko) }),
                        "원"
                      ] })
                    ] })
                  ]
                },
                r.title
              )) })
            ] })
          }
        ),
        /* @__PURE__ */ a.jsx(
          "section",
          {
            className: $(
              "flex flex-col items-center pb-[2.85714rem] text-center",
              t ? "gap-y-[3.14286rem]" : "gap-y-[4.28571rem]"
            ),
            children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.14286rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-20-bebas-b uppercase", children: "Membership Products" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-24-b", children: [
                    "굿즈 외에도 내 상품, 디지털 상품까지",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "멤버십 혜택으로 판매"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m", children: [
                  "이미 제작해 둔 상품부터 ",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "핸드메이드 상품, 전자책, 이미지 파일 등의 ",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "디지털 상품도 등록해서 멤버십 혜택으로 만들 수 있어요."
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(p2, { direction: "left", autoFill: !0, children: LH.map((r) => /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: "ml-[1.71429rem] flex flex-col items-center gap-y-[1.14286rem]",
                  children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "relative size-[10.57143rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        aa,
                        {
                          src: r.imgUrl,
                          width: "10.5714rem",
                          height: "10.5714rem",
                          objectFit: "cover"
                        }
                      ),
                      /* @__PURE__ */ a.jsx("div", { className: "absolute left-[1.14286rem] top-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
                        dy,
                        {
                          property1: "Membership",
                          property2: "Icon"
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-16-b text-mshop-black", children: [
                      /* @__PURE__ */ a.jsx("p", { children: r.title }),
                      /* @__PURE__ */ a.jsxs("p", { children: [
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-b", children: r.price.toLocaleString(cr.Ko) }),
                        "원"
                      ] })
                    ] })
                  ]
                },
                r.title
              )) })
            ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.71429rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-24-bebas-b uppercase", children: "Membership Products" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-32-b", children: [
                    "굿즈 외에도 내 상품, 디지털 상품까지",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "멤버십 혜택으로 판매"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m", children: [
                  "이미 제작해 둔 상품부터 핸드메이드 상품, 전자책, 이미지 파일 등의",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "디지털 상품도 등록해서 멤버십 혜택으로 만들 수 있어요."
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(
                p2,
                {
                  direction: "left",
                  autoFill: !0,
                  gradient: !0,
                  gradientWidth: 400,
                  delay: 1,
                  children: LH.map((r) => /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: "ml-[1.71429rem] flex flex-col items-center gap-y-[1.14286rem]",
                      children: [
                        /* @__PURE__ */ a.jsxs("div", { className: "relative size-[14.28571rem]", children: [
                          /* @__PURE__ */ a.jsx(
                            aa,
                            {
                              src: r.imgUrl,
                              width: "14.2857rem",
                              height: "14.2857rem",
                              objectFit: "cover"
                            }
                          ),
                          /* @__PURE__ */ a.jsx("div", { className: "absolute left-[1.14286rem] top-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
                            dy,
                            {
                              property1: "Membership",
                              property2: "Icon"
                            }
                          ) })
                        ] }),
                        /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-16-b text-mshop-black", children: [
                          /* @__PURE__ */ a.jsx("p", { children: r.title }),
                          /* @__PURE__ */ a.jsxs("p", { children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-b", children: r.price.toLocaleString(cr.Ko) }),
                            "원"
                          ] })
                        ] })
                      ]
                    },
                    r.title
                  ))
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ a.jsx(
          "section",
          {
            className: $(
              "flex flex-col items-center",
              t ? "gap-y-[3.14286rem]" : "gap-y-[4.28571rem]"
            ),
            children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.14286rem] text-center", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-20-bebas-b uppercase", children: "Creator Community" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-24-b", children: [
                    "함께 소통하며 강력해지는 팬덤,",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "멤버십 커뮤니티 혜택"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m", children: [
                  "사이어티는 팬들과 소통할 수 있는",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "크리에이터 전용 커뮤니티 플랫폼입니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "디지털 콘텐츠, 라이브 방송, 채팅 채널, 1:1 메시지 혜택",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "등을 멤버십 전용 혜택으로 운영할 수 있어요.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "사이어티에서 커뮤니티를 만들고 마플샵과 연동해",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "더 특별한 멤버십을 만들어 보세요."
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex gap-x-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-m text-mshop-gray-50", children: "Powered by" }),
                  /* @__PURE__ */ a.jsx("a", { href: l9, target: "_blank", children: /* @__PURE__ */ a.jsx(DH, { className: "h-[1.42857rem] w-[7.14286rem] fill-mshop-gray-50" }) })
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(p2, { direction: "left", autoFill: !0, children: FH.map((r) => /* @__PURE__ */ a.jsx("div", { className: "ml-[1.14286rem]", children: /* @__PURE__ */ a.jsxs("div", { className: "flex w-[22rem] flex-col items-center gap-y-[1.71429rem] rounded-[1.14286rem] bg-mshop-gray-5 pt-[1.71429rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex-col gap-y-[0.57143rem] whitespace-pre-line text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b", children: r.title }),
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-center", children: r.description })
                ] }),
                /* @__PURE__ */ a.jsx("div", { className: "h-[21.71428] w-full", children: /* @__PURE__ */ a.jsx(
                  aa,
                  {
                    src: r.imgUrl,
                    width: "22.8571rem",
                    height: "21.7143rem",
                    objectFit: "cover"
                  }
                ) })
              ] }) }, r.title)) })
            ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.71429rem] text-center", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-24-bebas-b uppercase", children: "Creator Community" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-32-b", children: [
                    "함께 소통하며 강력해지는 팬덤,",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "크리에이터 커뮤니티 혜택"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m", children: [
                  "사이어티는 팬들과 소통할 수 있는 크리에이터 전용 커뮤니티 플랫폼입니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "디지털 콘텐츠, 라이브 방송, 채팅 채널, 1:1 메시지 혜택 등을 멤버십 전용 혜택으로 운영할 수 있어요.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "사이어티에서 커뮤니티를 만들고 마플샵과 연동해 더 특별한 멤버십을 만들어 보세요."
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex gap-x-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-m text-mshop-gray-50", children: "Powered by" }),
                  /* @__PURE__ */ a.jsx("a", { href: "https://ciety.xyz/", target: "_blank", children: /* @__PURE__ */ a.jsx(DH, { className: "h-[1.42857rem] w-[7.14286rem] fill-mshop-gray-50" }) })
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(p2, { direction: "left", autoFill: !0, gradient: !0, gradientWidth: 400, children: FH.map((r) => /* @__PURE__ */ a.jsx("div", { className: "ml-[1.71429rem]", children: /* @__PURE__ */ a.jsxs("div", { className: "flex w-[28.57143rem] flex-col items-center gap-y-[1.71429rem] rounded-[1.14286rem] bg-mshop-gray-5 pt-[4.28571rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex-col gap-y-[0.57143rem] whitespace-pre-line text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-24-b", children: r.title }),
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-m", children: r.description })
                ] }),
                /* @__PURE__ */ a.jsx("div", { className: "h-[27.14285rem] w-full", children: /* @__PURE__ */ a.jsx(
                  aa,
                  {
                    src: r.imgUrl,
                    width: "28.5714rem",
                    height: "27.2143rem",
                    objectFit: "cover"
                  }
                ) })
              ] }) }, r.title)) })
            ] })
          }
        ),
        /* @__PURE__ */ a.jsx(
          "section",
          {
            className: $(
              "flex flex-col items-center text-center",
              t ? "gap-y-[3.14286rem]" : "gap-y-[4.28571rem]"
            ),
            children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.14286rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-20-bebas-b uppercase", children: "Creator Membership" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-24-b", children: [
                    "팬들을 위한 크리에이터의 마음, ",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "크리에이터 멤버십 기능"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m", children: [
                  "멤버십 독점 상품부터 쉽게 제공하는 디지털 상품,",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "이미 만들어둔 재고 상품 판매 혜택까지",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "내 팬들이 원하는 것이라면, 다양하게 멤버십 혜택으로 등록하고",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "멤버십 결제금액을 자유롭게 설정하세요!"
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(p2, { direction: "left", autoFill: !0, speed: 40, children: IH.map((r) => /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: "ml-[1.71429rem] flex h-[44.20975rem] w-[14.28571rem] flex-col",
                  children: /* @__PURE__ */ a.jsx("div", { className: "w-full", style: { height: r.heightMo }, children: /* @__PURE__ */ a.jsx(
                    aa,
                    {
                      src: r.imgUrl,
                      width: "14.28571rem",
                      height: r.heightMo,
                      objectFit: "contain"
                    }
                  ) })
                },
                r.imgUrl
              )) })
            ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.71429rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-24-bebas-b uppercase", children: "Creator Membership" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-32-b", children: [
                    "소중한 팬들을 위한 크리에이터의 마음,",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "마플샵 크리에이터 멤버십"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m", children: [
                  "멤버십 독점 상품부터 쉽게 제공하는 디지털 상품, 이미 만들어둔 재고 상품 판매 혜택까지",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "내 팬들이 원하는 것이라면, 다양하게 멤버십 혜택으로 등록하고 멤버십 결제금액을 자유롭게 설정하세요!"
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(
                p2,
                {
                  direction: "left",
                  autoFill: !0,
                  gradient: !0,
                  gradientWidth: 400,
                  delay: 1.8,
                  speed: 40,
                  children: IH.map((r) => /* @__PURE__ */ a.jsx(
                    "div",
                    {
                      className: "ml-[1.71429rem] flex h-[61.7rem] w-[19.75357rem] flex-col",
                      children: /* @__PURE__ */ a.jsx("div", { className: "w-full", style: { height: r.height }, children: /* @__PURE__ */ a.jsx(
                        aa,
                        {
                          src: r.imgUrl,
                          width: "19.75357rem",
                          height: r.height,
                          objectFit: "contain"
                        }
                      ) })
                    },
                    r.imgUrl
                  ))
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ a.jsx(
          "section",
          {
            className: $(
              "flex flex-col items-center",
              t ? "gap-y-[3.14286rem] px-[1.14286rem]" : "gap-y-[4.28571rem]"
            ),
            children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.14286rem] text-center", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-20-bebas-b uppercase", children: "Creator Commission" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-24-b", children: [
                    "내 팬들에게 보다 특별한 선물,",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "크리에이터 커미션 기능"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m", children: [
                  "나만의 특기를 살려서 커미션 공지글을 올리고, ",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "팬들이 원하는 조건을 요청하면 ",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "그에 맞는 개인화된 콘텐츠를 제공해 보세요."
                ] })
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem]", children: [
                /* @__PURE__ */ a.jsxs(
                  "section",
                  {
                    className: "relative flex w-full items-center overflow-hidden rounded-[1.14286rem]",
                    children: [
                      /* @__PURE__ */ a.jsx("div", { className: "absolute inset-0 z-0", children: /* @__PURE__ */ a.jsx(
                        aa,
                        {
                          src: qj.imgUrl,
                          height: "10.5714rem",
                          width: "24.5rem",
                          objectFit: "cover"
                        }
                      ) }),
                      /* @__PURE__ */ a.jsx("div", { className: "absolute inset-0 z-10 bg-mshop-dim-60 backdrop-blur-[30px]" }),
                      /* @__PURE__ */ a.jsxs("div", { className: "z-20 flex w-full gap-x-[1.14286rem] p-[1.71429rem]", children: [
                        /* @__PURE__ */ a.jsxs("div", { className: "relative size-[6.28571rem] shrink-0", children: [
                          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m flex-center absolute h-[1.71429rem] w-fit rounded-[0.28571rem] bg-mshop-black px-[0.57143rem] text-mshop-white", children: "커미션" }),
                          /* @__PURE__ */ a.jsx(
                            Ql,
                            {
                              imageUrl: qj.imgUrl
                            }
                          )
                        ] }),
                        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem]", children: [
                          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-b whitespace-pre text-ciety-wh", children: qj.title }),
                          /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m text-mshop-gray-20", children: [
                            "예상 작업 기간 ",
                            /* @__PURE__ */ a.jsx("span", { children: "7" }),
                            "일"
                          ] })
                        ] })
                      ] })
                    ]
                  },
                  qj.title
                ),
                /* @__PURE__ */ a.jsxs("section", { className: "rounded-[1.14286rem] border border-mshop-gray-10 bg-mshop-white", children: [
                  /* @__PURE__ */ a.jsx("header", { className: "typo-mshop-kr-16-b h-[4rem] px-[1.71429rem] py-[1.14286rem] text-center text-mshop-black", children: "커미션 신청" }),
                  /* @__PURE__ */ a.jsxs("main", { className: "flex flex-col items-center gap-y-[1.14286rem] px-[1.71429rem] pb-[1.14286rem]", children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "relative h-[15.71429rem] w-[20.57143rem] overflow-hidden rounded-[1.14286rem]", children: [
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-m flex-center absolute left-[0.29rem] top-[0.86rem] w-fit rounded-[0.28571rem] bg-mshop-black px-[0.57143rem] py-[0.28571rem] text-mshop-white", children: "커미션" }),
                      /* @__PURE__ */ a.jsx(
                        aa,
                        {
                          src: kt.Admin.StudioSection6Thumbnail,
                          width: "27.7143rem",
                          height: "27.7143rem",
                          objectFit: "cover"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a.jsxs("div", { className: "w flex flex-col gap-y-[0.28571rem]", children: [
                      /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-16-b text-mshop-black", children: "동양화 느낌으로 프로필을 그려드려요!" }),
                      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57143rem]", children: [
                        /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-b text-mshop-black", children: [
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b", children: "9,900" }),
                          "원"
                        ] }),
                        /* @__PURE__ */ a.jsx("div", { className: "h-[0.85714rem] w-[0.07143rem] bg-mshop-gray-20" }),
                        /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-12-m text-mshop-gray-80", children: [
                          "예상 작업 기간",
                          " ",
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-12-unica-m", children: "7" }),
                          "일"
                        ] })
                      ] }),
                      /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m line-clamp-2 text-ellipsis text-mshop-black", children: "동양화 느낌의 특별한 프로필, 저만의 감각으로 그려드려요! 은은한 붓터치로 동양화 스타일의 프로필을 완성해 드립니다." })
                    ] })
                  ] }),
                  /* @__PURE__ */ a.jsx("div", { className: "px-[1.14286rem] pb-[1.71429rem]", children: /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-b rounded-[0.85714rem] bg-mshop-blue-100 px-[1.71429rem] py-[0.85714rem] text-center text-mshop-white", children: "커미션 신청하기" }) })
                ] })
              ] })
            ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.71429rem] text-center", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-24-bebas-b uppercase", children: "Creator Commission" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-32-b", children: [
                    "내 팬들에게 보다 특별한 선물,",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "크리에이터 커미션 기능"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m", children: [
                  "나만의 특기를 살려서 커미션 공지글을 올리고,",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "팬들이 원하는 조건을 요청하면 그에 맞는 개인화된 콘텐츠를 제공해 보세요."
                ] })
              ] }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[1.71429rem] px-[5.71429rem]", children: [
                /* @__PURE__ */ a.jsx("section", { className: "flex flex-col gap-y-[1.14286rem]", children: n6e.map((r) => /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: "relative flex w-[40.14286rem] flex-1 items-center overflow-hidden rounded-[1.14286rem]",
                    children: [
                      /* @__PURE__ */ a.jsx("div", { className: "absolute inset-0 z-0", children: /* @__PURE__ */ a.jsx(
                        aa,
                        {
                          src: r.imgUrl,
                          height: "19.2857rem",
                          width: "64.2857rem",
                          objectFit: "cover"
                        }
                      ) }),
                      /* @__PURE__ */ a.jsx("div", { className: "absolute inset-0 z-10 bg-mshop-dim-60 backdrop-blur-[30px]" }),
                      /* @__PURE__ */ a.jsx("div", { className: "z-20 flex w-full flex-col gap-y-[0.57143rem] p-[1.71429rem]", children: /* @__PURE__ */ a.jsxs("div", { className: "flex shrink-0 gap-x-[1.14286rem]", children: [
                        /* @__PURE__ */ a.jsxs("div", { className: "relative size-[11.42857rem] shrink-0", children: [
                          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m flex-center absolute h-[1.71429rem] w-fit rounded-[0.28571rem] bg-mshop-black px-[0.57143rem] text-mshop-white", children: "커미션" }),
                          /* @__PURE__ */ a.jsx(Ql, { imageUrl: r.imgUrl })
                        ] }),
                        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem] pt-[1.14286rem]", children: [
                          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-24-b whitespace-pre-line text-mshop-white", children: r.title }),
                          /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m text-mshop-gray-20", children: [
                            "예상 작업 기간 ",
                            r.estimatedTime,
                            "일"
                          ] })
                        ] })
                      ] }) })
                    ]
                  },
                  r.title
                )) }),
                /* @__PURE__ */ a.jsxs("section", { className: "rounded-[1.14286rem] border border-mshop-gray-10 bg-mshop-white", children: [
                  /* @__PURE__ */ a.jsx("header", { className: "typo-mshop-kr-16-b h-[4rem] px-[1.71429rem] py-[1.14286rem] text-center text-mshop-black", children: "커미션 신청" }),
                  /* @__PURE__ */ a.jsxs("main", { className: "flex flex-col items-center gap-y-[1.14286rem] px-[1.71429rem] pb-[1.14286rem]", children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "relative size-[27.71429rem]", children: [
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-m flex-center absolute left-[1.71rem] top-[1.43rem] w-fit rounded-[0.28571rem] bg-mshop-black px-[0.57143rem] py-[0.28571rem] text-mshop-white", children: "커미션" }),
                      /* @__PURE__ */ a.jsx(
                        aa,
                        {
                          src: kt.Admin.StudioSection6Thumbnail,
                          width: "27.7143rem",
                          height: "27.7143rem",
                          objectFit: "cover"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex w-[31.14286rem] flex-col gap-y-[0.28571rem] px-[1.71429rem]", children: [
                      /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-24-b text-mshop-black", children: "동양화 느낌으로 프로필을 그려드려요!" }),
                      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57143rem]", children: [
                        /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-b text-mshop-black", children: [
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-b", children: "9,900" }),
                          "원"
                        ] }),
                        /* @__PURE__ */ a.jsx("div", { className: "h-[0.85714rem] w-[0.07143rem] bg-mshop-gray-20" }),
                        /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                          "예상 작업 기간",
                          " ",
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: "7" }),
                          "일"
                        ] })
                      ] }),
                      /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m text-mshop-black", children: [
                        "동양화 느낌의 특별한 프로필, 저만의 감각으로 그려드려요!",
                        /* @__PURE__ */ a.jsx("br", {}),
                        "은은한 붓터치로 동양화 스타일의 프로필을 완성해 드립니다."
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ a.jsx("div", { className: "px-[1.71429rem] pb-[1.71429rem] pt-[1.14286rem]", children: /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-b h-[4rem] rounded-[0.85714rem] bg-mshop-blue-100 px-[1.71429rem] py-[1.14286rem] text-center text-mshop-white", children: "커미션 신청하기" }) })
                ] })
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ a.jsx(
          "section",
          {
            className: $(
              "flex flex-col items-center",
              t ? "gap-y-[3.14286rem] px-[1.14286rem]" : "gap-y-[4.28571rem]"
            ),
            children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.14286rem] text-center", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-20-bebas-b uppercase", children: "Creator Support" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-24-b", children: [
                    "팬이 크리에이터에게 전하는 마음,",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "크리에이터 후원 기능"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m", children: [
                  "팬들이 창작 활동에 공감과 응원을 할 수 있도록",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "다양한 후원을 만들어 보세요.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "후원을 해준 팬들에게는 크리에이터님만의",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "감사 메시지도 자동으로 보낼 수 있어요!"
                ] })
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "flex flex-col gap-y-[1.14286rem]", children: t6e.map((r) => /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: "flex h-[10.57143rem] gap-x-[1.42857rem] rounded-[1.14286rem] border border-mshop-gray-10 bg-mshop-white p-[1.14286rem]",
                  children: [
                    /* @__PURE__ */ a.jsx("div", { className: "size-[5.71429rem] shrink-0 overflow-hidden rounded-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
                      aa,
                      {
                        src: r.imgUrl,
                        width: "5.7143rem",
                        height: "6.4286rem",
                        objectFit: "cover"
                      }
                    ) }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] whitespace-pre-line", children: [
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m w-fit rounded-[0.28571rem] bg-mshop-blue-100 px-[0.57143rem] py-[0.28571rem] text-mshop-white", children: r.badge }),
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-b line-clamp-2 text-ellipsis text-mshop-black", children: r.title }),
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-12-m line-clamp-2 text-ellipsis text-mshop-gray-80", children: r.description })
                    ] })
                  ]
                },
                r.title
              )) })
            ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-y-[1.71429rem] text-center", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem] text-mshop-black", children: [
                  /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-24-bebas-b uppercase", children: "Creator Support" }),
                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-32-b", children: [
                    "팬들이 크리에이터에게 전하는 마음,",
                    /* @__PURE__ */ a.jsx("br", {}),
                    "크리에이터 후원 기능"
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m", children: [
                  "팬들이 창작 활동에 공감과 응원을 할 수 있도록 다양한 후원을 만들어 보세요.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "후원을 해준 팬들에게는 크리에이터님만의 감사 메시지도 자동으로 보낼 수 있어요!"
                ] })
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "grid max-w-[87.85714rem] grid-cols-2 gap-x-[1.71429rem] gap-y-[1.14286rem] px-[5.71429rem]", children: e6e.map((r) => /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: "flex h-[15.42857rem] gap-x-[1.42857rem] overflow-hidden rounded-[1.14286rem] border border-mshop-gray-10 bg-mshop-white p-[1.14286rem]",
                  children: [
                    /* @__PURE__ */ a.jsx("div", { className: "size-[8.57143rem] shrink-0 overflow-hidden rounded-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
                      aa,
                      {
                        src: r.imgUrl,
                        width: "8.5714rem",
                        height: "9.7143rem",
                        objectFit: "cover"
                      }
                    ) }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem] whitespace-pre-line pt-[0.57143rem]", children: [
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m w-fit rounded-[0.28571rem] bg-mshop-blue-100 px-[0.57143rem] py-[0.28571rem] text-mshop-white", children: r.badge }),
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-24-b text-mshop-black", children: r.title }),
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-m text-mshop-gray-80", children: r.description })
                    ] })
                  ]
                },
                r.title
              )) })
            ] })
          }
        ),
        /* @__PURE__ */ a.jsx(
          "section",
          {
            className: $("flex flex-col gap-y-[2.85714rem]", {
              "px-[1.14286rem]": t
            }),
            children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-24-b text-center text-mshop-black", children: "크리에이터 멤버십 FAQ" }),
              /* @__PURE__ */ a.jsx("div", { className: "flex max-w-[87.85714rem] flex-col gap-y-[1.14286rem]", children: n.map((r) => /* @__PURE__ */ a.jsx(Mv, { children: ({ open: s }) => /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    "flex flex-col rounded-[0.85714rem] px-[1.14286rem] pt-[1.14286rem]",
                    s ? "bg-mshop-blue-100 text-mshop-white" : "bg-mshop-blue-10 text-mshop-blue-100"
                  ),
                  children: [
                    /* @__PURE__ */ a.jsxs(V8, { className: "flex justify-between pb-[1.14286rem]", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: r.question }),
                      s ? /* @__PURE__ */ a.jsx(PH, { className: "size-[1.42857rem] fill-mshop-white" }) : /* @__PURE__ */ a.jsx(OH, { className: "size-[1.42857rem] fill-mshop-blue-100" })
                    ] }),
                    /* @__PURE__ */ a.jsx(
                      w2,
                      {
                        transition: !0,
                        className: $(
                          "whitespace-pre-line pb-[4.28571rem]",
                          t ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-m"
                        ),
                        children: r.answer
                      }
                    )
                  ]
                }
              ) }, r.question)) })
            ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex flex-col gap-y-[2.85714rem] px-[5.71429rem]", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-32-b text-mshop-black", children: "크리에이터 멤버십 FAQ" }),
              /* @__PURE__ */ a.jsx("div", { className: "flex w-full max-w-[87.85714rem] flex-col gap-y-[1.14286rem]", children: n.map((r) => /* @__PURE__ */ a.jsx(Mv, { children: ({ open: s }) => /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    "flex flex-col rounded-[1.71429rem] px-[4.28571rem] pt-[2rem]",
                    s ? "bg-mshop-blue-100 text-mshop-white" : "bg-mshop-blue-10 text-mshop-blue-100"
                  ),
                  children: [
                    /* @__PURE__ */ a.jsxs(V8, { className: "flex justify-between pb-[2rem]", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b", children: r.question }),
                      s ? /* @__PURE__ */ a.jsx(PH, { className: "size-[1.71429rem] fill-mshop-white" }) : /* @__PURE__ */ a.jsx(OH, { className: "size-[1.71429rem] fill-mshop-blue-100" })
                    ] }),
                    /* @__PURE__ */ a.jsx(
                      w2,
                      {
                        transition: !0,
                        className: "typo-mshop-kr-16-m whitespace-pre-line pb-[4.28571rem]",
                        children: r.answer
                      }
                    )
                  ]
                }
              ) }, r.question)) })
            ] })
          }
        ),
        /* @__PURE__ */ a.jsx(
          "section",
          {
            className: $(
              "flex-center flex",
              t ? "px-[1.14286rem]" : "px-[5.71429rem]"
            ),
            children: t ? /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsxs("div", { className: "flex-center relative flex h-[17.14285rem] w-full overflow-hidden rounded-[1.14286rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "absolute inset-0 h-full w-full", children: /* @__PURE__ */ a.jsx(
                aa,
                {
                  src: kt.Admin.StudioSection9Bg2,
                  width: "24.5rem",
                  height: "17.1429rem",
                  objectFit: "cover"
                }
              ) }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex-center z-10 flex flex-col gap-y-[1.14286rem]", children: [
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-20-b text-mshop-white", children: [
                  "멤버십을 만들고 싶은데",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "도움이 필요하신가요?"
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57142rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    fn,
                    {
                      variant: "lg",
                      theme: "line",
                      type: "button",
                      onClick: e.onContactButtonClick,
                      children: "마플샵에 문의하기"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    fn,
                    {
                      variant: "lg",
                      theme: "white",
                      type: "button",
                      onClick: e.onCreatorGuideClick,
                      children: "크리에이터 가이드"
                    }
                  )
                ] })
              ] })
            ] }) }) : /* @__PURE__ */ a.jsxs("div", { className: "flex-center relative flex h-[22.85714rem] w-full max-w-[87.85714rem] overflow-hidden rounded-[1.14286rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "absolute inset-0 h-full w-full", children: /* @__PURE__ */ a.jsx(
                aa,
                {
                  src: kt.Admin.StudioSection9Bg2,
                  width: "109.8571rem",
                  height: "61.7143rem",
                  objectFit: "cover"
                }
              ) }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex-center z-10 flex flex-col gap-y-[1.71429rem]", children: [
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-28-b text-mshop-white", children: [
                  "멤버십을 만들고 싶은데",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "도움이 필요하신가요?"
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    fn,
                    {
                      variant: "lg",
                      theme: "line",
                      type: "button",
                      onClick: e.onContactButtonClick,
                      children: "마플샵에 문의하기"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    fn,
                    {
                      variant: "lg",
                      theme: "white",
                      type: "button",
                      onClick: e.onCreatorGuideClick,
                      children: "크리에이터 가이드"
                    }
                  )
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
}
function a6e(e) {
  return /* @__PURE__ */ a.jsx(r6e, { ...e });
}
class Wje extends Ol {
  constructor({
    onContactButtonClick: t,
    onIntegratedPaidServiceTermsTextClick: n,
    onCreatorGuideClick: r,
    ...s
  }) {
    super(s), this.render = (o) => go(o).render(
      /* @__PURE__ */ a.jsx(
        a6e,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onError: this.onError,
          onScrollLock: this.onScrollLock,
          onContactButtonClick: this.onContactButtonClick,
          onCreatorGuideClick: this.onCreatorGuideClick,
          onIntegratedPaidServiceTermsTextClick: this.onIntegratedPaidServiceTermsTextClick
        }
      )
    ), this.onContactButtonClick = t, this.onIntegratedPaidServiceTermsTextClick = n, this.onCreatorGuideClick = r;
  }
}
async function s6e(e, t) {
  return jn(
    "/commission-settings",
    {
      body: e
    },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
        return n;
      default:
        throw new Error("postCommissionSettings");
    }
  });
}
const nr = {
  Hidden: "HIDDEN",
  Open: "OPEN",
  Close: "CLOSED",
  Deleted: "DELETED",
  Paused: "PAUSED"
};
async function i6e(e, t) {
  return jn(
    "/create-commission",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.Maximum:
      case le.InvalidImage:
      case le.BadWordName:
        return n;
      default:
        throw new Error("postCreateCommission");
    }
  });
}
async function o6e(e, t) {
  return jn(
    "/delete-commission",
    {
      body: e
    },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.WorkInProcess:
        return n;
      default:
        throw new Error("PostDeleteCommission");
    }
  });
}
async function l6e(e, t) {
  return jn(
    "/update-commission",
    { body: e },
    t
  ).then((n) => {
    switch (n.code) {
      case le.Success:
      case le.TokenExpired:
      case le.Maximum:
      case le.InvalidImage:
      case le.BadWordName:
      case le.WorkInProcess:
        return n;
      default:
        throw new Error("postUpdateCommission");
    }
  });
}
const c6e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_2883_73276)" }, /* @__PURE__ */ re.createElement("path", { d: "M20.4 3.54004H3.6C2.72 3.54004 2 4.26004 2 5.14004V18.86C2 19.74 2.72 20.46 3.6 20.46H20.4C21.28 20.46 22 19.74 22 18.86V5.14004C22 4.26004 21.28 3.54004 20.4 3.54004ZM15.82 9.53004C15.78 9.75004 15.67 9.96004 15.5 10.12C15.34 10.28 15.13 10.39 14.91 10.44C14.69 10.48 14.45 10.46 14.24 10.37C14.03 10.28 13.85 10.13 13.72 9.94004C13.59 9.75004 13.53 9.53004 13.53 9.30004C13.53 8.99004 13.65 8.70004 13.87 8.48004C14.09 8.26004 14.38 8.14004 14.69 8.14004C14.92 8.14004 15.14 8.21004 15.33 8.33004C15.52 8.46004 15.67 8.64004 15.76 8.85004C15.85 9.06004 15.87 9.29004 15.83 9.52004L15.82 9.53004ZM8.24 10.52C8.33 10.48 8.43 10.46 8.53 10.46C8.63 10.46 8.73 10.48 8.82 10.52C8.91 10.56 9 10.62 9.07 10.69L10.07 11.69L15.55 17.17C15.6 17.22 15.67 17.26 15.74 17.29C15.76 17.3 15.78 17.32 15.8 17.33C16.12 17.48 16.52 17.43 16.79 17.16C17.13 16.82 17.13 16.26 16.79 15.92L15.09 14.22L16.32 12.99C16.46 12.85 16.66 12.77 16.86 12.77C17.06 12.77 17.26 12.85 17.4 12.99L20.24 15.83V18.71H3.75V14.93L7.99 10.68C8.06 10.61 8.15 10.55 8.24 10.51V10.52Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_2883_73276" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), u6e = yn(c6e), Ma = {
  PersonalUseOnly: "PERSONAL_USE_ONLY",
  NonCommercial: "NON_COMMERCIAL",
  NonCommercialDerivative: "NON_COMMERCIAL_DERIVATIVE",
  Commercial: "COMMERCIAL",
  CommercialDerivative: "COMMERCIAL_DERIVATIVE",
  Custom: "CUSTOM",
  CreditRequired: "CREDIT_REQUIRED",
  UnRestricted: "UNRESTRICTED"
}, co = {
  [Ma.Custom]: {
    name: "직접 입력",
    description: null
  },
  [Ma.PersonalUseOnly]: {
    name: "개인 소장용",
    description: "구매자 본인만 감상 가능하며, 복제, 배포, 2차 가공 및 상업적 이용이 모두 금지됩니다."
  },
  [Ma.NonCommercial]: {
    name: "비영리적 이용 허용",
    description: "비영리적 목적으로만 사용 가능하며, 상업적 이용, 2차 가공 및 배포는 금지됩니다."
  },
  [Ma.NonCommercialDerivative]: {
    name: "상업적 이용 금지 및 2차 가공 허용",
    description: "비상업적 목적에 한해 2차 가공 및 공유가 가능하며, 상업적 이용은 금지됩니다."
  },
  [Ma.Commercial]: {
    name: "상업적 이용 허용",
    description: "상업적 목적(광고 등)으로 사용 가능하며, 2차 가공은 금지됩니다."
  },
  [Ma.CommercialDerivative]: {
    name: "상업적 이용 및 2차 가공 허용",
    description: "상업적 목적의 사용과 2차 가공이 모두 허용됩니다"
  },
  [Ma.CreditRequired]: {
    name: "크레딧 표기 필수",
    description: "사용 시 크리에이터 이름을 반드시 표기해야 합니다."
  },
  [Ma.UnRestricted]: {
    name: "제한 없는 자유 이용",
    description: "개인, 비영리, 상업적 목적으로 제한 없이 사용 가능하며, 복제 및 2차 가공도 허용됩니다."
  }
}, Ny = Qt(Vn), d6e = Qt(
  null,
  (e, t, n) => {
    const r = e(Ny);
    if (r === Vn)
      throw new Error(Xr(ia.SettingCommissions));
    t(Ny, [
      ...r.filter(
        (s) => s.state !== nr.Close
      ),
      n,
      ...r.filter(
        (s) => s.state === nr.Close
      )
    ]);
  }
), f6e = Qt(
  null,
  (e, t, n) => {
    const r = e(Ny);
    if (r === Vn)
      throw new Error(Xr(ia.SettingCommissions));
    t(
      Ny,
      r.map(
        (s) => s.id === n.id ? n : s
      )
    );
  }
), m6e = Qt(
  null,
  (e, t, n) => {
    const r = e(Ny);
    if (r === Vn)
      throw new Error(Xr(ia.SettingCommissions));
    t(
      Ny,
      r.filter((s) => s.id !== n)
    );
  }
), h6e = Qt(
  null,
  (e, t, n) => {
    const r = e(Ny);
    if (r === Vn)
      throw new Error(Xr(ia.SettingCommissions));
    t(Ny, [
      ...r.filter((s) => s.id !== n.id),
      n
    ]);
  }
);
function p6e() {
  const [e, t] = Ar(
    Ny
  );
  if (e === Vn)
    throw new Error(Xr(ia.SettingCommissions));
  const n = Ka(d6e), r = Ka(
    f6e
  ), s = Ka(
    m6e
  ), o = Ka(
    h6e
  );
  return {
    settingCommissions: e,
    setSettingCommissions: t,
    setAddSettingCommission: n,
    setUpdateSettingCommission: r,
    setDeleteSettingCommission: s,
    setMoveToEndSettingCommission: o
  };
}
function g6e(e) {
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...e,
      className: $(
        "flex-center size-[3.14285rem] flex-shrink-0 rounded-[.28571rem]",
        e.disabled ? "bg-mshop-gray-50" : "bg-mshop-blue-100"
      ),
      children: /* @__PURE__ */ a.jsx(vE, { className: "size-[2rem] text-mshop-white" })
    }
  );
}
const y6e = ["png", "jpg", "jpeg", "gif"], v6e = 5 * 1024 * 1024, x6e = yn(
  ({
    name: e,
    title: t,
    recommended: n,
    onLoading: r,
    onError: s,
    onSuccess: o,
    client: c,
    minImageWidth: u,
    minImageHeight: m,
    disabled: y = !1
  }, b) => {
    const w = async (E) => {
      wt(E.currentTarget.files);
      const T = E.currentTarget.files[0];
      await k(T) && await j(T);
    }, k = async (E) => y6e.includes(E.type.split("/")[1]) ? E.size > v6e ? (s("이미지 크기는 5MB 이하로 업로드해 주세요."), !1) : await aO(E, u, m) ? !0 : (s("이미지 해상도가 너무 낮습니다. 권장 크기를 확인해 주세요."), !1) : (s("PNG, JPG, JPEG, GIF 형식의 이미지만 업로드해 주세요."), !1), j = async (E) => {
      const T = await sO(E, {
        quality: 0.8,
        maxWidth: 120,
        maxHeight: 120
      });
      r(!0), o(T);
      const { code: D, data: L } = await cw({}, { client: c, onError: s });
      if (D === le.TokenExpired)
        return s(Ht);
      (await fetch(L.uploadUrl, {
        method: "PUT",
        referrerPolicy: "no-referrer-when-downgrade",
        headers: {
          "Content-Type": E.type
        },
        cache: "no-store",
        body: E
      })).status === 200 ? (o(L.url), r(!1)) : s("이미지 업로드 실패");
    };
    return /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex max-w-[35.71428rem] cursor-pointer gap-x-[1.14285rem] rounded-[0.14285rem] p-[1.14285rem]",
          y ? "bg-mshop-gray-5" : "bg-mshop-blue-10"
        ),
        onClick: () => {
          var E;
          typeof b != "function" && !y && ((E = b == null ? void 0 : b.current) == null || E.click());
        },
        children: [
          /* @__PURE__ */ a.jsx(g6e, { type: "button", disabled: y }),
          /* @__PURE__ */ a.jsx(
            "input",
            {
              name: e,
              type: "file",
              ref: b,
              className: "hidden",
              multiple: !1,
              accept: ".png, .jpg, .jpeg, .gif",
              onChange: w
            }
          ),
          /* @__PURE__ */ a.jsxs("div", { children: [
            /* @__PURE__ */ a.jsx(
              "p",
              {
                className: $(
                  "typo-mshop-kr-14-b",
                  y ? "text-mshop-gray-50" : "text-mshop-blue-100"
                ),
                children: t
              }
            ),
            /* @__PURE__ */ a.jsxs(
              "p",
              {
                className: $(
                  "typo-mshop-kr-14-m",
                  y ? "text-mshop-gray-50" : "text-mshop-gray-80"
                ),
                children: [
                  "권장 : ",
                  n,
                  " / PNG, JPG, GIF 형식 / 5MB 이하"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
);
function b6e({
  show: e,
  onClose: t,
  imgUrl: n,
  title: r,
  descriptions: s,
  confirmButton: o,
  guidLineButton: c
}) {
  return /* @__PURE__ */ a.jsx(Zu, { show: e, onClose: t, children: /* @__PURE__ */ a.jsxs("div", { className: "flex w-[32rem] min-w-[20.57142rem] flex-col overflow-hidden rounded-[1.14285rem] bg-mshop-blue-100", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "relative flex h-[25.71429rem] flex-col items-center justify-end", children: [
      /* @__PURE__ */ a.jsx(
        "button",
        {
          type: "button",
          className: "flex-center absolute right-[.57143rem] top-[.57143rem] size-[2.85714rem] rounded-full bg-mshop-dim-10",
          onClick: t,
          children: /* @__PURE__ */ a.jsx(Zg, { className: "size-[1.42857rem] fill-mshop-white" })
        }
      ),
      /* @__PURE__ */ a.jsx("div", { className: "absolute left-1/2 top-1/2 size-[24rem] -translate-x-1/2 -translate-y-1/2 transform", children: /* @__PURE__ */ a.jsx(
        aa,
        {
          width: "24rem",
          height: "24rem",
          src: n,
          objectFit: "cover"
        }
      ) }),
      /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-en-40-bebas-b absolute mb-[2.28571rem] text-center text-mshop-white", children: r })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[2.28571rem] bg-mshop-white p-[1.71428rem]", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center gap-y-[.85714rem]", children: [
        /* @__PURE__ */ a.jsx("ul", { className: "typo-mshop-kr-14-m w-full list-disc whitespace-pre-wrap pl-[1.42857rem] text-mshop-black", children: s.map((u, m) => /* @__PURE__ */ a.jsx("li", { children: u }, u + m)) }),
        /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            className: "typo-mshop-kr-14-m w-fit text-mshop-blue-100 underline underline-offset-8",
            onClick: c.onClick,
            children: c.title
          }
        )
      ] }),
      /* @__PURE__ */ a.jsx(
        za,
        {
          variant: "md",
          theme: "blue",
          widthFull: !0,
          type: "button",
          onClick: o.onClick,
          children: o.title
        }
      )
    ] })
  ] }) });
}
const S6e = ["png", "jpg", "jpeg", "gif"], w6e = 5 * 1024 * 1024, C6e = [
  {
    title: "커미션 정보 입력",
    description: `커미션 이름, 소개 등 기본 정보를 입력해 주세요.
팬들이 커미션 작업 내용을 이해하기 쉽도록 상세하게 작성해 주세요!`,
    imgSrc: kt.Admin.CommissionGuideModalStep1
  },
  {
    title: "작업 안내 설정",
    description: "어떤 작업물이 제공되는지 작업 안내 이미지로 예시를 보여주세요. 작업 상세 내용, 작업물 이용 범위, 사전 질문 제목을 활용해 신청자가 작업을 정확히 이해하고 요청할 수 있도록 해주세요.",
    imgSrc: kt.Admin.CommissionGuideModalStep2
  },
  {
    title: "커미션 판매 시작",
    description: `내 팬들에게 보다 특별한 선물을, 마플샵 크리에이터 커미션
마플샵 커미션으로 나만의 재능을 담은 특별한 창작물로 수익을 만들어 보세요!`,
    imgSrc: kt.Admin.CommissionGuideModalStep3
  }
], UH = [
  {
    value: Ma.Custom,
    name: co[Ma.Custom].name,
    description: null
  },
  {
    value: Ma.PersonalUseOnly,
    name: co[Ma.PersonalUseOnly].name,
    description: co[Ma.PersonalUseOnly].description
  },
  {
    value: Ma.NonCommercial,
    name: co[Ma.NonCommercial].name,
    description: co[Ma.NonCommercial].description
  },
  {
    value: Ma.NonCommercialDerivative,
    name: co[Ma.NonCommercialDerivative].name,
    description: co[Ma.NonCommercialDerivative].description
  },
  {
    value: Ma.Commercial,
    name: co[Ma.Commercial].name,
    description: co[Ma.Commercial].description
  },
  {
    value: Ma.CommercialDerivative,
    name: co[Ma.CommercialDerivative].name,
    description: co[Ma.CommercialDerivative].description
  },
  {
    value: Ma.CreditRequired,
    name: co[Ma.CreditRequired].name,
    description: co[Ma.CreditRequired].description
  },
  {
    value: Ma.UnRestricted,
    name: co[Ma.UnRestricted].name,
    description: co[Ma.UnRestricted].description
  }
], zH = {
  [nr.Open]: {
    name: "판매 중",
    color: "bg-mshop-blue-100 text-mshop-white"
  },
  [nr.Paused]: {
    name: "일시 중단",
    color: "bg-mshop-gray-5 text-mshop-gray-80"
  },
  [nr.Close]: {
    name: "종료",
    color: "bg-mshop-gray-5 text-mshop-gray-80"
  }
}, N6e = "새로운 커미션", BH = 6;
function j6e({
  projectId: e,
  client: t,
  isMobile: n,
  isApp: r,
  toggleSpinner: s,
  onScrollLock: o,
  onError: c,
  fetchedSettingsCommissions: u,
  onTermsTextClick: m,
  onCreatorGuideTextClick: y,
  onCheckMyCommissionButtonClick: b
}) {
  var bn, mr, ur, _r, ai, ls, Ot, En, Xt, qt, In;
  Al([
    [ol, t],
    [
      ll,
      {
        isMobile: n,
        isApp: r,
        toggleSpinner: s,
        onError: c,
        onScrollLock: o
      }
    ],
    [R1, e],
    [Ny, u]
  ]);
  const [w, k] = Re(!1), [j, E] = Re(((bn = u[0].sampleImages[0]) == null ? void 0 : bn.url) || null), T = Rt(null), [D, L] = Re(!1), [I, R] = Re(!1), [U, z] = Re(u[0]), [H, K] = Re(
    u[0].state !== nr.Hidden
  );
  an(() => {
    Ue(
      u[0].sampleImages.map((st) => st.url)
    );
  }, []);
  const q = (st) => ({
    state: st.state,
    thumbnailImageUrl: st.thumbnailImage.url,
    displayName: st.displayName,
    description: st.description,
    estimatedTime: st.id === Tv ? null : st.estimatedTime,
    price: st.id === Tv ? "" : st.price.toLocaleString(cr.Ko),
    sampleImageUrls: st.sampleImages.map(
      (lt) => lt.url
    ),
    workDescription: st.workDescription,
    license: st.license,
    licenseText: st.licenseText,
    preQuestion: st.preQuestion
  }), {
    register: Q,
    setValue: Z,
    watch: X,
    clearErrors: se,
    formState: { errors: te, isDirty: fe, isValid: ce },
    setError: pe,
    reset: Se,
    getValues: oe
  } = bp({
    reValidateMode: "onChange",
    mode: "onChange",
    defaultValues: q(u[0])
  }), {
    isUploading: ue,
    ref: he,
    handleClickUploadImage: ve,
    handleRemoveUploadedImage: Te,
    handleChangeFileInput: Ie,
    handleResetUploadedImage: Ue,
    handleValidateImageFiles: qe
  } = hA({ maxUploadCount: BH }), {
    settingCommissions: it,
    setSettingCommissions: Ne,
    setAddSettingCommission: Xe,
    setUpdateSettingCommission: xt,
    setDeleteSettingCommission: rn,
    setMoveToEndSettingCommission: vt
  } = p6e(), At = async () => fe ? await ho({
    body: (st, lt) => /* @__PURE__ */ a.jsx(
      qu,
      {
        confirmButton: {
          props: st,
          text: "삭제"
        },
        cancelButton: {
          props: lt
        },
        children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "저장되지 않은 입력 내용" }),
          /* @__PURE__ */ a.jsxs("div", { children: [
            "입력한 내용이 저장되지 않았습니다.",
            /* @__PURE__ */ a.jsx("br", {}),
            "저장하지 않고 내용을 삭제할까요?"
          ] })
        ] })
      }
    )
  }) : !0, He = (st) => {
    K(st.state !== nr.Hidden), z(st), Se(q(st));
    const lt = (st.sampleImages || []).length === 0 ? null : st.sampleImages.map((Nt) => Nt.url);
    E(lt ? lt[0] : null), Ue(lt);
  }, Pt = async (st) => {
    if (st.map((Nt) => Nt.id).join("_") === (it == null ? void 0 : it.map((Nt) => Nt.id).join("_")))
      return;
    Ne(st);
    const { code: lt } = await eO(
      {
        projectId: e,
        type: nO.Commission,
        items: st.map((Nt) => ({
          id: Nt.id
        }))
      },
      { client: t, onError: c }
    );
    if (lt === le.TokenExpired)
      return c(Ht);
  }, Lt = async () => {
    if (U.id !== Tv && await At()) {
      if (it.filter(
        (st) => st.state !== nr.Close
      ).length >= 10) {
        await en({
          body: (st) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: st
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 개수 초과" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "최대 10개의 플랜만 생성할 수 있습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "추가 커미션을 만들려면 기존 커미션을 삭제해 주세요."
                ] })
              ] })
            }
          )
        });
        return;
      }
      Xe(r3), He(r3);
    }
  }, er = async () => {
    const {
      licenseText: st,
      license: lt,
      price: Nt,
      preQuestion: Wt,
      estimatedTime: wn,
      ...pt
    } = oe();
    wt(lt), wt(Nt), wt(wn), s(!0);
    const hr = await i6e(
      {
        projectId: e,
        ...pt,
        license: lt,
        price: Number(Nt),
        estimatedTime: Number(wn),
        ...st !== null && { licenseText: st },
        ...Wt && { preQuestion: Wt }
      },
      { client: t, onError: c }
    );
    s(!1), hr.code === le.Success ? (rn(Tv), L(!0), Xe(hr.data), He(hr.data)) : await Pe(hr);
  }, It = async (st, lt) => {
    const { license: Nt, estimatedTime: Wt, ...wn } = st;
    wt(Nt), wt(Wt);
    let pt = {};
    return lt !== nr.Close && (pt = {
      thumbnailImageUrl: Kl(
        U.thumbnailImage.url,
        wn.thumbnailImageUrl
      ),
      displayName: Kl(
        U.displayName,
        wn.displayName
      ),
      description: Kl(
        U.description,
        wn.description
      ),
      estimatedTime: Kl(
        U.estimatedTime,
        Number(Wt)
      ),
      sampleImageUrls: Kl(
        U.sampleImages.map((hr) => hr.url),
        wn.sampleImageUrls
      ),
      workDescription: Kl(
        U.workDescription,
        wn.workDescription
      ),
      ...wn.licenseText !== null && {
        licenseText: Kl(
          U.licenseText || "",
          wn.licenseText
        )
      },
      preQuestion: Kl(
        U.preQuestion || null,
        wn.preQuestion || null
      ),
      license: Kl(U.license, Nt)
    }), await l6e(
      {
        commissionId: U.id,
        state: lt,
        ...pt
      },
      { client: t, onError: c }
    );
  }, ye = async () => {
    const st = U.state !== nr.Paused && X("state") === nr.Paused;
    let lt;
    if (st)
      lt = await ho({
        body: (Wt, wn) => /* @__PURE__ */ a.jsx(
          qu,
          {
            confirmButton: {
              props: Wt,
              text: "일시 중단하기"
            },
            cancelButton: {
              props: wn
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.86rem]", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 일시 중단" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                "일시 중단하면 더 이상 새로운 신청을 받을 수 없습니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "접수된 신청서는 기한 내에 작업을 완료해 주세요."
              ] })
            ] })
          }
        )
      });
    else {
      const Wt = U.statusCount.PENDING > 0 || U.statusCount.ACCEPTED + U.statusCount.TASK_DONE > 0;
      lt = await ho({
        body: (wn, pt) => Wt ? /* @__PURE__ */ a.jsx(
          V9,
          {
            confirmButton: {
              props: wn,
              text: "변경 저장하기"
            },
            cancelButton: {
              props: pt
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14285rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { children: [
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 변경 저장" }),
                /* @__PURE__ */ a.jsx("p", { className: "mt-[0.28571rem]", children: "변경 적용 전 다음 사항을 꼭 확인해 주세요." })
              ] }),
              /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m list-disc rounded-lg bg-mshop-gray-5 py-[0.57143rem] pl-[2.28571rem] pr-[0.57143rem] text-left text-mshop-gray-80", children: [
                /* @__PURE__ */ a.jsx("li", { children: "변경 내용은 저장 즉시 반영됩니다." }),
                /* @__PURE__ */ a.jsx("li", { children: "변경 저장 이후 접수되는 신청부터 변경된 내용이 적용됩니다." })
              ] }),
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m rounded-lg bg-mshop-red-10 px-[0.85714rem] py-[0.57143rem] text-center text-mshop-red-80", children: "이미 접수된 신청서는 변경 전 내용으로 진행해 주세요." })
            ] })
          }
        ) : /* @__PURE__ */ a.jsx(
          qu,
          {
            confirmButton: {
              props: wn,
              text: "변경 저장하기"
            },
            cancelButton: {
              props: pt
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.86rem]", children: [
              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 변경 저장" }),
              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                "변경된 내용으로 바로 적용됩니다.",
                /* @__PURE__ */ a.jsx("br", {}),
                "커미션을 변경하시겠어요?"
              ] })
            ] })
          }
        )
      });
    }
    if (!lt)
      return;
    s(!0);
    const Nt = await It(
      oe(),
      X("state")
    );
    s(!1), Nt.code === le.Success ? (xt(Nt.data), He(Nt.data), await en({
      body: (Wt) => /* @__PURE__ */ a.jsx(
        sa,
        {
          button: {
            props: Wt
          },
          children: /* @__PURE__ */ a.jsx(a.Fragment, { children: st ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 일시 중단 완료" }),
            /* @__PURE__ */ a.jsxs("div", { children: [
              "커미션이 일시 중단 되었습니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "수락 대기 신청서는 수락 여부를 결정해 주세요.",
              /* @__PURE__ */ a.jsx("br", {}),
              "작업 중 신청서는 기한 내 작업을 완료해 주세요."
            ] })
          ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "변경 저장 완료" }),
            /* @__PURE__ */ a.jsx("div", { children: "커미션 내용이 변경되었습니다." })
          ] }) })
        }
      )
    })) : await Pe(Nt);
  }, ke = async () => {
    if (U.statusCount.PENDING > 0 || U.statusCount.ACCEPTED + U.statusCount.TASK_DONE > 0) {
      await en({
        body: (Wt) => /* @__PURE__ */ a.jsx(
          sa,
          {
            button: {
              props: Wt
            },
            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 종료 불가" }),
              /* @__PURE__ */ a.jsxs("div", { children: [
                "수락 대기, 작업 중, 작업 완료 상태가 있는 ",
                /* @__PURE__ */ a.jsx("br", {}),
                "커미션은 종료할 수 없습니다."
              ] })
            ] })
          }
        )
      });
      return;
    }
    if (!await ho({
      body: (Wt, wn) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: Wt,
            text: "종료하기"
          },
          cancelButton: {
            props: wn
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.143rem]", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 종료" }),
            /* @__PURE__ */ a.jsxs("p", { className: "mt-[0.286rem]", children: [
              "종료된 커미션은 다시 판매할 수 없으니",
              /* @__PURE__ */ a.jsx("br", {}),
              "신중히 결정해 주세요."
            ] })
          ] })
        }
      )
    }))
      return;
    s(!0);
    const Nt = await It(
      oe(),
      nr.Close
    );
    switch (s(!1), Nt.code) {
      case le.Success:
        vt(Nt.data), He(Nt.data), await en({
          body: (Wt) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Wt
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 종료 완료" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "커미션이 종료되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "새로운 커미션을 만들어보세요!"
                ] })
              ] })
            }
          )
        });
        return;
      default:
        await Pe(Nt);
    }
  }, Pe = async (st) => {
    switch (st.code) {
      case le.BadWordName: {
        const lt = st.data.column;
        pe(lt, {
          message: lt === "displayName" ? "부적절한 단어가 포함되어 있습니다. 다른 이름을 입력해 주세요." : "부적절한 단어가 포함되어 있습니다. 입력 텍스트를 확인해 주세요."
        });
        return;
      }
      case le.WorkInProcess:
      case le.TokenExpired:
        return c(Ht);
      default:
        await en({
          body: (lt) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: lt
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "예기치 못한 오류로 인해 진행할 수 없습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "동일한 문제가 반복적으로 발생할 경우",
                  /* @__PURE__ */ a.jsx("br", {}),
                  /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                  "로 문의해 주세요."
                ] })
              ] })
            }
          )
        }), Se();
    }
  }, tt = async () => {
    if (!await ho({
      body: (Nt, Wt) => /* @__PURE__ */ a.jsx(
        qu,
        {
          confirmButton: {
            props: Nt,
            color: "red",
            text: "삭제하기"
          },
          cancelButton: {
            props: Wt
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.143rem]", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 삭제" }),
            /* @__PURE__ */ a.jsxs("p", { className: "mt-[0.286rem]", children: [
              "삭제된 커미션은 복구가 불가능합니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "커미션을 삭제하시겠어요?"
            ] })
          ] })
        }
      )
    }))
      return;
    s(!0);
    const lt = await o6e(
      { commissionId: U.id },
      { client: t, onError: c }
    );
    switch (s(!1), lt.code) {
      case le.Success: {
        await en({
          body: (Wt) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Wt
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 삭제 완료" }),
                /* @__PURE__ */ a.jsxs("div", { children: [
                  "커미션이 삭제되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "새로운 커미션을 만들어보세요!"
                ] })
              ] })
            }
          )
        });
        const Nt = it.filter(
          (Wt) => Wt.id !== U.id
        );
        rn(U.id), Nt.length === 0 ? (Xe(r3), He(r3)) : He(Nt[0]);
        return;
      }
      case le.TokenExpired:
        c(Ht);
        return;
      default:
        await en({
          body: (Nt) => /* @__PURE__ */ a.jsx(
            sa,
            {
              button: {
                props: Nt
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "예기치 못한 오류로 인해 진행할 수 없습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "동일한 문제가 반복적으로 발생할 경우",
                  /* @__PURE__ */ a.jsx("br", {}),
                  /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                  "로 문의해 주세요."
                ] })
              ] })
            }
          )
        }), Se();
    }
  }, ot = async (st) => {
    const lt = st.currentTarget.files;
    switch (wt(lt), await qe(lt, {
      imageFormats: S6e,
      maxFileSize: w6e,
      minImageResolution: 460
    })) {
      case Wg.FileTooLarge:
        pe("sampleImageUrls", {
          message: "이미지 크기는 5MB 이하로 업로드해 주세요."
        });
        return;
      case Wg.LowResolution:
        pe("sampleImageUrls", {
          message: "이미지 해상도가 너무 낮습니다. 권장 크기를 확인해 주세요."
        });
        return;
      case Wg.InvalidFormat:
        pe("sampleImageUrls", {
          message: "PNG, JPG, JPEG, GIF 형식의 이미지만 업로드해 주세요."
        });
        return;
      default:
        se("sampleImageUrls");
    }
    await Ie({ files: lt, onSuccess: (wn) => {
      E(wn[wn.length - 1]), Z("sampleImageUrls", wn, {
        shouldValidate: !0,
        shouldDirty: !0
      }), se("sampleImageUrls");
    } });
  }, ut = async (st) => {
    const lt = X("sampleImageUrls").findIndex(
      (Wt) => Wt === j
    );
    Te(lt, (Wt) => {
      E(Wt[0] ?? null), Z("sampleImageUrls", Wt, {
        shouldValidate: !0,
        shouldDirty: !0
      });
    })(st);
  }, Vt = (st) => {
    const lt = X(st);
    lt !== null && Z(st, lt.trim(), {
      shouldValidate: !0
    });
  };
  return /* @__PURE__ */ a.jsx("div", { className: "twp", children: n ? /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex flex-col bg-mshop-white px-[1.14286rem] pt-[6.85714rem] text-center text-mshop-black", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.57143rem]", children: [
      /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-24-b", children: [
        "커미션 만들기 기능은",
        /* @__PURE__ */ a.jsx("br", {}),
        "PC에서 이용해 주세요."
      ] }),
      /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m", children: [
        "더 나은 경험을 위해 PC 마플샵 스튜디오로",
        /* @__PURE__ */ a.jsx("br", {}),
        "커미션을 만들고 관리해 보세요."
      ] })
    ] }),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: "size-[20rem] bg-cover bg-center bg-no-repeat",
        style: {
          backgroundImage: `url(${kt.Admin.CommissionCreateMobile})`
        }
      }
    )
  ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs("form", { className: "mb-[20rem] w-full", children: [
      /* @__PURE__ */ a.jsxs(
        "header",
        {
          className: "flex w-full flex-col gap-y-[0.571rem]",
          id: "commission-create-header",
          children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-start gap-x-[0.571rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-28-b text-mshop-black", children: "커미션 만들기" }),
              /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  onClick: () => R(!0),
                  className: "py-[0.28571rem]",
                  children: /* @__PURE__ */ a.jsx(tO, { className: "size-[1.42857rem] fill-mshop-black" })
                }
              )
            ] }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "나만의 재능을 담은 커미션을 만들어 팬들에게 창작물을 제공해 보세요!" })
          ]
        }
      ),
      /* @__PURE__ */ a.jsxs("main", { className: "mt-[2.86rem] flex h-full gap-x-[1.14286rem]", children: [
        /* @__PURE__ */ a.jsxs(
          "section",
          {
            className: "flex h-[57.14285rem] w-[20rem] flex-shrink-0 flex-col gap-y-[1.71428rem] overflow-hidden rounded-[.57142rem] bg-mshop-gray-5 px-[1.14286rem] py-[1.71429rem]",
            id: "commission-create-plan-list",
            children: [
              /* @__PURE__ */ a.jsx("div", { className: "overflow-y-auto", children: /* @__PURE__ */ a.jsx(
                gw.ReactSortable,
                {
                  className: "flex flex-col gap-y-[.28571rem]",
                  list: it,
                  setList: Pt,
                  animation: 150,
                  handle: ".sortable-handle",
                  draggable: ".sortable-item",
                  children: it.map((st) => /* @__PURE__ */ a.jsxs(
                    "button",
                    {
                      type: "button",
                      className: $(
                        "flex-0 flex min-h-[2.85714rem] items-center gap-x-[0.28571rem] rounded-[0.28571rem] border bg-mshop-white px-[0.85714rem]",
                        {
                          "border-mshop-blue-100": U.id === st.id
                        },
                        {
                          "sortable-item": st.state !== nr.Close
                        }
                      ),
                      onClick: async () => {
                        if (U.id !== st.id) {
                          if (!await At())
                            return;
                          rn(Tv), He(st);
                        }
                      },
                      children: [
                        /* @__PURE__ */ a.jsx("div", { className: "size-[1.14285rem] flex-shrink-0", children: nr.Close !== U.state && U.id === st.id && U.id !== Tv ? /* @__PURE__ */ a.jsx(yw, { className: "sortable-handle size-full cursor-pointer fill-mshop-gray-20" }) : /* @__PURE__ */ a.jsx("div", { className: "bg-transparent" }) }),
                        /* @__PURE__ */ a.jsx(
                          "span",
                          {
                            className: $(
                              "typo-mshop-kr-14-m line-clamp-1 flex-grow text-ellipsis text-start",
                              {
                                "text-mshop-black": st.state !== nr.Close && U.id === st.id
                              },
                              {
                                "text-mshop-gray-50 hover:text-mshop-black": st.state !== nr.Close && U.id !== st.id
                              },
                              {
                                "text-mshop-gray-50": st.state === nr.Close
                              }
                            ),
                            children: st.id === Tv ? N6e : st.displayName
                          }
                        ),
                        nr.Close === st.state && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m flex-shrink-0 text-mshop-gray-50", children: "종료" })
                      ]
                    },
                    st.id
                  ))
                }
              ) }),
              /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx(
                za,
                {
                  widthFull: !0,
                  variant: "sm",
                  theme: "blue",
                  iconFront: "add",
                  type: "button",
                  onClick: Lt,
                  children: "커미션 만들기"
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs("div", { className: "flex min-w-[37.57143rem] max-w-[85.71429rem] flex-1 flex-col gap-y-[1.14rem]", children: [
          /* @__PURE__ */ a.jsxs(
            "section",
            {
              className: "flex w-full flex-col rounded-[0.57143rem] border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]",
              id: "commission-create-info-section",
              children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b mb-[1.14rem] text-mshop-black", children: "커미션 정보" }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.71rem]", children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "커미션 이름", required: !0 }),
                    /* @__PURE__ */ a.jsx(
                      M8,
                      {
                        ...Q("displayName", {
                          ...Ss.commissionDisplayName,
                          validate: {
                            notOnlySpecialChars: (st) => rO(st) ? "특수문자만으로 이름을 작성할 수 없습니다. 문자를 포함해 입력해 주세요." : !0
                          }
                        }),
                        disabled: nr.Close === U.state,
                        watch: X("displayName"),
                        maxLength: Ss.commissionDisplayName.maxLength.value,
                        placeholder: "커미션 이름을 설정해 주세요.",
                        invalid: !!te.displayName,
                        onBlur: () => {
                          Vt("displayName");
                        }
                      }
                    ),
                    ((mr = te.displayName) == null ? void 0 : mr.message) && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: te.displayName.message
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "커미션 소개", required: !0 }),
                    /* @__PURE__ */ a.jsx(
                      vy,
                      {
                        ...Q(
                          "description",
                          Ss.commissionDescription
                        ),
                        disabled: nr.Close === U.state,
                        watch: X("description"),
                        maxLength: Ss.commissionDescription.maxLength.value,
                        placeholder: "커미션에 대해 간략하게 소개해 주세요.",
                        invalid: !!te.description,
                        onBlur: () => {
                          Vt("description");
                        }
                      }
                    ),
                    ((ur = te.description) == null ? void 0 : ur.message) && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: te.description.message
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "썸네일 이미지", required: !0 }),
                    X("thumbnailImageUrl") ? /* @__PURE__ */ a.jsxs("div", { className: "relative h-[28.57143rem] w-[28.57143rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        "img",
                        {
                          src: X("thumbnailImageUrl"),
                          alt: "",
                          className: "h-full w-full rounded-[0.57142rem] object-cover"
                        }
                      ),
                      nr.Close !== U.state && /* @__PURE__ */ a.jsx(
                        "button",
                        {
                          type: "button",
                          className: "flex-center absolute -right-[0.571rem] -top-[0.571rem] h-[2.28571rem] w-[2.28571rem] rounded-full bg-mshop-gray-80",
                          onClick: () => Z("thumbnailImageUrl", "", {
                            shouldValidate: !0,
                            shouldDirty: !0
                          }),
                          children: /* @__PURE__ */ a.jsx(Wd, { className: "h-[0.85714rem] w-[0.85714rem] fill-mshop-white" })
                        }
                      )
                    ] }) : /* @__PURE__ */ a.jsx(
                      x6e,
                      {
                        minImageHeight: 664,
                        minImageWidth: 664,
                        ...Q(
                          "thumbnailImageUrl",
                          Ss.commissionThumbnailImageUrl
                        ),
                        title: "커미션 썸네일 이미지를 업로드해 주세요.",
                        ref: T,
                        recommended: "비율 1:1, 664px 이상",
                        onLoading: (st) => k(st),
                        onError: (st) => pe("thumbnailImageUrl", { message: st }),
                        onSuccess: (st) => Z("thumbnailImageUrl", st, {
                          shouldValidate: !0,
                          shouldDirty: !0
                        }),
                        client: t
                      }
                    ),
                    ((_r = te.thumbnailImageUrl) == null ? void 0 : _r.message) && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: te.thumbnailImageUrl.message
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.71rem] 2xl:flex-row 2xl:gap-[0.85714rem]", children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 flex-col gap-y-[0.571rem]", children: [
                      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.29rem]", children: [
                        /* @__PURE__ */ a.jsx(Fs, { label: "예상 작업 기간", required: !0 }),
                        /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                          /* @__PURE__ */ a.jsx(D8, { className: "peer size-[1.14286rem] fill-mshop-gray-80" }),
                          /* @__PURE__ */ a.jsxs(
                            "div",
                            {
                              className: "typo-mshop-kr-14-m absolute left-0 top-[2rem] hidden w-[19rem] max-w-[28.57143rem] whitespace-pre-line rounded-[1.143rem] bg-mshop-blue-10 bg-opacity-60 p-[1.143rem] text-start text-mshop-blue-100 backdrop-blur-[40px] peer-hover:block",
                              style: {
                                zIndex: Tc.GLOBAL.TOOLTIP
                              },
                              children: [
                                "신청자가 참고할 수 있도록 커미션의 예상 작업 기간을 입력해 주세요. (최대 90일) ",
                                /* @__PURE__ */ a.jsx("br", {}),
                                "참고로, 예상 작업 기간과는 별도로 커미션 신청을 수락할 때 작업 마감 기한을 직접 설정할 수 있습니다."
                              ]
                            }
                          )
                        ] })
                      ] }),
                      /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                        /* @__PURE__ */ a.jsx(
                          J4,
                          {
                            ...Q("estimatedTime", {
                              ...Ss.commissionEstimatedTime,
                              validate: (st) => {
                                const lt = Number(st);
                                return lt < 1 || lt > 90 ? "작업 기간은 최소 1일에서 최대 90일까지 설정 가능합니다." : !0;
                              }
                            }),
                            type: "text",
                            placeholder: "최대 작업 기간으로 입력해 주세요.",
                            padding: { right: "4.571rem" },
                            disabled: nr.Close === U.state,
                            onChange: (st) => {
                              const lt = st.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                              Z("estimatedTime", Number(lt), {
                                shouldValidate: !0,
                                shouldDirty: !0
                              });
                            }
                          }
                        ),
                        /* @__PURE__ */ a.jsxs("div", { className: "flex-center absolute inset-y-0 right-0 gap-x-[0.57143rem] pr-[0.857rem]", children: [
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: "일" }),
                          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col justify-center", children: [
                            /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                className: "size-[1.143rem]",
                                onClick: () => Z(
                                  "estimatedTime",
                                  Number(X("estimatedTime") || 0) + 1,
                                  {
                                    shouldValidate: !0,
                                    shouldDirty: !0
                                  }
                                ),
                                type: "button",
                                disabled: nr.Close === U.state,
                                children: /* @__PURE__ */ a.jsx(
                                  Z4,
                                  {
                                    className: $(
                                      "size-full rotate-180",
                                      nr.Close === U.state ? "fill-mshop-gray-50" : "fill-mshop-black"
                                    )
                                  }
                                )
                              }
                            ),
                            /* @__PURE__ */ a.jsx(
                              "button",
                              {
                                className: "size-[1.143rem]",
                                type: "button",
                                onClick: () => Z(
                                  "estimatedTime",
                                  Number(X("estimatedTime") || 0) - 1,
                                  {
                                    shouldValidate: !0,
                                    shouldDirty: !0
                                  }
                                ),
                                disabled: nr.Close === U.state,
                                children: /* @__PURE__ */ a.jsx(
                                  Z4,
                                  {
                                    className: $(
                                      "size-full",
                                      nr.Close === U.state ? "fill-mshop-gray-50" : "fill-mshop-black"
                                    )
                                  }
                                )
                              }
                            )
                          ] })
                        ] })
                      ] }),
                      ((ai = te.estimatedTime) == null ? void 0 : ai.message) && /* @__PURE__ */ a.jsx(
                        sl,
                        {
                          message: te.estimatedTime.message
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 flex-col gap-y-[0.571rem]", children: [
                      /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
                        /* @__PURE__ */ a.jsx(Fs, { label: "결제 금액", required: !0 }),
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-blue-100", children: "결제 금액은 판매가 시작되면 변경할 수 없습니다." })
                      ] }),
                      /* @__PURE__ */ a.jsxs("div", { className: "relative", children: [
                        /* @__PURE__ */ a.jsx(
                          J4,
                          {
                            ...Q("price", {
                              ...Ss.commissionPrice,
                              validate: {
                                isMultipleOf100: (st) => Number(
                                  st.replace(/,/g, "")
                                ) % 100 !== 0 ? "결제 금액은 100원 단위로 입력해 주세요." : !0,
                                isWithinRange: (st) => {
                                  const lt = Number(
                                    st.replace(/,/g, "")
                                  );
                                  return lt < 100 || lt > 1e6 ? "결제 금액은 100원 이상 1,000,000원 이하로 설정할 수 있습니다." : !0;
                                }
                              }
                            }),
                            onChange: (st) => {
                              const lt = st.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                              Z("price", lt, {
                                shouldValidate: !0,
                                shouldDirty: !0
                              }), st.target.value = lt;
                            },
                            padding: { right: "2.06rem" },
                            type: "text",
                            placeholder: "커미션 신청 금액을 입력해 주세요.",
                            disabled: U.state !== nr.Hidden
                          }
                        ),
                        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m absolute inset-y-0 right-0 flex items-center pr-[0.75rem] text-mshop-black", children: "원" })
                      ] }),
                      ((ls = te.price) == null ? void 0 : ls.message) && /* @__PURE__ */ a.jsx(
                        sl,
                        {
                          message: te.price.message
                        }
                      )
                    ] })
                  ] })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ a.jsxs(
            "section",
            {
              className: "flex w-full flex-col rounded-[0.57143rem] border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]",
              id: "commission-create-request-guide-section",
              children: [
                /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-20-b mb-[1.14rem] text-mshop-black", children: "작업 안내" }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.71rem]", children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex w-fit flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "작업 안내 이미지", required: !0 }),
                    /* @__PURE__ */ a.jsxs("div", { children: [
                      /* @__PURE__ */ a.jsxs("div", { className: "mb-[0.85714rem] flex items-center gap-x-[0.57143rem]", children: [
                        X("sampleImageUrls").map((st, lt) => /* @__PURE__ */ a.jsx(
                          "button",
                          {
                            className: $(
                              "size-[5.14286rem] overflow-hidden rounded-[0.28571rem] border",
                              j === st ? "border-mshop-blue-100" : "border-mshop-gray-20"
                            ),
                            onClick: () => {
                              E(st);
                            },
                            type: "button",
                            children: /* @__PURE__ */ a.jsx(
                              "img",
                              {
                                src: st,
                                className: "size-full object-cover",
                                alt: ""
                              }
                            )
                          },
                          lt
                        )),
                        Array.from(
                          {
                            length: BH - X("sampleImageUrls").length
                          },
                          (st, lt) => /* @__PURE__ */ a.jsx(
                            "button",
                            {
                              className: $("size-[5.14286rem]", {
                                "rounded-[0.28571rem] border border-dashed border-mshop-gray-20 bg-mshop-gray-5": nr.Close === U.state
                              }),
                              type: "button",
                              disabled: nr.Close === U.state,
                              onClick: () => {
                                E(null), ve();
                              },
                              children: nr.Close !== U.state && /* @__PURE__ */ a.jsx(dA, { className: "size-full text-mshop-gray-20" })
                            },
                            lt
                          )
                        )
                      ] }),
                      j ? /* @__PURE__ */ a.jsxs("div", { className: "relative size-[33.71429rem]", children: [
                        /* @__PURE__ */ a.jsx(
                          "img",
                          {
                            src: j,
                            alt: "",
                            className: "h-full w-full rounded-[0.57142rem] object-cover"
                          }
                        ),
                        nr.Close !== U.state && /* @__PURE__ */ a.jsx(
                          "button",
                          {
                            type: "button",
                            className: "flex-center absolute right-[0.571rem] top-[0.571rem] size-[2.28571rem] rounded-full bg-mshop-gray-80",
                            onClick: ut,
                            children: /* @__PURE__ */ a.jsx(tk, { className: "size-6 fill-mshop-white" })
                          }
                        )
                      ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex size-[33.71429rem] flex-col items-center justify-center gap-y-[1.71429rem] rounded-[0.57143rem] border border-mshop-gray-20", children: [
                        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col items-center gap-y-[0.28571rem] text-mshop-gray-50", children: [
                          /* @__PURE__ */ a.jsx("div", { className: "size-[2.85714rem]", children: /* @__PURE__ */ a.jsx(u6e, { className: "h-full w-full text-mshop-gray-20" }) }),
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "작업 안내 이미지를 업로드해 주세요." }),
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "권장 : 비율 1:1, 460px 이상 / PNG, JPG, GIF 형식 / 5MB 이하" })
                        ] }),
                        /* @__PURE__ */ a.jsx(
                          za,
                          {
                            variant: "sm",
                            theme: "white",
                            type: "button",
                            iconFront: "upload",
                            onClick: ve,
                            disabled: ue,
                            children: "이미지 업로드"
                          }
                        )
                      ] }),
                      /* @__PURE__ */ a.jsx(
                        "input",
                        {
                          ref: he,
                          type: "file",
                          className: "sr-only",
                          multiple: !0,
                          onChange: ot,
                          accept: ".jpeg, .png, .gif, .jpg"
                        }
                      )
                    ] }),
                    ((Ot = te.sampleImageUrls) == null ? void 0 : Ot.message) && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: te.sampleImageUrls.message
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "작업 상세 내용", required: !0 }),
                    /* @__PURE__ */ a.jsx(
                      vy,
                      {
                        ...Q(
                          "workDescription",
                          Ss.commissionWorkDescription
                        ),
                        watch: X("workDescription"),
                        maxLength: Ss.commissionWorkDescription.maxLength.value,
                        placeholder: `신청자가 작업을 정확히 이해하고 요청할 수 있도록 상세한 작업 안내를 작성해 주세요.

작업 스타일 : 가능한 작업 범위나 스타일을 구체적으로 작성해 주세요.
이미지 첨부 요청 : 참고할 이미지가 필요하다면 신청자에게 업로드 요청해 주세요.
제공 파일 형식 : PNG, JPG, PDF, AI, PSD 등 제공되는 파일 형식을 명시해 주세요.
수정 가능 여부 : 수정 가능/불가능 여부와 수정 가능 시 최대 횟수와 범위를 안내해 주세요.
거부 사유 : 작업 스타일과 맞지 않거나 기한 내 불가능한 요청 등 예상 거부 사유를 이해하기 쉽게 작성해 주세요.
작업 기한 안내 : 개인 일정에 따라 기한이 변경될 수 있다면, 신청자에게 작업 중 기한이 변경될 수 있는 점을 안내해 주세요.
유의 사항 : 신청자가 미리 알아야 할 주의 사항을 포함해 주세요.`,
                        minRows: 9,
                        disabled: nr.Close === U.state,
                        onBlur: () => Vt("workDescription")
                      }
                    ),
                    ((En = te.workDescription) == null ? void 0 : En.message) && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: te.workDescription.message
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "작업물 이용 범위", required: !0 }),
                    /* @__PURE__ */ a.jsxs(
                      yp,
                      {
                        ...Q("license", Ss.commissionLicense),
                        onChange: (st) => {
                          X("license") === Ma.Custom && Z("licenseText", null, {
                            shouldDirty: !0,
                            shouldValidate: !0
                          }), Z("license", st, {
                            shouldDirty: !0,
                            shouldValidate: !0
                          });
                        },
                        as: "div",
                        disabled: nr.Close === U.state,
                        children: [
                          /* @__PURE__ */ a.jsx(_1, { children: /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $(
                                "text-start",
                                X("license") === null || nr.Close === U.state ? "text-mshop-gray-50" : "text-mshop-black"
                              ),
                              children: ((Xt = UH.find(
                                (st) => st.value === X("license")
                              )) == null ? void 0 : Xt.name) || "작업물의 저작권과 이용 범위를 안내해 주세요."
                            }
                          ) }),
                          /* @__PURE__ */ a.jsx(M1, { children: UH.map((st) => /* @__PURE__ */ a.jsx(
                            T1,
                            {
                              value: st.value,
                              isSelected: X("license") === st.value,
                              children: /* @__PURE__ */ a.jsxs("div", { className: "line-clamp-1 cursor-pointer text-mshop-black", children: [
                                /* @__PURE__ */ a.jsx(
                                  "span",
                                  {
                                    className: st.value === Ma.Custom ? "typo-mshop-kr-14-m" : "typo-mshop-kr-14-b",
                                    children: st.name
                                  }
                                ),
                                st.description && /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m", children: [
                                  " : ",
                                  st.description
                                ] })
                              ] })
                            },
                            st.value
                          )) })
                        ]
                      }
                    ),
                    X("license") === Ma.Custom && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                      /* @__PURE__ */ a.jsx(
                        M8,
                        {
                          ...Q(
                            "licenseText",
                            Ss.commissionLicenseText
                          ),
                          watch: X("licenseText") || "",
                          maxLength: Ss.commissionLicenseText.maxLength.value,
                          placeholder: "작업물 이용 범위를 상세히 작성해 주세요.",
                          invalid: !!te.licenseText,
                          disabled: nr.Close === U.state,
                          onBlur: () => Vt("licenseText")
                        }
                      ),
                      ((qt = te.licenseText) == null ? void 0 : qt.message) && /* @__PURE__ */ a.jsx(
                        sl,
                        {
                          message: te.licenseText.message
                        }
                      )
                    ] })
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(Fs, { label: "사전 질문 제목" }),
                    /* @__PURE__ */ a.jsx(
                      M8,
                      {
                        ...Q(
                          "preQuestion",
                          Ss.CommissionPreQuestion
                        ),
                        watch: X("preQuestion") || "",
                        maxLength: Ss.CommissionPreQuestion.maxLength.value,
                        disabled: nr.Close === U.state,
                        placeholder: "커미션 작업에 필요한 질문이나 작업 참고를 위한 파일 업로드를 요청할 수 있어요.",
                        invalid: !!te.preQuestion,
                        onBlur: () => Vt("preQuestion")
                      }
                    ),
                    ((In = te.preQuestion) == null ? void 0 : In.message) && /* @__PURE__ */ a.jsx(
                      sl,
                      {
                        message: te.preQuestion.message
                      }
                    )
                  ] })
                ] })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ a.jsxs(
          "section",
          {
            className: "sticky top-[2.85714rem] h-fit w-[36.429rem] min-w-[25.71429rem] flex-shrink",
            id: "commission-create-commission-status",
            children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.714rem] rounded-lg border border-mshop-gray-10 bg-mshop-white p-[1.71429rem]", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 상태" }),
                  U.state !== nr.Hidden && U.state !== nr.Deleted && /* @__PURE__ */ a.jsx(
                    "div",
                    {
                      className: $(
                        "typo-mshop-kr-12-m flex-center flex w-fit rounded-[0.28571rem] bg-mshop-blue-100 px-[0.57143rem] pb-[0.28571rem] pt-[0.21429rem]",
                        zH[U.state].color
                      ),
                      children: zH[U.state].name
                    }
                  )
                ] }),
                U.state === nr.Hidden && /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[1.143rem]", children: [
                  /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-b mr-[2.857rem] text-mshop-gray-50", children: "STEP" }),
                  /* @__PURE__ */ a.jsxs("div", { children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-wrap items-center gap-x-[0.571rem]", children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "커미션 만들기" }),
                      /* @__PURE__ */ a.jsx(sA, { className: "size-[1.143rem] -rotate-90 fill-mshop-black" }),
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $(
                            "typo-mshop-kr-16-b",
                            U.state === nr.Hidden ? "text-mshop-gray-20" : "text-mshop-black"
                          ),
                          children: "커미션 판매 시작!"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-12-m mt-[0.571rem] text-mshop-gray-80", children: [
                      "나만의 특별한 재능을 활용해 커미션을 만들어 보세요.",
                      /* @__PURE__ */ a.jsx("br", {}),
                      "회원들이 이해하기 쉽도록 커미션 상세 내용을 자세히 작성해 주세요."
                    ] })
                  ] })
                ] }),
                U.state !== nr.Hidden && U.state !== nr.Close && /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem]", children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[1.143rem]", children: [
                    /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-b w-[5.71428rem] flex-shrink-0 text-mshop-gray-50", children: "일시 중단" }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] pt-[0.14286rem]", children: [
                      /* @__PURE__ */ a.jsx(
                        qW,
                        {
                          checked: X("state") === nr.Paused,
                          onChange: (st) => {
                            Z(
                              "state",
                              st ? nr.Paused : nr.Open,
                              {
                                shouldValidate: !0,
                                shouldDirty: !0
                              }
                            );
                          }
                        }
                      ),
                      oe("state") === nr.Paused && /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                        "일시 중단하면 더 이상 새로운 신청을 받을 수 없습니다.",
                        /* @__PURE__ */ a.jsx("br", {}),
                        "수락 대기/작업 중 상태의 신청서는 정상적으로 진행해 주세요."
                      ] })
                    ] })
                  ] }),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem]", children: [
                    /* @__PURE__ */ a.jsxs("div", { className: "flex", children: [
                      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 items-center gap-x-[1.143rem]", children: [
                        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-b w-[5.71428rem] text-mshop-gray-50", children: "수락 대기" }),
                        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.14286rem]", children: [
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: U.statusCount.PENDING }),
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50", children: "건" })
                        ] })
                      ] }),
                      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 items-center gap-x-[1.143rem]", children: [
                        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-b w-[5.71428rem] text-mshop-gray-50", children: "작업 완료" }),
                        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.14286rem]", children: [
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: U.statusCount.TASK_DONE }),
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50", children: "건" })
                        ] })
                      ] })
                    ] }),
                    /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[1.143rem]", children: [
                      /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-16-b w-[5.71428rem] text-mshop-gray-50", children: "작업 중" }),
                      /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.14286rem]", children: [
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: U.statusCount.ACCEPTED }),
                        /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50", children: "건" })
                      ] })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "rounded-[0.571rem] border bg-mshop-gray-5", children: [
                  /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m list-disc p-[0.857rem] text-mshop-gray-80", children: [
                    /* @__PURE__ */ a.jsxs(il, { children: [
                      "커미션 서비스를 이용하기 전",
                      " ",
                      /* @__PURE__ */ a.jsx(
                        "button",
                        {
                          className: "typo-mshop-kr-14-m underline underline-offset-2",
                          type: "button",
                          onClick: m,
                          children: "이용약관"
                        }
                      ),
                      "을 확인해 주세요."
                    ] }),
                    /* @__PURE__ */ a.jsx(il, { children: "(주)마플코퍼레이션(이하 '회사')은 회원 간 콘텐츠 거래를 중개하며, 통신 판매자를 대리하지 않습니다." }),
                    /* @__PURE__ */ a.jsx(il, { children: "크리에이터는 서비스 정책을 준수하고 작업을 성실히 이행해야 하며, 커미션 설명에 작업물 수정 가능 횟수와 범위를 명확히 기재해 주셔야 합니다." }),
                    /* @__PURE__ */ a.jsx(il, { children: "신청자에게 안내된 작업 마감 기한까지 최종 작업물이 전달되지 않을 경우, 결제 금액은 자동으로 환불 처리됩니다." }),
                    /* @__PURE__ */ a.jsx(il, { children: "작업물의 저작권은 신청자와 별도로 협의하지 않는 한 크리에이터에게 귀속되며, 이용 범위는 커미션 상세 설명에 명시된 내용을 기준으로 합니다." }),
                    /* @__PURE__ */ a.jsx(il, { children: "또한 저작권 침해, 명예훼손, 불법·차별적인 내용 등 부적절한 작업물에 대한 모든 책임은 크리에이터에게 있습니다." }),
                    /* @__PURE__ */ a.jsx(il, { children: "서비스 정책 위반 시 이용에 제한이 있을 수 있습니다." })
                  ] }),
                  /* @__PURE__ */ a.jsxs(Bd, { className: "flex items-center gap-x-[0.571rem] border-t border-mshop-gray-10 px-[1.143rem] py-[0.857rem]", children: [
                    /* @__PURE__ */ a.jsx(
                      $O,
                      {
                        disabled: U.state !== nr.Hidden,
                        checked: H,
                        onChange: K
                      }
                    ),
                    /* @__PURE__ */ a.jsx(_c, { className: "typo-mshop-kr-14-b cursor-pointer text-mshop-gray-80", children: "위 이용약관을 충분히 읽고 이해하였으며, 약관에 동의합니다." })
                  ] })
                ] }),
                U.state === nr.Close || U.state === nr.Hidden ? /* @__PURE__ */ a.jsx(
                  za,
                  {
                    type: "button",
                    theme: "blue",
                    variant: "md",
                    disabled: !H || w || !fe || !ce || Object.keys(te).length > 0 || U.state === nr.Close || (X("sampleImageUrls") || []).length === 0 || X("license") === Ma.Custom && !X("licenseText"),
                    widthFull: !0,
                    onClick: er,
                    children: U.state === nr.Close ? "종료된 커미션입니다" : "커미션 판매하기"
                  }
                ) : /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.714rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    za,
                    {
                      type: "button",
                      theme: "blue",
                      variant: "md",
                      widthFull: !0,
                      disabled: !fe || !ce || w || Object.keys(te).length > 0 || (X("sampleImageUrls") || []).length === 0 || X("license") === Ma.Custom && X("licenseText") === null,
                      onClick: ye,
                      children: "커미션 변경 저장하기"
                    }
                  ),
                  " ",
                  /* @__PURE__ */ a.jsx(
                    za,
                    {
                      type: "button",
                      theme: "lineGray",
                      variant: "md",
                      widthFull: !0,
                      onClick: ke,
                      children: "커미션 종료하기"
                    }
                  )
                ] })
              ] }),
              U.state === nr.Close && /* @__PURE__ */ a.jsx("div", { className: "mt-[1.429rem] text-right", children: /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: "typo-mshop-kr-14-m text-mshop-gray-50 underline underline-offset-2",
                  onClick: tt,
                  children: "이 커미션 삭제하기"
                }
              ) })
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a.jsx(
      BO,
      {
        show: I,
        modalTitle: ["마플샵 커미션", "판매하기"],
        onClose: () => R(!1),
        stepInfos: C6e
      }
    ),
    /* @__PURE__ */ a.jsx(
      b6e,
      {
        show: D,
        onClose: () => L(!1),
        imgUrl: kt.KeyVisual.MembershipCommissionWhite,
        title: "COMMISSION OPEN!",
        descriptions: [
          "신청자와 약속한 마감 기한과 조건은 꼭 지켜주세요.",
          "신청자에게 고지한 마감 기한까지 최종 작업물이 전달되지 않으면 자동으로 환불됩니다.",
          "작업물과 관련된 신청자의 문의사항에 성실하게 답변해주세요.",
          "플랫폼 외 거래는 허용되지 않으며, 안전한 결제를 위해 반드시 플랫폼을 이용해주세요.",
          "부적절하거나 정책에 위배되는 요청은 거절할 수 있습니다."
        ],
        guidLineButton: {
          title: "크리에이터 가이드 보러가기",
          onClick: () => {
            y(), L(!1);
          }
        },
        confirmButton: {
          title: "내 커미션 확인하기",
          onClick: () => {
            b(), L(!1);
          }
        }
      }
    )
  ] }) });
}
const Tv = "new", r3 = {
  id: Tv,
  commissionSnapshotId: Tv,
  displayName: "",
  description: "",
  thumbnailImage: {
    url: "",
    width: 0,
    height: 0
  },
  estimatedTime: 0,
  price: 0,
  index: 0,
  state: nr.Hidden,
  projectId: "",
  sampleImages: [],
  workDescription: "",
  license: null,
  preQuestion: null,
  licenseText: null,
  statusCount: {
    ACCEPTED: 0,
    END: 0,
    PENDING: 0,
    TASK_DONE: 0,
    REFUNDED: 0,
    ON_REFUND: 0
  }
};
function E6e({
  projectId: e,
  onTermsTextClick: t,
  onCreatorGuideTextClick: n,
  onCheckMyCommissionButtonClick: r,
  ...s
}) {
  const [o, c] = Re(!0), [u, m] = Re();
  return an(() => {
    (async () => {
      const y = await s6e(
        { projectId: e },
        { client: s.client, onError: s.onError }
      );
      switch (y.code) {
        case le.Success:
          m(
            y.data.items.length > 0 ? y.data.items : [r3]
          );
          return;
        case le.TokenExpired:
        default:
          return s.onError(Ht);
      }
    })(), c(!1);
  }, []), o || !u || u.length === 0 ? null : /* @__PURE__ */ a.jsx(
    j6e,
    {
      projectId: e,
      fetchedSettingsCommissions: u,
      onTermsTextClick: t,
      onCreatorGuideTextClick: n,
      onCheckMyCommissionButtonClick: r,
      ...s
    }
  );
}
class Yje extends Ol {
  constructor({
    projectId: t,
    onTermsTextClick: n,
    onCreatorGuideTextClick: r,
    onCheckMyCommissionButtonClick: s,
    ...o
  }) {
    super(o), this.render = (c) => go(c).render(
      /* @__PURE__ */ a.jsx(
        E6e,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onScrollLock: this.onScrollLock,
          onError: this.onError,
          projectId: this.projectId,
          onTermsTextClick: this.onTermsTextClick,
          onCreatorGuideTextClick: this.onCreatorGuideTextClick,
          onCheckMyCommissionButtonClick: this.onCheckMyCommissionButtonClick
        }
      )
    ), this.projectId = t, this.onTermsTextClick = n, this.onCreatorGuideTextClick = r, this.onCheckMyCommissionButtonClick = s;
  }
}
const uK = (e, t) => jn(
  "/mypage-commission",
  { body: e },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
      return n;
    default:
      throw new Error();
  }
}), k6e = (e, t) => jn(
  "/cancel-commission-request",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.UnableToProcessRequest:
    case le.AlreadyCancelledInfo:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), _6e = (e, t) => jn(
  "/complete-commission-request",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.UnableToProcessRequest:
    case le.AlreadyCompleted:
      return n;
    default:
      throw new Error();
  }
}), HH = {
  Paid: "PAID",
  Cancelled: "CANCELLED"
}, J0 = {
  /**
   * 크리에이터가 거절
   * */
  Canceled: "CANCELED",
  /**
   * 유저가 거절
   * */
  CanceledByClient: "CANCELED_BY_CLIENT",
  /**
   * 기간 내 수락을 하지 않아서 거절
   * */
  AutoCanceled: "AUTO_CANCELED",
  /**
   * 기간 내 작업물을 업로드 하지 않아서 거절
   * */
  DeadlineExpired: "DEADLINE_EXPIRED"
}, dK = Qt(Vn);
function T6e() {
  const [e, t] = Ar(dK);
  if (e === Vn)
    throw new Error(Xr(ia.MypageCommission));
  return { mypageCommission: e, setMypageCommission: t };
}
function Kj({
  type: e,
  paymentStatement: t,
  baseWidgetProps: n,
  isShowReceiptButton: r
}) {
  const [s, o] = Re(!1), [c, u] = Re(null), m = async () => {
    if (n.isMobile) {
      o(!0), n.toggleSpinner(!0);
      const y = await kw(
        {
          paymentStatementId: t.id
        },
        {
          client: n.client,
          onError: n.onError
        }
      );
      switch (o(!1), n.toggleSpinner(!1), y.code) {
        case le.Success:
          O4(y.data.target === "COMMISSION"), u(y.data);
          return;
        case le.TokenExpired:
          n.onError(Ht);
          return;
        default:
          throw new Error();
      }
    } else
      E6(t.id);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.57143rem]", children: [
      /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: $(
            "flex items-center justify-between border-b border-mshop-black",
            n.isMobile ? "pb-[0.57143rem]" : "pb-[0.857rem]"
          ),
          children: [
            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-16-b", children: [
              e === "payment" ? "결제" : "환불",
              " 정보"
            ] }),
            r && /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                onClick: m,
                disabled: s,
                className: 'typo-mshop-kr-12-m text-mshop-gray-80" rounded-[0.28571rem] border border-mshop-gray-20 bg-mshop-white px-[0.571rem] py-[0.286rem] backdrop-blur-[20px]',
                children: "영수증 조회"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ a.jsxs("ul", { children: [
        /* @__PURE__ */ a.jsxs(
          "li",
          {
            className: $(
              "flex items-center",
              n.isMobile ? "gap-x-[1.14286rem] py-[0.57143rem]" : "gap-x-[3.42857rem] py-[0.85714rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "typo-mshop-kr-14-m flex-shrink-0 text-mshop-gray-50",
                    n.isMobile ? "w-[5.71429rem]" : "w-[9.14286rem]"
                  ),
                  children: "결제 수단"
                }
              ),
              /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m text-mshop-black", children: [
                "신용카드 (",
                t.cardName,
                ")"
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "li",
          {
            className: $(
              "flex items-center",
              n.isMobile ? "gap-x-[1.14286rem] py-[0.57143rem]" : "gap-x-[3.42857rem] py-[0.85714rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "typo-mshop-kr-14-m flex-shrink-0 text-mshop-gray-50",
                    n.isMobile ? "w-[5.71429rem]" : "w-[9.14286rem]"
                  ),
                  children: "승인 시간"
                }
              ),
              /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-en-14-unica-m text-mshop-black", children: jt(t.paidAt, "yyyy.MM.dd HH:mm") })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "li",
          {
            className: $(
              "flex items-center",
              n.isMobile ? "gap-x-[1.14286rem] py-[0.57143rem]" : "gap-x-[3.42857rem] py-[0.85714rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "typo-mshop-kr-14-m flex-shrink-0 text-mshop-gray-50",
                    n.isMobile ? "w-[5.71429rem]" : "w-[9.14286rem]"
                  ),
                  children: "결제 금액"
                }
              ),
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: e === "payment" ? "text-mshop-black" : "text-mshop-red-80",
                  children: [
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m", children: t.price.toLocaleString() }),
                    /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m", children: "원" })
                  ]
                }
              )
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a.jsx(
      k6,
      {
        show: !!c,
        target: "COMMISSION",
        business: (c == null ? void 0 : c.business) ?? null,
        paymentDetails: (c == null ? void 0 : c.paymentDetails) ?? null,
        paymentRecord: (c == null ? void 0 : c.paymentRecord) ?? null,
        onClose: () => u(null)
      }
    )
  ] });
}
const M6e = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M13.69 2H5.27C4.29 2 3.5 2.79 3.5 3.77V20.23C3.5 21.21 4.29 22 5.27 22H18.73C19.71 22 20.5 21.21 20.5 20.23V8.81L13.69 2ZM13.69 4.47L18.03 8.81H13.69V4.47Z" })), YA = yn(M6e);
function VH({
  preQuestionAnswer: e,
  commissionSnapshot: t,
  message: n,
  files: r,
  isMobile: s
}) {
  return /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.57143rem]", children: [
    /* @__PURE__ */ a.jsx(
      "h2",
      {
        className: $(
          "typo-mshop-kr-16-b border-b border-mshop-black text-mshop-black",
          s ? "pb-[0.57143rem]" : "pb-[0.857rem]"
        ),
        children: "커미션 신청서"
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex flex-col",
          s ? "gap-y-[0.57143rem] py-[0.57143rem]" : "gap-y-[0.57143rem] py-[0.85714rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("h3", { className: "typo-mshop-kr-14-b text-mshop-black", children: "작업물 이용 범위" }),
          /* @__PURE__ */ a.jsxs("div", { className: "whitespace-pre-wrap break-words rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem] text-mshop-gray-80", children: [
            t.license !== Ma.Custom && /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-b", children: co[t.license].name }),
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m whitespace-pre-wrap", children: t.license === Ma.Custom && t.licenseText ? t.licenseText : co[t.license].description })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex flex-col",
          s ? "gap-y-[0.57143rem] py-[0.57143rem]" : "gap-y-[0.57143rem] py-[0.85714rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("h3", { className: "typo-mshop-kr-14-b", children: "작업 상세 내용" }),
          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m whitespace-pre-wrap break-words rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem] text-mshop-gray-80", children: t.workDescription })
        ]
      }
    ),
    t.preQuestion && /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex flex-col",
          s ? "gap-y-[0.57143rem] py-[0.57143rem]" : "gap-y-[0.57143rem] py-[0.85714rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("h3", { className: "typo-mshop-kr-14-b break-all", children: t.preQuestion }),
          /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m whitespace-pre-wrap break-words rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem] text-mshop-gray-80", children: e })
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex flex-col",
          s ? "gap-y-[0.57143rem] py-[0.57143rem]" : "gap-y-[0.57143rem] py-[0.85714rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("h3", { className: "typo-mshop-kr-14-b", children: "기타 요청 사항" }),
          n ? /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m whitespace-pre-wrap break-words rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem] text-mshop-gray-80", children: n }) : /* @__PURE__ */ a.jsx(
            "div",
            {
              className: $("typo-mshop-kr-14-m text-mshop-gray-50", {
                "rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem] text-center": !s
              }),
              children: "작성 내역이 없습니다."
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex flex-col",
          s ? "gap-y-[0.57143rem] py-[0.57143rem]" : "gap-y-[0.57143rem] py-[0.85714rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("h3", { className: "typo-mshop-kr-14-b", children: "참고 이미지 파일" }),
          r.length > 0 ? /* @__PURE__ */ a.jsx("ul", { className: "typo-mshop-kr-14-m rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem] text-mshop-gray-80", children: r.map((o) => /* @__PURE__ */ a.jsxs(
            "li",
            {
              className: "flex-center gap-x-[1.14286rem] py-[0.57143rem] pr-[0.57143rem]",
              children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-grow items-center gap-x-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsx("div", { className: "size-[1.71429rem] flex-shrink-0 rounded-[0.28571rem] bg-mshop-gray-5 p-[0.28571rem]", children: /* @__PURE__ */ a.jsx(YA, { className: "size-full" }) }),
                  /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m flex text-mshop-black", children: [
                    /* @__PURE__ */ a.jsx("span", { className: "line-clamp-1 break-all", children: o.name ? rw(o.name) : "참고 이미지 파일" }),
                    o.ext && /* @__PURE__ */ a.jsxs("span", { children: [
                      ".",
                      aw(o.ext)
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ a.jsx(
                  "button",
                  {
                    type: "button",
                    onClick: async () => {
                      wt(o), await n5({
                        url: o.url,
                        filename: o.name || "",
                        onDownloadFailed: async () => {
                          await en({
                            body: (c) => /* @__PURE__ */ a.jsx(
                              ea,
                              {
                                button: {
                                  props: c
                                },
                                children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                                  /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "다운로드 실패" }),
                                  /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                                    "파일 다운로드에 실패했습니다.",
                                    /* @__PURE__ */ a.jsx("br", {}),
                                    "잠시 후 다시 시도해 주세요."
                                  ] })
                                ] })
                              }
                            )
                          });
                        }
                      });
                    },
                    className: "size-[1.42857rem] flex-shrink-0",
                    children: /* @__PURE__ */ a.jsx(Y8, { className: "filter-mshop-gray-80 size-full" })
                  }
                )
              ]
            },
            o.id
          )) }) : /* @__PURE__ */ a.jsx(
            "div",
            {
              className: $("typo-mshop-kr-14-m text-mshop-gray-50", {
                "rounded-[0.85714rem] border border-mshop-gray-10 p-[1.14286rem] text-center": !s
              }),
              children: "참고 이미지 파일 내역이 없습니다."
            }
          )
        ]
      }
    )
  ] });
}
function R6e({
  show: e,
  onClose: t,
  disabled: n,
  commissionFiles: r,
  recentWorkFileIndex: s,
  requestState: o,
  onFileDownloadButtonClick: c
}) {
  return /* @__PURE__ */ a.jsxs(dh, { show: e, onClose: t, children: [
    /* @__PURE__ */ a.jsx(
      p5,
      {
        title: "작업 파일 내역",
        onClose: t,
        disabled: n
      }
    ),
    /* @__PURE__ */ a.jsxs("div", { className: "size-full overflow-y-auto overflow-x-hidden p-[1.14286rem]", children: [
      o === Ln.TaskDone && /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-12-m mb-[0.57143rem] flex flex-col gap-y-[0.28571rem] rounded-[0.57143rem] bg-mshop-blue-10 p-[0.85714rem] text-mshop-blue-100", children: [
        /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[0.28571rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.21429rem] flex-shrink-0 items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.14286rem] rounded-full bg-mshop-blue-100" }) }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m flex-1", children: "파일이 업로드되었어요. 최종 확인 후 구매 확정 버튼을 눌러주세요." })
        ] }),
        /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[0.28571rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.21429rem] flex-shrink-0 items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.14286rem] rounded-full bg-mshop-blue-100" }) }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m flex-1", children: "파일 업로드 후, 7일이 지나면 자동으로 구매 확정 처리됩니다." })
        ] }),
        /* @__PURE__ */ a.jsxs("li", { className: "flex gap-[0.28571rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex h-[1.21429rem] flex-shrink-0 items-center", children: /* @__PURE__ */ a.jsx("div", { className: "size-[0.14286rem] rounded-full bg-mshop-blue-100" }) }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m flex-1", children: "구매 확정 후에는 환불이 불가하오니 파일에 이상이 있을 경우, 7일 이내에 크리에이터에게 문의해 주세요." })
        ] })
      ] }),
      /* @__PURE__ */ a.jsx("ul", { children: r.map((u, m) => /* @__PURE__ */ a.jsxs(
        "li",
        {
          className: "flex flex-col gap-y-[0.28571rem] py-[0.57143rem] pr-[0.57143rem]",
          children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-gray-50", children: jt(u.createdAt, "yyyy.MM.dd HH:mm") }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[1.71429rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-grow gap-x-[0.57143rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "size-[1.71429rem] flex-shrink-0 rounded-[0.28571rem] bg-mshop-gray-5 p-[0.28571rem]", children: /* @__PURE__ */ a.jsx(
                  YA,
                  {
                    className: $(
                      "size-full",
                      {
                        "fill-mshop-blue-100": m === s
                      },
                      {
                        "fill-mshop-gray-80": m !== s && u.file !== null
                      },
                      {
                        "fill-mshop-gray-20": m !== s && u.file === null
                      }
                    )
                  }
                ) }),
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "typo-mshop-kr-14-m flex",
                      {
                        "text-mshop-blue-100": m === s
                      },
                      {
                        "text-mshop-gray-80": m !== s && u.file !== null
                      },
                      {
                        "text-mshop-gray-20": m !== s && u.file === null
                      }
                    ),
                    children: u.file === null ? "삭제된 파일입니다." : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                      /* @__PURE__ */ a.jsx("span", { className: "line-clamp-1 break-all", children: u.file.name ? rw(u.file.name) : "커미션 작업 파일" }),
                      u.file.ext && /* @__PURE__ */ a.jsxs("span", { children: [
                        ".",
                        aw(u.file.ext)
                      ] })
                    ] })
                  }
                )
              ] }),
              u.file !== null && /* @__PURE__ */ a.jsx(
                "button",
                {
                  type: "button",
                  className: "size-[1.71429rem] flex-shrink-0",
                  onClick: () => {
                    u.file && c(
                      u.file.url,
                      u.file.name ?? "커미션 작업 파일"
                    );
                  },
                  children: /* @__PURE__ */ a.jsx(
                    Y8,
                    {
                      className: $(
                        "size-full",
                        {
                          "fill-mshop-blue-100": m === s
                        },
                        {
                          "fill-mshop-gray-80": m !== s
                        }
                      )
                    }
                  )
                }
              )
            ] })
          ]
        },
        u.id
      )) })
    ] })
  ] });
}
function D6e({
  requestState: e,
  commissionFiles: t,
  recentWorkFileIndex: n
}) {
  return /* @__PURE__ */ a.jsxs("section", { children: [
    /* @__PURE__ */ a.jsx("div", { className: "mb-[0.57143rem] border-b border-mshop-black pb-[0.857rem]", children: /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b", children: "작업 파일 내역" }) }),
    t.length > 0 ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      e === Ln.TaskDone && /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-14-m flex flex-col gap-y-[0.28571rem] rounded-[0.57143rem] bg-mshop-blue-10 px-[1.14286rem] py-[0.85714rem] text-mshop-blue-100", children: [
        /* @__PURE__ */ a.jsxs("li", { className: "flex items-center gap-[0.57142rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "size-[0.22857rem] flex-shrink-0 rounded-full bg-mshop-blue-100" }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m flex-1", children: "파일이 업로드되었어요. 최종 확인 후 구매 확정 버튼을 눌러주세요." })
        ] }),
        /* @__PURE__ */ a.jsxs("li", { className: "flex items-center gap-[0.57142rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "size-[0.22857rem] flex-shrink-0 rounded-full bg-mshop-blue-100" }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m flex-1", children: "파일 업로드 후, 7일이 지나면 자동으로 구매 확정 처리됩니다." })
        ] }),
        /* @__PURE__ */ a.jsxs("li", { className: "flex items-center gap-[0.57142rem]", children: [
          /* @__PURE__ */ a.jsx("div", { className: "size-[0.22857rem] flex-shrink-0 rounded-full bg-mshop-blue-100" }),
          /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m flex-1", children: "구매 확정 후에는 환불이 불가하오니 파일에 이상이 있을 경우, 7일 이내에 크리에이터에게 문의해 주세요." })
        ] })
      ] }),
      /* @__PURE__ */ a.jsx("ul", { className: "py-[0.57143rem]", children: t.map((r, s) => /* @__PURE__ */ a.jsxs(
        "li",
        {
          className: "flex-center gap-x-[3.42857rem] py-[0.85714rem] pr-[0.85714rem]",
          children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m w-[9.14286rem] flex-shrink-0 text-mshop-gray-50", children: jt(r.createdAt, "yyyy.MM.dd HH:mm") }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-grow items-center gap-x-[0.57143rem]", children: [
              /* @__PURE__ */ a.jsx("div", { className: "size-[1.71429rem] flex-shrink-0 rounded-[0.28571rem] bg-mshop-gray-5 p-[0.28571rem]", children: /* @__PURE__ */ a.jsx(
                YA,
                {
                  className: $(
                    "h-full w-full",
                    {
                      "fill-mshop-blue-100": s === n
                    },
                    {
                      "fill-mshop-gray-80": s !== n && r.file !== null
                    },
                    {
                      "fill-mshop-gray-20": s !== n && r.file === null
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "typo-mshop-kr-14-m flex",
                    {
                      "text-mshop-blue-100": s === n
                    },
                    {
                      "text-mshop-gray-80": s !== n && r.file !== null
                    },
                    {
                      "text-mshop-gray-20": s !== n && r.file === null
                    }
                  ),
                  children: r.file === null ? "삭제된 파일입니다." : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx("span", { className: "line-clamp-1 break-all", children: r.file.name ? rw(r.file.name) : "커미션 작업 파일" }),
                    r.file.ext && /* @__PURE__ */ a.jsxs("span", { children: [
                      ".",
                      aw(r.file.ext)
                    ] })
                  ] })
                }
              )
            ] }),
            r.file && /* @__PURE__ */ a.jsx(
              "button",
              {
                type: "button",
                className: "size-[1.71429rem] flex-shrink-0",
                onClick: async () => {
                  wt(r.file), await n5({
                    url: r.file.url,
                    filename: r.file.name || "",
                    onDownloadFailed: async () => {
                      await en({
                        body: (o) => /* @__PURE__ */ a.jsx(
                          ea,
                          {
                            button: {
                              props: o
                            },
                            children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                              /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "다운로드 실패" }),
                              /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                                "파일 다운로드에 실패했습니다.",
                                /* @__PURE__ */ a.jsx("br", {}),
                                "잠시 후 다시 시도해 주세요."
                              ] })
                            ] })
                          }
                        )
                      });
                    }
                  });
                },
                children: /* @__PURE__ */ a.jsx(
                  Y8,
                  {
                    className: $(
                      "h-full w-full",
                      {
                        "fill-mshop-blue-100": s === n
                      },
                      {
                        "fill-mshop-gray-80": s !== n
                      }
                    )
                  }
                )
              }
            )
          ]
        },
        r.id
      )) })
    ] }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: e === Ln.Pending ? /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m py-[0.85714rem] text-center text-mshop-gray-50", children: "작업이 완료되면 여기에서 확인할 수 있어요." }) : /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m py-[0.85714rem] text-center text-mshop-gray-50", children: [
      "크리에이터가 작업을 시작했어요! ",
      /* @__PURE__ */ a.jsx("br", {}),
      "작업이 완료되면 여기에서 확인할 수 있어요."
    ] }) })
  ] });
}
const $H = {
  [J0.AutoCanceled]: "자동 취소 (신청서 미확인)",
  [J0.Canceled]: "신청서 거절",
  [J0.CanceledByClient]: "신청 취소",
  [J0.DeadlineExpired]: "기한 내 작업 파일 미업로드"
};
function P6e({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  onScrollLock: s,
  onError: o,
  fetchedMypageCommission: c,
  onGoBackToCommissionListButtonClick: u,
  onContactButtonClick: m,
  onFileDownloadButtonClick: y,
  onShopButtonClick: b
}) {
  var Q, Z, X, se, te, fe, ce, pe, Se, oe;
  Al([
    [ol, e],
    [
      ll,
      {
        isMobile: t,
        isApp: n,
        toggleSpinner: r,
        onError: o,
        onScrollLock: s
      }
    ],
    [dK, c]
  ]);
  const [w, k] = Re(!1), [j, E] = Re(!1), { mypageCommission: T, setMypageCommission: D } = T6e(), L = T.paymentStatements.find(
    (ue) => ue.paymentState === HH.Paid
  ), I = T.paymentStatements.find(
    (ue) => ue.paymentState === HH.Cancelled
  );
  wt(L);
  const R = T.commissionFiles.findIndex(
    (ue) => ue.file !== null
  ), U = {
    [Ln.Pending]: {
      name: "수락 대기",
      description: `크리에이터가 7일 이내로
수락하지 않으면 자동 환불됩니다.`,
      isViewDueDate: !1,
      isViewDueDateUpateDescription: !1,
      isViewWorkFileButton: !1,
      isViewAdditionalMessage: !1
    },
    [Ln.Accepted]: {
      name: "작업 중",
      description: null,
      isViewDueDate: !0,
      isViewDueDateUpateDescription: !0,
      isViewWorkFileButton: !0,
      isViewAdditionalMessage: !0
    },
    [Ln.TaskDone]: {
      name: "작업 완료",
      description: null,
      isViewDueDate: !0,
      isViewDueDateUpateDescription: !0,
      isViewWorkFileButton: !0,
      isViewAdditionalMessage: !0
    },
    [Ln.End]: {
      name: "구매 확정",
      description: null,
      isViewDueDate: !0,
      isViewDueDateUpateDescription: !0,
      isViewWorkFileButton: !0,
      isViewAdditionalMessage: !0
    },
    [Ln.Refunded]: {
      name: "환불 완료",
      description: (Q = T.rejectionStatus) != null && Q.reason ? $H[T.rejectionStatus.reason] : null,
      isViewDueDate: ((Z = T.rejectionStatus) == null ? void 0 : Z.reason) === J0.DeadlineExpired,
      isViewDueDateUpateDescription: !1,
      isViewWorkFileButton: !1,
      isViewAdditionalMessage: ((X = T.rejectionStatus) == null ? void 0 : X.reason) === J0.DeadlineExpired
    },
    [Ln.OnRefund]: {
      name: "환불 예정",
      description: (se = T.rejectionStatus) != null && se.reason ? $H[T.rejectionStatus.reason] : null,
      isViewDueDate: ((te = T.rejectionStatus) == null ? void 0 : te.reason) === J0.DeadlineExpired,
      isViewDueDateUpateDescription: !1,
      isViewWorkFileButton: !1,
      isViewAdditionalMessage: ((fe = T.rejectionStatus) == null ? void 0 : fe.reason) === J0.DeadlineExpired
    }
  }, z = async () => {
    r(!0), k(!0);
    const ue = await uK(
      { commissionRequestId: T.id },
      {
        client: e,
        onError: o
      }
    );
    r(!1), k(!1), ue.code === le.Success && D(ue.data);
  }, H = async () => {
    if (!await ho({
      body: (ve, Te) => /* @__PURE__ */ a.jsx(
        D3,
        {
          confirmButton: {
            props: ve
          },
          cancelButton: {
            props: Te
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem] text-center", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 취소 요청" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "취소된 커미션은 다시 복구할 수 없습니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "정말 신청을 취소하시겠습니까?"
            ] })
          ] })
        }
      )
    }))
      return;
    k(!0), r(!0);
    const he = await k6e(
      { commissionRequestId: T.id, force: !1 },
      {
        client: e,
        onError: o
      }
    );
    switch (k(!1), r(!1), he.code) {
      case le.Success:
        await en({
          body: (ve) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: ve
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "커미션 취소 요청 접수" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "요청 확인 후 취소가 완료되며,",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "영업일 기준 2일에서 최대 10일까지 소요됩니다."
                ] })
              ] })
            }
          )
        }), await z();
        return;
      case le.AlreadyCancelledInfo:
        await en({
          body: (ve) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: ve
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "취소 요청 불가" }),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "이미 취소된 커미션입니다." })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.UnableToProcessRequest:
        await en({
          body: (ve) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: ve
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "취소 요청 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "크리에이터가 작업을 시작한 커미션은 ",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "취소가 불가합니다."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.TokenExpired:
        o(Ht);
        return;
      default:
        return new Error();
    }
  }, K = async () => {
    if (!await ho({
      body: (ve, Te) => /* @__PURE__ */ a.jsx(
        D3,
        {
          confirmButton: {
            props: ve
          },
          cancelButton: {
            props: Te
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem] text-center", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "구매 확정" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "구매 확정 후에는 환불이 불가능합니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "구매를 확정하시겠습니까?"
            ] })
          ] })
        }
      )
    }))
      return;
    k(!0), r(!0);
    const he = await _6e(
      { commissionRequestId: T.id },
      { client: e, onError: o }
    );
    switch (k(!1), r(!1), he.code) {
      case le.Success:
        await z();
        return;
      case le.AlreadyCompleted:
        await en({
          body: (ve) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: ve
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "이미 구매 확정된 커미션입니다." })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.UnableToProcessRequest:
        await en({
          body: (ve) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: ve
              },
              children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "크리에이터의 요청으로 작업 파일이 삭제되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "새로운 파일이 업로드되면 다시 시도해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
        return;
      case le.TokenExpired:
        o(Ht);
        return;
      default:
        throw new Error();
    }
  }, q = () => {
    const {
      seller: { shop: ue }
    } = T;
    ue && b(ue.url);
  };
  return /* @__PURE__ */ a.jsx("div", { className: "twp w-full", id: "my-page-commission-detail", children: t ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[3.42857rem]", children: [
      /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[1.14286rem]", children: [
        /* @__PURE__ */ a.jsx("div", { className: "border-b border-mshop-black pb-[0.57143rem]", children: /* @__PURE__ */ a.jsxs(
          "button",
          {
            type: "button",
            onClick: q,
            className: "flex items-center gap-[0.286rem] text-mshop-black",
            children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b line-clamp-1", children: Ef(T.seller.shop) }),
              /* @__PURE__ */ a.jsx(ch, { className: "size-[1.42857rem] shrink-0" })
            ]
          }
        ) }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.85714rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[1.14286rem]", children: [
            /* @__PURE__ */ a.jsx(
              "img",
              {
                src: T.commissionSnapshot.thumbnailImage.url,
                className: "size-[7.14286rem] flex-shrink-0 rounded-[1.143rem] object-cover",
                alt: ""
              }
            ),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col justify-center gap-y-[0.28571rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-black", children: T.commissionSnapshot.displayName }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "커미션" }),
              /* @__PURE__ */ a.jsxs("div", { children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b text-mshop-black", children: T.commissionSnapshot.price.toLocaleString() }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b text-mshop-black", children: "원" })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsx(
              "div",
              {
                className: $(
                  "typo-mshop-kr-12-r w-fit rounded-[0.28571rem] px-[0.28571rem] pb-[0.14286rem] pt-[0.07143rem] backdrop-blur-[5px]",
                  T.state === Ln.Refunded || T.state === Ln.OnRefund ? "bg-mshop-gray-5 text-mshop-gray-80" : "bg-mshop-black text-mshop-white"
                ),
                children: U[T.state].name
              }
            ),
            U[T.state].description && /* @__PURE__ */ a.jsx("div", { className: "typo-msho-kr-14-m text-mshop-gray-80", children: U[T.state].description }),
            U[T.state].isViewDueDateUpateDescription && T.updatedDueDate && /* @__PURE__ */ a.jsx("div", { className: "typo-msho-kr-14-m text-mshop-gray-80", children: "크리에이터의 요청으로 마감 기한이 변경되었습니다." }),
            U[T.state].isViewDueDate && T.dueDate && /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.28571rem] rounded-[0.57143rem] bg-mshop-gray-5 p-[0.85714rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "마감 기한" }),
                /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $(
                      "typo-mshop-en-14-unica-b",
                      T.updatedDueDate ? "text-mshop-gray-50" : "text-mshop-blue-100"
                    ),
                    children: jt(
                      T.updatedDueDate || T.dueDate,
                      "yyyy.MM.dd HH:mm"
                    )
                  }
                )
              ] }),
              T.updatedDueDate && /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "변경 기한" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-b text-mshop-blue-100", children: jt(
                  T.dueDate,
                  "yyyy.MM.dd HH:mm"
                ) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-[0.57143rem]", children: [
              T.state === Ln.Pending ? /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "sm",
                  theme: "line",
                  widthFull: !0,
                  type: "button",
                  disabled: w,
                  onClick: H,
                  children: "취소 요청"
                }
              ) : /* @__PURE__ */ a.jsx(a.Fragment, { children: U[T.state].isViewWorkFileButton && /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "sm",
                  theme: "white",
                  widthFull: !0,
                  type: "button",
                  disabled: w || T.commissionFiles.length === 0,
                  onClick: () => E(!0),
                  children: "작업 파일 보기"
                }
              ) }),
              /* @__PURE__ */ a.jsx(
                fn,
                {
                  variant: "sm",
                  theme: "line",
                  widthFull: !0,
                  type: "button",
                  disabled: w,
                  onClick: () => m(
                    T.commission.projectId,
                    T.commission.id
                  ),
                  children: "커미션 문의하기"
                }
              )
            ] }),
            T.state === Ln.TaskDone && /* @__PURE__ */ a.jsx(
              fn,
              {
                variant: "sm",
                theme: "blue",
                widthFull: !0,
                type: "button",
                disabled: w,
                onClick: K,
                children: "구매 확정"
              }
            )
          ] })
        ] })
      ] }),
      (T.state === Ln.Refunded || T.state === Ln.OnRefund) && ((ce = T.rejectionStatus) == null ? void 0 : ce.reason) === J0.Canceled && /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.57143rem]", children: [
        /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b border-b border-mshop-black pb-[0.857rem]", children: "커미션 거절 사유" }),
        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m whitespace-pre-wrap py-[0.57143rem] text-mshop-black", children: (pe = T == null ? void 0 : T.rejectionStatus) == null ? void 0 : pe.message })
      ] }),
      U[T.state].isViewAdditionalMessage && T.additionalMessage && /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.57143rem]", children: [
        /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b border-b border-mshop-black pb-[0.857rem]", children: "커미션 추가 안내" }),
        /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m whitespace-pre-wrap py-[0.57143rem] text-mshop-black", children: T.additionalMessage })
      ] }),
      T.state === Ln.Refunded && I && /* @__PURE__ */ a.jsx(
        Kj,
        {
          type: "refund",
          paymentStatement: I,
          baseWidgetProps: { isMobile: t, toggleSpinner: r, client: e, onError: o },
          isShowReceiptButton: !0
        }
      ),
      /* @__PURE__ */ a.jsx(
        Kj,
        {
          type: "payment",
          paymentStatement: L,
          baseWidgetProps: { isMobile: t, toggleSpinner: r, client: e, onError: o },
          isShowReceiptButton: T.state !== Ln.Refunded
        }
      ),
      /* @__PURE__ */ a.jsx(
        VH,
        {
          commissionSnapshot: T.commissionSnapshot,
          preQuestionAnswer: T.preQuestionAnswer,
          message: T.message,
          files: T.files,
          isMobile: t
        }
      )
    ] }),
    /* @__PURE__ */ a.jsx(
      R6e,
      {
        show: j,
        onClose: () => E(!1),
        disabled: w,
        recentWorkFileIndex: R,
        commissionFiles: T.commissionFiles,
        requestState: T.state,
        onFileDownloadButtonClick: y
      }
    )
  ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: "커미션 상세" }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[3.43rem] pt-[1.143rem]", children: [
      /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[1.14286rem]", children: [
        /* @__PURE__ */ a.jsx("div", { className: "border-b border-mshop-black pb-[0.85714rem]", children: /* @__PURE__ */ a.jsxs(
          "button",
          {
            type: "button",
            onClick: q,
            className: "flex items-center gap-[0.286rem] text-mshop-black",
            children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b line-clamp-1", children: Ef(T.seller.shop) }),
              /* @__PURE__ */ a.jsx(ch, { className: "size-[1.143rem] shrink-0" })
            ]
          }
        ) }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex w-full gap-x-[2.28571rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-grow gap-x-[1.14286rem]", children: [
            /* @__PURE__ */ a.jsx(
              "img",
              {
                src: T.commissionSnapshot.thumbnailImage.url,
                className: "size-[9.71429rem] flex-shrink-0 rounded-[1.143rem] object-cover",
                alt: ""
              }
            ),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col justify-center gap-y-[0.57143rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: T.commissionSnapshot.displayName }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-50", children: "커미션" }),
              /* @__PURE__ */ a.jsxs("div", { children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-20-unica-b text-mshop-black", children: T.commissionSnapshot.price.toLocaleString() }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: "원" })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex-col-center flex w-[22.85714rem] flex-col items-center justify-center gap-y-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: U[T.state].name }),
            U[T.state].description && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m whitespace-pre text-center text-mshop-gray-80", children: U[T.state].description }),
            U[T.state].isViewDueDateUpateDescription && T.updatedDueDate && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "크리에이터의 요청으로 마감 기한이 변경되었습니다." }),
            U[T.state].isViewDueDate && T.dueDate && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.57143rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "마감 기한" }),
                /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $(
                      "typo-mshop-en-14-unica-m",
                      T.updatedDueDate ? "text-mshop-gray-80" : "text-mshop-blue-100"
                    ),
                    children: jt(
                      T.updatedDueDate || T.dueDate,
                      "yyyy.MM.dd HH:mm"
                    )
                  }
                )
              ] }),
              T.updatedDueDate && /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-[0.57143rem] text-mshop-gray-80", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: "변경 기한" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m text-mshop-blue-100", children: jt(
                  T.dueDate,
                  "yyyy.MM.dd HH:mm"
                ) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col justify-center gap-y-[0.57143rem]", children: [
            T.state === Ln.TaskDone && /* @__PURE__ */ a.jsx(
              fn,
              {
                variant: "sm",
                theme: "blue",
                widthFull: !0,
                type: "button",
                disabled: w,
                onClick: K,
                children: "구매 확정"
              }
            ),
            T.state === Ln.Pending && /* @__PURE__ */ a.jsx(
              fn,
              {
                variant: "sm",
                theme: "line",
                widthFull: !0,
                type: "button",
                disabled: w,
                onClick: H,
                children: "취소 요청"
              }
            ),
            /* @__PURE__ */ a.jsx(
              fn,
              {
                variant: "sm",
                theme: "line",
                widthFull: !0,
                type: "button",
                onClick: () => m(
                  T.commission.projectId,
                  T.commission.id
                ),
                children: "커미션 문의하기"
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ a.jsxs("section", { className: "flex gap-x-[1.14286rem]", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex w-1/2 flex-col gap-y-[3.42857rem] pr-[1.14286rem]", children: [
          (T.state === Ln.Refunded || T.state === Ln.OnRefund) && ((Se = T.rejectionStatus) == null ? void 0 : Se.reason) === J0.Canceled && /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b border-b border-mshop-black pb-[0.857rem]", children: "커미션 거절 사유" }),
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m whitespace-pre-wrap py-[0.85714rem] text-mshop-black", children: (oe = T == null ? void 0 : T.rejectionStatus) == null ? void 0 : oe.message })
          ] }),
          U[T.state].isViewAdditionalMessage && T.additionalMessage && /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-y-[0.57143rem]", children: [
            /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b border-b border-mshop-black pb-[0.857rem]", children: "커미션 추가 안내" }),
            /* @__PURE__ */ a.jsx("div", { className: "typo-mshop-kr-14-m whitespace-pre-wrap py-[0.85714rem] text-mshop-black", children: T.additionalMessage })
          ] }),
          /* @__PURE__ */ a.jsx(
            VH,
            {
              commissionSnapshot: T.commissionSnapshot,
              preQuestionAnswer: T.preQuestionAnswer,
              message: T.message,
              files: T.files,
              isMobile: t
            }
          )
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex w-1/2 flex-col gap-y-[3.42857rem] pl-[1.14286rem]", children: [
          T.state !== Ln.Refunded && T.state !== Ln.OnRefund && /* @__PURE__ */ a.jsx(
            D6e,
            {
              requestState: T.state,
              commissionFiles: T.commissionFiles,
              recentWorkFileIndex: R
            }
          ),
          T.state === Ln.Refunded && I && /* @__PURE__ */ a.jsx(
            Kj,
            {
              type: "refund",
              paymentStatement: I,
              baseWidgetProps: {
                isMobile: t,
                toggleSpinner: r,
                client: e,
                onError: o
              },
              isShowReceiptButton: !0
            }
          ),
          /* @__PURE__ */ a.jsx(
            Kj,
            {
              type: "payment",
              paymentStatement: L,
              baseWidgetProps: { isMobile: t, toggleSpinner: r, client: e, onError: o },
              isShowReceiptButton: T.state !== Ln.Refunded
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ a.jsx("div", { className: "flex w-full justify-center pt-[1.71429rem]", children: /* @__PURE__ */ a.jsx(
      fn,
      {
        variant: "md",
        theme: "blue",
        type: "button",
        onClick: u,
        children: "커미션 내역으로 돌아가기"
      }
    ) })
  ] }) });
}
function O6e({
  commissionRequestId: e,
  onGoBackToCommissionListButtonClick: t,
  onContactButtonClick: n,
  onFileDownloadButtonClick: r,
  onShopButtonClick: s,
  ...o
}) {
  const [c, u] = Re(!0), [m, y] = Re(null);
  return an(() => {
    (async () => {
      const b = await uK(
        { commissionRequestId: e },
        {
          client: o.client,
          onError: o.onError
        }
      );
      if (b.code === le.Success)
        y(b.data);
      else
        throw new Error();
      u(!1);
    })();
  }, []), c || !m ? null : /* @__PURE__ */ a.jsx(
    P6e,
    {
      fetchedMypageCommission: m,
      onGoBackToCommissionListButtonClick: t,
      onContactButtonClick: n,
      onFileDownloadButtonClick: r,
      onShopButtonClick: s,
      ...o
    }
  );
}
class qje extends Ol {
  constructor({
    commissionRequestId: t,
    onGoBackToCommissionListButtonClick: n,
    onContactButtonClick: r,
    onFileDownloadButtonClick: s,
    onShopButtonClick: o,
    ...c
  }) {
    super(c), this.render = (u) => go(u).render(
      /* @__PURE__ */ a.jsx(
        O6e,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onScrollLock: this.onScrollLock,
          onError: this.onError,
          commissionRequestId: this.commissionRequestId,
          onGoBackToCommissionListButtonClick: this.onGoBackToCommissionListButtonClick,
          onContactButtonClick: this.onContactButtonClick,
          onFileDownloadButtonClick: this.onFileDownloadButtonClick,
          onShopButtonClick: this.onShopButtonClick
        }
      )
    ), this.commissionRequestId = t, this.onGoBackToCommissionListButtonClick = n, this.onContactButtonClick = r, this.onFileDownloadButtonClick = s, this.onShopButtonClick = o;
  }
}
const A6e = (e) => jn(
  "/mypage-commissions",
  {},
  e
).then((t) => {
  switch (t.code) {
    case le.Success:
      return t;
    default:
      throw new Error();
  }
}), fK = Qt(
  Vn
);
function L6e() {
  const [e, t] = Ar(
    fK
  );
  if (e === Vn)
    throw new Error(Xr(ia.MypageCommissions));
  return { mypageCommissions: e, setMypageCommissions: t };
}
const GH = {
  [Ln.Pending]: {
    elementProperty: "Awaiting"
  },
  [Ln.Accepted]: {
    elementProperty: "In Progress"
  },
  [Ln.TaskDone]: {
    elementProperty: "Done"
  },
  [Ln.Refunded]: {
    elementProperty: "Refunded"
  },
  [Ln.OnRefund]: {
    elementProperty: "Refund"
  },
  [Ln.End]: {
    elementProperty: "Confirmed"
  }
};
function WH({
  commissionSnapshot: e,
  state: t,
  createdAt: n,
  shop: r,
  onSeeCommissionDetailButtonClick: s,
  onShopButtonClick: o,
  isMobile: c
}) {
  const u = () => {
    r && o(r.url);
  };
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "relative rounded-[1.143rem] border border-mshop-gray-5",
        c ? "h-[34.28571rem]" : "h-[42.85714rem]"
      ),
      children: [
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: "isolate size-full overflow-hidden rounded-[1.143rem] bg-cover bg-center",
            style: {
              backgroundImage: `url(${e.thumbnailImage.url}?width=${3 * (c ? 288 : 326)}}&height=${3 * (c ? 480 : 600)})`
            },
            children: /* @__PURE__ */ a.jsx("div", { className: "aspect-[4/5] w-full bg-mshop-white", children: /* @__PURE__ */ a.jsx(
              aa,
              {
                src: e.thumbnailImage.url,
                width: c ? "20.5714rem" : "23.2857rem",
                height: c ? "25.7143rem" : "29.1071rem",
                objectFit: "cover"
              }
            ) })
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "absolute bottom-0 left-0 right-0 flex flex-col justify-end rounded-b-[1.143rem] bg-mshop-dim-60 backdrop-blur-[30px]",
              c ? "h-[25.71429rem] gap-[1.14286rem] px-[1.429rem] pb-[1.71429rem] pt-[1.143rem]" : "h-[31.42857rem] gap-[2.286rem] px-[1.429rem] pb-[2rem] pt-[1.143rem]"
            ),
            style: {
              mask: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 42.05%)"
            },
            children: [
              /* @__PURE__ */ a.jsxs("div", { children: [
                /* @__PURE__ */ a.jsxs(
                  "button",
                  {
                    type: "button",
                    onClick: u,
                    className: "flex items-center gap-[0.286rem]",
                    children: [
                      /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b line-clamp-1 text-mshop-white", children: Ef(r) }),
                      /* @__PURE__ */ a.jsx(ch, { className: "size-[1.143rem] shrink-0 text-mshop-white" })
                    ]
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "typo-mshop-kr-24-b mb-[0.57143rem] line-clamp-2 break-words text-mshop-white",
                      c ? "typo-mshop-kr-20-b" : "typo-mshop-kr-24-b"
                    ),
                    children: e.displayName
                  }
                ),
                /* @__PURE__ */ a.jsxs("div", { className: "mb-[0.28571rem] flex items-center gap-x-[0.28571rem] text-mshop-gray-20", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: c ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m",
                      children: "신청일"
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: c ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m",
                      children: jt(n, "yyyy. MM. dd")
                    }
                  )
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "text-mshop-gray-20", children: [
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: c ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m",
                      children: e.price.toLocaleString()
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    "span",
                    {
                      className: c ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m",
                      children: "원"
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ a.jsx(
                Y2,
                {
                  variant: "sm",
                  theme: "bright",
                  widthFull: !0,
                  type: "button",
                  onClick: s,
                  children: "커미션 상세보기"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a.jsx("section", { className: "absolute left-[1.43rem] top-[1.43rem]", children: c ? /* @__PURE__ */ a.jsx(
          _6,
          {
            property1: "Commission",
            property2: GH[t].elementProperty
          }
        ) : /* @__PURE__ */ a.jsx(
          dy,
          {
            property1: "Commission",
            property2: GH[t].elementProperty
          }
        ) })
      ]
    }
  );
}
const I6e = 1.25;
function F6e({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  onScrollLock: s,
  onError: o,
  fetchedMypageCommissions: c,
  onSeeCommissionDetailButtonClick: u,
  onShopButtonClick: m
}) {
  Al([
    [ol, e],
    [
      ll,
      {
        isMobile: t,
        isApp: n,
        toggleSpinner: r,
        onError: o,
        onScrollLock: s
      }
    ],
    [fK, c]
  ]);
  const { mypageCommissions: y } = L6e();
  return /* @__PURE__ */ a.jsx("div", { className: "twp", children: c.length === 0 ? /* @__PURE__ */ a.jsx("section", { className: "py-[11.42857rem]", children: /* @__PURE__ */ a.jsx(
    f5,
    {
      renderImage: /* @__PURE__ */ a.jsx(
        aa,
        {
          src: kt.KeyVisual.MembershipCommissionWhite,
          width: "11.4286rem",
          height: "11.4286rem"
        }
      ),
      title: "신청한 커미션이 없어요.",
      description: "좋아하는 크리에이터의 커미션을 신청해 보세요!"
    }
  ) }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: t ? /* @__PURE__ */ a.jsx("div", { className: "pt-[2.28571rem]", children: /* @__PURE__ */ a.jsx(
    Av,
    {
      slidesPerView: I6e,
      spaceBetween: kc(1.14286),
      slidesOffsetBefore: kc(1.14286),
      slidesOffsetAfter: kc(1.14286),
      modules: [zA],
      virtual: !0,
      children: y.map((b, w) => /* @__PURE__ */ a.jsx(Vg, { virtualIndex: w, children: /* @__PURE__ */ a.jsx(
        WH,
        {
          commissionSnapshot: b.commissionSnapshot,
          shop: b.seller.shop,
          state: b.state,
          createdAt: b.createdAt,
          onSeeCommissionDetailButtonClick: () => u(b.id),
          onShopButtonClick: m,
          isMobile: t
        },
        b.id
      ) }, b.id))
    }
  ) }) : /* @__PURE__ */ a.jsx("div", { className: "grid grid-cols-4 gap-[1.714rem]", children: y.map((b) => /* @__PURE__ */ a.jsx(
    WH,
    {
      commissionSnapshot: b.commissionSnapshot,
      shop: b.seller.shop,
      state: b.state,
      createdAt: b.createdAt,
      onSeeCommissionDetailButtonClick: () => u(b.id),
      onShopButtonClick: m,
      isMobile: t
    },
    b.id
  )) }) }) });
}
function U6e(e) {
  const [t, n] = Re(!0), [r, s] = Re(null);
  return an(() => {
    (async () => {
      const o = await A6e({
        client: e.client,
        onError: e.onError
      });
      if (o.code === le.Success)
        s(o.data.items);
      else
        throw new Error();
      n(!1);
    })();
  }, []), t || !r ? null : /* @__PURE__ */ a.jsx(
    F6e,
    {
      fetchedMypageCommissions: r,
      ...e
    }
  );
}
class Kje extends Ol {
  constructor({
    onSeeCommissionDetailButtonClick: t,
    onShopButtonClick: n,
    ...r
  }) {
    super(r), this.render = (s) => go(s).render(
      /* @__PURE__ */ a.jsx(
        U6e,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onScrollLock: this.onScrollLock,
          onError: this.onError,
          onSeeCommissionDetailButtonClick: this.onSeeCommissionDetailButtonClick,
          onShopButtonClick: this.onShopButtonClick
        }
      )
    ), this.onSeeCommissionDetailButtonClick = t, this.onShopButtonClick = n;
  }
}
const z6e = 608;
function B6e(e) {
  Al([
    [ol, e.client],
    [ll, e.widgetCore],
    [uq, e.paymentReceipt]
  ]);
  const { paymentReceipt: t } = dq();
  wt(t);
  const n = t.paymentDetails.cancelledAmount !== null, r = () => {
    const s = window.scrollY;
    window.addEventListener(
      "afterprint",
      () => {
        window.scrollTo(0, s);
      },
      {
        once: !0
      }
    ), window.print();
  };
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: "twp mx-auto flex flex-col gap-[1.71429rem] p-[2.28571rem] print:p-0",
      style: { maxWidth: z6e },
      children: [
        /* @__PURE__ */ a.jsxs("header", { className: "flex flex-col gap-[1.14286rem]", children: [
          n && /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[0.42857rem] rounded-[.65305rem] bg-mshop-red-10 p-[1.14285rem]", children: [
            /* @__PURE__ */ a.jsx(l_, { className: "size-[1.42857rem] text-mshop-red-80" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-red-80", children: "취소된 결제입니다." })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-[1.14286rem] border-b-[1px] border-l-0 border-r-0 border-t-0 border-solid border-mshop-gray-5 pb-[1.14286rem]", children: [
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-20-b flex-grow text-mshop-black", children: "결제 영수증" }),
            /* @__PURE__ */ a.jsx("div", { className: "print:hidden", children: /* @__PURE__ */ a.jsx(
              fn,
              {
                variant: "sm",
                theme: "blue",
                type: "button",
                widthFull: !0,
                onClick: r,
                children: "인쇄하기"
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[1.14285rem] border-b-[1px] border-l-0 border-r-0 border-t-0 border-solid border-mshop-gray-5 pb-[1.71428rem]", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "결제 정보" }),
          t.paymentRecord.payMethod === $g.Card && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
            /* @__PURE__ */ a.jsx("div", { className: "flex items-start justify-between", children: n ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "카드사 / 승인번호" }),
              /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[.28571rem]", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: t.paymentRecord.cardName }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: "/" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: t.paymentRecord.approvalNumber })
              ] })
            ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "카드사" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: t.paymentRecord.cardName })
            ] }) }),
            t.paymentRecord.cardNumber && /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "카드번호" }),
              /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: [
                "****-****-****-",
                t.paymentRecord.cardNumber.slice(-4)
              ] })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "거래종류/할부" }),
            /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[0.28571rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: t.paymentRecord.payMethod === $g.Card ? "신용(개인)" : c_[t.paymentRecord.payMethod] }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: "/" }),
              /* @__PURE__ */ a.jsx("span", {
                className: "typo-mshop-kr-16-m text-mshop-black",
                // https://ciety.xyz/@ciety-work/channels/1286?channelType=CHAT&highlightId=29160
                children: `${t.paymentRecord.cardQuota === 0 ? "일시불" : `할부 (${t.paymentRecord.cardQuota}개월)`}${n ? " 취소" : ""}`
              })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "결제일자" }),
            /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[.28571rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: jt(t.paymentRecord.paidAt, "yyyy.MM.dd") }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: jt(t.paymentRecord.paidAt, "HH:mm:ss") })
            ] })
          ] }),
          t.paymentRecord.cancelledAt && /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "취소일자" }),
            /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[.28571rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: jt(t.paymentRecord.cancelledAt, "yyyy.MM.dd") }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: jt(t.paymentRecord.cancelledAt, "HH:mm:ss") })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "구매자명" }),
            t.paymentRecord.username && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: t.paymentRecord.username })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "상품명" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: t.paymentRecord.productName })
          ] }),
          t.target === "MEMBERSHIP" && t.startTimeAt && t.endTimeAt && /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "이용 기간" }),
            /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-[.28571rem]", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: jt(t.startTimeAt, "yyyy.MM.dd") }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: "~" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: jt(t.endTimeAt, "yyyy.MM.dd") })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "구매번호" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: t.paymentRecord.paymentNo })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "상품번호" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: t.paymentRecord.paymentProductNo })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[1.14285rem] border-b-[1px] border-l-0 border-r-0 border-t-0 border-solid border-mshop-gray-5 pb-[1.71428rem]", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "판매자 정보" }),
          [
            ["상호", t.business.businessName],
            ["대표자명", t.business.representative],
            ["사업자등록번호", t.business.corporateRegistrationNum],
            ["전화번호", t.business.phoneNum],
            ["사업장주소", t.business.address]
          ].map(([s, o]) => /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m w-[9.14286rem] shrink-0 text-mshop-gray-50 print:text-mshop-gray-80", children: s }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-right text-mshop-black", children: o })
          ] }, s))
        ] }),
        /* @__PURE__ */ a.jsxs("section", { className: "flex flex-col gap-[1.14285rem]", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-black", children: "금액" }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: "승인금액" }),
            /* @__PURE__ */ a.jsxs("span", { children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: t.paymentDetails.approvedAmount.toLocaleString(
                cr.Ko
              ) }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-black", children: zs(t.paymentDetails.currency) })
            ] })
          ] }),
          [
            n ? [
              "취소금액",
              `-${t.paymentDetails.approvedAmount.toLocaleString(
                cr.Ko
              )}`
            ] : [],
            [
              "공급가액",
              `${n ? "-" : ""}${t.paymentDetails.supplyAmount.toLocaleString(cr.Ko)}`
            ],
            [
              "부가세액",
              `${n ? "-" : ""}${t.paymentDetails.tax.toLocaleString(cr.Ko)}`
            ]
          ].map(
            ([s, o]) => s && /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m text-mshop-gray-50 print:text-mshop-gray-80", children: s }),
              /* @__PURE__ */ a.jsxs("span", { children: [
                /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $("typo-mshop-kr-16-m", {
                      "text-mshop-red-80": n
                    }),
                    children: o
                  }
                ),
                /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $("typo-mshop-kr-16-m", {
                      "text-mshop-red-80": n
                    }),
                    children: zs(t.paymentDetails.currency)
                  }
                )
              ] })
            ] }, s)
          ),
          /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b text-mshop-gray-80", children: n ? "취소 금액 합계" : "합계" }),
            /* @__PURE__ */ a.jsxs("span", { children: [
              /* @__PURE__ */ a.jsx(
                "span",
                {
                  className: $("typo-mshop-en-20-unica-b", {
                    "text-mshop-red-80": n
                  }),
                  children: `${n ? "-" : ""}${parseInt(
                    t.paymentDetails.total,
                    10
                  ).toLocaleString(cr.Ko)}`
                }
              ),
              /* @__PURE__ */ a.jsx(
                "span",
                {
                  className: $("typo-mshop-kr-20-b", {
                    "text-mshop-red-80": n
                  }),
                  children: zs(t.paymentDetails.currency)
                }
              )
            ] })
          ] })
        ] })
      ]
    }
  );
}
function H6e({
  client: e,
  isApp: t,
  isMobile: n,
  paymentStatementId: r,
  onError: s,
  onScrollLock: o,
  toggleSpinner: c
}) {
  const [u, m] = Re(!0), [y, b] = Re(null);
  return an(() => {
    (async () => {
      const w = await kw(
        {
          paymentStatementId: r
        },
        {
          client: e,
          onError: s
        }
      );
      if (w.code === le.TokenExpired)
        return s(Ht);
      b({
        paymentReceipt: w.data
      }), m(!1);
    })();
  }, []), u || y === null ? null : /* @__PURE__ */ a.jsx(
    B6e,
    {
      client: e,
      widgetCore: {
        isMobile: n,
        isApp: t,
        toggleSpinner: c,
        onScrollLock: o,
        onError: s
      },
      paymentReceipt: y.paymentReceipt
    }
  );
}
class Xje extends Ol {
  constructor({
    client: t,
    isMobile: n,
    isApp: r,
    paymentStatementId: s,
    toggleSpinner: o,
    onError: c,
    onScrollLock: u
  }) {
    super({
      client: t,
      isMobile: n,
      isApp: r,
      toggleSpinner: o,
      onError: c,
      onScrollLock: u
    }), this.render = (m) => {
      go(m).render(
        /* @__PURE__ */ a.jsx(
          H6e,
          {
            client: this.client,
            isApp: this.isApp,
            isMobile: this.isMobile,
            paymentStatementId: this.paymentStatementId,
            onError: this.onError,
            onScrollLock: this.onScrollLock,
            toggleSpinner: this.toggleSpinner
          }
        )
      );
    }, this.paymentStatementId = s;
  }
}
const V6e = (e, t) => jn("/mainpage", { body: e }, t).then(
  (n) => {
    switch (n.code) {
      case le.Success:
        return n;
      default:
        throw new Error();
    }
  }
), mK = Qt(Vn), $6e = () => {
  const [e, t] = Ar(mK);
  if (e === Vn)
    throw new Error(Xr(ia.Mainpage));
  return {
    mainpage: e,
    setMainpage: t
  };
}, YH = 8, G6e = 4, W6e = 5, Y6e = [
  ss.BuyDigitalGoods,
  ss.BuyGoods,
  ss.BuyOrderMade
], q6e = (e) => Y6e.includes(e.type);
function qR({
  thumbnailImage: e,
  displayName: t,
  payment: n,
  rewards: r,
  description: s,
  showSwiperButtons: o,
  isAnimating: c,
  onPrevSlide: u,
  onNextSlide: m,
  onMembershipThumbnailClick: y,
  onMembershipJoinButtonClick: b,
  onMembershipDimThumbnailClick: w
}) {
  const [k, j] = Re(!1), {
    widgetCore: { isMobile: E }
  } = Gt(), [T, D] = Re(
    E ? W6e : YH
  ), L = Rt(null);
  an(() => {
    if (!L.current || E)
      return;
    const H = new ResizeObserver((K) => {
      requestAnimationFrame(() => {
        for (const q of K)
          D(
            q.contentRect.width > 528 ? YH : G6e
          );
      });
    });
    return L.current && H.observe(L.current), () => {
      L.current && H.unobserve(L.current);
    };
  }, []);
  const I = Qu(
    r,
    j1(q6e),
    YP((H) => H.products),
    e$((H) => H.id),
    $V((H, K) => K.price - H.price),
    py
  ), R = E ? _6 : dy, U = E ? "div" : "a", z = E ? "div" : "button";
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      ref: L,
      className: $(
        "relative isolate overflow-hidden rounded-[1.14286rem]",
        E ? "h-[9.71429rem]" : "h-[13.14286rem]"
      ),
      children: [
        /* @__PURE__ */ a.jsx("div", { className: "absolute size-full", children: /* @__PURE__ */ a.jsx(
          aa,
          {
            src: e.url,
            width: E ? "23.8571rem" : "48.5714rem",
            height: E ? "9.7143rem" : "13.1429rem",
            objectFit: "cover"
          }
        ) }),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "absolute flex w-full cursor-pointer items-center bg-mshop-dim-60 backdrop-blur-[30px]",
              E ? "gap-[0.57143rem] p-[1.14286rem]" : "gap-[1.14286rem] p-[1.71429rem]"
            ),
            onClick: c ? Gd : b,
            children: [
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    "relative shrink-0",
                    E ? "size-[7.42857rem]" : "size-[9.71429rem]"
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        type: "button",
                        className: "isolate overflow-hidden rounded-full",
                        onClick: (H) => {
                          H.stopPropagation(), y();
                        },
                        children: /* @__PURE__ */ a.jsx(
                          aa,
                          {
                            src: e.url,
                            width: E ? "7.4286rem" : "9.7143rem",
                            height: E ? "7.4286rem" : "9.7143rem",
                            objectFit: "cover"
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ a.jsx("div", { className: "absolute left-0 top-0", children: /* @__PURE__ */ a.jsx(R, { property1: "Membership", property2: "Icon+Text" }) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsxs("div", { className: "relative flex flex-grow flex-col justify-between self-stretch", children: [
                o && /* @__PURE__ */ a.jsxs("div", { className: "absolute right-0 top-0 flex gap-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    wy,
                    {
                      type: "button",
                      direction: "left",
                      background: "bright",
                      onClick: (H) => {
                        H.stopPropagation(), u();
                      }
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    wy,
                    {
                      type: "button",
                      direction: "right",
                      background: "bright",
                      onClick: (H) => {
                        H.stopPropagation(), m();
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: $("flex flex-col", {
                      "w-[calc(100%-6.85714rem)]": o && !E
                    }),
                    children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $(
                            "line-clamp-1 break-words text-mshop-white",
                            E ? "typo-mshop-kr-16-b" : "typo-mshop-kr-20-m"
                          ),
                          children: t
                        }
                      ),
                      /* @__PURE__ */ a.jsxs(
                        "span",
                        {
                          className: $(
                            "flex items-center",
                            E ? "gap-[0.35714rem]" : "gap-[0.57143rem]"
                          ),
                          children: [
                            /* @__PURE__ */ a.jsxs("span", { className: "flex items-center", children: [
                              /* @__PURE__ */ a.jsx(
                                "span",
                                {
                                  className: $(
                                    "text-mshop-white",
                                    E ? "typo-mshop-en-16-unica-b" : "typo-mshop-en-20-unica-b"
                                  ),
                                  children: n.price.toLocaleString(cr.Ko)
                                }
                              ),
                              /* @__PURE__ */ a.jsx(
                                "span",
                                {
                                  className: $(
                                    "text-mshop-white",
                                    E ? "typo-mshop-kr-16-b" : "typo-mshop-kr-20-b"
                                  ),
                                  children: zs(n.currency)
                                }
                              )
                            ] }),
                            /* @__PURE__ */ a.jsx(
                              "span",
                              {
                                className: $(
                                  "text-mshop-gray-50",
                                  E ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                                ),
                                children: "/"
                              }
                            ),
                            /* @__PURE__ */ a.jsxs(
                              "span",
                              {
                                className: $(
                                  "text-mshop-gray-10",
                                  E ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                                ),
                                children: [
                                  n.type === $n.ShortTermPass && "기간 한정",
                                  n.type === $n.SubscriptionPass && "정기 구독"
                                ]
                              }
                            )
                          ]
                        }
                      )
                    ]
                  }
                ),
                I.length ? /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $(
                      "grid",
                      { "grid-cols-5 gap-[0.38rem]": T === 5 },
                      { "grid-cols-4 gap-[0.57rem]": T === 4 },
                      { "grid-cols-8 gap-[0.38rem]": T === 8 }
                    ),
                    children: I.slice(0, T).map(
                      ({ id: H, image: K, imageRatio: q, link: Q }, Z) => Z === T - 1 && I.length > T ? /* @__PURE__ */ a.jsxs(
                        z,
                        {
                          className: $(
                            "flex-center relative isolate aspect-square overflow-hidden bg-mshop-gray-5",
                            E ? "rounded-[0.42857rem]" : "rounded-[0.57143rem]"
                          ),
                          ...!E && {
                            type: "button",
                            onClick: (X) => {
                              X.stopPropagation(), w();
                            }
                          },
                          children: [
                            /* @__PURE__ */ a.jsx(
                              "img",
                              {
                                alt: "",
                                src: K,
                                className: "aspect-ratio object-cover",
                                style: {
                                  width: `${q}%`
                                },
                                onLoad: () => j(!0)
                              }
                            ),
                            k && /* @__PURE__ */ a.jsxs(
                              "span",
                              {
                                className: $(
                                  "flex-center absolute top-0 size-full bg-black/30 text-mshop-white",
                                  E ? "typo-mshop-en-16-unica-b" : "typo-mshop-en-20-unica-b"
                                ),
                                children: [
                                  "+ ",
                                  I.length - T
                                ]
                              }
                            )
                          ]
                        },
                        H
                      ) : /* @__PURE__ */ a.jsx(
                        U,
                        {
                          className: $(
                            "flex-center isolate aspect-square overflow-hidden bg-mshop-gray-5",
                            E ? "rounded-[0.42857rem]" : "rounded-[0.57143rem]"
                          ),
                          ...!E && {
                            href: Q,
                            onClick: (X) => X.stopPropagation()
                          },
                          children: /* @__PURE__ */ a.jsx(
                            "img",
                            {
                              alt: "",
                              src: K,
                              className: "aspect-square object-cover",
                              style: {
                                width: `${q}%`
                              }
                            }
                          )
                        },
                        H
                      )
                    )
                  }
                ) : /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-end gap-[1.14286rem]", children: [
                  !E && s && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-r line-clamp-2 flex-grow break-all text-mshop-white", children: s }),
                  /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      type: "button",
                      className: "flex-center typo-mshop-kr-14-b border-mshop-wh min-w-[8.57143rem] shrink-0 rounded-[0.57143rem] border bg-mshop-bright-20 px-[1.71429rem] py-[0.64286rem] text-mshop-white backdrop-blur-[20px]",
                      onClick: (H) => {
                        H.stopPropagation(), b();
                      },
                      children: "멤버십 가입하기"
                    }
                  )
                ] })
              ] })
            ]
          }
        )
      ]
    }
  );
}
function KR({
  thumbnailImage: e,
  displayName: t,
  price: n,
  estimatedTime: r,
  description: s,
  showSwiperButtons: o,
  isAnimating: c,
  onPrevSlide: u,
  onNextSlide: m,
  onCommissionThumbnailClick: y,
  onCommissionRequestButtonClick: b
}) {
  const {
    widgetCore: { isMobile: w }
  } = Gt(), k = w ? _6 : dy;
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "relative isolate overflow-hidden rounded-[1.14286rem]",
        w ? "h-[9.71429rem]" : "h-[13.14286rem]"
      ),
      children: [
        /* @__PURE__ */ a.jsx("div", { className: "absolute size-full", children: /* @__PURE__ */ a.jsx(
          aa,
          {
            src: e.url,
            width: w ? "23.8571rem" : "48.5714rem",
            height: w ? "9.7143rem" : "13.1429rem",
            objectFit: "cover"
          }
        ) }),
        /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: $(
              "absolute flex w-full cursor-pointer items-center bg-mshop-dim-60 backdrop-blur-[30px]",
              w ? "gap-[0.57143rem] p-[1.14286rem]" : "gap-[1.14286rem] p-[1.71429rem]"
            ),
            onClick: c ? Gd : b,
            children: [
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    "relative shrink-0",
                    w ? "size-[7.42857rem]" : "size-[9.71429rem]"
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        type: "button",
                        className: "isolate overflow-hidden rounded-full",
                        onClick: (j) => {
                          j.stopPropagation(), y();
                        },
                        children: /* @__PURE__ */ a.jsx(
                          aa,
                          {
                            src: e.url,
                            width: w ? "7.4286rem" : "9.7143rem",
                            height: w ? "7.4286rem" : "9.7143rem",
                            objectFit: "cover"
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ a.jsx("div", { className: "absolute left-0 top-0", children: /* @__PURE__ */ a.jsx(k, { property1: "Commission", property2: "Text" }) })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsxs("div", { className: "relative flex flex-grow flex-col justify-between self-stretch", children: [
                o && /* @__PURE__ */ a.jsxs("div", { className: "absolute right-0 top-0 flex gap-[0.57143rem]", children: [
                  /* @__PURE__ */ a.jsx(
                    wy,
                    {
                      type: "button",
                      direction: "left",
                      background: "bright",
                      onClick: (j) => {
                        j.stopPropagation(), u();
                      }
                    }
                  ),
                  /* @__PURE__ */ a.jsx(
                    wy,
                    {
                      type: "button",
                      direction: "right",
                      background: "bright",
                      onClick: (j) => {
                        j.stopPropagation(), m();
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ a.jsxs(
                  "div",
                  {
                    className: $("flex flex-col", {
                      // https://github.com/marpple/mco-membership/pull/3045/files#diff-afbd1ddea0249625fdc0dc9c3cd996e9aa9bacbbc1113f8d537ef213bc8270b8
                      "w-[calc(100%-6.28571rem)]": o
                    }),
                    children: [
                      /* @__PURE__ */ a.jsx(
                        "span",
                        {
                          className: $(
                            "line-clamp-1 break-words text-mshop-white",
                            w ? "typo-mshop-kr-16-b" : "typo-mshop-kr-20-m"
                          ),
                          children: t
                        }
                      ),
                      /* @__PURE__ */ a.jsxs(
                        "span",
                        {
                          className: $(
                            "flex flex-wrap items-center",
                            w ? "gap-[0.35714rem]" : "gap-[0.57143rem]"
                          ),
                          children: [
                            /* @__PURE__ */ a.jsxs("span", { className: "flex items-center", children: [
                              /* @__PURE__ */ a.jsx(
                                "span",
                                {
                                  className: $(
                                    "text-mshop-white",
                                    w ? "typo-mshop-en-16-unica-b" : "typo-mshop-en-20-unica-b"
                                  ),
                                  children: n.toLocaleString(cr.Ko)
                                }
                              ),
                              /* @__PURE__ */ a.jsx(
                                "span",
                                {
                                  className: $(
                                    "text-mshop-white",
                                    w ? "typo-mshop-kr-16-b" : "typo-mshop-kr-20-b"
                                  ),
                                  children: "원"
                                }
                              )
                            ] }),
                            /* @__PURE__ */ a.jsx(
                              "span",
                              {
                                className: $(
                                  "text-mshop-gray-50",
                                  w ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                                ),
                                children: "/"
                              }
                            ),
                            /* @__PURE__ */ a.jsxs("span", { className: "flex items-center gap-x-2", children: [
                              /* @__PURE__ */ a.jsx(
                                "span",
                                {
                                  className: $(
                                    "text-mshop-gray-10",
                                    w ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                                  ),
                                  children: "예상 작업기간"
                                }
                              ),
                              /* @__PURE__ */ a.jsxs(
                                "span",
                                {
                                  className: $(
                                    "text-mshop-gray-10",
                                    w ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                                  ),
                                  children: [
                                    r,
                                    "일"
                                  ]
                                }
                              )
                            ] })
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-end gap-[1.14286rem]", children: [
                  !w && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-r line-clamp-2 flex-grow break-all text-mshop-white", children: s }),
                  /* @__PURE__ */ a.jsx(
                    "button",
                    {
                      type: "button",
                      className: "flex-center typo-mshop-kr-14-b border-mshop-wh min-w-[8.57143rem] shrink-0 rounded-[0.57143rem] border bg-mshop-bright-20 px-[1.71429rem] py-[0.64286rem] text-mshop-white backdrop-blur-[20px]",
                      onClick: (j) => {
                        j.stopPropagation(), b();
                      },
                      children: "커미션 신청하기"
                    }
                  )
                ] })
              ] })
            ]
          }
        )
      ]
    }
  );
}
const K6e = 400, X6e = 6e3, qH = 1.12;
function Q6e(e) {
  Al([
    [ol, e.client],
    [ll, e.widgetCore],
    [R1, e.projectId],
    [mK, e.mainpage]
  ]);
  const { mainpage: t } = $6e(), n = Rt(null), r = Rt(null), {
    widgetCore: { isMobile: s }
  } = Gt(), [o, c] = Re(!1), u = t.memberships.sort(
    (E, T) => E.index - T.index
  ), m = t.commissions.filter((E) => E.state === "OPEN").sort((E, T) => E.index - T.index), y = {
    speed: K6e,
    modules: [eCe],
    autoplay: {
      delay: X6e,
      pauseOnMouseEnter: !0
    }
  }, b = () => {
    wt(n.current), n.current.slidePrev();
  }, w = () => {
    wt(n.current), n.current.slideNext();
  }, k = () => {
    wt(r.current), r.current.slidePrev();
  }, j = () => {
    wt(r.current), r.current.slideNext();
  };
  return /* @__PURE__ */ a.jsx("div", { className: "twp", children: s ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[1.14286rem]", children: [
    !!u.length && /* @__PURE__ */ a.jsx(a.Fragment, { children: u.length === 1 ? /* @__PURE__ */ a.jsx("div", { className: "px-[1.14286rem]", children: u.map((E) => /* @__PURE__ */ a.jsx(Vg, { children: /* @__PURE__ */ a.jsx(
      qR,
      {
        displayName: E.displayName,
        payment: E.payment,
        rewards: E.rewards,
        thumbnailImage: E.thumbnailImage,
        description: E.description,
        showSwiperButtons: !1,
        isAnimating: !1,
        onPrevSlide: b,
        onNextSlide: w,
        onMembershipThumbnailClick: e.onMembershipThumbnailClick,
        onMembershipJoinButtonClick: e.onMembershipJoinButtonClick,
        onMembershipDimThumbnailClick: e.onMembershipDimThumbnailClick
      }
    ) }, E.id)) }) : /* @__PURE__ */ a.jsx(
      Av,
      {
        style: {
          width: "100%"
        },
        slidesPerView: qH,
        spaceBetween: kc(0.85714),
        slidesOffsetBefore: kc(1.14286),
        slidesOffsetAfter: kc(1.14286),
        ...y,
        children: u.map((E) => /* @__PURE__ */ a.jsx(Vg, { children: /* @__PURE__ */ a.jsx(
          qR,
          {
            displayName: E.displayName,
            payment: E.payment,
            rewards: E.rewards,
            thumbnailImage: E.thumbnailImage,
            description: E.description,
            showSwiperButtons: !1,
            isAnimating: !1,
            onPrevSlide: b,
            onNextSlide: w,
            onMembershipThumbnailClick: e.onMembershipThumbnailClick,
            onMembershipJoinButtonClick: e.onMembershipJoinButtonClick,
            onMembershipDimThumbnailClick: e.onMembershipDimThumbnailClick
          }
        ) }, E.id))
      }
    ) }),
    !!m.length && /* @__PURE__ */ a.jsx(a.Fragment, { children: m.length === 1 ? /* @__PURE__ */ a.jsx("div", { className: "px-[1.14286rem]", children: m.map((E) => /* @__PURE__ */ a.jsx(Vg, { children: /* @__PURE__ */ a.jsx(
      KR,
      {
        thumbnailImage: E.thumbnailImage,
        displayName: E.displayName,
        price: E.price,
        estimatedTime: E.estimatedTime,
        description: E.description,
        showSwiperButtons: !1,
        isAnimating: !1,
        onPrevSlide: k,
        onNextSlide: j,
        onCommissionThumbnailClick: e.onCommissionThumbnailClick,
        onCommissionRequestButtonClick: e.onCommissionRequestButtonClick
      }
    ) }, E.id)) }) : /* @__PURE__ */ a.jsx(
      Av,
      {
        style: {
          width: "100%"
        },
        slidesPerView: qH,
        spaceBetween: kc(0.85714),
        slidesOffsetBefore: kc(1.14286),
        slidesOffsetAfter: kc(1.14286),
        ...y,
        children: m.map((E) => /* @__PURE__ */ a.jsx(Vg, { children: /* @__PURE__ */ a.jsx(
          KR,
          {
            thumbnailImage: E.thumbnailImage,
            displayName: E.displayName,
            price: E.price,
            estimatedTime: E.estimatedTime,
            description: E.description,
            showSwiperButtons: !1,
            isAnimating: !1,
            onPrevSlide: k,
            onNextSlide: j,
            onCommissionThumbnailClick: e.onCommissionThumbnailClick,
            onCommissionRequestButtonClick: e.onCommissionRequestButtonClick
          }
        ) }, E.id))
      }
    ) })
  ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[1.14286rem]", children: [
    !!u.length && /* @__PURE__ */ a.jsx(
      Av,
      {
        style: { width: "50%", margin: 0 },
        spaceBetween: kc(1.14286),
        loop: !0,
        onSwiper: (E) => {
          n.current = E;
        },
        onSlideChangeTransitionStart: () => c(!0),
        onSlideChangeTransitionEnd: () => c(!1),
        ...y,
        children: u.map((E) => /* @__PURE__ */ a.jsx(Vg, { children: /* @__PURE__ */ a.jsx(
          qR,
          {
            displayName: E.displayName,
            payment: E.payment,
            rewards: E.rewards,
            thumbnailImage: E.thumbnailImage,
            description: E.description,
            showSwiperButtons: u.length >= 2,
            isAnimating: o,
            onPrevSlide: b,
            onNextSlide: w,
            onMembershipThumbnailClick: e.onMembershipThumbnailClick,
            onMembershipJoinButtonClick: e.onMembershipJoinButtonClick,
            onMembershipDimThumbnailClick: e.onMembershipDimThumbnailClick
          }
        ) }, E.id))
      }
    ),
    !!m.length && /* @__PURE__ */ a.jsx(
      Av,
      {
        style: { width: "50%", margin: 0 },
        spaceBetween: kc(1.14286),
        loop: !0,
        onSwiper: (E) => {
          r.current = E;
        },
        onSlideChangeTransitionStart: () => c(!0),
        onSlideChangeTransitionEnd: () => c(!1),
        ...y,
        children: m.map((E) => /* @__PURE__ */ a.jsx(Vg, { children: /* @__PURE__ */ a.jsx(
          KR,
          {
            thumbnailImage: E.thumbnailImage,
            displayName: E.displayName,
            price: E.price,
            estimatedTime: E.estimatedTime,
            description: E.description,
            showSwiperButtons: m.length >= 2,
            isAnimating: o,
            onPrevSlide: k,
            onNextSlide: j,
            onCommissionThumbnailClick: e.onCommissionThumbnailClick,
            onCommissionRequestButtonClick: e.onCommissionRequestButtonClick
          }
        ) }, E.id))
      }
    )
  ] }) });
}
function Z6e({
  client: e,
  isApp: t,
  isMobile: n,
  projectId: r,
  onError: s,
  onScrollLock: o,
  toggleSpinner: c,
  onMembershipThumbnailClick: u,
  onMembershipJoinButtonClick: m,
  onMembershipDimThumbnailClick: y,
  onCommissionThumbnailClick: b,
  onCommissionRequestButtonClick: w
}) {
  const [k, j] = Re(null), [E, T] = Re(!0);
  return an(() => {
    (async () => {
      const D = await V6e(
        {
          projectId: r
        },
        { client: e, onError: s }
      );
      j({
        mainpage: D.data
      }), T(!1);
    })();
  }, []), E || k === null || k.mainpage.memberships.length === 0 && k.mainpage.commissions.filter(
    (D) => D.state === "OPEN"
  ).length === 0 ? null : /* @__PURE__ */ a.jsx(
    Q6e,
    {
      client: e,
      widgetCore: {
        isMobile: n,
        isApp: t,
        toggleSpinner: c,
        onError: s,
        onScrollLock: o
      },
      projectId: r,
      mainpage: k.mainpage,
      onMembershipThumbnailClick: u,
      onMembershipJoinButtonClick: m,
      onMembershipDimThumbnailClick: y,
      onCommissionThumbnailClick: b,
      onCommissionRequestButtonClick: w
    }
  );
}
class Qje extends Ol {
  constructor({
    client: t,
    isApp: n,
    isMobile: r,
    projectId: s,
    onError: o,
    onScrollLock: c,
    toggleSpinner: u,
    onMembershipThumbnailClick: m,
    onMembershipJoinButtonClick: y,
    onMembershipDimThumbnailClick: b,
    onCommissionThumbnailClick: w,
    onCommissionRequestButtonClick: k
  }) {
    super({
      client: t,
      isApp: n,
      isMobile: r,
      onError: o,
      onScrollLock: c,
      toggleSpinner: u
    }), this.render = (j) => {
      go(j).render(
        /* @__PURE__ */ a.jsx(
          Z6e,
          {
            client: this.client,
            isMobile: this.isMobile,
            isApp: this.isApp,
            projectId: this.projectId,
            toggleSpinner: this.toggleSpinner,
            onError: this.onError,
            onScrollLock: this.onScrollLock,
            onMembershipThumbnailClick: this.onMembershipThumbnailClick,
            onMembershipJoinButtonClick: this.onMembershipJoinButtonClick,
            onMembershipDimThumbnailClick: this.onMembershipDimThumbnailClick,
            onCommissionThumbnailClick: this.onCommissionThumbnailClick,
            onCommissionRequestButtonClick: this.onCommissionRequestButtonClick
          }
        )
      );
    }, this.projectId = s, this.onMembershipThumbnailClick = m, this.onMembershipJoinButtonClick = y, this.onMembershipDimThumbnailClick = b, this.onCommissionThumbnailClick = w, this.onCommissionRequestButtonClick = k;
  }
}
const hK = (e) => jn("/mypage-supports", {}, e).then(
  (t) => {
    switch (t.code) {
      case le.Success:
        return t;
      default:
        throw new Error();
    }
  }
), pK = Qt(Vn), gK = () => {
  const [e, t] = Ar(pK);
  if (e === Vn)
    throw new Error(Xr(ia.MypageSupports));
  return {
    mypageSupports: e,
    setMypageSupports: t
  };
}, J6e = () => {
  const [e, t] = Ar(cq);
  return {
    user: e,
    setUser: t
  };
};
function KH(e) {
  const {
    widgetCore: { isMobile: t }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(
    dh,
    {
      show: e.show ?? !0,
      variant: "TYPE02",
      onClose: e.onClose,
      children: [
        t ? /* @__PURE__ */ a.jsx(
          LA,
          {
            variant: "Text+Close",
            title: "후원 감사 인사",
            theme: "Light",
            onCloseButtonClick: e.onClose
          }
        ) : /* @__PURE__ */ a.jsx(
          D1,
          {
            titleAlign: "Left",
            back: !1,
            close: !0,
            label: "후원 감사 인사",
            onCloseButtonClick: e.onClose
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "main",
          {
            className: $(
              "flex flex-col overflow-auto bg-mshop-white",
              t ? "h-full items-start gap-[1.71429rem] p-[1.14286rem]" : "max-h-[42.42857rem] items-center gap-[2.28571rem] px-[2.28571rem] pb-[2.28571rem] pt-[1.14286rem]"
            ),
            children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "isolate shrink-0 overflow-hidden rounded-[1.14286rem]",
                    t ? "aspect-square w-full" : "size-[24.57143rem]"
                  ),
                  children: /* @__PURE__ */ a.jsx(
                    aa,
                    {
                      src: e.thankImageUrl,
                      width: "24.5714rem",
                      height: "24.5714rem",
                      objectFit: "cover"
                    }
                  )
                }
              ),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[1.71429rem] self-stretch", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-20-b text-mshop-black", children: "크리에이터의 감사 인사가 도착했어요!" }),
                /* @__PURE__ */ a.jsx(
                  "p",
                  {
                    className: $("self-stretch whitespace-pre-wrap", {
                      "rounded-[0.57143rem] border border-mshop-gray-10 p-[1.14286rem]": !t
                    }),
                    children: e.thankDescription
                  }
                )
              ] })
            ]
          }
        ),
        t && /* @__PURE__ */ a.jsx("footer", { className: "bg-mshop-white p-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
          uh,
          {
            theme: "blue",
            type: "button",
            widthFull: !0,
            onClick: e.onClose,
            children: "확인"
          }
        ) })
      ]
    }
  );
}
function XH({
  displayName: e,
  lastPaymentAt: t,
  paymentCount: n,
  state: r,
  thankDescription: s,
  thankImage: o,
  thumbnailImage: c,
  totalPrice: u,
  supportId: m,
  projectId: y,
  shop: b,
  onSeeSupportDetailButtonClick: w,
  onIntegratedPaidServiceTermsTextClick: k,
  onClickPersonalInfoOutsourcing: j,
  onClickThirdPartyConsent: E,
  onClickInicisTerms: T,
  onMySupportMessageButtonClick: D,
  onShopButtonClick: L
}) {
  const [I, R] = Re(null), { client: U } = Ha(), { setUser: z } = J6e(), {
    widgetCore: { toggleSpinner: H, onError: K, isMobile: q, isApp: Q }
  } = Gt(), [Z, X] = Re(!1), { setMypageSupports: se } = gK(), te = r !== "OPEN" || Z, fe = q ? _6 : dy, ce = async () => {
    X(!0), H(!0);
    const oe = await oq(
      {
        projectId: y
      },
      {
        client: U,
        onError: K
      }
    );
    if (X(!1), H(!1), oe.code === le.TokenExpired)
      return K(Ht);
    z(oe.data), R("additionalSupport");
  }, pe = async () => {
    X(!0), H(!0);
    const oe = await hK({
      client: U,
      onError: K
    });
    X(!1), H(!1), se(oe.data);
  }, Se = () => {
    b && L(b.url);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        id: "my-page-support-card",
        className: $(
          "relative rounded-[1.143rem] border border-mshop-gray-5",
          q ? "h-[34.28571rem]" : "h-[42.857rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx(
            "div",
            {
              className: "isolate size-full overflow-hidden rounded-[1.143rem] bg-cover bg-center",
              style: {
                backgroundImage: `url(${c.url}?width=${3 * (q ? 288 : 326)}}&height=${3 * (q ? 480 : 600)})`
              },
              children: /* @__PURE__ */ a.jsx("div", { className: "aspect-[4/5] w-full bg-mshop-white", children: /* @__PURE__ */ a.jsx(
                aa,
                {
                  src: c.url,
                  width: q ? "20.5714rem" : "23.2857rem",
                  height: q ? "25.7143rem" : "29.1071rem",
                  objectFit: "cover"
                }
              ) })
            }
          ),
          /* @__PURE__ */ a.jsxs(
            "div",
            {
              className: $(
                "absolute bottom-0 left-0 right-0 flex flex-col justify-end rounded-b-[1.143rem] bg-mshop-dim-60 backdrop-blur-[30px]",
                q ? "h-[25.71429rem] gap-[1.14286rem] p-[1.14286rem]" : "h-[31.42857rem] gap-[2.286rem] px-[1.429rem] pb-[2rem] pt-[1.143rem]"
              ),
              style: {
                mask: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 42.05%)"
              },
              children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
                  /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.286rem]", children: [
                    /* @__PURE__ */ a.jsxs(
                      "button",
                      {
                        type: "button",
                        onClick: Se,
                        className: "flex items-center gap-[0.286rem]",
                        children: [
                          /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b line-clamp-1 text-mshop-white", children: Ef(b) }),
                          /* @__PURE__ */ a.jsx(ch, { className: "size-[1.143rem] shrink-0 text-mshop-white" })
                        ]
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "h2",
                      {
                        className: $(
                          "line-clamp-2 break-words text-mshop-white",
                          q ? "typo-mshop-kr-20-b" : "typo-mshop-kr-24-b"
                        ),
                        children: e
                      }
                    )
                  ] }),
                  /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: $(
                        "flex flex-col",
                        q ? "gap-[0.14286rem]" : "gap-[0.286rem]"
                      ),
                      children: [
                        /* @__PURE__ */ a.jsx(
                          "span",
                          {
                            className: $(
                              "text-mshop-gray-20",
                              q ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m"
                            ),
                            children: jt(t, "yyyy. MM. dd")
                          }
                        ),
                        /* @__PURE__ */ a.jsxs("span", { className: "flex items-start gap-[0.286rem]", children: [
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $(
                                "text-mshop-gray-20",
                                q ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m"
                              ),
                              children: "Total"
                            }
                          ),
                          /* @__PURE__ */ a.jsxs("span", { className: "flex items-start", children: [
                            /* @__PURE__ */ a.jsx(
                              "span",
                              {
                                className: $(
                                  "text-mshop-gray-20",
                                  q ? "typo-mshop-en-12-unica-m" : "typo-mshop-en-14-unica-m"
                                ),
                                children: u === null ? "0" : u.toLocaleString(cr.Ko)
                              }
                            ),
                            /* @__PURE__ */ a.jsx(
                              "span",
                              {
                                className: $(
                                  "text-mshop-gray-20",
                                  q ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                                ),
                                children: "원"
                              }
                            )
                          ] }),
                          /* @__PURE__ */ a.jsx(
                            "span",
                            {
                              className: $(
                                "text-mshop-gray-20",
                                q ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                              ),
                              children: "후원"
                            }
                          )
                        ] })
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
                  r === "OPEN" ? /* @__PURE__ */ a.jsx(
                    fn,
                    {
                      variant: "sm",
                      theme: "blue",
                      widthFull: !0,
                      disabled: Q ?? te,
                      type: "button",
                      onClick: Q ? Gd : ce,
                      children: Q ? "추가 후원은 PC에서만 가능해요" : "추가 후원하기"
                    }
                  ) : /* @__PURE__ */ a.jsx(
                    fn,
                    {
                      variant: "sm",
                      theme: "blue",
                      widthFull: !0,
                      disabled: te,
                      type: "button",
                      onClick: ce,
                      children: "종료된 후원입니다"
                    }
                  ),
                  /* @__PURE__ */ a.jsxs("div", { className: "flex gap-[0.571rem]", children: [
                    /* @__PURE__ */ a.jsx(
                      Y2,
                      {
                        variant: "sm",
                        theme: "bright",
                        widthFull: !0,
                        type: "button",
                        onClick: () => R("thanksMessage"),
                        children: "후원 감사 인사"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      Y2,
                      {
                        variant: "sm",
                        theme: "bright",
                        widthFull: !0,
                        type: "button",
                        onClick: w,
                        children: "후원 상세보기"
                      }
                    )
                  ] })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ a.jsx(
            "span",
            {
              className: $(
                "absolute",
                q ? "left-[1.14rem] top-[1.14rem]" : "left-[1.429rem] top-[1.429rem]"
              ),
              children: /* @__PURE__ */ a.jsx(
                fe,
                {
                  property1: "Support",
                  property2: "Default",
                  count: n
                }
              )
            }
          )
        ]
      }
    ),
    q ? /* @__PURE__ */ a.jsx(
      qD,
      {
        supportId: m,
        thankDescription: s,
        thankImage: o,
        show: I === "additionalSupport",
        shop: b,
        supportThanksMessageModalType: "MyPage",
        onClose: () => R(null),
        onSeeSupportDetailButtonClick: w,
        onSuccess: pe,
        onIntegratedPaidServiceTermsTextClick: k,
        onClickPersonalInfoOutsourcing: j,
        onClickThirdPartyConsent: E,
        onClickInicisTerms: T,
        onMySupportMessageButtonClick: D
      }
    ) : /* @__PURE__ */ a.jsx(
      qD,
      {
        supportId: m,
        thankDescription: s,
        thankImage: o,
        shop: b,
        show: I === "additionalSupport",
        supportThanksMessageModalType: "MyPage",
        onClose: () => R(null),
        onSeeSupportDetailButtonClick: w,
        onSuccess: pe,
        onIntegratedPaidServiceTermsTextClick: k,
        onClickPersonalInfoOutsourcing: j,
        onClickThirdPartyConsent: E,
        onClickInicisTerms: T,
        onMySupportMessageButtonClick: D
      }
    ),
    q ? /* @__PURE__ */ a.jsx(
      KH,
      {
        thankImageUrl: o.url,
        thankDescription: s,
        show: I === "thanksMessage",
        onClose: () => R(null)
      }
    ) : /* @__PURE__ */ a.jsx(a.Fragment, { children: I === "thanksMessage" && /* @__PURE__ */ a.jsx(
      KH,
      {
        thankImageUrl: o.url,
        thankDescription: s,
        onClose: () => R(null)
      }
    ) })
  ] });
}
const eNe = 1.25;
function tNe(e) {
  Al([
    [ol, e.client],
    [ll, e.widgetCore],
    [pK, e.mypageSupports],
    [m5, null],
    [M3, e.me]
  ]);
  const { mypageSupports: t } = gK(), {
    widgetCore: { isMobile: n }
  } = Gt();
  return n ? /* @__PURE__ */ a.jsx("div", { className: "twp pt-[2.28571rem]", children: /* @__PURE__ */ a.jsx(
    Av,
    {
      slidesPerView: eNe,
      spaceBetween: kc(1.14286),
      slidesOffsetBefore: kc(1.14286),
      slidesOffsetAfter: kc(1.14286),
      modules: [zA],
      virtual: !0,
      children: t.items.map((r, s) => /* @__PURE__ */ a.jsx(Vg, { virtualIndex: s, children: /* @__PURE__ */ a.jsx(
        XH,
        {
          displayName: r.displayName,
          lastPaymentAt: r.lastPaymentAt,
          paymentCount: r.paymentCount,
          state: r.state,
          thankDescription: r.thankDescription,
          thankImage: r.thankImage,
          thumbnailImage: r.thumbnailImage,
          shop: r.shop,
          totalPrice: r.totalPrice,
          supportId: r.id,
          projectId: r.projectId,
          onSeeSupportDetailButtonClick: () => e.onSeeSupportDetailButtonClick(
            r.projectId,
            r.id
          ),
          onIntegratedPaidServiceTermsTextClick: e.onIntegratedPaidServiceTermsTextClick,
          onClickPersonalInfoOutsourcing: e.onClickPersonalInfoOutsourcing,
          onClickThirdPartyConsent: e.onClickThirdPartyConsent,
          onClickInicisTerms: e.onClickInicisTerms,
          onMySupportMessageButtonClick: () => e.onMySupportMessageButtonClick(r.projectId),
          onShopButtonClick: e.onShopButtonClick
        }
      ) }, r.id))
    }
  ) }) : /* @__PURE__ */ a.jsx("div", { className: "twp grid grid-cols-4 gap-[1.714rem] pt-[2.28571rem]", children: t.items.map((r) => /* @__PURE__ */ a.jsx(
    XH,
    {
      displayName: r.displayName,
      lastPaymentAt: r.lastPaymentAt,
      paymentCount: r.paymentCount,
      state: r.state,
      thankDescription: r.thankDescription,
      thankImage: r.thankImage,
      thumbnailImage: r.thumbnailImage,
      totalPrice: r.totalPrice,
      shop: r.shop,
      supportId: r.id,
      projectId: r.projectId,
      onSeeSupportDetailButtonClick: () => e.onSeeSupportDetailButtonClick(r.projectId, r.id),
      onIntegratedPaidServiceTermsTextClick: e.onIntegratedPaidServiceTermsTextClick,
      onClickPersonalInfoOutsourcing: e.onClickPersonalInfoOutsourcing,
      onClickThirdPartyConsent: e.onClickThirdPartyConsent,
      onClickInicisTerms: e.onClickInicisTerms,
      onMySupportMessageButtonClick: () => e.onMySupportMessageButtonClick(r.projectId),
      onShopButtonClick: e.onShopButtonClick
    },
    r.id
  )) });
}
const nNe = X2();
function rNe({
  client: e,
  isMobile: t,
  isApp: n,
  toggleSpinner: r,
  onError: s,
  onScrollLock: o,
  onSeeSupportDetailButtonClick: c,
  onIntegratedPaidServiceTermsTextClick: u,
  onClickPersonalInfoOutsourcing: m,
  onClickThirdPartyConsent: y,
  onClickInicisTerms: b,
  onMySupportMessageButtonClick: w,
  onShopButtonClick: k
}) {
  const [j, E] = Re(!0), [T, D] = Re(null);
  return an(() => {
    (async () => {
      const [L, I] = await Promise.all([
        hK({
          client: e,
          onError: s
        }),
        Q8({
          client: e,
          onError: s
        })
      ]);
      if (I.code === le.TokenExpired)
        return s(Ht);
      D({
        mypageSupports: L.data,
        me: I.data
      }), E(!1);
    })();
  }, []), j || T === null ? null : T.mypageSupports.items.length === 0 ? t ? /* @__PURE__ */ a.jsx("div", { className: "py-[11.42857rem]", children: /* @__PURE__ */ a.jsx(
    p6,
    {
      title: "후원 내역이 없어요.",
      description: "좋아하는 크리에이터를 후원해 주세요!",
      renderImage: /* @__PURE__ */ a.jsx(
        aa,
        {
          src: kt.KeyVisual.MembershipCommunity,
          width: "8.5714rem",
          height: "8.5714rem"
        }
      )
    }
  ) }) : /* @__PURE__ */ a.jsx("div", { className: "py-[11.42857rem]", children: /* @__PURE__ */ a.jsx(
    f5,
    {
      title: "후원 내역이 없어요.",
      description: "좋아하는 크리에이터를 후원해 주세요!",
      renderImage: /* @__PURE__ */ a.jsx(
        aa,
        {
          src: kt.KeyVisual.MembershipCommunity,
          width: "11.4286rem",
          height: "11.4286rem"
        }
      )
    }
  ) }) : /* @__PURE__ */ a.jsx(lw, { store: nNe, children: /* @__PURE__ */ a.jsx(
    tNe,
    {
      client: e,
      widgetCore: {
        isMobile: t,
        isApp: n,
        toggleSpinner: r,
        onError: s,
        onScrollLock: o
      },
      mypageSupports: T.mypageSupports,
      me: T.me,
      onSeeSupportDetailButtonClick: c,
      onIntegratedPaidServiceTermsTextClick: u,
      onClickPersonalInfoOutsourcing: m,
      onClickThirdPartyConsent: y,
      onClickInicisTerms: b,
      onMySupportMessageButtonClick: w,
      onShopButtonClick: k
    }
  ) });
}
class Zje extends Ol {
  constructor({
    client: t,
    isMobile: n,
    isApp: r,
    toggleSpinner: s,
    onError: o,
    onSeeSupportDetailButtonClick: c,
    onIntegratedPaidServiceTermsTextClick: u,
    onClickPersonalInfoOutsourcing: m,
    onClickThirdPartyConsent: y,
    onClickInicisTerms: b,
    onMySupportMessageButtonClick: w,
    onScrollLock: k,
    onShopButtonClick: j
  }) {
    super({
      client: t,
      isApp: r,
      isMobile: n,
      toggleSpinner: s,
      onError: o,
      onScrollLock: k
    }), this.render = (E) => {
      go(E).render(
        /* @__PURE__ */ a.jsx(
          rNe,
          {
            client: this.client,
            isApp: this.isApp,
            isMobile: this.isMobile,
            toggleSpinner: this.toggleSpinner,
            onError: this.onError,
            onSeeSupportDetailButtonClick: this.onSeeSupportDetailButtonClick,
            onIntegratedPaidServiceTermsTextClick: this.onIntegratedPaidServiceTermsTextClick,
            onClickInicisTerms: this.onClickInicisTerms,
            onClickPersonalInfoOutsourcing: this.onClickPersonalInfoOutsourcing,
            onClickThirdPartyConsent: this.onClickThirdPartyConsent,
            onMySupportMessageButtonClick: this.onMySupportMessageButtonClick,
            onScrollLock: this.onScrollLock,
            onShopButtonClick: this.onShopButtonClick
          }
        )
      );
    }, this.onSeeSupportDetailButtonClick = c, this.onIntegratedPaidServiceTermsTextClick = u, this.onClickPersonalInfoOutsourcing = m, this.onClickThirdPartyConsent = y, this.onClickInicisTerms = b, this.onMySupportMessageButtonClick = w, this.onShopButtonClick = j;
  }
}
const yK = (e, t) => jn(
  "/commissions",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
      return n;
    default:
      throw new Error();
  }
}), aNe = (e, t) => jn(
  "/can-purchase-commission",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.UnableToProcessRequest:
    case le.AlreadyRequestCommission:
      return n;
    default:
      throw new Error();
  }
}), vK = Qt(Vn), sNe = Qt({
  message: null,
  preQuestionAnswer: null,
  attachmentUrls: []
}), qA = () => {
  const [e, t] = Ar(
    sNe
  );
  return {
    commissionFormData: e,
    setCommissionFormData: t,
    resetCommissionFormData: () => {
      t({
        attachmentUrls: [],
        message: null,
        preQuestionAnswer: null
      });
    }
  };
}, xK = {
  selectedCommission: null,
  paidCommissionRequestId: null
}, bK = Qt(xK), iNe = Qt(null, (e, t) => {
  t(bK, xK);
}), M6 = () => {
  const [e, t] = Ar(
    bK
  ), n = Ka(
    iNe
  );
  return {
    commissionModalData: e,
    setCommissionModalData: t,
    resetCommissionModalData: n
  };
}, oNe = Qt(
  null
), SK = () => {
  const [e, t] = Ar(
    oNe
  );
  return {
    commissionPaymentData: e,
    setCommissionPaymentData: t
  };
}, lNe = () => {
  const [e, t] = Ar(vK);
  if (e === Vn)
    throw Error(Xr(ia.Commissions));
  return {
    commissions: e,
    setCommissions: t,
    getCommissionById: (r) => {
      const s = e.items.find(
        (o) => o.id == r
      );
      return wt(s), s;
    }
  };
};
function cNe({
  onGoToCommissionDetailButtonClick: e,
  onClose: t
}) {
  const {
    widgetCore: { isMobile: n }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $("typo-mshop-kr-14-m flex flex-col text-mshop-black", {
        "h-full": n
      }),
      children: [
        n ? /* @__PURE__ */ a.jsxs("div", { className: "absolute left-0 top-0 z-10 flex h-[4.28571rem] w-full items-center justify-center bg-mshop-white px-[1.14rem]", children: [
          /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-16-b", children: "커미션 신청 완료" }),
          /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              onClick: t,
              className: "absolute right-[1.14rem] top-1/2 block -translate-y-1/2",
              children: /* @__PURE__ */ a.jsx(Zg, { className: "size-[1.429rem] text-mshop-black" })
            }
          )
        ] }) : /* @__PURE__ */ a.jsx(
          D1,
          {
            titleAlign: "Left",
            back: !1,
            close: !0,
            label: "커미션 신청 완료",
            onCloseButtonClick: t
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "section",
          {
            className: n ? "h-full overflow-y-auto px-[1.14rem] pb-[6.28571rem] pt-[4.28571rem]" : "pt-[1.14286rem]",
            children: [
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    "flex-center flex-col gap-y-[0.57rem]",
                    {
                      "h-[41.18rem]": !n
                    },
                    {
                      "mt-[7.75rem]": n
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsx(
                      "img",
                      {
                        src: kt.KeyVisual.MembershipCommissionBlue,
                        className: "h-[14.28571rem] w-[14.28571rem]",
                        alt: ""
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      "h1",
                      {
                        className: $(
                          { "typo-mshop-kr-24-b mt-[1.14rem]": !n },
                          { "typo-mshop-kr-20-b mt-[1.71rem]": n }
                        ),
                        children: "커미션 신청이 완료되었어요!"
                      }
                    ),
                    /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-16-m text-center text-mshop-gray-50", children: [
                      "작업이 완성되면 계정 메일 주소로 소식을 전해드려요.",
                      /* @__PURE__ */ a.jsx("br", {}),
                      "작업물은 마이페이지 > 커미션 상세페이지에서 확인하실 수 있어요!"
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    "flex",
                    {
                      "gap-x-[0.85714rem] border-t border-t-mshop-gray-5 px-[2.28571rem] py-[1.14rem]": !n
                    },
                    {
                      "mt-[1.71rem] flex-col items-center gap-y-[0.57rem]": n
                    }
                  ),
                  children: n ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx("div", { className: "w-[14rem]", children: /* @__PURE__ */ a.jsx(
                      fn,
                      {
                        variant: "lg",
                        theme: "line",
                        type: "button",
                        onClick: e,
                        widthFull: !0,
                        children: "커미션 상세보기"
                      }
                    ) }),
                    /* @__PURE__ */ a.jsx("div", { className: "w-[14rem]", children: /* @__PURE__ */ a.jsx(
                      fn,
                      {
                        variant: "lg",
                        theme: "blue",
                        type: "button",
                        onClick: t,
                        widthFull: !0,
                        children: "확인"
                      }
                    ) })
                  ] }) : /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                    /* @__PURE__ */ a.jsx(
                      fn,
                      {
                        variant: "lg",
                        theme: "line",
                        type: "button",
                        onClick: e,
                        widthFull: !0,
                        children: "커미션 상세보기"
                      }
                    ),
                    /* @__PURE__ */ a.jsx(
                      fn,
                      {
                        variant: "lg",
                        theme: "blue",
                        type: "button",
                        onClick: t,
                        widthFull: !0,
                        children: "확인"
                      }
                    )
                  ] })
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function uNe({
  show: e,
  onClose: t,
  onGoToCommissionDetailButtonClick: n,
  onAfterLeave: r
}) {
  const {
    widgetCore: { isMobile: s }
  } = Gt();
  return /* @__PURE__ */ a.jsx(
    dh,
    {
      show: e,
      variant: "TYPE02",
      onClose: t,
      transition: s && !e,
      afterLeave: r,
      children: /* @__PURE__ */ a.jsx(
        cNe,
        {
          onGoToCommissionDetailButtonClick: n,
          onClose: t
        }
      )
    }
  );
}
const dNe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { id: "Input-Component" }, /* @__PURE__ */ re.createElement("path", { id: "Polygon 1", d: "M7.42998 4.33274C7.7466 3.85745 8.44493 3.85745 8.76156 4.33274L13.0409 10.7564C13.395 11.2881 13.0139 12 12.3751 12H3.81647C3.17764 12 2.7965 11.2881 3.15067 10.7564L7.42998 4.33274Z" }))), fNe = yn(dNe), mNe = yn(
  ({ children: e, open: t }, n) => /* @__PURE__ */ a.jsx(
    "div",
    {
      ref: n,
      className: "grid overflow-auto transition-[grid-template-rows] duration-300 scrollbar-hide",
      style: {
        gridTemplateRows: t ? "1fr" : "0fr",
        transitionTimingFunction: "ease"
      },
      children: /* @__PURE__ */ a.jsx("div", { className: "min-h-0", children: e })
    }
  )
), hNe = (e = !1, t = !1, n = !1) => $(e ? "caret-mshop-red-80 border-b-mshop-red-80" : "", t && !n ? "text-mshop-gray-50" : "text-mshop-black", e && !n ? "border-mshop-red-80" : "border-mshop-gray-10", n || t ? "bg-mshop-gray-5" : "bg-mshop-white"), QH = yn(
  ({ watch: e, maxLength: t, minRows: n, invalid: r, guideText: s, ...o }, c) => {
    const u = hNe(
      r,
      o.disabled,
      o.readOnly
    ), m = FO(
      r,
      o.disabled,
      e.length
    );
    return /* @__PURE__ */ a.jsxs("div", { children: [
      /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: $(
            "py-[.85714rem] pr-[1.14rem]",
            "border-b",
            u
          ),
          children: [
            /* @__PURE__ */ a.jsx(
              YE,
              {
                ref: c,
                ...o,
                className: $(
                  "w-full resize-none overflow-hidden outline-none",
                  "typo-mshop-kr-14-m",
                  "placeholder:text-mshop-gray-50",
                  o.readOnly || o.disabled ? "bg-mshop-gray-5" : "bg-mshop-white"
                ),
                minRows: n || 3
              }
            ),
            /* @__PURE__ */ a.jsxs("div", { className: "mt-[0.57rem] flex w-full items-end justify-end", children: [
              /* @__PURE__ */ a.jsx(
                "span",
                {
                  className: $("typo-mshop-en-12-unica-m", m),
                  children: e.length
                }
              ),
              /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-en-12-unica-m ml-[.13714rem] text-mshop-gray-50", children: [
                "/ ",
                t
              ] })
            ] })
          ]
        }
      ),
      s && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m mt-[0.57rem] text-mshop-gray-50", children: s })
    ] });
  }
);
function N2({ label: e, required: t = !1 }) {
  const {
    widgetCore: { isMobile: n }
  } = Gt();
  return /* @__PURE__ */ a.jsxs("div", { className: $({ "flex gap-x-[.28571rem] break-all": t }), children: [
    /* @__PURE__ */ a.jsx(
      "span",
      {
        className: $(
          "break-all text-mshop-black",
          { "typo-mshop-kr-16-b": !n },
          {
            "typo-mshop-kr-14-b": n
          }
        ),
        children: e
      }
    ),
    t && /* @__PURE__ */ a.jsx("span", { className: "mt-[.28571rem]", children: /* @__PURE__ */ a.jsx(w3, {}) })
  ] });
}
const ZH = 6, pNe = ["png", "jpg", "jpeg", "gif"], gNe = 5 * 1024 * 1024;
function yNe({
  onClose: e,
  onNextStep: t
}) {
  const {
    commissionModalData: { selectedCommission: n }
  } = M6(), { client: r } = Ha(), { setMe: s } = by(), { setPayMethod: o } = xw(), {
    widgetCore: { isMobile: c, onError: u, toggleSpinner: m }
  } = Gt(), { commissionFormData: y, setCommissionFormData: b } = qA(), {
    ref: w,
    isUploading: k,
    uploadedImages: j,
    handleRemoveUploadedImage: E,
    handleClickUploadImage: T,
    handleValidateImageFiles: D,
    handleChangeFileInput: L
  } = hA({
    maxUploadCount: ZH,
    initialUploadedImages: (y == null ? void 0 : y.attachmentUrls) ?? []
  }), I = j.length, R = Rt(null), U = dn(
    () => Object.fromEntries(
      Object.entries(y).map(
        ([oe, ue]) => ue === null ? [oe, ""] : [oe, ue]
      )
    ),
    [y]
  ), {
    register: z,
    handleSubmit: H,
    watch: K,
    formState: { errors: q },
    setValue: Q,
    setError: Z,
    clearErrors: X,
    getFieldState: se
  } = bp({
    mode: "onChange",
    defaultValues: U
  }), te = Object.keys(q).filter((ue) => ue !== "attachmentUrls").length ? !1 : n && n.preQuestion && (K("preQuestionAnswer") ?? "").trim() ? !0 : !!(K("message") ?? "").trim(), fe = (oe) => {
    Q("attachmentUrls", oe, {
      shouldValidate: !0
    }), b((ue) => ({
      ...ue,
      attachmentUrls: oe
    }));
  }, ce = async (oe) => {
    var ve;
    X("attachmentUrls");
    const ue = oe.target.files;
    if (wt(ue), !ue.length)
      return;
    m(!0);
    const he = await D(ue, {
      imageFormats: pNe,
      maxFileSize: gNe
    });
    if (he === Wg.Success)
      return q.attachmentUrls && X("attachmentUrls"), L({
        files: ue,
        onSuccess: (Te) => {
          const Ie = Te.length > 0 ? Te : [];
          fe(Ie), m(!1);
        }
      });
    po.flushSync(() => {
      he === Wg.FileTooLarge ? Z("attachmentUrls", {
        type: "fileTooLarge",
        message: "이미지 크기는 1개당 5MB 이하로 업로드해 주세요."
      }) : he === Wg.InvalidFormat && Z("attachmentUrls", {
        type: "imageFormats",
        message: "png, jpg, jpeg, gif 형식만 업로드 가능합니다."
      });
    }), (ve = R.current) == null || ve.scrollIntoView(!0), m(!1);
  }, pe = (oe) => (ue) => {
    const he = ue.target.value.trim();
    Q(oe, he, {
      shouldValidate: !0
    }), b((ve) => ({
      ...ve,
      [oe]: he
    }));
  }, Se = async (oe) => {
    m(!0);
    const ue = Qu(
      oe,
      Vre,
      j1(([Te, Ie]) => Te === "attachmentUrls" && Array.isArray(Ie) ? Ie.length > 0 : typeof Ie == "string" && Ie.trim()),
      fre
    );
    b(ue);
    const [he, ve] = await Promise.all([
      Q8({ client: r, onError: u }),
      g6({ client: r, onError: u })
    ]);
    if (he.code === le.TokenExpired || ve.code === le.TokenExpired)
      return u(Ht);
    s(he.data), o(ve.data), m(!1), t();
  };
  return n == null ? null : /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $("typo-mshop-kr-14-m", {
        "h-full": c
      }),
      children: [
        c ? /* @__PURE__ */ a.jsxs("div", { className: "relative flex h-[4.28571rem] w-full items-center justify-center bg-mshop-white px-[1.14rem]", children: [
          /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-16-b", children: "커미션 신청서 작성" }),
          /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              onClick: e,
              className: "absolute right-[1.14rem] top-1/2 block -translate-y-1/2",
              children: /* @__PURE__ */ a.jsx(Zg, { className: "size-[1.429rem] text-mshop-black" })
            }
          )
        ] }) : /* @__PURE__ */ a.jsx(
          D1,
          {
            titleAlign: "Left",
            back: !1,
            close: !0,
            label: "커미션 신청서 작성",
            onCloseButtonClick: e
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "form",
          {
            className: $({ "h-[calc(100%-4.28571rem)]": c }),
            onSubmit: H(Se),
            children: [
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $({
                    "h-[calc(100%-5.71428rem)] overflow-y-auto scrollbar-hide": c
                  }),
                  children: /* @__PURE__ */ a.jsxs("div", { className: $({ "h-[41.07142rem] overflow-y-auto": !c }), children: [
                    /* @__PURE__ */ a.jsx(Mv, { children: ({ open: oe }) => /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $(
                          "border-b border-b-mshop-gray-10",
                          c ? "mx-[1.14286rem]" : "mx-[2.28571rem]"
                        ),
                        children: [
                          /* @__PURE__ */ a.jsxs(V8, { className: "flex w-full items-center justify-between py-[1.14286rem] text-mshop-black", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: "작업 상세 내용" }),
                            /* @__PURE__ */ a.jsx(
                              fNe,
                              {
                                className: $("size-[1.14286rem]", {
                                  "-rotate-180": !oe
                                })
                              }
                            )
                          ] }),
                          /* @__PURE__ */ a.jsx(Mv, { as: mNe, open: oe, children: /* @__PURE__ */ a.jsxs("div", { className: "pb-[1.14286rem]", children: [
                            /* @__PURE__ */ a.jsx("div", { className: "flex w-full items-center gap-x-[0.57143rem]", children: n.sampleImages.map(
                              (ue, he) => /* @__PURE__ */ a.jsx(
                                "div",
                                {
                                  className: $(
                                    "overflow-hidden rounded-[0.57143rem]",
                                    { "size-[5.71429rem]": !c },
                                    { "size-[3.60714rem]": c }
                                  ),
                                  children: /* @__PURE__ */ a.jsx(
                                    aa,
                                    {
                                      src: ue.url,
                                      width: "11.4286rem",
                                      height: "11.4286rem"
                                    }
                                  )
                                },
                                he
                              )
                            ) }),
                            /* @__PURE__ */ a.jsx("p", { className: "mt-[1.14rem] whitespace-pre-wrap break-words text-mshop-gray-80", children: n.workDescription })
                          ] }) })
                        ]
                      }
                    ) }),
                    /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $(
                          "flex flex-col",
                          c ? "gap-[1.71rem] p-[1.14rem]" : "gap-[2.28571rem] p-[2.28571rem]"
                        ),
                        children: [
                          n.preQuestion && /* @__PURE__ */ a.jsxs(
                            "div",
                            {
                              className: $({
                                "flex flex-col gap-[0.28571rem]": !c
                              }),
                              children: [
                                /* @__PURE__ */ a.jsx(
                                  N2,
                                  {
                                    label: n.preQuestion,
                                    required: !0
                                  }
                                ),
                                /* @__PURE__ */ a.jsx(
                                  QH,
                                  {
                                    ...z("preQuestionAnswer", {
                                      required: !0,
                                      maxLength: {
                                        value: 2e3,
                                        message: "2000자까지 입력 가능합니다."
                                      },
                                      onChange: (oe) => {
                                        b((ue) => ({
                                          ...ue,
                                          preQuestionAnswer: oe.target.value
                                        }));
                                      },
                                      onBlur: pe("preQuestionAnswer")
                                    }),
                                    watch: K("preQuestionAnswer") ?? "",
                                    invalid: se("preQuestionAnswer").isDirty && se("preQuestionAnswer").invalid,
                                    placeholder: "크리에이터의 질문에 맞춰 작성해 주세요.",
                                    maxLength: 2e3,
                                    maxRows: c ? 8 : 11
                                  }
                                ),
                                q.preQuestionAnswer && q.preQuestionAnswer.message && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m mt-[0.57rem] text-mshop-red-80", children: q.preQuestionAnswer.message })
                              ]
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            "div",
                            {
                              className: $({ "flex flex-col gap-[0.28571rem]": !c }),
                              children: [
                                /* @__PURE__ */ a.jsx(
                                  N2,
                                  {
                                    label: "기타 요청사항을 적어주세요.",
                                    required: !n.preQuestion
                                  }
                                ),
                                /* @__PURE__ */ a.jsx(
                                  QH,
                                  {
                                    ...z("message", {
                                      required: !n.preQuestion,
                                      maxLength: {
                                        value: 2e3,
                                        message: "2000자까지 입력 가능합니다."
                                      },
                                      onChange: (oe) => {
                                        b((ue) => ({
                                          ...ue,
                                          message: oe.target.value
                                        }));
                                      },
                                      onBlur: pe("message")
                                    }),
                                    watch: K("message") ?? "",
                                    invalid: !!q.message,
                                    placeholder: "필요한 요청사항이 있으면 작성해 주세요.",
                                    guideText: "크리에이터와 무관하거나 서비스 운영정책에 위배되는 메시지를 작성 시 해당 회원에게 별도의 제재가 적용될 수 있습니다.",
                                    maxLength: 2e3,
                                    maxRows: c ? 8 : 11
                                  }
                                ),
                                q.message && q.message.message && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m mt-[0.57rem] text-mshop-red-80", children: q.message.message })
                              ]
                            }
                          ),
                          /* @__PURE__ */ a.jsxs("div", { children: [
                            /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57rem]", children: [
                              /* @__PURE__ */ a.jsx(N2, { label: "참고 이미지 첨부" }),
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: "최대 6장까지 첨부 가능합니다." })
                            ] }),
                            /* @__PURE__ */ a.jsxs(
                              "div",
                              {
                                className: $(
                                  "flex items-center gap-[.57143rem] py-[.57143rem]",
                                  { "flex-wrap": c }
                                ),
                                children: [
                                  j.map((oe, ue) => /* @__PURE__ */ a.jsxs(
                                    "div",
                                    {
                                      className: "relative aspect-square w-[4.28571rem] overflow-hidden rounded-[.65305rem]",
                                      children: [
                                        /* @__PURE__ */ a.jsx(
                                          "img",
                                          {
                                            src: oe,
                                            className: "h-full w-full object-cover",
                                            alt: ""
                                          }
                                        ),
                                        /* @__PURE__ */ a.jsx(
                                          "button",
                                          {
                                            type: "button",
                                            className: "absolute right-0 top-0 rounded-[.65305rem] bg-mshop-black p-[.28571rem]",
                                            onClick: E(
                                              ue,
                                              fe
                                            ),
                                            children: /* @__PURE__ */ a.jsx(Zg, { className: "size-[.85714rem] text-mshop-white" })
                                          }
                                        )
                                      ]
                                    },
                                    ue
                                  )),
                                  I !== ZH && /* @__PURE__ */ a.jsxs("div", { children: [
                                    /* @__PURE__ */ a.jsx(
                                      "button",
                                      {
                                        type: "button",
                                        onClick: T,
                                        className: "flex aspect-square w-[4.28571em] items-center justify-center rounded-[.48979rem]",
                                        disabled: k,
                                        children: /* @__PURE__ */ a.jsx(dA, { className: "h-full w-full text-mshop-gray-20" })
                                      }
                                    ),
                                    /* @__PURE__ */ a.jsx(
                                      "input",
                                      {
                                        ref: w,
                                        type: "file",
                                        className: "sr-only",
                                        multiple: !0,
                                        onChange: ce,
                                        accept: "image/jpeg, image/png, image/gif, image/jpg"
                                      }
                                    )
                                  ] })
                                ]
                              }
                            ),
                            q.attachmentUrls && q.attachmentUrls.message && /* @__PURE__ */ a.jsx(
                              "p",
                              {
                                className: "typo-mshop-kr-12-m mt-[0.57rem] text-mshop-red-80",
                                ref: R,
                                children: q.attachmentUrls.message
                              }
                            ),
                            /* @__PURE__ */ a.jsx(
                              "input",
                              {
                                type: "hidden",
                                ...z("attachmentUrls"),
                                className: "sr-only"
                              }
                            )
                          ] })
                        ]
                      }
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ a.jsx(
                "div",
                {
                  className: $(
                    {
                      "border-t border-t-mshop-gray-5 px-[2.28571rem] py-[1.14rem]": !c
                    },
                    {
                      "p-[1.14rem]": c
                    }
                  ),
                  children: /* @__PURE__ */ a.jsx(
                    fn,
                    {
                      variant: c ? "md" : "lg",
                      theme: "blue",
                      type: "submit",
                      disabled: !te,
                      widthFull: !0,
                      children: "신청서 작성 완료"
                    }
                  )
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function vNe({
  show: e,
  onClose: t,
  onNextStep: n,
  onAfterLeave: r
}) {
  const {
    widgetCore: { isMobile: s }
  } = Gt();
  return /* @__PURE__ */ a.jsx(
    dh,
    {
      show: e,
      variant: "TYPE02",
      afterLeave: r,
      transition: s && !e,
      children: /* @__PURE__ */ a.jsx(
        yNe,
        {
          onClose: t,
          onNextStep: n
        }
      )
    }
  );
}
function xNe({
  onClose: e,
  onCommissionApplicationButtonClick: t
}) {
  const {
    commissionModalData: { selectedCommission: n }
  } = M6(), [r, s] = Re(0);
  if (n == null)
    return null;
  const o = n.sampleImages[r];
  return /* @__PURE__ */ a.jsxs("div", { className: "h-full", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "relative flex h-[4.28571rem] w-full items-center justify-center px-[1.14rem]", children: [
      /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-16-b", children: "커미션 신청" }),
      /* @__PURE__ */ a.jsx(
        "button",
        {
          type: "button",
          onClick: e,
          className: "absolute right-[1.14rem] top-1/2 block -translate-y-1/2",
          children: /* @__PURE__ */ a.jsx(Zg, { className: "size-[1.429rem] text-mshop-black" })
        }
      )
    ] }),
    /* @__PURE__ */ a.jsxs("section", { className: "typo-mshop-kr-14-m h-[calc(100%-4.28571rem-5.71428rem)] overflow-y-auto overflow-x-hidden text-mshop-black scrollbar-hide", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "relative aspect-square w-full overflow-hidden", children: [
        /* @__PURE__ */ a.jsx(
          "img",
          {
            src: o.url,
            className: "h-full w-full object-cover blur-2xl",
            alt: ""
          }
        ),
        /* @__PURE__ */ a.jsx(
          "img",
          {
            src: o.url,
            className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
            alt: ""
          }
        )
      ] }),
      /* @__PURE__ */ a.jsx("div", { className: "flex items-center gap-x-[0.571rem] px-[1.14285rem] py-[0.57142rem]", children: n.sampleImages.map((c, u) => /* @__PURE__ */ a.jsx(
        "button",
        {
          type: "button",
          className: "block flex-shrink-0",
          onClick: () => s(u),
          children: /* @__PURE__ */ a.jsx(
            "img",
            {
              src: c.url,
              className: $(
                "size-[3.60714rem] rounded-md border-[0.143rem] object-cover",
                {
                  "border-mshop-blue-100": u == r
                },
                {
                  "border-transparent opacity-50": u != r
                }
              ),
              alt: ""
            }
          )
        },
        u
      )) }),
      /* @__PURE__ */ a.jsx("section", { className: "flex flex-col justify-between", children: /* @__PURE__ */ a.jsx("div", { className: "flex w-full flex-col justify-between gap-y-[1.143rem]", children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.143rem] pb-[1.143rem] pl-[1.143rem] pr-[2.286rem] pt-[1.143rem]", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem] border-b border-b-mshop-gray-5 pb-[1.14rem]", children: [
          /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: n.displayName }),
          /* @__PURE__ */ a.jsxs("div", { children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex items-start gap-x-[0.57rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-b", children: n.price.toLocaleString(cr.Ko) }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "원" })
              ] }),
              /* @__PURE__ */ a.jsx("span", { className: "flex-center h-[1.71rem] w-[0.07rem] before:block before:h-[0.86rem] before:w-[0.07rem] before:bg-mshop-gray-20" }),
              /* @__PURE__ */ a.jsx("div", { className: "flex flex-col text-mshop-gray-80", children: /* @__PURE__ */ a.jsxs("div", { className: "flex items-center", children: [
                /* @__PURE__ */ a.jsx("span", { children: "예상 작업 기간" }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m ml-[0.29rem] text-mshop-gray-80", children: n.estimatedTime }),
                /* @__PURE__ */ a.jsx("span", { children: "일" })
              ] }) })
            ] }),
            /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m mt-[0.29rem] text-mshop-gray-50", children: "예상 작업 기간과 별개로 신청서에 따라 작업 마감 기한이 설정됩니다." })
          ] })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
          /* @__PURE__ */ a.jsxs("h2", { className: "typo-mshop-kr-16-b flex items-center gap-x-[0.29rem]", children: [
            "작업 상세 내용",
            /* @__PURE__ */ a.jsxs($8, { className: "flex-center", children: [
              /* @__PURE__ */ a.jsx(K4, { children: ({ open: c }) => /* @__PURE__ */ a.jsx(
                l_,
                {
                  className: $(
                    "size-[1.14rem]",
                    c ? "text-mshop-blue-100" : "text-mshop-gray-50"
                  )
                }
              ) }),
              /* @__PURE__ */ a.jsxs(
                X4,
                {
                  as: "section",
                  className: "mx-[1.14rem] mt-[0.57rem] rounded-[1.14rem] bg-mshop-blue-10 p-[1.14rem] text-mshop-blue-100",
                  style: {
                    zIndex: Tc.GLOBAL.MODAL
                  },
                  children: [
                    /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-14-b m-0", children: "커미션 진행 과정" }),
                    /* @__PURE__ */ a.jsxs("ol", { className: "typo-mshop-kr-14-m mb-0 mt-[0.57rem] pl-[1.14rem]", children: [
                      /* @__PURE__ */ a.jsx("li", { children: "신청서 작성 후 결제" }),
                      /* @__PURE__ */ a.jsx("li", { className: "mt-[0.29rem]", children: "신청서 수락 여부 및 마감 기한 확인" }),
                      /* @__PURE__ */ a.jsxs("li", { className: "mt-[0.29rem]", children: [
                        "작업물 확인",
                        /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-12-m m-0", children: [
                          "크리에이터와 작업물 관련 소통은",
                          /* @__PURE__ */ a.jsx("br", {}),
                          "커미션 문의 하기를 이용해 주세요."
                        ] })
                      ] }),
                      /* @__PURE__ */ a.jsxs("li", { className: "mt-[0.29rem]", children: [
                        "최종 완료",
                        /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-12-m m-0", children: [
                          "작업이 완료된 커미션은",
                          /* @__PURE__ */ a.jsx("br", {}),
                          "구매 확정 버튼을 눌러 완료해 주세요."
                        ] })
                      ] })
                    ] })
                  ]
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ a.jsx("p", { className: "whitespace-pre-wrap break-words text-mshop-black", children: n.workDescription })
        ] }),
        /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
          /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b", children: "작업물 이용 범위" }),
          /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m flex flex-col break-all rounded-[0.57rem] bg-mshop-gray-5 px-[1.14rem] py-[0.57rem] text-mshop-gray-80", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: co[n.license].name }),
            /* @__PURE__ */ a.jsx("span", { children: co[n.license].description ?? n.licenseText })
          ] })
        ] })
      ] }) }) })
    ] }),
    /* @__PURE__ */ a.jsx("div", { className: "p-[1.14rem]", children: /* @__PURE__ */ a.jsx(
      fn,
      {
        variant: "md",
        theme: "blue",
        type: "button",
        widthFull: !0,
        onClick: t,
        children: "커미션 신청하기"
      }
    ) })
  ] });
}
function bNe({
  onClose: e,
  onCommissionApplicationButtonClick: t
}) {
  const {
    commissionModalData: { selectedCommission: n }
  } = M6(), [r, s] = Re(0);
  if (n == null)
    return null;
  const o = n.sampleImages[r];
  return /* @__PURE__ */ a.jsxs("div", { className: "flex h-[43.857rem]", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "relative h-full w-[32.857rem] overflow-hidden", children: [
      /* @__PURE__ */ a.jsx(
        "img",
        {
          src: o.url,
          className: "h-full w-full object-cover blur-2xl",
          alt: ""
        }
      ),
      /* @__PURE__ */ a.jsx(
        "img",
        {
          src: o.url,
          className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
          alt: ""
        }
      ),
      r > 0 && /* @__PURE__ */ a.jsx("div", { className: "absolute left-[0.57143rem] top-1/2 -translate-y-1/2", children: /* @__PURE__ */ a.jsx(
        wy,
        {
          direction: "left",
          background: "dim",
          type: "button",
          onClick: () => s(r - 1)
        }
      ) }),
      r < n.sampleImages.length - 1 && /* @__PURE__ */ a.jsx("div", { className: "absolute right-[0.57143rem] top-1/2 -translate-y-1/2", children: /* @__PURE__ */ a.jsx(
        wy,
        {
          direction: "right",
          background: "dim",
          type: "button",
          onClick: () => s(r + 1)
        }
      ) })
    ] }),
    /* @__PURE__ */ a.jsxs("section", { className: "typo-mshop-kr-14-m w-[31.143rem] text-mshop-black", children: [
      /* @__PURE__ */ a.jsx(
        D1,
        {
          titleAlign: "Left",
          back: !1,
          close: !0,
          label: "커미션 신청",
          onCloseButtonClick: e
        }
      ),
      /* @__PURE__ */ a.jsxs("section", { className: "relative flex h-[calc(100%-5.42857rem)] flex-col justify-between", children: [
        /* @__PURE__ */ a.jsx("div", { className: "flex h-[calc(100%-12.28571rem)] w-full flex-col justify-between gap-y-[1.143rem] overflow-y-hidden", children: /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem] overflow-y-auto px-[2.28571rem]", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem] border-b border-b-mshop-gray-5 pb-[1.14rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b", children: n.displayName }),
            /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsxs("div", { className: "flex items-start gap-x-[0.57rem]", children: [
              /* @__PURE__ */ a.jsxs("div", { className: "flex", children: [
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-b", children: n.price.toLocaleString(cr.Ko) }),
                /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b", children: "원" })
              ] }),
              /* @__PURE__ */ a.jsx("span", { className: "flex-center h-[1.71rem] w-[0.07rem] before:block before:h-[0.86rem] before:w-[0.07rem] before:bg-mshop-gray-20" }),
              /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col text-mshop-gray-80", children: [
                /* @__PURE__ */ a.jsxs("div", { className: "flex items-center", children: [
                  /* @__PURE__ */ a.jsx("span", { children: "예상 작업 기간" }),
                  /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-14-unica-m ml-[0.29rem] text-mshop-gray-80", children: n.estimatedTime }),
                  /* @__PURE__ */ a.jsx("span", { children: "일" })
                ] }),
                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: "예상 작업 기간과 별개로 신청서에 따라 작업 마감 기한이 설정됩니다." })
              ] })
            ] }) })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
            /* @__PURE__ */ a.jsxs("h2", { className: "typo-mshop-kr-16-b flex items-center gap-x-[0.29rem]", children: [
              "작업 상세 내용",
              /* @__PURE__ */ a.jsxs($8, { className: "flex-center", children: [
                /* @__PURE__ */ a.jsx(K4, { children: ({ open: c }) => /* @__PURE__ */ a.jsx(
                  l_,
                  {
                    className: $(
                      "size-[1.14rem]",
                      c ? "text-mshop-blue-100" : "text-mshop-gray-50"
                    )
                  }
                ) }),
                /* @__PURE__ */ a.jsxs(
                  X4,
                  {
                    as: "section",
                    anchor: {
                      to: "right start"
                    },
                    className: "ml-[0.5rem] w-[16.85714rem] rounded-[1.14rem] bg-mshop-blue-10 p-[1.14rem] text-mshop-blue-100",
                    style: {
                      zIndex: Tc.GLOBAL.MODAL
                    },
                    children: [
                      /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-14-b m-0", children: "커미션 진행 과정" }),
                      /* @__PURE__ */ a.jsxs("ol", { className: "typo-mshop-kr-14-m mb-0 mt-[0.57rem] pl-[1.14rem]", children: [
                        /* @__PURE__ */ a.jsx("li", { children: "신청서 작성 후 결제" }),
                        /* @__PURE__ */ a.jsx("li", { className: "mt-[0.29rem]", children: "신청서 수락 여부 및 마감 기한 확인" }),
                        /* @__PURE__ */ a.jsxs("li", { className: "mt-[0.29rem]", children: [
                          "작업물 확인",
                          /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-12-m m-0", children: [
                            "크리에이터와 작업물 관련 소통은",
                            /* @__PURE__ */ a.jsx("br", {}),
                            "커미션 문의 하기를 이용해 주세요."
                          ] })
                        ] }),
                        /* @__PURE__ */ a.jsxs("li", { className: "mt-[0.29rem]", children: [
                          "최종 완료",
                          /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-12-m m-0", children: [
                            "작업이 완료된 커미션은",
                            /* @__PURE__ */ a.jsx("br", {}),
                            "구매 확정 버튼을 눌러 완료해 주세요."
                          ] })
                        ] })
                      ] })
                    ]
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ a.jsx("p", { className: "whitespace-pre-wrap break-words text-mshop-black", children: n.workDescription })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[0.57rem]", children: [
            /* @__PURE__ */ a.jsx("h2", { className: "typo-mshop-kr-16-b", children: "작업물 이용 범위" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m flex flex-col break-all rounded-[0.57rem] bg-mshop-gray-5 px-[1.14rem] py-[0.57rem] text-mshop-gray-80", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-14-b", children: co[n.license].name }),
              /* @__PURE__ */ a.jsx("span", { children: co[n.license].description ?? n.licenseText })
            ] })
          ] })
        ] }) }),
        /* @__PURE__ */ a.jsxs("div", { className: "absolute bottom-0 left-0 right-0 bg-mshop-white", children: [
          /* @__PURE__ */ a.jsx("div", { className: "flex items-center gap-x-[0.571rem] px-[2.28571rem] py-[1.14286rem]", children: n.sampleImages.map((c, u) => /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              className: "block flex-shrink-0",
              onClick: () => s(u),
              children: /* @__PURE__ */ a.jsx(
                "img",
                {
                  src: c.url,
                  className: $(
                    "size-[3.60714rem] rounded-md border-[0.143rem] object-cover",
                    {
                      "border-mshop-blue-100": u == r
                    },
                    {
                      "border-transparent opacity-50 hover:opacity-100": u != r
                    }
                  ),
                  alt: ""
                }
              )
            },
            u
          )) }),
          /* @__PURE__ */ a.jsx("div", { className: "border-t border-t-mshop-gray-5 px-[2.28571rem] py-[1.14286rem]", children: /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "lg",
              theme: "blue",
              type: "button",
              widthFull: !0,
              onClick: t,
              children: "커미션 신청하기"
            }
          ) })
        ] })
      ] })
    ] })
  ] });
}
function SNe(e) {
  const {
    widgetCore: { isMobile: t }
  } = Gt();
  return t ? /* @__PURE__ */ a.jsx(xNe, { ...e }) : /* @__PURE__ */ a.jsx(bNe, { ...e });
}
function wNe({
  show: e,
  onClose: t,
  onCommissionApplicationButtonClick: n,
  onAfterLeave: r
}) {
  return /* @__PURE__ */ a.jsx(
    dh,
    {
      show: e,
      variant: "TYPE03",
      onClose: t,
      afterLeave: r,
      children: /* @__PURE__ */ a.jsx(
        SNe,
        {
          onClose: t,
          onCommissionApplicationButtonClick: n
        }
      )
    }
  );
}
const CNe = (e, t) => jn(
  "/create-commission-payment",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
    case le.NotFoundPaymentModel:
    case le.InvalidImage:
    case le.NotRegisteredPayment:
    case le.FailedPayment:
    case le.UnableToProcessRequest:
    case le.AlreadyRequestCommission:
      return n;
    default:
      throw new Error();
  }
}), NNe = {
  UserDataChanged: "USER_DATA_CHANGED"
}, jNe = "https://mauth.marpple.com", ENe = "https://mauth.marpple.tw";
function kNe(e, t, n = [ENe, jNe]) {
  an(() => {
    const r = (s) => {
      if (!n.includes(s.origin))
        return;
      const { type: o, data: c } = s.data || {};
      if (o === e)
        return t(c);
    };
    return window.addEventListener("message", r), () => {
      window.removeEventListener("message", r);
    };
  }, [e, t, n]);
}
function _Ne({ show: e, onClose: t }) {
  const {
    widgetCore: { isMobile: n }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(dh, { show: e, variant: "TYPE02", children: [
    n ? /* @__PURE__ */ a.jsx(
      p5,
      {
        onClose: t,
        title: "개인 정보 수집 및 이용 동의"
      }
    ) : /* @__PURE__ */ a.jsx(
      D1,
      {
        titleAlign: "Left",
        back: !1,
        close: !0,
        label: "개인 정보 수집 및 이용 동의",
        onCloseButtonClick: t
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "typo-mshop-kr-12-m text-mshop-gray-80",
          n ? "h-full p-[1.14rem]" : "h-full px-[2.28571rem] pb-[2.28571rem] pt-[1.14286rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("div", { className: "overflow-hidden rounded-[0.28571rem] border border-mshop-gray-20", children: /* @__PURE__ */ a.jsxs("table", { className: "w-full text-center", children: [
            /* @__PURE__ */ a.jsx("thead", { children: /* @__PURE__ */ a.jsx("tr", { children: ["수집 목적", "수집 항목", "보유 기간"].map((r, s) => /* @__PURE__ */ a.jsx(
              "th",
              {
                scope: "col",
                className: $(
                  "typo-mshop-kr-12-b w-2/6 border-b border-b-mshop-gray-20 bg-mshop-gray-5 p-[0.57143rem]",
                  { "border-l border-l-mshop-gray-20": s > 0 }
                ),
                children: r
              },
              s
            )) }) }),
            /* @__PURE__ */ a.jsx("tbody", { children: /* @__PURE__ */ a.jsx("tr", { children: [
              "신청한 커미션의 진행, 커뮤니케이션, 환불 및 상담 회신",
              "이메일 주소, 이름, 연락처",
              "개인정보 수집 및 이용목적 달성 시 및 관련 법령에 따른 기간까지 보관"
            ].map((r, s) => /* @__PURE__ */ a.jsx(
              "td",
              {
                className: $("w-2/6 p-[0.57143rem]", {
                  "border-l border-l-mshop-gray-20": s > 0
                }),
                children: r
              },
              s
            )) }) })
          ] }) }),
          /* @__PURE__ */ a.jsx("p", { className: "mt-[0.57143rem]", children: "개인정보 제공에 동의하지 않으실 수 있으며, 동의하지 않으실 경우 서비스 이용이 제한될 수 있습니다. 그 밖의 사항은 (주)마플코퍼레이션의 개인정보처리방침에 따릅니다." })
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: $(
          "border-t border-t-mshop-gray-5",
          n ? "p-[1.14rem]" : "px-[2.28571rem] py-[1.14rem]"
        ),
        children: /* @__PURE__ */ a.jsx(
          fn,
          {
            variant: n ? "md" : "lg",
            theme: "blue",
            type: "button",
            widthFull: !0,
            onClick: t,
            children: "확인"
          }
        )
      }
    )
  ] });
}
function TNe({ show: e, onClose: t }) {
  const {
    widgetCore: { isMobile: n }
  } = Gt();
  return /* @__PURE__ */ a.jsxs(dh, { show: e, variant: "TYPE02", children: [
    n ? /* @__PURE__ */ a.jsx(
      p5,
      {
        onClose: t,
        title: "개인 정보 제 3자 제공 동의"
      }
    ) : /* @__PURE__ */ a.jsx(
      D1,
      {
        titleAlign: "Left",
        back: !1,
        close: !0,
        label: "개인 정보 제 3자 제공 동의",
        onCloseButtonClick: t
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "typo-mshop-kr-12-m p-[1.14rem] text-mshop-gray-80",
          n ? "h-full p-[1.14rem]" : "h-full px-[2.28571rem] pb-[2.28571rem] pt-[1.14286rem]"
        ),
        children: [
          /* @__PURE__ */ a.jsx("div", { className: "overflow-hidden rounded-[0.28571rem] border border-mshop-gray-20", children: /* @__PURE__ */ a.jsxs("table", { className: "w-full text-center", children: [
            /* @__PURE__ */ a.jsx("thead", { children: /* @__PURE__ */ a.jsx("tr", { children: ["제공받는 자", "수집 목적", "수집 항목", "보유 기간"].map(
              (r, s) => /* @__PURE__ */ a.jsx(
                "th",
                {
                  scope: "col",
                  className: $(
                    "typo-mshop-kr-12-b w-1/4 border-b border-b-mshop-gray-20 bg-mshop-gray-5 p-[0.57143rem]",
                    { "border-l border-l-mshop-gray-20": s > 0 }
                  ),
                  children: r
                },
                s
              )
            ) }) }),
            /* @__PURE__ */ a.jsx("tbody", { children: /* @__PURE__ */ a.jsx("tr", { children: [
              "신청 커미션 보유 크리에이터",
              "커미션 진행, 결과물 전달, 환불 및 상담 회신",
              "이메일 주소, 이름, 연락처",
              "개인정보 수집 및 이용목적 달성 시 및 관련 법령에 따른 기간까지 보관"
            ].map((r, s) => /* @__PURE__ */ a.jsx(
              "td",
              {
                className: $("w-1/4 p-[0.57143rem]", {
                  "border-l border-l-mshop-gray-20": s > 0
                }),
                children: r
              },
              s
            )) }) })
          ] }) }),
          /* @__PURE__ */ a.jsx("p", { className: "mt-[0.57143rem]", children: "커미션 종료 후 개인정보는 자동 마스킹 처리되어 크리에이터가 확인할 수 없습니다. 개인정보 제공에 동의하지 않으실 수 있으며, 동의하지 않으실 경우 서비스 이용이 제한될수 있습니다. 마플코퍼레이션은 크리에이터 커미션에 관해서는 통신판매중개자이며 통신판매의 당사자가 아닙니다. 따라서 마플코퍼레이션은 상품 거래정보 및 거래에 대하여 책임을 지지 않습니다." })
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: $(
          "border-t border-t-mshop-gray-5",
          n ? "p-[1.14rem]" : "px-[2.28571rem] py-[1.14rem]"
        ),
        children: /* @__PURE__ */ a.jsx(
          fn,
          {
            variant: n ? "md" : "lg",
            theme: "blue",
            type: "button",
            widthFull: !0,
            onClick: t,
            children: "확인"
          }
        )
      }
    )
  ] });
}
function MNe({
  onAccountSettingsButtonClick: e,
  onIntegratedPaidServiceTermsTextClick: t,
  onClickPrevButtonClick: n,
  onPaidSuccess: r,
  onClose: s,
  onShowPayMethodModal: o
}) {
  const { me: c } = by();
  wt(c);
  const { payMethod: u } = xw(), {
    commissionModalData: { selectedCommission: m }
  } = M6(), {
    widgetCore: { isMobile: y, toggleSpinner: b, onError: w }
  } = Gt(), { client: k } = Ha(), { setMe: j } = by(), { commissionPaymentData: E, setCommissionPaymentData: T } = SK(), {
    handleSubmit: D,
    register: L,
    formState: { isValid: I, errors: R },
    setError: U,
    setValue: z,
    clearErrors: H
  } = bp({
    defaultValues: {
      email: c.email ?? null,
      mobile: (E == null ? void 0 : E.mobile) ?? (c.mobile === null ? void 0 : K9(c.mobile)),
      username: (E == null ? void 0 : E.username) ?? c.username ?? "",
      isAgree: (E == null ? void 0 : E.isAgree) ?? !1
    },
    mode: "onChange"
  }), [
    K,
    q
  ] = Re(!1), [
    Q,
    Z
  ] = Re(!1);
  an(() => {
    Object.values(R).length > 0 && H();
  }, [u, H, R]);
  const { commissionFormData: X } = qA();
  wt(X);
  const se = (oe) => {
    const ue = oe.target.value;
    T((he) => ({
      ...he,
      username: ue
    })), z("username", ue, {
      shouldValidate: !0
    });
  }, te = (oe) => {
    oe.target.value = Yg(oe.target.value), T((ue) => ({
      ...ue,
      mobile: oe.target.value
    })), z("mobile", oe.target.value, {
      shouldValidate: !0
    });
  }, fe = (oe) => {
    oe.target.value = K9(oe.target.value);
  }, ce = (oe) => {
    oe.target.value = Yg(oe.target.value);
  }, pe = Rt(null), Se = async (oe) => {
    var ve;
    wt(u), wt(oe.username), wt(oe.mobile), wt(m), b(!0);
    const { code: ue, data: he } = await CNe(
      {
        ...X != null && X.message ? { message: X.message } : {},
        ...X != null && X.preQuestionAnswer ? { preQuestionAnswer: X.preQuestionAnswer } : {},
        attachmentUrls: X.attachmentUrls ?? [],
        username: oe.username,
        mobile: Yg(oe.mobile),
        payMethodId: u.id,
        paymentModelId: m.commissionSnapshotId
      },
      { client: k, onError: w }
    );
    return ue !== le.Success ? (b(!1), ue === le.NotFoundPaymentModel || ue === le.UnableToProcessRequest || ue === le.AlreadyRequestCommission ? (await en({
      body: (Te) => /* @__PURE__ */ a.jsx(
        ea,
        {
          button: {
            props: Te
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex-col gap-y-[0.857rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "해당 커미션의 상태나 정보가 변경되었습니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "신청 가능 여부 또는 변경된 정보를 확인 후",
              /* @__PURE__ */ a.jsx("br", {}),
              "다시 시도해 주세요."
            ] })
          ] })
        }
      )
    }), window.location.reload()) : (po.flushSync(() => {
      switch (ue) {
        case le.NotRegisteredPayment:
          U("root", {
            message: "유효하지 않은 결제 수단입니다. 결제 수단을 확인해 주세요."
          });
          break;
        case le.TokenExpired:
          return w(Ht);
        case le.FailedPayment:
          U("root", {
            message: he.column === fA.InsufficientBalance ? "계좌 잔액이 부족합니다. 확인 후 다시 시도해 주세요." : "결제 수단 확인 후 다시 시도해 주세요."
          });
          break;
        default:
          U("root", {
            type: "default"
          });
      }
    }), (ve = pe.current) == null ? void 0 : ve.scrollIntoView(!0))) : (wt(he.portone), pA({
      merchantUid: he.portone.merchantUid,
      onPaid: () => {
        b(!1), r(he.target.id);
      },
      onFailed: () => {
        var Te;
        b(!1), po.flushSync(() => {
          U("root", {
            type: "default"
          });
        }), (Te = pe.current) == null || Te.scrollIntoView(!0);
      },
      onCanceled: () => {
        var Te;
        b(!1), po.flushSync(() => {
          U("root", {
            message: "결제에 실패 했습니다. 나중에 다시 시도해 주세요."
          });
        }), (Te = pe.current) == null || Te.scrollIntoView(!0);
      },
      client: k,
      onError: w
    }));
  };
  return kNe(NNe.UserDataChanged, async () => {
    const { code: oe, data: ue } = await Q8({
      client: k,
      onError: w
    });
    if (oe === le.TokenExpired)
      return w(Ht);
    j(ue), z("email", ue.email);
  }), m == null ? null : /* @__PURE__ */ a.jsxs(
    "section",
    {
      className: $(
        {
          relative: !y
        },
        { "h-full": y }
      ),
      children: [
        y ? /* @__PURE__ */ a.jsxs("div", { className: "relative flex h-[4.28571rem] w-full items-center justify-center bg-mshop-white px-[1.14rem]", children: [
          /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-16-b", children: "커미션 결제하기" }),
          /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              onClick: s,
              className: "absolute right-[1.14rem] top-1/2 block -translate-y-1/2",
              children: /* @__PURE__ */ a.jsx(Zg, { className: "size-[1.429rem] text-mshop-black" })
            }
          )
        ] }) : /* @__PURE__ */ a.jsx(
          D1,
          {
            titleAlign: "Left",
            back: !1,
            close: !0,
            label: "커미션 결제하기",
            onCloseButtonClick: s
          }
        ),
        /* @__PURE__ */ a.jsxs(
          "form",
          {
            className: $({ "h-[calc(100%-4.28571rem)]": y }),
            onSubmit: D(Se),
            children: [
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: $(
                    {
                      "h-[calc(100%-5.71428rem)] overflow-y-auto scrollbar-hide": y
                    },
                    {
                      "h-[51.42857rem] overflow-y-auto pb-[6.35714rem] pt-[1.14286rem]": !y
                    }
                  ),
                  children: [
                    /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $(
                          "flex flex-col",
                          y ? "gap-[1.71rem] p-[1.143rem]" : "gap-[2.28571rem] px-[2.28571rem] pb-[2.28571rem]"
                        ),
                        children: [
                          /* @__PURE__ */ a.jsxs(
                            "div",
                            {
                              className: $(
                                "flex flex-col",
                                y ? "gap-[0.571rem]" : "gap-[0.28571rem]"
                              ),
                              children: [
                                /* @__PURE__ */ a.jsxs("div", { className: "flex items-start justify-between", children: [
                                  /* @__PURE__ */ a.jsx(N2, { label: "이메일" }),
                                  /* @__PURE__ */ a.jsx(
                                    "button",
                                    {
                                      type: "button",
                                      className: $(
                                        "text-mshop-gray-50",
                                        y ? "typo-mshop-kr-12-m" : "typo-mshop-kr-14-m"
                                      ),
                                      onClick: e,
                                      children: "계정 설정"
                                    }
                                  )
                                ] }),
                                /* @__PURE__ */ a.jsx(
                                  A8,
                                  {
                                    ...L("email", {
                                      required: !0
                                    }),
                                    readOnly: !0
                                  }
                                ),
                                /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m text-mshop-gray-50", children: "해당 이메일로 커미션 진행 소식이 전송됩니다. 사용 가능한 메일인지 확인해주세요." })
                              ]
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            "div",
                            {
                              className: $(
                                "flex flex-col",
                                y ? "gap-[0.571rem]" : "gap-[0.28571rem]"
                              ),
                              children: [
                                /* @__PURE__ */ a.jsx(N2, { label: "이름" }),
                                /* @__PURE__ */ a.jsx(
                                  A8,
                                  {
                                    ...L("username", {
                                      required: !0,
                                      maxLength: {
                                        value: 30,
                                        message: "30자까지 입력 가능합니다."
                                      },
                                      onChange: se
                                    }),
                                    placeholder: "이름을 입력해 주세요.",
                                    invalid: !!R.username
                                  }
                                ),
                                R.username && /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m text-mshop-red-80", children: R.username.message })
                              ]
                            }
                          ),
                          /* @__PURE__ */ a.jsxs(
                            "div",
                            {
                              className: $(
                                "flex flex-col",
                                y ? "gap-[0.571rem]" : "gap-[0.28571rem]"
                              ),
                              children: [
                                /* @__PURE__ */ a.jsx(N2, { label: "연락처" }),
                                /* @__PURE__ */ a.jsx(
                                  A8,
                                  {
                                    ...L("mobile", {
                                      required: !0,
                                      onChange: te,
                                      onBlur: fe
                                    }),
                                    onFocus: ce,
                                    maxLength: 12,
                                    invalid: !!R.mobile,
                                    placeholder: "하이픈(-) 없이 숫자만 입력해 주세요."
                                  }
                                ),
                                R.mobile && /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m text-mshop-red-80", children: R.mobile.message })
                              ]
                            }
                          ),
                          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-[0.571rem]", children: [
                            /* @__PURE__ */ a.jsx(N2, { label: "결제 금액" }),
                            /* @__PURE__ */ a.jsxs("div", { className: "flex h-[3.42857rem] items-center gap-x-[0.1rem] rounded-[0.57143rem] bg-mshop-gray-5 px-[1.14rem] text-mshop-blue-100", children: [
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-en-16-unica-m -mt-[0.28571rem]", children: m.price.toLocaleString(cr.Ko) }),
                              /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-m", children: "원" })
                            ] })
                          ] }),
                          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-[1.14286rem]", children: [
                            /* @__PURE__ */ a.jsxs("div", { className: "flex justify-between", children: [
                              /* @__PURE__ */ a.jsx(N2, { label: "결제 수단" }),
                              u && /* @__PURE__ */ a.jsx(
                                "button",
                                {
                                  className: "typo-mshop-kr-14-m text-mshop-blue-100",
                                  type: "button",
                                  onClick: o,
                                  children: "결제 수단 변경"
                                }
                              )
                            ] }),
                            u === null ? /* @__PURE__ */ a.jsx(
                              $2,
                              {
                                variant: "add",
                                onAddClick: o
                              }
                            ) : /* @__PURE__ */ a.jsx(
                              $2,
                              {
                                variant: "creditCard",
                                paymentMethod: u
                              }
                            )
                          ] }),
                          /* @__PURE__ */ a.jsxs("div", { children: [
                            /* @__PURE__ */ a.jsx("div", { className: "rounded-[0.57142rem] bg-mshop-gray-5 p-[1.14285rem]", children: /* @__PURE__ */ a.jsxs("ul", { className: "typo-mshop-kr-12-m list-disc space-y-[0.28571rem] pl-[1rem] text-mshop-gray-80", children: [
                              /* @__PURE__ */ a.jsxs("li", { children: [
                                "커미션 서비스를 이용하기 전에",
                                " ",
                                /* @__PURE__ */ a.jsx(
                                  "button",
                                  {
                                    type: "button",
                                    className: "typo-mshop-kr-12-m underline underline-offset-2",
                                    onClick: t,
                                    children: "이용약관"
                                  }
                                ),
                                "을 확인해주세요."
                              ] }),
                              /* @__PURE__ */ a.jsx("li", { children: "크리에이터가 커미션 신청을 거절하거나, 7일 내로 신청서를 수락하지 않으면 신청 취소되고 환불 처리됩니다." }),
                              /* @__PURE__ */ a.jsx("li", { children: "크리에이터 사정에 따라 마감 기한은 1회에 한해, 수락일로부터 최대 90일까지 연장될 수 있습니다." }),
                              /* @__PURE__ */ a.jsx("li", { className: "typo-mshop-kr-12-b", children: /* @__PURE__ */ a.jsx("span", { className: "text-mshop-black", children: "커미션 작업이 시작되면 크리에이터의 마감 기한 미준수를 제외한 모든 경우에 환불 불가합니다. 이 점 꼭 참고해주세요." }) })
                            ] }) }),
                            /* @__PURE__ */ a.jsxs("div", { className: "typo-mshop-kr-14-m flex flex-col gap-y-[0.571rem] pt-[0.57143rem]", children: [
                              /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
                                /* @__PURE__ */ a.jsx("span", { children: "개인 정보 수집 및 이용 동의" }),
                                /* @__PURE__ */ a.jsx(
                                  "button",
                                  {
                                    type: "button",
                                    className: "text-mshop-gray-80 underline",
                                    onClick: () => {
                                      q(!0);
                                    },
                                    children: "보기"
                                  }
                                )
                              ] }),
                              /* @__PURE__ */ a.jsxs("div", { className: "flex items-center justify-between", children: [
                                /* @__PURE__ */ a.jsx("span", { children: "개인 정보 제 3자 제공 동의" }),
                                /* @__PURE__ */ a.jsx(
                                  "button",
                                  {
                                    type: "button",
                                    className: "text-mshop-gray-80 underline",
                                    onClick: () => {
                                      Z(!0);
                                    },
                                    children: "보기"
                                  }
                                )
                              ] })
                            ] }),
                            /* @__PURE__ */ a.jsxs(
                              Bd,
                              {
                                className: $(
                                  "group mt-[0.57143rem] flex flex-row gap-x-[.57143rem]",
                                  y ? "typo-mshop-kr-14-m" : "typo-mshop-kr-16-m items-center"
                                ),
                                children: [
                                  /* @__PURE__ */ a.jsx(
                                    Z0,
                                    {
                                      ...L("isAgree", {
                                        required: !0
                                      }),
                                      onChange: (oe) => {
                                        z("isAgree", oe, {
                                          shouldValidate: !0
                                        }), T((ue) => ({
                                          ...ue,
                                          isAgree: oe
                                        }));
                                      },
                                      marginTop: y ? "0.25714rem" : ""
                                    }
                                  ),
                                  /* @__PURE__ */ a.jsxs(_c, { className: "typo-mshop-kr-14-m cursor-pointer", children: [
                                    /* @__PURE__ */ a.jsx("span", { className: $({ "typo-mshop-kr-14-b": !y }), children: "(필수)" }),
                                    " ",
                                    "주문 내용 및 위의 내용을 모두 확인하였으며, 결제에 동의합니다."
                                  ] })
                                ]
                              }
                            )
                          ] }),
                          R.root && (R.root.type === "default" ? /* @__PURE__ */ a.jsxs(
                            "p",
                            {
                              className: "typo-mshop-kr-14-m text-mshop-red-80",
                              ref: pe,
                              children: [
                                "예기치 못한 오류로 인해 진행할 수 없습니다.",
                                /* @__PURE__ */ a.jsx("br", {}),
                                "동일한 문제가 반복적으로 발생할 경우",
                                /* @__PURE__ */ a.jsx("br", {}),
                                /* @__PURE__ */ a.jsx("a", { href: "mailto:cs@marppleshop.com", className: "underline", children: "cs@marppleshop.com" }),
                                "로 문의해 주세요."
                              ]
                            }
                          ) : /* @__PURE__ */ a.jsx(
                            "p",
                            {
                              className: "typo-mshop-kr-14-m text-mshop-red-80",
                              ref: pe,
                              children: R.root.message
                            }
                          ))
                        ]
                      }
                    ),
                    !y && /* @__PURE__ */ a.jsxs(
                      "div",
                      {
                        className: $(
                          "bottom-0 left-0 right-0 flex items-center gap-x-[0.85714rem] bg-mshop-white",
                          {
                            "absolute border-t border-t-mshop-gray-5 px-[2.28571rem] py-[1.14rem]": !y
                          },
                          {
                            "fixed pb-[calc(env(safe-area-inset-bottom)+1.14rem)] pl-[1.14rem] pr-[1.14rem] pt-[1.14rem]": y
                          }
                        ),
                        children: [
                          /* @__PURE__ */ a.jsx("div", { className: "w-[11.42857rem] flex-shrink-0", children: /* @__PURE__ */ a.jsx(
                            fn,
                            {
                              variant: y ? "md" : "lg",
                              theme: "line",
                              type: "button",
                              onClick: n,
                              children: "이전"
                            }
                          ) }),
                          /* @__PURE__ */ a.jsx(
                            fn,
                            {
                              variant: y ? "md" : "lg",
                              theme: "blue",
                              type: "submit",
                              disabled: !I || !u,
                              widthFull: !0,
                              children: "결제하기"
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              ),
              y && /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[1.14rem] bg-mshop-white p-[1.14rem]", children: [
                /* @__PURE__ */ a.jsx("div", { className: "w-[11.42857rem] flex-shrink-0", children: /* @__PURE__ */ a.jsx(
                  fn,
                  {
                    variant: y ? "md" : "lg",
                    theme: "line",
                    type: "button",
                    onClick: n,
                    children: "이전"
                  }
                ) }),
                /* @__PURE__ */ a.jsx(
                  fn,
                  {
                    variant: y ? "md" : "lg",
                    theme: "blue",
                    type: "submit",
                    disabled: !I || !u,
                    widthFull: !0,
                    children: "결제하기"
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
          /* @__PURE__ */ a.jsx(
            _Ne,
            {
              show: K,
              onClose: () => {
                q(!1);
              }
            }
          ),
          /* @__PURE__ */ a.jsx(
            TNe,
            {
              show: Q,
              onClose: () => {
                Z(!1);
              }
            }
          )
        ] })
      ]
    }
  );
}
function RNe({
  show: e,
  onAccountSettingsButtonClick: t,
  onIntegratedPaidServiceTermsTextClick: n,
  onClickPrevButtonClick: r,
  onClose: s,
  onPaidSuccess: o,
  onShowPayMethodModal: c,
  onAfterLeave: u
}) {
  const {
    widgetCore: { isMobile: m }
  } = Gt();
  return /* @__PURE__ */ a.jsx(
    dh,
    {
      show: e,
      variant: "TYPE02",
      afterLeave: u,
      transition: m && !e,
      children: /* @__PURE__ */ a.jsx(
        MNe,
        {
          onClose: s,
          onAccountSettingsButtonClick: t,
          onIntegratedPaidServiceTermsTextClick: n,
          onClickPrevButtonClick: r,
          onPaidSuccess: o,
          onShowPayMethodModal: c
        }
      )
    }
  );
}
var DNe = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_CHANNEL_KEY: "channel-key-e7694500-512d-450e-aedd-6f47dad28dd0", VITE_IMP_ACCOUNT_ID: "imp03882726", VITE_IMP_CHANNEL_KEY: "M3RpWnV1YjFWa3h5dXFyViszYjA5Zz09", VITE_IMP_STORE_ID: "MOImarshop", VITE_STORE_ID: "store-a1ec38af-8bea-4805-8cdb-17632e1ebfdf" };
const PNe = 12, ONe = 1, ip = {
  ApplicationModal: "ApplicationModal",
  ApplicationFormModal: "ApplicationFormModal",
  ApplicationPaymentModal: "ApplicationPaymentModal",
  ApplicationCompleteModal: "ApplicationCompleteModal",
  PayMethodModal: "PayMethodModal"
};
function ANe({
  client: e,
  projectId: t,
  widgetCore: n,
  commissions: r,
  page: s,
  onAccountSettingsButtonClick: o,
  onIntegratedPaidServiceTermsTextClick: c,
  onClickPersonalInfoOutsourcing: u,
  onClickThirdPartyConsent: m,
  onClickInicisTerms: y,
  onGoToCommissionDetailButtonClick: b,
  onClickCommissionRequestButtonClick: w,
  onGoToCommissionFaqButtonClick: k,
  onCommissionInquiryButtonClick: j
}) {
  Al([
    [ol, e],
    [R1, t],
    [ll, n],
    [vK, r],
    [m5, null]
  ]);
  const {
    setCommissions: E,
    commissions: T,
    getCommissionById: D
  } = lNe(), {
    widgetCore: { isMobile: L, onError: I, isApp: R }
  } = Gt(), { commissionFormData: U, resetCommissionFormData: z } = qA(), { setCommissionPaymentData: H } = SK(), {
    commissionModalData: K,
    setCommissionModalData: q,
    resetCommissionModalData: Q
  } = M6(), [Z, X] = Re(null), [se, te] = Re(s ?? ONe), fe = async (Ie) => {
    DNe.STORYBOOK ? await Ue() : w(Ue);
    async function Ue() {
      const { code: qe } = await aNe(
        {
          commissionId: Ie
        },
        {
          client: e,
          onError: I
        }
      );
      if (qe === le.AlreadyRequestCommission || qe === le.UnableToProcessRequest)
        return await en({
          body: (it) => /* @__PURE__ */ a.jsx(
            ea,
            {
              button: {
                props: it
              },
              children: /* @__PURE__ */ a.jsxs("section", { className: "flex-center flex-col gap-y-[0.857rem]", children: [
                /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "요청 처리 불가" }),
                /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
                  "해당 멤버십의 상태나 정보가 변경되었습니다.",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "가입 가능 여부 또는 변경된 정보를 확인 후",
                  /* @__PURE__ */ a.jsx("br", {}),
                  "다시 시도해 주세요."
                ] })
              ] })
            }
          )
        }), window.location.reload();
      q((it) => ({
        ...it,
        selectedCommission: D(Ie)
      })), X(ip.ApplicationModal);
    }
  }, ce = () => {
    X(ip.ApplicationPaymentModal);
  }, pe = () => {
    X(null);
  }, Se = async () => {
    if (Object.values(U).filter((qe) => Array.isArray(qe) ? qe.length > 0 : qe).length == 0)
      return X(null);
    await ho({
      body: (qe, it) => /* @__PURE__ */ a.jsx(
        D3,
        {
          confirmButton: {
            props: qe
          },
          cancelButton: {
            props: it
          },
          children: /* @__PURE__ */ a.jsxs("div", { className: "flex-center flex-col gap-y-[0.857rem]", children: [
            /* @__PURE__ */ a.jsx("h1", { className: "typo-mshop-kr-20-b text-mshop-black", children: "작성 내용 초기화" }),
            /* @__PURE__ */ a.jsxs("p", { className: "typo-mshop-kr-14-m text-mshop-gray-80", children: [
              "작성 중인 내용이 초기화됩니다.",
              /* @__PURE__ */ a.jsx("br", {}),
              "신청서를 닫으시겠습니까?"
            ] })
          ] })
        }
      )
    }) && pe();
  }, { payMethod: oe, setPayMethod: ue } = xw(), he = (Ie) => {
    ue(Ie), X(ip.ApplicationPaymentModal);
  }, ve = (Ie) => {
    E({
      ...r,
      items: r.items.map((Ue) => {
        var qe;
        return Ue.id === ((qe = K.selectedCommission) == null ? void 0 : qe.id) ? {
          ...Ue,
          isRequested: !0
        } : Ue;
      })
    }), pe(), q((Ue) => ({
      ...Ue,
      paidCommissionRequestId: Ie
    })), X(ip.ApplicationCompleteModal);
  }, Te = () => {
    Z === null && (z(), H(null), Q());
  };
  return /* @__PURE__ */ a.jsxs("div", { className: "twp flex w-full flex-col gap-y-[1.71rem]", children: [
    /* @__PURE__ */ a.jsx(
      "section",
      {
        className: $(
          "grid text-mshop-black",
          {
            "grid-cols-3 gap-x-[1.14rem] gap-y-[2.26rem]": !L
          },
          {
            "grid-cols-1 gap-y-[1.14rem] p-[1.14rem]": L
          }
        ),
        children: T.items.map((Ie) => {
          const Ue = Ie.isRequested, qe = Ie.state === nr.Paused, it = Ie.state === nr.Close, Ne = !Ue && (it || qe);
          return /* @__PURE__ */ a.jsxs(
            "section",
            {
              className: "rounded-[1.71429rem] border border-mshop-gray-10 pb-[2.29rem] pl-[1.17rem] pr-[1.17rem] pt-[1.17rem]",
              children: [
                /* @__PURE__ */ a.jsxs("div", { className: $({ "flex gap-x-[1.14rem]": L }), children: [
                  /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: $(
                        "relative aspect-square overflow-hidden rounded-[1.14286rem]",
                        { "w-full": !L },
                        { "size-[6.85714rem] flex-shrink-0": L }
                      ),
                      children: [
                        /* @__PURE__ */ a.jsx(
                          "div",
                          {
                            className: $(
                              "absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2",
                              {
                                "opacity-[0.3]": it
                              }
                            ),
                            children: /* @__PURE__ */ a.jsx(
                              aa,
                              {
                                src: Ie.thumbnailImage.url,
                                width: L ? "6.8571rem" : "28.5714rem",
                                height: L ? "6.8571rem" : "28.5714rem",
                                objectFit: "cover"
                              }
                            )
                          }
                        ),
                        !L && Ne && /* @__PURE__ */ a.jsx("span", { className: "flex-center absolute left-[1.5rem] top-[1.14rem] h-[1.72rem] rounded-[0.28571rem] bg-mshop-gray-50 px-[0.57143rem] text-mshop-white backdrop-blur-[5px]", children: JH(Ie.state) })
                      ]
                    }
                  ),
                  /* @__PURE__ */ a.jsxs(
                    "div",
                    {
                      className: $(
                        "flex flex-col",
                        { "gap-y-[0.57rem]": !L },
                        {
                          "w-[calc(100%-6.85714rem-1.14rem)] gap-y-[0.14rem]": L
                        }
                      ),
                      children: [
                        L && Ne && /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-12-m inline-flex h-[1.21428rem] flex-shrink flex-grow-0 items-center justify-center rounded-[0.28571rem] bg-mshop-gray-50 px-[0.14285rem] text-mshop-white backdrop-blur-[5px]", children: JH(Ie.state) }) }),
                        /* @__PURE__ */ a.jsx(
                          "h1",
                          {
                            className: $(
                              "line-clamp-1 break-words",
                              {
                                "typo-mshop-kr-28-b pt-[1.71rem]": !L
                              },
                              {
                                "typo-mshop-kr-14-b": L
                              }
                            ),
                            children: Ie.displayName
                          }
                        ),
                        /* @__PURE__ */ a.jsxs(
                          "div",
                          {
                            className: $(
                              {
                                "flex items-center gap-x-[0.86rem]": !L
                              },
                              { "text-mshop-gray-80": L }
                            ),
                            children: [
                              /* @__PURE__ */ a.jsxs("div", { className: "text-mshop-black", children: [
                                /* @__PURE__ */ a.jsx(
                                  "span",
                                  {
                                    className: $(
                                      {
                                        "typo-mshop-en-20-unica-b": !L
                                      },
                                      {
                                        "typo-mshop-en-14-unica-b": L
                                      }
                                    ),
                                    children: Ie.price.toLocaleString(cr.Ko)
                                  }
                                ),
                                /* @__PURE__ */ a.jsx(
                                  "span",
                                  {
                                    className: $(
                                      {
                                        "typo-mshop-kr-20-b": !L
                                      },
                                      {
                                        "typo-mshop-kr-14-b": L
                                      }
                                    ),
                                    children: "원"
                                  }
                                )
                              ] }),
                              !L && /* @__PURE__ */ a.jsx("span", { className: "h-[0.85714rem] w-[0.07143rem] bg-mshop-gray-20" }),
                              /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-14-m", children: [
                                "예상 작업 기간 ",
                                Ie.estimatedTime,
                                "일"
                              ] })
                            ]
                          }
                        ),
                        !L && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
                          /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-[0.57rem]", children: [
                            /* @__PURE__ */ a.jsx("span", { className: "typo-mshop-kr-16-b flex-shrink-0", children: "작업물 이용 범위" }),
                            /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-16-m w-full truncate", children: [
                              co[Ie.license].name,
                              ":",
                              " ",
                              co[Ie.license].description ?? Ie.licenseText
                            ] })
                          ] }),
                          /* @__PURE__ */ a.jsx("div", { className: "mt-[0.57rem] min-h-[8.714285rem]", children: /* @__PURE__ */ a.jsx("div", { className: "border-t border-t-mshop-gray-5 py-[1.14rem]", children: /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-14-m line-clamp-4 text-mshop-gray-80", children: Ie.description }) }) })
                        ] })
                      ]
                    }
                  )
                ] }),
                L && /* @__PURE__ */ a.jsxs("div", { className: "text-mshop-gray-80", children: [
                  /* @__PURE__ */ a.jsx("div", { className: "mt-[0.86rem] flex items-center gap-x-[0.57rem]", children: /* @__PURE__ */ a.jsxs("span", { className: "typo-mshop-kr-12-b w-full truncate", children: [
                    co[Ie.license].name,
                    ":",
                    " ",
                    co[Ie.license].description ?? Ie.licenseText
                  ] }) }),
                  /* @__PURE__ */ a.jsx("div", { className: "mt-[0.86rem] h-[6.64285rem]", children: /* @__PURE__ */ a.jsx("div", { className: "border-t border-t-mshop-gray-5 py-[0.86rem]", children: /* @__PURE__ */ a.jsx("p", { className: "typo-mshop-kr-12-m line-clamp-4 text-mshop-gray-80", children: Ie.description }) }) })
                ] }),
                /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: $({ "mt-[1.14rem] flex justify-end": L }),
                    children: /* @__PURE__ */ a.jsx("div", { className: $({ "w-[11.42857rem]": L }), children: /* @__PURE__ */ a.jsx(
                      fn,
                      {
                        type: "button",
                        variant: L ? "sm" : "md",
                        theme: "blue",
                        widthFull: !0,
                        disabled: qe || it || Ue || R,
                        onClick: () => fe(Ie.id),
                        children: LNe({
                          isRequested: Ue,
                          isApp: R,
                          commissionState: Ie.state
                        })
                      }
                    ) })
                  }
                )
              ]
            },
            Ie.id
          );
        })
      }
    ),
    r.totalPage > 1 && /* @__PURE__ */ a.jsx(
      "div",
      {
        className: $(
          "flex-center",
          { "mt-[4rem]": !L },
          { "mt-[3.43rem]": L }
        ),
        children: /* @__PURE__ */ a.jsx(
          J2,
          {
            count: r.totalPage,
            onChange: async (Ie, Ue) => {
              te(Ue);
              const { data: qe } = await yK(
                {
                  page: Ue,
                  size: PNe,
                  projectId: t
                },
                {
                  client: e,
                  onError: I
                }
              );
              E(qe), window.scrollTo(0, 0);
            },
            page: se,
            showFirstButton: !0,
            showLastButton: !0,
            windowSize: L ? 5 : 10
          }
        )
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex-center gap-x-[0.57142rem]",
          { "mt-[3.43rem] py-[1.71rem]": !L },
          { "mt-[2.29rem]": L }
        ),
        children: [
          /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "md",
              theme: "line",
              type: "button",
              onClick: () => j(t),
              children: "커미션 문의하기"
            }
          ),
          /* @__PURE__ */ a.jsx(
            fn,
            {
              variant: "md",
              theme: "line",
              type: "button",
              onClick: k,
              children: "커미션 FAQ 보러가기"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ a.jsx(
      wNe,
      {
        show: Z === ip.ApplicationModal,
        onCommissionApplicationButtonClick: () => {
          X(ip.ApplicationFormModal);
        },
        onClose: () => {
          X(null);
        },
        onAfterLeave: Te
      }
    ),
    /* @__PURE__ */ a.jsx(
      vNe,
      {
        show: Z === ip.ApplicationFormModal,
        onClose: Se,
        onNextStep: ce,
        onAfterLeave: Te
      }
    ),
    /* @__PURE__ */ a.jsx(
      RNe,
      {
        show: Z === ip.ApplicationPaymentModal,
        onAccountSettingsButtonClick: o,
        onIntegratedPaidServiceTermsTextClick: c,
        onClickPrevButtonClick: () => {
          X(ip.ApplicationFormModal);
        },
        onPaidSuccess: ve,
        onClose: Se,
        onShowPayMethodModal: () => {
          X(ip.PayMethodModal);
        },
        onAfterLeave: Te
      }
    ),
    /* @__PURE__ */ a.jsx(
      Z8,
      {
        show: Z === ip.PayMethodModal,
        isMobile: L,
        onClose: () => {
          X(ip.ApplicationPaymentModal);
        },
        onRegister: he,
        registeredPayMethod: oe,
        onClickThirdPartyConsent: m,
        onClickInicisTerms: y,
        onClickPersonalInfoOutsourcing: u,
        onAfterLeave: Te,
        ...L ? { transition: !1 } : {}
      }
    ),
    /* @__PURE__ */ a.jsx(
      uNe,
      {
        show: Z === ip.ApplicationCompleteModal,
        onGoToCommissionDetailButtonClick: () => {
          wt(K.paidCommissionRequestId), b(
            K.paidCommissionRequestId
          );
        },
        onClose: () => {
          X(null);
        },
        onAfterLeave: Te
      }
    )
  ] });
}
function JH(e) {
  switch (e) {
    case nr.Close:
      return "종료";
    case nr.Paused:
      return "일시 중단";
    default:
      return null;
  }
}
function LNe({
  isRequested: e,
  commissionState: t,
  isApp: n
}) {
  return e ? "신청 중인 커미션이에요" : t === nr.Paused ? "커미션 일시중단" : t === nr.Close ? "종료된 커미션이에요" : n ? "PC에서만 가능해요" : "커미션 신청하기";
}
function INe({
  client: e,
  isMobile: t,
  isApp: n,
  projectId: r,
  toggleSpinner: s,
  onError: o,
  onScrollLock: c,
  page: u,
  onAccountSettingsButtonClick: m,
  onIntegratedPaidServiceTermsTextClick: y,
  onClickPersonalInfoOutsourcing: b,
  onClickThirdPartyConsent: w,
  onClickInicisTerms: k,
  onGoToCommissionDetailButtonClick: j,
  onClickCommissionRequestButtonClick: E,
  onGoToCommissionFaqButtonClick: T,
  onCommissionInquiryButtonClick: D
}) {
  const [L, I] = Re(null);
  return an(() => {
    (async () => {
      const { data: R } = await yK(
        {
          projectId: r,
          page: 1,
          size: 12
        },
        {
          client: e,
          onError: o
        }
      );
      I(R);
    })();
  }, []), L === null ? null : /* @__PURE__ */ a.jsx(
    ANe,
    {
      client: e,
      widgetCore: {
        isMobile: t,
        isApp: n,
        toggleSpinner: s,
        onError: o,
        onScrollLock: c
      },
      projectId: r,
      page: u,
      commissions: L,
      onClickCommissionRequestButtonClick: E,
      onAccountSettingsButtonClick: m,
      onIntegratedPaidServiceTermsTextClick: y,
      onClickPersonalInfoOutsourcing: b,
      onClickThirdPartyConsent: w,
      onClickInicisTerms: k,
      onGoToCommissionDetailButtonClick: j,
      onGoToCommissionFaqButtonClick: T,
      onCommissionInquiryButtonClick: D
    }
  );
}
class Jje extends Ol {
  constructor({
    client: t,
    isApp: n,
    isMobile: r,
    projectId: s,
    onError: o,
    onScrollLock: c,
    toggleSpinner: u,
    page: m,
    onClickCommissionRequestButtonClick: y,
    onAccountSettingsButtonClick: b,
    onIntegratedPaidServiceTermsTextClick: w,
    onClickPersonalInfoOutsourcing: k,
    onClickThirdPartyConsent: j,
    onClickInicisTerms: E,
    onGoToCommissionDetailButtonClick: T,
    onGoToCommissionFaqButtonClick: D,
    onCommissionInquiryButtonClick: L
  }) {
    super({
      client: t,
      isApp: n,
      isMobile: r,
      onError: o,
      onScrollLock: c,
      toggleSpinner: u
    }), this.render = (I) => {
      go(I).render(
        /* @__PURE__ */ a.jsx(
          INe,
          {
            client: this.client,
            isMobile: this.isMobile,
            isApp: this.isApp,
            projectId: this.projectId,
            toggleSpinner: this.toggleSpinner,
            onError: this.onError,
            page: this.page,
            onScrollLock: this.onScrollLock,
            onClickCommissionRequestButtonClick: this.onClickCommissionRequestButtonClick,
            onAccountSettingsButtonClick: this.onAccountSettingsButtonClick,
            onIntegratedPaidServiceTermsTextClick: this.onIntegratedPaidServiceTermsTextClick,
            onClickPersonalInfoOutsourcing: this.onClickPersonalInfoOutsourcing,
            onClickThirdPartyConsent: this.onClickThirdPartyConsent,
            onClickInicisTerms: this.onClickInicisTerms,
            onGoToCommissionDetailButtonClick: this.onGoToCommissionDetailButtonClick,
            onGoToCommissionFaqButtonClick: this.onGoToCommissionFaqButtonClick,
            onCommissionInquiryButtonClick: this.onCommissionInquiryButtonClick
          }
        )
      );
    }, this.projectId = s, this.page = m, this.onClickCommissionRequestButtonClick = y, this.onAccountSettingsButtonClick = b, this.onClickPersonalInfoOutsourcing = k, this.onClickThirdPartyConsent = j, this.onClickInicisTerms = E, this.onGoToCommissionDetailButtonClick = T, this.onGoToCommissionFaqButtonClick = D, this.onCommissionInquiryButtonClick = L, this.onIntegratedPaidServiceTermsTextClick = w;
  }
}
function FNe({
  commissionRequestId: e,
  show: t,
  onClose: n,
  client: r,
  ...s
}) {
  Al([
    [ol, r],
    [ll, s]
  ]);
  const {
    widgetCore: { onError: o, toggleSpinner: c }
  } = Gt(), { commissionRequest: u, setCommissionRequest: m } = f_();
  return an(() => {
    t && (async () => {
      c(!0);
      const { code: y, data: b } = await nK(
        {
          commissionRequestId: e
        },
        {
          client: r,
          onError: o
        }
      );
      if (c(!1), y === le.TokenExpired)
        return o(Ht);
      m(b);
    })();
  }, [t]), /* @__PURE__ */ a.jsx(
    Zu,
    {
      show: !!u && t,
      onClose: n,
      afterLeave: () => {
        m(null);
      },
      children: /* @__PURE__ */ a.jsx(
        aK,
        {
          isClient: !0,
          onClose: n
        }
      )
    }
  );
}
class e9e extends Ol {
  constructor({ commissionRequestId: t, show: n, onClose: r, ...s }) {
    super(s), this.render = (o) => {
      this.root || (this.root = go(o)), this.update();
    }, this.update = () => {
      this.root && this.root.render(
        /* @__PURE__ */ a.jsx(
          FNe,
          {
            client: this.client,
            isMobile: this.isMobile,
            isApp: this.isApp,
            toggleSpinner: this.toggleSpinner,
            onScrollLock: this.onScrollLock,
            onError: this.onError,
            onClose: this.onClose,
            commissionRequestId: this.commissionRequestId,
            show: this.show
          }
        )
      );
    }, this.commissionRequestId = t, this.show = n, this.onClose = r;
  }
  setShow(t) {
    this.show = t, this.update();
  }
}
const UNe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M19.25 13.62C19.25 17.41 16.17 20.5 12.37 20.5C8.57 20.5 5.5 17.42 5.5 13.62C5.5 9.82 8.58 6.74 12.38 6.74C12.99 6.74 13.57 6.84 14.13 6.99L11.13 9.99L12.19 11.05L15.25 7.99C16.06 7.18 16.06 5.86 15.25 5.04L12.18 2L11.12 3.06L13.38 5.32C13.05 5.28 12.72 5.25 12.37 5.25C7.75 5.25 4 9 4 13.62C4 18.24 7.75 22 12.38 22C17.01 22 20.76 18.25 20.76 13.62H19.25Z" })), zNe = yn(UNe), wK = Qt(null), BNe = () => {
  const [e, t] = Ar(
    wK
  );
  return {
    managementDaoUsers: e,
    setManagementDaoUsers: t
  };
}, HNe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24, rx: 12, fill: "#323239CC" }), /* @__PURE__ */ re.createElement("path", { d: "M10.3606 6H7.06811C6.95313 6 6.84674 6.06088 6.78849 6.16002L4.04518 10.8291C3.91816 11.0452 4.07405 11.3177 4.3248 11.3177H7.21703C7.32494 11.3177 7.42578 11.264 7.48605 11.1745L10.6297 6.50543C10.7747 6.29002 10.6203 6 10.3606 6Z", fill: "#currentColor" }), /* @__PURE__ */ re.createElement("path", { d: "M14.5349 11.3176C14.7946 11.3176 14.949 11.0276 14.804 10.8122L12.269 7.04722C12.1405 6.8563 11.8595 6.8563 11.731 7.04722L9.19605 10.8122C9.05101 11.0276 9.20537 11.3176 9.46506 11.3176H14.5349Z", fill: "#currentColor" }), /* @__PURE__ */ re.createElement("path", { d: "M19.9548 10.8291L17.2115 6.16002C17.1533 6.06088 17.0469 6 16.9319 6H13.6393C13.3797 6 13.2253 6.29002 13.3703 6.50543L16.514 11.1745C16.5742 11.264 16.6751 11.3177 16.783 11.3177H19.6752C19.9259 11.3177 20.0818 11.0453 19.9548 10.8291Z", fill: "#currentColor" }), /* @__PURE__ */ re.createElement("path", { d: "M9.12815 12.5338C8.89528 12.5338 8.7383 12.772 8.83011 12.986L11.702 20.1277C11.8143 20.3896 12.1857 20.3896 12.298 20.1277L15.1699 12.986C15.2617 12.772 15.1047 12.5338 14.8718 12.5338H9.12815Z", fill: "#currentColor" }), /* @__PURE__ */ re.createElement("path", { d: "M14.8856 18.5962L19.9138 13.0776C20.1049 12.8696 19.9574 12.5338 19.6751 12.5338H16.9015C16.7718 12.5338 16.6546 12.6111 16.6034 12.7302L14.3488 18.2489C14.2049 18.5842 14.6387 18.8648 14.8856 18.5962Z", fill: "#currentColor" }), /* @__PURE__ */ re.createElement("path", { d: "M9.11439 18.5962L4.08617 13.0776C3.89509 12.8697 4.04257 12.5338 4.32494 12.5338H7.09853C7.22821 12.5338 7.34544 12.6111 7.39657 12.7303L9.65121 18.2489C9.79506 18.5842 9.3613 18.8648 9.11439 18.5962Z", fill: "#currentColor" })), VNe = yn(HNe), $Ne = 3, eV = (e, t) => Qu(
  e,
  parseFloat,
  (n) => n * t,
  kc,
  Math.ceil,
  String
);
function GNe({
  src: e,
  alt: t = "",
  width: n,
  height: r,
  multiplicationFactor: s = $Ne,
  objectFit: o,
  ...c
}) {
  const u = new URLSearchParams();
  n && u.append("width", eV(n, s)), r && u.append("height", eV(r, s));
  const m = u.toString(), y = `${e}${m ? `?${m}` : ""}`;
  return /* @__PURE__ */ a.jsx(
    "img",
    {
      ...c,
      src: y,
      alt: t,
      className: "size-full",
      style: {
        objectFit: o
      }
    }
  );
}
const WNe = {
  xs: {
    container: "1.25rem",
    image: "1.25rem",
    border: "1px"
  },
  sm: {
    container: "1.75rem",
    image: "1.75rem",
    border: "1px"
  },
  md: {
    container: "2.5rem",
    image: "2.125rem",
    border: "1px"
  },
  lg: {
    container: "3.125rem",
    image: "2.875rem",
    border: "1px"
  },
  xl: {
    container: "6.25rem",
    image: "5.625rem",
    border: "2px"
  },
  xxl: {
    container: "7.5rem",
    image: "6.9rem",
    border: "2px"
  }
}, YNe = {
  xs: "-top-[0.13rem] -right-[0.13rem]",
  sm: "-top-[0.13rem] -right-[0.13rem]",
  md: "-top-[0.12rem] -right-[0.12rem]",
  lg: "-top-[0.25rem] -right-[0.25rem]",
  xl: "top-[0.13rem] right-[0.13rem]",
  xxl: "top-[0.13rem] right-[0.13rem]"
}, qNe = {
  xs: "size-[0.625rem]",
  sm: "size-3",
  md: "size-4",
  lg: "size-5",
  xl: "size-6",
  xxl: "size-8"
};
function KA({ imageUrl: e, size: t, membershipBadgeColor: n }) {
  const r = WNe[t];
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: "flex-center relative",
      style: {
        width: r.container,
        height: r.container,
        minWidth: r.container
      },
      children: [
        /* @__PURE__ */ a.jsx(
          "div",
          {
            className: "shrink-0 overflow-hidden rounded-full",
            style: {
              width: r.image,
              height: r.image
            },
            children: /* @__PURE__ */ a.jsx(
              GNe,
              {
                width: r.image,
                height: r.image,
                objectFit: "cover",
                src: e
              }
            )
          }
        ),
        n && /* @__PURE__ */ a.jsx(
          VNe,
          {
            className: $(
              qNe[t],
              YNe[t],
              "absolute rounded-full backdrop-blur-[10px]"
            ),
            style: { color: n }
          }
        )
      ]
    }
  );
}
const KNe = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M18.1052 8.41504L12.4502 13.98L12.4202 14.01C12.2702 14.16 12.0302 14.16 11.8802 14.01L6.33016 8.53504L6.21016 8.41504L5.16016 9.46504L10.8452 15.045C11.2052 15.405 11.6852 15.585 12.1652 15.585C12.6452 15.585 13.1252 15.405 13.4852 15.045L19.0352 9.58504L19.1702 9.45004L18.1052 8.41504Z" })), XNe = yn(KNe);
function QNe({ children: e, ...t }) {
  return /* @__PURE__ */ a.jsx(
    NO,
    {
      ...t,
      className: "typo-r1 flex h-12 w-full items-center justify-between gap-x-3 rounded-lg border border-ciety-dk-95 bg-ciety-dk-95 pl-4 pr-3 text-start text-ciety-gy outline-none hover:border-ciety-dk-60 data-[open]:border-ciety-dk-60 data-[disabled]:bg-ciety-dk data-[disabled]:text-ciety-dk-80",
      children: (n) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        typeof e == "function" ? e(n) : e,
        /* @__PURE__ */ a.jsx(
          XNe,
          {
            className: $(
              { "-rotate-180": n.open },
              n.disabled ? "fill-ciety-dk-80" : "fill-ciety-gy",
              "size-6 flex-shrink-0"
            )
          }
        )
      ] })
    }
  );
}
function ZNe({ children: e, ...t }) {
  return /* @__PURE__ */ a.jsx(
    EO,
    {
      ...t,
      className: "typo-r1 flex h-12 cursor-pointer items-center bg-ciety-dk-95 px-4 text-ciety-wh hover:bg-ciety-dk-90 data-[focus]:bg-ciety-dk-90",
      children: (n) => /* @__PURE__ */ a.jsx(a.Fragment, { children: typeof e == "function" ? e(n) : e })
    }
  );
}
function JNe({
  children: e,
  anchor: t = "bottom",
  height: n,
  ...r
}) {
  return /* @__PURE__ */ a.jsx(
    jO,
    {
      ...r,
      anchor: t,
      className: $(
        "typo-r1 twp w-[var(--button-width)] overflow-auto rounded-lg border border-ciety-dk-95 outline-none scrollbar-hide [--anchor-gap:0.5rem]",
        { "[--anchor-max-height:19.75rem]": !n }
      ),
      style: {
        height: n,
        zIndex: Tc.GLOBAL.LIST_BOX
      },
      children: (s) => /* @__PURE__ */ a.jsx(a.Fragment, { children: typeof e == "function" ? e(s) : e })
    }
  );
}
function CK({ planName: e }) {
  return /* @__PURE__ */ a.jsx("div", { className: "typo-r2 flex-center h-8 w-fit shrink-0 rounded bg-ciety-dk-90 px-3 text-ciety-wh backdrop-blur-[5px]", children: e });
}
const eje = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M9.06 21L16.34 13.59C17.22 12.71 17.22 11.29 16.34 10.41L9.06 3L8 4.06L15.28 11.47C15.57 11.76 15.57 12.24 15.28 12.53L8 19.94L9.06 21Z" })), tje = yn(eje), nje = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M14.94 21L7.66 13.59C6.78 12.71 6.78 11.29 7.66 10.41L14.94 3L16 4.06L8.72 11.47C8.43 11.76 8.43 12.24 8.72 12.53L16 19.94L14.94 21Z" })), rje = yn(nje), aje = {
  prev: /* @__PURE__ */ a.jsx(rje, { className: "size-4" }),
  next: /* @__PURE__ */ a.jsx(tje, { className: "size-4" })
};
function tV({ variant: e, onClick: t, disabled: n }) {
  return /* @__PURE__ */ a.jsx(
    "button",
    {
      type: "button",
      onClick: t,
      disabled: n,
      className: $(
        "size-7 rounded-full p-[0.375rem]",
        n ? "text-ciety-dk-90" : "text-ciety-wh hover:bg-ciety-dk-90"
      ),
      children: aje[e]
    }
  );
}
function sje({ isSelected: e, onClick: t, children: n }) {
  return /* @__PURE__ */ a.jsx(
    "button",
    {
      type: "button",
      onClick: t,
      className: $(
        "typo-r1 size-7",
        e ? "text-ciety-lg" : "text-ciety-dk-60"
      ),
      children: n
    }
  );
}
const ije = (e, t) => Math.floor((e - 1) / t) * t + 1;
function oje({ windowSize: e = 5, count: t, onChange: n, page: r }) {
  const s = ije(r, e), o = n$(ow(s, t + 1)).take(e).toArray(), c = r <= 1, u = r >= t;
  return /* @__PURE__ */ a.jsxs("div", { className: "inline-flex items-center gap-x-3", children: [
    /* @__PURE__ */ a.jsx(
      tV,
      {
        variant: "prev",
        onClick: (m) => n(m, r - 1),
        disabled: c
      }
    ),
    /* @__PURE__ */ a.jsx("div", { className: "flex gap-x-2", children: o.map((m) => /* @__PURE__ */ a.jsx(
      sje,
      {
        onClick: (y) => n(y, m),
        isSelected: m === r,
        children: m
      },
      m
    )) }),
    /* @__PURE__ */ a.jsx(
      tV,
      {
        variant: "next",
        onClick: (m) => n(m, r + 1),
        disabled: u
      }
    )
  ] });
}
const Y7 = wp(), lje = {
  JoinedAt: "joinedAt",
  LastActiveAt: "lastActiveAt"
}, m9 = {
  by: lje.JoinedAt,
  order: ws.Desc
}, cje = 10;
function uje({
  fetchedManagementDaoUsers: e,
  ...t
}) {
  Al([
    [ol, t.client],
    [R1, t.projectId],
    [wK, e],
    [
      ll,
      {
        isMobile: t.isMobile,
        isApp: t.isApp,
        toggleSpinner: t.toggleSpinner,
        onError: t.onError,
        onScrollLock: t.onScrollLock
      }
    ]
  ]);
  const [n, r] = Re(!1), { managementDaoUsers: s, setManagementDaoUsers: o } = BNe();
  wt(s);
  const { projectId: c } = Tf(), {
    widgetCore: { onError: u }
  } = Gt(), { client: m } = Ha(), [y, b] = Re(1), [w, k] = Re(m9), [j, E] = Re(null), T = Rt(null), D = s.totalPage > 1, L = s.totalCount === 0, I = async (Q) => {
    b(Q), await H({ page: Q, sort: w });
  }, R = async ({ by: Q }) => {
    const Z = w.by === Q ? {
      ...w,
      order: w.order === ws.Asc ? ws.Desc : ws.Asc
    } : { by: Q, order: ws.Desc };
    await H({
      page: y,
      sort: {
        order: Z.order,
        by: Z.by
      },
      membershipId: j == null ? void 0 : j.id
    }), k(Z);
  }, U = async (Q) => {
    b(1), E(Q), k(m9), await H({
      membershipId: Q.id,
      page: 1
    });
  }, z = async () => {
    E(null), b(1), k(m9), await H({
      page: 1
    });
  }, H = async ({
    page: Q,
    sort: Z,
    membershipId: X
  }) => {
    var te;
    if (n)
      return;
    r(!0);
    const se = await WA(
      I2({
        membershipId: X,
        projectId: c,
        size: cje,
        sort: Z,
        page: Q
      }),
      {
        client: m,
        onError: u
      }
    );
    switch (r(!1), se.code) {
      case le.Success:
        o(se.data), (te = T.current) == null || te.scrollTo(0, 0);
        return;
      case le.TokenExpired:
        return u(Ht);
    }
  }, K = [
    Y7.accessor("joinedAt", {
      header: "커뮤니티 가입일",
      cell: (Q) => jt(Q.getValue(), "yyyy.MM.dd"),
      size: 128
    }),
    Y7.accessor("lastActiveAt", {
      header: "마지막 접속일",
      cell: (Q) => jt(Q.getValue(), "yyyy.MM.dd"),
      size: 128
    }),
    Y7.accessor("user", {
      header: "마플샵 닉네임",
      cell: (Q) => /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-2", children: [
        /* @__PURE__ */ a.jsx("div", { className: "size-7 flex-shrink-0", children: /* @__PURE__ */ a.jsx(
          Ql,
          {
            imageUrl: Xu(Q.getValue())
          }
        ) }),
        /* @__PURE__ */ a.jsx("span", { className: "line-clamp-1 break-all", children: Mc(Q.getValue()) })
      ] }),
      size: 240,
      enableSorting: !1
    }),
    Y7.accessor(
      (Q) => {
        var Z;
        return wt(Q.imageUrl), /* @__PURE__ */ a.jsxs("div", { className: "flex w-fit items-center gap-x-2", children: [
          /* @__PURE__ */ a.jsx("div", { className: "size-7 flex-shrink-0", children: /* @__PURE__ */ a.jsx(
            KA,
            {
              imageUrl: Q.imageUrl,
              size: "sm",
              membershipBadgeColor: (Z = Q.plans.find(({ role: X }) => X.isPrimary)) == null ? void 0 : Z.role.displayColor
            }
          ) }),
          /* @__PURE__ */ a.jsx(
            "button",
            {
              type: "button",
              className: "line-clamp-1 break-all underline",
              onClick: () => t.onCommunityNicknameClick(Q.id),
              children: Q.state === Sy.Delete ? "비활성화 계정" : Q.nickname
            }
          )
        ] });
      },
      {
        header: "커뮤니티 닉네임",
        enableSorting: !1,
        cell: (Q) => Q.getValue()
      }
    ),
    Y7.accessor("plans", {
      header: "멤버십 플랜 / 커뮤니티 그룹",
      cell: (Q) => {
        const Z = Q.getValue();
        return /* @__PURE__ */ a.jsx("div", { className: "flex w-full flex-wrap items-center gap-x-4 gap-y-1", children: Z.map((X) => /* @__PURE__ */ a.jsxs(
          "div",
          {
            className: "flex items-center gap-x-1",
            children: [
              /* @__PURE__ */ a.jsx(CK, { planName: X.membership.displayName }),
              /* @__PURE__ */ a.jsxs(
                "div",
                {
                  className: "typo-r2 flex-center gap-x-1 rounded-[62.4375rem] bg-ciety-dk-95 px-3 py-[0.375rem]",
                  style: { color: `#${X.role.displayColor}` },
                  children: [
                    /* @__PURE__ */ a.jsx(
                      JE,
                      {
                        className: "size-3 shrink-0",
                        style: { color: `#${X.role.displayColor}` }
                      }
                    ),
                    X.role.displayName
                  ]
                }
              )
            ]
          },
          X.membership.id
        )) });
      },
      size: 864,
      enableSorting: !1
    })
  ], q = Np({
    columns: K,
    data: s.items,
    getCoreRowModel: Cp(),
    getSortedRowModel: j5()
  });
  return /* @__PURE__ */ a.jsxs("div", { className: "flex w-full flex-col", children: [
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-3", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex items-stretch gap-x-4", children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-1", children: [
          /* @__PURE__ */ a.jsx("span", { className: "typo-ciety-kr-14-b text-ciety-gy-30", children: "총" }),
          /* @__PURE__ */ a.jsxs("span", { className: "typo-ciety-kr-14-m text-ciety-gy-30", children: [
            Number(s.totalCount).toLocaleString(),
            "명"
          ] })
        ] }),
        /* @__PURE__ */ a.jsx("div", { className: "flex flex-1 justify-end", children: /* @__PURE__ */ a.jsxs("div", { className: "flex items-center gap-x-3", children: [
          /* @__PURE__ */ a.jsx("div", { className: "typo-ciety-kr-16-m w-full text-ciety-gy-10", children: "멤버십 플랜" }),
          /* @__PURE__ */ a.jsxs(
            yp,
            {
              value: j,
              onChange: (Q) => U(Q),
              children: [
                /* @__PURE__ */ a.jsx(QNe, { children: /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: $("w-[17.5rem]", {
                      "text-ciety-dk-60": !j
                    }),
                    children: j ? j.displayName : "멤버십 플랜별로 보기"
                  }
                ) }),
                /* @__PURE__ */ a.jsx(JNe, { children: s.memberships.map((Q) => /* @__PURE__ */ a.jsx(ZNe, { value: Q, children: Q.displayName }, Q.id)) })
              ]
            }
          )
        ] }) }),
        /* @__PURE__ */ a.jsx(
          "button",
          {
            type: "button",
            onClick: z,
            className: "shrink-0 rounded-lg bg-ciety-dk-80 px-3",
            children: /* @__PURE__ */ a.jsx(zNe, { className: "size-6 text-ciety-gy-10" })
          }
        )
      ] }),
      /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: "overflow-auto rounded-lg border border-ciety-dk-90 scrollbar-hide",
          ref: T,
          children: [
            /* @__PURE__ */ a.jsxs("table", { className: "w-full", children: [
              /* @__PURE__ */ a.jsx("thead", { children: q.getHeaderGroups().map((Q) => /* @__PURE__ */ a.jsx(
                "tr",
                {
                  className: "typo-ciety-kr-14-m h-14 border-b border-ciety-dk-90 bg-ciety-dk-90 text-ciety-gy-10",
                  children: Q.headers.map((Z) => /* @__PURE__ */ a.jsx(
                    "th",
                    {
                      style: {
                        minWidth: Z.getSize()
                      },
                      children: /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-2 p-2", children: [
                        Gi(
                          Z.column.columnDef.header,
                          Z.getContext()
                        ),
                        Z.column.getCanSort() && /* @__PURE__ */ a.jsx(
                          "button",
                          {
                            type: "button",
                            className: "block size-4",
                            onClick: async () => {
                              await R({
                                by: Z.column.id
                              });
                            },
                            children: /* @__PURE__ */ a.jsx(t0, { className: "size-full fill-ciety-wh" })
                          }
                        )
                      ] })
                    },
                    Z.id
                  ))
                },
                Q.id
              )) }),
              !L && /* @__PURE__ */ a.jsx("tbody", { children: q.getRowModel().rows.map((Q) => /* @__PURE__ */ a.jsx(
                "tr",
                {
                  className: "border-b border-ciety-dk-90 bg-ciety-dk",
                  children: Q.getVisibleCells().map((Z) => /* @__PURE__ */ a.jsx("td", { children: /* @__PURE__ */ a.jsx("div", { className: "flex-center min-h-[4.5rem] p-2 text-ciety-gy-10", children: Gi(
                    Z.column.columnDef.cell,
                    Z.getContext()
                  ) }) }, Z.id))
                },
                Q.id
              )) })
            ] }),
            L && /* @__PURE__ */ a.jsx("div", { className: "flex-center typo-r2 h-[37.5rem] text-ciety-dk-60", children: "멤버십 회원 내역이 없습니다." })
          ]
        }
      )
    ] }),
    D && /* @__PURE__ */ a.jsx("div", { className: "flex-center mt-10", children: /* @__PURE__ */ a.jsx(
      oje,
      {
        count: s.totalPage,
        onChange: (Q, Z) => I(Z),
        page: y
      }
    ) })
  ] });
}
function dje({
  projectId: e,
  onCommunityNicknameClick: t,
  ...n
}) {
  const [r, s] = Re(!0), [o, c] = Re();
  return an(() => {
    (async () => {
      const u = await WA(
        {
          projectId: e,
          size: 10,
          page: 1,
          sort: m9
        },
        {
          client: n.client,
          onError: n.onError
        }
      );
      switch (s(!1), u.code) {
        case le.Success:
          c(u.data);
          return;
        case le.TokenExpired:
          return n.onError(Ht);
      }
    })();
  }, []), r || !o ? null : /* @__PURE__ */ a.jsx(lw, { store: X2(), children: /* @__PURE__ */ a.jsx(
    uje,
    {
      projectId: e,
      fetchedManagementDaoUsers: o,
      onCommunityNicknameClick: t,
      ...n
    }
  ) });
}
class t9e extends Ol {
  constructor({
    projectId: t,
    onCommunityNicknameClick: n,
    ...r
  }) {
    super(r), this.render = (s) => go(s).render(
      /* @__PURE__ */ a.jsx(
        dje,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onScrollLock: this.onScrollLock,
          onError: this.onError,
          projectId: this.projectId,
          onCommunityNicknameClick: this.onCommunityNicknameClick
        }
      )
    ), this.projectId = t, this.onCommunityNicknameClick = n;
  }
}
const q7 = wp(), fje = [
  q7.accessor(
    (e) => `${jt(e.startTimeAt, "yyyy.MM.dd")}${e.endTimeAt ? ` ~ ${jt(e.endTimeAt, "yyyy.MM.dd")}` : ""}`,
    {
      header: "결제일 ~ 이용기간",
      cell: (e) => e.getValue(),
      size: 242,
      sortingFn: (e, t) => {
        const n = new Date(e.original.startTimeAt).getTime();
        return new Date(t.original.startTimeAt).getTime() - n;
      }
    }
  ),
  q7.accessor("membership.displayName", {
    header: "멤버십 플랜",
    cell: (e) => e.getValue(),
    enableSorting: !1,
    size: 242
  }),
  q7.accessor("membership.streakCount", {
    header: "회차",
    cell: (e) => e.getValue(),
    size: 96,
    enableSorting: !1
  }),
  q7.accessor("paymentState", {
    header: "상태",
    cell: (e) => I8(e.getValue()),
    size: 96,
    enableSorting: !1
  }),
  q7.accessor(
    (e) => /* @__PURE__ */ a.jsxs("span", { children: [
      e.paymentState === S1.Cancelled && /* @__PURE__ */ a.jsx(a.Fragment, { children: "-" }),
      e.price.toLocaleString(),
      "원"
    ] }),
    {
      header: "결제 금액",
      cell: (e) => e.getValue(),
      size: 128,
      enableSorting: !1
    }
  )
];
function mje({ fetchedMembershipInfo: e, ...t }) {
  var o;
  Al([
    [ol, t.client],
    [zq, e],
    [
      ll,
      {
        isMobile: t.isMobile,
        isApp: t.isApp,
        toggleSpinner: t.toggleSpinner,
        onError: t.onError,
        onScrollLock: t.onScrollLock
      }
    ]
  ]);
  const { managementDaoUser: n } = BA();
  wt(n), wt(n.imageUrl);
  const r = Np({
    columns: fje,
    data: n.statements,
    getCoreRowModel: Cp(),
    getSortedRowModel: j5()
  }), s = n.statements.length === 0;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: s ? /* @__PURE__ */ a.jsx("div", { className: "flex-center typo-r0 size-full text-ciety-dk-60", children: /* @__PURE__ */ a.jsx("div", { children: "멤버십 가입 정보가 없습니다." }) }) : /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "flex w-full flex-col",
        t.isMobile ? "gap-y-[2.5rem]" : "gap-y-5"
      ),
      children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-3", children: [
          /* @__PURE__ */ a.jsx(
            KA,
            {
              imageUrl: n.imageUrl,
              size: "xl",
              membershipBadgeColor: (o = n.plans.find(({ role: c }) => c.isPrimary)) == null ? void 0 : o.role.displayColor
            }
          ),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col justify-center gap-y-2", children: [
            /* @__PURE__ */ a.jsxs("div", { children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-m1 text-ciety-wh", children: n.nickname }),
              /* @__PURE__ */ a.jsx("div", { className: "typo-r2 text-ciety-dk-60", children: n.mcoAccount.email })
            ] }),
            /* @__PURE__ */ a.jsx(
              "div",
              {
                className: $(
                  "flex gap-1",
                  t.isMobile ? "flex-col" : "flex-wrap"
                ),
                children: n.plans.map(({ membership: c }) => /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: "flex-center typo-r3 h-8 w-fit rounded bg-ciety-dk-90 px-3 text-ciety-wh backdrop-blur-[5px]",
                    children: c.displayName
                  },
                  c.id
                ))
              }
            )
          ] })
        ] }),
        t.isMobile ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-2 rounded-xl border border-ciety-dk-90 p-6", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "마플샵 닉네임" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: n.mcoAccount.displayName })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "커뮤니티 가입일" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: jt(n.joinedAt, "yyyy.MM.dd") })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "마지막 접속일" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: jt(n.lastActiveAt, "yyyy.MM.dd") })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "멤버십 그룹" }),
            /* @__PURE__ */ a.jsx("div", { children: n.plans.length === 0 ? /* @__PURE__ */ a.jsx("span", { className: "text-ciety-gy", children: "-" }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: n.plans.map(({ role: c }) => /* @__PURE__ */ a.jsx(
              "span",
              {
                className: "typo-r2 line-clamp-1 break-all text-ciety-gy",
                children: c.displayName
              },
              c.id
            )) }) })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "멤버십 플랜" }),
            /* @__PURE__ */ a.jsx("div", { children: n.memberships.map((c) => /* @__PURE__ */ a.jsxs("div", { className: "typo-r2 flex text-ciety-gy", children: [
              /* @__PURE__ */ a.jsx(
                "span",
                {
                  className: "line-clamp-1 break-all",
                  children: c.displayName
                },
                c.id
              ),
              " ",
              c.status === U3.Expired && /* @__PURE__ */ a.jsx("span", { className: "shrink-0", children: "(해지)" })
            ] })) })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "총 결제 금액" }),
            /* @__PURE__ */ a.jsx("div", { children: n.memberships.map((c) => /* @__PURE__ */ a.jsxs(
              "span",
              {
                className: "typo-r2 line-clamp-1 break-all text-ciety-gy",
                children: [
                  c.totalPrice.toLocaleString(),
                  " 원"
                ]
              },
              c.id
            )) })
          ] })
        ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-4 rounded-xl border border-ciety-dk-90 p-6", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-6", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "마플샵 닉네임" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: n.mcoAccount.displayName })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "커뮤니티 가입일" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: jt(n.joinedAt, "yyyy.MM.dd") })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-6", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "멤버십 그룹" }),
              /* @__PURE__ */ a.jsx("div", { children: n.plans.length === 0 ? /* @__PURE__ */ a.jsx("span", { className: "text-ciety-gy", children: "-" }) : /* @__PURE__ */ a.jsx(a.Fragment, { children: n.plans.map(({ role: c }) => /* @__PURE__ */ a.jsx(
                "span",
                {
                  className: "typo-r2 line-clamp-1 break-all text-ciety-gy",
                  children: c.displayName
                },
                c.id
              )) }) })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "마지막 접속일" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: jt(n.lastActiveAt, "yyyy.MM.dd") })
            ] })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-6", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "멤버십 플랜" }),
              /* @__PURE__ */ a.jsx("div", { children: n.memberships.map((c) => /* @__PURE__ */ a.jsxs("div", { className: "typo-r2 flex text-ciety-gy", children: [
                /* @__PURE__ */ a.jsx(
                  "span",
                  {
                    className: "line-clamp-1 break-all",
                    children: c.displayName
                  },
                  c.id
                ),
                " ",
                c.status === U3.Expired && /* @__PURE__ */ a.jsx("span", { className: "shrink-0", children: "(해지)" })
              ] })) })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "총 결제 금액" }),
              /* @__PURE__ */ a.jsx("div", { children: n.memberships.map((c) => /* @__PURE__ */ a.jsxs(
                "span",
                {
                  className: "typo-r2 line-clamp-1 break-all text-ciety-gy",
                  children: [
                    c.totalPrice.toLocaleString(),
                    " 원"
                  ]
                },
                c.id
              )) })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ a.jsx("div", { className: "w-full overflow-hidden rounded border border-ciety-dk-90", children: /* @__PURE__ */ a.jsx("div", { className: "overflow-x-auto scrollbar-hide", children: /* @__PURE__ */ a.jsxs("table", { className: "w-max min-w-full", children: [
          /* @__PURE__ */ a.jsx("thead", { children: r.getHeaderGroups().map((c) => /* @__PURE__ */ a.jsx(
            "tr",
            {
              className: "typo-m3 h-8 border-b border-ciety-dk-90 bg-ciety-dk-95 text-ciety-wh",
              children: c.headers.map((u) => /* @__PURE__ */ a.jsx(
                "th",
                {
                  style: {
                    width: u.getSize()
                  },
                  children: /* @__PURE__ */ a.jsxs("div", { className: "flex-center gap-x-2 px-2", children: [
                    Gi(
                      u.column.columnDef.header,
                      u.getContext()
                    ),
                    u.column.getCanSort() && /* @__PURE__ */ a.jsx(
                      "button",
                      {
                        type: "button",
                        className: "block size-3",
                        onClick: () => {
                          u.column.toggleSorting(
                            u.column.getNextSortingOrder() === "desc"
                          );
                        },
                        children: /* @__PURE__ */ a.jsx(t0, { className: "size-full fill-ciety-wh" })
                      }
                    )
                  ] })
                },
                u.id
              ))
            },
            c.id
          )) }),
          /* @__PURE__ */ a.jsx("tbody", { children: r.getRowModel().rows.map((c) => /* @__PURE__ */ a.jsx(
            "tr",
            {
              className: "typo-r2 h-10 border-b border-ciety-dk-95 text-ciety-gy",
              children: c.getVisibleCells().map((u) => /* @__PURE__ */ a.jsx("td", { children: /* @__PURE__ */ a.jsx("div", { className: "flex-center px-2", children: Gi(
                u.column.columnDef.cell,
                u.getContext()
              ) }) }, u.id))
            },
            c.id
          )) })
        ] }) }) })
      ]
    }
  ) });
}
function hje({ projectId: e, memberId: t, ...n }) {
  const [r, s] = Re(!0), [o, c] = Re();
  return an(() => {
    (async () => {
      const u = await dP(
        {
          projectId: e,
          memberId: t
        },
        { client: n.client, onError: n.onError }
      );
      switch (s(!1), u.code) {
        case le.Success:
          c(u.data);
          return;
        case le.TokenExpired:
          return n.onError(Ht);
      }
    })();
  }, []), r || !o ? null : /* @__PURE__ */ a.jsx(lw, { store: X2(), children: /* @__PURE__ */ a.jsx(
    mje,
    {
      fetchedMembershipInfo: o,
      ...n
    }
  ) });
}
class n9e extends Ol {
  constructor({ projectId: t, memberId: n, ...r }) {
    super(r), this.render = (s) => go(s).render(
      /* @__PURE__ */ a.jsx(
        hje,
        {
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onScrollLock: this.onScrollLock,
          onError: this.onError,
          projectId: this.projectId,
          memberId: this.memberId
        }
      )
    ), this.projectId = t, this.memberId = n;
  }
}
const pje = (e, t) => jn(
  "/dao-member-summary",
  {
    body: e
  },
  t
).then((n) => {
  switch (n.code) {
    case le.Success:
    case le.TokenExpired:
      return n;
    default:
      throw new Error();
  }
}), NK = Qt(null), gje = () => {
  const [e, t] = Ar(NK);
  return {
    daoMemberSummary: e,
    setDaoMemberSummary: t
  };
}, yje = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("path", { d: "M19.07 12.75L12 19.94L13.06 21L20.34 13.59C21.22 12.71 21.22 11.29 20.34 10.41L13.06 3L12 4.06L19.07 11.25L3 11.25V12.75L19.07 12.75Z" })), vje = yn(yje), xje = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ re.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ re.createElement("title", { id: t }, e) : null, /* @__PURE__ */ re.createElement("g", { clipPath: "url(#clip0_10144_88947)" }, /* @__PURE__ */ re.createElement("path", { d: "M21.54 6.25001C20.7 4.18001 18.8 2.89001 16.57 2.89001C14.69 2.89001 12.95 3.84001 12 5.39001C11.05 3.84001 9.31002 2.89001 7.43002 2.89001C5.21002 2.89001 3.30002 4.18001 2.46002 6.25001C1.90002 7.63001 1.85002 9.12001 2.32002 10.8C2.46002 11.3 2.64002 11.81 2.87002 12.3C3.12002 12.85 3.42002 13.39 3.78002 13.93L3.82002 13.98C4.03002 14.29 4.25002 14.59 4.48002 14.88C6.33002 17.22 8.71002 19.23 11.77 21.05C11.83 21.09 11.91 21.11 12 21.11C12.05 21.11 12.15 21.11 12.23 21.05C15.29 19.24 17.68 17.22 19.52 14.88C19.75 14.59 19.97 14.29 20.18 13.98L20.22 13.91C20.57 13.38 20.88 12.84 21.12 12.29C21.35 11.8 21.53 11.29 21.67 10.79C22.14 9.11001 22.09 7.62001 21.53 6.24001L21.54 6.25001ZM16.37 15.78C15.94 16.2 15.48 16.61 15 17C15.18 16.66 15.35 16.31 15.52 15.96C15.81 15.91 16.09 15.85 16.37 15.78ZM14.31 14.39C12.81 14.58 11.2 14.58 9.70002 14.39C9.24002 13.26 8.93002 12.14 8.76002 10.97V10.95C10.85 11.26 13.16 11.26 15.25 10.95V10.97C15.08 12.14 14.77 13.26 14.31 14.39ZM8.48002 15.96C8.64002 16.31 8.82002 16.66 9.00002 17C8.52002 16.6 8.06002 16.19 7.63002 15.78C7.91002 15.85 8.19002 15.91 8.48002 15.96ZM14.27 5.43001C14.38 5.46001 14.89 5.88001 15.19 7.31001C15.32 7.90001 15.38 8.52001 15.38 9.18001C13.26 9.54001 10.74 9.54001 8.62002 9.18001C8.62002 8.51001 8.68002 7.90001 8.81002 7.31001C9.11002 5.88001 9.62002 5.46001 9.70002 5.43001C9.79002 5.45001 10.21 5.76001 10.51 6.79001L10.58 7.00001C10.77 7.63001 11.35 8.05001 12.01 8.05001C12.67 8.05001 13.24 7.63001 13.44 7.00001L13.51 6.79001C13.81 5.77001 14.24 5.45001 14.29 5.43001H14.27ZM7.10002 6.94001C6.98002 7.52001 6.90002 8.14001 6.88002 8.78001C6.59002 8.69001 6.32002 8.60001 6.07002 8.51001C4.95002 8.08001 4.18002 7.52001 4.06002 7.04001C4.05002 7.00001 4.06002 6.95002 4.07002 6.90001C4.37002 6.16001 4.84002 5.58001 5.46002 5.19001C6.20002 4.72001 7.13002 4.54001 8.02002 4.68001C7.61002 5.24001 7.29002 6.01001 7.09002 6.94001H7.10002ZM6.95002 10.6C6.97002 10.81 7.00002 11.01 7.03002 11.22C7.17002 12.17 7.39002 13.09 7.69002 14C7.24002 13.88 6.82002 13.74 6.43002 13.57C5.61002 13.23 4.94002 12.59 4.55002 11.78L4.52002 11.72C4.49002 11.61 4.45002 11.51 4.40002 11.45C4.24002 11.08 4.10002 10.7 4.00002 10.33C3.90002 9.97001 3.83002 9.62001 3.79002 9.29001C4.57002 9.83001 5.65002 10.28 6.96002 10.6H6.95002ZM16.97 11.22C17 11.01 17.03 10.81 17.05 10.6C18.35 10.27 19.44 9.82001 20.22 9.29001C20.18 9.63001 20.11 9.98001 20.01 10.33C19.91 10.7 19.77 11.08 19.63 11.42C19.56 11.52 19.51 11.62 19.5 11.7L19.46 11.78C19.06 12.59 18.4 13.23 17.56 13.58C17.18 13.74 16.76 13.88 16.31 14C16.62 13.08 16.83 12.17 16.97 11.22ZM20.16 6.81001L19.93 6.90001C19.93 6.90001 19.95 7.00001 19.94 7.04001C19.82 7.51001 19.05 8.08001 17.93 8.51001C17.68 8.61001 17.41 8.70001 17.12 8.78001C17.1 8.14001 17.03 7.52001 16.9 6.94001C16.7 6.01001 16.38 5.23001 15.97 4.67001C16.86 4.53001 17.79 4.71001 18.53 5.18001C19.15 5.58001 19.62 6.15001 19.92 6.89001L20.15 6.80001L20.16 6.81001ZM12 18.53C11.47 17.8 10.99 17.04 10.55 16.22C11.52 16.29 12.48 16.29 13.44 16.22C13 17.04 12.53 17.8 11.99 18.53H12Z" })), /* @__PURE__ */ re.createElement("defs", null, /* @__PURE__ */ re.createElement("clipPath", { id: "clip0_10144_88947" }, /* @__PURE__ */ re.createElement("rect", { width: 24, height: 24 })))), bje = yn(xje), nV = {
  Right: vje,
  Shop: bje,
  Membership: JE
}, Sje = {
  "Small-32": $("typo-m3 h-8 min-w-24 gap-1 rounded-[6.25rem] px-4"),
  "Medium-40": $("typo-m2 h-10 min-w-24 gap-1 rounded-[6.25rem] px-6"),
  "Large-48": $("typo-m1 h-12 gap-2 rounded-[6.25rem] px-10"),
  // @TODO sws: typo token
  "XLarge-56": $("h-14 gap-2 rounded-[6.25rem] px-10")
}, rV = {
  "Small-32": "size-3",
  "Medium-40": "size-4",
  "Large-48": "size-4",
  "XLarge-56": "size-5"
}, wje = {
  WH: $(
    "bg-ciety-wh text-ciety-dk disabled:bg-ciety-dk-90 disabled:text-ciety-dk-60"
  ),
  LG: $(
    "bg-ciety-lg text-ciety-dk disabled:bg-ciety-dk-90 disabled:text-ciety-dk-60"
  ),
  RD: $(
    "bg-ciety-rd text-ciety-wh disabled:bg-ciety-dk-90 disabled:text-ciety-dk-60"
  )
}, Cje = {
  WH: $(
    "border border-ciety-gy text-ciety-wh disabled:border-ciety-dk-80 disabled:text-ciety-dk-80"
  ),
  GY: $(
    "border border-ciety-dk-80 text-ciety-gy disabled:border-ciety-dk-80 disabled:text-ciety-dk-80"
  )
};
function aV({
  children: e,
  size: t,
  styleType: n,
  color: r,
  iconFront: s,
  iconRear: o,
  widthFull: c = !1,
  ...u
}) {
  const m = s ? nV[s] : null, y = o ? nV[o] : null;
  return /* @__PURE__ */ a.jsx(
    pm,
    {
      ...u,
      className: $(
        "inline-flex shrink-0 items-center justify-center",
        Sje[t],
        n === "Fill" ? wje[r] : Cje[r],
        {
          "w-full": c
        }
      ),
      children: (b) => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        m && /* @__PURE__ */ a.jsx(m, { className: rV[t] }),
        /* @__PURE__ */ a.jsx("span", { children: typeof e == "function" ? e(b) : e }),
        y && /* @__PURE__ */ a.jsx(y, { className: rV[t] })
      ] })
    }
  );
}
const Nje = 150, sV = wp(), jje = [
  sV.accessor("membership.streakCount", {
    header: "회차",
    cell: (e) => e.getValue(),
    size: 96
  }),
  sV.accessor(
    (e) => /* @__PURE__ */ a.jsxs("div", { className: "flex w-full gap-x-2", children: [
      /* @__PURE__ */ a.jsx(CK, { planName: e.membership.displayName }),
      /* @__PURE__ */ a.jsxs(
        "div",
        {
          className: "typo-r2 flex-center shrink-0 gap-x-1 rounded-[62.4375rem] bg-ciety-dk-90 px-3 py-[0.375rem]",
          style: { color: `#${e.role.displayColor}` },
          children: [
            /* @__PURE__ */ a.jsx(
              JE,
              {
                className: "size-3 shrink-0",
                style: { color: e.role.displayColor }
              }
            ),
            e.role.displayName
          ]
        }
      )
    ] }),
    {
      header: "멤버십 플랜 / 커뮤니티 그룹",
      cell: (e) => e.getValue()
    }
  )
];
function Eje({
  daoMemberSummaryData: e,
  onJoinMembershipButtonClick: t,
  onShowDetailMembershipButtonClick: n,
  ...r
}) {
  var m;
  Al([
    [ol, r.client],
    [NK, e],
    [
      ll,
      {
        isMobile: r.isMobile,
        isApp: r.isApp,
        toggleSpinner: r.toggleSpinner,
        onError: r.onError,
        onScrollLock: r.onScrollLock
      }
    ]
  ]);
  const { daoMemberSummary: s } = gje();
  wt(s), wt(s.imageUrl);
  const o = Np({
    columns: jje,
    data: s.plans,
    getCoreRowModel: Cp()
  }), c = s.plans.length === 0, u = c && s.memberships.length > 0;
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: c ? /* @__PURE__ */ a.jsx("div", { className: "flex-center size-full", children: /* @__PURE__ */ a.jsxs("div", { className: "flex-col-center items-center gap-y-6 text-center", children: [
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "text-ciety-wh",
          r.isMobile ? "typo-ciety-m1" : "typo-ciety-m0"
        ),
        children: [
          "현재 가입 중인 멤버십이 없어요. ",
          /* @__PURE__ */ a.jsx("br", {}),
          "멤버십에 가입하고 특별한 혜택을 경험해 보세요!"
        ]
      }
    ),
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: $(
          "flex flex-col",
          r.isMobile ? "w-44 gap-y-2" : "w-56 gap-y-3"
        ),
        children: [
          /* @__PURE__ */ a.jsx(
            aV,
            {
              type: "button",
              color: "LG",
              iconFront: "Membership",
              onClick: t,
              size: r.isMobile ? "Medium-40" : "Large-48",
              widthFull: !0,
              styleType: "Fill",
              children: "멤버십 가입하기"
            }
          ),
          u && /* @__PURE__ */ a.jsx(
            aV,
            {
              type: "button",
              color: "WH",
              iconFront: "Shop",
              onClick: n,
              size: r.isMobile ? "Medium-40" : "Large-48",
              styleType: "Fill",
              children: "가입 이력 상세보기"
            }
          )
        ]
      }
    )
  ] }) }) : /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: $(
        "flex flex-col",
        r.isMobile ? "gap-y-[2.5rem]" : "gap-y-5"
      ),
      children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-3", children: [
          /* @__PURE__ */ a.jsx(
            KA,
            {
              imageUrl: s.imageUrl,
              size: "xl",
              membershipBadgeColor: (m = s.plans.find(({ role: y }) => y.isPrimary)) == null ? void 0 : m.role.displayColor
            }
          ),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col justify-center gap-y-2", children: [
            /* @__PURE__ */ a.jsxs("div", { children: [
              /* @__PURE__ */ a.jsx("div", { className: "typo-m1 text-ciety-wh", children: s.nickname }),
              /* @__PURE__ */ a.jsx("div", { className: "typo-r2 text-ciety-dk-60", children: s.mcoAccount.email })
            ] }),
            /* @__PURE__ */ a.jsx(
              "div",
              {
                className: $(
                  "flex gap-1",
                  r.isMobile ? "flex-col" : "flex-wrap"
                ),
                children: s.plans.map(({ membership: y }) => /* @__PURE__ */ a.jsx(
                  "div",
                  {
                    className: "flex-center typo-r3 h-8 w-fit rounded bg-ciety-dk-90 px-3 text-ciety-wh backdrop-blur-[5px]",
                    children: y.displayName
                  },
                  y.id
                ))
              }
            )
          ] })
        ] }),
        r.isMobile ? /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-2 rounded-xl border border-ciety-dk-90 p-6", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "마플샵 닉네임" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: s.mcoAccount.displayName })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "커뮤니티 가입일" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: jt(s.joinedAt, "yyyy.MM.dd") })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "마지막 접속일" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: jt(s.lastActiveAt, "yyyy.MM.dd") })
          ] })
        ] }) : /* @__PURE__ */ a.jsxs("div", { className: "flex flex-col gap-y-4 rounded-xl border border-ciety-dk-90 p-6", children: [
          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-2", children: [
            /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "마플샵 닉네임" }),
            /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: s.mcoAccount.displayName })
          ] }),
          /* @__PURE__ */ a.jsxs("div", { className: "flex gap-x-6", children: [
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "커뮤니티 가입일" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: jt(s.joinedAt, "yyyy.MM.dd") })
            ] }),
            /* @__PURE__ */ a.jsxs("div", { className: "flex flex-1 gap-x-2", children: [
              /* @__PURE__ */ a.jsx("span", { className: "typo-m2 inline-block w-28 flex-shrink-0 text-ciety-wh", children: "마지막 접속일" }),
              /* @__PURE__ */ a.jsx("span", { className: "typo-r2 line-clamp-1 break-all text-ciety-gy", children: jt(s.lastActiveAt, "yyyy.MM.dd") })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ a.jsx("div", { className: "w-full overflow-hidden rounded border border-ciety-dk-90", children: /* @__PURE__ */ a.jsx(
          "div",
          {
            className: $({
              "overflow-x-auto scrollbar-hide": r.isMobile
            }),
            children: /* @__PURE__ */ a.jsxs("table", { className: "w-max min-w-full", children: [
              /* @__PURE__ */ a.jsx("thead", { children: o.getHeaderGroups().map((y) => /* @__PURE__ */ a.jsx(
                "tr",
                {
                  className: "typo-m3 h-8 border-b border-ciety-dk-95 bg-ciety-dk-95 text-ciety-wh",
                  children: y.headers.map((b) => /* @__PURE__ */ a.jsx(
                    "th",
                    {
                      style: {
                        width: b.getSize() === Nje ? "auto" : b.getSize()
                      },
                      children: Gi(
                        b.column.columnDef.header,
                        b.getContext()
                      )
                    },
                    b.id
                  ))
                },
                y.id
              )) }),
              /* @__PURE__ */ a.jsx("tbody", { children: o.getRowModel().rows.map((y) => /* @__PURE__ */ a.jsx(
                "tr",
                {
                  className: "typo-r2 h-12 border-b border-ciety-dk-95 text-ciety-gy",
                  children: y.getVisibleCells().map((b) => /* @__PURE__ */ a.jsx("td", { children: /* @__PURE__ */ a.jsx("div", { className: "flex-center px-1", children: Gi(
                    b.column.columnDef.cell,
                    b.getContext()
                  ) }) }, b.id))
                },
                y.id
              )) })
            ] })
          }
        ) })
      ]
    }
  ) });
}
function kje({
  projectId: e,
  onJoinMembershipButtonClick: t,
  onShowDetailMembershipButtonClick: n,
  ...r
}) {
  const [s, o] = Re(!0), [c, u] = Re();
  return an(() => {
    (async () => {
      const m = await pje(
        {
          projectId: e
        },
        { client: r.client, onError: r.onError }
      );
      switch (o(!1), m.code) {
        case le.Success:
          u(m.data);
          return;
        case le.TokenExpired:
          return r.onError(Ht);
      }
    })();
  }, []), s || !c ? null : /* @__PURE__ */ a.jsx(lw, { store: X2(), children: /* @__PURE__ */ a.jsx(
    Eje,
    {
      daoMemberSummaryData: c,
      onJoinMembershipButtonClick: t,
      onShowDetailMembershipButtonClick: n,
      ...r
    }
  ) });
}
class r9e extends Ol {
  constructor({
    projectId: t,
    onJoinMembershipButtonClick: n,
    onShowDetailMembershipButtonClick: r,
    ...s
  }) {
    super(s), this.render = (o) => go(o).render(
      /* @__PURE__ */ a.jsx(
        kje,
        {
          projectId: this.projectId,
          onJoinMembershipButtonClick: this.onJoinMembershipButtonClick,
          onShowDetailMembershipButtonClick: this.onShowDetailMembershipButtonClick,
          client: this.client,
          isMobile: this.isMobile,
          isApp: this.isApp,
          toggleSpinner: this.toggleSpinner,
          onScrollLock: this.onScrollLock,
          onError: this.onError
        }
      )
    ), this.projectId = t, this.onJoinMembershipButtonClick = n, this.onShowDetailMembershipButtonClick = r;
  }
}
Fne({
  dsn: "https://aaaf78c1b647e6560d1a9f16a6d9e12b@o264640.ingest.us.sentry.io/4508362840080384",
  // mco-membership-ui 에서 발생한 에러만 센트리로 전송 하도록 구현
  beforeSend(e) {
    var t, n, r;
    if (e.exception && e.exception.values) {
      const s = ((n = (t = e.exception) == null ? void 0 : t.values) == null ? void 0 : n.flatMap(
        (u) => {
          var m;
          return ((m = u.stacktrace) == null ? void 0 : m.frames) || [];
        }
      )) || [], o = s[s.length - 1];
      if (!((r = o == null ? void 0 : o.filename) == null ? void 0 : r.includes("mco-membership-ui")))
        return null;
    }
    return e;
  }
});
const a9e = {};
export {
  e9e as CommissionApplicationModalWidget,
  Yje as CommissionCreateWidget,
  Jje as CommissionWidget,
  Qje as CreatorFanServiceWidget,
  Pje as MembershipCreateWidget,
  n9e as MembershipInfoWidget,
  Hje as MembershipJoinWidget,
  t9e as MembershipManagementWidget,
  Uje as MembershipPaymentWidget,
  Gje as MembershipSupportManagementWidget,
  r9e as MyMembershipInfoWidget,
  qje as MyPageCommissionDetailWidget,
  Kje as MyPageCommissionWidget,
  $je as MyPageMembershipDetailWidget,
  Vje as MyPageMembershipWidget,
  zje as MyPagePayMethodWidget,
  Bje as MyPageSupportDetailWidget,
  Zje as MyPageSupportWidget,
  Xje as PaymentReceiptWidget,
  Wje as StudioMembershipWidget,
  Dje as SupportCreateWidget,
  Oje as SupportWidget,
  a9e as globalTheme
};
//# sourceMappingURL=index.js.map
